//
// Title: LiveSwitch for JavaScript
// Version: 1.9.4.33424
// Copyright Frozen Mountain Software 2011+
//
(function(name, dependencies, definition) {
    if (typeof exports === 'object') {
        for(var i = 0; i < dependencies.length; i++) {
            require('./' + dependencies[i]);
        }
        module.exports = definition();
    } else if (typeof define === 'function' && define.amd) {
        define(name, dependencies, definition);
    } else {
        this[name] = definition();
    }
}('fm.liveswitch', [], function() {
if (typeof global !== 'undefined' && !global.window) { global.window = global; global.document = { cookie: '' }; }
if (typeof global !== 'undefined' && !global.navigator) { global.navigator = { userAgent: ' ' }; }
this['fm'] = this['fm'] || { };
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var ArrayExtensions = /** @class */ (function () {
            function ArrayExtensions() {
            }
            ArrayExtensions.prototype.getTypeString = function () {
                return '[fm.liveswitch.ArrayExtensions]';
            };
            ArrayExtensions.getCount = function (array) {
                return array.length;
            };
            ArrayExtensions.add = function (array, value) {
                array.push(value);
            };
            ArrayExtensions.remove = function (array, value) {
                for (var i = 0; i < array.length; i++) {
                    var obj = array[i];
                    if (obj === value) {
                        array.splice(i, 1);
                        return true;
                    }
                }
                return false;
            };
            ArrayExtensions.removeAt = function (array, index) {
                array.splice(index, 1);
            };
            ArrayExtensions.insert = function (array, index, value) {
                array.splice(index, 0, value);
            };
            ArrayExtensions.toArray = function (array) {
                return this.clone(array);
            };
            ArrayExtensions.clear = function (array) {
                array.splice(0, array.length);
            };
            ArrayExtensions.addRange = function (array, values) {
                for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
                    var v = values_1[_i];
                    array.push(v);
                }
            };
            ArrayExtensions.getRange = function (array, index, count) {
                var newArray = new Array(count);
                for (var i = 0; i < newArray.length; i++) {
                    newArray[i] = array[i + index];
                }
                return newArray;
            };
            ArrayExtensions.contains = function (array, value) {
                for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
                    var obj = array_1[_i];
                    if (obj === value) {
                        return true;
                    }
                }
                return false;
            };
            ArrayExtensions.newArray = function (values) {
                return this.clone(values);
            };
            ArrayExtensions.clone = function (array) {
                var newArray = new Array(array.length);
                for (var i = 0; i < newArray.length; i++) {
                    newArray[i] = array[i];
                }
                return newArray;
            };
            ArrayExtensions.map = function (array, callback) {
                var newArray = new Array(array.length);
                for (var i = 0; i < newArray.length; i++) {
                    newArray[i] = callback(array[i], i, array);
                }
                return newArray;
            };
            return ArrayExtensions;
        }());
        liveswitch.ArrayExtensions = ArrayExtensions;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var AsyncLoggerBase = /** @class */ (function () {
            function AsyncLoggerBase(tag) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var tag_1 = __arguments[0];
                    //super();
                    if ((fm.liveswitch.Global.equals(tag_1, null))) {
                        throw new fm.liveswitch.Exception("The tag parameter cannot be null.");
                    }
                    this.setTag(tag_1);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            AsyncLoggerBase.prototype.getTypeString = function () {
                return '[fm.liveswitch.AsyncLoggerBase]';
            };
            AsyncLoggerBase.processLogEvent = function (logEvent) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.LogConfiguration.getHasProviders() && (fm.liveswitch.LogConfiguration.getTagLogLevel(logEvent.getTag()) <= logEvent.getLevel()))) {
                        for (var _i = 0, _a = fm.liveswitch.LogConfiguration.getLogProviders(); _i < _a.length; _i++) {
                            var provider = _a[_i];
                            provider.log(logEvent);
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            AsyncLoggerBase.prototype.debug = function () {
                if (arguments.length == 1) {
                    var message = arguments[0];
                    this.doLog(fm.liveswitch.LogLevel.Debug, null, message, null);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isError(arguments[1]))) {
                    var message = arguments[0];
                    var ex = arguments[1];
                    this.doLog(fm.liveswitch.LogLevel.Debug, null, message, ex);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                    var scope = arguments[0];
                    var message = arguments[1];
                    this.doLog(fm.liveswitch.LogLevel.Debug, scope, message, null);
                }
                else if (arguments.length == 3) {
                    var scope = arguments[0];
                    var message = arguments[1];
                    var ex = arguments[2];
                    this.doLog(fm.liveswitch.LogLevel.Debug, scope, message, ex);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            AsyncLoggerBase.prototype.doLog = function (level, scope, message, exception) {
                if (arguments.length == 4) {
                    this.doQueueLogEvent(new fm.liveswitch.LogEvent(fm.liveswitch.DateTime.getUtcNow(), this.getTag(), scope, level, message, exception, fm.liveswitch.ManagedThread.getCurrentThreadId()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            AsyncLoggerBase.prototype.error = function () {
                if (arguments.length == 1) {
                    var message = arguments[0];
                    this.doLog(fm.liveswitch.LogLevel.Error, null, message, null);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isError(arguments[1]))) {
                    var message = arguments[0];
                    var ex = arguments[1];
                    this.doLog(fm.liveswitch.LogLevel.Error, null, message, ex);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                    var scope = arguments[0];
                    var message = arguments[1];
                    this.doLog(fm.liveswitch.LogLevel.Error, scope, message, null);
                }
                else if (arguments.length == 3) {
                    var scope = arguments[0];
                    var message = arguments[1];
                    var ex = arguments[2];
                    this.doLog(fm.liveswitch.LogLevel.Error, scope, message, ex);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            AsyncLoggerBase.prototype.fatal = function () {
                if (arguments.length == 1) {
                    var message = arguments[0];
                    this.doLog(fm.liveswitch.LogLevel.Fatal, null, message, null);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isError(arguments[1]))) {
                    var message = arguments[0];
                    var ex = arguments[1];
                    this.doLog(fm.liveswitch.LogLevel.Fatal, null, message, ex);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                    var scope = arguments[0];
                    var message = arguments[1];
                    this.doLog(fm.liveswitch.LogLevel.Fatal, scope, message, null);
                }
                else if (arguments.length == 3) {
                    var scope = arguments[0];
                    var message = arguments[1];
                    var ex = arguments[2];
                    this.doLog(fm.liveswitch.LogLevel.Fatal, scope, message, ex);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            AsyncLoggerBase.prototype.getIsDebugEnabled = function () {
                if (arguments.length == 0) {
                    return this.isLogEnabled(fm.liveswitch.LogLevel.Debug);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            AsyncLoggerBase.prototype.getIsErrorEnabled = function () {
                if (arguments.length == 0) {
                    return this.isLogEnabled(fm.liveswitch.LogLevel.Error);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            AsyncLoggerBase.prototype.getIsFatalEnabled = function () {
                if (arguments.length == 0) {
                    return this.isLogEnabled(fm.liveswitch.LogLevel.Fatal);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            AsyncLoggerBase.prototype.getIsInfoEnabled = function () {
                if (arguments.length == 0) {
                    return this.isLogEnabled(fm.liveswitch.LogLevel.Info);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            AsyncLoggerBase.prototype.getIsVerboseEnabled = function () {
                if (arguments.length == 0) {
                    return this.isLogEnabled(fm.liveswitch.LogLevel.Verbose);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            AsyncLoggerBase.prototype.getIsWarnEnabled = function () {
                if (arguments.length == 0) {
                    return this.isLogEnabled(fm.liveswitch.LogLevel.Warn);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            AsyncLoggerBase.prototype.getTag = function () {
                if (arguments.length == 0) {
                    return this._tag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            AsyncLoggerBase.prototype.info = function () {
                if (arguments.length == 1) {
                    var message = arguments[0];
                    this.doLog(fm.liveswitch.LogLevel.Info, null, message, null);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isError(arguments[1]))) {
                    var message = arguments[0];
                    var ex = arguments[1];
                    this.doLog(fm.liveswitch.LogLevel.Info, null, message, ex);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                    var scope = arguments[0];
                    var message = arguments[1];
                    this.doLog(fm.liveswitch.LogLevel.Info, scope, message, null);
                }
                else if (arguments.length == 3) {
                    var scope = arguments[0];
                    var message = arguments[1];
                    var ex = arguments[2];
                    this.doLog(fm.liveswitch.LogLevel.Info, scope, message, ex);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            AsyncLoggerBase.prototype.isLogEnabled = function (level) {
                if (arguments.length == 1) {
                    return (fm.liveswitch.LogConfiguration.getTagLogLevel(this.getTag()) <= level);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            AsyncLoggerBase.prototype.log = function () {
                if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.LogEvent]'))) {
                    var logEvent = arguments[0];
                    this.doQueueLogEvent(logEvent);
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                    var message = arguments[0];
                    this.doLog(fm.liveswitch.LogLevel.Info, null, message, null);
                }
                else if (arguments.length == 2) {
                    var scope = arguments[0];
                    var message = arguments[1];
                    this.doLog(fm.liveswitch.LogLevel.Info, scope, message, null);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            AsyncLoggerBase.prototype.setTag = function (value) {
                if (arguments.length == 1) {
                    this._tag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            AsyncLoggerBase.prototype.verbose = function () {
                if (arguments.length == 1) {
                    var message = arguments[0];
                    this.doLog(fm.liveswitch.LogLevel.Verbose, null, message, null);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isError(arguments[1]))) {
                    var message = arguments[0];
                    var ex = arguments[1];
                    this.doLog(fm.liveswitch.LogLevel.Verbose, null, message, ex);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                    var scope = arguments[0];
                    var message = arguments[1];
                    this.doLog(fm.liveswitch.LogLevel.Verbose, scope, message, null);
                }
                else if (arguments.length == 3) {
                    var scope = arguments[0];
                    var message = arguments[1];
                    var ex = arguments[2];
                    this.doLog(fm.liveswitch.LogLevel.Verbose, scope, message, ex);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            AsyncLoggerBase.prototype.warn = function () {
                if (arguments.length == 1) {
                    var message = arguments[0];
                    this.doLog(fm.liveswitch.LogLevel.Warn, null, message, null);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isError(arguments[1]))) {
                    var message = arguments[0];
                    var ex = arguments[1];
                    this.doLog(fm.liveswitch.LogLevel.Warn, null, message, ex);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                    var scope = arguments[0];
                    var message = arguments[1];
                    this.doLog(fm.liveswitch.LogLevel.Warn, scope, message, null);
                }
                else if (arguments.length == 3) {
                    var scope = arguments[0];
                    var message = arguments[1];
                    var ex = arguments[2];
                    this.doLog(fm.liveswitch.LogLevel.Warn, scope, message, ex);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return AsyncLoggerBase;
        }());
        liveswitch.AsyncLoggerBase = AsyncLoggerBase;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="AsyncLoggerBase.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        @internal
        */
        var AsyncLogger = /** @class */ (function (_super) {
            __extends(AsyncLogger, _super);
            function AsyncLogger(tag) {
                return _super.call(this, tag) || this;
            }
            AsyncLogger.prototype.getTypeString = function () {
                return '[fm.liveswitch.AsyncLogger]';
            };
            /**
            @internal
            */
            AsyncLogger.prototype.doQueueLogEvent = function (logEvent) {
                window.setTimeout(function () {
                    fm.liveswitch.AsyncLoggerBase.processLogEvent(logEvent);
                }, 1);
            };
            AsyncLogger.prototype.flush = function () { };
            return AsyncLogger;
        }(fm.liveswitch.AsyncLoggerBase));
        liveswitch.AsyncLogger = AsyncLogger;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var AtomicInteger = /** @class */ (function () {
            function AtomicInteger(startValue) {
                if (arguments.length == 0) {
                    this._value = 0;
                }
                else {
                    this._value = startValue;
                }
            }
            AtomicInteger.prototype.compareAndSwap = function (expected, newValue) {
                var oldValue = this._value;
                if (this._value == expected) {
                    this._value = newValue;
                }
                return oldValue;
            };
            AtomicInteger.prototype.getValue = function () {
                return this._value;
            };
            AtomicInteger.prototype.add = function (value) {
                this._value = this._value + value;
                return this._value;
            };
            AtomicInteger.prototype.subtract = function (value) {
                this._value = this._value - value;
                return this._value;
            };
            AtomicInteger.prototype.increment = function () {
                this._value = this._value + 1;
                return this._value;
            };
            AtomicInteger.prototype.decrement = function () {
                this._value = this._value - 1;
                return this._value;
            };
            return AtomicInteger;
        }());
        liveswitch.AtomicInteger = AtomicInteger;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var AtomicLong = /** @class */ (function () {
            function AtomicLong(startValue) {
                if (arguments.length == 0) {
                    this._value = 0;
                }
                else {
                    this._value = startValue;
                }
            }
            AtomicLong.prototype.compareAndSwap = function (expected, newValue) {
                var oldValue = this._value;
                if (this._value == expected) {
                    this._value = newValue;
                }
                return oldValue;
            };
            AtomicLong.prototype.getValue = function () {
                return this._value;
            };
            AtomicLong.prototype.add = function (value) {
                this._value = this._value + value;
                return this._value;
            };
            AtomicLong.prototype.subtract = function (value) {
                this._value = this._value - value;
                return this._value;
            };
            AtomicLong.prototype.increment = function () {
                this._value = this._value + 1;
                return this._value;
            };
            AtomicLong.prototype.decrement = function () {
                this._value = this._value - 1;
                return this._value;
            };
            return AtomicLong;
        }());
        liveswitch.AtomicLong = AtomicLong;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Base64 = /** @class */ (function () {
            function Base64() {
            }
            Base64.prototype.getTypeString = function () {
                return '[fm.liveswitch.Base64]';
            };
            Base64.encode = function (b) {
                if (!b) {
                    return null;
                }
                return this.encodeIt(b, 0, b.length);
            };
            Base64.encodeBuffer = function (buffer) {
                if (!buffer) {
                    return null;
                }
                return this.encodeIt(buffer.getData(), buffer.getIndex(), buffer.getLength());
            };
            Base64.decode = function (s) {
                if (!s) {
                    return null;
                }
                if (!Base64._base64Regex.test(s)) {
                    return null;
                }
                return this.decodeIt(s);
            };
            Base64.tryEncode = function (b, result) {
                try {
                    var encoded = Base64.encode(b);
                    result.setValue(encoded);
                    if (!encoded) {
                        return false;
                    }
                    return true;
                }
                catch (error) {
                    result.setValue(null);
                    return false;
                }
            };
            Base64.tryEncodeBuffer = function (buffer, result) {
                try {
                    var encoded = Base64.encodeBuffer(buffer);
                    result.setValue(encoded);
                    if (!encoded) {
                        return false;
                    }
                    return true;
                }
                catch (error) {
                    result.setValue(null);
                    return false;
                }
            };
            Base64.tryDecode = function (s, result) {
                try {
                    var decoded = Base64.decode(s);
                    result.setValue(decoded);
                    if (!decoded) {
                        return false;
                    }
                    return true;
                }
                catch (error) {
                    result.setValue(null);
                    return false;
                }
            };
            Base64.b64ToUint6 = function (cc) {
                if (cc > 64 && cc < 91) {
                    return cc - 65;
                }
                else if (cc > 96 && cc < 123) {
                    return cc - 71;
                }
                else if (cc > 47 && cc < 58) {
                    return cc + 4;
                }
                else if (cc === 43) {
                    return 62;
                }
                else if (cc === 47) {
                    return 63;
                }
                else {
                    return 0;
                }
            };
            Base64.decodeIt = function (str64, blocksSize) {
                if (typeof Uint8Array === 'undefined') {
                    return null;
                }
                var str = str64.replace(/[^A-Za-z0-9\+\/]/g, '');
                var slen = str.length;
                var blen = blocksSize ? Math.ceil((slen * 3 + 1 >> 2) / blocksSize) * blocksSize : slen * 3 + 1 >> 2;
                var bytes = new Uint8Array(blen);
                var n = 0;
                var bi = 0;
                for (var si = 0; si < slen; si++) {
                    var mod4 = si & 3;
                    n |= Base64.b64ToUint6(str.charCodeAt(si)) << 18 - 6 * mod4;
                    if (mod4 === 3 || slen - si === 1) {
                        var mod3 = 0;
                        while ((mod3 < 3) && (bi < blen)) {
                            bytes[bi] = n >>> (16 >>> mod3 & 24) & 255;
                            mod3++;
                            bi++;
                        }
                        n = 0;
                    }
                }
                return bytes;
            };
            Base64.uint6ToB64 = function (b) {
                if (b < 26) {
                    return b + 65;
                }
                else if (b < 52) {
                    return b + 71;
                }
                else if (b < 62) {
                    return b - 4;
                }
                else if (b === 62) {
                    return 43;
                }
                else if (b === 63) {
                    return 47;
                }
                else {
                    return 65;
                }
            };
            Base64.encodeIt = function (bytes, index, length) {
                if (typeof Uint8Array === 'undefined') {
                    return null;
                }
                var str = '';
                var blen = length;
                var n = 0;
                for (var bi = 0; bi < blen; bi++) {
                    var mod3 = bi % 3;
                    //if (bi > 0 && (bi * 4 / 3) % 76 === 0) {
                    //    str += '\r\n';
                    //}
                    n |= bytes[index + bi] << (16 >>> mod3 & 24);
                    if (mod3 === 2 || length - bi === 1) {
                        str += String.fromCharCode(Base64.uint6ToB64(n >>> 18 & 63), Base64.uint6ToB64(n >>> 12 & 63), Base64.uint6ToB64(n >>> 6 & 63), Base64.uint6ToB64(n & 63));
                        n = 0;
                    }
                }
                return str.replace(/A(?=A$|$)/g, '=');
            };
            Base64._base64Regex = /^(?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=|[A-Za-z0-9+\/]*)?$/;
            return Base64;
        }());
        liveswitch.Base64 = Base64;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var BitAssistant = /** @class */ (function () {
            function BitAssistant() {
            }
            BitAssistant.prototype.getTypeString = function () {
                return '[fm.liveswitch.BitAssistant]';
            };
            BitAssistant.castByte = function (value) {
                return value;
            };
            BitAssistant.castInteger = function (value) {
                return value;
            };
            BitAssistant.castLong = function (value) {
                return value;
            };
            BitAssistant.leftShift = function (value, count) {
                return (value << count);
            };
            BitAssistant.leftShiftShort = function (value, count) {
                return (value << count);
            };
            BitAssistant.leftShiftInteger = function (value, count) {
                return (value << count);
            };
            BitAssistant.leftShiftLong = function (value, count) {
                return (value << count);
            };
            BitAssistant.rightShift = function (value, count) {
                return (value >> count);
            };
            BitAssistant.rightShiftShort = function (value, count) {
                return (value >> count);
            };
            BitAssistant.rightShiftInteger = function (value, count) {
                return (value >> count);
            };
            BitAssistant.rightShiftLong = function (value, count) {
                return (value >> count);
            };
            BitAssistant.sequencesAreEqual = function () {
                if (arguments.length == 2) {
                    var array1 = arguments[0];
                    var array2 = arguments[1];
                    if (array1 == null && array2 == null) {
                        return true;
                    }
                    if (array1 == null || array2 == null) {
                        return false;
                    }
                    if (array1.length != array2.length) {
                        return false;
                    }
                    for (var i = 0; i < array1.length; i++) {
                        if (array1[i] != array2[i]) {
                            return false;
                        }
                    }
                    return true;
                }
                else {
                    var array1 = arguments[0];
                    var offset1 = arguments[1];
                    var array2 = arguments[2];
                    var offset2 = arguments[3];
                    var length_1 = arguments[4];
                    if (array1 == null && array2 == null) {
                        return true;
                    }
                    if (array1 == null || array2 == null) {
                        return false;
                    }
                    if (array1.length < offset1 + length_1 || array2.length < offset2 + length_1) {
                        return false;
                    }
                    for (var i = 0; i < length_1; i++) {
                        if (array1[offset1 + i] != array2[offset2 + i]) {
                            return false;
                        }
                    }
                    return true;
                }
            };
            BitAssistant.sequencesAreEqualConstantTime = function () {
                if (arguments.length == 2) {
                    var array1 = arguments[0];
                    var array2 = arguments[1];
                    if (array1 == null && array2 == null) {
                        return true;
                    }
                    if (array1 == null || array2 == null) {
                        return false;
                    }
                    if (array1.length != array2.length) {
                        return false;
                    }
                    var areEqual = true;
                    for (var i = 0; i < array1.length; i++) {
                        if (array1[i] != array2[i]) {
                            areEqual = false;
                        }
                    }
                    return areEqual;
                }
                else {
                    var array1 = arguments[0];
                    var offset1 = arguments[1];
                    var array2 = arguments[2];
                    var offset2 = arguments[3];
                    var length_2 = arguments[4];
                    if (array1 == null && array2 == null) {
                        return true;
                    }
                    if (array1 == null || array2 == null) {
                        return false;
                    }
                    if (array1.length < offset1 + length_2 || array2.length < offset2 + length_2) {
                        return false;
                    }
                    var areEqual = true;
                    for (var i = 0; i < length_2; i++) {
                        if (array1[offset1 + i] != array2[offset2 + i]) {
                            areEqual = false;
                        }
                    }
                    return areEqual;
                }
            };
            BitAssistant.subArray = function (array, offset, count) {
                if (typeof count === 'undefined') {
                    return BitAssistant.subArray(array, offset, array.length - offset);
                }
                else {
                    var subarray = new Uint8Array(count);
                    BitAssistant.copy(array, offset, subarray, 0, count);
                    return subarray;
                }
            };
            BitAssistant.reverse = function (array) {
                array.reverse();
            };
            BitAssistant.copy = function (source, sourceIndex, destination, destinationIndex, length) {
                destination.set(source.subarray(sourceIndex, sourceIndex + length), destinationIndex);
            };
            BitAssistant.set = function (array, index, length, value) {
                array.fill(value, index, index + length);
            };
            BitAssistant.getHexString = function () {
                if (arguments.length == 1) {
                    var array = arguments[0];
                    return BitAssistant.getHexString(array, 0, array.length);
                }
                else {
                    var array = arguments[0];
                    var offset = arguments[1];
                    var length_3 = arguments[2];
                    var s = '';
                    for (var i = offset; i < offset + length_3; i++) {
                        var hex = (array[i] & 0xff).toString(16);
                        hex = (hex.length === 1) ? '0' + hex : hex;
                        s += hex;
                    }
                    return s;
                }
            };
            BitAssistant.getHexBytes = function (s) {
                var a = [];
                for (var i = 0; i < s.length; i += 2) {
                    a.push(parseInt(s.substr(i, 2), 16));
                }
                return new Uint8Array(a);
            };
            return BitAssistant;
        }());
        liveswitch.BitAssistant = BitAssistant;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var BooleanExtensions = /** @class */ (function () {
            function BooleanExtensions() {
            }
            BooleanExtensions.prototype.getTypeString = function () {
                return '[fm.liveswitch.BooleanExtensions]';
            };
            BooleanExtensions.toString = function (value, format) {
                return value.toString();
            };
            return BooleanExtensions;
        }());
        liveswitch.BooleanExtensions = BooleanExtensions;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var ByteCollection = /** @class */ (function () {
            function ByteCollection(buffer) {
                if (buffer) {
                    this._buffer = new Uint8Array(buffer);
                }
                else {
                    this._buffer = new Uint8Array(0);
                }
            }
            ByteCollection.prototype.getTypeString = function () {
                return '[fm.liveswitch.ByteCollection]';
            };
            ByteCollection.prototype.count = function () {
                return this._buffer.length;
            };
            ByteCollection.prototype.add = function (b) {
                var bufferA = this._buffer;
                var newBuffer = new Uint8Array(bufferA.length + 1);
                newBuffer.set(bufferA);
                newBuffer[bufferA.length] = b;
                this._buffer = newBuffer;
            };
            ByteCollection.prototype.addRange = function (buffer) {
                var byteCollection = fm.liveswitch.Global.tryCast(buffer, ByteCollection);
                if (byteCollection) {
                    buffer = byteCollection._buffer;
                }
                var bufferA = this._buffer;
                var bufferB = buffer;
                var newBuffer = new Uint8Array(bufferA.length + bufferB.length);
                newBuffer.set(bufferA);
                newBuffer.set(bufferB, bufferA.length);
                this._buffer = newBuffer;
            };
            ByteCollection.prototype.removeRange = function (index, count) {
                var bufferA = this._buffer.subarray(0, index);
                var bufferB = this._buffer.subarray(index + count);
                var newBuffer = new Uint8Array(bufferA.length + bufferB.length);
                newBuffer.set(bufferA);
                newBuffer.set(bufferB, bufferA.length);
                this._buffer = newBuffer;
            };
            ByteCollection.prototype.insertRange = function (index, buffer) {
                var byteCollection = fm.liveswitch.Global.tryCast(buffer, ByteCollection);
                if (byteCollection) {
                    buffer = byteCollection._buffer;
                }
                var bufferA = this._buffer.subarray(0, index);
                var bufferB = buffer;
                var bufferC = this._buffer.subarray(index);
                var newBuffer = new Uint8Array(bufferA.length + bufferB.length + bufferC.length);
                newBuffer.set(bufferA);
                newBuffer.set(bufferB, bufferA.length);
                newBuffer.set(bufferC, bufferA.length + bufferB.length);
                this._buffer = newBuffer;
            };
            ByteCollection.prototype.getRange = function (index, count) {
                var buffer = new Uint8Array(count);
                buffer.set(this._buffer.subarray(index, index + count));
                return buffer;
            };
            ByteCollection.prototype.get = function (index) {
                return this._buffer[index];
            };
            ByteCollection.prototype.toArray = function () {
                return new Uint8Array(this._buffer);
            };
            return ByteCollection;
        }());
        liveswitch.ByteCollection = ByteCollection;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Base class for all logging provider implementations.
        */
        var LogProvider = /** @class */ (function () {
            /**
            Initializes a new instance of the [[fm.liveswitch.logProvider]] class.
            */
            function LogProvider() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchLogProviderInit();
                    this.setLevel(fm.liveswitch.LogLevel.Info);
                    this.setProcessId(fm.liveswitch.Platform.getInstance().getProcessId());
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            LogProvider.prototype.getTypeString = function () {
                return '[fm.liveswitch.LogProvider]';
            };
            LogProvider.prototype.fmliveswitchLogProviderInit = function () {
                this._processId = 0;
            };
            /**
            Converts a log-level to a 5-character string for consistently-spaced character sequences.
            @param level The log level.
            @return The log level as an upper-case string
                        with right-side whitespace padding to ensure
                        a 5-character sequence.
            */
            LogProvider.getLogLevelString = function (level) {
                if (arguments.length == 1) {
                    var _var0 = level;
                    if (_var0 == fm.liveswitch.LogLevel.Verbose) {
                        do {
                            return "VERBOSE";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LogLevel.Debug) {
                        do {
                            return "DEBUG  ";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LogLevel.Info) {
                        do {
                            return "INFO   ";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LogLevel.Warn) {
                        do {
                            return "WARN   ";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LogLevel.Error) {
                        do {
                            return "ERROR  ";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LogLevel.Fatal) {
                        do {
                            return "FATAL  ";
                        } while (false);
                    }
                    return "NONE   ";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts a timestamp to an ISO-8601-formatted string for rendering in a log message (YYYY-MM-DDThh:mm:ss.sssZ).
            @param timestamp The timestamp.
            @return The timestamp as a formatted string.
            */
            LogProvider.getPrefixTimestamp = function (timestamp) {
                if (arguments.length == 1) {
                    return fm.liveswitch.Iso8601Timestamp.dateTimeToIso8601(timestamp);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Returns the name of the current product.
            */
            LogProvider.getProduct = function () {
                if (arguments.length == 0) {
                    return "LiveSwitch";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Generates a default log line.
            @param logEvent The log event details.
            */
            LogProvider.prototype.generateLogLine = function (logEvent) {
                if (arguments.length == 1) {
                    var product = fm.liveswitch.LogProvider.getProduct();
                    var str2 = fm.liveswitch.StringExtensions.format("[{0}][{1}][{2}] {3} [{4}][{5}] {6} {7}", [product, fm.liveswitch.NumberExtensions.toString(this.getProcessId()), fm.liveswitch.NumberExtensions.toString(logEvent.getThreadId()), fm.liveswitch.LogProvider.getLogLevelString(logEvent.getLevel()), ((fm.liveswitch.Global.equals(logEvent.getTag(), null)) ? "-" : logEvent.getTag()), ((fm.liveswitch.Global.equals(logEvent.getScope(), null)) ? "-" : logEvent.getScope()), fm.liveswitch.LogProvider.getPrefixTimestamp(logEvent.getTimestamp()), logEvent.getMessage()]);
                    if ((!fm.liveswitch.Global.equals(logEvent.getException(), null))) {
                        str2 = fm.liveswitch.StringExtensions.concat(str2, fm.liveswitch.StringExtensions.format("\n{0}", logEvent.getException().toString()));
                    }
                    return str2;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a filter on the log provider. Returning `true` will log the event, while returning `false` will skip it.
            */
            LogProvider.prototype.getFilter = function () {
                if (arguments.length == 0) {
                    return this._filter;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the log level.
            */
            LogProvider.prototype.getLevel = function () {
                if (arguments.length == 0) {
                    return this._level;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts a log-level to a 5-character string for consistently-spaced character sequences.
            @param level The log level.
            @param includeTimestamp Whether to include a timestamp in the prefix.
            @return The log level as an upper-case string
                        with right-side whitespace padding to ensure
                        a 5-character sequence.
            */
            LogProvider.prototype.getPrefix = function (level, includeTimestamp) {
                if (arguments.length == 2) {
                    var logLevelString = fm.liveswitch.LogProvider.getLogLevelString(level);
                    if (includeTimestamp) {
                        logLevelString = fm.liveswitch.StringExtensions.format("{0} {1}", logLevelString, fm.liveswitch.LogProvider.getPrefixTimestamp(fm.liveswitch.DateTime.getUtcNow()));
                    }
                    return logLevelString;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the current process id.
            */
            LogProvider.prototype.getProcessId = function () {
                if (arguments.length == 0) {
                    return this._processId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Log a message.
            @param logEvent The log event details.
            */
            LogProvider.prototype.log = function (logEvent) {
                if (arguments.length == 1) {
                    if ((logEvent.getLevel() >= this.getLevel())) {
                        try {
                            var flag = true;
                            if ((!fm.liveswitch.Global.equals(this.getFilter(), null))) {
                                flag = this.getFilter()(logEvent);
                            }
                            if (flag) {
                                this.doLog(logEvent);
                            }
                        }
                        catch (obj1) {
                        }
                        finally {
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a filter on the log provider. Returning `true` will log the event, while returning `false` will skip it.
            */
            LogProvider.prototype.setFilter = function (value) {
                if (arguments.length == 1) {
                    this._filter = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the log level.
            */
            LogProvider.prototype.setLevel = function (value) {
                if (arguments.length == 1) {
                    this._level = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LogProvider.prototype.setProcessId = function (value) {
                if (arguments.length == 1) {
                    this._processId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return LogProvider;
        }());
        liveswitch.LogProvider = LogProvider;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="LogProvider.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var ConsoleLogProvider = /** @class */ (function (_super) {
            __extends(ConsoleLogProvider, _super);
            function ConsoleLogProvider(level) {
                var _this = _super.call(this) || this;
                if (typeof level === 'undefined') {
                    level = fm.liveswitch.LogLevel.Warn;
                }
                _this.setLevel(level);
                return _this;
            }
            ConsoleLogProvider.prototype.getTypeString = function () {
                return '[fm.liveswitch.ConsoleLogProvider]' + ',' + _super.prototype.getTypeString.call(this);
            };
            ConsoleLogProvider.prototype.writeLine = function (text) {
                if (window.console && window.console.log) {
                    window.console.log(text);
                }
            };
            ConsoleLogProvider.prototype.doLog = function (logItem) {
                if (window.console) {
                    var text = _super.prototype.generateLogLine.call(this, logItem);
                    switch (logItem.getLevel()) {
                        case fm.liveswitch.LogLevel.Fatal:
                        case fm.liveswitch.LogLevel.Error:
                            if (window.console.error) {
                                window.console.error(text);
                                return;
                            }
                            break;
                        case fm.liveswitch.LogLevel.Warn:
                            if (window.console.warn) {
                                window.console.warn(text);
                                return;
                            }
                            break;
                        case fm.liveswitch.LogLevel.Info:
                            if (window.console.info) {
                                window.console.info(text);
                                return;
                            }
                            break;
                        case fm.liveswitch.LogLevel.Debug:
                        case fm.liveswitch.LogLevel.Verbose:
                            if (window.console.debug) {
                                window.console.debug(text);
                                return;
                            }
                            break;
                    }
                    window.console.log(text);
                }
            };
            return ConsoleLogProvider;
        }(fm.liveswitch.LogProvider));
        liveswitch.ConsoleLogProvider = ConsoleLogProvider;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Convert = /** @class */ (function () {
            function Convert() {
            }
            Convert.prototype.getTypeString = function () {
                return '[fm.liveswitch.Convert]';
            };
            Convert.toInt32 = function (s, base) {
                return parseInt(s, base);
            };
            return Convert;
        }());
        liveswitch.Convert = Convert;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var DateTime = /** @class */ (function () {
            function DateTime() {
                if (arguments.length == 1) {
                    if (fm.liveswitch.Util.isDate(arguments[0])) {
                        this._date = arguments[0];
                    }
                    else {
                        var ticks = arguments[0];
                        this._date = new Date((ticks - 621355968000000000) / fm.liveswitch.Constants.getTicksPerMillisecond());
                    }
                }
                else if (arguments.length >= 6) {
                    var year = arguments[0];
                    var month = arguments[1];
                    var day = arguments[2];
                    var hour = arguments[3];
                    var minute = arguments[4];
                    var second = arguments[5];
                    var millisecond = 0;
                    if (arguments.length >= 7) {
                        millisecond = arguments[6];
                    }
                    this._date = new Date(Date.UTC(year, month - 1, day, hour, minute, second, millisecond));
                }
            }
            DateTime.prototype.getTypeString = function () {
                return '[fm.liveswitch.DateTime]';
            };
            DateTime.getNow = function () {
                return new DateTime(new Date());
            };
            DateTime.getUtcNow = function () {
                return new DateTime(new Date());
            };
            DateTime.prototype.getDate = function () {
                return this._date;
            };
            DateTime.prototype.getTicks = function () {
                return 621355968000000000 + this._date.getTime() * fm.liveswitch.Constants.getTicksPerMillisecond();
            };
            DateTime.prototype.toUniversalTime = function () {
                return new DateTime(this._date);
            };
            DateTime.prototype.getYear = function () {
                return this._date.getUTCFullYear();
            };
            DateTime.prototype.getMonth = function () {
                return this._date.getUTCMonth() + 1;
            };
            DateTime.prototype.getDay = function () {
                return this._date.getUTCDate();
            };
            DateTime.prototype.getHour = function () {
                return this._date.getUTCHours();
            };
            DateTime.prototype.getMinute = function () {
                return this._date.getUTCMinutes();
            };
            DateTime.prototype.getSecond = function () {
                return this._date.getUTCSeconds();
            };
            DateTime.prototype.getMillisecond = function () {
                return this._date.getUTCMilliseconds();
            };
            DateTime.prototype.addHours = function (hours) {
                return new DateTime(this.getTicks() + (hours * fm.liveswitch.Constants.getTicksPerHour()));
            };
            DateTime.prototype.addMinutes = function (minutes) {
                return new DateTime(this.getTicks() + (minutes * fm.liveswitch.Constants.getTicksPerMinute()));
            };
            DateTime.prototype.addSeconds = function (seconds) {
                return new DateTime(this.getTicks() + (seconds * fm.liveswitch.Constants.getTicksPerSecond()));
            };
            DateTime.prototype.addMilliseconds = function (milliseconds) {
                return new DateTime(this.getTicks() + (milliseconds * fm.liveswitch.Constants.getTicksPerMillisecond()));
            };
            return DateTime;
        }());
        liveswitch.DateTime = DateTime;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var DateTimeFormatInfo = /** @class */ (function () {
            function DateTimeFormatInfo() {
            }
            DateTimeFormatInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.DateTimeFormatInfo]';
            };
            DateTimeFormatInfo.getInvariantInfo = function () {
                return new DateTimeFormatInfo();
            };
            return DateTimeFormatInfo;
        }());
        liveswitch.DateTimeFormatInfo = DateTimeFormatInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var DateTimeStyles;
        (function (DateTimeStyles) {
            DateTimeStyles[DateTimeStyles["AssumeUniversal"] = 1] = "AssumeUniversal";
            DateTimeStyles[DateTimeStyles["AdjustToUniversal"] = 2] = "AdjustToUniversal";
        })(DateTimeStyles = liveswitch.DateTimeStyles || (liveswitch.DateTimeStyles = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="IDispatchQueue.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var DispatchQueue = /** @class */ (function () {
            function DispatchQueue(action) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    this._action = action;
                    this._count = new fm.liveswitch.AtomicLong();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            DispatchQueue.prototype.getTypeString = function () {
                return '[fm.liveswitch.DispatchQueue]';
            };
            DispatchQueue.prototype.getQueueCount = function () {
                return this._count.getValue();
            };
            DispatchQueue.prototype.destroy = function () { };
            DispatchQueue.prototype.enqueue = function (item) {
                var action = this._action;
                var atomic = this._count;
                atomic.increment();
                window.setTimeout(function () {
                    try {
                        action(item);
                    }
                    finally {
                        atomic.decrement();
                    }
                }, 1);
            };
            return DispatchQueue;
        }());
        liveswitch.DispatchQueue = DispatchQueue;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="LogProvider.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var DomLogProvider = /** @class */ (function (_super) {
            __extends(DomLogProvider, _super);
            function DomLogProvider(container, level) {
                var _this = _super.call(this) || this;
                _this._container = container;
                if (typeof level === 'undefined') {
                    level = fm.liveswitch.LogLevel.Warn;
                }
                _this.setLevel(level);
                return _this;
            }
            DomLogProvider.prototype.getTypeString = function () {
                return '[fm.liveswitch.DomLogProvider]' + ',' + _super.prototype.getTypeString.call(this);
            };
            DomLogProvider.prototype.writeLine = function (text) {
                var div = document.createElement('div');
                div.innerHTML = text.replace(/\n/g, '<br />');
                this._container.appendChild(div);
            };
            DomLogProvider.prototype.doLog = function (logItem) {
                var text = _super.prototype.generateLogLine.call(this, logItem);
                this.writeLine(text);
            };
            return DomLogProvider;
        }(fm.liveswitch.LogProvider));
        liveswitch.DomLogProvider = DomLogProvider;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Encoding = /** @class */ (function () {
            function Encoding() {
            }
            Encoding.prototype.getTypeString = function () {
                return '[fm.liveswitch.Encoding]';
            };
            Encoding.getAscii = function () {
                return new Encoding();
            };
            Encoding.getUtf8 = function () {
                return new Encoding();
            };
            Encoding.prototype.getString = function (bytes, index, count) {
                if (typeof index === 'undefined') {
                    index = 0;
                }
                if (typeof count === 'undefined') {
                    count = bytes.length;
                }
                var str = '';
                var i = index;
                while (i < (index + count)) {
                    var c = void 0;
                    if (bytes[i] <= 0x7f) {
                        c = bytes[i];
                    }
                    else {
                        if ((bytes[i] >> 5) === 0x6) {
                            c = ((bytes[i] & 0x1f) << 6) | (bytes[++i] & 0x3f);
                        }
                        else if ((bytes[i] >> 4) === 0xe) {
                            c = ((bytes[i] & 0xf) << 12) | ((bytes[++i] & 0x3f) << 6) | (bytes[++i] & 0x3f);
                        }
                        else {
                            var s = 1;
                            while (bytes[i] & (0x20 >>> s)) {
                                s++;
                            }
                            c = bytes[i] & (0x1f >>> s);
                            while (s-- >= 0) {
                                c = (c << 6) ^ (bytes[++i] & 0x3f);
                            }
                        }
                    }
                    str += String.fromCharCode(c);
                    i++;
                }
                return str;
            };
            Encoding.prototype.getBytes = function (str) {
                if (!str) {
                    return null;
                }
                var n = str.length;
                var idx = 0;
                var utf8 = new Uint8Array(new ArrayBuffer(n * 4));
                var i = 0;
                while (i < n) {
                    var c = str.charCodeAt(i);
                    if (c <= 0x7F) {
                        utf8[idx++] = c;
                    }
                    else if (c <= 0x7FF) {
                        utf8[idx++] = 0xC0 | (c >>> 6);
                        utf8[idx++] = 0x80 | (c & 0x3F);
                    }
                    else if (c <= 0xFFFF) {
                        utf8[idx++] = 0xE0 | (c >>> 12);
                        utf8[idx++] = 0x80 | ((c >>> 6) & 0x3F);
                        utf8[idx++] = 0x80 | (c & 0x3F);
                    }
                    else {
                        var j = 4;
                        while (c >> (6 * j)) {
                            j++;
                        }
                        utf8[idx++] = ((0xFF00 >>> j) & 0xFF) | (c >>> (6 * --j));
                        while (j--) {
                            utf8[idx++] = 0x80 | ((c >>> (6 * j)) & 0x3F);
                        }
                    }
                    i++;
                }
                return utf8.subarray(0, idx);
            };
            Encoding.prototype.getByteCount = function (str) {
                return this.getBytes(str).length;
            };
            return Encoding;
        }());
        liveswitch.Encoding = Encoding;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
var fmliveswitchGlobalError = /** @class */ (function (_super) {
    __extends(fmliveswitchGlobalError, _super);
    function fmliveswitchGlobalError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return fmliveswitchGlobalError;
}(Error));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Exception = /** @class */ (function (_super) {
            __extends(Exception, _super);
            function Exception(message) {
                var _this = _super.call(this, message) || this;
                _this.message = message;
                _this.name = 'Exception';
                return _this;
            }
            return Exception;
        }(fmliveswitchGlobalError));
        liveswitch.Exception = Exception;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Future base properties/methods.
        */
        var FutureBase = /** @class */ (function () {
            function FutureBase() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            FutureBase.prototype.getTypeString = function () {
                return '[fm.liveswitch.FutureBase]';
            };
            /**
            Gets the exception if rejected.
            */
            FutureBase.prototype.getException = function () {
                if (arguments.length == 0) {
                    return this._exception;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the result if resolved.
            */
            FutureBase.prototype.getResult = function () {
                if (arguments.length == 0) {
                    return this._result;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the current state.
            */
            FutureBase.prototype.getState = function () {
                if (arguments.length == 0) {
                    return this._state;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the exception if rejected.
            */
            FutureBase.prototype.setException = function (value) {
                if (arguments.length == 1) {
                    this._exception = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the result if resolved.
            */
            FutureBase.prototype.setResult = function (value) {
                if (arguments.length == 1) {
                    this._result = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the current state.
            */
            FutureBase.prototype.setState = function (value) {
                if (arguments.length == 1) {
                    this._state = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return FutureBase;
        }());
        liveswitch.FutureBase = FutureBase;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="FutureBase.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Future = /** @class */ (function (_super) {
            __extends(Future, _super);
            function Future() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Future.prototype.getTypeString = function () {
                return '[fm.liveswitch.Future]';
            };
            return Future;
        }(fm.liveswitch.FutureBase));
        liveswitch.Future = Future;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Global = /** @class */ (function () {
            function Global() {
            }
            Global.prototype.getTypeString = function () {
                return '[fm.liveswitch.Global]';
            };
            Global.tryCast = function (x, t) {
                if (!x || x instanceof t) {
                    return x;
                }
                return null;
            };
            Global.tryCastArray = function (x) {
                if (!x || x instanceof Array) {
                    return x;
                }
                return null;
            };
            Global.tryCastObject = function (x) {
                if (!x || x instanceof Object) {
                    return x;
                }
                return null;
            };
            Global.tryCastString = function (x) {
                if (!x || typeof x === "string") {
                    return x;
                }
                return null;
            };
            Global.tryCastInt = function (x) {
                if (!x || !isNaN(parseInt(x))) {
                    return x;
                }
                return null;
            };
            Global.tryCastFloat = function (x) {
                if (!x || !isNaN(parseFloat(x))) {
                    return x;
                }
                return null;
            };
            Global.equals = function (x1, x2) {
                if (x1 === null || typeof x1 === 'undefined') {
                    return x2 === null || typeof x2 === 'undefined';
                }
                if (x2 === null || typeof x2 === 'undefined') {
                    return x1 === null || typeof x1 === 'undefined';
                }
                return x1 === x2;
            };
            return Global;
        }());
        liveswitch.Global = Global;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Guid = /** @class */ (function () {
            function Guid(guidString) {
                if (typeof guidString === 'undefined') {
                    this._guidString = '00000000-0000-0000-0000-000000000000';
                }
                else {
                    this._guidString = guidString;
                }
            }
            Guid.prototype.getTypeString = function () {
                return '[fm.liveswitch.Guid]';
            };
            Guid.prototype.equals = function (guid) {
                return (guid.toString() === this._guidString);
            };
            Guid.prototype.toString = function () {
                return this._guidString;
            };
            Guid.newGuid = function () {
                return new Guid('xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0;
                    var v = (c === 'x' ? r : r & 0x3 | 0x8);
                    return v.toString(16);
                }));
            };
            Guid.equals = function (guid1, guid2) {
                if (guid1 === null || typeof guid1 === 'undefined') {
                    return guid2 === null || typeof guid2 === 'undefined';
                }
                if (guid2 === null || typeof guid2 === 'undefined') {
                    return guid1 === null || typeof guid1 === 'undefined';
                }
                return guid1.equals(guid2);
            };
            Guid.empty = new Guid();
            return Guid;
        }());
        liveswitch.Guid = Guid;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A hash context.
        */
        var HashContextBase = /** @class */ (function () {
            /**
            Initializes a new instance of the [[fm.liveswitch.hashContextBase]] class.
            @param type The type.
            */
            function HashContextBase(type) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var type_1 = __arguments[0];
                    //super();
                    this.setType(type_1);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            HashContextBase.prototype.getTypeString = function () {
                return '[fm.liveswitch.HashContextBase]';
            };
            HashContextBase.compute = function () {
                if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.DataBuffer]'))) {
                    var type = arguments[0];
                    var input = arguments[1];
                    var context = new fm.liveswitch.HashContext(type);
                    var buffer = context.compute(input);
                    context.destroy();
                    return buffer;
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                    var type = arguments[0];
                    var inputString = arguments[1];
                    var context = new fm.liveswitch.HashContext(type);
                    var buffer = context.compute(inputString);
                    context.destroy();
                    return buffer;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            HashContextBase.prototype.compute = function () {
                if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.DataBuffer]'))) {
                    var input = arguments[0];
                    return this.doCompute(input);
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                    var inputString = arguments[0];
                    return this.doCompute(fm.liveswitch.DataBuffer.wrap(fm.liveswitch.Utf8.encode(inputString)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Destroys this instance.
            */
            HashContextBase.prototype.destroy = function () {
                if (arguments.length == 0) {
                    this.doDestroy();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the type.
            */
            HashContextBase.prototype.getType = function () {
                if (arguments.length == 0) {
                    return this._type;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            HashContextBase.prototype.setType = function (value) {
                if (arguments.length == 1) {
                    this._type = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return HashContextBase;
        }());
        liveswitch.HashContextBase = HashContextBase;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="HashContextBase.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var HashContext = /** @class */ (function (_super) {
            __extends(HashContext, _super);
            function HashContext(type) {
                return _super.call(this, type) || this;
            }
            HashContext.prototype.getTypeString = function () {
                return '[fm.liveswitch.HashContext]';
            };
            HashContext.prototype.doCompute = function (input) {
                if (this.getType() == fm.liveswitch.HashType.Md5) {
                    return null;
                }
                else if (this.getType() == fm.liveswitch.HashType.Sha1) {
                    return null;
                }
                else if (this.getType() == fm.liveswitch.HashType.Sha256) {
                    var hash = new fm.liveswitch.Sha256();
                    hash.update(input.getData());
                    var digest = hash.digest();
                    hash.clean();
                    return fm.liveswitch.DataBuffer.wrap(digest);
                }
                throw new fm.liveswitch.Exception('Unknown hash type.');
            };
            HashContext.prototype.doDestroy = function () { };
            return HashContext;
        }(fm.liveswitch.HashContextBase));
        liveswitch.HashContext = HashContext;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var HashExtensions = /** @class */ (function () {
            function HashExtensions() {
            }
            HashExtensions.prototype.getTypeString = function () {
                return '[fm.liveswitch.HashExtensions]';
            };
            HashExtensions.getCount = function (obj) {
                var i = 0;
                for (var key in obj) {
                    i++;
                }
                return i;
            };
            HashExtensions.getKeys = function (obj) {
                var keys = [];
                for (var key in obj) {
                    keys.push(key);
                }
                return keys;
            };
            HashExtensions.getValues = function (obj) {
                var values = [];
                for (var key in obj) {
                    values.push(obj[key]);
                }
                return values;
            };
            HashExtensions.tryGetValue = function (obj, key, holder) {
                if (HashExtensions.containsKey(obj, key)) {
                    holder.setValue(obj[key]);
                    return true;
                }
                return false;
            };
            HashExtensions.containsKey = function (obj, key) {
                if (key in obj) {
                    return true;
                }
                else {
                    return false;
                }
            };
            HashExtensions.containsValue = function (obj, value) {
                for (var key in obj) {
                    if (obj[key] === value) {
                        return true;
                    }
                }
                return false;
            };
            HashExtensions.add = function (obj, key, value) {
                obj[key] = value;
                return value;
            };
            HashExtensions.remove = function (obj, key) {
                if (HashExtensions.containsKey(obj, key)) {
                    delete obj[key];
                    return true;
                }
                return false;
            };
            HashExtensions.clear = function (obj) {
                for (var key in obj) {
                    delete obj[key];
                }
            };
            return HashExtensions;
        }());
        liveswitch.HashExtensions = HashExtensions;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        // SHA-256 (+ HMAC and PBKDF2) for JavaScript.
        //
        // Written in 2014-2016 by Dmitry Chestnykh.
        // Public domain, no warranty.
        var digestLength = 32;
        var blockSize = 64;
        // SHA-256 constants
        var K = new Uint32Array([
            0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b,
            0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01,
            0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7,
            0xc19bf174, 0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
            0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152,
            0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147,
            0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc,
            0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
            0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819,
            0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08,
            0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f,
            0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
            0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
        ]);
        function hashBlocks(w, v, p, pos, len) {
            var a, b, c, d, e, f, g, h, u, i, j, t1, t2;
            while (len >= 64) {
                a = v[0];
                b = v[1];
                c = v[2];
                d = v[3];
                e = v[4];
                f = v[5];
                g = v[6];
                h = v[7];
                for (i = 0; i < 16; i++) {
                    j = pos + i * 4;
                    w[i] = (((p[j] & 0xff) << 24) | ((p[j + 1] & 0xff) << 16) |
                        ((p[j + 2] & 0xff) << 8) | (p[j + 3] & 0xff));
                }
                for (i = 16; i < 64; i++) {
                    u = w[i - 2];
                    t1 = (u >>> 17 | u << (32 - 17)) ^ (u >>> 19 | u << (32 - 19)) ^ (u >>> 10);
                    u = w[i - 15];
                    t2 = (u >>> 7 | u << (32 - 7)) ^ (u >>> 18 | u << (32 - 18)) ^ (u >>> 3);
                    w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0);
                }
                for (i = 0; i < 64; i++) {
                    t1 = (((((e >>> 6 | e << (32 - 6)) ^ (e >>> 11 | e << (32 - 11)) ^
                        (e >>> 25 | e << (32 - 25))) + ((e & f) ^ (~e & g))) | 0) +
                        ((h + ((K[i] + w[i]) | 0)) | 0)) | 0;
                    t2 = (((a >>> 2 | a << (32 - 2)) ^ (a >>> 13 | a << (32 - 13)) ^
                        (a >>> 22 | a << (32 - 22))) + ((a & b) ^ (a & c) ^ (b & c))) | 0;
                    h = g;
                    g = f;
                    f = e;
                    e = (d + t1) | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = (t1 + t2) | 0;
                }
                v[0] += a;
                v[1] += b;
                v[2] += c;
                v[3] += d;
                v[4] += e;
                v[5] += f;
                v[6] += g;
                v[7] += h;
                pos += 64;
                len -= 64;
            }
            return pos;
        }
        // HMAC implements HMAC-SHA256 message authentication algorithm.
        var HmacSha256 = /** @class */ (function () {
            function HmacSha256(key) {
                this.inner = new fm.liveswitch.Sha256();
                this.outer = new fm.liveswitch.Sha256();
                this.blockSize = this.inner.blockSize;
                this.digestLength = this.inner.digestLength;
                var pad = new Uint8Array(this.blockSize);
                if (key.length > this.blockSize) {
                    (new fm.liveswitch.Sha256()).update(key).finish(pad).clean();
                }
                else {
                    for (var i = 0; i < key.length; i++) {
                        pad[i] = key[i];
                    }
                }
                for (var i = 0; i < pad.length; i++) {
                    pad[i] ^= 0x36;
                }
                this.inner.update(pad);
                for (var i = 0; i < pad.length; i++) {
                    pad[i] ^= 0x36 ^ 0x5c;
                }
                this.outer.update(pad);
                this.istate = new Uint32Array(8);
                this.ostate = new Uint32Array(8);
                this.inner._saveState(this.istate);
                this.outer._saveState(this.ostate);
                for (var i = 0; i < pad.length; i++) {
                    pad[i] = 0;
                }
            }
            // Returns HMAC state to the state initialized with key
            // to make it possible to run HMAC over the other data with the same
            // key without creating a new instance.
            HmacSha256.prototype.reset = function () {
                this.inner._restoreState(this.istate, this.inner.blockSize);
                this.outer._restoreState(this.ostate, this.outer.blockSize);
                return this;
            };
            // Cleans HMAC state.
            HmacSha256.prototype.clean = function () {
                for (var i = 0; i < this.istate.length; i++) {
                    this.ostate[i] = this.istate[i] = 0;
                }
                this.inner.clean();
                this.outer.clean();
            };
            // Updates state with provided data.
            HmacSha256.prototype.update = function (data) {
                this.inner.update(data);
                return this;
            };
            // Finalizes HMAC and puts the result in out.
            HmacSha256.prototype.finish = function (out) {
                if (this.outer.finished) {
                    this.outer.finish(out);
                }
                else {
                    this.inner.finish(out);
                    this.outer.update(out, this.digestLength).finish(out);
                }
                return this;
            };
            // Returns message authentication code.
            HmacSha256.prototype.digest = function () {
                var out = new Uint8Array(this.digestLength);
                this.finish(out);
                return out;
            };
            return HmacSha256;
        }());
        liveswitch.HmacSha256 = HmacSha256;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Holder = /** @class */ (function () {
            function Holder(value) {
                this._value = value;
            }
            Holder.prototype.getTypeString = function () {
                return '[fm.liveswitch.Holder]';
            };
            Holder.prototype.getValue = function () {
                return this._value;
            };
            Holder.prototype.setValue = function (value) {
                this._value = value;
            };
            return Holder;
        }());
        liveswitch.Holder = Holder;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Base class that defines methods for transferring content over HTTP.
        */
        var HttpTransfer = /** @class */ (function () {
            function HttpTransfer() {
                fm.liveswitch.HttpTransfer.fmliveswitchHttpTransferInitialize();
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            HttpTransfer.prototype.getTypeString = function () {
                return '[fm.liveswitch.HttpTransfer]';
            };
            /**
            Adds a handler that is raised before an HTTP request is sent.
            */
            HttpTransfer.addOnSendFinish = function (value) {
                fm.liveswitch.HttpTransfer.fmliveswitchHttpTransferInitialize();
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(fm.liveswitch.HttpTransfer.fm_liveswitch_HttpTransfer___onSendFinish, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised before an HTTP request is sent.
            */
            HttpTransfer.addOnSendStart = function (value) {
                fm.liveswitch.HttpTransfer.fmliveswitchHttpTransferInitialize();
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(fm.liveswitch.HttpTransfer.fm_liveswitch_HttpTransfer___onSendStart, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            HttpTransfer.addQueryToUrl = function () {
                fm.liveswitch.HttpTransfer.fmliveswitchHttpTransferInitialize();
                if (arguments.length == 2) {
                    var url = arguments[0];
                    var key = arguments[1];
                    return fm.liveswitch.HttpTransfer.addQueryToUrl(url, key, null);
                }
                else if (arguments.length == 3) {
                    var url = arguments[0];
                    var key = arguments[1];
                    var value = arguments[2];
                    if (fm.liveswitch.StringExtensions.isNullOrEmpty(key)) {
                        return url;
                    }
                    if ((fm.liveswitch.Global.equals(value, null))) {
                        value = fm.liveswitch.StringExtensions.empty;
                    }
                    key = fm.liveswitch.Uri.escapeDataString(key);
                    value = fm.liveswitch.Uri.escapeDataString(value);
                    return fm.liveswitch.StringExtensions.concat([url, ((fm.liveswitch.Global.equals(fm.liveswitch.StringExtensions.indexOf(url, "?", fm.liveswitch.StringComparison.OrdinalIgnoreCase), -1)) ? "?" : "&"), key, "=", value]);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a random wildcard character.
            @return A random wildcard character.
            */
            HttpTransfer.getRandomWildcardCharacter = function () {
                fm.liveswitch.HttpTransfer.fmliveswitchHttpTransferInitialize();
                if (arguments.length == 0) {
                    var wildcardCharacters = fm.liveswitch.HttpTransfer.getWildcardCharacters();
                    var startIndex = new fm.liveswitch.Randomizer().next(fm.liveswitch.StringExtensions.getLength(wildcardCharacters));
                    return fm.liveswitch.StringExtensions.substring(wildcardCharacters, startIndex, 1);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the wildcard characters used to replace asterisks in ReplaceWildcards.
            */
            HttpTransfer.getWildcardCharacters = function () {
                fm.liveswitch.HttpTransfer.fmliveswitchHttpTransferInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.HttpTransfer.fm_liveswitch_HttpTransfer___wildcardCharacters;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised before an HTTP request is sent.
            */
            HttpTransfer.removeOnSendFinish = function (value) {
                fm.liveswitch.HttpTransfer.fmliveswitchHttpTransferInitialize();
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.HttpTransfer.fm_liveswitch_HttpTransfer___onSendFinish, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised before an HTTP request is sent.
            */
            HttpTransfer.removeOnSendStart = function (value) {
                fm.liveswitch.HttpTransfer.fmliveswitchHttpTransferInitialize();
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.HttpTransfer.fm_liveswitch_HttpTransfer___onSendStart, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Replaces asterisks in URLs with characters from WildcardCharacters.
            @param url The URL with asterisks.
            */
            HttpTransfer.replaceWildcards = function (url) {
                fm.liveswitch.HttpTransfer.fmliveswitchHttpTransferInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.StringExtensions.replace(url, "*", fm.liveswitch.HttpTransfer.getRandomWildcardCharacter());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the wildcard characters used to replace asterisks in ReplaceWildcards.
            */
            HttpTransfer.setWildcardCharacters = function (value) {
                fm.liveswitch.HttpTransfer.fmliveswitchHttpTransferInitialize();
                if (arguments.length == 1) {
                    fm.liveswitch.HttpTransfer.fm_liveswitch_HttpTransfer___wildcardCharacters = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            HttpTransfer.prototype.doSend = function (requestArgs) {
                if (arguments.length == 1) {
                    var args = void 0;
                    this.startRequest(requestArgs);
                    try {
                        if ((!fm.liveswitch.Global.equals(requestArgs.getBinaryContent(), null))) {
                            args = this.sendBinary(requestArgs);
                        }
                        else {
                            args = this.sendText(requestArgs);
                        }
                    }
                    catch (exception) {
                        var args2 = new fm.liveswitch.HttpResponseArgs(requestArgs);
                        args2.setException(exception);
                        args = args2;
                    }
                    finally {
                    }
                    this.finishRequest(args);
                    return args;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            HttpTransfer.prototype.doSendAsync = function (requestArgs, callback, attempt, retryLogScope) {
                var _this = this;
                if (arguments.length == 4) {
                    var action = null;
                    var action2 = null;
                    this.startRequest(requestArgs);
                    try {
                        if ((!fm.liveswitch.Global.equals(requestArgs.getBinaryContent(), null))) {
                            if ((fm.liveswitch.Global.equals(action, null))) {
                                action = function (responseArgs) {
                                    _this.finishRequest(responseArgs);
                                    _this.sendAsyncCallback(requestArgs, responseArgs, callback, attempt, retryLogScope);
                                };
                            }
                            this.sendBinaryAsync(requestArgs, action);
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(action2, null))) {
                                action2 = function (responseArgs) {
                                    _this.finishRequest(responseArgs);
                                    _this.sendAsyncCallback(requestArgs, responseArgs, callback, attempt, retryLogScope);
                                };
                            }
                            this.sendTextAsync(requestArgs, action2);
                        }
                    }
                    catch (exception) {
                        var args = new fm.liveswitch.HttpResponseArgs(requestArgs);
                        args.setException(exception);
                        this.sendAsyncCallback(requestArgs, args, callback, attempt, retryLogScope);
                    }
                    finally {
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            HttpTransfer.prototype.finishRequest = function (responseArgs) {
                if (arguments.length == 1) {
                    this.raiseOnSendFinish(responseArgs);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            HttpTransfer.prototype.raiseOnSendFinish = function (responseArgs) {
                if (arguments.length == 1) {
                    var onSendFinish = fm.liveswitch.HttpTransfer.fm_liveswitch_HttpTransfer__onSendFinish;
                    if ((!fm.liveswitch.Global.equals(onSendFinish, null))) {
                        var p = new fm.liveswitch.HttpSendFinishArgs();
                        p.setSender(responseArgs.getRequestArgs().getSender());
                        p.setRequestBinaryContent(responseArgs.getRequestArgs().getBinaryContent());
                        p.setRequestTextContent(responseArgs.getRequestArgs().getTextContent());
                        p.setResponseBinaryContent(responseArgs.getBinaryContent());
                        p.setResponseTextContent(responseArgs.getTextContent());
                        p.setResponseHeaders(responseArgs.getHeaders());
                        onSendFinish(p);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            HttpTransfer.prototype.raiseOnSendStart = function (requestArgs) {
                if (arguments.length == 1) {
                    var onSendStart = fm.liveswitch.HttpTransfer.fm_liveswitch_HttpTransfer__onSendStart;
                    if ((!fm.liveswitch.Global.equals(onSendStart, null))) {
                        var p = new fm.liveswitch.HttpSendStartArgs();
                        p.setSender(requestArgs.getSender());
                        p.setRequestBinaryContent(requestArgs.getBinaryContent());
                        p.setRequestTextContent(requestArgs.getTextContent());
                        onSendStart(p);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sends a request synchronously.
            @param requestArgs The request parameters.
            @return The resulting response.
            */
            HttpTransfer.prototype.send = function (requestArgs) {
                if (arguments.length == 1) {
                    var num = 0;
                    var scope = null;
                    var args = this.doSend(requestArgs);
                    while (((!fm.liveswitch.Global.equals(args.getException(), null)) && (num < requestArgs.getMaxRetries()))) {
                        num++;
                        scope = fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "");
                        fm.liveswitch.HttpTransfer.fm_liveswitch_HttpTransfer___log.warn(scope, fm.liveswitch.StringExtensions.format("Synchronous HTTP request failed, but retrying... (attempt #{0}).", fm.liveswitch.NumberExtensions.toString(num)), args.getException());
                        args = this.doSend(requestArgs);
                    }
                    if (((!fm.liveswitch.Global.equals(args.getException(), null)) && (!fm.liveswitch.Global.equals(scope, null)))) {
                        args.setRetries(num);
                        fm.liveswitch.HttpTransfer.fm_liveswitch_HttpTransfer___log.warn(scope, "Synchronous HTTP request failed, and retries exhausted.", args.getException());
                    }
                    return args;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sends a request asynchronously.
            @param requestArgs The request parameters.
            @param callback The callback to execute with the resulting response.
            */
            HttpTransfer.prototype.sendAsync = function (requestArgs, callback) {
                if (arguments.length == 2) {
                    this.doSendAsync(requestArgs, callback, 0, null);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            HttpTransfer.prototype.sendAsyncCallback = function (requestArgs, responseArgs, callback, attempt, retryLogScope) {
                if (arguments.length == 5) {
                    if (((!fm.liveswitch.Global.equals(responseArgs.getException(), null)) && (attempt < requestArgs.getMaxRetries()))) {
                        attempt++;
                        retryLogScope = fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "");
                        fm.liveswitch.HttpTransfer.fm_liveswitch_HttpTransfer___log.warn(retryLogScope, fm.liveswitch.StringExtensions.format("Asynchronous HTTP request failed, but retrying... (attempt #{0}).", fm.liveswitch.NumberExtensions.toString(attempt)), responseArgs.getException());
                        this.doSendAsync(requestArgs, callback, attempt, retryLogScope);
                    }
                    else {
                        if (((!fm.liveswitch.Global.equals(responseArgs.getException(), null)) && (!fm.liveswitch.Global.equals(retryLogScope, null)))) {
                            responseArgs.setRetries(attempt);
                            fm.liveswitch.HttpTransfer.fm_liveswitch_HttpTransfer___log.warn(retryLogScope, "Asynchronous HTTP request failed, and retries exhausted.", responseArgs.getException());
                        }
                        callback(responseArgs);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            HttpTransfer.prototype.startRequest = function (requestArgs) {
                if (arguments.length == 1) {
                    this.raiseOnSendStart(requestArgs);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            HttpTransfer.fmliveswitchHttpTransferInitialize = function () {
                if (!fm.liveswitch.HttpTransfer.__fmliveswitchHttpTransferInitialized && !fm.liveswitch.HttpTransfer.__fmliveswitchHttpTransferInitializing) {
                    fm.liveswitch.HttpTransfer.__fmliveswitchHttpTransferInitializing = true;
                    HttpTransfer.fm_liveswitch_HttpTransfer___onSendFinish = [];
                    HttpTransfer.fm_liveswitch_HttpTransfer___onSendStart = [];
                    HttpTransfer.fm_liveswitch_HttpTransfer__onSendFinish = function (p0) { for (var _i = 0, _a = fm.liveswitch.HttpTransfer.fm_liveswitch_HttpTransfer___onSendFinish; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    HttpTransfer.fm_liveswitch_HttpTransfer__onSendStart = function (p0) { for (var _i = 0, _a = fm.liveswitch.HttpTransfer.fm_liveswitch_HttpTransfer___onSendStart; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    fm.liveswitch.HttpTransfer.fm_liveswitch_HttpTransfer___log = fm.liveswitch.Log.getLogger(new fm.liveswitch.Type('[fm.liveswitch.HttpTransfer]'));
                    fm.liveswitch.HttpTransfer.fm_liveswitch_HttpTransfer___wildcardCharacters = "abcdefghijklmnopqrstuvwxyz";
                    fm.liveswitch.HttpTransfer.__fmliveswitchHttpTransferInitialized = true;
                    fm.liveswitch.HttpTransfer.__fmliveswitchHttpTransferInitializing = false;
                }
            };
            /** @hidden */
            HttpTransfer.__fmliveswitchHttpTransferInitialized = false;
            /** @hidden */
            HttpTransfer.__fmliveswitchHttpTransferInitializing = false;
            return HttpTransfer;
        }());
        liveswitch.HttpTransfer = HttpTransfer;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
var fmliveswitchGlobalIsError = function (obj) {
    return (obj instanceof Error);
};

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Util = /** @class */ (function () {
            function Util() {
            }
            Util.prototype.getTypeString = function () {
                return '[fm.liveswitch.Util]';
            };
            Util.isNumber = function (obj) {
                return Object.prototype.toString.call(obj) === '[object Number]';
            };
            Util.isString = function (obj) {
                return Object.prototype.toString.call(obj) === '[object String]';
            };
            Util.isBoolean = function (obj) {
                return Object.prototype.toString.call(obj) === '[object Boolean]';
            };
            Util.isNull = function (obj) {
                return Object.prototype.toString.call(obj) === '[object Null]';
            };
            Util.isUndefined = function (obj) {
                return Object.prototype.toString.call(obj) === '[object Undefined]';
            };
            Util.isNullOrUndefined = function (obj) {
                return Util.isNull(obj) || Util.isUndefined(obj);
            };
            Util.isFunction = function (obj) {
                return Object.prototype.toString.call(obj) === '[object Function]';
            };
            Util.isArray = function (obj) {
                return Object.prototype.toString.call(obj) === '[object Array]';
            };
            Util.isUint8Array = function (obj) {
                return Object.prototype.toString.call(obj) === '[object Uint8Array]';
            };
            Util.isDate = function (obj) {
                return Object.prototype.toString.call(obj) === '[object Date]';
            };
            Util.isRegExp = function (obj) {
                return Object.prototype.toString.call(obj) === '[object RegExp]';
            };
            Util.isError = function (obj) {
                try {
                    if (fmliveswitchGlobalIsError(obj)) {
                        return true;
                    }
                }
                catch (_a) { }
                try {
                    var objName = Object.prototype.toString.call(obj);
                    return /\[object .*(Error|Exception)\]/.test(objName);
                }
                catch (_b) { }
                return false;
            };
            Util.isObject = function (obj) {
                return Object.prototype.toString.call(obj) === '[object Object]';
            };
            Util.isObjectType = function (obj, typeString) {
                return (Util.isObject(obj) && Util.isFunction(obj.getTypeString) && obj.getTypeString().indexOf(typeString) > -1);
            };
            Util.isArrayType = function (obj, typeString) {
                return (Util.isArray(obj) && (obj.length == 0 || (Util.isNullOrUndefined(obj[0]) || Util.isObjectType(obj[0], typeString))));
            };
            Util.isPlainObject = function (obj) {
                // following code from jQuery - excellent work!
                // ignore DOM nodes and window
                if (!obj || Object.prototype.toString.call(obj) !== '[object Object]' || obj.nodeType || obj === obj.window) {
                    return false;
                }
                // Because of IE, we also have to check the presence of the constructor property.
                try {
                    if (obj.constructor && !Object.prototype.hasOwnProperty.call(obj, "constructor") && !Object.prototype.hasOwnProperty.call(obj.constructor.prototype, "isPrototypeOf")) {
                        return false;
                    }
                }
                catch (error) {
                    return false;
                }
                // Own properties are enumerated firstly, so to speed up,
                // if last one is own, then all properties are own.
                var key;
                for (key in obj) { }
                return (key === void 0 || Object.prototype.hasOwnProperty.call(obj, key));
            };
            Util.canAttachProperties = function (instance, obj) {
                for (var key in obj) {
                    var value = obj[key];
                    var setterName = 'set' + key.charAt(0).toUpperCase() + key.substring(1);
                    var setter = instance[setterName];
                    if (!setter || Object.prototype.toString.call(setter) !== '[object Function]') {
                        return false;
                    }
                }
                return true;
            };
            Util.attachProperties = function (instance, obj) {
                for (var key in obj) {
                    var value = obj[key];
                    var setterName = 'set' + key.charAt(0).toUpperCase() + key.substring(1);
                    var setter = instance[setterName];
                    if (setter && Object.prototype.toString.call(setter) === '[object Function]') {
                        setter.call(instance, value);
                    }
                    else {
                        setter = instance['setExtensionValue'];
                        if (setter && Object.prototype.toString.call(setter) === '[object Function]') {
                            if (Object.prototype.toString.call(value) === '[object Function]') {
                                fm.liveswitch.Log.warn('Property "' + key + '" did not match any known setter and has a function as its value. Please verify your callback names are correct.');
                            }
                            else {
                                setter.call(instance, key, value);
                                fm.liveswitch.Log.debug('Property "' + key + '" did not match any known setter and is assumed to be an extension value.');
                            }
                        }
                        else {
                            fm.liveswitch.Log.debug('Property "' + key + '" did not match any known setter and was ignored.');
                        }
                    }
                }
                return instance;
            };
            Util.isIE = function () {
                return !!document.protocol;
            };
            Util.isIE6 = function () {
                return Util.isIE() && !window.XMLHttpRequest;
            };
            Util.isIE7 = function () {
                return Util.isIE() && window.XMLHttpRequest && !document.implementation;
            };
            Util.isIE8 = function () {
                return Util.isIE() && document.implementation && document.implementation.hasFeature && !document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1");
            };
            Util.isIE9 = function () {
                return Util.isIE() && document.implementation && document.implementation.hasFeature && document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1");
            };
            Util.isEdge = function () {
                return navigator.userAgent.match(/edge\//i) != null;
            };
            Util.isChrome = function () {
                return navigator.userAgent.match(/chrome/i) != null;
            };
            Util.isSafari9 = function () {
                return Util.isSafari() && navigator.userAgent.match(/version\/9\.\d(\.\d+)*(mobile\/[a-zA-Z0-9]+)? safari/i) != null;
            };
            Util.isSafari10 = function () {
                return Util.isSafari() && navigator.userAgent.match(/version\/10\.\d(\.\d+)*(mobile\/[a-zA-Z0-9]+)? safari/i) != null;
            };
            Util.isSafari11 = function () {
                return Util.isSafari() && navigator.userAgent.match(/version\/11\.\d(\.\d+)*(mobile\/[a-zA-Z0-9]+)? safari/i) != null;
            };
            Util.isSafari12 = function () {
                return Util.isSafari() && navigator.userAgent.match(/version\/12\.\d(\.\d+)*(mobile\/[a-zA-Z0-9]+)? safari/i) != null;
            };
            Util.isSafari12_1 = function () {
                return Util.isSafari() && navigator.userAgent.match(/version\/12\.1(\.\d+)*(mobile\/[a-zA-Z0-9]+)? safari/i) != null;
            };
            Util.isSafari = function () {
                if (Util.isChrome() || Util.isEdge()) {
                    return false;
                }
                return navigator.userAgent.match(/safari/i) != null;
            };
            Util.isOpera = function () {
                return navigator.userAgent.match(/Opera Mini/i) != null;
            };
            Util.isWindows = function () {
                return navigator.userAgent.match(/IEMobile/i) != null;
            };
            Util.isAndroid = function () {
                return navigator.userAgent.match(/Android/i) != null;
            };
            Util.isBlackBerry = function () {
                return navigator.userAgent.match(/BlackBerry/i) != null;
            };
            Util.isiOS = function () {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i) != null;
            };
            Util.isMobile = function () {
                return Util.isAndroid() || Util.isBlackBerry() || Util.isiOS() || Util.isOpera() || Util.isWindows();
            };
            Util.hasActiveX = function (checkFiltering) {
                var hasActiveX = window.ActiveXObject !== void 0;
                if (checkFiltering && hasActiveX && typeof window.external.msActiveXFilteringEnabled !== 'undefined' && window.external.msActiveXFilteringEnabled()) {
                    hasActiveX = false;
                    fm.liveswitch.Log.debug('ActiveX is filtered and cannot be used.');
                }
                return hasActiveX;
            };
            Util.hasJava = function () {
                return (Util.getJavaVersion() != null);
            };
            Util.getJavaVersion = function () {
                if (Util.isIE() && Util.hasActiveX()) {
                    if (Util.isJavaWebStartInstalledActiveX('1.9.0')) {
                        return '1.9.0';
                    }
                    if (Util.isJavaWebStartInstalledActiveX('1.8.0')) {
                        return '1.8.0';
                    }
                    if (Util.isJavaWebStartInstalledActiveX('1.7.0')) {
                        return '1.7.0';
                    }
                    if (Util.isJavaWebStartInstalledActiveX('1.6.0')) {
                        return '1.6.0';
                    }
                    if (Util.isJavaWebStartInstalledActiveX('1.5.0')) {
                        return '1.5.0';
                    }
                    if (Util.isJavaWebStartInstalledActiveX('1.4.2')) {
                        return '1.4.2';
                    }
                    return null;
                }
                else {
                    var version = null;
                    var mimes = window.navigator.mimeTypes;
                    if (mimes) {
                        for (var i = 0; i < mimes.length; i++) {
                            var mime = mimes[i];
                            var t = mime.type;
                            if (t.indexOf('java') > 0 && t.indexOf('jpi') > 0 && t.indexOf('applet') > 0) {
                                var parts = t.split('=');
                                version = parts[parts.length - 1];
                            }
                        }
                    }
                    return version;
                }
            };
            Util.isJavaWebStartInstalledActiveX = function (version) {
                try {
                    return Util.hasActiveX() && (new ActiveXObject('JavaWebStart.isInstalled.' + version + '.0') !== null);
                }
                catch (error) {
                    return false;
                }
            };
            Util.isXD = function (url1, url2) {
                try {
                    if (typeof url2 !== 'undefined') {
                        var host1 = Util.getHost(url1);
                        var host2 = Util.getHost(url2);
                        return Util.compareHost(host1, host2);
                    }
                    else {
                        if (!Util._xdCache[url1]) {
                            var handlerHost = Util.getHost(url1);
                            var thisHost = Util.getHost();
                            Util._xdCache[url1] = Util.compareHost(handlerHost, thisHost) ? 'y' : 'n';
                        }
                        return Util._xdCache[url1] === 'y';
                    }
                }
                catch (error) {
                    return false;
                }
            };
            Util.getHost = function (url) {
                if (!url) {
                    return Util.getCurrentHost();
                }
                var parsed = Util.parseUrl(url);
                if (!parsed.protocol) {
                    return Util.getCurrentHost();
                }
                return parsed;
            };
            Util.compareHost = function (host1, host2) {
                return host1.server !== host2.server || ((host1.port || host2.port) && host1.port !== host2.port);
            };
            Util.getCurrentHost = function () {
                var l = document.location;
                return {
                    protocol: l.protocol,
                    server: l.hostname,
                    port: l.port
                };
            };
            Util.parseUrl = function (url) {
                var parts = /(((http|ws)s?:)\/\/)?([\-\w\.\*]+)+(:(\d+))?(\/([^\?]*(\?\S+)?)?)?/i.exec(url);
                if (parts.length < 6) {
                    throw new fm.liveswitch.Exception('Invalid URL (' + url + ').');
                }
                return {
                    prefix: parts[1],
                    protocol: parts[2],
                    server: parts[4],
                    postfix: parts[5],
                    port: parts[6],
                    path: parts[7]
                };
            };
            Util.absolutizeUrl = function (url) {
                if (!url) {
                    return url;
                }
                var parsed = Util.parseUrl(url);
                if (parsed.protocol) {
                    if (parsed.server.indexOf('*') === -1) {
                        return url;
                    }
                    url = parsed.prefix + Util.wildcard(parsed.server);
                    if (parsed.postfix) {
                        url += parsed.postfix;
                    }
                    if (parsed.path) {
                        url += parsed.path;
                    }
                    return url;
                }
                var l = document.location;
                var base = l.protocol + '//' + l.host;
                if (url.charAt(0) === '/') {
                    return base + url;
                }
                else {
                    return base + l.pathname.substring(0, l.pathname.lastIndexOf('/') + 1) + url;
                }
            };
            Util.wildcard = function (str) {
                return str.replace('*', Util.getWildcard());
            };
            Util.getWildcard = function () {
                if (Util._wildcard === null) {
                    Util._wildcard = Util.randomChar(Util._chars);
                }
                return Util._wildcard;
            };
            Util.randomChar = function (str) {
                if (!str) {
                    return str;
                }
                return str.charAt(Math.floor(Math.random() * str.length));
            };
            Util.observe = function (element, event, handler) {
                if (element.addEventListener) {
                    element.addEventListener(event, handler, false);
                }
                else if (element.attachEvent) {
                    element.attachEvent('on' + event, handler);
                }
                else {
                    element['on' + event] = handler;
                }
            };
            Util.unobserve = function (element, event, handler) {
                if (element.removeEventListener) {
                    element.removeEventListener(event, handler, false);
                }
                else {
                    element.detachEvent('on' + event, handler);
                }
            };
            Util.observeAttr = function (element, handler) {
                var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
                var isDOMAttrModifiedSupported = function () {
                    var p = document.createElement('p');
                    var flag = false;
                    if (p.addEventListener) {
                        p.addEventListener('DOMAttrModified', function () {
                            return flag = true;
                        }, false);
                    }
                    else if (p.attachEvent) {
                        p.attachEvent('onDOMAttrModified', function () {
                            return flag = true;
                        });
                    }
                    else {
                        return false;
                    }
                    p.setAttribute('id', 'target');
                    return flag;
                };
                if (MutationObserver) {
                    var options = {
                        subtree: false,
                        attributes: true
                    };
                    var observer = new MutationObserver(function (mutations, observer) {
                        for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
                            var mutation = mutations_1[_i];
                            handler.call(mutation.target, mutation.attributeName);
                        }
                    });
                    observer.observe(element, options);
                }
                else if (isDOMAttrModifiedSupported()) {
                    Util.observe(element, 'DOMAttrModified', function (e) {
                        handler.call(element, e.attrName);
                    });
                }
                else if ('onpropertychange' in document.body) {
                    Util.observe(element, 'propertychange', function (e) {
                        handler.call(element, window.event.propertyName);
                    });
                }
            };
            Util.construct = function (func, args) {
                return (function (func, args, ctor) {
                    ctor.prototype = func.prototype;
                    var child = new ctor, result = func.apply(child, args);
                    return Object(result) === result ? result : child;
                })(func, args, function () { });
            };
            Util.extend = function (dest, src) {
                for (var key in src) {
                    dest[key] = src[key];
                }
                return dest;
            };
            Util.addOnLoad = function (fn) {
                if (Util._readyRun) {
                    window.setTimeout(fn, 1);
                }
                else {
                    Util._loadFunctions.push(fn);
                }
            };
            Util.ready = function () {
                if (Util._readyRun) {
                    return;
                }
                Util._readyRun = true;
                window.setTimeout(function () {
                    for (var _i = 0, _a = Util._loadFunctions; _i < _a.length; _i++) {
                        var loadFunction = _a[_i];
                        loadFunction();
                    }
                }, 1);
            };
            Util.bindReady = function () {
                if (Util._readyBound) {
                    return;
                }
                // the below code is shamelessly stolen from jQuery.
                // awesome work guys!
                Util._readyBound = true;
                if (document.readyState === 'complete') {
                    window.setTimeout(function () {
                        Util.ready();
                    }, 1);
                }
                else if (document.addEventListener) {
                    // Mozilla, Opera, WebKit
                    document.addEventListener("DOMContentLoaded", function () {
                        document.removeEventListener("DOMContentLoaded", arguments.callee, false);
                        Util.ready();
                    }, false);
                    window.addEventListener("load", function () {
                        window.removeEventListener("load", arguments.callee, false);
                        Util.ready();
                    }, false);
                }
                else if (document.attachEvent) {
                    // for good ol' IE...
                    document.attachEvent("onreadystatechange", function () {
                        if (document.readyState === "complete") {
                            document.detachEvent("onreadystatechange", arguments.callee);
                            Util.ready();
                        }
                    });
                    var topLevel = void 0;
                    try {
                        topLevel = window.frameElement === null;
                    }
                    catch (undefined) { }
                    if (document.documentElement.doScroll && topLevel) {
                        (function () {
                            if (Util._loaded) {
                                return;
                            }
                            try {
                                document.documentElement.doScroll("left");
                            }
                            catch (error) {
                                window.setTimeout(arguments.callee, 0);
                                return;
                            }
                            Util.ready();
                        })();
                    }
                }
                else {
                    Util.ready();
                }
            };
            Util.initialize = function () {
                if (!Util.__initialized) {
                    if (!Util._loaded) {
                        Util.addOnLoad(function () {
                            Util._loaded = true;
                        });
                    }
                    Util.bindReady();
                }
                Util.__initialized = true;
            };
            Util._xdCache = {};
            Util._chars = 'abcdefghijklmnopqrstuvwxyz';
            Util._loadFunctions = [];
            Util._wildcard = null;
            Util._readyRun = false;
            Util._readyBound = false;
            Util._loaded = false;
            Util.__initialized = false;
            return Util;
        }());
        liveswitch.Util = Util;
        Util.initialize(); // static constructor
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="HttpTransfer.ts" />
/// <reference path="Util.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var HttpWebRequestTransfer = /** @class */ (function (_super) {
            __extends(HttpWebRequestTransfer, _super);
            function HttpWebRequestTransfer() {
                return _super.call(this) || this;
            }
            HttpWebRequestTransfer.prototype.getTypeString = function () {
                return '[fm.liveswitch.HttpWebRequestTransfer]' + ',' + _super.prototype.getTypeString.call(this);
            };
            HttpWebRequestTransfer.setDisableCors = function (disableCors) {
                HttpWebRequestTransfer._disableCors = disableCors;
            };
            HttpWebRequestTransfer.getDisableCors = function () {
                return HttpWebRequestTransfer._disableCors || false;
            };
            HttpWebRequestTransfer.setDisablePostMessage = function (disablePostMessage) {
                HttpWebRequestTransfer._disablePostMessage = disablePostMessage;
            };
            HttpWebRequestTransfer.getDisablePostMessage = function () {
                return HttpWebRequestTransfer._disablePostMessage || false;
            };
            HttpWebRequestTransfer.setDisableJsonp = function (disableJsonp) {
                HttpWebRequestTransfer._disableJsonp = disableJsonp;
            };
            HttpWebRequestTransfer.getDisableJsonp = function () {
                return HttpWebRequestTransfer._disableJsonp || false;
            };
            HttpWebRequestTransfer.setForceJsonp = function (forceJsonp) {
                HttpWebRequestTransfer._forceJsonp = forceJsonp;
            };
            HttpWebRequestTransfer.getForceJsonp = function () {
                return HttpWebRequestTransfer._forceJsonp || false;
            };
            HttpWebRequestTransfer.canCors = function () {
                return window.XMLHttpRequest && ('withCredentials' in new XMLHttpRequest());
            };
            HttpWebRequestTransfer.canPostMessage = function () {
                if (fm.liveswitch.Util.isIE6() || fm.liveswitch.Util.isIE7()) {
                    return false;
                }
                if (window.postMessage) {
                    return true;
                }
                else {
                    return false;
                }
            };
            HttpWebRequestTransfer.prototype.sendTextAsync = function (requestArgs, callback) {
                var _this = this;
                return fm.liveswitch.Util.addOnLoad(function () {
                    return _this.process(requestArgs, callback);
                });
            };
            HttpWebRequestTransfer.prototype.sendText = function (requestArgs) {
                return this.process(requestArgs, null);
            };
            HttpWebRequestTransfer.prototype.sendBinaryAsync = function (requestArgs, callback) {
                var _this = this;
                return fm.liveswitch.Util.addOnLoad(function () {
                    return _this.process(requestArgs, callback);
                });
            };
            HttpWebRequestTransfer.prototype.sendBinary = function (requestArgs) {
                return this.process(requestArgs, null);
            };
            HttpWebRequestTransfer.prototype.process = function (requestArgs, callback) {
                var hwrt = HttpWebRequestTransfer;
                var url = requestArgs.getUrl();
                if (!requestArgs._processed) {
                    url = fm.liveswitch.Util.absolutizeUrl(url);
                    requestArgs.setUrl(url);
                    requestArgs._processed = true;
                }
                var sender = requestArgs.getSender();
                var disableCors = hwrt.getDisableCors() || (sender ? sender.getDisableCors() : false);
                var disablePostMessage = hwrt.getDisablePostMessage() || (sender ? sender.getDisablePostMessage() : false);
                var disableJsonp = hwrt.getDisableJsonp() || (sender ? sender.getDisableJsonp() : false);
                var forceJsonp = hwrt.getForceJsonp() || (sender ? sender.getForceJsonp() : false);
                var fn = fm.liveswitch.Xhr.send;
                var cors = false;
                var pm = false;
                if (fm.liveswitch.Util.isXD(url)) {
                    if (!disableCors && hwrt.canCors() && !hwrt._corsFailCache[url]) {
                        cors = true;
                    }
                    else if (!disablePostMessage && hwrt.canPostMessage() && !hwrt._pmFailCache[url]) {
                        pm = true;
                        fn = fm.liveswitch.PostMessage.send;
                    }
                    else {
                        fn = fm.liveswitch.Jsonp.send;
                    }
                    if (disableJsonp && fn === fm.liveswitch.Jsonp.send) {
                        var responseArgs = new fm.liveswitch.HttpResponseArgs(requestArgs);
                        responseArgs.setException(new fm.liveswitch.Exception('Could not send HTTP request. All transports failed.'));
                        if (callback) {
                            callback(responseArgs);
                        }
                        return responseArgs;
                    }
                }
                if (forceJsonp) {
                    fn = fm.liveswitch.Jsonp.send;
                }
                return this.sendInternal(fn, cors, pm, requestArgs, callback);
            };
            HttpWebRequestTransfer.prototype.sendInternal = function (fn, cors, pm, requestArgs, callback) {
                var _this = this;
                var responseArgs = new fm.liveswitch.HttpResponseArgs(requestArgs);
                responseArgs.setException(new fm.liveswitch.Exception('Environment does not support synchronous requests.'));
                var url = requestArgs.getUrl();
                var frameUrl = requestArgs.getDynamicProperties()['frameUrl'];
                if (frameUrl && !requestArgs._processedFrame) {
                    frameUrl = fm.liveswitch.Util.absolutizeUrl(frameUrl);
                    requestArgs.getDynamicProperties()['frameUrl'] = frameUrl;
                    requestArgs._processedFrame = true;
                }
                frameUrl = frameUrl || url;
                var method = 'GET';
                switch (requestArgs.getMethod()) {
                    case fm.liveswitch.HttpMethod.Head:
                        method = 'HEAD';
                        break;
                    case fm.liveswitch.HttpMethod.Post:
                        method = 'POST';
                        break;
                    case fm.liveswitch.HttpMethod.Put:
                        method = 'PUT';
                        break;
                    case fm.liveswitch.HttpMethod.Patch:
                        method = 'PATCH';
                        break;
                    case fm.liveswitch.HttpMethod.Delete:
                        method = 'DELETE';
                }
                var options = {
                    sync: (callback ? false : true),
                    url: url,
                    frameUrl: frameUrl,
                    method: method,
                    content: requestArgs.getTextContent(),
                    contentBinary: requestArgs.getBinaryContent(),
                    headers: requestArgs.getHeaders().toHash(),
                    timeout: requestArgs.getTimeout(),
                    robustResponse: true
                };
                options.onRequestCreated = function (request) {
                    var onRequestCreated = requestArgs.getOnRequestCreated();
                    if (onRequestCreated) {
                        var args = new fm.liveswitch.HttpRequestCreatedArgs();
                        args.setRequestArgs(requestArgs);
                        args.setSender(requestArgs.getSender());
                        args.setRequest(request);
                        onRequestCreated(args);
                        options.content = requestArgs.getTextContent();
                        options.contentBinary = requestArgs.getBinaryContent();
                        options.headers = requestArgs.getHeaders().toHash();
                        options.timeout = requestArgs.getTimeout();
                    }
                    return options;
                };
                options.onResponseReceived = function (response) {
                    var onResponseReceived = requestArgs.getOnResponseReceived();
                    if (onResponseReceived) {
                        var args = new fm.liveswitch.HttpResponseReceivedArgs();
                        args.setRequestArgs(requestArgs);
                        args.setSender(requestArgs.getSender());
                        args.setResponse(response);
                        onResponseReceived(args);
                    }
                };
                options.onSuccess = function (e) {
                    if (e.statusCode === 0 && cors) {
                        if (!HttpWebRequestTransfer._corsSuccessCache[url]) {
                            HttpWebRequestTransfer._corsFailCache[url] = true;
                        }
                        if (callback) {
                            _this.sendTextAsync(requestArgs, callback);
                        }
                        else {
                            responseArgs = _this.sendText(requestArgs);
                        }
                        return;
                    }
                    else if (cors) {
                        HttpWebRequestTransfer._corsSuccessCache[url] = true;
                        delete HttpWebRequestTransfer._corsFailCache[url];
                    }
                    else if (pm) {
                        HttpWebRequestTransfer._pmSuccessCache[url] = true;
                        delete HttpWebRequestTransfer._pmFailCache[url];
                    }
                    responseArgs.setException(null);
                    responseArgs.setTextContent(e.content);
                    if (e.hasOwnProperty('contentBinary')) {
                        responseArgs.setBinaryContent(e.contentBinary);
                    }
                    responseArgs.setStatusCode(e.statusCode);
                    var headers = responseArgs.getHeaders();
                    for (var headerName in e.headers) {
                        headers.set(headerName, e.headers[headerName]);
                    }
                    if (callback) {
                        callback(responseArgs);
                    }
                };
                options.onFailure = function (e) {
                    if (cors && !HttpWebRequestTransfer._corsSuccessCache[url]) {
                        HttpWebRequestTransfer._corsFailCache[url] = true;
                        if (callback) {
                            _this.sendTextAsync(requestArgs, callback);
                        }
                        else {
                            responseArgs = _this.sendText(requestArgs);
                        }
                        return;
                    }
                    else if (pm && (e.local || !HttpWebRequestTransfer._pmSuccessCache[url])) {
                        HttpWebRequestTransfer._pmFailCache[url] = true;
                        if (callback) {
                            _this.sendTextAsync(requestArgs, callback);
                        }
                        else {
                            responseArgs = _this.sendText(requestArgs);
                        }
                        return;
                    }
                    var exception = new fm.liveswitch.Exception(e.message);
                    responseArgs.setException(exception);
                    if (callback) {
                        callback(responseArgs);
                    }
                };
                fn(options);
                return responseArgs;
            };
            HttpWebRequestTransfer.prototype.shutdown = function () { };
            HttpWebRequestTransfer._corsFailCache = {};
            HttpWebRequestTransfer._corsSuccessCache = {};
            HttpWebRequestTransfer._pmFailCache = {};
            HttpWebRequestTransfer._pmSuccessCache = {};
            HttpWebRequestTransfer._disableCors = false;
            HttpWebRequestTransfer._disablePostMessage = false;
            HttpWebRequestTransfer._disableJsonp = false;
            HttpWebRequestTransfer._forceJsonp = false;
            HttpWebRequestTransfer.getPlatformCode = function () {
                return 'js';
            };
            return HttpWebRequestTransfer;
        }(fm.liveswitch.HttpTransfer));
        liveswitch.HttpWebRequestTransfer = HttpWebRequestTransfer;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var InternalConcurrentDictionary = /** @class */ (function () {
            function InternalConcurrentDictionary(hashCallback) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var hashCallback_1 = __arguments[0];
                    this.__hashFunction = hashCallback_1;
                    this.__dict = {};
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            InternalConcurrentDictionary.prototype.getTypeString = function () {
                return '[fm.liveswitch.InternalConcurrentDictionary]';
            };
            InternalConcurrentDictionary.prototype.getIsEmpty = function () {
                return this.getCount() == 0;
            };
            InternalConcurrentDictionary.prototype.getKeys = function () {
                var array = [];
                var pairs = fm.liveswitch.HashExtensions.getValues(this.__dict);
                for (var pair in pairs) {
                    array.push(pairs[pair].getItem1());
                }
                return array;
            };
            InternalConcurrentDictionary.prototype.getValues = function () {
                var array = [];
                var pairs = fm.liveswitch.HashExtensions.getValues(this.__dict);
                for (var pair in pairs) {
                    array.push(pairs[pair].getItem2());
                }
                return array;
            };
            InternalConcurrentDictionary.prototype.getCount = function () {
                return fm.liveswitch.HashExtensions.getCount(this.__dict);
            };
            InternalConcurrentDictionary.prototype.containsKey = function (key) {
                var hash = this.__hashFunction(key);
                return fm.liveswitch.HashExtensions.containsKey(this.__dict, hash);
            };
            InternalConcurrentDictionary.prototype.getOrAdd = function (key, valueFactory) {
                var hash = this.__hashFunction(key);
                var holder = new fm.liveswitch.Holder(null);
                if (fm.liveswitch.HashExtensions.tryGetValue(this.__dict, hash, holder)) {
                    return holder.getValue().getItem2();
                }
                else {
                    var pair = new fm.liveswitch.MutablePair(key, valueFactory(key));
                    fm.liveswitch.HashExtensions.add(this.__dict, hash, pair);
                    return pair.getItem2();
                }
            };
            InternalConcurrentDictionary.prototype.addOrUpdate = function (key, addValue, updateValueFactory) {
                var hash = this.__hashFunction(key);
                var holder = new fm.liveswitch.Holder(null);
                if (fm.liveswitch.HashExtensions.tryGetValue(this.__dict, hash, holder)) {
                    var pair = holder.getValue();
                    pair.setItem2(updateValueFactory(key, pair.getItem2()));
                    return pair.getItem2();
                }
                else {
                    var pair = new fm.liveswitch.MutablePair(key, addValue);
                    fm.liveswitch.HashExtensions.add(this.__dict, hash, pair);
                    return addValue;
                }
            };
            InternalConcurrentDictionary.prototype.tryAdd = function (key, value) {
                if (arguments.length == 2) {
                    var hash = this.__hashFunction(key);
                    if (fm.liveswitch.HashExtensions.containsKey(this.__dict, hash)) {
                        return false;
                    }
                    var pair = new fm.liveswitch.MutablePair(key, value);
                    fm.liveswitch.HashExtensions.add(this.__dict, hash, pair);
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            InternalConcurrentDictionary.prototype.tryGetValue = function (key, holder) {
                var hash = this.__hashFunction(key);
                var innerHolder = new fm.liveswitch.Holder(null);
                if (fm.liveswitch.HashExtensions.tryGetValue(this.__dict, hash, innerHolder)) {
                    holder.setValue(innerHolder.getValue().getItem2());
                    return true;
                }
                else {
                    return false;
                }
            };
            InternalConcurrentDictionary.prototype.tryRemove = function (key, value) {
                if (arguments.length == 2) {
                    var hash = this.__hashFunction(key);
                    var holder = new fm.liveswitch.Holder(null);
                    if (fm.liveswitch.HashExtensions.tryGetValue(this.__dict, hash, holder)) {
                        value.setValue(holder.getValue().getItem2());
                        fm.liveswitch.HashExtensions.remove(this.__dict, hash);
                        return true;
                    }
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            InternalConcurrentDictionary.prototype.tryUpdate = function (key, newValue, comparisonValue) {
                var hash = this.__hashFunction(key);
                var holder = new fm.liveswitch.Holder(null);
                if (fm.liveswitch.HashExtensions.tryGetValue(this.__dict, hash, holder)) {
                    var pair = holder.getValue();
                    if (pair.getItem2() === comparisonValue) {
                        pair.setItem2(newValue);
                        return true;
                    }
                }
                return false;
            };
            InternalConcurrentDictionary.prototype.clear = function () {
                fm.liveswitch.HashExtensions.clear(this.__dict);
            };
            return InternalConcurrentDictionary;
        }());
        liveswitch.InternalConcurrentDictionary = InternalConcurrentDictionary;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
         <div>
         Provides Json serialize and deserialize methods for all browsers. It will also
         turn strings with form <code>"/Date(xxxxxxxxxx-xxxx)"</code> (Microsoft date serialization format) into actual dates.
         </div>
         */
        var Json = /** @class */ (function () {
            function Json() {
            }
            Json.prototype.getTypeString = function () {
                return '[fm.liveswitch.Json]';
            };
            Json._reviver = function (key, value) {
                if (value && typeof value === 'string' && Json._dateRegex.test(value)) {
                    var ticksAndZone = value.match(Json._dateRegex)[1];
                    var delim = ticksAndZone.indexOf('-') > -1 ? '-' : '+';
                    var parts = ticksAndZone.split(delim);
                    var ticks = parseInt(parts[0], 10);
                    return new Date(ticks);
                }
                return value;
            };
            Json._buildReviver = function (reviver) {
                var _this = this;
                if (this.useMicrosoftDateFormat) {
                    if (reviver != null) {
                        return function (key, value) {
                            return reviver(key, _this._reviver(key, value));
                        };
                    }
                    else {
                        return this._reviver;
                    }
                }
                else {
                    return reviver;
                }
            };
            Json.deserialize = function () {
                var args = Array.prototype.slice.call(arguments);
                if (args.length === 0 || args[0] === null || args[0] === '') {
                    return null;
                }
                args[1] = Json._buildReviver(args[1]);
                return JSON.parse.apply(Json, args);
            };
            Json.serialize = function () {
                if (Json.useMicrosoftDateFormat) {
                    var dateToJSON = Date.prototype.toJSON;
                    Date.prototype.toJSON = function (key) {
                        if (isFinite(this.valueOf())) {
                            return '/Date(' + this.getTime() + '-0000)/';
                        }
                        else {
                            return null;
                        }
                    };
                    try {
                        var j = JSON.stringify.apply(Json, arguments);
                        if (j === 'undefined') {
                            throw new fm.liveswitch.Exception('Cannot serialize undefined to JSON. Try using null instead.');
                        }
                        return j.replace(/\//g, '\\/');
                    }
                    finally {
                        Date.prototype.toJSON = dateToJSON;
                    }
                }
                return JSON.stringify.apply(Json, arguments);
            };
            Json.useMicrosoftDateFormat = true;
            Json._dateRegex = /^\/Date\((\d+[\-|\+]?\d{0,4})\)\/$/;
            return Json;
        }());
        liveswitch.Json = Json;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="HttpWebRequestTransfer.ts" />
/// <reference path="Util.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Jsonp = /** @class */ (function () {
            function Jsonp() {
            }
            Jsonp.prototype.getTypeString = function () {
                return '[fm.liveswitch.Jsonp]';
            };
            Jsonp.getNextCallback = function (options) {
                var name = 'cb' + (Jsonp._callbackCount++);
                var namespace = 'fm.liveswitch.Jsonp._cb.';
                Jsonp._cb[name] = function (response) {
                    try {
                        if (options.onResponseReceived) {
                            options.onResponseReceived(null);
                        }
                        if (options.onSuccess) {
                            if (options.robustResponse) {
                                var content = response[options.contentParameterName];
                                if (!content) {
                                    content = '';
                                }
                                else if (typeof content !== 'string') {
                                    content = fm.liveswitch.Json.serialize(content);
                                }
                                options.onSuccess({
                                    content: content,
                                    contentBinary: null,
                                    statusCode: response[options.statusCodeParameterName] || 200,
                                    headers: response[options.headersParameterName] || {}
                                });
                            }
                            else {
                                var content = response;
                                if (!content) {
                                    content = '';
                                }
                                else if (typeof content !== 'string') {
                                    content = fm.liveswitch.Json.serialize(content);
                                }
                                options.onSuccess({
                                    content: content,
                                    contentBinary: null,
                                    statusCode: 200,
                                    headers: {}
                                });
                            }
                        }
                    }
                    catch (error) {
                        throw error;
                    }
                    finally {
                        Jsonp.cleanup((options.useFrame ? 'parent.' : '') + namespace + name, options.useFrame);
                    }
                };
                return (options.useFrame ? 'parent.' : '') + namespace + name;
            };
            Jsonp.failureHandler = function (options, callbackName, message) {
                if (options.onFailure) {
                    options.onFailure({
                        message: message,
                        local: false
                    });
                }
                Jsonp.cleanup(callbackName, options.useFrame);
            };
            Jsonp.send = function (options) {
                options = fm.liveswitch.Util.extend({
                    url: '',
                    method: 'POST',
                    content: null,
                    headers: {},
                    timeout: 15000,
                    canSegmentJsonArray: false,
                    robustResponse: false,
                    callbackParameterName: 'jsonp',
                    contentParameterName: 'content',
                    methodParameterName: 'method',
                    headersParameterName: 'headers',
                    statusCodeParameterName: 'statusCode',
                    cacheBusterParameterName: '_cb',
                    onRequestCreated: null,
                    onResponseReceived: null,
                    onFailure: null,
                    onSuccess: null
                }, options || {});
                options.useFrame = true;
                var callbackName = Jsonp.getNextCallback(options);
                try {
                    if (options.useFrame) {
                        if (!Jsonp._scriptFrameDestroyer) {
                            Jsonp._scriptFrameDestroyer = window.setInterval(function () {
                                if (Jsonp._scriptFrame !== null) {
                                    Jsonp._pastScriptFrames.push(Jsonp._scriptFrame);
                                    Jsonp._scriptFrame = null;
                                    Jsonp._scriptFrameLoaded = false;
                                    if (Jsonp._pastScriptFrames.length === 2) {
                                        var pastScriptFrame = Jsonp._pastScriptFrames[0];
                                        for (var prop in pastScriptFrame) {
                                            delete pastScriptFrame[prop];
                                        }
                                        document.body.removeChild(pastScriptFrame);
                                        Jsonp._pastScriptFrames.splice(0, 1);
                                    }
                                }
                            }, 300000);
                        }
                    }
                    var container = document.getElementsByTagName('head')[0];
                    var script_1;
                    if (options.useFrame) {
                        if (!Jsonp._scriptFrame) {
                            Jsonp._scriptFrame = document.createElement('iframe');
                            Jsonp._scriptFrame.style.display = 'none';
                            Jsonp._scriptFrame.src = 'PLEASE_IGNORE_THIS_404.htm';
                            document.body.appendChild(Jsonp._scriptFrame);
                        }
                        var doc = Jsonp._scriptFrame.contentWindow.document;
                        if (!doc) {
                            throw 'Could not create script frame.';
                        }
                        script_1 = doc.createElement('script');
                    }
                    else {
                        script_1 = document.createElement('script');
                    }
                    script_1.type = 'text/javascript';
                    script_1.charset = 'utf-8';
                    script_1.id = callbackName;
                    var url = options.url;
                    url = fm.liveswitch.HttpTransfer.addQueryToUrl(url, options.methodParameterName, options.method);
                    url = fm.liveswitch.HttpTransfer.addQueryToUrl(url, options.headersParameterName, fm.liveswitch.Json.serialize(options.headers));
                    url = fm.liveswitch.HttpTransfer.addQueryToUrl(url, options.callbackParameterName, callbackName);
                    url = fm.liveswitch.HttpTransfer.addQueryToUrl(url, options.cacheBusterParameterName, (new Date()).getTime().toString());
                    url = fm.liveswitch.HttpTransfer.addQueryToUrl(url, options.contentParameterName, options.content);
                    if (url.length > Jsonp.maxUrlLength) {
                        alert('URL length ' + url.length + ' exceeds maximum for JSON-P (' + Jsonp.maxUrlLength + ').');
                    }
                    script_1.src = url;
                    if (options.onRequestCreated) {
                        options.onRequestCreated(null);
                    }
                    window.setTimeout(function () {
                        if (Jsonp.callbackExists(callbackName)) {
                            Jsonp.failureHandler(options, callbackName, 'JSON-P request timed out.');
                        }
                    }, options.timeout);
                    if (options.useFrame) {
                        if (!Jsonp._scriptFrameLoaded) {
                            fm.liveswitch.Util.observe(Jsonp._scriptFrame, 'load', function () {
                                window.setTimeout(function () {
                                    try {
                                        var container_1 = Jsonp._scriptFrame.contentWindow.document.body;
                                        container_1.appendChild(script_1);
                                    }
                                    catch (error) {
                                        Jsonp.failureHandler(options, callbackName, 'JSON-P request failed. Could not access script frame.');
                                    }
                                }, 10);
                                Jsonp._scriptFrameLoaded = true;
                            });
                        }
                        else {
                            try {
                                var container_2 = Jsonp._scriptFrame.contentWindow.document.body;
                                container_2.appendChild(script_1);
                            }
                            catch (error) {
                                Jsonp.failureHandler(options, callbackName, 'JSON-P request failed. Could not access script frame.');
                            }
                        }
                    }
                    else {
                        container.appendChild(script_1);
                    }
                }
                catch (error) {
                    Jsonp.failureHandler(options, callbackName, 'JSON-P request failed. ' + (error.message || error.error || error.description || error));
                }
            };
            Jsonp.cleanup = function (callbackName, useFrame) {
                var parts = callbackName.split('.');
                var name = parts[parts.length - 1];
                Jsonp._cb[name] = null;
                delete Jsonp._cb[name];
                try {
                    var script = void 0;
                    if (useFrame) {
                        var scriptFrames = Jsonp._pastScriptFrames.concat([]);
                        if (Jsonp._scriptFrame !== null) {
                            scriptFrames.push(Jsonp._scriptFrame);
                        }
                        var doc = void 0;
                        for (var i = scriptFrames.length - 1; i >= 0; i--) {
                            doc = scriptFrames[i].contentWindow.document;
                            if (doc) {
                                script = doc.getElementById(callbackName);
                            }
                            if (script) {
                                break;
                            }
                        }
                        if (script) {
                            doc.body.removeChild(script);
                        }
                    }
                    else {
                        script = document.getElementById(callbackName);
                        if (script) {
                            document.getElementsByTagName('head')[0].removeChild(script);
                        }
                    }
                }
                catch (error) {
                    fm.liveswitch.Log.error('Could not remove script element.', error);
                }
            };
            Jsonp.callbackExists = function (callbackName) {
                var parts = callbackName.split('.');
                var name = parts[parts.length - 1];
                return fm.liveswitch.HashExtensions.containsKey(Jsonp._cb, name);
            };
            ;
            Jsonp.maxUrlLength = 2048;
            Jsonp._scriptFrame = null;
            Jsonp._scriptFrameLoaded = false;
            Jsonp._callbackCount = 0;
            Jsonp._cb = {};
            Jsonp._pastScriptFrames = [];
            Jsonp._scriptFrameDestroyer = 0;
            return Jsonp;
        }());
        liveswitch.Jsonp = Jsonp;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A message authentication code (MAC) context.
        */
        var MacContextBase = /** @class */ (function () {
            /**
            Initializes a new instance of the [[fm.liveswitch.macContextBase]] class.
            @param type The type.
            */
            function MacContextBase(type) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var type_2 = __arguments[0];
                    //super();
                    this.setType(type_2);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            MacContextBase.prototype.getTypeString = function () {
                return '[fm.liveswitch.MacContextBase]';
            };
            /**
            Computes the message authentication code (MAC) for a given type.
            @param type The type.
            @param key The key.
            @param input The input.
            */
            MacContextBase.compute = function (type, key, input) {
                if (arguments.length == 3) {
                    var context = new fm.liveswitch.MacContext(type, key);
                    var buffer = context.compute(input);
                    context.destroy();
                    return buffer;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Computes the message authentication code (MAC).
            @param input The input.
            */
            MacContextBase.prototype.compute = function (input) {
                if (arguments.length == 1) {
                    return this.doCompute(input);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Destroys this instance.
            */
            MacContextBase.prototype.destroy = function () {
                if (arguments.length == 0) {
                    this.doDestroy();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the type.
            */
            MacContextBase.prototype.getType = function () {
                if (arguments.length == 0) {
                    return this._type;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MacContextBase.prototype.setType = function (value) {
                if (arguments.length == 1) {
                    this._type = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MacContextBase;
        }());
        liveswitch.MacContextBase = MacContextBase;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="MacContextBase.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var MacContext = /** @class */ (function (_super) {
            __extends(MacContext, _super);
            function MacContext(type, key) {
                var _this = _super.call(this, type) || this;
                _this._key = key;
                return _this;
            }
            MacContext.prototype.getTypeString = function () {
                return '[fm.liveswitch.MacContext]';
            };
            MacContext.prototype.doCompute = function (input) {
                if (this.getType() == fm.liveswitch.MacType.HmacMd5) {
                    return null;
                }
                else if (this.getType() == fm.liveswitch.MacType.HmacSha1) {
                    return null;
                }
                else if (this.getType() == fm.liveswitch.MacType.HmacSha256) {
                    var hmac = new fm.liveswitch.HmacSha256(this._key.getData());
                    hmac.update(input.getData());
                    var digest = hmac.digest();
                    hmac.clean();
                    return fm.liveswitch.DataBuffer.wrap(digest);
                }
                throw new fm.liveswitch.Exception('Unknown MAC type.');
            };
            MacContext.prototype.doDestroy = function () { };
            return MacContext;
        }(fm.liveswitch.MacContextBase));
        liveswitch.MacContext = MacContext;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var ManagedStopwatch = /** @class */ (function () {
            function ManagedStopwatch() {
                this.startTime = 0;
                this.stopTime = 0;
            }
            ManagedStopwatch.prototype.getTypeString = function () {
                return '[fm.liveswitch.ManagedStopwatch]';
            };
            ManagedStopwatch.dispatch = function (action) {
                window.setTimeout(function () {
                    action();
                }, 1);
            };
            ManagedStopwatch.getTimestamp = function () {
                return (new Date().getTime()) * fm.liveswitch.Constants.getTicksPerMillisecond();
            };
            ManagedStopwatch.prototype.getElapsedTicks = function () {
                return this.getElapsedMilliseconds() * fm.liveswitch.Constants.getTicksPerMillisecond();
            };
            ManagedStopwatch.prototype.getElapsedMilliseconds = function () {
                if (this.startTime == 0) {
                    return 0;
                }
                if (this.stopTime == 0) {
                    return ((new Date().getTime()) - this.startTime);
                }
                return (this.stopTime - this.startTime);
            };
            ManagedStopwatch.prototype.start = function () {
                this.startTime = (new Date().getTime());
                this.stopTime = 0;
            };
            ManagedStopwatch.prototype.stop = function () {
                this.stopTime = (new Date().getTime());
            };
            ManagedStopwatch.prototype.restart = function () {
                this.start();
            };
            return ManagedStopwatch;
        }());
        liveswitch.ManagedStopwatch = ManagedStopwatch;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var ManagedThread = /** @class */ (function () {
            function ManagedThread() {
            }
            ManagedThread.prototype.getTypeString = function () {
                return '[fm.liveswitch.ManagedThread]';
            };
            ManagedThread.getCurrentThreadId = function () {
                return 1;
            };
            ManagedThread.dispatch = function (action) {
                window.setTimeout(function () {
                    action();
                }, 1);
            };
            return ManagedThread;
        }());
        liveswitch.ManagedThread = ManagedThread;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var MathAssistant = /** @class */ (function () {
            function MathAssistant() {
            }
            MathAssistant.prototype.getTypeString = function () {
                return '[fm.liveswitch.MathAssistant]';
            };
            MathAssistant.getPi = function () {
                return Math.PI;
            };
            MathAssistant.getE = function () {
                return Math.E;
            };
            MathAssistant.abs = function (val) {
                return Math.abs(val);
            };
            MathAssistant.acos = function (val) {
                return Math.acos(val);
            };
            MathAssistant.asin = function (val) {
                return Math.asin(val);
            };
            MathAssistant.atan = function (val) {
                return Math.atan(val);
            };
            MathAssistant.atan2 = function (y, x) {
                return Math.atan2(y, x);
            };
            MathAssistant.ceil = function (val) {
                return Math.ceil(val);
            };
            MathAssistant.cos = function (val) {
                return Math.cos(val);
            };
            MathAssistant.cosh = function (val) {
                return (Math.exp(val) + Math.exp(-val)) / 2;
            };
            MathAssistant.exp = function (val) {
                return Math.exp(val);
            };
            MathAssistant.floor = function (val) {
                return Math.floor(val);
            };
            MathAssistant.log = function (val) {
                return Math.log(val);
            };
            MathAssistant.log10 = function (val) {
                return Math.log(val) / Math.LN10;
            };
            MathAssistant.max = function (val1, val2) {
                return Math.max(val1, val2);
            };
            MathAssistant.min = function (val1, val2) {
                return Math.min(val1, val2);
            };
            MathAssistant.pow = function (x, y) {
                return Math.pow(x, y);
            };
            MathAssistant.round = function (value) {
                return Math.round(value);
            };
            MathAssistant.sin = function (val) {
                return Math.sin(val);
            };
            MathAssistant.sinh = function (val) {
                return (Math.exp(val) - Math.exp(-val)) / 2;
            };
            MathAssistant.sqrt = function (val) {
                return Math.sqrt(val);
            };
            MathAssistant.tan = function (val) {
                return Math.tan(val);
            };
            MathAssistant.tanh = function (val) {
                return (Math.exp(val) - Math.exp(-val)) / (Math.exp(val) + Math.exp(-val));
            };
            return MathAssistant;
        }());
        liveswitch.MathAssistant = MathAssistant;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var NameValueCollection = /** @class */ (function () {
            function NameValueCollection(value) {
                this._value = {};
                if (typeof value !== 'undefined') {
                    for (var n in value) {
                        this._value[n] = value[n];
                    }
                }
            }
            NameValueCollection.prototype.getTypeString = function () {
                return '[fm.liveswitch.NameValueCollection]';
            };
            NameValueCollection.prototype.source = function () {
                return this._value;
            };
            NameValueCollection.prototype.get = function (name) {
                for (var n in this._value) {
                    if (n.toLowerCase() === name.toLowerCase()) {
                        return this._value[n];
                    }
                }
                return null;
            };
            NameValueCollection.prototype.set = function (name, value) {
                for (var n in this._value) {
                    if (n.toLowerCase() === name.toLowerCase()) {
                        this._value[n] = value;
                        return;
                    }
                }
                this._value[name] = value;
            };
            NameValueCollection.prototype.getCount = function () {
                var i = 0;
                for (var n in this._value) {
                    i++;
                }
                return i;
            };
            NameValueCollection.prototype.toHash = function () {
                return this._value;
            };
            NameValueCollection.prototype.getKeys = function () {
                return this.getAllKeys();
            };
            NameValueCollection.prototype.getAllKeys = function () {
                var keys = [];
                for (var k in this._value) {
                    keys.push(k);
                }
                return keys;
            };
            return NameValueCollection;
        }());
        liveswitch.NameValueCollection = NameValueCollection;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var NumberExtensions = /** @class */ (function () {
            function NumberExtensions() {
            }
            NumberExtensions.prototype.getTypeString = function () {
                return '[fm.liveswitch.NumberExtensions]';
            };
            NumberExtensions.toString = function (value, format) {
                return value.toString();
            };
            return NumberExtensions;
        }());
        liveswitch.NumberExtensions = NumberExtensions;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var ObjectExtensions = /** @class */ (function () {
            function ObjectExtensions() {
            }
            ObjectExtensions.prototype.getTypeString = function () {
                return '[fm.liveswitch.ObjectExtensions]';
            };
            ObjectExtensions.getType = function (obj) {
                return new fm.liveswitch.Type(obj.getTypeString());
            };
            ObjectExtensions.getHashCode = function (obj) {
                if (typeof obj.getHashCode === 'function') {
                    return obj.getHashCode();
                }
                else if (fm.liveswitch.Util.isString(obj)) {
                    return fm.liveswitch.StringExtensions.getHashCode(obj);
                }
                else {
                    return fm.liveswitch.StringExtensions.getHashCode(JSON.stringify(obj));
                }
            };
            return ObjectExtensions;
        }());
        liveswitch.ObjectExtensions = ObjectExtensions;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var ParseAssistant = /** @class */ (function () {
            function ParseAssistant() {
            }
            ParseAssistant.prototype.getTypeString = function () {
                return '[fm.liveswitch.ParseAssistant]';
            };
            ParseAssistant.parseByteValue = function (s) {
                return parseInt(s);
            };
            ParseAssistant.parseShortValue = function (s) {
                return parseInt(s);
            };
            ParseAssistant.parseIntegerValue = function (s) {
                return parseInt(s);
            };
            ParseAssistant.parseLongValue = function (s) {
                return parseInt(s);
            };
            ParseAssistant.parseFloatValue = function (s) {
                return parseFloat(s);
            };
            ParseAssistant.parseDoubleValue = function (s) {
                return parseFloat(s);
            };
            ParseAssistant.parseDecimalValue = function (s) {
                return parseFloat(s);
            };
            ParseAssistant.parseBooleanValue = function (s) {
                if (s.toLowerCase() === "true" || s.toLowerCase() === "y" || s === "1") {
                    return true;
                }
                else {
                    return false;
                }
            };
            ParseAssistant.parseGuidValue = function (s) {
                return new fm.liveswitch.Guid(s);
            };
            ParseAssistant.tryParseByteValue = function (s, h) {
                if (isNaN(parseInt(s))) {
                    return false;
                }
                h.setValue(parseInt(s));
                return true;
            };
            ParseAssistant.tryParseShortValue = function (s, h) {
                if (isNaN(parseInt(s))) {
                    return false;
                }
                h.setValue(parseInt(s));
                return true;
            };
            ParseAssistant.tryParseIntegerValue = function (s, h) {
                if (isNaN(parseInt(s))) {
                    return false;
                }
                h.setValue(parseInt(s));
                return true;
            };
            ParseAssistant.tryParseLongValue = function (s, h) {
                if (isNaN(parseInt(s))) {
                    return false;
                }
                h.setValue(parseInt(s));
                return true;
            };
            ParseAssistant.tryParseFloatValue = function (s, h) {
                if (isNaN(parseFloat(s))) {
                    return false;
                }
                h.setValue(parseFloat(s));
                return true;
            };
            ParseAssistant.tryParseDoubleValue = function (s, h) {
                if (isNaN(parseFloat(s))) {
                    return false;
                }
                h.setValue(parseFloat(s));
                return true;
            };
            ParseAssistant.tryParseDecimalValue = function (s, h) {
                if (isNaN(parseFloat(s))) {
                    return false;
                }
                h.setValue(parseFloat(s));
                return true;
            };
            ParseAssistant.tryParseBooleanValue = function (s, h) {
                if (s.toLowerCase() === "true" || s.toLowerCase() === "y" || s === "1") {
                    h.setValue(true);
                }
                else {
                    h.setValue(false);
                }
                return true;
            };
            ParseAssistant.tryParseGuidValue = function (s, h) {
                if (!(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i.test(s))) {
                    return false;
                }
                h.setValue(new fm.liveswitch.Guid(s));
                return true;
            };
            return ParseAssistant;
        }());
        liveswitch.ParseAssistant = ParseAssistant;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="IPlatform.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Platform = /** @class */ (function () {
            function Platform() {
                this.littleEndianChecked = false;
                this.isLittleEndian = false;
                this.isMobile = false;
                this.useFipsAlgorithms = false;
                var check = false;
                // http://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
                (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
                    check = true; })(navigator.userAgent || navigator.vendor || window.opera);
                this.isMobile = check;
            }
            Platform.getInstance = function () {
                return Platform.instance;
            };
            Platform.prototype.getIsMobile = function () {
                return this.isMobile;
            };
            Platform.prototype.setIsMobile = function (isMobile) {
                this.isMobile = isMobile;
            };
            Platform.prototype.getIsLittleEndian = function () {
                // http://stackoverflow.com/questions/7869752/javascript-typed-arrays-and-endianness
                if (!this.littleEndianChecked) {
                    this.littleEndianChecked = true;
                    var a = new ArrayBuffer(4);
                    var b = new Uint8Array(a);
                    var c = new Uint32Array(a);
                    b[0] = 0xa1;
                    b[1] = 0xb2;
                    b[2] = 0xc3;
                    b[3] = 0xd4;
                    this.isLittleEndian = (c[0] == 0xd4c3b2a1);
                }
                return this.isLittleEndian;
            };
            Platform.prototype.getOperatingSystem = function () {
                //TODO
                /*if (navigator.oscpu) {
                }
                if (navigator.platform) {
                }
                if (navigator.appVersion) {
                }*/
                return fm.liveswitch.OperatingSystem.Unknown;
            };
            Platform.prototype.getOperatingSystemVersion = function () {
                return null; //TODO
            };
            Platform.prototype.getArchitecture = function () {
                //TODO
                /*if (navigator.cpuClass) {
                }*/
                return fm.liveswitch.Architecture.Unknown;
            };
            Platform.prototype.getSourceLanguage = function () {
                return fm.liveswitch.SourceLanguage.TypeScript;
            };
            Platform.prototype.getCoreCount = function () {
                return navigator.hardwareConcurrency || 0;
            };
            Platform.prototype.getPhysicalMemory = function () {
                return (navigator.deviceMemory || 0) * 1024 * 1024 * 1024;
            };
            Platform.prototype.getMachineName = function () {
                return navigator.userAgent;
            };
            Platform.prototype.getDirectorySeparator = function () {
                return '/';
            };
            Platform.prototype.getProcessId = function () {
                return 1;
            };
            Platform.prototype.getUseFipsAlgorithms = function () {
                return false;
            };
            Platform.prototype.setUseFipsAlgorithms = function (useFipsAlgorithms) { };
            Platform.prototype.getCryptoLibrary = function () {
                return fm.liveswitch.CryptoLibrary.Default;
            };
            Platform.prototype.setCryptoLibrary = function (cryptoLibrary) { };
            Platform.instance = new Platform();
            return Platform;
        }());
        liveswitch.Platform = Platform;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="HttpWebRequestTransfer.ts" />
/// <reference path="Util.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Xhr = /** @class */ (function () {
            function Xhr() {
            }
            Xhr.prototype.getTypeString = function () {
                return '[fm.liveswitch.Xhr]';
            };
            Xhr.setDisableBinary = function (disableBinary) {
                Xhr._disableBinary = disableBinary;
            };
            Xhr.getDisableBinary = function () {
                if (typeof Uint8Array === 'undefined') {
                    return true;
                }
                return Xhr._disableBinary;
            };
            Xhr.setDefaultWithCredentials = function (defaultWithCredentials) {
                Xhr._defaultWithCredentials = defaultWithCredentials;
            };
            Xhr.getDefaultWithCredentials = function () {
                return Xhr._defaultWithCredentials;
            };
            Xhr.failureHandler = function (options, message) {
                if (options.onFailure) {
                    return options.onFailure({
                        message: message,
                        local: false
                    });
                }
            };
            Xhr.successHandler = function (options, x) {
                if (options.onSuccess) {
                    var headers = {};
                    var headerString = x.getAllResponseHeaders();
                    if (headerString) {
                        for (var _i = 0, _a = headerString.split(/\r?\n/); _i < _a.length; _i++) {
                            var line = _a[_i];
                            var parts = line.split(':');
                            if (parts.length !== 2) {
                                continue;
                            }
                            var name_1 = parts[0].replace(/\s+$/, '');
                            var value = parts[1].replace(/^\s+/, '');
                            headers[name_1] = value;
                        }
                    }
                    var content = null;
                    var contentBinary = null;
                    var receivedBinary = false;
                    if (!Xhr.getDisableBinary()) {
                        try {
                            if (x.responseType === 'arraybuffer' && x.response) {
                                contentBinary = new Uint8Array(x.response);
                                if (headers['Content-Type'] !== 'application/octet-stream') {
                                    content = fm.liveswitch.Encoding.getUtf8().getString(contentBinary);
                                }
                                receivedBinary = true;
                            }
                        }
                        catch (error) {
                            Xhr.setDisableBinary(true);
                        }
                    }
                    if (!receivedBinary) {
                        content = x.responseText;
                    }
                    return options.onSuccess({
                        content: content,
                        contentBinary: contentBinary,
                        statusCode: x.status,
                        headers: headers
                    });
                }
            };
            Xhr.handler = function (options, x) {
                if (x._aborting) {
                    return Xhr.failureHandler(options, 'XHR request timed out.');
                }
                else {
                    if (options.onResponseReceived) {
                        options.onResponseReceived(x);
                    }
                    return Xhr.successHandler(options, x);
                }
            };
            Xhr.send = function (options) {
                options = fm.liveswitch.Util.extend({
                    sync: false,
                    url: '',
                    method: 'POST',
                    content: null,
                    contentBinary: null,
                    headers: {},
                    timeout: 15000,
                    abortOnUnload: false,
                    cacheBusterParameterName: '_cb',
                    onRequestCreated: null,
                    onResponseReceived: null,
                    onFailure: null,
                    onSuccess: null
                }, options || {});
                try {
                    var x_1;
                    if (window.XMLHttpRequest) {
                        x_1 = new XMLHttpRequest();
                    }
                    else {
                        try {
                            x_1 = new ActiveXObject('MSXML2.XMLHTTP.3.0');
                        }
                        catch (undefined) { }
                        if (!x_1) {
                            try {
                                x_1 = new ActiveXObject('Microsoft.XMLHTTP');
                            }
                            catch (undefined) { }
                        }
                    }
                    if (!x_1) {
                        return false;
                    }
                    var url = options.url;
                    if (options.method === 'GET') {
                        url = url + (url.indexOf('?') === -1 ? '?' : '&') + options.cacheBusterParameterName + '=' + (new Date()).getTime();
                    }
                    x_1.open(options.method, url, !options.sync);
                    if (Xhr.getDisableBinary()) {
                        x_1.setRequestHeader('X-FM-DisableBinary', 'true');
                    }
                    if ('withCredentials' in x_1) {
                        x_1.withCredentials = Xhr._defaultWithCredentials;
                    }
                    if (!Xhr.getDisableBinary() && !options.sync) {
                        try {
                            x_1.responseType = 'arraybuffer';
                        }
                        catch (error) {
                            Xhr.setDisableBinary(true);
                        }
                    }
                    if (options.onRequestCreated) {
                        options = options.onRequestCreated(x_1);
                    }
                    var useDefaultContentType = true;
                    for (var name_2 in options.headers) {
                        var value = options.headers[name_2];
                        if (name_2.toLowerCase() !== 'referer' && name_2.toLowerCase() !== 'origin') {
                            if (name_2.toLowerCase() === 'content-type') {
                                useDefaultContentType = false;
                            }
                            x_1.setRequestHeader(name_2, value);
                        }
                    }
                    var c_1;
                    if (options.abortOnUnload) {
                        c_1 = ++Xhr._count;
                        Xhr._current[c_1] = x_1;
                    }
                    var xhrTimeout_1;
                    if (!options.sync) {
                        x_1.onreadystatechange = function () {
                            if (x_1.readyState > 3 && !x_1._abortingOnUnload) {
                                clearTimeout(xhrTimeout_1);
                                try {
                                    x_1.onreadystatechange = null;
                                }
                                catch (error) {
                                    x_1.onreadystatechange = function () { };
                                }
                                if (x_1.status > 0) {
                                    Xhr.handler(options, x_1);
                                }
                                else {
                                    Xhr.failureHandler(options, 'Invalid XHR response.');
                                }
                                if (options.abortOnUnload) {
                                    return delete Xhr._current[c_1];
                                }
                            }
                        };
                    }
                    var sentBinary = false;
                    if (!Xhr.getDisableBinary() && options.contentBinary) {
                        try {
                            x_1.send(options.contentBinary.buffer);
                            sentBinary = true;
                        }
                        catch (error) {
                            try {
                                x_1.send(options.contentBinary);
                                sentBinary = true;
                            }
                            catch (error) {
                                Xhr.setDisableBinary(true);
                            }
                        }
                    }
                    if (!sentBinary) {
                        if (options.content) {
                            if (useDefaultContentType) {
                                x_1.setRequestHeader('Content-Type', 'application/json');
                            }
                            x_1.send(options.content);
                        }
                        else {
                            x_1.send();
                        }
                    }
                    xhrTimeout_1 = window.setTimeout(function () {
                        try {
                            x_1._aborting = true;
                            x_1.abort();
                        }
                        catch (undefined) { }
                    }, options.timeout);
                    if (options.sync) {
                        Xhr.handler(options, x_1);
                        if (options.abortOnUnload) {
                            delete Xhr._current[c_1];
                        }
                    }
                    return true;
                }
                catch (error) {
                    Xhr.failureHandler(options, 'XHR request failed. ' + (error.message || error.error || error.description || error));
                    return false;
                }
            };
            Xhr.initialize = function () {
                if (!Xhr.__initialized) {
                    fm.liveswitch.Util.observe(window, 'unload', function () {
                        for (var c in Xhr._current) {
                            var x = Xhr._current[c];
                            try {
                                x._abortingOnUnload = true;
                                x.abort();
                            }
                            catch (undefined) { }
                        }
                    });
                }
                Xhr.__initialized = true;
            };
            Xhr._count = 0;
            Xhr._current = {};
            Xhr._disableBinary = false;
            Xhr._defaultWithCredentials = true;
            Xhr.__initialized = false;
            return Xhr;
        }());
        liveswitch.Xhr = Xhr;
        Xhr.initialize(); // static constructor
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Xhr.ts" />
/// <reference path="Util.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var PostMessage = /** @class */ (function () {
            function PostMessage() {
            }
            PostMessage.prototype.getTypeString = function () {
                return '[fm.liveswitch.PostMessage]';
            };
            PostMessage.getOrigin = function (url) {
                return /\w+:\/\/[^\/]+/.exec(url)[0];
            };
            ;
            PostMessage.createFrame = function (options, callback) {
                var record = PostMessage._cache[options.frameUrl];
                if (!record) {
                    var frame_1 = document.createElement('iframe');
                    frame_1.style.display = 'none';
                    document.body.appendChild(frame_1);
                    var callbacks_1 = [callback];
                    frame_1.loading = true;
                    PostMessage._cache[options.frameUrl] = record = {
                        frame: frame_1,
                        callbacks: callbacks_1
                    };
                    var loadTimeout_1 = window.setTimeout(function () {
                        frame_1.loading = false;
                        frame_1.loaded = false;
                        frame_1.timedOut = true;
                        while (callbacks_1.length > 0) {
                            callbacks_1.shift()(null, 'Frame load timed out.');
                        }
                    }, options.timeout);
                    fm.liveswitch.Util.observe(frame_1, 'load', function () {
                        if (frame_1.timedOut) {
                            return;
                        }
                        clearTimeout(loadTimeout_1);
                        var receivePong = function (e) {
                            if (e.source === frame_1.contentWindow && e.data === 'pong') {
                                if (frame_1.timedOut) {
                                    return;
                                }
                                clearTimeout(pongTimeout);
                                frame_1.loading = false;
                                frame_1.loaded = true;
                                frame_1.timedOut = false;
                                PostMessage.listen(options, frame_1);
                                while (callbacks_1.length > 0) {
                                    callbacks_1.shift()(frame_1, null);
                                }
                                return fm.liveswitch.Util.unobserve(window, 'message', receivePong);
                            }
                        };
                        var pongTimeout = window.setTimeout(function () {
                            frame_1.loading = false;
                            frame_1.loaded = false;
                            frame_1.timedOut = true;
                            while (callbacks_1.length > 0) {
                                callbacks_1.shift()(null, 'Frame pong timed out.');
                            }
                            if (receivePong) {
                                return fm.liveswitch.Util.unobserve(window, 'message', receivePong);
                            }
                        }, 500);
                        fm.liveswitch.Util.observe(window, 'message', receivePong);
                        frame_1.contentWindow.postMessage('ping', PostMessage.getOrigin(options.url));
                    });
                    frame_1.src = fm.liveswitch.HttpTransfer.addQueryToUrl(options.frameUrl, 'type', 'pmf');
                }
                else {
                    if (record.frame.loading) {
                        record.callbacks.push(callback);
                    }
                    else {
                        window.setTimeout(function () {
                            if (record.frame.loaded) {
                                callback(record.frame, null);
                            }
                            else {
                                callback(null, 'Frame not loaded.');
                            }
                        }, 1);
                    }
                }
            };
            PostMessage.send = function (options) {
                options = fm.liveswitch.Util.extend({
                    url: '',
                    onFailure: null,
                    onSuccess: null,
                    onRequestCreated: null,
                    onResponseReceived: null
                }, options || {});
                options.contentBinary = null;
                PostMessage.createFrame(options, function (frame, error) {
                    if (frame) {
                        options.id = ++PostMessage._optionsCounter;
                        PostMessage._optionsCache[options.id] = options;
                        return frame.contentWindow.postMessage(fm.liveswitch.Json.serialize(options), PostMessage.getOrigin(options.url));
                    }
                    else {
                        if (options.onFailure) {
                            var message = 'Could not initialize postMessage frame.';
                            if (error) {
                                message += ' ' + error;
                            }
                            return options.onFailure({
                                message: message,
                                local: true
                            });
                        }
                    }
                });
            };
            PostMessage.listen = function (options, frame) {
                fm.liveswitch.Util.observe(window, 'message', function (e) {
                    if (e.source === frame.contentWindow) {
                        try {
                            e = fm.liveswitch.Json.deserialize(e.data);
                        }
                        catch (error) {
                            return;
                        }
                        if (!e.id) {
                            return;
                        }
                        options = PostMessage._optionsCache[e.id];
                        if (!options) {
                            return;
                        }
                        if (e.type === 1 || e.type === 2) {
                            delete PostMessage._optionsCache[e.id];
                        }
                        if (e.type === 1) {
                            if (options.onFailure) {
                                options.onFailure(e);
                            }
                        }
                        else if (e.type === 2) {
                            if (options.onSuccess) {
                                options.onSuccess(e);
                            }
                        }
                        else if (e.type === 3) {
                            if (options.onRequestCreated) {
                                options.onRequestCreated(null);
                            }
                        }
                        else if (e.type === 4) {
                            if (options.onResponseReceived) {
                                options.onResponseReceived(null);
                            }
                        }
                    }
                });
            };
            PostMessage._cache = {};
            PostMessage._optionsCounter = 0;
            PostMessage._optionsCache = {};
            return PostMessage;
        }());
        liveswitch.PostMessage = PostMessage;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Future.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Promise base properties/methods.
        */
        var PromiseBase = /** @class */ (function (_super) {
            __extends(PromiseBase, _super);
            /**
            Initializes a new instance of the [[fm.liveswitch.promiseBase]] class.
            */
            function PromiseBase() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.__id = fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "");
                    _this.__stateLock = new Object();
                    _this.__pendingPromisesToResolve = new Array();
                    _this.__pendingPromisesToReject = new Array();
                    _this.__pendingResolves = new Array();
                    _this.__pendingRejects = new Array();
                    _super.prototype.setState.call(_this, fm.liveswitch.FutureState.Pending);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            PromiseBase.prototype.getTypeString = function () {
                return '[fm.liveswitch.PromiseBase]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Returns a promise that resolves when all passed in promises resolve.
            @param promises The promises to check.
            */
            PromiseBase.all = function (promises) {
                if (arguments.length == 1) {
                    var promise = new fm.liveswitch.Promise();
                    if (((fm.liveswitch.Global.equals(promises, null)) || (fm.liveswitch.Global.equals(promises.length, 0)))) {
                        promise.resolve(null);
                        return promise;
                    }
                    var counter = new fm.liveswitch.AtomicInteger(promises.length);
                    promise.doAll(promises, counter);
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a promise and rejects it immediately.
            @param ex The exception.
            */
            PromiseBase.rejectNow = function (ex) {
                if (arguments.length == 1) {
                    var promise = new fm.liveswitch.Promise();
                    promise.reject(ex);
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            PromiseBase.resolveNow = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.PromiseBase.resolveNow(null);
                }
                else if (arguments.length == 1) {
                    var result = arguments[0];
                    var promise = new fm.liveswitch.Promise();
                    promise.resolve(result);
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a promise and resolves it using the result from a callback function, or rejects it if an exception is thrown.
            @param callback The callback function.
            */
            PromiseBase.wrapPromise = function (callback) {
                if (arguments.length == 1) {
                    try {
                        if ((fm.liveswitch.Global.equals(callback, null))) {
                            throw new fm.liveswitch.Exception("callback cannot be null.");
                        }
                        return callback();
                    }
                    catch (exception) {
                        return fm.liveswitch.PromiseBase.rejectNow(exception);
                    }
                    finally {
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PromiseBase.prototype.addReject = function (promise, reject) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(this.__pendingPromisesToReject, null))) {
                        this.__pendingPromisesToReject = new Array();
                    }
                    if ((fm.liveswitch.Global.equals(this.__pendingRejects, null))) {
                        this.__pendingRejects = new Array();
                    }
                    fm.liveswitch.ArrayExtensions.add(this.__pendingPromisesToReject, promise);
                    fm.liveswitch.ArrayExtensions.add(this.__pendingRejects, reject);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PromiseBase.prototype.addResolve = function (promise, resolve) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(this.__pendingPromisesToResolve, null))) {
                        this.__pendingPromisesToResolve = new Array();
                    }
                    if ((fm.liveswitch.Global.equals(this.__pendingResolves, null))) {
                        this.__pendingResolves = new Array();
                    }
                    fm.liveswitch.ArrayExtensions.add(this.__pendingPromisesToResolve, promise);
                    fm.liveswitch.ArrayExtensions.add(this.__pendingResolves, resolve);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Casts the result and resolves the promise. Will throw an exception if the cast fails.
            @param result The result.
            */
            PromiseBase.prototype.castAndResolve = function (result) {
                if (arguments.length == 1) {
                    return this.resolve(result);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Internal DoAll.
            */
            PromiseBase.prototype.doAll = function (promises, counter) {
                var _this = this;
                if (arguments.length == 2) {
                    var resolveAction = null;
                    var rejectAction = null;
                    for (var _i = 0, promises_1 = promises; _i < promises_1.length; _i++) {
                        var future = promises_1[_i];
                        if ((fm.liveswitch.Global.equals(resolveAction, null))) {
                            resolveAction = function (result) {
                                if ((fm.liveswitch.Global.equals(counter.decrement(), 0))) {
                                    _this.resolve(null);
                                }
                            };
                        }
                        if ((fm.liveswitch.Global.equals(rejectAction, null))) {
                            rejectAction = function (ex) {
                                _this.reject(ex);
                            };
                        }
                        future.then(resolveAction, rejectAction);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PromiseBase.prototype.doRejectAsync = function (promise, exception) {
                var _this = this;
                if (arguments.length == 2) {
                    fm.liveswitch.ManagedThread.dispatch(function () {
                        if (_this.reject(exception)) {
                            promise.resolve(null);
                        }
                        else {
                            promise.reject(new fm.liveswitch.Exception("Promise was already fulfilled."));
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PromiseBase.prototype.doResolveAsync = function (promise, result) {
                var _this = this;
                if (arguments.length == 2) {
                    fm.liveswitch.ManagedThread.dispatch(function () {
                        if (_this.resolve(result)) {
                            promise.resolve(null);
                        }
                        else {
                            promise.reject(new fm.liveswitch.Exception("Promise was already fulfilled."));
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the identifier of this promise.
            */
            PromiseBase.prototype.getId = function () {
                if (arguments.length == 0) {
                    return this.__id;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes the specified promise.
            @param promise The promise.
            @param resolve The resolve.
            @param reject The reject.
            */
            PromiseBase.prototype.process = function (promise, resolve, reject) {
                if (arguments.length == 3) {
                    if ((fm.liveswitch.Global.equals(_super.prototype.getState.call(this), fm.liveswitch.FutureState.Pending))) {
                        this.addResolve(promise, resolve);
                        this.addReject(promise, reject);
                        return;
                    }
                    if ((fm.liveswitch.Global.equals(_super.prototype.getState.call(this), fm.liveswitch.FutureState.Resolved))) {
                        this.raiseResolve(resolve, _super.prototype.getResult.call(this), promise);
                    }
                    else {
                        if ((fm.liveswitch.Global.equals(_super.prototype.getState.call(this), fm.liveswitch.FutureState.Rejected))) {
                            this.raiseReject(reject, _super.prototype.getException.call(this), promise);
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PromiseBase.prototype.raiseReject = function (callback, exception, promise) {
                if (arguments.length == 3) {
                    try {
                        callback(exception);
                    }
                    catch (exception2) {
                        fm.liveswitch.Log.error("Could not reject promise. Promise rejection callback threw an unhandled exception.", exception2);
                        promise.reject(exception2);
                    }
                    finally {
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PromiseBase.prototype.raiseRejects = function (exception) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(this.__pendingRejects, null))) {
                        for (var i = 0; (i < fm.liveswitch.ArrayExtensions.getCount(this.__pendingRejects)); i++) {
                            this.raiseReject(this.__pendingRejects[i], exception, this.__pendingPromisesToReject[i]);
                        }
                    }
                    this.reset();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PromiseBase.prototype.raiseResolve = function (callback, result, promise) {
                if (arguments.length == 3) {
                    try {
                        callback(result);
                    }
                    catch (exception) {
                        fm.liveswitch.Log.error("Could not resolve promise. Promise resolution callback threw an unhandled exception.", exception);
                        promise.reject(exception);
                    }
                    finally {
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PromiseBase.prototype.raiseResolves = function (result) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(this.__pendingResolves, null))) {
                        for (var i = 0; (i < fm.liveswitch.ArrayExtensions.getCount(this.__pendingResolves)); i++) {
                            this.raiseResolve(this.__pendingResolves[i], result, this.__pendingPromisesToResolve[i]);
                        }
                    }
                    this.reset();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Rejects the promise.
            @param exception The exception.
            */
            PromiseBase.prototype.reject = function (exception) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(_super.prototype.getState.call(this), fm.liveswitch.FutureState.Pending))) {
                        return false;
                    }
                    _super.prototype.setException.call(this, exception);
                    _super.prototype.setState.call(this, fm.liveswitch.FutureState.Rejected);
                    this.raiseRejects(exception);
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Rejects the promise asynchronously.
            @param exception The exception.
            */
            PromiseBase.prototype.rejectAsync = function (exception) {
                if (arguments.length == 1) {
                    var promise = new fm.liveswitch.Promise();
                    this.doRejectAsync(promise, exception);
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PromiseBase.prototype.reset = function () {
                if (arguments.length == 0) {
                    fm.liveswitch.ArrayExtensions.clear(this.__pendingPromisesToResolve);
                    fm.liveswitch.ArrayExtensions.clear(this.__pendingPromisesToReject);
                    fm.liveswitch.ArrayExtensions.clear(this.__pendingResolves);
                    fm.liveswitch.ArrayExtensions.clear(this.__pendingRejects);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Resolves the promise.
            @param result The result.
            */
            PromiseBase.prototype.resolve = function (result) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(_super.prototype.getState.call(this), fm.liveswitch.FutureState.Pending))) {
                        return false;
                    }
                    _super.prototype.setResult.call(this, result);
                    _super.prototype.setState.call(this, fm.liveswitch.FutureState.Resolved);
                    this.raiseResolves(result);
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Resolves the promise asynchronously.
            @param result The result.
            */
            PromiseBase.prototype.resolveAsync = function (result) {
                if (arguments.length == 1) {
                    var promise = new fm.liveswitch.Promise();
                    this.doResolveAsync(promise, result);
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return PromiseBase;
        }(fm.liveswitch.Future));
        liveswitch.PromiseBase = PromiseBase;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="PromiseBase.ts" />
/// <reference path="Util.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Promise = /** @class */ (function (_super) {
            __extends(Promise, _super);
            function Promise() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Promise.prototype.getTypeString = function () {
                return '[fm.liveswitch.Promise]' + ',' + _super.prototype.getTypeString.call(this);
            };
            Promise.prototype.then = function (resolve, reject) {
                var promise = new fm.liveswitch.Promise();
                this.process(promise, function (result) {
                    if (resolve == null) {
                        promise.resolve(result);
                    }
                    else {
                        var resolveResult = resolve(result);
                        if (fm.liveswitch.Util.isObjectType(resolveResult, '[fm.liveswitch.Future]')) {
                            resolveResult.then(function (chainedResult) {
                                promise.resolve(chainedResult);
                            }, function (exception) {
                                promise.reject(exception);
                            });
                        }
                        else {
                            promise.resolve(resolveResult);
                        }
                    }
                }, function (exception) {
                    if (reject != null) {
                        reject(exception);
                    }
                    promise.reject(exception);
                });
                return promise;
            };
            Promise.prototype.fail = function (reject) {
                var promise = new fm.liveswitch.Promise();
                this.process(promise, function (result) {
                    promise.resolve(result);
                }, function (exception) {
                    if (reject != null) {
                        reject(exception);
                    }
                    promise.reject(exception);
                });
                return promise;
            };
            Promise.wrap = function (callbackActionOrFunction) {
                var promise = new fm.liveswitch.Promise();
                try {
                    if (callbackActionOrFunction == null) {
                        promise.resolve(null);
                    }
                    else {
                        var result = callbackActionOrFunction();
                        if (result) {
                            promise.resolve(result);
                        }
                        else {
                            promise.resolve(null);
                        }
                    }
                }
                catch (ex) {
                    promise.reject(ex);
                }
                return promise;
            };
            Promise.wrapAsync = function (callbackActionOrFunction) {
                var promise = new fm.liveswitch.Promise();
                fm.liveswitch.ManagedThread.dispatch(function () {
                    try {
                        if (callbackActionOrFunction == null) {
                            promise.resolve(null);
                        }
                        else {
                            var result = callbackActionOrFunction();
                            if (result) {
                                promise.resolve(result);
                            }
                            else {
                                promise.resolve(null);
                            }
                        }
                    }
                    catch (ex) {
                        promise.reject(ex);
                    }
                });
                return promise;
            };
            return Promise;
        }(fm.liveswitch.PromiseBase));
        liveswitch.Promise = Promise;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Randomizer = /** @class */ (function () {
            function Randomizer() {
            }
            Randomizer.prototype.getTypeString = function () {
                return '[fm.liveswitch.Randomizer]';
            };
            Randomizer.prototype.next = function () {
                if (arguments.length == 0) {
                    return this.next(0, 2147483647);
                }
                else if (arguments.length == 1) {
                    var maxValue = arguments[0];
                    return this.next(0, maxValue);
                }
                else if (arguments.length == 2) {
                    var minValue = arguments[0];
                    var maxValue = arguments[1];
                    return Math.floor(Math.random() * (maxValue - minValue)) + minValue;
                }
            };
            Randomizer.prototype.nextDouble = function () {
                return Math.random();
            };
            Randomizer.prototype.nextBytes = function (buffer) {
                for (var i = 0; i < buffer.length; i++) {
                    buffer[i] = this.next(256);
                }
            };
            Randomizer.prototype.randomString = function (size) {
                var s = '';
                for (var i = 0; i < size; i++) {
                    s += Randomizer._randomCharset.charAt(this.next(Randomizer._randomCharset.length));
                }
                return s;
            };
            Randomizer._randomCharset = 'abcdefghijklmnopqrstuvwxyz0123456789';
            return Randomizer;
        }());
        liveswitch.Randomizer = Randomizer;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Regex = /** @class */ (function () {
            function Regex(pattern) {
                this.pattern = pattern;
            }
            Regex.prototype.getTypeString = function () {
                return '[fm.liveswitch.Regex]';
            };
            Regex.isMatch = function (input, pattern) {
                return new RegExp(pattern).test(input);
            };
            Regex.prototype.isMatch = function (input) {
                return new RegExp(this.pattern).test(input);
            };
            return Regex;
        }());
        liveswitch.Regex = Regex;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        // SHA-256 (+ HMAC and PBKDF2) for JavaScript.
        //
        // Written in 2014-2016 by Dmitry Chestnykh.
        // Public domain, no warranty.
        var digestLength = 32;
        var blockSize = 64;
        // SHA-256 constants
        var K = new Uint32Array([
            0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b,
            0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01,
            0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7,
            0xc19bf174, 0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
            0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152,
            0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147,
            0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc,
            0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
            0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819,
            0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08,
            0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f,
            0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
            0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
        ]);
        function hashBlocks(w, v, p, pos, len) {
            var a, b, c, d, e, f, g, h, u, i, j, t1, t2;
            while (len >= 64) {
                a = v[0];
                b = v[1];
                c = v[2];
                d = v[3];
                e = v[4];
                f = v[5];
                g = v[6];
                h = v[7];
                for (i = 0; i < 16; i++) {
                    j = pos + i * 4;
                    w[i] = (((p[j] & 0xff) << 24) | ((p[j + 1] & 0xff) << 16) |
                        ((p[j + 2] & 0xff) << 8) | (p[j + 3] & 0xff));
                }
                for (i = 16; i < 64; i++) {
                    u = w[i - 2];
                    t1 = (u >>> 17 | u << (32 - 17)) ^ (u >>> 19 | u << (32 - 19)) ^ (u >>> 10);
                    u = w[i - 15];
                    t2 = (u >>> 7 | u << (32 - 7)) ^ (u >>> 18 | u << (32 - 18)) ^ (u >>> 3);
                    w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0);
                }
                for (i = 0; i < 64; i++) {
                    t1 = (((((e >>> 6 | e << (32 - 6)) ^ (e >>> 11 | e << (32 - 11)) ^
                        (e >>> 25 | e << (32 - 25))) + ((e & f) ^ (~e & g))) | 0) +
                        ((h + ((K[i] + w[i]) | 0)) | 0)) | 0;
                    t2 = (((a >>> 2 | a << (32 - 2)) ^ (a >>> 13 | a << (32 - 13)) ^
                        (a >>> 22 | a << (32 - 22))) + ((a & b) ^ (a & c) ^ (b & c))) | 0;
                    h = g;
                    g = f;
                    f = e;
                    e = (d + t1) | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = (t1 + t2) | 0;
                }
                v[0] += a;
                v[1] += b;
                v[2] += c;
                v[3] += d;
                v[4] += e;
                v[5] += f;
                v[6] += g;
                v[7] += h;
                pos += 64;
                len -= 64;
            }
            return pos;
        }
        // Hash implements SHA256 hash algorithm.
        var Sha256 = /** @class */ (function () {
            function Sha256() {
                this.digestLength = digestLength;
                this.blockSize = blockSize;
                // Note: Int32Array is used instead of Uint32Array for performance reasons.
                this.state = new Int32Array(8); // hash state
                this.temp = new Int32Array(64); // temporary state
                this.buffer = new Uint8Array(128); // buffer for data to hash
                this.bufferLength = 0; // number of bytes in buffer
                this.bytesHashed = 0; // number of total bytes hashed
                this.finished = false; // indicates whether the hash was finalized
                this.reset();
            }
            // Resets hash state making it possible
            // to re-use this instance to hash other data.
            Sha256.prototype.reset = function () {
                this.state[0] = 0x6a09e667;
                this.state[1] = 0xbb67ae85;
                this.state[2] = 0x3c6ef372;
                this.state[3] = 0xa54ff53a;
                this.state[4] = 0x510e527f;
                this.state[5] = 0x9b05688c;
                this.state[6] = 0x1f83d9ab;
                this.state[7] = 0x5be0cd19;
                this.bufferLength = 0;
                this.bytesHashed = 0;
                this.finished = false;
                return this;
            };
            // Cleans internal buffers and re-initializes hash state.
            Sha256.prototype.clean = function () {
                for (var i = 0; i < this.buffer.length; i++) {
                    this.buffer[i] = 0;
                }
                for (var i = 0; i < this.temp.length; i++) {
                    this.temp[i] = 0;
                }
                this.reset();
            };
            // Updates hash state with the given data.
            //
            // Optionally, length of the data can be specified to hash
            // fewer bytes than data.length.
            //
            // Throws error when trying to update already finalized hash:
            // instance must be reset to use it again.
            Sha256.prototype.update = function (data, dataLength) {
                if (dataLength === void 0) { dataLength = data.length; }
                if (this.finished) {
                    throw new fm.liveswitch.Exception("SHA256: can't update because hash was finished.");
                }
                var dataPos = 0;
                this.bytesHashed += dataLength;
                if (this.bufferLength > 0) {
                    while (this.bufferLength < 64 && dataLength > 0) {
                        this.buffer[this.bufferLength++] = data[dataPos++];
                        dataLength--;
                    }
                    if (this.bufferLength === 64) {
                        hashBlocks(this.temp, this.state, this.buffer, 0, 64);
                        this.bufferLength = 0;
                    }
                }
                if (dataLength >= 64) {
                    dataPos = hashBlocks(this.temp, this.state, data, dataPos, dataLength);
                    dataLength %= 64;
                }
                while (dataLength > 0) {
                    this.buffer[this.bufferLength++] = data[dataPos++];
                    dataLength--;
                }
                return this;
            };
            // Finalizes hash state and puts hash into out.
            //
            // If hash was already finalized, puts the same value.
            Sha256.prototype.finish = function (out) {
                if (!this.finished) {
                    var bytesHashed = this.bytesHashed;
                    var left = this.bufferLength;
                    var bitLenHi = (bytesHashed / 0x20000000) | 0;
                    var bitLenLo = bytesHashed << 3;
                    var padLength = (bytesHashed % 64 < 56) ? 64 : 128;
                    this.buffer[left] = 0x80;
                    for (var i = left + 1; i < padLength - 8; i++) {
                        this.buffer[i] = 0;
                    }
                    this.buffer[padLength - 8] = (bitLenHi >>> 24) & 0xff;
                    this.buffer[padLength - 7] = (bitLenHi >>> 16) & 0xff;
                    this.buffer[padLength - 6] = (bitLenHi >>> 8) & 0xff;
                    this.buffer[padLength - 5] = (bitLenHi >>> 0) & 0xff;
                    this.buffer[padLength - 4] = (bitLenLo >>> 24) & 0xff;
                    this.buffer[padLength - 3] = (bitLenLo >>> 16) & 0xff;
                    this.buffer[padLength - 2] = (bitLenLo >>> 8) & 0xff;
                    this.buffer[padLength - 1] = (bitLenLo >>> 0) & 0xff;
                    hashBlocks(this.temp, this.state, this.buffer, 0, padLength);
                    this.finished = true;
                }
                for (var i = 0; i < 8; i++) {
                    out[i * 4 + 0] = (this.state[i] >>> 24) & 0xff;
                    out[i * 4 + 1] = (this.state[i] >>> 16) & 0xff;
                    out[i * 4 + 2] = (this.state[i] >>> 8) & 0xff;
                    out[i * 4 + 3] = (this.state[i] >>> 0) & 0xff;
                }
                return this;
            };
            // Returns the final hash digest.
            Sha256.prototype.digest = function () {
                var out = new Uint8Array(this.digestLength);
                this.finish(out);
                return out;
            };
            // Internal function for use in HMAC for optimization.
            Sha256.prototype._saveState = function (out) {
                for (var i = 0; i < this.state.length; i++) {
                    out[i] = this.state[i];
                }
            };
            // Internal function for use in HMAC for optimization.
            Sha256.prototype._restoreState = function (from, bytesHashed) {
                for (var i = 0; i < this.state.length; i++) {
                    this.state[i] = from[i];
                }
                this.bytesHashed = bytesHashed;
                this.finished = false;
                this.bufferLength = 0;
            };
            return Sha256;
        }());
        liveswitch.Sha256 = Sha256;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="HttpTransfer.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        (function () {
            fm.liveswitch.HttpTransfer.addQueryToUrl = function (url, key, value) {
                if (typeof key === 'undefined' || fm.liveswitch.StringExtensions.isNullOrEmpty(key)) {
                    return url;
                }
                if (typeof value === 'undefined' || value === null) {
                    value = '';
                }
                value = encodeURIComponent(value);
                return fm.liveswitch.StringExtensions.concat([url, (fm.liveswitch.StringExtensions.indexOf(url, "?", fm.liveswitch.StringComparison.OrdinalIgnoreCase) === -1 ? "?" : "&"), key, "=", value]);
            };
        })();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Stack = /** @class */ (function () {
            function Stack(depth) {
                this._list = [];
                if (typeof depth !== 'undefined') {
                    this._depth = depth;
                }
                else {
                    this._depth = 0;
                }
            }
            Stack.prototype.getTypeString = function () {
                return '[fm.liveswitch.Stack]';
            };
            Stack.prototype.push = function (o) {
                if (this._depth !== 0 && this.getCount() === this._depth) {
                    throw new fm.liveswitch.Exception('Depth of stack would be exceeded by pushing value.');
                }
                this._list.push(o);
            };
            Stack.prototype.pop = function () {
                return this._list.pop();
            };
            Stack.prototype.peek = function () {
                if (this._list.length === 0) {
                    return null;
                }
                return this._list[this._list.length - 1];
            };
            Stack.prototype.getCount = function () {
                return this._list.length;
            };
            return Stack;
        }());
        liveswitch.Stack = Stack;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var StringBuilder = /** @class */ (function () {
            function StringBuilder(value) {
                if (typeof value === 'undefined') {
                    this._value = '';
                }
                else {
                    this._value = value;
                }
            }
            StringBuilder.prototype.getTypeString = function () {
                return '[fm.liveswitch.StringBuilder]';
            };
            StringBuilder.prototype.append = function (s, startIndex, count) {
                if (typeof startIndex === 'undefined' && typeof count === 'undefined') {
                    this._value = this._value + s;
                }
                else if (typeof count === 'undefined') {
                    this._value = this._value + s.substring(startIndex);
                }
                else {
                    this._value = this._value + s.substring(startIndex, startIndex + count);
                }
                return this;
            };
            StringBuilder.prototype.toString = function () {
                return this._value;
            };
            StringBuilder.prototype.getLength = function () {
                return this._value.length;
            };
            StringBuilder.prototype.remove = function (startIndex, length) {
                this._value = this._value.substring(0, startIndex) + this._value.substring(startIndex + length);
                return this;
            };
            return StringBuilder;
        }());
        liveswitch.StringBuilder = StringBuilder;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var StringComparison;
        (function (StringComparison) {
            StringComparison[StringComparison["CurrentCulture"] = 0] = "CurrentCulture";
            StringComparison[StringComparison["CurrentCultureIgnoreCase"] = 1] = "CurrentCultureIgnoreCase";
            StringComparison[StringComparison["InvariantCulture"] = 2] = "InvariantCulture";
            StringComparison[StringComparison["InvariantCultureIgnoreCase"] = 3] = "InvariantCultureIgnoreCase";
            StringComparison[StringComparison["Ordinal"] = 4] = "Ordinal";
            StringComparison[StringComparison["OrdinalIgnoreCase"] = 5] = "OrdinalIgnoreCase";
        })(StringComparison = liveswitch.StringComparison || (liveswitch.StringComparison = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Util.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var StringExtensions = /** @class */ (function () {
            function StringExtensions() {
            }
            StringExtensions.prototype.getTypeString = function () {
                return '[fm.liveswitch.StringExtensions]';
            };
            StringExtensions.nullCoalesce = function (value1, value2) {
                if (value1 || value1 == '') {
                    return value1;
                }
                return value2;
            };
            StringExtensions.toString = function (s) {
                return s;
            };
            StringExtensions.trim = function (s) {
                if (s === null || s === undefined) {
                    throw new fm.liveswitch.Exception("trim() received a null argument.");
                }
                return s.replace(/^\s+|\s+$/g, '');
            };
            StringExtensions.trimEnd = function (s, chars) {
                if (s === null || s === undefined) {
                    throw new fm.liveswitch.Exception("trimEnd() received a null argument.");
                }
                var expression = '[';
                for (var _i = 0, chars_1 = chars; _i < chars_1.length; _i++) {
                    var c = chars_1[_i];
                    expression += String.fromCharCode(c);
                }
                expression += ']*$';
                return s.replace(new RegExp(expression, 'g'), '');
            };
            StringExtensions.trimStart = function (s, chars) {
                if (s === null || s === undefined) {
                    throw new fm.liveswitch.Exception("trimStart() received a null argument.");
                }
                var expression = '^[';
                for (var _i = 0, chars_2 = chars; _i < chars_2.length; _i++) {
                    var c = chars_2[_i];
                    expression += String.fromCharCode(c);
                }
                expression += ']*';
                return s.replace(new RegExp(expression, 'g'), '');
            };
            StringExtensions.replace = function (s, search, replace) {
                if (s === null || s === undefined || search === null || search === undefined) {
                    throw new fm.liveswitch.Exception("replace() received a null argument.");
                }
                return s.replace(new RegExp(search.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1"), 'g'), replace);
            };
            StringExtensions.concat = function () {
                var strings = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    strings[_i] = arguments[_i];
                }
                if (strings.length == 1 && fm.liveswitch.Util.isArray(strings[0])) {
                    strings = strings[0];
                }
                var s = '';
                for (var _a = 0, strings_1 = strings; _a < strings_1.length; _a++) {
                    var str = strings_1[_a];
                    s += str;
                }
                return s;
            };
            StringExtensions.contains = function (str, s) {
                if (str === null || str === undefined) {
                    throw new fm.liveswitch.Exception("contains() received a null argument.");
                }
                return (str.indexOf(s) > -1);
            };
            StringExtensions.join = function (separator) {
                var array = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    array[_i - 1] = arguments[_i];
                }
                if (array.length == 1 && fm.liveswitch.Util.isArray(array[0])) {
                    array = array[0];
                }
                var sb = new fm.liveswitch.StringBuilder();
                for (var i = 0; i < array.length; i++) {
                    if (i > 0) {
                        sb.append(separator);
                    }
                    sb.append(array[i]);
                }
                return sb.toString();
            };
            StringExtensions.split = function (s, chars) {
                if (s === null || s === undefined || chars === null || chars === undefined) {
                    throw new fm.liveswitch.Exception("split() received a null argument.");
                }
                var splits = [];
                var start = 0;
                for (var i = 0; i < s.length; i++) {
                    for (var _i = 0, chars_3 = chars; _i < chars_3.length; _i++) {
                        var c = chars_3[_i];
                        if (c == s.charCodeAt(i)) {
                            splits.push(s.substring(start, i));
                            start = i + 1;
                        }
                    }
                }
                splits.push(s.substring(start, s.length));
                return splits;
            };
            StringExtensions.isNullOrEmpty = function (s) {
                var noe = typeof s === 'undefined' || s === null || s === '';
                if (!noe) {
                    if (typeof s !== 'string' && !(s instanceof String)) {
                        throw new fm.liveswitch.Exception('Object is not a string.');
                    }
                }
                return noe;
            };
            StringExtensions.isEqual = function (str, s, stringComparison) {
                if (typeof stringComparison !== 'undefined') {
                    if (stringComparison === fm.liveswitch.StringComparison.CurrentCultureIgnoreCase || stringComparison === fm.liveswitch.StringComparison.InvariantCultureIgnoreCase || stringComparison === fm.liveswitch.StringComparison.OrdinalIgnoreCase) {
                        return str.toLowerCase() === s.toLowerCase();
                    }
                }
                return str === s;
            };
            StringExtensions.indexOf = function (str, s, stringComparison) {
                if (s === null || s === undefined) {
                    throw new fm.liveswitch.Exception("indexOf() received a null argument.");
                }
                if (typeof stringComparison !== 'undefined') {
                    if (stringComparison === fm.liveswitch.StringComparison.CurrentCultureIgnoreCase || stringComparison === fm.liveswitch.StringComparison.InvariantCultureIgnoreCase || stringComparison === fm.liveswitch.StringComparison.OrdinalIgnoreCase) {
                        return str.toLowerCase().indexOf(s.toLowerCase());
                    }
                }
                return str.indexOf(s);
            };
            StringExtensions.lastIndexOf = function (str, s, stringComparison) {
                if (s === null || s === undefined) {
                    throw new fm.liveswitch.Exception("lastIndexOf() received a null argument.");
                }
                if (typeof stringComparison !== 'undefined') {
                    if (stringComparison === fm.liveswitch.StringComparison.CurrentCultureIgnoreCase || stringComparison === fm.liveswitch.StringComparison.InvariantCultureIgnoreCase || stringComparison === fm.liveswitch.StringComparison.OrdinalIgnoreCase) {
                        return str.toLowerCase().lastIndexOf(s.toLowerCase());
                    }
                }
                return str.lastIndexOf(s);
            };
            StringExtensions.startsWith = function (str, s, stringComparison) {
                if (s === null || s === undefined) {
                    throw new fm.liveswitch.Exception("startsWith() received a null argument.");
                }
                if (typeof stringComparison !== 'undefined') {
                    if (stringComparison === fm.liveswitch.StringComparison.CurrentCultureIgnoreCase || stringComparison === fm.liveswitch.StringComparison.InvariantCultureIgnoreCase || stringComparison === fm.liveswitch.StringComparison.OrdinalIgnoreCase) {
                        return str.toLowerCase().indexOf(s.toLowerCase()) === 0;
                    }
                }
                return str.indexOf(s) === 0;
            };
            StringExtensions.endsWith = function (str, s, stringComparison) {
                if (s === null || s === undefined) {
                    throw new fm.liveswitch.Exception("endsWith() received a null argument.");
                }
                if (typeof stringComparison !== 'undefined') {
                    if (stringComparison === fm.liveswitch.StringComparison.CurrentCultureIgnoreCase || stringComparison === fm.liveswitch.StringComparison.InvariantCultureIgnoreCase || stringComparison === fm.liveswitch.StringComparison.OrdinalIgnoreCase) {
                        return str.toLowerCase().indexOf(s.toLowerCase(), str.length - s.length) !== -1;
                    }
                }
                return str.indexOf(s, str.length - s.length) !== -1;
            };
            StringExtensions.compareTo = function (s1, s2) {
                if (s1 === null || s1 === undefined || s2 === null || s2 === undefined) {
                    throw new fm.liveswitch.Exception("compareTo() received one or more null arguments.");
                }
                if (s1.toString() < s2.toString()) {
                    return -1;
                }
                if (s1.toString() > s2.toString()) {
                    return 1;
                }
                return 0;
            };
            StringExtensions.format = function (format) {
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                if (format === null || format === undefined) {
                    throw new fm.liveswitch.Exception("format() received a null argument.");
                }
                if (args.length == 1 && fm.liveswitch.Util.isArray(args[0])) {
                    args = args[0];
                }
                var formatter = function (match, number) {
                    if (args[number] != null) {
                        return args[number];
                    }
                    return match;
                };
                return format.replace(/{(\d+)}/g, formatter);
            };
            StringExtensions.toLower = function (str) {
                if (str === null || str === undefined) {
                    throw new fm.liveswitch.Exception("toLower() received a null argument.");
                }
                return str.toLowerCase();
            };
            StringExtensions.toUpper = function (str) {
                if (str === null || str === undefined) {
                    throw new fm.liveswitch.Exception("toUpper() received a null argument.");
                }
                return str.toUpperCase();
            };
            StringExtensions.getLength = function (str) {
                if (str === null || str === undefined) {
                    throw new fm.liveswitch.Exception("getLength() received a null argument.");
                }
                return str.length;
            };
            StringExtensions.getChars = function (str) {
                if (str === null || str === undefined) {
                    throw new fm.liveswitch.Exception("getChars() received a null argument.");
                }
                var chars = [];
                for (var i = 0; i < str.length; i++) {
                    chars.push(str[i]);
                }
                return chars;
            };
            StringExtensions.substring = function (str, startIndex, length) {
                if (str === null || str === undefined) {
                    throw new fm.liveswitch.Exception("substring() received a null argument.");
                }
                return str.substring(startIndex, startIndex + length);
            };
            StringExtensions.getHashCode = function (str) {
                if (str === null || str === undefined) {
                    throw new fm.liveswitch.Exception("getHashCode() received a null argument.");
                }
                var hash = 0, i = 0, chr = 0;
                if (str.length == 0) {
                    return hash;
                }
                for (i = 0; i < str.length; i++) {
                    chr = str.charCodeAt(i);
                    hash = ((hash << 5) - hash) + chr;
                    hash |= 0; // Convert to 32bit integer
                }
                return hash;
            };
            StringExtensions.empty = '';
            return StringExtensions;
        }());
        liveswitch.StringExtensions = StringExtensions;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="ITimeoutTimer.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var TimeoutTimer = /** @class */ (function () {
            function TimeoutTimer(callback, state) {
                this._timer = 0;
                this._callback = callback;
                this._state = state;
                this._currentTimeout = 0;
            }
            TimeoutTimer.prototype.getTypeString = function () {
                return '[fm.liveswitch.TimeoutTimer]';
            };
            TimeoutTimer.prototype.start = function (timeout) {
                var _this = this;
                if (this._timer) {
                    throw new fm.liveswitch.Exception('Timer is currently active.');
                }
                this._currentTimeout = timeout;
                timeout = Math.max(0, timeout);
                this._timer = setTimeout(function () {
                    if (_this._currentTimeout >= 0 && _this.stop() && _this._callback) {
                        _this._callback(_this._state);
                    }
                }, timeout);
            };
            TimeoutTimer.prototype.stop = function () {
                if (!this._timer) {
                    return false;
                }
                clearTimeout(this._timer);
                this._timer = null;
                return true;
            };
            return TimeoutTimer;
        }());
        liveswitch.TimeoutTimer = TimeoutTimer;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var TimeSpan = /** @class */ (function () {
            function TimeSpan() {
                if (arguments.length == 1) {
                    var ticks = arguments[0];
                    var milliseconds = ticks / 10000;
                    this._milliseconds = (milliseconds % 1000);
                    milliseconds -= this._milliseconds;
                    var seconds = milliseconds / 1000;
                    this._seconds = (seconds % 60);
                    seconds -= this._seconds;
                    var minutes = seconds / 60;
                    this._minutes = (minutes % 60);
                    minutes -= this._minutes;
                    var hours = minutes / 60;
                    this._hours = hours;
                }
                else {
                    var hours = arguments[0];
                    var minutes = arguments[0];
                    var seconds = arguments[0];
                    this._hours = hours;
                    this._minutes = minutes;
                    this._seconds = seconds;
                }
            }
            TimeSpan.prototype.getTotalSeconds = function () {
                return ((this._hours * 3600) + (this._minutes * 60) + this._seconds);
            };
            TimeSpan.prototype.getTotalMilliseconds = function () {
                return ((this._hours * 3600000) + (this._minutes * 60000) + (this._seconds * 1000) + this._milliseconds);
            };
            return TimeSpan;
        }());
        liveswitch.TimeSpan = TimeSpan;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Type = /** @class */ (function () {
            function Type(typeString) {
                this._typeString = typeString;
            }
            Type.prototype.getTypeString = function () {
                return '[fm.liveswitch.Type]';
            };
            Type.prototype.getFullName = function () {
                return this._typeString.substr(1, this._typeString.indexOf(']') - 1);
            };
            Type.prototype.getBaseType = function () {
                var typeStrings = fm.liveswitch.StringExtensions.split(this._typeString, [','.charCodeAt(0)]);
                if (typeStrings.length == 1) {
                    return new Type('[Object]');
                }
                return new Type(typeStrings[1]);
            };
            return Type;
        }());
        liveswitch.Type = Type;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Uri = /** @class */ (function () {
            function Uri(uriString) {
                this._uriString = uriString;
            }
            Uri.prototype.getTypeString = function () {
                return '[fm.liveswitch.Uri]';
            };
            Uri.prototype.toString = function () {
                return this._uriString;
            };
            Uri.escapeDataString = function (s) {
                return encodeURIComponent(s);
            };
            return Uri;
        }());
        liveswitch.Uri = Uri;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        WebSocket base properties/methods.
        */
        var WebSocketBase = /** @class */ (function () {
            function WebSocketBase() {
                fm.liveswitch.WebSocketBase.fmliveswitchWebSocketBaseInitialize();
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            WebSocketBase.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebSocketBase]';
            };
            /**
            Raises the close complete callback.
            @param closeArgs The close arguments.
            @param statusCode The status code.
            @param reason The reason.
            */
            WebSocketBase.prototype.raiseCloseComplete = function (closeArgs, statusCode, reason) {
                if (arguments.length == 3) {
                    if (((!fm.liveswitch.Global.equals(closeArgs, null)) && (!fm.liveswitch.Global.equals(closeArgs.getOnComplete(), null)))) {
                        var p = new fm.liveswitch.WebSocketCloseCompleteArgs();
                        p.setCloseArgs(closeArgs);
                        p.setStatusCode(statusCode);
                        p.setReason(reason);
                        closeArgs.getOnComplete()(p);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Raises the open failure callback.
            @param openArgs The open arguments.
            @param statusCode The status code.
            @param exception The exception.
            */
            WebSocketBase.prototype.raiseOpenFailure = function (openArgs, statusCode, exception) {
                if (arguments.length == 3) {
                    if (((!fm.liveswitch.Global.equals(openArgs, null)) && (!fm.liveswitch.Global.equals(openArgs.getOnFailure(), null)))) {
                        var p = new fm.liveswitch.WebSocketOpenFailureArgs();
                        p.setOpenArgs(openArgs);
                        p.setStatusCode(statusCode);
                        p.setException(exception);
                        openArgs.getOnFailure()(p);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Raises the open success callback.
            @param openArgs The open arguments.
            */
            WebSocketBase.prototype.raiseOpenSuccess = function (openArgs) {
                if (arguments.length == 1) {
                    if (((!fm.liveswitch.Global.equals(openArgs, null)) && (!fm.liveswitch.Global.equals(openArgs.getOnSuccess(), null)))) {
                        var p = new fm.liveswitch.WebSocketOpenSuccessArgs();
                        p.setOpenArgs(openArgs);
                        openArgs.getOnSuccess()(p);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Raises the receive callback.
            @param openArgs The open arguments.
            @param textMessage The text message.
            @param binaryMessage The binary message.
            */
            WebSocketBase.prototype.raiseReceive = function (openArgs, textMessage, binaryMessage) {
                if (arguments.length == 3) {
                    if (((!fm.liveswitch.Global.equals(openArgs, null)) && (!fm.liveswitch.Global.equals(openArgs.getOnReceive(), null)))) {
                        var p = new fm.liveswitch.WebSocketReceiveArgs();
                        p.setOpenArgs(openArgs);
                        p.setTextMessage(textMessage);
                        p.setBinaryMessage(binaryMessage);
                        openArgs.getOnReceive()(p);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Raises the stream failure callback.
            @param openArgs The open arguments.
            @param statusCode The status code.
            @param exception The exception.
            */
            WebSocketBase.prototype.raiseStreamFailure = function (openArgs, statusCode, exception) {
                if (arguments.length == 3) {
                    fm.liveswitch.WebSocketBase.fm_liveswitch_WebSocketBase___log.error("Websocket Stream failure.", exception);
                    if (((!fm.liveswitch.Global.equals(openArgs, null)) && (!fm.liveswitch.Global.equals(openArgs.getOnStreamFailure(), null)))) {
                        var p = new fm.liveswitch.WebSocketStreamFailureArgs();
                        p.setOpenArgs(openArgs);
                        p.setStatusCode(statusCode);
                        p.setException(exception);
                        openArgs.getOnStreamFailure()(p);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebSocketBase.fmliveswitchWebSocketBaseInitialize = function () {
                if (!fm.liveswitch.WebSocketBase.__fmliveswitchWebSocketBaseInitialized && !fm.liveswitch.WebSocketBase.__fmliveswitchWebSocketBaseInitializing) {
                    fm.liveswitch.WebSocketBase.__fmliveswitchWebSocketBaseInitializing = true;
                    fm.liveswitch.WebSocketBase.fm_liveswitch_WebSocketBase___log = fm.liveswitch.Log.getLogger(new fm.liveswitch.Type('[fm.liveswitch.WebSocketBase]'));
                    fm.liveswitch.WebSocketBase.__fmliveswitchWebSocketBaseInitialized = true;
                    fm.liveswitch.WebSocketBase.__fmliveswitchWebSocketBaseInitializing = false;
                }
            };
            /** @hidden */
            WebSocketBase.__fmliveswitchWebSocketBaseInitialized = false;
            /** @hidden */
            WebSocketBase.__fmliveswitchWebSocketBaseInitializing = false;
            return WebSocketBase;
        }());
        liveswitch.WebSocketBase = WebSocketBase;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="WebSocketBase.ts" />
/// <reference path="Util.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var WebSocket = /** @class */ (function (_super) {
            __extends(WebSocket, _super);
            function WebSocket(requestUrl, protocol) {
                var _this = _super.call(this) || this;
                _this.onOpen = function (e) {
                    _this.raiseOnResponseReceived();
                    _this._opening = false;
                    _this.raiseOpenSuccess(_this._openArgs);
                };
                _this.onError = function (e) {
                    if (_this._opening) {
                        _this._opening = false;
                        if (!_this._raisedOpenFailure) {
                            _this._raisedOpenFailure = true;
                            _this.raiseOpenFailure(_this._openArgs, fm.liveswitch.WebSocketStatusCode.Abnormal, new fm.liveswitch.Exception('WebSocket error.'));
                        }
                    }
                    else if (!_this._closing) {
                        if (!_this._raisedStreamFailure) {
                            _this._raisedStreamFailure = true;
                            _this.raiseStreamFailure(_this._openArgs, fm.liveswitch.WebSocketStatusCode.Abnormal, new fm.liveswitch.Exception('WebSocket error.'));
                        }
                    }
                };
                _this.onClose = function (e) {
                    _this.processOnClose(e.code, e.reason);
                };
                _this.onMessage = function (e) {
                    if (_this._timer) {
                        window.clearTimeout(_this._timer);
                    }
                    //this.raiseOnResponseReceived();
                    _this._sendArgs = null;
                    var binaryMessage = null;
                    var textMessage = null;
                    if (!WebSocket.getDisableBinary() && e.data instanceof ArrayBuffer) {
                        binaryMessage = new Uint8Array(e.data);
                    }
                    else {
                        textMessage = e.data;
                    }
                    return _this.raiseReceive(_this._openArgs, textMessage, binaryMessage);
                };
                requestUrl = fm.liveswitch.Util.absolutizeUrl(requestUrl);
                requestUrl = requestUrl.replace('https://', 'wss://');
                requestUrl = requestUrl.replace('http://', 'ws://');
                _this._requestUrl = requestUrl;
                _this._protocol = protocol || null;
                _this._webSocket = null;
                _this._onRequestCreated = null;
                _this._onResponseReceived = null;
                _this._opening = false;
                _this._closing = false;
                _this._aborting = false;
                _this._openArgs = null;
                _this._sendArgs = null;
                _this._timer = 0;
                _this._raisedStreamFailure = false;
                _this._raisedOpenFailure = false;
                return _this;
            }
            WebSocket.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebSocket]' + ',' + _super.prototype.getTypeString.call(this);
            };
            WebSocket.getExists = function () {
                return true;
            };
            WebSocket.setDisableBinary = function (disableBinary) {
                WebSocket._disableBinary = disableBinary;
            };
            WebSocket.getDisableBinary = function () {
                if (typeof Uint8Array === 'undefined') {
                    return true;
                }
                return WebSocket._disableBinary;
            };
            WebSocket.prototype.getSecure = function () {
                return (this._requestUrl.indexOf('wss://') === 0);
            };
            WebSocket.prototype.getBufferedAmount = function () {
                if (!this._webSocket) {
                    return 0;
                }
                return this._webSocket.bufferedAmount;
            };
            WebSocket.prototype.getIsOpen = function () {
                if (!this._webSocket) {
                    return false;
                }
                return (this._webSocket.readyState === 1);
            };
            WebSocket.prototype.open = function (args) {
                var url = this._requestUrl;
                this._openArgs = args;
                this._onRequestCreated = args.getOnRequestCreated();
                this._onResponseReceived = args.getOnResponseReceived();
                this.raiseOnRequestCreated();
                var headers = args.getHeaders();
                var headersHash = {};
                if (headers) {
                    headersHash = headers.toHash();
                }
                if (WebSocket.getDisableBinary()) {
                    headersHash['X-FM-DisableBinary'] = 'true';
                }
                url = fm.liveswitch.HttpTransfer.addQueryToUrl(url, 'headers', fm.liveswitch.Json.serialize(headersHash));
                if ('WebSocket' in window) {
                    this._webSocket = (this._protocol ? new window.WebSocket(url, this._protocol) : new window.WebSocket(url));
                }
                if (!this._webSocket) {
                    this.raiseOpenFailure(args, fm.liveswitch.WebSocketStatusCode.NoStatus, new fm.liveswitch.Exception('Could not create WebSocket.'));
                    return;
                }
                if (!WebSocket.getDisableBinary()) {
                    try {
                        this._webSocket.binaryType = 'arraybuffer';
                    }
                    catch (error) {
                        WebSocket.setDisableBinary(true);
                    }
                }
                this._opening = true;
                this._closing = false;
                this._raisedStreamFailure = false;
                this._raisedOpenFailure = false;
                this._webSocket.onopen = this.onOpen;
                this._webSocket.onerror = this.onError;
                this._webSocket.onclose = this.onClose;
                this._webSocket.onmessage = this.onMessage;
            };
            WebSocket.prototype.processOnClose = function (code, reason) {
                var reasonText = '';
                if (!fm.liveswitch.StringExtensions.isNullOrEmpty(reason)) {
                    reasonText = ' (' + reason + ')';
                }
                if (this._opening) {
                    this._opening = false;
                    if (!this._raisedOpenFailure) {
                        this._raisedOpenFailure = true;
                        this.raiseOpenFailure(this._openArgs, code, new fm.liveswitch.Exception('Could not open WebSocket.' + reasonText));
                    }
                }
                else if (this._aborting) {
                    if (!this._raisedStreamFailure) {
                        this._raisedStreamFailure = true;
                        this.raiseStreamFailure(this._openArgs, code, new fm.liveswitch.Exception('WebSocket request timed out.' + reasonText));
                    }
                }
                else if (!this._closing) {
                    if (!this._raisedStreamFailure) {
                        this._raisedStreamFailure = true;
                        this.raiseStreamFailure(this._openArgs, code, new fm.liveswitch.Exception('WebSocket closed.' + reasonText));
                    }
                }
            };
            WebSocket.prototype.send = function (args) {
                var _this = this;
                if (!this._webSocket) {
                    return;
                }
                this._sendArgs = args;
                //this.raiseOnRequestCreated();
                if (this._timer) {
                    window.clearTimeout(this._timer);
                }
                var timeout = args.getTimeout();
                if (timeout > 0) {
                    this._timer = window.setTimeout(function () {
                        if (!_this._webSocket) {
                            return;
                        }
                        _this._aborting = true;
                        _this._webSocket.close();
                        _this.processOnClose(4000, 'Timeout');
                    }, timeout);
                }
                var sentBinary = false;
                var binary = args.getBinaryMessage();
                if (!WebSocket.getDisableBinary() && binary) {
                    try {
                        this._webSocket.send(binary.buffer);
                        sentBinary = true;
                    }
                    catch (error) {
                        WebSocket.setDisableBinary(true);
                    }
                }
                if (!sentBinary) {
                    return this._webSocket.send(args.getTextMessage());
                }
            };
            WebSocket.prototype.close = function (args) {
                if (typeof args === 'undefined') {
                    this.close(new fm.liveswitch.WebSocketCloseArgs());
                    return;
                }
                var code = args.getStatusCode() || fm.liveswitch.WebSocketStatusCode.Normal;
                var reason = args.getReason() || '';
                var e = new fm.liveswitch.WebSocketCloseCompleteArgs();
                e.setStatusCode(code);
                e.setReason(reason);
                window.clearTimeout(this._timer);
                if (this._webSocket) {
                    this._closing = true;
                    this._webSocket.close(code, reason);
                    this._webSocket = null;
                }
                this.raiseCloseComplete(args, code, reason);
            };
            WebSocket.prototype.raiseOnRequestCreated = function () {
                if (this._onRequestCreated) {
                    var args = new fm.liveswitch.HttpRequestCreatedArgs();
                    args.setSender(this._openArgs.getSender());
                    args.setRequest(null);
                    this._onRequestCreated(args);
                }
            };
            WebSocket.prototype.raiseOnResponseReceived = function () {
                if (this._onResponseReceived) {
                    var args = new fm.liveswitch.HttpResponseReceivedArgs();
                    args.setSender(this._openArgs.getSender());
                    args.setResponse(null);
                    this._onResponseReceived(args);
                }
            };
            WebSocket._disableBinary = false;
            return WebSocket;
        }(fm.liveswitch.WebSocketBase));
        liveswitch.WebSocket = WebSocket;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Base definition for classes that allow serialization to/from JSON.
        */
        var Serializable = /** @class */ (function () {
            /**
            Initializes a new instance of the [[fm.liveswitch.serializable]] class.
            */
            function Serializable() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchSerializableInit();
                    this.setIsSerialized(false);
                    this.setIsDirty(false);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Serializable.prototype.getTypeString = function () {
                return '[fm.liveswitch.Serializable]';
            };
            Serializable.prototype.fmliveswitchSerializableInit = function () {
                this._isDirty = false;
                this._isSerialized = false;
            };
            /** @hidden */
            Serializable.prototype.getIsDirty = function () {
                if (arguments.length == 0) {
                    return this._isDirty;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Serializable.prototype.getIsSerialized = function () {
                if (arguments.length == 0) {
                    return this._isSerialized;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Serializable.prototype.getSerialized = function () {
                if (arguments.length == 0) {
                    return this.__serialized;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Serializable.prototype.setIsDirty = function (value) {
                if (arguments.length == 1) {
                    this._isDirty = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Serializable.prototype.setIsSerialized = function (value) {
                if (arguments.length == 1) {
                    this._isSerialized = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Serializable.prototype.setSerialized = function (value) {
                if (arguments.length == 1) {
                    this.__serialized = value;
                    this.setIsSerialized(true);
                    this.setIsDirty(false);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Serializable;
        }());
        liveswitch.Serializable = Serializable;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Serializable.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Supplies class instances with a key-value mapping to support dynamic property storage.
        */
        var Dynamic = /** @class */ (function (_super) {
            __extends(Dynamic, _super);
            function Dynamic() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.__dynamicProperties = null;
                    _this.__dynamicPropertiesLock = new Object();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            Dynamic.prototype.getTypeString = function () {
                return '[fm.liveswitch.Dynamic]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Gets the dynamic properties on this instance.
            */
            Dynamic.prototype.getDynamicProperties = function () {
                if (arguments.length == 0) {
                    if ((fm.liveswitch.Global.equals(this.__dynamicProperties, null))) {
                        return null;
                    }
                    var dictionary = {};
                    for (var _i = 0, _a = fm.liveswitch.HashExtensions.getKeys(this.__dynamicProperties); _i < _a.length; _i++) {
                        var str = _a[_i];
                        dictionary[str] = this.__dynamicProperties[str];
                    }
                    return dictionary;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a property value from the local cache.
            @param key The property key. This key is used internally only, but should be namespaced to avoid conflict with third-party extensions.
            @return The stored value, if found; otherwise null.
            */
            Dynamic.prototype.getDynamicValue = function (key) {
                if (arguments.length == 1) {
                    var obj2 = null;
                    this.tryInitDynamicProperties();
                    var _var0 = new fm.liveswitch.Holder(obj2);
                    var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this.__dynamicProperties, key, _var0);
                    obj2 = _var0.getValue();
                    if (_var1) {
                        return obj2;
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Dynamic.prototype.setDynamicProperties = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(value, null))) {
                        this.__dynamicProperties = null;
                    }
                    else {
                        this.__dynamicProperties = {};
                        for (var _i = 0, _a = fm.liveswitch.HashExtensions.getKeys(value); _i < _a.length; _i++) {
                            var str = _a[_i];
                            this.__dynamicProperties[str] = value[str];
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a property value in the local cache.
            @param key The property key. This key is used internally only, but should be namespaced to avoid conflict with third-party extensions.
            @param value The property value. This can be any object that needs to be stored for future use.
            */
            Dynamic.prototype.setDynamicValue = function (key, value) {
                if (arguments.length == 2) {
                    this.tryInitDynamicProperties();
                    this.__dynamicProperties[key] = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Dynamic.prototype.tryInitDynamicProperties = function () {
                if (arguments.length == 0) {
                    if ((fm.liveswitch.Global.equals(this.__dynamicProperties, null))) {
                        this.__dynamicProperties = {};
                        return true;
                    }
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Unsets a property value in the local cache.
            @param key The property key. This key is used internally only, but should be namespaced to avoid conflict with third-party extensions.
            @return `true` if the value was removed; otherwise, `false`.
            */
            Dynamic.prototype.unsetDynamicValue = function (key) {
                if (arguments.length == 1) {
                    this.tryInitDynamicProperties();
                    return fm.liveswitch.HashExtensions.remove(this.__dynamicProperties, key);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Dynamic;
        }(fm.liveswitch.Serializable));
        liveswitch.Dynamic = Dynamic;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Stream = /** @class */ (function (_super) {
            __extends(Stream, _super);
            function Stream() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Stream.prototype.getTypeString = function () {
                return '[fm.liveswitch.Stream]' + ',' + _super.prototype.getTypeString.call(this);
            };
            Stream.prototype.getState = function () {
                return this._getInternal().getState();
            };
            Stream.prototype.addOnStateChange = function (value) {
                this._getInternal().addOnStateChange(value);
            };
            Stream.prototype.removeOnStateChange = function (value) {
                this._getInternal().removeOnStateChange(value);
            };
            Stream.prototype.changeDirection = function (newDirection) {
                return this._getInternal().changeDirection(newDirection);
            };
            Stream.prototype.getDirection = function () {
                return this._getInternal().getDirection();
            };
            Stream.prototype.getLocalReceive = function () {
                return this._getInternal().getLocalReceive();
            };
            Stream.prototype.setLocalReceive = function (receiveEnabled) {
                return this._getInternal().setLocalReceive(receiveEnabled);
            };
            Stream.prototype.getLocalSend = function () {
                return this._getInternal().getLocalSend();
            };
            Stream.prototype.setLocalSend = function (sendEnabled) {
                return this._getInternal().setLocalSend(sendEnabled);
            };
            Stream.prototype.getRemoteReceive = function () {
                return this._getInternal().getRemoteReceive();
            };
            Stream.prototype.getRemoteSend = function () {
                return this._getInternal().getRemoteSend();
            };
            Stream.prototype.getRemoteDirection = function () {
                return this._getInternal().getRemoteDirection();
            };
            Stream.prototype.getId = function () {
                return this._getInternal().getId();
            };
            Stream.prototype.getExternalId = function () {
                return this._getInternal().getExternalId();
            };
            Stream.prototype.getLabel = function () {
                return this._getInternal().getId();
            };
            Stream.prototype.getLocalDirection = function () {
                return this._getInternal().getLocalDirection();
            };
            Stream.prototype.getMediaDescriptionId = function () {
                return this._getInternal().getMediaDescriptionId();
            };
            Stream.prototype.getTag = function () {
                return this._getInternal().getTag();
            };
            Stream.prototype.getType = function () {
                return this._getInternal().getType();
            };
            Stream.prototype.setExternalId = function (value) {
                this._getInternal().setExternalId(value);
            };
            Stream.prototype.setLocalDirection = function (value) {
                this._getInternal().setLocalDirection(value);
            };
            Stream.prototype.setTag = function (value) {
                this._getInternal().setTag(value);
            };
            Stream.prototype.addOnDirectionChange = function (value) {
                this._getInternal().addOnDirectionChange(value);
            };
            Stream.prototype.removeOnDirectionChange = function (value) {
                this._getInternal().removeOnDirectionChange(value);
            };
            Stream.prototype.getTransportInfo = function () {
                return this._getInternal().getTransportInfo();
            };
            return Stream;
        }(fm.liveswitch.Dynamic));
        liveswitch.Stream = Stream;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Stream.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var MediaStream = /** @class */ (function (_super) {
            __extends(MediaStream, _super);
            function MediaStream(localTrack, remoteTrack) {
                var _this = _super.call(this) || this;
                _this.localTrack = localTrack;
                _this.remoteTrack = remoteTrack;
                return _this;
            }
            MediaStream.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaStream]' + ',' + _super.prototype.getTypeString.call(this);
            };
            MediaStream.prototype.getLocalTrack = function () {
                return this.localTrack;
            };
            MediaStream.prototype.getRemoteTrack = function () {
                return this.remoteTrack;
            };
            MediaStream.prototype.getLocalBandwidth = function () {
                return this._getInternal().getLocalBandwidth();
            };
            MediaStream.prototype.getMuted = function () {
                return this.getInputMuted();
            };
            MediaStream.prototype.getInputMuted = function () {
                return this._getInternal().getInputMuted();
            };
            MediaStream.prototype.getOutputMuted = function () {
                return this._getInternal().getOutputMuted();
            };
            MediaStream.prototype.getRemoteBandwidth = function () {
                return this._getInternal().getRemoteBandwidth();
            };
            MediaStream.prototype.setLocalBandwidth = function (value) {
                this._getInternal().setLocalBandwidth(value);
            };
            MediaStream.prototype.setMuted = function (value) {
                this.setInputMuted(value);
            };
            MediaStream.prototype.setInputMuted = function (value) {
                this._getInternal().setInputMuted(value);
            };
            MediaStream.prototype.setOutputMuted = function (value) {
                this._getInternal().setOutputMuted(value);
            };
            MediaStream.prototype.getPreferredCodecs = function () {
                return this._getInternal().getPreferredCodecs();
            };
            MediaStream.prototype.setPreferredCodecs = function (names) {
                this._getInternal().setPreferredCodecs(names);
            };
            MediaStream.prototype.getCodecDisabled = function (name) {
                return this._getInternal().getCodecDisabled(name);
            };
            MediaStream.prototype.setCodecDisabled = function (name, disabled) {
                this._getInternal().setCodecDisabled(name, disabled);
            };
            MediaStream.prototype.getRemoteEncoding = function () {
                return this._getInternal().getRemoteEncoding();
            };
            MediaStream.prototype.setRemoteEncoding = function (value) {
                this._getInternal().setRemoteEncoding(value);
            };
            MediaStream.prototype.getSimulcastMode = function () {
                return this._getInternal().getSimulcastMode();
            };
            MediaStream.prototype.setSimulcastMode = function (value) {
                this._getInternal().setSimulcastMode(value);
            };
            MediaStream.prototype.getInfo = function () {
                return this._getInternal().getInfo();
            };
            MediaStream.prototype.getControlTransportInfo = function () {
                return this._getInternal().getControlTransportInfo();
            };
            MediaStream.prototype.getLocalCanonicalName = function () {
                return this._getInternal().getLocalCanonicalName();
            };
            MediaStream.prototype.getRemoteCanonicalName = function () {
                return this._getInternal().getRemoteCanonicalName();
            };
            MediaStream.prototype.addOnLocalEncodingDisabled = function (value) {
                this._getInternal().addOnLocalEncodingDisabled(value);
            };
            MediaStream.prototype.addOnLocalEncodingEnabled = function (value) {
                this._getInternal().addOnLocalEncodingEnabled(value);
            };
            MediaStream.prototype.removeOnLocalEncodingDisabled = function (value) {
                this._getInternal().removeOnLocalEncodingDisabled(value);
            };
            MediaStream.prototype.removeOnLocalEncodingEnabled = function (value) {
                this._getInternal().removeOnLocalEncodingEnabled(value);
            };
            MediaStream.prototype.addOnDiscardBitrateRequest = function (value) {
                this._getInternal().addOnDiscardBitrateRequest(value);
            };
            MediaStream.prototype.removeOnDiscardBitrateRequest = function (value) {
                this._getInternal().removeOnDiscardBitrateRequest(value);
            };
            MediaStream.prototype.raiseBitrateRequest = function (bitrateRequest) {
                return this._getInternal().raiseBitrateRequest(bitrateRequest);
            };
            MediaStream.prototype.addOnDiscardBitrateNotification = function (value) {
                this._getInternal().addOnDiscardBitrateNotification(value);
            };
            MediaStream.prototype.removeOnDiscardBitrateNotification = function (value) {
                this._getInternal().removeOnDiscardBitrateNotification(value);
            };
            MediaStream.prototype.raiseBitrateNotification = function (bitrateNotification) {
                return this._getInternal().raiseBitrateNotification(bitrateNotification);
            };
            MediaStream.prototype.getMaxSendBitrate = function () {
                return this._getInternal().getMaxSendBitrate();
            };
            MediaStream.prototype.setMaxSendBitrate = function (value) {
                this._getInternal().setMaxSendBitrate(value);
            };
            MediaStream.prototype.getMaxReceiveBitrate = function () {
                return this._getInternal().getMaxReceiveBitrate();
            };
            MediaStream.prototype.setMaxReceiveBitrate = function (value) {
                this._getInternal().setMaxReceiveBitrate(value);
            };
            return MediaStream;
        }(fm.liveswitch.Stream));
        liveswitch.MediaStream = MediaStream;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="MediaStream.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var AudioStream = /** @class */ (function (_super) {
            __extends(AudioStream, _super);
            function AudioStream() {
                var _this = this;
                if (arguments.length == 0) {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                var localTrack = null;
                var localMedia = null;
                var remoteTrack = null;
                var remoteMedia = null;
                if (arguments.length >= 1 && fm.liveswitch.Util.isNullOrUndefined(arguments[0])) {
                    //throw new fm.liveswitch.Exception('Local track/media cannot be null.');
                }
                else if (arguments.length >= 1 && fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.AudioTrack]')) {
                    localTrack = arguments[0];
                }
                else if (arguments.length >= 1 && fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.LocalMedia]')) {
                    localMedia = arguments[0];
                    localTrack = localMedia.getAudioTrack();
                }
                else if (arguments.length >= 1 && fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.RemoteMedia]')) {
                    remoteMedia = arguments[0];
                    remoteTrack = remoteMedia.getAudioTrack();
                }
                else if (arguments.length >= 1) {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                if (arguments.length >= 2 && fm.liveswitch.Util.isNullOrUndefined(arguments[1])) {
                    //throw new fm.liveswitch.Exception('Remote track/media cannot be null.');
                }
                else if (arguments.length >= 2 && fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.AudioTrack]')) {
                    remoteTrack = arguments[1];
                }
                else if (arguments.length >= 2 && fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.RemoteMedia]')) {
                    remoteMedia = arguments[1];
                    remoteTrack = remoteMedia.getAudioTrack();
                }
                else if (arguments.length >= 2) {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                _this = _super.call(this, localTrack, remoteTrack) || this;
                _this.localMedia = localMedia;
                _this.remoteMedia = remoteMedia;
                if (fm.liveswitch.Plugin.useActiveX()) {
                    _this._internal = new fm.liveswitch.PluginAudioStream(_this, (localTrack == null ? null : localTrack._getInternal()), (remoteTrack == null ? null : remoteTrack._getInternal()));
                }
                else if (fm.liveswitch.Plugin.useNative()) {
                    _this._internal = new fm.liveswitch.WebRtcAudioStream(_this, (localTrack == null ? null : localTrack._getInternal()), (remoteTrack == null ? null : remoteTrack._getInternal()));
                }
                else {
                    throw new fm.liveswitch.Exception('Browser does not support WebRTC/ORTC and no plugin found.');
                }
                return _this;
            }
            AudioStream.prototype.getTypeString = function () {
                return '[fm.liveswitch.AudioStream]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            AudioStream.prototype._getInternal = function () {
                return this._internal;
            };
            AudioStream.prototype.getLocalMedia = function () {
                return this.localMedia;
            };
            AudioStream.prototype.getRemoteMedia = function () {
                return this.remoteMedia;
            };
            /** @internal */
            AudioStream.prototype.getDiscardDtmfTones = function () {
                if (!fm.liveswitch.Plugin.useActiveX() && fm.liveswitch.Plugin.useNative()) {
                    return this._internal.getDiscardDtmfTones();
                }
                return false;
            };
            /** @internal */
            AudioStream.prototype.setDiscardDtmfTones = function (value) {
                if (!fm.liveswitch.Plugin.useActiveX() && fm.liveswitch.Plugin.useNative()) {
                    this._internal.setDiscardDtmfTones(value);
                }
            };
            AudioStream.prototype.addOnReceiveDtmfTone = function (value) {
                this._getInternal().addOnReceiveDtmfTone(value);
            };
            AudioStream.prototype.addOnReceiveDtmfToneChange = function (value) {
                this._getInternal().addOnReceiveDtmfToneChange(value);
            };
            AudioStream.prototype.addOnSendDtmfTone = function (value) {
                this._getInternal().addOnSendDtmfTone(value);
            };
            AudioStream.prototype.addOnSendDtmfToneChange = function (value) {
                this._getInternal().addOnSendDtmfToneChange(value);
            };
            AudioStream.prototype.insertDtmfTone = function (dtmfTone) {
                return this._getInternal().insertDtmfTone(dtmfTone);
            };
            AudioStream.prototype.insertDtmfTones = function (dtmfTones) {
                return this._getInternal().insertDtmfTones(dtmfTones);
            };
            AudioStream.prototype.removeOnReceiveDtmfTone = function (value) {
                this._getInternal().removeOnReceiveDtmfTone(value);
            };
            AudioStream.prototype.removeOnReceiveDtmfToneChange = function (value) {
                this._getInternal().removeOnReceiveDtmfToneChange(value);
            };
            AudioStream.prototype.removeOnSendDtmfTone = function (value) {
                this._getInternal().removeOnSendDtmfTone(value);
            };
            AudioStream.prototype.removeOnSendDtmfToneChange = function (value) {
                this._getInternal().removeOnSendDtmfToneChange(value);
            };
            AudioStream.prototype.getOpusDisabled = function () {
                return this._getInternal().getOpusDisabled();
            };
            AudioStream.prototype.getG722Disabled = function () {
                return this._getInternal().getG722Disabled();
            };
            AudioStream.prototype.getPcmuDisabled = function () {
                return this._getInternal().getPcmuDisabled();
            };
            AudioStream.prototype.getPcmaDisabled = function () {
                return this._getInternal().getPcmaDisabled();
            };
            AudioStream.prototype.setOpusDisabled = function (value) {
                return this._getInternal().setOpusDisabled(value);
            };
            AudioStream.prototype.setG722Disabled = function (value) {
                return this._getInternal().setG722Disabled(value);
            };
            AudioStream.prototype.setPcmuDisabled = function (value) {
                return this._getInternal().setPcmuDisabled(value);
            };
            AudioStream.prototype.setPcmaDisabled = function (value) {
                return this._getInternal().setPcmaDisabled(value);
            };
            AudioStream.prototype.addOnDiscardOutboundDtmfTones = function (value) {
                if (!fm.liveswitch.Plugin.useActiveX() && fm.liveswitch.Plugin.useNative()) {
                    this._internal.addOnDiscardOutboundDtmfTones(value);
                }
            };
            AudioStream.prototype.removeOnDiscardOutboundDtmfTones = function (value) {
                if (!fm.liveswitch.Plugin.useActiveX() && fm.liveswitch.Plugin.useNative()) {
                    this._internal.removeOnDiscardOutboundDtmfTones(value);
                }
            };
            return AudioStream;
        }(fm.liveswitch.MediaStream));
        liveswitch.AudioStream = AudioStream;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var MediaTrack = /** @class */ (function (_super) {
            __extends(MediaTrack, _super);
            function MediaTrack(media) {
                var _this = _super.call(this) || this;
                _this.media = media;
                return _this;
            }
            MediaTrack.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaTrack]' + ',' + _super.prototype.getTypeString.call(this);
            };
            MediaTrack.prototype.getMedia = function () {
                return this.media;
            };
            MediaTrack.prototype.addOnStarted = function (value) {
                return this._getInternal().addOnStarted(value);
            };
            MediaTrack.prototype.addOnStopped = function (value) {
                return this._getInternal().addOnStopped(value);
            };
            MediaTrack.prototype.addOnDestroyed = function (value) {
                return this._getInternal().addOnDestroyed(value);
            };
            MediaTrack.prototype.removeOnStarted = function (value) {
                return this._getInternal().removeOnStarted(value);
            };
            MediaTrack.prototype.removeOnStopped = function (value) {
                return this._getInternal().removeOnStopped(value);
            };
            MediaTrack.prototype.removeOnDestroyed = function (value) {
                return this._getInternal().removeOnDestroyed(value);
            };
            MediaTrack.prototype.changeSinkOutput = function (sinkOutput) {
                return this._getInternal().changeSinkOutput(sinkOutput);
            };
            MediaTrack.prototype.changeSourceInput = function (sourceInput) {
                return this._getInternal().changeSourceInput(sourceInput);
            };
            MediaTrack.prototype.destroy = function () {
                return this._getInternal().destroy();
            };
            MediaTrack.prototype.getMuted = function () {
                return this._getInternal().getMuted();
            };
            MediaTrack.prototype.getSinkOutput = function () {
                return this._getInternal().getSinkOutput();
            };
            MediaTrack.prototype.getSinkOutputs = function () {
                return this._getInternal().getSinkOutputs();
            };
            MediaTrack.prototype.getSourceInput = function () {
                return this._getInternal().getSourceInput();
            };
            MediaTrack.prototype.getSourceInputs = function () {
                return this._getInternal().getSourceInputs();
            };
            MediaTrack.prototype.setMuted = function (value) {
                this._getInternal().setMuted(value);
            };
            MediaTrack.prototype.setSinkOutput = function (value) {
                this._getInternal().setSinkOutput(value);
            };
            MediaTrack.prototype.setSourceInput = function (value) {
                this._getInternal().setSourceInput(value);
            };
            return MediaTrack;
        }(fm.liveswitch.Dynamic));
        liveswitch.MediaTrack = MediaTrack;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="MediaTrack.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var AudioTrack = /** @class */ (function (_super) {
            __extends(AudioTrack, _super);
            function AudioTrack(media, internalMedia) {
                var _this = _super.call(this, media) || this;
                if (fm.liveswitch.Util.isNullOrUndefined(media)) {
                    throw new fm.liveswitch.Exception('Media cannot be null.');
                }
                if (fm.liveswitch.Plugin.useActiveX()) {
                    _this._internal = new fm.liveswitch.PluginAudioTrack(_this, (media._getInternal() || internalMedia));
                }
                else if (fm.liveswitch.Plugin.useNative()) {
                    _this._internal = new fm.liveswitch.WebRtcAudioTrack(_this, (media._getInternal() || internalMedia));
                }
                else {
                    throw new fm.liveswitch.Exception('Browser does not support WebRTC/ORTC and no plugin found.');
                }
                return _this;
            }
            AudioTrack.prototype.getTypeString = function () {
                return '[fm.liveswitch.AudioTrack]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            AudioTrack.prototype._getInternal = function () {
                return this._internal;
            };
            AudioTrack.prototype.addOnLevel = function (value) {
                return this._internal.addOnLevel(value);
            };
            AudioTrack.prototype.getGain = function () {
                return this._internal.getGain();
            };
            AudioTrack.prototype.getVolume = function () {
                return this._internal.getVolume();
            };
            AudioTrack.prototype.removeOnLevel = function (value) {
                return this._internal.removeOnLevel(value);
            };
            AudioTrack.prototype.setGain = function (value) {
                this._internal.setGain(value);
            };
            AudioTrack.prototype.setVolume = function (value) {
                this._internal.setVolume(value);
            };
            return AudioTrack;
        }(fm.liveswitch.MediaTrack));
        liveswitch.AudioTrack = AudioTrack;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Connection = /** @class */ (function (_super) {
            __extends(Connection, _super);
            function Connection() {
                var _this = _super.call(this) || this;
                /** @internal */
                _this._onGatheringStateChangeValues = [];
                /** @internal */
                _this._onIceConnectionStateChangeValues = [];
                /** @internal */
                _this._onLocalCandidateValues = [];
                /** @internal */
                _this._onLocalDescriptionValues = [];
                /** @internal */
                _this._onRemoteCandidateValues = [];
                /** @internal */
                _this._onRemoteDescriptionValues = [];
                /** @internal */
                _this._onSignallingStateChangeValues = [];
                /** @internal */
                _this._onStateChangeValues = [];
                _this._onExternalIdChangeValues = [];
                var streams = null;
                if (arguments.length == 0 || (arguments.length >= 1 && fm.liveswitch.Util.isNullOrUndefined(arguments[0]))) {
                    throw new fm.liveswitch.Exception('Stream(s) cannot be null.');
                }
                else if (arguments.length >= 1 && fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.Stream]')) {
                    streams = [arguments[0]];
                }
                else if (arguments.length >= 1 && fm.liveswitch.Util.isArrayType(arguments[0], '[fm.liveswitch.Stream]')) {
                    streams = arguments[0];
                }
                else if (arguments.length >= 1) {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                var remoteMedia = null;
                for (var _i = 0, streams_1 = streams; _i < streams_1.length; _i++) {
                    var stream = streams_1[_i];
                    if (fm.liveswitch.Util.isObjectType(stream, '[fm.liveswitch.AudioStream]')) {
                        var audioStream = stream;
                        var remoteAudioTrack = audioStream.getRemoteTrack();
                        if (remoteAudioTrack) {
                            var remoteAudioMedia = remoteAudioTrack.getMedia();
                            if (remoteMedia == null) {
                                remoteMedia = remoteAudioMedia;
                            }
                            else if (remoteMedia != remoteAudioMedia) {
                                throw new fm.liveswitch.Exception('Remote media for streams does not match.');
                            }
                        }
                    }
                    else if (fm.liveswitch.Util.isObjectType(stream, '[fm.liveswitch.VideoStream]')) {
                        var videoStream = stream;
                        var remoteVideoTrack = videoStream.getRemoteTrack();
                        if (remoteVideoTrack) {
                            var remoteVideoMedia = remoteVideoTrack.getMedia();
                            if (remoteMedia == null) {
                                remoteMedia = remoteVideoMedia;
                            }
                            else if (remoteMedia != remoteVideoMedia) {
                                throw new fm.liveswitch.Exception('Remote media for streams does not match.');
                            }
                        }
                    }
                }
                if (remoteMedia == null) {
                    remoteMedia = new fm.liveswitch.RemoteMedia();
                }
                _this._remoteMedia = remoteMedia;
                if (fm.liveswitch.Plugin.useActiveX()) {
                    _this._internal = new fm.liveswitch.PluginConnection(_this, _this.externalsToInternals(streams));
                }
                else if (fm.liveswitch.Plugin.useNative()) {
                    _this._internal = new fm.liveswitch.WebRtcConnection(_this, _this.externalsToInternals(streams), _this._remoteMedia._getInternal());
                }
                else {
                    throw new fm.liveswitch.Exception('Browser does not support WebRTC/ORTC and no plugin found.');
                }
                // event proxy
                _this._internal.addOnExternalIdChange(function (id1, id2) {
                    for (var _i = 0, _a = _this._onExternalIdChangeValues; _i < _a.length; _i++) {
                        var onExternalIdChangeValue = _a[_i];
                        onExternalIdChangeValue(id1, id2);
                    }
                });
                _this._internal.addOnGatheringStateChange(function (c) {
                    for (var _i = 0, _a = _this._onGatheringStateChangeValues; _i < _a.length; _i++) {
                        var onGatheringStateChangeValue = _a[_i];
                        onGatheringStateChangeValue(_this);
                    }
                });
                _this._internal.addOnIceConnectionStateChange(function (c) {
                    for (var _i = 0, _a = _this._onIceConnectionStateChangeValues; _i < _a.length; _i++) {
                        var onIceConnectionStateChangeValue = _a[_i];
                        onIceConnectionStateChangeValue(_this);
                    }
                });
                _this._internal.addOnLocalCandidate(function (c, candidate) {
                    for (var _i = 0, _a = _this._onLocalCandidateValues; _i < _a.length; _i++) {
                        var onLocalCandidateValue = _a[_i];
                        onLocalCandidateValue(_this, candidate);
                    }
                });
                _this._internal.addOnLocalDescription(function (c, sessionDescription) {
                    for (var _i = 0, _a = _this._onLocalDescriptionValues; _i < _a.length; _i++) {
                        var onLocalDescriptionValue = _a[_i];
                        onLocalDescriptionValue(_this, sessionDescription);
                    }
                });
                _this._internal.addOnRemoteCandidate(function (c, candidate) {
                    for (var _i = 0, _a = _this._onRemoteCandidateValues; _i < _a.length; _i++) {
                        var onRemoteCandidateValue = _a[_i];
                        onRemoteCandidateValue(_this, candidate);
                    }
                });
                _this._internal.addOnRemoteDescription(function (c, sessionDescription) {
                    for (var _i = 0, _a = _this._onRemoteDescriptionValues; _i < _a.length; _i++) {
                        var onRemoteDescriptionValue = _a[_i];
                        onRemoteDescriptionValue(_this, sessionDescription);
                    }
                });
                _this._internal.addOnSignallingStateChange(function (c) {
                    for (var _i = 0, _a = _this._onSignallingStateChangeValues; _i < _a.length; _i++) {
                        var onSignallingStateChangeValue = _a[_i];
                        onSignallingStateChangeValue(_this);
                    }
                });
                _this._internal.addOnStateChange(function (c) {
                    for (var _i = 0, _a = _this._onStateChangeValues; _i < _a.length; _i++) {
                        var onStateChangeValue = _a[_i];
                        onStateChangeValue(_this);
                    }
                });
                return _this;
            }
            Connection.prototype.getTypeString = function () {
                return '[fm.liveswitch.Connection]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            Connection.prototype._getInternal = function () {
                return this._internal;
            };
            Connection.prototype.addIceServer = function (iceServer) {
                this._internal.addIceServer(iceServer);
            };
            Connection.prototype.addIceServers = function (iceServers) {
                this._internal.addIceServers(iceServers);
            };
            Connection.prototype.addOnGatheringStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onGatheringStateChangeValues, value);
            };
            Connection.prototype.addOnIceConnectionStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onIceConnectionStateChangeValues, value);
            };
            Connection.prototype.addOnLocalCandidate = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onLocalCandidateValues, value);
            };
            Connection.prototype.addOnLocalDescription = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onLocalDescriptionValues, value);
            };
            Connection.prototype.addOnRemoteCandidate = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onRemoteCandidateValues, value);
            };
            Connection.prototype.addOnRemoteDescription = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onRemoteDescriptionValues, value);
            };
            Connection.prototype.addOnSignallingStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onSignallingStateChangeValues, value);
            };
            Connection.prototype.addOnStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onStateChangeValues, value);
            };
            Connection.prototype.addRemoteCandidate = function (remoteCandidate) {
                return this._internal.addRemoteCandidate(remoteCandidate);
            };
            Connection.prototype.close = function () {
                return this._internal.close();
            };
            Connection.prototype.createAnswer = function () {
                return this._internal.createAnswer();
            };
            Connection.prototype.createOffer = function () {
                return this._internal.createOffer();
            };
            ;
            Connection.prototype.getDeadStreamTimeout = function () {
                return this._internal.getDeadStreamTimeout();
            };
            Connection.prototype.getError = function () {
                return this._internal.getError();
            };
            Connection.prototype.getExternalId = function () {
                return this._internal.getExternalId();
            };
            Connection.prototype.getBundlePolicy = function () {
                return this._internal.getBundlePolicy();
            };
            Connection.prototype.getIceGatherPolicy = function () {
                return this._internal.getIceGatherPolicy();
            };
            Connection.prototype.getIceServer = function () {
                return this._internal.getIceServer();
            };
            Connection.prototype.getGatheringState = function () {
                return this._internal.getGatheringState();
            };
            Connection.prototype.getIceConnectionState = function () {
                return this._internal.getIceConnectionState();
            };
            Connection.prototype.getIceServers = function () {
                return this._internal.getIceServers();
            };
            Connection.prototype.getId = function () {
                return this._internal.getId();
            };
            Connection.prototype.getCanonicalName = function () {
                return this._internal.getCanonicalName();
            };
            Connection.prototype.getLocalDescription = function () {
                return this._internal.getLocalDescription();
            };
            Connection.prototype.getRemoteDescription = function () {
                return this._internal.getRemoteDescription();
            };
            Connection.prototype.getSignallingState = function () {
                return this._internal.getSignallingState();
            };
            Connection.prototype.getState = function () {
                return this._internal.getState();
            };
            Connection.prototype.getStats = function () {
                return this._internal.getStats();
            };
            Connection.prototype.getStreams = function () {
                return this.internalsToExternals(this._internal.getStreams());
            };
            Connection.prototype.getTieBreaker = function () {
                return this._internal.getTieBreaker();
            };
            Connection.prototype.getLegacyTimeout = function () {
                return this._internal.getLegacyTimeout();
            };
            Connection.prototype.getTimeout = function () {
                return this._internal.getTimeout();
            };
            Connection.prototype.getTrickleIcePolicy = function () {
                return this._internal.getTrickleIcePolicy();
            };
            Connection.prototype.getHasAudio = function () {
                return this._internal.getHasAudio();
            };
            Connection.prototype.getHasVideo = function () {
                return this._internal.getHasVideo();
            };
            Connection.prototype.getHasData = function () {
                return this._internal.getHasData();
            };
            Connection.prototype.getAudioStream = function () {
                return this.internalToExternal(this._internal.getAudioStream());
            };
            Connection.prototype.getAudioStreams = function () {
                return this.internalsToExternals(this._internal.getAudioStreams());
            };
            Connection.prototype.getVideoStream = function () {
                return this.internalToExternal(this._internal.getVideoStream());
            };
            Connection.prototype.getVideoStreams = function () {
                return this.internalsToExternals(this._internal.getVideoStreams());
            };
            Connection.prototype.getDataStream = function () {
                return this.internalToExternal(this._internal.getDataStream());
            };
            Connection.prototype.getDataStreams = function () {
                return this.internalsToExternals(this._internal.getDataStreams());
            };
            Connection.prototype.removeIceServer = function (iceServer) {
                this._internal.removeIceServer(iceServer);
            };
            Connection.prototype.removeIceServers = function (iceServers) {
                this._internal.removeIceServers(iceServers);
            };
            Connection.prototype.removeOnGatheringStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onGatheringStateChangeValues, value);
            };
            Connection.prototype.removeOnIceConnectionStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onIceConnectionStateChangeValues, value);
            };
            Connection.prototype.removeOnLocalCandidate = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onLocalCandidateValues, value);
            };
            Connection.prototype.removeOnLocalDescription = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onLocalDescriptionValues, value);
            };
            Connection.prototype.removeOnRemoteCandidate = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onRemoteCandidateValues, value);
            };
            Connection.prototype.removeOnRemoteDescription = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onRemoteDescriptionValues, value);
            };
            Connection.prototype.removeOnSignallingStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onSignallingStateChangeValues, value);
            };
            Connection.prototype.removeOnStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onStateChangeValues, value);
            };
            Connection.prototype.setDeadStreamTimeout = function (value) {
                this._internal.setDeadStreamTimeout(value);
            };
            Connection.prototype.setExternalId = function (value) {
                this._internal.setExternalId(value);
            };
            Connection.prototype.setError = function (value) {
                this._internal.setError(value);
            };
            Connection.prototype.addOnExternalIdChange = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onExternalIdChangeValues, value);
            };
            Connection.prototype.removeOnExternalIdChange = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onExternalIdChangeValues, value);
            };
            Connection.prototype.setBundlePolicy = function (value) {
                this._internal.setBundlePolicy(value);
            };
            Connection.prototype.setIceGatherPolicy = function (value) {
                this._internal.setIceGatherPolicy(value);
            };
            Connection.prototype.setIceServer = function (value) {
                this._internal.setIceServer(value);
            };
            Connection.prototype.setIceServers = function (value) {
                this._internal.setIceServers(value);
            };
            Connection.prototype.setLocalDescription = function (localDescription) {
                return this._internal.setLocalDescription(localDescription);
            };
            Connection.prototype.setLegacyTimeout = function (legacyTimeout) {
                return this._internal.setLegacyTimeout(legacyTimeout);
            };
            Connection.prototype.setRemoteDescription = function (remoteDescription) {
                return this._internal.setRemoteDescription(remoteDescription);
            };
            Connection.prototype.setTimeout = function (value) {
                this._internal.setTimeout(value);
            };
            Connection.prototype.setTrickleIcePolicy = function (value) {
                this._internal.setTrickleIcePolicy(value);
            };
            Connection.prototype.setTieBreaker = function (value) {
                this._internal.setTieBreaker(value);
            };
            Connection.prototype.getRemoteMedia = function () {
                //TODO: review this
                return this._remoteMedia;
            };
            Connection.prototype.externalsToInternals = function (externals) {
                var _this = this;
                return fm.liveswitch.ArrayExtensions.map(externals, function (external) {
                    return _this.externalToInternal(external);
                });
            };
            Connection.prototype.externalToInternal = function (external) {
                return external._getInternal();
            };
            Connection.prototype.internalsToExternals = function (internals) {
                var _this = this;
                return fm.liveswitch.ArrayExtensions.map(internals, function (internal) {
                    return _this.internalToExternal(internal);
                });
            };
            Connection.prototype.internalToExternal = function (internal) {
                if (internal == null) {
                    return null;
                }
                return internal._getExternal();
            };
            return Connection;
        }(fm.liveswitch.Dynamic));
        liveswitch.Connection = Connection;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var DataChannel = /** @class */ (function (_super) {
            __extends(DataChannel, _super);
            function DataChannel(label, ordered, subprotocol) {
                var _this = _super.call(this) || this;
                /** @internal */
                _this._onStateChangeValues = [];
                if (fm.liveswitch.Util.isNullOrUndefined(ordered)) {
                    ordered = true;
                }
                if (fm.liveswitch.Util.isNullOrUndefined(subprotocol)) {
                    subprotocol = '';
                }
                if (fm.liveswitch.Plugin.useActiveX()) {
                    _this._internal = new fm.liveswitch.PluginDataChannel(_this, label, ordered, subprotocol);
                }
                else if (fm.liveswitch.Plugin.useNative()) {
                    _this._internal = new fm.liveswitch.WebRtcDataChannel(_this, label, ordered, subprotocol);
                }
                else {
                    throw new fm.liveswitch.Exception('Browser does not support WebRTC/ORTC and no plugin found.');
                }
                // event proxy
                _this._internal.addOnStateChange(function (c) {
                    for (var _i = 0, _a = _this._onStateChangeValues; _i < _a.length; _i++) {
                        var onStateChangeValue = _a[_i];
                        onStateChangeValue(_this);
                    }
                });
                return _this;
            }
            DataChannel.prototype.getTypeString = function () {
                return '[fm.liveswitch.DataChannel]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            DataChannel.prototype._getInternal = function () {
                return this._internal;
            };
            DataChannel.prototype.getInfo = function () {
                return this._getInternal().getInfo();
            };
            /** @internal */
            DataChannel.prototype.setGetRemoteConnectionInfo = function (value) {
                if (fm.liveswitch.Plugin.useActiveX()) {
                    var ch = this._getInternal();
                    ch.setGetRemoteConnectionInfo(value);
                }
                else if (fm.liveswitch.Plugin.useNative()) {
                    var ch = this._getInternal();
                    ch.setGetRemoteConnectionInfo(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Browser does not support WebRTC/ORTC and no plugin found.');
                }
            };
            DataChannel.prototype.setOnReceive = function (value) {
                return this._getInternal().setOnReceive(value);
            };
            DataChannel.prototype.getSubprotocol = function () {
                return this._getInternal().getSubprotocol();
            };
            DataChannel.prototype.getOnReceive = function () {
                return this._getInternal().getOnReceive();
            };
            DataChannel.prototype.sendDataString = function (dataString) {
                return this._getInternal().sendDataString(dataString);
            };
            DataChannel.prototype.sendDataBytes = function (dataBytes) {
                return this._getInternal().sendDataBytes(dataBytes);
            };
            DataChannel.prototype.getState = function () {
                return this._getInternal().getState();
            };
            DataChannel.prototype.getLabel = function () {
                return this._getInternal().getLabel();
            };
            DataChannel.prototype.getId = function () {
                return this._getInternal().getId();
            };
            DataChannel.prototype.getOrdered = function () {
                return this._getInternal().getOrdered();
            };
            DataChannel.prototype.addOnStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onStateChangeValues, value);
            };
            DataChannel.prototype.removeOnStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onStateChangeValues, value);
            };
            return DataChannel;
        }(fm.liveswitch.Dynamic));
        liveswitch.DataChannel = DataChannel;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Stream.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var DataStream = /** @class */ (function (_super) {
            __extends(DataStream, _super);
            function DataStream() {
                var _this = _super.call(this) || this;
                if (arguments.length == 0) {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                var channels = null;
                if (arguments.length >= 1 && fm.liveswitch.Util.isNullOrUndefined(arguments[0])) {
                    throw new fm.liveswitch.Exception('Data channels(s) cannot be null.');
                }
                else if (arguments.length >= 1 && fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.DataChannel]')) {
                    channels = [arguments[0]];
                }
                else if (arguments.length >= 1 && fm.liveswitch.Util.isArrayType(arguments[0], '[fm.liveswitch.DataChannel]')) {
                    channels = arguments[0];
                }
                else if (arguments.length >= 1) {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                var channelsInternal = fm.liveswitch.ArrayExtensions.map(channels, function (channel) {
                    return channel._getInternal();
                });
                if (fm.liveswitch.Plugin.useActiveX()) {
                    _this._internal = new fm.liveswitch.PluginDataStream(_this, channelsInternal);
                }
                else if (fm.liveswitch.Plugin.useNative()) {
                    _this._internal = new fm.liveswitch.WebRtcDataStream(_this, channelsInternal);
                }
                else {
                    throw new fm.liveswitch.Exception('Browser does not support WebRTC/ORTC and no plugin found.');
                }
                return _this;
            }
            DataStream.prototype.getTypeString = function () {
                return '[fm.liveswitch.DataStream]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            DataStream.prototype._getInternal = function () {
                return this._internal;
            };
            DataStream.prototype.getInfo = function () {
                return this._getInternal().getInfo();
            };
            DataStream.prototype.setGetRemoteConnectionInfo = function (value) {
                if (fm.liveswitch.Plugin.useActiveX()) {
                    var pluginDataStream = this._internal;
                    pluginDataStream.setGetRemoteConnectionInfo(value);
                }
                else if (fm.liveswitch.Plugin.useNative()) {
                    var webRtcDataStream = this._internal;
                    webRtcDataStream.setGetRemoteConnectionInfo(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Browser does not support WebRTC/ORTC and no plugin found.');
                }
            };
            DataStream.prototype.getChannels = function () {
                return this.internalsToExternals(this._getInternal().getChannels());
            };
            DataStream.prototype.externalToInternal = function (external) {
                return external._getInternal();
            };
            DataStream.prototype.externalsToInternals = function (externals) {
                return fm.liveswitch.ArrayExtensions.map(externals, function (external) {
                    return external._getInternal();
                });
            };
            DataStream.prototype.internalToExternal = function (internal) {
                return internal._getExternal();
            };
            DataStream.prototype.internalsToExternals = function (internals) {
                return fm.liveswitch.ArrayExtensions.map(internals, function (internal) {
                    return internal._getExternal();
                });
            };
            return DataStream;
        }(fm.liveswitch.Stream));
        liveswitch.DataStream = DataStream;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var DomAudioSink = /** @class */ (function (_super) {
            __extends(DomAudioSink, _super);
            function DomAudioSink(track) {
                var _this = _super.call(this) || this;
                if (fm.liveswitch.Plugin.useActiveX()) {
                    _this._internal = new fm.liveswitch.PluginDomAudioSink(_this, (track == null ? null : track._getInternal()));
                }
                else if (fm.liveswitch.Plugin.useNative()) {
                    _this._internal = new fm.liveswitch.WebRtcDomAudioSink(_this, (track == null ? null : track._getInternal()));
                }
                else {
                    throw new fm.liveswitch.Exception('Browser does not support WebRTC/ORTC and no plugin found.');
                }
                return _this;
            }
            DomAudioSink.prototype.getTypeString = function () {
                return '[fm.liveswitch.DomAudioSink]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            DomAudioSink.prototype._getInternal = function () {
                return this._internal;
            };
            DomAudioSink.prototype.getAudio = function () {
                return this._getInternal().getAudio();
            };
            return DomAudioSink;
        }(fm.liveswitch.Dynamic));
        liveswitch.DomAudioSink = DomAudioSink;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A layout preset.
        */
        var LayoutPreset = /** @class */ (function (_super) {
            __extends(LayoutPreset, _super);
            /**
            Initializes a new instance of the [[fm.liveswitch.layoutPreset]] class.
            */
            function LayoutPreset() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchLayoutPresetInit();
                    _this.__floatWidthPercent = 0;
                    _this.__floatHeightPercent = 0;
                    _this.__floatMarginXPercent = 0;
                    _this.__floatMarginYPercent = 0;
                    _this.__floatWidth = 0;
                    _this.__floatHeight = 0;
                    _this.__floatMarginX = 0;
                    _this.__floatMarginY = 0;
                    _this.__blockWidthPercent = 0;
                    _this.__blockHeightPercent = 0;
                    _this.__blockMarginXPercent = 0;
                    _this.__blockMarginYPercent = 0;
                    _this.__blockWidth = 0;
                    _this.__blockHeight = 0;
                    _this.__blockMarginX = 0;
                    _this.__blockMarginY = 0;
                    _this.setMode(fm.liveswitch.LayoutMode.FloatLocal);
                    _this.setDirection(fm.liveswitch.LayoutDirection.Horizontal);
                    _this.setAlignment(fm.liveswitch.LayoutAlignment.BottomRight);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            LayoutPreset.prototype.getTypeString = function () {
                return '[fm.liveswitch.LayoutPreset]' + ',' + _super.prototype.getTypeString.call(this);
            };
            LayoutPreset.prototype.fmliveswitchLayoutPresetInit = function () {
                this.__blockHeight = 0;
                this.__blockHeightPercent = 0;
                this.__blockMarginX = 0;
                this.__blockMarginXPercent = 0;
                this.__blockMarginY = 0;
                this.__blockMarginYPercent = 0;
                this.__blockWidth = 0;
                this.__blockWidthPercent = 0;
                this.__floatHeight = 0;
                this.__floatHeightPercent = 0;
                this.__floatMarginX = 0;
                this.__floatMarginXPercent = 0;
                this.__floatMarginY = 0;
                this.__floatMarginYPercent = 0;
                this.__floatWidth = 0;
                this.__floatWidthPercent = 0;
                this._inlineMargin = 0;
            };
            /** @hidden */
            LayoutPreset.calculateInlineOverflowFrame = function (baseCoordinate, layoutMeasurement, videoSize, direction) {
                if (arguments.length == 4) {
                    if ((fm.liveswitch.Global.equals(direction, fm.liveswitch.LayoutDirection.Horizontal))) {
                        if ((fm.liveswitch.Global.equals(videoSize.getHeight(), 0))) {
                            return new fm.liveswitch.LayoutFrame(baseCoordinate, 0, 0, layoutMeasurement);
                        }
                        return new fm.liveswitch.LayoutFrame(baseCoordinate, 0, fm.liveswitch.MathAssistant.floor((layoutMeasurement * videoSize.getWidth()) / videoSize.getHeight()), layoutMeasurement);
                    }
                    if ((fm.liveswitch.Global.equals(videoSize.getWidth(), 0))) {
                        return new fm.liveswitch.LayoutFrame(0, baseCoordinate, layoutMeasurement, 0);
                    }
                    return new fm.liveswitch.LayoutFrame(0, baseCoordinate, layoutMeasurement, fm.liveswitch.MathAssistant.floor((layoutMeasurement * videoSize.getHeight()) / videoSize.getWidth()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.calculateTable = function (tableWidth, tableHeight, count) {
                if (arguments.length == 3) {
                    var num = 0;
                    var num2 = 1;
                    var num3 = 1;
                    for (var i = count; (i >= 1); i--) {
                        var num5 = fm.liveswitch.MathAssistant.ceil((count / i));
                        var num6 = (tableWidth / i);
                        var num7 = (tableHeight / num5);
                        var num8 = ((num6 < num7) ? num6 : num7);
                        if ((num8 >= num)) {
                            num = num8;
                            num2 = i;
                            num3 = num5;
                        }
                    }
                    var cellWidth = fm.liveswitch.MathAssistant.floor((tableWidth / num2));
                    return new fm.liveswitch.LayoutTable(num2, num3, cellWidth, fm.liveswitch.MathAssistant.floor((tableHeight / num3)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.divideByTwo = function (value) {
                if (arguments.length == 1) {
                    return fm.liveswitch.MathAssistant.floor((value / 2));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a Facetime-style layout preset.
            */
            LayoutPreset.getFacetime = function () {
                if (arguments.length == 0) {
                    var preset = new fm.liveswitch.LayoutPreset();
                    preset.setMode(fm.liveswitch.LayoutMode.FloatLocal);
                    preset.setAlignment(fm.liveswitch.LayoutAlignment.BottomRight);
                    preset.setFloatMarginX(10);
                    preset.setFloatMarginY(10);
                    preset.setFloatWidthPercent(0.25);
                    preset.setFloatHeightPercent(0.25);
                    preset.setInlineMargin(0);
                    return preset;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a Google Hangouts-style layout preset. Note that this will present differently on mobile devices.
            */
            LayoutPreset.getGoogleHangouts = function () {
                if (arguments.length == 0) {
                    if (fm.liveswitch.Platform.getInstance().getIsMobile()) {
                        var preset = new fm.liveswitch.LayoutPreset();
                        preset.setMode(fm.liveswitch.LayoutMode.FloatRemote);
                        preset.setAlignment(fm.liveswitch.LayoutAlignment.BottomRight);
                        preset.setFloatMarginX(0);
                        preset.setFloatMarginY(10);
                        preset.setFloatWidthPercent(0.25);
                        preset.setFloatHeightPercent(0.25);
                        preset.setInlineMargin(5);
                        return preset;
                    }
                    var preset2 = new fm.liveswitch.LayoutPreset();
                    preset2.setMode(fm.liveswitch.LayoutMode.Block);
                    preset2.setAlignment(fm.liveswitch.LayoutAlignment.Top);
                    preset2.setBlockWidthPercent(0.666666666666667);
                    preset2.setBlockHeightPercent(0.666666666666667);
                    preset2.setInlineMargin(0);
                    return preset2;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.getSingleLayout = function (layoutWidth, layoutHeight, local) {
                if (arguments.length == 3) {
                    var layout = new fm.liveswitch.Layout();
                    layout.setLocalFrame((local ? new fm.liveswitch.LayoutFrame(0, 0, layoutWidth, layoutHeight) : null));
                    return layout;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a Skype-style layout preset. Note that this will present differently on mobile devices.
            */
            LayoutPreset.getSkype = function () {
                if (arguments.length == 0) {
                    if (fm.liveswitch.Platform.getInstance().getIsMobile()) {
                        return fm.liveswitch.LayoutPreset.getFacetime();
                    }
                    var preset = new fm.liveswitch.LayoutPreset();
                    preset.setMode(fm.liveswitch.LayoutMode.Block);
                    preset.setDirection(fm.liveswitch.LayoutDirection.Horizontal);
                    preset.setAlignment(fm.liveswitch.LayoutAlignment.Bottom);
                    preset.setBlockMarginX(10);
                    preset.setBlockMarginY(10);
                    preset.setBlockWidthPercent(0.333333333333333);
                    preset.setBlockHeightPercent(0.333333333333333);
                    preset.setInlineMargin(10);
                    return preset;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.getXMax = function (frames) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(frames.length, 0))) {
                        return frames[0].getX();
                    }
                    var x = frames[0].getX();
                    for (var i = 1; (i < frames.length); i++) {
                        var frame = frames[i];
                        if ((frame.getX() > x)) {
                            x = frame.getX();
                        }
                    }
                    return x;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.getXMid = function (frames) {
                if (arguments.length == 1) {
                    var xMin = fm.liveswitch.LayoutPreset.getXMin(frames);
                    var xMax = fm.liveswitch.LayoutPreset.getXMax(frames);
                    if ((fm.liveswitch.Global.equals(xMin, xMax))) {
                        return xMin;
                    }
                    var num3 = fm.liveswitch.LayoutPreset.divideByTwo((xMin + xMax));
                    var x = frames[0].getX();
                    var num5 = fm.liveswitch.MathAssistant.abs((num3 - x));
                    for (var i = 1; (i < frames.length); i++) {
                        var frame = frames[i];
                        var num7 = fm.liveswitch.MathAssistant.abs((num3 - frame.getX()));
                        if ((num7 < num5)) {
                            x = frame.getX();
                            num5 = num7;
                        }
                    }
                    return x;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.getXMin = function (frames) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(frames.length, 0))) {
                        return frames[0].getX();
                    }
                    var x = frames[0].getX();
                    for (var i = 1; (i < frames.length); i++) {
                        var frame = frames[i];
                        if ((frame.getX() < x)) {
                            x = frame.getX();
                        }
                    }
                    return x;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.getYMax = function (frames) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(frames.length, 0))) {
                        return frames[0].getY();
                    }
                    var y = frames[0].getY();
                    for (var i = 1; (i < frames.length); i++) {
                        var frame = frames[i];
                        if ((frame.getY() > y)) {
                            y = frame.getY();
                        }
                    }
                    return y;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.getYMid = function (frames) {
                if (arguments.length == 1) {
                    var yMin = fm.liveswitch.LayoutPreset.getYMin(frames);
                    var yMax = fm.liveswitch.LayoutPreset.getYMax(frames);
                    if ((fm.liveswitch.Global.equals(yMin, yMax))) {
                        return yMin;
                    }
                    var num3 = fm.liveswitch.LayoutPreset.divideByTwo((yMin + yMax));
                    var y = frames[0].getY();
                    var num5 = fm.liveswitch.MathAssistant.abs((num3 - y));
                    for (var i = 1; (i < frames.length); i++) {
                        var frame = frames[i];
                        var num7 = fm.liveswitch.MathAssistant.abs((num3 - frame.getY()));
                        if ((num7 < num5)) {
                            y = frame.getY();
                            num5 = num7;
                        }
                    }
                    return y;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.getYMin = function (frames) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(frames.length, 0))) {
                        return frames[0].getY();
                    }
                    var y = frames[0].getY();
                    for (var i = 1; (i < frames.length); i++) {
                        var frame = frames[i];
                        if ((frame.getY() < y)) {
                            y = frame.getY();
                        }
                    }
                    return y;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.mergeLayoutFrames = function (firstFrames, lastFrames) {
                if (arguments.length == 2) {
                    var num3 = void 0;
                    var length_4 = firstFrames.length;
                    var num2 = lastFrames.length;
                    var frameArray = new Array((length_4 + num2));
                    for (num3 = 0; (num3 < length_4); num3++) {
                        frameArray[num3] = firstFrames[num3];
                    }
                    for (num3 = 0; (num3 < num2); num3++) {
                        frameArray[(num3 + length_4)] = lastFrames[num3];
                    }
                    return frameArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.spliceLayoutFrame = function (frames, index) {
                if (arguments.length == 2) {
                    var start = (index + 1);
                    return fm.liveswitch.LayoutPreset.mergeLayoutFrames(fm.liveswitch.LayoutPreset.takeLayoutFrames(frames, 0, index), fm.liveswitch.LayoutPreset.takeLayoutFrames(frames, start, (frames.length - start)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.takeLayoutFrames = function (frames, start, length) {
                if (arguments.length == 3) {
                    var frameArray = new Array(length);
                    for (var i = 0; (i < frameArray.length); i++) {
                        frameArray[i] = frames[(start + i)];
                    }
                    return frameArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.transformFrame = function (frame, origin, layoutWidth, layoutHeight) {
                if (arguments.length == 4) {
                    var flag = false;
                    var flag2 = false;
                    var _var0 = origin;
                    if (_var0 == fm.liveswitch.LayoutOrigin.TopRight) {
                        do {
                            flag = true;
                            break;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LayoutOrigin.BottomRight) {
                        do {
                            flag = true;
                            flag2 = true;
                            break;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LayoutOrigin.BottomLeft) {
                        do {
                            flag2 = true;
                            break;
                        } while (false);
                    }
                    if (flag) {
                        frame.setX(((layoutWidth - frame.getX()) - frame.getWidth()));
                    }
                    if (flag2) {
                        frame.setY(((layoutHeight - frame.getY()) - frame.getHeight()));
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Applies a preset.
            @param preset The preset to apply.
            */
            LayoutPreset.prototype.applyPreset = function (preset) {
                if (arguments.length == 1) {
                    this.setMode(preset.getMode());
                    this.setDirection(preset.getDirection());
                    this.setAlignment(preset.getAlignment());
                    this.setFloatWidth(0);
                    this.setFloatHeight(0);
                    this.setFloatMarginX(0);
                    this.setFloatMarginY(0);
                    this.setFloatWidthPercent(0);
                    this.setFloatHeightPercent(0);
                    this.setFloatMarginXPercent(0);
                    this.setFloatMarginYPercent(0);
                    this.setBlockWidth(0);
                    this.setBlockHeight(0);
                    this.setBlockMarginX(0);
                    this.setBlockMarginY(0);
                    this.setBlockWidthPercent(0);
                    this.setBlockHeightPercent(0);
                    this.setBlockMarginXPercent(0);
                    this.setBlockMarginYPercent(0);
                    this.setInlineMargin(0);
                    if ((preset.getFloatWidth() > 0)) {
                        this.setFloatWidth(preset.getFloatWidth());
                    }
                    if ((preset.getFloatHeight() > 0)) {
                        this.setFloatHeight(preset.getFloatHeight());
                    }
                    if ((preset.getFloatMarginX() > 0)) {
                        this.setFloatMarginX(preset.getFloatMarginX());
                    }
                    if ((preset.getFloatMarginY() > 0)) {
                        this.setFloatMarginY(preset.getFloatMarginY());
                    }
                    if ((preset.getFloatWidthPercent() > 0)) {
                        this.setFloatWidthPercent(preset.getFloatWidthPercent());
                    }
                    if ((preset.getFloatHeightPercent() > 0)) {
                        this.setFloatHeightPercent(preset.getFloatHeightPercent());
                    }
                    if ((preset.getFloatMarginXPercent() > 0)) {
                        this.setFloatMarginXPercent(preset.getFloatMarginXPercent());
                    }
                    if ((preset.getFloatMarginYPercent() > 0)) {
                        this.setFloatMarginYPercent(preset.getFloatMarginYPercent());
                    }
                    if ((preset.getBlockWidth() > 0)) {
                        this.setBlockWidth(preset.getBlockWidth());
                    }
                    if ((preset.getBlockHeight() > 0)) {
                        this.setBlockHeight(preset.getBlockHeight());
                    }
                    if ((preset.getBlockMarginX() > 0)) {
                        this.setBlockMarginX(preset.getBlockMarginX());
                    }
                    if ((preset.getBlockMarginY() > 0)) {
                        this.setBlockMarginY(preset.getBlockMarginY());
                    }
                    if ((preset.getBlockWidthPercent() > 0)) {
                        this.setBlockWidthPercent(preset.getBlockWidthPercent());
                    }
                    if ((preset.getBlockHeightPercent() > 0)) {
                        this.setBlockHeightPercent(preset.getBlockHeightPercent());
                    }
                    if ((preset.getBlockMarginXPercent() > 0)) {
                        this.setBlockMarginXPercent(preset.getBlockMarginXPercent());
                    }
                    if ((preset.getBlockMarginYPercent() > 0)) {
                        this.setBlockMarginYPercent(preset.getBlockMarginYPercent());
                    }
                    if ((preset.getInlineMargin() > 0)) {
                        this.setInlineMargin(preset.getInlineMargin());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.prototype.calculateBlockFrame = function (layoutWidth, layoutHeight, marginX, marginY) {
                if (arguments.length == 4) {
                    if (((fm.liveswitch.Global.equals(this.getBlockWidth(), 0)) && (fm.liveswitch.Global.equals(this.getBlockWidthPercent(), 0)))) {
                        this.setBlockWidthPercent(0.25);
                    }
                    if (((fm.liveswitch.Global.equals(this.getBlockHeight(), 0)) && (fm.liveswitch.Global.equals(this.getBlockHeightPercent(), 0)))) {
                        this.setBlockHeightPercent(0.25);
                    }
                    var width = ((this.getBlockWidth() > 0) ? this.getBlockWidth() : (layoutWidth * this.getBlockWidthPercent()));
                    var height = ((this.getBlockHeight() > 0) ? this.getBlockHeight() : (layoutHeight * this.getBlockHeightPercent()));
                    marginX.setValue(((this.getBlockMarginX() > 0) ? this.getBlockMarginX() : (layoutWidth * this.getBlockMarginXPercent())));
                    marginY.setValue(((this.getBlockMarginY() > 0) ? this.getBlockMarginY() : (layoutHeight * this.getBlockMarginYPercent())));
                    var x = 0;
                    var _var0 = this.getAlignment();
                    if (_var0 == fm.liveswitch.LayoutAlignment.Top || _var0 == fm.liveswitch.LayoutAlignment.Center || _var0 == fm.liveswitch.LayoutAlignment.Bottom) {
                        do {
                            x = fm.liveswitch.LayoutPreset.divideByTwo((layoutWidth - width));
                            break;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LayoutAlignment.TopRight || _var0 == fm.liveswitch.LayoutAlignment.Right || _var0 == fm.liveswitch.LayoutAlignment.BottomRight) {
                        do {
                            x = (layoutWidth - width);
                            break;
                        } while (false);
                    }
                    else {
                        do {
                            x = 0;
                            break;
                        } while (false);
                    }
                    var y = 0;
                    var _var1 = this.getAlignment();
                    if (_var1 == fm.liveswitch.LayoutAlignment.Left || _var1 == fm.liveswitch.LayoutAlignment.Center || _var1 == fm.liveswitch.LayoutAlignment.Right) {
                        do {
                            y = fm.liveswitch.LayoutPreset.divideByTwo((layoutHeight - height));
                            break;
                        } while (false);
                    }
                    else if (_var1 == fm.liveswitch.LayoutAlignment.BottomLeft || _var1 == fm.liveswitch.LayoutAlignment.Bottom || _var1 == fm.liveswitch.LayoutAlignment.BottomRight) {
                        do {
                            y = (layoutHeight - height);
                            break;
                        } while (false);
                    }
                    else {
                        do {
                            y = 0;
                            break;
                        } while (false);
                    }
                    return new fm.liveswitch.LayoutFrame(x, y, width, height);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.prototype.calculateFillFrame = function (layoutWidth, layoutHeight) {
                if (arguments.length == 2) {
                    return new fm.liveswitch.LayoutFrame(0, 0, layoutWidth, layoutHeight);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.prototype.calculateFloatFrame = function (layoutWidth, layoutHeight) {
                if (arguments.length == 2) {
                    return this.calculateFloatFrames(layoutWidth, layoutHeight, 1)[0];
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.prototype.calculateFloatFrames = function (layoutWidth, layoutHeight, count) {
                if (arguments.length == 3) {
                    if (((fm.liveswitch.Global.equals(this.getFloatWidth(), 0)) && (fm.liveswitch.Global.equals(this.getFloatWidthPercent(), 0)))) {
                        this.setFloatWidthPercent(0.25);
                    }
                    if (((fm.liveswitch.Global.equals(this.getFloatHeight(), 0)) && (fm.liveswitch.Global.equals(this.getFloatHeightPercent(), 0)))) {
                        this.setFloatHeightPercent(0.25);
                    }
                    var num = ((this.getFloatWidth() > 0) ? this.getFloatWidth() : (layoutWidth * this.getFloatWidthPercent()));
                    var num2 = ((this.getFloatHeight() > 0) ? this.getFloatHeight() : (layoutHeight * this.getFloatHeightPercent()));
                    var num3 = ((this.getFloatMarginX() > 0) ? this.getFloatMarginX() : (layoutWidth * this.getFloatMarginXPercent()));
                    var num4 = ((this.getFloatMarginY() > 0) ? this.getFloatMarginY() : (layoutHeight * this.getFloatMarginYPercent()));
                    if ((fm.liveswitch.Global.equals(this.getDirection(), fm.liveswitch.LayoutDirection.Horizontal))) {
                        num = fm.liveswitch.MathAssistant.min(layoutWidth, (num * count));
                    }
                    else {
                        num2 = fm.liveswitch.MathAssistant.min(layoutHeight, (num2 * count));
                    }
                    var frameArray = this.calculateInlineFrames(num, num2, count, 0, 0);
                    var _var0 = this.getAlignment();
                    if (_var0 == fm.liveswitch.LayoutAlignment.TopLeft || _var0 == fm.liveswitch.LayoutAlignment.Top || _var0 == fm.liveswitch.LayoutAlignment.TopRight) {
                        do {
                            for (var _i = 0, frameArray_1 = frameArray; _i < frameArray_1.length; _i++) {
                                var frame = frameArray_1[_i];
                                frame.setY((frame.getY() + num4));
                            }
                            break;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LayoutAlignment.Left || _var0 == fm.liveswitch.LayoutAlignment.Center || _var0 == fm.liveswitch.LayoutAlignment.Right) {
                        do {
                            for (var _a = 0, frameArray_2 = frameArray; _a < frameArray_2.length; _a++) {
                                var frame = frameArray_2[_a];
                                frame.setY((frame.getY() + fm.liveswitch.LayoutPreset.divideByTwo((layoutHeight - num2))));
                            }
                            break;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LayoutAlignment.BottomLeft || _var0 == fm.liveswitch.LayoutAlignment.Bottom || _var0 == fm.liveswitch.LayoutAlignment.BottomRight) {
                        do {
                            for (var _b = 0, frameArray_3 = frameArray; _b < frameArray_3.length; _b++) {
                                var frame = frameArray_3[_b];
                                frame.setY((frame.getY() + ((layoutHeight - num2) - num4)));
                            }
                            break;
                        } while (false);
                    }
                    var _var1 = this.getAlignment();
                    if (_var1 == fm.liveswitch.LayoutAlignment.TopLeft || _var1 == fm.liveswitch.LayoutAlignment.Left || _var1 == fm.liveswitch.LayoutAlignment.BottomLeft) {
                        do {
                            for (var _c = 0, frameArray_4 = frameArray; _c < frameArray_4.length; _c++) {
                                var frame = frameArray_4[_c];
                                frame.setX((frame.getX() + num3));
                            }
                            return frameArray;
                        } while (false);
                    }
                    else if (_var1 == fm.liveswitch.LayoutAlignment.Top || _var1 == fm.liveswitch.LayoutAlignment.Center || _var1 == fm.liveswitch.LayoutAlignment.Bottom) {
                        do {
                            for (var _d = 0, frameArray_5 = frameArray; _d < frameArray_5.length; _d++) {
                                var frame = frameArray_5[_d];
                                frame.setX((frame.getX() + fm.liveswitch.LayoutPreset.divideByTwo((layoutWidth - num))));
                            }
                            return frameArray;
                        } while (false);
                    }
                    else if (_var1 == fm.liveswitch.LayoutAlignment.TopRight || _var1 == fm.liveswitch.LayoutAlignment.Right || _var1 == fm.liveswitch.LayoutAlignment.BottomRight) {
                        do {
                            for (var _e = 0, frameArray_6 = frameArray; _e < frameArray_6.length; _e++) {
                                var frame = frameArray_6[_e];
                                frame.setX((frame.getX() + ((layoutWidth - num) - num3)));
                            }
                            return frameArray;
                        } while (false);
                    }
                    return frameArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.prototype.calculateInlineFrame = function (cellX, cellY, cellWidth, cellHeight) {
                if (arguments.length == 4) {
                    var num = fm.liveswitch.LayoutPreset.divideByTwo(this.getInlineMargin());
                    var x = (cellX - num);
                    var y = (cellY - num);
                    var width = (cellWidth - this.getInlineMargin());
                    return new fm.liveswitch.LayoutFrame(x, y, width, (cellHeight - this.getInlineMargin()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.prototype.calculateInlineFrames = function (layoutWidth, layoutHeight, count, baseX, baseY) {
                if (arguments.length == 5) {
                    var num6 = void 0;
                    var num7 = void 0;
                    var num8 = void 0;
                    var num9 = void 0;
                    var num10 = void 0;
                    var num12 = void 0;
                    var num13 = void 0;
                    var num14 = void 0;
                    var num15 = void 0;
                    var num16 = void 0;
                    var num17 = void 0;
                    var frame = void 0;
                    var list = new Array();
                    var table = fm.liveswitch.LayoutPreset.calculateTable((layoutWidth + this.getInlineMargin()), (layoutHeight + this.getInlineMargin()), count);
                    var columnCount = table.getColumnCount();
                    var rowCount = table.getRowCount();
                    var cellWidth = table.getCellWidth();
                    var cellHeight = table.getCellHeight();
                    var num5 = fm.liveswitch.LayoutPreset.divideByTwo(this.getInlineMargin());
                    if ((fm.liveswitch.Global.equals(this.getDirection(), fm.liveswitch.LayoutDirection.Horizontal))) {
                        num6 = 0;
                        num7 = (baseY + num5);
                        num8 = ((layoutHeight - (rowCount * cellHeight)) + this.getInlineMargin());
                        num9 = 0;
                        while ((num9 < rowCount)) {
                            num10 = ((num9 < num8) ? 1 : 0);
                            var num11 = columnCount;
                            if ((fm.liveswitch.Global.equals(num9, (rowCount - 1)))) {
                                num11 = (count - num6);
                            }
                            num12 = (baseX + num5);
                            if (((fm.liveswitch.Global.equals(num9, (rowCount - 1))) && (rowCount > 1))) {
                                num13 = (num12 - num5);
                                num14 = (num7 - num5);
                                fm.liveswitch.ArrayExtensions.addRange(list, this.calculateInlineFrames((baseX + layoutWidth), ((baseY + layoutHeight) - num14), num11, num13, num14));
                            }
                            else {
                                num15 = ((layoutWidth - (num11 * cellWidth)) + this.getInlineMargin());
                                num16 = 0;
                                while ((num16 < num11)) {
                                    num17 = ((num16 < num15) ? 1 : 0);
                                    frame = this.calculateInlineFrame(num12, num7, (cellWidth + num17), (cellHeight + num10));
                                    fm.liveswitch.ArrayExtensions.add(list, frame);
                                    num12 = (num12 + (cellWidth + num17));
                                    num16++;
                                    num6++;
                                }
                            }
                            num7 = (num7 + (cellHeight + num10));
                            num9++;
                        }
                    }
                    else {
                        num6 = 0;
                        num12 = (baseX + num5);
                        num15 = ((layoutWidth - (columnCount * cellWidth)) + this.getInlineMargin());
                        for (num16 = 0; (num16 < columnCount); num16++) {
                            num17 = ((num16 < num15) ? 1 : 0);
                            var num18 = rowCount;
                            if ((fm.liveswitch.Global.equals(num16, (columnCount - 1)))) {
                                num18 = (count - num6);
                            }
                            num7 = (baseY + num5);
                            if (((fm.liveswitch.Global.equals(num16, (columnCount - 1))) && (columnCount > 1))) {
                                num13 = (num12 - num5);
                                num14 = (num7 - num5);
                                fm.liveswitch.ArrayExtensions.addRange(list, this.calculateInlineFrames(((baseX + layoutWidth) - num13), (baseY + layoutHeight), num18, num13, num14));
                            }
                            else {
                                num8 = ((layoutHeight - (num18 * cellHeight)) + this.getInlineMargin());
                                num9 = 0;
                                while ((num9 < num18)) {
                                    num10 = ((num9 < num8) ? 1 : 0);
                                    frame = this.calculateInlineFrame(num12, num7, (cellWidth + num17), (cellHeight + num10));
                                    fm.liveswitch.ArrayExtensions.add(list, frame);
                                    num7 = (num7 + (cellHeight + num10));
                                    num9++;
                                    num6++;
                                }
                            }
                            num12 = (num12 + (cellWidth + num17));
                        }
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.prototype.calculateInlineOverflowFrames = function (layoutWidth, layoutHeight, baseX, baseY, localVideoSize, remoteVideoSizes) {
                if (arguments.length == 6) {
                    var frame = void 0;
                    var frame2 = void 0;
                    var list = new Array();
                    if ((fm.liveswitch.Global.equals(this.getDirection(), fm.liveswitch.LayoutDirection.Horizontal))) {
                        var baseCoordinate = baseX;
                        if ((!fm.liveswitch.Global.equals(localVideoSize, null))) {
                            frame = fm.liveswitch.LayoutPreset.calculateInlineOverflowFrame(baseCoordinate, layoutHeight, localVideoSize, this.getDirection());
                            baseCoordinate = (baseCoordinate + frame.getWidth());
                            fm.liveswitch.ArrayExtensions.add(list, frame);
                        }
                        if ((!fm.liveswitch.Global.equals(remoteVideoSizes, null))) {
                            for (var _i = 0, remoteVideoSizes_1 = remoteVideoSizes; _i < remoteVideoSizes_1.length; _i++) {
                                var size = remoteVideoSizes_1[_i];
                                frame2 = fm.liveswitch.LayoutPreset.calculateInlineOverflowFrame(baseCoordinate, layoutHeight, size, this.getDirection());
                                baseCoordinate = (baseCoordinate + frame2.getWidth());
                                fm.liveswitch.ArrayExtensions.add(list, frame2);
                            }
                        }
                    }
                    else {
                        var num2 = baseY;
                        if ((!fm.liveswitch.Global.equals(localVideoSize, null))) {
                            frame = fm.liveswitch.LayoutPreset.calculateInlineOverflowFrame(num2, layoutWidth, localVideoSize, this.getDirection());
                            num2 = (num2 + frame.getHeight());
                            fm.liveswitch.ArrayExtensions.add(list, frame);
                        }
                        if ((!fm.liveswitch.Global.equals(remoteVideoSizes, null))) {
                            for (var _a = 0, remoteVideoSizes_2 = remoteVideoSizes; _a < remoteVideoSizes_2.length; _a++) {
                                var size = remoteVideoSizes_2[_a];
                                frame2 = fm.liveswitch.LayoutPreset.calculateInlineOverflowFrame(num2, layoutWidth, size, this.getDirection());
                                num2 = (num2 + frame2.getHeight());
                                fm.liveswitch.ArrayExtensions.add(list, frame2);
                            }
                        }
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            LayoutPreset.prototype.calculateLayout = function () {
                if (arguments.length == 7) {
                    var layoutWidth = arguments[0];
                    var layoutHeight = arguments[1];
                    var local = arguments[2];
                    var remoteCount = arguments[3];
                    var origin_1 = arguments[4];
                    var localVideoSize = arguments[5];
                    var remoteVideoSizes = arguments[6];
                    if ((layoutWidth < 0)) {
                        layoutWidth = 0;
                    }
                    if ((layoutHeight < 0)) {
                        layoutHeight = 0;
                    }
                    var layout = null;
                    if ((fm.liveswitch.Global.equals(this.getMode(), fm.liveswitch.LayoutMode.FloatLocal))) {
                        layout = this.getFloatLocalLayout(layoutWidth, layoutHeight, local, remoteCount, origin_1);
                    }
                    else {
                        if ((fm.liveswitch.Global.equals(this.getMode(), fm.liveswitch.LayoutMode.FloatRemote))) {
                            layout = this.getFloatRemoteLayout(layoutWidth, layoutHeight, local, remoteCount, origin_1);
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(this.getMode(), fm.liveswitch.LayoutMode.Block))) {
                                layout = this.getBlockLayout(layoutWidth, layoutHeight, local, remoteCount, origin_1);
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(this.getMode(), fm.liveswitch.LayoutMode.Inline))) {
                                    layout = this.getInlineLayout(layoutWidth, layoutHeight, local, remoteCount, origin_1);
                                }
                                else {
                                    if ((!fm.liveswitch.Global.equals(this.getMode(), fm.liveswitch.LayoutMode.InlineOverflow))) {
                                        throw new fm.liveswitch.Exception("Unrecognized layout mode.");
                                    }
                                    layout = this.getInlineOverflowLayout(layoutWidth, layoutHeight, origin_1, localVideoSize, remoteVideoSizes);
                                }
                            }
                        }
                    }
                    fm.liveswitch.LayoutPreset.transformFrame(layout.getLocalFrame(), origin_1, layoutWidth, layoutHeight);
                    for (var _i = 0, _a = layout.getRemoteFrames(); _i < _a.length; _i++) {
                        var frame = _a[_i];
                        fm.liveswitch.LayoutPreset.transformFrame(frame, origin_1, layoutWidth, layoutHeight);
                    }
                    return layout;
                }
                else if (arguments.length == 4) {
                    var layoutWidth = arguments[0];
                    var layoutHeight = arguments[1];
                    var remoteCount = arguments[2];
                    var origin_2 = arguments[3];
                    return this.calculateLayout(layoutWidth, layoutHeight, true, remoteCount, origin_2, null, null);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Copies this preset's properties to another preset.
            @param preset The target preset.
            */
            LayoutPreset.prototype.copyToPreset = function (preset) {
                if (arguments.length == 1) {
                    preset.setMode(this.getMode());
                    preset.setDirection(this.getDirection());
                    preset.setAlignment(this.getAlignment());
                    preset.setFloatWidth(0);
                    preset.setFloatHeight(0);
                    preset.setFloatMarginX(0);
                    preset.setFloatMarginY(0);
                    preset.setFloatWidthPercent(0);
                    preset.setFloatHeightPercent(0);
                    preset.setFloatMarginXPercent(0);
                    preset.setFloatMarginYPercent(0);
                    preset.setBlockWidth(0);
                    preset.setBlockHeight(0);
                    preset.setBlockMarginX(0);
                    preset.setBlockMarginY(0);
                    preset.setBlockWidthPercent(0);
                    preset.setBlockHeightPercent(0);
                    preset.setBlockMarginXPercent(0);
                    preset.setBlockMarginYPercent(0);
                    preset.setInlineMargin(0);
                    if ((this.getFloatWidth() > 0)) {
                        preset.setFloatWidth(this.getFloatWidth());
                    }
                    if ((this.getFloatHeight() > 0)) {
                        preset.setFloatHeight(this.getFloatHeight());
                    }
                    if ((this.getFloatMarginX() > 0)) {
                        preset.setFloatMarginX(this.getFloatMarginX());
                    }
                    if ((this.getFloatMarginY() > 0)) {
                        preset.setFloatMarginY(this.getFloatMarginY());
                    }
                    if ((this.getFloatWidthPercent() > 0)) {
                        preset.setFloatWidthPercent(this.getFloatWidthPercent());
                    }
                    if ((this.getFloatHeightPercent() > 0)) {
                        preset.setFloatHeightPercent(this.getFloatHeightPercent());
                    }
                    if ((this.getFloatMarginXPercent() > 0)) {
                        preset.setFloatMarginXPercent(this.getFloatMarginXPercent());
                    }
                    if ((this.getFloatMarginYPercent() > 0)) {
                        preset.setFloatMarginYPercent(this.getFloatMarginYPercent());
                    }
                    if ((this.getBlockWidth() > 0)) {
                        preset.setBlockWidth(this.getBlockWidth());
                    }
                    if ((this.getBlockHeight() > 0)) {
                        preset.setBlockHeight(this.getBlockHeight());
                    }
                    if ((this.getBlockMarginX() > 0)) {
                        preset.setBlockMarginX(this.getBlockMarginX());
                    }
                    if ((this.getBlockMarginY() > 0)) {
                        preset.setBlockMarginY(this.getBlockMarginY());
                    }
                    if ((this.getBlockWidthPercent() > 0)) {
                        preset.setBlockWidthPercent(this.getBlockWidthPercent());
                    }
                    if ((this.getBlockHeightPercent() > 0)) {
                        preset.setBlockHeightPercent(this.getBlockHeightPercent());
                    }
                    if ((this.getBlockMarginXPercent() > 0)) {
                        preset.setBlockMarginXPercent(this.getBlockMarginXPercent());
                    }
                    if ((this.getBlockMarginYPercent() > 0)) {
                        preset.setBlockMarginYPercent(this.getBlockMarginYPercent());
                    }
                    if ((this.getInlineMargin() > 0)) {
                        preset.setInlineMargin(this.getInlineMargin());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the alignment of the layout. Defaults to [[fm.liveswitch.layoutAlignment.BottomRight]].
            */
            LayoutPreset.prototype.getAlignment = function () {
                if (arguments.length == 0) {
                    return this._alignment;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the height of block elements in pixels. Overrides [[fm.liveswitch.layoutPreset.blockHeightPercent]].
            */
            LayoutPreset.prototype.getBlockHeight = function () {
                if (arguments.length == 0) {
                    return this.__blockHeight;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the height of block elements as a percent of the container height between 0.0 and 1.0. Overrides [[fm.liveswitch.layoutPreset.blockHeight]].
            */
            LayoutPreset.prototype.getBlockHeightPercent = function () {
                if (arguments.length == 0) {
                    return this.__blockHeightPercent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.prototype.getBlockLayout = function (layoutWidth, layoutHeight, local, remoteCount, origin) {
                if (arguments.length == 5) {
                    var num7 = void 0;
                    var num8 = void 0;
                    var marginX = 0;
                    var marginY = 0;
                    var _var0 = new fm.liveswitch.Holder(marginX);
                    var _var1 = new fm.liveswitch.Holder(marginY);
                    var _var2 = this.calculateBlockFrame(layoutWidth, layoutHeight, _var0, _var1);
                    marginX = _var0.getValue();
                    marginY = _var1.getValue();
                    var frame = (local ? _var2 : null);
                    var list = new Array();
                    if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.Center))) {
                        var count = fm.liveswitch.LayoutPreset.divideByTwo(remoteCount);
                        var num4 = (remoteCount - count);
                        var baseX = 0;
                        var baseY = 0;
                        if ((fm.liveswitch.Global.equals(this.getDirection(), fm.liveswitch.LayoutDirection.Vertical))) {
                            num7 = ((fm.liveswitch.Global.equals(frame, null)) ? 0 : ((frame.getWidth() + marginX) + marginX));
                            layoutWidth = fm.liveswitch.LayoutPreset.divideByTwo((layoutWidth - num7));
                            baseX = (layoutWidth + num7);
                        }
                        else {
                            num8 = ((fm.liveswitch.Global.equals(frame, null)) ? 0 : ((frame.getHeight() + marginY) + marginY));
                            layoutHeight = fm.liveswitch.LayoutPreset.divideByTwo((layoutHeight - num8));
                            baseY = (layoutHeight + num8);
                        }
                        if ((count > 0)) {
                            fm.liveswitch.ArrayExtensions.addRange(list, this.calculateInlineFrames(layoutWidth, layoutHeight, count, 0, 0));
                        }
                        if ((num4 > 0)) {
                            fm.liveswitch.ArrayExtensions.addRange(list, this.calculateInlineFrames(layoutWidth, layoutHeight, num4, baseX, baseY));
                        }
                    }
                    else {
                        var num9 = 0;
                        var num10 = 0;
                        num7 = ((fm.liveswitch.Global.equals(frame, null)) ? 0 : (frame.getWidth() + marginX));
                        num8 = ((fm.liveswitch.Global.equals(frame, null)) ? 0 : (frame.getHeight() + marginY));
                        if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.Top))) {
                            num10 = num8;
                            layoutHeight = (layoutHeight - num8);
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.Bottom))) {
                                layoutHeight = (layoutHeight - num8);
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.Left))) {
                                    num9 = num7;
                                    layoutWidth = (layoutWidth - num7);
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.Right))) {
                                        layoutWidth = (layoutWidth - num7);
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(this.getDirection(), fm.liveswitch.LayoutDirection.Vertical))) {
                                            if (((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.TopLeft)) || (fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.BottomLeft)))) {
                                                num9 = num7;
                                            }
                                            layoutWidth = (layoutWidth - num7);
                                        }
                                        else {
                                            if (((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.TopLeft)) || (fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.TopRight)))) {
                                                num10 = num8;
                                            }
                                            layoutHeight = (layoutHeight - num8);
                                        }
                                    }
                                }
                            }
                        }
                        fm.liveswitch.ArrayExtensions.addRange(list, this.calculateInlineFrames(layoutWidth, layoutHeight, remoteCount, num9, num10));
                    }
                    var layout = new fm.liveswitch.Layout();
                    layout.setOrigin(origin);
                    layout.setWidth(layoutWidth);
                    layout.setHeight(layoutHeight);
                    layout.setLocalFrame(frame);
                    layout.setRemoteFrames(fm.liveswitch.ArrayExtensions.toArray(list));
                    return layout;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the X-margin between block elements and the layout edge in pixels. Overrides [[fm.liveswitch.layoutPreset.blockMarginXPercent]].
            */
            LayoutPreset.prototype.getBlockMarginX = function () {
                if (arguments.length == 0) {
                    return this.__blockMarginX;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the X-margin between block elements and the layout edge as a percent of the container width between 0.0 and 1.0. Overrides [[fm.liveswitch.layoutPreset.blockMarginX]].
            */
            LayoutPreset.prototype.getBlockMarginXPercent = function () {
                if (arguments.length == 0) {
                    return this.__blockMarginXPercent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the Y-margin between block elements and the layout edge in pixels. Overrides [[fm.liveswitch.layoutPreset.blockMarginYPercent]].
            */
            LayoutPreset.prototype.getBlockMarginY = function () {
                if (arguments.length == 0) {
                    return this.__blockMarginY;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the Y-margin between block elements and the layout edge as a percent of the container height between 0.0 and 1.0. Overrides [[fm.liveswitch.layoutPreset.blockMarginY]].
            */
            LayoutPreset.prototype.getBlockMarginYPercent = function () {
                if (arguments.length == 0) {
                    return this.__blockMarginYPercent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the width of block elements in pixels. Overrides [[fm.liveswitch.layoutPreset.blockWidthPercent]].
            */
            LayoutPreset.prototype.getBlockWidth = function () {
                if (arguments.length == 0) {
                    return this.__blockWidth;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the width of block elements as a percent of the container width between 0.0 and 1.0. Overrides [[fm.liveswitch.layoutPreset.blockWidth]].
            */
            LayoutPreset.prototype.getBlockWidthPercent = function () {
                if (arguments.length == 0) {
                    return this.__blockWidthPercent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.prototype.getBottomRowIndexes = function (frames) {
                if (arguments.length == 1) {
                    var num3 = void 0;
                    var yMax = fm.liveswitch.LayoutPreset.getYMax(frames);
                    var num2 = 0;
                    for (num3 = 0; (num3 < frames.length); num3++) {
                        if ((fm.liveswitch.Global.equals(frames[num3].getY(), yMax))) {
                            num2++;
                        }
                    }
                    var num4 = 0;
                    var numArray = new Array(num2);
                    for (num3 = 0; (num3 < frames.length); num3++) {
                        if ((fm.liveswitch.Global.equals(frames[num3].getY(), yMax))) {
                            numArray[num4++] = num3;
                        }
                    }
                    return numArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.prototype.getCenterColumnIndexes = function (frames) {
                if (arguments.length == 1) {
                    var num3 = void 0;
                    var xMid = fm.liveswitch.LayoutPreset.getXMid(frames);
                    var num2 = 0;
                    for (num3 = 0; (num3 < frames.length); num3++) {
                        if ((fm.liveswitch.Global.equals(frames[num3].getX(), xMid))) {
                            num2++;
                        }
                    }
                    var num4 = 0;
                    var numArray = new Array(num2);
                    for (num3 = 0; (num3 < frames.length); num3++) {
                        if ((fm.liveswitch.Global.equals(frames[num3].getX(), xMid))) {
                            numArray[num4++] = num3;
                        }
                    }
                    return numArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.prototype.getCenterRowIndexes = function (frames) {
                if (arguments.length == 1) {
                    var num3 = void 0;
                    var yMid = fm.liveswitch.LayoutPreset.getYMid(frames);
                    var num2 = 0;
                    for (num3 = 0; (num3 < frames.length); num3++) {
                        if ((fm.liveswitch.Global.equals(frames[num3].getY(), yMid))) {
                            num2++;
                        }
                    }
                    var num4 = 0;
                    var numArray = new Array(num2);
                    for (num3 = 0; (num3 < frames.length); num3++) {
                        if ((fm.liveswitch.Global.equals(frames[num3].getY(), yMid))) {
                            numArray[num4++] = num3;
                        }
                    }
                    return numArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the direction of the layout flow. Defaults to [[fm.liveswitch.layoutDirection.Horizontal]].
            */
            LayoutPreset.prototype.getDirection = function () {
                if (arguments.length == 0) {
                    return this._direction;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the height of floating elements in pixels. Overrides [[fm.liveswitch.layoutPreset.floatHeightPercent]].
            */
            LayoutPreset.prototype.getFloatHeight = function () {
                if (arguments.length == 0) {
                    return this.__floatHeight;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the height of floating elements as a percent of the container height between 0.0 and 1.0. Overrides [[fm.liveswitch.layoutPreset.floatHeight]].
            */
            LayoutPreset.prototype.getFloatHeightPercent = function () {
                if (arguments.length == 0) {
                    return this.__floatHeightPercent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.prototype.getFloatLocalLayout = function (layoutWidth, layoutHeight, local, remoteCount, origin) {
                if (arguments.length == 5) {
                    if ((fm.liveswitch.Global.equals(remoteCount, 0))) {
                        return fm.liveswitch.LayoutPreset.getSingleLayout(layoutWidth, layoutHeight, local);
                    }
                    var layout = new fm.liveswitch.Layout();
                    layout.setOrigin(origin);
                    layout.setWidth(layoutWidth);
                    layout.setHeight(layoutHeight);
                    layout.setLocalFrame((local ? this.calculateFloatFrame(layoutWidth, layoutHeight) : null));
                    layout.setRemoteFrames(this.calculateInlineFrames(layoutWidth, layoutHeight, remoteCount, 0, 0));
                    return layout;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the X-margin between floating elements and the layout edge in pixels. Overrides [[fm.liveswitch.layoutPreset.floatMarginXPercent]].
            */
            LayoutPreset.prototype.getFloatMarginX = function () {
                if (arguments.length == 0) {
                    return this.__floatMarginX;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the X-margin between floating elements and the layout edge as a percent of the container width between 0.0 and 1.0. Overrides [[fm.liveswitch.layoutPreset.floatMarginX]].
            */
            LayoutPreset.prototype.getFloatMarginXPercent = function () {
                if (arguments.length == 0) {
                    return this.__floatMarginXPercent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the Y-margin between floating elements and the layout edge in pixels. Overrides [[fm.liveswitch.layoutPreset.floatMarginYPercent]].
            */
            LayoutPreset.prototype.getFloatMarginY = function () {
                if (arguments.length == 0) {
                    return this.__floatMarginY;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the Y-margin between floating elements and the layout edge as a percent of the container height between 0.0 and 1.0. Overrides [[fm.liveswitch.layoutPreset.floatMarginY]].
            */
            LayoutPreset.prototype.getFloatMarginYPercent = function () {
                if (arguments.length == 0) {
                    return this.__floatMarginYPercent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.prototype.getFloatRemoteLayout = function (layoutWidth, layoutHeight, local, remoteCount, origin) {
                if (arguments.length == 5) {
                    var layout = new fm.liveswitch.Layout();
                    layout.setOrigin(origin);
                    layout.setWidth(layoutWidth);
                    layout.setHeight(layoutHeight);
                    layout.setLocalFrame((local ? this.calculateFillFrame(layoutWidth, layoutHeight) : null));
                    layout.setRemoteFrames(this.calculateFloatFrames(layoutWidth, layoutHeight, remoteCount));
                    return layout;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the width of floating elements in pixels. Overrides [[fm.liveswitch.layoutPreset.floatWidthPercent]].
            */
            LayoutPreset.prototype.getFloatWidth = function () {
                if (arguments.length == 0) {
                    return this.__floatWidth;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the width of floating elements as a percent of the container width between 0.0 and 1.0. Overrides [[fm.liveswitch.layoutPreset.floatWidth]].
            */
            LayoutPreset.prototype.getFloatWidthPercent = function () {
                if (arguments.length == 0) {
                    return this.__floatWidthPercent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.prototype.getInlineLayout = function (layoutWidth, layoutHeight, local, remoteCount, origin) {
                if (arguments.length == 5) {
                    var frames_1 = this.calculateInlineFrames(layoutWidth, layoutHeight, (remoteCount + (local ? 1 : 0)), 0, 0);
                    var index = -1;
                    if (local) {
                        if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.TopLeft))) {
                            index = 0;
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.Top))) {
                                var topRowIndexes = this.getTopRowIndexes(frames_1);
                                index = topRowIndexes[fm.liveswitch.LayoutPreset.divideByTwo(topRowIndexes.length)];
                            }
                            else {
                                var centerRowIndexes = void 0;
                                if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.TopRight))) {
                                    if ((fm.liveswitch.Global.equals(this.getDirection(), fm.liveswitch.LayoutDirection.Horizontal))) {
                                        centerRowIndexes = this.getTopRowIndexes(frames_1);
                                        index = centerRowIndexes[(centerRowIndexes.length - 1)];
                                    }
                                    else {
                                        index = this.getRightColumnIndexes(frames_1)[0];
                                    }
                                }
                                else {
                                    var leftColumnIndexes = void 0;
                                    if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.Left))) {
                                        leftColumnIndexes = this.getLeftColumnIndexes(frames_1);
                                        index = leftColumnIndexes[fm.liveswitch.LayoutPreset.divideByTwo(leftColumnIndexes.length)];
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.Center))) {
                                            if ((fm.liveswitch.Global.equals(this.getDirection(), fm.liveswitch.LayoutDirection.Horizontal))) {
                                                centerRowIndexes = this.getCenterRowIndexes(frames_1);
                                                index = centerRowIndexes[fm.liveswitch.LayoutPreset.divideByTwo(centerRowIndexes.length)];
                                            }
                                            else {
                                                leftColumnIndexes = this.getCenterColumnIndexes(frames_1);
                                                index = leftColumnIndexes[fm.liveswitch.LayoutPreset.divideByTwo(leftColumnIndexes.length)];
                                            }
                                        }
                                        else {
                                            if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.Right))) {
                                                leftColumnIndexes = this.getRightColumnIndexes(frames_1);
                                                index = leftColumnIndexes[fm.liveswitch.LayoutPreset.divideByTwo(leftColumnIndexes.length)];
                                            }
                                            else {
                                                if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.BottomLeft))) {
                                                    if ((fm.liveswitch.Global.equals(this.getDirection(), fm.liveswitch.LayoutDirection.Horizontal))) {
                                                        index = this.getBottomRowIndexes(frames_1)[0];
                                                    }
                                                    else {
                                                        leftColumnIndexes = this.getLeftColumnIndexes(frames_1);
                                                        index = leftColumnIndexes[(leftColumnIndexes.length - 1)];
                                                    }
                                                }
                                                else {
                                                    if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.Bottom))) {
                                                        centerRowIndexes = this.getBottomRowIndexes(frames_1);
                                                        index = centerRowIndexes[fm.liveswitch.LayoutPreset.divideByTwo(centerRowIndexes.length)];
                                                    }
                                                    else {
                                                        if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.BottomRight))) {
                                                            index = (frames_1.length - 1);
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    var layout = new fm.liveswitch.Layout();
                    layout.setOrigin(origin);
                    layout.setWidth(layoutWidth);
                    layout.setHeight(layoutHeight);
                    layout.setLocalFrame(((fm.liveswitch.Global.equals(index, -1)) ? null : frames_1[index]));
                    layout.setRemoteFrames(((fm.liveswitch.Global.equals(index, -1)) ? frames_1 : fm.liveswitch.LayoutPreset.spliceLayoutFrame(frames_1, index)));
                    return layout;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the size of the margin in pixels to use between inline elements.
            */
            LayoutPreset.prototype.getInlineMargin = function () {
                if (arguments.length == 0) {
                    return this._inlineMargin;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.prototype.getInlineOverflowLayout = function (layoutWidth, layoutHeight, origin, localVideoSize, remoteVideoSizes) {
                if (arguments.length == 5) {
                    var frames_4 = this.calculateInlineOverflowFrames(layoutWidth, layoutHeight, 0, 0, localVideoSize, remoteVideoSizes);
                    if ((fm.liveswitch.Global.equals(frames_4.length, 0))) {
                        var layout = new fm.liveswitch.Layout();
                        layout.setOrigin(origin);
                        layout.setWidth(layoutWidth);
                        layout.setHeight(layoutHeight);
                        layout.setLocalFrame(null);
                        layout.setRemoteFrames(new Array(0));
                        return layout;
                    }
                    var index = -1;
                    if ((!fm.liveswitch.Global.equals(localVideoSize, null))) {
                        if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.TopLeft))) {
                            index = 0;
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.Top))) {
                                var topRowIndexes = this.getTopRowIndexes(frames_4);
                                index = topRowIndexes[fm.liveswitch.LayoutPreset.divideByTwo(topRowIndexes.length)];
                            }
                            else {
                                var centerRowIndexes = void 0;
                                if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.TopRight))) {
                                    if ((fm.liveswitch.Global.equals(this.getDirection(), fm.liveswitch.LayoutDirection.Horizontal))) {
                                        centerRowIndexes = this.getTopRowIndexes(frames_4);
                                        index = centerRowIndexes[(centerRowIndexes.length - 1)];
                                    }
                                    else {
                                        index = this.getRightColumnIndexes(frames_4)[0];
                                    }
                                }
                                else {
                                    var leftColumnIndexes = void 0;
                                    if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.Left))) {
                                        leftColumnIndexes = this.getLeftColumnIndexes(frames_4);
                                        index = leftColumnIndexes[fm.liveswitch.LayoutPreset.divideByTwo(leftColumnIndexes.length)];
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.Center))) {
                                            if ((fm.liveswitch.Global.equals(this.getDirection(), fm.liveswitch.LayoutDirection.Horizontal))) {
                                                centerRowIndexes = this.getCenterRowIndexes(frames_4);
                                                index = centerRowIndexes[fm.liveswitch.LayoutPreset.divideByTwo(centerRowIndexes.length)];
                                            }
                                            else {
                                                leftColumnIndexes = this.getCenterColumnIndexes(frames_4);
                                                index = leftColumnIndexes[fm.liveswitch.LayoutPreset.divideByTwo(leftColumnIndexes.length)];
                                            }
                                        }
                                        else {
                                            if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.Right))) {
                                                leftColumnIndexes = this.getRightColumnIndexes(frames_4);
                                                index = leftColumnIndexes[fm.liveswitch.LayoutPreset.divideByTwo(leftColumnIndexes.length)];
                                            }
                                            else {
                                                if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.BottomLeft))) {
                                                    if ((fm.liveswitch.Global.equals(this.getDirection(), fm.liveswitch.LayoutDirection.Horizontal))) {
                                                        index = this.getBottomRowIndexes(frames_4)[0];
                                                    }
                                                    else {
                                                        leftColumnIndexes = this.getLeftColumnIndexes(frames_4);
                                                        index = leftColumnIndexes[(leftColumnIndexes.length - 1)];
                                                    }
                                                }
                                                else {
                                                    if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.Bottom))) {
                                                        centerRowIndexes = this.getBottomRowIndexes(frames_4);
                                                        index = centerRowIndexes[fm.liveswitch.LayoutPreset.divideByTwo(centerRowIndexes.length)];
                                                    }
                                                    else {
                                                        if ((fm.liveswitch.Global.equals(this.getAlignment(), fm.liveswitch.LayoutAlignment.BottomRight))) {
                                                            index = (frames_4.length - 1);
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if ((fm.liveswitch.Global.equals(this.getDirection(), fm.liveswitch.LayoutDirection.Horizontal))) {
                        var num2 = 0;
                        for (var _i = 0, frames_2 = frames_4; _i < frames_2.length; _i++) {
                            var frame = frames_2[_i];
                            num2 = (num2 + frame.getWidth());
                        }
                        var layout2 = new fm.liveswitch.Layout();
                        layout2.setOrigin(origin);
                        layout2.setWidth(num2);
                        layout2.setHeight(layoutHeight);
                        layout2.setLocalFrame(((fm.liveswitch.Global.equals(index, -1)) ? null : frames_4[index]));
                        layout2.setRemoteFrames(((fm.liveswitch.Global.equals(index, -1)) ? frames_4 : fm.liveswitch.LayoutPreset.spliceLayoutFrame(frames_4, index)));
                        return layout2;
                    }
                    var num3 = 0;
                    for (var _a = 0, frames_3 = frames_4; _a < frames_3.length; _a++) {
                        var frame = frames_3[_a];
                        num3 = (num3 + frame.getHeight());
                    }
                    var layout3 = new fm.liveswitch.Layout();
                    layout3.setOrigin(origin);
                    layout3.setWidth(layoutWidth);
                    layout3.setHeight(num3);
                    layout3.setLocalFrame(((fm.liveswitch.Global.equals(index, -1)) ? null : frames_4[index]));
                    layout3.setRemoteFrames(((fm.liveswitch.Global.equals(index, -1)) ? frames_4 : fm.liveswitch.LayoutPreset.spliceLayoutFrame(frames_4, index)));
                    return layout3;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.prototype.getLeftColumnIndexes = function (frames) {
                if (arguments.length == 1) {
                    var num3 = void 0;
                    var xMin = fm.liveswitch.LayoutPreset.getXMin(frames);
                    var num2 = 0;
                    for (num3 = 0; (num3 < frames.length); num3++) {
                        if ((fm.liveswitch.Global.equals(frames[num3].getX(), xMin))) {
                            num2++;
                        }
                    }
                    var num4 = 0;
                    var numArray = new Array(num2);
                    for (num3 = 0; (num3 < frames.length); num3++) {
                        if ((fm.liveswitch.Global.equals(frames[num3].getX(), xMin))) {
                            numArray[num4++] = num3;
                        }
                    }
                    return numArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the mode used by the layout engine. Defaults to [[fm.liveswitch.layoutMode.FloatLocal]].
            */
            LayoutPreset.prototype.getMode = function () {
                if (arguments.length == 0) {
                    return this._mode;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.prototype.getRightColumnIndexes = function (frames) {
                if (arguments.length == 1) {
                    var num3 = void 0;
                    var xMax = fm.liveswitch.LayoutPreset.getXMax(frames);
                    var num2 = 0;
                    for (num3 = 0; (num3 < frames.length); num3++) {
                        if ((fm.liveswitch.Global.equals(frames[num3].getX(), xMax))) {
                            num2++;
                        }
                    }
                    var num4 = 0;
                    var numArray = new Array(num2);
                    for (num3 = 0; (num3 < frames.length); num3++) {
                        if ((fm.liveswitch.Global.equals(frames[num3].getX(), xMax))) {
                            numArray[num4++] = num3;
                        }
                    }
                    return numArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutPreset.prototype.getTopRowIndexes = function (frames) {
                if (arguments.length == 1) {
                    var num3 = void 0;
                    var yMin = fm.liveswitch.LayoutPreset.getYMin(frames);
                    var num2 = 0;
                    for (num3 = 0; (num3 < frames.length); num3++) {
                        if ((fm.liveswitch.Global.equals(frames[num3].getY(), yMin))) {
                            num2++;
                        }
                    }
                    var num4 = 0;
                    var numArray = new Array(num2);
                    for (num3 = 0; (num3 < frames.length); num3++) {
                        if ((fm.liveswitch.Global.equals(frames[num3].getY(), yMin))) {
                            numArray[num4++] = num3;
                        }
                    }
                    return numArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the alignment of the layout. Defaults to [[fm.liveswitch.layoutAlignment.BottomRight]].
            */
            LayoutPreset.prototype.setAlignment = function (value) {
                if (arguments.length == 1) {
                    this._alignment = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the height of block elements in pixels. Overrides [[fm.liveswitch.layoutPreset.blockHeightPercent]].
            */
            LayoutPreset.prototype.setBlockHeight = function (value) {
                if (arguments.length == 1) {
                    this.__blockHeight = value;
                    this.__blockHeightPercent = 0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the height of block elements as a percent of the container height between 0.0 and 1.0. Overrides [[fm.liveswitch.layoutPreset.blockHeight]].
            */
            LayoutPreset.prototype.setBlockHeightPercent = function (value) {
                if (arguments.length == 1) {
                    if ((value < 0)) {
                        value = 0;
                    }
                    if ((value > 1)) {
                        value = 1;
                    }
                    this.__blockHeightPercent = value;
                    this.__blockHeight = 0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the X-margin between block elements and the layout edge in pixels. Overrides [[fm.liveswitch.layoutPreset.blockMarginXPercent]].
            */
            LayoutPreset.prototype.setBlockMarginX = function (value) {
                if (arguments.length == 1) {
                    this.__blockMarginX = value;
                    this.__blockMarginXPercent = 0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the X-margin between block elements and the layout edge as a percent of the container width between 0.0 and 1.0. Overrides [[fm.liveswitch.layoutPreset.blockMarginX]].
            */
            LayoutPreset.prototype.setBlockMarginXPercent = function (value) {
                if (arguments.length == 1) {
                    if ((value < 0)) {
                        value = 0;
                    }
                    if ((value > 1)) {
                        value = 1;
                    }
                    this.__blockMarginXPercent = value;
                    this.__blockMarginX = 0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the Y-margin between block elements and the layout edge in pixels. Overrides [[fm.liveswitch.layoutPreset.blockMarginYPercent]].
            */
            LayoutPreset.prototype.setBlockMarginY = function (value) {
                if (arguments.length == 1) {
                    this.__blockMarginY = value;
                    this.__blockMarginYPercent = 0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the Y-margin between block elements and the layout edge as a percent of the container height between 0.0 and 1.0. Overrides [[fm.liveswitch.layoutPreset.blockMarginY]].
            */
            LayoutPreset.prototype.setBlockMarginYPercent = function (value) {
                if (arguments.length == 1) {
                    if ((value < 0)) {
                        value = 0;
                    }
                    if ((value > 1)) {
                        value = 1;
                    }
                    this.__blockMarginYPercent = value;
                    this.__blockMarginY = 0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the width of block elements in pixels. Overrides [[fm.liveswitch.layoutPreset.blockWidthPercent]].
            */
            LayoutPreset.prototype.setBlockWidth = function (value) {
                if (arguments.length == 1) {
                    this.__blockWidth = value;
                    this.__blockWidthPercent = 0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the width of block elements as a percent of the container width between 0.0 and 1.0. Overrides [[fm.liveswitch.layoutPreset.blockWidth]].
            */
            LayoutPreset.prototype.setBlockWidthPercent = function (value) {
                if (arguments.length == 1) {
                    if ((value < 0)) {
                        value = 0;
                    }
                    if ((value > 1)) {
                        value = 1;
                    }
                    this.__blockWidthPercent = value;
                    this.__blockWidth = 0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the direction of the layout flow. Defaults to [[fm.liveswitch.layoutDirection.Horizontal]].
            */
            LayoutPreset.prototype.setDirection = function (value) {
                if (arguments.length == 1) {
                    this._direction = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the height of floating elements in pixels. Overrides [[fm.liveswitch.layoutPreset.floatHeightPercent]].
            */
            LayoutPreset.prototype.setFloatHeight = function (value) {
                if (arguments.length == 1) {
                    this.__floatHeight = value;
                    this.__floatHeightPercent = 0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the height of floating elements as a percent of the container height between 0.0 and 1.0. Overrides [[fm.liveswitch.layoutPreset.floatHeight]].
            */
            LayoutPreset.prototype.setFloatHeightPercent = function (value) {
                if (arguments.length == 1) {
                    if ((value < 0)) {
                        value = 0;
                    }
                    if ((value > 1)) {
                        value = 1;
                    }
                    this.__floatHeightPercent = value;
                    this.__floatHeight = 0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the X-margin between floating elements and the layout edge in pixels. Overrides [[fm.liveswitch.layoutPreset.floatMarginXPercent]].
            */
            LayoutPreset.prototype.setFloatMarginX = function (value) {
                if (arguments.length == 1) {
                    this.__floatMarginX = value;
                    this.__floatMarginXPercent = 0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the X-margin between floating elements and the layout edge as a percent of the container width between 0.0 and 1.0. Overrides [[fm.liveswitch.layoutPreset.floatMarginX]].
            */
            LayoutPreset.prototype.setFloatMarginXPercent = function (value) {
                if (arguments.length == 1) {
                    if ((value < 0)) {
                        value = 0;
                    }
                    if ((value > 1)) {
                        value = 1;
                    }
                    this.__floatMarginXPercent = value;
                    this.__floatMarginX = 0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the Y-margin between floating elements and the layout edge in pixels. Overrides [[fm.liveswitch.layoutPreset.floatMarginYPercent]].
            */
            LayoutPreset.prototype.setFloatMarginY = function (value) {
                if (arguments.length == 1) {
                    this.__floatMarginY = value;
                    this.__floatMarginYPercent = 0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the Y-margin between floating elements and the layout edge as a percent of the container height between 0.0 and 1.0. Overrides [[fm.liveswitch.layoutPreset.floatMarginY]].
            */
            LayoutPreset.prototype.setFloatMarginYPercent = function (value) {
                if (arguments.length == 1) {
                    if ((value < 0)) {
                        value = 0;
                    }
                    if ((value > 1)) {
                        value = 1;
                    }
                    this.__floatMarginYPercent = value;
                    this.__floatMarginY = 0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the width of floating elements in pixels. Overrides [[fm.liveswitch.layoutPreset.floatWidthPercent]].
            */
            LayoutPreset.prototype.setFloatWidth = function (value) {
                if (arguments.length == 1) {
                    this.__floatWidth = value;
                    this.__floatWidthPercent = 0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the width of floating elements as a percent of the container width between 0.0 and 1.0. Overrides [[fm.liveswitch.layoutPreset.floatWidth]].
            */
            LayoutPreset.prototype.setFloatWidthPercent = function (value) {
                if (arguments.length == 1) {
                    if ((value < 0)) {
                        value = 0;
                    }
                    if ((value > 1)) {
                        value = 1;
                    }
                    this.__floatWidthPercent = value;
                    this.__floatWidth = 0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the size of the margin in pixels to use between inline elements.
            */
            LayoutPreset.prototype.setInlineMargin = function (value) {
                if (arguments.length == 1) {
                    this._inlineMargin = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the mode used by the layout engine. Defaults to [[fm.liveswitch.layoutMode.FloatLocal]].
            */
            LayoutPreset.prototype.setMode = function (value) {
                if (arguments.length == 1) {
                    this._mode = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return LayoutPreset;
        }(fm.liveswitch.Dynamic));
        liveswitch.LayoutPreset = LayoutPreset;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="LayoutPreset.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A class that supplies simple video frame layout management.
        */
        var LayoutManager = /** @class */ (function (_super) {
            __extends(LayoutManager, _super);
            function LayoutManager() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    // chained constructor: LayoutManager.call(this, null);
                    __arguments = new Array(1);
                    __arguments[0] = null;
                    {
                        var preset = __arguments[0];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchLayoutManagerInit();
                        _this._remoteViewsTable = {};
                        _this._remoteViewsLock = new Object();
                        _this._localView = null;
                        _this._inBatch = false;
                        if ((fm.liveswitch.Global.equals(preset, null))) {
                            preset = fm.liveswitch.LayoutPreset.getFacetime();
                        }
                        preset.copyToPreset(_this);
                        _this.setLayoutOrigin(fm.liveswitch.LayoutOrigin.TopLeft);
                    }
                }
                else if (__arguments.length == 1) {
                    var preset = __arguments[0];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchLayoutManagerInit();
                    _this._remoteViewsTable = {};
                    _this._remoteViewsLock = new Object();
                    _this._localView = null;
                    _this._inBatch = false;
                    if ((fm.liveswitch.Global.equals(preset, null))) {
                        preset = fm.liveswitch.LayoutPreset.getFacetime();
                    }
                    preset.copyToPreset(_this);
                    _this.setLayoutOrigin(fm.liveswitch.LayoutOrigin.TopLeft);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            LayoutManager.prototype.getTypeString = function () {
                return '[fm.liveswitch.LayoutManager]' + ',' + _super.prototype.getTypeString.call(this);
            };
            LayoutManager.prototype.fmliveswitchLayoutManagerInit = function () {
                var _this = this;
                this.__onLayout = [];
                this._inBatch = false;
                this._onLayout = function (p0) { for (var _i = 0, _a = _this.__onLayout; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
            };
            /**
            Adds a handler that is raised when a layout is calculated.
            */
            LayoutManager.prototype.addOnLayout = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onLayout, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds remote media to the layout.
            @param remoteMedia The remote media.
            @return `true` if successful; otherwise, `false`.
                
            */
            LayoutManager.prototype.addRemoteMedia = function (remoteMedia) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(remoteMedia, null))) {
                        return false;
                    }
                    return this.addRemoteView(remoteMedia.getId(), remoteMedia.getView());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a remote view to the layout.
            @param idValue The remote view ID.
            @param view The remote view.
            @return `true` if successful; otherwise, `false`. Check the logs for additional information.
            */
            LayoutManager.prototype.addRemoteView = function (idValue, view) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(idValue, null))) {
                        fm.liveswitch.Log.warn("Could not add remote view. The ID cannot be null.");
                        return false;
                    }
                    if ((fm.liveswitch.Global.equals(view, null))) {
                        fm.liveswitch.Log.warn("Could not add remote view. The view cannot be null.");
                        return false;
                    }
                    try {
                        this.dispatchToMainThread(this.addRemoteViewUI.bind(this), idValue, view);
                    }
                    catch (exception) {
                        fm.liveswitch.Log.error("Could not add remote view.", exception);
                    }
                    finally {
                    }
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds remote views to the layout.
            @param ids The remote view IDs.
            @param views The remote views.
            @return `true` if successful; otherwise, `false`. Check the logs for additional information.
            */
            LayoutManager.prototype.addRemoteViews = function (ids, views) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(ids, null))) {
                        fm.liveswitch.Log.warn("Could not add remote views. The IDs cannot be null.");
                        return false;
                    }
                    if ((fm.liveswitch.Global.equals(views, null))) {
                        fm.liveswitch.Log.warn("Could not add remote views. The views cannot be null.");
                        return false;
                    }
                    if ((!fm.liveswitch.Global.equals(ids.length, views.length))) {
                        fm.liveswitch.Log.warn("Could not add remote views. The number of IDs and views must match.");
                        return false;
                    }
                    try {
                        this.dispatchToMainThread(this.addRemoteViewsUI.bind(this), ids, views);
                    }
                    catch (exception) {
                        fm.liveswitch.Log.error("Could not add remote views.", exception);
                    }
                    finally {
                    }
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutManager.prototype.addRemoteViewsUI = function (idsObj, viewsObj) {
                if (arguments.length == 2) {
                    var strArray = idsObj;
                    var localArray = viewsObj;
                    this._inBatch = true;
                    for (var i = 0; (i < strArray.length); i++) {
                        this.addRemoteViewUI(strArray[i], localArray[i]);
                    }
                    this._inBatch = false;
                    this.layout();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutManager.prototype.addRemoteViewUI = function (idObj, viewObj) {
                if (arguments.length == 2) {
                    var idValue = idObj;
                    var item = viewObj;
                    var list = new Array();
                    fm.liveswitch.ArrayExtensions.add(list, item);
                    var remoteViewsInternal = this.getRemoteViewsInternal(idValue);
                    if ((!fm.liveswitch.Global.equals(remoteViewsInternal, null))) {
                        fm.liveswitch.ArrayExtensions.addRange(list, remoteViewsInternal);
                    }
                    this.addView(item);
                    this._remoteViewsTable[idValue] = list;
                    if (!this._inBatch) {
                        this.layout();
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the local view.
            @return The local view.
            */
            LayoutManager.prototype.doGetLocalView = function () {
                if (arguments.length == 0) {
                    return this._localView;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote views for a given remote view ID.
            @param idValue The remote view ID.
            @return The remote views.
            */
            LayoutManager.prototype.doGetRemoteViews = function (idValue) {
                if (arguments.length == 1) {
                    var list = null;
                    var _var0 = new fm.liveswitch.Holder(list);
                    var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this._remoteViewsTable, idValue, _var0);
                    list = _var0.getValue();
                    if (!_var1) {
                        list = null;
                    }
                    return list;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote view IDs.
            @return The remote view IDs.
            */
            LayoutManager.prototype.doGetRemoteViewsIds = function () {
                if (arguments.length == 0) {
                    var list = new Array();
                    for (var _i = 0, _a = fm.liveswitch.HashExtensions.getKeys(this._remoteViewsTable); _i < _a.length; _i++) {
                        var str = _a[_i];
                        fm.liveswitch.ArrayExtensions.add(list, str);
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutManager.prototype.doSwapRemoteView = function (idToRemove, viewToRemove, idToAdd, viewToAdd) {
                var _this = this;
                if (arguments.length == 4) {
                    var action = null;
                    try {
                        if ((fm.liveswitch.Global.equals(action, null))) {
                            action = function (unused1, unused2) {
                                if ((!fm.liveswitch.Global.equals(viewToRemove, null))) {
                                    _this.removeRemoteViewUI(idToRemove, viewToRemove);
                                }
                                _this.addRemoteViewUI(idToAdd, viewToAdd);
                            };
                        }
                        this.dispatchToMainThread(action, null, null);
                    }
                    catch (exception) {
                        fm.liveswitch.Log.error("Could not swap remote view.", exception);
                    }
                    finally {
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutManager.prototype.doSwapRemoteViews = function (idsToRemove, viewsToRemove, idsToAdd, viewsToAdd) {
                var _this = this;
                if (arguments.length == 4) {
                    var action = null;
                    try {
                        if ((fm.liveswitch.Global.equals(action, null))) {
                            action = function (unused1, unused2) {
                                _this.removeRemoteViewsUI(idsToRemove, viewsToRemove);
                                _this.addRemoteViewsUI(idsToAdd, viewsToAdd);
                            };
                        }
                        this.dispatchToMainThread(action, null, null);
                    }
                    catch (exception) {
                        fm.liveswitch.Log.error("Could not swap remote views.", exception);
                    }
                    finally {
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            LayoutManager.prototype.getLayout = function () {
                if (arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isBoolean(arguments[2])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[3]) || fm.liveswitch.Util.isNumber(arguments[3]))) {
                    var layoutWidth = arguments[0];
                    var layoutHeight = arguments[1];
                    var local = arguments[2];
                    var remoteCount = arguments[3];
                    return this.getLayout(layoutWidth, layoutHeight, local, remoteCount, null, null, null);
                }
                else if (arguments.length == 5) {
                    var layoutWidth = arguments[0];
                    var layoutHeight = arguments[1];
                    var local = arguments[2];
                    var remoteCount = arguments[3];
                    var remoteViewIds = arguments[4];
                    return this.getLayout(layoutWidth, layoutHeight, local, remoteCount, remoteViewIds, null, null);
                }
                else if (arguments.length == 7) {
                    var layoutWidth = arguments[0];
                    var layoutHeight = arguments[1];
                    var local = arguments[2];
                    var remoteCount = arguments[3];
                    var remoteViewIds = arguments[4];
                    var localVideoSize = arguments[5];
                    var remoteVideoSizes = arguments[6];
                    var p = _super.prototype.calculateLayout.call(this, layoutWidth, layoutHeight, local, remoteCount, this.getLayoutOrigin(), localVideoSize, remoteVideoSizes);
                    if ((!fm.liveswitch.Global.equals(remoteViewIds, null))) {
                        var remoteFrames = p.getRemoteFrames();
                        for (var i = 0; (i < remoteFrames.length); i++) {
                            var frame = remoteFrames[i];
                            frame.setViewId(remoteViewIds[i]);
                        }
                    }
                    var onLayout = this._onLayout;
                    if ((!fm.liveswitch.Global.equals(onLayout, null))) {
                        try {
                            onLayout(p);
                        }
                        catch (exception) {
                            fm.liveswitch.Unhandled.logException(exception, "LayoutManager -> OnLayout");
                        }
                        finally {
                        }
                    }
                    return p;
                }
                else if (arguments.length == 3) {
                    var layoutWidth = arguments[0];
                    var layoutHeight = arguments[1];
                    var remoteCount = arguments[2];
                    return this.getLayout(layoutWidth, layoutHeight, true, remoteCount, null, null, null);
                }
                else if (arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isNumber(arguments[2])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[3]) || (fm.liveswitch.Util.isArray(arguments[3]) && (arguments[3].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[3][0]) || fm.liveswitch.Util.isString(arguments[3][0])))))) {
                    var layoutWidth = arguments[0];
                    var layoutHeight = arguments[1];
                    var remoteCount = arguments[2];
                    var remoteViewIds = arguments[3];
                    return this.getLayout(layoutWidth, layoutHeight, true, remoteCount, remoteViewIds, null, null);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the layout origin. Defaults to TopLeft.
            */
            LayoutManager.prototype.getLayoutOrigin = function () {
                if (arguments.length == 0) {
                    return this._layoutOrigin;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the local view from the layout.
            @return The local view.
            */
            LayoutManager.prototype.getLocalView = function () {
                if (arguments.length == 0) {
                    return this.doGetLocalView();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutManager.prototype.getNewestRemoteView = function (idValue) {
                if (arguments.length == 1) {
                    var remoteViewsInternal = this.getRemoteViewsInternal(idValue);
                    if ((fm.liveswitch.Global.equals(remoteViewsInternal, null))) {
                        return null;
                    }
                    return remoteViewsInternal[0];
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutManager.prototype.getOldestRemoteView = function (idValue) {
                if (arguments.length == 1) {
                    var remoteViewsInternal = this.getRemoteViewsInternal(idValue);
                    if ((fm.liveswitch.Global.equals(remoteViewsInternal, null))) {
                        return null;
                    }
                    return remoteViewsInternal[(fm.liveswitch.ArrayExtensions.getCount(remoteViewsInternal) - 1)];
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a remote view from the layout.
            @param idValue The remote view ID.
            @return The remote view.
            */
            LayoutManager.prototype.getRemoteView = function (idValue) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(idValue, null))) {
                        return null;
                    }
                    return this.getNewestRemoteView(idValue);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the IDs of the remote views in the layout.
            @return The remote view IDs.
            */
            LayoutManager.prototype.getRemoteViewIds = function () {
                if (arguments.length == 0) {
                    return this.doGetRemoteViewsIds();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            LayoutManager.prototype.getRemoteViews = function () {
                if (arguments.length == 0) {
                    return this.getRemoteViews(this.getRemoteViewIds());
                }
                else if (arguments.length == 1) {
                    var ids = arguments[0];
                    if ((fm.liveswitch.Global.equals(ids, null))) {
                        throw new fm.liveswitch.Exception("Could not get remote views. The IDs cannot be null.");
                    }
                    var list = new Array();
                    for (var _i = 0, ids_1 = ids; _i < ids_1.length; _i++) {
                        var str = ids_1[_i];
                        fm.liveswitch.ArrayExtensions.add(list, this.getRemoteView(str));
                    }
                    return list;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutManager.prototype.getRemoteViewsInternal = function (idValue) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(idValue, null))) {
                        throw new fm.liveswitch.Exception("The ID cannot be null.");
                    }
                    return this.doGetRemoteViews(idValue);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Positions the local and remote views within the layout after dispatching to the main thread.
            */
            LayoutManager.prototype.layoutOnMainThread = function () {
                if (arguments.length == 0) {
                    this.dispatchToMainThread(this.layoutOnMainThreadUI.bind(this), null, null);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutManager.prototype.layoutOnMainThreadUI = function (unused1, unused2) {
                if (arguments.length == 2) {
                    this.layout();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when a layout is calculated.
            */
            LayoutManager.prototype.removeOnLayout = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onLayout, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes remote media from the layout.
            @param remoteMedia The remote media.
            @return `true` if successful; otherwise, `false`.
                
            */
            LayoutManager.prototype.removeRemoteMedia = function (remoteMedia) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(remoteMedia, null))) {
                        return false;
                    }
                    return this.removeRemoteView(remoteMedia.getId());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a remote view from the layout.
            @param idValue The remote view ID.
            @return `true` if successful; otherwise, `false`. Check the logs for additional information.
            */
            LayoutManager.prototype.removeRemoteView = function (idValue) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(idValue, null))) {
                        fm.liveswitch.Log.warn("Could not remove remote view. The ID cannot be null.");
                        return false;
                    }
                    var oldestRemoteView = this.getOldestRemoteView(idValue);
                    if ((!fm.liveswitch.Global.equals(oldestRemoteView, null))) {
                        try {
                            this.dispatchToMainThread(this.removeRemoteViewUI.bind(this), idValue, oldestRemoteView);
                        }
                        catch (exception) {
                            fm.liveswitch.Log.error("Could not remove remote view.", exception);
                        }
                        finally {
                        }
                    }
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            LayoutManager.prototype.removeRemoteViews = function () {
                if (arguments.length == 0) {
                    this.removeRemoteViews(this.getRemoteViewIds());
                }
                else if (arguments.length == 1) {
                    var ids = arguments[0];
                    if ((fm.liveswitch.Global.equals(ids, null))) {
                        fm.liveswitch.Log.warn("Could not remove remote views. The IDs cannot be null.");
                        return false;
                    }
                    try {
                        this.dispatchToMainThread(this.removeRemoteViewsUI.bind(this), ids, this.getRemoteViews(ids));
                    }
                    catch (exception) {
                        fm.liveswitch.Log.error("Could not remove remote views.", exception);
                    }
                    finally {
                    }
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutManager.prototype.removeRemoteViewsUI = function (idsObj, viewsObj) {
                if (arguments.length == 2) {
                    var strArray = idsObj;
                    var list = viewsObj;
                    this._inBatch = true;
                    for (var i = 0; (i < strArray.length); i++) {
                        this.removeRemoteViewUI(strArray[i], list[i]);
                    }
                    this._inBatch = false;
                    this.layout();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutManager.prototype.removeRemoteViewUI = function (idObj, viewObj) {
                if (arguments.length == 2) {
                    var idValue = idObj;
                    var item = viewObj;
                    var list = new Array();
                    var remoteViewsInternal = this.getRemoteViewsInternal(idValue);
                    if ((!fm.liveswitch.Global.equals(remoteViewsInternal, null))) {
                        fm.liveswitch.ArrayExtensions.addRange(list, remoteViewsInternal);
                    }
                    fm.liveswitch.ArrayExtensions.remove(list, item);
                    this.removeView(item);
                    if ((fm.liveswitch.Global.equals(fm.liveswitch.ArrayExtensions.getCount(list), 0))) {
                        fm.liveswitch.HashExtensions.remove(this._remoteViewsTable, idValue);
                    }
                    else {
                        this._remoteViewsTable[idValue] = list;
                    }
                    if (!this._inBatch) {
                        this.layout();
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes all remote views from the layout, then removes the local view from the layout.
            */
            LayoutManager.prototype.reset = function () {
                if (arguments.length == 0) {
                    this.removeRemoteViews();
                    this.unsetLocalView();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the layout origin. Defaults to TopLeft.
            */
            LayoutManager.prototype.setLayoutOrigin = function (value) {
                if (arguments.length == 1) {
                    this._layoutOrigin = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds the local media to the layout.
            @param localMedia The local media.
            @return `true` if successful; otherwise, `false`.
            */
            LayoutManager.prototype.setLocalMedia = function (localMedia) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(localMedia, null))) {
                        return false;
                    }
                    return this.setLocalView(localMedia.getView());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds the local view to the layout.
            @param view The local view.
            @return `true` if successful; otherwise, `false`. Check the logs for additional information.
            */
            LayoutManager.prototype.setLocalView = function (view) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(view, null))) {
                        fm.liveswitch.Log.warn("Could not set local view. The view cannot be null.");
                        return false;
                    }
                    if ((!fm.liveswitch.Global.equals(view, null))) {
                        try {
                            this.dispatchToMainThread(this.setLocalViewUI.bind(this), view, null);
                        }
                        catch (exception) {
                            fm.liveswitch.Log.error("Could not set local view.", exception);
                        }
                        finally {
                        }
                    }
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutManager.prototype.setLocalViewUI = function (viewObj, unused) {
                if (arguments.length == 2) {
                    var view = viewObj;
                    var localView = this._localView;
                    if ((!fm.liveswitch.Global.equals(localView, null))) {
                        this.removeView(localView);
                    }
                    this._localView = view;
                    this.addView(view);
                    this.layout();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Swaps remote media in the layout.
            @param remoteMediaToRemove The remote media to remove.
            @param remoteMediaToAdd The remote media to add.
            */
            LayoutManager.prototype.swapRemoteMedia = function (remoteMediaToRemove, remoteMediaToAdd) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(remoteMediaToRemove, null))) {
                        return false;
                    }
                    if ((fm.liveswitch.Global.equals(remoteMediaToAdd, null))) {
                        return false;
                    }
                    return this.swapRemoteView(remoteMediaToRemove.getId(), remoteMediaToAdd.getId(), remoteMediaToAdd.getView());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Swaps a remote view in the layout.
            @param idToRemove The remote view ID to remove.
            @param idToAdd The remote view ID to add.
            @param viewToAdd The remote view to add.
            */
            LayoutManager.prototype.swapRemoteView = function (idToRemove, idToAdd, viewToAdd) {
                if (arguments.length == 3) {
                    if ((fm.liveswitch.Global.equals(idToRemove, null))) {
                        fm.liveswitch.Log.warn("Could not swap remote view. The ID to remove cannot be null.");
                        return false;
                    }
                    if ((fm.liveswitch.Global.equals(idToAdd, null))) {
                        fm.liveswitch.Log.warn("Could not swap remote view. The ID to add cannot be null.");
                        return false;
                    }
                    if ((fm.liveswitch.Global.equals(viewToAdd, null))) {
                        fm.liveswitch.Log.warn("Could not swap remote view. The view to add cannot be null.");
                        return false;
                    }
                    this.doSwapRemoteView(idToRemove, this.getOldestRemoteView(idToRemove), idToAdd, viewToAdd);
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Swaps remote views in the layout.
            @param idsToRemove The remote view IDs to remove.
            @param idsToAdd The remote view IDs to add.
            @param viewsToAdd The remote views to add.
            @return `true` if successful; otherwise, `false`. Check the logs for additional information.
            */
            LayoutManager.prototype.swapRemoteViews = function (idsToRemove, idsToAdd, viewsToAdd) {
                if (arguments.length == 3) {
                    if ((fm.liveswitch.Global.equals(idsToRemove, null))) {
                        fm.liveswitch.Log.warn("Could not swap remote views. The IDs to remove cannot be null.");
                        return false;
                    }
                    if ((fm.liveswitch.Global.equals(idsToAdd, null))) {
                        fm.liveswitch.Log.warn("Could not swap remote views. The IDs to add cannot be null.");
                        return false;
                    }
                    if ((fm.liveswitch.Global.equals(viewsToAdd, null))) {
                        fm.liveswitch.Log.warn("Could not swap remote views. The views to add cannot be null.");
                        return false;
                    }
                    if ((!fm.liveswitch.Global.equals(idsToAdd.length, viewsToAdd.length))) {
                        fm.liveswitch.Log.warn("Could not swap remote views. The number of IDs and views to add must match.");
                        return false;
                    }
                    this.doSwapRemoteViews(idsToRemove, this.getRemoteViews(idsToRemove), idsToAdd, viewsToAdd);
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes the local view from the layout.
            @return `true` if successful; otherwise, `false`. Check the logs for additional information.
            */
            LayoutManager.prototype.unsetLocalView = function () {
                if (arguments.length == 0) {
                    var localView = this.getLocalView();
                    if ((fm.liveswitch.Global.equals(localView, null))) {
                        fm.liveswitch.Log.warn("Could not unset local view. A view does not exist.");
                        return false;
                    }
                    try {
                        this.dispatchToMainThread(this.unsetLocalViewUI.bind(this), localView, null);
                    }
                    catch (exception) {
                        fm.liveswitch.Log.error("Could not unset local view.", exception);
                    }
                    finally {
                    }
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LayoutManager.prototype.unsetLocalViewUI = function (viewObj, unused) {
                if (arguments.length == 2) {
                    var view = viewObj;
                    this._localView = null;
                    this.removeView(view);
                    this.layout();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return LayoutManager;
        }(fm.liveswitch.LayoutPreset));
        liveswitch.LayoutManager = LayoutManager;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="LayoutManager.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var DomLayoutManager = /** @class */ (function (_super) {
            __extends(DomLayoutManager, _super);
            function DomLayoutManager(container, preset) {
                var _this = this;
                if (typeof preset === 'undefined') {
                    preset = null;
                }
                _this = _super.call(this, preset) || this;
                _this._id = fm.liveswitch.Utility.generateId();
                _this._parentMissing = 0;
                _this._parentMissingMax = 16;
                _this._lastWidth = 0;
                _this._lastHeight = 0;
                _this._verticalScrollBarWidth = -1;
                _this._horizontalScrollBarHeight = -1;
                _this._retryTimeout = 0;
                _this._viewCleanups = {};
                _this._container = container;
                return _this;
            }
            DomLayoutManager.prototype.getTypeString = function () {
                return '[fm.liveswitch.DomLayoutManager]' + ',' + _super.prototype.getTypeString.call(this);
            };
            DomLayoutManager.prototype.getContainer = function () {
                return this._container;
            };
            DomLayoutManager.prototype.initializeInnerContainer = function () {
                var _this = this;
                if (this._innerContainer) {
                    return;
                }
                this.destroyInnerContainer();
                this._innerContainer = document.createElement('div');
                this._innerContainer.style.position = 'relative';
                this._innerContainer.style.width = '100%';
                this._innerContainer.style.height = '100%';
                this._innerContainer.setAttribute('data-fm-webrtc-inner-container', 'true');
                this._container.appendChild(this._innerContainer);
                this._resizeInterval = window.setInterval(function () {
                    if (!_this._container.parentNode) {
                        _this._parentMissing = _this._parentMissing + 1;
                        if (_this._parentMissing > _this._parentMissingMax) {
                            window.clearInterval(_this._resizeInterval);
                        }
                    }
                    else {
                        _this._parentMissing = 0;
                        var width = _this._innerContainer.offsetWidth;
                        var height = _this._innerContainer.offsetHeight;
                        if (width != _this._lastWidth || height != _this._lastHeight) {
                            _this.layout();
                            _this._lastWidth = width;
                            _this._lastHeight = height;
                        }
                    }
                }, 250);
            };
            DomLayoutManager.prototype.destroyInnerContainer = function () {
                for (var _i = 0, _a = this.collectionToArray(this._container.getElementsByTagName('div')); _i < _a.length; _i++) {
                    var child = _a[_i];
                    if (child.getAttribute('data-fm-webrtc-inner-container') == 'true') {
                        this._container.removeChild(child);
                    }
                }
            };
            DomLayoutManager.prototype.destroy = function () {
                this.destroyInnerContainer();
                clearInterval(this._resizeInterval);
            };
            DomLayoutManager.prototype.addView = function (view) {
                var _this = this;
                this.initializeInnerContainer();
                var viewId = fm.liveswitch.Utility.generateId();
                view.setAttribute('data-fm-webrtc-layout-' + this._id + '-view-id', viewId);
                this._viewCleanups[viewId] = this.addOnVideoSizeChange(view, function () {
                    _this.layout();
                });
                this._innerContainer.appendChild(view);
            };
            DomLayoutManager.prototype.removeView = function (view) {
                this.initializeInnerContainer();
                if (view.parentNode == this._innerContainer) {
                    this._innerContainer.removeChild(view);
                }
                var viewId = view.getAttribute('data-fm-webrtc-layout-' + this._id + '-view-id');
                if (viewId) {
                    var cleanup = this._viewCleanups[viewId];
                    if (cleanup) {
                        cleanup();
                    }
                    delete this._viewCleanups[viewId];
                }
            };
            DomLayoutManager.prototype.dispatchToMainThread = function (action, arg1, arg2) {
                action(arg1, arg2);
            };
            DomLayoutManager.prototype.doGetLocalView = function () {
                if (this._innerContainer) {
                    return _super.prototype.doGetLocalView.call(this);
                }
                var localViews = this.getViewsByClassName('fm-video-local');
                if (localViews.length == 0) {
                    return null;
                }
                return localViews[localViews.length - 1]; // last added
            };
            DomLayoutManager.prototype.doGetRemoteViewsIds = function () {
                if (this._innerContainer) {
                    return _super.prototype.doGetRemoteViewsIds.call(this);
                }
                var remoteViewIds = [];
                for (var _i = 0, _a = this.getViewsByClassName('fm-video-remote'); _i < _a.length; _i++) {
                    var remoteView = _a[_i];
                    remoteViewIds.push(remoteView.id);
                }
                return remoteViewIds;
            };
            DomLayoutManager.prototype.doGetRemoteViews = function (idValue) {
                if (this._innerContainer) {
                    return _super.prototype.doGetRemoteViews.call(this, idValue);
                }
                var remoteViews = [];
                for (var _i = 0, _a = this.getViewsByClassName('fm-video-remote'); _i < _a.length; _i++) {
                    var remoteView = _a[_i];
                    if (remoteView.id == idValue) {
                        remoteViews.push(remoteView);
                    }
                }
                return remoteViews;
            };
            DomLayoutManager.prototype.getViewsByClassName = function (className) {
                return this.getParentViews(this.collectionToArray(this._container.getElementsByClassName(className)));
            };
            DomLayoutManager.prototype.getParentViews = function (views) {
                var parentViews = [];
                for (var _i = 0, views_1 = views; _i < views_1.length; _i++) {
                    var view = views_1[_i];
                    parentViews.push(this.getParentView(view));
                }
                return parentViews;
            };
            DomLayoutManager.prototype.getParentView = function (view) {
                var parentView = view;
                while (parentView.parentElement != this._container) {
                    parentView = parentView.parentElement;
                }
                return parentView;
            };
            DomLayoutManager.prototype.collectionToArray = function (collection) {
                var elements = [];
                for (var i = 0; i < collection.length; i++) {
                    elements.push(collection[i]);
                }
                return elements;
            };
            DomLayoutManager.prototype.layout = function () {
                var _this = this;
                if (this._retryTimeout) {
                    clearTimeout(this._retryTimeout);
                }
                var localView = this.getLocalView();
                var remoteViewIds = this.getRemoteViewIds();
                var remoteViews = this.getRemoteViews(remoteViewIds);
                var localVideoSize = null;
                var remoteVideoSizes = [];
                if (this.getMode() == fm.liveswitch.LayoutMode.InlineOverflow) {
                    var retry = false;
                    if (localView != null) {
                        localVideoSize = this.getVideoSize(localView);
                        if (localVideoSize == null) {
                            // give it something for now...
                            localVideoSize = new fm.liveswitch.Size(0, 0);
                            // try again once we have a width/height
                            retry = true;
                        }
                    }
                    for (var i = 0; i < remoteViews.length; i++) {
                        var remoteVideoSize = this.getVideoSize(remoteViews[i]);
                        if (remoteVideoSize == null) {
                            // give it something for now...
                            remoteVideoSize = new fm.liveswitch.Size(0, 0);
                            // try again once we have a width/height
                            retry = true;
                        }
                        remoteVideoSizes.push(remoteVideoSize);
                    }
                    if (retry) {
                        this._retryTimeout = setTimeout(function () {
                            _this._retryTimeout = 0;
                            _this.layout();
                        }, 250);
                    }
                }
                var container = this._innerContainer || this._container;
                var containerWidth = container.offsetWidth;
                var containerHeight = container.offsetHeight;
                // Get the new layout.
                var layout = this.getLayout(containerWidth, containerHeight, localView != null, remoteViews.length, remoteViewIds, localVideoSize, remoteVideoSizes);
                var verticalScrollVisible = false;
                var horizontalScrollVisible = false;
                if (this.getMode() == fm.liveswitch.LayoutMode.InlineOverflow) {
                    if (this.getDirection() == fm.liveswitch.LayoutDirection.Horizontal) {
                        if (layout.getWidth() > containerWidth) {
                            containerHeight -= this.getHorizontalScrollbarHeight();
                            layout = this.getLayout(containerWidth, containerHeight, localView != null, remoteViews.length, remoteViewIds, localVideoSize, remoteVideoSizes);
                            horizontalScrollVisible = true;
                        }
                    }
                    else {
                        if (layout.getHeight() > containerHeight) {
                            containerWidth -= this.getVerticalScrollbarWidth();
                            layout = this.getLayout(containerWidth, containerHeight, localView != null, remoteViews.length, remoteViewIds, localVideoSize, remoteVideoSizes);
                            verticalScrollVisible = true;
                        }
                    }
                }
                // Apply the local video frame.
                if (localView != null) {
                    var localFrame = layout.getLocalFrame();
                    localView.style.position = 'absolute';
                    localView.style.left = localFrame.getX() + 'px';
                    localView.style.top = localFrame.getY() + 'px';
                    localView.style.width = localFrame.getWidth() + 'px';
                    localView.style.height = localFrame.getHeight() + 'px';
                    if (this.getMode() == fm.liveswitch.LayoutMode.FloatLocal) {
                        localView.style.zIndex = remoteViews.length.toString();
                    }
                    else if (this.getMode() == fm.liveswitch.LayoutMode.FloatRemote) {
                        localView.style.zIndex = '0';
                    }
                }
                // Apply the remote video frames.
                var remoteFrames = layout.getRemoteFrames();
                for (var i = 0; i < remoteFrames.length; i++) {
                    var remoteFrame = remoteFrames[i];
                    var remoteView = remoteViews[i];
                    remoteView.style.position = 'absolute';
                    remoteView.style.left = remoteFrame.getX() + 'px';
                    remoteView.style.top = remoteFrame.getY() + 'px';
                    remoteView.style.width = remoteFrame.getWidth() + 'px';
                    remoteView.style.height = remoteFrame.getHeight() + 'px';
                    if (this.getMode() == fm.liveswitch.LayoutMode.FloatLocal) {
                        remoteView.style.zIndex = i.toString();
                    }
                    else if (this.getMode() == fm.liveswitch.LayoutMode.FloatRemote) {
                        remoteView.style.zIndex = (i + 1).toString();
                    }
                }
                if (this.getMode() == fm.liveswitch.LayoutMode.InlineOverflow) {
                    container.style.overflowX = horizontalScrollVisible ? 'scroll' : 'hidden';
                    container.style.overflowY = verticalScrollVisible ? 'scroll' : 'hidden';
                }
            };
            DomLayoutManager.prototype.getVideoSize = function (view) {
                if (fm.liveswitch.Plugin.useActiveX()) {
                    return this.getPluginVideoSize(view);
                }
                else if (fm.liveswitch.Plugin.useNative()) {
                    return this.getWebRtcVideoSize(view);
                }
                else {
                    throw new fm.liveswitch.Exception('Browser does not support WebRTC/ORTC and no plugin found.');
                }
            };
            DomLayoutManager.prototype.getWebRtcVideoSize = function (view) {
                if (view == null) {
                    return null;
                }
                if (view.nodeName.toLowerCase() == 'video') {
                    var video = view;
                    var videoWidth = video.videoWidth;
                    var videoHeight = video.videoHeight;
                    if (videoWidth && videoHeight) {
                        return new fm.liveswitch.Size(videoWidth, videoHeight);
                    }
                }
                var children = view.children;
                if (children) {
                    for (var i = 0; i < children.length; i++) {
                        var videoSize = this.getWebRtcVideoSize(children[i]);
                        if (videoSize != null) {
                            return videoSize;
                        }
                    }
                }
                return null;
            };
            DomLayoutManager.prototype.getPluginVideoSize = function (view) {
                if (view == null) {
                    return null;
                }
                if (view.nodeName.toLowerCase() == 'object' && view.getAttribute('CLASSID') == 'clsid:' + fm.liveswitch.PluginConstants.getDomVideoSinkClassId()) {
                    var axo = view;
                    var videoWidth = axo.GetWidth();
                    var videoHeight = axo.GetHeight();
                    if (videoWidth && videoHeight) {
                        return new fm.liveswitch.Size(videoWidth, videoHeight);
                    }
                }
                var children = view.children;
                if (children) {
                    for (var i = 0; i < children.length; i++) {
                        var videoSize = this.getPluginVideoSize(children[i]);
                        if (videoSize != null) {
                            return videoSize;
                        }
                    }
                }
                return null;
            };
            DomLayoutManager.prototype.addOnVideoSizeChange = function (view, handler) {
                if (fm.liveswitch.Plugin.useActiveX()) {
                    return this.addOnPluginVideoSizeChange(view, handler);
                }
                else if (fm.liveswitch.Plugin.useNative()) {
                    return this.addOnWebRtcVideoSizeChange(view, handler);
                }
                else {
                    throw new fm.liveswitch.Exception('Browser does not support WebRTC/ORTC and no plugin found.');
                }
            };
            DomLayoutManager.prototype.addOnWebRtcVideoSizeChange = function (view, handler) {
                if (view == null) {
                    return null;
                }
                if (view.nodeName.toLowerCase() == 'video') {
                    var video_1 = view;
                    var listener_1 = function (event) {
                        handler(new fm.liveswitch.Size(video_1.videoWidth, video_1.videoHeight));
                    };
                    video_1.addEventListener('resize', listener_1);
                    return function () {
                        video_1.removeEventListener('resize', listener_1);
                    };
                }
                var children = view.children;
                if (children) {
                    for (var i = 0; i < children.length; i++) {
                        var cleanup = this.addOnWebRtcVideoSizeChange(children[i], handler);
                        if (cleanup) {
                            return cleanup;
                        }
                    }
                }
                return null;
            };
            DomLayoutManager.prototype.addOnPluginVideoSizeChange = function (view, handler) {
                if (view == null) {
                    return null;
                }
                if (view.nodeName.toLowerCase() == 'object' && view.getAttribute('CLASSID') == 'clsid:' + fm.liveswitch.PluginConstants.getDomVideoSinkClassId()) {
                    var axo_1 = view;
                    var listener = function () {
                        handler(new fm.liveswitch.Size(axo_1.GetVideoWidth(), axo_1.GetVideoHeight()));
                    };
                    axo_1.SetOnVideoResize(listener);
                    return function () {
                        axo_1.SetOnVideoResize(null);
                    };
                }
                var children = view.children;
                if (children) {
                    for (var i = 0; i < children.length; i++) {
                        var cleanup = this.addOnPluginVideoSizeChange(children[i], handler);
                        if (cleanup) {
                            return cleanup;
                        }
                    }
                }
                return null;
            };
            DomLayoutManager.prototype.getVerticalScrollbarWidth = function () {
                if (this._verticalScrollBarWidth == -1) {
                    var outer = document.createElement('div');
                    outer.style.visibility = 'hidden';
                    outer.style.overflow = 'scroll';
                    //@ts-ignore
                    outer.style.msOverflowStyle = 'scrollbar';
                    document.body.appendChild(outer);
                    var inner = document.createElement('div');
                    outer.appendChild(inner);
                    this._verticalScrollBarWidth = outer.offsetWidth - outer.clientWidth;
                    outer.parentNode.removeChild(outer);
                }
                return this._verticalScrollBarWidth;
            };
            DomLayoutManager.prototype.getHorizontalScrollbarHeight = function () {
                if (this._horizontalScrollBarHeight == -1) {
                    var outer = document.createElement('div');
                    outer.style.visibility = 'hidden';
                    outer.style.overflow = 'scroll';
                    //@ts-ignore
                    outer.style.msOverflowStyle = 'scrollbar';
                    document.body.appendChild(outer);
                    var inner = document.createElement('div');
                    outer.appendChild(inner);
                    this._horizontalScrollBarHeight = outer.offsetHeight - outer.clientHeight;
                    outer.parentNode.removeChild(outer);
                }
                return this._horizontalScrollBarHeight;
            };
            return DomLayoutManager;
        }(fm.liveswitch.LayoutManager));
        liveswitch.DomLayoutManager = DomLayoutManager;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var DomVideoSink = /** @class */ (function (_super) {
            __extends(DomVideoSink, _super);
            function DomVideoSink(track) {
                var _this = _super.call(this) || this;
                if (fm.liveswitch.Plugin.useActiveX()) {
                    _this._internal = new fm.liveswitch.PluginDomVideoSink(_this, (track == null ? null : track._getInternal()));
                }
                else if (fm.liveswitch.Plugin.useNative()) {
                    _this._internal = new fm.liveswitch.WebRtcDomVideoSink(_this, (track == null ? null : track._getInternal()));
                }
                else {
                    throw new fm.liveswitch.Exception('Browser does not support WebRTC/ORTC and no plugin found.');
                }
                return _this;
            }
            DomVideoSink.prototype.getTypeString = function () {
                return '[fm.liveswitch.DomVideoSink]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            DomVideoSink.prototype._getInternal = function () {
                return this._internal;
            };
            DomVideoSink.prototype.getVideo = function () {
                return this._getInternal().getVideo();
            };
            DomVideoSink.prototype.getView = function () {
                return this._getInternal().getView();
            };
            DomVideoSink.prototype.getViewScale = function () {
                return this._getInternal().getViewScale();
            };
            DomVideoSink.prototype.setViewScale = function (viewScale) {
                this._getInternal().setViewScale(viewScale);
            };
            DomVideoSink.prototype.getViewMirror = function () {
                return this._getInternal().getViewMirror();
            };
            DomVideoSink.prototype.setViewMirror = function (viewMirror) {
                this._getInternal().setViewMirror(viewMirror);
            };
            return DomVideoSink;
        }(fm.liveswitch.Dynamic));
        liveswitch.DomVideoSink = DomVideoSink;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Factory = /** @class */ (function () {
            function Factory() {
            }
            Factory.prototype.getTypeString = function () {
                return '[fm.liveswitch.Factory]';
            };
            // ALL THESE METHODS ARE DEPRECATED AND SHOULD NOT BE USED
            Factory.createConnection = function (streams) {
                return new fm.liveswitch.Connection(streams);
            };
            Factory.createAudioStream = function (localMedia) {
                return new fm.liveswitch.AudioStream(localMedia);
            };
            Factory.createVideoStream = function (localMedia) {
                return new fm.liveswitch.VideoStream(localMedia);
            };
            Factory.createDataChannel = function (label) {
                return new fm.liveswitch.DataChannel(label);
            };
            Factory.createDataStream = function (channel) {
                return new fm.liveswitch.DataStream(channel);
            };
            Factory.createDomVideoSink = function (track) {
                return new fm.liveswitch.DomVideoSink(track);
            };
            Factory.createLocalMedia = function (audio, video, screen) {
                return new fm.liveswitch.LocalMedia(audio, video, screen);
            };
            return Factory;
        }());
        liveswitch.Factory = Factory;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Media = /** @class */ (function (_super) {
            __extends(Media, _super);
            function Media() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Media.prototype.getTypeString = function () {
                return '[fm.liveswitch.Media]' + ',' + _super.prototype.getTypeString.call(this);
            };
            Media.prototype.addOnAudioDestroyed = function (value) {
                return this._getInternal().addOnAudioDestroyed(value);
            };
            Media.prototype.addOnVideoDestroyed = function (value) {
                return this._getInternal().addOnVideoDestroyed(value);
            };
            Media.prototype.removeOnAudioDestroyed = function (value) {
                return this._getInternal().removeOnAudioDestroyed(value);
            };
            Media.prototype.removeOnVideoDestroyed = function (value) {
                return this._getInternal().removeOnVideoDestroyed(value);
            };
            Media.prototype.addOnAudioLevel = function (value) {
                this._getInternal().addOnAudioLevel(value);
            };
            Media.prototype.addOnVideoSize = function (value) {
                this._getInternal().addOnVideoSize(value);
            };
            Media.prototype.getAudioGain = function () {
                return this._getInternal().getAudioGain();
            };
            Media.prototype.getAudioMuted = function () {
                return this._getInternal().getAudioMuted();
            };
            Media.prototype.getAudioTrack = function () {
                return this.internalToExternal(this._getInternal().getAudioTrack());
            };
            Media.prototype.getAudioTracks = function () {
                return this.internalsToExternals(this._getInternal().getAudioTracks());
            };
            Media.prototype.getAudioVolume = function () {
                return this._getInternal().getAudioVolume();
            };
            Media.prototype.getId = function () {
                return this._getInternal().getId();
            };
            Media.prototype.getVideoMuted = function () {
                return this._getInternal().getVideoMuted();
            };
            Media.prototype.getVideoSize = function () {
                return this._getInternal().getVideoSize();
            };
            Media.prototype.getVideoTrack = function () {
                return this.internalToExternal(this._getInternal().getVideoTrack());
            };
            Media.prototype.getVideoTracks = function () {
                return this.internalsToExternals(this._getInternal().getVideoTracks());
            };
            Media.prototype.grabVideoFrame = function () {
                return this._getInternal().grabVideoFrame();
            };
            Media.prototype.removeOnAudioLevel = function (value) {
                this._getInternal().removeOnAudioLevel(value);
            };
            Media.prototype.removeOnVideoSize = function (value) {
                this._getInternal().removeOnVideoSize(value);
            };
            Media.prototype.setAudioGain = function (value) {
                this._getInternal().setAudioGain(value);
            };
            Media.prototype.setAudioMuted = function (value) {
                this._getInternal().setAudioMuted(value);
            };
            Media.prototype.setAudioVolume = function (value) {
                this._getInternal().setAudioVolume(value);
            };
            Media.prototype.setId = function (value) {
                return this._getInternal().setId(value);
            };
            Media.prototype.setVideoMuted = function (value) {
                this._getInternal().setVideoMuted(value);
            };
            Media.prototype.destroy = function () {
                this._getInternal().destroy();
            };
            Media.prototype.getAudioSink = function () {
                var internalAudioSink = this._getInternal().getAudioSink();
                if (internalAudioSink == null) {
                    return null;
                }
                return internalAudioSink._getExternal();
            };
            Media.prototype.getVideoSink = function () {
                var internalViewSink = this._getInternal().getVideoSink();
                if (internalViewSink == null) {
                    return null;
                }
                return internalViewSink._getExternal();
            };
            Media.prototype.getView = function () {
                return this._getInternal().getView();
            };
            Media.prototype.getViewSink = function () {
                var internalViewSink = this._getInternal().getViewSink();
                if (internalViewSink == null) {
                    return null;
                }
                return internalViewSink._getExternal();
            };
            Media.prototype.externalsToInternals = function (externals) {
                var _this = this;
                return fm.liveswitch.ArrayExtensions.map(externals, function (external) {
                    return _this.externalToInternal(external);
                });
            };
            Media.prototype.externalToInternal = function (external) {
                return external._getInternal();
            };
            Media.prototype.internalsToExternals = function (internals) {
                var _this = this;
                return fm.liveswitch.ArrayExtensions.map(internals, function (internal) {
                    return _this.internalToExternal(internal);
                });
            };
            Media.prototype.internalToExternal = function (internal) {
                if (internal == null) {
                    return null;
                }
                return internal._getExternal();
            };
            return Media;
        }(fm.liveswitch.Dynamic));
        liveswitch.Media = Media;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Media.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var LocalMedia = /** @class */ (function (_super) {
            __extends(LocalMedia, _super);
            function LocalMedia(audio, video, screen) {
                var _this = _super.call(this) || this;
                if (typeof audio == 'undefined') {
                    audio = true;
                }
                if (typeof video == 'undefined') {
                    video = true;
                }
                if (typeof screen == 'undefined') {
                    screen = false;
                }
                if (screen && !video) {
                    screen = false;
                }
                if (fm.liveswitch.Plugin.useActiveX()) {
                    _this._internal = new fm.liveswitch.PluginLocalMedia(_this, audio, video, screen);
                }
                else if (fm.liveswitch.Plugin.useNative()) {
                    _this._internal = new fm.liveswitch.WebRtcLocalMedia(_this, audio, video, screen);
                }
                else {
                    throw new fm.liveswitch.Exception('Browser does not support WebRTC/ORTC and no plugin found.');
                }
                return _this;
            }
            LocalMedia.prototype.getTypeString = function () {
                return '[fm.liveswitch.LocalMedia]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            LocalMedia.prototype._getInternal = function () {
                return this._internal;
            };
            LocalMedia.prototype.addOnAudioStarted = function (value) {
                return this._getInternal().addOnAudioStarted(value);
            };
            LocalMedia.prototype.addOnAudioStopped = function (value) {
                return this._getInternal().addOnAudioStopped(value);
            };
            LocalMedia.prototype.addOnVideoStarted = function (value) {
                return this._getInternal().addOnVideoStarted(value);
            };
            LocalMedia.prototype.addOnVideoStopped = function (value) {
                return this._getInternal().addOnVideoStopped(value);
            };
            LocalMedia.prototype.removeOnAudioStarted = function (value) {
                return this._getInternal().removeOnAudioStarted(value);
            };
            LocalMedia.prototype.removeOnAudioStopped = function (value) {
                return this._getInternal().removeOnAudioStopped(value);
            };
            LocalMedia.prototype.removeOnVideoStarted = function (value) {
                return this._getInternal().removeOnVideoStarted(value);
            };
            LocalMedia.prototype.removeOnVideoStopped = function (value) {
                return this._getInternal().removeOnVideoStopped(value);
            };
            LocalMedia.prototype.getAudioEncoding = function () {
                return this._getInternal().getAudioEncoding();
            };
            LocalMedia.prototype.getAudioEncodings = function () {
                return this._getInternal().getAudioEncodings();
            };
            LocalMedia.prototype.setAudioEncodings = function (value) {
                return this._getInternal().setAudioEncodings(value);
            };
            LocalMedia.prototype.getVideoEncoding = function () {
                return this._getInternal().getVideoEncoding();
            };
            LocalMedia.prototype.getVideoEncodings = function () {
                return this._getInternal().getVideoEncodings();
            };
            LocalMedia.prototype.setVideoEncodings = function (value) {
                return this._getInternal().setVideoEncodings(value);
            };
            /**
             * Deprecated: Use fm.liveswitch.Plugin.getChromeExtensionId()
             */
            LocalMedia.getChromeExtensionId = function () {
                return fm.liveswitch.WebRtcLocalMedia.getChromeExtensionId();
            };
            /**
             * Deprecated: Use fm.liveswitch.Plugin.setChromeExtensionId()
             */
            LocalMedia.setChromeExtensionId = function (chromeExtensionId) {
                fm.liveswitch.WebRtcLocalMedia.setChromeExtensionId(chromeExtensionId);
            };
            /**
             * Deprecated: Use fm.liveswitch.Plugin.getChromeExtensionUrl()
             */
            LocalMedia.getChromeExtensionUrl = function () {
                return fm.liveswitch.WebRtcLocalMedia.getChromeExtensionUrl();
            };
            /**
             * Deprecated: Use fm.liveswitch.Plugin.getChromeExtensionInstalled()
             */
            LocalMedia.getChromeExtensionInstalled = function () {
                return fm.liveswitch.WebRtcLocalMedia.getChromeExtensionInstalled();
            };
            /**
             * Deprecated: Use fm.liveswitch.Plugin.getChromeExtensionRequiresUserGesture()
             */
            LocalMedia.getChromeExtensionRequiresUserGesture = function () {
                return fm.liveswitch.WebRtcLocalMedia.getChromeExtensionRequiresUserGesture();
            };
            /**
             * Deprecated: Use fm.liveswitch.Plugin.setChromeExtensionRequiresUserGesture()
             */
            LocalMedia.setChromeExtensionRequiresUserGesture = function (chromeExtensionRequiresUserGesture) {
                fm.liveswitch.WebRtcLocalMedia.setChromeExtensionRequiresUserGesture(chromeExtensionRequiresUserGesture);
            };
            LocalMedia.prototype.changeAudioSourceInput = function (audioSourceInput) {
                return this._getInternal().changeAudioSourceInput(audioSourceInput);
            };
            LocalMedia.prototype.changeVideoSourceInput = function (videoSourceInput) {
                return this._getInternal().changeVideoSourceInput(videoSourceInput);
            };
            LocalMedia.prototype.getAudioSourceInput = function () {
                return this._getInternal().getAudioSourceInput();
            };
            LocalMedia.prototype.getAudioSourceInputs = function () {
                return this._getInternal().getAudioSourceInputs();
            };
            LocalMedia.prototype.getVideoSourceInput = function () {
                return this._getInternal().getVideoSourceInput();
            };
            LocalMedia.prototype.getVideoSourceInputs = function () {
                return this._getInternal().getVideoSourceInputs();
            };
            LocalMedia.prototype.setAudioSourceInput = function (value) {
                this._getInternal().setAudioSourceInput(value);
            };
            LocalMedia.prototype.setVideoSourceInput = function (value) {
                this._getInternal().setVideoSourceInput(value);
            };
            LocalMedia.prototype.start = function () {
                var _this = this;
                var promise = new fm.liveswitch.Promise();
                this._getInternal().start().then(function (lm) {
                    promise.resolve(_this);
                }, function (ex) {
                    promise.reject(ex);
                });
                return promise;
            };
            LocalMedia.prototype.stop = function () {
                var _this = this;
                var promise = new fm.liveswitch.Promise();
                this._getInternal().stop().then(function (lm) {
                    promise.resolve(_this);
                }, function (ex) {
                    promise.reject(ex);
                });
                return promise;
            };
            LocalMedia.prototype.changeAudioInput = function (audioInput) {
                fm.liveswitch.Log.warn('LocalMedia.changeAudioInput is deprecated. Use LocalMedia.changeAudioSourceInput instead.');
                return this.changeAudioSourceInput(audioInput);
            };
            LocalMedia.prototype.changeVideoInput = function (videoInput) {
                fm.liveswitch.Log.warn('LocalMedia.changeVideoInput is deprecated. Use LocalMedia.changeVideoSourceInput instead.');
                return this.changeVideoSourceInput(videoInput);
            };
            LocalMedia.prototype.getAudioInput = function () {
                fm.liveswitch.Log.warn('LocalMedia.getAudioInput is deprecated. Use LocalMedia.getAudioSourceInput instead.');
                return this.getAudioSourceInput();
            };
            LocalMedia.prototype.getAudioInputs = function () {
                fm.liveswitch.Log.warn('LocalMedia.getAudioInputs is deprecated. Use LocalMedia.getAudioSourceInputs instead.');
                return this.getAudioSourceInputs();
            };
            LocalMedia.prototype.getVideoInput = function () {
                fm.liveswitch.Log.warn('LocalMedia.getVideoInput is deprecated. Use LocalMedia.getVideoSourceInput instead.');
                return this.getVideoSourceInput();
            };
            LocalMedia.prototype.getVideoInputs = function () {
                fm.liveswitch.Log.warn('LocalMedia.getVideoInputs is deprecated. Use LocalMedia.getVideoSourceInputs instead.');
                return this.getVideoSourceInputs();
            };
            LocalMedia.prototype.setAudioInput = function (audioInput) {
                fm.liveswitch.Log.warn('LocalMedia.setAudioInput is deprecated. Use LocalMedia.setAudioSourceInput instead.');
                return this.setAudioSourceInput(audioInput);
            };
            LocalMedia.prototype.setVideoInput = function (videoInput) {
                fm.liveswitch.Log.warn('LocalMedia.setVideoInput is deprecated. Use LocalMedia.setVideoSourceInput instead.');
                return this.setVideoSourceInput(videoInput);
            };
            LocalMedia.prototype.getState = function () {
                return this._getInternal().getState();
            };
            LocalMedia.prototype.getAudioSimulcastDisabled = function () {
                return this._getInternal().getAudioSimulcastDisabled();
            };
            LocalMedia.prototype.setAudioSimulcastDisabled = function (value) {
                this._getInternal().setAudioSimulcastDisabled(value);
            };
            LocalMedia.prototype.getAudioSimulcastEncodingCount = function () {
                return this._getInternal().getAudioSimulcastEncodingCount();
            };
            LocalMedia.prototype.setAudioSimulcastEncodingCount = function (value) {
                this._getInternal().setAudioSimulcastEncodingCount(value);
            };
            LocalMedia.prototype.getAudioSimulcastPreferredBitrate = function () {
                return this._getInternal().getAudioSimulcastPreferredBitrate();
            };
            LocalMedia.prototype.setAudioSimulcastPreferredBitrate = function (value) {
                this._getInternal().setAudioSimulcastPreferredBitrate(value);
            };
            LocalMedia.prototype.getVideoSimulcastDisabled = function () {
                return this._getInternal().getVideoSimulcastDisabled();
            };
            LocalMedia.prototype.setVideoSimulcastDisabled = function (value) {
                this._getInternal().setVideoSimulcastDisabled(value);
            };
            LocalMedia.prototype.getVideoSimulcastEncodingCount = function () {
                return this._getInternal().getVideoSimulcastEncodingCount();
            };
            LocalMedia.prototype.setVideoSimulcastEncodingCount = function (value) {
                this._getInternal().setVideoSimulcastEncodingCount(value);
            };
            LocalMedia.prototype.getVideoSimulcastPreferredBitrate = function () {
                return this._getInternal().getVideoSimulcastPreferredBitrate();
            };
            LocalMedia.prototype.setVideoSimulcastPreferredBitrate = function (value) {
                this._getInternal().setVideoSimulcastPreferredBitrate(value);
            };
            LocalMedia.prototype.getVideoSimulcastBitsPerPixel = function () {
                return this._getInternal().getVideoSimulcastBitsPerPixel();
            };
            LocalMedia.prototype.setVideoSimulcastBitsPerPixel = function (value) {
                this._getInternal().setVideoSimulcastBitsPerPixel(value);
            };
            LocalMedia.prototype.getVideoSimulcastDegradationPreference = function () {
                return this._getInternal().getVideoSimulcastDegradationPreference();
            };
            LocalMedia.prototype.setVideoSimulcastDegradationPreference = function (value) {
                this._getInternal().setVideoSimulcastDegradationPreference(value);
            };
            return LocalMedia;
        }(fm.liveswitch.Media));
        liveswitch.LocalMedia = LocalMedia;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var LocalNetwork = /** @class */ (function () {
            function LocalNetwork() {
            }
            LocalNetwork.prototype.getTypeString = function () {
                return '[fm.liveswitch.LocalNetwork]';
            };
            LocalNetwork.getAddressType = function (ipAddress) {
                if (ipAddress.indexOf(':') > -1) {
                    return fm.liveswitch.AddressType.IPv6;
                }
                return fm.liveswitch.AddressType.IPv4;
            };
            return LocalNetwork;
        }());
        liveswitch.LocalNetwork = LocalNetwork;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var MediaDescriptionManagerBase = /** @class */ (function () {
            function MediaDescriptionManagerBase() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            MediaDescriptionManagerBase.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaDescriptionManagerBase]';
            };
            MediaDescriptionManagerBase.syncroniseMediaIdentification = function (sdpMediaDescription, index) {
                if (arguments.length == 2) {
                    var str = "";
                    var mediaStreamIdentifierAttribute = sdpMediaDescription.getMediaStreamIdentifierAttribute();
                    if ((fm.liveswitch.Global.equals(mediaStreamIdentifierAttribute, null))) {
                        var idValue = fm.liveswitch.NumberExtensions.toString(index);
                        str = idValue;
                        sdpMediaDescription.addMediaAttribute(new fm.liveswitch.sdp.MediaStreamIdAttribute(idValue));
                        return str;
                    }
                    return mediaStreamIdentifierAttribute.getIdentificationTag();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            MediaDescriptionManagerBase.prototype.getMediaStreamIdentifier = function () {
                if (arguments.length == 0) {
                    return this._mediaStreamIdentifier;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            MediaDescriptionManagerBase.prototype.processSdpMediaDescription = function (mediaRequirements, sdpMessage, index, isLocalDescription, isRenegotiation, isOffer) {
                if (arguments.length == 6) {
                    mediaRequirements.setMediaStreamIdentifier(fm.liveswitch.MediaDescriptionManagerBase.syncroniseMediaIdentification(sdpMessage.getMediaDescriptions()[index], index));
                    this.setMediaStreamIdentifier(mediaRequirements.getMediaStreamIdentifier());
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            MediaDescriptionManagerBase.prototype.setMediaStreamIdentifier = function (value) {
                if (arguments.length == 1) {
                    this._mediaStreamIdentifier = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaDescriptionManagerBase;
        }());
        liveswitch.MediaDescriptionManagerBase = MediaDescriptionManagerBase;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="MediaDescriptionManagerBase.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        @hidden
        */
        var MediaDescriptionManager = /** @class */ (function (_super) {
            __extends(MediaDescriptionManager, _super);
            function MediaDescriptionManager() {
                return _super.call(this) || this;
            }
            MediaDescriptionManager.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaDescriptionManager]' + ',' + _super.prototype.getTypeString.call(this);
            };
            MediaDescriptionManager.prototype.processSdpMediaDescription = function (mediaRequirements, sdpMessage, index, isLocalDescription, isRenegotiation, isOffer) {
                if (arguments.length == 6) {
                    var error = _super.prototype.processSdpMediaDescription.call(this, mediaRequirements, sdpMessage, index, isLocalDescription, isRenegotiation, isOffer);
                    return error;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaDescriptionManager;
        }(fm.liveswitch.MediaDescriptionManagerBase));
        liveswitch.MediaDescriptionManager = MediaDescriptionManager;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var MediaDescriptionRequirementsBase = /** @class */ (function () {
            function MediaDescriptionRequirementsBase() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            MediaDescriptionRequirementsBase.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaDescriptionRequirementsBase]';
            };
            MediaDescriptionRequirementsBase.prototype.getMediaStreamIdentifier = function () {
                if (arguments.length == 0) {
                    return this._mediaStreamIdentifier;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            MediaDescriptionRequirementsBase.prototype.setMediaStreamIdentifier = function (value) {
                if (arguments.length == 1) {
                    this._mediaStreamIdentifier = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaDescriptionRequirementsBase;
        }());
        liveswitch.MediaDescriptionRequirementsBase = MediaDescriptionRequirementsBase;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="MediaDescriptionRequirementsBase.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        @internal
        */
        var MediaDescriptionRequirements = /** @class */ (function (_super) {
            __extends(MediaDescriptionRequirements, _super);
            function MediaDescriptionRequirements() {
                return _super.call(this) || this;
            }
            MediaDescriptionRequirements.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaDescriptionRequirements]' + ',' + _super.prototype.getTypeString.call(this);
            };
            return MediaDescriptionRequirements;
        }(fm.liveswitch.MediaDescriptionRequirementsBase));
        liveswitch.MediaDescriptionRequirements = MediaDescriptionRequirements;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var PluginConstants = /** @class */ (function () {
            function PluginConstants() {
            }
            PluginConstants.getLoaderClassId = function () {
                return '63655289-CA4B-3397-8168-05549188FA92';
            };
            PluginConstants.getDomVideoSinkClassId = function () {
                return '18DDDF1E-3362-38E8-90DA-7D6896912277';
            };
            return PluginConstants;
        }());
        liveswitch.PluginConstants = PluginConstants;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Util.ts" />
/// <reference path="PluginConstants.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var Plugin = /** @class */ (function () {
            function Plugin() {
            }
            Plugin.install = function (pluginConfig) {
                var promise = new fm.liveswitch.Promise();
                this._pluginConfig = pluginConfig;
                if (fm.liveswitch.Util.hasActiveX() && this._pluginConfig && this._pluginConfig.getActiveXPath()) {
                    var object = document.createElement('object');
                    object.id = 'activex.loader';
                    object.setAttribute('codebase', this._pluginConfig.getActiveXPath());
                    object.setAttribute('CLASSID', 'clsid:' + fm.liveswitch.PluginConstants.getLoaderClassId());
                    object.style.width = '0px';
                    object.style.height = '0px';
                    object.style.position = 'absolute';
                    var body = document.getElementsByTagName('body')[0];
                    body.appendChild(object);
                    this.checkForActiveX(promise, object, new Date().getTime());
                }
                else {
                    promise.resolve(null);
                }
                return promise;
            };
            Plugin.getPluginConfig = function () {
                return this._pluginConfig;
            };
            Plugin.hasRtcPeerConnection = function () {
                return (typeof RTCPeerConnection !== 'undefined');
            };
            Plugin.hasRtcDataChannel = function () {
                return (typeof RTCDataChannel !== 'undefined' || typeof window.DataChannel !== 'undefined'); // DataChannel is non-standard
            };
            Plugin.hasGetUserMedia = function () {
                return (typeof navigator.fmGetUserMedia !== 'undefined');
            };
            Plugin.hasGetDisplayMedia = function () {
                return navigator && navigator.mediaDevices && typeof navigator.mediaDevices.getDisplayMedia !== 'undefined';
            };
            Plugin.hasRtcIceGatherer = function () {
                return (typeof RTCIceGatherer !== 'undefined');
            };
            Plugin.hasRtcIceTransport = function () {
                return (typeof RTCIceTransport !== 'undefined');
            };
            Plugin.hasRtcDtlsTransport = function () {
                return (typeof RTCDtlsTransport !== 'undefined');
            };
            Plugin.hasRtcRtpSender = function () {
                return (typeof RTCRtpSender !== 'undefined');
            };
            Plugin.hasRtcRtpReceiver = function () {
                return (typeof RTCRtpReceiver !== 'undefined');
            };
            Plugin.hasWebRtc = function (localMedia, dataChannels) {
                return ((localMedia ? this.hasGetUserMedia() : true) && (dataChannels ? this.hasRtcDataChannel() : true) && this.hasRtcPeerConnection());
            };
            Plugin.hasOrtc = function (localMedia, dataChannels) {
                return ((localMedia ? this.hasGetUserMedia() : true) && (dataChannels ? this.hasRtcDataChannel() : true) && this.hasRtcIceGatherer() && this.hasRtcIceTransport() && this.hasRtcDtlsTransport() && this.hasRtcRtpSender() && this.hasRtcRtpReceiver());
            };
            Plugin.hasNative = function (localMedia, dataChannels) {
                return (this.hasWebRtc(localMedia, dataChannels) || this.hasOrtc(localMedia, dataChannels));
            };
            Plugin.hasActiveX = function () {
                return this._hasActiveX;
            };
            Plugin.isReady = function (localMedia, dataChannels) {
                return (this.hasActiveX() || this.hasNative(localMedia, dataChannels));
            };
            Plugin.isSupported = function (localMedia, dataChannels) {
                return (this.isReady(localMedia, dataChannels));
            };
            Plugin.useActiveX = function (localMedia, dataChannels) {
                if (this._pluginConfig && this._pluginConfig.getPreferActiveX()) {
                    return this.hasActiveX();
                }
                else {
                    return (this.hasActiveX() && !this.hasNative(localMedia, dataChannels));
                }
            };
            Plugin.useNative = function (localMedia, dataChannels) {
                return (!this.useActiveX(localMedia, dataChannels) && this.hasNative(localMedia, dataChannels));
            };
            Plugin.checkForActiveX = function (promise, object, startTime) {
                var _this = this;
                var loaded = false;
                try {
                    if (!fm.liveswitch.Util.isNullOrUndefined(object.GetIsLoaded)) {
                        loaded = object.GetIsLoaded();
                    }
                }
                catch (ex) {
                    loaded = false;
                }
                if (loaded) {
                    this._hasActiveX = true;
                    promise.resolve(null);
                }
                else if ((new Date().getTime() - startTime) > this._pluginConfig.getActiveXTimeout()) {
                    promise.reject(new fm.liveswitch.Exception('ActiveX install timed out.'));
                }
                else {
                    window.setTimeout(function () {
                        _this.checkForActiveX(promise, object, startTime);
                    }, 10);
                }
            };
            Plugin.getChromeExtensionId = function () {
                return fm.liveswitch.WebRtcLocalMedia.getChromeExtensionId();
            };
            Plugin.setChromeExtensionId = function (chromeExtensionId) {
                fm.liveswitch.WebRtcLocalMedia.setChromeExtensionId(chromeExtensionId);
            };
            Plugin.getChromeExtensionUrl = function () {
                return fm.liveswitch.WebRtcLocalMedia.getChromeExtensionUrl();
            };
            Plugin.getChromeExtensionInstalled = function () {
                return fm.liveswitch.WebRtcLocalMedia.getChromeExtensionInstalled();
            };
            Plugin.getChromeExtensionRequiresUserGesture = function () {
                return fm.liveswitch.WebRtcLocalMedia.getChromeExtensionRequiresUserGesture();
            };
            Plugin.setChromeExtensionRequiresUserGesture = function (chromeExtensionRequiresUserGesture) {
                fm.liveswitch.WebRtcLocalMedia.setChromeExtensionRequiresUserGesture(chromeExtensionRequiresUserGesture);
            };
            Plugin.getChromeExtensionRequired = function () {
                return fm.liveswitch.WebRtcLocalMedia.getChromeExtensionRequired();
            };
            /** @internal */
            Plugin._hasActiveX = false;
            return Plugin;
        }());
        liveswitch.Plugin = Plugin;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var PluginStream = /** @class */ (function (_super) {
            __extends(PluginStream, _super);
            function PluginStream() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            PluginStream.prototype.getTypeString = function () {
                return '[fm.liveswitch.PluginStream]' + ',' + _super.prototype.getTypeString.call(this);
            };
            return PluginStream;
        }(fm.liveswitch.Dynamic));
        liveswitch.PluginStream = PluginStream;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="PluginStream.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var PluginMediaStream = /** @class */ (function (_super) {
            __extends(PluginMediaStream, _super);
            function PluginMediaStream(localTrack, remoteTrack) {
                var _this = _super.call(this) || this;
                _this._localTrack = localTrack;
                _this._remoteTrack = remoteTrack;
                return _this;
            }
            PluginMediaStream.prototype.getTypeString = function () {
                return '[fm.liveswitch.PluginMediaStream]' + ',' + _super.prototype.getTypeString.call(this);
            };
            PluginMediaStream.prototype.getLocalTrack = function () {
                return this._localTrack;
            };
            PluginMediaStream.prototype.getRemoteTrack = function () {
                return this._remoteTrack;
            };
            return PluginMediaStream;
        }(fm.liveswitch.PluginStream));
        liveswitch.PluginMediaStream = PluginMediaStream;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var dtmf;
        (function (dtmf) {
            /**
            A DTMF (telephone-event) tone.
            */
            var Tone = /** @class */ (function () {
                function Tone() {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        //super();
                        this.fmliveswitchdtmfToneInit();
                    }
                    else if (__arguments.length == 1) {
                        var value = __arguments[0];
                        // chained constructor: Tone.call(this, value, 100);
                        __arguments = new Array(2);
                        __arguments[0] = value;
                        __arguments[1] = 100;
                        {
                            var value_1 = __arguments[0];
                            var duration = __arguments[1];
                            //super();
                            this.fmliveswitchdtmfToneInit();
                            this.setValue(value_1);
                            this.setDuration(duration);
                        }
                    }
                    else if (__arguments.length == 2) {
                        var value = __arguments[0];
                        var duration = __arguments[1];
                        //super();
                        this.fmliveswitchdtmfToneInit();
                        this.setValue(value);
                        this.setDuration(duration);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                Tone.prototype.getTypeString = function () {
                    return '[fm.liveswitch.dtmf.Tone]';
                };
                Tone.prototype.fmliveswitchdtmfToneInit = function () {
                    this._duration = 0;
                    this._end = false;
                    this._sentDuration = 0;
                };
                /** @hidden */
                Tone.eventCodeFromValue = function (eventString) {
                    if (arguments.length == 1) {
                        var _var0 = eventString;
                        if (_var0 == "0") {
                            do {
                                return 0;
                            } while (false);
                        }
                        else if (_var0 == "1") {
                            do {
                                return 1;
                            } while (false);
                        }
                        else if (_var0 == "2") {
                            do {
                                return 2;
                            } while (false);
                        }
                        else if (_var0 == "3") {
                            do {
                                return 3;
                            } while (false);
                        }
                        else if (_var0 == "4") {
                            do {
                                return 4;
                            } while (false);
                        }
                        else if (_var0 == "5") {
                            do {
                                return 5;
                            } while (false);
                        }
                        else if (_var0 == "6") {
                            do {
                                return 6;
                            } while (false);
                        }
                        else if (_var0 == "7") {
                            do {
                                return 7;
                            } while (false);
                        }
                        else if (_var0 == "8") {
                            do {
                                return 8;
                            } while (false);
                        }
                        else if (_var0 == "9") {
                            do {
                                return 9;
                            } while (false);
                        }
                        else if (_var0 == "*") {
                            do {
                                return 10;
                            } while (false);
                        }
                        else if (_var0 == "#") {
                            do {
                                return 11;
                            } while (false);
                        }
                        else if (_var0 == "A") {
                            do {
                                return 12;
                            } while (false);
                        }
                        else if (_var0 == "B") {
                            do {
                                return 13;
                            } while (false);
                        }
                        else if (_var0 == "C") {
                            do {
                                return 14;
                            } while (false);
                        }
                        else if (_var0 == "D") {
                            do {
                                return 15;
                            } while (false);
                        }
                        else if (_var0 == ",") {
                            do {
                                return 99;
                            } while (false);
                        }
                        return -1;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Deserializes from JSON.
                @param toneJson The JSON.
                */
                Tone.fromJson = function (toneJson) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.deserializeObject(toneJson, function () {
                            return new fm.liveswitch.dtmf.Tone();
                        }, function (tone, key, valueJson) {
                            var str = key;
                            if ((!fm.liveswitch.Global.equals(str, null))) {
                                if (!(fm.liveswitch.Global.equals(str, "value"))) {
                                    if ((fm.liveswitch.Global.equals(str, "duration"))) {
                                        tone.setDuration(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "end"))) {
                                            tone.setEnd(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                        }
                                    }
                                }
                                else {
                                    tone.setValue(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                }
                            }
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Deserializes an array from JSON.
                @param tonesJson The JSON.
                */
                Tone.fromJsonArray = function (tonesJson) {
                    if (arguments.length == 1) {
                        var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(tonesJson, fm.liveswitch.dtmf.Tone.fromJson.bind(fm.liveswitch.dtmf.Tone));
                        if ((fm.liveswitch.Global.equals(list, null))) {
                            return null;
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Tone.fromToneString = function () {
                    if (arguments.length == 1) {
                        var toneString = arguments[0];
                        return fm.liveswitch.dtmf.Tone.fromToneString(toneString, 100, 100);
                    }
                    else if (arguments.length == 2) {
                        var toneString = arguments[0];
                        var duration = arguments[1];
                        return fm.liveswitch.dtmf.Tone.fromToneString(toneString, duration, 100);
                    }
                    else if (arguments.length == 3) {
                        var toneString = arguments[0];
                        var duration = arguments[1];
                        var interToneGap = arguments[2];
                        duration = fm.liveswitch.MathAssistant.max(40, fm.liveswitch.MathAssistant.min(2000, duration));
                        interToneGap = fm.liveswitch.MathAssistant.max(40, interToneGap);
                        var list = new Array();
                        for (var i = 0; (i < fm.liveswitch.StringExtensions.getLength(toneString)); i++) {
                            if ((i > 0)) {
                                fm.liveswitch.ArrayExtensions.add(list, new fm.liveswitch.dtmf.Tone(fm.liveswitch.dtmf.Tone.getEmptyValue(), interToneGap));
                            }
                            var str = fm.liveswitch.StringExtensions.substring(toneString, i, 1);
                            if ((fm.liveswitch.Global.equals(str, fm.liveswitch.dtmf.Tone.getPauseValue()))) {
                                fm.liveswitch.ArrayExtensions.add(list, new fm.liveswitch.dtmf.Tone(str, 2000));
                            }
                            else {
                                fm.liveswitch.ArrayExtensions.add(list, new fm.liveswitch.dtmf.Tone(str, duration));
                            }
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets A tone.
                */
                Tone.getA = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.dtmf.Tone(fm.liveswitch.dtmf.Tone.getAValue(), 100);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the A value ("A").
                */
                Tone.getAValue = function () {
                    if (arguments.length == 0) {
                        return "A";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the B tone.
                */
                Tone.getB = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.dtmf.Tone(fm.liveswitch.dtmf.Tone.getBValue(), 100);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the B value ("B").
                */
                Tone.getBValue = function () {
                    if (arguments.length == 0) {
                        return "B";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the C tone.
                */
                Tone.getC = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.dtmf.Tone(fm.liveswitch.dtmf.Tone.getCValue(), 100);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the C value ("C").
                */
                Tone.getCValue = function () {
                    if (arguments.length == 0) {
                        return "C";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the D tone.
                */
                Tone.getD = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.dtmf.Tone(fm.liveswitch.dtmf.Tone.getDValue(), 100);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the D value ("D").
                */
                Tone.getDValue = function () {
                    if (arguments.length == 0) {
                        return "D";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the eight tone.
                */
                Tone.getEight = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.dtmf.Tone(fm.liveswitch.dtmf.Tone.getEightValue(), 100);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the eight value ("8").
                */
                Tone.getEightValue = function () {
                    if (arguments.length == 0) {
                        return "8";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the empty tone.
                */
                Tone.getEmpty = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.dtmf.Tone(fm.liveswitch.dtmf.Tone.getEmptyValue(), 0);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the empty value ("").
                */
                Tone.getEmptyValue = function () {
                    if (arguments.length == 0) {
                        return "";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the five tone.
                */
                Tone.getFive = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.dtmf.Tone(fm.liveswitch.dtmf.Tone.getFiveValue(), 100);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the five value ("5").
                */
                Tone.getFiveValue = function () {
                    if (arguments.length == 0) {
                        return "5";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the four tone.
                */
                Tone.getFour = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.dtmf.Tone(fm.liveswitch.dtmf.Tone.getFourValue(), 100);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the four value ("4").
                */
                Tone.getFourValue = function () {
                    if (arguments.length == 0) {
                        return "4";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the hash tone.
                */
                Tone.getHash = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.dtmf.Tone(fm.liveswitch.dtmf.Tone.getHashValue(), 100);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the hash value ("#").
                */
                Tone.getHashValue = function () {
                    if (arguments.length == 0) {
                        return "#";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the nine tone.
                */
                Tone.getNine = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.dtmf.Tone(fm.liveswitch.dtmf.Tone.getNineValue(), 100);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the nine value ("9").
                */
                Tone.getNineValue = function () {
                    if (arguments.length == 0) {
                        return "9";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the one tone.
                */
                Tone.getOne = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.dtmf.Tone(fm.liveswitch.dtmf.Tone.getOneValue(), 100);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the one value ("1").
                */
                Tone.getOneValue = function () {
                    if (arguments.length == 0) {
                        return "1";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the pause tone.
                */
                Tone.getPause = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.dtmf.Tone(fm.liveswitch.dtmf.Tone.getPauseValue(), 2000);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the pause duration in milliseconds (2000).
                */
                Tone.getPauseDuration = function () {
                    if (arguments.length == 0) {
                        return 2000;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the pause value (",").
                */
                Tone.getPauseValue = function () {
                    if (arguments.length == 0) {
                        return ",";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the seven tone.
                */
                Tone.getSeven = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.dtmf.Tone(fm.liveswitch.dtmf.Tone.getSevenValue(), 100);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the seven value ("7").
                */
                Tone.getSevenValue = function () {
                    if (arguments.length == 0) {
                        return "7";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the six tone.
                */
                Tone.getSix = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.dtmf.Tone(fm.liveswitch.dtmf.Tone.getSixValue(), 100);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the six value ("6").
                */
                Tone.getSixValue = function () {
                    if (arguments.length == 0) {
                        return "6";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the star tone.
                */
                Tone.getStar = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.dtmf.Tone(fm.liveswitch.dtmf.Tone.getStarValue(), 100);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the star value ("*").
                */
                Tone.getStarValue = function () {
                    if (arguments.length == 0) {
                        return "*";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the three tone.
                */
                Tone.getThree = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.dtmf.Tone(fm.liveswitch.dtmf.Tone.getThreeValue(), 100);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the three value ("3").
                */
                Tone.getThreeValue = function () {
                    if (arguments.length == 0) {
                        return "3";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the two tone.
                */
                Tone.getTwo = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.dtmf.Tone(fm.liveswitch.dtmf.Tone.getTwoValue(), 100);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the two value ("2").
                */
                Tone.getTwoValue = function () {
                    if (arguments.length == 0) {
                        return "2";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the zero tone.
                */
                Tone.getZero = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.dtmf.Tone(fm.liveswitch.dtmf.Tone.getZeroValue(), 100);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the zero value ("0").
                */
                Tone.getZeroValue = function () {
                    if (arguments.length == 0) {
                        return "0";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Serializes to JSON.
                */
                Tone.toJson = function (tone) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.serializeObject(tone, function (obj, jsonObj) {
                            jsonObj["value"] = fm.liveswitch.JsonSerializer.serializeString(obj.getValue());
                            jsonObj["duration"] = fm.liveswitch.JsonSerializer.serializeInteger(obj.getDuration());
                            jsonObj["end"] = fm.liveswitch.JsonSerializer.serializeBoolean(obj.getEnd());
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Serializes an array to JSON.
                @param tones The array.
                */
                Tone.toJsonArray = function (tones) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.serializeObjectArray(tones, fm.liveswitch.dtmf.Tone.toJson.bind(fm.liveswitch.dtmf.Tone));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Converts an array of DTMF tones into a tone string. This discards duration and inter-tone gap data.
                @param tones The tones.
                */
                Tone.toToneString = function (tones) {
                    if (arguments.length == 1) {
                        var builder = new fm.liveswitch.StringBuilder();
                        for (var _i = 0, tones_1 = tones; _i < tones_1.length; _i++) {
                            var tone = tones_1[_i];
                            builder.append(tone.getValue());
                        }
                        return builder.toString();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Tone.valueFromEventCode = function (eventCode) {
                    if (arguments.length == 1) {
                        var _var0 = eventCode;
                        if (_var0 == 0) {
                            do {
                                return "0";
                            } while (false);
                        }
                        else if (_var0 == 1) {
                            do {
                                return "1";
                            } while (false);
                        }
                        else if (_var0 == 2) {
                            do {
                                return "2";
                            } while (false);
                        }
                        else if (_var0 == 3) {
                            do {
                                return "3";
                            } while (false);
                        }
                        else if (_var0 == 4) {
                            do {
                                return "4";
                            } while (false);
                        }
                        else if (_var0 == 5) {
                            do {
                                return "5";
                            } while (false);
                        }
                        else if (_var0 == 6) {
                            do {
                                return "6";
                            } while (false);
                        }
                        else if (_var0 == 7) {
                            do {
                                return "7";
                            } while (false);
                        }
                        else if (_var0 == 8) {
                            do {
                                return "8";
                            } while (false);
                        }
                        else if (_var0 == 9) {
                            do {
                                return "9";
                            } while (false);
                        }
                        else if (_var0 == 10) {
                            do {
                                return "*";
                            } while (false);
                        }
                        else if (_var0 == 11) {
                            do {
                                return "#";
                            } while (false);
                        }
                        else if (_var0 == 12) {
                            do {
                                return "A";
                            } while (false);
                        }
                        else if (_var0 == 13) {
                            do {
                                return "B";
                            } while (false);
                        }
                        else if (_var0 == 14) {
                            do {
                                return "C";
                            } while (false);
                        }
                        else if (_var0 == 15) {
                            do {
                                return "D";
                            } while (false);
                        }
                        else if (_var0 == 99) {
                            do {
                                return ",";
                            } while (false);
                        }
                        return "";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Tone.prototype.clone = function () {
                    if (arguments.length == 0) {
                        return this.clone(this.getDuration());
                    }
                    else if (arguments.length == 1) {
                        var duration = arguments[0];
                        return new fm.liveswitch.dtmf.Tone(this.getValue(), duration);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the duration in milliseconds.
                */
                Tone.prototype.getDuration = function () {
                    if (arguments.length == 0) {
                        return this._duration;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets whether this is the final tone raised for the current value.
                */
                Tone.prototype.getEnd = function () {
                    if (arguments.length == 0) {
                        return this._end;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Tone.prototype.getSentDuration = function () {
                    if (arguments.length == 0) {
                        return this._sentDuration;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the value.
                */
                Tone.prototype.getValue = function () {
                    if (arguments.length == 0) {
                        return this._value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Tone.prototype.setDuration = function (value) {
                    if (arguments.length == 1) {
                        this._duration = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Tone.prototype.setEnd = function (value) {
                    if (arguments.length == 1) {
                        this._end = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Tone.prototype.setSentDuration = function (value) {
                    if (arguments.length == 1) {
                        this._sentDuration = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Tone.prototype.setValue = function (value) {
                    if (arguments.length == 1) {
                        this._value = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Serializes to JSON.
                */
                Tone.prototype.toJson = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.dtmf.Tone.toJson(this);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Serializes to a string.
                */
                Tone.prototype.toString = function () {
                    if (arguments.length == 0) {
                        if ((fm.liveswitch.Global.equals(this.getValue(), fm.liveswitch.dtmf.Tone.getEmptyValue()))) {
                            return fm.liveswitch.StringExtensions.format("[empty] ({0}ms)", fm.liveswitch.NumberExtensions.toString(this.getDuration()));
                        }
                        if ((fm.liveswitch.Global.equals(this.getValue(), fm.liveswitch.dtmf.Tone.getPauseValue()))) {
                            return fm.liveswitch.StringExtensions.format("[pause] ({0}ms)", fm.liveswitch.NumberExtensions.toString(this.getDuration()));
                        }
                        if (this.getEnd()) {
                            return fm.liveswitch.StringExtensions.format("{0} ({1}ms) [end]", this.getValue(), fm.liveswitch.NumberExtensions.toString(this.getDuration()));
                        }
                        return fm.liveswitch.StringExtensions.format("{0} ({1}ms)", this.getValue(), fm.liveswitch.NumberExtensions.toString(this.getDuration()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Tone;
            }());
            dtmf.Tone = Tone;
        })(dtmf = liveswitch.dtmf || (liveswitch.dtmf = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="PluginMediaStream.ts" />
/// <reference path="IPluginAudioStream.ts" />
/// <reference path="dtmf/Tone.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var PluginAudioStream = /** @class */ (function (_super) {
            __extends(PluginAudioStream, _super);
            function PluginAudioStream(external, localTrack, remoteTrack) {
                var _this = _super.call(this, localTrack, remoteTrack) || this;
                /** @internal */
                _this._onDirectionChangeValues = [];
                /** @internal */
                _this._onStateChangeValues = [];
                /** @internal */
                _this._onReceiveDtmfToneValues = [];
                /** @internal */
                _this._onReceiveDtmfToneChangeValues = [];
                /** @internal */
                _this._onSendDtmfToneValues = [];
                /** @internal */
                _this._onSendDtmfToneChangeValues = [];
                /** @internal */
                _this._onLocalEncodingDisabledValues = [];
                /** @internal */
                _this._onLocalEncodingEnabledValues = [];
                /** @internal */
                _this._onDiscardBitrateRequestValues = [];
                /** @internal */
                _this._onDiscardBitrateNotificationValues = [];
                _this._state = fm.liveswitch.StreamState.New;
                _this._external = external;
                _this._axo = new ActiveXObject("fm.liveswitch.AudioStream");
                _this._axo.Initialize(_this.getLocalTrack() == null ? 0 : _this.getLocalTrack().getMedia().getHandle(), remoteTrack == null ? 0 : remoteTrack.getMedia().getHandle());
                _this._axo.SetOnDirectionChange(function () {
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onDirectionChangeValues; _i < _a.length; _i++) {
                            var value = _a[_i];
                            value();
                        }
                    }, 1);
                });
                _this._axo.SetOnStateChange(function (state) {
                    _this._state = state;
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onStateChangeValues; _i < _a.length; _i++) {
                            var onStateChangeValue = _a[_i];
                            onStateChangeValue();
                        }
                    }, 1);
                });
                _this._axo.SetOnReceiveDtmfTone(function (toneJson) {
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onReceiveDtmfToneValues; _i < _a.length; _i++) {
                            var value = _a[_i];
                            value(fm.liveswitch.dtmf.Tone.fromJson(toneJson));
                        }
                    }, 1);
                });
                _this._axo.SetOnReceiveDtmfToneChange(function (toneJson) {
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onReceiveDtmfToneChangeValues; _i < _a.length; _i++) {
                            var value = _a[_i];
                            value(fm.liveswitch.dtmf.Tone.fromJson(toneJson));
                        }
                    }, 1);
                });
                _this._axo.SetOnSendDtmfTone(function (toneJson) {
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onSendDtmfToneValues; _i < _a.length; _i++) {
                            var value = _a[_i];
                            value(fm.liveswitch.dtmf.Tone.fromJson(toneJson));
                        }
                    }, 1);
                });
                _this._axo.SetOnSendDtmfToneChange(function (toneJson) {
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onSendDtmfToneChangeValues; _i < _a.length; _i++) {
                            var value = _a[_i];
                            value(fm.liveswitch.dtmf.Tone.fromJson(toneJson));
                        }
                    }, 1);
                });
                _this._axo.SetOnLocalEncodingDisabled(function (encodingJson) {
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onLocalEncodingDisabledValues; _i < _a.length; _i++) {
                            var value = _a[_i];
                            value(fm.liveswitch.EncodingInfo.fromJson(encodingJson));
                        }
                    }, 1);
                });
                _this._axo.SetOnLocalEncodingEnabled(function (encodingJson) {
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onLocalEncodingEnabledValues; _i < _a.length; _i++) {
                            var value = _a[_i];
                            value(fm.liveswitch.EncodingInfo.fromJson(encodingJson));
                        }
                    }, 1);
                });
                _this._axo.SetOnDiscardBitrateRequest(function (bitrateRequestJson) {
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onDiscardBitrateRequestValues; _i < _a.length; _i++) {
                            var value = _a[_i];
                            value(fm.liveswitch.BitrateRequest.fromJson(bitrateRequestJson));
                        }
                    }, 1);
                });
                _this._axo.SetOnDiscardBitrateNotification(function (bitrateNotificationJson) {
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onDiscardBitrateNotificationValues; _i < _a.length; _i++) {
                            var value = _a[_i];
                            value(fm.liveswitch.BitrateNotification.fromJson(bitrateNotificationJson));
                        }
                    }, 1);
                });
                return _this;
            }
            PluginAudioStream.prototype.getTypeString = function () {
                return '[fm.liveswitch.PluginAudioStream]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            PluginAudioStream.prototype._getExternal = function () {
                return this._external;
            };
            /** @internal */
            PluginAudioStream.prototype._getAxo = function () {
                return this._axo;
            };
            PluginAudioStream.prototype.getState = function () {
                return this._state;
            };
            PluginAudioStream.prototype.addOnStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onStateChangeValues, value);
            };
            PluginAudioStream.prototype.removeOnStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onStateChangeValues, value);
            };
            PluginAudioStream.prototype.getInfo = function () {
                return fm.liveswitch.MediaStreamInfo.fromJson(this._getAxo().GetInfo());
            };
            PluginAudioStream.prototype.getLocalReceive = function () {
                return this._getAxo().GetLocalReceive();
            };
            PluginAudioStream.prototype.getLocalSend = function () {
                return this._getAxo().GetLocalSend();
            };
            PluginAudioStream.prototype.getRemoteReceive = function () {
                return this._getAxo().GetRemoteReceive();
            };
            PluginAudioStream.prototype.getRemoteSend = function () {
                return this._getAxo().GetRemoteSend();
            };
            PluginAudioStream.prototype.setLocalReceive = function (value) {
                return this._getAxo().SetLocalReceive(value);
            };
            PluginAudioStream.prototype.setLocalSend = function (value) {
                return this._getAxo().SetLocalSend(value);
            };
            PluginAudioStream.prototype.getRemoteDirection = function () {
                return this._getAxo().GetRemoteDirection();
            };
            PluginAudioStream.prototype.getHandle = function () {
                return this._getAxo().GetHandle();
            };
            PluginAudioStream.prototype.changeDirection = function (newDirection) {
                return fm.liveswitch.Error.fromJson(this._getAxo().ChangeDirection(newDirection));
            };
            PluginAudioStream.prototype.getDirection = function () {
                return this._getAxo().GetDirection();
            };
            PluginAudioStream.prototype.getId = function () {
                return this._getAxo().GetId();
            };
            PluginAudioStream.prototype.getExternalId = function () {
                return this._getAxo().GetExternalId();
            };
            PluginAudioStream.prototype.setExternalId = function (value) {
                this._getAxo().SetExternalId(value);
            };
            PluginAudioStream.prototype.getLabel = function () {
                return this._getAxo().GetLabel();
            };
            PluginAudioStream.prototype.getLocalBandwidth = function () {
                return this._getAxo().GetLocalBandwidth();
            };
            PluginAudioStream.prototype.getLocalDirection = function () {
                return this._getAxo().GetLocalDirection();
            };
            PluginAudioStream.prototype.getInputMuted = function () {
                return this._getAxo().GetInputMuted();
            };
            PluginAudioStream.prototype.getLocalCanonicalName = function () {
                return this._getAxo().GetLocalCanonicalName();
            };
            PluginAudioStream.prototype.getOutputMuted = function () {
                return this._getAxo().GetOutputMuted();
            };
            PluginAudioStream.prototype.getMediaDescriptionId = function () {
                return this._getAxo().GetMediaDescriptionId();
            };
            PluginAudioStream.prototype.getRemoteCanonicalName = function () {
                return this._getAxo().GetRemoteCanonicalName();
            };
            PluginAudioStream.prototype.getRemoteBandwidth = function () {
                return this._getAxo().GetRemoteBandwidth();
            };
            PluginAudioStream.prototype.getTag = function () {
                return this._getAxo().GetTag();
            };
            PluginAudioStream.prototype.getType = function () {
                return fm.liveswitch.StreamType.Audio;
            };
            PluginAudioStream.prototype.setLocalDirection = function (value) {
                this._getAxo().SetLocalDirection(value);
            };
            PluginAudioStream.prototype.setLocalBandwidth = function (value) {
                this._getAxo().SetLocalBandwidth(value);
            };
            PluginAudioStream.prototype.setInputMuted = function (value) {
                this._getAxo().SetInputMuted(value);
            };
            PluginAudioStream.prototype.setOutputMuted = function (value) {
                this._getAxo().SetOutputMuted(value);
            };
            PluginAudioStream.prototype.setTag = function (value) {
                this._getAxo().SetTag(value);
            };
            PluginAudioStream.prototype.addOnDirectionChange = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onDirectionChangeValues, value);
            };
            PluginAudioStream.prototype.removeOnDirectionChange = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onDirectionChangeValues, value);
            };
            PluginAudioStream.prototype.addOnReceiveDtmfTone = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onReceiveDtmfToneValues, value);
            };
            PluginAudioStream.prototype.addOnReceiveDtmfToneChange = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onReceiveDtmfToneChangeValues, value);
            };
            PluginAudioStream.prototype.addOnSendDtmfTone = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onSendDtmfToneValues, value);
            };
            PluginAudioStream.prototype.addOnSendDtmfToneChange = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onSendDtmfToneChangeValues, value);
            };
            PluginAudioStream.prototype.insertDtmfTone = function (dtmfTone) {
                return this._getAxo().InsertDtmfTone(fm.liveswitch.dtmf.Tone.toJson(dtmfTone));
            };
            PluginAudioStream.prototype.insertDtmfTones = function (dtmfTones) {
                return this._getAxo().InsertDtmfTones(fm.liveswitch.dtmf.Tone.toJsonArray(dtmfTones));
            };
            PluginAudioStream.prototype.removeOnReceiveDtmfTone = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onReceiveDtmfToneValues, value);
            };
            PluginAudioStream.prototype.removeOnReceiveDtmfToneChange = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onReceiveDtmfToneChangeValues, value);
            };
            PluginAudioStream.prototype.removeOnSendDtmfTone = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onSendDtmfToneValues, value);
            };
            PluginAudioStream.prototype.removeOnSendDtmfToneChange = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onSendDtmfToneChangeValues, value);
            };
            PluginAudioStream.prototype.getPreferredCodecs = function () {
                return this._getAxo().GetPreferredCodecs();
            };
            PluginAudioStream.prototype.setPreferredCodecs = function (names) {
                this._getAxo().SetPreferredCodecs(names);
            };
            PluginAudioStream.prototype.getCodecDisabled = function (name) {
                return this._getAxo().GetCodecDisabled(name);
            };
            PluginAudioStream.prototype.setCodecDisabled = function (name, disabled) {
                this._getAxo().SetCodecDisabled(name, disabled);
            };
            PluginAudioStream.prototype.getOpusDisabled = function () {
                return this._getAxo().GetOpusDisabled();
            };
            PluginAudioStream.prototype.getG722Disabled = function () {
                return this._getAxo().GetG722Disabled();
            };
            PluginAudioStream.prototype.getPcmuDisabled = function () {
                return this._getAxo().GetPcmuDisabled();
            };
            PluginAudioStream.prototype.getPcmaDisabled = function () {
                return this._getAxo().GetPcmaDisabled();
            };
            PluginAudioStream.prototype.setOpusDisabled = function (value) {
                return this._getAxo().SetOpusDisabled(value);
            };
            PluginAudioStream.prototype.setG722Disabled = function (value) {
                return this._getAxo().SetG722Disabled(value);
            };
            PluginAudioStream.prototype.setPcmuDisabled = function (value) {
                return this._getAxo().SetPcmuDisabled(value);
            };
            PluginAudioStream.prototype.setPcmaDisabled = function (value) {
                return this._getAxo().SetPcmaDisabled(value);
            };
            PluginAudioStream.prototype.getRemoteEncoding = function () {
                return fm.liveswitch.EncodingInfo.fromJson(this._getAxo().GetRemoteEncoding());
            };
            PluginAudioStream.prototype.setRemoteEncoding = function (value) {
                this._getAxo().SetRemoteEncoding(fm.liveswitch.EncodingInfo.toJson(value));
            };
            PluginAudioStream.prototype.getSimulcastMode = function () {
                return this._getAxo().GetSimulcastMode();
            };
            PluginAudioStream.prototype.setSimulcastMode = function (value) {
                this._getAxo().SetSimulcastMode(value);
            };
            PluginAudioStream.prototype.getTransportInfo = function () {
                return fm.liveswitch.TransportInfo.fromJson(this._getAxo().GetTransportInfo());
            };
            PluginAudioStream.prototype.getControlTransportInfo = function () {
                return fm.liveswitch.TransportInfo.fromJson(this._getAxo().GetControlTransportInfo());
            };
            PluginAudioStream.prototype.addOnLocalEncodingDisabled = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onLocalEncodingDisabledValues, value);
            };
            PluginAudioStream.prototype.addOnLocalEncodingEnabled = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onLocalEncodingEnabledValues, value);
            };
            PluginAudioStream.prototype.removeOnLocalEncodingDisabled = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onLocalEncodingDisabledValues, value);
            };
            PluginAudioStream.prototype.removeOnLocalEncodingEnabled = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onLocalEncodingEnabledValues, value);
            };
            PluginAudioStream.prototype.addOnDiscardBitrateRequest = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onDiscardBitrateRequestValues, value);
            };
            PluginAudioStream.prototype.removeOnDiscardBitrateRequest = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onDiscardBitrateRequestValues, value);
            };
            PluginAudioStream.prototype.raiseBitrateRequest = function (bitrateRequest) {
                return this._axo.RaiseBitrateRequest(fm.liveswitch.BitrateRequest.toJson(bitrateRequest));
            };
            PluginAudioStream.prototype.addOnDiscardBitrateNotification = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onDiscardBitrateNotificationValues, value);
            };
            PluginAudioStream.prototype.removeOnDiscardBitrateNotification = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onDiscardBitrateNotificationValues, value);
            };
            PluginAudioStream.prototype.raiseBitrateNotification = function (bitrateNotification) {
                return this._axo.RaiseBitrateNotification(fm.liveswitch.BitrateNotification.toJson(bitrateNotification));
            };
            PluginAudioStream.prototype.getMaxSendBitrate = function () {
                return this._getAxo().GetMaxSendBitrate();
            };
            PluginAudioStream.prototype.setMaxSendBitrate = function (value) {
                this._getAxo().SetMaxSendBitrate(value);
            };
            PluginAudioStream.prototype.getMaxReceiveBitrate = function () {
                return this._getAxo().GetMaxReceiveBitrate();
            };
            PluginAudioStream.prototype.setMaxReceiveBitrate = function (value) {
                this._getAxo().SetMaxReceiveBitrate(value);
            };
            return PluginAudioStream;
        }(fm.liveswitch.PluginMediaStream));
        liveswitch.PluginAudioStream = PluginAudioStream;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var PluginMediaTrack = /** @class */ (function (_super) {
            __extends(PluginMediaTrack, _super);
            function PluginMediaTrack(media) {
                var _this = _super.call(this) || this;
                _this._media = media;
                return _this;
            }
            PluginMediaTrack.prototype.getTypeString = function () {
                return '[fm.liveswitch.PluginMediaTrack]' + ',' + _super.prototype.getTypeString.call(this);
            };
            PluginMediaTrack.prototype.getMedia = function () {
                return this._media;
            };
            PluginMediaTrack.prototype.destroy = function () {
                //TODO: ?
                return true;
            };
            return PluginMediaTrack;
        }(fm.liveswitch.Dynamic));
        liveswitch.PluginMediaTrack = PluginMediaTrack;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="PluginMediaTrack.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var PluginAudioTrack = /** @class */ (function (_super) {
            __extends(PluginAudioTrack, _super);
            function PluginAudioTrack(external, media) {
                var _this = _super.call(this, media) || this;
                _this._external = external;
                return _this;
            }
            PluginAudioTrack.prototype.getTypeString = function () {
                return '[fm.liveswitch.PluginAudioTrack]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            PluginAudioTrack.prototype._getExternal = function () {
                return this._external;
            };
            PluginAudioTrack.prototype.isLocal = function () {
                return (fm.liveswitch.Util.isObjectType(this.getMedia(), '[fm.liveswitch.PluginLocalMedia]'));
            };
            PluginAudioTrack.prototype.addOnStarted = function (value) {
                if (!this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call AudioTrack.addOnStarted on a remote track.');
                }
                this.getMedia().addOnAudioStarted(value);
            };
            PluginAudioTrack.prototype.addOnStopped = function (value) {
                if (!this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call AudioTrack.addOnStopped on a remote track.');
                }
                this.getMedia().addOnAudioStopped(value);
            };
            PluginAudioTrack.prototype.addOnDestroyed = function (value) {
                this.getMedia().addOnAudioDestroyed(value);
            };
            PluginAudioTrack.prototype.removeOnStarted = function (value) {
                if (!this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call AudioTrack.removeOnStarted on a remote track.');
                }
                this.getMedia().removeOnAudioStarted(value);
            };
            PluginAudioTrack.prototype.removeOnStopped = function (value) {
                if (!this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call AudioTrack.removeOnStopped on a remote track.');
                }
                this.getMedia().removeOnAudioStopped(value);
            };
            PluginAudioTrack.prototype.removeOnDestroyed = function (value) {
                this.getMedia().removeOnAudioDestroyed(value);
            };
            PluginAudioTrack.prototype.changeSinkOutput = function (sinkOutput) {
                if (this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call AudioTrack.changeSinkOutput on a local track.');
                }
                return this.getMedia().changeAudioSinkOutput(sinkOutput);
            };
            PluginAudioTrack.prototype.getSinkOutput = function () {
                if (this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call AudioTrack.getSinkOutput on a local track.');
                }
                return this.getMedia().getAudioSinkOutput();
            };
            PluginAudioTrack.prototype.getSinkOutputs = function () {
                if (this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call AudioTrack.getSinkOutputs on a local track.');
                }
                return this.getMedia().getAudioSinkOutputs();
            };
            PluginAudioTrack.prototype.setSinkOutput = function (value) {
                if (this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call AudioTrack.setSinkOutput on a local track.');
                }
                this.getMedia().setAudioSinkOutput(value);
            };
            PluginAudioTrack.prototype.changeSourceInput = function (sourceInput) {
                if (!this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call AudioTrack.changeSourceInput on a remote track.');
                }
                return this.getMedia().changeAudioSourceInput(sourceInput);
            };
            PluginAudioTrack.prototype.getSourceInput = function () {
                if (!this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call AudioTrack.getSourceInput on a remote track.');
                }
                return this.getMedia().getAudioSourceInput();
            };
            PluginAudioTrack.prototype.getSourceInputs = function () {
                if (!this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call AudioTrack.getSourceInputs on a remote track.');
                }
                return this.getMedia().getAudioSourceInputs();
            };
            PluginAudioTrack.prototype.setSourceInput = function (value) {
                if (!this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call AudioTrack.setSourceInput on a remote track.');
                }
                this.getMedia().setAudioSourceInput(value);
            };
            PluginAudioTrack.prototype.addOnLevel = function (value) {
                this.getMedia().addOnAudioLevel(value);
            };
            PluginAudioTrack.prototype.getGain = function () {
                return this.getMedia().getAudioGain();
            };
            PluginAudioTrack.prototype.getMuted = function () {
                return this.getMedia().getAudioMuted();
            };
            PluginAudioTrack.prototype.getVolume = function () {
                return this.getMedia().getAudioVolume();
            };
            PluginAudioTrack.prototype.removeOnLevel = function (value) {
                this.getMedia().removeOnAudioLevel(value);
            };
            PluginAudioTrack.prototype.setGain = function (value) {
                this.getMedia().setAudioGain(value);
            };
            PluginAudioTrack.prototype.setMuted = function (value) {
                this.getMedia().setAudioMuted(value);
            };
            PluginAudioTrack.prototype.setVolume = function (value) {
                this.getMedia().setAudioVolume(value);
            };
            return PluginAudioTrack;
        }(fm.liveswitch.PluginMediaTrack));
        liveswitch.PluginAudioTrack = PluginAudioTrack;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var PluginConfig = /** @class */ (function () {
            function PluginConfig() {
                this._activeXTimeout = 30000; // 30 secs
                this._preferActiveX = false;
            }
            PluginConfig.prototype.getActiveXPath = function () {
                return this._activeXPath;
            };
            PluginConfig.prototype.setActiveXPath = function (activeXPath) {
                this._activeXPath = activeXPath;
            };
            PluginConfig.prototype.getActiveXTimeout = function () {
                return this._activeXTimeout;
            };
            PluginConfig.prototype.setActiveXTimeout = function (activeXTimeout) {
                this._activeXTimeout = activeXTimeout;
            };
            PluginConfig.prototype.getPreferActiveX = function () {
                return this._preferActiveX;
            };
            PluginConfig.prototype.setPreferActiveX = function (preferActiveX) {
                this._preferActiveX = preferActiveX;
            };
            return PluginConfig;
        }());
        liveswitch.PluginConfig = PluginConfig;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />
/// <reference path="IPluginConnection.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var PluginConnection = /** @class */ (function (_super) {
            __extends(PluginConnection, _super);
            function PluginConnection(external, streams) {
                var _this = _super.call(this) || this;
                /** @internal */
                _this._onLocalCandidateValues = [];
                /** @internal */
                _this._onLocalDescriptionValues = [];
                /** @internal */
                _this._onRemoteCandidateValues = [];
                /** @internal */
                _this._onRemoteDescriptionValues = [];
                /** @internal */
                _this._onSignallingStateChangeValues = [];
                /** @internal */
                _this._onIceConnectionStateChangeValues = [];
                /** @internal */
                _this._onStateChangeValues = [];
                /** @internal */
                _this._onGatheringStateChangeValues = [];
                /** @internal */
                _this._onExternalIdChangeValues = [];
                _this._gatheringState = fm.liveswitch.IceGatheringState.New;
                _this._iceConnectionState = fm.liveswitch.IceConnectionState.New;
                _this._signallingState = fm.liveswitch.SignallingState.New;
                _this._state = fm.liveswitch.ConnectionState.New;
                _this._external = external;
                _this._streams = streams;
                _this._axo = new ActiveXObject("fm.liveswitch.Connection");
                _this._axo.Initialize(fm.liveswitch.ArrayExtensions.map(_this._streams, function (stream) {
                    return stream.getHandle();
                }));
                // event proxy
                _this._axo.SetOnLocalCandidate(function (candidate) {
                    setTimeout(function () {
                        var localCandidate = fm.liveswitch.Candidate.fromJson(candidate);
                        fm.liveswitch.Log.debug(fm.liveswitch.StringExtensions.format("Local candidate for stream {0}:\r\n{1}", fm.liveswitch.NumberExtensions.toString(localCandidate.getSdpMediaIndex()), localCandidate.getSdpCandidateAttribute().toString()));
                        for (var _i = 0, _a = _this._onLocalCandidateValues; _i < _a.length; _i++) {
                            var onLocalCandidateValue = _a[_i];
                            onLocalCandidateValue(_this, localCandidate);
                        }
                    }, 1);
                });
                _this._axo.SetOnIceConnectionStateChange(function (iceConnectionState) {
                    _this._iceConnectionState = iceConnectionState;
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onIceConnectionStateChangeValues; _i < _a.length; _i++) {
                            var onIceConnectionStateChangeValue = _a[_i];
                            onIceConnectionStateChangeValue(_this);
                        }
                    }, 1);
                });
                _this._axo.SetOnGatheringStateChange(function (gatheringState) {
                    _this._gatheringState = gatheringState;
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onGatheringStateChangeValues; _i < _a.length; _i++) {
                            var onGatheringStateChangeValue = _a[_i];
                            onGatheringStateChangeValue(_this);
                        }
                    }, 1);
                });
                _this._axo.SetOnLocalDescription(function (sessionDescription) {
                    setTimeout(function () {
                        var localDescription = fm.liveswitch.SessionDescription.fromJson(sessionDescription);
                        fm.liveswitch.Log.debug(fm.liveswitch.StringExtensions.format("Local session description ({0}):\r\n{1}", fm.liveswitch.StringExtensions.toLower(new fm.liveswitch.SessionDescriptionTypeWrapper(localDescription.getType()).toString()), localDescription.getSdpMessage().toString()));
                        for (var _i = 0, _a = _this._onLocalDescriptionValues; _i < _a.length; _i++) {
                            var onLocalDescriptionValue = _a[_i];
                            onLocalDescriptionValue(_this, localDescription);
                        }
                    }, 1);
                });
                _this._axo.SetOnRemoteCandidate(function (candidate) {
                    setTimeout(function () {
                        var remoteCandidate = fm.liveswitch.Candidate.fromJson(candidate);
                        fm.liveswitch.Log.debug(fm.liveswitch.StringExtensions.format("Remote candidate for stream {0}:\r\n{1}", fm.liveswitch.NumberExtensions.toString(remoteCandidate.getSdpMediaIndex()), remoteCandidate.getSdpCandidateAttribute().toString()));
                        for (var _i = 0, _a = _this._onRemoteCandidateValues; _i < _a.length; _i++) {
                            var onRemoteCandidateValue = _a[_i];
                            onRemoteCandidateValue(_this, remoteCandidate);
                        }
                    }, 1);
                });
                _this._axo.SetOnRemoteDescription(function (sessionDescription) {
                    setTimeout(function () {
                        var remoteDescription = fm.liveswitch.SessionDescription.fromJson(sessionDescription);
                        fm.liveswitch.Log.debug(fm.liveswitch.StringExtensions.format("Remote session description ({0}):\r\n{1}", fm.liveswitch.StringExtensions.toLower(new fm.liveswitch.SessionDescriptionTypeWrapper(remoteDescription.getType()).toString()), remoteDescription.getSdpMessage().toString()));
                        for (var _i = 0, _a = _this._onRemoteDescriptionValues; _i < _a.length; _i++) {
                            var onRemoteDescriptionValue = _a[_i];
                            onRemoteDescriptionValue(_this, remoteDescription);
                        }
                    }, 1);
                });
                _this._axo.SetOnSignallingStateChange(function (signallingState) {
                    _this._signallingState = signallingState;
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onSignallingStateChangeValues; _i < _a.length; _i++) {
                            var onSignallingStateChangeValue = _a[_i];
                            onSignallingStateChangeValue(_this);
                        }
                    }, 1);
                });
                _this._axo.SetOnStateChange(function (state) {
                    _this._state = state;
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onStateChangeValues; _i < _a.length; _i++) {
                            var onStateChangeValue = _a[_i];
                            onStateChangeValue(_this);
                        }
                    }, 1);
                });
                _this._axo.SetOnExternalIdChange(function (id1, id2) {
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onExternalIdChangeValues; _i < _a.length; _i++) {
                            var onExternalIdChangeValue = _a[_i];
                            onExternalIdChangeValue(id1, id2);
                        }
                    }, 1);
                });
                return _this;
            }
            PluginConnection.prototype.getTypeString = function () {
                return '[fm.liveswitch.PluginConnection]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            PluginConnection.prototype._getExternal = function () {
                return this._external;
            };
            /** @internal */
            PluginConnection.prototype._getAxo = function () {
                return this._axo;
            };
            PluginConnection.prototype.addIceServer = function (iceServer) {
                this._getAxo().AddIceServer(fm.liveswitch.IceServer.toJson(iceServer));
            };
            PluginConnection.prototype.addIceServers = function (iceServers) {
                this._getAxo().AddIceServers(fm.liveswitch.IceServer.toJsonArray(iceServers));
            };
            PluginConnection.prototype.addOnLocalCandidate = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onLocalCandidateValues, value);
            };
            PluginConnection.prototype.addOnExternalIdChange = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onExternalIdChangeValues, value);
            };
            PluginConnection.prototype.addOnIceConnectionStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onIceConnectionStateChangeValues, value);
            };
            PluginConnection.prototype.addOnGatheringStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onGatheringStateChangeValues, value);
            };
            PluginConnection.prototype.addOnLocalDescription = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onLocalDescriptionValues, value);
            };
            PluginConnection.prototype.addOnRemoteCandidate = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onRemoteCandidateValues, value);
            };
            PluginConnection.prototype.addOnRemoteDescription = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onRemoteDescriptionValues, value);
            };
            PluginConnection.prototype.addOnSignallingStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onSignallingStateChangeValues, value);
            };
            PluginConnection.prototype.addOnStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onStateChangeValues, value);
            };
            PluginConnection.prototype.addRemoteCandidate = function (remoteCandidate) {
                var promise = new fm.liveswitch.Promise();
                var innerPromise = new fm.liveswitch.Promise();
                innerPromise.then(function (remoteCandidateJson) {
                    promise.resolve(fm.liveswitch.Candidate.fromJson(remoteCandidateJson));
                }, function (error) {
                    promise.reject(new fm.liveswitch.Exception(error));
                });
                this._getAxo().AddRemoteCandidate(fm.liveswitch.Candidate.toJson(remoteCandidate), innerPromise);
                return promise;
            };
            PluginConnection.prototype.close = function () {
                return this._getAxo().Close();
            };
            PluginConnection.prototype.createAnswer = function () {
                var promise = new fm.liveswitch.Promise();
                var innerPromise = new fm.liveswitch.Promise();
                innerPromise.then(function (answerJson) {
                    promise.resolve(fm.liveswitch.SessionDescription.fromJson(answerJson));
                }, function (error) {
                    promise.reject(new fm.liveswitch.Exception(error));
                });
                this._getAxo().CreateAnswer(innerPromise);
                return promise;
            };
            PluginConnection.prototype.createOffer = function () {
                var promise = new fm.liveswitch.Promise();
                var innerPromise = new fm.liveswitch.Promise();
                innerPromise.then(function (offerJson) {
                    promise.resolve(fm.liveswitch.SessionDescription.fromJson(offerJson));
                }, function (error) {
                    promise.reject(new fm.liveswitch.Exception(error));
                });
                this._getAxo().CreateOffer(innerPromise);
                return promise;
            };
            PluginConnection.prototype.getHasAudio = function () {
                return (this.getAudioStream() != null);
            };
            PluginConnection.prototype.getHasVideo = function () {
                return (this.getVideoStream() != null);
            };
            PluginConnection.prototype.getHasData = function () {
                return (this.getDataStream() != null);
            };
            PluginConnection.prototype.getAudioStream = function () {
                return fm.liveswitch.Utility.firstOrDefault(this.getAudioStreams());
            };
            PluginConnection.prototype.getAudioStreams = function () {
                var streams = [];
                for (var _i = 0, _a = this._streams; _i < _a.length; _i++) {
                    var stream = _a[_i];
                    if (stream.getType() == fm.liveswitch.StreamType.Audio) {
                        streams.push(stream);
                    }
                }
                return streams;
            };
            PluginConnection.prototype.getVideoStream = function () {
                return fm.liveswitch.Utility.firstOrDefault(this.getVideoStreams());
            };
            PluginConnection.prototype.getVideoStreams = function () {
                var streams = [];
                for (var _i = 0, _a = this._streams; _i < _a.length; _i++) {
                    var stream = _a[_i];
                    if (stream.getType() == fm.liveswitch.StreamType.Video) {
                        streams.push(stream);
                    }
                }
                return streams;
            };
            PluginConnection.prototype.getDataStream = function () {
                return fm.liveswitch.Utility.firstOrDefault(this.getDataStreams());
            };
            PluginConnection.prototype.getDataStreams = function () {
                var streams = [];
                for (var _i = 0, _a = this._streams; _i < _a.length; _i++) {
                    var stream = _a[_i];
                    if (stream.getType() == fm.liveswitch.StreamType.Application) {
                        streams.push(stream);
                    }
                }
                return streams;
            };
            PluginConnection.prototype.getDeadStreamTimeout = function () {
                return this._getAxo().GetDeadStreamTimeout();
            };
            PluginConnection.prototype.getExternalId = function () {
                return this._getAxo().GetExternalId();
            };
            PluginConnection.prototype.getError = function () {
                return fm.liveswitch.Error.fromJson(this._getAxo().GetError());
            };
            PluginConnection.prototype.getIceGatherPolicy = function () {
                return this._getAxo().GetIceGatherPolicy();
            };
            PluginConnection.prototype.getBundlePolicy = function () {
                return this._getAxo().GetBundlePolicy();
            };
            PluginConnection.prototype.getIceServer = function () {
                return fm.liveswitch.IceServer.fromJson(this._getAxo().GetIceServer());
            };
            PluginConnection.prototype.getIceServers = function () {
                return fm.liveswitch.IceServer.fromJsonArray(this._getAxo().GetIceServers());
            };
            PluginConnection.prototype.getId = function () {
                return this._getAxo().GetId();
            };
            PluginConnection.prototype.getCanonicalName = function () {
                return this._getAxo().GetCanonicalName();
            };
            PluginConnection.prototype.getLocalDescription = function () {
                return fm.liveswitch.SessionDescription.fromJson(this._getAxo().GetLocalDescription());
            };
            PluginConnection.prototype.getRemoteDescription = function () {
                return fm.liveswitch.SessionDescription.fromJson(this._getAxo().GetRemoteDescription());
            };
            PluginConnection.prototype.getSignallingState = function () {
                return this._signallingState;
            };
            PluginConnection.prototype.getState = function () {
                return this._state;
            };
            PluginConnection.prototype.getStats = function () {
                var promise = new fm.liveswitch.Promise();
                var innerPromise = new fm.liveswitch.Promise();
                innerPromise.then(function (statsJson) {
                    promise.resolve(fm.liveswitch.ConnectionStats.fromJson(statsJson));
                }, function (error) {
                    promise.reject(new fm.liveswitch.Exception(error));
                });
                this._getAxo().GetStats(innerPromise);
                return promise;
            };
            PluginConnection.prototype.getStreams = function () {
                return this._streams;
            };
            PluginConnection.prototype.getTieBreaker = function () {
                return this._getAxo().GetTieBreaker();
            };
            PluginConnection.prototype.getTimeout = function () {
                return this._getAxo().GetTimeout();
            };
            PluginConnection.prototype.getLegacyTimeout = function () {
                return this._getAxo().GetLegacyTimeout();
            };
            PluginConnection.prototype.getTrickleIcePolicy = function () {
                return this._getAxo().GetTrickleIcePolicy();
            };
            PluginConnection.prototype.getIceConnectionState = function () {
                return this._iceConnectionState;
            };
            PluginConnection.prototype.getGatheringState = function () {
                return this._gatheringState;
            };
            PluginConnection.prototype.removeIceServer = function (iceServer) {
                this._getAxo().RemoveIceServer(fm.liveswitch.IceServer.toJson(iceServer));
            };
            PluginConnection.prototype.removeIceServers = function (iceServers) {
                this._getAxo().RemoveIceServers(fm.liveswitch.IceServer.toJsonArray(iceServers));
            };
            PluginConnection.prototype.removeOnLocalCandidate = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onLocalCandidateValues, value);
            };
            PluginConnection.prototype.removeOnIceConnectionStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onIceConnectionStateChangeValues, value);
            };
            PluginConnection.prototype.removeOnExternalIdChange = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onExternalIdChangeValues, value);
            };
            PluginConnection.prototype.removeOnGatheringStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onGatheringStateChangeValues, value);
            };
            PluginConnection.prototype.removeOnLocalDescription = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onLocalDescriptionValues, value);
            };
            PluginConnection.prototype.removeOnRemoteCandidate = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onRemoteCandidateValues, value);
            };
            PluginConnection.prototype.removeOnRemoteDescription = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onRemoteDescriptionValues, value);
            };
            PluginConnection.prototype.removeOnSignallingStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onSignallingStateChangeValues, value);
            };
            PluginConnection.prototype.removeOnStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onStateChangeValues, value);
            };
            PluginConnection.prototype.setDeadStreamTimeout = function (value) {
                this._getAxo().SetDeadStreamTimeout(value);
            };
            PluginConnection.prototype.setExternalId = function (value) {
                this._getAxo().SetExternalId(value);
            };
            PluginConnection.prototype.setError = function (value) {
                this._getAxo().SetError(fm.liveswitch.Error.toJson(value));
            };
            PluginConnection.prototype.setIceGatherPolicy = function (value) {
                this._getAxo().SetIceGatherPolicy(value);
            };
            PluginConnection.prototype.setBundlePolicy = function (value) {
                this._getAxo().SetBundlePolicy(value);
            };
            PluginConnection.prototype.setIceServer = function (value) {
                this._getAxo().SetIceServer(fm.liveswitch.IceServer.toJson(value));
            };
            PluginConnection.prototype.setIceServers = function (value) {
                this._getAxo().SetIceServers(fm.liveswitch.IceServer.toJsonArray(value));
            };
            PluginConnection.prototype.setLegacyTimeout = function (value) {
                this._getAxo().SetLegacyTimeout(value);
            };
            PluginConnection.prototype.setTieBreaker = function (value) {
                this._getAxo().SetTieBreaker(value);
            };
            PluginConnection.prototype.setLocalDescription = function (localDescription) {
                var promise = new fm.liveswitch.Promise();
                var innerPromise = new fm.liveswitch.Promise();
                innerPromise.then(function (localDescriptionJson) {
                    promise.resolve(fm.liveswitch.SessionDescription.fromJson(localDescriptionJson));
                }, function (error) {
                    promise.reject(new fm.liveswitch.Exception(error));
                });
                this._getAxo().SetLocalDescription(fm.liveswitch.SessionDescription.toJson(localDescription), innerPromise);
                return promise;
            };
            PluginConnection.prototype.setRemoteDescription = function (remoteDescription) {
                var promise = new fm.liveswitch.Promise();
                var innerPromise = new fm.liveswitch.Promise();
                innerPromise.then(function (remoteDescriptionJson) {
                    promise.resolve(fm.liveswitch.SessionDescription.fromJson(remoteDescriptionJson));
                }, function (error) {
                    promise.reject(new fm.liveswitch.Exception(error));
                });
                this._getAxo().SetRemoteDescription(fm.liveswitch.SessionDescription.toJson(remoteDescription), innerPromise);
                return promise;
            };
            PluginConnection.prototype.setTimeout = function (value) {
                this._getAxo().SetTimeout(value);
            };
            PluginConnection.prototype.setTrickleIcePolicy = function (value) {
                this._getAxo().SetTrickleIcePolicy(value);
            };
            return PluginConnection;
        }(fm.liveswitch.Dynamic));
        liveswitch.PluginConnection = PluginConnection;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />
/// <reference path="IPluginDataChannel.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var PluginDataChannel = /** @class */ (function (_super) {
            __extends(PluginDataChannel, _super);
            function PluginDataChannel(external, label, ordered, subprotocol) {
                var _this = _super.call(this) || this;
                /** @internal */
                _this._onStateChangeValues = [];
                /** @internal */
                _this._onReceive = null;
                _this._state = fm.liveswitch.DataChannelState.New;
                _this._getRemoteConnectionInfo = null;
                _this._external = external;
                _this._axo = new ActiveXObject("fm.liveswitch.DataChannel");
                _this._axo.Initialize(label, ordered, subprotocol);
                // event proxy
                _this._axo.SetOnStateChange(function (state) {
                    _this._state = state;
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onStateChangeValues; _i < _a.length; _i++) {
                            var onStateChangeValue = _a[_i];
                            onStateChangeValue(_this);
                        }
                    }, 1);
                });
                _this._axo.SetOnReceive(function (data, connectionId, isByte) {
                    setTimeout(function () {
                        var e = new fm.liveswitch.DataChannelReceiveArgs();
                        if (isByte) {
                            e.setDataBytes(fm.liveswitch.DataBuffer.wrap(fm.liveswitch.Base64.decode(data)));
                        }
                        else {
                            e.setDataString(data);
                        }
                        if (connectionId != null && _this._getRemoteConnectionInfo != null) {
                            e.setRemoteConnectionInfo(_this._getRemoteConnectionInfo(connectionId));
                        }
                        if (_this._onReceive) {
                            _this._onReceive(e);
                        }
                    }, 1);
                });
                return _this;
            }
            PluginDataChannel.prototype.getTypeString = function () {
                return '[fm.liveswitch.PluginDataChannel]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            PluginDataChannel.prototype._getExternal = function () {
                return this._external;
            };
            /** @internal */
            PluginDataChannel.prototype._getAxo = function () {
                return this._axo;
            };
            PluginDataChannel.prototype.getHandle = function () {
                return this._axo.GetHandle();
            };
            PluginDataChannel.prototype.setGetRemoteConnectionInfo = function (value) {
                this._getRemoteConnectionInfo = value;
            };
            PluginDataChannel.prototype.getInfo = function () {
                return fm.liveswitch.DataChannelInfo.fromJson(this._getAxo().GetInfo());
            };
            PluginDataChannel.prototype.addOnStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onStateChangeValues, value);
            };
            PluginDataChannel.prototype.getLabel = function () {
                return this._getAxo().GetLabel();
            };
            PluginDataChannel.prototype.getOnReceive = function () {
                return this._onReceive;
            };
            PluginDataChannel.prototype.getOrdered = function () {
                return this._getAxo().GetOrdered();
            };
            PluginDataChannel.prototype.getId = function () {
                return this._getAxo().GetId();
            };
            PluginDataChannel.prototype.getState = function () {
                return this._state;
            };
            PluginDataChannel.prototype.getSubprotocol = function () {
                return this._getAxo().GetSubprotocol();
            };
            PluginDataChannel.prototype.removeOnStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onStateChangeValues, value);
            };
            PluginDataChannel.prototype.sendDataBytes = function (dataBytes) {
                var promise = new fm.liveswitch.Promise();
                var strDataBytes = fm.liveswitch.Base64.encodeBuffer(dataBytes);
                this._getAxo().PrepareAndSendBytes(strDataBytes, promise);
                return promise;
            };
            PluginDataChannel.prototype.sendDataString = function (dataString) {
                var promise = new fm.liveswitch.Promise();
                this._getAxo().PrepareAndSendString(dataString, promise);
                return promise;
            };
            PluginDataChannel.prototype.setOnReceive = function (value) {
                this._onReceive = value;
            };
            return PluginDataChannel;
        }(fm.liveswitch.Dynamic));
        liveswitch.PluginDataChannel = PluginDataChannel;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="PluginStream.ts" />
/// <reference path="IPluginDataStream.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var PluginDataStream = /** @class */ (function (_super) {
            __extends(PluginDataStream, _super);
            function PluginDataStream(external, channels) {
                var _this = _super.call(this) || this;
                /** @internal */
                _this._onDirectionChangeValues = [];
                /** @internal */
                _this._onStateChangeValues = [];
                _this._state = fm.liveswitch.StreamState.New;
                _this._external = external;
                _this._channels = channels;
                _this._axo = new ActiveXObject("fm.liveswitch.DataStream");
                _this._axo.Initialize(fm.liveswitch.ArrayExtensions.map(channels, function (channel) {
                    return channel.getHandle();
                }));
                _this._axo.SetOnDirectionChange(function () {
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onDirectionChangeValues; _i < _a.length; _i++) {
                            var onDirectionChangeValue = _a[_i];
                            onDirectionChangeValue();
                        }
                    }, 1);
                });
                _this._axo.SetOnStateChange(function (state) {
                    _this._state = state;
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onStateChangeValues; _i < _a.length; _i++) {
                            var onStateChangeValue = _a[_i];
                            onStateChangeValue();
                        }
                    }, 1);
                });
                return _this;
            }
            PluginDataStream.prototype.getTypeString = function () {
                return '[fm.liveswitch.PluginDataStream]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            PluginDataStream.prototype._getExternal = function () {
                return this._external;
            };
            /** @internal */
            PluginDataStream.prototype._getAxo = function () {
                return this._axo;
            };
            PluginDataStream.prototype.getState = function () {
                return this._state;
            };
            PluginDataStream.prototype.addOnStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onStateChangeValues, value);
            };
            PluginDataStream.prototype.removeOnStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onStateChangeValues, value);
            };
            PluginDataStream.prototype.getInfo = function () {
                return fm.liveswitch.DataStreamInfo.fromJson(this._getAxo().GetInfo());
            };
            PluginDataStream.prototype.getLocalReceive = function () {
                return this._getAxo().GetLocalReceive();
            };
            PluginDataStream.prototype.getLocalSend = function () {
                return this._getAxo().GetLocalSend();
            };
            PluginDataStream.prototype.getRemoteReceive = function () {
                return this._getAxo().GetRemoteReceive();
            };
            PluginDataStream.prototype.getRemoteSend = function () {
                return this._getAxo().GetRemoteSend();
            };
            PluginDataStream.prototype.setLocalReceive = function (value) {
                return this._getAxo().SetLocalReceive(value);
            };
            PluginDataStream.prototype.setLocalSend = function (value) {
                return this._getAxo().SetLocalSend(value);
            };
            PluginDataStream.prototype.getRemoteDirection = function () {
                return this._getAxo().GetRemoteDirection();
            };
            PluginDataStream.prototype.getHandle = function () {
                return this._getAxo().GetHandle();
            };
            PluginDataStream.prototype.changeDirection = function (newDirection) {
                return fm.liveswitch.Error.fromJson(this._getAxo().ChangeDirection(newDirection));
            };
            PluginDataStream.prototype.getDirection = function () {
                return this._getAxo().GetDirection();
            };
            PluginDataStream.prototype.getId = function () {
                return this._getAxo().GetId();
            };
            PluginDataStream.prototype.getExternalId = function () {
                return this._getAxo().GetExternalId();
            };
            PluginDataStream.prototype.setExternalId = function (value) {
                this._getAxo().SetExternalId(value);
            };
            PluginDataStream.prototype.getLabel = function () {
                return this._getAxo().GetLabel();
            };
            PluginDataStream.prototype.getLocalDirection = function () {
                return this._getAxo().GetLocalDirection();
            };
            PluginDataStream.prototype.getMediaDescriptionId = function () {
                return this._getAxo().GetMediaDescriptionId();
            };
            PluginDataStream.prototype.getTag = function () {
                return this._getAxo().GetTag();
            };
            PluginDataStream.prototype.getType = function () {
                return fm.liveswitch.StreamType.Application;
            };
            PluginDataStream.prototype.setLocalDirection = function (value) {
                this._getAxo().SetLocalDirection(value);
            };
            PluginDataStream.prototype.setTag = function (value) {
                this._getAxo().SetTag(value);
            };
            PluginDataStream.prototype.addOnDirectionChange = function (callback) {
                fm.liveswitch.ArrayExtensions.add(this._onDirectionChangeValues, callback);
            };
            PluginDataStream.prototype.removeOnDirectionChange = function (callback) {
                fm.liveswitch.ArrayExtensions.remove(this._onDirectionChangeValues, callback);
            };
            PluginDataStream.prototype.getChannels = function () {
                return this._channels;
            };
            PluginDataStream.prototype.getTransportInfo = function () {
                return fm.liveswitch.TransportInfo.fromJson(this._getAxo().GetTransportInfo());
            };
            /** @internal */
            PluginDataStream.prototype.setGetRemoteConnectionInfo = function (value) {
                if (arguments.length == 1) {
                    for (var _i = 0, _a = this.getChannels(); _i < _a.length; _i++) {
                        var local = _a[_i];
                        local.setGetRemoteConnectionInfo(value);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return PluginDataStream;
        }(fm.liveswitch.PluginStream));
        liveswitch.PluginDataStream = PluginDataStream;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var PluginDomAudioSink = /** @class */ (function (_super) {
            __extends(PluginDomAudioSink, _super);
            /*public getVolume(): number {
                return this._audio.volume;
            }
            public setVolume(volume: number): void {
                this._audio.volume = volume;
            }
            public getMuted(): boolean {
                return this._audio.muted;
            }
            public setMuted(muted: boolean): void {
                this._audio.muted = muted;
            }*/
            function PluginDomAudioSink(external, track) {
                var _this = _super.call(this) || this;
                _this._external = external;
                _this.setTrack(track);
                return _this;
            }
            PluginDomAudioSink.prototype.getTypeString = function () {
                return '[fm.liveswitch.PluginDomAudioSink]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            PluginDomAudioSink.prototype._getExternal = function () {
                return this._external;
            };
            PluginDomAudioSink.prototype.getTrack = function () {
                return this._track;
            };
            PluginDomAudioSink.prototype.getLocal = function () {
                return this._local;
            };
            PluginDomAudioSink.prototype.getAudio = function () {
                return null;
            };
            PluginDomAudioSink.prototype.setTrack = function (track) {
                if (!track) {
                    return false;
                }
                this._track = track;
                this._local = fm.liveswitch.Util.isObjectType(track.getMedia(), '[fm.liveswitch.PluginLocalMedia]');
                return true;
            };
            return PluginDomAudioSink;
        }(fm.liveswitch.Dynamic));
        liveswitch.PluginDomAudioSink = PluginDomAudioSink;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />
/// <reference path="PluginConstants.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var PluginDomVideoSink = /** @class */ (function (_super) {
            __extends(PluginDomVideoSink, _super);
            function PluginDomVideoSink(external, track) {
                var _this = _super.call(this) || this;
                /** @internal */
                _this._axoLoaded = false;
                _this._external = external;
                _this.setTrack(track);
                return _this;
            }
            PluginDomVideoSink.prototype.getTypeString = function () {
                return '[fm.liveswitch.PluginDomVideoSink]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            PluginDomVideoSink.prototype._getExternal = function () {
                return this._external;
            };
            /** @internal */
            PluginDomVideoSink.prototype._getAxo = function () {
                return this._axo;
            };
            PluginDomVideoSink.prototype.getTrack = function () {
                return this._track;
            };
            PluginDomVideoSink.prototype.getLocal = function () {
                return this._local;
            };
            PluginDomVideoSink.prototype.getVideo = function () {
                return null;
            };
            PluginDomVideoSink.prototype.getView = function () {
                return this._container;
            };
            PluginDomVideoSink.prototype.getViewScale = function () {
                if (this._axoLoaded) {
                    return this._axo.GetViewScale();
                }
                return fm.liveswitch.LayoutScale.Contain;
            };
            PluginDomVideoSink.prototype.setViewScale = function (viewScale) {
                if (this._axoLoaded) {
                    this._axo.SetViewScale(viewScale);
                }
            };
            PluginDomVideoSink.prototype.getVideoWidth = function () {
                if (this._axoLoaded) {
                    return this._axo.GetWidth();
                }
                return 0;
            };
            PluginDomVideoSink.prototype.getVideoHeight = function () {
                if (this._axoLoaded) {
                    return this._axo.GetHeight();
                }
                return 0;
            };
            PluginDomVideoSink.prototype.getViewMirror = function () {
                if (this._axoLoaded) {
                    return this._axo.GetViewMirror();
                }
                return false;
            };
            PluginDomVideoSink.prototype.setViewMirror = function (viewMirror) {
                if (this._axoLoaded) {
                    this._axo.SetViewMirror(viewMirror);
                }
            };
            PluginDomVideoSink.prototype.setTrack = function (track) {
                var _this = this;
                if (!track) {
                    return false;
                }
                this._track = track;
                this._local = fm.liveswitch.Util.isObjectType(track.getMedia(), '[fm.liveswitch.PluginLocalMedia]');
                this._container = document.createElement('div');
                if (this._local) {
                    this._container.className = 'fm-video fm-video-local';
                }
                else {
                    this._container.className = 'fm-video fm-video-remote';
                }
                this._underlay = document.createElement('iframe');
                this._underlay.src = 'about:blank';
                this._underlay.setAttribute('allowTransparency', 'true');
                this._underlay.setAttribute('frameBorder', '0');
                this._underlay.style.border = '0';
                this._underlay.style.backgroundColor = '#000';
                this._underlay.style.position = 'absolute';
                this._underlay.style.top = '0';
                this._underlay.style.left = '0';
                this._underlay.style.width = '100%';
                this._underlay.style.height = '100%';
                this._container.appendChild(this._underlay);
                this._axo = document.createElement('object');
                this._axo.id = fm.liveswitch.Guid.newGuid().toString();
                this._axo.setAttribute('codebase', fm.liveswitch.Plugin.getPluginConfig().getActiveXPath());
                this._axo.setAttribute('CLASSID', 'clsid:' + fm.liveswitch.PluginConstants.getDomVideoSinkClassId());
                this._axo.style.position = 'absolute';
                this._axo.style.top = '0';
                this._axo.style.left = '0';
                this._axo.style.width = '100%';
                this._axo.style.height = '100%';
                window.setTimeout(function () {
                    _this._container.appendChild(_this._axo);
                }, 1);
                return this.checkifLoaded(this._axo);
            };
            PluginDomVideoSink.prototype.checkifLoaded = function (object) {
                var _this = this;
                var loaded = false;
                try {
                    if (!fm.liveswitch.Util.isNullOrUndefined(object.GetIsLoaded)) {
                        loaded = object.GetIsLoaded();
                    }
                }
                catch (ex) {
                    loaded = false;
                }
                if (loaded) {
                    this._axoLoaded = true;
                    this.setViewScale(fm.liveswitch.LayoutScale.Contain);
                    return true;
                }
                else {
                    window.setTimeout(function () {
                        _this.checkifLoaded(object);
                    }, 10);
                }
            };
            return PluginDomVideoSink;
        }(fm.liveswitch.Dynamic));
        liveswitch.PluginDomVideoSink = PluginDomVideoSink;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var PluginMedia = /** @class */ (function (_super) {
            __extends(PluginMedia, _super);
            function PluginMedia(external) {
                var _this = _super.call(this) || this;
                /** @internal */
                _this._onAudioLevelValues = [];
                /** @internal */
                _this._onVideoSizeValues = [];
                /** @internal */
                _this._audioTrack = null;
                /** @internal */
                _this._videoTrack = null;
                //protected _audioSink: fm.liveswitch.PluginDomAudioSink = null;
                _this._videoSink = null;
                var externalAudioTrack = new fm.liveswitch.AudioTrack(external, _this);
                var externalVideoTrack = new fm.liveswitch.VideoTrack(external, _this);
                //let externalAudioSink = new DomAudioSink(externalAudioTrack);
                var externalVideoSink = new fm.liveswitch.DomVideoSink(externalVideoTrack);
                _this._audioTrack = externalAudioTrack._getInternal();
                _this._videoTrack = externalVideoTrack._getInternal();
                //this._audioSink = <fm.liveswitch.PluginDomAudioSink>externalAudioSink._getInternal();
                _this._videoSink = externalVideoSink._getInternal();
                return _this;
            }
            PluginMedia.prototype.getTypeString = function () {
                return '[fm.liveswitch.PluginMedia]' + ',' + _super.prototype.getTypeString.call(this);
            };
            PluginMedia.prototype.getHandle = function () {
                return this._getAxo().GetHandle();
            };
            PluginMedia.prototype.destroy = function () {
                this._getAxo().Destroy();
            };
            PluginMedia.prototype.addOnAudioLevel = function (value) {
                var _this = this;
                fm.liveswitch.ArrayExtensions.add(this._onAudioLevelValues, value);
                if (this._onAudioLevelValues.length == 1) {
                    this._getAxo().SetOnAudioLevel(function (level) {
                        for (var _i = 0, _a = _this._onAudioLevelValues; _i < _a.length; _i++) {
                            var onAudioLevelValue = _a[_i];
                            onAudioLevelValue(level);
                        }
                    });
                }
            };
            PluginMedia.prototype.addOnVideoSize = function (value) {
                var _this = this;
                fm.liveswitch.ArrayExtensions.add(this._onVideoSizeValues, value);
                if (this._onVideoSizeValues.length == 1) {
                    this._getAxo().SetOnVideoSize(function (sizeJson) {
                        var size = fm.liveswitch.Size.fromJson(sizeJson);
                        for (var _i = 0, _a = _this._onVideoSizeValues; _i < _a.length; _i++) {
                            var onVideoSizeValue = _a[_i];
                            onVideoSizeValue(size);
                        }
                    });
                }
            };
            PluginMedia.prototype.getAudioGain = function () {
                return this._getAxo().GetAudioGain();
            };
            PluginMedia.prototype.getAudioMuted = function () {
                return this._getAxo().GetAudioMuted();
            };
            PluginMedia.prototype.getAudioTrack = function () {
                if (!this._audio) {
                    return null;
                }
                return this._audioTrack;
            };
            PluginMedia.prototype.getAudioTracks = function () {
                if (!this._audio) {
                    return [];
                }
                return [this.getAudioTrack()];
            };
            PluginMedia.prototype.getAudioVolume = function () {
                return this._getAxo().GetAudioVolume();
            };
            PluginMedia.prototype.getId = function () {
                return this._getAxo().GetId();
            };
            PluginMedia.prototype.getVideoMuted = function () {
                return this._getAxo().GetVideoMuted();
            };
            PluginMedia.prototype.getVideoSize = function () {
                return fm.liveswitch.Size.fromJson(this._getAxo().GetVideoSize());
            };
            PluginMedia.prototype.getVideoTrack = function () {
                if (!this._video) {
                    return null;
                }
                return this._videoTrack;
            };
            PluginMedia.prototype.getVideoTracks = function () {
                if (!this._video) {
                    return [];
                }
                return [this.getVideoTrack()];
            };
            PluginMedia.prototype.grabVideoFrame = function () {
                var _this = this;
                var promise = new fm.liveswitch.Promise();
                var innerPromise = new fm.liveswitch.Promise();
                innerPromise.then(function (videoBufferJson) {
                    promise.resolve(fm.liveswitch.VideoBuffer.fromJson(videoBufferJson));
                }, function (error) {
                    promise.reject(new fm.liveswitch.Exception(error));
                });
                window.setTimeout(function () {
                    _this._getAxo().GrabVideoFrame(innerPromise);
                }, 1);
                return promise;
            };
            PluginMedia.prototype.removeOnAudioLevel = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onAudioLevelValues, value);
                if (this._onAudioLevelValues.length == 0) {
                    this._getAxo().SetOnAudioLevel(null);
                }
            };
            PluginMedia.prototype.removeOnVideoSize = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onVideoSizeValues, value);
                if (this._onVideoSizeValues.length == 0) {
                    this._getAxo().SetOnVideoSize(null);
                }
            };
            PluginMedia.prototype.setAudioGain = function (value) {
                this._getAxo().SetAudioGain(value);
            };
            PluginMedia.prototype.setAudioMuted = function (value) {
                this._getAxo().SetAudioMuted(value);
            };
            PluginMedia.prototype.setAudioVolume = function (value) {
                this._getAxo().SetAudioVolume(value);
            };
            PluginMedia.prototype.setId = function (value) {
                return this._getAxo().SetId(value);
            };
            PluginMedia.prototype.setVideoMuted = function (value) {
                this._getAxo().SetVideoMuted(value);
            };
            PluginMedia.prototype.getAudioSink = function () {
                if (!this._audio) {
                    return null;
                }
                return null; //this._audioSink;
            };
            PluginMedia.prototype.getVideoSink = function () {
                if (!this._video) {
                    return null;
                }
                return this._videoSink;
            };
            PluginMedia.prototype.getView = function () {
                if (!this._video) {
                    return null;
                }
                return this._videoSink.getView();
            };
            PluginMedia.prototype.getViewSink = function () {
                if (!this._video) {
                    return null;
                }
                return this._videoSink;
            };
            PluginMedia.prototype.getAudio = function () {
                return this._audio;
            };
            PluginMedia.prototype.setAudio = function (audio) {
                this._audio = audio;
            };
            PluginMedia.prototype.getVideo = function () {
                return this._video;
            };
            PluginMedia.prototype.setVideo = function (video) {
                this._video = video;
            };
            return PluginMedia;
        }(fm.liveswitch.Dynamic));
        liveswitch.PluginMedia = PluginMedia;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="PluginMedia.ts" />
/// <reference path="IPluginLocalMedia.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var PluginLocalMedia = /** @class */ (function (_super) {
            __extends(PluginLocalMedia, _super);
            function PluginLocalMedia(external, audio, video, screen) {
                var _this = _super.call(this, external) || this;
                /** @internal */
                _this._onAudioStartedValues = [];
                /** @internal */
                _this._onVideoStartedValues = [];
                /** @internal */
                _this._onAudioStoppedValues = [];
                /** @internal */
                _this._onVideoStoppedValues = [];
                /** @internal */
                _this._onAudioDestroyedValues = [];
                /** @internal */
                _this._onVideoDestroyedValues = [];
                _this._external = external;
                _this._audio = audio;
                _this._video = video;
                _this._screen = fm.liveswitch.Util.isNullOrUndefined(screen) ? false : screen;
                _this._axo = new ActiveXObject("fm.liveswitch.LocalMedia");
                _this._axo.Initialize((audio === false), (video === false), _this._screen);
                _this._axo.SetOnAudioStarted(function () {
                    for (var _i = 0, _a = _this._onAudioStartedValues; _i < _a.length; _i++) {
                        var onAudioStartedValue = _a[_i];
                        onAudioStartedValue();
                    }
                });
                _this._axo.SetOnVideoStarted(function () {
                    for (var _i = 0, _a = _this._onVideoStartedValues; _i < _a.length; _i++) {
                        var onVideoStartedValue = _a[_i];
                        onVideoStartedValue();
                    }
                });
                _this._axo.SetOnAudioStopped(function () {
                    for (var _i = 0, _a = _this._onAudioStoppedValues; _i < _a.length; _i++) {
                        var onAudioStoppedValue = _a[_i];
                        onAudioStoppedValue();
                    }
                });
                _this._axo.SetOnVideoStopped(function () {
                    for (var _i = 0, _a = _this._onVideoStoppedValues; _i < _a.length; _i++) {
                        var onVideoStoppedValue = _a[_i];
                        onVideoStoppedValue();
                    }
                });
                _this._axo.SetOnAudioDestroyed(function () {
                    for (var _i = 0, _a = _this._onAudioDestroyedValues; _i < _a.length; _i++) {
                        var onAudioDestroyedValue = _a[_i];
                        onAudioDestroyedValue();
                    }
                });
                _this._axo.SetOnVideoDestroyed(function () {
                    for (var _i = 0, _a = _this._onVideoDestroyedValues; _i < _a.length; _i++) {
                        var onVideoDestroyedValue = _a[_i];
                        onVideoDestroyedValue();
                    }
                });
                if (video) {
                    _this.checkifLoaded(_this._axo);
                }
                return _this;
            }
            PluginLocalMedia.prototype.getTypeString = function () {
                return '[fm.liveswitch.PluginLocalMedia]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            PluginLocalMedia.prototype._getExternal = function () {
                return this._external;
            };
            /** @internal */
            PluginLocalMedia.prototype._getAxo = function () {
                return this._axo;
            };
            PluginLocalMedia.prototype.getScreen = function () {
                return this._screen;
            };
            PluginLocalMedia.prototype.setScreen = function (screen) {
                this._screen = screen;
            };
            PluginLocalMedia.prototype.getState = function () {
                return this._axo.GetState();
            };
            PluginLocalMedia.prototype.start = function () {
                var _this = this;
                if (!this.unloadHandler) {
                    this.unloadHandler = function (evt) {
                        _this._axo.Stop(new fm.liveswitch.Promise());
                    };
                }
                var promise = new fm.liveswitch.Promise();
                window.setTimeout(function () {
                    _this._axo.Start(promise);
                    fm.liveswitch.Util.observe(window, 'unload', _this.unloadHandler);
                }, 1);
                return promise;
            };
            PluginLocalMedia.prototype.stop = function () {
                var _this = this;
                var promise = new fm.liveswitch.Promise();
                window.setTimeout(function () {
                    fm.liveswitch.Util.unobserve(window, 'unload', _this.unloadHandler);
                    _this._axo.Stop(promise);
                }, 1);
                return promise;
            };
            PluginLocalMedia.prototype.getHandle = function () {
                return this._getAxo().GetHandle();
            };
            PluginLocalMedia.prototype.addOnAudioStarted = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onAudioStartedValues, value);
            };
            PluginLocalMedia.prototype.addOnVideoStarted = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onVideoStartedValues, value);
            };
            PluginLocalMedia.prototype.addOnAudioStopped = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onAudioStoppedValues, value);
            };
            PluginLocalMedia.prototype.addOnVideoStopped = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onVideoStoppedValues, value);
            };
            PluginLocalMedia.prototype.addOnAudioDestroyed = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onAudioDestroyedValues, value);
            };
            PluginLocalMedia.prototype.addOnVideoDestroyed = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onVideoDestroyedValues, value);
            };
            PluginLocalMedia.prototype.removeOnAudioStarted = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onAudioStartedValues, value);
            };
            PluginLocalMedia.prototype.removeOnVideoStarted = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onVideoStartedValues, value);
            };
            PluginLocalMedia.prototype.removeOnAudioStopped = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onAudioStoppedValues, value);
            };
            PluginLocalMedia.prototype.removeOnVideoStopped = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onVideoStoppedValues, value);
            };
            PluginLocalMedia.prototype.removeOnAudioDestroyed = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onAudioDestroyedValues, value);
            };
            PluginLocalMedia.prototype.removeOnVideoDestroyed = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onVideoDestroyedValues, value);
            };
            PluginLocalMedia.prototype.getAudioEncoding = function () {
                return fm.liveswitch.AudioEncodingConfig.fromJson(this._getAxo().GetAudioEncoding());
            };
            PluginLocalMedia.prototype.getAudioEncodings = function () {
                return fm.liveswitch.AudioEncodingConfig.fromJsonArray(this._getAxo().GetAudioEncodings());
            };
            PluginLocalMedia.prototype.setAudioEncodings = function (value) {
                return this._getAxo().SetAudioEncodings(fm.liveswitch.AudioEncodingConfig.toJsonArray(value));
            };
            PluginLocalMedia.prototype.getVideoEncoding = function () {
                return fm.liveswitch.VideoEncodingConfig.fromJson(this._getAxo().GetVideoEncoding());
            };
            PluginLocalMedia.prototype.getVideoEncodings = function () {
                return fm.liveswitch.VideoEncodingConfig.fromJsonArray(this._getAxo().GetVideoEncodings());
            };
            PluginLocalMedia.prototype.setVideoEncodings = function (value) {
                return this._getAxo().SetVideoEncodings(fm.liveswitch.VideoEncodingConfig.toJsonArray(value));
            };
            PluginLocalMedia.prototype.changeAudioSourceInput = function (audioSourceInput) {
                var _this = this;
                var promise = new fm.liveswitch.Promise();
                window.setTimeout(function () {
                    _this._getAxo().ChangeAudioSourceInput(promise, fm.liveswitch.SourceInput.toJson(audioSourceInput));
                }, 1);
                return promise;
            };
            PluginLocalMedia.prototype.changeVideoSourceInput = function (videoSourceInput) {
                var _this = this;
                var promise = new fm.liveswitch.Promise();
                window.setTimeout(function () {
                    _this._getAxo().ChangeVideoSourceInput(promise, fm.liveswitch.SourceInput.toJson(videoSourceInput));
                }, 1);
                return promise;
            };
            PluginLocalMedia.prototype.getAudioSourceInput = function () {
                return fm.liveswitch.SourceInput.fromJson(this._getAxo().GetAudioSourceInput());
            };
            PluginLocalMedia.prototype.getAudioSourceInputs = function () {
                var _this = this;
                var promise = new fm.liveswitch.Promise();
                var innerPromise = new fm.liveswitch.Promise();
                window.setTimeout(function () {
                    _this._getAxo().GetAudioSourceInputs(innerPromise);
                }, 1);
                innerPromise.then(function (sourceInputsJson) {
                    promise.resolve(fm.liveswitch.SourceInput.fromJsonArray(sourceInputsJson));
                });
                return promise;
            };
            PluginLocalMedia.prototype.getVideoSourceInput = function () {
                return fm.liveswitch.SourceInput.fromJson(this._getAxo().GetVideoSourceInput());
            };
            PluginLocalMedia.prototype.getVideoSourceInputs = function () {
                var _this = this;
                var promise = new fm.liveswitch.Promise();
                var innerPromise = new fm.liveswitch.Promise();
                window.setTimeout(function () {
                    _this._getAxo().GetVideoSourceInputs(innerPromise);
                }, 1);
                innerPromise.then(function (sourceInputsJson) {
                    promise.resolve(fm.liveswitch.SourceInput.fromJsonArray(sourceInputsJson));
                });
                return promise;
            };
            PluginLocalMedia.prototype.setAudioSourceInput = function (value) {
                this._getAxo().SetAudioSourceInput(fm.liveswitch.SourceInput.toJson(value));
            };
            PluginLocalMedia.prototype.setVideoSourceInput = function (value) {
                this._getAxo().SetVideoSourceInput(fm.liveswitch.SourceInput.toJson(value));
            };
            PluginLocalMedia.prototype.destroy = function () {
                //return this._getAxo().Destroy();
            };
            PluginLocalMedia.prototype.getAudioGain = function () {
                return this._getAxo().GetAudioGain();
            };
            PluginLocalMedia.prototype.getAudioMuted = function () {
                return this._getAxo().GetAudioMuted();
            };
            PluginLocalMedia.prototype.getId = function () {
                return this._getAxo().GetId();
            };
            PluginLocalMedia.prototype.getVideoMuted = function () {
                return this._getAxo().GetVideoMuted();
            };
            PluginLocalMedia.prototype.setAudioGain = function (value) {
                this._getAxo().SetAudioGain(value);
            };
            PluginLocalMedia.prototype.setAudioMuted = function (value) {
                this._getAxo().SetAudioMuted(value);
            };
            PluginLocalMedia.prototype.setVideoMuted = function (value) {
                this._getAxo().SetVideoMuted(value);
            };
            PluginLocalMedia.prototype.getAudioSimulcastDisabled = function () {
                return this._getAxo().GetAudioSimulcastDisabled();
            };
            PluginLocalMedia.prototype.setAudioSimulcastDisabled = function (value) {
                this._getAxo().SetAudioSimulcastDisabled(value);
            };
            PluginLocalMedia.prototype.getAudioSimulcastEncodingCount = function () {
                return this._getAxo().GetAudioSimulcastEncodingCount();
            };
            PluginLocalMedia.prototype.setAudioSimulcastEncodingCount = function (value) {
                this._getAxo().SetAudioSimulcastEncodingCount(value);
            };
            PluginLocalMedia.prototype.getAudioSimulcastPreferredBitrate = function () {
                return this._getAxo().GetAudioSimulcastPreferredBitrate();
            };
            PluginLocalMedia.prototype.setAudioSimulcastPreferredBitrate = function (value) {
                this._getAxo().SetAudioSimulcastPreferredBitrate(value);
            };
            PluginLocalMedia.prototype.getVideoSimulcastDisabled = function () {
                return this._getAxo().GetVideoSimulcastDisabled();
            };
            PluginLocalMedia.prototype.setVideoSimulcastDisabled = function (value) {
                this._getAxo().SetVideoSimulcastDisabled(value);
            };
            PluginLocalMedia.prototype.getVideoSimulcastEncodingCount = function () {
                return this._getAxo().GetVideoSimulcastEncodingCount();
            };
            PluginLocalMedia.prototype.setVideoSimulcastEncodingCount = function (value) {
                this._getAxo().SetVideoSimulcastEncodingCount(value);
            };
            PluginLocalMedia.prototype.getVideoSimulcastPreferredBitrate = function () {
                return this._getAxo().GetVideoSimulcastPreferredBitrate();
            };
            PluginLocalMedia.prototype.setVideoSimulcastPreferredBitrate = function (value) {
                this._getAxo().SetVideoSimulcastPreferredBitrate(value);
            };
            PluginLocalMedia.prototype.getVideoSimulcastBitsPerPixel = function () {
                return this._getAxo().GetVideoSimulcastBitsPerPixel();
            };
            PluginLocalMedia.prototype.setVideoSimulcastBitsPerPixel = function (value) {
                this._getAxo().SetVideoSimulcastBitsPerPixel(value);
            };
            PluginLocalMedia.prototype.getVideoSimulcastDegradationPreference = function () {
                return this._getAxo().GetVideoSimulcastDegradationPreference();
            };
            PluginLocalMedia.prototype.setVideoSimulcastDegradationPreference = function (value) {
                this._getAxo().SetVideoSimulcastDegradationPreference(value);
            };
            PluginLocalMedia.prototype.checkifLoaded = function (object) {
                var _this = this;
                var loaded = false;
                try {
                    if (!fm.liveswitch.Util.isNullOrUndefined(this._videoSink._getAxo().GetIsLoaded)) {
                        loaded = this._videoSink._getAxo().GetIsLoaded();
                    }
                }
                catch (ex) {
                    loaded = false;
                }
                if (loaded) {
                    object.AttachView(this._videoSink._getAxo().GetHandle());
                }
                else {
                    window.setTimeout(function () {
                        _this.checkifLoaded(object);
                    }, 10);
                }
            };
            return PluginLocalMedia;
        }(fm.liveswitch.PluginMedia));
        liveswitch.PluginLocalMedia = PluginLocalMedia;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="PluginMedia.ts" />
/// <reference path="IPluginRemoteMedia.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var PluginRemoteMedia = /** @class */ (function (_super) {
            __extends(PluginRemoteMedia, _super);
            function PluginRemoteMedia(external, audio, video) {
                var _this = _super.call(this, external) || this;
                /** @internal */
                _this._onAudioDestroyedValues = [];
                /** @internal */
                _this._onVideoDestroyedValues = [];
                _this._external = external;
                _this._audio = audio;
                _this._video = video;
                _this._axo = new ActiveXObject("fm.liveswitch.RemoteMedia");
                _this._axo.Initialize(false, false);
                _this._axo.SetOnAudioDestroyed(function () {
                    for (var _i = 0, _a = _this._onAudioDestroyedValues; _i < _a.length; _i++) {
                        var onAudioDestroyedValue = _a[_i];
                        onAudioDestroyedValue();
                    }
                });
                _this._axo.SetOnVideoDestroyed(function () {
                    for (var _i = 0, _a = _this._onVideoDestroyedValues; _i < _a.length; _i++) {
                        var onVideoDestroyedValue = _a[_i];
                        onVideoDestroyedValue();
                    }
                });
                _this.checkifLoaded(_this._axo);
                return _this;
            }
            PluginRemoteMedia.prototype.getTypeString = function () {
                return '[fm.liveswitch.PluginRemoteMedia]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            PluginRemoteMedia.prototype._getExternal = function () {
                return this._external;
            };
            /** @internal */
            PluginRemoteMedia.prototype._getAxo = function () {
                return this._axo;
            };
            PluginRemoteMedia.prototype.checkifLoaded = function (object) {
                var _this = this;
                var loaded = false;
                try {
                    if (!fm.liveswitch.Util.isNullOrUndefined(this._videoSink._getAxo().GetIsLoaded)) {
                        loaded = this._videoSink._getAxo().GetIsLoaded();
                    }
                }
                catch (ex) {
                    loaded = false;
                }
                if (loaded) {
                    object.AttachView(this._videoSink._getAxo().GetHandle());
                }
                else {
                    window.setTimeout(function () {
                        _this.checkifLoaded(object);
                    }, 10);
                }
            };
            PluginRemoteMedia.prototype.getHandle = function () {
                return this._getAxo().GetHandle();
            };
            PluginRemoteMedia.prototype.addOnAudioDestroyed = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onAudioDestroyedValues, value);
            };
            PluginRemoteMedia.prototype.addOnVideoDestroyed = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onVideoDestroyedValues, value);
            };
            PluginRemoteMedia.prototype.removeOnAudioDestroyed = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onAudioDestroyedValues, value);
            };
            PluginRemoteMedia.prototype.removeOnVideoDestroyed = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onVideoDestroyedValues, value);
            };
            PluginRemoteMedia.prototype.changeAudioSinkOutput = function (audioSinkOutput) {
                var _this = this;
                var promise = new fm.liveswitch.Promise();
                window.setTimeout(function () {
                    _this._getAxo().ChangeAudioSinkOutput(promise, fm.liveswitch.SinkOutput.toJson(audioSinkOutput));
                }, 1);
                return promise;
            };
            PluginRemoteMedia.prototype.changeVideoSinkOutput = function (videoSinkOutput) {
                var _this = this;
                var promise = new fm.liveswitch.Promise();
                window.setTimeout(function () {
                    _this._getAxo().ChangeVideoSinkOutput(promise, fm.liveswitch.SinkOutput.toJson(videoSinkOutput));
                }, 1);
                return promise;
            };
            PluginRemoteMedia.prototype.getAudioSinkOutput = function () {
                return fm.liveswitch.SinkOutput.fromJson(this._getAxo().GetAudioSinkOutput());
            };
            PluginRemoteMedia.prototype.getAudioSinkOutputs = function () {
                var _this = this;
                var promise = new fm.liveswitch.Promise();
                var innerPromise = new fm.liveswitch.Promise();
                window.setTimeout(function () {
                    _this._getAxo().GetAudioSinkOutputs(innerPromise);
                }, 1);
                innerPromise.then(function (sinkOutputsJson) {
                    promise.resolve(fm.liveswitch.SinkOutput.fromJsonArray(sinkOutputsJson));
                });
                return promise;
            };
            PluginRemoteMedia.prototype.getVideoSinkOutput = function () {
                return fm.liveswitch.SinkOutput.fromJson(this._getAxo().GetVideoSinkOutput());
            };
            PluginRemoteMedia.prototype.getVideoSinkOutputs = function () {
                var _this = this;
                var promise = new fm.liveswitch.Promise();
                var innerPromise = new fm.liveswitch.Promise();
                window.setTimeout(function () {
                    _this._getAxo().GetVideoSinkOutputs(innerPromise);
                }, 1);
                innerPromise.then(function (sinkOutputsJson) {
                    promise.resolve(fm.liveswitch.SinkOutput.fromJsonArray(sinkOutputsJson));
                });
                return promise;
            };
            PluginRemoteMedia.prototype.setAudioSinkOutput = function (value) {
                this._getAxo().SetAudioSinkOutput(fm.liveswitch.SinkOutput.toJson(value));
            };
            PluginRemoteMedia.prototype.setVideoSinkOutput = function (value) {
                this._getAxo().SetVideoSinkOutput(fm.liveswitch.SinkOutput.toJson(value));
            };
            PluginRemoteMedia.prototype.destroy = function () {
                return this._getAxo().Destroy();
            };
            PluginRemoteMedia.prototype.getAudioGain = function () {
                return this._getAxo().GetAudioGain();
            };
            PluginRemoteMedia.prototype.getAudioMuted = function () {
                return this._getAxo().GetAudioMuted();
            };
            PluginRemoteMedia.prototype.getId = function () {
                return this._getAxo().GetId();
            };
            PluginRemoteMedia.prototype.getVideoMuted = function () {
                return this._getAxo().GetVideoMuted();
            };
            PluginRemoteMedia.prototype.setAudioGain = function (value) {
                this._getAxo().SetAudioGain(value);
            };
            PluginRemoteMedia.prototype.setAudioMuted = function (value) {
                this._getAxo().SetAudioMuted(value);
            };
            PluginRemoteMedia.prototype.setVideoMuted = function (value) {
                this._getAxo().SetVideoMuted(value);
            };
            return PluginRemoteMedia;
        }(fm.liveswitch.PluginMedia));
        liveswitch.PluginRemoteMedia = PluginRemoteMedia;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="PluginMediaStream.ts" />
/// <reference path="IPluginVideoStream.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var PluginVideoStream = /** @class */ (function (_super) {
            __extends(PluginVideoStream, _super);
            function PluginVideoStream(external, localTrack, remoteTrack) {
                var _this = _super.call(this, localTrack, remoteTrack) || this;
                /** @internal */
                _this._onDirectionChangeValues = [];
                /** @internal */
                _this._onStateChangeValues = [];
                /** @internal */
                _this._onLocalEncodingDisabledValues = [];
                /** @internal */
                _this._onLocalEncodingEnabledValues = [];
                /** @internal */
                _this._onDiscardKeyFrameRequestValues = [];
                /** @internal */
                _this._onDiscardBitrateRequestValues = [];
                /** @internal */
                _this._onDiscardBitrateNotificationValues = [];
                _this._state = fm.liveswitch.StreamState.New;
                _this._external = external;
                _this._axo = new ActiveXObject("fm.liveswitch.VideoStream");
                _this._axo.Initialize(_this.getLocalTrack() == null ? 0 : _this.getLocalTrack().getMedia().getHandle(), remoteTrack == null ? 0 : remoteTrack.getMedia().getHandle());
                _this._axo.SetOnDirectionChange(function () {
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onDirectionChangeValues; _i < _a.length; _i++) {
                            var onDirectionChangeValue = _a[_i];
                            onDirectionChangeValue();
                        }
                    }, 1);
                });
                _this._axo.SetOnStateChange(function (state) {
                    _this._state = state;
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onStateChangeValues; _i < _a.length; _i++) {
                            var onStateChangeValue = _a[_i];
                            onStateChangeValue();
                        }
                    }, 1);
                });
                _this._axo.SetOnLocalEncodingDisabled(function (encodingJson) {
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onLocalEncodingDisabledValues; _i < _a.length; _i++) {
                            var value = _a[_i];
                            value(fm.liveswitch.EncodingInfo.fromJson(encodingJson));
                        }
                    }, 1);
                });
                _this._axo.SetOnLocalEncodingEnabled(function (encodingJson) {
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onLocalEncodingEnabledValues; _i < _a.length; _i++) {
                            var value = _a[_i];
                            value(fm.liveswitch.EncodingInfo.fromJson(encodingJson));
                        }
                    }, 1);
                });
                _this._axo.SetOnDiscardKeyFrameRequest(function (synchronizationSources) {
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onDiscardKeyFrameRequestValues; _i < _a.length; _i++) {
                            var value = _a[_i];
                            value(synchronizationSources);
                        }
                    }, 1);
                });
                _this._axo.SetOnDiscardBitrateRequest(function (bitrateRequestJson) {
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onDiscardBitrateRequestValues; _i < _a.length; _i++) {
                            var value = _a[_i];
                            value(fm.liveswitch.BitrateRequest.fromJson(bitrateRequestJson));
                        }
                    }, 1);
                });
                _this._axo.SetOnDiscardBitrateNotification(function (bitrateNotificationJson) {
                    setTimeout(function () {
                        for (var _i = 0, _a = _this._onDiscardBitrateNotificationValues; _i < _a.length; _i++) {
                            var value = _a[_i];
                            value(fm.liveswitch.BitrateNotification.fromJson(bitrateNotificationJson));
                        }
                    }, 1);
                });
                return _this;
            }
            PluginVideoStream.prototype.getTypeString = function () {
                return '[fm.liveswitch.PluginVideoStream]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            PluginVideoStream.prototype._getExternal = function () {
                return this._external;
            };
            /** @internal */
            PluginVideoStream.prototype._getAxo = function () {
                return this._axo;
            };
            PluginVideoStream.prototype.getState = function () {
                return this._state;
            };
            PluginVideoStream.prototype.addOnStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onStateChangeValues, value);
            };
            PluginVideoStream.prototype.removeOnStateChange = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onStateChangeValues, value);
            };
            PluginVideoStream.prototype.getInfo = function () {
                return fm.liveswitch.MediaStreamInfo.fromJson(this._getAxo().GetInfo());
            };
            PluginVideoStream.prototype.getLocalReceive = function () {
                return this._getAxo().GetLocalReceive();
            };
            PluginVideoStream.prototype.getLocalSend = function () {
                return this._getAxo().GetLocalSend();
            };
            PluginVideoStream.prototype.getRemoteReceive = function () {
                return this._getAxo().GetRemoteReceive();
            };
            PluginVideoStream.prototype.getRemoteSend = function () {
                return this._getAxo().GetRemoteSend();
            };
            PluginVideoStream.prototype.setLocalReceive = function (value) {
                return this._getAxo().SetLocalReceive(value);
            };
            PluginVideoStream.prototype.setLocalSend = function (value) {
                return this._getAxo().SetLocalSend(value);
            };
            PluginVideoStream.prototype.getRemoteDirection = function () {
                return this._getAxo().GetRemoteDirection();
            };
            PluginVideoStream.prototype.getHandle = function () {
                return this._getAxo().GetHandle();
            };
            PluginVideoStream.prototype.changeDirection = function (newDirection) {
                return fm.liveswitch.Error.fromJson(this._getAxo().ChangeDirection(newDirection));
            };
            PluginVideoStream.prototype.getDirection = function () {
                return this._getAxo().GetDirection();
            };
            PluginVideoStream.prototype.getLocalCanonicalName = function () {
                return this._getAxo().GetLocalCanonicalName();
            };
            PluginVideoStream.prototype.getRemoteCanonicalName = function () {
                return this._getAxo().GetRemoteCanonicalName();
            };
            PluginVideoStream.prototype.getId = function () {
                return this._getAxo().GetId();
            };
            PluginVideoStream.prototype.getExternalId = function () {
                return this._getAxo().GetExternalId();
            };
            PluginVideoStream.prototype.setExternalId = function (value) {
                this._getAxo().SetExternalId(value);
            };
            PluginVideoStream.prototype.getLabel = function () {
                return this._getAxo().GetLabel();
            };
            PluginVideoStream.prototype.getLocalBandwidth = function () {
                return this._getAxo().GetLocalBandwidth();
            };
            PluginVideoStream.prototype.getLocalDirection = function () {
                return this._getAxo().GetLocalDirection();
            };
            PluginVideoStream.prototype.getInputMuted = function () {
                return this._getAxo().GetInputMuted();
            };
            PluginVideoStream.prototype.getMediaDescriptionId = function () {
                return this._getAxo().GetMediaDescriptionId();
            };
            PluginVideoStream.prototype.getOutputMuted = function () {
                return this._getAxo().GetOutputMuted();
            };
            PluginVideoStream.prototype.getRemoteBandwidth = function () {
                return this._getAxo().GetRemoteBandwidth();
            };
            PluginVideoStream.prototype.getTag = function () {
                return this._getAxo().GetTag();
            };
            PluginVideoStream.prototype.getType = function () {
                return fm.liveswitch.StreamType.Video;
            };
            PluginVideoStream.prototype.setLocalDirection = function (value) {
                this._getAxo().SetLocalDirection(value);
            };
            PluginVideoStream.prototype.setLocalBandwidth = function (value) {
                this._getAxo().SetLocalBandwidth(value);
            };
            PluginVideoStream.prototype.setInputMuted = function (value) {
                this._getAxo().SetInputMuted(value);
            };
            PluginVideoStream.prototype.setOutputMuted = function (value) {
                this._getAxo().SetOutputMuted(value);
            };
            PluginVideoStream.prototype.setTag = function (value) {
                this._getAxo().SetTag(value);
            };
            PluginVideoStream.prototype.addOnDirectionChange = function (callback) {
                fm.liveswitch.ArrayExtensions.add(this._onDirectionChangeValues, callback);
            };
            PluginVideoStream.prototype.removeOnDirectionChange = function (callback) {
                fm.liveswitch.ArrayExtensions.remove(this._onDirectionChangeValues, callback);
            };
            PluginVideoStream.prototype.getPreferredCodecs = function () {
                return this._getAxo().GetPreferredCodecs();
            };
            PluginVideoStream.prototype.setPreferredCodecs = function (names) {
                this._getAxo().SetPreferredCodecs(names);
            };
            PluginVideoStream.prototype.getCodecDisabled = function (name) {
                return this._getAxo().GetCodecDisabled(name);
            };
            PluginVideoStream.prototype.setCodecDisabled = function (name, disabled) {
                this._getAxo().SetCodecDisabled(name, disabled);
            };
            PluginVideoStream.prototype.getVp8Disabled = function () {
                return this._getAxo().GetVp8Disabled();
            };
            PluginVideoStream.prototype.getVp9Disabled = function () {
                return this._getAxo().GetVp9Disabled();
            };
            PluginVideoStream.prototype.getH264Disabled = function () {
                return this._getAxo().GetH264Disabled();
            };
            PluginVideoStream.prototype.setVp8Disabled = function (value) {
                return this._getAxo().SetVp8Disabled(value);
            };
            PluginVideoStream.prototype.setVp9Disabled = function (value) {
                return this._getAxo().SetVp9Disabled(value);
            };
            PluginVideoStream.prototype.setH264Disabled = function (value) {
                return this._getAxo().SetH264Disabled(value);
            };
            PluginVideoStream.prototype.getRemoteEncoding = function () {
                return fm.liveswitch.EncodingInfo.fromJson(this._getAxo().GetRemoteEncoding());
            };
            PluginVideoStream.prototype.setRemoteEncoding = function (value) {
                this._getAxo().SetRemoteEncoding(fm.liveswitch.EncodingInfo.toJson(value));
            };
            PluginVideoStream.prototype.getSimulcastMode = function () {
                return this._getAxo().GetSimulcastMode();
            };
            PluginVideoStream.prototype.setSimulcastMode = function (value) {
                this._getAxo().SetSimulcastMode(value);
            };
            PluginVideoStream.prototype.getTransportInfo = function () {
                return fm.liveswitch.TransportInfo.fromJson(this._getAxo().GetTransportInfo());
            };
            PluginVideoStream.prototype.getControlTransportInfo = function () {
                return fm.liveswitch.TransportInfo.fromJson(this._getAxo().GetControlTransportInfo());
            };
            PluginVideoStream.prototype.addOnLocalEncodingDisabled = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onLocalEncodingDisabledValues, value);
            };
            PluginVideoStream.prototype.addOnLocalEncodingEnabled = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onLocalEncodingEnabledValues, value);
            };
            PluginVideoStream.prototype.removeOnLocalEncodingDisabled = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onLocalEncodingDisabledValues, value);
            };
            PluginVideoStream.prototype.removeOnLocalEncodingEnabled = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onLocalEncodingEnabledValues, value);
            };
            PluginVideoStream.prototype.addOnDiscardKeyFrameRequest = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onDiscardKeyFrameRequestValues, value);
            };
            PluginVideoStream.prototype.removeOnDiscardKeyFrameRequest = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onDiscardKeyFrameRequestValues, value);
            };
            PluginVideoStream.prototype.raiseKeyFrameRequest = function (synchronizationSources) {
                this._axo.RaiseKeyFrameRequest(synchronizationSources);
            };
            PluginVideoStream.prototype.addOnDiscardBitrateRequest = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onDiscardBitrateRequestValues, value);
            };
            PluginVideoStream.prototype.removeOnDiscardBitrateRequest = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onDiscardBitrateRequestValues, value);
            };
            PluginVideoStream.prototype.raiseBitrateRequest = function (bitrateRequest) {
                return this._axo.RaiseBitrateRequest(fm.liveswitch.BitrateRequest.toJson(bitrateRequest));
            };
            PluginVideoStream.prototype.addOnDiscardBitrateNotification = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onDiscardBitrateNotificationValues, value);
            };
            PluginVideoStream.prototype.removeOnDiscardBitrateNotification = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onDiscardBitrateNotificationValues, value);
            };
            PluginVideoStream.prototype.raiseBitrateNotification = function (bitrateNotification) {
                return this._axo.RaiseBitrateNotification(fm.liveswitch.BitrateNotification.toJson(bitrateNotification));
            };
            PluginVideoStream.prototype.getMaxSendBitrate = function () {
                return this._getAxo().GetMaxSendBitrate();
            };
            PluginVideoStream.prototype.setMaxSendBitrate = function (value) {
                this._getAxo().SetMaxSendBitrate(value);
            };
            PluginVideoStream.prototype.getMaxReceiveBitrate = function () {
                return this._getAxo().GetMaxReceiveBitrate();
            };
            PluginVideoStream.prototype.setMaxReceiveBitrate = function (value) {
                this._getAxo().SetMaxReceiveBitrate(value);
            };
            return PluginVideoStream;
        }(fm.liveswitch.PluginMediaStream));
        liveswitch.PluginVideoStream = PluginVideoStream;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="PluginMediaTrack.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var PluginVideoTrack = /** @class */ (function (_super) {
            __extends(PluginVideoTrack, _super);
            function PluginVideoTrack(external, media) {
                var _this = _super.call(this, media) || this;
                _this._external = external;
                return _this;
            }
            PluginVideoTrack.prototype.getTypeString = function () {
                return '[fm.liveswitch.PluginVideoTrack]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            PluginVideoTrack.prototype._getExternal = function () {
                return this._external;
            };
            PluginVideoTrack.prototype.isLocal = function () {
                return (fm.liveswitch.Util.isObjectType(this.getMedia(), '[fm.liveswitch.PluginLocalMedia]'));
            };
            PluginVideoTrack.prototype.addOnStarted = function (value) {
                if (!this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call VideoTrack.addOnStarted on a remote track.');
                }
                this.getMedia().addOnVideoStarted(value);
            };
            PluginVideoTrack.prototype.addOnStopped = function (value) {
                if (!this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call VideoTrack.addOnStopped on a remote track.');
                }
                this.getMedia().addOnVideoStopped(value);
            };
            PluginVideoTrack.prototype.addOnDestroyed = function (value) {
                this.getMedia().addOnVideoDestroyed(value);
            };
            PluginVideoTrack.prototype.removeOnStarted = function (value) {
                if (!this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call VideoTrack.removeOnStarted on a remote track.');
                }
                this.getMedia().removeOnVideoStarted(value);
            };
            PluginVideoTrack.prototype.removeOnStopped = function (value) {
                if (!this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call VideoTrack.removeOnStopped on a remote track.');
                }
                this.getMedia().removeOnVideoStopped(value);
            };
            PluginVideoTrack.prototype.removeOnDestroyed = function (value) {
                this.getMedia().removeOnVideoDestroyed(value);
            };
            PluginVideoTrack.prototype.changeSinkOutput = function (sinkOutput) {
                if (this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call VideoTrack.changeSinkOutput on a local track.');
                }
                return this.getMedia().changeVideoSinkOutput(sinkOutput);
            };
            PluginVideoTrack.prototype.getSinkOutput = function () {
                if (this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call VideoTrack.getSinkOutput on a local track.');
                }
                return this.getMedia().getVideoSinkOutput();
            };
            PluginVideoTrack.prototype.getSinkOutputs = function () {
                if (this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call VideoTrack.getSinkOutputs on a local track.');
                }
                return this.getMedia().getVideoSinkOutputs();
            };
            PluginVideoTrack.prototype.setSinkOutput = function (value) {
                if (this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call VideoTrack.setSinkOutput on a local track.');
                }
                this.getMedia().setVideoSinkOutput(value);
            };
            PluginVideoTrack.prototype.changeSourceInput = function (sourceInput) {
                if (!this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call VideoTrack.changeSourceInput on a remote track.');
                }
                return this.getMedia().changeVideoSourceInput(sourceInput);
            };
            PluginVideoTrack.prototype.getSourceInput = function () {
                if (!this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call VideoTrack.getSourceInput on a remote track.');
                }
                return this.getMedia().getVideoSourceInput();
            };
            PluginVideoTrack.prototype.getSourceInputs = function () {
                if (!this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call VideoTrack.getSourceInputs on a remote track.');
                }
                return this.getMedia().getVideoSourceInputs();
            };
            PluginVideoTrack.prototype.setSourceInput = function (value) {
                if (!this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call VideoTrack.setSourceInput on a remote track.');
                }
                this.getMedia().setVideoSourceInput(value);
            };
            PluginVideoTrack.prototype.addOnSize = function (value) {
                this.getMedia().addOnVideoSize(value);
            };
            PluginVideoTrack.prototype.getMuted = function () {
                return this.getMedia().getVideoMuted();
            };
            PluginVideoTrack.prototype.getSize = function () {
                return this.getMedia().getVideoSize();
            };
            PluginVideoTrack.prototype.grabFrame = function () {
                return this.getMedia().grabVideoFrame();
            };
            PluginVideoTrack.prototype.setMuted = function (value) {
                this.getMedia().setVideoMuted(value);
            };
            PluginVideoTrack.prototype.removeOnSize = function (value) {
                this.getMedia().removeOnVideoSize(value);
            };
            return PluginVideoTrack;
        }(fm.liveswitch.PluginMediaTrack));
        liveswitch.PluginVideoTrack = PluginVideoTrack;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Media.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var RemoteMedia = /** @class */ (function (_super) {
            __extends(RemoteMedia, _super);
            function RemoteMedia(audio, video) {
                var _this = _super.call(this) || this;
                if (typeof audio == 'undefined') {
                    audio = true;
                }
                if (typeof video == 'undefined') {
                    video = true;
                }
                if (fm.liveswitch.Plugin.useActiveX()) {
                    _this._internal = new fm.liveswitch.PluginRemoteMedia(_this, audio, video);
                }
                else if (fm.liveswitch.Plugin.useNative()) {
                    _this._internal = new fm.liveswitch.WebRtcRemoteMedia(_this, audio, video);
                }
                else {
                    throw new fm.liveswitch.Exception('Browser does not support WebRTC/ORTC and no plugin found.');
                }
                return _this;
            }
            RemoteMedia.prototype.getTypeString = function () {
                return '[fm.liveswitch.RemoteMedia]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            RemoteMedia.prototype._getInternal = function () {
                return this._internal;
            };
            RemoteMedia.prototype.changeAudioSinkOutput = function (audioSinkOutput) {
                return this._getInternal().changeAudioSinkOutput(audioSinkOutput);
            };
            RemoteMedia.prototype.changeVideoSinkOutput = function (videoSinkOutput) {
                return this._getInternal().changeVideoSinkOutput(videoSinkOutput);
            };
            RemoteMedia.prototype.getAudioSinkOutput = function () {
                return this._getInternal().getAudioSinkOutput();
            };
            RemoteMedia.prototype.getAudioSinkOutputs = function () {
                return this._getInternal().getAudioSinkOutputs();
            };
            RemoteMedia.prototype.getVideoSinkOutput = function () {
                return this._getInternal().getVideoSinkOutput();
            };
            RemoteMedia.prototype.getVideoSinkOutputs = function () {
                return this._getInternal().getVideoSinkOutputs();
            };
            RemoteMedia.prototype.setAudioSinkOutput = function (value) {
                this._getInternal().setAudioSinkOutput(value);
            };
            RemoteMedia.prototype.setVideoSinkOutput = function (value) {
                this._getInternal().setVideoSinkOutput(value);
            };
            return RemoteMedia;
        }(fm.liveswitch.Media));
        liveswitch.RemoteMedia = RemoteMedia;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var SessionDescriptionManagerBase = /** @class */ (function () {
            function SessionDescriptionManagerBase() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.__streamIndex = new Array();
                    this.__audioStreamIndex = new Array();
                    this.__videoStreamIndex = new Array();
                    this.__dataStreamIndex = new Array();
                    this.__streamMatcher = new fm.liveswitch.SessionDescriptionStreamMatcher(0);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            SessionDescriptionManagerBase.prototype.getTypeString = function () {
                return '[fm.liveswitch.SessionDescriptionManagerBase]';
            };
            /** @hidden */
            SessionDescriptionManagerBase.updateTrickleIcePolicy = function (message, policy) {
                if (arguments.length == 2) {
                    if (((fm.liveswitch.Global.equals(policy, fm.liveswitch.TrickleIcePolicy.FullTrickle)) || (fm.liveswitch.Global.equals(policy, fm.liveswitch.TrickleIcePolicy.HalfTrickle)))) {
                        message.setSupportsTrickleIce(true);
                    }
                    else {
                        message.setSupportsTrickleIce(false);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SessionDescriptionManagerBase.prototype.addMediaDescriptions = function (msg, descriptions) {
                if (arguments.length == 2) {
                    var length_5 = descriptions.length;
                    var descriptionArray = new Array(length_5);
                    for (var i = 0; (i < length_5); i++) {
                        var offererStreamIndexFor = this.__streamMatcher.getOffererStreamIndexFor(i);
                        descriptionArray[offererStreamIndexFor] = descriptions[i];
                    }
                    for (var _i = 0, descriptionArray_1 = descriptionArray; _i < descriptionArray_1.length; _i++) {
                        var description = descriptionArray_1[_i];
                        msg.addMediaDescription(description);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SessionDescriptionManagerBase.prototype.addStream = function (stream) {
                if (arguments.length == 1) {
                    fm.liveswitch.HashExtensions.add(this.getStreams(), stream.getId(), stream);
                    this.addToIndex(stream);
                    this.resetStreamMatcher();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SessionDescriptionManagerBase.prototype.addToIndex = function (stream) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__streamIndex, stream);
                    if ((fm.liveswitch.Global.equals(stream.getType(), fm.liveswitch.StreamType.Audio))) {
                        fm.liveswitch.ArrayExtensions.add(this.__audioStreamIndex, stream);
                    }
                    else {
                        if ((fm.liveswitch.Global.equals(stream.getType(), fm.liveswitch.StreamType.Video))) {
                            fm.liveswitch.ArrayExtensions.add(this.__videoStreamIndex, stream);
                        }
                        else {
                            if ((!fm.liveswitch.Global.equals(stream.getType(), fm.liveswitch.StreamType.Application))) {
                                throw new fm.liveswitch.Exception("Unsupported stream type.");
                            }
                            fm.liveswitch.ArrayExtensions.add(this.__dataStreamIndex, stream);
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SessionDescriptionManagerBase.prototype.getOffererStreamIndexFor = function (answererStreamIndex) {
                if (arguments.length == 1) {
                    return this.__streamMatcher.getOffererStreamIndexFor(answererStreamIndex);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SessionDescriptionManagerBase.prototype.matchAndProcessDescriptionPerType = function (streams, description, isLocalDescription, streamMatcher, processSdpMediaDescriptionForStreamHandler, processSdpMediaDescriptionInternal) {
                if (arguments.length == 6) {
                    if ((fm.liveswitch.Global.equals(processSdpMediaDescriptionForStreamHandler, null))) {
                        throw new fm.liveswitch.Exception("ProcessSdpMediaDescriptionForStreamHandler is not set.");
                    }
                    var indexInType = 0;
                    var sdpMessage = description.getSdpMessage();
                    var mediaDescriptions = sdpMessage.getMediaDescriptions();
                    for (var _i = 0, streams_2 = streams; _i < streams_2.length; _i++) {
                        var local = streams_2[_i];
                        var type = local.getType();
                        var offererStreamMediaIndexForStream = streamMatcher.getOffererStreamMediaIndexForStream(type, indexInType);
                        if ((fm.liveswitch.Global.equals(offererStreamMediaIndexForStream, -1))) {
                            return new fm.liveswitch.Error(fm.liveswitch.ErrorCode.ConnectionInvalidArchitecture, new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("SDP offer did not contain stream of type {0} or stream of this type is not supported.", new fm.liveswitch.StreamTypeWrapper(local.getType()).toString())));
                        }
                        var internalStreamMediaIndexForStream = streamMatcher.getInternalStreamMediaIndexForStream(type, indexInType);
                        streamMatcher.setMatchingIndexes(internalStreamMediaIndexForStream, offererStreamMediaIndexForStream);
                        var description2 = mediaDescriptions[offererStreamMediaIndexForStream];
                        var error = processSdpMediaDescriptionForStreamHandler(local, description2, offererStreamMediaIndexForStream, isLocalDescription, description.getRenegotiation());
                        if ((!fm.liveswitch.Global.equals(error, null))) {
                            return error;
                        }
                        if (processSdpMediaDescriptionInternal) {
                            error = local.processSdpMediaDescription(sdpMessage, description2, offererStreamMediaIndexForStream, isLocalDescription, description.getIsOffer(), description.getRenegotiation());
                            if ((!fm.liveswitch.Global.equals(error, null))) {
                                return error;
                            }
                        }
                        indexInType++;
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SessionDescriptionManagerBase.prototype.parseSessionDescriptionForStreamChangesAndUpdateMids = function (newRemoteDescription, existingAudioStreams, existingVideoStreams, existingDataStreams) {
                if (arguments.length == 4) {
                    var renegotiation = newRemoteDescription.getRenegotiation();
                    var mediaDescriptions = newRemoteDescription.getSdpMessage().getMediaDescriptions();
                    var streamsByMid = {};
                    var index = -1;
                    var num2 = -1;
                    var num3 = -1;
                    for (var _i = 0, existingAudioStreams_1 = existingAudioStreams; _i < existingAudioStreams_1.length; _i++) {
                        var local = existingAudioStreams_1[_i];
                        if (!fm.liveswitch.StringExtensions.isNullOrEmpty(local.getMediaStreamIdentification())) {
                            streamsByMid[local.getMediaStreamIdentification()] = local;
                        }
                    }
                    for (var _a = 0, existingVideoStreams_1 = existingVideoStreams; _a < existingVideoStreams_1.length; _a++) {
                        var local = existingVideoStreams_1[_a];
                        if (!fm.liveswitch.StringExtensions.isNullOrEmpty(local.getMediaStreamIdentification())) {
                            streamsByMid[local.getMediaStreamIdentification()] = local;
                        }
                    }
                    for (var _b = 0, existingDataStreams_1 = existingDataStreams; _b < existingDataStreams_1.length; _b++) {
                        var local = existingDataStreams_1[_b];
                        if (!fm.liveswitch.StringExtensions.isNullOrEmpty(local.getMediaStreamIdentification())) {
                            streamsByMid[local.getMediaStreamIdentification()] = local;
                        }
                    }
                    var foundStreams = new Array();
                    var newStreams = new Array();
                    for (var _c = 0, mediaDescriptions_1 = mediaDescriptions; _c < mediaDescriptions_1.length; _c++) {
                        var description = mediaDescriptions_1[_c];
                        var mediaType = description.getMedia().getMediaType();
                        var mediaStreamIdentifierAttribute = description.getMediaStreamIdentifierAttribute();
                        var mid = fm.liveswitch.StringExtensions.empty;
                        if ((!fm.liveswitch.Global.equals(mediaStreamIdentifierAttribute, null))) {
                            mid = mediaStreamIdentifierAttribute.getIdentificationTag();
                        }
                        mediaType = fm.liveswitch.StringExtensions.trim(mediaType);
                        var _var0 = mediaType;
                        if (_var0 == "audio") {
                            do {
                                index++;
                                if ((fm.liveswitch.Global.equals(mid, fm.liveswitch.StringExtensions.empty))) {
                                    mid = fm.liveswitch.StringExtensions.concat("audio", fm.liveswitch.NumberExtensions.toString(index));
                                }
                                if (renegotiation) {
                                    this.processMSection(foundStreams, newStreams, streamsByMid, description, mid);
                                }
                                else {
                                    existingAudioStreams[index].setMediaStreamIdentification(mid);
                                }
                                break;
                            } while (false);
                        }
                        else if (_var0 == "video") {
                            do {
                                num3++;
                                if ((fm.liveswitch.Global.equals(mid, fm.liveswitch.StringExtensions.empty))) {
                                    mid = fm.liveswitch.StringExtensions.concat("video", fm.liveswitch.NumberExtensions.toString(num3));
                                }
                                if (renegotiation) {
                                    this.processMSection(foundStreams, newStreams, streamsByMid, description, mid);
                                }
                                else {
                                    existingVideoStreams[num3].setMediaStreamIdentification(mid);
                                }
                                break;
                            } while (false);
                        }
                        else {
                            do {
                                if (!(fm.liveswitch.Global.equals(mediaType, "application"))) {
                                    throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Unsupported stream type {0}", mediaType));
                                }
                                num2++;
                                if ((fm.liveswitch.Global.equals(mid, fm.liveswitch.StringExtensions.empty))) {
                                    mid = fm.liveswitch.StringExtensions.concat("application", fm.liveswitch.NumberExtensions.toString(num2));
                                }
                                if (renegotiation) {
                                    this.processMSection(foundStreams, newStreams, streamsByMid, description, mid);
                                }
                                else {
                                    existingDataStreams[num2].setMediaStreamIdentification(mid);
                                }
                                break;
                            } while (false);
                        }
                    }
                    for (var _d = 0, foundStreams_1 = foundStreams; _d < foundStreams_1.length; _d++) {
                        var local = foundStreams_1[_d];
                        fm.liveswitch.HashExtensions.remove(streamsByMid, local.getMediaStreamIdentification());
                    }
                    var list3 = new Array();
                    for (var _e = 0, _f = fm.liveswitch.HashExtensions.getValues(streamsByMid); _e < _f.length; _e++) {
                        var local2 = _f[_e];
                        fm.liveswitch.ArrayExtensions.add(list3, local2);
                    }
                    return new fm.liveswitch.Pair(fm.liveswitch.ArrayExtensions.toArray(newStreams), fm.liveswitch.ArrayExtensions.toArray(list3));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SessionDescriptionManagerBase.prototype.populateStreamTypeIndexes = function (descriptions, streams, streamMatcher) {
                if (arguments.length == 3) {
                    streamMatcher.reset(fm.liveswitch.ArrayExtensions.getCount(streams));
                    var error = streamMatcher.populateInternalStreamTypeIndexes(streams);
                    if ((fm.liveswitch.Global.equals(error, null))) {
                        error = streamMatcher.populateOffererStreamTypeIndexes(descriptions);
                    }
                    return error;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SessionDescriptionManagerBase.prototype.processDescription = function (description, isLocalDescription) {
                if (arguments.length == 2) {
                    var error = this.validateBaseDescription(description, isLocalDescription);
                    if ((!fm.liveswitch.Global.equals(error, null))) {
                        return error;
                    }
                    var mediaDescriptions = description.getSdpMessage().getMediaDescriptions();
                    if (description.getIsOffer()) {
                        error = this.populateStreamTypeIndexes(mediaDescriptions, this.__streamIndex, this.__streamMatcher);
                        if ((!fm.liveswitch.Global.equals(error, null))) {
                            return error;
                        }
                    }
                    error = this.matchAndProcessDescriptionPerType(this.__audioStreamIndex, description, isLocalDescription, this.__streamMatcher, this.processSdpMediaDescriptionForStream.bind(this), true);
                    if ((!fm.liveswitch.Global.equals(error, null))) {
                        return error;
                    }
                    error = this.matchAndProcessDescriptionPerType(this.__videoStreamIndex, description, isLocalDescription, this.__streamMatcher, this.processSdpMediaDescriptionForStream.bind(this), true);
                    if ((!fm.liveswitch.Global.equals(error, null))) {
                        return error;
                    }
                    error = this.matchAndProcessDescriptionPerType(this.__dataStreamIndex, description, isLocalDescription, this.__streamMatcher, this.processSdpMediaDescriptionForStream.bind(this), true);
                    if ((!fm.liveswitch.Global.equals(error, null))) {
                        return error;
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SessionDescriptionManagerBase.prototype.processMSection = function (foundStreams, newStreams, streamsByMid, mSection, mid) {
                if (arguments.length == 5) {
                    var local = null;
                    var _var0 = new fm.liveswitch.Holder(local);
                    var _var1 = fm.liveswitch.HashExtensions.tryGetValue(streamsByMid, mid, _var0);
                    local = _var0.getValue();
                    if (_var1) {
                        fm.liveswitch.ArrayExtensions.add(foundStreams, local);
                    }
                    else {
                        fm.liveswitch.ArrayExtensions.add(newStreams, new fm.liveswitch.StreamDescription(mSection));
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SessionDescriptionManagerBase.prototype.removeFromIndex = function (stream) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__streamIndex, stream);
                    if ((fm.liveswitch.Global.equals(stream.getType(), fm.liveswitch.StreamType.Audio))) {
                        fm.liveswitch.ArrayExtensions.remove(this.__audioStreamIndex, stream);
                    }
                    else {
                        if ((fm.liveswitch.Global.equals(stream.getType(), fm.liveswitch.StreamType.Video))) {
                            fm.liveswitch.ArrayExtensions.remove(this.__videoStreamIndex, stream);
                        }
                        else {
                            if ((!fm.liveswitch.Global.equals(stream.getType(), fm.liveswitch.StreamType.Application))) {
                                throw new fm.liveswitch.Exception("Unsupported stream type.");
                            }
                            fm.liveswitch.ArrayExtensions.remove(this.__dataStreamIndex, stream);
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SessionDescriptionManagerBase.prototype.removeStream = function (stream) {
                if (arguments.length == 1) {
                    if (fm.liveswitch.HashExtensions.remove(this.getStreams(), stream.getId())) {
                        this.removeFromIndex(stream);
                        this.resetStreamMatcher();
                        return true;
                    }
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SessionDescriptionManagerBase.prototype.resetStreamMatcher = function () {
                if (arguments.length == 0) {
                    if ((!fm.liveswitch.Global.equals(this.__streamMatcher, null))) {
                        this.__streamMatcher.reset(fm.liveswitch.HashExtensions.getCount(this.getStreams()));
                    }
                    else {
                        this.__streamMatcher = new fm.liveswitch.SessionDescriptionStreamMatcher(fm.liveswitch.HashExtensions.getCount(this.getStreams()));
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SessionDescriptionManagerBase.prototype.updateLocalDescription = function (localDescription) {
                if (arguments.length == 1) {
                    var num = void 0;
                    var preferredCodecs = void 0;
                    var username = localDescription.getSdpMessage().getOrigin().getUsername();
                    username = ((fm.liveswitch.Global.equals(fm.liveswitch.StringExtensions.trim(username), "-")) ? fm.liveswitch.StringExtensions.concat("LiveSwitch-", fm.liveswitch.Build.getVersion()) : fm.liveswitch.StringExtensions.concat(username, "_LiveSwitch-", fm.liveswitch.Build.getVersion()));
                    localDescription.getSdpMessage().getOrigin().setUsername(username);
                    var audioStreams = this.getAudioStreams();
                    if ((!fm.liveswitch.Global.equals(audioStreams, null))) {
                        for (num = 0; (num < audioStreams.length); num++) {
                            var local = audioStreams[num];
                            if (local.getOpusDisabled()) {
                                localDescription.getSdpMessage().getAudioDescriptions()[num].purgeFormat(fm.liveswitch.AudioFormat.getOpusName());
                            }
                            if (local.getG722Disabled()) {
                                localDescription.getSdpMessage().getAudioDescriptions()[num].purgeFormat(fm.liveswitch.AudioFormat.getG722Name());
                            }
                            if (local.getPcmuDisabled()) {
                                localDescription.getSdpMessage().getAudioDescriptions()[num].purgeFormat(fm.liveswitch.AudioFormat.getPcmuName());
                            }
                            if (local.getPcmaDisabled()) {
                                localDescription.getSdpMessage().getAudioDescriptions()[num].purgeFormat(fm.liveswitch.AudioFormat.getPcmaName());
                            }
                            preferredCodecs = local.getPreferredCodecs();
                            if ((!fm.liveswitch.Global.equals(preferredCodecs, null))) {
                                localDescription.getSdpMessage().getAudioDescriptions()[num].orderFormats(preferredCodecs);
                            }
                        }
                    }
                    var videoStreams = this.getVideoStreams();
                    if ((!fm.liveswitch.Global.equals(videoStreams, null))) {
                        for (num = 0; (num < videoStreams.length); num++) {
                            var local2 = videoStreams[num];
                            if (local2.getVp8Disabled()) {
                                localDescription.getSdpMessage().getVideoDescriptions()[num].purgeFormat(fm.liveswitch.VideoFormat.getVp8Name());
                            }
                            if (local2.getVp9Disabled()) {
                                localDescription.getSdpMessage().getVideoDescriptions()[num].purgeFormat(fm.liveswitch.VideoFormat.getVp9Name());
                            }
                            if (local2.getH264Disabled()) {
                                localDescription.getSdpMessage().getVideoDescriptions()[num].purgeFormat(fm.liveswitch.VideoFormat.getH264Name());
                            }
                            preferredCodecs = local2.getPreferredCodecs();
                            if ((!fm.liveswitch.Global.equals(preferredCodecs, null))) {
                                localDescription.getSdpMessage().getVideoDescriptions()[num].orderFormats(preferredCodecs);
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SessionDescriptionManagerBase.prototype.validateBaseDescription = function (description, isLocalDescription) {
                if (arguments.length == 2) {
                    var sdpMessage = description.getSdpMessage();
                    if ((fm.liveswitch.Global.equals(sdpMessage, null))) {
                        return new fm.liveswitch.Error(fm.liveswitch.ErrorCode.LocalDescriptionError, new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("{0} session description is empty.", (isLocalDescription ? "Local" : "Remote"))));
                    }
                    var streams = this.getStreams();
                    if (((fm.liveswitch.Global.equals(streams, null)) || (fm.liveswitch.Global.equals(fm.liveswitch.HashExtensions.getCount(streams), 0)))) {
                        return new fm.liveswitch.Error(fm.liveswitch.ErrorCode.ConnectionInvalidArchitecture, new fm.liveswitch.Exception("At least one local stream is required for the connection to conduct signalling exchange."));
                    }
                    var mediaDescriptions = sdpMessage.getMediaDescriptions();
                    if (((fm.liveswitch.Global.equals(mediaDescriptions, null)) || (fm.liveswitch.Global.equals(mediaDescriptions.length, 0)))) {
                        return new fm.liveswitch.Error(fm.liveswitch.ErrorCode.ConnectionInvalidArchitecture, new fm.liveswitch.Exception("At least one media description is required for the connection to conduct signalling exchange."));
                    }
                    var count = fm.liveswitch.HashExtensions.getCount(streams);
                    var length_6 = mediaDescriptions.length;
                    if ((!fm.liveswitch.Global.equals(count, length_6))) {
                        return new fm.liveswitch.Error(fm.liveswitch.ErrorCode.ConnectionInvalidArchitecture, new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("There is a mismatch between the number of local streams ({0}) and the number of media descriptions ({1}).", fm.liveswitch.NumberExtensions.toString(count), fm.liveswitch.NumberExtensions.toString(length_6))));
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return SessionDescriptionManagerBase;
        }());
        liveswitch.SessionDescriptionManagerBase = SessionDescriptionManagerBase;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="SessionDescriptionManagerBase.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        @hidden
        */
        var SessionDescriptionManager = /** @class */ (function (_super) {
            __extends(SessionDescriptionManager, _super);
            function SessionDescriptionManager() {
                var _this = _super.call(this) || this;
                _this._streams = {};
                return _this;
            }
            SessionDescriptionManager.prototype.getTypeString = function () {
                return '[fm.liveswitch.SessionDescriptionManager]' + ',' + _super.prototype.getTypeString.call(this);
            };
            SessionDescriptionManager.prototype.getStreams = function () {
                return this._streams;
            };
            SessionDescriptionManager.prototype.getAudioStreams = function () {
                var audioStreams = [];
                this.__streamIndex.forEach(function (stream) {
                    if (stream.getType() == fm.liveswitch.StreamType.Audio) {
                        audioStreams.push(stream);
                    }
                });
                return audioStreams;
            };
            SessionDescriptionManager.prototype.getVideoStreams = function () {
                var videoStreams = [];
                this.__streamIndex.forEach(function (stream) {
                    if (stream.getType() == fm.liveswitch.StreamType.Video) {
                        videoStreams.push(stream);
                    }
                });
                return videoStreams;
            };
            SessionDescriptionManager.prototype.getDataStreams = function () {
                var dataStreams = [];
                this.__streamIndex.forEach(function (stream) {
                    if (stream.getType() == fm.liveswitch.StreamType.Application) {
                        dataStreams.push(stream);
                    }
                });
                return dataStreams;
            };
            SessionDescriptionManager.prototype.processSdpMediaDescriptionForStream = function (stream, sdpMediaDescription, sdpMediaIndex, isLocalDescription, isRenegotiation) {
                return null;
            };
            return SessionDescriptionManager;
        }(fm.liveswitch.SessionDescriptionManagerBase));
        liveswitch.SessionDescriptionManager = SessionDescriptionManager;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="MediaStream.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var VideoStream = /** @class */ (function (_super) {
            __extends(VideoStream, _super);
            function VideoStream() {
                var _this = this;
                if (arguments.length == 0) {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                var localTrack = null;
                var localMedia = null;
                var remoteTrack = null;
                var remoteMedia = null;
                if (arguments.length >= 1 && fm.liveswitch.Util.isNullOrUndefined(arguments[0])) {
                    //throw new fm.liveswitch.Exception('Local track/media cannot be null.');
                }
                else if (arguments.length >= 1 && fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.VideoTrack]')) {
                    localTrack = arguments[0];
                }
                else if (arguments.length >= 1 && fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.LocalMedia]')) {
                    localMedia = arguments[0];
                    localTrack = localMedia.getVideoTrack();
                }
                else if (arguments.length >= 1 && fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.RemoteMedia]')) {
                    remoteMedia = arguments[0];
                    remoteTrack = remoteMedia.getVideoTrack();
                }
                else if (arguments.length >= 1) {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                if (arguments.length >= 2 && fm.liveswitch.Util.isNullOrUndefined(arguments[1])) {
                    //throw new fm.liveswitch.Exception('Remote track/media cannot be null.');
                }
                else if (arguments.length >= 2 && fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.VideoTrack]')) {
                    remoteTrack = arguments[1];
                }
                else if (arguments.length >= 2 && fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.RemoteMedia]')) {
                    remoteMedia = arguments[1];
                    remoteTrack = remoteMedia.getVideoTrack();
                }
                else if (arguments.length >= 2) {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                _this = _super.call(this, localTrack, remoteTrack) || this;
                _this.localMedia = localMedia;
                _this.remoteMedia = remoteMedia;
                if (fm.liveswitch.Plugin.useActiveX()) {
                    _this._internal = new fm.liveswitch.PluginVideoStream(_this, (localTrack == null ? null : localTrack._getInternal()), (remoteTrack == null ? null : remoteTrack._getInternal()));
                }
                else if (fm.liveswitch.Plugin.useNative()) {
                    _this._internal = new fm.liveswitch.WebRtcVideoStream(_this, (localTrack == null ? null : localTrack._getInternal()), (remoteTrack == null ? null : remoteTrack._getInternal()));
                }
                else {
                    throw new fm.liveswitch.Exception('Browser does not support WebRTC/ORTC and no plugin found.');
                }
                return _this;
            }
            VideoStream.prototype.getTypeString = function () {
                return '[fm.liveswitch.VideoStream]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            VideoStream.prototype._getInternal = function () {
                return this._internal;
            };
            VideoStream.prototype.getLocalMedia = function () {
                return this.localMedia;
            };
            VideoStream.prototype.getRemoteMedia = function () {
                return this.remoteMedia;
            };
            VideoStream.prototype.getVp8Disabled = function () {
                return this._getInternal().getVp8Disabled();
            };
            VideoStream.prototype.getVp9Disabled = function () {
                return this._getInternal().getVp9Disabled();
            };
            VideoStream.prototype.getH264Disabled = function () {
                return this._getInternal().getH264Disabled();
            };
            VideoStream.prototype.setVp8Disabled = function (value) {
                return this._getInternal().setVp8Disabled(value);
            };
            VideoStream.prototype.setVp9Disabled = function (value) {
                return this._getInternal().setVp9Disabled(value);
            };
            VideoStream.prototype.setH264Disabled = function (value) {
                return this._getInternal().setH264Disabled(value);
            };
            VideoStream.prototype.addOnDiscardKeyFrameRequest = function (value) {
                this._getInternal().addOnDiscardKeyFrameRequest(value);
            };
            VideoStream.prototype.removeOnDiscardKeyFrameRequest = function (value) {
                this._getInternal().removeOnDiscardKeyFrameRequest(value);
            };
            VideoStream.prototype.raiseKeyFrameRequest = function (synchronizationSources) {
                this._getInternal().raiseKeyFrameRequest(synchronizationSources);
            };
            return VideoStream;
        }(fm.liveswitch.MediaStream));
        liveswitch.VideoStream = VideoStream;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="MediaTrack.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var VideoTrack = /** @class */ (function (_super) {
            __extends(VideoTrack, _super);
            function VideoTrack(media, internalMedia) {
                var _this = _super.call(this, media) || this;
                if (fm.liveswitch.Util.isNullOrUndefined(media)) {
                    throw new fm.liveswitch.Exception('Media cannot be null.');
                }
                if (fm.liveswitch.Plugin.useActiveX()) {
                    _this._internal = new fm.liveswitch.PluginVideoTrack(_this, (media._getInternal() || internalMedia));
                }
                else if (fm.liveswitch.Plugin.useNative()) {
                    _this._internal = new fm.liveswitch.WebRtcVideoTrack(_this, (media._getInternal() || internalMedia));
                }
                else {
                    throw new fm.liveswitch.Exception('Browser does not support WebRTC/ORTC and no plugin found.');
                }
                return _this;
            }
            VideoTrack.prototype.getTypeString = function () {
                return '[fm.liveswitch.VideoTrack]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            VideoTrack.prototype._getInternal = function () {
                return this._internal;
            };
            VideoTrack.prototype.addOnSize = function (value) {
                return this._internal.addOnSize(value);
            };
            VideoTrack.prototype.getSize = function () {
                return this._internal.getSize();
            };
            VideoTrack.prototype.grabFrame = function () {
                return this._internal.grabFrame();
            };
            VideoTrack.prototype.removeOnSize = function (value) {
                return this._internal.removeOnSize(value);
            };
            return VideoTrack;
        }(fm.liveswitch.MediaTrack));
        liveswitch.VideoTrack = VideoTrack;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Stream base properties/methods.
        */
        var WebRtcStreamBase = /** @class */ (function (_super) {
            __extends(WebRtcStreamBase, _super);
            /**
            Initializes a new instance of the [[fm.liveswitch.streamBase]] class.
            @param type The type.
            */
            function WebRtcStreamBase(type) {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var type_3 = __arguments[0];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchWebRtcStreamBaseInit();
                    _this.__id = fm.liveswitch.Utility.generateId();
                    _this.__stateLock = new Object();
                    _this.setType(type_3);
                    _this.setConnectedTimestamp(-1);
                    _this.__stateMachine = new fm.liveswitch.StreamStateMachine();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            WebRtcStreamBase.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcStreamBase]' + ',' + _super.prototype.getTypeString.call(this);
            };
            WebRtcStreamBase.prototype.fmliveswitchWebRtcStreamBaseInit = function () {
                var _this = this;
                this.__onDirectionChange = [];
                this.__onStateChange = [];
                this._connectedTimestamp = 0;
                this._onDirectionChange = function () { for (var _i = 0, _a = _this.__onDirectionChange; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action();
                } };
                this._onStateChange = function () { for (var _i = 0, _a = _this.__onStateChange; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action();
                } };
            };
            /**
            Adds a handler that is raised when the stream direction change has occurred.
            */
            WebRtcStreamBase.prototype.addOnDirectionChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onDirectionChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when the stream state changes.
            */
            WebRtcStreamBase.prototype.addOnStateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onStateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the ManagedStopwatch.GetTimestamp() value representing the ticks that passed when this stream's connection state changed to connected.
            */
            WebRtcStreamBase.prototype.getConnectedTimestamp = function () {
                if (arguments.length == 0) {
                    return this._connectedTimestamp;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connection identifier.
            */
            WebRtcStreamBase.prototype.getConnectionId = function () {
                if (arguments.length == 0) {
                    return this._connectionId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the external identifier.
            */
            WebRtcStreamBase.prototype.getExternalId = function () {
                if (arguments.length == 0) {
                    return this._externalId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the identifier.
            */
            WebRtcStreamBase.prototype.getId = function () {
                if (arguments.length == 0) {
                    return this.__id;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the stream is currently closed or failed.
            */
            WebRtcStreamBase.prototype.getIsTerminated = function () {
                if (arguments.length == 0) {
                    return ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.StreamState.Closed)) || (fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.StreamState.Failed)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the stream is currently closing or failing.
            */
            WebRtcStreamBase.prototype.getIsTerminating = function () {
                if (arguments.length == 0) {
                    return ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.StreamState.Closing)) || (fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.StreamState.Failing)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the stream is currently closing, failing, closed, or failed.
            */
            WebRtcStreamBase.prototype.getIsTerminatingOrTerminated = function () {
                if (arguments.length == 0) {
                    return (this.getIsTerminating() || this.getIsTerminated());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether receiving media is supported by the local peer on this stream.
            */
            WebRtcStreamBase.prototype.getLocalReceive = function () {
                if (arguments.length == 0) {
                    var localDirection = this.getLocalDirection();
                    return ((fm.liveswitch.Global.equals(localDirection, fm.liveswitch.StreamDirection.SendReceive)) || (fm.liveswitch.Global.equals(localDirection, fm.liveswitch.StreamDirection.ReceiveOnly)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether sending media is supported by the local peer on this stream.
            */
            WebRtcStreamBase.prototype.getLocalSend = function () {
                if (arguments.length == 0) {
                    var localDirection = this.getLocalDirection();
                    return ((fm.liveswitch.Global.equals(localDirection, fm.liveswitch.StreamDirection.SendReceive)) || (fm.liveswitch.Global.equals(localDirection, fm.liveswitch.StreamDirection.SendOnly)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media description identifier.
            */
            WebRtcStreamBase.prototype.getMediaDescriptionId = function () {
                if (arguments.length == 0) {
                    return this.getMediaStreamIdentification();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcStreamBase.prototype.getMediaStreamIdentification = function () {
                if (arguments.length == 0) {
                    return this.__mediaStreamIdentification;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether receiving media is supported by the local peer on this stream. Returns false if the remote stream direction has not been received.
            */
            WebRtcStreamBase.prototype.getRemoteReceive = function () {
                if (arguments.length == 0) {
                    var remoteDirection = this.getRemoteDirection();
                    return ((fm.liveswitch.Global.equals(remoteDirection, fm.liveswitch.StreamDirection.SendReceive)) || (fm.liveswitch.Global.equals(remoteDirection, fm.liveswitch.StreamDirection.ReceiveOnly)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether sending media is supported by the remote peer on this stream. Returns false if the remote stream direction has not been received.
            */
            WebRtcStreamBase.prototype.getRemoteSend = function () {
                if (arguments.length == 0) {
                    var remoteDirection = this.getRemoteDirection();
                    return ((fm.liveswitch.Global.equals(remoteDirection, fm.liveswitch.StreamDirection.SendReceive)) || (fm.liveswitch.Global.equals(remoteDirection, fm.liveswitch.StreamDirection.SendOnly)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the state of the stream.
            */
            WebRtcStreamBase.prototype.getState = function () {
                if (arguments.length == 0) {
                    return this.__stateMachine.getState();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcStreamBase.prototype.getStateLock = function () {
                if (arguments.length == 0) {
                    return this.__stateLock;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets optional data to associate with this instance.
            */
            WebRtcStreamBase.prototype.getTag = function () {
                if (arguments.length == 0) {
                    return this._tag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the type.
            */
            WebRtcStreamBase.prototype.getType = function () {
                if (arguments.length == 0) {
                    return this._type;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcStreamBase.prototype.logInvalidStateTransition = function (state) {
                if (arguments.length == 1) {
                    if (fm.liveswitch.Log.getIsDebugEnabled()) {
                        fm.liveswitch.Log.debug(fm.liveswitch.StringExtensions.format("Stream {0} state for connection {1} is currently {2}. Cannot transition to {3} state.", [this.getId(), this.getConnectionId(), fm.liveswitch.StringExtensions.toLower(new fm.liveswitch.StreamStateWrapper(this.getState()).toString()), fm.liveswitch.StringExtensions.toLower(new fm.liveswitch.StreamStateWrapper(state).toString())]));
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a state change.
            */
            WebRtcStreamBase.prototype.processStateChange = function () {
                if (arguments.length == 0) {
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a state lock change.
            */
            WebRtcStreamBase.prototype.processStateLockChange = function () {
                if (arguments.length == 0) {
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcStreamBase.prototype.processUpdateToMediaStreamIdentification = function (oldValue) {
                if (arguments.length == 1) {
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcStreamBase.prototype.raiseDirectionChange = function () {
                if (arguments.length == 0) {
                    var onDirectionChange = this._onDirectionChange;
                    if ((!fm.liveswitch.Global.equals(onDirectionChange, null))) {
                        try {
                            onDirectionChange();
                        }
                        catch (exception) {
                            fm.liveswitch.Log.error(fm.liveswitch.StringExtensions.format("Exception occurred while raising direction change to the application code for stream {0}.", this.getId()), exception);
                        }
                        finally {
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcStreamBase.prototype.raiseStateChange = function () {
                if (arguments.length == 0) {
                    var onStateChange = this._onStateChange;
                    if ((!fm.liveswitch.Global.equals(onStateChange, null))) {
                        try {
                            onStateChange();
                        }
                        catch (exception) {
                            fm.liveswitch.Log.error(fm.liveswitch.StringExtensions.format("Exception occurred while raising state change to the application code for stream {0}.", this.getId()), exception);
                        }
                        finally {
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the stream direction change has occurred.
            */
            WebRtcStreamBase.prototype.removeOnDirectionChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onDirectionChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the stream state changes.
            */
            WebRtcStreamBase.prototype.removeOnStateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onStateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcStreamBase.prototype.setConnectedTimestamp = function (value) {
                if (arguments.length == 1) {
                    this._connectedTimestamp = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcStreamBase.prototype.setConnectionId = function (value) {
                if (arguments.length == 1) {
                    this._connectionId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the external identifier.
            */
            WebRtcStreamBase.prototype.setExternalId = function (value) {
                if (arguments.length == 1) {
                    this._externalId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a value indicating whether receiving media is supported by the local peer on this stream.
            */
            WebRtcStreamBase.prototype.setLocalReceive = function (value) {
                if (arguments.length == 1) {
                    var localDirection = this.getLocalDirection();
                    var _var0 = localDirection;
                    if (_var0 == fm.liveswitch.StreamDirection.SendReceive) {
                        do {
                            if (!value) {
                                this.setLocalDirection(fm.liveswitch.StreamDirection.SendOnly);
                            }
                            break;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.StreamDirection.Inactive || _var0 == fm.liveswitch.StreamDirection.Unset) {
                        do {
                            if (value) {
                                this.setLocalDirection(fm.liveswitch.StreamDirection.ReceiveOnly);
                            }
                            else {
                                this.setLocalDirection(fm.liveswitch.StreamDirection.SendOnly);
                            }
                            break;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.StreamDirection.SendOnly) {
                        do {
                            if (value) {
                                this.setLocalDirection(fm.liveswitch.StreamDirection.SendReceive);
                            }
                            break;
                        } while (false);
                    }
                    else {
                        do {
                            if (((fm.liveswitch.Global.equals(localDirection, fm.liveswitch.StreamDirection.ReceiveOnly)) && !value)) {
                                this.setLocalDirection(fm.liveswitch.StreamDirection.Inactive);
                            }
                            break;
                        } while (false);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a value indicating whether sending media is supported by the local peer on this stream.
            */
            WebRtcStreamBase.prototype.setLocalSend = function (value) {
                if (arguments.length == 1) {
                    var localDirection = this.getLocalDirection();
                    var _var0 = localDirection;
                    if (_var0 == fm.liveswitch.StreamDirection.SendReceive) {
                        do {
                            if (!value) {
                                this.setLocalDirection(fm.liveswitch.StreamDirection.ReceiveOnly);
                            }
                            break;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.StreamDirection.Inactive || _var0 == fm.liveswitch.StreamDirection.Unset) {
                        do {
                            if (value) {
                                this.setLocalDirection(fm.liveswitch.StreamDirection.SendOnly);
                            }
                            else {
                                this.setLocalDirection(fm.liveswitch.StreamDirection.ReceiveOnly);
                            }
                            break;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.StreamDirection.ReceiveOnly) {
                        do {
                            if (value) {
                                this.setLocalDirection(fm.liveswitch.StreamDirection.SendReceive);
                            }
                            break;
                        } while (false);
                    }
                    else {
                        do {
                            if (((fm.liveswitch.Global.equals(localDirection, fm.liveswitch.StreamDirection.SendOnly)) && !value)) {
                                this.setLocalDirection(fm.liveswitch.StreamDirection.Inactive);
                            }
                            break;
                        } while (false);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcStreamBase.prototype.setMediaStreamIdentification = function (value) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(this.__mediaStreamIdentification, value))) {
                        var oldValue = this.__mediaStreamIdentification;
                        this.__mediaStreamIdentification = value;
                        this.processUpdateToMediaStreamIdentification(oldValue);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcStreamBase.prototype.setState = function (state) {
                if (arguments.length == 1) {
                    if (!this.__stateMachine.transition(state)) {
                        if (((!fm.liveswitch.Global.equals(state, this.getState())) && ((!fm.liveswitch.Global.equals(state, fm.liveswitch.StreamState.Closing)) || ((!fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.StreamState.Closed)) && (!fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.StreamState.Failed)))))) {
                            this.logInvalidStateTransition(state);
                        }
                        return false;
                    }
                    if ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.StreamState.Connected))) {
                        this.setConnectedTimestamp(fm.liveswitch.ManagedStopwatch.getTimestamp());
                    }
                    if (fm.liveswitch.Log.getIsInfoEnabled()) {
                        if ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.StreamState.Connected))) {
                            fm.liveswitch.Log.info(fm.liveswitch.StringExtensions.format("{0} stream {1} for connection {2} took {3}ms to connect (connectivity checks and secure key exchange).", [new fm.liveswitch.StreamTypeWrapper(this.getType()).toString(), this.getId(), this.getConnectionId(), fm.liveswitch.NumberExtensions.toString(this.__stateMachine.getLastStateMillis())]));
                        }
                        fm.liveswitch.Log.info(fm.liveswitch.StringExtensions.format("Setting {0} stream {1} state for connection {2} to {3}.", [fm.liveswitch.StringExtensions.toLower(new fm.liveswitch.StreamTypeWrapper(this.getType()).toString()), this.getId(), this.getConnectionId(), fm.liveswitch.StringExtensions.toLower(new fm.liveswitch.StreamStateWrapper(this.getState()).toString())]));
                    }
                    this.raiseStateChange();
                    this.processStateChange();
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcStreamBase.prototype.setStateLock = function (value) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(this.__stateLock, value))) {
                        this.__stateLock = value;
                        this.processStateLockChange();
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets optional data to associate with this instance.
            */
            WebRtcStreamBase.prototype.setTag = function (value) {
                if (arguments.length == 1) {
                    this._tag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcStreamBase.prototype.setType = function (value) {
                if (arguments.length == 1) {
                    this._type = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Returns a string that represents this instance.
            */
            WebRtcStreamBase.prototype.toString = function () {
                if (arguments.length == 0) {
                    return this.getLabel();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return WebRtcStreamBase;
        }(fm.liveswitch.Dynamic));
        liveswitch.WebRtcStreamBase = WebRtcStreamBase;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="WebRtcStreamBase.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var WebRtcStream = /** @class */ (function (_super) {
            __extends(WebRtcStream, _super);
            function WebRtcStream() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            WebRtcStream.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcStream]' + ',' + _super.prototype.getTypeString.call(this);
            };
            WebRtcStream.prototype.getConnection = function () {
                return this._connection;
            };
            WebRtcStream.prototype.setConnection = function (remoteTrack) {
                this._connection = remoteTrack;
            };
            /** @hidden */
            WebRtcStream.prototype.getMediaDescriptionManager = function () {
                if (this._mediaDescriptionManager == null) {
                    this._mediaDescriptionManager = new fm.liveswitch.MediaDescriptionManager();
                }
                return this._mediaDescriptionManager;
            };
            /** @hidden */
            WebRtcStream.prototype.setMediaDescriptionManager = function (manager) {
                this._mediaDescriptionManager = manager;
            };
            WebRtcStream.prototype.setTransportInfo = function (transportInfo) {
                this._transportInfo = transportInfo;
            };
            WebRtcStream.prototype.getTransportInfo = function () {
                return this._transportInfo;
            };
            return WebRtcStream;
        }(fm.liveswitch.WebRtcStreamBase));
        liveswitch.WebRtcStream = WebRtcStream;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="WebRtcStream.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media stream base properties/methods.
        */
        var WebRtcMediaStreamBase = /** @class */ (function (_super) {
            __extends(WebRtcMediaStreamBase, _super);
            /**
            Initializes a new instance of the [[fm.liveswitch.mediaStreamBase]] class.
            @param type The type.
            */
            function WebRtcMediaStreamBase(type) {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var type_4 = __arguments[0];
                    _this = _super.call(this, type_4) || this;
                    _this.fmliveswitchWebRtcMediaStreamBaseInit();
                    _this._renegotiationLock = new Object();
                    _this.__maxSendBitrate = -1;
                    _this.__maxReceiveBitrate = -1;
                    _this.__pendingLocalDirection = fm.liveswitch.StreamDirection.Inactive;
                    _this.__disabledCodecs = {};
                    _this.setLocalDirection(fm.liveswitch.StreamDirection.Unset);
                    _this.setRemoteDirection(fm.liveswitch.StreamDirection.Unset);
                    _this.setLocalBandwidth(-1);
                    _this.setRemoteBandwidth(-1);
                    if ((!fm.liveswitch.Global.equals(fm.liveswitch.Platform.getInstance().getSourceLanguage(), fm.liveswitch.SourceLanguage.TypeScript))) {
                        _this.__localCanonicalName = fm.liveswitch.Utility.generateId();
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            WebRtcMediaStreamBase.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcMediaStreamBase]' + ',' + _super.prototype.getTypeString.call(this);
            };
            WebRtcMediaStreamBase.prototype.fmliveswitchWebRtcMediaStreamBaseInit = function () {
                var _this = this;
                this.__maxReceiveBitrate = 0;
                this.__maxSendBitrate = 0;
                this.__onLocalEncodingDisabled = [];
                this.__onLocalEncodingEnabled = [];
                this._localBandwidth = 0;
                this._onLocalEncodingDisabled = function (p0) { for (var _i = 0, _a = _this.__onLocalEncodingDisabled; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
                this._onLocalEncodingEnabled = function (p0) { for (var _i = 0, _a = _this.__onLocalEncodingEnabled; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
                this._remoteBandwidth = 0;
                this._renegotiationPending = false;
            };
            /**
            Adds a handler that is raised when a local encoding is disabled.
            */
            WebRtcMediaStreamBase.prototype.addOnLocalEncodingDisabled = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onLocalEncodingDisabled, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when a local encoding is enabled.
            */
            WebRtcMediaStreamBase.prototype.addOnLocalEncodingEnabled = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onLocalEncodingEnabled, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Records the pending direction of this stream. The LocalDirection of this stream will be updated when the connection renegotiation commences.
            */
            WebRtcMediaStreamBase.prototype.changeDirection = function (newDirection) {
                if (arguments.length == 1) {
                    var message = "An attempt has been made to modify exisiting media stream direction; however, existing stream capabilities do not support a new setting.";
                    if ((fm.liveswitch.Global.equals(this.getDirectionCapabilities(), fm.liveswitch.StreamDirection.Inactive))) {
                        if ((!fm.liveswitch.Global.equals(newDirection, fm.liveswitch.StreamDirection.Inactive))) {
                            return new fm.liveswitch.Error(fm.liveswitch.ErrorCode.InvalidStreamDirectionChange, new fm.liveswitch.Exception(message));
                        }
                    }
                    else {
                        if ((fm.liveswitch.Global.equals(this.getDirectionCapabilities(), fm.liveswitch.StreamDirection.SendOnly))) {
                            if (((!fm.liveswitch.Global.equals(newDirection, fm.liveswitch.StreamDirection.Inactive)) && (!fm.liveswitch.Global.equals(newDirection, fm.liveswitch.StreamDirection.SendOnly)))) {
                                return new fm.liveswitch.Error(fm.liveswitch.ErrorCode.InvalidStreamDirectionChange, new fm.liveswitch.Exception(message));
                            }
                        }
                        else {
                            if (((fm.liveswitch.Global.equals(this.getDirectionCapabilities(), fm.liveswitch.StreamDirection.ReceiveOnly)) && ((!fm.liveswitch.Global.equals(newDirection, fm.liveswitch.StreamDirection.Inactive)) && (!fm.liveswitch.Global.equals(newDirection, fm.liveswitch.StreamDirection.ReceiveOnly))))) {
                                return new fm.liveswitch.Error(fm.liveswitch.ErrorCode.InvalidStreamDirectionChange, new fm.liveswitch.Exception(message));
                            }
                        }
                    }
                    this.setPendingLocalDirection(newDirection);
                    this.setRenegotiationPending(true);
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcMediaStreamBase.prototype.extractCanonicalName = function (mediaDescription, isLocalDescription) {
                if (arguments.length == 2) {
                    var ssrcAttributes = mediaDescription.getSsrcAttributes();
                    var str = null;
                    for (var _i = 0, ssrcAttributes_1 = ssrcAttributes; _i < ssrcAttributes_1.length; _i++) {
                        var attribute = ssrcAttributes_1[_i];
                        if ((fm.liveswitch.Global.equals(attribute.getName(), fm.liveswitch.sdp.rtp.SsrcAttributeName.getCName()))) {
                            str = attribute.getValue();
                            break;
                        }
                    }
                    if (isLocalDescription) {
                        this.setLocalCanonicalName(str);
                    }
                    else {
                        this.setRemoteCanonicalName(str);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the canonical name. Getting the value of MediaStream.CanonicalName is deprecated. Get the value of MediaStream.LocalCanonicalName instead.
            */
            WebRtcMediaStreamBase.prototype.getCanonicalName = function () {
                if (arguments.length == 0) {
                    fm.liveswitch.Log.warn("Getting the value of MediaStream.CanonicalName is deprecated. Get the value of MediaStream.LocalCanonicalName instead.");
                    return this.getLocalCanonicalName();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether a codec is disabled.
            @param name The codec name.
            @return Whether the codec is disabled.
            */
            WebRtcMediaStreamBase.prototype.getCodecDisabled = function (name) {
                if (arguments.length == 1) {
                    var key = fm.liveswitch.StringExtensions.toLower(name);
                    return fm.liveswitch.HashExtensions.containsKey(this.__disabledCodecs, key);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the direction.
            */
            WebRtcMediaStreamBase.prototype.getDirection = function () {
                if (arguments.length == 0) {
                    if ((fm.liveswitch.Global.equals(this.getLocalDirection(), fm.liveswitch.StreamDirection.SendReceive))) {
                        if ((fm.liveswitch.Global.equals(this.getRemoteDirection(), fm.liveswitch.StreamDirection.ReceiveOnly))) {
                            return fm.liveswitch.StreamDirection.SendOnly;
                        }
                        if ((fm.liveswitch.Global.equals(this.getRemoteDirection(), fm.liveswitch.StreamDirection.SendOnly))) {
                            return fm.liveswitch.StreamDirection.ReceiveOnly;
                        }
                        return this.getRemoteDirection();
                    }
                    if ((fm.liveswitch.Global.equals(this.getLocalDirection(), fm.liveswitch.StreamDirection.SendOnly))) {
                        if (((fm.liveswitch.Global.equals(this.getRemoteDirection(), fm.liveswitch.StreamDirection.Inactive)) || (fm.liveswitch.Global.equals(this.getRemoteDirection(), fm.liveswitch.StreamDirection.SendOnly)))) {
                            return fm.liveswitch.StreamDirection.Inactive;
                        }
                        return this.getLocalDirection();
                    }
                    if ((fm.liveswitch.Global.equals(this.getLocalDirection(), fm.liveswitch.StreamDirection.ReceiveOnly))) {
                        if (((fm.liveswitch.Global.equals(this.getRemoteDirection(), fm.liveswitch.StreamDirection.Inactive)) || (fm.liveswitch.Global.equals(this.getRemoteDirection(), fm.liveswitch.StreamDirection.ReceiveOnly)))) {
                            return fm.liveswitch.StreamDirection.Inactive;
                        }
                        return this.getLocalDirection();
                    }
                    return fm.liveswitch.StreamDirection.Inactive;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media stream info.
            */
            WebRtcMediaStreamBase.prototype.getInfo = function () {
                if (arguments.length == 0) {
                    var info2 = new fm.liveswitch.MediaStreamInfo();
                    info2.setId(_super.prototype.getId.call(this));
                    info2.setTag(_super.prototype.getTag.call(this));
                    info2.setSendMuted(this.getInputMuted());
                    info2.setSendDisabled(fm.liveswitch.StreamDirectionHelper.isSendDisabled(this.getDirection()));
                    info2.setReceiveDisabled(fm.liveswitch.StreamDirectionHelper.isReceiveDisabled(this.getDirection()));
                    var info = info2;
                    this.populateInfo(info);
                    return info;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a label that identifies this class.
            */
            WebRtcMediaStreamBase.prototype.getLabel = function () {
                if (arguments.length == 0) {
                    var _var0 = _super.prototype.getType.call(this);
                    if (_var0 == fm.liveswitch.StreamType.Audio) {
                        do {
                            return "Audio Stream";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.StreamType.Video) {
                        do {
                            return "Video Stream";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.StreamType.Application) {
                        do {
                            return "Application Stream";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.StreamType.Message) {
                        do {
                            return "Message Stream";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.StreamType.Text) {
                        do {
                            return "Text Stream";
                        } while (false);
                    }
                    return "Unknown Stream";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the local bandwidth, in kbps. This value is signalled in the local session description sent to the remote endpoint so it can limit its outbound media bitrate. Use [[fm.liveswitch.mediaStreamBase.maxReceiveBitrate]] to control inbound media bitrate once the session has been negotiated.
            */
            WebRtcMediaStreamBase.prototype.getLocalBandwidth = function () {
                if (arguments.length == 0) {
                    return this._localBandwidth;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the local canonical name.
            */
            WebRtcMediaStreamBase.prototype.getLocalCanonicalName = function () {
                if (arguments.length == 0) {
                    return this.__localCanonicalName;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets current direction indicated by the local description.
            */
            WebRtcMediaStreamBase.prototype.getLocalDirection = function () {
                if (arguments.length == 0) {
                    return this.__localDirection;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the maximum desired receive bitrate, in kbps. This value must be less than or equal to [[fm.liveswitch.mediaStreamBase.localBandwidth]].
            */
            WebRtcMediaStreamBase.prototype.getMaxReceiveBitrate = function () {
                if (arguments.length == 0) {
                    return this.__maxReceiveBitrate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the maximum desired send bitrate, in kbps. This value must be less than or equal to [[fm.liveswitch.mediaStreamBase.remoteBandwidth]].
            */
            WebRtcMediaStreamBase.prototype.getMaxSendBitrate = function () {
                if (arguments.length == 0) {
                    return this.__maxSendBitrate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the input track is muted. Alias for [[fm.liveswitch.mediaStreamBase.inputMuted]].
            */
            WebRtcMediaStreamBase.prototype.getMuted = function () {
                if (arguments.length == 0) {
                    return this.getInputMuted();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcMediaStreamBase.prototype.getPendingLocalDirection = function () {
                if (arguments.length == 0) {
                    return this.__pendingLocalDirection;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets any preferred codecs, in order of preference.
            */
            WebRtcMediaStreamBase.prototype.getPreferredCodecs = function () {
                if (arguments.length == 0) {
                    return this._preferredCodecs;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote bandwidth, in kbps. This value is signalled in the remote session description received from the remote endpoint so we can limit our outbound media bitrate. Use [[fm.liveswitch.mediaStreamBase.maxSendBitrate]] to control outbound media bitrate once the session has been negotiated.
            */
            WebRtcMediaStreamBase.prototype.getRemoteBandwidth = function () {
                if (arguments.length == 0) {
                    return this._remoteBandwidth;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote canonical name.
            */
            WebRtcMediaStreamBase.prototype.getRemoteCanonicalName = function () {
                if (arguments.length == 0) {
                    return this._remoteCanonicalName;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets current direction indicated by the remote description.
            */
            WebRtcMediaStreamBase.prototype.getRemoteDirection = function () {
                if (arguments.length == 0) {
                    return this.__remoteDirection;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote encoding.
            */
            WebRtcMediaStreamBase.prototype.getRemoteEncoding = function () {
                if (arguments.length == 0) {
                    return this._remoteEncoding;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether there exist changes that are pending SDP renegotiation.
            */
            WebRtcMediaStreamBase.prototype.getRenegotiationPending = function () {
                if (arguments.length == 0) {
                    return this._renegotiationPending;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Raises the OnLocalEncodingDisabled event.
            @param encoding The encoding.
            */
            WebRtcMediaStreamBase.prototype.raiseLocalEncodingDisabled = function (encoding) {
                if (arguments.length == 1) {
                    var onLocalEncodingDisabled = this._onLocalEncodingDisabled;
                    if ((!fm.liveswitch.Global.equals(onLocalEncodingDisabled, null))) {
                        onLocalEncodingDisabled(encoding);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Raises the OnLocalEncodingEnabled event.
            @param encoding The encoding.
            */
            WebRtcMediaStreamBase.prototype.raiseLocalEncodingEnabled = function (encoding) {
                if (arguments.length == 1) {
                    var onLocalEncodingEnabled = this._onLocalEncodingEnabled;
                    if ((!fm.liveswitch.Global.equals(onLocalEncodingEnabled, null))) {
                        onLocalEncodingEnabled(encoding);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when a local encoding is disabled.
            */
            WebRtcMediaStreamBase.prototype.removeOnLocalEncodingDisabled = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onLocalEncodingDisabled, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when a local encoding is enabled.
            */
            WebRtcMediaStreamBase.prototype.removeOnLocalEncodingEnabled = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onLocalEncodingEnabled, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether a codec is disabled.
            @param name The codec name.
            @param disabled Whether to disable the codec.
            */
            WebRtcMediaStreamBase.prototype.setCodecDisabled = function (name, disabled) {
                if (arguments.length == 2) {
                    var key = fm.liveswitch.StringExtensions.toLower(name);
                    if (disabled) {
                        this.__disabledCodecs[key] = new Object();
                    }
                    else {
                        fm.liveswitch.HashExtensions.remove(this.__disabledCodecs, key);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the local bandwidth, in kbps. This value is signalled in the local session description sent to the remote endpoint so it can limit its outbound media bitrate. Use [[fm.liveswitch.mediaStreamBase.maxReceiveBitrate]] to control inbound media bitrate once the session has been negotiated.
            */
            WebRtcMediaStreamBase.prototype.setLocalBandwidth = function (value) {
                if (arguments.length == 1) {
                    this._localBandwidth = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcMediaStreamBase.prototype.setLocalCanonicalName = function (value) {
                if (arguments.length == 1) {
                    this.__localCanonicalName = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets current direction indicated by the local description.
            */
            WebRtcMediaStreamBase.prototype.setLocalDirection = function (value) {
                if (arguments.length == 1) {
                    var direction = this.getDirection();
                    this.__localDirection = value;
                    if ((!fm.liveswitch.Global.equals(direction, this.getDirection()))) {
                        _super.prototype.raiseDirectionChange.call(this);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the maximum desired receive bitrate, in kbps. This value must be less than or equal to [[fm.liveswitch.mediaStreamBase.localBandwidth]].
            */
            WebRtcMediaStreamBase.prototype.setMaxReceiveBitrate = function (value) {
                if (arguments.length == 1) {
                    var localBandwidth = this.getLocalBandwidth();
                    if (((!fm.liveswitch.Global.equals(localBandwidth, -1)) && (value > localBandwidth))) {
                        value = localBandwidth;
                    }
                    if ((value < 0)) {
                        value = -1;
                    }
                    this.__maxReceiveBitrate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the maximum desired send bitrate, in kbps. This value must be less than or equal to [[fm.liveswitch.mediaStreamBase.remoteBandwidth]].
            */
            WebRtcMediaStreamBase.prototype.setMaxSendBitrate = function (value) {
                if (arguments.length == 1) {
                    var remoteBandwidth = this.getRemoteBandwidth();
                    if (((!fm.liveswitch.Global.equals(remoteBandwidth, -1)) && (value > remoteBandwidth))) {
                        value = remoteBandwidth;
                    }
                    if ((value < 0)) {
                        value = -1;
                    }
                    this.__maxSendBitrate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the input track is muted. Alias for [[fm.liveswitch.mediaStreamBase.inputMuted]].
            */
            WebRtcMediaStreamBase.prototype.setMuted = function (value) {
                if (arguments.length == 1) {
                    this.setInputMuted(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcMediaStreamBase.prototype.setPendingLocalDirection = function (value) {
                if (arguments.length == 1) {
                    this.__pendingLocalDirection = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets any preferred codecs, in order of preference.
            */
            WebRtcMediaStreamBase.prototype.setPreferredCodecs = function (value) {
                if (arguments.length == 1) {
                    this._preferredCodecs = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote bandwidth, in kbps. This value is signalled in the remote session description received from the remote endpoint so we can limit our outbound media bitrate. Use [[fm.liveswitch.mediaStreamBase.maxSendBitrate]] to control outbound media bitrate once the session has been negotiated.
            */
            WebRtcMediaStreamBase.prototype.setRemoteBandwidth = function (value) {
                if (arguments.length == 1) {
                    this._remoteBandwidth = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcMediaStreamBase.prototype.setRemoteCanonicalName = function (value) {
                if (arguments.length == 1) {
                    this._remoteCanonicalName = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcMediaStreamBase.prototype.setRemoteDirection = function (value) {
                if (arguments.length == 1) {
                    var direction = this.getDirection();
                    this.__remoteDirection = value;
                    if ((!fm.liveswitch.Global.equals(direction, this.getDirection()))) {
                        _super.prototype.raiseDirectionChange.call(this);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote encoding.
            */
            WebRtcMediaStreamBase.prototype.setRemoteEncoding = function (value) {
                if (arguments.length == 1) {
                    this._remoteEncoding = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether there exist changes that are pending SDP renegotiation.
            */
            WebRtcMediaStreamBase.prototype.setRenegotiationPending = function (value) {
                if (arguments.length == 1) {
                    this._renegotiationPending = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return WebRtcMediaStreamBase;
        }(fm.liveswitch.WebRtcStream));
        liveswitch.WebRtcMediaStreamBase = WebRtcMediaStreamBase;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="WebRtcMediaStreamBase.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var WebRtcMediaStream = /** @class */ (function (_super) {
            __extends(WebRtcMediaStream, _super);
            function WebRtcMediaStream(external, localTrack, remoteTrack, type) {
                var _this = _super.call(this, type) || this;
                /** @hidden */
                _this._onDiscardBitrateRequestValues = [];
                /** @hidden */
                _this._onDiscardBitrateNotificationValues = [];
                /** @hidden */
                _this._deactivatedByServer = null;
                /** @hidden */
                _this._maxVideoSize = new fm.liveswitch.Size();
                /** @hidden */
                _this._sender = null;
                /** @hidden */
                _this._receiver = null;
                /** @hidden */
                _this._singleSendBitrate = -1; // if no simulcast
                /** @hidden */
                _this._sendEncodings = null;
                /** @hidden */
                _this._receiveEncodings = null;
                _this._simulcastMode = fm.liveswitch.SimulcastMode.Disabled;
                if (localTrack == null) {
                    _this.setLocalDirection(fm.liveswitch.StreamDirection.ReceiveOnly);
                }
                else {
                    _this.setLocalDirection(fm.liveswitch.StreamDirection.SendReceive);
                }
                //TODO: can we initialize the remote track early?
                _this.setRemoteDirection(fm.liveswitch.StreamDirection.SendReceive); // until we know better
                _this.setLocalTrack(localTrack);
                _this.setRemoteTrack(remoteTrack);
                if (localTrack) {
                    localTrack.addOutput(_this);
                }
                if (remoteTrack) {
                    remoteTrack.addInput(_this);
                }
                _this.addOnStateChange(function () {
                    if (_this.getState() == fm.liveswitch.StreamState.Closed || _this.getState() == fm.liveswitch.StreamState.Failed) {
                        if (localTrack) {
                            localTrack.removeOutput(_this);
                        }
                        if (remoteTrack) {
                            remoteTrack.removeInput(_this);
                        }
                    }
                });
                return _this;
            }
            WebRtcMediaStream.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcMediaStream]' + ',' + _super.prototype.getTypeString.call(this);
            };
            WebRtcMediaStream.prototype.getLocalTrack = function () {
                return this._localTrack;
            };
            WebRtcMediaStream.prototype.setLocalTrack = function (localTrack) {
                this._localTrack = localTrack;
            };
            WebRtcMediaStream.prototype.getRemoteTrack = function () {
                return this._remoteTrack;
            };
            WebRtcMediaStream.prototype.setRemoteTrack = function (remoteTrack) {
                this._remoteTrack = remoteTrack;
            };
            WebRtcMediaStream.prototype.setInputMuted = function (muted) {
                if (this._localTrack) {
                    this._localTrack.setMuted(muted);
                }
            };
            WebRtcMediaStream.prototype.getInputMuted = function () {
                if (this._localTrack) {
                    return this._localTrack.getMuted();
                }
                return false;
            };
            WebRtcMediaStream.prototype.setOutputMuted = function (muted) {
                if (this._remoteTrack) {
                    this._remoteTrack.setMuted(muted);
                }
            };
            WebRtcMediaStream.prototype.getOutputMuted = function () {
                if (this._remoteTrack) {
                    return this._remoteTrack.getMuted();
                }
                return false;
            };
            /** @hidden */
            WebRtcMediaStream.prototype.setMaxWidthAndHeight = function (width, height) {
                if (width > 0 && height > 0) {
                    if (width < height) {
                        var temp = width;
                        width = height;
                        height = temp;
                    }
                    if (this._maxVideoSize.getWidth() * this._maxVideoSize.getHeight() < width * height) {
                        this._maxVideoSize.setWidth(width);
                        this._maxVideoSize.setHeight(height);
                    }
                }
            };
            WebRtcMediaStream.prototype.populateInfo = function (info) {
                info.setMaxFrameWidth(this._maxVideoSize.getWidth());
                info.setMaxFrameHeight(this._maxVideoSize.getHeight());
                if (this._sender && this._sender.getParameters) {
                    var params = this._sender.getParameters();
                    if (params) {
                        var codecs = params.codecs;
                        if (codecs) {
                            info.setSendFormats(this.toFormatInfos(codecs));
                        }
                    }
                }
                var sendEncodings = this.getSendEncodingInfos();
                if (sendEncodings) {
                    info.setSendEncodings(sendEncodings);
                }
                if (this._receiver && this._receiver.getParameters) {
                    var params = this._receiver.getParameters();
                    if (params) {
                        var codecs = params.codecs;
                        if (codecs) {
                            info.setReceiveFormats(this.toFormatInfos(codecs));
                        }
                    }
                }
                var receiveEncodings = this.getReceiveEncodingInfos();
                if (receiveEncodings) {
                    info.setReceiveEncodings(receiveEncodings);
                }
            };
            /** @hidden */
            WebRtcMediaStream.prototype.toFormatInfos = function (codecs) {
                var formatInfos = [];
                for (var _i = 0, codecs_1 = codecs; _i < codecs_1.length; _i++) {
                    var codec = codecs_1[_i];
                    var name_3 = codec.mimeType;
                    if (!name_3) {
                        continue;
                    }
                    if (name_3.indexOf('/') != -1) {
                        name_3 = name_3.split('/')[1];
                    }
                    var formatInfo = null;
                    if (this.getType() == fm.liveswitch.StreamType.Audio) {
                        formatInfo = new fm.liveswitch.FormatInfo(name_3, codec.clockRate, codec.channels);
                    }
                    else {
                        formatInfo = new fm.liveswitch.FormatInfo(name_3, codec.clockRate);
                    }
                    formatInfos.push(formatInfo);
                }
                return formatInfos;
            };
            /** @hidden */
            WebRtcMediaStream.prototype.getSender = function () {
                return this._sender;
            };
            /** @hidden */
            WebRtcMediaStream.prototype.setSender = function (value, applySendEncodings) {
                this._sender = value;
                if (applySendEncodings) {
                    this.applySendEncodings();
                }
            };
            /** @hidden */
            WebRtcMediaStream.prototype.getReceiver = function () {
                return this._receiver;
            };
            /** @hidden */
            WebRtcMediaStream.prototype.setReceiver = function (value) {
                this._receiver = value;
            };
            /** @hidden */
            WebRtcMediaStream.prototype.getSingleSendBitrate = function () {
                return this._singleSendBitrate;
            };
            /** @hidden */
            WebRtcMediaStream.prototype.getSendEncodings = function () {
                return this._sendEncodings;
            };
            /** @hidden */
            WebRtcMediaStream.prototype.setSendEncodings = function (sendEncodings) {
                this._sendEncodings = sendEncodings;
                if (this._deactivatedByServer == null) {
                    this._deactivatedByServer = [];
                    for (var i = 0; i < sendEncodings.length; i++) {
                        this._deactivatedByServer.push(false);
                    }
                }
                this.applySendEncodings();
            };
            /** @hidden */
            WebRtcMediaStream.prototype.applySendEncodings = function (sendEncodingIndex) {
                var _this = this;
                if (this.getSimulcastMode() == fm.liveswitch.SimulcastMode.Disabled) {
                    return null;
                }
                var sendEncodings = this._sendEncodings;
                if (!sendEncodings || sendEncodings.length == 0) {
                    return null;
                }
                var sender = this._sender;
                if (!sender || !sender.getParameters) {
                    return null;
                }
                var params = sender.getParameters();
                if (!params) {
                    return null;
                }
                var nativeSendEncodings = params.encodings;
                if (nativeSendEncodings && nativeSendEncodings.length > 0) {
                    if (nativeSendEncodings.length <= sendEncodings.length) {
                        for (var i = 0; i < nativeSendEncodings.length; i++) {
                            if (sendEncodingIndex != undefined && sendEncodingIndex != i) {
                                continue;
                            }
                            if (!this.updateNativeEncoding(nativeSendEncodings[i], sendEncodings[i], this._deactivatedByServer[i])) {
                                continue;
                            }
                            var encodingInfo = new fm.liveswitch.EncodingInfo();
                            this.updateEncodingInfo(encodingInfo, sendEncodings[i], true);
                            var rid = 'rid' in nativeSendEncodings[i] ? nativeSendEncodings[i].rid : null;
                            if (rid != null) {
                                encodingInfo.setRtpStreamId(rid);
                            }
                            var ssrc = 'ssrc' in nativeSendEncodings[i] ? nativeSendEncodings[i].ssrc : -1;
                            if (ssrc != -1) {
                                encodingInfo.setSynchronizationSource(ssrc);
                            }
                            if (!nativeSendEncodings[i].active) {
                                this.raiseLocalEncodingDisabled(encodingInfo);
                                if (ssrc == -1 && rid == null) {
                                    fm.liveswitch.Log.debug(new fm.liveswitch.StreamTypeWrapper(this.getType()).toString() + ' stream encoding has paused.');
                                }
                                else if (ssrc == -1) {
                                    fm.liveswitch.Log.debug(new fm.liveswitch.StreamTypeWrapper(this.getType()).toString() + ' stream encoding with RTP stream ID ' + rid + ' has paused.');
                                }
                                else if (rid == null) {
                                    fm.liveswitch.Log.debug(new fm.liveswitch.StreamTypeWrapper(this.getType()).toString() + ' stream encoding with SSRC ' + ssrc + ' has paused.');
                                }
                                else {
                                    fm.liveswitch.Log.debug(new fm.liveswitch.StreamTypeWrapper(this.getType()).toString() + ' stream encoding with SSRC ' + ssrc + ' and RTP stream ID ' + rid + ' has paused.');
                                }
                                // deactivated
                                var bitrateNotification = new fm.liveswitch.BitrateNotification();
                                bitrateNotification.setBitrate(0);
                                if (rid != null) {
                                    bitrateNotification.setRtpStreamId(rid);
                                }
                                if (ssrc != -1) {
                                    bitrateNotification.setSynchronizationSource(ssrc);
                                }
                                this.processBitrateNotification(bitrateNotification);
                            }
                            else {
                                this.raiseLocalEncodingEnabled(encodingInfo);
                                if (ssrc == -1 && rid == null) {
                                    fm.liveswitch.Log.debug(new fm.liveswitch.StreamTypeWrapper(this.getType()).toString() + ' stream encoding has resumed.');
                                }
                                else if (ssrc == -1) {
                                    fm.liveswitch.Log.debug(new fm.liveswitch.StreamTypeWrapper(this.getType()).toString() + ' stream encoding with RTP stream ID ' + rid + ' has resumed.');
                                }
                                else if (rid == null) {
                                    fm.liveswitch.Log.debug(new fm.liveswitch.StreamTypeWrapper(this.getType()).toString() + ' stream encoding with SSRC ' + ssrc + ' has resumed.');
                                }
                                else {
                                    fm.liveswitch.Log.debug(new fm.liveswitch.StreamTypeWrapper(this.getType()).toString() + ' stream encoding with SSRC ' + ssrc + ' and RTP stream ID ' + rid + ' has resumed.');
                                }
                            }
                        }
                    }
                    else {
                        fm.liveswitch.Log.error('Could not set local ' + new fm.liveswitch.StreamTypeWrapper(this.getType()).toString() + ' send encodings.', new fm.liveswitch.Exception('Cannot change the number of send encodings.'));
                    }
                }
                else {
                    nativeSendEncodings = this.getNativeSendEncodings();
                    var rtpStreamIndex = 0;
                    for (var _i = 0, nativeSendEncodings_1 = nativeSendEncodings; _i < nativeSendEncodings_1.length; _i++) {
                        var nativeSendEncoding = nativeSendEncodings_1[_i];
                        nativeSendEncoding.rid = (rtpStreamIndex++).toString();
                    }
                    params.encodings = nativeSendEncodings;
                }
                this._sender.setParameters(params).catch(function (error) {
                    fm.liveswitch.Log.error('Could not set local ' + new fm.liveswitch.StreamTypeWrapper(_this.getType()).toString() + ' send encodings.', new fm.liveswitch.Exception('' + error));
                });
                return params;
            };
            /** @hidden */
            WebRtcMediaStream.prototype.getReceiveEncodings = function () {
                return this._receiveEncodings;
            };
            /** @hidden */
            WebRtcMediaStream.prototype.setReceiveEncodings = function (receiveEncodings) {
                this._receiveEncodings = receiveEncodings;
            };
            /** @hidden */
            WebRtcMediaStream.prototype.getNativeSendEncodings = function () {
                if (this.getSimulcastMode() == fm.liveswitch.SimulcastMode.Disabled) {
                    return null;
                }
                if (!this._sendEncodings) {
                    return null;
                }
                var nativeEncodings = [];
                for (var _i = 0, _a = this._sendEncodings; _i < _a.length; _i++) {
                    var sendEncoding = _a[_i];
                    var nativeEncoding = {};
                    this.updateNativeEncoding(nativeEncoding, sendEncoding, false);
                    nativeEncodings.push(nativeEncoding);
                }
                return nativeEncodings;
            };
            /** @hidden */
            WebRtcMediaStream.prototype.getSendEncodingInfos = function () {
                var sendEncodings = this._sendEncodings;
                // if the send encodings have not been explicitly set yet
                // by the connection initialization routine (triggered by
                // the creation or procesing of an offer or answer), then
                // attempt to infer them implicitly
                if (!sendEncodings) {
                    var localTrack = this.getLocalTrack();
                    if (localTrack) {
                        var media = localTrack.getMedia();
                        if (media && media instanceof fm.liveswitch.WebRtcLocalMedia) {
                            var localMedia = media;
                            if (localMedia) {
                                if (this.getType() == fm.liveswitch.StreamType.Audio) {
                                    sendEncodings = localMedia.getAudioEncodings();
                                }
                                else if (this.getType() == fm.liveswitch.StreamType.Video) {
                                    sendEncodings = localMedia.getVideoEncodings();
                                }
                            }
                        }
                    }
                }
                if (!sendEncodings) {
                    return [];
                }
                var encodingInfos = [];
                for (var _i = 0, sendEncodings_1 = sendEncodings; _i < sendEncodings_1.length; _i++) {
                    var sendEncoding = sendEncodings_1[_i];
                    var encodingInfo = new fm.liveswitch.EncodingInfo();
                    this.updateEncodingInfo(encodingInfo, sendEncoding, true);
                    encodingInfos.push(encodingInfo);
                }
                return encodingInfos;
            };
            /** @hidden */
            WebRtcMediaStream.prototype.getReceiveEncodingInfos = function () {
                if (!this._receiveEncodings) {
                    return [];
                }
                var encodingInfos = [];
                for (var _i = 0, _a = this._receiveEncodings; _i < _a.length; _i++) {
                    var receiveEncoding = _a[_i];
                    var encodingInfo = new fm.liveswitch.EncodingInfo();
                    this.updateEncodingInfo(encodingInfo, receiveEncoding, false);
                    encodingInfos.push(encodingInfo);
                }
                return encodingInfos;
            };
            /** @hidden */
            WebRtcMediaStream.prototype.updateNativeEncoding = function (nativeEncoding, encoding, deactivatedByServer) {
                var newActive = !(encoding.getDeactivated() || deactivatedByServer);
                var oldActive = nativeEncoding.active;
                nativeEncoding.active = newActive;
                var bitrate = encoding.getBitrate();
                if (bitrate > 0) {
                    nativeEncoding.maxBitrate = bitrate * 1000;
                }
                if (this.getType() == fm.liveswitch.StreamType.Video) {
                    var videoEncoding = encoding;
                    var frameRate = videoEncoding.getFrameRate();
                    if (frameRate > 0) {
                        nativeEncoding.maxFramerate = frameRate;
                    }
                    var scale = videoEncoding.getScale();
                    if (scale > 0) {
                        nativeEncoding.scaleResolutionDownBy = 1 / scale;
                    }
                }
                return oldActive != newActive;
            };
            /** @hidden */
            WebRtcMediaStream.prototype.updateEncodingInfo = function (encodingInfo, encoding, send) {
                encodingInfo.setDeactivated(encoding.getDeactivated());
                encodingInfo.setBitrate(encoding.getBitrate());
                encodingInfo.setRtpStreamId(encoding.getRtpStreamId());
                encodingInfo.setSynchronizationSource(encoding.getSynchronizationSource());
                if (this.getType() == fm.liveswitch.StreamType.Video) {
                    var videoEncoding = encoding;
                    encodingInfo.setFrameRate(videoEncoding.getFrameRate());
                    encodingInfo.setScale(videoEncoding.getScale());
                    var sourceEncoding = this.getSourceEncoding();
                    if (sourceEncoding) {
                        var sourceSize = sourceEncoding.getSize();
                        if (sourceSize) {
                            var sourceWidth = sourceSize.getWidth();
                            var sourceHeight = sourceSize.getHeight();
                            if (sourceWidth > 0 && sourceHeight > 0) {
                                encodingInfo.setSize(new fm.liveswitch.Size(sourceSize.getWidth(), sourceSize.getHeight()));
                            }
                        }
                        var sourceFrameRate = sourceEncoding.getFrameRate();
                        if (sourceFrameRate > 0) {
                            encodingInfo.setFrameRate(sourceFrameRate);
                        }
                    }
                }
            };
            /** @hidden */
            WebRtcMediaStream.prototype.getNativeTrack = function (send) {
                var track = send ? this._localTrack : this._remoteTrack;
                if (track) {
                    var nativeTrack = track._getMediaStreamTrack();
                    if (nativeTrack) {
                        return nativeTrack;
                    }
                }
                if (send) {
                    var sender = this._sender;
                    if (sender) {
                        var nativeTrack = sender.track;
                        if (nativeTrack) {
                            return nativeTrack;
                        }
                    }
                }
                else {
                    var receiver = this._receiver;
                    if (receiver) {
                        var nativeTrack = receiver.track;
                        if (nativeTrack) {
                            return nativeTrack;
                        }
                    }
                }
                return null;
            };
            /** @hidden */
            WebRtcMediaStream.prototype.getSourceEncoding = function () {
                var encodingInfo = new fm.liveswitch.EncodingInfo();
                if (this.getType() == fm.liveswitch.StreamType.Video) {
                    var nativeTrack = this.getNativeTrack(true);
                    if (nativeTrack && nativeTrack.getSettings) {
                        var settings = nativeTrack.getSettings();
                        if (settings) {
                            if (settings.width > 0 && settings.height > 0) {
                                encodingInfo.setSize(new fm.liveswitch.Size(settings.width, settings.height));
                            }
                            if (settings.frameRate > 0) {
                                encodingInfo.setFrameRate(settings.frameRate);
                            }
                        }
                    }
                }
                return encodingInfo;
            };
            /** @hidden */
            WebRtcMediaStream.prototype.replaceLocalTrack = function (localTrack) {
                var connection = this.getConnection();
                if (!connection) {
                    return fm.liveswitch.Promise.rejectNow(new fm.liveswitch.Exception('Not connected.'));
                }
                return connection.replaceLocalTrack(localTrack, this);
            };
            /** @hidden */
            WebRtcMediaStream.prototype.replaceRemoteTrack = function (remoteTrack) {
                var connection = this.getConnection();
                if (!connection) {
                    return fm.liveswitch.Promise.rejectNow(new fm.liveswitch.Exception('Not connected.'));
                }
                return connection.replaceRemoteTrack(remoteTrack, this);
            };
            WebRtcMediaStream.prototype.processCachedChanges = function () {
                if (this.getRenegotiationPending()) {
                    var direction = this.getPendingLocalDirection();
                    this.setLocalDirection(direction);
                }
            };
            WebRtcMediaStream.prototype.resetRemoteDirection = function () {
                this.setRemoteDirection(fm.liveswitch.StreamDirection.SendReceive);
            };
            WebRtcMediaStream.prototype.processSdpMediaDescription = function (sdpMessage, sdpMediaDescription, index, isLocalDescription, isOffer, isRenegotiation) {
                var manager = this.getMediaDescriptionManager();
                var requirements = new fm.liveswitch.MediaDescriptionRequirements();
                var error = manager.processSdpMediaDescription(requirements, sdpMessage, index, isLocalDescription, isRenegotiation, isOffer);
                if (error != null) {
                    return error;
                }
                if (!isLocalDescription) {
                    for (var _i = 0, _a = sdpMediaDescription.getMediaAttributes(); _i < _a.length; _i++) {
                        var sdpMediaAttribute = _a[_i];
                        if (fm.liveswitch.Util.isObjectType(sdpMediaAttribute, '[fm.liveswitch.sdp.SendReceiveAttribute]')) {
                            this.setRemoteDirection(fm.liveswitch.StreamDirection.SendReceive);
                        }
                        else if (fm.liveswitch.Util.isObjectType(sdpMediaAttribute, '[fm.liveswitch.sdp.SendOnlyAttribute]')) {
                            this.setRemoteDirection(fm.liveswitch.StreamDirection.SendOnly);
                        }
                        else if (fm.liveswitch.Util.isObjectType(sdpMediaAttribute, '[fm.liveswitch.sdp.ReceiveOnlyAttribute]')) {
                            this.setRemoteDirection(fm.liveswitch.StreamDirection.ReceiveOnly);
                        }
                        else if (fm.liveswitch.Util.isObjectType(sdpMediaAttribute, '[fm.liveswitch.sdp.InactiveAttribute]')) {
                            this.setRemoteDirection(fm.liveswitch.StreamDirection.Inactive);
                        }
                    }
                }
                //Update Local CNAME assigned by this browser or Remote CNAME assigned by remote peer.
                this.extractCanonicalName(sdpMediaDescription, isLocalDescription);
                return null;
            };
            WebRtcMediaStream.prototype.getDirectionCapabilities = function () {
                return fm.liveswitch.StreamDirection.SendReceive;
            };
            WebRtcMediaStream.prototype.setControlTransportInfo = function (info) {
                this._controlTransportInfo = info;
            };
            WebRtcMediaStream.prototype.getControlTransportInfo = function () {
                return this._controlTransportInfo;
            };
            WebRtcMediaStream.prototype.getSimulcastMode = function () {
                return this._simulcastMode;
            };
            WebRtcMediaStream.prototype.setSimulcastMode = function (value) {
                this._simulcastMode = value;
            };
            WebRtcMediaStream.prototype.addOnDiscardBitrateRequest = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onDiscardBitrateRequestValues, value);
            };
            WebRtcMediaStream.prototype.removeOnDiscardBitrateRequest = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onDiscardBitrateRequestValues, value);
            };
            /** @hidden */
            WebRtcMediaStream.prototype.raiseOnDiscardBitrateRequest = function (bitrateNotification) {
                for (var _i = 0, _a = this._onDiscardBitrateRequestValues; _i < _a.length; _i++) {
                    var onDiscardBitrateRequestValue = _a[_i];
                    onDiscardBitrateRequestValue(bitrateNotification);
                }
            };
            /** @hidden */
            WebRtcMediaStream.prototype.processBitrateRequest = function (bitrateRequest) {
                bitrateRequest.setMediaDescriptionId(this.getMediaDescriptionId() || new fm.liveswitch.StreamTypeWrapper(this.getType()).toString().toLowerCase());
                this.raiseOnDiscardBitrateRequest(bitrateRequest);
            };
            WebRtcMediaStream.prototype.raiseBitrateRequest = function (bitrateRequest) {
                var _this = this;
                if (this.getSimulcastMode() == fm.liveswitch.SimulcastMode.Disabled ||
                    this._sendEncodings == null ||
                    this._sendEncodings.length == 0 ||
                    (this._sendEncodings.length == 1 &&
                        this._sendEncodings[0].getSynchronizationSource() == -1 &&
                        this._sendEncodings[0].getRtpStreamId() == null &&
                        this._sendEncodings[0].getBitrate() == -1)) {
                    var connection = this.getConnection();
                    if (!connection) {
                        return false;
                    }
                    connection.setMaxSendBitrate(bitrateRequest.getBitrate(), this.getType()).then(function () {
                        _this._singleSendBitrate = bitrateRequest.getBitrate();
                        var bitrateNotification = new fm.liveswitch.BitrateNotification();
                        bitrateNotification.setBitrate(bitrateRequest.getBitrate());
                        bitrateNotification.setRtpStreamId(bitrateRequest.getRtpStreamId());
                        bitrateNotification.setSynchronizationSource(bitrateRequest.getSynchronizationSource());
                        _this.processBitrateNotification(bitrateNotification);
                    }, function (ex) {
                        fm.liveswitch.Log.error('Could not process bitrate request for ' + new fm.liveswitch.StreamTypeWrapper(_this.getType()).toString() + ' stream.', ex);
                    });
                    return true;
                }
                var sendEncodingIndex = this.findSendEncodingIndex(bitrateRequest);
                if (sendEncodingIndex == -1) {
                    return false;
                }
                var rid = bitrateRequest.getRtpStreamId();
                var ssrc = bitrateRequest.getSynchronizationSource();
                var requestBitrate = bitrateRequest.getBitrate();
                var remoteRequestedDeactivate = requestBitrate == 0;
                if (remoteRequestedDeactivate) {
                    // this should always succeed
                    var disabled = this.remoteRequestedMaxSendBitrate(sendEncodingIndex, requestBitrate);
                    if (disabled) {
                        // deactivated (signalled by state change)
                    }
                    else {
                        // NOT deactivated (shouldn't happen, but for completeness)
                        var bitrateNotification = new fm.liveswitch.BitrateNotification();
                        bitrateNotification.setBitrate(this._sendEncodings[sendEncodingIndex].getBitrate());
                        bitrateNotification.setRtpStreamId(bitrateRequest.getRtpStreamId());
                        bitrateNotification.setSynchronizationSource(bitrateRequest.getSynchronizationSource());
                        this.processBitrateNotification(bitrateNotification);
                    }
                }
                else {
                    var oldBitrate = this._sendEncodings[sendEncodingIndex].getBitrate();
                    // this could fail if the client has deactivated the encoding
                    var disabled = this.remoteRequestedMaxSendBitrate(sendEncodingIndex, requestBitrate);
                    if (disabled) {
                        // NOT activated (refused for unspecified local considerations)
                        var bitrateNotification = new fm.liveswitch.BitrateNotification();
                        bitrateNotification.setBitrate(0);
                        bitrateNotification.setRtpStreamId(bitrateRequest.getRtpStreamId());
                        bitrateNotification.setSynchronizationSource(bitrateRequest.getSynchronizationSource());
                        this.processBitrateNotification(bitrateNotification);
                    }
                    else {
                        var bitrate = this._sendEncodings[sendEncodingIndex].getBitrate();
                        if (oldBitrate != bitrate) {
                            // activated (signalled by media flow)
                            var bitrateNotification = new fm.liveswitch.BitrateNotification();
                            bitrateNotification.setBitrate(bitrate);
                            bitrateNotification.setRtpStreamId(bitrateRequest.getRtpStreamId());
                            bitrateNotification.setSynchronizationSource(bitrateRequest.getSynchronizationSource());
                            this.processBitrateNotification(bitrateNotification);
                            if (ssrc == -1 && rid == null) {
                                fm.liveswitch.Log.debug(new fm.liveswitch.StreamTypeWrapper(this.getType()).toString() + ' stream encoding has maximum bitrate ' + bitrate + 'kbps.');
                            }
                            else if (ssrc == -1) {
                                fm.liveswitch.Log.debug(new fm.liveswitch.StreamTypeWrapper(this.getType()).toString() + ' stream encoding with RTP stream ID ' + rid + ' has maximum bitrate ' + bitrate + 'kbps.');
                            }
                            else if (rid == null) {
                                fm.liveswitch.Log.debug(new fm.liveswitch.StreamTypeWrapper(this.getType()).toString() + ' stream encoding with SSRC ' + ssrc + ' has maximum bitrate ' + bitrate + 'kbps.');
                            }
                            else {
                                fm.liveswitch.Log.debug(new fm.liveswitch.StreamTypeWrapper(this.getType()).toString() + ' stream encoding with SSRC ' + ssrc + ' and RTP stream ID ' + rid + ' has maximum bitrate ' + bitrate + 'kbps.');
                            }
                        }
                    }
                }
                return true;
            };
            WebRtcMediaStream.prototype.remoteRequestedMaxSendBitrate = function (sendEncodingIndex, maxBitrate) {
                var sendEncodings = this._sendEncodings;
                if (!sendEncodings || sendEncodings.length == 0) {
                    return null;
                }
                var sender = this._sender;
                if (!sender || !sender.getParameters) {
                    return false;
                }
                var params = sender.getParameters();
                if (!params || !params.encodings) {
                    return false;
                }
                this._deactivatedByServer[sendEncodingIndex] = (maxBitrate == 0);
                if (maxBitrate != 0) {
                    sendEncodings[sendEncodingIndex].setBitrate(maxBitrate);
                }
                params = this.applySendEncodings(sendEncodingIndex);
                return !params.encodings[sendEncodingIndex].active;
            };
            WebRtcMediaStream.prototype.findSendEncodingIndex = function (bitrateRequest) {
                var sender = this._sender;
                if (sender && sender.getParameters) {
                    var params = sender.getParameters();
                    if (params && params.encodings) {
                        for (var i = 0; i < params.encodings.length; i++) {
                            var rid = 'rid' in params.encodings[i] ? params.encodings[i].rid : null;
                            if (rid != null && rid == bitrateRequest.getRtpStreamId()) {
                                return i;
                            }
                            var ssrc = 'ssrc' in params.encodings[i] ? params.encodings[i].ssrc : -1;
                            if (ssrc != -1 && ssrc == bitrateRequest.getSynchronizationSource()) {
                                return i;
                            }
                        }
                    }
                }
                return -1;
            };
            WebRtcMediaStream.prototype.addOnDiscardBitrateNotification = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onDiscardBitrateNotificationValues, value);
            };
            WebRtcMediaStream.prototype.removeOnDiscardBitrateNotification = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onDiscardBitrateNotificationValues, value);
            };
            /** @hidden */
            WebRtcMediaStream.prototype._raiseOnDiscardBitrateNotification = function (bitrateNotification) {
                for (var _i = 0, _a = this._onDiscardBitrateNotificationValues; _i < _a.length; _i++) {
                    var onDiscardBitrateNotificationValue = _a[_i];
                    onDiscardBitrateNotificationValue(bitrateNotification);
                }
            };
            /** @hidden */
            WebRtcMediaStream.prototype.processBitrateNotification = function (bitrateNotification) {
                bitrateNotification.setMediaDescriptionId(this.getMediaDescriptionId() || new fm.liveswitch.StreamTypeWrapper(this.getType()).toString().toLowerCase());
                this._raiseOnDiscardBitrateNotification(bitrateNotification);
            };
            WebRtcMediaStream.prototype.raiseBitrateNotification = function (bitrateNotification) {
                return true;
            };
            WebRtcMediaStream.prototype.setMaxSendBitrate = function (value) {
                var _this = this;
                _super.prototype.setMaxSendBitrate.call(this, value);
                var connection = this.getConnection();
                if (!connection) {
                    return fm.liveswitch.Promise.rejectNow(new fm.liveswitch.Exception('Media stream is not attached to a connection.'));
                }
                var promise = new fm.liveswitch.Promise();
                connection.setMaxSendBitrate(_super.prototype.getMaxSendBitrate.call(this), this.getType()).then(function (o) {
                    _this.applySendEncodings();
                    promise.resolve(o);
                }, function (ex) {
                    promise.reject(ex);
                });
                return promise;
            };
            WebRtcMediaStream.prototype.setMaxReceiveBitrate = function (value) {
                _super.prototype.setMaxReceiveBitrate.call(this, value);
                var bitrateRequest = new fm.liveswitch.BitrateRequest();
                bitrateRequest.setBitrate(_super.prototype.getMaxReceiveBitrate.call(this));
                this.processBitrateRequest(bitrateRequest);
            };
            return WebRtcMediaStream;
        }(fm.liveswitch.WebRtcMediaStreamBase));
        liveswitch.WebRtcMediaStream = WebRtcMediaStream;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="WebRtcMediaStream.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var WebRtcAudioStream = /** @class */ (function (_super) {
            __extends(WebRtcAudioStream, _super);
            function WebRtcAudioStream(external, localTrack, remoteTrack) {
                var _this = _super.call(this, external, localTrack, remoteTrack, fm.liveswitch.StreamType.Audio) || this;
                /** @hidden */
                _this._dtmfSender = null;
                /** @hidden */
                _this._onSendDtmfToneValues = [];
                /** @hidden */
                _this._onSendDtmfToneChangeValues = [];
                /** @hidden */
                _this._onDiscardOutboundDtmfTonesValues = [];
                _this._external = external;
                return _this;
            }
            WebRtcAudioStream.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcAudioStream]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @hidden */
            WebRtcAudioStream.prototype._getExternal = function () {
                return this._external;
            };
            /** @internal */
            WebRtcAudioStream.prototype.getDiscardDtmfTones = function () {
                return this._discardDtmfTones;
            };
            /** @internal */
            WebRtcAudioStream.prototype.setDiscardDtmfTones = function (value) {
                this._discardDtmfTones = value;
            };
            /** @internal */
            WebRtcAudioStream.prototype.addOnDiscardOutboundDtmfTones = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onDiscardOutboundDtmfTonesValues, value);
            };
            /** @internal */
            WebRtcAudioStream.prototype.removeOnDiscardOutboundDtmfTones = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onDiscardOutboundDtmfTonesValues, value);
            };
            /** @hidden */
            WebRtcAudioStream.prototype.raiseOnDiscardOutboundDtmfTones = function (dtmfTones) {
                for (var _i = 0, _a = this._onDiscardOutboundDtmfTonesValues; _i < _a.length; _i++) {
                    var onDiscardOutboundDtmfTonesValue = _a[_i];
                    onDiscardOutboundDtmfTonesValue(dtmfTones);
                }
            };
            WebRtcAudioStream.prototype.addOnReceiveDtmfTone = function (value) {
                throw new fm.liveswitch.Exception('DTMF receive-tone events are not supported by WebRTC.');
            };
            WebRtcAudioStream.prototype.addOnReceiveDtmfToneChange = function (value) {
                throw new fm.liveswitch.Exception('DTMF receive-tone-change events are not supported by WebRTC.');
            };
            WebRtcAudioStream.prototype.addOnSendDtmfTone = function (value) {
                throw new fm.liveswitch.Exception('DTMF send-tone events are not supported by WebRTC.');
            };
            WebRtcAudioStream.prototype.addOnSendDtmfToneChange = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onSendDtmfToneChangeValues, value);
            };
            WebRtcAudioStream.prototype.insertDtmfTone = function (dtmfTone) {
                return this.insertDtmfTones([dtmfTone]);
            };
            WebRtcAudioStream.prototype.insertDtmfTones = function (dtmfTones) {
                var _this = this;
                if (this._discardDtmfTones) {
                    this.raiseOnDiscardOutboundDtmfTones(dtmfTones);
                    return true;
                }
                if (this._dtmfSender == null) {
                    var connection = this.getConnection();
                    if (!connection) {
                        this.raiseOnDiscardOutboundDtmfTones(dtmfTones);
                        return false;
                    }
                    this._dtmfSender = connection.getDtmfSender();
                    if (this._dtmfSender == null) {
                        this.raiseOnDiscardOutboundDtmfTones(dtmfTones);
                        return false;
                    }
                    this._dtmfSender.ontonechange = function (ev) {
                        var tones = fm.liveswitch.dtmf.Tone.fromToneString(ev.tone);
                        for (var _i = 0, _a = _this._onSendDtmfToneChangeValues; _i < _a.length; _i++) {
                            var value = _a[_i];
                            for (var _b = 0, tones_2 = tones; _b < tones_2.length; _b++) {
                                var tone = tones_2[_b];
                                value(tone);
                            }
                        }
                    };
                }
                this._dtmfSender.insertDTMF(fm.liveswitch.dtmf.Tone.toToneString(dtmfTones));
                return true;
            };
            WebRtcAudioStream.prototype.removeOnReceiveDtmfTone = function (value) {
                throw new fm.liveswitch.Exception('DTMF receive-tone events are not supported by WebRTC.');
            };
            WebRtcAudioStream.prototype.removeOnReceiveDtmfToneChange = function (value) {
                throw new fm.liveswitch.Exception('DTMF receive-tone-change events are not supported by WebRTC.');
            };
            WebRtcAudioStream.prototype.removeOnSendDtmfTone = function (value) {
                throw new fm.liveswitch.Exception('DTMF send-tone events are not supported by WebRTC.');
            };
            WebRtcAudioStream.prototype.removeOnSendDtmfToneChange = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onSendDtmfToneChangeValues, value);
            };
            WebRtcAudioStream.prototype.getOpusDisabled = function () {
                return this.getCodecDisabled(fm.liveswitch.AudioFormat.getOpusName());
            };
            WebRtcAudioStream.prototype.getG722Disabled = function () {
                return this.getCodecDisabled(fm.liveswitch.AudioFormat.getG722Name());
            };
            WebRtcAudioStream.prototype.getPcmuDisabled = function () {
                return this.getCodecDisabled(fm.liveswitch.AudioFormat.getPcmuName());
            };
            WebRtcAudioStream.prototype.getPcmaDisabled = function () {
                return this.getCodecDisabled(fm.liveswitch.AudioFormat.getPcmaName());
            };
            WebRtcAudioStream.prototype.setOpusDisabled = function (value) {
                return this.setCodecDisabled(fm.liveswitch.AudioFormat.getOpusName(), value);
            };
            WebRtcAudioStream.prototype.setG722Disabled = function (value) {
                return this.setCodecDisabled(fm.liveswitch.AudioFormat.getG722Name(), value);
            };
            WebRtcAudioStream.prototype.setPcmuDisabled = function (value) {
                return this.setCodecDisabled(fm.liveswitch.AudioFormat.getPcmuName(), value);
            };
            WebRtcAudioStream.prototype.setPcmaDisabled = function (value) {
                return this.setCodecDisabled(fm.liveswitch.AudioFormat.getPcmaName(), value);
            };
            return WebRtcAudioStream;
        }(fm.liveswitch.WebRtcMediaStream));
        liveswitch.WebRtcAudioStream = WebRtcAudioStream;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media track base properties/methods.
        */
        var WebRtcMediaTrackBase = /** @class */ (function (_super) {
            __extends(WebRtcMediaTrackBase, _super);
            function WebRtcMediaTrackBase() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            WebRtcMediaTrackBase.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcMediaTrackBase]' + ',' + _super.prototype.getTypeString.call(this);
            };
            return WebRtcMediaTrackBase;
        }(fm.liveswitch.Dynamic));
        liveswitch.WebRtcMediaTrackBase = WebRtcMediaTrackBase;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="WebRtcMediaTrackBase.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var WebRtcMediaTrack = /** @class */ (function (_super) {
            __extends(WebRtcMediaTrack, _super);
            function WebRtcMediaTrack(external, media) {
                var _this = _super.call(this) || this;
                /** @internal */
                _this._onStartedValues = [];
                /** @internal */
                _this._onStoppedValues = [];
                /** @internal */
                _this._onDestroyedValues = [];
                /** @internal */
                _this._outputs = [];
                /** @internal */
                _this._inputs = [];
                /** @internal */
                _this._mediaStreamTrackDisabled = false;
                _this._muted = false;
                _this._media = media;
                return _this;
            }
            WebRtcMediaTrack.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcMediaTrack]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            WebRtcMediaTrack.prototype.getOutputs = function () {
                return this._outputs;
            };
            /** @internal */
            WebRtcMediaTrack.prototype.addOutput = function (output) {
                fm.liveswitch.ArrayExtensions.add(this._outputs, output);
            };
            /** @internal */
            WebRtcMediaTrack.prototype.removeOutput = function (output) {
                return fm.liveswitch.ArrayExtensions.remove(this._outputs, output);
            };
            /** @internal */
            WebRtcMediaTrack.prototype.getInputs = function () {
                return this._inputs;
            };
            /** @internal */
            WebRtcMediaTrack.prototype.addInput = function (input) {
                fm.liveswitch.ArrayExtensions.add(this._inputs, input);
            };
            /** @internal */
            WebRtcMediaTrack.prototype.removeInput = function (input) {
                return fm.liveswitch.ArrayExtensions.remove(this._inputs, input);
            };
            /** @internal */
            WebRtcMediaTrack.prototype._getMediaStreamTrack = function () {
                return this._mediaStreamTrack;
            };
            /** @internal */
            WebRtcMediaTrack.prototype._setMediaStreamTrack = function (mediaStreamTrack) {
                var _this = this;
                if (mediaStreamTrack) {
                    if (mediaStreamTrack != this._mediaStreamTrack) {
                        mediaStreamTrack.onended = function (e) {
                            _this.raiseOnStopped();
                        };
                        for (var _i = 0, _a = this._onStartedValues; _i < _a.length; _i++) {
                            var value = _a[_i];
                            value();
                        }
                    }
                }
                else {
                    this._mediaStreamTrackDisabled = true;
                    if (this._mediaStreamTrack) {
                        this._mediaStreamTrack.onended = null;
                    }
                }
                this._mediaStreamTrack = mediaStreamTrack;
                this.setMuted(this._muted);
                var _loop_1 = function (output) {
                    output.replaceLocalTrack(this_1).fail(function (ex) {
                        fm.liveswitch.Log.error('Could not replace local track attached to ' + output.getType() + ' stream for connection ' + output.getConnectionId() + '.', ex);
                    });
                };
                var this_1 = this;
                for (var _b = 0, _c = this.getOutputs(); _b < _c.length; _b++) {
                    var output = _c[_b];
                    _loop_1(output);
                }
                /* TO DO */
                /*for (let input of this.getInputs()) {
                    input.replaceRemoteTrack(this);
                }*/
            };
            /** @internal */
            WebRtcMediaTrack.prototype._getMediaStreamTrackDisabled = function () {
                return this._mediaStreamTrackDisabled;
            };
            WebRtcMediaTrack.prototype.addOnStarted = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onStartedValues, value);
            };
            WebRtcMediaTrack.prototype.addOnStopped = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onStoppedValues, value);
            };
            WebRtcMediaTrack.prototype.addOnDestroyed = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onDestroyedValues, value);
            };
            WebRtcMediaTrack.prototype.removeOnStarted = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onStartedValues, value);
            };
            WebRtcMediaTrack.prototype.removeOnStopped = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onStoppedValues, value);
            };
            WebRtcMediaTrack.prototype.removeOnDestroyed = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onDestroyedValues, value);
            };
            WebRtcMediaTrack.prototype.getMedia = function () {
                return this._media;
            };
            WebRtcMediaTrack.prototype.getMuted = function () {
                var mediaStreamTrack = this._getMediaStreamTrack();
                if (mediaStreamTrack) {
                    return !mediaStreamTrack.enabled;
                }
                return false;
            };
            WebRtcMediaTrack.prototype.setMuted = function (muted) {
                this._muted = muted;
                var mediaStreamTrack = this._getMediaStreamTrack();
                if (mediaStreamTrack) {
                    mediaStreamTrack.enabled = !muted;
                }
            };
            WebRtcMediaTrack.prototype.stop = function () {
                var mediaStreamTrack = this._getMediaStreamTrack();
                if (mediaStreamTrack) {
                    mediaStreamTrack.stop();
                    // https://stackoverflow.com/a/55960232/1135577
                    // `ended` isn't fired when we call `stop` on local tracks as per spec.
                    // So we need to fire it manually.
                    if (this.getMedia() instanceof fm.liveswitch.WebRtcLocalMedia) {
                        this.raiseOnStopped();
                    }
                }
            };
            WebRtcMediaTrack.prototype.destroy = function () {
                if (this._mediaStreamTrack) {
                    for (var _i = 0, _a = this._onDestroyedValues; _i < _a.length; _i++) {
                        var value = _a[_i];
                        value();
                    }
                    return true;
                }
                return false;
            };
            WebRtcMediaTrack.prototype.raiseOnStopped = function () {
                for (var _i = 0, _a = this._onStoppedValues; _i < _a.length; _i++) {
                    var value = _a[_i];
                    value();
                }
            };
            return WebRtcMediaTrack;
        }(fm.liveswitch.WebRtcMediaTrackBase));
        liveswitch.WebRtcMediaTrack = WebRtcMediaTrack;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="WebRtcMediaTrack.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var WebRtcAudioTrack = /** @class */ (function (_super) {
            __extends(WebRtcAudioTrack, _super);
            function WebRtcAudioTrack(external, media) {
                var _this = _super.call(this, external, media) || this;
                _this._external = external;
                return _this;
            }
            WebRtcAudioTrack.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcAudioTrack]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            WebRtcAudioTrack.prototype._getExternal = function () {
                return this._external;
            };
            WebRtcAudioTrack.prototype.isLocal = function () {
                return (fm.liveswitch.Util.isObjectType(this.getMedia(), '[fm.liveswitch.WebRtcLocalMedia]'));
            };
            WebRtcAudioTrack.prototype.changeSinkOutput = function (sinkOutput) {
                if (this.isLocal()) {
                    var promise = new fm.liveswitch.Promise();
                    promise.reject(new fm.liveswitch.Exception('Cannot call AudioTrack.changeSinkOutput on a local track.'));
                    return promise;
                }
                return this.getMedia().changeAudioSinkOutput(sinkOutput);
            };
            WebRtcAudioTrack.prototype.getSinkOutput = function () {
                if (this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call AudioTrack.getSinkOutput on a local track.');
                }
                return this.getMedia().getAudioSinkOutput();
            };
            WebRtcAudioTrack.prototype.getSinkOutputs = function () {
                if (this.isLocal()) {
                    var promise = new fm.liveswitch.Promise();
                    promise.reject(new fm.liveswitch.Exception('Cannot call AudioTrack.getSinkOutputs on a local track.'));
                    return promise;
                }
                return this.getMedia().getAudioSinkOutputs();
            };
            WebRtcAudioTrack.prototype.setSinkOutput = function (value) {
                if (this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call AudioTrack.setSinkOutput on a local track.');
                }
                this.getMedia().setAudioSinkOutput(value);
            };
            WebRtcAudioTrack.prototype.changeSourceInput = function (sourceInput) {
                if (!this.isLocal()) {
                    var promise = new fm.liveswitch.Promise();
                    promise.reject(new fm.liveswitch.Exception('Cannot call AudioTrack.changeSourceInput on a remote track.'));
                    return promise;
                }
                return this.getMedia().changeAudioSourceInput(sourceInput);
            };
            WebRtcAudioTrack.prototype.getSourceInput = function () {
                if (!this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call AudioTrack.getSourceInput on a remote track.');
                }
                return this.getMedia().getAudioSourceInput();
            };
            WebRtcAudioTrack.prototype.getSourceInputs = function () {
                if (!this.isLocal()) {
                    var promise = new fm.liveswitch.Promise();
                    promise.reject(new fm.liveswitch.Exception('Cannot call AudioTrack.getSourceInputs on a remote track.'));
                    return promise;
                }
                return this.getMedia().getAudioSourceInputs();
            };
            WebRtcAudioTrack.prototype.setSourceInput = function (value) {
                if (!this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call AudioTrack.setSourceInput on a remote track.');
                }
                this.getMedia().setAudioSourceInput(value);
            };
            WebRtcAudioTrack.prototype.addOnLevel = function (value) {
                return this.getMedia().addOnAudioLevel(value);
            };
            WebRtcAudioTrack.prototype.getGain = function () {
                return this.getMedia().getAudioGain();
            };
            WebRtcAudioTrack.prototype.getVolume = function () {
                return this.getMedia().getAudioVolume();
            };
            WebRtcAudioTrack.prototype.removeOnLevel = function (value) {
                return this.getMedia().removeOnAudioLevel(value);
            };
            WebRtcAudioTrack.prototype.setGain = function (value) {
                this.getMedia().setAudioGain(value);
            };
            WebRtcAudioTrack.prototype.setVolume = function (value) {
                this.getMedia().setAudioVolume(value);
            };
            return WebRtcAudioTrack;
        }(fm.liveswitch.WebRtcMediaTrack));
        liveswitch.WebRtcAudioTrack = WebRtcAudioTrack;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Connection base properties/methods.
        */
        var WebRtcConnectionBase = /** @class */ (function (_super) {
            __extends(WebRtcConnectionBase, _super);
            /**
            Initializes a new instance of the [[fm.liveswitch.connectionBase]] class.
            */
            function WebRtcConnectionBase(sharedLock) {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var sharedLock_1 = __arguments[0];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchWebRtcConnectionBaseInit();
                    _this.__id = fm.liveswitch.Utility.generateId();
                    _this.__bundlePolicy = fm.liveswitch.BundlePolicy.MaxCompatibility;
                    _this.__connected = new fm.liveswitch.Promise();
                    _this.__closed = new fm.liveswitch.Promise();
                    _this.__failed = new fm.liveswitch.Promise();
                    _this.__iceServers = new fm.liveswitch.IceServerCollection();
                    _this.__useTrickleIce = true;
                    _this.__trickleIcePolicy = fm.liveswitch.TrickleIcePolicy.FullTrickle;
                    _this._earlyRemoteCandidatePromises = new Array();
                    _this.__signallingState = fm.liveswitch.SignallingState.New;
                    _this._connectionLock = sharedLock_1;
                    _this.setLegacyTimeout(true);
                    _this.setTieBreaker(fm.liveswitch.Utility.generateId());
                    _this.setTimeout(30000);
                    _this.setDeadStreamTimeout(15000);
                    _this.setIceGatherPolicy(fm.liveswitch.IceGatherPolicy.All);
                    _this.setTrickleIcePolicy(fm.liveswitch.TrickleIcePolicy.FullTrickle);
                    _this.__stateMachine = new fm.liveswitch.ConnectionStateMachine();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            WebRtcConnectionBase.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcConnectionBase]' + ',' + _super.prototype.getTypeString.call(this);
            };
            WebRtcConnectionBase.prototype.fmliveswitchWebRtcConnectionBaseInit = function () {
                var _this = this;
                this.__onExternalIdChange = [];
                this.__onGatheringStateChange = [];
                this.__onIceConnectionStateChange = [];
                this.__onLocalCandidate = [];
                this.__onLocalDescription = [];
                this.__onRemoteCandidate = [];
                this.__onRemoteDescription = [];
                this.__onSignallingStateChange = [];
                this.__onStateChange = [];
                this.__useTrickleIce = false;
                this._deadStreamTimeout = 0;
                this._legacyTimeout = false;
                this._onExternalIdChange = function (p0, p1) { for (var _i = 0, _a = _this.__onExternalIdChange; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0, p1);
                } };
                this._onGatheringStateChange = function (p0) { for (var _i = 0, _a = _this.__onGatheringStateChange; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
                this._onIceConnectionStateChange = function (p0) { for (var _i = 0, _a = _this.__onIceConnectionStateChange; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
                this._onLocalCandidate = function (p0, p1) { for (var _i = 0, _a = _this.__onLocalCandidate; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0, p1);
                } };
                this._onLocalDescription = function (p0, p1) { for (var _i = 0, _a = _this.__onLocalDescription; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0, p1);
                } };
                this._onRemoteCandidate = function (p0, p1) { for (var _i = 0, _a = _this.__onRemoteCandidate; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0, p1);
                } };
                this._onRemoteDescription = function (p0, p1) { for (var _i = 0, _a = _this.__onRemoteDescription; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0, p1);
                } };
                this._onSignallingStateChange = function (p0) { for (var _i = 0, _a = _this.__onSignallingStateChange; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
                this._onStateChange = function (p0) { for (var _i = 0, _a = _this.__onStateChange; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
                this._timeout = 0;
            };
            /**
            Adds an ICE server.
            @param iceServer The ICE server.
            */
            WebRtcConnectionBase.prototype.addIceServer = function (iceServer) {
                if (arguments.length == 1) {
                    this.__iceServers.add(iceServer);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds some ICE servers.
            @param iceServers The ICE servers.
            */
            WebRtcConnectionBase.prototype.addIceServers = function (iceServers) {
                if (arguments.length == 1) {
                    this.__iceServers.addMany(iceServers);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when external Id of this connection changes. Old external Id as well as internal Id are raised.
            */
            WebRtcConnectionBase.prototype.addOnExternalIdChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onExternalIdChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when the gathering state changes.
            */
            WebRtcConnectionBase.prototype.addOnGatheringStateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onGatheringStateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when the ice connection state changes.
            */
            WebRtcConnectionBase.prototype.addOnIceConnectionStateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onIceConnectionStateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when a local candidate is added.
            */
            WebRtcConnectionBase.prototype.addOnLocalCandidate = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onLocalCandidate, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when a local description is set.
            */
            WebRtcConnectionBase.prototype.addOnLocalDescription = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onLocalDescription, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when a remote description is added.
            */
            WebRtcConnectionBase.prototype.addOnRemoteCandidate = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onRemoteCandidate, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when a remote description is set.
            */
            WebRtcConnectionBase.prototype.addOnRemoteDescription = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onRemoteDescription, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when the signalling state changes.
            */
            WebRtcConnectionBase.prototype.addOnSignallingStateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onSignallingStateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when the connection state changes.
            */
            WebRtcConnectionBase.prototype.addOnStateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onStateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds the remote candidate.
            @param remoteCandidate The remote candidate.
            */
            WebRtcConnectionBase.prototype.addRemoteCandidate = function (remoteCandidate) {
                if (arguments.length == 1) {
                    var item = new fm.liveswitch.RemoteCandidatePromise(remoteCandidate);
                    if (((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.ConnectionState.New)) || (fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.ConnectionState.Initializing)))) {
                        fm.liveswitch.ArrayExtensions.add(this._earlyRemoteCandidatePromises, item);
                        if (((!fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.ConnectionState.New)) && (!fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.ConnectionState.Initializing)))) {
                            fm.liveswitch.ArrayExtensions.clear(this._earlyRemoteCandidatePromises);
                            this.addRemoteCandidatePromise(item);
                        }
                        return item;
                    }
                    if (!this.getIsTerminatingOrTerminated()) {
                        this.addRemoteCandidatePromise(item);
                    }
                    return item;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.addRemoteCandidatePromise = function (remoteCandidatePromise) {
                if (arguments.length == 1) {
                    try {
                        var remoteCandidate = remoteCandidatePromise.getRemoteCandidate();
                        this.updateRemoteCandidateIndex(remoteCandidate);
                        this.raiseRemoteCandidate(remoteCandidatePromise.getRemoteCandidate());
                        this.doAddRemoteCandidate(remoteCandidatePromise, remoteCandidatePromise.getRemoteCandidate());
                    }
                    catch (exception) {
                        remoteCandidatePromise.reject(exception);
                    }
                    finally {
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates an answer.
            */
            WebRtcConnectionBase.prototype.createAnswer = function () {
                if (arguments.length == 0) {
                    var asyncPromise = new fm.liveswitch.Promise();
                    this.createAnswerWrapper(asyncPromise);
                    return asyncPromise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.createAnswerWrapper = function (asyncPromise) {
                if (arguments.length == 1) {
                    var resolveAction = null;
                    var rejectAction = null;
                    try {
                        var promise = new fm.liveswitch.Promise();
                        this.doCreateAnswer(promise);
                        if ((fm.liveswitch.Global.equals(resolveAction, null))) {
                            resolveAction = function (sd) {
                                asyncPromise.resolveAsync(sd);
                            };
                        }
                        if ((fm.liveswitch.Global.equals(rejectAction, null))) {
                            rejectAction = function (ex) {
                                asyncPromise.rejectAsync(ex);
                            };
                        }
                        promise.then(resolveAction, rejectAction);
                    }
                    catch (exception) {
                        asyncPromise.rejectAsync(exception);
                    }
                    finally {
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates an offer.
            */
            WebRtcConnectionBase.prototype.createOffer = function () {
                if (arguments.length == 0) {
                    var asyncPromise = new fm.liveswitch.Promise();
                    this.createOfferWrapper(asyncPromise);
                    return asyncPromise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.createOfferWrapper = function (asyncPromise) {
                if (arguments.length == 1) {
                    var resolveAction = null;
                    var rejectAction = null;
                    try {
                        var promise = new fm.liveswitch.Promise();
                        this.doCreateOffer(promise);
                        if ((fm.liveswitch.Global.equals(resolveAction, null))) {
                            resolveAction = function (sd) {
                                asyncPromise.resolveAsync(sd);
                            };
                        }
                        if ((fm.liveswitch.Global.equals(rejectAction, null))) {
                            rejectAction = function (ex) {
                                asyncPromise.rejectAsync(ex);
                            };
                        }
                        promise.then(resolveAction, rejectAction);
                    }
                    catch (exception) {
                        asyncPromise.rejectAsync(exception);
                    }
                    finally {
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a session description.
            @param description The session description.
            @param isLocalDescription Whether this is a local session description.
            */
            WebRtcConnectionBase.prototype.doProcessDescription = function (description, isLocalDescription) {
                if (arguments.length == 2) {
                    var error = this.getSessionDescriptionManager().processDescription(description, isLocalDescription);
                    if ((!fm.liveswitch.Global.equals(error, null))) {
                        return error;
                    }
                    if ((!isLocalDescription && (fm.liveswitch.Global.equals(this.getTrickleIcePolicy(), fm.liveswitch.TrickleIcePolicy.HalfTrickle)))) {
                        if (description.getSdpMessage().getSupportsTrickleIce()) {
                            fm.liveswitch.Log.debug(fm.liveswitch.StringExtensions.format("Peer supports Trickle-Ice. Trickle Ice will be enabled in all subsequent communications with the peer for the lifetime of connection {0}.", this.getId()));
                            this.setUseTrickleIce(true);
                        }
                        else {
                            this.setUseTrickleIce(false);
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.doSetLocalDescriptionInternal = function (localDescription) {
                if (arguments.length == 1) {
                    var promise = new fm.liveswitch.Promise();
                    this.doSetLocalDescription(promise, localDescription);
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.doSetRemoteDescriptionInternal = function (remoteDescription) {
                if (arguments.length == 1) {
                    var promise = new fm.liveswitch.Promise();
                    this.doSetRemoteDescription(promise, remoteDescription);
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the first audio stream.
            */
            WebRtcConnectionBase.prototype.getAudioStream = function () {
                if (arguments.length == 0) {
                    var audioStreams = this.getAudioStreams();
                    if (((fm.liveswitch.Global.equals(audioStreams, null)) || (fm.liveswitch.Global.equals(audioStreams.length, 0)))) {
                        return null;
                    }
                    return audioStreams[0];
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the bundle policy.
            */
            WebRtcConnectionBase.prototype.getBundlePolicy = function () {
                if (arguments.length == 0) {
                    return this.__bundlePolicy;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the canonical name. Getting the value of Connection.CanonicalName is deprecated. Get the value of MediaStream.LocalCanonicalName instead.
            */
            WebRtcConnectionBase.prototype.getCanonicalName = function () {
                if (arguments.length == 0) {
                    fm.liveswitch.Log.warn("Getting the value of Connection.CanonicalName is deprecated. Get the value of MediaStream.LocalCanonicalName instead.");
                    return this.getConnectionWideCanonicalName();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a future that resolves if the connection enters the Closed state or rejects if the connection enters the Failed state before that happens.
            */
            WebRtcConnectionBase.prototype.getClosed = function () {
                if (arguments.length == 0) {
                    return this.__closed;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a future that resolves if the connection enters the Connected state or rejects if the connection enters the Failed state before that happens.
            */
            WebRtcConnectionBase.prototype.getConnected = function () {
                if (arguments.length == 0) {
                    return this.__connected;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.getConnectionWideCanonicalName = function () {
                if (arguments.length == 0) {
                    var streams = this.getStreams();
                    for (var _i = 0, streams_3 = streams; _i < streams_3.length; _i++) {
                        var local = streams_3[_i];
                        if ((fm.liveswitch.Global.equals(local.getType(), fm.liveswitch.StreamType.Audio))) {
                            return fm.liveswitch.Global.tryCast(local, fm.liveswitch.WebRtcMediaStreamBase).getLocalCanonicalName();
                        }
                        if ((fm.liveswitch.Global.equals(local.getType(), fm.liveswitch.StreamType.Video))) {
                            return fm.liveswitch.Global.tryCast(local, fm.liveswitch.WebRtcMediaStreamBase).getLocalCanonicalName();
                        }
                    }
                    return this.getId();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the first data stream.
            */
            WebRtcConnectionBase.prototype.getDataStream = function () {
                if (arguments.length == 0) {
                    var dataStreams = this.getDataStreams();
                    if (((fm.liveswitch.Global.equals(dataStreams, null)) || (fm.liveswitch.Global.equals(dataStreams.length, 0)))) {
                        return null;
                    }
                    return dataStreams[0];
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the amount of time (in milliseconds) to wait for connectivity checks to re-establish after they start to fail on a live connection. Defaults to 15,000.
            */
            WebRtcConnectionBase.prototype.getDeadStreamTimeout = function () {
                if (arguments.length == 0) {
                    return this._deadStreamTimeout;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the error.
            */
            WebRtcConnectionBase.prototype.getError = function () {
                if (arguments.length == 0) {
                    return this._error;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the external identifier.
            */
            WebRtcConnectionBase.prototype.getExternalId = function () {
                if (arguments.length == 0) {
                    return this.__externalId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a future that resolves if the connection enters the Failed state or rejects if the connection enters the Closed state before that happens.
            */
            WebRtcConnectionBase.prototype.getFailed = function () {
                if (arguments.length == 0) {
                    return this.__failed;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether this connection has an audio stream.
            */
            WebRtcConnectionBase.prototype.getHasAudio = function () {
                if (arguments.length == 0) {
                    return (!fm.liveswitch.Global.equals(this.getAudioStream(), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether this connection has a data stream.
            */
            WebRtcConnectionBase.prototype.getHasData = function () {
                if (arguments.length == 0) {
                    return (!fm.liveswitch.Global.equals(this.getDataStream(), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether this connection has a video stream.
            */
            WebRtcConnectionBase.prototype.getHasVideo = function () {
                if (arguments.length == 0) {
                    return (!fm.liveswitch.Global.equals(this.getVideoStream(), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the ICE gather policy.
            */
            WebRtcConnectionBase.prototype.getIceGatherPolicy = function () {
                if (arguments.length == 0) {
                    return this._iceGatherPolicy;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the ICE server.
            */
            WebRtcConnectionBase.prototype.getIceServer = function () {
                if (arguments.length == 0) {
                    return this.__iceServers.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the ICE servers.
            */
            WebRtcConnectionBase.prototype.getIceServers = function () {
                if (arguments.length == 0) {
                    return this.__iceServers.getValues();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the identifier.
            */
            WebRtcConnectionBase.prototype.getId = function () {
                if (arguments.length == 0) {
                    return this.__id;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the connection is currently closed or failed.
            */
            WebRtcConnectionBase.prototype.getIsTerminated = function () {
                if (arguments.length == 0) {
                    return ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.ConnectionState.Closed)) || (fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.ConnectionState.Failed)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the connection is currently closing or failing.
            */
            WebRtcConnectionBase.prototype.getIsTerminating = function () {
                if (arguments.length == 0) {
                    return ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.ConnectionState.Closing)) || (fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.ConnectionState.Failing)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the connection is currently closing, failing, closed, or failed.
            */
            WebRtcConnectionBase.prototype.getIsTerminatingOrTerminated = function () {
                if (arguments.length == 0) {
                    return (this.getIsTerminating() || this.getIsTerminated());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether legacy Connection.Timeout should be used. When disabled, Connection.Timeout only accounts for the time spent trying to establish connectivity (i.e. time it takes to transition from the Connecting to the Connected state; from the time point when both offer and answer had been set to the connection being fully established). When enabled, Connection.Timeout accounts for the time spent from receiving an offer (or creating an offer) to establishing connectivity (i.e. time it takes to transition from Initializing to Connected state). By default, LegacyTimeout is set to true, so that existing behavior is preserved. However, in the future default will be updated to false. This means that IL will not account for any signalling delays that may occur while establishing connectivity. This option will be later deprecated.
            */
            WebRtcConnectionBase.prototype.getLegacyTimeout = function () {
                if (arguments.length == 0) {
                    return this._legacyTimeout;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the state of the signalling.
            */
            WebRtcConnectionBase.prototype.getSignallingState = function () {
                if (arguments.length == 0) {
                    return this.__signallingState;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the state of the connection.
            */
            WebRtcConnectionBase.prototype.getState = function () {
                if (arguments.length == 0) {
                    return this.__stateMachine.getState();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the first stream.
            */
            WebRtcConnectionBase.prototype.getStream = function () {
                if (arguments.length == 0) {
                    var streams = this.getStreams();
                    if (((fm.liveswitch.Global.equals(streams, null)) || (fm.liveswitch.Global.equals(streams.length, 0)))) {
                        return null;
                    }
                    return streams[0];
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the tie breaker.
            */
            WebRtcConnectionBase.prototype.getTieBreaker = function () {
                if (arguments.length == 0) {
                    return this._tieBreaker;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the amount of time (in milliseconds) to wait for a connection to establish before giving up and closing it. Defaults to 30,000.
            */
            WebRtcConnectionBase.prototype.getTimeout = function () {
                if (arguments.length == 0) {
                    return this._timeout;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets Trickle Ice Support Policy. Cf. https://tools.ietf.org/html/draft-ietf-ice-trickle-05
            */
            WebRtcConnectionBase.prototype.getTrickleIcePolicy = function () {
                if (arguments.length == 0) {
                    return this.__trickleIcePolicy;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.getUseTrickleIce = function () {
                if (arguments.length == 0) {
                    return this.__useTrickleIce;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the first video stream.
            */
            WebRtcConnectionBase.prototype.getVideoStream = function () {
                if (arguments.length == 0) {
                    var videoStreams = this.getVideoStreams();
                    if (((fm.liveswitch.Global.equals(videoStreams, null)) || (fm.liveswitch.Global.equals(videoStreams.length, 0)))) {
                        return null;
                    }
                    return videoStreams[0];
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.logInvalidStateTransition = function (state) {
                if (arguments.length == 1) {
                    if (fm.liveswitch.Log.getIsDebugEnabled()) {
                        fm.liveswitch.Log.debug(fm.liveswitch.StringExtensions.format("Connection {0} state is currently {1}. Cannot transition to {2}.", this.getId(), fm.liveswitch.StringExtensions.toLower(new fm.liveswitch.ConnectionStateWrapper(this.getState()).toString()), fm.liveswitch.StringExtensions.toLower(new fm.liveswitch.ConnectionStateWrapper(state).toString())));
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a session description.
            @param description The session description.
            @param isLocalDescription Whether this is a local session description.
            */
            WebRtcConnectionBase.prototype.processDescription = function (description, isLocalDescription) {
                if (arguments.length == 2) {
                    return this.doProcessDescription(description, isLocalDescription);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a state change.
            */
            WebRtcConnectionBase.prototype.processStateChange = function () {
                if (arguments.length == 0) {
                    var streams = this.getStreams();
                    if ((!fm.liveswitch.Global.equals(streams, null))) {
                        for (var _i = 0, streams_4 = streams; _i < streams_4.length; _i++) {
                            var local = streams_4[_i];
                            if ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.ConnectionState.Initializing))) {
                                local.setState(fm.liveswitch.StreamState.Initializing);
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.ConnectionState.Connecting))) {
                                    local.setState(fm.liveswitch.StreamState.Connecting);
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.ConnectionState.Connected))) {
                                        local.setState(fm.liveswitch.StreamState.Connected);
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.ConnectionState.Closing))) {
                                            local.setState(fm.liveswitch.StreamState.Closing);
                                        }
                                        else {
                                            if ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.ConnectionState.Closed))) {
                                                local.setState(fm.liveswitch.StreamState.Closed);
                                            }
                                            else {
                                                if ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.ConnectionState.Failing))) {
                                                    local.setState(fm.liveswitch.StreamState.Failing);
                                                }
                                                else {
                                                    if ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.ConnectionState.Failed))) {
                                                        local.setState(fm.liveswitch.StreamState.Failed);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.raiseCachedCandidates = function () {
                if (arguments.length == 0) {
                    for (var _i = 0, _a = this._earlyRemoteCandidatePromises; _i < _a.length; _i++) {
                        var promise = _a[_i];
                        this.addRemoteCandidatePromise(promise);
                    }
                    fm.liveswitch.ArrayExtensions.clear(this._earlyRemoteCandidatePromises);
                    this.doSendCachedLocalCandidates();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.raiseConnected = function () {
                if (arguments.length == 0) {
                    if ((fm.liveswitch.Global.equals(this.__connected.getState(), fm.liveswitch.FutureState.Pending))) {
                        this.__connected.resolve(null);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Raises gathering state change.
            */
            WebRtcConnectionBase.prototype.raiseGatheringStateChange = function (connection) {
                if (arguments.length == 1) {
                    var onGatheringStateChange = this._onGatheringStateChange;
                    if ((!fm.liveswitch.Global.equals(onGatheringStateChange, null))) {
                        try {
                            onGatheringStateChange(connection);
                        }
                        catch (exception) {
                            fm.liveswitch.Log.error(fm.liveswitch.StringExtensions.format("Exception occurred while raising gathering state change to the application code for connection {0}.", this.getId()), exception);
                        }
                        finally {
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Raises ICE connection state change.
            */
            WebRtcConnectionBase.prototype.raiseIceConnectionStateChange = function (connection) {
                if (arguments.length == 1) {
                    var onIceConnectionStateChange = this._onIceConnectionStateChange;
                    if ((!fm.liveswitch.Global.equals(onIceConnectionStateChange, null))) {
                        try {
                            onIceConnectionStateChange(connection);
                        }
                        catch (exception) {
                            fm.liveswitch.Log.error(fm.liveswitch.StringExtensions.format("Exception occurred while raising ICE connection state change to the application code for connection {0}.", this.getId()), exception);
                        }
                        finally {
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Raises a local candidate but only if it has not been already raised.
            @param localCandidate The local candidate.
            */
            WebRtcConnectionBase.prototype.raiseLocalCandidate = function (localCandidate) {
                if (arguments.length == 1) {
                    var onLocalCandidate = this._onLocalCandidate;
                    if (((!fm.liveswitch.Global.equals(onLocalCandidate, null)) && !localCandidate.getDispatched())) {
                        try {
                            onLocalCandidate(this.getInstance(), localCandidate);
                        }
                        catch (exception) {
                            fm.liveswitch.Log.error(fm.liveswitch.StringExtensions.format("Exception occurred while raising local candidate to the application code for connection {0}.", this.getId()), exception);
                        }
                        finally {
                        }
                    }
                    if ((fm.liveswitch.Global.equals(localCandidate.getRelayProtocol(), fm.liveswitch.ProtocolType.Tcp))) {
                        fm.liveswitch.Log.info(fm.liveswitch.StringExtensions.format("Local candidate for stream {0} (over TCP) for connection {2}:\n{1}", fm.liveswitch.NumberExtensions.toString(localCandidate.getSdpMediaIndex()), localCandidate.getSdpCandidateAttribute().toString(), this.getId()));
                    }
                    else {
                        if ((fm.liveswitch.Global.equals(localCandidate.getRelayProtocol(), fm.liveswitch.ProtocolType.Tls))) {
                            fm.liveswitch.Log.info(fm.liveswitch.StringExtensions.format("Local candidate for stream {0} (over TLS) for connection {2}:\n{1}", fm.liveswitch.NumberExtensions.toString(localCandidate.getSdpMediaIndex()), localCandidate.getSdpCandidateAttribute().toString(), this.getId()));
                        }
                        else {
                            fm.liveswitch.Log.info(fm.liveswitch.StringExtensions.format("Local candidate for stream {0} for connection {2}:\n{1}", fm.liveswitch.NumberExtensions.toString(localCandidate.getSdpMediaIndex()), localCandidate.getSdpCandidateAttribute().toString(), this.getId()));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.raiseLocalDescription = function (localDescription) {
                if (arguments.length == 1) {
                    var onLocalDescription = this._onLocalDescription;
                    if ((!fm.liveswitch.Global.equals(onLocalDescription, null))) {
                        try {
                            onLocalDescription(this.getInstance(), localDescription);
                        }
                        catch (exception) {
                            fm.liveswitch.Log.error(fm.liveswitch.StringExtensions.format("Exception occurred while raising local description to the application code for connection {0}.", this.getId()), exception);
                        }
                        finally {
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.raiseRemoteCandidate = function (remoteCandidate) {
                if (arguments.length == 1) {
                    var onRemoteCandidate = this._onRemoteCandidate;
                    if ((!fm.liveswitch.Global.equals(onRemoteCandidate, null))) {
                        try {
                            onRemoteCandidate(this.getInstance(), remoteCandidate);
                        }
                        catch (exception) {
                            fm.liveswitch.Log.error(fm.liveswitch.StringExtensions.format("Exception occurred while raising remote candidate to the application code for connection {0}.", this.getId()), exception);
                        }
                        finally {
                        }
                    }
                    fm.liveswitch.Log.info(fm.liveswitch.StringExtensions.format("Remote candidate for stream {0} for connection {2}:\n{1}", fm.liveswitch.NumberExtensions.toString(remoteCandidate.getSdpMediaIndex()), remoteCandidate.getSdpCandidateAttribute().toString(), this.getId()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.raiseRemoteDescription = function (remoteDescription) {
                if (arguments.length == 1) {
                    var onRemoteDescription = this._onRemoteDescription;
                    if ((!fm.liveswitch.Global.equals(onRemoteDescription, null))) {
                        try {
                            onRemoteDescription(this.getInstance(), remoteDescription);
                        }
                        catch (exception) {
                            fm.liveswitch.Log.error(fm.liveswitch.StringExtensions.format("Exception occurred while raising remote description to the application code for connection {0}.", this.getId()), exception);
                        }
                        finally {
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.raiseStateChange = function () {
                var _this = this;
                if (arguments.length == 0) {
                    var action2 = null;
                    var action3 = null;
                    var action4 = null;
                    var _var0 = this.getState();
                    if (_var0 == fm.liveswitch.ConnectionState.Connected) {
                        do {
                            if ((fm.liveswitch.Global.equals(action2, null))) {
                                action2 = function () {
                                    _this.raiseConnected();
                                };
                            }
                            fm.liveswitch.ManagedThread.dispatch(action2);
                            break;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.ConnectionState.Failed) {
                        do {
                            if ((fm.liveswitch.Global.equals(action4, null))) {
                                action4 = function () {
                                    _this.raiseTerminated(true);
                                };
                            }
                            fm.liveswitch.ManagedThread.dispatch(action4);
                            break;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.ConnectionState.Closed) {
                        do {
                            if ((fm.liveswitch.Global.equals(action3, null))) {
                                action3 = function () {
                                    _this.raiseTerminated(false);
                                };
                            }
                            fm.liveswitch.ManagedThread.dispatch(action3);
                            break;
                        } while (false);
                    }
                    var onStateChange = this._onStateChange;
                    if ((!fm.liveswitch.Global.equals(onStateChange, null))) {
                        try {
                            onStateChange(this.getInstance());
                        }
                        catch (exception) {
                            fm.liveswitch.Log.error(fm.liveswitch.StringExtensions.format("Exception occurred while raising state change to the application code for connection {0}.", this.getId()), exception);
                        }
                        finally {
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.raiseTerminated = function (failed) {
                if (arguments.length == 1) {
                    if (failed) {
                        if ((fm.liveswitch.Global.equals(this.__connected.getState(), fm.liveswitch.FutureState.Pending))) {
                            this.__connected.reject(this.getError().getException());
                        }
                        if ((fm.liveswitch.Global.equals(this.__closed.getState(), fm.liveswitch.FutureState.Pending))) {
                            this.__closed.reject(this.getError().getException());
                        }
                        if ((fm.liveswitch.Global.equals(this.__failed.getState(), fm.liveswitch.FutureState.Pending))) {
                            this.__failed.resolve(null);
                        }
                    }
                    else {
                        if ((fm.liveswitch.Global.equals(this.__connected.getState(), fm.liveswitch.FutureState.Pending))) {
                            this.__connected.reject(new fm.liveswitch.Exception("Connection closed."));
                        }
                        if ((fm.liveswitch.Global.equals(this.__failed.getState(), fm.liveswitch.FutureState.Pending))) {
                            this.__failed.reject(new fm.liveswitch.Exception("Connection closed."));
                        }
                        if ((fm.liveswitch.Global.equals(this.__closed.getState(), fm.liveswitch.FutureState.Pending))) {
                            this.__closed.resolve(null);
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.registerStreamWithSessionDescriptionManager = function (stream) {
                if (arguments.length == 1) {
                    this.getSessionDescriptionManager().addStream(stream);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes an ICE server.
            @param iceServer The ICE server.
            */
            WebRtcConnectionBase.prototype.removeIceServer = function (iceServer) {
                if (arguments.length == 1) {
                    this.__iceServers.remove(iceServer);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes some ICE servers.
            @param iceServers The ICE servers.
            */
            WebRtcConnectionBase.prototype.removeIceServers = function (iceServers) {
                if (arguments.length == 1) {
                    this.__iceServers.removeMany(iceServers);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when external Id of this connection changes. Old external Id as well as internal Id are raised.
            */
            WebRtcConnectionBase.prototype.removeOnExternalIdChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onExternalIdChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the gathering state changes.
            */
            WebRtcConnectionBase.prototype.removeOnGatheringStateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onGatheringStateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the ice connection state changes.
            */
            WebRtcConnectionBase.prototype.removeOnIceConnectionStateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onIceConnectionStateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when a local candidate is added.
            */
            WebRtcConnectionBase.prototype.removeOnLocalCandidate = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onLocalCandidate, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when a local description is set.
            */
            WebRtcConnectionBase.prototype.removeOnLocalDescription = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onLocalDescription, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when a remote description is added.
            */
            WebRtcConnectionBase.prototype.removeOnRemoteCandidate = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onRemoteCandidate, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when a remote description is set.
            */
            WebRtcConnectionBase.prototype.removeOnRemoteDescription = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onRemoteDescription, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the signalling state changes.
            */
            WebRtcConnectionBase.prototype.removeOnSignallingStateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onSignallingStateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the connection state changes.
            */
            WebRtcConnectionBase.prototype.removeOnStateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onStateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the bundle policy.
            */
            WebRtcConnectionBase.prototype.setBundlePolicy = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(value, fm.liveswitch.BundlePolicy.Balanced))) {
                        throw new fm.liveswitch.Exception("Balanced stream bundling is currently not supported.");
                    }
                    this.__bundlePolicy = value;
                    this.updateBundlePolicy(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the amount of time (in milliseconds) to wait for connectivity checks to re-establish after they start to fail on a live connection. Defaults to 15,000.
            */
            WebRtcConnectionBase.prototype.setDeadStreamTimeout = function (value) {
                if (arguments.length == 1) {
                    this._deadStreamTimeout = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the error.
            */
            WebRtcConnectionBase.prototype.setError = function (value) {
                if (arguments.length == 1) {
                    this._error = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the external identifier.
            */
            WebRtcConnectionBase.prototype.setExternalId = function (value) {
                if (arguments.length == 1) {
                    var str = this.__externalId;
                    if ((!fm.liveswitch.Global.equals(str, value))) {
                        this.__externalId = value;
                        var onExternalIdChange = this._onExternalIdChange;
                        if ((!fm.liveswitch.Global.equals(onExternalIdChange, null))) {
                            try {
                                onExternalIdChange(this.getId(), str);
                            }
                            catch (exception) {
                                fm.liveswitch.Log.error(fm.liveswitch.StringExtensions.format("Exception occurred while raising external ID change to the application code for connection {0}.", this.getId()), exception);
                            }
                            finally {
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the ICE gather policy.
            */
            WebRtcConnectionBase.prototype.setIceGatherPolicy = function (value) {
                if (arguments.length == 1) {
                    this._iceGatherPolicy = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the ICE server.
            */
            WebRtcConnectionBase.prototype.setIceServer = function (value) {
                if (arguments.length == 1) {
                    this.__iceServers.setValue(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the ICE servers.
            */
            WebRtcConnectionBase.prototype.setIceServers = function (value) {
                if (arguments.length == 1) {
                    this.__iceServers.replace(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a value indicating whether legacy Connection.Timeout should be used. When disabled, Connection.Timeout only accounts for the time spent trying to establish connectivity (i.e. time it takes to transition from the Connecting to the Connected state; from the time point when both offer and answer had been set to the connection being fully established). When enabled, Connection.Timeout accounts for the time spent from receiving an offer (or creating an offer) to establishing connectivity (i.e. time it takes to transition from Initializing to Connected state). By default, LegacyTimeout is set to true, so that existing behavior is preserved. However, in the future default will be updated to false. This means that IL will not account for any signalling delays that may occur while establishing connectivity. This option will be later deprecated.
            */
            WebRtcConnectionBase.prototype.setLegacyTimeout = function (value) {
                if (arguments.length == 1) {
                    this._legacyTimeout = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the local description.
            @param localDescription The local description.
            */
            WebRtcConnectionBase.prototype.setLocalDescription = function (localDescription) {
                if (arguments.length == 1) {
                    var promise = new fm.liveswitch.Promise();
                    try {
                        this.setLocalDescriptionInternal(promise, localDescription);
                    }
                    catch (exception) {
                        promise.reject(exception);
                    }
                    finally {
                    }
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.setLocalDescriptionInternal = function (promise, localDescription) {
                var _this = this;
                if (arguments.length == 2) {
                    this.getSessionDescriptionManager().updateLocalDescription(localDescription);
                    this.raiseLocalDescription(localDescription);
                    var future = null;
                    if (this.getIsTerminatingOrTerminated()) {
                        throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Cannot set local description: connection is {0}.", new fm.liveswitch.ConnectionStateWrapper(this.getState()).toString()));
                    }
                    future = this.doSetLocalDescriptionInternal(localDescription);
                    future.then(function (ld) {
                        try {
                            fm.liveswitch.Log.info(fm.liveswitch.StringExtensions.format("Local session description ({0}) for connection {2}:\n{1}", fm.liveswitch.StringExtensions.toLower(new fm.liveswitch.SessionDescriptionTypeWrapper(ld.getType()).toString()), fm.liveswitch.StringExtensions.replace(ld.getSdpMessage().toString(), "\r\n", "\n"), _this.getId()));
                            var sdpMessage = ld.getSdpMessage();
                            if ((!fm.liveswitch.Global.equals(sdpMessage, null))) {
                                for (var _i = 0, _a = sdpMessage.getMediaDescriptions(); _i < _a.length; _i++) {
                                    var description = _a[_i];
                                    var simulcastAttribute = description.getSimulcastAttribute();
                                    if (((!fm.liveswitch.Global.equals(simulcastAttribute, null)) && (!fm.liveswitch.Global.equals(simulcastAttribute.getReceiveDescription(), null)))) {
                                        var exception = new fm.liveswitch.Exception("Receiving simulcast streams is not supported.");
                                        _this.setError(new fm.liveswitch.Error(fm.liveswitch.ErrorCode.ConnectionSimulcastNotSupported, exception));
                                        throw exception;
                                    }
                                }
                            }
                            promise.resolve(ld);
                        }
                        catch (exception2) {
                            promise.reject(exception2);
                        }
                        finally {
                        }
                    }, function (ex) {
                        promise.reject(ex);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote description.
            @param remoteDescription The remote description.
            */
            WebRtcConnectionBase.prototype.setRemoteDescription = function (remoteDescription) {
                if (arguments.length == 1) {
                    var promise = new fm.liveswitch.Promise();
                    try {
                        this.setRemoteDescriptionInternal(promise, remoteDescription);
                    }
                    catch (exception) {
                        promise.reject(exception);
                    }
                    finally {
                    }
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.setRemoteDescriptionInternal = function (promise, remoteDescription) {
                var _this = this;
                if (arguments.length == 2) {
                    var sdpMessage = remoteDescription.getSdpMessage();
                    if ((!fm.liveswitch.Global.equals(sdpMessage, null))) {
                        for (var _i = 0, _a = sdpMessage.getMediaDescriptions(); _i < _a.length; _i++) {
                            var description = _a[_i];
                            var exception = void 0;
                            var simulcastAttribute = description.getSimulcastAttribute();
                            if (((!fm.liveswitch.Global.equals(simulcastAttribute, null)) && (!fm.liveswitch.Global.equals(simulcastAttribute.getSendDescription(), null)))) {
                                exception = new fm.liveswitch.Exception("Receiving simulcast streams is not supported.");
                                this.setError(new fm.liveswitch.Error(fm.liveswitch.ErrorCode.ConnectionSimulcastNotSupported, exception));
                                throw exception;
                            }
                            if ((!fm.liveswitch.Global.equals(description.getSsrcGroupSsrcs("SIM"), null))) {
                                exception = new fm.liveswitch.Exception("Receiving simulcast streams is not supported.");
                                this.setError(new fm.liveswitch.Error(fm.liveswitch.ErrorCode.ConnectionSimulcastNotSupported, exception));
                                throw exception;
                            }
                        }
                    }
                    this.raiseRemoteDescription(remoteDescription);
                    var future = null;
                    this.verifySessionIdAndVersion(remoteDescription);
                    if (this.getIsTerminatingOrTerminated()) {
                        throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Cannot set remote description: connection is {0}.", new fm.liveswitch.ConnectionStateWrapper(this.getState()).toString()));
                    }
                    future = this.doSetRemoteDescriptionInternal(remoteDescription);
                    future.then(function (rd) {
                        fm.liveswitch.Log.info(fm.liveswitch.StringExtensions.format("Remote session description ({0}) for connection {2}:\n{1}", fm.liveswitch.StringExtensions.toLower(new fm.liveswitch.SessionDescriptionTypeWrapper(rd.getType()).toString()), fm.liveswitch.StringExtensions.replace(rd.getSdpMessage().toString(), "\r\n", "\n"), _this.getId()));
                        promise.resolve(rd);
                    }, function (ex) {
                        promise.reject(ex);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the state of the signalling.
            */
            WebRtcConnectionBase.prototype.setSignallingState = function (value) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(this.__signallingState, value))) {
                        this.__signallingState = value;
                        var onSignallingStateChange = this._onSignallingStateChange;
                        if ((!fm.liveswitch.Global.equals(onSignallingStateChange, null))) {
                            try {
                                onSignallingStateChange(this.getInstance());
                            }
                            catch (exception) {
                                fm.liveswitch.Log.error(fm.liveswitch.StringExtensions.format("Exception occurred while raising signalling state change to the application code for connection {0}.", this.getId()), exception);
                            }
                            finally {
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            WebRtcConnectionBase.prototype.setState = function () {
                if (arguments.length == 1) {
                    var state = arguments[0];
                    return this.setState(state, null);
                }
                else if (arguments.length == 2) {
                    var state = arguments[0];
                    var error = arguments[1];
                    var flag = false;
                    if (((fm.liveswitch.Global.equals(state, fm.liveswitch.ConnectionState.Failing)) && (fm.liveswitch.Global.equals(error, null)))) {
                        throw new fm.liveswitch.Exception("Transitioning to the failing state requires an error.");
                    }
                    if (((!fm.liveswitch.Global.equals(state, fm.liveswitch.ConnectionState.Failing)) && (!fm.liveswitch.Global.equals(error, null)))) {
                        throw new fm.liveswitch.Exception("An error can only be specified when transitioning to the failing state.");
                    }
                    if (!this.__stateMachine.transition(state)) {
                        if (((!fm.liveswitch.Global.equals(state, this.getState())) && ((!fm.liveswitch.Global.equals(state, fm.liveswitch.ConnectionState.Closing)) || ((!fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.ConnectionState.Closed)) && (!fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.ConnectionState.Failed)))))) {
                            this.logInvalidStateTransition(state);
                        }
                        return false;
                    }
                    if ((!fm.liveswitch.Global.equals(error, null))) {
                        this.setError(error);
                    }
                    var idValue = this.getId();
                    var externalId = this.getExternalId();
                    if ((!fm.liveswitch.Global.equals(externalId, null))) {
                        idValue = fm.liveswitch.StringExtensions.format("{0} (external ID {1})", idValue, externalId);
                    }
                    flag = (fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.ConnectionState.Connecting));
                    if (fm.liveswitch.Log.getIsInfoEnabled()) {
                        if ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.ConnectionState.Connecting))) {
                            fm.liveswitch.Log.info(fm.liveswitch.StringExtensions.format("Connection {0} took {1}ms to initialize (offer/answer signalling).", this.getId(), fm.liveswitch.NumberExtensions.toString(this.__stateMachine.getLastStateMillis())));
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.ConnectionState.Connected))) {
                                fm.liveswitch.Log.info(fm.liveswitch.StringExtensions.format("Connection {0} took {1}ms to connect (connectivity checks and secure key exchange).", this.getId(), fm.liveswitch.NumberExtensions.toString(this.__stateMachine.getLastStateMillis())));
                            }
                        }
                        var description = null;
                        if ((!fm.liveswitch.Global.equals(error, null))) {
                            description = error.getDescription();
                        }
                        if ((fm.liveswitch.Global.equals(description, null))) {
                            fm.liveswitch.Log.info(fm.liveswitch.StringExtensions.format("Setting connection {0} state to {1}.", idValue, fm.liveswitch.StringExtensions.toLower(new fm.liveswitch.ConnectionStateWrapper(this.getState()).toString())));
                        }
                        else {
                            fm.liveswitch.Log.info(fm.liveswitch.StringExtensions.format("Setting connection {0} state to {1}. Error: {2}", idValue, fm.liveswitch.StringExtensions.toLower(new fm.liveswitch.ConnectionStateWrapper(this.getState()).toString()), description));
                        }
                    }
                    this.raiseStateChange();
                    this.processStateChange();
                    if (flag) {
                        this.raiseCachedCandidates();
                    }
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the tie breaker.
            */
            WebRtcConnectionBase.prototype.setTieBreaker = function (value) {
                if (arguments.length == 1) {
                    this._tieBreaker = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the amount of time (in milliseconds) to wait for a connection to establish before giving up and closing it. Defaults to 30,000.
            */
            WebRtcConnectionBase.prototype.setTimeout = function (value) {
                if (arguments.length == 1) {
                    this._timeout = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets Trickle Ice Support Policy. Cf. https://tools.ietf.org/html/draft-ietf-ice-trickle-05
            */
            WebRtcConnectionBase.prototype.setTrickleIcePolicy = function (value) {
                if (arguments.length == 1) {
                    this.__trickleIcePolicy = value;
                    if ((fm.liveswitch.Global.equals(value, fm.liveswitch.TrickleIcePolicy.FullTrickle))) {
                        this.setUseTrickleIce(true);
                    }
                    else {
                        if ((fm.liveswitch.Global.equals(value, fm.liveswitch.TrickleIcePolicy.NotSupported))) {
                            this.setUseTrickleIce(false);
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(value, fm.liveswitch.TrickleIcePolicy.HalfTrickle))) {
                                this.setUseTrickleIce(false);
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.setUseTrickleIce = function (value) {
                if (arguments.length == 1) {
                    this.__useTrickleIce = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.unregisterStreamWithSessionDescriptionManager = function (stream) {
                if (arguments.length == 1) {
                    this.getSessionDescriptionManager().removeStream(stream);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.updateBundlePolicy = function (policy) {
                if (arguments.length == 1) {
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.updateRemoteCandidateIndex = function (candidate) {
                if (arguments.length == 1) {
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcConnectionBase.prototype.verifySessionIdAndVersion = function (remoteDescription) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(this.getRemoteDescription(), null))) {
                        var sessionId = this.getRemoteDescription().getSessionId();
                        var num2 = remoteDescription.getSessionId();
                        var sessionVersion = this.getRemoteDescription().getSessionVersion();
                        var num4 = remoteDescription.getSessionVersion();
                        if ((!fm.liveswitch.Global.equals(sessionId, num2))) {
                            throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Received new remote description with session id {0} and session version {1}, but current remote description has id {2} and version {3}. Cannot set remote description.", [fm.liveswitch.NumberExtensions.toString(num2), fm.liveswitch.NumberExtensions.toString(num4), fm.liveswitch.NumberExtensions.toString(sessionId), fm.liveswitch.NumberExtensions.toString(sessionVersion)]));
                        }
                        if ((sessionVersion >= num4)) {
                            throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Received new remote description with session id {0} and session version {1}, but current remote description has id {2} and version {3}. Cannot set remote description.", [fm.liveswitch.NumberExtensions.toString(num2), fm.liveswitch.NumberExtensions.toString(num4), fm.liveswitch.NumberExtensions.toString(sessionId), fm.liveswitch.NumberExtensions.toString(sessionVersion)]));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return WebRtcConnectionBase;
        }(fm.liveswitch.Dynamic));
        liveswitch.WebRtcConnectionBase = WebRtcConnectionBase;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="WebRtcConnectionBase.ts" />
function fmicelinkWebRtcConnection_makeMediaStream() {
    return new MediaStream();
}

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var WebRtcConnection = /** @class */ (function (_super) {
            __extends(WebRtcConnection, _super);
            function WebRtcConnection(external, streams, remoteMedia) {
                var _this = _super.call(this, new Object()) || this;
                _this._remoteMediaTrackCount = 0;
                _this._dataStreamsReady = false;
                _this._mediaStreamsReady = false;
                // this is used to cache the last seen frame
                // stats from inbound/outbound-rtp since they
                // disappear from the result object if the
                // encoding deactivates. that alone isn't a
                // problem, but we rely on those properties
                // being present to give the track stats an
                // accurate number in simulcast scenarios
                _this._lastMediaComponentFrameStatsCollection = {};
                /** @hidden */
                _this._iceCandidateProcessingTimeout = 2000;
                _this.dtmfSender = null;
                _this._setMaxSendBitrateQueue = [];
                _this._processingMaxSendBitrate = false;
                _this._external = external;
                _this._remoteMedia = remoteMedia;
                if (!fm.liveswitch.Plugin.hasWebRtc() && !fm.liveswitch.Plugin.hasOrtc()) {
                    throw new fm.liveswitch.Exception('Native browser support for WebRTC/ORTC could not be found.');
                }
                _this._streams = [];
                _this._mediaStreams = [];
                _this._audioStreams = [];
                _this._videoStreams = [];
                _this._dataStreams = [];
                _this._isRenegotiation = false;
                _this._initialized = false;
                _this._localDescription = null;
                _this._remoteDescription = null;
                _this._sessionDescriptionManager = new fm.liveswitch.SessionDescriptionManager();
                _this.addStreamsInternal(streams);
                for (var _i = 0, streams_5 = streams; _i < streams_5.length; _i++) {
                    var stream = streams_5[_i];
                    stream.setConnectionId(_this.getId());
                    stream.setStateLock(_this._connectionLock);
                }
                return _this;
            }
            WebRtcConnection.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcConnection]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @hidden */
            WebRtcConnection.prototype._getExternal = function () {
                return this._external;
            };
            WebRtcConnection.prototype.getRemoteMedia = function () {
                return this._remoteMedia;
            };
            WebRtcConnection.prototype.getNativePeerConnection = function () {
                return this._nativePeerConnection;
            };
            WebRtcConnection.prototype.getNativeIceGatherers = function () {
                return this._nativeIceGatherers;
            };
            WebRtcConnection.prototype.getNativeIceTransports = function () {
                return this._nativeIceTransports;
            };
            WebRtcConnection.prototype.getNativeDtlsTransports = function () {
                return this._nativeDtlsTransports;
            };
            WebRtcConnection.prototype.getNativeRtpSenders = function () {
                return this._nativeRtpSenders;
            };
            WebRtcConnection.prototype.getNativeRtpReceivers = function () {
                return this._nativeRtpReceivers;
            };
            WebRtcConnection.prototype.getInstance = function () {
                return this;
            };
            WebRtcConnection.prototype.addStreamInternal = function (stream) {
                stream.setConnection(this);
                if (stream.getType() == fm.liveswitch.StreamType.Application) {
                    fm.liveswitch.ArrayExtensions.add(this._dataStreams, stream);
                }
                else {
                    if (stream.getType() == fm.liveswitch.StreamType.Audio) {
                        fm.liveswitch.ArrayExtensions.add(this._audioStreams, stream);
                    }
                    else if (stream.getType() == fm.liveswitch.StreamType.Video) {
                        fm.liveswitch.ArrayExtensions.add(this._videoStreams, stream);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Unsupported stream type.');
                    }
                    fm.liveswitch.ArrayExtensions.add(this._mediaStreams, stream);
                }
                fm.liveswitch.ArrayExtensions.add(this._streams, stream);
                this.registerStreamWithSessionDescriptionManager(stream);
            };
            WebRtcConnection.prototype.addStreamsInternal = function (streams) {
                for (var _i = 0, streams_6 = streams; _i < streams_6.length; _i++) {
                    var stream = streams_6[_i];
                    this.addStreamInternal(stream);
                }
            };
            WebRtcConnection.prototype.processStateChange = function () {
                _super.prototype.processStateChange.call(this);
                if ((!this.getLegacyTimeout() && this.getState() == fm.liveswitch.ConnectionState.Connecting) || (this.getLegacyTimeout() && this.getState() == fm.liveswitch.ConnectionState.Initializing)) {
                    this.startConnectionTimeout();
                }
            };
            WebRtcConnection.prototype.startConnectionTimeout = function () {
                var _this = this;
                window.setTimeout(function () {
                    if (_this.getState() == fm.liveswitch.ConnectionState.Connecting || _this.getState() == fm.liveswitch.ConnectionState.Initializing) {
                        if (_this.setState(fm.liveswitch.ConnectionState.Failing, new fm.liveswitch.Error(fm.liveswitch.ErrorCode.ConnectionNotEstablished, new fm.liveswitch.Exception('Could not establish connectivity with remote peer. Shutting down connection.')))) {
                            _this.doClose();
                            _this.setState(fm.liveswitch.ConnectionState.Failed);
                        }
                    }
                }, this.getTimeout());
            };
            WebRtcConnection.prototype.getStreams = function () {
                return this._streams;
            };
            WebRtcConnection.prototype.getMediaStreams = function () {
                return this._mediaStreams;
            };
            WebRtcConnection.prototype.getAudioStreams = function () {
                return this._audioStreams;
            };
            WebRtcConnection.prototype.getVideoStreams = function () {
                return this._videoStreams;
            };
            WebRtcConnection.prototype.getDataStreams = function () {
                return this._dataStreams;
            };
            WebRtcConnection.prototype.constraintMin = function (num1, num2) {
                if (num1 == -1) {
                    return num2;
                }
                if (num2 == -1) {
                    return num1;
                }
                return Math.min(num1, num2);
            };
            WebRtcConnection.prototype.constraintMax = function (num1, num2) {
                if (num1 == -1) {
                    return num2;
                }
                if (num2 == -1) {
                    return num1;
                }
                return Math.max(num1, num2);
            };
            WebRtcConnection.prototype.getStats = function () {
                var _this = this;
                var promise = new fm.liveswitch.Promise();
                try {
                    var timestamp_1 = fm.liveswitch.DateTime.getUtcNow();
                    var stats_1 = new fm.liveswitch.ConnectionStats();
                    stats_1.setId(this.getId());
                    stats_1.setTimestamp(timestamp_1);
                    var successCallback = function (result) {
                        // normalize for legacy
                        if (fm.liveswitch.Util.isFunction(result.result)) {
                            result = result.result();
                        }
                        var report = {};
                        if (fm.liveswitch.Util.isFunction(result.forEach)) {
                            result.forEach(function (stat) {
                                // normalize for legacy
                                if (fm.liveswitch.Util.isFunction(stat.names)) {
                                    var record_1 = stat;
                                    stat = {
                                        id: record_1.id,
                                        type: record_1.type
                                    };
                                    record_1.names().forEach(function (name) {
                                        stat[name] = record_1.stat(name);
                                    });
                                }
                                report[stat.id] = stat;
                            });
                        }
                        //TODO: update to support multiple audio/video streams
                        var audioMediaSenderIds = null;
                        var audioMediaReceiverIds = null;
                        var audioTransportId = null;
                        var videoMediaSenderIds = null;
                        var videoMediaReceiverIds = null;
                        var videoTransportId = null;
                        for (var key in report) {
                            var stat = report[key];
                            switch (stat.type) {
                                case 'inboundrtp':
                                case 'inbound-rtp':
                                    if (stat.mediaType == 'audio') {
                                        if (audioMediaReceiverIds == null) {
                                            audioMediaReceiverIds = [];
                                        }
                                        audioMediaReceiverIds.push(stat.id);
                                        audioTransportId = stat.transportId;
                                    }
                                    else {
                                        if (videoMediaReceiverIds == null) {
                                            videoMediaReceiverIds = [];
                                        }
                                        videoMediaReceiverIds.push(stat.id);
                                        videoTransportId = stat.transportId;
                                    }
                                    break;
                                case 'outboundrtp':
                                case 'outbound-rtp':
                                    if (stat.mediaType == 'audio') {
                                        if (audioMediaSenderIds == null) {
                                            audioMediaSenderIds = [];
                                        }
                                        audioMediaSenderIds.push(stat.id);
                                        audioTransportId = stat.transportId;
                                    }
                                    else {
                                        if (videoMediaSenderIds == null) {
                                            videoMediaSenderIds = [];
                                        }
                                        videoMediaSenderIds.push(stat.id);
                                        videoTransportId = stat.transportId;
                                    }
                                    break;
                            }
                        }
                        stats_1.setMediaStreams([]);
                        for (var _i = 0, _a = _this.getStreams(); _i < _a.length; _i++) {
                            var stream = _a[_i];
                            if (stream.getType() == fm.liveswitch.StreamType.Audio || stream.getType() == fm.liveswitch.StreamType.Video) {
                                var mediaStream = stream;
                                var mediaStreamStats = new fm.liveswitch.MediaStreamStats();
                                mediaStreamStats.setId(stream.getId());
                                mediaStreamStats.setTimestamp(timestamp_1);
                                mediaStreamStats.setType(stream.getType());
                                mediaStreamStats.setDirection(stream.getDirection());
                                mediaStreamStats.setMaxSendBitrate(_this.constraintMin(mediaStream.getMaxSendBitrate(), mediaStream.getRemoteBandwidth()));
                                mediaStreamStats.setMaxReceiveBitrate(_this.constraintMin(mediaStream.getMaxReceiveBitrate(), mediaStream.getLocalBandwidth()));
                                var mediaSenderIds = void 0, mediaReceiverIds = void 0, transportId = void 0;
                                if (stream.getType() == fm.liveswitch.StreamType.Audio) {
                                    mediaSenderIds = audioMediaSenderIds;
                                    mediaReceiverIds = audioMediaReceiverIds;
                                    transportId = audioTransportId;
                                }
                                else {
                                    mediaSenderIds = videoMediaSenderIds;
                                    mediaReceiverIds = videoMediaReceiverIds;
                                    transportId = videoTransportId;
                                }
                                if (mediaStream.getDirection() == fm.liveswitch.StreamDirection.SendReceive || mediaStream.getDirection() == fm.liveswitch.StreamDirection.SendOnly) {
                                    if (mediaSenderIds != null) {
                                        var senders = [];
                                        for (var _b = 0, mediaSenderIds_1 = mediaSenderIds; _b < mediaSenderIds_1.length; _b++) {
                                            var mediaSenderId = mediaSenderIds_1[_b];
                                            var sender = _this.getMediaSenderStats(mediaSenderId, report, mediaStream);
                                            if (sender != null) {
                                                senders.push(sender);
                                            }
                                        }
                                        senders.sort(function (s1, s2) {
                                            var rid1 = s1.getRtpStreamId();
                                            var rid2 = s2.getRtpStreamId();
                                            if (!rid1 && !rid2) {
                                                return 0;
                                            }
                                            if (!rid1) {
                                                return -1;
                                            }
                                            if (!rid2) {
                                                return 1;
                                            }
                                            return rid1.localeCompare(rid2);
                                        });
                                        mediaStreamStats.setSenders(senders);
                                    }
                                }
                                if (mediaStream.getDirection() == fm.liveswitch.StreamDirection.SendReceive || mediaStream.getDirection() == fm.liveswitch.StreamDirection.ReceiveOnly) {
                                    if (mediaReceiverIds != null) {
                                        var receivers = [];
                                        for (var _c = 0, mediaReceiverIds_1 = mediaReceiverIds; _c < mediaReceiverIds_1.length; _c++) {
                                            var mediaReceiverId = mediaReceiverIds_1[_c];
                                            var receiver = _this.getMediaReceiverStats(mediaReceiverId, report, mediaStream);
                                            if (receiver != null) {
                                                receivers.push(receiver);
                                            }
                                        }
                                        receivers.sort(function (r1, r2) {
                                            var rid1 = r1.getRtpStreamId();
                                            var rid2 = r2.getRtpStreamId();
                                            if (!rid1 && !rid2) {
                                                return 0;
                                            }
                                            if (!rid1) {
                                                return -1;
                                            }
                                            if (!rid2) {
                                                return 1;
                                            }
                                            return rid1.localeCompare(rid2);
                                        });
                                        mediaStreamStats.setReceivers(receivers);
                                    }
                                }
                                mediaStreamStats.setTransport(_this.getTransportStats(transportId, report, mediaStreamStats.getSender(), mediaStreamStats.getReceiver()));
                                if (mediaStreamStats.getTransport()) {
                                    var transportInfo = new fm.liveswitch.TransportInfo(mediaStreamStats.getTransport(), null);
                                    mediaStream.setTransportInfo(transportInfo);
                                    var rtcpTransport = mediaStreamStats.getTransport().getRtcpTransport();
                                    if (rtcpTransport != null) {
                                        var rtcpTransportInfo = new fm.liveswitch.TransportInfo(rtcpTransport, null);
                                        mediaStream.setControlTransportInfo(rtcpTransportInfo);
                                    }
                                }
                                stats_1.getMediaStreams().push(mediaStreamStats);
                            }
                            else {
                                var dataStream = stream;
                                var dataStreamStats = new fm.liveswitch.DataStreamStats();
                                dataStreamStats.setId(stream.getId());
                                dataStreamStats.setTimestamp(timestamp_1);
                                dataStreamStats.setType(stream.getType());
                                dataStreamStats.setChannels([]);
                                for (var _d = 0, _e = dataStream.getChannels(); _d < _e.length; _d++) {
                                    var dataChannel = _e[_d];
                                    var dataChannelStats = new fm.liveswitch.DataChannelStats();
                                    dataChannelStats.setId(dataChannel.getId());
                                    dataChannelStats.setTimestamp(timestamp_1);
                                    dataChannelStats.setBytesSent(dataChannel.getBytesSent());
                                    dataChannelStats.setBytesReceived(dataChannel.getBytesReceived());
                                    dataChannelStats.setMessagesSent(dataChannel.getMessagesSent());
                                    dataChannelStats.setMessagesReceived(dataChannel.getMessagesReceived());
                                    dataChannelStats.setLabel(dataChannel.getLabel());
                                    dataChannelStats.setOrdered(dataChannel.getOrdered());
                                    dataChannelStats.setProtocol(dataChannel.getSubprotocol());
                                    dataChannelStats.setState(dataChannel.getState());
                                    dataStreamStats.getChannels().push(dataChannelStats);
                                }
                                if (dataStreamStats.getTransport()) {
                                    var transportInfo = new fm.liveswitch.TransportInfo(dataStreamStats.getTransport(), null);
                                    dataStream.setTransportInfo(transportInfo);
                                }
                                stats_1.setDataStream(dataStreamStats);
                            }
                        }
                        promise.resolve(stats_1);
                    };
                    var failureCallback = function (ex) {
                        promise.reject(ex);
                    };
                    if (this._nativePeerConnection && fm.liveswitch.Util.isFunction(this._nativePeerConnection.getStats) && this.getState() != fm.liveswitch.ConnectionState.Closing && this.getState() != fm.liveswitch.ConnectionState.Closed && this.getState() != fm.liveswitch.ConnectionState.Failing && this.getState() != fm.liveswitch.ConnectionState.Failed) {
                        try {
                            this._nativePeerConnection.getStats().then(successCallback, failureCallback);
                        }
                        catch (ex) {
                            try {
                                // deprecated API - Firefox
                                this._nativePeerConnection.getStats(null, successCallback, failureCallback);
                            }
                            catch (ex) {
                                try {
                                    // deprecated API - Chrome
                                    this._nativePeerConnection.getStats(successCallback, null, failureCallback);
                                }
                                catch (ex) {
                                    successCallback({});
                                }
                            }
                        }
                    }
                    else {
                        successCallback({});
                    }
                }
                catch (ex) {
                    promise.reject(ex);
                }
                return promise;
            };
            WebRtcConnection.prototype.getMediaSenderStats = function (mediaSenderId, report, _mediaStream) {
                if (!mediaSenderId) {
                    return null;
                }
                var mediaSender = report[mediaSenderId];
                if (!mediaSender) {
                    return null;
                }
                var mediaSenderStats = new fm.liveswitch.MediaSenderStats();
                mediaSenderStats.setId(mediaSenderId);
                mediaSenderStats.setTimestamp(fm.liveswitch.DateTime.getUtcNow());
                mediaSenderStats.setBytesSent(mediaSender.bytesSent || 0);
                mediaSenderStats.setCodec(this.getCodecStats(mediaSender.codecId, report, true));
                mediaSenderStats.setFirCount(mediaSender.firCount || 0);
                mediaSenderStats.setNackCount(mediaSender.nackCount || 0);
                mediaSenderStats.setPacketsSent(mediaSender.packetsSent || 0);
                mediaSenderStats.setPliCount(mediaSender.pliCount || 0);
                mediaSenderStats.setRoundTripTime(Math.round((mediaSender.roundTripTime || 0) * 1000));
                mediaSenderStats.setSynchronizationSource(mediaSender.ssrc || 0);
                mediaSenderStats.setRtpStreamId(mediaSender.rid || mediaSender.rtpStreamId || null);
                mediaSenderStats.setRepairedRtpStreamId(mediaSender.rrid || mediaSender.repairedRtpStreamId || null);
                mediaSenderStats.setTrack(this.getMediaTrackStats(mediaSender.trackId || mediaSender.mediaTrackId, report, _mediaStream.getLocalTrack(), mediaSender, _mediaStream, true));
                return mediaSenderStats;
            };
            WebRtcConnection.prototype.getMediaReceiverStats = function (mediaReceiverId, report, _mediaStream) {
                if (!mediaReceiverId) {
                    return null;
                }
                var mediaReceiver = report[mediaReceiverId];
                if (!mediaReceiver) {
                    return null;
                }
                var mediaReceiverStats = new fm.liveswitch.MediaReceiverStats();
                mediaReceiverStats.setId(mediaReceiverId);
                mediaReceiverStats.setTimestamp(fm.liveswitch.DateTime.getUtcNow());
                mediaReceiverStats.setBytesReceived(mediaReceiver.bytesReceived || 0);
                mediaReceiverStats.setCodec(this.getCodecStats(mediaReceiver.codecId, report, false));
                mediaReceiverStats.setFirCount(mediaReceiver.firCount || 0);
                mediaReceiverStats.setJitter(Math.round((mediaReceiver.jitter || 0) * 1000));
                mediaReceiverStats.setNackCount(mediaReceiver.nackCount || 0);
                mediaReceiverStats.setPacketsDiscarded(mediaReceiver.packetsDiscarded || 0);
                mediaReceiverStats.setPacketsDuplicated(mediaReceiver.packetsDuplicated || 0);
                mediaReceiverStats.setPacketsLost(mediaReceiver.packetsLost || 0);
                mediaReceiverStats.setPacketsReceived(mediaReceiver.packetsReceived || 0);
                mediaReceiverStats.setPacketsRepaired(mediaReceiver.packetsRepaired || 0);
                mediaReceiverStats.setPliCount(mediaReceiver.pliCount || 0);
                mediaReceiverStats.setSynchronizationSource(mediaReceiver.ssrc || 0);
                mediaReceiverStats.setRtpStreamId(mediaReceiver.rid || mediaReceiver.rtpStreamId || null);
                mediaReceiverStats.setRepairedRtpStreamId(mediaReceiver.rrid || mediaReceiver.repairedRtpStreamId || null);
                mediaReceiverStats.setTrack(this.getMediaTrackStats(mediaReceiver.trackId || mediaReceiver.mediaTrackId, report, _mediaStream.getRemoteTrack(), mediaReceiver, _mediaStream, false));
                return mediaReceiverStats;
            };
            WebRtcConnection.prototype.getTransportStats = function (transportId, report, mediaSenderStats, mediaReceiverStats) {
                var transportStats = new fm.liveswitch.TransportStats();
                transportStats.setId(transportId || null);
                transportStats.setTimestamp(fm.liveswitch.DateTime.getUtcNow());
                var localCandidateIds = [];
                var remoteCandidateIds = [];
                var candidatePairIds = [];
                var selectedCandidatePairId = null;
                for (var key in report) {
                    var stat = report[key];
                    switch (stat.type) {
                        case 'localcandidate':
                        case 'local-candidate':
                            localCandidateIds.push(stat.id);
                            break;
                        case 'remotecandidate':
                        case 'remote-candidate':
                            remoteCandidateIds.push(stat.id);
                            break;
                        case 'candidatepair':
                        case 'candidate-pair':
                            if (stat.selected) {
                                selectedCandidatePairId = stat.id;
                            }
                            candidatePairIds.push(stat.id);
                            break;
                    }
                }
                transportStats.setCandidatePairs([]);
                for (var _i = 0, candidatePairIds_1 = candidatePairIds; _i < candidatePairIds_1.length; _i++) {
                    var candidatePairId = candidatePairIds_1[_i];
                    transportStats.getCandidatePairs().push(this.getCandidatePairStats(candidatePairId, report));
                }
                transportStats.setLocalCandidates([]);
                for (var _a = 0, localCandidateIds_1 = localCandidateIds; _a < localCandidateIds_1.length; _a++) {
                    var localCandidateId = localCandidateIds_1[_a];
                    transportStats.getLocalCandidates().push(this.getCandidateStats(localCandidateId, report));
                }
                transportStats.setRemoteCandidates([]);
                for (var _b = 0, remoteCandidateIds_1 = remoteCandidateIds; _b < remoteCandidateIds_1.length; _b++) {
                    var remoteCandidateId = remoteCandidateIds_1[_b];
                    transportStats.getRemoteCandidates().push(this.getCandidateStats(remoteCandidateId, report));
                }
                var transport = report[transportId];
                if (transport) {
                    transportStats.setActiveCandidatePair(this.getCandidatePairStats(transport.selectedCandidatePairId || selectedCandidatePairId, report));
                    transportStats.setBytesReceived(transport.bytesReceived || 0);
                    transportStats.setBytesSent(transport.bytesSent || 0);
                    transportStats.setLocalCertificate(this.getCertificateStats(transport.localCertificateId, report));
                    transportStats.setRemoteCertificate(this.getCertificateStats(transport.remoteCertificateId, report));
                    if (transport.rtcpTransportStatsId) {
                        transportStats.setRtcpTransport(this.getTransportStats(transport.rtcpTransportStatsId, report, mediaSenderStats, mediaReceiverStats));
                    }
                    else {
                        transportStats.setRtcpTransport(null);
                    }
                }
                else {
                    transportStats.setActiveCandidatePair(this.getCandidatePairStats(selectedCandidatePairId, report));
                    transportStats.setBytesReceived(0);
                    if (mediaReceiverStats) {
                        transportStats.setBytesReceived(mediaReceiverStats.getBytesReceived());
                    }
                    transportStats.setBytesSent(0);
                    if (mediaSenderStats) {
                        transportStats.setBytesSent(mediaSenderStats.getBytesSent());
                    }
                    transportStats.setLocalCertificate(null);
                    transportStats.setRemoteCertificate(null);
                    transportStats.setRtcpTransport(null);
                }
                return transportStats;
            };
            WebRtcConnection.prototype.getCertificateStats = function (certificateId, report) {
                if (!certificateId) {
                    return null;
                }
                var certificate = report[certificateId];
                if (!certificate) {
                    return null;
                }
                var certificateStats = new fm.liveswitch.CertificateStats();
                certificateStats.setId(certificateId);
                certificateStats.setTimestamp(fm.liveswitch.DateTime.getUtcNow());
                certificateStats.setCertificateBase64(certificate.base64Certificate || null);
                certificateStats.setFingerprint(certificate.fingerprint || null);
                certificateStats.setFingerprintAlgorithm(certificate.fingerprintAlgorithm || null);
                return certificateStats;
            };
            WebRtcConnection.prototype.getCandidateStats = function (candidateId, report) {
                if (!candidateId) {
                    return null;
                }
                var candidate = report[candidateId];
                if (!candidate) {
                    return null;
                }
                var candidateStats = new fm.liveswitch.CandidateStats();
                candidateStats.setId(candidateId);
                candidateStats.setTimestamp(fm.liveswitch.DateTime.getUtcNow());
                candidateStats.setIPAddress(candidate.ip || candidate.ipAddress || null);
                candidateStats.setPort(candidate.port || candidate.portNumber || -1);
                candidateStats.setPriority(candidate.priority || -1);
                candidateStats.setProtocol(fm.liveswitch.ProtocolType.Unknown);
                switch (candidate.protocol || candidate.transport) {
                    case 'UDP':
                    case 'udp':
                        candidateStats.setProtocol(fm.liveswitch.ProtocolType.Udp);
                        break;
                    case 'TCP':
                    case 'tcp':
                        candidateStats.setProtocol(fm.liveswitch.ProtocolType.Tcp);
                        break;
                }
                candidateStats.setRelatedIPAddress(candidate.relatedIP || candidate.relatedIPAddress || null);
                candidateStats.setRelatedPort(candidate.relatedPort || candidate.relatedPortNumber || -1);
                candidateStats.setType(fm.liveswitch.CandidateType.Unknown);
                switch (candidate.candidateType) {
                    case 'host':
                        candidateStats.setType(fm.liveswitch.CandidateType.Host);
                        break;
                    case 'srflx':
                        candidateStats.setType(fm.liveswitch.CandidateType.ServerReflexive);
                        break;
                    case 'relay':
                        candidateStats.setType(fm.liveswitch.CandidateType.Relayed);
                        break;
                    case 'prflx':
                        candidateStats.setType(fm.liveswitch.CandidateType.PeerReflexive);
                        break;
                }
                return candidateStats;
            };
            WebRtcConnection.prototype.getCandidatePairStats = function (candidatePairId, report) {
                if (!candidatePairId) {
                    return null;
                }
                var candidatePair = report[candidatePairId];
                if (!candidatePair) {
                    return null;
                }
                var candidatePairStats = new fm.liveswitch.CandidatePairStats();
                candidatePairStats.setId(candidatePairId);
                candidatePairStats.setTimestamp(fm.liveswitch.DateTime.getUtcNow());
                candidatePairStats.setBytesReceived(candidatePair.bytesReceived || 0);
                candidatePairStats.setBytesSent(candidatePair.bytesSent || 0);
                candidatePairStats.setCurrentRoundTripTime(Math.round((candidatePair.currentRoundTripTime || 0) * 1000));
                candidatePairStats.setLocalCandidateId(candidatePair.localCandidateId || null);
                candidatePairStats.setNominated(candidatePair.nominated || false);
                candidatePairStats.setPriority(candidatePair.priority || -1);
                candidatePairStats.setRemoteCandidateId(candidatePair.remoteCandidateId || null);
                candidatePairStats.setState(fm.liveswitch.CandidatePairState.New);
                switch (candidatePair.state) {
                    case 'frozen':
                        candidatePairStats.setState(fm.liveswitch.CandidatePairState.New);
                        break;
                    case 'waiting':
                        candidatePairStats.setState(fm.liveswitch.CandidatePairState.Waiting);
                        break;
                    case 'inprogress':
                        candidatePairStats.setState(fm.liveswitch.CandidatePairState.InProgress);
                        break;
                    case 'failed':
                        candidatePairStats.setState(fm.liveswitch.CandidatePairState.Failed);
                        break;
                    case 'succeeded':
                        candidatePairStats.setState(fm.liveswitch.CandidatePairState.Succeeded);
                        break;
                    case 'cancelled':
                        candidatePairStats.setState(fm.liveswitch.CandidatePairState.Closed);
                        break;
                }
                candidatePairStats.setTotalRoundTripTime(Math.round((candidatePair.totalRoundTripTime || 0) * 1000));
                candidatePairStats.setTransportId(candidatePair.transportId || null);
                return candidatePairStats;
            };
            WebRtcConnection.prototype.getCodecStats = function (codecId, report, sender) {
                if (!codecId) {
                    return null;
                }
                var codec = report[codecId];
                if (!codec) {
                    return null;
                }
                var name = codec.codec || codec.mimeType || codec.name;
                if (name && (name.indexOf('audio/') == 0 || name.indexOf('video/') == 0)) {
                    name = name.substr(6);
                }
                var codecStats = new fm.liveswitch.CodecStats();
                codecStats.setId(codecId);
                if (sender) {
                    codecStats.setCodecType(fm.liveswitch.CodecType.Encode);
                }
                else {
                    codecStats.setCodecType(fm.liveswitch.CodecType.Decode);
                }
                codecStats.setTimestamp(fm.liveswitch.DateTime.getUtcNow());
                codecStats.setChannelCount(codec.channels || codec.channelCount || 0);
                codecStats.setClockRate(codec.clockRate || 0);
                codecStats.setName(name || null);
                codecStats.setParameters(codec.parameters || null);
                codecStats.setPayloadType(codec.payloadType || -1);
                if (codecStats.getName() == 'opus' && codecStats.getChannelCount() == 0) {
                    codecStats.setChannelCount(2);
                }
                return codecStats;
            };
            WebRtcConnection.prototype.getWebRTCBundlePolicyString = function () {
                var bundlePolicy = this.getBundlePolicy();
                if (bundlePolicy == fm.liveswitch.BundlePolicy.Balanced) {
                    return "balanced";
                }
                else if (bundlePolicy == fm.liveswitch.BundlePolicy.MaxBundle) {
                    return "max-bundle";
                }
                else if (bundlePolicy == fm.liveswitch.BundlePolicy.MaxCompatibility) {
                    return "max-compat";
                }
                else {
                    return "max-compat"; //Disabled is not available for WebRTC
                }
            };
            WebRtcConnection.prototype.getMediaTrackStats = function (mediaTrackId, report, _mediaTrack, mediaComponent, _mediaStream, local) {
                var _this = this;
                if (!mediaTrackId) {
                    return null;
                }
                var mediaTrack = report[mediaTrackId];
                if (!mediaTrack) {
                    return null;
                }
                // for simulcast, as future browser stats move from track to inbound/outbound-rtp
                var lastMediaComponentFrameStats = this._lastMediaComponentFrameStatsCollection[mediaComponent.id];
                if (!lastMediaComponentFrameStats) {
                    lastMediaComponentFrameStats = this._lastMediaComponentFrameStatsCollection[mediaComponent.id] = {};
                }
                if (mediaComponent.hasOwnProperty('frameWidth')) {
                    lastMediaComponentFrameStats.frameWidth = mediaComponent.frameWidth;
                }
                if (mediaComponent.hasOwnProperty('frameHeight')) {
                    lastMediaComponentFrameStats.frameHeight = mediaComponent.frameHeight;
                }
                if (mediaComponent.hasOwnProperty('framesPerSecond')) {
                    lastMediaComponentFrameStats.framesPerSecond = mediaComponent.framesPerSecond;
                }
                if (mediaComponent.hasOwnProperty('framesCorrupted')) {
                    lastMediaComponentFrameStats.framesCorrupted = mediaComponent.framesCorrupted;
                }
                if (mediaComponent.hasOwnProperty('framesDecoded')) {
                    lastMediaComponentFrameStats.framesDecoded = mediaComponent.framesDecoded;
                }
                if (mediaComponent.hasOwnProperty('framesDropped')) {
                    lastMediaComponentFrameStats.framesDropped = mediaComponent.framesDropped;
                }
                if (mediaComponent.hasOwnProperty('framesEncoded')) {
                    lastMediaComponentFrameStats.framesEncoded = mediaComponent.framesEncoded;
                }
                if (mediaComponent.hasOwnProperty('framesReceived')) {
                    lastMediaComponentFrameStats.framesReceived = mediaComponent.framesReceived;
                }
                if (mediaComponent.hasOwnProperty('framesSent')) {
                    lastMediaComponentFrameStats.framesSent = mediaComponent.framesSent;
                }
                if (mediaComponent.hasOwnProperty('targetBitrate')) {
                    lastMediaComponentFrameStats.targetBitrate = mediaComponent.targetBitrate;
                }
                var mediaTrackStats = new fm.liveswitch.MediaTrackStats();
                mediaTrackStats.setId(mediaTrackId);
                mediaTrackStats.setTimestamp(fm.liveswitch.DateTime.getUtcNow());
                mediaTrackStats.setDetached(mediaTrack.detached || false);
                mediaTrackStats.setFrameWidth(lastMediaComponentFrameStats.frameWidth || mediaTrack.frameWidth || 0);
                mediaTrackStats.setFrameHeight(lastMediaComponentFrameStats.frameHeight || mediaTrack.frameHeight || 0);
                mediaTrackStats.setFrameRate(lastMediaComponentFrameStats.framesPerSecond || mediaTrack.framesPerSecond || mediaTrack.frameRate || 0);
                mediaTrackStats.setFramesCorrupted(lastMediaComponentFrameStats.framesCorrupted || mediaTrack.framesCorrupted || 0);
                mediaTrackStats.setFramesDecoded(lastMediaComponentFrameStats.framesDecoded || mediaTrack.framesDecoded || 0);
                mediaTrackStats.setFramesDropped(lastMediaComponentFrameStats.framesDropped || mediaTrack.framesDropped || 0);
                mediaTrackStats.setFramesEncoded(lastMediaComponentFrameStats.framesEncoded || mediaTrack.framesEncoded || 0);
                mediaTrackStats.setFramesReceived(lastMediaComponentFrameStats.framesReceived || mediaTrack.framesReceived || 0);
                mediaTrackStats.setFramesSent(lastMediaComponentFrameStats.framesSent || mediaTrack.framesSent || 0);
                mediaTrackStats.setMuted(_mediaTrack ? _mediaTrack.getMuted() : false);
                mediaTrackStats.setStopped(mediaTrack.ended || mediaTrack.stopped || false);
                mediaTrackStats.setSynchronizationSources(mediaTrack.ssrcIds || []);
                // local min/current/max bitrate plus frame-rate
                if (local) {
                    var bitrate_1 = -1;
                    if (lastMediaComponentFrameStats.hasOwnProperty('targetBitrate')) {
                        bitrate_1 = lastMediaComponentFrameStats.targetBitrate / 1000;
                    }
                    var minBitrate = -1;
                    var maxBitrate_1 = _mediaStream.getSingleSendBitrate();
                    var frameRate_1 = mediaTrackStats.getFrameRate();
                    maxBitrate_1 = this.constraintMin(maxBitrate_1, _mediaStream.getMaxSendBitrate());
                    maxBitrate_1 = this.constraintMin(maxBitrate_1, _mediaStream.getRemoteBandwidth());
                    var sendEncodings = _mediaStream.getSendEncodings();
                    if (sendEncodings && sendEncodings.length > 0) {
                        var applySendEncoding = function (sendEncoding) {
                            bitrate_1 = sendEncoding.getBitrate();
                            maxBitrate_1 = _this.constraintMax(maxBitrate_1, sendEncoding.getBitrate());
                            if (sendEncoding instanceof fm.liveswitch.VideoEncodingConfig) {
                                var videoSendEncoding = sendEncoding;
                                if (videoSendEncoding.getFrameRate() > 0) {
                                    frameRate_1 = videoSendEncoding.getFrameRate();
                                }
                            }
                        };
                        for (var _i = 0, sendEncodings_2 = sendEncodings; _i < sendEncodings_2.length; _i++) {
                            var sendEncoding = sendEncodings_2[_i];
                            if ((mediaComponent.rid && mediaComponent.rid == sendEncoding.getRtpStreamId()) ||
                                (mediaComponent.ssrc && mediaComponent.ssrc == sendEncoding.getSynchronizationSource())) {
                                applySendEncoding(sendEncoding);
                            }
                        }
                        if (bitrate_1 == -1) {
                            for (var i = 0; i < sendEncodings.length; i++) {
                                if (mediaComponent.rid) {
                                    var index = parseInt(mediaComponent.rid);
                                    if (!isNaN(index) && index == i) {
                                        applySendEncoding(sendEncodings[i]);
                                    }
                                }
                            }
                        }
                    }
                    mediaTrackStats.setBitrate(bitrate_1);
                    mediaTrackStats.setMinBitrate(this.constraintMax(minBitrate, _mediaStream.getType() == fm.liveswitch.StreamType.Audio ? 6 : 100));
                    mediaTrackStats.setMaxBitrate(this.constraintMin(maxBitrate_1, _mediaStream.getType() == fm.liveswitch.StreamType.Audio ? 510 : 100000));
                    mediaTrackStats.setFrameRate(frameRate_1);
                }
                return mediaTrackStats;
            };
            WebRtcConnection.prototype.initialize = function () {
                var _this = this;
                this.setState(fm.liveswitch.ConnectionState.Initializing);
                var allowTcp = (this._ortcSupportsTcp || (fm.liveswitch.Plugin.hasWebRtc() && !fm.liveswitch.Plugin.hasOrtc()));
                var servers = [];
                for (var _i = 0, _a = this.getIceServers(); _i < _a.length; _i++) {
                    var server = _a[_i];
                    if (fm.liveswitch.StringExtensions.endsWith(server.getUrl(), '?transport=udp')) {
                        servers.push(server);
                    }
                    else if (fm.liveswitch.StringExtensions.endsWith(server.getUrl(), '?transport=tcp')) {
                        if (allowTcp) {
                            servers.push(server);
                        }
                    }
                    else {
                        if (server.getIsStun()) {
                            servers.push(new fm.liveswitch.IceServer(server.getUrl()));
                        }
                        else {
                            servers.push(new fm.liveswitch.IceServer(server.getUrl() + '?transport=udp', server.getUsername(), server.getPassword()));
                            if (allowTcp) {
                                servers.push(new fm.liveswitch.IceServer(server.getUrl() + '?transport=tcp', server.getUsername(), server.getPassword()));
                            }
                        }
                    }
                }
                var rtcServers = [];
                for (var _b = 0, servers_1 = servers; _b < servers_1.length; _b++) {
                    var server = servers_1[_b];
                    fm.liveswitch.Log.debug('Using ' + server.getUrl() + '.');
                    var rtcServer = {};
                    rtcServer.urls = [server.getUrl()];
                    if (server.getIsTurn()) {
                        rtcServer.username = server.getUsername();
                        rtcServer.credential = server.getPassword();
                    }
                    rtcServers.push(rtcServer);
                }
                var mediaStreamCount = this._mediaStreams.length;
                var dataChannelCount = 0;
                for (var _c = 0, _d = this._dataStreams; _c < _d.length; _c++) {
                    var dataStream = _d[_c];
                    dataChannelCount += dataStream.getChannels().length;
                }
                if (fm.liveswitch.Plugin.hasOrtc()) {
                    // TODO: data channels
                    if (dataChannelCount > 0) {
                        throw new fm.liveswitch.Exception('ORTC does not currently support data channels.');
                    }
                    this._remoteNativeMediaStream = fmicelinkWebRtcConnection_makeMediaStream();
                    this._nativeIceGatherers = [];
                    this._nativeIceTransports = [];
                    this._nativeDtlsTransports = [];
                    this._nativeRtpSenders = [];
                    this._nativeRtpReceivers = [];
                    this._rtpKinds = [];
                    this._localDescription = null;
                    this._remoteDescription = null;
                    this._gatheringState = fm.liveswitch.IceGatheringState.New;
                    this._iceConnectionState = fm.liveswitch.IceConnectionState.New;
                    this._transportsRemaining = 0;
                    // TODO: allow BUNDLE
                    if (mediaStreamCount > 0) {
                        var mediaStreams = this.getMediaStreams();
                        var elements = [];
                        var index = 0;
                        for (var _e = 0, mediaStreams_1 = mediaStreams; _e < mediaStreams_1.length; _e++) {
                            var mediaStream = mediaStreams_1[_e];
                            var streamType = mediaStream.getType();
                            var localTrack = mediaStream.getLocalTrack();
                            var mediaStreamTrack = (localTrack == null) ? null : localTrack._getMediaStreamTrack();
                            var streamKind = (streamType == fm.liveswitch.StreamType.Audio) ? 'audio' : 'video';
                            if (streamType == fm.liveswitch.StreamType.Audio || streamType == fm.liveswitch.StreamType.Video) {
                                elements.push({
                                    track: mediaStreamTrack,
                                    kind: streamKind,
                                    index: index++
                                });
                            }
                        }
                        for (var _f = 0, elements_1 = elements; _f < elements_1.length; _f++) {
                            var element = elements_1[_f];
                            this._remoteNativeMediaStream.addTrack(this.initializeTrack(element, rtcServers));
                        }
                    }
                }
                else {
                    this._discoveredCandidates = [];
                    this._gatheringState = fm.liveswitch.IceGatheringState.New;
                    this._iceConnectionState = fm.liveswitch.IceConnectionState.New;
                    var webRtcBundlePolicy = this.getWebRTCBundlePolicyString();
                    try {
                        this._nativePeerConnection = new RTCPeerConnection({
                            iceServers: rtcServers,
                            bundlePolicy: webRtcBundlePolicy
                        });
                    }
                    catch (ex) {
                        try {
                            // try with a string instead of an array
                            for (var _g = 0, rtcServers_1 = rtcServers; _g < rtcServers_1.length; _g++) {
                                var rtcServer_1 = rtcServers_1[_g];
                                if (rtcServer_1.urls) {
                                    rtcServer_1.urls = rtcServer_1.urls[0];
                                }
                            }
                            this._nativePeerConnection = new RTCPeerConnection({
                                iceServers: rtcServers,
                                bundlePolicy: webRtcBundlePolicy
                            });
                        }
                        catch (ex) {
                            try {
                                // try with the deprecated API
                                for (var _h = 0, rtcServers_2 = rtcServers; _h < rtcServers_2.length; _h++) {
                                    var rtcServer_2 = rtcServers_2[_h];
                                    if (rtcServer_2.urls) {
                                        rtcServer_2.url = rtcServer_2.urls;
                                    }
                                }
                                delete rtcServer.urls;
                                this._nativePeerConnection = new RTCPeerConnection({
                                    iceServers: rtcServers,
                                    bundlePolicy: webRtcBundlePolicy
                                });
                            }
                            catch (ex) {
                                // LS-4441
                                if (ex.message == "") {
                                    throw new fm.liveswitch.Exception("Unable to create internal RTCPeerConnection.");
                                }
                                else {
                                    throw ex;
                                }
                            }
                        }
                    }
                    this._nativePeerConnection.onicegatheringstatechange = function (event) {
                        switch (_this._nativePeerConnection.iceGatheringState) {
                            case "new":
                                _this.setGatheringState(fm.liveswitch.IceGatheringState.New);
                                break;
                            case "complete":
                                _this.setGatheringState(fm.liveswitch.IceGatheringState.Complete);
                                break;
                            case "gathering":
                                _this.setGatheringState(fm.liveswitch.IceGatheringState.Gathering);
                                break;
                        }
                    };
                    this._nativePeerConnection.oniceconnectionstatechange = function (event) {
                        switch (_this._nativePeerConnection.iceConnectionState) {
                            case "new":
                                _this.setIceConnectionState(fm.liveswitch.IceConnectionState.New);
                                break;
                            case "checking":
                                _this.setIceConnectionState(fm.liveswitch.IceConnectionState.Checking);
                                break;
                            case "connected":
                                _this.setIceConnectionState(fm.liveswitch.IceConnectionState.Connected);
                                break;
                            case "completed":
                                _this.setIceConnectionState(fm.liveswitch.IceConnectionState.Completed);
                                break;
                            case "failed":
                                _this.setIceConnectionState(fm.liveswitch.IceConnectionState.Failed);
                                break;
                            case "disconnected":
                                _this.setIceConnectionState(fm.liveswitch.IceConnectionState.Disconnected);
                                break;
                            case "closed":
                                _this.setIceConnectionState(fm.liveswitch.IceConnectionState.Closed);
                                break;
                        }
                    };
                    this._nativePeerConnection.onicecandidate = function (event) {
                        if (event.candidate) {
                            var sdpCandidateString = event.candidate.candidate;
                            //The following checks whether browsers generated end-of-candidates event
                            //once Chrome and Safari supports this, this need to be updated to
                            //send a=end-of-candidates
                            //Current chrome bug:
                            //https://bugs.chromium.org/p/chromium/issues/detail?id=978582
                            if (sdpCandidateString && sdpCandidateString.length > 0) {
                                if (!fm.liveswitch.StringExtensions.startsWith(sdpCandidateString, 'a=')) {
                                    sdpCandidateString = 'a=' + sdpCandidateString;
                                }
                                var localCandidate = new fm.liveswitch.Candidate();
                                localCandidate.setSdpMediaIndex(event.candidate.sdpMLineIndex);
                                localCandidate.setSdpCandidateAttribute(fm.liveswitch.sdp.Attribute.parse(sdpCandidateString));
                                var trickleIceSupported = _this.getUseTrickleIce();
                                if (!trickleIceSupported) {
                                    if (_this.validateCandidate(localCandidate)) {
                                        _this._discoveredCandidates.push(localCandidate);
                                    }
                                }
                                else {
                                    if (_this.validateCandidate(localCandidate)) {
                                        _this.raiseLocalCandidate(localCandidate);
                                    }
                                }
                            }
                        }
                    };
                    var dataChannelsConnected_1 = 0;
                    this._dataStreamsReady = (dataChannelsConnected_1 == dataChannelCount);
                    var processDataChannelStateChange_1 = function (dataChannel) {
                        var dataChannelState = dataChannel.getState();
                        if (dataChannelState == fm.liveswitch.DataChannelState.Connected) {
                            dataChannelsConnected_1++;
                        }
                        else if (dataChannelState == fm.liveswitch.DataChannelState.Closed) {
                            dataChannelsConnected_1--;
                            if (dataChannelsConnected_1 == 0 && mediaStreamCount == 0) {
                                if (_this.setState(fm.liveswitch.ConnectionState.Closing)) {
                                    _this.doClose();
                                    _this.setState(fm.liveswitch.ConnectionState.Closed);
                                }
                            }
                        }
                        else if (dataChannelState == fm.liveswitch.DataChannelState.Failed) {
                            dataChannelsConnected_1--;
                            if (dataChannelsConnected_1 == 0 && mediaStreamCount == 0) {
                                if (_this.setState(fm.liveswitch.ConnectionState.Failing, new fm.liveswitch.Error(fm.liveswitch.ErrorCode.ReliableDataChannelSendError, new fm.liveswitch.Exception('Data channel failed.')))) {
                                    _this.doClose();
                                    _this.setState(fm.liveswitch.ConnectionState.Failed);
                                }
                            }
                        }
                        _this._dataStreamsReady = (dataChannelsConnected_1 == dataChannelCount);
                        if (_this._dataStreamsReady && _this._mediaStreamsReady && _this.getState() == fm.liveswitch.ConnectionState.Connecting) {
                            _this.setState(fm.liveswitch.ConnectionState.Connected);
                        }
                    };
                    var _loop_2 = function (dataStream) {
                        if (this_2._offerer) {
                            for (var _i = 0, _a = dataStream.getChannels(); _i < _a.length; _i++) {
                                var dataChannel = _a[_i];
                                var rtcDataChannel = this_2._nativePeerConnection.createDataChannel(dataChannel.getLabel(), {
                                    ordered: dataChannel.getOrdered(),
                                    //maxPacketLifeTime?: number,
                                    //maxRetransmits?: number,
                                    //protocol: dataChannel.getSubprotocol(),
                                    negotiated: false,
                                });
                                dataChannel.setNativeDataChannel(rtcDataChannel);
                                dataChannel.addOnStateChange(processDataChannelStateChange_1);
                            }
                        }
                        else {
                            this_2._nativePeerConnection.ondatachannel = function (event) {
                                var rtcDataChannel = event.channel;
                                for (var _i = 0, _a = dataStream.getChannels(); _i < _a.length; _i++) {
                                    var dataChannel = _a[_i];
                                    if (dataChannel.getLabel() == rtcDataChannel.label) {
                                        dataChannel.setNativeDataChannel(rtcDataChannel);
                                        dataChannel.addOnStateChange(processDataChannelStateChange_1);
                                    }
                                }
                            };
                        }
                    };
                    var this_2 = this;
                    for (var _j = 0, _k = this._dataStreams; _j < _k.length; _j++) {
                        var dataStream = _k[_j];
                        _loop_2(dataStream);
                    }
                    this._mediaStreamsReady = (mediaStreamCount == 0);
                    if (mediaStreamCount > 0) {
                        var pendingNativeMediaStreams_1 = [];
                        var processNativeMediaStream_1 = function (nativeMediaStreams) {
                            pendingNativeMediaStreams_1 = pendingNativeMediaStreams_1.concat(nativeMediaStreams);
                            var remainingTracks = _this._remoteMediaTrackCount;
                            var nativeAudioStream = null;
                            var nativeVideoStream = null;
                            for (var _i = 0, pendingNativeMediaStreams_2 = pendingNativeMediaStreams_1; _i < pendingNativeMediaStreams_2.length; _i++) {
                                var pendingNativeMediaStream = pendingNativeMediaStreams_2[_i];
                                var nativeAudioTracks = pendingNativeMediaStream.getAudioTracks();
                                if (nativeAudioTracks.length) {
                                    nativeAudioStream = pendingNativeMediaStream;
                                    remainingTracks -= nativeAudioTracks.length;
                                }
                                var nativeVideoTracks = pendingNativeMediaStream.getVideoTracks();
                                if (nativeVideoTracks.length > 0) {
                                    nativeVideoStream = pendingNativeMediaStream;
                                    remainingTracks -= nativeVideoTracks.length;
                                }
                                if (remainingTracks == 0) {
                                    // ready to go
                                    _this._remoteMedia._setMediaStreams(nativeAudioStream, nativeVideoStream);
                                    var remoteAudioTracks = _this._remoteMedia.getAudioTracks();
                                    for (var i = 0; i < remoteAudioTracks.length; i++) {
                                        if (i < _this._audioStreams.length) {
                                            var audioStream = _this._audioStreams[i];
                                            if (!audioStream.getRemoteTrack()) {
                                                audioStream.setRemoteTrack(remoteAudioTracks[i]);
                                            }
                                        }
                                    }
                                    var remoteVideoTracks = _this._remoteMedia.getVideoTracks();
                                    for (var i = 0; i < remoteVideoTracks.length; i++) {
                                        if (i < _this._videoStreams.length) {
                                            var videoStream = _this._videoStreams[i];
                                            if (!videoStream.getRemoteTrack()) {
                                                videoStream.setRemoteTrack(remoteVideoTracks[i]);
                                            }
                                        }
                                    }
                                    _this._mediaStreamsReady = true;
                                    if (_this._dataStreamsReady && _this._mediaStreamsReady && _this.getState() == fm.liveswitch.ConnectionState.Connecting) {
                                        _this.setState(fm.liveswitch.ConnectionState.Connected);
                                    }
                                }
                            }
                        };
                        if ('ontrack' in this._nativePeerConnection) {
                            this._nativePeerConnection.ontrack = function (event) {
                                processNativeMediaStream_1(event.streams);
                            };
                        }
                        else {
                            // deprecated API
                            this._nativePeerConnection.onaddstream = function (event) {
                                processNativeMediaStream_1([event.stream]);
                            };
                        }
                    }
                    var useAddTrack = fm.liveswitch.Util.isFunction(this._nativePeerConnection.addTrack);
                    var useAddTransceiver = fm.liveswitch.Util.isFunction(this._nativePeerConnection.addTransceiver);
                    var addedStreams = [];
                    var _loop_3 = function (mediaStream) {
                        var localMediaTrack = mediaStream.getLocalTrack();
                        if (localMediaTrack) {
                            var localMedia_1 = localMediaTrack.getMedia();
                            var nativeMediaStreamTrack = localMediaTrack._getMediaStreamTrack();
                            if (nativeMediaStreamTrack) {
                                var kind = nativeMediaStreamTrack.kind;
                                var nativeMediaStream = (kind == 'audio' ? localMedia_1._getAudioMediaStream() : localMedia_1._getVideoMediaStream());
                                if (nativeMediaStream) {
                                    var nativeDirection = void 0;
                                    var direction = mediaStream.getDirection();
                                    if (direction != fm.liveswitch.StreamDirection.Unset) {
                                        nativeDirection = fm.liveswitch.StreamDirectionHelper.directionToString(direction);
                                    }
                                    var nativeSendEncodings = void 0;
                                    if (kind == 'audio') {
                                        localMedia_1.addAudioStream(mediaStream);
                                        this_3.addOnStateChange(function (c) {
                                            if (c.getIsTerminating()) {
                                                localMedia_1.removeAudioStream(mediaStream);
                                            }
                                        });
                                        nativeSendEncodings = mediaStream.getNativeSendEncodings();
                                    }
                                    else {
                                        localMedia_1.addVideoStream(mediaStream);
                                        this_3.addOnStateChange(function (c) {
                                            if (c.getIsTerminating()) {
                                                localMedia_1.removeVideoStream(mediaStream);
                                            }
                                        });
                                        nativeSendEncodings = mediaStream.getNativeSendEncodings();
                                    }
                                    useSimulcast = nativeSendEncodings && nativeSendEncodings.length > 1;
                                    if (useSimulcast) {
                                        var simulcastMode = mediaStream.getSimulcastMode();
                                        if (simulcastMode == fm.liveswitch.SimulcastMode.Disabled) {
                                            throw new fm.liveswitch.Exception('Multiple send encodings were specified, but the SimulcastMode is Disabled. Choose a different SimulcastMode for the stream or reduce the number of encodings to one.');
                                        }
                                        else if (simulcastMode == fm.liveswitch.SimulcastMode.RtpStreamId) {
                                            var rtpStreamIndex = 0;
                                            for (var _i = 0, nativeSendEncodings_2 = nativeSendEncodings; _i < nativeSendEncodings_2.length; _i++) {
                                                var nativeSendEncoding = nativeSendEncodings_2[_i];
                                                nativeSendEncoding.rid = (rtpStreamIndex++).toString();
                                            }
                                        }
                                        else {
                                            throw new fm.liveswitch.Exception('Multiple send encodings were specified, but the SimulcastMode ' + new fm.liveswitch.SimulcastModeWrapper(simulcastMode).toString() + ' was not recognized.');
                                        }
                                    }
                                    if (useAddTransceiver && useSimulcast) {
                                        var nativeTransceiverInit = {};
                                        if (nativeDirection) {
                                            nativeTransceiverInit.direction = nativeDirection;
                                        }
                                        if (nativeSendEncodings) {
                                            nativeTransceiverInit.sendEncodings = nativeSendEncodings;
                                        }
                                        var transceiver = this_3._nativePeerConnection.addTransceiver(nativeMediaStreamTrack.kind, nativeTransceiverInit);
                                        this_3._nativePeerConnection.addTrack(nativeMediaStreamTrack, nativeMediaStream);
                                        if (transceiver.sender) {
                                            mediaStream.setSender(transceiver.sender, true);
                                        }
                                        if (transceiver.receiver) {
                                            mediaStream.setReceiver(transceiver.receiver);
                                        }
                                    }
                                    else {
                                        if (useSimulcast) {
                                            fm.liveswitch.Log.warn('Multiple send encodings were specified, but this browser does not support simulcast. The default encoding will be sent.');
                                        }
                                        if (useAddTrack) {
                                            var sender = this_3._nativePeerConnection.addTrack(nativeMediaStreamTrack, nativeMediaStream);
                                            if (sender) {
                                                mediaStream.setSender(sender, false);
                                            }
                                        }
                                        else {
                                            // legacy
                                            if (!fm.liveswitch.ArrayExtensions.contains(addedStreams, nativeMediaStream)) {
                                                this_3._nativePeerConnection.addStream(nativeMediaStream);
                                                addedStreams.push(nativeMediaStream);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    };
                    var this_3 = this, useSimulcast;
                    for (var _l = 0, _m = this._mediaStreams; _l < _m.length; _l++) {
                        var mediaStream = _m[_l];
                        _loop_3(mediaStream);
                    }
                    var deadStreamTimer_1 = 0;
                    this._nativePeerConnection.oniceconnectionstatechange = function (event) {
                        if (_this._nativePeerConnection.iceConnectionState == 'connected' || _this._nativePeerConnection.iceConnectionState == 'completed') {
                            if (deadStreamTimer_1) {
                                fm.liveswitch.Log.debug('Connectivity checks have restored.');
                                window.clearTimeout(deadStreamTimer_1);
                                deadStreamTimer_1 = null;
                            }
                            if (_this.getState() == fm.liveswitch.ConnectionState.Initializing) {
                                fm.liveswitch.Log.debug('Transitioning Connection from Initializing to Connecting state because inner iceConnectionState state is Connected.');
                                _this.setState(fm.liveswitch.ConnectionState.Connecting);
                            }
                            if (_this._dataStreamsReady && _this._mediaStreamsReady && _this.getState() == fm.liveswitch.ConnectionState.Connecting) {
                                _this.setState(fm.liveswitch.ConnectionState.Connected);
                            }
                        }
                        if (_this._nativePeerConnection.iceConnectionState == 'disconnected' && _this.getState() == fm.liveswitch.ConnectionState.Connected) {
                            fm.liveswitch.Log.debug('Some connectivity checks have failed. Monitoring for dead stream.');
                            if (!deadStreamTimer_1) {
                                deadStreamTimer_1 = window.setTimeout(function () {
                                    deadStreamTimer_1 = null;
                                    if (_this.setState(fm.liveswitch.ConnectionState.Failing, new fm.liveswitch.Error(fm.liveswitch.ErrorCode.ConnectionDeadStream, new fm.liveswitch.Exception('Dead stream detected.')))) {
                                        _this.doClose();
                                        _this.setState(fm.liveswitch.ConnectionState.Failed);
                                    }
                                }, _this.getDeadStreamTimeout());
                            }
                        }
                    };
                }
                this._initialized = true;
            };
            // private localStreamsWithCandidatesDone: number = 0;
            WebRtcConnection.prototype.initializeTrack = function (element, rtcServers) {
                var _this = this;
                var iceGatherer = this.createIceGatherer(rtcServers);
                this._nativeIceGatherers.push(iceGatherer);
                iceGatherer.onlocalcandidate = function (event) {
                    var rtcCandidate = event.candidate;
                    /*if (this.getTrickleIceSupport() == TrickleIceSupportPolicy.NotSupported) {
                        if (Object.keys(rtcCandidate).length > 0) {
                            this._localParams.medias[track.mediaIndex].candidates.push(rtcCandidate);
                        } else {
                            this._localStreamsWithCandidatesDone++;
                            if (this._localStreamsWithCandidatesDone == this._iceGatherers.length) {
                                this.createInternalSuccess(this.paramsToSdp(this._localParams));
                            }
                        }
                    } else {*/
                    if (Object.keys(rtcCandidate).length > 0) {
                        var localCandidate = new fm.liveswitch.Candidate();
                        localCandidate.setSdpMediaIndex(element.index);
                        localCandidate.setSdpCandidateAttribute(_this.rtcCandidateToSdpCandidateAttribute(rtcCandidate));
                        if (_this.validateCandidate(localCandidate)) {
                            _this.raiseLocalCandidate(localCandidate);
                        }
                        //}
                    }
                };
                var iceTransport = new RTCIceTransport();
                this._nativeIceTransports.push(iceTransport);
                var dtlsTransport = new window.RTCDtlsTransport(iceTransport);
                this._nativeDtlsTransports.push(dtlsTransport);
                if (element.track && element.track.readyState != 'ended') {
                    var rtpSender = new window.RTCRtpSender(element.track, dtlsTransport);
                    this._nativeRtpSenders.push(rtpSender);
                }
                else {
                    this._nativeRtpSenders.push(null);
                }
                var rtpReceiver = new window.RTCRtpReceiver(dtlsTransport, element.kind);
                this._nativeRtpReceivers.push(rtpReceiver);
                this._rtpKinds.push(element.kind);
                return rtpReceiver.track;
            };
            WebRtcConnection.prototype.validateCandidate = function (candidate) {
                if (this.getIceGatherPolicy() == fm.liveswitch.IceGatherPolicy.NoHost) {
                    return (candidate.getSdpCandidateAttribute().getCandidateType() !== fm.liveswitch.sdp.ice.CandidateType.getHost());
                }
                else if (this.getIceGatherPolicy() == fm.liveswitch.IceGatherPolicy.Relay) {
                    return (candidate.getSdpCandidateAttribute().getCandidateType() === fm.liveswitch.sdp.ice.CandidateType.getRelayed());
                }
                return true;
            };
            WebRtcConnection.prototype.createIceGatherer = function (rtcServers) {
                rtcServers = rtcServers.slice(0); // clone array
                var iceGatherer;
                var gatherPolicy = 'all';
                if (this.getIceGatherPolicy() == fm.liveswitch.IceGatherPolicy.NoHost) {
                    gatherPolicy = 'nohost';
                }
                else if (this.getIceGatherPolicy() == fm.liveswitch.IceGatherPolicy.Relay) {
                    gatherPolicy = 'relayonly';
                }
                try {
                    for (var _i = 0, rtcServers_3 = rtcServers; _i < rtcServers_3.length; _i++) {
                        var rtcServer = rtcServers_3[_i];
                        if (fm.liveswitch.Util.isArray(rtcServer.urls)) {
                            rtcServer.urls = rtcServer.urls[0];
                        }
                    }
                    iceGatherer = new RTCIceGatherer({
                        gatherPolicy: 'all',
                        iceServers: rtcServers
                    });
                }
                catch (ex) {
                    try {
                        // ORTC doesn't like STUN && TURNS right now
                        var i = rtcServers.length;
                        while (i--) {
                            if (fm.liveswitch.StringExtensions.startsWith(rtcServers[i].urls, 'stun:')) {
                                fm.liveswitch.Log.info(fm.liveswitch.StringExtensions.format("ORTC currently does not support STUN protocol. Removing {0} from the list of ICE servers.", rtcServers[i].urls));
                                rtcServers.splice(i, 1);
                            }
                            else if (fm.liveswitch.StringExtensions.startsWith(rtcServers[i].urls, 'turns:')) {
                                fm.liveswitch.Log.info(fm.liveswitch.StringExtensions.format("ORTC currently does not support TURNS protocol. Removing {0} from the list of ICE servers.", rtcServers[i].urls));
                                rtcServers.splice(i, 1);
                            }
                        }
                        iceGatherer = new RTCIceGatherer({
                            gatherPolicy: 'all',
                            iceServers: rtcServers
                        });
                    }
                    catch (ex) {
                        try {
                            for (var _a = 0, rtcServers_4 = rtcServers; _a < rtcServers_4.length; _a++) {
                                var rtcServer = rtcServers_4[_a];
                                if (rtcServer.username == '') {
                                    rtcServer.username = 'unspecified';
                                }
                                if (rtcServer.credential == '') {
                                    rtcServer.credential = 'unspecified';
                                }
                            }
                            iceGatherer = new RTCIceGatherer({
                                gatherPolicy: 'all',
                                iceServers: rtcServers
                            });
                        }
                        catch (ex) {
                            //Likely this is due to the fact that Edge does not support multiple TURN servers with the same transport type.
                            //Workaround till this is fixed is to strip all the TURN servers but the first.
                            //cf. https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10163458/
                            try {
                                if (rtcServers.length > 1) {
                                    var server = rtcServers[0];
                                    rtcServers = new Array(1);
                                    rtcServers[0] = server;
                                    iceGatherer = new RTCIceGatherer({
                                        gatherPolicy: 'all',
                                        iceServers: rtcServers
                                    });
                                }
                                else {
                                    fm.liveswitch.Log.error('Could not create ORTC IceGatherer.', ex);
                                    throw ex;
                                }
                            }
                            catch (ex) {
                                fm.liveswitch.Log.error('Could not create ORTC IceGatherer.', ex);
                                throw ex;
                            }
                        }
                    }
                }
                return iceGatherer;
            };
            WebRtcConnection.prototype.sessionDescriptionTypeToString = function (typeEnum) {
                return (typeEnum == fm.liveswitch.SessionDescriptionType.Offer ? 'offer' : 'answer');
            };
            WebRtcConnection.prototype.sessionDescriptionTypeToEnum = function (typeString) {
                return (typeString == 'offer' ? fm.liveswitch.SessionDescriptionType.Offer : fm.liveswitch.SessionDescriptionType.Answer);
            };
            WebRtcConnection.prototype.webrtcCandidateToCandidate = function (webrtcCandidate) {
                var candidate = new fm.liveswitch.Candidate();
                candidate.setSdpCandidateAttribute(fm.liveswitch.sdp.Attribute.parse(webrtcCandidate.candidate));
                candidate.setSdpMediaIndex(webrtcCandidate.sdpMLineIndex);
                return candidate;
            };
            WebRtcConnection.prototype.webrtcCandidateFromCandidate = function (candidate) {
                return new RTCIceCandidate({
                    candidate: candidate.getSdpCandidateAttribute().toString(),
                    sdpMLineIndex: candidate.getSdpMediaIndex()
                });
            };
            WebRtcConnection.prototype.webrtcSessionDescriptionToSessionDescription = function (webrtcSessionDescription) {
                var sessionDescription = new fm.liveswitch.SessionDescription();
                sessionDescription.setSdpMessage(fm.liveswitch.sdp.Message.parse(webrtcSessionDescription.sessionDescription.sdp));
                sessionDescription.setType(this.sessionDescriptionTypeToEnum(webrtcSessionDescription.sessionDescription.type));
                sessionDescription.setTieBreaker(webrtcSessionDescription.tieBreaker);
                return sessionDescription;
            };
            WebRtcConnection.prototype.webrtcSessionDescriptionFromSessionDescription = function (sessionDescription) {
                return {
                    sessionDescription: new RTCSessionDescription({
                        sdp: sessionDescription.getSdpMessage().toString(),
                        type: this.sessionDescriptionTypeToString(sessionDescription.getType())
                    }),
                    tieBreaker: sessionDescription.getTieBreaker()
                };
            };
            WebRtcConnection.prototype.rtcCandidateToSdpCandidateAttribute = function (rtcCandidate) {
                var sdpCandidateAttribute = new fm.liveswitch.sdp.ice.CandidateAttribute();
                sdpCandidateAttribute.setFoundation(rtcCandidate.foundation);
                sdpCandidateAttribute.setComponentId(1); // TODO: allow disabling of RTP/RTCP multiplexing
                sdpCandidateAttribute.setProtocol(rtcCandidate.protocol);
                sdpCandidateAttribute.setPriority(rtcCandidate.priority);
                sdpCandidateAttribute.setConnectionAddress(rtcCandidate.ip);
                sdpCandidateAttribute.setPort(rtcCandidate.port);
                sdpCandidateAttribute.setCandidateType(rtcCandidate.type);
                if (rtcCandidate.relatedAddress) {
                    sdpCandidateAttribute.setRelatedAddress(rtcCandidate.relatedAddress);
                    sdpCandidateAttribute.setRelatedPort(rtcCandidate.relatedPort);
                }
                return sdpCandidateAttribute;
            };
            WebRtcConnection.prototype.rtcCandidateFromSdpCandidateAttribute = function (sdpCandidateAttribute) {
                return {
                    foundation: sdpCandidateAttribute.getFoundation(),
                    protocol: sdpCandidateAttribute.getProtocol(),
                    priority: sdpCandidateAttribute.getPriority(),
                    ip: sdpCandidateAttribute.getConnectionAddress(),
                    port: sdpCandidateAttribute.getPort(),
                    type: sdpCandidateAttribute.getCandidateType(),
                    relatedAddress: sdpCandidateAttribute.getRelatedAddress(),
                    relatedPort: sdpCandidateAttribute.getRelatedPort(),
                    tcpType: (sdpCandidateAttribute.getProtocol() == fm.liveswitch.sdp.ice.TransportProtocol.getTcp() ? 'active' : undefined)
                };
            };
            WebRtcConnection.prototype.ortcCandidateToCandidate = function (ortcCandidate) {
                var candidate = new fm.liveswitch.Candidate();
                candidate.setSdpCandidateAttribute(this.rtcCandidateToSdpCandidateAttribute(ortcCandidate.candidate));
                candidate.setSdpMediaIndex(ortcCandidate.mediaIndex);
                return candidate;
            };
            WebRtcConnection.prototype.ortcCandidateFromCandidate = function (candidate) {
                return {
                    candidate: this.rtcCandidateFromSdpCandidateAttribute(candidate.getSdpCandidateAttribute()),
                    mediaIndex: candidate.getSdpMediaIndex()
                };
            };
            WebRtcConnection.prototype.ortcSessionDescriptionToSessionDescription = function (ortcSessionDescription) {
                var sdpMessage = new fm.liveswitch.sdp.Message(new fm.liveswitch.sdp.Origin('127.0.0.1'), 'Frozen Mountain ORTC');
                //TODO: test this
                //message.addSessionAttribute(new fm.liveswitch.sdp.ice.OptionsAttribute(['trickle']));
                var mediaDescriptions = new Array(ortcSessionDescription.mediaDescriptions.length);
                var index = 0;
                for (var _i = 0, _a = ortcSessionDescription.mediaDescriptions; _i < _a.length; _i++) {
                    var ortcMediaDescription = _a[_i];
                    var transportPort = 9;
                    var connectionAddress = "0.0.0.0";
                    var codecPayloadTypes = [];
                    for (var _b = 0, _c = ortcMediaDescription.codecCaps; _b < _c.length; _b++) {
                        var ortcCodecCap = _c[_b];
                        codecPayloadTypes.push(ortcCodecCap.preferredPayloadType);
                    }
                    var sdpMediaDescription = new fm.liveswitch.sdp.MediaDescription(new fm.liveswitch.sdp.Media(ortcMediaDescription.kind, transportPort, 'RTP/SAVPF', codecPayloadTypes.join(' ')));
                    sdpMediaDescription.setConnectionData(new fm.liveswitch.sdp.ConnectionData(connectionAddress));
                    sdpMediaDescription.addMediaAttribute(new fm.liveswitch.sdp.rtcp.Attribute(transportPort, connectionAddress));
                    sdpMediaDescription.addMediaAttribute(new fm.liveswitch.sdp.ice.UfragAttribute(ortcMediaDescription.iceParams.usernameFragment));
                    sdpMediaDescription.addMediaAttribute(new fm.liveswitch.sdp.ice.PasswordAttribute(ortcMediaDescription.iceParams.password));
                    for (var _d = 0, _e = ortcMediaDescription.dtlsParams.fingerprints; _d < _e.length; _d++) {
                        var fingerprint = _e[_d];
                        sdpMediaDescription.addMediaAttribute(new fm.liveswitch.sdp.ice.FingerprintAttribute(fingerprint.algorithm, fingerprint.value));
                    }
                    if (ortcMediaDescription.dtlsParams.role == 'auto') {
                        sdpMediaDescription.addMediaAttribute(new fm.liveswitch.sdp.SetupAttribute(fm.liveswitch.sdp.Setup.getActPass()));
                    }
                    else if (ortcMediaDescription.dtlsParams.role == 'client') {
                        sdpMediaDescription.addMediaAttribute(new fm.liveswitch.sdp.SetupAttribute(fm.liveswitch.sdp.Setup.getActive()));
                    }
                    else if (ortcMediaDescription.dtlsParams.role == 'server') {
                        sdpMediaDescription.addMediaAttribute(new fm.liveswitch.sdp.SetupAttribute(fm.liveswitch.sdp.Setup.getPassive()));
                    }
                    if (ortcMediaDescription.direction == fm.liveswitch.StreamDirection.SendReceive) {
                        sdpMediaDescription.addMediaAttribute(new fm.liveswitch.sdp.SendReceiveAttribute());
                    }
                    else if (ortcMediaDescription.direction == fm.liveswitch.StreamDirection.SendOnly) {
                        sdpMediaDescription.addMediaAttribute(new fm.liveswitch.sdp.SendOnlyAttribute());
                    }
                    else if (ortcMediaDescription.direction == fm.liveswitch.StreamDirection.ReceiveOnly) {
                        sdpMediaDescription.addMediaAttribute(new fm.liveswitch.sdp.ReceiveOnlyAttribute());
                    }
                    else {
                        sdpMediaDescription.addMediaAttribute(new fm.liveswitch.sdp.InactiveAttribute());
                    }
                    //TODO: add support for bundling and non-muxed
                    sdpMediaDescription.addMediaAttribute(new fm.liveswitch.sdp.rtcp.MuxAttribute());
                    for (var _f = 0, _g = ortcMediaDescription.codecCaps; _f < _g.length; _f++) {
                        var ortcCodecCap = _g[_f];
                        if (ortcCodecCap.numChannels > 1) {
                            sdpMediaDescription.addMediaAttribute(new fm.liveswitch.sdp.rtp.MapAttribute(ortcCodecCap.preferredPayloadType, ortcCodecCap.name, ortcCodecCap.clockRate, ortcCodecCap.numChannels.toString()));
                        }
                        else {
                            sdpMediaDescription.addMediaAttribute(new fm.liveswitch.sdp.rtp.MapAttribute(ortcCodecCap.preferredPayloadType, ortcCodecCap.name, ortcCodecCap.clockRate));
                        }
                        if (ortcCodecCap.parameters && fm.liveswitch.HashExtensions.getCount(ortcCodecCap.parameters) > 0) {
                            var sdpFormatParametersAttribute = new fm.liveswitch.sdp.FormatParametersAttribute(ortcCodecCap.preferredPayloadType);
                            for (var key in ortcCodecCap.parameters) {
                                sdpFormatParametersAttribute.setFormatSpecificParameter(key, ortcCodecCap.parameters[key]);
                            }
                            sdpMediaDescription.addMediaAttribute(sdpFormatParametersAttribute);
                        }
                        if (ortcCodecCap.rtcpFeedback) {
                            for (var _h = 0, _j = ortcCodecCap.rtcpFeedback; _h < _j.length; _h++) {
                                var rtcpFeedback = _j[_h];
                                if (fm.liveswitch.StringExtensions.isNullOrEmpty(rtcpFeedback.parameter)) {
                                    sdpMediaDescription.addMediaAttribute(new fm.liveswitch.sdp.rtcp.FeedbackAttribute(ortcCodecCap.preferredPayloadType, rtcpFeedback.type));
                                }
                                else {
                                    sdpMediaDescription.addMediaAttribute(new fm.liveswitch.sdp.rtcp.FeedbackAttribute(ortcCodecCap.preferredPayloadType, rtcpFeedback.type, rtcpFeedback.parameter));
                                }
                            }
                        }
                    }
                    for (var _k = 0, _l = ortcMediaDescription.candidates; _k < _l.length; _k++) {
                        var ortcCandidate = _l[_k];
                        sdpMediaDescription.addMediaAttribute(this.rtcCandidateToSdpCandidateAttribute(ortcCandidate));
                    }
                    if (ortcMediaDescription.ssrc != 0) {
                        sdpMediaDescription.addMediaAttribute(new fm.liveswitch.sdp.rtp.SsrcAttribute(ortcMediaDescription.ssrc, fm.liveswitch.sdp.rtp.SsrcAttributeName.getCName(), ortcMediaDescription.cname));
                    }
                    mediaDescriptions[index] = sdpMediaDescription;
                    index++;
                }
                this.getSessionDescriptionManager().addMediaDescriptions(sdpMessage, mediaDescriptions);
                var sessionDescription = new fm.liveswitch.SessionDescription();
                sessionDescription.setSdpMessage(sdpMessage);
                sessionDescription.setTieBreaker(ortcSessionDescription.tieBreaker);
                sessionDescription.setType(ortcSessionDescription.type);
                return sessionDescription;
            };
            WebRtcConnection.prototype.ortcSessionDescriptionFromSessionDescription = function (sessionDescription) {
                var sdpMessage = sessionDescription.getSdpMessage();
                var sdpOrigin = sdpMessage.getOrigin();
                var ortcSessionDescription = {
                    sessionId: sdpOrigin.getSessionId(),
                    sessionVersion: sdpOrigin.getSessionVersion(),
                    mediaDescriptions: [],
                    tieBreaker: sessionDescription.getTieBreaker(),
                    type: sessionDescription.getType()
                };
                var sessionUfragAttribute = null;
                var sessionPasswordAttribute = null;
                var sessionFingerprintAttributes = [];
                for (var _i = 0, _a = sdpMessage.getSessionAttributes(); _i < _a.length; _i++) {
                    var sdpSessionAttribute = _a[_i];
                    if (fm.liveswitch.Util.isObjectType(sdpSessionAttribute, '[fm.liveswitch.sdp.ice.UfragAttribute]')) {
                        sessionUfragAttribute = (sdpSessionAttribute);
                    }
                    else if (fm.liveswitch.Util.isObjectType(sdpSessionAttribute, '[fm.liveswitch.sdp.ice.PasswordAttribute]')) {
                        sessionPasswordAttribute = (sdpSessionAttribute);
                    }
                    else if (fm.liveswitch.Util.isObjectType(sdpSessionAttribute, '[fm.liveswitch.sdp.ice.FingerprintAttribute]')) {
                        sessionFingerprintAttributes.push((sdpSessionAttribute));
                    }
                }
                for (var _b = 0, _c = sdpMessage.getMediaDescriptions(); _b < _c.length; _b++) {
                    var sdpMediaDescription = _c[_b];
                    var ortcMediaDescription = {
                        kind: sdpMediaDescription.getMedia().getMediaType(),
                        direction: fm.liveswitch.StreamDirection.SendReceive,
                        iceParams: {},
                        dtlsParams: {
                            fingerprints: []
                        },
                        codecCaps: [],
                        candidates: [],
                        ssrc: 0,
                        cname: null
                    };
                    if (sessionUfragAttribute != null) {
                        ortcMediaDescription.iceParams.usernameFragment = sessionUfragAttribute.getUfrag();
                    }
                    if (sessionPasswordAttribute != null) {
                        ortcMediaDescription.iceParams.password = sessionPasswordAttribute.getPassword();
                    }
                    for (var _d = 0, sessionFingerprintAttributes_1 = sessionFingerprintAttributes; _d < sessionFingerprintAttributes_1.length; _d++) {
                        var sessionFingerprintAttribute = sessionFingerprintAttributes_1[_d];
                        ortcMediaDescription.dtlsParams.fingerprints.push({
                            algorithm: sessionFingerprintAttribute.getHashFunction(),
                            value: sessionFingerprintAttribute.getFingerprint(),
                        });
                    }
                    var mediaFormatParametersHash = {};
                    var mediaFeedbackAttributeHash = {};
                    for (var _e = 0, _f = sdpMediaDescription.getMediaAttributes(); _e < _f.length; _e++) {
                        var sdpMediaAttribute = _f[_e];
                        if (fm.liveswitch.Util.isObjectType(sdpMediaAttribute, '[fm.liveswitch.sdp.FormatParametersAttribute]')) {
                            var mediaFormatParametersAttribute = (sdpMediaAttribute);
                            var key = mediaFormatParametersAttribute.getFormat().toString();
                            var mediaFormatParametersList = mediaFormatParametersHash[key];
                            if (!mediaFormatParametersList) {
                                mediaFormatParametersHash[key] = mediaFormatParametersList = [];
                            }
                            mediaFormatParametersList.push(mediaFormatParametersAttribute);
                        }
                        else if (fm.liveswitch.Util.isObjectType(sdpMediaAttribute, '[fm.liveswitch.sdp.rtcp.FeedbackAttribute]')) {
                            var mediaFeedbackAttribute = (sdpMediaAttribute);
                            var key = mediaFeedbackAttribute.getPayloadType().toString();
                            var mediaFeedbackAttributeList = mediaFeedbackAttributeHash[key];
                            if (!mediaFeedbackAttributeList) {
                                mediaFeedbackAttributeHash[key] = mediaFeedbackAttributeList = [];
                            }
                            mediaFeedbackAttributeList.push(mediaFeedbackAttribute);
                        }
                    }
                    for (var _g = 0, _h = sdpMediaDescription.getMediaAttributes(); _g < _h.length; _g++) {
                        var sdpMediaAttribute = _h[_g];
                        if (fm.liveswitch.Util.isObjectType(sdpMediaAttribute, '[fm.liveswitch.sdp.ice.UfragAttribute]')) {
                            var mediaUfragAttribute = (sdpMediaAttribute);
                            ortcMediaDescription.iceParams.usernameFragment = mediaUfragAttribute.getUfrag();
                        }
                        else if (fm.liveswitch.Util.isObjectType(sdpMediaAttribute, '[fm.liveswitch.sdp.ice.PasswordAttribute]')) {
                            var mediaPasswordAttribute = (sdpMediaAttribute);
                            ortcMediaDescription.iceParams.password = mediaPasswordAttribute.getPassword();
                        }
                        else if (fm.liveswitch.Util.isObjectType(sdpMediaAttribute, '[fm.liveswitch.sdp.ice.FingerprintAttribute]')) {
                            var mediaFingerprintAttribute = (sdpMediaAttribute);
                            ortcMediaDescription.dtlsParams.fingerprints.push({
                                algorithm: mediaFingerprintAttribute.getHashFunction(),
                                value: mediaFingerprintAttribute.getFingerprint(),
                            });
                        }
                        else if (fm.liveswitch.Util.isObjectType(sdpMediaAttribute, '[fm.liveswitch.sdp.SetupAttribute]')) {
                            var mediaSetupAttribute = (sdpMediaAttribute);
                            if (mediaSetupAttribute.getSetup() == fm.liveswitch.sdp.Setup.getActPass()) {
                                ortcMediaDescription.dtlsParams.role = 'auto';
                            }
                            else if (mediaSetupAttribute.getSetup() == fm.liveswitch.sdp.Setup.getActive()) {
                                ortcMediaDescription.dtlsParams.role = 'client';
                            }
                            else if (mediaSetupAttribute.getSetup() == fm.liveswitch.sdp.Setup.getPassive()) {
                                ortcMediaDescription.dtlsParams.role = 'server';
                            }
                        }
                        else if (fm.liveswitch.Util.isObjectType(sdpMediaAttribute, '[fm.liveswitch.sdp.rtp.MapAttribute]')) {
                            var mediaRtpMapAttribute = (sdpMediaAttribute);
                            var formatParameters = mediaRtpMapAttribute.getFormatParameters();
                            var codecCap = {
                                preferredPayloadType: mediaRtpMapAttribute.getPayloadType(),
                                name: mediaRtpMapAttribute.getFormatName(),
                                clockRate: mediaRtpMapAttribute.getClockRate(),
                                numChannels: fm.liveswitch.StringExtensions.isNullOrEmpty(formatParameters) ? 1 : fm.liveswitch.ParseAssistant.parseIntegerValue(formatParameters),
                                parameters: {},
                                rtcpFeedback: []
                            };
                            var payloadTypeKey = mediaRtpMapAttribute.getPayloadType().toString();
                            this.applyMediaFormatParametersAttributes(codecCap, mediaFormatParametersHash[payloadTypeKey]);
                            this.applyMediaFeedbackAttributes(codecCap, mediaFeedbackAttributeHash[payloadTypeKey]);
                            this.applyMediaFeedbackAttributes(codecCap, mediaFeedbackAttributeHash['-1']); // wildcard
                            /*
                            if (mediaRtpMapAttribute.getFormatName().toLowerCase() == 'opus')
                            {
                                //codecCap.rtcpFeedback.push({
                                //    type: 'x-message',
                                //    parameter: 'app send:dsh recv:dsh' // Dominant Speaker History Notification https://msdn.microsoft.com/en-us/library/mt599587(v=vs.85).aspx
                                //});
                            }
                            else if (mediaRtpMapAttribute.getFormatName().toLowerCase() == 'h264')
                            {
                                codecCap.parameters['packetization-mode'] = '1';
                                codecCap.parameters['profile-level-id'] = '42C02A';
                                codecCap.rtcpFeedback.push({
                                    type: 'nack',
                                    parameter: 'pli'
                                });
                                codecCap.rtcpFeedback.push({
                                    type: 'nack',
                                    parameter: ''
                                });
                                //codecCap.rtcpFeedback.push({
                                //    type: 'goog-remb',
                                //    parameter: ''
                                //});
                            }*/
                            ortcMediaDescription.codecCaps.push(codecCap);
                        }
                        else if (fm.liveswitch.Util.isObjectType(sdpMediaAttribute, '[fm.liveswitch.sdp.ice.CandidateAttribute]')) {
                            var mediaCandidateAttribute = (sdpMediaAttribute);
                            if (mediaCandidateAttribute.getProtocol() != fm.liveswitch.sdp.ice.TransportProtocol.getTcp() || this._ortcSupportsTcp) {
                                ortcMediaDescription.candidates.push(this.rtcCandidateFromSdpCandidateAttribute(mediaCandidateAttribute));
                            }
                        }
                        else if (fm.liveswitch.Util.isObjectType(sdpMediaAttribute, '[fm.liveswitch.sdp.rtp.SsrcAttribute]')) {
                            var mediaSsrcAttribute = (sdpMediaAttribute);
                            if (ortcMediaDescription.ssrc == 0) {
                                ortcMediaDescription.ssrc = mediaSsrcAttribute.getSynchronizationSource();
                            }
                            if (mediaSsrcAttribute.getName() == fm.liveswitch.sdp.rtp.SsrcAttributeName.getCName() && ortcMediaDescription.ssrc == mediaSsrcAttribute.getSynchronizationSource()) {
                                ortcMediaDescription.cname = mediaSsrcAttribute.getValue();
                            }
                        }
                    }
                    ortcSessionDescription.mediaDescriptions.push(ortcMediaDescription);
                }
                return ortcSessionDescription;
            };
            WebRtcConnection.prototype.applyMediaFormatParametersAttributes = function (codecCap, mediaFormatParametersList) {
                if (mediaFormatParametersList) {
                    for (var _i = 0, mediaFormatParametersList_1 = mediaFormatParametersList; _i < mediaFormatParametersList_1.length; _i++) {
                        var mediaFormatParameters = mediaFormatParametersList_1[_i];
                        var params = mediaFormatParameters.deserializeFormatSpecificParameters();
                        for (var key in params) {
                            codecCap.parameters[key] = params[key];
                        }
                    }
                }
            };
            WebRtcConnection.prototype.applyMediaFeedbackAttributes = function (codecCap, mediaFeedbackAttributeList) {
                if (mediaFeedbackAttributeList) {
                    for (var _i = 0, mediaFeedbackAttributeList_1 = mediaFeedbackAttributeList; _i < mediaFeedbackAttributeList_1.length; _i++) {
                        var mediaFeedbackAttribute = mediaFeedbackAttributeList_1[_i];
                        codecCap.rtcpFeedback.push({
                            type: mediaFeedbackAttribute.getType(),
                            parameter: mediaFeedbackAttribute.getSubType() || ''
                        });
                    }
                }
            };
            WebRtcConnection.prototype.getIceCandidateProcessingTimeout = function () {
                return this._iceCandidateProcessingTimeout;
            };
            WebRtcConnection.prototype.setIceCandidateProcessingTimeout = function (value) {
                if (value > 0) {
                    this._iceCandidateProcessingTimeout = value;
                }
                else {
                    throw new fm.liveswitch.Exception("");
                }
            };
            WebRtcConnection.prototype.doCreateOffer = function (promise) {
                this._offerer = true;
                this.doCreate(promise);
                return true;
            };
            WebRtcConnection.prototype.doCreateAnswer = function (promise) {
                this._offerer = false;
                this.doCreate(promise);
            };
            WebRtcConnection.prototype.processIceGatheringStateComplete = function () {
                this._iceGatheringComplete = true;
                if (!this.getUseTrickleIce() && !this._isRenegotiation && this._originalSetNativeDescriptionComplete) {
                    this.injectDiscoveredCandidatesIntoSdp();
                }
            };
            WebRtcConnection.prototype.injectDiscoveredCandidatesIntoSdp = function () {
                if (this._injectingCandidates) {
                    //Indicates that candidate gathering timeout was reached prior to finishing gathering candidates. Ignore.
                }
                else if (this._localSessionDescriptionPromise == null || this._localSessionDescription == null) {
                    this._injectingCandidates = true;
                    var errorMsg = "Local Session Description not ready when trying to inject local candidates into session description.";
                    if (this._localSessionDescriptionPromise == null) {
                        errorMsg = "Local Session Description Promise not set when trying to inject local candidates into session description.";
                    }
                    var error = new fm.liveswitch.Error(fm.liveswitch.ErrorCode.ConnectionInternalError, errorMsg);
                    if (this.setState(fm.liveswitch.ConnectionState.Failing, error)) {
                        this.doClose();
                        this.setState(fm.liveswitch.ConnectionState.Failed);
                    }
                    if (this._localSessionDescriptionPromise != null) {
                        this._localSessionDescriptionPromise.reject(new fm.liveswitch.Exception(errorMsg));
                    }
                }
                else {
                    this._injectingCandidates = true;
                    var sdpMessage = this._localSessionDescription.getSdpMessage();
                    var medias = sdpMessage.getMediaDescriptions();
                    if (medias != null) {
                        for (var _i = 0, _a = this._discoveredCandidates; _i < _a.length; _i++) {
                            var candidate = _a[_i];
                            var index = candidate.getSdpMediaIndex();
                            var media = medias[index];
                            var candidateAttribute = candidate.getSdpCandidateAttribute();
                            media.addMediaAttribute(candidateAttribute);
                            //Update connection and media lines with candidate's port and ip if possible.
                            var connectionData = media.getConnectionData();
                            var existingIp = connectionData.getConnectionAddress();
                            var candidatePort = candidateAttribute.getPort();
                            var candidateIp = candidateAttribute.getConnectionAddress();
                            var candidateComponent = candidateAttribute.getComponentId();
                            if (candidateComponent == 2) {
                                var rtcpAttribute = media.getRtcpAttribute();
                                if (rtcpAttribute == null) {
                                    rtcpAttribute = new fm.liveswitch.sdp.rtcp.Attribute(candidatePort, candidateIp);
                                    media.setRtcpAttribute(rtcpAttribute);
                                }
                                else {
                                    rtcpAttribute.update(candidatePort, candidateIp);
                                }
                            }
                            var existingIpBlank = (existingIp == "0.0.0.0" || existingIp == "::" || existingIp == "0:0:0:0:0:0:0:0");
                            var candidateIpBlank = (candidateIp == "0.0.0.0" || candidateIp == "::" || existingIp == "0:0:0:0:0:0:0:0");
                            //If this is a udp based candidate, prefer that over tcp:
                            var isUdpCandidate = (candidateAttribute.getProtocol().toLowerCase() == fm.liveswitch.sdp.ice.TransportProtocol.getUdp().toLowerCase());
                            if (candidateComponent == 1 && isUdpCandidate && existingIpBlank && !candidateIpBlank && candidatePort > 0) {
                                connectionData.update(candidateIp);
                                var sdpMedia = media.getMedia();
                                sdpMedia.setTransportPort(candidatePort);
                            }
                        }
                    }
                    this._localSessionDescriptionPromise.resolve(this._localSessionDescription);
                }
            };
            WebRtcConnection.prototype.setNativeDescriptionSuccess = function (sessionDescription, promise) {
                var _this = this;
                this._originalSetNativeDescriptionComplete = true;
                this._localSessionDescriptionPromise = promise;
                this._localSessionDescription = sessionDescription;
                if (!this.getUseTrickleIce() && !this._isRenegotiation) {
                    if (this._iceGatheringComplete) {
                        this.injectDiscoveredCandidatesIntoSdp();
                    }
                    else {
                        window.setTimeout(function () {
                            _this.injectDiscoveredCandidatesIntoSdp();
                        }, this.getIceCandidateProcessingTimeout());
                    }
                }
                else {
                    promise.resolve(sessionDescription);
                }
            };
            ;
            WebRtcConnection.prototype.doCreate = function (promise) {
                var _this = this;
                fm.liveswitch.ManagedThread.dispatch(function () {
                    try {
                        if (!_this._initialized) {
                            _this.initialize();
                        }
                        if (fm.liveswitch.Plugin.hasOrtc()) {
                            _this._ortcLocalDescription = {
                                sessionId: Math.floor(Math.random() * 9223372036854775807),
                                sessionVersion: Math.floor(Math.random() * 2147483647),
                                mediaDescriptions: [],
                                tieBreaker: _this.getTieBreaker(),
                                type: _this._offerer ? fm.liveswitch.SessionDescriptionType.Offer : fm.liveswitch.SessionDescriptionType.Answer
                            };
                            var cname = fm.liveswitch.Guid.newGuid().toString().replace('-', '').substr(0, 8);
                            for (var i = 0; i < _this._nativeIceGatherers.length; i++) {
                                var localMediaDescription = {
                                    kind: _this._rtpKinds[i],
                                    direction: _this._mediaStreams[i].getDirection(),
                                    iceParams: _this._nativeIceGatherers[i].getLocalParameters(),
                                    dtlsParams: _this._nativeDtlsTransports[i].getLocalParameters(),
                                    codecCaps: [],
                                    candidates: [],
                                    ssrc: (_this._nativeRtpSenders[i] == null ? 0 : Math.floor(Math.random() * 4294967296)),
                                    cname: cname
                                };
                                // get send/receive codecs and use union of the two going forward
                                var send = RTCRtpSender.getCapabilities(_this._rtpKinds[i]);
                                var receive = RTCRtpReceiver.getCapabilities(_this._rtpKinds[i]);
                                var receiveCodecs = {};
                                for (var _i = 0, _a = receive.codecs; _i < _a.length; _i++) {
                                    var codec = _a[_i];
                                    var encodingName = [codec.name, codec.clockRate, codec.numChannels, codec.preferredPayloadType].join('/').toLowerCase();
                                    receiveCodecs[encodingName] = codec;
                                    if (codec.name.toLowerCase() == 'h264' && codec.parameters['level-asymmetry-allowed'] == undefined) {
                                        codec.parameters['level-asymmetry-allowed'] = '1';
                                    }
                                }
                                for (var _b = 0, _c = send.codecs; _b < _c.length; _b++) {
                                    var codec = _c[_b];
                                    var encodingName = [codec.name, codec.clockRate, codec.numChannels, codec.preferredPayloadType].join('/').toLowerCase();
                                    if (receiveCodecs[encodingName]) {
                                        localMediaDescription.codecCaps.push(codec);
                                    }
                                    if (codec.name.toLowerCase() == 'h264' && codec.parameters['level-asymmetry-allowed'] == undefined) {
                                        codec.parameters['level-asymmetry-allowed'] = '1';
                                    }
                                }
                                localMediaDescription.codecCaps.sort(function (a, b) {
                                    if (a.clockRate == b.clockRate) {
                                        return b.numChannels - a.numChannels;
                                    }
                                    return b.clockRate - a.clockRate;
                                });
                                // if we have remote parameters, update based on negotiated parameters
                                if (_this._ortcRemoteDescription) {
                                    var remoteMediaDescription = _this._ortcRemoteDescription.mediaDescriptions[i];
                                    // update DTLS role
                                    if (remoteMediaDescription.dtlsParams.role == 'auto' || remoteMediaDescription.dtlsParams.role == 'server') {
                                        localMediaDescription.dtlsParams.role = 'client';
                                    }
                                    else {
                                        localMediaDescription.dtlsParams.role = 'server';
                                    }
                                    // update codecs
                                    var localCodecs = [];
                                    for (var _d = 0, _e = remoteMediaDescription.codecCaps; _d < _e.length; _d++) {
                                        var remoteCodec = _e[_d];
                                        // TODO: support RTX
                                        if (remoteCodec.name == 'rtx') {
                                            continue;
                                        }
                                        var skip = false;
                                        for (var _f = 0, _g = localMediaDescription.codecCaps; _f < _g.length; _f++) {
                                            var localCodec = _g[_f];
                                            if (localCodec.name.toLowerCase() == remoteCodec.name.toLowerCase() &&
                                                localCodec.clockRate == remoteCodec.clockRate &&
                                                localCodec.numChannels == remoteCodec.numChannels) {
                                                //This is a temporary fix to ensure that we do not have multiple matches for codecs with almost identical features except for parameters.
                                                for (var _h = 0, _j = localCodecs; _h < _j.length; _h++) {
                                                    var negotiatedCodec = _j[_h];
                                                    if (remoteCodec.name.toLowerCase() == negotiatedCodec.name.toLowerCase() &&
                                                        remoteCodec.clockRate == negotiatedCodec.clockRate &&
                                                        remoteCodec.numChannels == negotiatedCodec.numChannels) {
                                                        skip = true;
                                                        break; //TODO:negotiate parameters.
                                                    }
                                                }
                                                if (!skip) {
                                                    // use remote casing and payload type when answering
                                                    localCodec.name = remoteCodec.name;
                                                    localCodec.preferredPayloadType = remoteCodec.preferredPayloadType;
                                                    localCodecs.push(localCodec);
                                                }
                                                break;
                                            }
                                        }
                                    }
                                    localMediaDescription.codecCaps = localCodecs;
                                }
                                _this._ortcLocalDescription.mediaDescriptions.push(localMediaDescription);
                            }
                            promise.resolve(_this.ortcSessionDescriptionToSessionDescription(_this._ortcLocalDescription));
                        }
                        else {
                            for (var _k = 0, _l = _this.getStreams(); _k < _l.length; _k++) {
                                var stream = _l[_k];
                                var streamType = stream.getType();
                                if (_this._offerer && (_this.getState() == fm.liveswitch.ConnectionState.Connected)) {
                                    if (streamType == fm.liveswitch.StreamType.Audio) {
                                        stream.processCachedChanges();
                                        stream.resetRemoteDirection();
                                    }
                                    else if (streamType == fm.liveswitch.StreamType.Video) {
                                        stream.processCachedChanges();
                                        stream.resetRemoteDirection();
                                    }
                                }
                            }
                            var createSuccess = function (rtcSessionDescription) {
                                var sessionDescription = _this.webrtcSessionDescriptionToSessionDescription({
                                    sessionDescription: rtcSessionDescription,
                                    tieBreaker: _this.getTieBreaker()
                                });
                                // there is a possibility the direction in the SDP doesn't align with
                                // the direction provided in the stream, since Chrome infers the direction
                                // of the stream from the presence of a local track and the offerToReceive flags,
                                // which may or may not align with the direction set by the developer
                                var audioDirections = [];
                                var videoDirections = [];
                                for (var _i = 0, _a = _this.getStreams(); _i < _a.length; _i++) {
                                    var stream = _a[_i];
                                    var streamDirection = stream.getLocalDirection();
                                    if (streamDirection == fm.liveswitch.StreamDirection.Unset) {
                                        streamDirection = stream.getDirectionCapabilities();
                                    }
                                    var streamType = stream.getType();
                                    if (streamType === fm.liveswitch.StreamType.Audio) {
                                        audioDirections.push(streamDirection);
                                    }
                                    else if (streamType === fm.liveswitch.StreamType.Video) {
                                        videoDirections.push(streamDirection);
                                    }
                                }
                                var audioDirectionIndex = 0;
                                var videoDirectionIndex = 0;
                                for (var _b = 0, _c = sessionDescription.getSdpMessage().getMediaDescriptions(); _b < _c.length; _b++) {
                                    var sdpMediaDescription = _c[_b];
                                    var streamDirection = fm.liveswitch.StreamDirection.Unset;
                                    if (sdpMediaDescription.getMedia().getMediaType() == fm.liveswitch.sdp.MediaType.getAudio()) {
                                        streamDirection = audioDirections[audioDirectionIndex++];
                                    }
                                    else if (sdpMediaDescription.getMedia().getMediaType() == fm.liveswitch.sdp.MediaType.getVideo()) {
                                        streamDirection = videoDirections[videoDirectionIndex++];
                                    }
                                    else {
                                        continue;
                                    }
                                    var needsDirectionAttribute = false;
                                    for (var _d = 0, _e = sdpMediaDescription.getMediaAttributes(); _d < _e.length; _d++) {
                                        var sdpMediaAttribute = _e[_d];
                                        if ((fm.liveswitch.Util.isObjectType(sdpMediaAttribute, '[fm.liveswitch.sdp.SendReceiveAttribute]') && streamDirection != fm.liveswitch.StreamDirection.SendReceive) ||
                                            (fm.liveswitch.Util.isObjectType(sdpMediaAttribute, '[fm.liveswitch.sdp.SendOnlyAttribute]') && streamDirection != fm.liveswitch.StreamDirection.SendOnly) ||
                                            (fm.liveswitch.Util.isObjectType(sdpMediaAttribute, '[fm.liveswitch.sdp.ReceiveOnlyAttribute]') && streamDirection != fm.liveswitch.StreamDirection.ReceiveOnly) ||
                                            (fm.liveswitch.Util.isObjectType(sdpMediaAttribute, '[fm.liveswitch.sdp.InactiveAttribute]') && streamDirection != fm.liveswitch.StreamDirection.Inactive)) {
                                            sdpMediaDescription.removeMediaAttribute(sdpMediaAttribute);
                                            needsDirectionAttribute = true;
                                            break;
                                        }
                                    }
                                    if (needsDirectionAttribute) {
                                        switch (streamDirection) {
                                            case fm.liveswitch.StreamDirection.SendReceive:
                                                sdpMediaDescription.addMediaAttribute(new fm.liveswitch.sdp.SendReceiveAttribute());
                                                break;
                                            case fm.liveswitch.StreamDirection.SendOnly:
                                                sdpMediaDescription.addMediaAttribute(new fm.liveswitch.sdp.SendOnlyAttribute());
                                                break;
                                            case fm.liveswitch.StreamDirection.ReceiveOnly:
                                                sdpMediaDescription.addMediaAttribute(new fm.liveswitch.sdp.ReceiveOnlyAttribute());
                                                break;
                                            case fm.liveswitch.StreamDirection.Inactive:
                                                sdpMediaDescription.addMediaAttribute(new fm.liveswitch.sdp.InactiveAttribute());
                                                break;
                                        }
                                    }
                                }
                                fm.liveswitch.SessionDescriptionManager.updateTrickleIcePolicy(sessionDescription.getSdpMessage(), _this.getTrickleIcePolicy());
                                if (_this.getSignallingState() == fm.liveswitch.SignallingState.Stable) {
                                    _this._isRenegotiation = true;
                                }
                                promise.resolve(sessionDescription);
                            };
                            var createFailure = function (domError) {
                                var ex = new fm.liveswitch.Exception('Could not create ' + (_this._offerer ? 'offer' : 'answer') + ' (' + domError + ').');
                                if (_this.setState(fm.liveswitch.ConnectionState.Failing, new fm.liveswitch.Error(fm.liveswitch.ErrorCode.ConnectionInvalidArchitecture, ex))) {
                                    _this.doClose();
                                    _this.setState(fm.liveswitch.ConnectionState.Failed);
                                }
                                promise.reject(ex);
                            };
                            var audioStreamCount = (_this.getAudioStreams().length);
                            var videoStreamCount = (_this.getVideoStreams().length);
                            try {
                                if (_this._offerer) {
                                    var transceivers = _this._nativePeerConnection.getTransceivers();
                                    var videoTransceiverCount = 0;
                                    var audioTransceiverCount = 0;
                                    for (var _m = 0, transceivers_1 = transceivers; _m < transceivers_1.length; _m++) {
                                        var transceiver = transceivers_1[_m];
                                        if (transceiver.sender.track && transceiver.sender.track.kind == 'video') {
                                            videoTransceiverCount++;
                                        }
                                        if (transceiver.sender.track && transceiver.sender.track.kind == 'audio') {
                                            audioTransceiverCount++;
                                        }
                                    }
                                    var addAudioTransceivers = audioStreamCount - audioTransceiverCount;
                                    var addVideoTransceivers = videoStreamCount - videoTransceiverCount;
                                    for (var j = 0; j < addAudioTransceivers; j++) {
                                        _this._nativePeerConnection.addTransceiver('audio');
                                    }
                                    for (var j = 0; j < addVideoTransceivers; j++) {
                                        _this._nativePeerConnection.addTransceiver('video');
                                    }
                                    _this._nativePeerConnection.createOffer().then(createSuccess, createFailure);
                                }
                                else {
                                    _this._nativePeerConnection.createAnswer().then(createSuccess, createFailure);
                                }
                            }
                            catch (ex) {
                                try {
                                    if (_this._offerer) {
                                        _this._nativePeerConnection.createOffer({
                                            offerToReceiveAudio: audioStreamCount,
                                            offerToReceiveVideo: videoStreamCount // deprecated, but still in use
                                        }).then(createSuccess, createFailure);
                                    }
                                    else {
                                        _this._nativePeerConnection.createAnswer().then(createSuccess, createFailure);
                                    }
                                }
                                catch (ex) {
                                    try {
                                        // try with deprecated API
                                        if (_this._offerer) {
                                            _this._nativePeerConnection.createOffer(createSuccess, createFailure, {
                                                offerToReceiveAudio: audioStreamCount,
                                                offerToReceiveVideo: videoStreamCount
                                            });
                                        }
                                        else {
                                            _this._nativePeerConnection.createAnswer(createSuccess, createFailure);
                                        }
                                    }
                                    catch (ex) {
                                        // try with deprecated API
                                        if (_this._offerer) {
                                            _this._nativePeerConnection.createOffer(createSuccess, createFailure, {
                                                optional: [],
                                                mandatory: {
                                                    OfferToReceiveAudio: audioStreamCount,
                                                    OfferToReceiveVideo: videoStreamCount
                                                }
                                            });
                                        }
                                        else {
                                            _this._nativePeerConnection.createAnswer(createSuccess, createFailure);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    catch (ex) {
                        if (_this.setState(fm.liveswitch.ConnectionState.Failing, new fm.liveswitch.Error(fm.liveswitch.ErrorCode.ConnectionInvalidArchitecture, ex))) {
                            _this.doClose();
                            _this.setState(fm.liveswitch.ConnectionState.Failed);
                        }
                        promise.reject(ex);
                    }
                });
            };
            WebRtcConnection.prototype.getLocalDescription = function () {
                return this._localDescription;
            };
            WebRtcConnection.prototype.getGatheringState = function () {
                return this._gatheringState;
            };
            WebRtcConnection.prototype.getIceConnectionState = function () {
                return this._iceConnectionState;
            };
            WebRtcConnection.prototype.setGatheringState = function (state) {
                if (this._gatheringState != state) {
                    this._gatheringState = state;
                    if (state == fm.liveswitch.IceGatheringState.Complete) {
                        this.processIceGatheringStateComplete();
                    }
                    this.raiseGatheringStateChange(this);
                }
            };
            WebRtcConnection.prototype.setIceConnectionState = function (state) {
                if (this._iceConnectionState != state) {
                    this._iceConnectionState = state;
                    this.raiseIceConnectionStateChange(this);
                }
            };
            WebRtcConnection.prototype.getRemoteDescription = function () {
                return this._remoteDescription;
            };
            /** @hidden */
            WebRtcConnection.prototype.getSessionDescriptionManager = function () {
                return this._sessionDescriptionManager;
            };
            /** @hidden */
            WebRtcConnection.prototype.setSessionDescriptionManager = function (manager) {
                this._sessionDescriptionManager = manager;
            };
            //This method conducts local SDP mangling to ensure that the stream direction is set appropreately.
            WebRtcConnection.prototype.updateLocalDescription = function (localDescription) {
                var msg = localDescription.getSdpMessage();
                //var origin = msg.getOrigin();
                //var sessionVersion = origin.getSessionVersion();
                //origin.setSessionVersion(sessionVersion + 1);
                var mediaDescriptions = msg.getMediaDescriptions();
                var streamDirection = fm.liveswitch.StreamDirection.Inactive;
                var updatedStreamDirection = false;
                if (mediaDescriptions != null) {
                    var mediaIndex = -1;
                    var streams = this.getStreams();
                    for (var _i = 0, mediaDescriptions_2 = mediaDescriptions; _i < mediaDescriptions_2.length; _i++) {
                        var mediaDescription = mediaDescriptions_2[_i];
                        mediaIndex++;
                        if (fm.liveswitch.Util.isSafari() && mediaDescription.getRtpMapAttribute('VP8', 90000)) {
                            // temporarily disabling H.264 on Safari until Apple
                            // fixes encoder bug, but only if VP8 is available
                            // https://bugzilla.mozilla.org/show_bug.cgi?id=1492038#c38
                            // https://bugzilla.mozilla.org/show_bug.cgi?id=1492038#c41
                            mediaDescription.purgeFormat('H264');
                        }
                        if (mediaIndex < streams.length) {
                            var stream_1 = streams[mediaIndex];
                            if (stream_1.getType() == fm.liveswitch.StreamType.Audio || stream_1.getType() == fm.liveswitch.StreamType.Video) {
                                var mediaStream = stream_1;
                                var usedRtpStreamIds = [];
                                var midAttribute = mediaDescription.getMediaStreamIdentifierAttribute();
                                if (midAttribute) {
                                    mediaStream.setMediaStreamIdentification(midAttribute.getIdentificationTag());
                                }
                                // simulcast send restrictions
                                var ridAttributes = mediaDescription.getRidAttributes();
                                if (ridAttributes && ridAttributes.length > 0) {
                                    var sendEncodings = mediaStream.getSendEncodingInfos();
                                    if (sendEncodings && sendEncodings.length <= ridAttributes.length) {
                                        for (var i = 0; i < sendEncodings.length; i++) {
                                            ridAttributes[i].setRestrictions(sendEncodings[i].getSdpRidRestrictions());
                                        }
                                    }
                                    for (var _a = 0, ridAttributes_1 = ridAttributes; _a < ridAttributes_1.length; _a++) {
                                        var ridAttribute = ridAttributes_1[_a];
                                        usedRtpStreamIds.push(ridAttribute.getId());
                                    }
                                }
                                else if (stream_1.getType() == fm.liveswitch.StreamType.Video) {
                                    var sourceEncoding = mediaStream.getSourceEncoding();
                                    if (sourceEncoding) {
                                        var ssrcAttributes = mediaDescription.getSsrcAttributes(fm.liveswitch.sdp.rtp.SsrcAttributeName.getCName());
                                        if (ssrcAttributes.length > 0) {
                                            sourceEncoding.setSynchronizationSource(ssrcAttributes[0].getSynchronizationSource());
                                            for (var _b = 0, _c = sourceEncoding.getSdpSsrcRestrictionAttributes(); _b < _c.length; _b++) {
                                                var ssrcRestrictionAttribute = _c[_b];
                                                mediaDescription.addMediaAttribute(ssrcRestrictionAttribute);
                                            }
                                        }
                                    }
                                }
                                // there are significant issues w/ VP9 simulcast
                                if (mediaStream.getSimulcastMode() != fm.liveswitch.SimulcastMode.Disabled) {
                                    var sendEncodings = mediaStream.getSendEncodingInfos();
                                    if (sendEncodings.length > 1) {
                                        mediaDescription.purgeFormat('VP9');
                                    }
                                }
                                // receive restrictions
                                var remoteEncoding = mediaStream.getRemoteEncoding();
                                if (remoteEncoding) {
                                    var remoteRtpStreamIndex = 0;
                                    while (true) {
                                        if (!fm.liveswitch.ArrayExtensions.contains(usedRtpStreamIds, remoteRtpStreamIndex.toString())) {
                                            break;
                                        }
                                        remoteRtpStreamIndex++;
                                    }
                                    var remoteRtpStreamId = remoteRtpStreamIndex.toString();
                                    var ridAttribute = new fm.liveswitch.sdp.rtp.RidAttribute(remoteRtpStreamId, fm.liveswitch.sdp.rtp.RidDirection.getReceive(), remoteEncoding.getSdpRidRestrictions());
                                    mediaDescription.addMediaAttribute(ridAttribute);
                                }
                            }
                        }
                        updatedStreamDirection = false;
                        var media = mediaDescription.getMedia();
                        var mediaType = media.getMediaType();
                        var streamType = fm.liveswitch.sdp.MediaType.toStreamType(mediaType);
                        if (streamType == fm.liveswitch.StreamType.Audio) {
                            var audioStreams = this.getAudioStreams();
                            if (audioStreams != null && audioStreams.length > 0) {
                                var stream_2 = audioStreams[0];
                                streamDirection = stream_2.getDirection();
                                updatedStreamDirection = true;
                                for (var _d = 0, _e = mediaDescription.getBandwidths(); _d < _e.length; _d++) {
                                    var bandwidth = _e[_d];
                                    if (bandwidth.getBandwidthType().toLowerCase() == "tias" ||
                                        bandwidth.getBandwidthType().toLowerCase() == "as") {
                                        mediaDescription.removeBandwidth(bandwidth);
                                        break;
                                    }
                                }
                                if (stream_2.getLocalBandwidth() > 0) {
                                    mediaDescription.addBandwidth(new fm.liveswitch.sdp.Bandwidth("TIAS", stream_2.getLocalBandwidth() * 1000));
                                    mediaDescription.addBandwidth(new fm.liveswitch.sdp.Bandwidth("AS", stream_2.getLocalBandwidth()));
                                }
                            }
                        }
                        else if (streamType == fm.liveswitch.StreamType.Video) {
                            var videoStreams = this.getVideoStreams();
                            if (videoStreams != null && videoStreams.length > 0) {
                                var stream = videoStreams[0];
                                streamDirection = stream.getDirection();
                                updatedStreamDirection = true;
                                for (var _f = 0, _g = mediaDescription.getBandwidths(); _f < _g.length; _f++) {
                                    var bandwidth = _g[_f];
                                    if (bandwidth.getBandwidthType().toLowerCase() == "tias" ||
                                        bandwidth.getBandwidthType().toLowerCase() == "as") {
                                        mediaDescription.removeBandwidth(bandwidth);
                                        break;
                                    }
                                }
                                if (stream.getLocalBandwidth() > 0) {
                                    mediaDescription.addBandwidth(new fm.liveswitch.sdp.Bandwidth("TIAS", stream.getLocalBandwidth() * 1000));
                                    mediaDescription.addBandwidth(new fm.liveswitch.sdp.Bandwidth("AS", stream.getLocalBandwidth()));
                                }
                            }
                        }
                        if (updatedStreamDirection) {
                            mediaDescription.setStreamDirection(streamDirection);
                        }
                    }
                }
                return localDescription;
            };
            WebRtcConnection.prototype.doSetLocalDescription = function (promise, localDescription) {
                var _this = this;
                fm.liveswitch.ManagedThread.dispatch(function () {
                    try {
                        if (!_this._initialized) {
                            _this.initialize();
                        }
                        localDescription = _this.updateLocalDescription(localDescription);
                        var error = _this.processDescription(localDescription, true);
                        if (error == null) {
                            var signallingState = _this.getSignallingState();
                            if (signallingState == fm.liveswitch.SignallingState.New) {
                                _this.setSignallingState(fm.liveswitch.SignallingState.HaveLocalOffer);
                            }
                            else if (signallingState == fm.liveswitch.SignallingState.HaveRemoteOffer) {
                                _this.setSignallingState(fm.liveswitch.SignallingState.Stable);
                            }
                            else if (signallingState == fm.liveswitch.SignallingState.Stable) {
                                _this.setSignallingState(fm.liveswitch.SignallingState.HaveLocalOffer);
                            }
                            if (fm.liveswitch.Plugin.hasOrtc()) {
                                _this._ortcLocalDescription = _this.ortcSessionDescriptionFromSessionDescription(localDescription);
                                _this._localDescription = localDescription;
                                if (_this.getRemoteDescription()) {
                                    if (_this.getState() != fm.liveswitch.ConnectionState.Connected) {
                                        _this.setState(fm.liveswitch.ConnectionState.Connecting);
                                        _this.startOrtc();
                                    }
                                }
                                promise.resolve(localDescription);
                            }
                            else {
                                var webrtcSessionDescription = _this.webrtcSessionDescriptionFromSessionDescription(localDescription);
                                var successCallback = function () {
                                    _this._localDescription = localDescription;
                                    if (_this.getRemoteDescription()) {
                                        if (_this.getState() != fm.liveswitch.ConnectionState.Connected) {
                                            _this.setState(fm.liveswitch.ConnectionState.Connecting);
                                        }
                                    }
                                    _this.setNativeDescriptionSuccess(localDescription, promise);
                                    //promise.resolve(localDescription);
                                };
                                var failureCallback = function (ex) {
                                    if (_this.setState(fm.liveswitch.ConnectionState.Failing, new fm.liveswitch.Error(fm.liveswitch.ErrorCode.ConnectionInvalidArchitecture, ex))) {
                                        _this.doClose();
                                        _this.setState(fm.liveswitch.ConnectionState.Failed);
                                    }
                                    promise.reject(ex);
                                };
                                try {
                                    _this._nativePeerConnection.setLocalDescription(webrtcSessionDescription.sessionDescription).then(successCallback, failureCallback);
                                }
                                catch (ex) {
                                    // deprecated API
                                    _this._nativePeerConnection.setLocalDescription(webrtcSessionDescription.sessionDescription, successCallback, failureCallback);
                                }
                            }
                            var canonicalName = _this.getConnectionWideCanonicalName();
                            var streams = _this.getStreams();
                            for (var _i = 0, streams_7 = streams; _i < streams_7.length; _i++) {
                                var stream = streams_7[_i];
                                if (stream.getType() == fm.liveswitch.StreamType.Application) {
                                    stream.setCanonicalName(canonicalName);
                                }
                            }
                        }
                        else {
                            if (_this.setState(fm.liveswitch.ConnectionState.Failing, error)) {
                                _this.doClose();
                                _this.setState(fm.liveswitch.ConnectionState.Failed);
                            }
                            promise.reject(error.getException());
                        }
                    }
                    catch (ex) {
                        if (_this.setState(fm.liveswitch.ConnectionState.Failing, new fm.liveswitch.Error(fm.liveswitch.ErrorCode.ConnectionInvalidArchitecture, ex))) {
                            _this.doClose();
                            _this.setState(fm.liveswitch.ConnectionState.Failed);
                        }
                        promise.reject(ex);
                    }
                });
            };
            WebRtcConnection.prototype.processRemoteDescriptionOnRenegotiation = function (promise, remoteDescription) {
                //Need to update dtls role to ensure no collision occurs:
                if (this._localDescription == null || this._remoteDescription == null) {
                    return;
                }
                //For now just query a local stream to get its role. This should be modified because streams may have varying roles accross connection:
                var localMessage = this._localDescription.getSdpMessage();
                var descriptions = localMessage.getMediaDescriptions();
                var description = descriptions[0];
                var localSetupAttribute = description.getSetupAttribute();
                var localRole = localSetupAttribute.getSetup();
                var remoteRole = fm.liveswitch.sdp.Setup.getPassive();
                var currentRemoteMessage = this._remoteDescription.getSdpMessage();
                fm.liveswitch.Log.info("Current remote description:");
                fm.liveswitch.Log.info(currentRemoteMessage.toString());
                var currentRemoteDescriptions = currentRemoteMessage.getMediaDescriptions();
                if (localRole == fm.liveswitch.sdp.Setup.getActive()) {
                    remoteRole = fm.liveswitch.sdp.Setup.getPassive();
                }
                else if (localRole == fm.liveswitch.sdp.Setup.getPassive()) {
                    remoteRole = fm.liveswitch.sdp.Setup.getActive();
                }
                else {
                    description = currentRemoteDescriptions[0];
                    var remoteSetupAttribute = description.getSetupAttribute();
                    remoteRole = remoteSetupAttribute.getSetup();
                }
                var newRemoteMessage = remoteDescription.getSdpMessage();
                var newRemoteDescriptions = newRemoteMessage.getMediaDescriptions();
                for (var _i = 0, newRemoteDescriptions_1 = newRemoteDescriptions; _i < newRemoteDescriptions_1.length; _i++) {
                    var mediaDescription = newRemoteDescriptions_1[_i];
                    mediaDescription.setSetupAttribute(remoteSetupAttribute);
                }
                newRemoteMessage.updateSetupValue(remoteRole);
                /*for (let mediaDescription of currentRemoteDescriptions) {
                    mediaDescription.updateSetupValue(remoteRole);
                }
                var origin = currentRemoteMessage.getOrigin();
                var version = origin.getSessionVersion();
                origin.setSessionVersion(version + 1);*/
                newRemoteMessage.updateSetupValue(remoteRole);
                this._remoteDescription = remoteDescription;
                //This method hijacks setting remote description by extracting changes from remote description that we support,
                //modifying local description and ignoring any other changes. 
                //Once we figure out a way to process remote descriptions through a call to browser, this should go away.
                //Currently, we only support changes to direction. These changes should have already been set to respectful streams
                //via a call to let error = this.processDescription(remoteDescription, false); The modify _remoteDirection property.
                //As such, we only need to set local description.
                this.doCreateAnswer(promise);
            };
            WebRtcConnection.prototype.removeSdesAttributesIfNeeded = function (remoteDescription) {
                if (remoteDescription.getIsOffer()) {
                    var message = remoteDescription.getSdpMessage();
                    var sessionFingerprint = message.getSessionLevelFingerprintAttribute();
                    var sessionCryptos = message.getSessionLevelCryptoAttributes();
                    var mediaDescriptions = message.getMediaDescriptions();
                    var removeSessionCryptos = false;
                    for (var _i = 0, mediaDescriptions_3 = mediaDescriptions; _i < mediaDescriptions_3.length; _i++) {
                        var mediaDescription = mediaDescriptions_3[_i];
                        var cryptoAttributes = mediaDescription.getCryptoAttributes();
                        var fingerprintAttribute = mediaDescription.getFingerprintAttribute();
                        if (fingerprintAttribute != null || sessionFingerprint != null) {
                            if (cryptoAttributes != null) {
                                for (var _a = 0, cryptoAttributes_1 = cryptoAttributes; _a < cryptoAttributes_1.length; _a++) {
                                    var cryptoAttribute = cryptoAttributes_1[_a];
                                    mediaDescription.removeMediaAttribute(cryptoAttribute);
                                }
                            }
                            removeSessionCryptos = true;
                        }
                    }
                    if (removeSessionCryptos) {
                        if (sessionCryptos != null) {
                            message.removeSessionAttribute(fm.liveswitch.sdp.AttributeType.CryptoAttribute);
                        }
                    }
                }
            };
            WebRtcConnection.prototype.doSetRemoteDescription = function (promise, remoteDescription) {
                var _this = this;
                fm.liveswitch.ManagedThread.dispatch(function () {
                    try {
                        if (!_this._initialized) {
                            _this.initialize();
                        }
                        var error = _this.processDescription(remoteDescription, false);
                        if (error == null) {
                            if (fm.liveswitch.Plugin.hasOrtc()) {
                                _this._ortcRemoteDescription = _this.ortcSessionDescriptionFromSessionDescription(remoteDescription);
                                for (var i = 0; i < _this._ortcRemoteDescription.mediaDescriptions.length; i++) {
                                    var remoteMediaDescription = _this._ortcRemoteDescription.mediaDescriptions[i];
                                    if (!remoteMediaDescription.ssrc) {
                                        remoteMediaDescription.ssrc = 0;
                                    }
                                    if (!remoteMediaDescription.cname) {
                                        remoteMediaDescription.cname = '';
                                    }
                                    if (remoteMediaDescription.candidates.length > 0) {
                                        for (var j = 0; j < remoteMediaDescription.candidates.length; j++) {
                                            if (_this._nativeIceTransports[i].state != "closed") {
                                                _this._nativeIceTransports[i].addRemoteCandidate(remoteMediaDescription.candidates[j]);
                                            }
                                        }
                                    }
                                }
                                // wait briefly before signalling "no more candidates"                        
                                _this.setRemoteCandidatesDoneTimer();
                                _this._remoteDescription = remoteDescription;
                                var signallingState = _this.getSignallingState();
                                if (signallingState == fm.liveswitch.SignallingState.New) {
                                    _this.setSignallingState(fm.liveswitch.SignallingState.HaveRemoteOffer);
                                }
                                else if (signallingState == fm.liveswitch.SignallingState.HaveLocalOffer) {
                                    _this.setSignallingState(fm.liveswitch.SignallingState.Stable);
                                }
                                else if (signallingState == fm.liveswitch.SignallingState.Stable) {
                                    _this.setSignallingState(fm.liveswitch.SignallingState.HaveRemoteOffer);
                                }
                                if (_this.getLocalDescription()) {
                                    if (_this.getState() != fm.liveswitch.ConnectionState.Connected) {
                                        _this.setState(fm.liveswitch.ConnectionState.Connecting);
                                        _this.startOrtc();
                                    }
                                }
                                promise.resolve(remoteDescription);
                            }
                            else {
                                _this._remoteMediaTrackCount = 0;
                                for (var _i = 0, _a = remoteDescription.getSdpMessage().getMediaDescriptions(); _i < _a.length; _i++) {
                                    var sdpMediaDescription = _a[_i];
                                    var direction = sdpMediaDescription.getStreamDirection();
                                    if (sdpMediaDescription.getSsrcAttributes().length > 0 && (direction == fm.liveswitch.StreamDirection.SendReceive || direction == fm.liveswitch.StreamDirection.SendOnly)) {
                                        _this._remoteMediaTrackCount++;
                                    }
                                }
                                if (_this._remoteMediaTrackCount == 0) {
                                    _this._mediaStreamsReady = true; // there won't be any ontrack/onstream events
                                }
                                //If this is a renegotiation, do not proceed with changing direction:
                                //ABB:
                                /*if (this._isRenegotiation)
                                {
                                    this.processRemoteDescriptionOnRenegotiation(promise, remoteDescription);
                                }
                                else
                                {*/
                                _this.removeSdesAttributesIfNeeded(remoteDescription);
                                var webrtcSessionDescription = _this.webrtcSessionDescriptionFromSessionDescription(remoteDescription);
                                var successCallback = function () {
                                    _this._remoteDescription = remoteDescription;
                                    var remoteMedia = _this.getRemoteMedia();
                                    remoteMedia._setMediaStreams(remoteMedia._getAudioMediaStream(), remoteMedia._getVideoMediaStream());
                                    var remoteVideoTrack = remoteMedia.getVideoTrack();
                                    for (var _i = 0, _a = _this.getVideoStreams(); _i < _a.length; _i++) {
                                        var videoStream = _a[_i];
                                        if (videoStream.getRemoteTrack() == null) {
                                            videoStream.setRemoteTrack(remoteVideoTrack);
                                        }
                                    }
                                    var remoteAudioTrack = remoteMedia.getAudioTrack();
                                    for (var _b = 0, _c = _this.getAudioStreams(); _b < _c.length; _b++) {
                                        var audioStream = _c[_b];
                                        if (audioStream.getRemoteTrack() == null) {
                                            audioStream.setRemoteTrack(remoteAudioTrack);
                                        }
                                    }
                                    var signallingState = _this.getSignallingState();
                                    if (signallingState == fm.liveswitch.SignallingState.New) {
                                        _this.setSignallingState(fm.liveswitch.SignallingState.HaveRemoteOffer);
                                    }
                                    else if (signallingState == fm.liveswitch.SignallingState.HaveLocalOffer) {
                                        _this.setSignallingState(fm.liveswitch.SignallingState.Stable);
                                    }
                                    else if (signallingState == fm.liveswitch.SignallingState.Stable) {
                                        _this.setSignallingState(fm.liveswitch.SignallingState.HaveRemoteOffer);
                                    }
                                    if (_this.getSignallingState() == fm.liveswitch.SignallingState.Stable) {
                                        _this._isRenegotiation = true;
                                    }
                                    if (_this.getLocalDescription()) {
                                        if (_this.getState() != fm.liveswitch.ConnectionState.Connected) {
                                            _this.setState(fm.liveswitch.ConnectionState.Connecting);
                                        }
                                    }
                                    promise.resolve(remoteDescription);
                                };
                                var failureCallback = function (ex) {
                                    if (_this.setState(fm.liveswitch.ConnectionState.Failing, new fm.liveswitch.Error(fm.liveswitch.ErrorCode.ConnectionInvalidArchitecture, ex))) {
                                        _this.doClose();
                                        _this.setState(fm.liveswitch.ConnectionState.Failed);
                                    }
                                    promise.reject(ex);
                                };
                                try {
                                    _this._nativePeerConnection.setRemoteDescription(webrtcSessionDescription.sessionDescription).then(successCallback, failureCallback);
                                }
                                catch (ex) {
                                    // deprecated API
                                    _this._nativePeerConnection.setRemoteDescription(webrtcSessionDescription.sessionDescription, successCallback, failureCallback);
                                }
                                //} //ABB
                            }
                        }
                        else {
                            if (_this.setState(fm.liveswitch.ConnectionState.Failing, error)) {
                                _this.doClose();
                                _this.setState(fm.liveswitch.ConnectionState.Failed);
                            }
                            promise.reject(error.getException());
                        }
                    }
                    catch (ex) {
                        if (_this.setState(fm.liveswitch.ConnectionState.Failing, new fm.liveswitch.Error(fm.liveswitch.ErrorCode.ConnectionInvalidArchitecture, ex))) {
                            _this.doClose();
                            _this.setState(fm.liveswitch.ConnectionState.Failed);
                        }
                        promise.reject(ex);
                    }
                });
            };
            WebRtcConnection.prototype.doSendCachedLocalCandidates = function () { };
            WebRtcConnection.prototype.startOrtc = function () {
                this._transportsRemaining = this._nativeDtlsTransports.length;
                for (var i = 0; i < this._nativeIceGatherers.length; i++) {
                    this.startOrtcTrack(this._nativeIceGatherers[i], this._nativeIceTransports[i], this._nativeDtlsTransports[i], this._ortcLocalDescription.mediaDescriptions[i], this._ortcRemoteDescription.mediaDescriptions[i]);
                }
                for (var i = 0; i < this._nativeRtpReceivers.length; i++) {
                    var remoteMediaDescription = this._ortcRemoteDescription.mediaDescriptions[i];
                    if (remoteMediaDescription.ssrc > 0 && this._nativeRtpReceivers[i]) {
                        this._nativeRtpReceivers[i].receive({
                            muxId: '',
                            codecs: this.selectCodecs(i),
                            headerExtensions: [],
                            encodings: this.selectEncodings(i, false),
                            rtcp: this.selectRtcp(i, false)
                        });
                    }
                }
                for (var i = 0; i < this._nativeRtpSenders.length; i++) {
                    var localMediaDescription = this._ortcLocalDescription.mediaDescriptions[i];
                    if (localMediaDescription.ssrc > 0 && this._nativeRtpSenders[i]) {
                        this._nativeRtpSenders[i].send({
                            muxId: '',
                            codecs: this.selectCodecs(i),
                            headerExtensions: [],
                            encodings: this.selectEncodings(i, true),
                            rtcp: this.selectRtcp(i, true)
                        });
                    }
                }
                this._remoteMedia._setMediaStream(this._remoteNativeMediaStream);
            };
            WebRtcConnection.prototype.startOrtcTrack = function (iceGatherer, iceTransport, dtlsTransport, localMediaDescription, remoteMediaDescription) {
                var _this = this;
                var iceRole = 'controlling';
                if (localMediaDescription.dtlsParams.role == 'client' ||
                    remoteMediaDescription.dtlsParams.role == 'server') {
                    iceRole = 'controlled';
                }
                iceGatherer.onerror = function (evt) {
                    if (_this.setState(fm.liveswitch.ConnectionState.Failing, new fm.liveswitch.Error(fm.liveswitch.ErrorCode.IceStartError, new fm.liveswitch.Exception('An ICE gatherer error occurred.')))) {
                        _this.doClose();
                        _this.setState(fm.liveswitch.ConnectionState.Failed);
                    }
                };
                dtlsTransport.onerror = function (evt) {
                    if (_this.setState(fm.liveswitch.ConnectionState.Failing, new fm.liveswitch.Error(fm.liveswitch.ErrorCode.DtlsInternalError, new fm.liveswitch.Exception('A DTLS transport error occurred.')))) {
                        _this.doClose();
                        _this.setState(fm.liveswitch.ConnectionState.Failed);
                    }
                };
                iceTransport.onicestatechange = function (evt) {
                    fm.liveswitch.Log.debug('ORTC ICE transport state has changed to ' + iceTransport.state);
                    if (iceTransport.state == "new") {
                        _this.setIceConnectionState(fm.liveswitch.IceConnectionState.New);
                        _this.setGatheringState(fm.liveswitch.IceGatheringState.New);
                    }
                    else if (iceTransport.state == "checking") {
                        _this.setIceConnectionState(fm.liveswitch.IceConnectionState.Checking);
                        _this.setGatheringState(fm.liveswitch.IceGatheringState.Gathering);
                    }
                    else if (iceTransport.state == "connected") {
                        _this.setIceConnectionState(fm.liveswitch.IceConnectionState.Connected);
                    }
                    else if (iceTransport.state == "completed") {
                        _this.setIceConnectionState(fm.liveswitch.IceConnectionState.Completed);
                        _this.setGatheringState(fm.liveswitch.IceGatheringState.Complete);
                    }
                    else if (iceTransport.state == "disconnected") {
                        _this.setIceConnectionState(fm.liveswitch.IceConnectionState.Disconnected);
                    }
                    else if (iceTransport.state == "closed") {
                        _this.setIceConnectionState(fm.liveswitch.IceConnectionState.Closed);
                    }
                };
                dtlsTransport.ondtlsstatechange = function (evt) {
                    fm.liveswitch.Log.debug('ORTC DTLS transport state has changed to ' + dtlsTransport.state);
                    if (dtlsTransport.state == 'connected') {
                        _this._transportsRemaining--;
                        if (_this._transportsRemaining == 0) {
                            _this.setState(fm.liveswitch.ConnectionState.Connected);
                        }
                    }
                };
                iceTransport.start(iceGatherer, remoteMediaDescription.iceParams, iceRole);
                dtlsTransport.start(remoteMediaDescription.dtlsParams);
            };
            WebRtcConnection.prototype.selectCodecs = function (mediaIndex) {
                var localMediaDescription = this._ortcLocalDescription.mediaDescriptions[mediaIndex];
                var remoteMediaDescription = this._ortcRemoteDescription.mediaDescriptions[mediaIndex];
                var selectedCodecs = [];
                for (var _i = 0, _a = localMediaDescription.codecCaps; _i < _a.length; _i++) {
                    var localCodec = _a[_i];
                    for (var _b = 0, _c = remoteMediaDescription.codecCaps; _b < _c.length; _b++) {
                        var remoteCodec = _c[_b];
                        if (localCodec.name.toLowerCase() == remoteCodec.name.toLowerCase() &&
                            localCodec.clockRate == remoteCodec.clockRate &&
                            localCodec.numChannels == remoteCodec.numChannels &&
                            localCodec.preferredPayloadType == remoteCodec.preferredPayloadType) {
                            selectedCodecs.push({
                                name: localCodec.name,
                                payloadType: localCodec.preferredPayloadType,
                                clockRate: localCodec.clockRate,
                                numChannels: localCodec.numChannels,
                                rtcpFeedback: localCodec.rtcpFeedback,
                                parameters: localCodec.parameters
                            });
                            break;
                        }
                    }
                }
                return selectedCodecs;
            };
            WebRtcConnection.prototype.selectEncodings = function (mediaIndex, send) {
                var localMediaDescription = this._ortcLocalDescription.mediaDescriptions[mediaIndex];
                var remoteMediaDescription = this._ortcRemoteDescription.mediaDescriptions[mediaIndex];
                return [{
                        active: true,
                        codecPayloadType: 0,
                        //dependencyEncodingId: undefined,
                        //encodingId: undefined,
                        fec: 0,
                        framerateBias: 0.5,
                        framerateScale: 1,
                        maxBitrate: 2000000,
                        minQuality: 0,
                        priority: 1,
                        resolutionScale: 1,
                        rtx: 0,
                        ssrc: send ? localMediaDescription.ssrc : remoteMediaDescription.ssrc
                    }];
            };
            WebRtcConnection.prototype.selectRtcp = function (mediaIndex, send) {
                var localMediaDescription = this._ortcLocalDescription.mediaDescriptions[mediaIndex];
                var remoteMediaDescription = this._ortcRemoteDescription.mediaDescriptions[mediaIndex];
                return {
                    cname: '',
                    mux: true,
                    reducedSize: false,
                    ssrc: 0
                };
            };
            WebRtcConnection.prototype.doAddRemoteCandidate = function (promise, remoteCandidate) {
                var _this = this;
                fm.liveswitch.ManagedThread.dispatch(function () {
                    try {
                        if (fm.liveswitch.Plugin.hasOrtc()) {
                            if (_this._remoteCandidatesDone) {
                                throw new fm.liveswitch.Exception('Could not add remote candidate. End of candidates has been signalled.');
                            }
                            var ortcCandidate = _this.ortcCandidateFromCandidate(remoteCandidate);
                            if (ortcCandidate.candidate.protocol == fm.liveswitch.sdp.ice.TransportProtocol.getTcp() && !_this._ortcSupportsTcp) {
                                throw new fm.liveswitch.Exception('ORTC does not currently support the TCP protocol.');
                            }
                            if (_this._nativeIceTransports[ortcCandidate.mediaIndex].state != "closed") {
                                _this._nativeIceTransports[ortcCandidate.mediaIndex].addRemoteCandidate(ortcCandidate.candidate);
                            }
                            // wait briefly before signalling "no more candidates"                        
                            _this.setRemoteCandidatesDoneTimer();
                            promise.resolve(remoteCandidate);
                        }
                        else {
                            var successCallback = function () {
                                promise.resolve(remoteCandidate);
                            };
                            var failureCallback = function (ex) {
                                promise.reject(ex);
                            };
                            try {
                                _this._nativePeerConnection.addIceCandidate(_this.webrtcCandidateFromCandidate(remoteCandidate)).then(successCallback, failureCallback);
                            }
                            catch (ex) {
                                // deprecated API
                                _this._nativePeerConnection.addIceCandidate(_this.webrtcCandidateFromCandidate(remoteCandidate), successCallback, failureCallback);
                            }
                        }
                    }
                    catch (ex) {
                        promise.reject(ex);
                    }
                });
            };
            WebRtcConnection.prototype.setRemoteCandidatesDoneTimer = function () {
                var _this = this;
                // wait briefly before signalling "no more candidates"
                if (this._remoteCandidatesTimer) {
                    clearTimeout(this._remoteCandidatesTimer);
                }
                this._remoteCandidatesTimer = setTimeout(function () {
                    if (_this.getState() != fm.liveswitch.ConnectionState.Connected) {
                        for (var i = 0; i < _this._nativeIceTransports.length; i++) {
                            //this._nativeIceTransports[i].addRemoteCandidate(<RTCIceCandidateComplete>{});
                            var iceTransport = _this._nativeIceTransports[i];
                            if (iceTransport.state === "new" && iceTransport.getRemoteCandidates().length > 0) {
                                iceTransport.addRemoteCandidate({});
                            }
                        }
                        _this._remoteCandidatesDone = true;
                    }
                }, 1500); //TODO: this.getEarlyCandidatesTimeout());
            };
            WebRtcConnection.prototype.assignRemoteDescriptionInternal = function (sessionDescription) {
                throw new fm.liveswitch.Exception('assignRemoteDescriptionInternal');
            };
            WebRtcConnection.prototype.close = function () {
                if (this.setState(fm.liveswitch.ConnectionState.Closing)) {
                    this.doClose();
                    this.setState(fm.liveswitch.ConnectionState.Closed);
                    return true;
                }
                return false;
            };
            WebRtcConnection.prototype.doClose = function () {
                if (fm.liveswitch.Plugin.hasOrtc()) {
                    if (this._nativeRtpSenders) {
                        for (var _i = 0, _a = this._nativeRtpSenders; _i < _a.length; _i++) {
                            var rtpSender = _a[_i];
                            try {
                                rtpSender.stop();
                            }
                            catch (ex) { }
                        }
                        this._nativeRtpSenders = [];
                    }
                    if (this._nativeRtpReceivers) {
                        for (var _b = 0, _c = this._nativeRtpReceivers; _b < _c.length; _b++) {
                            var rtpReceiver = _c[_b];
                            try {
                                rtpReceiver.stop();
                            }
                            catch (ex) { }
                        }
                        this._nativeRtpReceivers = [];
                    }
                    if (this._nativeIceTransports) {
                        for (var _d = 0, _e = this._nativeIceTransports; _d < _e.length; _d++) {
                            var iceTransport = _e[_d];
                            try {
                                iceTransport.stop();
                            }
                            catch (ex) { }
                        }
                        this._nativeIceTransports = [];
                    }
                    if (this._nativeDtlsTransports) {
                        for (var _f = 0, _g = this._nativeDtlsTransports; _f < _g.length; _f++) {
                            var dtlsTransport = _g[_f];
                            try {
                                dtlsTransport.stop();
                            }
                            catch (ex) { }
                        }
                        this._nativeDtlsTransports = [];
                    }
                }
                else {
                    if (this._nativePeerConnection) {
                        try {
                            this._nativePeerConnection.close();
                        }
                        catch (ex) { }
                    }
                }
            };
            WebRtcConnection.prototype.getDtmfSender = function () {
                if (!this.dtmfSender) {
                    if (fm.liveswitch.Plugin.hasOrtc()) {
                        if (!this._nativeRtpSenders) {
                            return null;
                        }
                        var senders = this._nativeRtpSenders;
                        var audioSender = null;
                        for (var _i = 0, senders_1 = senders; _i < senders_1.length; _i++) {
                            var sender = senders_1[_i];
                            if (sender.track && sender.track.kind == 'audio') {
                                audioSender = sender;
                            }
                        }
                        if (!audioSender) {
                            return null;
                        }
                        this.dtmfSender = new RTCDtmfSender(audioSender);
                    }
                    else {
                        if (!this._nativePeerConnection) {
                            return null;
                        }
                        if (this._nativePeerConnection.createDTMFSender) {
                            var mediaStreams = this._mediaStreams;
                            var audioStream = null;
                            for (var _a = 0, mediaStreams_2 = mediaStreams; _a < mediaStreams_2.length; _a++) {
                                var mediaStream = mediaStreams_2[_a];
                                if (mediaStream.getType() == fm.liveswitch.StreamType.Audio) {
                                    audioStream = mediaStream;
                                }
                            }
                            if (!audioStream) {
                                return null;
                            }
                            var localAudioTrack = audioStream.getLocalTrack();
                            if (!localAudioTrack) {
                                return null;
                            }
                            var nativeAudioTrack = localAudioTrack._getMediaStreamTrack();
                            if (!nativeAudioTrack) {
                                return null;
                            }
                            this.dtmfSender = this._nativePeerConnection.createDTMFSender(nativeAudioTrack);
                        }
                        else {
                            if (!this._nativePeerConnection.getSenders) {
                                return null;
                            }
                            var senders = this._nativePeerConnection.getSenders();
                            var audioSender = null;
                            for (var _b = 0, senders_2 = senders; _b < senders_2.length; _b++) {
                                var sender = senders_2[_b];
                                if (sender.track && sender.track.kind == 'audio') {
                                    audioSender = sender;
                                }
                            }
                            if (!audioSender) {
                                return null;
                            }
                            if (!audioSender.dtmf) {
                                return null;
                            }
                            this.dtmfSender = audioSender.dtmf;
                        }
                    }
                }
                return this.dtmfSender;
            };
            WebRtcConnection.prototype.replaceLocalTrack = function (localTrack, mediaStream) {
                var promise = new fm.liveswitch.Promise();
                try {
                    var mediaStreamIndex = 0;
                    var mediaStreams = this.getMediaStreams();
                    for (var _i = 0, mediaStreams_3 = mediaStreams; _i < mediaStreams_3.length; _i++) {
                        var ms = mediaStreams_3[_i];
                        if (ms == mediaStream) {
                            break;
                        }
                        mediaStreamIndex++;
                    }
                    if (mediaStreamIndex == mediaStreams.length) {
                        throw new fm.liveswitch.Exception('Media stream is not attached to this connection.');
                    }
                    var rtpSender = this.getRtpSender(mediaStreamIndex);
                    if (!rtpSender.replaceTrack) {
                        throw new fm.liveswitch.Exception('Browser does not support replaceTrack.');
                    }
                    rtpSender.replaceTrack(localTrack._getMediaStreamTrack() /*, local media stream*/).then(function () {
                        promise.resolve(null);
                    }, function (ex) {
                        promise.reject(ex);
                    });
                }
                catch (ex) {
                    promise.reject(ex);
                }
                return promise;
            };
            WebRtcConnection.prototype.replaceRemoteTrack = function (remoteTrack, mediaStream) {
                return fm.liveswitch.Promise.rejectNow(new fm.liveswitch.Exception('Replacing the remote track is not supported.'));
            };
            WebRtcConnection.prototype.getRtpSender = function (mediaStreamIndex) {
                var rtpSenders = [];
                if (fm.liveswitch.Plugin.hasOrtc()) {
                    if (!this._nativeRtpSenders) {
                        throw new fm.liveswitch.Exception('ORTC peer connection not initialized.');
                    }
                    rtpSenders = this._nativeRtpSenders;
                }
                else {
                    if (!this._nativePeerConnection) {
                        throw new fm.liveswitch.Exception('WebRTC peer connection not initialized.');
                    }
                    if (!this._nativePeerConnection.getSenders) {
                        throw new fm.liveswitch.Exception('WebRTC browser does not support getSenders.');
                    }
                    rtpSenders = this._nativePeerConnection.getSenders();
                }
                if (mediaStreamIndex >= rtpSenders.length) {
                    throw new fm.liveswitch.Exception('Media stream index exceeds RTP senders count.');
                }
                return rtpSenders[mediaStreamIndex];
            };
            WebRtcConnection.prototype.tryGetRtpSender = function (mediaStreamIndex) {
                var rtpSenders = [];
                if (fm.liveswitch.Plugin.hasOrtc()) {
                    if (!this._nativeRtpSenders) {
                        return null;
                    }
                    rtpSenders = this._nativeRtpSenders;
                }
                else {
                    if (!this._nativePeerConnection) {
                        return null;
                    }
                    if (!this._nativePeerConnection.getSenders) {
                        return null;
                    }
                    rtpSenders = this._nativePeerConnection.getSenders();
                }
                if (mediaStreamIndex >= rtpSenders.length) {
                    return null;
                }
                return rtpSenders[mediaStreamIndex];
            };
            WebRtcConnection.prototype.setMaxSendBitrate = function (bitrate, streamType) {
                var promise = new fm.liveswitch.Promise();
                if (this._processingMaxSendBitrate) {
                    this._setMaxSendBitrateQueue.push({
                        bitrate: bitrate,
                        streamType: streamType,
                        promise: promise
                    });
                    return promise;
                }
                this.doSetMaxSendBitrate(bitrate, streamType, promise);
                return promise;
            };
            WebRtcConnection.prototype.processNextSetMaxSendBitrate = function () {
                if (this._setMaxSendBitrateQueue.length > 0) {
                    var next = this._setMaxSendBitrateQueue[0];
                    this._setMaxSendBitrateQueue.splice(0, 1);
                    this.doSetMaxSendBitrate(next.bitrate, next.streamType, next.promise);
                }
            };
            WebRtcConnection.prototype.doSetMaxSendBitrate = function (bitrate, streamType, promise) {
                var _this = this;
                this._processingMaxSendBitrate = true;
                try {
                    if (!fm.liveswitch.Plugin.hasWebRtc()) {
                        throw new fm.liveswitch.Exception('Browser not supported.');
                    }
                    var nativePeerConnection_1 = this._nativePeerConnection;
                    if (!nativePeerConnection_1) {
                        throw new fm.liveswitch.Exception('No connection.');
                    }
                    var localDescription = this.getLocalDescription();
                    if (!localDescription) {
                        throw new fm.liveswitch.Exception('No local description.');
                    }
                    var remoteDescription = this.getRemoteDescription();
                    if (!remoteDescription) {
                        throw new fm.liveswitch.Exception('No remote description.');
                    }
                    var sdpMessage = remoteDescription.getSdpMessage();
                    if (!this.updateMaxBitrateSdpMessage(bitrate, streamType, sdpMessage)) {
                        throw new fm.liveswitch.Exception('No ' + new fm.liveswitch.StreamTypeWrapper(streamType).toString().toLowerCase() + ' description.');
                    }
                    var nativeLocalDescription_1 = this.webrtcSessionDescriptionFromSessionDescription(localDescription).sessionDescription;
                    var nativeRemoteDescription_1 = this.webrtcSessionDescriptionFromSessionDescription(remoteDescription).sessionDescription;
                    var successCallback_1 = function () {
                        try {
                            promise.resolve(null);
                        }
                        finally {
                            _this._processingMaxSendBitrate = false;
                            _this.processNextSetMaxSendBitrate();
                        }
                    };
                    var failureCallback_1 = function (ex) {
                        try {
                            promise.reject(ex);
                        }
                        finally {
                            _this._processingMaxSendBitrate = false;
                            _this.processNextSetMaxSendBitrate();
                        }
                    };
                    nativePeerConnection_1.createOffer().then(function () {
                        nativePeerConnection_1.setLocalDescription(nativeLocalDescription_1).then(function () {
                            nativePeerConnection_1.setRemoteDescription(nativeRemoteDescription_1).then(successCallback_1, failureCallback_1);
                        }, failureCallback_1);
                    }, failureCallback_1);
                }
                catch (ex) {
                    promise.reject(ex);
                    this._processingMaxSendBitrate = false;
                    this.processNextSetMaxSendBitrate();
                }
            };
            WebRtcConnection.prototype.updateMaxBitrateSdpMessage = function (bitrate, streamType, sdpMessage) {
                if (streamType == fm.liveswitch.StreamType.Audio) {
                    var sdpAudioDescription = sdpMessage.getAudioDescription();
                    if (sdpAudioDescription) {
                        this.updateMaxBitrateSdpMediaDescription(bitrate, sdpAudioDescription);
                        return true;
                    }
                }
                if (streamType == fm.liveswitch.StreamType.Video) {
                    var sdpVideoDescription = sdpMessage.getVideoDescription();
                    if (sdpVideoDescription) {
                        this.updateMaxBitrateSdpMediaDescription(bitrate, sdpVideoDescription);
                        return true;
                    }
                }
                return false;
            };
            WebRtcConnection.prototype.updateMaxBitrateSdpMediaDescription = function (bitrate, sdpMediaDescription) {
                for (var _i = 0, _a = sdpMediaDescription.getBandwidths(); _i < _a.length; _i++) {
                    var bandwidth = _a[_i];
                    if (bandwidth.getBandwidthType().toLowerCase() == "tias" ||
                        bandwidth.getBandwidthType().toLowerCase() == "as") {
                        sdpMediaDescription.removeBandwidth(bandwidth);
                        break;
                    }
                }
                if (bitrate > 0) {
                    sdpMediaDescription.addBandwidth(new fm.liveswitch.sdp.Bandwidth("TIAS", bitrate * 1000));
                    sdpMediaDescription.addBandwidth(new fm.liveswitch.sdp.Bandwidth("AS", bitrate));
                }
            };
            /** @hidden */
            WebRtcConnection.webRtcConnectionInitialize = function () {
                if (!this.__webRtcConnectionInitialized) {
                    window.RTCPeerConnection = window.RTCPeerConnection ||
                        window.webkitRTCPeerConnection ||
                        window.mozRTCPeerConnection ||
                        window.msRTCPeerConnection;
                    window.RTCDataChannel = window.RTCDataChannel ||
                        window.webkitRTCDataChannel ||
                        window.mozRTCDataChannel ||
                        window.msRTCDataChannel;
                    window.RTCSessionDescription = window.RTCSessionDescription ||
                        window.webkitRTCSessionDescription ||
                        window.mozRTCSessionDescription ||
                        window.msRTCPeerConnection;
                    window.RTCIceCandidate = window.RTCIceCandidate ||
                        window.webkitRTCIceCandidate ||
                        window.mozRTCIceCandidate ||
                        window.msRTCIceCandidate;
                }
                fm.liveswitch.WebRtcConnection.__webRtcConnectionInitialized = true;
            };
            /** @hidden */
            WebRtcConnection.__webRtcConnectionInitialized = false;
            return WebRtcConnection;
        }(fm.liveswitch.WebRtcConnectionBase));
        liveswitch.WebRtcConnection = WebRtcConnection;
        fm.liveswitch.WebRtcConnection.webRtcConnectionInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Data channel base properties/methods.
        */
        var WebRtcDataChannelBase = /** @class */ (function (_super) {
            __extends(WebRtcDataChannelBase, _super);
            /**
            Initializes a new instance of the [[fm.liveswitch.dataChannelBase]] class.
            @param label The label.
            @param ordered Whether messages will be delivered in the order they are sent.
            @param subprotocol The subprotocol.
            */
            function WebRtcDataChannelBase(label, ordered, subprotocol) {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 3) {
                    var label_1 = __arguments[0];
                    var ordered_1 = __arguments[1];
                    var subprotocol_1 = __arguments[2];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchWebRtcDataChannelBaseInit();
                    _this.__log = fm.liveswitch.Log.getLogger(new fm.liveswitch.Type('[fm.liveswitch.DataChannel]'));
                    _this.__id = fm.liveswitch.Utility.generateId();
                    _this.__stateLock = new Object();
                    _this.__messagesSent = new fm.liveswitch.AtomicLong();
                    _this.__messagesReceived = new fm.liveswitch.AtomicLong();
                    _this.__bytesSent = new fm.liveswitch.AtomicLong();
                    _this.__bytesReceived = new fm.liveswitch.AtomicLong();
                    _this.setLabel(label_1);
                    _this.setOrdered(ordered_1);
                    _this.setSubprotocol(subprotocol_1);
                    _this.__stateMachine = new fm.liveswitch.DataChannelStateMachine();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            WebRtcDataChannelBase.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcDataChannelBase]' + ',' + _super.prototype.getTypeString.call(this);
            };
            WebRtcDataChannelBase.prototype.fmliveswitchWebRtcDataChannelBaseInit = function () {
                var _this = this;
                this.__onDataReceived = [];
                this.__onDataSent = [];
                this.__onStateChange = [];
                this._onDataReceived = function (p0) { for (var _i = 0, _a = _this.__onDataReceived; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
                this._onDataSent = function (p0) { for (var _i = 0, _a = _this.__onDataSent; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
                this._onStateChange = function (p0) { for (var _i = 0, _a = _this.__onStateChange; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
                this._ordered = false;
            };
            /** @hidden */
            WebRtcDataChannelBase.prototype.addOnDataReceived = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onDataReceived, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcDataChannelBase.prototype.addOnDataSent = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onDataSent, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when the data channel state changes.
            */
            WebRtcDataChannelBase.prototype.addOnStateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onStateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes received.
            */
            WebRtcDataChannelBase.prototype.getBytesReceived = function () {
                if (arguments.length == 0) {
                    return this.__bytesReceived.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes sent.
            */
            WebRtcDataChannelBase.prototype.getBytesSent = function () {
                if (arguments.length == 0) {
                    return this.__bytesSent.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connection identifier.
            */
            WebRtcDataChannelBase.prototype.getConnectionId = function () {
                if (arguments.length == 0) {
                    return this._connectionId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcDataChannelBase.prototype.getGetRemoteConnectionInfo = function () {
                if (arguments.length == 0) {
                    return this._getRemoteConnectionInfo;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the identifier.
            */
            WebRtcDataChannelBase.prototype.getId = function () {
                if (arguments.length == 0) {
                    return this.__id;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the data channel info.
            */
            WebRtcDataChannelBase.prototype.getInfo = function () {
                if (arguments.length == 0) {
                    var info = new fm.liveswitch.DataChannelInfo();
                    info.setId(this.getId());
                    info.setLabel(this.getLabel());
                    info.setOrdered(this.getOrdered());
                    info.setSubprotocol(this.getSubprotocol());
                    return info;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the data channel is currently closed or failed.
            */
            WebRtcDataChannelBase.prototype.getIsTerminated = function () {
                if (arguments.length == 0) {
                    return ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.DataChannelState.Closed)) || (fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.DataChannelState.Failed)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the data channel is currently closing.
            */
            WebRtcDataChannelBase.prototype.getIsTerminating = function () {
                if (arguments.length == 0) {
                    return (fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.DataChannelState.Closing));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the data channel is currently closing, closed, or failed.
            */
            WebRtcDataChannelBase.prototype.getIsTerminatingOrTerminated = function () {
                if (arguments.length == 0) {
                    return (this.getIsTerminating() || this.getIsTerminated());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the label.
            */
            WebRtcDataChannelBase.prototype.getLabel = function () {
                if (arguments.length == 0) {
                    return this._label;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of messages received.
            */
            WebRtcDataChannelBase.prototype.getMessagesReceived = function () {
                if (arguments.length == 0) {
                    return this.__messagesReceived.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of messages sent.
            */
            WebRtcDataChannelBase.prototype.getMessagesSent = function () {
                if (arguments.length == 0) {
                    return this.__messagesSent.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the callback to execute when a message is received.
            */
            WebRtcDataChannelBase.prototype.getOnReceive = function () {
                if (arguments.length == 0) {
                    return this._onReceive;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether messages will be delivered in the order they are sent.
            */
            WebRtcDataChannelBase.prototype.getOrdered = function () {
                if (arguments.length == 0) {
                    return this._ordered;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the state.
            */
            WebRtcDataChannelBase.prototype.getState = function () {
                if (arguments.length == 0) {
                    return this.__stateMachine.getState();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcDataChannelBase.prototype.getStateLock = function () {
                if (arguments.length == 0) {
                    return this.__stateLock;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the stream identifier.
            */
            WebRtcDataChannelBase.prototype.getStreamId = function () {
                if (arguments.length == 0) {
                    return this._streamId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the subprotocol.
            */
            WebRtcDataChannelBase.prototype.getSubprotocol = function () {
                if (arguments.length == 0) {
                    return this._subprotocol;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcDataChannelBase.prototype.logInvalidStateTransition = function (state) {
                if (arguments.length == 1) {
                    if (fm.liveswitch.Log.getIsDebugEnabled()) {
                        fm.liveswitch.Log.debug(fm.liveswitch.StringExtensions.format("Data channel {0} ({1}) state for stream {2} for connection {3} is currently {4}. Cannot transition to {5} state.", [this.getId(), this.getLabel(), this.getStreamId(), this.getConnectionId(), fm.liveswitch.StringExtensions.toLower(new fm.liveswitch.DataChannelStateWrapper(this.getState()).toString()), fm.liveswitch.StringExtensions.toLower(new fm.liveswitch.DataChannelStateWrapper(state).toString())]));
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            WebRtcDataChannelBase.prototype.prepareAndSendMessage = function () {
                if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.DataBuffer]'))) {
                    var buffer = arguments[0];
                    var promise = arguments[1];
                    var length_7 = buffer.getLength();
                    buffer = new fm.liveswitch.DataMessage(buffer).getBytes();
                    this.promisedSendDataBytes(buffer, length_7, promise);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                    var msg = arguments[0];
                    var promise = arguments[1];
                    var length_8 = fm.liveswitch.Utf8.encode(msg).length;
                    var bytes = new fm.liveswitch.DataMessage(msg).getBytes();
                    this.promisedSendDataBytes(bytes, length_8, promise);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a state change.
            */
            WebRtcDataChannelBase.prototype.processStateChange = function () {
                if (arguments.length == 0) {
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a state lock change.
            */
            WebRtcDataChannelBase.prototype.processStateLockChange = function () {
                if (arguments.length == 0) {
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Raises the OnReceive callback with data bytes.
            @param dataBytes The data bytes.
            */
            WebRtcDataChannelBase.prototype.raiseDataBytes = function (dataBytes) {
                if (arguments.length == 1) {
                    var message = fm.liveswitch.DataMessage.parseBytes(dataBytes);
                    if ((!fm.liveswitch.Global.equals(message, null))) {
                        if ((!fm.liveswitch.Global.equals(message.getDataBytes(), null))) {
                            this.registerDataReceived(message.getDataBytes().getLength());
                        }
                        else {
                            this.registerDataReceived(fm.liveswitch.Utf8.encode(message.getDataString()).length);
                        }
                        var args2 = new fm.liveswitch.DataChannelReceiveArgs();
                        args2.setDataString(message.getDataString());
                        args2.setDataBytes(message.getDataBytes());
                        args2.setDataMessage(message);
                        var p = args2;
                        var getRemoteConnectionInfo = this.getGetRemoteConnectionInfo();
                        var remoteConnectionId = message.getRemoteConnectionId();
                        if (((!fm.liveswitch.Global.equals(getRemoteConnectionInfo, null)) && (!fm.liveswitch.Global.equals(remoteConnectionId, null)))) {
                            p.setRemoteConnectionInfo(getRemoteConnectionInfo(remoteConnectionId));
                        }
                        var onReceive = this.getOnReceive();
                        if ((!fm.liveswitch.Global.equals(onReceive, null))) {
                            onReceive(p);
                        }
                    }
                    else {
                        fm.liveswitch.Log.error("DataChannelBase.RaiseDataBytes: Could not parse received bytes as data message.");
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Raises the OnReceive callback with a data string.
            @param dataString The data string.
            */
            WebRtcDataChannelBase.prototype.raiseDataString = function (dataString) {
                if (arguments.length == 1) {
                    this.registerDataReceived(fm.liveswitch.Utf8.encode(dataString).length);
                    this.__log.error(fm.liveswitch.StringExtensions.format("Discarding unexpected string on data channel with label '{0}' for connection with ID '{1}': {2}.", this.getLabel(), this.getConnectionId(), dataString));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcDataChannelBase.prototype.raiseStateChange = function () {
                if (arguments.length == 0) {
                    var onStateChange = this._onStateChange;
                    if ((!fm.liveswitch.Global.equals(onStateChange, null))) {
                        try {
                            onStateChange(this.getInstance());
                        }
                        catch (exception) {
                            fm.liveswitch.Log.error(fm.liveswitch.StringExtensions.format("Exception occurred while raising state change to the application code for data stream {0}.", this.getId()), exception);
                        }
                        finally {
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Registers that a data has been sent.
            @param dataLength The data length.
            */
            WebRtcDataChannelBase.prototype.registerDataReceived = function (dataLength) {
                if (arguments.length == 1) {
                    var onDataReceived = this._onDataReceived;
                    if ((!fm.liveswitch.Global.equals(onDataReceived, null))) {
                        onDataReceived(dataLength);
                    }
                    this.__messagesReceived.increment();
                    this.__bytesReceived.add(dataLength);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Registers that a data has been sent.
            @param dataLength The data length.
            */
            WebRtcDataChannelBase.prototype.registerDataSent = function (dataLength) {
                if (arguments.length == 1) {
                    var onDataSent = this._onDataSent;
                    if ((!fm.liveswitch.Global.equals(onDataSent, null))) {
                        onDataSent(dataLength);
                    }
                    this.__messagesSent.increment();
                    this.__bytesSent.add(dataLength);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcDataChannelBase.prototype.removeOnDataReceived = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onDataReceived, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcDataChannelBase.prototype.removeOnDataSent = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onDataSent, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the data channel state changes.
            */
            WebRtcDataChannelBase.prototype.removeOnStateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onStateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcDataChannelBase.prototype.setConnectionId = function (value) {
                if (arguments.length == 1) {
                    this._connectionId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcDataChannelBase.prototype.setGetRemoteConnectionInfo = function (value) {
                if (arguments.length == 1) {
                    this._getRemoteConnectionInfo = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcDataChannelBase.prototype.setLabel = function (value) {
                if (arguments.length == 1) {
                    this._label = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the callback to execute when a message is received.
            */
            WebRtcDataChannelBase.prototype.setOnReceive = function (value) {
                if (arguments.length == 1) {
                    this._onReceive = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcDataChannelBase.prototype.setOrdered = function (value) {
                if (arguments.length == 1) {
                    this._ordered = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcDataChannelBase.prototype.setState = function (state) {
                if (arguments.length == 1) {
                    if (!this.__stateMachine.transition(state)) {
                        if (((!fm.liveswitch.Global.equals(state, this.getState())) && ((!fm.liveswitch.Global.equals(state, fm.liveswitch.DataChannelState.Closing)) || ((!fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.DataChannelState.Closed)) && (!fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.DataChannelState.Failed)))))) {
                            this.logInvalidStateTransition(state);
                        }
                        return false;
                    }
                    if (fm.liveswitch.Log.getIsInfoEnabled()) {
                        if ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.DataChannelState.Connected))) {
                            fm.liveswitch.Log.info(fm.liveswitch.StringExtensions.format("Data channel {0} ({1} for stream {2} for connection {3} took {4}ms to connect.", [this.getId(), this.getLabel(), this.getStreamId(), this.getConnectionId(), fm.liveswitch.NumberExtensions.toString(this.__stateMachine.getLastStateMillis())]));
                        }
                        fm.liveswitch.Log.info(fm.liveswitch.StringExtensions.format("Setting data channel {0} ({1}) state for stream {2} for connection {3} to {4}.", [this.getId(), this.getLabel(), this.getStreamId(), this.getConnectionId(), fm.liveswitch.StringExtensions.toLower(new fm.liveswitch.DataChannelStateWrapper(this.getState()).toString())]));
                    }
                    this.raiseStateChange();
                    this.processStateChange();
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcDataChannelBase.prototype.setStateLock = function (value) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(this.__stateLock, value))) {
                        this.__stateLock = value;
                        this.processStateLockChange();
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcDataChannelBase.prototype.setStreamId = function (value) {
                if (arguments.length == 1) {
                    this._streamId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcDataChannelBase.prototype.setSubprotocol = function (value) {
                if (arguments.length == 1) {
                    this._subprotocol = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return WebRtcDataChannelBase;
        }(fm.liveswitch.Dynamic));
        liveswitch.WebRtcDataChannelBase = WebRtcDataChannelBase;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="WebRtcDataChannelBase.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var WebRtcDataChannel = /** @class */ (function (_super) {
            __extends(WebRtcDataChannel, _super);
            function WebRtcDataChannel(external, label, ordered, subprotocol) {
                var _this = this;
                if (fm.liveswitch.Util.isNullOrUndefined(ordered)) {
                    ordered = true;
                }
                if (fm.liveswitch.Util.isNullOrUndefined(subprotocol)) {
                    subprotocol = '';
                }
                _this = _super.call(this, label, ordered, subprotocol) || this;
                _this._external = external;
                _this.sendQueue = [];
                return _this;
            }
            WebRtcDataChannel.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcDataChannel]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @hidden */
            WebRtcDataChannel.prototype._getExternal = function () {
                return this._external;
            };
            WebRtcDataChannel.prototype.getNativeDataChannel = function () {
                return this._nativeDataChannel;
            };
            WebRtcDataChannel.prototype.setNativeDataChannel = function (nativeDataChannel) {
                var _this = this;
                if (nativeDataChannel != this._nativeDataChannel) {
                    if (this._nativeDataChannel) {
                        this._nativeDataChannel.onmessage = null;
                    }
                    this._nativeDataChannel = nativeDataChannel;
                    if (this._nativeDataChannel) {
                        this._nativeDataChannel.onmessage = function (event) {
                            if (fm.liveswitch.Util.isString(event.data)) {
                                _this.raiseDataString(event.data);
                            }
                            else {
                                _this.raiseDataBytes(fm.liveswitch.DataBuffer.wrap(new Uint8Array(event.data)));
                            }
                        };
                        this.setState(fm.liveswitch.DataChannelState.Connecting);
                        this._nativeDataChannel.onopen = function (event) {
                            _this.setState(fm.liveswitch.DataChannelState.Connected);
                            _this._nativeDataChannel.binaryType = 'arraybuffer';
                            _this.sendQueue.forEach(function (o) {
                                if (o.dataBytes) {
                                    _this._nativeDataChannel.send(o.dataBytes);
                                    _this.registerDataSent(o.dataLength);
                                }
                                else if (o.dataString) {
                                    _this._nativeDataChannel.send(o.dataString);
                                    _this.registerDataSent(o.dataLength);
                                }
                            });
                        };
                        this._nativeDataChannel.onerror = function (event) {
                            _this.setState(fm.liveswitch.DataChannelState.Failed);
                        };
                        this._nativeDataChannel.onclose = function (event) {
                            if (_this.setState(fm.liveswitch.DataChannelState.Closing)) {
                                _this.setState(fm.liveswitch.DataChannelState.Closed);
                            }
                        };
                    }
                }
            };
            WebRtcDataChannel.prototype.getInstance = function () {
                return this;
            };
            WebRtcDataChannel.prototype.sendDataString = function (dataString) {
                var promise = new fm.liveswitch.Promise();
                //this.promisedSendDataString(dataString, promise);
                this.prepareAndSendMessage(dataString, promise);
                return promise;
            };
            /** @hidden */
            WebRtcDataChannel.prototype.promisedSendDataBytes = function (dataBytes, dataLength, promise) {
                var nativeDataChannel = this.getNativeDataChannel();
                if (nativeDataChannel) {
                    var state = nativeDataChannel.readyState;
                    if (state === 'open') {
                        nativeDataChannel.send(dataBytes.toArray());
                        this.registerDataSent(dataLength);
                        promise.resolve(dataBytes);
                    }
                    else if (state == 'connecting') {
                        this.sendQueue.push({
                            dataBytes: dataBytes,
                            dataLength: dataLength
                        });
                        promise.resolve(dataBytes);
                    }
                    else {
                        var errorStr = 'Attempt to communicate on a data channel that is not open or connecting.';
                        fm.liveswitch.Log.debug(errorStr);
                        promise.reject(new fm.liveswitch.Exception(errorStr));
                    }
                }
                else {
                    var errorStr = 'Attempt to communicate on a data channel that has not been prepared.';
                    fm.liveswitch.Log.debug(errorStr);
                    promise.reject(new fm.liveswitch.Exception(errorStr));
                }
            };
            /** @hidden */
            WebRtcDataChannel.prototype.promisedSendDataString = function (dataString, dataLength, promise) {
                var nativeDataChannel = this.getNativeDataChannel();
                if (nativeDataChannel) {
                    var state = nativeDataChannel.readyState;
                    if (state === 'open') {
                        nativeDataChannel.send(dataString);
                        this.registerDataSent(dataLength);
                        promise.resolve(dataString);
                    }
                    else if (state == 'connecting') {
                        this.sendQueue.push({
                            dataString: dataString,
                            dataLength: dataLength
                        });
                        promise.resolve(dataString);
                    }
                    else {
                        var errorStr = 'Attempt to communicate on a data channel that is not open or connecting.';
                        fm.liveswitch.Log.debug(errorStr);
                        promise.reject(new fm.liveswitch.Exception(errorStr));
                    }
                }
                else {
                    var errorStr = 'Attempt to communicate on a data channel that has not been prepared.';
                    fm.liveswitch.Log.debug(errorStr);
                    promise.reject(new fm.liveswitch.Exception(errorStr));
                }
            };
            WebRtcDataChannel.prototype.sendDataBytes = function (dataBytes) {
                var promise = new fm.liveswitch.Promise();
                //this.promisedSendDataBytes(dataBytes, promise);
                this.prepareAndSendMessage(dataBytes, promise);
                return promise;
            };
            return WebRtcDataChannel;
        }(fm.liveswitch.WebRtcDataChannelBase));
        liveswitch.WebRtcDataChannel = WebRtcDataChannel;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="WebRtcStream.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Data stream base properties/methods.
        */
        var WebRtcDataStreamBase = /** @class */ (function (_super) {
            __extends(WebRtcDataStreamBase, _super);
            /**
            Initializes a new instance of the [[fm.liveswitch.dataStreamBase]] class.
            */
            function WebRtcDataStreamBase() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this, fm.liveswitch.StreamType.Application) || this;
                    _this.__messagesSent = new fm.liveswitch.AtomicLong();
                    _this.__messagesReceived = new fm.liveswitch.AtomicLong();
                    _this.__bytesSent = new fm.liveswitch.AtomicLong();
                    _this.__bytesReceived = new fm.liveswitch.AtomicLong();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            WebRtcDataStreamBase.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcDataStreamBase]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Attaches a data channel to this stream (events and IDs).
            @param channel
            */
            WebRtcDataStreamBase.prototype.attachToChannel = function (channel) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(channel.getStreamId(), null))) {
                        channel.setStreamId(_super.prototype.getId.call(this));
                        channel.removeOnDataSent(this.registerDataSent.bind(this));
                        channel.addOnDataSent(this.registerDataSent.bind(this));
                        channel.removeOnDataReceived(this.registerDataReceived.bind(this));
                        channel.addOnDataReceived(this.registerDataReceived.bind(this));
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Changes this stream's direction
            */
            WebRtcDataStreamBase.prototype.changeDirection = function (newDirection) {
                if (arguments.length == 1) {
                    return new fm.liveswitch.Error(fm.liveswitch.ErrorCode.DataStreamDirectionCannotBeChanged, new fm.liveswitch.Exception("Changes to Stream Direction of Data Streams are not permitted."));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes received.
            */
            WebRtcDataStreamBase.prototype.getBytesReceived = function () {
                if (arguments.length == 0) {
                    return this.__bytesReceived.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes sent.
            */
            WebRtcDataStreamBase.prototype.getBytesSent = function () {
                if (arguments.length == 0) {
                    return this.__bytesSent.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the canonical name. Getting the value of DataStream.CanonicalName is deprecated and will be removed in a future release.
            */
            WebRtcDataStreamBase.prototype.getCanonicalName = function () {
                if (arguments.length == 0) {
                    fm.liveswitch.Log.warn("Getting the value of DataStream.CanonicalName is deprecated and will be removed in a future release.");
                    return this.__obsoleteCanonicalName;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the current direction.
            */
            WebRtcDataStreamBase.prototype.getDirection = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StreamDirection.SendReceive;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcDataStreamBase.prototype.getDirectionCapabilities = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StreamDirection.SendReceive;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcDataStreamBase.prototype.getGetRemoteConnectionInfo = function () {
                if (arguments.length == 0) {
                    return this.__getRemoteConnectionInfo;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the data stream info.
            */
            WebRtcDataStreamBase.prototype.getInfo = function () {
                if (arguments.length == 0) {
                    var list = new Array();
                    for (var _i = 0, _a = this.getChannels(); _i < _a.length; _i++) {
                        var local = _a[_i];
                        fm.liveswitch.ArrayExtensions.add(list, local.getInfo());
                    }
                    var info = new fm.liveswitch.DataStreamInfo();
                    info.setId(_super.prototype.getId.call(this));
                    info.setTag(_super.prototype.getTag.call(this));
                    info.setChannels(fm.liveswitch.ArrayExtensions.toArray(list));
                    var report = new fm.liveswitch.DataStreamReport();
                    report.setBytesReceived(this.getBytesReceived());
                    report.setBytesSent(this.getBytesSent());
                    report.setMessagesReceived(this.getMessagesReceived());
                    report.setMessagesSent(this.getMessagesSent());
                    info.setReport(report);
                    return info;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a label that identifies this class.
            */
            WebRtcDataStreamBase.prototype.getLabel = function () {
                if (arguments.length == 0) {
                    return "Data Stream";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the current direction.
            */
            WebRtcDataStreamBase.prototype.getLocalDirection = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StreamDirection.SendReceive;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of messages received.
            */
            WebRtcDataStreamBase.prototype.getMessagesReceived = function () {
                if (arguments.length == 0) {
                    return this.__messagesReceived.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of messages sent.
            */
            WebRtcDataStreamBase.prototype.getMessagesSent = function () {
                if (arguments.length == 0) {
                    return this.__messagesSent.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the current direction.
            */
            WebRtcDataStreamBase.prototype.getRemoteDirection = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StreamDirection.SendReceive;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a state change.
            */
            WebRtcDataStreamBase.prototype.processStateChange = function () {
                if (arguments.length == 0) {
                    _super.prototype.processStateChange.call(this);
                    var channels = this.getChannels();
                    if ((!fm.liveswitch.Global.equals(channels, null))) {
                        for (var _i = 0, channels_1 = channels; _i < channels_1.length; _i++) {
                            var local = channels_1[_i];
                            if ((fm.liveswitch.Global.equals(_super.prototype.getState.call(this), fm.liveswitch.StreamState.Closing))) {
                                local.setState(fm.liveswitch.DataChannelState.Closing);
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(_super.prototype.getState.call(this), fm.liveswitch.StreamState.Closed))) {
                                    local.setState(fm.liveswitch.DataChannelState.Closed);
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(_super.prototype.getState.call(this), fm.liveswitch.StreamState.Failed))) {
                                        local.setState(fm.liveswitch.DataChannelState.Failed);
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a state lock change.
            */
            WebRtcDataStreamBase.prototype.processStateLockChange = function () {
                if (arguments.length == 0) {
                    _super.prototype.processStateLockChange.call(this);
                    var channels = this.getChannels();
                    if ((!fm.liveswitch.Global.equals(channels, null))) {
                        for (var _i = 0, channels_2 = channels; _i < channels_2.length; _i++) {
                            var local = channels_2[_i];
                            this.attachToChannel(local);
                            local.setConnectionId(_super.prototype.getConnectionId.call(this));
                            local.setStateLock(_super.prototype.getStateLock.call(this));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Registers that a data has been received.
            @param dataLength The data length.
            */
            WebRtcDataStreamBase.prototype.registerDataReceived = function (dataLength) {
                if (arguments.length == 1) {
                    this.__messagesReceived.increment();
                    this.__bytesReceived.add(dataLength);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Registers that a data has been received.
            @param dataLength The data length.
            */
            WebRtcDataStreamBase.prototype.registerDataSent = function (dataLength) {
                if (arguments.length == 1) {
                    this.__messagesSent.increment();
                    this.__bytesSent.add(dataLength);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcDataStreamBase.prototype.setCanonicalName = function (canonicalName) {
                if (arguments.length == 1) {
                    this.__obsoleteCanonicalName = canonicalName;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcDataStreamBase.prototype.setGetRemoteConnectionInfo = function (value) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(this.__getRemoteConnectionInfo, value))) {
                        this.__getRemoteConnectionInfo = value;
                        for (var _i = 0, _a = this.getChannels(); _i < _a.length; _i++) {
                            var local = _a[_i];
                            local.setGetRemoteConnectionInfo(value);
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the current direction.
            */
            WebRtcDataStreamBase.prototype.setLocalDirection = function (value) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(value, fm.liveswitch.StreamDirection.SendReceive))) {
                        throw new fm.liveswitch.Exception("Local direction other than SendReceive for DataStreams is not currently supported.");
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcDataStreamBase.prototype.setRemoteDirection = function (value) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(value, fm.liveswitch.StreamDirection.SendReceive))) {
                        throw new fm.liveswitch.Exception("Remote direction other than SendReceive for DataStreams is not currently supported.");
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return WebRtcDataStreamBase;
        }(fm.liveswitch.WebRtcStream));
        liveswitch.WebRtcDataStreamBase = WebRtcDataStreamBase;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="WebRtcDataStreamBase.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var WebRtcDataStream = /** @class */ (function (_super) {
            __extends(WebRtcDataStream, _super);
            function WebRtcDataStream(external, channels) {
                var _this = _super.call(this) || this;
                _this._external = external;
                _this._channels = channels;
                return _this;
            }
            WebRtcDataStream.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcDataStream]' + ',' + _super.prototype.getTypeString.call(this);
            };
            WebRtcDataStream.prototype.processSdpMediaDescription = function (sdpMessage, sdpMediaDescription, index, isLocalDescription, isOffer, isRenegotiation) {
                var manager = this.getMediaDescriptionManager();
                var requirements = new fm.liveswitch.MediaDescriptionRequirements();
                return manager.processSdpMediaDescription(requirements, sdpMessage, index, isLocalDescription, isRenegotiation, isOffer);
            };
            /** @hidden */
            WebRtcDataStream.prototype._getExternal = function () {
                return this._external;
            };
            WebRtcDataStream.prototype.getChannels = function () {
                return this._channels;
            };
            return WebRtcDataStream;
        }(fm.liveswitch.WebRtcDataStreamBase));
        liveswitch.WebRtcDataStream = WebRtcDataStream;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var WebRtcDomAudioSink = /** @class */ (function (_super) {
            __extends(WebRtcDomAudioSink, _super);
            function WebRtcDomAudioSink(external, track) {
                var _this = _super.call(this) || this;
                _this._external = external;
                _this._audio = document.createElement('audio');
                _this._audio.setAttribute('autoplay', 'autoplay');
                _this.setTrack(track);
                return _this;
            }
            WebRtcDomAudioSink.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcDomAudioSink]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            WebRtcDomAudioSink.prototype._getExternal = function () {
                return this._external;
            };
            WebRtcDomAudioSink.prototype.getTrack = function () {
                return this._track;
            };
            WebRtcDomAudioSink.prototype.getLocal = function () {
                return this._local;
            };
            WebRtcDomAudioSink.prototype.getAudio = function () {
                return this._audio;
            };
            WebRtcDomAudioSink.prototype.getVolume = function () {
                return this._audio.volume;
            };
            WebRtcDomAudioSink.prototype.setVolume = function (volume) {
                this._audio.volume = volume;
            };
            WebRtcDomAudioSink.prototype.getMuted = function () {
                return this._audio.muted;
            };
            WebRtcDomAudioSink.prototype.setMuted = function (muted) {
                this._audio.muted = muted;
            };
            WebRtcDomAudioSink.prototype.setTrack = function (track) {
                var _this = this;
                if (!track) {
                    return false;
                }
                this._track = track;
                this._local = fm.liveswitch.Util.isObjectType(track.getMedia(), '[fm.liveswitch.WebRtcLocalMedia]');
                this.setMuted(this.getLocal());
                fm.liveswitch.ManagedThread.dispatch(function () {
                    var nativeMediaStream = track.getMedia()._getAudioMediaStream();
                    try {
                        if (typeof _this._audio.srcObject != 'undefined') {
                            _this._audio.srcObject = nativeMediaStream;
                        }
                        else if (typeof _this._audio.mozSrcObject != 'undefined') {
                            _this._audio.mozSrcObject = nativeMediaStream;
                        }
                        else if (typeof window.attachMediaStream != 'undefined') {
                            window.attachMediaStream(_this._audio, nativeMediaStream);
                        }
                        else {
                            URL = window.URL || window.webkitURL;
                            _this._audio.src = URL.createObjectURL(nativeMediaStream);
                        }
                    }
                    catch (error) {
                        fm.liveswitch.Log.error('Could not attach ' + (_this.getLocal() ? 'local' : 'remote') + ' media stream to audio element.', error);
                    }
                    if (navigator.mozGetUserMedia) {
                        _this.playAudio();
                    }
                });
                return true;
            };
            WebRtcDomAudioSink.prototype.playAudio = function () {
                var _this = this;
                var playPromise = this.getAudio().play();
                if (playPromise !== undefined) {
                    playPromise.then(function () {
                        fm.liveswitch.Log.debug("Audio playback started.");
                    })
                        .catch(function () {
                        setTimeout(function () {
                            _this.getAudio().play().catch(function (error) {
                                fm.liveswitch.Log.error('Audio playback failed to start.', error);
                            });
                        }, 100);
                    });
                }
            };
            return WebRtcDomAudioSink;
        }(fm.liveswitch.Dynamic));
        liveswitch.WebRtcDomAudioSink = WebRtcDomAudioSink;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var WebRtcDomVideoSink = /** @class */ (function (_super) {
            __extends(WebRtcDomVideoSink, _super);
            function WebRtcDomVideoSink(external, track) {
                var _this = _super.call(this) || this;
                _this._external = external;
                _this._container = document.createElement('div');
                _this._container.style.position = 'relative';
                _this._container.style.overflow = 'hidden';
                _this._container.className = 'fm-video';
                _this._video = document.createElement('video');
                _this._video.style.position = 'absolute';
                _this._video.setAttribute('autoplay', 'autoplay');
                _this._video.setAttribute('playsinline', 'playsinline');
                _this._video.setAttribute('webkit-playsinline', 'webkit-playsinline'); // legacy
                _this._video.muted = true;
                _this._video.addEventListener('resize', function (event) {
                    var track = _this.getTrack();
                    if (track) {
                        if (_this._local) {
                            for (var _i = 0, _a = track.getOutputs(); _i < _a.length; _i++) {
                                var videoStream = _a[_i];
                                videoStream.setMaxWidthAndHeight(_this._video.videoWidth, _this._video.videoHeight);
                            }
                        }
                        else {
                            for (var _b = 0, _c = track.getInputs(); _b < _c.length; _b++) {
                                var videoStream = _c[_b];
                                videoStream.setMaxWidthAndHeight(_this._video.videoWidth, _this._video.videoHeight);
                            }
                        }
                    }
                });
                // pausing from DOM removal is auto-reversed
                if (!fm.liveswitch.WebRtcDomVideoSink._observer) {
                    fm.liveswitch.WebRtcDomVideoSink._observer = new MutationObserver(function (mutationList) {
                        mutationList.forEach(function (mutation) {
                            if (mutation.type == 'childList') {
                                mutation.addedNodes.forEach(function (node) {
                                    for (var i = 0; i < fm.liveswitch.WebRtcDomVideoSink._videoSinks.length; i++) {
                                        var sink = fm.liveswitch.WebRtcDomVideoSink._videoSinks[i];
                                        if (node.contains(sink.getVideo())) {
                                            sink.playVideo();
                                        }
                                    }
                                });
                            }
                        });
                    });
                    fm.liveswitch.WebRtcDomVideoSink._observer.observe(document.body, { childList: true, subtree: true });
                }
                fm.liveswitch.WebRtcDomVideoSink._videoSinks.push(_this);
                _this._container.appendChild(_this._video);
                _this.setTrack(track);
                return _this;
            }
            WebRtcDomVideoSink.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcDomVideoSink]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            WebRtcDomVideoSink.prototype._getExternal = function () {
                return this._external;
            };
            WebRtcDomVideoSink.prototype.getTrack = function () {
                return this._track;
            };
            WebRtcDomVideoSink.prototype.getLocal = function () {
                return this._local;
            };
            WebRtcDomVideoSink.prototype.getView = function () {
                return this._container;
            };
            WebRtcDomVideoSink.prototype.getViewScale = function () {
                return this._viewScale;
            };
            WebRtcDomVideoSink.prototype.setViewScale = function (viewScale) {
                this.applyScale(viewScale);
                this._viewScale = viewScale;
            };
            WebRtcDomVideoSink.prototype.getViewMirror = function () {
                return this._viewMirror;
            };
            WebRtcDomVideoSink.prototype.setViewMirror = function (viewMirror) {
                if (viewMirror) {
                    this._container.style.transform = 'scale(-1,1)';
                }
                else {
                    this._container.style.transform = '';
                }
                this._viewMirror = viewMirror;
            };
            WebRtcDomVideoSink.prototype.getVideo = function () {
                return this._video;
            };
            WebRtcDomVideoSink.prototype.getVideoWidth = function () {
                if (this._video) {
                    return this._video.videoWidth;
                }
                return 0;
            };
            WebRtcDomVideoSink.prototype.getVideoHeight = function () {
                if (this._video) {
                    return this._video.videoHeight;
                }
                return 0;
            };
            WebRtcDomVideoSink.prototype.getVolume = function () {
                return this._video.volume;
            };
            WebRtcDomVideoSink.prototype.setVolume = function (volume) {
                this._video.volume = volume;
            };
            WebRtcDomVideoSink.prototype.getMuted = function () {
                return this._video.muted;
            };
            WebRtcDomVideoSink.prototype.setMuted = function (muted) {
                this._video.muted = muted;
            };
            WebRtcDomVideoSink.prototype.destroy = function () {
                var sinkCount = fm.liveswitch.WebRtcDomVideoSink._videoSinks.length;
                if (sinkCount > 0) {
                    while (sinkCount--) {
                        if (fm.liveswitch.WebRtcDomVideoSink._videoSinks[sinkCount] == this) {
                            fm.liveswitch.WebRtcDomVideoSink._videoSinks.splice(sinkCount, 1);
                            break;
                        }
                    }
                    if (fm.liveswitch.WebRtcDomVideoSink._videoSinks.length === 0 && WebRtcDomVideoSink._observer) {
                        fm.liveswitch.WebRtcDomVideoSink._observer.disconnect();
                        fm.liveswitch.WebRtcDomVideoSink._observer = null;
                    }
                }
            };
            WebRtcDomVideoSink.prototype.setTrack = function (track) {
                var _this = this;
                if (!track) {
                    return false;
                }
                this._track = track;
                this._local = fm.liveswitch.Util.isObjectType(this._track.getMedia(), '[fm.liveswitch.WebRtcLocalMedia]');
                if (this._local) {
                    this._container.className = 'fm-video fm-video-local';
                }
                else {
                    this._container.className = 'fm-video fm-video-remote';
                }
                if (this.getLocal()) {
                    var localMedia = this.getTrack().getMedia();
                    var videoConstraints = localMedia.getVideoConstraints();
                    if (localMedia.getScreen()) {
                        this.setViewMirror(false);
                    }
                    else if (videoConstraints) {
                        var facingMode = videoConstraints.facingMode;
                        if (facingMode && facingMode.exact) {
                            facingMode = facingMode.exact;
                        }
                        else if (facingMode && facingMode.ideal) {
                            facingMode = facingMode.ideal;
                        }
                        this.setViewMirror(facingMode == 'user');
                    }
                    else {
                        this.setViewMirror(true);
                    }
                }
                else {
                    this.setViewMirror(false);
                }
                fm.liveswitch.ManagedThread.dispatch(function () {
                    var nativeMediaStream = _this.getTrack().getMedia()._getVideoMediaStream();
                    try {
                        _this._video.audioVolume = 0;
                        _this._video.muted = true;
                    }
                    catch (error) {
                        fm.liveswitch.Log.error('Could not set ' + (_this.getLocal() ? 'local' : 'remote') + ' video element audio volume.', error);
                    }
                    try {
                        if (typeof _this._video.srcObject !== 'undefined') {
                            _this._video.srcObject = nativeMediaStream;
                        }
                        else if (typeof _this._video.mozSrcObject !== 'undefined') {
                            _this._video.mozSrcObject = nativeMediaStream;
                        }
                        else if (typeof window.attachMediaStream !== 'undefined') {
                            var detached = _this._container.parentNode == null;
                            if (detached) {
                                document.body.appendChild(_this._container);
                            }
                            window.attachMediaStream(_this._video, nativeMediaStream);
                            _this._video = _this._container.firstChild;
                            if (detached) {
                                document.body.removeChild(_this._container);
                            }
                        }
                        else {
                            URL = window.URL || window.webkitURL;
                            _this._video.src = URL.createObjectURL(nativeMediaStream);
                        }
                    }
                    catch (error) {
                        fm.liveswitch.Log.error('Could not attach ' + (_this.getLocal() ? 'local' : 'remote') + ' media stream to video element.', error);
                    }
                    _this.playVideo();
                    _this.setViewScale(_this.getViewScale() || fm.liveswitch.LayoutScale.Contain);
                });
                return true;
            };
            WebRtcDomVideoSink.prototype.playVideo = function () {
                var _this = this;
                var playPromise = this.getVideo().play();
                if (playPromise !== undefined) {
                    playPromise.then(function () {
                        fm.liveswitch.Log.debug("Video playback started.");
                    })
                        .catch(function () {
                        setTimeout(function () {
                            try {
                                _this.getVideo().play().catch(function (error) {
                                    fm.liveswitch.Log.error('Video playback failed to start.', error);
                                });
                            }
                            catch (error) {
                                fm.liveswitch.Log.error('Video playback failed to start.', error);
                            }
                        }, 100);
                    });
                }
            };
            WebRtcDomVideoSink.prototype.applyScale = function (scale) {
                var _this = this;
                if (this._video.style.hasOwnProperty('objectFit')) {
                    this._video.style.width = '100%';
                    this._video.style.height = '100%';
                    switch (scale) {
                        case fm.liveswitch.LayoutScale.Contain: {
                            this._video.style.objectFit = 'contain';
                            break;
                        }
                        case fm.liveswitch.LayoutScale.Cover: {
                            this._video.style.objectFit = 'cover';
                            break;
                        }
                        case fm.liveswitch.LayoutScale.Stretch: {
                            this._video.style.objectFit = 'fill';
                            break;
                        }
                    }
                }
                else {
                    switch (scale) {
                        case fm.liveswitch.LayoutScale.Contain: {
                            this._video.style.width = '100%';
                            this._video.style.height = '100%';
                            break;
                        }
                        case fm.liveswitch.LayoutScale.Cover: {
                            this._container.style.display = 'inline-block';
                            this._video.style.left = '-100%';
                            this._video.style.right = '-100%';
                            this._video.style.top = '-100%';
                            this._video.style.bottom = '-100%';
                            this._video.style.margin = 'auto';
                            this._video.style.maxWidth = 'none';
                            this._video.style.maxHeight = 'none';
                            var rescale_1 = function () {
                                var containerWidth = _this._container.clientWidth;
                                var containerHeight = _this._container.clientHeight;
                                var videoWidth = _this._video.clientWidth;
                                var videoHeight = _this._video.clientHeight;
                                if (!videoHeight || videoWidth / videoHeight > containerWidth / containerHeight) {
                                    // wider
                                    _this._video.style.width = 'auto';
                                    _this._video.style.height = '100%';
                                    _this._video.style.maxWidth = 'none';
                                }
                                else {
                                    // taller
                                    _this._video.style.width = '100%';
                                    _this._video.style.height = 'auto';
                                    _this._video.style.maxWidth = 'none';
                                }
                            };
                            fm.liveswitch.Util.observe(this._video, 'loadeddata', function () {
                                rescale_1();
                            });
                            fm.liveswitch.Util.observeAttr(this._container, function (attrName) {
                                if (attrName == 'width' || attrName == 'height' || attrName == 'style') {
                                    rescale_1();
                                }
                            });
                            rescale_1();
                            break;
                        }
                        case fm.liveswitch.LayoutScale.Stretch: {
                            this._video.style.transformOrigin = '0px 0px';
                            var lastContainerWidth_1 = 0;
                            var lastContainerHeight_1 = 0;
                            var lastVideoWidth_1 = 0;
                            var lastVideoHeight_1 = 0;
                            var rescale_2 = function () {
                                var containerWidth = _this._container.clientWidth;
                                var containerHeight = _this._container.clientHeight;
                                var videoWidth = _this._video.clientWidth;
                                var videoHeight = _this._video.clientHeight;
                                if (containerWidth != lastContainerWidth_1 || containerHeight != lastContainerHeight_1 || videoWidth != lastVideoWidth_1 || videoHeight != lastVideoHeight_1) {
                                    if (videoWidth && videoHeight) {
                                        _this._video.style.transform = 'scale(' + (containerWidth / videoWidth) + ', ' + (containerHeight / videoHeight) + ')';
                                        lastContainerWidth_1 = containerWidth;
                                        lastContainerHeight_1 = containerHeight;
                                        lastVideoWidth_1 = videoWidth;
                                        lastVideoHeight_1 = videoHeight;
                                    }
                                }
                            };
                            fm.liveswitch.Util.observe(this._video, 'loadeddata', function () {
                                rescale_2();
                            });
                            fm.liveswitch.Util.observeAttr(this._container, function (attrName) {
                                if (attrName == 'width' || attrName == 'height' || attrName == 'style') {
                                    rescale_2();
                                }
                            });
                            rescale_2();
                            break;
                        }
                    }
                }
            };
            /** @internal */
            WebRtcDomVideoSink._videoSinks = [];
            return WebRtcDomVideoSink;
        }(fm.liveswitch.Dynamic));
        liveswitch.WebRtcDomVideoSink = WebRtcDomVideoSink;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A collection of audio/video track base methods/properties.
        */
        var WebRtcMediaBase = /** @class */ (function (_super) {
            __extends(WebRtcMediaBase, _super);
            /**
            Initializes a new instance of the [[fm.liveswitch.mediaBase]] class.
            */
            function WebRtcMediaBase() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.setId(fm.liveswitch.Utility.generateId());
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            WebRtcMediaBase.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcMediaBase]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Gets a value indicating the gain (input amplification) of the first audio track.
            */
            WebRtcMediaBase.prototype.getAudioGain = function () {
                if (arguments.length == 0) {
                    var audioTrack = this.getAudioTrack();
                    if ((!fm.liveswitch.Global.equals(audioTrack, null))) {
                        return audioTrack.getGain();
                    }
                    return 1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the first audio track is muted.
            */
            WebRtcMediaBase.prototype.getAudioMuted = function () {
                if (arguments.length == 0) {
                    var audioTrack = this.getAudioTrack();
                    return ((!fm.liveswitch.Global.equals(audioTrack, null)) && audioTrack.getMuted());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the first audio track.
            */
            WebRtcMediaBase.prototype.getAudioTrack = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Utility.firstOrDefault(this.getAudioTracks());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating the volume (output resistance) of the first audio track.
            */
            WebRtcMediaBase.prototype.getAudioVolume = function () {
                if (arguments.length == 0) {
                    var audioTrack = this.getAudioTrack();
                    if ((!fm.liveswitch.Global.equals(audioTrack, null))) {
                        return audioTrack.getVolume();
                    }
                    return 1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the identifier.
            */
            WebRtcMediaBase.prototype.getId = function () {
                if (arguments.length == 0) {
                    return this._id;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the first video track is muted.
            */
            WebRtcMediaBase.prototype.getVideoMuted = function () {
                if (arguments.length == 0) {
                    var videoTrack = this.getVideoTrack();
                    return ((!fm.liveswitch.Global.equals(videoTrack, null)) && videoTrack.getMuted());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the first video track.
            */
            WebRtcMediaBase.prototype.getVideoTrack = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Utility.firstOrDefault(this.getVideoTracks());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a value indicating the gain (input amplification) of the first audio track.
            */
            WebRtcMediaBase.prototype.setAudioGain = function (value) {
                if (arguments.length == 1) {
                    var audioTrack = this.getAudioTrack();
                    if ((!fm.liveswitch.Global.equals(audioTrack, null))) {
                        audioTrack.setGain(value);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a value indicating whether the first audio track is muted.
            */
            WebRtcMediaBase.prototype.setAudioMuted = function (value) {
                if (arguments.length == 1) {
                    var audioTrack = this.getAudioTrack();
                    if ((!fm.liveswitch.Global.equals(audioTrack, null))) {
                        audioTrack.setMuted(value);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a value indicating the volume (output resistance) of the first audio track.
            */
            WebRtcMediaBase.prototype.setAudioVolume = function (value) {
                if (arguments.length == 1) {
                    var audioTrack = this.getAudioTrack();
                    if ((!fm.liveswitch.Global.equals(audioTrack, null))) {
                        audioTrack.setVolume(value);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the identifier.
            */
            WebRtcMediaBase.prototype.setId = function (value) {
                if (arguments.length == 1) {
                    this._id = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a value indicating whether the first video track is muted.
            */
            WebRtcMediaBase.prototype.setVideoMuted = function (value) {
                if (arguments.length == 1) {
                    var videoTrack = this.getVideoTrack();
                    if ((!fm.liveswitch.Global.equals(videoTrack, null))) {
                        videoTrack.setMuted(value);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return WebRtcMediaBase;
        }(fm.liveswitch.Dynamic));
        liveswitch.WebRtcMediaBase = WebRtcMediaBase;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var WebRtcMedia = /** @class */ (function (_super) {
            __extends(WebRtcMedia, _super);
            function WebRtcMedia(external) {
                var _this = _super.call(this) || this;
                /** @internal */
                _this._audioMediaStream = null;
                /** @internal */
                _this._videoMediaStream = null;
                /** @internal */
                _this._audioTrack = null;
                /** @internal */
                _this._videoTrack = null;
                /** @internal */
                _this._audioSink = null;
                /** @internal */
                _this._videoSink = null;
                /** @internal */
                _this._onAudioLevelValues = [];
                /** @internal */
                _this._onVideoSizeValues = [];
                /** @internal */
                _this._onAudioDestroyedValues = [];
                /** @internal */
                _this._onVideoDestroyedValues = [];
                var externalAudioTrack = new fm.liveswitch.AudioTrack(external, _this);
                var externalVideoTrack = new fm.liveswitch.VideoTrack(external, _this);
                var externalAudioSink = new fm.liveswitch.DomAudioSink(null); // set later
                var externalVideoSink = new fm.liveswitch.DomVideoSink(null); // set later
                _this._audioTrack = externalAudioTrack._getInternal();
                _this._videoTrack = externalVideoTrack._getInternal();
                _this._audioSink = externalAudioSink._getInternal();
                _this._videoSink = externalVideoSink._getInternal();
                _this._audioTrack.addOnDestroyed(function () {
                    for (var _i = 0, _a = _this._onAudioDestroyedValues; _i < _a.length; _i++) {
                        var value = _a[_i];
                        value();
                    }
                });
                _this._videoTrack.addOnDestroyed(function () {
                    _this._videoSink.destroy();
                    for (var _i = 0, _a = _this._onVideoDestroyedValues; _i < _a.length; _i++) {
                        var value = _a[_i];
                        value();
                    }
                });
                return _this;
            }
            WebRtcMedia.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcMedia]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            WebRtcMedia.prototype._getAudioMediaStream = function () {
                return this._audioMediaStream;
            };
            /** @internal */
            WebRtcMedia.prototype._getVideoMediaStream = function () {
                return this._videoMediaStream;
            };
            WebRtcMedia.prototype._setAudioMediaStream = function (audioMediaStream) {
                if (audioMediaStream == this._audioMediaStream) {
                    return false;
                }
                this._audioMediaStream = audioMediaStream;
                if (audioMediaStream) {
                    var hasAudio = (audioMediaStream.getAudioTracks().length > 0);
                    if (hasAudio) {
                        this._audioTrack._setMediaStreamTrack(audioMediaStream.getAudioTracks()[0]);
                        this._audioSink.setTrack(this._audioTrack);
                        this.initializeAudioContext(); // initialize audio context (if events are present)
                    }
                    else {
                        this._audioTrack._setMediaStreamTrack(null);
                        this.destroyAudioContext(); // destroy audio context (even if events are present)
                    }
                }
                else {
                    this._audioTrack._setMediaStreamTrack(null);
                    this.destroyAudioContext(); // destroy audio context (even if events are present)
                }
                return true;
            };
            WebRtcMedia.prototype._setVideoMediaStream = function (videoMediaStream) {
                if (videoMediaStream == this._videoMediaStream) {
                    return false;
                }
                this._videoMediaStream = videoMediaStream;
                if (videoMediaStream) {
                    var hasVideo = (videoMediaStream.getVideoTracks().length > 0);
                    if (hasVideo) {
                        this._videoTrack._setMediaStreamTrack(videoMediaStream.getVideoTracks()[0]);
                        this._videoSink.setTrack(this._videoTrack);
                    }
                    else {
                        this._videoTrack._setMediaStreamTrack(null);
                    }
                }
                else {
                    this._videoTrack._setMediaStreamTrack(null);
                }
                return true;
            };
            /** @internal */
            WebRtcMedia.prototype._setMediaStreams = function (audioMediaStream, videoMediaStream) {
                this._setAudioMediaStream(audioMediaStream);
                this._setVideoMediaStream(videoMediaStream);
            };
            /** @internal */
            WebRtcMedia.prototype._setMediaStream = function (mediaStream) {
                this._setMediaStreams(mediaStream, mediaStream);
            };
            WebRtcMedia.prototype.getAudio = function () {
                return this._audio;
            };
            WebRtcMedia.prototype.setAudio = function (audio) {
                this._audio = audio;
            };
            WebRtcMedia.prototype.getVideo = function () {
                return this._video;
            };
            WebRtcMedia.prototype.setVideo = function (video) {
                this._video = video;
            };
            WebRtcMedia.prototype.addOnAudioDestroyed = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onAudioDestroyedValues, value);
            };
            WebRtcMedia.prototype.addOnVideoDestroyed = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onVideoDestroyedValues, value);
            };
            WebRtcMedia.prototype.removeOnAudioDestroyed = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onAudioDestroyedValues, value);
            };
            WebRtcMedia.prototype.removeOnVideoDestroyed = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onVideoDestroyedValues, value);
            };
            WebRtcMedia.prototype.addOnAudioLevel = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onAudioLevelValues, value);
                this.initializeAudioContext(); // initialize audio context (if there is one)
            };
            WebRtcMedia.prototype.addOnVideoSize = function (value) {
                var _this = this;
                fm.liveswitch.ArrayExtensions.add(this._onVideoSizeValues, value);
                var video = this._videoSink.getVideo();
                if (video && !this._videoSizeEventsAttached) {
                    try {
                        fm.liveswitch.Util.observe(video, 'loadedmetadata', function (evt) {
                            for (var _i = 0, _a = _this._onVideoSizeValues; _i < _a.length; _i++) {
                                var onVideoSizeValue = _a[_i];
                                onVideoSizeValue(new fm.liveswitch.Size(video.videoWidth, video.videoHeight));
                            }
                        });
                        fm.liveswitch.Util.observe(video, 'timeupdate', function (evt) {
                            for (var _i = 0, _a = _this._onVideoSizeValues; _i < _a.length; _i++) {
                                var onVideoSizeValue = _a[_i];
                                onVideoSizeValue(new fm.liveswitch.Size(video.videoWidth, video.videoHeight));
                            }
                        });
                    }
                    catch (ex) {
                        fm.liveswitch.Log.error('Could not initialize AudioContext.', ex);
                    }
                }
            };
            WebRtcMedia.prototype.destroy = function () {
                this._audioTrack.destroy();
                this._videoTrack.destroy();
            };
            WebRtcMedia.prototype.getAudioGain = function () {
                //TODO: don't rely on volume here
                return this.getAudioVolume();
            };
            WebRtcMedia.prototype.getAudioTracks = function () {
                if (!this._audio || this._audioTrack._getMediaStreamTrackDisabled()) {
                    return [];
                }
                return [this._audioTrack];
            };
            WebRtcMedia.prototype.getAudioVolume = function () {
                if (this._audioSink.getTrack()) {
                    return this._audioSink.getVolume();
                }
                if (this._videoSink.getTrack()) {
                    return this._videoSink.getVolume();
                }
                return 1.0;
            };
            WebRtcMedia.prototype.getVideoSize = function () {
                return new fm.liveswitch.Size(this._videoSink.getVideoWidth(), this._videoSink.getVideoHeight());
            };
            WebRtcMedia.prototype.getVideoTracks = function () {
                if (!this._video || this._videoTrack._getMediaStreamTrackDisabled()) {
                    return [];
                }
                return [this._videoTrack];
            };
            WebRtcMedia.prototype.getAudioSink = function () {
                if (!this._audio) {
                    return null;
                }
                return this._audioSink;
            };
            WebRtcMedia.prototype.getVideoSink = function () {
                if (!this._video) {
                    return null;
                }
                return this._videoSink;
            };
            WebRtcMedia.prototype.getView = function () {
                if (!this._video) {
                    return null;
                }
                return this._videoSink.getView();
            };
            WebRtcMedia.prototype.getViewSink = function () {
                if (!this._video) {
                    return null;
                }
                return this._videoSink;
            };
            WebRtcMedia.prototype.grabVideoFrame = function () {
                var promise = new fm.liveswitch.Promise();
                var video = this._videoSink.getVideo();
                if (video && video.videoWidth && video.videoHeight) {
                    var width = video.videoWidth;
                    var height = video.videoHeight;
                    var canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    var context = canvas.getContext('2d');
                    context.drawImage(video, 0, 0, width, height);
                    var image = context.getImageData(0, 0, width, height);
                    var data = new Uint8Array(image.data.buffer);
                    promise.resolve(new fm.liveswitch.VideoBuffer(width, height, fm.liveswitch.DataBuffer.wrap(data), fm.liveswitch.VideoFormat.getRgba()));
                }
                else {
                    promise.reject(new fm.liveswitch.Exception('No video to grab.'));
                }
                return promise;
            };
            WebRtcMedia.prototype.removeOnAudioLevel = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onAudioLevelValues, value);
                if (this._onAudioLevelValues.length == 0) { // destroy audio context, if there is one
                    this.destroyAudioContext();
                }
            };
            WebRtcMedia.prototype.removeOnVideoSize = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onVideoSizeValues, value);
            };
            WebRtcMedia.prototype.setAudioGain = function (value) {
                //TODO: don't rely on volume here
                this.setAudioVolume(value);
            };
            WebRtcMedia.prototype.setAudioVolume = function (value) {
                if (this._audioSink.getTrack()) {
                    this._audioSink.setVolume(value);
                }
                if (this._videoSink.getTrack()) {
                    this._videoSink.setVolume(value);
                }
            };
            WebRtcMedia.prototype.initializeAudioContext = function () {
                var _this = this;
                if (this._audioMediaStream && !this._audioContext && this._onAudioLevelValues.length > 0) {
                    try {
                        var audioTracks = this._audioMediaStream.getAudioTracks();
                        if (audioTracks && audioTracks.length > 0) {
                            if (this._audioContext == null && typeof AudioContext !== 'undefined') {
                                this._audioContext = new AudioContext();
                            }
                            if (this._audioContext == null && typeof window.webkitAudioContext !== 'undefined') {
                                this._audioContext = new window.webkitAudioContext();
                            }
                            if (this._audioContext != null) {
                                this._audioMicrophone = this._audioContext.createMediaStreamSource(this._audioMediaStream);
                                this._audioAnalyser = this._audioContext.createAnalyser();
                                this._audioScriptNode = this._audioContext.createScriptProcessor(2048, 1, 1);
                                this._audioMicrophone.connect(this._audioAnalyser);
                                this._audioAnalyser.connect(this._audioScriptNode);
                                this._audioScriptNode.connect(this._audioContext.destination);
                                this._audioScriptNode.onaudioprocess = function (event) {
                                    var input = event.inputBuffer.getChannelData(0);
                                    var sum = 0.0;
                                    for (var i = 0; i < input.length; i++) {
                                        sum += input[i] * input[i];
                                    }
                                    var level = Math.sqrt(sum / input.length);
                                    for (var _i = 0, _a = _this._onAudioLevelValues; _i < _a.length; _i++) {
                                        var onAudioLevelValue = _a[_i];
                                        onAudioLevelValue(level);
                                    }
                                };
                            }
                            for (var _i = 0, audioTracks_1 = audioTracks; _i < audioTracks_1.length; _i++) {
                                var audioTrack = audioTracks_1[_i];
                                audioTrack.onended = function (event) {
                                    _this.destroyAudioContext(); // destroy audio context (even if events are present)
                                };
                            }
                        }
                    }
                    catch (ex) {
                        fm.liveswitch.Log.error('Could not initialize AudioContext.', ex);
                    }
                }
            };
            WebRtcMedia.prototype.destroyAudioContext = function () {
                try {
                    if (this._audioContext) {
                        if (this._audioMicrophone) {
                            this._audioMicrophone.disconnect(this._audioAnalyser);
                            this._audioMicrophone = null;
                        }
                        if (this._audioAnalyser) {
                            this._audioAnalyser.disconnect(this._audioScriptNode);
                            this._audioAnalyser = null;
                        }
                        if (this._audioScriptNode) {
                            this._audioScriptNode.disconnect(this._audioContext.destination);
                            this._audioScriptNode = null;
                        }
                        this._audioContext.close();
                        this._audioContext = null;
                    }
                }
                catch (ex) {
                    fm.liveswitch.Log.error('Could not destroy AudioContext.', ex);
                }
            };
            return WebRtcMedia;
        }(fm.liveswitch.WebRtcMediaBase));
        liveswitch.WebRtcMedia = WebRtcMedia;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="WebRtcMedia.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A collection of local audio/video track base methods.
        */
        var WebRtcLocalMediaBase = /** @class */ (function (_super) {
            __extends(WebRtcLocalMediaBase, _super);
            /**
            Initializes a new instance of the [[fm.liveswitch.localMediaBase]] class.
            @param external The external.
            */
            function WebRtcLocalMediaBase(external) {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var external_1 = __arguments[0];
                    _this = _super.call(this, external_1) || this;
                    _this.fmliveswitchWebRtcLocalMediaBaseInit();
                    _this.__audioEncodingsSetLock = new Object();
                    _this.__videoEncodingsSetLock = new Object();
                    _this.__audioEncodingsSet = false;
                    _this.__videoEncodingsSet = false;
                    _this.__stateLock = new Object();
                    _this.setState(fm.liveswitch.LocalMediaState.New);
                    _this.initializeSimulcastConfigs();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            WebRtcLocalMediaBase.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcLocalMediaBase]' + ',' + _super.prototype.getTypeString.call(this);
            };
            WebRtcLocalMediaBase.prototype.fmliveswitchWebRtcLocalMediaBaseInit = function () {
                this.__audioEncodingsSet = false;
                this.__videoEncodingsSet = false;
            };
            /**
            Aborts the start.
            @param promise The promise.
            @param exception The exception.
            */
            WebRtcLocalMediaBase.prototype.abortStart = function (promise, exception) {
                var _this = this;
                if (arguments.length == 2) {
                    fm.liveswitch.Log.debug(fm.liveswitch.StringExtensions.format("Local media failed to start and is in a partial state. Stopping...", new Array(0)));
                    this.doStop().then(function (result) {
                        fm.liveswitch.Log.debug(fm.liveswitch.StringExtensions.format("Local media has successfully stopped.", new Array(0)));
                        _this.setState(fm.liveswitch.LocalMediaState.Stopped);
                        promise.reject(exception);
                    }, function (ex) {
                        fm.liveswitch.Log.debug(fm.liveswitch.StringExtensions.format("Local media did not stop successfully.", new Array(0)));
                        _this.setState(fm.liveswitch.LocalMediaState.Stopped);
                        promise.reject(exception);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the first (primary) local audio encoding.
            */
            WebRtcLocalMediaBase.prototype.getAudioEncoding = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Utility.firstOrDefault(this.getAudioEncodings());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the local audio encodings.
            */
            WebRtcLocalMediaBase.prototype.getAudioEncodings = function () {
                if (arguments.length == 0) {
                    return this.doGetAudioEncodings();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether audio simulcast is disabled.
            */
            WebRtcLocalMediaBase.prototype.getAudioSimulcastDisabled = function () {
                if (arguments.length == 0) {
                    return this.__audioSimulcast.getDisabled();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of audio simulcast encodings.
            */
            WebRtcLocalMediaBase.prototype.getAudioSimulcastEncodingCount = function () {
                if (arguments.length == 0) {
                    return this.__audioSimulcast.getEncodingCount();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the preferred audio simulcast bitrate, in kbps.
            */
            WebRtcLocalMediaBase.prototype.getAudioSimulcastPreferredBitrate = function () {
                if (arguments.length == 0) {
                    return this.__audioSimulcast.getPreferredBitrate();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the state.
            */
            WebRtcLocalMediaBase.prototype.getState = function () {
                if (arguments.length == 0) {
                    return this._state;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the first (primary) local video encoding.
            */
            WebRtcLocalMediaBase.prototype.getVideoEncoding = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Utility.firstOrDefault(this.getVideoEncodings());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the local video encodings.
            */
            WebRtcLocalMediaBase.prototype.getVideoEncodings = function () {
                if (arguments.length == 0) {
                    return this.doGetVideoEncodings();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the desired video simulcast bits-per-pixel (bpp). If this value is set and the video source has declared a target width, height, and frame-rate, encoding bitrates will be automatically calculated using this value instad of using preferred bitrate.
            */
            WebRtcLocalMediaBase.prototype.getVideoSimulcastBitsPerPixel = function () {
                if (arguments.length == 0) {
                    return this.__videoSimulcast.getBitsPerPixel();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the video simulcast degradation preference.
            */
            WebRtcLocalMediaBase.prototype.getVideoSimulcastDegradationPreference = function () {
                if (arguments.length == 0) {
                    return this.__videoSimulcast.getDegradationPreference();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether video simulcast is disabled.
            */
            WebRtcLocalMediaBase.prototype.getVideoSimulcastDisabled = function () {
                if (arguments.length == 0) {
                    return this.__videoSimulcast.getDisabled();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of video simulcast encodings.
            */
            WebRtcLocalMediaBase.prototype.getVideoSimulcastEncodingCount = function () {
                if (arguments.length == 0) {
                    return this.__videoSimulcast.getEncodingCount();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the preferred video simulcast bitrate, in kbps.
            */
            WebRtcLocalMediaBase.prototype.getVideoSimulcastPreferredBitrate = function () {
                if (arguments.length == 0) {
                    return this.__videoSimulcast.getPreferredBitrate();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcLocalMediaBase.prototype.initializeSimulcastConfigs = function () {
                if (arguments.length == 0) {
                    var config = new fm.liveswitch.AudioSimulcastConfig(1, 32);
                    config.setDisabled(true);
                    this.__audioSimulcast = config;
                    var config2 = new fm.liveswitch.VideoSimulcastConfig(2, 1024, 0.05);
                    config2.setDisabled(false);
                    this.__videoSimulcast = config2;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Locks the audio encodings in prior to initialization.
            */
            WebRtcLocalMediaBase.prototype.lockAudioEncodings = function () {
                if (arguments.length == 0) {
                    if (((fm.liveswitch.Global.equals(this.getAudioEncodings(), null)) || (fm.liveswitch.Global.equals(this.getAudioEncodings().length, 0)))) {
                        this.setAudioEncodings(this.__audioSimulcast.getEncodingConfigs());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            WebRtcLocalMediaBase.prototype.lockVideoEncodings = function () {
                if (arguments.length == 0) {
                    this.lockVideoEncodings(fm.liveswitch.VideoType.Unknown);
                }
                else if (arguments.length == 1) {
                    var sourceType = arguments[0];
                    this.lockVideoEncodings(sourceType, -1, -1, -1);
                }
                else if (arguments.length == 4) {
                    var sourceType = arguments[0];
                    var sourceWidth = arguments[1];
                    var sourceHeight = arguments[2];
                    var sourceFrameRate = arguments[3];
                    if (((fm.liveswitch.Global.equals(this.getVideoEncodings(), null)) || (fm.liveswitch.Global.equals(this.getVideoEncodings().length, 0)))) {
                        this.setVideoEncodings(this.__videoSimulcast.getEncodingConfigs(sourceType, sourceWidth, sourceHeight, sourceFrameRate));
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the local audio encodings.
            */
            WebRtcLocalMediaBase.prototype.setAudioEncodings = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(value, null))) {
                        value = [new fm.liveswitch.AudioEncodingConfig()];
                    }
                    if ((fm.liveswitch.Global.equals(value.length, 0))) {
                        throw new fm.liveswitch.Exception("Audio encodings cannot be empty.");
                    }
                    var audioEncodings = this.getAudioEncodings();
                    if (((this.__audioEncodingsSet && (!fm.liveswitch.Global.equals(audioEncodings, null))) && (!fm.liveswitch.Global.equals(audioEncodings.length, value.length)))) {
                        throw new fm.liveswitch.Exception("The number of audio encodings cannot be changed once set.");
                    }
                    this.__audioEncodingsSet = true;
                    this.doSetAudioEncodings(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether audio simulcast is disabled.
            */
            WebRtcLocalMediaBase.prototype.setAudioSimulcastDisabled = function (value) {
                if (arguments.length == 1) {
                    this.__audioSimulcast.setDisabled(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of audio simulcast encodings.
            */
            WebRtcLocalMediaBase.prototype.setAudioSimulcastEncodingCount = function (value) {
                if (arguments.length == 1) {
                    this.__audioSimulcast.setEncodingCount(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the preferred audio simulcast bitrate, in kbps.
            */
            WebRtcLocalMediaBase.prototype.setAudioSimulcastPreferredBitrate = function (value) {
                if (arguments.length == 1) {
                    this.__audioSimulcast.setPreferredBitrate(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcLocalMediaBase.prototype.setState = function (value) {
                if (arguments.length == 1) {
                    this._state = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the local video encodings.
            */
            WebRtcLocalMediaBase.prototype.setVideoEncodings = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(value, null))) {
                        throw new fm.liveswitch.Exception("Video encodings cannot be null.");
                    }
                    if ((fm.liveswitch.Global.equals(value.length, 0))) {
                        throw new fm.liveswitch.Exception("Video encodings cannot be empty.");
                    }
                    var videoEncodings = this.getVideoEncodings();
                    if (((this.__videoEncodingsSet && (!fm.liveswitch.Global.equals(videoEncodings, null))) && (!fm.liveswitch.Global.equals(videoEncodings.length, value.length)))) {
                        throw new fm.liveswitch.Exception("The number of video encodings cannot be changed once set.");
                    }
                    this.__videoEncodingsSet = true;
                    this.doSetVideoEncodings(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the desired video simulcast bits-per-pixel (bpp). If this value is set and the video source has declared a target width, height, and frame-rate, encoding bitrates will be automatically calculated using this value instad of using preferred bitrate.
            */
            WebRtcLocalMediaBase.prototype.setVideoSimulcastBitsPerPixel = function (value) {
                if (arguments.length == 1) {
                    this.__videoSimulcast.setBitsPerPixel(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the video simulcast degradation preference.
            */
            WebRtcLocalMediaBase.prototype.setVideoSimulcastDegradationPreference = function (value) {
                if (arguments.length == 1) {
                    this.__videoSimulcast.setDegradationPreference(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether video simulcast is disabled.
            */
            WebRtcLocalMediaBase.prototype.setVideoSimulcastDisabled = function (value) {
                if (arguments.length == 1) {
                    this.__videoSimulcast.setDisabled(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of video simulcast encodings.
            */
            WebRtcLocalMediaBase.prototype.setVideoSimulcastEncodingCount = function (value) {
                if (arguments.length == 1) {
                    this.__videoSimulcast.setEncodingCount(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the preferred video simulcast bitrate, in kbps.
            */
            WebRtcLocalMediaBase.prototype.setVideoSimulcastPreferredBitrate = function (value) {
                if (arguments.length == 1) {
                    this.__videoSimulcast.setPreferredBitrate(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Starts the media track sources.
            */
            WebRtcLocalMediaBase.prototype.start = function () {
                if (arguments.length == 0) {
                    return this.startInternal(new fm.liveswitch.Promise());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcLocalMediaBase.prototype.startInternal = function (promise) {
                var _this = this;
                if (arguments.length == 1) {
                    var _var0 = this.getState();
                    if (_var0 == fm.liveswitch.LocalMediaState.Starting) {
                        do {
                            promise.reject(new fm.liveswitch.Exception("Local media cannot be started while it is being started on a different thread."));
                            return promise;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LocalMediaState.Started) {
                        do {
                            promise.resolve(this);
                            return promise;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LocalMediaState.Stopping) {
                        do {
                            promise.reject(new fm.liveswitch.Exception("Local media cannot be started while it is being stopped."));
                            return promise;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LocalMediaState.Destroying) {
                        do {
                            promise.reject(new fm.liveswitch.Exception("Local media cannot be started while it is being destroyed."));
                            return promise;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LocalMediaState.Destroyed) {
                        do {
                            promise.reject(new fm.liveswitch.Exception("Local media cannot be started while it is destroyed."));
                            return promise;
                        } while (false);
                    }
                    this.setState(fm.liveswitch.LocalMediaState.Starting);
                    fm.liveswitch.Log.debug(fm.liveswitch.StringExtensions.format("Local media is being started.", new Array(0)));
                    this.doStart().then(function (result) {
                        fm.liveswitch.Log.debug(fm.liveswitch.StringExtensions.format("Local media has successfully started.", new Array(0)));
                        _this.setState(fm.liveswitch.LocalMediaState.Started);
                        promise.resolve(result);
                    }, function (exception) {
                        fm.liveswitch.Log.debug(fm.liveswitch.StringExtensions.format("Local media did not start successfully.", new Array(0)));
                        _this.setState(fm.liveswitch.LocalMediaState.Stopped);
                        promise.reject(exception);
                    });
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Stops the media track sources.
            */
            WebRtcLocalMediaBase.prototype.stop = function () {
                if (arguments.length == 0) {
                    return this.stopInternal(new fm.liveswitch.Promise());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebRtcLocalMediaBase.prototype.stopInternal = function (promise) {
                var _this = this;
                if (arguments.length == 1) {
                    var _var0 = this.getState();
                    if (_var0 == fm.liveswitch.LocalMediaState.New) {
                        do {
                            promise.resolve(this);
                            return promise;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LocalMediaState.Starting) {
                        do {
                            promise.reject(new fm.liveswitch.Exception("Local media cannot be stopped while it is being started."));
                            return promise;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LocalMediaState.Stopping) {
                        do {
                            promise.reject(new fm.liveswitch.Exception("Local media cannot be stopped while it is being stopped on a different thread."));
                            return promise;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LocalMediaState.Stopped) {
                        do {
                            promise.resolve(this);
                            return promise;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LocalMediaState.Destroying) {
                        do {
                            promise.reject(new fm.liveswitch.Exception("Local media cannot be stopped while it is being destroyed."));
                            return promise;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LocalMediaState.Destroyed) {
                        do {
                            promise.reject(new fm.liveswitch.Exception("Local media cannot be stopped while it is destroyed."));
                            return promise;
                        } while (false);
                    }
                    this.setState(fm.liveswitch.LocalMediaState.Stopping);
                    fm.liveswitch.Log.debug(fm.liveswitch.StringExtensions.format("Local media is being stopped.", new Array(0)));
                    this.doStop().then(function (result) {
                        fm.liveswitch.Log.debug(fm.liveswitch.StringExtensions.format("Local media has successfully stopped.", new Array(0)));
                        _this.setState(fm.liveswitch.LocalMediaState.Stopped);
                        promise.resolve(result);
                    }, function (exception) {
                        fm.liveswitch.Log.debug(fm.liveswitch.StringExtensions.format("Local media did not stop successfully.", new Array(0)));
                        _this.setState(fm.liveswitch.LocalMediaState.Started);
                        promise.reject(exception);
                    });
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return WebRtcLocalMediaBase;
        }(fm.liveswitch.WebRtcMedia));
        liveswitch.WebRtcLocalMediaBase = WebRtcLocalMediaBase;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var WebRtcGetUserMediaResult = /** @class */ (function () {
            function WebRtcGetUserMediaResult() {
            }
            return WebRtcGetUserMediaResult;
        }());
        var WebRtcLocalMedia = /** @class */ (function (_super) {
            __extends(WebRtcLocalMedia, _super);
            function WebRtcLocalMedia(external, audio, video, screen) {
                var _this = _super.call(this, external) || this;
                /** @internal */
                _this._onAudioStartedValues = [];
                /** @internal */
                _this._onAudioStoppedValues = [];
                /** @internal */
                _this._onVideoStartedValues = [];
                /** @internal */
                _this._onVideoStoppedValues = [];
                /** @internal */
                _this._audioStreams = [];
                /** @internal */
                _this._videoStreams = [];
                /** @internal */
                _this._audioEncodings = [];
                /** @internal */
                _this._videoEncodings = [];
                _this._external = external;
                _this._audio = audio;
                _this._video = video;
                _this._screen = fm.liveswitch.Util.isNullOrUndefined(screen) ? false : screen;
                if (!audio) {
                    _this._audioTrack._setMediaStreamTrack(null);
                }
                if (!video) {
                    _this._videoTrack._setMediaStreamTrack(null);
                }
                _this._audioTrack.addOnStarted(function () {
                    for (var _i = 0, _a = _this._onAudioStartedValues; _i < _a.length; _i++) {
                        var value = _a[_i];
                        value();
                    }
                });
                _this._audioTrack.addOnStopped(function () {
                    for (var _i = 0, _a = _this._onAudioStoppedValues; _i < _a.length; _i++) {
                        var value = _a[_i];
                        value();
                    }
                });
                _this._videoTrack.addOnStarted(function () {
                    for (var _i = 0, _a = _this._onVideoStartedValues; _i < _a.length; _i++) {
                        var value = _a[_i];
                        value();
                    }
                });
                _this._videoTrack.addOnStopped(function () {
                    for (var _i = 0, _a = _this._onVideoStoppedValues; _i < _a.length; _i++) {
                        var value = _a[_i];
                        value();
                    }
                });
                return _this;
            }
            WebRtcLocalMedia.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcLocalMedia]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            WebRtcLocalMedia.prototype._getExternal = function () {
                return this._external;
            };
            /** @internal */
            WebRtcLocalMedia.getChromeExtensionId = function () {
                return this._chromeExtensionId;
            };
            /** @internal */
            WebRtcLocalMedia.setChromeExtensionId = function (chromeExtensionId) {
                this._chromeExtensionId = chromeExtensionId;
                this._chromeExtensionUrl = 'https://chrome.google.com/webstore/detail/' + chromeExtensionId;
                var head = document.getElementsByTagName('head')[0];
                var linkExists = false;
                for (var i = 0; i < head.childNodes.length; i++) {
                    var child = head.childNodes[i];
                    if (child.tagName == 'LINK' && child.href == this._chromeExtensionUrl) {
                        linkExists = true;
                    }
                    break;
                }
                if (!linkExists) {
                    var link = document.createElement('link');
                    link.rel = 'chrome-webstore-item';
                    link.href = this._chromeExtensionUrl;
                    head.appendChild(link);
                }
            };
            /** @internal */
            WebRtcLocalMedia.getChromeExtensionUrl = function () {
                return this._chromeExtensionUrl;
            };
            /** @internal */
            WebRtcLocalMedia.getChromeExtensionInstalled = function () {
                return this._chromeExtensionInstalled;
            };
            /** @internal */
            WebRtcLocalMedia.getChromeExtensionRequiresUserGesture = function () {
                return this._chromeExtensionRequiresUserGesture;
            };
            /** @internal */
            WebRtcLocalMedia.setChromeExtensionRequiresUserGesture = function (chromeExtensionRequiresUserGesture) {
                this._chromeExtensionRequiresUserGesture = chromeExtensionRequiresUserGesture;
            };
            /** @internal */
            WebRtcLocalMedia.getChromeExtensionRequired = function () {
                if (window.navigator) {
                    return navigator.webkitGetUserMedia && (this._chromeExtensionId != null || (!navigator.getDisplayMedia && !navigator.mediaDevices.getDisplayMedia));
                }
                else {
                    return false;
                }
            };
            WebRtcLocalMedia.prototype.addOnAudioStarted = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onAudioStartedValues, value);
            };
            WebRtcLocalMedia.prototype.addOnAudioStopped = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onAudioStoppedValues, value);
            };
            WebRtcLocalMedia.prototype.addOnVideoStarted = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onVideoStartedValues, value);
            };
            WebRtcLocalMedia.prototype.addOnVideoStopped = function (value) {
                fm.liveswitch.ArrayExtensions.add(this._onVideoStoppedValues, value);
            };
            WebRtcLocalMedia.prototype.removeOnAudioStarted = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onAudioStartedValues, value);
            };
            WebRtcLocalMedia.prototype.removeOnAudioStopped = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onAudioStoppedValues, value);
            };
            WebRtcLocalMedia.prototype.removeOnVideoStarted = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onVideoStartedValues, value);
            };
            WebRtcLocalMedia.prototype.removeOnVideoStopped = function (value) {
                fm.liveswitch.ArrayExtensions.remove(this._onVideoStoppedValues, value);
            };
            WebRtcLocalMedia.prototype.getAudioSourceInputs = function () {
                return this.getSourceInputs('audio');
            };
            WebRtcLocalMedia.prototype.getVideoSourceInputs = function () {
                return this.getSourceInputs('video');
            };
            WebRtcLocalMedia.prototype.getSourceInputs = function (kind) {
                var promise = new fm.liveswitch.Promise();
                if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
                    try {
                        navigator.mediaDevices.enumerateDevices().then(function (mediaDeviceInfos) {
                            var inputs = [];
                            var index = -1;
                            for (var _i = 0, mediaDeviceInfos_1 = mediaDeviceInfos; _i < mediaDeviceInfos_1.length; _i++) {
                                var mediaDeviceInfo = mediaDeviceInfos_1[_i];
                                if (mediaDeviceInfo.kind == kind || mediaDeviceInfo.kind == kind + 'input') {
                                    index++;
                                    var id = mediaDeviceInfo.deviceId;
                                    if (!id) {
                                        id = 'audio-' + index;
                                    }
                                    var name_4 = mediaDeviceInfo.label;
                                    if (!name_4) {
                                        name_4 = id;
                                    }
                                    inputs.push(new fm.liveswitch.SourceInput(id, name_4));
                                }
                            }
                            promise.resolve(inputs);
                        }).catch(function (ex) {
                            promise.reject(ex);
                        });
                    }
                    catch (error) {
                        promise.reject(error);
                    }
                }
                else if (MediaStreamTrack && MediaStreamTrack.getSources) {
                    try {
                        MediaStreamTrack.getSources(function (sources) {
                            var inputs = [];
                            var index = -1;
                            for (var _i = 0, sources_1 = sources; _i < sources_1.length; _i++) {
                                var source = sources_1[_i];
                                if (source.kind == kind || source.kind == kind + 'input') {
                                    index++;
                                    var id = source.deviceId;
                                    if (!id) {
                                        id = 'audio-' + index;
                                    }
                                    var name_5 = source.label;
                                    if (!name_5) {
                                        name_5 = id;
                                    }
                                    inputs.push(new fm.liveswitch.SourceInput(id, name_5));
                                }
                            }
                            promise.resolve(inputs);
                        });
                    }
                    catch (error) {
                        promise.reject(error);
                    }
                }
                else {
                    promise.reject(new fm.liveswitch.Exception('Browser does not support media device enumeration.'));
                }
                return promise;
            };
            WebRtcLocalMedia.prototype.getAudioSourceInput = function () {
                return this._audioSourceInput;
            };
            WebRtcLocalMedia.prototype.setAudioSourceInput = function (audioInput) {
                if (this.getState() == fm.liveswitch.LocalMediaState.Started) {
                    throw new fm.liveswitch.Exception("Cannot set audio source input while the local media is started. Use 'changeAudioSourceInput' instead or stop the local media first.");
                }
                this._audioSourceInput = audioInput;
            };
            WebRtcLocalMedia.prototype.getVideoSourceInput = function () {
                return this._videoSourceInput;
            };
            WebRtcLocalMedia.prototype.setVideoSourceInput = function (videoInput) {
                if (this.getState() == fm.liveswitch.LocalMediaState.Started) {
                    throw new fm.liveswitch.Exception("Cannot set video source input while the local media is started. Use 'changeVideoSourceInput' instead or stop the local media first.");
                }
                this._videoSourceInput = videoInput;
            };
            WebRtcLocalMedia.prototype.getScreen = function () {
                return this._screen;
            };
            WebRtcLocalMedia.prototype.setScreen = function (screen) {
                this._screen = screen;
            };
            WebRtcLocalMedia.prototype.getAudioConstraints = function () {
                return this._audioConstraints;
            };
            WebRtcLocalMedia.prototype.getVideoConstraints = function () {
                return this._videoConstraints;
            };
            WebRtcLocalMedia.prototype.changeAudioConstraints = function (audioConstraints) {
                var promise = new fm.liveswitch.Promise();
                try {
                    var audioTrack = this.getAudioTrack();
                    if (audioTrack == null) {
                        throw new fm.liveswitch.Exception('No audio track.');
                    }
                    var nativeAudioTrack = this.getAudioTrack()._getMediaStreamTrack();
                    if (nativeAudioTrack == null) {
                        throw new fm.liveswitch.Exception('No active audio track.');
                    }
                    if (typeof nativeAudioTrack.applyConstraints !== 'undefined') {
                        nativeAudioTrack.applyConstraints(audioConstraints).then(function () {
                            promise.resolve(null);
                        }, function (ex) {
                            promise.reject(ex);
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Browser does not support changing audio constraints.');
                    }
                }
                catch (ex) {
                    promise.reject(ex);
                }
                return promise;
            };
            WebRtcLocalMedia.prototype.changeVideoConstraints = function (videoConstraints) {
                var promise = new fm.liveswitch.Promise();
                try {
                    var videoTrack = this.getVideoTrack();
                    if (videoTrack == null) {
                        throw new fm.liveswitch.Exception('No video track.');
                    }
                    var nativeVideoTrack = this.getVideoTrack()._getMediaStreamTrack();
                    if (nativeVideoTrack == null) {
                        throw new fm.liveswitch.Exception('No active video track.');
                    }
                    if (typeof nativeVideoTrack.applyConstraints !== 'undefined') {
                        nativeVideoTrack.applyConstraints(videoConstraints).then(function () {
                            promise.resolve(null);
                        }, function (ex) {
                            promise.reject(ex);
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Browser does not support changing video constraints.');
                    }
                }
                catch (ex) {
                    promise.reject(ex);
                }
                return promise;
            };
            WebRtcLocalMedia.prototype.changeAudioSourceInput = function (audioSourceInput) {
                var _this = this;
                var promise = new fm.liveswitch.Promise();
                if (audioSourceInput == this.getAudioSourceInput()) {
                    fm.liveswitch.ManagedThread.dispatch(function () {
                        promise.resolve(null);
                    });
                }
                else if (this.getState() == fm.liveswitch.LocalMediaState.Started) {
                    if (fm.liveswitch.Plugin.hasRtcRtpSender() && RTCRtpSender.prototype.replaceTrack) {
                        this.doStopAudio();
                        this._audioSourceInput = audioSourceInput;
                        this.doGetUserMedia(this.getAudio(), null).then(function (result) {
                            _this._audioConstraints = result.audioConstraints;
                            _this._setAudioMediaStream(result.audioMediaStream);
                            //TODO: replaceTrack on WebRtcConnection.RtpSender...
                            promise.resolve(null);
                        }, function (ex) {
                            promise.reject(ex);
                        });
                    }
                    else if (fm.liveswitch.Plugin.hasRtcRtpSender()) {
                        this.doStopAudio();
                        this._audioSourceInput = audioSourceInput;
                        this.doGetUserMedia(this.getAudio(), null).then(function (result) {
                            _this._audioConstraints = result.audioConstraints;
                            _this._setAudioMediaStream(result.audioMediaStream);
                            promise.resolve(null);
                        }, function (ex) {
                            promise.reject(ex);
                        });
                    }
                }
                else {
                    fm.liveswitch.ManagedThread.dispatch(function () {
                        _this.setAudioSourceInput(audioSourceInput);
                        promise.resolve(null);
                    });
                }
                return promise;
            };
            WebRtcLocalMedia.prototype.changeVideoSourceInput = function (videoSourceInput) {
                var _this = this;
                var promise = new fm.liveswitch.Promise();
                if (videoSourceInput == this.getVideoSourceInput()) {
                    fm.liveswitch.ManagedThread.dispatch(function () {
                        promise.resolve(null);
                    });
                }
                else if (this.getState() == fm.liveswitch.LocalMediaState.Started) {
                    if (fm.liveswitch.Plugin.hasRtcRtpSender() && RTCRtpSender.prototype.replaceTrack) {
                        this.doStopVideo();
                        this._videoSourceInput = videoSourceInput;
                        this.doGetUserMedia(null, this.getVideo()).then(function (result) {
                            _this._videoConstraints = result.videoConstraints;
                            _this._setVideoMediaStream(result.videoMediaStream);
                            //TODO: replaceTrack on WebRtcConnection.RtpSender...
                            promise.resolve(null);
                        }, function (ex) {
                            promise.reject(ex);
                        });
                    }
                    else if (fm.liveswitch.Plugin.hasRtcRtpSender()) {
                        this.doStopVideo();
                        this._videoSourceInput = videoSourceInput;
                        this.doGetUserMedia(null, this.getVideo()).then(function (result) {
                            _this._videoConstraints = result.videoConstraints;
                            _this._setVideoMediaStream(result.videoMediaStream);
                            promise.resolve(null);
                        }, function (ex) {
                            promise.reject(ex);
                        });
                    }
                }
                else {
                    fm.liveswitch.ManagedThread.dispatch(function () {
                        _this.setVideoSourceInput(videoSourceInput);
                        promise.resolve(null);
                    });
                }
                return promise;
            };
            WebRtcLocalMedia.prototype.doStart = function () {
                var _this = this;
                var promise = new fm.liveswitch.Promise();
                fm.liveswitch.ManagedThread.dispatch(function () {
                    if (_this._screen && fm.liveswitch.WebRtcLocalMedia.getChromeExtensionRequired()) {
                        if (!fm.liveswitch.WebRtcLocalMedia.getChromeExtensionInstalled()) {
                            var chrome = window.chrome;
                            if (chrome && chrome.webstore && chrome.webstore.install) {
                                try {
                                    chrome.webstore.install(fm.liveswitch.WebRtcLocalMedia.getChromeExtensionUrl(), function () {
                                        //TODO: we can do better... load inline and resolve promise
                                        location.reload();
                                    }, function (error) {
                                        fm.liveswitch.WebRtcLocalMedia.setChromeExtensionRequiresUserGesture(false);
                                        promise.reject(new fm.liveswitch.Exception('Chrome extension is not installed and inline installation failed. ' + error));
                                    });
                                }
                                catch (error) {
                                    fm.liveswitch.WebRtcLocalMedia.setChromeExtensionRequiresUserGesture(true);
                                    promise.reject(new fm.liveswitch.Exception('Chrome extension is not installed and inline installation could not be started. ' + error));
                                }
                            }
                            else {
                                fm.liveswitch.WebRtcLocalMedia.setChromeExtensionRequiresUserGesture(false);
                                promise.reject(new fm.liveswitch.Exception('Chrome extension is not installed.'));
                            }
                        }
                        else {
                            _this._chromeScreenEventListener = function (event) {
                                if (event.origin == window.location.origin) {
                                    var message = event.data;
                                    if (message.namespace && message.namespace == 'fm.liveswitch.chrome') {
                                        if (message.type == 'chooseDesktopMediaSuccess') {
                                            _this._chromeScreenStreamId = message.streamId;
                                            _this.doStartInternal(promise);
                                        }
                                        else if (message.type == 'chooseDesktopMediaFailure') {
                                            if (_this._chromeScreenEventListener) {
                                                window.removeEventListener('message', _this._chromeScreenEventListener);
                                                _this._chromeScreenEventListener = null;
                                            }
                                            if (message.audioUnavailable) {
                                                promise.reject(new fm.liveswitch.Exception('Chrome 50+ is required to allow audio with screen-sharing. Please update your browser and try again.'));
                                            }
                                            else {
                                                promise.reject(new fm.liveswitch.Exception('Request for screen sharing access was denied.'));
                                            }
                                        }
                                    }
                                }
                            };
                            window.addEventListener('message', _this._chromeScreenEventListener);
                            window.postMessage({
                                namespace: 'fm.liveswitch.chrome',
                                type: 'chooseDesktopMedia',
                                origin: window.location.origin,
                                audio: _this._audio ? true : false
                            }, '*');
                        }
                    }
                    else {
                        _this.doStartInternal(promise);
                    }
                });
                return promise;
            };
            WebRtcLocalMedia.prototype.doStartInternal = function (promise) {
                var _this = this;
                this.doGetUserMedia(this.getAudio(), this.getVideo()).then(function (result) {
                    _this._audioConstraints = result.audioConstraints;
                    _this._videoConstraints = result.videoConstraints;
                    _this._setMediaStreams(result.audioMediaStream, result.videoMediaStream);
                    promise.resolve(_this);
                }, function (ex) {
                    promise.reject(ex);
                });
            };
            /** @internal */
            WebRtcLocalMedia.prototype.doGetUserMedia = function (audio, video, deprecated) {
                var _this = this;
                if (arguments.length == 2) {
                    try {
                        // try with new API, unless the new API isn't available or we're screen-sharing in Chrome
                        deprecated = (!!(this.getScreen() && this._chromeScreenStreamId) || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia);
                        return this.doGetUserMedia(audio, video, deprecated);
                    }
                    catch (error) {
                        // fall back to deprecated API
                        return this.doGetUserMedia(audio, video, !deprecated);
                    }
                }
                var promise = new fm.liveswitch.Promise();
                try {
                    var result_1 = new WebRtcGetUserMediaResult();
                    var audioIsMediaStream_1 = audio && (typeof audio.getAudioTracks !== 'undefined');
                    var videoIsMediaStream_1 = video && (typeof video.getVideoTracks !== 'undefined');
                    var getUserMediaSuccess_1 = function (nativeMediaStream) {
                        if (audioIsMediaStream_1) {
                            result_1.audioMediaStream = audio;
                        }
                        else {
                            result_1.audioMediaStream = nativeMediaStream;
                        }
                        if (videoIsMediaStream_1) {
                            result_1.videoMediaStream = video;
                        }
                        else {
                            result_1.videoMediaStream = nativeMediaStream;
                        }
                        if (audio) {
                            var mediaStream = result_1.audioMediaStream;
                            if (mediaStream) {
                                var audioTracks = mediaStream.getAudioTracks();
                                if (audioTracks && audioTracks.length > 0) {
                                    var audioTrack = audioTracks[0];
                                    if (audioTrack) {
                                        _this.lockAudioEncodings();
                                    }
                                }
                            }
                        }
                        if (video && !_this.getScreen()) { // screen-sharing simulcast doesn't seem to work
                            var mediaStream = result_1.videoMediaStream;
                            if (mediaStream) {
                                var videoTracks = mediaStream.getVideoTracks();
                                if (videoTracks && videoTracks.length > 0) {
                                    var videoTrack = videoTracks[0];
                                    if (videoTrack) {
                                        var sourceType = _this.getScreen() ? fm.liveswitch.VideoType.Screen : fm.liveswitch.VideoType.Camera;
                                        var sourceWidth = -1;
                                        var sourceHeight = -1;
                                        var sourceFrameRate = -1;
                                        if (videoTrack.getSettings) {
                                            var videoSettings = videoTrack.getSettings();
                                            if (videoSettings) {
                                                if (videoSettings.width) {
                                                    sourceWidth = videoSettings.width;
                                                }
                                                if (videoSettings.height) {
                                                    sourceHeight = videoSettings.height;
                                                }
                                                if (videoSettings.frameRate) {
                                                    sourceFrameRate = videoSettings.frameRate;
                                                }
                                            }
                                        }
                                        _this.lockVideoEncodings(sourceType, sourceWidth, sourceHeight, sourceFrameRate);
                                    }
                                }
                            }
                        }
                        promise.resolve(result_1);
                    };
                    var getUserMediaFailure = function (error) {
                        if (_this.getScreen()) {
                            if (document.location.protocol == 'https:') {
                                fm.liveswitch.Log.error('Local screen access denied.', error);
                            }
                            else {
                                fm.liveswitch.Log.error('Local screen access denied. (The page may need to be loaded using HTTPS.)', error);
                            }
                        }
                        else {
                            if (document.location.protocol == 'file:') {
                                fm.liveswitch.Log.error('Local media access denied. (The media source may be unavailable/locked or you may need to access this page through a webserver instead of the file system.)', error);
                            }
                            else {
                                fm.liveswitch.Log.error('Local media access denied. (The media source may be unavailable/locked.)', error);
                            }
                        }
                        promise.reject(error);
                    };
                    if (audio && !audioIsMediaStream_1) {
                        result_1.audioConstraints = this.createAudioConstraints(audio, deprecated);
                    }
                    if (video && !videoIsMediaStream_1) {
                        result_1.videoConstraints = this.createVideoConstraints(video, deprecated);
                    }
                    if (result_1.audioConstraints || result_1.videoConstraints) {
                        var getUserMediaArgs = {};
                        if (result_1.audioConstraints) {
                            getUserMediaArgs.audio = result_1.audioConstraints;
                        }
                        if (result_1.videoConstraints) {
                            getUserMediaArgs.video = result_1.videoConstraints;
                        }
                        var getMedia = navigator.fmGetUserMedia;
                        var getDisplayMedia = !fm.liveswitch.WebRtcLocalMedia.getChromeExtensionRequired() && (navigator.getDisplayMedia || navigator.mediaDevices.getDisplayMedia);
                        if (this.getScreen() && getDisplayMedia) {
                            getMedia = function (constraints, success, failure) {
                                var result = null;
                                if (navigator.getDisplayMedia) {
                                    result = navigator.getDisplayMedia(constraints);
                                }
                                else if (navigator.mediaDevices.getDisplayMedia) {
                                    result = navigator.mediaDevices.getDisplayMedia(constraints);
                                }
                                else {
                                    result = navigator.mediaDevices.getUserMedia(constraints);
                                }
                                result.then(success).catch(failure);
                            };
                        }
                        getMedia(getUserMediaArgs, function (nativeMediaStream) {
                            // now that we have permission, we have non-anonymized names,
                            // so if an audio or video source input exists, we need to
                            // update the name(s) with the unveiled information
                            _this.updateAudioSourceInput(nativeMediaStream.getAudioTracks());
                            _this.updateVideoSourceInput(nativeMediaStream.getVideoTracks());
                            // we can also now properly update the facing mode,
                            // which currently depends on a best guess using
                            // the name on a mobile device
                            if (result_1.videoConstraints) {
                                _this.updateFacingMode(result_1.videoConstraints);
                            }
                            // ready to go
                            getUserMediaSuccess_1(nativeMediaStream);
                        }, getUserMediaFailure);
                    }
                    else {
                        getUserMediaSuccess_1(null);
                    }
                }
                catch (ex) {
                    promise.reject(ex);
                }
                return promise;
            };
            /** @internal */
            WebRtcLocalMedia.prototype.updateAudioSourceInput = function (nativeAudioTracks) {
                if (nativeAudioTracks.length > 0) {
                    var nativeAudioTrack = nativeAudioTracks[0];
                    var audioSourceInput = this._audioSourceInput;
                    if (this._audioSourceInput == null) {
                        if (typeof nativeAudioTrack.getSettings !== 'undefined') {
                            var settings = nativeAudioTrack.getSettings();
                            if (settings != null) {
                                this._audioSourceInput = new fm.liveswitch.SourceInput(settings.deviceId, nativeAudioTrack.label);
                            }
                        }
                    }
                    else {
                        this._audioSourceInput.setName(nativeAudioTrack.label);
                    }
                }
            };
            /** @internal */
            WebRtcLocalMedia.prototype.updateVideoSourceInput = function (nativeVideoTracks) {
                if (nativeVideoTracks.length > 0) {
                    var nativeVideoTrack = nativeVideoTracks[0];
                    var videoSourceInput = this._videoSourceInput;
                    if (this._videoSourceInput == null) {
                        if (typeof nativeVideoTrack.getSettings !== 'undefined') {
                            var settings = nativeVideoTrack.getSettings();
                            if (settings != null) {
                                this._videoSourceInput = new fm.liveswitch.SourceInput(settings.deviceId, nativeVideoTrack.label);
                            }
                        }
                    }
                    else {
                        this._videoSourceInput.setName(nativeVideoTrack.label);
                    }
                }
            };
            /** @internal */
            WebRtcLocalMedia.prototype.updateFacingMode = function (videoConstraints) {
                if (!this.getScreen()) {
                    var videoSourceInput = this.getVideoSourceInput();
                    // facingMode helps us set up mirroring correctly for the local preview
                    if (!videoConstraints.facingMode) {
                        videoConstraints.facingMode = 'user';
                    }
                    if (videoConstraints.deviceId && videoSourceInput != null) {
                        var name_6 = videoSourceInput.getName();
                        // would be better if MediaDevices.enumerateDevices told us facing details...
                        if (fm.liveswitch.StringExtensions.startsWith(name_6, 'back', fm.liveswitch.StringComparison.InvariantCultureIgnoreCase) ||
                            fm.liveswitch.StringExtensions.endsWith(name_6, 'back', fm.liveswitch.StringComparison.InvariantCultureIgnoreCase) ||
                            fm.liveswitch.StringExtensions.startsWith(name_6, 'rear', fm.liveswitch.StringComparison.InvariantCultureIgnoreCase) ||
                            fm.liveswitch.StringExtensions.endsWith(name_6, 'rear', fm.liveswitch.StringComparison.InvariantCultureIgnoreCase) ||
                            fm.liveswitch.StringExtensions.startsWith(name_6, 'environment', fm.liveswitch.StringComparison.InvariantCultureIgnoreCase) ||
                            fm.liveswitch.StringExtensions.endsWith(name_6, 'environment', fm.liveswitch.StringComparison.InvariantCultureIgnoreCase)) {
                            videoConstraints.facingMode = 'environment';
                        }
                    }
                }
            };
            /** @internal */
            WebRtcLocalMedia.prototype.createAudioConstraints = function (audio, deprecated) {
                var audioSourceInput = this.getAudioSourceInput();
                if (deprecated) {
                    var audioConstraints_1 = {
                        optional: [],
                        mandatory: {}
                    };
                    if (this.getScreen()) {
                        if (this._chromeScreenStreamId) {
                            audioConstraints_1.mandatory.chromeMediaSource = 'desktop';
                            audioConstraints_1.mandatory.chromeMediaSourceId = this._chromeScreenStreamId;
                        }
                    }
                    if (audioSourceInput) {
                        audioConstraints_1.optional.push({ sourceId: audioSourceInput.getId() });
                    }
                    if (fm.liveswitch.Util.isPlainObject(audio)) {
                        if (audio.mandatory) {
                            for (var key in audio.mandatory) {
                                audioConstraints_1.mandatory[key] = audio.mandatory[key];
                            }
                        }
                        if (audio.optional) {
                            for (var _i = 0, _a = audio.optional; _i < _a.length; _i++) {
                                var value = _a[_i];
                                audioConstraints_1.optional.push(value);
                            }
                        }
                    }
                    return audioConstraints_1;
                }
                var audioConstraints = {
                    echoCancellation: true
                };
                if (this.getScreen()) {
                    if (this._chromeScreenStreamId) {
                        audioConstraints.chromeMediaSource = 'desktop';
                        audioConstraints.chromeMediaSourceId = this._chromeScreenStreamId;
                    }
                }
                if (audioSourceInput) {
                    audioConstraints.deviceId = { exact: audioSourceInput.getId() };
                }
                if (fm.liveswitch.Util.isPlainObject(audio)) {
                    for (var key in audio) {
                        if (key !== 'mandatory' && key !== 'optional') {
                            audioConstraints[key] = audio[key];
                        }
                    }
                }
                return audioConstraints;
            };
            /** @internal */
            WebRtcLocalMedia.prototype.createVideoConstraints = function (video, deprecated) {
                var videoSourceInput = this.getVideoSourceInput();
                if (deprecated) {
                    var videoConstraints_1 = {
                        optional: [],
                        mandatory: {}
                    };
                    if (video.getTypeString) {
                        var videoConfig = video;
                        videoConstraints_1.mandatory.maxWidth = videoConfig.getWidth();
                        videoConstraints_1.mandatory.maxHeight = videoConfig.getHeight();
                        videoConstraints_1.mandatory.maxFrameRate = videoConfig.getFrameRate();
                    }
                    if (this.getScreen()) {
                        if (this._chromeScreenStreamId) {
                            videoConstraints_1.mandatory.chromeMediaSource = 'desktop';
                            videoConstraints_1.mandatory.chromeMediaSourceId = this._chromeScreenStreamId;
                        }
                        else {
                            videoConstraints_1.mandatory.mediaSource = 'screen';
                        }
                    }
                    else if (videoSourceInput) {
                        videoConstraints_1.optional.push({ sourceId: videoSourceInput.getId() });
                    }
                    if (fm.liveswitch.Util.isPlainObject(video)) {
                        if (video.mandatory) {
                            for (var key in video.mandatory) {
                                videoConstraints_1.mandatory[key] = video.mandatory[key];
                            }
                        }
                        if (video.optional) {
                            for (var _i = 0, _a = video.optional; _i < _a.length; _i++) {
                                var value = _a[_i];
                                videoConstraints_1.optional.push(value);
                            }
                        }
                    }
                    return videoConstraints_1;
                }
                var videoConstraints = {};
                if (video.getTypeString) {
                    var videoConfig = video;
                    videoConstraints.width = videoConfig.getWidth();
                    videoConstraints.height = videoConfig.getHeight();
                    videoConstraints.frameRate = videoConfig.getFrameRate();
                    // removed because it interferes with 'facingMode'
                    //videoConstraints.aspectRatio = videoConfig.getWidth() / videoConfig.getHeight();
                }
                if (this.getScreen()) {
                    if (this._chromeScreenStreamId) {
                        videoConstraints.chromeMediaSource = 'desktop';
                        videoConstraints.chromeMediaSourceId = this._chromeScreenStreamId;
                    }
                    else {
                        videoConstraints.mediaSource = 'screen';
                    }
                }
                else if (videoSourceInput) {
                    videoConstraints.deviceId = { exact: videoSourceInput.getId() };
                }
                if (fm.liveswitch.Util.isPlainObject(video)) {
                    for (var key in video) {
                        if (key !== 'mandatory' && key !== 'optional') {
                            videoConstraints[key] = video[key];
                        }
                    }
                }
                if (fm.liveswitch.Util.isMobile()) {
                    // best effort
                    this.updateFacingMode(videoConstraints);
                }
                return videoConstraints;
            };
            WebRtcLocalMedia.prototype.doStop = function () {
                var _this = this;
                var promise = new fm.liveswitch.Promise();
                fm.liveswitch.ManagedThread.dispatch(function () {
                    try {
                        if (_this._chromeScreenEventListener) {
                            window.removeEventListener('message', _this._chromeScreenEventListener);
                            _this._chromeScreenEventListener = null;
                        }
                        if (_this._chromeScreenStreamId) {
                            window.postMessage({
                                namespace: 'fm.liveswitch.chrome',
                                type: 'cancelChooseDesktopMedia'
                            }, '*');
                        }
                        _this.doStopAudio();
                        _this.doStopVideo();
                        promise.resolve(_this);
                    }
                    catch (error) {
                        promise.reject(error);
                    }
                });
                return promise;
            };
            /** @internal */
            WebRtcLocalMedia.prototype.doStopAudio = function () {
                try {
                    for (var _i = 0, _a = this.getAudioTracks(); _i < _a.length; _i++) {
                        var audioTrack = _a[_i];
                        audioTrack.stop();
                    }
                }
                catch (error) {
                    try {
                        // try deprecated API
                        var audioMediaStream = this._getAudioMediaStream();
                        if (audioMediaStream) {
                            audioMediaStream.stop();
                        }
                    }
                    catch (error) { }
                }
                this.destroyAudioContext();
            };
            /** @internal */
            WebRtcLocalMedia.prototype.doStopVideo = function () {
                try {
                    for (var _i = 0, _a = this.getVideoTracks(); _i < _a.length; _i++) {
                        var videoTrack = _a[_i];
                        videoTrack.stop();
                    }
                }
                catch (error) {
                    try {
                        // try deprecated API
                        var videoMediaStream = this._getVideoMediaStream();
                        if (videoMediaStream) {
                            videoMediaStream.stop();
                        }
                    }
                    catch (error) { }
                }
            };
            WebRtcLocalMedia.prototype.doGetAudioEncodings = function () {
                return this._audioEncodings;
            };
            WebRtcLocalMedia.prototype.doSetAudioEncodings = function (encodings) {
                this._audioEncodings = encodings;
                for (var _i = 0, _a = this._audioStreams; _i < _a.length; _i++) {
                    var audioStream = _a[_i];
                    audioStream.setSendEncodings(encodings);
                }
            };
            WebRtcLocalMedia.prototype.doGetVideoEncodings = function () {
                return this._videoEncodings;
            };
            WebRtcLocalMedia.prototype.doSetVideoEncodings = function (encodings) {
                this._videoEncodings = encodings;
                for (var _i = 0, _a = this._videoStreams; _i < _a.length; _i++) {
                    var videoStream = _a[_i];
                    videoStream.setSendEncodings(encodings);
                }
            };
            /** @internal */
            WebRtcLocalMedia.prototype.addAudioStream = function (value) {
                if (value) {
                    value.setSendEncodings(this._audioEncodings);
                    fm.liveswitch.ArrayExtensions.add(this._audioStreams, value);
                }
            };
            /** @internal */
            WebRtcLocalMedia.prototype.removeAudioStream = function (value) {
                if (value && fm.liveswitch.ArrayExtensions.remove(this._audioStreams, value)) {
                    value.setSendEncodings(null);
                    return true;
                }
                return false;
            };
            /** @internal */
            WebRtcLocalMedia.prototype.addVideoStream = function (value) {
                if (value) {
                    value.setSendEncodings(this._videoEncodings);
                    fm.liveswitch.ArrayExtensions.add(this._videoStreams, value);
                }
            };
            /** @internal */
            WebRtcLocalMedia.prototype.removeVideoStream = function (value) {
                if (value && fm.liveswitch.ArrayExtensions.remove(this._videoStreams, value)) {
                    value.setSendEncodings(null);
                    return true;
                }
                return false;
            };
            /** @internal */
            WebRtcLocalMedia.webRtcLocalMediaInitialize = function () {
                var _this = this;
                if (!this.__webRtcLocalMediaInitialized) {
                    if (window.navigator) {
                        navigator.fmGetUserMedia = navigator.getUserMedia ||
                            navigator.webkitGetUserMedia ||
                            navigator.mozGetUserMedia ||
                            navigator.msGetUserMedia;
                        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                            navigator.fmGetUserMedia = function (constraints, success, failure) {
                                navigator.mediaDevices.getUserMedia(constraints).then(success).catch(failure);
                            };
                        }
                    }
                    if (window.navigator && navigator.webkitGetUserMedia) {
                        window.addEventListener('message', function (event) {
                            if (event.origin == window.location.origin) {
                                var message = event.data;
                                if (message.namespace && message.namespace == 'fm.liveswitch.chrome' && message.type == 'active') {
                                    _this._chromeExtensionInstalled = true;
                                }
                            }
                        });
                        window.postMessage({
                            namespace: 'fm.liveswitch.chrome',
                            type: 'testActive'
                        }, '*');
                    }
                }
                fm.liveswitch.WebRtcLocalMedia.__webRtcLocalMediaInitialized = true;
            };
            /** @internal */
            WebRtcLocalMedia.__webRtcLocalMediaInitialized = false;
            return WebRtcLocalMedia;
        }(fm.liveswitch.WebRtcLocalMediaBase));
        liveswitch.WebRtcLocalMedia = WebRtcLocalMedia;
        fm.liveswitch.WebRtcLocalMedia.webRtcLocalMediaInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="WebRtcMedia.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var WebRtcRemoteMedia = /** @class */ (function (_super) {
            __extends(WebRtcRemoteMedia, _super);
            function WebRtcRemoteMedia(external, audio, video) {
                var _this = _super.call(this, external) || this;
                _this._external = external;
                _this._audio = audio;
                _this._video = video;
                return _this;
            }
            WebRtcRemoteMedia.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcRemoteMedia]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            WebRtcRemoteMedia.prototype._getExternal = function () {
                return this._external;
            };
            WebRtcRemoteMedia.prototype.getAudioSinkOutputs = function () {
                return this.getSinkOutputs('audio');
            };
            WebRtcRemoteMedia.prototype.getVideoSinkOutputs = function () {
                return this.getSinkOutputs('video');
            };
            WebRtcRemoteMedia.prototype.getSinkOutputs = function (kind) {
                var promise = new fm.liveswitch.Promise();
                if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
                    try {
                        navigator.mediaDevices.enumerateDevices().then(function (mediaDeviceInfos) {
                            var outputs = [];
                            var index = -1;
                            for (var _i = 0, mediaDeviceInfos_2 = mediaDeviceInfos; _i < mediaDeviceInfos_2.length; _i++) {
                                var mediaDeviceInfo = mediaDeviceInfos_2[_i];
                                if (mediaDeviceInfo.kind == kind || mediaDeviceInfo.kind == kind + 'output') {
                                    index++;
                                    var id = mediaDeviceInfo.deviceId;
                                    if (!id) {
                                        id = 'audio-' + index;
                                    }
                                    var name_7 = mediaDeviceInfo.label;
                                    if (!name_7) {
                                        name_7 = id;
                                    }
                                    outputs.push(new fm.liveswitch.SinkOutput(id, name_7));
                                }
                            }
                            promise.resolve(outputs);
                        }).catch(function (ex) {
                            promise.reject(ex);
                        });
                    }
                    catch (error) {
                        promise.reject(error);
                    }
                }
                else if (MediaStreamTrack && MediaStreamTrack.getSources) {
                    try {
                        MediaStreamTrack.getSources(function (sources) {
                            var outputs = [];
                            var index = -1;
                            for (var _i = 0, sources_2 = sources; _i < sources_2.length; _i++) {
                                var source = sources_2[_i];
                                if (source.kind == kind || source.kind == kind + 'output') {
                                    index++;
                                    var id = source.deviceId;
                                    if (!id) {
                                        id = 'audio-' + index;
                                    }
                                    var name_8 = source.label;
                                    if (!name_8) {
                                        name_8 = id;
                                    }
                                    outputs.push(new fm.liveswitch.SinkOutput(id, name_8));
                                }
                            }
                            promise.resolve(outputs);
                        });
                    }
                    catch (error) {
                        promise.reject(error);
                    }
                }
                else {
                    promise.reject(new fm.liveswitch.Exception('Browser does not support media device enumeration.'));
                }
                return promise;
            };
            WebRtcRemoteMedia.prototype.getAudioSinkOutput = function () {
                return this._audioSinkOutput;
            };
            WebRtcRemoteMedia.prototype.setAudioSinkOutput = function (audioSinkOutput) {
                if (this._audioSinkOutput != audioSinkOutput) {
                    if (this._audioSink.getTrack()) {
                        this.attachAudioSinkOutput(audioSinkOutput, this._audioSink.getAudio());
                    }
                    else if (this._videoSink.getTrack()) {
                        this.attachAudioSinkOutput(audioSinkOutput, this._videoSink.getVideo());
                    }
                    this._audioSinkOutput = audioSinkOutput;
                }
            };
            WebRtcRemoteMedia.prototype.attachAudioSinkOutput = function (audioSinkOutput, element) {
                if (typeof element.setSinkId !== 'undefined') {
                    element.setSinkId(audioSinkOutput.getId());
                }
                else {
                    throw new fm.liveswitch.Exception('Browser does not support changing audio sink output.');
                }
            };
            WebRtcRemoteMedia.prototype.getVideoSinkOutput = function () {
                return this._videoSinkOutput;
            };
            WebRtcRemoteMedia.prototype.setVideoSinkOutput = function (videoSinkOutput) {
                if (this._videoSinkOutput != videoSinkOutput) {
                    this._videoSinkOutput = videoSinkOutput;
                    // nothing else to do here
                }
            };
            WebRtcRemoteMedia.prototype.changeAudioSinkOutput = function (audioInput) {
                var _this = this;
                var promise = new fm.liveswitch.Promise();
                if (audioInput == this.getAudioSinkOutput()) {
                    fm.liveswitch.ManagedThread.dispatch(function () {
                        promise.resolve(null);
                    });
                }
                else {
                    fm.liveswitch.ManagedThread.dispatch(function () {
                        try {
                            _this.setAudioSinkOutput(audioInput);
                            promise.resolve(null);
                        }
                        catch (ex) {
                            promise.reject(ex);
                        }
                    });
                }
                return promise;
            };
            WebRtcRemoteMedia.prototype.changeVideoSinkOutput = function (videoInput) {
                var _this = this;
                var promise = new fm.liveswitch.Promise();
                if (videoInput == this.getVideoSinkOutput()) {
                    fm.liveswitch.ManagedThread.dispatch(function () {
                        promise.resolve(null);
                    });
                }
                else {
                    fm.liveswitch.ManagedThread.dispatch(function () {
                        try {
                            _this.setVideoSinkOutput(videoInput);
                            promise.resolve(null);
                        }
                        catch (ex) {
                            promise.reject(ex);
                        }
                    });
                }
                return promise;
            };
            return WebRtcRemoteMedia;
        }(fm.liveswitch.WebRtcMedia));
        liveswitch.WebRtcRemoteMedia = WebRtcRemoteMedia;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="WebRtcMediaStream.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var WebRtcVideoStream = /** @class */ (function (_super) {
            __extends(WebRtcVideoStream, _super);
            function WebRtcVideoStream(external, localTrack, remoteTrack) {
                var _this = _super.call(this, external, localTrack, remoteTrack, fm.liveswitch.StreamType.Video) || this;
                _this._external = external;
                return _this;
            }
            WebRtcVideoStream.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcVideoStream]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @hidden */
            WebRtcVideoStream.prototype._getExternal = function () {
                return this._external;
            };
            WebRtcVideoStream.prototype.getVp8Disabled = function () {
                return this.getCodecDisabled(fm.liveswitch.VideoFormat.getVp8Name());
            };
            WebRtcVideoStream.prototype.getVp9Disabled = function () {
                return this.getCodecDisabled(fm.liveswitch.VideoFormat.getVp9Name());
            };
            WebRtcVideoStream.prototype.getH264Disabled = function () {
                return this.getCodecDisabled(fm.liveswitch.VideoFormat.getH264Name());
            };
            WebRtcVideoStream.prototype.setVp8Disabled = function (value) {
                return this.setCodecDisabled(fm.liveswitch.VideoFormat.getVp8Name(), value);
            };
            WebRtcVideoStream.prototype.setVp9Disabled = function (value) {
                return this.setCodecDisabled(fm.liveswitch.VideoFormat.getVp9Name(), value);
            };
            WebRtcVideoStream.prototype.setH264Disabled = function (value) {
                return this.setCodecDisabled(fm.liveswitch.VideoFormat.getH264Name(), value);
            };
            WebRtcVideoStream.prototype.addOnDiscardKeyFrameRequest = function (value) { };
            WebRtcVideoStream.prototype.removeOnDiscardKeyFrameRequest = function (value) { };
            WebRtcVideoStream.prototype.raiseKeyFrameRequest = function (synchronizationSources) { };
            return WebRtcVideoStream;
        }(fm.liveswitch.WebRtcMediaStream));
        liveswitch.WebRtcVideoStream = WebRtcVideoStream;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="WebRtcMediaTrack.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var WebRtcVideoTrack = /** @class */ (function (_super) {
            __extends(WebRtcVideoTrack, _super);
            function WebRtcVideoTrack(external, media) {
                var _this = _super.call(this, external, media) || this;
                _this._external = external;
                return _this;
            }
            WebRtcVideoTrack.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebRtcVideoTrack]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @internal */
            WebRtcVideoTrack.prototype._getExternal = function () {
                return this._external;
            };
            WebRtcVideoTrack.prototype.setConfig = function (config) {
                var nativeMediaStreamTrack = this._getMediaStreamTrack();
                if (nativeMediaStreamTrack.applyConstraints) {
                    var constraints = {};
                    if (config.getWidth() > 0) {
                        constraints.width = config.getWidth();
                    }
                    if (config.getHeight() > 0) {
                        constraints.height = config.getHeight();
                    }
                    if (config.getFrameRate() > 0) {
                        constraints.frameRate = config.getFrameRate();
                    }
                    nativeMediaStreamTrack.applyConstraints(constraints);
                }
            };
            WebRtcVideoTrack.prototype.isLocal = function () {
                return (fm.liveswitch.Util.isObjectType(this.getMedia(), '[fm.liveswitch.WebRtcLocalMedia]'));
            };
            WebRtcVideoTrack.prototype.changeSinkOutput = function (sinkOutput) {
                if (this.isLocal()) {
                    var promise = new fm.liveswitch.Promise();
                    promise.reject(new fm.liveswitch.Exception('Cannot call VideoTrack.changeSinkOutput on a local track.'));
                    return promise;
                }
                return this.getMedia().changeVideoSinkOutput(sinkOutput);
            };
            WebRtcVideoTrack.prototype.getSinkOutput = function () {
                if (this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call VideoTrack.getSinkOutput on a local track.');
                }
                return this.getMedia().getVideoSinkOutput();
            };
            WebRtcVideoTrack.prototype.getSinkOutputs = function () {
                if (this.isLocal()) {
                    var promise = new fm.liveswitch.Promise();
                    promise.reject(new fm.liveswitch.Exception('Cannot call VideoTrack.getSinkOutputs on a local track.'));
                    return promise;
                }
                return this.getMedia().getVideoSinkOutputs();
            };
            WebRtcVideoTrack.prototype.setSinkOutput = function (value) {
                if (this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call VideoTrack.setSinkOutput on a local track.');
                }
                this.getMedia().setVideoSinkOutput(value);
            };
            WebRtcVideoTrack.prototype.changeSourceInput = function (sourceInput) {
                if (!this.isLocal()) {
                    var promise = new fm.liveswitch.Promise();
                    promise.reject(new fm.liveswitch.Exception('Cannot call VideoTrack.changeSourceInput on a remote track.'));
                    return promise;
                }
                return this.getMedia().changeVideoSourceInput(sourceInput);
            };
            WebRtcVideoTrack.prototype.getSourceInput = function () {
                if (!this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call VideoTrack.getSourceInput on a remote track.');
                }
                return this.getMedia().getVideoSourceInput();
            };
            WebRtcVideoTrack.prototype.getSourceInputs = function () {
                if (!this.isLocal()) {
                    var promise = new fm.liveswitch.Promise();
                    promise.reject(new fm.liveswitch.Exception('Cannot call VideoTrack.getSourceInputs on a remote track.'));
                    return promise;
                }
                return this.getMedia().getVideoSourceInputs();
            };
            WebRtcVideoTrack.prototype.setSourceInput = function (value) {
                if (!this.isLocal()) {
                    throw new fm.liveswitch.Exception('Cannot call VideoTrack.setSourceInput on a remote track.');
                }
                this.getMedia().setVideoSourceInput(value);
            };
            WebRtcVideoTrack.prototype.addOnSize = function (value) {
                this.getMedia().addOnVideoSize(value);
            };
            WebRtcVideoTrack.prototype.getSize = function () {
                return this.getMedia().getVideoSize();
            };
            WebRtcVideoTrack.prototype.grabFrame = function () {
                return this.getMedia().grabVideoFrame();
            };
            WebRtcVideoTrack.prototype.removeOnSize = function (value) {
                this.getMedia().removeOnVideoSize(value);
            };
            return WebRtcVideoTrack;
        }(fm.liveswitch.WebRtcMediaTrack));
        liveswitch.WebRtcVideoTrack = WebRtcVideoTrack;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A crypto library.
        */
        var CryptoLibrary;
        (function (CryptoLibrary) {
            /**
            Indicates that the default library should be used.
            */
            CryptoLibrary[CryptoLibrary["Default"] = 1] = "Default";
        })(CryptoLibrary = liveswitch.CryptoLibrary || (liveswitch.CryptoLibrary = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Address types.
        */
        var AddressType;
        (function (AddressType) {
            /**
            Indicates an IP version 4 address.
            */
            AddressType[AddressType["IPv4"] = 1] = "IPv4";
            /**
            Indicates an IP version 6 address.
            */
            AddressType[AddressType["IPv6"] = 2] = "IPv6";
            /**
            Indicates an unknown address type.
            */
            AddressType[AddressType["Unknown"] = 3] = "Unknown";
        })(AddressType = liveswitch.AddressType || (liveswitch.AddressType = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var JsonCheckerMode;
        (function (JsonCheckerMode) {
            JsonCheckerMode[JsonCheckerMode["Array"] = 1] = "Array";
            JsonCheckerMode[JsonCheckerMode["Done"] = 2] = "Done";
            JsonCheckerMode[JsonCheckerMode["Key"] = 3] = "Key";
            JsonCheckerMode[JsonCheckerMode["Object"] = 4] = "Object";
            JsonCheckerMode[JsonCheckerMode["String"] = 5] = "String";
        })(JsonCheckerMode = liveswitch.JsonCheckerMode || (liveswitch.JsonCheckerMode = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        An operating system.
        */
        var OperatingSystem;
        (function (OperatingSystem) {
            /**
            Indicates an unknown or default OS.
            */
            OperatingSystem[OperatingSystem["Unknown"] = 1] = "Unknown";
            /**
            Indicates a Windows operating system.
            */
            OperatingSystem[OperatingSystem["Windows"] = 2] = "Windows";
            /**
            Indicates a Android operating system.
            */
            OperatingSystem[OperatingSystem["Android"] = 3] = "Android";
            /**
            Indicates a macOS operating system.
            */
            OperatingSystem[OperatingSystem["MacOS"] = 4] = "MacOS";
            /**
            Indicates a iOS operating system.
            */
            OperatingSystem[OperatingSystem["IOS"] = 5] = "IOS";
            /**
            Indicates a Linux operating system.
            */
            OperatingSystem[OperatingSystem["Linux"] = 6] = "Linux";
            /**
            Indicates a tvOS operating system.
            */
            OperatingSystem[OperatingSystem["TvOS"] = 7] = "TvOS";
            /**
            Indicates a watchOS operating system.
            */
            OperatingSystem[OperatingSystem["WatchOS"] = 8] = "WatchOS";
        })(OperatingSystem = liveswitch.OperatingSystem || (liveswitch.OperatingSystem = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A CPU architecture.
        */
        var Architecture;
        (function (Architecture) {
            /**
            Indicates an unknown or default CPU architecture.
            */
            Architecture[Architecture["Unknown"] = 1] = "Unknown";
            /**
            Indicates an Intel-based 32-bit CPU architecture.
            */
            Architecture[Architecture["X86"] = 2] = "X86";
            /**
            Indicates an Intel-based 64-bit CPU architecture.
            */
            Architecture[Architecture["X64"] = 3] = "X64";
            /**
            Indicates an ARMv7-based 32-bit CPU architecture.
            */
            Architecture[Architecture["Armv7"] = 4] = "Armv7";
            /**
            Indicates an ARMv8-based 32-bit CPU architecture.
            */
            Architecture[Architecture["Armv8"] = 5] = "Armv8";
            /**
            Indicates an ARM-based 64-bit CPU architecture.
            */
            Architecture[Architecture["Arm64"] = 6] = "Arm64";
            /**
            Indicates a MIPS-based 32-bit CPU architecture.
            */
            Architecture[Architecture["Mips"] = 7] = "Mips";
            /**
            Indicates a MIPS-based 64-bit CPU architecture.
            */
            Architecture[Architecture["Mips64"] = 8] = "Mips64";
        })(Architecture = liveswitch.Architecture || (liveswitch.Architecture = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A protocol type.
        */
        var ProtocolType;
        (function (ProtocolType) {
            /**
            Indicates the UDP protocol.
            */
            ProtocolType[ProtocolType["Udp"] = 1] = "Udp";
            /**
            Indicates the TCP protocol.
            */
            ProtocolType[ProtocolType["Tcp"] = 2] = "Tcp";
            /**
            Indicates the TLS protocol.
            */
            ProtocolType[ProtocolType["Tls"] = 3] = "Tls";
            /**
            Indicates an unknown protocol.
            */
            ProtocolType[ProtocolType["Unknown"] = 4] = "Unknown";
        })(ProtocolType = liveswitch.ProtocolType || (liveswitch.ProtocolType = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A source language.
        */
        var SourceLanguage;
        (function (SourceLanguage) {
            /**
            Indicates that the source language is C#.
            */
            SourceLanguage[SourceLanguage["CSharp"] = 1] = "CSharp";
            /**
            Indicates that the source language is Java.
            */
            SourceLanguage[SourceLanguage["Java"] = 2] = "Java";
            /**
            Indicates that the source language is Objective-C.
            */
            SourceLanguage[SourceLanguage["ObjectiveC"] = 3] = "ObjectiveC";
            /**
            Indicates that the source language is TypeScript.
            */
            SourceLanguage[SourceLanguage["TypeScript"] = 4] = "TypeScript";
        })(SourceLanguage = liveswitch.SourceLanguage || (liveswitch.SourceLanguage = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var StringType;
        (function (StringType) {
            StringType[StringType["None"] = 1] = "None";
            StringType[StringType["Single"] = 2] = "Single";
            StringType[StringType["Double"] = 3] = "Double";
        })(StringType = liveswitch.StringType || (liveswitch.StringType = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The compare result in a sort operation.
        */
        var CompareResult;
        (function (CompareResult) {
            /**
            Indicates that the two elements are equal.
            */
            CompareResult[CompareResult["Equal"] = 1] = "Equal";
            /**
            Indicates that the first element belongs before the second.
            */
            CompareResult[CompareResult["Negative"] = 2] = "Negative";
            /**
            Indicates that ths second element belongs before the first.
            */
            CompareResult[CompareResult["Positive"] = 3] = "Positive";
        })(CompareResult = liveswitch.CompareResult || (liveswitch.CompareResult = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A hash algorithm.
        */
        var HashType;
        (function (HashType) {
            /**
            Indciates MD5.
            */
            HashType[HashType["Md5"] = 1] = "Md5";
            /**
            Indicates SHA1.
            */
            HashType[HashType["Sha1"] = 2] = "Sha1";
            /**
            Indicates SHA256.
            */
            HashType[HashType["Sha256"] = 3] = "Sha256";
        })(HashType = liveswitch.HashType || (liveswitch.HashType = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A message authentication code (MAC) algorithm.
        */
        var MacType;
        (function (MacType) {
            /**
            Indicates HMAC-MD5.
            */
            MacType[MacType["HmacMd5"] = 1] = "HmacMd5";
            /**
            Indicates HMAC-SHA1
            */
            MacType[MacType["HmacSha1"] = 2] = "HmacSha1";
            /**
            Indicates HMAC-SHA256
            */
            MacType[MacType["HmacSha256"] = 3] = "HmacSha256";
        })(MacType = liveswitch.MacType || (liveswitch.MacType = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Error codes are six digit values, where the first three digits indicate component, while the remaining three digits particular problem with the component.
        */
        var ErrorCode;
        (function (ErrorCode) {
            /**
            Indicates that the socket encountered an error while sending.
            */
            ErrorCode[ErrorCode["SocketSendError"] = 100000] = "SocketSendError";
            /**
            Indicates that the socket encountered an error while receiving.
            */
            ErrorCode[ErrorCode["SocketReceiveError"] = 100001] = "SocketReceiveError";
            /**
            Indicates that the socket is closed.
            */
            ErrorCode[ErrorCode["SocketClosed"] = 100002] = "SocketClosed";
            /**
            Indicates that the socket's send buffer is full.
            */
            ErrorCode[ErrorCode["SocketSendBufferFull"] = 100003] = "SocketSendBufferFull";
            /**
            Indicates the IP Protocol mismatch has occurred.
            */
            ErrorCode[ErrorCode["IPProtocolMismatch"] = 100004] = "IPProtocolMismatch";
            /**
            Indicates the supplied Turn relay server is invalid or not resolved.
            */
            ErrorCode[ErrorCode["PacketTooLarge"] = 100005] = "PacketTooLarge";
            /**
            300 Try Alternate. RFC5389. Indicates that a server using this extension redirects a client to another server by replying to a request message with an error response message with an error code of 300 (Try Alternate). The server MUST include an ALTERNATE-SERVER attribute in the error response.  The error response message MAY be authenticated; however, there are uses cases for ALTERNATE-SERVER where authentication of the response is not possible or practical.
            */
            ErrorCode[ErrorCode["StunTryAlternate"] = 114000] = "StunTryAlternate";
            /**
            400 Bad Request. RFC5389. Idicates that the original request was malformed.  The client SHOULD NOT retry the request without modification from the previous attempt.  The server may not be able to generate a valid MESSAGE-INTEGRITY for this error, so the client MUST NOT expect a valid MESSAGE-INTEGRITY attribute on this response.
            */
            ErrorCode[ErrorCode["StunBadRequest"] = 114001] = "StunBadRequest";
            /**
            401  Unauthorized. RFC5389. Indicates that the request did not contain the correct credentials to proceed.  The client should retry the request with proper credentials.
            */
            ErrorCode[ErrorCode["StunUnauthorized"] = 114002] = "StunUnauthorized";
            /**
            403 Forbidden. RFC 5766. Indicates that the request is valid, but the server is refusing to perform it, likely due to administrative restrictions. The client considers the current transaction as having failed. The client MAY notify the user or operator and SHOULD NOT retry the same request with this server until it believes the problem has been fixed.
            */
            ErrorCode[ErrorCode["StunTurnForbidden"] = 114003] = "StunTurnForbidden";
            /**
            405 Mobility Forbidden. RFC 8016. Indicates that the request is valid, but the server is refusing to perform it, likely due to administrative restrictions. The client considers the current transaction as having failed. The client can notify the user or operator.  The client SHOULD NOT retry sending the Allocate request containing the MOBILITY-TICKET with this server until it believes the problem has been fixed.
            */
            ErrorCode[ErrorCode["StunTurnMobilityForbidden"] = 114004] = "StunTurnMobilityForbidden";
            /**
            420  Unknown Attribute. RFC5389. Indicates that the server received a STUN packet containing a comprehension-required attribute that it did not understand. The server MUST put this unknown attribute in the UNKNOWN-ATTRIBUTE attribute of its error response.
            */
            ErrorCode[ErrorCode["StunUnknownAttribute"] = 114005] = "StunUnknownAttribute";
            /**
            430 Stale credentials; the shared secret sent in the request is expired; the client should obtain a new shared secret.
            */
            ErrorCode[ErrorCode["StunStaleCredentials"] = 114006] = "StunStaleCredentials";
            /**
            431 Integrity Check Failure.
            */
            ErrorCode[ErrorCode["StunIntegrityCheckFailure"] = 114007] = "StunIntegrityCheckFailure";
            /**
            432 Missing Username; the username attribute is not present in the request.
            */
            ErrorCode[ErrorCode["StunMissingUsername"] = 114008] = "StunMissingUsername";
            /**
            437 Allocation Mismatch. RFC 5766. This indicates that the client has picked a 5-tuple that the server sees as already in use. One way this could happen is if an intervening NAT assigned a mapped transport address that was used by another client that recently crashed.  The client considers the current transaction as having failed. The client SHOULD pick another client transport address and retry the Allocate request (using a different transaction id). The client SHOULD try three different client transport addresses before giving up on this server.Once the client gives up on the server, it SHOULD NOT try to create another allocation on the server for 2 minutes.
            */
            ErrorCode[ErrorCode["StunTurnAllocationMismatch"] = 114009] = "StunTurnAllocationMismatch";
            /**
            438 Stale Nonce. RFC5389. Indicates that the NONCE used by the client was no longer valid. The client should retry, using the NONCE provided in the response.
            */
            ErrorCode[ErrorCode["StunStaleNonce"] = 114010] = "StunStaleNonce";
            /**
            440 Address Family Not Supported. RFC 6156. Indicates that the server does not support the address family requested by the client.
            */
            ErrorCode[ErrorCode["StunAddressFamilyNotSupported"] = 114011] = "StunAddressFamilyNotSupported";
            /**
            441 Wrong Credentials. RFC 5766. Indicates that wrong credential were used by the client. The client should not receive this error in response to an Allocate request.  The client MAY notify the user or operator and SHOULD NOT retry the same request with this server until it believes the problem has been fixed.
            */
            ErrorCode[ErrorCode["StunTurnWrongCredentials"] = 114012] = "StunTurnWrongCredentials";
            /**
            442 Unsupported Transport Protocol. The client should not receive this error in response to a request for a UDP allocation. The client MAY notify the user or operator and SHOULD NOT reattempt the request with this server until it believes the problem has been fixed.
            */
            ErrorCode[ErrorCode["StunTurnUnsupportedTransportProtocol"] = 114013] = "StunTurnUnsupportedTransportProtocol";
            /**
            443 Peer Address Family Mismatch. A peer address was of a different address family than that of the relayed transport address of the allocation.
            */
            ErrorCode[ErrorCode["StunTurnPeerAddressFamilyMismatch"] = 114014] = "StunTurnPeerAddressFamilyMismatch";
            /**
            446 Connection Already exists. This indicates that either 1) the server is currently processing a Connect request for this allocation with the same XOR-PEER-ADDRESS; OR 2) the server has already successfully processed a Connect request for this allocation with the same XOR-PEER-ADDRESS, and the resulting client and peer data connections are either pending or active
            */
            ErrorCode[ErrorCode["StunTurnConnectionAlreadyExists"] = 114015] = "StunTurnConnectionAlreadyExists";
            /**
            447 Connection Timeout or Failure. This indicates that the TURN server was unable to connect to the peer. The client MAY retry with the same XOR-PEER-ADDRESS attribute, but MUST wait at least 10 seconds.
            */
            ErrorCode[ErrorCode["StunTurnConnectionTimeoutOrFailure"] = 114016] = "StunTurnConnectionTimeoutOrFailure";
            /**
            486 Allocation Quota Reached. The server is currently unable to create any more allocations with this username.  The client considers the current transaction as having failed. The client SHOULD wait at least 1 minute before trying to create any more allocations on the server.
            */
            ErrorCode[ErrorCode["StunTurnAllocationQuotaReached"] = 114017] = "StunTurnAllocationQuotaReached";
            /**
            487 Role Conflict. The Binding request contained either the ICE-CONTROLLING or ICE-CONTROLLED attribute, indicating a role that conflicted with the server. The server ran a tie-breaker based on the tie-breaker value in the request and determined that the client needs to switch roles.
            */
            ErrorCode[ErrorCode["StunIceRoleConflict"] = 114018] = "StunIceRoleConflict";
            /**
            500 Server Error. RFC5389. Indicates that the server has suffered a temporary error. The client should try again.
            */
            ErrorCode[ErrorCode["StunServerError"] = 114019] = "StunServerError";
            /**
            508 Insufficient Capacity. The server has no more relayed transport addresses available, or has none with the requested properties, or the one that was reserved is no longer available. The client considers the current operation as having failed. If the client is using either the EVEN-PORT or the RESERVATION-TOKEN attribute, then the client MAY choose to remove or modify this attribute and try again immediately.  Otherwise, the client SHOULD wait at least 1 minute before trying to create any more allocations on this server.
            */
            ErrorCode[ErrorCode["StunTurnInsufficientCapacity"] = 114020] = "StunTurnInsufficientCapacity";
            /**
            Indicates Invalid Response Type, where message type obtained in reponse to a request is of unexpected type.
            */
            ErrorCode[ErrorCode["StunInvalidResponseType"] = 114021] = "StunInvalidResponseType";
            /**
            Indicates that a failed response does not contain an error code or when the error code is inconsistent with the contents of the response.
            */
            ErrorCode[ErrorCode["StunInvalidErrorCode"] = 114022] = "StunInvalidErrorCode";
            /**
            Indicates Invalid Stun Transaction Id
            */
            ErrorCode[ErrorCode["StunInvalidTransactionId"] = 114023] = "StunInvalidTransactionId";
            /**
            Indicates Unknown Stun Error Code
            */
            ErrorCode[ErrorCode["StunUnknownStunErrorCode"] = 114024] = "StunUnknownStunErrorCode";
            /**
            Indicates Invalid Stun Message Integrity
            */
            ErrorCode[ErrorCode["StunInvalidMessageIntegrity"] = 114025] = "StunInvalidMessageIntegrity";
            /**
            Indicates that the stream socket ip is invalid, remote server ip is invalid or there is a mimatch in the the ip of the socket and the remote server ip version
            */
            ErrorCode[ErrorCode["SocketIPError"] = 115001] = "SocketIPError";
            /**
            Indicates the local relayed candidate could not be processed.
            */
            ErrorCode[ErrorCode["IceLocalRelayedDatagramCandidateError"] = 101000] = "IceLocalRelayedDatagramCandidateError";
            /**
            Indicates the local server reflexive could not be processed.
            */
            ErrorCode[ErrorCode["IceLocalServerReflexiveCandidateError"] = 101001] = "IceLocalServerReflexiveCandidateError";
            /**
            Indicates that an operation was attempted in an invalid state.
            */
            ErrorCode[ErrorCode["SocketManagerInvalidState"] = 101002] = "SocketManagerInvalidState";
            /**
            Indicates that the ICE gatherer could not be started.
            */
            ErrorCode[ErrorCode["IceStartError"] = 102000] = "IceStartError";
            /**
            Indicates that RTCP datagram sockets were assigned incorrectly after the gatherer was started.
            */
            ErrorCode[ErrorCode["IceUnsuitableSocketAssignment"] = 102001] = "IceUnsuitableSocketAssignment";
            /**
            Indicates that all ports are in use.
            */
            ErrorCode[ErrorCode["IceAllPortsInUse"] = 102002] = "IceAllPortsInUse";
            /**
            Indicates that no local addresses were found.
            */
            ErrorCode[ErrorCode["IceLocalAddressUnavailable"] = 102003] = "IceLocalAddressUnavailable";
            /**
            Indicates that an Ice Gatherer error occurred.
            */
            ErrorCode[ErrorCode["IceGenericGathererError"] = 102004] = "IceGenericGathererError";
            /**
            Indicates that the relayed candidate refresh request timed out.
            */
            ErrorCode[ErrorCode["IceRefreshTimeout"] = 103000] = "IceRefreshTimeout";
            /**
            Indicates that the relayed candidate refresh request failed.
            */
            ErrorCode[ErrorCode["IceRefreshError"] = 103001] = "IceRefreshError";
            /**
            Indicates that the candidate pair create-permission request timed out.
            */
            ErrorCode[ErrorCode["IceCreatePermissionTimeout"] = 104000] = "IceCreatePermissionTimeout";
            /**
            Indicates that the candidate pair create-permission request failed.
            */
            ErrorCode[ErrorCode["IceCreatePermissionError"] = 104001] = "IceCreatePermissionError";
            /**
            Indicates that connectivity checks failed on the candidate pair.
            */
            ErrorCode[ErrorCode["IceConnectivityCheckFailed"] = 104002] = "IceConnectivityCheckFailed";
            /**
            Indicates that the ICE transport encountered an error while sending.
            */
            ErrorCode[ErrorCode["IceSendError"] = 105000] = "IceSendError";
            /**
            Indicates that the ICE transport encountered a problem creating a peer reflexive candidate.
            */
            ErrorCode[ErrorCode["IcePeerReflexiveError"] = 105001] = "IcePeerReflexiveError";
            /**
            Indicates that the IcePolicy requirements are not supported by the remote client.
            */
            ErrorCode[ErrorCode["IncompatibleIceSetup"] = 105002] = "IncompatibleIceSetup";
            /**
            Indicates that an internal DTLS error occurred.
            */
            ErrorCode[ErrorCode["DtlsInternalError"] = 106000] = "DtlsInternalError";
            /**
            Indicates that the DTLS key exchange failed.
            */
            ErrorCode[ErrorCode["DtlsKeyExchangeFailed"] = 106001] = "DtlsKeyExchangeFailed";
            /**
            Indicates that a DTLS message was received before the DTLS endpoint was ready.
            */
            ErrorCode[ErrorCode["DtlsNotReady"] = 106002] = "DtlsNotReady";
            /**
            Indicates that an SCTP message had no payload data.
            */
            ErrorCode[ErrorCode["SctpNoPayloadData"] = 107000] = "SctpNoPayloadData";
            /**
            Indicates that an attempt was made to send data on an unsupported stream.
            */
            ErrorCode[ErrorCode["SctpUnsupportedStream"] = 107001] = "SctpUnsupportedStream";
            /**
            Indicates that an operation was attempted while in a state that doesn't allow it.
            */
            ErrorCode[ErrorCode["SctpInvalidState"] = 107002] = "SctpInvalidState";
            /**
            Indicates that an internal SCTP error occurred.
            */
            ErrorCode[ErrorCode["SctpInternalError"] = 107003] = "SctpInternalError";
            /**
            Indicates the media transport failed.
            */
            ErrorCode[ErrorCode["MediaTransportFailed"] = 108000] = "MediaTransportFailed";
            /**
            Indicates that the reliable data channel encountered an error while opening.
            */
            ErrorCode[ErrorCode["ReliableDataChannelOpenError"] = 109000] = "ReliableDataChannelOpenError";
            /**
            Indicates that the reliable data channel encountered an error while sending.
            */
            ErrorCode[ErrorCode["ReliableDataChannelSendError"] = 109001] = "ReliableDataChannelSendError";
            /**
            Indicates that the connection architecture is invalid.
            */
            ErrorCode[ErrorCode["ConnectionInvalidArchitecture"] = 110000] = "ConnectionInvalidArchitecture";
            /**
            Indicates that an internal connection error occurred.
            */
            ErrorCode[ErrorCode["ConnectionInternalError"] = 110001] = "ConnectionInternalError";
            /**
            Indicates that the connection's inner transport could not be started.
            */
            ErrorCode[ErrorCode["ConnectionTransportStartError"] = 110002] = "ConnectionTransportStartError";
            /**
            Indicates that the connection's inner transport is closed.
            */
            ErrorCode[ErrorCode["ConnectionTransportClosed"] = 110003] = "ConnectionTransportClosed";
            /**
            Indicates that a connection has failed connectivity checks for an extended period.
            */
            ErrorCode[ErrorCode["ConnectionDeadStream"] = 110004] = "ConnectionDeadStream";
            /**
            Indicates that a connection has not been established within allocated timeframe.
            */
            ErrorCode[ErrorCode["ConnectionNotEstablished"] = 110005] = "ConnectionNotEstablished";
            /**
            Indicates that the remote end of the connection signalled failure.
            */
            ErrorCode[ErrorCode["ConnectionRemoteFailure"] = 110006] = "ConnectionRemoteFailure";
            /**
            Indicates that simulcast is not supported.
            */
            ErrorCode[ErrorCode["ConnectionSimulcastNotSupported"] = 110007] = "ConnectionSimulcastNotSupported";
            /**
            Indicates that the stream was disabled.
            */
            ErrorCode[ErrorCode["StreamDisabled"] = 111000] = "StreamDisabled";
            /**
            Indicates that the local and remote stream encryption modes are not compatible.
            */
            ErrorCode[ErrorCode["StreamEncryptionMismatch"] = 111001] = "StreamEncryptionMismatch";
            /**
            Indicates that the local and remote stream directions are not compatible.
            */
            ErrorCode[ErrorCode["StreamDirectionMismatch"] = 111002] = "StreamDirectionMismatch";
            /**
            Indicates that an attempt was made to modify Data Stream direction; however, this is not allowed.
            */
            ErrorCode[ErrorCode["DataStreamDirectionCannotBeChanged"] = 111003] = "DataStreamDirectionCannotBeChanged";
            /**
            Indicates that a Media Stream direction change attempt was made; however, new direction setting is not supported by the existing stream capabilities (inputs or outpus are missing).
            */
            ErrorCode[ErrorCode["InvalidStreamDirectionChange"] = 111004] = "InvalidStreamDirectionChange";
            /**
            Indicates that an error was encountered while processing the local description.
            */
            ErrorCode[ErrorCode["LocalDescriptionError"] = 112000] = "LocalDescriptionError";
            /**
            Indicates that an error was encountered while processing the remote description.
            */
            ErrorCode[ErrorCode["RemoteDescriptionError"] = 112001] = "RemoteDescriptionError";
            /**
            Indicates the local relayed candidate could not be processed.
            */
            ErrorCode[ErrorCode["IceLocalRelayedStreamCandidateError"] = 113000] = "IceLocalRelayedStreamCandidateError";
            /**
            Indicates the supplied Turn relay server is invalid or not resolved
            */
            ErrorCode[ErrorCode["IceInvalidServerAssignmentError"] = 113001] = "IceInvalidServerAssignmentError";
        })(ErrorCode = liveswitch.ErrorCode || (liveswitch.ErrorCode = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The method used by an HTTP request.
        */
        var HttpMethod;
        (function (HttpMethod) {
            /**
            Indicates a GET request.
            */
            HttpMethod[HttpMethod["Get"] = 1] = "Get";
            /**
            Indicates a HEAD request.
            */
            HttpMethod[HttpMethod["Head"] = 2] = "Head";
            /**
            Indicates a POST request.
            */
            HttpMethod[HttpMethod["Post"] = 3] = "Post";
            /**
            Indicates a PUT request.
            */
            HttpMethod[HttpMethod["Put"] = 4] = "Put";
            /**
            Indicates a PATCH request.
            */
            HttpMethod[HttpMethod["Patch"] = 5] = "Patch";
            /**
            Indicates a DELETE request.
            */
            HttpMethod[HttpMethod["Delete"] = 6] = "Delete";
        })(HttpMethod = liveswitch.HttpMethod || (liveswitch.HttpMethod = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The level at which to log.
        */
        var LogLevel;
        (function (LogLevel) {
            /**
            Logs extensive messages detailing the program's state for troubleshooting.
            */
            LogLevel[LogLevel["Verbose"] = 1] = "Verbose";
            /**
            Logs messages relevant to development and troubleshooting.
            */
            LogLevel[LogLevel["Debug"] = 2] = "Debug";
            /**
            Logs messages relevant to expected use.
            */
            LogLevel[LogLevel["Info"] = 3] = "Info";
            /**
            Logs messages relevant to potential pit-falls.
            */
            LogLevel[LogLevel["Warn"] = 4] = "Warn";
            /**
            Logs messages relevant to errors that allow program execution to continue.
            */
            LogLevel[LogLevel["Error"] = 5] = "Error";
            /**
            Logs messages relevant to errors that require the program to terminate.
            */
            LogLevel[LogLevel["Fatal"] = 6] = "Fatal";
            /**
            Logs nothing.
            */
            LogLevel[LogLevel["None"] = 7] = "None";
        })(LogLevel = liveswitch.LogLevel || (liveswitch.LogLevel = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The state of a future.
        */
        var FutureState;
        (function (FutureState) {
            /**
            Indicates that the promise has not been resolved or rejected.
            */
            FutureState[FutureState["Pending"] = 1] = "Pending";
            /**
            Indicates that the promise has been resolved.
            */
            FutureState[FutureState["Resolved"] = 2] = "Resolved";
            /**
            Indicates that the promise has been rejected.
            */
            FutureState[FutureState["Rejected"] = 3] = "Rejected";
        })(FutureState = liveswitch.FutureState || (liveswitch.FutureState = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        An enumeration of potential WebSocket status codes.
        */
        var WebSocketStatusCode;
        (function (WebSocketStatusCode) {
            /**
            Indicates normal closure, meaning that the purpose for which the connection was established has been fulfilled.
            */
            WebSocketStatusCode[WebSocketStatusCode["Normal"] = 1000] = "Normal";
            /**
            Indicates that an endpoint is "going away", such as a server going down or a browser having navigated away from a page.
            */
            WebSocketStatusCode[WebSocketStatusCode["GoingAway"] = 1001] = "GoingAway";
            /**
            Indicates that an endpoint is terminating the connection due to a protocol error.
            */
            WebSocketStatusCode[WebSocketStatusCode["ProtocolError"] = 1002] = "ProtocolError";
            /**
            Indicates that an endpoint is terminating the connection because it has received a type of data that it cannot accept.
            */
            WebSocketStatusCode[WebSocketStatusCode["InvalidType"] = 1003] = "InvalidType";
            /**
            Indicates that no status code was present in the Close frame. Reserved for use outside Close frames.
            */
            WebSocketStatusCode[WebSocketStatusCode["NoStatus"] = 1005] = "NoStatus";
            /**
            Indicates that the connection was closed abnormally, without sending a Close frame. Reserved for use outside Close frames.
            */
            WebSocketStatusCode[WebSocketStatusCode["Abnormal"] = 1006] = "Abnormal";
            /**
            Indicates that an endpoint is terminating the connection because it has received data within a message that was not consistent with the type of message.
            */
            WebSocketStatusCode[WebSocketStatusCode["InvalidData"] = 1007] = "InvalidData";
            /**
            Indicates that an endpoint is terminating the connection because it has received a message that violates its policy.
            */
            WebSocketStatusCode[WebSocketStatusCode["PolicyViolation"] = 1008] = "PolicyViolation";
            /**
            Indicates that an endpoint is terminating the connection because it has received a message that is too big for it to process.
            */
            WebSocketStatusCode[WebSocketStatusCode["MessageTooLarge"] = 1009] = "MessageTooLarge";
            /**
            Indicates that the client is terminating the connection because it has expected the server to negotiate one or more extensions, but the server didn't return them in the response message of the WebSocket handshake.
            */
            WebSocketStatusCode[WebSocketStatusCode["UnsupportedExtension"] = 1010] = "UnsupportedExtension";
            /**
            Indicates that the server is terminating the connection because it encountered an unexpected condition that prevented it from fulfilling the request.
            */
            WebSocketStatusCode[WebSocketStatusCode["UnexpectedCondition"] = 1011] = "UnexpectedCondition";
            /**
            Indicates that the connection was closed due to a failure to perform a TLS handshake. Reserved for use outside Close frames.
            */
            WebSocketStatusCode[WebSocketStatusCode["SecureHandshakeFailure"] = 1015] = "SecureHandshakeFailure";
        })(WebSocketStatusCode = liveswitch.WebSocketStatusCode || (liveswitch.WebSocketStatusCode = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The state of a candidate pair.
        */
        var CandidatePairState;
        (function (CandidatePairState) {
            /**
            Indicates that the candidate pair has been formed, but connectivity checks have not yet started.
            */
            CandidatePairState[CandidatePairState["New"] = 1] = "New";
            /**
            Indicates that the connectivity check is ready for connectivity checks, but checks have not yet started.
            */
            CandidatePairState[CandidatePairState["Waiting"] = 2] = "Waiting";
            /**
            Indicates that connectivity checks are in progress.
            */
            CandidatePairState[CandidatePairState["InProgress"] = 3] = "InProgress";
            /**
            Indicates that a connectivity check was successful.
            */
            CandidatePairState[CandidatePairState["Succeeded"] = 4] = "Succeeded";
            /**
            Indicates that all connectivity checks have timed out or produced a failure response.
            */
            CandidatePairState[CandidatePairState["Failed"] = 5] = "Failed";
            /**
            Indicates that connectivity checks have been stopped intentionally due to transport closure.
            */
            CandidatePairState[CandidatePairState["Closed"] = 6] = "Closed";
            /**
            Indicates that connectivity checks have succeeded in the past, but are currently not responding.
            */
            CandidatePairState[CandidatePairState["ConnectivityLost"] = 7] = "ConnectivityLost";
        })(CandidatePairState = liveswitch.CandidatePairState || (liveswitch.CandidatePairState = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The type of a candidate.
        */
        var CandidateType;
        (function (CandidateType) {
            /**
            Indicates a 'host' candidate, discovered by querying a local network interface adapter. The candidate should contain a private IP address of this client.
            */
            CandidateType[CandidateType["Host"] = 1] = "Host";
            /**
            Indicates a 'srflx' candidate, discovered by using a STUN server to echo back the source IP address it sees in a UDP binding request. When the STUN server is properly configured, the candidate should contain a public IP address of this client.
            */
            CandidateType[CandidateType["ServerReflexive"] = 2] = "ServerReflexive";
            /**
            Indicates a 'relay' candidate, discovered by using a TURN server to set up a public port in response to a UDP or TCP allocate request. When the TURN server is properly configured, the candidate should contain a public IP address of the TURN server.
            */
            CandidateType[CandidateType["Relayed"] = 3] = "Relayed";
            /**
            Indicates a 'prflx' candidate, discovered by sending STUN connectivity checks between peers residing behind more restrictive firewalls. The candidate should contain a public IP address of this client.
            */
            CandidateType[CandidateType["PeerReflexive"] = 4] = "PeerReflexive";
            /**
            Indicates an unknown candidate type.
            */
            CandidateType[CandidateType["Unknown"] = 5] = "Unknown";
        })(CandidateType = liveswitch.CandidateType || (liveswitch.CandidateType = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A value used to indicate whether this codec is used to encode or decode.
        */
        var CodecType;
        (function (CodecType) {
            /**
            The attached RTCCodecStats represents a media format that is being encoded, or that the implementation is prepared to encode.
            */
            CodecType[CodecType["Encode"] = 1] = "Encode";
            /**
            The attached RTCCodecStats represents a media format that the implementation is prepared to decode.
            */
            CodecType[CodecType["Decode"] = 2] = "Decode";
        })(CodecType = liveswitch.CodecType || (liveswitch.CodecType = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The state of a connection.
        */
        var ConnectionState;
        (function (ConnectionState) {
            /**
            Indicates that the connection is new and has not been started.
            */
            ConnectionState[ConnectionState["New"] = 1] = "New";
            /**
            Indicates that the connection is being initialized but no connecting attempts have been made.
            */
            ConnectionState[ConnectionState["Initializing"] = 2] = "Initializing";
            /**
            Indicates that the connection is currently connecting.
            */
            ConnectionState[ConnectionState["Connecting"] = 3] = "Connecting";
            /**
            Indicates that the connection is currently connected.
            */
            ConnectionState[ConnectionState["Connected"] = 4] = "Connected";
            /**
            Indicates that the connection has encountered an error and is cleaning up.
            */
            ConnectionState[ConnectionState["Failing"] = 5] = "Failing";
            /**
            Indicates that the connection has encountered an error and has cleaned up.
            */
            ConnectionState[ConnectionState["Failed"] = 6] = "Failed";
            /**
            Indicates that the connection has been instructed to close and is cleaning up.
            */
            ConnectionState[ConnectionState["Closing"] = 7] = "Closing";
            /**
            Indicates that the connection has been instructed to close and has cleaned up.
            */
            ConnectionState[ConnectionState["Closed"] = 8] = "Closed";
        })(ConnectionState = liveswitch.ConnectionState || (liveswitch.ConnectionState = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A data channel state.
        */
        var DataChannelState;
        (function (DataChannelState) {
            /**
            Indicates the data channel has been created and has not started negotiating yet.
            */
            DataChannelState[DataChannelState["New"] = 1] = "New";
            /**
            Indicates the data channel is in the process of negotiating a secure connection.
            */
            DataChannelState[DataChannelState["Connecting"] = 2] = "Connecting";
            /**
            Indicates the data channel has completed negotiation of a secure connection.
            */
            DataChannelState[DataChannelState["Connected"] = 3] = "Connected";
            /**
            Indicates the data channel is in the process of closing due to an intentional request.
            */
            DataChannelState[DataChannelState["Closing"] = 4] = "Closing";
            /**
            Indicates the data channel has been closed due to an intentional request.
            */
            DataChannelState[DataChannelState["Closed"] = 5] = "Closed";
            /**
            Indicates the data channel has been closed as the result of an error.
            */
            DataChannelState[DataChannelState["Failed"] = 6] = "Failed";
        })(DataChannelState = liveswitch.DataChannelState || (liveswitch.DataChannelState = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The encryption mode for the stream.
        */
        var EncryptionMode;
        (function (EncryptionMode) {
            /**
            No encryption and no integrity checking.
            */
            EncryptionMode[EncryptionMode["Null"] = 1] = "Null";
            /**
            AES 128-bit encryption with strong HMAC-SHA1 integrity checking (80-bit).
            */
            EncryptionMode[EncryptionMode["Aes128Strong"] = 2] = "Aes128Strong";
            /**
            AES 128-bit encryption with weak HMAC-SHA1 integrity checking (32-bit).
            */
            EncryptionMode[EncryptionMode["Aes128Weak"] = 3] = "Aes128Weak";
            /**
            Null encryption with strong HMAC-SHA1 integrity checking (80-bit).
            */
            EncryptionMode[EncryptionMode["NullStrong"] = 4] = "NullStrong";
            /**
            Null encryption with weak HMAC-SHA1 integrity checking (32-bit).
            */
            EncryptionMode[EncryptionMode["NullWeak"] = 5] = "NullWeak";
        })(EncryptionMode = liveswitch.EncryptionMode || (liveswitch.EncryptionMode = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Specifies how an element should be scaled within a layout.
        */
        var LayoutScale;
        (function (LayoutScale) {
            /**
            Indicates that the element should be uniformly scaled (maintaining aspect ratio) to the largest size such that both its width and its height can fit inside its bounding box.
            */
            LayoutScale[LayoutScale["Contain"] = 1] = "Contain";
            /**
            Indicates that the element should be uniformly scaled (maintaining aspect ratio) to be as large as possible so that the bounding box is completely covered. Some parts of the element may not be in view (cropped).
            */
            LayoutScale[LayoutScale["Cover"] = 2] = "Cover";
            /**
            Indicates that the element should be non-uniformly scaled (not maintaining aspect ratio) so that the bounding box is completely covered, but all parts of the element are in view (no cropping).
            */
            LayoutScale[LayoutScale["Stretch"] = 3] = "Stretch";
        })(LayoutScale = liveswitch.LayoutScale || (liveswitch.LayoutScale = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            Specified Multiplexing category of SDP Attribute. Rules governing SDP Attribute multiplexing are as per draft-ietf-mmusic-sdp-mux-attributes
            */
            var AttributeCategory;
            (function (AttributeCategory) {
                /**
                The attributes in the NORMAL category can be independently specified when multiplexed and they retain their original semantics.
                */
                AttributeCategory[AttributeCategory["Normal"] = 1] = "Normal";
                /**
                The attributes in the CAUTION category are advised against multiplexing since their usage under multiplexing might lead to incorrect behaviour.
                */
                AttributeCategory[AttributeCategory["Caution"] = 2] = "Caution";
                /**
                The attributes and their associated values (if any) in the IDENTICAL category MUST be repeated across all the media descriptions under multiplexing.
                */
                AttributeCategory[AttributeCategory["Identical"] = 3] = "Identical";
                /**
                The attributes in the SUM category can be set as they are normally used but software using them in the multiplexing scenario MUST apply the sum of all the attributes being multiplexed instead of trying to use them independently.This is typically used for bandwidth or other rate limiting attributes to the underlying transport.
                */
                AttributeCategory[AttributeCategory["Sum"] = 4] = "Sum";
                /**
                The attributes in the TRANSPORT category can be set normally for multiple items in a multiplexed group but the software MUST pick the one that's associated with the "m=" line whose information is used for setting up the underlying transport.
                */
                AttributeCategory[AttributeCategory["Transport"] = 5] = "Transport";
                /**
                The attributes in the INHERIT category encapsulate other SDP attributes or parameters.  These attributes inherit their multiplexing characteristics from the attributes or parameters they encapsulate.  Such attributes are defined in [RFC3407], [RFC5939] and [RFC6871] as part of a generic framework for indicating and negotiating transport, media, and media format related capabilities in the SDP.  The inheritance manifests itself when the encapsulated attribute or parameter is being leveraged.  In the case of SDP Capability Negotiation [RFC5939] for example, this occurs when a capability (encapsulating attribute) is used as part of a configuration; the configuration inherits the multiplexing category of each of its constituent (encapsulated) attributes and parameters.  The inherited attributes MUST be coherent in order to form a valid configuration from a multiplexing point of view (see Section 14 for further details).
                */
                AttributeCategory[AttributeCategory["Inherit"] = 6] = "Inherit";
                /**
                The attributes in the IDENTICAL-PER-PT category define the RTP payload configuration on per Payload Type basis and MUST have identical values across all the media descriptions for a given RTP Payload Type when repeated.  These Payload Types identify the same codec configuration as defined in the Section 10.1.2 of [I-D.ietf-mmusic-sdp-bundle-negotiation] under this context.
                */
                AttributeCategory[AttributeCategory["IdenticalPerPT"] = 7] = "IdenticalPerPT";
                /**
                For the attributes in the SPECIAL category, the text in the specification defining the attribute MUST be consulted for further handling when multiplexed.
                */
                AttributeCategory[AttributeCategory["Special"] = 8] = "Special";
            })(AttributeCategory = sdp.AttributeCategory || (sdp.AttributeCategory = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            SDP Attribute types
            */
            var AttributeType;
            (function (AttributeType) {
                /**
                Unknown SDP Attribute
                */
                AttributeType[AttributeType["UnknownAttribute"] = 999666] = "UnknownAttribute";
                /**
                SDP Direction Attribute
                */
                AttributeType[AttributeType["DirectionAttribute"] = 1] = "DirectionAttribute";
                /**
                SDP Category Attribute
                */
                AttributeType[AttributeType["CategoryAttribute"] = 2] = "CategoryAttribute";
                /**
                SDP Character Set Attribute
                */
                AttributeType[AttributeType["CharacterSetAttribute"] = 3] = "CharacterSetAttribute";
                /**
                SDP Conference Type Attribute
                */
                AttributeType[AttributeType["ConferenceTypeAttribute"] = 4] = "ConferenceTypeAttribute";
                /**
                SDP Crypto Attribute
                */
                AttributeType[AttributeType["CryptoAttribute"] = 5] = "CryptoAttribute";
                /**
                SDP Format Parameters Attribute
                */
                AttributeType[AttributeType["FormatParametersAttribute"] = 6] = "FormatParametersAttribute";
                /**
                SDP Frame Rate Attribute
                */
                AttributeType[AttributeType["FrameRateAttribute"] = 7] = "FrameRateAttribute";
                /**
                SDP Keywords Attribute
                */
                AttributeType[AttributeType["KeywordsAttribute"] = 8] = "KeywordsAttribute";
                /**
                SDP Language Attribute
                */
                AttributeType[AttributeType["LanguageAttribute"] = 9] = "LanguageAttribute";
                /**
                SDP Max Packet Time Attribute
                */
                AttributeType[AttributeType["MaxPacketTimeAttribute"] = 10] = "MaxPacketTimeAttribute";
                /**
                SDP Orientiation Attribute
                */
                AttributeType[AttributeType["OrientationAttribute"] = 11] = "OrientationAttribute";
                /**
                SDP Packet Time Attribute
                */
                AttributeType[AttributeType["PacketTimeAttribute"] = 12] = "PacketTimeAttribute";
                /**
                SDP Quality Attribute
                */
                AttributeType[AttributeType["QualityAttribute"] = 13] = "QualityAttribute";
                /**
                SDP Sdp Language Attribute
                */
                AttributeType[AttributeType["SdpLanguageAttribute"] = 14] = "SdpLanguageAttribute";
                /**
                SDP Setup Attribute
                */
                AttributeType[AttributeType["SetupAttribute"] = 15] = "SetupAttribute";
                /**
                SDP Tool  Attribute
                */
                AttributeType[AttributeType["ToolAttribute"] = 16] = "ToolAttribute";
                /**
                SDP Media Stream Id Semantic Attribute
                */
                AttributeType[AttributeType["MediaStreamIdSemanticAttribute"] = 17] = "MediaStreamIdSemanticAttribute";
                /**
                SDP Stream Id Attribute
                */
                AttributeType[AttributeType["MediaStreamIdAttribute"] = 18] = "MediaStreamIdAttribute";
                /**
                SDP Bundle-only Attribute
                */
                AttributeType[AttributeType["BundleOnlyAttribute"] = 40] = "BundleOnlyAttribute";
                /**
                SDP Ice Candidate Attribute
                */
                AttributeType[AttributeType["IceCandidateAttribute"] = 19] = "IceCandidateAttribute";
                /**
                SDP Ice Fingerprint Attribute
                */
                AttributeType[AttributeType["IceFingerprintAttribute"] = 20] = "IceFingerprintAttribute";
                /**
                SDP Ice Lite Attribute
                */
                AttributeType[AttributeType["IceLiteAttribute"] = 21] = "IceLiteAttribute";
                /**
                SDP Ice Mismatch Attribute
                */
                AttributeType[AttributeType["IceMismatchAttribute"] = 22] = "IceMismatchAttribute";
                /**
                SDP Ice Options Attribute
                */
                AttributeType[AttributeType["IceOptionsAttribute"] = 23] = "IceOptionsAttribute";
                /**
                SDP Ice Password Attribute
                */
                AttributeType[AttributeType["IcePasswordAttribute"] = 24] = "IcePasswordAttribute";
                /**
                SDP Ice Ufrag Attribute
                */
                AttributeType[AttributeType["IceUfragAttribute"] = 25] = "IceUfragAttribute";
                /**
                SDP Ice Remote Candidates Attribute
                */
                AttributeType[AttributeType["IceRemoteCandidatesAttribute"] = 26] = "IceRemoteCandidatesAttribute";
                /**
                SDP RTP Map Attribute
                */
                AttributeType[AttributeType["RtpMapAttribute"] = 27] = "RtpMapAttribute";
                /**
                SDP RTP SSRC Attribute
                */
                AttributeType[AttributeType["RtpSsrcAttribute"] = 28] = "RtpSsrcAttribute";
                /**
                SDP RTP Extension Map Attribute (https://tools.ietf.org/html/rfc5285#section-5)
                */
                AttributeType[AttributeType["RtpExtMapAttribute"] = 29] = "RtpExtMapAttribute";
                /**
                SDP RTCP Attribute
                */
                AttributeType[AttributeType["RtcpAttribute"] = 30] = "RtcpAttribute";
                /**
                SDP RTCP Feedback Attribute
                */
                AttributeType[AttributeType["RtcpFeedbackAttribute"] = 31] = "RtcpFeedbackAttribute";
                /**
                SDP RTCP Mux Attribute
                */
                AttributeType[AttributeType["RtcpMuxAttribute"] = 32] = "RtcpMuxAttribute";
                /**
                SDP SCTP Port Attribute
                */
                AttributeType[AttributeType["SctpPortAttribute"] = 33] = "SctpPortAttribute";
                /**
                SDP SCTP Map Attribute
                */
                AttributeType[AttributeType["SctpMapAttribute"] = 34] = "SctpMapAttribute";
                /**
                SDP SCTP Max Message Size Attribute
                */
                AttributeType[AttributeType["SctpMaxMessageSizeAttribute"] = 35] = "SctpMaxMessageSizeAttribute";
                /**
                SDP Group Attribute
                */
                AttributeType[AttributeType["GroupAttribute"] = 36] = "GroupAttribute";
                /**
                SDP RTP RID Attribute
                */
                AttributeType[AttributeType["RtpRidAttribute"] = 37] = "RtpRidAttribute";
                /**
                SDP Simulcast Attribute
                */
                AttributeType[AttributeType["SimulcastAttribute"] = 38] = "SimulcastAttribute";
                /**
                SDP RTP SSRC Group Attribute
                */
                AttributeType[AttributeType["RtpSsrcGroupAttribute"] = 39] = "RtpSsrcGroupAttribute";
            })(AttributeType = sdp.AttributeType || (sdp.AttributeType = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            SDP Group Semantics
            */
            var GroupSemanticsType;
            (function (GroupSemanticsType) {
                /**
                An application that receives a session description that contains "m" lines that are grouped together using LS semantics MUST synchronize the playout of the corresponding media streams.Note that LS semantics not only apply to a video stream that has to be synchronized with an audio stream.The playout of two streams of the same type can be synchronized as well.
                */
                GroupSemanticsType[GroupSemanticsType["LipSynchronization"] = 1] = "LipSynchronization";
                /**
                An "m" line in an SDP session description defines a media stream. However, SDP does not define what a media stream is.  This definition can be found in the RTSP specification.The RTSP RFC[5] defines a media stream as "a single media instance, e.g., an audio stream or a video stream as well as a single whiteboard or shared application group. When using RTP, a stream consists of all RTP and RTCP packets created by a source within an RTP session".
                */
                GroupSemanticsType[GroupSemanticsType["FlowIdentification"] = 2] = "FlowIdentification";
                /**
                The extension can be used with the Session Description Protocol(SDP) Offer/Answer mechanism[RFC3264] to negotiate which "m=" sections will become part of a BUNDLE group.
                */
                GroupSemanticsType[GroupSemanticsType["Bundling"] = 3] = "Bundling";
                /**
                Unknown Group semantics type.
                */
                GroupSemanticsType[GroupSemanticsType["Unknown"] = 4] = "Unknown";
            })(GroupSemanticsType = sdp.GroupSemanticsType || (sdp.GroupSemanticsType = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var ice;
            (function (ice) {
                /**
                A list of known types for [[fm.liveswitch.sdp.ice.optionTag]].
                */
                var OptionTagType;
                (function (OptionTagType) {
                    /**
                    Indicates an unknown option tag.
                    */
                    OptionTagType[OptionTagType["Unknown"] = 1] = "Unknown";
                    /**
                    Indicates the trickle-ice option tag.
                    */
                    OptionTagType[OptionTagType["Trickle"] = 2] = "Trickle";
                })(OptionTagType = ice.OptionTagType || (ice.OptionTagType = {}));
            })(ice = sdp.ice || (sdp.ice = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            Media Stream Id Semantic Tokens
            */
            var MediaStreamIdSemanticToken;
            (function (MediaStreamIdSemanticToken) {
                /**
                WebRTC Media Stream Semantic
                */
                MediaStreamIdSemanticToken[MediaStreamIdSemanticToken["Wms"] = 1] = "Wms";
            })(MediaStreamIdSemanticToken = sdp.MediaStreamIdSemanticToken || (sdp.MediaStreamIdSemanticToken = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A session description type.
        */
        var SessionDescriptionType;
        (function (SessionDescriptionType) {
            /**
            Indicates an offer.
            */
            SessionDescriptionType[SessionDescriptionType["Offer"] = 1] = "Offer";
            /**
            Indicates an answer.
            */
            SessionDescriptionType[SessionDescriptionType["Answer"] = 2] = "Answer";
        })(SessionDescriptionType = liveswitch.SessionDescriptionType || (liveswitch.SessionDescriptionType = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A stream direction.
        */
        var StreamDirection;
        (function (StreamDirection) {
            /**
            Indicates a stream that can send and can receive.
            */
            StreamDirection[StreamDirection["SendReceive"] = 1] = "SendReceive";
            /**
            Indicates a stream that can send.
            */
            StreamDirection[StreamDirection["SendOnly"] = 2] = "SendOnly";
            /**
            Indicates a stream that can receive.
            */
            StreamDirection[StreamDirection["ReceiveOnly"] = 3] = "ReceiveOnly";
            /**
            Indicates a stream that cannot send or receive.
            */
            StreamDirection[StreamDirection["Inactive"] = 4] = "Inactive";
            /**
            Indicates that a stream direction has not been set.
            */
            StreamDirection[StreamDirection["Unset"] = 5] = "Unset";
        })(StreamDirection = liveswitch.StreamDirection || (liveswitch.StreamDirection = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The state of a stream.
        */
        var StreamState;
        (function (StreamState) {
            /**
            Indicates that the stream is new and has not been started.
            */
            StreamState[StreamState["New"] = 1] = "New";
            /**
            Indicates that the stream is being initialized but no connecting attempts have been made.
            */
            StreamState[StreamState["Initializing"] = 2] = "Initializing";
            /**
            Indicates that the stream is currently connecting.
            */
            StreamState[StreamState["Connecting"] = 3] = "Connecting";
            /**
            Indicates that the stream is currently connected.
            */
            StreamState[StreamState["Connected"] = 4] = "Connected";
            /**
            Indicates that the stream has encountered an error and is cleaning up.
            */
            StreamState[StreamState["Failing"] = 5] = "Failing";
            /**
            Indicates that the stream has encountered an error and has cleaned up.
            */
            StreamState[StreamState["Failed"] = 6] = "Failed";
            /**
            Indicates that the stream has been instructed to close and is cleaning up.
            */
            StreamState[StreamState["Closing"] = 7] = "Closing";
            /**
            Indicates that the stream has been instructed to close and has cleaned up.
            */
            StreamState[StreamState["Closed"] = 8] = "Closed";
        })(StreamState = liveswitch.StreamState || (liveswitch.StreamState = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A stream type.
        */
        var StreamType;
        (function (StreamType) {
            /**
            Indicates an audio stream.
            */
            StreamType[StreamType["Audio"] = 1] = "Audio";
            /**
            Indicates a video stream.
            */
            StreamType[StreamType["Video"] = 2] = "Video";
            /**
            Indicates an application stream.
            */
            StreamType[StreamType["Application"] = 3] = "Application";
            /**
            Indicates a message stream.
            */
            StreamType[StreamType["Message"] = 4] = "Message";
            /**
            Indicates a text stream.
            */
            StreamType[StreamType["Text"] = 5] = "Text";
        })(StreamType = liveswitch.StreamType || (liveswitch.StreamType = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The CCM TMMBN policy.
        */
        var CcmTmmbnPolicy;
        (function (CcmTmmbnPolicy) {
            /**
            The usage of CCM TMMBN is disabled.
            */
            CcmTmmbnPolicy[CcmTmmbnPolicy["Disabled"] = 1] = "Disabled";
            /**
            The usage of CCM TMMBN is negotiated with the peer.
            */
            CcmTmmbnPolicy[CcmTmmbnPolicy["Negotiated"] = 2] = "Negotiated";
        })(CcmTmmbnPolicy = liveswitch.CcmTmmbnPolicy || (liveswitch.CcmTmmbnPolicy = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The CCM TMMBR policy.
        */
        var CcmTmmbrPolicy;
        (function (CcmTmmbrPolicy) {
            /**
            The usage of CCM TMMBR is disabled.
            */
            CcmTmmbrPolicy[CcmTmmbrPolicy["Disabled"] = 1] = "Disabled";
            /**
            The usage of CCM TMMBR is negotiated with the peer.
            */
            CcmTmmbrPolicy[CcmTmmbrPolicy["Negotiated"] = 2] = "Negotiated";
        })(CcmTmmbrPolicy = liveswitch.CcmTmmbrPolicy || (liveswitch.CcmTmmbrPolicy = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A video type.
        */
        var VideoType;
        (function (VideoType) {
            /**
            Indicates an unknown type.
            */
            VideoType[VideoType["Unknown"] = 1] = "Unknown";
            /**
            Indicates camera-based video.
            */
            VideoType[VideoType["Camera"] = 2] = "Camera";
            /**
            Indicates screen-based video.
            */
            VideoType[VideoType["Screen"] = 3] = "Screen";
        })(VideoType = liveswitch.VideoType || (liveswitch.VideoType = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A video degradation preference.
        */
        var VideoDegradationPreference;
        (function (VideoDegradationPreference) {
            /**
            Indicates a preference to automate the degradation preference based on the video type. A video type of [[fm.liveswitch.videoType.Screen]] will prefer to degrade [[fm.liveswitch.videoDegradationPreference.FrameRate]]. A video type of [[fm.liveswitch.videoType.Camera]] will prefer to degrade [[fm.liveswitch.videoDegradationPreference.Resolution]]. A video type of [[fm.liveswitch.videoType.Unknown]] will prefer a [[fm.liveswitch.videoDegradationPreference.Balanced]] approach.
            */
            VideoDegradationPreference[VideoDegradationPreference["Automatic"] = 1] = "Automatic";
            /**
            Indicates a preference to degrade both frame-rate and resolution together in smaller increments.
            */
            VideoDegradationPreference[VideoDegradationPreference["Balanced"] = 2] = "Balanced";
            /**
            Indicates a preference to degrade frame-rate instead of resolution.
            */
            VideoDegradationPreference[VideoDegradationPreference["FrameRate"] = 3] = "FrameRate";
            /**
            Indicates a preference to degrade resolution instead of frame-rate.
            */
            VideoDegradationPreference[VideoDegradationPreference["Resolution"] = 4] = "Resolution";
        })(VideoDegradationPreference = liveswitch.VideoDegradationPreference || (liveswitch.VideoDegradationPreference = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The CCM LRR policy.
        */
        var CcmLrrPolicy;
        (function (CcmLrrPolicy) {
            /**
            The usage of CCM LRR is disabled.
            */
            CcmLrrPolicy[CcmLrrPolicy["Disabled"] = 1] = "Disabled";
            /**
            The usage of CCM LRR is negotiated with the peer.
            */
            CcmLrrPolicy[CcmLrrPolicy["Negotiated"] = 2] = "Negotiated";
        })(CcmLrrPolicy = liveswitch.CcmLrrPolicy || (liveswitch.CcmLrrPolicy = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The CCM FIR policy.
        */
        var CcmFirPolicy;
        (function (CcmFirPolicy) {
            /**
            The usage of CCM FIR is disabled.
            */
            CcmFirPolicy[CcmFirPolicy["Disabled"] = 1] = "Disabled";
            /**
            The usage of CCM FIR is negotiated with the peer.
            */
            CcmFirPolicy[CcmFirPolicy["Negotiated"] = 2] = "Negotiated";
        })(CcmFirPolicy = liveswitch.CcmFirPolicy || (liveswitch.CcmFirPolicy = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The NACK PLI policy.
        */
        var NackPliPolicy;
        (function (NackPliPolicy) {
            /**
            The usage of NACK PLI is disabled.
            */
            NackPliPolicy[NackPliPolicy["Disabled"] = 1] = "Disabled";
            /**
            The usage of NACK PLI is negotiated with the peer.
            */
            NackPliPolicy[NackPliPolicy["Negotiated"] = 2] = "Negotiated";
        })(NackPliPolicy = liveswitch.NackPliPolicy || (liveswitch.NackPliPolicy = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The simulcast mode.
        */
        var SimulcastMode;
        (function (SimulcastMode) {
            /**
            Simulcast will not be signalled.
            */
            SimulcastMode[SimulcastMode["Disabled"] = 1] = "Disabled";
            /**
            Simulcast will be signalled using RTP stream identifiers and the "simulcast" media attribute.
            */
            SimulcastMode[SimulcastMode["RtpStreamId"] = 3] = "RtpStreamId";
        })(SimulcastMode = liveswitch.SimulcastMode || (liveswitch.SimulcastMode = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The local bundle negotiation policy. Denotes the policy this peer uses when negotiating resulting connection bundling policy.
        */
        var BundlePolicy;
        (function (BundlePolicy) {
            /**
            Indicates that the first media section of each type will contain transport parameters. The second and any subsequent media sections of each type will be marked as "bundle only".
            */
            BundlePolicy[BundlePolicy["Balanced"] = 1] = "Balanced";
            /**
            Indicates that all media sections will contain transport parameters. No media sections will be marked as "bundle only".
            */
            BundlePolicy[BundlePolicy["MaxCompatibility"] = 2] = "MaxCompatibility";
            /**
            Indicates that only the first media section will contain transport parameters. All other media sections will be marked as "bundle only".
            */
            BundlePolicy[BundlePolicy["MaxBundle"] = 3] = "MaxBundle";
            /**
            Indicates that all media sections will contain transport parameters. No support for bundling.
            */
            BundlePolicy[BundlePolicy["Disabled"] = 4] = "Disabled";
        })(BundlePolicy = liveswitch.BundlePolicy || (liveswitch.BundlePolicy = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Indicates encryption policy for a connection.
        */
        var EncryptionPolicy;
        (function (EncryptionPolicy) {
            /**
            Encryption is required. If encryption is not supported by peer, connection must fail.
            */
            EncryptionPolicy[EncryptionPolicy["Required"] = 1] = "Required";
            /**
            Encryption is preferred but not required. If the other peer does not support encryption, connection will be established without encryption.
            */
            EncryptionPolicy[EncryptionPolicy["Negotiated"] = 2] = "Negotiated";
            /**
            Encryption will not be available for the given connection.
            */
            EncryptionPolicy[EncryptionPolicy["Disabled"] = 3] = "Disabled";
        })(EncryptionPolicy = liveswitch.EncryptionPolicy || (liveswitch.EncryptionPolicy = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The state of an ICE gatherer.
        */
        var IceConnectionState;
        (function (IceConnectionState) {
            /**
            Indicates that the ICE agent(s) is(are) gathering addresses or is(are) waiting to be given remote candidates (or both)..
            */
            IceConnectionState[IceConnectionState["New"] = 1] = "New";
            /**
            Indicates that the ICE agent(s) has(ve) been given one or more remote candidates and is(are) checking pairs of local and remote candidates against one another to try to find a compatible match, but has(ve) not yet found a pair which will allow the peer connection to be made. It's possible that gathering of candidates is also still underway.
            */
            IceConnectionState[IceConnectionState["Checking"] = 2] = "Checking";
            /**
            Indicates that a usable pairing of local and remote candidates has been found for all components of the connection, and the connection has been established. It's possible that gathering is still underway, and it's also possible that the ICE agent is still checking candidates against one another looking for a better connection to use.
            */
            IceConnectionState[IceConnectionState["Connected"] = 3] = "Connected";
            /**
            Indicates that the ICE agent has finished gathering candidates, has checked all pairs against one another, and has found a connection for all components.
            */
            IceConnectionState[IceConnectionState["Completed"] = 4] = "Completed";
            /**
            Indicates that the ICE candidate has checked all candidates pairs against one another and has failed to find compatible matches for all components of the connection. It is, however, possible that the ICE agent did find compatible connections for some components.
            */
            IceConnectionState[IceConnectionState["Failed"] = 5] = "Failed";
            /**
            Indicates that checks to ensure that components are still connected failed for at least one component of the RTCPeerConnection. This is a less stringent test than "failed" and may trigger intermittently and resolve just as spontaneously on less reliable networks, or during temporary disconnections. When the problem resolves, the connection may return to the "Connected" state.
            */
            IceConnectionState[IceConnectionState["Disconnected"] = 6] = "Disconnected";
            /**
            The ICE agent(s) for this RTCPeerConnection has shut down and is no longer handling requests
            */
            IceConnectionState[IceConnectionState["Closed"] = 7] = "Closed";
        })(IceConnectionState = liveswitch.IceConnectionState || (liveswitch.IceConnectionState = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The state of an ICE gatherer.
        */
        var IceGatheringState;
        (function (IceGatheringState) {
            /**
            Indicates that the gatherer has been created and no gathering has occurred yet.
            */
            IceGatheringState[IceGatheringState["New"] = 1] = "New";
            /**
            Indicates that the gatherer is in the process of gathering candidates.
            */
            IceGatheringState[IceGatheringState["Gathering"] = 2] = "Gathering";
            /**
            Indicates that the gatherer has completed gathering candidates.
            */
            IceGatheringState[IceGatheringState["Complete"] = 3] = "Complete";
            /**
            Indicates that the gatherer has started closing intentionally via a call to stop.
            */
            IceGatheringState[IceGatheringState["Closing"] = 4] = "Closing";
            /**
            Indicates that the gatherer has been closed intentionally via a call to stop.
            */
            IceGatheringState[IceGatheringState["Closed"] = 5] = "Closed";
            /**
            Indicates that the gatherer failed due to an error.
            */
            IceGatheringState[IceGatheringState["Failed"] = 6] = "Failed";
        })(IceGatheringState = liveswitch.IceGatheringState || (liveswitch.IceGatheringState = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The local policy for gathering candidates.
        */
        var IceGatherPolicy;
        (function (IceGatherPolicy) {
            /**
            All candidates (host, reflexive, and relay) will be gathered.
            */
            IceGatherPolicy[IceGatherPolicy["All"] = 1] = "All";
            /**
            Only reflexive and relay candidates will be gathered.
            */
            IceGatherPolicy[IceGatherPolicy["NoHost"] = 2] = "NoHost";
            /**
            Only relay candidates will be gathered.
            */
            IceGatherPolicy[IceGatherPolicy["Relay"] = 3] = "Relay";
        })(IceGatherPolicy = liveswitch.IceGatherPolicy || (liveswitch.IceGatherPolicy = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A layout alignment definition.
        */
        var LayoutAlignment;
        (function (LayoutAlignment) {
            /**
            Indicates a top-left alignment.
            */
            LayoutAlignment[LayoutAlignment["TopLeft"] = 1] = "TopLeft";
            /**
            Indicates a top-center alignment.
            */
            LayoutAlignment[LayoutAlignment["Top"] = 2] = "Top";
            /**
            Indicates a top-right alignment.
            */
            LayoutAlignment[LayoutAlignment["TopRight"] = 3] = "TopRight";
            /**
            Indicates a center-left alignment.
            */
            LayoutAlignment[LayoutAlignment["Left"] = 4] = "Left";
            /**
            Indicates a center-center alignment.
            */
            LayoutAlignment[LayoutAlignment["Center"] = 5] = "Center";
            /**
            Indicates a center-right alignment.
            */
            LayoutAlignment[LayoutAlignment["Right"] = 6] = "Right";
            /**
            Indicates a bottom-left alignment.
            */
            LayoutAlignment[LayoutAlignment["BottomLeft"] = 7] = "BottomLeft";
            /**
            Indicates a bottom-center alignment.
            */
            LayoutAlignment[LayoutAlignment["Bottom"] = 8] = "Bottom";
            /**
            Indicates a bottom-right alignment.
            */
            LayoutAlignment[LayoutAlignment["BottomRight"] = 9] = "BottomRight";
        })(LayoutAlignment = liveswitch.LayoutAlignment || (liveswitch.LayoutAlignment = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Specifies the direction of the layout flow.
        */
        var LayoutDirection;
        (function (LayoutDirection) {
            /**
            Indicates that the layout should flow horizontally, filling rows as needed.
            */
            LayoutDirection[LayoutDirection["Horizontal"] = 1] = "Horizontal";
            /**
            Indicates that the layout should flow vertically, filling columns as needed.
            */
            LayoutDirection[LayoutDirection["Vertical"] = 2] = "Vertical";
        })(LayoutDirection = liveswitch.LayoutDirection || (liveswitch.LayoutDirection = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Specifies the layout mode that should be used.
        */
        var LayoutMode;
        (function (LayoutMode) {
            /**
            Indicates that the local video feed should be displayed as a floating element above the remote video feeds.
            */
            LayoutMode[LayoutMode["FloatLocal"] = 1] = "FloatLocal";
            /**
            Indicates that the remote video feeds should be displayed as floating elements above the local video feed.
            */
            LayoutMode[LayoutMode["FloatRemote"] = 2] = "FloatRemote";
            /**
            Indicates that the video feed should be displayed as a block element on its own row/column, separate from other video feeds.
            */
            LayoutMode[LayoutMode["Block"] = 3] = "Block";
            /**
            Indicates that the video feed should be displayed as an inline element that shares a row/column with other video feeds.
            */
            LayoutMode[LayoutMode["Inline"] = 4] = "Inline";
            /**
            Indicates that the video feed should be displayed as an inline element that shares a row/column with other video feeds, allowing container overflow as needed.
            */
            LayoutMode[LayoutMode["InlineOverflow"] = 5] = "InlineOverflow";
        })(LayoutMode = liveswitch.LayoutMode || (liveswitch.LayoutMode = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A layout origin definition.
        */
        var LayoutOrigin;
        (function (LayoutOrigin) {
            /**
            Indicates an origin where 0,0 is in the top-left corner.
            */
            LayoutOrigin[LayoutOrigin["TopLeft"] = 1] = "TopLeft";
            /**
            Indicates an origin where 0,0 is in the top-right corner.
            */
            LayoutOrigin[LayoutOrigin["TopRight"] = 2] = "TopRight";
            /**
            Indicates an origin where 0,0 is in the bottom-right corner.
            */
            LayoutOrigin[LayoutOrigin["BottomRight"] = 3] = "BottomRight";
            /**
            Indicates an origin where 0,0 is in the bottom-left corner.
            */
            LayoutOrigin[LayoutOrigin["BottomLeft"] = 4] = "BottomLeft";
        })(LayoutOrigin = liveswitch.LayoutOrigin || (liveswitch.LayoutOrigin = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The state of local media.
        */
        var LocalMediaState;
        (function (LocalMediaState) {
            /**
            Indicates that the local media has not been started yet.
            */
            LocalMediaState[LocalMediaState["New"] = 1] = "New";
            /**
            Indicates that the local media is starting.
            */
            LocalMediaState[LocalMediaState["Starting"] = 2] = "Starting";
            /**
            Indicates that the local media has started.
            */
            LocalMediaState[LocalMediaState["Started"] = 3] = "Started";
            /**
            Indicates that the local media is stopping.
            */
            LocalMediaState[LocalMediaState["Stopping"] = 4] = "Stopping";
            /**
            Indicates that the local media has stopped.
            */
            LocalMediaState[LocalMediaState["Stopped"] = 5] = "Stopped";
            /**
            Indicates that the local media is being destroyed.
            */
            LocalMediaState[LocalMediaState["Destroying"] = 6] = "Destroying";
            /**
            Indicates that the local media has been destroyed.
            */
            LocalMediaState[LocalMediaState["Destroyed"] = 7] = "Destroyed";
        })(LocalMediaState = liveswitch.LocalMediaState || (liveswitch.LocalMediaState = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The local policy for the use of generic RTP Negative Acknowledgements (NACK). Cf. https://tools.ietf.org/html/draft-ietf-rtcweb-rtp-usage-26  NackPolicy is for enabling/configuring negative acknowledgement. Negative acknowledgements are used by media receivers to request that a media sender retransmit a packet. It is highly effective for video in low-latency networks since video is stateful and the cost of losing a packet is high. It is far less effective for audio, where any delay is especially harmful and the cost of losing a packet is not significant. Because of this, it is enabled by default for video and disabled by default for audio. You can modify the buffer size using NackConfig, but generally, it should be left with default values. The option to set these values will most likely be removed in a future release as our adaptive algorithms improve.
        */
        var NackPolicy;
        (function (NackPolicy) {
            /**
            The usage of generic NACKs is disabled.
            */
            NackPolicy[NackPolicy["Disabled"] = 1] = "Disabled";
            /**
            The usage of generic NACKs is negotiated with the peer.
            */
            NackPolicy[NackPolicy["Negotiated"] = 2] = "Negotiated";
        })(NackPolicy = liveswitch.NackPolicy || (liveswitch.NackPolicy = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The local policy for the RED Forward Error Correction support. Cf. https://tools.ietf.org/html/draft-ietf-rtcweb-fec-04  RedFecPolicy is for enabling/configuring forward error correction. Forward error correction adds redundancy to the media stream (increased bandwidth) with the intention that media receivers can recover from packet loss without requiring the media server to retransmit anything. It is a last resort for high latency networks. It is disabled by default and not currently supported as it does not have sufficient test coverage.
        */
        var RedFecPolicy;
        (function (RedFecPolicy) {
            /**
            The usage of RED FEC is disabled.
            */
            RedFecPolicy[RedFecPolicy["Disabled"] = 1] = "Disabled";
            /**
            The usage of RED FEC is negotiated with the peer.
            */
            RedFecPolicy[RedFecPolicy["Negotiated"] = 2] = "Negotiated";
        })(RedFecPolicy = liveswitch.RedFecPolicy || (liveswitch.RedFecPolicy = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The local policy for the use of Receiver Estimated Maximum Bitrates (goog-remb). Cf. https://tools.ietf.org/html/draft-alvestrand-rmcat-remb-03
        */
        var RembPolicy;
        (function (RembPolicy) {
            /**
            The usage of goog-rembs is disabled.
            */
            RembPolicy[RembPolicy["Disabled"] = 1] = "Disabled";
            /**
            The usage of goog-rembs is negotiated with the peer.
            */
            RembPolicy[RembPolicy["Negotiated"] = 2] = "Negotiated";
        })(RembPolicy = liveswitch.RembPolicy || (liveswitch.RembPolicy = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var rtp;
        (function (rtp) {
            /** @hidden */
            var HeaderExtensionForm;
            (function (HeaderExtensionForm) {
                HeaderExtensionForm[HeaderExtensionForm["OneByte"] = 1] = "OneByte";
                HeaderExtensionForm[HeaderExtensionForm["TwoByte"] = 2] = "TwoByte";
            })(HeaderExtensionForm = rtp.HeaderExtensionForm || (rtp.HeaderExtensionForm = {}));
        })(rtp = liveswitch.rtp || (liveswitch.rtp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Indicates Sdes policy for stream.
        */
        var SdesPolicy;
        (function (SdesPolicy) {
            /**
            Sdes is preferred but not required. If stream type is compatible (i.e. not a DataStream) Crypto attributes will be included in the session description.
            */
            SdesPolicy[SdesPolicy["Negotiated"] = 2] = "Negotiated";
            /**
            Sdes is disabled. Crypto attributes will not be included in the session description.
            */
            SdesPolicy[SdesPolicy["Disabled"] = 3] = "Disabled";
        })(SdesPolicy = liveswitch.SdesPolicy || (liveswitch.SdesPolicy = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The signalling state of a connection.
        */
        var SignallingState;
        (function (SignallingState) {
            /**
            Indicates that no offer/answer exchange ever occurred.
            */
            SignallingState[SignallingState["New"] = 1] = "New";
            /**
            Indicates that the connection has a local offer and remote answer is outstanding.
            */
            SignallingState[SignallingState["HaveLocalOffer"] = 2] = "HaveLocalOffer";
            /**
            Indicates that the connection has a remote offer and local answer is outstanding.
            */
            SignallingState[SignallingState["HaveRemoteOffer"] = 3] = "HaveRemoteOffer";
            /**
            Indicates that for each offer there is a matching answer.
            */
            SignallingState[SignallingState["Stable"] = 4] = "Stable";
        })(SignallingState = liveswitch.SignallingState || (liveswitch.SignallingState = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var TransportType;
        (function (TransportType) {
            TransportType[TransportType["Gatherer"] = 1] = "Gatherer";
            TransportType[TransportType["IceTransport"] = 2] = "IceTransport";
            TransportType[TransportType["DtlsTransport"] = 3] = "DtlsTransport";
            TransportType[TransportType["SctpTransport"] = 4] = "SctpTransport";
            TransportType[TransportType["ReliableDataTransport"] = 5] = "ReliableDataTransport";
            TransportType[TransportType["SrtpTransport"] = 6] = "SrtpTransport";
            TransportType[TransportType["Unset"] = 7] = "Unset";
            TransportType[TransportType["MediaTransport"] = 8] = "MediaTransport";
        })(TransportType = liveswitch.TransportType || (liveswitch.TransportType = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The local policy for TrickleIce support. Cf. https://tools.ietf.org/html/draft-ietf-ice-trickle-04
        */
        var TrickleIcePolicy;
        (function (TrickleIcePolicy) {
            /**
            A Trickle ICE mode of operation where the offerer gathers all of the possible candidates strictly before creating and sending the offer.
            */
            TrickleIcePolicy[TrickleIcePolicy["NotSupported"] = 1] = "NotSupported";
            /**
            The regular mode of operation for Trickle ICE agents, in which an initial offer can include any number of candidates (even zero candidates) and does not need to include the entire first generation of candidates as in half trickle.
            */
            TrickleIcePolicy[TrickleIcePolicy["FullTrickle"] = 2] = "FullTrickle";
            /**
            A Trickle ICE mode of operation where the offerer gathers its first generation of candidates strictly before creating and sending the offer. Once sent, that offer can be processed by Vanilla ICE agents and does not require support for this specification. It also allows Trickle ICE capable answerers to still gather candidates and perform connectivity checks in a non-blocking way, thus roughly offering "half" the advantages of Trickle ICE. The mechanism is mostly meant for use in cases where support for Trickle ICE cannot be confirmed prior to sending an initial offer.
            */
            TrickleIcePolicy[TrickleIcePolicy["HalfTrickle"] = 3] = "HalfTrickle";
        })(TrickleIcePolicy = liveswitch.TrickleIcePolicy || (liveswitch.TrickleIcePolicy = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A peer role.
        */
        var PeerRole;
        (function (PeerRole) {
            /**
            The offering role.
            */
            PeerRole[PeerRole["Offerer"] = 1] = "Offerer";
            /**
            The answering role.
            */
            PeerRole[PeerRole["Answerer"] = 2] = "Answerer";
        })(PeerRole = liveswitch.PeerRole || (liveswitch.PeerRole = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var FailureSource;
        (function (FailureSource) {
            FailureSource[FailureSource["None"] = 1] = "None";
            FailureSource[FailureSource["Network"] = 2] = "Network";
            FailureSource[FailureSource["Message"] = 3] = "Message";
        })(FailureSource = liveswitch.FailureSource || (liveswitch.FailureSource = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The state of a client.
        */
        var ClientState;
        (function (ClientState) {
            /**
            Indicates that the client is new and has not yet registered with the gateway.
            */
            ClientState[ClientState["New"] = 1] = "New";
            /**
            Indicates that the client is registering with the gateway.
            */
            ClientState[ClientState["Registering"] = 2] = "Registering";
            /**
            Indicates that the client is registered with the gateway.
            */
            ClientState[ClientState["Registered"] = 3] = "Registered";
            /**
            Indicates that the client is unregistering with the gateway.
            */
            ClientState[ClientState["Unregistering"] = 4] = "Unregistering";
            /**
            Indicates that the client is unregistered with the gateway.
            */
            ClientState[ClientState["Unregistered"] = 5] = "Unregistered";
        })(ClientState = liveswitch.ClientState || (liveswitch.ClientState = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        The invite feedback states.
        */
        var InvitationState;
        (function (InvitationState) {
            /**
            Gets the unknown state.
            */
            InvitationState[InvitationState["Unknown"] = 1] = "Unknown";
            /**
            Gets the state for "pending". This state is for when no feedback has been received yet.
            */
            InvitationState[InvitationState["Pending"] = 2] = "Pending";
            /**
            Gets the state for "proceeding". This state is for when we are waiting for the invited party to respond.
            */
            InvitationState[InvitationState["Proceeding"] = 3] = "Proceeding";
            /**
            Gets the state for "sent". This state is for when the invite is sent in a way that does not allow feedback to be returned.
            */
            InvitationState[InvitationState["Sent"] = 4] = "Sent";
            /**
            Gets the state for "canceled". This state is for when the invite has been canceled.
            */
            InvitationState[InvitationState["Cancelled"] = 5] = "Cancelled";
            /**
            Gets the state for "cancelling". This state is for when the invite is in the process of being cancelled. May fail due to timing.
            */
            InvitationState[InvitationState["Cancelling"] = 6] = "Cancelling";
            /**
            Gets the state for "rejected". This state is for when the invitation was explicitly rejected.
            */
            InvitationState[InvitationState["Rejected"] = 7] = "Rejected";
            /**
            Gets the state for "accepted". This state is for when the invitation was accepted.
            */
            InvitationState[InvitationState["Accepted"] = 8] = "Accepted";
            /**
            Gets the state for "notFound". This state is for when the invited user id cannot be found.
            */
            InvitationState[InvitationState["NotFound"] = 9] = "NotFound";
            /**
            Gets the state for "busy". This state is for when the invited user signals they are busy.
            */
            InvitationState[InvitationState["Busy"] = 10] = "Busy";
            /**
            Gets the state for "noResponse". This state is for when the invitation did not receive a response.
            */
            InvitationState[InvitationState["NoResponse"] = 11] = "NoResponse";
            /**
            Gets the state for "invalid". This state is when the invitation cannot be processed.
            */
            InvitationState[InvitationState["Invalid"] = 12] = "Invalid";
            /**
            Gets the state for "alreadyInvited". This state is when another invite for the same user id, protocol, and channel already exists.
            */
            InvitationState[InvitationState["AlreadyInvited"] = 13] = "AlreadyInvited";
        })(InvitationState = liveswitch.InvitationState || (liveswitch.InvitationState = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientState;
            (function (ClientState) {
                ClientState[ClientState["New"] = 1] = "New";
                ClientState[ClientState["Connecting"] = 2] = "Connecting";
                ClientState[ClientState["Connected"] = 3] = "Connected";
                ClientState[ClientState["Disconnecting"] = 4] = "Disconnecting";
                ClientState[ClientState["Disconnected"] = 5] = "Disconnected";
            })(ClientState = signalling.ClientState || (signalling.ClientState = {}));
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ConcurrencyMode;
            (function (ConcurrencyMode) {
                ConcurrencyMode[ConcurrencyMode["Low"] = 1] = "Low";
                ConcurrencyMode[ConcurrencyMode["High"] = 2] = "High";
                ConcurrencyMode[ConcurrencyMode["Default"] = 1] = "Default";
            })(ConcurrencyMode = signalling.ConcurrencyMode || (signalling.ConcurrencyMode = {}));
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ConnectionType;
            (function (ConnectionType) {
                ConnectionType[ConnectionType["WebSocket"] = 1] = "WebSocket";
                ConnectionType[ConnectionType["LongPolling"] = 2] = "LongPolling";
                ConnectionType[ConnectionType["CallbackPolling"] = 3] = "CallbackPolling";
                ConnectionType[ConnectionType["IFrame"] = 4] = "IFrame";
                ConnectionType[ConnectionType["Flash"] = 5] = "Flash";
                ConnectionType[ConnectionType["NotSet"] = 99] = "NotSet";
            })(ConnectionType = signalling.ConnectionType || (signalling.ConnectionType = {}));
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var MessageType;
            (function (MessageType) {
                MessageType[MessageType["Connect"] = 1] = "Connect";
                MessageType[MessageType["Disconnect"] = 2] = "Disconnect";
                MessageType[MessageType["Bind"] = 3] = "Bind";
                MessageType[MessageType["Unbind"] = 4] = "Unbind";
                MessageType[MessageType["Subscribe"] = 5] = "Subscribe";
                MessageType[MessageType["Unsubscribe"] = 6] = "Unsubscribe";
                MessageType[MessageType["Publish"] = 7] = "Publish";
                MessageType[MessageType["Service"] = 9] = "Service";
                MessageType[MessageType["Stream"] = 10] = "Stream";
                MessageType[MessageType["Unknown"] = 11] = "Unknown";
            })(MessageType = signalling.MessageType || (signalling.MessageType = {}));
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var PresenceType;
            (function (PresenceType) {
                PresenceType[PresenceType["Subscribe"] = 1] = "Subscribe";
                PresenceType[PresenceType["Unsubscribe"] = 2] = "Unsubscribe";
            })(PresenceType = signalling.PresenceType || (signalling.PresenceType = {}));
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var Reconnect;
            (function (Reconnect) {
                Reconnect[Reconnect["Retry"] = 1] = "Retry";
                Reconnect[Reconnect["Handshake"] = 2] = "Handshake";
                Reconnect[Reconnect["None"] = 3] = "None";
                Reconnect[Reconnect["NotSet"] = 99] = "NotSet";
            })(Reconnect = signalling.Reconnect || (signalling.Reconnect = {}));
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var CryptoLibraryWrapper = /** @class */ (function () {
            function CryptoLibraryWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_2 = __arguments[0];
                    //super();
                    this._value = value_2;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            CryptoLibraryWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.CryptoLibraryWrapper]';
            };
            CryptoLibraryWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.CryptoLibrary.Default)
                        return 'Default';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return CryptoLibraryWrapper;
        }());
        liveswitch.CryptoLibraryWrapper = CryptoLibraryWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A data buffer pool tracer.
        */
        var DataBufferPoolTracer = /** @class */ (function () {
            /**
            Initializes a new instance of the [[fm.liveswitch.dataBufferPoolTracer]] class.
            */
            function DataBufferPoolTracer(tag, pool) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 2) {
                    var tag_2 = __arguments[0];
                    var pool_1 = __arguments[1];
                    //super();
                    if ((fm.liveswitch.Global.equals(tag_2, null))) {
                        throw new fm.liveswitch.Exception("Tag cannot be null.");
                    }
                    if ((fm.liveswitch.Global.equals(pool_1, null))) {
                        throw new fm.liveswitch.Exception("Pool cannot be null.");
                    }
                    this.setTag(tag_2);
                    this.setPool(pool_1);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            DataBufferPoolTracer.prototype.getTypeString = function () {
                return '[fm.liveswitch.DataBufferPoolTracer]';
            };
            /**
            Gets the underlying pool.
            */
            DataBufferPoolTracer.prototype.getPool = function () {
                if (arguments.length == 0) {
                    return this._pool;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the traced usage statistics.
            */
            DataBufferPoolTracer.prototype.getStatistics = function () {
                if (arguments.length == 0) {
                    return this.getPool().getOrAddTraceStatistics(this.getTag());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the tag that identifies requests to the underlying pool.
            */
            DataBufferPoolTracer.prototype.getTag = function () {
                if (arguments.length == 0) {
                    return this._tag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataBufferPoolTracer.prototype.setPool = function (value) {
                if (arguments.length == 1) {
                    this._pool = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataBufferPoolTracer.prototype.setTag = function (value) {
                if (arguments.length == 1) {
                    this._tag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBufferPoolTracer.prototype.take = function () {
                if (arguments.length == 1) {
                    var size = arguments[0];
                    return this.getPool().traceTake(size, this.getTag());
                }
                else if (arguments.length == 2) {
                    var size = arguments[0];
                    var littleEndian = arguments[1];
                    return this.getPool().traceTake(size, littleEndian, this.getTag());
                }
                else if (arguments.length == 3) {
                    var size = arguments[0];
                    var littleEndian = arguments[1];
                    var clearBytes = arguments[2];
                    return this.getPool().traceTake(size, littleEndian, clearBytes, this.getTag());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return DataBufferPoolTracer;
        }());
        liveswitch.DataBufferPoolTracer = DataBufferPoolTracer;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var PendingPromise = /** @class */ (function () {
            function PendingPromise(promise, result) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 2) {
                    var promise_1 = __arguments[0];
                    var result_2 = __arguments[1];
                    //super();
                    this.__promise = promise_1;
                    this.__result = result_2;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            PendingPromise.prototype.getTypeString = function () {
                return '[fm.liveswitch.PendingPromise]';
            };
            PendingPromise.prototype.reject = function (ex) {
                if (arguments.length == 1) {
                    this.__promise.reject(ex);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            PendingPromise.prototype.resolve = function () {
                if (arguments.length == 0) {
                    this.__promise.castAndResolve(this.__result);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return PendingPromise;
        }());
        liveswitch.PendingPromise = PendingPromise;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A system clock.
        */
        var SystemClock = /** @class */ (function () {
            function SystemClock() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            SystemClock.prototype.getTypeString = function () {
                return '[fm.liveswitch.SystemClock]';
            };
            /**
            Gets the current system timestamp in ticks. 10,000 ticks is equal to 1 millisecond.
            @return The current system timestamp in ticks.
            */
            SystemClock.prototype.getTimestamp = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ManagedStopwatch.getTimestamp();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return SystemClock;
        }());
        liveswitch.SystemClock = SystemClock;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var AddressTypeWrapper = /** @class */ (function () {
            function AddressTypeWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_3 = __arguments[0];
                    //super();
                    this._value = value_3;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            AddressTypeWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.AddressTypeWrapper]';
            };
            AddressTypeWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.AddressType.IPv4)
                        return 'IPv4';
                    if (this._value == fm.liveswitch.AddressType.IPv6)
                        return 'IPv6';
                    if (this._value == fm.liveswitch.AddressType.Unknown)
                        return 'Unknown';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return AddressTypeWrapper;
        }());
        liveswitch.AddressTypeWrapper = AddressTypeWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        ASCII encoding/decoding utility.
        */
        var Ascii = /** @class */ (function () {
            function Ascii() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Ascii.prototype.getTypeString = function () {
                return '[fm.liveswitch.Ascii]';
            };
            Ascii.decode = function () {
                if (arguments.length == 1) {
                    var input = arguments[0];
                    return fm.liveswitch.Ascii.decode(input, 0, input.length);
                }
                else if (arguments.length == 3) {
                    var input = arguments[0];
                    var index = arguments[1];
                    var length_9 = arguments[2];
                    return fm.liveswitch.Encoding.getAscii().getString(input, index, length_9);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Encodes a string to a UTF-8 byte array.
            @param input The input string.
            */
            Ascii.encode = function (input) {
                if (arguments.length == 1) {
                    return fm.liveswitch.Encoding.getAscii().getBytes(input);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes that would be returned by a call to encode.
            @param input The input string.
            */
            Ascii.getByteCount = function (input) {
                if (arguments.length == 1) {
                    return fm.liveswitch.Encoding.getAscii().getByteCount(input);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Ascii;
        }());
        liveswitch.Ascii = Ascii;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A managed mutex.
        */
        var AtomicMutex = /** @class */ (function () {
            /**
            Creates a new instance of an AtomicMutex.
            */
            function AtomicMutex() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.__lock = new fm.liveswitch.AtomicInteger(0);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            AtomicMutex.prototype.getTypeString = function () {
                return '[fm.liveswitch.AtomicMutex]';
            };
            /**
            Gets if the mutex is locked or not.
            */
            AtomicMutex.prototype.getIsLocked = function () {
                if (arguments.length == 0) {
                    return (fm.liveswitch.Global.equals(this.__lock.getValue(), 1));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Releases the lock.
            */
            AtomicMutex.prototype.release = function () {
                if (arguments.length == 0) {
                    this.__lock.compareAndSwap(1, 0);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to obtain a lock with this thread.
            */
            AtomicMutex.prototype.tryLock = function () {
                if (arguments.length == 0) {
                    return (fm.liveswitch.Global.equals(this.__lock.compareAndSwap(0, 1), 0));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return AtomicMutex;
        }());
        liveswitch.AtomicMutex = AtomicMutex;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Common binary methods.
        */
        var Binary = /** @class */ (function () {
            function Binary() {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Binary.prototype.getTypeString = function () {
                return '[fm.liveswitch.Binary]';
            };
            Binary.bitStringToBytes = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 1) {
                    var bitString = arguments[0];
                    var numberOfUnusedBits = 0;
                    var _var0 = new fm.liveswitch.Holder(numberOfUnusedBits);
                    var _var1 = fm.liveswitch.Binary.bitStringToBytes(bitString, _var0);
                    numberOfUnusedBits = _var0.getValue();
                    return _var1;
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.Holder<number>]'))) {
                    var bitString = arguments[0];
                    var numberOfUnusedBits = arguments[1];
                    var _var0 = fm.liveswitch.Binary.bitStringToBytes(bitString, false, numberOfUnusedBits);
                    return _var0;
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isBoolean(arguments[1]))) {
                    var bitString = arguments[0];
                    var padLeft = arguments[1];
                    var numberOfUnusedBits = 0;
                    var _var0 = new fm.liveswitch.Holder(numberOfUnusedBits);
                    var _var1 = fm.liveswitch.Binary.bitStringToBytes(bitString, padLeft, _var0);
                    numberOfUnusedBits = _var0.getValue();
                    return _var1;
                }
                else if (arguments.length == 3) {
                    var bitString = arguments[0];
                    var padLeft = arguments[1];
                    var numberOfUnusedBits = arguments[2];
                    var num = (fm.liveswitch.StringExtensions.getLength(bitString) % 8);
                    numberOfUnusedBits.setValue(0);
                    if ((num > 0)) {
                        numberOfUnusedBits.setValue((8 - num));
                        for (var j = 0; (j < numberOfUnusedBits.getValue()); j++) {
                            if (padLeft) {
                                bitString = fm.liveswitch.StringExtensions.concat("0", bitString);
                            }
                            else {
                                bitString = fm.liveswitch.StringExtensions.concat(bitString, "0");
                            }
                        }
                    }
                    var buffer = new Uint8Array(fm.liveswitch.MathAssistant.floor(fm.liveswitch.StringExtensions.getLength(bitString) / 8));
                    var index = 0;
                    for (var i = 0; (index < buffer.length); i = (i + 8)) {
                        var flag = (!fm.liveswitch.Global.equals(bitString.charCodeAt(i), 48));
                        var flag2 = (!fm.liveswitch.Global.equals(bitString.charCodeAt((i + 1)), 48));
                        var flag3 = (!fm.liveswitch.Global.equals(bitString.charCodeAt((i + 2)), 48));
                        var flag4 = (!fm.liveswitch.Global.equals(bitString.charCodeAt((i + 3)), 48));
                        var flag5 = (!fm.liveswitch.Global.equals(bitString.charCodeAt((i + 4)), 48));
                        var flag6 = (!fm.liveswitch.Global.equals(bitString.charCodeAt((i + 5)), 48));
                        var flag7 = (!fm.liveswitch.Global.equals(bitString.charCodeAt((i + 6)), 48));
                        var flag8 = (!fm.liveswitch.Global.equals(bitString.charCodeAt((i + 7)), 48));
                        var num5 = 0;
                        if (flag) {
                            num5 = (num5 + 128);
                        }
                        if (flag2) {
                            num5 = (num5 + 64);
                        }
                        if (flag3) {
                            num5 = (num5 + 32);
                        }
                        if (flag4) {
                            num5 = (num5 + 16);
                        }
                        if (flag5) {
                            num5 = (num5 + 8);
                        }
                        if (flag6) {
                            num5 = (num5 + 4);
                        }
                        if (flag7) {
                            num5 = (num5 + 2);
                        }
                        if (flag8) {
                            num5++;
                        }
                        buffer[index] = fm.liveswitch.BitAssistant.castByte(num5);
                        index++;
                    }
                    return buffer;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.bytesToBitString = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 1) {
                    var bytes = arguments[0];
                    return fm.liveswitch.Binary.bytesToBitString(bytes, 0, bytes.length);
                }
                else if (arguments.length == 3) {
                    var bytes = arguments[0];
                    var offset = arguments[1];
                    var length_10 = arguments[2];
                    return fm.liveswitch.Binary.bytesToBitString(bytes, offset, length_10, 0);
                }
                else if (arguments.length == 4) {
                    var bytes = arguments[0];
                    var offset = arguments[1];
                    var length_11 = arguments[2];
                    var numberOfUnusedBits = arguments[3];
                    return fm.liveswitch.Binary.bytesToBitString(bytes, offset, length_11, numberOfUnusedBits, false);
                }
                else if (arguments.length == 5) {
                    var bytes = arguments[0];
                    var offset = arguments[1];
                    var length_12 = arguments[2];
                    var numberOfUnusedBits = arguments[3];
                    var trimLeft = arguments[4];
                    var str = "";
                    for (var i = offset; (i < (offset + length_12)); i++) {
                        var num2 = bytes[i];
                        var flag = (fm.liveswitch.Global.equals((num2 & 128), 128));
                        var flag2 = (fm.liveswitch.Global.equals((num2 & 64), 64));
                        var flag3 = (fm.liveswitch.Global.equals((num2 & 32), 32));
                        var flag4 = (fm.liveswitch.Global.equals((num2 & 16), 16));
                        var flag5 = (fm.liveswitch.Global.equals((num2 & 8), 8));
                        var flag6 = (fm.liveswitch.Global.equals((num2 & 4), 4));
                        var flag7 = (fm.liveswitch.Global.equals((num2 & 2), 2));
                        var flag8 = (fm.liveswitch.Global.equals((num2 & 1), 1));
                        str = fm.liveswitch.StringExtensions.concat(str, fm.liveswitch.StringExtensions.format("{0}{1}{2}{3}{4}{5}{6}{7}", [(flag ? "1" : "0"), (flag2 ? "1" : "0"), (flag3 ? "1" : "0"), (flag4 ? "1" : "0"), (flag5 ? "1" : "0"), (flag6 ? "1" : "0"), (flag7 ? "1" : "0"), (flag8 ? "1" : "0")]));
                    }
                    if (trimLeft) {
                        return fm.liveswitch.StringExtensions.substring(str, numberOfUnusedBits, (fm.liveswitch.StringExtensions.getLength(str) - numberOfUnusedBits));
                    }
                    return fm.liveswitch.StringExtensions.substring(str, 0, (fm.liveswitch.StringExtensions.getLength(str) - numberOfUnusedBits));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.deinterleave = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 2) {
                    var inputFrame = arguments[0];
                    var outputFrame = arguments[1];
                    fm.liveswitch.Binary.deinterleave(inputFrame, outputFrame, 0, inputFrame.length, false);
                }
                else if (arguments.length == 4) {
                    var inputFrame = arguments[0];
                    var outputFrame = arguments[1];
                    var start = arguments[2];
                    var length_13 = arguments[3];
                    fm.liveswitch.Binary.deinterleave(inputFrame, outputFrame, start, length_13, false);
                }
                else if (arguments.length == 5) {
                    var inputFrame = arguments[0];
                    var outputFrame = arguments[1];
                    var start = arguments[2];
                    var length_14 = arguments[3];
                    var reversePlanes = arguments[4];
                    var num = (start + length_14);
                    var num2 = fm.liveswitch.MathAssistant.floor(length_14 / 2);
                    if ((num > outputFrame.length)) {
                        fm.liveswitch.Log.error("start + length greater than outputFrame length");
                    }
                    else {
                        var num3 = void 0;
                        var num4 = void 0;
                        if (reversePlanes) {
                            num3 = (start + num2);
                            num4 = start;
                        }
                        else {
                            num3 = start;
                            num4 = (start + num2);
                        }
                        for (var i = start; (i < num); i = (i + 2)) {
                            outputFrame[num3++] = inputFrame[i];
                            outputFrame[num4++] = inputFrame[(i + 1)];
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.deinterleaveTransform = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 6) {
                    var inputFrame = arguments[0];
                    var outputFrame = arguments[1];
                    var width = arguments[2];
                    var height = arguments[3];
                    var stride = arguments[4];
                    var rotation = arguments[5];
                    fm.liveswitch.Binary.deinterleaveTransform(inputFrame, outputFrame, width, height, stride, rotation, 0, false);
                }
                else if (arguments.length == 7) {
                    var inputFrame = arguments[0];
                    var outputFrame = arguments[1];
                    var width = arguments[2];
                    var height = arguments[3];
                    var stride = arguments[4];
                    var rotation = arguments[5];
                    var start = arguments[6];
                    fm.liveswitch.Binary.deinterleaveTransform(inputFrame, outputFrame, width, height, stride, rotation, start, false);
                }
                else if (arguments.length == 8) {
                    var inputFrame = arguments[0];
                    var outputFrame = arguments[1];
                    var width = arguments[2];
                    var height = arguments[3];
                    var stride = arguments[4];
                    var rotation = arguments[5];
                    var start = arguments[6];
                    var reversePlanes = arguments[7];
                    var num = (width * height);
                    var length_15 = (num * 2);
                    var num3 = (stride - width);
                    var num4 = (start + length_15);
                    if ((num4 > outputFrame.length)) {
                        fm.liveswitch.Log.error("start + length greater than outputFrame length");
                    }
                    else {
                        var num5 = void 0;
                        var num6 = void 0;
                        var num9 = void 0;
                        var num10 = void 0;
                        if (reversePlanes) {
                            num5 = (start + num);
                            num6 = start;
                        }
                        else {
                            num5 = start;
                            num6 = (start + num);
                        }
                        var num7 = (height + 1);
                        var numArray = new Array(num7);
                        var num8 = (width * 2);
                        for (num9 = 0; (num9 < num7); num9++) {
                            numArray[num9] = ((num8 * num9) + start);
                            if ((num9 > 1)) {
                                numArray[num9] = (numArray[num9] + (num3 * (num9 - 1)));
                            }
                        }
                        if ((fm.liveswitch.Global.equals(rotation, 270))) {
                            for (num9 = 1; (num9 <= num8); num9 = (num9 + 2)) {
                                num10 = 1;
                                while ((num10 < num7)) {
                                    outputFrame[num5++] = inputFrame[(numArray[num10] - (num9 + 1))];
                                    outputFrame[num6++] = inputFrame[(numArray[num10] - num9)];
                                    num10++;
                                }
                            }
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(rotation, 90))) {
                                for (num9 = 0; (num9 < num8); num9 = (num9 + 2)) {
                                    for (num10 = (num7 - 2); (num10 >= 0); num10--) {
                                        outputFrame[num5++] = inputFrame[(numArray[num10] + num9)];
                                        outputFrame[num6++] = inputFrame[(numArray[num10] + (num9 + 1))];
                                    }
                                }
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(rotation, 180))) {
                                    for (num9 = ((start + length_15) - 1); (num9 >= start); num9 = (num9 - 2)) {
                                        outputFrame[num5++] = inputFrame[(num9 - 1)];
                                        outputFrame[num6++] = inputFrame[num9];
                                    }
                                }
                                else {
                                    fm.liveswitch.Binary.deinterleave(inputFrame, outputFrame, start, length_15, reversePlanes);
                                }
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 1-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @return The value.
            */
            Binary.fromBytes1 = function (input, inputIndex, bitOffset) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        inputIndex++;
                    }
                    return (fm.liveswitch.Global.equals((fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes8(input, inputIndex), (7 - bitOffset)) & 1), 1));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 10-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @return The value.
            */
            Binary.fromBytes10 = function (input, inputIndex, bitOffset) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        inputIndex++;
                    }
                    if ((bitOffset >= 7)) {
                        if (((inputIndex + 2) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes24(input, inputIndex, false), (14 - bitOffset)) & 1023);
                        }
                    }
                    else {
                        if (((inputIndex + 1) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes16(input, inputIndex, false), (6 - bitOffset)) & 1023);
                        }
                    }
                    throw new fm.liveswitch.Exception("Input data is not large enough to read 10 bits.");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 11-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @return The value.
            */
            Binary.fromBytes11 = function (input, inputIndex, bitOffset) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        inputIndex++;
                    }
                    if ((bitOffset >= 6)) {
                        if (((inputIndex + 2) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes24(input, inputIndex, false), (13 - bitOffset)) & 2047);
                        }
                    }
                    else {
                        if (((inputIndex + 1) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes16(input, inputIndex, false), (5 - bitOffset)) & 2047);
                        }
                    }
                    throw new fm.liveswitch.Exception("Input data is not large enough to read 11 bits.");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 12-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @return The value.
            */
            Binary.fromBytes12 = function (input, inputIndex, bitOffset) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        inputIndex++;
                    }
                    if ((bitOffset >= 5)) {
                        if (((inputIndex + 2) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes24(input, inputIndex, false), (12 - bitOffset)) & 4095);
                        }
                    }
                    else {
                        if (((inputIndex + 1) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes16(input, inputIndex, false), (4 - bitOffset)) & 4095);
                        }
                    }
                    throw new fm.liveswitch.Exception("Input data is not large enough to read 12 bits.");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 13-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @return The value.
            */
            Binary.fromBytes13 = function (input, inputIndex, bitOffset) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        inputIndex++;
                    }
                    if ((bitOffset >= 4)) {
                        if (((inputIndex + 2) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes24(input, inputIndex, false), (11 - bitOffset)) & 8191);
                        }
                    }
                    else {
                        if (((inputIndex + 1) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes16(input, inputIndex, false), (3 - bitOffset)) & 8191);
                        }
                    }
                    throw new fm.liveswitch.Exception("Input data is not large enough to read 13 bits.");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 14-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @return The value.
            */
            Binary.fromBytes14 = function (input, inputIndex, bitOffset) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        inputIndex++;
                    }
                    if ((bitOffset >= 3)) {
                        if (((inputIndex + 2) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes24(input, inputIndex, false), (10 - bitOffset)) & 16383);
                        }
                    }
                    else {
                        if (((inputIndex + 1) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes16(input, inputIndex, false), (2 - bitOffset)) & 16383);
                        }
                    }
                    throw new fm.liveswitch.Exception("Input data is not large enough to read 14 bits.");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 15-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @return The value.
            */
            Binary.fromBytes15 = function (input, inputIndex, bitOffset) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        inputIndex++;
                    }
                    if ((bitOffset >= 2)) {
                        if (((inputIndex + 2) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes24(input, inputIndex, false), (9 - bitOffset)) & 32767);
                        }
                    }
                    else {
                        if (((inputIndex + 1) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes16(input, inputIndex, false), (1 - bitOffset)) & 32767);
                        }
                    }
                    throw new fm.liveswitch.Exception("Input data is not large enough to read 15 bits.");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 16-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param littleEndian Whether to use little-endian format.
            @return The value.
            */
            Binary.fromBytes16 = function (input, inputIndex, littleEndian) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    var num = 0;
                    if (littleEndian) {
                        num = (num | fm.liveswitch.BitAssistant.leftShiftInteger(fm.liveswitch.BitAssistant.castInteger(input[inputIndex++]), 0));
                        return (num | fm.liveswitch.BitAssistant.leftShiftInteger(fm.liveswitch.BitAssistant.castInteger(input[inputIndex++]), 8));
                    }
                    num = (num | fm.liveswitch.BitAssistant.leftShiftInteger(fm.liveswitch.BitAssistant.castInteger(input[inputIndex++]), 8));
                    return (num | fm.liveswitch.BitAssistant.leftShiftInteger(fm.liveswitch.BitAssistant.castInteger(input[inputIndex++]), 0));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads an 17-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @return The value.
            */
            Binary.fromBytes17 = function (input, inputIndex, bitOffset) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        inputIndex++;
                    }
                    return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes24(input, inputIndex, false), (7 - bitOffset)) & 131071);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads an 18-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @return The value.
            */
            Binary.fromBytes18 = function (input, inputIndex, bitOffset) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        inputIndex++;
                    }
                    if ((bitOffset >= 7)) {
                        if (((inputIndex + 3) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftLong(fm.liveswitch.Binary.fromBytes32(input, inputIndex, false), (14 - bitOffset)) & 262143);
                        }
                    }
                    else {
                        if (((inputIndex + 2) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes24(input, inputIndex, false), (6 - bitOffset)) & 262143);
                        }
                    }
                    throw new fm.liveswitch.Exception("Input data is not large enough to read 18 bits.");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads an 19-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @return The value.
            */
            Binary.fromBytes19 = function (input, inputIndex, bitOffset) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        inputIndex++;
                    }
                    if ((bitOffset >= 6)) {
                        if (((inputIndex + 3) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftLong(fm.liveswitch.Binary.fromBytes32(input, inputIndex, false), (13 - bitOffset)) & 524287);
                        }
                    }
                    else {
                        if (((inputIndex + 2) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes24(input, inputIndex, false), (5 - bitOffset)) & 524287);
                        }
                    }
                    throw new fm.liveswitch.Exception("Input data is not large enough to read 19 bits.");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 2-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @return The value.
            */
            Binary.fromBytes2 = function (input, inputIndex, bitOffset) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        inputIndex++;
                    }
                    return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes8(input, inputIndex), (6 - bitOffset)) & 3);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads an 20-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @return The value.
            */
            Binary.fromBytes20 = function (input, inputIndex, bitOffset) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        inputIndex++;
                    }
                    if ((bitOffset >= 5)) {
                        if (((inputIndex + 3) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftLong(fm.liveswitch.Binary.fromBytes32(input, inputIndex, false), (12 - bitOffset)) & 1048575);
                        }
                    }
                    else {
                        if (((inputIndex + 2) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes24(input, inputIndex, false), (4 - bitOffset)) & 1048575);
                        }
                    }
                    throw new fm.liveswitch.Exception("Input data is not large enough to read 20 bits.");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads an 21-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @return The value.
            */
            Binary.fromBytes21 = function (input, inputIndex, bitOffset) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        inputIndex++;
                    }
                    if ((bitOffset >= 4)) {
                        if (((inputIndex + 3) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftLong(fm.liveswitch.Binary.fromBytes32(input, inputIndex, false), (11 - bitOffset)) & 2097151);
                        }
                    }
                    else {
                        if (((inputIndex + 2) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes24(input, inputIndex, false), (3 - bitOffset)) & 2097151);
                        }
                    }
                    throw new fm.liveswitch.Exception("Input data is not large enough to read 21 bits.");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads an 22-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @return The value.
            */
            Binary.fromBytes22 = function (input, inputIndex, bitOffset) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        inputIndex++;
                    }
                    if ((bitOffset >= 3)) {
                        if (((inputIndex + 3) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftLong(fm.liveswitch.Binary.fromBytes32(input, inputIndex, false), (10 - bitOffset)) & 4194303);
                        }
                    }
                    else {
                        if (((inputIndex + 2) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes24(input, inputIndex, false), (2 - bitOffset)) & 4194303);
                        }
                    }
                    throw new fm.liveswitch.Exception("Input data is not large enough to read 22 bits.");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads an 23-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @return The value.
            */
            Binary.fromBytes23 = function (input, inputIndex, bitOffset) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        inputIndex++;
                    }
                    if ((bitOffset >= 2)) {
                        if (((inputIndex + 3) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftLong(fm.liveswitch.Binary.fromBytes32(input, inputIndex, false), (9 - bitOffset)) & 8388607);
                        }
                    }
                    else {
                        if (((inputIndex + 2) < input.length)) {
                            return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes24(input, inputIndex, false), (1 - bitOffset)) & 8388607);
                        }
                    }
                    throw new fm.liveswitch.Exception("Input data is not large enough to read 23 bits.");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 24-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param littleEndian Whether to use little-endian format.
            @return The value.
            */
            Binary.fromBytes24 = function (input, inputIndex, littleEndian) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    var num = 0;
                    if (littleEndian) {
                        num = (num | fm.liveswitch.BitAssistant.leftShiftInteger(fm.liveswitch.BitAssistant.castInteger(input[inputIndex++]), 0));
                        num = (num | fm.liveswitch.BitAssistant.leftShiftInteger(fm.liveswitch.BitAssistant.castInteger(input[inputIndex++]), 8));
                        return (num | fm.liveswitch.BitAssistant.leftShiftInteger(fm.liveswitch.BitAssistant.castInteger(input[inputIndex++]), 16));
                    }
                    num = (num | fm.liveswitch.BitAssistant.leftShiftInteger(fm.liveswitch.BitAssistant.castInteger(input[inputIndex++]), 16));
                    num = (num | fm.liveswitch.BitAssistant.leftShiftInteger(fm.liveswitch.BitAssistant.castInteger(input[inputIndex++]), 8));
                    return (num | fm.liveswitch.BitAssistant.leftShiftInteger(fm.liveswitch.BitAssistant.castInteger(input[inputIndex++]), 0));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 3-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @return The value.
            */
            Binary.fromBytes3 = function (input, inputIndex, bitOffset) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        inputIndex++;
                    }
                    return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes8(input, inputIndex), (5 - bitOffset)) & 7);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 32-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param littleEndian Whether to use little-endian format.
            @return The value.
            */
            Binary.fromBytes32 = function (input, inputIndex, littleEndian) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    var num = 0;
                    if (littleEndian) {
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 0));
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 8));
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 16));
                        return (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 24));
                    }
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 24));
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 16));
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 8));
                    return (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 0));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 4-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @return The value.
            */
            Binary.fromBytes4 = function (input, inputIndex, bitOffset) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        inputIndex++;
                    }
                    return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes8(input, inputIndex), (4 - bitOffset)) & 15);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 40-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param littleEndian Whether to use little-endian format.
            @return The value.
            */
            Binary.fromBytes40 = function (input, inputIndex, littleEndian) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    var num = 0;
                    if (littleEndian) {
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 0));
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 8));
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 16));
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 24));
                        return (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 32));
                    }
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 32));
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 24));
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 16));
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 8));
                    return (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 0));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 48-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param littleEndian Whether to use little-endian format.
            @return The value.
            */
            Binary.fromBytes48 = function (input, inputIndex, littleEndian) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    var num = 0;
                    if (littleEndian) {
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 0));
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 8));
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 16));
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 24));
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 32));
                        return (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 40));
                    }
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 40));
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 32));
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 24));
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 16));
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 8));
                    return (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 0));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 5-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @return The value.
            */
            Binary.fromBytes5 = function (input, inputIndex, bitOffset) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        inputIndex++;
                    }
                    return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes8(input, inputIndex), (3 - bitOffset)) & 31);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 56-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param littleEndian Whether to use little-endian format.
            @return The value.
            */
            Binary.fromBytes56 = function (input, inputIndex, littleEndian) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    var num = 0;
                    if (littleEndian) {
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 0));
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 8));
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 16));
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 24));
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 32));
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 40));
                        return (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 48));
                    }
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 48));
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 40));
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 32));
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 24));
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 16));
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 8));
                    return (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 0));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 6-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @return The value.
            */
            Binary.fromBytes6 = function (input, inputIndex, bitOffset) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        inputIndex++;
                    }
                    return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes8(input, inputIndex), (2 - bitOffset)) & 63);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 64-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param littleEndian Whether to use little-endian format.
            @return The value.
            */
            Binary.fromBytes64 = function (input, inputIndex, littleEndian) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    var num = 0;
                    if (littleEndian) {
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 0));
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 8));
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 16));
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 24));
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 32));
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 40));
                        num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 48));
                        return (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 56));
                    }
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 56));
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 48));
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 40));
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 32));
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 24));
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 16));
                    num = (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 8));
                    return (num | fm.liveswitch.BitAssistant.leftShiftLong(fm.liveswitch.BitAssistant.castLong(input[inputIndex++]), 0));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 7-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @return The value.
            */
            Binary.fromBytes7 = function (input, inputIndex, bitOffset) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        inputIndex++;
                    }
                    return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes8(input, inputIndex), (1 - bitOffset)) & 127);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads an 8-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @return The value.
            */
            Binary.fromBytes8 = function (input, inputIndex) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 2) {
                    return fm.liveswitch.BitAssistant.leftShiftInteger(fm.liveswitch.BitAssistant.castInteger(input[inputIndex]), 0);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 9-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @return The value.
            */
            Binary.fromBytes9 = function (input, inputIndex, bitOffset) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        inputIndex++;
                    }
                    if (((inputIndex + 1) >= input.length)) {
                        throw new fm.liveswitch.Exception("Input data is not large enough to read 9 bits.");
                    }
                    return (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fromBytes16(input, inputIndex, false), (7 - bitOffset)) & 511);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.interleave = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 2) {
                    var inputFrame = arguments[0];
                    var outputFrame = arguments[1];
                    fm.liveswitch.Binary.interleave(inputFrame, outputFrame, 0, inputFrame.length, false);
                }
                else if (arguments.length == 4) {
                    var inputFrame = arguments[0];
                    var outputFrame = arguments[1];
                    var start = arguments[2];
                    var length_16 = arguments[3];
                    fm.liveswitch.Binary.interleave(inputFrame, outputFrame, start, length_16, false);
                }
                else if (arguments.length == 5) {
                    var inputFrame = arguments[0];
                    var outputFrame = arguments[1];
                    var start = arguments[2];
                    var length_17 = arguments[3];
                    var reversePlanes = arguments[4];
                    var num = (start + length_17);
                    var num2 = fm.liveswitch.MathAssistant.floor(length_17 / 2);
                    if ((num > outputFrame.length)) {
                        fm.liveswitch.Log.error("start + length greater than outputFrame length");
                    }
                    else {
                        var num3 = void 0;
                        var num4 = void 0;
                        if (reversePlanes) {
                            num3 = (start + num2);
                            num4 = start;
                        }
                        else {
                            num3 = start;
                            num4 = (start + num2);
                        }
                        var num5 = 0;
                        for (var i = 0; (i < num2); i++) {
                            outputFrame[num5++] = inputFrame[(num3 + i)];
                            outputFrame[num5++] = inputFrame[(num4 + i)];
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.interleaveTransform = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 6) {
                    var inputFrame = arguments[0];
                    var outputFrame = arguments[1];
                    var width = arguments[2];
                    var height = arguments[3];
                    var stride = arguments[4];
                    var rotation = arguments[5];
                    fm.liveswitch.Binary.interleaveTransform(inputFrame, outputFrame, width, height, stride, rotation, 0, false);
                }
                else if (arguments.length == 7) {
                    var inputFrame = arguments[0];
                    var outputFrame = arguments[1];
                    var width = arguments[2];
                    var height = arguments[3];
                    var stride = arguments[4];
                    var rotation = arguments[5];
                    var start = arguments[6];
                    fm.liveswitch.Binary.interleaveTransform(inputFrame, outputFrame, width, height, stride, rotation, start, false);
                }
                else if (arguments.length == 8) {
                    var inputFrame = arguments[0];
                    var outputFrame = arguments[1];
                    var width = arguments[2];
                    var height = arguments[3];
                    var stride = arguments[4];
                    var rotation = arguments[5];
                    var start = arguments[6];
                    var reversePlanes = arguments[7];
                    var num = ((stride > 0) ? (stride * height) : (width * height));
                    var num2 = ((width * height) * 2);
                    var num3 = ((stride > 0) ? (stride - width) : width);
                    var num4 = (start + num2);
                    if ((num4 > outputFrame.length)) {
                        fm.liveswitch.Log.error("start + length greater than outputFrame length");
                    }
                    else {
                        var num5 = void 0;
                        var num6 = void 0;
                        var num9 = void 0;
                        var num11 = void 0;
                        if (reversePlanes) {
                            num5 = (start + num);
                            num6 = start;
                        }
                        else {
                            num5 = start;
                            num6 = (start + num);
                        }
                        var num7 = (height + 1);
                        var numArray = new Array(num7);
                        var num8 = width;
                        for (num9 = 0; (num9 < num7); num9++) {
                            numArray[num9] = (((num8 * num9) + start) + (num3 * (num9 - 1)));
                        }
                        var num10 = 0;
                        if ((fm.liveswitch.Global.equals(rotation, 270))) {
                            for (num9 = 1; (num9 <= num8); num9++) {
                                num11 = 1;
                                while ((num11 < num7)) {
                                    outputFrame[num10++] = inputFrame[((num5 + numArray[num11]) - num9)];
                                    outputFrame[num10++] = inputFrame[((num6 + numArray[num11]) - num9)];
                                    num11++;
                                }
                            }
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(rotation, 90))) {
                                for (num9 = 0; (num9 < num8); num9++) {
                                    for (num11 = (num7 - 2); (num11 >= 0); num11--) {
                                        outputFrame[num10++] = inputFrame[(((num5 + numArray[num11]) + num9) + num3)];
                                        outputFrame[num10++] = inputFrame[(((num6 + numArray[num11]) + num9) + num3)];
                                    }
                                }
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(rotation, 180))) {
                                    for (num9 = (num - 1); (num9 >= 0); num9--) {
                                        outputFrame[num10++] = inputFrame[(num5 + num9)];
                                        outputFrame[num10++] = inputFrame[(num6 + num9)];
                                    }
                                }
                                else {
                                    fm.liveswitch.Binary.interleave(inputFrame, outputFrame, start, (num * 2), reversePlanes);
                                }
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Binary.roundUp = function (value, multiple) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(multiple, 0))) {
                        return value;
                    }
                    var num = (value % multiple);
                    if ((fm.liveswitch.Global.equals(num, 0))) {
                        return value;
                    }
                    return ((value + multiple) - num);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Binary.toBytes = function (value, bitOffset, littleEndian, output, outputIndex, bitCount) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 6) {
                    var num4 = void 0;
                    var num5 = void 0;
                    if ((bitOffset >= 8)) {
                        return fm.liveswitch.Binary.toBytes(value, (bitOffset % 8), littleEndian, output, (outputIndex + fm.liveswitch.MathAssistant.floor(bitOffset / 8)), bitCount);
                    }
                    var num = fm.liveswitch.Binary.roundUp((bitCount + bitOffset), 8);
                    var num2 = fm.liveswitch.MathAssistant.floor(num / 8);
                    if (((outputIndex + num2) > output.length)) {
                        throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Output data is not large enough to write {0} bits.", fm.liveswitch.NumberExtensions.toString(bitCount)));
                    }
                    if (littleEndian) {
                        throw new fm.liveswitch.Exception("Little-endian bit-level serialization is not supported.");
                    }
                    var num3 = fm.liveswitch.BitAssistant.leftShiftInteger(value, ((num - bitCount) - bitOffset));
                    if ((num2 > 0)) {
                        num4 = (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fm_liveswitch_Binary___bitmasks[(bitCount - 1)][0], bitOffset) & 255);
                        num5 = (num - 8);
                        output[outputIndex] = ((output[outputIndex] & num4) | fm.liveswitch.BitAssistant.rightShiftInteger((num3 & fm.liveswitch.BitAssistant.leftShiftInteger(~num4, num5)), num5));
                        outputIndex++;
                    }
                    if ((num2 > 1)) {
                        num4 = (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fm_liveswitch_Binary___bitmasks[(bitCount - 1)][1], bitOffset) & 255);
                        num5 = (num - 16);
                        output[outputIndex] = ((output[outputIndex] & num4) | fm.liveswitch.BitAssistant.rightShiftInteger((num3 & fm.liveswitch.BitAssistant.leftShiftInteger(~num4, num5)), num5));
                        outputIndex++;
                    }
                    if ((num2 > 2)) {
                        num4 = (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fm_liveswitch_Binary___bitmasks[(bitCount - 1)][2], bitOffset) & 255);
                        num5 = (num - 24);
                        output[outputIndex] = ((output[outputIndex] & num4) | fm.liveswitch.BitAssistant.rightShiftInteger((num3 & fm.liveswitch.BitAssistant.leftShiftInteger(~num4, num5)), num5));
                        outputIndex++;
                    }
                    if ((num2 > 3)) {
                        num4 = (fm.liveswitch.BitAssistant.rightShiftInteger(fm.liveswitch.Binary.fm_liveswitch_Binary___bitmasks[(bitCount - 1)][3], bitOffset) & 255);
                        num5 = (num - 32);
                        output[outputIndex] = ((output[outputIndex] & num4) | fm.liveswitch.BitAssistant.rightShiftInteger((num3 & fm.liveswitch.BitAssistant.leftShiftInteger(~num4, num5)), num5));
                        outputIndex++;
                    }
                    return output;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes1 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 2) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var num = 1;
                    var outputIndex = 0;
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                        num++;
                    }
                    return fm.liveswitch.Binary.toBytes1(value, bitOffset, new Uint8Array(num), outputIndex);
                }
                else if (arguments.length == 4) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var output = arguments[2];
                    var outputIndex = arguments[3];
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                    }
                    return fm.liveswitch.Binary.toBytes((value ? 1 : 0), bitOffset, false, output, outputIndex, 1);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes10 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var num = 2;
                    var outputIndex = 0;
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                        num++;
                    }
                    if ((bitOffset >= 7)) {
                        return fm.liveswitch.Binary.toBytes10(value, bitOffset, littleEndian, new Uint8Array((num + 1)), outputIndex);
                    }
                    return fm.liveswitch.Binary.toBytes10(value, bitOffset, littleEndian, new Uint8Array(num), outputIndex);
                }
                else if (arguments.length == 5) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var output = arguments[3];
                    var outputIndex = arguments[4];
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                    }
                    return fm.liveswitch.Binary.toBytes(value, bitOffset, littleEndian, output, outputIndex, 10);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes11 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var num = 2;
                    var outputIndex = 0;
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                        num++;
                    }
                    if ((bitOffset >= 6)) {
                        return fm.liveswitch.Binary.toBytes11(value, bitOffset, littleEndian, new Uint8Array((num + 1)), outputIndex);
                    }
                    return fm.liveswitch.Binary.toBytes11(value, bitOffset, littleEndian, new Uint8Array(num), outputIndex);
                }
                else if (arguments.length == 5) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var output = arguments[3];
                    var outputIndex = arguments[4];
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                    }
                    return fm.liveswitch.Binary.toBytes(value, bitOffset, littleEndian, output, outputIndex, 11);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes12 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var num = 2;
                    var outputIndex = 0;
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                        num++;
                    }
                    if ((bitOffset >= 5)) {
                        return fm.liveswitch.Binary.toBytes12(value, bitOffset, littleEndian, new Uint8Array((num + 1)), outputIndex);
                    }
                    return fm.liveswitch.Binary.toBytes12(value, bitOffset, littleEndian, new Uint8Array(num), outputIndex);
                }
                else if (arguments.length == 5) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var output = arguments[3];
                    var outputIndex = arguments[4];
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                    }
                    return fm.liveswitch.Binary.toBytes(value, bitOffset, littleEndian, output, outputIndex, 12);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes13 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var num = 2;
                    var outputIndex = 0;
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                        num++;
                    }
                    if ((bitOffset >= 4)) {
                        return fm.liveswitch.Binary.toBytes13(value, bitOffset, littleEndian, new Uint8Array((num + 1)), outputIndex);
                    }
                    return fm.liveswitch.Binary.toBytes13(value, bitOffset, littleEndian, new Uint8Array(num), outputIndex);
                }
                else if (arguments.length == 5) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var output = arguments[3];
                    var outputIndex = arguments[4];
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                    }
                    return fm.liveswitch.Binary.toBytes(value, bitOffset, littleEndian, output, outputIndex, 13);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes14 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var num = 2;
                    var outputIndex = 0;
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                        num++;
                    }
                    if ((bitOffset >= 3)) {
                        return fm.liveswitch.Binary.toBytes14(value, bitOffset, littleEndian, new Uint8Array((num + 1)), outputIndex);
                    }
                    return fm.liveswitch.Binary.toBytes14(value, bitOffset, littleEndian, new Uint8Array(num), outputIndex);
                }
                else if (arguments.length == 5) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var output = arguments[3];
                    var outputIndex = arguments[4];
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                    }
                    return fm.liveswitch.Binary.toBytes(value, bitOffset, littleEndian, output, outputIndex, 14);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes15 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var num = 2;
                    var outputIndex = 0;
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                        num++;
                    }
                    if ((bitOffset >= 2)) {
                        return fm.liveswitch.Binary.toBytes15(value, bitOffset, littleEndian, new Uint8Array((num + 1)), outputIndex);
                    }
                    return fm.liveswitch.Binary.toBytes15(value, bitOffset, littleEndian, new Uint8Array(num), outputIndex);
                }
                else if (arguments.length == 5) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var output = arguments[3];
                    var outputIndex = arguments[4];
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                    }
                    return fm.liveswitch.Binary.toBytes(value, bitOffset, littleEndian, output, outputIndex, 15);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes16 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 2) {
                    var value = arguments[0];
                    var littleEndian = arguments[1];
                    return fm.liveswitch.Binary.toBytes16(value, littleEndian, new Uint8Array(2), 0);
                }
                else if (arguments.length == 4) {
                    var value = arguments[0];
                    var littleEndian = arguments[1];
                    var output = arguments[2];
                    var outputIndex = arguments[3];
                    if (((outputIndex + 1) < output.length)) {
                        if (littleEndian) {
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftInteger((value & 255), 0);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftInteger((value & 65280), 8);
                            return output;
                        }
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftInteger((value & 65280), 8);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftInteger((value & 255), 0);
                        return output;
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes17 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var num = 3;
                    var outputIndex = 0;
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                        num++;
                    }
                    return fm.liveswitch.Binary.toBytes17(value, bitOffset, littleEndian, new Uint8Array(num), outputIndex);
                }
                else if (arguments.length == 5) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var output = arguments[3];
                    var outputIndex = arguments[4];
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                    }
                    return fm.liveswitch.Binary.toBytes(value, bitOffset, littleEndian, output, outputIndex, 17);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes18 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var num = 3;
                    var outputIndex = 0;
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                        num++;
                    }
                    if ((bitOffset >= 7)) {
                        return fm.liveswitch.Binary.toBytes18(value, bitOffset, littleEndian, new Uint8Array((num + 1)), outputIndex);
                    }
                    return fm.liveswitch.Binary.toBytes18(value, bitOffset, littleEndian, new Uint8Array(num), outputIndex);
                }
                else if (arguments.length == 5) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var output = arguments[3];
                    var outputIndex = arguments[4];
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                    }
                    return fm.liveswitch.Binary.toBytes(value, bitOffset, littleEndian, output, outputIndex, 18);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes19 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var num = 3;
                    var outputIndex = 0;
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                        num++;
                    }
                    if ((bitOffset >= 6)) {
                        return fm.liveswitch.Binary.toBytes19(value, bitOffset, littleEndian, new Uint8Array((num + 1)), outputIndex);
                    }
                    return fm.liveswitch.Binary.toBytes19(value, bitOffset, littleEndian, new Uint8Array(num), outputIndex);
                }
                else if (arguments.length == 5) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var output = arguments[3];
                    var outputIndex = arguments[4];
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                    }
                    return fm.liveswitch.Binary.toBytes(value, bitOffset, littleEndian, output, outputIndex, 19);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes2 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 2) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var num = 1;
                    var outputIndex = 0;
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                        num++;
                    }
                    if ((bitOffset >= 7)) {
                        return fm.liveswitch.Binary.toBytes2(value, bitOffset, new Uint8Array((num + 1)), outputIndex);
                    }
                    return fm.liveswitch.Binary.toBytes2(value, bitOffset, new Uint8Array(num), outputIndex);
                }
                else if (arguments.length == 4) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var output = arguments[2];
                    var outputIndex = arguments[3];
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                    }
                    return fm.liveswitch.Binary.toBytes(value, bitOffset, false, output, outputIndex, 2);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes20 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var num = 3;
                    var outputIndex = 0;
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                        num++;
                    }
                    if ((bitOffset >= 5)) {
                        return fm.liveswitch.Binary.toBytes20(value, bitOffset, littleEndian, new Uint8Array((num + 1)), outputIndex);
                    }
                    return fm.liveswitch.Binary.toBytes20(value, bitOffset, littleEndian, new Uint8Array(num), outputIndex);
                }
                else if (arguments.length == 5) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var output = arguments[3];
                    var outputIndex = arguments[4];
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                    }
                    return fm.liveswitch.Binary.toBytes(value, bitOffset, littleEndian, output, outputIndex, 20);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes21 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var num = 3;
                    var outputIndex = 0;
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                        num++;
                    }
                    if ((bitOffset >= 4)) {
                        return fm.liveswitch.Binary.toBytes21(value, bitOffset, littleEndian, new Uint8Array((num + 1)), outputIndex);
                    }
                    return fm.liveswitch.Binary.toBytes21(value, bitOffset, littleEndian, new Uint8Array(num), outputIndex);
                }
                else if (arguments.length == 5) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var output = arguments[3];
                    var outputIndex = arguments[4];
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                    }
                    return fm.liveswitch.Binary.toBytes(value, bitOffset, littleEndian, output, outputIndex, 21);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes22 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var num = 3;
                    var outputIndex = 0;
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                        num++;
                    }
                    if ((bitOffset >= 3)) {
                        return fm.liveswitch.Binary.toBytes22(value, bitOffset, littleEndian, new Uint8Array((num + 1)), outputIndex);
                    }
                    return fm.liveswitch.Binary.toBytes22(value, bitOffset, littleEndian, new Uint8Array(num), outputIndex);
                }
                else if (arguments.length == 5) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var output = arguments[3];
                    var outputIndex = arguments[4];
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                    }
                    return fm.liveswitch.Binary.toBytes(value, bitOffset, false, output, outputIndex, 22);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes23 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var num = 3;
                    var outputIndex = 0;
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                        num++;
                    }
                    if ((bitOffset >= 2)) {
                        return fm.liveswitch.Binary.toBytes23(value, bitOffset, littleEndian, new Uint8Array((num + 1)), outputIndex);
                    }
                    return fm.liveswitch.Binary.toBytes23(value, bitOffset, littleEndian, new Uint8Array(num), outputIndex);
                }
                else if (arguments.length == 5) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var output = arguments[3];
                    var outputIndex = arguments[4];
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                    }
                    return fm.liveswitch.Binary.toBytes(value, bitOffset, littleEndian, output, outputIndex, 23);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes24 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 2) {
                    var value = arguments[0];
                    var littleEndian = arguments[1];
                    return fm.liveswitch.Binary.toBytes24(value, littleEndian, new Uint8Array(3), 0);
                }
                else if (arguments.length == 4) {
                    var value = arguments[0];
                    var littleEndian = arguments[1];
                    var output = arguments[2];
                    var outputIndex = arguments[3];
                    if (((outputIndex + 2) < output.length)) {
                        if (littleEndian) {
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftInteger((value & 255), 0);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftInteger((value & 65280), 8);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftInteger((value & 16711680), 16);
                            return output;
                        }
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftInteger((value & 16711680), 16);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftInteger((value & 65280), 8);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftInteger((value & 255), 0);
                        return output;
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes3 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 2) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var num = 1;
                    var outputIndex = 0;
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                        num++;
                    }
                    if ((bitOffset >= 6)) {
                        return fm.liveswitch.Binary.toBytes3(value, bitOffset, new Uint8Array((num + 1)), outputIndex);
                    }
                    return fm.liveswitch.Binary.toBytes3(value, bitOffset, new Uint8Array(num), outputIndex);
                }
                else if (arguments.length == 4) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var output = arguments[2];
                    var outputIndex = arguments[3];
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                    }
                    return fm.liveswitch.Binary.toBytes(value, bitOffset, false, output, outputIndex, 3);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes32 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 2) {
                    var value = arguments[0];
                    var littleEndian = arguments[1];
                    return fm.liveswitch.Binary.toBytes32(value, littleEndian, new Uint8Array(4), 0);
                }
                else if (arguments.length == 4) {
                    var value = arguments[0];
                    var littleEndian = arguments[1];
                    var output = arguments[2];
                    var outputIndex = arguments[3];
                    if (((outputIndex + 3) < output.length)) {
                        if (littleEndian) {
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 255), 0);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 65280), 8);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 16711680), 16);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 4278190080), 24);
                            return output;
                        }
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 4278190080), 24);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 16711680), 16);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 65280), 8);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 255), 0);
                        return output;
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes4 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 2) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var num = 1;
                    var outputIndex = 0;
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                        num++;
                    }
                    if ((bitOffset >= 5)) {
                        return fm.liveswitch.Binary.toBytes4(value, bitOffset, new Uint8Array((num + 1)), outputIndex);
                    }
                    return fm.liveswitch.Binary.toBytes4(value, bitOffset, new Uint8Array(num), outputIndex);
                }
                else if (arguments.length == 4) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var output = arguments[2];
                    var outputIndex = arguments[3];
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                    }
                    return fm.liveswitch.Binary.toBytes(value, bitOffset, false, output, outputIndex, 4);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes40 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 2) {
                    var value = arguments[0];
                    var littleEndian = arguments[1];
                    return fm.liveswitch.Binary.toBytes40(value, littleEndian, new Uint8Array(5), 0);
                }
                else if (arguments.length == 4) {
                    var value = arguments[0];
                    var littleEndian = arguments[1];
                    var output = arguments[2];
                    var outputIndex = arguments[3];
                    if (((outputIndex + 4) < output.length)) {
                        if (littleEndian) {
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 255), 0);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 65280), 8);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 16711680), 16);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 4278190080), 24);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 1095216660480), 32);
                            return output;
                        }
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 1095216660480), 32);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 4278190080), 24);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 16711680), 16);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 65280), 8);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 255), 0);
                        return output;
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes48 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 2) {
                    var value = arguments[0];
                    var littleEndian = arguments[1];
                    return fm.liveswitch.Binary.toBytes48(value, littleEndian, new Uint8Array(6), 0);
                }
                else if (arguments.length == 4) {
                    var value = arguments[0];
                    var littleEndian = arguments[1];
                    var output = arguments[2];
                    var outputIndex = arguments[3];
                    if (((outputIndex + 5) < output.length)) {
                        if (littleEndian) {
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 255), 0);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 65280), 8);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 16711680), 16);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 4278190080), 24);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 1095216660480), 32);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 280375465082880), 40);
                            return output;
                        }
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 280375465082880), 40);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 1095216660480), 32);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 4278190080), 24);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 16711680), 16);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 65280), 8);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 255), 0);
                        return output;
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes5 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 2) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var num = 1;
                    var outputIndex = 0;
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                        num++;
                    }
                    if ((bitOffset >= 4)) {
                        return fm.liveswitch.Binary.toBytes5(value, bitOffset, new Uint8Array((num + 1)), outputIndex);
                    }
                    return fm.liveswitch.Binary.toBytes5(value, bitOffset, new Uint8Array(num), outputIndex);
                }
                else if (arguments.length == 4) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var output = arguments[2];
                    var outputIndex = arguments[3];
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                    }
                    return fm.liveswitch.Binary.toBytes(value, bitOffset, false, output, outputIndex, 5);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes56 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 2) {
                    var value = arguments[0];
                    var littleEndian = arguments[1];
                    return fm.liveswitch.Binary.toBytes56(value, littleEndian, new Uint8Array(7), 0);
                }
                else if (arguments.length == 4) {
                    var value = arguments[0];
                    var littleEndian = arguments[1];
                    var output = arguments[2];
                    var outputIndex = arguments[3];
                    if (((outputIndex + 6) < output.length)) {
                        if (littleEndian) {
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 255), 0);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 65280), 8);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 16711680), 16);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 4278190080), 24);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 1095216660480), 32);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 280375465082880), 40);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 71776119061217280), 48);
                            return output;
                        }
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 71776119061217280), 48);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 280375465082880), 40);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 1095216660480), 32);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 4278190080), 24);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 16711680), 16);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 65280), 8);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 255), 0);
                        return output;
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes6 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 2) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var num = 1;
                    var outputIndex = 0;
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                        num++;
                    }
                    if ((bitOffset >= 3)) {
                        return fm.liveswitch.Binary.toBytes6(value, bitOffset, new Uint8Array((num + 1)), outputIndex);
                    }
                    return fm.liveswitch.Binary.toBytes6(value, bitOffset, new Uint8Array(num), outputIndex);
                }
                else if (arguments.length == 4) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var output = arguments[2];
                    var outputIndex = arguments[3];
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                    }
                    return fm.liveswitch.Binary.toBytes(value, bitOffset, false, output, outputIndex, 6);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes64 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 2) {
                    var value = arguments[0];
                    var littleEndian = arguments[1];
                    return fm.liveswitch.Binary.toBytes64(value, littleEndian, new Uint8Array(8), 0);
                }
                else if (arguments.length == 4) {
                    var value = arguments[0];
                    var littleEndian = arguments[1];
                    var output = arguments[2];
                    var outputIndex = arguments[3];
                    if (((outputIndex + 7) < output.length)) {
                        if (littleEndian) {
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong(value, 0);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 65280), 8);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 16711680), 16);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 4278190080), 24);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 1095216660480), 32);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 280375465082880), 40);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 71776119061217280), 48);
                            output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong(value, 56);
                            return output;
                        }
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong(value, 56);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 71776119061217280), 48);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 280375465082880), 40);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 1095216660480), 32);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 4278190080), 24);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 16711680), 16);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 65280), 8);
                        output[outputIndex++] = fm.liveswitch.BitAssistant.rightShiftLong((value & 255), 0);
                        return output;
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes7 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 2) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var num = 1;
                    var outputIndex = 0;
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                        num++;
                    }
                    if ((bitOffset >= 2)) {
                        return fm.liveswitch.Binary.toBytes7(value, bitOffset, new Uint8Array((num + 1)), outputIndex);
                    }
                    return fm.liveswitch.Binary.toBytes7(value, bitOffset, new Uint8Array(num), outputIndex);
                }
                else if (arguments.length == 4) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var output = arguments[2];
                    var outputIndex = arguments[3];
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                    }
                    return fm.liveswitch.Binary.toBytes(value, bitOffset, false, output, outputIndex, 7);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes8 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 1) {
                    var value = arguments[0];
                    return fm.liveswitch.Binary.toBytes8(value, new Uint8Array(1), 0);
                }
                else if (arguments.length == 3) {
                    var value = arguments[0];
                    var output = arguments[1];
                    var outputIndex = arguments[2];
                    if ((outputIndex >= output.length)) {
                        throw new fm.liveswitch.Exception("Output data is not large enough to write 8 bits.");
                    }
                    output[outputIndex] = fm.liveswitch.BitAssistant.rightShiftInteger((value & 255), 0);
                    return output;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.toBytes9 = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var num = 2;
                    var outputIndex = 0;
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                        num++;
                    }
                    return fm.liveswitch.Binary.toBytes9(value, bitOffset, littleEndian, new Uint8Array(num), outputIndex);
                }
                else if (arguments.length == 5) {
                    var value = arguments[0];
                    var bitOffset = arguments[1];
                    var littleEndian = arguments[2];
                    var output = arguments[3];
                    var outputIndex = arguments[4];
                    while ((bitOffset >= 8)) {
                        bitOffset = (bitOffset - 8);
                        outputIndex++;
                    }
                    return fm.liveswitch.Binary.toBytes(value, bitOffset, littleEndian, output, outputIndex, 9);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Binary.transform = function () {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 6) {
                    var inputFrame = arguments[0];
                    var outputFrame = arguments[1];
                    var width = arguments[2];
                    var height = arguments[3];
                    var stride = arguments[4];
                    var rotation = arguments[5];
                    fm.liveswitch.Binary.transform(inputFrame, outputFrame, width, height, stride, rotation, 0, 0);
                }
                else if (arguments.length == 8) {
                    var inputFrame = arguments[0];
                    var outputFrame = arguments[1];
                    var width = arguments[2];
                    var height = arguments[3];
                    var stride = arguments[4];
                    var rotation = arguments[5];
                    var inputStart = arguments[6];
                    var outputStart = arguments[7];
                    fm.liveswitch.Binary.transform(inputFrame, outputFrame, width, height, stride, rotation, inputStart, outputStart, 1);
                }
                else if (arguments.length == 9) {
                    var inputFrame = arguments[0];
                    var outputFrame = arguments[1];
                    var width = arguments[2];
                    var height = arguments[3];
                    var stride = arguments[4];
                    var rotation = arguments[5];
                    var inputStart = arguments[6];
                    var outputStart = arguments[7];
                    var chunkLength = arguments[8];
                    var num = ((width * height) * chunkLength);
                    var length_18 = ((stride > 0) ? ((stride * height) * chunkLength) : num);
                    var num3 = ((outputStart > 0) ? outputStart : inputStart);
                    var num4 = ((stride > 0) ? ((stride - width) * chunkLength) : 0);
                    var num5 = (outputStart + num);
                    if ((num5 > outputFrame.length)) {
                        fm.liveswitch.Log.error("otuputStart + calculated output plane length is greater than outputFrame length");
                    }
                    else {
                        var num8 = void 0;
                        var num9 = void 0;
                        var num10 = void 0;
                        var num6 = (height + 1);
                        var numArray = new Array(num6);
                        var num7 = (width * chunkLength);
                        for (num8 = 0; (num8 < num6); num8++) {
                            numArray[num8] = (((num7 * num8) + inputStart) + (num4 * (num8 - 1)));
                        }
                        if ((fm.liveswitch.Global.equals(rotation, 270))) {
                            for (num8 = 1; (num8 <= num7); num8 = (num8 + chunkLength)) {
                                num9 = 1;
                                while ((num9 < num6)) {
                                    num10 = (chunkLength - 1);
                                    while ((num10 >= 0)) {
                                        outputFrame[num3++] = inputFrame[((numArray[num9] - num8) - num10)];
                                        num10--;
                                    }
                                    num9++;
                                }
                            }
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(rotation, 90))) {
                                for (num8 = 0; (num8 < num7); num8 = (num8 + chunkLength)) {
                                    for (num9 = (num6 - 2); (num9 >= 0); num9--) {
                                        num10 = 0;
                                        while ((num10 < chunkLength)) {
                                            outputFrame[num3++] = inputFrame[(((numArray[num9] + num4) + num8) + num10)];
                                            num10++;
                                        }
                                    }
                                }
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(rotation, 180))) {
                                    var num11 = 0;
                                    for (num8 = (((inputStart + length_18) - num4) - 1); (num8 >= inputStart); num8 = (num8 - chunkLength)) {
                                        if ((((fm.liveswitch.Global.equals(num4, 0)) || (fm.liveswitch.Global.equals(num11, 0))) || (!fm.liveswitch.Global.equals((num11 % num7), 0)))) {
                                            for (num10 = (chunkLength - 1); (num10 >= 0); num10--) {
                                                outputFrame[num3++] = inputFrame[(num8 - num10)];
                                                num11++;
                                            }
                                        }
                                        else {
                                            num8 = (num8 - (num4 - chunkLength));
                                            num11 = 0;
                                        }
                                    }
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(num4, 0))) {
                                        fm.liveswitch.BitAssistant.copy(inputFrame, inputStart, outputFrame, outputStart, length_18);
                                    }
                                    else {
                                        for (num8 = 0; (num8 < height); num8++) {
                                            fm.liveswitch.BitAssistant.copy(inputFrame, (inputStart + ((stride * chunkLength) * num8)), outputFrame, (outputStart + ((width * chunkLength) * num8)), (width * chunkLength));
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if (arguments.length == 7) {
                    var inputFrame = arguments[0];
                    var outputFrame = arguments[1];
                    var width = arguments[2];
                    var height = arguments[3];
                    var stride = arguments[4];
                    var rotation = arguments[5];
                    var start = arguments[6];
                    fm.liveswitch.Binary.transform(inputFrame, outputFrame, width, height, stride, rotation, start, start);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 1-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes1 = function (input, inputIndex, bitOffset, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if ((inputIndex < input.length)) {
                        value.setValue(fm.liveswitch.Binary.fromBytes1(input, inputIndex, bitOffset));
                        return true;
                    }
                    value.setValue(false);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 10-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes10 = function (input, inputIndex, bitOffset, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if ((bitOffset >= 7)) {
                        if (((inputIndex + 2) < input.length)) {
                            value.setValue(fm.liveswitch.Binary.fromBytes10(input, inputIndex, bitOffset));
                            return true;
                        }
                    }
                    else {
                        if (((inputIndex + 1) < input.length)) {
                            value.setValue(fm.liveswitch.Binary.fromBytes10(input, inputIndex, bitOffset));
                            return true;
                        }
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 11-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes11 = function (input, inputIndex, bitOffset, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if ((bitOffset >= 6)) {
                        if (((inputIndex + 2) < input.length)) {
                            value.setValue(fm.liveswitch.Binary.fromBytes11(input, inputIndex, bitOffset));
                            return true;
                        }
                    }
                    else {
                        if (((inputIndex + 1) < input.length)) {
                            value.setValue(fm.liveswitch.Binary.fromBytes11(input, inputIndex, bitOffset));
                            return true;
                        }
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 12-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes12 = function (input, inputIndex, bitOffset, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if ((bitOffset >= 5)) {
                        if (((inputIndex + 2) < input.length)) {
                            value.setValue(fm.liveswitch.Binary.fromBytes12(input, inputIndex, bitOffset));
                            return true;
                        }
                    }
                    else {
                        if (((inputIndex + 1) < input.length)) {
                            value.setValue(fm.liveswitch.Binary.fromBytes12(input, inputIndex, bitOffset));
                            return true;
                        }
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 13-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes13 = function (input, inputIndex, bitOffset, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if ((bitOffset >= 4)) {
                        if (((inputIndex + 2) < input.length)) {
                            value.setValue(fm.liveswitch.Binary.fromBytes13(input, inputIndex, bitOffset));
                            return true;
                        }
                    }
                    else {
                        if (((inputIndex + 1) < input.length)) {
                            value.setValue(fm.liveswitch.Binary.fromBytes13(input, inputIndex, bitOffset));
                            return true;
                        }
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 14-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes14 = function (input, inputIndex, bitOffset, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if ((bitOffset >= 3)) {
                        if (((inputIndex + 2) < input.length)) {
                            value.setValue(fm.liveswitch.Binary.fromBytes14(input, inputIndex, bitOffset));
                            return true;
                        }
                    }
                    else {
                        if (((inputIndex + 1) < input.length)) {
                            value.setValue(fm.liveswitch.Binary.fromBytes14(input, inputIndex, bitOffset));
                            return true;
                        }
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 15-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes15 = function (input, inputIndex, bitOffset, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if ((bitOffset >= 2)) {
                        if (((inputIndex + 2) < input.length)) {
                            value.setValue(fm.liveswitch.Binary.fromBytes15(input, inputIndex, bitOffset));
                            return true;
                        }
                    }
                    else {
                        if (((inputIndex + 1) < input.length)) {
                            value.setValue(fm.liveswitch.Binary.fromBytes15(input, inputIndex, bitOffset));
                            return true;
                        }
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 16-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param littleEndian Whether to use little-endian format.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes16 = function (input, inputIndex, littleEndian, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if (((inputIndex + 1) < input.length)) {
                        value.setValue(fm.liveswitch.Binary.fromBytes16(input, inputIndex, littleEndian));
                        return true;
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 17-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes17 = function (input, inputIndex, bitOffset, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if ((inputIndex < input.length)) {
                        value.setValue(fm.liveswitch.Binary.fromBytes17(input, inputIndex, bitOffset));
                        return true;
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 18-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes18 = function (input, inputIndex, bitOffset, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if ((bitOffset >= 7)) {
                        if (((inputIndex + 3) < input.length)) {
                            value.setValue(fm.liveswitch.Binary.fromBytes18(input, inputIndex, bitOffset));
                            return true;
                        }
                    }
                    else {
                        if (((inputIndex + 2) < input.length)) {
                            value.setValue(fm.liveswitch.Binary.fromBytes18(input, inputIndex, bitOffset));
                            return true;
                        }
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 19-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes19 = function (input, inputIndex, bitOffset, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if ((inputIndex < input.length)) {
                        value.setValue(fm.liveswitch.Binary.fromBytes19(input, inputIndex, bitOffset));
                        return true;
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 2-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes2 = function (input, inputIndex, bitOffset, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if ((inputIndex < input.length)) {
                        value.setValue(fm.liveswitch.Binary.fromBytes2(input, inputIndex, bitOffset));
                        return true;
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 20-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes20 = function (input, inputIndex, bitOffset, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if ((inputIndex < input.length)) {
                        value.setValue(fm.liveswitch.Binary.fromBytes20(input, inputIndex, bitOffset));
                        return true;
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 21-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes21 = function (input, inputIndex, bitOffset, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if ((inputIndex < input.length)) {
                        value.setValue(fm.liveswitch.Binary.fromBytes21(input, inputIndex, bitOffset));
                        return true;
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 22-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes22 = function (input, inputIndex, bitOffset, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if ((inputIndex < input.length)) {
                        value.setValue(fm.liveswitch.Binary.fromBytes22(input, inputIndex, bitOffset));
                        return true;
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 23-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes23 = function (input, inputIndex, bitOffset, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if ((inputIndex < input.length)) {
                        value.setValue(fm.liveswitch.Binary.fromBytes23(input, inputIndex, bitOffset));
                        return true;
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 24-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param littleEndian Whether to use little-endian format.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes24 = function (input, inputIndex, littleEndian, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if (((inputIndex + 2) < input.length)) {
                        value.setValue(fm.liveswitch.Binary.fromBytes24(input, inputIndex, littleEndian));
                        return true;
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 3-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes3 = function (input, inputIndex, bitOffset, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if ((inputIndex < input.length)) {
                        value.setValue(fm.liveswitch.Binary.fromBytes3(input, inputIndex, bitOffset));
                        return true;
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 32-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param littleEndian Whether to use little-endian format.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes32 = function (input, inputIndex, littleEndian, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if (((inputIndex + 3) < input.length)) {
                        value.setValue(fm.liveswitch.Binary.fromBytes32(input, inputIndex, littleEndian));
                        return true;
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 4-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes4 = function (input, inputIndex, bitOffset, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if ((inputIndex < input.length)) {
                        value.setValue(fm.liveswitch.Binary.fromBytes4(input, inputIndex, bitOffset));
                        return true;
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 40-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param littleEndian Whether to use little-endian format.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes40 = function (input, inputIndex, littleEndian, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if (((inputIndex + 4) < input.length)) {
                        value.setValue(fm.liveswitch.Binary.fromBytes40(input, inputIndex, littleEndian));
                        return true;
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 48-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param littleEndian Whether to use little-endian format.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes48 = function (input, inputIndex, littleEndian, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if (((inputIndex + 5) < input.length)) {
                        value.setValue(fm.liveswitch.Binary.fromBytes48(input, inputIndex, littleEndian));
                        return true;
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 5-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes5 = function (input, inputIndex, bitOffset, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if ((inputIndex < input.length)) {
                        value.setValue(fm.liveswitch.Binary.fromBytes5(input, inputIndex, bitOffset));
                        return true;
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 56-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param littleEndian Whether to use little-endian format.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes56 = function (input, inputIndex, littleEndian, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if (((inputIndex + 6) < input.length)) {
                        value.setValue(fm.liveswitch.Binary.fromBytes56(input, inputIndex, littleEndian));
                        return true;
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 6-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes6 = function (input, inputIndex, bitOffset, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if ((inputIndex < input.length)) {
                        value.setValue(fm.liveswitch.Binary.fromBytes6(input, inputIndex, bitOffset));
                        return true;
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 64-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param littleEndian Whether to use little-endian format.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes64 = function (input, inputIndex, littleEndian, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if (((inputIndex + 7) < input.length)) {
                        value.setValue(fm.liveswitch.Binary.fromBytes64(input, inputIndex, littleEndian));
                        return true;
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 7-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes7 = function (input, inputIndex, bitOffset, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if ((inputIndex < input.length)) {
                        value.setValue(fm.liveswitch.Binary.fromBytes7(input, inputIndex, bitOffset));
                        return true;
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read an 8-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes8 = function (input, inputIndex, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 3) {
                    if ((inputIndex < input.length)) {
                        value.setValue(fm.liveswitch.Binary.fromBytes8(input, inputIndex));
                        return true;
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 9-bit value from a byte array.
            @param input The input byte array.
            @param inputIndex The index to start reading.
            @param bitOffset The offset of the value within the byte.
            @param value The value.
            @return `true` if the index is valid and the value was read; otherwise, `false`
            */
            Binary.tryFromBytes9 = function (input, inputIndex, bitOffset, value) {
                fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
                if (arguments.length == 4) {
                    if (((inputIndex + 1) < input.length)) {
                        value.setValue(fm.liveswitch.Binary.fromBytes9(input, inputIndex, bitOffset));
                        return true;
                    }
                    value.setValue(0);
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Binary.fmliveswitchBinaryInitialize = function () {
                if (!fm.liveswitch.Binary.__fmliveswitchBinaryInitialized && !fm.liveswitch.Binary.__fmliveswitchBinaryInitializing) {
                    fm.liveswitch.Binary.__fmliveswitchBinaryInitializing = true;
                    var numArray = new Array(24);
                    numArray[0] = [65407, 32767];
                    numArray[1] = [65343, 16383];
                    numArray[2] = [65311, 8191];
                    numArray[3] = [65295, 4095];
                    numArray[4] = [65287, 2047];
                    numArray[5] = [65283, 1023];
                    numArray[6] = [65281, 511];
                    numArray[7] = [65280, 255];
                    numArray[8] = [65280, 127, 32767];
                    numArray[9] = [65280, 63, 16383];
                    numArray[10] = [65280, 31, 8191];
                    numArray[11] = [65280, 15, 4095];
                    numArray[12] = [65280, 7, 2047];
                    numArray[13] = [65280, 3, 1023];
                    numArray[14] = [65280, 1, 511];
                    var numArray2 = new Array(3);
                    numArray2[0] = 65280;
                    numArray2[2] = 255;
                    numArray[15] = numArray2;
                    numArray[16] = [65280, 0, 127, 32767];
                    numArray[17] = [65280, 0, 63, 16383];
                    numArray[18] = [65280, 0, 31, 8191];
                    numArray[19] = [65280, 0, 15, 4095];
                    numArray[20] = [65280, 0, 7, 2047];
                    numArray[21] = [65280, 0, 3, 1023];
                    numArray[22] = [65280, 0, 1, 511];
                    numArray2 = new Array(4);
                    numArray2[0] = 65280;
                    numArray2[3] = 255;
                    numArray[23] = numArray2;
                    fm.liveswitch.Binary.fm_liveswitch_Binary___bitmasks = numArray;
                    fm.liveswitch.Binary.__fmliveswitchBinaryInitialized = true;
                    fm.liveswitch.Binary.__fmliveswitchBinaryInitializing = false;
                }
            };
            /** @hidden */
            Binary.__fmliveswitchBinaryInitialized = false;
            /** @hidden */
            Binary.__fmliveswitchBinaryInitializing = false;
            return Binary;
        }());
        liveswitch.Binary = Binary;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Class to hold a boolean value passed by reference.
        */
        var BooleanHolder = /** @class */ (function () {
            function BooleanHolder() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchBooleanHolderInit();
                }
                else if (__arguments.length == 1) {
                    var value = __arguments[0];
                    //super();
                    this.fmliveswitchBooleanHolderInit();
                    this.setValue(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            BooleanHolder.prototype.getTypeString = function () {
                return '[fm.liveswitch.BooleanHolder]';
            };
            BooleanHolder.prototype.fmliveswitchBooleanHolderInit = function () {
                this._value = false;
            };
            /**
            Gets the value.
            */
            BooleanHolder.prototype.getValue = function () {
                if (arguments.length == 0) {
                    return this._value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the value.
            */
            BooleanHolder.prototype.setValue = function (value) {
                if (arguments.length == 1) {
                    this._value = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return BooleanHolder;
        }());
        liveswitch.BooleanHolder = BooleanHolder;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Details about the current build.
        */
        var Build = /** @class */ (function () {
            function Build() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Build.prototype.getTypeString = function () {
                return '[fm.liveswitch.Build]';
            };
            /**
            Gets the build date.
            */
            Build.getDate = function () {
                if (arguments.length == 0) {
                    if ((((fm.liveswitch.Global.equals(fm.liveswitch.Build.getYear(), 0)) && (fm.liveswitch.Global.equals(fm.liveswitch.Build.getMonth(), 0))) && (fm.liveswitch.Global.equals(fm.liveswitch.Build.getDay(), 0)))) {
                        return new fm.liveswitch.DateTime(1970, 1, 1, 0, 0, 0);
                    }
                    return new fm.liveswitch.DateTime(fm.liveswitch.Build.getYear(), fm.liveswitch.Build.getMonth(), fm.liveswitch.Build.getDay(), 0, 0, 0);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the build day.
            */
            Build.getDay = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ParseAssistant.parseIntegerValue(fm.liveswitch.StringExtensions.substring("2020-09-17", 8, 2));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the build major version.
            */
            Build.getMajorVersion = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ParseAssistant.parseIntegerValue(fm.liveswitch.StringExtensions.split("1.9.4.33424", [46])[0]);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the build minor version.
            */
            Build.getMinorVersion = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ParseAssistant.parseIntegerValue(fm.liveswitch.StringExtensions.split("1.9.4.33424", [46])[1]);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the build month.
            */
            Build.getMonth = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ParseAssistant.parseIntegerValue(fm.liveswitch.StringExtensions.substring("2020-09-17", 5, 2));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the build patch version.
            */
            Build.getPatchVersion = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ParseAssistant.parseIntegerValue(fm.liveswitch.StringExtensions.split("1.9.4.33424", [46])[2]);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the build revision version.
            */
            Build.getRevisionVersion = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ParseAssistant.parseIntegerValue(fm.liveswitch.StringExtensions.split("1.9.4.33424", [46])[3]);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the full build version.
            */
            Build.getVersion = function () {
                if (arguments.length == 0) {
                    return "1.9.4.33424";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the build year.
            */
            Build.getYear = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ParseAssistant.parseIntegerValue(fm.liveswitch.StringExtensions.substring("2020-09-17", 0, 4));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the build version.
            */
            Build.VersionConstant = "1.9.4.33424";
            return Build;
        }());
        liveswitch.Build = Build;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Class to hold a byte value passed by reference.
        */
        var ByteHolder = /** @class */ (function () {
            function ByteHolder() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchByteHolderInit();
                }
                else if (__arguments.length == 1) {
                    var value = __arguments[0];
                    //super();
                    this.fmliveswitchByteHolderInit();
                    this.setValue(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            ByteHolder.prototype.getTypeString = function () {
                return '[fm.liveswitch.ByteHolder]';
            };
            ByteHolder.prototype.fmliveswitchByteHolderInit = function () {
                this._value = 0;
            };
            /**
            Gets the value.
            */
            ByteHolder.prototype.getValue = function () {
                if (arguments.length == 0) {
                    return this._value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the value.
            */
            ByteHolder.prototype.setValue = function (value) {
                if (arguments.length == 1) {
                    this._value = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ByteHolder;
        }());
        liveswitch.ByteHolder = ByteHolder;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Class to hold a character value passed by reference.
        */
        var CharacterHolder = /** @class */ (function () {
            function CharacterHolder() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchCharacterHolderInit();
                }
                else if (__arguments.length == 1) {
                    var value = __arguments[0];
                    //super();
                    this.fmliveswitchCharacterHolderInit();
                    this.setValue(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            CharacterHolder.prototype.getTypeString = function () {
                return '[fm.liveswitch.CharacterHolder]';
            };
            CharacterHolder.prototype.fmliveswitchCharacterHolderInit = function () {
                this._value = 0;
            };
            /**
            Gets the value.
            */
            CharacterHolder.prototype.getValue = function () {
                if (arguments.length == 0) {
                    return this._value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the value.
            */
            CharacterHolder.prototype.setValue = function (value) {
                if (arguments.length == 1) {
                    this._value = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return CharacterHolder;
        }());
        liveswitch.CharacterHolder = CharacterHolder;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A circular buffer.
        */
        var CircularBuffer = /** @class */ (function () {
            function CircularBuffer() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 2) {
                    var length_19 = __arguments[0];
                    var latency = __arguments[1];
                    // chained constructor: CircularBuffer.call(this, length, latency, false);
                    __arguments = new Array(3);
                    __arguments[0] = length_19;
                    __arguments[1] = latency;
                    __arguments[2] = false;
                    {
                        var length_20 = __arguments[0];
                        var latency_1 = __arguments[1];
                        var littleEndian = __arguments[2];
                        //super();
                        this.fmliveswitchCircularBufferInit();
                        this.__allowRead = false;
                        if ((length_20 <= 0)) {
                            throw new fm.liveswitch.Exception("Cannot create a circular buffer with no length.");
                        }
                        this.__buffer = fm.liveswitch.DataBuffer.allocate(length_20, littleEndian);
                        this.setReadOffset(0);
                        this.setWriteOffset(this.getLatency());
                        this.setLatency(latency_1);
                        this.setLittleEndian(littleEndian);
                    }
                }
                else if (__arguments.length == 3) {
                    var length_21 = __arguments[0];
                    var latency = __arguments[1];
                    var littleEndian = __arguments[2];
                    //super();
                    this.fmliveswitchCircularBufferInit();
                    this.__allowRead = false;
                    if ((length_21 <= 0)) {
                        throw new fm.liveswitch.Exception("Cannot create a circular buffer with no length.");
                    }
                    this.__buffer = fm.liveswitch.DataBuffer.allocate(length_21, littleEndian);
                    this.setReadOffset(0);
                    this.setWriteOffset(this.getLatency());
                    this.setLatency(latency);
                    this.setLittleEndian(littleEndian);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            CircularBuffer.prototype.getTypeString = function () {
                return '[fm.liveswitch.CircularBuffer]';
            };
            CircularBuffer.prototype.fmliveswitchCircularBufferInit = function () {
                this.__allowRead = false;
                this._latency = 0;
                this._littleEndian = false;
                this._readOffset = 0;
                this._writeOffset = 0;
            };
            /**
            Gets the number of bytes available for reading.
            */
            CircularBuffer.prototype.getAvailable = function () {
                if (arguments.length == 0) {
                    return (this.getWriteOffset() - this.getReadOffset());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the latency.
            */
            CircularBuffer.prototype.getLatency = function () {
                if (arguments.length == 0) {
                    return this._latency;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the length.
            */
            CircularBuffer.prototype.getLength = function () {
                if (arguments.length == 0) {
                    return this.__buffer.getLength();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the data is little-endian.
            */
            CircularBuffer.prototype.getLittleEndian = function () {
                if (arguments.length == 0) {
                    return this._littleEndian;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the read offset.
            */
            CircularBuffer.prototype.getReadOffset = function () {
                if (arguments.length == 0) {
                    return this._readOffset;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the read offset.
            */
            CircularBuffer.prototype.getWriteOffset = function () {
                if (arguments.length == 0) {
                    return this._writeOffset;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads data from the buffer.
            @param length The number of bytes to read.
            */
            CircularBuffer.prototype.read = function (length) {
                if (arguments.length == 1) {
                    if ((length > this.getLength())) {
                        return null;
                    }
                    var buffer = fm.liveswitch.DataBuffer.allocate(length, this.getLittleEndian());
                    if (this.__allowRead) {
                        if (((this.getReadOffset() + length) <= this.getLength())) {
                            buffer.write(this.__buffer.subset(this.getReadOffset(), length), 0);
                            this.__buffer.set(0, this.getReadOffset(), length);
                        }
                        else {
                            var num = (this.__buffer.getLength() - this.getReadOffset());
                            var num2 = (length - num);
                            buffer.write(this.__buffer.subset(this.getReadOffset(), num), 0);
                            buffer.write(this.__buffer.subset(0, num2), num);
                            this.__buffer.set(0, this.getReadOffset(), num);
                            this.__buffer.set(0, 0, num2);
                        }
                        this.setReadOffset(((this.getReadOffset() + length) % this.getLength()));
                    }
                    return buffer;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CircularBuffer.prototype.setLatency = function (value) {
                if (arguments.length == 1) {
                    this._latency = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CircularBuffer.prototype.setLittleEndian = function (value) {
                if (arguments.length == 1) {
                    this._littleEndian = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CircularBuffer.prototype.setReadOffset = function (value) {
                if (arguments.length == 1) {
                    this._readOffset = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CircularBuffer.prototype.setWriteOffset = function (value) {
                if (arguments.length == 1) {
                    this._writeOffset = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes data to the buffer.
            @param buffer The data to write.
            */
            CircularBuffer.prototype.write = function (buffer) {
                if (arguments.length == 1) {
                    var num2 = void 0;
                    for (var i = 0; (i < buffer.getLength()); i = (i + num2)) {
                        num2 = 0;
                        if (((buffer.getLength() - i) < (this.getLength() - this.getWriteOffset()))) {
                            num2 = (buffer.getLength() - i);
                        }
                        else {
                            num2 = (this.getLength() - this.getWriteOffset());
                        }
                        this.__buffer.write(buffer.subset(i, num2), this.getWriteOffset());
                        this.setWriteOffset(((this.getWriteOffset() + num2) % this.getLength()));
                    }
                    if ((!this.__allowRead && (this.getWriteOffset() >= (this.getReadOffset() + this.getLatency())))) {
                        this.__allowRead = true;
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return CircularBuffer;
        }());
        liveswitch.CircularBuffer = CircularBuffer;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A collection of values.
        */
        var Collection = /** @class */ (function () {
            /**
            Initializes a new instance of the [[fm.liveswitch.collection]] class.
            */
            function Collection() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.__values = new Array();
                    this.__valuesLock = new Object();
                    this.__valuesCache = this.arrayFromList(this.__values);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Collection.prototype.getTypeString = function () {
                return '[fm.liveswitch.Collection]';
            };
            /**
            Adds a value.
            @param value The value.
            */
            Collection.prototype.add = function (value) {
                if (arguments.length == 1) {
                    var flag = false;
                    if ((!fm.liveswitch.Global.equals(value, null))) {
                        if (!fm.liveswitch.ArrayExtensions.contains(this.__values, value)) {
                            flag = true;
                            fm.liveswitch.ArrayExtensions.add(this.__values, value);
                            this.__valuesCache = this.arrayFromList(this.__values);
                            this.addSuccess(value);
                        }
                        if (flag) {
                            this.addSuccessNoLock(value);
                        }
                    }
                    return flag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds some values.
            @param values The values.
            */
            Collection.prototype.addMany = function (values) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(values, null))) {
                        var list = new Array();
                        for (var _i = 0, values_2 = values; _i < values_2.length; _i++) {
                            var local = values_2[_i];
                            if (!fm.liveswitch.ArrayExtensions.contains(this.__values, local)) {
                                fm.liveswitch.ArrayExtensions.add(this.__values, local);
                                this.__valuesCache = this.arrayFromList(this.__values);
                                fm.liveswitch.ArrayExtensions.add(list, local);
                                this.addSuccess(local);
                            }
                        }
                        for (var _a = 0, list_1 = list; _a < list_1.length; _a++) {
                            var local2 = list_1[_a];
                            this.addSuccessNoLock(local2);
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Invoked when an element is added to the collection.
            @param value The value.
            */
            Collection.prototype.addSuccess = function (value) {
                if (arguments.length == 1) {
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Invoked after an element is added to the collection.
            @param value The value.
            */
            Collection.prototype.addSuccessNoLock = function (value) {
                if (arguments.length == 1) {
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Collection.prototype.any = function () {
                if (arguments.length == 0) {
                    return this.any(null);
                }
                else if (arguments.length == 1) {
                    var predicate = arguments[0];
                    for (var _i = 0, _a = this.__values; _i < _a.length; _i++) {
                        var local = _a[_i];
                        if (!((fm.liveswitch.Global.equals(predicate, null)) ? false : !predicate(local))) {
                            return true;
                        }
                    }
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Determines whether the collection contains a value.
            @param value The value.
            */
            Collection.prototype.contains = function (value) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(value, null))) {
                        return fm.liveswitch.ArrayExtensions.contains(this.__values, value);
                    }
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Collection.prototype.first = function () {
                if (arguments.length == 0) {
                    var local = this.firstOrDefault();
                    if ((fm.liveswitch.Global.equals(local, null))) {
                        throw new fm.liveswitch.Exception("The collection does not contain any values.");
                    }
                    return local;
                }
                else if (arguments.length == 1) {
                    var predicate = arguments[0];
                    var local = this.firstOrDefault(predicate);
                    if ((fm.liveswitch.Global.equals(local, null))) {
                        throw new fm.liveswitch.Exception("The collection does not contain any matching values.");
                    }
                    return local;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Collection.prototype.firstOrDefault = function () {
                if (arguments.length == 0) {
                    return this.firstOrDefault(null);
                }
                else if (arguments.length == 1) {
                    var predicate = arguments[0];
                    for (var i = 0; (i < fm.liveswitch.ArrayExtensions.getCount(this.__values)); i++) {
                        var p = this.__values[i];
                        if (!((fm.liveswitch.Global.equals(predicate, null)) ? false : !predicate(p))) {
                            return p;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Executes a callback function once per value.
            @param callback The callback to execute.
            */
            Collection.prototype.forEach = function (callback) {
                if (arguments.length == 1) {
                    var num = 0;
                    for (var _i = 0, _a = this.getValues(); _i < _a.length; _i++) {
                        var local = _a[_i];
                        callback(local, num++);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the count.
            */
            Collection.prototype.getCount = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ArrayExtensions.getCount(this.__values);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the value.
            */
            Collection.prototype.getValue = function () {
                if (arguments.length == 0) {
                    if ((fm.liveswitch.ArrayExtensions.getCount(this.__values) > 0)) {
                        return this.__values[0];
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the values.
            */
            Collection.prototype.getValues = function () {
                if (arguments.length == 0) {
                    return this.__valuesCache;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Collection.prototype.last = function () {
                if (arguments.length == 0) {
                    var local = this.lastOrDefault();
                    if ((fm.liveswitch.Global.equals(local, null))) {
                        throw new fm.liveswitch.Exception("The collection does not contain any values.");
                    }
                    return local;
                }
                else if (arguments.length == 1) {
                    var predicate = arguments[0];
                    var local = this.lastOrDefault(predicate);
                    if ((fm.liveswitch.Global.equals(local, null))) {
                        throw new fm.liveswitch.Exception("The collection does not contain any matching values.");
                    }
                    return local;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Collection.prototype.lastOrDefault = function () {
                if (arguments.length == 0) {
                    return this.lastOrDefault(null);
                }
                else if (arguments.length == 1) {
                    var predicate = arguments[0];
                    for (var i = (fm.liveswitch.ArrayExtensions.getCount(this.__values) - 1); (i > -1); i--) {
                        var p = this.__values[i];
                        if (!((fm.liveswitch.Global.equals(predicate, null)) ? false : !predicate(p))) {
                            return p;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a value.
            @param value The value.
            */
            Collection.prototype.remove = function (value) {
                if (arguments.length == 1) {
                    var flag = false;
                    if ((!fm.liveswitch.Global.equals(value, null))) {
                        if (fm.liveswitch.ArrayExtensions.remove(this.__values, value)) {
                            this.__valuesCache = this.arrayFromList(this.__values);
                            flag = true;
                            this.removeSuccess(value);
                        }
                        if (flag) {
                            this.removeSuccessNoLock(value);
                        }
                    }
                    return flag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes all values.
            */
            Collection.prototype.removeAll = function () {
                if (arguments.length == 0) {
                    var localArray = void 0;
                    localArray = this.arrayFromList(this.__values);
                    this.__values = new Array();
                    this.__valuesCache = this.arrayFromList(this.__values);
                    for (var _i = 0, localArray_1 = localArray; _i < localArray_1.length; _i++) {
                        var local = localArray_1[_i];
                        this.removeSuccess(local);
                    }
                    for (var _a = 0, localArray_2 = localArray; _a < localArray_2.length; _a++) {
                        var local = localArray_2[_a];
                        this.removeSuccessNoLock(local);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Collection.prototype.removeFirst = function () {
                if (arguments.length == 0) {
                    if ((fm.liveswitch.ArrayExtensions.getCount(this.__values) > 0)) {
                        var local = this.__values[0];
                        this.remove(local);
                        return local;
                    }
                    return null;
                }
                else if (arguments.length == 1) {
                    var condition = arguments[0];
                    for (var i = 0; (i < fm.liveswitch.ArrayExtensions.getCount(this.__values)); i++) {
                        var p = this.__values[i];
                        if (condition(p)) {
                            return p;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Collection.prototype.removeLast = function () {
                if (arguments.length == 0) {
                    if ((fm.liveswitch.ArrayExtensions.getCount(this.__values) > 0)) {
                        var local = this.__values[(fm.liveswitch.ArrayExtensions.getCount(this.__values) - 1)];
                        this.remove(local);
                        return local;
                    }
                    return null;
                }
                else if (arguments.length == 1) {
                    var condition = arguments[0];
                    for (var i = (fm.liveswitch.ArrayExtensions.getCount(this.__values) - 1); (i >= 0); i++) {
                        var p = this.__values[i];
                        if (condition(p)) {
                            return p;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes some values.
            @param values The values.
            */
            Collection.prototype.removeMany = function (values) {
                if (arguments.length == 1) {
                    if (((!fm.liveswitch.Global.equals(values, null)) && (values.length > 0))) {
                        var list = new Array();
                        for (var _i = 0, values_3 = values; _i < values_3.length; _i++) {
                            var local = values_3[_i];
                            if (fm.liveswitch.ArrayExtensions.remove(this.__values, local)) {
                                this.__valuesCache = this.arrayFromList(this.__values);
                                fm.liveswitch.ArrayExtensions.add(list, local);
                                this.removeSuccess(local);
                            }
                        }
                        for (var _a = 0, list_2 = list; _a < list_2.length; _a++) {
                            var local2 = list_2[_a];
                            this.removeSuccessNoLock(local2);
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Invoked when an element is removed from the collection.
            @param value The value.
            */
            Collection.prototype.removeSuccess = function (value) {
                if (arguments.length == 1) {
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Invoked after an element is removed from the collection.
            @param value The value.
            */
            Collection.prototype.removeSuccessNoLock = function (value) {
                if (arguments.length == 1) {
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Replaces the collection with a new set of values.
            @param values The values.
            */
            Collection.prototype.replace = function (values) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.clear(this.__values);
                    if ((!fm.liveswitch.Global.equals(values, null))) {
                        fm.liveswitch.ArrayExtensions.addRange(this.__values, values);
                    }
                    this.__valuesCache = this.arrayFromList(this.__values);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the value.
            */
            Collection.prototype.setValue = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.clear(this.__values);
                    if ((!fm.liveswitch.Global.equals(value, null))) {
                        fm.liveswitch.ArrayExtensions.add(this.__values, value);
                    }
                    this.__valuesCache = this.arrayFromList(this.__values);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the values.
            */
            Collection.prototype.setValues = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.clear(this.__values);
                    if ((!fm.liveswitch.Global.equals(value, null))) {
                        fm.liveswitch.ArrayExtensions.addRange(this.__values, value);
                    }
                    this.__valuesCache = this.arrayFromList(this.__values);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Collection.prototype.single = function () {
                if (arguments.length == 0) {
                    var local = this.singleOrDefault();
                    if ((fm.liveswitch.Global.equals(local, null))) {
                        throw new fm.liveswitch.Exception("The collection does not contain a single value.");
                    }
                    return local;
                }
                else if (arguments.length == 1) {
                    var predicate = arguments[0];
                    var local = this.singleOrDefault(predicate);
                    if ((fm.liveswitch.Global.equals(local, null))) {
                        throw new fm.liveswitch.Exception("The collection does not contain a single matching value.");
                    }
                    return local;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Collection.prototype.singleOrDefault = function () {
                if (arguments.length == 0) {
                    return this.singleOrDefault(null);
                }
                else if (arguments.length == 1) {
                    var predicate = arguments[0];
                    var local = null;
                    var flag = false;
                    for (var i = 0; (i < fm.liveswitch.ArrayExtensions.getCount(this.__values)); i++) {
                        var p = this.__values[i];
                        if (!((fm.liveswitch.Global.equals(predicate, null)) ? false : !predicate(p))) {
                            if (flag) {
                                throw new fm.liveswitch.Exception("Collection contains more than one matching element.");
                            }
                            local = p;
                            flag = true;
                        }
                    }
                    return local;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Clones the values into a new array.
            */
            Collection.prototype.toArray = function () {
                if (arguments.length == 0) {
                    return this.arrayFromList(this.__values);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the value at the specified index. Throws an exception if a value does not exist at that index.
            @param index The index.
            */
            Collection.prototype.valueAt = function (index) {
                if (arguments.length == 1) {
                    var local = this.valueAtOrDefault(index);
                    if ((fm.liveswitch.Global.equals(local, null))) {
                        throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Value does not exist at index {0}.", fm.liveswitch.NumberExtensions.toString(index)));
                    }
                    return local;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the value at the specified index. Returns a default value if a value does not exist at that index.
            @param index The index.
            */
            Collection.prototype.valueAtOrDefault = function (index) {
                if (arguments.length == 1) {
                    if ((index < fm.liveswitch.ArrayExtensions.getCount(this.__values))) {
                        for (var i = 0; (i < fm.liveswitch.ArrayExtensions.getCount(this.__values)); i++) {
                            if ((fm.liveswitch.Global.equals(i, index))) {
                                return this.__values[i];
                            }
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a new collection with values that match the specified predicate.
            @param predicate The predicate.
            */
            Collection.prototype.where = function (predicate) {
                if (arguments.length == 1) {
                    var local = this.createCollection();
                    for (var i = 0; (i < fm.liveswitch.ArrayExtensions.getCount(this.__values)); i++) {
                        var local2 = this.__values[i];
                        if (!((fm.liveswitch.Global.equals(predicate, null)) ? false : !predicate(local2, i))) {
                            local.add(local2);
                        }
                    }
                    return local;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Collection;
        }());
        liveswitch.Collection = Collection;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A record that calculates the min, max, and average from integer samples.
        */
        var DiagnosticSampler = /** @class */ (function () {
            function DiagnosticSampler() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    // chained constructor: DiagnosticSampler.call(this, (<string>(null as any)));
                    __arguments = new Array(1);
                    __arguments[0] = null;
                    {
                        var label = __arguments[0];
                        // chained constructor: DiagnosticSampler.call(this, 100, label);
                        __arguments = new Array(2);
                        __arguments[0] = 100;
                        __arguments[1] = label;
                        {
                            var averageSampleCount = __arguments[0];
                            var label_2 = __arguments[1];
                            //super();
                            this.fmliveswitchDiagnosticSamplerInit();
                            this.setLastValue(0);
                            this.setLabel(label_2);
                            this.__min = new fm.liveswitch.AtomicLong(9223372036854775807);
                            this.__max = new fm.liveswitch.AtomicLong();
                            this.__count = new fm.liveswitch.AtomicLong();
                            this.__sum = new fm.liveswitch.AtomicLong();
                            this.__arrayPointer = new fm.liveswitch.AtomicInteger();
                            this.__samples = new Array(averageSampleCount);
                        }
                    }
                }
                else if (__arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isNumber(arguments[0]))) {
                    var averageSampleCount = __arguments[0];
                    // chained constructor: DiagnosticSampler.call(this, averageSampleCount, null);
                    __arguments = new Array(2);
                    __arguments[0] = averageSampleCount;
                    __arguments[1] = null;
                    {
                        var averageSampleCount_1 = __arguments[0];
                        var label = __arguments[1];
                        //super();
                        this.fmliveswitchDiagnosticSamplerInit();
                        this.setLastValue(0);
                        this.setLabel(label);
                        this.__min = new fm.liveswitch.AtomicLong(9223372036854775807);
                        this.__max = new fm.liveswitch.AtomicLong();
                        this.__count = new fm.liveswitch.AtomicLong();
                        this.__sum = new fm.liveswitch.AtomicLong();
                        this.__arrayPointer = new fm.liveswitch.AtomicInteger();
                        this.__samples = new Array(averageSampleCount_1);
                    }
                }
                else if (__arguments.length == 2) {
                    var averageSampleCount = __arguments[0];
                    var label = __arguments[1];
                    //super();
                    this.fmliveswitchDiagnosticSamplerInit();
                    this.setLastValue(0);
                    this.setLabel(label);
                    this.__min = new fm.liveswitch.AtomicLong(9223372036854775807);
                    this.__max = new fm.liveswitch.AtomicLong();
                    this.__count = new fm.liveswitch.AtomicLong();
                    this.__sum = new fm.liveswitch.AtomicLong();
                    this.__arrayPointer = new fm.liveswitch.AtomicInteger();
                    this.__samples = new Array(averageSampleCount);
                }
                else if (__arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                    var label = __arguments[0];
                    // chained constructor: DiagnosticSampler.call(this, 100, label);
                    __arguments = new Array(2);
                    __arguments[0] = 100;
                    __arguments[1] = label;
                    {
                        var averageSampleCount = __arguments[0];
                        var label_3 = __arguments[1];
                        //super();
                        this.fmliveswitchDiagnosticSamplerInit();
                        this.setLastValue(0);
                        this.setLabel(label_3);
                        this.__min = new fm.liveswitch.AtomicLong(9223372036854775807);
                        this.__max = new fm.liveswitch.AtomicLong();
                        this.__count = new fm.liveswitch.AtomicLong();
                        this.__sum = new fm.liveswitch.AtomicLong();
                        this.__arrayPointer = new fm.liveswitch.AtomicInteger();
                        this.__samples = new Array(averageSampleCount);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            DiagnosticSampler.prototype.getTypeString = function () {
                return '[fm.liveswitch.DiagnosticSampler]';
            };
            DiagnosticSampler.prototype.fmliveswitchDiagnosticSamplerInit = function () {
                this._lastValue = 0;
            };
            /**
            Adds a new sample to the calculation.
            @param longSample The sample to add.
            */
            DiagnosticSampler.prototype.addSample = function (longSample) {
                if (arguments.length == 1) {
                    this.setLastValue(longSample);
                    this.__count.increment();
                    this.__sum.add(longSample);
                    var index = (this.__arrayPointer.increment() % this.__samples.length);
                    this.__samples[index] = longSample;
                    if ((this.__min.getValue() > longSample)) {
                        var num2 = this.__min.getValue();
                        for (var i = fm.liveswitch.MathAssistant.min(num2, longSample); (!fm.liveswitch.Global.equals(this.__min.compareAndSwap(num2, i), num2)); i = fm.liveswitch.MathAssistant.min(num2, longSample)) {
                            num2 = this.__min.getValue();
                        }
                    }
                    if ((this.__max.getValue() < longSample)) {
                        var num4 = this.__max.getValue();
                        for (var j = fm.liveswitch.MathAssistant.max(num4, longSample); (!fm.liveswitch.Global.equals(this.__max.compareAndSwap(num4, j), num4)); j = fm.liveswitch.MathAssistant.max(num4, longSample)) {
                            num4 = this.__max.getValue();
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the average of all samples.
            */
            DiagnosticSampler.prototype.getAverage = function () {
                if (arguments.length == 0) {
                    var num = fm.liveswitch.MathAssistant.min(this.__samples.length, this.getCount());
                    var num2 = 0;
                    for (var i = 0; (i < num); i++) {
                        num2 = (num2 + this.__samples[i]);
                    }
                    return (num2 / num);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets how many samples this record has used.
            */
            DiagnosticSampler.prototype.getCount = function () {
                if (arguments.length == 0) {
                    return this.__count.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the label for this sampler.
            */
            DiagnosticSampler.prototype.getLabel = function () {
                if (arguments.length == 0) {
                    return this._label;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the value of the last sample recorded.
            */
            DiagnosticSampler.prototype.getLastValue = function () {
                if (arguments.length == 0) {
                    return this._lastValue;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the maximum sample ever recorded.
            */
            DiagnosticSampler.prototype.getMax = function () {
                if (arguments.length == 0) {
                    return this.__max.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the minimum sample ever recorded.
            */
            DiagnosticSampler.prototype.getMin = function () {
                if (arguments.length == 0) {
                    return this.__min.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets how many samples are included in the average.
            */
            DiagnosticSampler.prototype.getSamplesInAverage = function () {
                if (arguments.length == 0) {
                    return this.__samples.length;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the sum of all values.
            */
            DiagnosticSampler.prototype.getSum = function () {
                if (arguments.length == 0) {
                    return this.__sum.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DiagnosticSampler.prototype.setLabel = function (value) {
                if (arguments.length == 1) {
                    this._label = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DiagnosticSampler.prototype.setLastValue = function (value) {
                if (arguments.length == 1) {
                    this._lastValue = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return DiagnosticSampler;
        }());
        liveswitch.DiagnosticSampler = DiagnosticSampler;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Utility class to assist with ISO-8601 timestamp conversions.
        */
        var Iso8601Timestamp = /** @class */ (function () {
            function Iso8601Timestamp() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Iso8601Timestamp.prototype.getTypeString = function () {
                return '[fm.liveswitch.Iso8601Timestamp]';
            };
            /**
            Converts a date to a ISO-8601 timestamp.
            @param dateTime The date to convert.
            @return The equivalent ISO-8601 timestamp.
            */
            Iso8601Timestamp.dateTimeToIso8601 = function (dateTime) {
                if (arguments.length == 1) {
                    var str = fm.liveswitch.NumberExtensions.toString(dateTime.getYear());
                    var str2 = fm.liveswitch.NumberExtensions.toString(dateTime.getMonth());
                    var str3 = fm.liveswitch.NumberExtensions.toString(dateTime.getDay());
                    var str4 = fm.liveswitch.NumberExtensions.toString(dateTime.getHour());
                    var str5 = fm.liveswitch.NumberExtensions.toString(dateTime.getMinute());
                    var str6 = fm.liveswitch.NumberExtensions.toString(dateTime.getSecond());
                    var str7 = fm.liveswitch.NumberExtensions.toString(dateTime.getMillisecond());
                    while ((fm.liveswitch.StringExtensions.getLength(str) < 4)) {
                        str = fm.liveswitch.StringExtensions.concat("0", str);
                    }
                    while ((fm.liveswitch.StringExtensions.getLength(str2) < 2)) {
                        str2 = fm.liveswitch.StringExtensions.concat("0", str2);
                    }
                    while ((fm.liveswitch.StringExtensions.getLength(str3) < 2)) {
                        str3 = fm.liveswitch.StringExtensions.concat("0", str3);
                    }
                    while ((fm.liveswitch.StringExtensions.getLength(str4) < 2)) {
                        str4 = fm.liveswitch.StringExtensions.concat("0", str4);
                    }
                    while ((fm.liveswitch.StringExtensions.getLength(str5) < 2)) {
                        str5 = fm.liveswitch.StringExtensions.concat("0", str5);
                    }
                    while ((fm.liveswitch.StringExtensions.getLength(str6) < 2)) {
                        str6 = fm.liveswitch.StringExtensions.concat("0", str6);
                    }
                    while ((fm.liveswitch.StringExtensions.getLength(str7) < 3)) {
                        str7 = fm.liveswitch.StringExtensions.concat("0", str7);
                    }
                    return fm.liveswitch.StringExtensions.format("{0}-{1}-{2}T{3}:{4}:{5}.{6}Z", [str, str2, str3, str4, str5, str6, str7]);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Iso8601Timestamp.getMinimumNeedleIndex = function (haystack, needles) {
                if (arguments.length == 2) {
                    var num = -1;
                    for (var _i = 0, needles_1 = needles; _i < needles_1.length; _i++) {
                        var str = needles_1[_i];
                        var index = fm.liveswitch.StringExtensions.indexOf(haystack, str);
                        if ((!fm.liveswitch.Global.equals(index, -1))) {
                            if ((fm.liveswitch.Global.equals(num, -1))) {
                                num = index;
                            }
                            else {
                                num = fm.liveswitch.MathAssistant.min(num, index);
                            }
                        }
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the current UTC time in ISO-8601 format.
            */
            Iso8601Timestamp.getUtcNow = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Iso8601Timestamp.dateTimeToIso8601(fm.liveswitch.DateTime.getUtcNow());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts a ISO-8601 timestamp to a date.
            @param iso8601 The ISO-8601 timestamp to convert.
            @return The equivalent date.
            */
            Iso8601Timestamp.iso8601ToDateTime = function (iso8601) {
                if (arguments.length == 1) {
                    var year = 0;
                    var month = 0;
                    var day = 0;
                    var hour = 0;
                    var minute = 0;
                    var second = 0;
                    var millisecond = 0;
                    var num8 = 0;
                    var num9 = 0;
                    var offset = 0;
                    var _var0 = new fm.liveswitch.Holder(offset);
                    var _var1 = new fm.liveswitch.Holder(year);
                    var _var2 = new fm.liveswitch.Holder(month);
                    var _var3 = new fm.liveswitch.Holder(day);
                    var _var4 = fm.liveswitch.Iso8601Timestamp.tryParseDate(iso8601, offset, _var0, _var1, _var2, _var3);
                    offset = _var0.getValue();
                    year = _var1.getValue();
                    month = _var2.getValue();
                    day = _var3.getValue();
                    var _var5 = new fm.liveswitch.Holder(offset);
                    var _var6 = fm.liveswitch.Iso8601Timestamp.tryRead(iso8601, offset, "T", _var5);
                    offset = _var5.getValue();
                    var _var7 = new fm.liveswitch.Holder(offset);
                    var _var8 = new fm.liveswitch.Holder(hour);
                    var _var9 = new fm.liveswitch.Holder(minute);
                    var _var10 = new fm.liveswitch.Holder(second);
                    var _var11 = new fm.liveswitch.Holder(millisecond);
                    var _var12 = fm.liveswitch.Iso8601Timestamp.tryParseTime(iso8601, offset, _var7, _var8, _var9, _var10, _var11);
                    offset = _var7.getValue();
                    hour = _var8.getValue();
                    minute = _var9.getValue();
                    second = _var10.getValue();
                    millisecond = _var11.getValue();
                    if (((_var4 && _var6) && _var12)) {
                        var _var13 = new fm.liveswitch.Holder(offset);
                        var _var14 = new fm.liveswitch.Holder(num8);
                        var _var15 = new fm.liveswitch.Holder(num9);
                        var _var16 = fm.liveswitch.Iso8601Timestamp.tryParseTimezone(iso8601, offset, _var13, _var14, _var15);
                        offset = _var13.getValue();
                        num8 = _var14.getValue();
                        num9 = _var15.getValue();
                    }
                    var time2 = new fm.liveswitch.DateTime(year, month, day, hour, minute, second, millisecond);
                    return time2.addHours(num8).addMinutes(num9);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Iso8601Timestamp.tryParseDate = function (iso8601, offset, offsetPlus, year, month, day) {
                if (arguments.length == 6) {
                    year.setValue(1970);
                    month.setValue(1);
                    day.setValue(1);
                    var str = null;
                    var str2 = null;
                    var str3 = null;
                    var _var0 = new fm.liveswitch.Holder(str);
                    var _var1 = new fm.liveswitch.Holder(offset);
                    var _var2 = fm.liveswitch.Iso8601Timestamp.tryRead(iso8601, offset, 4, _var0, _var1);
                    str = _var0.getValue();
                    offset = _var1.getValue();
                    if (_var2) {
                        var _var3 = new fm.liveswitch.Holder(offset);
                        var _var4 = fm.liveswitch.Iso8601Timestamp.tryRead(iso8601, offset, "-", _var3);
                        offset = _var3.getValue();
                        var _var5 = new fm.liveswitch.Holder(str2);
                        var _var6 = new fm.liveswitch.Holder(offset);
                        var _var7 = fm.liveswitch.Iso8601Timestamp.tryRead(iso8601, offset, 2, _var5, _var6);
                        str2 = _var5.getValue();
                        offset = _var6.getValue();
                        if (_var7) {
                            var _var8 = new fm.liveswitch.Holder(offset);
                            var _var9 = fm.liveswitch.Iso8601Timestamp.tryRead(iso8601, offset, "-", _var8);
                            offset = _var8.getValue();
                            var _var10 = new fm.liveswitch.Holder(str3);
                            var _var11 = new fm.liveswitch.Holder(offset);
                            var _var12 = fm.liveswitch.Iso8601Timestamp.tryRead(iso8601, offset, 2, _var10, _var11);
                            str3 = _var10.getValue();
                            offset = _var11.getValue();
                        }
                    }
                    var _var13 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(str, year);
                    if (!((fm.liveswitch.Global.equals(str, null)) || _var13)) {
                        offsetPlus.setValue(offset);
                        return false;
                    }
                    var _var14 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(str2, month);
                    if (!((fm.liveswitch.Global.equals(str2, null)) || _var14)) {
                        offsetPlus.setValue(offset);
                        return false;
                    }
                    var _var15 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(str3, day);
                    if (!((fm.liveswitch.Global.equals(str3, null)) || _var15)) {
                        offsetPlus.setValue(offset);
                        return false;
                    }
                    offsetPlus.setValue(offset);
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Iso8601Timestamp.tryParseTime = function (iso8601, offset, offsetPlus, hour, minute, second, millisecond) {
                if (arguments.length == 7) {
                    hour.setValue(0);
                    minute.setValue(0);
                    second.setValue(0);
                    millisecond.setValue(0);
                    var str = null;
                    var str2 = null;
                    var str3 = null;
                    var s = null;
                    var terminalStrings = ["Z", "+", "-"];
                    var _var0 = new fm.liveswitch.Holder(str);
                    var _var1 = new fm.liveswitch.Holder(offset);
                    var _var2 = fm.liveswitch.Iso8601Timestamp.tryRead(iso8601, offset, 2, terminalStrings, _var0, _var1);
                    str = _var0.getValue();
                    offset = _var1.getValue();
                    if (_var2) {
                        var _var3 = new fm.liveswitch.Holder(offset);
                        var _var4 = fm.liveswitch.Iso8601Timestamp.tryRead(iso8601, offset, ":", _var3);
                        offset = _var3.getValue();
                        var _var5 = new fm.liveswitch.Holder(str2);
                        var _var6 = new fm.liveswitch.Holder(offset);
                        var _var7 = fm.liveswitch.Iso8601Timestamp.tryRead(iso8601, offset, 2, terminalStrings, _var5, _var6);
                        str2 = _var5.getValue();
                        offset = _var6.getValue();
                        if (_var7) {
                            var _var8 = new fm.liveswitch.Holder(offset);
                            var _var9 = fm.liveswitch.Iso8601Timestamp.tryRead(iso8601, offset, ":", _var8);
                            offset = _var8.getValue();
                            var _var10 = new fm.liveswitch.Holder(str3);
                            var _var11 = new fm.liveswitch.Holder(offset);
                            var _var12 = fm.liveswitch.Iso8601Timestamp.tryRead(iso8601, offset, 2, terminalStrings, _var10, _var11);
                            str3 = _var10.getValue();
                            offset = _var11.getValue();
                            var _var13 = new fm.liveswitch.Holder(offset);
                            var _var14 = fm.liveswitch.Iso8601Timestamp.tryRead(iso8601, offset, ".", _var13);
                            offset = _var13.getValue();
                            if ((_var12 && _var14)) {
                                var str5 = null;
                                var _var15 = new fm.liveswitch.Holder(str5);
                                var _var16 = new fm.liveswitch.Holder(offset);
                                var _var17 = fm.liveswitch.Iso8601Timestamp.tryRead(iso8601, offset, terminalStrings, _var15, _var16);
                                str5 = _var15.getValue();
                                offset = _var16.getValue();
                                if (_var17) {
                                    if ((fm.liveswitch.StringExtensions.getLength(str5) < 3)) {
                                        for (s = str5; (fm.liveswitch.StringExtensions.getLength(s) < 3); s = fm.liveswitch.StringExtensions.concat(s, "0")) {
                                        }
                                    }
                                    else {
                                        s = fm.liveswitch.StringExtensions.substring(str5, 0, 3);
                                    }
                                }
                            }
                        }
                    }
                    var _var18 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(str, hour);
                    if (!((fm.liveswitch.Global.equals(str, null)) || _var18)) {
                        offsetPlus.setValue(offset);
                        return false;
                    }
                    var _var19 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(str2, minute);
                    if (!((fm.liveswitch.Global.equals(str2, null)) || _var19)) {
                        offsetPlus.setValue(offset);
                        return false;
                    }
                    var _var20 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(str3, second);
                    if (!((fm.liveswitch.Global.equals(str3, null)) || _var20)) {
                        offsetPlus.setValue(offset);
                        return false;
                    }
                    var _var21 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(s, millisecond);
                    if (!((fm.liveswitch.Global.equals(s, null)) || _var21)) {
                        offsetPlus.setValue(offset);
                        return false;
                    }
                    offsetPlus.setValue(offset);
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Iso8601Timestamp.tryParseTimezone = function (iso8601, offset, offsetPlus, hour, minute) {
                if (arguments.length == 5) {
                    var flag = void 0;
                    hour.setValue(0);
                    minute.setValue(0);
                    var _var0 = new fm.liveswitch.Holder(offset);
                    var _var1 = fm.liveswitch.Iso8601Timestamp.tryRead(iso8601, offset, "Z", _var0);
                    offset = _var0.getValue();
                    if (_var1) {
                        offsetPlus.setValue(offset);
                        return true;
                    }
                    var str = null;
                    var str2 = null;
                    var _var2 = new fm.liveswitch.Holder(offset);
                    var _var3 = fm.liveswitch.Iso8601Timestamp.tryRead(iso8601, offset, "+", _var2);
                    offset = _var2.getValue();
                    if (_var3) {
                        flag = false;
                    }
                    else {
                        var _var4 = new fm.liveswitch.Holder(offset);
                        var _var5 = fm.liveswitch.Iso8601Timestamp.tryRead(iso8601, offset, "-", _var4);
                        offset = _var4.getValue();
                        if (_var5) {
                            flag = true;
                        }
                        else {
                            offsetPlus.setValue(offset);
                            return false;
                        }
                    }
                    var _var6 = new fm.liveswitch.Holder(str);
                    var _var7 = new fm.liveswitch.Holder(offset);
                    var _var8 = fm.liveswitch.Iso8601Timestamp.tryRead(iso8601, offset, 2, _var6, _var7);
                    str = _var6.getValue();
                    offset = _var7.getValue();
                    if (_var8) {
                        var _var9 = new fm.liveswitch.Holder(offset);
                        var _var10 = fm.liveswitch.Iso8601Timestamp.tryRead(iso8601, offset, ":", _var9);
                        offset = _var9.getValue();
                        var _var11 = new fm.liveswitch.Holder(str2);
                        var _var12 = new fm.liveswitch.Holder(offset);
                        var _var13 = fm.liveswitch.Iso8601Timestamp.tryRead(iso8601, offset, 2, _var11, _var12);
                        str2 = _var11.getValue();
                        offset = _var12.getValue();
                    }
                    var _var14 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(str, hour);
                    if (!((fm.liveswitch.Global.equals(str, null)) || _var14)) {
                        offsetPlus.setValue(offset);
                        return false;
                    }
                    var _var15 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(str2, minute);
                    if (!((fm.liveswitch.Global.equals(str2, null)) || _var15)) {
                        offsetPlus.setValue(offset);
                        return false;
                    }
                    if (flag) {
                        hour.setValue(-hour.getValue());
                        minute.setValue(-minute.getValue());
                    }
                    offsetPlus.setValue(offset);
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Iso8601Timestamp.tryRead = function () {
                if (arguments.length == 6) {
                    var input = arguments[0];
                    var offset = arguments[1];
                    var count = arguments[2];
                    var terminalStrings = arguments[3];
                    var value = arguments[4];
                    var offsetPlus = arguments[5];
                    if ((fm.liveswitch.Global.equals(count, -1))) {
                        if ((offset > fm.liveswitch.StringExtensions.getLength(input))) {
                            value.setValue(null);
                            offsetPlus.setValue(offset);
                            return false;
                        }
                        value.setValue(input.substring(offset));
                        offsetPlus.setValue((offset + fm.liveswitch.StringExtensions.getLength(value.getValue())));
                        if (((!fm.liveswitch.Global.equals(terminalStrings, null)) && (!fm.liveswitch.Global.equals(terminalStrings.length, 0)))) {
                            var minimumNeedleIndex = fm.liveswitch.Iso8601Timestamp.getMinimumNeedleIndex(value.getValue(), terminalStrings);
                            if ((fm.liveswitch.Global.equals(minimumNeedleIndex, -1))) {
                                return true;
                            }
                            value.setValue(fm.liveswitch.StringExtensions.substring(input, offset, minimumNeedleIndex));
                            offsetPlus.setValue((offset + fm.liveswitch.StringExtensions.getLength(value.getValue())));
                        }
                        return true;
                    }
                    if (((offset + count) > fm.liveswitch.StringExtensions.getLength(input))) {
                        value.setValue(null);
                        offsetPlus.setValue(offset);
                        return false;
                    }
                    value.setValue(fm.liveswitch.StringExtensions.substring(input, offset, count));
                    offsetPlus.setValue((offset + fm.liveswitch.StringExtensions.getLength(value.getValue())));
                    return (((fm.liveswitch.Global.equals(terminalStrings, null)) || (fm.liveswitch.Global.equals(terminalStrings.length, 0))) || (fm.liveswitch.Global.equals(fm.liveswitch.Iso8601Timestamp.getMinimumNeedleIndex(value.getValue(), terminalStrings), -1)));
                }
                else if (arguments.length == 5 && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isNumber(arguments[2]))) {
                    var input = arguments[0];
                    var offset = arguments[1];
                    var count = arguments[2];
                    var value = arguments[3];
                    var offsetPlus = arguments[4];
                    var _var0 = fm.liveswitch.Iso8601Timestamp.tryRead(input, offset, count, null, value, offsetPlus);
                    return _var0;
                }
                else if (arguments.length == 5 && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || (fm.liveswitch.Util.isArray(arguments[2]) && (arguments[2].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[2][0]) || fm.liveswitch.Util.isString(arguments[2][0])))))) {
                    var input = arguments[0];
                    var offset = arguments[1];
                    var terminalStrings = arguments[2];
                    var value = arguments[3];
                    var offsetPlus = arguments[4];
                    var _var0 = fm.liveswitch.Iso8601Timestamp.tryRead(input, offset, -1, terminalStrings, value, offsetPlus);
                    return _var0;
                }
                else if (arguments.length == 4) {
                    var input = arguments[0];
                    var offset = arguments[1];
                    var value = arguments[2];
                    var offsetPlus = arguments[3];
                    if (((offset + fm.liveswitch.StringExtensions.getLength(value)) > fm.liveswitch.StringExtensions.getLength(input))) {
                        offsetPlus.setValue(offset);
                        return false;
                    }
                    if ((!fm.liveswitch.Global.equals(fm.liveswitch.StringExtensions.substring(input, offset, fm.liveswitch.StringExtensions.getLength(value)), value))) {
                        offsetPlus.setValue(offset);
                        return false;
                    }
                    offsetPlus.setValue((offset + fm.liveswitch.StringExtensions.getLength(value)));
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Iso8601Timestamp;
        }());
        liveswitch.Iso8601Timestamp = Iso8601Timestamp;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var JsonCheckerModeWrapper = /** @class */ (function () {
            function JsonCheckerModeWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_4 = __arguments[0];
                    //super();
                    this._value = value_4;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            JsonCheckerModeWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.JsonCheckerModeWrapper]';
            };
            JsonCheckerModeWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.JsonCheckerMode.Array)
                        return 'Array';
                    if (this._value == fm.liveswitch.JsonCheckerMode.Done)
                        return 'Done';
                    if (this._value == fm.liveswitch.JsonCheckerMode.Key)
                        return 'Key';
                    if (this._value == fm.liveswitch.JsonCheckerMode.Object)
                        return 'Object';
                    if (this._value == fm.liveswitch.JsonCheckerMode.String)
                        return 'String';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return JsonCheckerModeWrapper;
        }());
        liveswitch.JsonCheckerModeWrapper = JsonCheckerModeWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A countdown latch that will signal when the counter reaches zero.
        */
        var ManagedCountdownLatch = /** @class */ (function () {
            function ManagedCountdownLatch() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.reset();
                }
                else if (__arguments.length == 1) {
                    var initialCount = __arguments[0];
                    //super();
                    this.reset(initialCount);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            ManagedCountdownLatch.prototype.getTypeString = function () {
                return '[fm.liveswitch.ManagedCountdownLatch]';
            };
            /**
            Decrements the counter by one and signals if it reaches zero.
            */
            ManagedCountdownLatch.prototype.decrement = function () {
                if (arguments.length == 0) {
                    if ((fm.liveswitch.Global.equals(this.__counter.decrement(), 0))) {
                        this.__waitPromise.resolveAsync(null);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the current count on the latch.
            */
            ManagedCountdownLatch.prototype.getCount = function () {
                if (arguments.length == 0) {
                    return this.__counter.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ManagedCountdownLatch.prototype.reset = function () {
                if (arguments.length == 0) {
                    this.__counter = new fm.liveswitch.AtomicInteger();
                    this.__waitPromise = new fm.liveswitch.Promise();
                }
                else if (arguments.length == 1) {
                    var initialCount = arguments[0];
                    this.__counter = new fm.liveswitch.AtomicInteger(initialCount);
                    this.__waitPromise = new fm.liveswitch.Promise();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the counter for the latch. This brings the count back up into positive numbers.
            */
            ManagedCountdownLatch.prototype.setCount = function (count) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(this.__counter.add(count), 0))) {
                        this.__waitPromise.resolveAsync(null);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Generates a string description of this instance.
            */
            ManagedCountdownLatch.prototype.toString = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.format("Countdown Latch ({0})", fm.liveswitch.NumberExtensions.toString(this.getCount()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Returns a promise that resolves once the counter reaches zero.
            */
            ManagedCountdownLatch.prototype.waitAsync = function () {
                if (arguments.length == 0) {
                    if ((this.__counter.getValue() <= 0)) {
                        return fm.liveswitch.PromiseBase.resolveNow(null);
                    }
                    return this.__waitPromise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ManagedCountdownLatch;
        }());
        liveswitch.ManagedCountdownLatch = ManagedCountdownLatch;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var OperatingSystemWrapper = /** @class */ (function () {
            function OperatingSystemWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_5 = __arguments[0];
                    //super();
                    this._value = value_5;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            OperatingSystemWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.OperatingSystemWrapper]';
            };
            OperatingSystemWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.OperatingSystem.Unknown)
                        return 'Unknown';
                    if (this._value == fm.liveswitch.OperatingSystem.Windows)
                        return 'Windows';
                    if (this._value == fm.liveswitch.OperatingSystem.Android)
                        return 'Android';
                    if (this._value == fm.liveswitch.OperatingSystem.MacOS)
                        return 'MacOS';
                    if (this._value == fm.liveswitch.OperatingSystem.IOS)
                        return 'IOS';
                    if (this._value == fm.liveswitch.OperatingSystem.Linux)
                        return 'Linux';
                    if (this._value == fm.liveswitch.OperatingSystem.TvOS)
                        return 'TvOS';
                    if (this._value == fm.liveswitch.OperatingSystem.WatchOS)
                        return 'WatchOS';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return OperatingSystemWrapper;
        }());
        liveswitch.OperatingSystemWrapper = OperatingSystemWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var ArchitectureWrapper = /** @class */ (function () {
            function ArchitectureWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_6 = __arguments[0];
                    //super();
                    this._value = value_6;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            ArchitectureWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.ArchitectureWrapper]';
            };
            ArchitectureWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.Architecture.Unknown)
                        return 'Unknown';
                    if (this._value == fm.liveswitch.Architecture.X86)
                        return 'X86';
                    if (this._value == fm.liveswitch.Architecture.X64)
                        return 'X64';
                    if (this._value == fm.liveswitch.Architecture.Armv7)
                        return 'Armv7';
                    if (this._value == fm.liveswitch.Architecture.Armv8)
                        return 'Armv8';
                    if (this._value == fm.liveswitch.Architecture.Arm64)
                        return 'Arm64';
                    if (this._value == fm.liveswitch.Architecture.Mips)
                        return 'Mips';
                    if (this._value == fm.liveswitch.Architecture.Mips64)
                        return 'Mips64';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ArchitectureWrapper;
        }());
        liveswitch.ArchitectureWrapper = ArchitectureWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A pool of objects.
        */
        var Pool = /** @class */ (function () {
            function Pool() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var createObject = __arguments[0];
                    // chained constructor: Pool.call(this, createObject, 0);
                    __arguments = new Array(2);
                    __arguments[0] = createObject;
                    __arguments[1] = 0;
                    {
                        var createObject_1 = __arguments[0];
                        var minSize = __arguments[1];
                        // chained constructor: Pool.call(this, createObject, minSize, 2147483647);
                        __arguments = new Array(3);
                        __arguments[0] = createObject_1;
                        __arguments[1] = minSize;
                        __arguments[2] = 2147483647;
                        {
                            var createObject_2 = __arguments[0];
                            var minSize_1 = __arguments[1];
                            var maxSize = __arguments[2];
                            //super();
                            this.fmliveswitchPoolInit();
                            this.__destroyLock = new Object();
                            this.__isDestroyed = false;
                            if ((fm.liveswitch.Global.equals(createObject_2, null))) {
                                throw new fm.liveswitch.Exception("Cannot initialize pool without a function to create objects.");
                            }
                            if ((minSize_1 < 0)) {
                                throw new fm.liveswitch.Exception("Minimum pool size cannot be less than zero.");
                            }
                            if ((maxSize < 0)) {
                                throw new fm.liveswitch.Exception("Maximum pool size cannot be less than zero.");
                            }
                            if ((minSize_1 > maxSize)) {
                                throw new fm.liveswitch.Exception("Minimum pool size cannot be greater than maximum pool size.");
                            }
                            this.__createObject = createObject_2;
                            this.setMinSize(minSize_1);
                            this.setMaxSize(maxSize);
                            this.__stack = new fm.liveswitch.ManagedConcurrentStack();
                            this.__createObjectCounter = new fm.liveswitch.AtomicInteger();
                            for (var i = 0; (i < this.getMinSize()); i++) {
                                this.__createObjectCounter.increment();
                                this.__stack.push(this.__createObject());
                            }
                        }
                    }
                }
                else if (__arguments.length == 2) {
                    var createObject = __arguments[0];
                    var minSize = __arguments[1];
                    // chained constructor: Pool.call(this, createObject, minSize, 2147483647);
                    __arguments = new Array(3);
                    __arguments[0] = createObject;
                    __arguments[1] = minSize;
                    __arguments[2] = 2147483647;
                    {
                        var createObject_3 = __arguments[0];
                        var minSize_2 = __arguments[1];
                        var maxSize = __arguments[2];
                        //super();
                        this.fmliveswitchPoolInit();
                        this.__destroyLock = new Object();
                        this.__isDestroyed = false;
                        if ((fm.liveswitch.Global.equals(createObject_3, null))) {
                            throw new fm.liveswitch.Exception("Cannot initialize pool without a function to create objects.");
                        }
                        if ((minSize_2 < 0)) {
                            throw new fm.liveswitch.Exception("Minimum pool size cannot be less than zero.");
                        }
                        if ((maxSize < 0)) {
                            throw new fm.liveswitch.Exception("Maximum pool size cannot be less than zero.");
                        }
                        if ((minSize_2 > maxSize)) {
                            throw new fm.liveswitch.Exception("Minimum pool size cannot be greater than maximum pool size.");
                        }
                        this.__createObject = createObject_3;
                        this.setMinSize(minSize_2);
                        this.setMaxSize(maxSize);
                        this.__stack = new fm.liveswitch.ManagedConcurrentStack();
                        this.__createObjectCounter = new fm.liveswitch.AtomicInteger();
                        for (var i = 0; (i < this.getMinSize()); i++) {
                            this.__createObjectCounter.increment();
                            this.__stack.push(this.__createObject());
                        }
                    }
                }
                else if (__arguments.length == 3) {
                    var createObject = __arguments[0];
                    var minSize = __arguments[1];
                    var maxSize = __arguments[2];
                    //super();
                    this.fmliveswitchPoolInit();
                    this.__destroyLock = new Object();
                    this.__isDestroyed = false;
                    if ((fm.liveswitch.Global.equals(createObject, null))) {
                        throw new fm.liveswitch.Exception("Cannot initialize pool without a function to create objects.");
                    }
                    if ((minSize < 0)) {
                        throw new fm.liveswitch.Exception("Minimum pool size cannot be less than zero.");
                    }
                    if ((maxSize < 0)) {
                        throw new fm.liveswitch.Exception("Maximum pool size cannot be less than zero.");
                    }
                    if ((minSize > maxSize)) {
                        throw new fm.liveswitch.Exception("Minimum pool size cannot be greater than maximum pool size.");
                    }
                    this.__createObject = createObject;
                    this.setMinSize(minSize);
                    this.setMaxSize(maxSize);
                    this.__stack = new fm.liveswitch.ManagedConcurrentStack();
                    this.__createObjectCounter = new fm.liveswitch.AtomicInteger();
                    for (var i = 0; (i < this.getMinSize()); i++) {
                        this.__createObjectCounter.increment();
                        this.__stack.push(this.__createObject());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Pool.prototype.getTypeString = function () {
                return '[fm.liveswitch.Pool]';
            };
            Pool.prototype.fmliveswitchPoolInit = function () {
                this.__isDestroyed = false;
                this._maxSize = 0;
                this._minSize = 0;
            };
            /**
            Removes all items from the pool and calls a callback for each one.
            @param destroyCallback
            */
            Pool.prototype.destroy = function (destroyCallback) {
                if (arguments.length == 1) {
                    this.__isDestroyed = true;
                    var result = null;
                    var _var0 = new fm.liveswitch.Holder(result);
                    var _var1 = this.__stack.tryPop(_var0);
                    result = _var0.getValue();
                    while (_var1) {
                        destroyCallback(result);
                    }
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets an object.
            */
            Pool.prototype.get = function () {
                if (arguments.length == 0) {
                    var result = null;
                    var _var0 = new fm.liveswitch.Holder(result);
                    var _var1 = this.__stack.tryPop(_var0);
                    result = _var0.getValue();
                    if (_var1) {
                        return result;
                    }
                    if ((this.__createObjectCounter.increment() > this.getMaxSize())) {
                        this.__createObjectCounter.decrement();
                        throw new fm.liveswitch.Exception("Could not create pooled object. Maximum size reached.");
                    }
                    return this.__createObject();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of available objects.
            */
            Pool.prototype.getAvailable = function () {
                if (arguments.length == 0) {
                    return this.__stack.getCount();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the maximum size. Value must be >= 0. A value of 0 indicates no maximum.
            */
            Pool.prototype.getMaxSize = function () {
                if (arguments.length == 0) {
                    return this._maxSize;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the minimum size. Value must be >= 0.
            */
            Pool.prototype.getMinSize = function () {
                if (arguments.length == 0) {
                    return this._minSize;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the current size of the pool.
            */
            Pool.prototype.getSize = function () {
                if (arguments.length == 0) {
                    return this.__createObjectCounter.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Put an object back.
            @param item
            */
            Pool.prototype.put = function (item) {
                if (arguments.length == 1) {
                    if (((!fm.liveswitch.Global.equals(item, null)) && !this.__isDestroyed)) {
                        this.__stack.push(item);
                        return true;
                    }
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Pool.prototype.setMaxSize = function (value) {
                if (arguments.length == 1) {
                    this._maxSize = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Pool.prototype.setMinSize = function (value) {
                if (arguments.length == 1) {
                    this._minSize = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Pool;
        }());
        liveswitch.Pool = Pool;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var ProtocolTypeWrapper = /** @class */ (function () {
            function ProtocolTypeWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_7 = __arguments[0];
                    //super();
                    this._value = value_7;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            ProtocolTypeWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.ProtocolTypeWrapper]';
            };
            ProtocolTypeWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.ProtocolType.Udp)
                        return 'Udp';
                    if (this._value == fm.liveswitch.ProtocolType.Tcp)
                        return 'Tcp';
                    if (this._value == fm.liveswitch.ProtocolType.Tls)
                        return 'Tls';
                    if (this._value == fm.liveswitch.ProtocolType.Unknown)
                        return 'Unknown';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ProtocolTypeWrapper;
        }());
        liveswitch.ProtocolTypeWrapper = ProtocolTypeWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var SourceLanguageWrapper = /** @class */ (function () {
            function SourceLanguageWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_8 = __arguments[0];
                    //super();
                    this._value = value_8;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            SourceLanguageWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.SourceLanguageWrapper]';
            };
            SourceLanguageWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.SourceLanguage.CSharp)
                        return 'CSharp';
                    if (this._value == fm.liveswitch.SourceLanguage.Java)
                        return 'Java';
                    if (this._value == fm.liveswitch.SourceLanguage.ObjectiveC)
                        return 'ObjectiveC';
                    if (this._value == fm.liveswitch.SourceLanguage.TypeScript)
                        return 'TypeScript';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return SourceLanguageWrapper;
        }());
        liveswitch.SourceLanguageWrapper = SourceLanguageWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Provides methods for serializing/deserializing .NET value types to/from JSON as well as facilities for converting objects and arrays if appropriate callbacks are supplied to assist with the conversion.
        */
        var JsonSerializer = /** @class */ (function () {
            function JsonSerializer() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            JsonSerializer.prototype.getTypeString = function () {
                return '[fm.liveswitch.JsonSerializer]';
            };
            /** @hidden */
            JsonSerializer.charToUnicodeString = function (value) {
                if (arguments.length == 1) {
                    var ch = fm.liveswitch.JsonSerializer.intToHex(((value >> 12) & 15));
                    var ch2 = fm.liveswitch.JsonSerializer.intToHex(((value >> 8) & 15));
                    var ch3 = fm.liveswitch.JsonSerializer.intToHex(((value >> 4) & 15));
                    var ch4 = fm.liveswitch.JsonSerializer.intToHex((value & 15));
                    return fm.liveswitch.StringExtensions.concat(["\\u", String.fromCharCode(ch), String.fromCharCode(ch2), String.fromCharCode(ch3), String.fromCharCode(ch4)]);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a boolean value.
            @param valueJson The boolean JSON to deserialize.
            @return The deserialized boolean value.
            */
            JsonSerializer.deserializeBoolean = function (valueJson) {
                if (arguments.length == 1) {
                    if (!fm.liveswitch.StringExtensions.isNullOrEmpty(valueJson)) {
                        valueJson = fm.liveswitch.StringExtensions.trim(valueJson);
                        if ((fm.liveswitch.Global.equals(valueJson, "null"))) {
                            return null;
                        }
                        var boolResult = false;
                        var _var0 = new fm.liveswitch.Holder(boolResult);
                        var _var1 = fm.liveswitch.ParseAssistant.tryParseBooleanValue(valueJson, _var0);
                        boolResult = _var0.getValue();
                        if (_var1) {
                            return boolResult;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a boolean array from JSON.
            @param arrayJson A JSON-serialized boolean array.
            @return An array of boolean values.
            */
            JsonSerializer.deserializeBooleanArray = function (arrayJson) {
                if (arguments.length == 1) {
                    if (fm.liveswitch.StringExtensions.isNullOrEmpty(arrayJson)) {
                        return null;
                    }
                    arrayJson = fm.liveswitch.StringExtensions.trim(arrayJson);
                    if ((fm.liveswitch.Global.equals(arrayJson, "null"))) {
                        return null;
                    }
                    var flagArray = null;
                    if ((fm.liveswitch.Global.equals(arrayJson.charCodeAt(0), 91))) {
                        arrayJson = fm.liveswitch.StringExtensions.substring(arrayJson, 1, (fm.liveswitch.StringExtensions.getLength(arrayJson) - 2));
                        if (fm.liveswitch.StringExtensions.isNullOrEmpty(arrayJson)) {
                            flagArray = new Array(0);
                        }
                        else {
                            var strArray = fm.liveswitch.StringExtensions.split(arrayJson, [44]);
                            flagArray = new Array(strArray.length);
                            for (var i = 0; (i < strArray.length); i++) {
                                flagArray[i] = fm.liveswitch.JsonSerializer.deserializeBoolean(fm.liveswitch.StringExtensions.trim(strArray[i]));
                            }
                        }
                    }
                    return flagArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a decimal value.
            @param valueJson The decimal JSON to deserialize.
            @return The deserialized decimal value.
            */
            JsonSerializer.deserializeDecimal = function (valueJson) {
                if (arguments.length == 1) {
                    if (!fm.liveswitch.StringExtensions.isNullOrEmpty(valueJson)) {
                        valueJson = fm.liveswitch.StringExtensions.trim(valueJson);
                        if ((fm.liveswitch.Global.equals(valueJson, "null"))) {
                            return null;
                        }
                        var decimalResult = 0;
                        var _var0 = new fm.liveswitch.Holder(decimalResult);
                        var _var1 = fm.liveswitch.ParseAssistant.tryParseDecimalValue(valueJson, _var0);
                        decimalResult = _var0.getValue();
                        if (_var1) {
                            return decimalResult;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a decimal array from JSON.
            @param arrayJson A JSON-serialized decimal array.
            @return An array of decimal values.
            */
            JsonSerializer.deserializeDecimalArray = function (arrayJson) {
                if (arguments.length == 1) {
                    if (fm.liveswitch.StringExtensions.isNullOrEmpty(arrayJson)) {
                        return null;
                    }
                    arrayJson = fm.liveswitch.StringExtensions.trim(arrayJson);
                    if ((fm.liveswitch.Global.equals(arrayJson, "null"))) {
                        return null;
                    }
                    var numArray = null;
                    if ((fm.liveswitch.Global.equals(arrayJson.charCodeAt(0), 91))) {
                        arrayJson = fm.liveswitch.StringExtensions.substring(arrayJson, 1, (fm.liveswitch.StringExtensions.getLength(arrayJson) - 2));
                        if (fm.liveswitch.StringExtensions.isNullOrEmpty(arrayJson)) {
                            numArray = new Array(0);
                        }
                        else {
                            var strArray = fm.liveswitch.StringExtensions.split(arrayJson, [44]);
                            numArray = new Array(strArray.length);
                            for (var i = 0; (i < strArray.length); i++) {
                                numArray[i] = fm.liveswitch.JsonSerializer.deserializeDecimal(fm.liveswitch.StringExtensions.trim(strArray[i]));
                            }
                        }
                    }
                    return numArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a JSON string into a dictionary.
            @param dictionaryJson The JSON-encoded dictionary.
            @param createDictionaryCallback The callback that creates a blank dictionary.
            @param deserializeValueCallback The callback that deserializes a value.
            @return
                        The deserialized dictionary.
                
            */
            JsonSerializer.deserializeDictionary = function (dictionaryJson, createDictionaryCallback, deserializeValueCallback) {
                if (arguments.length == 3) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(dictionaryJson, createDictionaryCallback, function (dictionary, key, valueJson) {
                        dictionary[key] = deserializeValueCallback(valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a double value.
            @param valueJson The double JSON to deserialize.
            @return The deserialized double value.
            */
            JsonSerializer.deserializeDouble = function (valueJson) {
                if (arguments.length == 1) {
                    if (!fm.liveswitch.StringExtensions.isNullOrEmpty(valueJson)) {
                        valueJson = fm.liveswitch.StringExtensions.trim(valueJson);
                        if ((fm.liveswitch.Global.equals(valueJson, "null"))) {
                            return null;
                        }
                        var doubleResult = 0;
                        var _var0 = new fm.liveswitch.Holder(doubleResult);
                        var _var1 = fm.liveswitch.ParseAssistant.tryParseDoubleValue(valueJson, _var0);
                        doubleResult = _var0.getValue();
                        if (_var1) {
                            return doubleResult;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a double array from JSON.
            @param arrayJson A JSON-serialized double array.
            @return An array of double values.
            */
            JsonSerializer.deserializeDoubleArray = function (arrayJson) {
                if (arguments.length == 1) {
                    if (fm.liveswitch.StringExtensions.isNullOrEmpty(arrayJson)) {
                        return null;
                    }
                    arrayJson = fm.liveswitch.StringExtensions.trim(arrayJson);
                    if ((fm.liveswitch.Global.equals(arrayJson, "null"))) {
                        return null;
                    }
                    var numArray = null;
                    if ((fm.liveswitch.Global.equals(arrayJson.charCodeAt(0), 91))) {
                        arrayJson = fm.liveswitch.StringExtensions.substring(arrayJson, 1, (fm.liveswitch.StringExtensions.getLength(arrayJson) - 2));
                        if (fm.liveswitch.StringExtensions.isNullOrEmpty(arrayJson)) {
                            numArray = new Array(0);
                        }
                        else {
                            var strArray = fm.liveswitch.StringExtensions.split(arrayJson, [44]);
                            numArray = new Array(strArray.length);
                            for (var i = 0; (i < strArray.length); i++) {
                                numArray[i] = fm.liveswitch.JsonSerializer.deserializeDouble(fm.liveswitch.StringExtensions.trim(strArray[i]));
                            }
                        }
                    }
                    return numArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a float value.
            @param valueJson The float JSON to deserialize.
            @return The deserialized float value.
            */
            JsonSerializer.deserializeFloat = function (valueJson) {
                if (arguments.length == 1) {
                    if (!fm.liveswitch.StringExtensions.isNullOrEmpty(valueJson)) {
                        valueJson = fm.liveswitch.StringExtensions.trim(valueJson);
                        if ((fm.liveswitch.Global.equals(valueJson, "null"))) {
                            return null;
                        }
                        var floatResult = 0;
                        var _var0 = new fm.liveswitch.Holder(floatResult);
                        var _var1 = fm.liveswitch.ParseAssistant.tryParseFloatValue(valueJson, _var0);
                        floatResult = _var0.getValue();
                        if (_var1) {
                            return floatResult;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a float array from JSON.
            @param arrayJson A JSON-serialized float array.
            @return An array of float values.
            */
            JsonSerializer.deserializeFloatArray = function (arrayJson) {
                if (arguments.length == 1) {
                    if (fm.liveswitch.StringExtensions.isNullOrEmpty(arrayJson)) {
                        return null;
                    }
                    arrayJson = fm.liveswitch.StringExtensions.trim(arrayJson);
                    if ((fm.liveswitch.Global.equals(arrayJson, "null"))) {
                        return null;
                    }
                    var numArray = null;
                    if ((fm.liveswitch.Global.equals(arrayJson.charCodeAt(0), 91))) {
                        arrayJson = fm.liveswitch.StringExtensions.substring(arrayJson, 1, (fm.liveswitch.StringExtensions.getLength(arrayJson) - 2));
                        if (fm.liveswitch.StringExtensions.isNullOrEmpty(arrayJson)) {
                            numArray = new Array(0);
                        }
                        else {
                            var strArray = fm.liveswitch.StringExtensions.split(arrayJson, [44]);
                            numArray = new Array(strArray.length);
                            for (var i = 0; (i < strArray.length); i++) {
                                numArray[i] = fm.liveswitch.JsonSerializer.deserializeFloat(fm.liveswitch.StringExtensions.trim(strArray[i]));
                            }
                        }
                    }
                    return numArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a globally unique identifier.
            @param valueJson The GUID JSON to deserialize.
            @return The deserialized GUID.
            */
            JsonSerializer.deserializeGuid = function (valueJson) {
                if (arguments.length == 1) {
                    if (!fm.liveswitch.StringExtensions.isNullOrEmpty(valueJson)) {
                        valueJson = fm.liveswitch.StringExtensions.trim(valueJson);
                        if ((fm.liveswitch.Global.equals(valueJson, "null"))) {
                            return null;
                        }
                        var empty = fm.liveswitch.Guid.empty;
                        var _var0 = new fm.liveswitch.Holder(empty);
                        var _var1 = fm.liveswitch.ParseAssistant.tryParseGuidValue(fm.liveswitch.JsonSerializer.deserializeString(valueJson), _var0);
                        empty = _var0.getValue();
                        if (_var1) {
                            return empty;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a GUID array from JSON.
            @param arrayJson A JSON-serialized GUID array.
            @return An array of GUID values.
            */
            JsonSerializer.deserializeGuidArray = function (arrayJson) {
                if (arguments.length == 1) {
                    if (fm.liveswitch.StringExtensions.isNullOrEmpty(arrayJson)) {
                        return null;
                    }
                    arrayJson = fm.liveswitch.StringExtensions.trim(arrayJson);
                    if ((fm.liveswitch.Global.equals(arrayJson, "null"))) {
                        return null;
                    }
                    var guidArray = null;
                    if ((fm.liveswitch.Global.equals(arrayJson.charCodeAt(0), 91))) {
                        arrayJson = fm.liveswitch.StringExtensions.substring(arrayJson, 1, (fm.liveswitch.StringExtensions.getLength(arrayJson) - 2));
                        if (fm.liveswitch.StringExtensions.isNullOrEmpty(arrayJson)) {
                            guidArray = new Array(0);
                        }
                        else {
                            var strArray = fm.liveswitch.StringExtensions.split(arrayJson, [44]);
                            guidArray = new Array(strArray.length);
                            for (var i = 0; (i < strArray.length); i++) {
                                guidArray[i] = fm.liveswitch.JsonSerializer.deserializeGuid(fm.liveswitch.StringExtensions.trim(strArray[i]));
                            }
                        }
                    }
                    return guidArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an integer value.
            @param valueJson The integer JSON to deserialize.
            @return The deserialized integer value.
            */
            JsonSerializer.deserializeInteger = function (valueJson) {
                if (arguments.length == 1) {
                    if (!fm.liveswitch.StringExtensions.isNullOrEmpty(valueJson)) {
                        valueJson = fm.liveswitch.StringExtensions.trim(valueJson);
                        if ((fm.liveswitch.Global.equals(valueJson, "null"))) {
                            return null;
                        }
                        var intResult = 0;
                        var _var0 = new fm.liveswitch.Holder(intResult);
                        var _var1 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(valueJson, _var0);
                        intResult = _var0.getValue();
                        if (_var1) {
                            return intResult;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a integer array from JSON.
            @param arrayJson A JSON-serialized integer array.
            @return An array of integer values.
            */
            JsonSerializer.deserializeIntegerArray = function (arrayJson) {
                if (arguments.length == 1) {
                    if (fm.liveswitch.StringExtensions.isNullOrEmpty(arrayJson)) {
                        return null;
                    }
                    arrayJson = fm.liveswitch.StringExtensions.trim(arrayJson);
                    if ((fm.liveswitch.Global.equals(arrayJson, "null"))) {
                        return null;
                    }
                    var numArray = null;
                    if ((fm.liveswitch.Global.equals(arrayJson.charCodeAt(0), 91))) {
                        arrayJson = fm.liveswitch.StringExtensions.substring(arrayJson, 1, (fm.liveswitch.StringExtensions.getLength(arrayJson) - 2));
                        if (fm.liveswitch.StringExtensions.isNullOrEmpty(arrayJson)) {
                            numArray = new Array(0);
                        }
                        else {
                            var strArray = fm.liveswitch.StringExtensions.split(arrayJson, [44]);
                            numArray = new Array(strArray.length);
                            for (var i = 0; (i < strArray.length); i++) {
                                numArray[i] = fm.liveswitch.JsonSerializer.deserializeInteger(fm.liveswitch.StringExtensions.trim(strArray[i]));
                            }
                        }
                    }
                    return numArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a long value.
            @param valueJson The long JSON to deserialize.
            @return The deserialized long value.
            */
            JsonSerializer.deserializeLong = function (valueJson) {
                if (arguments.length == 1) {
                    if (!fm.liveswitch.StringExtensions.isNullOrEmpty(valueJson)) {
                        valueJson = fm.liveswitch.StringExtensions.trim(valueJson);
                        if ((fm.liveswitch.Global.equals(valueJson, "null"))) {
                            return null;
                        }
                        var longResult = 0;
                        var _var0 = new fm.liveswitch.Holder(longResult);
                        var _var1 = fm.liveswitch.ParseAssistant.tryParseLongValue(valueJson, _var0);
                        longResult = _var0.getValue();
                        if (_var1) {
                            return longResult;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a long array from JSON.
            @param arrayJson A JSON-serialized long array.
            @return An array of long values.
            */
            JsonSerializer.deserializeLongArray = function (arrayJson) {
                if (arguments.length == 1) {
                    if (fm.liveswitch.StringExtensions.isNullOrEmpty(arrayJson)) {
                        return null;
                    }
                    arrayJson = fm.liveswitch.StringExtensions.trim(arrayJson);
                    if ((fm.liveswitch.Global.equals(arrayJson, "null"))) {
                        return null;
                    }
                    var numArray = null;
                    if ((fm.liveswitch.Global.equals(arrayJson.charCodeAt(0), 91))) {
                        arrayJson = fm.liveswitch.StringExtensions.substring(arrayJson, 1, (fm.liveswitch.StringExtensions.getLength(arrayJson) - 2));
                        if (fm.liveswitch.StringExtensions.isNullOrEmpty(arrayJson)) {
                            numArray = new Array(0);
                        }
                        else {
                            var strArray = fm.liveswitch.StringExtensions.split(arrayJson, [44]);
                            numArray = new Array(strArray.length);
                            for (var i = 0; (i < strArray.length); i++) {
                                numArray[i] = fm.liveswitch.JsonSerializer.deserializeLong(fm.liveswitch.StringExtensions.trim(strArray[i]));
                            }
                        }
                    }
                    return numArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a JSON string into a target object type.
            @param json The JSON-encoded string.
            @param creator The method used for creating a new object.
            @param callback The method used for deserializing a property.
            @return The deserialized object.
            */
            JsonSerializer.deserializeObject = function (json, creator, callback) {
                if (arguments.length == 3) {
                    if ((fm.liveswitch.Global.equals(json, null))) {
                        return null;
                    }
                    json = fm.liveswitch.StringExtensions.trim(json);
                    if (((fm.liveswitch.Global.equals(json, "null")) || (fm.liveswitch.StringExtensions.getLength(json) < 2))) {
                        return null;
                    }
                    var local = creator();
                    if ((((fm.liveswitch.Global.equals(json.charCodeAt(0), 123)) && (fm.liveswitch.Global.equals(json.charCodeAt((fm.liveswitch.StringExtensions.getLength(json) - 1)), 125))) && (fm.liveswitch.StringExtensions.getLength(json) > 2))) {
                        json = fm.liveswitch.StringExtensions.concat(fm.liveswitch.StringExtensions.substring(json, 1, (fm.liveswitch.StringExtensions.getLength(json) - 2)), ",");
                        var num = 0;
                        var num2 = 0;
                        var flag = false;
                        var num3 = -2;
                        var none = fm.liveswitch.StringType.None;
                        var startIndex = 0;
                        var num5 = 0;
                        var valueJson = fm.liveswitch.StringExtensions.empty;
                        var str2 = fm.liveswitch.StringExtensions.empty;
                        for (var i = 0; (i < fm.liveswitch.StringExtensions.getLength(json)); i++) {
                            var ch = json.charCodeAt(i);
                            var flag2 = (fm.liveswitch.Global.equals(num3, (i - 1)));
                            var flag3 = false;
                            if (!flag) {
                                var _var0 = ch;
                                if (_var0 == 91) {
                                    do {
                                        num2++;
                                        flag3 = true;
                                        break;
                                    } while (false);
                                }
                                else if (_var0 == 93) {
                                    do {
                                        num2--;
                                        flag3 = true;
                                        break;
                                    } while (false);
                                }
                                else if (_var0 == 123) {
                                    do {
                                        num++;
                                        flag3 = true;
                                        break;
                                    } while (false);
                                }
                                else if (_var0 == 125) {
                                    do {
                                        num--;
                                        flag3 = true;
                                        break;
                                    } while (false);
                                }
                            }
                            if (!flag3) {
                                if ((flag && !((!fm.liveswitch.Global.equals(ch, 92)) || flag2))) {
                                    num3 = i;
                                    flag3 = true;
                                }
                                if (!flag3) {
                                    if (((fm.liveswitch.Global.equals(num, 0)) && (fm.liveswitch.Global.equals(num2, 0)))) {
                                        var _var1 = ch;
                                        if (_var1 == 44) {
                                            do {
                                                if (!flag) {
                                                    str2 = fm.liveswitch.StringExtensions.trim(fm.liveswitch.StringExtensions.substring(json, num5, (i - num5)));
                                                    callback(local, fm.liveswitch.JsonSerializer.deserializeString(valueJson), str2);
                                                    startIndex = (i + 1);
                                                }
                                                flag3 = true;
                                                break;
                                            } while (false);
                                        }
                                        else if (_var1 == 58) {
                                            do {
                                                if (!flag) {
                                                    valueJson = fm.liveswitch.StringExtensions.trim(fm.liveswitch.StringExtensions.substring(json, startIndex, (i - startIndex)));
                                                    num5 = (i + 1);
                                                }
                                                flag3 = true;
                                                break;
                                            } while (false);
                                        }
                                    }
                                    if ((!flag3 && (((fm.liveswitch.Global.equals(ch, 39)) || (fm.liveswitch.Global.equals(ch, 34))) && !flag2))) {
                                        var type2 = ((fm.liveswitch.Global.equals(ch, 34)) ? fm.liveswitch.StringType.Double : fm.liveswitch.StringType.Single);
                                        if (!flag) {
                                            flag = true;
                                            none = type2;
                                        }
                                        else {
                                            if ((fm.liveswitch.Global.equals(none, type2))) {
                                                flag = false;
                                                none = fm.liveswitch.StringType.None;
                                            }
                                        }
                                        flag3 = true;
                                    }
                                }
                            }
                        }
                    }
                    return local;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a JSON string into an array of target object types.
            @param json The JSON-encoded string.
            @param deserializer The callback used to deserialize each item in the array.
            @return An array of deserialized objects.
            */
            JsonSerializer.deserializeObjectArray = function (json, deserializer) {
                if (arguments.length == 2) {
                    var list = fm.liveswitch.JsonSerializer.deserializeRawArray(json);
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    var list2 = new Array();
                    for (var _i = 0, list_3 = list; _i < list_3.length; _i++) {
                        var str = list_3[_i];
                        var item = deserializer(str);
                        fm.liveswitch.ArrayExtensions.add(list2, item);
                    }
                    return list2;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a JSON string into a [[fm.liveswitch.serializable]] target object type.
            @param json The JSON-encoded string.
            @param creator The method used for creating a new object.
            @param callback The method used for deserializing a property.
            @return The deserialized object.
            */
            JsonSerializer.deserializeObjectFast = function (json, creator, callback) {
                if (arguments.length == 3) {
                    var local = fm.liveswitch.JsonSerializer.deserializeObject(json, creator, callback);
                    if ((!fm.liveswitch.Global.equals(local, null))) {
                        local.setSerialized(json);
                    }
                    return local;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a piece of raw JSON.
            @param dataJson The raw data.
            @return The deserialized data.
            */
            JsonSerializer.deserializeRaw = function (dataJson) {
                if (arguments.length == 1) {
                    if (fm.liveswitch.StringExtensions.isNullOrEmpty(dataJson)) {
                        return null;
                    }
                    return fm.liveswitch.StringExtensions.trim(dataJson);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a raw array from JSON.
            @param json A JSON-serialized raw array.
            @return An array of raw values.
            */
            JsonSerializer.deserializeRawArray = function (json) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(json, null))) {
                        return null;
                    }
                    json = fm.liveswitch.StringExtensions.trim(json);
                    if (((fm.liveswitch.Global.equals(json, "null")) || (fm.liveswitch.StringExtensions.getLength(json) < 2))) {
                        return null;
                    }
                    var list = new Array();
                    if ((((fm.liveswitch.Global.equals(json.charCodeAt(0), 91)) && (fm.liveswitch.Global.equals(json.charCodeAt((fm.liveswitch.StringExtensions.getLength(json) - 1)), 93))) && (fm.liveswitch.StringExtensions.getLength(json) > 2))) {
                        var num = 0;
                        var startIndex = 0;
                        var flag = false;
                        var num3 = -2;
                        var none = fm.liveswitch.StringType.None;
                        for (var i = 1; (i < (fm.liveswitch.StringExtensions.getLength(json) - 1)); i++) {
                            var ch = json.charCodeAt(i);
                            var flag2 = (fm.liveswitch.Global.equals(num3, (i - 1)));
                            if (!flag) {
                                var _var0 = ch;
                                if (_var0 == 123) {
                                    do {
                                        if ((fm.liveswitch.Global.equals(num, 0))) {
                                            startIndex = i;
                                        }
                                        num++;
                                        break;
                                    } while (false);
                                }
                                else if (_var0 == 125) {
                                    do {
                                        num--;
                                        if ((fm.liveswitch.Global.equals(num, 0))) {
                                            fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.substring(json, startIndex, ((i - startIndex) + 1)));
                                        }
                                        break;
                                    } while (false);
                                }
                            }
                            if ((flag && !((!fm.liveswitch.Global.equals(ch, 92)) || flag2))) {
                                num3 = i;
                            }
                            else {
                                if ((((fm.liveswitch.Global.equals(ch, 39)) || (fm.liveswitch.Global.equals(ch, 34))) && !flag2)) {
                                    var type2 = ((fm.liveswitch.Global.equals(ch, 34)) ? fm.liveswitch.StringType.Double : fm.liveswitch.StringType.Single);
                                    if (!flag) {
                                        flag = true;
                                        none = type2;
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(none, type2))) {
                                            flag = false;
                                            none = fm.liveswitch.StringType.None;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    return list;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a string.
            @param valueJson The string to deserialize.
            @return The deserialized string value.
            */
            JsonSerializer.deserializeString = function (valueJson) {
                if (arguments.length == 1) {
                    if (fm.liveswitch.StringExtensions.isNullOrEmpty(valueJson)) {
                        return null;
                    }
                    valueJson = fm.liveswitch.StringExtensions.trim(valueJson);
                    if ((fm.liveswitch.Global.equals(valueJson, "null"))) {
                        return null;
                    }
                    var flag = (fm.liveswitch.StringExtensions.startsWith(valueJson, "\"") || fm.liveswitch.StringExtensions.startsWith(valueJson, "'"));
                    var flag2 = (fm.liveswitch.StringExtensions.endsWith(valueJson, "\"") || fm.liveswitch.StringExtensions.endsWith(valueJson, "'"));
                    if (!(flag && flag2)) {
                        return null;
                    }
                    return fm.liveswitch.JsonSerializer.unescapeString(fm.liveswitch.JsonSerializer.trimQuotes(valueJson));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a simple string array from JSON.
            @param arrayJson A JSON-serialized string array.
            @return An array of string values.
            */
            JsonSerializer.deserializeStringArray = function (arrayJson) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(arrayJson, null))) {
                        return null;
                    }
                    var str = null;
                    var list = new Array();
                    var str2 = "array-start";
                    for (var i = 0; (i < fm.liveswitch.StringExtensions.getLength(arrayJson)); i++) {
                        var ch = arrayJson.charCodeAt(i);
                        var _var0 = str2;
                        if (_var0 == "array-start") {
                            do {
                                if ((fm.liveswitch.Global.equals(ch, 91))) {
                                    str2 = "value-start";
                                }
                                else {
                                    if (((((!fm.liveswitch.Global.equals(ch, 32)) && (fm.liveswitch.Global.equals(ch, 9))) && (!fm.liveswitch.Global.equals(ch, 10))) && (!fm.liveswitch.Global.equals(ch, 13)))) {
                                        return null;
                                    }
                                }
                                break;
                            } while (false);
                        }
                        else if (_var0 == "value-start") {
                            do {
                                if ((fm.liveswitch.Global.equals(ch, 93))) {
                                    str2 = "array-end";
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(ch, 34))) {
                                        str = "";
                                        str2 = "in-string";
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(ch, 110))) {
                                            str = null;
                                            str2 = "in-null-n";
                                        }
                                        else {
                                            if (((((!fm.liveswitch.Global.equals(ch, 32)) && (!fm.liveswitch.Global.equals(ch, 9))) && (!fm.liveswitch.Global.equals(ch, 10))) && (!fm.liveswitch.Global.equals(ch, 13)))) {
                                                return null;
                                            }
                                        }
                                    }
                                }
                                break;
                            } while (false);
                        }
                        else if (_var0 == "in-null-n") {
                            do {
                                if ((!fm.liveswitch.Global.equals(ch, 117))) {
                                    return null;
                                }
                                str2 = "in-null-nu";
                                break;
                            } while (false);
                        }
                        else if (_var0 == "in-null-nu") {
                            do {
                                if ((fm.liveswitch.Global.equals(ch, 108))) {
                                    str2 = "in-null-nul";
                                    break;
                                }
                                return null;
                            } while (false);
                        }
                        else if (_var0 == "in-null-nul") {
                            do {
                                if ((fm.liveswitch.Global.equals(ch, 108))) {
                                    fm.liveswitch.ArrayExtensions.add(list, null);
                                    str2 = "value-end";
                                    break;
                                }
                                return null;
                            } while (false);
                        }
                        else if (_var0 == "in-string") {
                            do {
                                if ((fm.liveswitch.Global.equals(ch, 34))) {
                                    fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.JsonSerializer.unescapeString(fm.liveswitch.JsonSerializer.trimQuotes(fm.liveswitch.StringExtensions.trim(str))));
                                    str = null;
                                    str2 = "value-end";
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(ch, 92))) {
                                        str = fm.liveswitch.StringExtensions.concat(str, "\\");
                                        str2 = "in-string-escape";
                                    }
                                    else {
                                        str = fm.liveswitch.StringExtensions.concat(str, String.fromCharCode(ch));
                                    }
                                }
                                break;
                            } while (false);
                        }
                        else if (_var0 == "in-string-escape") {
                            do {
                                str = fm.liveswitch.StringExtensions.concat(str, String.fromCharCode(ch));
                                str2 = "in-string";
                                break;
                            } while (false);
                        }
                        else if (_var0 == "value-end") {
                            do {
                                if ((fm.liveswitch.Global.equals(ch, 44))) {
                                    str2 = "value-start";
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(ch, 93))) {
                                        str2 = "array-end";
                                    }
                                    else {
                                        if (((((!fm.liveswitch.Global.equals(ch, 32)) && (!fm.liveswitch.Global.equals(ch, 9))) && (!fm.liveswitch.Global.equals(ch, 10))) && (!fm.liveswitch.Global.equals(ch, 13)))) {
                                            return null;
                                        }
                                    }
                                }
                                break;
                            } while (false);
                        }
                        else {
                            do {
                                if (((fm.liveswitch.Global.equals(str2, "array-end")) && ((((!fm.liveswitch.Global.equals(ch, 32)) && (!fm.liveswitch.Global.equals(ch, 9))) && (!fm.liveswitch.Global.equals(ch, 10))) && (!fm.liveswitch.Global.equals(ch, 13))))) {
                                    return null;
                                }
                                break;
                            } while (false);
                        }
                    }
                    if ((!fm.liveswitch.Global.equals(str2, "array-end"))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Escapes any special characters in a string.
            @param text The string without escaped characters.
            @return The escaped string.
            */
            JsonSerializer.escapeString = function (text) {
                if (arguments.length == 1) {
                    var builder = new fm.liveswitch.StringBuilder();
                    var startIndex = -1;
                    for (var i = 0; (i < fm.liveswitch.StringExtensions.getLength(text)); i++) {
                        var ch = text.charCodeAt(i);
                        if ((ch > 126)) {
                            if ((!fm.liveswitch.Global.equals(startIndex, -1))) {
                                builder.append(text, startIndex, (i - startIndex));
                                startIndex = -1;
                            }
                            builder.append(fm.liveswitch.JsonSerializer.charToUnicodeString(ch));
                        }
                        else {
                            var _var0 = ch;
                            if (_var0 == 8) {
                                do {
                                    if ((!fm.liveswitch.Global.equals(startIndex, -1))) {
                                        builder.append(text, startIndex, (i - startIndex));
                                        startIndex = -1;
                                    }
                                    builder.append("\\b");
                                    break;
                                } while (false);
                            }
                            else if (_var0 == 12) {
                                do {
                                    if ((!fm.liveswitch.Global.equals(startIndex, -1))) {
                                        builder.append(text, startIndex, (i - startIndex));
                                        startIndex = -1;
                                    }
                                    builder.append("\\f");
                                    break;
                                } while (false);
                            }
                            else if (_var0 == 10) {
                                do {
                                    if ((!fm.liveswitch.Global.equals(startIndex, -1))) {
                                        builder.append(text, startIndex, (i - startIndex));
                                        startIndex = -1;
                                    }
                                    builder.append("\\n");
                                    break;
                                } while (false);
                            }
                            else if (_var0 == 13) {
                                do {
                                    if ((!fm.liveswitch.Global.equals(startIndex, -1))) {
                                        builder.append(text, startIndex, (i - startIndex));
                                        startIndex = -1;
                                    }
                                    builder.append("\\r");
                                    break;
                                } while (false);
                            }
                            else if (_var0 == 9) {
                                do {
                                    if ((!fm.liveswitch.Global.equals(startIndex, -1))) {
                                        builder.append(text, startIndex, (i - startIndex));
                                        startIndex = -1;
                                    }
                                    builder.append("\\t");
                                    break;
                                } while (false);
                            }
                            else if (_var0 == 34) {
                                do {
                                    if ((!fm.liveswitch.Global.equals(startIndex, -1))) {
                                        builder.append(text, startIndex, (i - startIndex));
                                        startIndex = -1;
                                    }
                                    builder.append("\\\"");
                                    break;
                                } while (false);
                            }
                            else if (_var0 == 47) {
                                do {
                                    if ((!fm.liveswitch.Global.equals(startIndex, -1))) {
                                        builder.append(text, startIndex, (i - startIndex));
                                        startIndex = -1;
                                    }
                                    builder.append("\\/");
                                    break;
                                } while (false);
                            }
                            else if (_var0 == 92) {
                                do {
                                    if ((!fm.liveswitch.Global.equals(startIndex, -1))) {
                                        builder.append(text, startIndex, (i - startIndex));
                                        startIndex = -1;
                                    }
                                    builder.append("\\\\");
                                    break;
                                } while (false);
                            }
                            else {
                                do {
                                    if ((fm.liveswitch.Global.equals(startIndex, -1))) {
                                        startIndex = i;
                                    }
                                    break;
                                } while (false);
                            }
                        }
                    }
                    if ((!fm.liveswitch.Global.equals(startIndex, -1))) {
                        builder.append(text, startIndex, (fm.liveswitch.StringExtensions.getLength(text) - startIndex));
                    }
                    return builder.toString();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            JsonSerializer.intToHex = function (value) {
                if (arguments.length == 1) {
                    if ((value <= 9)) {
                        return (value + 48);
                    }
                    return ((value - 10) + 97);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Determines whether the specified JSON string is valid.
            @param json The JSON string to validate.
            @return True if the JSON string is valid; false otherwise.
            */
            JsonSerializer.isValidJson = function (json) {
                if (arguments.length == 1) {
                    return new fm.liveswitch.JsonChecker().checkString(json);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a boolean value.
            @param value The boolean to serialize.
            @return The serialized boolean value.
            */
            JsonSerializer.serializeBoolean = function (value) {
                if (arguments.length == 1) {
                    if (!(value != null)) {
                        return "null";
                    }
                    if (value) {
                        return "true";
                    }
                    return "false";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a boolean array to JSON.
            @param array An array of boolean values.
            @return A JSON-serialized boolean array.
            */
            JsonSerializer.serializeBooleanArray = function (array) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(array, null))) {
                        return "null";
                    }
                    var strArray = new Array(array.length);
                    for (var i = 0; (i < array.length); i++) {
                        strArray[i] = fm.liveswitch.JsonSerializer.serializeBoolean(array[i]);
                    }
                    return fm.liveswitch.StringExtensions.concat("[", fm.liveswitch.StringExtensions.join(",", strArray), "]");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a decimal value.
            @param value The decimal to serialize.
            @return The serialized decimal value.
            */
            JsonSerializer.serializeDecimal = function (value) {
                if (arguments.length == 1) {
                    if (!(value != null)) {
                        return "null";
                    }
                    return fm.liveswitch.NumberExtensions.toString(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a decimal array to JSON.
            @param array An array of decimal values.
            @return A JSON-serialized decimal array.
            */
            JsonSerializer.serializeDecimalArray = function (array) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(array, null))) {
                        return "null";
                    }
                    var strArray = new Array(array.length);
                    for (var i = 0; (i < array.length); i++) {
                        strArray[i] = fm.liveswitch.JsonSerializer.serializeDecimal(array[i]);
                    }
                    return fm.liveswitch.StringExtensions.concat("[", fm.liveswitch.StringExtensions.join(",", strArray), "]");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a dictionary into a JSON string.
            @param dictionary The dictionary being serialized.
            @param serializeValueCallback The callback that serializes a value.
            @return The dictionary as a JSON string.
            */
            JsonSerializer.serializeDictionary = function (dictionary, serializeValueCallback) {
                if (arguments.length == 2) {
                    return fm.liveswitch.JsonSerializer.serializeObject(dictionary, function (d, jsonObject) {
                        for (var _i = 0, _a = fm.liveswitch.HashExtensions.getKeys(d); _i < _a.length; _i++) {
                            var str = _a[_i];
                            jsonObject[str] = serializeValueCallback(d[str]);
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a double value.
            @param value The double to serialize.
            @return The serialized double value.
            */
            JsonSerializer.serializeDouble = function (value) {
                if (arguments.length == 1) {
                    if (!(value != null)) {
                        return "null";
                    }
                    return fm.liveswitch.NumberExtensions.toString(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a double array to JSON.
            @param array An array of double values.
            @return A JSON-serialized double array.
            */
            JsonSerializer.serializeDoubleArray = function (array) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(array, null))) {
                        return "null";
                    }
                    var strArray = new Array(array.length);
                    for (var i = 0; (i < array.length); i++) {
                        strArray[i] = fm.liveswitch.JsonSerializer.serializeDouble(array[i]);
                    }
                    return fm.liveswitch.StringExtensions.concat("[", fm.liveswitch.StringExtensions.join(",", strArray), "]");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a float value.
            @param value The float to serialize.
            @return The serialized float value.
            */
            JsonSerializer.serializeFloat = function (value) {
                if (arguments.length == 1) {
                    if (!(value != null)) {
                        return "null";
                    }
                    return fm.liveswitch.NumberExtensions.toString(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a float array to JSON.
            @param array An array of float values.
            @return A JSON-serialized float array.
            */
            JsonSerializer.serializeFloatArray = function (array) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(array, null))) {
                        return "null";
                    }
                    var strArray = new Array(array.length);
                    for (var i = 0; (i < array.length); i++) {
                        strArray[i] = fm.liveswitch.JsonSerializer.serializeFloat(array[i]);
                    }
                    return fm.liveswitch.StringExtensions.concat("[", fm.liveswitch.StringExtensions.join(",", strArray), "]");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a globally unique identifier.
            @param value The GUID to serialize.
            @return The serialized GUID.
            */
            JsonSerializer.serializeGuid = function (value) {
                if (arguments.length == 1) {
                    if (!(value != null)) {
                        return "null";
                    }
                    return fm.liveswitch.StringExtensions.concat("\"", value.toString(), "\"");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a GUID array to JSON.
            @param array An array of GUID values.
            @return A JSON-serialized GUID array.
            */
            JsonSerializer.serializeGuidArray = function (array) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(array, null))) {
                        return "null";
                    }
                    var strArray = new Array(array.length);
                    for (var i = 0; (i < array.length); i++) {
                        strArray[i] = fm.liveswitch.JsonSerializer.serializeGuid(array[i]);
                    }
                    return fm.liveswitch.StringExtensions.concat("[", fm.liveswitch.StringExtensions.join(",", strArray), "]");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an integer value.
            @param value The integer to serialize.
            @return The serialized integer value.
            */
            JsonSerializer.serializeInteger = function (value) {
                if (arguments.length == 1) {
                    if (!(value != null)) {
                        return "null";
                    }
                    return fm.liveswitch.NumberExtensions.toString(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a integer array to JSON.
            @param array An array of integer values.
            @return A JSON-serialized integer array.
            */
            JsonSerializer.serializeIntegerArray = function (array) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(array, null))) {
                        return "null";
                    }
                    var strArray = new Array(array.length);
                    for (var i = 0; (i < array.length); i++) {
                        strArray[i] = fm.liveswitch.JsonSerializer.serializeInteger(array[i]);
                    }
                    return fm.liveswitch.StringExtensions.concat("[", fm.liveswitch.StringExtensions.join(",", strArray), "]");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a long value.
            @param value The long to serialize.
            @return The serialized long value.
            */
            JsonSerializer.serializeLong = function (value) {
                if (arguments.length == 1) {
                    if (!(value != null)) {
                        return "null";
                    }
                    return fm.liveswitch.NumberExtensions.toString(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a long array to JSON.
            @param array An array of long values.
            @return A JSON-serialized long array.
            */
            JsonSerializer.serializeLongArray = function (array) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(array, null))) {
                        return "null";
                    }
                    var strArray = new Array(array.length);
                    for (var i = 0; (i < array.length); i++) {
                        strArray[i] = fm.liveswitch.JsonSerializer.serializeLong(array[i]);
                    }
                    return fm.liveswitch.StringExtensions.concat("[", fm.liveswitch.StringExtensions.join(",", strArray), "]");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an object into a JSON string.
            @param source The object being serialized.
            @param callback The method used for serializing properties.
            @return The object as a JSON string.
            */
            JsonSerializer.serializeObject = function (source, callback) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(source, null))) {
                        return "null";
                    }
                    var dictionary = {};
                    callback(source, dictionary);
                    var list = new Array();
                    for (var _i = 0, _a = fm.liveswitch.HashExtensions.getKeys(dictionary); _i < _a.length; _i++) {
                        var str = _a[_i];
                        fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.concat(fm.liveswitch.JsonSerializer.serializeString(str), ":", dictionary[str]));
                    }
                    return fm.liveswitch.StringExtensions.concat("{", fm.liveswitch.StringExtensions.join(",", fm.liveswitch.ArrayExtensions.toArray(list)), "}");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an object array into a JSON string.
            @param objects The object array being serialized.
            @param serializer The callback used to serialize each item in the array.
            @return The object array as a JSON string.
            */
            JsonSerializer.serializeObjectArray = function (objects, serializer) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(objects, null))) {
                        return "null";
                    }
                    if ((fm.liveswitch.Global.equals(objects.length, 0))) {
                        return "[]";
                    }
                    var strArray = new Array(objects.length);
                    for (var i = 0; (i < objects.length); i++) {
                        strArray[i] = serializer(objects[i]);
                    }
                    return fm.liveswitch.StringExtensions.concat("[", fm.liveswitch.StringExtensions.join(",", strArray), "]");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a [[fm.liveswitch.serializable]] object into a JSON string.
            @param source The object being serialized.
            @param callback The method used for serializing properties.
            @return The object as a JSON string.
            */
            JsonSerializer.serializeObjectFast = function (source, callback) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(source, null))) {
                        return "null";
                    }
                    if (!(source.getIsSerialized() && !source.getIsDirty())) {
                        source.setSerialized(fm.liveswitch.JsonSerializer.serializeObject(source, callback));
                    }
                    return source.getSerialized();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a piece of raw JSON.
            @param dataJson The raw data.
            @return The serialized data.
            */
            JsonSerializer.serializeRaw = function (dataJson) {
                if (arguments.length == 1) {
                    return dataJson;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a raw array to JSON.
            @param jsons An array of raw values.
            @return A JSON-serialized raw array.
            */
            JsonSerializer.serializeRawArray = function (jsons) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(jsons, null))) {
                        return "null";
                    }
                    return fm.liveswitch.StringExtensions.concat("[", fm.liveswitch.StringExtensions.join(",", jsons), "]");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a string.
            @param value The string to serialize.
            @return The serialized string value.
            */
            JsonSerializer.serializeString = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(value, null))) {
                        return "null";
                    }
                    return fm.liveswitch.StringExtensions.concat("\"", fm.liveswitch.JsonSerializer.escapeString(value), "\"");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a string array to JSON.
            @param array An array of string values.
            @return A JSON-serialized string array.
            */
            JsonSerializer.serializeStringArray = function (array) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(array, null))) {
                        return "null";
                    }
                    var strArray = new Array(array.length);
                    for (var i = 0; (i < array.length); i++) {
                        strArray[i] = fm.liveswitch.JsonSerializer.serializeString(array[i]);
                    }
                    return fm.liveswitch.StringExtensions.concat("[", fm.liveswitch.StringExtensions.join(",", strArray), "]");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Trims the quotes from a JavaScript string value.
            @param value The JavaScript string value.
            @return The string without quotes.
            */
            JsonSerializer.trimQuotes = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.StringExtensions.getLength(value) > 1)) {
                        var ch = value.charCodeAt(0);
                        var ch2 = value.charCodeAt((fm.liveswitch.StringExtensions.getLength(value) - 1));
                        if (((fm.liveswitch.Global.equals(ch, ch2)) && ((fm.liveswitch.Global.equals(ch, 39)) || (fm.liveswitch.Global.equals(ch, 34))))) {
                            value = fm.liveswitch.StringExtensions.substring(value, 1, (fm.liveswitch.StringExtensions.getLength(value) - 2));
                        }
                    }
                    return value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Unescapes any special characters from a string.
            @param text The string with escaped characters.
            @return The unescaped string.
            */
            JsonSerializer.unescapeString = function (text) {
                if (arguments.length == 1) {
                    var builder = new fm.liveswitch.StringBuilder();
                    var startIndex = -1;
                    for (var i = 0; (i < fm.liveswitch.StringExtensions.getLength(text)); i++) {
                        var ch = text.charCodeAt(i);
                        if ((fm.liveswitch.Global.equals(ch, 92))) {
                            if ((!fm.liveswitch.Global.equals(startIndex, -1))) {
                                builder.append(text, startIndex, (i - startIndex));
                                startIndex = -1;
                            }
                            if ((fm.liveswitch.Global.equals(i, (fm.liveswitch.StringExtensions.getLength(text) - 1)))) {
                                continue;
                            }
                            var ch2 = text.charCodeAt((i + 1));
                            var _var0 = ch2;
                            if (_var0 == 98) {
                                do {
                                    builder.append("\b");
                                    break;
                                } while (false);
                            }
                            else if (_var0 == 102) {
                                do {
                                    builder.append("\f");
                                    break;
                                } while (false);
                            }
                            else if (_var0 == 110) {
                                do {
                                    builder.append("\n");
                                    break;
                                } while (false);
                            }
                            else if (_var0 == 114) {
                                do {
                                    builder.append("\r");
                                    break;
                                } while (false);
                            }
                            else if (_var0 == 116) {
                                do {
                                    builder.append("\t");
                                    break;
                                } while (false);
                            }
                            else if (_var0 == 47) {
                                do {
                                    builder.append("/");
                                    break;
                                } while (false);
                            }
                            else if (_var0 == 117) {
                                do {
                                    if ((i < (fm.liveswitch.StringExtensions.getLength(text) - 5))) {
                                        builder.append(String.fromCharCode(fm.liveswitch.JsonSerializer.unicodeStringToChar(fm.liveswitch.StringExtensions.substring(text, i, 6))));
                                        i = (i + 4);
                                    }
                                    else {
                                        builder.append("u");
                                    }
                                    break;
                                } while (false);
                            }
                            else if (_var0 == 120) {
                                do {
                                    if ((i < (fm.liveswitch.StringExtensions.getLength(text) - 3))) {
                                        builder.append(String.fromCharCode(fm.liveswitch.JsonSerializer.unicodeStringToChar(fm.liveswitch.StringExtensions.substring(text, i, 4))));
                                        i = (i + 2);
                                    }
                                    else {
                                        builder.append("x");
                                    }
                                    break;
                                } while (false);
                            }
                            else {
                                do {
                                    builder.append(String.fromCharCode(ch2));
                                    break;
                                } while (false);
                            }
                            i++;
                            continue;
                        }
                        if ((fm.liveswitch.Global.equals(startIndex, -1))) {
                            startIndex = i;
                        }
                    }
                    if ((!fm.liveswitch.Global.equals(startIndex, -1))) {
                        builder.append(text, startIndex, (fm.liveswitch.StringExtensions.getLength(text) - startIndex));
                    }
                    return builder.toString();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            JsonSerializer.unicodeStringToChar = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.StringExtensions.getLength(value) < 2)) {
                        throw new fm.liveswitch.Exception("Unicode string has invalid length.");
                    }
                    return fm.liveswitch.Convert.toInt32(value.substring(2), 16);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return JsonSerializer;
        }());
        liveswitch.JsonSerializer = JsonSerializer;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="JsonSerializer.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Provides methods for serializing/deserializing .NET value types to/from JSON as well as facilities for converting objects and arrays if appropriate callbacks are supplied to assist with the conversion.
        */
        var Serializer = /** @class */ (function (_super) {
            __extends(Serializer, _super);
            function Serializer() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            Serializer.prototype.getTypeString = function () {
                return '[fm.liveswitch.Serializer]' + ',' + _super.prototype.getTypeString.call(this);
            };
            return Serializer;
        }(fm.liveswitch.JsonSerializer));
        liveswitch.Serializer = Serializer;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A simple state machine.
        */
        var StateMachine = /** @class */ (function () {
            /**
            Initializes a new instance of the [[fm.liveswitch.stateMachine]] class.
            @param initialState The initial state.
            */
            function StateMachine(initialState) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var initialState_1 = __arguments[0];
                    //super();
                    this.fmliveswitchStateMachineInit();
                    this.__pendingPromises = {};
                    this.__transitions = {};
                    this.__transitionReachabilityMatrix = {};
                    this.__states = new Array();
                    this.__transitionsLock = new Object();
                    this.setSystemTimestamp(-1);
                    this.setLastStateTicks(-1);
                    this.setStateValue(this.stateToValue(initialState_1));
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            StateMachine.prototype.getTypeString = function () {
                return '[fm.liveswitch.StateMachine]';
            };
            StateMachine.prototype.fmliveswitchStateMachineInit = function () {
                this.__stateValue = 0;
                this._lastStateTicks = 0;
                this._systemTimestamp = 0;
            };
            /** @hidden */
            StateMachine.prototype.addPendingPromise = function (state, promise, returnValue) {
                if (arguments.length == 3) {
                    var item = new fm.liveswitch.PendingPromise(promise, returnValue);
                    var list = null;
                    var _var0 = new fm.liveswitch.Holder(list);
                    var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this.__pendingPromises, state, _var0);
                    list = _var0.getValue();
                    if (!_var1) {
                        this.__pendingPromises[state] = list = new Array();
                    }
                    fm.liveswitch.ArrayExtensions.add(list, item);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds an allowed transition.
            @param fromState The "from" state.
            @param toState The "to" state.
            */
            StateMachine.prototype.addTransition = function (fromState, toState) {
                if (arguments.length == 2) {
                    var key = fm.liveswitch.NumberExtensions.toString(this.stateToValue(fromState));
                    var item = fm.liveswitch.NumberExtensions.toString(this.stateToValue(toState));
                    var list = null;
                    var _var0 = new fm.liveswitch.Holder(list);
                    var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this.__transitions, key, _var0);
                    list = _var0.getValue();
                    if (!_var1) {
                        this.__transitions[key] = list = new Array();
                    }
                    if (!fm.liveswitch.ArrayExtensions.contains(list, item)) {
                        fm.liveswitch.ArrayExtensions.add(list, item);
                    }
                    if (!fm.liveswitch.ArrayExtensions.contains(this.__states, key)) {
                        fm.liveswitch.ArrayExtensions.add(this.__states, key);
                    }
                    if (!fm.liveswitch.ArrayExtensions.contains(this.__states, item)) {
                        fm.liveswitch.ArrayExtensions.add(this.__states, item);
                    }
                    this.computeTransitionMatrix();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Determines whether a transition to the specified state is allowed.
            @param toState The "to" state.
            @return `true` if a transition to the specified state is allowed; otherwise, `false`.
                
            */
            StateMachine.prototype.canTransition = function (toState) {
                if (arguments.length == 1) {
                    var item = fm.liveswitch.NumberExtensions.toString(this.stateToValue(toState));
                    var list = null;
                    var _var0 = new fm.liveswitch.Holder(list);
                    var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this.__transitions, fm.liveswitch.NumberExtensions.toString(this.getStateValue()), _var0);
                    list = _var0.getValue();
                    if (!_var1) {
                        return false;
                    }
                    return fm.liveswitch.ArrayExtensions.contains(list, item);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            StateMachine.prototype.checkReachable = function (toState) {
                if (arguments.length == 1) {
                    var str = fm.liveswitch.NumberExtensions.toString(this.getStateValue());
                    return this.__transitionReachabilityMatrix[str][toState];
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            StateMachine.prototype.computeTransitionMatrix = function () {
                if (arguments.length == 0) {
                    fm.liveswitch.HashExtensions.clear(this.__transitionReachabilityMatrix);
                    for (var _i = 0, _a = this.__states; _i < _a.length; _i++) {
                        var str = _a[_i];
                        var discoveredToStates = {};
                        for (var _b = 0, _c = this.__states; _b < _c.length; _b++) {
                            var str2 = _c[_b];
                            discoveredToStates[str2] = false;
                        }
                        this.exploreStates(str, discoveredToStates);
                        this.__transitionReachabilityMatrix[str] = discoveredToStates;
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            StateMachine.prototype.exploreStates = function (fromState, discoveredToStates) {
                if (arguments.length == 2) {
                    var list = null;
                    var _var0 = new fm.liveswitch.Holder(list);
                    var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this.__transitions, fromState, _var0);
                    list = _var0.getValue();
                    if (_var1) {
                        for (var _i = 0, list_4 = list; _i < list_4.length; _i++) {
                            var str = list_4[_i];
                            if (!discoveredToStates[str]) {
                                discoveredToStates[str] = true;
                                this.exploreStates(str, discoveredToStates);
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the length of time spent in the last state, in milliseconds.
            */
            StateMachine.prototype.getLastStateMillis = function () {
                if (arguments.length == 0) {
                    var lastStateTicks = this.getLastStateTicks();
                    if ((fm.liveswitch.Global.equals(lastStateTicks, -1))) {
                        return -1;
                    }
                    return fm.liveswitch.MathAssistant.floor(lastStateTicks / fm.liveswitch.Constants.getTicksPerMillisecond());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the length of time spent in the last state, in ticks.
            */
            StateMachine.prototype.getLastStateTicks = function () {
                if (arguments.length == 0) {
                    return this._lastStateTicks;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a promise, which may be resolved or rejected depending on the current state of this machine.
            @param state State, in which promise must be resolved.
            @param returnValue Return type of this promise.
            @return Promise, which may be resolved or rejected depending on the current state of this machine
            */
            StateMachine.prototype.getPromise = function (state, returnValue) {
                if (arguments.length == 2) {
                    var toState = fm.liveswitch.NumberExtensions.toString(this.stateToValue(state));
                    var promise = new fm.liveswitch.Promise();
                    if ((fm.liveswitch.Global.equals(this.getStateValue(), this.stateToValue(state)))) {
                        promise.resolve(returnValue);
                        return promise;
                    }
                    if (!this.checkReachable(toState)) {
                        promise.reject(new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Cannot transition to state {0}.", state.toString())));
                        return promise;
                    }
                    this.addPendingPromise(toState, promise, returnValue);
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the state.
            */
            StateMachine.prototype.getState = function () {
                if (arguments.length == 0) {
                    return this.valueToState(this.__stateValue);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the state value.
            */
            StateMachine.prototype.getStateValue = function () {
                if (arguments.length == 0) {
                    return this.__stateValue;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the system timestamp of the last state transition.
            */
            StateMachine.prototype.getSystemTimestamp = function () {
                if (arguments.length == 0) {
                    return this._systemTimestamp;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Determines whether a transition to a specified state is possible (even via intermediate hops).
            @param state The "to" state.
            @return `true` if a transition to the specified state is possible; otherwise, `false`.
                
            */
            StateMachine.prototype.isReachable = function (state) {
                if (arguments.length == 1) {
                    var toState = fm.liveswitch.NumberExtensions.toString(this.stateToValue(state));
                    return this.checkReachable(toState);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            StateMachine.prototype.setLastStateTicks = function (value) {
                if (arguments.length == 1) {
                    this._lastStateTicks = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            StateMachine.prototype.setStateValue = function (value) {
                if (arguments.length == 1) {
                    var timestamp = fm.liveswitch.ManagedStopwatch.getTimestamp();
                    if ((!fm.liveswitch.Global.equals(this.getSystemTimestamp(), -1))) {
                        this.setLastStateTicks((timestamp - this.getSystemTimestamp()));
                    }
                    this.setSystemTimestamp(timestamp);
                    this.__stateValue = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            StateMachine.prototype.setSystemTimestamp = function (value) {
                if (arguments.length == 1) {
                    this._systemTimestamp = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Transitions to the specified state.
            @param toState The "to" state.
            @return `true` if a transition to the specified state is allowed; otherwise, `false`.
                
            */
            StateMachine.prototype.transition = function (toState) {
                if (arguments.length == 1) {
                    if (!this.canTransition(toState)) {
                        return false;
                    }
                    this.setStateValue(this.stateToValue(toState));
                    this.validatePendingPromises();
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            StateMachine.prototype.validatePendingPromises = function () {
                if (arguments.length == 0) {
                    for (var _i = 0, _a = fm.liveswitch.HashExtensions.getKeys(this.__pendingPromises); _i < _a.length; _i++) {
                        var str = _a[_i];
                        if ((fm.liveswitch.Global.equals(fm.liveswitch.NumberExtensions.toString(this.getStateValue()), str))) {
                            for (var _b = 0, _c = this.__pendingPromises[str]; _b < _c.length; _b++) {
                                var promise = _c[_b];
                                promise.resolve();
                            }
                            fm.liveswitch.HashExtensions.remove(this.__pendingPromises, str);
                        }
                        else {
                            if (!this.checkReachable(str)) {
                                for (var _d = 0, _e = this.__pendingPromises[str]; _d < _e.length; _d++) {
                                    var promise = _e[_d];
                                    promise.reject(new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Cannot transition to state {0}.", str.toString())));
                                }
                                fm.liveswitch.HashExtensions.remove(this.__pendingPromises, str);
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return StateMachine;
        }());
        liveswitch.StateMachine = StateMachine;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var StringTypeWrapper = /** @class */ (function () {
            function StringTypeWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_9 = __arguments[0];
                    //super();
                    this._value = value_9;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            StringTypeWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.StringTypeWrapper]';
            };
            StringTypeWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.StringType.None)
                        return 'None';
                    if (this._value == fm.liveswitch.StringType.Single)
                        return 'Single';
                    if (this._value == fm.liveswitch.StringType.Double)
                        return 'Double';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return StringTypeWrapper;
        }());
        liveswitch.StringTypeWrapper = StringTypeWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A linked list node.
        */
        var LinkedListNode = /** @class */ (function () {
            /**
            Initializes a new instance of the [[fm.liveswitch.linkedListNode]] class.
            @param item The item.
            */
            function LinkedListNode(item) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var item_1 = __arguments[0];
                    //super();
                    this.setValue(item_1);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            LinkedListNode.prototype.getTypeString = function () {
                return '[fm.liveswitch.LinkedListNode]';
            };
            /**
            Gets the next node. Will be `null` if last.
            */
            LinkedListNode.prototype.getNext = function () {
                if (arguments.length == 0) {
                    return this._next;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the previous node. Null if first.
            */
            LinkedListNode.prototype.getPrevious = function () {
                if (arguments.length == 0) {
                    return this._previous;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the item in the linked list.
            */
            LinkedListNode.prototype.getValue = function () {
                if (arguments.length == 0) {
                    return this._value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LinkedListNode.prototype.setNext = function (value) {
                if (arguments.length == 1) {
                    this._next = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LinkedListNode.prototype.setPrevious = function (value) {
                if (arguments.length == 1) {
                    this._previous = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LinkedListNode.prototype.setValue = function (value) {
                if (arguments.length == 1) {
                    this._value = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return LinkedListNode;
        }());
        liveswitch.LinkedListNode = LinkedListNode;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A linked list enumerator.
        */
        var LinkedListEnumerator = /** @class */ (function () {
            /**
            Initializes a new instance of the [[fm.liveswitch.linkedListEnumerator]] class.
            @param root The root node.
            */
            function LinkedListEnumerator(root) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var root_1 = __arguments[0];
                    //super();
                    this.fmliveswitchLinkedListEnumeratorInit();
                    this.__root = root_1;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            LinkedListEnumerator.prototype.getTypeString = function () {
                return '[fm.liveswitch.LinkedListEnumerator]';
            };
            LinkedListEnumerator.prototype.fmliveswitchLinkedListEnumeratorInit = function () {
                this.__started = false;
            };
            /**
            Gets the current value.
            */
            LinkedListEnumerator.prototype.getCurrent = function () {
                if (arguments.length == 0) {
                    return this.__currentNode.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the current node.
            */
            LinkedListEnumerator.prototype.getCurrentNode = function () {
                if (arguments.length == 0) {
                    return this.__currentNode;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Moves to the next node.
            */
            LinkedListEnumerator.prototype.moveNext = function () {
                if (arguments.length == 0) {
                    if (!((!fm.liveswitch.Global.equals(this.__currentNode, null)) || this.__started)) {
                        this.__started = true;
                        this.__currentNode = this.__root;
                    }
                    else {
                        this.__currentNode = this.__currentNode.getNext();
                    }
                    return (!fm.liveswitch.Global.equals(this.__currentNode, null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Resets this instance.
            */
            LinkedListEnumerator.prototype.reset = function () {
                if (arguments.length == 0) {
                    this.__started = false;
                    this.__currentNode = null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return LinkedListEnumerator;
        }());
        liveswitch.LinkedListEnumerator = LinkedListEnumerator;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var InternalConcurrentQueue = /** @class */ (function () {
            function InternalConcurrentQueue() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this._backingData = new Array();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            InternalConcurrentQueue.prototype.getTypeString = function () {
                return '[fm.liveswitch.InternalConcurrentQueue]';
            };
            InternalConcurrentQueue.prototype.enqueue = function (item) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this._backingData, item);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            InternalConcurrentQueue.prototype.getCount = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ArrayExtensions.getCount(this._backingData);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            InternalConcurrentQueue.prototype.getIsEmpty = function () {
                if (arguments.length == 0) {
                    return (fm.liveswitch.Global.equals(this.getCount(), 0));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            InternalConcurrentQueue.prototype.tryDequeue = function (item) {
                if (arguments.length == 1) {
                    if (this.getIsEmpty()) {
                        item.setValue(null);
                        return false;
                    }
                    item.setValue(this._backingData[0]);
                    fm.liveswitch.ArrayExtensions.removeAt(this._backingData, 0);
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            InternalConcurrentQueue.prototype.tryPeek = function (item) {
                if (arguments.length == 1) {
                    if (this.getIsEmpty()) {
                        item.setValue(null);
                        return false;
                    }
                    item.setValue(this._backingData[0]);
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return InternalConcurrentQueue;
        }());
        liveswitch.InternalConcurrentQueue = InternalConcurrentQueue;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var InternalConcurrentStack = /** @class */ (function () {
            function InternalConcurrentStack() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this._backingData = new Array();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            InternalConcurrentStack.prototype.getTypeString = function () {
                return '[fm.liveswitch.InternalConcurrentStack]';
            };
            InternalConcurrentStack.prototype.clear = function () {
                if (arguments.length == 0) {
                    fm.liveswitch.ArrayExtensions.clear(this._backingData);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            InternalConcurrentStack.prototype.getCount = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ArrayExtensions.getCount(this._backingData);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            InternalConcurrentStack.prototype.getIsEmpty = function () {
                if (arguments.length == 0) {
                    return (fm.liveswitch.Global.equals(this.getCount(), 0));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            InternalConcurrentStack.prototype.push = function (item) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this._backingData, item);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            InternalConcurrentStack.prototype.tryPeek = function (result) {
                if (arguments.length == 1) {
                    if (this.getIsEmpty()) {
                        result.setValue(null);
                        return false;
                    }
                    result.setValue(this._backingData[(fm.liveswitch.ArrayExtensions.getCount(this._backingData) - 1)]);
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            InternalConcurrentStack.prototype.tryPop = function (result) {
                if (arguments.length == 1) {
                    if (this.getIsEmpty()) {
                        result.setValue(null);
                        return false;
                    }
                    result.setValue(this._backingData[(fm.liveswitch.ArrayExtensions.getCount(this._backingData) - 1)]);
                    fm.liveswitch.ArrayExtensions.removeAt(this._backingData, (fm.liveswitch.ArrayExtensions.getCount(this._backingData) - 1));
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return InternalConcurrentStack;
        }());
        liveswitch.InternalConcurrentStack = InternalConcurrentStack;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A ConcurrentDictonary that maps to the appropriate platform version.
        */
        var ManagedConcurrentDictionary = /** @class */ (function () {
            function ManagedConcurrentDictionary() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    // chained constructor: ManagedConcurrentDictionary.call(this, null);
                    __arguments = new Array(1);
                    __arguments[0] = null;
                    {
                        var hashCallback = __arguments[0];
                        //super();
                        if ((fm.liveswitch.Global.equals(hashCallback, null))) {
                            this.__dictionary = new fm.liveswitch.InternalConcurrentDictionary(this.hash.bind(this));
                        }
                        else {
                            this.__dictionary = new fm.liveswitch.InternalConcurrentDictionary(hashCallback);
                        }
                    }
                }
                else if (__arguments.length == 1) {
                    var hashCallback = __arguments[0];
                    //super();
                    if ((fm.liveswitch.Global.equals(hashCallback, null))) {
                        this.__dictionary = new fm.liveswitch.InternalConcurrentDictionary(this.hash.bind(this));
                    }
                    else {
                        this.__dictionary = new fm.liveswitch.InternalConcurrentDictionary(hashCallback);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            ManagedConcurrentDictionary.prototype.getTypeString = function () {
                return '[fm.liveswitch.ManagedConcurrentDictionary]';
            };
            ManagedConcurrentDictionary.prototype.addOrUpdate = function () {
                if (arguments.length == 2) {
                    var key = arguments[0];
                    var addValue_1 = arguments[1];
                    return this.__dictionary.addOrUpdate(key, addValue_1, function (k, v) {
                        return addValue_1;
                    });
                }
                else if (arguments.length == 3) {
                    var key = arguments[0];
                    var addValue = arguments[1];
                    var updateValueFactory_1 = arguments[2];
                    return this.__dictionary.addOrUpdate(key, addValue, function (k, v) {
                        return updateValueFactory_1(k, v);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Clears the dictionary of all items.
            */
            ManagedConcurrentDictionary.prototype.clear = function () {
                if (arguments.length == 0) {
                    this.__dictionary.clear();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            True if the dictionary contains the key.
            @param key The key to check.
            */
            ManagedConcurrentDictionary.prototype.containsKey = function (key) {
                if (arguments.length == 1) {
                    return this.__dictionary.containsKey(key);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of items in the dictionary.
            */
            ManagedConcurrentDictionary.prototype.getCount = function () {
                if (arguments.length == 0) {
                    return this.__dictionary.getCount();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets true if dictionary is empty.
            */
            ManagedConcurrentDictionary.prototype.getIsEmpty = function () {
                if (arguments.length == 0) {
                    return this.__dictionary.getIsEmpty();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets an array of keys.
            */
            ManagedConcurrentDictionary.prototype.getKeys = function () {
                if (arguments.length == 0) {
                    return this.__dictionary.getKeys();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the value from the dictionary or adds a new one if it does not exist.
            @param key The key to use when adding to the dictionary.
            @param valueFactory The Func that will create a value if needed.
            @return The dictionary value if exist, the value returned by the Func if not.
            */
            ManagedConcurrentDictionary.prototype.getOrAdd = function (key, valueFactory) {
                if (arguments.length == 2) {
                    return this.__dictionary.getOrAdd(key, function (k) {
                        return valueFactory(k);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets an array of Values.
            */
            ManagedConcurrentDictionary.prototype.getValues = function () {
                if (arguments.length == 0) {
                    return this.__dictionary.getValues();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConcurrentDictionary.prototype.hash = function (key) {
                if (arguments.length == 1) {
                    return key.toString();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to add a new value to the dictionary.
            @param key The key to use when adding.
            @param value The value to be added to the dictionary.
            @return True if added, false if key already exists.
            */
            ManagedConcurrentDictionary.prototype.tryAdd = function (key, value) {
                if (arguments.length == 2) {
                    return this.__dictionary.tryAdd(key, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to get a value from the dictionary.
            @param key They key of the item to get form the dictionary.
            @param value The value that was just received or null if failed.
            @return True if succeeded.
            */
            ManagedConcurrentDictionary.prototype.tryGetValue = function (key, value) {
                if (arguments.length == 2) {
                    var _var0 = this.__dictionary.tryGetValue(key, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ManagedConcurrentDictionary.prototype.tryRemove = function () {
                if (arguments.length == 1) {
                    var key = arguments[0];
                    var local = null;
                    var _var0 = new fm.liveswitch.Holder(local);
                    var _var1 = this.__dictionary.tryRemove(key, _var0);
                    local = _var0.getValue();
                    return _var1;
                }
                else if (arguments.length == 2) {
                    var key = arguments[0];
                    var value = arguments[1];
                    var _var0 = this.__dictionary.tryRemove(key, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to update the value in the dictionary.
            @param key The key to use when updating.
            @param newValue The new value.
            @param comparisonValue The value to compare with the current value in the dictionary.
            @return True if succeeded.
            */
            ManagedConcurrentDictionary.prototype.tryUpdate = function (key, newValue, comparisonValue) {
                if (arguments.length == 3) {
                    return this.__dictionary.tryUpdate(key, newValue, comparisonValue);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ManagedConcurrentDictionary;
        }());
        liveswitch.ManagedConcurrentDictionary = ManagedConcurrentDictionary;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A thread-safe queue.
        */
        var ManagedConcurrentQueue = /** @class */ (function () {
            /**
            Creates a new ConcurrentQueue.
            */
            function ManagedConcurrentQueue() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.__queue = new fm.liveswitch.InternalConcurrentQueue();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            ManagedConcurrentQueue.prototype.getTypeString = function () {
                return '[fm.liveswitch.ManagedConcurrentQueue]';
            };
            /**
            Add the item to the end of the queue.
            @param item The item to add.
            */
            ManagedConcurrentQueue.prototype.enqueue = function (item) {
                if (arguments.length == 1) {
                    this.__queue.enqueue(item);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the amount of items in this queue.
            */
            ManagedConcurrentQueue.prototype.getCount = function () {
                if (arguments.length == 0) {
                    return this.__queue.getCount();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets true if the queue is empty.
            */
            ManagedConcurrentQueue.prototype.getIsEmpty = function () {
                if (arguments.length == 0) {
                    return this.__queue.getIsEmpty();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes and returns the item at the front of the queue.
            @param item The dequeued item.
            @return True if item received, false if no item.
            */
            ManagedConcurrentQueue.prototype.tryDequeue = function (item) {
                if (arguments.length == 1) {
                    var _var0 = this.__queue.tryDequeue(item);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Peeks at the first item in the queue.
            @param item The item at the front of the queue.
            @return False if queue is empty. True if first item peeked at.
            */
            ManagedConcurrentQueue.prototype.tryPeek = function (item) {
                if (arguments.length == 1) {
                    var _var0 = this.__queue.tryPeek(item);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ManagedConcurrentQueue;
        }());
        liveswitch.ManagedConcurrentQueue = ManagedConcurrentQueue;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A ConcurrentStack that maps to the appropriate platform version.
        */
        var ManagedConcurrentStack = /** @class */ (function () {
            /**
            Creates a new instance of a ConcurrentStack.
            */
            function ManagedConcurrentStack() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.__stack = new fm.liveswitch.InternalConcurrentStack();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            ManagedConcurrentStack.prototype.getTypeString = function () {
                return '[fm.liveswitch.ManagedConcurrentStack]';
            };
            /**
            Clears the stack of all items.
            */
            ManagedConcurrentStack.prototype.clear = function () {
                if (arguments.length == 0) {
                    this.__stack.clear();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the amount of items in the stack.
            */
            ManagedConcurrentStack.prototype.getCount = function () {
                if (arguments.length == 0) {
                    return this.__stack.getCount();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets true if the stack is empty.
            */
            ManagedConcurrentStack.prototype.getIsEmpty = function () {
                if (arguments.length == 0) {
                    return this.__stack.getIsEmpty();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Pushes a new item on top of the stack.
            @param item The item to push.
            */
            ManagedConcurrentStack.prototype.push = function (item) {
                if (arguments.length == 1) {
                    this.__stack.push(item);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to peek at the top value in stack.
            @param result The value from the stack if possible, null otherwise.
            @return True if peek succeeded, false if not.
            */
            ManagedConcurrentStack.prototype.tryPeek = function (result) {
                if (arguments.length == 1) {
                    var _var0 = this.__stack.tryPeek(result);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to pop the top value off of the stack.
            @param result The value from the top of the stack if possible, null otherwise.
            @return True if pop suceeded, false if not.
            */
            ManagedConcurrentStack.prototype.tryPop = function (result) {
                if (arguments.length == 1) {
                    var _var0 = this.__stack.tryPop(result);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ManagedConcurrentStack;
        }());
        liveswitch.ManagedConcurrentStack = ManagedConcurrentStack;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A mutable 2-tuple.
        */
        var MutablePair = /** @class */ (function () {
            /**
            Initializes a new instance of the [[fm.liveswitch.mutablePair]] class.
            @param item1 First item the tuple holds.
            @param item2 Second item the tuple holds.
            */
            function MutablePair(item1, item2) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 2) {
                    var item1_1 = __arguments[0];
                    var item2_1 = __arguments[1];
                    //super();
                    this.setItem1(item1_1);
                    this.setItem2(item2_1);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            MutablePair.prototype.getTypeString = function () {
                return '[fm.liveswitch.MutablePair]';
            };
            /**
            Gets the first item in the tuple.
            */
            MutablePair.prototype.getItem1 = function () {
                if (arguments.length == 0) {
                    return this._item1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the second item in the tuple.
            */
            MutablePair.prototype.getItem2 = function () {
                if (arguments.length == 0) {
                    return this._item2;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the first item in the tuple.
            */
            MutablePair.prototype.setItem1 = function (value) {
                if (arguments.length == 1) {
                    this._item1 = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the second item in the tuple.
            */
            MutablePair.prototype.setItem2 = function (value) {
                if (arguments.length == 1) {
                    this._item2 = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MutablePair;
        }());
        liveswitch.MutablePair = MutablePair;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A mutable 1-tuple.
        */
        var MutableUnit = /** @class */ (function () {
            /**
            Initializes a new instance of the [[fm.liveswitch.mutableUnit]] class.
            @param item The item to hold.
            */
            function MutableUnit(item) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var item_2 = __arguments[0];
                    //super();
                    this.setItem(item_2);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            MutableUnit.prototype.getTypeString = function () {
                return '[fm.liveswitch.MutableUnit]';
            };
            /**
            Gets the first item in the tuple.
            */
            MutableUnit.prototype.getItem = function () {
                if (arguments.length == 0) {
                    return this._item;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the first item in the tuple.
            */
            MutableUnit.prototype.setItem = function (value) {
                if (arguments.length == 1) {
                    this._item = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MutableUnit;
        }());
        liveswitch.MutableUnit = MutableUnit;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A 2-tuple.
        */
        var Pair = /** @class */ (function () {
            /**
            Initializes a new instance of the [[fm.liveswitch.pair]] class.
            @param item1 First item the tuple holds.
            @param item2 Second item the tuple holds.
            */
            function Pair(item1, item2) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 2) {
                    var item1_2 = __arguments[0];
                    var item2_2 = __arguments[1];
                    //super();
                    this.setItem1(item1_2);
                    this.setItem2(item2_2);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Pair.prototype.getTypeString = function () {
                return '[fm.liveswitch.Pair]';
            };
            /**
            Calculates the hashcode for this pair.
            */
            Pair.prototype.getHashCode = function () {
                if (arguments.length == 0) {
                    return (fm.liveswitch.ObjectExtensions.getHashCode(this.getItem1()) + fm.liveswitch.ObjectExtensions.getHashCode(this.getItem2()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the first item in the tuple.
            */
            Pair.prototype.getItem1 = function () {
                if (arguments.length == 0) {
                    return this._item1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the second item in the tuple.
            */
            Pair.prototype.getItem2 = function () {
                if (arguments.length == 0) {
                    return this._item2;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Pair.prototype.setItem1 = function (value) {
                if (arguments.length == 1) {
                    this._item1 = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Pair.prototype.setItem2 = function (value) {
                if (arguments.length == 1) {
                    this._item2 = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Pair;
        }());
        liveswitch.Pair = Pair;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="LogProvider.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Simple log provider that writes log events to a local array.
        */
        var LogEventLogProvider = /** @class */ (function (_super) {
            __extends(LogEventLogProvider, _super);
            function LogEventLogProvider() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    // chained constructor: LogEventLogProvider.call(this, fm.liveswitch.LogLevel.Info);
                    __arguments = new Array(1);
                    __arguments[0] = fm.liveswitch.LogLevel.Info;
                    {
                        var level = __arguments[0];
                        _this = _super.call(this) || this;
                        _this.__events = new Array();
                        _this.__eventsLock = new Object();
                        _super.prototype.setLevel.call(_this, level);
                    }
                }
                else if (__arguments.length == 1) {
                    var level = __arguments[0];
                    _this = _super.call(this) || this;
                    _this.__events = new Array();
                    _this.__eventsLock = new Object();
                    _super.prototype.setLevel.call(_this, level);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            LogEventLogProvider.prototype.getTypeString = function () {
                return '[fm.liveswitch.LogEventLogProvider]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Clears all text from the log and returns the former contents.
            */
            LogEventLogProvider.prototype.clear = function () {
                if (arguments.length == 0) {
                    var eventArray = void 0;
                    eventArray = fm.liveswitch.ArrayExtensions.toArray(this.__events);
                    this.__events = new Array();
                    return eventArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Logs a message at the specified log level.
            @param logEvent The log event details.
            */
            LogEventLogProvider.prototype.doLog = function (logEvent) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__events, logEvent);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the logged events.
            */
            LogEventLogProvider.prototype.getEvents = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ArrayExtensions.toArray(this.__events);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return LogEventLogProvider;
        }(fm.liveswitch.LogProvider));
        liveswitch.LogEventLogProvider = LogEventLogProvider;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A 3-tuple.
        */
        var Triple = /** @class */ (function () {
            /**
            Initializes a new instance of the [[fm.liveswitch.triple]] class.
            @param item1 First item the tuple holds.
            @param item2 Second item the tuple holds.
            @param item3 Third item the tuple holds.
            */
            function Triple(item1, item2, item3) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 3) {
                    var item1_3 = __arguments[0];
                    var item2_3 = __arguments[1];
                    var item3_1 = __arguments[2];
                    //super();
                    this.setItem1(item1_3);
                    this.setItem2(item2_3);
                    this.setItem3(item3_1);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Triple.prototype.getTypeString = function () {
                return '[fm.liveswitch.Triple]';
            };
            /**
            Gets the first item in the tuple.
            */
            Triple.prototype.getItem1 = function () {
                if (arguments.length == 0) {
                    return this._item1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the second item in the tuple.
            */
            Triple.prototype.getItem2 = function () {
                if (arguments.length == 0) {
                    return this._item2;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the third item in the tuple.
            */
            Triple.prototype.getItem3 = function () {
                if (arguments.length == 0) {
                    return this._item3;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Triple.prototype.setItem1 = function (value) {
                if (arguments.length == 1) {
                    this._item1 = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Triple.prototype.setItem2 = function (value) {
                if (arguments.length == 1) {
                    this._item2 = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Triple.prototype.setItem3 = function (value) {
                if (arguments.length == 1) {
                    this._item3 = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Triple;
        }());
        liveswitch.Triple = Triple;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A 1-tuple.
        */
        var Unit = /** @class */ (function () {
            /**
            Initializes a new instance of the [[fm.liveswitch.unit]] class.
            @param item The item to hold.
            */
            function Unit(item) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var item_3 = __arguments[0];
                    //super();
                    this.setItem(item_3);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Unit.prototype.getTypeString = function () {
                return '[fm.liveswitch.Unit]';
            };
            /**
            Gets the item in the tuple.
            */
            Unit.prototype.getItem = function () {
                if (arguments.length == 0) {
                    return this._item;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Unit.prototype.setItem = function (value) {
                if (arguments.length == 1) {
                    this._item = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Unit;
        }());
        liveswitch.Unit = Unit;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var CompareResultWrapper = /** @class */ (function () {
            function CompareResultWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_10 = __arguments[0];
                    //super();
                    this._value = value_10;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            CompareResultWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.CompareResultWrapper]';
            };
            CompareResultWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.CompareResult.Equal)
                        return 'Equal';
                    if (this._value == fm.liveswitch.CompareResult.Negative)
                        return 'Negative';
                    if (this._value == fm.liveswitch.CompareResult.Positive)
                        return 'Positive';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return CompareResultWrapper;
        }());
        liveswitch.CompareResultWrapper = CompareResultWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A collection of platform-independent constant values.
        */
        var Constants = /** @class */ (function () {
            function Constants() {
                fm.liveswitch.Constants.fmliveswitchConstantsInitialize();
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Constants.prototype.getTypeString = function () {
                return '[fm.liveswitch.Constants]';
            };
            /**
            Gets the number of hours in one day.
            */
            Constants.getHoursPerDay = function () {
                fm.liveswitch.Constants.fmliveswitchConstantsInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.Constants.fm_liveswitch_Constants___hoursPerDay;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of milliseconds in one hour.
            */
            Constants.getMillisecondsPerDay = function () {
                fm.liveswitch.Constants.fmliveswitchConstantsInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.Constants.fm_liveswitch_Constants___millisecondsPerDay;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of milliseconds in one hour.
            */
            Constants.getMillisecondsPerHour = function () {
                fm.liveswitch.Constants.fmliveswitchConstantsInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.Constants.fm_liveswitch_Constants___millisecondsPerHour;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of milliseconds in one minute.
            */
            Constants.getMillisecondsPerMinute = function () {
                fm.liveswitch.Constants.fmliveswitchConstantsInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.Constants.fm_liveswitch_Constants___millisecondsPerMinute;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of milliseconds in one second.
            */
            Constants.getMillisecondsPerSecond = function () {
                fm.liveswitch.Constants.fmliveswitchConstantsInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.Constants.fm_liveswitch_Constants___millisecondsPerSecond;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of minutes in one day.
            */
            Constants.getMinutesPerDay = function () {
                fm.liveswitch.Constants.fmliveswitchConstantsInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.Constants.fm_liveswitch_Constants___minutesPerDay;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of minutes in one hour.
            */
            Constants.getMinutesPerHour = function () {
                fm.liveswitch.Constants.fmliveswitchConstantsInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.Constants.fm_liveswitch_Constants___minutesPerHour;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of nanoseconds in one tick.
            */
            Constants.getNanosecondsPerTick = function () {
                fm.liveswitch.Constants.fmliveswitchConstantsInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.Constants.fm_liveswitch_Constants___nanosecondsPerTick;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of seconds in one day.
            */
            Constants.getSecondsPerDay = function () {
                fm.liveswitch.Constants.fmliveswitchConstantsInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.Constants.fm_liveswitch_Constants___secondsPerDay;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of seconds in one hour.
            */
            Constants.getSecondsPerHour = function () {
                fm.liveswitch.Constants.fmliveswitchConstantsInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.Constants.fm_liveswitch_Constants___secondsPerHour;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of seconds in one minute.
            */
            Constants.getSecondsPerMinute = function () {
                fm.liveswitch.Constants.fmliveswitchConstantsInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.Constants.fm_liveswitch_Constants___secondsPerMinute;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of ticks in one day.
            */
            Constants.getTicksPerDay = function () {
                fm.liveswitch.Constants.fmliveswitchConstantsInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.Constants.fm_liveswitch_Constants___ticksPerDay;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of ticks in one hour.
            */
            Constants.getTicksPerHour = function () {
                fm.liveswitch.Constants.fmliveswitchConstantsInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.Constants.fm_liveswitch_Constants___ticksPerHour;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of ticks in one millisecond.
            */
            Constants.getTicksPerMillisecond = function () {
                fm.liveswitch.Constants.fmliveswitchConstantsInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.Constants.fm_liveswitch_Constants___ticksPerMillisecond;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of ticks in one minute.
            */
            Constants.getTicksPerMinute = function () {
                fm.liveswitch.Constants.fmliveswitchConstantsInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.Constants.fm_liveswitch_Constants___ticksPerMinute;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of ticks in one second.
            */
            Constants.getTicksPerSecond = function () {
                fm.liveswitch.Constants.fmliveswitchConstantsInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.Constants.fm_liveswitch_Constants___ticksPerSecond;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Constants.fmliveswitchConstantsInitialize = function () {
                if (!fm.liveswitch.Constants.__fmliveswitchConstantsInitialized && !fm.liveswitch.Constants.__fmliveswitchConstantsInitializing) {
                    fm.liveswitch.Constants.__fmliveswitchConstantsInitializing = true;
                    Constants.fm_liveswitch_Constants___hoursPerDay = 0;
                    Constants.fm_liveswitch_Constants___millisecondsPerDay = 0;
                    Constants.fm_liveswitch_Constants___millisecondsPerHour = 0;
                    Constants.fm_liveswitch_Constants___millisecondsPerMinute = 0;
                    Constants.fm_liveswitch_Constants___millisecondsPerSecond = 0;
                    Constants.fm_liveswitch_Constants___minutesPerDay = 0;
                    Constants.fm_liveswitch_Constants___minutesPerHour = 0;
                    Constants.fm_liveswitch_Constants___nanosecondsPerTick = 0;
                    Constants.fm_liveswitch_Constants___secondsPerDay = 0;
                    Constants.fm_liveswitch_Constants___secondsPerHour = 0;
                    Constants.fm_liveswitch_Constants___secondsPerMinute = 0;
                    Constants.fm_liveswitch_Constants___ticksPerDay = 0;
                    Constants.fm_liveswitch_Constants___ticksPerHour = 0;
                    Constants.fm_liveswitch_Constants___ticksPerMillisecond = 0;
                    Constants.fm_liveswitch_Constants___ticksPerMinute = 0;
                    Constants.fm_liveswitch_Constants___ticksPerSecond = 0;
                    fm.liveswitch.Constants.fm_liveswitch_Constants___nanosecondsPerTick = 100;
                    fm.liveswitch.Constants.fm_liveswitch_Constants___ticksPerMillisecond = 10000;
                    fm.liveswitch.Constants.fm_liveswitch_Constants___millisecondsPerSecond = 1000;
                    fm.liveswitch.Constants.fm_liveswitch_Constants___secondsPerMinute = 60;
                    fm.liveswitch.Constants.fm_liveswitch_Constants___minutesPerHour = 60;
                    fm.liveswitch.Constants.fm_liveswitch_Constants___hoursPerDay = 24;
                    fm.liveswitch.Constants.fm_liveswitch_Constants___ticksPerSecond = (fm.liveswitch.Constants.getTicksPerMillisecond() * fm.liveswitch.Constants.getMillisecondsPerSecond());
                    fm.liveswitch.Constants.fm_liveswitch_Constants___ticksPerMinute = (fm.liveswitch.Constants.getTicksPerSecond() * fm.liveswitch.Constants.getSecondsPerMinute());
                    fm.liveswitch.Constants.fm_liveswitch_Constants___ticksPerHour = (fm.liveswitch.Constants.getTicksPerMinute() * fm.liveswitch.Constants.getMinutesPerHour());
                    fm.liveswitch.Constants.fm_liveswitch_Constants___ticksPerDay = (fm.liveswitch.Constants.getTicksPerHour() * fm.liveswitch.Constants.getHoursPerDay());
                    fm.liveswitch.Constants.fm_liveswitch_Constants___millisecondsPerMinute = (fm.liveswitch.Constants.getMillisecondsPerSecond() * fm.liveswitch.Constants.getSecondsPerMinute());
                    fm.liveswitch.Constants.fm_liveswitch_Constants___millisecondsPerHour = (fm.liveswitch.Constants.getMillisecondsPerMinute() * fm.liveswitch.Constants.getMinutesPerHour());
                    fm.liveswitch.Constants.fm_liveswitch_Constants___millisecondsPerDay = (fm.liveswitch.Constants.getMillisecondsPerHour() * fm.liveswitch.Constants.getHoursPerDay());
                    fm.liveswitch.Constants.fm_liveswitch_Constants___secondsPerHour = (fm.liveswitch.Constants.getSecondsPerMinute() * fm.liveswitch.Constants.getMinutesPerHour());
                    fm.liveswitch.Constants.fm_liveswitch_Constants___secondsPerDay = (fm.liveswitch.Constants.getSecondsPerHour() * fm.liveswitch.Constants.getHoursPerDay());
                    fm.liveswitch.Constants.fm_liveswitch_Constants___minutesPerDay = (fm.liveswitch.Constants.getMinutesPerHour() * fm.liveswitch.Constants.getHoursPerDay());
                    fm.liveswitch.Constants.__fmliveswitchConstantsInitialized = true;
                    fm.liveswitch.Constants.__fmliveswitchConstantsInitializing = false;
                }
            };
            /** @hidden */
            Constants.__fmliveswitchConstantsInitialized = false;
            /** @hidden */
            Constants.__fmliveswitchConstantsInitializing = false;
            return Constants;
        }());
        liveswitch.Constants = Constants;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A data buffer stream.
        */
        var DataBufferStream = /** @class */ (function () {
            function DataBufferStream() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.DataBuffer]'))) {
                    var buffer = __arguments[0];
                    //super();
                    this.fmliveswitchDataBufferStreamInit();
                    this.__buffer = buffer;
                }
                else if (__arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isNumber(arguments[0]))) {
                    var dataBufferSize = __arguments[0];
                    // chained constructor: DataBufferStream.call(this, dataBufferSize, false);
                    __arguments = new Array(2);
                    __arguments[0] = dataBufferSize;
                    __arguments[1] = false;
                    {
                        var dataBufferSize_1 = __arguments[0];
                        var littleEndian = __arguments[1];
                        // chained constructor: DataBufferStream.call(this, fm.liveswitch.DataBuffer.allocate(dataBufferSize, littleEndian));
                        __arguments = new Array(1);
                        __arguments[0] = fm.liveswitch.DataBuffer.allocate(dataBufferSize_1, littleEndian);
                        {
                            var buffer = __arguments[0];
                            //super();
                            this.fmliveswitchDataBufferStreamInit();
                            this.__buffer = buffer;
                        }
                    }
                }
                else if (__arguments.length == 2) {
                    var dataBufferSize = __arguments[0];
                    var littleEndian = __arguments[1];
                    // chained constructor: DataBufferStream.call(this, fm.liveswitch.DataBuffer.allocate(dataBufferSize, littleEndian));
                    __arguments = new Array(1);
                    __arguments[0] = fm.liveswitch.DataBuffer.allocate(dataBufferSize, littleEndian);
                    {
                        var buffer = __arguments[0];
                        //super();
                        this.fmliveswitchDataBufferStreamInit();
                        this.__buffer = buffer;
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            DataBufferStream.prototype.getTypeString = function () {
                return '[fm.liveswitch.DataBufferStream]';
            };
            DataBufferStream.prototype.fmliveswitchDataBufferStreamInit = function () {
                this.__bitPosition = 0;
                this.__position = 0;
            };
            /**
            Gets the available bytes to be read from the DataBuffer.
            */
            DataBufferStream.prototype.getAvailable = function () {
                if (arguments.length == 0) {
                    return (this.getLength() - this.__position);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the bit position within a byte.
            */
            DataBufferStream.prototype.getBitPosition = function () {
                if (arguments.length == 0) {
                    return this.__bitPosition;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the buffer.
            */
            DataBufferStream.prototype.getBuffer = function () {
                if (arguments.length == 0) {
                    return this.__buffer;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the buffer length.
            */
            DataBufferStream.prototype.getLength = function () {
                if (arguments.length == 0) {
                    return this.__buffer.getLength();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the position within the stream.
            */
            DataBufferStream.prototype.getPosition = function () {
                if (arguments.length == 0) {
                    return this.__position;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Resets the bit count to 0 and advances to the next byte.
            */
            DataBufferStream.prototype.nextByte = function () {
                if (arguments.length == 0) {
                    this.__bitPosition = 0;
                    this.__position++;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads an 8-bit value from the DataBuffer without advancing the Position.
            */
            DataBufferStream.prototype.peek = function () {
                if (arguments.length == 0) {
                    return this.__buffer.read8(this.getPosition());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads the specified length from the DataBuffer and advances the position by the length.
            @param length The length.
            */
            DataBufferStream.prototype.read = function (length) {
                if (arguments.length == 1) {
                    var buffer = this.__buffer.subset(this.__position, length);
                    this.__position = (this.__position + length);
                    return buffer;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Read a single bit and advance the bit position by 1.
            */
            DataBufferStream.prototype.read1 = function () {
                if (arguments.length == 0) {
                    var flag = this.__buffer.read1(this.__position, this.__bitPosition);
                    this.__bitPosition = (this.__bitPosition + 1);
                    if ((fm.liveswitch.Global.equals(this.__bitPosition, 8))) {
                        this.__position++;
                        this.__bitPosition = 0;
                    }
                    return flag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads an 15-bit value from the DataBuffer and advances the Position by 1 and the BitPosition by 7.
            */
            DataBufferStream.prototype.read15 = function () {
                if (arguments.length == 0) {
                    var num = this.__buffer.read15(this.__position, this.__bitPosition);
                    this.__position++;
                    this.__bitPosition = (this.__bitPosition + 7);
                    if ((this.__bitPosition >= 8)) {
                        this.__position++;
                        this.__bitPosition = (this.__bitPosition - 8);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads an 16-bit value from the DataBuffer and advances the Position by 2.
            */
            DataBufferStream.prototype.read16 = function () {
                if (arguments.length == 0) {
                    var num = this.__buffer.read16(this.__position);
                    this.__position = (this.__position + 2);
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Read a 2-bit value and advance the BitPosition by 2.
            */
            DataBufferStream.prototype.read2 = function () {
                if (arguments.length == 0) {
                    var num = this.__buffer.read2(this.__position, this.__bitPosition);
                    this.__bitPosition = (this.__bitPosition + 2);
                    if ((this.__bitPosition >= 8)) {
                        this.__position++;
                        this.__bitPosition = (this.__bitPosition - 8);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads an 24-bit value from the DataBuffer and advances the Position by 3.
            */
            DataBufferStream.prototype.read24 = function () {
                if (arguments.length == 0) {
                    var num = this.__buffer.read24(this.__position);
                    this.__position = (this.__position + 3);
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Read a 3-bit value and advance the BitPosition by 3.
            */
            DataBufferStream.prototype.read3 = function () {
                if (arguments.length == 0) {
                    var num = this.__buffer.read3(this.__position, this.__bitPosition);
                    this.__bitPosition = (this.__bitPosition + 3);
                    if ((this.__bitPosition >= 8)) {
                        this.__position++;
                        this.__bitPosition = (this.__bitPosition - 8);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads an 32-bit value from the DataBuffer and advances the Position by 4.
            */
            DataBufferStream.prototype.read32 = function () {
                if (arguments.length == 0) {
                    var num = this.__buffer.read32(this.__position);
                    this.__position = (this.__position + 4);
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Read a 4-bit value and advance the BitPosition by 4.
            */
            DataBufferStream.prototype.read4 = function () {
                if (arguments.length == 0) {
                    var num = this.__buffer.read4(this.__position, this.__bitPosition);
                    this.__bitPosition = (this.__bitPosition + 4);
                    if ((this.__bitPosition >= 8)) {
                        this.__position++;
                        this.__bitPosition = (this.__bitPosition - 8);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads an 40-bit value from the DataBuffer and advances the Position by 5.
            */
            DataBufferStream.prototype.read40 = function () {
                if (arguments.length == 0) {
                    var num = this.__buffer.read40(this.__position);
                    this.__position = (this.__position + 5);
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads an 48-bit value from the DataBuffer and advances the Position by 6.
            */
            DataBufferStream.prototype.read48 = function () {
                if (arguments.length == 0) {
                    var num = this.__buffer.read48(this.__position);
                    this.__position = (this.__position + 6);
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads an 56-bit value from the DataBuffer and advances the Position by 7.
            */
            DataBufferStream.prototype.read56 = function () {
                if (arguments.length == 0) {
                    var num = this.__buffer.read56(this.__position);
                    this.__position = (this.__position + 7);
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads an 64-bit value from the DataBuffer and advances the Position by 8.
            */
            DataBufferStream.prototype.read64 = function () {
                if (arguments.length == 0) {
                    var num = this.__buffer.read64(this.__position);
                    this.__position = (this.__position + 8);
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads an 7-bit value from the DataBuffer and advances the BitPosition by 7.
            */
            DataBufferStream.prototype.read7 = function () {
                if (arguments.length == 0) {
                    var num = this.__buffer.read7(this.__position, this.__bitPosition);
                    this.__bitPosition = (this.__bitPosition + 7);
                    if ((this.__bitPosition >= 8)) {
                        this.__position++;
                        this.__bitPosition = (this.__bitPosition - 8);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads an 8-bit value from the DataBuffer and advances the Position by 1.
            */
            DataBufferStream.prototype.read8 = function () {
                if (arguments.length == 0) {
                    var num = this.__buffer.read8(this.__position);
                    this.__position++;
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a single byte from the stream and advances the Position by 1.
            */
            DataBufferStream.prototype.readByte = function () {
                if (arguments.length == 0) {
                    return this.read8();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Read a specified number of bytes from the DataBuffer and advance the Position by that number.
            @param length The number of bytes to read.
            */
            DataBufferStream.prototype.readBytes = function (length) {
                if (arguments.length == 1) {
                    var buffer = this.__buffer.subset(this.__position, length).toArray();
                    this.__position = (this.__position + length);
                    return buffer;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the bit position within a byte.
            */
            DataBufferStream.prototype.setBitPosition = function (value) {
                if (arguments.length == 1) {
                    this.__bitPosition = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the position within the stream.
            */
            DataBufferStream.prototype.setPosition = function (value) {
                if (arguments.length == 1) {
                    this.__position = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes the specified buffer to the DataBuffer and advances the Position by the length of the buffer.
            @param buffer The buffer.
            */
            DataBufferStream.prototype.write = function (buffer) {
                if (arguments.length == 1) {
                    this.__buffer.write(buffer, this.__position);
                    this.__position = (this.__position + buffer.getLength());
                    return this;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes an 16-bit value to the DataBuffer and advances the Position by 2.
            @param value The value.
            */
            DataBufferStream.prototype.write16 = function (value) {
                if (arguments.length == 1) {
                    this.__buffer.write16(value, this.__position);
                    this.__position = (this.__position + 2);
                    return this;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes an 32-bit value to the DataBuffer and advances the Position by 4.
            @param value The value.
            */
            DataBufferStream.prototype.write32 = function (value) {
                if (arguments.length == 1) {
                    this.__buffer.write32(value, this.__position);
                    this.__position = (this.__position + 4);
                    return this;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes an 64-bit value to the DataBuffer and advances the Position by 8.
            @param value The value.
            */
            DataBufferStream.prototype.write64 = function (value) {
                if (arguments.length == 1) {
                    this.__buffer.write64(value, this.__position);
                    this.__position = (this.__position + 8);
                    return this;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes an 8-bit value to the DataBuffer and advances the Position by 1.
            @param value The value.
            */
            DataBufferStream.prototype.write8 = function (value) {
                if (arguments.length == 1) {
                    this.__buffer.write8(value, this.__position);
                    this.__position++;
                    return this;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBufferStream.prototype.writeBytes = function () {
                if (arguments.length == 1) {
                    var data = arguments[0];
                    return this.writeBytes(data, 0, data.length);
                }
                else if (arguments.length == 3) {
                    var data = arguments[0];
                    var index = arguments[1];
                    var length_22 = arguments[2];
                    if ((this.getAvailable() < length_22)) {
                        this.getBuffer().resize(((this.getBuffer().getLength() - this.getAvailable()) + length_22));
                    }
                    this.__buffer.writeBytes(data, index, length_22, this.__position);
                    this.__position = (this.__position + length_22);
                    return this;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return DataBufferStream;
        }());
        liveswitch.DataBufferStream = DataBufferStream;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Binary data buffer implementation
        */
        var DataBuffer = /** @class */ (function () {
            function DataBuffer() {
                fm.liveswitch.DataBuffer.fmliveswitchDataBufferInitialize();
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchDataBufferInit();
                }
                else if (__arguments.length == 4) {
                    var data = __arguments[0];
                    var index = __arguments[1];
                    var length_23 = __arguments[2];
                    var littleEndian = __arguments[3];
                    //super();
                    this.fmliveswitchDataBufferInit();
                    this.setInnerData(data);
                    this.setIndex(index);
                    this.setLength(length_23);
                    this.setLittleEndian(littleEndian);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            DataBuffer.prototype.getTypeString = function () {
                return '[fm.liveswitch.DataBuffer]';
            };
            DataBuffer.prototype.fmliveswitchDataBufferInit = function () {
                this._index = 0;
                this._length = 0;
                this._littleEndian = false;
            };
            DataBuffer.allocate = function () {
                fm.liveswitch.DataBuffer.fmliveswitchDataBufferInitialize();
                if (arguments.length == 1) {
                    var count = arguments[0];
                    return fm.liveswitch.DataBuffer.allocate(count, false);
                }
                else if (arguments.length == 2) {
                    var count = arguments[0];
                    var littleEndian = arguments[1];
                    return fm.liveswitch.DataBuffer.wrap(new Uint8Array(count), littleEndian);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tests if the two buffers have equal contents.
            @param buffer1 First buffer to test.
            @param buffer2 Second buffer to test.
            */
            DataBuffer.areEqual = function (buffer1, buffer2) {
                fm.liveswitch.DataBuffer.fmliveswitchDataBufferInitialize();
                if (arguments.length == 2) {
                    if ((!fm.liveswitch.Global.equals(buffer1.getLength(), buffer2.getLength()))) {
                        return false;
                    }
                    for (var i = 0; (i < buffer1.getLength()); i++) {
                        if ((!fm.liveswitch.Global.equals(buffer1.read8(i), buffer2.read8(i)))) {
                            return false;
                        }
                    }
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.fromBytes = function () {
                fm.liveswitch.DataBuffer.fmliveswitchDataBufferInitialize();
                if (arguments.length == 1) {
                    var bytes = arguments[0];
                    return fm.liveswitch.DataBuffer.wrap(bytes);
                }
                else if (arguments.length == 2) {
                    var bytes = arguments[0];
                    var littleEndian = arguments[1];
                    return fm.liveswitch.DataBuffer.wrap(bytes, littleEndian);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.fromHexString = function () {
                fm.liveswitch.DataBuffer.fmliveswitchDataBufferInitialize();
                if (arguments.length == 1) {
                    var hexString = arguments[0];
                    return fm.liveswitch.DataBuffer.wrap(fm.liveswitch.BitAssistant.getHexBytes(hexString));
                }
                else if (arguments.length == 2) {
                    var hexString = arguments[0];
                    var littleEndian = arguments[1];
                    return fm.liveswitch.DataBuffer.wrap(fm.liveswitch.BitAssistant.getHexBytes(hexString), littleEndian);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an instance from JSON.
            @param dataBufferJson The data buffer JSON.
            */
            DataBuffer.fromJson = function (dataBufferJson) {
                fm.liveswitch.DataBuffer.fmliveswitchDataBufferInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(dataBufferJson, function () {
                        return new fm.liveswitch.DataBuffer();
                    }, function (dataBuffer, name, valueJson) {
                        var str = name;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            if (!(fm.liveswitch.Global.equals(str, "data"))) {
                                if ((fm.liveswitch.Global.equals(str, "index"))) {
                                    dataBuffer.setIndex(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "length"))) {
                                        dataBuffer.setLength(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "littleEndian"))) {
                                            dataBuffer.setLittleEndian(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                        }
                                    }
                                }
                            }
                            else {
                                dataBuffer.setInnerData(fm.liveswitch.Base64.decode(valueJson));
                            }
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array of instances from JSON.
            @param dataBuffersJson The data buffers JSON.
            */
            DataBuffer.fromJsonArray = function (dataBuffersJson) {
                fm.liveswitch.DataBuffer.fmliveswitchDataBufferInitialize();
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(dataBuffersJson, fm.liveswitch.DataBuffer.fromJson.bind(fm.liveswitch.DataBuffer));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets an empty data buffer.
            */
            DataBuffer.getEmpty = function () {
                fm.liveswitch.DataBuffer.fmliveswitchDataBufferInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.DataBuffer.allocate(0, false);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param dataBuffer The data buffer.
            */
            DataBuffer.toJson = function (dataBuffer) {
                fm.liveswitch.DataBuffer.fmliveswitchDataBufferInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(dataBuffer, function (obj, jsonObject) {
                        var b = dataBuffer.toArray();
                        jsonObject["data"] = fm.liveswitch.Base64.encode(b);
                        jsonObject["index"] = fm.liveswitch.JsonSerializer.serializeInteger(0);
                        jsonObject["length"] = fm.liveswitch.JsonSerializer.serializeInteger(b.length);
                        jsonObject["littleEndian"] = fm.liveswitch.JsonSerializer.serializeBoolean(dataBuffer.getLittleEndian());
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array of instances to JSON.
            @param dataBuffers The data buffers.
            */
            DataBuffer.toJsonArray = function (dataBuffers) {
                fm.liveswitch.DataBuffer.fmliveswitchDataBufferInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(dataBuffers, fm.liveswitch.DataBuffer.toJson.bind(fm.liveswitch.DataBuffer));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.wrap = function () {
                fm.liveswitch.DataBuffer.fmliveswitchDataBufferInitialize();
                if (arguments.length == 1) {
                    var data = arguments[0];
                    return fm.liveswitch.DataBuffer.wrap(data, 0, -1, false);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isNumber(arguments[1]))) {
                    var data = arguments[0];
                    var index = arguments[1];
                    return fm.liveswitch.DataBuffer.wrap(data, index, -1, false);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isNumber(arguments[2]))) {
                    var data = arguments[0];
                    var index = arguments[1];
                    var length_24 = arguments[2];
                    return fm.liveswitch.DataBuffer.wrap(data, index, length_24, false);
                }
                else if (arguments.length == 4) {
                    var data = arguments[0];
                    var index = arguments[1];
                    var length_25 = arguments[2];
                    var littleEndian = arguments[3];
                    if ((fm.liveswitch.Global.equals(data, null))) {
                        return null;
                    }
                    if ((index < 0)) {
                        return null;
                    }
                    if ((length_25 < 0)) {
                        length_25 = (data.length - index);
                    }
                    return new fm.liveswitch.DataBuffer(data, index, length_25, littleEndian);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isBoolean(arguments[2]))) {
                    var data = arguments[0];
                    var index = arguments[1];
                    var littleEndian = arguments[2];
                    return fm.liveswitch.DataBuffer.wrap(data, index, -1, littleEndian);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isBoolean(arguments[1]))) {
                    var data = arguments[0];
                    var littleEndian = arguments[1];
                    return fm.liveswitch.DataBuffer.wrap(data, 0, -1, littleEndian);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Performs a bitwise "and" operation on a value.
            @param value The value.
            @param offset The offset.
            */
            DataBuffer.prototype.and = function (value, offset) {
                if (arguments.length == 2) {
                    return this.write8((this.read8(offset) & value), offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.append = function () {
                if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.DataBuffer]'))) {
                    var buffer = arguments[0];
                    if (((!fm.liveswitch.Global.equals(buffer, null)) && (buffer.getLength() > 0))) {
                        var newLength = (this.getLength() + buffer.getLength());
                        if ((newLength > this.getLength())) {
                            var length_26 = this.getLength();
                            this.resize(newLength);
                            this.write(buffer, length_26);
                            length_26 = (length_26 + buffer.getLength());
                        }
                    }
                    return this;
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isObjectType(arguments[0][0], '[fm.liveswitch.DataBuffer]')))))) {
                    var buffers = arguments[0];
                    if (((!fm.liveswitch.Global.equals(buffers, null)) && (buffers.length > 0))) {
                        var length_27 = this.getLength();
                        for (var _i = 0, buffers_1 = buffers; _i < buffers_1.length; _i++) {
                            var buffer = buffers_1[_i];
                            length_27 = (length_27 + buffer.getLength());
                        }
                        if ((length_27 > this.getLength())) {
                            var offset = this.getLength();
                            this.resize(length_27);
                            for (var _a = 0, buffers_2 = buffers; _a < buffers_2.length; _a++) {
                                var buffer = buffers_2[_a];
                                this.write(buffer, offset);
                                offset = (offset + buffer.getLength());
                            }
                        }
                    }
                    return this;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether this buffer can be resized to the new length.
            @param newLength The new length.
            @param offset The offset.
            */
            DataBuffer.prototype.canResize = function (newLength, offset) {
                if (arguments.length == 2) {
                    if (this.getIsPooled()) {
                        var num = (newLength - this.getLength());
                        if ((num <= 0)) {
                            return true;
                        }
                        if ((offset >= this.getIndex())) {
                            if (((this.getIndex() + newLength) >= this.getData().length)) {
                                return false;
                            }
                        }
                        else {
                            if ((offset < 0)) {
                                if (((this.getIndex() + newLength) > this.getData().length)) {
                                    return false;
                                }
                            }
                            else {
                                if ((((this.getIndex() - offset) + newLength) >= this.getData().length)) {
                                    return false;
                                }
                            }
                        }
                    }
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.clone = function () {
                if (arguments.length == 0) {
                    return this.clone(this.getLittleEndian());
                }
                else if (arguments.length == 1) {
                    var littleEndian = arguments[0];
                    return this.subset(0);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.copy = function () {
                if (arguments.length == 0) {
                    return this.copy(false);
                }
                else if (arguments.length == 1) {
                    var usePool = arguments[0];
                    var buffer = void 0;
                    if (usePool) {
                        buffer = fm.liveswitch.DataBuffer.fm_liveswitch_DataBuffer___dataBufferPool.take(this.getLength());
                    }
                    else {
                        buffer = fm.liveswitch.DataBuffer.allocate(this.getLength(), this.getLittleEndian());
                    }
                    buffer.write(this);
                    return buffer;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Decrements the retain count by one and returns the Buffer to the pool if zero.
            */
            DataBuffer.prototype.free = function () {
                if (arguments.length == 0) {
                    return this;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the data.
            */
            DataBuffer.prototype.getData = function () {
                if (arguments.length == 0) {
                    if ((fm.liveswitch.Global.equals(this.getInnerData(), null))) {
                        throw new fm.liveswitch.Exception("This data buffer has been invalidated.");
                    }
                    return this.getInnerData();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the index.
            */
            DataBuffer.prototype.getIndex = function () {
                if (arguments.length == 0) {
                    return this._index;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets backing data buffer.
            */
            DataBuffer.prototype.getInnerData = function () {
                if (arguments.length == 0) {
                    return this._innerData;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether this DataBuffer is from a pool.
            */
            DataBuffer.prototype.getIsPooled = function () {
                if (arguments.length == 0) {
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether this DataBuffer is a subset.
            */
            DataBuffer.prototype.getIsSubset = function () {
                if (arguments.length == 0) {
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the length.
            */
            DataBuffer.prototype.getLength = function () {
                if (arguments.length == 0) {
                    return this._length;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether [[fm.liveswitch.dataBuffer.data]] is little-endian.
            */
            DataBuffer.prototype.getLittleEndian = function () {
                if (arguments.length == 0) {
                    return this._littleEndian;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Increment the retain count by one.
            */
            DataBuffer.prototype.keep = function () {
                if (arguments.length == 0) {
                    return this;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Performs a bitwise "or" operation on a value.
            @param value The value.
            @param offset The offset.
            */
            DataBuffer.prototype.or = function (value, offset) {
                if (arguments.length == 2) {
                    return this.write8((this.read8(offset) | value), offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.prepend = function () {
                if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.DataBuffer]'))) {
                    var buffer = arguments[0];
                    var length_28 = buffer.getLength();
                    if ((length_28 <= this.getIndex())) {
                        this.setIndex((this.getIndex() - length_28));
                        this.setLength((this.getLength() + length_28));
                    }
                    else {
                        this.resize((this.getLength() + length_28), 0);
                    }
                    var offset = 0;
                    this.write(buffer, offset);
                    offset = (offset + buffer.getLength());
                    return this;
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isObjectType(arguments[0][0], '[fm.liveswitch.DataBuffer]')))))) {
                    var buffers = arguments[0];
                    if (((!fm.liveswitch.Global.equals(buffers, null)) && (buffers.length > 0))) {
                        var num = 0;
                        for (var _i = 0, buffers_3 = buffers; _i < buffers_3.length; _i++) {
                            var buffer = buffers_3[_i];
                            num = (num + buffer.getLength());
                        }
                        if ((num <= this.getIndex())) {
                            this.setIndex((this.getIndex() - num));
                            this.setLength((this.getLength() + num));
                        }
                        else {
                            this.resize((this.getLength() + num), 0);
                        }
                        var offset = 0;
                        for (var _a = 0, buffers_4 = buffers; _a < buffers_4.length; _a++) {
                            var buffer = buffers_4[_a];
                            this.write(buffer, offset);
                            offset = (offset + buffer.getLength());
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 1-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read1 = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    return fm.liveswitch.Binary.fromBytes1(this.getData(), (this.getIndex() + offset), bitOffset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 10-bit value.
            @param offset The offset.
            @param bitOffset The bitoffset.
            */
            DataBuffer.prototype.read10 = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    return fm.liveswitch.Binary.fromBytes10(this.getData(), (this.getIndex() + offset), bitOffset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 10-bit signed value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read10Signed = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    var num = this.read10(offset, bitOffset);
                    if ((num > 511)) {
                        num = (num - 1024);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 11-bit value.
            @param offset The offset.
            @param bitOffset The bitoffset.
            */
            DataBuffer.prototype.read11 = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    return fm.liveswitch.Binary.fromBytes11(this.getData(), (this.getIndex() + offset), bitOffset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 11-bit signed value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read11Signed = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    var num = this.read11(offset, bitOffset);
                    if ((num > 1023)) {
                        num = (num - 2048);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 12-bit value.
            @param offset The offset.
            @param bitOffset The bitoffset.
            */
            DataBuffer.prototype.read12 = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    return fm.liveswitch.Binary.fromBytes12(this.getData(), (this.getIndex() + offset), bitOffset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 12-bit signed value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read12Signed = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    var num = this.read12(offset, bitOffset);
                    if ((num > 2047)) {
                        num = (num - 4096);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 13-bit value.
            @param offset The offset.
            @param bitOffset The bitoffset.
            */
            DataBuffer.prototype.read13 = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    return fm.liveswitch.Binary.fromBytes13(this.getData(), (this.getIndex() + offset), bitOffset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 13-bit signed value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read13Signed = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    var num = this.read13(offset, bitOffset);
                    if ((num > 4095)) {
                        num = (num - 8192);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 14-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read14 = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    return fm.liveswitch.Binary.fromBytes14(this.getData(), (this.getIndex() + offset), bitOffset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 14-bit signed value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read14Signed = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    var num = this.read14(offset, bitOffset);
                    if ((num > 8191)) {
                        num = (num - 16384);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 15-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read15 = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    return fm.liveswitch.Binary.fromBytes15(this.getData(), (this.getIndex() + offset), bitOffset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 15-bit signed value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read15Signed = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    var num = this.read15(offset, bitOffset);
                    if ((num > 16383)) {
                        num = (num - 32768);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.read16 = function () {
                if (arguments.length == 1) {
                    var offset = arguments[0];
                    return fm.liveswitch.Binary.fromBytes16(this.getData(), (this.getIndex() + offset), this.getLittleEndian());
                }
                else if (arguments.length == 2) {
                    var offset = arguments[0];
                    var offsetPlus = arguments[1];
                    offsetPlus.setValue((offset + 2));
                    return this.read16(offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.read16Signed = function () {
                if (arguments.length == 1) {
                    var offset = arguments[0];
                    var num = this.read16(offset);
                    if ((num > 32767)) {
                        num = (num - 65536);
                    }
                    return num;
                }
                else if (arguments.length == 2) {
                    var offset = arguments[0];
                    var offsetPlus = arguments[1];
                    offsetPlus.setValue((offset + 2));
                    return this.read16Signed(offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 17-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read17 = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    return fm.liveswitch.Binary.fromBytes17(this.getData(), (this.getIndex() + offset), bitOffset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 17-bit signed value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read17Signed = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    var num = this.read17(offset, bitOffset);
                    if ((num > 65535)) {
                        num = (num - 131072);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads an 18-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read18 = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    return fm.liveswitch.Binary.fromBytes18(this.getData(), (this.getIndex() + offset), bitOffset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads an 18-bit signed value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read18Signed = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    var num = this.read18(offset, bitOffset);
                    if ((num > 131071)) {
                        num = (num - 262144);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 19-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read19 = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    return fm.liveswitch.Binary.fromBytes19(this.getData(), (this.getIndex() + offset), bitOffset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 19-bit signed value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read19Signed = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    var num = this.read19(offset, bitOffset);
                    if ((num > 262143)) {
                        num = (num - 524288);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 2-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read2 = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    return fm.liveswitch.Binary.fromBytes2(this.getData(), (this.getIndex() + offset), bitOffset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 20-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read20 = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    return fm.liveswitch.Binary.fromBytes20(this.getData(), (this.getIndex() + offset), bitOffset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 20-bit signed value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read20Signed = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    var num = this.read20(offset, bitOffset);
                    if ((num > 524287)) {
                        num = (num - 1048576);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 21-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read21 = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    return fm.liveswitch.Binary.fromBytes21(this.getData(), (this.getIndex() + offset), bitOffset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 21-bit signed value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read21Signed = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    var num = this.read21(offset, bitOffset);
                    if ((num > 1048575)) {
                        num = (num - 2097152);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 22-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read22 = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    return fm.liveswitch.Binary.fromBytes22(this.getData(), (this.getIndex() + offset), bitOffset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 22-bit signed value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read22Signed = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    var num = this.read22(offset, bitOffset);
                    if ((num > 2097151)) {
                        num = (num - 4194304);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 23-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read23 = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    return fm.liveswitch.Binary.fromBytes23(this.getData(), (this.getIndex() + offset), bitOffset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 23-bit signed value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read23Signed = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    var num = this.read23(offset, bitOffset);
                    if ((num > 4194303)) {
                        num = (num - 8388608);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.read24 = function () {
                if (arguments.length == 1) {
                    var offset = arguments[0];
                    return fm.liveswitch.Binary.fromBytes24(this.getData(), (this.getIndex() + offset), this.getLittleEndian());
                }
                else if (arguments.length == 2) {
                    var offset = arguments[0];
                    var offsetPlus = arguments[1];
                    offsetPlus.setValue((offset + 3));
                    return this.read24(offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.read24Signed = function () {
                if (arguments.length == 1) {
                    var offset = arguments[0];
                    var num = this.read24(offset);
                    if ((num > 8388607)) {
                        num = (num - 16777216);
                    }
                    return num;
                }
                else if (arguments.length == 2) {
                    var offset = arguments[0];
                    var offsetPlus = arguments[1];
                    offsetPlus.setValue((offset + 3));
                    return this.read24Signed(offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 2-bit signed value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read2Signed = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    var num = this.read2(offset, bitOffset);
                    if ((num > 1)) {
                        num = (num - 4);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 3-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read3 = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    return fm.liveswitch.Binary.fromBytes3(this.getData(), (this.getIndex() + offset), bitOffset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.read32 = function () {
                if (arguments.length == 1) {
                    var offset = arguments[0];
                    return fm.liveswitch.Binary.fromBytes32(this.getData(), (this.getIndex() + offset), this.getLittleEndian());
                }
                else if (arguments.length == 2) {
                    var offset = arguments[0];
                    var offsetPlus = arguments[1];
                    offsetPlus.setValue((offset + 4));
                    return this.read32(offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.read32Signed = function () {
                if (arguments.length == 1) {
                    var offset = arguments[0];
                    var num = this.read32(offset);
                    if ((num > 2147483647)) {
                        num = (num - 4294967296);
                    }
                    return num;
                }
                else if (arguments.length == 2) {
                    var offset = arguments[0];
                    var offsetPlus = arguments[1];
                    offsetPlus.setValue((offset + 4));
                    return this.read32Signed(offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 3-bit signed value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read3Signed = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    var num = this.read3(offset, bitOffset);
                    if ((num > 3)) {
                        num = (num - 8);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 4-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read4 = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    return fm.liveswitch.Binary.fromBytes4(this.getData(), (this.getIndex() + offset), bitOffset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.read40 = function () {
                if (arguments.length == 1) {
                    var offset = arguments[0];
                    return fm.liveswitch.Binary.fromBytes40(this.getData(), (this.getIndex() + offset), this.getLittleEndian());
                }
                else if (arguments.length == 2) {
                    var offset = arguments[0];
                    var offsetPlus = arguments[1];
                    offsetPlus.setValue((offset + 5));
                    return this.read40(offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.read40Signed = function () {
                if (arguments.length == 1) {
                    var offset = arguments[0];
                    var num = this.read40(offset);
                    if ((num > 549755813887)) {
                        num = (num - 1099511627776);
                    }
                    return num;
                }
                else if (arguments.length == 2) {
                    var offset = arguments[0];
                    var offsetPlus = arguments[1];
                    offsetPlus.setValue((offset + 5));
                    return this.read40Signed(offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.read48 = function () {
                if (arguments.length == 1) {
                    var offset = arguments[0];
                    return fm.liveswitch.Binary.fromBytes48(this.getData(), (this.getIndex() + offset), this.getLittleEndian());
                }
                else if (arguments.length == 2) {
                    var offset = arguments[0];
                    var offsetPlus = arguments[1];
                    offsetPlus.setValue((offset + 6));
                    return this.read48(offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.read48Signed = function () {
                if (arguments.length == 1) {
                    var offset = arguments[0];
                    var num = this.read48(offset);
                    if ((num > 140737488355327)) {
                        num = (num - 281474976710656);
                    }
                    return num;
                }
                else if (arguments.length == 2) {
                    var offset = arguments[0];
                    var offsetPlus = arguments[1];
                    offsetPlus.setValue((offset + 6));
                    return this.read48Signed(offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 4-bit signed value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read4Signed = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    var num = this.read4(offset, bitOffset);
                    if ((num > 7)) {
                        num = (num - 16);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 5-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read5 = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    return fm.liveswitch.Binary.fromBytes5(this.getData(), (this.getIndex() + offset), bitOffset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.read56 = function () {
                if (arguments.length == 1) {
                    var offset = arguments[0];
                    return fm.liveswitch.Binary.fromBytes56(this.getData(), (this.getIndex() + offset), this.getLittleEndian());
                }
                else if (arguments.length == 2) {
                    var offset = arguments[0];
                    var offsetPlus = arguments[1];
                    offsetPlus.setValue((offset + 7));
                    return this.read56(offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.read56Signed = function () {
                if (arguments.length == 1) {
                    var offset = arguments[0];
                    var num = this.read56(offset);
                    if ((num > 36028797018963967)) {
                        num = (num - 72057594037927936);
                    }
                    return num;
                }
                else if (arguments.length == 2) {
                    var offset = arguments[0];
                    var offsetPlus = arguments[1];
                    offsetPlus.setValue((offset + 7));
                    return this.read56Signed(offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 5-bit signed value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read5Signed = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    var num = this.read5(offset, bitOffset);
                    if ((num > 15)) {
                        num = (num - 32);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 6-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read6 = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    return fm.liveswitch.Binary.fromBytes6(this.getData(), (this.getIndex() + offset), bitOffset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.read64 = function () {
                if (arguments.length == 1) {
                    var offset = arguments[0];
                    return fm.liveswitch.Binary.fromBytes64(this.getData(), (this.getIndex() + offset), this.getLittleEndian());
                }
                else if (arguments.length == 2) {
                    var offset = arguments[0];
                    var offsetPlus = arguments[1];
                    offsetPlus.setValue((offset + 8));
                    return this.read64(offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.read64Signed = function () {
                if (arguments.length == 1) {
                    var offset = arguments[0];
                    return this.read64(offset);
                }
                else if (arguments.length == 2) {
                    var offset = arguments[0];
                    var offsetPlus = arguments[1];
                    offsetPlus.setValue((offset + 8));
                    return this.read64Signed(offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 6-bit signed value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read6Signed = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    var num = this.read6(offset, bitOffset);
                    if ((num > 31)) {
                        num = (num - 64);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 7-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read7 = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    return fm.liveswitch.Binary.fromBytes7(this.getData(), (this.getIndex() + offset), bitOffset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 7-bit signed value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read7Signed = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    var num = this.read7(offset, bitOffset);
                    if ((num > 63)) {
                        num = (num - 128);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.read8 = function () {
                if (arguments.length == 1) {
                    var offset = arguments[0];
                    return fm.liveswitch.Binary.fromBytes8(this.getData(), (this.getIndex() + offset));
                }
                else if (arguments.length == 2) {
                    var offset = arguments[0];
                    var offsetPlus = arguments[1];
                    offsetPlus.setValue((offset + 1));
                    return this.read8(offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.read8Signed = function () {
                if (arguments.length == 1) {
                    var offset = arguments[0];
                    var num = this.read8(offset);
                    if ((num > 127)) {
                        num = (num - 256);
                    }
                    return num;
                }
                else if (arguments.length == 2) {
                    var offset = arguments[0];
                    var offsetPlus = arguments[1];
                    offsetPlus.setValue((offset + 1));
                    return this.read8Signed(offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 9-bit value.
            @param offset The offset.
            @param bitOffset The bitoffset.
            */
            DataBuffer.prototype.read9 = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    return fm.liveswitch.Binary.fromBytes9(this.getData(), (this.getIndex() + offset), bitOffset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Reads a 9-bit signed value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.read9Signed = function (offset, bitOffset) {
                if (arguments.length == 2) {
                    var num = this.read9(offset, bitOffset);
                    if ((num > 255)) {
                        num = (num - 512);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.readUtf8String = function () {
                if (arguments.length == 1) {
                    var offset = arguments[0];
                    return fm.liveswitch.Encoding.getUtf8().getString(this.getData(), (this.getIndex() + offset), (this.getLength() - offset));
                }
                else if (arguments.length == 2) {
                    var offset = arguments[0];
                    var length_29 = arguments[1];
                    return fm.liveswitch.Encoding.getUtf8().getString(this.getData(), (this.getIndex() + offset), length_29);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.resize = function () {
                if (arguments.length == 1) {
                    var newLength = arguments[0];
                    this.resize(newLength, this.getLength());
                }
                else if (arguments.length == 2) {
                    var newLength = arguments[0];
                    var offset = arguments[1];
                    this.resize(newLength, offset, false);
                }
                else if (arguments.length == 3) {
                    var newLength = arguments[0];
                    var offset = arguments[1];
                    var setZero = arguments[2];
                    if ((fm.liveswitch.Global.equals(offset, -1))) {
                        offset = this.getLength();
                    }
                    if ((offset < 0)) {
                        throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Offset '{0}' is invalid.", fm.liveswitch.NumberExtensions.toString(offset)));
                    }
                    var length_30 = (newLength - this.getLength());
                    if ((length_30 < 0)) {
                        length_30 = -length_30;
                        if (((offset + length_30) > this.getLength())) {
                            throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Truncating at offset '{0}' for length '{1}' would exceed data buffer length '{2}'.", fm.liveswitch.NumberExtensions.toString(offset), fm.liveswitch.NumberExtensions.toString(length_30), fm.liveswitch.NumberExtensions.toString(this.getLength())));
                        }
                        if ((fm.liveswitch.Global.equals(offset, 0))) {
                            this.setIndex((this.getIndex() + length_30));
                        }
                        else {
                            if ((!fm.liveswitch.Global.equals((offset + length_30), this.getLength()))) {
                                fm.liveswitch.BitAssistant.copy(this.getData(), ((this.getIndex() + offset) + length_30), this.getData(), (this.getIndex() + offset), ((this.getLength() - offset) - length_30));
                            }
                        }
                    }
                    else {
                        if ((length_30 > 0)) {
                            if ((offset > this.getLength())) {
                                throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Offset '{0}' exceeds data buffer length '{1}'.", fm.liveswitch.NumberExtensions.toString(offset), fm.liveswitch.NumberExtensions.toString(this.getLength())));
                            }
                            if (((fm.liveswitch.Global.equals(offset, 0)) && (length_30 <= this.getIndex()))) {
                                this.setIndex((this.getIndex() - length_30));
                                if (setZero) {
                                    fm.liveswitch.BitAssistant.set(this.getData(), this.getIndex(), length_30, 0);
                                }
                            }
                            else {
                                if (((fm.liveswitch.Global.equals(offset, this.getLength())) && (((this.getIndex() + this.getLength()) + length_30) < this.getData().length))) {
                                    if (setZero) {
                                        fm.liveswitch.BitAssistant.set(this.getData(), (this.getIndex() + this.getLength()), length_30, 0);
                                    }
                                }
                                else {
                                    if ((newLength > this.getData().length)) {
                                        if (this.getIsPooled()) {
                                            throw new fm.liveswitch.Exception("Cannot expand the underlying byte array of a pooled data buffer.");
                                        }
                                        var destination = new Uint8Array(newLength);
                                        fm.liveswitch.BitAssistant.copy(this.getData(), this.getIndex(), destination, 0, offset);
                                        fm.liveswitch.BitAssistant.copy(this.getData(), (this.getIndex() + offset), destination, (offset + length_30), (this.getLength() - offset));
                                        this.setInnerData(destination);
                                    }
                                    else {
                                        if (((this.getIndex() + newLength) > this.getData().length)) {
                                            var destinationIndex = (this.getData().length - newLength);
                                            fm.liveswitch.BitAssistant.copy(this.getData(), this.getIndex(), this.getData(), destinationIndex, offset);
                                            fm.liveswitch.BitAssistant.copy(this.getData(), (this.getIndex() + offset), this.getData(), ((destinationIndex + offset) + length_30), (this.getLength() - offset));
                                            this.setIndex(destinationIndex);
                                            if (setZero) {
                                                fm.liveswitch.BitAssistant.set(this.getData(), (this.getIndex() + offset), length_30, 0);
                                            }
                                        }
                                        else {
                                            fm.liveswitch.BitAssistant.copy(this.getData(), (this.getIndex() + offset), this.getData(), ((this.getIndex() + offset) + length_30), (this.getLength() - offset));
                                            if (setZero) {
                                                fm.liveswitch.BitAssistant.set(this.getData(), (this.getIndex() + offset), length_30, 0);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    this.setLength(newLength);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Compares a data buffer for equality.
            @param buffer The data buffer.
            @return `true` if the sequences are equal; otherwise, `false`.
                
            */
            DataBuffer.prototype.sequenceEquals = function (buffer) {
                if (arguments.length == 1) {
                    return fm.liveswitch.BitAssistant.sequencesAreEqual(this.getData(), this.getIndex(), buffer.getData(), buffer.getIndex(), this.getLength());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Compares a data buffer for equality in constant time.
            @param buffer The buffer.
            @return `true` if the sequences are equal; otherwise, `false`.
                
            */
            DataBuffer.prototype.sequenceEqualsConstantTime = function (buffer) {
                if (arguments.length == 1) {
                    return fm.liveswitch.BitAssistant.sequencesAreEqualConstantTime(this.getData(), this.getIndex(), buffer.getData(), buffer.getIndex(), this.getLength());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.set = function () {
                if (arguments.length == 1) {
                    var value = arguments[0];
                    this.set(value, 0, this.getLength());
                }
                else if (arguments.length == 2) {
                    var value = arguments[0];
                    var offset = arguments[1];
                    fm.liveswitch.BitAssistant.set(this.getData(), (this.getIndex() + offset), (this.getLength() - offset), value);
                }
                else if (arguments.length == 3) {
                    var value = arguments[0];
                    var offset = arguments[1];
                    var length_31 = arguments[2];
                    fm.liveswitch.BitAssistant.set(this.getData(), (this.getIndex() + offset), length_31, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataBuffer.prototype.setIndex = function (value) {
                if (arguments.length == 1) {
                    this._index = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets backing data buffer.
            */
            DataBuffer.prototype.setInnerData = function (value) {
                if (arguments.length == 1) {
                    this._innerData = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataBuffer.prototype.setLength = function (value) {
                if (arguments.length == 1) {
                    this._length = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether [[fm.liveswitch.dataBuffer.data]] is little-endian.
            */
            DataBuffer.prototype.setLittleEndian = function (value) {
                if (arguments.length == 1) {
                    this._littleEndian = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.subset = function () {
                if (arguments.length == 1) {
                    var offset = arguments[0];
                    return this.subset(offset, (this.getLength() - offset));
                }
                else if (arguments.length == 2) {
                    var offset = arguments[0];
                    var length_32 = arguments[1];
                    if ((((offset + length_32) > this.getLength()) || (length_32 < 0))) {
                        return null;
                    }
                    if (this.getIsPooled()) {
                        return new fm.liveswitch.DataBufferSubset(this, (this.getIndex() + offset), length_32);
                    }
                    return new fm.liveswitch.DataBuffer(this.getData(), (this.getIndex() + offset), length_32, this.getLittleEndian());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts this instance to an array of bytes.
            */
            DataBuffer.prototype.toArray = function () {
                if (arguments.length == 0) {
                    return this.toBytes();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts this instance to an array of bytes.
            */
            DataBuffer.prototype.toBytes = function () {
                if (arguments.length == 0) {
                    var destination = new Uint8Array(this.getLength());
                    fm.liveswitch.BitAssistant.copy(this.getData(), this.getIndex(), destination, 0, this.getLength());
                    return destination;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts this instance to a hexadecimal string.
            */
            DataBuffer.prototype.toHexString = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.BitAssistant.getHexString(this.getData(), this.getIndex(), this.getLength());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            DataBuffer.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.DataBuffer.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Attempts to increment the retain count by one.
            @return True if successful.
            */
            DataBuffer.prototype.tryKeep = function () {
                if (arguments.length == 0) {
                    try {
                        this.keep();
                        return true;
                    }
                    catch (obj1) {
                        return false;
                    }
                    finally {
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 1-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            @param value if set to `true` [value].
            */
            DataBuffer.prototype.tryRead1 = function (offset, bitOffset, value) {
                if (arguments.length == 3) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes1(this.getData(), (this.getIndex() + offset), bitOffset, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 10-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead10 = function (offset, bitOffset, value) {
                if (arguments.length == 3) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes10(this.getData(), (this.getIndex() + offset), bitOffset, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read an 11-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead11 = function (offset, bitOffset, value) {
                if (arguments.length == 3) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes11(this.getData(), (this.getIndex() + offset), bitOffset, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 12-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead12 = function (offset, bitOffset, value) {
                if (arguments.length == 3) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes12(this.getData(), (this.getIndex() + offset), bitOffset, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 13-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead13 = function (offset, bitOffset, value) {
                if (arguments.length == 3) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes13(this.getData(), (this.getIndex() + offset), bitOffset, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 14-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead14 = function (offset, bitOffset, value) {
                if (arguments.length == 3) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes14(this.getData(), (this.getIndex() + offset), bitOffset, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 15-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead15 = function (offset, bitOffset, value) {
                if (arguments.length == 3) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes15(this.getData(), (this.getIndex() + offset), bitOffset, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 16-bit value.
            @param offset The offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead16 = function (offset, value) {
                if (arguments.length == 2) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes16(this.getData(), (this.getIndex() + offset), this.getLittleEndian(), value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 17-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead17 = function (offset, bitOffset, value) {
                if (arguments.length == 3) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes17(this.getData(), (this.getIndex() + offset), bitOffset, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read an 18-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead18 = function (offset, bitOffset, value) {
                if (arguments.length == 3) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes18(this.getData(), (this.getIndex() + offset), bitOffset, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 19-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead19 = function (offset, bitOffset, value) {
                if (arguments.length == 3) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes19(this.getData(), (this.getIndex() + offset), bitOffset, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 2-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead2 = function (offset, bitOffset, value) {
                if (arguments.length == 3) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes2(this.getData(), (this.getIndex() + offset), bitOffset, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 20-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead20 = function (offset, bitOffset, value) {
                if (arguments.length == 3) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes20(this.getData(), (this.getIndex() + offset), bitOffset, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 21-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead21 = function (offset, bitOffset, value) {
                if (arguments.length == 3) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes21(this.getData(), (this.getIndex() + offset), bitOffset, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 22-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead22 = function (offset, bitOffset, value) {
                if (arguments.length == 3) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes22(this.getData(), (this.getIndex() + offset), bitOffset, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 23-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead23 = function (offset, bitOffset, value) {
                if (arguments.length == 3) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes23(this.getData(), (this.getIndex() + offset), bitOffset, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 24-bit value.
            @param offset The offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead24 = function (offset, value) {
                if (arguments.length == 2) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes24(this.getData(), (this.getIndex() + offset), this.getLittleEndian(), value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 3-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead3 = function (offset, bitOffset, value) {
                if (arguments.length == 3) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes3(this.getData(), (this.getIndex() + offset), bitOffset, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 32-bit value.
            @param offset The offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead32 = function (offset, value) {
                if (arguments.length == 2) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes32(this.getData(), (this.getIndex() + offset), this.getLittleEndian(), value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 4-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead4 = function (offset, bitOffset, value) {
                if (arguments.length == 3) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes4(this.getData(), (this.getIndex() + offset), bitOffset, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 40-bit value.
            @param offset The offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead40 = function (offset, value) {
                if (arguments.length == 2) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes40(this.getData(), (this.getIndex() + offset), this.getLittleEndian(), value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 48-bit value.
            @param offset The offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead48 = function (offset, value) {
                if (arguments.length == 2) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes48(this.getData(), (this.getIndex() + offset), this.getLittleEndian(), value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 5-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead5 = function (offset, bitOffset, value) {
                if (arguments.length == 3) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes5(this.getData(), (this.getIndex() + offset), bitOffset, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 56-bit value.
            @param offset The offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead56 = function (offset, value) {
                if (arguments.length == 2) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes56(this.getData(), (this.getIndex() + offset), this.getLittleEndian(), value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 6-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead6 = function (offset, bitOffset, value) {
                if (arguments.length == 3) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes6(this.getData(), (this.getIndex() + offset), bitOffset, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 64-bit value.
            @param offset The offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead64 = function (offset, value) {
                if (arguments.length == 2) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes64(this.getData(), (this.getIndex() + offset), this.getLittleEndian(), value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 7-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead7 = function (offset, bitOffset, value) {
                if (arguments.length == 3) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes7(this.getData(), (this.getIndex() + offset), bitOffset, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read an 8-bit value.
            @param offset The offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead8 = function (offset, value) {
                if (arguments.length == 2) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes8(this.getData(), (this.getIndex() + offset), value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to read a 9-bit value.
            @param offset The offset.
            @param bitOffset The bit offset.
            @param value The value.
            */
            DataBuffer.prototype.tryRead9 = function (offset, bitOffset, value) {
                if (arguments.length == 3) {
                    var _var0 = fm.liveswitch.Binary.tryFromBytes9(this.getData(), (this.getIndex() + offset), bitOffset, value);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.write = function () {
                if (arguments.length == 1) {
                    var buffer = arguments[0];
                    this.write(buffer, 0);
                }
                else if (arguments.length == 2) {
                    var buffer = arguments[0];
                    var offset = arguments[1];
                    fm.liveswitch.BitAssistant.copy(buffer.getData(), buffer.getIndex(), this.getData(), (this.getIndex() + offset), buffer.getLength());
                }
                else if (arguments.length == 3) {
                    var buffer = arguments[0];
                    var offset = arguments[1];
                    var offsetPlus = arguments[2];
                    offsetPlus.setValue((offset + buffer.getLength()));
                    this.write(buffer, offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes a 1-bit value.
            @param value The value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.write1 = function (value, offset, bitOffset) {
                if (arguments.length == 3) {
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes1(value, bitOffset, this.getData(), (this.getIndex() + offset)), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes a 10-bit value.
            @param value The value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.write10 = function (value, offset, bitOffset) {
                if (arguments.length == 3) {
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes10(value, bitOffset, this.getLittleEndian(), this.getData(), (this.getIndex() + offset)), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes an 11-bit value.
            @param value The value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.write11 = function (value, offset, bitOffset) {
                if (arguments.length == 3) {
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes11(value, bitOffset, this.getLittleEndian(), this.getData(), (this.getIndex() + offset)), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes a 12-bit value.
            @param value The value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.write12 = function (value, offset, bitOffset) {
                if (arguments.length == 3) {
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes12(value, bitOffset, this.getLittleEndian(), this.getData(), (this.getIndex() + offset)), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes a 13-bit value.
            @param value The value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.write13 = function (value, offset, bitOffset) {
                if (arguments.length == 3) {
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes13(value, bitOffset, this.getLittleEndian(), this.getData(), (this.getIndex() + offset)), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes a 14-bit value.
            @param value The value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.write14 = function (value, offset, bitOffset) {
                if (arguments.length == 3) {
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes14(value, bitOffset, this.getLittleEndian(), this.getData(), (this.getIndex() + offset)), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes a 15-bit value.
            @param value The value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.write15 = function (value, offset, bitOffset) {
                if (arguments.length == 3) {
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes15(value, bitOffset, this.getLittleEndian(), this.getData(), (this.getIndex() + offset)), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.write16 = function () {
                if (arguments.length == 2) {
                    var value = arguments[0];
                    var offset = arguments[1];
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes16(value, this.getLittleEndian(), this.getData(), (this.getIndex() + offset)), null));
                }
                else if (arguments.length == 3) {
                    var value = arguments[0];
                    var offset = arguments[1];
                    var offsetPlus = arguments[2];
                    offsetPlus.setValue((offset + 2));
                    return this.write16(value, offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes a 17-bit value.
            @param value The value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.write17 = function (value, offset, bitOffset) {
                if (arguments.length == 3) {
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes17(value, bitOffset, this.getLittleEndian(), this.getData(), (this.getIndex() + offset)), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes an 18-bit value.
            @param value The value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.write18 = function (value, offset, bitOffset) {
                if (arguments.length == 3) {
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes18(value, bitOffset, this.getLittleEndian(), this.getData(), (this.getIndex() + offset)), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes a 19-bit value.
            @param value The value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.write19 = function (value, offset, bitOffset) {
                if (arguments.length == 3) {
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes19(value, bitOffset, this.getLittleEndian(), this.getData(), (this.getIndex() + offset)), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes a 2-bit value.
            @param value The value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.write2 = function (value, offset, bitOffset) {
                if (arguments.length == 3) {
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes2(value, bitOffset, this.getData(), (this.getIndex() + offset)), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes a 20-bit value.
            @param value The value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.write20 = function (value, offset, bitOffset) {
                if (arguments.length == 3) {
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes20(value, bitOffset, this.getLittleEndian(), this.getData(), (this.getIndex() + offset)), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes a 21-bit value.
            @param value The value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.write21 = function (value, offset, bitOffset) {
                if (arguments.length == 3) {
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes21(value, bitOffset, this.getLittleEndian(), this.getData(), (this.getIndex() + offset)), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes a 22-bit value.
            @param value The value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.write22 = function (value, offset, bitOffset) {
                if (arguments.length == 3) {
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes22(value, bitOffset, this.getLittleEndian(), this.getData(), (this.getIndex() + offset)), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes a 23-bit value.
            @param value The value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.write23 = function (value, offset, bitOffset) {
                if (arguments.length == 3) {
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes23(value, bitOffset, this.getLittleEndian(), this.getData(), (this.getIndex() + offset)), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.write24 = function () {
                if (arguments.length == 2) {
                    var value = arguments[0];
                    var offset = arguments[1];
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes24(value, this.getLittleEndian(), this.getData(), (this.getIndex() + offset)), null));
                }
                else if (arguments.length == 3) {
                    var value = arguments[0];
                    var offset = arguments[1];
                    var offsetPlus = arguments[2];
                    offsetPlus.setValue((offset + 3));
                    return this.write24(value, offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes a 3-bit value.
            @param value The value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.write3 = function (value, offset, bitOffset) {
                if (arguments.length == 3) {
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes3(value, bitOffset, this.getData(), (this.getIndex() + offset)), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.write32 = function () {
                if (arguments.length == 2) {
                    var value = arguments[0];
                    var offset = arguments[1];
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes32(value, this.getLittleEndian(), this.getData(), (this.getIndex() + offset)), null));
                }
                else if (arguments.length == 3) {
                    var value = arguments[0];
                    var offset = arguments[1];
                    var offsetPlus = arguments[2];
                    offsetPlus.setValue((offset + 4));
                    return this.write32(value, offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes a 4-bit value.
            @param value The value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.write4 = function (value, offset, bitOffset) {
                if (arguments.length == 3) {
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes4(value, bitOffset, this.getData(), (this.getIndex() + offset)), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.write40 = function () {
                if (arguments.length == 2) {
                    var value = arguments[0];
                    var offset = arguments[1];
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes40(value, this.getLittleEndian(), this.getData(), (this.getIndex() + offset)), null));
                }
                else if (arguments.length == 3) {
                    var value = arguments[0];
                    var offset = arguments[1];
                    var offsetPlus = arguments[2];
                    offsetPlus.setValue((offset + 5));
                    return this.write40(value, offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.write48 = function () {
                if (arguments.length == 2) {
                    var value = arguments[0];
                    var offset = arguments[1];
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes48(value, this.getLittleEndian(), this.getData(), (this.getIndex() + offset)), null));
                }
                else if (arguments.length == 3) {
                    var value = arguments[0];
                    var offset = arguments[1];
                    var offsetPlus = arguments[2];
                    offsetPlus.setValue((offset + 6));
                    return this.write48(value, offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes a 5-bit value.
            @param value The value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.write5 = function (value, offset, bitOffset) {
                if (arguments.length == 3) {
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes5(value, bitOffset, this.getData(), (this.getIndex() + offset)), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.write56 = function () {
                if (arguments.length == 2) {
                    var value = arguments[0];
                    var offset = arguments[1];
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes56(value, this.getLittleEndian(), this.getData(), (this.getIndex() + offset)), null));
                }
                else if (arguments.length == 3) {
                    var value = arguments[0];
                    var offset = arguments[1];
                    var offsetPlus = arguments[2];
                    offsetPlus.setValue((offset + 7));
                    return this.write56(value, offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes a 6-bit value.
            @param value The value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.write6 = function (value, offset, bitOffset) {
                if (arguments.length == 3) {
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes6(value, bitOffset, this.getData(), (this.getIndex() + offset)), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.write64 = function () {
                if (arguments.length == 2) {
                    var value = arguments[0];
                    var offset = arguments[1];
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes64(value, this.getLittleEndian(), this.getData(), (this.getIndex() + offset)), null));
                }
                else if (arguments.length == 3) {
                    var value = arguments[0];
                    var offset = arguments[1];
                    var offsetPlus = arguments[2];
                    offsetPlus.setValue((offset + 8));
                    return this.write64(value, offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes a 7-bit value.
            @param value The value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.write7 = function (value, offset, bitOffset) {
                if (arguments.length == 3) {
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes7(value, bitOffset, this.getData(), (this.getIndex() + offset)), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.write8 = function () {
                if (arguments.length == 2) {
                    var value = arguments[0];
                    var offset = arguments[1];
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes8(value, this.getData(), (this.getIndex() + offset)), null));
                }
                else if (arguments.length == 3) {
                    var value = arguments[0];
                    var offset = arguments[1];
                    var offsetPlus = arguments[2];
                    offsetPlus.setValue((offset + 1));
                    return this.write8(value, offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes a 9-bit value.
            @param value The value.
            @param offset The offset.
            @param bitOffset The bit offset.
            */
            DataBuffer.prototype.write9 = function (value, offset, bitOffset) {
                if (arguments.length == 3) {
                    return (!fm.liveswitch.Global.equals(fm.liveswitch.Binary.toBytes9(value, bitOffset, this.getLittleEndian(), this.getData(), (this.getIndex() + offset)), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBuffer.prototype.writeBytes = function () {
                if (arguments.length == 1) {
                    var bytes = arguments[0];
                    this.writeBytes(bytes, 0, bytes.length, 0);
                }
                else if (arguments.length == 4) {
                    var bytes = arguments[0];
                    var bytesIndex = arguments[1];
                    var bytesLength = arguments[2];
                    var offset = arguments[3];
                    if (((offset + bytesLength) > this.getLength())) {
                        throw new fm.liveswitch.Exception("Would write out of the allowed bounds for this data buffer.");
                    }
                    fm.liveswitch.BitAssistant.copy(bytes, bytesIndex, this.getData(), (this.getIndex() + offset), bytesLength);
                }
                else if (arguments.length == 5) {
                    var bytes = arguments[0];
                    var bytesIndex = arguments[1];
                    var bytesLength = arguments[2];
                    var offset = arguments[3];
                    var offsetPlus = arguments[4];
                    offsetPlus.setValue((offset + bytesLength));
                    this.writeBytes(bytes, bytesIndex, bytesLength, offset);
                }
                else if (arguments.length == 3) {
                    var bytes = arguments[0];
                    var bytesIndex = arguments[1];
                    var offset = arguments[2];
                    this.writeBytes(bytes, bytesIndex, (bytes.length - bytesIndex), offset);
                }
                else if (arguments.length == 2) {
                    var bytes = arguments[0];
                    var offset = arguments[1];
                    this.writeBytes(bytes, 0, bytes.length, offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Performs a bitwise "xor" operation on a value.
            @param value The value.
            @param offset The offset.
            */
            DataBuffer.prototype.xor = function (value, offset) {
                if (arguments.length == 2) {
                    return this.write8((this.read8(offset) ^ value), offset);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataBuffer.fmliveswitchDataBufferInitialize = function () {
                if (!fm.liveswitch.DataBuffer.__fmliveswitchDataBufferInitialized && !fm.liveswitch.DataBuffer.__fmliveswitchDataBufferInitializing) {
                    fm.liveswitch.DataBuffer.__fmliveswitchDataBufferInitializing = true;
                    fm.liveswitch.DataBuffer.fm_liveswitch_DataBuffer___dataBufferPool = fm.liveswitch.DataBufferPool.getTracer(new fm.liveswitch.Type('[fm.liveswitch.DataBuffer]'));
                    fm.liveswitch.DataBuffer.__fmliveswitchDataBufferInitialized = true;
                    fm.liveswitch.DataBuffer.__fmliveswitchDataBufferInitializing = false;
                }
            };
            /** @hidden */
            DataBuffer.__fmliveswitchDataBufferInitialized = false;
            /** @hidden */
            DataBuffer.__fmliveswitchDataBufferInitializing = false;
            return DataBuffer;
        }());
        liveswitch.DataBuffer = DataBuffer;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="DataBuffer.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var DataBufferPooled = /** @class */ (function (_super) {
            __extends(DataBufferPooled, _super);
            function DataBufferPooled(pool, data, length, littleEndian, tag) {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 5) {
                    var pool_2 = __arguments[0];
                    var data_1 = __arguments[1];
                    var length_33 = __arguments[2];
                    var littleEndian_1 = __arguments[3];
                    var tag_3 = __arguments[4];
                    _this = _super.call(this, data_1, 0, length_33, littleEndian_1) || this;
                    _this.__pool = pool_2;
                    _this.__counter = new fm.liveswitch.AtomicInteger();
                    _this.__tag = tag_3;
                    _this.keep();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            DataBufferPooled.prototype.getTypeString = function () {
                return '[fm.liveswitch.DataBufferPooled]' + ',' + _super.prototype.getTypeString.call(this);
            };
            DataBufferPooled.prototype.decrementRetain = function () {
                if (arguments.length == 0) {
                    return this.__counter.decrement();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBufferPooled.prototype.free = function () {
                if (arguments.length == 0) {
                    this.__pool.returnBuffer(this, this.__tag);
                    return this;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBufferPooled.prototype.getIsPooled = function () {
                if (arguments.length == 0) {
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBufferPooled.prototype.getRetainCount = function () {
                if (arguments.length == 0) {
                    return this.__counter.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBufferPooled.prototype.invalidate = function () {
                if (arguments.length == 0) {
                    var innerData = _super.prototype.getInnerData.call(this);
                    _super.prototype.setInnerData.call(this, null);
                    return innerData;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBufferPooled.prototype.keep = function () {
                if (arguments.length == 0) {
                    if ((fm.liveswitch.Global.equals(_super.prototype.getInnerData.call(this), null))) {
                        throw new fm.liveswitch.Exception("DataBuffer already invalidated.");
                    }
                    this.__counter.increment();
                    return this;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return DataBufferPooled;
        }(fm.liveswitch.DataBuffer));
        liveswitch.DataBufferPooled = DataBufferPooled;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="DataBuffer.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A subset of a DataBuffer.
        */
        var DataBufferSubset = /** @class */ (function (_super) {
            __extends(DataBufferSubset, _super);
            /** @hidden */
            function DataBufferSubset(buffer, index, length) {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 3) {
                    var buffer_1 = __arguments[0];
                    var index_1 = __arguments[1];
                    var length_34 = __arguments[2];
                    _this = _super.call(this, null, index_1, length_34, buffer_1.getLittleEndian()) || this;
                    _this.setParent(buffer_1);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            DataBufferSubset.prototype.getTypeString = function () {
                return '[fm.liveswitch.DataBufferSubset]' + ',' + _super.prototype.getTypeString.call(this);
            };
            DataBufferSubset.prototype.append = function () {
                if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.DataBuffer]'))) {
                    var buffer = arguments[0];
                    throw new fm.liveswitch.Exception("Cannot append to a DataBuffer subset.");
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isObjectType(arguments[0][0], '[fm.liveswitch.DataBuffer]')))))) {
                    var buffers = arguments[0];
                    throw new fm.liveswitch.Exception("Cannot append to a DataBuffer subset.");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Decrements the retain count by one and returns the Buffer to the pool if zero.
            */
            DataBufferSubset.prototype.free = function () {
                if (arguments.length == 0) {
                    this.getParent().free();
                    return this;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the data.
            */
            DataBufferSubset.prototype.getData = function () {
                if (arguments.length == 0) {
                    return this.getParent().getData();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether this DataBuffer is from a pool.
            */
            DataBufferSubset.prototype.getIsPooled = function () {
                if (arguments.length == 0) {
                    return this.getParent().getIsPooled();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether this DataBuffer is a subset.
            */
            DataBufferSubset.prototype.getIsSubset = function () {
                if (arguments.length == 0) {
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the Subset parent.
            */
            DataBufferSubset.prototype.getParent = function () {
                if (arguments.length == 0) {
                    return this._parent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Increment the retain count by one.
            */
            DataBufferSubset.prototype.keep = function () {
                if (arguments.length == 0) {
                    this.getParent().keep();
                    return this;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBufferSubset.prototype.prepend = function () {
                if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.DataBuffer]'))) {
                    var buffer = arguments[0];
                    throw new fm.liveswitch.Exception("Cannot prepend to a DataBuffer subset.");
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isObjectType(arguments[0][0], '[fm.liveswitch.DataBuffer]')))))) {
                    var buffers = arguments[0];
                    throw new fm.liveswitch.Exception("Cannot prepend to a DataBuffer subset.");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataBufferSubset.prototype.setParent = function (value) {
                if (arguments.length == 1) {
                    this._parent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBufferSubset.prototype.subset = function () {
                if (arguments.length == 1) {
                    var offset = arguments[0];
                    return this.getParent().subset((offset + _super.prototype.getIndex.call(this)), (_super.prototype.getLength.call(this) - offset));
                }
                else if (arguments.length == 2) {
                    var offset = arguments[0];
                    var length_35 = arguments[1];
                    return this.getParent().subset((offset + _super.prototype.getIndex.call(this)), length_35);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return DataBufferSubset;
        }(fm.liveswitch.DataBuffer));
        liveswitch.DataBufferSubset = DataBufferSubset;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Details about a specific log event.
        */
        var LogEvent = /** @class */ (function () {
            function LogEvent() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchLogEventInit();
                }
                else if (__arguments.length == 7) {
                    var timestamp = __arguments[0];
                    var tag = __arguments[1];
                    var scope = __arguments[2];
                    var level = __arguments[3];
                    var message = __arguments[4];
                    var exception = __arguments[5];
                    var threadId = __arguments[6];
                    //super();
                    this.fmliveswitchLogEventInit();
                    this.setTimestamp(timestamp);
                    this.setTag(tag);
                    this.setScope(scope);
                    this.setLevel(level);
                    this.setMessage(message);
                    this.setException(exception);
                    this.setThreadId(threadId);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            LogEvent.prototype.getTypeString = function () {
                return '[fm.liveswitch.LogEvent]';
            };
            LogEvent.prototype.fmliveswitchLogEventInit = function () {
                this._threadId = 0;
            };
            /**
            Deserializes a log event from JSON.
            @param logEventJson The log event JSON.
            */
            LogEvent.fromJson = function (logEventJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(logEventJson, function () {
                        return new fm.liveswitch.LogEvent();
                    }, function (logEvent, key, valueJson) {
                        var _var0 = key;
                        if (_var0 == "timestamp") {
                            do {
                                logEvent.setTimestamp(fm.liveswitch.Iso8601Timestamp.iso8601ToDateTime(fm.liveswitch.JsonSerializer.deserializeString(valueJson)));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "tag") {
                            do {
                                logEvent.setTag(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "scope") {
                            do {
                                logEvent.setScope(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "level") {
                            do {
                                logEvent.setLevel(fm.liveswitch.LogEvent.stringToLogLevel(fm.liveswitch.JsonSerializer.deserializeString(valueJson)));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "message") {
                            do {
                                logEvent.setMessage(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "exception") {
                            do {
                                logEvent.setException(new fm.liveswitch.Exception(fm.liveswitch.JsonSerializer.deserializeString(valueJson)));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "threadId") {
                            do {
                                logEvent.setThreadId(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                                break;
                            } while (false);
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LogEvent.logLevelToString = function (logLevel) {
                if (arguments.length == 1) {
                    var _var0 = logLevel;
                    if (_var0 == fm.liveswitch.LogLevel.Verbose) {
                        do {
                            return "verbose";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LogLevel.Debug) {
                        do {
                            return "debug";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LogLevel.Info) {
                        do {
                            return "info";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LogLevel.Warn) {
                        do {
                            return "warn";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LogLevel.Error) {
                        do {
                            return "error";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.LogLevel.Fatal) {
                        do {
                            return "fatal";
                        } while (false);
                    }
                    return "none";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LogEvent.stringToLogLevel = function (logLevelString) {
                if (arguments.length == 1) {
                    var _var0 = logLevelString;
                    if (_var0 == "verbose") {
                        do {
                            return fm.liveswitch.LogLevel.Verbose;
                        } while (false);
                    }
                    else if (_var0 == "debug") {
                        do {
                            return fm.liveswitch.LogLevel.Debug;
                        } while (false);
                    }
                    else if (_var0 == "info") {
                        do {
                            return fm.liveswitch.LogLevel.Info;
                        } while (false);
                    }
                    else if (_var0 == "warn") {
                        do {
                            return fm.liveswitch.LogLevel.Warn;
                        } while (false);
                    }
                    else if (_var0 == "error") {
                        do {
                            return fm.liveswitch.LogLevel.Error;
                        } while (false);
                    }
                    else if (_var0 == "fatal") {
                        do {
                            return fm.liveswitch.LogLevel.Fatal;
                        } while (false);
                    }
                    return fm.liveswitch.LogLevel.None;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a log event to JSON.
            @param logEvent The log event.
            */
            LogEvent.toJson = function (logEvent) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(logEvent, function (le, jsonObj) {
                        jsonObj["timestamp"] = fm.liveswitch.JsonSerializer.serializeString(fm.liveswitch.Iso8601Timestamp.dateTimeToIso8601(logEvent.getTimestamp()));
                        if ((!fm.liveswitch.Global.equals(logEvent.getTag(), null))) {
                            jsonObj["tag"] = fm.liveswitch.JsonSerializer.serializeString(logEvent.getTag());
                        }
                        if ((!fm.liveswitch.Global.equals(logEvent.getScope(), null))) {
                            jsonObj["scope"] = fm.liveswitch.JsonSerializer.serializeString(logEvent.getScope());
                        }
                        jsonObj["level"] = fm.liveswitch.JsonSerializer.serializeString(fm.liveswitch.LogEvent.logLevelToString(logEvent.getLevel()));
                        if ((!fm.liveswitch.Global.equals(logEvent.getMessage(), null))) {
                            jsonObj["message"] = fm.liveswitch.JsonSerializer.serializeString(logEvent.getMessage());
                        }
                        if ((!fm.liveswitch.Global.equals(logEvent.getException(), null))) {
                            jsonObj["exception"] = fm.liveswitch.JsonSerializer.serializeString(logEvent.getException().message);
                        }
                        jsonObj["threadId"] = fm.liveswitch.JsonSerializer.serializeLong(logEvent.getThreadId());
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the event exception, if one exists.
            */
            LogEvent.prototype.getException = function () {
                if (arguments.length == 0) {
                    return this._exception;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the event level.
            */
            LogEvent.prototype.getLevel = function () {
                if (arguments.length == 0) {
                    return this._level;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the level of this log event. Alias for [[fm.liveswitch.logEvent.level]].
            */
            LogEvent.prototype.getLogLevel = function () {
                if (arguments.length == 0) {
                    return this.getLevel();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the event message.
            */
            LogEvent.prototype.getMessage = function () {
                if (arguments.length == 0) {
                    return this._message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the event scope.
            */
            LogEvent.prototype.getScope = function () {
                if (arguments.length == 0) {
                    return this._scope;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the event tag.
            */
            LogEvent.prototype.getTag = function () {
                if (arguments.length == 0) {
                    return this._tag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the ID of the thread generating the event.
            */
            LogEvent.prototype.getThreadId = function () {
                if (arguments.length == 0) {
                    return this._threadId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the event timestamp.
            */
            LogEvent.prototype.getTimestamp = function () {
                if (arguments.length == 0) {
                    return this._timestamp;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the event exception, if one exists.
            */
            LogEvent.prototype.setException = function (value) {
                if (arguments.length == 1) {
                    this._exception = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the event level.
            */
            LogEvent.prototype.setLevel = function (value) {
                if (arguments.length == 1) {
                    this._level = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LogEvent.prototype.setLogLevel = function (value) {
                if (arguments.length == 1) {
                    this.setLevel(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the event message.
            */
            LogEvent.prototype.setMessage = function (value) {
                if (arguments.length == 1) {
                    this._message = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the event scope.
            */
            LogEvent.prototype.setScope = function (value) {
                if (arguments.length == 1) {
                    this._scope = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the event tag.
            */
            LogEvent.prototype.setTag = function (value) {
                if (arguments.length == 1) {
                    this._tag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the ID of the thread generating the event.
            */
            LogEvent.prototype.setThreadId = function (value) {
                if (arguments.length == 1) {
                    this._threadId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the event timestamp.
            */
            LogEvent.prototype.setTimestamp = function (value) {
                if (arguments.length == 1) {
                    this._timestamp = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            LogEvent.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.LogEvent.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
    
            */
            LogEvent.prototype.toString = function () {
                if (arguments.length == 0) {
                    var product = fm.liveswitch.LogProvider.getProduct();
                    var str2 = fm.liveswitch.StringExtensions.format("[{0}][{1}][{2}] {3} [{4}][{5}] {6} {7}", [product, "0", fm.liveswitch.NumberExtensions.toString(this.getThreadId()), fm.liveswitch.LogProvider.getLogLevelString(this.getLevel()), ((fm.liveswitch.Global.equals(this.getTag(), null)) ? "-" : this.getTag()), ((fm.liveswitch.Global.equals(this.getScope(), null)) ? "-" : this.getScope()), fm.liveswitch.LogProvider.getPrefixTimestamp(this.getTimestamp()), this.getMessage()]);
                    if ((!fm.liveswitch.Global.equals(this.getException(), null))) {
                        str2 = fm.liveswitch.StringExtensions.concat(str2, fm.liveswitch.StringExtensions.format("\n{0}", this.getException().toString()));
                    }
                    return str2;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return LogEvent;
        }());
        liveswitch.LogEvent = LogEvent;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var HashTypeWrapper = /** @class */ (function () {
            function HashTypeWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_11 = __arguments[0];
                    //super();
                    this._value = value_11;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            HashTypeWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.HashTypeWrapper]';
            };
            HashTypeWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.HashType.Md5)
                        return 'Md5';
                    if (this._value == fm.liveswitch.HashType.Sha1)
                        return 'Sha1';
                    if (this._value == fm.liveswitch.HashType.Sha256)
                        return 'Sha256';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return HashTypeWrapper;
        }());
        liveswitch.HashTypeWrapper = HashTypeWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var MacTypeWrapper = /** @class */ (function () {
            function MacTypeWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_12 = __arguments[0];
                    //super();
                    this._value = value_12;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            MacTypeWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.MacTypeWrapper]';
            };
            MacTypeWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.MacType.HmacMd5)
                        return 'HmacMd5';
                    if (this._value == fm.liveswitch.MacType.HmacSha1)
                        return 'HmacSha1';
                    if (this._value == fm.liveswitch.MacType.HmacSha256)
                        return 'HmacSha256';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MacTypeWrapper;
        }());
        liveswitch.MacTypeWrapper = MacTypeWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Utility class to assist with Unix timestamp conversions.
        */
        var UnixTimestamp = /** @class */ (function () {
            function UnixTimestamp() {
                fm.liveswitch.UnixTimestamp.fmliveswitchUnixTimestampInitialize();
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            UnixTimestamp.prototype.getTypeString = function () {
                return '[fm.liveswitch.UnixTimestamp]';
            };
            /**
            Converts a date to a Unix timestamp.
            @param dateTime The date to convert.
            @return The equivalent Unix timestamp.
            */
            UnixTimestamp.dateTimeToUnix = function (dateTime) {
                fm.liveswitch.UnixTimestamp.fmliveswitchUnixTimestampInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.UnixTimestamp.ticksToUnix(dateTime.getTicks());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts a date to a Unix timestamp with millisecond precision.
            @param dateTime The date to convert.
            @return The equivalent Unix timestamp.
            */
            UnixTimestamp.dateTimeToUnixMillis = function (dateTime) {
                fm.liveswitch.UnixTimestamp.fmliveswitchUnixTimestampInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.UnixTimestamp.ticksToUnixMillis(dateTime.getTicks());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the current UTC time in Unix format.
            */
            UnixTimestamp.getUtcNow = function () {
                fm.liveswitch.UnixTimestamp.fmliveswitchUnixTimestampInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.UnixTimestamp.dateTimeToUnix(fm.liveswitch.DateTime.getUtcNow());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the current UTC time in Unix format with millisecond precision.
            */
            UnixTimestamp.getUtcNowMillis = function () {
                fm.liveswitch.UnixTimestamp.fmliveswitchUnixTimestampInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.UnixTimestamp.dateTimeToUnixMillis(fm.liveswitch.DateTime.getUtcNow());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts ticks to a Unix timestamp.
            @param ticks The ticks to convert.
            @return The equivalent Unix timestamp.
            */
            UnixTimestamp.ticksToUnix = function (ticks) {
                fm.liveswitch.UnixTimestamp.fmliveswitchUnixTimestampInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.MathAssistant.floor((ticks - fm.liveswitch.UnixTimestamp.fm_liveswitch_UnixTimestamp__baseTicks) / fm.liveswitch.Constants.getTicksPerSecond());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts ticks to a Unix timestamp with millisecond precision.
            @param ticks The ticks to convert.
            @return The equivalent Unix timestamp.
            */
            UnixTimestamp.ticksToUnixMillis = function (ticks) {
                fm.liveswitch.UnixTimestamp.fmliveswitchUnixTimestampInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.MathAssistant.floor((ticks - fm.liveswitch.UnixTimestamp.fm_liveswitch_UnixTimestamp__baseTicks) / fm.liveswitch.Constants.getTicksPerMillisecond());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts a Unix timestamp with millisecond precision to a date.
            @param unix The Unix timestamp to convert.
            @return The equivalent date.
            */
            UnixTimestamp.unixMillisToDateTime = function (unix) {
                fm.liveswitch.UnixTimestamp.fmliveswitchUnixTimestampInitialize();
                if (arguments.length == 1) {
                    return new fm.liveswitch.DateTime(fm.liveswitch.UnixTimestamp.unixMillisToTicks(unix));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts a Unix timestamp with millisecond precision to ticks.
            @param unix The Unix timestamp to convert.
            @return The equivalent ticks.
            */
            UnixTimestamp.unixMillisToTicks = function (unix) {
                fm.liveswitch.UnixTimestamp.fmliveswitchUnixTimestampInitialize();
                if (arguments.length == 1) {
                    return (fm.liveswitch.UnixTimestamp.fm_liveswitch_UnixTimestamp__baseTicks + (unix * fm.liveswitch.Constants.getTicksPerMillisecond()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts a Unix timestamp to a date.
            @param unix The Unix timestamp to convert.
            @return The equivalent date.
            */
            UnixTimestamp.unixToDateTime = function (unix) {
                fm.liveswitch.UnixTimestamp.fmliveswitchUnixTimestampInitialize();
                if (arguments.length == 1) {
                    return new fm.liveswitch.DateTime(fm.liveswitch.UnixTimestamp.unixToTicks(unix));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts a Unix timestamp to ticks.
            @param unix The Unix timestamp to convert.
            @return The equivalent ticks.
            */
            UnixTimestamp.unixToTicks = function (unix) {
                fm.liveswitch.UnixTimestamp.fmliveswitchUnixTimestampInitialize();
                if (arguments.length == 1) {
                    return (fm.liveswitch.UnixTimestamp.fm_liveswitch_UnixTimestamp__baseTicks + (unix * fm.liveswitch.Constants.getTicksPerSecond()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            UnixTimestamp.fmliveswitchUnixTimestampInitialize = function () {
                if (!fm.liveswitch.UnixTimestamp.__fmliveswitchUnixTimestampInitialized && !fm.liveswitch.UnixTimestamp.__fmliveswitchUnixTimestampInitializing) {
                    fm.liveswitch.UnixTimestamp.__fmliveswitchUnixTimestampInitializing = true;
                    UnixTimestamp.fm_liveswitch_UnixTimestamp__baseTicks = 0;
                    var time = new fm.liveswitch.DateTime(1970, 1, 1, 0, 0, 0);
                    fm.liveswitch.UnixTimestamp.fm_liveswitch_UnixTimestamp__baseTicks = time.getTicks();
                    fm.liveswitch.UnixTimestamp.__fmliveswitchUnixTimestampInitialized = true;
                    fm.liveswitch.UnixTimestamp.__fmliveswitchUnixTimestampInitializing = false;
                }
            };
            /** @hidden */
            UnixTimestamp.__fmliveswitchUnixTimestampInitialized = false;
            /** @hidden */
            UnixTimestamp.__fmliveswitchUnixTimestampInitializing = false;
            return UnixTimestamp;
        }());
        liveswitch.UnixTimestamp = UnixTimestamp;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Class to hold a double value passed by reference.
        */
        var DoubleHolder = /** @class */ (function () {
            function DoubleHolder() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchDoubleHolderInit();
                }
                else if (__arguments.length == 1) {
                    var value = __arguments[0];
                    //super();
                    this.fmliveswitchDoubleHolderInit();
                    this.setValue(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            DoubleHolder.prototype.getTypeString = function () {
                return '[fm.liveswitch.DoubleHolder]';
            };
            DoubleHolder.prototype.fmliveswitchDoubleHolderInit = function () {
                this._value = 0;
            };
            /**
            Gets the value.
            */
            DoubleHolder.prototype.getValue = function () {
                if (arguments.length == 0) {
                    return this._value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the value.
            */
            DoubleHolder.prototype.setValue = function (value) {
                if (arguments.length == 1) {
                    this._value = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return DoubleHolder;
        }());
        liveswitch.DoubleHolder = DoubleHolder;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        An error.
        */
        var Error = /** @class */ (function () {
            function Error() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else if (__arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isError(arguments[1]))) {
                    var code = __arguments[0];
                    var exception = __arguments[1];
                    //super();
                    this.setCode(code);
                    this.setException(exception);
                }
                else if (__arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                    var code = __arguments[0];
                    var message = __arguments[1];
                    //super();
                    this.setCode(code);
                    this.setMessage(message);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Error.prototype.getTypeString = function () {
                return '[fm.liveswitch.Error]';
            };
            /**
            Deserializes an instance from JSON.
            @param errorJson The JSON to deserialize.
            @return The deserialized error.
            */
            Error.fromJson = function (errorJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(errorJson, function () {
                        return new fm.liveswitch.Error();
                    }, function (error, name, valueJson) {
                        var str = name;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            if (!(fm.liveswitch.Global.equals(str, "code"))) {
                                if ((fm.liveswitch.Global.equals(str, "message"))) {
                                    error.setMessage(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                }
                            }
                            else {
                                error.setCodeValue(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            }
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param error The error.
            @return
                        The serialized JSON.
                
            */
            Error.toJson = function (error) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(error, function (obj, jsonObject) {
                        jsonObject["code"] = fm.liveswitch.JsonSerializer.serializeInteger(obj.getCodeValue());
                        if ((!fm.liveswitch.Global.equals(error.getMessage(), null))) {
                            jsonObject["message"] = fm.liveswitch.JsonSerializer.serializeString(obj.getMessage());
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the code.
            */
            Error.prototype.getCode = function () {
                if (arguments.length == 0) {
                    return this._code;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the code.
            */
            Error.prototype.getCodeValue = function () {
                if (arguments.length == 0) {
                    return this.getCode();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the description for this [[fm.liveswitch.error]].
            */
            Error.prototype.getDescription = function () {
                if (arguments.length == 0) {
                    var str = new fm.liveswitch.ErrorCodeWrapper(this.getCode()).toString();
                    var message = this.getMessage();
                    if ((!fm.liveswitch.Global.equals(message, null))) {
                        str = fm.liveswitch.StringExtensions.concat(str, " ", message);
                    }
                    str = fm.liveswitch.StringExtensions.trimEnd(str, new Array(0));
                    if (!fm.liveswitch.StringExtensions.endsWith(str, ".")) {
                        str = fm.liveswitch.StringExtensions.concat(str, ".");
                    }
                    return str;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the code. Obsolete. Alias for [[fm.liveswitch.error.code]].
            */
            Error.prototype.getErrorCode = function () {
                if (arguments.length == 0) {
                    return this.getCode();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the exception.
            */
            Error.prototype.getException = function () {
                if (arguments.length == 0) {
                    return this._exception;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the message.
            */
            Error.prototype.getMessage = function () {
                if (arguments.length == 0) {
                    return ((fm.liveswitch.Global.equals(this.getException(), null)) ? null : this.getException().message);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the code.
            */
            Error.prototype.setCode = function (value) {
                if (arguments.length == 1) {
                    this._code = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the code.
            */
            Error.prototype.setCodeValue = function (value) {
                if (arguments.length == 1) {
                    this.setCode(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the code. Obsolete. Alias for [[fm.liveswitch.error.code]].
            */
            Error.prototype.setErrorCode = function (value) {
                if (arguments.length == 1) {
                    this.setCode(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the exception.
            */
            Error.prototype.setException = function (value) {
                if (arguments.length == 1) {
                    this._exception = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the message.
            */
            Error.prototype.setMessage = function (value) {
                if (arguments.length == 1) {
                    this.setException(((fm.liveswitch.Global.equals(value, null)) ? null : new fm.liveswitch.Exception(value)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            @return
                        The serialized JSON.
                
            */
            Error.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Error.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Returns the string representation of this error.
            */
            Error.prototype.toString = function () {
                if (arguments.length == 0) {
                    return this.getDescription();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Error;
        }());
        liveswitch.Error = Error;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var ErrorCodeWrapper = /** @class */ (function () {
            function ErrorCodeWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_13 = __arguments[0];
                    //super();
                    this._value = value_13;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            ErrorCodeWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.ErrorCodeWrapper]';
            };
            ErrorCodeWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.ErrorCode.SocketSendError)
                        return 'SocketSendError';
                    if (this._value == fm.liveswitch.ErrorCode.SocketReceiveError)
                        return 'SocketReceiveError';
                    if (this._value == fm.liveswitch.ErrorCode.SocketClosed)
                        return 'SocketClosed';
                    if (this._value == fm.liveswitch.ErrorCode.SocketSendBufferFull)
                        return 'SocketSendBufferFull';
                    if (this._value == fm.liveswitch.ErrorCode.IPProtocolMismatch)
                        return 'IPProtocolMismatch';
                    if (this._value == fm.liveswitch.ErrorCode.PacketTooLarge)
                        return 'PacketTooLarge';
                    if (this._value == fm.liveswitch.ErrorCode.StunTryAlternate)
                        return 'StunTryAlternate';
                    if (this._value == fm.liveswitch.ErrorCode.StunBadRequest)
                        return 'StunBadRequest';
                    if (this._value == fm.liveswitch.ErrorCode.StunUnauthorized)
                        return 'StunUnauthorized';
                    if (this._value == fm.liveswitch.ErrorCode.StunTurnForbidden)
                        return 'StunTurnForbidden';
                    if (this._value == fm.liveswitch.ErrorCode.StunTurnMobilityForbidden)
                        return 'StunTurnMobilityForbidden';
                    if (this._value == fm.liveswitch.ErrorCode.StunUnknownAttribute)
                        return 'StunUnknownAttribute';
                    if (this._value == fm.liveswitch.ErrorCode.StunStaleCredentials)
                        return 'StunStaleCredentials';
                    if (this._value == fm.liveswitch.ErrorCode.StunIntegrityCheckFailure)
                        return 'StunIntegrityCheckFailure';
                    if (this._value == fm.liveswitch.ErrorCode.StunMissingUsername)
                        return 'StunMissingUsername';
                    if (this._value == fm.liveswitch.ErrorCode.StunTurnAllocationMismatch)
                        return 'StunTurnAllocationMismatch';
                    if (this._value == fm.liveswitch.ErrorCode.StunStaleNonce)
                        return 'StunStaleNonce';
                    if (this._value == fm.liveswitch.ErrorCode.StunAddressFamilyNotSupported)
                        return 'StunAddressFamilyNotSupported';
                    if (this._value == fm.liveswitch.ErrorCode.StunTurnWrongCredentials)
                        return 'StunTurnWrongCredentials';
                    if (this._value == fm.liveswitch.ErrorCode.StunTurnUnsupportedTransportProtocol)
                        return 'StunTurnUnsupportedTransportProtocol';
                    if (this._value == fm.liveswitch.ErrorCode.StunTurnPeerAddressFamilyMismatch)
                        return 'StunTurnPeerAddressFamilyMismatch';
                    if (this._value == fm.liveswitch.ErrorCode.StunTurnConnectionAlreadyExists)
                        return 'StunTurnConnectionAlreadyExists';
                    if (this._value == fm.liveswitch.ErrorCode.StunTurnConnectionTimeoutOrFailure)
                        return 'StunTurnConnectionTimeoutOrFailure';
                    if (this._value == fm.liveswitch.ErrorCode.StunTurnAllocationQuotaReached)
                        return 'StunTurnAllocationQuotaReached';
                    if (this._value == fm.liveswitch.ErrorCode.StunIceRoleConflict)
                        return 'StunIceRoleConflict';
                    if (this._value == fm.liveswitch.ErrorCode.StunServerError)
                        return 'StunServerError';
                    if (this._value == fm.liveswitch.ErrorCode.StunTurnInsufficientCapacity)
                        return 'StunTurnInsufficientCapacity';
                    if (this._value == fm.liveswitch.ErrorCode.StunInvalidResponseType)
                        return 'StunInvalidResponseType';
                    if (this._value == fm.liveswitch.ErrorCode.StunInvalidErrorCode)
                        return 'StunInvalidErrorCode';
                    if (this._value == fm.liveswitch.ErrorCode.StunInvalidTransactionId)
                        return 'StunInvalidTransactionId';
                    if (this._value == fm.liveswitch.ErrorCode.StunUnknownStunErrorCode)
                        return 'StunUnknownStunErrorCode';
                    if (this._value == fm.liveswitch.ErrorCode.StunInvalidMessageIntegrity)
                        return 'StunInvalidMessageIntegrity';
                    if (this._value == fm.liveswitch.ErrorCode.SocketIPError)
                        return 'SocketIPError';
                    if (this._value == fm.liveswitch.ErrorCode.IceLocalRelayedDatagramCandidateError)
                        return 'IceLocalRelayedDatagramCandidateError';
                    if (this._value == fm.liveswitch.ErrorCode.IceLocalServerReflexiveCandidateError)
                        return 'IceLocalServerReflexiveCandidateError';
                    if (this._value == fm.liveswitch.ErrorCode.SocketManagerInvalidState)
                        return 'SocketManagerInvalidState';
                    if (this._value == fm.liveswitch.ErrorCode.IceStartError)
                        return 'IceStartError';
                    if (this._value == fm.liveswitch.ErrorCode.IceUnsuitableSocketAssignment)
                        return 'IceUnsuitableSocketAssignment';
                    if (this._value == fm.liveswitch.ErrorCode.IceAllPortsInUse)
                        return 'IceAllPortsInUse';
                    if (this._value == fm.liveswitch.ErrorCode.IceLocalAddressUnavailable)
                        return 'IceLocalAddressUnavailable';
                    if (this._value == fm.liveswitch.ErrorCode.IceGenericGathererError)
                        return 'IceGenericGathererError';
                    if (this._value == fm.liveswitch.ErrorCode.IceRefreshTimeout)
                        return 'IceRefreshTimeout';
                    if (this._value == fm.liveswitch.ErrorCode.IceRefreshError)
                        return 'IceRefreshError';
                    if (this._value == fm.liveswitch.ErrorCode.IceCreatePermissionTimeout)
                        return 'IceCreatePermissionTimeout';
                    if (this._value == fm.liveswitch.ErrorCode.IceCreatePermissionError)
                        return 'IceCreatePermissionError';
                    if (this._value == fm.liveswitch.ErrorCode.IceConnectivityCheckFailed)
                        return 'IceConnectivityCheckFailed';
                    if (this._value == fm.liveswitch.ErrorCode.IceSendError)
                        return 'IceSendError';
                    if (this._value == fm.liveswitch.ErrorCode.IcePeerReflexiveError)
                        return 'IcePeerReflexiveError';
                    if (this._value == fm.liveswitch.ErrorCode.IncompatibleIceSetup)
                        return 'IncompatibleIceSetup';
                    if (this._value == fm.liveswitch.ErrorCode.DtlsInternalError)
                        return 'DtlsInternalError';
                    if (this._value == fm.liveswitch.ErrorCode.DtlsKeyExchangeFailed)
                        return 'DtlsKeyExchangeFailed';
                    if (this._value == fm.liveswitch.ErrorCode.DtlsNotReady)
                        return 'DtlsNotReady';
                    if (this._value == fm.liveswitch.ErrorCode.SctpNoPayloadData)
                        return 'SctpNoPayloadData';
                    if (this._value == fm.liveswitch.ErrorCode.SctpUnsupportedStream)
                        return 'SctpUnsupportedStream';
                    if (this._value == fm.liveswitch.ErrorCode.SctpInvalidState)
                        return 'SctpInvalidState';
                    if (this._value == fm.liveswitch.ErrorCode.SctpInternalError)
                        return 'SctpInternalError';
                    if (this._value == fm.liveswitch.ErrorCode.MediaTransportFailed)
                        return 'MediaTransportFailed';
                    if (this._value == fm.liveswitch.ErrorCode.ReliableDataChannelOpenError)
                        return 'ReliableDataChannelOpenError';
                    if (this._value == fm.liveswitch.ErrorCode.ReliableDataChannelSendError)
                        return 'ReliableDataChannelSendError';
                    if (this._value == fm.liveswitch.ErrorCode.ConnectionInvalidArchitecture)
                        return 'ConnectionInvalidArchitecture';
                    if (this._value == fm.liveswitch.ErrorCode.ConnectionInternalError)
                        return 'ConnectionInternalError';
                    if (this._value == fm.liveswitch.ErrorCode.ConnectionTransportStartError)
                        return 'ConnectionTransportStartError';
                    if (this._value == fm.liveswitch.ErrorCode.ConnectionTransportClosed)
                        return 'ConnectionTransportClosed';
                    if (this._value == fm.liveswitch.ErrorCode.ConnectionDeadStream)
                        return 'ConnectionDeadStream';
                    if (this._value == fm.liveswitch.ErrorCode.ConnectionNotEstablished)
                        return 'ConnectionNotEstablished';
                    if (this._value == fm.liveswitch.ErrorCode.ConnectionRemoteFailure)
                        return 'ConnectionRemoteFailure';
                    if (this._value == fm.liveswitch.ErrorCode.ConnectionSimulcastNotSupported)
                        return 'ConnectionSimulcastNotSupported';
                    if (this._value == fm.liveswitch.ErrorCode.StreamDisabled)
                        return 'StreamDisabled';
                    if (this._value == fm.liveswitch.ErrorCode.StreamEncryptionMismatch)
                        return 'StreamEncryptionMismatch';
                    if (this._value == fm.liveswitch.ErrorCode.StreamDirectionMismatch)
                        return 'StreamDirectionMismatch';
                    if (this._value == fm.liveswitch.ErrorCode.DataStreamDirectionCannotBeChanged)
                        return 'DataStreamDirectionCannotBeChanged';
                    if (this._value == fm.liveswitch.ErrorCode.InvalidStreamDirectionChange)
                        return 'InvalidStreamDirectionChange';
                    if (this._value == fm.liveswitch.ErrorCode.LocalDescriptionError)
                        return 'LocalDescriptionError';
                    if (this._value == fm.liveswitch.ErrorCode.RemoteDescriptionError)
                        return 'RemoteDescriptionError';
                    if (this._value == fm.liveswitch.ErrorCode.IceLocalRelayedStreamCandidateError)
                        return 'IceLocalRelayedStreamCandidateError';
                    if (this._value == fm.liveswitch.ErrorCode.IceInvalidServerAssignmentError)
                        return 'IceInvalidServerAssignmentError';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ErrorCodeWrapper;
        }());
        liveswitch.ErrorCodeWrapper = ErrorCodeWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Class to hold a float value passed by reference.
        */
        var FloatHolder = /** @class */ (function () {
            function FloatHolder() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchFloatHolderInit();
                }
                else if (__arguments.length == 1) {
                    var value = __arguments[0];
                    //super();
                    this.fmliveswitchFloatHolderInit();
                    this.setValue(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            FloatHolder.prototype.getTypeString = function () {
                return '[fm.liveswitch.FloatHolder]';
            };
            FloatHolder.prototype.fmliveswitchFloatHolderInit = function () {
                this._value = 0;
            };
            /**
            Gets the value.
            */
            FloatHolder.prototype.getValue = function () {
                if (arguments.length == 0) {
                    return this._value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the value.
            */
            FloatHolder.prototype.setValue = function (value) {
                if (arguments.length == 1) {
                    this._value = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return FloatHolder;
        }());
        liveswitch.FloatHolder = FloatHolder;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var HttpMethodWrapper = /** @class */ (function () {
            function HttpMethodWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_14 = __arguments[0];
                    //super();
                    this._value = value_14;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            HttpMethodWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.HttpMethodWrapper]';
            };
            HttpMethodWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.HttpMethod.Get)
                        return 'Get';
                    if (this._value == fm.liveswitch.HttpMethod.Head)
                        return 'Head';
                    if (this._value == fm.liveswitch.HttpMethod.Post)
                        return 'Post';
                    if (this._value == fm.liveswitch.HttpMethod.Put)
                        return 'Put';
                    if (this._value == fm.liveswitch.HttpMethod.Patch)
                        return 'Patch';
                    if (this._value == fm.liveswitch.HttpMethod.Delete)
                        return 'Delete';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return HttpMethodWrapper;
        }());
        liveswitch.HttpMethodWrapper = HttpMethodWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Arguments for sending an HTTP request.
        */
        var HttpRequestArgs = /** @class */ (function (_super) {
            __extends(HttpRequestArgs, _super);
            /**
            Initializes a new instance of the [[fm.liveswitch.httpRequestArgs]] class with default values.
            */
            function HttpRequestArgs() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchHttpRequestArgsInit();
                    _this.setTimeout(15000);
                    _this.setMethod(fm.liveswitch.HttpMethod.Post);
                    _this.__headers = new fm.liveswitch.NameValueCollection();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            HttpRequestArgs.prototype.getTypeString = function () {
                return '[fm.liveswitch.HttpRequestArgs]' + ',' + _super.prototype.getTypeString.call(this);
            };
            HttpRequestArgs.prototype.fmliveswitchHttpRequestArgsInit = function () {
                this._maxRetries = 0;
                this._timeout = 0;
            };
            /**
            Gets the binary content to transfer over HTTP. Overrides [[fm.liveswitch.httpRequestArgs.textContent]].
            */
            HttpRequestArgs.prototype.getBinaryContent = function () {
                if (arguments.length == 0) {
                    return this._binaryContent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the headers to transfer over HTTP.
            */
            HttpRequestArgs.prototype.getHeaders = function () {
                if (arguments.length == 0) {
                    return this.__headers;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the maximum number of retries allowed.
            */
            HttpRequestArgs.prototype.getMaxRetries = function () {
                if (arguments.length == 0) {
                    return this._maxRetries;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the HTTP method.
            */
            HttpRequestArgs.prototype.getMethod = function () {
                if (arguments.length == 0) {
                    return this._method;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the callback to invoke once the outgoing HTTP request is created. See [[fm.liveswitch.httpRequestCreatedArgs]] for callback argument details.
            */
            HttpRequestArgs.prototype.getOnRequestCreated = function () {
                if (arguments.length == 0) {
                    return this._onRequestCreated;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the callback to invoke once the incoming HTTP response has been received. See [[fm.liveswitch.httpResponseReceivedArgs]] for callback argument details.
            */
            HttpRequestArgs.prototype.getOnResponseReceived = function () {
                if (arguments.length == 0) {
                    return this._onResponseReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the sender of the content, either a client or publisher.
            */
            HttpRequestArgs.prototype.getSender = function () {
                if (arguments.length == 0) {
                    return this._sender;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the text content to transfer over HTTP.
            */
            HttpRequestArgs.prototype.getTextContent = function () {
                if (arguments.length == 0) {
                    return this._textContent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of milliseconds to wait before timing out the HTTP transfer. Defaults to 15000 ms (15 seconds).
            */
            HttpRequestArgs.prototype.getTimeout = function () {
                if (arguments.length == 0) {
                    return this._timeout;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the target URL for the HTTP request.
            */
            HttpRequestArgs.prototype.getUrl = function () {
                if (arguments.length == 0) {
                    return this._url;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the binary content to transfer over HTTP. Overrides [[fm.liveswitch.httpRequestArgs.textContent]].
            */
            HttpRequestArgs.prototype.setBinaryContent = function (value) {
                if (arguments.length == 1) {
                    this._binaryContent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the headers to transfer over HTTP.
            */
            HttpRequestArgs.prototype.setHeaders = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(value, null))) {
                        this.__headers = new fm.liveswitch.NameValueCollection();
                    }
                    else {
                        this.__headers = value;
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the maximum number of retries allowed.
            */
            HttpRequestArgs.prototype.setMaxRetries = function (value) {
                if (arguments.length == 1) {
                    this._maxRetries = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the HTTP method.
            */
            HttpRequestArgs.prototype.setMethod = function (value) {
                if (arguments.length == 1) {
                    this._method = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the callback to invoke once the outgoing HTTP request is created. See [[fm.liveswitch.httpRequestCreatedArgs]] for callback argument details.
            */
            HttpRequestArgs.prototype.setOnRequestCreated = function (value) {
                if (arguments.length == 1) {
                    this._onRequestCreated = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the callback to invoke once the incoming HTTP response has been received. See [[fm.liveswitch.httpResponseReceivedArgs]] for callback argument details.
            */
            HttpRequestArgs.prototype.setOnResponseReceived = function (value) {
                if (arguments.length == 1) {
                    this._onResponseReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the sender of the content, either a client or publisher.
            */
            HttpRequestArgs.prototype.setSender = function (value) {
                if (arguments.length == 1) {
                    this._sender = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the text content to transfer over HTTP.
            */
            HttpRequestArgs.prototype.setTextContent = function (value) {
                if (arguments.length == 1) {
                    this._textContent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of milliseconds to wait before timing out the HTTP transfer. Defaults to 15000 ms (15 seconds).
            */
            HttpRequestArgs.prototype.setTimeout = function (value) {
                if (arguments.length == 1) {
                    this._timeout = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the target URL for the HTTP request.
            */
            HttpRequestArgs.prototype.setUrl = function (value) {
                if (arguments.length == 1) {
                    this._url = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return HttpRequestArgs;
        }(fm.liveswitch.Dynamic));
        liveswitch.HttpRequestArgs = HttpRequestArgs;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Arguments passed into callbacks when an HTTP request is created.
        */
        var HttpRequestCreatedArgs = /** @class */ (function () {
            function HttpRequestCreatedArgs() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            HttpRequestCreatedArgs.prototype.getTypeString = function () {
                return '[fm.liveswitch.HttpRequestCreatedArgs]';
            };
            /**
            Gets the outgoing HTTP request about to be sent to the server.
            */
            HttpRequestCreatedArgs.prototype.getRequest = function () {
                if (arguments.length == 0) {
                    return this._request;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the original request arguments.
            */
            HttpRequestCreatedArgs.prototype.getRequestArgs = function () {
                if (arguments.length == 0) {
                    return this._requestArgs;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the sender of the request, either a client or publisher.
            */
            HttpRequestCreatedArgs.prototype.getSender = function () {
                if (arguments.length == 0) {
                    return this._sender;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the outgoing HTTP request about to be sent to the server.
            */
            HttpRequestCreatedArgs.prototype.setRequest = function (value) {
                if (arguments.length == 1) {
                    this._request = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the original request arguments.
            */
            HttpRequestCreatedArgs.prototype.setRequestArgs = function (value) {
                if (arguments.length == 1) {
                    this._requestArgs = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the sender of the request, either a client or publisher.
            */
            HttpRequestCreatedArgs.prototype.setSender = function (value) {
                if (arguments.length == 1) {
                    this._sender = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return HttpRequestCreatedArgs;
        }());
        liveswitch.HttpRequestCreatedArgs = HttpRequestCreatedArgs;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Arguments for receiving an HTTP response.
        */
        var HttpResponseArgs = /** @class */ (function () {
            function HttpResponseArgs() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchHttpResponseArgsInit();
                    this.setHeaders(new fm.liveswitch.NameValueCollection());
                }
                else if (__arguments.length == 1) {
                    var requestArgs = __arguments[0];
                    // chained constructor: HttpResponseArgs.call(this);
                    __arguments = new Array(0);
                    {
                        //super();
                        this.fmliveswitchHttpResponseArgsInit();
                        this.setHeaders(new fm.liveswitch.NameValueCollection());
                    }
                    this.setRequestArgs(requestArgs);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            HttpResponseArgs.prototype.getTypeString = function () {
                return '[fm.liveswitch.HttpResponseArgs]';
            };
            HttpResponseArgs.prototype.fmliveswitchHttpResponseArgsInit = function () {
                this._retries = 0;
                this._statusCode = 0;
            };
            /**
            Gets the binary content read from the HTTP response.
            */
            HttpResponseArgs.prototype.getBinaryContent = function () {
                if (arguments.length == 0) {
                    return this._binaryContent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the exception generated while completing the request.
            */
            HttpResponseArgs.prototype.getException = function () {
                if (arguments.length == 0) {
                    return this._exception;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the headers read from the HTTP response.
            */
            HttpResponseArgs.prototype.getHeaders = function () {
                if (arguments.length == 0) {
                    return this._headers;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the original [[fm.liveswitch.httpRequestArgs]].
            */
            HttpResponseArgs.prototype.getRequestArgs = function () {
                if (arguments.length == 0) {
                    return this._requestArgs;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of retries that were required.
            */
            HttpResponseArgs.prototype.getRetries = function () {
                if (arguments.length == 0) {
                    return this._retries;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the status code read from the HTTP response.
            */
            HttpResponseArgs.prototype.getStatusCode = function () {
                if (arguments.length == 0) {
                    return this._statusCode;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the text content read from the HTTP response.
            */
            HttpResponseArgs.prototype.getTextContent = function () {
                if (arguments.length == 0) {
                    return this._textContent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the binary content read from the HTTP response.
            */
            HttpResponseArgs.prototype.setBinaryContent = function (value) {
                if (arguments.length == 1) {
                    this._binaryContent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the exception generated while completing the request.
            */
            HttpResponseArgs.prototype.setException = function (value) {
                if (arguments.length == 1) {
                    this._exception = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            HttpResponseArgs.prototype.setHeaders = function (value) {
                if (arguments.length == 1) {
                    this._headers = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the original [[fm.liveswitch.httpRequestArgs]].
            */
            HttpResponseArgs.prototype.setRequestArgs = function (value) {
                if (arguments.length == 1) {
                    this._requestArgs = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of retries that were required.
            */
            HttpResponseArgs.prototype.setRetries = function (value) {
                if (arguments.length == 1) {
                    this._retries = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the status code read from the HTTP response.
            */
            HttpResponseArgs.prototype.setStatusCode = function (value) {
                if (arguments.length == 1) {
                    this._statusCode = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the text content read from the HTTP response.
            */
            HttpResponseArgs.prototype.setTextContent = function (value) {
                if (arguments.length == 1) {
                    this._textContent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return HttpResponseArgs;
        }());
        liveswitch.HttpResponseArgs = HttpResponseArgs;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Arguments passed into callbacks when an HTTP response is received.
        */
        var HttpResponseReceivedArgs = /** @class */ (function () {
            function HttpResponseReceivedArgs() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            HttpResponseReceivedArgs.prototype.getTypeString = function () {
                return '[fm.liveswitch.HttpResponseReceivedArgs]';
            };
            /**
            Gets the original request arguments.
            */
            HttpResponseReceivedArgs.prototype.getRequestArgs = function () {
                if (arguments.length == 0) {
                    return this._requestArgs;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the incoming HTTP response received from the server.
            */
            HttpResponseReceivedArgs.prototype.getResponse = function () {
                if (arguments.length == 0) {
                    return this._response;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the sender of the request, either a client or publisher.
            */
            HttpResponseReceivedArgs.prototype.getSender = function () {
                if (arguments.length == 0) {
                    return this._sender;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the original request arguments.
            */
            HttpResponseReceivedArgs.prototype.setRequestArgs = function (value) {
                if (arguments.length == 1) {
                    this._requestArgs = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the incoming HTTP response received from the server.
            */
            HttpResponseReceivedArgs.prototype.setResponse = function (value) {
                if (arguments.length == 1) {
                    this._response = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the sender of the request, either a client or publisher.
            */
            HttpResponseReceivedArgs.prototype.setSender = function (value) {
                if (arguments.length == 1) {
                    this._sender = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return HttpResponseReceivedArgs;
        }());
        liveswitch.HttpResponseReceivedArgs = HttpResponseReceivedArgs;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Arguments for [[fm.liveswitch.httpTransfer.addOnSendStart]].
        */
        var HttpSendFinishArgs = /** @class */ (function () {
            function HttpSendFinishArgs() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            HttpSendFinishArgs.prototype.getTypeString = function () {
                return '[fm.liveswitch.HttpSendFinishArgs]';
            };
            /**
            Gets the binary content of the request.
            */
            HttpSendFinishArgs.prototype.getRequestBinaryContent = function () {
                if (arguments.length == 0) {
                    return this._requestBinaryContent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the text content of the request.
            */
            HttpSendFinishArgs.prototype.getRequestTextContent = function () {
                if (arguments.length == 0) {
                    return this._requestTextContent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the binary content of the response.
            */
            HttpSendFinishArgs.prototype.getResponseBinaryContent = function () {
                if (arguments.length == 0) {
                    return this._responseBinaryContent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the headers of the response.
            */
            HttpSendFinishArgs.prototype.getResponseHeaders = function () {
                if (arguments.length == 0) {
                    return this._responseHeaders;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the binary content of the response.
            */
            HttpSendFinishArgs.prototype.getResponseTextContent = function () {
                if (arguments.length == 0) {
                    return this._responseTextContent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the sender of the request, either a client or publisher.
            */
            HttpSendFinishArgs.prototype.getSender = function () {
                if (arguments.length == 0) {
                    return this._sender;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            HttpSendFinishArgs.prototype.setRequestBinaryContent = function (value) {
                if (arguments.length == 1) {
                    this._requestBinaryContent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            HttpSendFinishArgs.prototype.setRequestTextContent = function (value) {
                if (arguments.length == 1) {
                    this._requestTextContent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            HttpSendFinishArgs.prototype.setResponseBinaryContent = function (value) {
                if (arguments.length == 1) {
                    this._responseBinaryContent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            HttpSendFinishArgs.prototype.setResponseHeaders = function (value) {
                if (arguments.length == 1) {
                    this._responseHeaders = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            HttpSendFinishArgs.prototype.setResponseTextContent = function (value) {
                if (arguments.length == 1) {
                    this._responseTextContent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            HttpSendFinishArgs.prototype.setSender = function (value) {
                if (arguments.length == 1) {
                    this._sender = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return HttpSendFinishArgs;
        }());
        liveswitch.HttpSendFinishArgs = HttpSendFinishArgs;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Arguments for [[fm.liveswitch.httpTransfer.addOnSendStart]].
        */
        var HttpSendStartArgs = /** @class */ (function () {
            function HttpSendStartArgs() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            HttpSendStartArgs.prototype.getTypeString = function () {
                return '[fm.liveswitch.HttpSendStartArgs]';
            };
            /**
            Gets the binary content of the request.
            */
            HttpSendStartArgs.prototype.getRequestBinaryContent = function () {
                if (arguments.length == 0) {
                    return this._requestBinaryContent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the text content of the request.
            */
            HttpSendStartArgs.prototype.getRequestTextContent = function () {
                if (arguments.length == 0) {
                    return this._requestTextContent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the sender of the request, either a client or publisher.
            */
            HttpSendStartArgs.prototype.getSender = function () {
                if (arguments.length == 0) {
                    return this._sender;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            HttpSendStartArgs.prototype.setRequestBinaryContent = function (value) {
                if (arguments.length == 1) {
                    this._requestBinaryContent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            HttpSendStartArgs.prototype.setRequestTextContent = function (value) {
                if (arguments.length == 1) {
                    this._requestTextContent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            HttpSendStartArgs.prototype.setSender = function (value) {
                if (arguments.length == 1) {
                    this._sender = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return HttpSendStartArgs;
        }());
        liveswitch.HttpSendStartArgs = HttpSendStartArgs;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Creates implementations of [[fm.liveswitch.httpTransfer]].
        */
        var HttpTransferFactory = /** @class */ (function () {
            function HttpTransferFactory() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            HttpTransferFactory.prototype.getTypeString = function () {
                return '[fm.liveswitch.HttpTransferFactory]';
            };
            /** @hidden */
            HttpTransferFactory.defaultCreateHttpTransfer = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.HttpWebRequestTransfer();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the callback that creates an HTTP-based transfer class.
            */
            HttpTransferFactory.getCreateHttpTransfer = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.HttpTransferFactory.fm_liveswitch_HttpTransferFactory__createHttpTransfer;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets an instance of the HTTP-based transfer class.
            */
            HttpTransferFactory.getHttpTransfer = function () {
                if (arguments.length == 0) {
                    if ((fm.liveswitch.Global.equals(fm.liveswitch.HttpTransferFactory.getCreateHttpTransfer(), null))) {
                        fm.liveswitch.HttpTransferFactory.setCreateHttpTransfer(fm.liveswitch.HttpTransferFactory.defaultCreateHttpTransfer.bind(fm.liveswitch.HttpTransferFactory));
                    }
                    var transfer = fm.liveswitch.HttpTransferFactory.getCreateHttpTransfer()();
                    if ((fm.liveswitch.Global.equals(transfer, null))) {
                        transfer = fm.liveswitch.HttpTransferFactory.defaultCreateHttpTransfer();
                    }
                    return transfer;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the callback that creates an HTTP-based transfer class.
            */
            HttpTransferFactory.setCreateHttpTransfer = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.HttpTransferFactory.fm_liveswitch_HttpTransferFactory__createHttpTransfer = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return HttpTransferFactory;
        }());
        liveswitch.HttpTransferFactory = HttpTransferFactory;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        An HTTP web request sender.
        */
        var HttpWebRequestSender = /** @class */ (function (_super) {
            __extends(HttpWebRequestSender, _super);
            function HttpWebRequestSender() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchHttpWebRequestSenderInit();
                    _this.__disableJsonp = true;
                    _this.__forceJsonp = false;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            HttpWebRequestSender.prototype.getTypeString = function () {
                return '[fm.liveswitch.HttpWebRequestSender]' + ',' + _super.prototype.getTypeString.call(this);
            };
            HttpWebRequestSender.prototype.fmliveswitchHttpWebRequestSenderInit = function () {
                this.__disableJsonp = false;
                this.__forceJsonp = false;
                this._disableCors = false;
                this._disablePostMessage = false;
            };
            /**
            Gets a value indicating whether to disable the cross-origin resource sharing (CORS) transport.
            */
            HttpWebRequestSender.prototype.getDisableCors = function () {
                if (arguments.length == 0) {
                    return this._disableCors;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether to disable the JSON-P transport.
            */
            HttpWebRequestSender.prototype.getDisableJsonp = function () {
                if (arguments.length == 0) {
                    return this.__disableJsonp;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether to disable the postMessage transport.
            */
            HttpWebRequestSender.prototype.getDisablePostMessage = function () {
                if (arguments.length == 0) {
                    return this._disablePostMessage;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether to force the JSON-P transport.
            */
            HttpWebRequestSender.prototype.getForceJsonp = function () {
                if (arguments.length == 0) {
                    return this.__forceJsonp;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a value indicating whether to disable the cross-origin resource sharing (CORS) transport.
            */
            HttpWebRequestSender.prototype.setDisableCors = function (value) {
                if (arguments.length == 1) {
                    this._disableCors = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a value indicating whether to disable the JSON-P transport.
            */
            HttpWebRequestSender.prototype.setDisableJsonp = function (value) {
                if (arguments.length == 1) {
                    this.__disableJsonp = value;
                    if (this.__disableJsonp) {
                        this.__forceJsonp = false;
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a value indicating whether to disable the postMessage transport.
            */
            HttpWebRequestSender.prototype.setDisablePostMessage = function (value) {
                if (arguments.length == 1) {
                    this._disablePostMessage = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a value indicating whether to force the JSON-P transport.
            */
            HttpWebRequestSender.prototype.setForceJsonp = function (value) {
                if (arguments.length == 1) {
                    this.__forceJsonp = value;
                    if (this.__forceJsonp) {
                        this.__disableJsonp = false;
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return HttpWebRequestSender;
        }(fm.liveswitch.Dynamic));
        liveswitch.HttpWebRequestSender = HttpWebRequestSender;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Class to hold an integer value passed by reference.
        */
        var IntegerHolder = /** @class */ (function () {
            function IntegerHolder() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchIntegerHolderInit();
                }
                else if (__arguments.length == 1) {
                    var value = __arguments[0];
                    //super();
                    this.fmliveswitchIntegerHolderInit();
                    this.setValue(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            IntegerHolder.prototype.getTypeString = function () {
                return '[fm.liveswitch.IntegerHolder]';
            };
            IntegerHolder.prototype.fmliveswitchIntegerHolderInit = function () {
                this._value = 0;
            };
            /**
            Gets the value.
            */
            IntegerHolder.prototype.getValue = function () {
                if (arguments.length == 0) {
                    return this._value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the value.
            */
            IntegerHolder.prototype.setValue = function (value) {
                if (arguments.length == 1) {
                    this._value = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return IntegerHolder;
        }());
        liveswitch.IntegerHolder = IntegerHolder;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var JsonChecker = /** @class */ (function () {
            function JsonChecker() {
                fm.liveswitch.JsonChecker.fmliveswitchJsonCheckerInitialize();
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    // chained constructor: JsonChecker.call(this, 0);
                    __arguments = new Array(1);
                    __arguments[0] = 0;
                    {
                        var depth = __arguments[0];
                        //super();
                        this.fmliveswitchJsonCheckerInit();
                        if ((depth < 0)) {
                            throw new fm.liveswitch.Exception("Invalid depth.");
                        }
                        this.__state = 0;
                        this.__depth = depth;
                        this.__stack = new fm.liveswitch.Stack(depth);
                        this.push(fm.liveswitch.JsonCheckerMode.Done);
                    }
                }
                else if (__arguments.length == 1) {
                    var depth = __arguments[0];
                    //super();
                    this.fmliveswitchJsonCheckerInit();
                    if ((depth < 0)) {
                        throw new fm.liveswitch.Exception("Invalid depth.");
                    }
                    this.__state = 0;
                    this.__depth = depth;
                    this.__stack = new fm.liveswitch.Stack(depth);
                    this.push(fm.liveswitch.JsonCheckerMode.Done);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            JsonChecker.prototype.getTypeString = function () {
                return '[fm.liveswitch.JsonChecker]';
            };
            JsonChecker.prototype.fmliveswitchJsonCheckerInit = function () {
                this.__depth = 0;
                this.__offset = 0;
                this.__state = 0;
            };
            /** @hidden */
            JsonChecker.prototype.check = function (ch) {
                if (arguments.length == 1) {
                    var num = void 0;
                    if ((ch < 0)) {
                        this.onError();
                    }
                    if ((ch >= 128)) {
                        num = 30;
                    }
                    else {
                        num = fm.liveswitch.JsonChecker.fm_liveswitch_JsonChecker__ascii_class[ch];
                        if ((num <= -1)) {
                            this.onError();
                        }
                    }
                    var num2 = fm.liveswitch.JsonChecker.fm_liveswitch_JsonChecker__state_transition_table[this.__state][num];
                    if ((num2 >= 0)) {
                        this.__state = num2;
                        this.__offset = (this.__offset + 1);
                    }
                    else {
                        if ((fm.liveswitch.Global.equals(num2, -9))) {
                            this.pop(fm.liveswitch.JsonCheckerMode.Key);
                            this.__state = 1;
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(num2, -8))) {
                                this.pop(fm.liveswitch.JsonCheckerMode.Object);
                                this.__state = 1;
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(num2, -7))) {
                                    this.pop(fm.liveswitch.JsonCheckerMode.Array);
                                    this.__state = 1;
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(num2, -6))) {
                                        this.push(fm.liveswitch.JsonCheckerMode.Key);
                                        this.__state = 2;
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(num2, -5))) {
                                            this.push(fm.liveswitch.JsonCheckerMode.Array);
                                            this.__state = 6;
                                        }
                                        else {
                                            var mode = void 0;
                                            if ((fm.liveswitch.Global.equals(num2, -4))) {
                                                mode = this.__stack.peek();
                                                if ((fm.liveswitch.Global.equals(mode, fm.liveswitch.JsonCheckerMode.Key))) {
                                                    this.__state = 4;
                                                }
                                                else {
                                                    if (((fm.liveswitch.Global.equals(mode, fm.liveswitch.JsonCheckerMode.Array)) || (fm.liveswitch.Global.equals(mode, fm.liveswitch.JsonCheckerMode.Object)))) {
                                                        this.__state = 1;
                                                    }
                                                    else {
                                                        if ((fm.liveswitch.Global.equals(mode, fm.liveswitch.JsonCheckerMode.Done))) {
                                                            this.push(fm.liveswitch.JsonCheckerMode.String);
                                                            this.__state = 7;
                                                        }
                                                        else {
                                                            if ((fm.liveswitch.Global.equals(mode, fm.liveswitch.JsonCheckerMode.String))) {
                                                                this.pop(fm.liveswitch.JsonCheckerMode.String);
                                                                this.__state = 1;
                                                            }
                                                            else {
                                                                this.onError();
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                if ((fm.liveswitch.Global.equals(num2, -3))) {
                                                    mode = this.__stack.peek();
                                                    if ((fm.liveswitch.Global.equals(mode, fm.liveswitch.JsonCheckerMode.Object))) {
                                                        this.pop(fm.liveswitch.JsonCheckerMode.Object);
                                                        this.push(fm.liveswitch.JsonCheckerMode.Key);
                                                        this.__state = 3;
                                                    }
                                                    else {
                                                        if ((fm.liveswitch.Global.equals(mode, fm.liveswitch.JsonCheckerMode.Array))) {
                                                            this.__state = 5;
                                                        }
                                                        else {
                                                            this.onError();
                                                        }
                                                    }
                                                }
                                                else {
                                                    if ((fm.liveswitch.Global.equals(num2, -2))) {
                                                        this.pop(fm.liveswitch.JsonCheckerMode.Key);
                                                        this.push(fm.liveswitch.JsonCheckerMode.Object);
                                                        this.__state = 5;
                                                    }
                                                    else {
                                                        this.onError();
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        this.__offset = (this.__offset + 1);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            JsonChecker.prototype.checkString = function (str) {
                if (arguments.length == 1) {
                    var doubleResult = 0;
                    var decimalResult = 0;
                    var _var0 = new fm.liveswitch.Holder(doubleResult);
                    var _var1 = fm.liveswitch.ParseAssistant.tryParseDoubleValue(str, _var0);
                    doubleResult = _var0.getValue();
                    var _var2 = new fm.liveswitch.Holder(decimalResult);
                    var _var3 = fm.liveswitch.ParseAssistant.tryParseDecimalValue(str, _var2);
                    decimalResult = _var2.getValue();
                    if (((((fm.liveswitch.Global.equals(str, "true")) || (fm.liveswitch.Global.equals(str, "false"))) || ((fm.liveswitch.Global.equals(str, "null")) || _var1)) || _var3)) {
                        return true;
                    }
                    try {
                        for (var i = 0; (i < fm.liveswitch.StringExtensions.getLength(str)); i++) {
                            this.check(str.charCodeAt(i));
                        }
                        this.finalCheck();
                        return true;
                    }
                    catch (exception1) {
                        return false;
                    }
                    finally {
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            JsonChecker.prototype.finalCheck = function () {
                if (arguments.length == 0) {
                    if ((!fm.liveswitch.Global.equals(this.__state, 1))) {
                        this.onError();
                    }
                    this.pop(fm.liveswitch.JsonCheckerMode.Done);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            JsonChecker.prototype.onError = function () {
                if (arguments.length == 0) {
                    throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Invalid JSON text at character offset {0}.", fm.liveswitch.NumberExtensions.toString(this.__offset, "N0")));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            JsonChecker.prototype.pop = function (mode) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(this.__stack.pop(), mode))) {
                        this.onError();
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            JsonChecker.prototype.push = function (mode) {
                if (arguments.length == 1) {
                    if (((this.__depth > 0) && (this.__stack.getCount() >= this.__depth))) {
                        this.onError();
                    }
                    this.__stack.push(mode);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            JsonChecker.fmliveswitchJsonCheckerInitialize = function () {
                if (!fm.liveswitch.JsonChecker.__fmliveswitchJsonCheckerInitialized && !fm.liveswitch.JsonChecker.__fmliveswitchJsonCheckerInitializing) {
                    fm.liveswitch.JsonChecker.__fmliveswitchJsonCheckerInitializing = true;
                    fm.liveswitch.JsonChecker.fm_liveswitch_JsonChecker__ascii_class = [-1, -1, -1, -1, -1, -1, -1, -1, -1, 1, 1, -1, -1, 1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 0, 30, 8, 30, 30, 30, 30, 30, 30, 30, 30, 11, 7, 12, 13, 10, 14, 15, 15, 15, 15, 15, 15, 15, 15, 15, 6, 30, 30, 30, 30, 30, 30, 28, 28, 28, 28, 29, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 4, 9, 5, 30, 30, 30, 16, 17, 18, 19, 20, 21, 30, 30, 30, 30, 30, 22, 30, 23, 30, 30, 30, 24, 25, 26, 27, 30, 30, 30, 30, 30, 2, 30, 3, 30, 30];
                    fm.liveswitch.JsonChecker.fm_liveswitch_JsonChecker__state_transition_table = [[0, 0, -6, -1, -5, -1, -1, -1, -4, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1], [1, 1, -1, -8, -1, -7, -1, -3, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1], [2, 2, -1, -9, -1, -1, -1, -1, 7, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1], [3, 3, -1, -1, -1, -1, -1, -1, 7, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1], [4, 4, -1, -1, -1, -1, -2, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1], [5, 5, -6, -1, -5, -1, -1, -1, 7, -1, -1, -1, 13, -1, 14, 15, -1, -1, -1, -1, -1, 23, -1, 27, -1, -1, 20, -1, -1, -1, -1], [6, 6, -6, -1, -5, -7, -1, -1, 7, -1, -1, -1, 13, -1, 14, 15, -1, -1, -1, -1, -1, 23, -1, 27, -1, -1, 20, -1, -1, -1, -1], [7, -1, 7, 7, 7, 7, 7, 7, -4, 8, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7], [-1, -1, -1, -1, -1, -1, -1, -1, 7, 7, 7, -1, -1, -1, -1, -1, -1, 7, -1, -1, -1, 7, -1, 7, 7, -1, 7, 9, -1, -1, -1], [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 10, 10, 10, 10, 10, 10, 10, 10, -1, -1, -1, -1, -1, -1, 10, 10, -1], [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 11, 11, 11, 11, 11, 11, 11, 11, -1, -1, -1, -1, -1, -1, 11, 11, -1], [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 12, 12, 12, 12, 12, 12, 12, 12, -1, -1, -1, -1, -1, -1, 12, 12, -1], [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 7, 7, 7, 7, 7, 7, 7, 7, -1, -1, -1, -1, -1, -1, 7, 7, -1], [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 14, 15, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1], [1, 1, -1, -8, -1, -7, -1, -3, -1, -1, -1, -1, -1, 16, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1], [1, 1, -1, -8, -1, -7, -1, -3, -1, -1, -1, -1, -1, 16, 15, 15, -1, -1, -1, -1, 17, -1, -1, -1, -1, -1, -1, -1, -1, 17, -1], [1, 1, -1, -8, -1, -7, -1, -3, -1, -1, -1, -1, -1, -1, 16, 16, -1, -1, -1, -1, 17, -1, -1, -1, -1, -1, -1, -1, -1, 17, -1], [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 18, 18, -1, 19, 19, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1], [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 19, 19, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1], [1, 1, -1, -8, -1, -7, -1, -3, -1, -1, -1, -1, -1, -1, 19, 19, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1], [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 21, -1, -1, -1, -1, -1, -1], [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 22, -1, -1, -1], [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1], [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 24, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1], [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 25, -1, -1, -1, -1, -1, -1, -1, -1], [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 26, -1, -1, -1, -1, -1], [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1], [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 28, -1, -1, -1], [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 29, -1, -1, -1, -1, -1, -1, -1, -1], [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 1, -1, -1, -1, -1, -1, -1, -1, -1]];
                    fm.liveswitch.JsonChecker.__fmliveswitchJsonCheckerInitialized = true;
                    fm.liveswitch.JsonChecker.__fmliveswitchJsonCheckerInitializing = false;
                }
            };
            /** @hidden */
            JsonChecker.__fmliveswitchJsonCheckerInitialized = false;
            /** @hidden */
            JsonChecker.__fmliveswitchJsonCheckerInitializing = false;
            return JsonChecker;
        }());
        liveswitch.JsonChecker = JsonChecker;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Base class for all JSON provider implementations.
        */
        var JsonProvider = /** @class */ (function () {
            function JsonProvider() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            JsonProvider.prototype.getTypeString = function () {
                return '[fm.liveswitch.JsonProvider]';
            };
            return JsonProvider;
        }());
        liveswitch.JsonProvider = JsonProvider;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Thread-safe class providing access to a single [[fm.liveswitch.lockedRandomizer.Randomizer]].
        */
        var LockedRandomizer = /** @class */ (function () {
            function LockedRandomizer() {
            }
            LockedRandomizer.prototype.getTypeString = function () {
                return '[fm.liveswitch.LockedRandomizer]';
            };
            LockedRandomizer.next = function () {
                fm.liveswitch.LockedRandomizer.fmliveswitchLockedRandomizerInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.LockedRandomizer.fm_liveswitch_LockedRandomizer__randomizer.next();
                }
                else if (arguments.length == 1) {
                    var maxValue = arguments[0];
                    return fm.liveswitch.LockedRandomizer.fm_liveswitch_LockedRandomizer__randomizer.next(maxValue);
                }
                else if (arguments.length == 2) {
                    var minValue = arguments[0];
                    var maxValue = arguments[1];
                    return fm.liveswitch.LockedRandomizer.fm_liveswitch_LockedRandomizer__randomizer.next(minValue, maxValue);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Fills the elements of a specified array of bytes with random numbers.
            @param buffer The array of bytes to fill.
            */
            LockedRandomizer.nextBytes = function (buffer) {
                fm.liveswitch.LockedRandomizer.fmliveswitchLockedRandomizerInitialize();
                if (arguments.length == 1) {
                    fm.liveswitch.LockedRandomizer.fm_liveswitch_LockedRandomizer__randomizer.nextBytes(buffer);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Returns a random number between 0.0 and 1.0.
            */
            LockedRandomizer.nextDouble = function () {
                fm.liveswitch.LockedRandomizer.fmliveswitchLockedRandomizerInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.LockedRandomizer.fm_liveswitch_LockedRandomizer__randomizer.nextDouble();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Returns a nonnegative random number.
            */
            LockedRandomizer.nextLong = function () {
                fm.liveswitch.LockedRandomizer.fmliveswitchLockedRandomizerInitialize();
                if (arguments.length == 0) {
                    return (fm.liveswitch.LockedRandomizer.fm_liveswitch_LockedRandomizer__randomizer.nextDouble() * 9.22337203685478e+18);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Generates a random string of a specified size.
            @param size The size of the output string.
            */
            LockedRandomizer.randomString = function (size) {
                fm.liveswitch.LockedRandomizer.fmliveswitchLockedRandomizerInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.LockedRandomizer.fm_liveswitch_LockedRandomizer__randomizer.randomString(size);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LockedRandomizer.fmliveswitchLockedRandomizerInitialize = function () {
                if (!fm.liveswitch.LockedRandomizer.__fmliveswitchLockedRandomizerInitialized && !fm.liveswitch.LockedRandomizer.__fmliveswitchLockedRandomizerInitializing) {
                    fm.liveswitch.LockedRandomizer.__fmliveswitchLockedRandomizerInitializing = true;
                    fm.liveswitch.LockedRandomizer.fm_liveswitch_LockedRandomizer__randomizer = new fm.liveswitch.Randomizer();
                    fm.liveswitch.LockedRandomizer.fm_liveswitch_LockedRandomizer__randomLock = new Object();
                    fm.liveswitch.LockedRandomizer.__fmliveswitchLockedRandomizerInitialized = true;
                    fm.liveswitch.LockedRandomizer.__fmliveswitchLockedRandomizerInitializing = false;
                }
            };
            /** @hidden */
            LockedRandomizer.__fmliveswitchLockedRandomizerInitialized = false;
            /** @hidden */
            LockedRandomizer.__fmliveswitchLockedRandomizerInitializing = false;
            return LockedRandomizer;
        }());
        liveswitch.LockedRandomizer = LockedRandomizer;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Log utility class.
        */
        var Log = /** @class */ (function () {
            function Log() {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Log.prototype.getTypeString = function () {
                return '[fm.liveswitch.Log]';
            };
            Log.addProvider = function () {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 1) {
                    var provider = arguments[0];
                    fm.liveswitch.Log.registerProvider(provider);
                }
                else if (arguments.length == 2) {
                    var provider = arguments[0];
                    var level = arguments[1];
                    fm.liveswitch.Log.registerProvider(provider, level);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Log.debug = function () {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 1) {
                    var message = arguments[0];
                    fm.liveswitch.Log.fm_liveswitch_Log___staticLogger.debug(message);
                }
                else if (arguments.length == 2) {
                    var message = arguments[0];
                    var ex = arguments[1];
                    fm.liveswitch.Log.fm_liveswitch_Log___staticLogger.debug(message, ex);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Log.error = function () {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 1) {
                    var message = arguments[0];
                    fm.liveswitch.Log.fm_liveswitch_Log___staticLogger.error(message);
                }
                else if (arguments.length == 2) {
                    var message = arguments[0];
                    var ex = arguments[1];
                    fm.liveswitch.Log.fm_liveswitch_Log___staticLogger.error(message, ex);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Log.fatal = function () {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 1) {
                    var message = arguments[0];
                    fm.liveswitch.Log.fm_liveswitch_Log___staticLogger.fatal(message);
                }
                else if (arguments.length == 2) {
                    var message = arguments[0];
                    var ex = arguments[1];
                    fm.liveswitch.Log.fm_liveswitch_Log___staticLogger.fatal(message, ex);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Blocks until all logs are written out.
            */
            Log.flush = function () {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 0) {
                    fm.liveswitch.Log.fm_liveswitch_Log___staticLogger.flush();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether logging is enabled for debug-level messages.
            */
            Log.getIsDebugEnabled = function () {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 0) {
                    return (fm.liveswitch.LogConfiguration.getDefaultLogLevel() <= fm.liveswitch.LogLevel.Debug);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether logging is enabled for error-level messages.
            */
            Log.getIsErrorEnabled = function () {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 0) {
                    return (fm.liveswitch.LogConfiguration.getDefaultLogLevel() <= fm.liveswitch.LogLevel.Error);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether logging is enabled for fatal-level messages.
            */
            Log.getIsFatalEnabled = function () {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 0) {
                    return (fm.liveswitch.LogConfiguration.getDefaultLogLevel() <= fm.liveswitch.LogLevel.Fatal);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether logging is enabled for info-level messages.
            */
            Log.getIsInfoEnabled = function () {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 0) {
                    return (fm.liveswitch.LogConfiguration.getDefaultLogLevel() <= fm.liveswitch.LogLevel.Info);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether logging is enabled for verbose-level messages.
            */
            Log.getIsVerboseEnabled = function () {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 0) {
                    return (fm.liveswitch.LogConfiguration.getDefaultLogLevel() <= fm.liveswitch.LogLevel.Verbose);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether logging is enabled for warn-level messages.
            */
            Log.getIsWarnEnabled = function () {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 0) {
                    return (fm.liveswitch.LogConfiguration.getDefaultLogLevel() <= fm.liveswitch.LogLevel.Warn);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Log.getLogger = function () {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                    var tag = arguments[0];
                    return new fm.liveswitch.AsyncLogger(tag);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                    var tag = arguments[0];
                    var level = arguments[1];
                    fm.liveswitch.LogConfiguration.setTagLogLevel(tag, level);
                    return fm.liveswitch.Log.getLogger(tag);
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.Type]'))) {
                    var type = arguments[0];
                    return fm.liveswitch.Log.getLogger(type.getFullName());
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.Type]'))) {
                    var type = arguments[0];
                    var level = arguments[1];
                    return fm.liveswitch.Log.getLogger(type.getFullName(), level);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the default log level.
            */
            Log.getLogLevel = function () {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.LogConfiguration.getDefaultLogLevel();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the first log provider.
            */
            Log.getProvider = function () {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 0) {
                    var logProviders = fm.liveswitch.LogConfiguration.getLogProviders();
                    return ((logProviders.length > 0) ? logProviders[0] : null);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the log providers.
            */
            Log.getProviders = function () {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.LogConfiguration.getLogProviders();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Log.info = function () {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 1) {
                    var message = arguments[0];
                    fm.liveswitch.Log.fm_liveswitch_Log___staticLogger.info(message);
                }
                else if (arguments.length == 2) {
                    var message = arguments[0];
                    var ex = arguments[1];
                    fm.liveswitch.Log.fm_liveswitch_Log___staticLogger.info(message, ex);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Log.registerProvider = function () {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 1) {
                    var provider = arguments[0];
                    fm.liveswitch.LogConfiguration.addLogProvider(provider);
                    if ((provider.getLevel() < fm.liveswitch.LogConfiguration.getDefaultLogLevel())) {
                        fm.liveswitch.LogConfiguration.setDefaultLogLevel(provider.getLevel());
                    }
                }
                else if (arguments.length == 2) {
                    var provider = arguments[0];
                    var level = arguments[1];
                    provider.setLevel(level);
                    fm.liveswitch.Log.registerProvider(provider);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Unregisters a log provider as a logging target. Alias for UnregisterProvider.
            @param provider The provider.
            */
            Log.removeProvider = function (provider) {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.Log.unregisterProvider(provider);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Unregisters all log providers as logging targets. Alias for UnregisterProviders.
            */
            Log.removeProviders = function () {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 0) {
                    fm.liveswitch.Log.unregisterProviders();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the default log level.
            */
            Log.setLogLevel = function (value) {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 1) {
                    fm.liveswitch.LogConfiguration.setDefaultLogLevel(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the first log provider.
            */
            Log.setProvider = function (value) {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 1) {
                    fm.liveswitch.LogConfiguration.clearLogProviders();
                    fm.liveswitch.Log.registerProvider(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Override the default log level for a specific tag.
            @param tag The Tag to set the log level to.
            @param level The new loglevel to use.
            */
            Log.setTagOverride = function (tag, level) {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 2) {
                    fm.liveswitch.LogConfiguration.setTagLogLevel(tag, level);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Unregisters a log provider as a logging target.
            @param provider The provider.
            */
            Log.unregisterProvider = function (provider) {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.LogConfiguration.removeLogProvider(provider);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Unregisters all log providers as logging targets.
            */
            Log.unregisterProviders = function () {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 0) {
                    fm.liveswitch.LogConfiguration.clearLogProviders();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Log.verbose = function () {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 1) {
                    var message = arguments[0];
                    fm.liveswitch.Log.fm_liveswitch_Log___staticLogger.verbose(message);
                }
                else if (arguments.length == 2) {
                    var message = arguments[0];
                    var ex = arguments[1];
                    fm.liveswitch.Log.fm_liveswitch_Log___staticLogger.verbose(message, ex);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Log.warn = function () {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 1) {
                    var message = arguments[0];
                    fm.liveswitch.Log.fm_liveswitch_Log___staticLogger.warn(message);
                }
                else if (arguments.length == 2) {
                    var message = arguments[0];
                    var ex = arguments[1];
                    fm.liveswitch.Log.fm_liveswitch_Log___staticLogger.warn(message, ex);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes a line of text to the log.
            @param text The text to write to the log.
            */
            Log.writeLine = function (text) {
                fm.liveswitch.Log.fmliveswitchLogInitialize();
                if (arguments.length == 1) {
                    fm.liveswitch.Log.fm_liveswitch_Log___staticLogger.log(text);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Log.fmliveswitchLogInitialize = function () {
                if (!fm.liveswitch.Log.__fmliveswitchLogInitialized && !fm.liveswitch.Log.__fmliveswitchLogInitializing) {
                    fm.liveswitch.Log.__fmliveswitchLogInitializing = true;
                    fm.liveswitch.Log.fm_liveswitch_Log___staticLogger = new fm.liveswitch.AsyncLogger("FM");
                    fm.liveswitch.Log.__fmliveswitchLogInitialized = true;
                    fm.liveswitch.Log.__fmliveswitchLogInitializing = false;
                }
            };
            /** @hidden */
            Log.__fmliveswitchLogInitialized = false;
            /** @hidden */
            Log.__fmliveswitchLogInitializing = false;
            return Log;
        }());
        liveswitch.Log = Log;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var LogConfiguration = /** @class */ (function () {
            function LogConfiguration() {
                fm.liveswitch.LogConfiguration.fmliveswitchLogConfigurationInitialize();
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            LogConfiguration.prototype.getTypeString = function () {
                return '[fm.liveswitch.LogConfiguration]';
            };
            LogConfiguration.addLogProvider = function (provider) {
                fm.liveswitch.LogConfiguration.fmliveswitchLogConfigurationInitialize();
                if (arguments.length == 1) {
                    var list = fm.liveswitch.ArrayExtensions.newArray(fm.liveswitch.LogConfiguration.fm_liveswitch_LogConfiguration___logProviders);
                    fm.liveswitch.ArrayExtensions.add(list, provider);
                    fm.liveswitch.LogConfiguration.fm_liveswitch_LogConfiguration___providerCount++;
                    fm.liveswitch.LogConfiguration.fm_liveswitch_LogConfiguration___logProviders = fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            LogConfiguration.clearLogProviders = function () {
                fm.liveswitch.LogConfiguration.fmliveswitchLogConfigurationInitialize();
                if (arguments.length == 0) {
                    fm.liveswitch.LogConfiguration.fm_liveswitch_LogConfiguration___logProviders = new Array(0);
                    fm.liveswitch.LogConfiguration.fm_liveswitch_LogConfiguration___providerCount = 0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            LogConfiguration.getDefaultLogLevel = function () {
                fm.liveswitch.LogConfiguration.fmliveswitchLogConfigurationInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.LogConfiguration.fm_liveswitch_LogConfiguration__defaultLogLevel;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            LogConfiguration.getHasProviders = function () {
                fm.liveswitch.LogConfiguration.fmliveswitchLogConfigurationInitialize();
                if (arguments.length == 0) {
                    return (fm.liveswitch.LogConfiguration.fm_liveswitch_LogConfiguration___providerCount > 0);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            LogConfiguration.getLogProviders = function () {
                fm.liveswitch.LogConfiguration.fmliveswitchLogConfigurationInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.LogConfiguration.fm_liveswitch_LogConfiguration___logProviders;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            LogConfiguration.getTagLogLevel = function (tag) {
                fm.liveswitch.LogConfiguration.fmliveswitchLogConfigurationInitialize();
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(tag, null))) {
                        if (fm.liveswitch.HashExtensions.containsKey(fm.liveswitch.LogConfiguration.fm_liveswitch_LogConfiguration___tagOverrides, tag)) {
                            return fm.liveswitch.LogConfiguration.fm_liveswitch_LogConfiguration___tagOverrides[tag];
                        }
                    }
                    return fm.liveswitch.LogConfiguration.getDefaultLogLevel();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            LogConfiguration.removeLogProvider = function (provider) {
                fm.liveswitch.LogConfiguration.fmliveswitchLogConfigurationInitialize();
                if (arguments.length == 1) {
                    var list = fm.liveswitch.ArrayExtensions.newArray(fm.liveswitch.LogConfiguration.fm_liveswitch_LogConfiguration___logProviders);
                    if (!fm.liveswitch.ArrayExtensions.remove(list, provider)) {
                        return false;
                    }
                    fm.liveswitch.LogConfiguration.fm_liveswitch_LogConfiguration___providerCount--;
                    fm.liveswitch.LogConfiguration.fm_liveswitch_LogConfiguration___logProviders = fm.liveswitch.ArrayExtensions.toArray(list);
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            LogConfiguration.setDefaultLogLevel = function (value) {
                fm.liveswitch.LogConfiguration.fmliveswitchLogConfigurationInitialize();
                if (arguments.length == 1) {
                    fm.liveswitch.LogConfiguration.fm_liveswitch_LogConfiguration__defaultLogLevel = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            LogConfiguration.setTagLogLevel = function (tag, logLevel) {
                fm.liveswitch.LogConfiguration.fmliveswitchLogConfigurationInitialize();
                if (arguments.length == 2) {
                    if ((!fm.liveswitch.Global.equals(tag, null))) {
                        fm.liveswitch.LogConfiguration.fm_liveswitch_LogConfiguration___tagOverrides[tag] = logLevel;
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LogConfiguration.fmliveswitchLogConfigurationInitialize = function () {
                if (!fm.liveswitch.LogConfiguration.__fmliveswitchLogConfigurationInitialized && !fm.liveswitch.LogConfiguration.__fmliveswitchLogConfigurationInitializing) {
                    fm.liveswitch.LogConfiguration.__fmliveswitchLogConfigurationInitializing = true;
                    LogConfiguration.fm_liveswitch_LogConfiguration___providerCount = 0;
                    fm.liveswitch.LogConfiguration.fm_liveswitch_LogConfiguration___lock = new Object();
                    fm.liveswitch.LogConfiguration.fm_liveswitch_LogConfiguration___tagOverridesLock = new Object();
                    fm.liveswitch.LogConfiguration.fm_liveswitch_LogConfiguration___logProviders = new Array(0);
                    fm.liveswitch.LogConfiguration.fm_liveswitch_LogConfiguration___tagOverrides = {};
                    fm.liveswitch.LogConfiguration.setDefaultLogLevel(fm.liveswitch.LogLevel.Info);
                    fm.liveswitch.LogConfiguration.__fmliveswitchLogConfigurationInitialized = true;
                    fm.liveswitch.LogConfiguration.__fmliveswitchLogConfigurationInitializing = false;
                }
            };
            /** @hidden */
            LogConfiguration.__fmliveswitchLogConfigurationInitialized = false;
            /** @hidden */
            LogConfiguration.__fmliveswitchLogConfigurationInitializing = false;
            return LogConfiguration;
        }());
        liveswitch.LogConfiguration = LogConfiguration;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var LogLevelWrapper = /** @class */ (function () {
            function LogLevelWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_15 = __arguments[0];
                    //super();
                    this._value = value_15;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            LogLevelWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.LogLevelWrapper]';
            };
            LogLevelWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.LogLevel.Verbose)
                        return 'Verbose';
                    if (this._value == fm.liveswitch.LogLevel.Debug)
                        return 'Debug';
                    if (this._value == fm.liveswitch.LogLevel.Info)
                        return 'Info';
                    if (this._value == fm.liveswitch.LogLevel.Warn)
                        return 'Warn';
                    if (this._value == fm.liveswitch.LogLevel.Error)
                        return 'Error';
                    if (this._value == fm.liveswitch.LogLevel.Fatal)
                        return 'Fatal';
                    if (this._value == fm.liveswitch.LogLevel.None)
                        return 'None';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return LogLevelWrapper;
        }());
        liveswitch.LogLevelWrapper = LogLevelWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Class to hold a long value passed by reference.
        */
        var LongHolder = /** @class */ (function () {
            function LongHolder() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchLongHolderInit();
                }
                else if (__arguments.length == 1) {
                    var value = __arguments[0];
                    //super();
                    this.fmliveswitchLongHolderInit();
                    this.setValue(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            LongHolder.prototype.getTypeString = function () {
                return '[fm.liveswitch.LongHolder]';
            };
            LongHolder.prototype.fmliveswitchLongHolderInit = function () {
                this._value = 0;
            };
            /**
            Gets the value.
            */
            LongHolder.prototype.getValue = function () {
                if (arguments.length == 0) {
                    return this._value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the value.
            */
            LongHolder.prototype.setValue = function (value) {
                if (arguments.length == 1) {
                    this._value = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return LongHolder;
        }());
        liveswitch.LongHolder = LongHolder;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="JsonProvider.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        An implementation of a JSON provider that does nothing.
        */
        var NullJsonProvider = /** @class */ (function (_super) {
            __extends(NullJsonProvider, _super);
            function NullJsonProvider() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            NullJsonProvider.prototype.getTypeString = function () {
                return '[fm.liveswitch.NullJsonProvider]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Deserializes a value from a JSON string.
            @param valueJson The JSON string to deserialize.
            @return
                        The deserialized value.
                
            */
            NullJsonProvider.prototype.deserialize = function (valueJson) {
                if (arguments.length == 1) {
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a value to a JSON string.
            @param value The value to serialize.
            @return
                        The serialized JSON string.
                
            */
            NullJsonProvider.prototype.serialize = function (value) {
                if (arguments.length == 1) {
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return NullJsonProvider;
        }(fm.liveswitch.JsonProvider));
        liveswitch.NullJsonProvider = NullJsonProvider;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="LogProvider.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        An implementation of a logging provider that does nothing.
        */
        var NullLogProvider = /** @class */ (function (_super) {
            __extends(NullLogProvider, _super);
            function NullLogProvider() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            NullLogProvider.prototype.getTypeString = function () {
                return '[fm.liveswitch.NullLogProvider]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Logs a message at the specified log level.
            @param logEvent The log event details.
            */
            NullLogProvider.prototype.doLog = function (logEvent) {
                if (arguments.length == 1) {
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return NullLogProvider;
        }(fm.liveswitch.LogProvider));
        liveswitch.NullLogProvider = NullLogProvider;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A data buffer pool.
        */
        var DataBufferPool = /** @class */ (function () {
            function DataBufferPool() {
                fm.liveswitch.DataBufferPool.fmliveswitchDataBufferPoolInitialize();
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    // chained constructor: DataBufferPool.call(this, new fm.liveswitch.Type('[fm.liveswitch.DataBufferPool]').getFullName());
                    __arguments = new Array(1);
                    __arguments[0] = new fm.liveswitch.Type('[fm.liveswitch.DataBufferPool]').getFullName();
                    {
                        var tag = __arguments[0];
                        //super();
                        this.fmliveswitchDataBufferPoolInit();
                        this._log = fm.liveswitch.Log.getLogger("DataBufferPool", fm.liveswitch.LogLevel.Info);
                        this.__blockSize = 128;
                        this.__traceStatistics = new fm.liveswitch.ManagedConcurrentDictionary();
                        this.__pools = new fm.liveswitch.ManagedConcurrentDictionary();
                        this.setEnableStatistics(false);
                        this.setStatistics(new fm.liveswitch.PoolStatistics(tag));
                    }
                }
                else if (__arguments.length == 1) {
                    var tag = __arguments[0];
                    //super();
                    this.fmliveswitchDataBufferPoolInit();
                    this._log = fm.liveswitch.Log.getLogger("DataBufferPool", fm.liveswitch.LogLevel.Info);
                    this.__blockSize = 128;
                    this.__traceStatistics = new fm.liveswitch.ManagedConcurrentDictionary();
                    this.__pools = new fm.liveswitch.ManagedConcurrentDictionary();
                    this.setEnableStatistics(false);
                    this.setStatistics(new fm.liveswitch.PoolStatistics(tag));
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            DataBufferPool.prototype.getTypeString = function () {
                return '[fm.liveswitch.DataBufferPool]';
            };
            DataBufferPool.prototype.fmliveswitchDataBufferPoolInit = function () {
                this.__blockSize = 0;
                this._disabled = false;
                this._enableStatistics = false;
            };
            /**
            Gets the singleton instance.
            */
            DataBufferPool.getInstance = function () {
                fm.liveswitch.DataBufferPool.fmliveswitchDataBufferPoolInitialize();
                if (arguments.length == 0) {
                    if ((fm.liveswitch.Global.equals(fm.liveswitch.DataBufferPool.fm_liveswitch_DataBufferPool___singleton, null))) {
                        fm.liveswitch.DataBufferPool.fm_liveswitch_DataBufferPool___singleton = new fm.liveswitch.DataBufferPool();
                    }
                    return fm.liveswitch.DataBufferPool.fm_liveswitch_DataBufferPool___singleton;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether DataBuffer pooling is supported on this platform.
            */
            DataBufferPool.getIsSupported = function () {
                fm.liveswitch.DataBufferPool.fmliveswitchDataBufferPoolInitialize();
                if (arguments.length == 0) {
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBufferPool.getTracer = function () {
                fm.liveswitch.DataBufferPool.fmliveswitchDataBufferPoolInitialize();
                if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                    var tag = arguments[0];
                    return fm.liveswitch.DataBufferPool.getTracer(tag, fm.liveswitch.DataBufferPool.getInstance());
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                    var tag = arguments[0];
                    var pool = arguments[1];
                    return new fm.liveswitch.DataBufferPoolTracer(tag, pool);
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.Type]'))) {
                    var type = arguments[0];
                    return fm.liveswitch.DataBufferPool.getTracer(type.getFullName());
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.Type]'))) {
                    var type = arguments[0];
                    var pool = arguments[1];
                    return fm.liveswitch.DataBufferPool.getTracer(type.getFullName(), pool);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataBufferPool.prototype.createStack = function (tagStatistics) {
                if (arguments.length == 1) {
                    if (this.getEnableStatistics()) {
                        this.getStatistics().__creates.increment();
                        if ((!fm.liveswitch.Global.equals(tagStatistics, null))) {
                            tagStatistics.__creates.increment();
                        }
                    }
                    return new fm.liveswitch.ManagedConcurrentStack();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataBufferPool.prototype.createTraceStatistics = function (tag) {
                if (arguments.length == 1) {
                    return new fm.liveswitch.PoolStatistics(tag);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataBufferPool.prototype.doTraceTake = function (size, littleEndian, clearBytes, tag, tagStatistics) {
                var _this = this;
                if (arguments.length == 5) {
                    var valueFactory = null;
                    var key = this.padToBlock(size);
                    var orAdd = null;
                    var _var0 = new fm.liveswitch.Holder(orAdd);
                    var _var1 = this.__pools.tryGetValue(key, _var0);
                    orAdd = _var0.getValue();
                    if (!_var1) {
                        if ((fm.liveswitch.Global.equals(valueFactory, null))) {
                            valueFactory = function (s) {
                                return _this.createStack(tagStatistics);
                            };
                        }
                        orAdd = this.__pools.getOrAdd(key, valueFactory);
                    }
                    if (this.getEnableStatistics()) {
                        this.getStatistics().__paddingWasted.add((key - size));
                        if ((!fm.liveswitch.Global.equals(tagStatistics, null))) {
                            tagStatistics.__paddingWasted.add((key - size));
                        }
                    }
                    var result = null;
                    var _var2 = new fm.liveswitch.Holder(result);
                    var _var3 = orAdd.tryPop(_var2);
                    result = _var2.getValue();
                    if (_var3) {
                        if (clearBytes) {
                            fm.liveswitch.BitAssistant.set(result, 0, result.length, 0);
                        }
                        if (this.getEnableStatistics()) {
                            this.getStatistics().__hits.increment();
                            this.getStatistics().__takenSize.add(result.length);
                            this.getStatistics().__pendingPoolSize.subtract(result.length);
                            if ((!fm.liveswitch.Global.equals(tagStatistics, null))) {
                                tagStatistics.__hits.increment();
                                tagStatistics.__takenSize.add(result.length);
                                tagStatistics.__pendingPoolSize.subtract(result.length);
                            }
                        }
                        return new fm.liveswitch.DataBufferPooled(this, result, size, littleEndian, tag);
                    }
                    if (this.getEnableStatistics()) {
                        this.getStatistics().__misses.increment();
                        this.getStatistics().__takenSize.add(key);
                        this.getStatistics().__totalPoolSize.add(key);
                        if ((!fm.liveswitch.Global.equals(tagStatistics, null))) {
                            tagStatistics.__misses.increment();
                            tagStatistics.__takenSize.add(key);
                            tagStatistics.__totalPoolSize.add(key);
                        }
                    }
                    return new fm.liveswitch.DataBufferPooled(this, new Uint8Array(key), size, littleEndian, tag);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the block size.
            */
            DataBufferPool.prototype.getBlockSize = function () {
                if (arguments.length == 0) {
                    return this.__blockSize;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the pool is disabled. If disabled, each call to take a buffer will result in a new allocation.
            */
            DataBufferPool.prototype.getDisabled = function () {
                if (arguments.length == 0) {
                    return this._disabled;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether to enable statistics.
            */
            DataBufferPool.prototype.getEnableStatistics = function () {
                if (arguments.length == 0) {
                    return this._enableStatistics;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataBufferPool.prototype.getOrAddTraceStatistics = function (tag) {
                if (arguments.length == 1) {
                    var orAdd = null;
                    var _var0 = new fm.liveswitch.Holder(orAdd);
                    var _var1 = this.__traceStatistics.tryGetValue(tag, _var0);
                    orAdd = _var0.getValue();
                    if (!_var1) {
                        orAdd = this.__traceStatistics.getOrAdd(tag, this.createTraceStatistics.bind(this));
                    }
                    return orAdd;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the pool usage statistics.
            */
            DataBufferPool.prototype.getStatistics = function () {
                if (arguments.length == 0) {
                    return this._statistics;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBufferPool.prototype.getTraceStatistics = function () {
                if (arguments.length == 0) {
                    var values = this.__traceStatistics.getValues();
                    var statisticsArray = new Array(fm.liveswitch.ArrayExtensions.getCount(values));
                    var num = 0;
                    for (var _i = 0, values_4 = values; _i < values_4.length; _i++) {
                        var statistics = values_4[_i];
                        statisticsArray[num++] = statistics;
                    }
                    return statisticsArray;
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                    var tag = arguments[0];
                    if ((fm.liveswitch.Global.equals(tag, null))) {
                        return this.getStatistics();
                    }
                    var statistics = null;
                    var _var0 = new fm.liveswitch.Holder(statistics);
                    var _var1 = this.__traceStatistics.tryGetValue(tag, _var0);
                    statistics = _var0.getValue();
                    if (_var1) {
                        return statistics;
                    }
                    return null;
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.Type]'))) {
                    var type = arguments[0];
                    return this.getTraceStatistics(type.getFullName());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataBufferPool.prototype.padToBlock = function (size) {
                if (arguments.length == 1) {
                    var num = ((size + this.__blockSize) - 1);
                    return (num - (num & (this.__blockSize - 1)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataBufferPool.prototype.returnBuffer = function (buffer, tag) {
                if (arguments.length == 2) {
                    if (!this.getDisabled()) {
                        var orAddTraceStatistics = null;
                        if ((this.getEnableStatistics() && (!fm.liveswitch.Global.equals(tag, null)))) {
                            orAddTraceStatistics = this.getOrAddTraceStatistics(tag);
                        }
                        var num = buffer.decrementRetain();
                        if ((fm.liveswitch.Global.equals(num, 0))) {
                            var item = buffer.invalidate();
                            var stack = null;
                            var _var0 = new fm.liveswitch.Holder(stack);
                            var _var1 = this.__pools.tryGetValue(item.length, _var0);
                            stack = _var0.getValue();
                            if (!_var1) {
                                throw new fm.liveswitch.Exception("Cannot return a buffer to the pool that was not taken from the pool.");
                            }
                            stack.push(item);
                            if (this.getEnableStatistics()) {
                                this.getStatistics().__returnedSize.add(item.length);
                                this.getStatistics().__pendingPoolSize.add(item.length);
                                if ((!fm.liveswitch.Global.equals(orAddTraceStatistics, null))) {
                                    orAddTraceStatistics.__returnedSize.add(item.length);
                                    orAddTraceStatistics.__pendingPoolSize.add(item.length);
                                }
                            }
                        }
                        else {
                            if ((num < 0)) {
                                this._log.warn("Cannot return a buffer to the pool with a negative retain count.");
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataBufferPool.prototype.setBlockSize = function (value) {
                if (arguments.length == 1) {
                    this.__blockSize = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the pool is disabled. If disabled, each call to take a buffer will result in a new allocation.
            */
            DataBufferPool.prototype.setDisabled = function (value) {
                if (arguments.length == 1) {
                    this._disabled = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether to enable statistics.
            */
            DataBufferPool.prototype.setEnableStatistics = function (value) {
                if (arguments.length == 1) {
                    this._enableStatistics = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataBufferPool.prototype.setStatistics = function (value) {
                if (arguments.length == 1) {
                    this._statistics = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBufferPool.prototype.take = function () {
                if (arguments.length == 1) {
                    var size = arguments[0];
                    return this.traceTake(size, null);
                }
                else if (arguments.length == 2) {
                    var size = arguments[0];
                    var littleEndian = arguments[1];
                    return this.traceTake(size, littleEndian, null);
                }
                else if (arguments.length == 3) {
                    var size = arguments[0];
                    var littleEndian = arguments[1];
                    var clearBytes = arguments[2];
                    return this.traceTake(size, littleEndian, clearBytes, null);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataBufferPool.prototype.traceTake = function () {
                if (arguments.length == 4) {
                    var size = arguments[0];
                    var littleEndian = arguments[1];
                    var clearBytes = arguments[2];
                    var tag = arguments[3];
                    if (this.getDisabled()) {
                        return fm.liveswitch.DataBuffer.allocate(size, littleEndian);
                    }
                    var tagStatistics = null;
                    if ((this.getEnableStatistics() && (!fm.liveswitch.Global.equals(tag, null)))) {
                        tagStatistics = this.getOrAddTraceStatistics(tag);
                    }
                    return this.doTraceTake(size, littleEndian, clearBytes, tag, tagStatistics);
                }
                else if (arguments.length == 3) {
                    var size = arguments[0];
                    var littleEndian = arguments[1];
                    var tag = arguments[2];
                    return this.traceTake(size, littleEndian, false, tag);
                }
                else if (arguments.length == 2) {
                    var size = arguments[0];
                    var tag = arguments[1];
                    return this.traceTake(size, false, tag);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataBufferPool.fmliveswitchDataBufferPoolInitialize = function () {
                if (!fm.liveswitch.DataBufferPool.__fmliveswitchDataBufferPoolInitialized && !fm.liveswitch.DataBufferPool.__fmliveswitchDataBufferPoolInitializing) {
                    fm.liveswitch.DataBufferPool.__fmliveswitchDataBufferPoolInitializing = true;
                    fm.liveswitch.DataBufferPool.fm_liveswitch_DataBufferPool___singleton = null;
                    fm.liveswitch.DataBufferPool.fm_liveswitch_DataBufferPool___singletonLock = new Object();
                    fm.liveswitch.DataBufferPool.__fmliveswitchDataBufferPoolInitialized = true;
                    fm.liveswitch.DataBufferPool.__fmliveswitchDataBufferPoolInitializing = false;
                }
            };
            /** @hidden */
            DataBufferPool.__fmliveswitchDataBufferPoolInitialized = false;
            /** @hidden */
            DataBufferPool.__fmliveswitchDataBufferPoolInitializing = false;
            return DataBufferPool;
        }());
        liveswitch.DataBufferPool = DataBufferPool;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Pool statistics.
        */
        var PoolStatistics = /** @class */ (function () {
            /** @hidden */
            function PoolStatistics(tag) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var tag_4 = __arguments[0];
                    //super();
                    this.setTag(tag_4);
                    this.__hits = new fm.liveswitch.AtomicLong();
                    this.__misses = new fm.liveswitch.AtomicLong();
                    this.__creates = new fm.liveswitch.AtomicLong();
                    this.__paddingWasted = new fm.liveswitch.AtomicLong();
                    this.__totalPoolSize = new fm.liveswitch.AtomicLong();
                    this.__pendingPoolSize = new fm.liveswitch.AtomicLong();
                    this.__takenSize = new fm.liveswitch.AtomicLong();
                    this.__returnedSize = new fm.liveswitch.AtomicLong();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            PoolStatistics.prototype.getTypeString = function () {
                return '[fm.liveswitch.PoolStatistics]';
            };
            /**
            Gets the number of pools in use.
            */
            PoolStatistics.prototype.getActivePools = function () {
                if (arguments.length == 0) {
                    return this.__creates.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the percentage of cache hits.
            */
            PoolStatistics.prototype.getHitPercentage = function () {
                if (arguments.length == 0) {
                    if ((fm.liveswitch.Global.equals(this.getTotalCalls(), 0))) {
                        return -1;
                    }
                    return ((this.__hits.getValue() / this.getTotalCalls()) * 100);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the percentage of cache misses.
            */
            PoolStatistics.prototype.getMissPercentage = function () {
                if (arguments.length == 0) {
                    if ((fm.liveswitch.Global.equals(this.getTotalCalls(), 0))) {
                        return -1;
                    }
                    return ((this.__misses.getValue() / this.getTotalCalls()) * 100);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the amount of buffer padding that is unused for caller's requested buffers.
            */
            PoolStatistics.prototype.getPaddingWasted = function () {
                if (arguments.length == 0) {
                    return this.__paddingWasted.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the total size of all buffers currently in the pool.
            */
            PoolStatistics.prototype.getPendingPoolSize = function () {
                if (arguments.length == 0) {
                    return this.__pendingPoolSize.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the percentage of items returned to the pool.
            */
            PoolStatistics.prototype.getReturnPercentage = function () {
                if (arguments.length == 0) {
                    var num = this.__returnedSize.getValue();
                    var num2 = this.__takenSize.getValue();
                    if ((fm.liveswitch.Global.equals(num2, 0))) {
                        return -1;
                    }
                    return ((num / num2) * 100);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the tag.
            */
            PoolStatistics.prototype.getTag = function () {
                if (arguments.length == 0) {
                    return this._tag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the total calls to obtain a DataBuffer.
            */
            PoolStatistics.prototype.getTotalCalls = function () {
                if (arguments.length == 0) {
                    return (this.__hits.getValue() + this.__misses.getValue());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the total pools created.
            */
            PoolStatistics.prototype.getTotalPools = function () {
                if (arguments.length == 0) {
                    return this.__creates.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the total size of all buffers allocated in the pool.
            */
            PoolStatistics.prototype.getTotalPoolSize = function () {
                if (arguments.length == 0) {
                    return this.__totalPoolSize.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PoolStatistics.prototype.setTag = function (value) {
                if (arguments.length == 1) {
                    this._tag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Overriden ToString
            */
            PoolStatistics.prototype.toString = function () {
                if (arguments.length == 0) {
                    var num = this.__hits.getValue();
                    var num2 = this.__misses.getValue();
                    var num3 = (num + num2);
                    var num4 = ((fm.liveswitch.Global.equals(num3, 0)) ? -1 : ((num / num3) * 100));
                    var num5 = ((fm.liveswitch.Global.equals(num3, 0)) ? -1 : ((num2 / num3) * 100));
                    var num6 = this.__returnedSize.getValue();
                    var num7 = this.__takenSize.getValue();
                    var num8 = ((fm.liveswitch.Global.equals(num7, 0)) ? -1 : ((num6 / num7) * 100));
                    return fm.liveswitch.StringExtensions.format("{0}:\n\tHit Rate: {1}%\n\tMiss Rate: {2}%\n\tReturn Rate: {3}%\n\tPools: {4}\n\tAllocated: {5} bytes\n\tReady: {6} bytes", [this.getTag(), fm.liveswitch.NumberExtensions.toString(num4), fm.liveswitch.NumberExtensions.toString(num5), fm.liveswitch.NumberExtensions.toString(num8), fm.liveswitch.NumberExtensions.toString(this.getTotalPools()), fm.liveswitch.NumberExtensions.toString(this.getTotalPoolSize()), fm.liveswitch.NumberExtensions.toString(this.getPendingPoolSize())]);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return PoolStatistics;
        }());
        liveswitch.PoolStatistics = PoolStatistics;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var FutureStateWrapper = /** @class */ (function () {
            function FutureStateWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_16 = __arguments[0];
                    //super();
                    this._value = value_16;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            FutureStateWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.FutureStateWrapper]';
            };
            FutureStateWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.FutureState.Pending)
                        return 'Pending';
                    if (this._value == fm.liveswitch.FutureState.Resolved)
                        return 'Resolved';
                    if (this._value == fm.liveswitch.FutureState.Rejected)
                        return 'Rejected';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return FutureStateWrapper;
        }());
        liveswitch.FutureStateWrapper = FutureStateWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Class to hold a short value passed by reference.
        */
        var ShortHolder = /** @class */ (function () {
            function ShortHolder() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchShortHolderInit();
                }
                else if (__arguments.length == 1) {
                    var value = __arguments[0];
                    //super();
                    this.fmliveswitchShortHolderInit();
                    this.setValue(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            ShortHolder.prototype.getTypeString = function () {
                return '[fm.liveswitch.ShortHolder]';
            };
            ShortHolder.prototype.fmliveswitchShortHolderInit = function () {
                this._value = 0;
            };
            /**
            Gets the value.
            */
            ShortHolder.prototype.getValue = function () {
                if (arguments.length == 0) {
                    return this._value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the value.
            */
            ShortHolder.prototype.setValue = function (value) {
                if (arguments.length == 1) {
                    this._value = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ShortHolder;
        }());
        liveswitch.ShortHolder = ShortHolder;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Encapsulates useful sorting utilities.
        */
        var Sort = /** @class */ (function () {
            function Sort() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Sort.prototype.getTypeString = function () {
                return '[fm.liveswitch.Sort]';
            };
            /** @hidden */
            Sort.doQuickSort = function (array, left, right, comparer) {
                if (arguments.length == 4) {
                    if ((left < right)) {
                        var pivotIndex = (left + fm.liveswitch.MathAssistant.floor((right - left) / 2));
                        var num2 = fm.liveswitch.Sort.partition(array, left, right, pivotIndex, comparer);
                        fm.liveswitch.Sort.doQuickSort(array, left, (num2 - 1), comparer);
                        fm.liveswitch.Sort.doQuickSort(array, (num2 + 1), right, comparer);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Sort.partition = function (array, left, right, pivotIndex, comparer) {
                if (arguments.length == 5) {
                    var local = array[pivotIndex];
                    fm.liveswitch.Sort.swap(array, pivotIndex, right);
                    var num = left;
                    for (var i = left; (i < right); i++) {
                        if ((fm.liveswitch.Global.equals(comparer(array[i], local), fm.liveswitch.CompareResult.Negative))) {
                            fm.liveswitch.Sort.swap(array, i, num);
                            num++;
                        }
                    }
                    fm.liveswitch.Sort.swap(array, num, right);
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sorts an array using the in-place quick-sort algorithm.
            @param array The array of elements.
            @param comparer The function used to compare elements in the array -
                        should return less than 0 if item 1 is less than item 2 (item 1 should appear
                        before item 2), 0 if the items are equal, or more than 0 is item 1 is greater
                        than item 2 (item 1 should appear after item 2).
            */
            Sort.quickSort = function (array, comparer) {
                if (arguments.length == 2) {
                    var right = (fm.liveswitch.ArrayExtensions.getCount(array) - 1);
                    fm.liveswitch.Sort.doQuickSort(array, 0, right, comparer);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Sort.swap = function (array, pos1, pos2) {
                if (arguments.length == 3) {
                    var local = array[pos1];
                    array[pos1] = array[pos2];
                    array[pos2] = local;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Sort;
        }());
        liveswitch.Sort = Sort;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Utility class for splitting strings.
        */
        var Splitter = /** @class */ (function () {
            function Splitter() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Splitter.prototype.getTypeString = function () {
                return '[fm.liveswitch.Splitter]';
            };
            /**
            Splits a string using a given delimiter.
            @param str The string.
            @param delimiter The delimiter.
            */
            Splitter.split = function (str, delimiter) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(str, null))) {
                        throw new fm.liveswitch.Exception("str cannot be null.");
                    }
                    if ((fm.liveswitch.Global.equals(delimiter, null))) {
                        throw new fm.liveswitch.Exception("delimiter cannot be null.");
                    }
                    if ((fm.liveswitch.Global.equals(fm.liveswitch.StringExtensions.getLength(delimiter), 0))) {
                        return [str];
                    }
                    var startIndex = 0;
                    var num2 = 0;
                    var list = new Array();
                    for (var i = 0; (i < fm.liveswitch.StringExtensions.getLength(str)); i++) {
                        var ch = str.charCodeAt(i);
                        var ch2 = delimiter.charCodeAt(num2);
                        if ((fm.liveswitch.Global.equals(ch, ch2))) {
                            if ((fm.liveswitch.Global.equals(num2, (fm.liveswitch.StringExtensions.getLength(delimiter) - 1)))) {
                                fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.substring(str, startIndex, ((i - num2) - startIndex)));
                                startIndex = (i + 1);
                                num2 = 0;
                            }
                            else {
                                num2++;
                            }
                        }
                        else {
                            num2 = 0;
                        }
                    }
                    fm.liveswitch.ArrayExtensions.add(list, str.substring(startIndex));
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Splitter;
        }());
        liveswitch.Splitter = Splitter;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Contains methods for string manipulation.
        */
        var StringAssistant = /** @class */ (function () {
            function StringAssistant() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            StringAssistant.prototype.getTypeString = function () {
                return '[fm.liveswitch.StringAssistant]';
            };
            /**
    
            @param s The s.
            */
            StringAssistant.isNullOrWhiteSpace = function (s) {
                if (arguments.length == 1) {
                    return ((fm.liveswitch.Global.equals(s, null)) || fm.liveswitch.StringExtensions.isNullOrEmpty(fm.liveswitch.StringExtensions.trim(s)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            StringAssistant.subArray = function () {
                if (arguments.length == 2) {
                    var array = arguments[0];
                    var offset = arguments[1];
                    return fm.liveswitch.StringAssistant.subArray(array, offset, (array.length - offset));
                }
                else if (arguments.length == 3) {
                    var array = arguments[0];
                    var offset = arguments[1];
                    var count = arguments[2];
                    var strArray = new Array(count);
                    for (var i = 0; (i < count); i++) {
                        strArray[i] = array[(offset + i)];
                    }
                    return strArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return StringAssistant;
        }());
        liveswitch.StringAssistant = StringAssistant;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="LogProvider.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Simple log provider that writes to a local string builder.
        */
        var TextLogProvider = /** @class */ (function (_super) {
            __extends(TextLogProvider, _super);
            function TextLogProvider() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    // chained constructor: TextLogProvider.call(this, fm.liveswitch.LogLevel.Info);
                    __arguments = new Array(1);
                    __arguments[0] = fm.liveswitch.LogLevel.Info;
                    {
                        var level = __arguments[0];
                        _this = _super.call(this) || this;
                        _this.__text = new fm.liveswitch.StringBuilder();
                        _this.__textLock = new Object();
                        _super.prototype.setLevel.call(_this, level);
                    }
                }
                else if (__arguments.length == 1) {
                    var level = __arguments[0];
                    _this = _super.call(this) || this;
                    _this.__text = new fm.liveswitch.StringBuilder();
                    _this.__textLock = new Object();
                    _super.prototype.setLevel.call(_this, level);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            TextLogProvider.prototype.getTypeString = function () {
                return '[fm.liveswitch.TextLogProvider]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Clears all text from the log and returns the former contents.
            */
            TextLogProvider.prototype.clear = function () {
                if (arguments.length == 0) {
                    var str = void 0;
                    str = this.__text.toString();
                    this.__text = new fm.liveswitch.StringBuilder();
                    return str;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Logs a message at the specified log level.
            @param logEvent The log event details.
            */
            TextLogProvider.prototype.doLog = function (logEvent) {
                if (arguments.length == 1) {
                    this.writeLine(this.generateLogLine(logEvent));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a callback to invoke whenever text is written to the log.
            */
            TextLogProvider.prototype.getCallback = function () {
                if (arguments.length == 0) {
                    return this.__callback;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the logged text.
            */
            TextLogProvider.prototype.getText = function () {
                if (arguments.length == 0) {
                    return this.__text.toString();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a callback to invoke whenever text is written to the log.
            */
            TextLogProvider.prototype.setCallback = function (value) {
                if (arguments.length == 1) {
                    var str = this.__text.toString();
                    if (!fm.liveswitch.StringExtensions.isNullOrEmpty(str)) {
                        if (fm.liveswitch.StringExtensions.endsWith(str, "\n")) {
                            str = fm.liveswitch.StringExtensions.substring(str, 0, (fm.liveswitch.StringExtensions.getLength(str) - 1));
                        }
                        value(str);
                    }
                    this.__callback = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            TextLogProvider.prototype.writeLine = function (text) {
                if (arguments.length == 1) {
                    this.__text.append(fm.liveswitch.StringExtensions.concat(text, "\n"));
                    if ((!fm.liveswitch.Global.equals(this.__callback, null))) {
                        this.__callback(text);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return TextLogProvider;
        }(fm.liveswitch.LogProvider));
        liveswitch.TextLogProvider = TextLogProvider;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Throws exceptions on a separate thread.
        */
        var Unhandled = /** @class */ (function () {
            function Unhandled() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Unhandled.prototype.getTypeString = function () {
                return '[fm.liveswitch.Unhandled]';
            };
            /**
            Logs an unhandled exception.
            @param ex The exception to throw.
            @param source The source of the exception.
            */
            Unhandled.logException = function (ex, source) {
                if (arguments.length == 2) {
                    fm.liveswitch.Log.error(fm.liveswitch.StringExtensions.concat("An exception in user code (", source, ") was unhandled."), ex);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Unhandled;
        }());
        liveswitch.Unhandled = Unhandled;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Arguments for an unhandled exception.
        */
        var UnhandledExceptionArgs = /** @class */ (function () {
            /**
            Initializes a new instance of the [[fm.liveswitch.unhandledExceptionArgs]] class.
            @param exception The exception.
            */
            function UnhandledExceptionArgs(exception) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var exception_1 = __arguments[0];
                    //super();
                    this.fmliveswitchUnhandledExceptionArgsInit();
                    this.__exception = exception_1;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            UnhandledExceptionArgs.prototype.getTypeString = function () {
                return '[fm.liveswitch.UnhandledExceptionArgs]';
            };
            UnhandledExceptionArgs.prototype.fmliveswitchUnhandledExceptionArgsInit = function () {
                this._handled = false;
            };
            /**
            Gets the unhandled exception.
            */
            UnhandledExceptionArgs.prototype.getException = function () {
                if (arguments.length == 0) {
                    return this.__exception;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the exception has been appropriately handled. If set to `true`, then the exception will not be thrown.
            */
            UnhandledExceptionArgs.prototype.getHandled = function () {
                if (arguments.length == 0) {
                    return this._handled;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the exception has been appropriately handled. If set to `true`, then the exception will not be thrown.
            */
            UnhandledExceptionArgs.prototype.setHandled = function (value) {
                if (arguments.length == 1) {
                    this._handled = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return UnhandledExceptionArgs;
        }());
        liveswitch.UnhandledExceptionArgs = UnhandledExceptionArgs;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        UTF-8 encoding/decoding utility.
        */
        var Utf8 = /** @class */ (function () {
            function Utf8() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Utf8.prototype.getTypeString = function () {
                return '[fm.liveswitch.Utf8]';
            };
            Utf8.decode = function () {
                if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.DataBuffer]'))) {
                    var buffer = arguments[0];
                    return fm.liveswitch.Utf8.decode(buffer.getData(), buffer.getIndex(), buffer.getLength());
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isUint8Array(arguments[0]))) {
                    var input = arguments[0];
                    return fm.liveswitch.Utf8.decode(input, 0, input.length);
                }
                else if (arguments.length == 3) {
                    var input = arguments[0];
                    var index = arguments[1];
                    var length_36 = arguments[2];
                    return fm.liveswitch.Encoding.getUtf8().getString(input, index, length_36);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Encodes a string to a UTF-8 byte array.
            @param input The input string.
            */
            Utf8.encode = function (input) {
                if (arguments.length == 1) {
                    return fm.liveswitch.Encoding.getUtf8().getBytes(input);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes that would be returned by a call to encode.
            @param input The input string.
            */
            Utf8.getByteCount = function (input) {
                if (arguments.length == 1) {
                    return fm.liveswitch.Encoding.getUtf8().getByteCount(input);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Utf8;
        }());
        liveswitch.Utf8 = Utf8;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var WebSocketSendState = /** @class */ (function () {
            function WebSocketSendState() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            WebSocketSendState.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebSocketSendState]';
            };
            WebSocketSendState.prototype.getRequestBytes = function () {
                if (arguments.length == 0) {
                    return this._requestBytes;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            WebSocketSendState.prototype.getSendArgs = function () {
                if (arguments.length == 0) {
                    return this._sendArgs;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            WebSocketSendState.prototype.setRequestBytes = function (value) {
                if (arguments.length == 1) {
                    this._requestBytes = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            WebSocketSendState.prototype.setSendArgs = function (value) {
                if (arguments.length == 1) {
                    this._sendArgs = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return WebSocketSendState;
        }());
        liveswitch.WebSocketSendState = WebSocketSendState;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Close arguments for the [[fm.liveswitch.webSocket]] class.
        */
        var WebSocketCloseArgs = /** @class */ (function (_super) {
            __extends(WebSocketCloseArgs, _super);
            /**
            Creates a new instance of [[fm.liveswitch.webSocketCloseArgs]] with default values.
            */
            function WebSocketCloseArgs() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.setStatusCode(fm.liveswitch.WebSocketStatusCode.Normal);
                    _this.setReason(fm.liveswitch.StringExtensions.empty);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            WebSocketCloseArgs.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebSocketCloseArgs]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Gets the callback to execute when the connection is closed.
            */
            WebSocketCloseArgs.prototype.getOnComplete = function () {
                if (arguments.length == 0) {
                    return this._onComplete;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the reason to send with the close frame.
            */
            WebSocketCloseArgs.prototype.getReason = function () {
                if (arguments.length == 0) {
                    return this._reason;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the status code to send with the close frame.
            */
            WebSocketCloseArgs.prototype.getStatusCode = function () {
                if (arguments.length == 0) {
                    return this._statusCode;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the callback to execute when the connection is closed.
            */
            WebSocketCloseArgs.prototype.setOnComplete = function (value) {
                if (arguments.length == 1) {
                    this._onComplete = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the reason to send with the close frame.
            */
            WebSocketCloseArgs.prototype.setReason = function (value) {
                if (arguments.length == 1) {
                    this._reason = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the status code to send with the close frame.
            */
            WebSocketCloseArgs.prototype.setStatusCode = function (value) {
                if (arguments.length == 1) {
                    this._statusCode = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return WebSocketCloseArgs;
        }(fm.liveswitch.Dynamic));
        liveswitch.WebSocketCloseArgs = WebSocketCloseArgs;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Arguments for [[fm.liveswitch.webSocketCloseArgs.onComplete]].
        */
        var WebSocketCloseCompleteArgs = /** @class */ (function (_super) {
            __extends(WebSocketCloseCompleteArgs, _super);
            function WebSocketCloseCompleteArgs() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            WebSocketCloseCompleteArgs.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebSocketCloseCompleteArgs]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Gets the original arguments passed to the close method.
            */
            WebSocketCloseCompleteArgs.prototype.getCloseArgs = function () {
                if (arguments.length == 0) {
                    return this._closeArgs;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the reason given for closing the connection.
            */
            WebSocketCloseCompleteArgs.prototype.getReason = function () {
                if (arguments.length == 0) {
                    return this._reason;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the status code associated with the close operation.
            */
            WebSocketCloseCompleteArgs.prototype.getStatusCode = function () {
                if (arguments.length == 0) {
                    return this._statusCode;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the original arguments passed to the close method.
            */
            WebSocketCloseCompleteArgs.prototype.setCloseArgs = function (value) {
                if (arguments.length == 1) {
                    this._closeArgs = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the reason given for closing the connection.
            */
            WebSocketCloseCompleteArgs.prototype.setReason = function (value) {
                if (arguments.length == 1) {
                    this._reason = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the status code associated with the close operation.
            */
            WebSocketCloseCompleteArgs.prototype.setStatusCode = function (value) {
                if (arguments.length == 1) {
                    this._statusCode = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return WebSocketCloseCompleteArgs;
        }(fm.liveswitch.Dynamic));
        liveswitch.WebSocketCloseCompleteArgs = WebSocketCloseCompleteArgs;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Open arguments for the [[fm.liveswitch.webSocket]] class.
        */
        var WebSocketOpenArgs = /** @class */ (function (_super) {
            __extends(WebSocketOpenArgs, _super);
            /**
            Creates a new instance of
            */
            function WebSocketOpenArgs() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchWebSocketOpenArgsInit();
                    _this.setHandshakeTimeout(15000);
                    _this.setStreamTimeout(40000);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            WebSocketOpenArgs.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebSocketOpenArgs]' + ',' + _super.prototype.getTypeString.call(this);
            };
            WebSocketOpenArgs.prototype.fmliveswitchWebSocketOpenArgsInit = function () {
                this._handshakeTimeout = 0;
                this._streamTimeout = 0;
            };
            /**
            Gets the timeout for the handshake (in ms).
            */
            WebSocketOpenArgs.prototype.getHandshakeTimeout = function () {
                if (arguments.length == 0) {
                    return this._handshakeTimeout;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets headers to send with the handshake request.
            */
            WebSocketOpenArgs.prototype.getHeaders = function () {
                if (arguments.length == 0) {
                    return this._headers;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the callback to invoke when a connection could not be established.
            */
            WebSocketOpenArgs.prototype.getOnFailure = function () {
                if (arguments.length == 0) {
                    return this._onFailure;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the callback to invoke when a message is received.
            */
            WebSocketOpenArgs.prototype.getOnReceive = function () {
                if (arguments.length == 0) {
                    return this._onReceive;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the callback to invoke before the handshake request is sent.
            */
            WebSocketOpenArgs.prototype.getOnRequestCreated = function () {
                if (arguments.length == 0) {
                    return this._onRequestCreated;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the callback to invoke after the handshake response is received.
            */
            WebSocketOpenArgs.prototype.getOnResponseReceived = function () {
                if (arguments.length == 0) {
                    return this._onResponseReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the callback to invoke when a successful connection breaks down.
            */
            WebSocketOpenArgs.prototype.getOnStreamFailure = function () {
                if (arguments.length == 0) {
                    return this._onStreamFailure;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the callback to invoke when a successful connection has been established.
            */
            WebSocketOpenArgs.prototype.getOnSuccess = function () {
                if (arguments.length == 0) {
                    return this._onSuccess;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the sender of the request.
            */
            WebSocketOpenArgs.prototype.getSender = function () {
                if (arguments.length == 0) {
                    return this._sender;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the timeout for the stream (in ms).
            */
            WebSocketOpenArgs.prototype.getStreamTimeout = function () {
                if (arguments.length == 0) {
                    return this._streamTimeout;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the timeout for the handshake (in ms).
            */
            WebSocketOpenArgs.prototype.setHandshakeTimeout = function (value) {
                if (arguments.length == 1) {
                    this._handshakeTimeout = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets headers to send with the handshake request.
            */
            WebSocketOpenArgs.prototype.setHeaders = function (value) {
                if (arguments.length == 1) {
                    this._headers = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the callback to invoke when a connection could not be established.
            */
            WebSocketOpenArgs.prototype.setOnFailure = function (value) {
                if (arguments.length == 1) {
                    this._onFailure = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the callback to invoke when a message is received.
            */
            WebSocketOpenArgs.prototype.setOnReceive = function (value) {
                if (arguments.length == 1) {
                    this._onReceive = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the callback to invoke before the handshake request is sent.
            */
            WebSocketOpenArgs.prototype.setOnRequestCreated = function (value) {
                if (arguments.length == 1) {
                    this._onRequestCreated = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the callback to invoke after the handshake response is received.
            */
            WebSocketOpenArgs.prototype.setOnResponseReceived = function (value) {
                if (arguments.length == 1) {
                    this._onResponseReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the callback to invoke when a successful connection breaks down.
            */
            WebSocketOpenArgs.prototype.setOnStreamFailure = function (value) {
                if (arguments.length == 1) {
                    this._onStreamFailure = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the callback to invoke when a successful connection has been established.
            */
            WebSocketOpenArgs.prototype.setOnSuccess = function (value) {
                if (arguments.length == 1) {
                    this._onSuccess = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the sender of the request.
            */
            WebSocketOpenArgs.prototype.setSender = function (value) {
                if (arguments.length == 1) {
                    this._sender = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the timeout for the stream (in ms).
            */
            WebSocketOpenArgs.prototype.setStreamTimeout = function (value) {
                if (arguments.length == 1) {
                    this._streamTimeout = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return WebSocketOpenArgs;
        }(fm.liveswitch.Dynamic));
        liveswitch.WebSocketOpenArgs = WebSocketOpenArgs;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Arguments for [[fm.liveswitch.webSocketOpenArgs.onFailure]].
        */
        var WebSocketOpenFailureArgs = /** @class */ (function (_super) {
            __extends(WebSocketOpenFailureArgs, _super);
            function WebSocketOpenFailureArgs() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            WebSocketOpenFailureArgs.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebSocketOpenFailureArgs]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Gets the exception generated while connecting.
            */
            WebSocketOpenFailureArgs.prototype.getException = function () {
                if (arguments.length == 0) {
                    return this._exception;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the original arguments passed to the open method.
            */
            WebSocketOpenFailureArgs.prototype.getOpenArgs = function () {
                if (arguments.length == 0) {
                    return this._openArgs;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the status code associated with the failure to connect.
            */
            WebSocketOpenFailureArgs.prototype.getStatusCode = function () {
                if (arguments.length == 0) {
                    return this._statusCode;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the exception generated while connecting.
            */
            WebSocketOpenFailureArgs.prototype.setException = function (value) {
                if (arguments.length == 1) {
                    this._exception = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the original arguments passed to the open method.
            */
            WebSocketOpenFailureArgs.prototype.setOpenArgs = function (value) {
                if (arguments.length == 1) {
                    this._openArgs = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the status code associated with the failure to connect.
            */
            WebSocketOpenFailureArgs.prototype.setStatusCode = function (value) {
                if (arguments.length == 1) {
                    this._statusCode = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return WebSocketOpenFailureArgs;
        }(fm.liveswitch.Dynamic));
        liveswitch.WebSocketOpenFailureArgs = WebSocketOpenFailureArgs;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Arguments for [[fm.liveswitch.webSocketOpenArgs.onSuccess]].
        */
        var WebSocketOpenSuccessArgs = /** @class */ (function (_super) {
            __extends(WebSocketOpenSuccessArgs, _super);
            function WebSocketOpenSuccessArgs() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            WebSocketOpenSuccessArgs.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebSocketOpenSuccessArgs]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Gets the original arguments passed to the open method.
            */
            WebSocketOpenSuccessArgs.prototype.getOpenArgs = function () {
                if (arguments.length == 0) {
                    return this._openArgs;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the original arguments passed to the open method.
            */
            WebSocketOpenSuccessArgs.prototype.setOpenArgs = function (value) {
                if (arguments.length == 1) {
                    this._openArgs = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return WebSocketOpenSuccessArgs;
        }(fm.liveswitch.Dynamic));
        liveswitch.WebSocketOpenSuccessArgs = WebSocketOpenSuccessArgs;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Arguments for [[fm.liveswitch.webSocketOpenArgs.onReceive]].
        */
        var WebSocketReceiveArgs = /** @class */ (function (_super) {
            __extends(WebSocketReceiveArgs, _super);
            function WebSocketReceiveArgs() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            WebSocketReceiveArgs.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebSocketReceiveArgs]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Gets the message received from the server as binary data.
            */
            WebSocketReceiveArgs.prototype.getBinaryMessage = function () {
                if (arguments.length == 0) {
                    return this._binaryMessage;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether or not the received message is text.
            */
            WebSocketReceiveArgs.prototype.getIsText = function () {
                if (arguments.length == 0) {
                    return (!fm.liveswitch.Global.equals(this.getTextMessage(), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the original arguments passed to the open method.
            */
            WebSocketReceiveArgs.prototype.getOpenArgs = function () {
                if (arguments.length == 0) {
                    return this._openArgs;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the message received from the server as text data.
            */
            WebSocketReceiveArgs.prototype.getTextMessage = function () {
                if (arguments.length == 0) {
                    return this._textMessage;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the message received from the server as binary data.
            */
            WebSocketReceiveArgs.prototype.setBinaryMessage = function (value) {
                if (arguments.length == 1) {
                    this._binaryMessage = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the original arguments passed to the open method.
            */
            WebSocketReceiveArgs.prototype.setOpenArgs = function (value) {
                if (arguments.length == 1) {
                    this._openArgs = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the message received from the server as text data.
            */
            WebSocketReceiveArgs.prototype.setTextMessage = function (value) {
                if (arguments.length == 1) {
                    this._textMessage = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return WebSocketReceiveArgs;
        }(fm.liveswitch.Dynamic));
        liveswitch.WebSocketReceiveArgs = WebSocketReceiveArgs;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var WebSocketRequest = /** @class */ (function () {
            function WebSocketRequest() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            WebSocketRequest.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebSocketRequest]';
            };
            WebSocketRequest.prototype.getArgs = function () {
                if (arguments.length == 0) {
                    return this._args;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            WebSocketRequest.prototype.getCallback = function () {
                if (arguments.length == 0) {
                    return this._callback;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            WebSocketRequest.prototype.setArgs = function (value) {
                if (arguments.length == 1) {
                    this._args = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            WebSocketRequest.prototype.setCallback = function (value) {
                if (arguments.length == 1) {
                    this._callback = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return WebSocketRequest;
        }());
        liveswitch.WebSocketRequest = WebSocketRequest;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Send arguments for the [[fm.liveswitch.webSocket]] class.
        */
        var WebSocketSendArgs = /** @class */ (function (_super) {
            __extends(WebSocketSendArgs, _super);
            /**
            Creates a new [[fm.liveswitch.webSocketSendArgs]] instance.
            */
            function WebSocketSendArgs() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchWebSocketSendArgsInit();
                    _this.setTimeout(15000);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            WebSocketSendArgs.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebSocketSendArgs]' + ',' + _super.prototype.getTypeString.call(this);
            };
            WebSocketSendArgs.prototype.fmliveswitchWebSocketSendArgsInit = function () {
                this._timeout = 0;
            };
            /**
            Gets the message to send as binary data.
            */
            WebSocketSendArgs.prototype.getBinaryMessage = function () {
                if (arguments.length == 0) {
                    return this._binaryMessage;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebSocketSendArgs.prototype.getIsText = function () {
                if (arguments.length == 0) {
                    return (!fm.liveswitch.Global.equals(this.getTextMessage(), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the message to send as text data.
            */
            WebSocketSendArgs.prototype.getTextMessage = function () {
                if (arguments.length == 0) {
                    return this._textMessage;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the timeout for the request (in ms).
            */
            WebSocketSendArgs.prototype.getTimeout = function () {
                if (arguments.length == 0) {
                    return this._timeout;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the message to send as binary data.
            */
            WebSocketSendArgs.prototype.setBinaryMessage = function (value) {
                if (arguments.length == 1) {
                    this._binaryMessage = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the message to send as text data.
            */
            WebSocketSendArgs.prototype.setTextMessage = function (value) {
                if (arguments.length == 1) {
                    this._textMessage = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the timeout for the request (in ms).
            */
            WebSocketSendArgs.prototype.setTimeout = function (value) {
                if (arguments.length == 1) {
                    this._timeout = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return WebSocketSendArgs;
        }(fm.liveswitch.Dynamic));
        liveswitch.WebSocketSendArgs = WebSocketSendArgs;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var WebSocketStatusCodeWrapper = /** @class */ (function () {
            function WebSocketStatusCodeWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_17 = __arguments[0];
                    //super();
                    this._value = value_17;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            WebSocketStatusCodeWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebSocketStatusCodeWrapper]';
            };
            WebSocketStatusCodeWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.WebSocketStatusCode.Normal)
                        return 'Normal';
                    if (this._value == fm.liveswitch.WebSocketStatusCode.GoingAway)
                        return 'GoingAway';
                    if (this._value == fm.liveswitch.WebSocketStatusCode.ProtocolError)
                        return 'ProtocolError';
                    if (this._value == fm.liveswitch.WebSocketStatusCode.InvalidType)
                        return 'InvalidType';
                    if (this._value == fm.liveswitch.WebSocketStatusCode.NoStatus)
                        return 'NoStatus';
                    if (this._value == fm.liveswitch.WebSocketStatusCode.Abnormal)
                        return 'Abnormal';
                    if (this._value == fm.liveswitch.WebSocketStatusCode.InvalidData)
                        return 'InvalidData';
                    if (this._value == fm.liveswitch.WebSocketStatusCode.PolicyViolation)
                        return 'PolicyViolation';
                    if (this._value == fm.liveswitch.WebSocketStatusCode.MessageTooLarge)
                        return 'MessageTooLarge';
                    if (this._value == fm.liveswitch.WebSocketStatusCode.UnsupportedExtension)
                        return 'UnsupportedExtension';
                    if (this._value == fm.liveswitch.WebSocketStatusCode.UnexpectedCondition)
                        return 'UnexpectedCondition';
                    if (this._value == fm.liveswitch.WebSocketStatusCode.SecureHandshakeFailure)
                        return 'SecureHandshakeFailure';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return WebSocketStatusCodeWrapper;
        }());
        liveswitch.WebSocketStatusCodeWrapper = WebSocketStatusCodeWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Arguments for [[fm.liveswitch.webSocketOpenArgs.onStreamFailure]].
        */
        var WebSocketStreamFailureArgs = /** @class */ (function (_super) {
            __extends(WebSocketStreamFailureArgs, _super);
            function WebSocketStreamFailureArgs() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            WebSocketStreamFailureArgs.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebSocketStreamFailureArgs]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Gets the exception generated by the active connection.
            */
            WebSocketStreamFailureArgs.prototype.getException = function () {
                if (arguments.length == 0) {
                    return this._exception;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the original arguments passed to the open method.
            */
            WebSocketStreamFailureArgs.prototype.getOpenArgs = function () {
                if (arguments.length == 0) {
                    return this._openArgs;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the status code associated with the stream failure.
            */
            WebSocketStreamFailureArgs.prototype.getStatusCode = function () {
                if (arguments.length == 0) {
                    return this._statusCode;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the exception generated by the active connection.
            */
            WebSocketStreamFailureArgs.prototype.setException = function (value) {
                if (arguments.length == 1) {
                    this._exception = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the original arguments passed to the open method.
            */
            WebSocketStreamFailureArgs.prototype.setOpenArgs = function (value) {
                if (arguments.length == 1) {
                    this._openArgs = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the status code associated with the stream failure.
            */
            WebSocketStreamFailureArgs.prototype.setStatusCode = function (value) {
                if (arguments.length == 1) {
                    this._statusCode = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return WebSocketStreamFailureArgs;
        }(fm.liveswitch.Dynamic));
        liveswitch.WebSocketStreamFailureArgs = WebSocketStreamFailureArgs;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Base class that defines methods for transferring content over the WebSocket protocol.
        */
        var WebSocketTransfer = /** @class */ (function () {
            /**
            Initializes a new instance of the [[fm.liveswitch.webSocketTransfer]] class.
            @param url The URL.
            */
            function WebSocketTransfer(url) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var url_1 = __arguments[0];
                    //super();
                    this.fmliveswitchWebSocketTransferInit();
                    this.setUrl(url_1);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            WebSocketTransfer.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebSocketTransfer]';
            };
            WebSocketTransfer.prototype.fmliveswitchWebSocketTransferInit = function () {
                this._handshakeTimeout = 0;
                this._streamTimeout = 0;
            };
            /**
            Gets the timeout for the initial handshake (in ms).
            */
            WebSocketTransfer.prototype.getHandshakeTimeout = function () {
                if (arguments.length == 0) {
                    return this._handshakeTimeout;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the callback to invoke if the handshake fails.
            */
            WebSocketTransfer.prototype.getOnOpenFailure = function () {
                if (arguments.length == 0) {
                    return this._onOpenFailure;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the callback to invoke if the handshake succeeds.
            */
            WebSocketTransfer.prototype.getOnOpenSuccess = function () {
                if (arguments.length == 0) {
                    return this._onOpenSuccess;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the callback to invoke when the handshake request is created.
            */
            WebSocketTransfer.prototype.getOnRequestCreated = function () {
                if (arguments.length == 0) {
                    return this._onRequestCreated;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the callback to invoke when the handshake response is received.
            */
            WebSocketTransfer.prototype.getOnResponseReceived = function () {
                if (arguments.length == 0) {
                    return this._onResponseReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the callback to invoke if the stream errors out.
            */
            WebSocketTransfer.prototype.getOnStreamFailure = function () {
                if (arguments.length == 0) {
                    return this._onStreamFailure;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the sender of the messages.
            */
            WebSocketTransfer.prototype.getSender = function () {
                if (arguments.length == 0) {
                    return this._sender;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the timeout for the stream (in ms).
            */
            WebSocketTransfer.prototype.getStreamTimeout = function () {
                if (arguments.length == 0) {
                    return this._streamTimeout;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the URL.
            */
            WebSocketTransfer.prototype.getUrl = function () {
                if (arguments.length == 0) {
                    return this.__url;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the timeout for the initial handshake (in ms).
            */
            WebSocketTransfer.prototype.setHandshakeTimeout = function (value) {
                if (arguments.length == 1) {
                    this._handshakeTimeout = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the callback to invoke if the handshake fails.
            */
            WebSocketTransfer.prototype.setOnOpenFailure = function (value) {
                if (arguments.length == 1) {
                    this._onOpenFailure = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the callback to invoke if the handshake succeeds.
            */
            WebSocketTransfer.prototype.setOnOpenSuccess = function (value) {
                if (arguments.length == 1) {
                    this._onOpenSuccess = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the callback to invoke when the handshake request is created.
            */
            WebSocketTransfer.prototype.setOnRequestCreated = function (value) {
                if (arguments.length == 1) {
                    this._onRequestCreated = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the callback to invoke when the handshake response is received.
            */
            WebSocketTransfer.prototype.setOnResponseReceived = function (value) {
                if (arguments.length == 1) {
                    this._onResponseReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the callback to invoke if the stream errors out.
            */
            WebSocketTransfer.prototype.setOnStreamFailure = function (value) {
                if (arguments.length == 1) {
                    this._onStreamFailure = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the sender of the messages.
            */
            WebSocketTransfer.prototype.setSender = function (value) {
                if (arguments.length == 1) {
                    this._sender = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the timeout for the stream (in ms).
            */
            WebSocketTransfer.prototype.setStreamTimeout = function (value) {
                if (arguments.length == 1) {
                    this._streamTimeout = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the URL.
            */
            WebSocketTransfer.prototype.setUrl = function (value) {
                if (arguments.length == 1) {
                    value = fm.liveswitch.StringExtensions.replace(value, "https://", "wss://");
                    value = fm.liveswitch.StringExtensions.replace(value, "http://", "ws://");
                    this.__url = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return WebSocketTransfer;
        }());
        liveswitch.WebSocketTransfer = WebSocketTransfer;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Creates implementations of [[fm.liveswitch.webSocketWebRequestTransfer]].
        */
        var WebSocketTransferFactory = /** @class */ (function () {
            function WebSocketTransferFactory() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            WebSocketTransferFactory.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebSocketTransferFactory]';
            };
            /** @hidden */
            WebSocketTransferFactory.defaultCreateWebSocketTransfer = function (url) {
                if (arguments.length == 1) {
                    return new fm.liveswitch.WebSocketWebRequestTransfer(url);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the callback that creates a WebSocket-based transfer class.
            */
            WebSocketTransferFactory.getCreateWebSocketTransfer = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.WebSocketTransferFactory.fm_liveswitch_WebSocketTransferFactory__createWebSocketTransfer;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets an instance of the WebSocket-based transfer class.
            */
            WebSocketTransferFactory.getWebSocketTransfer = function (url) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(fm.liveswitch.WebSocketTransferFactory.getCreateWebSocketTransfer(), null))) {
                        fm.liveswitch.WebSocketTransferFactory.setCreateWebSocketTransfer(fm.liveswitch.WebSocketTransferFactory.defaultCreateWebSocketTransfer.bind(fm.liveswitch.WebSocketTransferFactory));
                    }
                    var transfer = fm.liveswitch.WebSocketTransferFactory.getCreateWebSocketTransfer()(url);
                    if ((fm.liveswitch.Global.equals(transfer, null))) {
                        transfer = fm.liveswitch.WebSocketTransferFactory.defaultCreateWebSocketTransfer(url);
                    }
                    return transfer;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the callback that creates a WebSocket-based transfer class.
            */
            WebSocketTransferFactory.setCreateWebSocketTransfer = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.WebSocketTransferFactory.fm_liveswitch_WebSocketTransferFactory__createWebSocketTransfer = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return WebSocketTransferFactory;
        }());
        liveswitch.WebSocketTransferFactory = WebSocketTransferFactory;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="WebSocketTransfer.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Defines methods for transferring messages using the WebSocket protocol.
        */
        var WebSocketWebRequestTransfer = /** @class */ (function (_super) {
            __extends(WebSocketWebRequestTransfer, _super);
            /**
            Creates a new instance of [[fm.liveswitch.webSocketWebRequestTransfer]].
            @param url The URL.
            */
            function WebSocketWebRequestTransfer(url) {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var url_2 = __arguments[0];
                    _this = _super.call(this, url_2) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            WebSocketWebRequestTransfer.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebSocketWebRequestTransfer]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @hidden */
            WebSocketWebRequestTransfer.prototype.connectFailure = function (e) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(_super.prototype.getOnOpenFailure.call(this), null))) {
                        _super.prototype.getOnOpenFailure.call(this)(e);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebSocketWebRequestTransfer.prototype.connectSuccess = function (e) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(_super.prototype.getOnOpenSuccess.call(this), null))) {
                        _super.prototype.getOnOpenSuccess.call(this)(e);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebSocketWebRequestTransfer.prototype.getWebSocket = function () {
                if (arguments.length == 0) {
                    return this._webSocket;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Opens the WebSocket connection.
            */
            WebSocketWebRequestTransfer.prototype.open = function (headers) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(this.getWebSocket(), null))) {
                        this.getWebSocket().close();
                        this.setWebSocket(null);
                    }
                    this.setWebSocket(new fm.liveswitch.WebSocket(_super.prototype.getUrl.call(this)));
                    try {
                        var openArgs = new fm.liveswitch.WebSocketOpenArgs();
                        openArgs.setHandshakeTimeout(_super.prototype.getHandshakeTimeout.call(this));
                        openArgs.setHeaders(headers);
                        openArgs.setOnSuccess(this.connectSuccess.bind(this));
                        openArgs.setOnFailure(this.connectFailure.bind(this));
                        openArgs.setOnStreamFailure(this.streamFailure.bind(this));
                        openArgs.setOnRequestCreated(_super.prototype.getOnRequestCreated.call(this));
                        openArgs.setOnResponseReceived(_super.prototype.getOnResponseReceived.call(this));
                        openArgs.setOnReceive(this.receive.bind(this));
                        openArgs.setSender(_super.prototype.getSender.call(this));
                        this.getWebSocket().open(openArgs);
                    }
                    catch (exception) {
                        fm.liveswitch.Log.error("Could not open WebSocket.", exception);
                    }
                    finally {
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebSocketWebRequestTransfer.prototype.receive = function (e) {
                if (arguments.length == 1) {
                    var p = new fm.liveswitch.HttpResponseArgs(this._activeRequest.getArgs());
                    p.setTextContent(e.getTextMessage());
                    p.setBinaryContent(e.getBinaryMessage());
                    this._activeRequest.getCallback()(p);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sends a request synchronously.
            @param requestArgs The request parameters.
            @return The response parameters.
            */
            WebSocketWebRequestTransfer.prototype.send = function (requestArgs) {
                if (arguments.length == 1) {
                    throw new fm.liveswitch.Exception("Synchronous WebSockets are not supported.");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sends a request asynchronously.
            @param requestArgs The request parameters.
            @param callback The callback to execute with the resulting response.
            */
            WebSocketWebRequestTransfer.prototype.sendAsync = function (requestArgs, callback) {
                if (arguments.length == 2) {
                    try {
                        var request2 = new fm.liveswitch.WebSocketRequest();
                        request2.setArgs(requestArgs);
                        request2.setCallback(callback);
                        var request = request2;
                        var args2 = new fm.liveswitch.WebSocketSendArgs();
                        args2.setTimeout(request.getArgs().getTimeout());
                        var sendArgs = args2;
                        sendArgs.setTextMessage(request.getArgs().getTextContent());
                        sendArgs.setBinaryMessage(request.getArgs().getBinaryContent());
                        this._activeRequest = request;
                        this.getWebSocket().send(sendArgs);
                    }
                    catch (exception) {
                        var p = new fm.liveswitch.HttpResponseArgs(requestArgs);
                        p.setException(exception);
                        p.setStatusCode(0);
                        callback(p);
                    }
                    finally {
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebSocketWebRequestTransfer.prototype.setWebSocket = function (value) {
                if (arguments.length == 1) {
                    this._webSocket = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Releases any resources and shuts down.
            */
            WebSocketWebRequestTransfer.prototype.shutdown = function () {
                if (arguments.length == 0) {
                    _super.prototype.setOnOpenFailure.call(this, null);
                    _super.prototype.setOnOpenSuccess.call(this, null);
                    _super.prototype.setOnRequestCreated.call(this, null);
                    _super.prototype.setOnResponseReceived.call(this, null);
                    _super.prototype.setOnStreamFailure.call(this, null);
                    this.getWebSocket().close();
                    this.setWebSocket(null);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            WebSocketWebRequestTransfer.prototype.streamFailure = function (e) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(_super.prototype.getOnStreamFailure.call(this), null))) {
                        _super.prototype.getOnStreamFailure.call(this)(e);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return WebSocketWebRequestTransfer;
        }(fm.liveswitch.WebSocketTransfer));
        liveswitch.WebSocketWebRequestTransfer = WebSocketWebRequestTransfer;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A media configuration.
        */
        var MediaConfig = /** @class */ (function () {
            /**
            Initializes a new instance of the [[fm.liveswitch.mediaConfig]] class.
            @param clockRate The clock rate.
            */
            function MediaConfig(clockRate) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var clockRate_1 = __arguments[0];
                    //super();
                    this.fmliveswitchMediaConfigInit();
                    this.setClockRate(clockRate_1);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            MediaConfig.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaConfig]';
            };
            MediaConfig.prototype.fmliveswitchMediaConfigInit = function () {
                this._clockRate = 0;
            };
            /**
            Gets the clock rate.
            */
            MediaConfig.prototype.getClockRate = function () {
                if (arguments.length == 0) {
                    return this._clockRate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Determines whether the specified configuration is equivalent.
            @param config The configuration.
            */
            MediaConfig.prototype.isEquivalent = function (config) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(config, null))) {
                        return false;
                    }
                    return (fm.liveswitch.Global.equals(this.getClockRate(), config.getClockRate()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaConfig.prototype.setClockRate = function (value) {
                if (arguments.length == 1) {
                    this._clockRate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaConfig;
        }());
        liveswitch.MediaConfig = MediaConfig;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="MediaConfig.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        An audio configuration.
        */
        var AudioConfig = /** @class */ (function (_super) {
            __extends(AudioConfig, _super);
            /**
            Initializes a new instance of the [[fm.liveswitch.audioConfig]] class.
            @param clockRate The clock rate.
            @param channelCount The channel count.
            */
            function AudioConfig(clockRate, channelCount) {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 2) {
                    var clockRate_2 = __arguments[0];
                    var channelCount_1 = __arguments[1];
                    _this = _super.call(this, clockRate_2) || this;
                    _this.fmliveswitchAudioConfigInit();
                    _this.setChannelCount(channelCount_1);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            AudioConfig.prototype.getTypeString = function () {
                return '[fm.liveswitch.AudioConfig]' + ',' + _super.prototype.getTypeString.call(this);
            };
            AudioConfig.prototype.fmliveswitchAudioConfigInit = function () {
                this._channelCount = 0;
            };
            /**
            Gets the channel count.
            */
            AudioConfig.prototype.getChannelCount = function () {
                if (arguments.length == 0) {
                    return this._channelCount;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Determines whether the specified configuration is equivalent.
            @param config The configuration.
            */
            AudioConfig.prototype.isEquivalent = function (config) {
                if (arguments.length == 1) {
                    if (!_super.prototype.isEquivalent.call(this, config)) {
                        return false;
                    }
                    return (fm.liveswitch.Global.equals(this.getChannelCount(), config.getChannelCount()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            AudioConfig.prototype.setChannelCount = function (value) {
                if (arguments.length == 1) {
                    this._channelCount = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Returns a string that represents this instance.
            */
            AudioConfig.prototype.toString = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.format("Clock Rate: {0}, Channel Count: {1}", fm.liveswitch.NumberExtensions.toString(_super.prototype.getClockRate.call(this)), fm.liveswitch.NumberExtensions.toString(this.getChannelCount()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return AudioConfig;
        }(fm.liveswitch.MediaConfig));
        liveswitch.AudioConfig = AudioConfig;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Base stats.
        */
        var BaseStats = /** @class */ (function () {
            function BaseStats() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            BaseStats.prototype.getTypeString = function () {
                return '[fm.liveswitch.BaseStats]';
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            BaseStats.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "id"))) {
                            if ((fm.liveswitch.Global.equals(str, "timestamp"))) {
                                this.setTimestamp(fm.liveswitch.UnixTimestamp.unixMillisToDateTime(fm.liveswitch.JsonSerializer.deserializeLong(valueJson)));
                            }
                        }
                        else {
                            this.setId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the identifier of the object generating these stats.
            */
            BaseStats.prototype.getId = function () {
                if (arguments.length == 0) {
                    return this._id;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the timestamp when these stats were generated.
            */
            BaseStats.prototype.getTimestamp = function () {
                if (arguments.length == 0) {
                    return this._timestamp;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            BaseStats.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(this.getId(), null))) {
                        jsonObject["id"] = fm.liveswitch.JsonSerializer.serializeString(this.getId());
                    }
                    jsonObject["timestamp"] = fm.liveswitch.JsonSerializer.serializeLong(fm.liveswitch.UnixTimestamp.dateTimeToUnixMillis(this.getTimestamp()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            BaseStats.prototype.setId = function (value) {
                if (arguments.length == 1) {
                    this._id = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            BaseStats.prototype.setTimestamp = function (value) {
                if (arguments.length == 1) {
                    this._timestamp = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return BaseStats;
        }());
        liveswitch.BaseStats = BaseStats;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A bitrate notification.
        */
        var BitrateNotification = /** @class */ (function () {
            /**
            Initializes a new instance of the [[fm.liveswitch.bitrateNotification]] class.
            */
            function BitrateNotification() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchBitrateNotificationInit();
                    this.setSynchronizationSource(-1);
                    this.setMediaDescriptionId(null);
                    this.setRtpStreamId(null);
                    this.setBitrate(-1);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            BitrateNotification.prototype.getTypeString = function () {
                return '[fm.liveswitch.BitrateNotification]';
            };
            BitrateNotification.prototype.fmliveswitchBitrateNotificationInit = function () {
                this._bitrate = 0;
                this._synchronizationSource = 0;
            };
            /**
            Deserializes an instance from JSON.
            @param bitrateNotificationJson The instance in JSON format.
            @return The instance.
            */
            BitrateNotification.fromJson = function (bitrateNotificationJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(bitrateNotificationJson, function () {
                        return new fm.liveswitch.BitrateNotification();
                    }, function (bn, key, valueJson) {
                        bn.deserializeProperty(key, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array from JSON.
            @param bitrateNotificationsJson The array in JSON format.
            @return The array.
            */
            BitrateNotification.fromJsonArray = function (bitrateNotificationsJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(bitrateNotificationsJson, fm.liveswitch.BitrateNotification.fromJson.bind(fm.liveswitch.BitrateNotification));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param bitrateNotification The instance.
            @return The instance in JSON format.
            */
            BitrateNotification.toJson = function (bitrateNotification) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(bitrateNotification, function (bn, dict) {
                        bn.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param bitrateNotifications The array.
            @return The array in JSON format.
            */
            BitrateNotification.toJsonArray = function (bitrateNotifications) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(bitrateNotifications, fm.liveswitch.BitrateNotification.toJson.bind(fm.liveswitch.BitrateNotification));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a property from JSON.
            @param key The property key.
            @param valueJson The property value in JSON format.
            */
            BitrateNotification.prototype.deserializeProperty = function (key, valueJson) {
                if (arguments.length == 2) {
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "synchronizationSource"))) {
                            if ((fm.liveswitch.Global.equals(str, "mediaDescriptionId"))) {
                                this.setMediaDescriptionId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "rtpStreamId"))) {
                                    this.setRtpStreamId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "bitrate"))) {
                                        this.setBitrate(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                    }
                                }
                            }
                        }
                        else {
                            this.setSynchronizationSource(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the bitrate.
            */
            BitrateNotification.prototype.getBitrate = function () {
                if (arguments.length == 0) {
                    return this._bitrate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media description ID.
            */
            BitrateNotification.prototype.getMediaDescriptionId = function () {
                if (arguments.length == 0) {
                    return this._mediaDescriptionId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the RTP stream ID.
            */
            BitrateNotification.prototype.getRtpStreamId = function () {
                if (arguments.length == 0) {
                    return this._rtpStreamId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the synchronization source.
            */
            BitrateNotification.prototype.getSynchronizationSource = function () {
                if (arguments.length == 0) {
                    return this._synchronizationSource;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes properties to JSON.
            @param jsonObject The JSON target.
            */
            BitrateNotification.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(this.getSynchronizationSource(), -1))) {
                        jsonObject["synchronizationSource"] = fm.liveswitch.JsonSerializer.serializeLong(this.getSynchronizationSource());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getMediaDescriptionId(), null))) {
                        jsonObject["mediaDescriptionId"] = fm.liveswitch.JsonSerializer.serializeString(this.getMediaDescriptionId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRtpStreamId(), null))) {
                        jsonObject["rtpStreamId"] = fm.liveswitch.JsonSerializer.serializeString(this.getRtpStreamId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getBitrate(), -1))) {
                        jsonObject["bitrate"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getBitrate());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the bitrate.
            */
            BitrateNotification.prototype.setBitrate = function (value) {
                if (arguments.length == 1) {
                    this._bitrate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media description ID.
            */
            BitrateNotification.prototype.setMediaDescriptionId = function (value) {
                if (arguments.length == 1) {
                    this._mediaDescriptionId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the RTP stream ID.
            */
            BitrateNotification.prototype.setRtpStreamId = function (value) {
                if (arguments.length == 1) {
                    this._rtpStreamId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the synchronization source.
            */
            BitrateNotification.prototype.setSynchronizationSource = function (value) {
                if (arguments.length == 1) {
                    this._synchronizationSource = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            BitrateNotification.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.BitrateNotification.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return BitrateNotification;
        }());
        liveswitch.BitrateNotification = BitrateNotification;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A bitrate request.
        */
        var BitrateRequest = /** @class */ (function () {
            /**
            Initializes a new instance of the [[fm.liveswitch.bitrateRequest]] class.
            */
            function BitrateRequest() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchBitrateRequestInit();
                    this.setSynchronizationSource(-1);
                    this.setMediaDescriptionId(null);
                    this.setRtpStreamId(null);
                    this.setBitrate(-1);
                    this.setSenderSynchronizationSource(-1);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            BitrateRequest.prototype.getTypeString = function () {
                return '[fm.liveswitch.BitrateRequest]';
            };
            BitrateRequest.prototype.fmliveswitchBitrateRequestInit = function () {
                this._bitrate = 0;
                this._senderSynchronizationSource = 0;
                this._synchronizationSource = 0;
            };
            /**
            Deserializes an instance from JSON.
            @param bitrateRequestJson The instance in JSON format.
            @return The instance.
            */
            BitrateRequest.fromJson = function (bitrateRequestJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(bitrateRequestJson, function () {
                        return new fm.liveswitch.BitrateRequest();
                    }, function (br, key, valueJson) {
                        br.deserializeProperty(key, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array from JSON.
            @param bitrateRequestsJson The array in JSON format.
            @return The array.
            */
            BitrateRequest.fromJsonArray = function (bitrateRequestsJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(bitrateRequestsJson, fm.liveswitch.BitrateRequest.fromJson.bind(fm.liveswitch.BitrateRequest));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param bitrateRequest The instance.
            @return The instance in JSON format.
            */
            BitrateRequest.toJson = function (bitrateRequest) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(bitrateRequest, function (br, dict) {
                        br.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param bitrateRequests The array.
            @return The array in JSON format.
            */
            BitrateRequest.toJsonArray = function (bitrateRequests) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(bitrateRequests, fm.liveswitch.BitrateRequest.toJson.bind(fm.liveswitch.BitrateRequest));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a property from JSON.
            @param key The property key.
            @param valueJson The property value in JSON format.
            */
            BitrateRequest.prototype.deserializeProperty = function (key, valueJson) {
                if (arguments.length == 2) {
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "synchronizationSource"))) {
                            if ((fm.liveswitch.Global.equals(str, "mediaDescriptionId"))) {
                                this.setMediaDescriptionId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "rtpStreamId"))) {
                                    this.setRtpStreamId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "bitrate"))) {
                                        this.setBitrate(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "senderSynchronizationSource"))) {
                                            this.setSenderSynchronizationSource(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            this.setSynchronizationSource(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the bitrate.
            */
            BitrateRequest.prototype.getBitrate = function () {
                if (arguments.length == 0) {
                    return this._bitrate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media description ID.
            */
            BitrateRequest.prototype.getMediaDescriptionId = function () {
                if (arguments.length == 0) {
                    return this._mediaDescriptionId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the RTP stream ID.
            */
            BitrateRequest.prototype.getRtpStreamId = function () {
                if (arguments.length == 0) {
                    return this._rtpStreamId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the sender synchronization source.
            */
            BitrateRequest.prototype.getSenderSynchronizationSource = function () {
                if (arguments.length == 0) {
                    return this._senderSynchronizationSource;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the synchronization source.
            */
            BitrateRequest.prototype.getSynchronizationSource = function () {
                if (arguments.length == 0) {
                    return this._synchronizationSource;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes properties to JSON.
            @param jsonObject The JSON target.
            */
            BitrateRequest.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(this.getSynchronizationSource(), -1))) {
                        jsonObject["synchronizationSource"] = fm.liveswitch.JsonSerializer.serializeLong(this.getSynchronizationSource());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getMediaDescriptionId(), null))) {
                        jsonObject["mediaDescriptionId"] = fm.liveswitch.JsonSerializer.serializeString(this.getMediaDescriptionId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRtpStreamId(), null))) {
                        jsonObject["rtpStreamId"] = fm.liveswitch.JsonSerializer.serializeString(this.getRtpStreamId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getBitrate(), -1))) {
                        jsonObject["bitrate"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getBitrate());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getSenderSynchronizationSource(), -1))) {
                        jsonObject["senderSynchronizationSource"] = fm.liveswitch.JsonSerializer.serializeLong(this.getSenderSynchronizationSource());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the bitrate.
            */
            BitrateRequest.prototype.setBitrate = function (value) {
                if (arguments.length == 1) {
                    this._bitrate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media description ID.
            */
            BitrateRequest.prototype.setMediaDescriptionId = function (value) {
                if (arguments.length == 1) {
                    this._mediaDescriptionId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the RTP stream ID.
            */
            BitrateRequest.prototype.setRtpStreamId = function (value) {
                if (arguments.length == 1) {
                    this._rtpStreamId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the sender synchronization source.
            */
            BitrateRequest.prototype.setSenderSynchronizationSource = function (value) {
                if (arguments.length == 1) {
                    this._senderSynchronizationSource = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the synchronization source.
            */
            BitrateRequest.prototype.setSynchronizationSource = function (value) {
                if (arguments.length == 1) {
                    this._synchronizationSource = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            BitrateRequest.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.BitrateRequest.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return BitrateRequest;
        }());
        liveswitch.BitrateRequest = BitrateRequest;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Information.
        */
        var Info = /** @class */ (function () {
            function Info() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Info.prototype.getTypeString = function () {
                return '[fm.liveswitch.Info]';
            };
            /**
            Processes an array for an info.
            @param newValues The new values.
            @param oldValues The old values.
            @return The new values, if the new values are not equivalent to the old values; otherwise null.
            */
            Info.processArray = function (newValues, oldValues) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(newValues, oldValues))) {
                        return null;
                    }
                    if ((((!fm.liveswitch.Global.equals(newValues, null)) && (!fm.liveswitch.Global.equals(oldValues, null))) && (fm.liveswitch.Global.equals(oldValues.length, newValues.length)))) {
                        for (var i = 0; (i < newValues.length); i++) {
                            if (!newValues[i].isEquivalent(oldValues[i])) {
                                return newValues;
                            }
                        }
                        return null;
                    }
                    return newValues;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a boolean for an info.
            @param newValue The new value.
            @param oldValue The old value.
            @return The new value, if the new value does not equal the old value; otherwise null.
            */
            Info.processBoolean = function (newValue, oldValue) {
                if (arguments.length == 2) {
                    return ((fm.liveswitch.Global.equals(newValue, oldValue)) ? null : newValue);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a boolean array for an info.
            @param newValues The new values.
            @param oldValues The old values.
            @return The new values, if the new values do not equal the old values; otherwise null.
            */
            Info.processBooleanArray = function (newValues, oldValues) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(newValues, oldValues))) {
                        return null;
                    }
                    if ((((!fm.liveswitch.Global.equals(newValues, null)) && (!fm.liveswitch.Global.equals(oldValues, null))) && (fm.liveswitch.Global.equals(oldValues.length, newValues.length)))) {
                        for (var i = 0; (i < newValues.length); i++) {
                            if ((!fm.liveswitch.Global.equals(newValues[i], oldValues[i]))) {
                                return newValues;
                            }
                        }
                        return null;
                    }
                    return newValues;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a double for an info.
            @param newValue The new value.
            @param oldValue The old value.
            @return The new value, if the new value does not equal the old value; otherwise null.
            */
            Info.processDouble = function (newValue, oldValue) {
                if (arguments.length == 2) {
                    return ((fm.liveswitch.Global.equals(newValue, oldValue)) ? null : newValue);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a float for an info.
            @param newValue The new value.
            @param oldValue The old value.
            @return The new value, if the new value does not equal the old value; otherwise null.
            */
            Info.processFloat = function (newValue, oldValue) {
                if (arguments.length == 2) {
                    return ((fm.liveswitch.Global.equals(newValue, oldValue)) ? null : newValue);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a float array for an info.
            @param newValues The new values.
            @param oldValues The old values.
            @return The new values, if the new values do not equal the old values; otherwise null.
            */
            Info.processFloatArray = function (newValues, oldValues) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(newValues, oldValues))) {
                        return null;
                    }
                    if ((((!fm.liveswitch.Global.equals(newValues, null)) && (!fm.liveswitch.Global.equals(oldValues, null))) && (fm.liveswitch.Global.equals(oldValues.length, newValues.length)))) {
                        for (var i = 0; (i < newValues.length); i++) {
                            if ((!fm.liveswitch.Global.equals(newValues[i], oldValues[i]))) {
                                return newValues;
                            }
                        }
                        return null;
                    }
                    return newValues;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes an integer for an info.
            @param newValue The new value.
            @param oldValue The old value.
            @return The new value, if the new value does not equal the old value; otherwise null.
            */
            Info.processInteger = function (newValue, oldValue) {
                if (arguments.length == 2) {
                    return ((fm.liveswitch.Global.equals(newValue, oldValue)) ? null : newValue);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a integer array for an info.
            @param newValues The new values.
            @param oldValues The old values.
            @return The new values, if the new values do not equal the old values; otherwise null.
            */
            Info.processIntegerArray = function (newValues, oldValues) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(newValues, oldValues))) {
                        return null;
                    }
                    if ((((!fm.liveswitch.Global.equals(newValues, null)) && (!fm.liveswitch.Global.equals(oldValues, null))) && (fm.liveswitch.Global.equals(oldValues.length, newValues.length)))) {
                        for (var i = 0; (i < newValues.length); i++) {
                            if ((!fm.liveswitch.Global.equals(newValues[i], oldValues[i]))) {
                                return newValues;
                            }
                        }
                        return null;
                    }
                    return newValues;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a long for an info.
            @param newValue The new value.
            @param oldValue The old value.
            @return The new value, if the new value does not equal the old value; otherwise null.
            */
            Info.processLong = function (newValue, oldValue) {
                if (arguments.length == 2) {
                    return ((fm.liveswitch.Global.equals(newValue, oldValue)) ? null : newValue);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a long array for an info.
            @param newValues The new values.
            @param oldValues The old values.
            @return The new values, if the new values do not equal the old values; otherwise null.
            */
            Info.processLongArray = function (newValues, oldValues) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(newValues, oldValues))) {
                        return null;
                    }
                    if ((((!fm.liveswitch.Global.equals(newValues, null)) && (!fm.liveswitch.Global.equals(oldValues, null))) && (fm.liveswitch.Global.equals(oldValues.length, newValues.length)))) {
                        for (var i = 0; (i < newValues.length); i++) {
                            if ((!fm.liveswitch.Global.equals(newValues[i], oldValues[i]))) {
                                return newValues;
                            }
                        }
                        return null;
                    }
                    return newValues;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes an object for an info.
            @param newValue The new value.
            @param oldValue The old value.
            @return The new value, if the new value does not equal the old value; otherwise null.
            */
            Info.processObject = function (newValue, oldValue) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(newValue, oldValue))) {
                        return null;
                    }
                    if ((((!fm.liveswitch.Global.equals(newValue, null)) && (!fm.liveswitch.Global.equals(oldValue, null))) && newValue.isEquivalent(oldValue))) {
                        return null;
                    }
                    return newValue;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a short for an info.
            @param newValue The new value.
            @param oldValue The old value.
            @return The new value, if the new value does not equal the old value; otherwise null.
            */
            Info.processShort = function (newValue, oldValue) {
                if (arguments.length == 2) {
                    return ((fm.liveswitch.Global.equals(newValue, oldValue)) ? null : newValue);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a short array for an info.
            @param newValues The new values.
            @param oldValues The old values.
            @return The new values, if the new values do not equal the old values; otherwise null.
            */
            Info.processShortArray = function (newValues, oldValues) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(newValues, oldValues))) {
                        return null;
                    }
                    if ((((!fm.liveswitch.Global.equals(newValues, null)) && (!fm.liveswitch.Global.equals(oldValues, null))) && (fm.liveswitch.Global.equals(oldValues.length, newValues.length)))) {
                        for (var i = 0; (i < newValues.length); i++) {
                            if ((!fm.liveswitch.Global.equals(newValues[i], oldValues[i]))) {
                                return newValues;
                            }
                        }
                        return null;
                    }
                    return newValues;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a string for an info.
            @param newValue The new value.
            @param oldValue The old value.
            @return The new value, if the new value does not equal the old value; otherwise null.
            */
            Info.processString = function (newValue, oldValue) {
                if (arguments.length == 2) {
                    return ((fm.liveswitch.Global.equals(newValue, oldValue)) ? null : newValue);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            Info.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    var str = key;
                    if (((!fm.liveswitch.Global.equals(str, null)) && (fm.liveswitch.Global.equals(str, "id")))) {
                        this.setId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the identifier.
            */
            Info.prototype.getId = function () {
                if (arguments.length == 0) {
                    return this._id;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            Info.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(this.getId(), null))) {
                        jsonObject["id"] = fm.liveswitch.JsonSerializer.serializeString(this.getId());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the identifier.
            */
            Info.prototype.setId = function (value) {
                if (arguments.length == 1) {
                    this._id = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Info;
        }());
        liveswitch.Info = Info;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Candidate information.
        */
        var CandidateInfo = /** @class */ (function (_super) {
            __extends(CandidateInfo, _super);
            function CandidateInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchCandidateInfoInit();
                }
                else if (__arguments.length == 2) {
                    var stats = __arguments[0];
                    var lastStats = __arguments[1];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchCandidateInfoInit();
                    _super.prototype.setId.call(_this, stats.getId());
                    var flag = (fm.liveswitch.Global.equals(lastStats, null));
                    _this.setIPAddress((flag ? stats.getIPAddress() : fm.liveswitch.Info.processString(stats.getIPAddress(), lastStats.getIPAddress())));
                    _this.setPort((flag ? stats.getPort() : fm.liveswitch.Info.processInteger(stats.getPort(), lastStats.getPort())));
                    _this.setPriority((flag ? stats.getPriority() : fm.liveswitch.Info.processLong(stats.getPriority(), lastStats.getPriority())));
                    _this.setProtocol(((!flag && (fm.liveswitch.Global.equals(stats.getProtocol(), lastStats.getProtocol()))) ? null : fm.liveswitch.CandidateUtility.protocolTypeToString(stats.getProtocol())));
                    _this.setRelatedIPAddress((flag ? stats.getRelatedIPAddress() : fm.liveswitch.Info.processString(stats.getRelatedIPAddress(), lastStats.getRelatedIPAddress())));
                    _this.setRelatedPort((flag ? stats.getRelatedPort() : fm.liveswitch.Info.processInteger(stats.getRelatedPort(), lastStats.getRelatedPort())));
                    _this.setRelayProtocol(((!flag && (fm.liveswitch.Global.equals(stats.getRelayProtocol(), lastStats.getRelayProtocol()))) ? null : fm.liveswitch.CandidateUtility.protocolTypeToString(stats.getRelayProtocol())));
                    _this.setType(((!flag && (fm.liveswitch.Global.equals(stats.getType(), lastStats.getType()))) ? null : fm.liveswitch.CandidateUtility.typeToString(stats.getType())));
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            CandidateInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.CandidateInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            CandidateInfo.prototype.fmliveswitchCandidateInfoInit = function () {
                this._port = 0;
                this._priority = 0;
                this._relatedPort = 0;
            };
            /**
            Deserializes an instance from JSON.
            @param candidateReportJson The JSON.
            @return The deserialized instance.
            */
            CandidateInfo.fromJson = function (candidateReportJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(candidateReportJson, function () {
                        return new fm.liveswitch.CandidateInfo();
                    }, function (obj, key, valueJson) {
                        obj.deserializeProperties(key, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array from JSON.
            @param candidateReportsJson The JSON.
            @return The deserialized array.
            */
            CandidateInfo.fromJsonArray = function (candidateReportsJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(candidateReportsJson, fm.liveswitch.CandidateInfo.fromJson.bind(fm.liveswitch.CandidateInfo));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param candidateReport The instance.
            @return The serialized JSON.
            */
            CandidateInfo.toJson = function (candidateReport) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(candidateReport, function (obj, jsonObject) {
                        obj.serializeProperties(jsonObject);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param candidateReports The array.
            @return The serialized JSON.
            */
            CandidateInfo.toJsonArray = function (candidateReports) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(candidateReports, fm.liveswitch.CandidateInfo.toJson.bind(fm.liveswitch.CandidateInfo));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            CandidateInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var _var0 = key;
                    if (_var0 == "ipAddress") {
                        do {
                            this.setIPAddress(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "port") {
                        do {
                            this.setPort(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "relatedIPAddress") {
                        do {
                            this.setRelatedIPAddress(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "relatedPort") {
                        do {
                            this.setRelatedPort(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "protocol") {
                        do {
                            this.setProtocol(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "relayProtocol") {
                        do {
                            this.setRelayProtocol(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "type") {
                        do {
                            this.setType(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "priority") {
                        do {
                            this.setPriority(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the candidate IP address.
            */
            CandidateInfo.prototype.getIPAddress = function () {
                if (arguments.length == 0) {
                    return this._ipAddress;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the candidate port.
            */
            CandidateInfo.prototype.getPort = function () {
                if (arguments.length == 0) {
                    return this._port;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the candidate priority.
            */
            CandidateInfo.prototype.getPriority = function () {
                if (arguments.length == 0) {
                    return this._priority;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the candidate protocol.
            */
            CandidateInfo.prototype.getProtocol = function () {
                if (arguments.length == 0) {
                    return this._protocol;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the candidate related IP address.
            */
            CandidateInfo.prototype.getRelatedIPAddress = function () {
                if (arguments.length == 0) {
                    return this._relatedIPAddress;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the candidate related port.
            */
            CandidateInfo.prototype.getRelatedPort = function () {
                if (arguments.length == 0) {
                    return this._relatedPort;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the candidate relay protocol.
            */
            CandidateInfo.prototype.getRelayProtocol = function () {
                if (arguments.length == 0) {
                    return this._relayProtocol;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the candidate type.
            */
            CandidateInfo.prototype.getType = function () {
                if (arguments.length == 0) {
                    return this._type;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            CandidateInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getIPAddress(), null))) {
                        jsonObject["ipAddress"] = fm.liveswitch.JsonSerializer.serializeString(this.getIPAddress());
                    }
                    if ((this.getPort() != null)) {
                        jsonObject["port"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getPort());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRelatedIPAddress(), null))) {
                        jsonObject["relatedIPAddress"] = fm.liveswitch.JsonSerializer.serializeString(this.getRelatedIPAddress());
                    }
                    if ((this.getRelatedPort() != null)) {
                        jsonObject["relatedPort"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getRelatedPort());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getProtocol(), null))) {
                        jsonObject["protocol"] = fm.liveswitch.JsonSerializer.serializeString(this.getProtocol());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRelayProtocol(), null))) {
                        jsonObject["relayProtocol"] = fm.liveswitch.JsonSerializer.serializeString(this.getRelayProtocol());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getType(), null))) {
                        jsonObject["type"] = fm.liveswitch.JsonSerializer.serializeString(this.getType());
                    }
                    if ((this.getPriority() != null)) {
                        jsonObject["priority"] = fm.liveswitch.JsonSerializer.serializeLong(this.getPriority());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the candidate IP address.
            */
            CandidateInfo.prototype.setIPAddress = function (value) {
                if (arguments.length == 1) {
                    this._ipAddress = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the candidate port.
            */
            CandidateInfo.prototype.setPort = function (value) {
                if (arguments.length == 1) {
                    this._port = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the candidate priority.
            */
            CandidateInfo.prototype.setPriority = function (value) {
                if (arguments.length == 1) {
                    this._priority = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the candidate protocol.
            */
            CandidateInfo.prototype.setProtocol = function (value) {
                if (arguments.length == 1) {
                    this._protocol = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the candidate related IP address.
            */
            CandidateInfo.prototype.setRelatedIPAddress = function (value) {
                if (arguments.length == 1) {
                    this._relatedIPAddress = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the candidate related port.
            */
            CandidateInfo.prototype.setRelatedPort = function (value) {
                if (arguments.length == 1) {
                    this._relatedPort = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the candidate relay protocol.
            */
            CandidateInfo.prototype.setRelayProtocol = function (value) {
                if (arguments.length == 1) {
                    this._relayProtocol = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the candidate type.
            */
            CandidateInfo.prototype.setType = function (value) {
                if (arguments.length == 1) {
                    this._type = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            CandidateInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.CandidateInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return CandidateInfo;
        }(fm.liveswitch.Info));
        liveswitch.CandidateInfo = CandidateInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Candidate pair information.
        */
        var CandidatePairInfo = /** @class */ (function (_super) {
            __extends(CandidatePairInfo, _super);
            function CandidatePairInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchCandidatePairInfoInit();
                }
                else if (__arguments.length == 2) {
                    var stats = __arguments[0];
                    var lastStats = __arguments[1];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchCandidatePairInfoInit();
                    _super.prototype.setId.call(_this, stats.getId());
                    var flag = (fm.liveswitch.Global.equals(lastStats, null));
                    _this.setLocalCandidateId(stats.getLocalCandidateId());
                    _this.setRemoteCandidateId(stats.getRemoteCandidateId());
                    _this.setState(((!flag && (fm.liveswitch.Global.equals(stats.getState(), lastStats.getState()))) ? null : fm.liveswitch.CandidateUtility.candidatePairStateToString(stats.getState())));
                    _this.setPriority((flag ? stats.getPriority() : fm.liveswitch.Info.processLong(stats.getPriority(), lastStats.getPriority())));
                    _this.setNominated((flag ? stats.getNominated() : fm.liveswitch.Info.processBoolean(stats.getNominated(), lastStats.getNominated())));
                    _this.setReport(new fm.liveswitch.CandidatePairReport(stats, lastStats));
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            CandidatePairInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.CandidatePairInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            CandidatePairInfo.prototype.fmliveswitchCandidatePairInfoInit = function () {
                this._nominated = false;
                this._priority = 0;
            };
            /**
            Deserializes an instance from JSON.
            @param instanceJson The instance JSON.
            @return The deserialized instance.
            */
            CandidatePairInfo.fromJson = function (instanceJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(instanceJson, function () {
                        return new fm.liveswitch.CandidatePairInfo();
                    }, function (obj, key, valueJson) {
                        obj.deserializeProperties(key, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Derializes an array from JSON.
            @param arrayJson The array JSON.
            @return The deserialized array.
            */
            CandidatePairInfo.fromJsonArray = function (arrayJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(arrayJson, fm.liveswitch.CandidatePairInfo.fromJson.bind(fm.liveswitch.CandidatePairInfo));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param instance The instance.
            @return The serialized instance JSON.
            */
            CandidatePairInfo.toJson = function (instance) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(instance, function (obj, jsonObject) {
                        obj.serializeProperties(jsonObject);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param array The array.
            @return The serialized array JSON.
            */
            CandidatePairInfo.toJsonArray = function (array) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(array, fm.liveswitch.CandidatePairInfo.toJson.bind(fm.liveswitch.CandidatePairInfo));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            CandidatePairInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "localCandidateId"))) {
                            if ((fm.liveswitch.Global.equals(str, "remoteCandidateId"))) {
                                this.setRemoteCandidateId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "state"))) {
                                    this.setState(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "priority"))) {
                                        this.setPriority(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "nominated"))) {
                                            this.setNominated(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                        }
                                        else {
                                            if ((fm.liveswitch.Global.equals(str, "report"))) {
                                                this.setReport(fm.liveswitch.CandidatePairReport.fromJson(valueJson));
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            this.setLocalCandidateId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the candidate pair's local candidate identifier.
            */
            CandidatePairInfo.prototype.getLocalCandidateId = function () {
                if (arguments.length == 0) {
                    return this._localCandidateId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the candidate pair is nominated.
            */
            CandidatePairInfo.prototype.getNominated = function () {
                if (arguments.length == 0) {
                    return this._nominated;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the candidate pair priority.
            */
            CandidatePairInfo.prototype.getPriority = function () {
                if (arguments.length == 0) {
                    return this._priority;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the candidate pair's remote candidate identifier.
            */
            CandidatePairInfo.prototype.getRemoteCandidateId = function () {
                if (arguments.length == 0) {
                    return this._remoteCandidateId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the candidate pair report.
            */
            CandidatePairInfo.prototype.getReport = function () {
                if (arguments.length == 0) {
                    return this._report;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the candidate pair state.
            */
            CandidatePairInfo.prototype.getState = function () {
                if (arguments.length == 0) {
                    return this._state;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            CandidatePairInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getLocalCandidateId(), null))) {
                        jsonObject["localCandidateId"] = fm.liveswitch.JsonSerializer.serializeString(this.getLocalCandidateId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRemoteCandidateId(), null))) {
                        jsonObject["remoteCandidateId"] = fm.liveswitch.JsonSerializer.serializeString(this.getRemoteCandidateId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getState(), null))) {
                        jsonObject["state"] = fm.liveswitch.JsonSerializer.serializeString(this.getState());
                    }
                    if ((this.getPriority() != null)) {
                        jsonObject["priority"] = fm.liveswitch.JsonSerializer.serializeLong(this.getPriority());
                    }
                    if ((this.getNominated() != null)) {
                        jsonObject["nominated"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getNominated());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getReport(), null))) {
                        jsonObject["report"] = fm.liveswitch.CandidatePairReport.toJson(this.getReport());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the candidate pair's local candidate identifier.
            */
            CandidatePairInfo.prototype.setLocalCandidateId = function (value) {
                if (arguments.length == 1) {
                    this._localCandidateId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the candidate pair is nominated.
            */
            CandidatePairInfo.prototype.setNominated = function (value) {
                if (arguments.length == 1) {
                    this._nominated = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the candidate pair priority.
            */
            CandidatePairInfo.prototype.setPriority = function (value) {
                if (arguments.length == 1) {
                    this._priority = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the candidate pair's remote candidate identifier.
            */
            CandidatePairInfo.prototype.setRemoteCandidateId = function (value) {
                if (arguments.length == 1) {
                    this._remoteCandidateId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the candidate pair report.
            */
            CandidatePairInfo.prototype.setReport = function (value) {
                if (arguments.length == 1) {
                    this._report = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the candidate pair state.
            */
            CandidatePairInfo.prototype.setState = function (value) {
                if (arguments.length == 1) {
                    this._state = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            CandidatePairInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.CandidatePairInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return CandidatePairInfo;
        }(fm.liveswitch.Info));
        liveswitch.CandidatePairInfo = CandidatePairInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var CandidatePairStateWrapper = /** @class */ (function () {
            function CandidatePairStateWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_18 = __arguments[0];
                    //super();
                    this._value = value_18;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            CandidatePairStateWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.CandidatePairStateWrapper]';
            };
            CandidatePairStateWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.CandidatePairState.New)
                        return 'New';
                    if (this._value == fm.liveswitch.CandidatePairState.Waiting)
                        return 'Waiting';
                    if (this._value == fm.liveswitch.CandidatePairState.InProgress)
                        return 'InProgress';
                    if (this._value == fm.liveswitch.CandidatePairState.Succeeded)
                        return 'Succeeded';
                    if (this._value == fm.liveswitch.CandidatePairState.Failed)
                        return 'Failed';
                    if (this._value == fm.liveswitch.CandidatePairState.Closed)
                        return 'Closed';
                    if (this._value == fm.liveswitch.CandidatePairState.ConnectivityLost)
                        return 'ConnectivityLost';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return CandidatePairStateWrapper;
        }());
        liveswitch.CandidatePairStateWrapper = CandidatePairStateWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="BaseStats.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Candidate pair stats.
        */
        var CandidatePairStats = /** @class */ (function (_super) {
            __extends(CandidatePairStats, _super);
            /**
            Initializes a new instance of the [[fm.liveswitch.candidatePairStats]] class.
            */
            function CandidatePairStats() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchCandidatePairStatsInit();
                    _this.setState(fm.liveswitch.CandidatePairState.New);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            CandidatePairStats.prototype.getTypeString = function () {
                return '[fm.liveswitch.CandidatePairStats]' + ',' + _super.prototype.getTypeString.call(this);
            };
            CandidatePairStats.prototype.fmliveswitchCandidatePairStatsInit = function () {
                this._bytesReceived = 0;
                this._bytesSent = 0;
                this._consentRequestsReceived = 0;
                this._consentRequestsSent = 0;
                this._consentResponsesReceived = 0;
                this._consentResponsesSent = 0;
                this._currentRoundTripTime = 0;
                this._nominated = false;
                this._priority = 0;
                this._requestsReceived = 0;
                this._requestsSent = 0;
                this._responsesReceived = 0;
                this._responsesSent = 0;
                this._totalRoundTripTime = 0;
            };
            /**
            Derializes candidate pair stats from JSON.
            @param candidatePairJson The candidate pair's stats JSON.
            */
            CandidatePairStats.fromJson = function (candidatePairJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(candidatePairJson, function () {
                        return new fm.liveswitch.CandidatePairStats();
                    }, function (obj, key, valueJson) {
                        obj.deserializeProperties(key, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Derializes an array of candidate pair stats from JSON.
            @param candidatePairsJson The candidate pairs' stats JSON.
            */
            CandidatePairStats.fromJsonArray = function (candidatePairsJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(candidatePairsJson, fm.liveswitch.CandidatePairStats.fromJson.bind(fm.liveswitch.CandidatePairStats));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes candidate pair stats to JSON.
            @param candidatePair The candidate pair's stats.
            */
            CandidatePairStats.toJson = function (candidatePair) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(candidatePair, function (obj, jsonObject) {
                        obj.serializeProperties(jsonObject);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array of candidate pair stats to JSON.
            @param candidatePairs The candidate pairs' stats.
            */
            CandidatePairStats.toJsonArray = function (candidatePairs) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(candidatePairs, fm.liveswitch.CandidatePairStats.toJson.bind(fm.liveswitch.CandidatePairStats));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            CandidatePairStats.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var _var0 = key;
                    if (_var0 == "transportId") {
                        do {
                            this.setTransportId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "localCandidateId") {
                        do {
                            this.setLocalCandidateId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "remoteCandidateId") {
                        do {
                            this.setRemoteCandidateId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "state") {
                        do {
                            this.setState(fm.liveswitch.CandidateUtility.candidatePairStateFromString(fm.liveswitch.JsonSerializer.deserializeString(valueJson)));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "priority") {
                        do {
                            this.setPriority(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "nominated") {
                        do {
                            this.setNominated(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "bytesSent") {
                        do {
                            this.setBytesSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "bytesReceived") {
                        do {
                            this.setBytesReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "requestsSent") {
                        do {
                            this.setRequestsSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "requestsReceived") {
                        do {
                            this.setRequestsReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "responsesSent") {
                        do {
                            this.setResponsesSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "responsesReceived") {
                        do {
                            this.setResponsesReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "consentRequestsSent") {
                        do {
                            this.setConsentRequestsSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "consentRequestsReceived") {
                        do {
                            this.setConsentRequestsReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "consentResponsesSent") {
                        do {
                            this.setConsentResponsesSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "consentResponsesReceived") {
                        do {
                            this.setConsentResponsesReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "totalRoundTripTime") {
                        do {
                            this.setTotalRoundTripTime(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "currentRoundTripTime") {
                        do {
                            this.setCurrentRoundTripTime(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes received.
            */
            CandidatePairStats.prototype.getBytesReceived = function () {
                if (arguments.length == 0) {
                    return this._bytesReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes sent.
            */
            CandidatePairStats.prototype.getBytesSent = function () {
                if (arguments.length == 0) {
                    return this._bytesSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of consent requests received.
            */
            CandidatePairStats.prototype.getConsentRequestsReceived = function () {
                if (arguments.length == 0) {
                    return this._consentRequestsReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of consent requests sent.
            */
            CandidatePairStats.prototype.getConsentRequestsSent = function () {
                if (arguments.length == 0) {
                    return this._consentRequestsSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of consent responses received.
            */
            CandidatePairStats.prototype.getConsentResponsesReceived = function () {
                if (arguments.length == 0) {
                    return this._consentResponsesReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of consent responses sent.
            */
            CandidatePairStats.prototype.getConsentResponsesSent = function () {
                if (arguments.length == 0) {
                    return this._consentResponsesSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the current round trip time in milliseconds.
            */
            CandidatePairStats.prototype.getCurrentRoundTripTime = function () {
                if (arguments.length == 0) {
                    return this._currentRoundTripTime;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the local candidate identifier.
            */
            CandidatePairStats.prototype.getLocalCandidateId = function () {
                if (arguments.length == 0) {
                    return this._localCandidateId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the candidate pair is nominated.
            */
            CandidatePairStats.prototype.getNominated = function () {
                if (arguments.length == 0) {
                    return this._nominated;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the priority.
            */
            CandidatePairStats.prototype.getPriority = function () {
                if (arguments.length == 0) {
                    return this._priority;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote candidate identifier.
            */
            CandidatePairStats.prototype.getRemoteCandidateId = function () {
                if (arguments.length == 0) {
                    return this._remoteCandidateId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of requests received.
            */
            CandidatePairStats.prototype.getRequestsReceived = function () {
                if (arguments.length == 0) {
                    return this._requestsReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of requests sent.
            */
            CandidatePairStats.prototype.getRequestsSent = function () {
                if (arguments.length == 0) {
                    return this._requestsSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of responses received.
            */
            CandidatePairStats.prototype.getResponsesReceived = function () {
                if (arguments.length == 0) {
                    return this._responsesReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of responses sent.
            */
            CandidatePairStats.prototype.getResponsesSent = function () {
                if (arguments.length == 0) {
                    return this._responsesSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the state.
            */
            CandidatePairStats.prototype.getState = function () {
                if (arguments.length == 0) {
                    return this._state;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the total round trip time in milliseconds.
            */
            CandidatePairStats.prototype.getTotalRoundTripTime = function () {
                if (arguments.length == 0) {
                    return this._totalRoundTripTime;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the transport identifier.
            */
            CandidatePairStats.prototype.getTransportId = function () {
                if (arguments.length == 0) {
                    return this._transportId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Checks if a candidate pair is equivalent to this one.
            @param instance The candidate pair.
            */
            CandidatePairStats.prototype.isEquivalent = function (instance) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(instance, null))) {
                        return false;
                    }
                    return (((((((fm.liveswitch.Global.equals(instance.getTransportId(), this.getTransportId())) && (fm.liveswitch.Global.equals(instance.getLocalCandidateId(), this.getLocalCandidateId()))) && ((fm.liveswitch.Global.equals(instance.getRemoteCandidateId(), this.getRemoteCandidateId())) && (fm.liveswitch.Global.equals(instance.getState(), this.getState())))) && (((fm.liveswitch.Global.equals(instance.getPriority(), this.getPriority())) && (fm.liveswitch.Global.equals(instance.getNominated(), this.getNominated()))) && ((fm.liveswitch.Global.equals(instance.getBytesSent(), this.getBytesSent())) && (fm.liveswitch.Global.equals(instance.getBytesReceived(), this.getBytesReceived()))))) && ((((fm.liveswitch.Global.equals(instance.getRequestsSent(), this.getRequestsSent())) && (fm.liveswitch.Global.equals(instance.getRequestsReceived(), this.getRequestsReceived()))) && ((fm.liveswitch.Global.equals(instance.getResponsesSent(), this.getResponsesSent())) && (fm.liveswitch.Global.equals(instance.getResponsesReceived(), this.getResponsesReceived())))) && (((fm.liveswitch.Global.equals(instance.getConsentRequestsSent(), this.getConsentRequestsSent())) && (fm.liveswitch.Global.equals(instance.getConsentRequestsReceived(), this.getConsentRequestsReceived()))) && ((fm.liveswitch.Global.equals(instance.getConsentResponsesSent(), this.getConsentResponsesSent())) && (fm.liveswitch.Global.equals(instance.getConsentResponsesReceived(), this.getConsentResponsesReceived())))))) && (fm.liveswitch.Global.equals(instance.getTotalRoundTripTime(), this.getTotalRoundTripTime()))) && (fm.liveswitch.Global.equals(instance.getCurrentRoundTripTime(), this.getCurrentRoundTripTime())));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            CandidatePairStats.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getTransportId(), null))) {
                        jsonObject["transportId"] = fm.liveswitch.JsonSerializer.serializeString(this.getTransportId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getLocalCandidateId(), null))) {
                        jsonObject["localCandidateId"] = fm.liveswitch.JsonSerializer.serializeString(this.getLocalCandidateId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRemoteCandidateId(), null))) {
                        jsonObject["remoteCandidateId"] = fm.liveswitch.JsonSerializer.serializeString(this.getRemoteCandidateId());
                    }
                    jsonObject["state"] = fm.liveswitch.JsonSerializer.serializeString(fm.liveswitch.CandidateUtility.candidatePairStateToString(this.getState()));
                    jsonObject["priority"] = fm.liveswitch.JsonSerializer.serializeLong(this.getPriority());
                    jsonObject["nominated"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getNominated());
                    jsonObject["bytesSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getBytesSent());
                    jsonObject["bytesReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getBytesReceived());
                    jsonObject["requestsSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getRequestsSent());
                    jsonObject["requestsReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getRequestsReceived());
                    jsonObject["responsesSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getResponsesSent());
                    jsonObject["responsesReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getResponsesReceived());
                    jsonObject["consentRequestsSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getConsentRequestsSent());
                    jsonObject["consentRequestsReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getConsentRequestsReceived());
                    jsonObject["consentResponsesSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getConsentResponsesSent());
                    jsonObject["consentResponsesReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getConsentResponsesReceived());
                    jsonObject["totalRoundTripTime"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getTotalRoundTripTime());
                    jsonObject["currentRoundTripTime"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getCurrentRoundTripTime());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidatePairStats.prototype.setBytesReceived = function (value) {
                if (arguments.length == 1) {
                    this._bytesReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidatePairStats.prototype.setBytesSent = function (value) {
                if (arguments.length == 1) {
                    this._bytesSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidatePairStats.prototype.setConsentRequestsReceived = function (value) {
                if (arguments.length == 1) {
                    this._consentRequestsReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidatePairStats.prototype.setConsentRequestsSent = function (value) {
                if (arguments.length == 1) {
                    this._consentRequestsSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidatePairStats.prototype.setConsentResponsesReceived = function (value) {
                if (arguments.length == 1) {
                    this._consentResponsesReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidatePairStats.prototype.setConsentResponsesSent = function (value) {
                if (arguments.length == 1) {
                    this._consentResponsesSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidatePairStats.prototype.setCurrentRoundTripTime = function (value) {
                if (arguments.length == 1) {
                    this._currentRoundTripTime = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidatePairStats.prototype.setLocalCandidateId = function (value) {
                if (arguments.length == 1) {
                    this._localCandidateId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidatePairStats.prototype.setNominated = function (value) {
                if (arguments.length == 1) {
                    this._nominated = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidatePairStats.prototype.setPriority = function (value) {
                if (arguments.length == 1) {
                    this._priority = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidatePairStats.prototype.setRemoteCandidateId = function (value) {
                if (arguments.length == 1) {
                    this._remoteCandidateId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidatePairStats.prototype.setRequestsReceived = function (value) {
                if (arguments.length == 1) {
                    this._requestsReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidatePairStats.prototype.setRequestsSent = function (value) {
                if (arguments.length == 1) {
                    this._requestsSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidatePairStats.prototype.setResponsesReceived = function (value) {
                if (arguments.length == 1) {
                    this._responsesReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidatePairStats.prototype.setResponsesSent = function (value) {
                if (arguments.length == 1) {
                    this._responsesSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidatePairStats.prototype.setState = function (value) {
                if (arguments.length == 1) {
                    this._state = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidatePairStats.prototype.setTotalRoundTripTime = function (value) {
                if (arguments.length == 1) {
                    this._totalRoundTripTime = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidatePairStats.prototype.setTransportId = function (value) {
                if (arguments.length == 1) {
                    this._transportId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this to JSON.
            */
            CandidatePairStats.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.CandidatePairStats.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return CandidatePairStats;
        }(fm.liveswitch.BaseStats));
        liveswitch.CandidatePairStats = CandidatePairStats;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="BaseStats.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Candidate stats.
        */
        var CandidateStats = /** @class */ (function (_super) {
            __extends(CandidateStats, _super);
            /**
            Initializes a new instance of the [[fm.liveswitch.candidateStats]] class.
            */
            function CandidateStats() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchCandidateStatsInit();
                    _this.setPort(-1);
                    _this.setRelatedPort(-1);
                    _this.setProtocol(fm.liveswitch.ProtocolType.Unknown);
                    _this.setRelayProtocol(fm.liveswitch.ProtocolType.Unknown);
                    _this.setType(fm.liveswitch.CandidateType.Unknown);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            CandidateStats.prototype.getTypeString = function () {
                return '[fm.liveswitch.CandidateStats]' + ',' + _super.prototype.getTypeString.call(this);
            };
            CandidateStats.prototype.fmliveswitchCandidateStatsInit = function () {
                this._port = 0;
                this._priority = 0;
                this._relatedPort = 0;
            };
            /**
            Derializes candidate stats from JSON.
            @param candidateJson The candidate's stats JSON.
            */
            CandidateStats.fromJson = function (candidateJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(candidateJson, function () {
                        return new fm.liveswitch.CandidateStats();
                    }, function (obj, key, valueJson) {
                        obj.deserializeProperties(key, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Derializes an array of candidate stats from JSON.
            @param candidatesJson The candidates' stats JSON.
            */
            CandidateStats.fromJsonArray = function (candidatesJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(candidatesJson, fm.liveswitch.CandidateStats.fromJson.bind(fm.liveswitch.CandidateStats));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes candidate stats to JSON.
            @param candidate The candidate's stats.
            */
            CandidateStats.toJson = function (candidate) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(candidate, function (obj, jsonObject) {
                        obj.serializeProperties(jsonObject);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array of candidate stats to JSON.
            @param candidates The candidates' stats.
            */
            CandidateStats.toJsonArray = function (candidates) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(candidates, fm.liveswitch.CandidateStats.toJson.bind(fm.liveswitch.CandidateStats));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            CandidateStats.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var _var0 = key;
                    if (_var0 == "ipAddress") {
                        do {
                            this.setIPAddress(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "port") {
                        do {
                            this.setPort(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "relayProtocol") {
                        do {
                            this.setRelayProtocol(fm.liveswitch.CandidateUtility.protocolTypeFromString(fm.liveswitch.JsonSerializer.deserializeString(valueJson)));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "relatedIPAddress") {
                        do {
                            this.setRelatedIPAddress(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "relatedPort") {
                        do {
                            this.setRelatedPort(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "protocol") {
                        do {
                            this.setProtocol(fm.liveswitch.CandidateUtility.protocolTypeFromString(fm.liveswitch.JsonSerializer.deserializeString(valueJson)));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "type") {
                        do {
                            this.setType(fm.liveswitch.CandidateUtility.typeFromString(fm.liveswitch.JsonSerializer.deserializeString(valueJson)));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "priority") {
                        do {
                            this.setPriority(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the IP address.
            */
            CandidateStats.prototype.getIPAddress = function () {
                if (arguments.length == 0) {
                    return this._ipAddress;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the candidate is host/local.
            */
            CandidateStats.prototype.getIsHost = function () {
                if (arguments.length == 0) {
                    return (fm.liveswitch.Global.equals(this.getType(), fm.liveswitch.CandidateType.Host));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the candidate is reflexive.
            */
            CandidateStats.prototype.getIsReflexive = function () {
                if (arguments.length == 0) {
                    return ((fm.liveswitch.Global.equals(this.getType(), fm.liveswitch.CandidateType.ServerReflexive)) || (fm.liveswitch.Global.equals(this.getType(), fm.liveswitch.CandidateType.PeerReflexive)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the candidate is relayed.
            */
            CandidateStats.prototype.getIsRelayed = function () {
                if (arguments.length == 0) {
                    return (fm.liveswitch.Global.equals(this.getType(), fm.liveswitch.CandidateType.Relayed));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the port.
            */
            CandidateStats.prototype.getPort = function () {
                if (arguments.length == 0) {
                    return this._port;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the priority.
            */
            CandidateStats.prototype.getPriority = function () {
                if (arguments.length == 0) {
                    return this._priority;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the protocol.
            */
            CandidateStats.prototype.getProtocol = function () {
                if (arguments.length == 0) {
                    return this._protocol;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the related IP address.
            */
            CandidateStats.prototype.getRelatedIPAddress = function () {
                if (arguments.length == 0) {
                    return this._relatedIPAddress;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the related port.
            */
            CandidateStats.prototype.getRelatedPort = function () {
                if (arguments.length == 0) {
                    return this._relatedPort;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the relay protocol.
            */
            CandidateStats.prototype.getRelayProtocol = function () {
                if (arguments.length == 0) {
                    return this._relayProtocol;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the relay protocol. Obsolete. Alias for [[fm.liveswitch.candidateStats.relayProtocol]].
            */
            CandidateStats.prototype.getTurnProtocol = function () {
                if (arguments.length == 0) {
                    return this.getRelayProtocol();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the type.
            */
            CandidateStats.prototype.getType = function () {
                if (arguments.length == 0) {
                    return this._type;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Checks if a candidate is equivalent to this one.
            @param instance The candidate.
            */
            CandidateStats.prototype.isEquivalent = function (instance) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(instance, null))) {
                        return false;
                    }
                    return (((((fm.liveswitch.Global.equals(instance.getIPAddress(), this.getIPAddress())) && (fm.liveswitch.Global.equals(instance.getPort(), this.getPort()))) && ((fm.liveswitch.Global.equals(instance.getRelayProtocol(), this.getRelayProtocol())) && (fm.liveswitch.Global.equals(instance.getRelatedIPAddress(), this.getRelatedIPAddress())))) && (((fm.liveswitch.Global.equals(instance.getRelatedPort(), this.getRelatedPort())) && (fm.liveswitch.Global.equals(instance.getProtocol(), this.getProtocol()))) && (fm.liveswitch.Global.equals(instance.getType(), this.getType())))) && (fm.liveswitch.Global.equals(instance.getPriority(), this.getPriority())));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            CandidateStats.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getIPAddress(), null))) {
                        jsonObject["ipAddress"] = fm.liveswitch.JsonSerializer.serializeString(this.getIPAddress());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getPort(), 0))) {
                        jsonObject["port"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getPort());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRelatedIPAddress(), null))) {
                        jsonObject["relatedIPAddress"] = fm.liveswitch.JsonSerializer.serializeString(this.getRelatedIPAddress());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRelatedPort(), 0))) {
                        jsonObject["relatedPort"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getRelatedPort());
                    }
                    jsonObject["protocol"] = fm.liveswitch.JsonSerializer.serializeString(fm.liveswitch.CandidateUtility.protocolTypeToString(this.getProtocol()));
                    jsonObject["type"] = fm.liveswitch.JsonSerializer.serializeString(fm.liveswitch.CandidateUtility.typeToString(this.getType()));
                    if ((fm.liveswitch.Global.equals(this.getType(), fm.liveswitch.CandidateType.Relayed))) {
                        jsonObject["relayProtocol"] = fm.liveswitch.JsonSerializer.serializeString(fm.liveswitch.CandidateUtility.protocolTypeToString(this.getRelayProtocol()));
                    }
                    jsonObject["priority"] = fm.liveswitch.JsonSerializer.serializeLong(this.getPriority());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidateStats.prototype.setIPAddress = function (value) {
                if (arguments.length == 1) {
                    this._ipAddress = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidateStats.prototype.setPort = function (value) {
                if (arguments.length == 1) {
                    this._port = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidateStats.prototype.setPriority = function (value) {
                if (arguments.length == 1) {
                    this._priority = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidateStats.prototype.setProtocol = function (value) {
                if (arguments.length == 1) {
                    this._protocol = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidateStats.prototype.setRelatedIPAddress = function (value) {
                if (arguments.length == 1) {
                    this._relatedIPAddress = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidateStats.prototype.setRelatedPort = function (value) {
                if (arguments.length == 1) {
                    this._relatedPort = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidateStats.prototype.setRelayProtocol = function (value) {
                if (arguments.length == 1) {
                    this._relayProtocol = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CandidateStats.prototype.setType = function (value) {
                if (arguments.length == 1) {
                    this._type = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this to JSON.
            */
            CandidateStats.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.CandidateStats.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return CandidateStats;
        }(fm.liveswitch.BaseStats));
        liveswitch.CandidateStats = CandidateStats;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var CandidateTypeWrapper = /** @class */ (function () {
            function CandidateTypeWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_19 = __arguments[0];
                    //super();
                    this._value = value_19;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            CandidateTypeWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.CandidateTypeWrapper]';
            };
            CandidateTypeWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.CandidateType.Host)
                        return 'Host';
                    if (this._value == fm.liveswitch.CandidateType.ServerReflexive)
                        return 'ServerReflexive';
                    if (this._value == fm.liveswitch.CandidateType.Relayed)
                        return 'Relayed';
                    if (this._value == fm.liveswitch.CandidateType.PeerReflexive)
                        return 'PeerReflexive';
                    if (this._value == fm.liveswitch.CandidateType.Unknown)
                        return 'Unknown';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return CandidateTypeWrapper;
        }());
        liveswitch.CandidateTypeWrapper = CandidateTypeWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Utility functions for candidate and candidate pair.
        */
        var CandidateUtility = /** @class */ (function () {
            function CandidateUtility() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            CandidateUtility.prototype.getTypeString = function () {
                return '[fm.liveswitch.CandidateUtility]';
            };
            /**
            Convert string to CandidatePairState.
            @param stateString
            */
            CandidateUtility.candidatePairStateFromString = function (stateString) {
                if (arguments.length == 1) {
                    var _var0 = stateString;
                    if (_var0 == "new") {
                        do {
                            return fm.liveswitch.CandidatePairState.New;
                        } while (false);
                    }
                    else if (_var0 == "waiting") {
                        do {
                            return fm.liveswitch.CandidatePairState.Waiting;
                        } while (false);
                    }
                    else if (_var0 == "inProgress") {
                        do {
                            return fm.liveswitch.CandidatePairState.InProgress;
                        } while (false);
                    }
                    else if (_var0 == "succeeded") {
                        do {
                            return fm.liveswitch.CandidatePairState.Succeeded;
                        } while (false);
                    }
                    else if (_var0 == "failed") {
                        do {
                            return fm.liveswitch.CandidatePairState.Failed;
                        } while (false);
                    }
                    else if (_var0 == "closed") {
                        do {
                            return fm.liveswitch.CandidatePairState.Closed;
                        } while (false);
                    }
                    else if (_var0 == "connectivityLost") {
                        do {
                            return fm.liveswitch.CandidatePairState.ConnectivityLost;
                        } while (false);
                    }
                    return fm.liveswitch.CandidatePairState.New;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Convert CandidatePairState to string.
            @param state
            */
            CandidateUtility.candidatePairStateToString = function (state) {
                if (arguments.length == 1) {
                    var _var0 = state;
                    if (_var0 == fm.liveswitch.CandidatePairState.New) {
                        do {
                            return "new";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.CandidatePairState.Waiting) {
                        do {
                            return "waiting";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.CandidatePairState.InProgress) {
                        do {
                            return "inProgress";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.CandidatePairState.Succeeded) {
                        do {
                            return "succeeded";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.CandidatePairState.Failed) {
                        do {
                            return "failed";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.CandidatePairState.Closed) {
                        do {
                            return "closed";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.CandidatePairState.ConnectivityLost) {
                        do {
                            return "connectivityLost";
                        } while (false);
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Convert string to ProtocolType.
            @param protocolTypeString
            */
            CandidateUtility.protocolTypeFromString = function (protocolTypeString) {
                if (arguments.length == 1) {
                    var _var0 = protocolTypeString;
                    if (_var0 == "udp") {
                        do {
                            return fm.liveswitch.ProtocolType.Udp;
                        } while (false);
                    }
                    else if (_var0 == "tcp") {
                        do {
                            return fm.liveswitch.ProtocolType.Tcp;
                        } while (false);
                    }
                    else if (_var0 == "tls") {
                        do {
                            return fm.liveswitch.ProtocolType.Tls;
                        } while (false);
                    }
                    return fm.liveswitch.ProtocolType.Unknown;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Convert ProtocolType to string.
            @param protocolType
            */
            CandidateUtility.protocolTypeToString = function (protocolType) {
                if (arguments.length == 1) {
                    var _var0 = protocolType;
                    if (_var0 == fm.liveswitch.ProtocolType.Udp) {
                        do {
                            return "udp";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.ProtocolType.Tcp) {
                        do {
                            return "tcp";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.ProtocolType.Tls) {
                        do {
                            return "tls";
                        } while (false);
                    }
                    return "unknown";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Convert string to CandidateType.
            @param typeString
            */
            CandidateUtility.typeFromString = function (typeString) {
                if (arguments.length == 1) {
                    var _var0 = typeString;
                    if (_var0 == "host") {
                        do {
                            return fm.liveswitch.CandidateType.Host;
                        } while (false);
                    }
                    else if (_var0 == "srflx") {
                        do {
                            return fm.liveswitch.CandidateType.ServerReflexive;
                        } while (false);
                    }
                    else if (_var0 == "relay") {
                        do {
                            return fm.liveswitch.CandidateType.Relayed;
                        } while (false);
                    }
                    else if (_var0 == "prflx") {
                        do {
                            return fm.liveswitch.CandidateType.PeerReflexive;
                        } while (false);
                    }
                    return fm.liveswitch.CandidateType.Unknown;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Convert CandidateType to string.
            @param type
            */
            CandidateUtility.typeToString = function (type) {
                if (arguments.length == 1) {
                    var _var0 = type;
                    if (_var0 == fm.liveswitch.CandidateType.Host) {
                        do {
                            return "host";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.CandidateType.ServerReflexive) {
                        do {
                            return "srflx";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.CandidateType.Relayed) {
                        do {
                            return "relay";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.CandidateType.PeerReflexive) {
                        do {
                            return "prflx";
                        } while (false);
                    }
                    return "unknown";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return CandidateUtility;
        }());
        liveswitch.CandidateUtility = CandidateUtility;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Certificate information.
        */
        var CertificateInfo = /** @class */ (function (_super) {
            __extends(CertificateInfo, _super);
            function CertificateInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else if (__arguments.length == 2) {
                    var stats = __arguments[0];
                    var lastStats = __arguments[1];
                    _this = _super.call(this) || this;
                    var flag = (fm.liveswitch.Global.equals(lastStats, null));
                    _this.setFingerprint((flag ? stats.getFingerprint() : fm.liveswitch.Info.processString(stats.getFingerprint(), lastStats.getFingerprint())));
                    _this.setFingerprintAlgorithm((flag ? stats.getFingerprintAlgorithm() : fm.liveswitch.Info.processString(stats.getFingerprintAlgorithm(), lastStats.getFingerprintAlgorithm())));
                    _this.setBase64((flag ? stats.getCertificateBase64() : fm.liveswitch.Info.processString(stats.getCertificateBase64(), lastStats.getCertificateBase64())));
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            CertificateInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.CertificateInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Deserializes an instance from JSON.
            @param instanceJson The instance JSON.
            @return The deserialized instance.
            */
            CertificateInfo.fromJson = function (instanceJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(instanceJson, function () {
                        return new fm.liveswitch.CertificateInfo();
                    }, function (obj, key, valueJson) {
                        obj.deserializeProperties(key, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Derializes an array from JSON.
            @param arrayJson The array JSON.
            @return The deserialized array.
            */
            CertificateInfo.fromJsonArray = function (arrayJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(arrayJson, fm.liveswitch.CertificateInfo.fromJson.bind(fm.liveswitch.CertificateInfo));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param instance The instance.
            @return The serialized instance JSON.
            */
            CertificateInfo.toJson = function (instance) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(instance, function (obj, jsonObject) {
                        obj.serializeProperties(jsonObject);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param array The array.
            @return The serialized array JSON.
            */
            CertificateInfo.toJsonArray = function (array) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(array, fm.liveswitch.CertificateInfo.toJson.bind(fm.liveswitch.CertificateInfo));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            CertificateInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "fingerprint"))) {
                            if ((fm.liveswitch.Global.equals(str, "remoteCandidateId"))) {
                                this.setFingerprintAlgorithm(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "base64"))) {
                                    this.setBase64(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                }
                            }
                        }
                        else {
                            this.setFingerprint(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the certificate in Base64 format.
            */
            CertificateInfo.prototype.getBase64 = function () {
                if (arguments.length == 0) {
                    return this._base64;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the certificate fingerprint.
            */
            CertificateInfo.prototype.getFingerprint = function () {
                if (arguments.length == 0) {
                    return this._fingerprint;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the certificate fingerprint algorithm.
            */
            CertificateInfo.prototype.getFingerprintAlgorithm = function () {
                if (arguments.length == 0) {
                    return this._fingerprintAlgorithm;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            CertificateInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getFingerprint(), null))) {
                        jsonObject["fingerprint"] = fm.liveswitch.JsonSerializer.serializeString(this.getFingerprint());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getFingerprintAlgorithm(), null))) {
                        jsonObject["fingerprintAlgorithm"] = fm.liveswitch.JsonSerializer.serializeString(this.getFingerprintAlgorithm());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getBase64(), null))) {
                        jsonObject["base64"] = fm.liveswitch.JsonSerializer.serializeString(this.getBase64());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the certificate in Base64 format.
            */
            CertificateInfo.prototype.setBase64 = function (value) {
                if (arguments.length == 1) {
                    this._base64 = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the certificate fingerprint.
            */
            CertificateInfo.prototype.setFingerprint = function (value) {
                if (arguments.length == 1) {
                    this._fingerprint = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the certificate fingerprint algorithm.
            */
            CertificateInfo.prototype.setFingerprintAlgorithm = function (value) {
                if (arguments.length == 1) {
                    this._fingerprintAlgorithm = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            CertificateInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.CertificateInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return CertificateInfo;
        }(fm.liveswitch.Info));
        liveswitch.CertificateInfo = CertificateInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="BaseStats.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Certificate stats.
        */
        var CertificateStats = /** @class */ (function (_super) {
            __extends(CertificateStats, _super);
            function CertificateStats() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            CertificateStats.prototype.getTypeString = function () {
                return '[fm.liveswitch.CertificateStats]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Derializes certificate stats from JSON.
            @param certificateJson The certificate's stats JSON.
            */
            CertificateStats.fromJson = function (certificateJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(certificateJson, function () {
                        return new fm.liveswitch.CertificateStats();
                    }, function (obj, key, valueJson) {
                        obj.deserializeProperties(key, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Derializes an array of certificate stats from JSON.
            @param certificatesJson The certificates' stats JSON.
            */
            CertificateStats.fromJsonArray = function (certificatesJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(certificatesJson, fm.liveswitch.CertificateStats.fromJson.bind(fm.liveswitch.CertificateStats));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes certificate stats to JSON.
            @param certificate The certificate's stats.
            */
            CertificateStats.toJson = function (certificate) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(certificate, function (obj, jsonObject) {
                        obj.serializeProperties(jsonObject);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array of certificate stats to JSON.
            @param certificates The certificates' stats.
            */
            CertificateStats.toJsonArray = function (certificates) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(certificates, fm.liveswitch.CertificateStats.toJson.bind(fm.liveswitch.CertificateStats));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            CertificateStats.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "fingerprint"))) {
                            if ((fm.liveswitch.Global.equals(str, "fingerprintAlgorithm"))) {
                                this.setFingerprintAlgorithm(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "certificateBase64"))) {
                                    this.setCertificateBase64(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                }
                            }
                        }
                        else {
                            this.setFingerprint(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the certificate in Base64 format.
            */
            CertificateStats.prototype.getCertificateBase64 = function () {
                if (arguments.length == 0) {
                    return this._certificateBase64;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the fingerprint.
            */
            CertificateStats.prototype.getFingerprint = function () {
                if (arguments.length == 0) {
                    return this._fingerprint;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the fingerprint algorithm.
            */
            CertificateStats.prototype.getFingerprintAlgorithm = function () {
                if (arguments.length == 0) {
                    return this._fingerprintAlgorithm;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Checks if a certificate is equivalent to this one.
            @param instance The certificate.
            */
            CertificateStats.prototype.isEquivalent = function (instance) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(instance, null))) {
                        return false;
                    }
                    return (((fm.liveswitch.Global.equals(instance.getFingerprint(), this.getFingerprint())) && (fm.liveswitch.Global.equals(instance.getFingerprintAlgorithm(), this.getFingerprintAlgorithm()))) && (fm.liveswitch.Global.equals(instance.getCertificateBase64(), this.getCertificateBase64())));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            CertificateStats.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getFingerprint(), null))) {
                        jsonObject["fingerprint"] = fm.liveswitch.JsonSerializer.serializeString(this.getFingerprint());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getFingerprintAlgorithm(), null))) {
                        jsonObject["fingerprintAlgorithm"] = fm.liveswitch.JsonSerializer.serializeString(this.getFingerprintAlgorithm());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getCertificateBase64(), null))) {
                        jsonObject["certificateBase64"] = fm.liveswitch.JsonSerializer.serializeString(this.getCertificateBase64());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CertificateStats.prototype.setCertificateBase64 = function (value) {
                if (arguments.length == 1) {
                    this._certificateBase64 = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CertificateStats.prototype.setFingerprint = function (value) {
                if (arguments.length == 1) {
                    this._fingerprint = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CertificateStats.prototype.setFingerprintAlgorithm = function (value) {
                if (arguments.length == 1) {
                    this._fingerprintAlgorithm = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this to JSON.
            */
            CertificateStats.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.CertificateStats.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return CertificateStats;
        }(fm.liveswitch.BaseStats));
        liveswitch.CertificateStats = CertificateStats;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Codec information.
        */
        var CodecInfo = /** @class */ (function (_super) {
            __extends(CodecInfo, _super);
            function CodecInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchCodecInfoInit();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            CodecInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.CodecInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            CodecInfo.prototype.fmliveswitchCodecInfoInit = function () {
                this._channelCount = 0;
                this._clockRate = 0;
                this._payloadType = 0;
            };
            /**
            Deserializes an instance from JSON.
            @param codecInfoJson The serialized JSON.
            @return The deserialized instance.
            */
            CodecInfo.fromJson = function (codecInfoJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(codecInfoJson, function () {
                        return new fm.liveswitch.CodecInfo();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array from JSON.
            @param codecInfosJson The serialized JSON.
            @return The deserialized array.
            */
            CodecInfo.fromJsonArray = function (codecInfosJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(codecInfosJson, fm.liveswitch.CodecInfo.fromJson.bind(fm.liveswitch.CodecInfo));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param codecInfo The instance to serialize.
            @return The serialized JSON.
            */
            CodecInfo.toJson = function (codecInfo) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(codecInfo, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param codecInfos The array to serialize.
            @return The serialized JSON.
            */
            CodecInfo.toJsonArray = function (codecInfos) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(codecInfos, fm.liveswitch.CodecInfo.toJson.bind(fm.liveswitch.CodecInfo));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            CodecInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "name"))) {
                            if ((fm.liveswitch.Global.equals(str, "clockRate"))) {
                                this.setClockRate(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "channelCount"))) {
                                    this.setChannelCount(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "parameters"))) {
                                        this.setParameters(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "payloadType"))) {
                                            this.setPayloadType(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            this.setName(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the codec channel count.
            */
            CodecInfo.prototype.getChannelCount = function () {
                if (arguments.length == 0) {
                    return this._channelCount;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the codec clock rate.
            */
            CodecInfo.prototype.getClockRate = function () {
                if (arguments.length == 0) {
                    return this._clockRate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the codec name.
            */
            CodecInfo.prototype.getName = function () {
                if (arguments.length == 0) {
                    return this._name;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the codec parameters.
            */
            CodecInfo.prototype.getParameters = function () {
                if (arguments.length == 0) {
                    return this._parameters;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the codec payload type.
            */
            CodecInfo.prototype.getPayloadType = function () {
                if (arguments.length == 0) {
                    return this._payloadType;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            CodecInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if (!fm.liveswitch.StringExtensions.isNullOrEmpty(this.getName())) {
                        jsonObject["name"] = fm.liveswitch.JsonSerializer.serializeString(this.getName());
                    }
                    if ((this.getClockRate() != null)) {
                        jsonObject["clockRate"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getClockRate());
                    }
                    if ((this.getChannelCount() != null)) {
                        jsonObject["channelCount"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getChannelCount());
                    }
                    if (!fm.liveswitch.StringExtensions.isNullOrEmpty(this.getParameters())) {
                        jsonObject["parameters"] = fm.liveswitch.JsonSerializer.serializeString(this.getParameters());
                    }
                    if ((this.getPayloadType() != null)) {
                        jsonObject["payloadType"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getPayloadType());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the codec channel count.
            */
            CodecInfo.prototype.setChannelCount = function (value) {
                if (arguments.length == 1) {
                    this._channelCount = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the codec clock rate.
            */
            CodecInfo.prototype.setClockRate = function (value) {
                if (arguments.length == 1) {
                    this._clockRate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the codec name.
            */
            CodecInfo.prototype.setName = function (value) {
                if (arguments.length == 1) {
                    this._name = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the codec parameters.
            */
            CodecInfo.prototype.setParameters = function (value) {
                if (arguments.length == 1) {
                    this._parameters = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the codec payload type.
            */
            CodecInfo.prototype.setPayloadType = function (value) {
                if (arguments.length == 1) {
                    this._payloadType = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            CodecInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.CodecInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return CodecInfo;
        }(fm.liveswitch.Info));
        liveswitch.CodecInfo = CodecInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="BaseStats.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Codec stats.
        */
        var CodecStats = /** @class */ (function (_super) {
            __extends(CodecStats, _super);
            function CodecStats() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchCodecStatsInit();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            CodecStats.prototype.getTypeString = function () {
                return '[fm.liveswitch.CodecStats]' + ',' + _super.prototype.getTypeString.call(this);
            };
            CodecStats.prototype.fmliveswitchCodecStatsInit = function () {
                this._channelCount = 0;
                this._clockRate = 0;
                this._payloadType = 0;
            };
            /**
            Derializes codec stats from JSON.
            @param codecJson The codec's stats JSON.
            */
            CodecStats.fromJson = function (codecJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(codecJson, function () {
                        return new fm.liveswitch.CodecStats();
                    }, function (obj, key, valueJson) {
                        obj.deserializeProperties(key, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes codec stats to JSON.
            @param codec The codec's stats.
            */
            CodecStats.toJson = function (codec) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(codec, function (obj, jsonObject) {
                        obj.serializeProperties(jsonObject);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            CodecStats.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str2 = key;
                    if ((!fm.liveswitch.Global.equals(str2, null))) {
                        if (!(fm.liveswitch.Global.equals(str2, "codecType"))) {
                            if ((fm.liveswitch.Global.equals(str2, "payloadType"))) {
                                this.setPayloadType(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str2, "name"))) {
                                    this.setName(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str2, "clockRate"))) {
                                        this.setClockRate(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str2, "channelCount"))) {
                                            this.setChannelCount(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                        }
                                        else {
                                            if ((fm.liveswitch.Global.equals(str2, "parameters"))) {
                                                this.setParameters(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            var str = fm.liveswitch.JsonSerializer.deserializeString(valueJson);
                            this.setCodecType(((fm.liveswitch.Global.equals(str, "encode")) ? fm.liveswitch.CodecType.Encode : fm.liveswitch.CodecType.Decode));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the channel count.
            */
            CodecStats.prototype.getChannelCount = function () {
                if (arguments.length == 0) {
                    return this._channelCount;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the clock rate.
            */
            CodecStats.prototype.getClockRate = function () {
                if (arguments.length == 0) {
                    return this._clockRate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the codec type, "encode" or "decode", depending on whether this object represents a media format that the implementation is prepared to encode or decode.
            */
            CodecStats.prototype.getCodecType = function () {
                if (arguments.length == 0) {
                    return this._codecType;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name.
            */
            CodecStats.prototype.getName = function () {
                if (arguments.length == 0) {
                    return this._name;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the parameters.
            */
            CodecStats.prototype.getParameters = function () {
                if (arguments.length == 0) {
                    return this._parameters;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the payload type.
            */
            CodecStats.prototype.getPayloadType = function () {
                if (arguments.length == 0) {
                    return this._payloadType;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Checks if a codec is equivalent to this one.
            @param instance The codec.
            */
            CodecStats.prototype.isEquivalent = function (instance) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(instance, null))) {
                        return false;
                    }
                    return (((((fm.liveswitch.Global.equals(instance.getCodecType(), this.getCodecType())) && (fm.liveswitch.Global.equals(instance.getPayloadType(), this.getPayloadType()))) && ((fm.liveswitch.Global.equals(instance.getName(), this.getName())) && (fm.liveswitch.Global.equals(instance.getClockRate(), this.getClockRate())))) && (fm.liveswitch.Global.equals(instance.getChannelCount(), this.getChannelCount()))) && (fm.liveswitch.Global.equals(instance.getParameters(), this.getParameters())));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            CodecStats.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    jsonObject["codecType"] = fm.liveswitch.JsonSerializer.serializeString(((fm.liveswitch.Global.equals(this.getCodecType(), fm.liveswitch.CodecType.Encode)) ? "encode" : "decode"));
                    jsonObject["payloadType"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getPayloadType());
                    if ((!fm.liveswitch.Global.equals(this.getName(), null))) {
                        jsonObject["name"] = fm.liveswitch.JsonSerializer.serializeString(this.getName());
                    }
                    jsonObject["clockRate"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getClockRate());
                    if ((!fm.liveswitch.Global.equals(this.getChannelCount(), 0))) {
                        jsonObject["channelCount"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getChannelCount());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getParameters(), null))) {
                        jsonObject["parameters"] = fm.liveswitch.JsonSerializer.serializeString(this.getParameters());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CodecStats.prototype.setChannelCount = function (value) {
                if (arguments.length == 1) {
                    this._channelCount = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CodecStats.prototype.setClockRate = function (value) {
                if (arguments.length == 1) {
                    this._clockRate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CodecStats.prototype.setCodecType = function (value) {
                if (arguments.length == 1) {
                    this._codecType = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CodecStats.prototype.setName = function (value) {
                if (arguments.length == 1) {
                    this._name = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CodecStats.prototype.setParameters = function (value) {
                if (arguments.length == 1) {
                    this._parameters = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            CodecStats.prototype.setPayloadType = function (value) {
                if (arguments.length == 1) {
                    this._payloadType = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this to JSON.
            */
            CodecStats.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.CodecStats.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return CodecStats;
        }(fm.liveswitch.BaseStats));
        liveswitch.CodecStats = CodecStats;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var CodecTypeWrapper = /** @class */ (function () {
            function CodecTypeWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_20 = __arguments[0];
                    //super();
                    this._value = value_20;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            CodecTypeWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.CodecTypeWrapper]';
            };
            CodecTypeWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.CodecType.Encode)
                        return 'Encode';
                    if (this._value == fm.liveswitch.CodecType.Decode)
                        return 'Decode';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return CodecTypeWrapper;
        }());
        liveswitch.CodecTypeWrapper = CodecTypeWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var ConnectionStateWrapper = /** @class */ (function () {
            function ConnectionStateWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_21 = __arguments[0];
                    //super();
                    this._value = value_21;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            ConnectionStateWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.ConnectionStateWrapper]';
            };
            ConnectionStateWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.ConnectionState.New)
                        return 'New';
                    if (this._value == fm.liveswitch.ConnectionState.Initializing)
                        return 'Initializing';
                    if (this._value == fm.liveswitch.ConnectionState.Connecting)
                        return 'Connecting';
                    if (this._value == fm.liveswitch.ConnectionState.Connected)
                        return 'Connected';
                    if (this._value == fm.liveswitch.ConnectionState.Failing)
                        return 'Failing';
                    if (this._value == fm.liveswitch.ConnectionState.Failed)
                        return 'Failed';
                    if (this._value == fm.liveswitch.ConnectionState.Closing)
                        return 'Closing';
                    if (this._value == fm.liveswitch.ConnectionState.Closed)
                        return 'Closed';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ConnectionStateWrapper;
        }());
        liveswitch.ConnectionStateWrapper = ConnectionStateWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="BaseStats.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Connection stats.
        */
        var ConnectionStats = /** @class */ (function (_super) {
            __extends(ConnectionStats, _super);
            function ConnectionStats() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            ConnectionStats.prototype.getTypeString = function () {
                return '[fm.liveswitch.ConnectionStats]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Derializes connection stats from JSON.
            @param connectionJson The connection's stats JSON.
            */
            ConnectionStats.fromJson = function (connectionJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(connectionJson, function () {
                        return new fm.liveswitch.ConnectionStats();
                    }, function (obj, key, valueJson) {
                        obj.deserializeProperties(key, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes connection stats to JSON.
            @param connection The connection's stats.
            */
            ConnectionStats.toJson = function (connection) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(connection, function (obj, jsonObject) {
                        obj.serializeProperties(jsonObject);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            ConnectionStats.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "externalId"))) {
                            if ((fm.liveswitch.Global.equals(str, "state"))) {
                                this.setState(this.stateFromString(fm.liveswitch.JsonSerializer.deserializeString(valueJson)));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "mediaStreams"))) {
                                    this.setMediaStreams(fm.liveswitch.MediaStreamStats.fromJsonArray(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "dataStream"))) {
                                        this.setDataStream(fm.liveswitch.DataStreamStats.fromJson(valueJson));
                                    }
                                }
                            }
                        }
                        else {
                            this.setExternalId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the first audio stream's stats.
            */
            ConnectionStats.prototype.getAudioStream = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Utility.firstOrDefault(this.getAudioStreams());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the audio streams' stats.
            */
            ConnectionStats.prototype.getAudioStreams = function () {
                if (arguments.length == 0) {
                    var list = new Array();
                    var mediaStreams = this.getMediaStreams();
                    if ((!fm.liveswitch.Global.equals(mediaStreams, null))) {
                        for (var _i = 0, mediaStreams_4 = mediaStreams; _i < mediaStreams_4.length; _i++) {
                            var stats = mediaStreams_4[_i];
                            if ((fm.liveswitch.Global.equals(stats.getType(), fm.liveswitch.StreamType.Audio))) {
                                fm.liveswitch.ArrayExtensions.add(list, stats);
                            }
                        }
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the data stream's stats.
            */
            ConnectionStats.prototype.getDataStream = function () {
                if (arguments.length == 0) {
                    return this._dataStream;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the external identifier.
            */
            ConnectionStats.prototype.getExternalId = function () {
                if (arguments.length == 0) {
                    return this._externalId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether any of the streams are using a transport whose active candidate pair has a host candidate.
            */
            ConnectionStats.prototype.getIsHost = function () {
                if (arguments.length == 0) {
                    var streams = this.getStreams();
                    if ((!fm.liveswitch.Global.equals(streams, null))) {
                        for (var _i = 0, streams_8 = streams; _i < streams_8.length; _i++) {
                            var stats = streams_8[_i];
                            if (stats.getIsHost()) {
                                return true;
                            }
                        }
                    }
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether any of the streams are using a transport whose active candidate pair has a reflexive candidate.
            */
            ConnectionStats.prototype.getIsReflexive = function () {
                if (arguments.length == 0) {
                    var streams = this.getStreams();
                    if ((!fm.liveswitch.Global.equals(streams, null))) {
                        for (var _i = 0, streams_9 = streams; _i < streams_9.length; _i++) {
                            var stats = streams_9[_i];
                            if (stats.getIsReflexive()) {
                                return true;
                            }
                        }
                    }
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether any of the streams are using a transport whose active candidate pair has a relayed candidate.
            */
            ConnectionStats.prototype.getIsRelayed = function () {
                if (arguments.length == 0) {
                    var streams = this.getStreams();
                    if ((!fm.liveswitch.Global.equals(streams, null))) {
                        for (var _i = 0, streams_10 = streams; _i < streams_10.length; _i++) {
                            var stats = streams_10[_i];
                            if (stats.getIsRelayed()) {
                                return true;
                            }
                        }
                    }
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ConnectionStats.prototype.getMediaStream = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Utility.firstOrDefault(this.getMediaStreams());
                }
                else if (arguments.length == 1) {
                    var mediaStreamId = arguments[0];
                    for (var _i = 0, _a = this.getMediaStreams(); _i < _a.length; _i++) {
                        var stats = _a[_i];
                        if ((fm.liveswitch.Global.equals(stats.getId(), mediaStreamId))) {
                            return stats;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media streams' stats.
            */
            ConnectionStats.prototype.getMediaStreams = function () {
                if (arguments.length == 0) {
                    return this._mediaStreams;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the state.
            */
            ConnectionStats.prototype.getState = function () {
                if (arguments.length == 0) {
                    return this._state;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the streams' stats.
            */
            ConnectionStats.prototype.getStreams = function () {
                if (arguments.length == 0) {
                    var list = new Array();
                    var mediaStreams = this.getMediaStreams();
                    if ((!fm.liveswitch.Global.equals(mediaStreams, null))) {
                        for (var _i = 0, mediaStreams_5 = mediaStreams; _i < mediaStreams_5.length; _i++) {
                            var stats = mediaStreams_5[_i];
                            fm.liveswitch.ArrayExtensions.add(list, stats);
                        }
                    }
                    var dataStream = this.getDataStream();
                    if ((!fm.liveswitch.Global.equals(dataStream, null))) {
                        fm.liveswitch.ArrayExtensions.add(list, dataStream);
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the first video stream's stats.
            */
            ConnectionStats.prototype.getVideoStream = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Utility.firstOrDefault(this.getVideoStreams());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the video streams' stats.
            */
            ConnectionStats.prototype.getVideoStreams = function () {
                if (arguments.length == 0) {
                    var list = new Array();
                    var mediaStreams = this.getMediaStreams();
                    if ((!fm.liveswitch.Global.equals(mediaStreams, null))) {
                        for (var _i = 0, mediaStreams_6 = mediaStreams; _i < mediaStreams_6.length; _i++) {
                            var stats = mediaStreams_6[_i];
                            if ((fm.liveswitch.Global.equals(stats.getType(), fm.liveswitch.StreamType.Video))) {
                                fm.liveswitch.ArrayExtensions.add(list, stats);
                            }
                        }
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            ConnectionStats.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getExternalId(), null))) {
                        jsonObject["externalId"] = fm.liveswitch.JsonSerializer.serializeString(this.getExternalId());
                    }
                    jsonObject["state"] = fm.liveswitch.JsonSerializer.serializeString(this.stateToString(this.getState()));
                    if ((!fm.liveswitch.Global.equals(this.getMediaStreams(), null))) {
                        jsonObject["mediaStreams"] = fm.liveswitch.MediaStreamStats.toJsonArray(this.getMediaStreams());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getDataStream(), null))) {
                        jsonObject["dataStream"] = fm.liveswitch.DataStreamStats.toJson(this.getDataStream());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ConnectionStats.prototype.setDataStream = function (value) {
                if (arguments.length == 1) {
                    this._dataStream = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the external identifier.
            */
            ConnectionStats.prototype.setExternalId = function (value) {
                if (arguments.length == 1) {
                    this._externalId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ConnectionStats.prototype.setMediaStreams = function (value) {
                if (arguments.length == 1) {
                    this._mediaStreams = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the state.
            */
            ConnectionStats.prototype.setState = function (value) {
                if (arguments.length == 1) {
                    this._state = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ConnectionStats.prototype.stateFromString = function (stateString) {
                if (arguments.length == 1) {
                    var _var0 = stateString;
                    if (_var0 == "new") {
                        do {
                            return fm.liveswitch.ConnectionState.New;
                        } while (false);
                    }
                    else if (_var0 == "initializing") {
                        do {
                            return fm.liveswitch.ConnectionState.Initializing;
                        } while (false);
                    }
                    else if (_var0 == "connecting") {
                        do {
                            return fm.liveswitch.ConnectionState.Connecting;
                        } while (false);
                    }
                    else if (_var0 == "connected") {
                        do {
                            return fm.liveswitch.ConnectionState.Connected;
                        } while (false);
                    }
                    else if (_var0 == "failing") {
                        do {
                            return fm.liveswitch.ConnectionState.Failing;
                        } while (false);
                    }
                    else if (_var0 == "failed") {
                        do {
                            return fm.liveswitch.ConnectionState.Failed;
                        } while (false);
                    }
                    else if (_var0 == "closing") {
                        do {
                            return fm.liveswitch.ConnectionState.Closing;
                        } while (false);
                    }
                    else if (_var0 == "closed") {
                        do {
                            return fm.liveswitch.ConnectionState.Closed;
                        } while (false);
                    }
                    return fm.liveswitch.ConnectionState.New;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ConnectionStats.prototype.stateToString = function (state) {
                if (arguments.length == 1) {
                    var _var0 = state;
                    if (_var0 == fm.liveswitch.ConnectionState.New) {
                        do {
                            return "new";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.ConnectionState.Initializing) {
                        do {
                            return "initializing";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.ConnectionState.Connecting) {
                        do {
                            return "connecting";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.ConnectionState.Connected) {
                        do {
                            return "connected";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.ConnectionState.Failing) {
                        do {
                            return "failing";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.ConnectionState.Failed) {
                        do {
                            return "failed";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.ConnectionState.Closing) {
                        do {
                            return "closing";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.ConnectionState.Closed) {
                        do {
                            return "closed";
                        } while (false);
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this to JSON.
            */
            ConnectionStats.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ConnectionStats.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ConnectionStats;
        }(fm.liveswitch.BaseStats));
        liveswitch.ConnectionStats = ConnectionStats;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Data channel information.
        */
        var DataChannelInfo = /** @class */ (function (_super) {
            __extends(DataChannelInfo, _super);
            function DataChannelInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchDataChannelInfoInit();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            DataChannelInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.DataChannelInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            DataChannelInfo.prototype.fmliveswitchDataChannelInfoInit = function () {
                this._ordered = false;
            };
            /**
            Deserializes Json to a DataChannelInfo.
            @param dataChannelInfoJson The serialized Json.
            @return The deserialized DataChannelInfo.
            */
            DataChannelInfo.fromJson = function (dataChannelInfoJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(dataChannelInfoJson, function () {
                        return new fm.liveswitch.DataChannelInfo();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes JSON to an array.
            @param dataChannelInfosJson The serialized JSON.
            @return The deserialized array.
            */
            DataChannelInfo.fromJsonArray = function (dataChannelInfosJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(dataChannelInfosJson, fm.liveswitch.DataChannelInfo.fromJson.bind(fm.liveswitch.DataChannelInfo));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to Json.
            @param dataChannelInfo The instance to serialize.
            @return Serialized Json.
            */
            DataChannelInfo.toJson = function (dataChannelInfo) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(dataChannelInfo, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param dataChannelInfos The array to serialize.
            @return The serialized JSON.
            */
            DataChannelInfo.toJsonArray = function (dataChannelInfos) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(dataChannelInfos, fm.liveswitch.DataChannelInfo.toJson.bind(fm.liveswitch.DataChannelInfo));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            DataChannelInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "label"))) {
                            if ((fm.liveswitch.Global.equals(str, "ordered"))) {
                                this.setOrdered(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "subprotocol"))) {
                                    this.setSubprotocol(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "state"))) {
                                        this.setState(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "report"))) {
                                            this.setReport(fm.liveswitch.DataChannelReport.fromJson(valueJson));
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            this.setLabel(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the data channel label.
            */
            DataChannelInfo.prototype.getLabel = function () {
                if (arguments.length == 0) {
                    return this._label;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the data channel is ordered.
            */
            DataChannelInfo.prototype.getOrdered = function () {
                if (arguments.length == 0) {
                    return this._ordered;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the data channel report.
            */
            DataChannelInfo.prototype.getReport = function () {
                if (arguments.length == 0) {
                    return this._report;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the data channel state.
            */
            DataChannelInfo.prototype.getState = function () {
                if (arguments.length == 0) {
                    return this._state;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the data channel subprotocol.
            */
            DataChannelInfo.prototype.getSubprotocol = function () {
                if (arguments.length == 0) {
                    return this._subprotocol;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataChannelInfo.prototype.populateReports = function (stats, lastStats, eventType) {
                if (arguments.length == 3) {
                    this.setReport(new fm.liveswitch.DataChannelReport(stats, lastStats, eventType));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            DataChannelInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getLabel(), null))) {
                        jsonObject["label"] = fm.liveswitch.JsonSerializer.serializeString(this.getLabel());
                    }
                    if (this.getOrdered()) {
                        jsonObject["ordered"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getOrdered());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getSubprotocol(), null))) {
                        jsonObject["subprotocol"] = fm.liveswitch.JsonSerializer.serializeString(this.getSubprotocol());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getState(), null))) {
                        jsonObject["state"] = fm.liveswitch.JsonSerializer.serializeString(this.getState());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getReport(), null))) {
                        jsonObject["report"] = fm.liveswitch.DataChannelReport.toJson(this.getReport());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the data channel label.
            */
            DataChannelInfo.prototype.setLabel = function (value) {
                if (arguments.length == 1) {
                    this._label = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the data channel is ordered.
            */
            DataChannelInfo.prototype.setOrdered = function (value) {
                if (arguments.length == 1) {
                    this._ordered = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the data channel report.
            */
            DataChannelInfo.prototype.setReport = function (value) {
                if (arguments.length == 1) {
                    this._report = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the data channel state.
            */
            DataChannelInfo.prototype.setState = function (value) {
                if (arguments.length == 1) {
                    this._state = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the data channel subprotocol.
            */
            DataChannelInfo.prototype.setSubprotocol = function (value) {
                if (arguments.length == 1) {
                    this._subprotocol = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to Json.
            */
            DataChannelInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.DataChannelInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return DataChannelInfo;
        }(fm.liveswitch.Info));
        liveswitch.DataChannelInfo = DataChannelInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var DataChannelStateWrapper = /** @class */ (function () {
            function DataChannelStateWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_22 = __arguments[0];
                    //super();
                    this._value = value_22;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            DataChannelStateWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.DataChannelStateWrapper]';
            };
            DataChannelStateWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.DataChannelState.New)
                        return 'New';
                    if (this._value == fm.liveswitch.DataChannelState.Connecting)
                        return 'Connecting';
                    if (this._value == fm.liveswitch.DataChannelState.Connected)
                        return 'Connected';
                    if (this._value == fm.liveswitch.DataChannelState.Closing)
                        return 'Closing';
                    if (this._value == fm.liveswitch.DataChannelState.Closed)
                        return 'Closed';
                    if (this._value == fm.liveswitch.DataChannelState.Failed)
                        return 'Failed';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return DataChannelStateWrapper;
        }());
        liveswitch.DataChannelStateWrapper = DataChannelStateWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="BaseStats.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Data channel stats.
        */
        var DataChannelStats = /** @class */ (function (_super) {
            __extends(DataChannelStats, _super);
            /**
            Initializes a new instance of [[fm.liveswitch.dataChannelStats]].
            */
            function DataChannelStats() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchDataChannelStatsInit();
                    _this.setState(fm.liveswitch.DataChannelState.New);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            DataChannelStats.prototype.getTypeString = function () {
                return '[fm.liveswitch.DataChannelStats]' + ',' + _super.prototype.getTypeString.call(this);
            };
            DataChannelStats.prototype.fmliveswitchDataChannelStatsInit = function () {
                this._bytesReceived = 0;
                this._bytesSent = 0;
                this._messagesReceived = 0;
                this._messagesSent = 0;
                this._ordered = false;
            };
            /**
            Derializes data channel stats from JSON.
            @param dataChannelJson The data channel's stats JSON.
            */
            DataChannelStats.fromJson = function (dataChannelJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(dataChannelJson, function () {
                        return new fm.liveswitch.DataChannelStats();
                    }, function (obj, key, valueJson) {
                        obj.deserializeProperties(key, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Derializes an array of data channel stats from JSON.
            @param dataChannelsJson The data channels' stats JSON.
            */
            DataChannelStats.fromJsonArray = function (dataChannelsJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(dataChannelsJson, fm.liveswitch.DataChannelStats.fromJson.bind(fm.liveswitch.DataChannelStats));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes data channel stats to JSON.
            @param dataChannel The data channel's stats.
            */
            DataChannelStats.toJson = function (dataChannel) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(dataChannel, function (obj, jsonObject) {
                        obj.serializeProperties(jsonObject);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array of data channel stats to JSON.
            @param dataChannels The data channels' stats.
            */
            DataChannelStats.toJsonArray = function (dataChannels) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(dataChannels, fm.liveswitch.DataChannelStats.toJson.bind(fm.liveswitch.DataChannelStats));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            DataChannelStats.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var _var0 = key;
                    if (_var0 == "label") {
                        do {
                            this.setLabel(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "ordered") {
                        do {
                            this.setOrdered(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "protocol") {
                        do {
                            this.setProtocol(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "state") {
                        do {
                            this.setState(this.stateFromString(fm.liveswitch.JsonSerializer.deserializeString(valueJson)));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "messagesSent") {
                        do {
                            this.setMessagesSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "bytesSent") {
                        do {
                            this.setBytesSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "messagesReceived") {
                        do {
                            this.setMessagesReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "bytesReceived") {
                        do {
                            this.setBytesReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes received.
            */
            DataChannelStats.prototype.getBytesReceived = function () {
                if (arguments.length == 0) {
                    return this._bytesReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes sent.
            */
            DataChannelStats.prototype.getBytesSent = function () {
                if (arguments.length == 0) {
                    return this._bytesSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the label.
            */
            DataChannelStats.prototype.getLabel = function () {
                if (arguments.length == 0) {
                    return this._label;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of messages received.
            */
            DataChannelStats.prototype.getMessagesReceived = function () {
                if (arguments.length == 0) {
                    return this._messagesReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of messages sent.
            */
            DataChannelStats.prototype.getMessagesSent = function () {
                if (arguments.length == 0) {
                    return this._messagesSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the channel is ordered.
            */
            DataChannelStats.prototype.getOrdered = function () {
                if (arguments.length == 0) {
                    return this._ordered;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the protocol.
            */
            DataChannelStats.prototype.getProtocol = function () {
                if (arguments.length == 0) {
                    return this._protocol;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the state.
            */
            DataChannelStats.prototype.getState = function () {
                if (arguments.length == 0) {
                    return this._state;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            DataChannelStats.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getLabel(), null))) {
                        jsonObject["label"] = fm.liveswitch.JsonSerializer.serializeString(this.getLabel());
                    }
                    jsonObject["ordered"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getOrdered());
                    if ((!fm.liveswitch.Global.equals(this.getProtocol(), null))) {
                        jsonObject["protocol"] = fm.liveswitch.JsonSerializer.serializeString(this.getProtocol());
                    }
                    jsonObject["state"] = fm.liveswitch.JsonSerializer.serializeString(this.stateToString(this.getState()));
                    jsonObject["messagesSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getMessagesSent());
                    jsonObject["bytesSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getBytesSent());
                    jsonObject["messagesReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getMessagesReceived());
                    jsonObject["bytesReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getBytesReceived());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataChannelStats.prototype.setBytesReceived = function (value) {
                if (arguments.length == 1) {
                    this._bytesReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataChannelStats.prototype.setBytesSent = function (value) {
                if (arguments.length == 1) {
                    this._bytesSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataChannelStats.prototype.setLabel = function (value) {
                if (arguments.length == 1) {
                    this._label = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataChannelStats.prototype.setMessagesReceived = function (value) {
                if (arguments.length == 1) {
                    this._messagesReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataChannelStats.prototype.setMessagesSent = function (value) {
                if (arguments.length == 1) {
                    this._messagesSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataChannelStats.prototype.setOrdered = function (value) {
                if (arguments.length == 1) {
                    this._ordered = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataChannelStats.prototype.setProtocol = function (value) {
                if (arguments.length == 1) {
                    this._protocol = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataChannelStats.prototype.setState = function (value) {
                if (arguments.length == 1) {
                    this._state = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataChannelStats.prototype.stateFromString = function (stateString) {
                if (arguments.length == 1) {
                    var _var0 = stateString;
                    if (_var0 == "new") {
                        do {
                            return fm.liveswitch.DataChannelState.New;
                        } while (false);
                    }
                    else if (_var0 == "connecting") {
                        do {
                            return fm.liveswitch.DataChannelState.Connecting;
                        } while (false);
                    }
                    else if (_var0 == "connected") {
                        do {
                            return fm.liveswitch.DataChannelState.Connected;
                        } while (false);
                    }
                    else if (_var0 == "failed") {
                        do {
                            return fm.liveswitch.DataChannelState.Failed;
                        } while (false);
                    }
                    else if (_var0 == "closing") {
                        do {
                            return fm.liveswitch.DataChannelState.Closing;
                        } while (false);
                    }
                    else if (_var0 == "closed") {
                        do {
                            return fm.liveswitch.DataChannelState.Closed;
                        } while (false);
                    }
                    return fm.liveswitch.DataChannelState.New;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataChannelStats.prototype.stateToString = function (state) {
                if (arguments.length == 1) {
                    var _var0 = state;
                    if (_var0 == fm.liveswitch.DataChannelState.New) {
                        do {
                            return "new";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.DataChannelState.Connecting) {
                        do {
                            return "connecting";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.DataChannelState.Connected) {
                        do {
                            return "connected";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.DataChannelState.Closing) {
                        do {
                            return "closing";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.DataChannelState.Closed) {
                        do {
                            return "closed";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.DataChannelState.Failed) {
                        do {
                            return "failed";
                        } while (false);
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this to JSON.
            */
            DataChannelStats.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.DataChannelStats.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return DataChannelStats;
        }(fm.liveswitch.BaseStats));
        liveswitch.DataChannelStats = DataChannelStats;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Stream information.
        */
        var StreamInfo = /** @class */ (function (_super) {
            __extends(StreamInfo, _super);
            function StreamInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            StreamInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.StreamInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            StreamInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "tag"))) {
                            if ((fm.liveswitch.Global.equals(str, "transportId"))) {
                                this.setTransportId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            }
                        }
                        else {
                            this.setTag(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the tag.
            */
            StreamInfo.prototype.getTag = function () {
                if (arguments.length == 0) {
                    return this._tag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the transport id.
            */
            StreamInfo.prototype.getTransportId = function () {
                if (arguments.length == 0) {
                    return this._transportId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            StreamInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getTag(), null))) {
                        jsonObject["tag"] = fm.liveswitch.JsonSerializer.serializeString(this.getTag());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getTransportId(), null))) {
                        jsonObject["transportId"] = fm.liveswitch.JsonSerializer.serializeString(this.getTransportId());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the tag.
            */
            StreamInfo.prototype.setTag = function (value) {
                if (arguments.length == 1) {
                    this._tag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the transport id.
            */
            StreamInfo.prototype.setTransportId = function (value) {
                if (arguments.length == 1) {
                    this._transportId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return StreamInfo;
        }(fm.liveswitch.Info));
        liveswitch.StreamInfo = StreamInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="StreamInfo.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Data stream information.
        */
        var DataStreamInfo = /** @class */ (function (_super) {
            __extends(DataStreamInfo, _super);
            function DataStreamInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            DataStreamInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.DataStreamInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Deserializes Json to a DataStreamInfo.
            @param dataStreamInfoJson The serialized Json.
            @return The deserialized DataStreamInfo.
            */
            DataStreamInfo.fromJson = function (dataStreamInfoJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(dataStreamInfoJson, function () {
                        return new fm.liveswitch.DataStreamInfo();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes JSON to a DataStreamInfo array.
            @param dataStreamInfosJson The serialized JSON.
            @return The deserialized DataStreamInfo array.
            */
            DataStreamInfo.fromJsonArray = function (dataStreamInfosJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(dataStreamInfosJson, fm.liveswitch.DataStreamInfo.fromJson.bind(fm.liveswitch.DataStreamInfo));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to Json.
            @param dataStreamInfo The instance to serialize.
            @return Serialized Json.
            */
            DataStreamInfo.toJson = function (dataStreamInfo) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(dataStreamInfo, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance array to JSON.
            @param dataStreamInfos The instance array to serialize.
            @return Serialized Json.
            */
            DataStreamInfo.toJsonArray = function (dataStreamInfos) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(dataStreamInfos, fm.liveswitch.DataStreamInfo.toJson.bind(fm.liveswitch.DataStreamInfo));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            DataStreamInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "channels"))) {
                            if ((fm.liveswitch.Global.equals(str, "report"))) {
                                this.setReport(fm.liveswitch.DataStreamReport.fromJson(valueJson));
                            }
                        }
                        else {
                            this.setChannels(fm.liveswitch.DataChannelInfo.fromJsonArray(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the data stream channels.
            */
            DataStreamInfo.prototype.getChannels = function () {
                if (arguments.length == 0) {
                    return this._channels;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the data stream report.
            */
            DataStreamInfo.prototype.getReport = function () {
                if (arguments.length == 0) {
                    return this._report;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataStreamInfo.prototype.populateInfos = function (stats, lastStats, eventType) {
                if (arguments.length == 3) {
                    var flag = (fm.liveswitch.Global.equals(lastStats, null));
                    this.setReport(new fm.liveswitch.DataStreamReport(stats, lastStats, eventType));
                    var transport = stats.getTransport();
                    if ((!fm.liveswitch.Global.equals(transport, null))) {
                        _super.prototype.setTransportId.call(this, transport.getId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getChannels(), null))) {
                        var channels = stats.getChannels();
                        if ((!fm.liveswitch.Global.equals(channels, null))) {
                            var statsArray2 = (flag ? null : lastStats.getChannels());
                            for (var i = 0; (i < fm.liveswitch.MathAssistant.min(channels.length, this.getChannels().length)); i++) {
                                var stats3 = (((!fm.liveswitch.Global.equals(statsArray2, null)) && (statsArray2.length > i)) ? statsArray2[i] : null);
                                if (((!fm.liveswitch.Global.equals(stats3, null)) && (fm.liveswitch.Global.equals(channels[i].getState(), stats3.getState())))) {
                                    this.getChannels()[i].setState(null);
                                }
                                else {
                                    this.getChannels()[i].setState(fm.liveswitch.StringExtensions.toLower(new fm.liveswitch.DataChannelStateWrapper(channels[i].getState()).toString()));
                                }
                                this.getChannels()[i].populateReports(channels[i], (flag ? null : stats3), eventType);
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            DataStreamInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getChannels(), null))) {
                        jsonObject["channels"] = fm.liveswitch.DataChannelInfo.toJsonArray(this.getChannels());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getReport(), null))) {
                        jsonObject["report"] = this.getReport().toJson();
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the data stream channels.
            */
            DataStreamInfo.prototype.setChannels = function (value) {
                if (arguments.length == 1) {
                    this._channels = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the data stream report.
            */
            DataStreamInfo.prototype.setReport = function (value) {
                if (arguments.length == 1) {
                    this._report = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to Json.
            */
            DataStreamInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.DataStreamInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return DataStreamInfo;
        }(fm.liveswitch.StreamInfo));
        liveswitch.DataStreamInfo = DataStreamInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="BaseStats.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Stream stats.
        */
        var StreamStats = /** @class */ (function (_super) {
            __extends(StreamStats, _super);
            function StreamStats() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            StreamStats.prototype.getTypeString = function () {
                return '[fm.liveswitch.StreamStats]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            StreamStats.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "type"))) {
                            if ((fm.liveswitch.Global.equals(str, "transport"))) {
                                this.setTransport(fm.liveswitch.TransportStats.fromJson(valueJson));
                            }
                        }
                        else {
                            this.setType(this.typeFromString(fm.liveswitch.JsonSerializer.deserializeString(valueJson)));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the transport's active candidate pair has a host candidate.
            */
            StreamStats.prototype.getIsHost = function () {
                if (arguments.length == 0) {
                    var transport = this.getTransport();
                    if ((fm.liveswitch.Global.equals(transport, null))) {
                        return false;
                    }
                    return transport.getIsHost();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the transport's active candidate pair has a reflexive candidate.
            */
            StreamStats.prototype.getIsReflexive = function () {
                if (arguments.length == 0) {
                    var transport = this.getTransport();
                    if ((fm.liveswitch.Global.equals(transport, null))) {
                        return false;
                    }
                    return transport.getIsReflexive();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the transport's active candidate pair has a relayed candidate.
            */
            StreamStats.prototype.getIsRelayed = function () {
                if (arguments.length == 0) {
                    var transport = this.getTransport();
                    if ((fm.liveswitch.Global.equals(transport, null))) {
                        return false;
                    }
                    return transport.getIsRelayed();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the transport's stats.
            */
            StreamStats.prototype.getTransport = function () {
                if (arguments.length == 0) {
                    return this._transport;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the type.
            */
            StreamStats.prototype.getType = function () {
                if (arguments.length == 0) {
                    return this._type;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            StreamStats.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    jsonObject["type"] = fm.liveswitch.JsonSerializer.serializeString(this.typeToString(this.getType()));
                    if ((!fm.liveswitch.Global.equals(this.getTransport(), null))) {
                        jsonObject["transport"] = fm.liveswitch.TransportStats.toJson(this.getTransport());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            StreamStats.prototype.setTransport = function (value) {
                if (arguments.length == 1) {
                    this._transport = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            StreamStats.prototype.setType = function (value) {
                if (arguments.length == 1) {
                    this._type = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            StreamStats.prototype.typeFromString = function (typeString) {
                if (arguments.length == 1) {
                    var _var0 = typeString;
                    if (_var0 == "audio") {
                        do {
                            return fm.liveswitch.StreamType.Audio;
                        } while (false);
                    }
                    else if (_var0 == "video") {
                        do {
                            return fm.liveswitch.StreamType.Video;
                        } while (false);
                    }
                    else if (_var0 == "application") {
                        do {
                            return fm.liveswitch.StreamType.Application;
                        } while (false);
                    }
                    else if (_var0 == "message") {
                        do {
                            return fm.liveswitch.StreamType.Message;
                        } while (false);
                    }
                    else if (_var0 == "text") {
                        do {
                            return fm.liveswitch.StreamType.Text;
                        } while (false);
                    }
                    return fm.liveswitch.StreamType.Text;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            StreamStats.prototype.typeToString = function (type) {
                if (arguments.length == 1) {
                    var _var0 = type;
                    if (_var0 == fm.liveswitch.StreamType.Audio) {
                        do {
                            return "audio";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.StreamType.Video) {
                        do {
                            return "video";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.StreamType.Application) {
                        do {
                            return "application";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.StreamType.Message) {
                        do {
                            return "message";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.StreamType.Text) {
                        do {
                            return "text";
                        } while (false);
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return StreamStats;
        }(fm.liveswitch.BaseStats));
        liveswitch.StreamStats = StreamStats;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="StreamStats.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Data stream stats.
        */
        var DataStreamStats = /** @class */ (function (_super) {
            __extends(DataStreamStats, _super);
            function DataStreamStats() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchDataStreamStatsInit();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            DataStreamStats.prototype.getTypeString = function () {
                return '[fm.liveswitch.DataStreamStats]' + ',' + _super.prototype.getTypeString.call(this);
            };
            DataStreamStats.prototype.fmliveswitchDataStreamStatsInit = function () {
                this._bytesReceived = 0;
                this._bytesSent = 0;
                this._messagesReceived = 0;
                this._messagesSent = 0;
            };
            /**
            Derializes data stream stats from JSON.
            @param dataStreamJson The data stream's stats JSON.
            */
            DataStreamStats.fromJson = function (dataStreamJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(dataStreamJson, function () {
                        return new fm.liveswitch.DataStreamStats();
                    }, function (obj, key, valueJson) {
                        obj.deserializeProperties(key, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Derializes an array of data stream stats from JSON.
            @param dataStreamsJson The data streams' stats JSON.
            */
            DataStreamStats.fromJsonArray = function (dataStreamsJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(dataStreamsJson, fm.liveswitch.DataStreamStats.fromJson.bind(fm.liveswitch.DataStreamStats));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes data stream stats to JSON.
            @param dataStream The data stream's stats.
            */
            DataStreamStats.toJson = function (dataStream) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(dataStream, function (obj, jsonObject) {
                        obj.serializeProperties(jsonObject);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array of data stream stats to JSON.
            @param dataStreams The data streams' stats.
            */
            DataStreamStats.toJsonArray = function (dataStreams) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(dataStreams, fm.liveswitch.DataStreamStats.toJson.bind(fm.liveswitch.DataStreamStats));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            DataStreamStats.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "messagesSent"))) {
                            if ((fm.liveswitch.Global.equals(str, "bytesSent"))) {
                                this.setBytesSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "messagesReceived"))) {
                                    this.setMessagesReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "bytesReceived"))) {
                                        this.setBytesReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "channels"))) {
                                            this.setChannels(fm.liveswitch.DataChannelStats.fromJsonArray(valueJson));
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            this.setMessagesSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes received.
            */
            DataStreamStats.prototype.getBytesReceived = function () {
                if (arguments.length == 0) {
                    return this._bytesReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes sent.
            */
            DataStreamStats.prototype.getBytesSent = function () {
                if (arguments.length == 0) {
                    return this._bytesSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataStreamStats.prototype.getChannel = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Utility.firstOrDefault(this.getChannels());
                }
                else if (arguments.length == 1) {
                    var channelId = arguments[0];
                    for (var _i = 0, _a = this.getChannels(); _i < _a.length; _i++) {
                        var stats = _a[_i];
                        if ((fm.liveswitch.Global.equals(stats.getId(), channelId))) {
                            return stats;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the channels' stats.
            */
            DataStreamStats.prototype.getChannels = function () {
                if (arguments.length == 0) {
                    return this._channels;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataStreamStats.prototype.getDataChannel = function () {
                if (arguments.length == 0) {
                    return this.getChannel();
                }
                else if (arguments.length == 1) {
                    var dataChannelId = arguments[0];
                    return this.getChannel(dataChannelId);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the channels' stats. Obsolete. Alias for [[fm.liveswitch.dataStreamStats.channels]].
            */
            DataStreamStats.prototype.getDataChannels = function () {
                if (arguments.length == 0) {
                    return this.getChannels();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of messages received.
            */
            DataStreamStats.prototype.getMessagesReceived = function () {
                if (arguments.length == 0) {
                    return this._messagesReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of messages sent.
            */
            DataStreamStats.prototype.getMessagesSent = function () {
                if (arguments.length == 0) {
                    return this._messagesSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            DataStreamStats.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    jsonObject["messagesSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getMessagesSent());
                    jsonObject["bytesSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getBytesSent());
                    jsonObject["messagesReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getMessagesReceived());
                    jsonObject["bytesReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getBytesReceived());
                    if ((!fm.liveswitch.Global.equals(this.getChannels(), null))) {
                        jsonObject["channels"] = fm.liveswitch.DataChannelStats.toJsonArray(this.getChannels());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataStreamStats.prototype.setBytesReceived = function (value) {
                if (arguments.length == 1) {
                    this._bytesReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataStreamStats.prototype.setBytesSent = function (value) {
                if (arguments.length == 1) {
                    this._bytesSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataStreamStats.prototype.setChannels = function (value) {
                if (arguments.length == 1) {
                    this._channels = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataStreamStats.prototype.setMessagesReceived = function (value) {
                if (arguments.length == 1) {
                    this._messagesReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataStreamStats.prototype.setMessagesSent = function (value) {
                if (arguments.length == 1) {
                    this._messagesSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this to JSON.
            */
            DataStreamStats.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.DataStreamStats.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return DataStreamStats;
        }(fm.liveswitch.StreamStats));
        liveswitch.DataStreamStats = DataStreamStats;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Encoding configuration.
        */
        var EncodingConfig = /** @class */ (function () {
            function EncodingConfig() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchEncodingConfigInit();
                    this.setRtpStreamId(null);
                    this.setSynchronizationSource(-1);
                    this.setDeactivated(false);
                    this.setBitrate(-1);
                }
                else if (__arguments.length == 1) {
                    var encoding = __arguments[0];
                    //super();
                    this.fmliveswitchEncodingConfigInit();
                    this.setRtpStreamId(encoding.getRtpStreamId());
                    this.setSynchronizationSource(encoding.getSynchronizationSource());
                    this.setDeactivated(encoding.getDeactivated());
                    this.setBitrate(encoding.getBitrate());
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            EncodingConfig.prototype.getTypeString = function () {
                return '[fm.liveswitch.EncodingConfig]';
            };
            EncodingConfig.prototype.fmliveswitchEncodingConfigInit = function () {
                this._bitrate = 0;
                this._deactivated = false;
                this._synchronizationSource = 0;
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            EncodingConfig.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "rtpStreamId"))) {
                            if ((fm.liveswitch.Global.equals(str, "synchronizationSource"))) {
                                this.setSynchronizationSource(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "deactivated"))) {
                                    this.setDeactivated(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "bitrate"))) {
                                        this.setBitrate(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                    }
                                }
                            }
                        }
                        else {
                            this.setRtpStreamId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the bitrate, in kbps.
            */
            EncodingConfig.prototype.getBitrate = function () {
                if (arguments.length == 0) {
                    return this._bitrate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether this encoding is deactivated.
            */
            EncodingConfig.prototype.getDeactivated = function () {
                if (arguments.length == 0) {
                    return this._deactivated;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the RTP stream identifier.
            */
            EncodingConfig.prototype.getRtpStreamId = function () {
                if (arguments.length == 0) {
                    return this._rtpStreamId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the synchronization source.
            */
            EncodingConfig.prototype.getSynchronizationSource = function () {
                if (arguments.length == 0) {
                    return this._synchronizationSource;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            EncodingConfig.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(this.getRtpStreamId(), null))) {
                        jsonObject["rtpStreamId"] = fm.liveswitch.JsonSerializer.serializeString(this.getRtpStreamId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getSynchronizationSource(), -1))) {
                        jsonObject["synchronizationSource"] = fm.liveswitch.JsonSerializer.serializeLong(this.getSynchronizationSource());
                    }
                    if (this.getDeactivated()) {
                        jsonObject["deactivated"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getDeactivated());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getBitrate(), -1))) {
                        jsonObject["bitrate"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getBitrate());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the bitrate, in kbps.
            */
            EncodingConfig.prototype.setBitrate = function (value) {
                if (arguments.length == 1) {
                    this._bitrate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether this encoding is deactivated.
            */
            EncodingConfig.prototype.setDeactivated = function (value) {
                if (arguments.length == 1) {
                    this._deactivated = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingConfig.prototype.setRtpStreamId = function (value) {
                if (arguments.length == 1) {
                    this._rtpStreamId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingConfig.prototype.setSynchronizationSource = function (value) {
                if (arguments.length == 1) {
                    this._synchronizationSource = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return EncodingConfig;
        }());
        liveswitch.EncodingConfig = EncodingConfig;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="EncodingConfig.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Audio encoding configuration.
        */
        var AudioEncodingConfig = /** @class */ (function (_super) {
            __extends(AudioEncodingConfig, _super);
            function AudioEncodingConfig() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else if (__arguments.length == 1) {
                    var encoding = __arguments[0];
                    _this = _super.call(this, encoding) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            AudioEncodingConfig.prototype.getTypeString = function () {
                return '[fm.liveswitch.AudioEncodingConfig]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Deserializes an instance from JSON.
            @param encodingConfigJson The serialized JSON.
            @return The deserialized instance.
            */
            AudioEncodingConfig.fromJson = function (encodingConfigJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(encodingConfigJson, function () {
                        return new fm.liveswitch.AudioEncodingConfig();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array from JSON.
            @param encodingConfigsJson The serialized JSON.
            @return The deserialized array.
            */
            AudioEncodingConfig.fromJsonArray = function (encodingConfigsJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(encodingConfigsJson, fm.liveswitch.AudioEncodingConfig.fromJson.bind(fm.liveswitch.AudioEncodingConfig));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param encodingConfig The instance to serialize.
            @return The serialized JSON.
            */
            AudioEncodingConfig.toJson = function (encodingConfig) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(encodingConfig, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param encodingConfigs The array to serialize.
            @return The serialized JSON.
            */
            AudioEncodingConfig.toJsonArray = function (encodingConfigs) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(encodingConfigs, fm.liveswitch.AudioEncodingConfig.toJson.bind(fm.liveswitch.AudioEncodingConfig));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            AudioEncodingConfig.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.AudioEncodingConfig.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Returns a string that represents this instance.
            @return
                        A string that represents this instance.
                
            */
            AudioEncodingConfig.prototype.toString = function () {
                if (arguments.length == 0) {
                    var flag = false;
                    var list = new Array();
                    var rtpStreamId = _super.prototype.getRtpStreamId.call(this);
                    if ((!fm.liveswitch.Global.equals(rtpStreamId, null))) {
                        fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.format("RTP Stream ID: {0}", rtpStreamId));
                    }
                    var synchronizationSource = _super.prototype.getSynchronizationSource.call(this);
                    if ((!fm.liveswitch.Global.equals(synchronizationSource, -1))) {
                        fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.format("Synchronization Source: {0}", fm.liveswitch.NumberExtensions.toString(synchronizationSource)));
                    }
                    var deactivated = _super.prototype.getDeactivated.call(this);
                    if (deactivated) {
                        fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.format("Deactivated: {0}", fm.liveswitch.BooleanExtensions.toString(deactivated)));
                    }
                    var bitrate = _super.prototype.getBitrate.call(this);
                    if ((!fm.liveswitch.Global.equals(bitrate, -1))) {
                        flag = true;
                        fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.format("Bitrate: {0}", fm.liveswitch.NumberExtensions.toString(bitrate)));
                    }
                    var str2 = fm.liveswitch.StringExtensions.join(", ", fm.liveswitch.ArrayExtensions.toArray(list));
                    if (!flag) {
                        str2 = fm.liveswitch.StringExtensions.trim(fm.liveswitch.StringExtensions.format("{0} [Unrestricted]", str2));
                    }
                    return str2;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return AudioEncodingConfig;
        }(fm.liveswitch.EncodingConfig));
        liveswitch.AudioEncodingConfig = AudioEncodingConfig;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A stream description.
        */
        var StreamDescription = /** @class */ (function () {
            /**
            Creates a new StreamDescription object.
            @param description SDP MediaDescription of the stream.
            */
            function StreamDescription(description) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var description_1 = __arguments[0];
                    //super();
                    this.setMediaDescription(description_1);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            StreamDescription.prototype.getTypeString = function () {
                return '[fm.liveswitch.StreamDescription]';
            };
            /**
            Gets the media description associated with this stream.
            */
            StreamDescription.prototype.getMediaDescription = function () {
                if (arguments.length == 0) {
                    return this._mediaDescription;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the mid associated with this stream, if present. Null if not.
            */
            StreamDescription.prototype.getMediaDescriptionIdentifier = function () {
                if (arguments.length == 0) {
                    var mediaDescription = this.getMediaDescription();
                    if ((!fm.liveswitch.Global.equals(mediaDescription, null))) {
                        var mediaStreamIdentifierAttribute = mediaDescription.getMediaStreamIdentifierAttribute();
                        if ((!fm.liveswitch.Global.equals(mediaStreamIdentifierAttribute, null))) {
                            return mediaStreamIdentifierAttribute.getIdentificationTag();
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the stream type.
            */
            StreamDescription.prototype.getStreamType = function () {
                if (arguments.length == 0) {
                    var mediaDescription = this.getMediaDescription();
                    if ((!fm.liveswitch.Global.equals(mediaDescription, null))) {
                        if (mediaDescription.getIsApplication()) {
                            return fm.liveswitch.StreamType.Application;
                        }
                        if (mediaDescription.getIsAudio()) {
                            return fm.liveswitch.StreamType.Audio;
                        }
                        if (mediaDescription.getIsVideo()) {
                            return fm.liveswitch.StreamType.Video;
                        }
                        if (mediaDescription.getIsMessage()) {
                            return fm.liveswitch.StreamType.Message;
                        }
                        if (mediaDescription.getIsText()) {
                            return fm.liveswitch.StreamType.Text;
                        }
                    }
                    throw new fm.liveswitch.Exception("Could not identify the stream type from the media description.");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media description associated with this stream.
            */
            StreamDescription.prototype.setMediaDescription = function (value) {
                if (arguments.length == 1) {
                    this._mediaDescription = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return StreamDescription;
        }());
        liveswitch.StreamDescription = StreamDescription;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="EncodingConfig.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Video encoding configuration.
        */
        var VideoEncodingConfig = /** @class */ (function (_super) {
            __extends(VideoEncodingConfig, _super);
            function VideoEncodingConfig() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchVideoEncodingConfigInit();
                    _this.setFrameRate(-1);
                    _this.setScale(-1);
                }
                else if (__arguments.length == 1) {
                    var encoding = __arguments[0];
                    _this = _super.call(this, encoding) || this;
                    _this.fmliveswitchVideoEncodingConfigInit();
                    _this.setFrameRate(encoding.getFrameRate());
                    _this.setScale(encoding.getScale());
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            VideoEncodingConfig.prototype.getTypeString = function () {
                return '[fm.liveswitch.VideoEncodingConfig]' + ',' + _super.prototype.getTypeString.call(this);
            };
            VideoEncodingConfig.prototype.fmliveswitchVideoEncodingConfigInit = function () {
                this._frameRate = 0;
                this._scale = 0;
            };
            /**
            Deserializes an instance from JSON.
            @param encodingConfigJson The serialized JSON.
            @return The deserialized instance.
            */
            VideoEncodingConfig.fromJson = function (encodingConfigJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(encodingConfigJson, function () {
                        return new fm.liveswitch.VideoEncodingConfig();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array from JSON.
            @param encodingConfigsJson The serialized JSON.
            @return The deserialized array.
            */
            VideoEncodingConfig.fromJsonArray = function (encodingConfigsJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(encodingConfigsJson, fm.liveswitch.VideoEncodingConfig.fromJson.bind(fm.liveswitch.VideoEncodingConfig));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param encodingConfig The instance to serialize.
            @return The serialized JSON.
            */
            VideoEncodingConfig.toJson = function (encodingConfig) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(encodingConfig, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param encodingConfigs The array to serialize.
            @return The serialized JSON.
            */
            VideoEncodingConfig.toJsonArray = function (encodingConfigs) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(encodingConfigs, fm.liveswitch.VideoEncodingConfig.toJson.bind(fm.liveswitch.VideoEncodingConfig));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            VideoEncodingConfig.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "frameRate"))) {
                            if ((fm.liveswitch.Global.equals(str, "scale"))) {
                                this.setScale(fm.liveswitch.JsonSerializer.deserializeDouble(valueJson));
                            }
                        }
                        else {
                            this.setFrameRate(fm.liveswitch.JsonSerializer.deserializeDouble(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the frame-rate, in fps.
            */
            VideoEncodingConfig.prototype.getFrameRate = function () {
                if (arguments.length == 0) {
                    return this._frameRate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the target scale.
            */
            VideoEncodingConfig.prototype.getScale = function () {
                if (arguments.length == 0) {
                    return this._scale;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            VideoEncodingConfig.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getFrameRate(), -1))) {
                        jsonObject["frameRate"] = fm.liveswitch.JsonSerializer.serializeDouble(this.getFrameRate());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getScale(), -1))) {
                        jsonObject["scale"] = fm.liveswitch.JsonSerializer.serializeDouble(this.getScale());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the frame-rate, in fps.
            */
            VideoEncodingConfig.prototype.setFrameRate = function (value) {
                if (arguments.length == 1) {
                    this._frameRate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the target scale.
            */
            VideoEncodingConfig.prototype.setScale = function (value) {
                if (arguments.length == 1) {
                    this._scale = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            VideoEncodingConfig.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.VideoEncodingConfig.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Returns a string that represents this instance.
            @return
                        A string that represents this instance.
                
            */
            VideoEncodingConfig.prototype.toString = function () {
                if (arguments.length == 0) {
                    var flag = false;
                    var list = new Array();
                    var rtpStreamId = _super.prototype.getRtpStreamId.call(this);
                    if ((!fm.liveswitch.Global.equals(rtpStreamId, null))) {
                        fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.format("RTP Stream ID: {0}", rtpStreamId));
                    }
                    var synchronizationSource = _super.prototype.getSynchronizationSource.call(this);
                    if ((!fm.liveswitch.Global.equals(synchronizationSource, -1))) {
                        fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.format("Synchronization Source: {0}", fm.liveswitch.NumberExtensions.toString(synchronizationSource)));
                    }
                    var deactivated = _super.prototype.getDeactivated.call(this);
                    if (deactivated) {
                        fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.format("Deactivated: {0}", fm.liveswitch.BooleanExtensions.toString(deactivated)));
                    }
                    var bitrate = _super.prototype.getBitrate.call(this);
                    if ((!fm.liveswitch.Global.equals(bitrate, -1))) {
                        flag = true;
                        fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.format("Bitrate: {0}", fm.liveswitch.NumberExtensions.toString(bitrate)));
                    }
                    var frameRate = this.getFrameRate();
                    if ((!fm.liveswitch.Global.equals(frameRate, -1))) {
                        flag = true;
                        fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.format("Frame Rate: {0}", fm.liveswitch.NumberExtensions.toString(frameRate)));
                    }
                    var scale = this.getScale();
                    if ((!fm.liveswitch.Global.equals(scale, -1))) {
                        flag = true;
                        fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.format("Scale: {0}", fm.liveswitch.NumberExtensions.toString(scale)));
                    }
                    var str2 = fm.liveswitch.StringExtensions.join(", ", fm.liveswitch.ArrayExtensions.toArray(list));
                    if (!flag) {
                        str2 = fm.liveswitch.StringExtensions.trim(fm.liveswitch.StringExtensions.format("{0} [Unrestricted]", str2));
                    }
                    return str2;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return VideoEncodingConfig;
        }(fm.liveswitch.EncodingConfig));
        liveswitch.VideoEncodingConfig = VideoEncodingConfig;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var EncryptionModeWrapper = /** @class */ (function () {
            function EncryptionModeWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_23 = __arguments[0];
                    //super();
                    this._value = value_23;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            EncryptionModeWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.EncryptionModeWrapper]';
            };
            EncryptionModeWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.EncryptionMode.Null)
                        return 'Null';
                    if (this._value == fm.liveswitch.EncryptionMode.Aes128Strong)
                        return 'Aes128Strong';
                    if (this._value == fm.liveswitch.EncryptionMode.Aes128Weak)
                        return 'Aes128Weak';
                    if (this._value == fm.liveswitch.EncryptionMode.NullStrong)
                        return 'NullStrong';
                    if (this._value == fm.liveswitch.EncryptionMode.NullWeak)
                        return 'NullWeak';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return EncryptionModeWrapper;
        }());
        liveswitch.EncryptionModeWrapper = EncryptionModeWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Format information.
        */
        var FormatInfo = /** @class */ (function () {
            function FormatInfo() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchFormatInfoInit();
                }
                else if (__arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.AudioFormat]'))) {
                    var audioFormat = __arguments[0];
                    // chained constructor: FormatInfo.call(this, audioFormat.getName(), audioFormat.getClockRate(), audioFormat.getChannelCount());
                    __arguments = new Array(3);
                    __arguments[0] = audioFormat.getName();
                    __arguments[1] = audioFormat.getClockRate();
                    __arguments[2] = audioFormat.getChannelCount();
                    {
                        var name_9 = __arguments[0];
                        var clockRate = __arguments[1];
                        var channelCount = __arguments[2];
                        //super();
                        this.fmliveswitchFormatInfoInit();
                        this.setName(name_9);
                        this.setClockRate(clockRate);
                        this.setChannelCount(channelCount);
                    }
                }
                else if (__arguments.length == 2) {
                    var codecName = __arguments[0];
                    var clockRate = __arguments[1];
                    // chained constructor: FormatInfo.call(this, codecName, clockRate, 0);
                    __arguments = new Array(3);
                    __arguments[0] = codecName;
                    __arguments[1] = clockRate;
                    __arguments[2] = 0;
                    {
                        var name_10 = __arguments[0];
                        var clockRate_3 = __arguments[1];
                        var channelCount = __arguments[2];
                        //super();
                        this.fmliveswitchFormatInfoInit();
                        this.setName(name_10);
                        this.setClockRate(clockRate_3);
                        this.setChannelCount(channelCount);
                    }
                }
                else if (__arguments.length == 3) {
                    var name_11 = __arguments[0];
                    var clockRate = __arguments[1];
                    var channelCount = __arguments[2];
                    //super();
                    this.fmliveswitchFormatInfoInit();
                    this.setName(name_11);
                    this.setClockRate(clockRate);
                    this.setChannelCount(channelCount);
                }
                else if (__arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.VideoFormat]'))) {
                    var videoFormat = __arguments[0];
                    // chained constructor: FormatInfo.call(this, videoFormat.getName(), videoFormat.getClockRate());
                    __arguments = new Array(2);
                    __arguments[0] = videoFormat.getName();
                    __arguments[1] = videoFormat.getClockRate();
                    {
                        var codecName = __arguments[0];
                        var clockRate = __arguments[1];
                        // chained constructor: FormatInfo.call(this, codecName, clockRate, 0);
                        __arguments = new Array(3);
                        __arguments[0] = codecName;
                        __arguments[1] = clockRate;
                        __arguments[2] = 0;
                        {
                            var name_12 = __arguments[0];
                            var clockRate_4 = __arguments[1];
                            var channelCount = __arguments[2];
                            //super();
                            this.fmliveswitchFormatInfoInit();
                            this.setName(name_12);
                            this.setClockRate(clockRate_4);
                            this.setChannelCount(channelCount);
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            FormatInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.FormatInfo]';
            };
            FormatInfo.prototype.fmliveswitchFormatInfoInit = function () {
                this._channelCount = 0;
                this._clockRate = 0;
            };
            /**
            Deserializes Json to a FormatInfo.
            @param formatInfoJson The serialized Json.
            @return The deserialized FormatInfo.
            */
            FormatInfo.fromJson = function (formatInfoJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(formatInfoJson, function () {
                        return new fm.liveswitch.FormatInfo();
                    }, function (info, key, value) {
                        var str = key;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            if (!(fm.liveswitch.Global.equals(str, "name"))) {
                                if ((fm.liveswitch.Global.equals(str, "clockRate"))) {
                                    info.setClockRate(fm.liveswitch.JsonSerializer.deserializeInteger(value));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "channelCount"))) {
                                        info.setChannelCount(fm.liveswitch.JsonSerializer.deserializeInteger(value));
                                    }
                                }
                            }
                            else {
                                info.setName(fm.liveswitch.JsonSerializer.deserializeString(value));
                            }
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Derializes an array of format infos from JSON.
            @param formatInfosJson The format infos in JSON format.
            */
            FormatInfo.fromJsonArray = function (formatInfosJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(formatInfosJson, fm.liveswitch.FormatInfo.fromJson.bind(fm.liveswitch.FormatInfo));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts the RTP map attributes in an SDP media description to an array of FormatInfo objects.
            @param sdpMediaDescription The SDP media description.
            @return An array of FormatInfo objects.
            */
            FormatInfo.fromSdpMediaDescription = function (sdpMediaDescription) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(sdpMediaDescription, null))) {
                        return null;
                    }
                    var list = new Array();
                    for (var _i = 0, _a = sdpMediaDescription.getRtpMapAttributes(); _i < _a.length; _i++) {
                        var attribute = _a[_i];
                        var intResult = 1;
                        if (!fm.liveswitch.StringExtensions.isNullOrEmpty(attribute.getFormatParameters())) {
                            var _var0 = new fm.liveswitch.Holder(intResult);
                            var _var1 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(attribute.getFormatParameters(), _var0);
                            intResult = _var0.getValue();
                        }
                        fm.liveswitch.ArrayExtensions.add(list, new fm.liveswitch.FormatInfo(attribute.getFormatName(), attribute.getClockRate(), intResult));
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to Json.
            @param formatInfo The instance to serialize.
            @return Serialized Json.
            */
            FormatInfo.toJson = function (formatInfo) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(formatInfo, function (info, dict) {
                        dict["name"] = fm.liveswitch.JsonSerializer.serializeString(info.getName());
                        dict["clockRate"] = fm.liveswitch.JsonSerializer.serializeInteger(info.getClockRate());
                        if ((info.getChannelCount() > 0)) {
                            dict["channelCount"] = fm.liveswitch.JsonSerializer.serializeInteger(info.getChannelCount());
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array of format infos to JSON.
            @param formatInfos The format infos.
            */
            FormatInfo.toJsonArray = function (formatInfos) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(formatInfos, fm.liveswitch.FormatInfo.toJson.bind(fm.liveswitch.FormatInfo));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the channel count if available. Unused for video codecs.
            */
            FormatInfo.prototype.getChannelCount = function () {
                if (arguments.length == 0) {
                    return this._channelCount;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the clock rate.
            */
            FormatInfo.prototype.getClockRate = function () {
                if (arguments.length == 0) {
                    return this._clockRate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name. Obsolete. Alias for [[fm.liveswitch.formatInfo.name]].
            */
            FormatInfo.prototype.getCodecName = function () {
                if (arguments.length == 0) {
                    return this.getName();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name.
            */
            FormatInfo.prototype.getName = function () {
                if (arguments.length == 0) {
                    return this._name;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            FormatInfo.prototype.isEquivalent = function () {
                if (arguments.length == 1) {
                    var instance = arguments[0];
                    return ((!fm.liveswitch.Global.equals(instance, null)) && this.isEquivalent(instance.getName(), instance.getClockRate(), instance.getChannelCount()));
                }
                else if (arguments.length == 3) {
                    var name_13 = arguments[0];
                    var clockRate = arguments[1];
                    var channelCount = arguments[2];
                    return (((fm.liveswitch.Global.equals(name_13, this.getName())) && (fm.liveswitch.Global.equals(clockRate, this.getClockRate()))) && (fm.liveswitch.Global.equals(channelCount, this.getChannelCount())));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the channel count if available. Unused for video codecs.
            */
            FormatInfo.prototype.setChannelCount = function (value) {
                if (arguments.length == 1) {
                    this._channelCount = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the clock rate.
            */
            FormatInfo.prototype.setClockRate = function (value) {
                if (arguments.length == 1) {
                    this._clockRate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the name. Obsolete. Alias for [[fm.liveswitch.formatInfo.name]].
            */
            FormatInfo.prototype.setCodecName = function (value) {
                if (arguments.length == 1) {
                    this.setName(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the name.
            */
            FormatInfo.prototype.setName = function (value) {
                if (arguments.length == 1) {
                    this._name = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to Json.
            */
            FormatInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.FormatInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Returns a string that represents this instance.
            */
            FormatInfo.prototype.toString = function () {
                if (arguments.length == 0) {
                    if ((this.getChannelCount() > 1)) {
                        return fm.liveswitch.StringExtensions.format("{0}/{1}/{2}", this.getName(), fm.liveswitch.NumberExtensions.toString(this.getClockRate()), fm.liveswitch.NumberExtensions.toString(this.getChannelCount()));
                    }
                    return fm.liveswitch.StringExtensions.format("{0}/{1}", this.getName(), fm.liveswitch.NumberExtensions.toString(this.getClockRate()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return FormatInfo;
        }());
        liveswitch.FormatInfo = FormatInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A layout frame definition, including X/Y coordinates and width/height values.
        */
        var LayoutFrame = /** @class */ (function () {
            function LayoutFrame() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchLayoutFrameInit();
                }
                else if (__arguments.length == 4) {
                    var x = __arguments[0];
                    var y = __arguments[1];
                    var width = __arguments[2];
                    var height = __arguments[3];
                    //super();
                    this.fmliveswitchLayoutFrameInit();
                    this.setX(x);
                    this.setY(y);
                    this.setWidth(width);
                    this.setHeight(height);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            LayoutFrame.prototype.getTypeString = function () {
                return '[fm.liveswitch.LayoutFrame]';
            };
            LayoutFrame.prototype.fmliveswitchLayoutFrameInit = function () {
                this._height = 0;
                this._orientation = 0;
                this._width = 0;
                this._x = 0;
                this._y = 0;
            };
            /**
            Deserializes a layout frame from JSON.
            @param layoutFrameJson The layout frame JSON.
            */
            LayoutFrame.fromJson = function (layoutFrameJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(layoutFrameJson, function () {
                        return new fm.liveswitch.LayoutFrame();
                    }, function (rectangle, key, valueJson) {
                        var _var0 = key;
                        if (_var0 == "x") {
                            do {
                                rectangle.setX(fm.liveswitch.ParseAssistant.parseIntegerValue(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "y") {
                            do {
                                rectangle.setY(fm.liveswitch.ParseAssistant.parseIntegerValue(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "w" || _var0 == "width") {
                            do {
                                rectangle.setWidth(fm.liveswitch.ParseAssistant.parseIntegerValue(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "h" || _var0 == "height") {
                            do {
                                rectangle.setHeight(fm.liveswitch.ParseAssistant.parseIntegerValue(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "orientation") {
                            do {
                                rectangle.setOrientation(fm.liveswitch.ParseAssistant.parseIntegerValue(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "uid") {
                            do {
                                rectangle.setUserId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "did") {
                            do {
                                rectangle.setDeviceId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "cid") {
                            do {
                                rectangle.setClientId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                break;
                            } while (false);
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a scaled frame.
            @param scale The scaling algorithm to use.
            @param outerWidth The width of the outer container.
            @param outerHeight The height of the outer container.
            @param innerWidth The width of the inner element.
            @param innerHeight The height of the inner element.
            */
            LayoutFrame.getScaledFrame = function (scale, outerWidth, outerHeight, innerWidth, innerHeight) {
                if (arguments.length == 5) {
                    var x = 0;
                    var y = 0;
                    var width = outerWidth;
                    var height = outerHeight;
                    if (((((fm.liveswitch.Global.equals(outerWidth, 0)) || (fm.liveswitch.Global.equals(outerHeight, 0))) || (fm.liveswitch.Global.equals(innerWidth, 0))) || (fm.liveswitch.Global.equals(innerHeight, 0)))) {
                        if (((fm.liveswitch.Global.equals(outerWidth, 0)) || (fm.liveswitch.Global.equals(innerWidth, 0)))) {
                            width = 0;
                            x = fm.liveswitch.MathAssistant.floor(outerWidth / 2);
                        }
                        if (((fm.liveswitch.Global.equals(outerHeight, 0)) || (fm.liveswitch.Global.equals(innerHeight, 0)))) {
                            height = 0;
                            y = fm.liveswitch.MathAssistant.floor(outerHeight / 2);
                        }
                    }
                    else {
                        var num5 = void 0;
                        var num6 = void 0;
                        if ((fm.liveswitch.Global.equals(scale, fm.liveswitch.LayoutScale.Contain))) {
                            num5 = (outerWidth / outerHeight);
                            num6 = (innerWidth / innerHeight);
                            if ((num5 > num6)) {
                                width = (outerHeight * num6);
                                x = fm.liveswitch.MathAssistant.floor((outerWidth - width) / 2);
                            }
                            else {
                                if ((num5 < num6)) {
                                    height = (outerWidth / num6);
                                    y = fm.liveswitch.MathAssistant.floor((outerHeight - height) / 2);
                                }
                            }
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(scale, fm.liveswitch.LayoutScale.Cover))) {
                                num5 = (outerWidth / outerHeight);
                                num6 = (innerWidth / innerHeight);
                                if ((num5 < num6)) {
                                    width = (outerHeight * num6);
                                    x = fm.liveswitch.MathAssistant.floor((outerWidth - width) / 2);
                                }
                                else {
                                    if ((num5 > num6)) {
                                        height = (outerWidth / num6);
                                        y = fm.liveswitch.MathAssistant.floor((outerHeight - height) / 2);
                                    }
                                }
                            }
                        }
                    }
                    return new fm.liveswitch.LayoutFrame(x, y, width, height);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a layout frame to JSON.
            @param layoutFrame The layout frame.
            */
            LayoutFrame.toJson = function (layoutFrame) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(layoutFrame, function (r, jsonObject) {
                        jsonObject["x"] = fm.liveswitch.NumberExtensions.toString(r.getX());
                        jsonObject["y"] = fm.liveswitch.NumberExtensions.toString(r.getY());
                        jsonObject["width"] = fm.liveswitch.NumberExtensions.toString(r.getWidth());
                        jsonObject["height"] = fm.liveswitch.NumberExtensions.toString(r.getHeight());
                        jsonObject["orientation"] = fm.liveswitch.NumberExtensions.toString(r.getOrientation());
                        if ((!fm.liveswitch.Global.equals(r.getUserId(), null))) {
                            jsonObject["uid"] = fm.liveswitch.JsonSerializer.serializeString(r.getUserId());
                        }
                        if ((!fm.liveswitch.Global.equals(r.getDeviceId(), null))) {
                            jsonObject["did"] = fm.liveswitch.JsonSerializer.serializeString(r.getDeviceId());
                        }
                        if ((!fm.liveswitch.Global.equals(r.getClientId(), null))) {
                            jsonObject["cid"] = fm.liveswitch.JsonSerializer.serializeString(r.getClientId());
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client identifier.
            */
            LayoutFrame.prototype.getClientId = function () {
                if (arguments.length == 0) {
                    return this._clientId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the device identifier.
            */
            LayoutFrame.prototype.getDeviceId = function () {
                if (arguments.length == 0) {
                    return this._deviceId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the height value.
            */
            LayoutFrame.prototype.getHeight = function () {
                if (arguments.length == 0) {
                    return this._height;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the orientation in degrees.
            */
            LayoutFrame.prototype.getOrientation = function () {
                if (arguments.length == 0) {
                    return this._orientation;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the user identifier.
            */
            LayoutFrame.prototype.getUserId = function () {
                if (arguments.length == 0) {
                    return this._userId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the view ID.
            */
            LayoutFrame.prototype.getViewId = function () {
                if (arguments.length == 0) {
                    return this._viewId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the width value.
            */
            LayoutFrame.prototype.getWidth = function () {
                if (arguments.length == 0) {
                    return this._width;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the X coordinate.
            */
            LayoutFrame.prototype.getX = function () {
                if (arguments.length == 0) {
                    return this._x;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the Y coordinate.
            */
            LayoutFrame.prototype.getY = function () {
                if (arguments.length == 0) {
                    return this._y;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Determines whether the specified layout frame is equivalent.
            @param layoutFrame The layout frame.
            */
            LayoutFrame.prototype.isEquivalent = function (layoutFrame) {
                if (arguments.length == 1) {
                    return ((((fm.liveswitch.Global.equals(layoutFrame.getX(), this.getX())) && (fm.liveswitch.Global.equals(layoutFrame.getY(), this.getY()))) && (fm.liveswitch.Global.equals(layoutFrame.getWidth(), this.getWidth()))) && (fm.liveswitch.Global.equals(layoutFrame.getHeight(), this.getHeight())));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the client identifier.
            */
            LayoutFrame.prototype.setClientId = function (value) {
                if (arguments.length == 1) {
                    this._clientId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the device identifier.
            */
            LayoutFrame.prototype.setDeviceId = function (value) {
                if (arguments.length == 1) {
                    this._deviceId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the height value.
            */
            LayoutFrame.prototype.setHeight = function (value) {
                if (arguments.length == 1) {
                    this._height = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the orientation in degrees.
            */
            LayoutFrame.prototype.setOrientation = function (value) {
                if (arguments.length == 1) {
                    this._orientation = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the user identifier.
            */
            LayoutFrame.prototype.setUserId = function (value) {
                if (arguments.length == 1) {
                    this._userId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the view ID.
            */
            LayoutFrame.prototype.setViewId = function (value) {
                if (arguments.length == 1) {
                    this._viewId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the width value.
            */
            LayoutFrame.prototype.setWidth = function (value) {
                if (arguments.length == 1) {
                    this._width = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the X coordinate.
            */
            LayoutFrame.prototype.setX = function (value) {
                if (arguments.length == 1) {
                    this._x = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the Y coordinate.
            */
            LayoutFrame.prototype.setY = function (value) {
                if (arguments.length == 1) {
                    this._y = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            LayoutFrame.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.LayoutFrame.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return LayoutFrame;
        }());
        liveswitch.LayoutFrame = LayoutFrame;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var LayoutScaleWrapper = /** @class */ (function () {
            function LayoutScaleWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_24 = __arguments[0];
                    //super();
                    this._value = value_24;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            LayoutScaleWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.LayoutScaleWrapper]';
            };
            LayoutScaleWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.LayoutScale.Contain)
                        return 'Contain';
                    if (this._value == fm.liveswitch.LayoutScale.Cover)
                        return 'Cover';
                    if (this._value == fm.liveswitch.LayoutScale.Stretch)
                        return 'Stretch';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return LayoutScaleWrapper;
        }());
        liveswitch.LayoutScaleWrapper = LayoutScaleWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media component information.
        */
        var MediaComponentInfo = /** @class */ (function (_super) {
            __extends(MediaComponentInfo, _super);
            function MediaComponentInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaComponentInfoInit();
                }
                else if (__arguments.length == 2) {
                    var stats = __arguments[0];
                    var lastStats = __arguments[1];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaComponentInfoInit();
                    _super.prototype.setId.call(_this, stats.getId());
                    var stats2 = ((fm.liveswitch.Global.equals(lastStats, null)) ? stats.getTrack() : fm.liveswitch.Info.processObject(stats.getTrack(), lastStats.getTrack()));
                    if ((!fm.liveswitch.Global.equals(stats2, null))) {
                        var stats3 = ((fm.liveswitch.Global.equals(lastStats, null)) ? null : lastStats.getTrack());
                        _this.setSynchronizationSource(((fm.liveswitch.Global.equals(stats3, null)) ? stats2.getSynchronizationSource() : fm.liveswitch.Info.processLong(stats2.getSynchronizationSource(), stats3.getSynchronizationSource())));
                        _this.setTrack(new fm.liveswitch.MediaTrackInfo(stats2, stats3));
                    }
                    var stats4 = ((fm.liveswitch.Global.equals(lastStats, null)) ? stats.getCodec() : fm.liveswitch.Info.processObject(stats.getCodec(), lastStats.getCodec()));
                    if ((!fm.liveswitch.Global.equals(stats4, null))) {
                        var stats5 = ((fm.liveswitch.Global.equals(lastStats, null)) ? null : lastStats.getCodec());
                        var info = new fm.liveswitch.CodecInfo();
                        info.setId(stats4.getId());
                        info.setChannelCount(((fm.liveswitch.Global.equals(stats5, null)) ? stats4.getChannelCount() : fm.liveswitch.Info.processInteger(stats4.getChannelCount(), stats5.getChannelCount())));
                        info.setClockRate(((fm.liveswitch.Global.equals(stats5, null)) ? stats4.getClockRate() : fm.liveswitch.Info.processInteger(stats4.getClockRate(), stats5.getClockRate())));
                        info.setName(((fm.liveswitch.Global.equals(stats5, null)) ? stats4.getName() : fm.liveswitch.Info.processString(stats4.getName(), stats5.getName())));
                        info.setParameters(((fm.liveswitch.Global.equals(stats5, null)) ? stats4.getParameters() : fm.liveswitch.Info.processString(stats4.getParameters(), stats5.getParameters())));
                        info.setPayloadType(((fm.liveswitch.Global.equals(stats5, null)) ? stats4.getPayloadType() : fm.liveswitch.Info.processInteger(stats4.getPayloadType(), stats5.getPayloadType())));
                        _this.setCodec(info);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaComponentInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaComponentInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            MediaComponentInfo.prototype.fmliveswitchMediaComponentInfoInit = function () {
                this._synchronizationSource = 0;
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            MediaComponentInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "track"))) {
                            if ((fm.liveswitch.Global.equals(str, "codec"))) {
                                this.setCodec(fm.liveswitch.CodecInfo.fromJson(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "synchronizationSource"))) {
                                    this.setSynchronizationSource(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                                }
                            }
                        }
                        else {
                            this.setTrack(fm.liveswitch.MediaTrackInfo.fromJson(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets codec.
            */
            MediaComponentInfo.prototype.getCodec = function () {
                if (arguments.length == 0) {
                    return this._codec;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets synchronization source of media track.
            */
            MediaComponentInfo.prototype.getSynchronizationSource = function () {
                if (arguments.length == 0) {
                    return this._synchronizationSource;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets track.
            */
            MediaComponentInfo.prototype.getTrack = function () {
                if (arguments.length == 0) {
                    return this._track;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            MediaComponentInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getTrack(), null))) {
                        jsonObject["track"] = fm.liveswitch.MediaTrackInfo.toJson(this.getTrack());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getCodec(), null))) {
                        jsonObject["codec"] = fm.liveswitch.CodecInfo.toJson(this.getCodec());
                    }
                    if ((this.getSynchronizationSource() != null)) {
                        jsonObject["synchronizationSource"] = fm.liveswitch.JsonSerializer.serializeLong(this.getSynchronizationSource());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets codec.
            */
            MediaComponentInfo.prototype.setCodec = function (value) {
                if (arguments.length == 1) {
                    this._codec = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets synchronization source of media track.
            */
            MediaComponentInfo.prototype.setSynchronizationSource = function (value) {
                if (arguments.length == 1) {
                    this._synchronizationSource = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets track.
            */
            MediaComponentInfo.prototype.setTrack = function (value) {
                if (arguments.length == 1) {
                    this._track = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaComponentInfo;
        }(fm.liveswitch.Info));
        liveswitch.MediaComponentInfo = MediaComponentInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="BaseStats.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media component stats.
        */
        var MediaComponentStats = /** @class */ (function (_super) {
            __extends(MediaComponentStats, _super);
            function MediaComponentStats() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaComponentStatsInit();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaComponentStats.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaComponentStats]' + ',' + _super.prototype.getTypeString.call(this);
            };
            MediaComponentStats.prototype.fmliveswitchMediaComponentStatsInit = function () {
                this._firCount = 0;
                this._lrrCount = 0;
                this._nackCount = 0;
                this._pliCount = 0;
                this._sliCount = 0;
                this._synchronizationSource = 0;
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            MediaComponentStats.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var _var0 = key;
                    if (_var0 == "ssrc") {
                        do {
                            this.setSynchronizationSource(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "rid") {
                        do {
                            this.setRtpStreamId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "rrid") {
                        do {
                            this.setRepairedRtpStreamId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "track") {
                        do {
                            this.setTrack(fm.liveswitch.MediaTrackStats.fromJson(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "codec") {
                        do {
                            this.setCodec(fm.liveswitch.CodecStats.fromJson(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "nackCount") {
                        do {
                            this.setNackCount(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "pliCount") {
                        do {
                            this.setPliCount(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "firCount") {
                        do {
                            this.setFirCount(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "lrrCount") {
                        do {
                            this.setLrrCount(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "sliCount") {
                        do {
                            this.setSliCount(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the codec stats.
            */
            MediaComponentStats.prototype.getCodec = function () {
                if (arguments.length == 0) {
                    return this._codec;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the FIR count.
            */
            MediaComponentStats.prototype.getFirCount = function () {
                if (arguments.length == 0) {
                    return this._firCount;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the LRR count.
            */
            MediaComponentStats.prototype.getLrrCount = function () {
                if (arguments.length == 0) {
                    return this._lrrCount;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the NACK count.
            */
            MediaComponentStats.prototype.getNackCount = function () {
                if (arguments.length == 0) {
                    return this._nackCount;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the PLI count.
            */
            MediaComponentStats.prototype.getPliCount = function () {
                if (arguments.length == 0) {
                    return this._pliCount;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the repaired RTP stream identifier.
            */
            MediaComponentStats.prototype.getRepairedRtpStreamId = function () {
                if (arguments.length == 0) {
                    return this._repairedRtpStreamId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the RTP stream identifier.
            */
            MediaComponentStats.prototype.getRtpStreamId = function () {
                if (arguments.length == 0) {
                    return this._rtpStreamId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the SLI count.
            */
            MediaComponentStats.prototype.getSliCount = function () {
                if (arguments.length == 0) {
                    return this._sliCount;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the synchronization source.
            */
            MediaComponentStats.prototype.getSynchronizationSource = function () {
                if (arguments.length == 0) {
                    return this._synchronizationSource;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the track's stats.
            */
            MediaComponentStats.prototype.getTrack = function () {
                if (arguments.length == 0) {
                    return this._track;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            MediaComponentStats.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    jsonObject["ssrc"] = fm.liveswitch.JsonSerializer.serializeLong(this.getSynchronizationSource());
                    jsonObject["rid"] = fm.liveswitch.JsonSerializer.serializeString(this.getRtpStreamId());
                    jsonObject["rrid"] = fm.liveswitch.JsonSerializer.serializeString(this.getRepairedRtpStreamId());
                    if ((!fm.liveswitch.Global.equals(this.getTrack(), null))) {
                        jsonObject["track"] = fm.liveswitch.MediaTrackStats.toJson(this.getTrack());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getCodec(), null))) {
                        jsonObject["codec"] = fm.liveswitch.CodecStats.toJson(this.getCodec());
                    }
                    jsonObject["nackCount"] = fm.liveswitch.JsonSerializer.serializeLong(this.getNackCount());
                    jsonObject["pliCount"] = fm.liveswitch.JsonSerializer.serializeLong(this.getPliCount());
                    jsonObject["firCount"] = fm.liveswitch.JsonSerializer.serializeLong(this.getFirCount());
                    jsonObject["lrrCount"] = fm.liveswitch.JsonSerializer.serializeLong(this.getLrrCount());
                    jsonObject["sliCount"] = fm.liveswitch.JsonSerializer.serializeLong(this.getSliCount());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the codec stats.
            */
            MediaComponentStats.prototype.setCodec = function (value) {
                if (arguments.length == 1) {
                    this._codec = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the FIR count.
            */
            MediaComponentStats.prototype.setFirCount = function (value) {
                if (arguments.length == 1) {
                    this._firCount = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the LRR count.
            */
            MediaComponentStats.prototype.setLrrCount = function (value) {
                if (arguments.length == 1) {
                    this._lrrCount = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the NACK count.
            */
            MediaComponentStats.prototype.setNackCount = function (value) {
                if (arguments.length == 1) {
                    this._nackCount = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the PLI count.
            */
            MediaComponentStats.prototype.setPliCount = function (value) {
                if (arguments.length == 1) {
                    this._pliCount = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the repaired RTP stream identifier.
            */
            MediaComponentStats.prototype.setRepairedRtpStreamId = function (value) {
                if (arguments.length == 1) {
                    this._repairedRtpStreamId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the RTP stream identifier.
            */
            MediaComponentStats.prototype.setRtpStreamId = function (value) {
                if (arguments.length == 1) {
                    this._rtpStreamId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the SLI count.
            */
            MediaComponentStats.prototype.setSliCount = function (value) {
                if (arguments.length == 1) {
                    this._sliCount = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the synchronization source.
            */
            MediaComponentStats.prototype.setSynchronizationSource = function (value) {
                if (arguments.length == 1) {
                    this._synchronizationSource = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the track's stats.
            */
            MediaComponentStats.prototype.setTrack = function (value) {
                if (arguments.length == 1) {
                    this._track = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaComponentStats;
        }(fm.liveswitch.BaseStats));
        liveswitch.MediaComponentStats = MediaComponentStats;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="MediaComponentInfo.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media receiver information.
        */
        var MediaReceiverInfo = /** @class */ (function (_super) {
            __extends(MediaReceiverInfo, _super);
            function MediaReceiverInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else if (__arguments.length == 2) {
                    var stats = __arguments[0];
                    var lastStats = __arguments[1];
                    _this = _super.call(this, stats, lastStats) || this;
                    var sink = stats.getSink();
                    if ((!fm.liveswitch.Global.equals(sink, null))) {
                        _this.setSink(new fm.liveswitch.MediaSinkInfo(sink, ((fm.liveswitch.Global.equals(lastStats, null)) ? null : lastStats.getSink())));
                    }
                    _this.setReport(new fm.liveswitch.MediaReceiverReport(stats, lastStats));
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaReceiverInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaReceiverInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Deserializes an instance from JSON.
            @param mediaReceiverJson The serialized JSON.
            @return The deserialized instance.
            */
            MediaReceiverInfo.fromJson = function (mediaReceiverJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(mediaReceiverJson, function () {
                        return new fm.liveswitch.MediaReceiverInfo();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array from JSON.
            @param mediaReceiversJson The serialized JSON.
            @return The deserialized array.
            */
            MediaReceiverInfo.fromJsonArray = function (mediaReceiversJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(mediaReceiversJson, fm.liveswitch.MediaReceiverInfo.fromJson.bind(fm.liveswitch.MediaReceiverInfo));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param mediaReceiver The instance to serialize.
            @return The serialized JSON.
            */
            MediaReceiverInfo.toJson = function (mediaReceiver) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(mediaReceiver, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param mediaReceivers The array to serialize.
            @return The serialized JSON.
            */
            MediaReceiverInfo.toJsonArray = function (mediaReceivers) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(mediaReceivers, fm.liveswitch.MediaReceiverInfo.toJson.bind(fm.liveswitch.MediaReceiverInfo));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            MediaReceiverInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "sink"))) {
                            if ((fm.liveswitch.Global.equals(str, "report"))) {
                                this.setReport(fm.liveswitch.MediaReceiverReport.fromJson(valueJson));
                            }
                        }
                        else {
                            this.setSink(fm.liveswitch.MediaSinkInfo.fromJson(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets report.
            */
            MediaReceiverInfo.prototype.getReport = function () {
                if (arguments.length == 0) {
                    return this._report;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets sink.
            */
            MediaReceiverInfo.prototype.getSink = function () {
                if (arguments.length == 0) {
                    return this._sink;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            MediaReceiverInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getSink(), null))) {
                        jsonObject["sink"] = fm.liveswitch.MediaSinkInfo.toJson(this.getSink());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getReport(), null))) {
                        jsonObject["report"] = fm.liveswitch.MediaReceiverReport.toJson(this.getReport());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets report.
            */
            MediaReceiverInfo.prototype.setReport = function (value) {
                if (arguments.length == 1) {
                    this._report = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets sink.
            */
            MediaReceiverInfo.prototype.setSink = function (value) {
                if (arguments.length == 1) {
                    this._sink = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            MediaReceiverInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.MediaReceiverInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaReceiverInfo;
        }(fm.liveswitch.MediaComponentInfo));
        liveswitch.MediaReceiverInfo = MediaReceiverInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="MediaComponentStats.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media receiver stats.
        */
        var MediaReceiverStats = /** @class */ (function (_super) {
            __extends(MediaReceiverStats, _super);
            function MediaReceiverStats() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaReceiverStatsInit();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaReceiverStats.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaReceiverStats]' + ',' + _super.prototype.getTypeString.call(this);
            };
            MediaReceiverStats.prototype.fmliveswitchMediaReceiverStatsInit = function () {
                this._bytesReceived = 0;
                this._jitter = 0;
                this._packetsDiscarded = 0;
                this._packetsDuplicated = 0;
                this._packetsLost = 0;
                this._packetsReceived = 0;
                this._packetsRepaired = 0;
            };
            /**
            Derializes media receiver stats from JSON.
            @param mediaReceiverJson The media receiver's stats JSON.
            */
            MediaReceiverStats.fromJson = function (mediaReceiverJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(mediaReceiverJson, function () {
                        return new fm.liveswitch.MediaReceiverStats();
                    }, function (obj, key, valueJson) {
                        obj.deserializeProperties(key, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Derializes media receiver stats array from JSON.
            @param mediaReceiversJson The media receivers' stats JSON.
            */
            MediaReceiverStats.fromJsonArray = function (mediaReceiversJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(mediaReceiversJson, fm.liveswitch.MediaReceiverStats.fromJson.bind(fm.liveswitch.MediaReceiverStats));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes media receiver stats to JSON.
            @param mediaReceiver The media receiver's stats.
            */
            MediaReceiverStats.toJson = function (mediaReceiver) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(mediaReceiver, function (obj, jsonObject) {
                        obj.serializeProperties(jsonObject);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes media receiver stats array to JSON.
            @param mediaReceivers The media receivers' stats.
            */
            MediaReceiverStats.toJsonArray = function (mediaReceivers) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(mediaReceivers, fm.liveswitch.MediaReceiverStats.toJson.bind(fm.liveswitch.MediaReceiverStats));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            MediaReceiverStats.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var _var0 = key;
                    if (_var0 == "packetsReceived") {
                        do {
                            this.setPacketsReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "bytesReceived") {
                        do {
                            this.setBytesReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "packetsLost") {
                        do {
                            this.setPacketsLost(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "jitter") {
                        do {
                            this.setJitter(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "packetsDiscarded") {
                        do {
                            this.setPacketsDiscarded(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "packetsDuplicated") {
                        do {
                            this.setPacketsDuplicated(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "packetsRepaired") {
                        do {
                            this.setPacketsRepaired(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "sink") {
                        do {
                            this.setSink(fm.liveswitch.MediaSinkStats.fromJson(valueJson));
                            break;
                        } while (false);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes received.
            */
            MediaReceiverStats.prototype.getBytesReceived = function () {
                if (arguments.length == 0) {
                    return this._bytesReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the jitter in milliseconds.
            */
            MediaReceiverStats.prototype.getJitter = function () {
                if (arguments.length == 0) {
                    return this._jitter;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of packets discarded.
            */
            MediaReceiverStats.prototype.getPacketsDiscarded = function () {
                if (arguments.length == 0) {
                    return this._packetsDiscarded;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of packets duplicated.
            */
            MediaReceiverStats.prototype.getPacketsDuplicated = function () {
                if (arguments.length == 0) {
                    return this._packetsDuplicated;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of packets lost.
            */
            MediaReceiverStats.prototype.getPacketsLost = function () {
                if (arguments.length == 0) {
                    return this._packetsLost;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of packets received.
            */
            MediaReceiverStats.prototype.getPacketsReceived = function () {
                if (arguments.length == 0) {
                    return this._packetsReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of packets repaired.
            */
            MediaReceiverStats.prototype.getPacketsRepaired = function () {
                if (arguments.length == 0) {
                    return this._packetsRepaired;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the sink stats.
            */
            MediaReceiverStats.prototype.getSink = function () {
                if (arguments.length == 0) {
                    return this._sink;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Checks if a media receiver is equivalent to this one.
            @param instance The media receiver.
            */
            MediaReceiverStats.prototype.isEquivalent = function (instance) {
                if (arguments.length == 1) {
                    return ((((((fm.liveswitch.Global.equals(instance.getSynchronizationSource(), _super.prototype.getSynchronizationSource.call(this))) && ((fm.liveswitch.Global.equals(instance.getTrack(), _super.prototype.getTrack.call(this))) || ((!fm.liveswitch.Global.equals(_super.prototype.getTrack.call(this), null)) && _super.prototype.getTrack.call(this).isEquivalent(instance.getTrack())))) && (((fm.liveswitch.Global.equals(instance.getCodec(), _super.prototype.getCodec.call(this))) || ((!fm.liveswitch.Global.equals(_super.prototype.getCodec.call(this), null)) && _super.prototype.getCodec.call(this).isEquivalent(instance.getCodec()))) && ((fm.liveswitch.Global.equals(instance.getNackCount(), _super.prototype.getNackCount.call(this))) && (fm.liveswitch.Global.equals(instance.getPliCount(), _super.prototype.getPliCount.call(this)))))) && ((((fm.liveswitch.Global.equals(instance.getFirCount(), _super.prototype.getFirCount.call(this))) && (fm.liveswitch.Global.equals(instance.getLrrCount(), _super.prototype.getLrrCount.call(this)))) && ((fm.liveswitch.Global.equals(instance.getSliCount(), _super.prototype.getSliCount.call(this))) && (fm.liveswitch.Global.equals(instance.getPacketsReceived(), this.getPacketsReceived())))) && (((fm.liveswitch.Global.equals(instance.getBytesReceived(), this.getBytesReceived())) && (fm.liveswitch.Global.equals(instance.getPacketsLost(), this.getPacketsLost()))) && ((fm.liveswitch.Global.equals(instance.getJitter(), this.getJitter())) && (fm.liveswitch.Global.equals(instance.getPacketsDiscarded(), this.getPacketsDiscarded())))))) && ((fm.liveswitch.Global.equals(instance.getPacketsDuplicated(), this.getPacketsDuplicated())) && (fm.liveswitch.Global.equals(instance.getPacketsRepaired(), this.getPacketsRepaired())))) && ((fm.liveswitch.Global.equals(instance.getSink(), this.getSink())) || ((!fm.liveswitch.Global.equals(this.getSink(), null)) && this.getSink().isEquivalent(instance.getSink()))));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            MediaReceiverStats.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    jsonObject["packetsReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getPacketsReceived());
                    jsonObject["bytesReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getBytesReceived());
                    jsonObject["packetsLost"] = fm.liveswitch.JsonSerializer.serializeLong(this.getPacketsLost());
                    jsonObject["jitter"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getJitter());
                    jsonObject["packetsDiscarded"] = fm.liveswitch.JsonSerializer.serializeLong(this.getPacketsDiscarded());
                    jsonObject["packetsDuplicated"] = fm.liveswitch.JsonSerializer.serializeLong(this.getPacketsDuplicated());
                    jsonObject["packetsRepaired"] = fm.liveswitch.JsonSerializer.serializeLong(this.getPacketsRepaired());
                    if ((!fm.liveswitch.Global.equals(this.getSink(), null))) {
                        jsonObject["sink"] = fm.liveswitch.MediaSinkStats.toJson(this.getSink());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaReceiverStats.prototype.setBytesReceived = function (value) {
                if (arguments.length == 1) {
                    this._bytesReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaReceiverStats.prototype.setJitter = function (value) {
                if (arguments.length == 1) {
                    this._jitter = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaReceiverStats.prototype.setPacketsDiscarded = function (value) {
                if (arguments.length == 1) {
                    this._packetsDiscarded = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaReceiverStats.prototype.setPacketsDuplicated = function (value) {
                if (arguments.length == 1) {
                    this._packetsDuplicated = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaReceiverStats.prototype.setPacketsLost = function (value) {
                if (arguments.length == 1) {
                    this._packetsLost = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaReceiverStats.prototype.setPacketsReceived = function (value) {
                if (arguments.length == 1) {
                    this._packetsReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaReceiverStats.prototype.setPacketsRepaired = function (value) {
                if (arguments.length == 1) {
                    this._packetsRepaired = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaReceiverStats.prototype.setSink = function (value) {
                if (arguments.length == 1) {
                    this._sink = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this to JSON.
            */
            MediaReceiverStats.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.MediaReceiverStats.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaReceiverStats;
        }(fm.liveswitch.MediaComponentStats));
        liveswitch.MediaReceiverStats = MediaReceiverStats;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="MediaComponentInfo.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media sender information.
        */
        var MediaSenderInfo = /** @class */ (function (_super) {
            __extends(MediaSenderInfo, _super);
            function MediaSenderInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else if (__arguments.length == 2) {
                    var stats = __arguments[0];
                    var lastStats = __arguments[1];
                    _this = _super.call(this, stats, lastStats) || this;
                    var source = stats.getSource();
                    if ((!fm.liveswitch.Global.equals(source, null))) {
                        _this.setSource(new fm.liveswitch.MediaSourceInfo(source, ((fm.liveswitch.Global.equals(lastStats, null)) ? null : lastStats.getSource())));
                    }
                    _this.setReport(new fm.liveswitch.MediaSenderReport(stats, lastStats));
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaSenderInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaSenderInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Deserializes an instance from JSON.
            @param mediaSenderJson The serialized JSON.
            @return The deserialized instance.
            */
            MediaSenderInfo.fromJson = function (mediaSenderJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(mediaSenderJson, function () {
                        return new fm.liveswitch.MediaSenderInfo();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array from JSON.
            @param mediaSendersJson The serialized JSON.
            @return The deserialized array.
            */
            MediaSenderInfo.fromJsonArray = function (mediaSendersJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(mediaSendersJson, fm.liveswitch.MediaSenderInfo.fromJson.bind(fm.liveswitch.MediaSenderInfo));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param mediaSender The instance to serialize.
            @return The serialized JSON.
            */
            MediaSenderInfo.toJson = function (mediaSender) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(mediaSender, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param mediaSenders The array to serialize.
            @return The serialized JSON.
            */
            MediaSenderInfo.toJsonArray = function (mediaSenders) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(mediaSenders, fm.liveswitch.MediaSenderInfo.toJson.bind(fm.liveswitch.MediaSenderInfo));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            MediaSenderInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "source"))) {
                            if ((fm.liveswitch.Global.equals(str, "report"))) {
                                this.setReport(fm.liveswitch.MediaSenderReport.fromJson(valueJson));
                            }
                        }
                        else {
                            this.setSource(fm.liveswitch.MediaSourceInfo.fromJson(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets report.
            */
            MediaSenderInfo.prototype.getReport = function () {
                if (arguments.length == 0) {
                    return this._report;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets source.
            */
            MediaSenderInfo.prototype.getSource = function () {
                if (arguments.length == 0) {
                    return this._source;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            MediaSenderInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getSource(), null))) {
                        jsonObject["source"] = fm.liveswitch.MediaSourceInfo.toJson(this.getSource());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getReport(), null))) {
                        jsonObject["report"] = fm.liveswitch.MediaSenderReport.toJson(this.getReport());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets report.
            */
            MediaSenderInfo.prototype.setReport = function (value) {
                if (arguments.length == 1) {
                    this._report = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets source.
            */
            MediaSenderInfo.prototype.setSource = function (value) {
                if (arguments.length == 1) {
                    this._source = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            MediaSenderInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.MediaSenderInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaSenderInfo;
        }(fm.liveswitch.MediaComponentInfo));
        liveswitch.MediaSenderInfo = MediaSenderInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="MediaComponentStats.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media sender stats.
        */
        var MediaSenderStats = /** @class */ (function (_super) {
            __extends(MediaSenderStats, _super);
            function MediaSenderStats() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaSenderStatsInit();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaSenderStats.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaSenderStats]' + ',' + _super.prototype.getTypeString.call(this);
            };
            MediaSenderStats.prototype.fmliveswitchMediaSenderStatsInit = function () {
                this._bytesSent = 0;
                this._packetsSent = 0;
                this._roundTripTime = 0;
            };
            /**
            Derializes media sender stats from JSON.
            @param mediaSenderJson The media sender's stats JSON.
            */
            MediaSenderStats.fromJson = function (mediaSenderJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(mediaSenderJson, function () {
                        return new fm.liveswitch.MediaSenderStats();
                    }, function (obj, key, valueJson) {
                        obj.deserializeProperties(key, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Derializes a media sender stats array from JSON.
            @param mediaSendersJson The media senders' stats JSON.
            */
            MediaSenderStats.fromJsonArray = function (mediaSendersJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(mediaSendersJson, fm.liveswitch.MediaSenderStats.fromJson.bind(fm.liveswitch.MediaSenderStats));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes media sender stats to JSON.
            @param mediaSender The media sender's stats.
            */
            MediaSenderStats.toJson = function (mediaSender) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(mediaSender, function (obj, jsonObject) {
                        obj.serializeProperties(jsonObject);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a media sender stats array to JSON.
            @param mediaSenders The media senders' stats.
            */
            MediaSenderStats.toJsonArray = function (mediaSenders) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(mediaSenders, fm.liveswitch.MediaSenderStats.toJson.bind(fm.liveswitch.MediaSenderStats));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            MediaSenderStats.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "packetsSent"))) {
                            if ((fm.liveswitch.Global.equals(str, "bytesSent"))) {
                                this.setBytesSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "rtt"))) {
                                    this.setRoundTripTime(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "source"))) {
                                        this.setSource(fm.liveswitch.MediaSourceStats.fromJson(valueJson));
                                    }
                                }
                            }
                        }
                        else {
                            this.setPacketsSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes sent.
            */
            MediaSenderStats.prototype.getBytesSent = function () {
                if (arguments.length == 0) {
                    return this._bytesSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of packets sent.
            */
            MediaSenderStats.prototype.getPacketsSent = function () {
                if (arguments.length == 0) {
                    return this._packetsSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the round trip time in milliseconds.
            */
            MediaSenderStats.prototype.getRoundTripTime = function () {
                if (arguments.length == 0) {
                    return this._roundTripTime;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the source stats.
            */
            MediaSenderStats.prototype.getSource = function () {
                if (arguments.length == 0) {
                    return this._source;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Checks if a media sender is equivalent to this one.
            @param instance The media sender.
            */
            MediaSenderStats.prototype.isEquivalent = function (instance) {
                if (arguments.length == 1) {
                    return (((((fm.liveswitch.Global.equals(instance.getSynchronizationSource(), _super.prototype.getSynchronizationSource.call(this))) && ((fm.liveswitch.Global.equals(instance.getTrack(), _super.prototype.getTrack.call(this))) || ((!fm.liveswitch.Global.equals(_super.prototype.getTrack.call(this), null)) && _super.prototype.getTrack.call(this).isEquivalent(instance.getTrack())))) && (((fm.liveswitch.Global.equals(instance.getCodec(), _super.prototype.getCodec.call(this))) || ((!fm.liveswitch.Global.equals(_super.prototype.getCodec.call(this), null)) && _super.prototype.getCodec.call(this).isEquivalent(instance.getCodec()))) && ((fm.liveswitch.Global.equals(instance.getNackCount(), _super.prototype.getNackCount.call(this))) && (fm.liveswitch.Global.equals(instance.getPliCount(), _super.prototype.getPliCount.call(this)))))) && ((((fm.liveswitch.Global.equals(instance.getFirCount(), _super.prototype.getFirCount.call(this))) && (fm.liveswitch.Global.equals(instance.getLrrCount(), _super.prototype.getLrrCount.call(this)))) && ((fm.liveswitch.Global.equals(instance.getSliCount(), _super.prototype.getSliCount.call(this))) && (fm.liveswitch.Global.equals(instance.getPacketsSent(), this.getPacketsSent())))) && ((fm.liveswitch.Global.equals(instance.getBytesSent(), this.getBytesSent())) && (fm.liveswitch.Global.equals(instance.getRoundTripTime(), this.getRoundTripTime()))))) && ((fm.liveswitch.Global.equals(instance.getSource(), this.getSource())) || ((!fm.liveswitch.Global.equals(this.getSource(), null)) && this.getSource().isEquivalent(instance.getSource()))));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            MediaSenderStats.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    jsonObject["packetsSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getPacketsSent());
                    jsonObject["bytesSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getBytesSent());
                    jsonObject["rtt"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getRoundTripTime());
                    if ((!fm.liveswitch.Global.equals(this.getSource(), null))) {
                        jsonObject["source"] = fm.liveswitch.MediaSourceStats.toJson(this.getSource());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaSenderStats.prototype.setBytesSent = function (value) {
                if (arguments.length == 1) {
                    this._bytesSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaSenderStats.prototype.setPacketsSent = function (value) {
                if (arguments.length == 1) {
                    this._packetsSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaSenderStats.prototype.setRoundTripTime = function (value) {
                if (arguments.length == 1) {
                    this._roundTripTime = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaSenderStats.prototype.setSource = function (value) {
                if (arguments.length == 1) {
                    this._source = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this to JSON.
            */
            MediaSenderStats.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.MediaSenderStats.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaSenderStats;
        }(fm.liveswitch.MediaComponentStats));
        liveswitch.MediaSenderStats = MediaSenderStats;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media sink information.
        */
        var MediaSinkInfo = /** @class */ (function (_super) {
            __extends(MediaSinkInfo, _super);
            function MediaSinkInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else if (__arguments.length == 2) {
                    var stats = __arguments[0];
                    var lastStats = __arguments[1];
                    _this = _super.call(this) || this;
                    _super.prototype.setId.call(_this, stats.getId());
                    var flag = (fm.liveswitch.Global.equals(lastStats, null));
                    _this.setTag((flag ? stats.getTag() : fm.liveswitch.Info.processString(stats.getTag(), lastStats.getTag())));
                    _this.setLabel((flag ? stats.getLabel() : fm.liveswitch.Info.processString(stats.getLabel(), lastStats.getLabel())));
                    _this.setOutputId((flag ? stats.getOutputId() : fm.liveswitch.Info.processString(stats.getOutputId(), lastStats.getOutputId())));
                    _this.setOutputName((flag ? stats.getOutputName() : fm.liveswitch.Info.processString(stats.getOutputName(), lastStats.getOutputName())));
                    if (((!fm.liveswitch.Global.equals(stats.getInputFormat(), null)) && (flag || !stats.getInputFormat().isEquivalent(lastStats.getInputFormat())))) {
                        _this.setInputFormat(new fm.liveswitch.FormatInfo(stats.getInputFormat().getName(), stats.getInputFormat().getClockRate(), stats.getInputFormat().getChannelCount()));
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaSinkInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaSinkInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Deserializes an instance from JSON.
            @param mediaSinkInfoJson The serialized JSON.
            @return The deserialized instance.
            */
            MediaSinkInfo.fromJson = function (mediaSinkInfoJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(mediaSinkInfoJson, function () {
                        return new fm.liveswitch.MediaSinkInfo();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array from JSON.
            @param mediaSinkInfosJson The serialized JSON.
            @return The deserialized array.
            */
            MediaSinkInfo.fromJsonArray = function (mediaSinkInfosJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(mediaSinkInfosJson, fm.liveswitch.MediaSinkInfo.fromJson.bind(fm.liveswitch.MediaSinkInfo));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param mediaSinkInfo The instance to serialize.
            @return The serialized JSON.
            */
            MediaSinkInfo.toJson = function (mediaSinkInfo) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(mediaSinkInfo, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param mediaSinkInfos The array to serialize.
            @return The serialized JSON.
            */
            MediaSinkInfo.toJsonArray = function (mediaSinkInfos) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(mediaSinkInfos, fm.liveswitch.MediaSinkInfo.toJson.bind(fm.liveswitch.MediaSinkInfo));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            MediaSinkInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "tag"))) {
                            if ((fm.liveswitch.Global.equals(str, "label"))) {
                                this.setLabel(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "outputId"))) {
                                    this.setOutputId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "outputName"))) {
                                        this.setOutputName(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "inputFormat"))) {
                                            this.setInputFormat(fm.liveswitch.FormatInfo.fromJson(valueJson));
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            this.setTag(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media sink input format.
            */
            MediaSinkInfo.prototype.getInputFormat = function () {
                if (arguments.length == 0) {
                    return this._inputFormat;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media sink label.
            */
            MediaSinkInfo.prototype.getLabel = function () {
                if (arguments.length == 0) {
                    return this._label;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media sink output id.
            */
            MediaSinkInfo.prototype.getOutputId = function () {
                if (arguments.length == 0) {
                    return this._outputId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media sink output name.
            */
            MediaSinkInfo.prototype.getOutputName = function () {
                if (arguments.length == 0) {
                    return this._outputName;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media sink tag.
            */
            MediaSinkInfo.prototype.getTag = function () {
                if (arguments.length == 0) {
                    return this._tag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            MediaSinkInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if (!fm.liveswitch.StringExtensions.isNullOrEmpty(this.getTag())) {
                        jsonObject["tag"] = fm.liveswitch.JsonSerializer.serializeString(this.getTag());
                    }
                    if (!fm.liveswitch.StringExtensions.isNullOrEmpty(this.getLabel())) {
                        jsonObject["label"] = fm.liveswitch.JsonSerializer.serializeString(this.getLabel());
                    }
                    if (!fm.liveswitch.StringExtensions.isNullOrEmpty(this.getOutputId())) {
                        jsonObject["outputId"] = fm.liveswitch.JsonSerializer.serializeString(this.getOutputId());
                    }
                    if (!fm.liveswitch.StringExtensions.isNullOrEmpty(this.getOutputName())) {
                        jsonObject["outputName"] = fm.liveswitch.JsonSerializer.serializeString(this.getOutputName());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getInputFormat(), null))) {
                        jsonObject["inputFormat"] = fm.liveswitch.FormatInfo.toJson(this.getInputFormat());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media sink input format.
            */
            MediaSinkInfo.prototype.setInputFormat = function (value) {
                if (arguments.length == 1) {
                    this._inputFormat = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media sink label.
            */
            MediaSinkInfo.prototype.setLabel = function (value) {
                if (arguments.length == 1) {
                    this._label = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media sink output id.
            */
            MediaSinkInfo.prototype.setOutputId = function (value) {
                if (arguments.length == 1) {
                    this._outputId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media sink output name.
            */
            MediaSinkInfo.prototype.setOutputName = function (value) {
                if (arguments.length == 1) {
                    this._outputName = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media sink tag.
            */
            MediaSinkInfo.prototype.setTag = function (value) {
                if (arguments.length == 1) {
                    this._tag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            MediaSinkInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.MediaSinkInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaSinkInfo;
        }(fm.liveswitch.Info));
        liveswitch.MediaSinkInfo = MediaSinkInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="BaseStats.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media sink stats.
        */
        var MediaSinkStats = /** @class */ (function (_super) {
            __extends(MediaSinkStats, _super);
            function MediaSinkStats() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaSinkStatsInit();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaSinkStats.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaSinkStats]' + ',' + _super.prototype.getTypeString.call(this);
            };
            MediaSinkStats.prototype.fmliveswitchMediaSinkStatsInit = function () {
                this._muted = false;
            };
            /**
            Deserializes an instance from JSON.
            @param instanceJson The serialized JSON.
            @return The deserialized instance.
            */
            MediaSinkStats.fromJson = function (instanceJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(instanceJson, function () {
                        return new fm.liveswitch.MediaSinkStats();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array from JSON.
            @param arrayJson The serialized JSON.
            @return The deserialized array.
            */
            MediaSinkStats.fromJsonArray = function (arrayJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(arrayJson, fm.liveswitch.MediaSinkStats.fromJson.bind(fm.liveswitch.MediaSinkStats));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param instance The instance to serialize.
            @return Serialized JSON.
            */
            MediaSinkStats.toJson = function (instance) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(instance, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param array The array to serialize.
            @return The serialized JSON.
            */
            MediaSinkStats.toJsonArray = function (array) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(array, fm.liveswitch.MediaSinkStats.toJson.bind(fm.liveswitch.MediaSinkStats));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            MediaSinkStats.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "tag"))) {
                            if ((fm.liveswitch.Global.equals(str, "label"))) {
                                this.setLabel(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "muted"))) {
                                    this.setMuted(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "outputId"))) {
                                        this.setOutputId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "outputName"))) {
                                            this.setOutputName(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                        }
                                        else {
                                            if ((fm.liveswitch.Global.equals(str, "inputFormat"))) {
                                                this.setInputFormat(fm.liveswitch.FormatInfo.fromJson(valueJson));
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            this.setTag(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the input format.
            */
            MediaSinkStats.prototype.getInputFormat = function () {
                if (arguments.length == 0) {
                    return this._inputFormat;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the label.
            */
            MediaSinkStats.prototype.getLabel = function () {
                if (arguments.length == 0) {
                    return this._label;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the muted flag.
            */
            MediaSinkStats.prototype.getMuted = function () {
                if (arguments.length == 0) {
                    return this._muted;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the output identifier.
            */
            MediaSinkStats.prototype.getOutputId = function () {
                if (arguments.length == 0) {
                    return this._outputId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the output name.
            */
            MediaSinkStats.prototype.getOutputName = function () {
                if (arguments.length == 0) {
                    return this._outputName;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the tag.
            */
            MediaSinkStats.prototype.getTag = function () {
                if (arguments.length == 0) {
                    return this._tag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Checks if a source is equivalent to this one.
            @param instance The source.
            */
            MediaSinkStats.prototype.isEquivalent = function (instance) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(instance, null))) {
                        return false;
                    }
                    if (((fm.liveswitch.Global.equals(instance.getInputFormat(), null)) && (!fm.liveswitch.Global.equals(this.getInputFormat(), null)))) {
                        return false;
                    }
                    return (((((fm.liveswitch.Global.equals(instance.getTag(), this.getTag())) && (fm.liveswitch.Global.equals(instance.getLabel(), this.getLabel()))) && ((fm.liveswitch.Global.equals(instance.getMuted(), this.getMuted())) && (fm.liveswitch.Global.equals(instance.getOutputId(), this.getOutputId())))) && (fm.liveswitch.Global.equals(instance.getOutputName(), this.getOutputName()))) && instance.getInputFormat().isEquivalent(this.getInputFormat()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            MediaSinkStats.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getTag(), null))) {
                        jsonObject["tag"] = fm.liveswitch.JsonSerializer.serializeString(this.getTag());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getLabel(), null))) {
                        jsonObject["label"] = fm.liveswitch.JsonSerializer.serializeString(this.getLabel());
                    }
                    jsonObject["muted"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getMuted());
                    if ((!fm.liveswitch.Global.equals(this.getOutputId(), null))) {
                        jsonObject["outputId"] = fm.liveswitch.JsonSerializer.serializeString(this.getOutputId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getOutputName(), null))) {
                        jsonObject["outputName"] = fm.liveswitch.JsonSerializer.serializeString(this.getOutputName());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getInputFormat(), null))) {
                        jsonObject["inputFormat"] = fm.liveswitch.FormatInfo.toJson(this.getInputFormat());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the input format.
            */
            MediaSinkStats.prototype.setInputFormat = function (value) {
                if (arguments.length == 1) {
                    this._inputFormat = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the label.
            */
            MediaSinkStats.prototype.setLabel = function (value) {
                if (arguments.length == 1) {
                    this._label = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the muted flag.
            */
            MediaSinkStats.prototype.setMuted = function (value) {
                if (arguments.length == 1) {
                    this._muted = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the output identifier.
            */
            MediaSinkStats.prototype.setOutputId = function (value) {
                if (arguments.length == 1) {
                    this._outputId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the output name.
            */
            MediaSinkStats.prototype.setOutputName = function (value) {
                if (arguments.length == 1) {
                    this._outputName = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the tag.
            */
            MediaSinkStats.prototype.setTag = function (value) {
                if (arguments.length == 1) {
                    this._tag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            MediaSinkStats.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.MediaSinkStats.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaSinkStats;
        }(fm.liveswitch.BaseStats));
        liveswitch.MediaSinkStats = MediaSinkStats;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="BaseStats.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media source stats.
        */
        var MediaSourceStats = /** @class */ (function (_super) {
            __extends(MediaSourceStats, _super);
            function MediaSourceStats() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaSourceStatsInit();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaSourceStats.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaSourceStats]' + ',' + _super.prototype.getTypeString.call(this);
            };
            MediaSourceStats.prototype.fmliveswitchMediaSourceStatsInit = function () {
                this._muted = false;
            };
            /**
            Deserializes an instance from JSON.
            @param instanceJson The serialized Json.
            @return The deserialized VideoSourceInfo.
            */
            MediaSourceStats.fromJson = function (instanceJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(instanceJson, function () {
                        return new fm.liveswitch.MediaSourceStats();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param instance The instance to serialize.
            @return Serialized Json.
            */
            MediaSourceStats.toJson = function (instance) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(instance, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            MediaSourceStats.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "tag"))) {
                            if ((fm.liveswitch.Global.equals(str, "label"))) {
                                this.setLabel(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "muted"))) {
                                    this.setMuted(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "inputId"))) {
                                        this.setInputId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "inputName"))) {
                                            this.setInputName(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                        }
                                        else {
                                            if ((fm.liveswitch.Global.equals(str, "outputFormat"))) {
                                                this.setOutputFormat(fm.liveswitch.FormatInfo.fromJson(valueJson));
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            this.setTag(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the input identifier.
            */
            MediaSourceStats.prototype.getInputId = function () {
                if (arguments.length == 0) {
                    return this._inputId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the input name.
            */
            MediaSourceStats.prototype.getInputName = function () {
                if (arguments.length == 0) {
                    return this._inputName;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the label.
            */
            MediaSourceStats.prototype.getLabel = function () {
                if (arguments.length == 0) {
                    return this._label;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the muted flag.
            */
            MediaSourceStats.prototype.getMuted = function () {
                if (arguments.length == 0) {
                    return this._muted;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the output format.
            */
            MediaSourceStats.prototype.getOutputFormat = function () {
                if (arguments.length == 0) {
                    return this._outputFormat;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the tag.
            */
            MediaSourceStats.prototype.getTag = function () {
                if (arguments.length == 0) {
                    return this._tag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Checks if a source is equivalent to this one.
            @param instance The source.
            */
            MediaSourceStats.prototype.isEquivalent = function (instance) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(instance, null))) {
                        return false;
                    }
                    if (((fm.liveswitch.Global.equals(instance.getOutputFormat(), null)) && (!fm.liveswitch.Global.equals(this.getOutputFormat(), null)))) {
                        return false;
                    }
                    return (((((fm.liveswitch.Global.equals(instance.getTag(), this.getTag())) && (fm.liveswitch.Global.equals(instance.getLabel(), this.getLabel()))) && ((fm.liveswitch.Global.equals(instance.getMuted(), this.getMuted())) && (fm.liveswitch.Global.equals(instance.getInputId(), this.getInputId())))) && (fm.liveswitch.Global.equals(instance.getInputName(), this.getInputName()))) && instance.getOutputFormat().isEquivalent(this.getOutputFormat()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            MediaSourceStats.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getTag(), null))) {
                        jsonObject["tag"] = fm.liveswitch.JsonSerializer.serializeString(this.getTag());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getLabel(), null))) {
                        jsonObject["label"] = fm.liveswitch.JsonSerializer.serializeString(this.getLabel());
                    }
                    jsonObject["muted"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getMuted());
                    if ((!fm.liveswitch.Global.equals(this.getInputId(), null))) {
                        jsonObject["inputId"] = fm.liveswitch.JsonSerializer.serializeString(this.getInputId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getInputName(), null))) {
                        jsonObject["inputName"] = fm.liveswitch.JsonSerializer.serializeString(this.getInputName());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getOutputFormat(), null))) {
                        jsonObject["outputFormat"] = fm.liveswitch.FormatInfo.toJson(this.getOutputFormat());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the input identifier.
            */
            MediaSourceStats.prototype.setInputId = function (value) {
                if (arguments.length == 1) {
                    this._inputId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the input name.
            */
            MediaSourceStats.prototype.setInputName = function (value) {
                if (arguments.length == 1) {
                    this._inputName = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the label.
            */
            MediaSourceStats.prototype.setLabel = function (value) {
                if (arguments.length == 1) {
                    this._label = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the muted flag.
            */
            MediaSourceStats.prototype.setMuted = function (value) {
                if (arguments.length == 1) {
                    this._muted = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the output format.
            */
            MediaSourceStats.prototype.setOutputFormat = function (value) {
                if (arguments.length == 1) {
                    this._outputFormat = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the tag.
            */
            MediaSourceStats.prototype.setTag = function (value) {
                if (arguments.length == 1) {
                    this._tag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            MediaSourceStats.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.MediaSourceStats.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaSourceStats;
        }(fm.liveswitch.BaseStats));
        liveswitch.MediaSourceStats = MediaSourceStats;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="BaseStats.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media stats.
        */
        var MediaStats = /** @class */ (function (_super) {
            __extends(MediaStats, _super);
            function MediaStats() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaStats.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaStats]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Derializes media stats from JSON.
            @param mediaJson The media's stats JSON.
            */
            MediaStats.fromJson = function (mediaJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(mediaJson, function () {
                        return new fm.liveswitch.MediaStats();
                    }, function (obj, key, valueJson) {
                        obj.deserializeProperties(key, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes media stats to JSON.
            @param media The media's stats.
            */
            MediaStats.toJson = function (media) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(media, function (obj, jsonObject) {
                        obj.serializeProperties(jsonObject);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            MediaStats.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if (((!fm.liveswitch.Global.equals(str, null)) && (fm.liveswitch.Global.equals(str, "tracks")))) {
                        this.setTracks(fm.liveswitch.MediaTrackStats.fromJsonArray(valueJson));
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            MediaStats.prototype.getTrack = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Utility.firstOrDefault(this.getTracks());
                }
                else if (arguments.length == 1) {
                    var trackId = arguments[0];
                    for (var _i = 0, _a = this.getTracks(); _i < _a.length; _i++) {
                        var stats = _a[_i];
                        if ((fm.liveswitch.Global.equals(stats.getId(), trackId))) {
                            return stats;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the tracks' stats.
            */
            MediaStats.prototype.getTracks = function () {
                if (arguments.length == 0) {
                    return this._tracks;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            MediaStats.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getTracks(), null))) {
                        jsonObject["tracks"] = fm.liveswitch.MediaTrackStats.toJsonArray(this.getTracks());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaStats.prototype.setTracks = function (value) {
                if (arguments.length == 1) {
                    this._tracks = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this to JSON.
            */
            MediaStats.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.MediaStats.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaStats;
        }(fm.liveswitch.BaseStats));
        liveswitch.MediaStats = MediaStats;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Encoding information.
        */
        var EncodingInfo = /** @class */ (function (_super) {
            __extends(EncodingInfo, _super);
            function EncodingInfo() {
                var _this = this;
                fm.liveswitch.EncodingInfo.fmliveswitchEncodingInfoInitialize();
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchEncodingInfoInit();
                    _this.__synchronizationSource = -1;
                    _this.__bitrate = -1;
                    _this.__frameRate = -1;
                    _this.__scale = -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            EncodingInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.EncodingInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            EncodingInfo.prototype.fmliveswitchEncodingInfoInit = function () {
                this.__bitrate = 0;
                this.__frameRate = 0;
                this.__scale = 0;
                this.__synchronizationSource = 0;
                this._deactivated = false;
            };
            /** @hidden */
            EncodingInfo.findEncoding = function (encodings, synchronizationSource, rtpStreamId) {
                fm.liveswitch.EncodingInfo.fmliveswitchEncodingInfoInitialize();
                if (arguments.length == 3) {
                    if ((synchronizationSource >= 0)) {
                        for (var _i = 0, encodings_1 = encodings; _i < encodings_1.length; _i++) {
                            var info = encodings_1[_i];
                            if ((fm.liveswitch.Global.equals(info.getSynchronizationSource(), synchronizationSource))) {
                                return info;
                            }
                        }
                    }
                    if ((!fm.liveswitch.Global.equals(rtpStreamId, null))) {
                        for (var _a = 0, encodings_2 = encodings; _a < encodings_2.length; _a++) {
                            var info = encodings_2[_a];
                            if ((fm.liveswitch.Global.equals(info.getRtpStreamId(), rtpStreamId))) {
                                return info;
                            }
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an instance from JSON.
            @param encodingInfoJson The serialized JSON.
            @return The deserialized instance.
            */
            EncodingInfo.fromJson = function (encodingInfoJson) {
                fm.liveswitch.EncodingInfo.fmliveswitchEncodingInfoInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(encodingInfoJson, function () {
                        return new fm.liveswitch.EncodingInfo();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array from JSON.
            @param encodingInfosJson The serialized JSON.
            @return The deserialized array.
            */
            EncodingInfo.fromJsonArray = function (encodingInfosJson) {
                fm.liveswitch.EncodingInfo.fmliveswitchEncodingInfoInitialize();
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(encodingInfosJson, fm.liveswitch.EncodingInfo.fromJson.bind(fm.liveswitch.EncodingInfo));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts an SDP RID attribute into an instance.
            @param ridAttribute The SDP RID attribute.
            */
            EncodingInfo.fromSdpRidAttribute = function (ridAttribute) {
                fm.liveswitch.EncodingInfo.fmliveswitchEncodingInfoInitialize();
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(ridAttribute, null))) {
                        return null;
                    }
                    if ((fm.liveswitch.Global.equals(ridAttribute.getId(), null))) {
                        throw new fm.liveswitch.Exception("RTP stream ID cannot be null.");
                    }
                    var info2 = new fm.liveswitch.EncodingInfo();
                    info2.setRtpStreamId(ridAttribute.getId());
                    var info = info2;
                    info.setSdpRidRestrictions(ridAttribute.getRestrictions());
                    return info;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            EncodingInfo.isEquivalent = function () {
                fm.liveswitch.EncodingInfo.fmliveswitchEncodingInfoInitialize();
                if (arguments.length == 2) {
                    var encoding1 = arguments[0];
                    var encoding2 = arguments[1];
                    return fm.liveswitch.EncodingInfo.isEquivalent(encoding1, encoding2, false);
                }
                else if (arguments.length == 3) {
                    var encoding1 = arguments[0];
                    var encoding2 = arguments[1];
                    var restrictionsOnly = arguments[2];
                    if ((fm.liveswitch.Global.equals(encoding1, encoding2))) {
                        return true;
                    }
                    if (((fm.liveswitch.Global.equals(encoding1, null)) || (fm.liveswitch.Global.equals(encoding2, null)))) {
                        return false;
                    }
                    return fm.liveswitch.EncodingInfo.isEquivalentNoCheck(encoding1, encoding2, restrictionsOnly);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.isEquivalentNoCheck = function (encoding1, encoding2, restrictionsOnly) {
                fm.liveswitch.EncodingInfo.fmliveswitchEncodingInfoInitialize();
                if (arguments.length == 3) {
                    return (((((restrictionsOnly || (fm.liveswitch.Global.equals(encoding1.getRtpStreamId(), encoding2.getRtpStreamId()))) && (restrictionsOnly || (fm.liveswitch.Global.equals(encoding1.getSynchronizationSource(), encoding2.getSynchronizationSource())))) && ((restrictionsOnly || (fm.liveswitch.Global.equals(encoding1.getDeactivated(), encoding2.getDeactivated()))) && ((fm.liveswitch.Global.equals(encoding1.getBitrate(), encoding2.getBitrate())) && (fm.liveswitch.Global.equals(encoding1.getFrameRate(), encoding2.getFrameRate()))))) && fm.liveswitch.Size.isEquivalent(encoding1.getSize(), encoding2.getSize())) && (fm.liveswitch.Global.equals(encoding1.getScale(), encoding2.getScale())));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Returns a new encoding with each value being the maximum of two input encodings.
            @param encoding1 The first encoding.
            @param encoding2 The second encoding.
            @return A new encoding.
            */
            EncodingInfo.max = function (encoding1, encoding2) {
                fm.liveswitch.EncodingInfo.fmliveswitchEncodingInfoInitialize();
                if (arguments.length == 2) {
                    var info2 = new fm.liveswitch.EncodingInfo();
                    info2.setBitrate(fm.liveswitch.EncodingInfo.maxInteger(encoding1.getBitrate(), encoding2.getBitrate()));
                    info2.setFrameRate(fm.liveswitch.EncodingInfo.maxDouble(encoding1.getFrameRate(), encoding2.getFrameRate()));
                    var info = info2;
                    var scaledSize = encoding1.getScaledSize();
                    var size2 = encoding2.getScaledSize();
                    if ((fm.liveswitch.Global.equals(fm.liveswitch.EncodingInfo.maxSize(scaledSize, size2), scaledSize))) {
                        info.setSize(encoding1.getSize());
                        info.setScale(encoding1.getScale());
                        return info;
                    }
                    info.setSize(encoding2.getSize());
                    info.setScale(encoding2.getScale());
                    return info;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.maxDouble = function (value1, value2) {
                fm.liveswitch.EncodingInfo.fmliveswitchEncodingInfoInitialize();
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(value1, -1))) {
                        return value2;
                    }
                    if ((fm.liveswitch.Global.equals(value2, -1))) {
                        return value1;
                    }
                    return fm.liveswitch.MathAssistant.max(value1, value2);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.maxInteger = function (value1, value2) {
                fm.liveswitch.EncodingInfo.fmliveswitchEncodingInfoInitialize();
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(value1, -1))) {
                        return value2;
                    }
                    if ((fm.liveswitch.Global.equals(value2, -1))) {
                        return value1;
                    }
                    return fm.liveswitch.MathAssistant.max(value1, value2);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.maxSize = function (value1, value2) {
                fm.liveswitch.EncodingInfo.fmliveswitchEncodingInfoInitialize();
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(value1, null))) {
                        return value2;
                    }
                    if (((!fm.liveswitch.Global.equals(value2, null)) && ((value2.getWidth() * value2.getHeight()) > (value1.getWidth() * value1.getHeight())))) {
                        return value2;
                    }
                    return value1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.merge = function (encodings) {
                fm.liveswitch.EncodingInfo.fmliveswitchEncodingInfoInitialize();
                if (arguments.length == 1) {
                    var list = new Array();
                    for (var _i = 0, encodings_3 = encodings; _i < encodings_3.length; _i++) {
                        var info = encodings_3[_i];
                        var info2 = fm.liveswitch.EncodingInfo.findEncoding(list, info.getSynchronizationSource(), info.getRtpStreamId());
                        if ((fm.liveswitch.Global.equals(info2, null))) {
                            var info3 = new fm.liveswitch.EncodingInfo();
                            info3.setSynchronizationSource(info.getSynchronizationSource());
                            info3.setRtpStreamId(info.getRtpStreamId());
                            info3.setDeactivated(info.getDeactivated());
                            fm.liveswitch.ArrayExtensions.add(list, info3.extend(info));
                        }
                        else {
                            info2.extend(info);
                        }
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Returns a new encoding with each value being the minimum of two input encodings.
            @param encoding1 The first encoding.
            @param encoding2 The second encoding.
            @return A new encoding.
            */
            EncodingInfo.min = function (encoding1, encoding2) {
                fm.liveswitch.EncodingInfo.fmliveswitchEncodingInfoInitialize();
                if (arguments.length == 2) {
                    var info2 = new fm.liveswitch.EncodingInfo();
                    info2.setBitrate(fm.liveswitch.EncodingInfo.minInteger(encoding1.getBitrate(), encoding2.getBitrate()));
                    info2.setFrameRate(fm.liveswitch.EncodingInfo.minDouble(encoding1.getFrameRate(), encoding2.getFrameRate()));
                    var info = info2;
                    var scaledSize = encoding1.getScaledSize();
                    var size2 = encoding2.getScaledSize();
                    if ((fm.liveswitch.Global.equals(fm.liveswitch.EncodingInfo.minSize(scaledSize, size2), scaledSize))) {
                        info.setSize(encoding1.getSize());
                        info.setScale(encoding1.getScale());
                        return info;
                    }
                    info.setSize(encoding2.getSize());
                    info.setScale(encoding2.getScale());
                    return info;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.minDouble = function (value1, value2) {
                fm.liveswitch.EncodingInfo.fmliveswitchEncodingInfoInitialize();
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(value1, -1))) {
                        return value2;
                    }
                    if ((fm.liveswitch.Global.equals(value2, -1))) {
                        return value1;
                    }
                    return fm.liveswitch.MathAssistant.min(value1, value2);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.minInteger = function (value1, value2) {
                fm.liveswitch.EncodingInfo.fmliveswitchEncodingInfoInitialize();
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(value1, -1))) {
                        return value2;
                    }
                    if ((fm.liveswitch.Global.equals(value2, -1))) {
                        return value1;
                    }
                    return fm.liveswitch.MathAssistant.min(value1, value2);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.minSize = function (value1, value2) {
                fm.liveswitch.EncodingInfo.fmliveswitchEncodingInfoInitialize();
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(value1, null))) {
                        return value2;
                    }
                    if (((!fm.liveswitch.Global.equals(value2, null)) && ((value2.getWidth() * value2.getHeight()) < (value1.getWidth() * value1.getHeight())))) {
                        return value2;
                    }
                    return value1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param encodingInfo The instance to serialize.
            @return The serialized JSON.
            */
            EncodingInfo.toJson = function (encodingInfo) {
                fm.liveswitch.EncodingInfo.fmliveswitchEncodingInfoInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(encodingInfo, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param encodingInfos The array to serialize.
            @return The serialized JSON.
            */
            EncodingInfo.toJsonArray = function (encodingInfos) {
                fm.liveswitch.EncodingInfo.fmliveswitchEncodingInfoInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(encodingInfos, fm.liveswitch.EncodingInfo.toJson.bind(fm.liveswitch.EncodingInfo));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            EncodingInfo.toSdpRidAttribute = function () {
                fm.liveswitch.EncodingInfo.fmliveswitchEncodingInfoInitialize();
                if (arguments.length == 2) {
                    var encoding = arguments[0];
                    var direction = arguments[1];
                    return fm.liveswitch.EncodingInfo.toSdpRidAttribute(encoding, direction, true);
                }
                else if (arguments.length == 3) {
                    var encoding = arguments[0];
                    var direction = arguments[1];
                    var includeRestrictions = arguments[2];
                    if ((fm.liveswitch.Global.equals(encoding, null))) {
                        return null;
                    }
                    if ((fm.liveswitch.Global.equals(encoding.getRtpStreamId(), null))) {
                        throw new fm.liveswitch.Exception("RTP stream ID cannot be null.");
                    }
                    return new fm.liveswitch.sdp.rtp.RidAttribute(encoding.getRtpStreamId(), direction, (includeRestrictions ? encoding.getSdpRidRestrictions() : null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            EncodingInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var _var0 = key;
                    if (_var0 == "rtpStreamId") {
                        do {
                            this.setRtpStreamId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "synchronizationSource") {
                        do {
                            this.setSynchronizationSource(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "deactivated") {
                        do {
                            this.setDeactivated(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "bitrate") {
                        do {
                            this.setBitrate(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "frameRate") {
                        do {
                            this.setFrameRate(fm.liveswitch.JsonSerializer.deserializeDouble(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "size") {
                        do {
                            this.setSize(fm.liveswitch.Size.fromJson(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "scale") {
                        do {
                            this.setScale(fm.liveswitch.JsonSerializer.deserializeDouble(valueJson));
                            break;
                        } while (false);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.prototype.extend = function (encoding) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(this.getDeactivated(), encoding.getDeactivated()))) {
                        this.setDeactivated(false);
                    }
                    if (((fm.liveswitch.Global.equals(this.getBitrate(), -1)) || (encoding.getBitrate() > this.getBitrate()))) {
                        this.setBitrate(encoding.getBitrate());
                    }
                    if (((fm.liveswitch.Global.equals(this.getFrameRate(), -1)) || (encoding.getFrameRate() > this.getFrameRate()))) {
                        this.setFrameRate(encoding.getFrameRate());
                    }
                    if ((((fm.liveswitch.Global.equals(this.getWidth(), -1)) && (fm.liveswitch.Global.equals(this.getHeight(), -1))) || ((encoding.getWidth() > this.getWidth()) && (encoding.getHeight() > this.getHeight())))) {
                        this.setSize(encoding.getSize());
                    }
                    if (((fm.liveswitch.Global.equals(this.getScale(), -1)) || (encoding.getScale() > this.getScale()))) {
                        this.setScale(encoding.getScale());
                    }
                    return this;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the bitrate, in kbps.
            */
            EncodingInfo.prototype.getBitrate = function () {
                if (arguments.length == 0) {
                    return this.__bitrate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether this encoding is deactivated.
            */
            EncodingInfo.prototype.getDeactivated = function () {
                if (arguments.length == 0) {
                    return this._deactivated;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the frame-rate, in fps.
            */
            EncodingInfo.prototype.getFrameRate = function () {
                if (arguments.length == 0) {
                    return this.__frameRate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the height.
            */
            EncodingInfo.prototype.getHeight = function () {
                if (arguments.length == 0) {
                    var size = this.getSize();
                    if ((fm.liveswitch.Global.equals(size, null))) {
                        return -1;
                    }
                    return size.getHeight();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether this encoding is empty.
            */
            EncodingInfo.prototype.getIsEmpty = function () {
                if (arguments.length == 0) {
                    return (((((fm.liveswitch.Global.equals(this.getRtpStreamId(), null)) && (fm.liveswitch.Global.equals(this.getSynchronizationSource(), -1))) && (!this.getDeactivated() && (fm.liveswitch.Global.equals(this.getBitrate(), -1)))) && ((fm.liveswitch.Global.equals(this.getFrameRate(), -1)) && (fm.liveswitch.Global.equals(this.getSize(), null)))) && (fm.liveswitch.Global.equals(this.getScale(), -1)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.prototype.getRidRestrictionValue = function (ridRestrictions, ridRestrictionKey) {
                if (arguments.length == 2) {
                    for (var _i = 0, ridRestrictions_1 = ridRestrictions; _i < ridRestrictions_1.length; _i++) {
                        var restriction = ridRestrictions_1[_i];
                        if ((fm.liveswitch.Global.equals(restriction.getKey(), ridRestrictionKey))) {
                            return restriction.getValue();
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the RTP stream identifier.
            */
            EncodingInfo.prototype.getRtpStreamId = function () {
                if (arguments.length == 0) {
                    return this._rtpStreamId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the target scale.
            */
            EncodingInfo.prototype.getScale = function () {
                if (arguments.length == 0) {
                    return this.__scale;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the scaled height.
            */
            EncodingInfo.prototype.getScaledHeight = function () {
                if (arguments.length == 0) {
                    var scaledSize = this.getScaledSize();
                    if ((fm.liveswitch.Global.equals(scaledSize, null))) {
                        return -1;
                    }
                    return scaledSize.getHeight();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the scaled size.
            */
            EncodingInfo.prototype.getScaledSize = function () {
                if (arguments.length == 0) {
                    var size = this.getSize();
                    if ((fm.liveswitch.Global.equals(size, null))) {
                        return null;
                    }
                    var scale = this.getScale();
                    if ((scale > 0)) {
                        return new fm.liveswitch.Size((size.getWidth() * scale), (size.getHeight() * scale));
                    }
                    return size;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the scaled width.
            */
            EncodingInfo.prototype.getScaledWidth = function () {
                if (arguments.length == 0) {
                    var scaledSize = this.getScaledSize();
                    if ((fm.liveswitch.Global.equals(scaledSize, null))) {
                        return -1;
                    }
                    return scaledSize.getWidth();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.prototype.getSdpRidRestrictions = function () {
                if (arguments.length == 0) {
                    var list = new Array();
                    var bitrate = this.getBitrate();
                    if ((bitrate > 0)) {
                        var num6 = (bitrate * 1000);
                        fm.liveswitch.ArrayExtensions.add(list, new fm.liveswitch.sdp.rtp.RidRestriction(fm.liveswitch.sdp.rtp.RidRestriction.getMaxBitrateKey(), fm.liveswitch.NumberExtensions.toString(num6)));
                    }
                    var frameRate = this.getFrameRate();
                    if ((frameRate > 0)) {
                        fm.liveswitch.ArrayExtensions.add(list, new fm.liveswitch.sdp.rtp.RidRestriction(fm.liveswitch.sdp.rtp.RidRestriction.getMaxFramesPerSecondKey(), fm.liveswitch.NumberExtensions.toString(frameRate)));
                    }
                    var scale = this.getScale();
                    var width = this.getWidth();
                    if ((width > 0)) {
                        if ((scale > 0)) {
                            width = fm.liveswitch.MathAssistant.round((width * scale));
                        }
                        fm.liveswitch.ArrayExtensions.add(list, new fm.liveswitch.sdp.rtp.RidRestriction(fm.liveswitch.sdp.rtp.RidRestriction.getMaxWidthKey(), fm.liveswitch.NumberExtensions.toString(width)));
                    }
                    var height = this.getHeight();
                    if ((height > 0)) {
                        if ((scale > 0)) {
                            height = fm.liveswitch.MathAssistant.round((height * scale));
                        }
                        fm.liveswitch.ArrayExtensions.add(list, new fm.liveswitch.sdp.rtp.RidRestriction(fm.liveswitch.sdp.rtp.RidRestriction.getMaxHeightKey(), fm.liveswitch.NumberExtensions.toString(height)));
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.prototype.getSdpSimulcastStream = function () {
                if (arguments.length == 0) {
                    if ((fm.liveswitch.Global.equals(this.getSdpSimulcastStreamId(), null))) {
                        return null;
                    }
                    return new fm.liveswitch.sdp.rtp.SimulcastStream(this.getSdpSimulcastStreamId());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.prototype.getSdpSimulcastStreamId = function () {
                if (arguments.length == 0) {
                    var rtpStreamId = this.getRtpStreamId();
                    if ((fm.liveswitch.Global.equals(rtpStreamId, null))) {
                        return null;
                    }
                    return new fm.liveswitch.sdp.rtp.SimulcastStreamId(rtpStreamId, this.getDeactivated());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.prototype.getSdpSsrcRestrictionAttributes = function () {
                if (arguments.length == 0) {
                    var list = new Array();
                    for (var _i = 0, _a = this.getSdpRidRestrictions(); _i < _a.length; _i++) {
                        var restriction = _a[_i];
                        fm.liveswitch.ArrayExtensions.add(list, new fm.liveswitch.sdp.rtp.SsrcAttribute(this.getSynchronizationSource(), restriction.getKey(), restriction.getValue()));
                    }
                    if (this.getDeactivated()) {
                        fm.liveswitch.ArrayExtensions.add(list, new fm.liveswitch.sdp.rtp.SsrcAttribute(this.getSynchronizationSource(), fm.liveswitch.EncodingInfo.fm_liveswitch_EncodingInfo___pausedKey, "1"));
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the size.
            */
            EncodingInfo.prototype.getSize = function () {
                if (arguments.length == 0) {
                    return this._size;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.prototype.getSsrcRestrictionAttributeValue = function (ssrcRestrictionAttributes, ridRestrictionKey) {
                if (arguments.length == 2) {
                    for (var _i = 0, ssrcRestrictionAttributes_1 = ssrcRestrictionAttributes; _i < ssrcRestrictionAttributes_1.length; _i++) {
                        var attribute = ssrcRestrictionAttributes_1[_i];
                        if (((fm.liveswitch.Global.equals(attribute.getSynchronizationSource(), this.getSynchronizationSource())) && (fm.liveswitch.Global.equals(attribute.getName(), ridRestrictionKey)))) {
                            return attribute.getValue();
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the synchronization source.
            */
            EncodingInfo.prototype.getSynchronizationSource = function () {
                if (arguments.length == 0) {
                    return this.__synchronizationSource;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the width.
            */
            EncodingInfo.prototype.getWidth = function () {
                if (arguments.length == 0) {
                    var size = this.getSize();
                    if ((fm.liveswitch.Global.equals(size, null))) {
                        return -1;
                    }
                    return size.getWidth();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            EncodingInfo.prototype.isEquivalent = function () {
                if (arguments.length == 1) {
                    var encoding = arguments[0];
                    return this.isEquivalent(encoding, false);
                }
                else if (arguments.length == 2) {
                    var encoding = arguments[0];
                    var restrictionsOnly = arguments[1];
                    return fm.liveswitch.EncodingInfo.isEquivalent(this, encoding, restrictionsOnly);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.prototype.parseBitrate = function (ridRestrictionMaxBitrateValue) {
                if (arguments.length == 1) {
                    var intResult = 0;
                    var _var0 = new fm.liveswitch.Holder(intResult);
                    var _var1 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(ridRestrictionMaxBitrateValue, _var0);
                    intResult = _var0.getValue();
                    if (!((!fm.liveswitch.Global.equals(ridRestrictionMaxBitrateValue, null)) && _var1)) {
                        return -1;
                    }
                    return fm.liveswitch.MathAssistant.max(0, fm.liveswitch.MathAssistant.floor(intResult / 1000));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.prototype.parseDeactivated = function (ridRestrictionPausedValue) {
                if (arguments.length == 1) {
                    var intResult = 0;
                    var _var0 = new fm.liveswitch.Holder(intResult);
                    var _var1 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(ridRestrictionPausedValue, _var0);
                    intResult = _var0.getValue();
                    if (!((!fm.liveswitch.Global.equals(ridRestrictionPausedValue, null)) && _var1)) {
                        return false;
                    }
                    return (fm.liveswitch.Global.equals(intResult, 1));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.prototype.parseFrameRate = function (ridRestrictionMaxFramesPerSecondValue) {
                if (arguments.length == 1) {
                    var doubleResult = 0;
                    var _var0 = new fm.liveswitch.Holder(doubleResult);
                    var _var1 = fm.liveswitch.ParseAssistant.tryParseDoubleValue(ridRestrictionMaxFramesPerSecondValue, _var0);
                    doubleResult = _var0.getValue();
                    if (!((!fm.liveswitch.Global.equals(ridRestrictionMaxFramesPerSecondValue, null)) && _var1)) {
                        return -1;
                    }
                    return fm.liveswitch.MathAssistant.max(0, doubleResult);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.prototype.parseSize = function (ridRestrictionMaxWidthValue, ridRestrictionMaxHeightValue) {
                if (arguments.length == 2) {
                    var intResult = 0;
                    var num2 = 0;
                    var _var0 = new fm.liveswitch.Holder(intResult);
                    var _var1 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(ridRestrictionMaxWidthValue, _var0);
                    intResult = _var0.getValue();
                    var _var2 = new fm.liveswitch.Holder(num2);
                    var _var3 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(ridRestrictionMaxHeightValue, _var2);
                    num2 = _var2.getValue();
                    if (!((((!fm.liveswitch.Global.equals(ridRestrictionMaxWidthValue, null)) && (!fm.liveswitch.Global.equals(ridRestrictionMaxHeightValue, null))) && _var1) && _var3)) {
                        return null;
                    }
                    return new fm.liveswitch.Size(fm.liveswitch.MathAssistant.max(0, intResult), fm.liveswitch.MathAssistant.max(0, num2));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            EncodingInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getRtpStreamId(), null))) {
                        jsonObject["rtpStreamId"] = fm.liveswitch.JsonSerializer.serializeString(this.getRtpStreamId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getSynchronizationSource(), -1))) {
                        jsonObject["synchronizationSource"] = fm.liveswitch.JsonSerializer.serializeLong(this.getSynchronizationSource());
                    }
                    if (this.getDeactivated()) {
                        jsonObject["deactivated"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getDeactivated());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getBitrate(), -1))) {
                        jsonObject["bitrate"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getBitrate());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getFrameRate(), -1))) {
                        jsonObject["frameRate"] = fm.liveswitch.JsonSerializer.serializeDouble(this.getFrameRate());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getSize(), null))) {
                        jsonObject["size"] = fm.liveswitch.Size.toJson(this.getSize());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getScale(), -1))) {
                        jsonObject["scale"] = fm.liveswitch.JsonSerializer.serializeDouble(this.getScale());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the bitrate, in kbps.
            */
            EncodingInfo.prototype.setBitrate = function (value) {
                if (arguments.length == 1) {
                    this.__bitrate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether this encoding is deactivated.
            */
            EncodingInfo.prototype.setDeactivated = function (value) {
                if (arguments.length == 1) {
                    this._deactivated = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the frame-rate, in fps.
            */
            EncodingInfo.prototype.setFrameRate = function (value) {
                if (arguments.length == 1) {
                    this.__frameRate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the RTP stream identifier.
            */
            EncodingInfo.prototype.setRtpStreamId = function (value) {
                if (arguments.length == 1) {
                    this._rtpStreamId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the target scale.
            */
            EncodingInfo.prototype.setScale = function (value) {
                if (arguments.length == 1) {
                    this.__scale = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.prototype.setSdpRidRestrictions = function (value) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(value, null))) {
                        this.setBitrate(this.parseBitrate(this.getRidRestrictionValue(value, fm.liveswitch.sdp.rtp.RidRestriction.getMaxBitrateKey())));
                        this.setFrameRate(this.parseFrameRate(this.getRidRestrictionValue(value, fm.liveswitch.sdp.rtp.RidRestriction.getMaxFramesPerSecondKey())));
                        this.setSize(this.parseSize(this.getRidRestrictionValue(value, fm.liveswitch.sdp.rtp.RidRestriction.getMaxWidthKey()), this.getRidRestrictionValue(value, fm.liveswitch.sdp.rtp.RidRestriction.getMaxHeightKey())));
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.prototype.setSdpSimulcastStreamId = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(value, null))) {
                        this.setRtpStreamId(null);
                        this.setDeactivated(false);
                    }
                    else {
                        this.setRtpStreamId(value.getId());
                        this.setDeactivated(value.getPaused());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.prototype.setSdpSsrcRestrictionAttributes = function (value) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(value, null))) {
                        this.setDeactivated(this.parseDeactivated(this.getSsrcRestrictionAttributeValue(value, fm.liveswitch.EncodingInfo.fm_liveswitch_EncodingInfo___pausedKey)));
                        this.setBitrate(this.parseBitrate(this.getSsrcRestrictionAttributeValue(value, fm.liveswitch.sdp.rtp.RidRestriction.getMaxBitrateKey())));
                        this.setFrameRate(this.parseFrameRate(this.getSsrcRestrictionAttributeValue(value, fm.liveswitch.sdp.rtp.RidRestriction.getMaxFramesPerSecondKey())));
                        this.setSize(this.parseSize(this.getSsrcRestrictionAttributeValue(value, fm.liveswitch.sdp.rtp.RidRestriction.getMaxWidthKey()), this.getSsrcRestrictionAttributeValue(value, fm.liveswitch.sdp.rtp.RidRestriction.getMaxHeightKey())));
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the size.
            */
            EncodingInfo.prototype.setSize = function (value) {
                if (arguments.length == 1) {
                    this._size = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the synchronization source.
            */
            EncodingInfo.prototype.setSynchronizationSource = function (value) {
                if (arguments.length == 1) {
                    this.__synchronizationSource = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            EncodingInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.EncodingInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            EncodingInfo.prototype.toSdpRidAttribute = function () {
                if (arguments.length == 1) {
                    var direction = arguments[0];
                    return this.toSdpRidAttribute(direction, true);
                }
                else if (arguments.length == 2) {
                    var direction = arguments[0];
                    var includeRestrictions = arguments[1];
                    return fm.liveswitch.EncodingInfo.toSdpRidAttribute(this, direction, includeRestrictions);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Returns a string that represents this instance.
            @return
                        A string that represents this instance.
                
            */
            EncodingInfo.prototype.toString = function () {
                if (arguments.length == 0) {
                    var flag = false;
                    var list = new Array();
                    var rtpStreamId = this.getRtpStreamId();
                    if ((!fm.liveswitch.Global.equals(rtpStreamId, null))) {
                        fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.format("RTP Stream ID: {0}", rtpStreamId));
                    }
                    var synchronizationSource = this.getSynchronizationSource();
                    if ((!fm.liveswitch.Global.equals(synchronizationSource, -1))) {
                        fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.format("Synchronization Source: {0}", fm.liveswitch.NumberExtensions.toString(synchronizationSource)));
                    }
                    var deactivated = this.getDeactivated();
                    if (deactivated) {
                        fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.format("Deactivated: {0}", fm.liveswitch.BooleanExtensions.toString(deactivated)));
                    }
                    var bitrate = this.getBitrate();
                    if ((!fm.liveswitch.Global.equals(bitrate, -1))) {
                        flag = true;
                        fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.format("Bitrate: {0}", fm.liveswitch.NumberExtensions.toString(bitrate)));
                    }
                    var frameRate = this.getFrameRate();
                    if ((!fm.liveswitch.Global.equals(frameRate, -1))) {
                        flag = true;
                        fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.format("Frame Rate: {0}", fm.liveswitch.NumberExtensions.toString(frameRate)));
                    }
                    var size = this.getSize();
                    if ((!fm.liveswitch.Global.equals(size, null))) {
                        fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.format("Size: {0}", size.toString()));
                    }
                    var scale = this.getScale();
                    if ((!fm.liveswitch.Global.equals(scale, -1))) {
                        flag = true;
                        fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.format("Scale: {0}", fm.liveswitch.NumberExtensions.toString(scale)));
                        if ((!fm.liveswitch.Global.equals(scale, 1))) {
                            var scaledSize = this.getScaledSize();
                            if ((!fm.liveswitch.Global.equals(scaledSize, null))) {
                                fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.format("Scaled Size: {0}", scaledSize.toString()));
                            }
                        }
                    }
                    var str2 = fm.liveswitch.StringExtensions.join(", ", fm.liveswitch.ArrayExtensions.toArray(list));
                    if (!flag) {
                        str2 = fm.liveswitch.StringExtensions.trim(fm.liveswitch.StringExtensions.format("{0} [Unrestricted]", str2));
                    }
                    return str2;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            EncodingInfo.fmliveswitchEncodingInfoInitialize = function () {
                if (!fm.liveswitch.EncodingInfo.__fmliveswitchEncodingInfoInitialized && !fm.liveswitch.EncodingInfo.__fmliveswitchEncodingInfoInitializing) {
                    fm.liveswitch.EncodingInfo.__fmliveswitchEncodingInfoInitializing = true;
                    fm.liveswitch.EncodingInfo.fm_liveswitch_EncodingInfo___pausedKey = "paused";
                    fm.liveswitch.EncodingInfo.__fmliveswitchEncodingInfoInitialized = true;
                    fm.liveswitch.EncodingInfo.__fmliveswitchEncodingInfoInitializing = false;
                }
            };
            /** @hidden */
            EncodingInfo.__fmliveswitchEncodingInfoInitialized = false;
            /** @hidden */
            EncodingInfo.__fmliveswitchEncodingInfoInitializing = false;
            return EncodingInfo;
        }(fm.liveswitch.Info));
        liveswitch.EncodingInfo = EncodingInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="StreamInfo.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media stream information.
        */
        var MediaStreamInfo = /** @class */ (function (_super) {
            __extends(MediaStreamInfo, _super);
            function MediaStreamInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaStreamInfoInit();
                    _this.__localBandwidth = -1;
                    _this.__remoteBandwidth = -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaStreamInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaStreamInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            MediaStreamInfo.prototype.fmliveswitchMediaStreamInfoInit = function () {
                this.__localBandwidth = 0;
                this.__remoteBandwidth = 0;
                this._maxFrameHeight = 0;
                this._maxFrameWidth = 0;
                this._receiveDisabled = false;
                this._sendDisabled = false;
                this._sendMuted = false;
            };
            /**
            Deserializes an instance from JSON.
            @param mediaStreamInfoJson The serialized JSON.
            @return The deserialized instance.
            */
            MediaStreamInfo.fromJson = function (mediaStreamInfoJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(mediaStreamInfoJson, function () {
                        return new fm.liveswitch.MediaStreamInfo();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array from JSON.
            @param mediaStreamInfosJson The serialized JSON.
            @return The deserialized array.
            */
            MediaStreamInfo.fromJsonArray = function (mediaStreamInfosJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(mediaStreamInfosJson, fm.liveswitch.MediaStreamInfo.fromJson.bind(fm.liveswitch.MediaStreamInfo));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param mediaStreamInfo The instance to serialize.
            @return The serialized JSON.
            */
            MediaStreamInfo.toJson = function (mediaStreamInfo) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(mediaStreamInfo, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param mediaStreamInfos The array to serialize.
            @return The serialized JSON.
            */
            MediaStreamInfo.toJsonArray = function (mediaStreamInfos) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(mediaStreamInfos, fm.liveswitch.MediaStreamInfo.toJson.bind(fm.liveswitch.MediaStreamInfo));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            MediaStreamInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var _var0 = key;
                    if (_var0 == "sendMuted") {
                        do {
                            this.setSendMuted(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "sendDisabled") {
                        do {
                            this.setSendDisabled(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "receiveDisabled") {
                        do {
                            this.setReceiveDisabled(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "sendFormats") {
                        do {
                            this.setSendFormats(fm.liveswitch.FormatInfo.fromJsonArray(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "receiveFormats") {
                        do {
                            this.setReceiveFormats(fm.liveswitch.FormatInfo.fromJsonArray(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "sendEncodings") {
                        do {
                            this.setSendEncodings(fm.liveswitch.EncodingInfo.fromJsonArray(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "receiveEncodings") {
                        do {
                            this.setReceiveEncodings(fm.liveswitch.EncodingInfo.fromJsonArray(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "localBandwidth") {
                        do {
                            this.setLocalBandwidth(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "remoteBandwidth") {
                        do {
                            this.setRemoteBandwidth(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "maxFrameWidth") {
                        do {
                            this.setMaxFrameWidth(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "maxFrameHeight") {
                        do {
                            this.setMaxFrameHeight(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "senders") {
                        do {
                            this.setSenders(fm.liveswitch.MediaSenderInfo.fromJsonArray(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "receivers") {
                        do {
                            this.setReceivers(fm.liveswitch.MediaReceiverInfo.fromJsonArray(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "controlTransportId") {
                        do {
                            this.setControlTransportId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaStreamInfo.prototype.findMatchingReceiver = function (receivers, idValue) {
                if (arguments.length == 2) {
                    if ((!fm.liveswitch.Global.equals(receivers, null))) {
                        for (var _i = 0, receivers_1 = receivers; _i < receivers_1.length; _i++) {
                            var stats = receivers_1[_i];
                            if ((fm.liveswitch.Global.equals(stats.getId(), idValue))) {
                                return stats;
                            }
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaStreamInfo.prototype.findMatchingSender = function (senders, idValue) {
                if (arguments.length == 2) {
                    if ((!fm.liveswitch.Global.equals(senders, null))) {
                        for (var _i = 0, senders_3 = senders; _i < senders_3.length; _i++) {
                            var stats = senders_3[_i];
                            if ((fm.liveswitch.Global.equals(stats.getId(), idValue))) {
                                return stats;
                            }
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the control transport id. This will be `null` if BUNDLE is active.
            */
            MediaStreamInfo.prototype.getControlTransportId = function () {
                if (arguments.length == 0) {
                    return this._controlTransportId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media stream direction.
            */
            MediaStreamInfo.prototype.getDirection = function () {
                if (arguments.length == 0) {
                    var directionString = "inactive";
                    return fm.liveswitch.StreamDirectionHelper.setReceiveDisabled(fm.liveswitch.StreamDirectionHelper.setSendDisabled(directionString, this.getSendDisabled()), this.getReceiveDisabled());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media stream's local bandwidth.
            */
            MediaStreamInfo.prototype.getLocalBandwidth = function () {
                if (arguments.length == 0) {
                    return this.__localBandwidth;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media stream's maximum frame height.
            */
            MediaStreamInfo.prototype.getMaxFrameHeight = function () {
                if (arguments.length == 0) {
                    return this._maxFrameHeight;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media stream's maximum frame width.
            */
            MediaStreamInfo.prototype.getMaxFrameWidth = function () {
                if (arguments.length == 0) {
                    return this._maxFrameWidth;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the media stream has the receive direction disabled.
            */
            MediaStreamInfo.prototype.getReceiveDisabled = function () {
                if (arguments.length == 0) {
                    return this._receiveDisabled;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media stream receive encodings.
            */
            MediaStreamInfo.prototype.getReceiveEncodings = function () {
                if (arguments.length == 0) {
                    return this._receiveEncodings;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media stream receive formats.
            */
            MediaStreamInfo.prototype.getReceiveFormats = function () {
                if (arguments.length == 0) {
                    return this._receiveFormats;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the first media stream receiver information.
            */
            MediaStreamInfo.prototype.getReceiver = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Utility.firstOrDefault(this.getReceivers());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media stream receivers information.
            */
            MediaStreamInfo.prototype.getReceivers = function () {
                if (arguments.length == 0) {
                    return this._receivers;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media stream's remote bandwidth.
            */
            MediaStreamInfo.prototype.getRemoteBandwidth = function () {
                if (arguments.length == 0) {
                    return this.__remoteBandwidth;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the media stream has the send direction disabled.
            */
            MediaStreamInfo.prototype.getSendDisabled = function () {
                if (arguments.length == 0) {
                    return this._sendDisabled;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media stream send encodings.
            */
            MediaStreamInfo.prototype.getSendEncodings = function () {
                if (arguments.length == 0) {
                    return this._sendEncodings;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the first media stream sender information.
            */
            MediaStreamInfo.prototype.getSender = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Utility.firstOrDefault(this.getSenders());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media stream senders information.
            */
            MediaStreamInfo.prototype.getSenders = function () {
                if (arguments.length == 0) {
                    return this._senders;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media stream send formats.
            */
            MediaStreamInfo.prototype.getSendFormats = function () {
                if (arguments.length == 0) {
                    return this._sendFormats;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the media stream has muted sending.
            */
            MediaStreamInfo.prototype.getSendMuted = function () {
                if (arguments.length == 0) {
                    return this._sendMuted;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaStreamInfo.prototype.populateInfos = function (stats, lastStats) {
                if (arguments.length == 2) {
                    var num = void 0;
                    var flag = (fm.liveswitch.Global.equals(lastStats, null));
                    var transport = stats.getTransport();
                    if ((!fm.liveswitch.Global.equals(transport, null))) {
                        _super.prototype.setTransportId.call(this, transport.getId());
                        var rtcpTransport = transport.getRtcpTransport();
                        if (((!fm.liveswitch.Global.equals(rtcpTransport, null)) && (!fm.liveswitch.Global.equals(rtcpTransport, transport)))) {
                            this.setControlTransportId(rtcpTransport.getId());
                        }
                        else {
                            this.setControlTransportId(_super.prototype.getTransportId.call(this));
                        }
                    }
                    var statsArray = (flag ? stats.getSenders() : fm.liveswitch.Info.processArray(stats.getSenders(), lastStats.getSenders()));
                    if ((!fm.liveswitch.Global.equals(statsArray, null))) {
                        this.setSenders(new Array(statsArray.length));
                        for (num = 0; (num < statsArray.length); num++) {
                            var stats4 = stats.getSenders()[num];
                            var stats5 = (flag ? null : this.findMatchingSender(lastStats.getSenders(), stats4.getId()));
                            this.getSenders()[num] = new fm.liveswitch.MediaSenderInfo(stats4, stats5);
                        }
                    }
                    var statsArray2 = (flag ? stats.getReceivers() : fm.liveswitch.Info.processArray(stats.getReceivers(), lastStats.getReceivers()));
                    if ((!fm.liveswitch.Global.equals(statsArray2, null))) {
                        this.setReceivers(new Array(statsArray2.length));
                        for (num = 0; (num < statsArray2.length); num++) {
                            var stats6 = stats.getReceivers()[num];
                            var stats7 = (flag ? null : this.findMatchingReceiver(lastStats.getReceivers(), stats6.getId()));
                            this.getReceivers()[num] = new fm.liveswitch.MediaReceiverInfo(stats6, stats7);
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            MediaStreamInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if (this.getSendMuted()) {
                        jsonObject["sendMuted"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getSendMuted());
                    }
                    if (this.getSendDisabled()) {
                        jsonObject["sendDisabled"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getSendDisabled());
                    }
                    if (this.getReceiveDisabled()) {
                        jsonObject["receiveDisabled"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getReceiveDisabled());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getSendFormats(), null))) {
                        jsonObject["sendFormats"] = fm.liveswitch.FormatInfo.toJsonArray(this.getSendFormats());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getReceiveFormats(), null))) {
                        jsonObject["receiveFormats"] = fm.liveswitch.FormatInfo.toJsonArray(this.getReceiveFormats());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getSendEncodings(), null))) {
                        jsonObject["sendEncodings"] = fm.liveswitch.EncodingInfo.toJsonArray(this.getSendEncodings());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getReceiveEncodings(), null))) {
                        jsonObject["receiveEncodings"] = fm.liveswitch.EncodingInfo.toJsonArray(this.getReceiveEncodings());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getLocalBandwidth(), -1))) {
                        jsonObject["localBandwidth"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getLocalBandwidth());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRemoteBandwidth(), -1))) {
                        jsonObject["remoteBandwidth"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getRemoteBandwidth());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getMaxFrameWidth(), 0))) {
                        jsonObject["maxFrameWidth"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getMaxFrameWidth());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getMaxFrameHeight(), 0))) {
                        jsonObject["maxFrameHeight"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getMaxFrameHeight());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getSenders(), null))) {
                        jsonObject["senders"] = fm.liveswitch.MediaSenderInfo.toJsonArray(this.getSenders());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getReceivers(), null))) {
                        jsonObject["receivers"] = fm.liveswitch.MediaReceiverInfo.toJsonArray(this.getReceivers());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getControlTransportId(), null))) {
                        jsonObject["controlTransportId"] = fm.liveswitch.JsonSerializer.serializeString(this.getControlTransportId());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the control transport id. This will be `null` if BUNDLE is active.
            */
            MediaStreamInfo.prototype.setControlTransportId = function (value) {
                if (arguments.length == 1) {
                    this._controlTransportId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media stream direction.
            */
            MediaStreamInfo.prototype.setDirection = function (value) {
                if (arguments.length == 1) {
                    this.setSendDisabled(fm.liveswitch.StreamDirectionHelper.isSendDisabled(value));
                    this.setReceiveDisabled(fm.liveswitch.StreamDirectionHelper.isReceiveDisabled(value));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media stream's local bandwidth.
            */
            MediaStreamInfo.prototype.setLocalBandwidth = function (value) {
                if (arguments.length == 1) {
                    this.__localBandwidth = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media stream's maximum frame height.
            */
            MediaStreamInfo.prototype.setMaxFrameHeight = function (value) {
                if (arguments.length == 1) {
                    this._maxFrameHeight = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media stream's maximum frame width.
            */
            MediaStreamInfo.prototype.setMaxFrameWidth = function (value) {
                if (arguments.length == 1) {
                    this._maxFrameWidth = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the media stream has the receive direction disabled.
            */
            MediaStreamInfo.prototype.setReceiveDisabled = function (value) {
                if (arguments.length == 1) {
                    this._receiveDisabled = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media stream receive encodings.
            */
            MediaStreamInfo.prototype.setReceiveEncodings = function (value) {
                if (arguments.length == 1) {
                    this._receiveEncodings = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media stream receive formats.
            */
            MediaStreamInfo.prototype.setReceiveFormats = function (value) {
                if (arguments.length == 1) {
                    this._receiveFormats = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media stream receivers information.
            */
            MediaStreamInfo.prototype.setReceivers = function (value) {
                if (arguments.length == 1) {
                    this._receivers = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media stream's remote bandwidth.
            */
            MediaStreamInfo.prototype.setRemoteBandwidth = function (value) {
                if (arguments.length == 1) {
                    this.__remoteBandwidth = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the media stream has the send direction disabled.
            */
            MediaStreamInfo.prototype.setSendDisabled = function (value) {
                if (arguments.length == 1) {
                    this._sendDisabled = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media stream send encodings.
            */
            MediaStreamInfo.prototype.setSendEncodings = function (value) {
                if (arguments.length == 1) {
                    this._sendEncodings = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media stream senders information.
            */
            MediaStreamInfo.prototype.setSenders = function (value) {
                if (arguments.length == 1) {
                    this._senders = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media stream send formats.
            */
            MediaStreamInfo.prototype.setSendFormats = function (value) {
                if (arguments.length == 1) {
                    this._sendFormats = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the media stream has muted sending.
            */
            MediaStreamInfo.prototype.setSendMuted = function (value) {
                if (arguments.length == 1) {
                    this._sendMuted = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            MediaStreamInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.MediaStreamInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaStreamInfo;
        }(fm.liveswitch.StreamInfo));
        liveswitch.MediaStreamInfo = MediaStreamInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="StreamStats.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media stream stats.
        */
        var MediaStreamStats = /** @class */ (function (_super) {
            __extends(MediaStreamStats, _super);
            function MediaStreamStats() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaStreamStatsInit();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaStreamStats.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaStreamStats]' + ',' + _super.prototype.getTypeString.call(this);
            };
            MediaStreamStats.prototype.fmliveswitchMediaStreamStatsInit = function () {
                this._maxReceiveBitrate = 0;
                this._maxSendBitrate = 0;
            };
            /**
            Derializes media stream stats from JSON.
            @param mediaStreamJson The media stream's stats JSON.
            */
            MediaStreamStats.fromJson = function (mediaStreamJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(mediaStreamJson, function () {
                        return new fm.liveswitch.MediaStreamStats();
                    }, function (obj, key, valueJson) {
                        obj.deserializeProperties(key, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Derializes an array of media stream stats from JSON.
            @param mediaStreamsJson The media streams' stats JSON.
            */
            MediaStreamStats.fromJsonArray = function (mediaStreamsJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(mediaStreamsJson, fm.liveswitch.MediaStreamStats.fromJson.bind(fm.liveswitch.MediaStreamStats));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes media stream stats to JSON.
            @param mediaStream The media stream's stats.
            */
            MediaStreamStats.toJson = function (mediaStream) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(mediaStream, function (obj, jsonObject) {
                        obj.serializeProperties(jsonObject);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array of media stream stats to JSON.
            @param mediaStreams The media streams' stats.
            */
            MediaStreamStats.toJsonArray = function (mediaStreams) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(mediaStreams, fm.liveswitch.MediaStreamStats.toJson.bind(fm.liveswitch.MediaStreamStats));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            MediaStreamStats.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "direction"))) {
                            if ((fm.liveswitch.Global.equals(str, "maxSendBitrate"))) {
                                this.setMaxSendBitrate(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "maxReceiveBitrate"))) {
                                    this.setMaxReceiveBitrate(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "senders"))) {
                                        this.setSenders(fm.liveswitch.MediaSenderStats.fromJsonArray(valueJson));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "receivers"))) {
                                            this.setReceivers(fm.liveswitch.MediaReceiverStats.fromJsonArray(valueJson));
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            this.setDirection(fm.liveswitch.StreamDirectionHelper.directionFromString(fm.liveswitch.JsonSerializer.deserializeString(valueJson)));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the direction.
            */
            MediaStreamStats.prototype.getDirection = function () {
                if (arguments.length == 0) {
                    return this._direction;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the max receive bitrate.
            */
            MediaStreamStats.prototype.getMaxReceiveBitrate = function () {
                if (arguments.length == 0) {
                    return this._maxReceiveBitrate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the max send bitrate.
            */
            MediaStreamStats.prototype.getMaxSendBitrate = function () {
                if (arguments.length == 0) {
                    return this._maxSendBitrate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the first receiver's stats.
            */
            MediaStreamStats.prototype.getReceiver = function () {
                if (arguments.length == 0) {
                    var receivers = this.getReceivers();
                    if (((fm.liveswitch.Global.equals(receivers, null)) || (fm.liveswitch.Global.equals(receivers.length, 0)))) {
                        return null;
                    }
                    return receivers[0];
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the receivers' stats.
            */
            MediaStreamStats.prototype.getReceivers = function () {
                if (arguments.length == 0) {
                    return this._receivers;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the first sender's stats.
            */
            MediaStreamStats.prototype.getSender = function () {
                if (arguments.length == 0) {
                    var senders = this.getSenders();
                    if (((fm.liveswitch.Global.equals(senders, null)) || (fm.liveswitch.Global.equals(senders.length, 0)))) {
                        return null;
                    }
                    return senders[0];
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the senders' stats.
            */
            MediaStreamStats.prototype.getSenders = function () {
                if (arguments.length == 0) {
                    return this._senders;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            MediaStreamStats.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    jsonObject["direction"] = fm.liveswitch.JsonSerializer.serializeString(fm.liveswitch.StreamDirectionHelper.directionToString(this.getDirection()));
                    jsonObject["maxSendBitrate"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getMaxSendBitrate());
                    jsonObject["maxReceiveBitrate"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getMaxReceiveBitrate());
                    if ((!fm.liveswitch.Global.equals(this.getSenders(), null))) {
                        jsonObject["senders"] = fm.liveswitch.MediaSenderStats.toJsonArray(this.getSenders());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getReceivers(), null))) {
                        jsonObject["receivers"] = fm.liveswitch.MediaReceiverStats.toJsonArray(this.getReceivers());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaStreamStats.prototype.setDirection = function (value) {
                if (arguments.length == 1) {
                    this._direction = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaStreamStats.prototype.setMaxReceiveBitrate = function (value) {
                if (arguments.length == 1) {
                    this._maxReceiveBitrate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaStreamStats.prototype.setMaxSendBitrate = function (value) {
                if (arguments.length == 1) {
                    this._maxSendBitrate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaStreamStats.prototype.setReceivers = function (value) {
                if (arguments.length == 1) {
                    this._receivers = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaStreamStats.prototype.setSenders = function (value) {
                if (arguments.length == 1) {
                    this._senders = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this to JSON.
            */
            MediaStreamStats.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.MediaStreamStats.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaStreamStats;
        }(fm.liveswitch.StreamStats));
        liveswitch.MediaStreamStats = MediaStreamStats;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media track information
        */
        var MediaTrackInfo = /** @class */ (function (_super) {
            __extends(MediaTrackInfo, _super);
            function MediaTrackInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaTrackInfoInit();
                }
                else if (__arguments.length == 2) {
                    var stats = __arguments[0];
                    var lastStats = __arguments[1];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaTrackInfoInit();
                    _super.prototype.setId.call(_this, stats.getId());
                    _this.setDetached(((fm.liveswitch.Global.equals(lastStats, null)) ? stats.getDetached() : fm.liveswitch.Info.processBoolean(stats.getDetached(), lastStats.getDetached())));
                    _this.setMuted(((fm.liveswitch.Global.equals(lastStats, null)) ? stats.getMuted() : fm.liveswitch.Info.processBoolean(stats.getMuted(), lastStats.getMuted())));
                    _this.setStopped(((fm.liveswitch.Global.equals(lastStats, null)) ? stats.getStopped() : fm.liveswitch.Info.processBoolean(stats.getStopped(), lastStats.getStopped())));
                    _this.setReport(new fm.liveswitch.MediaTrackReport(stats, lastStats));
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaTrackInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaTrackInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            MediaTrackInfo.prototype.fmliveswitchMediaTrackInfoInit = function () {
                this._detached = false;
                this._muted = false;
                this._stopped = false;
            };
            /**
            Deserializes an instance from JSON.
            @param mediaTrackInfoJson The serialized JSON.
            @return The deserialized instance.
            */
            MediaTrackInfo.fromJson = function (mediaTrackInfoJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(mediaTrackInfoJson, function () {
                        return new fm.liveswitch.MediaTrackInfo();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array from JSON.
            @param mediaTrackInfosJson The serialized JSON.
            @return The deserialized array.
            */
            MediaTrackInfo.fromJsonArray = function (mediaTrackInfosJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(mediaTrackInfosJson, fm.liveswitch.MediaTrackInfo.fromJson.bind(fm.liveswitch.MediaTrackInfo));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param mediaTrackInfo The instance to serialize.
            @return The serialized JSON.
            */
            MediaTrackInfo.toJson = function (mediaTrackInfo) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(mediaTrackInfo, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param mediaTrackInfos The array to serialize.
            @return The serialized JSON.
            */
            MediaTrackInfo.toJsonArray = function (mediaTrackInfos) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(mediaTrackInfos, fm.liveswitch.MediaTrackInfo.toJson.bind(fm.liveswitch.MediaTrackInfo));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            MediaTrackInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "stopped"))) {
                            if ((fm.liveswitch.Global.equals(str, "detached"))) {
                                this.setDetached(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "muted"))) {
                                    this.setMuted(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "report"))) {
                                        this.setReport(fm.liveswitch.MediaTrackReport.fromJson(valueJson));
                                    }
                                }
                            }
                        }
                        else {
                            this.setMuted(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the whether the media track is detached.
            */
            MediaTrackInfo.prototype.getDetached = function () {
                if (arguments.length == 0) {
                    return this._detached;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the whether the media track is muted.
            */
            MediaTrackInfo.prototype.getMuted = function () {
                if (arguments.length == 0) {
                    return this._muted;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the data stream report.
            */
            MediaTrackInfo.prototype.getReport = function () {
                if (arguments.length == 0) {
                    return this._report;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the whether the media track is stopped.
            */
            MediaTrackInfo.prototype.getStopped = function () {
                if (arguments.length == 0) {
                    return this._stopped;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            MediaTrackInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((this.getStopped() != null)) {
                        jsonObject["stopped"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getStopped());
                    }
                    if ((this.getDetached() != null)) {
                        jsonObject["detached"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getDetached());
                    }
                    if ((this.getMuted() != null)) {
                        jsonObject["muted"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getMuted());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getReport(), null))) {
                        jsonObject["report"] = this.getReport().toJson();
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the whether the media track is detached.
            */
            MediaTrackInfo.prototype.setDetached = function (value) {
                if (arguments.length == 1) {
                    this._detached = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the whether the media track is muted.
            */
            MediaTrackInfo.prototype.setMuted = function (value) {
                if (arguments.length == 1) {
                    this._muted = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the data stream report.
            */
            MediaTrackInfo.prototype.setReport = function (value) {
                if (arguments.length == 1) {
                    this._report = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the whether the media track is stopped.
            */
            MediaTrackInfo.prototype.setStopped = function (value) {
                if (arguments.length == 1) {
                    this._stopped = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            MediaTrackInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.MediaTrackInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaTrackInfo;
        }(fm.liveswitch.Info));
        liveswitch.MediaTrackInfo = MediaTrackInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="BaseStats.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media track stats.
        */
        var MediaTrackStats = /** @class */ (function (_super) {
            __extends(MediaTrackStats, _super);
            function MediaTrackStats() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaTrackStatsInit();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaTrackStats.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaTrackStats]' + ',' + _super.prototype.getTypeString.call(this);
            };
            MediaTrackStats.prototype.fmliveswitchMediaTrackStatsInit = function () {
                this._bitrate = 0;
                this._detached = false;
                this._frameHeight = 0;
                this._frameRate = 0;
                this._framesCorrupted = 0;
                this._framesDecoded = 0;
                this._framesDropped = 0;
                this._framesEncoded = 0;
                this._framesReceived = 0;
                this._framesSent = 0;
                this._frameWidth = 0;
                this._maxBitrate = 0;
                this._minBitrate = 0;
                this._muted = false;
                this._stopped = false;
            };
            /**
            Derializes media track stats from JSON.
            @param mediaTrackJson The media track's stats JSON.
            */
            MediaTrackStats.fromJson = function (mediaTrackJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(mediaTrackJson, function () {
                        return new fm.liveswitch.MediaTrackStats();
                    }, function (obj, key, valueJson) {
                        obj.deserializeProperties(key, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Derializes an array of media track stats from JSON.
            @param mediaTracksJson The media tracks' stats JSON.
            */
            MediaTrackStats.fromJsonArray = function (mediaTracksJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(mediaTracksJson, fm.liveswitch.MediaTrackStats.fromJson.bind(fm.liveswitch.MediaTrackStats));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes media track stats to JSON.
            @param mediaTrack The media track's stats.
            */
            MediaTrackStats.toJson = function (mediaTrack) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(mediaTrack, function (obj, jsonObject) {
                        obj.serializeProperties(jsonObject);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array of media track stats to JSON.
            @param mediaTracks The media tracks' stats.
            */
            MediaTrackStats.toJsonArray = function (mediaTracks) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(mediaTracks, fm.liveswitch.MediaTrackStats.toJson.bind(fm.liveswitch.MediaTrackStats));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            MediaTrackStats.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var _var0 = key;
                    if (_var0 == "stopped") {
                        do {
                            this.setStopped(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "detached") {
                        do {
                            this.setDetached(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "muted") {
                        do {
                            this.setMuted(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "ssrcs") {
                        do {
                            this.setSynchronizationSources(fm.liveswitch.JsonSerializer.deserializeLongArray(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "minBitrate") {
                        do {
                            this.setMinBitrate(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "maxBitrate") {
                        do {
                            this.setMaxBitrate(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "bitrate") {
                        do {
                            this.setBitrate(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "frameWidth") {
                        do {
                            this.setFrameWidth(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "frameHeight") {
                        do {
                            this.setFrameHeight(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "frameRate") {
                        do {
                            this.setFrameRate(fm.liveswitch.JsonSerializer.deserializeDouble(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "framesSent") {
                        do {
                            this.setFramesSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "framesReceived") {
                        do {
                            this.setFramesReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "framesDecoded") {
                        do {
                            this.setFramesDecoded(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "framesDropped") {
                        do {
                            this.setFramesDropped(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "framesCorrupted") {
                        do {
                            this.setFramesCorrupted(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "framesEncoded") {
                        do {
                            this.setFramesEncoded(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the bitrate. Set by the encoder.
            */
            MediaTrackStats.prototype.getBitrate = function () {
                if (arguments.length == 0) {
                    return this._bitrate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the track is detached.
            */
            MediaTrackStats.prototype.getDetached = function () {
                if (arguments.length == 0) {
                    return this._detached;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the frame height. Video-only. Set by encoder or decoder.
            */
            MediaTrackStats.prototype.getFrameHeight = function () {
                if (arguments.length == 0) {
                    return this._frameHeight;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the frame rate. Video-only. Set by encoder or decoder.
            */
            MediaTrackStats.prototype.getFrameRate = function () {
                if (arguments.length == 0) {
                    return this._frameRate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of corrupted frames. Video-only. Set by depacketizer.
            */
            MediaTrackStats.prototype.getFramesCorrupted = function () {
                if (arguments.length == 0) {
                    return this._framesCorrupted;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of frames decoded. Set by decoder.
            */
            MediaTrackStats.prototype.getFramesDecoded = function () {
                if (arguments.length == 0) {
                    return this._framesDecoded;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of frames dropped. Video-only. Set by depacketizer.
            */
            MediaTrackStats.prototype.getFramesDropped = function () {
                if (arguments.length == 0) {
                    return this._framesDropped;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of frames encoded. Set by encoder.
            */
            MediaTrackStats.prototype.getFramesEncoded = function () {
                if (arguments.length == 0) {
                    return this._framesEncoded;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of frames received. Set by depacketizer.
            */
            MediaTrackStats.prototype.getFramesReceived = function () {
                if (arguments.length == 0) {
                    return this._framesReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of frames sent. Set by packetizer.
            */
            MediaTrackStats.prototype.getFramesSent = function () {
                if (arguments.length == 0) {
                    return this._framesSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the frame width. Video-only. Set by encoder or decoder.
            */
            MediaTrackStats.prototype.getFrameWidth = function () {
                if (arguments.length == 0) {
                    return this._frameWidth;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the maximum bitrate. Set by the encoder.
            */
            MediaTrackStats.prototype.getMaxBitrate = function () {
                if (arguments.length == 0) {
                    return this._maxBitrate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the minimum bitrate. Set by the encoder.
            */
            MediaTrackStats.prototype.getMinBitrate = function () {
                if (arguments.length == 0) {
                    return this._minBitrate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the track is muted.
            */
            MediaTrackStats.prototype.getMuted = function () {
                if (arguments.length == 0) {
                    return this._muted;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the first repaired RTP stream identifier.
            */
            MediaTrackStats.prototype.getRepairedRtpStreamId = function () {
                if (arguments.length == 0) {
                    var repairedRtpStreamIds = this.getRepairedRtpStreamIds();
                    if (((fm.liveswitch.Global.equals(repairedRtpStreamIds, null)) || (fm.liveswitch.Global.equals(repairedRtpStreamIds.length, 0)))) {
                        return null;
                    }
                    return repairedRtpStreamIds[0];
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the repaired RTP stream identifiers.
            */
            MediaTrackStats.prototype.getRepairedRtpStreamIds = function () {
                if (arguments.length == 0) {
                    return this._repairedRtpStreamIds;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the first RTP stream identifier.
            */
            MediaTrackStats.prototype.getRtpStreamId = function () {
                if (arguments.length == 0) {
                    var rtpStreamIds = this.getRtpStreamIds();
                    if (((fm.liveswitch.Global.equals(rtpStreamIds, null)) || (fm.liveswitch.Global.equals(rtpStreamIds.length, 0)))) {
                        return null;
                    }
                    return rtpStreamIds[0];
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the RTP stream identifiers.
            */
            MediaTrackStats.prototype.getRtpStreamIds = function () {
                if (arguments.length == 0) {
                    return this._rtpStreamIds;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the track is stopped. Set by source.
            */
            MediaTrackStats.prototype.getStopped = function () {
                if (arguments.length == 0) {
                    return this._stopped;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the first synchronization source.
            */
            MediaTrackStats.prototype.getSynchronizationSource = function () {
                if (arguments.length == 0) {
                    var synchronizationSources = this.getSynchronizationSources();
                    if (((fm.liveswitch.Global.equals(synchronizationSources, null)) || (fm.liveswitch.Global.equals(synchronizationSources.length, 0)))) {
                        return 0;
                    }
                    return synchronizationSources[0];
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the synchronization sources.
            */
            MediaTrackStats.prototype.getSynchronizationSources = function () {
                if (arguments.length == 0) {
                    return this._synchronizationSources;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Checks if a track is equivalent to this one.
            @param instance The track.
            */
            MediaTrackStats.prototype.isEquivalent = function (instance) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(instance, null))) {
                        return false;
                    }
                    return ((((((fm.liveswitch.Global.equals(instance.getStopped(), this.getStopped())) && (fm.liveswitch.Global.equals(instance.getDetached(), this.getDetached()))) && ((fm.liveswitch.Global.equals(instance.getMuted(), this.getMuted())) && (fm.liveswitch.Global.equals(instance.getSynchronizationSources(), this.getSynchronizationSources())))) && (((fm.liveswitch.Global.equals(instance.getMinBitrate(), this.getMinBitrate())) && (fm.liveswitch.Global.equals(instance.getMaxBitrate(), this.getMaxBitrate()))) && ((fm.liveswitch.Global.equals(instance.getBitrate(), this.getBitrate())) && (fm.liveswitch.Global.equals(instance.getFrameWidth(), this.getFrameWidth()))))) && ((((fm.liveswitch.Global.equals(instance.getFrameHeight(), this.getFrameHeight())) && (fm.liveswitch.Global.equals(instance.getFrameRate(), this.getFrameRate()))) && ((fm.liveswitch.Global.equals(instance.getFramesSent(), this.getFramesSent())) && (fm.liveswitch.Global.equals(instance.getFramesReceived(), this.getFramesReceived())))) && (((fm.liveswitch.Global.equals(instance.getFramesDecoded(), this.getFramesDecoded())) && (fm.liveswitch.Global.equals(instance.getFramesDropped(), this.getFramesDropped()))) && (fm.liveswitch.Global.equals(instance.getFramesCorrupted(), this.getFramesCorrupted()))))) && (fm.liveswitch.Global.equals(instance.getFramesEncoded(), this.getFramesEncoded())));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            MediaTrackStats.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    jsonObject["stopped"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getStopped());
                    jsonObject["detached"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getDetached());
                    jsonObject["muted"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getMuted());
                    jsonObject["ssrcs"] = fm.liveswitch.JsonSerializer.serializeLongArray(this.getSynchronizationSources());
                    jsonObject["minBitrate"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getMinBitrate());
                    jsonObject["maxBitrate"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getMaxBitrate());
                    jsonObject["bitrate"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getBitrate());
                    jsonObject["frameWidth"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getFrameWidth());
                    jsonObject["frameHeight"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getFrameHeight());
                    jsonObject["frameRate"] = fm.liveswitch.JsonSerializer.serializeDouble(this.getFrameRate());
                    jsonObject["framesSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getFramesSent());
                    jsonObject["framesReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getFramesReceived());
                    jsonObject["framesDecoded"] = fm.liveswitch.JsonSerializer.serializeLong(this.getFramesDecoded());
                    jsonObject["framesDropped"] = fm.liveswitch.JsonSerializer.serializeLong(this.getFramesDropped());
                    jsonObject["framesCorrupted"] = fm.liveswitch.JsonSerializer.serializeLong(this.getFramesCorrupted());
                    jsonObject["framesEncoded"] = fm.liveswitch.JsonSerializer.serializeLong(this.getFramesEncoded());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaTrackStats.prototype.setBitrate = function (value) {
                if (arguments.length == 1) {
                    this._bitrate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaTrackStats.prototype.setDetached = function (value) {
                if (arguments.length == 1) {
                    this._detached = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaTrackStats.prototype.setFrameHeight = function (value) {
                if (arguments.length == 1) {
                    this._frameHeight = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaTrackStats.prototype.setFrameRate = function (value) {
                if (arguments.length == 1) {
                    this._frameRate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaTrackStats.prototype.setFramesCorrupted = function (value) {
                if (arguments.length == 1) {
                    this._framesCorrupted = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaTrackStats.prototype.setFramesDecoded = function (value) {
                if (arguments.length == 1) {
                    this._framesDecoded = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaTrackStats.prototype.setFramesDropped = function (value) {
                if (arguments.length == 1) {
                    this._framesDropped = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaTrackStats.prototype.setFramesEncoded = function (value) {
                if (arguments.length == 1) {
                    this._framesEncoded = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaTrackStats.prototype.setFramesReceived = function (value) {
                if (arguments.length == 1) {
                    this._framesReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaTrackStats.prototype.setFramesSent = function (value) {
                if (arguments.length == 1) {
                    this._framesSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaTrackStats.prototype.setFrameWidth = function (value) {
                if (arguments.length == 1) {
                    this._frameWidth = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaTrackStats.prototype.setMaxBitrate = function (value) {
                if (arguments.length == 1) {
                    this._maxBitrate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaTrackStats.prototype.setMinBitrate = function (value) {
                if (arguments.length == 1) {
                    this._minBitrate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaTrackStats.prototype.setMuted = function (value) {
                if (arguments.length == 1) {
                    this._muted = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaTrackStats.prototype.setRepairedRtpStreamIds = function (value) {
                if (arguments.length == 1) {
                    this._repairedRtpStreamIds = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaTrackStats.prototype.setRtpStreamIds = function (value) {
                if (arguments.length == 1) {
                    this._rtpStreamIds = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaTrackStats.prototype.setStopped = function (value) {
                if (arguments.length == 1) {
                    this._stopped = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaTrackStats.prototype.setSynchronizationSources = function (value) {
                if (arguments.length == 1) {
                    this._synchronizationSources = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this to JSON.
            */
            MediaTrackStats.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.MediaTrackStats.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaTrackStats;
        }(fm.liveswitch.BaseStats));
        liveswitch.MediaTrackStats = MediaTrackStats;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media source information.
        */
        var MediaSourceInfo = /** @class */ (function (_super) {
            __extends(MediaSourceInfo, _super);
            function MediaSourceInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaSourceInfoInit();
                }
                else if (__arguments.length == 2) {
                    var stats = __arguments[0];
                    var lastStats = __arguments[1];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaSourceInfoInit();
                    var flag = (fm.liveswitch.Global.equals(lastStats, null));
                    _super.prototype.setId.call(_this, stats.getId());
                    _this.setTag((flag ? stats.getTag() : fm.liveswitch.Info.processString(stats.getTag(), (flag ? null : lastStats.getTag()))));
                    _this.setLabel((flag ? stats.getLabel() : fm.liveswitch.Info.processString(stats.getLabel(), (flag ? null : lastStats.getLabel()))));
                    _this.setMuted((flag ? stats.getMuted() : fm.liveswitch.Info.processBoolean(stats.getMuted(), lastStats.getMuted())));
                    _this.setInputId((flag ? stats.getInputId() : fm.liveswitch.Info.processString(stats.getInputId(), lastStats.getInputId())));
                    _this.setInputName((flag ? stats.getInputName() : fm.liveswitch.Info.processString(stats.getInputName(), lastStats.getInputName())));
                    if (((!fm.liveswitch.Global.equals(stats.getOutputFormat(), null)) && (flag || !stats.getOutputFormat().isEquivalent(lastStats.getOutputFormat())))) {
                        _this.setOutputFormat(new fm.liveswitch.FormatInfo(stats.getOutputFormat().getName(), stats.getOutputFormat().getClockRate(), stats.getOutputFormat().getChannelCount()));
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaSourceInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaSourceInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            MediaSourceInfo.prototype.fmliveswitchMediaSourceInfoInit = function () {
                this._muted = false;
            };
            /**
            Deserializes an instance from JSON.
            @param mediaSourceInfoJson The serialized JSON.
            @return The deserialized instance.
            */
            MediaSourceInfo.fromJson = function (mediaSourceInfoJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(mediaSourceInfoJson, function () {
                        return new fm.liveswitch.MediaSourceInfo();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array from JSON.
            @param mediaSourceInfosJson The serialized JSON.
            @return The deserialized array.
            */
            MediaSourceInfo.fromJsonArray = function (mediaSourceInfosJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(mediaSourceInfosJson, fm.liveswitch.MediaSourceInfo.fromJson.bind(fm.liveswitch.MediaSourceInfo));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param mediaSourceInfo The instance to serialize.
            @return The serialized JSON.
            */
            MediaSourceInfo.toJson = function (mediaSourceInfo) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(mediaSourceInfo, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param mediaSourceInfos The array to serialize.
            @return The serialized JSON.
            */
            MediaSourceInfo.toJsonArray = function (mediaSourceInfos) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(mediaSourceInfos, fm.liveswitch.MediaSourceInfo.toJson.bind(fm.liveswitch.MediaSourceInfo));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            MediaSourceInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "tag"))) {
                            if ((fm.liveswitch.Global.equals(str, "label"))) {
                                this.setLabel(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "muted"))) {
                                    this.setMuted(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "inputId"))) {
                                        this.setInputId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "inputName"))) {
                                            this.setInputName(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                        }
                                        else {
                                            if ((fm.liveswitch.Global.equals(str, "outputFormat"))) {
                                                this.setOutputFormat(fm.liveswitch.FormatInfo.fromJson(valueJson));
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            this.setTag(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media source input identifier.
            */
            MediaSourceInfo.prototype.getInputId = function () {
                if (arguments.length == 0) {
                    return this._inputId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media source input name.
            */
            MediaSourceInfo.prototype.getInputName = function () {
                if (arguments.length == 0) {
                    return this._inputName;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media source label.
            */
            MediaSourceInfo.prototype.getLabel = function () {
                if (arguments.length == 0) {
                    return this._label;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the whether the media source is muted.
            */
            MediaSourceInfo.prototype.getMuted = function () {
                if (arguments.length == 0) {
                    return this._muted;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media source output format.
            */
            MediaSourceInfo.prototype.getOutputFormat = function () {
                if (arguments.length == 0) {
                    return this._outputFormat;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media source tag.
            */
            MediaSourceInfo.prototype.getTag = function () {
                if (arguments.length == 0) {
                    return this._tag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            MediaSourceInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if (!fm.liveswitch.StringExtensions.isNullOrEmpty(this.getTag())) {
                        jsonObject["tag"] = fm.liveswitch.JsonSerializer.serializeString(this.getTag());
                    }
                    if (!fm.liveswitch.StringExtensions.isNullOrEmpty(this.getLabel())) {
                        jsonObject["label"] = fm.liveswitch.JsonSerializer.serializeString(this.getLabel());
                    }
                    if ((this.getMuted() != null)) {
                        jsonObject["muted"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getMuted());
                    }
                    if (!fm.liveswitch.StringExtensions.isNullOrEmpty(this.getInputId())) {
                        jsonObject["inputId"] = fm.liveswitch.JsonSerializer.serializeString(this.getInputId());
                    }
                    if (!fm.liveswitch.StringExtensions.isNullOrEmpty(this.getInputName())) {
                        jsonObject["inputName"] = fm.liveswitch.JsonSerializer.serializeString(this.getInputName());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getOutputFormat(), null))) {
                        jsonObject["outputFormat"] = fm.liveswitch.FormatInfo.toJson(this.getOutputFormat());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media source input identifier.
            */
            MediaSourceInfo.prototype.setInputId = function (value) {
                if (arguments.length == 1) {
                    this._inputId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media source input name.
            */
            MediaSourceInfo.prototype.setInputName = function (value) {
                if (arguments.length == 1) {
                    this._inputName = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media source label.
            */
            MediaSourceInfo.prototype.setLabel = function (value) {
                if (arguments.length == 1) {
                    this._label = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the whether the media source is muted.
            */
            MediaSourceInfo.prototype.setMuted = function (value) {
                if (arguments.length == 1) {
                    this._muted = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media source output format.
            */
            MediaSourceInfo.prototype.setOutputFormat = function (value) {
                if (arguments.length == 1) {
                    this._outputFormat = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media source tag.
            */
            MediaSourceInfo.prototype.setTag = function (value) {
                if (arguments.length == 1) {
                    this._tag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            MediaSourceInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.MediaSourceInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaSourceInfo;
        }(fm.liveswitch.Info));
        liveswitch.MediaSourceInfo = MediaSourceInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A point (x and y coordinates).
        */
        var Point = /** @class */ (function () {
            function Point() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchPointInit();
                    this.setX(0);
                    this.setY(0);
                }
                else if (__arguments.length == 2) {
                    var x = __arguments[0];
                    var y = __arguments[1];
                    //super();
                    this.fmliveswitchPointInit();
                    this.setX(x);
                    this.setY(y);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Point.prototype.getTypeString = function () {
                return '[fm.liveswitch.Point]';
            };
            Point.prototype.fmliveswitchPointInit = function () {
                this.__x = 0;
                this.__y = 0;
            };
            /**
            Deserializes an instance from JSON.
            @param pointJson The JSON to deserialize.
            @return The deserialized point.
            */
            Point.fromJson = function (pointJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(pointJson, function () {
                        return new fm.liveswitch.Point();
                    }, function (point, name, valueJson) {
                        var str = name;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            if (!(fm.liveswitch.Global.equals(str, "x"))) {
                                if ((fm.liveswitch.Global.equals(str, "y"))) {
                                    point.setY(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                }
                            }
                            else {
                                point.setX(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            }
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the empty point (0,0).
            */
            Point.getEmpty = function () {
                if (arguments.length == 0) {
                    if ((fm.liveswitch.Global.equals(fm.liveswitch.Point.fm_liveswitch_Point___empty, null))) {
                        fm.liveswitch.Point.fm_liveswitch_Point___empty = new fm.liveswitch.Point();
                    }
                    return fm.liveswitch.Point.fm_liveswitch_Point___empty;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Determines whether the two points are equivalent.
            @param point1 The first point.
            @param point2 The second point.
            */
            Point.isEquivalent = function (point1, point2) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(point1, point2))) {
                        return true;
                    }
                    if (((fm.liveswitch.Global.equals(point1, null)) || (fm.liveswitch.Global.equals(point2, null)))) {
                        return false;
                    }
                    return fm.liveswitch.Point.isEquivalentNoCheck(point1, point2);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Point.isEquivalentNoCheck = function (point1, point2) {
                if (arguments.length == 2) {
                    return ((fm.liveswitch.Global.equals(point1.getX(), point2.getX())) && (fm.liveswitch.Global.equals(point1.getY(), point2.getY())));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param point The point.
            @return
                        The serialized JSON.
                
            */
            Point.toJson = function (point) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(point, function (obj, jsonObj) {
                        if ((!fm.liveswitch.Global.equals(point.getX(), -1))) {
                            jsonObj["x"] = fm.liveswitch.JsonSerializer.serializeInteger(point.getX());
                        }
                        if ((!fm.liveswitch.Global.equals(point.getY(), -1))) {
                            jsonObj["y"] = fm.liveswitch.JsonSerializer.serializeInteger(point.getY());
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the X coordinate.
            */
            Point.prototype.getX = function () {
                if (arguments.length == 0) {
                    return this.__x;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the Y coordinate.
            */
            Point.prototype.getY = function () {
                if (arguments.length == 0) {
                    return this.__y;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Determines whether the specified point is equivalent.
            @param point The point.
            */
            Point.prototype.isEquivalent = function (point) {
                if (arguments.length == 1) {
                    return fm.liveswitch.Point.isEquivalent(this, point);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the X coordinate.
            */
            Point.prototype.setX = function (value) {
                if (arguments.length == 1) {
                    this.__x = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the Y coordinate.
            */
            Point.prototype.setY = function (value) {
                if (arguments.length == 1) {
                    this.__y = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            @return
                        The serialized JSON.
                
            */
            Point.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Point.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Returns a string that represents this instance using format "{x},{y}".
            */
            Point.prototype.toString = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.format("{0},{1}", fm.liveswitch.NumberExtensions.toString(this.getX()), fm.liveswitch.NumberExtensions.toString(this.getY()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Point;
        }());
        liveswitch.Point = Point;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A rectangle (size and origin).
        */
        var Rectangle = /** @class */ (function () {
            function Rectangle() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.setOrigin(fm.liveswitch.Point.getEmpty());
                    this.setSize(fm.liveswitch.Size.getEmpty());
                }
                else if (__arguments.length == 2) {
                    var origin_3 = __arguments[0];
                    var size = __arguments[1];
                    //super();
                    this.setOrigin(origin_3);
                    this.setSize(size);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Rectangle.prototype.getTypeString = function () {
                return '[fm.liveswitch.Rectangle]';
            };
            /**
            Deserializes an instance from JSON.
            @param rectangleJson The JSON to deserialize.
            @return The deserialized rectangle.
            */
            Rectangle.fromJson = function (rectangleJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(rectangleJson, function () {
                        return new fm.liveswitch.Rectangle();
                    }, function (rectangle, name, valueJson) {
                        var str = name;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            if (!(fm.liveswitch.Global.equals(str, "origin"))) {
                                if ((fm.liveswitch.Global.equals(str, "size"))) {
                                    rectangle.setSize(fm.liveswitch.Size.fromJson(valueJson));
                                }
                            }
                            else {
                                rectangle.setOrigin(fm.liveswitch.Point.fromJson(valueJson));
                            }
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the empty rectangle (0,0/0x0).
            */
            Rectangle.getEmpty = function () {
                if (arguments.length == 0) {
                    if ((fm.liveswitch.Global.equals(fm.liveswitch.Rectangle.fm_liveswitch_Rectangle___empty, null))) {
                        fm.liveswitch.Rectangle.fm_liveswitch_Rectangle___empty = new fm.liveswitch.Rectangle();
                    }
                    return fm.liveswitch.Rectangle.fm_liveswitch_Rectangle___empty;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Determines whether the two rectangles are equivalent.
            @param rectangle1 The first rectangle.
            @param rectangle2 The second rectangle.
            */
            Rectangle.isEquivalent = function (rectangle1, rectangle2) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(rectangle1, rectangle2))) {
                        return true;
                    }
                    if (((fm.liveswitch.Global.equals(rectangle1, null)) || (fm.liveswitch.Global.equals(rectangle2, null)))) {
                        return false;
                    }
                    return fm.liveswitch.Rectangle.isEquivalentNoCheck(rectangle1, rectangle2);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Rectangle.isEquivalentNoCheck = function (rectangle1, rectangle2) {
                if (arguments.length == 2) {
                    return (fm.liveswitch.Point.isEquivalent(rectangle1.getOrigin(), rectangle2.getOrigin()) && fm.liveswitch.Size.isEquivalent(rectangle1.getSize(), rectangle2.getSize()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param rectangle The rectangle.
            @return
                        The serialized JSON.
                
            */
            Rectangle.toJson = function (rectangle) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(rectangle, function (obj, jsonObj) {
                        if ((!fm.liveswitch.Global.equals(rectangle.getOrigin(), null))) {
                            jsonObj["origin"] = fm.liveswitch.Point.toJson(rectangle.getOrigin());
                        }
                        if ((!fm.liveswitch.Global.equals(rectangle.getSize(), null))) {
                            jsonObj["size"] = fm.liveswitch.Size.toJson(rectangle.getSize());
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the size height.
            */
            Rectangle.prototype.getHeight = function () {
                if (arguments.length == 0) {
                    return this.getSize().getHeight();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the origin.
            */
            Rectangle.prototype.getOrigin = function () {
                if (arguments.length == 0) {
                    return this.__origin;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the size.
            */
            Rectangle.prototype.getSize = function () {
                if (arguments.length == 0) {
                    return this.__size;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the size width.
            */
            Rectangle.prototype.getWidth = function () {
                if (arguments.length == 0) {
                    return this.getSize().getWidth();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the origin X coordinate.
            */
            Rectangle.prototype.getX = function () {
                if (arguments.length == 0) {
                    return this.getOrigin().getX();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the origin Y coordinate.
            */
            Rectangle.prototype.getY = function () {
                if (arguments.length == 0) {
                    return this.getOrigin().getY();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Determines whether the specified rectangle is equivalent.
            @param rectangle The rectangle.
            */
            Rectangle.prototype.isEquivalent = function (rectangle) {
                if (arguments.length == 1) {
                    return fm.liveswitch.Rectangle.isEquivalent(this, rectangle);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the origin.
            */
            Rectangle.prototype.setOrigin = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(value, null))) {
                        throw new fm.liveswitch.Exception("Origin cannot be null.");
                    }
                    this.__origin = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the size.
            */
            Rectangle.prototype.setSize = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(value, null))) {
                        throw new fm.liveswitch.Exception("Size cannot be null.");
                    }
                    this.__size = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            @return
                        The serialized JSON.
                
            */
            Rectangle.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Rectangle.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Returns a string that represents this instance using format "{origin}/{size}".
            */
            Rectangle.prototype.toString = function () {
                if (arguments.length == 0) {
                    var origin_4 = this.getOrigin();
                    var size = this.getSize();
                    return fm.liveswitch.StringExtensions.format("{0}/{1}", origin_4.toString(), size.toString());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Rectangle;
        }());
        liveswitch.Rectangle = Rectangle;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            Defines valid SDP address types.
            */
            var AddressType = /** @class */ (function () {
                function AddressType() {
                }
                AddressType.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.AddressType]';
                };
                /**
                Gets the SDP address type for the specified IP address.
                @param ipAddress The IP address.
                */
                AddressType.getAddressTypeForAddress = function (ipAddress) {
                    if (arguments.length == 1) {
                        var _var0 = fm.liveswitch.LocalNetwork.getAddressType(ipAddress);
                        if (_var0 == fm.liveswitch.AddressType.IPv4) {
                            do {
                                return fm.liveswitch.sdp.AddressType.getIP4();
                            } while (false);
                        }
                        else if (_var0 == fm.liveswitch.AddressType.IPv6) {
                            do {
                                return fm.liveswitch.sdp.AddressType.getIP6();
                            } while (false);
                        }
                        throw new fm.liveswitch.Exception("Only IPv4 and IPv6 addresses are supported by SDP.");
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP address type meaning "IP version 4".
                */
                AddressType.getIP4 = function () {
                    if (arguments.length == 0) {
                        return "IP4";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP address type meaning "IP version 6".
                */
                AddressType.getIP6 = function () {
                    if (arguments.length == 0) {
                        return "IP6";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return AddressType;
            }());
            sdp.AddressType = AddressType;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            An SDP attribute.
            */
            var Attribute = /** @class */ (function () {
                function Attribute() {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        //super();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                Attribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.Attribute]';
                };
                /**
                Creates an attribute.
                @param name The name.
                @param value The value.
                */
                Attribute.createAttribute = function (name, value) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 2) {
                        for (var _i = 0, _a = fm.liveswitch.HashExtensions.getKeys(fm.liveswitch.sdp.Attribute.fm_liveswitch_sdp_Attribute__registeredAttributes); _i < _a.length; _i++) {
                            var str = _a[_i];
                            var registration = fm.liveswitch.sdp.Attribute.fm_liveswitch_sdp_Attribute__registeredAttributes[str];
                            if ((fm.liveswitch.Global.equals(registration.getName(), name))) {
                                return registration.getCreationDelegate()(new fm.liveswitch.sdp.AttributeCreationArgs(value));
                            }
                        }
                        return new fm.liveswitch.sdp.UnknownAttribute(name, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPBundleOnlyAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.BundleOnlyAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPCandidateAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.ice.CandidateAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPCategoryAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.CategoryAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPCharacterSetAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.CharacterSetAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPConferenceTypeAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.ConferenceTypeAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPCryptoAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.CryptoAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPExtMapAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.rtp.ExtMapAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPFingerprintAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.ice.FingerprintAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPFormatParametersAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.FormatParametersAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPFrameRateAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.FrameRateAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPGroupAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.GroupAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPIceLiteAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.ice.LiteAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPIceMismatchAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.ice.MismatchAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPIceOptionsAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.ice.OptionsAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPIcePasswordAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.ice.PasswordAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPIceUfragAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.ice.UfragAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPInactiveAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.InactiveAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPKeywordsAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.KeywordsAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPLanguageAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.LanguageAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPMaxPacketTimeAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.MaxPacketTimeAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPMediaStreamIdAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.MediaStreamIdAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPMediaStreamIdSemanticAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.MediaStreamIdSemanticAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPOrientationAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.OrientationAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPPacketTimeAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.PacketTimeAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPQualityAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.QualityAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPReceiveOnlyAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.ReceiveOnlyAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPRemoteCandidatesAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.ice.RemoteCandidatesAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPRidAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.rtp.RidAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPRtcpAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.rtcp.Attribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPRtcpFeedbackAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.rtcp.FeedbackAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPRtcpMuxAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.rtcp.MuxAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPRtpMapAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.rtp.MapAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPSctpMapAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.sctp.MapAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPSctpMaxMessageSizeAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.sctp.MaxMessageSizeAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPSctpPortAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.sctp.PortAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPSdpLanguageAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.SdpLanguageAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPSendOnlyAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.SendOnlyAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPSendReceiveAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.SendReceiveAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPSetupAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.SetupAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPSimulcastAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.rtp.SimulcastAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPSSRCAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.rtp.SsrcAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPSSRCGroupAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.rtp.SsrcGroupAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.createSDPToolAttribute = function (e) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.sdp.ToolAttribute.fromAttributeValue(e.getValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the name of the attribute type.
                @param type The attribute type.
                */
                Attribute.getTypeName = function (type) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        var registration = null;
                        var _var0 = new fm.liveswitch.Holder(registration);
                        var _var1 = fm.liveswitch.HashExtensions.tryGetValue(fm.liveswitch.sdp.Attribute.fm_liveswitch_sdp_Attribute__registeredAttributes, type.getFullName(), _var0);
                        registration = _var0.getValue();
                        if (_var1) {
                            return registration.getName();
                        }
                        var baseType = type.getBaseType();
                        if ((!fm.liveswitch.Global.equals(baseType, null))) {
                            return fm.liveswitch.sdp.Attribute.getTypeName(baseType);
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Determines whether the type applies to media streams.
                @param type The type.
                */
                Attribute.isMediaLevel = function (type) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(type.getFullName(), fm.liveswitch.sdp.Attribute.fm_liveswitch_sdp_Attribute__unknownAttributeTypeName))) {
                            return true;
                        }
                        var registration = null;
                        var _var0 = new fm.liveswitch.Holder(registration);
                        var _var1 = fm.liveswitch.HashExtensions.tryGetValue(fm.liveswitch.sdp.Attribute.fm_liveswitch_sdp_Attribute__registeredAttributes, type.getFullName(), _var0);
                        registration = _var0.getValue();
                        if (_var1) {
                            return registration.getMediaLevel();
                        }
                        return false;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Determines whether the type applies to sessions.
                @param type The type.
                */
                Attribute.isSessionLevel = function (type) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(type.getFullName(), fm.liveswitch.sdp.Attribute.fm_liveswitch_sdp_Attribute__unknownAttributeTypeName))) {
                            return true;
                        }
                        var registration = null;
                        var _var0 = new fm.liveswitch.Holder(registration);
                        var _var1 = fm.liveswitch.HashExtensions.tryGetValue(fm.liveswitch.sdp.Attribute.fm_liveswitch_sdp_Attribute__registeredAttributes, type.getFullName(), _var0);
                        registration = _var0.getValue();
                        if (_var1) {
                            return registration.getSessionLevel();
                        }
                        return false;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Creates an [[fm.liveswitch.sdp.connectionData]] instance from a string.
                @param s The string to parse.
                */
                Attribute.parse = function (s) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        var str = void 0;
                        var str2 = void 0;
                        s = s.substring(2);
                        var index = fm.liveswitch.StringExtensions.indexOf(s, ":");
                        if ((fm.liveswitch.Global.equals(index, -1))) {
                            str = s;
                            str2 = null;
                        }
                        else {
                            str = fm.liveswitch.StringExtensions.substring(s, 0, index);
                            str2 = s.substring((index + 1));
                        }
                        return fm.liveswitch.sdp.Attribute.createAttribute(str, str2);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.registerAttribute = function (type, name, sessionLevel, mediaLevel, creationDelegate) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 5) {
                        fm.liveswitch.sdp.Attribute.fm_liveswitch_sdp_Attribute__registeredAttributes[type.getFullName()] = new fm.liveswitch.sdp.AttributeRegistration(name, sessionLevel, mediaLevel, creationDelegate);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.unregisterAttribute = function (type) {
                    fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.HashExtensions.remove(fm.liveswitch.sdp.Attribute.fm_liveswitch_sdp_Attribute__registeredAttributes, type.getFullName());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets this Attribute's Type.
                */
                Attribute.prototype.getAttributeType = function () {
                    if (arguments.length == 0) {
                        return this._attributeType;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the Multiplexing Category of this Attribute.
                */
                Attribute.prototype.getMultiplexingCategory = function () {
                    if (arguments.length == 0) {
                        return this._multiplexingCategory;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets this Attribute's Type.
                */
                Attribute.prototype.setAttributeType = function (value) {
                    if (arguments.length == 1) {
                        this._attributeType = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the Multiplexing Category of this Attribute.
                */
                Attribute.prototype.setMultiplexingCategory = function (value) {
                    if (arguments.length == 1) {
                        this._multiplexingCategory = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Converts this instance to a string.
                */
                Attribute.prototype.toString = function () {
                    if (arguments.length == 0) {
                        var builder = new fm.liveswitch.StringBuilder();
                        builder.append("a=");
                        var type = new fm.liveswitch.Type(this.getTypeString());
                        if ((fm.liveswitch.Global.equals(type.getFullName(), fm.liveswitch.sdp.Attribute.fm_liveswitch_sdp_Attribute__unknownAttributeTypeName))) {
                            builder.append(this.getName());
                        }
                        else {
                            builder.append(fm.liveswitch.sdp.Attribute.getTypeName(type));
                        }
                        var attributeValue = this.getAttributeValue();
                        if ((!fm.liveswitch.Global.equals(attributeValue, null))) {
                            builder.append(":");
                            builder.append(attributeValue);
                        }
                        return builder.toString();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Attribute.fmliveswitchsdpAttributeInitialize = function () {
                    if (!fm.liveswitch.sdp.Attribute.__fmliveswitchsdpAttributeInitialized && !fm.liveswitch.sdp.Attribute.__fmliveswitchsdpAttributeInitializing) {
                        fm.liveswitch.sdp.Attribute.__fmliveswitchsdpAttributeInitializing = true;
                        fm.liveswitch.sdp.Attribute.fm_liveswitch_sdp_Attribute__registeredAttributes = {};
                        fm.liveswitch.sdp.Attribute.fm_liveswitch_sdp_Attribute__registeredAttributesLock = new Object();
                        fm.liveswitch.sdp.Attribute.fm_liveswitch_sdp_Attribute__unknownAttributeTypeName = new fm.liveswitch.Type('[fm.liveswitch.sdp.UnknownAttribute]').getFullName();
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.GroupAttribute]'), "group", true, false, fm.liveswitch.sdp.Attribute.createSDPGroupAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.CategoryAttribute]'), "cat", true, false, fm.liveswitch.sdp.Attribute.createSDPCategoryAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.CharacterSetAttribute]'), "charset", true, false, fm.liveswitch.sdp.Attribute.createSDPCharacterSetAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.ConferenceTypeAttribute]'), "type", true, false, fm.liveswitch.sdp.Attribute.createSDPConferenceTypeAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.CryptoAttribute]'), "crypto", true, true, fm.liveswitch.sdp.Attribute.createSDPCryptoAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.FormatParametersAttribute]'), "fmtp", false, true, fm.liveswitch.sdp.Attribute.createSDPFormatParametersAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.FrameRateAttribute]'), "framerate", false, true, fm.liveswitch.sdp.Attribute.createSDPFrameRateAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.InactiveAttribute]'), "inactive", true, true, fm.liveswitch.sdp.Attribute.createSDPInactiveAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.KeywordsAttribute]'), "keywds", true, false, fm.liveswitch.sdp.Attribute.createSDPKeywordsAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.LanguageAttribute]'), "lang", true, true, fm.liveswitch.sdp.Attribute.createSDPLanguageAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.MaxPacketTimeAttribute]'), "maxptime", false, true, fm.liveswitch.sdp.Attribute.createSDPMaxPacketTimeAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.OrientationAttribute]'), "orient", false, true, fm.liveswitch.sdp.Attribute.createSDPOrientationAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.PacketTimeAttribute]'), "ptime", false, true, fm.liveswitch.sdp.Attribute.createSDPPacketTimeAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.QualityAttribute]'), "quality", false, true, fm.liveswitch.sdp.Attribute.createSDPQualityAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.ReceiveOnlyAttribute]'), "recvonly", true, true, fm.liveswitch.sdp.Attribute.createSDPReceiveOnlyAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.SdpLanguageAttribute]'), "sdplang", true, true, fm.liveswitch.sdp.Attribute.createSDPSdpLanguageAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.SendOnlyAttribute]'), "sendonly", true, true, fm.liveswitch.sdp.Attribute.createSDPSendOnlyAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.SendReceiveAttribute]'), "sendrecv", true, true, fm.liveswitch.sdp.Attribute.createSDPSendReceiveAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.SetupAttribute]'), "setup", true, true, fm.liveswitch.sdp.Attribute.createSDPSetupAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.ToolAttribute]'), "tool", true, false, fm.liveswitch.sdp.Attribute.createSDPToolAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.MediaStreamIdSemanticAttribute]'), "msid-semantic", true, true, fm.liveswitch.sdp.Attribute.createSDPMediaStreamIdSemanticAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.MediaStreamIdAttribute]'), "mid", true, true, fm.liveswitch.sdp.Attribute.createSDPMediaStreamIdAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.BundleOnlyAttribute]'), "bundle-only", false, true, fm.liveswitch.sdp.Attribute.createSDPBundleOnlyAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.ice.CandidateAttribute]'), "candidate", false, true, fm.liveswitch.sdp.Attribute.createSDPCandidateAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.ice.FingerprintAttribute]'), "fingerprint", true, true, fm.liveswitch.sdp.Attribute.createSDPFingerprintAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.ice.LiteAttribute]'), "ice-lite", true, false, fm.liveswitch.sdp.Attribute.createSDPIceLiteAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.ice.MismatchAttribute]'), "ice-mismatch", true, false, fm.liveswitch.sdp.Attribute.createSDPIceMismatchAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.ice.OptionsAttribute]'), "ice-options", true, true, fm.liveswitch.sdp.Attribute.createSDPIceOptionsAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.ice.PasswordAttribute]'), "ice-pwd", true, true, fm.liveswitch.sdp.Attribute.createSDPIcePasswordAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.ice.UfragAttribute]'), "ice-ufrag", true, true, fm.liveswitch.sdp.Attribute.createSDPIceUfragAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.ice.RemoteCandidatesAttribute]'), "remote-candidates", false, true, fm.liveswitch.sdp.Attribute.createSDPRemoteCandidatesAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.rtp.MapAttribute]'), "rtpmap", false, true, fm.liveswitch.sdp.Attribute.createSDPRtpMapAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.rtp.SsrcAttribute]'), "ssrc", false, true, fm.liveswitch.sdp.Attribute.createSDPSSRCAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.rtp.SsrcGroupAttribute]'), "ssrc-group", false, true, fm.liveswitch.sdp.Attribute.createSDPSSRCGroupAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.rtp.ExtMapAttribute]'), "extmap", true, true, fm.liveswitch.sdp.Attribute.createSDPExtMapAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.rtp.RidAttribute]'), "rid", false, true, fm.liveswitch.sdp.Attribute.createSDPRidAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.rtp.SimulcastAttribute]'), "simulcast", false, true, fm.liveswitch.sdp.Attribute.createSDPSimulcastAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.rtcp.Attribute]'), "rtcp", false, true, fm.liveswitch.sdp.Attribute.createSDPRtcpAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.rtcp.FeedbackAttribute]'), "rtcp-fb", false, true, fm.liveswitch.sdp.Attribute.createSDPRtcpFeedbackAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.rtcp.MuxAttribute]'), "rtcp-mux", false, true, fm.liveswitch.sdp.Attribute.createSDPRtcpMuxAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.sctp.PortAttribute]'), "sctp-port", false, true, fm.liveswitch.sdp.Attribute.createSDPSctpPortAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.sctp.MapAttribute]'), "sctpmap", false, true, fm.liveswitch.sdp.Attribute.createSDPSctpMapAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.registerAttribute(new fm.liveswitch.Type('[fm.liveswitch.sdp.sctp.MaxMessageSizeAttribute]'), "max-message-size", false, true, fm.liveswitch.sdp.Attribute.createSDPSctpMaxMessageSizeAttribute.bind(fm.liveswitch.sdp.Attribute));
                        fm.liveswitch.sdp.Attribute.__fmliveswitchsdpAttributeInitialized = true;
                        fm.liveswitch.sdp.Attribute.__fmliveswitchsdpAttributeInitializing = false;
                    }
                };
                /** @hidden */
                Attribute.__fmliveswitchsdpAttributeInitialized = false;
                /** @hidden */
                Attribute.__fmliveswitchsdpAttributeInitializing = false;
                return Attribute;
            }());
            sdp.Attribute = Attribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var AttributeCategoryWrapper = /** @class */ (function () {
                function AttributeCategoryWrapper(value) {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var value_25 = __arguments[0];
                        //super();
                        this._value = value_25;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                AttributeCategoryWrapper.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.AttributeCategoryWrapper]';
                };
                AttributeCategoryWrapper.prototype.toString = function () {
                    if (arguments.length == 0) {
                        if (this._value == fm.liveswitch.sdp.AttributeCategory.Normal)
                            return 'Normal';
                        if (this._value == fm.liveswitch.sdp.AttributeCategory.Caution)
                            return 'Caution';
                        if (this._value == fm.liveswitch.sdp.AttributeCategory.Identical)
                            return 'Identical';
                        if (this._value == fm.liveswitch.sdp.AttributeCategory.Sum)
                            return 'Sum';
                        if (this._value == fm.liveswitch.sdp.AttributeCategory.Transport)
                            return 'Transport';
                        if (this._value == fm.liveswitch.sdp.AttributeCategory.Inherit)
                            return 'Inherit';
                        if (this._value == fm.liveswitch.sdp.AttributeCategory.IdenticalPerPT)
                            return 'IdenticalPerPT';
                        if (this._value == fm.liveswitch.sdp.AttributeCategory.Special)
                            return 'Special';
                        return '';
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return AttributeCategoryWrapper;
            }());
            sdp.AttributeCategoryWrapper = AttributeCategoryWrapper;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /** @hidden */
            var AttributeCollection = /** @class */ (function () {
                function AttributeCollection() {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        //super();
                        this.__attributes = {};
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                AttributeCollection.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.AttributeCollection]';
                };
                AttributeCollection.prototype.addAttribute = function (attribute) {
                    if (arguments.length == 1) {
                        var key = new fm.liveswitch.sdp.AttributeTypeWrapper(attribute.getAttributeType()).toString();
                        var list = null;
                        var _var0 = new fm.liveswitch.Holder(list);
                        var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this.__attributes, key, _var0);
                        list = _var0.getValue();
                        if (!_var1) {
                            list = new Array();
                            fm.liveswitch.ArrayExtensions.add(list, attribute);
                            fm.liveswitch.HashExtensions.add(this.__attributes, key, list);
                        }
                        else {
                            fm.liveswitch.ArrayExtensions.add(list, attribute);
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                AttributeCollection.prototype.remove = function () {
                    if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.sdp.Attribute]'))) {
                        var attribute = arguments[0];
                        var flag = false;
                        var list = null;
                        var _var0 = new fm.liveswitch.Holder(list);
                        var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this.__attributes, new fm.liveswitch.sdp.AttributeTypeWrapper(attribute.getAttributeType()).toString(), _var0);
                        list = _var0.getValue();
                        if (_var1) {
                            if ((fm.liveswitch.Global.equals(list, null))) {
                                return flag;
                            }
                            flag = fm.liveswitch.ArrayExtensions.remove(list, attribute);
                            if ((fm.liveswitch.Global.equals(fm.liveswitch.ArrayExtensions.getCount(list), 0))) {
                                fm.liveswitch.HashExtensions.remove(this.__attributes, new fm.liveswitch.sdp.AttributeTypeWrapper(attribute.getAttributeType()).toString());
                            }
                        }
                        return flag;
                    }
                    else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isNumber(arguments[0]))) {
                        var attributeType = arguments[0];
                        return fm.liveswitch.HashExtensions.remove(this.__attributes, new fm.liveswitch.sdp.AttributeTypeWrapper(attributeType).toString());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                AttributeCollection.prototype.replaceAttribute = function (attribute) {
                    if (arguments.length == 1) {
                        var attributeType = attribute.getAttributeType();
                        fm.liveswitch.HashExtensions.remove(this.__attributes, new fm.liveswitch.sdp.AttributeTypeWrapper(attributeType).toString());
                        var list = new Array();
                        fm.liveswitch.ArrayExtensions.add(list, attribute);
                        fm.liveswitch.HashExtensions.add(this.__attributes, new fm.liveswitch.sdp.AttributeTypeWrapper(attributeType).toString(), list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                AttributeCollection.prototype.toArray = function () {
                    if (arguments.length == 0) {
                        var list = new Array();
                        for (var _i = 0, _a = fm.liveswitch.HashExtensions.getValues(this.__attributes); _i < _a.length; _i++) {
                            var list2 = _a[_i];
                            fm.liveswitch.ArrayExtensions.addRange(list, list2);
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                AttributeCollection.prototype.tryGetAttribute = function (type, attribute) {
                    if (arguments.length == 2) {
                        var attributes = null;
                        var _var0 = new fm.liveswitch.Holder(attributes);
                        var _var1 = this.tryGetAttributes(type, _var0);
                        attributes = _var0.getValue();
                        if (_var1) {
                            if ((attributes.length > 0)) {
                                attribute.setValue(attributes[0]);
                                return true;
                            }
                            attribute.setValue(null);
                            return false;
                        }
                        attribute.setValue(null);
                        return false;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                AttributeCollection.prototype.tryGetAttributes = function (type, attributes) {
                    if (arguments.length == 2) {
                        var list = null;
                        var _var0 = new fm.liveswitch.Holder(list);
                        var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this.__attributes, new fm.liveswitch.sdp.AttributeTypeWrapper(type).toString(), _var0);
                        list = _var0.getValue();
                        if (_var1) {
                            var count = fm.liveswitch.ArrayExtensions.getCount(list);
                            attributes.setValue(new Array(count));
                            for (var i = 0; (i < count); i++) {
                                attributes.getValue()[i] = list[i];
                            }
                            return true;
                        }
                        attributes.setValue(new Array(0));
                        return false;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return AttributeCollection;
            }());
            sdp.AttributeCollection = AttributeCollection;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /** @hidden */
            var AttributeCreationArgs = /** @class */ (function () {
                function AttributeCreationArgs(value) {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var value_26 = __arguments[0];
                        //super();
                        if ((!fm.liveswitch.Global.equals(value_26, null))) {
                            value_26 = fm.liveswitch.StringExtensions.trim(value_26);
                        }
                        this.setValue(value_26);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                AttributeCreationArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.AttributeCreationArgs]';
                };
                AttributeCreationArgs.prototype.getValue = function () {
                    if (arguments.length == 0) {
                        return this._value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                AttributeCreationArgs.prototype.setValue = function (value) {
                    if (arguments.length == 1) {
                        this._value = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return AttributeCreationArgs;
            }());
            sdp.AttributeCreationArgs = AttributeCreationArgs;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /** @hidden */
            var AttributeRegistration = /** @class */ (function () {
                function AttributeRegistration(name, sessionLevel, mediaLevel, creationDelegate) {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 4) {
                        var name_14 = __arguments[0];
                        var sessionLevel_1 = __arguments[1];
                        var mediaLevel_1 = __arguments[2];
                        var creationDelegate_1 = __arguments[3];
                        //super();
                        this.fmliveswitchsdpAttributeRegistrationInit();
                        this.setName(name_14);
                        this.setSessionLevel(sessionLevel_1);
                        this.setMediaLevel(mediaLevel_1);
                        this.setCreationDelegate(creationDelegate_1);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                AttributeRegistration.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.AttributeRegistration]';
                };
                AttributeRegistration.prototype.fmliveswitchsdpAttributeRegistrationInit = function () {
                    this._mediaLevel = false;
                    this._sessionLevel = false;
                };
                AttributeRegistration.prototype.getCreationDelegate = function () {
                    if (arguments.length == 0) {
                        return this._creationDelegate;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                AttributeRegistration.prototype.getMediaLevel = function () {
                    if (arguments.length == 0) {
                        return this._mediaLevel;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                AttributeRegistration.prototype.getName = function () {
                    if (arguments.length == 0) {
                        return this._name;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                AttributeRegistration.prototype.getSessionLevel = function () {
                    if (arguments.length == 0) {
                        return this._sessionLevel;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                AttributeRegistration.prototype.setCreationDelegate = function (value) {
                    if (arguments.length == 1) {
                        this._creationDelegate = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                AttributeRegistration.prototype.setMediaLevel = function (value) {
                    if (arguments.length == 1) {
                        this._mediaLevel = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                AttributeRegistration.prototype.setName = function (value) {
                    if (arguments.length == 1) {
                        this._name = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                AttributeRegistration.prototype.setSessionLevel = function (value) {
                    if (arguments.length == 1) {
                        this._sessionLevel = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return AttributeRegistration;
            }());
            sdp.AttributeRegistration = AttributeRegistration;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var AttributeTypeWrapper = /** @class */ (function () {
                function AttributeTypeWrapper(value) {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var value_27 = __arguments[0];
                        //super();
                        this._value = value_27;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                AttributeTypeWrapper.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.AttributeTypeWrapper]';
                };
                AttributeTypeWrapper.prototype.toString = function () {
                    if (arguments.length == 0) {
                        if (this._value == fm.liveswitch.sdp.AttributeType.UnknownAttribute)
                            return 'UnknownAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.DirectionAttribute)
                            return 'DirectionAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.CategoryAttribute)
                            return 'CategoryAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.CharacterSetAttribute)
                            return 'CharacterSetAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.ConferenceTypeAttribute)
                            return 'ConferenceTypeAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.CryptoAttribute)
                            return 'CryptoAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.FormatParametersAttribute)
                            return 'FormatParametersAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.FrameRateAttribute)
                            return 'FrameRateAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.KeywordsAttribute)
                            return 'KeywordsAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.LanguageAttribute)
                            return 'LanguageAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.MaxPacketTimeAttribute)
                            return 'MaxPacketTimeAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.OrientationAttribute)
                            return 'OrientationAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.PacketTimeAttribute)
                            return 'PacketTimeAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.QualityAttribute)
                            return 'QualityAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.SdpLanguageAttribute)
                            return 'SdpLanguageAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.SetupAttribute)
                            return 'SetupAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.ToolAttribute)
                            return 'ToolAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.MediaStreamIdSemanticAttribute)
                            return 'MediaStreamIdSemanticAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.MediaStreamIdAttribute)
                            return 'MediaStreamIdAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.BundleOnlyAttribute)
                            return 'BundleOnlyAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.IceCandidateAttribute)
                            return 'IceCandidateAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.IceFingerprintAttribute)
                            return 'IceFingerprintAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.IceLiteAttribute)
                            return 'IceLiteAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.IceMismatchAttribute)
                            return 'IceMismatchAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.IceOptionsAttribute)
                            return 'IceOptionsAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.IcePasswordAttribute)
                            return 'IcePasswordAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.IceUfragAttribute)
                            return 'IceUfragAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.IceRemoteCandidatesAttribute)
                            return 'IceRemoteCandidatesAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.RtpMapAttribute)
                            return 'RtpMapAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.RtpSsrcAttribute)
                            return 'RtpSsrcAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.RtpExtMapAttribute)
                            return 'RtpExtMapAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.RtcpAttribute)
                            return 'RtcpAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.RtcpFeedbackAttribute)
                            return 'RtcpFeedbackAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.RtcpMuxAttribute)
                            return 'RtcpMuxAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.SctpPortAttribute)
                            return 'SctpPortAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.SctpMapAttribute)
                            return 'SctpMapAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.SctpMaxMessageSizeAttribute)
                            return 'SctpMaxMessageSizeAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.GroupAttribute)
                            return 'GroupAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.RtpRidAttribute)
                            return 'RtpRidAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.SimulcastAttribute)
                            return 'SimulcastAttribute';
                        if (this._value == fm.liveswitch.sdp.AttributeType.RtpSsrcGroupAttribute)
                            return 'RtpSsrcGroupAttribute';
                        return '';
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return AttributeTypeWrapper;
            }());
            sdp.AttributeTypeWrapper = AttributeTypeWrapper;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            An SDP bandwidth element.
            */
            var Bandwidth = /** @class */ (function () {
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.bandwidth]] class.
                @param bandwidthType The type of bandwidth. See [[fm.liveswitch.sdp.bandwidth.bandwidthType]] for possible values.
                @param value The bandwidth, typically in kilobits per second.
                */
                function Bandwidth(bandwidthType, value) {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 2) {
                        var bandwidthType_1 = __arguments[0];
                        var value_28 = __arguments[1];
                        //super();
                        this.fmliveswitchsdpBandwidthInit();
                        this.setBandwidthType(bandwidthType_1);
                        this.setValue(value_28);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                Bandwidth.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.Bandwidth]';
                };
                Bandwidth.prototype.fmliveswitchsdpBandwidthInit = function () {
                    this._value = 0;
                };
                /**
                Creates an [[fm.liveswitch.sdp.bandwidth]] instance from a string.
                @param s The string to parse.
                */
                Bandwidth.parse = function (s) {
                    if (arguments.length == 1) {
                        s = s.substring(2);
                        var strArray = fm.liveswitch.StringExtensions.split(s, [58]);
                        var bandwidthType = strArray[0];
                        return new fm.liveswitch.sdp.Bandwidth(bandwidthType, fm.liveswitch.ParseAssistant.parseLongValue(strArray[1]));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the type of bandwidth. See [[fm.liveswitch.sdp.bandwidth.bandwidthType]] for possible values.
                */
                Bandwidth.prototype.getBandwidthType = function () {
                    if (arguments.length == 0) {
                        return this._bandwidthType;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the bandwidth, typically in kilobits per second.
                */
                Bandwidth.prototype.getValue = function () {
                    if (arguments.length == 0) {
                        return this._value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Bandwidth.prototype.setBandwidthType = function (value) {
                    if (arguments.length == 1) {
                        this._bandwidthType = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Bandwidth.prototype.setValue = function (value) {
                    if (arguments.length == 1) {
                        this._value = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Converts this instance to a string.
                */
                Bandwidth.prototype.toString = function () {
                    if (arguments.length == 0) {
                        var builder = new fm.liveswitch.StringBuilder();
                        builder.append("b=");
                        builder.append(this.getBandwidthType());
                        builder.append(":");
                        builder.append(fm.liveswitch.NumberExtensions.toString(this.getValue()));
                        return builder.toString();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Bandwidth;
            }());
            sdp.Bandwidth = Bandwidth;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            Defines valid SDP bandwidth types.
            */
            var BandwidthType = /** @class */ (function () {
                function BandwidthType() {
                }
                BandwidthType.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.BandwidthType]';
                };
                /**
                Gets the SDP bandwidth type meaning "Application Specific".
                */
                BandwidthType.getApplicationSpecific = function () {
                    if (arguments.length == 0) {
                        return "AS";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP bandwidth type meaning "Conference Total".
                */
                BandwidthType.getConferenceTotal = function () {
                    if (arguments.length == 0) {
                        return "CT";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP bandwidth type meaning "RTCP Receivers".
                */
                BandwidthType.getRtcpReceivers = function () {
                    if (arguments.length == 0) {
                        return "RR";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP bandwidth type meaning "RTCP Senders".
                */
                BandwidthType.getRtcpSenders = function () {
                    if (arguments.length == 0) {
                        return "RS";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP bandwidth type meaning "Transport Independent Application Specific Maximum".
                */
                BandwidthType.getTransportIndependentApplicationSpecificMaximum = function () {
                    if (arguments.length == 0) {
                        return "TIAS";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return BandwidthType;
            }());
            sdp.BandwidthType = BandwidthType;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            An SDP encryption key element.
            */
            var EncryptionKey = /** @class */ (function () {
                function EncryptionKey() {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        //super();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                EncryptionKey.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.EncryptionKey]';
                };
                /**
                Creates an [[fm.liveswitch.sdp.encryptionKey]] instance from a string.
                @param s The string to parse.
                */
                EncryptionKey.parse = function (s) {
                    if (arguments.length == 1) {
                        var str = void 0;
                        var str2 = void 0;
                        s = s.substring(2);
                        var index = fm.liveswitch.StringExtensions.indexOf(s, ":");
                        if ((fm.liveswitch.Global.equals(index, -1))) {
                            str = s;
                            str2 = null;
                        }
                        else {
                            str = fm.liveswitch.StringExtensions.substring(s, 0, index);
                            str2 = s.substring((index + 1));
                        }
                        var _var0 = str;
                        if (_var0 == "clear") {
                            do {
                                return new fm.liveswitch.sdp.ClearEncryptionKey(str2);
                            } while (false);
                        }
                        else if (_var0 == "base64") {
                            do {
                                return new fm.liveswitch.sdp.Base64EncryptionKey(str2);
                            } while (false);
                        }
                        else if (_var0 == "uri") {
                            do {
                                try {
                                    return new fm.liveswitch.sdp.UriEncryptionKey(new fm.liveswitch.Uri(str2));
                                }
                                catch (exception1) {
                                    return null;
                                }
                                finally {
                                }
                            } while (false);
                        }
                        else if (_var0 == "prompt") {
                            do {
                                return new fm.liveswitch.sdp.PromptEncryptionKey();
                            } while (false);
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Converts this instance to a string.
                */
                EncryptionKey.prototype.toString = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.StringExtensions.concat("k=", this.getMethodAndValue());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return EncryptionKey;
            }());
            sdp.EncryptionKey = EncryptionKey;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/EncryptionKey.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            An SDP encryption key with a method of "base64".
            */
            var Base64EncryptionKey = /** @class */ (function (_super) {
                __extends(Base64EncryptionKey, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.base64EncryptionKey]] class.
                @param encodedEncryptionKey The base64-encoded encryption key.
                */
                function Base64EncryptionKey(encodedEncryptionKey) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var encodedEncryptionKey_1 = __arguments[0];
                        _this = _super.call(this) || this;
                        if ((fm.liveswitch.Global.equals(encodedEncryptionKey_1, null))) {
                            throw new fm.liveswitch.Exception("encodedEncryptionKey cannot be null.");
                        }
                        _this.setEncodedEncryptionKey(encodedEncryptionKey_1);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                Base64EncryptionKey.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.Base64EncryptionKey]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Gets the base64-encoded encryption key.
                */
                Base64EncryptionKey.prototype.getEncodedEncryptionKey = function () {
                    if (arguments.length == 0) {
                        return this._encodedEncryptionKey;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Base64EncryptionKey.prototype.getMethodAndValue = function () {
                    if (arguments.length == 0) {
                        var builder = new fm.liveswitch.StringBuilder();
                        builder.append("base64:");
                        builder.append(this.getEncodedEncryptionKey());
                        return builder.toString();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Base64EncryptionKey.prototype.setEncodedEncryptionKey = function (value) {
                    if (arguments.length == 1) {
                        this._encodedEncryptionKey = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Base64EncryptionKey;
            }(fm.liveswitch.sdp.EncryptionKey));
            sdp.Base64EncryptionKey = Base64EncryptionKey;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            Defined in draft-ietf-mmusic-sdp-bundle-negotiation. Attribute is used to identify that a gioven media description can only be used  in bundled group. Its formatting in SDP is described by the following BNF: Name: bundle-only  Value: N/A  Usage Level: media  Charset Dependent: no  Example:  a=bundle-only
            */
            var BundleOnlyAttribute = /** @class */ (function (_super) {
                __extends(BundleOnlyAttribute, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.bundleOnlyAttribute]] class.
                */
                function BundleOnlyAttribute() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.BundleOnlyAttribute);
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                BundleOnlyAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.BundleOnlyAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.groupAttribute]] class.
                @param value The attribute value.
                */
                BundleOnlyAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        return new fm.liveswitch.sdp.BundleOnlyAttribute();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                BundleOnlyAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return BundleOnlyAttribute;
            }(fm.liveswitch.sdp.Attribute));
            sdp.BundleOnlyAttribute = BundleOnlyAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            This attribute gives the dot-separated hierarchical category of the session.  This is to enable a receiver to filter unwanted sessions by category.  There is no central registry of categories.  It is a session-level attribute, and it is not dependent on charset.
            */
            var CategoryAttribute = /** @class */ (function (_super) {
                __extends(CategoryAttribute, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.categoryAttribute]] class.
                @param category The dot-separated hierarchical category of the session.
                */
                function CategoryAttribute(category) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var category_1 = __arguments[0];
                        _this = _super.call(this) || this;
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.CategoryAttribute);
                        if ((fm.liveswitch.Global.equals(category_1, null))) {
                            throw new fm.liveswitch.Exception("category cannot be null.");
                        }
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                        _this.setCategory(category_1);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                CategoryAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.CategoryAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.categoryAttribute]] class.
                @param value The attribute value.
                */
                CategoryAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        return new fm.liveswitch.sdp.CategoryAttribute(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                CategoryAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        return this.getCategory();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the dot-separated hierarchical category of the session.
                */
                CategoryAttribute.prototype.getCategory = function () {
                    if (arguments.length == 0) {
                        return this._category;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                CategoryAttribute.prototype.setCategory = function (value) {
                    if (arguments.length == 1) {
                        this._category = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return CategoryAttribute;
            }(fm.liveswitch.sdp.Attribute));
            sdp.CategoryAttribute = CategoryAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            This specifies the character set to be used to display the session name and information data.  By default, the ISO-10646 character set in UTF-8 encoding is used.  If a more compact representation is required, other character sets may be used. For example, the ISO 8859-1 is specified with the following SDP attribute:  a=charset:ISO-8859-1
            */
            var CharacterSetAttribute = /** @class */ (function (_super) {
                __extends(CharacterSetAttribute, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.characterSetAttribute]] class.
                @param characterSet The character set to be used to display the session name and information data.
                */
                function CharacterSetAttribute(characterSet) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var characterSet_1 = __arguments[0];
                        _this = _super.call(this) || this;
                        if ((fm.liveswitch.Global.equals(characterSet_1, null))) {
                            throw new fm.liveswitch.Exception("characterSet cannot be null.");
                        }
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.CharacterSetAttribute);
                        _this.setCharacterSet(characterSet_1);
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                CharacterSetAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.CharacterSetAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.characterSetAttribute]] class.
                @param value The attribute value.
                */
                CharacterSetAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        return new fm.liveswitch.sdp.CharacterSetAttribute(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                CharacterSetAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        return this.getCharacterSet();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the character set to be used to display the session name and information data.
                */
                CharacterSetAttribute.prototype.getCharacterSet = function () {
                    if (arguments.length == 0) {
                        return this._characterSet;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                CharacterSetAttribute.prototype.setCharacterSet = function (value) {
                    if (arguments.length == 1) {
                        this._characterSet = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return CharacterSetAttribute;
            }(fm.liveswitch.sdp.Attribute));
            sdp.CharacterSetAttribute = CharacterSetAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/EncryptionKey.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            An SDP encryption key with a method of "clear".
            */
            var ClearEncryptionKey = /** @class */ (function (_super) {
                __extends(ClearEncryptionKey, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.clearEncryptionKey]] class.
                @param encryptionKey The untransformed encryption key.
                */
                function ClearEncryptionKey(encryptionKey) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var encryptionKey_1 = __arguments[0];
                        _this = _super.call(this) || this;
                        if ((fm.liveswitch.Global.equals(encryptionKey_1, null))) {
                            throw new fm.liveswitch.Exception("encryptionKey cannot be null.");
                        }
                        _this.setEncryptionKey(encryptionKey_1);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClearEncryptionKey.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.ClearEncryptionKey]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Gets the untransformed encryption key.
                */
                ClearEncryptionKey.prototype.getEncryptionKey = function () {
                    if (arguments.length == 0) {
                        return this._encryptionKey;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                ClearEncryptionKey.prototype.getMethodAndValue = function () {
                    if (arguments.length == 0) {
                        var builder = new fm.liveswitch.StringBuilder();
                        builder.append("clear:");
                        builder.append(this.getEncryptionKey());
                        return builder.toString();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                ClearEncryptionKey.prototype.setEncryptionKey = function (value) {
                    if (arguments.length == 1) {
                        this._encryptionKey = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ClearEncryptionKey;
            }(fm.liveswitch.sdp.EncryptionKey));
            sdp.ClearEncryptionKey = ClearEncryptionKey;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            Defines valid SDP conference types.
            */
            var ConferenceType = /** @class */ (function () {
                function ConferenceType() {
                }
                ConferenceType.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.ConferenceType]';
                };
                /**
                Gets the SDP conference type meaning "Broadcast", which should imply receive-only.
                */
                ConferenceType.getBroadcast = function () {
                    if (arguments.length == 0) {
                        return "broadcast";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP conference type meaning "H332", which should imply receive-only and indicate that this loosely coupled session is part of an H.332 session.
                */
                ConferenceType.getH332 = function () {
                    if (arguments.length == 0) {
                        return "H332";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP conference type meaning "Meeting", which should imply send-receive.
                */
                ConferenceType.getMeeting = function () {
                    if (arguments.length == 0) {
                        return "meeting";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP conference type meaning "Moderated", which should indicate the use of a floor control tool and that the media tools are started so as to mute new sites joining the conference.
                */
                ConferenceType.getModerated = function () {
                    if (arguments.length == 0) {
                        return "moderated";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP conference type meaning "Test", which should imply that unless explicitly requested otherwise, receivers can safely avoid displaying this session description to users.
                */
                ConferenceType.getTest = function () {
                    if (arguments.length == 0) {
                        return "test";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ConferenceType;
            }());
            sdp.ConferenceType = ConferenceType;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            This specifies the type of the conference.  Suggested values are "broadcast", "meeting", "moderated", "test", and "H332". "recvonly" should be the default for "type:broadcast" sessions, "type:meeting" should imply "sendrecv", and "type:moderated" should indicate the use of a floor control tool and that the media tools are started so as to mute new sites joining the conference.
            */
            var ConferenceTypeAttribute = /** @class */ (function (_super) {
                __extends(ConferenceTypeAttribute, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.conferenceTypeAttribute]] class.
                @param conferenceType The type of the conference. See [[fm.liveswitch.sdp.conferenceTypeAttribute.conferenceType]] for possible values.
                */
                function ConferenceTypeAttribute(conferenceType) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var conferenceType_1 = __arguments[0];
                        _this = _super.call(this) || this;
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.ConferenceTypeAttribute);
                        if ((fm.liveswitch.Global.equals(conferenceType_1, null))) {
                            throw new fm.liveswitch.Exception("conferenceType cannot be null.");
                        }
                        _this.setConferenceType(conferenceType_1);
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ConferenceTypeAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.ConferenceTypeAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.conferenceTypeAttribute]] class.
                @param value The attribute value.
                */
                ConferenceTypeAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        return new fm.liveswitch.sdp.ConferenceTypeAttribute(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                ConferenceTypeAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        return this.getConferenceType();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the type of the conference. See [[fm.liveswitch.sdp.conferenceTypeAttribute.conferenceType]] for possible values.
                */
                ConferenceTypeAttribute.prototype.getConferenceType = function () {
                    if (arguments.length == 0) {
                        return this._conferenceType;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                ConferenceTypeAttribute.prototype.setConferenceType = function (value) {
                    if (arguments.length == 1) {
                        this._conferenceType = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ConferenceTypeAttribute;
            }(fm.liveswitch.sdp.Attribute));
            sdp.ConferenceTypeAttribute = ConferenceTypeAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            An SDP connection data element.
            */
            var ConnectionData = /** @class */ (function () {
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.connectionData]] class.
                @param connectionAddress The connection address.
                */
                function ConnectionData(connectionAddress) {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var connectionAddress_1 = __arguments[0];
                        //super();
                        if ((fm.liveswitch.Global.equals(connectionAddress_1, null))) {
                            throw new fm.liveswitch.Exception("connectionAddress cannot be null.");
                        }
                        this.update(connectionAddress_1);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                ConnectionData.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.ConnectionData]';
                };
                /**
                Creates an [[fm.liveswitch.sdp.connectionData]] instance from a string.
                @param s The string to parse.
                */
                ConnectionData.parse = function (s) {
                    if (arguments.length == 1) {
                        s = s.substring(2);
                        var strArray = fm.liveswitch.StringExtensions.split(s, [32]);
                        var connectionAddress = strArray[2];
                        var data = new fm.liveswitch.sdp.ConnectionData(connectionAddress);
                        data.setNetworkType(strArray[0]);
                        data.setAddressType(strArray[1]);
                        return data;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the type of the address. See [[fm.liveswitch.sdp.connectionData.addressType]] for possible values.
                */
                ConnectionData.prototype.getAddressType = function () {
                    if (arguments.length == 0) {
                        return this._addressType;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the connection address.
                */
                ConnectionData.prototype.getConnectionAddress = function () {
                    if (arguments.length == 0) {
                        return this._connectionAddress;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the type of network. See [[fm.liveswitch.sdp.connectionData.networkType]] for possible values.
                */
                ConnectionData.prototype.getNetworkType = function () {
                    if (arguments.length == 0) {
                        return this._networkType;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the type of the address. See [[fm.liveswitch.sdp.connectionData.addressType]] for possible values.
                */
                ConnectionData.prototype.setAddressType = function (value) {
                    if (arguments.length == 1) {
                        this._addressType = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the connection address.
                */
                ConnectionData.prototype.setConnectionAddress = function (value) {
                    if (arguments.length == 1) {
                        this._connectionAddress = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the type of network. See [[fm.liveswitch.sdp.connectionData.networkType]] for possible values.
                */
                ConnectionData.prototype.setNetworkType = function (value) {
                    if (arguments.length == 1) {
                        this._networkType = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Converts this instance to a string.
                */
                ConnectionData.prototype.toString = function () {
                    if (arguments.length == 0) {
                        var builder = new fm.liveswitch.StringBuilder();
                        builder.append("c=");
                        builder.append(this.getNetworkType());
                        builder.append(" ");
                        builder.append(this.getAddressType());
                        builder.append(" ");
                        builder.append(this.getConnectionAddress());
                        return builder.toString();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Updates the connection address.
                @param connectionAddress The connection address.
                */
                ConnectionData.prototype.update = function (connectionAddress) {
                    if (arguments.length == 1) {
                        this.setNetworkType(fm.liveswitch.sdp.NetworkType.getInternet());
                        this.setAddressType(fm.liveswitch.sdp.AddressType.getAddressTypeForAddress(connectionAddress));
                        this.setConnectionAddress(connectionAddress);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ConnectionData;
            }());
            sdp.ConnectionData = ConnectionData;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            This gives the maximum amount of media that can be encapsulated in each packet, expressed as time in milliseconds.  The time SHALL be calculated as the sum of the time the media present in the packet represents.  For frame-based codecs, the time SHOULD be an integer multiple of the frame size.  This attribute is probably only meaningful for audio data, but may be used with other media types if it makes sense.  It is a media-level attribute, and it is not dependent on charset.  Note that this attribute was introduced after RFC 2327, and non-updated implementations will ignore this attribute.
            */
            var CryptoAttribute = /** @class */ (function (_super) {
                __extends(CryptoAttribute, _super);
                function CryptoAttribute() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsdpCryptoAttributeInit();
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.CryptoAttribute);
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Transport);
                    }
                    else if (__arguments.length == 2) {
                        var tag = __arguments[0];
                        var cryptoSuite = __arguments[1];
                        // chained constructor: CryptoAttribute.call(this);
                        __arguments = new Array(0);
                        {
                            _this = _super.call(this) || this;
                            _this.fmliveswitchsdpCryptoAttributeInit();
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.CryptoAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Transport);
                        }
                        _this.setTag(tag);
                        _this.setCryptoSuite(cryptoSuite);
                        _this.setKeyParams({});
                        _this.setSessionParams(new Array());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                CryptoAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.CryptoAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                CryptoAttribute.prototype.fmliveswitchsdpCryptoAttributeInit = function () {
                    this._tag = 0;
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.cryptoAttribute]] class.
                @param value The attribute value.
                */
                CryptoAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        var strArray = void 0;
                        var index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                        var num2 = fm.liveswitch.ParseAssistant.parseIntegerValue(fm.liveswitch.StringExtensions.substring(value, 0, index));
                        value = value.substring((index + 1));
                        index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                        var str = fm.liveswitch.StringExtensions.substring(value, 0, index);
                        value = value.substring((index + 1));
                        var dictionary = {};
                        var list = new Array();
                        index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                        if ((fm.liveswitch.Global.equals(index, -1))) {
                            strArray = fm.liveswitch.StringExtensions.split(value, [59]);
                            for (var _i = 0, strArray_1 = strArray; _i < strArray_1.length; _i++) {
                                var str2 = strArray_1[_i];
                                var length_37 = fm.liveswitch.StringExtensions.indexOf(str2, ":");
                                if ((!fm.liveswitch.Global.equals(length_37, -1))) {
                                    var str3 = fm.liveswitch.StringExtensions.substring(str2, 0, length_37);
                                    var str4 = str2.substring((length_37 + 1));
                                    dictionary[str3] = str4;
                                }
                            }
                        }
                        else {
                            strArray = fm.liveswitch.StringExtensions.split(fm.liveswitch.StringExtensions.substring(value, 0, index), [59]);
                            for (var _a = 0, strArray_2 = strArray; _a < strArray_2.length; _a++) {
                                var str2 = strArray_2[_a];
                                var strArray2 = fm.liveswitch.StringExtensions.split(str2, [58]);
                                if ((fm.liveswitch.Global.equals(strArray2.length, 2))) {
                                    dictionary[strArray2[0]] = strArray2[1];
                                }
                            }
                            value = value.substring((index + 1));
                            var strArray3 = fm.liveswitch.StringExtensions.split(value, [32]);
                            for (var _b = 0, strArray3_1 = strArray3; _b < strArray3_1.length; _b++) {
                                var str5 = strArray3_1[_b];
                                fm.liveswitch.ArrayExtensions.add(list, str5);
                            }
                        }
                        var attribute = new fm.liveswitch.sdp.CryptoAttribute();
                        attribute.setTag(num2);
                        attribute.setCryptoSuite(str);
                        attribute.setKeyParams(dictionary);
                        attribute.setSessionParams(list);
                        return attribute;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                CryptoAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        var builder = new fm.liveswitch.StringBuilder();
                        builder.append(fm.liveswitch.NumberExtensions.toString(this.getTag()));
                        builder.append(" ");
                        builder.append(this.getCryptoSuite());
                        for (var _i = 0, _a = fm.liveswitch.HashExtensions.getKeys(this.getKeyParams()); _i < _a.length; _i++) {
                            var str = _a[_i];
                            builder.append(" ");
                            builder.append(str);
                            builder.append(":");
                            builder.append(this.getKeyParams()[str]);
                        }
                        for (var _b = 0, _c = this.getSessionParams(); _b < _c.length; _b++) {
                            var str2 = _c[_b];
                            builder.append(" ");
                            builder.append(str2);
                        }
                        return builder.toString();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the crypto suite. See [[fm.liveswitch.sdp.cryptoAttribute.cryptoSuite]] for possible values.
                */
                CryptoAttribute.prototype.getCryptoSuite = function () {
                    if (arguments.length == 0) {
                        return this._cryptoSuite;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the key from the "inline" key parameter.
                */
                CryptoAttribute.prototype.getKey = function () {
                    if (arguments.length == 0) {
                        if (((!fm.liveswitch.Global.equals(this.getCryptoSuite(), fm.liveswitch.sdp.CryptoSuite.getAesCM128HmacSha180())) && !(fm.liveswitch.Global.equals(this.getCryptoSuite(), fm.liveswitch.sdp.CryptoSuite.getAesCm128HmacSha132())))) {
                            throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Unrecognized crypto-suite: {0}.", this.getCryptoSuite()));
                        }
                        var s = this.getKeyParams()[fm.liveswitch.sdp.CryptoKeyMethod.getInline()];
                        var index = fm.liveswitch.StringExtensions.indexOf(s, "|");
                        if ((!fm.liveswitch.Global.equals(index, -1))) {
                            s = fm.liveswitch.StringExtensions.substring(s, 0, index);
                        }
                        var array = fm.liveswitch.Base64.decode(s);
                        if ((!fm.liveswitch.Global.equals(array.length, 30))) {
                            throw new fm.liveswitch.Exception("Unexpected key/salt length.");
                        }
                        return fm.liveswitch.DataBuffer.wrap(fm.liveswitch.BitAssistant.subArray(array, 0, 16));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the key parameters.
                */
                CryptoAttribute.prototype.getKeyParams = function () {
                    if (arguments.length == 0) {
                        return this._keyParams;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the salt from the "inline" key parameter.
                */
                CryptoAttribute.prototype.getSalt = function () {
                    if (arguments.length == 0) {
                        if (((!fm.liveswitch.Global.equals(this.getCryptoSuite(), fm.liveswitch.sdp.CryptoSuite.getAesCM128HmacSha180())) && !(fm.liveswitch.Global.equals(this.getCryptoSuite(), fm.liveswitch.sdp.CryptoSuite.getAesCm128HmacSha132())))) {
                            throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Unrecognized crypto-suite: {0}.", this.getCryptoSuite()));
                        }
                        var s = this.getKeyParams()[fm.liveswitch.sdp.CryptoKeyMethod.getInline()];
                        var index = fm.liveswitch.StringExtensions.indexOf(s, "|");
                        if ((!fm.liveswitch.Global.equals(index, -1))) {
                            s = fm.liveswitch.StringExtensions.substring(s, 0, index);
                        }
                        var array = fm.liveswitch.Base64.decode(s);
                        if ((!fm.liveswitch.Global.equals(array.length, 30))) {
                            throw new fm.liveswitch.Exception("Unexpected key/salt length.");
                        }
                        return fm.liveswitch.DataBuffer.wrap(fm.liveswitch.BitAssistant.subArray(array, 16, 14));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the session parameters.
                */
                CryptoAttribute.prototype.getSessionParams = function () {
                    if (arguments.length == 0) {
                        return this._sessionParams;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the tag.
                */
                CryptoAttribute.prototype.getTag = function () {
                    if (arguments.length == 0) {
                        return this._tag;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                CryptoAttribute.prototype.setCryptoSuite = function (value) {
                    if (arguments.length == 1) {
                        this._cryptoSuite = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                CryptoAttribute.prototype.setKeyParams = function (value) {
                    if (arguments.length == 1) {
                        this._keyParams = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the key and salt for the "inline" key parameter.
                @param key The key.
                @param salt The salt.
                */
                CryptoAttribute.prototype.setKeySalt = function (key, salt) {
                    if (arguments.length == 2) {
                        var num = void 0;
                        var b = new Uint8Array((key.length + salt.length));
                        for (num = 0; (num < key.length); num++) {
                            b[num] = key[num];
                        }
                        for (num = 0; (num < salt.length); num++) {
                            b[(key.length + num)] = salt[num];
                        }
                        this.getKeyParams()[fm.liveswitch.sdp.CryptoKeyMethod.getInline()] = fm.liveswitch.Base64.encode(b);
                        return this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                CryptoAttribute.prototype.setSessionParams = function (value) {
                    if (arguments.length == 1) {
                        this._sessionParams = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the tag.
                */
                CryptoAttribute.prototype.setTag = function (value) {
                    if (arguments.length == 1) {
                        this._tag = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return CryptoAttribute;
            }(fm.liveswitch.sdp.Attribute));
            sdp.CryptoAttribute = CryptoAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            Defines valid SDP crypto key methods.
            */
            var CryptoKeyMethod = /** @class */ (function () {
                function CryptoKeyMethod() {
                }
                CryptoKeyMethod.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.CryptoKeyMethod]';
                };
                /**
                Gets the SDP crypto key method meaning "inline".
                */
                CryptoKeyMethod.getInline = function () {
                    if (arguments.length == 0) {
                        return "inline";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return CryptoKeyMethod;
            }());
            sdp.CryptoKeyMethod = CryptoKeyMethod;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            Defines valid SDP crypto session parameters.
            */
            var CryptoSessionParam = /** @class */ (function () {
                function CryptoSessionParam() {
                }
                CryptoSessionParam.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.CryptoSessionParam]';
                };
                /**
                Gets the SDP crypto session parameter meaning "unauthenticated SRTP".
                */
                CryptoSessionParam.getUnauthenticatedSRTP = function () {
                    if (arguments.length == 0) {
                        return "UNAUTHENTICATED_SRTP";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP crypto session parameter meaning "unencrypted SRTCP".
                */
                CryptoSessionParam.getUnencryptedSRTCP = function () {
                    if (arguments.length == 0) {
                        return "UNENCRYPTED_SRTCP";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP crypto session parameter meaning "unencrypted SRTP".
                */
                CryptoSessionParam.getUnencryptedSRTP = function () {
                    if (arguments.length == 0) {
                        return "UNENCRYPTED_SRTP";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return CryptoSessionParam;
            }());
            sdp.CryptoSessionParam = CryptoSessionParam;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            Defines valid SDP crypto suites.
            */
            var CryptoSuite = /** @class */ (function () {
                function CryptoSuite() {
                }
                CryptoSuite.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.CryptoSuite]';
                };
                /**
                Gets the SDP crypto suite meaning "AES-CM 128-bit cipher and HMAC-SHA1 message authentication with a 32-bit authentication tag".
                */
                CryptoSuite.getAesCm128HmacSha132 = function () {
                    if (arguments.length == 0) {
                        return "AES_CM_128_HMAC_SHA1_32";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP crypto suite meaning "AES-CM 128-bit cipher and HMAC-SHA1 message authentication with an 80-bit authentication tag".
                */
                CryptoSuite.getAesCM128HmacSha180 = function () {
                    if (arguments.length == 0) {
                        return "AES_CM_128_HMAC_SHA1_80";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Converts an EncryptionMode enum to a crypto-suite string.
                @param encryptionMode The EncryptionMode enum.
                @return The crypto-suite string.
                */
                CryptoSuite.getCryptoSuite = function (encryptionMode) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(encryptionMode, fm.liveswitch.EncryptionMode.Aes128Strong))) {
                            return fm.liveswitch.sdp.CryptoSuite.getAesCM128HmacSha180();
                        }
                        if ((fm.liveswitch.Global.equals(encryptionMode, fm.liveswitch.EncryptionMode.Aes128Weak))) {
                            return fm.liveswitch.sdp.CryptoSuite.getAesCm128HmacSha132();
                        }
                        if ((fm.liveswitch.Global.equals(encryptionMode, fm.liveswitch.EncryptionMode.NullStrong))) {
                            return fm.liveswitch.sdp.CryptoSuite.getNullHmacSha180();
                        }
                        if ((fm.liveswitch.Global.equals(encryptionMode, fm.liveswitch.EncryptionMode.NullWeak))) {
                            return fm.liveswitch.sdp.CryptoSuite.getNullHmacSha132();
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Converts a crypto-suite string to an EncryptionMode enum.
                @param cryptoSuite The crypto-suite string.
                @return The EncryptionMode enum.
                */
                CryptoSuite.getEncryptionMode = function (cryptoSuite) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(cryptoSuite, fm.liveswitch.sdp.CryptoSuite.getAesCM128HmacSha180()))) {
                            return fm.liveswitch.EncryptionMode.Aes128Strong;
                        }
                        if ((fm.liveswitch.Global.equals(cryptoSuite, fm.liveswitch.sdp.CryptoSuite.getAesCm128HmacSha132()))) {
                            return fm.liveswitch.EncryptionMode.Aes128Weak;
                        }
                        if ((fm.liveswitch.Global.equals(cryptoSuite, fm.liveswitch.sdp.CryptoSuite.getNullHmacSha180()))) {
                            return fm.liveswitch.EncryptionMode.NullStrong;
                        }
                        if ((fm.liveswitch.Global.equals(cryptoSuite, fm.liveswitch.sdp.CryptoSuite.getNullHmacSha132()))) {
                            return fm.liveswitch.EncryptionMode.NullWeak;
                        }
                        return fm.liveswitch.EncryptionMode.Null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP crypto suite meaning "NULL cipher and HMAC-SHA1 message authentication with a 32-bit authentication tag".
                */
                CryptoSuite.getNullHmacSha132 = function () {
                    if (arguments.length == 0) {
                        return "NULL_HMAC_SHA1_32";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP crypto suite meaning "NULL cipher and HMAC-SHA1 message authentication with an 80-bit authentication tag".
                */
                CryptoSuite.getNullHmacSha180 = function () {
                    if (arguments.length == 0) {
                        return "NULL_HMAC_SHA1_80";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return CryptoSuite;
            }());
            sdp.CryptoSuite = CryptoSuite;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            This specifies the mode in which tools should be started.
            */
            var DirectionAttribute = /** @class */ (function (_super) {
                __extends(DirectionAttribute, _super);
                function DirectionAttribute() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                DirectionAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.DirectionAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Creates a DirectionAttribute for a required direction.
                @param direction Direction.
                */
                DirectionAttribute.generateDirectionAttribute = function (direction) {
                    if (arguments.length == 1) {
                        if (((fm.liveswitch.Global.equals(direction, fm.liveswitch.StreamDirection.Inactive)) || (fm.liveswitch.Global.equals(direction, fm.liveswitch.StreamDirection.Unset)))) {
                            if ((fm.liveswitch.Global.equals(direction, fm.liveswitch.StreamDirection.Unset))) {
                                fm.liveswitch.Log.debug("Attempted to create Sdp Direction attribute with unset direction. Creating Inactive direction attribute instead.");
                            }
                            return new fm.liveswitch.sdp.InactiveAttribute();
                        }
                        if ((fm.liveswitch.Global.equals(direction, fm.liveswitch.StreamDirection.SendOnly))) {
                            return new fm.liveswitch.sdp.SendOnlyAttribute();
                        }
                        if ((fm.liveswitch.Global.equals(direction, fm.liveswitch.StreamDirection.ReceiveOnly))) {
                            return new fm.liveswitch.sdp.ReceiveOnlyAttribute();
                        }
                        if ((!fm.liveswitch.Global.equals(direction, fm.liveswitch.StreamDirection.SendReceive))) {
                            throw new fm.liveswitch.Exception("Unexpected Sdp.StreamDirection");
                        }
                        return new fm.liveswitch.sdp.SendReceiveAttribute();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return DirectionAttribute;
            }(fm.liveswitch.sdp.Attribute));
            sdp.DirectionAttribute = DirectionAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            This attribute allows parameters that are specific to a particular format to be conveyed in a way that SDP does not have to understand them.  The format must be one of the formats specified for the media.  Format-specific parameters may be any set of parameters required to be conveyed by SDP and given unchanged to the media tool that will use this format.  At most one instance of this attribute is allowed for each format.
            */
            var FormatParametersAttribute = /** @class */ (function (_super) {
                __extends(FormatParametersAttribute, _super);
                function FormatParametersAttribute() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsdpFormatParametersAttributeInit();
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.FormatParametersAttribute);
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.IdenticalPerPT);
                    }
                    else if (__arguments.length == 1) {
                        var format = __arguments[0];
                        // chained constructor: FormatParametersAttribute.call(this, format, null);
                        __arguments = new Array(2);
                        __arguments[0] = format;
                        __arguments[1] = null;
                        {
                            var format_1 = __arguments[0];
                            var formatSpecificParameters = __arguments[1];
                            // chained constructor: FormatParametersAttribute.call(this);
                            __arguments = new Array(0);
                            {
                                _this = _super.call(this) || this;
                                _this.fmliveswitchsdpFormatParametersAttributeInit();
                                _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.FormatParametersAttribute);
                                _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.IdenticalPerPT);
                            }
                            _this.setFormat(format_1);
                            _this.setFormatSpecificParameters(formatSpecificParameters);
                        }
                    }
                    else if (__arguments.length == 2) {
                        var format = __arguments[0];
                        var formatSpecificParameters = __arguments[1];
                        // chained constructor: FormatParametersAttribute.call(this);
                        __arguments = new Array(0);
                        {
                            _this = _super.call(this) || this;
                            _this.fmliveswitchsdpFormatParametersAttributeInit();
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.FormatParametersAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.IdenticalPerPT);
                        }
                        _this.setFormat(format);
                        _this.setFormatSpecificParameters(formatSpecificParameters);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                FormatParametersAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.FormatParametersAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                FormatParametersAttribute.prototype.fmliveswitchsdpFormatParametersAttributeInit = function () {
                    this._format = 0;
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.formatParametersAttribute]] class.
                @param value The attribute value.
                */
                FormatParametersAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        var index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                        var num2 = fm.liveswitch.ParseAssistant.parseIntegerValue(fm.liveswitch.StringExtensions.substring(value, 0, index));
                        var str = value.substring((index + 1));
                        var attribute = new fm.liveswitch.sdp.FormatParametersAttribute();
                        attribute.setFormat(num2);
                        attribute.setFormatSpecificParameters(str);
                        return attribute;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Creates a dictionary map from the format specific parameters.
                */
                FormatParametersAttribute.prototype.deserializeFormatSpecificParameters = function () {
                    if (arguments.length == 0) {
                        var dictionary = {};
                        var formatSpecificParameters = this.getFormatSpecificParameters();
                        if ((!fm.liveswitch.Global.equals(formatSpecificParameters, null))) {
                            var strArray = fm.liveswitch.StringExtensions.split(formatSpecificParameters, [59]);
                            for (var _i = 0, strArray_3 = strArray; _i < strArray_3.length; _i++) {
                                var str2 = strArray_3[_i];
                                var strArray2 = fm.liveswitch.StringExtensions.split(fm.liveswitch.StringExtensions.trim(str2), [61]);
                                if ((fm.liveswitch.Global.equals(strArray2.length, 1))) {
                                    dictionary[strArray2[0]] = null;
                                }
                                else {
                                    dictionary[strArray2[0]] = strArray2[1];
                                }
                            }
                        }
                        return dictionary;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                FormatParametersAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        var builder = new fm.liveswitch.StringBuilder();
                        builder.append(fm.liveswitch.NumberExtensions.toString(this.getFormat()));
                        builder.append(" ");
                        builder.append(this.getFormatSpecificParameters());
                        return builder.toString();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the format.
                */
                FormatParametersAttribute.prototype.getFormat = function () {
                    if (arguments.length == 0) {
                        return this._format;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets a format specific parameter.
                @param key The key.
                */
                FormatParametersAttribute.prototype.getFormatSpecificParameter = function (key) {
                    if (arguments.length == 1) {
                        return this.deserializeFormatSpecificParameters()[key];
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the format-specific parameters.
                */
                FormatParametersAttribute.prototype.getFormatSpecificParameters = function () {
                    if (arguments.length == 0) {
                        return this._formatSpecificParameters;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Updates the format specific parameters based on a dictionary map.
                @param map The map.
                */
                FormatParametersAttribute.prototype.serializeFormatSpecificParameters = function (map) {
                    if (arguments.length == 1) {
                        var list = new Array();
                        for (var _i = 0, _a = fm.liveswitch.HashExtensions.getKeys(map); _i < _a.length; _i++) {
                            var str = _a[_i];
                            if ((fm.liveswitch.Global.equals(map[str], null))) {
                                fm.liveswitch.ArrayExtensions.add(list, str);
                            }
                            else {
                                fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.join("=", [str, map[str]]));
                            }
                        }
                        this.setFormatSpecificParameters(fm.liveswitch.StringExtensions.join(";", fm.liveswitch.ArrayExtensions.toArray(list)));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the format.
                */
                FormatParametersAttribute.prototype.setFormat = function (value) {
                    if (arguments.length == 1) {
                        this._format = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets a format specific parameter.
                @param key The key.
                @param value The value.
                */
                FormatParametersAttribute.prototype.setFormatSpecificParameter = function (key, value) {
                    if (arguments.length == 2) {
                        var map = this.deserializeFormatSpecificParameters();
                        map[key] = value;
                        this.serializeFormatSpecificParameters(map);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                FormatParametersAttribute.prototype.setFormatSpecificParameters = function (value) {
                    if (arguments.length == 1) {
                        this._formatSpecificParameters = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Tries to get a format specific parameter.
                @param key The key.
                @param value The value.
                */
                FormatParametersAttribute.prototype.tryGetFormatSpecificParameter = function (key, value) {
                    if (arguments.length == 2) {
                        var dictionary = this.deserializeFormatSpecificParameters();
                        value.setValue(null);
                        var _var0 = fm.liveswitch.HashExtensions.tryGetValue(dictionary, key, value);
                        return _var0;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Unsets a format specific parameter.
                @param key The key.
                */
                FormatParametersAttribute.prototype.unsetFormatSpecificParameter = function (key) {
                    if (arguments.length == 1) {
                        var map = this.deserializeFormatSpecificParameters();
                        if (fm.liveswitch.HashExtensions.remove(map, key)) {
                            this.serializeFormatSpecificParameters(map);
                            return true;
                        }
                        return false;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return FormatParametersAttribute;
            }(fm.liveswitch.sdp.Attribute));
            sdp.FormatParametersAttribute = FormatParametersAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            This gives the maximum video frame rate in frames/sec.  It is intended as a recommendation for the encoding of video data. Decimal representations of fractional values using the notation "integer.fraction" are allowed.  It is a media-level attribute, defined only for video media, and it is not dependent on charset.
            */
            var FrameRateAttribute = /** @class */ (function (_super) {
                __extends(FrameRateAttribute, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.frameRateAttribute]] class.
                @param frameRate The maximum video frame rate in frames/second.
                */
                function FrameRateAttribute(frameRate) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var frameRate_2 = __arguments[0];
                        _this = _super.call(this) || this;
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.FrameRateAttribute);
                        if ((fm.liveswitch.Global.equals(frameRate_2, null))) {
                            throw new fm.liveswitch.Exception("frameRate cannot be null.");
                        }
                        _this.setFrameRate(frameRate_2);
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.IdenticalPerPT);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                FrameRateAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.FrameRateAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.frameRateAttribute]] class.
                @param value The attribute value.
                */
                FrameRateAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        return new fm.liveswitch.sdp.FrameRateAttribute(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                FrameRateAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        return this.getFrameRate();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the maximum video frame rate in frames/second.
                */
                FrameRateAttribute.prototype.getFrameRate = function () {
                    if (arguments.length == 0) {
                        return this._frameRate;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                FrameRateAttribute.prototype.setFrameRate = function (value) {
                    if (arguments.length == 1) {
                        this._frameRate = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return FrameRateAttribute;
            }(fm.liveswitch.sdp.Attribute));
            sdp.FrameRateAttribute = FrameRateAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            A bundle group of SDP Media Description elements.
            */
            var BundleGroup = /** @class */ (function () {
                /**
                Creates a BundleGroup object.
                @param groupType
                */
                function BundleGroup(groupType) {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var groupType_1 = __arguments[0];
                        //super();
                        this.fmliveswitchsdpBundleGroupInit();
                        this.__mediaDescriptions = new Array();
                        this.__mids = new Array();
                        this.setGroupType(groupType_1);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                BundleGroup.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.BundleGroup]';
                };
                BundleGroup.prototype.fmliveswitchsdpBundleGroupInit = function () {
                    this._bundleOnly = false;
                };
                /**
                Adds a media description to this bundle group.
                @param mediaDescription
                */
                BundleGroup.prototype.addMediaDescription = function (mediaDescription) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__mediaDescriptions, mediaDescription);
                        if ((fm.liveswitch.Global.equals(this.getTaggedMSection(), null))) {
                            this.setTaggedMSection(mediaDescription);
                        }
                        var mediaStreamIdentifierAttribute = mediaDescription.getMediaStreamIdentifierAttribute();
                        if ((fm.liveswitch.Global.equals(mediaStreamIdentifierAttribute, null))) {
                            throw new fm.liveswitch.Exception("SDP Media Stream Identifier Attribute missing for media description in bundle group.");
                        }
                        fm.liveswitch.ArrayExtensions.add(this.__mids, mediaStreamIdentifierAttribute.getIdentificationTag());
                        if (mediaDescription.getBundleOnly()) {
                            this.setBundleOnly(true);
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets a value indicating whether this group contains Bundle-only elements.
                */
                BundleGroup.prototype.getBundleOnly = function () {
                    if (arguments.length == 0) {
                        return this._bundleOnly;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the semntic type of this group.
                */
                BundleGroup.prototype.getGroupType = function () {
                    if (arguments.length == 0) {
                        return this._groupType;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the mecia descriptions in this bundle group.
                */
                BundleGroup.prototype.getMediaDescriptions = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.ArrayExtensions.toArray(this.__mediaDescriptions);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets media description identifiers associated with this bundle group.
                */
                BundleGroup.prototype.getMids = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.ArrayExtensions.toArray(this.__mids);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the tagged m-section of this bundle group.
                */
                BundleGroup.prototype.getTaggedMSection = function () {
                    if (arguments.length == 0) {
                        return this._taggedMSection;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                BundleGroup.prototype.setBundleOnly = function (value) {
                    if (arguments.length == 1) {
                        this._bundleOnly = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                BundleGroup.prototype.setGroupType = function (value) {
                    if (arguments.length == 1) {
                        this._groupType = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the tagged m-section of this bundle group.
                */
                BundleGroup.prototype.setTaggedMSection = function (value) {
                    if (arguments.length == 1) {
                        this._taggedMSection = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return BundleGroup;
            }());
            sdp.BundleGroup = BundleGroup;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            Defined in RFC 3388. Attribute is used for grouping together different media streams. Its formatting in SDP is described by the following BNF: group-attribute    = "a=group:" semantics * (space identification-tag) semantics          = "LS" | "FID" | "BUNDLE"
            */
            var GroupAttribute = /** @class */ (function (_super) {
                __extends(GroupAttribute, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.groupAttribute]] class.
                @param type The semantics type.
                @param ids Group identification ID tags.
                */
                function GroupAttribute(type, ids) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 2) {
                        var type_5 = __arguments[0];
                        var ids_2 = __arguments[1];
                        _this = _super.call(this) || this;
                        _this.setSemantics(type_5);
                        _this.setIds(ids_2);
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.GroupAttribute);
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                GroupAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.GroupAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.groupAttribute]] class.
                @param value The attribute value.
                */
                GroupAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        var strArray = fm.liveswitch.StringExtensions.split(value, [32]);
                        var str = strArray[0];
                        var unknown = fm.liveswitch.sdp.GroupSemanticsType.Unknown;
                        var ids = new Array((strArray.length - 1));
                        if ((fm.liveswitch.Global.equals(str, "BUNDLE"))) {
                            unknown = fm.liveswitch.sdp.GroupSemanticsType.Bundling;
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(str, "FID"))) {
                                unknown = fm.liveswitch.sdp.GroupSemanticsType.FlowIdentification;
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "LS"))) {
                                    unknown = fm.liveswitch.sdp.GroupSemanticsType.LipSynchronization;
                                }
                                else {
                                    unknown = fm.liveswitch.sdp.GroupSemanticsType.Unknown;
                                }
                            }
                        }
                        for (var i = 1; (i < strArray.length); i++) {
                            ids[(i - 1)] = strArray[i];
                        }
                        return new fm.liveswitch.sdp.GroupAttribute(unknown, ids);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                GroupAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        var str = "";
                        if ((fm.liveswitch.Global.equals(this.getSemantics(), fm.liveswitch.sdp.GroupSemanticsType.Bundling))) {
                            str = "BUNDLE";
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(this.getSemantics(), fm.liveswitch.sdp.GroupSemanticsType.FlowIdentification))) {
                                str = "FID";
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(this.getSemantics(), fm.liveswitch.sdp.GroupSemanticsType.LipSynchronization))) {
                                    str = "LS";
                                }
                                else {
                                    str = "";
                                }
                            }
                        }
                        for (var _i = 0, _a = this.getIds(); _i < _a.length; _i++) {
                            var str2 = _a[_i];
                            str = fm.liveswitch.StringExtensions.concat(str, " ", str2);
                        }
                        return str;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the group identification tags.
                */
                GroupAttribute.prototype.getIds = function () {
                    if (arguments.length == 0) {
                        return this._ids;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the semantics.
                */
                GroupAttribute.prototype.getSemantics = function () {
                    if (arguments.length == 0) {
                        return this._semantics;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                GroupAttribute.prototype.setIds = function (value) {
                    if (arguments.length == 1) {
                        this._ids = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                GroupAttribute.prototype.setSemantics = function (value) {
                    if (arguments.length == 1) {
                        this._semantics = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return GroupAttribute;
            }(fm.liveswitch.sdp.Attribute));
            sdp.GroupAttribute = GroupAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var GroupSemanticsTypeWrapper = /** @class */ (function () {
                function GroupSemanticsTypeWrapper(value) {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var value_29 = __arguments[0];
                        //super();
                        this._value = value_29;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                GroupSemanticsTypeWrapper.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.GroupSemanticsTypeWrapper]';
                };
                GroupSemanticsTypeWrapper.prototype.toString = function () {
                    if (arguments.length == 0) {
                        if (this._value == fm.liveswitch.sdp.GroupSemanticsType.LipSynchronization)
                            return 'LipSynchronization';
                        if (this._value == fm.liveswitch.sdp.GroupSemanticsType.FlowIdentification)
                            return 'FlowIdentification';
                        if (this._value == fm.liveswitch.sdp.GroupSemanticsType.Bundling)
                            return 'Bundling';
                        if (this._value == fm.liveswitch.sdp.GroupSemanticsType.Unknown)
                            return 'Unknown';
                        return '';
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return GroupSemanticsTypeWrapper;
            }());
            sdp.GroupSemanticsTypeWrapper = GroupSemanticsTypeWrapper;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var ice;
            (function (ice) {
                /**
                The candidate attribute is a media-level attribute only.  It contains a transport address for a candidate that can be used for connectivity checks.
                */
                var CandidateAttribute = /** @class */ (function (_super) {
                    __extends(CandidateAttribute, _super);
                    function CandidateAttribute() {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            _this = _super.call(this) || this;
                            _this.fmliveswitchsdpiceCandidateAttributeInit();
                            _this.__foundation = fm.liveswitch.StringExtensions.empty;
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.IceCandidateAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Transport);
                        }
                        else if (__arguments.length == 6) {
                            var foundation = __arguments[0];
                            var priority = __arguments[1];
                            var connectionAddress = __arguments[2];
                            var port = __arguments[3];
                            var candidateType = __arguments[4];
                            var componentId = __arguments[5];
                            // chained constructor: CandidateAttribute.call(this, foundation, priority, connectionAddress, port, candidateType, null, 0, "udp", componentId);
                            __arguments = new Array(9);
                            __arguments[0] = foundation;
                            __arguments[1] = priority;
                            __arguments[2] = connectionAddress;
                            __arguments[3] = port;
                            __arguments[4] = candidateType;
                            __arguments[5] = null;
                            __arguments[6] = 0;
                            __arguments[7] = "udp";
                            __arguments[8] = componentId;
                            {
                                var foundation_1 = __arguments[0];
                                var priority_1 = __arguments[1];
                                var connectionAddress_2 = __arguments[2];
                                var port_1 = __arguments[3];
                                var candidateType_1 = __arguments[4];
                                var relatedAddress = __arguments[5];
                                var relatedPort = __arguments[6];
                                var protocol = __arguments[7];
                                var componentId_1 = __arguments[8];
                                // chained constructor: CandidateAttribute.call(this);
                                __arguments = new Array(0);
                                {
                                    _this = _super.call(this) || this;
                                    _this.fmliveswitchsdpiceCandidateAttributeInit();
                                    _this.__foundation = fm.liveswitch.StringExtensions.empty;
                                    _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.IceCandidateAttribute);
                                    _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Transport);
                                }
                                _this.setFoundation(foundation_1);
                                _this.setProtocol(protocol);
                                _this.setPriority(priority_1);
                                _this.setConnectionAddress(connectionAddress_2);
                                _this.setPort(port_1);
                                _this.setCandidateType(candidateType_1);
                                _this.setRelatedAddress(relatedAddress);
                                _this.setRelatedPort(relatedPort);
                                _this.setComponentId(componentId_1);
                                _this.setExtensions({});
                            }
                        }
                        else if (__arguments.length == 9) {
                            var foundation = __arguments[0];
                            var priority = __arguments[1];
                            var connectionAddress = __arguments[2];
                            var port = __arguments[3];
                            var candidateType = __arguments[4];
                            var relatedAddress = __arguments[5];
                            var relatedPort = __arguments[6];
                            var protocol = __arguments[7];
                            var componentId = __arguments[8];
                            // chained constructor: CandidateAttribute.call(this);
                            __arguments = new Array(0);
                            {
                                _this = _super.call(this) || this;
                                _this.fmliveswitchsdpiceCandidateAttributeInit();
                                _this.__foundation = fm.liveswitch.StringExtensions.empty;
                                _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.IceCandidateAttribute);
                                _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Transport);
                            }
                            _this.setFoundation(foundation);
                            _this.setProtocol(protocol);
                            _this.setPriority(priority);
                            _this.setConnectionAddress(connectionAddress);
                            _this.setPort(port);
                            _this.setCandidateType(candidateType);
                            _this.setRelatedAddress(relatedAddress);
                            _this.setRelatedPort(relatedPort);
                            _this.setComponentId(componentId);
                            _this.setExtensions({});
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    CandidateAttribute.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.ice.CandidateAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    CandidateAttribute.prototype.fmliveswitchsdpiceCandidateAttributeInit = function () {
                        this._componentId = 0;
                        this._port = 0;
                        this._priority = 0;
                        this._relatedPort = 0;
                    };
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.ice.candidateAttribute]] class.
                    @param value The attribute as a string.
                    */
                    CandidateAttribute.fromAttributeValue = function (value) {
                        if (arguments.length == 1) {
                            var index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                            var str = fm.liveswitch.StringExtensions.substring(value, 0, index);
                            value = value.substring((index + 1));
                            index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                            var num2 = fm.liveswitch.ParseAssistant.parseIntegerValue(fm.liveswitch.StringExtensions.substring(value, 0, index));
                            value = value.substring((index + 1));
                            index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                            var str2 = fm.liveswitch.StringExtensions.toLower(fm.liveswitch.StringExtensions.substring(value, 0, index));
                            value = value.substring((index + 1));
                            index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                            var num3 = fm.liveswitch.ParseAssistant.parseLongValue(fm.liveswitch.StringExtensions.substring(value, 0, index));
                            value = value.substring((index + 1));
                            index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                            var str3 = fm.liveswitch.StringExtensions.substring(value, 0, index);
                            value = value.substring((index + 1));
                            index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                            var num4 = fm.liveswitch.ParseAssistant.parseIntegerValue(fm.liveswitch.StringExtensions.substring(value, 0, index));
                            value = value.substring((index + 1));
                            var dictionary = {};
                            var strArray = fm.liveswitch.StringExtensions.split(value, [32]);
                            var length_38 = strArray.length;
                            var str4 = null;
                            var str5 = null;
                            var num6 = 0;
                            if ((fm.liveswitch.Global.equals((length_38 % 2), 1))) {
                                length_38--;
                            }
                            for (var i = 0; (i < length_38); i = (i + 2)) {
                                var str6 = strArray[i];
                                var s = strArray[(i + 1)];
                                if ((fm.liveswitch.Global.equals(str6, "typ"))) {
                                    str4 = s;
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str6, "raddr"))) {
                                        str5 = s;
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str6, "rport"))) {
                                            num6 = fm.liveswitch.ParseAssistant.parseIntegerValue(s);
                                        }
                                        else {
                                            dictionary[str6] = s;
                                        }
                                    }
                                }
                            }
                            var attribute = new fm.liveswitch.sdp.ice.CandidateAttribute();
                            attribute.setFoundation(str);
                            attribute.setComponentId(num2);
                            attribute.setProtocol(str2);
                            attribute.setPriority(num3);
                            attribute.setConnectionAddress(str3);
                            attribute.setPort(num4);
                            attribute.setExtensions(dictionary);
                            attribute.setCandidateType(str4);
                            attribute.setRelatedAddress(str5);
                            attribute.setRelatedPort(num6);
                            return attribute;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the value of the attribute.
                    */
                    CandidateAttribute.prototype.getAttributeValue = function () {
                        if (arguments.length == 0) {
                            var builder = new fm.liveswitch.StringBuilder();
                            builder.append(this.getFoundation());
                            builder.append(" ");
                            builder.append(fm.liveswitch.NumberExtensions.toString(this.getComponentId()));
                            builder.append(" ");
                            builder.append(this.getProtocol());
                            builder.append(" ");
                            builder.append(fm.liveswitch.NumberExtensions.toString(this.getPriority()));
                            builder.append(" ");
                            builder.append(this.getConnectionAddress());
                            builder.append(" ");
                            builder.append(fm.liveswitch.NumberExtensions.toString(this.getPort()));
                            builder.append(" ");
                            builder.append("typ");
                            builder.append(" ");
                            builder.append(this.getCandidateType());
                            if (((!fm.liveswitch.Global.equals(this.getCandidateType(), fm.liveswitch.sdp.ice.CandidateType.getHost())) && (!fm.liveswitch.Global.equals(this.getRelatedAddress(), null)))) {
                                builder.append(" ");
                                builder.append("raddr");
                                builder.append(" ");
                                builder.append(this.getRelatedAddress());
                                builder.append(" ");
                                builder.append("rport");
                                builder.append(" ");
                                builder.append(fm.liveswitch.NumberExtensions.toString(this.getRelatedPort()));
                            }
                            for (var _i = 0, _a = fm.liveswitch.HashExtensions.getKeys(this.getExtensions()); _i < _a.length; _i++) {
                                var str = _a[_i];
                                builder.append(" ");
                                builder.append(str);
                                builder.append(" ");
                                builder.append(this.getExtensions()[str]);
                            }
                            return builder.toString();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the type of the candidate. See [[fm.liveswitch.sdp.ice.candidateAttribute.candidateType]] for possible values.
                    */
                    CandidateAttribute.prototype.getCandidateType = function () {
                        if (arguments.length == 0) {
                            return this.__candidateType;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the ID of the component for which this is a candidate.
                    */
                    CandidateAttribute.prototype.getComponentId = function () {
                        if (arguments.length == 0) {
                            return this._componentId;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the IP address of the candidate.
                    */
                    CandidateAttribute.prototype.getConnectionAddress = function () {
                        if (arguments.length == 0) {
                            return this.__connectionAddress;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the extensions.
                    */
                    CandidateAttribute.prototype.getExtensions = function () {
                        if (arguments.length == 0) {
                            return this._extensions;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the candidate's foundation.
                    */
                    CandidateAttribute.prototype.getFoundation = function () {
                        if (arguments.length == 0) {
                            return this.__foundation;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the port of the candidate.
                    */
                    CandidateAttribute.prototype.getPort = function () {
                        if (arguments.length == 0) {
                            return this._port;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the priority of the candidate.
                    */
                    CandidateAttribute.prototype.getPriority = function () {
                        if (arguments.length == 0) {
                            return this._priority;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the protocol of this candidate.
                    */
                    CandidateAttribute.prototype.getProtocol = function () {
                        if (arguments.length == 0) {
                            return this._protocol;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the IP address related to the candidate.
                    */
                    CandidateAttribute.prototype.getRelatedAddress = function () {
                        if (arguments.length == 0) {
                            return this._relatedAddress;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the port related to the candidate.
                    */
                    CandidateAttribute.prototype.getRelatedPort = function () {
                        if (arguments.length == 0) {
                            return this._relatedPort;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the type of the candidate. See [[fm.liveswitch.sdp.ice.candidateAttribute.candidateType]] for possible values.
                    */
                    CandidateAttribute.prototype.setCandidateType = function (value) {
                        if (arguments.length == 1) {
                            if ((fm.liveswitch.Global.equals(value, null))) {
                                throw new fm.liveswitch.Exception("Candidate type cannot be null.");
                            }
                            this.__candidateType = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the ID of the component for which this is a candidate.
                    */
                    CandidateAttribute.prototype.setComponentId = function (value) {
                        if (arguments.length == 1) {
                            this._componentId = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the IP address of the candidate.
                    */
                    CandidateAttribute.prototype.setConnectionAddress = function (value) {
                        if (arguments.length == 1) {
                            if ((fm.liveswitch.Global.equals(value, null))) {
                                throw new fm.liveswitch.Exception("Connection address cannot be null.");
                            }
                            this.__connectionAddress = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    CandidateAttribute.prototype.setExtensions = function (value) {
                        if (arguments.length == 1) {
                            this._extensions = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the candidate's foundation.
                    */
                    CandidateAttribute.prototype.setFoundation = function (value) {
                        if (arguments.length == 1) {
                            if ((fm.liveswitch.Global.equals(value, null))) {
                                throw new fm.liveswitch.Exception("Foundation cannot be null.");
                            }
                            this.__foundation = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the port of the candidate.
                    */
                    CandidateAttribute.prototype.setPort = function (value) {
                        if (arguments.length == 1) {
                            this._port = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the priority of the candidate.
                    */
                    CandidateAttribute.prototype.setPriority = function (value) {
                        if (arguments.length == 1) {
                            this._priority = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the protocol of this candidate.
                    */
                    CandidateAttribute.prototype.setProtocol = function (value) {
                        if (arguments.length == 1) {
                            this._protocol = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the IP address related to the candidate.
                    */
                    CandidateAttribute.prototype.setRelatedAddress = function (value) {
                        if (arguments.length == 1) {
                            this._relatedAddress = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the port related to the candidate.
                    */
                    CandidateAttribute.prototype.setRelatedPort = function (value) {
                        if (arguments.length == 1) {
                            this._relatedPort = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return CandidateAttribute;
                }(fm.liveswitch.sdp.Attribute));
                ice.CandidateAttribute = CandidateAttribute;
            })(ice = sdp.ice || (sdp.ice = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var ice;
            (function (ice) {
                /**
                Defines valid SDP candidate types.
                */
                var CandidateType = /** @class */ (function () {
                    function CandidateType() {
                    }
                    CandidateType.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.ice.CandidateType]';
                    };
                    /**
                    Gets the SDP candidate type meaning "Host".
                    */
                    CandidateType.getHost = function () {
                        if (arguments.length == 0) {
                            return "host";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the SDP candidate type meaning "Peer Reflexive".
                    */
                    CandidateType.getPeerReflexive = function () {
                        if (arguments.length == 0) {
                            return "prflx";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the SDP candidate type meaning "Relayed".
                    */
                    CandidateType.getRelayed = function () {
                        if (arguments.length == 0) {
                            return "relay";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the SDP candidate type meaning "Server Reflexive".
                    */
                    CandidateType.getServerReflexive = function () {
                        if (arguments.length == 0) {
                            return "srflx";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return CandidateType;
                }());
                ice.CandidateType = CandidateType;
            })(ice = sdp.ice || (sdp.ice = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var ice;
            (function (ice) {
                /**
                The SDP session attribute "fingerprint" provides an encryption certificate fingerprint to a remote peer for use with DTLS.
                */
                var FingerprintAttribute = /** @class */ (function (_super) {
                    __extends(FingerprintAttribute, _super);
                    function FingerprintAttribute() {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            _this = _super.call(this) || this;
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.IceFingerprintAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Transport);
                        }
                        else if (__arguments.length == 2) {
                            var hashFunction = __arguments[0];
                            var fingerprint = __arguments[1];
                            // chained constructor: FingerprintAttribute.call(this);
                            __arguments = new Array(0);
                            {
                                _this = _super.call(this) || this;
                                _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.IceFingerprintAttribute);
                                _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Transport);
                            }
                            _this.setHashFunction(hashFunction);
                            if ((fm.liveswitch.StringExtensions.indexOf(fingerprint, ":") < 0)) {
                                var list = new Array();
                                for (var i = 0; (i < fm.liveswitch.StringExtensions.getLength(fingerprint)); i = (i + 2)) {
                                    fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.substring(fingerprint, i, 2));
                                }
                                fingerprint = fm.liveswitch.StringExtensions.join(":", fm.liveswitch.ArrayExtensions.toArray(list));
                            }
                            _this.setFingerprint(fm.liveswitch.StringExtensions.toUpper(fingerprint));
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    FingerprintAttribute.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.ice.FingerprintAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.ice.fingerprintAttribute]] class.
                    @param value The attribute as a string.
                    */
                    FingerprintAttribute.fromAttributeValue = function (value) {
                        if (arguments.length == 1) {
                            var index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                            var str = fm.liveswitch.StringExtensions.substring(value, 0, index);
                            value = value.substring((index + 1));
                            var str2 = value;
                            var attribute = new fm.liveswitch.sdp.ice.FingerprintAttribute();
                            attribute.setHashFunction(str);
                            attribute.setFingerprint(str2);
                            return attribute;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the value of the attribute.
                    */
                    FingerprintAttribute.prototype.getAttributeValue = function () {
                        if (arguments.length == 0) {
                            var builder = new fm.liveswitch.StringBuilder();
                            builder.append(this.getHashFunction());
                            builder.append(" ");
                            builder.append(this.getFingerprint());
                            return builder.toString();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the fingerprint.
                    */
                    FingerprintAttribute.prototype.getFingerprint = function () {
                        if (arguments.length == 0) {
                            return this._fingerprint;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the hash function (i.e. sha-256).
                    */
                    FingerprintAttribute.prototype.getHashFunction = function () {
                        if (arguments.length == 0) {
                            return this._hashFunction;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    FingerprintAttribute.prototype.setFingerprint = function (value) {
                        if (arguments.length == 1) {
                            this._fingerprint = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    FingerprintAttribute.prototype.setHashFunction = function (value) {
                        if (arguments.length == 1) {
                            this._hashFunction = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return FingerprintAttribute;
                }(fm.liveswitch.sdp.Attribute));
                ice.FingerprintAttribute = FingerprintAttribute;
            })(ice = sdp.ice || (sdp.ice = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var ice;
            (function (ice) {
                /**
                "ice-lite" is a session-level attribute only, and indicates that an agent is a lite implementation.
                */
                var LiteAttribute = /** @class */ (function (_super) {
                    __extends(LiteAttribute, _super);
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.ice.liteAttribute]] class.
                    */
                    function LiteAttribute() {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            _this = _super.call(this) || this;
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.IceLiteAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    LiteAttribute.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.ice.LiteAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.ice.liteAttribute]] class.
                    @param value The attribute value.
                    */
                    LiteAttribute.fromAttributeValue = function (value) {
                        if (arguments.length == 1) {
                            return new fm.liveswitch.sdp.ice.LiteAttribute();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the value of the attribute.
                    */
                    LiteAttribute.prototype.getAttributeValue = function () {
                        if (arguments.length == 0) {
                            return null;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return LiteAttribute;
                }(fm.liveswitch.sdp.Attribute));
                ice.LiteAttribute = LiteAttribute;
            })(ice = sdp.ice || (sdp.ice = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var ice;
            (function (ice) {
                /**
                "ice-mismatch" is a media-level attribute only, and when present in an answer, indicates that the offer arrived with a default destination for a media component that didn't have a corresponding candidate attribute.
                */
                var MismatchAttribute = /** @class */ (function (_super) {
                    __extends(MismatchAttribute, _super);
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.ice.mismatchAttribute]] class.
                    */
                    function MismatchAttribute() {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            _this = _super.call(this) || this;
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.IceMismatchAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    MismatchAttribute.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.ice.MismatchAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.ice.mismatchAttribute]] class.
                    @param value The attribute value.
                    */
                    MismatchAttribute.fromAttributeValue = function (value) {
                        if (arguments.length == 1) {
                            return new fm.liveswitch.sdp.ice.MismatchAttribute();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the value of the attribute.
                    */
                    MismatchAttribute.prototype.getAttributeValue = function () {
                        if (arguments.length == 0) {
                            return null;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return MismatchAttribute;
                }(fm.liveswitch.sdp.Attribute));
                ice.MismatchAttribute = MismatchAttribute;
            })(ice = sdp.ice || (sdp.ice = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var ice;
            (function (ice) {
                /**
                The "ice-options" attribute is a session-level attribute.  It contains a series of tokens that identify the options supported by the agent.
                */
                var OptionsAttribute = /** @class */ (function (_super) {
                    __extends(OptionsAttribute, _super);
                    function OptionsAttribute() {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            _this = _super.call(this) || this;
                            _this.__tags = new Array();
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.IceOptionsAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                        }
                        else if (__arguments.length == 1) {
                            var tags = __arguments[0];
                            // chained constructor: OptionsAttribute.call(this);
                            __arguments = new Array(0);
                            {
                                _this = _super.call(this) || this;
                                _this.__tags = new Array();
                                _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.IceOptionsAttribute);
                                _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                            }
                            if ((fm.liveswitch.Global.equals(tags, null))) {
                                tags = new Array();
                            }
                            _this.setTags(tags);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    OptionsAttribute.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.ice.OptionsAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.ice.optionsAttribute]] class.
                    @param value The attribute value.
                    */
                    OptionsAttribute.fromAttributeValue = function (value) {
                        if (arguments.length == 1) {
                            var strArray = fm.liveswitch.StringExtensions.split(value, [32]);
                            var list = new Array();
                            for (var _i = 0, strArray_4 = strArray; _i < strArray_4.length; _i++) {
                                var str = strArray_4[_i];
                                var item = fm.liveswitch.sdp.ice.OptionTag.parse(str);
                                if ((!fm.liveswitch.Global.equals(item, null))) {
                                    fm.liveswitch.ArrayExtensions.add(list, item);
                                }
                            }
                            var attribute = new fm.liveswitch.sdp.ice.OptionsAttribute();
                            attribute.setTags(list);
                            return attribute;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the value of the attribute.
                    */
                    OptionsAttribute.prototype.getAttributeValue = function () {
                        if (arguments.length == 0) {
                            if ((fm.liveswitch.Global.equals(this.getTags(), null))) {
                                return "";
                            }
                            var count = fm.liveswitch.ArrayExtensions.getCount(this.getTags());
                            var strArray = new Array(count);
                            for (var i = 0; (i < count); i++) {
                                strArray[i] = this.getTags()[i].toString();
                            }
                            return fm.liveswitch.StringExtensions.join(" ", strArray);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the tokens that identify options supported by the agent.
                    */
                    OptionsAttribute.prototype.getTags = function () {
                        if (arguments.length == 0) {
                            return this.__tags;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets a value indicating whether trickle-ice is supported.
                    */
                    OptionsAttribute.prototype.getTrickleOptionSet = function () {
                        if (arguments.length == 0) {
                            for (var _i = 0, _a = this.getTags(); _i < _a.length; _i++) {
                                var tag = _a[_i];
                                if ((fm.liveswitch.Global.equals(tag.getType(), fm.liveswitch.sdp.ice.OptionTagType.Trickle))) {
                                    return true;
                                }
                            }
                            return false;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the tokens that identify options supported by the agent.
                    */
                    OptionsAttribute.prototype.setTags = function (value) {
                        if (arguments.length == 1) {
                            this.__tags = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets a value indicating whether trickle-ice is supported.
                    */
                    OptionsAttribute.prototype.setTrickleOptionSet = function (value) {
                        if (arguments.length == 1) {
                            if (value) {
                                for (var _i = 0, _a = this.getTags(); _i < _a.length; _i++) {
                                    var tag = _a[_i];
                                    if ((fm.liveswitch.Global.equals(tag.getType(), fm.liveswitch.sdp.ice.OptionTagType.Trickle))) {
                                        return;
                                    }
                                }
                                fm.liveswitch.ArrayExtensions.add(this.getTags(), new fm.liveswitch.sdp.ice.TrickleIceOptionTag());
                            }
                            else {
                                var item = null;
                                for (var _b = 0, _c = this.getTags(); _b < _c.length; _b++) {
                                    var tag = _c[_b];
                                    if ((fm.liveswitch.Global.equals(tag.getType(), fm.liveswitch.sdp.ice.OptionTagType.Trickle))) {
                                        item = tag;
                                    }
                                }
                                fm.liveswitch.ArrayExtensions.remove(this.getTags(), item);
                            }
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return OptionsAttribute;
                }(fm.liveswitch.sdp.Attribute));
                ice.OptionsAttribute = OptionsAttribute;
            })(ice = sdp.ice || (sdp.ice = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var ice;
            (function (ice) {
                /**
                A tag for an [[fm.liveswitch.sdp.ice.optionsAttribute]].
                */
                var OptionTag = /** @class */ (function () {
                    function OptionTag() {
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            //super();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                    }
                    OptionTag.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.ice.OptionTag]';
                    };
                    /**
                    Gets the "trickle" option string.
                    */
                    OptionTag.getTrickle = function () {
                        if (arguments.length == 0) {
                            return "trickle";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Generates a tag object from a string.
                    @param tagString The tag string.
                    */
                    OptionTag.parse = function (tagString) {
                        if (arguments.length == 1) {
                            if ((fm.liveswitch.Global.equals(tagString, fm.liveswitch.sdp.ice.OptionTag.getTrickle()))) {
                                return new fm.liveswitch.sdp.ice.TrickleIceOptionTag();
                            }
                            return new fm.liveswitch.sdp.ice.UnknownIceOptionTag(tagString);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the type of this tag.
                    */
                    OptionTag.prototype.getType = function () {
                        if (arguments.length == 0) {
                            return this._type;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the type of this tag.
                    */
                    OptionTag.prototype.setType = function (value) {
                        if (arguments.length == 1) {
                            this._type = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return OptionTag;
                }());
                ice.OptionTag = OptionTag;
            })(ice = sdp.ice || (sdp.ice = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var ice;
            (function (ice) {
                var OptionTagTypeWrapper = /** @class */ (function () {
                    function OptionTagTypeWrapper(value) {
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 1) {
                            var value_30 = __arguments[0];
                            //super();
                            this._value = value_30;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                    }
                    OptionTagTypeWrapper.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.ice.OptionTagTypeWrapper]';
                    };
                    OptionTagTypeWrapper.prototype.toString = function () {
                        if (arguments.length == 0) {
                            if (this._value == fm.liveswitch.sdp.ice.OptionTagType.Unknown)
                                return 'Unknown';
                            if (this._value == fm.liveswitch.sdp.ice.OptionTagType.Trickle)
                                return 'Trickle';
                            return '';
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return OptionTagTypeWrapper;
                }());
                ice.OptionTagTypeWrapper = OptionTagTypeWrapper;
            })(ice = sdp.ice || (sdp.ice = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var ice;
            (function (ice) {
                /**
                The "ice-pwd" attribute conveys the password used by ICE for message integrity.
                */
                var PasswordAttribute = /** @class */ (function (_super) {
                    __extends(PasswordAttribute, _super);
                    function PasswordAttribute() {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            // chained constructor: PasswordAttribute.call(this, fm.liveswitch.sdp.ice.PasswordAttribute.generatePassword());
                            __arguments = new Array(1);
                            __arguments[0] = fm.liveswitch.sdp.ice.PasswordAttribute.generatePassword();
                            {
                                var password = __arguments[0];
                                _this = _super.call(this) || this;
                                _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.IcePasswordAttribute);
                                if (((fm.liveswitch.StringExtensions.getLength(password) < 22) || (fm.liveswitch.StringExtensions.getLength(password) > 256))) {
                                    throw new fm.liveswitch.Exception("password must be at least 22 characters long up to 256 characters.");
                                }
                                _this.setPassword(password);
                                _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Transport);
                            }
                        }
                        else if (__arguments.length == 1) {
                            var password = __arguments[0];
                            _this = _super.call(this) || this;
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.IcePasswordAttribute);
                            if (((fm.liveswitch.StringExtensions.getLength(password) < 22) || (fm.liveswitch.StringExtensions.getLength(password) > 256))) {
                                throw new fm.liveswitch.Exception("password must be at least 22 characters long up to 256 characters.");
                            }
                            _this.setPassword(password);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Transport);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    PasswordAttribute.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.ice.PasswordAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.ice.passwordAttribute]] class.
                    @param value The attribute value.
                    */
                    PasswordAttribute.fromAttributeValue = function (value) {
                        if (arguments.length == 1) {
                            return new fm.liveswitch.sdp.ice.PasswordAttribute(value);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Generates a random password.
                    */
                    PasswordAttribute.generatePassword = function () {
                        if (arguments.length == 0) {
                            return fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "");
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the value of the attribute.
                    */
                    PasswordAttribute.prototype.getAttributeValue = function () {
                        if (arguments.length == 0) {
                            return this.getPassword();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the password used by ICE for message integrity.
                    */
                    PasswordAttribute.prototype.getPassword = function () {
                        if (arguments.length == 0) {
                            return this._password;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    PasswordAttribute.prototype.setPassword = function (value) {
                        if (arguments.length == 1) {
                            this._password = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return PasswordAttribute;
                }(fm.liveswitch.sdp.Attribute));
                ice.PasswordAttribute = PasswordAttribute;
            })(ice = sdp.ice || (sdp.ice = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var ice;
            (function (ice) {
                /**
                An SDP remote candidate element.
                */
                var RemoteCandidate = /** @class */ (function () {
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.ice.remoteCandidate]] class.
                    @param componentId The ID of the component for which this is a remote candidate.
                    @param connectionAddress The IP address of the remote candidate.
                    @param port The port of the remote candidate.
                    */
                    function RemoteCandidate(componentId, connectionAddress, port) {
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 3) {
                            var componentId_2 = __arguments[0];
                            var connectionAddress_3 = __arguments[1];
                            var port_2 = __arguments[2];
                            //super();
                            this.fmliveswitchsdpiceRemoteCandidateInit();
                            if ((fm.liveswitch.Global.equals(connectionAddress_3, null))) {
                                throw new fm.liveswitch.Exception("connectionAddress cannot be null.");
                            }
                            this.setComponentId(componentId_2);
                            this.setConnectionAddress(connectionAddress_3);
                            this.setPort(port_2);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                    }
                    RemoteCandidate.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.ice.RemoteCandidate]';
                    };
                    RemoteCandidate.prototype.fmliveswitchsdpiceRemoteCandidateInit = function () {
                        this._componentId = 0;
                        this._port = 0;
                    };
                    /**
                    Creates an [[fm.liveswitch.sdp.ice.remoteCandidate]] instance from a string.
                    @param s The string to parse.
                    */
                    RemoteCandidate.parse = function (s) {
                        if (arguments.length == 1) {
                            var strArray = fm.liveswitch.StringExtensions.split(s, [32]);
                            var componentId = fm.liveswitch.ParseAssistant.parseIntegerValue(strArray[0]);
                            var connectionAddress = strArray[1];
                            return new fm.liveswitch.sdp.ice.RemoteCandidate(componentId, connectionAddress, fm.liveswitch.ParseAssistant.parseIntegerValue(strArray[2]));
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the ID of the component for which this is a remote candidate.
                    */
                    RemoteCandidate.prototype.getComponentId = function () {
                        if (arguments.length == 0) {
                            return this._componentId;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the IP address of the remote candidate.
                    */
                    RemoteCandidate.prototype.getConnectionAddress = function () {
                        if (arguments.length == 0) {
                            return this._connectionAddress;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the port of the remote candidate.
                    */
                    RemoteCandidate.prototype.getPort = function () {
                        if (arguments.length == 0) {
                            return this._port;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    RemoteCandidate.prototype.setComponentId = function (value) {
                        if (arguments.length == 1) {
                            this._componentId = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    RemoteCandidate.prototype.setConnectionAddress = function (value) {
                        if (arguments.length == 1) {
                            this._connectionAddress = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    RemoteCandidate.prototype.setPort = function (value) {
                        if (arguments.length == 1) {
                            this._port = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Converts this instance to a string.
                    */
                    RemoteCandidate.prototype.toString = function () {
                        if (arguments.length == 0) {
                            var builder = new fm.liveswitch.StringBuilder();
                            builder.append(fm.liveswitch.NumberExtensions.toString(this.getComponentId()));
                            builder.append(" ");
                            builder.append(this.getConnectionAddress());
                            builder.append(" ");
                            builder.append(fm.liveswitch.NumberExtensions.toString(this.getPort()));
                            return builder.toString();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return RemoteCandidate;
                }());
                ice.RemoteCandidate = RemoteCandidate;
            })(ice = sdp.ice || (sdp.ice = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var ice;
            (function (ice) {
                /**
                The attribute contains a connection-address and port for each component.  The ordering of components is irrelevant.  However, a value MUST be present for each component of a media stream.  This attribute MUST be included in an offer by a controlling agent for a media stream that is Completed, and MUST NOT be included in any other case.
                */
                var RemoteCandidatesAttribute = /** @class */ (function (_super) {
                    __extends(RemoteCandidatesAttribute, _super);
                    function RemoteCandidatesAttribute() {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            _this = _super.call(this) || this;
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.IceRemoteCandidatesAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Transport);
                        }
                        else if (__arguments.length == 1) {
                            var candidates = __arguments[0];
                            // chained constructor: RemoteCandidatesAttribute.call(this);
                            __arguments = new Array(0);
                            {
                                _this = _super.call(this) || this;
                                _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.IceRemoteCandidatesAttribute);
                                _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Transport);
                            }
                            if ((fm.liveswitch.Global.equals(candidates, null))) {
                                throw new fm.liveswitch.Exception("candidates cannot be null.");
                            }
                            _this.setCandidates(candidates);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    RemoteCandidatesAttribute.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.ice.RemoteCandidatesAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.ice.remoteCandidatesAttribute]] class.
                    @param value The attribute value.
                    */
                    RemoteCandidatesAttribute.fromAttributeValue = function (value) {
                        if (arguments.length == 1) {
                            var array = fm.liveswitch.StringExtensions.split(value, [32]);
                            var list = new Array();
                            for (var i = 0; (i < array.length); i = (i + 3)) {
                                fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.sdp.ice.RemoteCandidate.parse(fm.liveswitch.StringExtensions.join(" ", fm.liveswitch.StringAssistant.subArray(array, i, 3))));
                            }
                            var attribute = new fm.liveswitch.sdp.ice.RemoteCandidatesAttribute();
                            attribute.setCandidates(fm.liveswitch.ArrayExtensions.toArray(list));
                            return attribute;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the value of the attribute.
                    */
                    RemoteCandidatesAttribute.prototype.getAttributeValue = function () {
                        if (arguments.length == 0) {
                            var strArray = new Array(this.getCandidates().length);
                            for (var i = 0; (i < this.getCandidates().length); i++) {
                                strArray[i] = this.getCandidates()[i].toString();
                            }
                            return fm.liveswitch.StringExtensions.join(" ", strArray);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the array of remote candidates.
                    */
                    RemoteCandidatesAttribute.prototype.getCandidates = function () {
                        if (arguments.length == 0) {
                            return this._candidates;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    RemoteCandidatesAttribute.prototype.setCandidates = function (value) {
                        if (arguments.length == 1) {
                            this._candidates = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return RemoteCandidatesAttribute;
                }(fm.liveswitch.sdp.Attribute));
                ice.RemoteCandidatesAttribute = RemoteCandidatesAttribute;
            })(ice = sdp.ice || (sdp.ice = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var ice;
            (function (ice) {
                /**
                Defines valid SDP transport protocols.
                */
                var TransportProtocol = /** @class */ (function () {
                    function TransportProtocol() {
                    }
                    TransportProtocol.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.ice.TransportProtocol]';
                    };
                    /**
                    Gets the SDP transport protocol meaning "tcp".
                    */
                    TransportProtocol.getTcp = function () {
                        if (arguments.length == 0) {
                            return "tcp";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the SDP transport protocol meaning "udp".
                    */
                    TransportProtocol.getUdp = function () {
                        if (arguments.length == 0) {
                            return "udp";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return TransportProtocol;
                }());
                ice.TransportProtocol = TransportProtocol;
            })(ice = sdp.ice || (sdp.ice = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/ice/OptionTag.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var ice;
            (function (ice) {
                /**
                A trickle-ice tag for an [[fm.liveswitch.sdp.ice.optionsAttribute]]
                */
                var TrickleIceOptionTag = /** @class */ (function (_super) {
                    __extends(TrickleIceOptionTag, _super);
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.ice.trickleIceOptionTag]] class.
                    */
                    function TrickleIceOptionTag() {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            _this = _super.call(this) || this;
                            _super.prototype.setType.call(_this, fm.liveswitch.sdp.ice.OptionTagType.Trickle);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    TrickleIceOptionTag.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.ice.TrickleIceOptionTag]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    /**
                    Gets the string representation of this tag
                    */
                    TrickleIceOptionTag.prototype.toString = function () {
                        if (arguments.length == 0) {
                            return fm.liveswitch.sdp.ice.OptionTag.getTrickle();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return TrickleIceOptionTag;
                }(fm.liveswitch.sdp.ice.OptionTag));
                ice.TrickleIceOptionTag = TrickleIceOptionTag;
            })(ice = sdp.ice || (sdp.ice = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var ice;
            (function (ice) {
                /**
                The "ice-ufrag" attribute conveys the username fragment used by ICE for message integrity.
                */
                var UfragAttribute = /** @class */ (function (_super) {
                    __extends(UfragAttribute, _super);
                    function UfragAttribute() {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            // chained constructor: UfragAttribute.call(this, fm.liveswitch.sdp.ice.UfragAttribute.generateUfrag());
                            __arguments = new Array(1);
                            __arguments[0] = fm.liveswitch.sdp.ice.UfragAttribute.generateUfrag();
                            {
                                var ufrag = __arguments[0];
                                _this = _super.call(this) || this;
                                _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.IceUfragAttribute);
                                if (((fm.liveswitch.StringExtensions.getLength(ufrag) < 4) || (fm.liveswitch.StringExtensions.getLength(ufrag) > 256))) {
                                    throw new fm.liveswitch.Exception("ufrag must be at least 4 characters long up to 256 characters.");
                                }
                                _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Transport);
                                _this.setUfrag(ufrag);
                            }
                        }
                        else if (__arguments.length == 1) {
                            var ufrag = __arguments[0];
                            _this = _super.call(this) || this;
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.IceUfragAttribute);
                            if (((fm.liveswitch.StringExtensions.getLength(ufrag) < 4) || (fm.liveswitch.StringExtensions.getLength(ufrag) > 256))) {
                                throw new fm.liveswitch.Exception("ufrag must be at least 4 characters long up to 256 characters.");
                            }
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Transport);
                            _this.setUfrag(ufrag);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    UfragAttribute.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.ice.UfragAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.ice.ufragAttribute]] class.
                    @param value The attribute value.
                    */
                    UfragAttribute.fromAttributeValue = function (value) {
                        if (arguments.length == 1) {
                            return new fm.liveswitch.sdp.ice.UfragAttribute(value);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Generates a username fragment.
                    */
                    UfragAttribute.generateUfrag = function () {
                        if (arguments.length == 0) {
                            return fm.liveswitch.StringExtensions.substring(fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", ""), 0, 8);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the value of the attribute.
                    */
                    UfragAttribute.prototype.getAttributeValue = function () {
                        if (arguments.length == 0) {
                            return this.getUfrag();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the username fragment used by ICE for message integrity.
                    */
                    UfragAttribute.prototype.getUfrag = function () {
                        if (arguments.length == 0) {
                            return this._ufrag;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    UfragAttribute.prototype.setUfrag = function (value) {
                        if (arguments.length == 1) {
                            this._ufrag = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return UfragAttribute;
                }(fm.liveswitch.sdp.Attribute));
                ice.UfragAttribute = UfragAttribute;
            })(ice = sdp.ice || (sdp.ice = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/ice/OptionTag.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var ice;
            (function (ice) {
                /**
                An unknown tag for an [[fm.liveswitch.sdp.ice.optionsAttribute]]
                */
                var UnknownIceOptionTag = /** @class */ (function (_super) {
                    __extends(UnknownIceOptionTag, _super);
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.ice.unknownIceOptionTag]] class.
                    */
                    function UnknownIceOptionTag(tagString) {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 1) {
                            var tagString_1 = __arguments[0];
                            _this = _super.call(this) || this;
                            _super.prototype.setType.call(_this, fm.liveswitch.sdp.ice.OptionTagType.Unknown);
                            _this.setTagString(tagString_1);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    UnknownIceOptionTag.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.ice.UnknownIceOptionTag]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    /**
                    Gets the tag string.
                    */
                    UnknownIceOptionTag.prototype.getTagString = function () {
                        if (arguments.length == 0) {
                            return this._tagString;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    UnknownIceOptionTag.prototype.setTagString = function (value) {
                        if (arguments.length == 1) {
                            this._tagString = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the string representation of this tag.
                    */
                    UnknownIceOptionTag.prototype.toString = function () {
                        if (arguments.length == 0) {
                            return this.getTagString();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return UnknownIceOptionTag;
                }(fm.liveswitch.sdp.ice.OptionTag));
                ice.UnknownIceOptionTag = UnknownIceOptionTag;
            })(ice = sdp.ice || (sdp.ice = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/DirectionAttribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            This specifies that the tools should be started in inactive mode.  This is necessary for interactive conferences where users can put other users on hold.  No media is sent over an inactive media stream.  Note that an RTP-based system SHOULD still send RTCP, even if started inactive.  It can be either a session or media-level attribute, and it is not dependent on charset.
            */
            var InactiveAttribute = /** @class */ (function (_super) {
                __extends(InactiveAttribute, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.inactiveAttribute]] class.
                */
                function InactiveAttribute() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.DirectionAttribute);
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                InactiveAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.InactiveAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.inactiveAttribute]] class.
                @param value The attribute value.
                */
                InactiveAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        return new fm.liveswitch.sdp.InactiveAttribute();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                InactiveAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the stream direction.
                */
                InactiveAttribute.prototype.getStreamDirection = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.StreamDirection.Inactive;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return InactiveAttribute;
            }(fm.liveswitch.sdp.DirectionAttribute));
            sdp.InactiveAttribute = InactiveAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            Like the cat attribute, this is to assist identifying wanted sessions at the receiver.  This allows a receiver to select interesting session based on keywords describing the purpose of the session; there is no central registry of keywords.  It is a session-level attribute.  It is a charset-dependent attribute, meaning that its value should be interpreted in the charset specified for the session description if one is specified, or by default in ISO 10646/UTF-8.
            */
            var KeywordsAttribute = /** @class */ (function (_super) {
                __extends(KeywordsAttribute, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.keywordsAttribute]] class.
                @param keywords The keywords describing the purpose of the session.
                */
                function KeywordsAttribute(keywords) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var keywords_1 = __arguments[0];
                        _this = _super.call(this) || this;
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.KeywordsAttribute);
                        if ((fm.liveswitch.Global.equals(keywords_1, null))) {
                            throw new fm.liveswitch.Exception("keywords cannot be null.");
                        }
                        _this.setKeywords(keywords_1);
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                KeywordsAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.KeywordsAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.keywordsAttribute]] class.
                @param value The attribute value.
                */
                KeywordsAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        return new fm.liveswitch.sdp.KeywordsAttribute(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                KeywordsAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        return this.getKeywords();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the keywords describing the purpose of the session.
                */
                KeywordsAttribute.prototype.getKeywords = function () {
                    if (arguments.length == 0) {
                        return this._keywords;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                KeywordsAttribute.prototype.setKeywords = function (value) {
                    if (arguments.length == 1) {
                        this._keywords = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return KeywordsAttribute;
            }(fm.liveswitch.sdp.Attribute));
            sdp.KeywordsAttribute = KeywordsAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            This can be a session-level attribute or a media-level attribute.  As a session-level attribute, it specifies the default language for the session being described.  As a media- level attribute, it specifies the language for that media, overriding any session-level language specified.  Multiple lang attributes can be provided either at session or media level if the session description or media use multiple languages, in which case the order of the attributes indicates the order of importance of the various languages in the session or media from most important to least important.
            */
            var LanguageAttribute = /** @class */ (function (_super) {
                __extends(LanguageAttribute, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.languageAttribute]] class.
                @param languageTag The default language for the session being described
                            (if used as a session-level attribute) or the language for a media
                            stream (if used as a media-level attribute).
                */
                function LanguageAttribute(languageTag) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var languageTag_1 = __arguments[0];
                        _this = _super.call(this) || this;
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.LanguageAttribute);
                        if ((fm.liveswitch.Global.equals(languageTag_1, null))) {
                            throw new fm.liveswitch.Exception("languageTag cannot be null.");
                        }
                        _this.setLanguageTag(languageTag_1);
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                LanguageAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.LanguageAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.languageAttribute]] class.
                @param value The attribute value.
                */
                LanguageAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        return new fm.liveswitch.sdp.LanguageAttribute(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                LanguageAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        return this.getLanguageTag();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the default language for the session being described (if used as a session-level attribute) or the language for a media stream (if used as a media-level attribute).
                */
                LanguageAttribute.prototype.getLanguageTag = function () {
                    if (arguments.length == 0) {
                        return this._languageTag;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                LanguageAttribute.prototype.setLanguageTag = function (value) {
                    if (arguments.length == 1) {
                        this._languageTag = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return LanguageAttribute;
            }(fm.liveswitch.sdp.Attribute));
            sdp.LanguageAttribute = LanguageAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            This gives the maximum amount of media that can be encapsulated in each packet, expressed as time in milliseconds.  The time SHALL be calculated as the sum of the time the media present in the packet represents.  For frame-based codecs, the time SHOULD be an integer multiple of the frame size.  This attribute is probably only meaningful for audio data, but may be used with other media types if it makes sense.  It is a media-level attribute, and it is not dependent on charset.  Note that this attribute was introduced after RFC 2327, and non-updated implementations will ignore this attribute.
            */
            var MaxPacketTimeAttribute = /** @class */ (function (_super) {
                __extends(MaxPacketTimeAttribute, _super);
                function MaxPacketTimeAttribute() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsdpMaxPacketTimeAttributeInit();
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.MaxPacketTimeAttribute);
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.IdenticalPerPT);
                    }
                    else if (__arguments.length == 1) {
                        var maxPacketTime = __arguments[0];
                        // chained constructor: MaxPacketTimeAttribute.call(this);
                        __arguments = new Array(0);
                        {
                            _this = _super.call(this) || this;
                            _this.fmliveswitchsdpMaxPacketTimeAttributeInit();
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.MaxPacketTimeAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.IdenticalPerPT);
                        }
                        _this.setMaxPacketTime(maxPacketTime);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                MaxPacketTimeAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.MaxPacketTimeAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                MaxPacketTimeAttribute.prototype.fmliveswitchsdpMaxPacketTimeAttributeInit = function () {
                    this._maxPacketTime = 0;
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.maxPacketTimeAttribute]] class.
                @param value The attribute value.
                */
                MaxPacketTimeAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        var attribute = new fm.liveswitch.sdp.MaxPacketTimeAttribute();
                        attribute.setMaxPacketTime(fm.liveswitch.ParseAssistant.parseIntegerValue(value));
                        return attribute;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                MaxPacketTimeAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.NumberExtensions.toString(this.getMaxPacketTime());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the maximum amount of media that can be encapsulated, in each packet, expressed as time in milliseconds.
                */
                MaxPacketTimeAttribute.prototype.getMaxPacketTime = function () {
                    if (arguments.length == 0) {
                        return this._maxPacketTime;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MaxPacketTimeAttribute.prototype.setMaxPacketTime = function (value) {
                    if (arguments.length == 1) {
                        this._maxPacketTime = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return MaxPacketTimeAttribute;
            }(fm.liveswitch.sdp.Attribute));
            sdp.MaxPacketTimeAttribute = MaxPacketTimeAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            An SDP media element.
            */
            var Media = /** @class */ (function () {
                function Media() {
                    fm.liveswitch.sdp.Media.fmliveswitchsdpMediaInitialize();
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        //super();
                        this.fmliveswitchsdpMediaInit();
                    }
                    else if (__arguments.length == 3) {
                        var mediaType = __arguments[0];
                        var transportPort = __arguments[1];
                        var transportProtocol = __arguments[2];
                        // chained constructor: Media.call(this, mediaType, transportPort, transportProtocol, null);
                        __arguments = new Array(4);
                        __arguments[0] = mediaType;
                        __arguments[1] = transportPort;
                        __arguments[2] = transportProtocol;
                        __arguments[3] = null;
                        {
                            var mediaType_1 = __arguments[0];
                            var transportPort_1 = __arguments[1];
                            var transportProtocol_1 = __arguments[2];
                            var formatDescription = __arguments[3];
                            //super();
                            this.fmliveswitchsdpMediaInit();
                            if ((fm.liveswitch.Global.equals(mediaType_1, null))) {
                                throw new fm.liveswitch.Exception("mediaType cannot be null.");
                            }
                            if ((fm.liveswitch.Global.equals(transportProtocol_1, null))) {
                                throw new fm.liveswitch.Exception("transportProtocol cannot be null.");
                            }
                            this.setMediaType(mediaType_1);
                            this.setTransportPort(transportPort_1);
                            this.setNumberOfPorts(fm.liveswitch.sdp.Media.fm_liveswitch_sdp_Media__defaultNumberOfPorts);
                            this.setTransportProtocol(transportProtocol_1);
                            this.setFormatDescription(formatDescription);
                        }
                    }
                    else if (__arguments.length == 4) {
                        var mediaType = __arguments[0];
                        var transportPort = __arguments[1];
                        var transportProtocol = __arguments[2];
                        var formatDescription = __arguments[3];
                        //super();
                        this.fmliveswitchsdpMediaInit();
                        if ((fm.liveswitch.Global.equals(mediaType, null))) {
                            throw new fm.liveswitch.Exception("mediaType cannot be null.");
                        }
                        if ((fm.liveswitch.Global.equals(transportProtocol, null))) {
                            throw new fm.liveswitch.Exception("transportProtocol cannot be null.");
                        }
                        this.setMediaType(mediaType);
                        this.setTransportPort(transportPort);
                        this.setNumberOfPorts(fm.liveswitch.sdp.Media.fm_liveswitch_sdp_Media__defaultNumberOfPorts);
                        this.setTransportProtocol(transportProtocol);
                        this.setFormatDescription(formatDescription);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                Media.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.Media]';
                };
                Media.prototype.fmliveswitchsdpMediaInit = function () {
                    this._numberOfPorts = 0;
                    this._transportPort = 0;
                };
                /**
                Creates an [[fm.liveswitch.sdp.media]] instance from a string.
                @param s The string to parse.
                */
                Media.parse = function (s) {
                    fm.liveswitch.sdp.Media.fmliveswitchsdpMediaInitialize();
                    if (arguments.length == 1) {
                        var media = void 0;
                        s = s.substring(2);
                        var array = fm.liveswitch.StringExtensions.split(s, [32]);
                        var mediaType = array[0];
                        var strArray2 = fm.liveswitch.StringExtensions.split(array[1], [47]);
                        var transportPort = fm.liveswitch.ParseAssistant.parseIntegerValue(strArray2[0]);
                        var transportProtocol = array[2];
                        var formatDescription = fm.liveswitch.StringExtensions.join(" ", fm.liveswitch.StringAssistant.subArray(array, 3));
                        if ((fm.liveswitch.Global.equals(transportProtocol, fm.liveswitch.sdp.UdpMedia.getUdpTransportProtocol()))) {
                            media = new fm.liveswitch.sdp.UdpMedia(mediaType, transportPort, formatDescription);
                        }
                        else {
                            if ((((((fm.liveswitch.Global.equals(transportProtocol, fm.liveswitch.sdp.rtp.Media.getRtpAvpTransportProtocol())) || (fm.liveswitch.Global.equals(transportProtocol, fm.liveswitch.sdp.rtp.Media.getRtpSavpTransportProtocol()))) || ((fm.liveswitch.Global.equals(transportProtocol, fm.liveswitch.sdp.rtp.Media.getRtpAvpfTransportProtocol())) || (fm.liveswitch.Global.equals(transportProtocol, fm.liveswitch.sdp.rtp.Media.getRtpSavpfTransportProtocol())))) || (fm.liveswitch.Global.equals(transportProtocol, fm.liveswitch.sdp.rtp.Media.getUdpTlsRtpSavpTransportProtocol()))) || (fm.liveswitch.Global.equals(transportProtocol, fm.liveswitch.sdp.rtp.Media.getUdpTlsRtpSavpfTransportProtocol())))) {
                                var rtpPayloadTypeNumbers = new Array(0);
                                if (!fm.liveswitch.StringExtensions.isNullOrEmpty(formatDescription)) {
                                    var strArray3 = fm.liveswitch.StringExtensions.split(formatDescription, [32]);
                                    rtpPayloadTypeNumbers = new Array(strArray3.length);
                                    for (var i = 0; (i < rtpPayloadTypeNumbers.length); i++) {
                                        rtpPayloadTypeNumbers[i] = fm.liveswitch.ParseAssistant.parseIntegerValue(strArray3[i]);
                                    }
                                }
                                media = new fm.liveswitch.sdp.rtp.Media(mediaType, transportPort, transportProtocol, rtpPayloadTypeNumbers);
                            }
                            else {
                                if (((((fm.liveswitch.Global.equals(transportProtocol, fm.liveswitch.sdp.sctp.Media.getDtlsSctpTransportProtocol())) || (fm.liveswitch.Global.equals(transportProtocol, fm.liveswitch.sdp.sctp.Media.getSctpDtlsTransportProtocol()))) || ((fm.liveswitch.Global.equals(transportProtocol, fm.liveswitch.sdp.sctp.Media.getSctpTransportProtocol())) || (fm.liveswitch.Global.equals(transportProtocol, fm.liveswitch.sdp.sctp.Media.getTcpDtlsSctpTransportProtocol())))) || (fm.liveswitch.Global.equals(transportProtocol, fm.liveswitch.sdp.sctp.Media.getUdpDtlsSctpTransportProtocol())))) {
                                    media = new fm.liveswitch.sdp.sctp.Media(mediaType, transportPort, transportProtocol, formatDescription);
                                }
                                else {
                                    media = new fm.liveswitch.sdp.Media(mediaType, transportPort, transportProtocol, formatDescription);
                                }
                            }
                        }
                        if ((fm.liveswitch.Global.equals(strArray2.length, 2))) {
                            media.setNumberOfPorts(fm.liveswitch.ParseAssistant.parseShortValue(strArray2[1]));
                        }
                        return media;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the format description.
                */
                Media.prototype.getFormatDescription = function () {
                    if (arguments.length == 0) {
                        return this._formatDescription;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the media type. See [[fm.liveswitch.sdp.media.mediaType]] for possible values.
                */
                Media.prototype.getMediaType = function () {
                    if (arguments.length == 0) {
                        return this._mediaType;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the number of ports.
                */
                Media.prototype.getNumberOfPorts = function () {
                    if (arguments.length == 0) {
                        return this._numberOfPorts;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the transport port.
                */
                Media.prototype.getTransportPort = function () {
                    if (arguments.length == 0) {
                        return this._transportPort;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the transport protocol.
                */
                Media.prototype.getTransportProtocol = function () {
                    if (arguments.length == 0) {
                        return this._transportProtocol;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the format description.
                */
                Media.prototype.setFormatDescription = function (value) {
                    if (arguments.length == 1) {
                        this._formatDescription = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the media type. See [[fm.liveswitch.sdp.media.mediaType]] for possible values.
                */
                Media.prototype.setMediaType = function (value) {
                    if (arguments.length == 1) {
                        this._mediaType = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the number of ports.
                */
                Media.prototype.setNumberOfPorts = function (value) {
                    if (arguments.length == 1) {
                        this._numberOfPorts = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the transport port.
                */
                Media.prototype.setTransportPort = function (value) {
                    if (arguments.length == 1) {
                        this._transportPort = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the transport protocol.
                */
                Media.prototype.setTransportProtocol = function (value) {
                    if (arguments.length == 1) {
                        this._transportProtocol = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Converts this instance to a string.
                */
                Media.prototype.toString = function () {
                    if (arguments.length == 0) {
                        var builder = new fm.liveswitch.StringBuilder();
                        builder.append("m=");
                        builder.append(this.getMediaType());
                        builder.append(" ");
                        builder.append(fm.liveswitch.NumberExtensions.toString(this.getTransportPort()));
                        if ((this.getNumberOfPorts() > 1)) {
                            builder.append("/");
                            builder.append(fm.liveswitch.NumberExtensions.toString(this.getNumberOfPorts()));
                        }
                        builder.append(" ");
                        builder.append(this.getTransportProtocol());
                        if ((!fm.liveswitch.Global.equals(this.getFormatDescription(), null))) {
                            builder.append(" ");
                            builder.append(this.getFormatDescription());
                        }
                        return builder.toString();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Media.fmliveswitchsdpMediaInitialize = function () {
                    if (!fm.liveswitch.sdp.Media.__fmliveswitchsdpMediaInitialized && !fm.liveswitch.sdp.Media.__fmliveswitchsdpMediaInitializing) {
                        fm.liveswitch.sdp.Media.__fmliveswitchsdpMediaInitializing = true;
                        Media.fm_liveswitch_sdp_Media__defaultNumberOfPorts = 0;
                        fm.liveswitch.sdp.Media.fm_liveswitch_sdp_Media__defaultNumberOfPorts = 1;
                        fm.liveswitch.sdp.Media.__fmliveswitchsdpMediaInitialized = true;
                        fm.liveswitch.sdp.Media.__fmliveswitchsdpMediaInitializing = false;
                    }
                };
                /** @hidden */
                Media.__fmliveswitchsdpMediaInitialized = false;
                /** @hidden */
                Media.__fmliveswitchsdpMediaInitializing = false;
                return Media;
            }());
            sdp.Media = Media;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            An SDP media description element.
            */
            var MediaDescription = /** @class */ (function () {
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.mediaDescription]] class.
                @param media The media name and transport address.
                */
                function MediaDescription(media) {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var media_1 = __arguments[0];
                        //super();
                        this.__bandwidths = new Array();
                        this.__mediaAttributes = new fm.liveswitch.sdp.AttributeCollection();
                        this.__orphanedAttributes = new Array();
                        if ((fm.liveswitch.Global.equals(media_1, null))) {
                            throw new fm.liveswitch.Exception("media cannot be null.");
                        }
                        this.setMedia(media_1);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                MediaDescription.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.MediaDescription]';
                };
                /** @hidden */
                MediaDescription.getBundleOnlyAttributeFromCollection = function (attributes) {
                    if (arguments.length == 1) {
                        var attributeArray = null;
                        var _var0 = new fm.liveswitch.Holder(attributeArray);
                        var _var1 = attributes.tryGetAttributes(fm.liveswitch.sdp.AttributeType.BundleOnlyAttribute, _var0);
                        attributeArray = _var0.getValue();
                        if ((_var1 && (attributeArray.length > 0))) {
                            return attributeArray[0];
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaDescription.getCryptoAttributesFromCollection = function (attributes) {
                    if (arguments.length == 1) {
                        var attributeArray = null;
                        var _var0 = new fm.liveswitch.Holder(attributeArray);
                        var _var1 = attributes.tryGetAttributes(fm.liveswitch.sdp.AttributeType.CryptoAttribute, _var0);
                        attributeArray = _var0.getValue();
                        if (_var1) {
                            var attributeArray2 = new Array(attributeArray.length);
                            var index = 0;
                            for (var _i = 0, attributeArray_1 = attributeArray; _i < attributeArray_1.length; _i++) {
                                var attribute = attributeArray_1[_i];
                                attributeArray2[index] = attribute;
                                index++;
                            }
                            return attributeArray2;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaDescription.getFingerprintAttributeFromCollection = function (attributes) {
                    if (arguments.length == 1) {
                        var attribute = null;
                        var _var0 = new fm.liveswitch.Holder(attribute);
                        var _var1 = attributes.tryGetAttribute(fm.liveswitch.sdp.AttributeType.IceFingerprintAttribute, _var0);
                        attribute = _var0.getValue();
                        if (_var1) {
                            return attribute;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaDescription.getGroupAttributesFromCollection = function (collection) {
                    if (arguments.length == 1) {
                        var attributes = null;
                        var list = new Array();
                        var _var0 = new fm.liveswitch.Holder(attributes);
                        var _var1 = collection.tryGetAttributes(fm.liveswitch.sdp.AttributeType.GroupAttribute, _var0);
                        attributes = _var0.getValue();
                        if (_var1) {
                            for (var _i = 0, attributes_1 = attributes; _i < attributes_1.length; _i++) {
                                var attribute = attributes_1[_i];
                                var item = attribute;
                                fm.liveswitch.ArrayExtensions.add(list, item);
                            }
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaDescription.getIceOptionAttributesFromCollection = function (attributes) {
                    if (arguments.length == 1) {
                        var attributeArray = null;
                        var _var0 = new fm.liveswitch.Holder(attributeArray);
                        var _var1 = attributes.tryGetAttributes(fm.liveswitch.sdp.AttributeType.IceOptionsAttribute, _var0);
                        attributeArray = _var0.getValue();
                        if (_var1) {
                            return attributeArray;
                        }
                        return new Array(0);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaDescription.getIcePasswordAttributeFromCollection = function (attributes) {
                    if (arguments.length == 1) {
                        var attribute = null;
                        var _var0 = new fm.liveswitch.Holder(attribute);
                        var _var1 = attributes.tryGetAttribute(fm.liveswitch.sdp.AttributeType.IcePasswordAttribute, _var0);
                        attribute = _var0.getValue();
                        if (_var1) {
                            return attribute;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaDescription.getIceUfragAttributeFromCollection = function (attributes) {
                    if (arguments.length == 1) {
                        var attribute = null;
                        var _var0 = new fm.liveswitch.Holder(attribute);
                        var _var1 = attributes.tryGetAttribute(fm.liveswitch.sdp.AttributeType.IceUfragAttribute, _var0);
                        attribute = _var0.getValue();
                        if (_var1) {
                            return attribute;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaDescription.getQualityAttributeFromCollection = function (attributes) {
                    if (arguments.length == 1) {
                        var attribute = null;
                        var _var0 = new fm.liveswitch.Holder(attribute);
                        var _var1 = attributes.tryGetAttribute(fm.liveswitch.sdp.AttributeType.QualityAttribute, _var0);
                        attribute = _var0.getValue();
                        if (_var1) {
                            return attribute;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaDescription.getRtcpMultiplexingSupportFromCollection = function (attributes) {
                    if (arguments.length == 1) {
                        var attribute = null;
                        var _var0 = new fm.liveswitch.Holder(attribute);
                        var _var1 = attributes.tryGetAttribute(fm.liveswitch.sdp.AttributeType.RtcpMuxAttribute, _var0);
                        attribute = _var0.getValue();
                        return _var1;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaDescription.getRtpExtMapAttributesFromCollection = function (attributes) {
                    if (arguments.length == 1) {
                        var attributeArray = null;
                        var _var0 = new fm.liveswitch.Holder(attributeArray);
                        var _var1 = attributes.tryGetAttributes(fm.liveswitch.sdp.AttributeType.RtpExtMapAttribute, _var0);
                        attributeArray = _var0.getValue();
                        if (_var1) {
                            return attributeArray;
                        }
                        return new Array(0);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaDescription.getSetupAttributeFromCollection = function (attributes) {
                    if (arguments.length == 1) {
                        var attribute = null;
                        var _var0 = new fm.liveswitch.Holder(attribute);
                        var _var1 = attributes.tryGetAttribute(fm.liveswitch.sdp.AttributeType.SetupAttribute, _var0);
                        attribute = _var0.getValue();
                        if (_var1) {
                            return attribute;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaDescription.getStreamDirectionFromCollection = function (attributes) {
                    if (arguments.length == 1) {
                        var attribute = null;
                        var _var0 = new fm.liveswitch.Holder(attribute);
                        var _var1 = attributes.tryGetAttribute(fm.liveswitch.sdp.AttributeType.DirectionAttribute, _var0);
                        attribute = _var0.getValue();
                        if (((!fm.liveswitch.Global.equals(attributes, null)) && _var1)) {
                            return attribute.getStreamDirection();
                        }
                        return fm.liveswitch.StreamDirection.Unset;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaDescription.getSupportsIceFromCollection = function (attributes) {
                    if (arguments.length == 1) {
                        return ((!fm.liveswitch.Global.equals(fm.liveswitch.sdp.MediaDescription.getIceUfragAttributeFromCollection(attributes), null)) && (!fm.liveswitch.Global.equals(fm.liveswitch.sdp.MediaDescription.getIcePasswordAttributeFromCollection(attributes), null)));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Creates an [[fm.liveswitch.sdp.mediaDescription]] instance from a string.
                @param s The string to parse.
                */
                MediaDescription.parse = function (s) {
                    if (arguments.length == 1) {
                        var strArray = fm.liveswitch.sdp.Utility.splitAndClean(s);
                        if ((!fm.liveswitch.Global.equals(strArray[0].charCodeAt(0), 109))) {
                            return null;
                        }
                        var description = new fm.liveswitch.sdp.MediaDescription(fm.liveswitch.sdp.Media.parse(strArray[0]));
                        var dictionary = {};
                        var dictionary2 = {};
                        var dictionary3 = {};
                        for (var i = 1; (i < strArray.length); i++) {
                            var str = strArray[i];
                            if ((fm.liveswitch.Global.equals(str.charCodeAt(0), 97))) {
                                var str2 = void 0;
                                var attribute = fm.liveswitch.sdp.Attribute.parse(str);
                                if (((!fm.liveswitch.Global.equals(attribute.getAttributeType(), fm.liveswitch.sdp.AttributeType.RtcpFeedbackAttribute)) && (!fm.liveswitch.Global.equals(attribute.getAttributeType(), fm.liveswitch.sdp.AttributeType.FormatParametersAttribute)))) {
                                    description.addMediaAttribute(attribute);
                                    if ((fm.liveswitch.Global.equals(attribute.getAttributeType(), fm.liveswitch.sdp.AttributeType.RtpMapAttribute))) {
                                        var attribute2 = attribute;
                                        str2 = fm.liveswitch.NumberExtensions.toString(attribute2.getPayloadType());
                                        dictionary2[str2] = attribute2;
                                        var attribute3 = null;
                                        var list = null;
                                        var _var0 = new fm.liveswitch.Holder(attribute3);
                                        var _var1 = fm.liveswitch.HashExtensions.tryGetValue(dictionary, str2, _var0);
                                        attribute3 = _var0.getValue();
                                        if (_var1) {
                                            attribute2.setRelatedFormatParametersAttribute(attribute3);
                                        }
                                        var _var2 = new fm.liveswitch.Holder(list);
                                        var _var3 = fm.liveswitch.HashExtensions.tryGetValue(dictionary3, str2, _var2);
                                        list = _var2.getValue();
                                        if (_var3) {
                                            attribute2.resetRtcpFeedbackAttributes(fm.liveswitch.ArrayExtensions.toArray(list));
                                        }
                                    }
                                }
                                else {
                                    var attribute5 = void 0;
                                    if ((fm.liveswitch.Global.equals(attribute.getAttributeType(), fm.liveswitch.sdp.AttributeType.RtcpFeedbackAttribute))) {
                                        var item = attribute;
                                        str2 = fm.liveswitch.NumberExtensions.toString(item.getPayloadType());
                                        var list2 = null;
                                        var _var4 = new fm.liveswitch.Holder(list2);
                                        var _var5 = fm.liveswitch.HashExtensions.tryGetValue(dictionary3, str2, _var4);
                                        list2 = _var4.getValue();
                                        if (!_var5) {
                                            list2 = new Array();
                                        }
                                        fm.liveswitch.ArrayExtensions.add(list2, item);
                                        dictionary3[str2] = list2;
                                        if ((fm.liveswitch.Global.equals(str2, "-1"))) {
                                            for (var _i = 0, _a = fm.liveswitch.HashExtensions.getKeys(dictionary2); _i < _a.length; _i++) {
                                                var str3 = _a[_i];
                                                dictionary2[str3].addRelatedRtcpFeedbackAttribute(item);
                                            }
                                        }
                                        else {
                                            attribute5 = null;
                                            var _var6 = new fm.liveswitch.Holder(attribute5);
                                            var _var7 = fm.liveswitch.HashExtensions.tryGetValue(dictionary2, str2, _var6);
                                            attribute5 = _var6.getValue();
                                            if (_var7) {
                                                attribute5.resetRtcpFeedbackAttributes(fm.liveswitch.ArrayExtensions.toArray(list2));
                                            }
                                        }
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(attribute.getAttributeType(), fm.liveswitch.sdp.AttributeType.FormatParametersAttribute))) {
                                            var attribute6 = attribute;
                                            str2 = fm.liveswitch.NumberExtensions.toString(attribute6.getFormat());
                                            dictionary[str2] = attribute6;
                                            attribute5 = null;
                                            var _var8 = new fm.liveswitch.Holder(attribute5);
                                            var _var9 = fm.liveswitch.HashExtensions.tryGetValue(dictionary2, str2, _var8);
                                            attribute5 = _var8.getValue();
                                            if (_var9) {
                                                attribute5.setRelatedFormatParametersAttribute(attribute6);
                                            }
                                        }
                                    }
                                }
                            }
                            if ((fm.liveswitch.Global.equals(str.charCodeAt(0), 105))) {
                                description.setMediaTitle(str.substring(2));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str.charCodeAt(0), 99))) {
                                    description.setConnectionData(fm.liveswitch.sdp.ConnectionData.parse(str));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str.charCodeAt(0), 98))) {
                                        description.addBandwidth(fm.liveswitch.sdp.Bandwidth.parse(str));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str.charCodeAt(0), 107))) {
                                            description.setEncryptionKey(fm.liveswitch.sdp.EncryptionKey.parse(str));
                                        }
                                    }
                                }
                            }
                        }
                        return description;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Adds a proposed bandwidth.
                @param bandwidth The proposed bandwidth to add.
                */
                MediaDescription.prototype.addBandwidth = function (bandwidth) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__bandwidths, bandwidth);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Adds a media-level attribute.
                @param attribute The session-level attribute to add.
                */
                MediaDescription.prototype.addMediaAttribute = function (attribute) {
                    if (arguments.length == 1) {
                        var attribute3 = void 0;
                        var type = new fm.liveswitch.Type(attribute.getTypeString());
                        var flag = fm.liveswitch.sdp.Attribute.isMediaLevel(type);
                        var flag2 = fm.liveswitch.sdp.Attribute.isSessionLevel(type);
                        if (!(flag || flag2)) {
                            throw new fm.liveswitch.Exception("Attribute is not registered.");
                        }
                        if (!(!flag2 || flag)) {
                            throw new fm.liveswitch.Exception("Attribute is session-only.");
                        }
                        if (((fm.liveswitch.Global.equals(attribute.getAttributeType(), fm.liveswitch.sdp.AttributeType.RtcpFeedbackAttribute)) || (fm.liveswitch.Global.equals(attribute.getAttributeType(), fm.liveswitch.sdp.AttributeType.FormatParametersAttribute)))) {
                            var payloadType = -1;
                            var attribute2 = null;
                            attribute3 = null;
                            if ((fm.liveswitch.Global.equals(attribute.getAttributeType(), fm.liveswitch.sdp.AttributeType.RtcpFeedbackAttribute))) {
                                attribute2 = attribute;
                                payloadType = attribute2.getPayloadType();
                            }
                            else {
                                attribute3 = attribute;
                                payloadType = attribute3.getFormat();
                            }
                            var flag3 = false;
                            if ((payloadType > -1)) {
                                var rtpMapAttributes = this.getRtpMapAttributes();
                                for (var _i = 0, rtpMapAttributes_1 = rtpMapAttributes; _i < rtpMapAttributes_1.length; _i++) {
                                    var attribute4 = rtpMapAttributes_1[_i];
                                    var attribute5 = attribute4;
                                    if ((fm.liveswitch.Global.equals(payloadType, attribute5.getPayloadType()))) {
                                        flag3 = true;
                                        if ((!fm.liveswitch.Global.equals(attribute2, null))) {
                                            attribute5.addRelatedRtcpFeedbackAttribute(attribute2);
                                        }
                                        if ((!fm.liveswitch.Global.equals(attribute3, null))) {
                                            attribute5.setRelatedFormatParametersAttribute(attribute3);
                                        }
                                    }
                                }
                            }
                            if (!flag3) {
                                fm.liveswitch.ArrayExtensions.add(this.__orphanedAttributes, attribute);
                            }
                        }
                        else {
                            this.__mediaAttributes.addAttribute(attribute);
                        }
                        if ((fm.liveswitch.Global.equals(attribute.getAttributeType(), fm.liveswitch.sdp.AttributeType.RtpMapAttribute))) {
                            var attribute6 = attribute;
                            var num2 = attribute6.getPayloadType();
                            var attributeArray2 = fm.liveswitch.ArrayExtensions.toArray(this.__orphanedAttributes);
                            for (var _a = 0, attributeArray2_1 = attributeArray2; _a < attributeArray2_1.length; _a++) {
                                var attribute7 = attributeArray2_1[_a];
                                if ((fm.liveswitch.Global.equals(attribute7.getAttributeType(), fm.liveswitch.sdp.AttributeType.RtcpFeedbackAttribute))) {
                                    var attribute8 = attribute7;
                                    if ((fm.liveswitch.Global.equals(attribute8.getPayloadType(), num2))) {
                                        attribute6.addRelatedRtcpFeedbackAttribute(attribute8);
                                        fm.liveswitch.ArrayExtensions.remove(this.__orphanedAttributes, attribute7);
                                    }
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(attribute7.getAttributeType(), fm.liveswitch.sdp.AttributeType.FormatParametersAttribute))) {
                                        attribute3 = attribute7;
                                        if ((fm.liveswitch.Global.equals(attribute3.getFormat(), num2))) {
                                            attribute6.setRelatedFormatParametersAttribute(attribute3);
                                            fm.liveswitch.ArrayExtensions.remove(this.__orphanedAttributes, attribute7);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the array of proposed bandwidths to be used by the media.
                */
                MediaDescription.prototype.getBandwidths = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.ArrayExtensions.toArray(this.__bandwidths);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets a value indicating whether this media description has been marked as bundle-only.
                */
                MediaDescription.prototype.getBundleOnly = function () {
                    if (arguments.length == 0) {
                        return (!fm.liveswitch.Global.equals(fm.liveswitch.sdp.MediaDescription.getBundleOnlyAttributeFromCollection(this.__mediaAttributes), null));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Obtains Ice Candidate attributes associated with this media description.
                */
                MediaDescription.prototype.getCandidateAttributes = function () {
                    if (arguments.length == 0) {
                        var attributes = null;
                        var _var0 = new fm.liveswitch.Holder(attributes);
                        var _var1 = this.__mediaAttributes.tryGetAttributes(fm.liveswitch.sdp.AttributeType.IceCandidateAttribute, _var0);
                        attributes = _var0.getValue();
                        if (_var1) {
                            return attributes;
                        }
                        return new Array(0);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaDescription.prototype.getCategoryAttributes = function (category) {
                    if (arguments.length == 1) {
                        var list = new Array();
                        for (var _i = 0, _a = this.__mediaAttributes.toArray(); _i < _a.length; _i++) {
                            var attribute = _a[_i];
                            if ((fm.liveswitch.Global.equals(attribute.getMultiplexingCategory(), category))) {
                                fm.liveswitch.ArrayExtensions.add(list, attribute);
                            }
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the RTCP "ccm fir" feedback attribute for the given payload type.
                @param payloadType The payload type.
                */
                MediaDescription.prototype.getCcmFirFeedbackAttribute = function (payloadType) {
                    if (arguments.length == 1) {
                        return this.getRtcpFeedbackAttribute(payloadType, fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getCcm(), fm.liveswitch.sdp.rtcp.FeedbackAttributeSubType.getFir());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the RTCP "ccm lrr" feedback attribute for the given payload type.
                @param payloadType The payload type.
                */
                MediaDescription.prototype.getCcmLrrFeedbackAttribute = function (payloadType) {
                    if (arguments.length == 1) {
                        return this.getRtcpFeedbackAttribute(payloadType, fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getCcm(), fm.liveswitch.sdp.rtcp.FeedbackAttributeSubType.getLrr());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets media-level connection data.
                */
                MediaDescription.prototype.getConnectionData = function () {
                    if (arguments.length == 0) {
                        return this._connectionData;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets CryptoAttributes associated with this MediaDescription.
                */
                MediaDescription.prototype.getCryptoAttributes = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.sdp.MediaDescription.getCryptoAttributesFromCollection(this.__mediaAttributes);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the media-level encryption key.
                */
                MediaDescription.prototype.getEncryptionKey = function () {
                    if (arguments.length == 0) {
                        return this._encryptionKey;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the Fingerprint Attribute from this MediaDescription
                */
                MediaDescription.prototype.getFingerprintAttribute = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.sdp.MediaDescription.getFingerprintAttributeFromCollection(this.__mediaAttributes);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the format parameters attribute for the given payload type.
                @param payloadType The payload type.
                */
                MediaDescription.prototype.getFormatParametersAttribute = function (payloadType) {
                    if (arguments.length == 1) {
                        var attributes = null;
                        var _var0 = new fm.liveswitch.Holder(attributes);
                        var _var1 = this.__mediaAttributes.tryGetAttributes(fm.liveswitch.sdp.AttributeType.RtpMapAttribute, _var0);
                        attributes = _var0.getValue();
                        if ((_var1 && (!fm.liveswitch.Global.equals(attributes, null)))) {
                            for (var _i = 0, attributes_2 = attributes; _i < attributes_2.length; _i++) {
                                var attribute = attributes_2[_i];
                                var attribute2 = attribute;
                                if ((fm.liveswitch.Global.equals(attribute2.getPayloadType(), payloadType))) {
                                    return attribute2.getRelatedFormatParametersAttribute();
                                }
                            }
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets a format parameter value.
                */
                MediaDescription.prototype.getFormatParameterValue = function (payloadType, formatParameterName) {
                    if (arguments.length == 2) {
                        var rtpMapAttribute = this.getRtpMapAttribute(payloadType);
                        if ((fm.liveswitch.Global.equals(rtpMapAttribute, null))) {
                            return null;
                        }
                        var relatedFormatParametersAttribute = rtpMapAttribute.getRelatedFormatParametersAttribute();
                        if ((fm.liveswitch.Global.equals(relatedFormatParametersAttribute, null))) {
                            relatedFormatParametersAttribute = this.getFormatParametersAttribute(payloadType);
                            if ((fm.liveswitch.Global.equals(relatedFormatParametersAttribute, null))) {
                                return null;
                            }
                            rtpMapAttribute.setRelatedFormatParametersAttribute(relatedFormatParametersAttribute);
                        }
                        var str = null;
                        var _var0 = new fm.liveswitch.Holder(str);
                        var _var1 = relatedFormatParametersAttribute.tryGetFormatSpecificParameter(formatParameterName, _var0);
                        str = _var0.getValue();
                        return str;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Obtains Ice Options attributes associated with this media description.
                */
                MediaDescription.prototype.getIceOptionAttributes = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.sdp.MediaDescription.getIceOptionAttributesFromCollection(this.__mediaAttributes);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the IcePasswordAttribute associated with this MediaDescription
                */
                MediaDescription.prototype.getIcePasswordAttribute = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.sdp.MediaDescription.getIcePasswordAttributeFromCollection(this.__mediaAttributes);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the IceUfragAttribute associated with this MediaDescription
                */
                MediaDescription.prototype.getIceUfragAttribute = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.sdp.MediaDescription.getIceUfragAttributeFromCollection(this.__mediaAttributes);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the attributes with Identical Multiplexing Category present in this description.
                @return Attributes with Identical Multiplexing Category present in this description.
                */
                MediaDescription.prototype.getIdenticalCategoryAttributes = function () {
                    if (arguments.length == 0) {
                        return this.getCategoryAttributes(fm.liveswitch.sdp.AttributeCategory.Identical);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets whether this media description represents an application stream (media type == "application").
                */
                MediaDescription.prototype.getIsApplication = function () {
                    if (arguments.length == 0) {
                        return this.isMediaType(fm.liveswitch.sdp.MediaType.getApplication());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets whether this media description represents an audio stream (media type == "audio").
                */
                MediaDescription.prototype.getIsAudio = function () {
                    if (arguments.length == 0) {
                        return this.isMediaType(fm.liveswitch.sdp.MediaType.getAudio());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets whether this media description represents a message stream (media type == "message").
                */
                MediaDescription.prototype.getIsMessage = function () {
                    if (arguments.length == 0) {
                        return this.isMediaType(fm.liveswitch.sdp.MediaType.getMessage());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets whether this media description represents a text stream (media type == "text").
                */
                MediaDescription.prototype.getIsText = function () {
                    if (arguments.length == 0) {
                        return this.isMediaType(fm.liveswitch.sdp.MediaType.getText());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets whether this media description represents a video stream (media type == "video").
                */
                MediaDescription.prototype.getIsVideo = function () {
                    if (arguments.length == 0) {
                        return this.isMediaType(fm.liveswitch.sdp.MediaType.getVideo());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Obtains the maximum packet time attribute.
                */
                MediaDescription.prototype.getMaxPacketTimeAttribute = function () {
                    if (arguments.length == 0) {
                        var attribute = null;
                        var _var0 = new fm.liveswitch.Holder(attribute);
                        var _var1 = this.__mediaAttributes.tryGetAttribute(fm.liveswitch.sdp.AttributeType.MaxPacketTimeAttribute, _var0);
                        attribute = _var0.getValue();
                        if (_var1) {
                            return attribute;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the media name and transport address.
                */
                MediaDescription.prototype.getMedia = function () {
                    if (arguments.length == 0) {
                        return this._media;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the array of media-level attributes.
                */
                MediaDescription.prototype.getMediaAttributes = function () {
                    if (arguments.length == 0) {
                        var list = new Array();
                        for (var _i = 0, _a = this.__mediaAttributes.toArray(); _i < _a.length; _i++) {
                            var attribute = _a[_i];
                            fm.liveswitch.ArrayExtensions.add(list, attribute);
                            if ((fm.liveswitch.Global.equals(attribute.getAttributeType(), fm.liveswitch.sdp.AttributeType.RtpMapAttribute))) {
                                var attribute2 = attribute;
                                var relatedRtcpFeedbackAttributes = attribute2.getRelatedRtcpFeedbackAttributes();
                                if ((!fm.liveswitch.Global.equals(relatedRtcpFeedbackAttributes, null))) {
                                    for (var _b = 0, relatedRtcpFeedbackAttributes_1 = relatedRtcpFeedbackAttributes; _b < relatedRtcpFeedbackAttributes_1.length; _b++) {
                                        var attribute3 = relatedRtcpFeedbackAttributes_1[_b];
                                        fm.liveswitch.ArrayExtensions.add(list, attribute3);
                                    }
                                }
                                var relatedFormatParametersAttribute = attribute2.getRelatedFormatParametersAttribute();
                                if ((!fm.liveswitch.Global.equals(relatedFormatParametersAttribute, null))) {
                                    fm.liveswitch.ArrayExtensions.add(list, relatedFormatParametersAttribute);
                                }
                            }
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Obtains the media stream identifier attribute.
                */
                MediaDescription.prototype.getMediaStreamIdentifierAttribute = function () {
                    if (arguments.length == 0) {
                        var attribute = null;
                        var _var0 = new fm.liveswitch.Holder(attribute);
                        var _var1 = this.__mediaAttributes.tryGetAttribute(fm.liveswitch.sdp.AttributeType.MediaStreamIdAttribute, _var0);
                        attribute = _var0.getValue();
                        if (_var1) {
                            return attribute;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the media title.
                */
                MediaDescription.prototype.getMediaTitle = function () {
                    if (arguments.length == 0) {
                        return this._mediaTitle;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the RTCP "nack" feedback attribute for the given payload type.
                @param payloadType The payload type.
                */
                MediaDescription.prototype.getNackFeedbackAttribute = function (payloadType) {
                    if (arguments.length == 1) {
                        return this.getRtcpFeedbackAttribute(payloadType, fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getNack(), null);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the RTCP "nack pli" feedback attribute for the given payload type.
                @param payloadType The payload type.
                */
                MediaDescription.prototype.getNackPliFeedbackAttribute = function (payloadType) {
                    if (arguments.length == 1) {
                        return this.getRtcpFeedbackAttribute(payloadType, fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getNack(), fm.liveswitch.sdp.rtcp.FeedbackAttributeSubType.getPli());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the RTCP "nack rpsi" feedback attribute for the given payload type.
                @param payloadType The payload type.
                */
                MediaDescription.prototype.getNackRpsiFeedbackAttribute = function (payloadType) {
                    if (arguments.length == 1) {
                        return this.getRtcpFeedbackAttribute(payloadType, fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getNack(), fm.liveswitch.sdp.rtcp.FeedbackAttributeSubType.getRpsi());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the RTCP "nack sli" feedback attribute for the given payload type.
                @param payloadType The payload type.
                */
                MediaDescription.prototype.getNackSliFeedbackAttribute = function (payloadType) {
                    if (arguments.length == 1) {
                        return this.getRtcpFeedbackAttribute(payloadType, fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getNack(), fm.liveswitch.sdp.rtcp.FeedbackAttributeSubType.getSli());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Obtains the packet time attribute.
                */
                MediaDescription.prototype.getPacketTimeAttribute = function () {
                    if (arguments.length == 0) {
                        var attribute = null;
                        var _var0 = new fm.liveswitch.Holder(attribute);
                        var _var1 = this.__mediaAttributes.tryGetAttribute(fm.liveswitch.sdp.AttributeType.PacketTimeAttribute, _var0);
                        attribute = _var0.getValue();
                        if (_var1) {
                            return attribute;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Obtains the RTP map attributes in preference order.
                */
                MediaDescription.prototype.getPreferredRtpMapAttributes = function () {
                    if (arguments.length == 0) {
                        var media = this.getMedia();
                        if ((fm.liveswitch.Global.equals(media, null))) {
                            return new Array(0);
                        }
                        var list = new Array();
                        var formatDescription = media.getFormatDescription();
                        if ((!fm.liveswitch.Global.equals(formatDescription, null))) {
                            var strArray = fm.liveswitch.StringExtensions.split(formatDescription, [32]);
                            for (var _i = 0, strArray_5 = strArray; _i < strArray_5.length; _i++) {
                                var str2 = strArray_5[_i];
                                var intResult = 0;
                                var _var0 = new fm.liveswitch.Holder(intResult);
                                var _var1 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(str2, _var0);
                                intResult = _var0.getValue();
                                if (_var1) {
                                    fm.liveswitch.ArrayExtensions.add(list, this.getRtpMapAttribute(intResult) || fm.liveswitch.sdp.rtp.MapAttribute.getIanaMapAttribute(intResult));
                                }
                            }
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the QualityAttribute associated with this MediaDescription.
                */
                MediaDescription.prototype.getQualityAttribute = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.sdp.MediaDescription.getQualityAttributeFromCollection(this.__mediaAttributes);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Obtains an RID attribute by its RID.
                */
                MediaDescription.prototype.getRidAttribute = function (rid) {
                    if (arguments.length == 1) {
                        var attributes = null;
                        var _var0 = new fm.liveswitch.Holder(attributes);
                        var _var1 = this.__mediaAttributes.tryGetAttributes(fm.liveswitch.sdp.AttributeType.RtpRidAttribute, _var0);
                        attributes = _var0.getValue();
                        if (_var1) {
                            for (var _i = 0, attributes_3 = attributes; _i < attributes_3.length; _i++) {
                                var attribute = attributes_3[_i];
                                var attribute2 = attribute;
                                if ((fm.liveswitch.Global.equals(attribute2.getId(), rid))) {
                                    return attribute2;
                                }
                            }
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MediaDescription.prototype.getRidAttributes = function () {
                    if (arguments.length == 0) {
                        var list = new Array();
                        var attributes = null;
                        var _var0 = new fm.liveswitch.Holder(attributes);
                        var _var1 = this.__mediaAttributes.tryGetAttributes(fm.liveswitch.sdp.AttributeType.RtpRidAttribute, _var0);
                        attributes = _var0.getValue();
                        if (_var1) {
                            for (var _i = 0, attributes_4 = attributes; _i < attributes_4.length; _i++) {
                                var attribute = attributes_4[_i];
                                fm.liveswitch.ArrayExtensions.add(list, attribute);
                            }
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else if (arguments.length == 1) {
                        var direction = arguments[0];
                        var list = new Array();
                        for (var _a = 0, _b = this.getRidAttributes(); _a < _b.length; _a++) {
                            var attribute = _b[_a];
                            if ((fm.liveswitch.Global.equals(attribute.getDirection(), direction))) {
                                fm.liveswitch.ArrayExtensions.add(list, attribute);
                            }
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets Rtcp Attributes associated with this media description.
                */
                MediaDescription.prototype.getRtcpAttribute = function () {
                    if (arguments.length == 0) {
                        var attribute = null;
                        var _var0 = new fm.liveswitch.Holder(attribute);
                        var _var1 = this.__mediaAttributes.tryGetAttribute(fm.liveswitch.sdp.AttributeType.RtcpAttribute, _var0);
                        attribute = _var0.getValue();
                        if (_var1) {
                            return attribute;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the RTCP feedback attribute for the given payload type.
                @param payloadType The payload type.
                @param type The type.
                @param subType The sub-type.
                */
                MediaDescription.prototype.getRtcpFeedbackAttribute = function (payloadType, type, subType) {
                    if (arguments.length == 3) {
                        var attributes = null;
                        var _var0 = new fm.liveswitch.Holder(attributes);
                        var _var1 = this.__mediaAttributes.tryGetAttributes(fm.liveswitch.sdp.AttributeType.RtpMapAttribute, _var0);
                        attributes = _var0.getValue();
                        if (_var1) {
                            for (var _i = 0, attributes_5 = attributes; _i < attributes_5.length; _i++) {
                                var attribute = attributes_5[_i];
                                var attribute2 = attribute;
                                if ((fm.liveswitch.Global.equals(attribute2.getPayloadType(), payloadType))) {
                                    return attribute2.getRelatedRtcpFeedbackAttribute(payloadType, type, subType);
                                }
                            }
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets a value indicating support for RTCP Multiplexing.
                */
                MediaDescription.prototype.getRtcpMultiplexingSupported = function () {
                    if (arguments.length == 0) {
                        var rtcpMultiplexingSupportFromCollection = fm.liveswitch.sdp.MediaDescription.getRtcpMultiplexingSupportFromCollection(this.__mediaAttributes);
                        if (!rtcpMultiplexingSupportFromCollection) {
                            rtcpMultiplexingSupportFromCollection = (!fm.liveswitch.Global.equals(fm.liveswitch.sdp.MediaDescription.getBundleOnlyAttributeFromCollection(this.__mediaAttributes), null));
                        }
                        return rtcpMultiplexingSupportFromCollection;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaDescription.prototype.getRtcpMuxAttribute = function () {
                    if (arguments.length == 0) {
                        var attribute = null;
                        var _var0 = new fm.liveswitch.Holder(attribute);
                        var _var1 = this.__mediaAttributes.tryGetAttribute(fm.liveswitch.sdp.AttributeType.RtcpMuxAttribute, _var0);
                        attribute = _var0.getValue();
                        if (_var1) {
                            return attribute;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Obtains the RTP ext-map attributes.
                */
                MediaDescription.prototype.getRtpExtMapAttributes = function () {
                    if (arguments.length == 0) {
                        var attributes = null;
                        var _var0 = new fm.liveswitch.Holder(attributes);
                        var _var1 = this.__mediaAttributes.tryGetAttributes(fm.liveswitch.sdp.AttributeType.RtpExtMapAttribute, _var0);
                        attributes = _var0.getValue();
                        return ((fm.liveswitch.Global.equals(attributes, null)) ? new Array(0) : attributes);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MediaDescription.prototype.getRtpMapAttribute = function () {
                    if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isNumber(arguments[1]))) {
                        var formatName = arguments[0];
                        var clockRate = arguments[1];
                        return this.getRtpMapAttribute(formatName, clockRate, null);
                    }
                    else if (arguments.length == 3) {
                        var formatName = arguments[0];
                        var clockRate = arguments[1];
                        var formatParameters = arguments[2];
                        var rtpMapAttributeIndex = -1;
                        var _var0 = new fm.liveswitch.Holder(rtpMapAttributeIndex);
                        var _var1 = this.getRtpMapAttribute(formatName, clockRate, formatParameters, _var0);
                        rtpMapAttributeIndex = _var0.getValue();
                        return _var1;
                    }
                    else if (arguments.length == 4) {
                        var formatName = arguments[0];
                        var clockRate = arguments[1];
                        var formatParameters = arguments[2];
                        var rtpMapAttributeIndex = arguments[3];
                        rtpMapAttributeIndex.setValue(-1);
                        var rtpMapAttributes = this.getRtpMapAttributes();
                        var attribute = null;
                        for (var i = 0; (i < rtpMapAttributes.length); i++) {
                            attribute = rtpMapAttributes[i];
                            if ((((fm.liveswitch.Global.equals(attribute.getFormatName(), formatName)) && (fm.liveswitch.Global.equals(attribute.getClockRate(), clockRate))) && (fm.liveswitch.Global.equals(attribute.getFormatParameters(), formatParameters)))) {
                                rtpMapAttributeIndex.setValue(i);
                                return attribute;
                            }
                        }
                        return null;
                    }
                    else if (arguments.length == 1) {
                        var payloadType = arguments[0];
                        var rtpMapAttributeIndex = -1;
                        var _var0 = new fm.liveswitch.Holder(rtpMapAttributeIndex);
                        var _var1 = this.getRtpMapAttribute(payloadType, _var0);
                        rtpMapAttributeIndex = _var0.getValue();
                        return _var1;
                    }
                    else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isNumber(arguments[0])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.Holder<number>]'))) {
                        var payloadType = arguments[0];
                        var rtpMapAttributeIndex = arguments[1];
                        rtpMapAttributeIndex.setValue(-1);
                        var rtpMapAttributes = this.getRtpMapAttributes();
                        var attribute = null;
                        for (var i = 0; (i < rtpMapAttributes.length); i++) {
                            attribute = rtpMapAttributes[i];
                            if ((fm.liveswitch.Global.equals(attribute.getPayloadType(), payloadType))) {
                                rtpMapAttributeIndex.setValue(i);
                                return attribute;
                            }
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MediaDescription.prototype.getRtpMapAttributes = function () {
                    if (arguments.length == 0) {
                        var list = new Array();
                        var attributes = null;
                        var _var0 = new fm.liveswitch.Holder(attributes);
                        var _var1 = this.__mediaAttributes.tryGetAttributes(fm.liveswitch.sdp.AttributeType.RtpMapAttribute, _var0);
                        attributes = _var0.getValue();
                        if (_var1) {
                            for (var _i = 0, attributes_6 = attributes; _i < attributes_6.length; _i++) {
                                var attribute = attributes_6[_i];
                                fm.liveswitch.ArrayExtensions.add(list, attribute);
                            }
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else if (arguments.length == 3) {
                        var formatName = arguments[0];
                        var clockRate = arguments[1];
                        var formatParameters = arguments[2];
                        var rtpMapAttributeIndices = new Array(0);
                        var _var0 = new fm.liveswitch.Holder(rtpMapAttributeIndices);
                        var _var1 = this.getRtpMapAttributes(formatName, clockRate, formatParameters, _var0);
                        rtpMapAttributeIndices = _var0.getValue();
                        return _var1;
                    }
                    else if (arguments.length == 4) {
                        var formatName = arguments[0];
                        var clockRate = arguments[1];
                        var formatParameters = arguments[2];
                        var rtpMapAttributeIndices = arguments[3];
                        var num = void 0;
                        var rtpMapAttributes = this.getRtpMapAttributes();
                        var item = null;
                        var list = new Array();
                        var list2 = new Array();
                        for (num = 0; (num < rtpMapAttributes.length); num++) {
                            item = rtpMapAttributes[num];
                            if ((((fm.liveswitch.Global.equals(item.getFormatName(), formatName)) && (fm.liveswitch.Global.equals(item.getClockRate(), clockRate))) && (fm.liveswitch.Global.equals(item.getFormatParameters(), formatParameters)))) {
                                fm.liveswitch.ArrayExtensions.add(list, item);
                                fm.liveswitch.ArrayExtensions.add(list2, num);
                            }
                        }
                        if ((fm.liveswitch.Global.equals(fm.liveswitch.ArrayExtensions.getCount(list2), 0))) {
                            rtpMapAttributeIndices.setValue(new Array(0));
                            return new Array(0);
                        }
                        rtpMapAttributeIndices.setValue(new Array(fm.liveswitch.ArrayExtensions.getCount(list2)));
                        for (num = 0; (num < fm.liveswitch.ArrayExtensions.getCount(list2)); num++) {
                            rtpMapAttributeIndices.getValue()[num] = list2[num];
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the Sctp Map Attribute, if it is present in the Media Description.
                */
                MediaDescription.prototype.getSctpMapAttribute = function () {
                    if (arguments.length == 0) {
                        var attribute = null;
                        var _var0 = new fm.liveswitch.Holder(attribute);
                        var _var1 = this.__mediaAttributes.tryGetAttribute(fm.liveswitch.sdp.AttributeType.SctpMapAttribute, _var0);
                        attribute = _var0.getValue();
                        if (_var1) {
                            return attribute;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the Sctp Max Message Size Attribute, if it is present in the Media Description.
                */
                MediaDescription.prototype.getSctpMaxMessageSizeAttribute = function () {
                    if (arguments.length == 0) {
                        var attribute = null;
                        var _var0 = new fm.liveswitch.Holder(attribute);
                        var _var1 = this.__mediaAttributes.tryGetAttribute(fm.liveswitch.sdp.AttributeType.SctpMaxMessageSizeAttribute, _var0);
                        attribute = _var0.getValue();
                        if (_var1) {
                            return attribute;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the Sctp Port Attribute, if it is present in the Media Description.
                */
                MediaDescription.prototype.getSctpPortAttribute = function () {
                    if (arguments.length == 0) {
                        var attribute = null;
                        var _var0 = new fm.liveswitch.Holder(attribute);
                        var _var1 = this.__mediaAttributes.tryGetAttribute(fm.liveswitch.sdp.AttributeType.SctpPortAttribute, _var0);
                        attribute = _var0.getValue();
                        if (_var1) {
                            return attribute;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SetupAttribute associated with this MediaDescription.
                */
                MediaDescription.prototype.getSetupAttribute = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.sdp.MediaDescription.getSetupAttributeFromCollection(this.__mediaAttributes);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Obtains the simulcast attribute.
                */
                MediaDescription.prototype.getSimulcastAttribute = function () {
                    if (arguments.length == 0) {
                        var attribute = null;
                        var _var0 = new fm.liveswitch.Holder(attribute);
                        var _var1 = this.__mediaAttributes.tryGetAttribute(fm.liveswitch.sdp.AttributeType.SimulcastAttribute, _var0);
                        attribute = _var0.getValue();
                        if (_var1) {
                            return attribute;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MediaDescription.prototype.getSsrcAttribute = function () {
                    if (arguments.length == 2) {
                        var ssrc = arguments[0];
                        var name_15 = arguments[1];
                        var ssrcAttributes = this.getSsrcAttributes(ssrc, name_15);
                        var index = 0;
                        while ((index < ssrcAttributes.length)) {
                            return ssrcAttributes[index];
                        }
                        return null;
                    }
                    else if (arguments.length == 3) {
                        var ssrc = arguments[0];
                        var name_16 = arguments[1];
                        var value = arguments[2];
                        for (var _i = 0, _a = this.getSsrcAttributes(ssrc, name_16); _i < _a.length; _i++) {
                            var attribute = _a[_i];
                            if ((fm.liveswitch.Global.equals(attribute.getValue(), value))) {
                                return attribute;
                            }
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MediaDescription.prototype.getSsrcAttributes = function () {
                    if (arguments.length == 0) {
                        var attributes = null;
                        var _var0 = new fm.liveswitch.Holder(attributes);
                        var _var1 = this.__mediaAttributes.tryGetAttributes(fm.liveswitch.sdp.AttributeType.RtpSsrcAttribute, _var0);
                        attributes = _var0.getValue();
                        var list = new Array();
                        for (var _i = 0, attributes_7 = attributes; _i < attributes_7.length; _i++) {
                            var attribute = attributes_7[_i];
                            fm.liveswitch.ArrayExtensions.add(list, attribute);
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                        var name_17 = arguments[0];
                        var list = new Array();
                        for (var _a = 0, _b = this.getSsrcAttributes(); _a < _b.length; _a++) {
                            var attribute = _b[_a];
                            if ((fm.liveswitch.Global.equals(attribute.getName(), name_17))) {
                                fm.liveswitch.ArrayExtensions.add(list, attribute);
                            }
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isNumber(arguments[0]))) {
                        var ssrc = arguments[0];
                        var list = new Array();
                        for (var _c = 0, _d = this.getSsrcAttributes(); _c < _d.length; _c++) {
                            var attribute = _d[_c];
                            if ((fm.liveswitch.Global.equals(attribute.getSynchronizationSource(), ssrc))) {
                                fm.liveswitch.ArrayExtensions.add(list, attribute);
                            }
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else if (arguments.length == 2) {
                        var ssrc = arguments[0];
                        var name_18 = arguments[1];
                        var list = new Array();
                        for (var _e = 0, _f = this.getSsrcAttributes(ssrc); _e < _f.length; _e++) {
                            var attribute = _f[_e];
                            if ((fm.liveswitch.Global.equals(attribute.getName(), name_18))) {
                                fm.liveswitch.ArrayExtensions.add(list, attribute);
                            }
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Obtains the SSRC Group attributes.
                */
                MediaDescription.prototype.getSsrcGroupAttributes = function () {
                    if (arguments.length == 0) {
                        var attributes = null;
                        var _var0 = new fm.liveswitch.Holder(attributes);
                        var _var1 = this.__mediaAttributes.tryGetAttributes(fm.liveswitch.sdp.AttributeType.RtpSsrcGroupAttribute, _var0);
                        attributes = _var0.getValue();
                        var list = new Array();
                        for (var _i = 0, attributes_8 = attributes; _i < attributes_8.length; _i++) {
                            var attribute = attributes_8[_i];
                            fm.liveswitch.ArrayExtensions.add(list, attribute);
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Obtains the SSRCS from the first SSRC Group with matching semantics.
                */
                MediaDescription.prototype.getSsrcGroupSsrcs = function (semantics) {
                    if (arguments.length == 1) {
                        for (var _i = 0, _a = this.getSsrcGroupAttributes(); _i < _a.length; _i++) {
                            var attribute = _a[_i];
                            if ((fm.liveswitch.Global.equals(attribute.getSemantics(), semantics))) {
                                return attribute.getSynchronizationSources();
                            }
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the stream direction indicated in Media Description. Getter returns StreamDirection if DirectionAttribute is present; otherwise, returns StreamDirection.Unset.
                */
                MediaDescription.prototype.getStreamDirection = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.sdp.MediaDescription.getStreamDirectionFromCollection(this.__mediaAttributes);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets a value indicating whether this SDP MediaDescription suggests support for ICE.
                */
                MediaDescription.prototype.getSupportsIce = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.sdp.MediaDescription.getSupportsIceFromCollection(this.__mediaAttributes);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the attributes with Transport Multiplexing Category present in this description.
                @return Attributes with Transport Multiplexing Category present in this description.
                */
                MediaDescription.prototype.getTransportCategoryAttributes = function () {
                    if (arguments.length == 0) {
                        return this.getCategoryAttributes(fm.liveswitch.sdp.AttributeCategory.Transport);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                DEPRECATED: Use AddMediaAttribute instead. Inserts a media-level attribute at the given index.
                @param attribute The session-level attribute to add.
                @param index The index.
                */
                MediaDescription.prototype.insertMediaAttribute = function (attribute, index) {
                    if (arguments.length == 2) {
                        this.addMediaAttribute(attribute);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaDescription.prototype.isMediaType = function (mediaType) {
                    if (arguments.length == 1) {
                        var media = this.getMedia();
                        return ((!fm.liveswitch.Global.equals(media, null)) && (fm.liveswitch.Global.equals(media.getMediaType(), mediaType)));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Orders the formats in preference order.
                @param names The format names.
                @return `false` if a media element does not exist; otherwise `true`.
                */
                MediaDescription.prototype.orderFormats = function (names) {
                    if (arguments.length == 1) {
                        var media = this.getMedia();
                        if ((fm.liveswitch.Global.equals(media, null))) {
                            return false;
                        }
                        var strArray = fm.liveswitch.StringExtensions.split(media.getFormatDescription(), [32]);
                        var list = new Array();
                        var list2 = new Array();
                        for (var _i = 0, strArray_6 = strArray; _i < strArray_6.length; _i++) {
                            var str = strArray_6[_i];
                            var intResult = 0;
                            var _var0 = new fm.liveswitch.Holder(intResult);
                            var _var1 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(str, _var0);
                            intResult = _var0.getValue();
                            if (_var1) {
                                var rtpMapAttribute = this.getRtpMapAttribute(intResult);
                                if ((!fm.liveswitch.Global.equals(rtpMapAttribute, null))) {
                                    fm.liveswitch.ArrayExtensions.add(list2, rtpMapAttribute);
                                }
                            }
                        }
                        for (var _a = 0, names_1 = names; _a < names_1.length; _a++) {
                            var str2 = names_1[_a];
                            for (var _b = 0, list2_1 = list2; _b < list2_1.length; _b++) {
                                var attribute = list2_1[_b];
                                if (fm.liveswitch.StringExtensions.isEqual(attribute.getFormatName(), str2, fm.liveswitch.StringComparison.InvariantCultureIgnoreCase)) {
                                    fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.NumberExtensions.toString(attribute.getPayloadType()));
                                }
                            }
                        }
                        for (var _c = 0, list2_2 = list2; _c < list2_2.length; _c++) {
                            var attribute = list2_2[_c];
                            var flag = false;
                            for (var _d = 0, list_5 = list; _d < list_5.length; _d++) {
                                var str3 = list_5[_d];
                                if ((fm.liveswitch.Global.equals(str3, fm.liveswitch.NumberExtensions.toString(attribute.getPayloadType())))) {
                                    flag = true;
                                    break;
                                }
                            }
                            if (!flag) {
                                fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.NumberExtensions.toString(attribute.getPayloadType()));
                            }
                        }
                        media.setFormatDescription(fm.liveswitch.StringExtensions.join(" ", fm.liveswitch.ArrayExtensions.toArray(list)));
                        return true;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MediaDescription.prototype.purgeFormat = function () {
                    if (arguments.length == 1) {
                        var name_19 = arguments[0];
                        return this.purgeFormat(name_19, -1);
                    }
                    else if (arguments.length == 2) {
                        var name_20 = arguments[0];
                        var clockRate = arguments[1];
                        return this.purgeFormat(name_20, clockRate, -1);
                    }
                    else if (arguments.length == 3) {
                        var name_21 = arguments[0];
                        var clockRate = arguments[1];
                        var channelCount = arguments[2];
                        var flag = false;
                        var rtpMapAttributes = this.getRtpMapAttributes();
                        for (var _i = 0, rtpMapAttributes_2 = rtpMapAttributes; _i < rtpMapAttributes_2.length; _i++) {
                            var attribute = rtpMapAttributes_2[_i];
                            if ((((fm.liveswitch.StringExtensions.isEqual(attribute.getFormatName(), name_21, fm.liveswitch.StringComparison.InvariantCultureIgnoreCase) && ((fm.liveswitch.Global.equals(clockRate, -1)) || (fm.liveswitch.Global.equals(clockRate, attribute.getClockRate())))) && ((fm.liveswitch.Global.equals(channelCount, -1)) || (fm.liveswitch.Global.equals(fm.liveswitch.NumberExtensions.toString(channelCount), attribute.getFormatParameters())))) && this.purgeRtpMapAttribute(attribute))) {
                                flag = true;
                            }
                        }
                        return flag;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaDescription.prototype.purgeRtpMapAttribute = function (rtpMapAttribute) {
                    if (arguments.length == 1) {
                        var media = this.getMedia();
                        if ((fm.liveswitch.Global.equals(media, null))) {
                            return false;
                        }
                        if (!this.removeMediaAttribute(rtpMapAttribute)) {
                            return false;
                        }
                        var str = fm.liveswitch.NumberExtensions.toString(rtpMapAttribute.getPayloadType());
                        var relatedRtcpFeedbackAttributes = rtpMapAttribute.getRelatedRtcpFeedbackAttributes();
                        if ((!fm.liveswitch.Global.equals(relatedRtcpFeedbackAttributes, null))) {
                            for (var _i = 0, relatedRtcpFeedbackAttributes_2 = relatedRtcpFeedbackAttributes; _i < relatedRtcpFeedbackAttributes_2.length; _i++) {
                                var attribute = relatedRtcpFeedbackAttributes_2[_i];
                                this.removeMediaAttribute(attribute);
                            }
                        }
                        var relatedFormatParametersAttribute = rtpMapAttribute.getRelatedFormatParametersAttribute();
                        if ((!fm.liveswitch.Global.equals(relatedFormatParametersAttribute, null))) {
                            this.removeMediaAttribute(relatedFormatParametersAttribute);
                        }
                        var formatDescription = media.getFormatDescription();
                        if ((!fm.liveswitch.Global.equals(formatDescription, null))) {
                            var list = new Array();
                            var strArray = fm.liveswitch.StringExtensions.split(formatDescription, [32]);
                            for (var _a = 0, strArray_7 = strArray; _a < strArray_7.length; _a++) {
                                var str3 = strArray_7[_a];
                                if ((!fm.liveswitch.Global.equals(str3, str))) {
                                    fm.liveswitch.ArrayExtensions.add(list, str3);
                                }
                            }
                            media.setFormatDescription(fm.liveswitch.StringExtensions.join(" ", fm.liveswitch.ArrayExtensions.toArray(list)));
                        }
                        for (var _b = 0, _c = this.getRtpMapAttributes(); _b < _c.length; _b++) {
                            var attribute3 = _c[_b];
                            if (fm.liveswitch.StringExtensions.isEqual(attribute3.getFormatName(), "rtx", fm.liveswitch.StringComparison.InvariantCultureIgnoreCase)) {
                                var attribute4 = attribute3.getRelatedFormatParametersAttribute();
                                if (((!fm.liveswitch.Global.equals(attribute4, null)) && (fm.liveswitch.Global.equals(attribute4.getFormatSpecificParameter("apt"), str)))) {
                                    this.purgeRtpMapAttribute(attribute3);
                                }
                            }
                        }
                        return true;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Removes a proposed bandwidth.
                @param bandwidth The proposed bandwidth to remove.
                */
                MediaDescription.prototype.removeBandwidth = function (bandwidth) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.ArrayExtensions.remove(this.__bandwidths, bandwidth);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Removes Bundle (i.e. Transport and Identical) Category Attributes.
                */
                MediaDescription.prototype.removeBundleCategoryAttributes = function () {
                    if (arguments.length == 0) {
                        this.removeTransportCategoryAttributes();
                        this.removeIdenticalCategoryAttributes();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaDescription.prototype.removeIdenticalCategoryAttributes = function () {
                    if (arguments.length == 0) {
                        var identicalCategoryAttributes = this.getIdenticalCategoryAttributes();
                        for (var _i = 0, identicalCategoryAttributes_1 = identicalCategoryAttributes; _i < identicalCategoryAttributes_1.length; _i++) {
                            var attribute = identicalCategoryAttributes_1[_i];
                            this.__mediaAttributes.remove(attribute);
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Removes a media-level attribute.
                @param attribute The session-level attribute to remove.
                */
                MediaDescription.prototype.removeMediaAttribute = function (attribute) {
                    if (arguments.length == 1) {
                        var rtpMapAttributes = void 0;
                        var attribute4 = void 0;
                        var flag = void 0;
                        var _var0 = attribute.getAttributeType();
                        if (_var0 == fm.liveswitch.sdp.AttributeType.FormatParametersAttribute) {
                            do {
                                var attribute2 = attribute;
                                rtpMapAttributes = this.getRtpMapAttributes();
                                for (var _i = 0, rtpMapAttributes_3 = rtpMapAttributes; _i < rtpMapAttributes_3.length; _i++) {
                                    var attribute3 = rtpMapAttributes_3[_i];
                                    attribute4 = attribute3;
                                    if ((!fm.liveswitch.Global.equals(attribute4.getRelatedFormatParametersAttribute(), null))) {
                                        flag = (fm.liveswitch.Global.equals(attribute4.getRelatedFormatParametersAttribute().getFormat(), attribute2.getFormat()));
                                        if (flag) {
                                            attribute4.setRelatedFormatParametersAttribute(null);
                                            return flag;
                                        }
                                    }
                                }
                                break;
                            } while (false);
                        }
                        else if (_var0 == fm.liveswitch.sdp.AttributeType.RtcpFeedbackAttribute) {
                            do {
                                var attribute5 = attribute;
                                rtpMapAttributes = this.getRtpMapAttributes();
                                for (var _a = 0, rtpMapAttributes_4 = rtpMapAttributes; _a < rtpMapAttributes_4.length; _a++) {
                                    var attribute3 = rtpMapAttributes_4[_a];
                                    attribute4 = attribute3;
                                    if ((!fm.liveswitch.Global.equals(attribute4.getRelatedRtcpFeedbackAttributes(), null))) {
                                        flag = attribute4.removeRelatedRtcpFeedbackAttribute(attribute5);
                                        if (flag) {
                                            return flag;
                                        }
                                    }
                                }
                                break;
                            } while (false);
                        }
                        else {
                            do {
                                return this.__mediaAttributes.remove(attribute);
                            } while (false);
                        }
                        return false;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaDescription.prototype.removeTransportCategoryAttributes = function () {
                    if (arguments.length == 0) {
                        var transportCategoryAttributes = this.getTransportCategoryAttributes();
                        for (var _i = 0, transportCategoryAttributes_1 = transportCategoryAttributes; _i < transportCategoryAttributes_1.length; _i++) {
                            var attribute = transportCategoryAttributes_1[_i];
                            this.__mediaAttributes.remove(attribute);
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets media-level connection data.
                */
                MediaDescription.prototype.setConnectionData = function (value) {
                    if (arguments.length == 1) {
                        this._connectionData = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the media-level encryption key.
                */
                MediaDescription.prototype.setEncryptionKey = function (value) {
                    if (arguments.length == 1) {
                        this._encryptionKey = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets a format parameter value.
                */
                MediaDescription.prototype.setFormatParameterValue = function (payloadType, formatParameterName, formatParameterValue) {
                    if (arguments.length == 3) {
                        var rtpMapAttributeIndex = -1;
                        var _var0 = new fm.liveswitch.Holder(rtpMapAttributeIndex);
                        var _var1 = this.getRtpMapAttribute(payloadType, _var0);
                        rtpMapAttributeIndex = _var0.getValue();
                        var rtpMapAttribute = _var1;
                        if ((fm.liveswitch.Global.equals(rtpMapAttribute, null))) {
                            return false;
                        }
                        var relatedFormatParametersAttribute = rtpMapAttribute.getRelatedFormatParametersAttribute();
                        if ((fm.liveswitch.Global.equals(relatedFormatParametersAttribute, null))) {
                            relatedFormatParametersAttribute = this.getFormatParametersAttribute(payloadType);
                            if ((fm.liveswitch.Global.equals(relatedFormatParametersAttribute, null))) {
                                relatedFormatParametersAttribute = new fm.liveswitch.sdp.FormatParametersAttribute(payloadType);
                                this.insertMediaAttribute(relatedFormatParametersAttribute, (rtpMapAttributeIndex + 1));
                            }
                            rtpMapAttribute.setRelatedFormatParametersAttribute(relatedFormatParametersAttribute);
                        }
                        relatedFormatParametersAttribute.setFormatSpecificParameter(formatParameterName, formatParameterValue);
                        return true;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaDescription.prototype.setMedia = function (value) {
                    if (arguments.length == 1) {
                        this._media = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the media title.
                */
                MediaDescription.prototype.setMediaTitle = function (value) {
                    if (arguments.length == 1) {
                        this._mediaTitle = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the QualityAttribute associated with this MediaDescription.
                */
                MediaDescription.prototype.setQualityAttribute = function (value) {
                    if (arguments.length == 1) {
                        this.__mediaAttributes.replaceAttribute(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets Rtcp Attributes associated with this media description.
                */
                MediaDescription.prototype.setRtcpAttribute = function (value) {
                    if (arguments.length == 1) {
                        this.__mediaAttributes.replaceAttribute(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets a value indicating support for RTCP Multiplexing.
                */
                MediaDescription.prototype.setRtcpMultiplexingSupported = function (value) {
                    if (arguments.length == 1) {
                        var rtcpMultiplexingSupportFromCollection = fm.liveswitch.sdp.MediaDescription.getRtcpMultiplexingSupportFromCollection(this.__mediaAttributes);
                        if (value) {
                            if (!rtcpMultiplexingSupportFromCollection) {
                                this.addMediaAttribute(new fm.liveswitch.sdp.rtcp.MuxAttribute());
                            }
                        }
                        else {
                            if (rtcpMultiplexingSupportFromCollection) {
                                this.__mediaAttributes.remove(fm.liveswitch.sdp.AttributeType.RtcpMuxAttribute);
                            }
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the SetupAttribute associated with this MediaDescription.
                */
                MediaDescription.prototype.setSetupAttribute = function (value) {
                    if (arguments.length == 1) {
                        this.__mediaAttributes.replaceAttribute(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the stream direction indicated in Media Description. Getter returns StreamDirection if DirectionAttribute is present; otherwise, returns StreamDirection.Unset.
                */
                MediaDescription.prototype.setStreamDirection = function (value) {
                    if (arguments.length == 1) {
                        var attribute = fm.liveswitch.sdp.DirectionAttribute.generateDirectionAttribute(value);
                        this.__mediaAttributes.replaceAttribute(attribute);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Converts this instance to a string.
                */
                MediaDescription.prototype.toString = function () {
                    if (arguments.length == 0) {
                        var builder = new fm.liveswitch.StringBuilder();
                        builder.append(fm.liveswitch.StringExtensions.concat(this.getMedia().toString(), "\r\n"));
                        if ((!fm.liveswitch.Global.equals(this.getMediaTitle(), null))) {
                            builder.append(fm.liveswitch.StringExtensions.concat("i=", this.getMediaTitle(), "\r\n"));
                        }
                        if ((!fm.liveswitch.Global.equals(this.getConnectionData(), null))) {
                            builder.append(fm.liveswitch.StringExtensions.concat(this.getConnectionData().toString(), "\r\n"));
                        }
                        for (var _i = 0, _a = this.getBandwidths(); _i < _a.length; _i++) {
                            var bandwidth = _a[_i];
                            builder.append(fm.liveswitch.StringExtensions.concat(bandwidth.toString(), "\r\n"));
                        }
                        if ((!fm.liveswitch.Global.equals(this.getEncryptionKey(), null))) {
                            builder.append(fm.liveswitch.StringExtensions.concat(this.getEncryptionKey().toString(), "\r\n"));
                        }
                        for (var _b = 0, _c = this.__mediaAttributes.toArray(); _b < _c.length; _b++) {
                            var attribute = _c[_b];
                            builder.append(fm.liveswitch.StringExtensions.concat(attribute.toString(), "\r\n"));
                            if ((fm.liveswitch.Global.equals(attribute.getAttributeType(), fm.liveswitch.sdp.AttributeType.RtpMapAttribute))) {
                                var attribute2 = attribute;
                                var relatedRtcpFeedbackAttributes = attribute2.getRelatedRtcpFeedbackAttributes();
                                if ((!fm.liveswitch.Global.equals(relatedRtcpFeedbackAttributes, null))) {
                                    for (var _d = 0, relatedRtcpFeedbackAttributes_3 = relatedRtcpFeedbackAttributes; _d < relatedRtcpFeedbackAttributes_3.length; _d++) {
                                        var attribute3 = relatedRtcpFeedbackAttributes_3[_d];
                                        builder.append(fm.liveswitch.StringExtensions.concat(attribute3.toString(), "\r\n"));
                                    }
                                }
                                var relatedFormatParametersAttribute = attribute2.getRelatedFormatParametersAttribute();
                                if ((!fm.liveswitch.Global.equals(relatedFormatParametersAttribute, null))) {
                                    builder.append(fm.liveswitch.StringExtensions.concat(relatedFormatParametersAttribute.toString(), "\r\n"));
                                }
                            }
                        }
                        return builder.toString();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Updates SDP Quality Attribute associated with this media description if one is present. Otherwise, creates a new one and inserts it into this media description.
                @param quality
                */
                MediaDescription.prototype.updateQualityAttributeValue = function (quality) {
                    if (arguments.length == 1) {
                        this.__mediaAttributes.replaceAttribute(new fm.liveswitch.sdp.QualityAttribute(quality));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return MediaDescription;
            }());
            sdp.MediaDescription = MediaDescription;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            https://tools.ietf.org/html/rfc5888#page-4 "Media stream identification" media attribute, which is used for identifying media streams within a session description. Its formatting in SDP [RFC4566] is described by the following Augmented Backus-Naur Form(ABNF) [RFC5234]:  mid-attribute      = "a=mid:" identification-tag identification-tag = token ; token is defined in RFC 4566 The identification-tag MUST be unique within an SDP session description.
            */
            var MediaStreamIdAttribute = /** @class */ (function (_super) {
                __extends(MediaStreamIdAttribute, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.mediaStreamIdAttribute]] class.
                @param idValue The identifier.
                */
                function MediaStreamIdAttribute(idValue) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var idValue_1 = __arguments[0];
                        _this = _super.call(this) || this;
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.MediaStreamIdAttribute);
                        _this.setIdentificationTag(idValue_1);
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                MediaStreamIdAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.MediaStreamIdAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.mediaStreamIdAttribute]] class.
                @param value The attribute value.
                */
                MediaStreamIdAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        return new fm.liveswitch.sdp.MediaStreamIdAttribute(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                MediaStreamIdAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        return this.getIdentificationTag();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the identification tag.
                */
                MediaStreamIdAttribute.prototype.getIdentificationTag = function () {
                    if (arguments.length == 0) {
                        return this._identificationTag;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaStreamIdAttribute.prototype.setIdentificationTag = function (value) {
                    if (arguments.length == 1) {
                        this._identificationTag = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return MediaStreamIdAttribute;
            }(fm.liveswitch.sdp.Attribute));
            sdp.MediaStreamIdAttribute = MediaStreamIdAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            https://tools.ietf.org/html/draft-ietf-mmusic-msid-08 - NB: Removed in subsequent drafts, most likely will not be used eventually. Used here for compatibility with Google Chrome and Mozilla Firefox.  A session-level attribute is defined for signalling the semantics associated with an msid grouping.This allows msid groupings with different semantics to coexist.  This OPTIONAL attribute gives the group identifier and its group semantic; it carries the same meaning as the ssrc-group-attr of RFC 5576 section 4.2, but uses the identifier of the group rather than a list of SSRC values.  This attribute MUST be present if "a=msid" is used.  An empty list of identifiers is an indication that the sender supports the indicated semantic, but has no msid groupings of the given type in the present SDP.  An identifier of "*" is an indication that all "a=msid" lines in the SDP have this specific semantic.  If "*" is not used, each msid-id in the SDP MUST appear in one and only one "msid-semantic" line. The name of the attribute is "msid-semantic". The value of the attribute is given by the following ABNF:  msid-semantic-value = msid - semantic msid-list msid-semantic = token ; see RFC 4566 msid-list = *(" " msid-id) / " *"  The semantic field holds values from the IANA registriy "Semantics for the msid-semantic SDP attribute" (which is defined in Section 6 of https://tools.ietf.org/html/draft-ietf-mmusic-msid-08 ).  An example msid-semantic might look like this, if a semantic LS was registered by IANA for the same purpose as the existing LS grouping semantic:  a= msid-semantic:LS xyzzy forolow  This means that the SDP description has two lip sync groups, with the group identifiers xyzzy and forolow, respectively.  The msid-semantic attribute can occur more than once, but MUST NOT occur more than once with the same msid-semantic value.
            */
            var MediaStreamIdSemanticAttribute = /** @class */ (function (_super) {
                __extends(MediaStreamIdSemanticAttribute, _super);
                function MediaStreamIdSemanticAttribute() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var semanticToken = __arguments[0];
                        // chained constructor: MediaStreamIdSemanticAttribute.call(this, semanticToken, "*");
                        __arguments = new Array(2);
                        __arguments[0] = semanticToken;
                        __arguments[1] = "*";
                        {
                            var semanticToken_1 = __arguments[0];
                            var msidList = __arguments[1];
                            _this = _super.call(this) || this;
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.MediaStreamIdSemanticAttribute);
                            _this.setSemanticToken(semanticToken_1);
                            _this.setMsIdList(msidList);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                        }
                    }
                    else if (__arguments.length == 2) {
                        var semanticToken = __arguments[0];
                        var msidList = __arguments[1];
                        _this = _super.call(this) || this;
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.MediaStreamIdSemanticAttribute);
                        _this.setSemanticToken(semanticToken);
                        _this.setMsIdList(msidList);
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                MediaStreamIdSemanticAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.MediaStreamIdSemanticAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.mediaStreamIdSemanticAttribute]] class.
                @param value The attribute value.
                */
                MediaStreamIdSemanticAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        var strArray = fm.liveswitch.StringExtensions.split(value, [32]);
                        if ((fm.liveswitch.Global.equals(strArray.length, 0))) {
                            return new fm.liveswitch.sdp.MediaStreamIdSemanticAttribute(fm.liveswitch.sdp.MediaStreamIdSemanticToken.Wms);
                        }
                        var semanticToken = strArray[0];
                        var semanticTokenFromString = fm.liveswitch.sdp.MediaStreamIdSemanticAttribute.getSemanticTokenFromString(semanticToken);
                        if ((fm.liveswitch.Global.equals(strArray.length, 1))) {
                            return new fm.liveswitch.sdp.MediaStreamIdSemanticAttribute(semanticTokenFromString);
                        }
                        return new fm.liveswitch.sdp.MediaStreamIdSemanticAttribute(semanticTokenFromString, value.substring((fm.liveswitch.StringExtensions.getLength(semanticToken) + 1)));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaStreamIdSemanticAttribute.getSemanticTokenFromString = function (semanticToken) {
                    if (arguments.length == 1) {
                        var str = semanticToken;
                        if (((!fm.liveswitch.Global.equals(str, null)) && (fm.liveswitch.Global.equals(str, "WMS")))) {
                            return fm.liveswitch.sdp.MediaStreamIdSemanticToken.Wms;
                        }
                        return fm.liveswitch.sdp.MediaStreamIdSemanticToken.Wms;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaStreamIdSemanticAttribute.getSemanticTokenString = function (semanticToken) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(semanticToken, fm.liveswitch.sdp.MediaStreamIdSemanticToken.Wms))) {
                            return "WMS";
                        }
                        return "WMS";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                MediaStreamIdSemanticAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        if (fm.liveswitch.StringExtensions.isNullOrEmpty(this.getMsIdList())) {
                            return fm.liveswitch.sdp.MediaStreamIdSemanticAttribute.getSemanticTokenString(this.getSemanticToken());
                        }
                        return fm.liveswitch.StringExtensions.concat(fm.liveswitch.sdp.MediaStreamIdSemanticAttribute.getSemanticTokenString(this.getSemanticToken()), " ", this.getMsIdList());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the space-delimited list of msids for which a given semantic is used. An empty list of identifiers is an indication that the sender supports the indicated semantic, but has no msid groupings of the given type in the present SDP.  An identifier of "*" is an indication that all "a=msid" lines in the SDP have this specific semantic.  If "*" is not used, each msid-id in the SDP MUST appear in one and only one "msid-semantic" line.
                */
                MediaStreamIdSemanticAttribute.prototype.getMsIdList = function () {
                    if (arguments.length == 0) {
                        return this._msIdList;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaStreamIdSemanticAttribute.prototype.getSemanticToken = function () {
                    if (arguments.length == 0) {
                        return this._semanticToken;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the space-delimited list of msids for which a given semantic is used. An empty list of identifiers is an indication that the sender supports the indicated semantic, but has no msid groupings of the given type in the present SDP.  An identifier of "*" is an indication that all "a=msid" lines in the SDP have this specific semantic.  If "*" is not used, each msid-id in the SDP MUST appear in one and only one "msid-semantic" line.
                */
                MediaStreamIdSemanticAttribute.prototype.setMsIdList = function (value) {
                    if (arguments.length == 1) {
                        this._msIdList = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MediaStreamIdSemanticAttribute.prototype.setSemanticToken = function (value) {
                    if (arguments.length == 1) {
                        this._semanticToken = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return MediaStreamIdSemanticAttribute;
            }(fm.liveswitch.sdp.Attribute));
            sdp.MediaStreamIdSemanticAttribute = MediaStreamIdSemanticAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var MediaStreamIdSemanticTokenWrapper = /** @class */ (function () {
                function MediaStreamIdSemanticTokenWrapper(value) {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var value_31 = __arguments[0];
                        //super();
                        this._value = value_31;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                MediaStreamIdSemanticTokenWrapper.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.MediaStreamIdSemanticTokenWrapper]';
                };
                MediaStreamIdSemanticTokenWrapper.prototype.toString = function () {
                    if (arguments.length == 0) {
                        if (this._value == fm.liveswitch.sdp.MediaStreamIdSemanticToken.Wms)
                            return 'Wms';
                        return '';
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return MediaStreamIdSemanticTokenWrapper;
            }());
            sdp.MediaStreamIdSemanticTokenWrapper = MediaStreamIdSemanticTokenWrapper;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            Defines valid SDP media types.
            */
            var MediaType = /** @class */ (function () {
                function MediaType() {
                }
                MediaType.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.MediaType]';
                };
                /**
                Convert a StreamType enum to an SDP media type.
                @param streamType The StreamType enum.
                */
                MediaType.fromStreamType = function (streamType) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(streamType, fm.liveswitch.StreamType.Audio))) {
                            return fm.liveswitch.sdp.MediaType.getAudio();
                        }
                        if ((fm.liveswitch.Global.equals(streamType, fm.liveswitch.StreamType.Video))) {
                            return fm.liveswitch.sdp.MediaType.getVideo();
                        }
                        if ((!fm.liveswitch.Global.equals(streamType, fm.liveswitch.StreamType.Application))) {
                            if ((fm.liveswitch.Global.equals(streamType, fm.liveswitch.StreamType.Message))) {
                                return fm.liveswitch.sdp.MediaType.getMessage();
                            }
                            if ((fm.liveswitch.Global.equals(streamType, fm.liveswitch.StreamType.Text))) {
                                return fm.liveswitch.sdp.MediaType.getText();
                            }
                        }
                        return fm.liveswitch.sdp.MediaType.getApplication();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP media type meaning "Application".
                */
                MediaType.getApplication = function () {
                    if (arguments.length == 0) {
                        return "application";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP media type meaning "Audio".
                */
                MediaType.getAudio = function () {
                    if (arguments.length == 0) {
                        return "audio";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP media type meaning "Message".
                */
                MediaType.getMessage = function () {
                    if (arguments.length == 0) {
                        return "message";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP media type meaning "Text".
                */
                MediaType.getText = function () {
                    if (arguments.length == 0) {
                        return "text";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP media type meaning "Video".
                */
                MediaType.getVideo = function () {
                    if (arguments.length == 0) {
                        return "video";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Converts an SDP media type to a StreamType enum.
                @param mediaType The SDP media type.
                */
                MediaType.toStreamType = function (mediaType) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(mediaType, fm.liveswitch.sdp.MediaType.getAudio()))) {
                            return fm.liveswitch.StreamType.Audio;
                        }
                        if ((fm.liveswitch.Global.equals(mediaType, fm.liveswitch.sdp.MediaType.getVideo()))) {
                            return fm.liveswitch.StreamType.Video;
                        }
                        if ((!fm.liveswitch.Global.equals(mediaType, fm.liveswitch.sdp.MediaType.getApplication()))) {
                            if ((fm.liveswitch.Global.equals(mediaType, fm.liveswitch.sdp.MediaType.getMessage()))) {
                                return fm.liveswitch.StreamType.Message;
                            }
                            if ((fm.liveswitch.Global.equals(mediaType, fm.liveswitch.sdp.MediaType.getText()))) {
                                return fm.liveswitch.StreamType.Text;
                            }
                        }
                        return fm.liveswitch.StreamType.Application;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return MediaType;
            }());
            sdp.MediaType = MediaType;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            An SDP message.
            */
            var Message = /** @class */ (function () {
                function Message() {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var origin_5 = __arguments[0];
                        // chained constructor: Message.call(this, origin, null);
                        __arguments = new Array(2);
                        __arguments[0] = origin_5;
                        __arguments[1] = null;
                        {
                            var origin_6 = __arguments[0];
                            var sessionName = __arguments[1];
                            // chained constructor: Message.call(this, origin, sessionName, null);
                            __arguments = new Array(3);
                            __arguments[0] = origin_6;
                            __arguments[1] = sessionName;
                            __arguments[2] = null;
                            {
                                var origin_7 = __arguments[0];
                                var sessionName_1 = __arguments[1];
                                var timeDescriptions = __arguments[2];
                                //super();
                                this.__bandwidths = new Array();
                                this.__timeDescriptions = new Array();
                                this.__sessionAttributes = new fm.liveswitch.sdp.AttributeCollection();
                                this.__mediaDescriptions = new Array();
                                if ((fm.liveswitch.Global.equals(origin_7, null))) {
                                    throw new fm.liveswitch.Exception("origin cannot be null.");
                                }
                                if ((fm.liveswitch.Global.equals(timeDescriptions, null))) {
                                    timeDescriptions = [new fm.liveswitch.sdp.TimeDescription(new fm.liveswitch.sdp.Timing())];
                                }
                                if (((fm.liveswitch.Global.equals(sessionName_1, null)) || fm.liveswitch.StringExtensions.isNullOrEmpty(fm.liveswitch.StringExtensions.trim(sessionName_1)))) {
                                    sessionName_1 = "-";
                                }
                                this.setProtocolVersion("0");
                                this.setOrigin(origin_7);
                                this.setSessionName(fm.liveswitch.StringExtensions.trim(sessionName_1));
                                fm.liveswitch.ArrayExtensions.addRange(this.__timeDescriptions, timeDescriptions);
                            }
                        }
                    }
                    else if (__arguments.length == 2) {
                        var origin_8 = __arguments[0];
                        var sessionName = __arguments[1];
                        // chained constructor: Message.call(this, origin, sessionName, null);
                        __arguments = new Array(3);
                        __arguments[0] = origin_8;
                        __arguments[1] = sessionName;
                        __arguments[2] = null;
                        {
                            var origin_9 = __arguments[0];
                            var sessionName_2 = __arguments[1];
                            var timeDescriptions = __arguments[2];
                            //super();
                            this.__bandwidths = new Array();
                            this.__timeDescriptions = new Array();
                            this.__sessionAttributes = new fm.liveswitch.sdp.AttributeCollection();
                            this.__mediaDescriptions = new Array();
                            if ((fm.liveswitch.Global.equals(origin_9, null))) {
                                throw new fm.liveswitch.Exception("origin cannot be null.");
                            }
                            if ((fm.liveswitch.Global.equals(timeDescriptions, null))) {
                                timeDescriptions = [new fm.liveswitch.sdp.TimeDescription(new fm.liveswitch.sdp.Timing())];
                            }
                            if (((fm.liveswitch.Global.equals(sessionName_2, null)) || fm.liveswitch.StringExtensions.isNullOrEmpty(fm.liveswitch.StringExtensions.trim(sessionName_2)))) {
                                sessionName_2 = "-";
                            }
                            this.setProtocolVersion("0");
                            this.setOrigin(origin_9);
                            this.setSessionName(fm.liveswitch.StringExtensions.trim(sessionName_2));
                            fm.liveswitch.ArrayExtensions.addRange(this.__timeDescriptions, timeDescriptions);
                        }
                    }
                    else if (__arguments.length == 3) {
                        var origin_10 = __arguments[0];
                        var sessionName = __arguments[1];
                        var timeDescriptions = __arguments[2];
                        //super();
                        this.__bandwidths = new Array();
                        this.__timeDescriptions = new Array();
                        this.__sessionAttributes = new fm.liveswitch.sdp.AttributeCollection();
                        this.__mediaDescriptions = new Array();
                        if ((fm.liveswitch.Global.equals(origin_10, null))) {
                            throw new fm.liveswitch.Exception("origin cannot be null.");
                        }
                        if ((fm.liveswitch.Global.equals(timeDescriptions, null))) {
                            timeDescriptions = [new fm.liveswitch.sdp.TimeDescription(new fm.liveswitch.sdp.Timing())];
                        }
                        if (((fm.liveswitch.Global.equals(sessionName, null)) || fm.liveswitch.StringExtensions.isNullOrEmpty(fm.liveswitch.StringExtensions.trim(sessionName)))) {
                            sessionName = "-";
                        }
                        this.setProtocolVersion("0");
                        this.setOrigin(origin_10);
                        this.setSessionName(fm.liveswitch.StringExtensions.trim(sessionName));
                        fm.liveswitch.ArrayExtensions.addRange(this.__timeDescriptions, timeDescriptions);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                Message.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.Message]';
                };
                /**
                Creates an [[fm.liveswitch.sdp.message]] instance from a string.
                @param s The string to parse.
                */
                Message.parse = function (s) {
                    if (arguments.length == 1) {
                        var strArray = fm.liveswitch.sdp.Utility.splitAndClean(s);
                        if ((((!fm.liveswitch.Global.equals(strArray[0].charCodeAt(0), 118)) || (!fm.liveswitch.Global.equals(strArray[1].charCodeAt(0), 111))) || (!fm.liveswitch.Global.equals(strArray[2].charCodeAt(0), 115)))) {
                            return null;
                        }
                        var origin_11 = fm.liveswitch.sdp.Origin.parse(strArray[1].substring(2));
                        var sessionName = strArray[2].substring(2);
                        var message = new fm.liveswitch.sdp.Message(origin_11, sessionName);
                        message.removeTimeDescriptions();
                        for (var i = 3; (i < strArray.length); i++) {
                            var num2 = void 0;
                            var str4 = void 0;
                            var str2 = strArray[i];
                            if ((fm.liveswitch.Global.equals(str2.charCodeAt(0), 105))) {
                                message.setSessionInformation(str2.substring(2));
                                continue;
                            }
                            if ((fm.liveswitch.Global.equals(str2.charCodeAt(0), 117))) {
                                try {
                                    message.setUri(new fm.liveswitch.Uri(str2.substring(2)));
                                }
                                catch (exception1) {
                                }
                                finally {
                                }
                                continue;
                            }
                            if ((fm.liveswitch.Global.equals(str2.charCodeAt(0), 101))) {
                                message.setEmailAddress(str2.substring(2));
                                continue;
                            }
                            if ((fm.liveswitch.Global.equals(str2.charCodeAt(0), 112))) {
                                message.setPhoneNumber(str2.substring(2));
                                continue;
                            }
                            if ((fm.liveswitch.Global.equals(str2.charCodeAt(0), 99))) {
                                message.setConnectionData(fm.liveswitch.sdp.ConnectionData.parse(str2));
                                continue;
                            }
                            if ((fm.liveswitch.Global.equals(str2.charCodeAt(0), 98))) {
                                message.addBandwidth(fm.liveswitch.sdp.Bandwidth.parse(str2));
                                continue;
                            }
                            if ((fm.liveswitch.Global.equals(str2.charCodeAt(0), 116))) {
                                var str3 = str2;
                                num2 = (i + 1);
                                while ((num2 < strArray.length)) {
                                    str4 = strArray[num2];
                                    if ((!fm.liveswitch.Global.equals(str4.charCodeAt(0), 114))) {
                                        break;
                                    }
                                    str3 = fm.liveswitch.StringExtensions.concat(str3, "\n", str4);
                                    i++;
                                    num2++;
                                }
                                message.addTimeDescription(fm.liveswitch.sdp.TimeDescription.parse(str3));
                                continue;
                            }
                            if ((fm.liveswitch.Global.equals(str2.charCodeAt(0), 122))) {
                                message.setTimeZoneAdjustments(fm.liveswitch.sdp.TimeZones.parse(str2));
                                continue;
                            }
                            if ((fm.liveswitch.Global.equals(str2.charCodeAt(0), 107))) {
                                message.setEncryptionKey(fm.liveswitch.sdp.EncryptionKey.parse(str2));
                                continue;
                            }
                            if ((fm.liveswitch.Global.equals(str2.charCodeAt(0), 97))) {
                                message.addSessionAttribute(fm.liveswitch.sdp.Attribute.parse(str2));
                                continue;
                            }
                            if ((fm.liveswitch.Global.equals(str2.charCodeAt(0), 109))) {
                                var str5 = str2;
                                for (num2 = (i + 1); (num2 < strArray.length); num2++) {
                                    str4 = strArray[num2];
                                    if ((fm.liveswitch.Global.equals(str4.charCodeAt(0), 109))) {
                                        break;
                                    }
                                    str5 = fm.liveswitch.StringExtensions.concat(str5, "\n", str4);
                                    i++;
                                }
                                message.addMediaDescription(fm.liveswitch.sdp.MediaDescription.parse(str5));
                            }
                        }
                        return message;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Adds a proposed bandwidth.
                @param bandwidth The proposed bandwidth to add.
                */
                Message.prototype.addBandwidth = function (bandwidth) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__bandwidths, bandwidth);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Adds a media description.
                @param mediaDescription The media description to add.
                */
                Message.prototype.addMediaDescription = function (mediaDescription) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__mediaDescriptions, mediaDescription);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Adds a session-level attribute.
                @param attribute The session-level attribute to add.
                */
                Message.prototype.addSessionAttribute = function (attribute) {
                    if (arguments.length == 1) {
                        if (fm.liveswitch.sdp.Attribute.isSessionLevel(new fm.liveswitch.Type(attribute.getTypeString()))) {
                            this.__sessionAttributes.addAttribute(attribute);
                        }
                        else {
                            if (fm.liveswitch.sdp.Attribute.isMediaLevel(new fm.liveswitch.Type(attribute.getTypeString()))) {
                                throw new fm.liveswitch.Exception("Attribute is media-only.");
                            }
                            throw new fm.liveswitch.Exception("Attribute is not registered.");
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Adds a start, stop, and repeat time.
                @param timeDescription The start, stop, and repeat time to add.
                */
                Message.prototype.addTimeDescription = function (timeDescription) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__timeDescriptions, timeDescription);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Message.prototype.findBundleGroups = function () {
                    if (arguments.length == 0) {
                        var bundling = fm.liveswitch.sdp.GroupSemanticsType.Bundling;
                        var groupAttributesFromCollection = fm.liveswitch.sdp.MediaDescription.getGroupAttributesFromCollection(this.__sessionAttributes);
                        if ((fm.liveswitch.Global.equals(groupAttributesFromCollection, null))) {
                            return null;
                        }
                        var groupArray = new Array(groupAttributesFromCollection.length);
                        for (var i = 0; (i < groupArray.length); i++) {
                            var attribute = groupAttributesFromCollection[i];
                            if ((fm.liveswitch.Global.equals(bundling, attribute.getSemantics()))) {
                                var group = new fm.liveswitch.sdp.BundleGroup(bundling);
                                for (var _i = 0, _a = attribute.getIds(); _i < _a.length; _i++) {
                                    var str = _a[_i];
                                    var mediaDescription = this.findMediaDescription(str);
                                    if ((!fm.liveswitch.Global.equals(mediaDescription, null))) {
                                        group.addMediaDescription(mediaDescription);
                                    }
                                }
                                groupArray[i] = group;
                            }
                        }
                        return groupArray;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Message.prototype.findMediaDescription = function (mid) {
                    if (arguments.length == 1) {
                        for (var _i = 0, _a = this.getMediaDescriptions(); _i < _a.length; _i++) {
                            var description = _a[_i];
                            var mediaStreamIdentifierAttribute = description.getMediaStreamIdentifierAttribute();
                            if (((!fm.liveswitch.Global.equals(mediaStreamIdentifierAttribute, null)) && (fm.liveswitch.Global.equals(mediaStreamIdentifierAttribute.getIdentificationTag(), mid)))) {
                                return description;
                            }
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Message.prototype.findMediaDescriptions = function (mediaType) {
                    if (arguments.length == 1) {
                        var list = new Array();
                        for (var _i = 0, _a = this.getMediaDescriptions(); _i < _a.length; _i++) {
                            var description = _a[_i];
                            var media = description.getMedia();
                            if (((!fm.liveswitch.Global.equals(media, null)) && (fm.liveswitch.Global.equals(media.getMediaType(), mediaType)))) {
                                fm.liveswitch.ArrayExtensions.add(list, description);
                            }
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the first media description of type "application".
                */
                Message.prototype.getApplicationDescription = function () {
                    if (arguments.length == 0) {
                        return this.getFirstMediaDescription(this.getApplicationDescriptions());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets any media descriptions of type "application".
                */
                Message.prototype.getApplicationDescriptions = function () {
                    if (arguments.length == 0) {
                        return this.findMediaDescriptions(fm.liveswitch.sdp.MediaType.getApplication());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the first media description of type "audio".
                */
                Message.prototype.getAudioDescription = function () {
                    if (arguments.length == 0) {
                        return this.getFirstMediaDescription(this.getAudioDescriptions());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets any media descriptions of type "audio".
                */
                Message.prototype.getAudioDescriptions = function () {
                    if (arguments.length == 0) {
                        return this.findMediaDescriptions(fm.liveswitch.sdp.MediaType.getAudio());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the array of proposed bandwidths to be used by the session.
                */
                Message.prototype.getBandwidths = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.ArrayExtensions.toArray(this.__bandwidths);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets bundle groups in this media description.
                */
                Message.prototype.getBundleGroups = function () {
                    if (arguments.length == 0) {
                        return this.findBundleGroups();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets session-level connection data.
                */
                Message.prototype.getConnectionData = function () {
                    if (arguments.length == 0) {
                        return this._connectionData;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the email address for the person responsible for the conference.
                */
                Message.prototype.getEmailAddress = function () {
                    if (arguments.length == 0) {
                        return this._emailAddress;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the session-level encryption key.
                */
                Message.prototype.getEncryptionKey = function () {
                    if (arguments.length == 0) {
                        return this._encryptionKey;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Message.prototype.getFirstMediaDescription = function (mediaDescriptions) {
                    if (arguments.length == 1) {
                        if (((fm.liveswitch.Global.equals(mediaDescriptions, null)) || (fm.liveswitch.Global.equals(mediaDescriptions.length, 0)))) {
                            return null;
                        }
                        return mediaDescriptions[0];
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the array of media descriptions.
                */
                Message.prototype.getMediaDescriptions = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.ArrayExtensions.toArray(this.__mediaDescriptions);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the first media description of type "message".
                */
                Message.prototype.getMessageDescription = function () {
                    if (arguments.length == 0) {
                        return this.getFirstMediaDescription(this.getMessageDescriptions());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets any media descriptions of type "message".
                */
                Message.prototype.getMessageDescriptions = function () {
                    if (arguments.length == 0) {
                        return this.findMediaDescriptions(fm.liveswitch.sdp.MediaType.getMessage());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the originator of the session plus a session identifier and version number.
                */
                Message.prototype.getOrigin = function () {
                    if (arguments.length == 0) {
                        return this._origin;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the phone number for the person responsible for the conference.
                */
                Message.prototype.getPhoneNumber = function () {
                    if (arguments.length == 0) {
                        return this._phoneNumber;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the version of the Session Description Protocol.
                */
                Message.prototype.getProtocolVersion = function () {
                    if (arguments.length == 0) {
                        return this._protocolVersion;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the array of session-level attributes.
                */
                Message.prototype.getSessionAttributes = function () {
                    if (arguments.length == 0) {
                        return this.__sessionAttributes.toArray();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets textual information about the session.
                */
                Message.prototype.getSessionInformation = function () {
                    if (arguments.length == 0) {
                        return this._sessionInformation;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Obtains Crypto attributes from the session-level attributes in this message. Crypto attributes may also be sent as a media-level argument, so individual media descriptions must also be examined.
                */
                Message.prototype.getSessionLevelCryptoAttributes = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.sdp.MediaDescription.getCryptoAttributesFromCollection(this.__sessionAttributes);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Obtains the stream direction indicated as a session-level attribute in this message. If none is supplied, StreamDirection.Unset is returned. Stream Direction may also be (and most likely is) indicated as a media-level attribute, so individual media descriptions must also be examined.
                */
                Message.prototype.getSessionLevelDirection = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.sdp.MediaDescription.getStreamDirectionFromCollection(this.__sessionAttributes);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Obtains Fingerprint attribute from the session-level attributes in this message. Fingerprint attribute may also be sent as a media-level argument, so individual media descriptions must also be examined.
                */
                Message.prototype.getSessionLevelFingerprintAttribute = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.sdp.MediaDescription.getFingerprintAttributeFromCollection(this.__sessionAttributes);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Obtains session-level Ice Options attributes associated with the Sdp Message.
                */
                Message.prototype.getSessionLevelIceOptionAttributes = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.sdp.MediaDescription.getIceOptionAttributesFromCollection(this.__sessionAttributes);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Obtains Ice Password Attribute from the session-level attributes in this message. Ice Password attribute may also be sent as a media-level argument, so individual media descriptions must also be examined.
                */
                Message.prototype.getSessionLevelIcePasswordAttribute = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.sdp.MediaDescription.getIcePasswordAttributeFromCollection(this.__sessionAttributes);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Obtains Ice Ufrag Attribute from the session-level attributes in this message. Ice Ufrag Attributes may also be sent as a media-level argument, so individual media descriptions must also be examined.
                */
                Message.prototype.getSessionLevelIceUfragAttribute = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.sdp.MediaDescription.getIceUfragAttributeFromCollection(this.__sessionAttributes);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Returns a value stating whether Rtcp Multiplexing support is indicated  as a session-level attribute in this message. Rtcp Multiplexing support may also be indicated via a media-level argument, so individual media descriptions must also be examined.
                */
                Message.prototype.getSessionLevelRtcpMultiplexingSupport = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.sdp.MediaDescription.getRtcpMultiplexingSupportFromCollection(this.__sessionAttributes);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Obtains session-level RTP ext-map attributes associated with the Sdp Message.
                */
                Message.prototype.getSessionLevelRtpExtMapAttributes = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.sdp.MediaDescription.getRtpExtMapAttributesFromCollection(this.__sessionAttributes);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Obtains Setup Attribute from the session-level attributes in this message. Setup Attributes may also be sent as a media-level argument, so individual media descriptions must also be examined.
                */
                Message.prototype.getSessionLevelSetupAttribute = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.sdp.MediaDescription.getSetupAttributeFromCollection(this.__sessionAttributes);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the textual session name.
                */
                Message.prototype.getSessionName = function () {
                    if (arguments.length == 0) {
                        return this._sessionName;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets a value indicating whether Trickle-ICE is supported.
                */
                Message.prototype.getSupportsTrickleIce = function () {
                    if (arguments.length == 0) {
                        var attribute = null;
                        var attribute2 = void 0;
                        var _var0 = new fm.liveswitch.Holder(attribute);
                        var _var1 = this.__sessionAttributes.tryGetAttribute(fm.liveswitch.sdp.AttributeType.IceOptionsAttribute, _var0);
                        attribute = _var0.getValue();
                        if (_var1) {
                            attribute2 = attribute;
                            if (attribute2.getTrickleOptionSet()) {
                                return true;
                            }
                        }
                        var flag2 = true;
                        for (var _i = 0, _a = this.getMediaDescriptions(); _i < _a.length; _i++) {
                            var description = _a[_i];
                            var flag3 = false;
                            var iceOptionAttributes = description.getIceOptionAttributes();
                            for (var _b = 0, iceOptionAttributes_1 = iceOptionAttributes; _b < iceOptionAttributes_1.length; _b++) {
                                var attribute3 = iceOptionAttributes_1[_b];
                                attribute2 = attribute3;
                                flag3 = (flag3 || attribute2.getTrickleOptionSet());
                            }
                            flag2 = (flag2 && flag3);
                        }
                        return flag2;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the first media description of type "text".
                */
                Message.prototype.getTextDescription = function () {
                    if (arguments.length == 0) {
                        return this.getFirstMediaDescription(this.getTextDescriptions());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets any media descriptions of type "text".
                */
                Message.prototype.getTextDescriptions = function () {
                    if (arguments.length == 0) {
                        return this.findMediaDescriptions(fm.liveswitch.sdp.MediaType.getText());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the array of start, stop, and repeat times for the session.
                */
                Message.prototype.getTimeDescriptions = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.ArrayExtensions.toArray(this.__timeDescriptions);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the time zone adjustments.
                */
                Message.prototype.getTimeZoneAdjustments = function () {
                    if (arguments.length == 0) {
                        return this._timeZoneAdjustments;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the pointer to additional information about the session.
                */
                Message.prototype.getUri = function () {
                    if (arguments.length == 0) {
                        return this._uri;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the first media description of type "video".
                */
                Message.prototype.getVideoDescription = function () {
                    if (arguments.length == 0) {
                        return this.getFirstMediaDescription(this.getVideoDescriptions());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets any media descriptions of type "video".
                */
                Message.prototype.getVideoDescriptions = function () {
                    if (arguments.length == 0) {
                        return this.findMediaDescriptions(fm.liveswitch.sdp.MediaType.getVideo());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Adds a media description at the given index.
                @param index The index at which to add the media description.
                @param mediaDescription The media description to add.
                */
                Message.prototype.insertMediaDescription = function (index, mediaDescription) {
                    if (arguments.length == 2) {
                        fm.liveswitch.ArrayExtensions.insert(this.__mediaDescriptions, index, mediaDescription);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Removes a proposed bandwidth.
                @param bandwidth The proposed bandwidth to remove.
                */
                Message.prototype.removeBandwidth = function (bandwidth) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.ArrayExtensions.remove(this.__bandwidths, bandwidth);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Removes a media description.
                @param mediaDescription The media description to remove.
                */
                Message.prototype.removeMediaDescription = function (mediaDescription) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.ArrayExtensions.remove(this.__mediaDescriptions, mediaDescription);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Removes a session-level attribute.
                @param attributeType The session-level attribute type to remove.
                */
                Message.prototype.removeSessionAttribute = function (attributeType) {
                    if (arguments.length == 1) {
                        return this.__sessionAttributes.remove(attributeType);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Removes a start, stop, and repeat time.
                @param timeDescription The start, stop, and repeat time to remove.
                */
                Message.prototype.removeTimeDescription = function (timeDescription) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.ArrayExtensions.remove(this.__timeDescriptions, timeDescription);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Removes all time descriptions.
                */
                Message.prototype.removeTimeDescriptions = function () {
                    if (arguments.length == 0) {
                        this.__timeDescriptions = new Array();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets session-level connection data.
                */
                Message.prototype.setConnectionData = function (value) {
                    if (arguments.length == 1) {
                        this._connectionData = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the email address for the person responsible for the conference.
                */
                Message.prototype.setEmailAddress = function (value) {
                    if (arguments.length == 1) {
                        this._emailAddress = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the session-level encryption key.
                */
                Message.prototype.setEncryptionKey = function (value) {
                    if (arguments.length == 1) {
                        this._encryptionKey = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Message.prototype.setOrigin = function (value) {
                    if (arguments.length == 1) {
                        this._origin = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the phone number for the person responsible for the conference.
                */
                Message.prototype.setPhoneNumber = function (value) {
                    if (arguments.length == 1) {
                        this._phoneNumber = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Message.prototype.setProtocolVersion = function (value) {
                    if (arguments.length == 1) {
                        this._protocolVersion = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets textual information about the session.
                */
                Message.prototype.setSessionInformation = function (value) {
                    if (arguments.length == 1) {
                        this._sessionInformation = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Message.prototype.setSessionName = function (value) {
                    if (arguments.length == 1) {
                        this._sessionName = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets a value indicating whether Trickle-ICE is supported.
                */
                Message.prototype.setSupportsTrickleIce = function (value) {
                    if (arguments.length == 1) {
                        var attribute = null;
                        var attribute3 = void 0;
                        for (var _i = 0, _a = this.getMediaDescriptions(); _i < _a.length; _i++) {
                            var description = _a[_i];
                            var iceOptionAttributes = description.getIceOptionAttributes();
                            var list = new Array();
                            for (var _b = 0, iceOptionAttributes_2 = iceOptionAttributes; _b < iceOptionAttributes_2.length; _b++) {
                                var attribute2 = iceOptionAttributes_2[_b];
                                attribute3 = attribute2;
                                attribute3.setTrickleOptionSet(false);
                                if ((fm.liveswitch.Global.equals(fm.liveswitch.ArrayExtensions.getCount(attribute3.getTags()), 0))) {
                                    fm.liveswitch.ArrayExtensions.add(list, attribute3);
                                }
                            }
                            for (var _c = 0, list_6 = list; _c < list_6.length; _c++) {
                                var attribute4 = list_6[_c];
                                description.removeMediaAttribute(attribute4);
                            }
                        }
                        var _var0 = new fm.liveswitch.Holder(attribute);
                        var _var1 = this.__sessionAttributes.tryGetAttribute(fm.liveswitch.sdp.AttributeType.IceOptionsAttribute, _var0);
                        attribute = _var0.getValue();
                        if (_var1) {
                            attribute3 = attribute;
                            attribute3.setTrickleOptionSet(value);
                            var tags = attribute3.getTags();
                            if (((fm.liveswitch.Global.equals(tags, null)) || (fm.liveswitch.Global.equals(fm.liveswitch.ArrayExtensions.getCount(tags), 0)))) {
                                this.__sessionAttributes.remove(attribute3);
                            }
                        }
                        else {
                            if (value) {
                                var list5 = new Array();
                                fm.liveswitch.ArrayExtensions.add(list5, new fm.liveswitch.sdp.ice.TrickleIceOptionTag());
                                var list4 = list5;
                                this.addSessionAttribute(new fm.liveswitch.sdp.ice.OptionsAttribute(list4));
                            }
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the time zone adjustments.
                */
                Message.prototype.setTimeZoneAdjustments = function (value) {
                    if (arguments.length == 1) {
                        this._timeZoneAdjustments = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the pointer to additional information about the session.
                */
                Message.prototype.setUri = function (value) {
                    if (arguments.length == 1) {
                        this._uri = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Converts this instance to a string.
                */
                Message.prototype.toString = function () {
                    if (arguments.length == 0) {
                        var builder = new fm.liveswitch.StringBuilder();
                        builder.append(fm.liveswitch.StringExtensions.concat("v=", this.getProtocolVersion(), "\r\n"));
                        builder.append(fm.liveswitch.StringExtensions.concat("o=", this.getOrigin().toString(), "\r\n"));
                        builder.append(fm.liveswitch.StringExtensions.concat("s=", this.getSessionName(), "\r\n"));
                        if ((!fm.liveswitch.Global.equals(this.getSessionInformation(), null))) {
                            builder.append(fm.liveswitch.StringExtensions.concat("i=", this.getSessionInformation(), "\r\n"));
                        }
                        if ((!fm.liveswitch.Global.equals(this.getUri(), null))) {
                            builder.append(fm.liveswitch.StringExtensions.concat("u=", this.getUri().toString(), "\r\n"));
                        }
                        if ((!fm.liveswitch.Global.equals(this.getEmailAddress(), null))) {
                            builder.append(fm.liveswitch.StringExtensions.concat("e=", this.getEmailAddress(), "\r\n"));
                        }
                        if ((!fm.liveswitch.Global.equals(this.getPhoneNumber(), null))) {
                            builder.append(fm.liveswitch.StringExtensions.concat("p=", this.getPhoneNumber(), "\r\n"));
                        }
                        if ((!fm.liveswitch.Global.equals(this.getConnectionData(), null))) {
                            builder.append(fm.liveswitch.StringExtensions.concat(this.getConnectionData().toString(), "\r\n"));
                        }
                        for (var _i = 0, _a = this.getBandwidths(); _i < _a.length; _i++) {
                            var bandwidth = _a[_i];
                            builder.append(fm.liveswitch.StringExtensions.concat(bandwidth.toString(), "\r\n"));
                        }
                        for (var _b = 0, _c = this.getTimeDescriptions(); _b < _c.length; _b++) {
                            var description = _c[_b];
                            builder.append(description.toString());
                        }
                        if ((!fm.liveswitch.Global.equals(this.getTimeZoneAdjustments(), null))) {
                            builder.append(fm.liveswitch.StringExtensions.concat(this.getTimeZoneAdjustments().toString(), "\r\n"));
                        }
                        if ((!fm.liveswitch.Global.equals(this.getEncryptionKey(), null))) {
                            builder.append(fm.liveswitch.StringExtensions.concat(this.getEncryptionKey().toString(), "\r\n"));
                        }
                        for (var _d = 0, _e = this.getSessionAttributes(); _d < _e.length; _d++) {
                            var attribute = _e[_d];
                            builder.append(fm.liveswitch.StringExtensions.concat(attribute.toString(), "\r\n"));
                        }
                        for (var _f = 0, _g = this.getMediaDescriptions(); _f < _g.length; _f++) {
                            var description2 = _g[_f];
                            builder.append(description2.toString());
                        }
                        return builder.toString();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Updates SDP Setup Value associated with the session description.
                @param setupValue
                */
                Message.prototype.updateSetupValue = function (setupValue) {
                    if (arguments.length == 1) {
                        this.removeSessionAttribute(fm.liveswitch.sdp.AttributeType.SetupAttribute);
                        var attribute = new fm.liveswitch.sdp.SetupAttribute(setupValue);
                        this.addSessionAttribute(attribute);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Message;
            }());
            sdp.Message = Message;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            Defines valid SDP network types.
            */
            var NetworkType = /** @class */ (function () {
                function NetworkType() {
                }
                NetworkType.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.NetworkType]';
                };
                /**
                Gets the SDP network type meaning "Internet".
                */
                NetworkType.getInternet = function () {
                    if (arguments.length == 0) {
                        return "IN";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return NetworkType;
            }());
            sdp.NetworkType = NetworkType;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            Defines valid SDP orientations.
            */
            var Orientation = /** @class */ (function () {
                function Orientation() {
                }
                Orientation.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.Orientation]';
                };
                /**
                Gets the SDP orientation meaning "Landscape".
                */
                Orientation.getLandscape = function () {
                    if (arguments.length == 0) {
                        return "landscape";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP orientation meaning "Portrait".
                */
                Orientation.getPortrait = function () {
                    if (arguments.length == 0) {
                        return "portrait";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP orientation meaning "Upside-Down Landscape".
                */
                Orientation.getSeascape = function () {
                    if (arguments.length == 0) {
                        return "seascape";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Orientation;
            }());
            sdp.Orientation = Orientation;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            Normally this is only used for a whiteboard or presentation tool.  It specifies the orientation of a the workspace on the screen.  It is a media-level attribute.  Permitted values are "portrait", "landscape", and "seascape" (upside-down landscape).  It is not dependent on charset.
            */
            var OrientationAttribute = /** @class */ (function (_super) {
                __extends(OrientationAttribute, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.orientationAttribute]] class.
                @param orientation The orientation of a workspace on the screen. See [[fm.liveswitch.sdp.orientationAttribute.orientation]] for possible values.
                */
                function OrientationAttribute(orientation) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var orientation_1 = __arguments[0];
                        _this = _super.call(this) || this;
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.OrientationAttribute);
                        _this.setOrientation(orientation_1);
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                OrientationAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.OrientationAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.orientationAttribute]] class.
                @param value The attribute value.
                */
                OrientationAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        return new fm.liveswitch.sdp.OrientationAttribute(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                OrientationAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        return this.getOrientation();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the orientation of a workspace on the screen. See [[fm.liveswitch.sdp.orientationAttribute.orientation]] for possible values.
                */
                OrientationAttribute.prototype.getOrientation = function () {
                    if (arguments.length == 0) {
                        return this._orientation;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                OrientationAttribute.prototype.setOrientation = function (value) {
                    if (arguments.length == 1) {
                        this._orientation = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return OrientationAttribute;
            }(fm.liveswitch.sdp.Attribute));
            sdp.OrientationAttribute = OrientationAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            An SDP origin element.
            */
            var Origin = /** @class */ (function () {
                function Origin() {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var unicastAddress = __arguments[0];
                        // chained constructor: Origin.call(this, unicastAddress, "-");
                        __arguments = new Array(2);
                        __arguments[0] = unicastAddress;
                        __arguments[1] = "-";
                        {
                            var unicastAddress_1 = __arguments[0];
                            var username = __arguments[1];
                            //super();
                            this.fmliveswitchsdpOriginInit();
                            if ((fm.liveswitch.Global.equals(unicastAddress_1, null))) {
                                throw new fm.liveswitch.Exception("unicastAddress cannot be null.");
                            }
                            this.setUsername(username);
                            this.setSessionId(this.generateSessionId());
                            this.setSessionVersion(this.generateSessionVersion());
                            this.setNetworkType(fm.liveswitch.sdp.NetworkType.getInternet());
                            this.setAddressType(fm.liveswitch.sdp.AddressType.getAddressTypeForAddress(unicastAddress_1));
                            this.setUnicastAddress(unicastAddress_1);
                        }
                    }
                    else if (__arguments.length == 2) {
                        var unicastAddress = __arguments[0];
                        var username = __arguments[1];
                        //super();
                        this.fmliveswitchsdpOriginInit();
                        if ((fm.liveswitch.Global.equals(unicastAddress, null))) {
                            throw new fm.liveswitch.Exception("unicastAddress cannot be null.");
                        }
                        this.setUsername(username);
                        this.setSessionId(this.generateSessionId());
                        this.setSessionVersion(this.generateSessionVersion());
                        this.setNetworkType(fm.liveswitch.sdp.NetworkType.getInternet());
                        this.setAddressType(fm.liveswitch.sdp.AddressType.getAddressTypeForAddress(unicastAddress));
                        this.setUnicastAddress(unicastAddress);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                Origin.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.Origin]';
                };
                Origin.prototype.fmliveswitchsdpOriginInit = function () {
                    this._sessionId = 0;
                    this._sessionVersion = 0;
                };
                /**
                Creates an [[fm.liveswitch.sdp.origin]] instance from a string.
                @param s The string to parse.
                */
                Origin.parse = function (s) {
                    if (arguments.length == 1) {
                        var strArray = fm.liveswitch.StringExtensions.split(s, [32]);
                        var username = strArray[0];
                        var unicastAddress = strArray[5];
                        var origin_12 = new fm.liveswitch.sdp.Origin(unicastAddress, username);
                        origin_12.setSessionId(fm.liveswitch.ParseAssistant.parseLongValue(strArray[1]));
                        origin_12.setSessionVersion(fm.liveswitch.ParseAssistant.parseLongValue(strArray[2]));
                        origin_12.setNetworkType(strArray[3]);
                        origin_12.setAddressType(strArray[4]);
                        return origin_12;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Origin.prototype.generateSessionId = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.LockedRandomizer.nextLong();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Origin.prototype.generateSessionVersion = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.UnixTimestamp.getUtcNow();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the type of the address. See [[fm.liveswitch.sdp.origin.addressType]] for possible values.
                */
                Origin.prototype.getAddressType = function () {
                    if (arguments.length == 0) {
                        return this._addressType;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the type of network. See [[fm.liveswitch.sdp.origin.networkType]] for possible values.
                */
                Origin.prototype.getNetworkType = function () {
                    if (arguments.length == 0) {
                        return this._networkType;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the globally unique identifier for the session.
                */
                Origin.prototype.getSessionId = function () {
                    if (arguments.length == 0) {
                        return this._sessionId;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the version number for the session.
                */
                Origin.prototype.getSessionVersion = function () {
                    if (arguments.length == 0) {
                        return this._sessionVersion;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the address of the machine from which the session was created.
                */
                Origin.prototype.getUnicastAddress = function () {
                    if (arguments.length == 0) {
                        return this._unicastAddress;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the user's login on the originating host.
                */
                Origin.prototype.getUsername = function () {
                    if (arguments.length == 0) {
                        return this._username;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the type of the address. See [[fm.liveswitch.sdp.origin.addressType]] for possible values.
                */
                Origin.prototype.setAddressType = function (value) {
                    if (arguments.length == 1) {
                        this._addressType = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the type of network. See [[fm.liveswitch.sdp.origin.networkType]] for possible values.
                */
                Origin.prototype.setNetworkType = function (value) {
                    if (arguments.length == 1) {
                        this._networkType = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the globally unique identifier for the session.
                */
                Origin.prototype.setSessionId = function (value) {
                    if (arguments.length == 1) {
                        this._sessionId = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the version number for the session.
                */
                Origin.prototype.setSessionVersion = function (value) {
                    if (arguments.length == 1) {
                        this._sessionVersion = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the address of the machine from which the session was created.
                */
                Origin.prototype.setUnicastAddress = function (value) {
                    if (arguments.length == 1) {
                        this._unicastAddress = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the user's login on the originating host.
                */
                Origin.prototype.setUsername = function (value) {
                    if (arguments.length == 1) {
                        this._username = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Converts this instance to a string.
                */
                Origin.prototype.toString = function () {
                    if (arguments.length == 0) {
                        var builder = new fm.liveswitch.StringBuilder();
                        builder.append(this.getUsername());
                        builder.append(" ");
                        builder.append(fm.liveswitch.NumberExtensions.toString(this.getSessionId()));
                        builder.append(" ");
                        builder.append(fm.liveswitch.NumberExtensions.toString(this.getSessionVersion()));
                        builder.append(" ");
                        builder.append(this.getNetworkType());
                        builder.append(" ");
                        builder.append(this.getAddressType());
                        builder.append(" ");
                        builder.append(this.getUnicastAddress());
                        return builder.toString();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Origin;
            }());
            sdp.Origin = Origin;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            This gives the length of time in milliseconds represented by the media in a packet.  This is probably only meaningful for audio data, but may be used with other media types if it makes sense.  It should not be necessary to know ptime to decode RTP or vat audio, and it is intended as a recommendation for the encoding/packetisation of audio.  It is a media-level attribute, and it is not dependent on charset.
            */
            var PacketTimeAttribute = /** @class */ (function (_super) {
                __extends(PacketTimeAttribute, _super);
                function PacketTimeAttribute() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsdpPacketTimeAttributeInit();
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.PacketTimeAttribute);
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.IdenticalPerPT);
                    }
                    else if (__arguments.length == 1) {
                        var packetTime = __arguments[0];
                        // chained constructor: PacketTimeAttribute.call(this);
                        __arguments = new Array(0);
                        {
                            _this = _super.call(this) || this;
                            _this.fmliveswitchsdpPacketTimeAttributeInit();
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.PacketTimeAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.IdenticalPerPT);
                        }
                        _this.setPacketTime(packetTime);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                PacketTimeAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.PacketTimeAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                PacketTimeAttribute.prototype.fmliveswitchsdpPacketTimeAttributeInit = function () {
                    this._packetTime = 0;
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.packetTimeAttribute]] class.
                @param value The attribute value.
                */
                PacketTimeAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        var attribute = new fm.liveswitch.sdp.PacketTimeAttribute();
                        attribute.setPacketTime(fm.liveswitch.ParseAssistant.parseIntegerValue(value));
                        return attribute;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                PacketTimeAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.NumberExtensions.toString(this.getPacketTime());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the length of time in milliseconds represented by the media in a packet.
                */
                PacketTimeAttribute.prototype.getPacketTime = function () {
                    if (arguments.length == 0) {
                        return this._packetTime;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                PacketTimeAttribute.prototype.setPacketTime = function (value) {
                    if (arguments.length == 1) {
                        this._packetTime = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return PacketTimeAttribute;
            }(fm.liveswitch.sdp.Attribute));
            sdp.PacketTimeAttribute = PacketTimeAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/EncryptionKey.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            An SDP encryption key with a method of "prompt".
            */
            var PromptEncryptionKey = /** @class */ (function (_super) {
                __extends(PromptEncryptionKey, _super);
                function PromptEncryptionKey() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                PromptEncryptionKey.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.PromptEncryptionKey]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /** @hidden */
                PromptEncryptionKey.prototype.getMethodAndValue = function () {
                    if (arguments.length == 0) {
                        return "prompt";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return PromptEncryptionKey;
            }(fm.liveswitch.sdp.EncryptionKey));
            sdp.PromptEncryptionKey = PromptEncryptionKey;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            This gives a suggestion for the quality of the encoding as an integer value.  The intention of the quality attribute for video is to specify a non-default trade-off between frame-rate and still-image quality.  For video, the value is in the range 0 to 10, with the following suggested meaning:  10 - the best still-image quality the compression scheme can give. 5  - the default behaviour given no quality suggestion. 0  - the worst still-image quality the codec designer thinks is still usable.  It is a media-level attribute, and it is not dependent on charset.
            */
            var QualityAttribute = /** @class */ (function (_super) {
                __extends(QualityAttribute, _super);
                function QualityAttribute() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsdpQualityAttributeInit();
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.QualityAttribute);
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                    }
                    else if (__arguments.length == 1) {
                        var quality = __arguments[0];
                        // chained constructor: QualityAttribute.call(this);
                        __arguments = new Array(0);
                        {
                            _this = _super.call(this) || this;
                            _this.fmliveswitchsdpQualityAttributeInit();
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.QualityAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                        }
                        if (((quality < 0) || (quality > 10))) {
                            throw new fm.liveswitch.Exception("quality must be a value in the range 0 to 10.");
                        }
                        _this.setQuality(quality);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                QualityAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.QualityAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                QualityAttribute.prototype.fmliveswitchsdpQualityAttributeInit = function () {
                    this._quality = 0;
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.qualityAttribute]] class.
                @param value The attribute value.
                */
                QualityAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        var attribute = new fm.liveswitch.sdp.QualityAttribute();
                        attribute.setQuality(fm.liveswitch.ParseAssistant.parseByteValue(value));
                        return attribute;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                QualityAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.NumberExtensions.toString(this.getQuality());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the suggested quality of the encoding as an integer value from 0-10.
                */
                QualityAttribute.prototype.getQuality = function () {
                    if (arguments.length == 0) {
                        return this._quality;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                QualityAttribute.prototype.setQuality = function (value) {
                    if (arguments.length == 1) {
                        this._quality = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return QualityAttribute;
            }(fm.liveswitch.sdp.Attribute));
            sdp.QualityAttribute = QualityAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/DirectionAttribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            This specifies that the tools should be started in receive-only mode where applicable.  It can be either a session- or media- level attribute, and it is not dependent on charset.  Note that recvonly applies to the media only, not to any associated control protocol (e.g., an RTP-based system in recvonly mode SHOULD still send RTCP packets).
            */
            var ReceiveOnlyAttribute = /** @class */ (function (_super) {
                __extends(ReceiveOnlyAttribute, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.receiveOnlyAttribute]] class.
                */
                function ReceiveOnlyAttribute() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.DirectionAttribute);
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ReceiveOnlyAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.ReceiveOnlyAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.receiveOnlyAttribute]] class.
                @param value The attribute value.
                */
                ReceiveOnlyAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        return new fm.liveswitch.sdp.ReceiveOnlyAttribute();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                ReceiveOnlyAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the stream direction.
                */
                ReceiveOnlyAttribute.prototype.getStreamDirection = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.StreamDirection.ReceiveOnly;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ReceiveOnlyAttribute;
            }(fm.liveswitch.sdp.DirectionAttribute));
            sdp.ReceiveOnlyAttribute = ReceiveOnlyAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            An SDP repeat time element.
            */
            var RepeatTime = /** @class */ (function () {
                function RepeatTime() {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 2) {
                        var repeatInterval = __arguments[0];
                        var activeDuration = __arguments[1];
                        // chained constructor: RepeatTime.call(this, repeatInterval, activeDuration, null);
                        __arguments = new Array(3);
                        __arguments[0] = repeatInterval;
                        __arguments[1] = activeDuration;
                        __arguments[2] = null;
                        {
                            var repeatInterval_1 = __arguments[0];
                            var activeDuration_1 = __arguments[1];
                            var offsets = __arguments[2];
                            //super();
                            this.__offsets = new Array();
                            this.setRepeatInterval(repeatInterval_1);
                            this.setActiveDuration(activeDuration_1);
                            if ((!fm.liveswitch.Global.equals(offsets, null))) {
                                fm.liveswitch.ArrayExtensions.addRange(this.__offsets, offsets);
                            }
                        }
                    }
                    else if (__arguments.length == 3) {
                        var repeatInterval = __arguments[0];
                        var activeDuration = __arguments[1];
                        var offsets = __arguments[2];
                        //super();
                        this.__offsets = new Array();
                        this.setRepeatInterval(repeatInterval);
                        this.setActiveDuration(activeDuration);
                        if ((!fm.liveswitch.Global.equals(offsets, null))) {
                            fm.liveswitch.ArrayExtensions.addRange(this.__offsets, offsets);
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                RepeatTime.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.RepeatTime]';
                };
                /**
                Creates an [[fm.liveswitch.sdp.repeatTime]] instance from a string.
                @param s The string to parse.
                */
                RepeatTime.parse = function (s) {
                    if (arguments.length == 1) {
                        s = s.substring(2);
                        var strArray = fm.liveswitch.StringExtensions.split(s, [32]);
                        var repeatInterval = new fm.liveswitch.TimeSpan(0, 0, fm.liveswitch.ParseAssistant.parseIntegerValue(strArray[0]));
                        var activeDuration = new fm.liveswitch.TimeSpan(0, 0, fm.liveswitch.ParseAssistant.parseIntegerValue(strArray[1]));
                        var time = new fm.liveswitch.sdp.RepeatTime(repeatInterval, activeDuration);
                        for (var i = 2; (i < strArray.length); i++) {
                            time.addOffset(new fm.liveswitch.TimeSpan(0, 0, fm.liveswitch.ParseAssistant.parseIntegerValue(strArray[2])));
                        }
                        return time;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Adds an offset from the start time.
                @param offset The offset from the start time to add.
                */
                RepeatTime.prototype.addOffset = function (offset) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__offsets, offset);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the active duration.
                */
                RepeatTime.prototype.getActiveDuration = function () {
                    if (arguments.length == 0) {
                        return this._activeDuration;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the array of offsets from the start time.
                */
                RepeatTime.prototype.getOffsets = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.ArrayExtensions.toArray(this.__offsets);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the repeat interval.
                */
                RepeatTime.prototype.getRepeatInterval = function () {
                    if (arguments.length == 0) {
                        return this._repeatInterval;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Removes an offset from the start time.
                @param offset The offset from the start time to remove.
                */
                RepeatTime.prototype.removeOffset = function (offset) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.ArrayExtensions.remove(this.__offsets, offset);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                RepeatTime.prototype.setActiveDuration = function (value) {
                    if (arguments.length == 1) {
                        this._activeDuration = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                RepeatTime.prototype.setRepeatInterval = function (value) {
                    if (arguments.length == 1) {
                        this._repeatInterval = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Converts this instance to a string.
                */
                RepeatTime.prototype.toString = function () {
                    if (arguments.length == 0) {
                        var builder = new fm.liveswitch.StringBuilder();
                        builder.append("r=");
                        builder.append(fm.liveswitch.NumberExtensions.toString(this.getRepeatInterval().getTotalSeconds()));
                        builder.append(" ");
                        var totalSeconds = this.getActiveDuration().getTotalSeconds();
                        builder.append(fm.liveswitch.NumberExtensions.toString(totalSeconds));
                        for (var _i = 0, _a = this.getOffsets(); _i < _a.length; _i++) {
                            var span = _a[_i];
                            builder.append(" ");
                            builder.append(fm.liveswitch.NumberExtensions.toString(span.getTotalSeconds()));
                        }
                        return builder.toString();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return RepeatTime;
            }());
            sdp.RepeatTime = RepeatTime;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var rtcp;
            (function (rtcp) {
                /**
                The RTCP attribute is used to document the RTCP port used for media stream, when that port is not the next higher (odd) port number following the RTP port described in the media line.
                */
                var Attribute = /** @class */ (function (_super) {
                    __extends(Attribute, _super);
                    function Attribute() {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            _this = _super.call(this) || this;
                            _this.fmliveswitchsdprtcpAttributeInit();
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.RtcpAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Transport);
                        }
                        else if (__arguments.length == 2) {
                            var port = __arguments[0];
                            var connectionAddress = __arguments[1];
                            // chained constructor: Attribute.call(this);
                            __arguments = new Array(0);
                            {
                                _this = _super.call(this) || this;
                                _this.fmliveswitchsdprtcpAttributeInit();
                                _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.RtcpAttribute);
                                _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Transport);
                            }
                            if ((fm.liveswitch.Global.equals(connectionAddress, null))) {
                                throw new fm.liveswitch.Exception("connectionAddress cannot be null.");
                            }
                            _this.update(port, connectionAddress);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    Attribute.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.rtcp.Attribute]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    Attribute.prototype.fmliveswitchsdprtcpAttributeInit = function () {
                        this._port = 0;
                    };
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.rtcp.attribute]] class.
                    @param value The attribute value.
                    */
                    Attribute.fromAttributeValue = function (value) {
                        if (arguments.length == 1) {
                            var index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                            var num2 = 0;
                            var str = null;
                            var str2 = null;
                            var str3 = null;
                            if ((fm.liveswitch.Global.equals(index, -1))) {
                                num2 = fm.liveswitch.ParseAssistant.parseIntegerValue(value);
                            }
                            else {
                                num2 = fm.liveswitch.ParseAssistant.parseIntegerValue(fm.liveswitch.StringExtensions.substring(value, 0, index));
                                value = value.substring((index + 1));
                                index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                                str = fm.liveswitch.StringExtensions.substring(value, 0, index);
                                value = value.substring((index + 1));
                                index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                                str2 = fm.liveswitch.StringExtensions.substring(value, 0, index);
                                value = value.substring((index + 1));
                                str3 = value;
                            }
                            var attribute = new fm.liveswitch.sdp.rtcp.Attribute();
                            attribute.setPort(num2);
                            attribute.setNetworkType(str);
                            attribute.setAddressType(str2);
                            attribute.setConnectionAddress(str3);
                            return attribute;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the type of the address. See [[fm.liveswitch.sdp.rtcp.attribute.addressType]] for possible values.
                    */
                    Attribute.prototype.getAddressType = function () {
                        if (arguments.length == 0) {
                            return this._addressType;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the internal value of the attribute.
                    */
                    Attribute.prototype.getAttributeValue = function () {
                        if (arguments.length == 0) {
                            var builder = new fm.liveswitch.StringBuilder();
                            builder.append(fm.liveswitch.NumberExtensions.toString(this.getPort()));
                            if ((!fm.liveswitch.Global.equals(this.getConnectionAddress(), null))) {
                                builder.append(" ");
                                builder.append(this.getNetworkType());
                                builder.append(" ");
                                builder.append(this.getAddressType());
                                builder.append(" ");
                                builder.append(this.getConnectionAddress());
                            }
                            return builder.toString();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the RTCP connection address.
                    */
                    Attribute.prototype.getConnectionAddress = function () {
                        if (arguments.length == 0) {
                            return this._connectionAddress;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the type of network. See [[fm.liveswitch.sdp.rtcp.attribute.networkType]] for possible values.
                    */
                    Attribute.prototype.getNetworkType = function () {
                        if (arguments.length == 0) {
                            return this._networkType;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the RTCP port number.
                    */
                    Attribute.prototype.getPort = function () {
                        if (arguments.length == 0) {
                            return this._port;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the type of the address. See [[fm.liveswitch.sdp.rtcp.attribute.addressType]] for possible values.
                    */
                    Attribute.prototype.setAddressType = function (value) {
                        if (arguments.length == 1) {
                            this._addressType = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the RTCP connection address.
                    */
                    Attribute.prototype.setConnectionAddress = function (value) {
                        if (arguments.length == 1) {
                            this._connectionAddress = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the type of network. See [[fm.liveswitch.sdp.rtcp.attribute.networkType]] for possible values.
                    */
                    Attribute.prototype.setNetworkType = function (value) {
                        if (arguments.length == 1) {
                            this._networkType = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the RTCP port number.
                    */
                    Attribute.prototype.setPort = function (value) {
                        if (arguments.length == 1) {
                            this._port = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Updates the port and connection address.
                    @param port The port.
                    @param connectionAddress The connection address.
                    */
                    Attribute.prototype.update = function (port, connectionAddress) {
                        if (arguments.length == 2) {
                            this.setPort(port);
                            this.setNetworkType(fm.liveswitch.sdp.NetworkType.getInternet());
                            this.setAddressType(fm.liveswitch.sdp.AddressType.getAddressTypeForAddress(connectionAddress));
                            this.setConnectionAddress(connectionAddress);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return Attribute;
                }(fm.liveswitch.sdp.Attribute));
                rtcp.Attribute = Attribute;
            })(rtcp = sdp.rtcp || (sdp.rtcp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var rtcp;
            (function (rtcp) {
                /**
                This attribute is used to indicate the capability of using RTCP feedback.
                */
                var FeedbackAttribute = /** @class */ (function (_super) {
                    __extends(FeedbackAttribute, _super);
                    function FeedbackAttribute() {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            _this = _super.call(this) || this;
                            _this.fmliveswitchsdprtcpFeedbackAttributeInit();
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.RtcpFeedbackAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.IdenticalPerPT);
                        }
                        else if (__arguments.length == 2) {
                            var payloadType = __arguments[0];
                            var type = __arguments[1];
                            // chained constructor: FeedbackAttribute.call(this, payloadType, type, null);
                            __arguments = new Array(3);
                            __arguments[0] = payloadType;
                            __arguments[1] = type;
                            __arguments[2] = null;
                            {
                                var payloadType_1 = __arguments[0];
                                var type_6 = __arguments[1];
                                var subtype = __arguments[2];
                                // chained constructor: FeedbackAttribute.call(this);
                                __arguments = new Array(0);
                                {
                                    _this = _super.call(this) || this;
                                    _this.fmliveswitchsdprtcpFeedbackAttributeInit();
                                    _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.RtcpFeedbackAttribute);
                                    _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.IdenticalPerPT);
                                }
                                _this.setPayloadType(payloadType_1);
                                _this.setType(type_6);
                                _this.setSubType(subtype);
                            }
                        }
                        else if (__arguments.length == 3) {
                            var payloadType = __arguments[0];
                            var type = __arguments[1];
                            var subtype = __arguments[2];
                            // chained constructor: FeedbackAttribute.call(this);
                            __arguments = new Array(0);
                            {
                                _this = _super.call(this) || this;
                                _this.fmliveswitchsdprtcpFeedbackAttributeInit();
                                _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.RtcpFeedbackAttribute);
                                _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.IdenticalPerPT);
                            }
                            _this.setPayloadType(payloadType);
                            _this.setType(type);
                            _this.setSubType(subtype);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    FeedbackAttribute.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.rtcp.FeedbackAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    FeedbackAttribute.prototype.fmliveswitchsdprtcpFeedbackAttributeInit = function () {
                        this._payloadType = 0;
                    };
                    /**
                    Creates a "ccm fir" feedback attribute.
                    @param payloadType The payload type.
                    */
                    FeedbackAttribute.ccmFirAttribute = function (payloadType) {
                        if (arguments.length == 1) {
                            return new fm.liveswitch.sdp.rtcp.FeedbackAttribute(payloadType, fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getCcm(), fm.liveswitch.sdp.rtcp.FeedbackAttributeSubType.getFir());
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Creates a "ccm lrr" feedback attribute.
                    @param payloadType The payload type.
                    */
                    FeedbackAttribute.ccmLrrAttribute = function (payloadType) {
                        if (arguments.length == 1) {
                            return new fm.liveswitch.sdp.rtcp.FeedbackAttribute(payloadType, fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getCcm(), fm.liveswitch.sdp.rtcp.FeedbackAttributeSubType.getLrr());
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Creates a "ccm tmmbn" feedback attribute.
                    @param payloadType The payload type.
                    */
                    FeedbackAttribute.ccmTmmbnAttribute = function (payloadType) {
                        if (arguments.length == 1) {
                            return new fm.liveswitch.sdp.rtcp.FeedbackAttribute(payloadType, fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getCcm(), fm.liveswitch.sdp.rtcp.FeedbackAttributeSubType.getTmmbn());
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Creates a "ccm tmmbr" feedback attribute.
                    @param payloadType The payload type.
                    */
                    FeedbackAttribute.ccmTmmbrAttribute = function (payloadType) {
                        if (arguments.length == 1) {
                            return new fm.liveswitch.sdp.rtcp.FeedbackAttribute(payloadType, fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getCcm(), fm.liveswitch.sdp.rtcp.FeedbackAttributeSubType.getTmmbr());
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.rtcp.feedbackAttribute]] class.
                    @param value The attribute value.
                    */
                    FeedbackAttribute.fromAttributeValue = function (value) {
                        if (arguments.length == 1) {
                            var wildcardPayloadType = fm.liveswitch.sdp.rtcp.FeedbackAttribute.getWildcardPayloadType();
                            var index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                            if ((index < 0)) {
                                fm.liveswitch.Log.error(fm.liveswitch.StringExtensions.concat("Could not parse SDP attribute (RTCP feedback): ", value));
                                return null;
                            }
                            var s = fm.liveswitch.StringExtensions.substring(value, 0, index);
                            if ((!fm.liveswitch.Global.equals(s, "*"))) {
                                wildcardPayloadType = fm.liveswitch.ParseAssistant.parseIntegerValue(s);
                            }
                            value = value.substring((index + 1));
                            var str2 = value;
                            var str3 = null;
                            index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                            if ((index >= 0)) {
                                str2 = fm.liveswitch.StringExtensions.substring(value, 0, index);
                                value = value.substring((index + 1));
                                str3 = value;
                            }
                            var attribute = new fm.liveswitch.sdp.rtcp.FeedbackAttribute();
                            attribute.setPayloadType(wildcardPayloadType);
                            attribute.setType(str2);
                            attribute.setSubType(str3);
                            return attribute;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the payload type that represents wildcard feedback attributes ('*').
                    */
                    FeedbackAttribute.getWildcardPayloadType = function () {
                        if (arguments.length == 0) {
                            return -1;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Creates a "nack" feedback attribute.
                    @param payloadType The payload type.
                    */
                    FeedbackAttribute.nackAttribute = function (payloadType) {
                        if (arguments.length == 1) {
                            return new fm.liveswitch.sdp.rtcp.FeedbackAttribute(payloadType, fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getNack());
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Creates a "nack pli" feedback attribute.
                    @param payloadType The payload type.
                    */
                    FeedbackAttribute.nackPliAttribute = function (payloadType) {
                        if (arguments.length == 1) {
                            return new fm.liveswitch.sdp.rtcp.FeedbackAttribute(payloadType, fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getNack(), fm.liveswitch.sdp.rtcp.FeedbackAttributeSubType.getPli());
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Creates a "nack rpsi" feedback attribute.
                    @param payloadType The payload type.
                    */
                    FeedbackAttribute.nackRpsiAttribute = function (payloadType) {
                        if (arguments.length == 1) {
                            return new fm.liveswitch.sdp.rtcp.FeedbackAttribute(payloadType, fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getNack(), fm.liveswitch.sdp.rtcp.FeedbackAttributeSubType.getRpsi());
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Creates a "nack sli" feedback attribute.
                    @param payloadType The payload type.
                    */
                    FeedbackAttribute.nackSliAttribute = function (payloadType) {
                        if (arguments.length == 1) {
                            return new fm.liveswitch.sdp.rtcp.FeedbackAttribute(payloadType, fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getNack(), fm.liveswitch.sdp.rtcp.FeedbackAttributeSubType.getSli());
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Creates a "goog-remb" feedback attribute.
                    @param payloadType The payload type.
                    */
                    FeedbackAttribute.rembAttribute = function (payloadType) {
                        if (arguments.length == 1) {
                            return new fm.liveswitch.sdp.rtcp.FeedbackAttribute(payloadType, fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getRemb());
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the internal value of the attribute.
                    */
                    FeedbackAttribute.prototype.getAttributeValue = function () {
                        if (arguments.length == 0) {
                            var str = ((fm.liveswitch.Global.equals(this.getPayloadType(), fm.liveswitch.sdp.rtcp.FeedbackAttribute.getWildcardPayloadType())) ? "*" : fm.liveswitch.NumberExtensions.toString(this.getPayloadType()));
                            if ((fm.liveswitch.Global.equals(this.getSubType(), null))) {
                                return fm.liveswitch.StringExtensions.format("{0} {1}", str, this.getType());
                            }
                            return fm.liveswitch.StringExtensions.format("{0} {1} {2}", str, this.getType(), this.getSubType());
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the payload type.
                    */
                    FeedbackAttribute.prototype.getPayloadType = function () {
                        if (arguments.length == 0) {
                            return this._payloadType;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the sub-type.
                    */
                    FeedbackAttribute.prototype.getSubType = function () {
                        if (arguments.length == 0) {
                            return this._subType;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the type.
                    */
                    FeedbackAttribute.prototype.getType = function () {
                        if (arguments.length == 0) {
                            return this._type;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the payload type.
                    */
                    FeedbackAttribute.prototype.setPayloadType = function (value) {
                        if (arguments.length == 1) {
                            this._payloadType = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the sub-type.
                    */
                    FeedbackAttribute.prototype.setSubType = function (value) {
                        if (arguments.length == 1) {
                            this._subType = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the type.
                    */
                    FeedbackAttribute.prototype.setType = function (value) {
                        if (arguments.length == 1) {
                            this._type = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return FeedbackAttribute;
                }(fm.liveswitch.sdp.Attribute));
                rtcp.FeedbackAttribute = FeedbackAttribute;
            })(rtcp = sdp.rtcp || (sdp.rtcp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var rtcp;
            (function (rtcp) {
                /**
                A feedback attribute sub type.
                */
                var FeedbackAttributeSubType = /** @class */ (function () {
                    function FeedbackAttributeSubType() {
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            //super();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                    }
                    FeedbackAttributeSubType.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.rtcp.FeedbackAttributeSubType]';
                    };
                    /**
                    Gets the "full intraframe refresh" sub-type.
                    */
                    FeedbackAttributeSubType.getFir = function () {
                        if (arguments.length == 0) {
                            return "fir";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the "layer refresh request" sub-type.
                    */
                    FeedbackAttributeSubType.getLrr = function () {
                        if (arguments.length == 0) {
                            return "lrr";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the "picture loss indication" sub-type.
                    */
                    FeedbackAttributeSubType.getPli = function () {
                        if (arguments.length == 0) {
                            return "pli";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the "reference picture selection indication" sub-type.
                    */
                    FeedbackAttributeSubType.getRpsi = function () {
                        if (arguments.length == 0) {
                            return "rpsi";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the "slice loss indication" sub-type.
                    */
                    FeedbackAttributeSubType.getSli = function () {
                        if (arguments.length == 0) {
                            return "sli";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the "temporary maximum media-stream bitrate notification" sub-type.
                    */
                    FeedbackAttributeSubType.getTmmbn = function () {
                        if (arguments.length == 0) {
                            return "tmmbn";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the "temporary maximum media-stream bitrate request" sub-type.
                    */
                    FeedbackAttributeSubType.getTmmbr = function () {
                        if (arguments.length == 0) {
                            return "tmmbr";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return FeedbackAttributeSubType;
                }());
                rtcp.FeedbackAttributeSubType = FeedbackAttributeSubType;
            })(rtcp = sdp.rtcp || (sdp.rtcp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var rtcp;
            (function (rtcp) {
                /**
                A feedback attribute type.
                */
                var FeedbackAttributeType = /** @class */ (function () {
                    function FeedbackAttributeType() {
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            //super();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                    }
                    FeedbackAttributeType.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.rtcp.FeedbackAttributeType]';
                    };
                    /**
                    Gets the "positive acknowledgement" type.
                    */
                    FeedbackAttributeType.getAck = function () {
                        if (arguments.length == 0) {
                            return "ack";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the application-defined type.
                    */
                    FeedbackAttributeType.getApp = function () {
                        if (arguments.length == 0) {
                            return "app";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the "codec control message" type.
                    */
                    FeedbackAttributeType.getCcm = function () {
                        if (arguments.length == 0) {
                            return "ccm";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the "negative acknowledgement" type.
                    */
                    FeedbackAttributeType.getNack = function () {
                        if (arguments.length == 0) {
                            return "nack";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the "receiver estimated maximum bitrate" type.
                    */
                    FeedbackAttributeType.getRemb = function () {
                        if (arguments.length == 0) {
                            return "goog-remb";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return FeedbackAttributeType;
                }());
                rtcp.FeedbackAttributeType = FeedbackAttributeType;
            })(rtcp = sdp.rtcp || (sdp.rtcp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var rtcp;
            (function (rtcp) {
                /**
                This attribute is used to signal that RTP and RTCP traffic should be multiplexed on a single port.  It is a property attribute, which does not take a value.
                */
                var MuxAttribute = /** @class */ (function (_super) {
                    __extends(MuxAttribute, _super);
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.rtcp.muxAttribute]] class.
                    */
                    function MuxAttribute() {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            _this = _super.call(this) || this;
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.RtcpMuxAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Identical);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    MuxAttribute.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.rtcp.MuxAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.rtcp.muxAttribute]] class.
                    @param value The attribute value.
                    */
                    MuxAttribute.fromAttributeValue = function (value) {
                        if (arguments.length == 1) {
                            return new fm.liveswitch.sdp.rtcp.MuxAttribute();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the internal value of the attribute.
                    */
                    MuxAttribute.prototype.getAttributeValue = function () {
                        if (arguments.length == 0) {
                            return null;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return MuxAttribute;
                }(fm.liveswitch.sdp.Attribute));
                rtcp.MuxAttribute = MuxAttribute;
            })(rtcp = sdp.rtcp || (sdp.rtcp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var rtp;
            (function (rtp) {
                /**
                https://tools.ietf.org/html/rfc5285#section-5 Stream or media-level attribute used to indicate the presence of RTP Header Extensions, and the mapping of local identifiers used in the header extension to a larger namespace.  A usable mapping MUST use IDs in the valid range, and each ID in this range MUST be used only once for each media (or only once if the mappings are session level).  Mappings that do not conform to these rules MAY be presented, for instance, during offer/answer negotiation as described in the next section, but remapping to conformant values is necessary before they can be applied.  Each extension is named by a URI. Each local identifier potentially used in the stream is mapped to a string using an attribute of the form: a=extmap:VALUE["/"DIRECTION] URI EXTENSIONATTRIBUTES Where URI is a URI, as above, VALUE is the local identifier (ID) of this extension and is an integer in the valid range inclusive (0 is reserved for padding in both forms, and 15 is reserved in the one-byte header form), and direction is one of "sendonly", "recvonly", "sendrecv", or "inactive" (without the quotes). Example:  a=extmap:1 http://example.com/082005/ext.htm#ttime a=extmap:2/sendrecv http://example.com/082005/ext.htm#xmeta short
                */
                var ExtMapAttribute = /** @class */ (function (_super) {
                    __extends(ExtMapAttribute, _super);
                    function ExtMapAttribute() {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            _this = _super.call(this) || this;
                            _this.fmliveswitchsdprtpExtMapAttributeInit();
                            _this.__direction = fm.liveswitch.StreamDirection.Unset;
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.RtpExtMapAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Special);
                        }
                        else if (__arguments.length == 2) {
                            var idValue = __arguments[0];
                            var uri = __arguments[1];
                            // chained constructor: ExtMapAttribute.call(this);
                            __arguments = new Array(0);
                            {
                                _this = _super.call(this) || this;
                                _this.fmliveswitchsdprtpExtMapAttributeInit();
                                _this.__direction = fm.liveswitch.StreamDirection.Unset;
                                _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.RtpExtMapAttribute);
                                _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Special);
                            }
                            _this.setId(idValue);
                            _this.setUri(uri);
                        }
                        else if (__arguments.length == 3) {
                            var idValue = __arguments[0];
                            var uri = __arguments[1];
                            var direction = __arguments[2];
                            // chained constructor: ExtMapAttribute.call(this, idValue, uri);
                            __arguments = new Array(2);
                            __arguments[0] = idValue;
                            __arguments[1] = uri;
                            {
                                var idValue_2 = __arguments[0];
                                var uri_1 = __arguments[1];
                                // chained constructor: ExtMapAttribute.call(this);
                                __arguments = new Array(0);
                                {
                                    _this = _super.call(this) || this;
                                    _this.fmliveswitchsdprtpExtMapAttributeInit();
                                    _this.__direction = fm.liveswitch.StreamDirection.Unset;
                                    _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.RtpExtMapAttribute);
                                    _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Special);
                                }
                                _this.setId(idValue_2);
                                _this.setUri(uri_1);
                            }
                            _this.setDirection(direction);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    ExtMapAttribute.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.rtp.ExtMapAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    ExtMapAttribute.prototype.fmliveswitchsdprtpExtMapAttributeInit = function () {
                        this._id = 0;
                    };
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.rtp.mapAttribute]] class.
                    @param value The attribute value.
                    */
                    ExtMapAttribute.fromAttributeValue = function (value) {
                        if (arguments.length == 1) {
                            var index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                            var num2 = fm.liveswitch.StringExtensions.indexOf(value, "/");
                            var flag = ((num2 > -1) && (index > num2));
                            var sendReceive = fm.liveswitch.StreamDirection.SendReceive;
                            var idValue = fm.liveswitch.ParseAssistant.parseIntegerValue(fm.liveswitch.StringExtensions.substring(value, 0, ((num2 > -1) ? fm.liveswitch.MathAssistant.min(index, num2) : index)));
                            if (flag) {
                                sendReceive = fm.liveswitch.StreamDirectionHelper.directionFromString(fm.liveswitch.StringExtensions.substring(value, (num2 + 1), ((index - num2) - 1)));
                            }
                            var str2 = value.substring((index + 1));
                            var length_39 = fm.liveswitch.StringExtensions.indexOf(str2, " ");
                            var uri = "";
                            var str4 = "";
                            if ((fm.liveswitch.Global.equals(length_39, -1))) {
                                uri = str2;
                            }
                            else {
                                uri = fm.liveswitch.StringExtensions.substring(str2, 0, length_39);
                                str4 = str2.substring((length_39 + 1));
                            }
                            var attribute = new fm.liveswitch.sdp.rtp.ExtMapAttribute(idValue, uri);
                            if (flag) {
                                attribute.setDirection(sendReceive);
                            }
                            if (!fm.liveswitch.StringExtensions.isNullOrEmpty(str4)) {
                                attribute.setExtensionAttributes(str4);
                            }
                            return attribute;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the internal value of the attribute.
                    */
                    ExtMapAttribute.prototype.getAttributeValue = function () {
                        if (arguments.length == 0) {
                            var builder = new fm.liveswitch.StringBuilder();
                            builder.append(fm.liveswitch.NumberExtensions.toString(this.getId()));
                            if ((!fm.liveswitch.Global.equals(this.getDirection(), fm.liveswitch.StreamDirection.Unset))) {
                                var str = fm.liveswitch.StreamDirectionHelper.directionToString(this.getDirection());
                                builder.append("/");
                                builder.append(str);
                            }
                            builder.append(" ");
                            builder.append(this.getUri());
                            if (!fm.liveswitch.StringExtensions.isNullOrEmpty(this.getExtensionAttributes())) {
                                builder.append(" ");
                                builder.append(this.getExtensionAttributes());
                            }
                            return builder.toString();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the direction of this extension (optional). If not present, stream direction is assumed to be the direction of the extension.
                    */
                    ExtMapAttribute.prototype.getDirection = function () {
                        if (arguments.length == 0) {
                            return this.__direction;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets extension attributes (optional).
                    */
                    ExtMapAttribute.prototype.getExtensionAttributes = function () {
                        if (arguments.length == 0) {
                            return this._extensionAttributes;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the local identifier of this extension.
                    */
                    ExtMapAttribute.prototype.getId = function () {
                        if (arguments.length == 0) {
                            return this._id;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the well-known URI of this extension
                    */
                    ExtMapAttribute.prototype.getUri = function () {
                        if (arguments.length == 0) {
                            return this._uri;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the direction of this extension (optional). If not present, stream direction is assumed to be the direction of the extension.
                    */
                    ExtMapAttribute.prototype.setDirection = function (value) {
                        if (arguments.length == 1) {
                            this.__direction = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets extension attributes (optional).
                    */
                    ExtMapAttribute.prototype.setExtensionAttributes = function (value) {
                        if (arguments.length == 1) {
                            this._extensionAttributes = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the local identifier of this extension.
                    */
                    ExtMapAttribute.prototype.setId = function (value) {
                        if (arguments.length == 1) {
                            this._id = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    ExtMapAttribute.prototype.setUri = function (value) {
                        if (arguments.length == 1) {
                            this._uri = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return ExtMapAttribute;
                }(fm.liveswitch.sdp.Attribute));
                rtp.ExtMapAttribute = ExtMapAttribute;
            })(rtp = sdp.rtp || (sdp.rtp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var rtp;
            (function (rtp) {
                /** @hidden */
                var FeedbackAttributeCollection = /** @class */ (function () {
                    function FeedbackAttributeCollection() {
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            //super();
                            this.__attributes = {};
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                    }
                    FeedbackAttributeCollection.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.rtp.FeedbackAttributeCollection]';
                    };
                    FeedbackAttributeCollection.prototype.addAttribute = function (attribute) {
                        if (arguments.length == 1) {
                            var key = this.calculateFeedbackAttributeKey(attribute.getPayloadType(), attribute.getType(), attribute.getSubType());
                            if (!fm.liveswitch.HashExtensions.containsKey(this.__attributes, key)) {
                                fm.liveswitch.HashExtensions.add(this.__attributes, key, attribute);
                                return true;
                            }
                            return false;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    FeedbackAttributeCollection.prototype.calculateFeedbackAttributeKey = function (payloadType, feedbackAttributeType, subType) {
                        if (arguments.length == 3) {
                            var str = (fm.liveswitch.StringExtensions.isNullOrEmpty(feedbackAttributeType) ? "null" : feedbackAttributeType);
                            var str2 = (fm.liveswitch.StringExtensions.isNullOrEmpty(subType) ? "null" : subType);
                            var str3 = fm.liveswitch.NumberExtensions.toString(payloadType);
                            return fm.liveswitch.StringExtensions.concat([str, "&", str2, "&", str3]);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    FeedbackAttributeCollection.prototype.clear = function () {
                        if (arguments.length == 0) {
                            fm.liveswitch.HashExtensions.clear(this.__attributes);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    FeedbackAttributeCollection.prototype.remove = function (attribute) {
                        if (arguments.length == 1) {
                            var key = this.calculateFeedbackAttributeKey(attribute.getPayloadType(), attribute.getType(), attribute.getSubType());
                            return fm.liveswitch.HashExtensions.remove(this.__attributes, key);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    FeedbackAttributeCollection.prototype.toArray = function () {
                        if (arguments.length == 0) {
                            var list = new Array();
                            for (var _i = 0, _a = fm.liveswitch.HashExtensions.getValues(this.__attributes); _i < _a.length; _i++) {
                                var attribute = _a[_i];
                                fm.liveswitch.ArrayExtensions.add(list, attribute);
                            }
                            return fm.liveswitch.ArrayExtensions.toArray(list);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    FeedbackAttributeCollection.prototype.tryGetFeedbackAttribute = function (payloadType, feedbackAttributeType, subType, feedbackAttribute) {
                        if (arguments.length == 4) {
                            var attribute = null;
                            var key = this.calculateFeedbackAttributeKey(payloadType, feedbackAttributeType, subType);
                            var _var0 = new fm.liveswitch.Holder(attribute);
                            var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this.__attributes, key, _var0);
                            attribute = _var0.getValue();
                            if (_var1) {
                                feedbackAttribute.setValue(attribute);
                                return true;
                            }
                            feedbackAttribute.setValue(null);
                            return false;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return FeedbackAttributeCollection;
                }());
                rtp.FeedbackAttributeCollection = FeedbackAttributeCollection;
            })(rtp = sdp.rtp || (sdp.rtp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var rtp;
            (function (rtp) {
                /**
                This attribute maps from an RTP payload type number (as used in an "m=" line) to an format name denoting the payload format to be used.  It also provides information on the clock rate and format parameters.  It is a media-level attribute that is not dependent on charset.
                */
                var MapAttribute = /** @class */ (function (_super) {
                    __extends(MapAttribute, _super);
                    function MapAttribute() {
                        var _this = this;
                        fm.liveswitch.sdp.rtp.MapAttribute.fmliveswitchsdprtpMapAttributeInitialize();
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            _this = _super.call(this) || this;
                            _this.fmliveswitchsdprtpMapAttributeInit();
                            _this.__relatedRtcpFeedbackAttributes = new fm.liveswitch.sdp.rtp.FeedbackAttributeCollection();
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.RtpMapAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.IdenticalPerPT);
                        }
                        else if (__arguments.length == 3) {
                            var payloadType = __arguments[0];
                            var formatName = __arguments[1];
                            var clockRate = __arguments[2];
                            // chained constructor: MapAttribute.call(this, payloadType, formatName, clockRate, null);
                            __arguments = new Array(4);
                            __arguments[0] = payloadType;
                            __arguments[1] = formatName;
                            __arguments[2] = clockRate;
                            __arguments[3] = null;
                            {
                                var payloadType_2 = __arguments[0];
                                var formatName_1 = __arguments[1];
                                var clockRate_5 = __arguments[2];
                                var formatParameters = __arguments[3];
                                // chained constructor: MapAttribute.call(this);
                                __arguments = new Array(0);
                                {
                                    _this = _super.call(this) || this;
                                    _this.fmliveswitchsdprtpMapAttributeInit();
                                    _this.__relatedRtcpFeedbackAttributes = new fm.liveswitch.sdp.rtp.FeedbackAttributeCollection();
                                    _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.RtpMapAttribute);
                                    _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.IdenticalPerPT);
                                }
                                if ((fm.liveswitch.Global.equals(formatName_1, null))) {
                                    throw new fm.liveswitch.Exception("formatName cannot be null.");
                                }
                                _this.setPayloadType(payloadType_2);
                                _this.setFormatName(formatName_1);
                                _this.setClockRate(clockRate_5);
                                _this.setFormatParameters(formatParameters);
                            }
                        }
                        else if (__arguments.length == 4) {
                            var payloadType = __arguments[0];
                            var formatName = __arguments[1];
                            var clockRate = __arguments[2];
                            var formatParameters = __arguments[3];
                            // chained constructor: MapAttribute.call(this);
                            __arguments = new Array(0);
                            {
                                _this = _super.call(this) || this;
                                _this.fmliveswitchsdprtpMapAttributeInit();
                                _this.__relatedRtcpFeedbackAttributes = new fm.liveswitch.sdp.rtp.FeedbackAttributeCollection();
                                _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.RtpMapAttribute);
                                _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.IdenticalPerPT);
                            }
                            if ((fm.liveswitch.Global.equals(formatName, null))) {
                                throw new fm.liveswitch.Exception("formatName cannot be null.");
                            }
                            _this.setPayloadType(payloadType);
                            _this.setFormatName(formatName);
                            _this.setClockRate(clockRate);
                            _this.setFormatParameters(formatParameters);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    MapAttribute.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.rtp.MapAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    MapAttribute.prototype.fmliveswitchsdprtpMapAttributeInit = function () {
                        this._clockRate = 0;
                        this._payloadType = 0;
                    };
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.rtp.mapAttribute]] class.
                    @param value The attribute value.
                    */
                    MapAttribute.fromAttributeValue = function (value) {
                        fm.liveswitch.sdp.rtp.MapAttribute.fmliveswitchsdprtpMapAttributeInitialize();
                        if (arguments.length == 1) {
                            var index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                            var num2 = fm.liveswitch.ParseAssistant.parseIntegerValue(fm.liveswitch.StringExtensions.substring(value, 0, index));
                            value = value.substring((index + 1));
                            var length_40 = fm.liveswitch.StringExtensions.indexOf(value, "/");
                            var str = fm.liveswitch.StringExtensions.substring(value, 0, length_40);
                            value = value.substring((length_40 + 1));
                            length_40 = fm.liveswitch.StringExtensions.indexOf(value, "/");
                            var num4 = 0;
                            var str2 = null;
                            if ((fm.liveswitch.Global.equals(length_40, -1))) {
                                num4 = fm.liveswitch.ParseAssistant.parseIntegerValue(value);
                            }
                            else {
                                num4 = fm.liveswitch.ParseAssistant.parseIntegerValue(fm.liveswitch.StringExtensions.substring(value, 0, length_40));
                                str2 = value.substring((length_40 + 1));
                            }
                            var attribute = new fm.liveswitch.sdp.rtp.MapAttribute();
                            attribute.setPayloadType(num2);
                            attribute.setFormatName(str);
                            attribute.setClockRate(num4);
                            attribute.setFormatParameters(str2);
                            return attribute;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the RTP map attribute for an IANA-reserved payload type.
                    @param payloadType The payload type.
                    */
                    MapAttribute.getIanaMapAttribute = function (payloadType) {
                        fm.liveswitch.sdp.rtp.MapAttribute.fmliveswitchsdprtpMapAttributeInitialize();
                        if (arguments.length == 1) {
                            var attribute = null;
                            var _var0 = new fm.liveswitch.Holder(attribute);
                            var _var1 = fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.tryGetValue(fm.liveswitch.NumberExtensions.toString(payloadType), _var0);
                            attribute = _var0.getValue();
                            return attribute;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Adds an Rtcp Feedback attribute associated with this Map Attribute.
                    @param attribute
                    */
                    MapAttribute.prototype.addRelatedRtcpFeedbackAttribute = function (attribute) {
                        if (arguments.length == 1) {
                            this.__relatedRtcpFeedbackAttributes.addAttribute(attribute);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the internal value of the attribute.
                    */
                    MapAttribute.prototype.getAttributeValue = function () {
                        if (arguments.length == 0) {
                            var builder = new fm.liveswitch.StringBuilder();
                            builder.append(fm.liveswitch.NumberExtensions.toString(this.getPayloadType()));
                            builder.append(" ");
                            builder.append(this.getFormatName());
                            builder.append("/");
                            builder.append(fm.liveswitch.NumberExtensions.toString(this.getClockRate()));
                            if (!fm.liveswitch.StringExtensions.isNullOrEmpty(this.getFormatParameters())) {
                                builder.append("/");
                                builder.append(this.getFormatParameters());
                            }
                            return builder.toString();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the payload clock rate.
                    */
                    MapAttribute.prototype.getClockRate = function () {
                        if (arguments.length == 0) {
                            return this._clockRate;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the format name denoting the payload format to be used.
                    */
                    MapAttribute.prototype.getFormatName = function () {
                        if (arguments.length == 0) {
                            return this._formatName;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets format parameters for the payload.
                    */
                    MapAttribute.prototype.getFormatParameters = function () {
                        if (arguments.length == 0) {
                            return this._formatParameters;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the RTP payload type number.
                    */
                    MapAttribute.prototype.getPayloadType = function () {
                        if (arguments.length == 0) {
                            return this._payloadType;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the RTCP "ccm fir" feedback attribute associated with this payload type.
                    */
                    MapAttribute.prototype.getRelatedCcmFirFeedbackAttribute = function () {
                        if (arguments.length == 0) {
                            return this.getRelatedRtcpFeedbackAttribute(fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getCcm(), fm.liveswitch.sdp.rtcp.FeedbackAttributeSubType.getFir());
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the RTCP "ccm lrr" feedback attribute associated with this payload type.
                    */
                    MapAttribute.prototype.getRelatedCcmLrrFeedbackAttribute = function () {
                        if (arguments.length == 0) {
                            return this.getRelatedRtcpFeedbackAttribute(fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getCcm(), fm.liveswitch.sdp.rtcp.FeedbackAttributeSubType.getLrr());
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the RTCP "ccm tmmbn" feedback attribute associated with this payload type.
                    */
                    MapAttribute.prototype.getRelatedCcmTmmbnFeedbackAttribute = function () {
                        if (arguments.length == 0) {
                            return this.getRelatedRtcpFeedbackAttribute(fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getCcm(), fm.liveswitch.sdp.rtcp.FeedbackAttributeSubType.getTmmbn());
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the RTCP "ccm tmmbr" feedback attribute associated with this payload type.
                    */
                    MapAttribute.prototype.getRelatedCcmTmmbrFeedbackAttribute = function () {
                        if (arguments.length == 0) {
                            return this.getRelatedRtcpFeedbackAttribute(fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getCcm(), fm.liveswitch.sdp.rtcp.FeedbackAttributeSubType.getTmmbr());
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets Format Parameters attribute associated with this Map Attribute
                    */
                    MapAttribute.prototype.getRelatedFormatParametersAttribute = function () {
                        if (arguments.length == 0) {
                            return this._relatedFormatParametersAttribute;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the RTCP "nack" feedback attribute associated with this payload type.
                    */
                    MapAttribute.prototype.getRelatedNackFeedbackAttribute = function () {
                        if (arguments.length == 0) {
                            return this.getRelatedRtcpFeedbackAttribute(fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getNack(), null);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the RTCP "nack pli" feedback attribute associated with this payload type.
                    */
                    MapAttribute.prototype.getRelatedNackPliFeedbackAttribute = function () {
                        if (arguments.length == 0) {
                            return this.getRelatedRtcpFeedbackAttribute(fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getNack(), fm.liveswitch.sdp.rtcp.FeedbackAttributeSubType.getPli());
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the RTCP "nack rpsi" feedback attribute associated with this payload type.
                    */
                    MapAttribute.prototype.getRelatedNackRpsiFeedbackAttribute = function () {
                        if (arguments.length == 0) {
                            return this.getRelatedRtcpFeedbackAttribute(fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getNack(), fm.liveswitch.sdp.rtcp.FeedbackAttributeSubType.getRpsi());
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the RTCP "nack sli" feedback attribute associated with this payload type.
                    */
                    MapAttribute.prototype.getRelatedNackSliFeedbackAttribute = function () {
                        if (arguments.length == 0) {
                            return this.getRelatedRtcpFeedbackAttribute(fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getNack(), fm.liveswitch.sdp.rtcp.FeedbackAttributeSubType.getSli());
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the RTCP "goog-remb" feedback attribute associated with this payload type.
                    */
                    MapAttribute.prototype.getRelatedRembFeedbackAttribute = function () {
                        if (arguments.length == 0) {
                            return this.getRelatedRtcpFeedbackAttribute(fm.liveswitch.sdp.rtcp.FeedbackAttributeType.getRemb(), null);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    MapAttribute.prototype.getRelatedRtcpFeedbackAttribute = function () {
                        if (arguments.length == 3) {
                            var payloadType = arguments[0];
                            var type = arguments[1];
                            var subType = arguments[2];
                            for (var _i = 0, _a = this.getRelatedRtcpFeedbackAttributes(); _i < _a.length; _i++) {
                                var attribute = _a[_i];
                                if (((((!fm.liveswitch.Global.equals(attribute, null)) && (fm.liveswitch.Global.equals(attribute.getType(), type))) && (fm.liveswitch.Global.equals(attribute.getSubType(), subType))) && (fm.liveswitch.Global.equals(attribute.getPayloadType(), payloadType)))) {
                                    return attribute;
                                }
                            }
                            return null;
                        }
                        else if (arguments.length == 2) {
                            var type = arguments[0];
                            var subType = arguments[1];
                            for (var _b = 0, _c = this.getRelatedRtcpFeedbackAttributes(); _b < _c.length; _b++) {
                                var attribute = _c[_b];
                                if ((((!fm.liveswitch.Global.equals(attribute, null)) && (fm.liveswitch.Global.equals(attribute.getType(), type))) && (fm.liveswitch.Global.equals(attribute.getSubType(), subType)))) {
                                    return attribute;
                                }
                            }
                            return null;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets Rtcp Feedback attributes associated with this Map Attribute.
                    */
                    MapAttribute.prototype.getRelatedRtcpFeedbackAttributes = function () {
                        if (arguments.length == 0) {
                            return this.__relatedRtcpFeedbackAttributes.toArray();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Removes an Rtcp Feedback attribute associated with this Map Attribute. Returns true if the attribute was reomved; if the attribute was not present, returns false.
                    @param attribute
                    */
                    MapAttribute.prototype.removeRelatedRtcpFeedbackAttribute = function (attribute) {
                        if (arguments.length == 1) {
                            return this.__relatedRtcpFeedbackAttributes.remove(attribute);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Resets Rtcp Feedback attributes associated with this Map Attribute.
                    */
                    MapAttribute.prototype.resetRtcpFeedbackAttributes = function (attributes) {
                        if (arguments.length == 1) {
                            this.__relatedRtcpFeedbackAttributes.clear();
                            for (var _i = 0, attributes_9 = attributes; _i < attributes_9.length; _i++) {
                                var attribute = attributes_9[_i];
                                this.__relatedRtcpFeedbackAttributes.addAttribute(attribute);
                            }
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    MapAttribute.prototype.setClockRate = function (value) {
                        if (arguments.length == 1) {
                            this._clockRate = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    MapAttribute.prototype.setFormatName = function (value) {
                        if (arguments.length == 1) {
                            this._formatName = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    MapAttribute.prototype.setFormatParameters = function (value) {
                        if (arguments.length == 1) {
                            this._formatParameters = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the RTP payload type number.
                    */
                    MapAttribute.prototype.setPayloadType = function (value) {
                        if (arguments.length == 1) {
                            this._payloadType = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets Format Parameters attribute associated with this Map Attribute
                    */
                    MapAttribute.prototype.setRelatedFormatParametersAttribute = function (value) {
                        if (arguments.length == 1) {
                            this._relatedFormatParametersAttribute = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    MapAttribute.fmliveswitchsdprtpMapAttributeInitialize = function () {
                        if (!fm.liveswitch.sdp.rtp.MapAttribute.__fmliveswitchsdprtpMapAttributeInitialized && !fm.liveswitch.sdp.rtp.MapAttribute.__fmliveswitchsdprtpMapAttributeInitializing) {
                            fm.liveswitch.sdp.rtp.MapAttribute.__fmliveswitchsdprtpMapAttributeInitializing = true;
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes = new fm.liveswitch.ManagedConcurrentDictionary();
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("0", new fm.liveswitch.sdp.rtp.MapAttribute(0, "PCMU", 8000));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("3", new fm.liveswitch.sdp.rtp.MapAttribute(3, "GSM", 8000));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("4", new fm.liveswitch.sdp.rtp.MapAttribute(4, "G723", 8000));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("5", new fm.liveswitch.sdp.rtp.MapAttribute(5, "DVI4", 8000));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("6", new fm.liveswitch.sdp.rtp.MapAttribute(6, "DVI4", 16000));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("7", new fm.liveswitch.sdp.rtp.MapAttribute(7, "LPC", 8000));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("8", new fm.liveswitch.sdp.rtp.MapAttribute(8, "PCMA", 8000));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("9", new fm.liveswitch.sdp.rtp.MapAttribute(9, "G722", 8000));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("10", new fm.liveswitch.sdp.rtp.MapAttribute(10, "L16", 44100, "2"));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("11", new fm.liveswitch.sdp.rtp.MapAttribute(11, "L16", 44100));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("12", new fm.liveswitch.sdp.rtp.MapAttribute(12, "QCELP", 8000));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("13", new fm.liveswitch.sdp.rtp.MapAttribute(13, "CN", 8000));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("14", new fm.liveswitch.sdp.rtp.MapAttribute(14, "MPA", 90000));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("15", new fm.liveswitch.sdp.rtp.MapAttribute(15, "G728", 8000));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("16", new fm.liveswitch.sdp.rtp.MapAttribute(16, "DVI4", 11025));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("17", new fm.liveswitch.sdp.rtp.MapAttribute(17, "DVI4", 22050));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("18", new fm.liveswitch.sdp.rtp.MapAttribute(18, "G729", 8000));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("25", new fm.liveswitch.sdp.rtp.MapAttribute(25, "CelB", 90000));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("26", new fm.liveswitch.sdp.rtp.MapAttribute(26, "JPEG", 90000));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("28", new fm.liveswitch.sdp.rtp.MapAttribute(28, "nv", 90000));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("31", new fm.liveswitch.sdp.rtp.MapAttribute(31, "H261", 90000));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("32", new fm.liveswitch.sdp.rtp.MapAttribute(32, "MPV", 90000));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("33", new fm.liveswitch.sdp.rtp.MapAttribute(33, "MP2T", 90000));
                            fm.liveswitch.sdp.rtp.MapAttribute.fm_liveswitch_sdp_rtp_MapAttribute___ianaMapAttributes.addOrUpdate("34", new fm.liveswitch.sdp.rtp.MapAttribute(34, "H263", 90000));
                            fm.liveswitch.sdp.rtp.MapAttribute.__fmliveswitchsdprtpMapAttributeInitialized = true;
                            fm.liveswitch.sdp.rtp.MapAttribute.__fmliveswitchsdprtpMapAttributeInitializing = false;
                        }
                    };
                    /** @hidden */
                    MapAttribute.__fmliveswitchsdprtpMapAttributeInitialized = false;
                    /** @hidden */
                    MapAttribute.__fmliveswitchsdprtpMapAttributeInitializing = false;
                    return MapAttribute;
                }(fm.liveswitch.sdp.Attribute));
                rtp.MapAttribute = MapAttribute;
            })(rtp = sdp.rtp || (sdp.rtp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/Media.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var rtp;
            (function (rtp) {
                /**
                An SDP media description with a transport protocol of "RTP/AVP" or "RTP/SAVP".
                */
                var Media = /** @class */ (function (_super) {
                    __extends(Media, _super);
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.rtp.media]] class.
                    @param mediaType The media type. See [[fm.liveswitch.sdp.mediaType]] for possible values.
                    @param transportPort The transport port.
                    @param transportProtocol The transport protocol.
                    @param rtpPayloadTypeNumbers The RTP payload type numbers.
                    */
                    function Media(mediaType, transportPort, transportProtocol, rtpPayloadTypeNumbers) {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 4) {
                            var mediaType_2 = __arguments[0];
                            var transportPort_2 = __arguments[1];
                            var transportProtocol_2 = __arguments[2];
                            var rtpPayloadTypeNumbers_1 = __arguments[3];
                            _this = _super.call(this, mediaType_2, transportPort_2, transportProtocol_2) || this;
                            if ((fm.liveswitch.Global.equals(rtpPayloadTypeNumbers_1, null))) {
                                throw new fm.liveswitch.Exception("rtpPayloadTypeNumbers cannot be null.");
                            }
                            var strArray = new Array(rtpPayloadTypeNumbers_1.length);
                            for (var i = 0; (i < rtpPayloadTypeNumbers_1.length); i++) {
                                strArray[i] = fm.liveswitch.NumberExtensions.toString(rtpPayloadTypeNumbers_1[i]);
                            }
                            _super.prototype.setFormatDescription.call(_this, fm.liveswitch.StringExtensions.join(" ", strArray));
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    Media.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.rtp.Media]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    /**
                    Generates Rtp Prfile for a given combination of stream type, whjether or not RTCP-based feedback is supported, whether (D)TLS is in use and whether encryption is in use in general.
                    @param type Stream type.
                    @param rtcpFeedbackSupported Indicates whether Rtcp-based feedback is supported.
                    @param useDtls Indicates whether (D)TLS is in use.
                    @param useEncryption Indicates whether encryption is in use.
                    */
                    Media.generateRtpProfile = function (type, rtcpFeedbackSupported, useDtls, useEncryption) {
                        if (arguments.length == 4) {
                            if (!(useEncryption || !useDtls)) {
                                throw new fm.liveswitch.Exception("Cannot generate RTP Profile for the case when DTLS support is required but encryption is not used. Likely, useEncryption must be set.");
                            }
                            if (((!fm.liveswitch.Global.equals(type, fm.liveswitch.StreamType.Video)) && (!fm.liveswitch.Global.equals(type, fm.liveswitch.StreamType.Audio)))) {
                                throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Cannot generate RTP Profile streams of type other than Audio or Video. {0} type supplied.", new fm.liveswitch.StreamTypeWrapper(type).toString()));
                            }
                            if (useEncryption) {
                                if (useDtls) {
                                    if (rtcpFeedbackSupported) {
                                        return fm.liveswitch.sdp.rtp.Media.getUdpTlsRtpSavpfTransportProtocol();
                                    }
                                    return fm.liveswitch.sdp.rtp.Media.getUdpTlsRtpSavpTransportProtocol();
                                }
                                if (rtcpFeedbackSupported) {
                                    return fm.liveswitch.sdp.rtp.Media.getRtpSavpfTransportProtocol();
                                }
                                return fm.liveswitch.sdp.rtp.Media.getRtpSavpTransportProtocol();
                            }
                            if (rtcpFeedbackSupported) {
                                return fm.liveswitch.sdp.rtp.Media.getRtpAvpfTransportProtocol();
                            }
                            return fm.liveswitch.sdp.rtp.Media.getRtpAvpTransportProtocol();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the payload types.
                    @param formatDesciption The media format desciption.
                    */
                    Media.getPayloadTypes = function (formatDesciption) {
                        if (arguments.length == 1) {
                            if (((!fm.liveswitch.Global.equals(formatDesciption, null)) && (fm.liveswitch.StringExtensions.getLength(formatDesciption) > 0))) {
                                var strArray = fm.liveswitch.StringExtensions.split(fm.liveswitch.StringExtensions.trim(formatDesciption), [32]);
                                var numArray = new Array(strArray.length);
                                for (var i = 0; (i < strArray.length); i++) {
                                    numArray[i] = fm.liveswitch.ParseAssistant.parseIntegerValue(strArray[i]);
                                }
                                return numArray;
                            }
                            return new Array(0);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the protocol keyword for the extended RTP audio/video profile.
                    */
                    Media.getRtpAvpfTransportProtocol = function () {
                        if (arguments.length == 0) {
                            return "RTP/AVPF";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the protocol keyword for the RTP audio/video profile.
                    */
                    Media.getRtpAvpTransportProtocol = function () {
                        if (arguments.length == 0) {
                            return "RTP/AVP";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the protocol keyword for the extended Secure RTP audio/video profile.
                    */
                    Media.getRtpSavpfTransportProtocol = function () {
                        if (arguments.length == 0) {
                            return "RTP/SAVPF";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the protocol keyword for the Secure RTP audio/video profile.
                    */
                    Media.getRtpSavpTransportProtocol = function () {
                        if (arguments.length == 0) {
                            return "RTP/SAVP";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the protocol keyword for the extended Secure RTP audio/video profile with DTLS key exchange.
                    */
                    Media.getUdpTlsRtpSavpfTransportProtocol = function () {
                        if (arguments.length == 0) {
                            return "UDP/TLS/RTP/SAVPF";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the protocol keyword for the Secure RTP audio/video profile with DTLS key exchange.
                    */
                    Media.getUdpTlsRtpSavpTransportProtocol = function () {
                        if (arguments.length == 0) {
                            return "UDP/TLS/RTP/SAVP";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Returns the clockrate of a well-known payload type.
                    @param payloadType The well-known payload type to get the clockrate of.
                    */
                    Media.getWellKnownPayloadClockRate = function (payloadType) {
                        if (arguments.length == 1) {
                            var _var0 = payloadType;
                            if (_var0 == 0 || _var0 == 3 || _var0 == 4 || _var0 == 5) {
                                do {
                                    return 8000;
                                } while (false);
                            }
                            else if (_var0 == 6) {
                                do {
                                    return 16000;
                                } while (false);
                            }
                            else if (_var0 == 7 || _var0 == 8 || _var0 == 9) {
                                do {
                                    return 8000;
                                } while (false);
                            }
                            else if (_var0 == 10 || _var0 == 11) {
                                do {
                                    return 44100;
                                } while (false);
                            }
                            else if (_var0 == 12 || _var0 == 13) {
                                do {
                                    return 8000;
                                } while (false);
                            }
                            else if (_var0 == 14) {
                                do {
                                    return 90000;
                                } while (false);
                            }
                            else if (_var0 == 15) {
                                do {
                                    return 8000;
                                } while (false);
                            }
                            else if (_var0 == 16) {
                                do {
                                    return 11025;
                                } while (false);
                            }
                            else if (_var0 == 17) {
                                do {
                                    return 22050;
                                } while (false);
                            }
                            else if (_var0 == 18) {
                                do {
                                    return 8000;
                                } while (false);
                            }
                            else if (_var0 == 25 || _var0 == 26 || _var0 == 28 || _var0 == 31 || _var0 == 32 || _var0 == 33 || _var0 == 34) {
                                do {
                                    return 90000;
                                } while (false);
                            }
                            return -1;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Returns the name of a well-known payload type.
                    @param payloadType The well-known payload type to get the name of.
                    */
                    Media.getWellKnownPayloadName = function (payloadType) {
                        if (arguments.length == 1) {
                            var _var0 = payloadType;
                            if (_var0 == 0) {
                                do {
                                    return "PCMU";
                                } while (false);
                            }
                            else if (_var0 == 3) {
                                do {
                                    return "GSM";
                                } while (false);
                            }
                            else if (_var0 == 4) {
                                do {
                                    return "G723";
                                } while (false);
                            }
                            else if (_var0 == 5 || _var0 == 6) {
                                do {
                                    return "DVI4";
                                } while (false);
                            }
                            else if (_var0 == 7) {
                                do {
                                    return "LPC";
                                } while (false);
                            }
                            else if (_var0 == 8) {
                                do {
                                    return "PCMA";
                                } while (false);
                            }
                            else if (_var0 == 9) {
                                do {
                                    return "G722";
                                } while (false);
                            }
                            else if (_var0 == 10 || _var0 == 11) {
                                do {
                                    return "L16";
                                } while (false);
                            }
                            else if (_var0 == 12) {
                                do {
                                    return "QCELP";
                                } while (false);
                            }
                            else if (_var0 == 13) {
                                do {
                                    return "CN";
                                } while (false);
                            }
                            else if (_var0 == 14) {
                                do {
                                    return "MPA";
                                } while (false);
                            }
                            else if (_var0 == 15) {
                                do {
                                    return "G728";
                                } while (false);
                            }
                            else if (_var0 == 16 || _var0 == 17) {
                                do {
                                    return "DVI4";
                                } while (false);
                            }
                            else if (_var0 == 18) {
                                do {
                                    return "G729";
                                } while (false);
                            }
                            else if (_var0 == 25) {
                                do {
                                    return "CelB";
                                } while (false);
                            }
                            else if (_var0 == 26) {
                                do {
                                    return "JPEG";
                                } while (false);
                            }
                            else if (_var0 == 28) {
                                do {
                                    return "nv";
                                } while (false);
                            }
                            else if (_var0 == 31) {
                                do {
                                    return "H261";
                                } while (false);
                            }
                            else if (_var0 == 32) {
                                do {
                                    return "MPV";
                                } while (false);
                            }
                            else if (_var0 == 33) {
                                do {
                                    return "MP2T";
                                } while (false);
                            }
                            else if (_var0 == 34) {
                                do {
                                    return "H263";
                                } while (false);
                            }
                            return null;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Returns a value indicating whther a given protocol supports encryption.
                    @param protocol Protocol keyword.
                    @return Value indicating whther a given protocol supports encryption.
                    */
                    Media.supportsEncryption = function (protocol) {
                        if (arguments.length == 1) {
                            return ((((fm.liveswitch.Global.equals(protocol, fm.liveswitch.sdp.rtp.Media.getUdpTlsRtpSavpTransportProtocol())) || (fm.liveswitch.Global.equals(protocol, fm.liveswitch.sdp.rtp.Media.getUdpTlsRtpSavpfTransportProtocol()))) || (fm.liveswitch.Global.equals(protocol, fm.liveswitch.sdp.rtp.Media.getRtpSavpTransportProtocol()))) || (fm.liveswitch.Global.equals(protocol, fm.liveswitch.sdp.rtp.Media.getRtpSavpfTransportProtocol())));
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Returns a value indicating whther a given protocol supports encryption.
                    @param protocol Protocol keyword.
                    @return Value indicating whther a given protocol supports encryption.
                    */
                    Media.supportsRtcpBasedFeedback = function (protocol) {
                        if (arguments.length == 1) {
                            return (((fm.liveswitch.Global.equals(protocol, fm.liveswitch.sdp.rtp.Media.getRtpSavpfTransportProtocol())) || (fm.liveswitch.Global.equals(protocol, fm.liveswitch.sdp.rtp.Media.getRtpAvpfTransportProtocol()))) || (fm.liveswitch.Global.equals(protocol, fm.liveswitch.sdp.rtp.Media.getUdpTlsRtpSavpfTransportProtocol())));
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return Media;
                }(fm.liveswitch.sdp.Media));
                rtp.Media = Media;
            })(rtp = sdp.rtp || (sdp.rtp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var rtp;
            (function (rtp) {
                /**
                A stream for a simulcast stream description.
                */
                var SimulcastStream = /** @class */ (function () {
                    function SimulcastStream() {
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.sdp.rtp.SimulcastStreamId]'))) {
                            var idValue = __arguments[0];
                            // chained constructor: SimulcastStream.call(this, ((fm.liveswitch.Global.equals(idValue, null)) ? null : [idValue]));
                            __arguments = new Array(1);
                            __arguments[0] = ((fm.liveswitch.Global.equals(idValue, null)) ? null : [idValue]);
                            {
                                var ids = __arguments[0];
                                //super();
                                if ((fm.liveswitch.Global.equals(ids, null))) {
                                    throw new fm.liveswitch.Exception("Simulcast stream 'IDs' cannot be null.");
                                }
                                if ((fm.liveswitch.Global.equals(ids.length, 0))) {
                                    throw new fm.liveswitch.Exception("Simulcast stream requires at least one ID.");
                                }
                                this.setIds(ids);
                            }
                        }
                        else if (__arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isObjectType(arguments[0][0], '[fm.liveswitch.sdp.rtp.SimulcastStreamId]')))))) {
                            var ids = __arguments[0];
                            //super();
                            if ((fm.liveswitch.Global.equals(ids, null))) {
                                throw new fm.liveswitch.Exception("Simulcast stream 'IDs' cannot be null.");
                            }
                            if ((fm.liveswitch.Global.equals(ids.length, 0))) {
                                throw new fm.liveswitch.Exception("Simulcast stream requires at least one ID.");
                            }
                            this.setIds(ids);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                    }
                    SimulcastStream.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.rtp.SimulcastStream]';
                    };
                    /**
                    Gets the identifiers.
                    */
                    SimulcastStream.prototype.getIds = function () {
                        if (arguments.length == 0) {
                            return this._ids;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    SimulcastStream.prototype.setIds = function (value) {
                        if (arguments.length == 1) {
                            this._ids = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return SimulcastStream;
                }());
                rtp.SimulcastStream = SimulcastStream;
            })(rtp = sdp.rtp || (sdp.rtp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var rtp;
            (function (rtp) {
                /**
                The allowed directions for a simulcast attribute.
                */
                var SimulcastDirection = /** @class */ (function () {
                    function SimulcastDirection() {
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            //super();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                    }
                    SimulcastDirection.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.rtp.SimulcastDirection]';
                    };
                    /**
                    Gets the receive direction ("recv").
                    */
                    SimulcastDirection.getReceive = function () {
                        if (arguments.length == 0) {
                            return "recv";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the send direction ("send").
                    */
                    SimulcastDirection.getSend = function () {
                        if (arguments.length == 0) {
                            return "send";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return SimulcastDirection;
                }());
                rtp.SimulcastDirection = SimulcastDirection;
            })(rtp = sdp.rtp || (sdp.rtp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var rtp;
            (function (rtp) {
                /**
                A stream description for a simulcast attribute.
                */
                var SimulcastStreamDescription = /** @class */ (function () {
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.rtp.simulcastStreamDescription]] class.
                    @param direction The direction.
                    @param streams The streams.
                    */
                    function SimulcastStreamDescription(direction, streams) {
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 2) {
                            var direction_1 = __arguments[0];
                            var streams_11 = __arguments[1];
                            //super();
                            if ((fm.liveswitch.Global.equals(direction_1, null))) {
                                throw new fm.liveswitch.Exception("Simulcast stream description 'direction' cannot be null.");
                            }
                            if ((fm.liveswitch.Global.equals(streams_11, null))) {
                                throw new fm.liveswitch.Exception("Simulcast stream description 'streams' cannot be null.");
                            }
                            if ((fm.liveswitch.Global.equals(streams_11.length, 0))) {
                                throw new fm.liveswitch.Exception("Simulcast stream description requires at least one stream.");
                            }
                            this.setDirection(direction_1);
                            this.setStreams(streams_11);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                    }
                    SimulcastStreamDescription.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.rtp.SimulcastStreamDescription]';
                    };
                    /** @hidden */
                    SimulcastStreamDescription.prototype.directionIsValid = function (direction) {
                        if (arguments.length == 1) {
                            for (var _i = 0, _a = [fm.liveswitch.sdp.rtp.SimulcastDirection.getSend(), fm.liveswitch.sdp.rtp.SimulcastDirection.getReceive()]; _i < _a.length; _i++) {
                                var str = _a[_i];
                                if ((fm.liveswitch.Global.equals(direction, str))) {
                                    return true;
                                }
                            }
                            return false;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the direction.
                    */
                    SimulcastStreamDescription.prototype.getDirection = function () {
                        if (arguments.length == 0) {
                            return this.__direction;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the streams.
                    */
                    SimulcastStreamDescription.prototype.getStreams = function () {
                        if (arguments.length == 0) {
                            return this._streams;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    SimulcastStreamDescription.prototype.setDirection = function (value) {
                        if (arguments.length == 1) {
                            if (!this.directionIsValid(value)) {
                                throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Simulcast stream description 'direction' cannot be '{0}'.", value));
                            }
                            this.__direction = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    SimulcastStreamDescription.prototype.setStreams = function (value) {
                        if (arguments.length == 1) {
                            this._streams = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return SimulcastStreamDescription;
                }());
                rtp.SimulcastStreamDescription = SimulcastStreamDescription;
            })(rtp = sdp.rtp || (sdp.rtp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var rtp;
            (function (rtp) {
                /**
                The allowed directions for an RID attribute.
                */
                var RidDirection = /** @class */ (function () {
                    function RidDirection() {
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            //super();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                    }
                    RidDirection.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.rtp.RidDirection]';
                    };
                    /**
                    Gets the receive direction ("recv").
                    */
                    RidDirection.getReceive = function () {
                        if (arguments.length == 0) {
                            return "recv";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the send direction ("send").
                    */
                    RidDirection.getSend = function () {
                        if (arguments.length == 0) {
                            return "send";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return RidDirection;
                }());
                rtp.RidDirection = RidDirection;
            })(rtp = sdp.rtp || (sdp.rtp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var rtp;
            (function (rtp) {
                /**
                A restriction for an RID attribute.
                */
                var RidRestriction = /** @class */ (function () {
                    function RidRestriction() {
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 1) {
                            var key = __arguments[0];
                            // chained constructor: RidRestriction.call(this, key, null);
                            __arguments = new Array(2);
                            __arguments[0] = key;
                            __arguments[1] = null;
                            {
                                var key_1 = __arguments[0];
                                var value = __arguments[1];
                                //super();
                                if (fm.liveswitch.StringExtensions.isNullOrEmpty(key_1)) {
                                    throw new fm.liveswitch.Exception("RID restriction 'key' cannot be null.");
                                }
                                this.setKey(key_1);
                                this.setValue(value);
                            }
                        }
                        else if (__arguments.length == 2) {
                            var key = __arguments[0];
                            var value = __arguments[1];
                            //super();
                            if (fm.liveswitch.StringExtensions.isNullOrEmpty(key)) {
                                throw new fm.liveswitch.Exception("RID restriction 'key' cannot be null.");
                            }
                            this.setKey(key);
                            this.setValue(value);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                    }
                    RidRestriction.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.rtp.RidRestriction]';
                    };
                    /**
                    Gets the "depend" key, for spatial resolution in pixels. The value is a comma-separated list of rid-ids.These rid-ids identify RTP streams that this stream depends on in order to allow for proper interpretation.  The mechanism defined in this document allows for such dependencies to be expressed only when the streams are in the same media section.
                    */
                    RidRestriction.getDependKey = function () {
                        if (arguments.length == 0) {
                            return "depend";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the "max-br" key, for bit rate in bits per second. The restriction applies to the media payload only, and does not include overhead introduced by other layers(e.g., RTP, UDP, IP, or Ethernet).  The exact means of keeping within this limit are left up to the implementation, and instantaneous excursions outside the limit are permissible. For any given one-second sliding window, however, the total number of bits in the payload portion of RTP SHOULD NOT exceed the value specified in "max-br."
                    */
                    RidRestriction.getMaxBitrateKey = function () {
                        if (arguments.length == 0) {
                            return "max-br";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the "max-bpp" key, for maximum number of bits per pixel, calculated as an average of all samples of any given coded picture. This is expressed as a floating point value, with an allowed range of 0.0001 to 48.0.  These values MUST NOT be encoded with more than four digits to the right of the decimal point.
                    */
                    RidRestriction.getMaxBitsPerPixelKey = function () {
                        if (arguments.length == 0) {
                            return "max-bpp";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the "max-fs" key, for frame size in pixels per frame. This is the product of frame width and frame height, in pixels, for rectangular frames.
                    */
                    RidRestriction.getMaxFrameSizeKey = function () {
                        if (arguments.length == 0) {
                            return "max-fs";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the "max-fps" key, for frame rate in frames per second. For encoders that do not use a fixed framerate for encoding, this value is used to restrict the minimum amount of time between frames: the time between any two consecutive frames SHOULD NOT be less than 1 / max - fps seconds.
                    */
                    RidRestriction.getMaxFramesPerSecondKey = function () {
                        if (arguments.length == 0) {
                            return "max-fps";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the "max-height" key, for spatial resolution in pixels. In the case that stream orientation signaling is used to modify the intended display orientation, this attribute refers to the height of the stream when a rotation of zero degrees is encoded.
                    */
                    RidRestriction.getMaxHeightKey = function () {
                        if (arguments.length == 0) {
                            return "max-height";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the "max-pps" key, for pixel rate in pixels per second. This value SHOULD be handled identically to max-fps, after performing the following conversion: max-fps = max-pps / (width* height).  If the stream resolution changes, this value is recalculated. Due to this recalculation, excursions outside the specified maximum are possible near resolution change boundaries.
                    */
                    RidRestriction.getMaxPixelsPerSecondKey = function () {
                        if (arguments.length == 0) {
                            return "max-pps";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the "max-width" key, for spatial resolution in pixels. In the case that stream orientation signaling is used to modify the intended display orientation, this attribute refers to the width of the stream when a rotation of zero degrees is encoded.
                    */
                    RidRestriction.getMaxWidthKey = function () {
                        if (arguments.length == 0) {
                            return "max-width";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the restriction key.
                    */
                    RidRestriction.prototype.getKey = function () {
                        if (arguments.length == 0) {
                            return this._key;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the restriction value.
                    */
                    RidRestriction.prototype.getValue = function () {
                        if (arguments.length == 0) {
                            return this._value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    RidRestriction.prototype.setKey = function (value) {
                        if (arguments.length == 1) {
                            this._key = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the restriction value.
                    */
                    RidRestriction.prototype.setValue = function (value) {
                        if (arguments.length == 1) {
                            this._value = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return RidRestriction;
                }());
                rtp.RidRestriction = RidRestriction;
            })(rtp = sdp.rtp || (sdp.rtp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var rtp;
            (function (rtp) {
                /**
                The SDP media attribute "rid" specifies restrictions defining a unique RTP payload configuration.
                */
                var RidAttribute = /** @class */ (function (_super) {
                    __extends(RidAttribute, _super);
                    function RidAttribute() {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            _this = _super.call(this) || this;
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.RtpRidAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Special);
                        }
                        else if (__arguments.length == 2) {
                            var idValue = __arguments[0];
                            var direction = __arguments[1];
                            // chained constructor: RidAttribute.call(this, idValue, direction, null, null);
                            __arguments = new Array(4);
                            __arguments[0] = idValue;
                            __arguments[1] = direction;
                            __arguments[2] = null;
                            __arguments[3] = null;
                            {
                                var idValue_3 = __arguments[0];
                                var direction_2 = __arguments[1];
                                var payloadTypes = __arguments[2];
                                var restrictions = __arguments[3];
                                // chained constructor: RidAttribute.call(this);
                                __arguments = new Array(0);
                                {
                                    _this = _super.call(this) || this;
                                    _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.RtpRidAttribute);
                                    _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Special);
                                }
                                if (fm.liveswitch.StringExtensions.isNullOrEmpty(idValue_3)) {
                                    throw new fm.liveswitch.Exception("RID 'id' cannot be null.");
                                }
                                if (fm.liveswitch.StringExtensions.isNullOrEmpty(direction_2)) {
                                    throw new fm.liveswitch.Exception("RID 'direction' cannot be null.");
                                }
                                if (!fm.liveswitch.sdp.rtp.RidAttribute.validateId(idValue_3)) {
                                    throw new fm.liveswitch.Exception("RID 'id' may only conain alphanumeric characters.");
                                }
                                _this.setId(idValue_3);
                                _this.setDirection(direction_2);
                                _this.setPayloadTypes(payloadTypes);
                                _this.setRestrictions(restrictions);
                            }
                        }
                        else if (__arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || (fm.liveswitch.Util.isArray(arguments[2]) && (arguments[2].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[2][0]) || fm.liveswitch.Util.isNumber(arguments[2][0])))))) {
                            var idValue = __arguments[0];
                            var direction = __arguments[1];
                            var payloadTypes = __arguments[2];
                            // chained constructor: RidAttribute.call(this, idValue, direction, payloadTypes, null);
                            __arguments = new Array(4);
                            __arguments[0] = idValue;
                            __arguments[1] = direction;
                            __arguments[2] = payloadTypes;
                            __arguments[3] = null;
                            {
                                var idValue_4 = __arguments[0];
                                var direction_3 = __arguments[1];
                                var payloadTypes_1 = __arguments[2];
                                var restrictions = __arguments[3];
                                // chained constructor: RidAttribute.call(this);
                                __arguments = new Array(0);
                                {
                                    _this = _super.call(this) || this;
                                    _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.RtpRidAttribute);
                                    _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Special);
                                }
                                if (fm.liveswitch.StringExtensions.isNullOrEmpty(idValue_4)) {
                                    throw new fm.liveswitch.Exception("RID 'id' cannot be null.");
                                }
                                if (fm.liveswitch.StringExtensions.isNullOrEmpty(direction_3)) {
                                    throw new fm.liveswitch.Exception("RID 'direction' cannot be null.");
                                }
                                if (!fm.liveswitch.sdp.rtp.RidAttribute.validateId(idValue_4)) {
                                    throw new fm.liveswitch.Exception("RID 'id' may only conain alphanumeric characters.");
                                }
                                _this.setId(idValue_4);
                                _this.setDirection(direction_3);
                                _this.setPayloadTypes(payloadTypes_1);
                                _this.setRestrictions(restrictions);
                            }
                        }
                        else if (__arguments.length == 4) {
                            var idValue = __arguments[0];
                            var direction = __arguments[1];
                            var payloadTypes = __arguments[2];
                            var restrictions = __arguments[3];
                            // chained constructor: RidAttribute.call(this);
                            __arguments = new Array(0);
                            {
                                _this = _super.call(this) || this;
                                _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.RtpRidAttribute);
                                _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Special);
                            }
                            if (fm.liveswitch.StringExtensions.isNullOrEmpty(idValue)) {
                                throw new fm.liveswitch.Exception("RID 'id' cannot be null.");
                            }
                            if (fm.liveswitch.StringExtensions.isNullOrEmpty(direction)) {
                                throw new fm.liveswitch.Exception("RID 'direction' cannot be null.");
                            }
                            if (!fm.liveswitch.sdp.rtp.RidAttribute.validateId(idValue)) {
                                throw new fm.liveswitch.Exception("RID 'id' may only conain alphanumeric characters.");
                            }
                            _this.setId(idValue);
                            _this.setDirection(direction);
                            _this.setPayloadTypes(payloadTypes);
                            _this.setRestrictions(restrictions);
                        }
                        else if (__arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || (fm.liveswitch.Util.isArray(arguments[2]) && (arguments[2].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[2][0]) || fm.liveswitch.Util.isObjectType(arguments[2][0], '[fm.liveswitch.sdp.rtp.RidRestriction]')))))) {
                            var idValue = __arguments[0];
                            var direction = __arguments[1];
                            var restrictions = __arguments[2];
                            // chained constructor: RidAttribute.call(this, idValue, direction, null, restrictions);
                            __arguments = new Array(4);
                            __arguments[0] = idValue;
                            __arguments[1] = direction;
                            __arguments[2] = null;
                            __arguments[3] = restrictions;
                            {
                                var idValue_5 = __arguments[0];
                                var direction_4 = __arguments[1];
                                var payloadTypes = __arguments[2];
                                var restrictions_1 = __arguments[3];
                                // chained constructor: RidAttribute.call(this);
                                __arguments = new Array(0);
                                {
                                    _this = _super.call(this) || this;
                                    _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.RtpRidAttribute);
                                    _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Special);
                                }
                                if (fm.liveswitch.StringExtensions.isNullOrEmpty(idValue_5)) {
                                    throw new fm.liveswitch.Exception("RID 'id' cannot be null.");
                                }
                                if (fm.liveswitch.StringExtensions.isNullOrEmpty(direction_4)) {
                                    throw new fm.liveswitch.Exception("RID 'direction' cannot be null.");
                                }
                                if (!fm.liveswitch.sdp.rtp.RidAttribute.validateId(idValue_5)) {
                                    throw new fm.liveswitch.Exception("RID 'id' may only conain alphanumeric characters.");
                                }
                                _this.setId(idValue_5);
                                _this.setDirection(direction_4);
                                _this.setPayloadTypes(payloadTypes);
                                _this.setRestrictions(restrictions_1);
                            }
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    RidAttribute.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.rtp.RidAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.rtp.ridAttribute]] class.
                    @param value The attribute value.
                    */
                    RidAttribute.fromAttributeValue = function (value) {
                        if (arguments.length == 1) {
                            var index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                            var str = fm.liveswitch.StringExtensions.substring(value, 0, index);
                            value = value.substring((index + 1));
                            var str2 = null;
                            var numArray = null;
                            var restrictionArray = null;
                            index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                            if ((fm.liveswitch.Global.equals(index, -1))) {
                                str2 = value;
                            }
                            else {
                                var str3 = void 0;
                                var num3 = void 0;
                                str2 = fm.liveswitch.StringExtensions.substring(value, 0, index);
                                value = value.substring((index + 1));
                                var strArray = fm.liveswitch.StringExtensions.split(value, [59]);
                                var num2 = 0;
                                if (((strArray.length > num2) && fm.liveswitch.StringExtensions.startsWith(strArray[num2], "pt="))) {
                                    str3 = strArray[num2++];
                                    var strArray2 = fm.liveswitch.StringExtensions.split(str3.substring(3), [44]);
                                    numArray = new Array(strArray2.length);
                                    for (num3 = 0; (num3 < numArray.length); num3++) {
                                        numArray[num3] = fm.liveswitch.ParseAssistant.parseIntegerValue(strArray2[num3]);
                                    }
                                }
                                if ((strArray.length > num2)) {
                                    restrictionArray = new Array((strArray.length - num2));
                                    for (num3 = 0; (num3 < restrictionArray.length); num3++) {
                                        str3 = strArray[num2++];
                                        var length_41 = fm.liveswitch.StringExtensions.indexOf(str3, "=");
                                        if ((fm.liveswitch.Global.equals(length_41, -1))) {
                                            restrictionArray[num3] = new fm.liveswitch.sdp.rtp.RidRestriction(str3);
                                        }
                                        else {
                                            var key = fm.liveswitch.StringExtensions.substring(str3, 0, length_41);
                                            var str5 = str3.substring((length_41 + 1));
                                            restrictionArray[num3] = new fm.liveswitch.sdp.rtp.RidRestriction(key, str5);
                                        }
                                    }
                                }
                            }
                            var attribute = new fm.liveswitch.sdp.rtp.RidAttribute();
                            attribute.setId(str);
                            attribute.setDirection(str2);
                            attribute.setPayloadTypes(numArray);
                            attribute.setRestrictions(restrictionArray);
                            return attribute;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Validates that the identifier conforms to RFC syntax, which means that it only contains alpha-numeric characters and/or the hyphen and underscore. See https://tools.ietf.org/html/draft-ietf-avtext-rid/ and https://tools.ietf.org/html/draft-ietf-mmusic-rid/ for more info.
                    @param idValue The identifier
                    */
                    RidAttribute.validateId = function (idValue) {
                        if (arguments.length == 1) {
                            for (var i = 0; (i < fm.liveswitch.StringExtensions.getLength(idValue)); i++) {
                                var ch = idValue.charCodeAt(i);
                                if ((((((ch < 45) || ((ch > 45) && (ch < 48))) || (((ch > 57) && (ch < 65)) || ((ch > 90) && (ch < 95)))) || ((ch > 95) && (ch < 97))) || (ch > 122))) {
                                    return false;
                                }
                            }
                            return true;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    RidAttribute.prototype.directionIsValid = function (direction) {
                        if (arguments.length == 1) {
                            for (var _i = 0, _a = [fm.liveswitch.sdp.rtp.RidDirection.getSend(), fm.liveswitch.sdp.rtp.RidDirection.getReceive()]; _i < _a.length; _i++) {
                                var str = _a[_i];
                                if ((fm.liveswitch.Global.equals(direction, str))) {
                                    return true;
                                }
                            }
                            return false;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the internal value of the attribute.
                    */
                    RidAttribute.prototype.getAttributeValue = function () {
                        if (arguments.length == 0) {
                            var builder = new fm.liveswitch.StringBuilder();
                            builder.append(this.getId());
                            builder.append(" ");
                            builder.append(this.getDirection());
                            var num = ((fm.liveswitch.Global.equals(this.getPayloadTypes(), null)) ? 0 : this.getPayloadTypes().length);
                            var num2 = ((fm.liveswitch.Global.equals(this.getRestrictions(), null)) ? 0 : this.getRestrictions().length);
                            var strArray = new Array((((fm.liveswitch.Global.equals(num, 0)) ? 0 : 1) + num2));
                            var num3 = 0;
                            if ((num > 0)) {
                                var strArray2 = new Array(num);
                                for (var i = 0; (i < num); i++) {
                                    strArray2[i] = fm.liveswitch.NumberExtensions.toString(this.getPayloadTypes()[i]);
                                }
                                strArray[num3++] = fm.liveswitch.StringExtensions.format("pt={0}", fm.liveswitch.StringExtensions.join(",", strArray2));
                            }
                            if ((num2 > 0)) {
                                for (var _i = 0, _a = this.getRestrictions(); _i < _a.length; _i++) {
                                    var restriction = _a[_i];
                                    if ((fm.liveswitch.Global.equals(restriction.getValue(), null))) {
                                        strArray[num3++] = restriction.getKey();
                                    }
                                    else {
                                        strArray[num3++] = fm.liveswitch.StringExtensions.format("{0}={1}", restriction.getKey(), restriction.getValue());
                                    }
                                }
                            }
                            if ((strArray.length > 0)) {
                                builder.append(" ");
                                builder.append(fm.liveswitch.StringExtensions.join(";", strArray));
                            }
                            return builder.toString();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the direction.
                    */
                    RidAttribute.prototype.getDirection = function () {
                        if (arguments.length == 0) {
                            return this.__direction;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the identifier.
                    */
                    RidAttribute.prototype.getId = function () {
                        if (arguments.length == 0) {
                            return this._id;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the payload types that can be used in the associated stream. This property is optional and may be null.
                    */
                    RidAttribute.prototype.getPayloadTypes = function () {
                        if (arguments.length == 0) {
                            return this._payloadTypes;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the codec-agnostic restrictions to which the corresponding stream will conform. This property is optional and may be null.
                    */
                    RidAttribute.prototype.getRestrictions = function () {
                        if (arguments.length == 0) {
                            return this._restrictions;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets a restriction value.
                    @param restrictionKey The restriction key.
                    */
                    RidAttribute.prototype.getRestrictionValue = function (restrictionKey) {
                        if (arguments.length == 1) {
                            if ((!fm.liveswitch.Global.equals(this.getRestrictions(), null))) {
                                for (var _i = 0, _a = this.getRestrictions(); _i < _a.length; _i++) {
                                    var restriction = _a[_i];
                                    if ((fm.liveswitch.Global.equals(restriction.getKey(), restrictionKey))) {
                                        return restriction.getValue();
                                    }
                                }
                            }
                            return null;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    RidAttribute.prototype.setDirection = function (value) {
                        if (arguments.length == 1) {
                            if (!this.directionIsValid(value)) {
                                throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("RID 'direction' cannot be '{0}'.", value));
                            }
                            this.__direction = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    RidAttribute.prototype.setId = function (value) {
                        if (arguments.length == 1) {
                            this._id = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the payload types that can be used in the associated stream. This property is optional and may be null.
                    */
                    RidAttribute.prototype.setPayloadTypes = function (value) {
                        if (arguments.length == 1) {
                            this._payloadTypes = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the codec-agnostic restrictions to which the corresponding stream will conform. This property is optional and may be null.
                    */
                    RidAttribute.prototype.setRestrictions = function (value) {
                        if (arguments.length == 1) {
                            this._restrictions = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return RidAttribute;
                }(fm.liveswitch.sdp.Attribute));
                rtp.RidAttribute = RidAttribute;
            })(rtp = sdp.rtp || (sdp.rtp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var rtp;
            (function (rtp) {
                /**
                The SDP media attribute "simulcast" describes, independently for send and receive directions, the number of simulcast RTP streams as well as potential alternative formats for each simulcast RTP stream.
                */
                var SimulcastAttribute = /** @class */ (function (_super) {
                    __extends(SimulcastAttribute, _super);
                    function SimulcastAttribute() {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            _this = _super.call(this) || this;
                            _this.fmliveswitchsdprtpSimulcastAttributeInit();
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.SimulcastAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                        }
                        else if (__arguments.length == 1) {
                            var description = __arguments[0];
                            // chained constructor: SimulcastAttribute.call(this, description, null);
                            __arguments = new Array(2);
                            __arguments[0] = description;
                            __arguments[1] = null;
                            {
                                var description1 = __arguments[0];
                                var description2 = __arguments[1];
                                // chained constructor: SimulcastAttribute.call(this);
                                __arguments = new Array(0);
                                {
                                    _this = _super.call(this) || this;
                                    _this.fmliveswitchsdprtpSimulcastAttributeInit();
                                    _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.SimulcastAttribute);
                                    _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                                }
                                if ((fm.liveswitch.Global.equals(description1, null))) {
                                    throw new fm.liveswitch.Exception("Simulcast attribute 'description1' cannot be null.");
                                }
                                if (((!fm.liveswitch.Global.equals(description2, null)) && (fm.liveswitch.Global.equals(description1.getDirection(), description2.getDirection())))) {
                                    throw new fm.liveswitch.Exception("Simulcast attribute 'descriptions' must have different directions.");
                                }
                                _this.setDescription1(description1);
                                _this.setDescription2(description2);
                            }
                        }
                        else if (__arguments.length == 2) {
                            var description1 = __arguments[0];
                            var description2 = __arguments[1];
                            // chained constructor: SimulcastAttribute.call(this);
                            __arguments = new Array(0);
                            {
                                _this = _super.call(this) || this;
                                _this.fmliveswitchsdprtpSimulcastAttributeInit();
                                _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.SimulcastAttribute);
                                _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                            }
                            if ((fm.liveswitch.Global.equals(description1, null))) {
                                throw new fm.liveswitch.Exception("Simulcast attribute 'description1' cannot be null.");
                            }
                            if (((!fm.liveswitch.Global.equals(description2, null)) && (fm.liveswitch.Global.equals(description1.getDirection(), description2.getDirection())))) {
                                throw new fm.liveswitch.Exception("Simulcast attribute 'descriptions' must have different directions.");
                            }
                            _this.setDescription1(description1);
                            _this.setDescription2(description2);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    SimulcastAttribute.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.rtp.SimulcastAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    SimulcastAttribute.prototype.fmliveswitchsdprtpSimulcastAttributeInit = function () {
                        this._draftVersion = 0;
                    };
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.rtp.simulcastAttribute]] class.
                    @param value The attribute value.
                    */
                    SimulcastAttribute.fromAttributeValue = function (value) {
                        if (arguments.length == 1) {
                            var index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                            var direction = fm.liveswitch.StringExtensions.substring(value, 0, index);
                            value = value.substring((index + 1));
                            var streams = null;
                            var str2 = null;
                            var streamArray2 = null;
                            index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                            var draftVersion = -1;
                            if ((fm.liveswitch.Global.equals(index, -1))) {
                                var _var0 = new fm.liveswitch.Holder(draftVersion);
                                var _var1 = fm.liveswitch.sdp.rtp.SimulcastAttribute.streamsFromString(value, _var0);
                                draftVersion = _var0.getValue();
                                streams = _var1;
                            }
                            else {
                                var num3 = -1;
                                var _var2 = new fm.liveswitch.Holder(num3);
                                var _var3 = fm.liveswitch.sdp.rtp.SimulcastAttribute.streamsFromString(fm.liveswitch.StringExtensions.substring(value, 0, index), _var2);
                                num3 = _var2.getValue();
                                streams = _var3;
                                value = value.substring((index + 1));
                                index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                                str2 = fm.liveswitch.StringExtensions.substring(value, 0, index);
                                value = value.substring((index + 1));
                                var num4 = -1;
                                var _var4 = new fm.liveswitch.Holder(num4);
                                var _var5 = fm.liveswitch.sdp.rtp.SimulcastAttribute.streamsFromString(value, _var4);
                                num4 = _var4.getValue();
                                streamArray2 = _var5;
                                draftVersion = fm.liveswitch.MathAssistant.max(num3, num4);
                            }
                            var description = new fm.liveswitch.sdp.rtp.SimulcastStreamDescription(direction, streams);
                            var description2 = null;
                            if ((!fm.liveswitch.Global.equals(str2, null))) {
                                description2 = new fm.liveswitch.sdp.rtp.SimulcastStreamDescription(str2, streamArray2);
                            }
                            var attribute = new fm.liveswitch.sdp.rtp.SimulcastAttribute(description, description2);
                            attribute.setDraftVersion(draftVersion);
                            return attribute;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    SimulcastAttribute.streamsFromString = function (streamsString, draftVersion) {
                        if (arguments.length == 2) {
                            draftVersion.setValue(-1);
                            if (fm.liveswitch.StringExtensions.startsWith(streamsString, "rid=")) {
                                draftVersion.setValue(3);
                                streamsString = streamsString.substring(fm.liveswitch.StringExtensions.getLength("rid="));
                            }
                            else {
                                if (fm.liveswitch.StringExtensions.startsWith(streamsString, "pt=")) {
                                    throw new fm.liveswitch.Exception("Draft version 03 'pt=' parsing is not supported.");
                                }
                            }
                            var strArray = fm.liveswitch.StringExtensions.split(streamsString, [59]);
                            var streamArray = new Array(strArray.length);
                            for (var i = 0; (i < streamArray.length); i++) {
                                var strArray2 = fm.liveswitch.StringExtensions.split(strArray[i], [44]);
                                var ids = new Array(strArray2.length);
                                for (var j = 0; (j < ids.length); j++) {
                                    var idValue = strArray2[j];
                                    if (fm.liveswitch.StringExtensions.startsWith(idValue, "~")) {
                                        ids[j] = new fm.liveswitch.sdp.rtp.SimulcastStreamId(idValue.substring(1), true);
                                    }
                                    else {
                                        ids[j] = new fm.liveswitch.sdp.rtp.SimulcastStreamId(idValue);
                                    }
                                }
                                streamArray[i] = new fm.liveswitch.sdp.rtp.SimulcastStream(ids);
                            }
                            return streamArray;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    SimulcastAttribute.streamsToString = function (streams, draftVersion) {
                        if (arguments.length == 2) {
                            var strArray = new Array(streams.length);
                            for (var i = 0; (i < strArray.length); i++) {
                                var stream = streams[i];
                                var strArray2 = new Array(stream.getIds().length);
                                for (var j = 0; (j < strArray2.length); j++) {
                                    var idValue = stream.getIds()[j];
                                    if (idValue.getPaused()) {
                                        strArray2[j] = fm.liveswitch.StringExtensions.format("~{0}", idValue.getId());
                                    }
                                    else {
                                        strArray2[j] = idValue.getId();
                                    }
                                }
                                strArray[i] = fm.liveswitch.StringExtensions.join(",", strArray2);
                            }
                            var str = fm.liveswitch.StringExtensions.join(";", strArray);
                            if (((fm.liveswitch.Global.equals(draftVersion, 2)) || (fm.liveswitch.Global.equals(draftVersion, 3)))) {
                                str = fm.liveswitch.StringExtensions.concat("rid=", str);
                            }
                            return str;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the internal value of the attribute.
                    */
                    SimulcastAttribute.prototype.getAttributeValue = function () {
                        if (arguments.length == 0) {
                            var builder = new fm.liveswitch.StringBuilder();
                            builder.append(this.getDescription1().getDirection());
                            builder.append(" ");
                            builder.append(fm.liveswitch.sdp.rtp.SimulcastAttribute.streamsToString(this.getDescription1().getStreams(), this.getDraftVersion()));
                            if ((!fm.liveswitch.Global.equals(this.getDescription2(), null))) {
                                builder.append(" ");
                                builder.append(this.getDescription2().getDirection());
                                builder.append(" ");
                                builder.append(fm.liveswitch.sdp.rtp.SimulcastAttribute.streamsToString(this.getDescription2().getStreams(), this.getDraftVersion()));
                            }
                            return builder.toString();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    SimulcastAttribute.prototype.getDescription = function (direction) {
                        if (arguments.length == 1) {
                            if (((!fm.liveswitch.Global.equals(this.getDescription1(), null)) && (fm.liveswitch.Global.equals(this.getDescription1().getDirection(), direction)))) {
                                return this.getDescription1();
                            }
                            if (((!fm.liveswitch.Global.equals(this.getDescription2(), null)) && (fm.liveswitch.Global.equals(this.getDescription2().getDirection(), direction)))) {
                                return this.getDescription2();
                            }
                            return null;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the first description.
                    */
                    SimulcastAttribute.prototype.getDescription1 = function () {
                        if (arguments.length == 0) {
                            return this._description1;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the second description.
                    */
                    SimulcastAttribute.prototype.getDescription2 = function () {
                        if (arguments.length == 0) {
                            return this._description2;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the version of the IETF draft to comply with. https://tools.ietf.org/html/draft-ietf-mmusic-sdp-simulcast
                    */
                    SimulcastAttribute.prototype.getDraftVersion = function () {
                        if (arguments.length == 0) {
                            return this._draftVersion;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the 'receive' description.
                    */
                    SimulcastAttribute.prototype.getReceiveDescription = function () {
                        if (arguments.length == 0) {
                            return this.getDescription(fm.liveswitch.sdp.rtp.SimulcastDirection.getReceive());
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the 'send' description.
                    */
                    SimulcastAttribute.prototype.getSendDescription = function () {
                        if (arguments.length == 0) {
                            return this.getDescription(fm.liveswitch.sdp.rtp.SimulcastDirection.getSend());
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    SimulcastAttribute.prototype.setDescription1 = function (value) {
                        if (arguments.length == 1) {
                            this._description1 = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    SimulcastAttribute.prototype.setDescription2 = function (value) {
                        if (arguments.length == 1) {
                            this._description2 = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the version of the IETF draft to comply with. https://tools.ietf.org/html/draft-ietf-mmusic-sdp-simulcast
                    */
                    SimulcastAttribute.prototype.setDraftVersion = function (value) {
                        if (arguments.length == 1) {
                            this._draftVersion = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return SimulcastAttribute;
                }(fm.liveswitch.sdp.Attribute));
                rtp.SimulcastAttribute = SimulcastAttribute;
            })(rtp = sdp.rtp || (sdp.rtp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var rtp;
            (function (rtp) {
                /**
                A simulcast stream identifier.
                */
                var SimulcastStreamId = /** @class */ (function () {
                    function SimulcastStreamId() {
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 1) {
                            var idValue = __arguments[0];
                            // chained constructor: SimulcastStreamId.call(this, idValue, false);
                            __arguments = new Array(2);
                            __arguments[0] = idValue;
                            __arguments[1] = false;
                            {
                                var idValue_6 = __arguments[0];
                                var paused = __arguments[1];
                                //super();
                                this.fmliveswitchsdprtpSimulcastStreamIdInit();
                                if ((fm.liveswitch.Global.equals(idValue_6, null))) {
                                    throw new fm.liveswitch.Exception("Simulcast stream 'ID' cannot be null.");
                                }
                                this.setId(idValue_6);
                                this.setPaused(paused);
                            }
                        }
                        else if (__arguments.length == 2) {
                            var idValue = __arguments[0];
                            var paused = __arguments[1];
                            //super();
                            this.fmliveswitchsdprtpSimulcastStreamIdInit();
                            if ((fm.liveswitch.Global.equals(idValue, null))) {
                                throw new fm.liveswitch.Exception("Simulcast stream 'ID' cannot be null.");
                            }
                            this.setId(idValue);
                            this.setPaused(paused);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                    }
                    SimulcastStreamId.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.rtp.SimulcastStreamId]';
                    };
                    SimulcastStreamId.prototype.fmliveswitchsdprtpSimulcastStreamIdInit = function () {
                        this._paused = false;
                    };
                    /**
                    Gets the identifier.
                    */
                    SimulcastStreamId.prototype.getId = function () {
                        if (arguments.length == 0) {
                            return this._id;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets whether the stream is paused.
                    */
                    SimulcastStreamId.prototype.getPaused = function () {
                        if (arguments.length == 0) {
                            return this._paused;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    SimulcastStreamId.prototype.setId = function (value) {
                        if (arguments.length == 1) {
                            this._id = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    SimulcastStreamId.prototype.setPaused = function (value) {
                        if (arguments.length == 1) {
                            this._paused = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return SimulcastStreamId;
                }());
                rtp.SimulcastStreamId = SimulcastStreamId;
            })(rtp = sdp.rtp || (sdp.rtp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var rtp;
            (function (rtp) {
                /**
                The SDP media attribute "ssrc-group" expresses a relationship among several sources of an RTP session.
                */
                var SsrcGroupAttribute = /** @class */ (function (_super) {
                    __extends(SsrcGroupAttribute, _super);
                    function SsrcGroupAttribute() {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            _this = _super.call(this) || this;
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.RtpSsrcGroupAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                        }
                        else if (__arguments.length == 2) {
                            var semantics = __arguments[0];
                            var synchronizationSources = __arguments[1];
                            // chained constructor: SsrcGroupAttribute.call(this);
                            __arguments = new Array(0);
                            {
                                _this = _super.call(this) || this;
                                _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.RtpSsrcGroupAttribute);
                                _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                            }
                            if (fm.liveswitch.StringExtensions.isNullOrEmpty(semantics)) {
                                throw new fm.liveswitch.Exception("semantics cannot be null.");
                            }
                            if ((fm.liveswitch.Global.equals(synchronizationSources, null))) {
                                throw new fm.liveswitch.Exception("synchronizationSources cannot be null.");
                            }
                            _this.setSemantics(semantics);
                            _this.setSynchronizationSources(synchronizationSources);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    SsrcGroupAttribute.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.rtp.SsrcGroupAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.rtp.ssrcGroupAttribute]] class.
                    @param value The attribute value.
                    */
                    SsrcGroupAttribute.fromAttributeValue = function (value) {
                        if (arguments.length == 1) {
                            var index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                            var str = fm.liveswitch.StringExtensions.substring(value, 0, index);
                            value = value.substring((index + 1));
                            var strArray = fm.liveswitch.StringExtensions.split(value, [32]);
                            var numArray = new Array(strArray.length);
                            for (var i = 0; (i < numArray.length); i++) {
                                numArray[i] = fm.liveswitch.ParseAssistant.parseLongValue(strArray[i]);
                            }
                            var attribute = new fm.liveswitch.sdp.rtp.SsrcGroupAttribute();
                            attribute.setSemantics(str);
                            attribute.setSynchronizationSources(numArray);
                            return attribute;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the internal value of the attribute.
                    */
                    SsrcGroupAttribute.prototype.getAttributeValue = function () {
                        if (arguments.length == 0) {
                            var builder = new fm.liveswitch.StringBuilder();
                            builder.append(this.getSemantics());
                            for (var _i = 0, _a = this.getSynchronizationSources(); _i < _a.length; _i++) {
                                var num = _a[_i];
                                builder.append(" ");
                                builder.append(fm.liveswitch.NumberExtensions.toString(num));
                            }
                            return builder.toString();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the semantics.
                    */
                    SsrcGroupAttribute.prototype.getSemantics = function () {
                        if (arguments.length == 0) {
                            return this._semantics;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the synchronization sources.
                    */
                    SsrcGroupAttribute.prototype.getSynchronizationSources = function () {
                        if (arguments.length == 0) {
                            return this._synchronizationSources;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    SsrcGroupAttribute.prototype.setSemantics = function (value) {
                        if (arguments.length == 1) {
                            this._semantics = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    SsrcGroupAttribute.prototype.setSynchronizationSources = function (value) {
                        if (arguments.length == 1) {
                            this._synchronizationSources = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return SsrcGroupAttribute;
                }(fm.liveswitch.sdp.Attribute));
                rtp.SsrcGroupAttribute = SsrcGroupAttribute;
            })(rtp = sdp.rtp || (sdp.rtp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var rtp;
            (function (rtp) {
                /**
                The SDP media attribute "ssrc" indicates a property (known as a "source-level attribute") of a media source (RTP stream) within an RTP session.
                */
                var SsrcAttribute = /** @class */ (function (_super) {
                    __extends(SsrcAttribute, _super);
                    function SsrcAttribute() {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            _this = _super.call(this) || this;
                            _this.fmliveswitchsdprtpSsrcAttributeInit();
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.RtpSsrcAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                        }
                        else if (__arguments.length == 2) {
                            var synchronizationSource = __arguments[0];
                            var attributeName = __arguments[1];
                            // chained constructor: SsrcAttribute.call(this, synchronizationSource, attributeName, null);
                            __arguments = new Array(3);
                            __arguments[0] = synchronizationSource;
                            __arguments[1] = attributeName;
                            __arguments[2] = null;
                            {
                                var synchronizationSource_1 = __arguments[0];
                                var attributeName_1 = __arguments[1];
                                var attributeValue = __arguments[2];
                                // chained constructor: SsrcAttribute.call(this);
                                __arguments = new Array(0);
                                {
                                    _this = _super.call(this) || this;
                                    _this.fmliveswitchsdprtpSsrcAttributeInit();
                                    _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.RtpSsrcAttribute);
                                    _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                                }
                                if (fm.liveswitch.StringExtensions.isNullOrEmpty(attributeName_1)) {
                                    throw new fm.liveswitch.Exception("attributeName cannot be null.");
                                }
                                _this.setSynchronizationSource(synchronizationSource_1);
                                _this.setName(attributeName_1);
                                _this.setValue(attributeValue);
                            }
                        }
                        else if (__arguments.length == 3) {
                            var synchronizationSource = __arguments[0];
                            var attributeName = __arguments[1];
                            var attributeValue = __arguments[2];
                            // chained constructor: SsrcAttribute.call(this);
                            __arguments = new Array(0);
                            {
                                _this = _super.call(this) || this;
                                _this.fmliveswitchsdprtpSsrcAttributeInit();
                                _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.RtpSsrcAttribute);
                                _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                            }
                            if (fm.liveswitch.StringExtensions.isNullOrEmpty(attributeName)) {
                                throw new fm.liveswitch.Exception("attributeName cannot be null.");
                            }
                            _this.setSynchronizationSource(synchronizationSource);
                            _this.setName(attributeName);
                            _this.setValue(attributeValue);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    SsrcAttribute.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.rtp.SsrcAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    SsrcAttribute.prototype.fmliveswitchsdprtpSsrcAttributeInit = function () {
                        this._synchronizationSource = 0;
                    };
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.rtp.ssrcAttribute]] class.
                    @param value The attribute value.
                    */
                    SsrcAttribute.fromAttributeValue = function (value) {
                        if (arguments.length == 1) {
                            var index = fm.liveswitch.StringExtensions.indexOf(value, " ");
                            var num2 = fm.liveswitch.ParseAssistant.parseLongValue(fm.liveswitch.StringExtensions.substring(value, 0, index));
                            value = value.substring((index + 1));
                            var length_42 = fm.liveswitch.StringExtensions.indexOf(value, ":");
                            var str = null;
                            var str2 = null;
                            if ((fm.liveswitch.Global.equals(length_42, -1))) {
                                str = value;
                            }
                            else {
                                str = fm.liveswitch.StringExtensions.substring(value, 0, length_42);
                                value = value.substring((length_42 + 1));
                                str2 = value;
                            }
                            var attribute = new fm.liveswitch.sdp.rtp.SsrcAttribute();
                            attribute.setSynchronizationSource(num2);
                            attribute.setName(str);
                            attribute.setValue(str2);
                            return attribute;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the internal value of the attribute.
                    */
                    SsrcAttribute.prototype.getAttributeValue = function () {
                        if (arguments.length == 0) {
                            var builder = new fm.liveswitch.StringBuilder();
                            builder.append(fm.liveswitch.NumberExtensions.toString(this.getSynchronizationSource()));
                            builder.append(" ");
                            builder.append(this.getName());
                            if (!fm.liveswitch.StringExtensions.isNullOrEmpty(this.getValue())) {
                                builder.append(":");
                                builder.append(this.getValue());
                            }
                            return builder.toString();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the name of the attribute.
                    */
                    SsrcAttribute.prototype.getName = function () {
                        if (arguments.length == 0) {
                            return this._name;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the synchronization source.
                    */
                    SsrcAttribute.prototype.getSynchronizationSource = function () {
                        if (arguments.length == 0) {
                            return this._synchronizationSource;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the attribute value.
                    */
                    SsrcAttribute.prototype.getValue = function () {
                        if (arguments.length == 0) {
                            return this._value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    SsrcAttribute.prototype.setName = function (value) {
                        if (arguments.length == 1) {
                            this._name = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    SsrcAttribute.prototype.setSynchronizationSource = function (value) {
                        if (arguments.length == 1) {
                            this._synchronizationSource = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Sets the attribute value.
                    */
                    SsrcAttribute.prototype.setValue = function (value) {
                        if (arguments.length == 1) {
                            this._value = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return SsrcAttribute;
                }(fm.liveswitch.sdp.Attribute));
                rtp.SsrcAttribute = SsrcAttribute;
            })(rtp = sdp.rtp || (sdp.rtp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var rtp;
            (function (rtp) {
                /**
                SSRC atribute names.
                */
                var SsrcAttributeName = /** @class */ (function () {
                    function SsrcAttributeName() {
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            //super();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                    }
                    SsrcAttributeName.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.rtp.SsrcAttributeName]';
                    };
                    /**
                    Gets a value indicating canonical name.
                    */
                    SsrcAttributeName.getCName = function () {
                        if (arguments.length == 0) {
                            return "cname";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets a value indicating format parameters.
                    */
                    SsrcAttributeName.getFormatParameters = function () {
                        if (arguments.length == 0) {
                            return "fmtp";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets a value indicating label.
                    */
                    SsrcAttributeName.getLabel = function () {
                        if (arguments.length == 0) {
                            return "label";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets a value indicating media stream ID.
                    */
                    SsrcAttributeName.getMediaStreamId = function () {
                        if (arguments.length == 0) {
                            return "msid";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets a value indicating media stream label.
                    */
                    SsrcAttributeName.getMediaStreamLabel = function () {
                        if (arguments.length == 0) {
                            return "mslabel";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets a value indicating previous SSRC.
                    */
                    SsrcAttributeName.getPreviousSsrc = function () {
                        if (arguments.length == 0) {
                            return "previous-ssrc";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return SsrcAttributeName;
                }());
                rtp.SsrcAttributeName = SsrcAttributeName;
            })(rtp = sdp.rtp || (sdp.rtp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var sctp;
            (function (sctp) {
                /**
                AB: Legacy attribute. To be removed when Firefox and Chrome stop using it. The sctpmap attribute maps from a port number (as used in an "m=" line) to an encoding name denoting the payload format to be used on top of the SCTP association or the actual protocol running on top of it. Last appears in https://tools.ietf.org/html/draft-ietf-mmusic-sctp-sdp-06#page-6 Has been replaced in subsequent drafts but is used in Firefox and Chrome for now.
                */
                var MapAttribute = /** @class */ (function (_super) {
                    __extends(MapAttribute, _super);
                    function MapAttribute() {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            _this = _super.call(this) || this;
                            _this.fmliveswitchsdpsctpMapAttributeInit();
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.SctpMapAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Caution);
                        }
                        else if (__arguments.length == 3) {
                            var port = __arguments[0];
                            var protocol = __arguments[1];
                            var streams = __arguments[2];
                            // chained constructor: MapAttribute.call(this);
                            __arguments = new Array(0);
                            {
                                _this = _super.call(this) || this;
                                _this.fmliveswitchsdpsctpMapAttributeInit();
                                _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.SctpMapAttribute);
                                _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Caution);
                            }
                            _this.setPort(port);
                            _this.setSctpProtocol(protocol);
                            _this.setStreams(streams);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    MapAttribute.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.sctp.MapAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    MapAttribute.prototype.fmliveswitchsdpsctpMapAttributeInit = function () {
                        this._port = 0;
                        this._streams = 0;
                    };
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.sctp.portAttribute]] class.
                    @param value The attribute value.
                    */
                    MapAttribute.fromAttributeValue = function (value) {
                        if (arguments.length == 1) {
                            var strArray = fm.liveswitch.StringExtensions.split(value, [32]);
                            var num = fm.liveswitch.ParseAssistant.parseIntegerValue(strArray[0]);
                            var str = strArray[1];
                            var num2 = ((strArray.length > 2) ? fm.liveswitch.ParseAssistant.parseIntegerValue(strArray[2]) : 16);
                            var attribute = new fm.liveswitch.sdp.sctp.MapAttribute();
                            attribute.setPort(num);
                            attribute.setSctpProtocol(str);
                            attribute.setStreams(num2);
                            return attribute;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the internal value of the attribute.
                    */
                    MapAttribute.prototype.getAttributeValue = function () {
                        if (arguments.length == 0) {
                            var builder = new fm.liveswitch.StringBuilder();
                            builder.append(fm.liveswitch.NumberExtensions.toString(this.getPort()));
                            builder.append(" ");
                            builder.append(this.getSctpProtocol());
                            builder.append(" ");
                            builder.append(fm.liveswitch.NumberExtensions.toString(this.getStreams()));
                            return builder.toString();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the SCTP port.
                    */
                    MapAttribute.prototype.getPort = function () {
                        if (arguments.length == 0) {
                            return this._port;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the SCTP sub-protocol (association usage).
                    */
                    MapAttribute.prototype.getSctpProtocol = function () {
                        if (arguments.length == 0) {
                            return this._sctpProtocol;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the number of incoming streams.
                    */
                    MapAttribute.prototype.getStreams = function () {
                        if (arguments.length == 0) {
                            return this._streams;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    MapAttribute.prototype.setPort = function (value) {
                        if (arguments.length == 1) {
                            this._port = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    MapAttribute.prototype.setSctpProtocol = function (value) {
                        if (arguments.length == 1) {
                            this._sctpProtocol = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    MapAttribute.prototype.setStreams = function (value) {
                        if (arguments.length == 1) {
                            this._streams = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return MapAttribute;
                }(fm.liveswitch.sdp.Attribute));
                sctp.MapAttribute = MapAttribute;
            })(sctp = sdp.sctp || (sdp.sctp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var sctp;
            (function (sctp) {
                /**
                The attribute can be associated with an m- line to indicate the maximum message size (indicated in bytes) that an SCTP endpoint is willing to receive on the SCTP association associated with the m- line. Different attribute values can be used in each direction.
                */
                var MaxMessageSizeAttribute = /** @class */ (function (_super) {
                    __extends(MaxMessageSizeAttribute, _super);
                    function MaxMessageSizeAttribute() {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            _this = _super.call(this) || this;
                            _this.fmliveswitchsdpsctpMaxMessageSizeAttributeInit();
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.SctpMaxMessageSizeAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Caution);
                        }
                        else if (__arguments.length == 1) {
                            var maxMessageSize = __arguments[0];
                            // chained constructor: MaxMessageSizeAttribute.call(this);
                            __arguments = new Array(0);
                            {
                                _this = _super.call(this) || this;
                                _this.fmliveswitchsdpsctpMaxMessageSizeAttributeInit();
                                _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.SctpMaxMessageSizeAttribute);
                                _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Caution);
                            }
                            _this.setMaxMessageSize(maxMessageSize);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    MaxMessageSizeAttribute.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.sctp.MaxMessageSizeAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    MaxMessageSizeAttribute.prototype.fmliveswitchsdpsctpMaxMessageSizeAttributeInit = function () {
                        this._maxMessageSize = 0;
                    };
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.sctp.maxMessageSizeAttribute]] class.
                    @param value The attribute value.
                    */
                    MaxMessageSizeAttribute.fromAttributeValue = function (value) {
                        if (arguments.length == 1) {
                            var num = fm.liveswitch.ParseAssistant.parseLongValue(value);
                            var attribute = new fm.liveswitch.sdp.sctp.MaxMessageSizeAttribute();
                            attribute.setMaxMessageSize(num);
                            return attribute;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the internal value of the attribute.
                    */
                    MaxMessageSizeAttribute.prototype.getAttributeValue = function () {
                        if (arguments.length == 0) {
                            var builder = new fm.liveswitch.StringBuilder();
                            builder.append(fm.liveswitch.NumberExtensions.toString(this.getMaxMessageSize()));
                            return builder.toString();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the maximum message size in bytes.
                    */
                    MaxMessageSizeAttribute.prototype.getMaxMessageSize = function () {
                        if (arguments.length == 0) {
                            return this._maxMessageSize;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    MaxMessageSizeAttribute.prototype.setMaxMessageSize = function (value) {
                        if (arguments.length == 1) {
                            this._maxMessageSize = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return MaxMessageSizeAttribute;
                }(fm.liveswitch.sdp.Attribute));
                sctp.MaxMessageSizeAttribute = MaxMessageSizeAttribute;
            })(sctp = sdp.sctp || (sdp.sctp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/Media.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var sctp;
            (function (sctp) {
                /**
                An SDP media description with a transport protocol of "RTP/AVP" or "RTP/SAVP".
                */
                var Media = /** @class */ (function (_super) {
                    __extends(Media, _super);
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.sctp.media]] class.
                    @param mediaType The media type. See [[fm.liveswitch.sdp.mediaType]] for possible values.
                    @param transportPort The transport port.
                    @param transportProtocol The transport protocol.
                    @param associationUsage The association usage.
                    */
                    function Media(mediaType, transportPort, transportProtocol, associationUsage) {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 4) {
                            var mediaType_3 = __arguments[0];
                            var transportPort_3 = __arguments[1];
                            var transportProtocol_3 = __arguments[2];
                            var associationUsage_1 = __arguments[3];
                            _this = _super.call(this, mediaType_3, transportPort_3, transportProtocol_3) || this;
                            if ((fm.liveswitch.Global.equals(associationUsage_1, null))) {
                                throw new fm.liveswitch.Exception("associationUsage cannot be null.");
                            }
                            _super.prototype.setFormatDescription.call(_this, associationUsage_1);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    Media.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.sctp.Media]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    /**
                    Gets the protocol keyword for the SCTP over DTLS data profile.
                    */
                    Media.getDtlsSctpTransportProtocol = function () {
                        if (arguments.length == 0) {
                            return "DTLS/SCTP";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the protocol keyword for the DTLS over SCTP data profile.
                    */
                    Media.getSctpDtlsTransportProtocol = function () {
                        if (arguments.length == 0) {
                            return "SCTP/DTLS";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the protocol keyword for the SCTP data profile.
                    */
                    Media.getSctpTransportProtocol = function () {
                        if (arguments.length == 0) {
                            return "SCTP";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the protocol keyword for the SCTP over DTLS over TCP data profile.
                    */
                    Media.getTcpDtlsSctpTransportProtocol = function () {
                        if (arguments.length == 0) {
                            return "TCP/DTLS/SCTP";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the protocol keyword for the SCTP over DTLS over UDP data profile.
                    */
                    Media.getUdpDtlsSctpTransportProtocol = function () {
                        if (arguments.length == 0) {
                            return "UDP/DTLS/SCTP";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the Association Usage name registry for WebRTC Datachannel.
                    */
                    Media.getWebRtcDatachannelAssociationUsage = function () {
                        if (arguments.length == 0) {
                            return "webrtc-datachannel";
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Returns a value indicating whther a given protocol is supported.
                    @param protocol Protocol keyword.
                    @return Value indicating whther a given protocol is supported.
                    */
                    Media.isSupported = function (protocol) {
                        if (arguments.length == 1) {
                            return ((((fm.liveswitch.Global.equals(protocol, fm.liveswitch.sdp.sctp.Media.getSctpTransportProtocol())) || (fm.liveswitch.Global.equals(protocol, fm.liveswitch.sdp.sctp.Media.getSctpDtlsTransportProtocol()))) || ((fm.liveswitch.Global.equals(protocol, fm.liveswitch.sdp.sctp.Media.getDtlsSctpTransportProtocol())) || (fm.liveswitch.Global.equals(protocol, fm.liveswitch.sdp.sctp.Media.getUdpDtlsSctpTransportProtocol())))) || (fm.liveswitch.Global.equals(protocol, fm.liveswitch.sdp.sctp.Media.getTcpDtlsSctpTransportProtocol())));
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Returns a value indicating whther a given protocol supports encryption.
                    @param protocol Protocol keyword.
                    @return Value indicating whther a given protocol supports encryption.
                    */
                    Media.supportsEncryption = function (protocol) {
                        if (arguments.length == 1) {
                            return (((fm.liveswitch.Global.equals(protocol, fm.liveswitch.sdp.sctp.Media.getUdpDtlsSctpTransportProtocol())) || (fm.liveswitch.Global.equals(protocol, fm.liveswitch.sdp.sctp.Media.getDtlsSctpTransportProtocol()))) || (fm.liveswitch.Global.equals(protocol, fm.liveswitch.sdp.sctp.Media.getTcpDtlsSctpTransportProtocol())));
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return Media;
                }(fm.liveswitch.sdp.Media));
                sctp.Media = Media;
            })(sctp = sdp.sctp || (sdp.sctp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var sctp;
            (function (sctp) {
                /**
                The attribute can be associated with an SDP media description (m- line) with a 'UDP/DTLS/SCTP' or a 'TCP/DTLS/SCTP' proto value, in which case the m- line port value indicates the port of the underlying transport-layer protocol (UDP or TCP), on which SCTP is carried, and the 'sctp-port' value indicates the SCTP port.
                */
                var PortAttribute = /** @class */ (function (_super) {
                    __extends(PortAttribute, _super);
                    function PortAttribute() {
                        var _this = this;
                        var __arguments = new Array(arguments.length);
                        for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                            __arguments[__argumentIndex] = arguments[__argumentIndex];
                        }
                        if (__arguments.length == 0) {
                            _this = _super.call(this) || this;
                            _this.fmliveswitchsdpsctpPortAttributeInit();
                            _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.SctpPortAttribute);
                            _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Caution);
                        }
                        else if (__arguments.length == 1) {
                            var port = __arguments[0];
                            // chained constructor: PortAttribute.call(this);
                            __arguments = new Array(0);
                            {
                                _this = _super.call(this) || this;
                                _this.fmliveswitchsdpsctpPortAttributeInit();
                                _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.SctpPortAttribute);
                                _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Caution);
                            }
                            _this.setPort(port);
                        }
                        else {
                            throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                        }
                        return _this;
                    }
                    PortAttribute.prototype.getTypeString = function () {
                        return '[fm.liveswitch.sdp.sctp.PortAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                    };
                    PortAttribute.prototype.fmliveswitchsdpsctpPortAttributeInit = function () {
                        this._port = 0;
                    };
                    /**
                    Initializes a new instance of the [[fm.liveswitch.sdp.sctp.portAttribute]] class.
                    @param value The attribute value.
                    */
                    PortAttribute.fromAttributeValue = function (value) {
                        if (arguments.length == 1) {
                            var num = fm.liveswitch.ParseAssistant.parseIntegerValue(value);
                            var attribute = new fm.liveswitch.sdp.sctp.PortAttribute();
                            attribute.setPort(num);
                            return attribute;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the internal value of the attribute.
                    */
                    PortAttribute.prototype.getAttributeValue = function () {
                        if (arguments.length == 0) {
                            var builder = new fm.liveswitch.StringBuilder();
                            builder.append(fm.liveswitch.NumberExtensions.toString(this.getPort()));
                            return builder.toString();
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /**
                    Gets the SCTP port.
                    */
                    PortAttribute.prototype.getPort = function () {
                        if (arguments.length == 0) {
                            return this._port;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    /** @hidden */
                    PortAttribute.prototype.setPort = function (value) {
                        if (arguments.length == 1) {
                            this._port = value;
                        }
                        else {
                            throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                        }
                    };
                    return PortAttribute;
                }(fm.liveswitch.sdp.Attribute));
                sctp.PortAttribute = PortAttribute;
            })(sctp = sdp.sctp || (sdp.sctp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            This can be a session-level attribute or a media-level attribute.  As a session-level attribute, it specifies the language for the session description.  As a media-level attribute, it specifies the language for any media-level SDP information field associated with that media.  Multiple sdplang attributes can be provided either at session or media level if multiple languages in the session description or media use multiple languages, in which case the order of the attributes indicates the order of importance of the various languages in the session or media from most important to least important.
            */
            var SdpLanguageAttribute = /** @class */ (function (_super) {
                __extends(SdpLanguageAttribute, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.sdpLanguageAttribute]] class.
                @param languageTag The language for either the session description
                            (if used as a session-level attribute) or any media-level SDP
                            information field associated with that media (if used as a
                            media-level attribute).
                */
                function SdpLanguageAttribute(languageTag) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var languageTag_2 = __arguments[0];
                        _this = _super.call(this) || this;
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.SdpLanguageAttribute);
                        if ((fm.liveswitch.Global.equals(languageTag_2, null))) {
                            throw new fm.liveswitch.Exception("languageTag cannot be null.");
                        }
                        _this.setLanguageTag(languageTag_2);
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                SdpLanguageAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.SdpLanguageAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.sdpLanguageAttribute]] class.
                @param value The attribute value.
                */
                SdpLanguageAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        return new fm.liveswitch.sdp.SdpLanguageAttribute(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                SdpLanguageAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        return this.getLanguageTag();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the language for either the session description (if used as a session-level attribute) or any media-level SDP information field associated with that media (if used as a media-level attribute).
                */
                SdpLanguageAttribute.prototype.getLanguageTag = function () {
                    if (arguments.length == 0) {
                        return this._languageTag;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                SdpLanguageAttribute.prototype.setLanguageTag = function (value) {
                    if (arguments.length == 1) {
                        this._languageTag = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return SdpLanguageAttribute;
            }(fm.liveswitch.sdp.Attribute));
            sdp.SdpLanguageAttribute = SdpLanguageAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/DirectionAttribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            This specifies that the tools should be started in send-only mode.  An example may be where a different unicast address is to be used for a traffic destination than for a traffic source. In such a case, two media descriptions may be used, one sendonly and one recvonly.  It can be either a session- or media-level attribute, but would normally only be used as a media attribute.  It is not dependent on charset.  Note that sendonly applies only to the media, and any associated control protocol (e.g., RTCP) SHOULD still be received and processed as normal.
            */
            var SendOnlyAttribute = /** @class */ (function (_super) {
                __extends(SendOnlyAttribute, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.sendOnlyAttribute]] class.
                */
                function SendOnlyAttribute() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.DirectionAttribute);
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                SendOnlyAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.SendOnlyAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.sendOnlyAttribute]] class.
                @param value The attribute value.
                */
                SendOnlyAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        return new fm.liveswitch.sdp.SendOnlyAttribute();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                SendOnlyAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the stream direction.
                */
                SendOnlyAttribute.prototype.getStreamDirection = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.StreamDirection.SendOnly;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return SendOnlyAttribute;
            }(fm.liveswitch.sdp.DirectionAttribute));
            sdp.SendOnlyAttribute = SendOnlyAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/DirectionAttribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            This specifies that the tools should be started in send and receive mode.  This is necessary for interactive conferences with tools that default to receive-only mode.  It can be either a session or media-level attribute, and it is not dependent on charset.
            */
            var SendReceiveAttribute = /** @class */ (function (_super) {
                __extends(SendReceiveAttribute, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.sendReceiveAttribute]] class.
                */
                function SendReceiveAttribute() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.DirectionAttribute);
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                SendReceiveAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.SendReceiveAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.sendReceiveAttribute]] class.
                @param value The attribute value.
                */
                SendReceiveAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        return new fm.liveswitch.sdp.SendReceiveAttribute();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                SendReceiveAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the stream direction.
                */
                SendReceiveAttribute.prototype.getStreamDirection = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.StreamDirection.SendReceive;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return SendReceiveAttribute;
            }(fm.liveswitch.sdp.DirectionAttribute));
            sdp.SendReceiveAttribute = SendReceiveAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            Defines valid SDP setups.
            */
            var Setup = /** @class */ (function () {
                function Setup() {
                }
                Setup.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.Setup]';
                };
                /**
                Gets the SDP setup meaning "Active".
                */
                Setup.getActive = function () {
                    if (arguments.length == 0) {
                        return "active";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP setup meaning "Active or Passive".
                */
                Setup.getActPass = function () {
                    if (arguments.length == 0) {
                        return "actpass";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the SDP setup meaning "Passive".
                */
                Setup.getPassive = function () {
                    if (arguments.length == 0) {
                        return "passive";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Setup;
            }());
            sdp.Setup = Setup;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            The 'setup' attribute indicates which of the end points should initiate the TCP connection establishment (i.e., send the initial TCP SYN).  The 'setup' attribute is charset-independent and can be a session-level or a media-level attribute.
            */
            var SetupAttribute = /** @class */ (function (_super) {
                __extends(SetupAttribute, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.setupAttribute]] class.
                @param setup Which end point should initiate the connection establishment. See [[fm.liveswitch.sdp.setupAttribute.setup]] for possible values.
                */
                function SetupAttribute(setup) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var setup_1 = __arguments[0];
                        _this = _super.call(this) || this;
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.SetupAttribute);
                        _this.setSetup(setup_1);
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Transport);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                SetupAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.SetupAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.setupAttribute]] class.
                @param value The attribute value.
                */
                SetupAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        return new fm.liveswitch.sdp.SetupAttribute(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                SetupAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        return this.getSetup();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets which end point should initiate the connection establishment. See [[fm.liveswitch.sdp.setupAttribute.setup]] for possible values.
                */
                SetupAttribute.prototype.getSetup = function () {
                    if (arguments.length == 0) {
                        return this._setup;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                SetupAttribute.prototype.setSetup = function (value) {
                    if (arguments.length == 1) {
                        this._setup = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return SetupAttribute;
            }(fm.liveswitch.sdp.Attribute));
            sdp.SetupAttribute = SetupAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            An SDP time description element.
            */
            var TimeDescription = /** @class */ (function () {
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.timeDescription]] class.
                @param timing The start and stop time.
                */
                function TimeDescription(timing) {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var timing_1 = __arguments[0];
                        //super();
                        this.__repeatTimes = new Array();
                        if ((fm.liveswitch.Global.equals(timing_1, null))) {
                            throw new fm.liveswitch.Exception("timing cannot be null.");
                        }
                        this.setTiming(timing_1);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                TimeDescription.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.TimeDescription]';
                };
                /**
                Creates an [[fm.liveswitch.sdp.timeDescription]] instance from a string.
                @param s The string to parse.
                */
                TimeDescription.parse = function (s) {
                    if (arguments.length == 1) {
                        var strArray = fm.liveswitch.sdp.Utility.splitAndClean(s);
                        if ((!fm.liveswitch.Global.equals(strArray[0].charCodeAt(0), 116))) {
                            return null;
                        }
                        var description = new fm.liveswitch.sdp.TimeDescription(fm.liveswitch.sdp.Timing.parse(strArray[0]));
                        for (var i = 1; (i < strArray.length); i++) {
                            var str = strArray[i];
                            if ((fm.liveswitch.Global.equals(str.charCodeAt(0), 114))) {
                                description.addRepeatTime(fm.liveswitch.sdp.RepeatTime.parse(str));
                            }
                        }
                        return description;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Adds a repeat time.
                @param repeatTime The repeat time to add.
                */
                TimeDescription.prototype.addRepeatTime = function (repeatTime) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__repeatTimes, repeatTime);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the array of repeat times.
                */
                TimeDescription.prototype.getRepeatTimes = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.ArrayExtensions.toArray(this.__repeatTimes);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the start and stop time.
                */
                TimeDescription.prototype.getTiming = function () {
                    if (arguments.length == 0) {
                        return this._timing;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Removes a repeat time.
                @param repeatTime The repeat time to remove.
                */
                TimeDescription.prototype.removeRepeatTime = function (repeatTime) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.ArrayExtensions.remove(this.__repeatTimes, repeatTime);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                TimeDescription.prototype.setTiming = function (value) {
                    if (arguments.length == 1) {
                        this._timing = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Converts this instance to a string.
                */
                TimeDescription.prototype.toString = function () {
                    if (arguments.length == 0) {
                        var builder = new fm.liveswitch.StringBuilder();
                        builder.append(fm.liveswitch.StringExtensions.concat(this.getTiming().toString(), "\r\n"));
                        for (var _i = 0, _a = this.getRepeatTimes(); _i < _a.length; _i++) {
                            var time = _a[_i];
                            builder.append(fm.liveswitch.StringExtensions.concat(time.toString(), "\r\n"));
                        }
                        return builder.toString();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return TimeDescription;
            }());
            sdp.TimeDescription = TimeDescription;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            An SDP time zone element.
            */
            var TimeZone = /** @class */ (function () {
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.timeZone]] class.
                @param adjustmentTime The time that a time zone adjustment happens (network time protocol).
                @param offset The offset from the time when the session was first scheduled.
                */
                function TimeZone(adjustmentTime, offset) {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 2) {
                        var adjustmentTime_1 = __arguments[0];
                        var offset_1 = __arguments[1];
                        //super();
                        this.fmliveswitchsdpTimeZoneInit();
                        this.setAdjustmentTime(adjustmentTime_1);
                        this.setOffset(offset_1);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                TimeZone.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.TimeZone]';
                };
                TimeZone.prototype.fmliveswitchsdpTimeZoneInit = function () {
                    this._adjustmentTime = 0;
                };
                /**
                Creates an [[fm.liveswitch.sdp.timeZone]] instance from a string.
                @param s The string to parse.
                */
                TimeZone.parse = function (s) {
                    if (arguments.length == 1) {
                        var strArray = fm.liveswitch.StringExtensions.split(s, [32]);
                        var adjustmentTime = fm.liveswitch.ParseAssistant.parseDoubleValue(strArray[0]);
                        return new fm.liveswitch.sdp.TimeZone(adjustmentTime, new fm.liveswitch.TimeSpan(0, 0, fm.liveswitch.ParseAssistant.parseIntegerValue(strArray[1])));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the time that a time zone adjustment happens (network time protocol).
                */
                TimeZone.prototype.getAdjustmentTime = function () {
                    if (arguments.length == 0) {
                        return this._adjustmentTime;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the offset from the time when the session was first scheduled.
                */
                TimeZone.prototype.getOffset = function () {
                    if (arguments.length == 0) {
                        return this._offset;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                TimeZone.prototype.setAdjustmentTime = function (value) {
                    if (arguments.length == 1) {
                        this._adjustmentTime = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                TimeZone.prototype.setOffset = function (value) {
                    if (arguments.length == 1) {
                        this._offset = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Converts this instance to a string.
                */
                TimeZone.prototype.toString = function () {
                    if (arguments.length == 0) {
                        var builder = new fm.liveswitch.StringBuilder();
                        builder.append(fm.liveswitch.NumberExtensions.toString(this.getAdjustmentTime()));
                        builder.append(" ");
                        builder.append(fm.liveswitch.NumberExtensions.toString(this.getOffset().getTotalSeconds()));
                        return builder.toString();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return TimeZone;
            }());
            sdp.TimeZone = TimeZone;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            An SDP time zones element.
            */
            var TimeZones = /** @class */ (function () {
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.timeZones]] class.
                @param values The values.
                */
                function TimeZones(values) {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var values_5 = __arguments[0];
                        //super();
                        this.__values = new Array();
                        if ((fm.liveswitch.Global.equals(values_5, null))) {
                            throw new fm.liveswitch.Exception("timeZones cannot be null.");
                        }
                        fm.liveswitch.ArrayExtensions.addRange(this.__values, values_5);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                TimeZones.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.TimeZones]';
                };
                /**
                Creates an [[fm.liveswitch.sdp.timeZones]] instance from a string.
                @param s The string to parse.
                */
                TimeZones.parse = function (s) {
                    if (arguments.length == 1) {
                        s = s.substring(2);
                        var array = fm.liveswitch.StringExtensions.split(s, [32]);
                        var zones = new fm.liveswitch.sdp.TimeZones([fm.liveswitch.sdp.TimeZone.parse(fm.liveswitch.StringExtensions.join(" ", fm.liveswitch.StringAssistant.subArray(array, 0, 2)))]);
                        for (var i = 2; (i < array.length); i = (i + 2)) {
                            zones.addTimeZone(fm.liveswitch.sdp.TimeZone.parse(fm.liveswitch.StringExtensions.join(" ", fm.liveswitch.StringAssistant.subArray(array, i, 2))));
                        }
                        return zones;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Adds a time zone adjustment.
                @param value The time zone adjustment to add.
                */
                TimeZones.prototype.addTimeZone = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__values, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the array of time zone adjustments.
                */
                TimeZones.prototype.getValues = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.ArrayExtensions.toArray(this.__values);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Removes a time zone adjustment.
                @param value The time zone adjustment to remove.
                */
                TimeZones.prototype.removeTimeZone = function (value) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.ArrayExtensions.remove(this.__values, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Converts this instance to a string.
                */
                TimeZones.prototype.toString = function () {
                    if (arguments.length == 0) {
                        var builder = new fm.liveswitch.StringBuilder();
                        builder.append("z=");
                        for (var _i = 0, _a = this.getValues(); _i < _a.length; _i++) {
                            var zone = _a[_i];
                            builder.append(" ");
                            builder.append(zone.toString());
                        }
                        return fm.liveswitch.StringExtensions.trim(builder.toString());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return TimeZones;
            }());
            sdp.TimeZones = TimeZones;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            An SDP timing element.
            */
            var Timing = /** @class */ (function () {
                function Timing() {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        //super();
                        this.fmliveswitchsdpTimingInit();
                        this.setStartTime(0);
                        this.setStopTime(0);
                    }
                    else if (__arguments.length == 2) {
                        var startTime = __arguments[0];
                        var stopTime = __arguments[1];
                        //super();
                        this.fmliveswitchsdpTimingInit();
                        this.setStartTime(startTime);
                        this.setStopTime(stopTime);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                Timing.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.Timing]';
                };
                Timing.prototype.fmliveswitchsdpTimingInit = function () {
                    this._startTime = 0;
                    this._stopTime = 0;
                };
                /**
                Creates an [[fm.liveswitch.sdp.timing]] instance from a string.
                @param s The string to parse.
                */
                Timing.parse = function (s) {
                    if (arguments.length == 1) {
                        s = s.substring(2);
                        var strArray = fm.liveswitch.StringExtensions.split(s, [32]);
                        var num = 0;
                        if ((!fm.liveswitch.Global.equals(strArray[0], "0"))) {
                            num = fm.liveswitch.ParseAssistant.parseDoubleValue(strArray[0]);
                        }
                        var num2 = 0;
                        if ((!fm.liveswitch.Global.equals(strArray[1], "0"))) {
                            num2 = fm.liveswitch.ParseAssistant.parseDoubleValue(strArray[1]);
                        }
                        var timing = new fm.liveswitch.sdp.Timing();
                        timing.setStartTime(num);
                        timing.setStopTime(num2);
                        return timing;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the start time.
                */
                Timing.prototype.getStartTime = function () {
                    if (arguments.length == 0) {
                        return this._startTime;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the stop time.
                */
                Timing.prototype.getStopTime = function () {
                    if (arguments.length == 0) {
                        return this._stopTime;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the start time.
                */
                Timing.prototype.setStartTime = function (value) {
                    if (arguments.length == 1) {
                        this._startTime = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the stop time.
                */
                Timing.prototype.setStopTime = function (value) {
                    if (arguments.length == 1) {
                        this._stopTime = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Converts this instance to a string.
                */
                Timing.prototype.toString = function () {
                    if (arguments.length == 0) {
                        var builder = new fm.liveswitch.StringBuilder();
                        builder.append("t=");
                        if ((!fm.liveswitch.Global.equals(this.getStartTime(), 0))) {
                            builder.append(fm.liveswitch.NumberExtensions.toString(this.getStartTime()));
                        }
                        else {
                            builder.append("0");
                        }
                        builder.append(" ");
                        if ((!fm.liveswitch.Global.equals(this.getStopTime(), 0))) {
                            builder.append(fm.liveswitch.NumberExtensions.toString(this.getStopTime()));
                        }
                        else {
                            builder.append("0");
                        }
                        return builder.toString();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Timing;
            }());
            sdp.Timing = Timing;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            This gives the name and version number of the tool used to create the session description.  It is a session-level attribute, and it is not dependent on charset.
            */
            var ToolAttribute = /** @class */ (function (_super) {
                __extends(ToolAttribute, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.toolAttribute]] class.
                @param tool The name and version number of the
                            tool used to create the session description.
                */
                function ToolAttribute(tool) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var tool_1 = __arguments[0];
                        _this = _super.call(this) || this;
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.ToolAttribute);
                        if ((fm.liveswitch.Global.equals(tool_1, null))) {
                            throw new fm.liveswitch.Exception("tool cannot be null.");
                        }
                        _this.setTool(tool_1);
                        _super.prototype.setMultiplexingCategory.call(_this, fm.liveswitch.sdp.AttributeCategory.Normal);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ToolAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.ToolAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.toolAttribute]] class.
                @param value The attribute value.
                */
                ToolAttribute.fromAttributeValue = function (value) {
                    if (arguments.length == 1) {
                        return new fm.liveswitch.sdp.ToolAttribute(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the internal value of the attribute.
                */
                ToolAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        return this.getTool();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the name and version number of the tool used to create the session description.
                */
                ToolAttribute.prototype.getTool = function () {
                    if (arguments.length == 0) {
                        return this._tool;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                ToolAttribute.prototype.setTool = function (value) {
                    if (arguments.length == 1) {
                        this._tool = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ToolAttribute;
            }(fm.liveswitch.sdp.Attribute));
            sdp.ToolAttribute = ToolAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/Media.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            An SDP media description with a transport protocol of "udp".
            */
            var UdpMedia = /** @class */ (function (_super) {
                __extends(UdpMedia, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.udpMedia]] class.
                @param mediaType The media type. See [[fm.liveswitch.sdp.mediaType]] for possible values.
                @param transportPort The transport port.
                @param formatDescription The format description.
                */
                function UdpMedia(mediaType, transportPort, formatDescription) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 3) {
                        var mediaType_4 = __arguments[0];
                        var transportPort_4 = __arguments[1];
                        var formatDescription_1 = __arguments[2];
                        _this = _super.call(this, mediaType_4, transportPort_4, fm.liveswitch.sdp.UdpMedia.getUdpTransportProtocol(), formatDescription_1) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                UdpMedia.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.UdpMedia]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Gets the protocol keyword for UDP.
                */
                UdpMedia.getUdpTransportProtocol = function () {
                    if (arguments.length == 0) {
                        return "udp";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return UdpMedia;
            }(fm.liveswitch.sdp.Media));
            sdp.UdpMedia = UdpMedia;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/Attribute.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            This attribute is used to encapsulate unrecognized SDP attributes.
            */
            var UnknownAttribute = /** @class */ (function (_super) {
                __extends(UnknownAttribute, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.unknownAttribute]] class.
                @param name The name.
                @param value The value.
                */
                function UnknownAttribute(name, value) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 2) {
                        var name_22 = __arguments[0];
                        var value_32 = __arguments[1];
                        _this = _super.call(this) || this;
                        _this.setName(name_22);
                        _this.setValue(value_32);
                        _super.prototype.setAttributeType.call(_this, fm.liveswitch.sdp.AttributeType.UnknownAttribute);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                UnknownAttribute.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.UnknownAttribute]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Gets the internal value of the attribute.
                */
                UnknownAttribute.prototype.getAttributeValue = function () {
                    if (arguments.length == 0) {
                        return this.getValue();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the attribute name.
                */
                UnknownAttribute.prototype.getName = function () {
                    if (arguments.length == 0) {
                        return this._name;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the attribute value.
                */
                UnknownAttribute.prototype.getValue = function () {
                    if (arguments.length == 0) {
                        return this._value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                UnknownAttribute.prototype.setName = function (value) {
                    if (arguments.length == 1) {
                        this._name = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                UnknownAttribute.prototype.setValue = function (value) {
                    if (arguments.length == 1) {
                        this._value = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return UnknownAttribute;
            }(fm.liveswitch.sdp.Attribute));
            sdp.UnknownAttribute = UnknownAttribute;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../sdp/EncryptionKey.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /**
            An SDP encryption key with a method of "uri".
            */
            var UriEncryptionKey = /** @class */ (function (_super) {
                __extends(UriEncryptionKey, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.sdp.uriEncryptionKey]] class.
                @param uri The URI referring to the data containing the key.
                */
                function UriEncryptionKey(uri) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var uri_2 = __arguments[0];
                        _this = _super.call(this) || this;
                        if ((fm.liveswitch.Global.equals(uri_2, null))) {
                            throw new fm.liveswitch.Exception("uri cannot be null.");
                        }
                        _this.setUri(uri_2);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                UriEncryptionKey.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.UriEncryptionKey]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /** @hidden */
                UriEncryptionKey.prototype.getMethodAndValue = function () {
                    if (arguments.length == 0) {
                        var builder = new fm.liveswitch.StringBuilder();
                        builder.append("uri:");
                        builder.append(this.getUri().toString());
                        return builder.toString();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the URI referring to the data containing the key.
                */
                UriEncryptionKey.prototype.getUri = function () {
                    if (arguments.length == 0) {
                        return this._uri;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                UriEncryptionKey.prototype.setUri = function (value) {
                    if (arguments.length == 1) {
                        this._uri = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return UriEncryptionKey;
            }(fm.liveswitch.sdp.EncryptionKey));
            sdp.UriEncryptionKey = UriEncryptionKey;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            /** @hidden */
            var Utility = /** @class */ (function () {
                function Utility() {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        //super();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                Utility.prototype.getTypeString = function () {
                    return '[fm.liveswitch.sdp.Utility]';
                };
                Utility.splitAndClean = function (s) {
                    if (arguments.length == 1) {
                        var list = fm.liveswitch.ArrayExtensions.newArray(fm.liveswitch.StringExtensions.split(s, [10]));
                        for (var i = 0; (i < fm.liveswitch.ArrayExtensions.getCount(list)); i++) {
                            list[i] = fm.liveswitch.StringExtensions.trim(list[i]);
                            if (fm.liveswitch.StringExtensions.isNullOrEmpty(list[i])) {
                                fm.liveswitch.ArrayExtensions.removeAt(list, i);
                                i--;
                            }
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Utility;
            }());
            sdp.Utility = Utility;
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A session description.
        */
        var SessionDescription = /** @class */ (function () {
            function SessionDescription() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchSessionDescriptionInit();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            SessionDescription.prototype.getTypeString = function () {
                return '[fm.liveswitch.SessionDescription]';
            };
            SessionDescription.prototype.fmliveswitchSessionDescriptionInit = function () {
                this._renegotiation = false;
            };
            /**
            Deserializes an instance from JSON.
            @param sessionDescriptionJson The JSON to deserialize.
            @return The deserialized session description.
            */
            SessionDescription.fromJson = function (sessionDescriptionJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(sessionDescriptionJson, function () {
                        return new fm.liveswitch.SessionDescription();
                    }, function (sessionDescription, name, valueJson) {
                        var str = name;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            if (!(fm.liveswitch.Global.equals(str, "sdpMessage"))) {
                                if ((fm.liveswitch.Global.equals(str, "tieBreaker"))) {
                                    sessionDescription.setTieBreaker(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "isOffer"))) {
                                        sessionDescription.setType(((fm.liveswitch.Global.equals(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson), true)) ? fm.liveswitch.SessionDescriptionType.Offer : fm.liveswitch.SessionDescriptionType.Answer));
                                    }
                                }
                            }
                            else {
                                sessionDescription.setSdpMessage(fm.liveswitch.sdp.Message.parse(fm.liveswitch.JsonSerializer.deserializeString(valueJson)));
                            }
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param sessionDescription The session description.
            @return
                        The serialized JSON.
                
            */
            SessionDescription.toJson = function (sessionDescription) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(sessionDescription, function (sd, jsonObject) {
                        if ((!fm.liveswitch.Global.equals(sessionDescription.getSdpMessage(), null))) {
                            jsonObject["sdpMessage"] = fm.liveswitch.JsonSerializer.serializeString(sessionDescription.getSdpMessage().toString());
                        }
                        if ((!fm.liveswitch.Global.equals(sessionDescription.getTieBreaker(), null))) {
                            jsonObject["tieBreaker"] = fm.liveswitch.JsonSerializer.serializeString(sessionDescription.getTieBreaker());
                        }
                        jsonObject["isOffer"] = fm.liveswitch.JsonSerializer.serializeBoolean(sessionDescription.getIsOffer());
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether an audio stream is described.
            */
            SessionDescription.prototype.getHasAudio = function () {
                if (arguments.length == 0) {
                    var sdpMessage = this.getSdpMessage();
                    if ((fm.liveswitch.Global.equals(sdpMessage, null))) {
                        return false;
                    }
                    return (!fm.liveswitch.Global.equals(sdpMessage.getAudioDescription(), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether a data stream is described.
            */
            SessionDescription.prototype.getHasData = function () {
                if (arguments.length == 0) {
                    var sdpMessage = this.getSdpMessage();
                    if ((fm.liveswitch.Global.equals(sdpMessage, null))) {
                        return false;
                    }
                    return (((!fm.liveswitch.Global.equals(sdpMessage.getApplicationDescription(), null)) || (!fm.liveswitch.Global.equals(sdpMessage.getTextDescription(), null))) || (!fm.liveswitch.Global.equals(sdpMessage.getMessageDescription(), null)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether a video stream is described.
            */
            SessionDescription.prototype.getHasVideo = function () {
                if (arguments.length == 0) {
                    var sdpMessage = this.getSdpMessage();
                    if ((fm.liveswitch.Global.equals(sdpMessage, null))) {
                        return false;
                    }
                    return (!fm.liveswitch.Global.equals(sdpMessage.getVideoDescription(), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this instance is offer.
            */
            SessionDescription.prototype.getIsOffer = function () {
                if (arguments.length == 0) {
                    return (fm.liveswitch.Global.equals(this.getType(), fm.liveswitch.SessionDescriptionType.Offer));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SessionDescription.prototype.getRenegotiation = function () {
                if (arguments.length == 0) {
                    return this._renegotiation;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the SDP message.
            */
            SessionDescription.prototype.getSdpMessage = function () {
                if (arguments.length == 0) {
                    return this._sdpMessage;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the session id of the remote description, if remote description is set. Returns null otherwise.
            */
            SessionDescription.prototype.getSessionId = function () {
                if (arguments.length == 0) {
                    if ((!fm.liveswitch.Global.equals(this.getSdpMessage(), null))) {
                        var origin_13 = this.getSdpMessage().getOrigin();
                        if ((!fm.liveswitch.Global.equals(origin_13, null))) {
                            return origin_13.getSessionId();
                        }
                    }
                    return -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the version of the remote description, if remote description is set. Returns null otherwise.
            */
            SessionDescription.prototype.getSessionVersion = function () {
                if (arguments.length == 0) {
                    if ((!fm.liveswitch.Global.equals(this.getSdpMessage(), null))) {
                        var origin_14 = this.getSdpMessage().getOrigin();
                        if ((!fm.liveswitch.Global.equals(origin_14, null))) {
                            return origin_14.getSessionVersion();
                        }
                    }
                    return -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the tie breaker in case of a role conflict.
            */
            SessionDescription.prototype.getTieBreaker = function () {
                if (arguments.length == 0) {
                    return this._tieBreaker;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the type.
            */
            SessionDescription.prototype.getType = function () {
                if (arguments.length == 0) {
                    return this._type;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SessionDescription.prototype.setRenegotiation = function (value) {
                if (arguments.length == 1) {
                    this._renegotiation = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the SDP message.
            */
            SessionDescription.prototype.setSdpMessage = function (value) {
                if (arguments.length == 1) {
                    this._sdpMessage = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the tie breaker in case of a role conflict.
            */
            SessionDescription.prototype.setTieBreaker = function (value) {
                if (arguments.length == 1) {
                    this._tieBreaker = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the type.
            */
            SessionDescription.prototype.setType = function (value) {
                if (arguments.length == 1) {
                    this._type = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            SessionDescription.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.SessionDescription.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return SessionDescription;
        }());
        liveswitch.SessionDescription = SessionDescription;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var SessionDescriptionTypeWrapper = /** @class */ (function () {
            function SessionDescriptionTypeWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_33 = __arguments[0];
                    //super();
                    this._value = value_33;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            SessionDescriptionTypeWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.SessionDescriptionTypeWrapper]';
            };
            SessionDescriptionTypeWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.SessionDescriptionType.Offer)
                        return 'Offer';
                    if (this._value == fm.liveswitch.SessionDescriptionType.Answer)
                        return 'Answer';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return SessionDescriptionTypeWrapper;
        }());
        liveswitch.SessionDescriptionTypeWrapper = SessionDescriptionTypeWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A size (width and height).
        */
        var Size = /** @class */ (function () {
            function Size() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchSizeInit();
                    this.setWidth(0);
                    this.setHeight(0);
                }
                else if (__arguments.length == 2) {
                    var width = __arguments[0];
                    var height = __arguments[1];
                    //super();
                    this.fmliveswitchSizeInit();
                    this.setWidth(width);
                    this.setHeight(height);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Size.prototype.getTypeString = function () {
                return '[fm.liveswitch.Size]';
            };
            Size.prototype.fmliveswitchSizeInit = function () {
                this.__height = 0;
                this.__width = 0;
            };
            /**
            Deserializes an instance from JSON.
            @param sizeJson The JSON to deserialize.
            @return The deserialized size.
            */
            Size.fromJson = function (sizeJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(sizeJson, function () {
                        return new fm.liveswitch.Size();
                    }, function (size, name, valueJson) {
                        var str = name;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            if (!(fm.liveswitch.Global.equals(str, "width"))) {
                                if ((fm.liveswitch.Global.equals(str, "height"))) {
                                    size.setHeight(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                }
                            }
                            else {
                                size.setWidth(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            }
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the empty size (0x0).
            */
            Size.getEmpty = function () {
                if (arguments.length == 0) {
                    if ((fm.liveswitch.Global.equals(fm.liveswitch.Size.fm_liveswitch_Size___empty, null))) {
                        fm.liveswitch.Size.fm_liveswitch_Size___empty = new fm.liveswitch.Size();
                    }
                    return fm.liveswitch.Size.fm_liveswitch_Size___empty;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Determines whether the two sizes are equivalent.
            @param size1 The first size.
            @param size2 The second size.
            */
            Size.isEquivalent = function (size1, size2) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(size1, size2))) {
                        return true;
                    }
                    if (((fm.liveswitch.Global.equals(size1, null)) || (fm.liveswitch.Global.equals(size2, null)))) {
                        return false;
                    }
                    return fm.liveswitch.Size.isEquivalentNoCheck(size1, size2);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Size.isEquivalentNoCheck = function (size1, size2) {
                if (arguments.length == 2) {
                    return ((fm.liveswitch.Global.equals(size1.getWidth(), size2.getWidth())) && (fm.liveswitch.Global.equals(size1.getHeight(), size2.getHeight())));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param size The size.
            @return
                        The serialized JSON.
                
            */
            Size.toJson = function (size) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(size, function (obj, jsonObj) {
                        if ((!fm.liveswitch.Global.equals(size.getWidth(), -1))) {
                            jsonObj["width"] = fm.liveswitch.JsonSerializer.serializeInteger(size.getWidth());
                        }
                        if ((!fm.liveswitch.Global.equals(size.getHeight(), -1))) {
                            jsonObj["height"] = fm.liveswitch.JsonSerializer.serializeInteger(size.getHeight());
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the height.
            */
            Size.prototype.getHeight = function () {
                if (arguments.length == 0) {
                    return this.__height;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the width.
            */
            Size.prototype.getWidth = function () {
                if (arguments.length == 0) {
                    return this.__width;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Determines whether the specified size is equivalent.
            @param size The size.
            */
            Size.prototype.isEquivalent = function (size) {
                if (arguments.length == 1) {
                    return fm.liveswitch.Size.isEquivalent(this, size);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the height.
            */
            Size.prototype.setHeight = function (value) {
                if (arguments.length == 1) {
                    if ((value < 0)) {
                        throw new fm.liveswitch.Exception("Height cannot be less than 0.");
                    }
                    this.__height = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the width.
            */
            Size.prototype.setWidth = function (value) {
                if (arguments.length == 1) {
                    if ((value < 0)) {
                        throw new fm.liveswitch.Exception("Width cannot be less than 0.");
                    }
                    this.__width = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            @return
                        The serialized JSON.
                
            */
            Size.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Size.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Returns a string that represents this instance using format "{width}x{height}".
            */
            Size.prototype.toString = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.format("{0}x{1}", fm.liveswitch.NumberExtensions.toString(this.getWidth()), fm.liveswitch.NumberExtensions.toString(this.getHeight()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Size;
        }());
        liveswitch.Size = Size;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var StreamDirectionWrapper = /** @class */ (function () {
            function StreamDirectionWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_34 = __arguments[0];
                    //super();
                    this._value = value_34;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            StreamDirectionWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.StreamDirectionWrapper]';
            };
            StreamDirectionWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.StreamDirection.SendReceive)
                        return 'SendReceive';
                    if (this._value == fm.liveswitch.StreamDirection.SendOnly)
                        return 'SendOnly';
                    if (this._value == fm.liveswitch.StreamDirection.ReceiveOnly)
                        return 'ReceiveOnly';
                    if (this._value == fm.liveswitch.StreamDirection.Inactive)
                        return 'Inactive';
                    if (this._value == fm.liveswitch.StreamDirection.Unset)
                        return 'Unset';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return StreamDirectionWrapper;
        }());
        liveswitch.StreamDirectionWrapper = StreamDirectionWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Class containing utility methods to manipulate [[fm.liveswitch.streamDirection]].
        */
        var StreamDirectionHelper = /** @class */ (function () {
            function StreamDirectionHelper() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            StreamDirectionHelper.prototype.getTypeString = function () {
                return '[fm.liveswitch.StreamDirectionHelper]';
            };
            /**
            Converts string representations of stream directions to [[fm.liveswitch.streamDirection]].
            @param directionString The direction string.
            @return The direction.
            */
            StreamDirectionHelper.directionFromString = function (directionString) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(directionString, null))) {
                        var str = directionString;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            if (!(fm.liveswitch.Global.equals(str, "sendrecv"))) {
                                if ((fm.liveswitch.Global.equals(str, "sendonly"))) {
                                    return fm.liveswitch.StreamDirection.SendOnly;
                                }
                                if ((fm.liveswitch.Global.equals(str, "recvonly"))) {
                                    return fm.liveswitch.StreamDirection.ReceiveOnly;
                                }
                                if ((fm.liveswitch.Global.equals(str, "inactive"))) {
                                    return fm.liveswitch.StreamDirection.Inactive;
                                }
                            }
                            else {
                                return fm.liveswitch.StreamDirection.SendReceive;
                            }
                        }
                    }
                    return fm.liveswitch.StreamDirection.Unset;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Obtains the string representation of [[fm.liveswitch.streamDirection]].
            @param direction The direction.
            @return The direction string.
            */
            StreamDirectionHelper.directionToString = function (direction) {
                if (arguments.length == 1) {
                    var _var0 = direction;
                    if (_var0 == fm.liveswitch.StreamDirection.SendReceive) {
                        do {
                            return "sendrecv";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.StreamDirection.SendOnly) {
                        do {
                            return "sendonly";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.StreamDirection.ReceiveOnly) {
                        do {
                            return "recvonly";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.StreamDirection.Inactive) {
                        do {
                            return "inactive";
                        } while (false);
                    }
                    return "unset";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            StreamDirectionHelper.isReceiveDisabled = function () {
                if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isNumber(arguments[0]))) {
                    var direction = arguments[0];
                    return ((fm.liveswitch.Global.equals(direction, fm.liveswitch.StreamDirection.Inactive)) || (fm.liveswitch.Global.equals(direction, fm.liveswitch.StreamDirection.SendOnly)));
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                    var directionString = arguments[0];
                    return fm.liveswitch.StreamDirectionHelper.isReceiveDisabled(fm.liveswitch.StreamDirectionHelper.directionFromString(directionString));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            StreamDirectionHelper.isSendDisabled = function () {
                if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isNumber(arguments[0]))) {
                    var direction = arguments[0];
                    return ((fm.liveswitch.Global.equals(direction, fm.liveswitch.StreamDirection.Inactive)) || (fm.liveswitch.Global.equals(direction, fm.liveswitch.StreamDirection.ReceiveOnly)));
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                    var directionString = arguments[0];
                    return fm.liveswitch.StreamDirectionHelper.isSendDisabled(fm.liveswitch.StreamDirectionHelper.directionFromString(directionString));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            StreamDirectionHelper.setReceiveDisabled = function () {
                if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isNumber(arguments[0]))) {
                    var direction = arguments[0];
                    var disabled = arguments[1];
                    return ((fm.liveswitch.Global.equals(disabled, fm.liveswitch.StreamDirectionHelper.isReceiveDisabled(direction))) ? direction : fm.liveswitch.StreamDirectionHelper.toggleReceive(direction));
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                    var directionString = arguments[0];
                    var disabled = arguments[1];
                    return fm.liveswitch.StreamDirectionHelper.directionToString(fm.liveswitch.StreamDirectionHelper.setReceiveDisabled(fm.liveswitch.StreamDirectionHelper.directionFromString(directionString), disabled));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            StreamDirectionHelper.setSendDisabled = function () {
                if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isNumber(arguments[0]))) {
                    var direction = arguments[0];
                    var disabled = arguments[1];
                    return ((fm.liveswitch.Global.equals(disabled, fm.liveswitch.StreamDirectionHelper.isSendDisabled(direction))) ? direction : fm.liveswitch.StreamDirectionHelper.toggleSend(direction));
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                    var directionString = arguments[0];
                    var disabled = arguments[1];
                    return fm.liveswitch.StreamDirectionHelper.directionToString(fm.liveswitch.StreamDirectionHelper.setSendDisabled(fm.liveswitch.StreamDirectionHelper.directionFromString(directionString), disabled));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            StreamDirectionHelper.toggleReceive = function () {
                if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isNumber(arguments[0]))) {
                    var direction = arguments[0];
                    if ((fm.liveswitch.Global.equals(direction, fm.liveswitch.StreamDirection.Inactive))) {
                        return fm.liveswitch.StreamDirection.ReceiveOnly;
                    }
                    if ((fm.liveswitch.Global.equals(direction, fm.liveswitch.StreamDirection.ReceiveOnly))) {
                        return fm.liveswitch.StreamDirection.Inactive;
                    }
                    if ((fm.liveswitch.Global.equals(direction, fm.liveswitch.StreamDirection.SendReceive))) {
                        return fm.liveswitch.StreamDirection.SendOnly;
                    }
                    if ((fm.liveswitch.Global.equals(direction, fm.liveswitch.StreamDirection.SendOnly))) {
                        return fm.liveswitch.StreamDirection.SendReceive;
                    }
                    return fm.liveswitch.StreamDirection.Unset;
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                    var directionString = arguments[0];
                    return fm.liveswitch.StreamDirectionHelper.directionToString(fm.liveswitch.StreamDirectionHelper.toggleReceive(fm.liveswitch.StreamDirectionHelper.directionFromString(directionString)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            StreamDirectionHelper.toggleSend = function () {
                if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isNumber(arguments[0]))) {
                    var direction = arguments[0];
                    if ((fm.liveswitch.Global.equals(direction, fm.liveswitch.StreamDirection.Inactive))) {
                        return fm.liveswitch.StreamDirection.SendOnly;
                    }
                    if ((fm.liveswitch.Global.equals(direction, fm.liveswitch.StreamDirection.SendOnly))) {
                        return fm.liveswitch.StreamDirection.Inactive;
                    }
                    if ((fm.liveswitch.Global.equals(direction, fm.liveswitch.StreamDirection.SendReceive))) {
                        return fm.liveswitch.StreamDirection.ReceiveOnly;
                    }
                    if ((fm.liveswitch.Global.equals(direction, fm.liveswitch.StreamDirection.ReceiveOnly))) {
                        return fm.liveswitch.StreamDirection.SendReceive;
                    }
                    return fm.liveswitch.StreamDirection.Unset;
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                    var directionString = arguments[0];
                    return fm.liveswitch.StreamDirectionHelper.directionToString(fm.liveswitch.StreamDirectionHelper.toggleSend(fm.liveswitch.StreamDirectionHelper.directionFromString(directionString)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return StreamDirectionHelper;
        }());
        liveswitch.StreamDirectionHelper = StreamDirectionHelper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var StreamStateWrapper = /** @class */ (function () {
            function StreamStateWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_35 = __arguments[0];
                    //super();
                    this._value = value_35;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            StreamStateWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.StreamStateWrapper]';
            };
            StreamStateWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.StreamState.New)
                        return 'New';
                    if (this._value == fm.liveswitch.StreamState.Initializing)
                        return 'Initializing';
                    if (this._value == fm.liveswitch.StreamState.Connecting)
                        return 'Connecting';
                    if (this._value == fm.liveswitch.StreamState.Connected)
                        return 'Connected';
                    if (this._value == fm.liveswitch.StreamState.Failing)
                        return 'Failing';
                    if (this._value == fm.liveswitch.StreamState.Failed)
                        return 'Failed';
                    if (this._value == fm.liveswitch.StreamState.Closing)
                        return 'Closing';
                    if (this._value == fm.liveswitch.StreamState.Closed)
                        return 'Closed';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return StreamStateWrapper;
        }());
        liveswitch.StreamStateWrapper = StreamStateWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var StreamTypeWrapper = /** @class */ (function () {
            function StreamTypeWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_36 = __arguments[0];
                    //super();
                    this._value = value_36;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            StreamTypeWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.StreamTypeWrapper]';
            };
            StreamTypeWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.StreamType.Audio)
                        return 'Audio';
                    if (this._value == fm.liveswitch.StreamType.Video)
                        return 'Video';
                    if (this._value == fm.liveswitch.StreamType.Application)
                        return 'Application';
                    if (this._value == fm.liveswitch.StreamType.Message)
                        return 'Message';
                    if (this._value == fm.liveswitch.StreamType.Text)
                        return 'Text';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return StreamTypeWrapper;
        }());
        liveswitch.StreamTypeWrapper = StreamTypeWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Transport Information.
        */
        var TransportInfo = /** @class */ (function (_super) {
            __extends(TransportInfo, _super);
            function TransportInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else if (__arguments.length == 2) {
                    var stats = __arguments[0];
                    var lastStats = __arguments[1];
                    _this = _super.call(this) || this;
                    var num = void 0;
                    _super.prototype.setId.call(_this, stats.getId());
                    var flag = (fm.liveswitch.Global.equals(lastStats, null));
                    if ((!fm.liveswitch.Global.equals(stats.getLocalCertificate(), null))) {
                        _this.setLocalCertificate(new fm.liveswitch.CertificateInfo(stats.getLocalCertificate(), (flag ? null : lastStats.getLocalCertificate())));
                    }
                    if ((!fm.liveswitch.Global.equals(stats.getRemoteCertificate(), null))) {
                        _this.setRemoteCertificate(new fm.liveswitch.CertificateInfo(stats.getRemoteCertificate(), (flag ? null : lastStats.getRemoteCertificate())));
                    }
                    if ((!fm.liveswitch.Global.equals(stats.getLocalCandidates(), null))) {
                        _this.setLocalCandidates(new Array(stats.getLocalCandidates().length));
                        for (num = 0; (num < stats.getLocalCandidates().length); num++) {
                            var stats2 = stats.getLocalCandidates()[num];
                            var stats3 = null;
                            if (!flag) {
                                stats3 = _this.findMatchingCandidate(lastStats.getLocalCandidates(), stats2.getId());
                            }
                            _this.getLocalCandidates()[num] = new fm.liveswitch.CandidateInfo(stats2, stats3);
                        }
                    }
                    if ((!fm.liveswitch.Global.equals(stats.getRemoteCandidates(), null))) {
                        _this.setRemoteCandidates(new Array(stats.getRemoteCandidates().length));
                        for (num = 0; (num < stats.getRemoteCandidates().length); num++) {
                            var stats4 = stats.getRemoteCandidates()[num];
                            var stats5 = null;
                            if (!flag) {
                                stats5 = _this.findMatchingCandidate(lastStats.getRemoteCandidates(), stats4.getId());
                            }
                            _this.getRemoteCandidates()[num] = new fm.liveswitch.CandidateInfo(stats4, stats5);
                        }
                    }
                    if ((!fm.liveswitch.Global.equals(stats.getCandidatePairs(), null))) {
                        _this.setCandidatePairs(new Array(stats.getCandidatePairs().length));
                        for (num = 0; (num < stats.getCandidatePairs().length); num++) {
                            var stats6 = stats.getCandidatePairs()[num];
                            var stats7 = null;
                            if (!flag) {
                                stats7 = _this.findMatchingCandidatePair(lastStats.getCandidatePairs(), stats6.getId());
                            }
                            _this.getCandidatePairs()[num] = new fm.liveswitch.CandidatePairInfo(stats6, stats7);
                        }
                    }
                    _this.setActiveCandidatePairId(((fm.liveswitch.Global.equals(stats.getActiveCandidatePair(), null)) ? null : stats.getActiveCandidatePair().getId()));
                    _this.setReport(new fm.liveswitch.TransportReport(stats, lastStats));
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            TransportInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.TransportInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Deserializes Json to a TransportReport.
            @param transportReportJson The serialized Json.
            @return The deserialized TransportReport.
            */
            TransportInfo.fromJson = function (transportReportJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(transportReportJson, function () {
                        return new fm.liveswitch.TransportInfo();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array from JSON.
            @param transportInfosJson The serialized JSON.
            @return The deserialized array.
            */
            TransportInfo.fromJsonArray = function (transportInfosJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(transportInfosJson, fm.liveswitch.TransportInfo.fromJson.bind(fm.liveswitch.TransportInfo));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to Json.
            @param transportReport The instance to serialize.
            @return Serialized Json.
            */
            TransportInfo.toJson = function (transportReport) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(transportReport, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param transportInfos The array to serialize.
            @return The serialized JSON.
            */
            TransportInfo.toJsonArray = function (transportInfos) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(transportInfos, fm.liveswitch.TransportInfo.toJson.bind(fm.liveswitch.TransportInfo));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            TransportInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var _var0 = key;
                    if (_var0 == "localCertificate") {
                        do {
                            this.setLocalCertificate(fm.liveswitch.CertificateInfo.fromJson(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "remoteCertificate") {
                        do {
                            this.setRemoteCertificate(fm.liveswitch.CertificateInfo.fromJson(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "localCandidates") {
                        do {
                            this.setLocalCandidates(fm.liveswitch.CandidateInfo.fromJsonArray(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "remoteCandidates") {
                        do {
                            this.setRemoteCandidates(fm.liveswitch.CandidateInfo.fromJsonArray(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "candidatePairs") {
                        do {
                            this.setCandidatePairs(fm.liveswitch.CandidatePairInfo.fromJsonArray(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "activeCandidatePairId") {
                        do {
                            this.setActiveCandidatePairId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "report") {
                        do {
                            this.setReport(fm.liveswitch.TransportReport.fromJson(valueJson));
                            break;
                        } while (false);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            TransportInfo.prototype.findMatchingCandidate = function (candidates, idValue) {
                if (arguments.length == 2) {
                    if ((!fm.liveswitch.Global.equals(candidates, null))) {
                        for (var _i = 0, candidates_1 = candidates; _i < candidates_1.length; _i++) {
                            var stats = candidates_1[_i];
                            if ((fm.liveswitch.Global.equals(stats.getId(), idValue))) {
                                return stats;
                            }
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            TransportInfo.prototype.findMatchingCandidatePair = function (candidatePairs, idValue) {
                if (arguments.length == 2) {
                    if ((!fm.liveswitch.Global.equals(candidatePairs, null))) {
                        for (var _i = 0, candidatePairs_1 = candidatePairs; _i < candidatePairs_1.length; _i++) {
                            var stats = candidatePairs_1[_i];
                            if ((fm.liveswitch.Global.equals(stats.getId(), idValue))) {
                                return stats;
                            }
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the active candidate pair identifier.
            */
            TransportInfo.prototype.getActiveCandidatePairId = function () {
                if (arguments.length == 0) {
                    return this._activeCandidatePairId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the candidate pairs.
            */
            TransportInfo.prototype.getCandidatePairs = function () {
                if (arguments.length == 0) {
                    return this._candidatePairs;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the local candidates.
            */
            TransportInfo.prototype.getLocalCandidates = function () {
                if (arguments.length == 0) {
                    return this._localCandidates;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the local certificate.
            */
            TransportInfo.prototype.getLocalCertificate = function () {
                if (arguments.length == 0) {
                    return this._localCertificate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote candidates.
            */
            TransportInfo.prototype.getRemoteCandidates = function () {
                if (arguments.length == 0) {
                    return this._remoteCandidates;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote certificate.
            */
            TransportInfo.prototype.getRemoteCertificate = function () {
                if (arguments.length == 0) {
                    return this._remoteCertificate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the transport report.
            */
            TransportInfo.prototype.getReport = function () {
                if (arguments.length == 0) {
                    return this._report;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            TransportInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getLocalCertificate(), null))) {
                        jsonObject["localCertificate"] = fm.liveswitch.CertificateInfo.toJson(this.getLocalCertificate());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRemoteCertificate(), null))) {
                        jsonObject["remoteCertificate"] = fm.liveswitch.CertificateInfo.toJson(this.getRemoteCertificate());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getLocalCandidates(), null))) {
                        jsonObject["localCandidates"] = fm.liveswitch.CandidateInfo.toJsonArray(this.getLocalCandidates());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRemoteCandidates(), null))) {
                        jsonObject["remoteCandidates"] = fm.liveswitch.CandidateInfo.toJsonArray(this.getRemoteCandidates());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getCandidatePairs(), null))) {
                        jsonObject["candidatePairs"] = fm.liveswitch.CandidatePairInfo.toJsonArray(this.getCandidatePairs());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getActiveCandidatePairId(), null))) {
                        jsonObject["activeCandidatePairId"] = fm.liveswitch.JsonSerializer.serializeString(this.getActiveCandidatePairId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getReport(), null))) {
                        jsonObject["report"] = fm.liveswitch.TransportReport.toJson(this.getReport());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the active candidate pair identifier.
            */
            TransportInfo.prototype.setActiveCandidatePairId = function (value) {
                if (arguments.length == 1) {
                    this._activeCandidatePairId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the candidate pairs.
            */
            TransportInfo.prototype.setCandidatePairs = function (value) {
                if (arguments.length == 1) {
                    this._candidatePairs = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the local candidates.
            */
            TransportInfo.prototype.setLocalCandidates = function (value) {
                if (arguments.length == 1) {
                    this._localCandidates = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the local certificate.
            */
            TransportInfo.prototype.setLocalCertificate = function (value) {
                if (arguments.length == 1) {
                    this._localCertificate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote candidates.
            */
            TransportInfo.prototype.setRemoteCandidates = function (value) {
                if (arguments.length == 1) {
                    this._remoteCandidates = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote certificate.
            */
            TransportInfo.prototype.setRemoteCertificate = function (value) {
                if (arguments.length == 1) {
                    this._remoteCertificate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the transport report.
            */
            TransportInfo.prototype.setReport = function (value) {
                if (arguments.length == 1) {
                    this._report = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to Json.
            */
            TransportInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.TransportInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return TransportInfo;
        }(fm.liveswitch.Info));
        liveswitch.TransportInfo = TransportInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="BaseStats.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Transport stats.
        */
        var TransportStats = /** @class */ (function (_super) {
            __extends(TransportStats, _super);
            function TransportStats() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchTransportStatsInit();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            TransportStats.prototype.getTypeString = function () {
                return '[fm.liveswitch.TransportStats]' + ',' + _super.prototype.getTypeString.call(this);
            };
            TransportStats.prototype.fmliveswitchTransportStatsInit = function () {
                this._bytesReceived = 0;
                this._bytesSent = 0;
            };
            /**
            Derializes transport stats from JSON.
            @param transportJson The transport's stats JSON.
            */
            TransportStats.fromJson = function (transportJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(transportJson, function () {
                        return new fm.liveswitch.TransportStats();
                    }, function (obj, key, valueJson) {
                        obj.deserializeProperties(key, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes transport stats to JSON.
            @param transport The transport's stats.
            */
            TransportStats.toJson = function (transport) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(transport, function (obj, jsonObject) {
                        obj.serializeProperties(jsonObject);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            TransportStats.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var _var0 = key;
                    if (_var0 == "bytesSent") {
                        do {
                            this.setBytesSent(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "bytesReceived") {
                        do {
                            this.setBytesReceived(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "rtcpTransport") {
                        do {
                            this.setRtcpTransport(fm.liveswitch.TransportStats.fromJson(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "localCandidates") {
                        do {
                            this.setLocalCandidates(fm.liveswitch.CandidateStats.fromJsonArray(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "remoteCandidates") {
                        do {
                            this.setRemoteCandidates(fm.liveswitch.CandidateStats.fromJsonArray(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "candidatePairs") {
                        do {
                            this.setCandidatePairs(fm.liveswitch.CandidatePairStats.fromJsonArray(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "activeCandidatePair") {
                        do {
                            this.setActiveCandidatePair(fm.liveswitch.CandidatePairStats.fromJson(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "localCertificate") {
                        do {
                            this.setLocalCertificate(fm.liveswitch.CertificateStats.fromJson(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "remoteCertificate") {
                        do {
                            this.setRemoteCertificate(fm.liveswitch.CertificateStats.fromJson(valueJson));
                            break;
                        } while (false);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the active candidate pair's stats.
            */
            TransportStats.prototype.getActiveCandidatePair = function () {
                if (arguments.length == 0) {
                    return this._activeCandidatePair;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes received.
            */
            TransportStats.prototype.getBytesReceived = function () {
                if (arguments.length == 0) {
                    return this._bytesReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes sent.
            */
            TransportStats.prototype.getBytesSent = function () {
                if (arguments.length == 0) {
                    return this._bytesSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a candidate pair by its identifier.
            @param candidatePairId The candidate pair identifier.
            */
            TransportStats.prototype.getCandidatePair = function (candidatePairId) {
                if (arguments.length == 1) {
                    for (var _i = 0, _a = this.getCandidatePairs(); _i < _a.length; _i++) {
                        var stats = _a[_i];
                        if ((fm.liveswitch.Global.equals(stats.getId(), candidatePairId))) {
                            return stats;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the candidate pairs' stats.
            */
            TransportStats.prototype.getCandidatePairs = function () {
                if (arguments.length == 0) {
                    return this._candidatePairs;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the active candidate pair has a host candidate.
            */
            TransportStats.prototype.getIsHost = function () {
                if (arguments.length == 0) {
                    var activeCandidatePair = this.getActiveCandidatePair();
                    if ((fm.liveswitch.Global.equals(activeCandidatePair, null))) {
                        return false;
                    }
                    var localCandidate = this.getLocalCandidate(activeCandidatePair.getLocalCandidateId());
                    var remoteCandidate = this.getRemoteCandidate(activeCandidatePair.getRemoteCandidateId());
                    return (((!fm.liveswitch.Global.equals(localCandidate, null)) && localCandidate.getIsHost()) || ((!fm.liveswitch.Global.equals(remoteCandidate, null)) && remoteCandidate.getIsHost()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the active candidate pair has a reflexive candidate.
            */
            TransportStats.prototype.getIsReflexive = function () {
                if (arguments.length == 0) {
                    var activeCandidatePair = this.getActiveCandidatePair();
                    if ((fm.liveswitch.Global.equals(activeCandidatePair, null))) {
                        return false;
                    }
                    var localCandidate = this.getLocalCandidate(activeCandidatePair.getLocalCandidateId());
                    var remoteCandidate = this.getRemoteCandidate(activeCandidatePair.getRemoteCandidateId());
                    return (((!fm.liveswitch.Global.equals(localCandidate, null)) && localCandidate.getIsReflexive()) || ((!fm.liveswitch.Global.equals(remoteCandidate, null)) && remoteCandidate.getIsReflexive()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the active candidate pair has a relayed candidate.
            */
            TransportStats.prototype.getIsRelayed = function () {
                if (arguments.length == 0) {
                    var activeCandidatePair = this.getActiveCandidatePair();
                    if ((fm.liveswitch.Global.equals(activeCandidatePair, null))) {
                        return false;
                    }
                    var localCandidate = this.getLocalCandidate(activeCandidatePair.getLocalCandidateId());
                    var remoteCandidate = this.getRemoteCandidate(activeCandidatePair.getRemoteCandidateId());
                    return (((!fm.liveswitch.Global.equals(localCandidate, null)) && localCandidate.getIsRelayed()) || ((!fm.liveswitch.Global.equals(remoteCandidate, null)) && remoteCandidate.getIsRelayed()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a local candidate by its identifier.
            @param candidateId The candidate identifier.
            */
            TransportStats.prototype.getLocalCandidate = function (candidateId) {
                if (arguments.length == 1) {
                    for (var _i = 0, _a = this.getLocalCandidates(); _i < _a.length; _i++) {
                        var stats = _a[_i];
                        if ((fm.liveswitch.Global.equals(stats.getId(), candidateId))) {
                            return stats;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the local candidates' stats.
            */
            TransportStats.prototype.getLocalCandidates = function () {
                if (arguments.length == 0) {
                    return this._localCandidates;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the local certificate's stats.
            */
            TransportStats.prototype.getLocalCertificate = function () {
                if (arguments.length == 0) {
                    return this._localCertificate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a remote candidate by its identifier.
            @param candidateId The candidate identifier.
            */
            TransportStats.prototype.getRemoteCandidate = function (candidateId) {
                if (arguments.length == 1) {
                    for (var _i = 0, _a = this.getRemoteCandidates(); _i < _a.length; _i++) {
                        var stats = _a[_i];
                        if ((fm.liveswitch.Global.equals(stats.getId(), candidateId))) {
                            return stats;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote candidates' stats.
            */
            TransportStats.prototype.getRemoteCandidates = function () {
                if (arguments.length == 0) {
                    return this._remoteCandidates;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote certificate's stats.
            */
            TransportStats.prototype.getRemoteCertificate = function () {
                if (arguments.length == 0) {
                    return this._remoteCertificate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the RTCP transport's stats.
            */
            TransportStats.prototype.getRtcpTransport = function () {
                if (arguments.length == 0) {
                    return this._rtcpTransport;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            TransportStats.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    jsonObject["bytesSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getBytesSent());
                    jsonObject["bytesReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getBytesReceived());
                    if ((!fm.liveswitch.Global.equals(this.getRtcpTransport(), null))) {
                        jsonObject["rtcpTransport"] = fm.liveswitch.TransportStats.toJson(this.getRtcpTransport());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getLocalCandidates(), null))) {
                        jsonObject["localCandidates"] = fm.liveswitch.CandidateStats.toJsonArray(this.getLocalCandidates());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRemoteCandidates(), null))) {
                        jsonObject["remoteCandidates"] = fm.liveswitch.CandidateStats.toJsonArray(this.getRemoteCandidates());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getCandidatePairs(), null))) {
                        jsonObject["candidatePairs"] = fm.liveswitch.CandidatePairStats.toJsonArray(this.getCandidatePairs());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getActiveCandidatePair(), null))) {
                        jsonObject["activeCandidatePair"] = fm.liveswitch.CandidatePairStats.toJson(this.getActiveCandidatePair());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getLocalCertificate(), null))) {
                        jsonObject["localCertificate"] = fm.liveswitch.CertificateStats.toJson(this.getLocalCertificate());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRemoteCertificate(), null))) {
                        jsonObject["remoteCertificate"] = fm.liveswitch.CertificateStats.toJson(this.getRemoteCertificate());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the active candidate pair's stats.
            */
            TransportStats.prototype.setActiveCandidatePair = function (value) {
                if (arguments.length == 1) {
                    this._activeCandidatePair = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of bytes received.
            */
            TransportStats.prototype.setBytesReceived = function (value) {
                if (arguments.length == 1) {
                    this._bytesReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of bytes sent.
            */
            TransportStats.prototype.setBytesSent = function (value) {
                if (arguments.length == 1) {
                    this._bytesSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the candidate pairs' stats.
            */
            TransportStats.prototype.setCandidatePairs = function (value) {
                if (arguments.length == 1) {
                    this._candidatePairs = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the local candidates' stats.
            */
            TransportStats.prototype.setLocalCandidates = function (value) {
                if (arguments.length == 1) {
                    this._localCandidates = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the local certificate's stats.
            */
            TransportStats.prototype.setLocalCertificate = function (value) {
                if (arguments.length == 1) {
                    this._localCertificate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote candidates' stats.
            */
            TransportStats.prototype.setRemoteCandidates = function (value) {
                if (arguments.length == 1) {
                    this._remoteCandidates = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote certificate's stats.
            */
            TransportStats.prototype.setRemoteCertificate = function (value) {
                if (arguments.length == 1) {
                    this._remoteCertificate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the RTCP transport's stats.
            */
            TransportStats.prototype.setRtcpTransport = function (value) {
                if (arguments.length == 1) {
                    this._rtcpTransport = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this to JSON.
            */
            TransportStats.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.TransportStats.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return TransportStats;
        }(fm.liveswitch.BaseStats));
        liveswitch.TransportStats = TransportStats;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Utility methods.
        */
        var Utility = /** @class */ (function () {
            function Utility() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Utility.prototype.getTypeString = function () {
                return '[fm.liveswitch.Utility]';
            };
            /**
            Clones the specified list.
            @param list The list.
            */
            Utility.clone = function (list) {
                if (arguments.length == 1) {
                    var list2 = new Array();
                    fm.liveswitch.ArrayExtensions.addRange(list2, list);
                    return list2;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Clones an array of int values.
            @param intArray An array of int values.
            */
            Utility.cloneIntArray = function (intArray) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(intArray, null))) {
                        return null;
                    }
                    var numArray = new Array(intArray.length);
                    for (var i = 0; (i < intArray.length); i++) {
                        numArray[i] = intArray[i];
                    }
                    return numArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Clones an array of long values.
            @param longArray An array of long values.
            */
            Utility.cloneLongArray = function (longArray) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(longArray, null))) {
                        return null;
                    }
                    var numArray = new Array(longArray.length);
                    for (var i = 0; (i < longArray.length); i++) {
                        numArray[i] = longArray[i];
                    }
                    return numArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Clones an array of string values.
            @param stringArray An array of string values.
            */
            Utility.cloneStringArray = function (stringArray) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(stringArray, null))) {
                        return null;
                    }
                    var strArray = new Array(stringArray.length);
                    for (var i = 0; (i < stringArray.length); i++) {
                        strArray[i] = stringArray[i];
                    }
                    return strArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Utility.firstOrDefault = function () {
                if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isObject(arguments[0][0])))))) {
                    var array = arguments[0];
                    if (((fm.liveswitch.Global.equals(array, null)) || (fm.liveswitch.Global.equals(array.length, 0)))) {
                        return null;
                    }
                    return array[0];
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObject(arguments[0]))) {
                    var list = arguments[0];
                    if (((fm.liveswitch.Global.equals(list, null)) || (fm.liveswitch.Global.equals(fm.liveswitch.ArrayExtensions.getCount(list), 0)))) {
                        return null;
                    }
                    return list[0];
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Formats a double as a percentage string.
            @param value The value.
            @param decimalPlaces The number of decimal places to include.
            */
            Utility.formatDoubleAsPercent = function (value, decimalPlaces) {
                if (arguments.length == 2) {
                    var num = void 0;
                    if ((decimalPlaces < 0)) {
                        decimalPlaces = 0;
                    }
                    var str = fm.liveswitch.NumberExtensions.toString((value * 100));
                    var strArray = fm.liveswitch.StringExtensions.split(str, [46]);
                    if ((fm.liveswitch.Global.equals(strArray.length, 1))) {
                        if ((decimalPlaces > 0)) {
                            str = fm.liveswitch.StringExtensions.concat(str, ".");
                        }
                        for (num = 0; (num < decimalPlaces); num++) {
                            str = fm.liveswitch.StringExtensions.concat(str, "0");
                        }
                        return str;
                    }
                    var str2 = strArray[0];
                    if ((fm.liveswitch.Global.equals(fm.liveswitch.StringExtensions.getLength(str2), 0))) {
                        str2 = "0";
                    }
                    if ((fm.liveswitch.Global.equals(decimalPlaces, 0))) {
                        return str2;
                    }
                    var str3 = strArray[1];
                    if ((fm.liveswitch.StringExtensions.getLength(str3) > decimalPlaces)) {
                        str3 = fm.liveswitch.StringExtensions.substring(str3, 0, decimalPlaces);
                    }
                    else {
                        if ((fm.liveswitch.StringExtensions.getLength(str3) < decimalPlaces)) {
                            var num2 = (decimalPlaces - fm.liveswitch.StringExtensions.getLength(str3));
                            for (num = 0; (num < num2); num++) {
                                str3 = fm.liveswitch.StringExtensions.concat(str3, "0");
                            }
                        }
                    }
                    return fm.liveswitch.StringExtensions.concat(str2, ".", str3);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Generates a unique identifier.
            */
            Utility.generateId = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Generates a synchronization source.
            */
            Utility.generateSynchronizationSource = function () {
                if (arguments.length == 0) {
                    var buffer = new Uint8Array(4);
                    fm.liveswitch.LockedRandomizer.nextBytes(buffer);
                    return fm.liveswitch.Binary.fromBytes32(buffer, 0, false);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Generates a tie-breaker. Obsolete. Alias for [[fm.liveswitch.utility.generateId]].
            */
            Utility.generateTieBreaker = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Utility.generateId();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Retrieves the difference between two RTP sequence numbers while accounting for overflow rollover.
            @param rtpSequenceNumber The current RTP sequence number.
            @param lastRtpSequenceNumber The last (previous) RTP sequence number.
            @return The difference between the two RTP sequence numbers.
            */
            Utility.getRtpSequenceNumberDelta = function (rtpSequenceNumber, lastRtpSequenceNumber) {
                if (arguments.length == 2) {
                    var num = (rtpSequenceNumber - lastRtpSequenceNumber);
                    if ((num < -32768)) {
                        return (num + 65536);
                    }
                    if ((num >= 32768)) {
                        num = (num - 65536);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Retrieves the difference between two RTP timestamps while accounting for overflow rollover.
            @param rtpTimestamp The current RTP timestamp.
            @param lastRtpTimestamp The last (previous) RTP timestamp.
            @return The difference between the two RTP timestamps.
            */
            Utility.getRtpTimestampDelta = function (rtpTimestamp, lastRtpTimestamp) {
                if (arguments.length == 2) {
                    var num = (rtpTimestamp - lastRtpTimestamp);
                    if ((num < -2147483648)) {
                        return (num + 4294967296);
                    }
                    if ((num >= 2147483648)) {
                        num = (num - 4294967296);
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Utility.lastOrDefault = function () {
                if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isObject(arguments[0][0])))))) {
                    var array = arguments[0];
                    if (((fm.liveswitch.Global.equals(array, null)) || (fm.liveswitch.Global.equals(array.length, 0)))) {
                        return null;
                    }
                    return array[(array.length - 1)];
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObject(arguments[0]))) {
                    var list = arguments[0];
                    if (((fm.liveswitch.Global.equals(list, null)) || (fm.liveswitch.Global.equals(fm.liveswitch.ArrayExtensions.getCount(list), 0)))) {
                        return null;
                    }
                    return list[(fm.liveswitch.ArrayExtensions.getCount(list) - 1)];
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Utility.singleOrDefault = function () {
                if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isObject(arguments[0][0])))))) {
                    var array = arguments[0];
                    if (((fm.liveswitch.Global.equals(array, null)) || (!fm.liveswitch.Global.equals(array.length, 1)))) {
                        return null;
                    }
                    return array[0];
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObject(arguments[0]))) {
                    var list = arguments[0];
                    if (((fm.liveswitch.Global.equals(list, null)) || (!fm.liveswitch.Global.equals(fm.liveswitch.ArrayExtensions.getCount(list), 1)))) {
                        return null;
                    }
                    return list[0];
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Utility.splice = function () {
                if (arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || (fm.liveswitch.Util.isArray(arguments[2]) && (arguments[2].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[2][0]) || fm.liveswitch.Util.isObject(arguments[2][0])))))) {
                    var array = arguments[0];
                    var index = arguments[1];
                    var addItems = arguments[2];
                    var createArray = arguments[3];
                    return fm.liveswitch.Utility.splice(array, index, 0, addItems, createArray);
                }
                else if (arguments.length == 5) {
                    var array = arguments[0];
                    var index = arguments[1];
                    var removeCount = arguments[2];
                    var addItems = arguments[3];
                    var createArray = arguments[4];
                    if (((index < 0) && ((array.length + index) >= 0))) {
                        index = (array.length + index);
                    }
                    if ((((index < 0) || (removeCount < 0)) || ((index + removeCount) > array.length))) {
                        var length_43 = array.length;
                        throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Cannot splice {0} items at index {1} from an array of length {2}.", fm.liveswitch.NumberExtensions.toString(removeCount), fm.liveswitch.NumberExtensions.toString(index), fm.liveswitch.NumberExtensions.toString(length_43)));
                    }
                    var num = ((fm.liveswitch.Global.equals(addItems, null)) ? 0 : addItems.length);
                    var localArray = createArray(((array.length - removeCount) + num));
                    var num2 = 0;
                    var num3 = 0;
                    var num4 = 0;
                    while ((num3 < index)) {
                        localArray[num2++] = array[num3++];
                    }
                    while ((num4 < num)) {
                        localArray[num2++] = addItems[num4++];
                    }
                    num3 = (num3 + removeCount);
                    while ((num3 < array.length)) {
                        localArray[num2++] = array[num3++];
                    }
                    return localArray;
                }
                else if (arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isNumber(arguments[2]))) {
                    var array = arguments[0];
                    var index = arguments[1];
                    var removeCount = arguments[2];
                    var createArray = arguments[3];
                    return fm.liveswitch.Utility.splice(array, index, removeCount, null, createArray);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts a list of int values to an array of int values.
            @param intList A list of int values.
            */
            Utility.toIntArray = function (intList) {
                if (arguments.length == 1) {
                    var numArray = new Array(fm.liveswitch.ArrayExtensions.getCount(intList));
                    for (var i = 0; (i < numArray.length); i++) {
                        numArray[i] = intList[i];
                    }
                    return numArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts an array to a list.
            @param array The array.
            */
            Utility.toList = function (array) {
                if (arguments.length == 1) {
                    var list = new Array();
                    for (var i = 0; (i < array.length); i++) {
                        fm.liveswitch.ArrayExtensions.add(list, array[i]);
                    }
                    return list;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts a list of long values to an array of long values.
            @param longList A list of long values.
            */
            Utility.toLongArray = function (longList) {
                if (arguments.length == 1) {
                    var numArray = new Array(fm.liveswitch.ArrayExtensions.getCount(longList));
                    for (var i = 0; (i < numArray.length); i++) {
                        numArray[i] = longList[i];
                    }
                    return numArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts a list of string values to an array of string values.
            @param stringList A list of string values.
            */
            Utility.toStringArray = function (stringList) {
                if (arguments.length == 1) {
                    var strArray = new Array(fm.liveswitch.ArrayExtensions.getCount(stringList));
                    for (var i = 0; (i < strArray.length); i++) {
                        strArray[i] = stringList[i];
                    }
                    return strArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Enumerates over all nodes in the tree, invoking the callback for each one.
            @param root The root.
            @param childrenCallback The children callback.
            @param nodeCallback The node callback.
            */
            Utility.treeFindLeaves = function (root, childrenCallback, nodeCallback) {
                if (arguments.length == 3) {
                    var localArray = childrenCallback(root);
                    if ((!fm.liveswitch.Global.equals(localArray, null))) {
                        for (var _i = 0, localArray_3 = localArray; _i < localArray_3.length; _i++) {
                            var local = localArray_3[_i];
                            fm.liveswitch.Utility.treeSearch(local, childrenCallback, nodeCallback);
                        }
                    }
                    else {
                        nodeCallback(root);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Enumerates over all nodes in the tree, invoking the callback for each one.
            @param root The root.
            @param childrenCallback The children callback.
            @param nodeCallback The node callback.
            */
            Utility.treeSearch = function (root, childrenCallback, nodeCallback) {
                if (arguments.length == 3) {
                    nodeCallback(root);
                    var localArray = childrenCallback(root);
                    if ((!fm.liveswitch.Global.equals(localArray, null))) {
                        for (var _i = 0, localArray_4 = localArray; _i < localArray_4.length; _i++) {
                            var local = localArray_4[_i];
                            fm.liveswitch.Utility.treeSearch(local, childrenCallback, nodeCallback);
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Utility;
        }());
        liveswitch.Utility = Utility;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="MediaConfig.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A screen configuration.
        */
        var ScreenConfig = /** @class */ (function (_super) {
            __extends(ScreenConfig, _super);
            function ScreenConfig() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.Point]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.Size]'))) {
                    var origin_15 = __arguments[0];
                    var size = __arguments[1];
                    var frameRate = __arguments[2];
                    // chained constructor: ScreenConfig.call(this, new fm.liveswitch.Rectangle(origin, size), frameRate);
                    __arguments = new Array(2);
                    __arguments[0] = new fm.liveswitch.Rectangle(origin_15, size);
                    __arguments[1] = frameRate;
                    {
                        var region = __arguments[0];
                        var frameRate_3 = __arguments[1];
                        // chained constructor: ScreenConfig.call(this, region, frameRate, 90000);
                        __arguments = new Array(3);
                        __arguments[0] = region;
                        __arguments[1] = frameRate_3;
                        __arguments[2] = 90000;
                        {
                            var region_1 = __arguments[0];
                            var frameRate_4 = __arguments[1];
                            var clockRate = __arguments[2];
                            _this = _super.call(this, clockRate) || this;
                            _this.fmliveswitchScreenConfigInit();
                            _this.setRegion(region_1);
                            _this.setFrameRate(frameRate_4);
                        }
                    }
                }
                else if (__arguments.length == 4) {
                    var origin_16 = __arguments[0];
                    var size = __arguments[1];
                    var frameRate = __arguments[2];
                    var clockRate = __arguments[3];
                    // chained constructor: ScreenConfig.call(this, new fm.liveswitch.Rectangle(origin, size), frameRate, clockRate);
                    __arguments = new Array(3);
                    __arguments[0] = new fm.liveswitch.Rectangle(origin_16, size);
                    __arguments[1] = frameRate;
                    __arguments[2] = clockRate;
                    {
                        var region = __arguments[0];
                        var frameRate_5 = __arguments[1];
                        var clockRate_6 = __arguments[2];
                        _this = _super.call(this, clockRate_6) || this;
                        _this.fmliveswitchScreenConfigInit();
                        _this.setRegion(region);
                        _this.setFrameRate(frameRate_5);
                    }
                }
                else if (__arguments.length == 2) {
                    var region = __arguments[0];
                    var frameRate = __arguments[1];
                    // chained constructor: ScreenConfig.call(this, region, frameRate, 90000);
                    __arguments = new Array(3);
                    __arguments[0] = region;
                    __arguments[1] = frameRate;
                    __arguments[2] = 90000;
                    {
                        var region_2 = __arguments[0];
                        var frameRate_6 = __arguments[1];
                        var clockRate = __arguments[2];
                        _this = _super.call(this, clockRate) || this;
                        _this.fmliveswitchScreenConfigInit();
                        _this.setRegion(region_2);
                        _this.setFrameRate(frameRate_6);
                    }
                }
                else if (__arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.Rectangle]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isNumber(arguments[1]))) {
                    var region = __arguments[0];
                    var frameRate = __arguments[1];
                    var clockRate = __arguments[2];
                    _this = _super.call(this, clockRate) || this;
                    _this.fmliveswitchScreenConfigInit();
                    _this.setRegion(region);
                    _this.setFrameRate(frameRate);
                }
                else if (__arguments.length == 5) {
                    var x = __arguments[0];
                    var y = __arguments[1];
                    var width = __arguments[2];
                    var height = __arguments[3];
                    var frameRate = __arguments[4];
                    // chained constructor: ScreenConfig.call(this, new fm.liveswitch.Point(x, y), new fm.liveswitch.Size(width, height), frameRate);
                    __arguments = new Array(3);
                    __arguments[0] = new fm.liveswitch.Point(x, y);
                    __arguments[1] = new fm.liveswitch.Size(width, height);
                    __arguments[2] = frameRate;
                    {
                        var origin_17 = __arguments[0];
                        var size = __arguments[1];
                        var frameRate_7 = __arguments[2];
                        // chained constructor: ScreenConfig.call(this, new fm.liveswitch.Rectangle(origin, size), frameRate);
                        __arguments = new Array(2);
                        __arguments[0] = new fm.liveswitch.Rectangle(origin_17, size);
                        __arguments[1] = frameRate_7;
                        {
                            var region = __arguments[0];
                            var frameRate_8 = __arguments[1];
                            // chained constructor: ScreenConfig.call(this, region, frameRate, 90000);
                            __arguments = new Array(3);
                            __arguments[0] = region;
                            __arguments[1] = frameRate_8;
                            __arguments[2] = 90000;
                            {
                                var region_3 = __arguments[0];
                                var frameRate_9 = __arguments[1];
                                var clockRate = __arguments[2];
                                _this = _super.call(this, clockRate) || this;
                                _this.fmliveswitchScreenConfigInit();
                                _this.setRegion(region_3);
                                _this.setFrameRate(frameRate_9);
                            }
                        }
                    }
                }
                else if (__arguments.length == 6) {
                    var x = __arguments[0];
                    var y = __arguments[1];
                    var width = __arguments[2];
                    var height = __arguments[3];
                    var frameRate = __arguments[4];
                    var clockRate = __arguments[5];
                    // chained constructor: ScreenConfig.call(this, new fm.liveswitch.Point(x, y), new fm.liveswitch.Size(width, height), frameRate, clockRate);
                    __arguments = new Array(4);
                    __arguments[0] = new fm.liveswitch.Point(x, y);
                    __arguments[1] = new fm.liveswitch.Size(width, height);
                    __arguments[2] = frameRate;
                    __arguments[3] = clockRate;
                    {
                        var origin_18 = __arguments[0];
                        var size = __arguments[1];
                        var frameRate_10 = __arguments[2];
                        var clockRate_7 = __arguments[3];
                        // chained constructor: ScreenConfig.call(this, new fm.liveswitch.Rectangle(origin, size), frameRate, clockRate);
                        __arguments = new Array(3);
                        __arguments[0] = new fm.liveswitch.Rectangle(origin_18, size);
                        __arguments[1] = frameRate_10;
                        __arguments[2] = clockRate_7;
                        {
                            var region = __arguments[0];
                            var frameRate_11 = __arguments[1];
                            var clockRate_8 = __arguments[2];
                            _this = _super.call(this, clockRate_8) || this;
                            _this.fmliveswitchScreenConfigInit();
                            _this.setRegion(region);
                            _this.setFrameRate(frameRate_11);
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            ScreenConfig.prototype.getTypeString = function () {
                return '[fm.liveswitch.ScreenConfig]' + ',' + _super.prototype.getTypeString.call(this);
            };
            ScreenConfig.prototype.fmliveswitchScreenConfigInit = function () {
                this.__frameRate = 0;
            };
            /**
            Gets the frame-rate.
            */
            ScreenConfig.prototype.getFrameRate = function () {
                if (arguments.length == 0) {
                    return this.__frameRate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the region size height.
            */
            ScreenConfig.prototype.getHeight = function () {
                if (arguments.length == 0) {
                    return this.getSize().getHeight();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the region origin.
            */
            ScreenConfig.prototype.getOrigin = function () {
                if (arguments.length == 0) {
                    return this.getRegion().getOrigin();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the region.
            */
            ScreenConfig.prototype.getRegion = function () {
                if (arguments.length == 0) {
                    return this.__region;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the region size.
            */
            ScreenConfig.prototype.getSize = function () {
                if (arguments.length == 0) {
                    return this.getRegion().getSize();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the region size width.
            */
            ScreenConfig.prototype.getWidth = function () {
                if (arguments.length == 0) {
                    return this.getSize().getWidth();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the region origin X coordinate.
            */
            ScreenConfig.prototype.getX = function () {
                if (arguments.length == 0) {
                    return this.getOrigin().getX();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the region origin Y coordinate.
            */
            ScreenConfig.prototype.getY = function () {
                if (arguments.length == 0) {
                    return this.getOrigin().getY();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Determines whether the specified configuration is equivalent.
            @param config The configuration.
            */
            ScreenConfig.prototype.isEquivalent = function (config) {
                if (arguments.length == 1) {
                    if (!_super.prototype.isEquivalent.call(this, config)) {
                        return false;
                    }
                    return ((((fm.liveswitch.Global.equals(this.getX(), config.getX())) && (fm.liveswitch.Global.equals(this.getY(), config.getY()))) && ((fm.liveswitch.Global.equals(this.getWidth(), config.getWidth())) && (fm.liveswitch.Global.equals(this.getHeight(), config.getHeight())))) && (fm.liveswitch.Global.equals(this.getFrameRate(), config.getFrameRate())));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the frame-rate.
            */
            ScreenConfig.prototype.setFrameRate = function (value) {
                if (arguments.length == 1) {
                    if ((value <= 0)) {
                        throw new fm.liveswitch.Exception("Frame-rate must be greater than 0.");
                    }
                    this.__frameRate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the region origin.
            */
            ScreenConfig.prototype.setOrigin = function (value) {
                if (arguments.length == 1) {
                    this.getRegion().setOrigin(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the region.
            */
            ScreenConfig.prototype.setRegion = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(value, null))) {
                        throw new fm.liveswitch.Exception("Region cannot be null.");
                    }
                    this.__region = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the region size.
            */
            ScreenConfig.prototype.setSize = function (value) {
                if (arguments.length == 1) {
                    this.getRegion().setSize(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Returns a string that represents this instance.
            */
            ScreenConfig.prototype.toString = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.format("Clock Rate: {0}, X: {1}, Y: {2} Width: {3}, Height: {4}, Frame Rate: {5}", [fm.liveswitch.NumberExtensions.toString(_super.prototype.getClockRate.call(this)), fm.liveswitch.NumberExtensions.toString(this.getX()), fm.liveswitch.NumberExtensions.toString(this.getY()), fm.liveswitch.NumberExtensions.toString(this.getWidth()), fm.liveswitch.NumberExtensions.toString(this.getHeight()), fm.liveswitch.NumberExtensions.toString(this.getFrameRate())]);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ScreenConfig;
        }(fm.liveswitch.MediaConfig));
        liveswitch.ScreenConfig = ScreenConfig;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="MediaConfig.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A video configuration.
        */
        var VideoConfig = /** @class */ (function (_super) {
            __extends(VideoConfig, _super);
            function VideoConfig() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 2) {
                    var size = __arguments[0];
                    var frameRate = __arguments[1];
                    // chained constructor: VideoConfig.call(this, size, frameRate, 90000);
                    __arguments = new Array(3);
                    __arguments[0] = size;
                    __arguments[1] = frameRate;
                    __arguments[2] = 90000;
                    {
                        var size_1 = __arguments[0];
                        var frameRate_12 = __arguments[1];
                        var clockRate = __arguments[2];
                        _this = _super.call(this, clockRate) || this;
                        _this.fmliveswitchVideoConfigInit();
                        _this.setSize(size_1);
                        _this.setFrameRate(frameRate_12);
                    }
                }
                else if (__arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.Size]'))) {
                    var size = __arguments[0];
                    var frameRate = __arguments[1];
                    var clockRate = __arguments[2];
                    _this = _super.call(this, clockRate) || this;
                    _this.fmliveswitchVideoConfigInit();
                    _this.setSize(size);
                    _this.setFrameRate(frameRate);
                }
                else if (__arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isNumber(arguments[0]))) {
                    var width = __arguments[0];
                    var height = __arguments[1];
                    var frameRate = __arguments[2];
                    // chained constructor: VideoConfig.call(this, new fm.liveswitch.Size(width, height), frameRate);
                    __arguments = new Array(2);
                    __arguments[0] = new fm.liveswitch.Size(width, height);
                    __arguments[1] = frameRate;
                    {
                        var size = __arguments[0];
                        var frameRate_13 = __arguments[1];
                        // chained constructor: VideoConfig.call(this, size, frameRate, 90000);
                        __arguments = new Array(3);
                        __arguments[0] = size;
                        __arguments[1] = frameRate_13;
                        __arguments[2] = 90000;
                        {
                            var size_2 = __arguments[0];
                            var frameRate_14 = __arguments[1];
                            var clockRate = __arguments[2];
                            _this = _super.call(this, clockRate) || this;
                            _this.fmliveswitchVideoConfigInit();
                            _this.setSize(size_2);
                            _this.setFrameRate(frameRate_14);
                        }
                    }
                }
                else if (__arguments.length == 4) {
                    var width = __arguments[0];
                    var height = __arguments[1];
                    var frameRate = __arguments[2];
                    var clockRate = __arguments[3];
                    // chained constructor: VideoConfig.call(this, new fm.liveswitch.Size(width, height), frameRate, clockRate);
                    __arguments = new Array(3);
                    __arguments[0] = new fm.liveswitch.Size(width, height);
                    __arguments[1] = frameRate;
                    __arguments[2] = clockRate;
                    {
                        var size = __arguments[0];
                        var frameRate_15 = __arguments[1];
                        var clockRate_9 = __arguments[2];
                        _this = _super.call(this, clockRate_9) || this;
                        _this.fmliveswitchVideoConfigInit();
                        _this.setSize(size);
                        _this.setFrameRate(frameRate_15);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            VideoConfig.prototype.getTypeString = function () {
                return '[fm.liveswitch.VideoConfig]' + ',' + _super.prototype.getTypeString.call(this);
            };
            VideoConfig.prototype.fmliveswitchVideoConfigInit = function () {
                this.__frameRate = 0;
            };
            /**
            Gets the frame duration in milliseconds.
            */
            VideoConfig.prototype.getFrameDuration = function () {
                if (arguments.length == 0) {
                    var frameRate = this.getFrameRate();
                    if ((frameRate <= 0)) {
                        return -1;
                    }
                    return (1000 / frameRate);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the frame-rate.
            */
            VideoConfig.prototype.getFrameRate = function () {
                if (arguments.length == 0) {
                    return this.__frameRate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the size height.
            */
            VideoConfig.prototype.getHeight = function () {
                if (arguments.length == 0) {
                    return this.getSize().getHeight();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the size.
            */
            VideoConfig.prototype.getSize = function () {
                if (arguments.length == 0) {
                    return this.__size;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the size width.
            */
            VideoConfig.prototype.getWidth = function () {
                if (arguments.length == 0) {
                    return this.getSize().getWidth();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Determines whether the specified configuration is equivalent.
            @param config The configuration.
            */
            VideoConfig.prototype.isEquivalent = function (config) {
                if (arguments.length == 1) {
                    if (!_super.prototype.isEquivalent.call(this, config)) {
                        return false;
                    }
                    return (((fm.liveswitch.Global.equals(this.getWidth(), config.getWidth())) && (fm.liveswitch.Global.equals(this.getHeight(), config.getHeight()))) && (fm.liveswitch.Global.equals(this.getFrameRate(), config.getFrameRate())));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the frame-rate.
            */
            VideoConfig.prototype.setFrameRate = function (value) {
                if (arguments.length == 1) {
                    if ((value <= 0)) {
                        throw new fm.liveswitch.Exception("Frame-rate must be greater than 0.");
                    }
                    this.__frameRate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the size.
            */
            VideoConfig.prototype.setSize = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(value, null))) {
                        throw new fm.liveswitch.Exception("Size cannot be null.");
                    }
                    this.__size = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Returns a string that represents this instance.
            */
            VideoConfig.prototype.toString = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.format("Clock Rate: {0}, Width: {1}, Height: {2}, Frame Rate: {3}", [fm.liveswitch.NumberExtensions.toString(_super.prototype.getClockRate.call(this)), fm.liveswitch.NumberExtensions.toString(this.getWidth()), fm.liveswitch.NumberExtensions.toString(this.getHeight()), fm.liveswitch.NumberExtensions.toString(this.getFrameRate())]);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return VideoConfig;
        }(fm.liveswitch.MediaConfig));
        liveswitch.VideoConfig = VideoConfig;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A media buffer.
        */
        var MediaBuffer = /** @class */ (function (_super) {
            __extends(MediaBuffer, _super);
            function MediaBuffer() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaBufferInit();
                }
                else if (__arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.DataBuffer]'))) {
                    var dataBuffer = __arguments[0];
                    var format = __arguments[1];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaBufferInit();
                    _this.setDataBuffer(dataBuffer);
                    _this.setFormat(format);
                }
                else if (__arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isObjectType(arguments[0][0], '[fm.liveswitch.DataBuffer]')))))) {
                    var dataBuffers = __arguments[0];
                    var format = __arguments[1];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaBufferInit();
                    _this.setDataBuffers(dataBuffers);
                    _this.setFormat(format);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaBuffer.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaBuffer]' + ',' + _super.prototype.getTypeString.call(this);
            };
            MediaBuffer.prototype.fmliveswitchMediaBufferInit = function () {
                this._recoveredByFec = false;
            };
            /**
            Clones this instance.
            */
            MediaBuffer.prototype.clone = function () {
                if (arguments.length == 0) {
                    var local = this.createInstance();
                    local.setDataBuffers(this.getDataBuffers());
                    local.setSequenceNumbers(fm.liveswitch.Utility.cloneLongArray(this.getSequenceNumbers()));
                    if ((!fm.liveswitch.Global.equals(this.getRtpHeaders(), null))) {
                        local.setRtpHeaders(new Array(this.getRtpHeaders().length));
                        for (var i = 0; (i < local.getRtpHeaders().length); i++) {
                            if ((!fm.liveswitch.Global.equals(this.getRtpHeaders()[i], null))) {
                                local.getRtpHeaders()[i] = this.getRtpHeaders()[i].clone();
                            }
                        }
                    }
                    local.setFormat(this.getFormat().clone());
                    return local;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Frees the data buffers referenced by this instance.
            @return This instance.
            */
            MediaBuffer.prototype.free = function () {
                if (arguments.length == 0) {
                    for (var _i = 0, _a = this.getDataBuffers(); _i < _a.length; _i++) {
                        var buffer = _a[_i];
                        buffer.free();
                    }
                    return this;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the data buffer.
            */
            MediaBuffer.prototype.getDataBuffer = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Utility.firstOrDefault(this.getDataBuffers());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the data buffers.
            */
            MediaBuffer.prototype.getDataBuffers = function () {
                if (arguments.length == 0) {
                    return this.__dataBuffers;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the approximate footprint of this media buffer by returning the sum of its data buffer lengths.
            */
            MediaBuffer.prototype.getFootprint = function () {
                if (arguments.length == 0) {
                    var num = 0;
                    for (var _i = 0, _a = this.getDataBuffers(); _i < _a.length; _i++) {
                        var buffer = _a[_i];
                        num = (num + buffer.getLength());
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the format.
            */
            MediaBuffer.prototype.getFormat = function () {
                if (arguments.length == 0) {
                    return this.__format;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaBuffer.prototype.getIsPacketized = function () {
                if (arguments.length == 0) {
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the last sequence number.
            */
            MediaBuffer.prototype.getLastSequenceNumber = function () {
                if (arguments.length == 0) {
                    var sequenceNumbers = this.getSequenceNumbers();
                    if ((fm.liveswitch.Global.equals(sequenceNumbers, null))) {
                        return -1;
                    }
                    return sequenceNumbers[(sequenceNumbers.length - 1)];
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this buffer contains data recovered by forward error correction (FEC).
            */
            MediaBuffer.prototype.getRecoveredByFec = function () {
                if (arguments.length == 0) {
                    return this._recoveredByFec;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the Rtp Packet Header for this media buffer.
            */
            MediaBuffer.prototype.getRtpHeader = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Utility.firstOrDefault(this.getRtpHeaders());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the RTP Packet Headers for this media buffer.
            */
            MediaBuffer.prototype.getRtpHeaders = function () {
                if (arguments.length == 0) {
                    return this._rtpHeaders;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the RTP sequence number.
            */
            MediaBuffer.prototype.getRtpSequenceNumber = function () {
                if (arguments.length == 0) {
                    var rtpSequenceNumbers = this.getRtpSequenceNumbers();
                    if ((fm.liveswitch.Global.equals(rtpSequenceNumbers, null))) {
                        return -1;
                    }
                    return rtpSequenceNumbers[0];
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the RTP sequence numbers.
            */
            MediaBuffer.prototype.getRtpSequenceNumbers = function () {
                if (arguments.length == 0) {
                    var rtpHeaders = this.getRtpHeaders();
                    if ((fm.liveswitch.Global.equals(rtpHeaders, null))) {
                        return null;
                    }
                    var numArray = new Array(rtpHeaders.length);
                    for (var i = 0; (i < numArray.length); i++) {
                        var header = rtpHeaders[i];
                        if ((fm.liveswitch.Global.equals(header, null))) {
                            numArray[i] = -1;
                        }
                        else {
                            numArray[i] = rtpHeaders[i].getSequenceNumber();
                        }
                    }
                    return numArray;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the sequence number.
            */
            MediaBuffer.prototype.getSequenceNumber = function () {
                if (arguments.length == 0) {
                    var sequenceNumbers = this.getSequenceNumbers();
                    if ((fm.liveswitch.Global.equals(sequenceNumbers, null))) {
                        return -1;
                    }
                    return sequenceNumbers[0];
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the sequence numbers.
            */
            MediaBuffer.prototype.getSequenceNumbers = function () {
                if (arguments.length == 0) {
                    return this._sequenceNumbers;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the source identifier.
            */
            MediaBuffer.prototype.getSourceId = function () {
                if (arguments.length == 0) {
                    return this._sourceId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Keeps the data buffers referenced by this instance.
            @return This instance.
            */
            MediaBuffer.prototype.keep = function () {
                if (arguments.length == 0) {
                    for (var _i = 0, _a = this.getDataBuffers(); _i < _a.length; _i++) {
                        var buffer = _a[_i];
                        buffer.keep();
                    }
                    return this;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the data buffer.
            */
            MediaBuffer.prototype.setDataBuffer = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(value, null))) {
                        throw new fm.liveswitch.Exception("Data buffer cannot be null.");
                    }
                    this.__dataBuffers = [value];
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the data buffers.
            */
            MediaBuffer.prototype.setDataBuffers = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(value, null))) {
                        throw new fm.liveswitch.Exception("Data buffers cannot be null.");
                    }
                    this.__dataBuffers = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the format.
            */
            MediaBuffer.prototype.setFormat = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(value, null))) {
                        throw new fm.liveswitch.Exception("Format cannot be null.");
                    }
                    this.__format = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a value indicating whether this buffer contains data recovered by forward error correction (FEC).
            */
            MediaBuffer.prototype.setRecoveredByFec = function (value) {
                if (arguments.length == 1) {
                    this._recoveredByFec = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the Rtp Packet Header for this media buffer.
            */
            MediaBuffer.prototype.setRtpHeader = function (value) {
                if (arguments.length == 1) {
                    this.setRtpHeaders(((fm.liveswitch.Global.equals(value, null)) ? null : [value]));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the RTP Packet Headers for this media buffer.
            */
            MediaBuffer.prototype.setRtpHeaders = function (value) {
                if (arguments.length == 1) {
                    this._rtpHeaders = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the sequence number.
            */
            MediaBuffer.prototype.setSequenceNumber = function (value) {
                if (arguments.length == 1) {
                    this.setSequenceNumbers([value]);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the sequence numbers.
            */
            MediaBuffer.prototype.setSequenceNumbers = function (value) {
                if (arguments.length == 1) {
                    this._sequenceNumbers = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the source identifier.
            */
            MediaBuffer.prototype.setSourceId = function (value) {
                if (arguments.length == 1) {
                    this._sourceId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Returns a string that represents this instance.
            */
            MediaBuffer.prototype.toString = function () {
                if (arguments.length == 0) {
                    return this.getFormat().toString();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Attempts to keep the data buffers referenced by this instance.
            @return True if succeeded.
            */
            MediaBuffer.prototype.tryKeep = function () {
                if (arguments.length == 0) {
                    try {
                        for (var _i = 0, _a = this.getDataBuffers(); _i < _a.length; _i++) {
                            var buffer = _a[_i];
                            buffer.keep();
                        }
                        return true;
                    }
                    catch (obj1) {
                        return false;
                    }
                    finally {
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaBuffer;
        }(fm.liveswitch.Dynamic));
        liveswitch.MediaBuffer = MediaBuffer;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A media format.
        */
        var MediaFormat = /** @class */ (function () {
            function MediaFormat() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchMediaFormatInit();
                    this.initialize();
                }
                else if (__arguments.length == 2) {
                    var name_23 = __arguments[0];
                    var clockRate = __arguments[1];
                    //super();
                    this.fmliveswitchMediaFormatInit();
                    this.initialize();
                    this.initialize(name_23, clockRate, null, null, null);
                }
                else if (__arguments.length == 3) {
                    var name_24 = __arguments[0];
                    var clockRate = __arguments[1];
                    var packetizationMode = __arguments[2];
                    //super();
                    this.fmliveswitchMediaFormatInit();
                    this.initialize();
                    this.initialize(name_24, clockRate, null, null, packetizationMode);
                }
                else if (__arguments.length == 4) {
                    var name_25 = __arguments[0];
                    var clockRate = __arguments[1];
                    var profile = __arguments[2];
                    var level = __arguments[3];
                    //super();
                    this.fmliveswitchMediaFormatInit();
                    this.initialize();
                    this.initialize(name_25, clockRate, profile, level, null);
                }
                else if (__arguments.length == 5) {
                    var name_26 = __arguments[0];
                    var clockRate = __arguments[1];
                    var profile = __arguments[2];
                    var level = __arguments[3];
                    var packetizationMode = __arguments[4];
                    //super();
                    this.fmliveswitchMediaFormatInit();
                    this.initialize();
                    this.initialize(name_26, clockRate, profile, level, packetizationMode);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            MediaFormat.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaFormat]';
            };
            MediaFormat.prototype.fmliveswitchMediaFormatInit = function () {
                this._clockRate = 0;
                this._isEncrypted = false;
                this._isFixedBitrate = false;
                this._isInjected = false;
                this._isPacketized = false;
                this._levelIsStrict = false;
                this._registeredPayloadType = 0;
                this._staticPayloadType = 0;
            };
            /**
            Gets the name of the RED media format.
            */
            MediaFormat.getRedName = function () {
                if (arguments.length == 0) {
                    return "red";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name of the ULPFEC media format.
            */
            MediaFormat.getUlpFecName = function () {
                if (arguments.length == 0) {
                    return "ulpfec";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Clones this instance.
            */
            MediaFormat.prototype.clone = function () {
                if (arguments.length == 0) {
                    var local = this.createInstance();
                    local.setName(this.getName());
                    local.setClockRate(this.getClockRate());
                    local.setIsPacketized(this.getIsPacketized());
                    local.setPacketizationMode(this.getPacketizationMode());
                    local.setProfile(this.getProfile());
                    local.setLevel(this.getLevel());
                    local.setLevelIsStrict(this.getLevelIsStrict());
                    local.setIsEncrypted(this.getIsEncrypted());
                    local.setIsInjected(this.getIsInjected());
                    local.setRegisteredPayloadType(this.getRegisteredPayloadType());
                    local.setStaticPayloadType(this.getStaticPayloadType());
                    local.setIsFixedBitrate(this.getIsFixedBitrate());
                    return local;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the clock rate.
            */
            MediaFormat.prototype.getClockRate = function () {
                if (arguments.length == 0) {
                    return this._clockRate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the full name, including clock rate and encoding parameters.
            */
            MediaFormat.prototype.getFullName = function () {
                if (arguments.length == 0) {
                    if ((fm.liveswitch.Global.equals(this.getName(), null))) {
                        throw new fm.liveswitch.Exception("Name cannot be null.");
                    }
                    var parameters = this.getParameters();
                    if (fm.liveswitch.StringExtensions.isNullOrEmpty(parameters)) {
                        return fm.liveswitch.StringExtensions.format("{0}/{1}", this.getName(), fm.liveswitch.NumberExtensions.toString(this.getClockRate()));
                    }
                    return fm.liveswitch.StringExtensions.format("{0}/{1}/{2}", this.getName(), fm.liveswitch.NumberExtensions.toString(this.getClockRate()), parameters);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating that the data is encrypted.
            */
            MediaFormat.prototype.getIsEncrypted = function () {
                if (arguments.length == 0) {
                    return this._isEncrypted;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether a format only supports fixed bitrate.
            */
            MediaFormat.prototype.getIsFixedBitrate = function () {
                if (arguments.length == 0) {
                    return this._isFixedBitrate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating that the data is injected into the primary media stream (e.g. DTMF).
            */
            MediaFormat.prototype.getIsInjected = function () {
                if (arguments.length == 0) {
                    return this._isInjected;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the data is packetized.
            */
            MediaFormat.prototype.getIsPacketized = function () {
                if (arguments.length == 0) {
                    return this._isPacketized;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the level.
            */
            MediaFormat.prototype.getLevel = function () {
                if (arguments.length == 0) {
                    return this._level;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the level is strict.
            */
            MediaFormat.prototype.getLevelIsStrict = function () {
                if (arguments.length == 0) {
                    return this._levelIsStrict;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the maximum bitrate supported by this format, in kbps.
            */
            MediaFormat.prototype.getMaxBitrate = function () {
                if (arguments.length == 0) {
                    return -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the maximum level.
            @param level1 The first level.
            @param level2 The second level.
            @return The maximum level.
            */
            MediaFormat.prototype.getMaxLevel = function (level1, level2) {
                if (arguments.length == 2) {
                    return level1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the minimum bitrate supported by this format, in kbps.
            */
            MediaFormat.prototype.getMinBitrate = function () {
                if (arguments.length == 0) {
                    return -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the minimum level.
            @param level1 The first level.
            @param level2 The second level.
            @return The minimum level.
            */
            MediaFormat.prototype.getMinLevel = function (level1, level2) {
                if (arguments.length == 2) {
                    return level1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name.
            */
            MediaFormat.prototype.getName = function () {
                if (arguments.length == 0) {
                    return this.__name;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the packetization mode.
            */
            MediaFormat.prototype.getPacketizationMode = function () {
                if (arguments.length == 0) {
                    if (this.getIsPacketized()) {
                        return this.__packetizationMode;
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the profile.
            */
            MediaFormat.prototype.getProfile = function () {
                if (arguments.length == 0) {
                    return this._profile;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaFormat.prototype.getRegisteredPayloadType = function () {
                if (arguments.length == 0) {
                    return this._registeredPayloadType;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the static payload type, if this format has a static payload type registered with IANA.
            */
            MediaFormat.prototype.getStaticPayloadType = function () {
                if (arguments.length == 0) {
                    return this._staticPayloadType;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            MediaFormat.prototype.initialize = function () {
                if (arguments.length == 0) {
                    this.setRegisteredPayloadType(-1);
                    this.setStaticPayloadType(-1);
                }
                else if (arguments.length == 5) {
                    var name_27 = arguments[0];
                    var clockRate = arguments[1];
                    var profile = arguments[2];
                    var level = arguments[3];
                    var packetizationMode = arguments[4];
                    this.setName(name_27);
                    this.setClockRate(clockRate);
                    this.setProfile(profile);
                    this.setLevel(level);
                    this.setPacketizationMode(packetizationMode);
                    if ((!fm.liveswitch.Global.equals(packetizationMode, null))) {
                        this.setIsPacketized(true);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Determines whether the specified format is compatible.
            @param format The format.
            */
            MediaFormat.prototype.isCompatible = function (format) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(format, null))) {
                        return false;
                    }
                    if (!fm.liveswitch.StringExtensions.isEqual(this.getName(), format.getName(), fm.liveswitch.StringComparison.InvariantCultureIgnoreCase)) {
                        return false;
                    }
                    if ((!fm.liveswitch.Global.equals(this.getClockRate(), format.getClockRate()))) {
                        return false;
                    }
                    if ((!fm.liveswitch.Global.equals(this.getIsPacketized(), format.getIsPacketized()))) {
                        return false;
                    }
                    if ((!fm.liveswitch.Global.equals(this.getPacketizationMode(), format.getPacketizationMode()))) {
                        return false;
                    }
                    if (((((!fm.liveswitch.Global.equals(this.getProfile(), null)) && (!fm.liveswitch.Global.equals(format.getProfile(), null))) && !fm.liveswitch.StringExtensions.isEqual(this.getProfile(), format.getProfile(), fm.liveswitch.StringComparison.InvariantCultureIgnoreCase)) && !this.isProfileCompatible(format.getProfile()))) {
                        return false;
                    }
                    if (((((!fm.liveswitch.Global.equals(this.getLevel(), null)) && (!fm.liveswitch.Global.equals(format.getLevel(), null))) && this.getLevelIsStrict()) && (!fm.liveswitch.StringExtensions.isEqual(this.getLevel(), format.getLevel(), fm.liveswitch.StringComparison.InvariantCultureIgnoreCase) && !this.isLevelCompatible(format.getLevel())))) {
                        return false;
                    }
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Determines whether the specified format is equivalent.
            @param format The format.
            @param ignoreIsPacketized Whether to ignore if the two formats differ in whether they are packetized.
            */
            MediaFormat.prototype.isEquivalent = function (format, ignoreIsPacketized) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(format, null))) {
                        return false;
                    }
                    if (!fm.liveswitch.StringExtensions.isEqual(this.getName(), format.getName(), fm.liveswitch.StringComparison.InvariantCultureIgnoreCase)) {
                        return false;
                    }
                    if ((!fm.liveswitch.Global.equals(this.getClockRate(), format.getClockRate()))) {
                        return false;
                    }
                    if (!ignoreIsPacketized) {
                        if ((!fm.liveswitch.Global.equals(this.getIsPacketized(), format.getIsPacketized()))) {
                            return false;
                        }
                        if ((!fm.liveswitch.Global.equals(this.getPacketizationMode(), format.getPacketizationMode()))) {
                            return false;
                        }
                    }
                    if ((fm.liveswitch.Global.equals(this.getProfile(), null))) {
                        if ((!fm.liveswitch.Global.equals(format.getProfile(), null))) {
                            return false;
                        }
                    }
                    else {
                        if (!fm.liveswitch.StringExtensions.isEqual(this.getProfile(), format.getProfile(), fm.liveswitch.StringComparison.InvariantCultureIgnoreCase)) {
                            return false;
                        }
                    }
                    if ((fm.liveswitch.Global.equals(this.getLevel(), null))) {
                        if ((!fm.liveswitch.Global.equals(format.getLevel(), null))) {
                            return false;
                        }
                    }
                    else {
                        if (!fm.liveswitch.StringExtensions.isEqual(this.getLevel(), format.getLevel(), fm.liveswitch.StringComparison.InvariantCultureIgnoreCase)) {
                            return false;
                        }
                    }
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether a level is compatible.
            @param level The level.
            */
            MediaFormat.prototype.isLevelCompatible = function (level) {
                if (arguments.length == 1) {
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether a profile is compatible.
            @param profile The profile.
            */
            MediaFormat.prototype.isProfileCompatible = function (profile) {
                if (arguments.length == 1) {
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the clock rate.
            */
            MediaFormat.prototype.setClockRate = function (value) {
                if (arguments.length == 1) {
                    this._clockRate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a value indicating that the data is encrypted.
            */
            MediaFormat.prototype.setIsEncrypted = function (value) {
                if (arguments.length == 1) {
                    this._isEncrypted = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a value indicating whether a format only supports fixed bitrate.
            */
            MediaFormat.prototype.setIsFixedBitrate = function (value) {
                if (arguments.length == 1) {
                    this._isFixedBitrate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a value indicating that the data is injected into the primary media stream (e.g. DTMF).
            */
            MediaFormat.prototype.setIsInjected = function (value) {
                if (arguments.length == 1) {
                    this._isInjected = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a value indicating whether the data is packetized.
            */
            MediaFormat.prototype.setIsPacketized = function (value) {
                if (arguments.length == 1) {
                    this._isPacketized = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the level.
            */
            MediaFormat.prototype.setLevel = function (value) {
                if (arguments.length == 1) {
                    this._level = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a value indicating whether the level is strict.
            */
            MediaFormat.prototype.setLevelIsStrict = function (value) {
                if (arguments.length == 1) {
                    this._levelIsStrict = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the name.
            */
            MediaFormat.prototype.setName = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(value, null))) {
                        throw new fm.liveswitch.Exception("Name cannot be null.");
                    }
                    this.__name = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the packetization mode.
            */
            MediaFormat.prototype.setPacketizationMode = function (value) {
                if (arguments.length == 1) {
                    this.__packetizationMode = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the profile.
            */
            MediaFormat.prototype.setProfile = function (value) {
                if (arguments.length == 1) {
                    this._profile = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaFormat.prototype.setRegisteredPayloadType = function (value) {
                if (arguments.length == 1) {
                    this._registeredPayloadType = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the static payload type, if this format has a static payload type registered with IANA.
            */
            MediaFormat.prototype.setStaticPayloadType = function (value) {
                if (arguments.length == 1) {
                    this._staticPayloadType = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Returns a string that represents this instance.
            */
            MediaFormat.prototype.toString = function () {
                if (arguments.length == 0) {
                    var builder = new fm.liveswitch.StringBuilder();
                    builder.append(this.getFullName());
                    var list = new Array();
                    if ((!fm.liveswitch.Global.equals(this.getPacketizationMode(), null))) {
                        fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.format("Packetization Mode {0}", this.getPacketizationMode()));
                    }
                    if ((!fm.liveswitch.Global.equals(this.getProfile(), null))) {
                        fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.format("Profile {0}", this.getProfile()));
                    }
                    if ((!fm.liveswitch.Global.equals(this.getLevel(), null))) {
                        fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.StringExtensions.format("Level {0}", this.getLevel()));
                    }
                    if ((fm.liveswitch.ArrayExtensions.getCount(list) > 0)) {
                        builder.append(" (");
                        builder.append(fm.liveswitch.StringExtensions.join("; ", fm.liveswitch.ArrayExtensions.toArray(list)));
                        builder.append(")");
                    }
                    return builder.toString();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Updates the level-is-strict flag to a compatible value.
            @param format The format.
            */
            MediaFormat.prototype.updateLevelIsStrictToCompatible = function (format) {
                if (arguments.length == 1) {
                    if (format.getLevelIsStrict()) {
                        this.setLevelIsStrict(true);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Updates the level to a compatible value.
            @param format The format.
            */
            MediaFormat.prototype.updateLevelToCompatible = function (format) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(format.getLevel(), null))) {
                        if ((fm.liveswitch.Global.equals(this.getLevel(), null))) {
                            this.setLevel(format.getLevel());
                        }
                        else {
                            if (!this.getLevelIsStrict()) {
                                if (format.getLevelIsStrict()) {
                                    this.setLevel(format.getLevel());
                                }
                                else {
                                    this.setLevel(this.getMinLevel(this.getLevel(), format.getLevel()));
                                }
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Updates the profile to a compatible value.
            @param format The format.
            */
            MediaFormat.prototype.updateProfileToCompatible = function (format) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(format.getProfile(), null))) {
                        this.setProfile(format.getProfile());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            MediaFormat.prototype.updateToCompatible = function (format) {
                if (arguments.length == 1) {
                    this.updateProfileToCompatible(format);
                    this.updateLevelToCompatible(format);
                    this.updateLevelIsStrictToCompatible(format);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaFormat;
        }());
        liveswitch.MediaFormat = MediaFormat;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="MediaFormat.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        An audio format.
        */
        var AudioFormat = /** @class */ (function (_super) {
            __extends(AudioFormat, _super);
            function AudioFormat() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchAudioFormatInit();
                }
                else if (__arguments.length == 3) {
                    var name_28 = __arguments[0];
                    var clockRate = __arguments[1];
                    var channelCount = __arguments[2];
                    _this = _super.call(this, name_28, clockRate) || this;
                    _this.fmliveswitchAudioFormatInit();
                    _this.setChannelCount(channelCount);
                }
                else if (__arguments.length == 2) {
                    var name_29 = __arguments[0];
                    var config = __arguments[1];
                    _this = _super.call(this, name_29, config.getClockRate()) || this;
                    _this.fmliveswitchAudioFormatInit();
                    _this.setChannelCount(config.getChannelCount());
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            AudioFormat.prototype.getTypeString = function () {
                return '[fm.liveswitch.AudioFormat]' + ',' + _super.prototype.getTypeString.call(this);
            };
            AudioFormat.prototype.fmliveswitchAudioFormatInit = function () {
                this._channelCount = 0;
                this._littleEndian = false;
            };
            /**
            Transforms a FormatInfo into an AudioFormat.
            @param info The format info.
            */
            AudioFormat.fromFormatInfo = function (info) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(info.getChannelCount(), -1))) {
                        throw new fm.liveswitch.Exception("Not an audio format info.");
                    }
                    return new fm.liveswitch.AudioFormat(info.getName(), new fm.liveswitch.AudioConfig(info.getClockRate(), info.getChannelCount()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an instance from JSON.
            @param audioFormatJson The audio format JSON.
            */
            AudioFormat.fromJson = function (audioFormatJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(audioFormatJson, function () {
                        return new fm.liveswitch.AudioFormat();
                    }, function (audioFormat, name, valueJson) {
                        var _var0 = name;
                        if (_var0 == "channelCount") {
                            do {
                                audioFormat.setChannelCount(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "littleEndian") {
                            do {
                                audioFormat.setLittleEndian(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "name") {
                            do {
                                audioFormat.setName(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "clockRate") {
                            do {
                                audioFormat.setClockRate(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "isPacketized") {
                            do {
                                audioFormat.setIsPacketized(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "isEncrypted") {
                            do {
                                audioFormat.setIsEncrypted(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "registeredPayloadType") {
                            do {
                                audioFormat.setRegisteredPayloadType(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "staticPayloadType") {
                            do {
                                audioFormat.setStaticPayloadType(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                break;
                            } while (false);
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name of the DTMF audio format ("telephone-event").
            */
            AudioFormat.getDtmfName = function () {
                if (arguments.length == 0) {
                    return "telephone-event";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name of the G.722 audio format ("G722").
            */
            AudioFormat.getG722Name = function () {
                if (arguments.length == 0) {
                    return "G722";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name of the Opus audio format ("opus").
            */
            AudioFormat.getOpusName = function () {
                if (arguments.length == 0) {
                    return "opus";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name of the PCMA audio format ("PCMA").
            */
            AudioFormat.getPcmaName = function () {
                if (arguments.length == 0) {
                    return "PCMA";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name of the PCM audio format ("PCM").
            */
            AudioFormat.getPcmName = function () {
                if (arguments.length == 0) {
                    return "PCM";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name of the PCMU audio format ("PCMU").
            */
            AudioFormat.getPcmuName = function () {
                if (arguments.length == 0) {
                    return "PCMU";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param audioFormat The audio format.
            */
            AudioFormat.toJson = function (audioFormat) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(audioFormat, function (obj, jsonObject) {
                        jsonObject["channelCount"] = fm.liveswitch.JsonSerializer.serializeInteger(audioFormat.getChannelCount());
                        jsonObject["littleEndian"] = fm.liveswitch.JsonSerializer.serializeBoolean(audioFormat.getLittleEndian());
                        jsonObject["name"] = fm.liveswitch.JsonSerializer.serializeString(audioFormat.getName());
                        jsonObject["clockRate"] = fm.liveswitch.JsonSerializer.serializeInteger(audioFormat.getClockRate());
                        jsonObject["isPacketized"] = fm.liveswitch.JsonSerializer.serializeBoolean(audioFormat.getIsPacketized());
                        jsonObject["isEncrypted"] = fm.liveswitch.JsonSerializer.serializeBoolean(audioFormat.getIsEncrypted());
                        jsonObject["registeredPayloadType"] = fm.liveswitch.JsonSerializer.serializeInteger(audioFormat.getRegisteredPayloadType());
                        jsonObject["staticPayloadType"] = fm.liveswitch.JsonSerializer.serializeInteger(audioFormat.getStaticPayloadType());
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Clones this instance.
            */
            AudioFormat.prototype.clone = function () {
                if (arguments.length == 0) {
                    var format = _super.prototype.clone.call(this);
                    format.setChannelCount(this.getChannelCount());
                    format.setLittleEndian(this.getLittleEndian());
                    return format;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a new instance.
            */
            AudioFormat.prototype.createInstance = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.AudioFormat();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the channel count.
            */
            AudioFormat.prototype.getChannelCount = function () {
                if (arguments.length == 0) {
                    return this._channelCount;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the clock rate and channel count as a configuration.
            */
            AudioFormat.prototype.getConfig = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.AudioConfig(_super.prototype.getClockRate.call(this), this.getChannelCount());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets this format as an info object.
            */
            AudioFormat.prototype.getInfo = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.FormatInfo(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether this is a compressed format.
            */
            AudioFormat.prototype.getIsCompressed = function () {
                if (arguments.length == 0) {
                    return !this.getIsPcm();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is DTMF.
            */
            AudioFormat.prototype.getIsDtmf = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.isEqual(_super.prototype.getName.call(this), fm.liveswitch.AudioFormat.getDtmfName(), fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is G.722.
            */
            AudioFormat.prototype.getIsG722 = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.isEqual(_super.prototype.getName.call(this), fm.liveswitch.AudioFormat.getG722Name(), fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is Opus.
            */
            AudioFormat.prototype.getIsOpus = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.isEqual(_super.prototype.getName.call(this), fm.liveswitch.AudioFormat.getOpusName(), fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is PCM.
            */
            AudioFormat.prototype.getIsPcm = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.isEqual(_super.prototype.getName.call(this), fm.liveswitch.AudioFormat.getPcmName(), fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is PCMA.
            */
            AudioFormat.prototype.getIsPcma = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.isEqual(_super.prototype.getName.call(this), fm.liveswitch.AudioFormat.getPcmaName(), fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is PCMU.
            */
            AudioFormat.prototype.getIsPcmu = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.isEqual(_super.prototype.getName.call(this), fm.liveswitch.AudioFormat.getPcmuName(), fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the format uses little endian byte order.
            */
            AudioFormat.prototype.getLittleEndian = function () {
                if (arguments.length == 0) {
                    return this._littleEndian;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the parameters.
            */
            AudioFormat.prototype.getParameters = function () {
                if (arguments.length == 0) {
                    var channelCount = this.getChannelCount();
                    if ((fm.liveswitch.Global.equals(channelCount, 1))) {
                        return null;
                    }
                    return fm.liveswitch.NumberExtensions.toString(channelCount);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Determines whether the specified format is compatible.
            @param format The format.
            */
            AudioFormat.prototype.isCompatible = function (format) {
                if (arguments.length == 1) {
                    if (!_super.prototype.isCompatible.call(this, format)) {
                        return false;
                    }
                    if ((!fm.liveswitch.Global.equals(this.getChannelCount(), format.getChannelCount()))) {
                        return false;
                    }
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Determines whether the specified format is equivalent.
            @param format The format.
            @param ignoreIsPacketized Whether to ignore if the two formats differ in whether they are packetized.
            */
            AudioFormat.prototype.isEquivalent = function (format, ignoreIsPacketized) {
                if (arguments.length == 2) {
                    return (_super.prototype.isEquivalent.call(this, format, ignoreIsPacketized) && (fm.liveswitch.Global.equals(this.getChannelCount(), format.getChannelCount())));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the channel count.
            */
            AudioFormat.prototype.setChannelCount = function (value) {
                if (arguments.length == 1) {
                    this._channelCount = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the format uses little endian byte order.
            */
            AudioFormat.prototype.setLittleEndian = function (value) {
                if (arguments.length == 1) {
                    this._littleEndian = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            AudioFormat.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.AudioFormat.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return AudioFormat;
        }(fm.liveswitch.MediaFormat));
        liveswitch.AudioFormat = AudioFormat;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media sink base properties/methods.
        */
        var MediaSinkBase = /** @class */ (function (_super) {
            __extends(MediaSinkBase, _super);
            function MediaSinkBase() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.__id = fm.liveswitch.Utility.generateId();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaSinkBase.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaSinkBase]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Gets the external identifier.
            */
            MediaSinkBase.prototype.getExternalId = function () {
                if (arguments.length == 0) {
                    return this._externalId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the identifier.
            */
            MediaSinkBase.prototype.getId = function () {
                if (arguments.length == 0) {
                    return this.__id;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets optional data to associate with this instance.
            */
            MediaSinkBase.prototype.getTag = function () {
                if (arguments.length == 0) {
                    return this._tag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the external identifier.
            */
            MediaSinkBase.prototype.setExternalId = function (value) {
                if (arguments.length == 1) {
                    this._externalId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets optional data to associate with this instance.
            */
            MediaSinkBase.prototype.setTag = function (value) {
                if (arguments.length == 1) {
                    this._tag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaSinkBase;
        }(fm.liveswitch.Dynamic));
        liveswitch.MediaSinkBase = MediaSinkBase;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media source base properties/methods.
        */
        var MediaSourceBase = /** @class */ (function (_super) {
            __extends(MediaSourceBase, _super);
            function MediaSourceBase() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.__id = fm.liveswitch.Utility.generateId();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaSourceBase.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaSourceBase]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Gets the external identifier.
            */
            MediaSourceBase.prototype.getExternalId = function () {
                if (arguments.length == 0) {
                    return this._externalId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the identifier.
            */
            MediaSourceBase.prototype.getId = function () {
                if (arguments.length == 0) {
                    return this.__id;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets optional data to associate with this instance.
            */
            MediaSourceBase.prototype.getTag = function () {
                if (arguments.length == 0) {
                    return this._tag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the external identifier.
            */
            MediaSourceBase.prototype.setExternalId = function (value) {
                if (arguments.length == 1) {
                    this._externalId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets optional data to associate with this instance.
            */
            MediaSourceBase.prototype.setTag = function (value) {
                if (arguments.length == 1) {
                    this._tag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaSourceBase;
        }(fm.liveswitch.Dynamic));
        liveswitch.MediaSourceBase = MediaSourceBase;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var CcmTmmbnPolicyWrapper = /** @class */ (function () {
            function CcmTmmbnPolicyWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_37 = __arguments[0];
                    //super();
                    this._value = value_37;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            CcmTmmbnPolicyWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.CcmTmmbnPolicyWrapper]';
            };
            CcmTmmbnPolicyWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.CcmTmmbnPolicy.Disabled)
                        return 'Disabled';
                    if (this._value == fm.liveswitch.CcmTmmbnPolicy.Negotiated)
                        return 'Negotiated';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return CcmTmmbnPolicyWrapper;
        }());
        liveswitch.CcmTmmbnPolicyWrapper = CcmTmmbnPolicyWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var CcmTmmbrPolicyWrapper = /** @class */ (function () {
            function CcmTmmbrPolicyWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_38 = __arguments[0];
                    //super();
                    this._value = value_38;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            CcmTmmbrPolicyWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.CcmTmmbrPolicyWrapper]';
            };
            CcmTmmbrPolicyWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.CcmTmmbrPolicy.Disabled)
                        return 'Disabled';
                    if (this._value == fm.liveswitch.CcmTmmbrPolicy.Negotiated)
                        return 'Negotiated';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return CcmTmmbrPolicyWrapper;
        }());
        liveswitch.CcmTmmbrPolicyWrapper = CcmTmmbrPolicyWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var VideoTypeWrapper = /** @class */ (function () {
            function VideoTypeWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_39 = __arguments[0];
                    //super();
                    this._value = value_39;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            VideoTypeWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.VideoTypeWrapper]';
            };
            VideoTypeWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.VideoType.Unknown)
                        return 'Unknown';
                    if (this._value == fm.liveswitch.VideoType.Camera)
                        return 'Camera';
                    if (this._value == fm.liveswitch.VideoType.Screen)
                        return 'Screen';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return VideoTypeWrapper;
        }());
        liveswitch.VideoTypeWrapper = VideoTypeWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var VideoDegradationPreferenceWrapper = /** @class */ (function () {
            function VideoDegradationPreferenceWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_40 = __arguments[0];
                    //super();
                    this._value = value_40;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            VideoDegradationPreferenceWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.VideoDegradationPreferenceWrapper]';
            };
            VideoDegradationPreferenceWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.VideoDegradationPreference.Automatic)
                        return 'Automatic';
                    if (this._value == fm.liveswitch.VideoDegradationPreference.Balanced)
                        return 'Balanced';
                    if (this._value == fm.liveswitch.VideoDegradationPreference.FrameRate)
                        return 'FrameRate';
                    if (this._value == fm.liveswitch.VideoDegradationPreference.Resolution)
                        return 'Resolution';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return VideoDegradationPreferenceWrapper;
        }());
        liveswitch.VideoDegradationPreferenceWrapper = VideoDegradationPreferenceWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var SimulcastConfig = /** @class */ (function () {
            function SimulcastConfig(encodingCount, preferredBitrate) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 2) {
                    var encodingCount_1 = __arguments[0];
                    var preferredBitrate_1 = __arguments[1];
                    //super();
                    this.fmliveswitchSimulcastConfigInit();
                    this.setEncodingCount(encodingCount_1);
                    this.setPreferredBitrate(preferredBitrate_1);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            SimulcastConfig.prototype.getTypeString = function () {
                return '[fm.liveswitch.SimulcastConfig]';
            };
            SimulcastConfig.prototype.fmliveswitchSimulcastConfigInit = function () {
                this.__encodingCount = 0;
                this.__preferredBitrate = 0;
                this._disabled = false;
            };
            SimulcastConfig.prototype.getDisabled = function () {
                if (arguments.length == 0) {
                    return this._disabled;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SimulcastConfig.prototype.getEncodingCount = function () {
                if (arguments.length == 0) {
                    return this.__encodingCount;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SimulcastConfig.prototype.getPreferredBitrate = function () {
                if (arguments.length == 0) {
                    return this.__preferredBitrate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SimulcastConfig.prototype.setDisabled = function (value) {
                if (arguments.length == 1) {
                    this._disabled = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SimulcastConfig.prototype.setEncodingCount = function (value) {
                if (arguments.length == 1) {
                    if ((value <= 0)) {
                        throw new fm.liveswitch.Exception("Encoding count must be a positive integer.");
                    }
                    this.__encodingCount = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SimulcastConfig.prototype.setPreferredBitrate = function (value) {
                if (arguments.length == 1) {
                    if ((value <= 0)) {
                        throw new fm.liveswitch.Exception("Preferred bitrate must be a positive integer.");
                    }
                    this.__preferredBitrate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return SimulcastConfig;
        }());
        liveswitch.SimulcastConfig = SimulcastConfig;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="SimulcastConfig.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var AudioSimulcastConfig = /** @class */ (function (_super) {
            __extends(AudioSimulcastConfig, _super);
            function AudioSimulcastConfig(encodingCount, preferredBitrate) {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 2) {
                    var encodingCount_2 = __arguments[0];
                    var preferredBitrate_2 = __arguments[1];
                    _this = _super.call(this, encodingCount_2, preferredBitrate_2) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            AudioSimulcastConfig.prototype.getTypeString = function () {
                return '[fm.liveswitch.AudioSimulcastConfig]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /** @hidden */
            AudioSimulcastConfig.prototype.getEncodingConfigs = function () {
                if (arguments.length == 0) {
                    var list = new Array();
                    if (_super.prototype.getDisabled.call(this)) {
                        fm.liveswitch.ArrayExtensions.add(list, new fm.liveswitch.AudioEncodingConfig());
                    }
                    else {
                        var format = new fm.liveswitch.opus.Format();
                        var num = fm.liveswitch.MathAssistant.min(fm.liveswitch.MathAssistant.max(format.getMinBitrate(), _super.prototype.getPreferredBitrate.call(this)), format.getMaxBitrate());
                        for (var i = 0; (i < _super.prototype.getEncodingCount.call(this)); i++) {
                            var num3 = (1 / fm.liveswitch.MathAssistant.pow(2, i));
                            var config2 = new fm.liveswitch.AudioEncodingConfig();
                            config2.setBitrate(fm.liveswitch.MathAssistant.ceil((num * num3)));
                            var item = config2;
                            if ((item.getBitrate() >= format.getMinBitrate())) {
                                fm.liveswitch.ArrayExtensions.add(list, item);
                            }
                        }
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return AudioSimulcastConfig;
        }(fm.liveswitch.SimulcastConfig));
        liveswitch.AudioSimulcastConfig = AudioSimulcastConfig;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="SimulcastConfig.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var VideoSimulcastConfig = /** @class */ (function (_super) {
            __extends(VideoSimulcastConfig, _super);
            function VideoSimulcastConfig() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 2) {
                    var encodingCount = __arguments[0];
                    var preferredBitrate = __arguments[1];
                    // chained constructor: VideoSimulcastConfig.call(this, encodingCount, preferredBitrate, 0);
                    __arguments = new Array(3);
                    __arguments[0] = encodingCount;
                    __arguments[1] = preferredBitrate;
                    __arguments[2] = 0;
                    {
                        var encodingCount_3 = __arguments[0];
                        var preferredBitrate_3 = __arguments[1];
                        var bitsPerPixel = __arguments[2];
                        _this = _super.call(this, encodingCount_3, preferredBitrate_3) || this;
                        _this.fmliveswitchVideoSimulcastConfigInit();
                        _this.setBitsPerPixel(bitsPerPixel);
                        _this.setDegradationPreference(fm.liveswitch.VideoDegradationPreference.Automatic);
                    }
                }
                else if (__arguments.length == 3) {
                    var encodingCount = __arguments[0];
                    var preferredBitrate = __arguments[1];
                    var bitsPerPixel = __arguments[2];
                    _this = _super.call(this, encodingCount, preferredBitrate) || this;
                    _this.fmliveswitchVideoSimulcastConfigInit();
                    _this.setBitsPerPixel(bitsPerPixel);
                    _this.setDegradationPreference(fm.liveswitch.VideoDegradationPreference.Automatic);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            VideoSimulcastConfig.prototype.getTypeString = function () {
                return '[fm.liveswitch.VideoSimulcastConfig]' + ',' + _super.prototype.getTypeString.call(this);
            };
            VideoSimulcastConfig.prototype.fmliveswitchVideoSimulcastConfigInit = function () {
                this.__bitsPerPixel = 0;
            };
            VideoSimulcastConfig.prototype.getBitsPerPixel = function () {
                if (arguments.length == 0) {
                    return this.__bitsPerPixel;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            VideoSimulcastConfig.prototype.getDegradationPreference = function () {
                if (arguments.length == 0) {
                    return this._degradationPreference;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoSimulcastConfig.prototype.getEncodingConfigs = function (sourceType, sourceWidth, sourceHeight, sourceFrameRate) {
                if (arguments.length == 4) {
                    var list = new Array();
                    if (_super.prototype.getDisabled.call(this)) {
                        fm.liveswitch.ArrayExtensions.add(list, new fm.liveswitch.VideoEncodingConfig());
                    }
                    else {
                        var degradationPreference = this.getDegradationPreference();
                        if ((fm.liveswitch.Global.equals(degradationPreference, fm.liveswitch.VideoDegradationPreference.Automatic))) {
                            if ((fm.liveswitch.Global.equals(sourceType, fm.liveswitch.VideoType.Camera))) {
                                degradationPreference = fm.liveswitch.VideoDegradationPreference.Resolution;
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(sourceType, fm.liveswitch.VideoType.Screen))) {
                                    degradationPreference = fm.liveswitch.VideoDegradationPreference.FrameRate;
                                }
                                else {
                                    degradationPreference = fm.liveswitch.VideoDegradationPreference.Balanced;
                                }
                            }
                        }
                        var format = new fm.liveswitch.vp8.Format();
                        var preferredBitrate = _super.prototype.getPreferredBitrate.call(this);
                        var bitsPerPixel = this.getBitsPerPixel();
                        if (((((sourceWidth > 0) && (sourceHeight > 0)) && (sourceFrameRate > 0)) && (bitsPerPixel > 0))) {
                            var num3 = 640;
                            var num4 = 480;
                            var num5 = (num3 * num4);
                            var num6 = (((num5 * sourceFrameRate) * bitsPerPixel) / 1000);
                            var num7 = (sourceWidth * sourceHeight);
                            var x = (num7 / num5);
                            preferredBitrate = fm.liveswitch.MathAssistant.ceil((fm.liveswitch.MathAssistant.pow(x, 0.75) * num6));
                        }
                        preferredBitrate = fm.liveswitch.MathAssistant.min(fm.liveswitch.MathAssistant.max(format.getMinBitrate(), preferredBitrate), format.getMaxBitrate());
                        for (var i = 0; (i < _super.prototype.getEncodingCount.call(this)); i++) {
                            var num10 = fm.liveswitch.MathAssistant.pow((1 / fm.liveswitch.MathAssistant.pow(2, i)), 0.75);
                            var config2 = new fm.liveswitch.VideoEncodingConfig();
                            config2.setBitrate(fm.liveswitch.MathAssistant.ceil((preferredBitrate * num10)));
                            var item = config2;
                            if ((fm.liveswitch.Global.equals(degradationPreference, fm.liveswitch.VideoDegradationPreference.Balanced))) {
                                num10 = fm.liveswitch.MathAssistant.sqrt(num10);
                            }
                            if ((sourceFrameRate > 0)) {
                                if (((fm.liveswitch.Global.equals(degradationPreference, fm.liveswitch.VideoDegradationPreference.FrameRate)) || (fm.liveswitch.Global.equals(degradationPreference, fm.liveswitch.VideoDegradationPreference.Balanced)))) {
                                    item.setFrameRate((sourceFrameRate * num10));
                                }
                                else {
                                    item.setFrameRate(sourceFrameRate);
                                }
                            }
                            if (((fm.liveswitch.Global.equals(degradationPreference, fm.liveswitch.VideoDegradationPreference.Resolution)) || (fm.liveswitch.Global.equals(degradationPreference, fm.liveswitch.VideoDegradationPreference.Balanced)))) {
                                item.setScale(fm.liveswitch.MathAssistant.sqrt(num10));
                            }
                            else {
                                item.setScale(1);
                            }
                            if ((item.getBitrate() >= format.getMinBitrate())) {
                                fm.liveswitch.ArrayExtensions.add(list, item);
                            }
                        }
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            VideoSimulcastConfig.prototype.setBitsPerPixel = function (value) {
                if (arguments.length == 1) {
                    if ((value < 0)) {
                        throw new fm.liveswitch.Exception("Bits-per-pixel must be a greater than or equal to zero.");
                    }
                    this.__bitsPerPixel = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            VideoSimulcastConfig.prototype.setDegradationPreference = function (value) {
                if (arguments.length == 1) {
                    this._degradationPreference = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return VideoSimulcastConfig;
        }(fm.liveswitch.SimulcastConfig));
        liveswitch.VideoSimulcastConfig = VideoSimulcastConfig;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../AudioFormat.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var g722;
        (function (g722) {
            /**
            A G.722 format.
            */
            var Format = /** @class */ (function (_super) {
                __extends(Format, _super);
                function Format() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        // chained constructor: Format.call(this, fm.liveswitch.g722.Format.getDefaultConfig());
                        __arguments = new Array(1);
                        __arguments[0] = fm.liveswitch.g722.Format.getDefaultConfig();
                        {
                            var config = __arguments[0];
                            // chained constructor: Format.call(this, config.getClockRate(), config.getChannelCount());
                            __arguments = new Array(2);
                            __arguments[0] = config.getClockRate();
                            __arguments[1] = config.getChannelCount();
                            {
                                var clockRate = __arguments[0];
                                var channelCount = __arguments[1];
                                _this = _super.call(this, fm.liveswitch.AudioFormat.getG722Name(), clockRate, channelCount) || this;
                                _super.prototype.setIsFixedBitrate.call(_this, true);
                                _super.prototype.setStaticPayloadType.call(_this, 9);
                            }
                        }
                    }
                    else if (__arguments.length == 2) {
                        var clockRate = __arguments[0];
                        var channelCount = __arguments[1];
                        _this = _super.call(this, fm.liveswitch.AudioFormat.getG722Name(), clockRate, channelCount) || this;
                        _super.prototype.setIsFixedBitrate.call(_this, true);
                        _super.prototype.setStaticPayloadType.call(_this, 9);
                    }
                    else if (__arguments.length == 1) {
                        var config = __arguments[0];
                        // chained constructor: Format.call(this, config.getClockRate(), config.getChannelCount());
                        __arguments = new Array(2);
                        __arguments[0] = config.getClockRate();
                        __arguments[1] = config.getChannelCount();
                        {
                            var clockRate = __arguments[0];
                            var channelCount = __arguments[1];
                            _this = _super.call(this, fm.liveswitch.AudioFormat.getG722Name(), clockRate, channelCount) || this;
                            _super.prototype.setIsFixedBitrate.call(_this, true);
                            _super.prototype.setStaticPayloadType.call(_this, 9);
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                Format.prototype.getTypeString = function () {
                    return '[fm.liveswitch.g722.Format]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Gets the default clock rate (1).
                */
                Format.getDefaultChannelCount = function () {
                    if (arguments.length == 0) {
                        return 1;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the default clock rate (16000).
                */
                Format.getDefaultClockRate = function () {
                    if (arguments.length == 0) {
                        return 16000;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the default configuration (16000/1).
                */
                Format.getDefaultConfig = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.AudioConfig(fm.liveswitch.g722.Format.getDefaultClockRate(), fm.liveswitch.g722.Format.getDefaultChannelCount());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Creates a new instance.
                */
                Format.prototype.createInstance = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.g722.Format();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Format.prototype.getFixedBitrate = function () {
                    if (arguments.length == 0) {
                        return 64;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the maximum bitrate supported by this format, in kbps.
                */
                Format.prototype.getMaxBitrate = function () {
                    if (arguments.length == 0) {
                        return this.getFixedBitrate();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the minimum bitrate supported by this format, in kbps.
                */
                Format.prototype.getMinBitrate = function () {
                    if (arguments.length == 0) {
                        return this.getFixedBitrate();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Format;
            }(fm.liveswitch.AudioFormat));
            g722.Format = Format;
        })(g722 = liveswitch.g722 || (liveswitch.g722 = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var CcmLrrPolicyWrapper = /** @class */ (function () {
            function CcmLrrPolicyWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_41 = __arguments[0];
                    //super();
                    this._value = value_41;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            CcmLrrPolicyWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.CcmLrrPolicyWrapper]';
            };
            CcmLrrPolicyWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.CcmLrrPolicy.Disabled)
                        return 'Disabled';
                    if (this._value == fm.liveswitch.CcmLrrPolicy.Negotiated)
                        return 'Negotiated';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return CcmLrrPolicyWrapper;
        }());
        liveswitch.CcmLrrPolicyWrapper = CcmLrrPolicyWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var DataMessage = /** @class */ (function () {
            function DataMessage() {
                fm.liveswitch.DataMessage.fmliveswitchDataMessageInitialize();
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.DataBuffer]'))) {
                    var messageBytes = __arguments[0];
                    //super();
                    this.__elements = new Array();
                    this.setDataBytes(messageBytes);
                }
                else if (__arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                    var messageString = __arguments[0];
                    //super();
                    this.__elements = new Array();
                    this.setDataString(messageString);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            DataMessage.prototype.getTypeString = function () {
                return '[fm.liveswitch.DataMessage]';
            };
            /** @hidden */
            DataMessage.parseBytes = function (buffer) {
                fm.liveswitch.DataMessage.fmliveswitchDataMessageInitialize();
                if (arguments.length == 1) {
                    var num = buffer.read4(0, 0);
                    if ((!fm.liveswitch.Global.equals(num, 1))) {
                        fm.liveswitch.DataMessage.fm_liveswitch_DataMessage___log.error(fm.liveswitch.StringExtensions.format("Cannot parse Liveswitch Data Message of version {0}", fm.liveswitch.NumberExtensions.toString(num)));
                        return null;
                    }
                    var num2 = buffer.read4(0, 4);
                    var offset = buffer.read16(2);
                    var num4 = 0;
                    var list = null;
                    if ((offset > 0)) {
                        list = new Array();
                        var offsetPlus = -1;
                        var item = null;
                        while (((num4 + 4) < offset)) {
                            var _var0 = new fm.liveswitch.Holder(offsetPlus);
                            var _var1 = fm.liveswitch.datamessageheader.Element.parseBytes(buffer, (4 + num4), _var0);
                            offsetPlus = _var0.getValue();
                            item = _var1;
                            num4 = (num4 + offsetPlus);
                            if (((num4 + 4) > offset)) {
                                var num6 = (num4 + 4);
                                fm.liveswitch.DataMessage.fm_liveswitch_DataMessage___log.error(fm.liveswitch.StringExtensions.format("Could not parse Data Message. Header length declared to have {0} bytes, while {1} bytes of header length were read.", fm.liveswitch.NumberExtensions.toString(offset), fm.liveswitch.NumberExtensions.toString(num6)));
                                return null;
                            }
                            if ((!fm.liveswitch.Global.equals(item, null))) {
                                fm.liveswitch.ArrayExtensions.add(list, item);
                            }
                        }
                    }
                    var message = null;
                    var _var2 = num2;
                    if (_var2 == 0) {
                        do {
                            message = new fm.liveswitch.DataMessage(buffer.subset(offset));
                            break;
                        } while (false);
                    }
                    else if (_var2 == 1) {
                        do {
                            message = new fm.liveswitch.DataMessage(buffer.readUtf8String(offset));
                            break;
                        } while (false);
                    }
                    else {
                        do {
                            fm.liveswitch.Log.error(fm.liveswitch.StringExtensions.format("Received a data message with an unknown payload {0}. Will not parse.", fm.liveswitch.NumberExtensions.toString(num2)));
                            return null;
                        } while (false);
                    }
                    if ((!fm.liveswitch.Global.equals(list, null))) {
                        message.setElements(fm.liveswitch.ArrayExtensions.toArray(list));
                    }
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataMessage.prototype.getBytes = function () {
                if (arguments.length == 0) {
                    var element = void 0;
                    var size = 4;
                    var bytes = null;
                    var num2 = 4;
                    if ((!fm.liveswitch.Global.equals(this.getDataBytes(), null))) {
                        size = (size + this.getDataBytes().getLength());
                    }
                    else {
                        if ((!fm.liveswitch.Global.equals(this.getDataString(), null))) {
                            bytes = fm.liveswitch.Utf8.encode(this.getDataString());
                            size = (size + bytes.length);
                        }
                    }
                    var index = 0;
                    while ((index < this.getElements().length)) {
                        element = this.getElements()[index];
                        size = (size + element.getLength());
                        num2 = (num2 + element.getLength());
                        index++;
                    }
                    var buffer2 = null;
                    if (fm.liveswitch.DataBufferPool.getIsSupported()) {
                        buffer2 = fm.liveswitch.DataMessage.fm_liveswitch_DataMessage___dataBufferPool.take(size);
                    }
                    else {
                        buffer2 = fm.liveswitch.DataBuffer.allocate(size);
                    }
                    buffer2.write4(1, 0, 0);
                    if ((!fm.liveswitch.Global.equals(this.getDataString(), null))) {
                        buffer2.write4(1, 0, 4);
                    }
                    else {
                        if ((!fm.liveswitch.Global.equals(this.getDataBytes(), null))) {
                            buffer2.write4(0, 0, 4);
                        }
                    }
                    buffer2.write8(0, 1);
                    buffer2.write16(num2, 2);
                    var offset = 4;
                    for (index = 0; (index < this.getElements().length); index++) {
                        element = this.getElements()[index];
                        var length_44 = element.getLength();
                        buffer2.write(element.getBytes(), offset);
                        offset = (offset + length_44);
                    }
                    if ((!fm.liveswitch.Global.equals(bytes, null))) {
                        buffer2.writeBytes(bytes, offset);
                        return buffer2;
                    }
                    if ((!fm.liveswitch.Global.equals(this.getDataBytes(), null))) {
                        buffer2.write(this.getDataBytes(), offset);
                    }
                    return buffer2;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataMessage.prototype.getDataBytes = function () {
                if (arguments.length == 0) {
                    return this._dataBytes;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            DataMessage.prototype.getDataString = function () {
                if (arguments.length == 0) {
                    return this._dataString;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataMessage.prototype.getElements = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ArrayExtensions.toArray(this.__elements);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataMessage.prototype.getNumberOfRetransmissions = function () {
                if (arguments.length == 0) {
                    for (var _i = 0, _a = this.getElements(); _i < _a.length; _i++) {
                        var element = _a[_i];
                        if ((fm.liveswitch.Global.equals(element.getType(), fm.liveswitch.datamessageheader.Type.getDeliveryAttempts()))) {
                            return element.getDeliveryAttempts();
                        }
                    }
                    return -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataMessage.prototype.getRemoteConnectionId = function () {
                if (arguments.length == 0) {
                    for (var _i = 0, _a = this.getElements(); _i < _a.length; _i++) {
                        var element = _a[_i];
                        if ((fm.liveswitch.Global.equals(element.getType(), fm.liveswitch.datamessageheader.Type.getConnectionId()))) {
                            return element.getConnectionId();
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataMessage.prototype.getTimeToLive = function () {
                if (arguments.length == 0) {
                    for (var _i = 0, _a = this.getElements(); _i < _a.length; _i++) {
                        var element = _a[_i];
                        if ((fm.liveswitch.Global.equals(element.getType(), fm.liveswitch.datamessageheader.Type.getTimeToLive()))) {
                            return element.getTimeToLive();
                        }
                    }
                    return -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataMessage.prototype.getVersion = function () {
                if (arguments.length == 0) {
                    return 1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataMessage.prototype.setDataBytes = function (value) {
                if (arguments.length == 1) {
                    this._dataBytes = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataMessage.prototype.setDataString = function (value) {
                if (arguments.length == 1) {
                    this._dataString = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataMessage.prototype.setElements = function (value) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(value, null))) {
                        fm.liveswitch.ArrayExtensions.addRange(this.__elements, value);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataMessage.prototype.setNumberOfRetransmissions = function (value) {
                if (arguments.length == 1) {
                    for (var _i = 0, _a = this.getElements(); _i < _a.length; _i++) {
                        var element = _a[_i];
                        if ((fm.liveswitch.Global.equals(element.getType(), fm.liveswitch.datamessageheader.Type.getDeliveryAttempts()))) {
                            fm.liveswitch.ArrayExtensions.remove(this.__elements, element);
                        }
                    }
                    fm.liveswitch.ArrayExtensions.add(this.__elements, new fm.liveswitch.datamessageheader.DeliveryAttemptsElement(value));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataMessage.prototype.setRemoteConnectionId = function (value) {
                if (arguments.length == 1) {
                    for (var _i = 0, _a = this.getElements(); _i < _a.length; _i++) {
                        var element = _a[_i];
                        if ((fm.liveswitch.Global.equals(element.getType(), fm.liveswitch.datamessageheader.Type.getConnectionId()))) {
                            fm.liveswitch.ArrayExtensions.remove(this.__elements, element);
                        }
                    }
                    fm.liveswitch.ArrayExtensions.add(this.__elements, new fm.liveswitch.datamessageheader.ConnectionIdElement(value));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataMessage.prototype.setTimeToLive = function (value) {
                if (arguments.length == 1) {
                    for (var _i = 0, _a = this.getElements(); _i < _a.length; _i++) {
                        var element = _a[_i];
                        if ((fm.liveswitch.Global.equals(element.getType(), fm.liveswitch.datamessageheader.Type.getTimeToLive()))) {
                            fm.liveswitch.ArrayExtensions.remove(this.__elements, element);
                        }
                    }
                    fm.liveswitch.ArrayExtensions.add(this.__elements, new fm.liveswitch.datamessageheader.TimeToLiveElement(value));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataMessage.fmliveswitchDataMessageInitialize = function () {
                if (!fm.liveswitch.DataMessage.__fmliveswitchDataMessageInitialized && !fm.liveswitch.DataMessage.__fmliveswitchDataMessageInitializing) {
                    fm.liveswitch.DataMessage.__fmliveswitchDataMessageInitializing = true;
                    fm.liveswitch.DataMessage.fm_liveswitch_DataMessage___dataBufferPool = fm.liveswitch.DataBufferPool.getTracer(new fm.liveswitch.Type('[fm.liveswitch.DataMessage]'));
                    fm.liveswitch.DataMessage.fm_liveswitch_DataMessage___log = fm.liveswitch.Log.getLogger(new fm.liveswitch.Type('[fm.liveswitch.DataMessage]'));
                    fm.liveswitch.DataMessage.__fmliveswitchDataMessageInitialized = true;
                    fm.liveswitch.DataMessage.__fmliveswitchDataMessageInitializing = false;
                }
            };
            /** @hidden */
            DataMessage.IntUnset = -1;
            /** @hidden */
            DataMessage.__fmliveswitchDataMessageInitialized = false;
            /** @hidden */
            DataMessage.__fmliveswitchDataMessageInitializing = false;
            return DataMessage;
        }());
        liveswitch.DataMessage = DataMessage;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var datamessageheader;
        (function (datamessageheader) {
            /** @hidden */
            var Element = /** @class */ (function () {
                function Element() {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        //super();
                        this.fmliveswitchdatamessageheaderElementInit();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                Element.prototype.getTypeString = function () {
                    return '[fm.liveswitch.datamessageheader.Element]';
                };
                Element.prototype.fmliveswitchdatamessageheaderElementInit = function () {
                    this._type = 0;
                };
                Element.parseBytes = function (buffer, offset, offsetPlus) {
                    if (arguments.length == 3) {
                        var num = buffer.read8(offset);
                        if ((fm.liveswitch.Global.equals(num, fm.liveswitch.datamessageheader.Type.getTimeToLive()))) {
                            var _var0 = fm.liveswitch.datamessageheader.TimeToLiveElement.doParseBytes(buffer, offset, offsetPlus);
                            return _var0;
                        }
                        if ((fm.liveswitch.Global.equals(num, fm.liveswitch.datamessageheader.Type.getDeliveryAttempts()))) {
                            var _var1 = fm.liveswitch.datamessageheader.DeliveryAttemptsElement.doParseBytes(buffer, offset, offsetPlus);
                            return _var1;
                        }
                        if ((fm.liveswitch.Global.equals(num, fm.liveswitch.datamessageheader.Type.getConnectionId()))) {
                            var _var2 = fm.liveswitch.datamessageheader.ConnectionIdElement.doParseBytes(buffer, offset, offsetPlus);
                            return _var2;
                        }
                        var _var3 = fm.liveswitch.datamessageheader.UnknownElement.doParseBytes(buffer, offset, offsetPlus);
                        return _var3;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Element.prototype.getType = function () {
                    if (arguments.length == 0) {
                        return this._type;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Element.prototype.setType = function (value) {
                    if (arguments.length == 1) {
                        this._type = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Element;
            }());
            datamessageheader.Element = Element;
        })(datamessageheader = liveswitch.datamessageheader || (liveswitch.datamessageheader = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../datamessageheader/Element.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var datamessageheader;
        (function (datamessageheader) {
            /** @hidden */
            var DeliveryAttemptsElement = /** @class */ (function (_super) {
                __extends(DeliveryAttemptsElement, _super);
                function DeliveryAttemptsElement(numAttempts) {
                    var _this = this;
                    fm.liveswitch.datamessageheader.DeliveryAttemptsElement.fmliveswitchdatamessageheaderDeliveryAttemptsElementInitialize();
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var numAttempts_1 = __arguments[0];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchdatamessageheaderDeliveryAttemptsElementInit();
                        _super.prototype.setType.call(_this, fm.liveswitch.datamessageheader.Type.getDeliveryAttempts());
                        _this.setDeliveryAttempts(numAttempts_1);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                DeliveryAttemptsElement.prototype.getTypeString = function () {
                    return '[fm.liveswitch.datamessageheader.DeliveryAttemptsElement]' + ',' + _super.prototype.getTypeString.call(this);
                };
                DeliveryAttemptsElement.prototype.fmliveswitchdatamessageheaderDeliveryAttemptsElementInit = function () {
                    this._deliveryAttempts = 0;
                };
                /** @hidden */
                DeliveryAttemptsElement.doParseBytes = function (buffer, index, offsetPlus) {
                    fm.liveswitch.datamessageheader.DeliveryAttemptsElement.fmliveswitchdatamessageheaderDeliveryAttemptsElementInitialize();
                    if (arguments.length == 3) {
                        offsetPlus.setValue(5);
                        return new fm.liveswitch.datamessageheader.DeliveryAttemptsElement(buffer.read16((index + 3)));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                DeliveryAttemptsElement.prototype.getBytes = function () {
                    if (arguments.length == 0) {
                        var buffer = fm.liveswitch.datamessageheader.DeliveryAttemptsElement.fm_liveswitch_datamessageheader_DeliveryAttemptsElement___dataBufferPool.take(this.getLength());
                        buffer.write8(_super.prototype.getType.call(this), 0);
                        buffer.write16(this.getLength(), 1);
                        buffer.write16(this.getDeliveryAttempts(), 3);
                        return buffer;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                DeliveryAttemptsElement.prototype.getDeliveryAttempts = function () {
                    if (arguments.length == 0) {
                        return this._deliveryAttempts;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                DeliveryAttemptsElement.prototype.getLength = function () {
                    if (arguments.length == 0) {
                        return 5;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                DeliveryAttemptsElement.prototype.setDeliveryAttempts = function (value) {
                    if (arguments.length == 1) {
                        this._deliveryAttempts = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                DeliveryAttemptsElement.fmliveswitchdatamessageheaderDeliveryAttemptsElementInitialize = function () {
                    if (!fm.liveswitch.datamessageheader.DeliveryAttemptsElement.__fmliveswitchdatamessageheaderDeliveryAttemptsElementInitialized && !fm.liveswitch.datamessageheader.DeliveryAttemptsElement.__fmliveswitchdatamessageheaderDeliveryAttemptsElementInitializing) {
                        fm.liveswitch.datamessageheader.DeliveryAttemptsElement.__fmliveswitchdatamessageheaderDeliveryAttemptsElementInitializing = true;
                        fm.liveswitch.datamessageheader.DeliveryAttemptsElement.fm_liveswitch_datamessageheader_DeliveryAttemptsElement___dataBufferPool = fm.liveswitch.DataBufferPool.getTracer(new fm.liveswitch.Type('[fm.liveswitch.datamessageheader.DeliveryAttemptsElement]'));
                        fm.liveswitch.datamessageheader.DeliveryAttemptsElement.__fmliveswitchdatamessageheaderDeliveryAttemptsElementInitialized = true;
                        fm.liveswitch.datamessageheader.DeliveryAttemptsElement.__fmliveswitchdatamessageheaderDeliveryAttemptsElementInitializing = false;
                    }
                };
                /** @hidden */
                DeliveryAttemptsElement.__fmliveswitchdatamessageheaderDeliveryAttemptsElementInitialized = false;
                /** @hidden */
                DeliveryAttemptsElement.__fmliveswitchdatamessageheaderDeliveryAttemptsElementInitializing = false;
                return DeliveryAttemptsElement;
            }(fm.liveswitch.datamessageheader.Element));
            datamessageheader.DeliveryAttemptsElement = DeliveryAttemptsElement;
        })(datamessageheader = liveswitch.datamessageheader || (liveswitch.datamessageheader = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../datamessageheader/Element.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var datamessageheader;
        (function (datamessageheader) {
            /** @hidden */
            var ConnectionIdElement = /** @class */ (function (_super) {
                __extends(ConnectionIdElement, _super);
                function ConnectionIdElement(idValue) {
                    var _this = this;
                    fm.liveswitch.datamessageheader.ConnectionIdElement.fmliveswitchdatamessageheaderConnectionIdElementInitialize();
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var idValue_7 = __arguments[0];
                        _this = _super.call(this) || this;
                        _super.prototype.setType.call(_this, fm.liveswitch.datamessageheader.Type.getConnectionId());
                        _this.setConnectionId(idValue_7);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ConnectionIdElement.prototype.getTypeString = function () {
                    return '[fm.liveswitch.datamessageheader.ConnectionIdElement]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /** @hidden */
                ConnectionIdElement.doParseBytes = function (buffer, index, offsetPlus) {
                    fm.liveswitch.datamessageheader.ConnectionIdElement.fmliveswitchdatamessageheaderConnectionIdElementInitialize();
                    if (arguments.length == 3) {
                        offsetPlus.setValue(buffer.read16((index + 1)));
                        return new fm.liveswitch.datamessageheader.ConnectionIdElement(buffer.readUtf8String((index + 3), (offsetPlus.getValue() - 3)));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ConnectionIdElement.prototype.getBytes = function () {
                    if (arguments.length == 0) {
                        var buffer = fm.liveswitch.datamessageheader.ConnectionIdElement.fm_liveswitch_datamessageheader_ConnectionIdElement___dataBufferPool.take(this.getLength());
                        buffer.write8(_super.prototype.getType.call(this), 0);
                        buffer.write16(this.getLength(), 1);
                        buffer.write(fm.liveswitch.DataBuffer.wrap(this.__connectionId), 3);
                        return buffer;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ConnectionIdElement.prototype.getConnectionId = function () {
                    if (arguments.length == 0) {
                        if ((!fm.liveswitch.Global.equals(this.__connectionId, null))) {
                            return fm.liveswitch.Encoding.getUtf8().getString(this.__connectionId);
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ConnectionIdElement.prototype.getLength = function () {
                    if (arguments.length == 0) {
                        return ((!fm.liveswitch.Global.equals(this.__connectionId, null)) ? (this.__connectionId.length + 3) : 3);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                ConnectionIdElement.prototype.setConnectionId = function (value) {
                    if (arguments.length == 1) {
                        this.__connectionId = fm.liveswitch.Utf8.encode(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                ConnectionIdElement.fmliveswitchdatamessageheaderConnectionIdElementInitialize = function () {
                    if (!fm.liveswitch.datamessageheader.ConnectionIdElement.__fmliveswitchdatamessageheaderConnectionIdElementInitialized && !fm.liveswitch.datamessageheader.ConnectionIdElement.__fmliveswitchdatamessageheaderConnectionIdElementInitializing) {
                        fm.liveswitch.datamessageheader.ConnectionIdElement.__fmliveswitchdatamessageheaderConnectionIdElementInitializing = true;
                        fm.liveswitch.datamessageheader.ConnectionIdElement.fm_liveswitch_datamessageheader_ConnectionIdElement___dataBufferPool = fm.liveswitch.DataBufferPool.getTracer(new fm.liveswitch.Type('[fm.liveswitch.datamessageheader.ConnectionIdElement]'));
                        fm.liveswitch.datamessageheader.ConnectionIdElement.__fmliveswitchdatamessageheaderConnectionIdElementInitialized = true;
                        fm.liveswitch.datamessageheader.ConnectionIdElement.__fmliveswitchdatamessageheaderConnectionIdElementInitializing = false;
                    }
                };
                /** @hidden */
                ConnectionIdElement.__fmliveswitchdatamessageheaderConnectionIdElementInitialized = false;
                /** @hidden */
                ConnectionIdElement.__fmliveswitchdatamessageheaderConnectionIdElementInitializing = false;
                return ConnectionIdElement;
            }(fm.liveswitch.datamessageheader.Element));
            datamessageheader.ConnectionIdElement = ConnectionIdElement;
        })(datamessageheader = liveswitch.datamessageheader || (liveswitch.datamessageheader = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../datamessageheader/Element.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var datamessageheader;
        (function (datamessageheader) {
            /** @hidden */
            var TimeToLiveElement = /** @class */ (function (_super) {
                __extends(TimeToLiveElement, _super);
                function TimeToLiveElement(ttl) {
                    var _this = this;
                    fm.liveswitch.datamessageheader.TimeToLiveElement.fmliveswitchdatamessageheaderTimeToLiveElementInitialize();
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var ttl_1 = __arguments[0];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchdatamessageheaderTimeToLiveElementInit();
                        _super.prototype.setType.call(_this, fm.liveswitch.datamessageheader.Type.getTimeToLive());
                        _this.setTimeToLive(ttl_1);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                TimeToLiveElement.prototype.getTypeString = function () {
                    return '[fm.liveswitch.datamessageheader.TimeToLiveElement]' + ',' + _super.prototype.getTypeString.call(this);
                };
                TimeToLiveElement.prototype.fmliveswitchdatamessageheaderTimeToLiveElementInit = function () {
                    this._timeToLive = 0;
                };
                /** @hidden */
                TimeToLiveElement.doParseBytes = function (buffer, index, offsetPlus) {
                    fm.liveswitch.datamessageheader.TimeToLiveElement.fmliveswitchdatamessageheaderTimeToLiveElementInitialize();
                    if (arguments.length == 3) {
                        offsetPlus.setValue(7);
                        return new fm.liveswitch.datamessageheader.TimeToLiveElement(buffer.read32((index + 3)));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                TimeToLiveElement.prototype.getBytes = function () {
                    if (arguments.length == 0) {
                        var buffer = fm.liveswitch.datamessageheader.TimeToLiveElement.fm_liveswitch_datamessageheader_TimeToLiveElement___dataBufferPool.take(this.getLength());
                        buffer.write8(_super.prototype.getType.call(this), 0);
                        buffer.write16(this.getLength(), 1);
                        buffer.write32(this.getTimeToLive(), 3);
                        return buffer;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                TimeToLiveElement.prototype.getLength = function () {
                    if (arguments.length == 0) {
                        return 7;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                TimeToLiveElement.prototype.getTimeToLive = function () {
                    if (arguments.length == 0) {
                        return this._timeToLive;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                TimeToLiveElement.prototype.setTimeToLive = function (value) {
                    if (arguments.length == 1) {
                        this._timeToLive = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                TimeToLiveElement.fmliveswitchdatamessageheaderTimeToLiveElementInitialize = function () {
                    if (!fm.liveswitch.datamessageheader.TimeToLiveElement.__fmliveswitchdatamessageheaderTimeToLiveElementInitialized && !fm.liveswitch.datamessageheader.TimeToLiveElement.__fmliveswitchdatamessageheaderTimeToLiveElementInitializing) {
                        fm.liveswitch.datamessageheader.TimeToLiveElement.__fmliveswitchdatamessageheaderTimeToLiveElementInitializing = true;
                        fm.liveswitch.datamessageheader.TimeToLiveElement.fm_liveswitch_datamessageheader_TimeToLiveElement___dataBufferPool = fm.liveswitch.DataBufferPool.getTracer(new fm.liveswitch.Type('[fm.liveswitch.datamessageheader.TimeToLiveElement]'));
                        fm.liveswitch.datamessageheader.TimeToLiveElement.__fmliveswitchdatamessageheaderTimeToLiveElementInitialized = true;
                        fm.liveswitch.datamessageheader.TimeToLiveElement.__fmliveswitchdatamessageheaderTimeToLiveElementInitializing = false;
                    }
                };
                /** @hidden */
                TimeToLiveElement.__fmliveswitchdatamessageheaderTimeToLiveElementInitialized = false;
                /** @hidden */
                TimeToLiveElement.__fmliveswitchdatamessageheaderTimeToLiveElementInitializing = false;
                return TimeToLiveElement;
            }(fm.liveswitch.datamessageheader.Element));
            datamessageheader.TimeToLiveElement = TimeToLiveElement;
        })(datamessageheader = liveswitch.datamessageheader || (liveswitch.datamessageheader = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var datamessageheader;
        (function (datamessageheader) {
            /** @hidden */
            var Type = /** @class */ (function () {
                function Type() {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        //super();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                Type.prototype.getTypeString = function () {
                    return '[fm.liveswitch.datamessageheader.Type]';
                };
                Type.getConnectionId = function () {
                    if (arguments.length == 0) {
                        return 3;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Type.getDeliveryAttempts = function () {
                    if (arguments.length == 0) {
                        return 2;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Type.getTimeToLive = function () {
                    if (arguments.length == 0) {
                        return 1;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Type;
            }());
            datamessageheader.Type = Type;
        })(datamessageheader = liveswitch.datamessageheader || (liveswitch.datamessageheader = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../datamessageheader/Element.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var datamessageheader;
        (function (datamessageheader) {
            /** @hidden */
            var UnknownElement = /** @class */ (function (_super) {
                __extends(UnknownElement, _super);
                function UnknownElement(type, payload) {
                    var _this = this;
                    fm.liveswitch.datamessageheader.UnknownElement.fmliveswitchdatamessageheaderUnknownElementInitialize();
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 2) {
                        var type_7 = __arguments[0];
                        var payload_1 = __arguments[1];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchdatamessageheaderUnknownElementInit();
                        _super.prototype.setType.call(_this, type_7);
                        _this.setPayload(payload_1);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                UnknownElement.prototype.getTypeString = function () {
                    return '[fm.liveswitch.datamessageheader.UnknownElement]' + ',' + _super.prototype.getTypeString.call(this);
                };
                UnknownElement.prototype.fmliveswitchdatamessageheaderUnknownElementInit = function () {
                    this.__length = 0;
                };
                /** @hidden */
                UnknownElement.doParseBytes = function (buffer, index, offsetPlus) {
                    fm.liveswitch.datamessageheader.UnknownElement.fmliveswitchdatamessageheaderUnknownElementInitialize();
                    if (arguments.length == 3) {
                        var num = buffer.read8(index);
                        offsetPlus.setValue(buffer.read16((index + 1)));
                        return new fm.liveswitch.datamessageheader.UnknownElement(num, buffer.subset((index + 3), (offsetPlus.getValue() - 3)));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnknownElement.prototype.getBytes = function () {
                    if (arguments.length == 0) {
                        var buffer = fm.liveswitch.datamessageheader.UnknownElement.fm_liveswitch_datamessageheader_UnknownElement___dataBufferPool.take(this.getLength());
                        buffer.write8(_super.prototype.getType.call(this), 0);
                        buffer.write16(this.getLength(), 1);
                        buffer.write(this.getPayload(), 3);
                        return buffer;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnknownElement.prototype.getLength = function () {
                    if (arguments.length == 0) {
                        return this.__length;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                UnknownElement.prototype.getPayload = function () {
                    if (arguments.length == 0) {
                        return this.__payload;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                UnknownElement.prototype.setPayload = function (value) {
                    if (arguments.length == 1) {
                        this.__payload = value;
                        this.__length = (this.__payload.getLength() + 3);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                UnknownElement.fmliveswitchdatamessageheaderUnknownElementInitialize = function () {
                    if (!fm.liveswitch.datamessageheader.UnknownElement.__fmliveswitchdatamessageheaderUnknownElementInitialized && !fm.liveswitch.datamessageheader.UnknownElement.__fmliveswitchdatamessageheaderUnknownElementInitializing) {
                        fm.liveswitch.datamessageheader.UnknownElement.__fmliveswitchdatamessageheaderUnknownElementInitializing = true;
                        fm.liveswitch.datamessageheader.UnknownElement.fm_liveswitch_datamessageheader_UnknownElement___dataBufferPool = fm.liveswitch.DataBufferPool.getTracer(new fm.liveswitch.Type('[fm.liveswitch.datamessageheader.UnknownElement]'));
                        fm.liveswitch.datamessageheader.UnknownElement.__fmliveswitchdatamessageheaderUnknownElementInitialized = true;
                        fm.liveswitch.datamessageheader.UnknownElement.__fmliveswitchdatamessageheaderUnknownElementInitializing = false;
                    }
                };
                /** @hidden */
                UnknownElement.__fmliveswitchdatamessageheaderUnknownElementInitialized = false;
                /** @hidden */
                UnknownElement.__fmliveswitchdatamessageheaderUnknownElementInitializing = false;
                return UnknownElement;
            }(fm.liveswitch.datamessageheader.Element));
            datamessageheader.UnknownElement = UnknownElement;
        })(datamessageheader = liveswitch.datamessageheader || (liveswitch.datamessageheader = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var CcmFirPolicyWrapper = /** @class */ (function () {
            function CcmFirPolicyWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_42 = __arguments[0];
                    //super();
                    this._value = value_42;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            CcmFirPolicyWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.CcmFirPolicyWrapper]';
            };
            CcmFirPolicyWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.CcmFirPolicy.Disabled)
                        return 'Disabled';
                    if (this._value == fm.liveswitch.CcmFirPolicy.Negotiated)
                        return 'Negotiated';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return CcmFirPolicyWrapper;
        }());
        liveswitch.CcmFirPolicyWrapper = CcmFirPolicyWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var NackPliPolicyWrapper = /** @class */ (function () {
            function NackPliPolicyWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_43 = __arguments[0];
                    //super();
                    this._value = value_43;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            NackPliPolicyWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.NackPliPolicyWrapper]';
            };
            NackPliPolicyWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.NackPliPolicy.Disabled)
                        return 'Disabled';
                    if (this._value == fm.liveswitch.NackPliPolicy.Negotiated)
                        return 'Negotiated';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return NackPliPolicyWrapper;
        }());
        liveswitch.NackPliPolicyWrapper = NackPliPolicyWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var SessionDescriptionStreamMatcher = /** @class */ (function () {
            function SessionDescriptionStreamMatcher(numStreams) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var numStreams_1 = __arguments[0];
                    //super();
                    this.__offererAudioStreamIndex = new Array();
                    this.__offererVideoStreamIndex = new Array();
                    this.__offererDataStreamIndex = new Array();
                    this.__internalAudioStreamIndex = new Array();
                    this.__internalVideoStreamIndex = new Array();
                    this.__internalDataStreamIndex = new Array();
                    this.reset(numStreams_1);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            SessionDescriptionStreamMatcher.prototype.getTypeString = function () {
                return '[fm.liveswitch.SessionDescriptionStreamMatcher]';
            };
            SessionDescriptionStreamMatcher.prototype.getInternalStreamIndexFor = function (oferrerStreamIndex) {
                if (arguments.length == 1) {
                    if ((this.__internalStreamIndexByOfferIndex.length > oferrerStreamIndex)) {
                        return this.__internalStreamIndexByOfferIndex[oferrerStreamIndex];
                    }
                    return -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SessionDescriptionStreamMatcher.prototype.getInternalStreamMediaIndexForStream = function (type, indexInType) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(type, fm.liveswitch.StreamType.Audio))) {
                        return this.__internalAudioStreamIndex[indexInType];
                    }
                    if ((fm.liveswitch.Global.equals(type, fm.liveswitch.StreamType.Video))) {
                        return this.__internalVideoStreamIndex[indexInType];
                    }
                    if ((fm.liveswitch.Global.equals(type, fm.liveswitch.StreamType.Application))) {
                        return this.__internalDataStreamIndex[indexInType];
                    }
                    return -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SessionDescriptionStreamMatcher.prototype.getOffererStreamIndexFor = function (internalStreamIndex) {
                if (arguments.length == 1) {
                    if ((this.__offererStreamIndexByInternalIndex.length > internalStreamIndex)) {
                        return this.__offererStreamIndexByInternalIndex[internalStreamIndex];
                    }
                    return -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SessionDescriptionStreamMatcher.prototype.getOffererStreamMediaIndexForStream = function (type, indexInType) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(type, fm.liveswitch.StreamType.Audio))) {
                        return this.__offererAudioStreamIndex[indexInType];
                    }
                    if ((fm.liveswitch.Global.equals(type, fm.liveswitch.StreamType.Video))) {
                        return this.__offererVideoStreamIndex[indexInType];
                    }
                    if ((fm.liveswitch.Global.equals(type, fm.liveswitch.StreamType.Application))) {
                        return this.__offererDataStreamIndex[indexInType];
                    }
                    return -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SessionDescriptionStreamMatcher.prototype.populateInternalStreamTypeIndexes = function (streams) {
                if (arguments.length == 1) {
                    for (var i = 0; (i < fm.liveswitch.ArrayExtensions.getCount(streams)); i++) {
                        var local = streams[i];
                        var type = local.getType();
                        if ((fm.liveswitch.Global.equals(type, fm.liveswitch.StreamType.Audio))) {
                            fm.liveswitch.ArrayExtensions.add(this.__internalAudioStreamIndex, i);
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(type, fm.liveswitch.StreamType.Video))) {
                                fm.liveswitch.ArrayExtensions.add(this.__internalVideoStreamIndex, i);
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(type, fm.liveswitch.StreamType.Application))) {
                                    fm.liveswitch.ArrayExtensions.add(this.__internalDataStreamIndex, i);
                                }
                                else {
                                    return new fm.liveswitch.Error(fm.liveswitch.ErrorCode.ConnectionInvalidArchitecture, new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Sdp offer contains a stream of type {0}. Processing of such streams is not currently supported.", new fm.liveswitch.StreamTypeWrapper(type).toString())));
                                }
                            }
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SessionDescriptionStreamMatcher.prototype.populateOffererStreamTypeIndexes = function (sdpMediaDescriptions) {
                if (arguments.length == 1) {
                    for (var i = 0; (i < sdpMediaDescriptions.length); i++) {
                        var type = fm.liveswitch.sdp.MediaType.toStreamType(sdpMediaDescriptions[i].getMedia().getMediaType());
                        if ((fm.liveswitch.Global.equals(type, fm.liveswitch.StreamType.Audio))) {
                            fm.liveswitch.ArrayExtensions.add(this.__offererAudioStreamIndex, i);
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(type, fm.liveswitch.StreamType.Video))) {
                                fm.liveswitch.ArrayExtensions.add(this.__offererVideoStreamIndex, i);
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(type, fm.liveswitch.StreamType.Application))) {
                                    fm.liveswitch.ArrayExtensions.add(this.__offererDataStreamIndex, i);
                                }
                                else {
                                    return new fm.liveswitch.Error(fm.liveswitch.ErrorCode.ConnectionInvalidArchitecture, new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Sdp offer contains a stream of type {0}. Processing of such streams is not currently supported.", new fm.liveswitch.StreamTypeWrapper(type).toString())));
                                }
                            }
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SessionDescriptionStreamMatcher.prototype.reset = function () {
                if (arguments.length == 0) {
                    this.reset(this.__offererStreamIndexByInternalIndex.length);
                }
                else if (arguments.length == 1) {
                    var numStreams = arguments[0];
                    fm.liveswitch.ArrayExtensions.clear(this.__offererAudioStreamIndex);
                    fm.liveswitch.ArrayExtensions.clear(this.__offererVideoStreamIndex);
                    fm.liveswitch.ArrayExtensions.clear(this.__offererDataStreamIndex);
                    this.__offererStreamIndexByInternalIndex = new Array(numStreams);
                    fm.liveswitch.ArrayExtensions.clear(this.__internalAudioStreamIndex);
                    fm.liveswitch.ArrayExtensions.clear(this.__internalVideoStreamIndex);
                    fm.liveswitch.ArrayExtensions.clear(this.__internalDataStreamIndex);
                    this.__internalStreamIndexByOfferIndex = new Array(numStreams);
                    for (var i = 0; (i < numStreams); i++) {
                        this.__offererStreamIndexByInternalIndex[i] = i;
                        this.__internalStreamIndexByOfferIndex[i] = i;
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SessionDescriptionStreamMatcher.prototype.setMatchingIndexes = function (internalStreamIndex, offererStreamIndex) {
                if (arguments.length == 2) {
                    if ((this.__offererStreamIndexByInternalIndex.length <= internalStreamIndex)) {
                        throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Cannot set offerer stream index for the internal stream index {0}. Number of streams exceeded.", fm.liveswitch.NumberExtensions.toString(internalStreamIndex)));
                    }
                    this.__offererStreamIndexByInternalIndex[internalStreamIndex] = offererStreamIndex;
                    this.__internalStreamIndexByOfferIndex[offererStreamIndex] = internalStreamIndex;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return SessionDescriptionStreamMatcher;
        }());
        liveswitch.SessionDescriptionStreamMatcher = SessionDescriptionStreamMatcher;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var SimulcastModeWrapper = /** @class */ (function () {
            function SimulcastModeWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_44 = __arguments[0];
                    //super();
                    this._value = value_44;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            SimulcastModeWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.SimulcastModeWrapper]';
            };
            SimulcastModeWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.SimulcastMode.Disabled)
                        return 'Disabled';
                    if (this._value == fm.liveswitch.SimulcastMode.RtpStreamId)
                        return 'RtpStreamId';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return SimulcastModeWrapper;
        }());
        liveswitch.SimulcastModeWrapper = SimulcastModeWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var BundlePolicyWrapper = /** @class */ (function () {
            function BundlePolicyWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_45 = __arguments[0];
                    //super();
                    this._value = value_45;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            BundlePolicyWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.BundlePolicyWrapper]';
            };
            BundlePolicyWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.BundlePolicy.Balanced)
                        return 'Balanced';
                    if (this._value == fm.liveswitch.BundlePolicy.MaxCompatibility)
                        return 'MaxCompatibility';
                    if (this._value == fm.liveswitch.BundlePolicy.MaxBundle)
                        return 'MaxBundle';
                    if (this._value == fm.liveswitch.BundlePolicy.Disabled)
                        return 'Disabled';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return BundlePolicyWrapper;
        }());
        liveswitch.BundlePolicyWrapper = BundlePolicyWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A candidate.
        */
        var Candidate = /** @class */ (function () {
            function Candidate() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchCandidateInit();
                    this.__relayProtocol = fm.liveswitch.ProtocolType.Unknown;
                    this.__protocol = fm.liveswitch.ProtocolType.Unknown;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Candidate.prototype.getTypeString = function () {
                return '[fm.liveswitch.Candidate]';
            };
            Candidate.prototype.fmliveswitchCandidateInit = function () {
                this._dispatched = false;
                this._sdpMediaIndex = 0;
            };
            /**
            Deserializes an instance from JSON.
            @param candidateJson The JSON to deserialize.
            @return
                        The deserialized candidate.
                
            */
            Candidate.fromJson = function (candidateJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(candidateJson, function () {
                        return new fm.liveswitch.Candidate();
                    }, function (candidate, name, valueJson) {
                        var str2 = name;
                        if ((!fm.liveswitch.Global.equals(str2, null))) {
                            if (!(fm.liveswitch.Global.equals(str2, "sdpCandidateAttribute"))) {
                                if ((fm.liveswitch.Global.equals(str2, "sdpMediaIndex"))) {
                                    candidate.setSdpMediaIndex(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                }
                            }
                            else {
                                var s = fm.liveswitch.JsonSerializer.deserializeString(valueJson);
                                if ((!fm.liveswitch.Global.equals(s, null))) {
                                    if (!fm.liveswitch.StringExtensions.startsWith(s, "a=")) {
                                        s = fm.liveswitch.StringExtensions.concat("a=", s);
                                    }
                                    candidate.setSdpCandidateAttribute(fm.liveswitch.Global.tryCast(fm.liveswitch.sdp.Attribute.parse(s), fm.liveswitch.sdp.ice.CandidateAttribute));
                                }
                            }
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param candidate The candidate to serialize.
            @return
                        The serialized JSON.
                
            */
            Candidate.toJson = function (candidate) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(candidate, function (c, jsonObject) {
                        var sdpCandidateAttribute = candidate.getSdpCandidateAttribute();
                        if ((!fm.liveswitch.Global.equals(sdpCandidateAttribute, null))) {
                            var str = sdpCandidateAttribute.toString();
                            if (!fm.liveswitch.StringExtensions.startsWith(str, "a=")) {
                                str = fm.liveswitch.StringExtensions.concat("a=", str);
                            }
                            jsonObject["sdpCandidateAttribute"] = fm.liveswitch.JsonSerializer.serializeString(str);
                        }
                        jsonObject["sdpMediaIndex"] = fm.liveswitch.JsonSerializer.serializeInteger(candidate.getSdpMediaIndex());
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this candidate has been already been dispatched as a part of a session description.
            */
            Candidate.prototype.getDispatched = function () {
                if (arguments.length == 0) {
                    return this._dispatched;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Candidate.prototype.getProtocol = function () {
                if (arguments.length == 0) {
                    return this.__protocol;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the relay protocol, the protocol used by this candidate to communicate with the relay (TURN) server.
            */
            Candidate.prototype.getRelayProtocol = function () {
                if (arguments.length == 0) {
                    return this.__relayProtocol;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the SDP candidate attribute.
            */
            Candidate.prototype.getSdpCandidateAttribute = function () {
                if (arguments.length == 0) {
                    return this.__sdpCandidateAttribute;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media index.
            */
            Candidate.prototype.getSdpMediaIndex = function () {
                if (arguments.length == 0) {
                    return this._sdpMediaIndex;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the relay protocol, the protocol used by this candidate to communicate with the relay (TURN) server. Obsolete. Alias for [[fm.liveswitch.candidate.relayProtocol]].
            */
            Candidate.prototype.getTurnTransportProtocol = function () {
                if (arguments.length == 0) {
                    return this.getRelayProtocol();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a value indicating whether this candidate has been already been dispatched as a part of a session description.
            */
            Candidate.prototype.setDispatched = function (value) {
                if (arguments.length == 1) {
                    this._dispatched = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Candidate.prototype.setProtocol = function (value) {
                if (arguments.length == 1) {
                    this.__protocol = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the relay protocol, the protocol used by this candidate to communicate with the relay (TURN) server.
            */
            Candidate.prototype.setRelayProtocol = function (value) {
                if (arguments.length == 1) {
                    this.__relayProtocol = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the SDP candidate attribute.
            */
            Candidate.prototype.setSdpCandidateAttribute = function (value) {
                if (arguments.length == 1) {
                    this.setProtocol(fm.liveswitch.CandidateUtility.protocolTypeFromString(value.getProtocol()));
                    this.__sdpCandidateAttribute = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media index.
            */
            Candidate.prototype.setSdpMediaIndex = function (value) {
                if (arguments.length == 1) {
                    this._sdpMediaIndex = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the relay protocol, the protocol used by this candidate to communicate with the relay (TURN) server. Obsolete. Alias for [[fm.liveswitch.candidate.relayProtocol]].
            */
            Candidate.prototype.setTurnTransportProtocol = function (value) {
                if (arguments.length == 1) {
                    this.setRelayProtocol(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            Candidate.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Candidate.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Candidate;
        }());
        liveswitch.Candidate = Candidate;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A color.
        */
        var Color = /** @class */ (function () {
            /**
            Initializes a new instance of the [[fm.liveswitch.color]] class.
            @param r The red value (0-255).
            @param g The green value (0-255).
            @param b The blue value (0-255).
            */
            function Color(r, g, b) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 3) {
                    var r_1 = __arguments[0];
                    var g_1 = __arguments[1];
                    var b_1 = __arguments[2];
                    //super();
                    this.fmliveswitchColorInit();
                    this.setR(fm.liveswitch.MathAssistant.max(0, fm.liveswitch.MathAssistant.min(255, r_1)));
                    this.setG(fm.liveswitch.MathAssistant.max(0, fm.liveswitch.MathAssistant.min(255, g_1)));
                    this.setB(fm.liveswitch.MathAssistant.max(0, fm.liveswitch.MathAssistant.min(255, b_1)));
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Color.prototype.getTypeString = function () {
                return '[fm.liveswitch.Color]';
            };
            Color.prototype.fmliveswitchColorInit = function () {
                this._b = 0;
                this._g = 0;
                this._r = 0;
            };
            /**
            Creates a [[fm.liveswitch.color]] using hue, saturation, and brightness.
            @param hue The hue value (0-359).
            @param saturation The saturation value (0.0-1.0).
            @param brightness The brightness value (0.0-1.0).
            */
            Color.fromHsb = function (hue, saturation, brightness) {
                if (arguments.length == 3) {
                    hue = fm.liveswitch.MathAssistant.max(0, fm.liveswitch.MathAssistant.min(359, hue));
                    saturation = fm.liveswitch.MathAssistant.max(0, fm.liveswitch.MathAssistant.min(1, saturation));
                    brightness = fm.liveswitch.MathAssistant.max(0, fm.liveswitch.MathAssistant.min(1, brightness));
                    if ((fm.liveswitch.Global.equals(saturation, 0))) {
                        var r = ((brightness * 255) + 0.5);
                        return new fm.liveswitch.Color(r, r, r);
                    }
                    var num2 = ((hue - fm.liveswitch.MathAssistant.floor(hue)) * 6);
                    var num3 = (num2 - fm.liveswitch.MathAssistant.floor(num2));
                    var num4 = (brightness * (1 - saturation));
                    var num5 = (brightness * (1 - (saturation * num3)));
                    var num6 = (brightness * (1 - (saturation * (1 - num3))));
                    var _var0 = num2;
                    if (_var0 == 0) {
                        do {
                            return new fm.liveswitch.Color(((brightness * 255) + 0.5), ((num6 * 255) + 0.5), ((num4 * 255) + 0.5));
                        } while (false);
                    }
                    else if (_var0 == 1) {
                        do {
                            return new fm.liveswitch.Color(((num5 * 255) + 0.5), ((brightness * 255) + 0.5), ((num4 * 255) + 0.5));
                        } while (false);
                    }
                    else if (_var0 == 2) {
                        do {
                            return new fm.liveswitch.Color(((num4 * 255) + 0.5), ((brightness * 255) + 0.5), ((num6 * 255) + 0.5));
                        } while (false);
                    }
                    else if (_var0 == 3) {
                        do {
                            return new fm.liveswitch.Color(((num4 * 255) + 0.5), ((num5 * 255) + 0.5), ((brightness * 255) + 0.5));
                        } while (false);
                    }
                    else if (_var0 == 4) {
                        do {
                            return new fm.liveswitch.Color(((num6 * 255) + 0.5), ((num4 * 255) + 0.5), ((brightness * 255) + 0.5));
                        } while (false);
                    }
                    return new fm.liveswitch.Color(((brightness * 255) + 0.5), ((num4 * 255) + 0.5), ((num5 * 255) + 0.5));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a black color.
            */
            Color.getBlack = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.Color(0, 0, 0);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a blue color.
            */
            Color.getBlue = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.Color(0, 0, 255);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a cyan color.
            */
            Color.getCyan = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.Color(0, 255, 255);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a dark-blue color.
            */
            Color.getDarkBlue = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.Color(0, 0, 127);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a dark-green color.
            */
            Color.getDarkGreen = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.Color(0, 127, 0);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a dark-red color.
            */
            Color.getDarkRed = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.Color(127, 0, 0);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a gray color.
            */
            Color.getGray = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.Color(127, 127, 127);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a green color.
            */
            Color.getGreen = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.Color(0, 255, 0);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a magenta color.
            */
            Color.getMagenta = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.Color(255, 0, 255);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets an olive color.
            */
            Color.getOlive = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.Color(127, 127, 0);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a purple color.
            */
            Color.getPurple = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.Color(127, 0, 127);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a red color.
            */
            Color.getRed = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.Color(255, 0, 0);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a teal color.
            */
            Color.getTeal = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.Color(0, 127, 127);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a white color.
            */
            Color.getWhite = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.Color(255, 255, 255);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a yellow color.
            */
            Color.getYellow = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.Color(255, 255, 0);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the blue value (0-255).
            */
            Color.prototype.getB = function () {
                if (arguments.length == 0) {
                    return this._b;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the green value (0-255).
            */
            Color.prototype.getG = function () {
                if (arguments.length == 0) {
                    return this._g;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the red value (0-255).
            */
            Color.prototype.getR = function () {
                if (arguments.length == 0) {
                    return this._r;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Color.prototype.setB = function (value) {
                if (arguments.length == 1) {
                    this._b = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Color.prototype.setG = function (value) {
                if (arguments.length == 1) {
                    this._g = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Color.prototype.setR = function (value) {
                if (arguments.length == 1) {
                    this._r = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Color;
        }());
        liveswitch.Color = Color;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Collection.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var ConnectionCollection = /** @class */ (function (_super) {
            __extends(ConnectionCollection, _super);
            function ConnectionCollection() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.__lookupByExternalId = {};
                    _this.__lookupByInternalId = {};
                    _this.__lookupLock = new Object();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            ConnectionCollection.prototype.getTypeString = function () {
                return '[fm.liveswitch.ConnectionCollection]' + ',' + _super.prototype.getTypeString.call(this);
            };
            ConnectionCollection.prototype.addSuccess = function (value) {
                if (arguments.length == 1) {
                    _super.prototype.addSuccess.call(this, value);
                    this.__lookupByInternalId[value.getId()] = value;
                    var externalId = value.getExternalId();
                    if ((!fm.liveswitch.Global.equals(externalId, null))) {
                        this.__lookupByExternalId[externalId] = value;
                    }
                    value.removeOnExternalIdChange(this.processExternalIdChange.bind(this));
                    value.addOnExternalIdChange(this.processExternalIdChange.bind(this));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ConnectionCollection.prototype.arrayFromList = function (list) {
                if (arguments.length == 1) {
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ConnectionCollection.prototype.createCollection = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.ConnectionCollection();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ConnectionCollection.prototype.getByExternalId = function (idValue) {
                if (arguments.length == 1) {
                    var connection = null;
                    var _var0 = new fm.liveswitch.Holder(connection);
                    var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this.__lookupByExternalId, idValue, _var0);
                    connection = _var0.getValue();
                    if (_var1) {
                        return connection;
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ConnectionCollection.prototype.getById = function (idValue) {
                if (arguments.length == 1) {
                    var connection = null;
                    var _var0 = new fm.liveswitch.Holder(connection);
                    var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this.__lookupByInternalId, idValue, _var0);
                    connection = _var0.getValue();
                    if (_var1) {
                        return connection;
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ConnectionCollection.prototype.processExternalIdChange = function (internalId, oldExternalId) {
                if (arguments.length == 2) {
                    var connection = null;
                    var _var0 = new fm.liveswitch.Holder(connection);
                    var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this.__lookupByInternalId, internalId, _var0);
                    connection = _var0.getValue();
                    if (_var1) {
                        var externalId = connection.getExternalId();
                        if ((!fm.liveswitch.Global.equals(oldExternalId, null))) {
                            fm.liveswitch.HashExtensions.remove(this.__lookupByExternalId, oldExternalId);
                        }
                        this.__lookupByExternalId[externalId] = connection;
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ConnectionCollection.prototype.removeSuccess = function (value) {
                if (arguments.length == 1) {
                    _super.prototype.removeSuccess.call(this, value);
                    fm.liveswitch.HashExtensions.remove(this.__lookupByInternalId, value.getId());
                    var externalId = value.getExternalId();
                    if ((!fm.liveswitch.Global.equals(externalId, null))) {
                        fm.liveswitch.HashExtensions.remove(this.__lookupByExternalId, externalId);
                    }
                    value.removeOnExternalIdChange(this.processExternalIdChange.bind(this));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ConnectionCollection.prototype.tryGetByExternalId = function (idValue, connection) {
                if (arguments.length == 2) {
                    var _var0 = fm.liveswitch.HashExtensions.tryGetValue(this.__lookupByExternalId, idValue, connection);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ConnectionCollection.prototype.tryGetById = function (idValue, connection) {
                if (arguments.length == 2) {
                    var _var0 = fm.liveswitch.HashExtensions.tryGetValue(this.__lookupByInternalId, idValue, connection);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ConnectionCollection;
        }(fm.liveswitch.Collection));
        liveswitch.ConnectionCollection = ConnectionCollection;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="StateMachine.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A state machine for data channel states.
        */
        var DataChannelStateMachine = /** @class */ (function (_super) {
            __extends(DataChannelStateMachine, _super);
            /**
            Initializes a new instance of the [[fm.liveswitch.dataChannelStateMachine]] class.
            */
            function DataChannelStateMachine() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this, fm.liveswitch.DataChannelState.New) || this;
                    _super.prototype.addTransition.call(_this, fm.liveswitch.DataChannelState.New, fm.liveswitch.DataChannelState.Connecting);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.DataChannelState.New, fm.liveswitch.DataChannelState.Failed);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.DataChannelState.New, fm.liveswitch.DataChannelState.Closing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.DataChannelState.Connecting, fm.liveswitch.DataChannelState.Connected);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.DataChannelState.Connecting, fm.liveswitch.DataChannelState.Failed);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.DataChannelState.Connecting, fm.liveswitch.DataChannelState.Closing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.DataChannelState.Connected, fm.liveswitch.DataChannelState.Failed);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.DataChannelState.Connected, fm.liveswitch.DataChannelState.Closing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.DataChannelState.Closing, fm.liveswitch.DataChannelState.Failed);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.DataChannelState.Closing, fm.liveswitch.DataChannelState.Closed);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            DataChannelStateMachine.prototype.getTypeString = function () {
                return '[fm.liveswitch.DataChannelStateMachine]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Converts a state to an integer value.
            @param state The state.
            */
            DataChannelStateMachine.prototype.stateToValue = function (state) {
                if (arguments.length == 1) {
                    return state;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts an integer value to a state.
            @param value The integer value.
            */
            DataChannelStateMachine.prototype.valueToState = function (value) {
                if (arguments.length == 1) {
                    return value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return DataChannelStateMachine;
        }(fm.liveswitch.StateMachine));
        liveswitch.DataChannelStateMachine = DataChannelStateMachine;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="StateMachine.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A state machine for stream states.
        */
        var StreamStateMachine = /** @class */ (function (_super) {
            __extends(StreamStateMachine, _super);
            /**
            Initializes a new instance of the [[fm.liveswitch.streamStateMachine]] class.
            */
            function StreamStateMachine() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this, fm.liveswitch.StreamState.New) || this;
                    _super.prototype.addTransition.call(_this, fm.liveswitch.StreamState.New, fm.liveswitch.StreamState.Initializing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.StreamState.New, fm.liveswitch.StreamState.Failing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.StreamState.New, fm.liveswitch.StreamState.Closing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.StreamState.Initializing, fm.liveswitch.StreamState.Connecting);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.StreamState.Initializing, fm.liveswitch.StreamState.Failing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.StreamState.Initializing, fm.liveswitch.StreamState.Closing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.StreamState.Connecting, fm.liveswitch.StreamState.Connected);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.StreamState.Connecting, fm.liveswitch.StreamState.Failing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.StreamState.Connecting, fm.liveswitch.StreamState.Closing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.StreamState.Connected, fm.liveswitch.StreamState.Failing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.StreamState.Connected, fm.liveswitch.StreamState.Closing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.StreamState.Closing, fm.liveswitch.StreamState.Failing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.StreamState.Closing, fm.liveswitch.StreamState.Closed);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.StreamState.Failing, fm.liveswitch.StreamState.Failed);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            StreamStateMachine.prototype.getTypeString = function () {
                return '[fm.liveswitch.StreamStateMachine]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Converts a state to an integer value.
            @param state The state.
            */
            StreamStateMachine.prototype.stateToValue = function (state) {
                if (arguments.length == 1) {
                    return state;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts an integer value to a state.
            @param value The integer value.
            */
            StreamStateMachine.prototype.valueToState = function (value) {
                if (arguments.length == 1) {
                    return value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return StreamStateMachine;
        }(fm.liveswitch.StateMachine));
        liveswitch.StreamStateMachine = StreamStateMachine;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="StateMachine.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A state machine for connection states.
        */
        var ConnectionStateMachine = /** @class */ (function (_super) {
            __extends(ConnectionStateMachine, _super);
            /**
            Initializes a new instance of the [[fm.liveswitch.connectionStateMachine]] class.
            */
            function ConnectionStateMachine() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this, fm.liveswitch.ConnectionState.New) || this;
                    _super.prototype.addTransition.call(_this, fm.liveswitch.ConnectionState.New, fm.liveswitch.ConnectionState.Initializing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.ConnectionState.New, fm.liveswitch.ConnectionState.Failing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.ConnectionState.New, fm.liveswitch.ConnectionState.Closing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.ConnectionState.Initializing, fm.liveswitch.ConnectionState.Connecting);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.ConnectionState.Initializing, fm.liveswitch.ConnectionState.Failing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.ConnectionState.Initializing, fm.liveswitch.ConnectionState.Closing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.ConnectionState.Connecting, fm.liveswitch.ConnectionState.Connected);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.ConnectionState.Connecting, fm.liveswitch.ConnectionState.Failing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.ConnectionState.Connecting, fm.liveswitch.ConnectionState.Closing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.ConnectionState.Connected, fm.liveswitch.ConnectionState.Failing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.ConnectionState.Connected, fm.liveswitch.ConnectionState.Closing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.ConnectionState.Closing, fm.liveswitch.ConnectionState.Failing);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.ConnectionState.Closing, fm.liveswitch.ConnectionState.Closed);
                    _super.prototype.addTransition.call(_this, fm.liveswitch.ConnectionState.Failing, fm.liveswitch.ConnectionState.Failed);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            ConnectionStateMachine.prototype.getTypeString = function () {
                return '[fm.liveswitch.ConnectionStateMachine]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Converts a state to an integer value.
            @param state The state.
            */
            ConnectionStateMachine.prototype.stateToValue = function (state) {
                if (arguments.length == 1) {
                    return state;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts an integer value to a state.
            @param value The integer value.
            */
            ConnectionStateMachine.prototype.valueToState = function (value) {
                if (arguments.length == 1) {
                    return value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ConnectionStateMachine;
        }(fm.liveswitch.StateMachine));
        liveswitch.ConnectionStateMachine = ConnectionStateMachine;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Collection.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A collection of data channels.
        */
        var DataChannelCollection = /** @class */ (function (_super) {
            __extends(DataChannelCollection, _super);
            function DataChannelCollection() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            DataChannelCollection.prototype.getTypeString = function () {
                return '[fm.liveswitch.DataChannelCollection]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Creates an array from a list.
            @param list The list.
            */
            DataChannelCollection.prototype.arrayFromList = function (list) {
                if (arguments.length == 1) {
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a collection.
            */
            DataChannelCollection.prototype.createCollection = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.DataChannelCollection();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return DataChannelCollection;
        }(fm.liveswitch.Collection));
        liveswitch.DataChannelCollection = DataChannelCollection;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Arguments for the data channel receive event.
        */
        var DataChannelReceiveArgs = /** @class */ (function () {
            function DataChannelReceiveArgs() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            DataChannelReceiveArgs.prototype.getTypeString = function () {
                return '[fm.liveswitch.DataChannelReceiveArgs]';
            };
            /**
            Gets the data buffer.
            */
            DataChannelReceiveArgs.prototype.getDataBytes = function () {
                if (arguments.length == 0) {
                    return this._dataBytes;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataChannelReceiveArgs.prototype.getDataMessage = function () {
                if (arguments.length == 0) {
                    return this._dataMessage;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the data string.
            */
            DataChannelReceiveArgs.prototype.getDataString = function () {
                if (arguments.length == 0) {
                    return this._dataString;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote connection info.
            */
            DataChannelReceiveArgs.prototype.getRemoteConnectionInfo = function () {
                if (arguments.length == 0) {
                    return this.__remoteConnectionInfo;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the data buffer.
            */
            DataChannelReceiveArgs.prototype.setDataBytes = function (value) {
                if (arguments.length == 1) {
                    this._dataBytes = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataChannelReceiveArgs.prototype.setDataMessage = function (value) {
                if (arguments.length == 1) {
                    this._dataMessage = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the data string.
            */
            DataChannelReceiveArgs.prototype.setDataString = function (value) {
                if (arguments.length == 1) {
                    this._dataString = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            DataChannelReceiveArgs.prototype.setRemoteConnectionInfo = function (remoteConnectionInfo) {
                if (arguments.length == 1) {
                    this.__remoteConnectionInfo = remoteConnectionInfo;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return DataChannelReceiveArgs;
        }());
        liveswitch.DataChannelReceiveArgs = DataChannelReceiveArgs;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../AudioFormat.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var dtmf;
        (function (dtmf) {
            /**
            A DTMF (telephone-event) format.
            */
            var Format = /** @class */ (function (_super) {
                __extends(Format, _super);
                function Format() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        // chained constructor: Format.call(this, fm.liveswitch.dtmf.Format.getDefaultClockRate());
                        __arguments = new Array(1);
                        __arguments[0] = fm.liveswitch.dtmf.Format.getDefaultClockRate();
                        {
                            var clockRate = __arguments[0];
                            _this = _super.call(this, fm.liveswitch.AudioFormat.getDtmfName(), clockRate, 1) || this;
                            _super.prototype.setIsFixedBitrate.call(_this, true);
                            _super.prototype.setIsInjected.call(_this, true);
                        }
                    }
                    else if (__arguments.length == 1) {
                        var clockRate = __arguments[0];
                        _this = _super.call(this, fm.liveswitch.AudioFormat.getDtmfName(), clockRate, 1) || this;
                        _super.prototype.setIsFixedBitrate.call(_this, true);
                        _super.prototype.setIsInjected.call(_this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                Format.prototype.getTypeString = function () {
                    return '[fm.liveswitch.dtmf.Format]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Gets the default clock rate (8000).
                */
                Format.getDefaultClockRate = function () {
                    if (arguments.length == 0) {
                        return 8000;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Format;
            }(fm.liveswitch.AudioFormat));
            dtmf.Format = Format;
        })(dtmf = liveswitch.dtmf || (liveswitch.dtmf = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var EncryptionPolicyWrapper = /** @class */ (function () {
            function EncryptionPolicyWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_46 = __arguments[0];
                    //super();
                    this._value = value_46;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            EncryptionPolicyWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.EncryptionPolicyWrapper]';
            };
            EncryptionPolicyWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.EncryptionPolicy.Required)
                        return 'Required';
                    if (this._value == fm.liveswitch.EncryptionPolicy.Negotiated)
                        return 'Negotiated';
                    if (this._value == fm.liveswitch.EncryptionPolicy.Disabled)
                        return 'Disabled';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return EncryptionPolicyWrapper;
        }());
        liveswitch.EncryptionPolicyWrapper = EncryptionPolicyWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../AudioFormat.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var g711;
        (function (g711) {
            /**
            A G.711 format.
            */
            var Format = /** @class */ (function (_super) {
                __extends(Format, _super);
                /**
                Initializes a new instance of the [[fm.liveswitch.g711.format]] class.
                @param name The name.
                @param clockRate The clock rate.
                @param channelCount The channel count.
                */
                function Format(name, clockRate, channelCount) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 3) {
                        var name_30 = __arguments[0];
                        var clockRate_10 = __arguments[1];
                        var channelCount_2 = __arguments[2];
                        _this = _super.call(this, name_30, clockRate_10, channelCount_2) || this;
                        _super.prototype.setIsFixedBitrate.call(_this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                Format.prototype.getTypeString = function () {
                    return '[fm.liveswitch.g711.Format]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Gets the default clock rate (1).
                */
                Format.getDefaultChannelCount = function () {
                    if (arguments.length == 0) {
                        return 1;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the default clock rate (8000).
                */
                Format.getDefaultClockRate = function () {
                    if (arguments.length == 0) {
                        return 8000;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the default configuration (8000/1).
                */
                Format.getDefaultConfig = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.AudioConfig(fm.liveswitch.g711.Format.getDefaultClockRate(), fm.liveswitch.g711.Format.getDefaultChannelCount());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Format.prototype.getFixedBitrate = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.MathAssistant.floor(fm.liveswitch.MathAssistant.floor((((_super.prototype.getConfig.call(this).getClockRate() * _super.prototype.getConfig.call(this).getChannelCount()) * 2) * 8) / 2) / 1000);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the maximum bitrate supported by this format, in kbps.
                */
                Format.prototype.getMaxBitrate = function () {
                    if (arguments.length == 0) {
                        return this.getFixedBitrate();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the minimum bitrate supported by this format, in kbps.
                */
                Format.prototype.getMinBitrate = function () {
                    if (arguments.length == 0) {
                        return this.getFixedBitrate();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Format;
            }(fm.liveswitch.AudioFormat));
            g711.Format = Format;
        })(g711 = liveswitch.g711 || (liveswitch.g711 = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="MediaFormat.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A video format.
        */
        var VideoFormat = /** @class */ (function (_super) {
            __extends(VideoFormat, _super);
            function VideoFormat() {
                var _this = this;
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else if (__arguments.length == 1) {
                    var name_31 = __arguments[0];
                    _this = _super.call(this, name_31, fm.liveswitch.VideoFormat.getDefaultClockRate()) || this;
                }
                else if (__arguments.length == 2) {
                    var name_32 = __arguments[0];
                    var clockRate = __arguments[1];
                    _this = _super.call(this, name_32, clockRate) || this;
                }
                else if (__arguments.length == 3) {
                    var name_33 = __arguments[0];
                    var clockRate = __arguments[1];
                    var packetizationMode = __arguments[2];
                    _this = _super.call(this, name_33, clockRate, packetizationMode) || this;
                }
                else if (__arguments.length == 4) {
                    var name_34 = __arguments[0];
                    var clockRate = __arguments[1];
                    var profile = __arguments[2];
                    var level = __arguments[3];
                    _this = _super.call(this, name_34, clockRate, profile, level) || this;
                }
                else if (__arguments.length == 5) {
                    var name_35 = __arguments[0];
                    var clockRate = __arguments[1];
                    var profile = __arguments[2];
                    var level = __arguments[3];
                    var packetizationMode = __arguments[4];
                    _this = _super.call(this, name_35, clockRate, profile, level, packetizationMode) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            VideoFormat.prototype.getTypeString = function () {
                return '[fm.liveswitch.VideoFormat]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Converts a format name to its FourCC value.
            @param formatName The format name.
            @return The FourCC value, or 0 if the format name is not recognized.
            */
            VideoFormat.formatNameToFourCC = function (formatName) {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 1) {
                    if (fm.liveswitch.HashExtensions.containsKey(fm.liveswitch.VideoFormat.fm_liveswitch_VideoFormat__fourCCLookup, formatName)) {
                        return fm.liveswitch.VideoFormat.fm_liveswitch_VideoFormat__fourCCLookup[formatName];
                    }
                    return 0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Transforms a FormatInfo into an VideoFormat.
            @param info The format info.
            */
            VideoFormat.fromFormatInfo = function (info) {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 1) {
                    return new fm.liveswitch.VideoFormat(info.getName(), info.getClockRate());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an instance from JSON.
            @param videoFormatJson The video format JSON.
            */
            VideoFormat.fromJson = function (videoFormatJson) {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(videoFormatJson, function () {
                        return new fm.liveswitch.VideoFormat();
                    }, function (videoFormat, name, valueJson) {
                        var _var0 = name;
                        if (_var0 == "name") {
                            do {
                                videoFormat.setName(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "clockRate") {
                            do {
                                videoFormat.setClockRate(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "isPacketized") {
                            do {
                                videoFormat.setIsPacketized(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "isEncrypted") {
                            do {
                                videoFormat.setIsEncrypted(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "registeredPayloadType") {
                            do {
                                videoFormat.setRegisteredPayloadType(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "staticPayloadType") {
                            do {
                                videoFormat.setStaticPayloadType(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "packetizationMode") {
                            do {
                                videoFormat.setPacketizationMode(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "profile") {
                            do {
                                videoFormat.setProfile(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "level") {
                            do {
                                videoFormat.setLevel(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "levelIsStrict") {
                            do {
                                videoFormat.setLevelIsStrict(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                break;
                            } while (false);
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets an ABGR video format.
            */
            VideoFormat.getAbgr = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    var format = new fm.liveswitch.VideoFormat(fm.liveswitch.VideoFormat.getAbgrName());
                    format.setIsFixedBitrate(true);
                    return format;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name of the ABGR video format ("ABGR"). Indicates that each pixel occupies 32 bits (8 bits for alpha, then 8 bits for blue, then8 bits for green, then 8 bits for red).
            */
            VideoFormat.getAbgrName = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    return "ABGR";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets an ARGB video format.
            */
            VideoFormat.getArgb = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    var format = new fm.liveswitch.VideoFormat(fm.liveswitch.VideoFormat.getArgbName());
                    format.setIsFixedBitrate(true);
                    return format;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name of the ARGB video format ("ARGB"). Indicates that each pixel occupies 32 bits (8 bits for alpha, then 8 bits for red, then 8 bits for green, then 8 bits for blue).
            */
            VideoFormat.getArgbName = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    return "ARGB";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a BGR video format.
            */
            VideoFormat.getBgr = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    var format = new fm.liveswitch.VideoFormat(fm.liveswitch.VideoFormat.getBgrName());
                    format.setIsFixedBitrate(true);
                    return format;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets an BGRA video format.
            */
            VideoFormat.getBgra = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    var format = new fm.liveswitch.VideoFormat(fm.liveswitch.VideoFormat.getBgraName());
                    format.setIsFixedBitrate(true);
                    return format;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name of the BGRA video format ("BGRA"). Indicates that each pixel occupies 32 bits (8 bits for blue, then8 bits for green, then 8 bits for red, then 8 bits for alpha).
            */
            VideoFormat.getBgraName = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    return "BGRA";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name of the BGR video format ("BGR"). Indicates that each pixel occupies 24 bits (8 bits for blue, then8 bits for green, then 8 bits for red).
            */
            VideoFormat.getBgrName = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    return "BGR";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the default clock rate.
            */
            VideoFormat.getDefaultClockRate = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    return 90000;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets an H.264 video format.
            */
            VideoFormat.getH264 = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    return new fm.liveswitch.h264.Format();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name of the H.264 video format ("H264").
            */
            VideoFormat.getH264Name = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    return "H264";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets an I420 video format.
            */
            VideoFormat.getI420 = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    var format = new fm.liveswitch.VideoFormat(fm.liveswitch.VideoFormat.getI420Name());
                    format.setIsFixedBitrate(true);
                    return format;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name of the I420 video format ("I420"). Indicates that each pixel occupies 12 bits (8 bits for Y, 2 bits for U, and 2 bits for V). Y plane is followed by U plane and then V plane.
            */
            VideoFormat.getI420Name = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    return "I420";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets an NV12 video format.
            */
            VideoFormat.getNv12 = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    var format = new fm.liveswitch.VideoFormat(fm.liveswitch.VideoFormat.getNv12Name());
                    format.setIsFixedBitrate(true);
                    return format;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name of the NV12 video format ("NV12"). Indicates that each pixel occupies 12 bits (8 bits for Y, 2 bits for U, and 2 bits for V). Y plane is followed by interleaved U/V plane.
            */
            VideoFormat.getNv12Name = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    return "NV12";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets an NV21 video format.
            */
            VideoFormat.getNv21 = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    var format = new fm.liveswitch.VideoFormat(fm.liveswitch.VideoFormat.getNv21Name());
                    format.setIsFixedBitrate(true);
                    return format;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name of the NV21 video format ("NV21"). Indicates that each pixel occupies 12 bits (8 bits for Y, 2 bits for U, and 2 bits for V). Y plane is followed by interleaved V/U plane.
            */
            VideoFormat.getNv21Name = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    return "NV21";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets an RGB video format.
            */
            VideoFormat.getRgb = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    var format = new fm.liveswitch.VideoFormat(fm.liveswitch.VideoFormat.getRgbName());
                    format.setIsFixedBitrate(true);
                    return format;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets an RGBA video format.
            */
            VideoFormat.getRgba = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    var format = new fm.liveswitch.VideoFormat(fm.liveswitch.VideoFormat.getRgbaName());
                    format.setIsFixedBitrate(true);
                    return format;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name of the RGBA video format ("RGBA"). Indicates that each pixel occupies 32 bits (8 bits for red, then 8 bits for green, then 8 bits for blue, then 8 bits for alpha).
            */
            VideoFormat.getRgbaName = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    return "RGBA";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name of the RGB video format ("RGB"). Indicates that each pixel occupies 24 bits (8 bits for red, then 8 bits for green, then 8 bits for blue).
            */
            VideoFormat.getRgbName = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    return "RGB";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a VP8 video format.
            */
            VideoFormat.getVp8 = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    return new fm.liveswitch.vp8.Format();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name of the VP8 video format ("VP8").
            */
            VideoFormat.getVp8Name = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    return "VP8";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a VP9 video format.
            */
            VideoFormat.getVp9 = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    return new fm.liveswitch.vp9.Format();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name of the VP9 video format ("VP9").
            */
            VideoFormat.getVp9Name = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    return "VP9";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a YV12 video format.
            */
            VideoFormat.getYv12 = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    var format = new fm.liveswitch.VideoFormat(fm.liveswitch.VideoFormat.getYv12Name());
                    format.setIsFixedBitrate(true);
                    return format;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name of the YV12 video format ("YV12"). Indicates that each pixel occupies 12 bits (8 bits for Y, 2 bits for U, and 2 bits for V). Y plane is followed by V plane and then U plane.
            */
            VideoFormat.getYv12Name = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 0) {
                    return "YV12";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            VideoFormat.toFourCC = function () {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 4) {
                    var a = arguments[0];
                    var b = arguments[1];
                    var c = arguments[2];
                    var d = arguments[3];
                    return (((a | fm.liveswitch.BitAssistant.leftShiftInteger(b, 8)) | fm.liveswitch.BitAssistant.leftShiftInteger(c, 16)) | fm.liveswitch.BitAssistant.leftShiftInteger(d, 24));
                }
                else if (arguments.length == 1) {
                    var fourcc = arguments[0];
                    return fm.liveswitch.VideoFormat.toFourCC(fourcc.charCodeAt(0), fourcc.charCodeAt(1), fourcc.charCodeAt(2), fourcc.charCodeAt(3));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param videoFormat The video format.
            */
            VideoFormat.toJson = function (videoFormat) {
                fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(videoFormat, function (obj, jsonObject) {
                        jsonObject["name"] = fm.liveswitch.JsonSerializer.serializeString(videoFormat.getName());
                        jsonObject["clockRate"] = fm.liveswitch.JsonSerializer.serializeInteger(videoFormat.getClockRate());
                        jsonObject["isPacketized"] = fm.liveswitch.JsonSerializer.serializeBoolean(videoFormat.getIsPacketized());
                        jsonObject["isEncrypted"] = fm.liveswitch.JsonSerializer.serializeBoolean(videoFormat.getIsEncrypted());
                        jsonObject["registeredPayloadType"] = fm.liveswitch.JsonSerializer.serializeInteger(videoFormat.getRegisteredPayloadType());
                        jsonObject["staticPayloadType"] = fm.liveswitch.JsonSerializer.serializeInteger(videoFormat.getStaticPayloadType());
                        jsonObject["packetizationMode"] = fm.liveswitch.JsonSerializer.serializeString(videoFormat.getPacketizationMode());
                        jsonObject["profile"] = fm.liveswitch.JsonSerializer.serializeString(videoFormat.getProfile());
                        jsonObject["level"] = fm.liveswitch.JsonSerializer.serializeString(videoFormat.getLevel());
                        jsonObject["levelIsStrict"] = fm.liveswitch.JsonSerializer.serializeBoolean(videoFormat.getLevelIsStrict());
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Clones this instance.
            */
            VideoFormat.prototype.clone = function () {
                if (arguments.length == 0) {
                    return _super.prototype.clone.call(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a new instance.
            */
            VideoFormat.prototype.createInstance = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.VideoFormat();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Converts a FourCC value to its format name.
            @param fourcc The FourCC value.
            @return The format name, or an empty string if the FourCC value is not recognized.
            */
            VideoFormat.prototype.fourCCToFormatName = function (fourcc) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(fm.liveswitch.VideoFormat.fm_liveswitch_VideoFormat__reverseFourCCLookup, null))) {
                        var dictionary = {};
                        for (var _i = 0, _a = fm.liveswitch.HashExtensions.getKeys(fm.liveswitch.VideoFormat.fm_liveswitch_VideoFormat__fourCCLookup); _i < _a.length; _i++) {
                            var str = _a[_i];
                            dictionary[fm.liveswitch.VideoFormat.fm_liveswitch_VideoFormat__fourCCLookup[str]] = str;
                        }
                        fm.liveswitch.VideoFormat.fm_liveswitch_VideoFormat__reverseFourCCLookup = dictionary;
                    }
                    var str2 = null;
                    var _var0 = new fm.liveswitch.Holder(str2);
                    var _var1 = fm.liveswitch.HashExtensions.tryGetValue(fm.liveswitch.VideoFormat.fm_liveswitch_VideoFormat__reverseFourCCLookup, fourcc, _var0);
                    str2 = _var0.getValue();
                    if (_var1) {
                        return str2;
                    }
                    return "";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the FourCC value for this format.
            */
            VideoFormat.prototype.getFourCC = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.VideoFormat.formatNameToFourCC(_super.prototype.getName.call(this));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets this format as an info object.
            */
            VideoFormat.prototype.getInfo = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.FormatInfo(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is ABGR.
            */
            VideoFormat.prototype.getIsAbgr = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.isEqual(_super.prototype.getName.call(this), fm.liveswitch.VideoFormat.getAbgrName(), fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is ARGB.
            */
            VideoFormat.prototype.getIsArgb = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.isEqual(_super.prototype.getName.call(this), fm.liveswitch.VideoFormat.getArgbName(), fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is BGR.
            */
            VideoFormat.prototype.getIsBgr = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.isEqual(_super.prototype.getName.call(this), fm.liveswitch.VideoFormat.getBgrName(), fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is BGRA.
            */
            VideoFormat.prototype.getIsBgra = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.isEqual(_super.prototype.getName.call(this), fm.liveswitch.VideoFormat.getBgraName(), fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether this is a compressed format.
            */
            VideoFormat.prototype.getIsCompressed = function () {
                if (arguments.length == 0) {
                    return !this.getIsRaw();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is H.264.
            */
            VideoFormat.prototype.getIsH264 = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.isEqual(_super.prototype.getName.call(this), fm.liveswitch.VideoFormat.getH264Name(), fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is I420.
            */
            VideoFormat.prototype.getIsI420 = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.isEqual(_super.prototype.getName.call(this), fm.liveswitch.VideoFormat.getI420Name(), fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is NV12.
            */
            VideoFormat.prototype.getIsNv12 = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.isEqual(_super.prototype.getName.call(this), fm.liveswitch.VideoFormat.getNv12Name(), fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is NV21.
            */
            VideoFormat.prototype.getIsNv21 = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.isEqual(_super.prototype.getName.call(this), fm.liveswitch.VideoFormat.getNv21Name(), fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is RGB, BGR, I420, YV12, NV12, NV21, RGBA, BGRA, ARGB, or ABGR.
            */
            VideoFormat.prototype.getIsRaw = function () {
                if (arguments.length == 0) {
                    return ((this.getIsYuvType() || this.getIsRgbType()) || this.getIsRgbaType());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is RGB.
            */
            VideoFormat.prototype.getIsRgb = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.isEqual(_super.prototype.getName.call(this), fm.liveswitch.VideoFormat.getRgbName(), fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is RGBA.
            */
            VideoFormat.prototype.getIsRgba = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.isEqual(_super.prototype.getName.call(this), fm.liveswitch.VideoFormat.getRgbaName(), fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is RGBA, BGRA, ARGB, or ABGR.
            */
            VideoFormat.prototype.getIsRgbaType = function () {
                if (arguments.length == 0) {
                    return (((this.getIsRgba() || this.getIsBgra()) || this.getIsArgb()) || this.getIsAbgr());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is RGB or BGR.
            */
            VideoFormat.prototype.getIsRgbType = function () {
                if (arguments.length == 0) {
                    return (this.getIsRgb() || this.getIsBgr());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is VP8.
            */
            VideoFormat.prototype.getIsVp8 = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.isEqual(_super.prototype.getName.call(this), fm.liveswitch.VideoFormat.getVp8Name(), fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is VP9.
            */
            VideoFormat.prototype.getIsVp9 = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.isEqual(_super.prototype.getName.call(this), fm.liveswitch.VideoFormat.getVp9Name(), fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is I420, YV12, NV12, or NV21.
            */
            VideoFormat.prototype.getIsYuvType = function () {
                if (arguments.length == 0) {
                    return (((this.getIsI420() || this.getIsYv12()) || this.getIsNv12()) || this.getIsNv21());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this format is YV12.
            */
            VideoFormat.prototype.getIsYv12 = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StringExtensions.isEqual(_super.prototype.getName.call(this), fm.liveswitch.VideoFormat.getYv12Name(), fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the maximum level.
            @param level1 The first level.
            @param level2 The second level.
            @return The maximum level.
            */
            VideoFormat.prototype.getMaxLevel = function (level1, level2) {
                if (arguments.length == 2) {
                    if (this.getIsH264()) {
                        var hexBytes = fm.liveswitch.BitAssistant.getHexBytes(level1);
                        var buffer2 = fm.liveswitch.BitAssistant.getHexBytes(level2);
                        if ((hexBytes[0] > buffer2[0])) {
                            return level1;
                        }
                        return level2;
                    }
                    return _super.prototype.getMaxLevel.call(this, level1, level2);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the minimum level.
            @param level1 The first level.
            @param level2 The second level.
            @return The minimum level.
            */
            VideoFormat.prototype.getMinLevel = function (level1, level2) {
                if (arguments.length == 2) {
                    if (this.getIsH264()) {
                        var hexBytes = fm.liveswitch.BitAssistant.getHexBytes(level1);
                        var buffer2 = fm.liveswitch.BitAssistant.getHexBytes(level2);
                        if ((hexBytes[0] > buffer2[0])) {
                            return level2;
                        }
                        return level1;
                    }
                    return _super.prototype.getMinLevel.call(this, level1, level2);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the parameters.
            */
            VideoFormat.prototype.getParameters = function () {
                if (arguments.length == 0) {
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether a level is compatible.
            @param level The level.
            */
            VideoFormat.prototype.isLevelCompatible = function (level) {
                if (arguments.length == 1) {
                    if ((this.getIsH264() && ((fm.liveswitch.Global.equals(fm.liveswitch.StringExtensions.getLength(_super.prototype.getLevel.call(this)), 2)) && (fm.liveswitch.Global.equals(fm.liveswitch.StringExtensions.getLength(level), 2))))) {
                        var hexBytes = fm.liveswitch.BitAssistant.getHexBytes(_super.prototype.getLevel.call(this));
                        var buffer2 = fm.liveswitch.BitAssistant.getHexBytes(level);
                        return (hexBytes[0] <= buffer2[0]);
                    }
                    return _super.prototype.isLevelCompatible.call(this, level);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether a profile is compatible.
            @param profile The profile.
            */
            VideoFormat.prototype.isProfileCompatible = function (profile) {
                if (arguments.length == 1) {
                    if ((this.getIsH264() && ((fm.liveswitch.Global.equals(fm.liveswitch.StringExtensions.getLength(_super.prototype.getProfile.call(this)), 4)) && (fm.liveswitch.Global.equals(fm.liveswitch.StringExtensions.getLength(profile), 4))))) {
                        var hexBytes = fm.liveswitch.BitAssistant.getHexBytes(_super.prototype.getProfile.call(this));
                        var buffer2 = fm.liveswitch.BitAssistant.getHexBytes(profile);
                        return (hexBytes[0] <= buffer2[0]);
                    }
                    return _super.prototype.isProfileCompatible.call(this, profile);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the FourCC value for this format.
            */
            VideoFormat.prototype.setFourCC = function (value) {
                if (arguments.length == 1) {
                    _super.prototype.setName.call(this, this.fourCCToFormatName(value));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            VideoFormat.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.VideoFormat.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Updates the profile to a compatible value.
            @param format The format.
            */
            VideoFormat.prototype.updateProfileToCompatible = function (format) {
                if (arguments.length == 1) {
                    if ((this.getIsH264() && (!fm.liveswitch.Global.equals(format.getProfile(), null)))) {
                        if ((((fm.liveswitch.Global.equals(_super.prototype.getProfile.call(this), null)) || (!fm.liveswitch.Global.equals(fm.liveswitch.StringExtensions.getLength(_super.prototype.getProfile.call(this)), 4))) || (!fm.liveswitch.Global.equals(fm.liveswitch.StringExtensions.getLength(format.getProfile()), 4)))) {
                            _super.prototype.setProfile.call(this, format.getProfile());
                        }
                        else {
                            var hexBytes = fm.liveswitch.BitAssistant.getHexBytes(_super.prototype.getProfile.call(this));
                            var buffer2 = fm.liveswitch.BitAssistant.getHexBytes(format.getProfile());
                            _super.prototype.setProfile.call(this, fm.liveswitch.BitAssistant.getHexString(new Uint8Array([buffer2[0], (hexBytes[1] | buffer2[1])])));
                        }
                    }
                    _super.prototype.updateProfileToCompatible.call(this, format);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoFormat.fmliveswitchVideoFormatInitialize = function () {
                if (!fm.liveswitch.VideoFormat.__fmliveswitchVideoFormatInitialized && !fm.liveswitch.VideoFormat.__fmliveswitchVideoFormatInitializing) {
                    fm.liveswitch.VideoFormat.__fmliveswitchVideoFormatInitializing = true;
                    fm.liveswitch.VideoFormat.fm_liveswitch_VideoFormat__fourCCLookup = {};
                    fm.liveswitch.VideoFormat.fm_liveswitch_VideoFormat__reverseFourCCLookup = null;
                    fm.liveswitch.VideoFormat.fm_liveswitch_VideoFormat__fourCCLookup[fm.liveswitch.VideoFormat.getRgbName()] = fm.liveswitch.VideoFormat.toFourCC(114, 97, 119, 32);
                    fm.liveswitch.VideoFormat.fm_liveswitch_VideoFormat__fourCCLookup[fm.liveswitch.VideoFormat.getBgrName()] = fm.liveswitch.VideoFormat.toFourCC(50, 52, 66, 71);
                    fm.liveswitch.VideoFormat.fm_liveswitch_VideoFormat__fourCCLookup[fm.liveswitch.VideoFormat.getNv12Name()] = fm.liveswitch.VideoFormat.toFourCC(78, 86, 49, 50);
                    fm.liveswitch.VideoFormat.fm_liveswitch_VideoFormat__fourCCLookup[fm.liveswitch.VideoFormat.getNv21Name()] = fm.liveswitch.VideoFormat.toFourCC(78, 86, 50, 49);
                    fm.liveswitch.VideoFormat.fm_liveswitch_VideoFormat__fourCCLookup[fm.liveswitch.VideoFormat.getI420Name()] = fm.liveswitch.VideoFormat.toFourCC(73, 52, 50, 48);
                    fm.liveswitch.VideoFormat.fm_liveswitch_VideoFormat__fourCCLookup[fm.liveswitch.VideoFormat.getYv12Name()] = fm.liveswitch.VideoFormat.toFourCC(89, 86, 49, 50);
                    fm.liveswitch.VideoFormat.fm_liveswitch_VideoFormat__fourCCLookup[fm.liveswitch.VideoFormat.getArgbName()] = fm.liveswitch.VideoFormat.toFourCC(65, 82, 71, 66);
                    fm.liveswitch.VideoFormat.fm_liveswitch_VideoFormat__fourCCLookup[fm.liveswitch.VideoFormat.getAbgrName()] = fm.liveswitch.VideoFormat.toFourCC(65, 66, 71, 82);
                    fm.liveswitch.VideoFormat.fm_liveswitch_VideoFormat__fourCCLookup[fm.liveswitch.VideoFormat.getRgbaName()] = fm.liveswitch.VideoFormat.toFourCC(82, 71, 66, 65);
                    fm.liveswitch.VideoFormat.fm_liveswitch_VideoFormat__fourCCLookup[fm.liveswitch.VideoFormat.getBgraName()] = fm.liveswitch.VideoFormat.toFourCC(66, 71, 82, 65);
                    fm.liveswitch.VideoFormat.__fmliveswitchVideoFormatInitialized = true;
                    fm.liveswitch.VideoFormat.__fmliveswitchVideoFormatInitializing = false;
                }
            };
            /** @hidden */
            VideoFormat.__fmliveswitchVideoFormatInitialized = false;
            /** @hidden */
            VideoFormat.__fmliveswitchVideoFormatInitializing = false;
            return VideoFormat;
        }(fm.liveswitch.MediaFormat));
        liveswitch.VideoFormat = VideoFormat;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../VideoFormat.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var h264;
        (function (h264) {
            /**
            An H.264 format.
            */
            var Format = /** @class */ (function (_super) {
                __extends(Format, _super);
                function Format() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this, fm.liveswitch.VideoFormat.getH264Name()) || this;
                    }
                    else if (__arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isNumber(arguments[0]))) {
                        var clockRate = __arguments[0];
                        _this = _super.call(this, fm.liveswitch.VideoFormat.getH264Name(), clockRate) || this;
                    }
                    else if (__arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isNumber(arguments[0]))) {
                        var clockRate = __arguments[0];
                        var packetizationMode = __arguments[1];
                        _this = _super.call(this, fm.liveswitch.VideoFormat.getH264Name(), clockRate, fm.liveswitch.NumberExtensions.toString(packetizationMode)) || this;
                    }
                    else if (__arguments.length == 4) {
                        var clockRate = __arguments[0];
                        var profile = __arguments[1];
                        var level = __arguments[2];
                        var packetizationMode = __arguments[3];
                        _this = _super.call(this, fm.liveswitch.VideoFormat.getH264Name(), clockRate, profile, level, fm.liveswitch.NumberExtensions.toString(packetizationMode)) || this;
                    }
                    else if (__arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isNumber(arguments[0])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.h264.ProfileLevelId]'))) {
                        var clockRate = __arguments[0];
                        var profileLevelId = __arguments[1];
                        var packetizationMode = __arguments[2];
                        _this = _super.call(this, fm.liveswitch.VideoFormat.getH264Name(), clockRate, profileLevelId.getProfile(), profileLevelId.getLevel(), fm.liveswitch.NumberExtensions.toString(packetizationMode)) || this;
                    }
                    else if (__arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                        var profile = __arguments[0];
                        var level = __arguments[1];
                        var packetizationMode = __arguments[2];
                        _this = _super.call(this, fm.liveswitch.VideoFormat.getH264Name(), 90000, profile, level, fm.liveswitch.NumberExtensions.toString(packetizationMode)) || this;
                    }
                    else if (__arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.h264.ProfileLevelId]'))) {
                        var profileLevelId = __arguments[0];
                        _this = _super.call(this, fm.liveswitch.VideoFormat.getH264Name(), 90000, profileLevelId.getProfile(), profileLevelId.getLevel()) || this;
                    }
                    else if (__arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.h264.ProfileLevelId]'))) {
                        var profileLevelId = __arguments[0];
                        var packetizationMode = __arguments[1];
                        _this = _super.call(this, fm.liveswitch.VideoFormat.getH264Name(), 90000, profileLevelId.getProfile(), profileLevelId.getLevel(), fm.liveswitch.NumberExtensions.toString(packetizationMode)) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                Format.prototype.getTypeString = function () {
                    return '[fm.liveswitch.h264.Format]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Creates a new instance.
                */
                Format.prototype.createInstance = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.h264.Format();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the maximum bitrate supported by this format, in kbps.
                */
                Format.prototype.getMaxBitrate = function () {
                    if (arguments.length == 0) {
                        return 100000;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the minimum bitrate supported by this format, in kbps.
                */
                Format.prototype.getMinBitrate = function () {
                    if (arguments.length == 0) {
                        return 100;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Format;
            }(fm.liveswitch.VideoFormat));
            h264.Format = Format;
        })(h264 = liveswitch.h264 || (liveswitch.h264 = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var h264;
        (function (h264) {
            /**
            An H.264 Profile IOP.
            */
            var ProfileIop = /** @class */ (function () {
                /**
                Initializes a new instance of the [[fm.liveswitch.h264.profileIop]] class.
                @param profileIop The profile IOP.
                */
                function ProfileIop(profileIop) {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var profileIop_1 = __arguments[0];
                        //super();
                        this.setDataBuffer(fm.liveswitch.DataBuffer.wrap(new Uint8Array([profileIop_1])));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                ProfileIop.prototype.getTypeString = function () {
                    return '[fm.liveswitch.h264.ProfileIop]';
                };
                /**
                Gets a value indicating whether constraint 0 is set.
                */
                ProfileIop.prototype.getConstraintSet0 = function () {
                    if (arguments.length == 0) {
                        return this.getDataBuffer().read1(0, 0);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets a value indicating whether constraint 1 is set.
                */
                ProfileIop.prototype.getConstraintSet1 = function () {
                    if (arguments.length == 0) {
                        return this.getDataBuffer().read1(0, 1);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets a value indicating whether constraint 2 is set.
                */
                ProfileIop.prototype.getConstraintSet2 = function () {
                    if (arguments.length == 0) {
                        return this.getDataBuffer().read1(0, 2);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the backing data buffer.
                */
                ProfileIop.prototype.getDataBuffer = function () {
                    if (arguments.length == 0) {
                        return this._dataBuffer;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets a value indicating whether constraint 0 is set.
                */
                ProfileIop.prototype.setConstraintSet0 = function (value) {
                    if (arguments.length == 1) {
                        this.getDataBuffer().write1(value, 0, 0);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets a value indicating whether constraint 1 is set.
                */
                ProfileIop.prototype.setConstraintSet1 = function (value) {
                    if (arguments.length == 1) {
                        this.getDataBuffer().write1(value, 0, 1);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets a value indicating whether constraint 2 is set.
                */
                ProfileIop.prototype.setConstraintSet2 = function (value) {
                    if (arguments.length == 1) {
                        this.getDataBuffer().write1(value, 0, 2);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                ProfileIop.prototype.setDataBuffer = function (value) {
                    if (arguments.length == 1) {
                        this._dataBuffer = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ProfileIop;
            }());
            h264.ProfileIop = ProfileIop;
        })(h264 = liveswitch.h264 || (liveswitch.h264 = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var h264;
        (function (h264) {
            /**
            An H.264 Profile Level ID.
            */
            var ProfileLevelId = /** @class */ (function () {
                function ProfileLevelId() {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        //super();
                        this.fmliveswitchh264ProfileLevelIdInit();
                    }
                    else if (__arguments.length == 2) {
                        var profile = __arguments[0];
                        var level = __arguments[1];
                        //super();
                        this.fmliveswitchh264ProfileLevelIdInit();
                        if ((fm.liveswitch.Global.equals(profile, null))) {
                            throw new fm.liveswitch.Exception("Cannot initialize with null profile.");
                        }
                        if ((fm.liveswitch.Global.equals(level, null))) {
                            throw new fm.liveswitch.Exception("Cannot initialize with null level.");
                        }
                        if ((!fm.liveswitch.Global.equals(fm.liveswitch.StringExtensions.getLength(profile), 4))) {
                            throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Invalid profile. (Length was {0} and should be 4.)", fm.liveswitch.NumberExtensions.toString(fm.liveswitch.StringExtensions.getLength(profile))));
                        }
                        if ((!fm.liveswitch.Global.equals(fm.liveswitch.StringExtensions.getLength(level), 2))) {
                            throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Invalid level. (Length was {0} and should be 2.)", fm.liveswitch.NumberExtensions.toString(fm.liveswitch.StringExtensions.getLength(level))));
                        }
                        var hexBytes = fm.liveswitch.BitAssistant.getHexBytes(profile);
                        var buffer2 = fm.liveswitch.BitAssistant.getHexBytes(level);
                        this.setProfileIdc(hexBytes[0]);
                        this.setProfileIop(new fm.liveswitch.h264.ProfileIop(hexBytes[1]));
                        this.setLevelIdc(buffer2[0]);
                    }
                    else if (__arguments.length == 3) {
                        var profileIdc = __arguments[0];
                        var profileIop = __arguments[1];
                        var levelIdc = __arguments[2];
                        //super();
                        this.fmliveswitchh264ProfileLevelIdInit();
                        this.setProfileIdc(profileIdc);
                        this.setProfileIop(new fm.liveswitch.h264.ProfileIop(profileIop));
                        this.setLevelIdc(levelIdc);
                    }
                    else if (__arguments.length == 1) {
                        var profileLevelId = __arguments[0];
                        //super();
                        this.fmliveswitchh264ProfileLevelIdInit();
                        if ((fm.liveswitch.Global.equals(profileLevelId, null))) {
                            throw new fm.liveswitch.Exception("Cannot initialize with null profile level ID.");
                        }
                        if ((!fm.liveswitch.Global.equals(fm.liveswitch.StringExtensions.getLength(profileLevelId), 6))) {
                            throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Invalid profile level ID. (Length was {0} and should be 6.)", fm.liveswitch.NumberExtensions.toString(fm.liveswitch.StringExtensions.getLength(profileLevelId))));
                        }
                        var hexBytes = fm.liveswitch.BitAssistant.getHexBytes(fm.liveswitch.StringExtensions.substring(profileLevelId, 0, 2));
                        var buffer2 = fm.liveswitch.BitAssistant.getHexBytes(fm.liveswitch.StringExtensions.substring(profileLevelId, 2, 2));
                        var buffer3 = fm.liveswitch.BitAssistant.getHexBytes(fm.liveswitch.StringExtensions.substring(profileLevelId, 4, 2));
                        this.setProfileIdc(hexBytes[0]);
                        this.setProfileIop(new fm.liveswitch.h264.ProfileIop(buffer2[0]));
                        this.setLevelIdc(buffer3[0]);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                ProfileLevelId.prototype.getTypeString = function () {
                    return '[fm.liveswitch.h264.ProfileLevelId]';
                };
                ProfileLevelId.prototype.fmliveswitchh264ProfileLevelIdInit = function () {
                    this._levelIdc = 0;
                    this._profileIdc = 0;
                };
                /**
                Gets baseline profile level 1.0.
                */
                ProfileLevelId.getBaselineLevel10 = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.h264.ProfileLevelId(66, 0, 10);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets baseline profile level 3.1.
                */
                ProfileLevelId.getBaselineLevel31 = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.h264.ProfileLevelId(66, 0, 31);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets constrained baseline profile level 1.0.
                */
                ProfileLevelId.getConstrainedBaselineLevel10 = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.h264.ProfileLevelId(66, 224, 10);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets constrained baseline profile level 3.1.
                */
                ProfileLevelId.getConstrainedBaselineLevel31 = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.h264.ProfileLevelId(66, 224, 31);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets [[fm.liveswitch.h264.profileLevelId.constrainedBaselineLevel31]].
                */
                ProfileLevelId.getDefault = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.h264.ProfileLevelId.getConstrainedBaselineLevel31();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets high profile level 5.0.
                */
                ProfileLevelId.getHighLevel50 = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.h264.ProfileLevelId(100, 0, 50);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets main profile level 5.0.
                */
                ProfileLevelId.getMainLevel50 = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.h264.ProfileLevelId(77, 0, 50);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the level.
                */
                ProfileLevelId.prototype.getLevel = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.StringExtensions.substring(this.toString(), 4, 2);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the level ID code.
                */
                ProfileLevelId.prototype.getLevelIdc = function () {
                    if (arguments.length == 0) {
                        return this._levelIdc;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the max encoding info value for the given level.
                @return EncodingInfo relating to the h264 profile level
                */
                ProfileLevelId.prototype.getMaxEncoding = function () {
                    if (arguments.length == 0) {
                        if (fm.liveswitch.StringExtensions.isEqual(this.getLevel(), "0a", fm.liveswitch.StringComparison.OrdinalIgnoreCase)) {
                            var info = new fm.liveswitch.EncodingInfo();
                            info.setBitrate(64);
                            info.setFrameRate(15);
                            info.setSize(new fm.liveswitch.Size(176, 144));
                            return info;
                        }
                        if (fm.liveswitch.StringExtensions.isEqual(this.getLevel(), "0b", fm.liveswitch.StringComparison.OrdinalIgnoreCase)) {
                            var info2 = new fm.liveswitch.EncodingInfo();
                            info2.setBitrate(192);
                            info2.setFrameRate(7.5);
                            info2.setSize(new fm.liveswitch.Size(352, 288));
                            return info2;
                        }
                        if (fm.liveswitch.StringExtensions.isEqual(this.getLevel(), "0c", fm.liveswitch.StringComparison.OrdinalIgnoreCase)) {
                            var info3 = new fm.liveswitch.EncodingInfo();
                            info3.setBitrate(384);
                            info3.setFrameRate(15.2);
                            info3.setSize(new fm.liveswitch.Size(352, 288));
                            return info3;
                        }
                        if (fm.liveswitch.StringExtensions.isEqual(this.getLevel(), "0d", fm.liveswitch.StringComparison.OrdinalIgnoreCase)) {
                            var info4 = new fm.liveswitch.EncodingInfo();
                            info4.setBitrate(768);
                            info4.setFrameRate(30);
                            info4.setSize(new fm.liveswitch.Size(352, 288));
                            return info4;
                        }
                        if (fm.liveswitch.StringExtensions.isEqual(this.getLevel(), "14", fm.liveswitch.StringComparison.OrdinalIgnoreCase)) {
                            var info5 = new fm.liveswitch.EncodingInfo();
                            info5.setBitrate(2000);
                            info5.setFrameRate(30);
                            info5.setSize(new fm.liveswitch.Size(352, 288));
                            return info5;
                        }
                        if (fm.liveswitch.StringExtensions.isEqual(this.getLevel(), "15", fm.liveswitch.StringComparison.OrdinalIgnoreCase)) {
                            var info6 = new fm.liveswitch.EncodingInfo();
                            info6.setBitrate(4000);
                            info6.setFrameRate(25);
                            info6.setSize(new fm.liveswitch.Size(352, 576));
                            return info6;
                        }
                        if (fm.liveswitch.StringExtensions.isEqual(this.getLevel(), "16", fm.liveswitch.StringComparison.OrdinalIgnoreCase)) {
                            var info7 = new fm.liveswitch.EncodingInfo();
                            info7.setBitrate(4000);
                            info7.setFrameRate(12.5);
                            info7.setSize(new fm.liveswitch.Size(720, 576));
                            return info7;
                        }
                        if (fm.liveswitch.StringExtensions.isEqual(this.getLevel(), "1e", fm.liveswitch.StringComparison.OrdinalIgnoreCase)) {
                            var info8 = new fm.liveswitch.EncodingInfo();
                            info8.setBitrate(10000);
                            info8.setFrameRate(25);
                            info8.setSize(new fm.liveswitch.Size(720, 576));
                            return info8;
                        }
                        if (fm.liveswitch.StringExtensions.isEqual(this.getLevel(), "1f", fm.liveswitch.StringComparison.OrdinalIgnoreCase)) {
                            var info9 = new fm.liveswitch.EncodingInfo();
                            info9.setBitrate(14000);
                            info9.setFrameRate(30);
                            info9.setSize(new fm.liveswitch.Size(1280, 720));
                            return info9;
                        }
                        if (fm.liveswitch.StringExtensions.isEqual(this.getLevel(), "20", fm.liveswitch.StringComparison.OrdinalIgnoreCase)) {
                            var info10 = new fm.liveswitch.EncodingInfo();
                            info10.setBitrate(20000);
                            info10.setFrameRate(42.2);
                            info10.setSize(new fm.liveswitch.Size(1280, 1024));
                            return info10;
                        }
                        if (fm.liveswitch.StringExtensions.isEqual(this.getLevel(), "28", fm.liveswitch.StringComparison.OrdinalIgnoreCase)) {
                            var info11 = new fm.liveswitch.EncodingInfo();
                            info11.setBitrate(20000);
                            info11.setFrameRate(30);
                            info11.setSize(new fm.liveswitch.Size(2048, 1024));
                            return info11;
                        }
                        if (fm.liveswitch.StringExtensions.isEqual(this.getLevel(), "29", fm.liveswitch.StringComparison.OrdinalIgnoreCase)) {
                            var info12 = new fm.liveswitch.EncodingInfo();
                            info12.setBitrate(50000);
                            info12.setFrameRate(30);
                            info12.setSize(new fm.liveswitch.Size(2048, 1024));
                            return info12;
                        }
                        if (fm.liveswitch.StringExtensions.isEqual(this.getLevel(), "2a", fm.liveswitch.StringComparison.OrdinalIgnoreCase)) {
                            var info13 = new fm.liveswitch.EncodingInfo();
                            info13.setBitrate(50000);
                            info13.setFrameRate(60);
                            info13.setSize(new fm.liveswitch.Size(2048, 1080));
                            return info13;
                        }
                        if (fm.liveswitch.StringExtensions.isEqual(this.getLevel(), "32", fm.liveswitch.StringComparison.OrdinalIgnoreCase)) {
                            var info14 = new fm.liveswitch.EncodingInfo();
                            info14.setBitrate(135000);
                            info14.setFrameRate(26.7);
                            info14.setSize(new fm.liveswitch.Size(3672, 1536));
                            return info14;
                        }
                        if (fm.liveswitch.StringExtensions.isEqual(this.getLevel(), "33", fm.liveswitch.StringComparison.OrdinalIgnoreCase)) {
                            var info15 = new fm.liveswitch.EncodingInfo();
                            info15.setBitrate(240000);
                            info15.setFrameRate(26.7);
                            info15.setSize(new fm.liveswitch.Size(4096, 2304));
                            return info15;
                        }
                        if (fm.liveswitch.StringExtensions.isEqual(this.getLevel(), "34", fm.liveswitch.StringComparison.OrdinalIgnoreCase)) {
                            var info16 = new fm.liveswitch.EncodingInfo();
                            info16.setBitrate(240000);
                            info16.setFrameRate(56.3);
                            info16.setSize(new fm.liveswitch.Size(4096, 2304));
                            return info16;
                        }
                        if (fm.liveswitch.StringExtensions.isEqual(this.getLevel(), "3c", fm.liveswitch.StringComparison.OrdinalIgnoreCase)) {
                            var info17 = new fm.liveswitch.EncodingInfo();
                            info17.setBitrate(240000);
                            info17.setFrameRate(30.2);
                            info17.setSize(new fm.liveswitch.Size(8192, 4320));
                            return info17;
                        }
                        if (fm.liveswitch.StringExtensions.isEqual(this.getLevel(), "3d", fm.liveswitch.StringComparison.OrdinalIgnoreCase)) {
                            var info18 = new fm.liveswitch.EncodingInfo();
                            info18.setBitrate(480000);
                            info18.setFrameRate(60.4);
                            info18.setSize(new fm.liveswitch.Size(8192, 4320));
                            return info18;
                        }
                        if (fm.liveswitch.StringExtensions.isEqual(this.getLevel(), "3e", fm.liveswitch.StringComparison.OrdinalIgnoreCase)) {
                            var info19 = new fm.liveswitch.EncodingInfo();
                            info19.setBitrate(800000);
                            info19.setFrameRate(120.9);
                            info19.setSize(new fm.liveswitch.Size(8192, 4320));
                            return info19;
                        }
                        var info20 = new fm.liveswitch.EncodingInfo();
                        info20.setBitrate(64);
                        info20.setFrameRate(15);
                        info20.setSize(new fm.liveswitch.Size(176, 144));
                        return info20;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the profile.
                */
                ProfileLevelId.prototype.getProfile = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.StringExtensions.substring(this.toString(), 0, 4);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the profile ID Code.
                */
                ProfileLevelId.prototype.getProfileIdc = function () {
                    if (arguments.length == 0) {
                        return this._profileIdc;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the profile constraints.
                */
                ProfileLevelId.prototype.getProfileIop = function () {
                    if (arguments.length == 0) {
                        return this._profileIop;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the level ID code.
                */
                ProfileLevelId.prototype.setLevelIdc = function (value) {
                    if (arguments.length == 1) {
                        this._levelIdc = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the profile ID Code.
                */
                ProfileLevelId.prototype.setProfileIdc = function (value) {
                    if (arguments.length == 1) {
                        this._profileIdc = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Sets the profile constraints.
                */
                ProfileLevelId.prototype.setProfileIop = function (value) {
                    if (arguments.length == 1) {
                        this._profileIop = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Returns a string that represents this instance.
                */
                ProfileLevelId.prototype.toString = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.BitAssistant.getHexString(new Uint8Array([this.getProfileIdc(), this.getProfileIop().getDataBuffer().read8(0), this.getLevelIdc()]));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ProfileLevelId;
            }());
            h264.ProfileLevelId = ProfileLevelId;
        })(h264 = liveswitch.h264 || (liveswitch.h264 = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var IceConnectionStateWrapper = /** @class */ (function () {
            function IceConnectionStateWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_47 = __arguments[0];
                    //super();
                    this._value = value_47;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            IceConnectionStateWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.IceConnectionStateWrapper]';
            };
            IceConnectionStateWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.IceConnectionState.New)
                        return 'New';
                    if (this._value == fm.liveswitch.IceConnectionState.Checking)
                        return 'Checking';
                    if (this._value == fm.liveswitch.IceConnectionState.Connected)
                        return 'Connected';
                    if (this._value == fm.liveswitch.IceConnectionState.Completed)
                        return 'Completed';
                    if (this._value == fm.liveswitch.IceConnectionState.Failed)
                        return 'Failed';
                    if (this._value == fm.liveswitch.IceConnectionState.Disconnected)
                        return 'Disconnected';
                    if (this._value == fm.liveswitch.IceConnectionState.Closed)
                        return 'Closed';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return IceConnectionStateWrapper;
        }());
        liveswitch.IceConnectionStateWrapper = IceConnectionStateWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var IceGatheringStateWrapper = /** @class */ (function () {
            function IceGatheringStateWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_48 = __arguments[0];
                    //super();
                    this._value = value_48;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            IceGatheringStateWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.IceGatheringStateWrapper]';
            };
            IceGatheringStateWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.IceGatheringState.New)
                        return 'New';
                    if (this._value == fm.liveswitch.IceGatheringState.Gathering)
                        return 'Gathering';
                    if (this._value == fm.liveswitch.IceGatheringState.Complete)
                        return 'Complete';
                    if (this._value == fm.liveswitch.IceGatheringState.Closing)
                        return 'Closing';
                    if (this._value == fm.liveswitch.IceGatheringState.Closed)
                        return 'Closed';
                    if (this._value == fm.liveswitch.IceGatheringState.Failed)
                        return 'Failed';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return IceGatheringStateWrapper;
        }());
        liveswitch.IceGatheringStateWrapper = IceGatheringStateWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var IceGatherPolicyWrapper = /** @class */ (function () {
            function IceGatherPolicyWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_49 = __arguments[0];
                    //super();
                    this._value = value_49;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            IceGatherPolicyWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.IceGatherPolicyWrapper]';
            };
            IceGatherPolicyWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.IceGatherPolicy.All)
                        return 'All';
                    if (this._value == fm.liveswitch.IceGatherPolicy.NoHost)
                        return 'NoHost';
                    if (this._value == fm.liveswitch.IceGatherPolicy.Relay)
                        return 'Relay';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return IceGatherPolicyWrapper;
        }());
        liveswitch.IceGatherPolicyWrapper = IceGatherPolicyWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        An ICE server.
        */
        var IceServer = /** @class */ (function () {
            function IceServer() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else if (__arguments.length == 1) {
                    var url = __arguments[0];
                    //super();
                    if (fm.liveswitch.StringExtensions.isNullOrEmpty(url)) {
                        throw new fm.liveswitch.Exception("URL cannot be null or empty.");
                    }
                    if ((fm.liveswitch.StringExtensions.startsWith(url, "turn:") || fm.liveswitch.StringExtensions.startsWith(url, "turns:"))) {
                        throw new fm.liveswitch.Exception("TURN servers require a username and password.");
                    }
                    if (!(fm.liveswitch.StringExtensions.startsWith(url, "stun:") || fm.liveswitch.StringExtensions.startsWith(url, "stuns:"))) {
                        url = fm.liveswitch.StringExtensions.format("stun:{0}", url);
                    }
                    /*if (!fm.liveswitch.StringExtensions.contains(url, "?transport=")) {
                        url = fm.liveswitch.StringExtensions.format("{0}?transport=udp", url);
                    }*/
                    this.setUrl(url);
                }
                else if (__arguments.length == 3) {
                    var url = __arguments[0];
                    var username = __arguments[1];
                    var password = __arguments[2];
                    //super();
                    if (fm.liveswitch.StringExtensions.isNullOrEmpty(url)) {
                        throw new fm.liveswitch.Exception("URL cannot be null or empty.");
                    }
                    if ((fm.liveswitch.Global.equals(username, null))) {
                        throw new fm.liveswitch.Exception("Username cannot be null.");
                    }
                    if ((fm.liveswitch.Global.equals(password, null))) {
                        throw new fm.liveswitch.Exception("Password cannot be null.");
                    }
                    if ((fm.liveswitch.StringExtensions.startsWith(url, "stun:") || fm.liveswitch.StringExtensions.startsWith(url, "stuns:"))) {
                        throw new fm.liveswitch.Exception("STUN servers do not have a username or password.");
                    }
                    if (!(fm.liveswitch.StringExtensions.startsWith(url, "turn:") || fm.liveswitch.StringExtensions.startsWith(url, "turns:"))) {
                        url = fm.liveswitch.StringExtensions.format("turn:{0}", url);
                    }
                    this.setUrl(url);
                    this.setUsername(username);
                    this.setPassword(password);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            IceServer.prototype.getTypeString = function () {
                return '[fm.liveswitch.IceServer]';
            };
            /**
            Deserializes an instance from JSON.
            @param iceServerJson The JSON to deserialize.
            @return The deserialized ICE server.
            */
            IceServer.fromJson = function (iceServerJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(iceServerJson, function () {
                        return new fm.liveswitch.IceServer();
                    }, function (iceServer, name, valueJson) {
                        var str = name;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            if (!(fm.liveswitch.Global.equals(str, "url"))) {
                                if ((fm.liveswitch.Global.equals(str, "username"))) {
                                    iceServer.setUsername(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "password"))) {
                                        iceServer.setPassword(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                    }
                                }
                            }
                            else {
                                var deserializedValueJson = fm.liveswitch.JsonSerializer.deserializeString(valueJson);
                                if (deserializedValueJson.indexOf('stun') === 0) {
                                    deserializedValueJson = deserializedValueJson.replace('?transport=udp', '');
                                }
                                iceServer.setUrl(deserializedValueJson);
                            }
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array of instances from JSON.
            @param iceServersJson The JSON to deserialize.
            @return The deserialized ICE server array.
            */
            IceServer.fromJsonArray = function (iceServersJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(iceServersJson, fm.liveswitch.IceServer.fromJson.bind(fm.liveswitch.IceServer));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the default non-secure port (in use for STUN and TURN).
            */
            IceServer.getDefaultPort = function () {
                if (arguments.length == 0) {
                    fm.liveswitch.Log.warn("Getting the value of IceServer.DefaultPort is deprecated. Get the value of IceServer.DefaultStunsPort/DefaultStunPort/DefaultTurnsPort/DefaultTurnPort instead.");
                    return 3478;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the default STUN port.
            */
            IceServer.getDefaultStunPort = function () {
                if (arguments.length == 0) {
                    return 3478;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the default STUNS port.
            */
            IceServer.getDefaultStunsPort = function () {
                if (arguments.length == 0) {
                    return 5349;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the default TURN port.
            */
            IceServer.getDefaultTurnPort = function () {
                if (arguments.length == 0) {
                    return 3478;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the default TURNS port.
            */
            IceServer.getDefaultTurnsPort = function () {
                if (arguments.length == 0) {
                    return 5349;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            IceServer.parseAddress = function (address, host, port) {
                if (arguments.length == 3) {
                    var strArray = void 0;
                    host.setValue(null);
                    port.setValue(-1);
                    if ((fm.liveswitch.Global.equals(address, null))) {
                        return false;
                    }
                    address = fm.liveswitch.StringExtensions.split(address, [63])[0];
                    if ((((fm.liveswitch.StringExtensions.startsWith(address, "stun:") || fm.liveswitch.StringExtensions.startsWith(address, "stuns:")) || fm.liveswitch.StringExtensions.startsWith(address, "turn:")) || fm.liveswitch.StringExtensions.startsWith(address, "turns:"))) {
                        address = address.substring((fm.liveswitch.StringExtensions.indexOf(address, ":") + 1));
                    }
                    if (fm.liveswitch.StringExtensions.startsWith(address, "[")) {
                        address = fm.liveswitch.StringExtensions.substring(address, 1, (fm.liveswitch.StringExtensions.getLength(address) - 1));
                        strArray = fm.liveswitch.StringExtensions.split(address, [93]);
                        host.setValue(strArray[0]);
                        if (((strArray.length > 1) && fm.liveswitch.StringExtensions.startsWith(strArray[1], ":"))) {
                            port.setValue(fm.liveswitch.IceServer.parsePort(strArray[1].substring(1)));
                        }
                    }
                    else {
                        strArray = fm.liveswitch.StringExtensions.split(address, [58]);
                        if ((fm.liveswitch.Global.equals(strArray.length, 1))) {
                            host.setValue(address);
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(strArray.length, 2))) {
                                host.setValue(strArray[0]);
                                port.setValue(fm.liveswitch.IceServer.parsePort(strArray[1]));
                            }
                            else {
                                if ((strArray.length > 2)) {
                                    host.setValue(address);
                                }
                            }
                        }
                    }
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            IceServer.parsePort = function (portString) {
                if (arguments.length == 1) {
                    var intResult = -1;
                    var _var0 = new fm.liveswitch.Holder(intResult);
                    var _var1 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(portString, _var0);
                    intResult = _var0.getValue();
                    if (!_var1) {
                        throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Could not parse port when trying to interpret uri in the IceServer constructor. Please verify that the port was given as an integer. Tried parsing value {0}.", portString));
                    }
                    return intResult;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param iceServer The ICE server.
            @return
                        The serialized JSON.
                
            */
            IceServer.toJson = function (iceServer) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(iceServer, function (i, jsonObject) {
                        if ((!fm.liveswitch.Global.equals(iceServer.getUrl(), null))) {
                            jsonObject["url"] = fm.liveswitch.JsonSerializer.serializeString(iceServer.getUrl());
                        }
                        if ((!fm.liveswitch.Global.equals(iceServer.getUsername(), null))) {
                            jsonObject["username"] = fm.liveswitch.JsonSerializer.serializeString(iceServer.getUsername());
                        }
                        if ((!fm.liveswitch.Global.equals(iceServer.getPassword(), null))) {
                            jsonObject["password"] = fm.liveswitch.JsonSerializer.serializeString(iceServer.getPassword());
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array of instances to JSON.
            @param iceServers The ICE servers.
            @return
                        The serialized JSON.
                
            */
            IceServer.toJsonArray = function (iceServers) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(iceServers, fm.liveswitch.IceServer.toJson.bind(fm.liveswitch.IceServer));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the host.
            */
            IceServer.prototype.getHost = function () {
                if (arguments.length == 0) {
                    var host = null;
                    var port = -1;
                    var _var0 = new fm.liveswitch.Holder(host);
                    var _var1 = new fm.liveswitch.Holder(port);
                    var _var2 = fm.liveswitch.IceServer.parseAddress(this.getUrl(), _var0, _var1);
                    host = _var0.getValue();
                    port = _var1.getValue();
                    return host;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            IceServer.prototype.getIPAddress = function () {
                if (arguments.length == 0) {
                    if ((((fm.liveswitch.Global.equals(this.__ipAddress, null)) && (!fm.liveswitch.Global.equals(this.__ipAddresses, null))) && (this.__ipAddresses.length > 0))) {
                        this.__ipAddress = this.__ipAddresses[0];
                    }
                    return this.__ipAddress;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            IceServer.prototype.getIPAddresses = function () {
                if (arguments.length == 0) {
                    if (((fm.liveswitch.Global.equals(this.__ipAddresses, null)) && (!fm.liveswitch.Global.equals(this.__ipAddress, null)))) {
                        this.__ipAddresses = [this.__ipAddress];
                    }
                    return this.__ipAddresses;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this represents a secure STUN or TURN server.
            */
            IceServer.prototype.getIsSecure = function () {
                if (arguments.length == 0) {
                    return (fm.liveswitch.StringExtensions.startsWith(this.getUrl(), "stuns:") || fm.liveswitch.StringExtensions.startsWith(this.getUrl(), "turns:"));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this represents a STUN server.
            */
            IceServer.prototype.getIsStun = function () {
                if (arguments.length == 0) {
                    return (fm.liveswitch.StringExtensions.startsWith(this.getUrl(), "stun:") || fm.liveswitch.StringExtensions.startsWith(this.getUrl(), "stuns:"));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this represents a TCP server.
            */
            IceServer.prototype.getIsTcp = function () {
                if (arguments.length == 0) {
                    return !fm.liveswitch.StringExtensions.endsWith(this.getUrl(), "?transport=udp");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this represents a TURN server.
            */
            IceServer.prototype.getIsTurn = function () {
                if (arguments.length == 0) {
                    return (fm.liveswitch.StringExtensions.startsWith(this.getUrl(), "turn:") || fm.liveswitch.StringExtensions.startsWith(this.getUrl(), "turns:"));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this represents a UDP server.
            */
            IceServer.prototype.getIsUdp = function () {
                if (arguments.length == 0) {
                    return !fm.liveswitch.StringExtensions.endsWith(this.getUrl(), "?transport=tcp");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the password.
            */
            IceServer.prototype.getPassword = function () {
                if (arguments.length == 0) {
                    return this._password;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the port.
            */
            IceServer.prototype.getPort = function () {
                if (arguments.length == 0) {
                    var host = null;
                    var port = -1;
                    var _var0 = new fm.liveswitch.Holder(host);
                    var _var1 = new fm.liveswitch.Holder(port);
                    var _var2 = fm.liveswitch.IceServer.parseAddress(this.getUrl(), _var0, _var1);
                    host = _var0.getValue();
                    port = _var1.getValue();
                    if ((fm.liveswitch.Global.equals(port, -1))) {
                        if (!(this.getIsSecure() || !this.getIsTurn())) {
                            return fm.liveswitch.IceServer.getDefaultTurnPort();
                        }
                        if (!(this.getIsSecure() || !this.getIsStun())) {
                            return fm.liveswitch.IceServer.getDefaultStunPort();
                        }
                        if ((this.getIsSecure() && this.getIsTurn())) {
                            return fm.liveswitch.IceServer.getDefaultTurnsPort();
                        }
                        return fm.liveswitch.IceServer.getDefaultStunsPort();
                    }
                    return port;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the URL.
            */
            IceServer.prototype.getUrl = function () {
                if (arguments.length == 0) {
                    return this._url;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the username.
            */
            IceServer.prototype.getUsername = function () {
                if (arguments.length == 0) {
                    return this._username;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            IceServer.prototype.setIPAddress = function (value) {
                if (arguments.length == 1) {
                    this.__ipAddress = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            IceServer.prototype.setIPAddresses = function (value) {
                if (arguments.length == 1) {
                    this.__ipAddresses = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            IceServer.prototype.setPassword = function (value) {
                if (arguments.length == 1) {
                    this._password = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            IceServer.prototype.setUrl = function (value) {
                if (arguments.length == 1) {
                    this._url = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            IceServer.prototype.setUsername = function (value) {
                if (arguments.length == 1) {
                    this._username = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            @return
                        The serialized JSON.
                
            */
            IceServer.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.IceServer.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return IceServer;
        }());
        liveswitch.IceServer = IceServer;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Collection.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        An ICE server collection.
        */
        var IceServerCollection = /** @class */ (function (_super) {
            __extends(IceServerCollection, _super);
            function IceServerCollection() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            IceServerCollection.prototype.getTypeString = function () {
                return '[fm.liveswitch.IceServerCollection]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Creates an array from a list.
            @param list The list.
            */
            IceServerCollection.prototype.arrayFromList = function (list) {
                if (arguments.length == 1) {
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a collection.
            */
            IceServerCollection.prototype.createCollection = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.IceServerCollection();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return IceServerCollection;
        }(fm.liveswitch.Collection));
        liveswitch.IceServerCollection = IceServerCollection;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A layout definition, including local and remote frame definitions.
        */
        var Layout = /** @class */ (function () {
            function Layout() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchLayoutInit();
                    this.__localFrame = new fm.liveswitch.LayoutFrame(0, 0, 0, 0);
                    this.__remoteFrames = new Array(0);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Layout.prototype.getTypeString = function () {
                return '[fm.liveswitch.Layout]';
            };
            Layout.prototype.fmliveswitchLayoutInit = function () {
                this._height = 0;
                this._width = 0;
            };
            /**
            Gets all frames (local and remote).
            */
            Layout.prototype.getAllFrames = function () {
                if (arguments.length == 0) {
                    var list = new Array();
                    fm.liveswitch.ArrayExtensions.add(list, this.getLocalFrame());
                    fm.liveswitch.ArrayExtensions.addRange(list, this.getRemoteFrames());
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the layout height.
            */
            Layout.prototype.getHeight = function () {
                if (arguments.length == 0) {
                    return this._height;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the local frame.
            */
            Layout.prototype.getLocalFrame = function () {
                if (arguments.length == 0) {
                    return this.__localFrame;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the layout origin.
            */
            Layout.prototype.getOrigin = function () {
                if (arguments.length == 0) {
                    return this._origin;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote frames.
            */
            Layout.prototype.getRemoteFrames = function () {
                if (arguments.length == 0) {
                    return this.__remoteFrames;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the layout width.
            */
            Layout.prototype.getWidth = function () {
                if (arguments.length == 0) {
                    return this._width;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the layout height.
            */
            Layout.prototype.setHeight = function (value) {
                if (arguments.length == 1) {
                    this._height = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the local frame.
            */
            Layout.prototype.setLocalFrame = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(value, null))) {
                        this.__localFrame = new fm.liveswitch.LayoutFrame(0, 0, 0, 0);
                    }
                    else {
                        this.__localFrame = value;
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the layout origin.
            */
            Layout.prototype.setOrigin = function (value) {
                if (arguments.length == 1) {
                    this._origin = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote frames.
            */
            Layout.prototype.setRemoteFrames = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(value, null))) {
                        this.__remoteFrames = new Array(0);
                    }
                    else {
                        this.__remoteFrames = value;
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the layout width.
            */
            Layout.prototype.setWidth = function (value) {
                if (arguments.length == 1) {
                    this._width = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Swaps the properties of two frames.
            @param frame1 The first frame.
            @param frame2 The second frame.
            */
            Layout.prototype.swapFrames = function (frame1, frame2) {
                if (arguments.length == 2) {
                    var x = frame1.getX();
                    var y = frame1.getY();
                    var width = frame1.getWidth();
                    var height = frame1.getHeight();
                    frame1.setX(frame2.getX());
                    frame1.setY(frame2.getY());
                    frame1.setWidth(frame2.getWidth());
                    frame1.setHeight(frame2.getHeight());
                    frame2.setX(x);
                    frame2.setY(y);
                    frame2.setWidth(width);
                    frame2.setHeight(height);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Swaps the local frame with a remote frame.
            @param remoteFrameIndex The index of the remote frame.
            */
            Layout.prototype.swapLocalFrame = function (remoteFrameIndex) {
                if (arguments.length == 1) {
                    var localFrame = this.getLocalFrame();
                    var remoteFrames = this.getRemoteFrames();
                    if (((!fm.liveswitch.Global.equals(localFrame, null)) && (remoteFrameIndex < remoteFrames.length))) {
                        this.swapFrames(localFrame, remoteFrames[remoteFrameIndex]);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Swaps two remote frames.
            @param remoteFrameIndex1 The index of the first remote frame.
            @param remoteFrameIndex2 The index of the second remote frame.
            */
            Layout.prototype.swapRemoteFrames = function (remoteFrameIndex1, remoteFrameIndex2) {
                if (arguments.length == 2) {
                    var remoteFrames = this.getRemoteFrames();
                    if (((remoteFrameIndex1 < remoteFrames.length) && (remoteFrameIndex2 < remoteFrames.length))) {
                        this.swapFrames(remoteFrames[remoteFrameIndex1], remoteFrames[remoteFrameIndex2]);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Layout;
        }());
        liveswitch.Layout = Layout;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var LayoutAlignmentWrapper = /** @class */ (function () {
            function LayoutAlignmentWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_50 = __arguments[0];
                    //super();
                    this._value = value_50;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            LayoutAlignmentWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.LayoutAlignmentWrapper]';
            };
            LayoutAlignmentWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.LayoutAlignment.TopLeft)
                        return 'TopLeft';
                    if (this._value == fm.liveswitch.LayoutAlignment.Top)
                        return 'Top';
                    if (this._value == fm.liveswitch.LayoutAlignment.TopRight)
                        return 'TopRight';
                    if (this._value == fm.liveswitch.LayoutAlignment.Left)
                        return 'Left';
                    if (this._value == fm.liveswitch.LayoutAlignment.Center)
                        return 'Center';
                    if (this._value == fm.liveswitch.LayoutAlignment.Right)
                        return 'Right';
                    if (this._value == fm.liveswitch.LayoutAlignment.BottomLeft)
                        return 'BottomLeft';
                    if (this._value == fm.liveswitch.LayoutAlignment.Bottom)
                        return 'Bottom';
                    if (this._value == fm.liveswitch.LayoutAlignment.BottomRight)
                        return 'BottomRight';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return LayoutAlignmentWrapper;
        }());
        liveswitch.LayoutAlignmentWrapper = LayoutAlignmentWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var LayoutDirectionWrapper = /** @class */ (function () {
            function LayoutDirectionWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_51 = __arguments[0];
                    //super();
                    this._value = value_51;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            LayoutDirectionWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.LayoutDirectionWrapper]';
            };
            LayoutDirectionWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.LayoutDirection.Horizontal)
                        return 'Horizontal';
                    if (this._value == fm.liveswitch.LayoutDirection.Vertical)
                        return 'Vertical';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return LayoutDirectionWrapper;
        }());
        liveswitch.LayoutDirectionWrapper = LayoutDirectionWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var LayoutModeWrapper = /** @class */ (function () {
            function LayoutModeWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_52 = __arguments[0];
                    //super();
                    this._value = value_52;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            LayoutModeWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.LayoutModeWrapper]';
            };
            LayoutModeWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.LayoutMode.FloatLocal)
                        return 'FloatLocal';
                    if (this._value == fm.liveswitch.LayoutMode.FloatRemote)
                        return 'FloatRemote';
                    if (this._value == fm.liveswitch.LayoutMode.Block)
                        return 'Block';
                    if (this._value == fm.liveswitch.LayoutMode.Inline)
                        return 'Inline';
                    if (this._value == fm.liveswitch.LayoutMode.InlineOverflow)
                        return 'InlineOverflow';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return LayoutModeWrapper;
        }());
        liveswitch.LayoutModeWrapper = LayoutModeWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var LayoutOriginWrapper = /** @class */ (function () {
            function LayoutOriginWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_53 = __arguments[0];
                    //super();
                    this._value = value_53;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            LayoutOriginWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.LayoutOriginWrapper]';
            };
            LayoutOriginWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.LayoutOrigin.TopLeft)
                        return 'TopLeft';
                    if (this._value == fm.liveswitch.LayoutOrigin.TopRight)
                        return 'TopRight';
                    if (this._value == fm.liveswitch.LayoutOrigin.BottomRight)
                        return 'BottomRight';
                    if (this._value == fm.liveswitch.LayoutOrigin.BottomLeft)
                        return 'BottomLeft';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return LayoutOriginWrapper;
        }());
        liveswitch.LayoutOriginWrapper = LayoutOriginWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Defines the results of a layout calculation.
        */
        var LayoutTable = /** @class */ (function () {
            /**
            Initializes a new instance of the [[fm.liveswitch.layoutTable]] class.
            @param columnCount The column count.
            @param rowCount The row count.
            @param cellWidth The width of each cell.
            @param cellHeight The height of each cell.
            */
            function LayoutTable(columnCount, rowCount, cellWidth, cellHeight) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 4) {
                    var columnCount_1 = __arguments[0];
                    var rowCount_1 = __arguments[1];
                    var cellWidth_1 = __arguments[2];
                    var cellHeight_1 = __arguments[3];
                    //super();
                    this.fmliveswitchLayoutTableInit();
                    this.setColumnCount(columnCount_1);
                    this.setRowCount(rowCount_1);
                    this.setCellWidth(cellWidth_1);
                    this.setCellHeight(cellHeight_1);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            LayoutTable.prototype.getTypeString = function () {
                return '[fm.liveswitch.LayoutTable]';
            };
            LayoutTable.prototype.fmliveswitchLayoutTableInit = function () {
                this._cellHeight = 0;
                this._cellWidth = 0;
                this._columnCount = 0;
                this._rowCount = 0;
            };
            /**
            Gets the height of each cell.
            */
            LayoutTable.prototype.getCellHeight = function () {
                if (arguments.length == 0) {
                    return this._cellHeight;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the width of each cell.
            */
            LayoutTable.prototype.getCellWidth = function () {
                if (arguments.length == 0) {
                    return this._cellWidth;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the column count.
            */
            LayoutTable.prototype.getColumnCount = function () {
                if (arguments.length == 0) {
                    return this._columnCount;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the row count.
            */
            LayoutTable.prototype.getRowCount = function () {
                if (arguments.length == 0) {
                    return this._rowCount;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the height of each cell.
            */
            LayoutTable.prototype.setCellHeight = function (value) {
                if (arguments.length == 1) {
                    this._cellHeight = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the width of each cell.
            */
            LayoutTable.prototype.setCellWidth = function (value) {
                if (arguments.length == 1) {
                    this._cellWidth = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the column count.
            */
            LayoutTable.prototype.setColumnCount = function (value) {
                if (arguments.length == 1) {
                    this._columnCount = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the row count.
            */
            LayoutTable.prototype.setRowCount = function (value) {
                if (arguments.length == 1) {
                    this._rowCount = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return LayoutTable;
        }());
        liveswitch.LayoutTable = LayoutTable;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var LocalMediaStateWrapper = /** @class */ (function () {
            function LocalMediaStateWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_54 = __arguments[0];
                    //super();
                    this._value = value_54;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            LocalMediaStateWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.LocalMediaStateWrapper]';
            };
            LocalMediaStateWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.LocalMediaState.New)
                        return 'New';
                    if (this._value == fm.liveswitch.LocalMediaState.Starting)
                        return 'Starting';
                    if (this._value == fm.liveswitch.LocalMediaState.Started)
                        return 'Started';
                    if (this._value == fm.liveswitch.LocalMediaState.Stopping)
                        return 'Stopping';
                    if (this._value == fm.liveswitch.LocalMediaState.Stopped)
                        return 'Stopped';
                    if (this._value == fm.liveswitch.LocalMediaState.Destroying)
                        return 'Destroying';
                    if (this._value == fm.liveswitch.LocalMediaState.Destroyed)
                        return 'Destroyed';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return LocalMediaStateWrapper;
        }());
        liveswitch.LocalMediaStateWrapper = LocalMediaStateWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="MediaBuffer.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A video buffer.
        */
        var VideoBuffer = /** @class */ (function (_super) {
            __extends(VideoBuffer, _super);
            function VideoBuffer() {
                var _this = this;
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchVideoBufferInit();
                    _this.__orientation = 0;
                }
                else if (__arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isObjectType(arguments[2], '[fm.liveswitch.DataBuffer]'))) {
                    var width = __arguments[0];
                    var height = __arguments[1];
                    var dataBuffer = __arguments[2];
                    var format = __arguments[3];
                    _this = _super.call(this, dataBuffer, format) || this;
                    _this.fmliveswitchVideoBufferInit();
                    _this.__orientation = 0;
                    _this.setWidth(width);
                    _this.setHeight(height);
                    _this.setStrides(_this.getDefaultStrides(width, format));
                }
                else if (__arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || (fm.liveswitch.Util.isArray(arguments[2]) && (arguments[2].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[2][0]) || fm.liveswitch.Util.isObjectType(arguments[2][0], '[fm.liveswitch.DataBuffer]')))))) {
                    var width = __arguments[0];
                    var height = __arguments[1];
                    var dataBuffers = __arguments[2];
                    var format = __arguments[3];
                    _this = _super.call(this, dataBuffers, format) || this;
                    _this.fmliveswitchVideoBufferInit();
                    _this.__orientation = 0;
                    _this.setWidth(width);
                    _this.setHeight(height);
                    _this.setStrides(_this.getDefaultStrides(width, format));
                }
                else if (__arguments.length == 5 && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isNumber(arguments[2])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[3]) || fm.liveswitch.Util.isObjectType(arguments[3], '[fm.liveswitch.DataBuffer]'))) {
                    var width = __arguments[0];
                    var height = __arguments[1];
                    var stride = __arguments[2];
                    var dataBuffer = __arguments[3];
                    var format = __arguments[4];
                    _this = _super.call(this, dataBuffer, format) || this;
                    _this.fmliveswitchVideoBufferInit();
                    _this.__orientation = 0;
                    _this.setWidth(width);
                    _this.setHeight(height);
                    _this.setStride(stride);
                }
                else if (__arguments.length == 5 && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || (fm.liveswitch.Util.isArray(arguments[2]) && (arguments[2].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[2][0]) || fm.liveswitch.Util.isNumber(arguments[2][0]))))) && (fm.liveswitch.Util.isNullOrUndefined(arguments[3]) || (fm.liveswitch.Util.isArray(arguments[3]) && (arguments[3].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[3][0]) || fm.liveswitch.Util.isObjectType(arguments[3][0], '[fm.liveswitch.DataBuffer]')))))) {
                    var width = __arguments[0];
                    var height = __arguments[1];
                    var strides = __arguments[2];
                    var dataBuffers = __arguments[3];
                    var format = __arguments[4];
                    _this = _super.call(this, dataBuffers, format) || this;
                    _this.fmliveswitchVideoBufferInit();
                    _this.__orientation = 0;
                    _this.setWidth(width);
                    _this.setHeight(height);
                    _this.setStrides(strides);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            VideoBuffer.prototype.getTypeString = function () {
                return '[fm.liveswitch.VideoBuffer]' + ',' + _super.prototype.getTypeString.call(this);
            };
            VideoBuffer.prototype.fmliveswitchVideoBufferInit = function () {
                this.__height = 0;
                this.__isMuted = false;
                this.__orientation = 0;
                this.__width = 0;
            };
            /** @hidden */
            VideoBuffer.calculateByteCount = function (format, width, height) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 3) {
                    if (format.getIsYuvType()) {
                        return ((width * height) * 1.5);
                    }
                    if (format.getIsRgbType()) {
                        return ((width * height) * 3);
                    }
                    if (format.getIsRgbaType()) {
                        return ((width * height) * 4);
                    }
                    return -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoBuffer.canPackWithoutCopy = function (dataBuffers) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 1) {
                    var data = dataBuffers[0].getData();
                    var index = dataBuffers[0].getIndex();
                    var length_45 = dataBuffers[0].getLength();
                    for (var i = 1; (i < dataBuffers.length); i++) {
                        var buffer2 = dataBuffers[i];
                        if ((!fm.liveswitch.Global.equals(buffer2.getData(), data))) {
                            return false;
                        }
                        if ((!fm.liveswitch.Global.equals(buffer2.getIndex(), (index + length_45)))) {
                            return false;
                        }
                        index = buffer2.getIndex();
                        length_45 = buffer2.getLength();
                    }
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoBuffer.clamp = function (value) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.MathAssistant.max(0, fm.liveswitch.MathAssistant.min(255, fm.liveswitch.MathAssistant.round(value)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a black (0, 0, 0) video buffer with the specified width/height.
            @param width The width.
            @param height The height.
            @param formatName Name of the format.
            */
            VideoBuffer.createBlack = function (width, height, formatName) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 3) {
                    return fm.liveswitch.VideoBuffer.createCustom(width, height, 0, 0, 0, formatName);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a blue (0, 0, 255) video buffer with the specified width/height.
            @param width The width.
            @param height The height.
            @param formatName Name of the format.
            */
            VideoBuffer.createBlue = function (width, height, formatName) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 3) {
                    return fm.liveswitch.VideoBuffer.createCustom(width, height, 0, 0, 255, formatName);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            VideoBuffer.createCustom = function () {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 6) {
                    var width = arguments[0];
                    var height = arguments[1];
                    var red = arguments[2];
                    var green = arguments[3];
                    var blue = arguments[4];
                    var formatName = arguments[5];
                    return fm.liveswitch.VideoBuffer.createCustom(width, height, red, green, blue, formatName, null);
                }
                else if (arguments.length == 7) {
                    var width = arguments[0];
                    var height = arguments[1];
                    var red = arguments[2];
                    var green = arguments[3];
                    var blue = arguments[4];
                    var formatName = arguments[5];
                    var buffer = arguments[6];
                    var num3 = void 0;
                    var num4 = void 0;
                    var count = fm.liveswitch.VideoBuffer.getMinimumBufferLength(width, height, formatName);
                    if ((fm.liveswitch.Global.equals(count, -1))) {
                        throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Could not create custom video buffer. Format '{0}' is not supported.", formatName));
                    }
                    if ((fm.liveswitch.Global.equals(buffer, null))) {
                        buffer = fm.liveswitch.DataBuffer.allocate(count);
                    }
                    if ((buffer.getLength() < count)) {
                        throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Buffer too small. Minimum buffer length is {0} but buffer length is {1}.", fm.liveswitch.NumberExtensions.toString(count), fm.liveswitch.NumberExtensions.toString(buffer.getLength())));
                    }
                    var flag = fm.liveswitch.StringExtensions.isEqual(fm.liveswitch.VideoFormat.getBgrName(), formatName, fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                    var flag2 = fm.liveswitch.StringExtensions.isEqual(fm.liveswitch.VideoFormat.getRgbName(), formatName, fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                    var flag3 = (flag || flag2);
                    var flag4 = fm.liveswitch.StringExtensions.isEqual(fm.liveswitch.VideoFormat.getBgraName(), formatName, fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                    var flag5 = fm.liveswitch.StringExtensions.isEqual(fm.liveswitch.VideoFormat.getRgbaName(), formatName, fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                    var flag6 = fm.liveswitch.StringExtensions.isEqual(fm.liveswitch.VideoFormat.getAbgrName(), formatName, fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                    var flag7 = fm.liveswitch.StringExtensions.isEqual(fm.liveswitch.VideoFormat.getArgbName(), formatName, fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                    var flag8 = (((flag4 || flag5) || flag6) || flag7);
                    var flag9 = fm.liveswitch.StringExtensions.isEqual(fm.liveswitch.VideoFormat.getI420Name(), formatName, fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                    var flag10 = fm.liveswitch.StringExtensions.isEqual(fm.liveswitch.VideoFormat.getYv12Name(), formatName, fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                    var flag11 = fm.liveswitch.StringExtensions.isEqual(fm.liveswitch.VideoFormat.getNv12Name(), formatName, fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                    var flag12 = fm.liveswitch.StringExtensions.isEqual(fm.liveswitch.VideoFormat.getNv21Name(), formatName, fm.liveswitch.StringComparison.OrdinalIgnoreCase);
                    var flag13 = (((flag9 || flag10) || flag11) || flag12);
                    var num2 = (width * height);
                    if (flag3) {
                        if (((fm.liveswitch.Global.equals(red, green)) && (fm.liveswitch.Global.equals(red, blue)))) {
                            buffer.set(fm.liveswitch.BitAssistant.castByte(red));
                        }
                        else {
                            num3 = 0;
                            if (flag) {
                                for (num4 = 0; (num4 < num2); num4++) {
                                    buffer.write8(blue, num3++);
                                    buffer.write8(green, num3++);
                                    buffer.write8(red, num3++);
                                }
                            }
                            else {
                                num4 = 0;
                                while ((num4 < num2)) {
                                    buffer.write8(red, num3++);
                                    buffer.write8(green, num3++);
                                    buffer.write8(blue, num3++);
                                    num4++;
                                }
                            }
                        }
                    }
                    else {
                        if (flag8) {
                            num3 = 0;
                            var num5 = 255;
                            if (flag4) {
                                for (num4 = 0; (num4 < num2); num4++) {
                                    buffer.write8(blue, num3++);
                                    buffer.write8(green, num3++);
                                    buffer.write8(red, num3++);
                                    buffer.write8(num5, num3++);
                                }
                            }
                            else {
                                if (flag5) {
                                    for (num4 = 0; (num4 < num2); num4++) {
                                        buffer.write8(red, num3++);
                                        buffer.write8(green, num3++);
                                        buffer.write8(blue, num3++);
                                        buffer.write8(num5, num3++);
                                    }
                                }
                                else {
                                    if (flag6) {
                                        for (num4 = 0; (num4 < num2); num4++) {
                                            buffer.write8(num5, num3++);
                                            buffer.write8(blue, num3++);
                                            buffer.write8(green, num3++);
                                            buffer.write8(red, num3++);
                                        }
                                    }
                                    else {
                                        if (flag7) {
                                            for (num4 = 0; (num4 < num2); num4++) {
                                                buffer.write8(num5, num3++);
                                                buffer.write8(red, num3++);
                                                buffer.write8(green, num3++);
                                                buffer.write8(blue, num3++);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            if (!flag13) {
                                throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Could not create custom video buffer. Format '{0}' is not recognized.", formatName));
                            }
                            var num6 = (((0.299 * red) + (0.587 * green)) + (0.110004 * blue));
                            var num7 = ((((-0.168736 * red) - (0.331264 * green)) + (0.5 * blue)) + 128);
                            var num8 = ((((0.5 * red) - (0.418688 * green)) - (0.081312 * blue)) + 128);
                            var length_46 = num2;
                            buffer.set(fm.liveswitch.BitAssistant.castByte(num6), 0, length_46);
                            if ((flag9 || flag10)) {
                                var num10 = fm.liveswitch.MathAssistant.floor(num2 / 4);
                                var num11 = fm.liveswitch.MathAssistant.floor(num2 / 4);
                                var offset = length_46;
                                var num13 = (length_46 + num10);
                                if (flag10) {
                                    num13 = length_46;
                                    offset = (length_46 + num11);
                                }
                                buffer.set(fm.liveswitch.BitAssistant.castByte(num7), offset, num10);
                                buffer.set(fm.liveswitch.BitAssistant.castByte(num8), num13, num11);
                            }
                            else {
                                var num14 = fm.liveswitch.MathAssistant.floor(num2 / 2);
                                var num15 = length_46;
                                var num16 = 0;
                                var num17 = 1;
                                if (flag12) {
                                    num16 = 1;
                                    num17 = 0;
                                }
                                for (num4 = num15; (num4 < (num15 + num14)); num4 = (num4 + 2)) {
                                    buffer.write8((num15 + num16), num7);
                                    buffer.write8((num15 + num17), num8);
                                }
                            }
                        }
                    }
                    return new fm.liveswitch.VideoBuffer(width, height, buffer, new fm.liveswitch.VideoFormat(formatName));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a cyan (0, 255, 255) video buffer with the specified width/height.
            @param width The width.
            @param height The height.
            @param formatName Name of the format.
            */
            VideoBuffer.createCyan = function (width, height, formatName) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 3) {
                    return fm.liveswitch.VideoBuffer.createCustom(width, height, 0, 255, 255, formatName);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a dark blue (0, 0, 128) video buffer with the specified width/height.
            @param width The width.
            @param height The height.
            @param formatName Name of the format.
            */
            VideoBuffer.createDarkBlue = function (width, height, formatName) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 3) {
                    return fm.liveswitch.VideoBuffer.createCustom(width, height, 0, 0, 128, formatName);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a dark green (0, 128, 0) video buffer with the specified width/height.
            @param width The width.
            @param height The height.
            @param formatName Name of the format.
            */
            VideoBuffer.createDarkGreen = function (width, height, formatName) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 3) {
                    return fm.liveswitch.VideoBuffer.createCustom(width, height, 0, 128, 0, formatName);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a dark red (128, 0, 0) video buffer with the specified width/height.
            @param width The width.
            @param height The height.
            @param formatName Name of the format.
            */
            VideoBuffer.createDarkRed = function (width, height, formatName) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 3) {
                    return fm.liveswitch.VideoBuffer.createCustom(width, height, 128, 0, 0, formatName);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a gray (255, 255, 255) video buffer with the specified width/height.
            @param width The width.
            @param height The height.
            @param formatName Name of the format.
            */
            VideoBuffer.createGray = function (width, height, formatName) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 3) {
                    return fm.liveswitch.VideoBuffer.createCustom(width, height, 128, 128, 128, formatName);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a green (0, 255, 0) video buffer with the specified width/height.
            @param width The width.
            @param height The height.
            @param formatName Name of the format.
            */
            VideoBuffer.createGreen = function (width, height, formatName) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 3) {
                    return fm.liveswitch.VideoBuffer.createCustom(width, height, 0, 255, 0, formatName);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a magenta (255, 0, 255) video buffer with the specified width/height.
            @param width The width.
            @param height The height.
            @param formatName Name of the format.
            */
            VideoBuffer.createMagenta = function (width, height, formatName) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 3) {
                    return fm.liveswitch.VideoBuffer.createCustom(width, height, 255, 0, 255, formatName);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates an olive (128, 128, 0) video buffer with the specified width/height.
            @param width The width.
            @param height The height.
            @param formatName Name of the format.
            */
            VideoBuffer.createOlive = function (width, height, formatName) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 3) {
                    return fm.liveswitch.VideoBuffer.createCustom(width, height, 128, 128, 0, formatName);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a purple (128, 0, 128) video buffer with the specified width/height.
            @param width The width.
            @param height The height.
            @param formatName Name of the format.
            */
            VideoBuffer.createPurple = function (width, height, formatName) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 3) {
                    return fm.liveswitch.VideoBuffer.createCustom(width, height, 128, 0, 128, formatName);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a red (255, 0, 0) video buffer with the specified width/height.
            @param width The width.
            @param height The height.
            @param formatName Name of the format.
            */
            VideoBuffer.createRed = function (width, height, formatName) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 3) {
                    return fm.liveswitch.VideoBuffer.createCustom(width, height, 255, 0, 0, formatName);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a teal (0, 128, 128) video buffer with the specified width/height.
            @param width The width.
            @param height The height.
            @param formatName Name of the format.
            */
            VideoBuffer.createTeal = function (width, height, formatName) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 3) {
                    return fm.liveswitch.VideoBuffer.createCustom(width, height, 0, 128, 128, formatName);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a white (255, 255, 255) video buffer with the specified width/height.
            @param width The width.
            @param height The height.
            @param formatName Name of the format.
            */
            VideoBuffer.createWhite = function (width, height, formatName) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 3) {
                    return fm.liveswitch.VideoBuffer.createCustom(width, height, 255, 255, 255, formatName);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a yellow (255, 255, 0) video buffer with the specified width/height.
            @param width The width.
            @param height The height.
            @param formatName Name of the format.
            */
            VideoBuffer.createYellow = function (width, height, formatName) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 3) {
                    return fm.liveswitch.VideoBuffer.createCustom(width, height, 255, 255, 0, formatName);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an instance from JSON.
            @param videoBufferJson The video buffer JSON.
            */
            VideoBuffer.fromJson = function (videoBufferJson) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(videoBufferJson, function () {
                        return new fm.liveswitch.VideoBuffer();
                    }, function (videoBuffer, name, valueJson) {
                        var _var0 = name;
                        if (_var0 == "width") {
                            do {
                                videoBuffer.setWidth(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "height") {
                            do {
                                videoBuffer.setHeight(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "strides") {
                            do {
                                videoBuffer.setStrides(fm.liveswitch.JsonSerializer.deserializeIntegerArray(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "orientation") {
                            do {
                                videoBuffer.setOrientation(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "isMuted") {
                            do {
                                videoBuffer.setIsMuted(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "dataBuffers") {
                            do {
                                videoBuffer.setDataBuffers(fm.liveswitch.DataBuffer.fromJsonArray(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "format") {
                            do {
                                videoBuffer.setFormat(fm.liveswitch.VideoFormat.fromJson(valueJson));
                                break;
                            } while (false);
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array of instances from JSON.
            @param videoBuffersJson The video buffers JSON.
            */
            VideoBuffer.fromJsonArray = function (videoBuffersJson) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(videoBuffersJson, fm.liveswitch.VideoBuffer.fromJson.bind(fm.liveswitch.VideoBuffer));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the minimum data buffer length for a given width, height, and format.
            @param width The width.
            @param height The height.
            @param formatName Name of the format.
            */
            VideoBuffer.getMinimumBufferLength = function (width, height, formatName) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 3) {
                    var num = (width * height);
                    if (((fm.liveswitch.Global.equals(formatName, fm.liveswitch.VideoFormat.getBgrName())) || (fm.liveswitch.Global.equals(formatName, fm.liveswitch.VideoFormat.getRgbName())))) {
                        return (num * 3);
                    }
                    if (((((fm.liveswitch.Global.equals(formatName, fm.liveswitch.VideoFormat.getBgraName())) || (fm.liveswitch.Global.equals(formatName, fm.liveswitch.VideoFormat.getRgbaName()))) || (fm.liveswitch.Global.equals(formatName, fm.liveswitch.VideoFormat.getAbgrName()))) || (fm.liveswitch.Global.equals(formatName, fm.liveswitch.VideoFormat.getArgbName())))) {
                        return (num * 4);
                    }
                    if (((((fm.liveswitch.Global.equals(formatName, fm.liveswitch.VideoFormat.getNv12Name())) || (fm.liveswitch.Global.equals(formatName, fm.liveswitch.VideoFormat.getNv21Name()))) || (fm.liveswitch.Global.equals(formatName, fm.liveswitch.VideoFormat.getI420Name()))) || (fm.liveswitch.Global.equals(formatName, fm.liveswitch.VideoFormat.getYv12Name())))) {
                        return (num * 1.5);
                    }
                    fm.liveswitch.Log.error(fm.liveswitch.StringExtensions.format("Could not get minimum buffer length. Format '{0}' is not supported.", formatName));
                    return -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param videoBuffer The video buffer.
            */
            VideoBuffer.toJson = function (videoBuffer) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(videoBuffer, function (obj, jsonObject) {
                        jsonObject["width"] = fm.liveswitch.JsonSerializer.serializeInteger(videoBuffer.getWidth());
                        jsonObject["height"] = fm.liveswitch.JsonSerializer.serializeInteger(videoBuffer.getHeight());
                        jsonObject["strides"] = fm.liveswitch.JsonSerializer.serializeIntegerArray(videoBuffer.getStrides());
                        jsonObject["orientation"] = fm.liveswitch.JsonSerializer.serializeInteger(videoBuffer.getOrientation());
                        jsonObject["isMuted"] = fm.liveswitch.JsonSerializer.serializeBoolean(videoBuffer.getIsMuted());
                        jsonObject["dataBuffers"] = fm.liveswitch.DataBuffer.toJsonArray(videoBuffer.getDataBuffers());
                        jsonObject["format"] = fm.liveswitch.VideoFormat.toJson(videoBuffer.getFormat());
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array of instances to JSON.
            @param videoBuffers The video buffers.
            */
            VideoBuffer.toJsonArray = function (videoBuffers) {
                fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(videoBuffers, fm.liveswitch.VideoBuffer.toJson.bind(fm.liveswitch.VideoBuffer));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Clones this instance.
            */
            VideoBuffer.prototype.clone = function () {
                if (arguments.length == 0) {
                    var buffer = _super.prototype.clone.call(this);
                    buffer.setStrides(this.getStrides());
                    buffer.setWidth(this.getWidth());
                    buffer.setHeight(this.getHeight());
                    buffer.setOrientation(this.getOrientation());
                    buffer.__isMuted = this.__isMuted;
                    return buffer;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            VideoBuffer.prototype.convert = function () {
                if (arguments.length == 1) {
                    var format = arguments[0];
                    return this.convert(format, false);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.DataBuffer]'))) {
                    var format = arguments[0];
                    var dataBuffer = arguments[1];
                    var numArray = void 0;
                    var numArray2 = void 0;
                    var numArray3 = void 0;
                    var numArray4 = void 0;
                    var numArray5 = void 0;
                    var numArray6 = void 0;
                    var numArray7 = void 0;
                    if (!(_super.prototype.getFormat.call(this).getIsRaw() && format.getIsRaw())) {
                        throw new fm.liveswitch.Exception("Cannot convert to or from encoded formats.");
                    }
                    if ((fm.liveswitch.Global.equals(dataBuffer, null))) {
                        dataBuffer = fm.liveswitch.DataBuffer.allocate(fm.liveswitch.VideoBuffer.calculateByteCount(format, this.getWidth(), this.getHeight()));
                    }
                    var buffer = new fm.liveswitch.VideoBuffer(this.getWidth(), this.getHeight(), dataBuffer, format);
                    if (_super.prototype.getFormat.call(this).getIsYuvType()) {
                        numArray = null;
                        numArray2 = null;
                        numArray3 = null;
                        var _var0 = new fm.liveswitch.Holder(numArray);
                        var _var1 = new fm.liveswitch.Holder(numArray2);
                        var _var2 = new fm.liveswitch.Holder(numArray3);
                        this.readYuv(_var0, _var1, _var2);
                        numArray = _var0.getValue();
                        numArray2 = _var1.getValue();
                        numArray3 = _var2.getValue();
                        if (format.getIsYuvType()) {
                            buffer.writeYuv(numArray, numArray2, numArray3);
                            return buffer;
                        }
                        numArray4 = null;
                        numArray5 = null;
                        numArray6 = null;
                        numArray7 = null;
                        var _var3 = new fm.liveswitch.Holder(numArray4);
                        var _var4 = new fm.liveswitch.Holder(numArray5);
                        var _var5 = new fm.liveswitch.Holder(numArray6);
                        var _var6 = new fm.liveswitch.Holder(numArray7);
                        this.convertYuvToRgba(numArray, numArray2, numArray3, _var3, _var4, _var5, _var6);
                        numArray4 = _var3.getValue();
                        numArray5 = _var4.getValue();
                        numArray6 = _var5.getValue();
                        numArray7 = _var6.getValue();
                        buffer.writeRgba(numArray4, numArray5, numArray6, numArray7);
                        return buffer;
                    }
                    numArray4 = null;
                    numArray5 = null;
                    numArray6 = null;
                    numArray7 = null;
                    var _var7 = new fm.liveswitch.Holder(numArray4);
                    var _var8 = new fm.liveswitch.Holder(numArray5);
                    var _var9 = new fm.liveswitch.Holder(numArray6);
                    var _var10 = new fm.liveswitch.Holder(numArray7);
                    this.readRgba(_var7, _var8, _var9, _var10);
                    numArray4 = _var7.getValue();
                    numArray5 = _var8.getValue();
                    numArray6 = _var9.getValue();
                    numArray7 = _var10.getValue();
                    if (format.getIsYuvType()) {
                        numArray = null;
                        numArray2 = null;
                        numArray3 = null;
                        var _var11 = new fm.liveswitch.Holder(numArray);
                        var _var12 = new fm.liveswitch.Holder(numArray2);
                        var _var13 = new fm.liveswitch.Holder(numArray3);
                        this.convertRgbaToYuv(numArray4, numArray5, numArray6, numArray7, _var11, _var12, _var13);
                        numArray = _var11.getValue();
                        numArray2 = _var12.getValue();
                        numArray3 = _var13.getValue();
                        buffer.writeYuv(numArray, numArray2, numArray3);
                        return buffer;
                    }
                    buffer.writeRgba(numArray4, numArray5, numArray6, numArray7);
                    return buffer;
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isBoolean(arguments[1]))) {
                    var format = arguments[0];
                    var usePool = arguments[1];
                    if (((fm.liveswitch.Global.equals(format, null)) || _super.prototype.getFormat.call(this).isEquivalent(format, false))) {
                        return this;
                    }
                    var dataBuffer = null;
                    if (usePool) {
                        dataBuffer = fm.liveswitch.VideoBuffer.fm_liveswitch_VideoBuffer___dataBufferPool.take(fm.liveswitch.VideoBuffer.calculateByteCount(format, this.getWidth(), this.getHeight()));
                    }
                    return this.convert(format, dataBuffer);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoBuffer.prototype.convertRgbaToYuv = function (rValues, gValues, bValues, aValues, yValues, uValues, vValues) {
                if (arguments.length == 7) {
                    var num = (this.getWidth() * this.getHeight());
                    yValues.setValue(new Array(num));
                    uValues.setValue(new Array(fm.liveswitch.MathAssistant.floor(num / 4)));
                    vValues.setValue(new Array(fm.liveswitch.MathAssistant.floor(num / 4)));
                    var index = 0;
                    var num3 = 0;
                    for (var i = 0; (i < this.getHeight()); i++) {
                        for (var j = 0; (j < this.getWidth()); j++) {
                            var num6 = rValues[index];
                            var num7 = gValues[index];
                            var num8 = bValues[index];
                            var num9 = 0.299;
                            var num10 = 0.587;
                            var num11 = 0.114;
                            yValues.getValue()[index] = fm.liveswitch.VideoBuffer.clamp((((num9 * num6) + (num10 * num7)) + (num11 * num8)));
                            if (((fm.liveswitch.Global.equals((j % 2), 0)) && (fm.liveswitch.Global.equals((i % 2), 0)))) {
                                var num12 = rValues[index];
                                var num13 = rValues[(index + 1)];
                                var num14 = rValues[(index + this.getWidth())];
                                var num15 = rValues[((index + this.getWidth()) + 1)];
                                var num16 = gValues[index];
                                var num17 = gValues[(index + 1)];
                                var num18 = gValues[(index + this.getWidth())];
                                var num19 = gValues[((index + this.getWidth()) + 1)];
                                var num20 = bValues[index];
                                var num21 = bValues[(index + 1)];
                                var num22 = bValues[(index + this.getWidth())];
                                var num23 = bValues[((index + this.getWidth()) + 1)];
                                var num24 = ((((((-0.5 * num12) * num9) / (1 - num11)) - (((0.5 * num16) * num10) / (1 - num11))) + (0.5 * num20)) + 128);
                                var num25 = ((((((-0.5 * num13) * num9) / (1 - num11)) - (((0.5 * num17) * num10) / (1 - num11))) + (0.5 * num21)) + 128);
                                var num26 = ((((((-0.5 * num14) * num9) / (1 - num11)) - (((0.5 * num18) * num10) / (1 - num11))) + (0.5 * num22)) + 128);
                                var num27 = ((((((-0.5 * num15) * num9) / (1 - num11)) - (((0.5 * num19) * num10) / (1 - num11))) + (0.5 * num23)) + 128);
                                var num28 = ((((0.5 * num12) - (((0.5 * num16) * num10) / (1 - num9))) - (((0.5 * num20) * num11) / (1 - num9))) + 128);
                                var num29 = ((((0.5 * num13) - (((0.5 * num17) * num10) / (1 - num9))) - (((0.5 * num21) * num11) / (1 - num9))) + 128);
                                var num30 = ((((0.5 * num14) - (((0.5 * num18) * num10) / (1 - num9))) - (((0.5 * num22) * num11) / (1 - num9))) + 128);
                                var num31 = ((((0.5 * num15) - (((0.5 * num19) * num10) / (1 - num9))) - (((0.5 * num23) * num11) / (1 - num9))) + 128);
                                uValues.getValue()[num3] = fm.liveswitch.VideoBuffer.clamp(((((num24 + num25) + num26) + num27) / 4));
                                vValues.getValue()[num3] = fm.liveswitch.VideoBuffer.clamp(((((num28 + num29) + num30) + num31) / 4));
                                num3++;
                            }
                            index++;
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoBuffer.prototype.convertYuvToRgba = function (yValues, uValues, vValues, rValues, gValues, bValues, aValues) {
                if (arguments.length == 7) {
                    var num = (this.getWidth() * this.getHeight());
                    rValues.setValue(new Array(num));
                    gValues.setValue(new Array(num));
                    bValues.setValue(new Array(num));
                    aValues.setValue(new Array(num));
                    for (var i = 0; (i < num); i++) {
                        var num3 = yValues[i];
                        var num4 = uValues[fm.liveswitch.MathAssistant.floor(i / 4)];
                        var num5 = vValues[fm.liveswitch.MathAssistant.floor(i / 4)];
                        var num6 = 0.299;
                        var num7 = 0.587;
                        var num8 = 0.114;
                        rValues.getValue()[i] = fm.liveswitch.VideoBuffer.clamp((num3 + ((2 * (num5 - 128)) * (1 - num6))));
                        gValues.getValue()[i] = fm.liveswitch.VideoBuffer.clamp(((num3 - ((((2 * (num4 - 128)) * (1 - num8)) * num8) / num7)) - ((((2 * (num5 - 128)) * (1 - num6)) * num6) / num7)));
                        bValues.getValue()[i] = fm.liveswitch.VideoBuffer.clamp((num3 + ((2 * (num4 - 128)) * (1 - num8))));
                        aValues.getValue()[i] = 255;
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a new instance.
            */
            VideoBuffer.prototype.createInstance = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.VideoBuffer();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the A value at a given index. If the video buffer is not RGBA-type, then this will return 255.
            @param index The index.
            @return The A value.
            */
            VideoBuffer.prototype.getAValue = function (index) {
                if (arguments.length == 1) {
                    if (_super.prototype.getFormat.call(this).getIsRgbaType()) {
                        return _super.prototype.getDataBuffer.call(this).read8(this.getAValueOffset(index));
                    }
                    return 255;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoBuffer.prototype.getAValueOffset = function (index) {
                if (arguments.length == 1) {
                    if ((_super.prototype.getFormat.call(this).getIsRgba() || _super.prototype.getFormat.call(this).getIsBgra())) {
                        return (((fm.liveswitch.MathAssistant.floor(index / this.getWidth()) * this.getStride()) + ((index % this.getWidth()) * 4)) + 3);
                    }
                    if ((_super.prototype.getFormat.call(this).getIsArgb() || _super.prototype.getFormat.call(this).getIsAbgr())) {
                        return ((fm.liveswitch.MathAssistant.floor(index / this.getWidth()) * this.getStride()) + ((index % this.getWidth()) * 4));
                    }
                    return -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the B value at a given index.
            @param index The index.
            @return The B value, or -1 if the video buffer is not RGB/RGBA-type.
            */
            VideoBuffer.prototype.getBValue = function (index) {
                if (arguments.length == 1) {
                    if ((_super.prototype.getFormat.call(this).getIsRgbType() || _super.prototype.getFormat.call(this).getIsRgbaType())) {
                        return _super.prototype.getDataBuffer.call(this).read8(this.getBValueOffset(index));
                    }
                    return -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoBuffer.prototype.getBValueOffset = function (index) {
                if (arguments.length == 1) {
                    if (_super.prototype.getFormat.call(this).getIsRgb()) {
                        return (((fm.liveswitch.MathAssistant.floor(index / this.getWidth()) * this.getStride()) + ((index % this.getWidth()) * 3)) + 2);
                    }
                    if (_super.prototype.getFormat.call(this).getIsBgr()) {
                        return ((fm.liveswitch.MathAssistant.floor(index / this.getWidth()) * this.getStride()) + ((index % this.getWidth()) * 3));
                    }
                    if (_super.prototype.getFormat.call(this).getIsRgba()) {
                        return (((fm.liveswitch.MathAssistant.floor(index / this.getWidth()) * this.getStride()) + ((index % this.getWidth()) * 4)) + 2);
                    }
                    if (_super.prototype.getFormat.call(this).getIsBgra()) {
                        return ((fm.liveswitch.MathAssistant.floor(index / this.getWidth()) * this.getStride()) + ((index % this.getWidth()) * 4));
                    }
                    if (_super.prototype.getFormat.call(this).getIsArgb()) {
                        return (((fm.liveswitch.MathAssistant.floor(index / this.getWidth()) * this.getStride()) + ((index % this.getWidth()) * 4)) + 3);
                    }
                    if (_super.prototype.getFormat.call(this).getIsAbgr()) {
                        return (((fm.liveswitch.MathAssistant.floor(index / this.getWidth()) * this.getStride()) + ((index % this.getWidth()) * 4)) + 1);
                    }
                    return -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoBuffer.prototype.getDefaultStrides = function (width, format) {
                if (arguments.length == 2) {
                    if (format.getIsRgbType()) {
                        return [(width * 3)];
                    }
                    if (format.getIsRgbaType()) {
                        return [(width * 4)];
                    }
                    if ((format.getIsI420() || format.getIsYv12())) {
                        if (this.getIsPacked()) {
                            return [width];
                        }
                        return [width, fm.liveswitch.MathAssistant.floor(width / 2), fm.liveswitch.MathAssistant.floor(width / 2)];
                    }
                    if ((format.getIsNv12() || format.getIsNv21())) {
                        if (this.getIsPacked()) {
                            return [width];
                        }
                        return [width, width];
                    }
                    if (((((!fm.liveswitch.Global.equals(format.getName(), fm.liveswitch.VideoFormat.getVp8Name())) && (!fm.liveswitch.Global.equals(format.getName(), fm.liveswitch.VideoFormat.getVp9Name()))) && ((!fm.liveswitch.Global.equals(format.getName(), fm.liveswitch.VideoFormat.getH264Name())) && (!fm.liveswitch.Global.equals(format.getName(), fm.liveswitch.MediaFormat.getRedName())))) && (!fm.liveswitch.Global.equals(format.getName(), fm.liveswitch.MediaFormat.getUlpFecName())))) {
                        throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.concat("Unsupported video format '", format.getName(), "'."));
                    }
                    return new Array(1);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the G value at a given index.
            @param index The index.
            @return The G value, or -1 if the video buffer is not RGB/RGBA-type.
            */
            VideoBuffer.prototype.getGValue = function (index) {
                if (arguments.length == 1) {
                    if ((_super.prototype.getFormat.call(this).getIsRgbType() || _super.prototype.getFormat.call(this).getIsRgbaType())) {
                        return _super.prototype.getDataBuffer.call(this).read8(this.getGValueOffset(index));
                    }
                    return -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoBuffer.prototype.getGValueOffset = function (index) {
                if (arguments.length == 1) {
                    if ((_super.prototype.getFormat.call(this).getIsRgb() || _super.prototype.getFormat.call(this).getIsBgr())) {
                        return (((fm.liveswitch.MathAssistant.floor(index / this.getWidth()) * this.getStride()) + ((index % this.getWidth()) * 3)) + 1);
                    }
                    if ((_super.prototype.getFormat.call(this).getIsRgba() || _super.prototype.getFormat.call(this).getIsBgra())) {
                        return (((fm.liveswitch.MathAssistant.floor(index / this.getWidth()) * this.getStride()) + ((index % this.getWidth()) * 4)) + 1);
                    }
                    if ((_super.prototype.getFormat.call(this).getIsArgb() || _super.prototype.getFormat.call(this).getIsAbgr())) {
                        return (((fm.liveswitch.MathAssistant.floor(index / this.getWidth()) * this.getStride()) + ((index % this.getWidth()) * 4)) + 2);
                    }
                    return -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the height.
            */
            VideoBuffer.prototype.getHeight = function () {
                if (arguments.length == 0) {
                    return this.__height;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this buffer has ABGR video.
            */
            VideoBuffer.prototype.getIsAbgr = function () {
                if (arguments.length == 0) {
                    var format = _super.prototype.getFormat.call(this);
                    return ((!fm.liveswitch.Global.equals(format, null)) && format.getIsAbgr());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this buffer has ARGB video.
            */
            VideoBuffer.prototype.getIsArgb = function () {
                if (arguments.length == 0) {
                    var format = _super.prototype.getFormat.call(this);
                    return ((!fm.liveswitch.Global.equals(format, null)) && format.getIsArgb());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this buffer has BGR video.
            */
            VideoBuffer.prototype.getIsBgr = function () {
                if (arguments.length == 0) {
                    var format = _super.prototype.getFormat.call(this);
                    return ((!fm.liveswitch.Global.equals(format, null)) && format.getIsBgr());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this buffer has BGRA video.
            */
            VideoBuffer.prototype.getIsBgra = function () {
                if (arguments.length == 0) {
                    var format = _super.prototype.getFormat.call(this);
                    return ((!fm.liveswitch.Global.equals(format, null)) && format.getIsBgra());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this buffer has H.264 video.
            */
            VideoBuffer.prototype.getIsH264 = function () {
                if (arguments.length == 0) {
                    var format = _super.prototype.getFormat.call(this);
                    return ((!fm.liveswitch.Global.equals(format, null)) && format.getIsH264());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this buffer has I420 video.
            */
            VideoBuffer.prototype.getIsI420 = function () {
                if (arguments.length == 0) {
                    var format = _super.prototype.getFormat.call(this);
                    return ((!fm.liveswitch.Global.equals(format, null)) && format.getIsI420());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this instance has been muted.
            */
            VideoBuffer.prototype.getIsMuted = function () {
                if (arguments.length == 0) {
                    return this.__isMuted;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this buffer has NV12 video.
            */
            VideoBuffer.prototype.getIsNv12 = function () {
                if (arguments.length == 0) {
                    var format = _super.prototype.getFormat.call(this);
                    return ((!fm.liveswitch.Global.equals(format, null)) && format.getIsNv12());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this buffer has NV21 video.
            */
            VideoBuffer.prototype.getIsNv21 = function () {
                if (arguments.length == 0) {
                    var format = _super.prototype.getFormat.call(this);
                    return ((!fm.liveswitch.Global.equals(format, null)) && format.getIsNv21());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the data is packed into a single data buffer.
            */
            VideoBuffer.prototype.getIsPacked = function () {
                if (arguments.length == 0) {
                    return (fm.liveswitch.Global.equals(_super.prototype.getDataBuffers.call(this).length, 1));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the data is spread across multiple data buffers (planes).
            */
            VideoBuffer.prototype.getIsPlanar = function () {
                if (arguments.length == 0) {
                    return (_super.prototype.getDataBuffers.call(this).length > 1);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this buffer has raw video.
            */
            VideoBuffer.prototype.getIsRaw = function () {
                if (arguments.length == 0) {
                    var format = _super.prototype.getFormat.call(this);
                    return ((!fm.liveswitch.Global.equals(format, null)) && format.getIsRaw());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this buffer has RGB video.
            */
            VideoBuffer.prototype.getIsRgb = function () {
                if (arguments.length == 0) {
                    var format = _super.prototype.getFormat.call(this);
                    return ((!fm.liveswitch.Global.equals(format, null)) && format.getIsRgb());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this buffer has RGBA video.
            */
            VideoBuffer.prototype.getIsRgba = function () {
                if (arguments.length == 0) {
                    var format = _super.prototype.getFormat.call(this);
                    return ((!fm.liveswitch.Global.equals(format, null)) && format.getIsRgba());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this buffer has raw RGBA, BGRA, ARGB, or ABGR video.
            */
            VideoBuffer.prototype.getIsRgbaType = function () {
                if (arguments.length == 0) {
                    var format = _super.prototype.getFormat.call(this);
                    return ((!fm.liveswitch.Global.equals(format, null)) && format.getIsRgbaType());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this buffer has raw RGB or BGR video.
            */
            VideoBuffer.prototype.getIsRgbType = function () {
                if (arguments.length == 0) {
                    var format = _super.prototype.getFormat.call(this);
                    return ((!fm.liveswitch.Global.equals(format, null)) && format.getIsRgbType());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this buffer has VP8 video.
            */
            VideoBuffer.prototype.getIsVp8 = function () {
                if (arguments.length == 0) {
                    var format = _super.prototype.getFormat.call(this);
                    return ((!fm.liveswitch.Global.equals(format, null)) && format.getIsVp8());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this buffer has VP9 video.
            */
            VideoBuffer.prototype.getIsVp9 = function () {
                if (arguments.length == 0) {
                    var format = _super.prototype.getFormat.call(this);
                    return ((!fm.liveswitch.Global.equals(format, null)) && format.getIsVp9());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this buffer has raw I420, YV12, NV12, or NV21 video.
            */
            VideoBuffer.prototype.getIsYuvType = function () {
                if (arguments.length == 0) {
                    var format = _super.prototype.getFormat.call(this);
                    return ((!fm.liveswitch.Global.equals(format, null)) && format.getIsYuvType());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether this buffer has YV12 video.
            */
            VideoBuffer.prototype.getIsYv12 = function () {
                if (arguments.length == 0) {
                    var format = _super.prototype.getFormat.call(this);
                    return ((!fm.liveswitch.Global.equals(format, null)) && format.getIsYv12());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the orientation.
            */
            VideoBuffer.prototype.getOrientation = function () {
                if (arguments.length == 0) {
                    return this.__orientation;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the R value at a given index.
            @param index The index.
            @return The R value, or -1 if the video buffer is not RGB/RGBA-type.
            */
            VideoBuffer.prototype.getRValue = function (index) {
                if (arguments.length == 1) {
                    if ((_super.prototype.getFormat.call(this).getIsRgbType() || _super.prototype.getFormat.call(this).getIsRgbaType())) {
                        return _super.prototype.getDataBuffer.call(this).read8(this.getRValueOffset(index));
                    }
                    return -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoBuffer.prototype.getRValueOffset = function (index) {
                if (arguments.length == 1) {
                    if (_super.prototype.getFormat.call(this).getIsRgb()) {
                        return ((fm.liveswitch.MathAssistant.floor(index / this.getWidth()) * this.getStride()) + ((index % this.getWidth()) * 3));
                    }
                    if (_super.prototype.getFormat.call(this).getIsBgr()) {
                        return (((fm.liveswitch.MathAssistant.floor(index / this.getWidth()) * this.getStride()) + ((index % this.getWidth()) * 3)) + 2);
                    }
                    if (_super.prototype.getFormat.call(this).getIsRgba()) {
                        return ((fm.liveswitch.MathAssistant.floor(index / this.getWidth()) * this.getStride()) + ((index % this.getWidth()) * 4));
                    }
                    if (_super.prototype.getFormat.call(this).getIsBgra()) {
                        return (((fm.liveswitch.MathAssistant.floor(index / this.getWidth()) * this.getStride()) + ((index % this.getWidth()) * 4)) + 2);
                    }
                    if (_super.prototype.getFormat.call(this).getIsArgb()) {
                        return (((fm.liveswitch.MathAssistant.floor(index / this.getWidth()) * this.getStride()) + ((index % this.getWidth()) * 4)) + 1);
                    }
                    if (_super.prototype.getFormat.call(this).getIsAbgr()) {
                        return (((fm.liveswitch.MathAssistant.floor(index / this.getWidth()) * this.getStride()) + ((index % this.getWidth()) * 4)) + 3);
                    }
                    return -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the stride.
            */
            VideoBuffer.prototype.getStride = function () {
                if (arguments.length == 0) {
                    var strides = this.getStrides();
                    if ((fm.liveswitch.Global.equals(strides, null))) {
                        return 0;
                    }
                    return strides[0];
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the strides.
            */
            VideoBuffer.prototype.getStrides = function () {
                if (arguments.length == 0) {
                    return this._strides;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the U value at a given index.
            @param index The index.
            @return The U value, or -1 if the video buffer is not YUV-type.
            */
            VideoBuffer.prototype.getUValue = function (index) {
                if (arguments.length == 1) {
                    if (_super.prototype.getFormat.call(this).getIsYuvType()) {
                        if (this.getIsPacked()) {
                            return _super.prototype.getDataBuffers.call(this)[0].read8(this.getUValueOffset(index));
                        }
                        if (this.getIsYv12()) {
                            return _super.prototype.getDataBuffers.call(this)[2].read8(this.getUValueOffset(index));
                        }
                        return _super.prototype.getDataBuffers.call(this)[1].read8(this.getUValueOffset(index));
                    }
                    return -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoBuffer.prototype.getUValueOffset = function (index) {
                if (arguments.length == 1) {
                    var num2 = void 0;
                    var num3 = void 0;
                    var num4 = void 0;
                    if (this.getIsPacked()) {
                        if ((this.getIsI420() || this.getIsYv12())) {
                            var num = fm.liveswitch.MathAssistant.floor(this.getStride() / 2);
                            num2 = fm.liveswitch.MathAssistant.floor(this.getWidth() / 2);
                            num3 = ((fm.liveswitch.MathAssistant.floor(index / num2) * num) + (index % num2));
                            if (this.getIsI420()) {
                                return ((this.getHeight() * this.getStride()) + num3);
                            }
                            return (fm.liveswitch.MathAssistant.floor(((this.getHeight() * this.getStride()) * 5) / 4) + num3);
                        }
                        num4 = (index * 2);
                        num3 = ((fm.liveswitch.MathAssistant.floor(num4 / this.getWidth()) * this.getStride()) + (num4 % this.getWidth()));
                        if (this.getIsNv12()) {
                            return ((this.getHeight() * this.getStride()) + num3);
                        }
                        return (((this.getHeight() * this.getStride()) + num3) + 1);
                    }
                    if ((this.getIsI420() || this.getIsYv12())) {
                        num2 = fm.liveswitch.MathAssistant.floor(this.getWidth() / 2);
                        if (this.getIsI420()) {
                            return ((fm.liveswitch.MathAssistant.floor(index / num2) * this.getStrides()[1]) + (index % num2));
                        }
                        return ((fm.liveswitch.MathAssistant.floor(index / num2) * this.getStrides()[2]) + (index % num2));
                    }
                    num4 = (index * 2);
                    num3 = ((fm.liveswitch.MathAssistant.floor(num4 / this.getWidth()) * this.getStrides()[1]) + (num4 % this.getWidth()));
                    if (this.getIsNv12()) {
                        return num3;
                    }
                    return (num3 + 1);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the V value at a given index.
            @param index The index.
            @return The V value, or -1 if the video buffer is not YUV-type.
            */
            VideoBuffer.prototype.getVValue = function (index) {
                if (arguments.length == 1) {
                    if (_super.prototype.getFormat.call(this).getIsYuvType()) {
                        if (this.getIsPacked()) {
                            return _super.prototype.getDataBuffers.call(this)[0].read8(this.getVValueOffset(index));
                        }
                        if (this.getIsI420()) {
                            return _super.prototype.getDataBuffers.call(this)[2].read8(this.getVValueOffset(index));
                        }
                        return _super.prototype.getDataBuffers.call(this)[1].read8(this.getVValueOffset(index));
                    }
                    return -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoBuffer.prototype.getVValueOffset = function (index) {
                if (arguments.length == 1) {
                    var num2 = void 0;
                    var num3 = void 0;
                    var num4 = void 0;
                    if (this.getIsPacked()) {
                        if ((this.getIsI420() || this.getIsYv12())) {
                            var num = fm.liveswitch.MathAssistant.floor(this.getStride() / 2);
                            num2 = fm.liveswitch.MathAssistant.floor(this.getWidth() / 2);
                            num3 = ((fm.liveswitch.MathAssistant.floor(index / num2) * num) + (index % num2));
                            if (this.getIsI420()) {
                                return (fm.liveswitch.MathAssistant.floor(((this.getHeight() * this.getStride()) * 5) / 4) + num3);
                            }
                            return ((this.getHeight() * this.getStride()) + num3);
                        }
                        num4 = (index * 2);
                        num3 = ((fm.liveswitch.MathAssistant.floor(num4 / this.getWidth()) * this.getStride()) + (num4 % this.getWidth()));
                        if (this.getIsNv12()) {
                            return (((this.getHeight() * this.getStride()) + num3) + 1);
                        }
                        return ((this.getHeight() * this.getStride()) + num3);
                    }
                    if ((this.getIsI420() || this.getIsYv12())) {
                        num2 = fm.liveswitch.MathAssistant.floor(this.getWidth() / 2);
                        if (this.getIsI420()) {
                            return ((fm.liveswitch.MathAssistant.floor(index / num2) * this.getStrides()[2]) + (index % num2));
                        }
                        return ((fm.liveswitch.MathAssistant.floor(index / num2) * this.getStrides()[1]) + (index % num2));
                    }
                    num4 = (index * 2);
                    num3 = ((fm.liveswitch.MathAssistant.floor(num4 / this.getWidth()) * this.getStrides()[1]) + (num4 % this.getWidth()));
                    if (this.getIsNv12()) {
                        return (num3 + 1);
                    }
                    return num3;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the width.
            */
            VideoBuffer.prototype.getWidth = function () {
                if (arguments.length == 0) {
                    return this.__width;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the Y value at a given index.
            @param index The index.
            @return The Y value, or -1 if the video buffer is not YUV-type.
            */
            VideoBuffer.prototype.getYValue = function (index) {
                if (arguments.length == 1) {
                    if (_super.prototype.getFormat.call(this).getIsYuvType()) {
                        return _super.prototype.getDataBuffer.call(this).read8(this.getYValueOffset(index));
                    }
                    return -1;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoBuffer.prototype.getYValueOffset = function (index) {
                if (arguments.length == 1) {
                    return ((fm.liveswitch.MathAssistant.floor(index / this.getWidth()) * this.getStride()) + (index % this.getWidth()));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Mutes this instance. This is a one-way operation that clears the underlying data buffer.
            */
            VideoBuffer.prototype.mute = function () {
                if (arguments.length == 0) {
                    if (!this.__isMuted) {
                        if (_super.prototype.getFormat.call(this).getIsRgbType()) {
                            _super.prototype.getDataBuffer.call(this).set(0);
                        }
                        else {
                            var dataBuffer = void 0;
                            var num3 = void 0;
                            if (_super.prototype.getFormat.call(this).getIsRgbaType()) {
                                dataBuffer = _super.prototype.getDataBuffer.call(this);
                                var num = 1;
                                var num2 = 0;
                                if ((_super.prototype.getFormat.call(this).getIsBgra() || _super.prototype.getFormat.call(this).getIsRgba())) {
                                    num = 0;
                                    num2 = 3;
                                }
                                for (num3 = 0; (num3 < dataBuffer.getLength()); num3 = (num3 + 4)) {
                                    dataBuffer.set(0, (num3 + num), 3);
                                    dataBuffer.set(fm.liveswitch.BitAssistant.castByte(255), (num3 + num2), 1);
                                }
                            }
                            else {
                                if (_super.prototype.getFormat.call(this).getIsYuvType()) {
                                    var dataBuffers = _super.prototype.getDataBuffers.call(this);
                                    if (this.getIsPacked()) {
                                        var length_47 = (this.getWidth() * this.getHeight());
                                        dataBuffer = dataBuffers[0];
                                        dataBuffer.set(0, 0, length_47);
                                        dataBuffer.set(fm.liveswitch.BitAssistant.castByte(128), length_47);
                                    }
                                    else {
                                        if (this.getIsPlanar()) {
                                            dataBuffers[0].set(0);
                                            for (num3 = 1; (num3 < dataBuffers.length); num3++) {
                                                dataBuffers[num3].set(fm.liveswitch.BitAssistant.castByte(128));
                                            }
                                        }
                                    }
                                }
                                else {
                                    return false;
                                }
                            }
                        }
                        this.__isMuted = true;
                    }
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoBuffer.prototype.readRgba = function (rValues, gValues, bValues, aValues) {
                if (arguments.length == 4) {
                    var num = (this.getWidth() * this.getHeight());
                    rValues.setValue(new Array(num));
                    gValues.setValue(new Array(num));
                    bValues.setValue(new Array(num));
                    aValues.setValue(new Array(num));
                    for (var i = 0; (i < num); i++) {
                        rValues.getValue()[i] = this.getRValue(i);
                        gValues.getValue()[i] = this.getGValue(i);
                        bValues.getValue()[i] = this.getBValue(i);
                        aValues.getValue()[i] = this.getAValue(i);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoBuffer.prototype.readYuv = function (yValues, uValues, vValues) {
                if (arguments.length == 3) {
                    var num2 = void 0;
                    var num = (this.getWidth() * this.getHeight());
                    yValues.setValue(new Array(num));
                    uValues.setValue(new Array(fm.liveswitch.MathAssistant.floor(num / 4)));
                    vValues.setValue(new Array(fm.liveswitch.MathAssistant.floor(num / 4)));
                    for (num2 = 0; (num2 < num); num2++) {
                        yValues.getValue()[num2] = this.getYValue(num2);
                    }
                    for (num2 = 0; (num2 < fm.liveswitch.MathAssistant.floor(num / 4)); num2++) {
                        uValues.getValue()[num2] = this.getUValue(num2);
                        vValues.getValue()[num2] = this.getVValue(num2);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the A value at a given index. If the video buffer is not RGBA-type, then this will return false.
            @param aValue The A value.
            @param index The index.
            @return `true` if the video buffer is RGBA-type.
            */
            VideoBuffer.prototype.setAValue = function (aValue, index) {
                if (arguments.length == 2) {
                    return (_super.prototype.getFormat.call(this).getIsRgbaType() && _super.prototype.getDataBuffer.call(this).write8(aValue, this.getAValueOffset(index)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the B value at a given index.
            @param bValue The B value.
            @param index The index.
            @return `true` if the video buffer is RGB/RGBA-type.
            */
            VideoBuffer.prototype.setBValue = function (bValue, index) {
                if (arguments.length == 2) {
                    return ((_super.prototype.getFormat.call(this).getIsRgbType() || _super.prototype.getFormat.call(this).getIsRgbaType()) && _super.prototype.getDataBuffer.call(this).write8(bValue, this.getBValueOffset(index)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the G value at a given index.
            @param gValue The G value.
            @param index The index.
            @return `true` if the video buffer is RGB/RGBA-type.
            */
            VideoBuffer.prototype.setGValue = function (gValue, index) {
                if (arguments.length == 2) {
                    return ((_super.prototype.getFormat.call(this).getIsRgbType() || _super.prototype.getFormat.call(this).getIsRgbaType()) && _super.prototype.getDataBuffer.call(this).write8(gValue, this.getGValueOffset(index)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the height.
            */
            VideoBuffer.prototype.setHeight = function (value) {
                if (arguments.length == 1) {
                    if (((!fm.liveswitch.Global.equals(value, -1)) && ((value % 2) > 0))) {
                        value--;
                    }
                    this.__height = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoBuffer.prototype.setIsMuted = function (value) {
                if (arguments.length == 1) {
                    this.__isMuted = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the orientation.
            */
            VideoBuffer.prototype.setOrientation = function (value) {
                if (arguments.length == 1) {
                    if (((((!fm.liveswitch.Global.equals(value, 0)) && (!fm.liveswitch.Global.equals(value, 90))) && (!fm.liveswitch.Global.equals(value, 180))) && (!fm.liveswitch.Global.equals(value, 270)))) {
                        throw new fm.liveswitch.Exception("Video orientation can only be 0, 90, 180 or 270.");
                    }
                    this.__orientation = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the R value at a given index.
            @param rValue The R value.
            @param index The index.
            @return `true` if the video buffer is RGB/RGBA-type.
            */
            VideoBuffer.prototype.setRValue = function (rValue, index) {
                if (arguments.length == 2) {
                    return ((_super.prototype.getFormat.call(this).getIsRgbType() || _super.prototype.getFormat.call(this).getIsRgbaType()) && _super.prototype.getDataBuffer.call(this).write8(rValue, this.getRValueOffset(index)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the stride.
            */
            VideoBuffer.prototype.setStride = function (value) {
                if (arguments.length == 1) {
                    this.setStrides([value]);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the strides.
            */
            VideoBuffer.prototype.setStrides = function (value) {
                if (arguments.length == 1) {
                    this._strides = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the U value at a given index.
            @param uValue The U value.
            @param index The index.
            @return `true` if the video buffer is YUV-type.
            */
            VideoBuffer.prototype.setUValue = function (uValue, index) {
                if (arguments.length == 2) {
                    if (_super.prototype.getFormat.call(this).getIsYuvType()) {
                        if (this.getIsPacked()) {
                            return _super.prototype.getDataBuffers.call(this)[0].write8(uValue, this.getUValueOffset(index));
                        }
                        if (this.getIsYv12()) {
                            return _super.prototype.getDataBuffers.call(this)[2].write8(uValue, this.getUValueOffset(index));
                        }
                        return _super.prototype.getDataBuffers.call(this)[1].write8(uValue, this.getUValueOffset(index));
                    }
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the V value at a given index.
            @param vValue The V value.
            @param index The index.
            @return `true` if the video buffer is YUV-type.
            */
            VideoBuffer.prototype.setVValue = function (vValue, index) {
                if (arguments.length == 2) {
                    if (_super.prototype.getFormat.call(this).getIsYuvType()) {
                        if (this.getIsPacked()) {
                            return _super.prototype.getDataBuffers.call(this)[0].write8(vValue, this.getVValueOffset(index));
                        }
                        if (this.getIsI420()) {
                            return _super.prototype.getDataBuffers.call(this)[2].write8(vValue, this.getVValueOffset(index));
                        }
                        return _super.prototype.getDataBuffers.call(this)[1].write8(vValue, this.getVValueOffset(index));
                    }
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the width.
            */
            VideoBuffer.prototype.setWidth = function (value) {
                if (arguments.length == 1) {
                    if (((!fm.liveswitch.Global.equals(value, -1)) && ((value % 2) > 0))) {
                        value--;
                    }
                    this.__width = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the Y value at a given index.
            @param yValue The Y value.
            @param index The index.
            @return `true` if the video buffer is YUV-type.
            */
            VideoBuffer.prototype.setYValue = function (yValue, index) {
                if (arguments.length == 2) {
                    return (_super.prototype.getFormat.call(this).getIsYuvType() && _super.prototype.getDataBuffer.call(this).write8(yValue, this.getYValueOffset(index)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            VideoBuffer.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.VideoBuffer.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            VideoBuffer.prototype.toPacked = function () {
                if (arguments.length == 0) {
                    return this.toPacked(false);
                }
                else if (arguments.length == 1) {
                    var usePool = arguments[0];
                    var num = void 0;
                    var buffer3 = void 0;
                    if (!(this.getIsYuvType() && (_super.prototype.getDataBuffers.call(this).length > 1))) {
                        return this;
                    }
                    var buffer = this.clone();
                    var dataBuffers = buffer.getDataBuffers();
                    var strides = buffer.getStrides();
                    if (fm.liveswitch.VideoBuffer.canPackWithoutCopy(dataBuffers)) {
                        num = 0;
                        for (var _i = 0, dataBuffers_1 = dataBuffers; _i < dataBuffers_1.length; _i++) {
                            var buffer2 = dataBuffers_1[_i];
                            num = (num + buffer2.getLength());
                        }
                        buffer3 = dataBuffers[0];
                        buffer3.setLength(num);
                        buffer.setDataBuffer(buffer3);
                    }
                    else {
                        num = (((strides[0] * buffer.getHeight()) * 3) / 2);
                        if (usePool) {
                            buffer3 = fm.liveswitch.VideoBuffer.fm_liveswitch_VideoBuffer___dataBufferPool.take(num);
                        }
                        else {
                            buffer3 = fm.liveswitch.DataBuffer.allocate(num);
                        }
                        var offset = 0;
                        for (var _a = 0, dataBuffers_2 = dataBuffers; _a < dataBuffers_2.length; _a++) {
                            var buffer2 = dataBuffers_2[_a];
                            var _var0 = new fm.liveswitch.Holder(offset);
                            buffer3.write(buffer2, offset, _var0);
                            offset = _var0.getValue();
                        }
                        buffer.setDataBuffer(buffer3);
                    }
                    buffer.setStride(strides[0]);
                    return buffer;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a planar representation of this packed buffer, if in YUV-packed format. Otherwise, returns the current buffer.
            */
            VideoBuffer.prototype.toPlanar = function () {
                if (arguments.length == 0) {
                    var num2 = void 0;
                    var num5 = void 0;
                    var num8 = void 0;
                    if (!(this.getIsYuvType() && (_super.prototype.getDataBuffers.call(this).length <= 1))) {
                        return this;
                    }
                    var buffer = this.clone();
                    var dataBuffer = buffer.getDataBuffer();
                    var stride = buffer.getStride();
                    if ((buffer.getIsI420() || buffer.getIsYv12())) {
                        var num9 = void 0;
                        var num10 = void 0;
                        num2 = stride;
                        var num3 = fm.liveswitch.MathAssistant.floor(stride / 2);
                        var num4 = fm.liveswitch.MathAssistant.floor(stride / 2);
                        num5 = (stride * buffer.getHeight());
                        var num6 = fm.liveswitch.MathAssistant.floor(num5 / 4);
                        var num7 = fm.liveswitch.MathAssistant.floor(num5 / 4);
                        num8 = 0;
                        if (buffer.getIsI420()) {
                            num9 = num5;
                            num10 = (num5 + num6);
                            buffer.setDataBuffers([dataBuffer.subset(num8, num5), dataBuffer.subset(num9, num6), dataBuffer.subset(num10, num7)]);
                            buffer.setStrides([num2, num3, num4]);
                        }
                        else {
                            num10 = num5;
                            num9 = (num5 + num7);
                            buffer.setDataBuffers([dataBuffer.subset(num8, num5), dataBuffer.subset(num10, num7), dataBuffer.subset(num9, num6)]);
                            buffer.setStrides([num2, num4, num3]);
                        }
                        return buffer;
                    }
                    num2 = stride;
                    var num11 = stride;
                    num5 = (stride * buffer.getHeight());
                    var length_48 = fm.liveswitch.MathAssistant.floor(num5 / 2);
                    num8 = 0;
                    var offset = num5;
                    buffer.setDataBuffers([dataBuffer.subset(num8, num5), dataBuffer.subset(offset, length_48)]);
                    buffer.setStrides([num2, num11]);
                    return buffer;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoBuffer.prototype.writeRgba = function (rValues, gValues, bValues, aValues) {
                if (arguments.length == 4) {
                    var num = (this.getWidth() * this.getHeight());
                    for (var i = 0; (i < num); i++) {
                        this.setRValue(rValues[i], i);
                        this.setGValue(gValues[i], i);
                        this.setBValue(bValues[i], i);
                        this.setAValue(aValues[i], i);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoBuffer.prototype.writeYuv = function (yValues, uValues, vValues) {
                if (arguments.length == 3) {
                    var num = void 0;
                    for (num = 0; (num < yValues.length); num++) {
                        this.setYValue(yValues[num], num);
                    }
                    for (num = 0; (num < uValues.length); num++) {
                        this.setUValue(uValues[num], num);
                    }
                    for (num = 0; (num < vValues.length); num++) {
                        this.setVValue(vValues[num], num);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoBuffer.fmliveswitchVideoBufferInitialize = function () {
                if (!fm.liveswitch.VideoBuffer.__fmliveswitchVideoBufferInitialized && !fm.liveswitch.VideoBuffer.__fmliveswitchVideoBufferInitializing) {
                    fm.liveswitch.VideoBuffer.__fmliveswitchVideoBufferInitializing = true;
                    fm.liveswitch.VideoBuffer.fm_liveswitch_VideoBuffer___dataBufferPool = fm.liveswitch.DataBufferPool.getTracer(new fm.liveswitch.Type('[fm.liveswitch.VideoBuffer]'));
                    fm.liveswitch.VideoBuffer.__fmliveswitchVideoBufferInitialized = true;
                    fm.liveswitch.VideoBuffer.__fmliveswitchVideoBufferInitializing = false;
                }
            };
            /** @hidden */
            VideoBuffer.__fmliveswitchVideoBufferInitialized = false;
            /** @hidden */
            VideoBuffer.__fmliveswitchVideoBufferInitializing = false;
            return VideoBuffer;
        }(fm.liveswitch.MediaBuffer));
        liveswitch.VideoBuffer = VideoBuffer;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Promise.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var RemoteCandidatePromise = /** @class */ (function (_super) {
            __extends(RemoteCandidatePromise, _super);
            function RemoteCandidatePromise(remoteCandidate) {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var remoteCandidate_1 = __arguments[0];
                    _this = _super.call(this) || this;
                    _this.setRemoteCandidate(remoteCandidate_1);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            RemoteCandidatePromise.prototype.getTypeString = function () {
                return '[fm.liveswitch.RemoteCandidatePromise]' + ',' + _super.prototype.getTypeString.call(this);
            };
            RemoteCandidatePromise.prototype.getRemoteCandidate = function () {
                if (arguments.length == 0) {
                    return this._remoteCandidate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            RemoteCandidatePromise.prototype.setRemoteCandidate = function (value) {
                if (arguments.length == 1) {
                    this._remoteCandidate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return RemoteCandidatePromise;
        }(fm.liveswitch.Promise));
        liveswitch.RemoteCandidatePromise = RemoteCandidatePromise;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Collection.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A collection of remote medias.
        */
        var RemoteMediaCollection = /** @class */ (function (_super) {
            __extends(RemoteMediaCollection, _super);
            function RemoteMediaCollection() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.__lookup = {};
                    _this.__lookupLock = new Object();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            RemoteMediaCollection.prototype.getTypeString = function () {
                return '[fm.liveswitch.RemoteMediaCollection]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Invoked when an element is added to the collection.
            @param value The value.
            */
            RemoteMediaCollection.prototype.addSuccess = function (value) {
                if (arguments.length == 1) {
                    _super.prototype.addSuccess.call(this, value);
                    this.__lookup[value.getId()] = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates an array from a list.
            @param list The list.
            */
            RemoteMediaCollection.prototype.arrayFromList = function (list) {
                if (arguments.length == 1) {
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a collection.
            */
            RemoteMediaCollection.prototype.createCollection = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.RemoteMediaCollection();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a media by ID.
            @param idValue The identifier.
            */
            RemoteMediaCollection.prototype.getById = function (idValue) {
                if (arguments.length == 1) {
                    var media = null;
                    var _var0 = new fm.liveswitch.Holder(media);
                    var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this.__lookup, idValue, _var0);
                    media = _var0.getValue();
                    if (_var1) {
                        return media;
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Invoked when an element is removed from the collection.
            @param value The value.
            */
            RemoteMediaCollection.prototype.removeSuccess = function (value) {
                if (arguments.length == 1) {
                    _super.prototype.removeSuccess.call(this, value);
                    fm.liveswitch.HashExtensions.remove(this.__lookup, value.getId());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return RemoteMediaCollection;
        }(fm.liveswitch.Collection));
        liveswitch.RemoteMediaCollection = RemoteMediaCollection;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="RemoteMediaCollection.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A collection of remote medias.
        */
        var MediaCollection = /** @class */ (function (_super) {
            __extends(MediaCollection, _super);
            function MediaCollection() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaCollection.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaCollection]' + ',' + _super.prototype.getTypeString.call(this);
            };
            return MediaCollection;
        }(fm.liveswitch.RemoteMediaCollection));
        liveswitch.MediaCollection = MediaCollection;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var NackPolicyWrapper = /** @class */ (function () {
            function NackPolicyWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_55 = __arguments[0];
                    //super();
                    this._value = value_55;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            NackPolicyWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.NackPolicyWrapper]';
            };
            NackPolicyWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.NackPolicy.Disabled)
                        return 'Disabled';
                    if (this._value == fm.liveswitch.NackPolicy.Negotiated)
                        return 'Negotiated';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return NackPolicyWrapper;
        }());
        liveswitch.NackPolicyWrapper = NackPolicyWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../AudioFormat.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var opus;
        (function (opus) {
            /**
            An Opus format.
            */
            var Format = /** @class */ (function (_super) {
                __extends(Format, _super);
                function Format() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        // chained constructor: Format.call(this, fm.liveswitch.opus.Format.getDefaultConfig());
                        __arguments = new Array(1);
                        __arguments[0] = fm.liveswitch.opus.Format.getDefaultConfig();
                        {
                            var config = __arguments[0];
                            // chained constructor: Format.call(this, config.getClockRate(), config.getChannelCount());
                            __arguments = new Array(2);
                            __arguments[0] = config.getClockRate();
                            __arguments[1] = config.getChannelCount();
                            {
                                var clockRate = __arguments[0];
                                var channelCount = __arguments[1];
                                _this = _super.call(this, fm.liveswitch.AudioFormat.getOpusName(), clockRate, channelCount) || this;
                            }
                        }
                    }
                    else if (__arguments.length == 2) {
                        var clockRate = __arguments[0];
                        var channelCount = __arguments[1];
                        _this = _super.call(this, fm.liveswitch.AudioFormat.getOpusName(), clockRate, channelCount) || this;
                    }
                    else if (__arguments.length == 1) {
                        var config = __arguments[0];
                        // chained constructor: Format.call(this, config.getClockRate(), config.getChannelCount());
                        __arguments = new Array(2);
                        __arguments[0] = config.getClockRate();
                        __arguments[1] = config.getChannelCount();
                        {
                            var clockRate = __arguments[0];
                            var channelCount = __arguments[1];
                            _this = _super.call(this, fm.liveswitch.AudioFormat.getOpusName(), clockRate, channelCount) || this;
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                Format.prototype.getTypeString = function () {
                    return '[fm.liveswitch.opus.Format]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Gets the default clock rate (2).
                */
                Format.getDefaultChannelCount = function () {
                    if (arguments.length == 0) {
                        return 2;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the default clock rate (48000).
                */
                Format.getDefaultClockRate = function () {
                    if (arguments.length == 0) {
                        return 48000;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the default configuration (48000/2).
                */
                Format.getDefaultConfig = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.AudioConfig(fm.liveswitch.opus.Format.getDefaultClockRate(), fm.liveswitch.opus.Format.getDefaultChannelCount());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Creates a new instance.
                */
                Format.prototype.createInstance = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.opus.Format();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the maximum bitrate supported by this format, in kbps.
                */
                Format.prototype.getMaxBitrate = function () {
                    if (arguments.length == 0) {
                        return 510;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the minimum bitrate supported by this format, in kbps.
                */
                Format.prototype.getMinBitrate = function () {
                    if (arguments.length == 0) {
                        return 6;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Format;
            }(fm.liveswitch.AudioFormat));
            opus.Format = Format;
        })(opus = liveswitch.opus || (liveswitch.opus = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../g711/Format.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var pcma;
        (function (pcma) {
            /**
            A PCMA (G.711a) format.
            */
            var Format = /** @class */ (function (_super) {
                __extends(Format, _super);
                function Format() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        // chained constructor: Format.call(this, fm.liveswitch.g711.Format.getDefaultConfig());
                        __arguments = new Array(1);
                        __arguments[0] = fm.liveswitch.g711.Format.getDefaultConfig();
                        {
                            var config = __arguments[0];
                            // chained constructor: Format.call(this, config.getClockRate(), config.getChannelCount());
                            __arguments = new Array(2);
                            __arguments[0] = config.getClockRate();
                            __arguments[1] = config.getChannelCount();
                            {
                                var clockRate = __arguments[0];
                                var channelCount = __arguments[1];
                                _this = _super.call(this, fm.liveswitch.AudioFormat.getPcmaName(), clockRate, channelCount) || this;
                                _super.prototype.setStaticPayloadType.call(_this, 8);
                            }
                        }
                    }
                    else if (__arguments.length == 2) {
                        var clockRate = __arguments[0];
                        var channelCount = __arguments[1];
                        _this = _super.call(this, fm.liveswitch.AudioFormat.getPcmaName(), clockRate, channelCount) || this;
                        _super.prototype.setStaticPayloadType.call(_this, 8);
                    }
                    else if (__arguments.length == 1) {
                        var config = __arguments[0];
                        // chained constructor: Format.call(this, config.getClockRate(), config.getChannelCount());
                        __arguments = new Array(2);
                        __arguments[0] = config.getClockRate();
                        __arguments[1] = config.getChannelCount();
                        {
                            var clockRate = __arguments[0];
                            var channelCount = __arguments[1];
                            _this = _super.call(this, fm.liveswitch.AudioFormat.getPcmaName(), clockRate, channelCount) || this;
                            _super.prototype.setStaticPayloadType.call(_this, 8);
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                Format.prototype.getTypeString = function () {
                    return '[fm.liveswitch.pcma.Format]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Creates a new instance.
                */
                Format.prototype.createInstance = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.pcma.Format();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Format;
            }(fm.liveswitch.g711.Format));
            pcma.Format = Format;
        })(pcma = liveswitch.pcma || (liveswitch.pcma = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../g711/Format.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var pcmu;
        (function (pcmu) {
            /**
            A PCMU (G.711u) format.
            */
            var Format = /** @class */ (function (_super) {
                __extends(Format, _super);
                function Format() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        // chained constructor: Format.call(this, fm.liveswitch.g711.Format.getDefaultConfig());
                        __arguments = new Array(1);
                        __arguments[0] = fm.liveswitch.g711.Format.getDefaultConfig();
                        {
                            var config = __arguments[0];
                            // chained constructor: Format.call(this, config.getClockRate(), config.getChannelCount());
                            __arguments = new Array(2);
                            __arguments[0] = config.getClockRate();
                            __arguments[1] = config.getChannelCount();
                            {
                                var clockRate = __arguments[0];
                                var channelCount = __arguments[1];
                                _this = _super.call(this, fm.liveswitch.AudioFormat.getPcmuName(), clockRate, channelCount) || this;
                                _super.prototype.setStaticPayloadType.call(_this, 0);
                            }
                        }
                    }
                    else if (__arguments.length == 2) {
                        var clockRate = __arguments[0];
                        var channelCount = __arguments[1];
                        _this = _super.call(this, fm.liveswitch.AudioFormat.getPcmuName(), clockRate, channelCount) || this;
                        _super.prototype.setStaticPayloadType.call(_this, 0);
                    }
                    else if (__arguments.length == 1) {
                        var config = __arguments[0];
                        // chained constructor: Format.call(this, config.getClockRate(), config.getChannelCount());
                        __arguments = new Array(2);
                        __arguments[0] = config.getClockRate();
                        __arguments[1] = config.getChannelCount();
                        {
                            var clockRate = __arguments[0];
                            var channelCount = __arguments[1];
                            _this = _super.call(this, fm.liveswitch.AudioFormat.getPcmuName(), clockRate, channelCount) || this;
                            _super.prototype.setStaticPayloadType.call(_this, 0);
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                Format.prototype.getTypeString = function () {
                    return '[fm.liveswitch.pcmu.Format]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Creates a new instance.
                */
                Format.prototype.createInstance = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.pcmu.Format();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Format;
            }(fm.liveswitch.g711.Format));
            pcmu.Format = Format;
        })(pcmu = liveswitch.pcmu || (liveswitch.pcmu = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var RedFecPolicyWrapper = /** @class */ (function () {
            function RedFecPolicyWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_56 = __arguments[0];
                    //super();
                    this._value = value_56;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            RedFecPolicyWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.RedFecPolicyWrapper]';
            };
            RedFecPolicyWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.RedFecPolicy.Disabled)
                        return 'Disabled';
                    if (this._value == fm.liveswitch.RedFecPolicy.Negotiated)
                        return 'Negotiated';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return RedFecPolicyWrapper;
        }());
        liveswitch.RedFecPolicyWrapper = RedFecPolicyWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var RembPolicyWrapper = /** @class */ (function () {
            function RembPolicyWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_57 = __arguments[0];
                    //super();
                    this._value = value_57;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            RembPolicyWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.RembPolicyWrapper]';
            };
            RembPolicyWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.RembPolicy.Disabled)
                        return 'Disabled';
                    if (this._value == fm.liveswitch.RembPolicy.Negotiated)
                        return 'Negotiated';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return RembPolicyWrapper;
        }());
        liveswitch.RembPolicyWrapper = RembPolicyWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        An RTP packet header.
        */
        var RtpPacketHeader = /** @class */ (function () {
            /**
            Creates a new instance of the [[fm.liveswitch.rtpPacketHeader]] class.
            */
            function RtpPacketHeader() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchRtpPacketHeaderInit();
                    this.setVersion(2);
                    this.setPayloadType(-1);
                    this.setSequenceNumber(-1);
                    this.setTimestamp(-1);
                    this.setSynchronizationSource(-1);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            RtpPacketHeader.prototype.getTypeString = function () {
                return '[fm.liveswitch.RtpPacketHeader]';
            };
            RtpPacketHeader.prototype.fmliveswitchRtpPacketHeaderInit = function () {
                this._contributingSourceCount = 0;
                this._extension = false;
                this._marker = false;
                this._padding = false;
                this._paddingLength = 0;
                this._payloadType = 0;
                this._sequenceNumber = 0;
                this._synchronizationSource = 0;
                this._timestamp = 0;
                this._version = 0;
            };
            /**
            Gets the length of the fixed header.
            */
            RtpPacketHeader.getFixedHeaderLength = function () {
                if (arguments.length == 0) {
                    return 12;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Calculates the length of the header. At least 12 bytes.
            */
            RtpPacketHeader.prototype.calculateHeaderLength = function () {
                if (arguments.length == 0) {
                    var num = (fm.liveswitch.RtpPacketHeader.getFixedHeaderLength() + (this.getContributingSourceCount() * 4));
                    if (this.getExtension()) {
                        num = (num + ((this.getHeaderExtension().getLength() * 4) + 4));
                    }
                    return num;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Clones this instance.
            */
            RtpPacketHeader.prototype.clone = function () {
                if (arguments.length == 0) {
                    var header = new fm.liveswitch.RtpPacketHeader();
                    header.setVersion(this.getVersion());
                    header.setMarker(this.getMarker());
                    header.setPadding(this.getPadding());
                    header.setExtension(this.getExtension());
                    header.setHeaderExtension(this.getHeaderExtension());
                    header.setContributingSourceCount(this.getContributingSourceCount());
                    header.setPayloadType(this.getPayloadType());
                    header.setSequenceNumber(this.getSequenceNumber());
                    header.setTimestamp(this.getTimestamp());
                    header.setSynchronizationSource(this.getSynchronizationSource());
                    header.setContributingSources(this.getContributingSources());
                    return header;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of contributing sources.
            */
            RtpPacketHeader.prototype.getContributingSourceCount = function () {
                if (arguments.length == 0) {
                    return this._contributingSourceCount;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the contributing sources.
            */
            RtpPacketHeader.prototype.getContributingSources = function () {
                if (arguments.length == 0) {
                    return this._contributingSources;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if there is an extension.
            */
            RtpPacketHeader.prototype.getExtension = function () {
                if (arguments.length == 0) {
                    return this._extension;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the header extension.
            */
            RtpPacketHeader.prototype.getHeaderExtension = function () {
                if (arguments.length == 0) {
                    return this.__headerExtension;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if the marker bit is set.
            */
            RtpPacketHeader.prototype.getMarker = function () {
                if (arguments.length == 0) {
                    return this._marker;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if the packet has padding.
            */
            RtpPacketHeader.prototype.getPadding = function () {
                if (arguments.length == 0) {
                    return this._padding;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes of padding.
            */
            RtpPacketHeader.prototype.getPaddingLength = function () {
                if (arguments.length == 0) {
                    return this._paddingLength;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the payload type.
            */
            RtpPacketHeader.prototype.getPayloadType = function () {
                if (arguments.length == 0) {
                    return this._payloadType;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the sequence number.
            */
            RtpPacketHeader.prototype.getSequenceNumber = function () {
                if (arguments.length == 0) {
                    return this._sequenceNumber;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the synchronization source.
            */
            RtpPacketHeader.prototype.getSynchronizationSource = function () {
                if (arguments.length == 0) {
                    return this._synchronizationSource;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the timestamp.
            */
            RtpPacketHeader.prototype.getTimestamp = function () {
                if (arguments.length == 0) {
                    return this._timestamp;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the version of the packet. Should be 2.
            */
            RtpPacketHeader.prototype.getVersion = function () {
                if (arguments.length == 0) {
                    return this._version;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of contributing sources.
            */
            RtpPacketHeader.prototype.setContributingSourceCount = function (value) {
                if (arguments.length == 1) {
                    this._contributingSourceCount = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the contributing sources.
            */
            RtpPacketHeader.prototype.setContributingSources = function (value) {
                if (arguments.length == 1) {
                    this._contributingSources = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            RtpPacketHeader.prototype.setExtension = function (value) {
                if (arguments.length == 1) {
                    this._extension = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the header extension.
            */
            RtpPacketHeader.prototype.setHeaderExtension = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(value, null))) {
                        this.setExtension(false);
                        this.__headerExtension = value;
                    }
                    else {
                        this.__headerExtension = value;
                        this.setExtension(true);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets if the marker bit is set.
            */
            RtpPacketHeader.prototype.setMarker = function (value) {
                if (arguments.length == 1) {
                    this._marker = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets if the packet has padding.
            */
            RtpPacketHeader.prototype.setPadding = function (value) {
                if (arguments.length == 1) {
                    this._padding = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            RtpPacketHeader.prototype.setPaddingLength = function (value) {
                if (arguments.length == 1) {
                    this._paddingLength = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the payload type.
            */
            RtpPacketHeader.prototype.setPayloadType = function (value) {
                if (arguments.length == 1) {
                    this._payloadType = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the sequence number.
            */
            RtpPacketHeader.prototype.setSequenceNumber = function (value) {
                if (arguments.length == 1) {
                    this._sequenceNumber = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the synchronization source.
            */
            RtpPacketHeader.prototype.setSynchronizationSource = function (value) {
                if (arguments.length == 1) {
                    this._synchronizationSource = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the timestamp.
            */
            RtpPacketHeader.prototype.setTimestamp = function (value) {
                if (arguments.length == 1) {
                    this._timestamp = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the version of the packet. Should be 2.
            */
            RtpPacketHeader.prototype.setVersion = function (value) {
                if (arguments.length == 1) {
                    this._version = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Writes this header to a buffer starting at the offset.
            @param buffer The target buffer.
            @param offset The starting offset.
            */
            RtpPacketHeader.prototype.writeTo = function (buffer, offset) {
                if (arguments.length == 2) {
                    buffer.write2(this.getVersion(), offset, 0);
                    buffer.write1(this.getPadding(), offset, 2);
                    buffer.write1(this.getExtension(), offset, 3);
                    buffer.write4(this.getContributingSourceCount(), offset, 4);
                    buffer.write1(this.getMarker(), (offset + 1), 0);
                    buffer.write7(this.getPayloadType(), (offset + 1), 1);
                    buffer.write16(this.getSequenceNumber(), (offset + 2));
                    buffer.write32(this.getTimestamp(), (offset + 4));
                    buffer.write32(this.getSynchronizationSource(), (offset + 8));
                    if ((this.getContributingSourceCount() > 0)) {
                        if (((fm.liveswitch.Global.equals(this.getContributingSources(), null)) || (!fm.liveswitch.Global.equals(this.getContributingSourceCount(), this.getContributingSources().length)))) {
                            throw new fm.liveswitch.Exception("Contributing sources count has a non-zero value but the contributing sources array is null or contains an invalid count.");
                        }
                        for (var i = 0; (i < this.getContributingSourceCount()); i++) {
                            buffer.write32(this.getContributingSources()[i], ((offset + 12) + (i * 4)));
                        }
                    }
                    if (this.getExtension()) {
                        var num2 = ((offset + fm.liveswitch.RtpPacketHeader.getFixedHeaderLength()) + (this.getContributingSourceCount() * 4));
                        buffer.getData()[(buffer.getIndex() + num2)] = this.getHeaderExtension().getId()[0];
                        buffer.getData()[((buffer.getIndex() + num2) + 1)] = this.getHeaderExtension().getId()[1];
                        buffer.write16(this.getHeaderExtension().getLength(), (num2 + 2));
                        this.getHeaderExtension().fillBuffer(buffer, (num2 + 4));
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return RtpPacketHeader;
        }());
        liveswitch.RtpPacketHeader = RtpPacketHeader;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var rtp;
        (function (rtp) {
            /** @hidden */
            var HeaderExtensionFormWrapper = /** @class */ (function () {
                function HeaderExtensionFormWrapper(value) {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var value_58 = __arguments[0];
                        //super();
                        this._value = value_58;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                HeaderExtensionFormWrapper.prototype.getTypeString = function () {
                    return '[fm.liveswitch.rtp.HeaderExtensionFormWrapper]';
                };
                HeaderExtensionFormWrapper.prototype.toString = function () {
                    if (arguments.length == 0) {
                        if (this._value == fm.liveswitch.rtp.HeaderExtensionForm.OneByte)
                            return 'OneByte';
                        if (this._value == fm.liveswitch.rtp.HeaderExtensionForm.TwoByte)
                            return 'TwoByte';
                        return '';
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return HeaderExtensionFormWrapper;
            }());
            rtp.HeaderExtensionFormWrapper = HeaderExtensionFormWrapper;
        })(rtp = liveswitch.rtp || (liveswitch.rtp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var rtp;
        (function (rtp) {
            /** @hidden */
            var RawHeaderExtension = /** @class */ (function () {
                function RawHeaderExtension(idValue, payload) {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 2) {
                        var idValue_8 = __arguments[0];
                        var payload_2 = __arguments[1];
                        //super();
                        this.fmliveswitchrtpRawHeaderExtensionInit();
                        this.setId(idValue_8);
                        this.setPayload(payload_2);
                        if ((fm.liveswitch.Global.equals(idValue_8[0], 16))) {
                            this.setForm(fm.liveswitch.rtp.HeaderExtensionForm.TwoByte);
                            this.setAppBits(idValue_8[1]);
                        }
                        else {
                            this.setForm(fm.liveswitch.rtp.HeaderExtensionForm.OneByte);
                            this.setAppBits(0);
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                RawHeaderExtension.prototype.getTypeString = function () {
                    return '[fm.liveswitch.rtp.RawHeaderExtension]';
                };
                RawHeaderExtension.prototype.fmliveswitchrtpRawHeaderExtensionInit = function () {
                    this._appBits = 0;
                };
                RawHeaderExtension.prototype.fillBuffer = function (buffer, offset) {
                    if (arguments.length == 2) {
                        buffer.writeBytes(this.getPayload(), offset);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                RawHeaderExtension.prototype.getAppBits = function () {
                    if (arguments.length == 0) {
                        return this._appBits;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                RawHeaderExtension.prototype.getForm = function () {
                    if (arguments.length == 0) {
                        return this._form;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                RawHeaderExtension.prototype.getId = function () {
                    if (arguments.length == 0) {
                        return this._id;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                RawHeaderExtension.prototype.getLength = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.MathAssistant.floor(this.getPayload().length / 4);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                RawHeaderExtension.prototype.getPayload = function () {
                    if (arguments.length == 0) {
                        return this._payload;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                RawHeaderExtension.prototype.setAppBits = function (value) {
                    if (arguments.length == 1) {
                        this._appBits = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                RawHeaderExtension.prototype.setForm = function (value) {
                    if (arguments.length == 1) {
                        this._form = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                RawHeaderExtension.prototype.setId = function (value) {
                    if (arguments.length == 1) {
                        this._id = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                RawHeaderExtension.prototype.setPayload = function (value) {
                    if (arguments.length == 1) {
                        this._payload = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return RawHeaderExtension;
            }());
            rtp.RawHeaderExtension = RawHeaderExtension;
        })(rtp = liveswitch.rtp || (liveswitch.rtp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var SdesPolicyWrapper = /** @class */ (function () {
            function SdesPolicyWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_59 = __arguments[0];
                    //super();
                    this._value = value_59;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            SdesPolicyWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.SdesPolicyWrapper]';
            };
            SdesPolicyWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.SdesPolicy.Negotiated)
                        return 'Negotiated';
                    if (this._value == fm.liveswitch.SdesPolicy.Disabled)
                        return 'Disabled';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return SdesPolicyWrapper;
        }());
        liveswitch.SdesPolicyWrapper = SdesPolicyWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var SignallingStateWrapper = /** @class */ (function () {
            function SignallingStateWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_60 = __arguments[0];
                    //super();
                    this._value = value_60;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            SignallingStateWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.SignallingStateWrapper]';
            };
            SignallingStateWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.SignallingState.New)
                        return 'New';
                    if (this._value == fm.liveswitch.SignallingState.HaveLocalOffer)
                        return 'HaveLocalOffer';
                    if (this._value == fm.liveswitch.SignallingState.HaveRemoteOffer)
                        return 'HaveRemoteOffer';
                    if (this._value == fm.liveswitch.SignallingState.Stable)
                        return 'Stable';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return SignallingStateWrapper;
        }());
        liveswitch.SignallingStateWrapper = SignallingStateWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A sink output (e.g. device, track, screen).
        */
        var SinkOutput = /** @class */ (function () {
            function SinkOutput() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else if (__arguments.length == 2) {
                    var idValue = __arguments[0];
                    var name_36 = __arguments[1];
                    //super();
                    this.setId(idValue);
                    this.setName(name_36);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            SinkOutput.prototype.getTypeString = function () {
                return '[fm.liveswitch.SinkOutput]';
            };
            /**
            Deserializes an instance from JSON.
            @param sinkOutputJson The sink output JSON.
            */
            SinkOutput.fromJson = function (sinkOutputJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(sinkOutputJson, function () {
                        return new fm.liveswitch.SinkOutput();
                    }, function (obj, key, valueJson) {
                        var str = key;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            if (!(fm.liveswitch.Global.equals(str, "id"))) {
                                if ((fm.liveswitch.Global.equals(str, "name"))) {
                                    obj.setName(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                }
                            }
                            else {
                                obj.setId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            }
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an instance array from JSON.
            @param sinkOutputsJson The sink outputs JSON.
            */
            SinkOutput.fromJsonArray = function (sinkOutputsJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(sinkOutputsJson, fm.liveswitch.SinkOutput.fromJson.bind(fm.liveswitch.SinkOutput));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param sinkOutput The sink output.
            */
            SinkOutput.toJson = function (sinkOutput) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(sinkOutput, function (obj, jsonObject) {
                        if ((!fm.liveswitch.Global.equals(obj.getId(), null))) {
                            jsonObject["id"] = fm.liveswitch.JsonSerializer.serializeString(obj.getId());
                        }
                        if ((!fm.liveswitch.Global.equals(obj.getName(), null))) {
                            jsonObject["name"] = fm.liveswitch.JsonSerializer.serializeString(obj.getName());
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance array to JSON.
            @param sinkOutputs The sink outputs.
            */
            SinkOutput.toJsonArray = function (sinkOutputs) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(sinkOutputs, fm.liveswitch.SinkOutput.toJson.bind(fm.liveswitch.SinkOutput));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the identifier.
            */
            SinkOutput.prototype.getId = function () {
                if (arguments.length == 0) {
                    return this._id;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name.
            */
            SinkOutput.prototype.getName = function () {
                if (arguments.length == 0) {
                    return this._name;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SinkOutput.prototype.setId = function (value) {
                if (arguments.length == 1) {
                    this._id = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SinkOutput.prototype.setName = function (value) {
                if (arguments.length == 1) {
                    this._name = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            SinkOutput.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.SinkOutput.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Returns a string that represents this instance.
            @return
                        A string that represents this instance.
                
            */
            SinkOutput.prototype.toString = function () {
                if (arguments.length == 0) {
                    return this.getName();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return SinkOutput;
        }());
        liveswitch.SinkOutput = SinkOutput;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A source input (e.g. device, track, screen).
        */
        var SourceInput = /** @class */ (function () {
            function SourceInput() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else if (__arguments.length == 2) {
                    var idValue = __arguments[0];
                    var name_37 = __arguments[1];
                    //super();
                    this.setId(idValue);
                    this.setName(name_37);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            SourceInput.prototype.getTypeString = function () {
                return '[fm.liveswitch.SourceInput]';
            };
            /**
            Deserializes an instance from JSON.
            @param sourceInputJson The source input JSON.
            */
            SourceInput.fromJson = function (sourceInputJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(sourceInputJson, function () {
                        return new fm.liveswitch.SourceInput();
                    }, function (obj, key, valueJson) {
                        var str = key;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            if (!(fm.liveswitch.Global.equals(str, "id"))) {
                                if ((fm.liveswitch.Global.equals(str, "name"))) {
                                    obj.setName(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                }
                            }
                            else {
                                obj.setId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            }
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an instance array from JSON.
            @param sourceInputsJson The source inputs JSON.
            */
            SourceInput.fromJsonArray = function (sourceInputsJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(sourceInputsJson, fm.liveswitch.SourceInput.fromJson.bind(fm.liveswitch.SourceInput));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param sourceInput The source input.
            */
            SourceInput.toJson = function (sourceInput) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(sourceInput, function (obj, jsonObject) {
                        if ((!fm.liveswitch.Global.equals(obj.getId(), null))) {
                            jsonObject["id"] = fm.liveswitch.JsonSerializer.serializeString(obj.getId());
                        }
                        if ((!fm.liveswitch.Global.equals(obj.getName(), null))) {
                            jsonObject["name"] = fm.liveswitch.JsonSerializer.serializeString(obj.getName());
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance array to JSON.
            @param sourceInputs The source inputs.
            */
            SourceInput.toJsonArray = function (sourceInputs) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(sourceInputs, fm.liveswitch.SourceInput.toJson.bind(fm.liveswitch.SourceInput));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the identifier.
            */
            SourceInput.prototype.getId = function () {
                if (arguments.length == 0) {
                    return this._id;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the name.
            */
            SourceInput.prototype.getName = function () {
                if (arguments.length == 0) {
                    return this._name;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the identifier.
            */
            SourceInput.prototype.setId = function (value) {
                if (arguments.length == 1) {
                    this._id = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the name.
            */
            SourceInput.prototype.setName = function (value) {
                if (arguments.length == 1) {
                    this._name = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            SourceInput.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.SourceInput.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Returns a string that represents this instance.
            @return
                        A string that represents this instance.
                
            */
            SourceInput.prototype.toString = function () {
                if (arguments.length == 0) {
                    return this.getName();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return SourceInput;
        }());
        liveswitch.SourceInput = SourceInput;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Collection.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A stream collection.
        */
        var StreamCollection = /** @class */ (function (_super) {
            __extends(StreamCollection, _super);
            function StreamCollection() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            StreamCollection.prototype.getTypeString = function () {
                return '[fm.liveswitch.StreamCollection]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Creates an array from a list.
            @param list The list.
            */
            StreamCollection.prototype.arrayFromList = function (list) {
                if (arguments.length == 1) {
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a collection.
            */
            StreamCollection.prototype.createCollection = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.StreamCollection();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a stream by its type.
            */
            StreamCollection.prototype.getByType = function (type) {
                if (arguments.length == 1) {
                    for (var _i = 0, _a = _super.prototype.getValues.call(this); _i < _a.length; _i++) {
                        var stream = _a[_i];
                        if ((fm.liveswitch.Global.equals(stream.getType(), type))) {
                            return stream;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets some streams by their type.
            */
            StreamCollection.prototype.getManyByType = function (type) {
                if (arguments.length == 1) {
                    var list = new Array();
                    for (var _i = 0, _a = _super.prototype.getValues.call(this); _i < _a.length; _i++) {
                        var stream = _a[_i];
                        if ((fm.liveswitch.Global.equals(stream.getType(), type))) {
                            fm.liveswitch.ArrayExtensions.add(list, stream);
                        }
                    }
                    return list;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return StreamCollection;
        }(fm.liveswitch.Collection));
        liveswitch.StreamCollection = StreamCollection;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var TransportTypeWrapper = /** @class */ (function () {
            function TransportTypeWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_61 = __arguments[0];
                    //super();
                    this._value = value_61;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            TransportTypeWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.TransportTypeWrapper]';
            };
            TransportTypeWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.TransportType.Gatherer)
                        return 'Gatherer';
                    if (this._value == fm.liveswitch.TransportType.IceTransport)
                        return 'IceTransport';
                    if (this._value == fm.liveswitch.TransportType.DtlsTransport)
                        return 'DtlsTransport';
                    if (this._value == fm.liveswitch.TransportType.SctpTransport)
                        return 'SctpTransport';
                    if (this._value == fm.liveswitch.TransportType.ReliableDataTransport)
                        return 'ReliableDataTransport';
                    if (this._value == fm.liveswitch.TransportType.SrtpTransport)
                        return 'SrtpTransport';
                    if (this._value == fm.liveswitch.TransportType.Unset)
                        return 'Unset';
                    if (this._value == fm.liveswitch.TransportType.MediaTransport)
                        return 'MediaTransport';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return TransportTypeWrapper;
        }());
        liveswitch.TransportTypeWrapper = TransportTypeWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var TrickleIcePolicyWrapper = /** @class */ (function () {
            function TrickleIcePolicyWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_62 = __arguments[0];
                    //super();
                    this._value = value_62;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            TrickleIcePolicyWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.TrickleIcePolicyWrapper]';
            };
            TrickleIcePolicyWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.TrickleIcePolicy.NotSupported)
                        return 'NotSupported';
                    if (this._value == fm.liveswitch.TrickleIcePolicy.FullTrickle)
                        return 'FullTrickle';
                    if (this._value == fm.liveswitch.TrickleIcePolicy.HalfTrickle)
                        return 'HalfTrickle';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return TrickleIcePolicyWrapper;
        }());
        liveswitch.TrickleIcePolicyWrapper = TrickleIcePolicyWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../VideoFormat.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var vp8;
        (function (vp8) {
            /**
            A VP8 format.
            */
            var Format = /** @class */ (function (_super) {
                __extends(Format, _super);
                function Format() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this, fm.liveswitch.VideoFormat.getVp8Name()) || this;
                    }
                    else if (__arguments.length == 1) {
                        var clockRate = __arguments[0];
                        _this = _super.call(this, fm.liveswitch.VideoFormat.getVp8Name(), clockRate) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                Format.prototype.getTypeString = function () {
                    return '[fm.liveswitch.vp8.Format]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Creates a new instance.
                */
                Format.prototype.createInstance = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.vp8.Format();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the maximum bitrate supported by this format, in kbps.
                */
                Format.prototype.getMaxBitrate = function () {
                    if (arguments.length == 0) {
                        return 100000;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the minimum bitrate supported by this format, in kbps.
                */
                Format.prototype.getMinBitrate = function () {
                    if (arguments.length == 0) {
                        return 100;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Format;
            }(fm.liveswitch.VideoFormat));
            vp8.Format = Format;
        })(vp8 = liveswitch.vp8 || (liveswitch.vp8 = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../VideoFormat.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var vp9;
        (function (vp9) {
            /**
            A VP9 format.
            */
            var Format = /** @class */ (function (_super) {
                __extends(Format, _super);
                function Format() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this, fm.liveswitch.VideoFormat.getVp9Name()) || this;
                    }
                    else if (__arguments.length == 1) {
                        var clockRate = __arguments[0];
                        _this = _super.call(this, fm.liveswitch.VideoFormat.getVp9Name(), clockRate) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                Format.prototype.getTypeString = function () {
                    return '[fm.liveswitch.vp9.Format]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /**
                Creates a new instance.
                */
                Format.prototype.createInstance = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.vp9.Format();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the maximum bitrate supported by this format, in kbps.
                */
                Format.prototype.getMaxBitrate = function () {
                    if (arguments.length == 0) {
                        return 100000;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /**
                Gets the minimum bitrate supported by this format, in kbps.
                */
                Format.prototype.getMinBitrate = function () {
                    if (arguments.length == 0) {
                        return 100;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Format;
            }(fm.liveswitch.VideoFormat));
            vp9.Format = Format;
        })(vp9 = liveswitch.vp9 || (liveswitch.vp9 = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A channel.
        */
        var Channel = /** @class */ (function (_super) {
            __extends(Channel, _super);
            /** @hidden */
            function Channel(sharedLock, connectionFactory, applicationId, userId, userAlias, deviceId, deviceAlias, clientId, clientTag, clientRoles, idValue, doSend) {
                var _this = this;
                fm.liveswitch.Channel.fmliveswitchChannelInitialize();
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 12) {
                    var sharedLock_2 = __arguments[0];
                    var connectionFactory_1 = __arguments[1];
                    var applicationId_1 = __arguments[2];
                    var userId_1 = __arguments[3];
                    var userAlias_1 = __arguments[4];
                    var deviceId_1 = __arguments[5];
                    var deviceAlias_1 = __arguments[6];
                    var clientId_1 = __arguments[7];
                    var clientTag_1 = __arguments[8];
                    var clientRoles_1 = __arguments[9];
                    var idValue_9 = __arguments[10];
                    var doSend_1 = __arguments[11];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchChannelInit();
                    _this.__left = false;
                    _this.__messagesSent = new fm.liveswitch.AtomicLong();
                    _this.__messagesReceived = new fm.liveswitch.AtomicLong();
                    _this.__messageBytesSent = new fm.liveswitch.AtomicLong();
                    _this.__messageBytesReceived = new fm.liveswitch.AtomicLong();
                    _this.__lock = sharedLock_2;
                    _this.__channelQueue = new fm.liveswitch.DispatchQueue(_this.processMessageSync.bind(_this));
                    _this.setApplicationId(applicationId_1);
                    _this.setUserId(userId_1);
                    _this.setUserAlias(userAlias_1);
                    _this.setDeviceId(deviceId_1);
                    _this.setDeviceAlias(deviceAlias_1);
                    _this.setClientId(clientId_1);
                    _this.setClientTag(clientTag_1);
                    _this.setClientRoles(clientRoles_1);
                    _this.setId(idValue_9);
                    _this.__doSend = doSend_1;
                    _this.__connectionFactory = connectionFactory_1;
                    _this.__remoteClientInfos = new Array();
                    _this.__remoteUpstreamConnectionInfos = new Array();
                    _this.__peerConnectionOffers = new fm.liveswitch.ManagedConcurrentDictionary();
                    _this.__invitations = new fm.liveswitch.ManagedConcurrentDictionary();
                    _this.setConnections(new fm.liveswitch.ManagedConnectionCollection());
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            Channel.prototype.getTypeString = function () {
                return '[fm.liveswitch.Channel]' + ',' + _super.prototype.getTypeString.call(this);
            };
            Channel.prototype.fmliveswitchChannelInit = function () {
                var _this = this;
                this.__left = false;
                this.__onClaimUpdate = [];
                this.__onClientMessage = [];
                this.__onDeviceMessage = [];
                this.__onKick = [];
                this.__onMcuVideoLayout = [];
                this.__onMessage = [];
                this.__onPeerConnectionOffer = [];
                this.__onRemoteClientJoin = [];
                this.__onRemoteClientLeave = [];
                this.__onRemoteClientUpdate = [];
                this.__onRemoteUpstreamConnectionClose = [];
                this.__onRemoteUpstreamConnectionOpen = [];
                this.__onRemoteUpstreamConnectionUpdate = [];
                this.__onUserMessage = [];
                this._onClaimUpdate = function (p0, p1) { for (var _i = 0, _a = _this.__onClaimUpdate; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0, p1);
                } };
                this._onClientMessage = function (p0, p1) { for (var _i = 0, _a = _this.__onClientMessage; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0, p1);
                } };
                this._onDeviceMessage = function (p0, p1) { for (var _i = 0, _a = _this.__onDeviceMessage; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0, p1);
                } };
                this._onKick = function () { for (var _i = 0, _a = _this.__onKick; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action();
                } };
                this._onMcuVideoLayout = function (p0) { for (var _i = 0, _a = _this.__onMcuVideoLayout; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
                this._onMessage = function (p0, p1) { for (var _i = 0, _a = _this.__onMessage; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0, p1);
                } };
                this._onPeerConnectionOffer = function (p0) { for (var _i = 0, _a = _this.__onPeerConnectionOffer; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
                this._onRemoteClientJoin = function (p0) { for (var _i = 0, _a = _this.__onRemoteClientJoin; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
                this._onRemoteClientLeave = function (p0) { for (var _i = 0, _a = _this.__onRemoteClientLeave; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
                this._onRemoteClientUpdate = function (p0, p1) { for (var _i = 0, _a = _this.__onRemoteClientUpdate; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0, p1);
                } };
                this._onRemoteUpstreamConnectionClose = function (p0) { for (var _i = 0, _a = _this.__onRemoteUpstreamConnectionClose; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
                this._onRemoteUpstreamConnectionOpen = function (p0) { for (var _i = 0, _a = _this.__onRemoteUpstreamConnectionOpen; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
                this._onRemoteUpstreamConnectionUpdate = function (p0, p1) { for (var _i = 0, _a = _this.__onRemoteUpstreamConnectionUpdate; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0, p1);
                } };
                this._onUserMessage = function (p0, p1) { for (var _i = 0, _a = _this.__onUserMessage; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0, p1);
                } };
            };
            /**
            Adds a handler that is raised when the client's channel claim has been updated. Parameters: - oldConnectionInfo - the old channel claim - newConnectionInfo - the new channel claim
            */
            Channel.prototype.addOnClaimUpdate = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onClaimUpdate, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when a client message is received from the server. Parameters: - clientInfo - the sending client information - message - the message
            */
            Channel.prototype.addOnClientMessage = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onClientMessage, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when a device message is received from the server. Parameters: - clientInfo - the sending client information - message - the message
            */
            Channel.prototype.addOnDeviceMessage = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onDeviceMessage, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when the client is kicked from the channel.
            */
            Channel.prototype.addOnKick = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onKick, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when a new MCU video layout is received from the server. Parameters: - videoLayout - the new MCU video layout
            */
            Channel.prototype.addOnMcuVideoLayout = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onMcuVideoLayout, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when a channel message is received from the server. Parameters: - clientInfo - the sending client information - message - the message
            */
            Channel.prototype.addOnMessage = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onMessage, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when a remote client wants to open a peer connection. Parameters: - peerConnectionOffer - the peer connection offer
            */
            Channel.prototype.addOnPeerConnectionOffer = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onPeerConnectionOffer, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when a remote client joins this channel. Parameters: - clientInfo - the remote client information
            */
            Channel.prototype.addOnRemoteClientJoin = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onRemoteClientJoin, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when a remote client leaves this channel. Parameters: - clientInfo - the remote client information
            */
            Channel.prototype.addOnRemoteClientLeave = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onRemoteClientLeave, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when a remote client updates their config. Parameters: - oldClientInfo - the old remote client information - newClientInfo - the new remote client information
            */
            Channel.prototype.addOnRemoteClientUpdate = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onRemoteClientUpdate, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when a remote upstream (SFU or MCU) connection is closed by a remote client. Parameters: - connectionInfo - the remote connection information
            */
            Channel.prototype.addOnRemoteUpstreamConnectionClose = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onRemoteUpstreamConnectionClose, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when a remote upstream (SFU or MCU) connection is opened by a remote client. Parameters: - connectionInfo - the remote connection information
            */
            Channel.prototype.addOnRemoteUpstreamConnectionOpen = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onRemoteUpstreamConnectionOpen, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when a remote upstream (SFU or MCU) connection is updated by a remote client. Parameters: - oldConnectionInfo - the old remote connection information - newConnectionInfo - the new remote connection information
            */
            Channel.prototype.addOnRemoteUpstreamConnectionUpdate = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onRemoteUpstreamConnectionUpdate, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when a user message is received from the server. Parameters: - clientInfo - the sending client information - message - the message
            */
            Channel.prototype.addOnUserMessage = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onUserMessage, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Closes all active connections.
            */
            Channel.prototype.closeAll = function () {
                if (arguments.length == 0) {
                    fm.liveswitch.Channel.fm_liveswitch_Channel___log.debug(fm.liveswitch.StringExtensions.format("Closing all channel {0} connections.", this.getId()));
                    var list = new Array();
                    for (var _i = 0, _a = this.getConnections().getValues(); _i < _a.length; _i++) {
                        var connection = _a[_i];
                        fm.liveswitch.ArrayExtensions.add(list, connection.close());
                    }
                    return fm.liveswitch.PromiseBase.all(fm.liveswitch.ArrayExtensions.toArray(list));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Channel.prototype.createMcuConnection = function () {
                if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.AudioStream]'))) {
                    var audioStream = arguments[0];
                    return this.createMcuConnection(audioStream, null, null, null);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.AudioStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.DataStream]'))) {
                    var audioStream = arguments[0];
                    var dataStream = arguments[1];
                    return this.createMcuConnection(audioStream, null, dataStream, null);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.AudioStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.DataStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isString(arguments[2]))) {
                    var audioStream = arguments[0];
                    var dataStream = arguments[1];
                    var mediaId = arguments[2];
                    return this.createMcuConnection(audioStream, null, dataStream, mediaId);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.AudioStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                    var audioStream = arguments[0];
                    var mediaId = arguments[1];
                    return this.createMcuConnection(audioStream, null, null, mediaId);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.AudioStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.VideoStream]'))) {
                    var audioStream = arguments[0];
                    var videoStream = arguments[1];
                    return this.createMcuConnection(audioStream, videoStream, null, null);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.AudioStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.VideoStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isObjectType(arguments[2], '[fm.liveswitch.DataStream]'))) {
                    var audioStream = arguments[0];
                    var videoStream = arguments[1];
                    var dataStream = arguments[2];
                    return this.createMcuConnection(audioStream, videoStream, dataStream, null);
                }
                else if (arguments.length == 4) {
                    var audioStream = arguments[0];
                    var videoStream = arguments[1];
                    var dataStream = arguments[2];
                    var mediaId = arguments[3];
                    if (this.__left) {
                        throw new fm.liveswitch.Exception("You have left this channel.");
                    }
                    if ((((fm.liveswitch.Global.equals(audioStream, null)) && (fm.liveswitch.Global.equals(videoStream, null))) && (fm.liveswitch.Global.equals(dataStream, null)))) {
                        throw new fm.liveswitch.Exception("Cannot open a connection with no streams.");
                    }
                    if ((!fm.liveswitch.Global.equals(dataStream, null))) {
                        dataStream.setGetRemoteConnectionInfo(this.getRemoteConnectionInfo.bind(this));
                    }
                    var connection = this.__connectionFactory.createMcuConnection(this.__lock, this.getApplicationId(), this.getId(), this.getUserId(), this.getDeviceId(), this.getClientId(), this.send.bind(this), audioStream, videoStream, dataStream, mediaId);
                    this.getConnections().add(connection);
                    connection.addOnStateChange(this.processConnectionStateChange.bind(this));
                    return connection;
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.AudioStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.VideoStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isString(arguments[2]))) {
                    var audioStream = arguments[0];
                    var videoStream = arguments[1];
                    var mediaId = arguments[2];
                    return this.createMcuConnection(audioStream, videoStream, null, mediaId);
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.DataStream]'))) {
                    var dataStream = arguments[0];
                    return this.createMcuConnection(null, null, dataStream, null);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.DataStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                    var dataStream = arguments[0];
                    var mediaId = arguments[1];
                    return this.createMcuConnection(null, null, dataStream, mediaId);
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.VideoStream]'))) {
                    var videoStream = arguments[0];
                    return this.createMcuConnection(null, videoStream, null, null);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.VideoStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.DataStream]'))) {
                    var videoStream = arguments[0];
                    var dataStream = arguments[1];
                    return this.createMcuConnection(null, videoStream, dataStream, null);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.VideoStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.DataStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isString(arguments[2]))) {
                    var videoStream = arguments[0];
                    var dataStream = arguments[1];
                    var mediaId = arguments[2];
                    return this.createMcuConnection(null, videoStream, dataStream, mediaId);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.VideoStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                    var videoStream = arguments[0];
                    var mediaId = arguments[1];
                    return this.createMcuConnection(null, videoStream, null, mediaId);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Channel.prototype.createPeerConnection = function () {
                if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.PeerConnectionOffer]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.AudioStream]'))) {
                    var peerConnectionOffer = arguments[0];
                    var audioStream = arguments[1];
                    return this.createPeerConnection(peerConnectionOffer, audioStream, null, null);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.PeerConnectionOffer]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.AudioStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isObjectType(arguments[2], '[fm.liveswitch.DataStream]'))) {
                    var peerConnectionOffer = arguments[0];
                    var audioStream = arguments[1];
                    var dataStream = arguments[2];
                    return this.createPeerConnection(peerConnectionOffer, audioStream, null, dataStream);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.PeerConnectionOffer]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.AudioStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isObjectType(arguments[2], '[fm.liveswitch.VideoStream]'))) {
                    var peerConnectionOffer = arguments[0];
                    var audioStream = arguments[1];
                    var videoStream = arguments[2];
                    return this.createPeerConnection(peerConnectionOffer, audioStream, videoStream, null);
                }
                else if (arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.PeerConnectionOffer]'))) {
                    var peerConnectionOffer = arguments[0];
                    var audioStream = arguments[1];
                    var videoStream = arguments[2];
                    var dataStream = arguments[3];
                    if (this.__left) {
                        throw new fm.liveswitch.Exception("You have left this channel.");
                    }
                    if ((fm.liveswitch.Global.equals(peerConnectionOffer, null))) {
                        throw new fm.liveswitch.Exception("Peer connection offer cannot be null.");
                    }
                    if ((((fm.liveswitch.Global.equals(audioStream, null)) && (fm.liveswitch.Global.equals(videoStream, null))) && (fm.liveswitch.Global.equals(dataStream, null)))) {
                        throw new fm.liveswitch.Exception("Cannot open a connection with no streams.");
                    }
                    if (!((fm.liveswitch.Global.equals(audioStream, null)) || peerConnectionOffer.getHasAudio())) {
                        throw new fm.liveswitch.Exception("Cannot open a connection with an audio stream if the offer does not contain an audio description.");
                    }
                    if (!((fm.liveswitch.Global.equals(videoStream, null)) || peerConnectionOffer.getHasVideo())) {
                        throw new fm.liveswitch.Exception("Cannot open a connection with a video stream if the offer does not contain a video description.");
                    }
                    if (!((fm.liveswitch.Global.equals(dataStream, null)) || peerConnectionOffer.getHasData())) {
                        throw new fm.liveswitch.Exception("Cannot open a connection with a data stream if the offer does not contain a data description.");
                    }
                    if (((fm.liveswitch.Global.equals(audioStream, null)) && peerConnectionOffer.getHasAudio())) {
                        throw new fm.liveswitch.Exception("An audio stream is required by the offer.");
                    }
                    if (((fm.liveswitch.Global.equals(videoStream, null)) && peerConnectionOffer.getHasVideo())) {
                        throw new fm.liveswitch.Exception("A video stream is required by the offer.");
                    }
                    if (((fm.liveswitch.Global.equals(dataStream, null)) && peerConnectionOffer.getHasData())) {
                        throw new fm.liveswitch.Exception("A data stream is required by the offer.");
                    }
                    if (this.__peerConnectionOffers.tryRemove(peerConnectionOffer.getRemoteConnectionId())) {
                        var connection = this.__connectionFactory.createPeerConnection(this.__lock, this.getApplicationId(), this.getId(), this.getUserId(), this.getDeviceId(), this.getClientId(), this.send.bind(this), peerConnectionOffer, audioStream, videoStream, dataStream);
                        this.getConnections().add(connection);
                        connection.addOnStateChange(this.processConnectionStateChange.bind(this));
                        for (var _i = 0, _a = peerConnectionOffer.getEarlyCandidateMessages(); _i < _a.length; _i++) {
                            var message = _a[_i];
                            connection.processMessage(message);
                        }
                        return connection;
                    }
                    return null;
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.PeerConnectionOffer]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.DataStream]'))) {
                    var peerConnectionOffer = arguments[0];
                    var dataStream = arguments[1];
                    return this.createPeerConnection(peerConnectionOffer, null, null, dataStream);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.PeerConnectionOffer]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.VideoStream]'))) {
                    var peerConnectionOffer = arguments[0];
                    var videoStream = arguments[1];
                    return this.createPeerConnection(peerConnectionOffer, null, videoStream, null);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.PeerConnectionOffer]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.VideoStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isObjectType(arguments[2], '[fm.liveswitch.DataStream]'))) {
                    var peerConnectionOffer = arguments[0];
                    var videoStream = arguments[1];
                    var dataStream = arguments[2];
                    return this.createPeerConnection(peerConnectionOffer, null, videoStream, dataStream);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.ClientInfo]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.AudioStream]'))) {
                    var remoteClientInfo = arguments[0];
                    var audioStream = arguments[1];
                    return this.createPeerConnection(remoteClientInfo, audioStream, null, null);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.ClientInfo]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.AudioStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isObjectType(arguments[2], '[fm.liveswitch.DataStream]'))) {
                    var remoteClientInfo = arguments[0];
                    var audioStream = arguments[1];
                    var dataStream = arguments[2];
                    return this.createPeerConnection(remoteClientInfo, audioStream, null, dataStream);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.ClientInfo]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.AudioStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isObjectType(arguments[2], '[fm.liveswitch.VideoStream]'))) {
                    var remoteClientInfo = arguments[0];
                    var audioStream = arguments[1];
                    var videoStream = arguments[2];
                    return this.createPeerConnection(remoteClientInfo, audioStream, videoStream, null);
                }
                else if (arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.ClientInfo]'))) {
                    var remoteClientInfo = arguments[0];
                    var audioStream = arguments[1];
                    var videoStream = arguments[2];
                    var dataStream = arguments[3];
                    if (this.__left) {
                        throw new fm.liveswitch.Exception("You have left this channel.");
                    }
                    if ((fm.liveswitch.Global.equals(remoteClientInfo, null))) {
                        throw new fm.liveswitch.Exception("Remote client information cannot be null.");
                    }
                    if ((((fm.liveswitch.Global.equals(audioStream, null)) && (fm.liveswitch.Global.equals(videoStream, null))) && (fm.liveswitch.Global.equals(dataStream, null)))) {
                        throw new fm.liveswitch.Exception("Cannot open a connection with no streams.");
                    }
                    var connection = this.__connectionFactory.createPeerConnection(this.__lock, this.getApplicationId(), this.getId(), this.getUserId(), this.getDeviceId(), this.getClientId(), this.send.bind(this), remoteClientInfo, audioStream, videoStream, dataStream);
                    this.getConnections().add(connection);
                    connection.addOnStateChange(this.processConnectionStateChange.bind(this));
                    return connection;
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.ClientInfo]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.DataStream]'))) {
                    var remoteClientInfo = arguments[0];
                    var dataStream = arguments[1];
                    return this.createPeerConnection(remoteClientInfo, null, null, dataStream);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.ClientInfo]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.VideoStream]'))) {
                    var remoteClientInfo = arguments[0];
                    var videoStream = arguments[1];
                    return this.createPeerConnection(remoteClientInfo, null, videoStream, null);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.ClientInfo]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.VideoStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isObjectType(arguments[2], '[fm.liveswitch.DataStream]'))) {
                    var remoteClientInfo = arguments[0];
                    var videoStream = arguments[1];
                    var dataStream = arguments[2];
                    return this.createPeerConnection(remoteClientInfo, null, videoStream, dataStream);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Channel.prototype.createSfuDownstreamConnection = function () {
                if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.ConnectionInfo]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.AudioStream]'))) {
                    var remoteConnectionInfo = arguments[0];
                    var audioStream = arguments[1];
                    return this.createSfuDownstreamConnection(remoteConnectionInfo, audioStream, null, null);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.ConnectionInfo]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.AudioStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isObjectType(arguments[2], '[fm.liveswitch.DataStream]'))) {
                    var remoteConnectionInfo = arguments[0];
                    var audioStream = arguments[1];
                    var dataStream = arguments[2];
                    return this.createSfuDownstreamConnection(remoteConnectionInfo, audioStream, null, dataStream);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.ConnectionInfo]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.AudioStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isObjectType(arguments[2], '[fm.liveswitch.VideoStream]'))) {
                    var remoteConnectionInfo = arguments[0];
                    var audioStream = arguments[1];
                    var videoStream = arguments[2];
                    return this.createSfuDownstreamConnection(remoteConnectionInfo, audioStream, videoStream, null);
                }
                else if (arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.ConnectionInfo]'))) {
                    var remoteConnectionInfo = arguments[0];
                    var audioStream = arguments[1];
                    var videoStream = arguments[2];
                    var dataStream = arguments[3];
                    if (this.__left) {
                        throw new fm.liveswitch.Exception("You have left this channel.");
                    }
                    if ((fm.liveswitch.Global.equals(remoteConnectionInfo, null))) {
                        throw new fm.liveswitch.Exception("Remote connection information cannot be null.");
                    }
                    if ((((fm.liveswitch.Global.equals(audioStream, null)) && (fm.liveswitch.Global.equals(videoStream, null))) && (fm.liveswitch.Global.equals(dataStream, null)))) {
                        throw new fm.liveswitch.Exception("Cannot open a connection with no streams.");
                    }
                    if ((!fm.liveswitch.Global.equals(dataStream, null))) {
                        dataStream.setGetRemoteConnectionInfo(this.getRemoteConnectionInfo.bind(this));
                    }
                    var connection = this.__connectionFactory.createSfuDownstreamConnection(this.__lock, this.getApplicationId(), this.getId(), this.getUserId(), this.getDeviceId(), this.getClientId(), this.send.bind(this), remoteConnectionInfo, audioStream, videoStream, dataStream);
                    this.getConnections().add(connection);
                    connection.addOnStateChange(this.processConnectionStateChange.bind(this));
                    return connection;
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.ConnectionInfo]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.DataStream]'))) {
                    var remoteConnectionInfo = arguments[0];
                    var dataStream = arguments[1];
                    return this.createSfuDownstreamConnection(remoteConnectionInfo, null, null, dataStream);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.ConnectionInfo]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.VideoStream]'))) {
                    var remoteConnectionInfo = arguments[0];
                    var videoStream = arguments[1];
                    return this.createSfuDownstreamConnection(remoteConnectionInfo, null, videoStream, null);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.ConnectionInfo]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.VideoStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isObjectType(arguments[2], '[fm.liveswitch.DataStream]'))) {
                    var remoteConnectionInfo = arguments[0];
                    var videoStream = arguments[1];
                    var dataStream = arguments[2];
                    return this.createSfuDownstreamConnection(remoteConnectionInfo, null, videoStream, dataStream);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.AudioStream]'))) {
                    var remoteMediaId = arguments[0];
                    var audioStream = arguments[1];
                    return this.createSfuDownstreamConnection(remoteMediaId, audioStream, null, null);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.AudioStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isObjectType(arguments[2], '[fm.liveswitch.DataStream]'))) {
                    var remoteMediaId = arguments[0];
                    var audioStream = arguments[1];
                    var dataStream = arguments[2];
                    return this.createSfuDownstreamConnection(remoteMediaId, audioStream, null, dataStream);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.AudioStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isObjectType(arguments[2], '[fm.liveswitch.VideoStream]'))) {
                    var remoteMediaId = arguments[0];
                    var audioStream = arguments[1];
                    var videoStream = arguments[2];
                    return this.createSfuDownstreamConnection(remoteMediaId, audioStream, videoStream, null);
                }
                else if (arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                    var remoteMediaId = arguments[0];
                    var audioStream = arguments[1];
                    var videoStream = arguments[2];
                    var dataStream = arguments[3];
                    if (this.__left) {
                        throw new fm.liveswitch.Exception("You have left this channel.");
                    }
                    if ((fm.liveswitch.Global.equals(remoteMediaId, null))) {
                        throw new fm.liveswitch.Exception("Remote media identifier cannot be null.");
                    }
                    if ((((fm.liveswitch.Global.equals(audioStream, null)) && (fm.liveswitch.Global.equals(videoStream, null))) && (fm.liveswitch.Global.equals(dataStream, null)))) {
                        throw new fm.liveswitch.Exception("Cannot open a connection with no streams.");
                    }
                    if ((!fm.liveswitch.Global.equals(dataStream, null))) {
                        dataStream.setGetRemoteConnectionInfo(this.getRemoteConnectionInfo.bind(this));
                    }
                    var connection = this.__connectionFactory.createSfuDownstreamConnection(this.__lock, this.getApplicationId(), this.getId(), this.getUserId(), this.getDeviceId(), this.getClientId(), this.send.bind(this), remoteMediaId, audioStream, videoStream, dataStream);
                    this.getConnections().add(connection);
                    connection.addOnStateChange(this.processConnectionStateChange.bind(this));
                    return connection;
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.DataStream]'))) {
                    var remoteMediaId = arguments[0];
                    var dataStream = arguments[1];
                    return this.createSfuDownstreamConnection(remoteMediaId, null, null, dataStream);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.VideoStream]'))) {
                    var remoteMediaId = arguments[0];
                    var videoStream = arguments[1];
                    return this.createSfuDownstreamConnection(remoteMediaId, null, videoStream, null);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.VideoStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isObjectType(arguments[2], '[fm.liveswitch.DataStream]'))) {
                    var remoteMediaId = arguments[0];
                    var videoStream = arguments[1];
                    var dataStream = arguments[2];
                    return this.createSfuDownstreamConnection(remoteMediaId, null, videoStream, dataStream);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Channel.prototype.createSfuUpstreamConnection = function () {
                if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.AudioStream]'))) {
                    var audioStream = arguments[0];
                    return this.createSfuUpstreamConnection(audioStream, null, null, null);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.AudioStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.DataStream]'))) {
                    var audioStream = arguments[0];
                    var dataStream = arguments[1];
                    return this.createSfuUpstreamConnection(audioStream, null, dataStream);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.AudioStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.DataStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isString(arguments[2]))) {
                    var audioStream = arguments[0];
                    var dataStream = arguments[1];
                    var mediaId = arguments[2];
                    return this.createSfuUpstreamConnection(audioStream, null, dataStream, mediaId);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.AudioStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                    var audioStream = arguments[0];
                    var mediaId = arguments[1];
                    return this.createSfuUpstreamConnection(audioStream, null, null, mediaId);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.AudioStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.VideoStream]'))) {
                    var audioStream = arguments[0];
                    var videoStream = arguments[1];
                    return this.createSfuUpstreamConnection(audioStream, videoStream, null, null);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.AudioStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.VideoStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isObjectType(arguments[2], '[fm.liveswitch.DataStream]'))) {
                    var audioStream = arguments[0];
                    var videoStream = arguments[1];
                    var dataStream = arguments[2];
                    return this.createSfuUpstreamConnection(audioStream, videoStream, dataStream, null);
                }
                else if (arguments.length == 4) {
                    var audioStream = arguments[0];
                    var videoStream = arguments[1];
                    var dataStream = arguments[2];
                    var mediaId = arguments[3];
                    if (this.__left) {
                        throw new fm.liveswitch.Exception("You have left this channel.");
                    }
                    if ((((fm.liveswitch.Global.equals(audioStream, null)) && (fm.liveswitch.Global.equals(videoStream, null))) && (fm.liveswitch.Global.equals(dataStream, null)))) {
                        throw new fm.liveswitch.Exception("Cannot open a connection with no streams.");
                    }
                    if ((!fm.liveswitch.Global.equals(dataStream, null))) {
                        dataStream.setGetRemoteConnectionInfo(this.getRemoteConnectionInfo.bind(this));
                    }
                    var connection = this.__connectionFactory.createSfuUpstreamConnection(this.__lock, this.getApplicationId(), this.getId(), this.getUserId(), this.getDeviceId(), this.getClientId(), this.send.bind(this), audioStream, videoStream, dataStream, mediaId);
                    this.getConnections().add(connection);
                    connection.addOnStateChange(this.processConnectionStateChange.bind(this));
                    return connection;
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.AudioStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.VideoStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isString(arguments[2]))) {
                    var audioStream = arguments[0];
                    var videoStream = arguments[1];
                    var mediaId = arguments[2];
                    return this.createSfuUpstreamConnection(audioStream, videoStream, null, mediaId);
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.DataStream]'))) {
                    var dataStream = arguments[0];
                    return this.createSfuUpstreamConnection(null, null, dataStream);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.DataStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                    var dataStream = arguments[0];
                    var mediaId = arguments[1];
                    return this.createSfuUpstreamConnection(null, null, dataStream, mediaId);
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.VideoStream]'))) {
                    var videoStream = arguments[0];
                    return this.createSfuUpstreamConnection(null, videoStream, null, null);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.VideoStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.DataStream]'))) {
                    var videoStream = arguments[0];
                    var dataStream = arguments[1];
                    return this.createSfuUpstreamConnection(null, videoStream, dataStream);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.VideoStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.DataStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isString(arguments[2]))) {
                    var videoStream = arguments[0];
                    var dataStream = arguments[1];
                    var mediaId = arguments[2];
                    return this.createSfuUpstreamConnection(null, videoStream, dataStream, mediaId);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.VideoStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                    var videoStream = arguments[0];
                    var mediaId = arguments[1];
                    return this.createSfuUpstreamConnection(null, videoStream, null, mediaId);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.doInvite = function (promise, invite, msg) {
                var _this = this;
                if (arguments.length == 3) {
                    this.send(msg).then(function (m) {
                        _this.processInviteFeedback(m);
                        promise.resolve(invite);
                    }, function (ex) {
                        promise.reject(ex);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.doKickClient = function (promise, remoteClientInfo) {
                if (arguments.length == 2) {
                    this.send(fm.liveswitch.Message.createKickMessage(this.getId(), remoteClientInfo.getId())).then(function (msg) {
                        if (((!fm.liveswitch.Global.equals(msg, null)) && (fm.liveswitch.Global.equals(msg.getType(), fm.liveswitch.MessageType.getError())))) {
                            promise.reject(new fm.liveswitch.Exception(msg.getPayload()));
                        }
                        else {
                            promise.resolve(null);
                        }
                    }, function (ex) {
                        promise.reject(ex);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.doSimpleSend = function (promise, message) {
                if (arguments.length == 2) {
                    var resolveAction = null;
                    var rejectAction = null;
                    try {
                        if (this.__left) {
                            throw new fm.liveswitch.Exception("You have left this channel.");
                        }
                        if ((fm.liveswitch.Global.equals(resolveAction, null))) {
                            resolveAction = function (response) {
                                promise.resolve(null);
                            };
                        }
                        if ((fm.liveswitch.Global.equals(rejectAction, null))) {
                            rejectAction = function (ex) {
                                promise.reject(ex);
                            };
                        }
                        this.send(message).then(resolveAction, rejectAction);
                    }
                    catch (exception) {
                        promise.reject(exception);
                    }
                    finally {
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.doUpdate = function (promise, newConfig) {
                if (arguments.length == 2) {
                    this.send(fm.liveswitch.Message.createUpdateMessage(newConfig.toJson())).then(function (msg) {
                        if (((!fm.liveswitch.Global.equals(msg, null)) && (fm.liveswitch.Global.equals(msg.getType(), fm.liveswitch.MessageType.getError())))) {
                            promise.reject(new fm.liveswitch.Exception(msg.getPayload()));
                        }
                        else {
                            promise.resolve(null);
                        }
                    }, function (ex) {
                        promise.reject(ex);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the application identifier.
            */
            Channel.prototype.getApplicationId = function () {
                if (arguments.length == 0) {
                    return this._applicationId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the claim.
            */
            Channel.prototype.getClaim = function () {
                if (arguments.length == 0) {
                    return this._claim;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client identifier.
            */
            Channel.prototype.getClientId = function () {
                if (arguments.length == 0) {
                    return this._clientId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client roles.
            */
            Channel.prototype.getClientRoles = function () {
                if (arguments.length == 0) {
                    return this._clientRoles;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client tag.
            */
            Channel.prototype.getClientTag = function () {
                if (arguments.length == 0) {
                    return this._clientTag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the active connections.
            */
            Channel.prototype.getConnections = function () {
                if (arguments.length == 0) {
                    return this._connections;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the device alias.
            */
            Channel.prototype.getDeviceAlias = function () {
                if (arguments.length == 0) {
                    return this._deviceAlias;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the device identifier.
            */
            Channel.prototype.getDeviceId = function () {
                if (arguments.length == 0) {
                    return this._deviceId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.getEquivalentRemoteClientInfo = function (remoteClientInfo) {
                if (arguments.length == 1) {
                    for (var _i = 0, _a = this.getRemoteClientInfos(); _i < _a.length; _i++) {
                        var info = _a[_i];
                        if (info.isEquivalent(remoteClientInfo)) {
                            return info;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.getEquivalentRemoteUpstreamConnectionInfo = function (remoteUpstreamConnectionInfo) {
                if (arguments.length == 1) {
                    for (var _i = 0, _a = this.getRemoteUpstreamConnectionInfos(); _i < _a.length; _i++) {
                        var info = _a[_i];
                        if (info.isEquivalent(remoteUpstreamConnectionInfo)) {
                            return info;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the channel identifier.
            */
            Channel.prototype.getId = function () {
                if (arguments.length == 0) {
                    return this._id;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of message bytes received.
            */
            Channel.prototype.getMessageBytesReceived = function () {
                if (arguments.length == 0) {
                    return this.__messageBytesReceived.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of message bytes sent.
            */
            Channel.prototype.getMessageBytesSent = function () {
                if (arguments.length == 0) {
                    return this.__messageBytesSent.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of messages received.
            */
            Channel.prototype.getMessagesReceived = function () {
                if (arguments.length == 0) {
                    return this.__messagesReceived.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of messages sent.
            */
            Channel.prototype.getMessagesSent = function () {
                if (arguments.length == 0) {
                    return this.__messagesSent.getValue();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets information about a remote client.
            @param clientId The client identifier.
            */
            Channel.prototype.getRemoteClientInfo = function (clientId) {
                if (arguments.length == 1) {
                    for (var _i = 0, _a = this.getRemoteClientInfos(); _i < _a.length; _i++) {
                        var info = _a[_i];
                        if ((fm.liveswitch.Global.equals(info.getId(), clientId))) {
                            return info;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets information about the remote client in this channel.
            */
            Channel.prototype.getRemoteClientInfos = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ArrayExtensions.toArray(this.__remoteClientInfos);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets information about a remote connection.
            @param connectionId The connection identifier.
            */
            Channel.prototype.getRemoteConnectionInfo = function (connectionId) {
                if (arguments.length == 1) {
                    for (var _i = 0, _a = this.getRemoteUpstreamConnectionInfos(); _i < _a.length; _i++) {
                        var info = _a[_i];
                        if ((fm.liveswitch.Global.equals(info.getId(), connectionId))) {
                            return info;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets information about the remote upstream (SFU or MCU) connections opened by remote clients in this channel.
            */
            Channel.prototype.getRemoteUpstreamConnectionInfos = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ArrayExtensions.toArray(this.__remoteUpstreamConnectionInfos);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.getReport = function () {
                if (arguments.length == 0) {
                    var report = new fm.liveswitch.ChannelReport();
                    report.setId(this.getId());
                    report.setMessagesSent(this.getMessagesSent());
                    report.setMessagesReceived(this.getMessagesReceived());
                    report.setMessageBytesSent(this.getMessageBytesSent());
                    report.setMessageBytesReceived(this.getMessageBytesReceived());
                    return report;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the user alias.
            */
            Channel.prototype.getUserAlias = function () {
                if (arguments.length == 0) {
                    return this._userAlias;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the user identifier.
            */
            Channel.prototype.getUserId = function () {
                if (arguments.length == 0) {
                    return this._userId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Invites a user into this channel.
            @param userId The user id to invite.
            @param protocol The protocol to use for the invite.
            */
            Channel.prototype.invite = function (userId, protocol) {
                if (arguments.length == 2) {
                    var invitation = new fm.liveswitch.Invitation(this, userId, protocol);
                    if (this.__invitations.tryAdd(invitation.getInviteKey(), invitation)) {
                        var promise = new fm.liveswitch.Promise();
                        var msg = fm.liveswitch.Message.createInviteMessage(userId, protocol);
                        this.doInvite(promise, invitation, msg);
                        return promise;
                    }
                    return fm.liveswitch.PromiseBase.rejectNow(new fm.liveswitch.Exception("Already existing invitation for this user and protocol."));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Kicks a client from this channel if the kick permission is enabled.
            @param remoteClientInfo The remote client to kick.
            */
            Channel.prototype.kickClient = function (remoteClientInfo) {
                if (arguments.length == 1) {
                    var promise = new fm.liveswitch.Promise();
                    this.doKickClient(promise, remoteClientInfo);
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.leave = function () {
                if (arguments.length == 0) {
                    this.__channelQueue.destroy();
                    this.__left = true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processAnswer = function (message) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(message.getConnectionId(), null))) {
                        this.processMessageForLocalConnection(message);
                    }
                    else {
                        if ((!fm.liveswitch.Global.equals(message.getRemoteConnectionId(), null))) {
                            this.processMessageForRemoteConnection(message);
                        }
                        else {
                            fm.liveswitch.Channel.fm_liveswitch_Channel___log.debug(fm.liveswitch.StringExtensions.format("Discarding unrecognized '{0}' message. ({1})", message.getType(), message.toJson()));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processBitrateNotification = function (message) {
                if (arguments.length == 1) {
                    var connection = ((!fm.liveswitch.Global.equals(message.getConnectionId(), null)) ? this.getConnections().getById(message.getConnectionId()) : this.getConnections().getByRemoteId(message.getRemoteConnectionId()));
                    if ((!fm.liveswitch.Global.equals(connection, null))) {
                        connection.processMessage(message);
                    }
                    else {
                        var offer = null;
                        var _var0 = new fm.liveswitch.Holder(offer);
                        var _var1 = this.__peerConnectionOffers.tryGetValue(message.getRemoteConnectionId(), _var0);
                        offer = _var0.getValue();
                        if (((!fm.liveswitch.Global.equals(message.getRemoteConnectionId(), null)) && _var1)) {
                            offer.processMessage(message);
                        }
                        else {
                            fm.liveswitch.Channel.fm_liveswitch_Channel___log.debug(fm.liveswitch.StringExtensions.concat("Discarding bitrateRequest message for unrecognized connection: ", message.toJson()));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processBitrateRequest = function (message) {
                if (arguments.length == 1) {
                    var connection = ((!fm.liveswitch.Global.equals(message.getConnectionId(), null)) ? this.getConnections().getById(message.getConnectionId()) : this.getConnections().getByRemoteId(message.getRemoteConnectionId()));
                    if ((!fm.liveswitch.Global.equals(connection, null))) {
                        connection.processMessage(message);
                    }
                    else {
                        var offer = null;
                        var _var0 = new fm.liveswitch.Holder(offer);
                        var _var1 = this.__peerConnectionOffers.tryGetValue(message.getRemoteConnectionId(), _var0);
                        offer = _var0.getValue();
                        if (((!fm.liveswitch.Global.equals(message.getRemoteConnectionId(), null)) && _var1)) {
                            offer.processMessage(message);
                        }
                        else {
                            fm.liveswitch.Channel.fm_liveswitch_Channel___log.debug(fm.liveswitch.StringExtensions.concat("Discarding bitrateRequest message for unrecognized connection: ", message.toJson()));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processCandidate = function (message) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(message.getConnectionId(), null))) {
                        this.processMessageForLocalConnection(message);
                    }
                    else {
                        if ((!fm.liveswitch.Global.equals(message.getRemoteConnectionId(), null))) {
                            this.processMessageForRemoteConnection(message);
                        }
                        else {
                            fm.liveswitch.Channel.fm_liveswitch_Channel___log.debug(fm.liveswitch.StringExtensions.format("Discarding unrecognized '{0}' message. ({1})", message.getType(), message.toJson()));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processClientUpdate = function (message) {
                if (arguments.length == 1) {
                    var config = fm.liveswitch.ClientConfig.fromJson(message.getPayload());
                    var remoteClientInfo = new fm.liveswitch.ClientInfo(message.getRemoteUserId(), null, message.getRemoteDeviceId(), null, message.getRemoteClientId(), null, null);
                    var equivalentRemoteClientInfo = this.getEquivalentRemoteClientInfo(remoteClientInfo);
                    if ((!fm.liveswitch.Global.equals(equivalentRemoteClientInfo, null))) {
                        var info3 = new fm.liveswitch.ClientInfo(equivalentRemoteClientInfo.getUserId(), equivalentRemoteClientInfo.getUserAlias(), equivalentRemoteClientInfo.getDeviceId(), equivalentRemoteClientInfo.getDeviceAlias(), equivalentRemoteClientInfo.getId(), equivalentRemoteClientInfo.getTag(), equivalentRemoteClientInfo.getRoles());
                        equivalentRemoteClientInfo.inflate(config.getUserAlias(), config.getDeviceAlias(), config.getTag(), config.getRoles());
                        var onRemoteClientUpdate = this._onRemoteClientUpdate;
                        if ((!fm.liveswitch.Global.equals(onRemoteClientUpdate, null))) {
                            onRemoteClientUpdate(info3, equivalentRemoteClientInfo);
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processClose = function (message) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(message.getConnectionId(), null))) {
                        this.processMessageForLocalConnection(message);
                    }
                    else {
                        if ((!fm.liveswitch.Global.equals(message.getRemoteConnectionId(), null))) {
                            this.processMessageForRemoteConnection(message);
                        }
                        else {
                            for (var _i = 0, _a = this.getConnections().getValues(); _i < _a.length; _i++) {
                                var connection = _a[_i];
                                var message2 = message.clone();
                                message2.setConnectionId(connection.getId());
                                connection.processMessage(message2);
                            }
                            this.__peerConnectionOffers.clear();
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processConnectionMessages = function (message) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getOffer()))) {
                        this.processOffer(message);
                        return true;
                    }
                    if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getAnswer()))) {
                        this.processAnswer(message);
                        return true;
                    }
                    if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getCandidate()))) {
                        this.processCandidate(message);
                        return true;
                    }
                    if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getKeyFrameRequest()))) {
                        this.processKeyFrameRequest(message);
                        return true;
                    }
                    if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getBitrateRequest()))) {
                        this.processBitrateRequest(message);
                        return true;
                    }
                    if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getBitrateNotification()))) {
                        this.processBitrateNotification(message);
                        return true;
                    }
                    if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getClose()))) {
                        this.processClose(message);
                        return true;
                    }
                    if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getFail()))) {
                        this.processFail(message);
                        return true;
                    }
                    if (((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getUpdate())) && (!fm.liveswitch.Global.equals(message.getConnectionId(), null)))) {
                        var byId = this.getConnections().getById(message.getConnectionId());
                        if ((!fm.liveswitch.Global.equals(byId, null))) {
                            byId.processMessage(message);
                        }
                        return true;
                    }
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processConnectionStateChange = function (connection) {
                if (arguments.length == 1) {
                    if (((fm.liveswitch.Global.equals(connection.getState(), fm.liveswitch.ConnectionState.Failed)) || (fm.liveswitch.Global.equals(connection.getState(), fm.liveswitch.ConnectionState.Closed)))) {
                        this.getConnections().remove(connection);
                        var dataStream = connection.getDataStream();
                        if ((!fm.liveswitch.Global.equals(dataStream, null))) {
                            dataStream.setGetRemoteConnectionInfo(null);
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processError = function (message) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(message.getConnectionId(), null))) {
                        this.processMessageForLocalConnection(message);
                    }
                    else {
                        if ((!fm.liveswitch.Global.equals(message.getRemoteConnectionId(), null))) {
                            this.processMessageForRemoteConnection(message);
                        }
                        else {
                            fm.liveswitch.Channel.fm_liveswitch_Channel___log.debug(fm.liveswitch.StringExtensions.format("Discarding unrecognized '{0}' message. ({1})", message.getType(), message.toJson()));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processFail = function (message) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(message.getConnectionId(), null))) {
                        this.processMessageForLocalConnection(message);
                    }
                    else {
                        if ((!fm.liveswitch.Global.equals(message.getRemoteConnectionId(), null))) {
                            this.processMessageForRemoteConnection(message);
                        }
                        else {
                            for (var _i = 0, _a = this.getConnections().getValues(); _i < _a.length; _i++) {
                                var connection = _a[_i];
                                var message2 = message.clone();
                                message2.setConnectionId(connection.getId());
                                connection.processMessage(message2);
                            }
                            this.__peerConnectionOffers.clear();
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processInviteFeedback = function (message) {
                if (arguments.length == 1) {
                    var feedback = fm.liveswitch.InviteFeedback.fromJson(message.getPayload());
                    var key = fm.liveswitch.Invitation.getInviteKey(this.getId(), feedback.getUserId(), feedback.getProtocol());
                    var invitation = null;
                    var _var0 = new fm.liveswitch.Holder(invitation);
                    var _var1 = this.__invitations.tryGetValue(key, _var0);
                    invitation = _var0.getValue();
                    if (_var1) {
                        if (!invitation.processFeedback(feedback)) {
                            var _var2 = new fm.liveswitch.Holder(invitation);
                            var _var3 = this.__invitations.tryRemove(key, _var2);
                            invitation = _var2.getValue();
                            return false;
                        }
                        return true;
                    }
                    fm.liveswitch.Channel.fm_liveswitch_Channel___log.error("Received InviteFeedback for unknown invite.");
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processKeyFrameRequest = function (message) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(message.getConnectionId(), null))) {
                        this.processMessageForLocalConnection(message);
                    }
                    else {
                        if ((!fm.liveswitch.Global.equals(message.getRemoteConnectionId(), null))) {
                            this.processMessageForRemoteConnection(message);
                        }
                        else {
                            fm.liveswitch.Channel.fm_liveswitch_Channel___log.debug(fm.liveswitch.StringExtensions.format("Discarding unrecognized '{0}' message. ({1})", message.getType(), message.toJson()));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processMessageAsync = function (message) {
                if (arguments.length == 1) {
                    if (!this.processConnectionMessages(message)) {
                        this.__channelQueue.enqueue(message);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processMessageForLocalConnection = function (message) {
                if (arguments.length == 1) {
                    var connectionId = message.getConnectionId();
                    var byId = this.getConnections().getById(connectionId);
                    if ((!fm.liveswitch.Global.equals(byId, null))) {
                        byId.processMessage(message);
                        return true;
                    }
                    fm.liveswitch.Channel.fm_liveswitch_Channel___log.debug(fm.liveswitch.StringExtensions.format("Discarding '{0}' message for unrecognized local connection '{1}'. ({2})", message.getType(), connectionId, message.toJson()));
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processMessageForRemoteConnection = function (message) {
                if (arguments.length == 1) {
                    var remoteConnectionId = message.getRemoteConnectionId();
                    var byRemoteId = this.getConnections().getByRemoteId(remoteConnectionId);
                    if ((!fm.liveswitch.Global.equals(byRemoteId, null))) {
                        byRemoteId.processMessage(message);
                        return true;
                    }
                    var offer = null;
                    var _var0 = new fm.liveswitch.Holder(offer);
                    var _var1 = this.__peerConnectionOffers.tryGetValue(remoteConnectionId, _var0);
                    offer = _var0.getValue();
                    if (_var1) {
                        offer.processMessage(message);
                        return true;
                    }
                    fm.liveswitch.Channel.fm_liveswitch_Channel___log.debug(fm.liveswitch.StringExtensions.format("Discarding '{0}' message for unrecognized remote connection '{1}'. ({2})", message.getType(), remoteConnectionId, message.toJson()));
                    return false;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processMessageSync = function (message) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getNotifyJoin()))) {
                        this.processNotifyJoin(fm.liveswitch.ClientInfo.fromJsonArray(message.getPayload()));
                    }
                    else {
                        if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getNotifyLeave()))) {
                            this.processNotifyLeave(fm.liveswitch.ClientInfo.fromJsonArray(message.getPayload()), new fm.liveswitch.ClientInfo(message.getRemoteUserId(), message.getRemoteDeviceId(), message.getRemoteClientId()));
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getNotifyUpstreamOpen()))) {
                                this.processNotifyUpstreamOpen(fm.liveswitch.ConnectionInfo.fromJsonArray(message.getPayload()));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getNotifyUpstreamClose()))) {
                                    this.processNotifyUpstreamClose(fm.liveswitch.ConnectionInfo.fromJsonArray(message.getPayload()));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getError()))) {
                                        this.processError(message);
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getNotifyUpstreamUpdate()))) {
                                            this.processNotifyUpstreamUpdate(fm.liveswitch.ConnectionInfo.fromJson(message.getPayload()));
                                        }
                                        else {
                                            if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getReject()))) {
                                                this.processReject(message);
                                            }
                                            else {
                                                if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getMcuVideoLayout()))) {
                                                    this.processVideoLayout(fm.liveswitch.VideoLayout.fromJson(message.getPayload()));
                                                }
                                                else {
                                                    if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getMessage()))) {
                                                        this.processMessageType(message);
                                                    }
                                                    else {
                                                        if (((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getUpdate())) && (fm.liveswitch.Global.equals(message.getRemoteClientId(), null)))) {
                                                            var claim = fm.liveswitch.ChannelClaim.fromJson(message.getPayload());
                                                            if ((fm.liveswitch.Global.equals(this.getClaim(), null))) {
                                                                this.setClaim(claim);
                                                            }
                                                            else {
                                                                var claim2 = this.getClaim();
                                                                this.setClaim(claim);
                                                                var onClaimUpdate = this._onClaimUpdate;
                                                                if ((!fm.liveswitch.Global.equals(onClaimUpdate, null))) {
                                                                    onClaimUpdate(claim2, claim);
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            if (((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getUpdate())) && (fm.liveswitch.Global.equals(message.getConnectionId(), null)))) {
                                                                this.processClientUpdate(message);
                                                            }
                                                            else {
                                                                if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getInviteFeedback()))) {
                                                                    this.processInviteFeedback(message);
                                                                }
                                                                else {
                                                                    fm.liveswitch.Channel.fm_liveswitch_Channel___log.error(fm.liveswitch.StringExtensions.concat("Unexpected message: ", message.toJson()));
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processMessageType = function (message) {
                if (arguments.length == 1) {
                    var info = new fm.liveswitch.ClientInfo(message.getRemoteUserId(), message.getUserAlias(), message.getRemoteDeviceId(), message.getDeviceAlias(), message.getRemoteClientId(), message.getClientTag(), message.getClientRoles());
                    if ((!fm.liveswitch.Global.equals(info, null))) {
                        var onClientMessage = void 0;
                        var input = fm.liveswitch.JsonSerializer.deserializeString(message.getPayload());
                        this.__messagesReceived.increment();
                        this.__messageBytesReceived.add(fm.liveswitch.Utf8.encode(input).length);
                        if ((!fm.liveswitch.Global.equals(message.getClientId(), null))) {
                            onClientMessage = this._onClientMessage;
                            if ((!fm.liveswitch.Global.equals(onClientMessage, null))) {
                                onClientMessage(info, input);
                            }
                        }
                        else {
                            if ((!fm.liveswitch.Global.equals(message.getDeviceId(), null))) {
                                onClientMessage = this._onDeviceMessage;
                                if ((!fm.liveswitch.Global.equals(onClientMessage, null))) {
                                    onClientMessage(info, input);
                                }
                            }
                            else {
                                if ((!fm.liveswitch.Global.equals(message.getUserId(), null))) {
                                    onClientMessage = this._onUserMessage;
                                    if ((!fm.liveswitch.Global.equals(onClientMessage, null))) {
                                        onClientMessage(info, input);
                                    }
                                }
                                else {
                                    onClientMessage = this._onMessage;
                                    if ((!fm.liveswitch.Global.equals(onClientMessage, null))) {
                                        onClientMessage(info, input);
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processNotifyJoin = function (remoteClientInfos) {
                if (arguments.length == 1) {
                    for (var _i = 0, remoteClientInfos_1 = remoteClientInfos; _i < remoteClientInfos_1.length; _i++) {
                        var info = remoteClientInfos_1[_i];
                        if (!info.isEquivalent(this.getUserId(), this.getDeviceId(), this.getClientId())) {
                            var flag = false;
                            for (var _a = 0, _b = this.__remoteClientInfos; _a < _b.length; _a++) {
                                var info2 = _b[_a];
                                if (info2.isEquivalent(info)) {
                                    flag = true;
                                }
                            }
                            if (!flag) {
                                fm.liveswitch.ArrayExtensions.add(this.__remoteClientInfos, info);
                            }
                            if (!flag) {
                                var onRemoteClientJoin = this._onRemoteClientJoin;
                                if ((!fm.liveswitch.Global.equals(onRemoteClientJoin, null))) {
                                    onRemoteClientJoin(info);
                                }
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processNotifyLeave = function (deflatedRemoteClientInfos, deflatedSourceClientInfo) {
                if (arguments.length == 2) {
                    for (var _i = 0, deflatedRemoteClientInfos_1 = deflatedRemoteClientInfos; _i < deflatedRemoteClientInfos_1.length; _i++) {
                        var info = deflatedRemoteClientInfos_1[_i];
                        if ((info.isEquivalent(this.getUserId(), this.getDeviceId(), this.getClientId()) && deflatedSourceClientInfo.isEquivalent(this.getUserId(), this.getDeviceId(), this.getClientId()))) {
                            fm.liveswitch.Channel.fm_liveswitch_Channel___log.debug(fm.liveswitch.StringExtensions.format("This client {0} has been kicked from channel {1}.", this.getClientId(), this.getId()));
                            var onKick = this._onKick;
                            if ((!fm.liveswitch.Global.equals(onKick, null))) {
                                onKick();
                            }
                        }
                        else {
                            var equivalentRemoteClientInfo = this.getEquivalentRemoteClientInfo(info);
                            if ((!fm.liveswitch.Global.equals(equivalentRemoteClientInfo, null))) {
                                fm.liveswitch.ArrayExtensions.remove(this.__remoteClientInfos, equivalentRemoteClientInfo);
                                for (var _a = 0, _b = this.getConnections().getValues(); _a < _b.length; _a++) {
                                    var connection = _b[_a];
                                    if ((connection instanceof fm.liveswitch.PeerConnection)) {
                                        var connection2 = connection;
                                        if (equivalentRemoteClientInfo.isEquivalent(connection2.getRemoteClientInfo())) {
                                            connection2.processMessage(fm.liveswitch.Message.createCloseMessage());
                                        }
                                    }
                                    else {
                                        if ((connection instanceof fm.liveswitch.SfuDownstreamConnection)) {
                                            var connection3 = connection;
                                            var remoteConnectionInfo = connection3.getRemoteConnectionInfo();
                                            if (((!fm.liveswitch.Global.equals(remoteConnectionInfo, null)) && equivalentRemoteClientInfo.isEquivalent(remoteConnectionInfo.createClientInfo()))) {
                                                connection3.processMessage(fm.liveswitch.Message.createCloseMessage());
                                            }
                                        }
                                    }
                                }
                                var onRemoteClientLeave = this._onRemoteClientLeave;
                                if ((!fm.liveswitch.Global.equals(onRemoteClientLeave, null))) {
                                    onRemoteClientLeave(equivalentRemoteClientInfo);
                                }
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processNotifyUpstreamClose = function (deflatedRemoteConnectionInfos) {
                if (arguments.length == 1) {
                    for (var _i = 0, deflatedRemoteConnectionInfos_1 = deflatedRemoteConnectionInfos; _i < deflatedRemoteConnectionInfos_1.length; _i++) {
                        var info = deflatedRemoteConnectionInfos_1[_i];
                        var equivalentRemoteUpstreamConnectionInfo = this.getEquivalentRemoteUpstreamConnectionInfo(info);
                        if ((!fm.liveswitch.Global.equals(equivalentRemoteUpstreamConnectionInfo, null))) {
                            fm.liveswitch.ArrayExtensions.remove(this.__remoteUpstreamConnectionInfos, equivalentRemoteUpstreamConnectionInfo);
                            var byId = this.getConnections().getById(equivalentRemoteUpstreamConnectionInfo.getId());
                            if ((!fm.liveswitch.Global.equals(byId, null))) {
                                byId.processMessage(fm.liveswitch.Message.createCloseMessage());
                            }
                            var onRemoteUpstreamConnectionClose = this._onRemoteUpstreamConnectionClose;
                            if ((!fm.liveswitch.Global.equals(onRemoteUpstreamConnectionClose, null))) {
                                onRemoteUpstreamConnectionClose(equivalentRemoteUpstreamConnectionInfo);
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processNotifyUpstreamOpen = function (remoteConnectionInfos) {
                if (arguments.length == 1) {
                    var obj2 = void 0;
                    for (var _i = 0, remoteConnectionInfos_1 = remoteConnectionInfos; _i < remoteConnectionInfos_1.length; _i++) {
                        var info = remoteConnectionInfos_1[_i];
                        if (!info.createClientInfo().isEquivalent(this.getUserId(), this.getDeviceId(), this.getClientId())) {
                            var flag = false;
                            if ((fm.liveswitch.Global.equals(this.getEquivalentRemoteUpstreamConnectionInfo(info), null))) {
                                fm.liveswitch.ArrayExtensions.add(this.__remoteUpstreamConnectionInfos, info);
                                flag = true;
                            }
                            if (flag) {
                                var onRemoteUpstreamConnectionOpen = this._onRemoteUpstreamConnectionOpen;
                                if ((!fm.liveswitch.Global.equals(onRemoteUpstreamConnectionOpen, null))) {
                                    onRemoteUpstreamConnectionOpen(info);
                                }
                            }
                        }
                    }
                    if (((!fm.liveswitch.Global.equals(this.__deferredLayout, null)) && this.processVideoLayout(this.__deferredLayout))) {
                        this.__deferredLayout = null;
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processNotifyUpstreamUpdate = function (deflatedUpdatedRemoteConnectionInfo) {
                var _this = this;
                if (arguments.length == 1) {
                    var rejectAction = null;
                    var equivalentRemoteUpstreamConnectionInfo = this.getEquivalentRemoteUpstreamConnectionInfo(deflatedUpdatedRemoteConnectionInfo);
                    if ((!fm.liveswitch.Global.equals(equivalentRemoteUpstreamConnectionInfo, null))) {
                        deflatedUpdatedRemoteConnectionInfo.inflate(equivalentRemoteUpstreamConnectionInfo.getUserAlias(), equivalentRemoteUpstreamConnectionInfo.getDeviceAlias(), equivalentRemoteUpstreamConnectionInfo.getClientTag(), equivalentRemoteUpstreamConnectionInfo.getClientRoles());
                        for (var _i = 0, _a = this.getConnections().getValues(); _i < _a.length; _i++) {
                            var connection = _a[_i];
                            if ((fm.liveswitch.Global.equals(connection.getType(), fm.liveswitch.ConnectionType.getSfu()))) {
                                var connection2 = fm.liveswitch.Global.tryCast(connection, fm.liveswitch.SfuDownstreamConnection);
                                if ((!fm.liveswitch.Global.equals(connection2, null))) {
                                    var remoteMediaId = connection2.getRemoteMediaId();
                                    var remoteConnectionInfo = connection2.getRemoteConnectionInfo();
                                    if ((((!fm.liveswitch.Global.equals(remoteConnectionInfo, null)) && remoteConnectionInfo.isEquivalent(equivalentRemoteUpstreamConnectionInfo)) || ((!fm.liveswitch.Global.equals(remoteMediaId, null)) && (fm.liveswitch.Global.equals(remoteMediaId, equivalentRemoteUpstreamConnectionInfo.getMediaId()))))) {
                                        if ((fm.liveswitch.Global.equals(rejectAction, null))) {
                                            rejectAction = function (ex) {
                                                fm.liveswitch.Channel.fm_liveswitch_Channel___log.error(fm.liveswitch.StringExtensions.format("Could not update SFU downstream connection {0}.", _this.getId()), ex);
                                            };
                                        }
                                        connection2.updateConnection(equivalentRemoteUpstreamConnectionInfo, deflatedUpdatedRemoteConnectionInfo).fail(rejectAction);
                                        break;
                                    }
                                }
                            }
                        }
                        var onRemoteUpstreamConnectionUpdate = this._onRemoteUpstreamConnectionUpdate;
                        if ((!fm.liveswitch.Global.equals(onRemoteUpstreamConnectionUpdate, null))) {
                            onRemoteUpstreamConnectionUpdate(equivalentRemoteUpstreamConnectionInfo, deflatedUpdatedRemoteConnectionInfo);
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processOffer = function (message) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(message.getConnectionId(), null))) {
                        var byId = this.getConnections().getById(message.getConnectionId());
                        if ((!fm.liveswitch.Global.equals(byId, null))) {
                            byId.processMessage(message);
                        }
                    }
                    else {
                        if ((!fm.liveswitch.Global.equals(message.getRemoteConnectionId(), null))) {
                            var remoteClientInfo = new fm.liveswitch.ClientInfo(message.getRemoteUserId(), null, message.getRemoteDeviceId(), null, message.getRemoteClientId(), null, null);
                            var equivalentRemoteClientInfo = this.getEquivalentRemoteClientInfo(remoteClientInfo);
                            if ((!fm.liveswitch.Global.equals(equivalentRemoteClientInfo, null))) {
                                var addValue = new fm.liveswitch.PeerConnectionOffer(this, equivalentRemoteClientInfo, message.getRemoteConnectionId(), message.getConnectionTag(), fm.liveswitch.SessionDescription.fromJson(message.getPayload()));
                                this.__peerConnectionOffers.addOrUpdate(message.getRemoteConnectionId(), addValue);
                                var onPeerConnectionOffer = this._onPeerConnectionOffer;
                                if ((!fm.liveswitch.Global.equals(onPeerConnectionOffer, null))) {
                                    onPeerConnectionOffer(addValue);
                                }
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processReject = function (message) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(message.getConnectionId(), null))) {
                        this.processMessageForLocalConnection(message);
                    }
                    else {
                        if ((!fm.liveswitch.Global.equals(message.getRemoteConnectionId(), null))) {
                            this.processMessageForRemoteConnection(message);
                        }
                        else {
                            fm.liveswitch.Channel.fm_liveswitch_Channel___log.debug(fm.liveswitch.StringExtensions.format("Discarding unrecognized '{0}' message. ({1})", message.getType(), message.toJson()));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.processVideoLayout = function (videoLayout) {
                if (arguments.length == 1) {
                    var flag = false;
                    if ((!fm.liveswitch.Global.equals(videoLayout, null))) {
                        flag = videoLayout.inflate(this, new fm.liveswitch.ClientInfo(this.getUserId(), this.getUserAlias(), this.getDeviceId(), this.getDeviceAlias(), this.getClientId(), this.getClientTag(), this.getClientRoles()), this.getRemoteUpstreamConnectionInfos());
                        if (!flag) {
                            fm.liveswitch.Channel.fm_liveswitch_Channel___log.debug("Unable to inflate video layout due to delayed upstream notifications. Deferring until arrived.");
                            this.__deferredLayout = videoLayout;
                        }
                    }
                    if (flag) {
                        var onMcuVideoLayout = this._onMcuVideoLayout;
                        if ((!fm.liveswitch.Global.equals(onMcuVideoLayout, null))) {
                            onMcuVideoLayout(videoLayout);
                        }
                    }
                    return flag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Rejects a peer connection offer.
            @param peerConnectionOffer The peer connection offer.
            */
            Channel.prototype.rejectPeerConnection = function (peerConnectionOffer) {
                if (arguments.length == 1) {
                    var userId = peerConnectionOffer.getRemoteClientInfo().getUserId();
                    var deviceId = peerConnectionOffer.getRemoteClientInfo().getDeviceId();
                    var idValue = peerConnectionOffer.getRemoteClientInfo().getId();
                    var remoteConnectionId = peerConnectionOffer.getRemoteConnectionId();
                    return this.simpleSend(fm.liveswitch.Message.createPeerRejectMessage(userId, deviceId, idValue, remoteConnectionId));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the client's channel claim has been updated. Parameters: - oldConnectionInfo - the old channel claim - newConnectionInfo - the new channel claim
            */
            Channel.prototype.removeOnClaimUpdate = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onClaimUpdate, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when a client message is received from the server. Parameters: - clientInfo - the sending client information - message - the message
            */
            Channel.prototype.removeOnClientMessage = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onClientMessage, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when a device message is received from the server. Parameters: - clientInfo - the sending client information - message - the message
            */
            Channel.prototype.removeOnDeviceMessage = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onDeviceMessage, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the client is kicked from the channel.
            */
            Channel.prototype.removeOnKick = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onKick, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when a new MCU video layout is received from the server. Parameters: - videoLayout - the new MCU video layout
            */
            Channel.prototype.removeOnMcuVideoLayout = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onMcuVideoLayout, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when a channel message is received from the server. Parameters: - clientInfo - the sending client information - message - the message
            */
            Channel.prototype.removeOnMessage = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onMessage, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when a remote client wants to open a peer connection. Parameters: - peerConnectionOffer - the peer connection offer
            */
            Channel.prototype.removeOnPeerConnectionOffer = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onPeerConnectionOffer, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when a remote client joins this channel. Parameters: - clientInfo - the remote client information
            */
            Channel.prototype.removeOnRemoteClientJoin = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onRemoteClientJoin, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when a remote client leaves this channel. Parameters: - clientInfo - the remote client information
            */
            Channel.prototype.removeOnRemoteClientLeave = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onRemoteClientLeave, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when a remote client updates their config. Parameters: - oldClientInfo - the old remote client information - newClientInfo - the new remote client information
            */
            Channel.prototype.removeOnRemoteClientUpdate = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onRemoteClientUpdate, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when a remote upstream (SFU or MCU) connection is closed by a remote client. Parameters: - connectionInfo - the remote connection information
            */
            Channel.prototype.removeOnRemoteUpstreamConnectionClose = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onRemoteUpstreamConnectionClose, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when a remote upstream (SFU or MCU) connection is opened by a remote client. Parameters: - connectionInfo - the remote connection information
            */
            Channel.prototype.removeOnRemoteUpstreamConnectionOpen = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onRemoteUpstreamConnectionOpen, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when a remote upstream (SFU or MCU) connection is updated by a remote client. Parameters: - oldConnectionInfo - the old remote connection information - newConnectionInfo - the new remote connection information
            */
            Channel.prototype.removeOnRemoteUpstreamConnectionUpdate = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onRemoteUpstreamConnectionUpdate, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when a user message is received from the server. Parameters: - clientInfo - the sending client information - message - the message
            */
            Channel.prototype.removeOnUserMessage = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onUserMessage, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.send = function (message) {
                if (arguments.length == 1) {
                    message.setChannelId(this.getId());
                    if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getMessage()))) {
                        var input = fm.liveswitch.JsonSerializer.deserializeString(message.getPayload());
                        this.__messagesSent.increment();
                        this.__messageBytesSent.add(fm.liveswitch.Utf8.encode(input).length);
                    }
                    return this.__doSend(message);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sends a message to a client in the channel.
            @param message The message to be sent.
            @param userId The user identifier.
            @param deviceId The device identifier.
            @param clientId The client identifier.
            */
            Channel.prototype.sendClientMessage = function (userId, deviceId, clientId, message) {
                if (arguments.length == 4) {
                    return this.simpleSend(fm.liveswitch.Message.createMessageMessage(message, userId, deviceId, clientId));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sends a message to a device in the channel.
            @param message The message to be sent.
            @param userId The user identifier.
            @param deviceId The device identifier.
            */
            Channel.prototype.sendDeviceMessage = function (userId, deviceId, message) {
                if (arguments.length == 3) {
                    return this.simpleSend(fm.liveswitch.Message.createMessageMessage(message, userId, deviceId));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sends a message to the channel.
            @param message The message to be sent.
            */
            Channel.prototype.sendMessage = function (message) {
                if (arguments.length == 1) {
                    return this.simpleSend(fm.liveswitch.Message.createMessageMessage(message));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sends a message to a user in the channel.
            @param userId The user identifier.
            @param message The message.
            */
            Channel.prototype.sendUserMessage = function (userId, message) {
                if (arguments.length == 2) {
                    return this.simpleSend(fm.liveswitch.Message.createMessageMessage(message, userId));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.setApplicationId = function (value) {
                if (arguments.length == 1) {
                    this._applicationId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.setClaim = function (value) {
                if (arguments.length == 1) {
                    this._claim = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.setClientId = function (value) {
                if (arguments.length == 1) {
                    this._clientId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.setClientRoles = function (value) {
                if (arguments.length == 1) {
                    this._clientRoles = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.setClientTag = function (value) {
                if (arguments.length == 1) {
                    this._clientTag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.setConnections = function (value) {
                if (arguments.length == 1) {
                    this._connections = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.setDeviceAlias = function (value) {
                if (arguments.length == 1) {
                    this._deviceAlias = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.setDeviceId = function (value) {
                if (arguments.length == 1) {
                    this._deviceId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.setId = function (value) {
                if (arguments.length == 1) {
                    this._id = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.setUserAlias = function (value) {
                if (arguments.length == 1) {
                    this._userAlias = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.setUserId = function (value) {
                if (arguments.length == 1) {
                    this._userId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.simpleSend = function (message) {
                if (arguments.length == 1) {
                    var promise = new fm.liveswitch.Promise();
                    this.doSimpleSend(promise, message);
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Updates the configuration for this channel.
            @param newConfig The new recording configuration
            */
            Channel.prototype.update = function (newConfig) {
                if (arguments.length == 1) {
                    var promise = new fm.liveswitch.Promise();
                    this.doUpdate(promise, newConfig);
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.prototype.updateClientConfig = function (clientConfig) {
                if (arguments.length == 1) {
                    this.setUserAlias(clientConfig.getUserAlias());
                    this.setDeviceAlias(clientConfig.getDeviceAlias());
                    this.setClientTag(clientConfig.getTag());
                    this.setClientRoles(clientConfig.getRoles());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Channel.fmliveswitchChannelInitialize = function () {
                if (!fm.liveswitch.Channel.__fmliveswitchChannelInitialized && !fm.liveswitch.Channel.__fmliveswitchChannelInitializing) {
                    fm.liveswitch.Channel.__fmliveswitchChannelInitializing = true;
                    fm.liveswitch.Channel.fm_liveswitch_Channel___log = fm.liveswitch.Log.getLogger(new fm.liveswitch.Type('[fm.liveswitch.Channel]'));
                    fm.liveswitch.Channel.__fmliveswitchChannelInitialized = true;
                    fm.liveswitch.Channel.__fmliveswitchChannelInitializing = false;
                }
            };
            /** @hidden */
            Channel.__fmliveswitchChannelInitialized = false;
            /** @hidden */
            Channel.__fmliveswitchChannelInitializing = false;
            return Channel;
        }(fm.liveswitch.Dynamic));
        liveswitch.Channel = Channel;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A LiveSwitch client.
        */
        var Client = /** @class */ (function (_super) {
            __extends(Client, _super);
            function Client() {
                var _this = this;
                fm.liveswitch.Client.fmliveswitchClientInitialize();
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 2) {
                    var gatewayUrl = __arguments[0];
                    var applicationId = __arguments[1];
                    // chained constructor: Client.call(this, gatewayUrl, applicationId, null);
                    __arguments = new Array(3);
                    __arguments[0] = gatewayUrl;
                    __arguments[1] = applicationId;
                    __arguments[2] = null;
                    {
                        var gatewayUrl_1 = __arguments[0];
                        var applicationId_2 = __arguments[1];
                        var userId = __arguments[2];
                        // chained constructor: Client.call(this, gatewayUrl, applicationId, userId, null);
                        __arguments = new Array(4);
                        __arguments[0] = gatewayUrl_1;
                        __arguments[1] = applicationId_2;
                        __arguments[2] = userId;
                        __arguments[3] = null;
                        {
                            var gatewayUrl_2 = __arguments[0];
                            var applicationId_3 = __arguments[1];
                            var userId_2 = __arguments[2];
                            var deviceId = __arguments[3];
                            // chained constructor: Client.call(this, gatewayUrl, applicationId, userId, deviceId, null, null);
                            __arguments = new Array(6);
                            __arguments[0] = gatewayUrl_2;
                            __arguments[1] = applicationId_3;
                            __arguments[2] = userId_2;
                            __arguments[3] = deviceId;
                            __arguments[4] = null;
                            __arguments[5] = null;
                            {
                                var gatewayUrl_3 = __arguments[0];
                                var applicationId_4 = __arguments[1];
                                var userId_3 = __arguments[2];
                                var deviceId_2 = __arguments[3];
                                var clientId = __arguments[4];
                                var roles = __arguments[5];
                                // chained constructor: Client.call(this, gatewayUrl, applicationId, userId, deviceId, clientId, roles, null);
                                __arguments = new Array(7);
                                __arguments[0] = gatewayUrl_3;
                                __arguments[1] = applicationId_4;
                                __arguments[2] = userId_3;
                                __arguments[3] = deviceId_2;
                                __arguments[4] = clientId;
                                __arguments[5] = roles;
                                __arguments[6] = null;
                                {
                                    var gatewayUrl_4 = __arguments[0];
                                    var applicationId_5 = __arguments[1];
                                    var userId_4 = __arguments[2];
                                    var deviceId_3 = __arguments[3];
                                    var clientId_2 = __arguments[4];
                                    var roles_1 = __arguments[5];
                                    var region = __arguments[6];
                                    _this = _super.call(this) || this;
                                    _this.fmliveswitchClientInit();
                                    _this.__lock = new Object();
                                    _this.__registered = false;
                                    _this.__registering = false;
                                    _this.__unregistering = false;
                                    _this.__joining = new Array();
                                    _this.__leaving = new Array();
                                    _this.__earlyChannelMessages = new fm.liveswitch.ManagedConcurrentDictionary();
                                    if (fm.liveswitch.StringExtensions.isNullOrEmpty(gatewayUrl_4)) {
                                        throw new fm.liveswitch.Exception("Gateway URL cannot be null or empty.");
                                    }
                                    if (fm.liveswitch.StringExtensions.isNullOrEmpty(applicationId_5)) {
                                        throw new fm.liveswitch.Exception("Application ID cannot be null or empty.");
                                    }
                                    _this.setGatewayUrl(gatewayUrl_4);
                                    _this.setApplicationId(applicationId_5);
                                    if ((!fm.liveswitch.Global.equals(clientId_2, null))) {
                                        _this.setExternalId(clientId_2);
                                        clientId_2 = null;
                                        fm.liveswitch.Client.fm_liveswitch_Client___log.warn(fm.liveswitch.StringExtensions.format("Client IDs are automatically generated. The provided client ID '{0}' will be moved to the ExternalId property and replaced with a generated ID.", _this.getExternalId()));
                                    }
                                    _this.setUserId(fm.liveswitch.StringExtensions.nullCoalesce(userId_4, fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "")));
                                    _this.setDeviceId(fm.liveswitch.StringExtensions.nullCoalesce(deviceId_3, fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "")));
                                    _this.setId(fm.liveswitch.StringExtensions.nullCoalesce(clientId_2, fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "")));
                                    _this.__roles = roles_1;
                                    _this.__region = region;
                                    _this.__channels = new fm.liveswitch.ManagedConcurrentDictionary();
                                    var client = new fm.liveswitch.signalling.Client(_this.getGatewayUrl(), _this.__lock);
                                    client.setDisableBinary(true);
                                    client.setRequestMaxRetries(3);
                                    _this.__gatewayClient = client;
                                    _this.__sendQueue = new fm.liveswitch.SendQueue(new fm.liveswitch.SignallingSendQueueTransport(_this.__gatewayClient));
                                    _this.__gatewayClient.addOnServerSubscribe(_this._gatewayClient_OnServerSubscribe.bind(_this));
                                    _this.__gatewayClient.addOnStateChange(_this._gatewayClient_OnStateChange.bind(_this));
                                    _this.__gatewayClient.addOnHttpRequestCreated(_this._gatewayClient_OnHttpRequestCreated.bind(_this));
                                    _this.__gatewayClient.addOnHttpResponseReceived(_this._gatewayClient_OnHttpResponseReceived.bind(_this));
                                }
                            }
                        }
                    }
                }
                else if (__arguments.length == 3) {
                    var gatewayUrl = __arguments[0];
                    var applicationId = __arguments[1];
                    var userId = __arguments[2];
                    // chained constructor: Client.call(this, gatewayUrl, applicationId, userId, null);
                    __arguments = new Array(4);
                    __arguments[0] = gatewayUrl;
                    __arguments[1] = applicationId;
                    __arguments[2] = userId;
                    __arguments[3] = null;
                    {
                        var gatewayUrl_5 = __arguments[0];
                        var applicationId_6 = __arguments[1];
                        var userId_5 = __arguments[2];
                        var deviceId = __arguments[3];
                        // chained constructor: Client.call(this, gatewayUrl, applicationId, userId, deviceId, null, null);
                        __arguments = new Array(6);
                        __arguments[0] = gatewayUrl_5;
                        __arguments[1] = applicationId_6;
                        __arguments[2] = userId_5;
                        __arguments[3] = deviceId;
                        __arguments[4] = null;
                        __arguments[5] = null;
                        {
                            var gatewayUrl_6 = __arguments[0];
                            var applicationId_7 = __arguments[1];
                            var userId_6 = __arguments[2];
                            var deviceId_4 = __arguments[3];
                            var clientId = __arguments[4];
                            var roles = __arguments[5];
                            // chained constructor: Client.call(this, gatewayUrl, applicationId, userId, deviceId, clientId, roles, null);
                            __arguments = new Array(7);
                            __arguments[0] = gatewayUrl_6;
                            __arguments[1] = applicationId_7;
                            __arguments[2] = userId_6;
                            __arguments[3] = deviceId_4;
                            __arguments[4] = clientId;
                            __arguments[5] = roles;
                            __arguments[6] = null;
                            {
                                var gatewayUrl_7 = __arguments[0];
                                var applicationId_8 = __arguments[1];
                                var userId_7 = __arguments[2];
                                var deviceId_5 = __arguments[3];
                                var clientId_3 = __arguments[4];
                                var roles_2 = __arguments[5];
                                var region = __arguments[6];
                                _this = _super.call(this) || this;
                                _this.fmliveswitchClientInit();
                                _this.__lock = new Object();
                                _this.__registered = false;
                                _this.__registering = false;
                                _this.__unregistering = false;
                                _this.__joining = new Array();
                                _this.__leaving = new Array();
                                _this.__earlyChannelMessages = new fm.liveswitch.ManagedConcurrentDictionary();
                                if (fm.liveswitch.StringExtensions.isNullOrEmpty(gatewayUrl_7)) {
                                    throw new fm.liveswitch.Exception("Gateway URL cannot be null or empty.");
                                }
                                if (fm.liveswitch.StringExtensions.isNullOrEmpty(applicationId_8)) {
                                    throw new fm.liveswitch.Exception("Application ID cannot be null or empty.");
                                }
                                _this.setGatewayUrl(gatewayUrl_7);
                                _this.setApplicationId(applicationId_8);
                                if ((!fm.liveswitch.Global.equals(clientId_3, null))) {
                                    _this.setExternalId(clientId_3);
                                    clientId_3 = null;
                                    fm.liveswitch.Client.fm_liveswitch_Client___log.warn(fm.liveswitch.StringExtensions.format("Client IDs are automatically generated. The provided client ID '{0}' will be moved to the ExternalId property and replaced with a generated ID.", _this.getExternalId()));
                                }
                                _this.setUserId(fm.liveswitch.StringExtensions.nullCoalesce(userId_7, fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "")));
                                _this.setDeviceId(fm.liveswitch.StringExtensions.nullCoalesce(deviceId_5, fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "")));
                                _this.setId(fm.liveswitch.StringExtensions.nullCoalesce(clientId_3, fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "")));
                                _this.__roles = roles_2;
                                _this.__region = region;
                                _this.__channels = new fm.liveswitch.ManagedConcurrentDictionary();
                                var client = new fm.liveswitch.signalling.Client(_this.getGatewayUrl(), _this.__lock);
                                client.setDisableBinary(true);
                                client.setRequestMaxRetries(3);
                                _this.__gatewayClient = client;
                                _this.__sendQueue = new fm.liveswitch.SendQueue(new fm.liveswitch.SignallingSendQueueTransport(_this.__gatewayClient));
                                _this.__gatewayClient.addOnServerSubscribe(_this._gatewayClient_OnServerSubscribe.bind(_this));
                                _this.__gatewayClient.addOnStateChange(_this._gatewayClient_OnStateChange.bind(_this));
                                _this.__gatewayClient.addOnHttpRequestCreated(_this._gatewayClient_OnHttpRequestCreated.bind(_this));
                                _this.__gatewayClient.addOnHttpResponseReceived(_this._gatewayClient_OnHttpResponseReceived.bind(_this));
                            }
                        }
                    }
                }
                else if (__arguments.length == 4) {
                    var gatewayUrl = __arguments[0];
                    var applicationId = __arguments[1];
                    var userId = __arguments[2];
                    var deviceId = __arguments[3];
                    // chained constructor: Client.call(this, gatewayUrl, applicationId, userId, deviceId, null, null);
                    __arguments = new Array(6);
                    __arguments[0] = gatewayUrl;
                    __arguments[1] = applicationId;
                    __arguments[2] = userId;
                    __arguments[3] = deviceId;
                    __arguments[4] = null;
                    __arguments[5] = null;
                    {
                        var gatewayUrl_8 = __arguments[0];
                        var applicationId_9 = __arguments[1];
                        var userId_8 = __arguments[2];
                        var deviceId_6 = __arguments[3];
                        var clientId = __arguments[4];
                        var roles = __arguments[5];
                        // chained constructor: Client.call(this, gatewayUrl, applicationId, userId, deviceId, clientId, roles, null);
                        __arguments = new Array(7);
                        __arguments[0] = gatewayUrl_8;
                        __arguments[1] = applicationId_9;
                        __arguments[2] = userId_8;
                        __arguments[3] = deviceId_6;
                        __arguments[4] = clientId;
                        __arguments[5] = roles;
                        __arguments[6] = null;
                        {
                            var gatewayUrl_9 = __arguments[0];
                            var applicationId_10 = __arguments[1];
                            var userId_9 = __arguments[2];
                            var deviceId_7 = __arguments[3];
                            var clientId_4 = __arguments[4];
                            var roles_3 = __arguments[5];
                            var region = __arguments[6];
                            _this = _super.call(this) || this;
                            _this.fmliveswitchClientInit();
                            _this.__lock = new Object();
                            _this.__registered = false;
                            _this.__registering = false;
                            _this.__unregistering = false;
                            _this.__joining = new Array();
                            _this.__leaving = new Array();
                            _this.__earlyChannelMessages = new fm.liveswitch.ManagedConcurrentDictionary();
                            if (fm.liveswitch.StringExtensions.isNullOrEmpty(gatewayUrl_9)) {
                                throw new fm.liveswitch.Exception("Gateway URL cannot be null or empty.");
                            }
                            if (fm.liveswitch.StringExtensions.isNullOrEmpty(applicationId_10)) {
                                throw new fm.liveswitch.Exception("Application ID cannot be null or empty.");
                            }
                            _this.setGatewayUrl(gatewayUrl_9);
                            _this.setApplicationId(applicationId_10);
                            if ((!fm.liveswitch.Global.equals(clientId_4, null))) {
                                _this.setExternalId(clientId_4);
                                clientId_4 = null;
                                fm.liveswitch.Client.fm_liveswitch_Client___log.warn(fm.liveswitch.StringExtensions.format("Client IDs are automatically generated. The provided client ID '{0}' will be moved to the ExternalId property and replaced with a generated ID.", _this.getExternalId()));
                            }
                            _this.setUserId(fm.liveswitch.StringExtensions.nullCoalesce(userId_9, fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "")));
                            _this.setDeviceId(fm.liveswitch.StringExtensions.nullCoalesce(deviceId_7, fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "")));
                            _this.setId(fm.liveswitch.StringExtensions.nullCoalesce(clientId_4, fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "")));
                            _this.__roles = roles_3;
                            _this.__region = region;
                            _this.__channels = new fm.liveswitch.ManagedConcurrentDictionary();
                            var client = new fm.liveswitch.signalling.Client(_this.getGatewayUrl(), _this.__lock);
                            client.setDisableBinary(true);
                            client.setRequestMaxRetries(3);
                            _this.__gatewayClient = client;
                            _this.__sendQueue = new fm.liveswitch.SendQueue(new fm.liveswitch.SignallingSendQueueTransport(_this.__gatewayClient));
                            _this.__gatewayClient.addOnServerSubscribe(_this._gatewayClient_OnServerSubscribe.bind(_this));
                            _this.__gatewayClient.addOnStateChange(_this._gatewayClient_OnStateChange.bind(_this));
                            _this.__gatewayClient.addOnHttpRequestCreated(_this._gatewayClient_OnHttpRequestCreated.bind(_this));
                            _this.__gatewayClient.addOnHttpResponseReceived(_this._gatewayClient_OnHttpResponseReceived.bind(_this));
                        }
                    }
                }
                else if (__arguments.length == 5) {
                    var gatewayUrl = __arguments[0];
                    var applicationId = __arguments[1];
                    var userId = __arguments[2];
                    var deviceId = __arguments[3];
                    var clientId = __arguments[4];
                    // chained constructor: Client.call(this, gatewayUrl, applicationId, userId, deviceId, clientId, null);
                    __arguments = new Array(6);
                    __arguments[0] = gatewayUrl;
                    __arguments[1] = applicationId;
                    __arguments[2] = userId;
                    __arguments[3] = deviceId;
                    __arguments[4] = clientId;
                    __arguments[5] = null;
                    {
                        var gatewayUrl_10 = __arguments[0];
                        var applicationId_11 = __arguments[1];
                        var userId_10 = __arguments[2];
                        var deviceId_8 = __arguments[3];
                        var clientId_5 = __arguments[4];
                        var roles = __arguments[5];
                        // chained constructor: Client.call(this, gatewayUrl, applicationId, userId, deviceId, clientId, roles, null);
                        __arguments = new Array(7);
                        __arguments[0] = gatewayUrl_10;
                        __arguments[1] = applicationId_11;
                        __arguments[2] = userId_10;
                        __arguments[3] = deviceId_8;
                        __arguments[4] = clientId_5;
                        __arguments[5] = roles;
                        __arguments[6] = null;
                        {
                            var gatewayUrl_11 = __arguments[0];
                            var applicationId_12 = __arguments[1];
                            var userId_11 = __arguments[2];
                            var deviceId_9 = __arguments[3];
                            var clientId_6 = __arguments[4];
                            var roles_4 = __arguments[5];
                            var region = __arguments[6];
                            _this = _super.call(this) || this;
                            _this.fmliveswitchClientInit();
                            _this.__lock = new Object();
                            _this.__registered = false;
                            _this.__registering = false;
                            _this.__unregistering = false;
                            _this.__joining = new Array();
                            _this.__leaving = new Array();
                            _this.__earlyChannelMessages = new fm.liveswitch.ManagedConcurrentDictionary();
                            if (fm.liveswitch.StringExtensions.isNullOrEmpty(gatewayUrl_11)) {
                                throw new fm.liveswitch.Exception("Gateway URL cannot be null or empty.");
                            }
                            if (fm.liveswitch.StringExtensions.isNullOrEmpty(applicationId_12)) {
                                throw new fm.liveswitch.Exception("Application ID cannot be null or empty.");
                            }
                            _this.setGatewayUrl(gatewayUrl_11);
                            _this.setApplicationId(applicationId_12);
                            if ((!fm.liveswitch.Global.equals(clientId_6, null))) {
                                _this.setExternalId(clientId_6);
                                clientId_6 = null;
                                fm.liveswitch.Client.fm_liveswitch_Client___log.warn(fm.liveswitch.StringExtensions.format("Client IDs are automatically generated. The provided client ID '{0}' will be moved to the ExternalId property and replaced with a generated ID.", _this.getExternalId()));
                            }
                            _this.setUserId(fm.liveswitch.StringExtensions.nullCoalesce(userId_11, fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "")));
                            _this.setDeviceId(fm.liveswitch.StringExtensions.nullCoalesce(deviceId_9, fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "")));
                            _this.setId(fm.liveswitch.StringExtensions.nullCoalesce(clientId_6, fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "")));
                            _this.__roles = roles_4;
                            _this.__region = region;
                            _this.__channels = new fm.liveswitch.ManagedConcurrentDictionary();
                            var client = new fm.liveswitch.signalling.Client(_this.getGatewayUrl(), _this.__lock);
                            client.setDisableBinary(true);
                            client.setRequestMaxRetries(3);
                            _this.__gatewayClient = client;
                            _this.__sendQueue = new fm.liveswitch.SendQueue(new fm.liveswitch.SignallingSendQueueTransport(_this.__gatewayClient));
                            _this.__gatewayClient.addOnServerSubscribe(_this._gatewayClient_OnServerSubscribe.bind(_this));
                            _this.__gatewayClient.addOnStateChange(_this._gatewayClient_OnStateChange.bind(_this));
                            _this.__gatewayClient.addOnHttpRequestCreated(_this._gatewayClient_OnHttpRequestCreated.bind(_this));
                            _this.__gatewayClient.addOnHttpResponseReceived(_this._gatewayClient_OnHttpResponseReceived.bind(_this));
                        }
                    }
                }
                else if (__arguments.length == 6) {
                    var gatewayUrl = __arguments[0];
                    var applicationId = __arguments[1];
                    var userId = __arguments[2];
                    var deviceId = __arguments[3];
                    var clientId = __arguments[4];
                    var roles = __arguments[5];
                    // chained constructor: Client.call(this, gatewayUrl, applicationId, userId, deviceId, clientId, roles, null);
                    __arguments = new Array(7);
                    __arguments[0] = gatewayUrl;
                    __arguments[1] = applicationId;
                    __arguments[2] = userId;
                    __arguments[3] = deviceId;
                    __arguments[4] = clientId;
                    __arguments[5] = roles;
                    __arguments[6] = null;
                    {
                        var gatewayUrl_12 = __arguments[0];
                        var applicationId_13 = __arguments[1];
                        var userId_12 = __arguments[2];
                        var deviceId_10 = __arguments[3];
                        var clientId_7 = __arguments[4];
                        var roles_5 = __arguments[5];
                        var region = __arguments[6];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchClientInit();
                        _this.__lock = new Object();
                        _this.__registered = false;
                        _this.__registering = false;
                        _this.__unregistering = false;
                        _this.__joining = new Array();
                        _this.__leaving = new Array();
                        _this.__earlyChannelMessages = new fm.liveswitch.ManagedConcurrentDictionary();
                        if (fm.liveswitch.StringExtensions.isNullOrEmpty(gatewayUrl_12)) {
                            throw new fm.liveswitch.Exception("Gateway URL cannot be null or empty.");
                        }
                        if (fm.liveswitch.StringExtensions.isNullOrEmpty(applicationId_13)) {
                            throw new fm.liveswitch.Exception("Application ID cannot be null or empty.");
                        }
                        _this.setGatewayUrl(gatewayUrl_12);
                        _this.setApplicationId(applicationId_13);
                        if ((!fm.liveswitch.Global.equals(clientId_7, null))) {
                            _this.setExternalId(clientId_7);
                            clientId_7 = null;
                            fm.liveswitch.Client.fm_liveswitch_Client___log.warn(fm.liveswitch.StringExtensions.format("Client IDs are automatically generated. The provided client ID '{0}' will be moved to the ExternalId property and replaced with a generated ID.", _this.getExternalId()));
                        }
                        _this.setUserId(fm.liveswitch.StringExtensions.nullCoalesce(userId_12, fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "")));
                        _this.setDeviceId(fm.liveswitch.StringExtensions.nullCoalesce(deviceId_10, fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "")));
                        _this.setId(fm.liveswitch.StringExtensions.nullCoalesce(clientId_7, fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "")));
                        _this.__roles = roles_5;
                        _this.__region = region;
                        _this.__channels = new fm.liveswitch.ManagedConcurrentDictionary();
                        var client = new fm.liveswitch.signalling.Client(_this.getGatewayUrl(), _this.__lock);
                        client.setDisableBinary(true);
                        client.setRequestMaxRetries(3);
                        _this.__gatewayClient = client;
                        _this.__sendQueue = new fm.liveswitch.SendQueue(new fm.liveswitch.SignallingSendQueueTransport(_this.__gatewayClient));
                        _this.__gatewayClient.addOnServerSubscribe(_this._gatewayClient_OnServerSubscribe.bind(_this));
                        _this.__gatewayClient.addOnStateChange(_this._gatewayClient_OnStateChange.bind(_this));
                        _this.__gatewayClient.addOnHttpRequestCreated(_this._gatewayClient_OnHttpRequestCreated.bind(_this));
                        _this.__gatewayClient.addOnHttpResponseReceived(_this._gatewayClient_OnHttpResponseReceived.bind(_this));
                    }
                }
                else if (__arguments.length == 7) {
                    var gatewayUrl = __arguments[0];
                    var applicationId = __arguments[1];
                    var userId = __arguments[2];
                    var deviceId = __arguments[3];
                    var clientId = __arguments[4];
                    var roles = __arguments[5];
                    var region = __arguments[6];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchClientInit();
                    _this.__lock = new Object();
                    _this.__registered = false;
                    _this.__registering = false;
                    _this.__unregistering = false;
                    _this.__joining = new Array();
                    _this.__leaving = new Array();
                    _this.__earlyChannelMessages = new fm.liveswitch.ManagedConcurrentDictionary();
                    if (fm.liveswitch.StringExtensions.isNullOrEmpty(gatewayUrl)) {
                        throw new fm.liveswitch.Exception("Gateway URL cannot be null or empty.");
                    }
                    if (fm.liveswitch.StringExtensions.isNullOrEmpty(applicationId)) {
                        throw new fm.liveswitch.Exception("Application ID cannot be null or empty.");
                    }
                    _this.setGatewayUrl(gatewayUrl);
                    _this.setApplicationId(applicationId);
                    if ((!fm.liveswitch.Global.equals(clientId, null))) {
                        _this.setExternalId(clientId);
                        clientId = null;
                        fm.liveswitch.Client.fm_liveswitch_Client___log.warn(fm.liveswitch.StringExtensions.format("Client IDs are automatically generated. The provided client ID '{0}' will be moved to the ExternalId property and replaced with a generated ID.", _this.getExternalId()));
                    }
                    _this.setUserId(fm.liveswitch.StringExtensions.nullCoalesce(userId, fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "")));
                    _this.setDeviceId(fm.liveswitch.StringExtensions.nullCoalesce(deviceId, fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "")));
                    _this.setId(fm.liveswitch.StringExtensions.nullCoalesce(clientId, fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", "")));
                    _this.__roles = roles;
                    _this.__region = region;
                    _this.__channels = new fm.liveswitch.ManagedConcurrentDictionary();
                    var client = new fm.liveswitch.signalling.Client(_this.getGatewayUrl(), _this.__lock);
                    client.setDisableBinary(true);
                    client.setRequestMaxRetries(3);
                    _this.__gatewayClient = client;
                    _this.__sendQueue = new fm.liveswitch.SendQueue(new fm.liveswitch.SignallingSendQueueTransport(_this.__gatewayClient));
                    _this.__gatewayClient.addOnServerSubscribe(_this._gatewayClient_OnServerSubscribe.bind(_this));
                    _this.__gatewayClient.addOnStateChange(_this._gatewayClient_OnStateChange.bind(_this));
                    _this.__gatewayClient.addOnHttpRequestCreated(_this._gatewayClient_OnHttpRequestCreated.bind(_this));
                    _this.__gatewayClient.addOnHttpResponseReceived(_this._gatewayClient_OnHttpResponseReceived.bind(_this));
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            Client.prototype.getTypeString = function () {
                return '[fm.liveswitch.Client]' + ',' + _super.prototype.getTypeString.call(this);
            };
            Client.prototype.fmliveswitchClientInit = function () {
                var _this = this;
                this.__onHttpRequestCreated = [];
                this.__onHttpResponseReceived = [];
                this.__onRemoteUpdate = [];
                this.__onStateChange = [];
                this.__registered = false;
                this.__registering = false;
                this.__unregistering = false;
                this._onHttpRequestCreated = function (p0) { for (var _i = 0, _a = _this.__onHttpRequestCreated; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
                this._onHttpResponseReceived = function (p0) { for (var _i = 0, _a = _this.__onHttpResponseReceived; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
                this._onRemoteUpdate = function (p0, p1) { for (var _i = 0, _a = _this.__onRemoteUpdate; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0, p1);
                } };
                this._onStateChange = function (p0) { for (var _i = 0, _a = _this.__onStateChange; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
            };
            /** @hidden */
            Client.prototype._gatewayClient_OnHttpRequestCreated = function (args) {
                if (arguments.length == 1) {
                    var onHttpRequestCreated = this._onHttpRequestCreated;
                    if ((!fm.liveswitch.Global.equals(onHttpRequestCreated, null))) {
                        onHttpRequestCreated(args);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype._gatewayClient_OnHttpResponseReceived = function (args) {
                if (arguments.length == 1) {
                    var onHttpResponseReceived = this._onHttpResponseReceived;
                    if ((!fm.liveswitch.Global.equals(onHttpResponseReceived, null))) {
                        onHttpResponseReceived(args);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype._gatewayClient_OnServerSubscribe = function (args) {
                var _this = this;
                if (arguments.length == 1) {
                    args.setOnReceive(function (e) {
                        _this.receive(fm.liveswitch.Message.fromJson(e.getDataJson()));
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype._gatewayClient_OnStateChange = function (client) {
                if (arguments.length == 1) {
                    if (fm.liveswitch.Client.fm_liveswitch_Client___log.getIsInfoEnabled()) {
                        fm.liveswitch.Client.fm_liveswitch_Client___log.info(fm.liveswitch.StringExtensions.format("Setting client {0} state to {1}.", this.getId(), fm.liveswitch.StringExtensions.toLower(new fm.liveswitch.ClientStateWrapper(this.getState()).toString())), this.getUnregisterException());
                    }
                    if ((fm.liveswitch.Global.equals(client.getState(), fm.liveswitch.signalling.ClientState.Connecting))) {
                        this.__registering = true;
                        this.__registered = false;
                        this.__unregistering = false;
                    }
                    else {
                        if ((fm.liveswitch.Global.equals(client.getState(), fm.liveswitch.signalling.ClientState.Connected))) {
                            this.__registering = false;
                            this.__registered = true;
                            this.__unregistering = false;
                            this.__sendQueue.trySendPending();
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(client.getState(), fm.liveswitch.signalling.ClientState.Disconnecting))) {
                                this.__unregistering = true;
                                this.__registering = false;
                                this.dispatchCloseAll(this.getChannels());
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(client.getState(), fm.liveswitch.signalling.ClientState.Disconnected))) {
                                    this.__unregistering = false;
                                    this.__registered = false;
                                    this.__registering = false;
                                    this.dispatchCloseAll(this.getChannels());
                                    fm.liveswitch.ArrayExtensions.clear(this.__joining);
                                    fm.liveswitch.ArrayExtensions.clear(this.__leaving);
                                    this.__sendQueue.clear();
                                    for (var _i = 0, _a = this.getChannels(); _i < _a.length; _i++) {
                                        var channel = _a[_i];
                                        this.removeChannel(channel.getId());
                                    }
                                }
                            }
                        }
                    }
                    var onStateChange = this._onStateChange;
                    if ((!fm.liveswitch.Global.equals(onStateChange, null))) {
                        onStateChange(this);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype.addChannel = function (channelId) {
                if (arguments.length == 1) {
                    return this.__channels.getOrAdd(channelId, this.createChannel.bind(this));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised whenever an underlying HTTP request has been created and is about to be transferred to the server. This is a good place to add headers/cookies. For WebSocket streams, this will fire only once for the initial HTTP-based handshake.
            */
            Client.prototype.addOnHttpRequestCreated = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onHttpRequestCreated, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised whenever an underlying HTTP response has been received and is about to be processed by the client. This is a good place to read headers/cookies. For WebSocket streams, this will fire only once for the initial HTTP-based handshake.
            */
            Client.prototype.addOnHttpResponseReceived = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onHttpResponseReceived, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when the the client's config on the server has changed.
            */
            Client.prototype.addOnRemoteUpdate = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onRemoteUpdate, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when the state changes.
            */
            Client.prototype.addOnStateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onStateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype.attachChannelEvents = function (channel, channelId) {
                var _this = this;
                if (arguments.length == 2) {
                    channel.addOnKick(function () {
                        channel.closeAll();
                        _this.removeChannel(channelId);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Closes all active connections in all channels.
            */
            Client.prototype.closeAll = function () {
                if (arguments.length == 0) {
                    return this.doCloseAll(this.getChannels());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype.createChannel = function (channelId) {
                if (arguments.length == 1) {
                    var channel = new fm.liveswitch.Channel(this.__lock, new fm.liveswitch.ConnectionFactory(), this.getApplicationId(), this.getUserId(), this.getUserAlias(), this.getDeviceId(), this.getDeviceAlias(), this.getId(), this.getTag(), this.getRoles(), channelId, this.send.bind(this));
                    this.attachChannelEvents(channel, channelId);
                    return channel;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype.dispatchCloseAll = function (channels) {
                var _this = this;
                if (arguments.length == 1) {
                    fm.liveswitch.ManagedThread.dispatch(function () {
                        _this.doCloseAll(channels);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype.doCloseAll = function (channels) {
                if (arguments.length == 1) {
                    fm.liveswitch.Client.fm_liveswitch_Client___log.debug(this.getId(), "Closing all connections.");
                    var list = new Array();
                    for (var _i = 0, channels_3 = channels; _i < channels_3.length; _i++) {
                        var channel = channels_3[_i];
                        fm.liveswitch.ArrayExtensions.add(list, channel.closeAll());
                    }
                    return fm.liveswitch.PromiseBase.all(fm.liveswitch.ArrayExtensions.toArray(list));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype.doDisconnect = function (promise, timestamp, channelReports) {
                var _this = this;
                if (arguments.length == 3) {
                    fm.liveswitch.Client.fm_liveswitch_Client___log.debug(this.getId(), "Sending unregister request.");
                    var disconnectArgs = new fm.liveswitch.signalling.DisconnectArgs();
                    disconnectArgs.setMetaJson(fm.liveswitch.Message.createUnregisterMessage(channelReports).toJson());
                    disconnectArgs.setOnComplete(function (e) {
                        var num = fm.liveswitch.MathAssistant.floor((fm.liveswitch.ManagedStopwatch.getTimestamp() - timestamp) / fm.liveswitch.Constants.getTicksPerMillisecond());
                        fm.liveswitch.Client.fm_liveswitch_Client___log.info(_this.getId(), fm.liveswitch.StringExtensions.format("Client {0} took {1}ms to unregister.", _this.getId(), fm.liveswitch.NumberExtensions.toString(num)));
                        if ((!fm.liveswitch.Global.equals(e.getException(), null))) {
                            fm.liveswitch.Client.fm_liveswitch_Client___log.error(_this.getId(), "Could not send unregister message.", e.getException());
                        }
                        promise.resolve(null);
                    });
                    this.__gatewayClient.disconnect(disconnectArgs);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype.doJoin = function (promise, channelId, token, timestamp) {
                var _this = this;
                if (arguments.length == 4) {
                    fm.liveswitch.Client.fm_liveswitch_Client___log.info(this.getId(), fm.liveswitch.StringExtensions.format("Joining channel {0}.", channelId));
                    if (!this.__registered) {
                        promise.reject(new fm.liveswitch.Exception("Client is not registered."));
                        return promise;
                    }
                    if (this.__unregistering) {
                        promise.reject(new fm.liveswitch.Exception("Client is unregistering."));
                        return promise;
                    }
                    if (this.__channels.containsKey(channelId)) {
                        var channel = null;
                        var _var0 = new fm.liveswitch.Holder(channel);
                        var _var1 = this.__channels.tryGetValue(channelId, _var0);
                        channel = _var0.getValue();
                        if (_var1) {
                            promise.resolve(channel);
                            return promise;
                        }
                    }
                    if (fm.liveswitch.ArrayExtensions.contains(this.__joining, channelId)) {
                        promise.reject(new fm.liveswitch.Exception("Client is already joining."));
                        return promise;
                    }
                    if (fm.liveswitch.ArrayExtensions.contains(this.__leaving, channelId)) {
                        promise.reject(new fm.liveswitch.Exception("Client is currently leaving."));
                        return promise;
                    }
                    fm.liveswitch.ArrayExtensions.add(this.__joining, channelId);
                    fm.liveswitch.Client.fm_liveswitch_Client___log.debug(this.getId(), "Sending join request.");
                    this.send(fm.liveswitch.Message.createJoinMessage(channelId, token)).then(function (response) {
                        var obj2;
                        var num = fm.liveswitch.MathAssistant.floor((fm.liveswitch.ManagedStopwatch.getTimestamp() - timestamp) / fm.liveswitch.Constants.getTicksPerMillisecond());
                        fm.liveswitch.Client.fm_liveswitch_Client___log.info(_this.getId(), fm.liveswitch.StringExtensions.format("Client {0} took {1}ms to join {2}.", _this.getId(), fm.liveswitch.NumberExtensions.toString(num), channelId));
                        if (((!fm.liveswitch.Global.equals(response, null)) && (fm.liveswitch.Global.equals(response.getType(), fm.liveswitch.MessageType.getError())))) {
                            fm.liveswitch.ArrayExtensions.remove(_this.__joining, channelId);
                            var str = null;
                            if ((!fm.liveswitch.Global.equals(response.getPayload(), null))) {
                                str = fm.liveswitch.JsonSerializer.deserializeString(response.getPayload());
                            }
                            if ((fm.liveswitch.Global.equals(str, null))) {
                                promise.reject(new fm.liveswitch.Exception("Gateway declined join request."));
                            }
                            else {
                                promise.reject(new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.concat("Gateway declined join request. ", str)));
                            }
                        }
                        else {
                            var result = _this.addChannel(channelId);
                            fm.liveswitch.ArrayExtensions.remove(_this.__joining, channelId);
                            if ((!fm.liveswitch.Global.equals(response, null))) {
                                if ((fm.liveswitch.Global.equals(response.getType(), fm.liveswitch.MessageType.getNotifyJoin()))) {
                                    result.processMessageSync(response);
                                }
                                else {
                                    fm.liveswitch.Client.fm_liveswitch_Client___log.warn(_this.getId(), fm.liveswitch.StringExtensions.concat("Unexpected message in join response: ", response.toJson()));
                                }
                            }
                            var list = null;
                            var _var2 = new fm.liveswitch.Holder(list);
                            var _var3 = _this.__earlyChannelMessages.tryRemove(channelId, _var2);
                            list = _var2.getValue();
                            if ((!fm.liveswitch.Global.equals(list, null))) {
                                for (var _i = 0, list_7 = list; _i < list_7.length; _i++) {
                                    var message = list_7[_i];
                                    result.processMessageAsync(message);
                                }
                            }
                            promise.resolve(result);
                        }
                    }, function (ex) {
                        fm.liveswitch.Client.fm_liveswitch_Client___log.error(_this.getId(), "Could not send join message.", ex);
                        fm.liveswitch.ArrayExtensions.remove(_this.__joining, channelId);
                        promise.reject(ex);
                    });
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype.doLeave = function (promise, channelId, timestamp) {
                if (arguments.length == 3) {
                    fm.liveswitch.Client.fm_liveswitch_Client___log.info(this.getId(), fm.liveswitch.StringExtensions.format("Leaving channel {0}.", channelId));
                    var channel = null;
                    if (!this.__registered) {
                        promise.reject(new fm.liveswitch.Exception("Client is not registered."));
                        return promise;
                    }
                    if (this.__unregistering) {
                        promise.reject(new fm.liveswitch.Exception("Client is unregistering."));
                        return promise;
                    }
                    var _var0 = new fm.liveswitch.Holder(channel);
                    var _var1 = this.__channels.tryGetValue(channelId, _var0);
                    channel = _var0.getValue();
                    if (!_var1) {
                        promise.resolve(null);
                        return promise;
                    }
                    if (fm.liveswitch.ArrayExtensions.contains(this.__leaving, channelId)) {
                        promise.reject(new fm.liveswitch.Exception("Client is already leaving."));
                        return promise;
                    }
                    if (fm.liveswitch.ArrayExtensions.contains(this.__joining, channelId)) {
                        promise.reject(new fm.liveswitch.Exception("Client is currently joining."));
                        return promise;
                    }
                    fm.liveswitch.ArrayExtensions.add(this.__leaving, channelId);
                    this.doLeaveChannel(promise, channelId, channel, timestamp);
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype.doLeaveChannel = function (promise, channelId, channel, timestamp) {
                var _this = this;
                if (arguments.length == 4) {
                    fm.liveswitch.Client.fm_liveswitch_Client___log.debug(this.getId(), "Sending leave request.");
                    this.send(fm.liveswitch.Message.createLeaveMessage(channelId, channel.getReport())).then(function (response) {
                        var obj2;
                        var num = fm.liveswitch.MathAssistant.floor((fm.liveswitch.ManagedStopwatch.getTimestamp() - timestamp) / fm.liveswitch.Constants.getTicksPerMillisecond());
                        fm.liveswitch.Client.fm_liveswitch_Client___log.info(_this.getId(), fm.liveswitch.StringExtensions.format("Client {0} took {1}ms to leave {2}.", _this.getId(), fm.liveswitch.NumberExtensions.toString(num), channelId));
                        if (((!fm.liveswitch.Global.equals(response, null)) && (fm.liveswitch.Global.equals(response.getType(), fm.liveswitch.MessageType.getError())))) {
                            fm.liveswitch.ArrayExtensions.remove(_this.__leaving, channelId);
                            var str = null;
                            if ((!fm.liveswitch.Global.equals(response.getPayload(), null))) {
                                str = fm.liveswitch.JsonSerializer.deserializeString(response.getPayload());
                            }
                            if ((fm.liveswitch.Global.equals(str, null))) {
                                promise.reject(new fm.liveswitch.Exception("Gateway declined leave request."));
                            }
                            else {
                                promise.reject(new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.concat("Gateway declined leave request. ", str)));
                            }
                        }
                        else {
                            _this.removeChannel(channelId);
                            fm.liveswitch.ArrayExtensions.remove(_this.__leaving, channelId);
                            if ((!fm.liveswitch.Global.equals(channel, null))) {
                                channel.closeAll();
                            }
                            if ((!fm.liveswitch.Global.equals(response, null))) {
                                fm.liveswitch.Client.fm_liveswitch_Client___log.warn(_this.getId(), fm.liveswitch.StringExtensions.concat("Unexpected message in leave response: ", response.toJson()));
                            }
                            promise.resolve(null);
                        }
                    }, function (ex) {
                        fm.liveswitch.Client.fm_liveswitch_Client___log.error(_this.getId(), "Could not send leave message.", ex);
                        fm.liveswitch.ArrayExtensions.remove(_this.__leaving, channelId);
                        promise.reject(ex);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype.doRegister = function (promise, token, timestamp) {
                var _this = this;
                if (arguments.length == 3) {
                    fm.liveswitch.Client.fm_liveswitch_Client___log.info(this.getId(), fm.liveswitch.StringExtensions.format("Registering to application {0}.", this.getApplicationId()));
                    if (this.__registered) {
                        promise.resolve(null);
                        return promise;
                    }
                    if (this.__registering) {
                        promise.reject(new fm.liveswitch.Exception("Client is already registering."));
                        return promise;
                    }
                    if (this.__unregistering) {
                        promise.reject(new fm.liveswitch.Exception("Client is currently unregistering."));
                        return promise;
                    }
                    var args2 = new fm.liveswitch.signalling.ConnectArgs();
                    args2.setMetaJson(fm.liveswitch.Message.createRegisterMessage(this.getApplicationId(), this.getUserId(), this.getUserAlias(), this.getDeviceId(), this.getDeviceAlias(), this.getId(), this.getTag(), this.getRoles(), this.getRegion(), token).toJson());
                    args2.setOnSuccess(function (e) {
                        var num = fm.liveswitch.MathAssistant.floor((fm.liveswitch.ManagedStopwatch.getTimestamp() - timestamp) / fm.liveswitch.Constants.getTicksPerMillisecond());
                        fm.liveswitch.Client.fm_liveswitch_Client___log.info(_this.getId(), fm.liveswitch.StringExtensions.format("Client {0} took {1}ms to register.", _this.getId(), fm.liveswitch.NumberExtensions.toString(num)));
                        try {
                            var token1 = fm.liveswitch.Token.parse(token);
                            if ((!fm.liveswitch.Global.equals(token1, null))) {
                                if ((!fm.liveswitch.Global.equals(token1.getClientRoles(), null))) {
                                    _this.__roles = token1.getClientRoles();
                                }
                                if ((!fm.liveswitch.Global.equals(token1.getRegion(), null))) {
                                    _this.__region = token1.getRegion();
                                }
                            }
                        }
                        catch (exception) {
                            fm.liveswitch.Client.fm_liveswitch_Client___log.error("Could not parse register token to extract roles/region.", exception);
                        }
                        finally {
                        }
                        if ((!fm.liveswitch.Global.equals(e.getMetaJson(), null))) {
                            var messageArray = fm.liveswitch.Message.fromJsonArray(e.getMetaJson());
                            if ((fm.liveswitch.Global.equals(messageArray, null))) {
                                fm.liveswitch.Client.fm_liveswitch_Client___log.error(_this.getId(), "Could not parse messages in register response.");
                            }
                            else {
                                for (var _i = 0, messageArray_1 = messageArray; _i < messageArray_1.length; _i++) {
                                    var message = messageArray_1[_i];
                                    if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getNotifyJoin()))) {
                                        _this.addChannel(message.getChannelId()).processMessageSync(message);
                                    }
                                    else {
                                        fm.liveswitch.Client.fm_liveswitch_Client___log.warn(_this.getId(), fm.liveswitch.StringExtensions.concat("Unexpected message in register response: ", message.toJson()));
                                    }
                                }
                            }
                        }
                        promise.resolve(_this.getChannels());
                    });
                    args2.setOnFailure(function (e) {
                        fm.liveswitch.Client.fm_liveswitch_Client___log.error(_this.getId(), "Could not send register message.", e.getException());
                        promise.reject(e.getException());
                    });
                    var connectArgs = args2;
                    var info = this.getInfo();
                    if ((!fm.liveswitch.Global.equals(info.getArchitecture(), null))) {
                        connectArgs.setExtensionValueJson("architecture", fm.liveswitch.JsonSerializer.serializeString(info.getArchitecture()));
                    }
                    if ((!fm.liveswitch.Global.equals(info.getCoreCount(), 0))) {
                        connectArgs.setExtensionValueJson("coreCount", fm.liveswitch.JsonSerializer.serializeInteger(info.getCoreCount()));
                    }
                    if ((!fm.liveswitch.Global.equals(info.getMachineName(), null))) {
                        connectArgs.setExtensionValueJson("machineName", fm.liveswitch.JsonSerializer.serializeString(info.getMachineName()));
                    }
                    if ((!fm.liveswitch.Global.equals(info.getOperatingSystem(), null))) {
                        connectArgs.setExtensionValueJson("operatingSystem", fm.liveswitch.JsonSerializer.serializeString(info.getOperatingSystem()));
                    }
                    if ((!fm.liveswitch.Global.equals(info.getOperatingSystemVersion(), null))) {
                        connectArgs.setExtensionValueJson("operatingSystemVersion", fm.liveswitch.JsonSerializer.serializeString(info.getOperatingSystemVersion()));
                    }
                    if ((!fm.liveswitch.Global.equals(info.getPhysicalMemory(), 0))) {
                        connectArgs.setExtensionValueJson("physicalMemory", fm.liveswitch.JsonSerializer.serializeLong(info.getPhysicalMemory()));
                    }
                    if ((!fm.liveswitch.Global.equals(info.getSourceLanguage(), null))) {
                        connectArgs.setExtensionValueJson("sourceLanguage", fm.liveswitch.JsonSerializer.serializeString(info.getSourceLanguage()));
                    }
                    fm.liveswitch.Client.fm_liveswitch_Client___log.debug(this.getId(), "Sending register request.");
                    this.__gatewayClient.connect(connectArgs);
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Client.prototype.doUnregister = function () {
                var _this = this;
                if (arguments.length == 2) {
                    var promise = arguments[0];
                    var timestamp = arguments[1];
                    fm.liveswitch.Client.fm_liveswitch_Client___log.info(this.getId(), fm.liveswitch.StringExtensions.format("Unregistering from application {0}.", this.getApplicationId()));
                    if (!this.__registered) {
                        promise.resolve(null);
                        return promise;
                    }
                    if (this.__unregistering) {
                        promise.reject(new fm.liveswitch.Exception("Client is already unregistering."));
                        return promise;
                    }
                    if (this.__registering) {
                        promise.reject(new fm.liveswitch.Exception("Client is currently registering."));
                        return promise;
                    }
                    var list = new Array();
                    for (var _i = 0, _a = this.getChannels(); _i < _a.length; _i++) {
                        var channel = _a[_i];
                        fm.liveswitch.ArrayExtensions.add(list, channel.getReport());
                    }
                    this.doUnregister(promise, timestamp, fm.liveswitch.ArrayExtensions.toArray(list));
                    return promise;
                }
                else if (arguments.length == 3) {
                    var promise_2 = arguments[0];
                    var timestamp_2 = arguments[1];
                    var channelReports_1 = arguments[2];
                    this.closeAll().then(function (o) {
                        _this.doDisconnect(promise_2, timestamp_2, channelReports_1);
                    }, function (ex) {
                        fm.liveswitch.Client.fm_liveswitch_Client___log.warn("An exception was encountered while closing connections before unregistering.", ex);
                        _this.doDisconnect(promise_2, timestamp_2, channelReports_1);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the application identifier.
            */
            Client.prototype.getApplicationId = function () {
                if (arguments.length == 0) {
                    return this._applicationId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether to unregister automatically when the page unloads.
            */
            Client.prototype.getAutoUnregister = function () {
                if (arguments.length == 0) {
                    return this.__gatewayClient.getAutoDisconnect();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets an array of joined channels.
            */
            Client.prototype.getChannels = function () {
                if (arguments.length == 0) {
                    var list = new Array();
                    for (var _i = 0, _a = this.__channels.getValues(); _i < _a.length; _i++) {
                        var channel = _a[_i];
                        fm.liveswitch.ArrayExtensions.add(list, channel);
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the current configuration.
            */
            Client.prototype.getConfig = function () {
                if (arguments.length == 0) {
                    var config = new fm.liveswitch.ClientConfig();
                    config.setUserAlias(this.getUserAlias());
                    config.setDeviceAlias(this.getDeviceAlias());
                    config.setTag(this.getTag());
                    config.setRoles(this.getRoles());
                    return config;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the device alias. Cannot be set after registration, use the 'Update' method instead.
            */
            Client.prototype.getDeviceAlias = function () {
                if (arguments.length == 0) {
                    return this.__deviceAlias;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the device identifier.
            */
            Client.prototype.getDeviceId = function () {
                if (arguments.length == 0) {
                    return this._deviceId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether to disable the cross-origin resource sharing (CORS) transport.
            */
            Client.prototype.getDisableCors = function () {
                if (arguments.length == 0) {
                    return this.__gatewayClient.getDisableCors();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether to disable the JSON-P transport.
            */
            Client.prototype.getDisableJsonp = function () {
                if (arguments.length == 0) {
                    return this.__gatewayClient.getDisableJsonp();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether to disable the postMessage transport.
            */
            Client.prototype.getDisablePostMessage = function () {
                if (arguments.length == 0) {
                    return this.__gatewayClient.getDisablePostMessage();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether to disable WebSocket protocol support and use long-polling, even if the server is capable of accepting WebSocket requests.
            */
            Client.prototype.getDisableWebSockets = function () {
                if (arguments.length == 0) {
                    return this.__gatewayClient.getDisableWebSockets();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the external client identifier.
            */
            Client.prototype.getExternalId = function () {
                if (arguments.length == 0) {
                    return this._externalId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether to force the JSON-P transport.
            */
            Client.prototype.getForceJsonp = function () {
                if (arguments.length == 0) {
                    return this.__gatewayClient.getForceJsonp();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the gateway URL.
            */
            Client.prototype.getGatewayUrl = function () {
                if (arguments.length == 0) {
                    return this._gatewayUrl;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client identifier.
            */
            Client.prototype.getId = function () {
                if (arguments.length == 0) {
                    return this._id;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client info.
            */
            Client.prototype.getInfo = function () {
                if (arguments.length == 0) {
                    var info = new fm.liveswitch.ClientInfo();
                    info.setApplicationId(this.getApplicationId());
                    info.setArchitecture(fm.liveswitch.StringExtensions.toLower(new fm.liveswitch.ArchitectureWrapper(fm.liveswitch.Platform.getInstance().getArchitecture()).toString()));
                    info.setCoreCount(fm.liveswitch.Platform.getInstance().getCoreCount());
                    info.setDeviceAlias(this.getDeviceAlias());
                    info.setDeviceId(this.getDeviceId());
                    info.setExternalId(this.getExternalId());
                    info.setId(this.getId());
                    info.setMachineName(fm.liveswitch.Platform.getInstance().getMachineName());
                    info.setOperatingSystem(fm.liveswitch.StringExtensions.toLower(new fm.liveswitch.OperatingSystemWrapper(fm.liveswitch.Platform.getInstance().getOperatingSystem()).toString()));
                    info.setOperatingSystemVersion(fm.liveswitch.Platform.getInstance().getOperatingSystemVersion());
                    info.setPhysicalMemory(fm.liveswitch.Platform.getInstance().getPhysicalMemory());
                    info.setRegion(this.getRegion());
                    info.setRoles(this.getRoles());
                    info.setSourceLanguage(fm.liveswitch.StringExtensions.toLower(new fm.liveswitch.SourceLanguageWrapper(fm.liveswitch.Platform.getInstance().getSourceLanguage()).toString()));
                    info.setTag(this.getTag());
                    info.setUserAlias(this.getUserAlias());
                    info.setUserId(this.getUserId());
                    info.setVersion(fm.liveswitch.Build.getVersion());
                    return info;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the region.
            */
            Client.prototype.getRegion = function () {
                if (arguments.length == 0) {
                    return this.__region;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the maximum number of retries allowed for a standard request.
            */
            Client.prototype.getRequestMaxRetries = function () {
                if (arguments.length == 0) {
                    return this.__gatewayClient.getRequestMaxRetries();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of milliseconds to wait for a standard request to return a response before it is aborted and another request is attempted. Defaults to 15000 (15 seconds).
            */
            Client.prototype.getRequestTimeout = function () {
                if (arguments.length == 0) {
                    return this.__gatewayClient.getRequestTimeout();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the roles.
            */
            Client.prototype.getRoles = function () {
                if (arguments.length == 0) {
                    return this.__roles;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the state.
            */
            Client.prototype.getState = function () {
                if (arguments.length == 0) {
                    var _var0 = this.__gatewayClient.getState();
                    if (_var0 == fm.liveswitch.signalling.ClientState.Connecting) {
                        do {
                            return fm.liveswitch.ClientState.Registering;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.signalling.ClientState.Connected) {
                        do {
                            return fm.liveswitch.ClientState.Registered;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.signalling.ClientState.Disconnecting) {
                        do {
                            return fm.liveswitch.ClientState.Unregistering;
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.signalling.ClientState.Disconnected) {
                        do {
                            return fm.liveswitch.ClientState.Unregistered;
                        } while (false);
                    }
                    return fm.liveswitch.ClientState.New;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the tag. Cannot be set after registration, use the 'Update' method instead.
            */
            Client.prototype.getTag = function () {
                if (arguments.length == 0) {
                    return this.__tag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the unregister exception, which is set if registration is reset abnormally.
            */
            Client.prototype.getUnregisterException = function () {
                if (arguments.length == 0) {
                    return this.__gatewayClient.getDisconnectException();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the user alias. Cannot be set after registration, use the 'Update' method instead.
            */
            Client.prototype.getUserAlias = function () {
                if (arguments.length == 0) {
                    return this.__userAlias;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the user identifier.
            */
            Client.prototype.getUserId = function () {
                if (arguments.length == 0) {
                    return this._userId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Client.prototype.join = function () {
                if (arguments.length == 2) {
                    var channelId = arguments[0];
                    var token = arguments[1];
                    var promise = new fm.liveswitch.Promise();
                    var message = null;
                    var channelClaim = null;
                    var _var0 = new fm.liveswitch.Holder(channelClaim);
                    var _var1 = new fm.liveswitch.Holder(message);
                    var _var2 = this.validateJoinToken(token, _var0, _var1);
                    channelClaim = _var0.getValue();
                    message = _var1.getValue();
                    if (!_var2) {
                        promise.reject(new fm.liveswitch.Exception(message));
                        return promise;
                    }
                    if ((!fm.liveswitch.Global.equals(channelId, channelClaim.getId()))) {
                        promise.reject(new fm.liveswitch.Exception("Token channel claim ID does not match channel ID."));
                        return promise;
                    }
                    this.doJoin(promise, channelClaim.getId(), token, fm.liveswitch.ManagedStopwatch.getTimestamp());
                    return promise;
                }
                else if (arguments.length == 1) {
                    var token = arguments[0];
                    var promise = new fm.liveswitch.Promise();
                    var message = null;
                    var channelClaim = null;
                    var _var0 = new fm.liveswitch.Holder(channelClaim);
                    var _var1 = new fm.liveswitch.Holder(message);
                    var _var2 = this.validateJoinToken(token, _var0, _var1);
                    channelClaim = _var0.getValue();
                    message = _var1.getValue();
                    if (!_var2) {
                        promise.reject(new fm.liveswitch.Exception(message));
                        return promise;
                    }
                    this.doJoin(promise, channelClaim.getId(), token, fm.liveswitch.ManagedStopwatch.getTimestamp());
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Leaves a channel.
            @param channelId The channel identifier.
            */
            Client.prototype.leave = function (channelId) {
                if (arguments.length == 1) {
                    var promise = new fm.liveswitch.Promise();
                    this.doLeave(promise, channelId, fm.liveswitch.ManagedStopwatch.getTimestamp());
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype.processChannelMessage = function (message) {
                if (arguments.length == 1) {
                    var channel = null;
                    var channelId = message.getChannelId();
                    var _var0 = new fm.liveswitch.Holder(channel);
                    var _var1 = this.__channels.tryGetValue(channelId, _var0);
                    channel = _var0.getValue();
                    if (!_var1) {
                        fm.liveswitch.ArrayExtensions.add(this.__earlyChannelMessages.getOrAdd(channelId, function (key) {
                            return new Array();
                        }), message);
                    }
                    if ((!fm.liveswitch.Global.equals(channel, null))) {
                        channel.processMessageAsync(message);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype.processMessage = function (message) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(message, null))) {
                        throw new fm.liveswitch.Exception("Message is null.");
                    }
                    if ((!fm.liveswitch.Global.equals(message.getChannelId(), null))) {
                        this.processChannelMessage(message);
                    }
                    else {
                        if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getUpdate()))) {
                            var clientConfig = fm.liveswitch.ClientConfig.fromJson(message.getPayload());
                            var info = new fm.liveswitch.ClientInfo(this.getUserId(), this.getUserAlias(), this.getDeviceId(), this.getDeviceAlias(), this.getId(), this.getTag(), this.getRoles());
                            var info2 = new fm.liveswitch.ClientInfo(this.getUserId(), fm.liveswitch.StringExtensions.nullCoalesce(clientConfig.getUserAlias(), this.getUserAlias()), this.getDeviceId(), fm.liveswitch.StringExtensions.nullCoalesce(clientConfig.getDeviceAlias(), this.getDeviceAlias()), this.getId(), fm.liveswitch.StringExtensions.nullCoalesce(clientConfig.getTag(), this.getTag()), clientConfig.getRoles() || this.getRoles());
                            this.__userAlias = info2.getUserAlias();
                            this.__deviceAlias = info2.getDeviceAlias();
                            this.__tag = info2.getTag();
                            this.__roles = info2.getRoles();
                            this.__region = info2.getRegion();
                            for (var _i = 0, _a = this.getChannels(); _i < _a.length; _i++) {
                                var channel = _a[_i];
                                channel.updateClientConfig(clientConfig);
                            }
                            var onRemoteUpdate = this._onRemoteUpdate;
                            if ((!fm.liveswitch.Global.equals(onRemoteUpdate, null))) {
                                onRemoteUpdate(info, info2);
                            }
                        }
                        else {
                            fm.liveswitch.Client.fm_liveswitch_Client___log.error(this.getId(), fm.liveswitch.StringExtensions.concat("Unexpected message: ", message.toJson()));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype.receive = function (message) {
                if (arguments.length == 1) {
                    try {
                        if (fm.liveswitch.Client.fm_liveswitch_Client___log.getIsDebugEnabled()) {
                            var str = void 0;
                            if ((fm.liveswitch.Global.equals(message.getPayload(), null))) {
                                str = fm.liveswitch.StringExtensions.format("Receiving {0} message for channel {1}.", message.getType(), message.getChannelId());
                            }
                            else {
                                str = fm.liveswitch.StringExtensions.format("Receiving {0} message for channel {1}: {2}", message.getType(), message.getChannelId(), message.getPayload());
                            }
                            fm.liveswitch.Client.fm_liveswitch_Client___log.debug(this.getId(), str);
                        }
                        this.processMessage(message);
                    }
                    catch (exception) {
                        fm.liveswitch.Client.fm_liveswitch_Client___log.error(this.getId(), "Could not process message.", exception);
                    }
                    finally {
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Registers with the signalling server.
            @param token The auth token.
            @return
                        A future with an array of initial channels as instructed by the auth token.
                
            */
            Client.prototype.register = function (token) {
                if (arguments.length == 1) {
                    var promise = new fm.liveswitch.Promise();
                    var token2 = fm.liveswitch.Token.parse(token);
                    if ((fm.liveswitch.Global.equals(token2, null))) {
                        promise.reject(new fm.liveswitch.Exception("Could not parse token."));
                        return promise;
                    }
                    var channelClaims = token2.getChannelClaims();
                    if ((!fm.liveswitch.Global.equals(channelClaims, null))) {
                        for (var _i = 0, channelClaims_1 = channelClaims; _i < channelClaims_1.length; _i++) {
                            var claim = channelClaims_1[_i];
                            if (fm.liveswitch.StringExtensions.isNullOrEmpty(claim.getId())) {
                                promise.reject(new fm.liveswitch.Exception("Token channel claim is missing ID."));
                                return promise;
                            }
                        }
                    }
                    this.doRegister(promise, token, fm.liveswitch.ManagedStopwatch.getTimestamp());
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype.removeChannel = function (channelId) {
                if (arguments.length == 1) {
                    var channel = null;
                    var _var0 = new fm.liveswitch.Holder(channel);
                    var _var1 = this.__channels.tryRemove(channelId, _var0);
                    channel = _var0.getValue();
                    if (_var1) {
                        channel.leave();
                        return channel;
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised whenever an underlying HTTP request has been created and is about to be transferred to the server. This is a good place to add headers/cookies. For WebSocket streams, this will fire only once for the initial HTTP-based handshake.
            */
            Client.prototype.removeOnHttpRequestCreated = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onHttpRequestCreated, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised whenever an underlying HTTP response has been received and is about to be processed by the client. This is a good place to read headers/cookies. For WebSocket streams, this will fire only once for the initial HTTP-based handshake.
            */
            Client.prototype.removeOnHttpResponseReceived = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onHttpResponseReceived, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the the client's config on the server has changed.
            */
            Client.prototype.removeOnRemoteUpdate = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onRemoteUpdate, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the state changes.
            */
            Client.prototype.removeOnStateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onStateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype.rolesAreEquivalent = function (roles1, roles2) {
                if (arguments.length == 2) {
                    if (((!fm.liveswitch.Global.equals(roles1, null)) || (!fm.liveswitch.Global.equals(roles2, null)))) {
                        if (((fm.liveswitch.Global.equals(roles1, null)) || (fm.liveswitch.Global.equals(roles2, null)))) {
                            return false;
                        }
                        if ((!fm.liveswitch.Global.equals(roles1.length, roles2.length))) {
                            return false;
                        }
                        for (var i = 0; (i < roles1.length); i++) {
                            if ((!fm.liveswitch.Global.equals(roles1[i], roles2[i]))) {
                                return false;
                            }
                        }
                    }
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype.send = function (message) {
                if (arguments.length == 1) {
                    try {
                        message.setApplicationId(this.getApplicationId());
                        message.setUserId(this.getUserId());
                        message.setDeviceId(this.getDeviceId());
                        message.setClientId(this.getId());
                        if (fm.liveswitch.Client.fm_liveswitch_Client___log.getIsDebugEnabled()) {
                            var str = void 0;
                            if ((fm.liveswitch.Global.equals(message.getPayload(), null))) {
                                str = fm.liveswitch.StringExtensions.format("Sending {0} message.", message.getType());
                            }
                            else {
                                str = fm.liveswitch.StringExtensions.format("Sending {0} message: {1}", message.getType(), message.getPayload());
                            }
                            var flag = false;
                            if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getEvent()))) {
                                flag = true;
                            }
                            if (flag) {
                                fm.liveswitch.Client.fm_liveswitch_Client___log.verbose(this.getId(), str);
                            }
                            else {
                                fm.liveswitch.Client.fm_liveswitch_Client___log.debug(this.getId(), str);
                            }
                        }
                        return this.__sendQueue.send(message);
                    }
                    catch (exception) {
                        var promise = new fm.liveswitch.Promise();
                        promise.reject(exception);
                        return promise;
                    }
                    finally {
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype.setApplicationId = function (value) {
                if (arguments.length == 1) {
                    this._applicationId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether to unregister automatically when the page unloads.
            */
            Client.prototype.setAutoUnregister = function (value) {
                if (arguments.length == 1) {
                    this.__gatewayClient.setAutoDisconnect(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the device alias. Cannot be set after registration, use the 'Update' method instead.
            */
            Client.prototype.setDeviceAlias = function (value) {
                if (arguments.length == 1) {
                    if (this.__registered) {
                        throw new fm.liveswitch.Exception("Please use the 'Update' method to update this property after registration.");
                    }
                    this.__deviceAlias = value;
                    for (var _i = 0, _a = this.getChannels(); _i < _a.length; _i++) {
                        var channel = _a[_i];
                        var clientConfig = new fm.liveswitch.ClientConfig();
                        clientConfig.setDeviceAlias(value);
                        channel.updateClientConfig(clientConfig);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype.setDeviceId = function (value) {
                if (arguments.length == 1) {
                    this._deviceId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a value indicating whether to disable the cross-origin resource sharing (CORS) transport.
            */
            Client.prototype.setDisableCors = function (value) {
                if (arguments.length == 1) {
                    this.__gatewayClient.setDisableCors(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a value indicating whether to disable the JSON-P transport.
            */
            Client.prototype.setDisableJsonp = function (value) {
                if (arguments.length == 1) {
                    this.__gatewayClient.setDisableJsonp(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a value indicating whether to disable the postMessage transport.
            */
            Client.prototype.setDisablePostMessage = function (value) {
                if (arguments.length == 1) {
                    this.__gatewayClient.setDisablePostMessage(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether to disable WebSocket protocol support and use long-polling, even if the server is capable of accepting WebSocket requests.
            */
            Client.prototype.setDisableWebSockets = function (value) {
                if (arguments.length == 1) {
                    this.__gatewayClient.setDisableWebSockets(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the external client identifier.
            */
            Client.prototype.setExternalId = function (value) {
                if (arguments.length == 1) {
                    this._externalId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a value indicating whether to force the JSON-P transport.
            */
            Client.prototype.setForceJsonp = function (value) {
                if (arguments.length == 1) {
                    this.__gatewayClient.setForceJsonp(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype.setGatewayUrl = function (value) {
                if (arguments.length == 1) {
                    this._gatewayUrl = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype.setId = function (value) {
                if (arguments.length == 1) {
                    this._id = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the maximum number of retries allowed for a standard request.
            */
            Client.prototype.setRequestMaxRetries = function (value) {
                if (arguments.length == 1) {
                    this.__gatewayClient.setRequestMaxRetries(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of milliseconds to wait for a standard request to return a response before it is aborted and another request is attempted. Defaults to 15000 (15 seconds).
            */
            Client.prototype.setRequestTimeout = function (value) {
                if (arguments.length == 1) {
                    this.__gatewayClient.setRequestTimeout(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the tag. Cannot be set after registration, use the 'Update' method instead.
            */
            Client.prototype.setTag = function (value) {
                if (arguments.length == 1) {
                    if (this.__registered) {
                        throw new fm.liveswitch.Exception("Please use the 'Update' method to update this property after registration.");
                    }
                    this.__tag = value;
                    for (var _i = 0, _a = this.getChannels(); _i < _a.length; _i++) {
                        var channel = _a[_i];
                        var clientConfig = new fm.liveswitch.ClientConfig();
                        clientConfig.setTag(value);
                        channel.updateClientConfig(clientConfig);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the user alias. Cannot be set after registration, use the 'Update' method instead.
            */
            Client.prototype.setUserAlias = function (value) {
                if (arguments.length == 1) {
                    if (this.__registered) {
                        throw new fm.liveswitch.Exception("Please use the 'Update' method to update this property after registration.");
                    }
                    this.__userAlias = value;
                    for (var _i = 0, _a = this.getChannels(); _i < _a.length; _i++) {
                        var channel = _a[_i];
                        var clientConfig = new fm.liveswitch.ClientConfig();
                        clientConfig.setUserAlias(value);
                        channel.updateClientConfig(clientConfig);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype.setUserId = function (value) {
                if (arguments.length == 1) {
                    this._userId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Unregisters with the signalling server.
            @return
                        A future that resolves when successfully unregistered.
                
            */
            Client.prototype.unregister = function () {
                if (arguments.length == 0) {
                    var promise = new fm.liveswitch.Promise();
                    this.doUnregister(promise, fm.liveswitch.ManagedStopwatch.getTimestamp());
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Updates your client configuration.
            @param clientConfig The new client configuration.
            */
            Client.prototype.update = function (clientConfig) {
                var _this = this;
                if (arguments.length == 1) {
                    var resolveFunction = null;
                    var rejectAction = null;
                    if (!this.rolesAreEquivalent(clientConfig.getRoles(), this.getRoles())) {
                        return fm.liveswitch.PromiseBase.rejectNow(new fm.liveswitch.Exception("For security reasons, roles cannot be updated from the SDK. Roles can only be updated with the REST API."));
                    }
                    var flag = false;
                    if ((!fm.liveswitch.Global.equals(clientConfig.getUserAlias(), this.getUserAlias()))) {
                        flag = true;
                    }
                    if ((!fm.liveswitch.Global.equals(clientConfig.getDeviceAlias(), this.getDeviceAlias()))) {
                        flag = true;
                    }
                    if ((!fm.liveswitch.Global.equals(clientConfig.getTag(), this.getTag()))) {
                        flag = true;
                    }
                    if (flag) {
                        if ((fm.liveswitch.Global.equals(resolveFunction, null))) {
                            resolveFunction = function (msg) {
                                _this.__userAlias = clientConfig.getUserAlias();
                                _this.__deviceAlias = clientConfig.getDeviceAlias();
                                _this.__tag = clientConfig.getTag();
                                for (var _i = 0, _a = _this.getChannels(); _i < _a.length; _i++) {
                                    var channel = _a[_i];
                                    channel.updateClientConfig(clientConfig);
                                }
                                return fm.liveswitch.PromiseBase.resolveNow(null);
                            };
                        }
                        if ((fm.liveswitch.Global.equals(rejectAction, null))) {
                            rejectAction = function (ex) {
                                fm.liveswitch.Client.fm_liveswitch_Client___log.error(_this.getId(), "Could not send update message.", ex);
                            };
                        }
                        return this.send(fm.liveswitch.Message.createUpdateMessage(clientConfig.toJson())).then(resolveFunction, rejectAction);
                    }
                    return fm.liveswitch.PromiseBase.resolveNow(null);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.prototype.validateJoinToken = function (token, channelClaim, message) {
                if (arguments.length == 3) {
                    var token2 = fm.liveswitch.Token.parse(token);
                    if ((fm.liveswitch.Global.equals(token2, null))) {
                        channelClaim.setValue(null);
                        message.setValue("Could not parse token.");
                        return false;
                    }
                    channelClaim.setValue(token2.getChannelClaim());
                    if ((fm.liveswitch.Global.equals(channelClaim.getValue(), null))) {
                        message.setValue("Token is missing channel claim.");
                        return false;
                    }
                    if (fm.liveswitch.StringExtensions.isNullOrEmpty(channelClaim.getValue().getId())) {
                        message.setValue("Token channel claim is missing ID.");
                        return false;
                    }
                    message.setValue(null);
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Client.fmliveswitchClientInitialize = function () {
                if (!fm.liveswitch.Client.__fmliveswitchClientInitialized && !fm.liveswitch.Client.__fmliveswitchClientInitializing) {
                    fm.liveswitch.Client.__fmliveswitchClientInitializing = true;
                    fm.liveswitch.Client.fm_liveswitch_Client___log = fm.liveswitch.Log.getLogger(new fm.liveswitch.Type('[fm.liveswitch.Client]'));
                    fm.liveswitch.Client.__fmliveswitchClientInitialized = true;
                    fm.liveswitch.Client.__fmliveswitchClientInitializing = false;
                }
            };
            /** @hidden */
            Client.__fmliveswitchClientInitialized = false;
            /** @hidden */
            Client.__fmliveswitchClientInitializing = false;
            return Client;
        }(fm.liveswitch.Dynamic));
        liveswitch.Client = Client;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var ConnectionFactory = /** @class */ (function () {
            function ConnectionFactory() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            ConnectionFactory.prototype.getTypeString = function () {
                return '[fm.liveswitch.ConnectionFactory]';
            };
            ConnectionFactory.prototype.createMcuConnection = function (sharedLock, applicationId, channelId, userId, deviceId, clientId, send, audioStream, videoStream, dataStream, mediaId) {
                if (arguments.length == 11) {
                    return new fm.liveswitch.McuConnection(sharedLock, applicationId, channelId, userId, deviceId, clientId, send, audioStream, videoStream, dataStream, mediaId);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ConnectionFactory.prototype.createPeerConnection = function () {
                if (arguments.length == 11 && (fm.liveswitch.Util.isNullOrUndefined(arguments[7]) || fm.liveswitch.Util.isObjectType(arguments[7], '[fm.liveswitch.PeerConnectionOffer]'))) {
                    var sharedLock = arguments[0];
                    var applicationId = arguments[1];
                    var channelId = arguments[2];
                    var userId = arguments[3];
                    var deviceId = arguments[4];
                    var clientId = arguments[5];
                    var send = arguments[6];
                    var peerConnectionOffer = arguments[7];
                    var audioStream = arguments[8];
                    var videoStream = arguments[9];
                    var dataStream = arguments[10];
                    return new fm.liveswitch.PeerConnection(sharedLock, applicationId, channelId, userId, deviceId, clientId, send, peerConnectionOffer, audioStream, videoStream, dataStream);
                }
                else if (arguments.length == 11 && (fm.liveswitch.Util.isNullOrUndefined(arguments[7]) || fm.liveswitch.Util.isObjectType(arguments[7], '[fm.liveswitch.ClientInfo]'))) {
                    var sharedLock = arguments[0];
                    var applicationId = arguments[1];
                    var channelId = arguments[2];
                    var userId = arguments[3];
                    var deviceId = arguments[4];
                    var clientId = arguments[5];
                    var send = arguments[6];
                    var remoteClientInfo = arguments[7];
                    var audioStream = arguments[8];
                    var videoStream = arguments[9];
                    var dataStream = arguments[10];
                    return new fm.liveswitch.PeerConnection(sharedLock, applicationId, channelId, userId, deviceId, clientId, send, remoteClientInfo, audioStream, videoStream, dataStream);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ConnectionFactory.prototype.createSfuDownstreamConnection = function () {
                if (arguments.length == 11 && (fm.liveswitch.Util.isNullOrUndefined(arguments[7]) || fm.liveswitch.Util.isObjectType(arguments[7], '[fm.liveswitch.ConnectionInfo]'))) {
                    var sharedLock = arguments[0];
                    var applicationId = arguments[1];
                    var channelId = arguments[2];
                    var userId = arguments[3];
                    var deviceId = arguments[4];
                    var clientId = arguments[5];
                    var send = arguments[6];
                    var remoteConnectionInfo = arguments[7];
                    var audioStream = arguments[8];
                    var videoStream = arguments[9];
                    var dataStream = arguments[10];
                    return new fm.liveswitch.SfuDownstreamConnection(sharedLock, applicationId, channelId, userId, deviceId, clientId, send, remoteConnectionInfo, audioStream, videoStream, dataStream);
                }
                else if (arguments.length == 11 && (fm.liveswitch.Util.isNullOrUndefined(arguments[7]) || fm.liveswitch.Util.isString(arguments[7]))) {
                    var sharedLock = arguments[0];
                    var applicationId = arguments[1];
                    var channelId = arguments[2];
                    var userId = arguments[3];
                    var deviceId = arguments[4];
                    var clientId = arguments[5];
                    var send = arguments[6];
                    var remoteMediaId = arguments[7];
                    var audioStream = arguments[8];
                    var videoStream = arguments[9];
                    var dataStream = arguments[10];
                    return new fm.liveswitch.SfuDownstreamConnection(sharedLock, applicationId, channelId, userId, deviceId, clientId, send, remoteMediaId, audioStream, videoStream, dataStream);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ConnectionFactory.prototype.createSfuUpstreamConnection = function (sharedLock, applicationId, channelId, userId, deviceId, clientId, send, audioStream, videoStream, dataStream, mediaId) {
                if (arguments.length == 11) {
                    return new fm.liveswitch.SfuUpstreamConnection(sharedLock, applicationId, channelId, userId, deviceId, clientId, send, audioStream, videoStream, dataStream, mediaId);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ConnectionFactory;
        }());
        liveswitch.ConnectionFactory = ConnectionFactory;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        An invitation to join a channel.
        */
        var Invitation = /** @class */ (function () {
            /** @hidden */
            function Invitation(channel, userId, protocol) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 3) {
                    var channel_1 = __arguments[0];
                    var userId_13 = __arguments[1];
                    var protocol_1 = __arguments[2];
                    //super();
                    this.fmliveswitchInvitationInit();
                    this.__lock = new Object();
                    this.__channel = channel_1;
                    this.setUserId(userId_13);
                    this.setProtocol(protocol_1);
                    this.setState(fm.liveswitch.InvitationState.Pending);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Invitation.prototype.getTypeString = function () {
                return '[fm.liveswitch.Invitation]';
            };
            Invitation.prototype.fmliveswitchInvitationInit = function () {
                var _this = this;
                this.__onStateChanging = [];
                this._onStateChanging = function (p0) { for (var _i = 0, _a = _this.__onStateChanging; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
            };
            /** @hidden */
            Invitation.getInviteKey = function (channelId, userId, protocol) {
                if (arguments.length == 3) {
                    return fm.liveswitch.StringExtensions.format("{0}|{1}|{2}", channelId, userId, protocol);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when the state changes.
            */
            Invitation.prototype.addOnStateChanging = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onStateChanging, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Attempts to cancel the invitation. May fail if the invitation is acted upon before being canceled.
            @return A promise that resolves if the cancel succeeds.
            */
            Invitation.prototype.cancel = function () {
                var _this = this;
                if (arguments.length == 0) {
                    var rejectAction = null;
                    if (((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.InvitationState.Pending)) || (fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.InvitationState.Proceeding)))) {
                        this.setState(fm.liveswitch.InvitationState.Cancelling);
                        this.onStateChange(this, this._onStateChanging);
                        this.__cancelPromise = new fm.liveswitch.Promise();
                        var message = fm.liveswitch.Message.createCancelInviteMessage(this.getUserId(), this.getProtocol());
                        if ((fm.liveswitch.Global.equals(rejectAction, null))) {
                            rejectAction = function (ex) {
                                _this.__cancelPromise.reject(ex);
                            };
                        }
                        this.__channel.send(message).fail(rejectAction);
                        return this.__cancelPromise;
                    }
                    if ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.InvitationState.Cancelling))) {
                        return fm.liveswitch.PromiseBase.rejectNow(new fm.liveswitch.Exception("Already cancelling."));
                    }
                    return fm.liveswitch.PromiseBase.rejectNow(new fm.liveswitch.Exception("The Invitation is in a state where it cannot be canceled."));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the channel id that this invitation is for.
            */
            Invitation.prototype.getChannelId = function () {
                if (arguments.length == 0) {
                    return this.__channel.getId();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the key for this invitation.
            */
            Invitation.prototype.getInviteKey = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Invitation.getInviteKey(this.getChannelId(), this.getUserId(), this.getProtocol());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the protocol that this user was invited on.
            */
            Invitation.prototype.getProtocol = function () {
                if (arguments.length == 0) {
                    return this._protocol;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the reason for a state if available.
            */
            Invitation.prototype.getReason = function () {
                if (arguments.length == 0) {
                    return this._reason;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the current state of the invitation. See InviteFeedbackState for possible values.
            */
            Invitation.prototype.getState = function () {
                if (arguments.length == 0) {
                    return this._state;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the user id of the user being invited.
            */
            Invitation.prototype.getUserId = function () {
                if (arguments.length == 0) {
                    return this._userId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Invitation.prototype.onStateChange = function (invitation, handler) {
                if (arguments.length == 2) {
                    var action = null;
                    if ((!fm.liveswitch.Global.equals(handler, null))) {
                        if ((fm.liveswitch.Global.equals(action, null))) {
                            action = function () {
                                handler(invitation);
                            };
                        }
                        fm.liveswitch.ManagedThread.dispatch(action);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Invitation.prototype.processFeedback = function (feedback) {
                if (arguments.length == 1) {
                    this.setState(feedback.getState());
                    this.setReason(feedback.getReason());
                    if ((!fm.liveswitch.Global.equals(this.__cancelPromise, null))) {
                        if ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.InvitationState.Cancelled))) {
                            this.__cancelPromise.resolve(null);
                        }
                        else {
                            if ((!fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.InvitationState.Cancelling))) {
                                this.__cancelPromise.reject(new fm.liveswitch.Exception("The invitation was acted upon before canceled."));
                            }
                        }
                    }
                    this.onStateChange(this, this._onStateChanging);
                    return ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.InvitationState.Proceeding)) || (fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.InvitationState.Cancelling)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the state changes.
            */
            Invitation.prototype.removeOnStateChanging = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onStateChanging, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Invitation.prototype.setProtocol = function (value) {
                if (arguments.length == 1) {
                    this._protocol = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Invitation.prototype.setReason = function (value) {
                if (arguments.length == 1) {
                    this._reason = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Invitation.prototype.setState = function (value) {
                if (arguments.length == 1) {
                    this._state = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Invitation.prototype.setUserId = function (value) {
                if (arguments.length == 1) {
                    this._userId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Invitation;
        }());
        liveswitch.Invitation = Invitation;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Collection.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A collection of connections.
        */
        var ManagedConnectionCollection = /** @class */ (function (_super) {
            __extends(ManagedConnectionCollection, _super);
            function ManagedConnectionCollection() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.__lookup = {};
                    _this.__remoteLookup = {};
                    _this.__lookupLock = new Object();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            ManagedConnectionCollection.prototype.getTypeString = function () {
                return '[fm.liveswitch.ManagedConnectionCollection]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Invoked when an element is added to the collection.
            @param value The value.
            */
            ManagedConnectionCollection.prototype.addSuccess = function (value) {
                if (arguments.length == 1) {
                    _super.prototype.addSuccess.call(this, value);
                    this.__lookup[value.getId()] = value;
                    if ((!fm.liveswitch.Global.equals(value.getRemoteConnectionId(), null))) {
                        this.__remoteLookup[value.getRemoteConnectionId()] = value;
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates an array from a list.
            @param list The list.
            */
            ManagedConnectionCollection.prototype.arrayFromList = function (list) {
                if (arguments.length == 1) {
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a collection.
            */
            ManagedConnectionCollection.prototype.createCollection = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.ManagedConnectionCollection();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a connection by ID.
            @param idValue The identifier.
            @return The connection, or `null` if the connection does not exist.
            */
            ManagedConnectionCollection.prototype.getById = function (idValue) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(idValue, null))) {
                        var connection = null;
                        var _var0 = new fm.liveswitch.Holder(connection);
                        var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this.__lookup, idValue, _var0);
                        connection = _var0.getValue();
                        if (_var1) {
                            return connection;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a connection by remote ID.
            @param idValue The identifier.
            @return The connection, or `null` if the connection does not exist.
            */
            ManagedConnectionCollection.prototype.getByRemoteId = function (idValue) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(idValue, null))) {
                        var connection = null;
                        var _var0 = new fm.liveswitch.Holder(connection);
                        var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this.__remoteLookup, idValue, _var0);
                        connection = _var0.getValue();
                        if (_var1) {
                            return connection;
                        }
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Invoked when an element is removed from the collection.
            @param value The value.
            */
            ManagedConnectionCollection.prototype.removeSuccess = function (value) {
                if (arguments.length == 1) {
                    _super.prototype.removeSuccess.call(this, value);
                    fm.liveswitch.HashExtensions.remove(this.__lookup, value.getId());
                    if ((!fm.liveswitch.Global.equals(value.getRemoteConnectionId(), null))) {
                        fm.liveswitch.HashExtensions.remove(this.__remoteLookup, value.getRemoteConnectionId());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to get a connection by ID.
            @param idValue The identifier.
            @param connection The connection.
            @return The connection, or `null` if the connection does not exist.
            */
            ManagedConnectionCollection.prototype.tryGetById = function (idValue, connection) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(idValue, null))) {
                        connection.setValue(null);
                        return false;
                    }
                    var _var0 = fm.liveswitch.HashExtensions.tryGetValue(this.__lookup, idValue, connection);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Tries to get a connection by remote ID.
            @param idValue The identifier.
            @param connection The connection.
            @return The connection, or `null` if the connection does not exist.
            */
            ManagedConnectionCollection.prototype.tryGetByRemoteId = function (idValue, connection) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(idValue, null))) {
                        connection.setValue(null);
                        return false;
                    }
                    var _var0 = fm.liveswitch.HashExtensions.tryGetValue(this.__remoteLookup, idValue, connection);
                    return _var0;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ManagedConnectionCollection;
        }(fm.liveswitch.Collection));
        liveswitch.ManagedConnectionCollection = ManagedConnectionCollection;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A managed connection.
        */
        var ManagedConnection = /** @class */ (function (_super) {
            __extends(ManagedConnection, _super);
            /** @hidden */
            function ManagedConnection(sharedLock, applicationId, channelId, userId, deviceId, clientId, doSend, type, audioStream, videoStream, dataStream, mediaId) {
                var _this = this;
                fm.liveswitch.ManagedConnection.fmliveswitchManagedConnectionInitialize();
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 12) {
                    var sharedLock_3 = __arguments[0];
                    var applicationId_14 = __arguments[1];
                    var channelId_1 = __arguments[2];
                    var userId_14 = __arguments[3];
                    var deviceId_11 = __arguments[4];
                    var clientId_8 = __arguments[5];
                    var doSend_2 = __arguments[6];
                    var type_8 = __arguments[7];
                    var audioStream_1 = __arguments[8];
                    var videoStream_1 = __arguments[9];
                    var dataStream_1 = __arguments[10];
                    var mediaId_1 = __arguments[11];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchManagedConnectionInit();
                    _this.__doSend = null;
                    _this.__lastStatsLock = new Object();
                    _this._openPromise = null;
                    _this.__messageQueue = new fm.liveswitch.DispatchQueue(_this.processQueuedMessage.bind(_this));
                    _this.__lock = sharedLock_3;
                    _this.setApplicationId(applicationId_14);
                    _this.setChannelId(channelId_1);
                    _this.setUserId(userId_14);
                    _this.setDeviceId(deviceId_11);
                    _this.setClientId(clientId_8);
                    _this.setMediaId(mediaId_1);
                    _this.__doSend = doSend_2;
                    _this.setType(type_8);
                    _this.setAudioStream(audioStream_1);
                    _this.setVideoStream(videoStream_1);
                    _this.setDataStream(dataStream_1);
                    if ((!fm.liveswitch.Global.equals(audioStream_1, null))) {
                        audioStream_1.addOnDiscardOutboundDtmfTones(_this.audioStream_OnDiscardOutboundDtmfTones.bind(_this));
                        audioStream_1.addOnDiscardBitrateRequest(_this.mediaStream_OnDiscardBitrateRequest.bind(_this));
                        audioStream_1.addOnDiscardBitrateNotification(_this.mediaStream_OnDiscardBitrateNotification.bind(_this));
                    }
                    if ((!fm.liveswitch.Global.equals(videoStream_1, null))) {
                        videoStream_1.addOnDiscardKeyFrameRequest(_this.videoStream_OnDiscardKeyFrameRequest.bind(_this));
                        videoStream_1.addOnDiscardBitrateRequest(_this.mediaStream_OnDiscardBitrateRequest.bind(_this));
                        videoStream_1.addOnDiscardBitrateNotification(_this.mediaStream_OnDiscardBitrateNotification.bind(_this));
                    }
                    _this.setDisableAutomaticIceServers(false);
                    _this.setStatsInterval(fm.liveswitch.ManagedConnection.getDefaultStatsInterval());
                    _this.setInternalConnection(fm.liveswitch.ConnectionUtility.createConnection(_this.__lock, _this.getType(), _this.getAudioStream(), _this.getVideoStream(), _this.getDataStream()));
                    _this.getInternalConnection().setLegacyTimeout(true);
                    _this.getInternalConnection().addOnStateChange(_this.internalConnection_OnStateChange.bind(_this));
                    _this.getInternalConnection().addOnSignallingStateChange(_this.internalConnection_OnSignallingStateChange.bind(_this));
                    _this.getInternalConnection().addOnIceConnectionStateChange(_this.internalConnection_OnIceConnectionStateChange.bind(_this));
                    _this.getInternalConnection().addOnGatheringStateChange(_this.internalConnection_OnGatheringStateChange.bind(_this));
                    _this.getInternalConnection().addOnLocalDescription(_this.internalConnection_OnLocalDescription.bind(_this));
                    _this.getInternalConnection().addOnRemoteDescription(_this.internalConnection_OnRemoteDescription.bind(_this));
                    _this.getInternalConnection().addOnLocalCandidate(_this.internalConnection_OnLocalCandidate.bind(_this));
                    _this.getInternalConnection().addOnRemoteCandidate(_this.internalConnection_OnRemoteCandidate.bind(_this));
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            ManagedConnection.prototype.getTypeString = function () {
                return '[fm.liveswitch.ManagedConnection]' + ',' + _super.prototype.getTypeString.call(this);
            };
            ManagedConnection.prototype.fmliveswitchManagedConnectionInit = function () {
                var _this = this;
                this.__onGatheringStateChange = [];
                this.__onIceConnectionStateChange = [];
                this.__onLocalCandidate = [];
                this.__onLocalDescription = [];
                this.__onRemoteAudioEncodingSwitch = [];
                this.__onRemoteCandidate = [];
                this.__onRemoteDescription = [];
                this.__onRemoteUpdate = [];
                this.__onRemoteVideoEncodingSwitch = [];
                this.__onSignallingStateChange = [];
                this.__onStateChange = [];
                this.__onStats = [];
                this.__sendStatsCancelled = false;
                this._disableAutomaticIceServers = false;
                this._onGatheringStateChange = function (p0) { for (var _i = 0, _a = _this.__onGatheringStateChange; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
                this._onIceConnectionStateChange = function (p0) { for (var _i = 0, _a = _this.__onIceConnectionStateChange; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
                this._onLocalCandidate = function (p0, p1) { for (var _i = 0, _a = _this.__onLocalCandidate; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0, p1);
                } };
                this._onLocalDescription = function (p0, p1) { for (var _i = 0, _a = _this.__onLocalDescription; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0, p1);
                } };
                this._onRemoteAudioEncodingSwitch = function (p0, p1) { for (var _i = 0, _a = _this.__onRemoteAudioEncodingSwitch; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0, p1);
                } };
                this._onRemoteCandidate = function (p0, p1) { for (var _i = 0, _a = _this.__onRemoteCandidate; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0, p1);
                } };
                this._onRemoteDescription = function (p0, p1) { for (var _i = 0, _a = _this.__onRemoteDescription; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0, p1);
                } };
                this._onRemoteUpdate = function (p0, p1) { for (var _i = 0, _a = _this.__onRemoteUpdate; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0, p1);
                } };
                this._onRemoteVideoEncodingSwitch = function (p0, p1) { for (var _i = 0, _a = _this.__onRemoteVideoEncodingSwitch; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0, p1);
                } };
                this._onSignallingStateChange = function (p0) { for (var _i = 0, _a = _this.__onSignallingStateChange; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
                this._onStateChange = function (p0) { for (var _i = 0, _a = _this.__onStateChange; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0);
                } };
                this._onStats = function () { for (var _i = 0, _a = _this.__onStats; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action();
                } };
                this._remoteAudioMuted = false;
                this._remoteClosed = false;
                this._remoteFailed = false;
                this._remoteRejected = false;
                this._remoteVideoMuted = false;
                this._statsInterval = 0;
            };
            /**
            Gets the default stats interval in milliseconds. The initial value is 10,000 (10 seconds).
            */
            ManagedConnection.getDefaultStatsInterval = function () {
                fm.liveswitch.ManagedConnection.fmliveswitchManagedConnectionInitialize();
                if (arguments.length == 0) {
                    return fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection__defaultStatsInterval;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the default stats interval in milliseconds. The initial value is 10,000 (10 seconds).
            */
            ManagedConnection.setDefaultStatsInterval = function (value) {
                fm.liveswitch.ManagedConnection.fmliveswitchManagedConnectionInitialize();
                if (arguments.length == 1) {
                    fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection__defaultStatsInterval = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when the ICE gathering state changes. Parameters: - connection - the connection
            */
            ManagedConnection.prototype.addOnGatheringStateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onGatheringStateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when the ICE connection state changes. Parameters: - connection - the connection
            */
            ManagedConnection.prototype.addOnIceConnectionStateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onIceConnectionStateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when a local candidate is ready. Parameters: - connection - the connection - candidate - the local candidate
            */
            ManagedConnection.prototype.addOnLocalCandidate = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onLocalCandidate, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when the local description is ready. Parameters: - connection - the connection - description - the local description
            */
            ManagedConnection.prototype.addOnLocalDescription = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onLocalDescription, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when the remote audio encoding is switched by the server.
            */
            ManagedConnection.prototype.addOnRemoteAudioEncodingSwitch = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onRemoteAudioEncodingSwitch, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when a remote candidate is ready. Parameters: - connection - the connection - candidate - the remote candidate
            */
            ManagedConnection.prototype.addOnRemoteCandidate = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onRemoteCandidate, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when the remote description is ready. Parameters: - connection - the connection - description - the remote description
            */
            ManagedConnection.prototype.addOnRemoteDescription = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onRemoteDescription, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when a remote connection has been updated.
            */
            ManagedConnection.prototype.addOnRemoteUpdate = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onRemoteUpdate, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when the remote video encoding is switched by the server.
            */
            ManagedConnection.prototype.addOnRemoteVideoEncodingSwitch = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onRemoteVideoEncodingSwitch, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when the signalling state changes. Parameters: - connection - the connection
            */
            ManagedConnection.prototype.addOnSignallingStateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onSignallingStateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when the connection state changes. Parameters: - connection - the connection
            */
            ManagedConnection.prototype.addOnStateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onStateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.addOnStats = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onStats, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.audioStream_OnDiscardOutboundDtmfTones = function (dtmfTones) {
                if (arguments.length == 1) {
                    this.send(fm.liveswitch.Message.createDtmfTonesMessage(dtmfTones));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.cancelSendStats = function () {
                if (arguments.length == 0) {
                    this.__sendStatsCancelled = true;
                    if ((!fm.liveswitch.Global.equals(this.__sendStatsTimer, null))) {
                        this.__sendStatsTimer.stop();
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Closes the connection.
            */
            ManagedConnection.prototype.close = function () {
                if (arguments.length == 0) {
                    var promise = new fm.liveswitch.Promise();
                    this.doClose(promise);
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.createCandidateMessage = function (candidate) {
                if (arguments.length == 1) {
                    return this.doCreateCandidateMessage(candidate);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.createCloseMessage = function () {
                if (arguments.length == 0) {
                    return this.doCreateCloseMessage();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.doClose = function (promise) {
                var _this = this;
                if (arguments.length == 1) {
                    var resolveAction = null;
                    var rejectAction = null;
                    try {
                        if (((((fm.liveswitch.Global.equals(this.getInternalConnection().getState(), fm.liveswitch.ConnectionState.Closing)) || (fm.liveswitch.Global.equals(this.getInternalConnection().getState(), fm.liveswitch.ConnectionState.Closed))) || (fm.liveswitch.Global.equals(this.getInternalConnection().getState(), fm.liveswitch.ConnectionState.Failing))) || (fm.liveswitch.Global.equals(this.getInternalConnection().getState(), fm.liveswitch.ConnectionState.Failed)))) {
                            this.__messageQueue.destroy();
                            promise.resolve(null);
                        }
                        else {
                            fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.debug(fm.liveswitch.StringExtensions.format("Closing connection with ID '{0}'.", this.getId()));
                            if (this.getInternalConnection().close()) {
                                if ((fm.liveswitch.Global.equals(resolveAction, null))) {
                                    resolveAction = function (response) {
                                        _this.__messageQueue.destroy();
                                        promise.resolve(null);
                                    };
                                }
                                if ((fm.liveswitch.Global.equals(rejectAction, null))) {
                                    rejectAction = function (ex) {
                                        fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.debug("Could not send close message.", ex);
                                        _this.__messageQueue.destroy();
                                        promise.resolve(null);
                                    };
                                }
                                this.send(this.createCloseMessage()).then(resolveAction, rejectAction);
                            }
                            else {
                                this.__messageQueue.destroy();
                                promise.resolve(null);
                            }
                        }
                    }
                    catch (exception) {
                        promise.reject(exception);
                    }
                    finally {
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates an update message.
            @param config The connection config.
            */
            ManagedConnection.prototype.doCreateUpdateMessage = function (config) {
                if (arguments.length == 1) {
                    return fm.liveswitch.Message.createUpdateMessage(config.toJson());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.doSelfNegotiate = function (answer, promise) {
                var _this = this;
                if (arguments.length == 2) {
                    this.getInternalConnection().createOffer().then(function (offer) {
                        _this.getInternalConnection().setLocalDescription(offer).then(function (localDescription) {
                            _this.getInternalConnection().setRemoteDescription(answer).then(function (remoteDescription) {
                                promise.resolve(null);
                            }, function (ex) {
                                promise.reject(ex);
                            });
                        }, function (ex) {
                            promise.reject(ex);
                        });
                    }, function (ex) {
                        promise.reject(ex);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.doSendConnectionEvent = function (promise, eventInfo) {
                var _this = this;
                if (arguments.length == 2) {
                    var resolveAction = null;
                    var rejectAction = null;
                    if ((fm.liveswitch.Global.equals(eventInfo.getType(), "connection.stats"))) {
                        if ((fm.liveswitch.Global.equals(resolveAction, null))) {
                            resolveAction = function (stats) {
                                eventInfo.getConnection().populateInfo(stats, _this.__lastStats, eventInfo.getType());
                                _this.__lastStats = stats;
                                var onStats = _this._onStats;
                                if ((!fm.liveswitch.Global.equals(onStats, null))) {
                                    onStats();
                                }
                                _this.sendConnectionEventMessage(promise, eventInfo);
                            };
                        }
                        if ((fm.liveswitch.Global.equals(rejectAction, null))) {
                            rejectAction = function (ex) {
                                promise.reject(ex);
                            };
                        }
                        this.getInternalConnection().getStats().then(resolveAction, rejectAction);
                    }
                    else {
                        this.sendConnectionEventMessage(promise, eventInfo);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.doUpdate = function (config, promise) {
                var _this = this;
                if (arguments.length == 2) {
                    var resolveAction = null;
                    var rejectAction = null;
                    if (((((!fm.liveswitch.Global.equals(this.getAudioStream(), null)) && (!fm.liveswitch.Global.equals(config.getAudioDirection(), this.getAudioDirection()))) && !this.isMediaDirectionAllowed(config.getAudioDirection())) || (((!fm.liveswitch.Global.equals(this.getVideoStream(), null)) && (!fm.liveswitch.Global.equals(config.getVideoDirection(), this.getVideoDirection()))) && !this.isMediaDirectionAllowed(config.getVideoDirection())))) {
                        throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("{0} connection {1} does not allow the '{2}' direction.", fm.liveswitch.StringExtensions.toUpper(this.getType()), this.getId(), config.getAudioDirection()));
                    }
                    var flag = false;
                    var flag2 = false;
                    if ((!fm.liveswitch.Global.equals(config.getTag(), this.getTag()))) {
                        flag = true;
                    }
                    if ((!fm.liveswitch.Global.equals(this.getAudioStream(), null))) {
                        if ((!fm.liveswitch.Global.equals(config.getLocalAudioMuted(), this.getAudioStream().getInputMuted()))) {
                            flag = true;
                        }
                        if ((!fm.liveswitch.Global.equals(config.getAudioDirection(), this.getAudioDirection()))) {
                            flag2 = true;
                        }
                        if ((!fm.liveswitch.Global.equals(config.getRemoteAudioEncoding(), this.getAudioStream().getRemoteEncoding()))) {
                            flag = true;
                        }
                        else {
                            config.setRemoteAudioEncoding(null);
                        }
                    }
                    if ((!fm.liveswitch.Global.equals(this.getVideoStream(), null))) {
                        if ((!fm.liveswitch.Global.equals(config.getLocalVideoMuted(), this.getVideoStream().getInputMuted()))) {
                            flag = true;
                        }
                        if ((!fm.liveswitch.Global.equals(config.getVideoDirection(), this.getVideoDirection()))) {
                            flag2 = true;
                        }
                        if ((!fm.liveswitch.Global.equals(config.getRemoteVideoEncoding(), this.getVideoStream().getRemoteEncoding()))) {
                            flag = true;
                        }
                        else {
                            config.setRemoteVideoEncoding(null);
                        }
                    }
                    if ((flag || flag2)) {
                        var future = null;
                        if (flag2) {
                            future = this.selfRenegotiate(fm.liveswitch.StreamDirectionHelper.directionFromString(config.getAudioDirection()), fm.liveswitch.StreamDirectionHelper.directionFromString(config.getVideoDirection()));
                        }
                        else {
                            future = fm.liveswitch.PromiseBase.resolveNow(null);
                        }
                        if ((fm.liveswitch.Global.equals(resolveAction, null))) {
                            resolveAction = function (r) {
                                _this.send(_this.doCreateUpdateMessage(config)).then(function (message) {
                                    _this.setTag(config.getTag());
                                    if ((!fm.liveswitch.Global.equals(_this.getAudioStream(), null))) {
                                        if ((!fm.liveswitch.Global.equals(config.getLocalAudioMuted(), _this.getAudioStream().getInputMuted()))) {
                                            _this.getAudioStream().setInputMuted(config.getLocalAudioMuted());
                                        }
                                        if ((!fm.liveswitch.Global.equals(config.getRemoteAudioEncoding(), _this.getAudioStream().getRemoteEncoding()))) {
                                            _this.getAudioStream().setRemoteEncoding(config.getRemoteAudioEncoding());
                                        }
                                    }
                                    if ((!fm.liveswitch.Global.equals(_this.getVideoStream(), null))) {
                                        if ((!fm.liveswitch.Global.equals(config.getLocalVideoMuted(), _this.getVideoStream().getInputMuted()))) {
                                            _this.getVideoStream().setInputMuted(config.getLocalVideoMuted());
                                        }
                                        if ((!fm.liveswitch.Global.equals(config.getRemoteVideoEncoding(), _this.getVideoStream().getRemoteEncoding()))) {
                                            _this.getVideoStream().setRemoteEncoding(config.getRemoteVideoEncoding());
                                        }
                                    }
                                    promise.resolve(null);
                                }, function (ex) {
                                    promise.reject(ex);
                                });
                            };
                        }
                        if ((fm.liveswitch.Global.equals(rejectAction, null))) {
                            rejectAction = function (ex) {
                                promise.reject(ex);
                            };
                        }
                        future.then(resolveAction, rejectAction);
                    }
                    else {
                        promise.resolve(null);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.doUpdateConnection = function (oldInfo, newInfo, promise) {
                var _this = this;
                if (arguments.length == 3) {
                    var future = void 0;
                    var flag = false;
                    if ((!fm.liveswitch.Global.equals(this.getRemoteAudioMuted(), newInfo.getLocalAudioMuted()))) {
                        fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.info(fm.liveswitch.StringExtensions.format("Remote connection {0} has {1} their audio stream.", this.getId(), (newInfo.getLocalAudioMuted() ? "muted" : "unmuted")));
                        this.setRemoteAudioMuted(newInfo.getLocalAudioMuted());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRemoteVideoMuted(), newInfo.getLocalVideoMuted()))) {
                        fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.info(fm.liveswitch.StringExtensions.format("Remote connection {0} has {1} their video stream.", this.getId(), (newInfo.getLocalVideoMuted() ? "muted" : "unmuted")));
                        this.setRemoteVideoMuted(newInfo.getLocalVideoMuted());
                    }
                    var direction = fm.liveswitch.StreamDirectionHelper.directionFromString(this.getAudioDirection());
                    var direction2 = fm.liveswitch.StreamDirectionHelper.directionFromString(this.getVideoDirection());
                    if ((fm.liveswitch.Global.equals(this.getType(), fm.liveswitch.ConnectionType.getPeer()))) {
                        if ((!fm.liveswitch.Global.equals(fm.liveswitch.StreamDirectionHelper.isReceiveDisabled(this.getAudioDirection()), fm.liveswitch.StreamDirectionHelper.isSendDisabled(newInfo.getAudioDirection())))) {
                            direction = fm.liveswitch.StreamDirectionHelper.setReceiveDisabled(direction, fm.liveswitch.StreamDirectionHelper.isSendDisabled(newInfo.getAudioDirection()));
                            fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.info(fm.liveswitch.StringExtensions.format("Remote connection {0} has {1} their audio stream.", this.getId(), (fm.liveswitch.StreamDirectionHelper.isSendDisabled(newInfo.getAudioDirection()) ? "disabled" : "enabled")));
                            flag = true;
                        }
                        if ((!fm.liveswitch.Global.equals(fm.liveswitch.StreamDirectionHelper.isReceiveDisabled(this.getVideoDirection()), fm.liveswitch.StreamDirectionHelper.isSendDisabled(newInfo.getVideoDirection())))) {
                            direction2 = fm.liveswitch.StreamDirectionHelper.setReceiveDisabled(direction2, fm.liveswitch.StreamDirectionHelper.isSendDisabled(newInfo.getVideoDirection()));
                            fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.info(fm.liveswitch.StringExtensions.format("Remote connection {0} has {1} their video stream.", this.getId(), (fm.liveswitch.StreamDirectionHelper.isSendDisabled(newInfo.getVideoDirection()) ? "disabled" : "enabled")));
                            flag = true;
                        }
                        if ((!fm.liveswitch.Global.equals(fm.liveswitch.StreamDirectionHelper.isSendDisabled(this.getAudioDirection()), fm.liveswitch.StreamDirectionHelper.isReceiveDisabled(newInfo.getAudioDirection())))) {
                            direction = fm.liveswitch.StreamDirectionHelper.setSendDisabled(direction, fm.liveswitch.StreamDirectionHelper.isReceiveDisabled(newInfo.getAudioDirection()));
                            fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.info(fm.liveswitch.StringExtensions.format("Remote connection {0} has {1} your audio stream.", this.getId(), (fm.liveswitch.StreamDirectionHelper.isReceiveDisabled(newInfo.getAudioDirection()) ? "disabled" : "enabled")));
                            flag = true;
                        }
                        if ((!fm.liveswitch.Global.equals(fm.liveswitch.StreamDirectionHelper.isSendDisabled(this.getVideoDirection()), fm.liveswitch.StreamDirectionHelper.isReceiveDisabled(newInfo.getVideoDirection())))) {
                            direction2 = fm.liveswitch.StreamDirectionHelper.setSendDisabled(direction2, fm.liveswitch.StreamDirectionHelper.isReceiveDisabled(newInfo.getVideoDirection()));
                            fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.info(fm.liveswitch.StringExtensions.format("Remote connection {0} has {1} your video stream.", this.getId(), (fm.liveswitch.StreamDirectionHelper.isReceiveDisabled(newInfo.getVideoDirection()) ? "disabled" : "enabled")));
                            flag = true;
                        }
                    }
                    if (flag) {
                        fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.debug(fm.liveswitch.StringExtensions.format("Doing self-renegotiation for connection {0}", this.getId()));
                        future = this.selfRenegotiate(direction, direction2);
                    }
                    else {
                        future = fm.liveswitch.PromiseBase.resolveNow(null);
                    }
                    future.then(function (o) {
                        _this.raiseRemoteUpdate(oldInfo, newInfo);
                        promise.resolve(null);
                    }, function (ex) {
                        promise.reject(ex);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the application identifier.
            */
            ManagedConnection.prototype.getApplicationId = function () {
                if (arguments.length == 0) {
                    return this._applicationId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets thes audio direction. Null if disabled.
            */
            ManagedConnection.prototype.getAudioDirection = function () {
                if (arguments.length == 0) {
                    return ((!fm.liveswitch.Global.equals(this.getAudioStream(), null)) ? fm.liveswitch.StreamDirectionHelper.directionToString(this.getAudioStream().getDirection()) : null);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the audio stream.
            */
            ManagedConnection.prototype.getAudioStream = function () {
                if (arguments.length == 0) {
                    return this._audioStream;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the Bundle Policy.
            */
            ManagedConnection.prototype.getBundlePolicy = function () {
                if (arguments.length == 0) {
                    return this.getInternalConnection().getBundlePolicy();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the canonical name for this Connection. Getting the value of Connection.CanonicalName is deprecated. Get the value of MediaStream.LocalCanonicalName instead.
            */
            ManagedConnection.prototype.getCanonicalName = function () {
                if (arguments.length == 0) {
                    return this.getInternalConnection().getCanonicalName();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the channel identifier.
            */
            ManagedConnection.prototype.getChannelId = function () {
                if (arguments.length == 0) {
                    return this._channelId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client identifier.
            */
            ManagedConnection.prototype.getClientId = function () {
                if (arguments.length == 0) {
                    return this._clientId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the current configuration.
            */
            ManagedConnection.prototype.getConfig = function () {
                if (arguments.length == 0) {
                    var config = new fm.liveswitch.ConnectionConfig();
                    config.setTag(this.getTag());
                    config.setLocalAudioMuted(this.getLocalAudioMuted());
                    config.setLocalVideoMuted(this.getLocalVideoMuted());
                    config.setLocalAudioDisabled(this.getLocalAudioDisabled());
                    config.setLocalVideoDisabled(this.getLocalVideoDisabled());
                    config.setRemoteAudioDisabled(this.getRemoteAudioDisabled());
                    config.setRemoteVideoDisabled(this.getRemoteVideoDisabled());
                    config.setRemoteAudioEncoding(this.getRemoteAudioEncoding());
                    config.setRemoteVideoEncoding(this.getRemoteVideoEncoding());
                    return config;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the data direction. Null if disabled.
            */
            ManagedConnection.prototype.getDataDirection = function () {
                if (arguments.length == 0) {
                    return ((!fm.liveswitch.Global.equals(this.getDataStream(), null)) ? fm.liveswitch.StreamDirectionHelper.directionToString(this.getDataStream().getDirection()) : null);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the data stream.
            */
            ManagedConnection.prototype.getDataStream = function () {
                if (arguments.length == 0) {
                    return this._dataStream;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the device identifier.
            */
            ManagedConnection.prototype.getDeviceId = function () {
                if (arguments.length == 0) {
                    return this._deviceId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether to disable automatic ICE servers.
            */
            ManagedConnection.prototype.getDisableAutomaticIceServers = function () {
                if (arguments.length == 0) {
                    return this._disableAutomaticIceServers;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the error, if an error exists.
            */
            ManagedConnection.prototype.getError = function () {
                if (arguments.length == 0) {
                    return this.getInternalConnection().getError();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the external connection identifier.
            */
            ManagedConnection.prototype.getExternalId = function () {
                if (arguments.length == 0) {
                    return this.getInternalConnection().getExternalId();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the state of the ice gathering.
            */
            ManagedConnection.prototype.getGatheringState = function () {
                if (arguments.length == 0) {
                    return this.getInternalConnection().getGatheringState();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether this connection has an audio stream.
            */
            ManagedConnection.prototype.getHasAudio = function () {
                if (arguments.length == 0) {
                    return (!fm.liveswitch.Global.equals(this.getAudioStream(), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether this connection has a data stream.
            */
            ManagedConnection.prototype.getHasData = function () {
                if (arguments.length == 0) {
                    return (!fm.liveswitch.Global.equals(this.getDataStream(), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether this connection has a video stream.
            */
            ManagedConnection.prototype.getHasVideo = function () {
                if (arguments.length == 0) {
                    return (!fm.liveswitch.Global.equals(this.getVideoStream(), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the state of the ice connection.
            */
            ManagedConnection.prototype.getIceConnectionState = function () {
                if (arguments.length == 0) {
                    return this.getInternalConnection().getIceConnectionState();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the ICE gather policy.
            */
            ManagedConnection.prototype.getIceGatherPolicy = function () {
                if (arguments.length == 0) {
                    return this.getInternalConnection().getIceGatherPolicy();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the ICE server.
            */
            ManagedConnection.prototype.getIceServer = function () {
                if (arguments.length == 0) {
                    return this.getInternalConnection().getIceServer();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the ICE servers.
            */
            ManagedConnection.prototype.getIceServers = function () {
                if (arguments.length == 0) {
                    return this.getInternalConnection().getIceServers();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connection identifier.
            */
            ManagedConnection.prototype.getId = function () {
                if (arguments.length == 0) {
                    return this.getInternalConnection().getId();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connection info.
            */
            ManagedConnection.prototype.getInfo = function () {
                if (arguments.length == 0) {
                    var info2 = new fm.liveswitch.ConnectionInfo();
                    info2.setId(this.getId());
                    info2.setExternalId(this.getExternalId());
                    info2.setState(fm.liveswitch.StringExtensions.toLower(new fm.liveswitch.ConnectionStateWrapper(this.getState()).toString()));
                    info2.setTag(this.getTag());
                    info2.setType(this.getType());
                    info2.setError(this.getError());
                    info2.setMediaId(this.getMediaId());
                    info2.setRemoteMediaId(this.getRemoteMediaId());
                    info2.setRemoteConnectionId(this.getRemoteConnectionId());
                    info2.setApplicationId(this.getApplicationId());
                    info2.setChannelId(this.getChannelId());
                    info2.setClientId(this.getClientId());
                    info2.setClientTag(null);
                    info2.setClientRoles(null);
                    info2.setUserId(this.getUserId());
                    info2.setUserAlias(null);
                    info2.setDeviceId(this.getDeviceId());
                    info2.setDeviceAlias(null);
                    info2.setRecording(false);
                    info2.setTransports(this.getTransportInfos());
                    var info = info2;
                    if ((!fm.liveswitch.Global.equals(this.getAudioStream(), null))) {
                        info.setAudioStreams([this.getAudioStream().getInfo()]);
                    }
                    if ((!fm.liveswitch.Global.equals(this.getVideoStream(), null))) {
                        info.setVideoStreams([this.getVideoStream().getInfo()]);
                    }
                    if ((!fm.liveswitch.Global.equals(this.getDataStream(), null))) {
                        info.setDataStream(this.getDataStream().getInfo());
                    }
                    return info;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.getInternalConnection = function () {
                if (arguments.length == 0) {
                    return this._internalConnection;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.getLastStats = function () {
                if (arguments.length == 0) {
                    return this.__lastStats;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if local audio is disabled.
            */
            ManagedConnection.prototype.getLocalAudioDisabled = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StreamDirectionHelper.isSendDisabled(this.getAudioDirection());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the local audio formats.
            */
            ManagedConnection.prototype.getLocalAudioFormats = function () {
                if (arguments.length == 0) {
                    return this._localAudioFormats;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the local audio is muted.
            */
            ManagedConnection.prototype.getLocalAudioMuted = function () {
                if (arguments.length == 0) {
                    if ((fm.liveswitch.Global.equals(this.getAudioStream(), null))) {
                        return false;
                    }
                    return this.getAudioStream().getInputMuted();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if local data is disabled.
            */
            ManagedConnection.prototype.getLocalDataDisabled = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StreamDirectionHelper.isSendDisabled(this.getDataDirection());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the local description.
            */
            ManagedConnection.prototype.getLocalDescription = function () {
                if (arguments.length == 0) {
                    return this.getInternalConnection().getLocalDescription();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if local video is disabled.
            */
            ManagedConnection.prototype.getLocalVideoDisabled = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StreamDirectionHelper.isSendDisabled(this.getVideoDirection());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the local video formats.
            */
            ManagedConnection.prototype.getLocalVideoFormats = function () {
                if (arguments.length == 0) {
                    return this._localVideoFormats;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the local video is muted.
            */
            ManagedConnection.prototype.getLocalVideoMuted = function () {
                if (arguments.length == 0) {
                    if ((fm.liveswitch.Global.equals(this.getVideoStream(), null))) {
                        return false;
                    }
                    return this.getVideoStream().getInputMuted();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media identifier.
            */
            ManagedConnection.prototype.getMediaId = function () {
                if (arguments.length == 0) {
                    return this._mediaId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if remote audio is disabled.
            */
            ManagedConnection.prototype.getRemoteAudioDisabled = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StreamDirectionHelper.isReceiveDisabled(this.getAudioDirection());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote audio encoding.
            */
            ManagedConnection.prototype.getRemoteAudioEncoding = function () {
                if (arguments.length == 0) {
                    return ((!fm.liveswitch.Global.equals(this.getAudioStream(), null)) ? this.getAudioStream().getRemoteEncoding() : null);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote audio formats.
            */
            ManagedConnection.prototype.getRemoteAudioFormats = function () {
                if (arguments.length == 0) {
                    return this._remoteAudioFormats;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the remote audio is muted.
            */
            ManagedConnection.prototype.getRemoteAudioMuted = function () {
                if (arguments.length == 0) {
                    return this._remoteAudioMuted;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the connection was closed by the remote host.
            */
            ManagedConnection.prototype.getRemoteClosed = function () {
                if (arguments.length == 0) {
                    return this._remoteClosed;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote connection identifier, if available.
            */
            ManagedConnection.prototype.getRemoteConnectionId = function () {
                if (arguments.length == 0) {
                    return this._remoteConnectionId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if remote data is disabled.
            */
            ManagedConnection.prototype.getRemoteDataDisabled = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StreamDirectionHelper.isReceiveDisabled(this.getDataDirection());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote description.
            */
            ManagedConnection.prototype.getRemoteDescription = function () {
                if (arguments.length == 0) {
                    return this.getInternalConnection().getRemoteDescription();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.getRemoteFailed = function () {
                if (arguments.length == 0) {
                    return this._remoteFailed;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote media identifier, if available.
            */
            ManagedConnection.prototype.getRemoteMediaId = function () {
                if (arguments.length == 0) {
                    return this._remoteMediaId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the connection was rejected by the remote host.
            */
            ManagedConnection.prototype.getRemoteRejected = function () {
                if (arguments.length == 0) {
                    return this._remoteRejected;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote tag, if applicable.
            */
            ManagedConnection.prototype.getRemoteTag = function () {
                if (arguments.length == 0) {
                    return this._remoteTag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if remote video is disabled.
            */
            ManagedConnection.prototype.getRemoteVideoDisabled = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StreamDirectionHelper.isReceiveDisabled(this.getVideoDirection());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote video encoding.
            */
            ManagedConnection.prototype.getRemoteVideoEncoding = function () {
                if (arguments.length == 0) {
                    return ((!fm.liveswitch.Global.equals(this.getVideoStream(), null)) ? this.getVideoStream().getRemoteEncoding() : null);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote video formats.
            */
            ManagedConnection.prototype.getRemoteVideoFormats = function () {
                if (arguments.length == 0) {
                    return this._remoteVideoFormats;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the remote video is muted.
            */
            ManagedConnection.prototype.getRemoteVideoMuted = function () {
                if (arguments.length == 0) {
                    return this._remoteVideoMuted;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the state of the signalling.
            */
            ManagedConnection.prototype.getSignallingState = function () {
                if (arguments.length == 0) {
                    return this.getInternalConnection().getSignallingState();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the state of the connection.
            */
            ManagedConnection.prototype.getState = function () {
                if (arguments.length == 0) {
                    var failed = this.getInternalConnection().getState();
                    if (this.getRemoteFailed()) {
                        var _var0 = failed;
                        if (_var0 == fm.liveswitch.ConnectionState.Closing) {
                            do {
                                return fm.liveswitch.ConnectionState.Failing;
                            } while (false);
                        }
                        else if (_var0 == fm.liveswitch.ConnectionState.Closed) {
                            do {
                                failed = fm.liveswitch.ConnectionState.Failed;
                                break;
                            } while (false);
                        }
                    }
                    return failed;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the current connection stats.
            */
            ManagedConnection.prototype.getStats = function () {
                if (arguments.length == 0) {
                    return this.getInternalConnection().getStats();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the stats interval in milliseconds. The default value is 10,000 (10 seconds).
            */
            ManagedConnection.prototype.getStatsInterval = function () {
                if (arguments.length == 0) {
                    return this._statsInterval;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the tag.
            */
            ManagedConnection.prototype.getTag = function () {
                if (arguments.length == 0) {
                    return this._tag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.getTransportInfos = function () {
                if (arguments.length == 0) {
                    var transportInfo = void 0;
                    var controlTransportInfo = void 0;
                    var list = new Array();
                    if ((!fm.liveswitch.Global.equals(this.getAudioStream(), null))) {
                        transportInfo = this.getAudioStream().getTransportInfo();
                        if (!((fm.liveswitch.Global.equals(transportInfo, null)) || fm.liveswitch.ArrayExtensions.contains(list, transportInfo))) {
                            fm.liveswitch.ArrayExtensions.add(list, transportInfo);
                        }
                        controlTransportInfo = this.getAudioStream().getControlTransportInfo();
                        if (!((fm.liveswitch.Global.equals(controlTransportInfo, null)) || fm.liveswitch.ArrayExtensions.contains(list, controlTransportInfo))) {
                            fm.liveswitch.ArrayExtensions.add(list, controlTransportInfo);
                        }
                    }
                    if ((!fm.liveswitch.Global.equals(this.getVideoStream(), null))) {
                        transportInfo = this.getVideoStream().getTransportInfo();
                        if (!((fm.liveswitch.Global.equals(transportInfo, null)) || fm.liveswitch.ArrayExtensions.contains(list, transportInfo))) {
                            fm.liveswitch.ArrayExtensions.add(list, transportInfo);
                        }
                        controlTransportInfo = this.getVideoStream().getControlTransportInfo();
                        if (!((fm.liveswitch.Global.equals(controlTransportInfo, null)) || fm.liveswitch.ArrayExtensions.contains(list, controlTransportInfo))) {
                            fm.liveswitch.ArrayExtensions.add(list, controlTransportInfo);
                        }
                    }
                    if ((!fm.liveswitch.Global.equals(this.getDataStream(), null))) {
                        transportInfo = this.getDataStream().getTransportInfo();
                        if (!((fm.liveswitch.Global.equals(transportInfo, null)) || fm.liveswitch.ArrayExtensions.contains(list, transportInfo))) {
                            fm.liveswitch.ArrayExtensions.add(list, transportInfo);
                        }
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the trickle-ICE policy.
            */
            ManagedConnection.prototype.getTrickleIcePolicy = function () {
                if (arguments.length == 0) {
                    return this.getInternalConnection().getTrickleIcePolicy();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connection type.
            */
            ManagedConnection.prototype.getType = function () {
                if (arguments.length == 0) {
                    return this._type;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the user identifier.
            */
            ManagedConnection.prototype.getUserId = function () {
                if (arguments.length == 0) {
                    return this._userId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the video direction. Null if disabled.
            */
            ManagedConnection.prototype.getVideoDirection = function () {
                if (arguments.length == 0) {
                    return ((!fm.liveswitch.Global.equals(this.getVideoStream(), null)) ? fm.liveswitch.StreamDirectionHelper.directionToString(this.getVideoStream().getDirection()) : null);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the video stream.
            */
            ManagedConnection.prototype.getVideoStream = function () {
                if (arguments.length == 0) {
                    return this._videoStream;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.internalConnection_OnGatheringStateChange = function (internalConnection) {
                if (arguments.length == 1) {
                    var onGatheringStateChange = this._onGatheringStateChange;
                    if ((!fm.liveswitch.Global.equals(onGatheringStateChange, null))) {
                        onGatheringStateChange(this);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.internalConnection_OnIceConnectionStateChange = function (internalConnection) {
                if (arguments.length == 1) {
                    var onIceConnectionStateChange = this._onIceConnectionStateChange;
                    if ((!fm.liveswitch.Global.equals(onIceConnectionStateChange, null))) {
                        onIceConnectionStateChange(this);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.internalConnection_OnLocalCandidate = function (internalConnection, localCandidate) {
                if (arguments.length == 2) {
                    var onLocalCandidate = this._onLocalCandidate;
                    if ((!fm.liveswitch.Global.equals(localCandidate.getProtocol(), fm.liveswitch.ProtocolType.Tcp))) {
                        if ((!fm.liveswitch.Global.equals(onLocalCandidate, null))) {
                            onLocalCandidate(this, localCandidate);
                        }
                        this.send(this.createCandidateMessage(localCandidate)).fail(function (ex) {
                            fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.error("Could not send candidate message.", ex);
                        });
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.internalConnection_OnLocalDescription = function (connection, localDescription) {
                if (arguments.length == 2) {
                    var onLocalDescription = this._onLocalDescription;
                    if ((!fm.liveswitch.Global.equals(onLocalDescription, null))) {
                        onLocalDescription(this, localDescription);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.internalConnection_OnRemoteCandidate = function (connection, remoteCandidate) {
                if (arguments.length == 2) {
                    var onRemoteCandidate = this._onRemoteCandidate;
                    if ((!fm.liveswitch.Global.equals(onRemoteCandidate, null))) {
                        onRemoteCandidate(this, remoteCandidate);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.internalConnection_OnRemoteDescription = function (connection, remoteDescription) {
                if (arguments.length == 2) {
                    var onRemoteDescription = this._onRemoteDescription;
                    if ((!fm.liveswitch.Global.equals(onRemoteDescription, null))) {
                        onRemoteDescription(this, remoteDescription);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.internalConnection_OnSignallingStateChange = function (internalConnection) {
                if (arguments.length == 1) {
                    var onSignallingStateChange = this._onSignallingStateChange;
                    if ((!fm.liveswitch.Global.equals(onSignallingStateChange, null))) {
                        onSignallingStateChange(this);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.internalConnection_OnStateChange = function (internalConnection) {
                if (arguments.length == 1) {
                    this.processStateChangeEvent(internalConnection.getState());
                    if ((!fm.liveswitch.Global.equals(this._openPromise, null))) {
                        var openPromise = void 0;
                        if ((fm.liveswitch.Global.equals(internalConnection.getState(), fm.liveswitch.ConnectionState.Connected))) {
                            openPromise = this._openPromise;
                            this._openPromise = null;
                            openPromise.resolveAsync(null);
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(internalConnection.getState(), fm.liveswitch.ConnectionState.Failed))) {
                                openPromise = this._openPromise;
                                this._openPromise = null;
                                if ((fm.liveswitch.Global.equals(internalConnection.getError(), null))) {
                                    openPromise.rejectAsync(new fm.liveswitch.Exception("Connection failed."));
                                }
                                else {
                                    openPromise.rejectAsync(new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Connection failed. ({0})", internalConnection.getError().getDescription())));
                                }
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(internalConnection.getState(), fm.liveswitch.ConnectionState.Closed))) {
                                    openPromise = this._openPromise;
                                    this._openPromise = null;
                                    if ((fm.liveswitch.Global.equals(internalConnection.getError(), null))) {
                                        openPromise.rejectAsync(new fm.liveswitch.Exception("Connection closed."));
                                    }
                                    else {
                                        openPromise.rejectAsync(new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Connection closed. ({0})", internalConnection.getError().getDescription())));
                                    }
                                }
                            }
                        }
                    }
                    var onStateChange = this._onStateChange;
                    if ((!fm.liveswitch.Global.equals(onStateChange, null))) {
                        onStateChange(this);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.mediaStream_OnDiscardBitrateNotification = function (bitrateNotification) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(bitrateNotification, null))) {
                        this.send(fm.liveswitch.Message.createBitrateNotificationMessage(bitrateNotification));
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.mediaStream_OnDiscardBitrateRequest = function (bitrateRequest) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(bitrateRequest, null))) {
                        this.send(fm.liveswitch.Message.createBitrateRequestMessage(bitrateRequest));
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Opens the connection.
            */
            ManagedConnection.prototype.open = function () {
                var _this = this;
                if (arguments.length == 0) {
                    var resolveAction = null;
                    var rejectAction = null;
                    try {
                        var promise = new fm.liveswitch.Promise();
                        if ((!fm.liveswitch.Global.equals(this._openPromise, null))) {
                            throw new fm.liveswitch.Exception("Open can only be called once.");
                        }
                        this._openPromise = promise;
                        fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.debug(fm.liveswitch.StringExtensions.format("Opening connection with ID '{0}'.", this.getId()));
                        if ((this.getDisableAutomaticIceServers() || (this.getIceServers().length > 0))) {
                            this.doOpen();
                        }
                        else {
                            fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.debug(fm.liveswitch.StringExtensions.format("Getting ICE servers for connection with ID '{0}'.", this.getId()));
                            if ((fm.liveswitch.Global.equals(resolveAction, null))) {
                                resolveAction = function (response) {
                                    if ((fm.liveswitch.Global.equals(response.getType(), fm.liveswitch.MessageType.getIceServers()))) {
                                        _this.setIceServers(fm.liveswitch.IceServer.fromJsonArray(response.getPayload()));
                                        _this.doOpen();
                                    }
                                    else {
                                        _this.processMessage(response);
                                    }
                                };
                            }
                            if ((fm.liveswitch.Global.equals(rejectAction, null))) {
                                rejectAction = function (ex) {
                                    fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.warn(fm.liveswitch.StringExtensions.format("Could not get ICE servers for connection with ID '{0}'.", _this.getId()), ex);
                                    _this.doOpen();
                                };
                            }
                            this.send(fm.liveswitch.Message.createIceServersMessage()).then(resolveAction, rejectAction);
                        }
                        return promise;
                    }
                    catch (exception) {
                        var promise2 = new fm.liveswitch.Promise();
                        promise2.reject(exception);
                        return promise2;
                    }
                    finally {
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.processBitrateNotification = function (message) {
                if (arguments.length == 1) {
                    var notificationArray = fm.liveswitch.BitrateNotification.fromJsonArray(message.getPayload());
                    if ((fm.liveswitch.Global.equals(notificationArray, null))) {
                        fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.warn("Received a malformed 'bitrateNotification' message.");
                    }
                    else {
                        if ((fm.liveswitch.Global.equals(notificationArray.length, 0))) {
                            fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.warn("Received a 'bitrateNotification' message with no bitrate notifications.");
                        }
                        else {
                            var audioStream = this.getAudioStream();
                            var videoStream = this.getVideoStream();
                            for (var _i = 0, notificationArray_1 = notificationArray; _i < notificationArray_1.length; _i++) {
                                var notification = notificationArray_1[_i];
                                if (((!fm.liveswitch.Global.equals(audioStream, null)) && (fm.liveswitch.Global.equals(notification.getMediaDescriptionId(), audioStream.getMediaDescriptionId())))) {
                                    this.raiseAudioBitrateNotification(audioStream, notification);
                                }
                                else {
                                    if (((!fm.liveswitch.Global.equals(videoStream, null)) && (fm.liveswitch.Global.equals(notification.getMediaDescriptionId(), videoStream.getMediaDescriptionId())))) {
                                        this.raiseVideoBitrateNotification(videoStream, notification);
                                    }
                                    else {
                                        if (((!fm.liveswitch.Global.equals(audioStream, null)) && (fm.liveswitch.Global.equals(notification.getMediaDescriptionId(), "audio")))) {
                                            this.raiseAudioBitrateNotification(audioStream, notification);
                                        }
                                        else {
                                            if (((!fm.liveswitch.Global.equals(videoStream, null)) && (fm.liveswitch.Global.equals(notification.getMediaDescriptionId(), "video")))) {
                                                this.raiseVideoBitrateNotification(videoStream, notification);
                                            }
                                            else {
                                                if (((!fm.liveswitch.Global.equals(videoStream, null)) && (fm.liveswitch.Global.equals(notification.getMediaDescriptionId(), null)))) {
                                                    this.raiseVideoBitrateNotification(videoStream, notification);
                                                }
                                                else {
                                                    fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.warn(fm.liveswitch.StringExtensions.format("Received a 'bitrateNotification' message with unexpected media description ID '{0}'.", notification.getMediaDescriptionId()));
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.processBitrateRequest = function (message) {
                if (arguments.length == 1) {
                    var requestArray = fm.liveswitch.BitrateRequest.fromJsonArray(message.getPayload());
                    if ((fm.liveswitch.Global.equals(requestArray, null))) {
                        fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.warn("Received a malformed 'bitrateRequest' message.");
                    }
                    else {
                        if ((fm.liveswitch.Global.equals(requestArray.length, 0))) {
                            fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.warn("Received a 'bitrateRequest' message with no bitrate requests.");
                        }
                        else {
                            var audioStream = this.getAudioStream();
                            var videoStream = this.getVideoStream();
                            for (var _i = 0, requestArray_1 = requestArray; _i < requestArray_1.length; _i++) {
                                var request = requestArray_1[_i];
                                if (((!fm.liveswitch.Global.equals(audioStream, null)) && (fm.liveswitch.Global.equals(request.getMediaDescriptionId(), audioStream.getMediaDescriptionId())))) {
                                    this.raiseAudioBitrateRequest(audioStream, request);
                                }
                                else {
                                    if (((!fm.liveswitch.Global.equals(videoStream, null)) && (fm.liveswitch.Global.equals(request.getMediaDescriptionId(), videoStream.getMediaDescriptionId())))) {
                                        this.raiseVideoBitrateRequest(videoStream, request);
                                    }
                                    else {
                                        if (((!fm.liveswitch.Global.equals(audioStream, null)) && (fm.liveswitch.Global.equals(request.getMediaDescriptionId(), "audio")))) {
                                            this.raiseAudioBitrateRequest(audioStream, request);
                                        }
                                        else {
                                            if (((!fm.liveswitch.Global.equals(videoStream, null)) && (fm.liveswitch.Global.equals(request.getMediaDescriptionId(), "video")))) {
                                                this.raiseVideoBitrateRequest(videoStream, request);
                                            }
                                            else {
                                                if (((!fm.liveswitch.Global.equals(videoStream, null)) && (fm.liveswitch.Global.equals(request.getMediaDescriptionId(), null)))) {
                                                    this.raiseVideoBitrateRequest(videoStream, request);
                                                }
                                                else {
                                                    fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.warn(fm.liveswitch.StringExtensions.format("Received a 'bitrateRequest' message with unexpected media description ID '{0}'.", request.getMediaDescriptionId()));
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.processCandidate = function (message) {
                if (arguments.length == 1) {
                    this.getInternalConnection().addRemoteCandidate(fm.liveswitch.Candidate.fromJson(message.getPayload())).fail(function (ex) {
                        fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.error("Could not add remote candidate.", ex);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.processClose = function () {
                if (arguments.length == 0) {
                    this.setRemoteClosed(true);
                    this.getInternalConnection().close();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.processFail = function (error) {
                if (arguments.length == 1) {
                    this.setRemoteFailed(true);
                    this.getInternalConnection().setError(error);
                    this.getInternalConnection().close();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.processKeyFrameRequest = function (message) {
                if (arguments.length == 1) {
                    var synchronizationSources = fm.liveswitch.JsonSerializer.deserializeLongArray(message.getPayload());
                    if ((fm.liveswitch.Global.equals(synchronizationSources, null))) {
                        fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.warn("Received a malformed 'keyFrameRequest' message.");
                    }
                    else {
                        if ((fm.liveswitch.Global.equals(synchronizationSources.length, 0))) {
                            fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.warn("Received a 'keyFrameRequest' message with no sychronization sources.");
                        }
                        else {
                            var videoStream = this.getVideoStream();
                            if ((!fm.liveswitch.Global.equals(videoStream, null))) {
                                videoStream.raiseKeyFrameRequest(synchronizationSources);
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a local failure.
            @param error The error.
            */
            ManagedConnection.prototype.processLocalError = function (error) {
                if (arguments.length == 1) {
                    this.setRemoteClosed(false);
                    this.getInternalConnection().setError(error);
                    this.getInternalConnection().close();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.processMessage = function (message) {
                if (arguments.length == 1) {
                    this.__messageQueue.enqueue(message);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.processQueuedMessage = function (message) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getOffer()))) {
                        if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getAnswer()))) {
                            this.processAnswer(message);
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getCandidate()))) {
                                this.processCandidate(message);
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getKeyFrameRequest()))) {
                                    this.processKeyFrameRequest(message);
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getBitrateRequest()))) {
                                        this.processBitrateRequest(message);
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getBitrateNotification()))) {
                                            this.processBitrateNotification(message);
                                        }
                                        else {
                                            if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getClose()))) {
                                                this.processClose();
                                            }
                                            else {
                                                if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getFail()))) {
                                                    this.processFail(new fm.liveswitch.Error(fm.liveswitch.ErrorCode.ConnectionRemoteFailure, new fm.liveswitch.Exception("Media server is no longer available.")));
                                                }
                                                else {
                                                    if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getReject()))) {
                                                        this.processReject();
                                                    }
                                                    else {
                                                        if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getError()))) {
                                                            var str = fm.liveswitch.JsonSerializer.deserializeString(message.getPayload());
                                                            if ((!fm.liveswitch.Global.equals(this.getType(), fm.liveswitch.ConnectionType.getPeer()))) {
                                                                fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.error(fm.liveswitch.StringExtensions.format("Received an error from the media server: {0}.", str));
                                                            }
                                                            else {
                                                                fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.error(fm.liveswitch.StringExtensions.format("Received an error from the remote peer: {0}.", str));
                                                            }
                                                            if ((((((fm.liveswitch.Global.equals(str, fm.liveswitch.ErrorType.getSfuInvalidUpstream())) || (fm.liveswitch.Global.equals(str, fm.liveswitch.ErrorType.getServerNoAudioCodecs()))) || ((fm.liveswitch.Global.equals(str, fm.liveswitch.ErrorType.getServerNoVideoCodecs())) || (fm.liveswitch.Global.equals(str, fm.liveswitch.ErrorType.getSdpStreamMismatch())))) || (fm.liveswitch.Global.equals(str, fm.liveswitch.ErrorType.getSdpSimulcastMismatch()))) || (fm.liveswitch.Global.equals(str, fm.liveswitch.ErrorType.getSdpCodecMismatch())))) {
                                                                this.processRemoteError(new fm.liveswitch.Error(fm.liveswitch.ErrorCode.ConnectionRemoteFailure, new fm.liveswitch.Exception(str)));
                                                            }
                                                            else {
                                                                this.processFail(new fm.liveswitch.Error(fm.liveswitch.ErrorCode.ConnectionRemoteFailure, new fm.liveswitch.Exception(str)));
                                                            }
                                                        }
                                                        else {
                                                            this.doProcessMessage(message);
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.processReject = function () {
                if (arguments.length == 0) {
                    this.setRemoteRejected(true);
                    this.getInternalConnection().close();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.processRemoteError = function (error) {
                if (arguments.length == 1) {
                    this.setRemoteClosed(true);
                    this.getInternalConnection().setError(error);
                    this.getInternalConnection().close();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.processStateChangeEvent = function (state) {
                var _this = this;
                if (arguments.length == 1) {
                    if (((fm.liveswitch.Global.equals(state, fm.liveswitch.ConnectionState.Closed)) || (fm.liveswitch.Global.equals(state, fm.liveswitch.ConnectionState.Failed)))) {
                        this.cancelSendStats();
                        this.unsubscribeFromInternalEvents();
                    }
                    else {
                        if (((fm.liveswitch.Global.equals(state, fm.liveswitch.ConnectionState.Closing)) || (fm.liveswitch.Global.equals(state, fm.liveswitch.ConnectionState.Failing)))) {
                            this.cancelSendStats();
                        }
                    }
                    this.sendConnectionEvent(fm.liveswitch.EventType.fromConnectionState(state)).then(function (o) {
                        if ((fm.liveswitch.Global.equals(state, fm.liveswitch.ConnectionState.Connected))) {
                            _this.scheduleSendStats();
                        }
                    }, function (ex) {
                        fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.warn(fm.liveswitch.StringExtensions.format("Could not send {0} event.", fm.liveswitch.EventType.fromConnectionState(state)), ex);
                        if ((fm.liveswitch.Global.equals(state, fm.liveswitch.ConnectionState.Connected))) {
                            _this.scheduleSendStats();
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Raises an audio bitrate notification.
            @param audioStream The audio stream.
            @param bitrateNotification The bitrate notification.
            */
            ManagedConnection.prototype.raiseAudioBitrateNotification = function (audioStream, bitrateNotification) {
                if (arguments.length == 2) {
                    audioStream.raiseBitrateNotification(bitrateNotification);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Raises an audio bitrate request.
            @param audioStream The audio stream.
            @param bitrateRequest The bitrate request.
            */
            ManagedConnection.prototype.raiseAudioBitrateRequest = function (audioStream, bitrateRequest) {
                if (arguments.length == 2) {
                    audioStream.raiseBitrateRequest(bitrateRequest);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.raiseRemoteUpdate = function (oldConnectionInfo, newConnectionInfo) {
                if (arguments.length == 2) {
                    var onRemoteUpdate = this._onRemoteUpdate;
                    if ((!fm.liveswitch.Global.equals(onRemoteUpdate, null))) {
                        onRemoteUpdate(oldConnectionInfo, newConnectionInfo);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Raises a video bitrate notification.
            @param videoStream The video stream.
            @param bitrateNotification The bitrate notification.
            */
            ManagedConnection.prototype.raiseVideoBitrateNotification = function (videoStream, bitrateNotification) {
                if (arguments.length == 2) {
                    videoStream.raiseBitrateNotification(bitrateNotification);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Raises a video bitrate request.
            @param videoStream The video stream.
            @param bitrateRequest The bitrate request.
            */
            ManagedConnection.prototype.raiseVideoBitrateRequest = function (videoStream, bitrateRequest) {
                if (arguments.length == 2) {
                    videoStream.raiseBitrateRequest(bitrateRequest);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the ICE gathering state changes. Parameters: - connection - the connection
            */
            ManagedConnection.prototype.removeOnGatheringStateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onGatheringStateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the ICE connection state changes. Parameters: - connection - the connection
            */
            ManagedConnection.prototype.removeOnIceConnectionStateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onIceConnectionStateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when a local candidate is ready. Parameters: - connection - the connection - candidate - the local candidate
            */
            ManagedConnection.prototype.removeOnLocalCandidate = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onLocalCandidate, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the local description is ready. Parameters: - connection - the connection - description - the local description
            */
            ManagedConnection.prototype.removeOnLocalDescription = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onLocalDescription, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the remote audio encoding is switched by the server.
            */
            ManagedConnection.prototype.removeOnRemoteAudioEncodingSwitch = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onRemoteAudioEncodingSwitch, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when a remote candidate is ready. Parameters: - connection - the connection - candidate - the remote candidate
            */
            ManagedConnection.prototype.removeOnRemoteCandidate = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onRemoteCandidate, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the remote description is ready. Parameters: - connection - the connection - description - the remote description
            */
            ManagedConnection.prototype.removeOnRemoteDescription = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onRemoteDescription, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when a remote connection has been updated.
            */
            ManagedConnection.prototype.removeOnRemoteUpdate = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onRemoteUpdate, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the remote video encoding is switched by the server.
            */
            ManagedConnection.prototype.removeOnRemoteVideoEncodingSwitch = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onRemoteVideoEncodingSwitch, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the signalling state changes. Parameters: - connection - the connection
            */
            ManagedConnection.prototype.removeOnSignallingStateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onSignallingStateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the connection state changes. Parameters: - connection - the connection
            */
            ManagedConnection.prototype.removeOnStateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onStateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.removeOnStats = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onStats, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.scheduleSendStats = function () {
                if (arguments.length == 0) {
                    if (!this.__sendStatsCancelled) {
                        this.__sendStatsTimer = new fm.liveswitch.TimeoutTimer(this.sendStats.bind(this), null);
                        this.__sendStatsTimer.start(this.getStatsInterval());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.selfRenegotiate = function (localAudioDirection, localVideoDirection) {
                if (arguments.length == 2) {
                    var promise = new fm.liveswitch.Promise();
                    try {
                        if (((!fm.liveswitch.Global.equals(this.getAudioStream(), null)) && (!fm.liveswitch.Global.equals(this.getAudioStream().getDirection(), localAudioDirection)))) {
                            this.getAudioStream().changeDirection(localAudioDirection);
                        }
                        if (((!fm.liveswitch.Global.equals(this.getVideoStream(), null)) && (!fm.liveswitch.Global.equals(this.getVideoStream().getDirection(), localVideoDirection)))) {
                            this.getVideoStream().changeDirection(localVideoDirection);
                        }
                        var description3 = new fm.liveswitch.SessionDescription();
                        description3.setRenegotiation(true);
                        description3.setTieBreaker(fm.liveswitch.Guid.newGuid().toString());
                        description3.setType(fm.liveswitch.SessionDescriptionType.Answer);
                        var answer = description3;
                        answer.setSdpMessage(fm.liveswitch.sdp.Message.parse(this.getInternalConnection().getRemoteDescription().getSdpMessage().toString()));
                        var origin_19 = answer.getSdpMessage().getOrigin();
                        origin_19.setSessionVersion((origin_19.getSessionVersion() + 1));
                        var direction = localAudioDirection;
                        direction = fm.liveswitch.StreamDirectionHelper.setReceiveDisabled(fm.liveswitch.StreamDirectionHelper.setSendDisabled(direction, fm.liveswitch.StreamDirectionHelper.isReceiveDisabled(localAudioDirection)), fm.liveswitch.StreamDirectionHelper.isSendDisabled(localAudioDirection));
                        var direction2 = localVideoDirection;
                        direction2 = fm.liveswitch.StreamDirectionHelper.setReceiveDisabled(fm.liveswitch.StreamDirectionHelper.setSendDisabled(direction2, fm.liveswitch.StreamDirectionHelper.isReceiveDisabled(localVideoDirection)), fm.liveswitch.StreamDirectionHelper.isSendDisabled(localVideoDirection));
                        for (var _i = 0, _a = answer.getSdpMessage().getMediaDescriptions(); _i < _a.length; _i++) {
                            var description2 = _a[_i];
                            if (description2.getIsAudio()) {
                                if ((!fm.liveswitch.Global.equals(description2.getStreamDirection(), direction))) {
                                    description2.setStreamDirection(direction);
                                }
                            }
                            else {
                                if ((description2.getIsVideo() && (!fm.liveswitch.Global.equals(description2.getStreamDirection(), direction2)))) {
                                    description2.setStreamDirection(direction2);
                                }
                            }
                        }
                        this.doSelfNegotiate(answer, promise);
                    }
                    catch (exception) {
                        promise.reject(exception);
                    }
                    finally {
                    }
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sends a message.
            @param message The message.
            */
            ManagedConnection.prototype.send = function (message) {
                if (arguments.length == 1) {
                    message.setConnectionId(this.getId());
                    message.setConnectionType(this.getType());
                    message.setMediaId(this.getMediaId());
                    return this.__doSend(message);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.sendConnectionEvent = function (eventType) {
                if (arguments.length == 1) {
                    var promise = new fm.liveswitch.Promise();
                    var eventInfo = new fm.liveswitch.EventInfo(eventType);
                    eventInfo.setConnection(this.getInfo());
                    this.doSendConnectionEvent(promise, eventInfo);
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.sendConnectionEventMessage = function (promise, eventInfo) {
                if (arguments.length == 2) {
                    if ((!fm.liveswitch.Global.equals(eventInfo.getConnection(), null))) {
                        eventInfo.getConnection().setSerializeLegacyProperties(false);
                    }
                    this.send(fm.liveswitch.Message.createEventMessage(eventInfo.toJson())).then(function (message) {
                        promise.resolve(null);
                    }, function (ex) {
                        promise.reject(ex);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.sendStats = function (state) {
                var _this = this;
                if (arguments.length == 1) {
                    var resolveAction = null;
                    var rejectAction = null;
                    if (!this.__sendStatsCancelled) {
                        if ((fm.liveswitch.Global.equals(resolveAction, null))) {
                            resolveAction = function (o) {
                                _this.scheduleSendStats();
                            };
                        }
                        if ((fm.liveswitch.Global.equals(rejectAction, null))) {
                            rejectAction = function (ex) {
                                fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log.warn(fm.liveswitch.StringExtensions.format("Could not send {0} event.", "connection.stats"), ex);
                                _this.scheduleSendStats();
                            };
                        }
                        this.sendConnectionEvent("connection.stats").then(resolveAction, rejectAction);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.setApplicationId = function (value) {
                if (arguments.length == 1) {
                    this._applicationId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.setAudioStream = function (value) {
                if (arguments.length == 1) {
                    this._audioStream = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the Bundle Policy.
            */
            ManagedConnection.prototype.setBundlePolicy = function (value) {
                if (arguments.length == 1) {
                    this.getInternalConnection().setBundlePolicy(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.setChannelId = function (value) {
                if (arguments.length == 1) {
                    this._channelId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.setClientId = function (value) {
                if (arguments.length == 1) {
                    this._clientId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.setDataStream = function (value) {
                if (arguments.length == 1) {
                    this._dataStream = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.setDeviceId = function (value) {
                if (arguments.length == 1) {
                    this._deviceId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether to disable automatic ICE servers.
            */
            ManagedConnection.prototype.setDisableAutomaticIceServers = function (value) {
                if (arguments.length == 1) {
                    this._disableAutomaticIceServers = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the ICE gather policy.
            */
            ManagedConnection.prototype.setIceGatherPolicy = function (value) {
                if (arguments.length == 1) {
                    this.getInternalConnection().setIceGatherPolicy(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the ICE server.
            */
            ManagedConnection.prototype.setIceServer = function (value) {
                if (arguments.length == 1) {
                    this.getInternalConnection().setIceServer(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the ICE servers.
            */
            ManagedConnection.prototype.setIceServers = function (value) {
                if (arguments.length == 1) {
                    this.getInternalConnection().setIceServers(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.setInternalConnection = function (value) {
                if (arguments.length == 1) {
                    this._internalConnection = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the local audio formats.
            */
            ManagedConnection.prototype.setLocalAudioFormats = function (value) {
                if (arguments.length == 1) {
                    this._localAudioFormats = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the local video formats.
            */
            ManagedConnection.prototype.setLocalVideoFormats = function (value) {
                if (arguments.length == 1) {
                    this._localVideoFormats = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media identifier.
            */
            ManagedConnection.prototype.setMediaId = function (value) {
                if (arguments.length == 1) {
                    this._mediaId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote audio encoding.
            */
            ManagedConnection.prototype.setRemoteAudioEncoding = function (value) {
                if (arguments.length == 1) {
                    var audioStream = this.getAudioStream();
                    if ((!fm.liveswitch.Global.equals(audioStream, null))) {
                        var remoteEncoding = audioStream.getRemoteEncoding();
                        audioStream.setRemoteEncoding(value);
                        var onRemoteAudioEncodingSwitch = this._onRemoteAudioEncodingSwitch;
                        if ((!fm.liveswitch.Global.equals(onRemoteAudioEncodingSwitch, null))) {
                            onRemoteAudioEncodingSwitch(remoteEncoding, value);
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote audio formats.
            */
            ManagedConnection.prototype.setRemoteAudioFormats = function (value) {
                if (arguments.length == 1) {
                    this._remoteAudioFormats = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the remote audio is muted.
            */
            ManagedConnection.prototype.setRemoteAudioMuted = function (value) {
                if (arguments.length == 1) {
                    this._remoteAudioMuted = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.setRemoteClosed = function (value) {
                if (arguments.length == 1) {
                    this._remoteClosed = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote connection identifier, if available.
            */
            ManagedConnection.prototype.setRemoteConnectionId = function (value) {
                if (arguments.length == 1) {
                    this._remoteConnectionId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.setRemoteFailed = function (value) {
                if (arguments.length == 1) {
                    this._remoteFailed = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote media identifier, if available.
            */
            ManagedConnection.prototype.setRemoteMediaId = function (value) {
                if (arguments.length == 1) {
                    this._remoteMediaId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.setRemoteRejected = function (value) {
                if (arguments.length == 1) {
                    this._remoteRejected = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote tag, if applicable.
            */
            ManagedConnection.prototype.setRemoteTag = function (value) {
                if (arguments.length == 1) {
                    this._remoteTag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote video encoding.
            */
            ManagedConnection.prototype.setRemoteVideoEncoding = function (value) {
                if (arguments.length == 1) {
                    var videoStream = this.getVideoStream();
                    if ((!fm.liveswitch.Global.equals(videoStream, null))) {
                        var remoteEncoding = videoStream.getRemoteEncoding();
                        videoStream.setRemoteEncoding(value);
                        var onRemoteVideoEncodingSwitch = this._onRemoteVideoEncodingSwitch;
                        if ((!fm.liveswitch.Global.equals(onRemoteVideoEncodingSwitch, null))) {
                            onRemoteVideoEncodingSwitch(remoteEncoding, value);
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote video formats.
            */
            ManagedConnection.prototype.setRemoteVideoFormats = function (value) {
                if (arguments.length == 1) {
                    this._remoteVideoFormats = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the remote video is muted.
            */
            ManagedConnection.prototype.setRemoteVideoMuted = function (value) {
                if (arguments.length == 1) {
                    this._remoteVideoMuted = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the stats interval in milliseconds. The default value is 10,000 (10 seconds).
            */
            ManagedConnection.prototype.setStatsInterval = function (value) {
                if (arguments.length == 1) {
                    this._statsInterval = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the tag.
            */
            ManagedConnection.prototype.setTag = function (value) {
                if (arguments.length == 1) {
                    this._tag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the trickle-ICE policy.
            */
            ManagedConnection.prototype.setTrickleIcePolicy = function (value) {
                if (arguments.length == 1) {
                    this.getInternalConnection().setTrickleIcePolicy(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.setType = function (value) {
                if (arguments.length == 1) {
                    this._type = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.setUserId = function (value) {
                if (arguments.length == 1) {
                    this._userId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.setVideoStream = function (value) {
                if (arguments.length == 1) {
                    this._videoStream = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.unsubscribeFromInternalEvents = function () {
                if (arguments.length == 0) {
                    var internalConnection = this.getInternalConnection();
                    if ((!fm.liveswitch.Global.equals(internalConnection, null))) {
                        internalConnection.removeOnStateChange(this.internalConnection_OnStateChange.bind(this));
                        internalConnection.removeOnSignallingStateChange(this.internalConnection_OnSignallingStateChange.bind(this));
                        internalConnection.removeOnIceConnectionStateChange(this.internalConnection_OnIceConnectionStateChange.bind(this));
                        internalConnection.removeOnGatheringStateChange(this.internalConnection_OnGatheringStateChange.bind(this));
                        internalConnection.removeOnLocalCandidate(this.internalConnection_OnLocalCandidate.bind(this));
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Updates the local description with any modified properties from the config and alerts the server.
            @param config The config
            @return A future that resolves when the renegotiation is complete.
            */
            ManagedConnection.prototype.update = function (config) {
                if (arguments.length == 1) {
                    var promise = new fm.liveswitch.Promise();
                    try {
                        this.doUpdate(config, promise);
                    }
                    catch (exception) {
                        promise.reject(exception);
                    }
                    finally {
                    }
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.updateConnection = function (oldInfo, newInfo) {
                if (arguments.length == 2) {
                    var promise = new fm.liveswitch.Promise();
                    try {
                        this.doUpdateConnection(oldInfo, newInfo, promise);
                    }
                    catch (exception) {
                        promise.reject(exception);
                    }
                    finally {
                    }
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.prototype.videoStream_OnDiscardKeyFrameRequest = function (synchronizationSources) {
                if (arguments.length == 1) {
                    if (((!fm.liveswitch.Global.equals(synchronizationSources, null)) && (synchronizationSources.length > 0))) {
                        this.send(fm.liveswitch.Message.createKeyFrameRequestMessage(synchronizationSources));
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ManagedConnection.fmliveswitchManagedConnectionInitialize = function () {
                if (!fm.liveswitch.ManagedConnection.__fmliveswitchManagedConnectionInitialized && !fm.liveswitch.ManagedConnection.__fmliveswitchManagedConnectionInitializing) {
                    fm.liveswitch.ManagedConnection.__fmliveswitchManagedConnectionInitializing = true;
                    ManagedConnection.fm_liveswitch_ManagedConnection__defaultStatsInterval = 0;
                    fm.liveswitch.ManagedConnection.fm_liveswitch_ManagedConnection___log = fm.liveswitch.Log.getLogger(new fm.liveswitch.Type('[fm.liveswitch.ManagedConnection]'));
                    fm.liveswitch.ManagedConnection.setDefaultStatsInterval(10000);
                    fm.liveswitch.ManagedConnection.__fmliveswitchManagedConnectionInitialized = true;
                    fm.liveswitch.ManagedConnection.__fmliveswitchManagedConnectionInitializing = false;
                }
            };
            /** @hidden */
            ManagedConnection.__fmliveswitchManagedConnectionInitialized = false;
            /** @hidden */
            ManagedConnection.__fmliveswitchManagedConnectionInitializing = false;
            return ManagedConnection;
        }(fm.liveswitch.Dynamic));
        liveswitch.ManagedConnection = ManagedConnection;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Utility to assist with managing the layout of a combined video feed.
        */
        var LayoutUtility = /** @class */ (function () {
            function LayoutUtility() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            LayoutUtility.prototype.getTypeString = function () {
                return '[fm.liveswitch.LayoutUtility]';
            };
            LayoutUtility.floatLocalPreview = function () {
                if (arguments.length == 3) {
                    var layout = arguments[0];
                    var videoLayout = arguments[1];
                    var localConnectionId = arguments[2];
                    var localFrame = null;
                    var remoteFrame = null;
                    if ((!fm.liveswitch.Global.equals(layout, null))) {
                        localFrame = layout.getLocalFrame();
                        var remoteFrames = layout.getRemoteFrames();
                        if (((!fm.liveswitch.Global.equals(remoteFrames, null)) && (remoteFrames.length > 0))) {
                            remoteFrame = remoteFrames[0];
                        }
                    }
                    return fm.liveswitch.LayoutUtility.floatLocalPreview(localFrame, remoteFrame, videoLayout, localConnectionId);
                }
                else if (arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.Layout]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.VideoLayout]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isString(arguments[2]))) {
                    var layout = arguments[0];
                    var videoLayout = arguments[1];
                    var localConnectionId = arguments[2];
                    var viewId = arguments[3];
                    var localFrame = null;
                    var remoteFrame = null;
                    if ((!fm.liveswitch.Global.equals(layout, null))) {
                        localFrame = layout.getLocalFrame();
                        var remoteFrames = layout.getRemoteFrames();
                        if (((!fm.liveswitch.Global.equals(remoteFrames, null)) && (remoteFrames.length > 0))) {
                            for (var _i = 0, remoteFrames_1 = remoteFrames; _i < remoteFrames_1.length; _i++) {
                                var frame3 = remoteFrames_1[_i];
                                var str = frame3.getViewId();
                                if (((!fm.liveswitch.Global.equals(str, null)) && fm.liveswitch.StringExtensions.isEqual(str, viewId))) {
                                    remoteFrame = frame3;
                                }
                            }
                        }
                    }
                    if ((!fm.liveswitch.Global.equals(videoLayout, null))) {
                        for (var _a = 0, _b = fm.liveswitch.HashExtensions.getKeys(videoLayout.getFrames()); _a < _b.length; _a++) {
                            var str2 = _b[_a];
                            var frame = videoLayout.getFrames()[str2];
                            var frame5 = videoLayout.getBounds()[str2];
                            fm.liveswitch.LayoutPreset.transformFrame(frame, layout.getOrigin(), videoLayout.getWidth(), videoLayout.getHeight());
                            fm.liveswitch.LayoutPreset.transformFrame(frame5, layout.getOrigin(), frame.getWidth(), frame.getHeight());
                        }
                    }
                    return fm.liveswitch.LayoutUtility.floatLocalPreview(localFrame, remoteFrame, videoLayout, localConnectionId);
                }
                else if (arguments.length == 5) {
                    var layout = arguments[0];
                    var videoLayout = arguments[1];
                    var localConnectionId = arguments[2];
                    var viewId = arguments[3];
                    var localViewSink = arguments[4];
                    if (((!fm.liveswitch.Global.equals(localViewSink, null)) && (!fm.liveswitch.Global.equals(videoLayout, null)))) {
                        localViewSink.setViewScale((videoLayout.getCrop() ? fm.liveswitch.LayoutScale.Cover : fm.liveswitch.LayoutScale.Contain));
                    }
                    return fm.liveswitch.LayoutUtility.floatLocalPreview(layout, videoLayout, localConnectionId, viewId);
                }
                else if (arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.LayoutFrame]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.LayoutFrame]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[2]) || fm.liveswitch.Util.isObjectType(arguments[2], '[fm.liveswitch.VideoLayout]'))) {
                    var localFrame = arguments[0];
                    var remoteFrame = arguments[1];
                    var videoLayout = arguments[2];
                    var localConnectionId = arguments[3];
                    if (((fm.liveswitch.Global.equals(localFrame, null)) || (fm.liveswitch.Global.equals(remoteFrame, null)))) {
                        return false;
                    }
                    if ((!fm.liveswitch.Global.equals(videoLayout, null))) {
                        var width = remoteFrame.getWidth();
                        var height = remoteFrame.getHeight();
                        var num3 = (width / height);
                        var num4 = videoLayout.getWidth();
                        var num5 = videoLayout.getHeight();
                        var num6 = (num4 / num5);
                        var num7 = width;
                        var num8 = height;
                        var num9 = 0;
                        var num10 = 0;
                        if ((num3 > num6)) {
                            num7 = (height * num6);
                            num9 = ((width - num7) / 2);
                        }
                        else {
                            num8 = (width / num6);
                            num10 = ((height - num8) / 2);
                        }
                        var frames_5 = videoLayout.getFrames();
                        for (var _c = 0, _d = fm.liveswitch.HashExtensions.getKeys(frames_5); _c < _d.length; _c++) {
                            var str = _d[_c];
                            if ((fm.liveswitch.Global.equals(str, localConnectionId))) {
                                var frame = frames_5[str];
                                localFrame.setX((remoteFrame.getX() + (num9 + ((frame.getX() / num4) * num7))));
                                localFrame.setY((remoteFrame.getY() + (num10 + ((frame.getY() / num5) * num8))));
                                localFrame.setWidth(((frame.getWidth() / num4) * num7));
                                localFrame.setHeight(((frame.getHeight() / num5) * num8));
                                return true;
                            }
                        }
                        return false;
                    }
                    localFrame.setX(remoteFrame.getX());
                    localFrame.setY(remoteFrame.getY());
                    localFrame.setWidth(remoteFrame.getWidth());
                    localFrame.setHeight(remoteFrame.getHeight());
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return LayoutUtility;
        }());
        liveswitch.LayoutUtility = LayoutUtility;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="ManagedConnection.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A server connection.
        */
        var ServerConnection = /** @class */ (function (_super) {
            __extends(ServerConnection, _super);
            /** @hidden */
            function ServerConnection(sharedLock, applicationId, channelId, userId, deviceId, clientId, send, connectionType, audioStream, videoStream, dataStream, mediaId) {
                var _this = this;
                fm.liveswitch.ServerConnection.fmliveswitchServerConnectionInitialize();
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 12) {
                    var sharedLock_4 = __arguments[0];
                    var applicationId_15 = __arguments[1];
                    var channelId_2 = __arguments[2];
                    var userId_15 = __arguments[3];
                    var deviceId_12 = __arguments[4];
                    var clientId_9 = __arguments[5];
                    var send_1 = __arguments[6];
                    var connectionType_1 = __arguments[7];
                    var audioStream_2 = __arguments[8];
                    var videoStream_2 = __arguments[9];
                    var dataStream_2 = __arguments[10];
                    var mediaId_2 = __arguments[11];
                    _this = _super.call(this, sharedLock_4, applicationId_15, channelId_2, userId_15, deviceId_12, clientId_9, send_1, connectionType_1, audioStream_2, videoStream_2, dataStream_2, mediaId_2) || this;
                    _this.fmliveswitchServerConnectionInit();
                    _this.__inboundAudioBitrate = -1;
                    _this.__inboundVideoBitrate = -1;
                    _super.prototype.setBundlePolicy.call(_this, fm.liveswitch.BundlePolicy.MaxBundle);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            ServerConnection.prototype.getTypeString = function () {
                return '[fm.liveswitch.ServerConnection]' + ',' + _super.prototype.getTypeString.call(this);
            };
            ServerConnection.prototype.fmliveswitchServerConnectionInit = function () {
                var _this = this;
                this.__inboundAudioBitrate = 0;
                this.__inboundVideoBitrate = 0;
                this.__onInboundAudioBitrateChange = [];
                this.__onInboundVideoBitrateChange = [];
                this._onInboundAudioBitrateChange = function (p0, p1) { for (var _i = 0, _a = _this.__onInboundAudioBitrateChange; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0, p1);
                } };
                this._onInboundVideoBitrateChange = function (p0, p1) { for (var _i = 0, _a = _this.__onInboundVideoBitrateChange; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action(p0, p1);
                } };
            };
            /**
            Adds a handler that is raised when the inbound audio bitrate changes.
            */
            ServerConnection.prototype.addOnInboundAudioBitrateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onInboundAudioBitrateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when the inbound video bitrate changes.
            */
            ServerConnection.prototype.addOnInboundVideoBitrateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onInboundVideoBitrateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a candidate message.
            @param candidate The candidate.
            */
            ServerConnection.prototype.doCreateCandidateMessage = function (candidate) {
                if (arguments.length == 1) {
                    return fm.liveswitch.Message.createCandidateMessage(candidate.toJson());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a close message.
            */
            ServerConnection.prototype.doCreateCloseMessage = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Message.createCloseMessage();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Opens the connection.
            */
            ServerConnection.prototype.doOpen = function () {
                var _this = this;
                if (arguments.length == 0) {
                    _super.prototype.getInternalConnection.call(this).createOffer().then(function (offer) {
                        _this.getInternalConnection().setLocalDescription(offer).then(function (localDescription) {
                            _super.prototype.setLocalAudioFormats.call(_this, fm.liveswitch.FormatInfo.fromSdpMediaDescription(localDescription.getSdpMessage().getAudioDescription()));
                            _super.prototype.setLocalVideoFormats.call(_this, fm.liveswitch.FormatInfo.fromSdpMediaDescription(localDescription.getSdpMessage().getVideoDescription()));
                            _this.send(_this.doCreateOfferMessage(localDescription)).then(function (response) {
                                if ((!fm.liveswitch.Global.equals(response, null))) {
                                    _this.processMessage(response);
                                }
                            }, function (ex) {
                                fm.liveswitch.ServerConnection.fm_liveswitch_ServerConnection___log.error("Could not send offer message.", ex);
                            });
                        }, function (ex) {
                            fm.liveswitch.ServerConnection.fm_liveswitch_ServerConnection___log.error("Could not set local description.", ex);
                            _this.processLocalError(new fm.liveswitch.Error(fm.liveswitch.ErrorCode.LocalDescriptionError, ex));
                        });
                    }, function (ex) {
                        fm.liveswitch.ServerConnection.fm_liveswitch_ServerConnection___log.error("Could not create offer.", ex);
                        _this.processLocalError(new fm.liveswitch.Error(fm.liveswitch.ErrorCode.LocalDescriptionError, ex));
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a message.
            @param message The message.
            */
            ServerConnection.prototype.doProcessMessage = function (message) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getUpdate()))) {
                        var config = fm.liveswitch.ConnectionConfig.fromJson(message.getPayload());
                        var remoteAudioEncoding = _super.prototype.getRemoteAudioEncoding.call(this);
                        var encoding = config.getRemoteAudioEncoding();
                        if ((((!fm.liveswitch.Global.equals(encoding, null)) && (!fm.liveswitch.Global.equals(remoteAudioEncoding, encoding))) && ((fm.liveswitch.Global.equals(remoteAudioEncoding, null)) || !remoteAudioEncoding.isEquivalent(encoding)))) {
                            _super.prototype.setRemoteAudioEncoding.call(this, encoding);
                        }
                        var remoteVideoEncoding = _super.prototype.getRemoteVideoEncoding.call(this);
                        var info4 = config.getRemoteVideoEncoding();
                        if ((((!fm.liveswitch.Global.equals(info4, null)) && (!fm.liveswitch.Global.equals(remoteVideoEncoding, info4))) && ((fm.liveswitch.Global.equals(remoteVideoEncoding, null)) || !remoteVideoEncoding.isEquivalent(info4)))) {
                            _super.prototype.setRemoteVideoEncoding.call(this, info4);
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the current inbound audio bitrate.
            */
            ServerConnection.prototype.getInboundAudioBitrate = function () {
                if (arguments.length == 0) {
                    return this.__inboundAudioBitrate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the current inbound video bitrate.
            */
            ServerConnection.prototype.getInboundVideoBitrate = function () {
                if (arguments.length == 0) {
                    return this.__inboundVideoBitrate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes an answer.
            @param message The message.
            */
            ServerConnection.prototype.processAnswer = function (message) {
                var _this = this;
                if (arguments.length == 1) {
                    _super.prototype.getInternalConnection.call(this).setRemoteDescription(fm.liveswitch.SessionDescription.fromJson(message.getPayload())).then(function (remoteDescription) {
                        _super.prototype.setRemoteAudioFormats.call(_this, fm.liveswitch.FormatInfo.fromSdpMediaDescription(remoteDescription.getSdpMessage().getAudioDescription()));
                        _super.prototype.setRemoteVideoFormats.call(_this, fm.liveswitch.FormatInfo.fromSdpMediaDescription(remoteDescription.getSdpMessage().getVideoDescription()));
                    }, function (ex) {
                        fm.liveswitch.ServerConnection.fm_liveswitch_ServerConnection___log.error("Could not set remote description.", ex);
                        _this.processLocalError(new fm.liveswitch.Error(fm.liveswitch.ErrorCode.RemoteDescriptionError, ex));
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Raises an audio bitrate notification.
            @param audioStream The audio stream.
            @param bitrateNotification The bitrate notification.
            */
            ServerConnection.prototype.raiseAudioBitrateNotification = function (audioStream, bitrateNotification) {
                if (arguments.length == 2) {
                    _super.prototype.raiseAudioBitrateNotification.call(this, audioStream, bitrateNotification);
                    var inboundAudioBitrate = this.getInboundAudioBitrate();
                    var bitrate = bitrateNotification.getBitrate();
                    if ((!fm.liveswitch.Global.equals(inboundAudioBitrate, bitrate))) {
                        this.setInboundAudioBitrate(bitrate);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Raises a video bitrate notification.
            @param videoStream The video stream.
            @param bitrateNotification The bitrate notification.
            */
            ServerConnection.prototype.raiseVideoBitrateNotification = function (videoStream, bitrateNotification) {
                if (arguments.length == 2) {
                    _super.prototype.raiseVideoBitrateNotification.call(this, videoStream, bitrateNotification);
                    var inboundVideoBitrate = this.getInboundVideoBitrate();
                    var bitrate = bitrateNotification.getBitrate();
                    if ((!fm.liveswitch.Global.equals(inboundVideoBitrate, bitrate))) {
                        this.setInboundVideoBitrate(bitrate);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the inbound audio bitrate changes.
            */
            ServerConnection.prototype.removeOnInboundAudioBitrateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onInboundAudioBitrateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the inbound video bitrate changes.
            */
            ServerConnection.prototype.removeOnInboundVideoBitrateChange = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onInboundVideoBitrateChange, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ServerConnection.prototype.setInboundAudioBitrate = function (value) {
                if (arguments.length == 1) {
                    var num = this.__inboundAudioBitrate;
                    this.__inboundAudioBitrate = value;
                    var onInboundAudioBitrateChange = this._onInboundAudioBitrateChange;
                    if ((!fm.liveswitch.Global.equals(onInboundAudioBitrateChange, null))) {
                        onInboundAudioBitrateChange(num, value);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ServerConnection.prototype.setInboundVideoBitrate = function (value) {
                if (arguments.length == 1) {
                    var num = this.__inboundVideoBitrate;
                    this.__inboundVideoBitrate = value;
                    var onInboundVideoBitrateChange = this._onInboundVideoBitrateChange;
                    if ((!fm.liveswitch.Global.equals(onInboundVideoBitrateChange, null))) {
                        onInboundVideoBitrateChange(num, value);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ServerConnection.fmliveswitchServerConnectionInitialize = function () {
                if (!fm.liveswitch.ServerConnection.__fmliveswitchServerConnectionInitialized && !fm.liveswitch.ServerConnection.__fmliveswitchServerConnectionInitializing) {
                    fm.liveswitch.ServerConnection.__fmliveswitchServerConnectionInitializing = true;
                    fm.liveswitch.ServerConnection.fm_liveswitch_ServerConnection___log = fm.liveswitch.Log.getLogger(new fm.liveswitch.Type('[fm.liveswitch.ServerConnection]'));
                    fm.liveswitch.ServerConnection.__fmliveswitchServerConnectionInitialized = true;
                    fm.liveswitch.ServerConnection.__fmliveswitchServerConnectionInitializing = false;
                }
            };
            /** @hidden */
            ServerConnection.__fmliveswitchServerConnectionInitialized = false;
            /** @hidden */
            ServerConnection.__fmliveswitchServerConnectionInitializing = false;
            return ServerConnection;
        }(fm.liveswitch.ManagedConnection));
        liveswitch.ServerConnection = ServerConnection;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="ServerConnection.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        An MCU connection.
        */
        var McuConnection = /** @class */ (function (_super) {
            __extends(McuConnection, _super);
            /** @hidden */
            function McuConnection(sharedLock, applicationId, channelId, userId, deviceId, clientId, send, audioStream, videoStream, dataStream, mediaId) {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 11) {
                    var sharedLock_5 = __arguments[0];
                    var applicationId_16 = __arguments[1];
                    var channelId_3 = __arguments[2];
                    var userId_16 = __arguments[3];
                    var deviceId_13 = __arguments[4];
                    var clientId_10 = __arguments[5];
                    var send_2 = __arguments[6];
                    var audioStream_3 = __arguments[7];
                    var videoStream_3 = __arguments[8];
                    var dataStream_3 = __arguments[9];
                    var mediaId_3 = __arguments[10];
                    _this = _super.call(this, sharedLock_5, applicationId_16, channelId_3, userId_16, deviceId_13, clientId_10, send_2, fm.liveswitch.ConnectionType.getMcu(), audioStream_3, videoStream_3, dataStream_3, mediaId_3) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            McuConnection.prototype.getTypeString = function () {
                return '[fm.liveswitch.McuConnection]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Creates an offer message.
            @param offer The offer.
            */
            McuConnection.prototype.doCreateOfferMessage = function (offer) {
                if (arguments.length == 1) {
                    return fm.liveswitch.Message.createMcuOfferMessage(_super.prototype.getTag.call(this), offer.toJson());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the given media direction is allowed for this connection.
            @param direction The direction.
            */
            McuConnection.prototype.isMediaDirectionAllowed = function (direction) {
                if (arguments.length == 1) {
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return McuConnection;
        }(fm.liveswitch.ServerConnection));
        liveswitch.McuConnection = McuConnection;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="ManagedConnection.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A peer connection.
        */
        var PeerConnection = /** @class */ (function (_super) {
            __extends(PeerConnection, _super);
            function PeerConnection() {
                var _this = this;
                fm.liveswitch.PeerConnection.fmliveswitchPeerConnectionInitialize();
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 11 && (fm.liveswitch.Util.isNullOrUndefined(arguments[7]) || fm.liveswitch.Util.isObjectType(arguments[7], '[fm.liveswitch.PeerConnectionOffer]'))) {
                    var sharedLock = __arguments[0];
                    var applicationId = __arguments[1];
                    var channelId = __arguments[2];
                    var userId = __arguments[3];
                    var deviceId = __arguments[4];
                    var clientId = __arguments[5];
                    var send = __arguments[6];
                    var peerConnectionOffer = __arguments[7];
                    var audioStream = __arguments[8];
                    var videoStream = __arguments[9];
                    var dataStream = __arguments[10];
                    _this = _super.call(this, sharedLock, applicationId, channelId, userId, deviceId, clientId, send, fm.liveswitch.ConnectionType.getPeer(), audioStream, videoStream, dataStream, null) || this;
                    _this.setRemoteClientInfo(peerConnectionOffer.getRemoteClientInfo());
                    _super.prototype.setRemoteConnectionId.call(_this, peerConnectionOffer.getRemoteConnectionId());
                    _super.prototype.setRemoteTag.call(_this, peerConnectionOffer.getConnectionTag());
                    _this.setRole(fm.liveswitch.PeerRole.Answerer);
                    _this.__pendingRemoteDescription = peerConnectionOffer.getOffer();
                }
                else if (__arguments.length == 11 && (fm.liveswitch.Util.isNullOrUndefined(arguments[7]) || fm.liveswitch.Util.isObjectType(arguments[7], '[fm.liveswitch.ClientInfo]'))) {
                    var sharedLock = __arguments[0];
                    var applicationId = __arguments[1];
                    var channelId = __arguments[2];
                    var userId = __arguments[3];
                    var deviceId = __arguments[4];
                    var clientId = __arguments[5];
                    var send = __arguments[6];
                    var remoteClientInfo = __arguments[7];
                    var audioStream = __arguments[8];
                    var videoStream = __arguments[9];
                    var dataStream = __arguments[10];
                    _this = _super.call(this, sharedLock, applicationId, channelId, userId, deviceId, clientId, send, fm.liveswitch.ConnectionType.getPeer(), audioStream, videoStream, dataStream, null) || this;
                    _this.setRemoteClientInfo(remoteClientInfo);
                    _super.prototype.setRemoteConnectionId.call(_this, null);
                    _super.prototype.setRemoteTag.call(_this, null);
                    _this.setRole(fm.liveswitch.PeerRole.Offerer);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            PeerConnection.prototype.getTypeString = function () {
                return '[fm.liveswitch.PeerConnection]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Creates a candidate message.
            @param candidate The candidate.
            */
            PeerConnection.prototype.doCreateCandidateMessage = function (candidate) {
                if (arguments.length == 1) {
                    return fm.liveswitch.Message.createPeerCandidateMessage(candidate.toJson(), this.getRemoteClientInfo().getUserId(), this.getRemoteClientInfo().getDeviceId(), this.getRemoteClientInfo().getId());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a close message.
            */
            PeerConnection.prototype.doCreateCloseMessage = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Message.createPeerCloseMessage(this.getRemoteClientInfo().getUserId(), this.getRemoteClientInfo().getDeviceId(), this.getRemoteClientInfo().getId());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates an update message.
            @param config The connection config.
            */
            PeerConnection.prototype.doCreateUpdateMessage = function (config) {
                if (arguments.length == 1) {
                    return fm.liveswitch.Message.createUpdateMessage(config.toJson(), this.getRemoteClientInfo().getUserId(), this.getRemoteClientInfo().getDeviceId(), this.getRemoteClientInfo().getId());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Opens the connection.
            */
            PeerConnection.prototype.doOpen = function () {
                var _this = this;
                if (arguments.length == 0) {
                    var resolveAction = null;
                    var rejectAction = null;
                    var action3 = null;
                    var action4 = null;
                    if ((fm.liveswitch.Global.equals(this.getRole(), fm.liveswitch.PeerRole.Offerer))) {
                        if ((fm.liveswitch.Global.equals(resolveAction, null))) {
                            resolveAction = function (offer) {
                                _this.getInternalConnection().setLocalDescription(offer).then(function (localDescription) {
                                    _super.prototype.setLocalAudioFormats.call(_this, fm.liveswitch.FormatInfo.fromSdpMediaDescription(localDescription.getSdpMessage().getAudioDescription()));
                                    _super.prototype.setLocalVideoFormats.call(_this, fm.liveswitch.FormatInfo.fromSdpMediaDescription(localDescription.getSdpMessage().getVideoDescription()));
                                    _this.send(fm.liveswitch.Message.createPeerOfferMessage(_super.prototype.getTag.call(_this), localDescription.toJson(), _this.getRemoteClientInfo().getUserId(), _this.getRemoteClientInfo().getDeviceId(), _this.getRemoteClientInfo().getId())).fail(function (ex) {
                                        fm.liveswitch.PeerConnection.fm_liveswitch_PeerConnection___log.error("Could not send offer message.", ex);
                                    });
                                }, function (ex) {
                                    fm.liveswitch.PeerConnection.fm_liveswitch_PeerConnection___log.error("Could not set local description.", ex);
                                    _this.processLocalError(new fm.liveswitch.Error(fm.liveswitch.ErrorCode.LocalDescriptionError, ex));
                                });
                            };
                        }
                        if ((fm.liveswitch.Global.equals(rejectAction, null))) {
                            rejectAction = function (ex) {
                                fm.liveswitch.PeerConnection.fm_liveswitch_PeerConnection___log.error("Could not create offer.", ex);
                                _this.processLocalError(new fm.liveswitch.Error(fm.liveswitch.ErrorCode.LocalDescriptionError, ex));
                            };
                        }
                        _super.prototype.getInternalConnection.call(this).createOffer().then(resolveAction, rejectAction);
                    }
                    else {
                        _super.prototype.getInternalConnection.call(this).setExternalId(_super.prototype.getRemoteConnectionId.call(this));
                        if ((fm.liveswitch.Global.equals(action3, null))) {
                            action3 = function (remoteDescription) {
                                _super.prototype.setRemoteAudioFormats.call(_this, fm.liveswitch.FormatInfo.fromSdpMediaDescription(remoteDescription.getSdpMessage().getAudioDescription()));
                                _super.prototype.setRemoteVideoFormats.call(_this, fm.liveswitch.FormatInfo.fromSdpMediaDescription(remoteDescription.getSdpMessage().getVideoDescription()));
                                _this.getInternalConnection().createAnswer().then(function (answer) {
                                    _this.getInternalConnection().setLocalDescription(answer).then(function (localDescription) {
                                        _super.prototype.setLocalAudioFormats.call(_this, fm.liveswitch.FormatInfo.fromSdpMediaDescription(localDescription.getSdpMessage().getAudioDescription()));
                                        _super.prototype.setLocalVideoFormats.call(_this, fm.liveswitch.FormatInfo.fromSdpMediaDescription(localDescription.getSdpMessage().getVideoDescription()));
                                        _this.send(fm.liveswitch.Message.createPeerAnswerMessage(_super.prototype.getTag.call(_this), localDescription.toJson(), _this.getRemoteClientInfo().getUserId(), _this.getRemoteClientInfo().getDeviceId(), _this.getRemoteClientInfo().getId())).fail(function (ex) {
                                            fm.liveswitch.PeerConnection.fm_liveswitch_PeerConnection___log.error("Could not send answer message.", ex);
                                        });
                                    }, function (ex) {
                                        fm.liveswitch.PeerConnection.fm_liveswitch_PeerConnection___log.error("Could not set local description.", ex);
                                        _this.processLocalError(new fm.liveswitch.Error(fm.liveswitch.ErrorCode.LocalDescriptionError, ex));
                                        _this.sendErrorToPeer(ex);
                                    });
                                }, function (ex) {
                                    fm.liveswitch.PeerConnection.fm_liveswitch_PeerConnection___log.error("Could not create answer.", ex);
                                    _this.processLocalError(new fm.liveswitch.Error(fm.liveswitch.ErrorCode.LocalDescriptionError, ex));
                                    _this.sendErrorToPeer(ex);
                                });
                            };
                        }
                        if ((fm.liveswitch.Global.equals(action4, null))) {
                            action4 = function (ex) {
                                fm.liveswitch.PeerConnection.fm_liveswitch_PeerConnection___log.error("Could not set remote description.", ex);
                                _this.processLocalError(new fm.liveswitch.Error(fm.liveswitch.ErrorCode.RemoteDescriptionError, ex));
                                _this.sendErrorToPeer(ex);
                            };
                        }
                        _super.prototype.getInternalConnection.call(this).setRemoteDescription(this.__pendingRemoteDescription).then(action3, action4);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a message.
            @param message The message.
            */
            PeerConnection.prototype.doProcessMessage = function (message) {
                var _this = this;
                if (arguments.length == 1) {
                    var rejectAction = null;
                    if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getUpdate()))) {
                        var config = fm.liveswitch.ConnectionConfig.fromJson(message.getPayload());
                        var sendReceive = fm.liveswitch.StreamDirection.SendReceive;
                        sendReceive = fm.liveswitch.StreamDirectionHelper.setReceiveDisabled(fm.liveswitch.StreamDirectionHelper.setSendDisabled(sendReceive, _super.prototype.getRemoteAudioDisabled.call(this)), _super.prototype.getLocalAudioDisabled.call(this));
                        var direction = fm.liveswitch.StreamDirection.SendReceive;
                        direction = fm.liveswitch.StreamDirectionHelper.setReceiveDisabled(fm.liveswitch.StreamDirectionHelper.setSendDisabled(direction, _super.prototype.getRemoteAudioDisabled.call(this)), _super.prototype.getLocalAudioDisabled.call(this));
                        var direction3 = fm.liveswitch.StreamDirection.SendReceive;
                        direction3 = fm.liveswitch.StreamDirectionHelper.setReceiveDisabled(fm.liveswitch.StreamDirectionHelper.setSendDisabled(direction3, _super.prototype.getRemoteDataDisabled.call(this)), _super.prototype.getLocalDataDisabled.call(this));
                        var oldInfo = new fm.liveswitch.ConnectionInfo(this.getRemoteClientInfo().getUserId(), this.getRemoteClientInfo().getUserAlias(), this.getRemoteClientInfo().getDeviceId(), this.getRemoteClientInfo().getDeviceAlias(), this.getRemoteClientInfo().getId(), this.getRemoteClientInfo().getTag(), this.getRemoteClientInfo().getRoles(), _super.prototype.getRemoteConnectionId.call(this), _super.prototype.getRemoteTag.call(this), _super.prototype.getType.call(this), _super.prototype.getRemoteMediaId.call(this), _super.prototype.getRemoteAudioMuted.call(this), _super.prototype.getRemoteVideoMuted.call(this), fm.liveswitch.StreamDirectionHelper.directionToString(sendReceive), fm.liveswitch.StreamDirectionHelper.directionToString(direction), fm.liveswitch.StreamDirectionHelper.directionToString(direction3), _super.prototype.getRemoteAudioFormats.call(this), _super.prototype.getRemoteVideoFormats.call(this));
                        _super.prototype.setRemoteTag.call(this, config.getTag());
                        var newInfo = new fm.liveswitch.ConnectionInfo(this.getRemoteClientInfo().getUserId(), this.getRemoteClientInfo().getUserAlias(), this.getRemoteClientInfo().getDeviceId(), this.getRemoteClientInfo().getDeviceAlias(), this.getRemoteClientInfo().getId(), this.getRemoteClientInfo().getTag(), this.getRemoteClientInfo().getRoles(), _super.prototype.getRemoteConnectionId.call(this), _super.prototype.getRemoteTag.call(this), _super.prototype.getType.call(this), _super.prototype.getRemoteMediaId.call(this), config.getLocalAudioMuted(), config.getLocalVideoMuted(), config.getAudioDirection(), config.getVideoDirection(), config.getDataDirection(), _super.prototype.getRemoteAudioFormats.call(this), _super.prototype.getRemoteVideoFormats.call(this));
                        if ((fm.liveswitch.Global.equals(rejectAction, null))) {
                            rejectAction = function (ex) {
                                fm.liveswitch.PeerConnection.fm_liveswitch_PeerConnection___log.error(fm.liveswitch.StringExtensions.format("Could not update peer connection {0}.", _super.prototype.getId.call(_this)), ex);
                            };
                        }
                        _super.prototype.updateConnection.call(this, oldInfo, newInfo).fail(rejectAction);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote client information.
            */
            PeerConnection.prototype.getRemoteClientInfo = function () {
                if (arguments.length == 0) {
                    return this._remoteClientInfo;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the role.
            */
            PeerConnection.prototype.getRole = function () {
                if (arguments.length == 0) {
                    return this._role;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the given media direction is allowed for this connection.
            @param direction The direction.
            */
            PeerConnection.prototype.isMediaDirectionAllowed = function (direction) {
                if (arguments.length == 1) {
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes an answer.
            @param message The message.
            */
            PeerConnection.prototype.processAnswer = function (message) {
                var _this = this;
                if (arguments.length == 1) {
                    _super.prototype.setRemoteConnectionId.call(this, message.getRemoteConnectionId());
                    _super.prototype.setRemoteTag.call(this, message.getConnectionTag());
                    _super.prototype.getInternalConnection.call(this).setExternalId(message.getRemoteConnectionId());
                    _super.prototype.getInternalConnection.call(this).setRemoteDescription(fm.liveswitch.SessionDescription.fromJson(message.getPayload())).then(function (remoteDescription) {
                        _super.prototype.setRemoteAudioFormats.call(_this, fm.liveswitch.FormatInfo.fromSdpMediaDescription(remoteDescription.getSdpMessage().getAudioDescription()));
                        _super.prototype.setRemoteVideoFormats.call(_this, fm.liveswitch.FormatInfo.fromSdpMediaDescription(remoteDescription.getSdpMessage().getVideoDescription()));
                    }, function (ex) {
                        fm.liveswitch.PeerConnection.fm_liveswitch_PeerConnection___log.error("Could not set remote description.", ex);
                        _this.processLocalError(new fm.liveswitch.Error(fm.liveswitch.ErrorCode.RemoteDescriptionError, ex));
                        _this.sendErrorToPeer(ex);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sends a message.
            @param message The message.
            */
            PeerConnection.prototype.send = function (message) {
                if (arguments.length == 1) {
                    message.setRemoteConnectionId(_super.prototype.getRemoteConnectionId.call(this));
                    return _super.prototype.send.call(this, message);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PeerConnection.prototype.sendErrorToPeer = function (ex) {
                if (arguments.length == 1) {
                    var error = _super.prototype.getInternalConnection.call(this).getError();
                    if (((!fm.liveswitch.Global.equals(error, null)) && (fm.liveswitch.Global.equals(error.getCode(), fm.liveswitch.ErrorCode.ConnectionInvalidArchitecture)))) {
                        this.send(fm.liveswitch.Message.createErrorMessage(fm.liveswitch.ErrorType.getSdpStreamMismatch(), this.getRemoteClientInfo().getUserId(), this.getRemoteClientInfo().getDeviceId(), this.getRemoteClientInfo().getId())).fail(function (ex2) {
                            fm.liveswitch.PeerConnection.fm_liveswitch_PeerConnection___log.error("Could not send error message.", ex2);
                        });
                    }
                    else {
                        if (((!fm.liveswitch.Global.equals(error, null)) && (fm.liveswitch.Global.equals(error.getCode(), fm.liveswitch.ErrorCode.ConnectionSimulcastNotSupported)))) {
                            this.send(fm.liveswitch.Message.createErrorMessage(fm.liveswitch.ErrorType.getSdpSimulcastMismatch(), this.getRemoteClientInfo().getUserId(), this.getRemoteClientInfo().getDeviceId(), this.getRemoteClientInfo().getId())).fail(function (ex2) {
                                fm.liveswitch.PeerConnection.fm_liveswitch_PeerConnection___log.error("Could not send error message.", ex2);
                            });
                        }
                        else {
                            this.send(fm.liveswitch.Message.createErrorMessage(fm.liveswitch.ErrorType.getSdpCodecMismatch(), this.getRemoteClientInfo().getUserId(), this.getRemoteClientInfo().getDeviceId(), this.getRemoteClientInfo().getId())).fail(function (ex2) {
                                fm.liveswitch.PeerConnection.fm_liveswitch_PeerConnection___log.error("Could not send error message.", ex2);
                            });
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PeerConnection.prototype.setRemoteClientInfo = function (value) {
                if (arguments.length == 1) {
                    this._remoteClientInfo = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PeerConnection.prototype.setRole = function (value) {
                if (arguments.length == 1) {
                    this._role = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PeerConnection.fmliveswitchPeerConnectionInitialize = function () {
                if (!fm.liveswitch.PeerConnection.__fmliveswitchPeerConnectionInitialized && !fm.liveswitch.PeerConnection.__fmliveswitchPeerConnectionInitializing) {
                    fm.liveswitch.PeerConnection.__fmliveswitchPeerConnectionInitializing = true;
                    fm.liveswitch.PeerConnection.fm_liveswitch_PeerConnection___log = fm.liveswitch.Log.getLogger(new fm.liveswitch.Type('[fm.liveswitch.PeerConnection]'));
                    fm.liveswitch.PeerConnection.__fmliveswitchPeerConnectionInitialized = true;
                    fm.liveswitch.PeerConnection.__fmliveswitchPeerConnectionInitializing = false;
                }
            };
            /** @hidden */
            PeerConnection.__fmliveswitchPeerConnectionInitialized = false;
            /** @hidden */
            PeerConnection.__fmliveswitchPeerConnectionInitializing = false;
            return PeerConnection;
        }(fm.liveswitch.ManagedConnection));
        liveswitch.PeerConnection = PeerConnection;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A peer connection offer.
        */
        var PeerConnectionOffer = /** @class */ (function () {
            /** @hidden */
            function PeerConnectionOffer(channel, remoteClientInfo, remoteConnectionId, connectionTag, offer) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 5) {
                    var channel_2 = __arguments[0];
                    var remoteClientInfo_1 = __arguments[1];
                    var remoteConnectionId_1 = __arguments[2];
                    var connectionTag_1 = __arguments[3];
                    var offer_1 = __arguments[4];
                    //super();
                    this.fmliveswitchPeerConnectionOfferInit();
                    this.__lock = new Object();
                    this.__earlyCandidateMessages = new Array();
                    this.setChannel(channel_2);
                    this.setRemoteClientInfo(remoteClientInfo_1);
                    this.setRemoteConnectionId(remoteConnectionId_1);
                    this.setConnectionTag(connectionTag_1);
                    this.setOffer(offer_1);
                    for (var _i = 0, _a = this.getOffer().getSdpMessage().getMediaDescriptions(); _i < _a.length; _i++) {
                        var description = _a[_i];
                        if ((fm.liveswitch.Global.equals(description.getMedia().getMediaType(), fm.liveswitch.sdp.MediaType.getAudio()))) {
                            this.setHasAudio(true);
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(description.getMedia().getMediaType(), fm.liveswitch.sdp.MediaType.getVideo()))) {
                                this.setHasVideo(true);
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(description.getMedia().getMediaType(), fm.liveswitch.sdp.MediaType.getApplication()))) {
                                    this.setHasData(true);
                                }
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            PeerConnectionOffer.prototype.getTypeString = function () {
                return '[fm.liveswitch.PeerConnectionOffer]';
            };
            PeerConnectionOffer.prototype.fmliveswitchPeerConnectionOfferInit = function () {
                var _this = this;
                this.__onCancel = [];
                this._hasAudio = false;
                this._hasData = false;
                this._hasVideo = false;
                this._onCancel = function () { for (var _i = 0, _a = _this.__onCancel; _i < _a.length; _i++) {
                    var action = _a[_i];
                    action();
                } };
                this._remoteClosed = false;
                this._remoteFailed = false;
            };
            PeerConnectionOffer.prototype.accept = function () {
                if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.AudioStream]'))) {
                    var audioStream = arguments[0];
                    return this.getChannel().createPeerConnection(this, audioStream);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.AudioStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.DataStream]'))) {
                    var audioStream = arguments[0];
                    var dataStream = arguments[1];
                    return this.getChannel().createPeerConnection(this, audioStream, dataStream);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.AudioStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.VideoStream]'))) {
                    var audioStream = arguments[0];
                    var videoStream = arguments[1];
                    return this.getChannel().createPeerConnection(this, audioStream, videoStream);
                }
                else if (arguments.length == 3) {
                    var audioStream = arguments[0];
                    var videoStream = arguments[1];
                    var dataStream = arguments[2];
                    return this.getChannel().createPeerConnection(this, audioStream, videoStream, dataStream);
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.DataStream]'))) {
                    var dataStream = arguments[0];
                    return this.getChannel().createPeerConnection(this, dataStream);
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.VideoStream]'))) {
                    var videoStream = arguments[0];
                    return this.getChannel().createPeerConnection(this, videoStream);
                }
                else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.VideoStream]')) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.DataStream]'))) {
                    var videoStream = arguments[0];
                    var dataStream = arguments[1];
                    return this.getChannel().createPeerConnection(this, videoStream, dataStream);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Adds a handler that is raised when the offer is withdrawn.
            */
            PeerConnectionOffer.prototype.addOnCancel = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.add(this.__onCancel, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the channel.
            */
            PeerConnectionOffer.prototype.getChannel = function () {
                if (arguments.length == 0) {
                    return this._channel;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connection tag.
            */
            PeerConnectionOffer.prototype.getConnectionTag = function () {
                if (arguments.length == 0) {
                    return this._connectionTag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PeerConnectionOffer.prototype.getEarlyCandidateMessages = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ArrayExtensions.toArray(this.__earlyCandidateMessages);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the offer includes an audio description.
            */
            PeerConnectionOffer.prototype.getHasAudio = function () {
                if (arguments.length == 0) {
                    return this._hasAudio;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the offer includes a data description.
            */
            PeerConnectionOffer.prototype.getHasData = function () {
                if (arguments.length == 0) {
                    return this._hasData;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the offer includes a video description.
            */
            PeerConnectionOffer.prototype.getHasVideo = function () {
                if (arguments.length == 0) {
                    return this._hasVideo;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the offer.
            */
            PeerConnectionOffer.prototype.getOffer = function () {
                if (arguments.length == 0) {
                    return this._offer;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote client information.
            */
            PeerConnectionOffer.prototype.getRemoteClientInfo = function () {
                if (arguments.length == 0) {
                    return this._remoteClientInfo;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the connection was closed by the remote host.
            */
            PeerConnectionOffer.prototype.getRemoteClosed = function () {
                if (arguments.length == 0) {
                    return this._remoteClosed;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote connection identifier.
            */
            PeerConnectionOffer.prototype.getRemoteConnectionId = function () {
                if (arguments.length == 0) {
                    return this._remoteConnectionId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the connection was failed by the remote host.
            */
            PeerConnectionOffer.prototype.getRemoteFailed = function () {
                if (arguments.length == 0) {
                    return this._remoteFailed;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PeerConnectionOffer.prototype.processMessage = function (message) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getCandidate()))) {
                        fm.liveswitch.ArrayExtensions.add(this.__earlyCandidateMessages, message);
                    }
                    else {
                        var onCancel = void 0;
                        if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getClose()))) {
                            this.setRemoteClosed(true);
                            onCancel = this._onCancel;
                            if ((!fm.liveswitch.Global.equals(onCancel, null))) {
                                onCancel();
                            }
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(message.getType(), fm.liveswitch.MessageType.getFail()))) {
                                this.setRemoteFailed(true);
                                onCancel = this._onCancel;
                                if ((!fm.liveswitch.Global.equals(onCancel, null))) {
                                    onCancel();
                                }
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Rejects this instance.
            */
            PeerConnectionOffer.prototype.reject = function () {
                if (arguments.length == 0) {
                    return this.getChannel().rejectPeerConnection(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Removes a handler that is raised when the offer is withdrawn.
            */
            PeerConnectionOffer.prototype.removeOnCancel = function (value) {
                if (arguments.length == 1) {
                    fm.liveswitch.ArrayExtensions.remove(this.__onCancel, value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PeerConnectionOffer.prototype.setChannel = function (value) {
                if (arguments.length == 1) {
                    this._channel = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PeerConnectionOffer.prototype.setConnectionTag = function (value) {
                if (arguments.length == 1) {
                    this._connectionTag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PeerConnectionOffer.prototype.setHasAudio = function (value) {
                if (arguments.length == 1) {
                    this._hasAudio = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PeerConnectionOffer.prototype.setHasData = function (value) {
                if (arguments.length == 1) {
                    this._hasData = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PeerConnectionOffer.prototype.setHasVideo = function (value) {
                if (arguments.length == 1) {
                    this._hasVideo = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PeerConnectionOffer.prototype.setOffer = function (value) {
                if (arguments.length == 1) {
                    this._offer = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PeerConnectionOffer.prototype.setRemoteClientInfo = function (value) {
                if (arguments.length == 1) {
                    this._remoteClientInfo = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PeerConnectionOffer.prototype.setRemoteClosed = function (value) {
                if (arguments.length == 1) {
                    this._remoteClosed = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PeerConnectionOffer.prototype.setRemoteConnectionId = function (value) {
                if (arguments.length == 1) {
                    this._remoteConnectionId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            PeerConnectionOffer.prototype.setRemoteFailed = function (value) {
                if (arguments.length == 1) {
                    this._remoteFailed = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return PeerConnectionOffer;
        }());
        liveswitch.PeerConnectionOffer = PeerConnectionOffer;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var PeerRoleWrapper = /** @class */ (function () {
            function PeerRoleWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_63 = __arguments[0];
                    //super();
                    this._value = value_63;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            PeerRoleWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.PeerRoleWrapper]';
            };
            PeerRoleWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.PeerRole.Offerer)
                        return 'Offerer';
                    if (this._value == fm.liveswitch.PeerRole.Answerer)
                        return 'Answerer';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return PeerRoleWrapper;
        }());
        liveswitch.PeerRoleWrapper = PeerRoleWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="ServerConnection.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        An SFU connection.
        */
        var SfuConnection = /** @class */ (function (_super) {
            __extends(SfuConnection, _super);
            /** @hidden */
            function SfuConnection(sharedLock, applicationId, channelId, userId, deviceId, clientId, send, audioStream, videoStream, dataStream, mediaId) {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 11) {
                    var sharedLock_6 = __arguments[0];
                    var applicationId_17 = __arguments[1];
                    var channelId_4 = __arguments[2];
                    var userId_17 = __arguments[3];
                    var deviceId_14 = __arguments[4];
                    var clientId_11 = __arguments[5];
                    var send_3 = __arguments[6];
                    var audioStream_4 = __arguments[7];
                    var videoStream_4 = __arguments[8];
                    var dataStream_4 = __arguments[9];
                    var mediaId_4 = __arguments[10];
                    _this = _super.call(this, sharedLock_6, applicationId_17, channelId_4, userId_17, deviceId_14, clientId_11, send_3, fm.liveswitch.ConnectionType.getSfu(), audioStream_4, videoStream_4, dataStream_4, mediaId_4) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            SfuConnection.prototype.getTypeString = function () {
                return '[fm.liveswitch.SfuConnection]' + ',' + _super.prototype.getTypeString.call(this);
            };
            return SfuConnection;
        }(fm.liveswitch.ServerConnection));
        liveswitch.SfuConnection = SfuConnection;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="SfuConnection.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        An SFU receiving connection.
        */
        var SfuDownstreamConnection = /** @class */ (function (_super) {
            __extends(SfuDownstreamConnection, _super);
            function SfuDownstreamConnection() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 11 && (fm.liveswitch.Util.isNullOrUndefined(arguments[7]) || fm.liveswitch.Util.isObjectType(arguments[7], '[fm.liveswitch.ConnectionInfo]'))) {
                    var sharedLock = __arguments[0];
                    var applicationId = __arguments[1];
                    var channelId = __arguments[2];
                    var userId = __arguments[3];
                    var deviceId = __arguments[4];
                    var clientId = __arguments[5];
                    var send = __arguments[6];
                    var remoteConnectionInfo = __arguments[7];
                    var audioStream = __arguments[8];
                    var videoStream = __arguments[9];
                    var dataStream = __arguments[10];
                    _this = _super.call(this, sharedLock, applicationId, channelId, userId, deviceId, clientId, send, audioStream, videoStream, dataStream, null) || this;
                    _this.setRemoteConnectionInfo(remoteConnectionInfo);
                    if ((!fm.liveswitch.Global.equals(remoteConnectionInfo, null))) {
                        _super.prototype.setRemoteConnectionId.call(_this, remoteConnectionInfo.getId());
                    }
                    _this.initialize(audioStream, videoStream, dataStream);
                }
                else if (__arguments.length == 11 && (fm.liveswitch.Util.isNullOrUndefined(arguments[7]) || fm.liveswitch.Util.isString(arguments[7]))) {
                    var sharedLock = __arguments[0];
                    var applicationId = __arguments[1];
                    var channelId = __arguments[2];
                    var userId = __arguments[3];
                    var deviceId = __arguments[4];
                    var clientId = __arguments[5];
                    var send = __arguments[6];
                    var remoteMediaId = __arguments[7];
                    var audioStream = __arguments[8];
                    var videoStream = __arguments[9];
                    var dataStream = __arguments[10];
                    _this = _super.call(this, sharedLock, applicationId, channelId, userId, deviceId, clientId, send, audioStream, videoStream, dataStream, null) || this;
                    _super.prototype.setRemoteMediaId.call(_this, remoteMediaId);
                    _this.initialize(audioStream, videoStream, dataStream);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            SfuDownstreamConnection.prototype.getTypeString = function () {
                return '[fm.liveswitch.SfuDownstreamConnection]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Creates an offer message.
            @param offer The offer.
            */
            SfuDownstreamConnection.prototype.doCreateOfferMessage = function (offer) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(this.getRemoteConnectionInfo(), null))) {
                        return fm.liveswitch.Message.createSfuOfferMessage(_super.prototype.getTag.call(this), offer.toJson(), this.getRemoteConnectionInfo().getUserId(), this.getRemoteConnectionInfo().getDeviceId(), this.getRemoteConnectionInfo().getClientId(), this.getRemoteConnectionInfo().getId());
                    }
                    if ((!fm.liveswitch.Global.equals(_super.prototype.getRemoteMediaId.call(this), null))) {
                        return fm.liveswitch.Message.createSfuOfferMessage(_super.prototype.getTag.call(this), offer.toJson(), _super.prototype.getRemoteMediaId.call(this));
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote connection information, if available.
            */
            SfuDownstreamConnection.prototype.getRemoteConnectionInfo = function () {
                if (arguments.length == 0) {
                    return this._remoteConnectionInfo;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SfuDownstreamConnection.prototype.initialize = function (audioStream, videoStream, dataStream) {
                if (arguments.length == 3) {
                    _super.prototype.setMediaId.call(this, null);
                    if ((!fm.liveswitch.Global.equals(audioStream, null))) {
                        if ((fm.liveswitch.Global.equals(audioStream.getLocalDirection(), fm.liveswitch.StreamDirection.SendReceive))) {
                            audioStream.setLocalDirection(fm.liveswitch.StreamDirection.ReceiveOnly);
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(audioStream.getLocalDirection(), fm.liveswitch.StreamDirection.SendOnly))) {
                                audioStream.setLocalDirection(fm.liveswitch.StreamDirection.Inactive);
                            }
                        }
                    }
                    if ((!fm.liveswitch.Global.equals(videoStream, null))) {
                        if ((fm.liveswitch.Global.equals(videoStream.getLocalDirection(), fm.liveswitch.StreamDirection.SendReceive))) {
                            videoStream.setLocalDirection(fm.liveswitch.StreamDirection.ReceiveOnly);
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(videoStream.getLocalDirection(), fm.liveswitch.StreamDirection.SendOnly))) {
                                videoStream.setLocalDirection(fm.liveswitch.StreamDirection.Inactive);
                            }
                        }
                    }
                    if ((!fm.liveswitch.Global.equals(dataStream, null))) {
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the given media direction is allowed for this connection.
            @param direction The direction.
            */
            SfuDownstreamConnection.prototype.isMediaDirectionAllowed = function (direction) {
                if (arguments.length == 1) {
                    return fm.liveswitch.StreamDirectionHelper.isSendDisabled(direction);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SfuDownstreamConnection.prototype.setRemoteConnectionInfo = function (value) {
                if (arguments.length == 1) {
                    this._remoteConnectionInfo = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return SfuDownstreamConnection;
        }(fm.liveswitch.SfuConnection));
        liveswitch.SfuDownstreamConnection = SfuDownstreamConnection;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="SfuConnection.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        An SFU sending connection.
        */
        var SfuUpstreamConnection = /** @class */ (function (_super) {
            __extends(SfuUpstreamConnection, _super);
            /** @hidden */
            function SfuUpstreamConnection(sharedLock, applicationId, channelId, userId, deviceId, clientId, send, audioStream, videoStream, dataStream, mediaId) {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 11) {
                    var sharedLock_7 = __arguments[0];
                    var applicationId_18 = __arguments[1];
                    var channelId_5 = __arguments[2];
                    var userId_18 = __arguments[3];
                    var deviceId_15 = __arguments[4];
                    var clientId_12 = __arguments[5];
                    var send_4 = __arguments[6];
                    var audioStream_5 = __arguments[7];
                    var videoStream_5 = __arguments[8];
                    var dataStream_5 = __arguments[9];
                    var mediaId_5 = __arguments[10];
                    _this = _super.call(this, sharedLock_7, applicationId_18, channelId_5, userId_18, deviceId_15, clientId_12, send_4, audioStream_5, videoStream_5, dataStream_5, mediaId_5) || this;
                    if ((!fm.liveswitch.Global.equals(audioStream_5, null))) {
                        if ((fm.liveswitch.Global.equals(audioStream_5.getLocalDirection(), fm.liveswitch.StreamDirection.SendReceive))) {
                            audioStream_5.setLocalDirection(fm.liveswitch.StreamDirection.SendOnly);
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(audioStream_5.getLocalDirection(), fm.liveswitch.StreamDirection.ReceiveOnly))) {
                                audioStream_5.setLocalDirection(fm.liveswitch.StreamDirection.Inactive);
                            }
                        }
                    }
                    if ((!fm.liveswitch.Global.equals(videoStream_5, null))) {
                        if ((fm.liveswitch.Global.equals(videoStream_5.getLocalDirection(), fm.liveswitch.StreamDirection.SendReceive))) {
                            videoStream_5.setLocalDirection(fm.liveswitch.StreamDirection.SendOnly);
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(videoStream_5.getLocalDirection(), fm.liveswitch.StreamDirection.ReceiveOnly))) {
                                videoStream_5.setLocalDirection(fm.liveswitch.StreamDirection.Inactive);
                            }
                        }
                    }
                    if ((!fm.liveswitch.Global.equals(dataStream_5, null))) {
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            SfuUpstreamConnection.prototype.getTypeString = function () {
                return '[fm.liveswitch.SfuUpstreamConnection]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Creates an offer message.
            @param offer The offer.
            */
            SfuUpstreamConnection.prototype.doCreateOfferMessage = function (offer) {
                if (arguments.length == 1) {
                    return fm.liveswitch.Message.createSfuOfferMessage(_super.prototype.getTag.call(this), offer.toJson());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the given media direction is allowed for this connection.
            @param direction The direction.
            */
            SfuUpstreamConnection.prototype.isMediaDirectionAllowed = function (direction) {
                if (arguments.length == 1) {
                    return fm.liveswitch.StreamDirectionHelper.isReceiveDisabled(direction);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return SfuUpstreamConnection;
        }(fm.liveswitch.SfuConnection));
        liveswitch.SfuUpstreamConnection = SfuUpstreamConnection;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Channel configuration.
        */
        var ChannelConfig = /** @class */ (function () {
            function ChannelConfig() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchChannelConfigInit();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            ChannelConfig.prototype.getTypeString = function () {
                return '[fm.liveswitch.ChannelConfig]';
            };
            ChannelConfig.prototype.fmliveswitchChannelConfigInit = function () {
                this._recording = false;
            };
            /**
            Deserializes an instance from JSON.
            @param clientConfigJson The JSON to deserialize.
            @return
                        The deserialized client config.
                
            */
            ChannelConfig.fromJson = function (clientConfigJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(clientConfigJson, function () {
                        return new fm.liveswitch.ChannelConfig();
                    }, function (config, key, value) {
                        var str = key;
                        if (((!fm.liveswitch.Global.equals(str, null)) && (fm.liveswitch.Global.equals(str, "recording")))) {
                            config.setRecording(fm.liveswitch.JsonSerializer.deserializeBoolean(value));
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param clientConfig The client config to serialize.
            @return
                        The serialized JSON.
                
            */
            ChannelConfig.toJson = function (clientConfig) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(clientConfig, function (config, dict) {
                        if ((config.getRecording() != null)) {
                            dict["recording"] = fm.liveswitch.JsonSerializer.serializeBoolean(config.getRecording());
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets recording to be enabled or disabled.
            */
            ChannelConfig.prototype.getRecording = function () {
                if (arguments.length == 0) {
                    return this._recording;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets recording to be enabled or disabled.
            */
            ChannelConfig.prototype.setRecording = function (value) {
                if (arguments.length == 1) {
                    this._recording = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            ChannelConfig.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ChannelConfig.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ChannelConfig;
        }());
        liveswitch.ChannelConfig = ChannelConfig;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var FailureSourceWrapper = /** @class */ (function () {
            function FailureSourceWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_64 = __arguments[0];
                    //super();
                    this._value = value_64;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            FailureSourceWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.FailureSourceWrapper]';
            };
            FailureSourceWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.FailureSource.None)
                        return 'None';
                    if (this._value == fm.liveswitch.FailureSource.Network)
                        return 'Network';
                    if (this._value == fm.liveswitch.FailureSource.Message)
                        return 'Message';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return FailureSourceWrapper;
        }());
        liveswitch.FailureSourceWrapper = FailureSourceWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var SendItem = /** @class */ (function () {
            function SendItem() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchSendItemInit();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            SendItem.prototype.getTypeString = function () {
                return '[fm.liveswitch.SendItem]';
            };
            SendItem.prototype.fmliveswitchSendItemInit = function () {
                this._lastInBatch = false;
                this._resendIndex = 0;
                this._retry = false;
                this._sendBackoff = 0;
                this._sendCounter = 0;
            };
            SendItem.prototype.getException = function () {
                if (arguments.length == 0) {
                    return this._exception;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SendItem.prototype.getLastInBatch = function () {
                if (arguments.length == 0) {
                    return this._lastInBatch;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SendItem.prototype.getMessage = function () {
                if (arguments.length == 0) {
                    return this._message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SendItem.prototype.getPromise = function () {
                if (arguments.length == 0) {
                    return this._promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SendItem.prototype.getResendIndex = function () {
                if (arguments.length == 0) {
                    return this._resendIndex;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SendItem.prototype.getRetry = function () {
                if (arguments.length == 0) {
                    return this._retry;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SendItem.prototype.getSendBackoff = function () {
                if (arguments.length == 0) {
                    return this._sendBackoff;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SendItem.prototype.getSendCounter = function () {
                if (arguments.length == 0) {
                    return this._sendCounter;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SendItem.prototype.setException = function (value) {
                if (arguments.length == 1) {
                    this._exception = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SendItem.prototype.setLastInBatch = function (value) {
                if (arguments.length == 1) {
                    this._lastInBatch = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SendItem.prototype.setMessage = function (value) {
                if (arguments.length == 1) {
                    this._message = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SendItem.prototype.setPromise = function (value) {
                if (arguments.length == 1) {
                    this._promise = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SendItem.prototype.setResendIndex = function (value) {
                if (arguments.length == 1) {
                    this._resendIndex = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SendItem.prototype.setRetry = function (value) {
                if (arguments.length == 1) {
                    this._retry = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SendItem.prototype.setSendBackoff = function (value) {
                if (arguments.length == 1) {
                    this._sendBackoff = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SendItem.prototype.setSendCounter = function (value) {
                if (arguments.length == 1) {
                    this._sendCounter = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return SendItem;
        }());
        liveswitch.SendItem = SendItem;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var SendQueue = /** @class */ (function () {
            function SendQueue(transport) {
                fm.liveswitch.SendQueue.fmliveswitchSendQueueInitialize();
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var transport_1 = __arguments[0];
                    //super();
                    this.__pending = new Array();
                    this.__sending = new Array();
                    this.__lock = new Object();
                    this._deferrer = null;
                    this.__sendQueueTransport = transport_1;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            SendQueue.prototype.getTypeString = function () {
                return '[fm.liveswitch.SendQueue]';
            };
            SendQueue.prototype.clear = function () {
                if (arguments.length == 0) {
                    var list = new Array();
                    fm.liveswitch.ArrayExtensions.addRange(list, this.__sending);
                    fm.liveswitch.ArrayExtensions.addRange(list, this.__pending);
                    fm.liveswitch.ArrayExtensions.clear(this.__sending);
                    fm.liveswitch.ArrayExtensions.clear(this.__pending);
                    for (var _i = 0, list_8 = list; _i < list_8.length; _i++) {
                        var item = list_8[_i];
                        item.getPromise().reject(new fm.liveswitch.Exception("Request cancelled."));
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SendQueue.prototype.doSend = function (item) {
                var _this = this;
                if (arguments.length == 1) {
                    this.__sendQueueTransport.send(item).then(function (i) {
                        _this.sendItemSuccessOrRetry(i);
                    }, function (ex) {
                        _this.sendItemFail(item, ex);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SendQueue.prototype.getPendingItems = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ArrayExtensions.toArray(this.__pending);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SendQueue.prototype.getSendingItems = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ArrayExtensions.toArray(this.__sending);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SendQueue.prototype.retrySending = function (retryDelay) {
                var _this = this;
                if (arguments.length == 1) {
                    this._deferrer = new fm.liveswitch.TimeoutTimer(function (state) {
                        _this.trySendPending();
                    }, null);
                    try {
                        this._deferrer.start(retryDelay);
                    }
                    catch (exception) {
                        fm.liveswitch.Log.error("Could not start SendQueue deferrer timer.", exception);
                    }
                    finally {
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SendQueue.prototype.send = function (message) {
                if (arguments.length == 1) {
                    var item2 = new fm.liveswitch.SendItem();
                    item2.setMessage(message);
                    item2.setPromise(new fm.liveswitch.Promise());
                    item2.setSendBackoff(100);
                    var item = item2;
                    fm.liveswitch.ArrayExtensions.add(this.__pending, item);
                    this.trySendPending();
                    return item.getPromise();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SendQueue.prototype.sendItemComplete = function (item) {
                var _this = this;
                if (arguments.length == 1) {
                    var action = null;
                    if (item.getLastInBatch()) {
                        if ((fm.liveswitch.Global.equals(action, null))) {
                            action = function () {
                                var retryDelay = item.getSendBackoff();
                                item.setSendBackoff(fm.liveswitch.MathAssistant.min(1000, (item.getSendBackoff() * 2)));
                                _this.retrySending(retryDelay);
                            };
                        }
                        fm.liveswitch.ManagedThread.dispatch(action);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SendQueue.prototype.sendItemFail = function (item, ex) {
                if (arguments.length == 2) {
                    fm.liveswitch.ArrayExtensions.removeAt(this.__sending, 0);
                    for (var _i = 0, _a = this.__sending; _i < _a.length; _i++) {
                        var item2 = _a[_i];
                        var resendIndex = item2.getResendIndex();
                        item2.setResendIndex((resendIndex - 1));
                    }
                    fm.liveswitch.SendQueue.fm_liveswitch_SendQueue___log.debug("An unrecoverable exception was encountered while sending a message. Will abandon message.", ex);
                    item.getPromise().reject(ex);
                    this.sendItemComplete(item);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SendQueue.prototype.sendItemSuccessOrRetry = function (item) {
                if (arguments.length == 1) {
                    var flag = false;
                    var flag2 = false;
                    if (!item.getRetry()) {
                        flag = true;
                    }
                    else {
                        flag2 = (item.getSendCounter() < 50);
                    }
                    fm.liveswitch.ArrayExtensions.removeAt(this.__sending, 0);
                    if (flag2) {
                        fm.liveswitch.SendQueue.fm_liveswitch_SendQueue___log.debug("A recoverable exception was encountered while sending a message. Will attempt to resend after reconnection.", item.getException());
                        fm.liveswitch.ArrayExtensions.insert(this.__pending, item.getResendIndex(), item);
                    }
                    else {
                        for (var _i = 0, _a = this.__sending; _i < _a.length; _i++) {
                            var item2 = _a[_i];
                            var resendIndex = item2.getResendIndex();
                            item2.setResendIndex((resendIndex - 1));
                        }
                    }
                    if (flag) {
                        item.getPromise().resolve(item.getMessage());
                    }
                    else {
                        if (!flag2) {
                            fm.liveswitch.SendQueue.fm_liveswitch_SendQueue___log.debug("An unrecoverable exception was encountered while sending a message. Will abandon message.", item.getException());
                            item.getPromise().reject(item.getException());
                        }
                    }
                    this.sendItemComplete(item);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SendQueue.prototype.trySendPending = function () {
                if (arguments.length == 0) {
                    var itemArray = void 0;
                    var length_49;
                    if (!this.__sendQueueTransport.getIsConnected()) {
                        return false;
                    }
                    if (((fm.liveswitch.ArrayExtensions.getCount(this.__sending) > 0) || (fm.liveswitch.Global.equals(fm.liveswitch.ArrayExtensions.getCount(this.__pending), 0)))) {
                        return false;
                    }
                    fm.liveswitch.ArrayExtensions.addRange(this.__sending, this.__pending);
                    fm.liveswitch.ArrayExtensions.clear(this.__pending);
                    itemArray = fm.liveswitch.ArrayExtensions.toArray(this.__sending);
                    if (fm.liveswitch.SendQueue.fm_liveswitch_SendQueue___log.getIsVerboseEnabled()) {
                        length_49 = itemArray.length;
                        fm.liveswitch.SendQueue.fm_liveswitch_SendQueue___log.verbose(fm.liveswitch.StringExtensions.format("Starting flush of send queue with {0} items.", fm.liveswitch.NumberExtensions.toString(length_49)));
                    }
                    this.__sendQueueTransport.startBatch();
                    for (var i = 0; (i < itemArray.length); i++) {
                        var item = itemArray[i];
                        item.setResendIndex(i);
                        item.setLastInBatch((fm.liveswitch.Global.equals(i, (itemArray.length - 1))));
                        var sendCounter = item.getSendCounter();
                        item.setSendCounter((sendCounter + 1));
                        this.doSend(item);
                    }
                    this.__sendQueueTransport.endBatch();
                    if (fm.liveswitch.SendQueue.fm_liveswitch_SendQueue___log.getIsVerboseEnabled()) {
                        length_49 = itemArray.length;
                        fm.liveswitch.SendQueue.fm_liveswitch_SendQueue___log.verbose(fm.liveswitch.StringExtensions.format("Finished flush of send queue with {0} items.", fm.liveswitch.NumberExtensions.toString(length_49)));
                    }
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            SendQueue.fmliveswitchSendQueueInitialize = function () {
                if (!fm.liveswitch.SendQueue.__fmliveswitchSendQueueInitialized && !fm.liveswitch.SendQueue.__fmliveswitchSendQueueInitializing) {
                    fm.liveswitch.SendQueue.__fmliveswitchSendQueueInitializing = true;
                    fm.liveswitch.SendQueue.fm_liveswitch_SendQueue___log = fm.liveswitch.Log.getLogger(new fm.liveswitch.Type('[fm.liveswitch.SendQueue]'));
                    fm.liveswitch.SendQueue.__fmliveswitchSendQueueInitialized = true;
                    fm.liveswitch.SendQueue.__fmliveswitchSendQueueInitializing = false;
                }
            };
            /** @hidden */
            SendQueue.__fmliveswitchSendQueueInitialized = false;
            /** @hidden */
            SendQueue.__fmliveswitchSendQueueInitializing = false;
            return SendQueue;
        }());
        liveswitch.SendQueue = SendQueue;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Client configuration.
        */
        var ClientConfig = /** @class */ (function () {
            /** @hidden */
            function ClientConfig() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            ClientConfig.prototype.getTypeString = function () {
                return '[fm.liveswitch.ClientConfig]';
            };
            /**
            Deserializes an instance from JSON.
            @param clientConfigJson The JSON to deserialize.
            @return
                        The deserialized client config.
                
            */
            ClientConfig.fromJson = function (clientConfigJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(clientConfigJson, function () {
                        return new fm.liveswitch.ClientConfig();
                    }, function (config, key, value) {
                        var str = key;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            if (!(fm.liveswitch.Global.equals(str, "userAlias"))) {
                                if ((fm.liveswitch.Global.equals(str, "deviceAlias"))) {
                                    config.setDeviceAlias(fm.liveswitch.JsonSerializer.deserializeString(value));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "tag"))) {
                                        config.setTag(fm.liveswitch.JsonSerializer.deserializeString(value));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "roles"))) {
                                            config.setRoles(fm.liveswitch.JsonSerializer.deserializeStringArray(value));
                                        }
                                    }
                                }
                            }
                            else {
                                config.setUserAlias(fm.liveswitch.JsonSerializer.deserializeString(value));
                            }
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param clientConfig The client config to serialize.
            @return
                        The serialized JSON.
                
            */
            ClientConfig.toJson = function (clientConfig) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(clientConfig, function (config, dict) {
                        if ((!fm.liveswitch.Global.equals(config.getUserAlias(), null))) {
                            dict["userAlias"] = fm.liveswitch.JsonSerializer.serializeString(config.getUserAlias());
                        }
                        if ((!fm.liveswitch.Global.equals(config.getDeviceAlias(), null))) {
                            dict["deviceAlias"] = fm.liveswitch.JsonSerializer.serializeString(config.getDeviceAlias());
                        }
                        if ((!fm.liveswitch.Global.equals(config.getTag(), null))) {
                            dict["tag"] = fm.liveswitch.JsonSerializer.serializeString(config.getTag());
                        }
                        if ((!fm.liveswitch.Global.equals(config.getRoles(), null))) {
                            dict["roles"] = fm.liveswitch.JsonSerializer.serializeStringArray(config.getRoles());
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the Device Alias.
            */
            ClientConfig.prototype.getDeviceAlias = function () {
                if (arguments.length == 0) {
                    return this._deviceAlias;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the Roles.
            */
            ClientConfig.prototype.getRoles = function () {
                if (arguments.length == 0) {
                    return this._roles;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the Tag.
            */
            ClientConfig.prototype.getTag = function () {
                if (arguments.length == 0) {
                    return this._tag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the User Alias.
            */
            ClientConfig.prototype.getUserAlias = function () {
                if (arguments.length == 0) {
                    return this._userAlias;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the Device Alias.
            */
            ClientConfig.prototype.setDeviceAlias = function (value) {
                if (arguments.length == 1) {
                    this._deviceAlias = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the Roles.
            */
            ClientConfig.prototype.setRoles = function (value) {
                if (arguments.length == 1) {
                    this._roles = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the Tag.
            */
            ClientConfig.prototype.setTag = function (value) {
                if (arguments.length == 1) {
                    this._tag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the User Alias.
            */
            ClientConfig.prototype.setUserAlias = function (value) {
                if (arguments.length == 1) {
                    this._userAlias = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            ClientConfig.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ClientConfig.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ClientConfig;
        }());
        liveswitch.ClientConfig = ClientConfig;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Connection configuration.
        */
        var ConnectionConfig = /** @class */ (function () {
            /** @hidden */
            function ConnectionConfig() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchConnectionConfigInit();
                    this.setAudioDirection("sendrecv");
                    this.setVideoDirection("sendrecv");
                    this.setDataDirection("sendrecv");
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            ConnectionConfig.prototype.getTypeString = function () {
                return '[fm.liveswitch.ConnectionConfig]';
            };
            ConnectionConfig.prototype.fmliveswitchConnectionConfigInit = function () {
                this._localAudioMuted = false;
                this._localVideoMuted = false;
            };
            /**
            Deserializes an instance from JSON.
            @param connectionConfigJson The JSON to deserialize.
            @return
                        The deserialized connection config.
                
            */
            ConnectionConfig.fromJson = function (connectionConfigJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(connectionConfigJson, function () {
                        return new fm.liveswitch.ConnectionConfig();
                    }, function (config, key, value) {
                        var _var0 = key;
                        if (_var0 == "localAudioMuted") {
                            do {
                                config.setLocalAudioMuted(fm.liveswitch.JsonSerializer.deserializeBoolean(value));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "localVideoMuted") {
                            do {
                                config.setLocalVideoMuted(fm.liveswitch.JsonSerializer.deserializeBoolean(value));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "audioDirection") {
                            do {
                                config.setAudioDirection(fm.liveswitch.JsonSerializer.deserializeString(value));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "videoDirection") {
                            do {
                                config.setVideoDirection(fm.liveswitch.JsonSerializer.deserializeString(value));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "dataDirection") {
                            do {
                                config.setDataDirection(fm.liveswitch.JsonSerializer.deserializeString(value));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "tag") {
                            do {
                                config.setTag(fm.liveswitch.JsonSerializer.deserializeString(value));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "remoteAudioEncoding") {
                            do {
                                config.setRemoteAudioEncoding(fm.liveswitch.EncodingInfo.fromJson(value));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "remoteVideoEncoding") {
                            do {
                                config.setRemoteVideoEncoding(fm.liveswitch.EncodingInfo.fromJson(value));
                                break;
                            } while (false);
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param connectionConfig The connection config to serialize.
            @return
                        The serialized JSON.
                
            */
            ConnectionConfig.toJson = function (connectionConfig) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(connectionConfig, function (config, dict) {
                        if (config.getLocalAudioMuted()) {
                            dict["localAudioMuted"] = fm.liveswitch.JsonSerializer.serializeBoolean(config.getLocalAudioMuted());
                        }
                        if (config.getLocalVideoMuted()) {
                            dict["localVideoMuted"] = fm.liveswitch.JsonSerializer.serializeBoolean(config.getLocalVideoMuted());
                        }
                        if ((!fm.liveswitch.Global.equals(config.getAudioDirection(), null))) {
                            dict["audioDirection"] = fm.liveswitch.JsonSerializer.serializeString(config.getAudioDirection());
                        }
                        if ((!fm.liveswitch.Global.equals(config.getVideoDirection(), null))) {
                            dict["videoDirection"] = fm.liveswitch.JsonSerializer.serializeString(config.getVideoDirection());
                        }
                        if ((!fm.liveswitch.Global.equals(config.getDataDirection(), null))) {
                            dict["dataDirection"] = fm.liveswitch.JsonSerializer.serializeString(config.getDataDirection());
                        }
                        if ((!fm.liveswitch.Global.equals(config.getTag(), null))) {
                            dict["tag"] = fm.liveswitch.JsonSerializer.serializeString(config.getTag());
                        }
                        if ((!fm.liveswitch.Global.equals(config.getRemoteAudioEncoding(), null))) {
                            dict["remoteAudioEncoding"] = fm.liveswitch.EncodingInfo.toJson(config.getRemoteAudioEncoding());
                        }
                        if ((!fm.liveswitch.Global.equals(config.getRemoteVideoEncoding(), null))) {
                            dict["remoteVideoEncoding"] = fm.liveswitch.EncodingInfo.toJson(config.getRemoteVideoEncoding());
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the audio direction ("sendrecv", "sendonly", "recvonly", or "inactive").
            */
            ConnectionConfig.prototype.getAudioDirection = function () {
                if (arguments.length == 0) {
                    return this._audioDirection;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the data direction ("sendrecv", "sendonly", "recvonly", or "inactive").
            */
            ConnectionConfig.prototype.getDataDirection = function () {
                if (arguments.length == 0) {
                    return this._dataDirection;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if local audio is disabled.
            */
            ConnectionConfig.prototype.getLocalAudioDisabled = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StreamDirectionHelper.isSendDisabled(this.getAudioDirection());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if the local audio is muted.
            */
            ConnectionConfig.prototype.getLocalAudioMuted = function () {
                if (arguments.length == 0) {
                    return this._localAudioMuted;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if local data is disabled.
            */
            ConnectionConfig.prototype.getLocalDataDisabled = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StreamDirectionHelper.isSendDisabled(this.getDataDirection());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if local video is disabled.
            */
            ConnectionConfig.prototype.getLocalVideoDisabled = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StreamDirectionHelper.isSendDisabled(this.getVideoDirection());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if the local video is muted.
            */
            ConnectionConfig.prototype.getLocalVideoMuted = function () {
                if (arguments.length == 0) {
                    return this._localVideoMuted;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if remote audio is disabled.
            */
            ConnectionConfig.prototype.getRemoteAudioDisabled = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StreamDirectionHelper.isReceiveDisabled(this.getAudioDirection());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote audio encoding.
            */
            ConnectionConfig.prototype.getRemoteAudioEncoding = function () {
                if (arguments.length == 0) {
                    return this._remoteAudioEncoding;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if remote data is disabled.
            */
            ConnectionConfig.prototype.getRemoteDataDisabled = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StreamDirectionHelper.isReceiveDisabled(this.getDataDirection());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if remote video is disabled.
            */
            ConnectionConfig.prototype.getRemoteVideoDisabled = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.StreamDirectionHelper.isReceiveDisabled(this.getVideoDirection());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote video encoding.
            */
            ConnectionConfig.prototype.getRemoteVideoEncoding = function () {
                if (arguments.length == 0) {
                    return this._remoteVideoEncoding;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the tag for this connection.
            */
            ConnectionConfig.prototype.getTag = function () {
                if (arguments.length == 0) {
                    return this._tag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the video direction ("sendrecv", "sendonly", "recvonly", or "inactive").
            */
            ConnectionConfig.prototype.getVideoDirection = function () {
                if (arguments.length == 0) {
                    return this._videoDirection;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the audio direction ("sendrecv", "sendonly", "recvonly", or "inactive").
            */
            ConnectionConfig.prototype.setAudioDirection = function (value) {
                if (arguments.length == 1) {
                    this._audioDirection = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the data direction ("sendrecv", "sendonly", "recvonly", or "inactive").
            */
            ConnectionConfig.prototype.setDataDirection = function (value) {
                if (arguments.length == 1) {
                    this._dataDirection = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets if local audio is disabled.
            */
            ConnectionConfig.prototype.setLocalAudioDisabled = function (value) {
                if (arguments.length == 1) {
                    this.setAudioDirection(fm.liveswitch.StreamDirectionHelper.setSendDisabled(this.getAudioDirection(), value));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets if the local audio is muted.
            */
            ConnectionConfig.prototype.setLocalAudioMuted = function (value) {
                if (arguments.length == 1) {
                    this._localAudioMuted = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets if local data is disabled.
            */
            ConnectionConfig.prototype.setLocalDataDisabled = function (value) {
                if (arguments.length == 1) {
                    this.setDataDirection(fm.liveswitch.StreamDirectionHelper.setSendDisabled(this.getDataDirection(), value));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets if local video is disabled.
            */
            ConnectionConfig.prototype.setLocalVideoDisabled = function (value) {
                if (arguments.length == 1) {
                    this.setVideoDirection(fm.liveswitch.StreamDirectionHelper.setSendDisabled(this.getVideoDirection(), value));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets if the local video is muted.
            */
            ConnectionConfig.prototype.setLocalVideoMuted = function (value) {
                if (arguments.length == 1) {
                    this._localVideoMuted = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets if remote audio is disabled.
            */
            ConnectionConfig.prototype.setRemoteAudioDisabled = function (value) {
                if (arguments.length == 1) {
                    this.setAudioDirection(fm.liveswitch.StreamDirectionHelper.setReceiveDisabled(this.getAudioDirection(), value));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote audio encoding.
            */
            ConnectionConfig.prototype.setRemoteAudioEncoding = function (value) {
                if (arguments.length == 1) {
                    this._remoteAudioEncoding = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets if remote data is disabled.
            */
            ConnectionConfig.prototype.setRemoteDataDisabled = function (value) {
                if (arguments.length == 1) {
                    this.setDataDirection(fm.liveswitch.StreamDirectionHelper.setReceiveDisabled(this.getDataDirection(), value));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets if remote video is disabled.
            */
            ConnectionConfig.prototype.setRemoteVideoDisabled = function (value) {
                if (arguments.length == 1) {
                    this.setVideoDirection(fm.liveswitch.StreamDirectionHelper.setReceiveDisabled(this.getVideoDirection(), value));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote video encoding.
            */
            ConnectionConfig.prototype.setRemoteVideoEncoding = function (value) {
                if (arguments.length == 1) {
                    this._remoteVideoEncoding = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the tag for this connection.
            */
            ConnectionConfig.prototype.setTag = function (value) {
                if (arguments.length == 1) {
                    this._tag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the video direction ("sendrecv", "sendonly", "recvonly", or "inactive").
            */
            ConnectionConfig.prototype.setVideoDirection = function (value) {
                if (arguments.length == 1) {
                    this._videoDirection = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            ConnectionConfig.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ConnectionConfig.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ConnectionConfig;
        }());
        liveswitch.ConnectionConfig = ConnectionConfig;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var SignallingSendQueueTransport = /** @class */ (function () {
            function SignallingSendQueueTransport(client) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var client_1 = __arguments[0];
                    //super();
                    this.__client = client_1;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            SignallingSendQueueTransport.prototype.getTypeString = function () {
                return '[fm.liveswitch.SignallingSendQueueTransport]';
            };
            /** @hidden */
            SignallingSendQueueTransport.prototype.doSend = function (item, promise) {
                if (arguments.length == 2) {
                    var action = null;
                    var action2 = null;
                    var client = this.__client;
                    if (((!fm.liveswitch.Global.equals(client, null)) && (!fm.liveswitch.Global.equals(item, null)))) {
                        var message = item.getMessage();
                        if ((!fm.liveswitch.Global.equals(message, null))) {
                            var serviceArgs = new fm.liveswitch.signalling.ServiceArgs();
                            serviceArgs.setChannel("/message");
                            serviceArgs.setDataJson(message.toJson());
                            if ((fm.liveswitch.Global.equals(action, null))) {
                                action = function (e) {
                                    item.setRetry(false);
                                    item.setException(null);
                                    var messageJson = e.getDataJson();
                                    item.setMessage(((!fm.liveswitch.Global.equals(messageJson, null)) ? fm.liveswitch.Message.fromJson(messageJson) : null));
                                    promise.resolve(item);
                                };
                            }
                            serviceArgs.setOnSuccess(action);
                            if ((fm.liveswitch.Global.equals(action2, null))) {
                                action2 = function (e) {
                                    item.setException(e.getException());
                                    if ((fm.liveswitch.Global.equals(e.getSource(), fm.liveswitch.FailureSource.Network))) {
                                        item.setRetry(true);
                                        promise.resolve(item);
                                    }
                                    else {
                                        promise.reject(e.getException());
                                    }
                                };
                            }
                            serviceArgs.setOnFailure(action2);
                            client.service(serviceArgs);
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SignallingSendQueueTransport.prototype.endBatch = function () {
                if (arguments.length == 0) {
                    this.__client.endBatch();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SignallingSendQueueTransport.prototype.getIsConnected = function () {
                if (arguments.length == 0) {
                    return (fm.liveswitch.Global.equals(this.__client.getState(), fm.liveswitch.signalling.ClientState.Connected));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SignallingSendQueueTransport.prototype.send = function (item) {
                if (arguments.length == 1) {
                    var promise = new fm.liveswitch.Promise();
                    this.doSend(item, promise);
                    return promise;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            SignallingSendQueueTransport.prototype.startBatch = function () {
                if (arguments.length == 0) {
                    this.__client.startBatch();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return SignallingSendQueueTransport;
        }());
        liveswitch.SignallingSendQueueTransport = SignallingSendQueueTransport;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Application information.
        */
        var ApplicationInfo = /** @class */ (function (_super) {
            __extends(ApplicationInfo, _super);
            function ApplicationInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            ApplicationInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.ApplicationInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Deserializes Json to a ApplicationInfo.
            @param applicationInfoJson The serialized Json.
            @return The deserialized ApplicationInfo.
            */
            ApplicationInfo.fromJson = function (applicationInfoJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(applicationInfoJson, function () {
                        return new fm.liveswitch.ApplicationInfo();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to Json.
            @param application The instance to serialize.
            @return Serialized Json.
            */
            ApplicationInfo.toJson = function (application) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(application, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            ApplicationInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            ApplicationInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to Json.
            */
            ApplicationInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ApplicationInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ApplicationInfo;
        }(fm.liveswitch.Info));
        liveswitch.ApplicationInfo = ApplicationInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Report.
        */
        var Report = /** @class */ (function () {
            function Report() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Report.prototype.getTypeString = function () {
                return '[fm.liveswitch.Report]';
            };
            /**
            Processes an array for a report.
            @param newValues The new values.
            @param oldValues The old values.
            @return The new values, if the new values are not equivalent to the old values; otherwise null.
            */
            Report.processArray = function (newValues, oldValues) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(newValues, oldValues))) {
                        return null;
                    }
                    if ((((!fm.liveswitch.Global.equals(newValues, null)) && (!fm.liveswitch.Global.equals(oldValues, null))) && (fm.liveswitch.Global.equals(oldValues.length, newValues.length)))) {
                        for (var i = 0; (i < newValues.length); i++) {
                            if (!newValues[i].isEquivalent(oldValues[i])) {
                                return newValues;
                            }
                        }
                        return null;
                    }
                    return newValues;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a boolean for a report.
            @param newValue The new value.
            @param oldValue The old value.
            @return The new value, if the new value does not equal the old value; otherwise null.
            */
            Report.processBoolean = function (newValue, oldValue) {
                if (arguments.length == 2) {
                    return ((fm.liveswitch.Global.equals(newValue, oldValue)) ? null : newValue);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a boolean array for a report.
            @param newValues The new values.
            @param oldValues The old values.
            @return The new values, if the new values do not equal the old values; otherwise null.
            */
            Report.processBooleanArray = function (newValues, oldValues) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(newValues, oldValues))) {
                        return null;
                    }
                    if ((((!fm.liveswitch.Global.equals(newValues, null)) && (!fm.liveswitch.Global.equals(oldValues, null))) && (fm.liveswitch.Global.equals(oldValues.length, newValues.length)))) {
                        for (var i = 0; (i < newValues.length); i++) {
                            if ((!fm.liveswitch.Global.equals(newValues[i], oldValues[i]))) {
                                return newValues;
                            }
                        }
                        return null;
                    }
                    return newValues;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a double for a report.
            @param newValue The new value.
            @param oldValue The old value.
            @return The new value, if the new value does not equal the old value; otherwise null.
            */
            Report.processDouble = function (newValue, oldValue) {
                if (arguments.length == 2) {
                    return ((fm.liveswitch.Global.equals(newValue, oldValue)) ? null : newValue);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a float for a report.
            @param newValue The new value.
            @param oldValue The old value.
            @return The new value, if the new value does not equal the old value; otherwise null.
            */
            Report.processFloat = function (newValue, oldValue) {
                if (arguments.length == 2) {
                    return ((fm.liveswitch.Global.equals(newValue, oldValue)) ? null : newValue);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a float array for a report.
            @param newValues The new values.
            @param oldValues The old values.
            @return The new values, if the new values do not equal the old values; otherwise null.
            */
            Report.processFloatArray = function (newValues, oldValues) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(newValues, oldValues))) {
                        return null;
                    }
                    if ((((!fm.liveswitch.Global.equals(newValues, null)) && (!fm.liveswitch.Global.equals(oldValues, null))) && (fm.liveswitch.Global.equals(oldValues.length, newValues.length)))) {
                        for (var i = 0; (i < newValues.length); i++) {
                            if ((!fm.liveswitch.Global.equals(newValues[i], oldValues[i]))) {
                                return newValues;
                            }
                        }
                        return null;
                    }
                    return newValues;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes an integer for a report.
            @param newValue The new value.
            @param oldValue The old value.
            @return The new value, if the new value does not equal the old value; otherwise null.
            */
            Report.processInteger = function (newValue, oldValue) {
                if (arguments.length == 2) {
                    return ((fm.liveswitch.Global.equals(newValue, oldValue)) ? null : newValue);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a integer array for a report.
            @param newValues The new values.
            @param oldValues The old values.
            @return The new values, if the new values do not equal the old values; otherwise null.
            */
            Report.processIntegerArray = function (newValues, oldValues) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(newValues, oldValues))) {
                        return null;
                    }
                    if ((((!fm.liveswitch.Global.equals(newValues, null)) && (!fm.liveswitch.Global.equals(oldValues, null))) && (fm.liveswitch.Global.equals(oldValues.length, newValues.length)))) {
                        for (var i = 0; (i < newValues.length); i++) {
                            if ((!fm.liveswitch.Global.equals(newValues[i], oldValues[i]))) {
                                return newValues;
                            }
                        }
                        return null;
                    }
                    return newValues;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a long for a report.
            @param newValue The new value.
            @param oldValue The old value.
            @return The new value, if the new value does not equal the old value; otherwise null.
            */
            Report.processLong = function (newValue, oldValue) {
                if (arguments.length == 2) {
                    return ((fm.liveswitch.Global.equals(newValue, oldValue)) ? null : newValue);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a long array for a report.
            @param newValues The new values.
            @param oldValues The old values.
            @return The new values, if the new values do not equal the old values; otherwise null.
            */
            Report.processLongArray = function (newValues, oldValues) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(newValues, oldValues))) {
                        return null;
                    }
                    if ((((!fm.liveswitch.Global.equals(newValues, null)) && (!fm.liveswitch.Global.equals(oldValues, null))) && (fm.liveswitch.Global.equals(oldValues.length, newValues.length)))) {
                        for (var i = 0; (i < newValues.length); i++) {
                            if ((!fm.liveswitch.Global.equals(newValues[i], oldValues[i]))) {
                                return newValues;
                            }
                        }
                        return null;
                    }
                    return newValues;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes an array for a report.
            @param newValue The new value.
            @param oldValue The old value.
            @return The new value, if the new value does not equal the old value; otherwise null.
            */
            Report.processObject = function (newValue, oldValue) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(newValue, oldValue))) {
                        return null;
                    }
                    if ((((!fm.liveswitch.Global.equals(newValue, null)) && (!fm.liveswitch.Global.equals(oldValue, null))) && newValue.isEquivalent(oldValue))) {
                        return null;
                    }
                    return newValue;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a short for a report.
            @param newValue The new value.
            @param oldValue The old value.
            @return The new value, if the new value does not equal the old value; otherwise null.
            */
            Report.processShort = function (newValue, oldValue) {
                if (arguments.length == 2) {
                    return ((fm.liveswitch.Global.equals(newValue, oldValue)) ? null : newValue);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a short array for a report.
            @param newValues The new values.
            @param oldValues The old values.
            @return The new values, if the new values do not equal the old values; otherwise null.
            */
            Report.processShortArray = function (newValues, oldValues) {
                if (arguments.length == 2) {
                    if ((fm.liveswitch.Global.equals(newValues, oldValues))) {
                        return null;
                    }
                    if ((((!fm.liveswitch.Global.equals(newValues, null)) && (!fm.liveswitch.Global.equals(oldValues, null))) && (fm.liveswitch.Global.equals(oldValues.length, newValues.length)))) {
                        for (var i = 0; (i < newValues.length); i++) {
                            if ((!fm.liveswitch.Global.equals(newValues[i], oldValues[i]))) {
                                return newValues;
                            }
                        }
                        return null;
                    }
                    return newValues;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Processes a string for a report.
            @param newValue The new value.
            @param oldValue The old value.
            @return The new value, if the new value does not equal the old value; otherwise null.
            */
            Report.processString = function (newValue, oldValue) {
                if (arguments.length == 2) {
                    return ((fm.liveswitch.Global.equals(newValue, oldValue)) ? null : newValue);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            Report.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            Report.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Report;
        }());
        liveswitch.Report = Report;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Report.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Candidate pair report.
        */
        var CandidatePairReport = /** @class */ (function (_super) {
            __extends(CandidatePairReport, _super);
            function CandidatePairReport() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchCandidatePairReportInit();
                }
                else if (__arguments.length == 2) {
                    var stats = __arguments[0];
                    var lastStats = __arguments[1];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchCandidatePairReportInit();
                    var flag = (fm.liveswitch.Global.equals(lastStats, null));
                    _this.setBytesSent(fm.liveswitch.Report.processLong(stats.getBytesSent(), (flag ? 0 : lastStats.getBytesSent())));
                    _this.setBytesReceived(fm.liveswitch.Report.processLong(stats.getBytesReceived(), (flag ? 0 : lastStats.getBytesReceived())));
                    _this.setRequestsSent(fm.liveswitch.Report.processLong(stats.getRequestsSent(), (flag ? 0 : lastStats.getRequestsSent())));
                    _this.setRequestsReceived(fm.liveswitch.Report.processLong(stats.getRequestsReceived(), (flag ? 0 : lastStats.getRequestsReceived())));
                    _this.setResponsesSent(fm.liveswitch.Report.processLong(stats.getResponsesSent(), (flag ? 0 : lastStats.getResponsesSent())));
                    _this.setResponsesReceived(fm.liveswitch.Report.processLong(stats.getResponsesReceived(), (flag ? 0 : lastStats.getResponsesReceived())));
                    _this.setConsentRequestsSent(fm.liveswitch.Report.processLong(stats.getConsentRequestsSent(), (flag ? 0 : lastStats.getConsentRequestsSent())));
                    _this.setConsentRequestsReceived(fm.liveswitch.Report.processLong(stats.getConsentRequestsReceived(), (flag ? 0 : lastStats.getConsentRequestsReceived())));
                    _this.setConsentResponsesSent(fm.liveswitch.Report.processLong(stats.getConsentResponsesSent(), (flag ? 0 : lastStats.getConsentResponsesSent())));
                    _this.setConsentResponsesReceived(fm.liveswitch.Report.processLong(stats.getConsentResponsesReceived(), (flag ? 0 : lastStats.getConsentResponsesReceived())));
                    _this.setTotalRoundTripTime(fm.liveswitch.Report.processInteger(stats.getTotalRoundTripTime(), (flag ? 0 : lastStats.getTotalRoundTripTime())));
                    _this.setCurrentRoundTripTime(fm.liveswitch.Report.processInteger(stats.getCurrentRoundTripTime(), (flag ? 0 : lastStats.getCurrentRoundTripTime())));
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            CandidatePairReport.prototype.getTypeString = function () {
                return '[fm.liveswitch.CandidatePairReport]' + ',' + _super.prototype.getTypeString.call(this);
            };
            CandidatePairReport.prototype.fmliveswitchCandidatePairReportInit = function () {
                this._bytesReceived = 0;
                this._bytesSent = 0;
                this._consentRequestsReceived = 0;
                this._consentRequestsSent = 0;
                this._consentResponsesReceived = 0;
                this._consentResponsesSent = 0;
                this._currentRoundTripTime = 0;
                this._requestsReceived = 0;
                this._requestsSent = 0;
                this._responsesReceived = 0;
                this._responsesSent = 0;
                this._totalRoundTripTime = 0;
            };
            /**
            Deserializes an instance from JSON.
            @param instanceJson The instance JSON.
            @return The deserialized instance.
            */
            CandidatePairReport.fromJson = function (instanceJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(instanceJson, function () {
                        return new fm.liveswitch.CandidatePairReport();
                    }, function (obj, key, valueJson) {
                        obj.deserializeProperties(key, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Derializes an array from JSON.
            @param arrayJson The array JSON.
            @return The deserialized array.
            */
            CandidatePairReport.fromJsonArray = function (arrayJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(arrayJson, fm.liveswitch.CandidatePairReport.fromJson.bind(fm.liveswitch.CandidatePairReport));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param instance The instance.
            @return The serialized instance JSON.
            */
            CandidatePairReport.toJson = function (instance) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(instance, function (obj, jsonObject) {
                        obj.serializeProperties(jsonObject);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param array The array.
            @return The serialized array JSON.
            */
            CandidatePairReport.toJsonArray = function (array) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(array, fm.liveswitch.CandidatePairReport.toJson.bind(fm.liveswitch.CandidatePairReport));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            CandidatePairReport.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var _var0 = key;
                    if (_var0 == "bytesSent") {
                        do {
                            this.setBytesSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "bytesReceived") {
                        do {
                            this.setBytesReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "requestsSent") {
                        do {
                            this.setRequestsSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "requestsReceived") {
                        do {
                            this.setRequestsReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "responsesSent") {
                        do {
                            this.setResponsesSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "responsesReceived") {
                        do {
                            this.setResponsesReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "consentRequestsSent") {
                        do {
                            this.setConsentRequestsSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "consentRequestsReceived") {
                        do {
                            this.setConsentRequestsReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "consentResponsesSent") {
                        do {
                            this.setConsentResponsesSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "consentResponsesReceived") {
                        do {
                            this.setConsentResponsesReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "totalRoundTripTime") {
                        do {
                            this.setTotalRoundTripTime(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "currentRoundTripTime") {
                        do {
                            this.setCurrentRoundTripTime(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of candidate pair bytes received.
            */
            CandidatePairReport.prototype.getBytesReceived = function () {
                if (arguments.length == 0) {
                    return this._bytesReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of candidate pair bytes sent.
            */
            CandidatePairReport.prototype.getBytesSent = function () {
                if (arguments.length == 0) {
                    return this._bytesSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of candidate pair consent requests received.
            */
            CandidatePairReport.prototype.getConsentRequestsReceived = function () {
                if (arguments.length == 0) {
                    return this._consentRequestsReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of candidate pair consent requests sent.
            */
            CandidatePairReport.prototype.getConsentRequestsSent = function () {
                if (arguments.length == 0) {
                    return this._consentRequestsSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of candidate pair consent responses received.
            */
            CandidatePairReport.prototype.getConsentResponsesReceived = function () {
                if (arguments.length == 0) {
                    return this._consentResponsesReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of candidate pair consent responses sent.
            */
            CandidatePairReport.prototype.getConsentResponsesSent = function () {
                if (arguments.length == 0) {
                    return this._consentResponsesSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the candidate pair current round trip time in milliseconds.
            */
            CandidatePairReport.prototype.getCurrentRoundTripTime = function () {
                if (arguments.length == 0) {
                    return this._currentRoundTripTime;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of candidate pair requests received.
            */
            CandidatePairReport.prototype.getRequestsReceived = function () {
                if (arguments.length == 0) {
                    return this._requestsReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of candidate pair requests sent.
            */
            CandidatePairReport.prototype.getRequestsSent = function () {
                if (arguments.length == 0) {
                    return this._requestsSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of candidate pair responses received.
            */
            CandidatePairReport.prototype.getResponsesReceived = function () {
                if (arguments.length == 0) {
                    return this._responsesReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of candidate pair responses sent.
            */
            CandidatePairReport.prototype.getResponsesSent = function () {
                if (arguments.length == 0) {
                    return this._responsesSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the candidate pair total round trip time in milliseconds.
            */
            CandidatePairReport.prototype.getTotalRoundTripTime = function () {
                if (arguments.length == 0) {
                    return this._totalRoundTripTime;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            CandidatePairReport.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((this.getBytesSent() != null)) {
                        jsonObject["bytesSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getBytesSent());
                    }
                    if ((this.getBytesReceived() != null)) {
                        jsonObject["bytesReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getBytesReceived());
                    }
                    if ((this.getRequestsSent() != null)) {
                        jsonObject["requestsSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getRequestsSent());
                    }
                    if ((this.getRequestsReceived() != null)) {
                        jsonObject["requestsReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getRequestsReceived());
                    }
                    if ((this.getResponsesSent() != null)) {
                        jsonObject["responsesSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getResponsesSent());
                    }
                    if ((this.getResponsesReceived() != null)) {
                        jsonObject["responsesReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getResponsesReceived());
                    }
                    if ((this.getConsentRequestsSent() != null)) {
                        jsonObject["consentRequestsSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getConsentRequestsSent());
                    }
                    if ((this.getConsentRequestsReceived() != null)) {
                        jsonObject["consentRequestsReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getConsentRequestsReceived());
                    }
                    if ((this.getConsentResponsesSent() != null)) {
                        jsonObject["consentResponsesSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getConsentResponsesSent());
                    }
                    if ((this.getConsentResponsesReceived() != null)) {
                        jsonObject["consentResponsesReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getConsentResponsesReceived());
                    }
                    if ((this.getTotalRoundTripTime() != null)) {
                        jsonObject["totalRoundTripTime"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getTotalRoundTripTime());
                    }
                    if ((this.getCurrentRoundTripTime() != null)) {
                        jsonObject["currentRoundTripTime"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getCurrentRoundTripTime());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of candidate pair bytes received.
            */
            CandidatePairReport.prototype.setBytesReceived = function (value) {
                if (arguments.length == 1) {
                    this._bytesReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of candidate pair bytes sent.
            */
            CandidatePairReport.prototype.setBytesSent = function (value) {
                if (arguments.length == 1) {
                    this._bytesSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of candidate pair consent requests received.
            */
            CandidatePairReport.prototype.setConsentRequestsReceived = function (value) {
                if (arguments.length == 1) {
                    this._consentRequestsReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of candidate pair consent requests sent.
            */
            CandidatePairReport.prototype.setConsentRequestsSent = function (value) {
                if (arguments.length == 1) {
                    this._consentRequestsSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of candidate pair consent responses received.
            */
            CandidatePairReport.prototype.setConsentResponsesReceived = function (value) {
                if (arguments.length == 1) {
                    this._consentResponsesReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of candidate pair consent responses sent.
            */
            CandidatePairReport.prototype.setConsentResponsesSent = function (value) {
                if (arguments.length == 1) {
                    this._consentResponsesSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the candidate pair current round trip time in milliseconds.
            */
            CandidatePairReport.prototype.setCurrentRoundTripTime = function (value) {
                if (arguments.length == 1) {
                    this._currentRoundTripTime = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of candidate pair requests received.
            */
            CandidatePairReport.prototype.setRequestsReceived = function (value) {
                if (arguments.length == 1) {
                    this._requestsReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of candidate pair requests sent.
            */
            CandidatePairReport.prototype.setRequestsSent = function (value) {
                if (arguments.length == 1) {
                    this._requestsSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of candidate pair responses received.
            */
            CandidatePairReport.prototype.setResponsesReceived = function (value) {
                if (arguments.length == 1) {
                    this._responsesReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of candidate pair responses sent.
            */
            CandidatePairReport.prototype.setResponsesSent = function (value) {
                if (arguments.length == 1) {
                    this._responsesSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the candidate pair total round trip time in milliseconds.
            */
            CandidatePairReport.prototype.setTotalRoundTripTime = function (value) {
                if (arguments.length == 1) {
                    this._totalRoundTripTime = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            CandidatePairReport.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.CandidatePairReport.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return CandidatePairReport;
        }(fm.liveswitch.Report));
        liveswitch.CandidatePairReport = CandidatePairReport;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Report.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Channel report.
        */
        var ChannelReport = /** @class */ (function (_super) {
            __extends(ChannelReport, _super);
            /**
            Initializes a new instance of the [[fm.liveswitch.channelReport]] class.
            */
            function ChannelReport() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchChannelReportInit();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            ChannelReport.prototype.getTypeString = function () {
                return '[fm.liveswitch.ChannelReport]' + ',' + _super.prototype.getTypeString.call(this);
            };
            ChannelReport.prototype.fmliveswitchChannelReportInit = function () {
                this._messageBytesReceived = 0;
                this._messageBytesSent = 0;
                this._messagesReceived = 0;
                this._messagesSent = 0;
            };
            /**
            Deserializes an instance from JSON.
            @param instanceJson The instance JSON.
            @return The deserialized instance.
            */
            ChannelReport.fromJson = function (instanceJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(instanceJson, function () {
                        return new fm.liveswitch.ChannelReport();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Derializes an array from JSON.
            @param arrayJson The array JSON.
            @return The deserialized array.
            */
            ChannelReport.fromJsonArray = function (arrayJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(arrayJson, fm.liveswitch.ChannelReport.fromJson.bind(fm.liveswitch.ChannelReport));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param instance The instance to serialize.
            @return The instance JSON.
            */
            ChannelReport.toJson = function (instance) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(instance, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param array The array.
            @return The serialized array JSON.
            */
            ChannelReport.toJsonArray = function (array) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(array, fm.liveswitch.ChannelReport.toJson.bind(fm.liveswitch.ChannelReport));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            ChannelReport.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "id"))) {
                            if ((fm.liveswitch.Global.equals(str, "messagesSent"))) {
                                this.setMessagesSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "messageBytesSent"))) {
                                    this.setMessageBytesSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "messagesReceived"))) {
                                        this.setMessagesReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "messageBytesReceived"))) {
                                            this.setMessageBytesReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            this.setId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the identifier.
            */
            ChannelReport.prototype.getId = function () {
                if (arguments.length == 0) {
                    return this._id;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of message bytes received on this channel.
            */
            ChannelReport.prototype.getMessageBytesReceived = function () {
                if (arguments.length == 0) {
                    return this._messageBytesReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of message bytes sent on this channel.
            */
            ChannelReport.prototype.getMessageBytesSent = function () {
                if (arguments.length == 0) {
                    return this._messageBytesSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of messages received on this channel.
            */
            ChannelReport.prototype.getMessagesReceived = function () {
                if (arguments.length == 0) {
                    return this._messagesReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of messages sent on this channel.
            */
            ChannelReport.prototype.getMessagesSent = function () {
                if (arguments.length == 0) {
                    return this._messagesSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            ChannelReport.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getId(), null))) {
                        jsonObject["id"] = fm.liveswitch.JsonSerializer.serializeString(this.getId());
                    }
                    if ((this.getMessagesSent() != null)) {
                        jsonObject["messagesSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getMessagesSent());
                    }
                    if ((this.getMessageBytesSent() != null)) {
                        jsonObject["messageBytesSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getMessageBytesSent());
                    }
                    if ((this.getMessagesReceived() != null)) {
                        jsonObject["messagesReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getMessagesReceived());
                    }
                    if ((this.getMessageBytesReceived() != null)) {
                        jsonObject["messageBytesReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getMessageBytesReceived());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the identifier.
            */
            ChannelReport.prototype.setId = function (value) {
                if (arguments.length == 1) {
                    this._id = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of message bytes received on this channel.
            */
            ChannelReport.prototype.setMessageBytesReceived = function (value) {
                if (arguments.length == 1) {
                    this._messageBytesReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of message bytes sent on this channel.
            */
            ChannelReport.prototype.setMessageBytesSent = function (value) {
                if (arguments.length == 1) {
                    this._messageBytesSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of messages received on this channel.
            */
            ChannelReport.prototype.setMessagesReceived = function (value) {
                if (arguments.length == 1) {
                    this._messagesReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of messages sent on this channel.
            */
            ChannelReport.prototype.setMessagesSent = function (value) {
                if (arguments.length == 1) {
                    this._messagesSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to Json.
            */
            ChannelReport.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ChannelReport.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ChannelReport;
        }(fm.liveswitch.Report));
        liveswitch.ChannelReport = ChannelReport;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Report.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Data stream report.
        */
        var DataStreamReport = /** @class */ (function (_super) {
            __extends(DataStreamReport, _super);
            function DataStreamReport() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchDataStreamReportInit();
                }
                else if (__arguments.length == 3) {
                    var stats = __arguments[0];
                    var lastStats = __arguments[1];
                    var eventType = __arguments[2];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchDataStreamReportInit();
                    var flag = (fm.liveswitch.Global.equals(lastStats, null));
                    _this.setMessagesSent(fm.liveswitch.Report.processLong(stats.getMessagesSent(), (flag ? 0 : lastStats.getMessagesSent())));
                    _this.setBytesSent(fm.liveswitch.Report.processLong(stats.getBytesSent(), (flag ? 0 : lastStats.getBytesSent())));
                    _this.setMessagesReceived(fm.liveswitch.Report.processLong(stats.getMessagesReceived(), (flag ? 0 : lastStats.getMessagesReceived())));
                    _this.setBytesReceived(fm.liveswitch.Report.processLong(stats.getBytesReceived(), (flag ? 0 : lastStats.getBytesReceived())));
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            DataStreamReport.prototype.getTypeString = function () {
                return '[fm.liveswitch.DataStreamReport]' + ',' + _super.prototype.getTypeString.call(this);
            };
            DataStreamReport.prototype.fmliveswitchDataStreamReportInit = function () {
                this._bytesReceived = 0;
                this._bytesSent = 0;
                this._messagesReceived = 0;
                this._messagesSent = 0;
            };
            /**
            Deserializes Json to a DataStreamReport.
            @param dataStreamReportJson The serialized Json.
            @return The deserialized DataChannelReport.
            */
            DataStreamReport.fromJson = function (dataStreamReportJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(dataStreamReportJson, function () {
                        return new fm.liveswitch.DataStreamReport();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to Json.
            @param dataStreamReport The instance to serialize.
            @return Serialized Json.
            */
            DataStreamReport.toJson = function (dataStreamReport) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(dataStreamReport, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            DataStreamReport.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "messagesSent"))) {
                            if ((fm.liveswitch.Global.equals(str, "bytesSent"))) {
                                this.setBytesSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "messagesReceived"))) {
                                    this.setMessagesReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "bytesReceived"))) {
                                        this.setBytesReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                                    }
                                }
                            }
                        }
                        else {
                            this.setMessagesSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes received on this data stream.
            */
            DataStreamReport.prototype.getBytesReceived = function () {
                if (arguments.length == 0) {
                    return this._bytesReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes sent on this data stream.
            */
            DataStreamReport.prototype.getBytesSent = function () {
                if (arguments.length == 0) {
                    return this._bytesSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of messages received on this data stream.
            */
            DataStreamReport.prototype.getMessagesReceived = function () {
                if (arguments.length == 0) {
                    return this._messagesReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of messages sent on this data stream.
            */
            DataStreamReport.prototype.getMessagesSent = function () {
                if (arguments.length == 0) {
                    return this._messagesSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            DataStreamReport.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((this.getMessagesSent() != null)) {
                        jsonObject["messagesSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getMessagesSent());
                    }
                    if ((this.getBytesSent() != null)) {
                        jsonObject["bytesSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getBytesSent());
                    }
                    if ((this.getMessagesReceived() != null)) {
                        jsonObject["messagesReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getMessagesReceived());
                    }
                    if ((this.getBytesReceived() != null)) {
                        jsonObject["bytesReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getBytesReceived());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of bytes received on this data stream.
            */
            DataStreamReport.prototype.setBytesReceived = function (value) {
                if (arguments.length == 1) {
                    this._bytesReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of bytes sent on this data stream.
            */
            DataStreamReport.prototype.setBytesSent = function (value) {
                if (arguments.length == 1) {
                    this._bytesSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of messages received on this data stream.
            */
            DataStreamReport.prototype.setMessagesReceived = function (value) {
                if (arguments.length == 1) {
                    this._messagesReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of messages sent on this data stream.
            */
            DataStreamReport.prototype.setMessagesSent = function (value) {
                if (arguments.length == 1) {
                    this._messagesSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to Json.
            */
            DataStreamReport.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.DataStreamReport.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return DataStreamReport;
        }(fm.liveswitch.Report));
        liveswitch.DataStreamReport = DataStreamReport;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        An event batch.
        */
        var EventBatch = /** @class */ (function () {
            function EventBatch() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            EventBatch.prototype.getTypeString = function () {
                return '[fm.liveswitch.EventBatch]';
            };
            /**
            Deserializes an instance from JSON.
            */
            EventBatch.fromJson = function (instanceJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(instanceJson, function () {
                        return new fm.liveswitch.EventBatch();
                    }, function (obj, key, valueJson) {
                        obj.deserializeProperty(key, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            */
            EventBatch.toJson = function (instance) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(instance, function (obj, jsonObject) {
                        obj.serializeProperties(jsonObject);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the property.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            EventBatch.prototype.deserializeProperty = function (key, valueJson) {
                if (arguments.length == 2) {
                    var str = key;
                    if (((!fm.liveswitch.Global.equals(str, null)) && (fm.liveswitch.Global.equals(str, "batch")))) {
                        this.setEvents(fm.liveswitch.EventInfo.fromJsonArray(valueJson));
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the events.
            */
            EventBatch.prototype.getEvents = function () {
                if (arguments.length == 0) {
                    return this._events;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            EventBatch.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(this.getEvents(), null))) {
                        jsonObject["batch"] = fm.liveswitch.EventInfo.toJsonArray(this.getEvents());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the events.
            */
            EventBatch.prototype.setEvents = function (value) {
                if (arguments.length == 1) {
                    this._events = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            EventBatch.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.EventBatch.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return EventBatch;
        }());
        liveswitch.EventBatch = EventBatch;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Event types.
        */
        var EventType = /** @class */ (function () {
            function EventType() {
            }
            EventType.prototype.getTypeString = function () {
                return '[fm.liveswitch.EventType]';
            };
            /**
            Converts a connection state enum value into an event type.
            @param connectionState The connection state.
            @return An event type.
            */
            EventType.fromConnectionState = function (connectionState) {
                if (arguments.length == 1) {
                    var _var0 = connectionState;
                    if (_var0 == fm.liveswitch.ConnectionState.Initializing) {
                        do {
                            return "connection.initializing";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.ConnectionState.Connecting) {
                        do {
                            return "connection.connecting";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.ConnectionState.Connected) {
                        do {
                            return "connection.connected";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.ConnectionState.Failing) {
                        do {
                            return "connection.failing";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.ConnectionState.Failed) {
                        do {
                            return "connection.failed";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.ConnectionState.Closing) {
                        do {
                            return "connection.closing";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.ConnectionState.Closed) {
                        do {
                            return "connection.closed";
                        } while (false);
                    }
                    return null;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the 'channel.activated' event type string.
            */
            EventType.ChannelActivated = "channel.activated";
            /**
            Gets the 'channel.client.joined' event type string.
            */
            EventType.ChannelClientJoined = "channel.client.joined";
            /**
            Gets the 'channel.client.left' event type string.
            */
            EventType.ChannelClientLeft = "channel.client.left";
            /**
            Gets the 'channel.deactivated' event type string.
            */
            EventType.ChannelDeactivated = "channel.deactivated";
            /**
            Gets the 'client.registered' event type string.
            */
            EventType.ClientRegistered = "client.registered";
            /**
            Gets the 'client.stats' event type string.
            */
            EventType.ClientStats = "client.stats";
            /**
            Gets the 'client.unregistered' event type string.
            */
            EventType.ClientUnregistered = "client.unregistered";
            /**
            Gets the 'client.updated' event type string.
            */
            EventType.ClientUpdated = "client.updated";
            /**
            Gets the 'connection.closed' event type string.
            */
            EventType.ConnectionClosed = "connection.closed";
            /**
            Gets the 'connection.closing' event type string.
            */
            EventType.ConnectionClosing = "connection.closing";
            /**
            Gets the 'connection.connected' event type string.
            */
            EventType.ConnectionConnected = "connection.connected";
            /**
            Gets the 'connection.connecting' event type string.
            */
            EventType.ConnectionConnecting = "connection.connecting";
            /**
            Gets the 'connection.failed' event type string.
            */
            EventType.ConnectionFailed = "connection.failed";
            /**
            Gets the 'connection.failing' event type string.
            */
            EventType.ConnectionFailing = "connection.failing";
            /**
            Gets the 'connection.initializing' event type string.
            */
            EventType.ConnectionInitializing = "connection.initializing";
            /**
            Gets the 'connection.stats' event type string.
            */
            EventType.ConnectionStats = "connection.stats";
            /**
            Gets the 'connection.updated' event type string.
            */
            EventType.ConnectionUpdated = "connection.updated";
            /**
            Gets the 'gateway.started' event type string.
            */
            EventType.GatewayStarted = "gateway.started";
            /**
            Gets the 'gateway.stats' event type string.
            */
            EventType.GatewayStats = "gateway.stats";
            /**
            Gets the 'gateway.stopped' event type string.
            */
            EventType.GatewayStopped = "gateway.stopped";
            /**
            Gets the 'mediaserver.registered' event type string.
            */
            EventType.MediaServerRegistered = "mediaserver.registered";
            /**
            Gets the 'mediaserver.started' event type string.
            */
            EventType.MediaServerStarted = "mediaserver.started";
            /**
            Gets the 'mediaserver.stats' event type string.
            */
            EventType.MediaServerStats = "mediaserver.stats";
            /**
            Gets the 'mediaserver.stopped' event type string.
            */
            EventType.MediaServerStopped = "mediaserver.stopped";
            /**
            Gets the 'mediaserver.unregistered' event type string.
            */
            EventType.MediaServerUnregistered = "mediaserver.unregistered";
            /**
            Gets the 'sipconnector.registered' event type string.
            */
            EventType.SipConnectorRegistered = "sipconnector.registered";
            /**
            Gets the 'sipconnector.started' event type string.
            */
            EventType.SipConnectorStarted = "sipconnector.started";
            /**
            Gets the 'sipconnector.stats' event type string.
            */
            EventType.SipConnectorStats = "sipconnector.stats";
            /**
            Gets the 'sipconnector.stopped' event type string.
            */
            EventType.SipConnectorStopped = "sipconnector.stopped";
            /**
            Gets the 'sipconnector.unregistered' event type string.
            */
            EventType.SipConnectorUnregistered = "sipconnector.unregistered";
            return EventType;
        }());
        liveswitch.EventType = EventType;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Report.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media component report.
        */
        var MediaComponentReport = /** @class */ (function (_super) {
            __extends(MediaComponentReport, _super);
            function MediaComponentReport() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaComponentReportInit();
                }
                else if (__arguments.length == 2) {
                    var stats = __arguments[0];
                    var lastStats = __arguments[1];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaComponentReportInit();
                    var flag = (fm.liveswitch.Global.equals(lastStats, null));
                    _this.setNackCount(fm.liveswitch.Report.processLong(stats.getNackCount(), (flag ? 0 : lastStats.getNackCount())));
                    _this.setPliCount(fm.liveswitch.Report.processLong(stats.getPliCount(), (flag ? 0 : lastStats.getPliCount())));
                    _this.setFirCount(fm.liveswitch.Report.processLong(stats.getFirCount(), (flag ? 0 : lastStats.getFirCount())));
                    _this.setSliCount(fm.liveswitch.Report.processLong(stats.getSliCount(), (flag ? 0 : lastStats.getSliCount())));
                    _this.setLrrCount(fm.liveswitch.Report.processLong(stats.getLrrCount(), (flag ? 0 : lastStats.getLrrCount())));
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaComponentReport.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaComponentReport]' + ',' + _super.prototype.getTypeString.call(this);
            };
            MediaComponentReport.prototype.fmliveswitchMediaComponentReportInit = function () {
                this._firCount = 0;
                this._lrrCount = 0;
                this._nackCount = 0;
                this._pliCount = 0;
                this._sliCount = 0;
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            MediaComponentReport.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "nackCount"))) {
                            if ((fm.liveswitch.Global.equals(str, "pliCount"))) {
                                this.setPliCount(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "firCount"))) {
                                    this.setFirCount(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "lrrCount"))) {
                                        this.setLrrCount(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "sliCount"))) {
                                            this.setSliCount(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            this.setNackCount(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of full intra refresh (FIR) messages sent.
            */
            MediaComponentReport.prototype.getFirCount = function () {
                if (arguments.length == 0) {
                    return this._firCount;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of layer refresh request (LRR) messages sent.
            */
            MediaComponentReport.prototype.getLrrCount = function () {
                if (arguments.length == 0) {
                    return this._lrrCount;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of negative-acknowledgement (NACK) messages sent.
            */
            MediaComponentReport.prototype.getNackCount = function () {
                if (arguments.length == 0) {
                    return this._nackCount;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of picture loss indication (PLI) messages sent.
            */
            MediaComponentReport.prototype.getPliCount = function () {
                if (arguments.length == 0) {
                    return this._pliCount;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of slice loss indication (SLI) messages sent.
            */
            MediaComponentReport.prototype.getSliCount = function () {
                if (arguments.length == 0) {
                    return this._sliCount;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            MediaComponentReport.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((this.getNackCount() != null)) {
                        jsonObject["nackCount"] = fm.liveswitch.JsonSerializer.serializeLong(this.getNackCount());
                    }
                    if ((this.getPliCount() != null)) {
                        jsonObject["pliCount"] = fm.liveswitch.JsonSerializer.serializeLong(this.getPliCount());
                    }
                    if ((this.getFirCount() != null)) {
                        jsonObject["firCount"] = fm.liveswitch.JsonSerializer.serializeLong(this.getFirCount());
                    }
                    if ((this.getLrrCount() != null)) {
                        jsonObject["lrrCount"] = fm.liveswitch.JsonSerializer.serializeLong(this.getLrrCount());
                    }
                    if ((this.getSliCount() != null)) {
                        jsonObject["sliCount"] = fm.liveswitch.JsonSerializer.serializeLong(this.getSliCount());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of full intra refresh (FIR) messages sent.
            */
            MediaComponentReport.prototype.setFirCount = function (value) {
                if (arguments.length == 1) {
                    this._firCount = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of layer refresh request (LRR) messages sent.
            */
            MediaComponentReport.prototype.setLrrCount = function (value) {
                if (arguments.length == 1) {
                    this._lrrCount = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of negative-acknowledgement (NACK) messages sent.
            */
            MediaComponentReport.prototype.setNackCount = function (value) {
                if (arguments.length == 1) {
                    this._nackCount = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of picture loss indication (PLI) messages sent.
            */
            MediaComponentReport.prototype.setPliCount = function (value) {
                if (arguments.length == 1) {
                    this._pliCount = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of slice loss indication (SLI) messages sent.
            */
            MediaComponentReport.prototype.setSliCount = function (value) {
                if (arguments.length == 1) {
                    this._sliCount = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaComponentReport;
        }(fm.liveswitch.Report));
        liveswitch.MediaComponentReport = MediaComponentReport;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Report.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media track report.
        */
        var MediaTrackReport = /** @class */ (function (_super) {
            __extends(MediaTrackReport, _super);
            function MediaTrackReport() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaTrackReportInit();
                }
                else if (__arguments.length == 2) {
                    var stats = __arguments[0];
                    var lastStats = __arguments[1];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaTrackReportInit();
                    var flag = (fm.liveswitch.Global.equals(lastStats, null));
                    _this.setMinBitrate(fm.liveswitch.Report.processInteger(stats.getMinBitrate(), (flag ? 0 : lastStats.getMinBitrate())));
                    _this.setMaxBitrate(fm.liveswitch.Report.processInteger(stats.getMaxBitrate(), (flag ? 0 : lastStats.getMaxBitrate())));
                    _this.setBitrate(fm.liveswitch.Report.processInteger(stats.getBitrate(), (flag ? 0 : lastStats.getBitrate())));
                    _this.setFramesCorrupted(fm.liveswitch.Report.processLong(stats.getFramesCorrupted(), (flag ? 0 : lastStats.getFramesCorrupted())));
                    _this.setFramesDecoded(fm.liveswitch.Report.processLong(stats.getFramesDecoded(), (flag ? 0 : lastStats.getFramesDecoded())));
                    _this.setFramesDropped(fm.liveswitch.Report.processLong(stats.getFramesDropped(), (flag ? 0 : lastStats.getFramesDropped())));
                    _this.setFramesEncoded(fm.liveswitch.Report.processLong(stats.getFramesEncoded(), (flag ? 0 : lastStats.getFramesEncoded())));
                    _this.setFrameHeight(fm.liveswitch.Report.processInteger(stats.getFrameHeight(), (flag ? 0 : lastStats.getFrameHeight())));
                    _this.setFrameRate(fm.liveswitch.Report.processDouble(stats.getFrameRate(), (flag ? 0 : lastStats.getFrameRate())));
                    _this.setFramesReceived(fm.liveswitch.Report.processLong(stats.getFramesReceived(), (flag ? 0 : lastStats.getFramesReceived())));
                    _this.setFramesSent(fm.liveswitch.Report.processLong(stats.getFramesSent(), (flag ? 0 : lastStats.getFramesSent())));
                    _this.setFrameWidth(fm.liveswitch.Report.processInteger(stats.getFrameWidth(), (flag ? 0 : lastStats.getFrameWidth())));
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaTrackReport.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaTrackReport]' + ',' + _super.prototype.getTypeString.call(this);
            };
            MediaTrackReport.prototype.fmliveswitchMediaTrackReportInit = function () {
                this._bitrate = 0;
                this._frameHeight = 0;
                this._frameRate = 0;
                this._framesCorrupted = 0;
                this._framesDecoded = 0;
                this._framesDropped = 0;
                this._framesEncoded = 0;
                this._framesReceived = 0;
                this._framesSent = 0;
                this._frameWidth = 0;
                this._maxBitrate = 0;
                this._minBitrate = 0;
            };
            /**
            Deserializes an instance from JSON.
            @param instanceJson The instance JSON.
            @return The deserialized instance.
            */
            MediaTrackReport.fromJson = function (instanceJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(instanceJson, function () {
                        return new fm.liveswitch.MediaTrackReport();
                    }, function (obj, key, valueJson) {
                        obj.deserializeProperties(key, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Derializes an array from JSON.
            @param arrayJson The array JSON.
            @return The deserialized array.
            */
            MediaTrackReport.fromJsonArray = function (arrayJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(arrayJson, fm.liveswitch.MediaTrackReport.fromJson.bind(fm.liveswitch.MediaTrackReport));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param instance The instance.
            @return The serialized instance JSON.
            */
            MediaTrackReport.toJson = function (instance) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(instance, function (obj, jsonObject) {
                        obj.serializeProperties(jsonObject);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param array The array.
            @return The serialized array JSON.
            */
            MediaTrackReport.toJsonArray = function (array) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(array, fm.liveswitch.MediaTrackReport.toJson.bind(fm.liveswitch.MediaTrackReport));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            MediaTrackReport.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var _var0 = key;
                    if (_var0 == "minBitrate") {
                        do {
                            this.setMinBitrate(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "maxBitrate") {
                        do {
                            this.setMaxBitrate(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "bitrate") {
                        do {
                            this.setBitrate(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "frameWidth") {
                        do {
                            this.setFrameWidth(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "frameHeight") {
                        do {
                            this.setFrameHeight(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "frameRate") {
                        do {
                            this.setFrameRate(fm.liveswitch.JsonSerializer.deserializeDouble(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "framesSent") {
                        do {
                            this.setFramesSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "framesReceived") {
                        do {
                            this.setFramesReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "framesDecoded") {
                        do {
                            this.setFramesDecoded(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "framesDropped") {
                        do {
                            this.setFramesDropped(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "framesCorrupted") {
                        do {
                            this.setFramesCorrupted(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "framesEncoded") {
                        do {
                            this.setFramesEncoded(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the bitrate.
            */
            MediaTrackReport.prototype.getBitrate = function () {
                if (arguments.length == 0) {
                    return this._bitrate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the frame height.
            */
            MediaTrackReport.prototype.getFrameHeight = function () {
                if (arguments.length == 0) {
                    return this._frameHeight;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the frame rate.
            */
            MediaTrackReport.prototype.getFrameRate = function () {
                if (arguments.length == 0) {
                    return this._frameRate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of frames corrupted.
            */
            MediaTrackReport.prototype.getFramesCorrupted = function () {
                if (arguments.length == 0) {
                    return this._framesCorrupted;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of frames decoded.
            */
            MediaTrackReport.prototype.getFramesDecoded = function () {
                if (arguments.length == 0) {
                    return this._framesDecoded;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of frames dropped.
            */
            MediaTrackReport.prototype.getFramesDropped = function () {
                if (arguments.length == 0) {
                    return this._framesDropped;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of frames encoded.
            */
            MediaTrackReport.prototype.getFramesEncoded = function () {
                if (arguments.length == 0) {
                    return this._framesEncoded;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of frames received.
            */
            MediaTrackReport.prototype.getFramesReceived = function () {
                if (arguments.length == 0) {
                    return this._framesReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of frames sent.
            */
            MediaTrackReport.prototype.getFramesSent = function () {
                if (arguments.length == 0) {
                    return this._framesSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the frame width.
            */
            MediaTrackReport.prototype.getFrameWidth = function () {
                if (arguments.length == 0) {
                    return this._frameWidth;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the maximum bitrate.
            */
            MediaTrackReport.prototype.getMaxBitrate = function () {
                if (arguments.length == 0) {
                    return this._maxBitrate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the minimum bitrate.
            */
            MediaTrackReport.prototype.getMinBitrate = function () {
                if (arguments.length == 0) {
                    return this._minBitrate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            MediaTrackReport.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((this.getMinBitrate() != null)) {
                        jsonObject["minBitrate"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getMinBitrate());
                    }
                    if ((this.getMaxBitrate() != null)) {
                        jsonObject["maxBitrate"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getMaxBitrate());
                    }
                    if ((this.getBitrate() != null)) {
                        jsonObject["bitrate"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getBitrate());
                    }
                    if ((this.getFrameWidth() != null)) {
                        jsonObject["frameWidth"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getFrameWidth());
                    }
                    if ((this.getFrameHeight() != null)) {
                        jsonObject["frameHeight"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getFrameHeight());
                    }
                    if ((this.getFrameRate() != null)) {
                        jsonObject["frameRate"] = fm.liveswitch.JsonSerializer.serializeDouble(this.getFrameRate());
                    }
                    if ((this.getFramesSent() != null)) {
                        jsonObject["framesSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getFramesSent());
                    }
                    if ((this.getFramesReceived() != null)) {
                        jsonObject["framesReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getFramesReceived());
                    }
                    if ((this.getFramesDecoded() != null)) {
                        jsonObject["framesDecoded"] = fm.liveswitch.JsonSerializer.serializeLong(this.getFramesDecoded());
                    }
                    if ((this.getFramesDropped() != null)) {
                        jsonObject["framesDropped"] = fm.liveswitch.JsonSerializer.serializeLong(this.getFramesDropped());
                    }
                    if ((this.getFramesCorrupted() != null)) {
                        jsonObject["framesCorrupted"] = fm.liveswitch.JsonSerializer.serializeLong(this.getFramesCorrupted());
                    }
                    if ((this.getFramesEncoded() != null)) {
                        jsonObject["framesEncoded"] = fm.liveswitch.JsonSerializer.serializeLong(this.getFramesEncoded());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the bitrate.
            */
            MediaTrackReport.prototype.setBitrate = function (value) {
                if (arguments.length == 1) {
                    this._bitrate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the frame height.
            */
            MediaTrackReport.prototype.setFrameHeight = function (value) {
                if (arguments.length == 1) {
                    this._frameHeight = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the frame rate.
            */
            MediaTrackReport.prototype.setFrameRate = function (value) {
                if (arguments.length == 1) {
                    this._frameRate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of frames corrupted.
            */
            MediaTrackReport.prototype.setFramesCorrupted = function (value) {
                if (arguments.length == 1) {
                    this._framesCorrupted = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of frames decoded.
            */
            MediaTrackReport.prototype.setFramesDecoded = function (value) {
                if (arguments.length == 1) {
                    this._framesDecoded = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of frames dropped.
            */
            MediaTrackReport.prototype.setFramesDropped = function (value) {
                if (arguments.length == 1) {
                    this._framesDropped = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of frames encoded.
            */
            MediaTrackReport.prototype.setFramesEncoded = function (value) {
                if (arguments.length == 1) {
                    this._framesEncoded = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of frames received.
            */
            MediaTrackReport.prototype.setFramesReceived = function (value) {
                if (arguments.length == 1) {
                    this._framesReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of frames sent.
            */
            MediaTrackReport.prototype.setFramesSent = function (value) {
                if (arguments.length == 1) {
                    this._framesSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the frame width.
            */
            MediaTrackReport.prototype.setFrameWidth = function (value) {
                if (arguments.length == 1) {
                    this._frameWidth = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the maximum bitrate.
            */
            MediaTrackReport.prototype.setMaxBitrate = function (value) {
                if (arguments.length == 1) {
                    this._maxBitrate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the minimum bitrate.
            */
            MediaTrackReport.prototype.setMinBitrate = function (value) {
                if (arguments.length == 1) {
                    this._minBitrate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            MediaTrackReport.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.MediaTrackReport.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaTrackReport;
        }(fm.liveswitch.Report));
        liveswitch.MediaTrackReport = MediaTrackReport;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A channel claim.
        */
        var ChannelClaim = /** @class */ (function () {
            function ChannelClaim() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchChannelClaimInit();
                    this.setAction("join");
                }
                else if (__arguments.length == 1) {
                    var idValue = __arguments[0];
                    // chained constructor: ChannelClaim.call(this);
                    __arguments = new Array(0);
                    {
                        //super();
                        this.fmliveswitchChannelClaimInit();
                        this.setAction("join");
                    }
                    if ((fm.liveswitch.Global.equals(idValue, null))) {
                        throw new fm.liveswitch.Exception("Channel ID must not be null.");
                    }
                    this.setId(idValue);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            ChannelClaim.prototype.getTypeString = function () {
                return '[fm.liveswitch.ChannelClaim]';
            };
            ChannelClaim.prototype.fmliveswitchChannelClaimInit = function () {
                this._broadcast = false;
                this._canKick = false;
                this._canUpdate = false;
                this._disableMcu = false;
                this._disablePeer = false;
                this._disableRemoteClientEvents = false;
                this._disableSendAudio = false;
                this._disableSendData = false;
                this._disableSendMessage = false;
                this._disableSendVideo = false;
                this._disableSfu = false;
            };
            /**
            Deserializes a channel claim from JSON.
            @param channelClaimJson The channel claim JSON.
            */
            ChannelClaim.fromJson = function (channelClaimJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(channelClaimJson, function () {
                        return new fm.liveswitch.ChannelClaim();
                    }, function (obj, key, valueJson) {
                        var _var0 = key;
                        if (_var0 == "id") {
                            do {
                                obj.setId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "disableSendMessage") {
                            do {
                                obj.setDisableSendMessage(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "disablePeer") {
                            do {
                                obj.setDisablePeer(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "disableMcu") {
                            do {
                                obj.setDisableMcu(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "disableSfu") {
                            do {
                                obj.setDisableSfu(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "disableSendAudio") {
                            do {
                                obj.setDisableSendAudio(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "disableSendVideo") {
                            do {
                                obj.setDisableSendVideo(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "disableSendData") {
                            do {
                                obj.setDisableSendData(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "disableRemoteClientEvents") {
                            do {
                                obj.setDisableRemoteClientEvents(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "audioReceiveWhitelist") {
                            do {
                                obj.setAudioReceiveWhitelist(fm.liveswitch.JsonSerializer.deserializeStringArray(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "videoReceiveWhitelist") {
                            do {
                                obj.setVideoReceiveWhitelist(fm.liveswitch.JsonSerializer.deserializeStringArray(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "dataReceiveWhitelist") {
                            do {
                                obj.setDataReceiveWhitelist(fm.liveswitch.JsonSerializer.deserializeStringArray(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "action") {
                            do {
                                obj.setAction(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "canKick") {
                            do {
                                obj.setCanKick(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "canUpdate") {
                            do {
                                obj.setCanUpdate(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                break;
                            } while (false);
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array of channel claims from JSON.
            @param channelClaimsJson The channel claims JSON.
            */
            ChannelClaim.fromJsonArray = function (channelClaimsJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(channelClaimsJson, fm.liveswitch.ChannelClaim.fromJson.bind(fm.liveswitch.ChannelClaim));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a channel claim to JSON.
            @param channelClaim The channel claim to serialize.
            */
            ChannelClaim.toJson = function (channelClaim) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(channelClaim, function (obj, jsonObject) {
                        jsonObject["id"] = fm.liveswitch.JsonSerializer.serializeString(channelClaim.getId());
                        if (channelClaim.getDisableSendMessage()) {
                            jsonObject["disableSendMessage"] = fm.liveswitch.JsonSerializer.serializeBoolean(channelClaim.getDisableSendMessage());
                        }
                        if (channelClaim.getDisablePeer()) {
                            jsonObject["disablePeer"] = fm.liveswitch.JsonSerializer.serializeBoolean(channelClaim.getDisablePeer());
                        }
                        if (channelClaim.getDisableSfu()) {
                            jsonObject["disableSfu"] = fm.liveswitch.JsonSerializer.serializeBoolean(channelClaim.getDisableSfu());
                        }
                        if (channelClaim.getDisableMcu()) {
                            jsonObject["disableMcu"] = fm.liveswitch.JsonSerializer.serializeBoolean(channelClaim.getDisableMcu());
                        }
                        if (channelClaim.getDisableSendAudio()) {
                            jsonObject["disableSendAudio"] = fm.liveswitch.JsonSerializer.serializeBoolean(channelClaim.getDisableSendAudio());
                        }
                        if (channelClaim.getDisableSendVideo()) {
                            jsonObject["disableSendVideo"] = fm.liveswitch.JsonSerializer.serializeBoolean(channelClaim.getDisableSendVideo());
                        }
                        if (channelClaim.getDisableSendData()) {
                            jsonObject["disableSendData"] = fm.liveswitch.JsonSerializer.serializeBoolean(channelClaim.getDisableSendData());
                        }
                        if (channelClaim.getDisableRemoteClientEvents()) {
                            jsonObject["disableRemoteClientEvents"] = fm.liveswitch.JsonSerializer.serializeBoolean(channelClaim.getDisableRemoteClientEvents());
                        }
                        if ((!fm.liveswitch.Global.equals(obj.getAudioReceiveWhitelist(), null))) {
                            jsonObject["audioReceiveWhitelist"] = fm.liveswitch.JsonSerializer.serializeStringArray(obj.getAudioReceiveWhitelist());
                        }
                        if ((!fm.liveswitch.Global.equals(obj.getVideoReceiveWhitelist(), null))) {
                            jsonObject["videoReceiveWhitelist"] = fm.liveswitch.JsonSerializer.serializeStringArray(obj.getVideoReceiveWhitelist());
                        }
                        if ((!fm.liveswitch.Global.equals(obj.getDataReceiveWhitelist(), null))) {
                            jsonObject["dataReceiveWhitelist"] = fm.liveswitch.JsonSerializer.serializeStringArray(obj.getDataReceiveWhitelist());
                        }
                        if ((!fm.liveswitch.Global.equals(obj.getAction(), null))) {
                            jsonObject["action"] = fm.liveswitch.JsonSerializer.serializeString(obj.getAction());
                        }
                        if (obj.getCanKick()) {
                            jsonObject["canKick"] = fm.liveswitch.JsonSerializer.serializeBoolean(obj.getCanKick());
                        }
                        if (obj.getCanUpdate()) {
                            jsonObject["canUpdate"] = fm.liveswitch.JsonSerializer.serializeBoolean(obj.getCanUpdate());
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array of channel claims to JSON.
            @param channelClaims The channel claims.
            */
            ChannelClaim.toJsonArray = function (channelClaims) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(channelClaims, fm.liveswitch.ChannelClaim.toJson.bind(fm.liveswitch.ChannelClaim));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the action of this channel claim. Possible values are in the [[fm.liveswitch.claimAction]] class.
            */
            ChannelClaim.prototype.getAction = function () {
                if (arguments.length == 0) {
                    return this._action;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a whitelist of roles whose member's audio can be received from. Null disables the whitelist whereas an empty list disables all receiving.
            */
            ChannelClaim.prototype.getAudioReceiveWhitelist = function () {
                if (arguments.length == 0) {
                    return this._audioReceiveWhitelist;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if this is a broadcast channel or not.
            */
            ChannelClaim.prototype.getBroadcast = function () {
                if (arguments.length == 0) {
                    return this._broadcast;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the user is authorized kick other users from this channel.
            */
            ChannelClaim.prototype.getCanKick = function () {
                if (arguments.length == 0) {
                    return this._canKick;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the user is authorized to update a media server channel.
            */
            ChannelClaim.prototype.getCanUpdate = function () {
                if (arguments.length == 0) {
                    return this._canUpdate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a whitelist of roles whose member's data can be received from. Null disables the whitelist whereas an empty list disables all receiving.
            */
            ChannelClaim.prototype.getDataReceiveWhitelist = function () {
                if (arguments.length == 0) {
                    return this._dataReceiveWhitelist;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the user is NOT authorized to create MCU connections.
            */
            ChannelClaim.prototype.getDisableMcu = function () {
                if (arguments.length == 0) {
                    return this._disableMcu;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the user is NOT authorized to create peer connections.
            */
            ChannelClaim.prototype.getDisablePeer = function () {
                if (arguments.length == 0) {
                    return this._disablePeer;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether to disable the NotifyJoin, NotifyLeave, and NotifyUpdate messages and events.
            */
            ChannelClaim.prototype.getDisableRemoteClientEvents = function () {
                if (arguments.length == 0) {
                    return this._disableRemoteClientEvents;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the user is NOT authorized to send audio.
            */
            ChannelClaim.prototype.getDisableSendAudio = function () {
                if (arguments.length == 0) {
                    return this._disableSendAudio;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the user is NOT authorized to send data.
            */
            ChannelClaim.prototype.getDisableSendData = function () {
                if (arguments.length == 0) {
                    return this._disableSendData;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the user is NOT authorized to send messages.
            */
            ChannelClaim.prototype.getDisableSendMessage = function () {
                if (arguments.length == 0) {
                    return this._disableSendMessage;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the user is NOT authorized to send video.
            */
            ChannelClaim.prototype.getDisableSendVideo = function () {
                if (arguments.length == 0) {
                    return this._disableSendVideo;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the user is NOT authorized to create SFU connections.
            */
            ChannelClaim.prototype.getDisableSfu = function () {
                if (arguments.length == 0) {
                    return this._disableSfu;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the channel identifier.
            */
            ChannelClaim.prototype.getId = function () {
                if (arguments.length == 0) {
                    return this._id;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a whitelist of roles whose member's video can be received from. Null disables the whitelist whereas an empty list disables all receiving.
            */
            ChannelClaim.prototype.getVideoReceiveWhitelist = function () {
                if (arguments.length == 0) {
                    return this._videoReceiveWhitelist;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the action of this channel claim. Possible values are in the [[fm.liveswitch.claimAction]] class.
            */
            ChannelClaim.prototype.setAction = function (value) {
                if (arguments.length == 1) {
                    this._action = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a whitelist of roles whose member's audio can be received from. Null disables the whitelist whereas an empty list disables all receiving.
            */
            ChannelClaim.prototype.setAudioReceiveWhitelist = function (value) {
                if (arguments.length == 1) {
                    this._audioReceiveWhitelist = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets if this is a broadcast channel or not.
            */
            ChannelClaim.prototype.setBroadcast = function (value) {
                if (arguments.length == 1) {
                    this._broadcast = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the user is authorized kick other users from this channel.
            */
            ChannelClaim.prototype.setCanKick = function (value) {
                if (arguments.length == 1) {
                    this._canKick = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the user is authorized to update a media server channel.
            */
            ChannelClaim.prototype.setCanUpdate = function (value) {
                if (arguments.length == 1) {
                    this._canUpdate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a whitelist of roles whose member's data can be received from. Null disables the whitelist whereas an empty list disables all receiving.
            */
            ChannelClaim.prototype.setDataReceiveWhitelist = function (value) {
                if (arguments.length == 1) {
                    this._dataReceiveWhitelist = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the user is NOT authorized to create MCU connections.
            */
            ChannelClaim.prototype.setDisableMcu = function (value) {
                if (arguments.length == 1) {
                    this._disableMcu = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the user is NOT authorized to create peer connections.
            */
            ChannelClaim.prototype.setDisablePeer = function (value) {
                if (arguments.length == 1) {
                    this._disablePeer = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether to disable the NotifyJoin, NotifyLeave, and NotifyUpdate messages and events.
            */
            ChannelClaim.prototype.setDisableRemoteClientEvents = function (value) {
                if (arguments.length == 1) {
                    this._disableRemoteClientEvents = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the user is NOT authorized to send audio.
            */
            ChannelClaim.prototype.setDisableSendAudio = function (value) {
                if (arguments.length == 1) {
                    this._disableSendAudio = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the user is NOT authorized to send data.
            */
            ChannelClaim.prototype.setDisableSendData = function (value) {
                if (arguments.length == 1) {
                    this._disableSendData = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the user is NOT authorized to send messages.
            */
            ChannelClaim.prototype.setDisableSendMessage = function (value) {
                if (arguments.length == 1) {
                    this._disableSendMessage = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the user is NOT authorized to send video.
            */
            ChannelClaim.prototype.setDisableSendVideo = function (value) {
                if (arguments.length == 1) {
                    this._disableSendVideo = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the user is NOT authorized to create SFU connections.
            */
            ChannelClaim.prototype.setDisableSfu = function (value) {
                if (arguments.length == 1) {
                    this._disableSfu = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the channel identifier.
            */
            ChannelClaim.prototype.setId = function (value) {
                if (arguments.length == 1) {
                    this._id = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets a whitelist of roles whose member's video can be received from. Null disables the whitelist whereas an empty list disables all receiving.
            */
            ChannelClaim.prototype.setVideoReceiveWhitelist = function (value) {
                if (arguments.length == 1) {
                    this._videoReceiveWhitelist = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this channel claim to JSON.
            */
            ChannelClaim.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ChannelClaim.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ChannelClaim;
        }());
        liveswitch.ChannelClaim = ChannelClaim;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Channel information.
        */
        var ChannelInfo = /** @class */ (function (_super) {
            __extends(ChannelInfo, _super);
            function ChannelInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchChannelInfoInit();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            ChannelInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.ChannelInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            ChannelInfo.prototype.fmliveswitchChannelInfoInit = function () {
                this._recording = false;
            };
            /**
            Deserializes Json to a ChannelInfo.
            @param channelInfoJson The serialized Json.
            @return The deserialized ChannelInfo.
            */
            ChannelInfo.fromJson = function (channelInfoJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(channelInfoJson, function () {
                        return new fm.liveswitch.ChannelInfo();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to Json.
            @param channel The instance to serialize.
            @return Serialized Json.
            */
            ChannelInfo.toJson = function (channel) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(channel, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            ChannelInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "applicationId"))) {
                            if ((fm.liveswitch.Global.equals(str, "recording"))) {
                                this.setRecording(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "report"))) {
                                    this.setReport(fm.liveswitch.ChannelReport.fromJson(valueJson));
                                }
                            }
                        }
                        else {
                            this.setApplicationId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the application identifier.
            */
            ChannelInfo.prototype.getApplicationId = function () {
                if (arguments.length == 0) {
                    return this._applicationId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the channel is recording.
            */
            ChannelInfo.prototype.getRecording = function () {
                if (arguments.length == 0) {
                    return this._recording;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the channel report.
            */
            ChannelInfo.prototype.getReport = function () {
                if (arguments.length == 0) {
                    return this._report;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            ChannelInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getApplicationId(), null))) {
                        jsonObject["applicationId"] = fm.liveswitch.JsonSerializer.serializeString(this.getApplicationId());
                    }
                    if (this.getRecording()) {
                        jsonObject["recording"] = fm.liveswitch.JsonSerializer.serializeBoolean(true);
                    }
                    if ((!fm.liveswitch.Global.equals(this.getReport(), null))) {
                        jsonObject["report"] = fm.liveswitch.ChannelReport.toJson(this.getReport());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the application identifier.
            */
            ChannelInfo.prototype.setApplicationId = function (value) {
                if (arguments.length == 1) {
                    this._applicationId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the channel is recording.
            */
            ChannelInfo.prototype.setRecording = function (value) {
                if (arguments.length == 1) {
                    this._recording = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the channel report.
            */
            ChannelInfo.prototype.setReport = function (value) {
                if (arguments.length == 1) {
                    this._report = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to Json.
            */
            ChannelInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ChannelInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ChannelInfo;
        }(fm.liveswitch.Info));
        liveswitch.ChannelInfo = ChannelInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Client information.
        */
        var ClientInfo = /** @class */ (function (_super) {
            __extends(ClientInfo, _super);
            function ClientInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchClientInfoInit();
                }
                else if (__arguments.length == 3) {
                    var userId = __arguments[0];
                    var deviceId = __arguments[1];
                    var idValue = __arguments[2];
                    // chained constructor: ClientInfo.call(this, userId, null, deviceId, null, idValue, null, null);
                    __arguments = new Array(7);
                    __arguments[0] = userId;
                    __arguments[1] = null;
                    __arguments[2] = deviceId;
                    __arguments[3] = null;
                    __arguments[4] = idValue;
                    __arguments[5] = null;
                    __arguments[6] = null;
                    {
                        var userId_19 = __arguments[0];
                        var userAlias = __arguments[1];
                        var deviceId_16 = __arguments[2];
                        var deviceAlias = __arguments[3];
                        var idValue_10 = __arguments[4];
                        var tag = __arguments[5];
                        var roles = __arguments[6];
                        // chained constructor: ClientInfo.call(this, userId, userAlias, deviceId, deviceAlias, idValue, tag, roles, null);
                        __arguments = new Array(8);
                        __arguments[0] = userId_19;
                        __arguments[1] = userAlias;
                        __arguments[2] = deviceId_16;
                        __arguments[3] = deviceAlias;
                        __arguments[4] = idValue_10;
                        __arguments[5] = tag;
                        __arguments[6] = roles;
                        __arguments[7] = null;
                        {
                            var userId_20 = __arguments[0];
                            var userAlias_2 = __arguments[1];
                            var deviceId_17 = __arguments[2];
                            var deviceAlias_2 = __arguments[3];
                            var idValue_11 = __arguments[4];
                            var tag_5 = __arguments[5];
                            var roles_6 = __arguments[6];
                            var region = __arguments[7];
                            _this = _super.call(this) || this;
                            _this.fmliveswitchClientInfoInit();
                            _this.setUserId(userId_20);
                            _this.setUserAlias(userAlias_2);
                            _this.setDeviceId(deviceId_17);
                            _this.setDeviceAlias(deviceAlias_2);
                            _super.prototype.setId.call(_this, idValue_11);
                            _this.setTag(tag_5);
                            _this.setRoles(roles_6);
                            _this.setRegion(region);
                        }
                    }
                }
                else if (__arguments.length == 7) {
                    var userId = __arguments[0];
                    var userAlias = __arguments[1];
                    var deviceId = __arguments[2];
                    var deviceAlias = __arguments[3];
                    var idValue = __arguments[4];
                    var tag = __arguments[5];
                    var roles = __arguments[6];
                    // chained constructor: ClientInfo.call(this, userId, userAlias, deviceId, deviceAlias, idValue, tag, roles, null);
                    __arguments = new Array(8);
                    __arguments[0] = userId;
                    __arguments[1] = userAlias;
                    __arguments[2] = deviceId;
                    __arguments[3] = deviceAlias;
                    __arguments[4] = idValue;
                    __arguments[5] = tag;
                    __arguments[6] = roles;
                    __arguments[7] = null;
                    {
                        var userId_21 = __arguments[0];
                        var userAlias_3 = __arguments[1];
                        var deviceId_18 = __arguments[2];
                        var deviceAlias_3 = __arguments[3];
                        var idValue_12 = __arguments[4];
                        var tag_6 = __arguments[5];
                        var roles_7 = __arguments[6];
                        var region = __arguments[7];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchClientInfoInit();
                        _this.setUserId(userId_21);
                        _this.setUserAlias(userAlias_3);
                        _this.setDeviceId(deviceId_18);
                        _this.setDeviceAlias(deviceAlias_3);
                        _super.prototype.setId.call(_this, idValue_12);
                        _this.setTag(tag_6);
                        _this.setRoles(roles_7);
                        _this.setRegion(region);
                    }
                }
                else if (__arguments.length == 8) {
                    var userId = __arguments[0];
                    var userAlias = __arguments[1];
                    var deviceId = __arguments[2];
                    var deviceAlias = __arguments[3];
                    var idValue = __arguments[4];
                    var tag = __arguments[5];
                    var roles = __arguments[6];
                    var region = __arguments[7];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchClientInfoInit();
                    _this.setUserId(userId);
                    _this.setUserAlias(userAlias);
                    _this.setDeviceId(deviceId);
                    _this.setDeviceAlias(deviceAlias);
                    _super.prototype.setId.call(_this, idValue);
                    _this.setTag(tag);
                    _this.setRoles(roles);
                    _this.setRegion(region);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            ClientInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.ClientInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            ClientInfo.prototype.fmliveswitchClientInfoInit = function () {
                this._coreCount = 0;
                this._physicalMemory = 0;
            };
            /**
            Deserializes an instance from JSON.
            @param clientInfoJson The JSON to deserialize.
            @return
                        The deserialized client info.
                
            */
            ClientInfo.fromJson = function (clientInfoJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(clientInfoJson, function () {
                        return new fm.liveswitch.ClientInfo();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array of instances from JSON.
            @param clientInfosJson The JSON to deserialize.
            @return
                        The deserialized client infos.
                
            */
            ClientInfo.fromJsonArray = function (clientInfosJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(clientInfosJson, fm.liveswitch.ClientInfo.fromJson.bind(fm.liveswitch.ClientInfo));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param clientInfo The client info to serialize.
            @return
                        The serialized JSON.
                
            */
            ClientInfo.toJson = function (clientInfo) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(clientInfo, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array of instances to JSON.
            @param clientInfos The client infos to serialize.
            @return
                        The serialized JSON.
                
            */
            ClientInfo.toJsonArray = function (clientInfos) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(clientInfos, fm.liveswitch.ClientInfo.toJson.bind(fm.liveswitch.ClientInfo));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ClientInfo.prototype.deflate = function () {
                if (arguments.length == 0) {
                    var info = new fm.liveswitch.ClientInfo();
                    info.setUserId(this.getUserId());
                    info.setDeviceId(this.getDeviceId());
                    info.setId(_super.prototype.getId.call(this));
                    return info;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            ClientInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var _var0 = key;
                    if (_var0 == "version") {
                        do {
                            this.setVersion(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "applicationId") {
                        do {
                            this.setApplicationId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "userId") {
                        do {
                            this.setUserId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "userAlias") {
                        do {
                            this.setUserAlias(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "deviceId") {
                        do {
                            this.setDeviceId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "deviceAlias") {
                        do {
                            this.setDeviceAlias(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "externalId") {
                        do {
                            this.setExternalId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "tag") {
                        do {
                            this.setTag(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "region") {
                        do {
                            this.setRegion(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "roles") {
                        do {
                            this.setRoles(fm.liveswitch.JsonSerializer.deserializeStringArray(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "sourceLanguage") {
                        do {
                            this.setSourceLanguage(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "machineName") {
                        do {
                            this.setMachineName(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "coreCount") {
                        do {
                            this.setCoreCount(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "physicalMemory") {
                        do {
                            this.setPhysicalMemory(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "operatingSystem") {
                        do {
                            this.setOperatingSystem(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "operatingSystemVersion") {
                        do {
                            this.setOperatingSystemVersion(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "architecture") {
                        do {
                            this.setArchitecture(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the application identifier.
            */
            ClientInfo.prototype.getApplicationId = function () {
                if (arguments.length == 0) {
                    return this._applicationId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client architecture.
            */
            ClientInfo.prototype.getArchitecture = function () {
                if (arguments.length == 0) {
                    return this._architecture;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client core count.
            */
            ClientInfo.prototype.getCoreCount = function () {
                if (arguments.length == 0) {
                    return this._coreCount;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the device alias.
            */
            ClientInfo.prototype.getDeviceAlias = function () {
                if (arguments.length == 0) {
                    return this._deviceAlias;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the device identifier.
            */
            ClientInfo.prototype.getDeviceId = function () {
                if (arguments.length == 0) {
                    return this._deviceId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client external identifier.
            */
            ClientInfo.prototype.getExternalId = function () {
                if (arguments.length == 0) {
                    return this._externalId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client machine name.
            */
            ClientInfo.prototype.getMachineName = function () {
                if (arguments.length == 0) {
                    return this._machineName;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client operating system.
            */
            ClientInfo.prototype.getOperatingSystem = function () {
                if (arguments.length == 0) {
                    return this._operatingSystem;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client operating system version.
            */
            ClientInfo.prototype.getOperatingSystemVersion = function () {
                if (arguments.length == 0) {
                    return this._operatingSystemVersion;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connector physical memory.
            */
            ClientInfo.prototype.getPhysicalMemory = function () {
                if (arguments.length == 0) {
                    return this._physicalMemory;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client region.
            */
            ClientInfo.prototype.getRegion = function () {
                if (arguments.length == 0) {
                    return this._region;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client roles.
            */
            ClientInfo.prototype.getRoles = function () {
                if (arguments.length == 0) {
                    return this._roles;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client source language.
            */
            ClientInfo.prototype.getSourceLanguage = function () {
                if (arguments.length == 0) {
                    return this._sourceLanguage;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client tag.
            */
            ClientInfo.prototype.getTag = function () {
                if (arguments.length == 0) {
                    return this._tag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the user alias.
            */
            ClientInfo.prototype.getUserAlias = function () {
                if (arguments.length == 0) {
                    return this._userAlias;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the user identifier.
            */
            ClientInfo.prototype.getUserId = function () {
                if (arguments.length == 0) {
                    return this._userId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client version.
            */
            ClientInfo.prototype.getVersion = function () {
                if (arguments.length == 0) {
                    return this._version;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ClientInfo.prototype.inflate = function (userAlias, deviceAlias, tag, roles) {
                if (arguments.length == 4) {
                    this.setUserAlias(userAlias);
                    this.setDeviceAlias(deviceAlias);
                    this.setTag(tag);
                    this.setRoles(roles);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ClientInfo.prototype.isEquivalent = function () {
                if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.ClientInfo]'))) {
                    var clientInfo = arguments[0];
                    return ((!fm.liveswitch.Global.equals(clientInfo, null)) && this.isEquivalent(clientInfo.getUserId(), clientInfo.getDeviceId(), clientInfo.getId()));
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.ConnectionInfo]'))) {
                    var connectionInfo = arguments[0];
                    return ((!fm.liveswitch.Global.equals(connectionInfo, null)) && this.isEquivalent(connectionInfo.getUserId(), connectionInfo.getDeviceId(), connectionInfo.getClientId()));
                }
                else if (arguments.length == 3) {
                    var userId = arguments[0];
                    var deviceId = arguments[1];
                    var idValue = arguments[2];
                    return (((fm.liveswitch.Global.equals(userId, this.getUserId())) && (fm.liveswitch.Global.equals(deviceId, this.getDeviceId()))) && (fm.liveswitch.Global.equals(idValue, _super.prototype.getId.call(this))));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            ClientInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getVersion(), null))) {
                        jsonObject["version"] = fm.liveswitch.JsonSerializer.serializeString(this.getVersion());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getApplicationId(), null))) {
                        jsonObject["applicationId"] = fm.liveswitch.JsonSerializer.serializeString(this.getApplicationId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getUserId(), null))) {
                        jsonObject["userId"] = fm.liveswitch.JsonSerializer.serializeString(this.getUserId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getUserAlias(), null))) {
                        jsonObject["userAlias"] = fm.liveswitch.JsonSerializer.serializeString(this.getUserAlias());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getDeviceId(), null))) {
                        jsonObject["deviceId"] = fm.liveswitch.JsonSerializer.serializeString(this.getDeviceId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getDeviceAlias(), null))) {
                        jsonObject["deviceAlias"] = fm.liveswitch.JsonSerializer.serializeString(this.getDeviceAlias());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getExternalId(), null))) {
                        jsonObject["externalId"] = fm.liveswitch.JsonSerializer.serializeString(this.getExternalId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getTag(), null))) {
                        jsonObject["tag"] = fm.liveswitch.JsonSerializer.serializeString(this.getTag());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRegion(), null))) {
                        jsonObject["region"] = fm.liveswitch.JsonSerializer.serializeString(this.getRegion());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRoles(), null))) {
                        jsonObject["roles"] = fm.liveswitch.JsonSerializer.serializeStringArray(this.getRoles());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getSourceLanguage(), null))) {
                        jsonObject["sourceLanguage"] = fm.liveswitch.JsonSerializer.serializeString(this.getSourceLanguage());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getMachineName(), null))) {
                        jsonObject["machineName"] = fm.liveswitch.JsonSerializer.serializeString(this.getMachineName());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getCoreCount(), 0))) {
                        jsonObject["coreCount"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getCoreCount());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getPhysicalMemory(), 0))) {
                        jsonObject["physicalMemory"] = fm.liveswitch.JsonSerializer.serializeLong(this.getPhysicalMemory());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getOperatingSystem(), null))) {
                        jsonObject["operatingSystem"] = fm.liveswitch.JsonSerializer.serializeString(this.getOperatingSystem());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getOperatingSystemVersion(), null))) {
                        jsonObject["operatingSystemVersion"] = fm.liveswitch.JsonSerializer.serializeString(this.getOperatingSystemVersion());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getArchitecture(), null))) {
                        jsonObject["architecture"] = fm.liveswitch.JsonSerializer.serializeString(this.getArchitecture());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the application identifier.
            */
            ClientInfo.prototype.setApplicationId = function (value) {
                if (arguments.length == 1) {
                    this._applicationId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the client architecture.
            */
            ClientInfo.prototype.setArchitecture = function (value) {
                if (arguments.length == 1) {
                    this._architecture = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the client core count.
            */
            ClientInfo.prototype.setCoreCount = function (value) {
                if (arguments.length == 1) {
                    this._coreCount = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the device alias.
            */
            ClientInfo.prototype.setDeviceAlias = function (value) {
                if (arguments.length == 1) {
                    this._deviceAlias = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the device identifier.
            */
            ClientInfo.prototype.setDeviceId = function (value) {
                if (arguments.length == 1) {
                    this._deviceId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the client external identifier.
            */
            ClientInfo.prototype.setExternalId = function (value) {
                if (arguments.length == 1) {
                    this._externalId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the client machine name.
            */
            ClientInfo.prototype.setMachineName = function (value) {
                if (arguments.length == 1) {
                    this._machineName = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the client operating system.
            */
            ClientInfo.prototype.setOperatingSystem = function (value) {
                if (arguments.length == 1) {
                    this._operatingSystem = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the client operating system version.
            */
            ClientInfo.prototype.setOperatingSystemVersion = function (value) {
                if (arguments.length == 1) {
                    this._operatingSystemVersion = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the connector physical memory.
            */
            ClientInfo.prototype.setPhysicalMemory = function (value) {
                if (arguments.length == 1) {
                    this._physicalMemory = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the client region.
            */
            ClientInfo.prototype.setRegion = function (value) {
                if (arguments.length == 1) {
                    this._region = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the client roles.
            */
            ClientInfo.prototype.setRoles = function (value) {
                if (arguments.length == 1) {
                    this._roles = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the client source language.
            */
            ClientInfo.prototype.setSourceLanguage = function (value) {
                if (arguments.length == 1) {
                    this._sourceLanguage = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the client tag.
            */
            ClientInfo.prototype.setTag = function (value) {
                if (arguments.length == 1) {
                    this._tag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the user alias.
            */
            ClientInfo.prototype.setUserAlias = function (value) {
                if (arguments.length == 1) {
                    this._userAlias = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the user identifier.
            */
            ClientInfo.prototype.setUserId = function (value) {
                if (arguments.length == 1) {
                    this._userId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the client version.
            */
            ClientInfo.prototype.setVersion = function (value) {
                if (arguments.length == 1) {
                    this._version = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to Json.
            */
            ClientInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ClientInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ClientInfo;
        }(fm.liveswitch.Info));
        liveswitch.ClientInfo = ClientInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var ClientStateWrapper = /** @class */ (function () {
            function ClientStateWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_65 = __arguments[0];
                    //super();
                    this._value = value_65;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            ClientStateWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.ClientStateWrapper]';
            };
            ClientStateWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.ClientState.New)
                        return 'New';
                    if (this._value == fm.liveswitch.ClientState.Registering)
                        return 'Registering';
                    if (this._value == fm.liveswitch.ClientState.Registered)
                        return 'Registered';
                    if (this._value == fm.liveswitch.ClientState.Unregistering)
                        return 'Unregistering';
                    if (this._value == fm.liveswitch.ClientState.Unregistered)
                        return 'Unregistered';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ClientStateWrapper;
        }());
        liveswitch.ClientStateWrapper = ClientStateWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Connection information.
        */
        var ConnectionInfo = /** @class */ (function (_super) {
            __extends(ConnectionInfo, _super);
            function ConnectionInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchConnectionInfoInit();
                    _this.__serializeLegacyProperties = true;
                }
                else if (__arguments.length == 6) {
                    var idValue = __arguments[0];
                    var applicationId = __arguments[1];
                    var channelId = __arguments[2];
                    var userId = __arguments[3];
                    var deviceId = __arguments[4];
                    var clientId = __arguments[5];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchConnectionInfoInit();
                    _this.__serializeLegacyProperties = true;
                    _super.prototype.setId.call(_this, idValue);
                    _this.setApplicationId(applicationId);
                    _this.setChannelId(channelId);
                    _this.setUserId(userId);
                    _this.setDeviceId(deviceId);
                    _this.setClientId(clientId);
                }
                else if (__arguments.length == 14) {
                    var userId = __arguments[0];
                    var deviceId = __arguments[1];
                    var clientId = __arguments[2];
                    var idValue = __arguments[3];
                    var tag = __arguments[4];
                    var type = __arguments[5];
                    var mediaId = __arguments[6];
                    var localAudioMuted = __arguments[7];
                    var localVideoMuted = __arguments[8];
                    var audioDirection = __arguments[9];
                    var videoDirection = __arguments[10];
                    var dataDirection = __arguments[11];
                    var audioFormats = __arguments[12];
                    var videoFormats = __arguments[13];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchConnectionInfoInit();
                    _this.__serializeLegacyProperties = true;
                    _this.setUserId(userId);
                    _this.setDeviceId(deviceId);
                    _this.setClientId(clientId);
                    _super.prototype.setId.call(_this, idValue);
                    _this.setTag(tag);
                    _this.setType(type);
                    _this.setMediaId(mediaId);
                    if ((!fm.liveswitch.Global.equals(audioDirection, null))) {
                        _this.setAudioDirection(audioDirection);
                    }
                    if ((!fm.liveswitch.Global.equals(videoDirection, null))) {
                        _this.setVideoDirection(videoDirection);
                    }
                    if ((!fm.liveswitch.Global.equals(dataDirection, null))) {
                        _this.setDataDirection(dataDirection);
                    }
                    if (localAudioMuted) {
                        _this.setLocalAudioMuted(localAudioMuted);
                    }
                    if (localVideoMuted) {
                        _this.setLocalVideoMuted(localVideoMuted);
                    }
                    if ((!fm.liveswitch.Global.equals(audioFormats, null))) {
                        _this.setAudioFormats(audioFormats);
                    }
                    if ((!fm.liveswitch.Global.equals(videoFormats, null))) {
                        _this.setVideoFormats(videoFormats);
                    }
                }
                else if (__arguments.length == 18) {
                    var userId = __arguments[0];
                    var userAlias = __arguments[1];
                    var deviceId = __arguments[2];
                    var deviceAlias = __arguments[3];
                    var clientId = __arguments[4];
                    var clientTag = __arguments[5];
                    var clientRoles = __arguments[6];
                    var idValue = __arguments[7];
                    var tag = __arguments[8];
                    var type = __arguments[9];
                    var mediaId = __arguments[10];
                    var localAudioMuted = __arguments[11];
                    var localVideoMuted = __arguments[12];
                    var audioDirection = __arguments[13];
                    var videoDirection = __arguments[14];
                    var dataDirection = __arguments[15];
                    var audioFormats = __arguments[16];
                    var videoFormats = __arguments[17];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchConnectionInfoInit();
                    _this.__serializeLegacyProperties = true;
                    _this.setUserId(userId);
                    _this.setUserAlias(userAlias);
                    _this.setDeviceId(deviceId);
                    _this.setDeviceAlias(deviceAlias);
                    _this.setClientId(clientId);
                    _this.setClientTag(clientTag);
                    _this.setClientRoles(clientRoles);
                    _super.prototype.setId.call(_this, idValue);
                    _this.setTag(tag);
                    _this.setType(type);
                    _this.setMediaId(mediaId);
                    if ((!fm.liveswitch.Global.equals(audioDirection, null))) {
                        _this.setAudioDirection(audioDirection);
                    }
                    if ((!fm.liveswitch.Global.equals(videoDirection, null))) {
                        _this.setVideoDirection(videoDirection);
                    }
                    if ((!fm.liveswitch.Global.equals(dataDirection, null))) {
                        _this.setDataDirection(dataDirection);
                    }
                    if (localAudioMuted) {
                        _this.setLocalAudioMuted(localAudioMuted);
                    }
                    if (localVideoMuted) {
                        _this.setLocalVideoMuted(localVideoMuted);
                    }
                    if ((!fm.liveswitch.Global.equals(audioFormats, null))) {
                        _this.setAudioFormats(audioFormats);
                    }
                    if ((!fm.liveswitch.Global.equals(videoFormats, null))) {
                        _this.setVideoFormats(videoFormats);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            ConnectionInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.ConnectionInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            ConnectionInfo.prototype.fmliveswitchConnectionInfoInit = function () {
                this.__serializeLegacyProperties = false;
                this._recording = false;
            };
            /**
            Deserializes Json to a ConnectionInfo.
            @param connectionInfoJson The serialized Json.
            @return The deserialized ConnectionInfo.
            */
            ConnectionInfo.fromJson = function (connectionInfoJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(connectionInfoJson, function () {
                        return new fm.liveswitch.ConnectionInfo();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array of instances from JSON.
            @param connectionInfosJson The JSON to deserialize.
            @return
                        The deserialized connection infos.
                
            */
            ConnectionInfo.fromJsonArray = function (connectionInfosJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(connectionInfosJson, fm.liveswitch.ConnectionInfo.fromJson.bind(fm.liveswitch.ConnectionInfo));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to Json.
            @param connectionInfo The instance to serialize.
            @return Serialized Json.
            */
            ConnectionInfo.toJson = function (connectionInfo) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(connectionInfo, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array of instances to JSON.
            @param connectionInfos The connection infos to serialize.
            @return
                        The serialized JSON.
                
            */
            ConnectionInfo.toJsonArray = function (connectionInfos) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(connectionInfos, fm.liveswitch.ConnectionInfo.toJson.bind(fm.liveswitch.ConnectionInfo));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a client info object with details from this connection info object.
            */
            ConnectionInfo.prototype.createClientInfo = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.ClientInfo(this.getUserId(), this.getUserAlias(), this.getDeviceId(), this.getDeviceAlias(), this.getClientId(), this.getClientTag(), this.getClientRoles());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            ConnectionInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var _var0 = key;
                    if (_var0 == "applicationId") {
                        do {
                            this.setApplicationId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "channelId") {
                        do {
                            this.setChannelId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "userId") {
                        do {
                            this.setUserId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "userAlias") {
                        do {
                            this.setUserAlias(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "deviceId") {
                        do {
                            this.setDeviceId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "deviceAlias") {
                        do {
                            this.setDeviceAlias(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "clientId") {
                        do {
                            this.setClientId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "clientRoles") {
                        do {
                            this.setClientRoles(fm.liveswitch.JsonSerializer.deserializeStringArray(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "clientTag") {
                        do {
                            this.setClientTag(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "externalId") {
                        do {
                            this.setExternalId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "state") {
                        do {
                            this.setState(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "tag") {
                        do {
                            this.setTag(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "type") {
                        do {
                            this.setType(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "recording") {
                        do {
                            this.setRecording(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "error") {
                        do {
                            this.setError(fm.liveswitch.Error.fromJson(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "mediaId") {
                        do {
                            this.setMediaId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "remoteConnectionId") {
                        do {
                            this.setRemoteConnectionId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "remoteMediaId") {
                        do {
                            this.setRemoteMediaId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "audioStreams") {
                        do {
                            this.setAudioStreams(fm.liveswitch.MediaStreamInfo.fromJsonArray(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "videoStreams") {
                        do {
                            this.setVideoStreams(fm.liveswitch.MediaStreamInfo.fromJsonArray(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "dataStream") {
                        do {
                            this.setDataStream(fm.liveswitch.DataStreamInfo.fromJson(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "transports") {
                        do {
                            this.setTransports(fm.liveswitch.TransportInfo.fromJsonArray(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "localAudioMuted") {
                        do {
                            this.setLocalAudioMuted(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "localVideoMuted") {
                        do {
                            this.setLocalVideoMuted(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "audioDirection") {
                        do {
                            this.setAudioDirection(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "videoDirection") {
                        do {
                            this.setVideoDirection(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "dataDirection") {
                        do {
                            this.setDataDirection(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "audioFormats") {
                        do {
                            this.setAudioFormats(fm.liveswitch.FormatInfo.fromJsonArray(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "videoFormats") {
                        do {
                            this.setVideoFormats(fm.liveswitch.FormatInfo.fromJsonArray(valueJson));
                            break;
                        } while (false);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the application identifier.
            */
            ConnectionInfo.prototype.getApplicationId = function () {
                if (arguments.length == 0) {
                    return this._applicationId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the audio stream direction. Obsolete. Use AudioStream.Direction instead.
            */
            ConnectionInfo.prototype.getAudioDirection = function () {
                if (arguments.length == 0) {
                    var audioStream = this.getAudioStream();
                    if ((fm.liveswitch.Global.equals(audioStream, null))) {
                        return null;
                    }
                    return fm.liveswitch.StringExtensions.nullCoalesce(audioStream.getDirection(), "sendrecv");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the audio formats, if applicable. Obsolete. Use AudioStream.Formats instead.
            */
            ConnectionInfo.prototype.getAudioFormats = function () {
                if (arguments.length == 0) {
                    var flag = void 0;
                    var audioStream = this.getAudioStream();
                    if ((fm.liveswitch.Global.equals(audioStream, null))) {
                        return null;
                    }
                    var list = new Array();
                    var sendFormats = audioStream.getSendFormats();
                    if ((!fm.liveswitch.Global.equals(sendFormats, null))) {
                        for (var _i = 0, sendFormats_1 = sendFormats; _i < sendFormats_1.length; _i++) {
                            var info2 = sendFormats_1[_i];
                            flag = false;
                            for (var _a = 0, list_9 = list; _a < list_9.length; _a++) {
                                var info3 = list_9[_a];
                                if (info2.isEquivalent(info3)) {
                                    flag = true;
                                    break;
                                }
                            }
                            if (!flag) {
                                fm.liveswitch.ArrayExtensions.add(list, info2);
                            }
                        }
                    }
                    var receiveFormats = audioStream.getReceiveFormats();
                    if ((!fm.liveswitch.Global.equals(receiveFormats, null))) {
                        for (var _b = 0, receiveFormats_1 = receiveFormats; _b < receiveFormats_1.length; _b++) {
                            var info4 = receiveFormats_1[_b];
                            flag = false;
                            for (var _c = 0, list_10 = list; _c < list_10.length; _c++) {
                                var info3 = list_10[_c];
                                if (info4.isEquivalent(info3)) {
                                    flag = true;
                                    break;
                                }
                            }
                            if (!flag) {
                                fm.liveswitch.ArrayExtensions.add(list, info4);
                            }
                        }
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the first connection audio stream.
            */
            ConnectionInfo.prototype.getAudioStream = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Utility.firstOrDefault(this.getAudioStreams());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connection audio streams.
            */
            ConnectionInfo.prototype.getAudioStreams = function () {
                if (arguments.length == 0) {
                    return this._audioStreams;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the channel identifier.
            */
            ConnectionInfo.prototype.getChannelId = function () {
                if (arguments.length == 0) {
                    return this._channelId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client identifier.
            */
            ConnectionInfo.prototype.getClientId = function () {
                if (arguments.length == 0) {
                    return this._clientId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client roles.
            */
            ConnectionInfo.prototype.getClientRoles = function () {
                if (arguments.length == 0) {
                    return this._clientRoles;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client tag.
            */
            ConnectionInfo.prototype.getClientTag = function () {
                if (arguments.length == 0) {
                    return this._clientTag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the data stream direction. Obsolete.
            */
            ConnectionInfo.prototype.getDataDirection = function () {
                if (arguments.length == 0) {
                    if ((fm.liveswitch.Global.equals(this.getDataStream(), null))) {
                        return null;
                    }
                    return "sendrecv";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connection data stream.
            */
            ConnectionInfo.prototype.getDataStream = function () {
                if (arguments.length == 0) {
                    return this._dataStream;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the device alias.
            */
            ConnectionInfo.prototype.getDeviceAlias = function () {
                if (arguments.length == 0) {
                    return this._deviceAlias;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the device identifier.
            */
            ConnectionInfo.prototype.getDeviceId = function () {
                if (arguments.length == 0) {
                    return this._deviceId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connection error, if an error exists.
            */
            ConnectionInfo.prototype.getError = function () {
                if (arguments.length == 0) {
                    return this._error;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connection external identifier.
            */
            ConnectionInfo.prototype.getExternalId = function () {
                if (arguments.length == 0) {
                    return this._externalId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the connection has an audio stream.
            */
            ConnectionInfo.prototype.getHasAudio = function () {
                if (arguments.length == 0) {
                    return (!fm.liveswitch.Global.equals(this.getAudioStream(), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the connection has a data stream.
            */
            ConnectionInfo.prototype.getHasData = function () {
                if (arguments.length == 0) {
                    return (!fm.liveswitch.Global.equals(this.getDataStream(), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets a value indicating whether the connection has a video stream.
            */
            ConnectionInfo.prototype.getHasVideo = function () {
                if (arguments.length == 0) {
                    return (!fm.liveswitch.Global.equals(this.getVideoStream(), null));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if local audio is disabled. Obsolete. Use AudioStream.SendDisabled instead.
            */
            ConnectionInfo.prototype.getLocalAudioDisabled = function () {
                if (arguments.length == 0) {
                    var audioStream = this.getAudioStream();
                    if ((fm.liveswitch.Global.equals(audioStream, null))) {
                        return false;
                    }
                    return audioStream.getSendDisabled();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if the local audio is muted. Obsolete. Use AudioStream.Muted instead.
            */
            ConnectionInfo.prototype.getLocalAudioMuted = function () {
                if (arguments.length == 0) {
                    var audioStream = this.getAudioStream();
                    if ((fm.liveswitch.Global.equals(audioStream, null))) {
                        return false;
                    }
                    return audioStream.getSendMuted();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if local video is disabled. Obsolete. Use VideoStream.SendDisabled instead.
            */
            ConnectionInfo.prototype.getLocalVideoDisabled = function () {
                if (arguments.length == 0) {
                    var videoStream = this.getVideoStream();
                    if ((fm.liveswitch.Global.equals(videoStream, null))) {
                        return false;
                    }
                    return videoStream.getSendDisabled();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if the local video is muted. Obsolete. Use VideoStream.Muted instead.
            */
            ConnectionInfo.prototype.getLocalVideoMuted = function () {
                if (arguments.length == 0) {
                    var videoStream = this.getVideoStream();
                    if ((fm.liveswitch.Global.equals(videoStream, null))) {
                        return false;
                    }
                    return videoStream.getSendMuted();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media identifier, for MCU or SFU upstream connections.
            */
            ConnectionInfo.prototype.getMediaId = function () {
                if (arguments.length == 0) {
                    return this._mediaId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the connection is recording.
            */
            ConnectionInfo.prototype.getRecording = function () {
                if (arguments.length == 0) {
                    return this._recording;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if remote audio is disabled. Obsolete. Use AudioStream.ReceiveDisabled instead.
            */
            ConnectionInfo.prototype.getRemoteAudioDisabled = function () {
                if (arguments.length == 0) {
                    var audioStream = this.getAudioStream();
                    if ((fm.liveswitch.Global.equals(audioStream, null))) {
                        return false;
                    }
                    return audioStream.getReceiveDisabled();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote connection identifier, for peer or SFU downstream connections.
            */
            ConnectionInfo.prototype.getRemoteConnectionId = function () {
                if (arguments.length == 0) {
                    return this._remoteConnectionId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote media identifier, for SFU downstream connections.
            */
            ConnectionInfo.prototype.getRemoteMediaId = function () {
                if (arguments.length == 0) {
                    return this._remoteMediaId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets if remote video is disabled. Obsolete. Use VideoStream.ReceiveDisabled instead.
            */
            ConnectionInfo.prototype.getRemoteVideoDisabled = function () {
                if (arguments.length == 0) {
                    var videoStream = this.getVideoStream();
                    if ((fm.liveswitch.Global.equals(videoStream, null))) {
                        return false;
                    }
                    return videoStream.getReceiveDisabled();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ConnectionInfo.prototype.getSerializeLegacyProperties = function () {
                if (arguments.length == 0) {
                    return this.__serializeLegacyProperties;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connection state.
            */
            ConnectionInfo.prototype.getState = function () {
                if (arguments.length == 0) {
                    return this._state;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connection tag.
            */
            ConnectionInfo.prototype.getTag = function () {
                if (arguments.length == 0) {
                    return this._tag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connection transport information. This will be `null` if BUNDLE is inactive.
            */
            ConnectionInfo.prototype.getTransports = function () {
                if (arguments.length == 0) {
                    return this._transports;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connection type.
            */
            ConnectionInfo.prototype.getType = function () {
                if (arguments.length == 0) {
                    return this._type;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the user alias.
            */
            ConnectionInfo.prototype.getUserAlias = function () {
                if (arguments.length == 0) {
                    return this._userAlias;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the user identifier.
            */
            ConnectionInfo.prototype.getUserId = function () {
                if (arguments.length == 0) {
                    return this._userId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the video stream direction. Obsolete. Use VideoStream.Direction instead.
            */
            ConnectionInfo.prototype.getVideoDirection = function () {
                if (arguments.length == 0) {
                    var videoStream = this.getVideoStream();
                    if ((fm.liveswitch.Global.equals(videoStream, null))) {
                        return null;
                    }
                    return fm.liveswitch.StringExtensions.nullCoalesce(videoStream.getDirection(), "sendrecv");
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the video formats, if applicable. Obsolete. Use VideoStream.Formats instead.
            */
            ConnectionInfo.prototype.getVideoFormats = function () {
                if (arguments.length == 0) {
                    var flag = void 0;
                    var videoStream = this.getVideoStream();
                    if ((fm.liveswitch.Global.equals(videoStream, null))) {
                        return null;
                    }
                    var list = new Array();
                    var sendFormats = videoStream.getSendFormats();
                    if ((!fm.liveswitch.Global.equals(sendFormats, null))) {
                        for (var _i = 0, sendFormats_2 = sendFormats; _i < sendFormats_2.length; _i++) {
                            var info2 = sendFormats_2[_i];
                            flag = false;
                            for (var _a = 0, list_11 = list; _a < list_11.length; _a++) {
                                var info3 = list_11[_a];
                                if (info2.isEquivalent(info3)) {
                                    flag = true;
                                    break;
                                }
                            }
                            if (!flag) {
                                fm.liveswitch.ArrayExtensions.add(list, info2);
                            }
                        }
                    }
                    var receiveFormats = videoStream.getReceiveFormats();
                    if ((!fm.liveswitch.Global.equals(receiveFormats, null))) {
                        for (var _b = 0, receiveFormats_2 = receiveFormats; _b < receiveFormats_2.length; _b++) {
                            var info4 = receiveFormats_2[_b];
                            flag = false;
                            for (var _c = 0, list_12 = list; _c < list_12.length; _c++) {
                                var info3 = list_12[_c];
                                if (info4.isEquivalent(info3)) {
                                    flag = true;
                                    break;
                                }
                            }
                            if (!flag) {
                                fm.liveswitch.ArrayExtensions.add(list, info4);
                            }
                        }
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the first connection video stream.
            */
            ConnectionInfo.prototype.getVideoStream = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Utility.firstOrDefault(this.getVideoStreams());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connection video streams.
            */
            ConnectionInfo.prototype.getVideoStreams = function () {
                if (arguments.length == 0) {
                    return this._videoStreams;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ConnectionInfo.prototype.inflate = function (userAlias, deviceAlias, clientTag, clientRoles) {
                if (arguments.length == 4) {
                    if ((!fm.liveswitch.Global.equals(userAlias, null))) {
                        this.setUserAlias(userAlias);
                    }
                    if ((!fm.liveswitch.Global.equals(deviceAlias, null))) {
                        this.setDeviceAlias(deviceAlias);
                    }
                    if ((!fm.liveswitch.Global.equals(clientTag, null))) {
                        this.setClientTag(clientTag);
                    }
                    if ((!fm.liveswitch.Global.equals(clientRoles, null))) {
                        this.setClientRoles(clientRoles);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ConnectionInfo.prototype.isEquivalent = function () {
                if (arguments.length == 1) {
                    var connectionInfo = arguments[0];
                    return ((!fm.liveswitch.Global.equals(connectionInfo, null)) && this.isEquivalent(connectionInfo.getUserId(), connectionInfo.getDeviceId(), connectionInfo.getClientId(), connectionInfo.getId()));
                }
                else if (arguments.length == 4) {
                    var userId = arguments[0];
                    var deviceId = arguments[1];
                    var clientId = arguments[2];
                    var idValue = arguments[3];
                    return ((((fm.liveswitch.Global.equals(userId, this.getUserId())) && (fm.liveswitch.Global.equals(deviceId, this.getDeviceId()))) && (fm.liveswitch.Global.equals(clientId, this.getClientId()))) && (fm.liveswitch.Global.equals(idValue, _super.prototype.getId.call(this))));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ConnectionInfo.prototype.populateInfo = function (stats, lastStats, eventType) {
                if (arguments.length == 3) {
                    this.setSerializeLegacyProperties(false);
                    if (this.shouldIncludeReport(eventType)) {
                        var num = void 0;
                        if ((!fm.liveswitch.Global.equals(this.getAudioStreams(), null))) {
                            var audioStreams = stats.getAudioStreams();
                            if ((!fm.liveswitch.Global.equals(audioStreams, null))) {
                                var statsArray2 = ((fm.liveswitch.Global.equals(lastStats, null)) ? null : lastStats.getAudioStreams());
                                for (num = 0; (num < fm.liveswitch.MathAssistant.min(audioStreams.length, this.getAudioStreams().length)); num++) {
                                    var stats2 = (((!fm.liveswitch.Global.equals(statsArray2, null)) && (statsArray2.length > num)) ? statsArray2[num] : null);
                                    this.getAudioStreams()[num].populateInfos(audioStreams[num], stats2);
                                    this.scrubTransport(audioStreams[num].getTransport(), ((fm.liveswitch.Global.equals(stats2, null)) ? null : stats2.getTransport()));
                                    if ((fm.liveswitch.Global.equals(eventType, "connection.stats"))) {
                                        this.getAudioStreams()[num].setId(null);
                                        this.getAudioStreams()[num].setSendDisabled(false);
                                        this.getAudioStreams()[num].setReceiveDisabled(false);
                                        this.getAudioStreams()[num].setSendFormats(null);
                                        this.getAudioStreams()[num].setReceiveFormats(null);
                                        this.getAudioStreams()[num].setSendEncodings(null);
                                        this.getAudioStreams()[num].setReceiveEncodings(null);
                                    }
                                }
                            }
                        }
                        if ((!fm.liveswitch.Global.equals(this.getVideoStreams(), null))) {
                            var videoStreams = stats.getVideoStreams();
                            if ((!fm.liveswitch.Global.equals(videoStreams, null))) {
                                var statsArray4 = ((fm.liveswitch.Global.equals(lastStats, null)) ? null : lastStats.getVideoStreams());
                                for (num = 0; (num < fm.liveswitch.MathAssistant.min(videoStreams.length, this.getVideoStreams().length)); num++) {
                                    var stats3 = (((!fm.liveswitch.Global.equals(statsArray4, null)) && (statsArray4.length > num)) ? statsArray4[num] : null);
                                    this.getVideoStreams()[num].populateInfos(videoStreams[num], stats3);
                                    this.scrubTransport(videoStreams[num].getTransport(), ((fm.liveswitch.Global.equals(stats3, null)) ? null : stats3.getTransport()));
                                    if ((fm.liveswitch.Global.equals(eventType, "connection.stats"))) {
                                        this.getVideoStreams()[num].setId(null);
                                        this.getVideoStreams()[num].setSendDisabled(false);
                                        this.getVideoStreams()[num].setReceiveDisabled(false);
                                        this.getVideoStreams()[num].setSendFormats(null);
                                        this.getVideoStreams()[num].setReceiveFormats(null);
                                        this.getVideoStreams()[num].setSendEncodings(null);
                                        this.getVideoStreams()[num].setReceiveEncodings(null);
                                    }
                                }
                            }
                        }
                        if ((!fm.liveswitch.Global.equals(this.getDataStream(), null))) {
                            var dataStream = stats.getDataStream();
                            if ((!fm.liveswitch.Global.equals(dataStream, null))) {
                                var stats5 = ((fm.liveswitch.Global.equals(lastStats, null)) ? null : lastStats.getDataStream());
                                this.getDataStream().populateInfos(dataStream, stats5, eventType);
                                this.scrubTransport(dataStream.getTransport(), ((fm.liveswitch.Global.equals(stats5, null)) ? null : stats5.getTransport()));
                                if ((fm.liveswitch.Global.equals(eventType, "connection.stats"))) {
                                    this.getDataStream().setId(null);
                                }
                            }
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ConnectionInfo.prototype.scrubTransport = function (transportStats, lastTransportStats) {
                if (arguments.length == 2) {
                    for (var i = 0; (i < this.getTransports().length); i++) {
                        var info = this.getTransports()[i];
                        if ((((!fm.liveswitch.Global.equals(info, null)) && (!fm.liveswitch.Global.equals(transportStats, null))) && (fm.liveswitch.Global.equals(info.getId(), transportStats.getId())))) {
                            this.getTransports()[i] = new fm.liveswitch.TransportInfo(transportStats, lastTransportStats);
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            ConnectionInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getApplicationId(), null))) {
                        jsonObject["applicationId"] = fm.liveswitch.JsonSerializer.serializeString(this.getApplicationId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getChannelId(), null))) {
                        jsonObject["channelId"] = fm.liveswitch.JsonSerializer.serializeString(this.getChannelId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getUserId(), null))) {
                        jsonObject["userId"] = fm.liveswitch.JsonSerializer.serializeString(this.getUserId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getUserAlias(), null))) {
                        jsonObject["userAlias"] = fm.liveswitch.JsonSerializer.serializeString(this.getUserAlias());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getDeviceId(), null))) {
                        jsonObject["deviceId"] = fm.liveswitch.JsonSerializer.serializeString(this.getDeviceId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getDeviceAlias(), null))) {
                        jsonObject["deviceAlias"] = fm.liveswitch.JsonSerializer.serializeString(this.getDeviceAlias());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getClientId(), null))) {
                        jsonObject["clientId"] = fm.liveswitch.JsonSerializer.serializeString(this.getClientId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getClientRoles(), null))) {
                        jsonObject["clientRoles"] = fm.liveswitch.JsonSerializer.serializeStringArray(this.getClientRoles());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getClientTag(), null))) {
                        jsonObject["clientTag"] = fm.liveswitch.JsonSerializer.serializeString(this.getClientTag());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getExternalId(), null))) {
                        jsonObject["externalId"] = fm.liveswitch.JsonSerializer.serializeString(this.getExternalId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getState(), null))) {
                        jsonObject["state"] = fm.liveswitch.JsonSerializer.serializeString(this.getState());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getTag(), null))) {
                        jsonObject["tag"] = fm.liveswitch.JsonSerializer.serializeString(this.getTag());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getType(), null))) {
                        jsonObject["type"] = fm.liveswitch.JsonSerializer.serializeString(this.getType());
                    }
                    if (this.getRecording()) {
                        jsonObject["recording"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getRecording());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getError(), null))) {
                        jsonObject["error"] = fm.liveswitch.Error.toJson(this.getError());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getMediaId(), null))) {
                        jsonObject["mediaId"] = fm.liveswitch.JsonSerializer.serializeString(this.getMediaId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRemoteConnectionId(), null))) {
                        jsonObject["remoteConnectionId"] = fm.liveswitch.JsonSerializer.serializeString(this.getRemoteConnectionId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRemoteMediaId(), null))) {
                        jsonObject["remoteMediaId"] = fm.liveswitch.JsonSerializer.serializeString(this.getRemoteMediaId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getAudioStreams(), null))) {
                        jsonObject["audioStreams"] = fm.liveswitch.MediaStreamInfo.toJsonArray(this.getAudioStreams());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getVideoStreams(), null))) {
                        jsonObject["videoStreams"] = fm.liveswitch.MediaStreamInfo.toJsonArray(this.getVideoStreams());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getDataStream(), null))) {
                        jsonObject["dataStream"] = fm.liveswitch.DataStreamInfo.toJson(this.getDataStream());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getTransports(), null))) {
                        jsonObject["transports"] = fm.liveswitch.TransportInfo.toJsonArray(this.getTransports());
                    }
                    if (this.getSerializeLegacyProperties()) {
                        if (this.getLocalAudioMuted()) {
                            jsonObject["localAudioMuted"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getLocalAudioMuted());
                        }
                        if (this.getLocalVideoMuted()) {
                            jsonObject["localVideoMuted"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getLocalVideoMuted());
                        }
                        if ((!fm.liveswitch.Global.equals(this.getAudioDirection(), null))) {
                            jsonObject["audioDirection"] = fm.liveswitch.JsonSerializer.serializeString(this.getAudioDirection());
                        }
                        if ((!fm.liveswitch.Global.equals(this.getVideoDirection(), null))) {
                            jsonObject["videoDirection"] = fm.liveswitch.JsonSerializer.serializeString(this.getVideoDirection());
                        }
                        if ((!fm.liveswitch.Global.equals(this.getDataDirection(), null))) {
                            jsonObject["dataDirection"] = fm.liveswitch.JsonSerializer.serializeString(this.getDataDirection());
                        }
                        if ((!fm.liveswitch.Global.equals(this.getAudioFormats(), null))) {
                            jsonObject["audioFormats"] = fm.liveswitch.FormatInfo.toJsonArray(this.getAudioFormats());
                        }
                        if ((!fm.liveswitch.Global.equals(this.getVideoFormats(), null))) {
                            jsonObject["videoFormats"] = fm.liveswitch.FormatInfo.toJsonArray(this.getVideoFormats());
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the application identifier.
            */
            ConnectionInfo.prototype.setApplicationId = function (value) {
                if (arguments.length == 1) {
                    this._applicationId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ConnectionInfo.prototype.setAudioDirection = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(value, null))) {
                        this.setAudioStream(null);
                    }
                    else {
                        var audioStream = this.getAudioStream();
                        if ((fm.liveswitch.Global.equals(audioStream, null))) {
                            audioStream = new fm.liveswitch.MediaStreamInfo();
                            this.setAudioStream(audioStream);
                        }
                        audioStream.setDirection(value);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ConnectionInfo.prototype.setAudioFormats = function (value) {
                if (arguments.length == 1) {
                    var audioStream = this.getAudioStream();
                    if ((fm.liveswitch.Global.equals(audioStream, null))) {
                        this.setAudioStream(new fm.liveswitch.MediaStreamInfo());
                        audioStream = this.getAudioStream();
                    }
                    audioStream.setSendFormats(value);
                    audioStream.setReceiveFormats(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the first connection audio stream.
            */
            ConnectionInfo.prototype.setAudioStream = function (value) {
                if (arguments.length == 1) {
                    this.setAudioStreams(((fm.liveswitch.Global.equals(value, null)) ? null : [value]));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the connection audio streams.
            */
            ConnectionInfo.prototype.setAudioStreams = function (value) {
                if (arguments.length == 1) {
                    this._audioStreams = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the channel identifier.
            */
            ConnectionInfo.prototype.setChannelId = function (value) {
                if (arguments.length == 1) {
                    this._channelId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the client identifier.
            */
            ConnectionInfo.prototype.setClientId = function (value) {
                if (arguments.length == 1) {
                    this._clientId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the client roles.
            */
            ConnectionInfo.prototype.setClientRoles = function (value) {
                if (arguments.length == 1) {
                    this._clientRoles = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the client tag.
            */
            ConnectionInfo.prototype.setClientTag = function (value) {
                if (arguments.length == 1) {
                    this._clientTag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ConnectionInfo.prototype.setDataDirection = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(value, null))) {
                        this.setDataStream(null);
                    }
                    else {
                        if ((fm.liveswitch.Global.equals(this.getDataStream(), null))) {
                            var info = new fm.liveswitch.DataStreamInfo();
                            this.setDataStream(info);
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the connection data stream.
            */
            ConnectionInfo.prototype.setDataStream = function (value) {
                if (arguments.length == 1) {
                    this._dataStream = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the device alias.
            */
            ConnectionInfo.prototype.setDeviceAlias = function (value) {
                if (arguments.length == 1) {
                    this._deviceAlias = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the device identifier.
            */
            ConnectionInfo.prototype.setDeviceId = function (value) {
                if (arguments.length == 1) {
                    this._deviceId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the connection error, if an error exists.
            */
            ConnectionInfo.prototype.setError = function (value) {
                if (arguments.length == 1) {
                    this._error = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the connection external identifier.
            */
            ConnectionInfo.prototype.setExternalId = function (value) {
                if (arguments.length == 1) {
                    this._externalId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ConnectionInfo.prototype.setLocalAudioDisabled = function (value) {
                if (arguments.length == 1) {
                    var audioStream = this.getAudioStream();
                    if ((fm.liveswitch.Global.equals(audioStream, null))) {
                        this.setAudioStream(new fm.liveswitch.MediaStreamInfo());
                        audioStream = this.getAudioStream();
                    }
                    audioStream.setSendDisabled(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ConnectionInfo.prototype.setLocalAudioMuted = function (value) {
                if (arguments.length == 1) {
                    var audioStream = this.getAudioStream();
                    if ((fm.liveswitch.Global.equals(audioStream, null))) {
                        this.setAudioStream(new fm.liveswitch.MediaStreamInfo());
                        audioStream = this.getAudioStream();
                    }
                    audioStream.setSendMuted(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ConnectionInfo.prototype.setLocalVideoDisabled = function (value) {
                if (arguments.length == 1) {
                    var videoStream = this.getVideoStream();
                    if ((fm.liveswitch.Global.equals(videoStream, null))) {
                        this.setVideoStream(new fm.liveswitch.MediaStreamInfo());
                        videoStream = this.getVideoStream();
                    }
                    videoStream.setSendDisabled(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ConnectionInfo.prototype.setLocalVideoMuted = function (value) {
                if (arguments.length == 1) {
                    var videoStream = this.getVideoStream();
                    if ((fm.liveswitch.Global.equals(videoStream, null))) {
                        this.setVideoStream(new fm.liveswitch.MediaStreamInfo());
                        videoStream = this.getVideoStream();
                    }
                    videoStream.setSendMuted(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media identifier, for MCU or SFU upstream connections.
            */
            ConnectionInfo.prototype.setMediaId = function (value) {
                if (arguments.length == 1) {
                    this._mediaId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the connection is recording.
            */
            ConnectionInfo.prototype.setRecording = function (value) {
                if (arguments.length == 1) {
                    this._recording = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ConnectionInfo.prototype.setRemoteAudioDisabled = function (value) {
                if (arguments.length == 1) {
                    var audioStream = this.getAudioStream();
                    if ((fm.liveswitch.Global.equals(audioStream, null))) {
                        this.setAudioStream(new fm.liveswitch.MediaStreamInfo());
                        audioStream = this.getAudioStream();
                    }
                    audioStream.setReceiveDisabled(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote connection identifier, for peer or SFU downstream connections.
            */
            ConnectionInfo.prototype.setRemoteConnectionId = function (value) {
                if (arguments.length == 1) {
                    this._remoteConnectionId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote media identifier, for SFU downstream connections.
            */
            ConnectionInfo.prototype.setRemoteMediaId = function (value) {
                if (arguments.length == 1) {
                    this._remoteMediaId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ConnectionInfo.prototype.setRemoteVideoDisabled = function (value) {
                if (arguments.length == 1) {
                    var videoStream = this.getVideoStream();
                    if ((fm.liveswitch.Global.equals(videoStream, null))) {
                        this.setVideoStream(new fm.liveswitch.MediaStreamInfo());
                        videoStream = this.getVideoStream();
                    }
                    videoStream.setReceiveDisabled(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ConnectionInfo.prototype.setSerializeLegacyProperties = function (value) {
                if (arguments.length == 1) {
                    this.__serializeLegacyProperties = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the connection state.
            */
            ConnectionInfo.prototype.setState = function (value) {
                if (arguments.length == 1) {
                    this._state = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the connection tag.
            */
            ConnectionInfo.prototype.setTag = function (value) {
                if (arguments.length == 1) {
                    this._tag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the connection transport information. This will be `null` if BUNDLE is inactive.
            */
            ConnectionInfo.prototype.setTransports = function (value) {
                if (arguments.length == 1) {
                    this._transports = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the connection type.
            */
            ConnectionInfo.prototype.setType = function (value) {
                if (arguments.length == 1) {
                    this._type = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the user alias.
            */
            ConnectionInfo.prototype.setUserAlias = function (value) {
                if (arguments.length == 1) {
                    this._userAlias = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the user identifier.
            */
            ConnectionInfo.prototype.setUserId = function (value) {
                if (arguments.length == 1) {
                    this._userId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ConnectionInfo.prototype.setVideoDirection = function (value) {
                if (arguments.length == 1) {
                    if ((fm.liveswitch.Global.equals(value, null))) {
                        this.setVideoStream(null);
                    }
                    else {
                        var videoStream = this.getVideoStream();
                        if ((fm.liveswitch.Global.equals(videoStream, null))) {
                            videoStream = new fm.liveswitch.MediaStreamInfo();
                            this.setVideoStream(videoStream);
                        }
                        videoStream.setDirection(value);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ConnectionInfo.prototype.setVideoFormats = function (value) {
                if (arguments.length == 1) {
                    var videoStream = this.getVideoStream();
                    if ((fm.liveswitch.Global.equals(videoStream, null))) {
                        this.setVideoStream(new fm.liveswitch.MediaStreamInfo());
                        videoStream = this.getVideoStream();
                    }
                    videoStream.setSendFormats(value);
                    videoStream.setReceiveFormats(value);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the first connection video stream.
            */
            ConnectionInfo.prototype.setVideoStream = function (value) {
                if (arguments.length == 1) {
                    this.setVideoStreams(((fm.liveswitch.Global.equals(value, null)) ? null : [value]));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the connection video streams.
            */
            ConnectionInfo.prototype.setVideoStreams = function (value) {
                if (arguments.length == 1) {
                    this._videoStreams = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            ConnectionInfo.prototype.shouldIncludeReport = function (eventType) {
                if (arguments.length == 1) {
                    return (((fm.liveswitch.Global.equals(eventType, "connection.stats")) || (fm.liveswitch.Global.equals(eventType, "connection.closed"))) || (fm.liveswitch.Global.equals(eventType, "connection.failed")));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether to serialize the legacy audio direction property.
            */
            ConnectionInfo.prototype.shouldSerializeAudioDirection = function () {
                if (arguments.length == 0) {
                    return this.getSerializeLegacyProperties();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether to serialize the legacy audio formats property.
            */
            ConnectionInfo.prototype.shouldSerializeAudioFormats = function () {
                if (arguments.length == 0) {
                    return this.getSerializeLegacyProperties();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether to serialize the legacy data direction property.
            */
            ConnectionInfo.prototype.shouldSerializeDataDirection = function () {
                if (arguments.length == 0) {
                    return this.getSerializeLegacyProperties();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether to serialize the legacy local audio muted property.
            */
            ConnectionInfo.prototype.shouldSerializeLocalAudioMuted = function () {
                if (arguments.length == 0) {
                    return this.getSerializeLegacyProperties();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether to serialize the legacy local video muted property.
            */
            ConnectionInfo.prototype.shouldSerializeLocalVideoMuted = function () {
                if (arguments.length == 0) {
                    return this.getSerializeLegacyProperties();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether to serialize the legacy video direction property.
            */
            ConnectionInfo.prototype.shouldSerializeVideoDirection = function () {
                if (arguments.length == 0) {
                    return this.getSerializeLegacyProperties();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether to serialize the legacy video formats property.
            */
            ConnectionInfo.prototype.shouldSerializeVideoFormats = function () {
                if (arguments.length == 0) {
                    return this.getSerializeLegacyProperties();
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to Json.
            */
            ConnectionInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.ConnectionInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ConnectionInfo;
        }(fm.liveswitch.Info));
        liveswitch.ConnectionInfo = ConnectionInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A connection type.
        */
        var ConnectionType = /** @class */ (function () {
            function ConnectionType() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            ConnectionType.prototype.getTypeString = function () {
                return '[fm.liveswitch.ConnectionType]';
            };
            /**
            Gets the "mcu" connection type string.
            */
            ConnectionType.getMcu = function () {
                if (arguments.length == 0) {
                    return "mcu";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "peer" connection type string.
            */
            ConnectionType.getPeer = function () {
                if (arguments.length == 0) {
                    return "peer";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "sfu" connection type string.
            */
            ConnectionType.getSfu = function () {
                if (arguments.length == 0) {
                    return "sfu";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ConnectionType;
        }());
        liveswitch.ConnectionType = ConnectionType;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Report.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Data channel report.
        */
        var DataChannelReport = /** @class */ (function (_super) {
            __extends(DataChannelReport, _super);
            function DataChannelReport() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchDataChannelReportInit();
                }
                else if (__arguments.length == 3) {
                    var stats = __arguments[0];
                    var lastStats = __arguments[1];
                    var eventType = __arguments[2];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchDataChannelReportInit();
                    var flag = (fm.liveswitch.Global.equals(lastStats, null));
                    _this.setMessagesSent(fm.liveswitch.Report.processLong(stats.getMessagesSent(), (flag ? 0 : lastStats.getMessagesSent())));
                    _this.setBytesSent(fm.liveswitch.Report.processLong(stats.getBytesSent(), (flag ? 0 : lastStats.getBytesSent())));
                    _this.setMessagesReceived(fm.liveswitch.Report.processLong(stats.getMessagesReceived(), (flag ? 0 : lastStats.getMessagesReceived())));
                    _this.setBytesReceived(fm.liveswitch.Report.processLong(stats.getBytesReceived(), (flag ? 0 : lastStats.getBytesReceived())));
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            DataChannelReport.prototype.getTypeString = function () {
                return '[fm.liveswitch.DataChannelReport]' + ',' + _super.prototype.getTypeString.call(this);
            };
            DataChannelReport.prototype.fmliveswitchDataChannelReportInit = function () {
                this._bytesReceived = 0;
                this._bytesSent = 0;
                this._messagesReceived = 0;
                this._messagesSent = 0;
            };
            /**
            Deserializes Json to a DataChannelReport.
            @param dataChannelReportJson The serialized Json.
            @return The deserialized DataChannelReport.
            */
            DataChannelReport.fromJson = function (dataChannelReportJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(dataChannelReportJson, function () {
                        return new fm.liveswitch.DataChannelReport();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to Json.
            @param dataChannelReport The instance to serialize.
            @return Serialized Json.
            */
            DataChannelReport.toJson = function (dataChannelReport) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(dataChannelReport, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            DataChannelReport.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "messagesSent"))) {
                            if ((fm.liveswitch.Global.equals(str, "bytesSent"))) {
                                this.setBytesSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "messagesReceived"))) {
                                    this.setMessagesReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "bytesReceived"))) {
                                        this.setBytesReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                                    }
                                }
                            }
                        }
                        else {
                            this.setMessagesSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes received on this data channel.
            */
            DataChannelReport.prototype.getBytesReceived = function () {
                if (arguments.length == 0) {
                    return this._bytesReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes sent on this data channel.
            */
            DataChannelReport.prototype.getBytesSent = function () {
                if (arguments.length == 0) {
                    return this._bytesSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of messages received on this data channel.
            */
            DataChannelReport.prototype.getMessagesReceived = function () {
                if (arguments.length == 0) {
                    return this._messagesReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of messages sent on this data channel.
            */
            DataChannelReport.prototype.getMessagesSent = function () {
                if (arguments.length == 0) {
                    return this._messagesSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            DataChannelReport.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((this.getMessagesSent() != null)) {
                        jsonObject["messagesSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getMessagesSent());
                    }
                    if ((this.getBytesSent() != null)) {
                        jsonObject["bytesSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getBytesSent());
                    }
                    if ((this.getMessagesReceived() != null)) {
                        jsonObject["messagesReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getMessagesReceived());
                    }
                    if ((this.getBytesReceived() != null)) {
                        jsonObject["bytesReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getBytesReceived());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of bytes received on this data channel.
            */
            DataChannelReport.prototype.setBytesReceived = function (value) {
                if (arguments.length == 1) {
                    this._bytesReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of bytes sent on this data channel.
            */
            DataChannelReport.prototype.setBytesSent = function (value) {
                if (arguments.length == 1) {
                    this._bytesSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of messages received on this data channel.
            */
            DataChannelReport.prototype.setMessagesReceived = function (value) {
                if (arguments.length == 1) {
                    this._messagesReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of messages sent on this data channel.
            */
            DataChannelReport.prototype.setMessagesSent = function (value) {
                if (arguments.length == 1) {
                    this._messagesSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to Json.
            */
            DataChannelReport.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.DataChannelReport.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return DataChannelReport;
        }(fm.liveswitch.Report));
        liveswitch.DataChannelReport = DataChannelReport;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /** @hidden */
        var ErrorType = /** @class */ (function () {
            function ErrorType() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            ErrorType.prototype.getTypeString = function () {
                return '[fm.liveswitch.ErrorType]';
            };
            ErrorType.getAccessChannelClaimDenied = function () {
                if (arguments.length == 0) {
                    return "accessChannelClaimDenied";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getAccessMessageBlocked = function () {
                if (arguments.length == 0) {
                    return "accessMessageBlocked";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getClientInvalidId = function () {
                if (arguments.length == 0) {
                    return "clientInvalidId";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getMessageParseFailure = function () {
                if (arguments.length == 0) {
                    return "messageParseFailure";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getMessageRegisterExpected = function () {
                if (arguments.length == 0) {
                    return "messageRegisterExpected";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getMessageRegisterUnexpected = function () {
                if (arguments.length == 0) {
                    return "messageRegisterUnexpected";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getMessageUnregisterUnexpected = function () {
                if (arguments.length == 0) {
                    return "messageUnregisterUnexpected";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getSdpCodecMismatch = function () {
                if (arguments.length == 0) {
                    return "sdpCodecMismatch";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getSdpSimulcastMismatch = function () {
                if (arguments.length == 0) {
                    return "sdpSimulcastMismatch";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getSdpStreamMismatch = function () {
                if (arguments.length == 0) {
                    return "sdpStreamMismatch";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getServerLicenseInvalid = function () {
                if (arguments.length == 0) {
                    return "serverLicenseInvalid";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getServerLicenseMissing = function () {
                if (arguments.length == 0) {
                    return "serverLicenseMissing";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getServerNoAudioCodecs = function () {
                if (arguments.length == 0) {
                    return "serverNoAudioCodecs";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getServerNoMediaServersAvailable = function () {
                if (arguments.length == 0) {
                    return "serverNoMediaServersAvailable";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getServerNoVideoCodecs = function () {
                if (arguments.length == 0) {
                    return "serverNoVideoCodecs";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getServerUnknownError = function () {
                if (arguments.length == 0) {
                    return "serverUnknownError";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getServerUpgradeRequired = function () {
                if (arguments.length == 0) {
                    return "serverUpgradeRequired";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getSfuInvalidUpstream = function () {
                if (arguments.length == 0) {
                    return "sfuInvalidUpstream";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getTokenApplicationMismatch = function () {
                if (arguments.length == 0) {
                    return "tokenApplicationMismatch";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getTokenAuthFailure = function () {
                if (arguments.length == 0) {
                    return "tokenAuthFailure";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getTokenClientMismatch = function () {
                if (arguments.length == 0) {
                    return "tokenClientMismatch";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getTokenClientRoleMismatch = function () {
                if (arguments.length == 0) {
                    return "tokenClientRoleMismatch";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getTokenDeviceMismatch = function () {
                if (arguments.length == 0) {
                    return "tokenDeviceMismatch";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getTokenExpired = function () {
                if (arguments.length == 0) {
                    return "tokenExpired";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getTokenMissing = function () {
                if (arguments.length == 0) {
                    return "tokenMissing";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getTokenMissingChannelClaim = function () {
                if (arguments.length == 0) {
                    return "tokenMissingChannelClaim";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getTokenParseFailure = function () {
                if (arguments.length == 0) {
                    return "tokenParseFailure";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getTokenRegionMismatch = function () {
                if (arguments.length == 0) {
                    return "tokenRegionMismatch";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            ErrorType.getTokenUserMismatch = function () {
                if (arguments.length == 0) {
                    return "tokenUserMismatch";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ErrorType;
        }());
        liveswitch.ErrorType = ErrorType;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Event information.
        */
        var EventInfo = /** @class */ (function (_super) {
            __extends(EventInfo, _super);
            function EventInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchEventInfoInit();
                }
                else if (__arguments.length == 1) {
                    var type = __arguments[0];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchEventInfoInit();
                    if ((fm.liveswitch.Global.equals(type, null))) {
                        throw new fm.liveswitch.Exception("Type cannot be null.");
                    }
                    _this.setTimestamp(fm.liveswitch.UnixTimestamp.getUtcNowMillis());
                    _this.setOrigin(fm.liveswitch.EventOrigin.getClient());
                    _this.setType(type);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            EventInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.EventInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            EventInfo.prototype.fmliveswitchEventInfoInit = function () {
                this._forced = false;
                this._timestamp = 0;
            };
            /**
            Deserializes an instance from JSON.
            */
            EventInfo.fromJson = function (eventJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(eventJson, function () {
                        return new fm.liveswitch.EventInfo();
                    }, function (evt, key, valueJson) {
                        evt.deserializeProperties(key, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array from JSON.
            */
            EventInfo.fromJsonArray = function (eventJsons) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(eventJsons, fm.liveswitch.EventInfo.fromJson.bind(fm.liveswitch.EventInfo));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            */
            EventInfo.toJson = function (evt) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(evt, function (obj, jsonObject) {
                        obj.serializeProperties(jsonObject);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            */
            EventInfo.toJsonArray = function (events) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(events, fm.liveswitch.EventInfo.toJson.bind(fm.liveswitch.EventInfo));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            EventInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var _var0 = key;
                    if (_var0 == "id") {
                        do {
                            _super.prototype.setId.call(this, fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "timestamp") {
                        do {
                            this.setTimestamp(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "origin") {
                        do {
                            this.setOrigin(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "type") {
                        do {
                            this.setType(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "forced") {
                        do {
                            this.setForced(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "channel") {
                        do {
                            this.setChannel(fm.liveswitch.ChannelInfo.fromJson(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "client") {
                        do {
                            this.setClient(fm.liveswitch.ClientInfo.fromJson(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "connection") {
                        do {
                            this.setConnection(fm.liveswitch.ConnectionInfo.fromJson(valueJson));
                            break;
                        } while (false);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the channel information.
            */
            EventInfo.prototype.getChannel = function () {
                if (arguments.length == 0) {
                    return this._channel;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client information.
            */
            EventInfo.prototype.getClient = function () {
                if (arguments.length == 0) {
                    return this._client;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connection information.
            */
            EventInfo.prototype.getConnection = function () {
                if (arguments.length == 0) {
                    return this._connection;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether this event was forced.
            */
            EventInfo.prototype.getForced = function () {
                if (arguments.length == 0) {
                    return this._forced;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the event origin.
            */
            EventInfo.prototype.getOrigin = function () {
                if (arguments.length == 0) {
                    return this._origin;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the event timestamp in milliseconds since epoch.
            */
            EventInfo.prototype.getTimestamp = function () {
                if (arguments.length == 0) {
                    return this._timestamp;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the event type.
            */
            EventInfo.prototype.getType = function () {
                if (arguments.length == 0) {
                    return this._type;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            EventInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(_super.prototype.getId.call(this), null))) {
                        jsonObject["id"] = fm.liveswitch.JsonSerializer.serializeString(_super.prototype.getId.call(this));
                    }
                    if ((!fm.liveswitch.Global.equals(this.getTimestamp(), 0))) {
                        jsonObject["timestamp"] = fm.liveswitch.JsonSerializer.serializeLong(this.getTimestamp());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getOrigin(), null))) {
                        jsonObject["origin"] = fm.liveswitch.JsonSerializer.serializeString(this.getOrigin());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getType(), null))) {
                        jsonObject["type"] = fm.liveswitch.JsonSerializer.serializeString(this.getType());
                    }
                    if (this.getForced()) {
                        jsonObject["forced"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getForced());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getChannel(), null))) {
                        jsonObject["channel"] = fm.liveswitch.ChannelInfo.toJson(this.getChannel());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getClient(), null))) {
                        jsonObject["client"] = fm.liveswitch.ClientInfo.toJson(this.getClient());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getConnection(), null))) {
                        jsonObject["connection"] = fm.liveswitch.ConnectionInfo.toJson(this.getConnection());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the channel information.
            */
            EventInfo.prototype.setChannel = function (value) {
                if (arguments.length == 1) {
                    this._channel = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the client information.
            */
            EventInfo.prototype.setClient = function (value) {
                if (arguments.length == 1) {
                    this._client = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the connection information.
            */
            EventInfo.prototype.setConnection = function (value) {
                if (arguments.length == 1) {
                    this._connection = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether this event was forced.
            */
            EventInfo.prototype.setForced = function (value) {
                if (arguments.length == 1) {
                    this._forced = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the event origin.
            */
            EventInfo.prototype.setOrigin = function (value) {
                if (arguments.length == 1) {
                    this._origin = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the event timestamp in milliseconds since epoch.
            */
            EventInfo.prototype.setTimestamp = function (value) {
                if (arguments.length == 1) {
                    this._timestamp = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the event type.
            */
            EventInfo.prototype.setType = function (value) {
                if (arguments.length == 1) {
                    this._type = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            EventInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.EventInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return EventInfo;
        }(fm.liveswitch.Info));
        liveswitch.EventInfo = EventInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Event origins.
        */
        var EventOrigin = /** @class */ (function () {
            function EventOrigin() {
            }
            EventOrigin.prototype.getTypeString = function () {
                return '[fm.liveswitch.EventOrigin]';
            };
            /**
            Gets the 'client' event origin string.
            */
            EventOrigin.getClient = function () {
                if (arguments.length == 0) {
                    return "client";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the 'gateway' event origin string.
            */
            EventOrigin.getGateway = function () {
                if (arguments.length == 0) {
                    return "gateway";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the 'mediaserver' event origin string.
            */
            EventOrigin.getMediaServer = function () {
                if (arguments.length == 0) {
                    return "mediaserver";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the 'sipconnector' event origin string.
            */
            EventOrigin.getSipConnector = function () {
                if (arguments.length == 0) {
                    return "sipconnector";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return EventOrigin;
        }());
        liveswitch.EventOrigin = EventOrigin;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Network information.
        */
        var NetworkInfo = /** @class */ (function () {
            function NetworkInfo() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            NetworkInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.NetworkInfo]';
            };
            /**
            Deserializes Json to a GatewayInfo.
            @param networkInfoJson The serialized Json.
            @return The deserialized GatewayInfo.
            */
            NetworkInfo.fromJson = function (networkInfoJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(networkInfoJson, function () {
                        return new fm.liveswitch.NetworkInfo();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to Json.
            @param networkInfo The instance to serialize.
            @return Serialized Json.
            */
            NetworkInfo.toJson = function (networkInfo) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(networkInfo, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            NetworkInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "iPAddresses"))) {
                            if ((fm.liveswitch.Global.equals(str, "ports"))) {
                                this.setPorts(fm.liveswitch.JsonSerializer.deserializeIntegerArray(valueJson));
                            }
                        }
                        else {
                            this.setIPAddresses(fm.liveswitch.JsonSerializer.deserializeStringArray(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the IP addresses.
            */
            NetworkInfo.prototype.getIPAddresses = function () {
                if (arguments.length == 0) {
                    return this._ipAddresses;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the ports.
            */
            NetworkInfo.prototype.getPorts = function () {
                if (arguments.length == 0) {
                    return this._ports;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            NetworkInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(this.getIPAddresses(), null))) {
                        jsonObject["iPAddresses"] = fm.liveswitch.JsonSerializer.serializeStringArray(this.getIPAddresses());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getPorts(), null))) {
                        jsonObject["ports"] = fm.liveswitch.JsonSerializer.serializeIntegerArray(this.getPorts());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the IP addresses.
            */
            NetworkInfo.prototype.setIPAddresses = function (value) {
                if (arguments.length == 1) {
                    this._ipAddresses = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the ports.
            */
            NetworkInfo.prototype.setPorts = function (value) {
                if (arguments.length == 1) {
                    this._ports = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to Json.
            */
            NetworkInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.NetworkInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return NetworkInfo;
        }());
        liveswitch.NetworkInfo = NetworkInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="NetworkInfo.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        External network information.
        */
        var ExternalNetworkInfo = /** @class */ (function (_super) {
            __extends(ExternalNetworkInfo, _super);
            function ExternalNetworkInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            ExternalNetworkInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.ExternalNetworkInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Deserializes Json to a ExternalNetworkInfo.
            @param networkInfoJson The serialized Json.
            @return The deserialized ExternalNetworkInfo.
            */
            ExternalNetworkInfo.fromJson = function (networkInfoJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(networkInfoJson, function () {
                        return new fm.liveswitch.ExternalNetworkInfo();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to Json.
            @param networkInfo The instance to serialize.
            @return Serialized Json.
            */
            ExternalNetworkInfo.toJson = function (networkInfo) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(networkInfo, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            ExternalNetworkInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "publicIPAddress"))) {
                            if ((fm.liveswitch.Global.equals(str, "publicHostname"))) {
                                this.setPublicHostname(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            }
                        }
                        else {
                            this.setPublicIPAddress(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the public hostname.
            */
            ExternalNetworkInfo.prototype.getPublicHostname = function () {
                if (arguments.length == 0) {
                    return this._publicHostname;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the public IP address.
            */
            ExternalNetworkInfo.prototype.getPublicIPAddress = function () {
                if (arguments.length == 0) {
                    return this._publicIPAddress;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            ExternalNetworkInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getPublicIPAddress(), null))) {
                        jsonObject["publicIPAddress"] = fm.liveswitch.JsonSerializer.serializeString(this.getPublicIPAddress());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getPublicHostname(), null))) {
                        jsonObject["publicHostname"] = fm.liveswitch.JsonSerializer.serializeString(this.getPublicHostname());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the public hostname.
            */
            ExternalNetworkInfo.prototype.setPublicHostname = function (value) {
                if (arguments.length == 1) {
                    this._publicHostname = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the public IP address.
            */
            ExternalNetworkInfo.prototype.setPublicIPAddress = function (value) {
                if (arguments.length == 1) {
                    this._publicIPAddress = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return ExternalNetworkInfo;
        }(fm.liveswitch.NetworkInfo));
        liveswitch.ExternalNetworkInfo = ExternalNetworkInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="NetworkInfo.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Internal network information.
        */
        var InternalNetworkInfo = /** @class */ (function (_super) {
            __extends(InternalNetworkInfo, _super);
            function InternalNetworkInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            InternalNetworkInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.InternalNetworkInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Deserializes Json to a InternalNetworkInfo.
            @param networkInfoJson The serialized Json.
            @return The deserialized InternalNetworkInfo.
            */
            InternalNetworkInfo.fromJson = function (networkInfoJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(networkInfoJson, function () {
                        return new fm.liveswitch.InternalNetworkInfo();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to Json.
            @param networkInfo The instance to serialize.
            @return Serialized Json.
            */
            InternalNetworkInfo.toJson = function (networkInfo) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(networkInfo, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            InternalNetworkInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            InternalNetworkInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return InternalNetworkInfo;
        }(fm.liveswitch.NetworkInfo));
        liveswitch.InternalNetworkInfo = InternalNetworkInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var InvitationStateWrapper = /** @class */ (function () {
            function InvitationStateWrapper(value) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 1) {
                    var value_66 = __arguments[0];
                    //super();
                    this._value = value_66;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            InvitationStateWrapper.prototype.getTypeString = function () {
                return '[fm.liveswitch.InvitationStateWrapper]';
            };
            InvitationStateWrapper.prototype.toString = function () {
                if (arguments.length == 0) {
                    if (this._value == fm.liveswitch.InvitationState.Unknown)
                        return 'Unknown';
                    if (this._value == fm.liveswitch.InvitationState.Pending)
                        return 'Pending';
                    if (this._value == fm.liveswitch.InvitationState.Proceeding)
                        return 'Proceeding';
                    if (this._value == fm.liveswitch.InvitationState.Sent)
                        return 'Sent';
                    if (this._value == fm.liveswitch.InvitationState.Cancelled)
                        return 'Cancelled';
                    if (this._value == fm.liveswitch.InvitationState.Cancelling)
                        return 'Cancelling';
                    if (this._value == fm.liveswitch.InvitationState.Rejected)
                        return 'Rejected';
                    if (this._value == fm.liveswitch.InvitationState.Accepted)
                        return 'Accepted';
                    if (this._value == fm.liveswitch.InvitationState.NotFound)
                        return 'NotFound';
                    if (this._value == fm.liveswitch.InvitationState.Busy)
                        return 'Busy';
                    if (this._value == fm.liveswitch.InvitationState.NoResponse)
                        return 'NoResponse';
                    if (this._value == fm.liveswitch.InvitationState.Invalid)
                        return 'Invalid';
                    if (this._value == fm.liveswitch.InvitationState.AlreadyInvited)
                        return 'AlreadyInvited';
                    return '';
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return InvitationStateWrapper;
        }());
        liveswitch.InvitationStateWrapper = InvitationStateWrapper;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A class containing the feedback from invite requests.
        */
        var InviteFeedback = /** @class */ (function () {
            function InviteFeedback() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else if (__arguments.length == 4) {
                    var userId = __arguments[0];
                    var protocol = __arguments[1];
                    var state = __arguments[2];
                    var reason = __arguments[3];
                    //super();
                    this.setUserId(userId);
                    this.setProtocol(protocol);
                    this.setState(state);
                    this.setReason(reason);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            InviteFeedback.prototype.getTypeString = function () {
                return '[fm.liveswitch.InviteFeedback]';
            };
            /** @hidden */
            InviteFeedback.deserializeState = function (state) {
                if (arguments.length == 1) {
                    var _var0 = state;
                    if (_var0 == "pending") {
                        do {
                            return fm.liveswitch.InvitationState.Pending;
                        } while (false);
                    }
                    else if (_var0 == "proceeding") {
                        do {
                            return fm.liveswitch.InvitationState.Proceeding;
                        } while (false);
                    }
                    else if (_var0 == "sent") {
                        do {
                            return fm.liveswitch.InvitationState.Sent;
                        } while (false);
                    }
                    else if (_var0 == "cancelled") {
                        do {
                            return fm.liveswitch.InvitationState.Cancelled;
                        } while (false);
                    }
                    else if (_var0 == "cancelling") {
                        do {
                            return fm.liveswitch.InvitationState.Cancelling;
                        } while (false);
                    }
                    else if (_var0 == "rejected") {
                        do {
                            return fm.liveswitch.InvitationState.Rejected;
                        } while (false);
                    }
                    else if (_var0 == "accepted") {
                        do {
                            return fm.liveswitch.InvitationState.Accepted;
                        } while (false);
                    }
                    else if (_var0 == "notFound") {
                        do {
                            return fm.liveswitch.InvitationState.NotFound;
                        } while (false);
                    }
                    else if (_var0 == "busy") {
                        do {
                            return fm.liveswitch.InvitationState.Busy;
                        } while (false);
                    }
                    else if (_var0 == "noResponse") {
                        do {
                            return fm.liveswitch.InvitationState.NoResponse;
                        } while (false);
                    }
                    else if (_var0 == "invalid") {
                        do {
                            return fm.liveswitch.InvitationState.Invalid;
                        } while (false);
                    }
                    else if (_var0 == "alreadyInvited") {
                        do {
                            return fm.liveswitch.InvitationState.AlreadyInvited;
                        } while (false);
                    }
                    return fm.liveswitch.InvitationState.Unknown;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an instance from JSON.
            @param feedbackJson The JSON to deserialize.
            @return
                        The deserialized invite feedback.
                
            */
            InviteFeedback.fromJson = function (feedbackJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(feedbackJson, function () {
                        return new fm.liveswitch.InviteFeedback();
                    }, function (feedback, key, value) {
                        var str = key;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            if (!(fm.liveswitch.Global.equals(str, "protocol"))) {
                                if ((fm.liveswitch.Global.equals(str, "userId"))) {
                                    feedback.setUserId(fm.liveswitch.JsonSerializer.deserializeString(value));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "state"))) {
                                        feedback.setState(fm.liveswitch.InviteFeedback.deserializeState(fm.liveswitch.JsonSerializer.deserializeString(value)));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "reason"))) {
                                            feedback.setReason(fm.liveswitch.JsonSerializer.deserializeString(value));
                                        }
                                    }
                                }
                            }
                            else {
                                feedback.setProtocol(fm.liveswitch.JsonSerializer.deserializeString(value));
                            }
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            InviteFeedback.serializeState = function (state) {
                if (arguments.length == 1) {
                    var _var0 = state;
                    if (_var0 == fm.liveswitch.InvitationState.Pending) {
                        do {
                            return "pending";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.InvitationState.Proceeding) {
                        do {
                            return "proceeding";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.InvitationState.Sent) {
                        do {
                            return "sent";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.InvitationState.Cancelled) {
                        do {
                            return "cancelled";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.InvitationState.Cancelling) {
                        do {
                            return "cancelling";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.InvitationState.Rejected) {
                        do {
                            return "rejected";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.InvitationState.Accepted) {
                        do {
                            return "accepted";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.InvitationState.NotFound) {
                        do {
                            return "notFound";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.InvitationState.Busy) {
                        do {
                            return "busy";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.InvitationState.NoResponse) {
                        do {
                            return "noResponse";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.InvitationState.Invalid) {
                        do {
                            return "invalid";
                        } while (false);
                    }
                    else if (_var0 == fm.liveswitch.InvitationState.AlreadyInvited) {
                        do {
                            return "alreadyInvited";
                        } while (false);
                    }
                    return "unknown";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param feedback The invite feedback to serialize.
            @return
                        The serialized JSON.
                
            */
            InviteFeedback.toJson = function (feedback) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(feedback, function (config, dict) {
                        if ((!fm.liveswitch.Global.equals(config.getProtocol(), null))) {
                            dict["protocol"] = fm.liveswitch.JsonSerializer.serializeString(config.getProtocol());
                        }
                        if ((!fm.liveswitch.Global.equals(config.getUserId(), null))) {
                            dict["userId"] = fm.liveswitch.JsonSerializer.serializeString(config.getUserId());
                        }
                        if ((!fm.liveswitch.Global.equals(config.getReason(), null))) {
                            dict["reason"] = fm.liveswitch.JsonSerializer.serializeString(config.getReason());
                        }
                        dict["state"] = fm.liveswitch.JsonSerializer.serializeString(fm.liveswitch.InviteFeedback.serializeState(config.getState()));
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the protocol the user was invited on.
            */
            InviteFeedback.prototype.getProtocol = function () {
                if (arguments.length == 0) {
                    return this._protocol;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the detailed reason for the state if available.
            */
            InviteFeedback.prototype.getReason = function () {
                if (arguments.length == 0) {
                    return this._reason;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the current state of the invite.
            */
            InviteFeedback.prototype.getState = function () {
                if (arguments.length == 0) {
                    return this._state;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the user id for the user being invited.
            */
            InviteFeedback.prototype.getUserId = function () {
                if (arguments.length == 0) {
                    return this._userId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            InviteFeedback.prototype.setProtocol = function (value) {
                if (arguments.length == 1) {
                    this._protocol = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            InviteFeedback.prototype.setReason = function (value) {
                if (arguments.length == 1) {
                    this._reason = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            InviteFeedback.prototype.setState = function (value) {
                if (arguments.length == 1) {
                    this._state = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            InviteFeedback.prototype.setUserId = function (value) {
                if (arguments.length == 1) {
                    this._userId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            InviteFeedback.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.InviteFeedback.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return InviteFeedback;
        }());
        liveswitch.InviteFeedback = InviteFeedback;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Log event information.
        */
        var LogEventInfo = /** @class */ (function (_super) {
            __extends(LogEventInfo, _super);
            function LogEventInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchLogEventInfoInit();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            LogEventInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.LogEventInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            LogEventInfo.prototype.fmliveswitchLogEventInfoInit = function () {
                this._threadId = 0;
            };
            /**
            Deserializes Json to a LogEventInfo.
            @param logEventInfoJson The serialized Json.
            @return The deserialized LogEventInfo.
            */
            LogEventInfo.fromJson = function (logEventInfoJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(logEventInfoJson, function () {
                        return new fm.liveswitch.LogEventInfo();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to Json.
            @param logEventInfo The instance to serialize.
            @return Serialized Json.
            */
            LogEventInfo.toJson = function (logEventInfo) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(logEventInfo, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            LogEventInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "level"))) {
                            if ((fm.liveswitch.Global.equals(str, "tag"))) {
                                this.setTag(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "scope"))) {
                                    this.setScope(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "message"))) {
                                        this.setMessage(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "exception"))) {
                                            this.setException(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                        }
                                        else {
                                            if ((fm.liveswitch.Global.equals(str, "threadId"))) {
                                                this.setThreadId(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            this.setLevel(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the log event exception message.
            */
            LogEventInfo.prototype.getException = function () {
                if (arguments.length == 0) {
                    return this._exception;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the log event level.
            */
            LogEventInfo.prototype.getLevel = function () {
                if (arguments.length == 0) {
                    return this._level;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the log event message.
            */
            LogEventInfo.prototype.getMessage = function () {
                if (arguments.length == 0) {
                    return this._message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the log event scope.
            */
            LogEventInfo.prototype.getScope = function () {
                if (arguments.length == 0) {
                    return this._scope;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the log event tag.
            */
            LogEventInfo.prototype.getTag = function () {
                if (arguments.length == 0) {
                    return this._tag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the log event thread ID.
            */
            LogEventInfo.prototype.getThreadId = function () {
                if (arguments.length == 0) {
                    return this._threadId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            LogEventInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getLevel(), null))) {
                        jsonObject["level"] = fm.liveswitch.JsonSerializer.serializeString(this.getLevel());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getTag(), null))) {
                        jsonObject["tag"] = fm.liveswitch.JsonSerializer.serializeString(this.getTag());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getScope(), null))) {
                        jsonObject["scope"] = fm.liveswitch.JsonSerializer.serializeString(this.getScope());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getMessage(), null))) {
                        jsonObject["message"] = fm.liveswitch.JsonSerializer.serializeString(this.getMessage());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getException(), null))) {
                        jsonObject["exception"] = fm.liveswitch.JsonSerializer.serializeString(this.getException());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getThreadId(), 0))) {
                        jsonObject["threadId"] = fm.liveswitch.JsonSerializer.serializeLong(this.getThreadId());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the log event exception message.
            */
            LogEventInfo.prototype.setException = function (value) {
                if (arguments.length == 1) {
                    this._exception = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            LogEventInfo.prototype.setLevel = function (value) {
                if (arguments.length == 1) {
                    this._level = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the log event message.
            */
            LogEventInfo.prototype.setMessage = function (value) {
                if (arguments.length == 1) {
                    this._message = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the log event scope.
            */
            LogEventInfo.prototype.setScope = function (value) {
                if (arguments.length == 1) {
                    this._scope = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the log event tag.
            */
            LogEventInfo.prototype.setTag = function (value) {
                if (arguments.length == 1) {
                    this._tag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the log event thread ID.
            */
            LogEventInfo.prototype.setThreadId = function (value) {
                if (arguments.length == 1) {
                    this._threadId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to Json.
            */
            LogEventInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.LogEventInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return LogEventInfo;
        }(fm.liveswitch.Info));
        liveswitch.LogEventInfo = LogEventInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media information.
        */
        var MediaInfo = /** @class */ (function (_super) {
            __extends(MediaInfo, _super);
            function MediaInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            MediaInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            MediaInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaInfo;
        }(fm.liveswitch.Info));
        liveswitch.MediaInfo = MediaInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="MediaComponentReport.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media receiver report.
        */
        var MediaReceiverReport = /** @class */ (function (_super) {
            __extends(MediaReceiverReport, _super);
            function MediaReceiverReport() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaReceiverReportInit();
                }
                else if (__arguments.length == 2) {
                    var stats = __arguments[0];
                    var lastStats = __arguments[1];
                    _this = _super.call(this, stats, lastStats) || this;
                    _this.fmliveswitchMediaReceiverReportInit();
                    var flag = (fm.liveswitch.Global.equals(lastStats, null));
                    _this.setBytesReceived(fm.liveswitch.Report.processLong(stats.getBytesReceived(), (flag ? 0 : lastStats.getBytesReceived())));
                    _this.setPacketsReceived(fm.liveswitch.Report.processLong(stats.getPacketsReceived(), (flag ? 0 : lastStats.getPacketsReceived())));
                    _this.setPacketsDiscarded(fm.liveswitch.Report.processLong(stats.getPacketsDiscarded(), (flag ? 0 : lastStats.getPacketsDiscarded())));
                    _this.setPacketsDuplicated(fm.liveswitch.Report.processLong(stats.getPacketsDuplicated(), (flag ? 0 : lastStats.getPacketsDuplicated())));
                    _this.setPacketsRepaired(fm.liveswitch.Report.processLong(stats.getPacketsRepaired(), (flag ? 0 : lastStats.getPacketsRepaired())));
                    _this.setPacketsLost(fm.liveswitch.Report.processLong(stats.getPacketsLost(), (flag ? 0 : lastStats.getPacketsLost())));
                    _this.setJitter(fm.liveswitch.Report.processLong(stats.getJitter(), (flag ? 0 : lastStats.getJitter())));
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaReceiverReport.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaReceiverReport]' + ',' + _super.prototype.getTypeString.call(this);
            };
            MediaReceiverReport.prototype.fmliveswitchMediaReceiverReportInit = function () {
                this._bytesReceived = 0;
                this._jitter = 0;
                this._packetsDiscarded = 0;
                this._packetsDuplicated = 0;
                this._packetsLost = 0;
                this._packetsReceived = 0;
                this._packetsRepaired = 0;
            };
            /**
            Deserializes an instance from JSON.
            @param mediaReceiverReportJson The serialized JSON.
            @return The deserialized instance.
            */
            MediaReceiverReport.fromJson = function (mediaReceiverReportJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(mediaReceiverReportJson, function () {
                        return new fm.liveswitch.MediaReceiverReport();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array from JSON.
            @param mediaReceiverReportsJson The serialized JSON.
            @return The deserialized array.
            */
            MediaReceiverReport.fromJsonArray = function (mediaReceiverReportsJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(mediaReceiverReportsJson, fm.liveswitch.MediaReceiverReport.fromJson.bind(fm.liveswitch.MediaReceiverReport));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param mediaReceiverReport The instance to serialize.
            @return The serialized JSON.
            */
            MediaReceiverReport.toJson = function (mediaReceiverReport) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(mediaReceiverReport, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param mediaReceiverReports The array to serialize.
            @return The serialized JSON.
            */
            MediaReceiverReport.toJsonArray = function (mediaReceiverReports) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(mediaReceiverReports, fm.liveswitch.MediaReceiverReport.toJson.bind(fm.liveswitch.MediaReceiverReport));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            MediaReceiverReport.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var _var0 = key;
                    if (_var0 == "bytesReceived") {
                        do {
                            this.setBytesReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "packetsReceived") {
                        do {
                            this.setPacketsReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "packetsDiscarded") {
                        do {
                            this.setPacketsDiscarded(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "packetsDuplicated") {
                        do {
                            this.setPacketsDuplicated(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "packetsRepaired") {
                        do {
                            this.setPacketsRepaired(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "packetsLost") {
                        do {
                            this.setPacketsLost(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "jitter") {
                        do {
                            this.setJitter(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes received.
            */
            MediaReceiverReport.prototype.getBytesReceived = function () {
                if (arguments.length == 0) {
                    return this._bytesReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the jitter in milliseconds.
            */
            MediaReceiverReport.prototype.getJitter = function () {
                if (arguments.length == 0) {
                    return this._jitter;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of packets discarded.
            */
            MediaReceiverReport.prototype.getPacketsDiscarded = function () {
                if (arguments.length == 0) {
                    return this._packetsDiscarded;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of packets duplicated.
            */
            MediaReceiverReport.prototype.getPacketsDuplicated = function () {
                if (arguments.length == 0) {
                    return this._packetsDuplicated;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of packets lost.
            */
            MediaReceiverReport.prototype.getPacketsLost = function () {
                if (arguments.length == 0) {
                    return this._packetsLost;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of packets received.
            */
            MediaReceiverReport.prototype.getPacketsReceived = function () {
                if (arguments.length == 0) {
                    return this._packetsReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of packets repaired.
            */
            MediaReceiverReport.prototype.getPacketsRepaired = function () {
                if (arguments.length == 0) {
                    return this._packetsRepaired;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            MediaReceiverReport.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((this.getBytesReceived() != null)) {
                        jsonObject["bytesReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getBytesReceived());
                    }
                    if ((this.getPacketsReceived() != null)) {
                        jsonObject["packetsReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getPacketsReceived());
                    }
                    if ((this.getPacketsDiscarded() != null)) {
                        jsonObject["packetsDiscarded"] = fm.liveswitch.JsonSerializer.serializeLong(this.getPacketsDiscarded());
                    }
                    if ((this.getPacketsDuplicated() != null)) {
                        jsonObject["packetsDuplicated"] = fm.liveswitch.JsonSerializer.serializeLong(this.getPacketsDuplicated());
                    }
                    if ((this.getPacketsRepaired() != null)) {
                        jsonObject["packetsRepaired"] = fm.liveswitch.JsonSerializer.serializeLong(this.getPacketsRepaired());
                    }
                    if ((this.getPacketsLost() != null)) {
                        jsonObject["packetsLost"] = fm.liveswitch.JsonSerializer.serializeLong(this.getPacketsLost());
                    }
                    if ((this.getJitter() != null)) {
                        jsonObject["jitter"] = fm.liveswitch.JsonSerializer.serializeLong(this.getJitter());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of bytes received.
            */
            MediaReceiverReport.prototype.setBytesReceived = function (value) {
                if (arguments.length == 1) {
                    this._bytesReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the jitter in milliseconds.
            */
            MediaReceiverReport.prototype.setJitter = function (value) {
                if (arguments.length == 1) {
                    this._jitter = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of packets discarded.
            */
            MediaReceiverReport.prototype.setPacketsDiscarded = function (value) {
                if (arguments.length == 1) {
                    this._packetsDiscarded = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of packets duplicated.
            */
            MediaReceiverReport.prototype.setPacketsDuplicated = function (value) {
                if (arguments.length == 1) {
                    this._packetsDuplicated = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of packets lost.
            */
            MediaReceiverReport.prototype.setPacketsLost = function (value) {
                if (arguments.length == 1) {
                    this._packetsLost = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of packets received.
            */
            MediaReceiverReport.prototype.setPacketsReceived = function (value) {
                if (arguments.length == 1) {
                    this._packetsReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of packets repaired.
            */
            MediaReceiverReport.prototype.setPacketsRepaired = function (value) {
                if (arguments.length == 1) {
                    this._packetsRepaired = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            MediaReceiverReport.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.MediaReceiverReport.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaReceiverReport;
        }(fm.liveswitch.MediaComponentReport));
        liveswitch.MediaReceiverReport = MediaReceiverReport;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="MediaComponentReport.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Media sender report.
        */
        var MediaSenderReport = /** @class */ (function (_super) {
            __extends(MediaSenderReport, _super);
            function MediaSenderReport() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMediaSenderReportInit();
                }
                else if (__arguments.length == 2) {
                    var stats = __arguments[0];
                    var lastStats = __arguments[1];
                    _this = _super.call(this, stats, lastStats) || this;
                    _this.fmliveswitchMediaSenderReportInit();
                    var flag = (fm.liveswitch.Global.equals(lastStats, null));
                    _this.setBytesSent(fm.liveswitch.Report.processLong(stats.getBytesSent(), (flag ? 0 : lastStats.getBytesSent())));
                    _this.setPacketsSent(fm.liveswitch.Report.processLong(stats.getPacketsSent(), (flag ? 0 : lastStats.getPacketsSent())));
                    _this.setRoundTripTime(fm.liveswitch.Report.processInteger(stats.getRoundTripTime(), (flag ? 0 : lastStats.getRoundTripTime())));
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MediaSenderReport.prototype.getTypeString = function () {
                return '[fm.liveswitch.MediaSenderReport]' + ',' + _super.prototype.getTypeString.call(this);
            };
            MediaSenderReport.prototype.fmliveswitchMediaSenderReportInit = function () {
                this._bytesSent = 0;
                this._packetsSent = 0;
                this._roundTripTime = 0;
            };
            /**
            Deserializes an instance from JSON.
            @param mediaSenderReportJson The serialized JSON.
            @return The deserialized instance.
            */
            MediaSenderReport.fromJson = function (mediaSenderReportJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(mediaSenderReportJson, function () {
                        return new fm.liveswitch.MediaSenderReport();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array from JSON.
            @param mediaSenderReportsJson The serialized JSON.
            @return The deserialized array.
            */
            MediaSenderReport.fromJsonArray = function (mediaSenderReportsJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(mediaSenderReportsJson, fm.liveswitch.MediaSenderReport.fromJson.bind(fm.liveswitch.MediaSenderReport));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param mediaSenderReport The instance to serialize.
            @return The serialized JSON.
            */
            MediaSenderReport.toJson = function (mediaSenderReport) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(mediaSenderReport, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param mediaSenderReports The array to serialize.
            @return The serialized JSON.
            */
            MediaSenderReport.toJsonArray = function (mediaSenderReports) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(mediaSenderReports, fm.liveswitch.MediaSenderReport.toJson.bind(fm.liveswitch.MediaSenderReport));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            MediaSenderReport.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "bytesSent"))) {
                            if ((fm.liveswitch.Global.equals(str, "packetsSent"))) {
                                this.setPacketsSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "roundTripTime"))) {
                                    this.setRoundTripTime(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                }
                            }
                        }
                        else {
                            this.setBytesSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes sent.
            */
            MediaSenderReport.prototype.getBytesSent = function () {
                if (arguments.length == 0) {
                    return this._bytesSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of packets sent.
            */
            MediaSenderReport.prototype.getPacketsSent = function () {
                if (arguments.length == 0) {
                    return this._packetsSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the round-trip-time in milliseconds.
            */
            MediaSenderReport.prototype.getRoundTripTime = function () {
                if (arguments.length == 0) {
                    return this._roundTripTime;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            MediaSenderReport.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((this.getBytesSent() != null)) {
                        jsonObject["bytesSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getBytesSent());
                    }
                    if ((this.getPacketsSent() != null)) {
                        jsonObject["packetsSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getPacketsSent());
                    }
                    if ((this.getRoundTripTime() != null)) {
                        jsonObject["roundTripTime"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getRoundTripTime());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of bytes sent.
            */
            MediaSenderReport.prototype.setBytesSent = function (value) {
                if (arguments.length == 1) {
                    this._bytesSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of packets sent.
            */
            MediaSenderReport.prototype.setPacketsSent = function (value) {
                if (arguments.length == 1) {
                    this._packetsSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the round-trip-time in milliseconds.
            */
            MediaSenderReport.prototype.setRoundTripTime = function (value) {
                if (arguments.length == 1) {
                    this._roundTripTime = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            MediaSenderReport.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.MediaSenderReport.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MediaSenderReport;
        }(fm.liveswitch.MediaComponentReport));
        liveswitch.MediaSenderReport = MediaSenderReport;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A message.
        */
        var Message = /** @class */ (function (_super) {
            __extends(Message, _super);
            function Message() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMessageInit();
                }
                else if (__arguments.length == 1) {
                    var type = __arguments[0];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMessageInit();
                    _this.setType(type);
                    _this.setApiVersion(fm.liveswitch.Build.getVersion());
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            Message.prototype.getTypeString = function () {
                return '[fm.liveswitch.Message]' + ',' + _super.prototype.getTypeString.call(this);
            };
            Message.prototype.fmliveswitchMessageInit = function () {
                this._timestamp = 0;
            };
            Message.createBitrateNotificationMessage = function () {
                if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.BitrateNotification]'))) {
                    var bitrateNotification = arguments[0];
                    return fm.liveswitch.Message.createBitrateNotificationMessage([bitrateNotification]);
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isObjectType(arguments[0][0], '[fm.liveswitch.BitrateNotification]')))))) {
                    var bitrateNotifications = arguments[0];
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getBitrateNotification());
                    message.setPayload(fm.liveswitch.BitrateNotification.toJsonArray(bitrateNotifications));
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Message.createBitrateRequestMessage = function () {
                if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.BitrateRequest]'))) {
                    var bitrateRequest = arguments[0];
                    return fm.liveswitch.Message.createBitrateRequestMessage([bitrateRequest]);
                }
                else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isObjectType(arguments[0][0], '[fm.liveswitch.BitrateRequest]')))))) {
                    var bitrateRequests = arguments[0];
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getBitrateRequest());
                    message.setPayload(fm.liveswitch.BitrateRequest.toJsonArray(bitrateRequests));
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a "cancelInvite" message.
            */
            Message.createCancelInviteMessage = function (userId, protocol) {
                if (arguments.length == 2) {
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getCancelInvite());
                    message.setRemoteUserId(userId);
                    message.setPayload(protocol);
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a "candidate" message.
            @param candidateJson The candidate.
            */
            Message.createCandidateMessage = function (candidateJson) {
                if (arguments.length == 1) {
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getCandidate());
                    message.setPayload(candidateJson);
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a "close" message.
            */
            Message.createCloseMessage = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.Message(fm.liveswitch.MessageType.getClose());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a "dtmfTones" message.
            */
            Message.createDtmfTonesMessage = function (dtmfTones) {
                if (arguments.length == 1) {
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getDtmfTones());
                    message.setPayload(fm.liveswitch.dtmf.Tone.toJsonArray(dtmfTones));
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Message.createErrorMessage = function () {
                if (arguments.length == 1) {
                    var error = arguments[0];
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getError());
                    message.setPayload(fm.liveswitch.JsonSerializer.serializeString(error));
                    return message;
                }
                else if (arguments.length == 4) {
                    var error = arguments[0];
                    var remoteUserId = arguments[1];
                    var remoteDeviceId = arguments[2];
                    var remoteClientId = arguments[3];
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getError());
                    message.setPayload(fm.liveswitch.JsonSerializer.serializeString(error));
                    message.setRemoteUserId(remoteUserId);
                    message.setRemoteDeviceId(remoteDeviceId);
                    message.setRemoteClientId(remoteClientId);
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates an "event" message.
            */
            Message.createEventMessage = function (eventInfoJson) {
                if (arguments.length == 1) {
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getEvent());
                    message.setPayload(eventInfoJson);
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates an "iceServers" message.
            */
            Message.createIceServersMessage = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.Message(fm.liveswitch.MessageType.getIceServers());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a "invite" message.
            */
            Message.createInviteMessage = function (userId, protocol) {
                if (arguments.length == 2) {
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getInvite());
                    message.setRemoteUserId(userId);
                    message.setPayload(protocol);
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a "join" message.
            @param channelId The channel to join.
            @param token The auth token.
            */
            Message.createJoinMessage = function (channelId, token) {
                if (arguments.length == 2) {
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getJoin());
                    message.setChannelId(channelId);
                    message.setToken(token);
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a "keyFrameRequest" message.
            */
            Message.createKeyFrameRequestMessage = function (synchronizationSources) {
                if (arguments.length == 1) {
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getKeyFrameRequest());
                    message.setPayload(fm.liveswitch.JsonSerializer.serializeLongArray(synchronizationSources));
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a "kick" message.
            @param channelId The channel identifier.
            @param clientId The ID of the client to kick.
            */
            Message.createKickMessage = function (channelId, clientId) {
                if (arguments.length == 2) {
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getKick());
                    message.setChannelId(channelId);
                    message.setRemoteClientId(clientId);
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a "leave" message.
            @param channelId The channel to leave.
            @param channelReport The channel report.
            */
            Message.createLeaveMessage = function (channelId, channelReport) {
                if (arguments.length == 2) {
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getLeave());
                    message.setChannelId(channelId);
                    message.setChannelReports(((fm.liveswitch.Global.equals(channelReport, null)) ? null : [channelReport]));
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates an MCU "offer" message.
            @param tag The tag.
            @param offerJson The offer.
            */
            Message.createMcuOfferMessage = function (tag, offerJson) {
                if (arguments.length == 2) {
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getOffer());
                    message.setConnectionType(fm.liveswitch.ConnectionType.getMcu());
                    message.setConnectionTag(tag);
                    message.setPayload(offerJson);
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Message.createMessageMessage = function () {
                if (arguments.length == 1) {
                    var message = arguments[0];
                    return fm.liveswitch.Message.createMessageMessage(message, null);
                }
                else if (arguments.length == 2) {
                    var message = arguments[0];
                    var remoteUserId = arguments[1];
                    return fm.liveswitch.Message.createMessageMessage(message, remoteUserId, null);
                }
                else if (arguments.length == 3) {
                    var message = arguments[0];
                    var remoteUserId = arguments[1];
                    var remoteDeviceId = arguments[2];
                    return fm.liveswitch.Message.createMessageMessage(message, remoteUserId, remoteDeviceId, null);
                }
                else if (arguments.length == 4) {
                    var message = arguments[0];
                    var remoteUserId = arguments[1];
                    var remoteDeviceId = arguments[2];
                    var remoteClientId = arguments[3];
                    var message2 = new fm.liveswitch.Message(fm.liveswitch.MessageType.getMessage());
                    message2.setPayload(fm.liveswitch.JsonSerializer.serializeString(message));
                    message2.setRemoteUserId(remoteUserId);
                    message2.setRemoteDeviceId(remoteDeviceId);
                    message2.setRemoteClientId(remoteClientId);
                    return message2;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a peer "answer" message.
            @param tag The tag.
            @param answerJson The answer.
            @param remoteUserId The remote user identifier.
            @param remoteDeviceId The remote device identifier.
            @param remoteClientId The remote client identifier.
            */
            Message.createPeerAnswerMessage = function (tag, answerJson, remoteUserId, remoteDeviceId, remoteClientId) {
                if (arguments.length == 5) {
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getAnswer());
                    message.setConnectionType(fm.liveswitch.ConnectionType.getPeer());
                    message.setConnectionTag(tag);
                    message.setPayload(answerJson);
                    message.setRemoteUserId(remoteUserId);
                    message.setRemoteDeviceId(remoteDeviceId);
                    message.setRemoteClientId(remoteClientId);
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a "candidate" message.
            @param candidateJson The candidate.
            @param remoteUserId The remote user identifier.
            @param remoteDeviceId The remote device identifier.
            @param remoteClientId The remote client identifier.
            */
            Message.createPeerCandidateMessage = function (candidateJson, remoteUserId, remoteDeviceId, remoteClientId) {
                if (arguments.length == 4) {
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getCandidate());
                    message.setPayload(candidateJson);
                    message.setRemoteUserId(remoteUserId);
                    message.setRemoteDeviceId(remoteDeviceId);
                    message.setRemoteClientId(remoteClientId);
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a "close" message.
            @param remoteUserId The remote user identifier.
            @param remoteDeviceId The remote device identifier.
            @param remoteClientId The remote client identifier.
            */
            Message.createPeerCloseMessage = function (remoteUserId, remoteDeviceId, remoteClientId) {
                if (arguments.length == 3) {
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getClose());
                    message.setRemoteUserId(remoteUserId);
                    message.setRemoteDeviceId(remoteDeviceId);
                    message.setRemoteClientId(remoteClientId);
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a peer "offer" message.
            @param tag The tag.
            @param offerJson The offer.
            @param remoteUserId The remote user identifier.
            @param remoteDeviceId The remote device identifier.
            @param remoteClientId The remote client identifier.
            */
            Message.createPeerOfferMessage = function (tag, offerJson, remoteUserId, remoteDeviceId, remoteClientId) {
                if (arguments.length == 5) {
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getOffer());
                    message.setConnectionType(fm.liveswitch.ConnectionType.getPeer());
                    message.setConnectionTag(tag);
                    message.setPayload(offerJson);
                    message.setRemoteUserId(remoteUserId);
                    message.setRemoteDeviceId(remoteDeviceId);
                    message.setRemoteClientId(remoteClientId);
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a "reject" message.
            @param remoteUserId The remote user identifier.
            @param remoteDeviceId The remote device identifier.
            @param remoteClientId The remote client identifier.
            @param remoteConnectionId The remote connection identifier.
            */
            Message.createPeerRejectMessage = function (remoteUserId, remoteDeviceId, remoteClientId, remoteConnectionId) {
                if (arguments.length == 4) {
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getReject());
                    message.setConnectionType(fm.liveswitch.ConnectionType.getPeer());
                    message.setRemoteUserId(remoteUserId);
                    message.setRemoteDeviceId(remoteDeviceId);
                    message.setRemoteClientId(remoteClientId);
                    message.setRemoteConnectionId(remoteConnectionId);
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a "register" message.
            @param applicationId The application identifier.
            @param userId The user identifier.
            @param userAlias The user alias.
            @param deviceId The device identifier.
            @param deviceAlias The device alias.
            @param clientId The client identifier.
            @param clientTag The client tag.
            @param clientRoles The client roles.
            @param region The region.
            @param token The auth token.
            */
            Message.createRegisterMessage = function (applicationId, userId, userAlias, deviceId, deviceAlias, clientId, clientTag, clientRoles, region, token) {
                if (arguments.length == 10) {
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getRegister());
                    message.setApplicationId(applicationId);
                    message.setUserId(userId);
                    message.setUserAlias(userAlias);
                    message.setDeviceId(deviceId);
                    message.setDeviceAlias(deviceAlias);
                    message.setClientId(clientId);
                    message.setClientTag(clientTag);
                    message.setClientRoles(clientRoles);
                    message.setRegion(region);
                    message.setToken(token);
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Message.createSfuOfferMessage = function () {
                if (arguments.length == 2) {
                    var tag = arguments[0];
                    var offerJson = arguments[1];
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getOffer());
                    message.setConnectionType(fm.liveswitch.ConnectionType.getSfu());
                    message.setConnectionTag(tag);
                    message.setPayload(offerJson);
                    return message;
                }
                else if (arguments.length == 3) {
                    var tag = arguments[0];
                    var offerJson = arguments[1];
                    var remoteMediaId = arguments[2];
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getOffer());
                    message.setConnectionType(fm.liveswitch.ConnectionType.getSfu());
                    message.setConnectionTag(tag);
                    message.setPayload(offerJson);
                    message.setRemoteMediaId(remoteMediaId);
                    return message;
                }
                else if (arguments.length == 6) {
                    var tag = arguments[0];
                    var offerJson = arguments[1];
                    var remoteUserId = arguments[2];
                    var remoteDeviceId = arguments[3];
                    var remoteClientId = arguments[4];
                    var remoteConnectionId = arguments[5];
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getOffer());
                    message.setConnectionType(fm.liveswitch.ConnectionType.getSfu());
                    message.setConnectionTag(tag);
                    message.setPayload(offerJson);
                    message.setRemoteUserId(remoteUserId);
                    message.setRemoteDeviceId(remoteDeviceId);
                    message.setRemoteClientId(remoteClientId);
                    message.setRemoteConnectionId(remoteConnectionId);
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Message.createUnregisterMessage = function () {
                if (arguments.length == 0) {
                    return new fm.liveswitch.Message(fm.liveswitch.MessageType.getUnregister());
                }
                else if (arguments.length == 1) {
                    var channelReports = arguments[0];
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getUnregister());
                    message.setChannelReports(channelReports);
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Message.createUpdateMessage = function () {
                if (arguments.length == 1) {
                    var configJson = arguments[0];
                    return fm.liveswitch.Message.createUpdateMessage(configJson, null, null, null);
                }
                else if (arguments.length == 4) {
                    var configJson = arguments[0];
                    var remoteUserId = arguments[1];
                    var remoteDeviceId = arguments[2];
                    var remoteClientId = arguments[3];
                    var message = new fm.liveswitch.Message(fm.liveswitch.MessageType.getUpdate());
                    message.setPayload(configJson);
                    message.setRemoteUserId(remoteUserId);
                    message.setRemoteDeviceId(remoteDeviceId);
                    message.setRemoteClientId(remoteClientId);
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an instance from JSON.
            @param messageJson The JSON to deserialize.
            @return
                        The deserialized message.
                
            */
            Message.fromJson = function (messageJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(messageJson, function () {
                        return new fm.liveswitch.Message(null);
                    }, function (message, name, valueJson) {
                        message.propertyFromJson(name, valueJson);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes an array of instances from JSON.
            @param messagesJson The JSON to deserialize.
            @return
                        The deserialized messages.
                
            */
            Message.fromJsonArray = function (messagesJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(messagesJson, fm.liveswitch.Message.fromJson.bind(fm.liveswitch.Message));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            @param message The message to serialize.
            @return
                        The serialized JSON.
                
            */
            Message.toJson = function (message) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(message, function (m, jsonObject) {
                        m.propertiesToJson(jsonObject);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array of instances to JSON.
            @param messages The messages to serialize.
            @return
                        The serialized JSON.
                
            */
            Message.toJsonArray = function (messages) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(messages, fm.liveswitch.Message.toJson.bind(fm.liveswitch.Message));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Creates a copy of the Message.
            */
            Message.prototype.clone = function () {
                if (arguments.length == 0) {
                    var clientRoles = this.getClientRoles();
                    var strArray2 = null;
                    if ((!fm.liveswitch.Global.equals(clientRoles, null))) {
                        strArray2 = new Array(clientRoles.length);
                        for (var i = 0; (i < strArray2.length); i++) {
                            strArray2[i] = clientRoles[i];
                        }
                    }
                    var message = new fm.liveswitch.Message();
                    message.setApiVersion(this.getApiVersion());
                    message.setApplicationId(this.getApplicationId());
                    message.setChannelId(this.getChannelId());
                    message.setClientId(this.getClientId());
                    message.setClientTag(this.getClientTag());
                    message.setClientRoles(strArray2);
                    message.setConnectionId(this.getConnectionId());
                    message.setConnectionTag(this.getConnectionTag());
                    message.setConnectionType(this.getConnectionType());
                    message.setConnectorId(this.getConnectorId());
                    message.setDeviceAlias(this.getDeviceAlias());
                    message.setDeviceId(this.getDeviceId());
                    message.setTimestamp(this.getTimestamp());
                    message.setMediaServerId(this.getMediaServerId());
                    message.setMediaId(this.getMediaId());
                    message.setPayload(this.getPayload());
                    message.setRemoteClientId(this.getRemoteClientId());
                    message.setRemoteConnectionId(this.getRemoteConnectionId());
                    message.setRemoteDeviceId(this.getRemoteDeviceId());
                    message.setRemoteMediaId(this.getRemoteMediaId());
                    message.setRemoteUserId(this.getRemoteUserId());
                    message.setRegion(this.getRegion());
                    message.setToken(this.getToken());
                    message.setType(this.getType());
                    message.setUserAlias(this.getUserAlias());
                    message.setUserId(this.getUserId());
                    return message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the API Version.
            */
            Message.prototype.getApiVersion = function () {
                if (arguments.length == 0) {
                    return this._apiVersion;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the application identifier.
            */
            Message.prototype.getApplicationId = function () {
                if (arguments.length == 0) {
                    return this._applicationId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the channel identifier.
            */
            Message.prototype.getChannelId = function () {
                if (arguments.length == 0) {
                    return this._channelId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the channel reports.
            */
            Message.prototype.getChannelReports = function () {
                if (arguments.length == 0) {
                    return this._channelReports;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client identifier.
            */
            Message.prototype.getClientId = function () {
                if (arguments.length == 0) {
                    return this._clientId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client roles.
            */
            Message.prototype.getClientRoles = function () {
                if (arguments.length == 0) {
                    return this._clientRoles;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client tag.
            */
            Message.prototype.getClientTag = function () {
                if (arguments.length == 0) {
                    return this._clientTag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connection identifier.
            */
            Message.prototype.getConnectionId = function () {
                if (arguments.length == 0) {
                    return this._connectionId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connection tag.
            */
            Message.prototype.getConnectionTag = function () {
                if (arguments.length == 0) {
                    return this._connectionTag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connection type.
            */
            Message.prototype.getConnectionType = function () {
                if (arguments.length == 0) {
                    return this._connectionType;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connector identifer.
            */
            Message.prototype.getConnectorId = function () {
                if (arguments.length == 0) {
                    return this._connectorId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the device alias.
            */
            Message.prototype.getDeviceAlias = function () {
                if (arguments.length == 0) {
                    return this._deviceAlias;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the device identifier.
            */
            Message.prototype.getDeviceId = function () {
                if (arguments.length == 0) {
                    return this._deviceId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the broadcast identifier.
            */
            Message.prototype.getMediaId = function () {
                if (arguments.length == 0) {
                    return this._mediaId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media server identifier.
            */
            Message.prototype.getMediaServerId = function () {
                if (arguments.length == 0) {
                    return this._mediaServerId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the payload.
            */
            Message.prototype.getPayload = function () {
                if (arguments.length == 0) {
                    return this._payload;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the region.
            */
            Message.prototype.getRegion = function () {
                if (arguments.length == 0) {
                    return this._region;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote client identifier.
            */
            Message.prototype.getRemoteClientId = function () {
                if (arguments.length == 0) {
                    return this._remoteClientId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote connection identifier.
            */
            Message.prototype.getRemoteConnectionId = function () {
                if (arguments.length == 0) {
                    return this._remoteConnectionId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote device identifier.
            */
            Message.prototype.getRemoteDeviceId = function () {
                if (arguments.length == 0) {
                    return this._remoteDeviceId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote broadcast identifier.
            */
            Message.prototype.getRemoteMediaId = function () {
                if (arguments.length == 0) {
                    return this._remoteMediaId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the remote user identifier.
            */
            Message.prototype.getRemoteUserId = function () {
                if (arguments.length == 0) {
                    return this._remoteUserId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the message timestamp.
            */
            Message.prototype.getTimestamp = function () {
                if (arguments.length == 0) {
                    return this._timestamp;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the token.
            */
            Message.prototype.getToken = function () {
                if (arguments.length == 0) {
                    return this._token;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the type.
            */
            Message.prototype.getType = function () {
                if (arguments.length == 0) {
                    return this._type;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the user alias.
            */
            Message.prototype.getUserAlias = function () {
                if (arguments.length == 0) {
                    return this._userAlias;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the user identifier.
            */
            Message.prototype.getUserId = function () {
                if (arguments.length == 0) {
                    return this._userId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Message.prototype.propertiesToJson = function (jsonObject) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(this.getMediaServerId(), null))) {
                        jsonObject["mediaServerId"] = fm.liveswitch.JsonSerializer.serializeString(this.getMediaServerId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getConnectorId(), null))) {
                        jsonObject["connectorId"] = fm.liveswitch.JsonSerializer.serializeString(this.getConnectorId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getApplicationId(), null))) {
                        jsonObject["applicationId"] = fm.liveswitch.JsonSerializer.serializeString(this.getApplicationId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getChannelId(), null))) {
                        jsonObject["channelId"] = fm.liveswitch.JsonSerializer.serializeString(this.getChannelId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getChannelReports(), null))) {
                        jsonObject["channelReports"] = fm.liveswitch.ChannelReport.toJsonArray(this.getChannelReports());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getUserId(), null))) {
                        jsonObject["userId"] = fm.liveswitch.JsonSerializer.serializeString(this.getUserId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getUserAlias(), null))) {
                        jsonObject["userAlias"] = fm.liveswitch.JsonSerializer.serializeString(this.getUserAlias());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getDeviceId(), null))) {
                        jsonObject["deviceId"] = fm.liveswitch.JsonSerializer.serializeString(this.getDeviceId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getDeviceAlias(), null))) {
                        jsonObject["deviceAlias"] = fm.liveswitch.JsonSerializer.serializeString(this.getDeviceAlias());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getClientId(), null))) {
                        jsonObject["clientId"] = fm.liveswitch.JsonSerializer.serializeString(this.getClientId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getClientTag(), null))) {
                        jsonObject["clientTag"] = fm.liveswitch.JsonSerializer.serializeString(this.getClientTag());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getClientRoles(), null))) {
                        jsonObject["clientRoles"] = fm.liveswitch.JsonSerializer.serializeStringArray(this.getClientRoles());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getConnectionId(), null))) {
                        jsonObject["connectionId"] = fm.liveswitch.JsonSerializer.serializeString(this.getConnectionId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getConnectionTag(), null))) {
                        jsonObject["connectionTag"] = fm.liveswitch.JsonSerializer.serializeString(this.getConnectionTag());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getConnectionType(), null))) {
                        jsonObject["connectionType"] = fm.liveswitch.JsonSerializer.serializeString(this.getConnectionType());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getMediaId(), null))) {
                        jsonObject["mediaId"] = fm.liveswitch.JsonSerializer.serializeString(this.getMediaId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getToken(), null))) {
                        jsonObject["token"] = fm.liveswitch.JsonSerializer.serializeString(this.getToken());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getType(), null))) {
                        jsonObject["type"] = fm.liveswitch.JsonSerializer.serializeString(this.getType());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getPayload(), null))) {
                        jsonObject["payload"] = fm.liveswitch.JsonSerializer.serializeString(this.getPayload());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRemoteUserId(), null))) {
                        jsonObject["remoteUserId"] = fm.liveswitch.JsonSerializer.serializeString(this.getRemoteUserId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRemoteDeviceId(), null))) {
                        jsonObject["remoteDeviceId"] = fm.liveswitch.JsonSerializer.serializeString(this.getRemoteDeviceId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRemoteClientId(), null))) {
                        jsonObject["remoteClientId"] = fm.liveswitch.JsonSerializer.serializeString(this.getRemoteClientId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRemoteConnectionId(), null))) {
                        jsonObject["remoteConnectionId"] = fm.liveswitch.JsonSerializer.serializeString(this.getRemoteConnectionId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRemoteMediaId(), null))) {
                        jsonObject["remoteMediaId"] = fm.liveswitch.JsonSerializer.serializeString(this.getRemoteMediaId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getRegion(), null))) {
                        jsonObject["region"] = fm.liveswitch.JsonSerializer.serializeString(this.getRegion());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getApiVersion(), null))) {
                        jsonObject["apiVersion"] = fm.liveswitch.JsonSerializer.serializeString(this.getApiVersion());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Message.prototype.propertyFromJson = function (name, valueJson) {
                if (arguments.length == 2) {
                    var _var0 = name;
                    if (_var0 == "mediaServerId") {
                        do {
                            this.setMediaServerId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "connectorId") {
                        do {
                            this.setConnectorId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "applicationId") {
                        do {
                            this.setApplicationId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "channelId") {
                        do {
                            this.setChannelId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "channelReports") {
                        do {
                            this.setChannelReports(fm.liveswitch.ChannelReport.fromJsonArray(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "userId") {
                        do {
                            this.setUserId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "userAlias") {
                        do {
                            this.setUserAlias(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "deviceId") {
                        do {
                            this.setDeviceId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "deviceAlias") {
                        do {
                            this.setDeviceAlias(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "clientId") {
                        do {
                            this.setClientId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "clientTag") {
                        do {
                            this.setClientTag(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "clientRoles") {
                        do {
                            this.setClientRoles(fm.liveswitch.JsonSerializer.deserializeStringArray(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "connectionId") {
                        do {
                            this.setConnectionId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "connectionTag") {
                        do {
                            this.setConnectionTag(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "connectionType") {
                        do {
                            this.setConnectionType(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "mediaId") {
                        do {
                            this.setMediaId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "token") {
                        do {
                            this.setToken(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "type") {
                        do {
                            this.setType(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "payload") {
                        do {
                            this.setPayload(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "remoteUserId") {
                        do {
                            this.setRemoteUserId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "remoteDeviceId") {
                        do {
                            this.setRemoteDeviceId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "remoteClientId") {
                        do {
                            this.setRemoteClientId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "remoteConnectionId") {
                        do {
                            this.setRemoteConnectionId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "remoteMediaId") {
                        do {
                            this.setRemoteMediaId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "region") {
                        do {
                            this.setRegion(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "apiVersion") {
                        do {
                            this.setApiVersion(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            break;
                        } while (false);
                    }
                    else if (_var0 == "timestamp") {
                        do {
                            this.setTimestamp(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            break;
                        } while (false);
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Message.prototype.setApiVersion = function (value) {
                if (arguments.length == 1) {
                    this._apiVersion = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the application identifier.
            */
            Message.prototype.setApplicationId = function (value) {
                if (arguments.length == 1) {
                    this._applicationId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the channel identifier.
            */
            Message.prototype.setChannelId = function (value) {
                if (arguments.length == 1) {
                    this._channelId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the channel reports.
            */
            Message.prototype.setChannelReports = function (value) {
                if (arguments.length == 1) {
                    this._channelReports = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the client identifier.
            */
            Message.prototype.setClientId = function (value) {
                if (arguments.length == 1) {
                    this._clientId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the client roles.
            */
            Message.prototype.setClientRoles = function (value) {
                if (arguments.length == 1) {
                    this._clientRoles = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the client tag.
            */
            Message.prototype.setClientTag = function (value) {
                if (arguments.length == 1) {
                    this._clientTag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the connection identifier.
            */
            Message.prototype.setConnectionId = function (value) {
                if (arguments.length == 1) {
                    this._connectionId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the connection tag.
            */
            Message.prototype.setConnectionTag = function (value) {
                if (arguments.length == 1) {
                    this._connectionTag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the connection type.
            */
            Message.prototype.setConnectionType = function (value) {
                if (arguments.length == 1) {
                    this._connectionType = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the connector identifer.
            */
            Message.prototype.setConnectorId = function (value) {
                if (arguments.length == 1) {
                    this._connectorId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the device alias.
            */
            Message.prototype.setDeviceAlias = function (value) {
                if (arguments.length == 1) {
                    this._deviceAlias = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the device identifier.
            */
            Message.prototype.setDeviceId = function (value) {
                if (arguments.length == 1) {
                    this._deviceId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the broadcast identifier.
            */
            Message.prototype.setMediaId = function (value) {
                if (arguments.length == 1) {
                    this._mediaId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the media server identifier.
            */
            Message.prototype.setMediaServerId = function (value) {
                if (arguments.length == 1) {
                    this._mediaServerId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the payload.
            */
            Message.prototype.setPayload = function (value) {
                if (arguments.length == 1) {
                    this._payload = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the region.
            */
            Message.prototype.setRegion = function (value) {
                if (arguments.length == 1) {
                    this._region = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote client identifier.
            */
            Message.prototype.setRemoteClientId = function (value) {
                if (arguments.length == 1) {
                    this._remoteClientId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote connection identifier.
            */
            Message.prototype.setRemoteConnectionId = function (value) {
                if (arguments.length == 1) {
                    this._remoteConnectionId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote device identifier.
            */
            Message.prototype.setRemoteDeviceId = function (value) {
                if (arguments.length == 1) {
                    this._remoteDeviceId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote broadcast identifier.
            */
            Message.prototype.setRemoteMediaId = function (value) {
                if (arguments.length == 1) {
                    this._remoteMediaId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the remote user identifier.
            */
            Message.prototype.setRemoteUserId = function (value) {
                if (arguments.length == 1) {
                    this._remoteUserId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the message timestamp.
            */
            Message.prototype.setTimestamp = function (value) {
                if (arguments.length == 1) {
                    this._timestamp = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the token.
            */
            Message.prototype.setToken = function (value) {
                if (arguments.length == 1) {
                    this._token = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the type.
            */
            Message.prototype.setType = function (value) {
                if (arguments.length == 1) {
                    this._type = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the user alias.
            */
            Message.prototype.setUserAlias = function (value) {
                if (arguments.length == 1) {
                    this._userAlias = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the user identifier.
            */
            Message.prototype.setUserId = function (value) {
                if (arguments.length == 1) {
                    this._userId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            Message.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Message.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return Message;
        }(fm.liveswitch.Dynamic));
        liveswitch.Message = Message;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Message information.
        */
        var MessageInfo = /** @class */ (function (_super) {
            __extends(MessageInfo, _super);
            function MessageInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MessageInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.MessageInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            /**
            Deserializes an instance from JSON.
            */
            MessageInfo.fromJson = function (messageInfoJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(messageInfoJson, function () {
                        return new fm.liveswitch.MessageInfo();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to JSON.
            */
            MessageInfo.toJson = function (messageInfo) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(messageInfo, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            MessageInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "userId"))) {
                            if ((fm.liveswitch.Global.equals(str, "deviceId"))) {
                                this.setDeviceId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "clientId"))) {
                                    this.setClientId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "message"))) {
                                        this.setMessage(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                    }
                                }
                            }
                        }
                        else {
                            this.setUserId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client identifier.
            */
            MessageInfo.prototype.getClientId = function () {
                if (arguments.length == 0) {
                    return this._clientId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the device identifier.
            */
            MessageInfo.prototype.getDeviceId = function () {
                if (arguments.length == 0) {
                    return this._deviceId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the message.
            */
            MessageInfo.prototype.getMessage = function () {
                if (arguments.length == 0) {
                    return this._message;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the user identifier.
            */
            MessageInfo.prototype.getUserId = function () {
                if (arguments.length == 0) {
                    return this._userId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            MessageInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getUserId(), null))) {
                        jsonObject["userId"] = fm.liveswitch.JsonSerializer.serializeString(this.getUserId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getDeviceId(), null))) {
                        jsonObject["deviceId"] = fm.liveswitch.JsonSerializer.serializeString(this.getDeviceId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getClientId(), null))) {
                        jsonObject["clientId"] = fm.liveswitch.JsonSerializer.serializeString(this.getClientId());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getMessage(), null))) {
                        jsonObject["message"] = fm.liveswitch.JsonSerializer.serializeString(this.getMessage());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the client identifier.
            */
            MessageInfo.prototype.setClientId = function (value) {
                if (arguments.length == 1) {
                    this._clientId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the device identifier.
            */
            MessageInfo.prototype.setDeviceId = function (value) {
                if (arguments.length == 1) {
                    this._deviceId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the message.
            */
            MessageInfo.prototype.setMessage = function (value) {
                if (arguments.length == 1) {
                    this._message = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the user identifier.
            */
            MessageInfo.prototype.setUserId = function (value) {
                if (arguments.length == 1) {
                    this._userId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            MessageInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.MessageInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MessageInfo;
        }(fm.liveswitch.Info));
        liveswitch.MessageInfo = MessageInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A message type.
        */
        var MessageType = /** @class */ (function () {
            function MessageType() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            MessageType.prototype.getTypeString = function () {
                return '[fm.liveswitch.MessageType]';
            };
            /**
            Gets the "answer" message type string.
            */
            MessageType.getAnswer = function () {
                if (arguments.length == 0) {
                    return "answer";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "bitrateNotification" message type string.
            */
            MessageType.getBitrateNotification = function () {
                if (arguments.length == 0) {
                    return "bitrateNotification";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "bitrateRequest" message type string.
            */
            MessageType.getBitrateRequest = function () {
                if (arguments.length == 0) {
                    return "bitrateRequest";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "cancelInvite" message type string.
            */
            MessageType.getCancelInvite = function () {
                if (arguments.length == 0) {
                    return "cancelInvite";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "candidate" message type string.
            */
            MessageType.getCandidate = function () {
                if (arguments.length == 0) {
                    return "candidate";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "close" message type string.
            */
            MessageType.getClose = function () {
                if (arguments.length == 0) {
                    return "close";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "dtmfTones" message type string.
            */
            MessageType.getDtmfTones = function () {
                if (arguments.length == 0) {
                    return "dtmfTones";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "error" message type string.
            */
            MessageType.getError = function () {
                if (arguments.length == 0) {
                    return "error";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "event" message type string.
            */
            MessageType.getEvent = function () {
                if (arguments.length == 0) {
                    return "event";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "fail" message type string.
            */
            MessageType.getFail = function () {
                if (arguments.length == 0) {
                    return "fail";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "iceServers" message type string.
            */
            MessageType.getIceServers = function () {
                if (arguments.length == 0) {
                    return "iceServers";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "invite" message type string.
            */
            MessageType.getInvite = function () {
                if (arguments.length == 0) {
                    return "invite";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "inviteFeedback" message type string.
            */
            MessageType.getInviteFeedback = function () {
                if (arguments.length == 0) {
                    return "inviteFeedback";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "join" message type string.
            */
            MessageType.getJoin = function () {
                if (arguments.length == 0) {
                    return "join";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "keyFrameRequest" message type string.
            */
            MessageType.getKeyFrameRequest = function () {
                if (arguments.length == 0) {
                    return "keyFrameRequest";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "kick" message type string.
            */
            MessageType.getKick = function () {
                if (arguments.length == 0) {
                    return "kick";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "leave" message type string.
            */
            MessageType.getLeave = function () {
                if (arguments.length == 0) {
                    return "leave";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "mcuVideoLayout" message type string.
            */
            MessageType.getMcuVideoLayout = function () {
                if (arguments.length == 0) {
                    return "mcuVideoLayout";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "message" message type string.
            */
            MessageType.getMessage = function () {
                if (arguments.length == 0) {
                    return "message";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "notifyJoin" message type string.
            */
            MessageType.getNotifyJoin = function () {
                if (arguments.length == 0) {
                    return "notifyJoin";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "notifyLeave" message type string.
            */
            MessageType.getNotifyLeave = function () {
                if (arguments.length == 0) {
                    return "notifyLeave";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "notifyServiceState" message type string.
            */
            MessageType.getNotifyServiceState = function () {
                if (arguments.length == 0) {
                    return "notifyServiceState";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "notifyUpstreamClose" message type string.
            */
            MessageType.getNotifyUpstreamClose = function () {
                if (arguments.length == 0) {
                    return "notifyUpstreamClose";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "notifyUpstreamOpen" message type string.
            */
            MessageType.getNotifyUpstreamOpen = function () {
                if (arguments.length == 0) {
                    return "notifyUpstreamOpen";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "notifyUpstreamUpdate" message type string.
            */
            MessageType.getNotifyUpstreamUpdate = function () {
                if (arguments.length == 0) {
                    return "notifyUpstreamUpdate";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "offer" message type string.
            */
            MessageType.getOffer = function () {
                if (arguments.length == 0) {
                    return "offer";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "record" message type string.
            */
            MessageType.getRecord = function () {
                if (arguments.length == 0) {
                    return "record";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "register" message type string.
            */
            MessageType.getRegister = function () {
                if (arguments.length == 0) {
                    return "register";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "reject" message type string.
            */
            MessageType.getReject = function () {
                if (arguments.length == 0) {
                    return "reject";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "report" message type string.
            */
            MessageType.getReport = function () {
                if (arguments.length == 0) {
                    return "report";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "unregister" message type string.
            */
            MessageType.getUnregister = function () {
                if (arguments.length == 0) {
                    return "unregister";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "update" message type string.
            */
            MessageType.getUpdate = function () {
                if (arguments.length == 0) {
                    return "update";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MessageType;
        }());
        liveswitch.MessageType = MessageType;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Mixer report.
        */
        var MixerReport = /** @class */ (function (_super) {
            __extends(MixerReport, _super);
            function MixerReport() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchMixerReportInit();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            MixerReport.prototype.getTypeString = function () {
                return '[fm.liveswitch.MixerReport]' + ',' + _super.prototype.getTypeString.call(this);
            };
            MixerReport.prototype.fmliveswitchMixerReportInit = function () {
                this._disabled = false;
                this._outputFrameRate = 0;
                this._outputHeight = 0;
                this._outputWidth = 0;
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            MixerReport.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "disabled"))) {
                            if ((fm.liveswitch.Global.equals(str, "inputFormat"))) {
                                this.setInputFormat(fm.liveswitch.FormatInfo.fromJson(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "outputFormat"))) {
                                    this.setOutputFormat(fm.liveswitch.FormatInfo.fromJson(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "outputWidth"))) {
                                        this.setOutputWidth(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "outputHeight"))) {
                                            this.setOutputHeight(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                        }
                                        else {
                                            if ((fm.liveswitch.Global.equals(str, "outputFrameRate"))) {
                                                this.setOutputFrameRate(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            this.setDisabled(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether the mixer is disabled.
            */
            MixerReport.prototype.getDisabled = function () {
                if (arguments.length == 0) {
                    return this._disabled;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the mixer input format.
            */
            MixerReport.prototype.getInputFormat = function () {
                if (arguments.length == 0) {
                    return this._inputFormat;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the mixer output format.
            */
            MixerReport.prototype.getOutputFormat = function () {
                if (arguments.length == 0) {
                    return this._outputFormat;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the mixer output frame-rate.
            */
            MixerReport.prototype.getOutputFrameRate = function () {
                if (arguments.length == 0) {
                    return this._outputFrameRate;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the mixer output height.
            */
            MixerReport.prototype.getOutputHeight = function () {
                if (arguments.length == 0) {
                    return this._outputHeight;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the mixer output width.
            */
            MixerReport.prototype.getOutputWidth = function () {
                if (arguments.length == 0) {
                    return this._outputWidth;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            MixerReport.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((this.getDisabled() != null)) {
                        jsonObject["disabled"] = fm.liveswitch.JsonSerializer.serializeBoolean(this.getDisabled());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getInputFormat(), null))) {
                        jsonObject["inputFormat"] = fm.liveswitch.FormatInfo.toJson(this.getInputFormat());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getOutputFormat(), null))) {
                        jsonObject["outputFormat"] = fm.liveswitch.FormatInfo.toJson(this.getOutputFormat());
                    }
                    if ((this.getOutputWidth() != null)) {
                        jsonObject["outputWidth"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getOutputWidth());
                    }
                    if ((this.getOutputHeight() != null)) {
                        jsonObject["outputHeight"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getOutputHeight());
                    }
                    if ((this.getOutputFrameRate() != null)) {
                        jsonObject["outputFrameRate"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getOutputFrameRate());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets whether the mixer is disabled.
            */
            MixerReport.prototype.setDisabled = function (value) {
                if (arguments.length == 1) {
                    this._disabled = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the mixer input format.
            */
            MixerReport.prototype.setInputFormat = function (value) {
                if (arguments.length == 1) {
                    this._inputFormat = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the mixer output format.
            */
            MixerReport.prototype.setOutputFormat = function (value) {
                if (arguments.length == 1) {
                    this._outputFormat = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the mixer output frame-rate.
            */
            MixerReport.prototype.setOutputFrameRate = function (value) {
                if (arguments.length == 1) {
                    this._outputFrameRate = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the mixer output height.
            */
            MixerReport.prototype.setOutputHeight = function (value) {
                if (arguments.length == 1) {
                    this._outputHeight = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the mixer output width.
            */
            MixerReport.prototype.setOutputWidth = function (value) {
                if (arguments.length == 1) {
                    this._outputWidth = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return MixerReport;
        }(fm.liveswitch.Info));
        liveswitch.MixerReport = MixerReport;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Network interface information.
        */
        var NetworkInterfaceInfo = /** @class */ (function (_super) {
            __extends(NetworkInterfaceInfo, _super);
            function NetworkInterfaceInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchNetworkInterfaceInfoInit();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            NetworkInterfaceInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.NetworkInterfaceInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            NetworkInterfaceInfo.prototype.fmliveswitchNetworkInterfaceInfoInit = function () {
                this._adapterSpeed = 0;
            };
            /**
            Deserializes Json to a NetworkInterfaceInfo.
            @param networkInterfaceInfoJson The serialized Json.
            @return The deserialized NetworkInterfaceInfo.
            */
            NetworkInterfaceInfo.fromJson = function (networkInterfaceInfoJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(networkInterfaceInfoJson, function () {
                        return new fm.liveswitch.NetworkInterfaceInfo();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes JSON to an array.
            @param networkInterfaceInfosJson The serialized JSON.
            @return The deserialized array.
            */
            NetworkInterfaceInfo.fromJsonArray = function (networkInterfaceInfosJson) {
                if (arguments.length == 1) {
                    var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(networkInterfaceInfosJson, fm.liveswitch.NetworkInterfaceInfo.fromJson.bind(fm.liveswitch.NetworkInterfaceInfo));
                    if ((fm.liveswitch.Global.equals(list, null))) {
                        return null;
                    }
                    return fm.liveswitch.ArrayExtensions.toArray(list);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to Json.
            @param client The instance to serialize.
            @return Serialized Json.
            */
            NetworkInterfaceInfo.toJson = function (client) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(client, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an array to JSON.
            @param networkInterfaceInfos The array to serialize.
            @return The serialized JSON.
            */
            NetworkInterfaceInfo.toJsonArray = function (networkInterfaceInfos) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObjectArray(networkInterfaceInfos, fm.liveswitch.NetworkInterfaceInfo.toJson.bind(fm.liveswitch.NetworkInterfaceInfo));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            NetworkInterfaceInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "type"))) {
                            if ((fm.liveswitch.Global.equals(str, "ipAddress"))) {
                                this.setIPAddress(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(str, "mask"))) {
                                    this.setMask(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "adapterSpeed"))) {
                                        this.setAdapterSpeed(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                                    }
                                }
                            }
                        }
                        else {
                            this.setType(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the network interface adapter speed.
            */
            NetworkInterfaceInfo.prototype.getAdapterSpeed = function () {
                if (arguments.length == 0) {
                    return this._adapterSpeed;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the network interface address.
            */
            NetworkInterfaceInfo.prototype.getIPAddress = function () {
                if (arguments.length == 0) {
                    return this._ipAddress;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the network interface subnet mask.
            */
            NetworkInterfaceInfo.prototype.getMask = function () {
                if (arguments.length == 0) {
                    return this._mask;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the type.
            */
            NetworkInterfaceInfo.prototype.getType = function () {
                if (arguments.length == 0) {
                    return this._type;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            NetworkInterfaceInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getType(), null))) {
                        jsonObject["type"] = fm.liveswitch.JsonSerializer.serializeString(this.getType());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getIPAddress(), null))) {
                        jsonObject["ipAddress"] = fm.liveswitch.JsonSerializer.serializeString(this.getIPAddress());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getMask(), null))) {
                        jsonObject["mask"] = fm.liveswitch.JsonSerializer.serializeString(this.getMask());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getAdapterSpeed(), 0))) {
                        jsonObject["adapterSpeed"] = fm.liveswitch.JsonSerializer.serializeLong(this.getAdapterSpeed());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the network interface adapter speed.
            */
            NetworkInterfaceInfo.prototype.setAdapterSpeed = function (value) {
                if (arguments.length == 1) {
                    this._adapterSpeed = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the network interface address.
            */
            NetworkInterfaceInfo.prototype.setIPAddress = function (value) {
                if (arguments.length == 1) {
                    this._ipAddress = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the network interface subnet mask.
            */
            NetworkInterfaceInfo.prototype.setMask = function (value) {
                if (arguments.length == 1) {
                    this._mask = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the type.
            */
            NetworkInterfaceInfo.prototype.setType = function (value) {
                if (arguments.length == 1) {
                    this._type = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to Json.
            */
            NetworkInterfaceInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.NetworkInterfaceInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return NetworkInterfaceInfo;
        }(fm.liveswitch.Info));
        liveswitch.NetworkInterfaceInfo = NetworkInterfaceInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A token.
        */
        var Token = /** @class */ (function () {
            function Token() {
                fm.liveswitch.Token.fmliveswitchTokenInitialize();
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.setIssuedAt(fm.liveswitch.DateTime.getUtcNow());
                    this.setExpirationTime(this.getIssuedAt().addSeconds(fm.liveswitch.Token.getDefaultExpiry()));
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            Token.prototype.getTypeString = function () {
                return '[fm.liveswitch.Token]';
            };
            Token.generateClientJoinToken = function () {
                fm.liveswitch.Token.fmliveswitchTokenInitialize();
                if (arguments.length == 6 && (fm.liveswitch.Util.isNullOrUndefined(arguments[4]) || fm.liveswitch.Util.isObjectType(arguments[4], '[fm.liveswitch.ChannelClaim]'))) {
                    var applicationId = arguments[0];
                    var userId = arguments[1];
                    var deviceId = arguments[2];
                    var clientId = arguments[3];
                    var channelClaim = arguments[4];
                    var sharedSecret = arguments[5];
                    return fm.liveswitch.Token.getClientJoinToken(applicationId, userId, deviceId, clientId, channelClaim).sign(sharedSecret);
                }
                else if (arguments.length == 7 && (fm.liveswitch.Util.isNullOrUndefined(arguments[4]) || fm.liveswitch.Util.isObjectType(arguments[4], '[fm.liveswitch.ChannelClaim]'))) {
                    var applicationId = arguments[0];
                    var userId = arguments[1];
                    var deviceId = arguments[2];
                    var clientId = arguments[3];
                    var channelClaim = arguments[4];
                    var sharedSecret = arguments[5];
                    var expirationTime = arguments[6];
                    var token = fm.liveswitch.Token.getClientJoinToken(applicationId, userId, deviceId, clientId, channelClaim);
                    token.setExpirationTime(expirationTime);
                    return token.sign(sharedSecret);
                }
                else if (arguments.length == 6 && (fm.liveswitch.Util.isNullOrUndefined(arguments[4]) || fm.liveswitch.Util.isString(arguments[4]))) {
                    var applicationId = arguments[0];
                    var userId = arguments[1];
                    var deviceId = arguments[2];
                    var clientId = arguments[3];
                    var channelId = arguments[4];
                    var sharedSecret = arguments[5];
                    return fm.liveswitch.Token.getClientJoinToken(applicationId, userId, deviceId, clientId, channelId).sign(sharedSecret);
                }
                else if (arguments.length == 7 && (fm.liveswitch.Util.isNullOrUndefined(arguments[4]) || fm.liveswitch.Util.isString(arguments[4]))) {
                    var applicationId = arguments[0];
                    var userId = arguments[1];
                    var deviceId = arguments[2];
                    var clientId = arguments[3];
                    var channelId = arguments[4];
                    var sharedSecret = arguments[5];
                    var expirationTime = arguments[6];
                    var token = fm.liveswitch.Token.getClientJoinToken(applicationId, userId, deviceId, clientId, channelId);
                    token.setExpirationTime(expirationTime);
                    return token.sign(sharedSecret);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.ChannelClaim]'))) {
                    var client = arguments[0];
                    var channelClaim = arguments[1];
                    var sharedSecret = arguments[2];
                    return fm.liveswitch.Token.generateClientJoinToken(client.getApplicationId(), client.getUserId(), client.getDeviceId(), client.getId(), channelClaim, sharedSecret);
                }
                else if (arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isObjectType(arguments[1], '[fm.liveswitch.ChannelClaim]'))) {
                    var client = arguments[0];
                    var channelClaim = arguments[1];
                    var sharedSecret = arguments[2];
                    var expirationTime = arguments[3];
                    return fm.liveswitch.Token.generateClientJoinToken(client.getApplicationId(), client.getUserId(), client.getDeviceId(), client.getId(), channelClaim, sharedSecret, expirationTime);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                    var client = arguments[0];
                    var channelId = arguments[1];
                    var sharedSecret = arguments[2];
                    return fm.liveswitch.Token.generateClientJoinToken(client.getApplicationId(), client.getUserId(), client.getDeviceId(), client.getId(), channelId, sharedSecret);
                }
                else if (arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                    var client = arguments[0];
                    var channelId = arguments[1];
                    var sharedSecret = arguments[2];
                    var expirationTime = arguments[3];
                    return fm.liveswitch.Token.generateClientJoinToken(client.getApplicationId(), client.getUserId(), client.getDeviceId(), client.getId(), channelId, sharedSecret, expirationTime);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Token.generateClientRegisterToken = function () {
                fm.liveswitch.Token.fmliveswitchTokenInitialize();
                if (arguments.length == 7 && (fm.liveswitch.Util.isNullOrUndefined(arguments[5]) || (fm.liveswitch.Util.isArray(arguments[5]) && (arguments[5].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[5][0]) || fm.liveswitch.Util.isObjectType(arguments[5][0], '[fm.liveswitch.ChannelClaim]')))))) {
                    var applicationId = arguments[0];
                    var userId = arguments[1];
                    var deviceId = arguments[2];
                    var clientId = arguments[3];
                    var clientRoles = arguments[4];
                    var channelClaims = arguments[5];
                    var sharedSecret = arguments[6];
                    return fm.liveswitch.Token.getClientRegisterToken(applicationId, userId, deviceId, clientId, clientRoles, channelClaims).sign(sharedSecret);
                }
                else if (arguments.length == 8 && (fm.liveswitch.Util.isNullOrUndefined(arguments[5]) || (fm.liveswitch.Util.isArray(arguments[5]) && (arguments[5].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[5][0]) || fm.liveswitch.Util.isObjectType(arguments[5][0], '[fm.liveswitch.ChannelClaim]'))))) && (fm.liveswitch.Util.isNullOrUndefined(arguments[7]) || fm.liveswitch.Util.isObjectType(arguments[7], '[fm.liveswitch.DateTime]'))) {
                    var applicationId = arguments[0];
                    var userId = arguments[1];
                    var deviceId = arguments[2];
                    var clientId = arguments[3];
                    var clientRoles = arguments[4];
                    var channelClaims = arguments[5];
                    var sharedSecret = arguments[6];
                    var expirationTime = arguments[7];
                    var token = fm.liveswitch.Token.getClientRegisterToken(applicationId, userId, deviceId, clientId, clientRoles, channelClaims);
                    token.setExpirationTime(expirationTime);
                    return token.sign(sharedSecret);
                }
                else if (arguments.length == 9 && (fm.liveswitch.Util.isNullOrUndefined(arguments[5]) || (fm.liveswitch.Util.isArray(arguments[5]) && (arguments[5].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[5][0]) || fm.liveswitch.Util.isObjectType(arguments[5][0], '[fm.liveswitch.ChannelClaim]')))))) {
                    var applicationId = arguments[0];
                    var userId = arguments[1];
                    var deviceId = arguments[2];
                    var clientId = arguments[3];
                    var clientRoles = arguments[4];
                    var channelClaims = arguments[5];
                    var sharedSecret = arguments[6];
                    var expirationTime = arguments[7];
                    var region = arguments[8];
                    var token = fm.liveswitch.Token.getClientRegisterToken(applicationId, userId, deviceId, clientId, clientRoles, channelClaims);
                    token.setRegion(region);
                    token.setExpirationTime(expirationTime);
                    return token.sign(sharedSecret);
                }
                else if (arguments.length == 8 && (fm.liveswitch.Util.isNullOrUndefined(arguments[5]) || (fm.liveswitch.Util.isArray(arguments[5]) && (arguments[5].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[5][0]) || fm.liveswitch.Util.isObjectType(arguments[5][0], '[fm.liveswitch.ChannelClaim]'))))) && (fm.liveswitch.Util.isNullOrUndefined(arguments[7]) || fm.liveswitch.Util.isString(arguments[7]))) {
                    var applicationId = arguments[0];
                    var userId = arguments[1];
                    var deviceId = arguments[2];
                    var clientId = arguments[3];
                    var clientRoles = arguments[4];
                    var channelClaims = arguments[5];
                    var sharedSecret = arguments[6];
                    var region = arguments[7];
                    var token = fm.liveswitch.Token.getClientRegisterToken(applicationId, userId, deviceId, clientId, clientRoles, channelClaims);
                    token.setRegion(region);
                    return token.sign(sharedSecret);
                }
                else if (arguments.length == 7 && (fm.liveswitch.Util.isNullOrUndefined(arguments[5]) || fm.liveswitch.Util.isString(arguments[5]))) {
                    var applicationId = arguments[0];
                    var userId = arguments[1];
                    var deviceId = arguments[2];
                    var clientId = arguments[3];
                    var clientRoles = arguments[4];
                    var channelId = arguments[5];
                    var sharedSecret = arguments[6];
                    return fm.liveswitch.Token.getClientRegisterToken(applicationId, userId, deviceId, clientId, clientRoles, channelId).sign(sharedSecret);
                }
                else if (arguments.length == 8 && (fm.liveswitch.Util.isNullOrUndefined(arguments[5]) || fm.liveswitch.Util.isString(arguments[5])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[7]) || fm.liveswitch.Util.isObjectType(arguments[7], '[fm.liveswitch.DateTime]'))) {
                    var applicationId = arguments[0];
                    var userId = arguments[1];
                    var deviceId = arguments[2];
                    var clientId = arguments[3];
                    var clientRoles = arguments[4];
                    var channelId = arguments[5];
                    var sharedSecret = arguments[6];
                    var expirationTime = arguments[7];
                    var token = fm.liveswitch.Token.getClientRegisterToken(applicationId, userId, deviceId, clientId, clientRoles, channelId);
                    token.setExpirationTime(expirationTime);
                    return token.sign(sharedSecret);
                }
                else if (arguments.length == 9 && (fm.liveswitch.Util.isNullOrUndefined(arguments[5]) || fm.liveswitch.Util.isString(arguments[5]))) {
                    var applicationId = arguments[0];
                    var userId = arguments[1];
                    var deviceId = arguments[2];
                    var clientId = arguments[3];
                    var clientRoles = arguments[4];
                    var channelId = arguments[5];
                    var sharedSecret = arguments[6];
                    var expirationTime = arguments[7];
                    var region = arguments[8];
                    var token = fm.liveswitch.Token.getClientRegisterToken(applicationId, userId, deviceId, clientId, clientRoles, channelId);
                    token.setRegion(region);
                    token.setExpirationTime(expirationTime);
                    return token.sign(sharedSecret);
                }
                else if (arguments.length == 8 && (fm.liveswitch.Util.isNullOrUndefined(arguments[5]) || fm.liveswitch.Util.isString(arguments[5])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[7]) || fm.liveswitch.Util.isString(arguments[7]))) {
                    var applicationId = arguments[0];
                    var userId = arguments[1];
                    var deviceId = arguments[2];
                    var clientId = arguments[3];
                    var clientRoles = arguments[4];
                    var channelId = arguments[5];
                    var sharedSecret = arguments[6];
                    var region = arguments[7];
                    var token = fm.liveswitch.Token.getClientRegisterToken(applicationId, userId, deviceId, clientId, clientRoles, channelId);
                    token.setRegion(region);
                    return token.sign(sharedSecret);
                }
                else if (arguments.length == 7 && (fm.liveswitch.Util.isNullOrUndefined(arguments[5]) || (fm.liveswitch.Util.isArray(arguments[5]) && (arguments[5].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[5][0]) || fm.liveswitch.Util.isString(arguments[5][0])))))) {
                    var applicationId = arguments[0];
                    var userId = arguments[1];
                    var deviceId = arguments[2];
                    var clientId = arguments[3];
                    var clientRoles = arguments[4];
                    var channelIds = arguments[5];
                    var sharedSecret = arguments[6];
                    return fm.liveswitch.Token.getClientRegisterToken(applicationId, userId, deviceId, clientId, clientRoles, channelIds).sign(sharedSecret);
                }
                else if (arguments.length == 8 && (fm.liveswitch.Util.isNullOrUndefined(arguments[5]) || (fm.liveswitch.Util.isArray(arguments[5]) && (arguments[5].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[5][0]) || fm.liveswitch.Util.isString(arguments[5][0]))))) && (fm.liveswitch.Util.isNullOrUndefined(arguments[7]) || fm.liveswitch.Util.isObjectType(arguments[7], '[fm.liveswitch.DateTime]'))) {
                    var applicationId = arguments[0];
                    var userId = arguments[1];
                    var deviceId = arguments[2];
                    var clientId = arguments[3];
                    var clientRoles = arguments[4];
                    var channelIds = arguments[5];
                    var sharedSecret = arguments[6];
                    var expirationTime = arguments[7];
                    var token = fm.liveswitch.Token.getClientRegisterToken(applicationId, userId, deviceId, clientId, clientRoles, channelIds);
                    token.setExpirationTime(expirationTime);
                    return token.sign(sharedSecret);
                }
                else if (arguments.length == 9 && (fm.liveswitch.Util.isNullOrUndefined(arguments[5]) || (fm.liveswitch.Util.isArray(arguments[5]) && (arguments[5].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[5][0]) || fm.liveswitch.Util.isString(arguments[5][0])))))) {
                    var applicationId = arguments[0];
                    var userId = arguments[1];
                    var deviceId = arguments[2];
                    var clientId = arguments[3];
                    var clientRoles = arguments[4];
                    var channelIds = arguments[5];
                    var sharedSecret = arguments[6];
                    var expirationTime = arguments[7];
                    var region = arguments[8];
                    var token = fm.liveswitch.Token.getClientRegisterToken(applicationId, userId, deviceId, clientId, clientRoles, channelIds);
                    token.setRegion(region);
                    token.setExpirationTime(expirationTime);
                    return token.sign(sharedSecret);
                }
                else if (arguments.length == 8 && (fm.liveswitch.Util.isNullOrUndefined(arguments[5]) || (fm.liveswitch.Util.isArray(arguments[5]) && (arguments[5].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[5][0]) || fm.liveswitch.Util.isString(arguments[5][0]))))) && (fm.liveswitch.Util.isNullOrUndefined(arguments[7]) || fm.liveswitch.Util.isString(arguments[7]))) {
                    var applicationId = arguments[0];
                    var userId = arguments[1];
                    var deviceId = arguments[2];
                    var clientId = arguments[3];
                    var clientRoles = arguments[4];
                    var channelIds = arguments[5];
                    var sharedSecret = arguments[6];
                    var region = arguments[7];
                    var token = fm.liveswitch.Token.getClientRegisterToken(applicationId, userId, deviceId, clientId, clientRoles, channelIds);
                    token.setRegion(region);
                    return token.sign(sharedSecret);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || (fm.liveswitch.Util.isArray(arguments[1]) && (arguments[1].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[1][0]) || fm.liveswitch.Util.isObjectType(arguments[1][0], '[fm.liveswitch.ChannelClaim]')))))) {
                    var client = arguments[0];
                    var channelClaims = arguments[1];
                    var sharedSecret = arguments[2];
                    return fm.liveswitch.Token.generateClientRegisterToken(client.getApplicationId(), client.getUserId(), client.getDeviceId(), client.getId(), client.getRoles(), channelClaims, sharedSecret);
                }
                else if (arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || (fm.liveswitch.Util.isArray(arguments[1]) && (arguments[1].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[1][0]) || fm.liveswitch.Util.isObjectType(arguments[1][0], '[fm.liveswitch.ChannelClaim]'))))) && (fm.liveswitch.Util.isNullOrUndefined(arguments[3]) || fm.liveswitch.Util.isObjectType(arguments[3], '[fm.liveswitch.DateTime]'))) {
                    var client = arguments[0];
                    var channelClaims = arguments[1];
                    var sharedSecret = arguments[2];
                    var expirationTime = arguments[3];
                    return fm.liveswitch.Token.generateClientRegisterToken(client.getApplicationId(), client.getUserId(), client.getDeviceId(), client.getId(), client.getRoles(), channelClaims, sharedSecret, expirationTime);
                }
                else if (arguments.length == 5 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || (fm.liveswitch.Util.isArray(arguments[1]) && (arguments[1].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[1][0]) || fm.liveswitch.Util.isObjectType(arguments[1][0], '[fm.liveswitch.ChannelClaim]')))))) {
                    var client = arguments[0];
                    var channelClaims = arguments[1];
                    var sharedSecret = arguments[2];
                    var expirationTime = arguments[3];
                    var region = arguments[4];
                    return fm.liveswitch.Token.generateClientRegisterToken(client.getApplicationId(), client.getUserId(), client.getDeviceId(), client.getId(), client.getRoles(), channelClaims, sharedSecret, expirationTime, region);
                }
                else if (arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || (fm.liveswitch.Util.isArray(arguments[1]) && (arguments[1].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[1][0]) || fm.liveswitch.Util.isObjectType(arguments[1][0], '[fm.liveswitch.ChannelClaim]'))))) && (fm.liveswitch.Util.isNullOrUndefined(arguments[3]) || fm.liveswitch.Util.isString(arguments[3]))) {
                    var client = arguments[0];
                    var channelClaims = arguments[1];
                    var sharedSecret = arguments[2];
                    var region = arguments[3];
                    return fm.liveswitch.Token.generateClientRegisterToken(client.getApplicationId(), client.getUserId(), client.getDeviceId(), client.getId(), client.getRoles(), channelClaims, sharedSecret, region);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                    var client = arguments[0];
                    var channelId = arguments[1];
                    var sharedSecret = arguments[2];
                    return fm.liveswitch.Token.generateClientRegisterToken(client.getApplicationId(), client.getUserId(), client.getDeviceId(), client.getId(), client.getRoles(), channelId, sharedSecret);
                }
                else if (arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[3]) || fm.liveswitch.Util.isObjectType(arguments[3], '[fm.liveswitch.DateTime]'))) {
                    var client = arguments[0];
                    var channelId = arguments[1];
                    var sharedSecret = arguments[2];
                    var expirationTime = arguments[3];
                    return fm.liveswitch.Token.generateClientRegisterToken(client.getApplicationId(), client.getUserId(), client.getDeviceId(), client.getId(), client.getRoles(), channelId, sharedSecret, expirationTime);
                }
                else if (arguments.length == 5 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                    var client = arguments[0];
                    var channelId = arguments[1];
                    var sharedSecret = arguments[2];
                    var expirationTime = arguments[3];
                    var region = arguments[4];
                    return fm.liveswitch.Token.generateClientRegisterToken(client.getApplicationId(), client.getUserId(), client.getDeviceId(), client.getId(), client.getRoles(), channelId, sharedSecret, expirationTime, region);
                }
                else if (arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[3]) || fm.liveswitch.Util.isString(arguments[3]))) {
                    var client = arguments[0];
                    var channelId = arguments[1];
                    var sharedSecret = arguments[2];
                    var region = arguments[3];
                    return fm.liveswitch.Token.generateClientRegisterToken(client.getApplicationId(), client.getUserId(), client.getDeviceId(), client.getId(), client.getRoles(), channelId, sharedSecret, region);
                }
                else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || (fm.liveswitch.Util.isArray(arguments[1]) && (arguments[1].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[1][0]) || fm.liveswitch.Util.isString(arguments[1][0])))))) {
                    var client = arguments[0];
                    var channelIds = arguments[1];
                    var sharedSecret = arguments[2];
                    return fm.liveswitch.Token.generateClientRegisterToken(client.getApplicationId(), client.getUserId(), client.getDeviceId(), client.getId(), client.getRoles(), channelIds, sharedSecret);
                }
                else if (arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || (fm.liveswitch.Util.isArray(arguments[1]) && (arguments[1].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[1][0]) || fm.liveswitch.Util.isString(arguments[1][0]))))) && (fm.liveswitch.Util.isNullOrUndefined(arguments[3]) || fm.liveswitch.Util.isObjectType(arguments[3], '[fm.liveswitch.DateTime]'))) {
                    var client = arguments[0];
                    var channelIds = arguments[1];
                    var sharedSecret = arguments[2];
                    var expirationTime = arguments[3];
                    return fm.liveswitch.Token.generateClientRegisterToken(client.getApplicationId(), client.getUserId(), client.getDeviceId(), client.getId(), client.getRoles(), channelIds, sharedSecret, expirationTime);
                }
                else if (arguments.length == 5 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || (fm.liveswitch.Util.isArray(arguments[1]) && (arguments[1].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[1][0]) || fm.liveswitch.Util.isString(arguments[1][0])))))) {
                    var client = arguments[0];
                    var channelIds = arguments[1];
                    var sharedSecret = arguments[2];
                    var expirationTime = arguments[3];
                    var region = arguments[4];
                    return fm.liveswitch.Token.generateClientRegisterToken(client.getApplicationId(), client.getUserId(), client.getDeviceId(), client.getId(), client.getRoles(), channelIds, sharedSecret, expirationTime, region);
                }
                else if (arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || (fm.liveswitch.Util.isArray(arguments[1]) && (arguments[1].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[1][0]) || fm.liveswitch.Util.isString(arguments[1][0]))))) && (fm.liveswitch.Util.isNullOrUndefined(arguments[3]) || fm.liveswitch.Util.isString(arguments[3]))) {
                    var client = arguments[0];
                    var channelIds = arguments[1];
                    var sharedSecret = arguments[2];
                    var region = arguments[3];
                    return fm.liveswitch.Token.generateClientRegisterToken(client.getApplicationId(), client.getUserId(), client.getDeviceId(), client.getId(), client.getRoles(), channelIds, sharedSecret, region);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Token.generateEventToken = function () {
                fm.liveswitch.Token.fmliveswitchTokenInitialize();
                if (arguments.length == 2) {
                    var applicationId = arguments[0];
                    var sharedSecret = arguments[1];
                    return fm.liveswitch.Token.getEventToken(applicationId).sign(sharedSecret);
                }
                else if (arguments.length == 3) {
                    var applicationId = arguments[0];
                    var sharedSecret = arguments[1];
                    var expirationTime = arguments[2];
                    var eventToken = fm.liveswitch.Token.getEventToken(applicationId);
                    eventToken.setExpirationTime(expirationTime);
                    return eventToken.sign(sharedSecret);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Token.getClientJoinToken = function () {
                fm.liveswitch.Token.fmliveswitchTokenInitialize();
                if (arguments.length == 5 && (fm.liveswitch.Util.isNullOrUndefined(arguments[4]) || fm.liveswitch.Util.isObjectType(arguments[4], '[fm.liveswitch.ChannelClaim]'))) {
                    var applicationId = arguments[0];
                    var userId = arguments[1];
                    var deviceId = arguments[2];
                    var clientId = arguments[3];
                    var channelClaim = arguments[4];
                    var token = new fm.liveswitch.Token();
                    token.setType(fm.liveswitch.TokenType.getJoin());
                    token.setApplicationId(applicationId);
                    token.setUserId(userId);
                    token.setDeviceId(deviceId);
                    token.setClientId(clientId);
                    token.setChannelClaims(((fm.liveswitch.Global.equals(channelClaim, null)) ? null : [channelClaim]));
                    return token;
                }
                else if (arguments.length == 5 && (fm.liveswitch.Util.isNullOrUndefined(arguments[4]) || fm.liveswitch.Util.isString(arguments[4]))) {
                    var applicationId = arguments[0];
                    var userId = arguments[1];
                    var deviceId = arguments[2];
                    var clientId = arguments[3];
                    var channelId = arguments[4];
                    return fm.liveswitch.Token.getClientJoinToken(applicationId, userId, deviceId, clientId, ((fm.liveswitch.Global.equals(channelId, null)) ? null : new fm.liveswitch.ChannelClaim(channelId)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            Token.getClientRegisterToken = function () {
                fm.liveswitch.Token.fmliveswitchTokenInitialize();
                if (arguments.length == 6 && (fm.liveswitch.Util.isNullOrUndefined(arguments[5]) || (fm.liveswitch.Util.isArray(arguments[5]) && (arguments[5].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[5][0]) || fm.liveswitch.Util.isObjectType(arguments[5][0], '[fm.liveswitch.ChannelClaim]')))))) {
                    var applicationId = arguments[0];
                    var userId = arguments[1];
                    var deviceId = arguments[2];
                    var clientId = arguments[3];
                    var clientRoles = arguments[4];
                    var channelClaims = arguments[5];
                    var token = new fm.liveswitch.Token();
                    token.setType(fm.liveswitch.TokenType.getRegister());
                    token.setApplicationId(applicationId);
                    token.setUserId(userId);
                    token.setDeviceId(deviceId);
                    token.setClientId(clientId);
                    token.setClientRoles(clientRoles);
                    token.setChannelClaims(channelClaims);
                    return token;
                }
                else if (arguments.length == 6 && (fm.liveswitch.Util.isNullOrUndefined(arguments[5]) || fm.liveswitch.Util.isString(arguments[5]))) {
                    var applicationId = arguments[0];
                    var userId = arguments[1];
                    var deviceId = arguments[2];
                    var clientId = arguments[3];
                    var clientRoles = arguments[4];
                    var channelId = arguments[5];
                    return fm.liveswitch.Token.getClientRegisterToken(applicationId, userId, deviceId, clientId, clientRoles, ((fm.liveswitch.Global.equals(channelId, null)) ? new Array(0) : [new fm.liveswitch.ChannelClaim(channelId)]));
                }
                else if (arguments.length == 6 && (fm.liveswitch.Util.isNullOrUndefined(arguments[5]) || (fm.liveswitch.Util.isArray(arguments[5]) && (arguments[5].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[5][0]) || fm.liveswitch.Util.isString(arguments[5][0])))))) {
                    var applicationId = arguments[0];
                    var userId = arguments[1];
                    var deviceId = arguments[2];
                    var clientId = arguments[3];
                    var clientRoles = arguments[4];
                    var channelIds = arguments[5];
                    var list = new Array();
                    for (var _i = 0, channelIds_1 = channelIds; _i < channelIds_1.length; _i++) {
                        var str = channelIds_1[_i];
                        fm.liveswitch.ArrayExtensions.add(list, new fm.liveswitch.ChannelClaim(str));
                    }
                    return fm.liveswitch.Token.getClientRegisterToken(applicationId, userId, deviceId, clientId, clientRoles, fm.liveswitch.ArrayExtensions.toArray(list));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the default token expiry (120 seconds).
            */
            Token.getDefaultExpiry = function () {
                fm.liveswitch.Token.fmliveswitchTokenInitialize();
                if (arguments.length == 0) {
                    return 120;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.getEventToken = function (applicationId) {
                fm.liveswitch.Token.fmliveswitchTokenInitialize();
                if (arguments.length == 1) {
                    var token = new fm.liveswitch.Token();
                    token.setType(fm.liveswitch.TokenType.getEvent());
                    token.setApplicationId(applicationId);
                    return token;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the HMAC SHA-256 algorithm string.
            */
            Token.getHmacSha256Algorithm = function () {
                fm.liveswitch.Token.fmliveswitchTokenInitialize();
                if (arguments.length == 0) {
                    return "HS256";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the RSA SHA-256 algorithm string.
            */
            Token.getRsaSha256Algorithm = function () {
                fm.liveswitch.Token.fmliveswitchTokenInitialize();
                if (arguments.length == 0) {
                    return "RS256";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.headerFromBase64 = function (headerBase64) {
                fm.liveswitch.Token.fmliveswitchTokenInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.Token.headerFromJson(fm.liveswitch.Utf8.decode(fm.liveswitch.Base64.decode(headerBase64)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.headerFromJson = function (headerJson) {
                fm.liveswitch.Token.fmliveswitchTokenInitialize();
                if (arguments.length == 1) {
                    var dictionary = fm.liveswitch.JsonSerializer.deserializeDictionary(headerJson, function () {
                        return {};
                    }, function (valueJson) {
                        return fm.liveswitch.JsonSerializer.deserializeString(valueJson);
                    });
                    if (!fm.liveswitch.HashExtensions.containsKey(dictionary, "alg")) {
                        throw new fm.liveswitch.Exception("Token header is missing 'alg'.");
                    }
                    if (!fm.liveswitch.HashExtensions.containsKey(dictionary, "typ")) {
                        throw new fm.liveswitch.Exception("Token header is missing 'typ'.");
                    }
                    var str = dictionary["alg"];
                    if (((!fm.liveswitch.Global.equals(str, fm.liveswitch.Token.getHmacSha256Algorithm())) && (!fm.liveswitch.Global.equals(str, fm.liveswitch.Token.getRsaSha256Algorithm())))) {
                        throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Token header contains unrecognized 'alg' ({0}).", str));
                    }
                    var str2 = dictionary["typ"];
                    if ((!fm.liveswitch.Global.equals(str2, "JWT"))) {
                        throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Token header contains unrecognized 'typ' ({0}).", str2));
                    }
                    return str;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.headerToBase64 = function (algorithm) {
                fm.liveswitch.Token.fmliveswitchTokenInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.Base64.encode(fm.liveswitch.Utf8.encode(fm.liveswitch.Token.headerToJson(algorithm)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.headerToJson = function (algorithm) {
                fm.liveswitch.Token.fmliveswitchTokenInitialize();
                if (arguments.length == 1) {
                    var dictionary = {};
                    dictionary["alg"] = algorithm;
                    dictionary["typ"] = "JWT";
                    return fm.liveswitch.JsonSerializer.serializeDictionary(dictionary, function (value) {
                        return fm.liveswitch.JsonSerializer.serializeString(value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Parses a token string.
            @param tokenString The token string.
            @return The token.
            */
            Token.parse = function (tokenString) {
                fm.liveswitch.Token.fmliveswitchTokenInitialize();
                if (arguments.length == 1) {
                    var strArray = fm.liveswitch.StringExtensions.split(tokenString, [46]);
                    if ((!fm.liveswitch.Global.equals(strArray.length, 3))) {
                        fm.liveswitch.Token.fm_liveswitch_Token___log.error("Invalid token.");
                        return null;
                    }
                    var str = fm.liveswitch.Token.headerFromBase64(strArray[0]);
                    var token = fm.liveswitch.Token.payloadFromBase64(strArray[1]);
                    token.setAlgorithm(str);
                    token.__headerBase64 = fm.liveswitch.StringExtensions.replace(fm.liveswitch.StringExtensions.replace(strArray[0], "\r", ""), "\n", "");
                    token.__payloadBase64 = fm.liveswitch.StringExtensions.replace(fm.liveswitch.StringExtensions.replace(strArray[1], "\r", ""), "\n", "");
                    token.__signatureBase64 = strArray[2];
                    return token;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.payloadFromBase64 = function (payloadBase64) {
                fm.liveswitch.Token.fmliveswitchTokenInitialize();
                if (arguments.length == 1) {
                    var input = fm.liveswitch.Base64.decode(payloadBase64);
                    if ((fm.liveswitch.Global.equals(input, null))) {
                        throw new fm.liveswitch.Exception("Unable to decode base64.");
                    }
                    return fm.liveswitch.Token.payloadFromJson(fm.liveswitch.Utf8.decode(input));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.payloadFromJson = function (payloadJson) {
                fm.liveswitch.Token.fmliveswitchTokenInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(payloadJson, function () {
                        return new fm.liveswitch.Token();
                    }, function (obj, key, valueJson) {
                        var _var0 = key;
                        if (_var0 == "iat") {
                            do {
                                var nullable = fm.liveswitch.JsonSerializer.deserializeLong(valueJson);
                                if (!(nullable != null)) {
                                    obj.setIssuedAt(new fm.liveswitch.DateTime(0));
                                    break;
                                }
                                obj.setIssuedAt(fm.liveswitch.UnixTimestamp.unixToDateTime(nullable));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "exp") {
                            do {
                                var nullable2 = fm.liveswitch.JsonSerializer.deserializeLong(valueJson);
                                if ((nullable2 != null)) {
                                    obj.setExpirationTime(fm.liveswitch.UnixTimestamp.unixToDateTime(nullable2));
                                }
                                break;
                            } while (false);
                        }
                        else if (_var0 == "type") {
                            do {
                                obj.setType(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "connectorId") {
                            do {
                                obj.setConnectorId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "mediaServerId") {
                            do {
                                obj.setMediaServerId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "applicationId") {
                            do {
                                obj.setApplicationId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "userId") {
                            do {
                                obj.setUserId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "deviceId") {
                            do {
                                obj.setDeviceId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "region") {
                            do {
                                obj.setRegion(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "clientId") {
                            do {
                                obj.setClientId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "clientRoles") {
                            do {
                                obj.setClientRoles(fm.liveswitch.JsonSerializer.deserializeStringArray(valueJson));
                                break;
                            } while (false);
                        }
                        else if (_var0 == "channels") {
                            do {
                                obj.setChannelClaims(fm.liveswitch.ChannelClaim.fromJsonArray(valueJson));
                                break;
                            } while (false);
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.payloadToBase64 = function (token) {
                fm.liveswitch.Token.fmliveswitchTokenInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.Base64.encode(fm.liveswitch.Utf8.encode(fm.liveswitch.Token.payloadToJson(token)));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.payloadToJson = function (token) {
                fm.liveswitch.Token.fmliveswitchTokenInitialize();
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(token, function (obj, jsonObject) {
                        jsonObject["iat"] = fm.liveswitch.JsonSerializer.serializeLong(fm.liveswitch.UnixTimestamp.dateTimeToUnix(token.getIssuedAt()));
                        if ((token.getExpirationTime() != null)) {
                            jsonObject["exp"] = fm.liveswitch.JsonSerializer.serializeLong(fm.liveswitch.UnixTimestamp.dateTimeToUnix(token.getExpirationTime()));
                        }
                        if ((!fm.liveswitch.Global.equals(token.getType(), null))) {
                            jsonObject["type"] = fm.liveswitch.JsonSerializer.serializeString(token.getType());
                        }
                        if ((!fm.liveswitch.Global.equals(token.getConnectorId(), null))) {
                            jsonObject["connectorId"] = fm.liveswitch.JsonSerializer.serializeString(token.getConnectorId());
                        }
                        if ((!fm.liveswitch.Global.equals(token.getMediaServerId(), null))) {
                            jsonObject["mediaServerId"] = fm.liveswitch.JsonSerializer.serializeString(token.getMediaServerId());
                        }
                        if ((!fm.liveswitch.Global.equals(token.getApplicationId(), null))) {
                            jsonObject["applicationId"] = fm.liveswitch.JsonSerializer.serializeString(token.getApplicationId());
                        }
                        if ((!fm.liveswitch.Global.equals(token.getUserId(), null))) {
                            jsonObject["userId"] = fm.liveswitch.JsonSerializer.serializeString(token.getUserId());
                        }
                        if ((!fm.liveswitch.Global.equals(token.getDeviceId(), null))) {
                            jsonObject["deviceId"] = fm.liveswitch.JsonSerializer.serializeString(token.getDeviceId());
                        }
                        if ((!fm.liveswitch.Global.equals(token.getClientId(), null))) {
                            jsonObject["clientId"] = fm.liveswitch.JsonSerializer.serializeString(token.getClientId());
                        }
                        if ((!fm.liveswitch.Global.equals(token.getRegion(), null))) {
                            jsonObject["region"] = fm.liveswitch.JsonSerializer.serializeString(token.getRegion());
                        }
                        if ((!fm.liveswitch.Global.equals(token.getClientRoles(), null))) {
                            jsonObject["clientRoles"] = fm.liveswitch.JsonSerializer.serializeStringArray(token.getClientRoles());
                        }
                        if ((!fm.liveswitch.Global.equals(token.getChannelClaims(), null))) {
                            jsonObject["channels"] = fm.liveswitch.ChannelClaim.toJsonArray(token.getChannelClaims());
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Parses a token and verifies its signature.
            @param tokenString The token string.
            @param sharedSecret The shared secret.
            @return `true` if the token string could be parsed and the signature is valid; otherwise, `false`
            */
            Token.verify = function (tokenString, sharedSecret) {
                fm.liveswitch.Token.fmliveswitchTokenInitialize();
                if (arguments.length == 2) {
                    var token = fm.liveswitch.Token.parse(tokenString);
                    if ((fm.liveswitch.Global.equals(token, null))) {
                        return false;
                    }
                    return token.verify(sharedSecret);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.prototype.computeSignature = function (headerBase64, payloadBase64, sharedSecret) {
                if (arguments.length == 3) {
                    return fm.liveswitch.MacContextBase.compute(fm.liveswitch.MacType.HmacSha256, fm.liveswitch.DataBuffer.wrap(fm.liveswitch.Utf8.encode(sharedSecret)), fm.liveswitch.DataBuffer.wrap(fm.liveswitch.Utf8.encode(fm.liveswitch.StringExtensions.format("{0}.{1}", headerBase64, payloadBase64))));
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the algorithm.
            */
            Token.prototype.getAlgorithm = function () {
                if (arguments.length == 0) {
                    return this._algorithm;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the application identifier.
            */
            Token.prototype.getApplicationId = function () {
                if (arguments.length == 0) {
                    return this._applicationId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the first channel claim.
            */
            Token.prototype.getChannelClaim = function () {
                if (arguments.length == 0) {
                    var channelClaims = this.getChannelClaims();
                    if (((fm.liveswitch.Global.equals(channelClaims, null)) || (fm.liveswitch.Global.equals(channelClaims.length, 0)))) {
                        return null;
                    }
                    return channelClaims[0];
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets an array of channel claims.
            */
            Token.prototype.getChannelClaims = function () {
                if (arguments.length == 0) {
                    return this._channelClaims;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client identifier.
            */
            Token.prototype.getClientId = function () {
                if (arguments.length == 0) {
                    return this._clientId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client roles.
            */
            Token.prototype.getClientRoles = function () {
                if (arguments.length == 0) {
                    return this._clientRoles;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connector identifier.
            */
            Token.prototype.getConnectorId = function () {
                if (arguments.length == 0) {
                    return this._connectorId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the device identifier.
            */
            Token.prototype.getDeviceId = function () {
                if (arguments.length == 0) {
                    return this._deviceId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "expires at" date/time.
            */
            Token.prototype.getExpirationTime = function () {
                if (arguments.length == 0) {
                    return this._expirationTime;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "issued at" date/time.
            */
            Token.prototype.getIssuedAt = function () {
                if (arguments.length == 0) {
                    return this._issuedAt;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the media server identifier.
            */
            Token.prototype.getMediaServerId = function () {
                if (arguments.length == 0) {
                    return this._mediaServerId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the region.
            */
            Token.prototype.getRegion = function () {
                if (arguments.length == 0) {
                    return this._region;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the type.
            */
            Token.prototype.getType = function () {
                if (arguments.length == 0) {
                    return this._type;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the user identifier.
            */
            Token.prototype.getUserId = function () {
                if (arguments.length == 0) {
                    return this._userId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.prototype.headerToBase64 = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Token.headerToBase64(this.getAlgorithm());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.prototype.headerToJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Token.headerToJson(this.getAlgorithm());
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.prototype.payloadToBase64 = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Token.payloadToBase64(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.prototype.payloadToJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.Token.payloadToJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.prototype.setAlgorithm = function (value) {
                if (arguments.length == 1) {
                    this._algorithm = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.prototype.setApplicationId = function (value) {
                if (arguments.length == 1) {
                    this._applicationId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.prototype.setChannelClaims = function (value) {
                if (arguments.length == 1) {
                    this._channelClaims = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.prototype.setClientId = function (value) {
                if (arguments.length == 1) {
                    this._clientId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.prototype.setClientRoles = function (value) {
                if (arguments.length == 1) {
                    this._clientRoles = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.prototype.setConnectorId = function (value) {
                if (arguments.length == 1) {
                    this._connectorId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.prototype.setDeviceId = function (value) {
                if (arguments.length == 1) {
                    this._deviceId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.prototype.setExpirationTime = function (value) {
                if (arguments.length == 1) {
                    this._expirationTime = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.prototype.setIssuedAt = function (value) {
                if (arguments.length == 1) {
                    this._issuedAt = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.prototype.setMediaServerId = function (value) {
                if (arguments.length == 1) {
                    this._mediaServerId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.prototype.setRegion = function (value) {
                if (arguments.length == 1) {
                    this._region = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.prototype.setType = function (value) {
                if (arguments.length == 1) {
                    this._type = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.prototype.setUserId = function (value) {
                if (arguments.length == 1) {
                    this._userId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.prototype.sign = function (sharedSecret) {
                if (arguments.length == 1) {
                    this.setAlgorithm(fm.liveswitch.Token.getHmacSha256Algorithm());
                    var str = this.headerToBase64();
                    var str2 = this.payloadToBase64();
                    var str3 = this.signBase64(str, str2, sharedSecret);
                    return fm.liveswitch.StringExtensions.format("{0}.{1}.{2}", str, str2, str3);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.prototype.signBase64 = function (headerBase64, payloadBase64, sharedSecret) {
                if (arguments.length == 3) {
                    return fm.liveswitch.StringExtensions.trimEnd(fm.liveswitch.Base64.encodeBuffer(this.computeSignature(headerBase64, payloadBase64, sharedSecret)), [61]);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Verifies the token signature.
            @param sharedSecret The shared secret.
            @return `true` if the signature is valid; otherwise, `false`.
                
            */
            Token.prototype.verify = function (sharedSecret) {
                if (arguments.length == 1) {
                    if ((!fm.liveswitch.Global.equals(this.getAlgorithm(), fm.liveswitch.Token.getHmacSha256Algorithm()))) {
                        fm.liveswitch.Token.fm_liveswitch_Token___log.error("Cannot verify an RS256 token with a shared secret.");
                        return false;
                    }
                    return this.verifyBase64(this.__signatureBase64, this.__headerBase64, this.__payloadBase64, sharedSecret);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.prototype.verifyBase64 = function (signatureBase64, headerBase64, payloadBase64, sharedSecret) {
                if (arguments.length == 4) {
                    var buffer = fm.liveswitch.Base64.decode(signatureBase64);
                    var buffer2 = this.computeSignature(headerBase64, payloadBase64, sharedSecret);
                    for (var i = 0; (i < buffer.length); i++) {
                        if ((!fm.liveswitch.Global.equals(buffer[i], buffer2.read8(i)))) {
                            return false;
                        }
                    }
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            Token.fmliveswitchTokenInitialize = function () {
                if (!fm.liveswitch.Token.__fmliveswitchTokenInitialized && !fm.liveswitch.Token.__fmliveswitchTokenInitializing) {
                    fm.liveswitch.Token.__fmliveswitchTokenInitializing = true;
                    fm.liveswitch.Token.fm_liveswitch_Token___log = fm.liveswitch.Log.getLogger(new fm.liveswitch.Type('[fm.liveswitch.Token]'));
                    fm.liveswitch.Token.__fmliveswitchTokenInitialized = true;
                    fm.liveswitch.Token.__fmliveswitchTokenInitializing = false;
                }
            };
            /** @hidden */
            Token.__fmliveswitchTokenInitialized = false;
            /** @hidden */
            Token.__fmliveswitchTokenInitializing = false;
            return Token;
        }());
        liveswitch.Token = Token;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A claim action.
        */
        var ClaimAction = /** @class */ (function () {
            function ClaimAction() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            ClaimAction.prototype.getTypeString = function () {
                return '[fm.liveswitch.ClaimAction]';
            };
            /**
            Gets the "claim" claim action string.
            */
            ClaimAction.Claim = "claim";
            /**
            Gets the "drop" claim action string.
            */
            ClaimAction.Drop = "drop";
            /**
            Gets the "join" claim action string.
            */
            ClaimAction.Join = "join";
            return ClaimAction;
        }());
        liveswitch.ClaimAction = ClaimAction;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A token type.
        */
        var TokenType = /** @class */ (function () {
            function TokenType() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            TokenType.prototype.getTypeString = function () {
                return '[fm.liveswitch.TokenType]';
            };
            /**
            Gets the "event" token type string.
            */
            TokenType.getEvent = function () {
                if (arguments.length == 0) {
                    return "event";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "join" token type string.
            */
            TokenType.getJoin = function () {
                if (arguments.length == 0) {
                    return "join";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the "register" token type string.
            */
            TokenType.getRegister = function () {
                if (arguments.length == 0) {
                    return "register";
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return TokenType;
        }());
        liveswitch.TokenType = TokenType;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Report.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Transport report.
        */
        var TransportReport = /** @class */ (function (_super) {
            __extends(TransportReport, _super);
            function TransportReport() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchTransportReportInit();
                }
                else if (__arguments.length == 2) {
                    var stats = __arguments[0];
                    var lastStats = __arguments[1];
                    _this = _super.call(this) || this;
                    _this.fmliveswitchTransportReportInit();
                    var flag = (fm.liveswitch.Global.equals(lastStats, null));
                    _this.setBytesReceived(fm.liveswitch.Report.processLong(stats.getBytesReceived(), (flag ? 0 : lastStats.getBytesReceived())));
                    _this.setBytesSent(fm.liveswitch.Report.processLong(stats.getBytesSent(), (flag ? 0 : lastStats.getBytesSent())));
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            TransportReport.prototype.getTypeString = function () {
                return '[fm.liveswitch.TransportReport]' + ',' + _super.prototype.getTypeString.call(this);
            };
            TransportReport.prototype.fmliveswitchTransportReportInit = function () {
                this._bytesReceived = 0;
                this._bytesSent = 0;
            };
            /**
            Deserializes Json to a TransportReport.
            @param transportReportJson The serialized Json.
            @return The deserialized TransportReport.
            */
            TransportReport.fromJson = function (transportReportJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(transportReportJson, function () {
                        return new fm.liveswitch.TransportReport();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to Json.
            @param transportReport The instance to serialize.
            @return Serialized Json.
            */
            TransportReport.toJson = function (transportReport) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(transportReport, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            TransportReport.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "bytesSent"))) {
                            if ((fm.liveswitch.Global.equals(str, "bytesReceived"))) {
                                this.setBytesReceived(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                            }
                        }
                        else {
                            this.setBytesSent(fm.liveswitch.JsonSerializer.deserializeLong(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes received on this transport.
            */
            TransportReport.prototype.getBytesReceived = function () {
                if (arguments.length == 0) {
                    return this._bytesReceived;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the number of bytes sent on this transport.
            */
            TransportReport.prototype.getBytesSent = function () {
                if (arguments.length == 0) {
                    return this._bytesSent;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            TransportReport.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((this.getBytesReceived() != null)) {
                        jsonObject["bytesReceived"] = fm.liveswitch.JsonSerializer.serializeLong(this.getBytesReceived());
                    }
                    if ((this.getBytesSent() != null)) {
                        jsonObject["bytesSent"] = fm.liveswitch.JsonSerializer.serializeLong(this.getBytesSent());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of bytes received on this transport.
            */
            TransportReport.prototype.setBytesReceived = function (value) {
                if (arguments.length == 1) {
                    this._bytesReceived = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the number of bytes sent on this transport.
            */
            TransportReport.prototype.setBytesSent = function (value) {
                if (arguments.length == 1) {
                    this._bytesSent = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to Json.
            */
            TransportReport.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.TransportReport.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return TransportReport;
        }(fm.liveswitch.Report));
        liveswitch.TransportReport = TransportReport;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A description of the layout within a mixed video view.
        */
        var VideoLayout = /** @class */ (function () {
            function VideoLayout() {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    //super();
                    this.fmliveswitchVideoLayoutInit();
                }
                else if (__arguments.length == 2) {
                    var width = __arguments[0];
                    var height = __arguments[1];
                    // chained constructor: VideoLayout.call(this, width, height, null, null);
                    __arguments = new Array(4);
                    __arguments[0] = width;
                    __arguments[1] = height;
                    __arguments[2] = null;
                    __arguments[3] = null;
                    {
                        var width_1 = __arguments[0];
                        var height_1 = __arguments[1];
                        var frames_6 = __arguments[2];
                        var bounds = __arguments[3];
                        // chained constructor: VideoLayout.call(this, width, height, frames, bounds, false);
                        __arguments = new Array(5);
                        __arguments[0] = width_1;
                        __arguments[1] = height_1;
                        __arguments[2] = frames_6;
                        __arguments[3] = bounds;
                        __arguments[4] = false;
                        {
                            var width_2 = __arguments[0];
                            var height_2 = __arguments[1];
                            var frames_7 = __arguments[2];
                            var bounds_1 = __arguments[3];
                            var crop = __arguments[4];
                            //super();
                            this.fmliveswitchVideoLayoutInit();
                            this.setWidth(width_2);
                            this.setHeight(height_2);
                            this.setFrames(frames_7 || {});
                            this.setBounds(bounds_1 || {});
                            this.setCrop(crop);
                        }
                    }
                }
                else if (__arguments.length == 3) {
                    var width = __arguments[0];
                    var height = __arguments[1];
                    var crop = __arguments[2];
                    // chained constructor: VideoLayout.call(this, width, height, null, null, crop);
                    __arguments = new Array(5);
                    __arguments[0] = width;
                    __arguments[1] = height;
                    __arguments[2] = null;
                    __arguments[3] = null;
                    __arguments[4] = crop;
                    {
                        var width_3 = __arguments[0];
                        var height_3 = __arguments[1];
                        var frames_8 = __arguments[2];
                        var bounds = __arguments[3];
                        var crop_1 = __arguments[4];
                        //super();
                        this.fmliveswitchVideoLayoutInit();
                        this.setWidth(width_3);
                        this.setHeight(height_3);
                        this.setFrames(frames_8 || {});
                        this.setBounds(bounds || {});
                        this.setCrop(crop_1);
                    }
                }
                else if (__arguments.length == 4) {
                    var width = __arguments[0];
                    var height = __arguments[1];
                    var frames_9 = __arguments[2];
                    var bounds = __arguments[3];
                    // chained constructor: VideoLayout.call(this, width, height, frames, bounds, false);
                    __arguments = new Array(5);
                    __arguments[0] = width;
                    __arguments[1] = height;
                    __arguments[2] = frames_9;
                    __arguments[3] = bounds;
                    __arguments[4] = false;
                    {
                        var width_4 = __arguments[0];
                        var height_4 = __arguments[1];
                        var frames_10 = __arguments[2];
                        var bounds_2 = __arguments[3];
                        var crop = __arguments[4];
                        //super();
                        this.fmliveswitchVideoLayoutInit();
                        this.setWidth(width_4);
                        this.setHeight(height_4);
                        this.setFrames(frames_10 || {});
                        this.setBounds(bounds_2 || {});
                        this.setCrop(crop);
                    }
                }
                else if (__arguments.length == 5) {
                    var width = __arguments[0];
                    var height = __arguments[1];
                    var frames_11 = __arguments[2];
                    var bounds = __arguments[3];
                    var crop = __arguments[4];
                    //super();
                    this.fmliveswitchVideoLayoutInit();
                    this.setWidth(width);
                    this.setHeight(height);
                    this.setFrames(frames_11 || {});
                    this.setBounds(bounds || {});
                    this.setCrop(crop);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            VideoLayout.prototype.getTypeString = function () {
                return '[fm.liveswitch.VideoLayout]';
            };
            VideoLayout.prototype.fmliveswitchVideoLayoutInit = function () {
                this._crop = false;
                this._height = 0;
                this._width = 0;
            };
            /** @hidden */
            VideoLayout.createLayoutFrameDictionary = function () {
                if (arguments.length == 0) {
                    return {};
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes a view from JSON.
            @param videoLayoutJson The layout JSON.
            */
            VideoLayout.fromJson = function (videoLayoutJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(videoLayoutJson, function () {
                        return new fm.liveswitch.VideoLayout();
                    }, function (videoLayout, key, valueJson) {
                        var str = key;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            if (!(fm.liveswitch.Global.equals(str, "w"))) {
                                if ((fm.liveswitch.Global.equals(str, "h"))) {
                                    videoLayout.setHeight(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "f"))) {
                                        videoLayout.setFrames(fm.liveswitch.JsonSerializer.deserializeDictionary(valueJson, fm.liveswitch.VideoLayout.createLayoutFrameDictionary.bind(fm.liveswitch.VideoLayout), fm.liveswitch.LayoutFrame.fromJson.bind(fm.liveswitch.LayoutFrame)));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "b"))) {
                                            videoLayout.setBounds(fm.liveswitch.JsonSerializer.deserializeDictionary(valueJson, fm.liveswitch.VideoLayout.createLayoutFrameDictionary.bind(fm.liveswitch.VideoLayout), fm.liveswitch.LayoutFrame.fromJson.bind(fm.liveswitch.LayoutFrame)));
                                        }
                                        else {
                                            if ((fm.liveswitch.Global.equals(str, "c"))) {
                                                videoLayout.setCrop(fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson));
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                videoLayout.setWidth(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            }
                        }
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes a view to JSON.
            @param videoLayout The layout.
            */
            VideoLayout.toJson = function (videoLayout) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(videoLayout, function (vl, jsonObject) {
                        jsonObject["w"] = fm.liveswitch.JsonSerializer.serializeInteger(vl.getWidth());
                        jsonObject["h"] = fm.liveswitch.JsonSerializer.serializeInteger(vl.getHeight());
                        jsonObject["f"] = fm.liveswitch.JsonSerializer.serializeDictionary(vl.getFrames(), fm.liveswitch.LayoutFrame.toJson.bind(fm.liveswitch.LayoutFrame));
                        jsonObject["b"] = fm.liveswitch.JsonSerializer.serializeDictionary(vl.getBounds(), fm.liveswitch.LayoutFrame.toJson.bind(fm.liveswitch.LayoutFrame));
                        jsonObject["c"] = fm.liveswitch.JsonSerializer.serializeBoolean(vl.getCrop());
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the bounds, keyed by connection ID.
            */
            VideoLayout.prototype.getBounds = function () {
                if (arguments.length == 0) {
                    return this._bounds;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoLayout.prototype.getClientKey = function (userId, deviceId, clientId) {
                if (arguments.length == 3) {
                    return fm.liveswitch.StringExtensions.format("/u/{0}/d/{1}/c/{2}", userId, deviceId, clientId);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets whether to crop.
            */
            VideoLayout.prototype.getCrop = function () {
                if (arguments.length == 0) {
                    return this._crop;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the frames, keyed by connection ID.
            */
            VideoLayout.prototype.getFrames = function () {
                if (arguments.length == 0) {
                    return this._frames;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the video height.
            */
            VideoLayout.prototype.getHeight = function () {
                if (arguments.length == 0) {
                    return this._height;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the regions within the layout where each region has a frame, bounds, and client/connection information. connection
            */
            VideoLayout.prototype.getRegions = function () {
                if (arguments.length == 0) {
                    return this._regions;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the video width.
            */
            VideoLayout.prototype.getWidth = function () {
                if (arguments.length == 0) {
                    return this._width;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoLayout.prototype.inflate = function (channel, localClientInfo, remoteConnectionInfos) {
                if (arguments.length == 3) {
                    var dictionary = {};
                    for (var _i = 0, remoteConnectionInfos_2 = remoteConnectionInfos; _i < remoteConnectionInfos_2.length; _i++) {
                        var info = remoteConnectionInfos_2[_i];
                        dictionary[info.getId()] = info;
                    }
                    var list = new Array();
                    for (var _a = 0, _b = fm.liveswitch.HashExtensions.getKeys(this.getFrames()); _a < _b.length; _a++) {
                        var str = _b[_a];
                        var frame = this.getFrames()[str];
                        var bounds = this.getBounds()[str];
                        var userId = frame.getUserId();
                        var deviceId = frame.getDeviceId();
                        var clientId = frame.getClientId();
                        var userAlias = null;
                        var deviceAlias = null;
                        var clientTag = null;
                        var clientRoles = new Array(0);
                        var connectionTag = null;
                        var info2 = null;
                        var _var0 = new fm.liveswitch.Holder(info2);
                        var _var1 = fm.liveswitch.HashExtensions.tryGetValue(dictionary, str, _var0);
                        info2 = _var0.getValue();
                        if (_var1) {
                            userId = info2.getUserId();
                            userAlias = info2.getUserAlias();
                            deviceId = info2.getDeviceId();
                            deviceAlias = info2.getDeviceAlias();
                            clientId = info2.getClientId();
                            clientTag = info2.getClientTag();
                            clientRoles = info2.getClientRoles();
                            connectionTag = info2.getTag();
                        }
                        else {
                            if ((((fm.liveswitch.Global.equals(localClientInfo.getUserId(), frame.getUserId())) && (fm.liveswitch.Global.equals(localClientInfo.getDeviceId(), frame.getDeviceId()))) && (fm.liveswitch.Global.equals(localClientInfo.getId(), frame.getClientId())))) {
                                userId = localClientInfo.getUserId();
                                userAlias = localClientInfo.getUserAlias();
                                deviceId = localClientInfo.getDeviceId();
                                deviceAlias = localClientInfo.getDeviceAlias();
                                clientId = localClientInfo.getId();
                                clientTag = localClientInfo.getTag();
                                clientRoles = localClientInfo.getRoles();
                                connectionTag = null;
                            }
                            else {
                                return false;
                            }
                        }
                        bounds.setUserId(userId);
                        bounds.setDeviceId(deviceId);
                        bounds.setClientId(clientId);
                        fm.liveswitch.ArrayExtensions.add(list, new fm.liveswitch.VideoLayoutRegion(frame, bounds, userId, userAlias, deviceId, deviceAlias, clientId, clientTag, clientRoles, str, connectionTag));
                    }
                    this.setRegions(fm.liveswitch.ArrayExtensions.toArray(list));
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Determines whether the specified video layout is equivalent.
            @param videoLayout The video layout.
            */
            VideoLayout.prototype.isEquivalent = function (videoLayout) {
                if (arguments.length == 1) {
                    if (((((!fm.liveswitch.Global.equals(this.getWidth(), videoLayout.getWidth())) || (!fm.liveswitch.Global.equals(this.getHeight(), videoLayout.getHeight()))) || ((!fm.liveswitch.Global.equals(this.getCrop(), videoLayout.getCrop())) || (!fm.liveswitch.Global.equals(fm.liveswitch.HashExtensions.getCount(this.getFrames()), fm.liveswitch.HashExtensions.getCount(videoLayout.getFrames()))))) || (!fm.liveswitch.Global.equals(fm.liveswitch.HashExtensions.getCount(this.getBounds()), fm.liveswitch.HashExtensions.getCount(videoLayout.getBounds()))))) {
                        return false;
                    }
                    for (var _i = 0, _a = fm.liveswitch.HashExtensions.getKeys(this.getFrames()); _i < _a.length; _i++) {
                        var str = _a[_i];
                        var frame = null;
                        var _var0 = new fm.liveswitch.Holder(frame);
                        var _var1 = fm.liveswitch.HashExtensions.tryGetValue(videoLayout.getFrames(), str, _var0);
                        frame = _var0.getValue();
                        if (!_var1) {
                            return false;
                        }
                        if (!this.getFrames()[str].isEquivalent(frame)) {
                            return false;
                        }
                    }
                    for (var _b = 0, _c = fm.liveswitch.HashExtensions.getKeys(this.getBounds()); _b < _c.length; _b++) {
                        var str = _c[_b];
                        var frame2 = null;
                        var _var2 = new fm.liveswitch.Holder(frame2);
                        var _var3 = fm.liveswitch.HashExtensions.tryGetValue(videoLayout.getBounds(), str, _var2);
                        frame2 = _var2.getValue();
                        if (!_var3) {
                            return false;
                        }
                        if (!this.getBounds()[str].isEquivalent(frame2)) {
                            return false;
                        }
                    }
                    return true;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoLayout.prototype.setBounds = function (value) {
                if (arguments.length == 1) {
                    this._bounds = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoLayout.prototype.setCrop = function (value) {
                if (arguments.length == 1) {
                    this._crop = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoLayout.prototype.setFrames = function (value) {
                if (arguments.length == 1) {
                    this._frames = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoLayout.prototype.setHeight = function (value) {
                if (arguments.length == 1) {
                    this._height = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoLayout.prototype.setRegions = function (value) {
                if (arguments.length == 1) {
                    this._regions = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoLayout.prototype.setWidth = function (value) {
                if (arguments.length == 1) {
                    this._width = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to JSON.
            */
            VideoLayout.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.VideoLayout.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return VideoLayout;
        }());
        liveswitch.VideoLayout = VideoLayout;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        A video layout region.
        */
        var VideoLayoutRegion = /** @class */ (function () {
            /**
            Initializes a new instance of the [[fm.liveswitch.videoLayoutRegion]] class.
            @param frame The frame.
            @param bounds The bounds.
            @param userId The user identifier.
            @param userAlias The user alias.
            @param deviceId The device identifier.
            @param deviceAlias The device alias.
            @param clientId The client identifier.
            @param clientTag The client tag.
            @param clientRoles The client roles.
            @param connectionId The connection identifier.
            @param connectionTag The connection tag.
            */
            function VideoLayoutRegion(frame, bounds, userId, userAlias, deviceId, deviceAlias, clientId, clientTag, clientRoles, connectionId, connectionTag) {
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 11) {
                    var frame_2 = __arguments[0];
                    var bounds_3 = __arguments[1];
                    var userId_22 = __arguments[2];
                    var userAlias_4 = __arguments[3];
                    var deviceId_19 = __arguments[4];
                    var deviceAlias_4 = __arguments[5];
                    var clientId_13 = __arguments[6];
                    var clientTag_2 = __arguments[7];
                    var clientRoles_2 = __arguments[8];
                    var connectionId_1 = __arguments[9];
                    var connectionTag_2 = __arguments[10];
                    //super();
                    this.setFrame(frame_2);
                    this.setBounds(bounds_3);
                    this.setUserId(userId_22);
                    this.setUserAlias(userAlias_4);
                    this.setDeviceId(deviceId_19);
                    this.setDeviceAlias(deviceAlias_4);
                    this.setClientId(clientId_13);
                    this.setClientTag(clientTag_2);
                    this.setClientRoles(clientRoles_2);
                    this.setConnectionId(connectionId_1);
                    this.setConnectionTag(connectionTag_2);
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
            }
            VideoLayoutRegion.prototype.getTypeString = function () {
                return '[fm.liveswitch.VideoLayoutRegion]';
            };
            /**
            Gets the bounds.
            */
            VideoLayoutRegion.prototype.getBounds = function () {
                if (arguments.length == 0) {
                    return this._bounds;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client identifier.
            */
            VideoLayoutRegion.prototype.getClientId = function () {
                if (arguments.length == 0) {
                    return this._clientId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client roles.
            */
            VideoLayoutRegion.prototype.getClientRoles = function () {
                if (arguments.length == 0) {
                    return this._clientRoles;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the client tag.
            */
            VideoLayoutRegion.prototype.getClientTag = function () {
                if (arguments.length == 0) {
                    return this._clientTag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connection identifier.
            */
            VideoLayoutRegion.prototype.getConnectionId = function () {
                if (arguments.length == 0) {
                    return this._connectionId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the connection tag.
            */
            VideoLayoutRegion.prototype.getConnectionTag = function () {
                if (arguments.length == 0) {
                    return this._connectionTag;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the device alias.
            */
            VideoLayoutRegion.prototype.getDeviceAlias = function () {
                if (arguments.length == 0) {
                    return this._deviceAlias;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the device identifier.
            */
            VideoLayoutRegion.prototype.getDeviceId = function () {
                if (arguments.length == 0) {
                    return this._deviceId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the frame.
            */
            VideoLayoutRegion.prototype.getFrame = function () {
                if (arguments.length == 0) {
                    return this._frame;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the user alias.
            */
            VideoLayoutRegion.prototype.getUserAlias = function () {
                if (arguments.length == 0) {
                    return this._userAlias;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the user identifier.
            */
            VideoLayoutRegion.prototype.getUserId = function () {
                if (arguments.length == 0) {
                    return this._userId;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoLayoutRegion.prototype.setBounds = function (value) {
                if (arguments.length == 1) {
                    this._bounds = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoLayoutRegion.prototype.setClientId = function (value) {
                if (arguments.length == 1) {
                    this._clientId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoLayoutRegion.prototype.setClientRoles = function (value) {
                if (arguments.length == 1) {
                    this._clientRoles = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoLayoutRegion.prototype.setClientTag = function (value) {
                if (arguments.length == 1) {
                    this._clientTag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoLayoutRegion.prototype.setConnectionId = function (value) {
                if (arguments.length == 1) {
                    this._connectionId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoLayoutRegion.prototype.setConnectionTag = function (value) {
                if (arguments.length == 1) {
                    this._connectionTag = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoLayoutRegion.prototype.setDeviceAlias = function (value) {
                if (arguments.length == 1) {
                    this._deviceAlias = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoLayoutRegion.prototype.setDeviceId = function (value) {
                if (arguments.length == 1) {
                    this._deviceId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoLayoutRegion.prototype.setFrame = function (value) {
                if (arguments.length == 1) {
                    this._frame = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoLayoutRegion.prototype.setUserAlias = function (value) {
                if (arguments.length == 1) {
                    this._userAlias = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /** @hidden */
            VideoLayoutRegion.prototype.setUserId = function (value) {
                if (arguments.length == 1) {
                    this._userId = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return VideoLayoutRegion;
        }());
        liveswitch.VideoLayoutRegion = VideoLayoutRegion;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Info.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        /**
        Webhook information.
        */
        var WebhookInfo = /** @class */ (function (_super) {
            __extends(WebhookInfo, _super);
            function WebhookInfo() {
                var _this = this;
                var __arguments = new Array(arguments.length);
                for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                    __arguments[__argumentIndex] = arguments[__argumentIndex];
                }
                if (__arguments.length == 0) {
                    _this = _super.call(this) || this;
                    _this.fmliveswitchWebhookInfoInit();
                }
                else {
                    throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                }
                return _this;
            }
            WebhookInfo.prototype.getTypeString = function () {
                return '[fm.liveswitch.WebhookInfo]' + ',' + _super.prototype.getTypeString.call(this);
            };
            WebhookInfo.prototype.fmliveswitchWebhookInfoInit = function () {
                this._result = 0;
            };
            /**
            Deserializes Json to a WebhookInfo.
            @param webhookInfoJson The serialized Json.
            @return The deserialized WebhookInfo.
            */
            WebhookInfo.fromJson = function (webhookInfoJson) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.deserializeObject(webhookInfoJson, function () {
                        return new fm.liveswitch.WebhookInfo();
                    }, function (info, key, value) {
                        info.deserializeProperties(key, value);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes an instance to Json.
            @param webhookInfo The instance to serialize.
            @return Serialized Json.
            */
            WebhookInfo.toJson = function (webhookInfo) {
                if (arguments.length == 1) {
                    return fm.liveswitch.JsonSerializer.serializeObject(webhookInfo, function (info, dict) {
                        info.serializeProperties(dict);
                    });
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Deserializes the properties.
            @param key The key.
            @param valueJson The value in JSON format.
            */
            WebhookInfo.prototype.deserializeProperties = function (key, valueJson) {
                if (arguments.length == 2) {
                    _super.prototype.deserializeProperties.call(this, key, valueJson);
                    var str = key;
                    if ((!fm.liveswitch.Global.equals(str, null))) {
                        if (!(fm.liveswitch.Global.equals(str, "url"))) {
                            if ((fm.liveswitch.Global.equals(str, "result"))) {
                                this.setResult(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                            }
                        }
                        else {
                            this.setUrl(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                        }
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the webhook result.
            */
            WebhookInfo.prototype.getResult = function () {
                if (arguments.length == 0) {
                    return this._result;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Gets the webhook URL.
            */
            WebhookInfo.prototype.getUrl = function () {
                if (arguments.length == 0) {
                    return this._url;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes the properties.
            @param jsonObject The JSON object.
            */
            WebhookInfo.prototype.serializeProperties = function (jsonObject) {
                if (arguments.length == 1) {
                    _super.prototype.serializeProperties.call(this, jsonObject);
                    if ((!fm.liveswitch.Global.equals(this.getUrl(), null))) {
                        jsonObject["url"] = fm.liveswitch.JsonSerializer.serializeString(this.getUrl());
                    }
                    if ((!fm.liveswitch.Global.equals(this.getResult(), 0))) {
                        jsonObject["result"] = fm.liveswitch.JsonSerializer.serializeInteger(this.getResult());
                    }
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the webhook result.
            */
            WebhookInfo.prototype.setResult = function (value) {
                if (arguments.length == 1) {
                    this._result = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Sets the webhook URL.
            */
            WebhookInfo.prototype.setUrl = function (value) {
                if (arguments.length == 1) {
                    this._url = value;
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            /**
            Serializes this instance to Json.
            */
            WebhookInfo.prototype.toJson = function () {
                if (arguments.length == 0) {
                    return fm.liveswitch.WebhookInfo.toJson(this);
                }
                else {
                    throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                }
            };
            return WebhookInfo;
        }(fm.liveswitch.Info));
        liveswitch.WebhookInfo = WebhookInfo;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../Serializable.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var BaseAdvice = /** @class */ (function (_super) {
                __extends(BaseAdvice, _super);
                function BaseAdvice() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingBaseAdviceInit();
                        _this.__reconnect = fm.liveswitch.signalling.Reconnect.NotSet;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                BaseAdvice.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.BaseAdvice]' + ',' + _super.prototype.getTypeString.call(this);
                };
                BaseAdvice.prototype.fmliveswitchsignallingBaseAdviceInit = function () {
                    this.__interval = 0;
                };
                BaseAdvice.deserializeReconnect = function (reconnectJson) {
                    if (arguments.length == 1) {
                        var _var0 = fm.liveswitch.JsonSerializer.deserializeString(reconnectJson);
                        if (_var0 == "retry") {
                            do {
                                return fm.liveswitch.signalling.Reconnect.Retry;
                            } while (false);
                        }
                        else if (_var0 == "handshake") {
                            do {
                                return fm.liveswitch.signalling.Reconnect.Handshake;
                            } while (false);
                        }
                        else if (_var0 == "none") {
                            do {
                                return fm.liveswitch.signalling.Reconnect.None;
                            } while (false);
                        }
                        return fm.liveswitch.signalling.Reconnect.NotSet;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BaseAdvice.fromJson = function (baseAdviceJson) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.deserializeObjectFast(baseAdviceJson, function () {
                            return new fm.liveswitch.signalling.BaseAdvice();
                        }, function (obj, name, valueJson) {
                            var str = name;
                            if ((!fm.liveswitch.Global.equals(str, null))) {
                                if (!(fm.liveswitch.Global.equals(str, "hosts"))) {
                                    if ((fm.liveswitch.Global.equals(str, "interval"))) {
                                        obj.setInterval(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "reconnect"))) {
                                            obj.setReconnect(fm.liveswitch.signalling.BaseAdvice.deserializeReconnect(valueJson));
                                        }
                                    }
                                }
                                else {
                                    obj.setHosts(fm.liveswitch.JsonSerializer.deserializeStringArray(valueJson));
                                }
                            }
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BaseAdvice.serializeReconnect = function (reconnect) {
                    if (arguments.length == 1) {
                        var str = null;
                        var _var0 = reconnect;
                        if (_var0 == fm.liveswitch.signalling.Reconnect.Retry) {
                            do {
                                str = "retry";
                                break;
                            } while (false);
                        }
                        else if (_var0 == fm.liveswitch.signalling.Reconnect.Handshake) {
                            do {
                                str = "handshake";
                                break;
                            } while (false);
                        }
                        else if (_var0 == fm.liveswitch.signalling.Reconnect.None) {
                            do {
                                str = "none";
                                break;
                            } while (false);
                        }
                        return fm.liveswitch.JsonSerializer.serializeString(str);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BaseAdvice.toJson = function (baseAdvice) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.serializeObjectFast(baseAdvice, function (obj, jsonObject) {
                            if ((!fm.liveswitch.Global.equals(obj.getHosts(), null))) {
                                jsonObject["hosts"] = fm.liveswitch.JsonSerializer.serializeStringArray(obj.getHosts());
                            }
                            if ((obj.getInterval() != null)) {
                                jsonObject["interval"] = fm.liveswitch.JsonSerializer.serializeInteger(obj.getInterval());
                            }
                            if ((!fm.liveswitch.Global.equals(obj.getReconnect(), fm.liveswitch.signalling.Reconnect.NotSet))) {
                                jsonObject["reconnect"] = fm.liveswitch.signalling.BaseAdvice.serializeReconnect(obj.getReconnect());
                            }
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BaseAdvice.prototype.getHosts = function () {
                    if (arguments.length == 0) {
                        return this.__hosts;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BaseAdvice.prototype.getInterval = function () {
                    if (arguments.length == 0) {
                        return this.__interval;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BaseAdvice.prototype.getReconnect = function () {
                    if (arguments.length == 0) {
                        return this.__reconnect;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BaseAdvice.prototype.setHosts = function (value) {
                    if (arguments.length == 1) {
                        this.__hosts = value;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BaseAdvice.prototype.setInterval = function (value) {
                    if (arguments.length == 1) {
                        this.__interval = value;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BaseAdvice.prototype.setReconnect = function (value) {
                    if (arguments.length == 1) {
                        this.__reconnect = value;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BaseAdvice.prototype.toJson = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.BaseAdvice.toJson(this);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return BaseAdvice;
            }(fm.liveswitch.Serializable));
            signalling.BaseAdvice = BaseAdvice;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/BaseAdvice.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var Advice = /** @class */ (function (_super) {
                __extends(Advice, _super);
                function Advice() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                Advice.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.Advice]' + ',' + _super.prototype.getTypeString.call(this);
                };
                Advice.fromJson = function (adviceJson) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.deserializeObjectFast(adviceJson, function () {
                            return new fm.liveswitch.signalling.Advice();
                        }, function (obj, name, valueJson) {
                            var str = name;
                            if ((!fm.liveswitch.Global.equals(str, null))) {
                                if (!(fm.liveswitch.Global.equals(str, "hosts"))) {
                                    if ((fm.liveswitch.Global.equals(str, "interval"))) {
                                        obj.setInterval(fm.liveswitch.JsonSerializer.deserializeInteger(valueJson));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "reconnect"))) {
                                            obj.setReconnect(fm.liveswitch.signalling.BaseAdvice.deserializeReconnect(valueJson));
                                        }
                                        else {
                                            if ((fm.liveswitch.Global.equals(str, "websocket"))) {
                                                obj.setWebSocket(fm.liveswitch.signalling.BaseAdvice.fromJson(valueJson));
                                            }
                                            else {
                                                if ((fm.liveswitch.Global.equals(str, "long-polling"))) {
                                                    obj.setLongPolling(fm.liveswitch.signalling.BaseAdvice.fromJson(valueJson));
                                                }
                                                else {
                                                    if ((fm.liveswitch.Global.equals(str, "callback-polling"))) {
                                                        obj.setCallbackPolling(fm.liveswitch.signalling.BaseAdvice.fromJson(valueJson));
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    obj.setHosts(fm.liveswitch.JsonSerializer.deserializeStringArray(valueJson));
                                }
                            }
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Advice.toJson = function (advice) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.serializeObjectFast(advice, function (obj, jsonObject) {
                            if ((!fm.liveswitch.Global.equals(obj.getHosts(), null))) {
                                jsonObject["hosts"] = fm.liveswitch.JsonSerializer.serializeStringArray(obj.getHosts());
                            }
                            if ((obj.getInterval() != null)) {
                                jsonObject["interval"] = fm.liveswitch.JsonSerializer.serializeInteger(obj.getInterval());
                            }
                            if ((!fm.liveswitch.Global.equals(obj.getReconnect(), fm.liveswitch.signalling.Reconnect.NotSet))) {
                                jsonObject["reconnect"] = fm.liveswitch.signalling.BaseAdvice.serializeReconnect(obj.getReconnect());
                            }
                            if ((!fm.liveswitch.Global.equals(obj.getWebSocket(), null))) {
                                jsonObject["websocket"] = fm.liveswitch.signalling.BaseAdvice.toJson(obj.getWebSocket());
                            }
                            if ((!fm.liveswitch.Global.equals(obj.getLongPolling(), null))) {
                                jsonObject["long-polling"] = fm.liveswitch.signalling.BaseAdvice.toJson(obj.getLongPolling());
                            }
                            if ((!fm.liveswitch.Global.equals(obj.getCallbackPolling(), null))) {
                                jsonObject["callback-polling"] = fm.liveswitch.signalling.BaseAdvice.toJson(obj.getCallbackPolling());
                            }
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Advice.prototype.getCallbackPolling = function () {
                    if (arguments.length == 0) {
                        return this._callbackPolling;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Advice.prototype.getLongPolling = function () {
                    if (arguments.length == 0) {
                        return this._longPolling;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Advice.prototype.getWebSocket = function () {
                    if (arguments.length == 0) {
                        return this._webSocket;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Advice.prototype.setCallbackPolling = function (value) {
                    if (arguments.length == 1) {
                        this._callbackPolling = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Advice.prototype.setLongPolling = function (value) {
                    if (arguments.length == 1) {
                        this._longPolling = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Advice.prototype.setWebSocket = function (value) {
                    if (arguments.length == 1) {
                        this._webSocket = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Advice.prototype.toJson = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Advice.toJson(this);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Advice;
            }(fm.liveswitch.signalling.BaseAdvice));
            signalling.Advice = Advice;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var Extensible = /** @class */ (function (_super) {
                __extends(Extensible, _super);
                function Extensible() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                Extensible.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.Extensible]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /** @hidden */
                Extensible.convertKeyToRecord = function (key) {
                    if (arguments.length == 1) {
                        return new fm.liveswitch.signalling.Record(key);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Extensible.convertRecordToKey = function (record) {
                    if (arguments.length == 1) {
                        return record.getKey();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.getAcknowledgementExtensionName = function () {
                    if (arguments.length == 0) {
                        return "fm.ack";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.getAuthTokenExtensionName = function () {
                    if (arguments.length == 0) {
                        return "fm.authToken";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.getDeviceIdExtensionName = function () {
                    if (arguments.length == 0) {
                        return "fm.deviceId";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.getDisableBinaryExtensionName = function () {
                    if (arguments.length == 0) {
                        return "fm.dbin";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.getIsPrivateExtensionName = function () {
                    if (arguments.length == 0) {
                        return "fm.private";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.getMetaExtensionName = function () {
                    if (arguments.length == 0) {
                        return "fm.meta";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.getPresenceExtensionName = function () {
                    if (arguments.length == 0) {
                        return "fm.presence";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.getRemoteClientExtensionName = function () {
                    if (arguments.length == 0) {
                        return "fm.remoteClient";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.getReturnDataExtensionName = function () {
                    if (arguments.length == 0) {
                        return "fm.returnData";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.getServerActionsExtensionName = function () {
                    if (arguments.length == 0) {
                        return "fm.server";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.getServerTimeoutExtensionName = function () {
                    if (arguments.length == 0) {
                        return "fm.timeout";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.getStreamIdExtensionName = function () {
                    if (arguments.length == 0) {
                        return "fm.streamId";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.getSubscribedClientsExtensionName = function () {
                    if (arguments.length == 0) {
                        return "fm.subscribed";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.getTagExtensionName = function () {
                    if (arguments.length == 0) {
                        return "fm.tag";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.getUserIdExtensionName = function () {
                    if (arguments.length == 0) {
                        return "fm.userId";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.sharedGetChannel = function (channels) {
                    if (arguments.length == 1) {
                        if (((fm.liveswitch.Global.equals(channels, null)) || (fm.liveswitch.Global.equals(channels.length, 0)))) {
                            return null;
                        }
                        return channels[0];
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.sharedGetChannels = function (channels) {
                    if (arguments.length == 1) {
                        return channels;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.sharedGetKey = function (keys) {
                    if (arguments.length == 1) {
                        if (((fm.liveswitch.Global.equals(keys, null)) || (fm.liveswitch.Global.equals(keys.length, 0)))) {
                            return null;
                        }
                        return keys[0];
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.sharedGetKeys = function (keys) {
                    if (arguments.length == 1) {
                        return keys;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.sharedGetRecord = function (records) {
                    if (arguments.length == 1) {
                        if (((fm.liveswitch.Global.equals(records, null)) || (fm.liveswitch.Global.equals(records.length, 0)))) {
                            return null;
                        }
                        return records[0];
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.sharedGetRecords = function (records) {
                    if (arguments.length == 1) {
                        return records;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.sharedSetChannel = function () {
                    if (arguments.length == 1) {
                        var channel = arguments[0];
                        return fm.liveswitch.signalling.Extensible.sharedSetChannel(channel, true);
                    }
                    else if (arguments.length == 2) {
                        var channel = arguments[0];
                        var validate = arguments[1];
                        if ((fm.liveswitch.Global.equals(channel, null))) {
                            return null;
                        }
                        var error = null;
                        var _var0 = new fm.liveswitch.Holder(error);
                        var _var1 = fm.liveswitch.signalling.Extensible.validateChannel(channel, _var0);
                        error = _var0.getValue();
                        if (!(!validate || _var1)) {
                            throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Invalid channel. {0}", error));
                        }
                        return [channel];
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.sharedSetChannels = function () {
                    if (arguments.length == 1) {
                        var channels = arguments[0];
                        return fm.liveswitch.signalling.Extensible.sharedSetChannels(channels, true);
                    }
                    else if (arguments.length == 2) {
                        var channels = arguments[0];
                        var validate = arguments[1];
                        if ((!fm.liveswitch.Global.equals(channels, null))) {
                            for (var _i = 0, channels_4 = channels; _i < channels_4.length; _i++) {
                                var str = channels_4[_i];
                                var error = null;
                                var _var0 = new fm.liveswitch.Holder(error);
                                var _var1 = fm.liveswitch.signalling.Extensible.validateChannel(str, _var0);
                                error = _var0.getValue();
                                if (!(!validate || _var1)) {
                                    throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Invalid channel. {0}", error));
                                }
                            }
                        }
                        return channels;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.sharedSetKey = function () {
                    if (arguments.length == 1) {
                        var key = arguments[0];
                        return fm.liveswitch.signalling.Extensible.sharedSetKey(key, true);
                    }
                    else if (arguments.length == 2) {
                        var key = arguments[0];
                        var validate = arguments[1];
                        if ((fm.liveswitch.Global.equals(key, null))) {
                            return null;
                        }
                        var error = null;
                        var _var0 = new fm.liveswitch.Holder(error);
                        var _var1 = fm.liveswitch.signalling.Extensible.validateKey(key, _var0);
                        error = _var0.getValue();
                        if (!(!validate || _var1)) {
                            throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Invalid key. {0}", error));
                        }
                        return [key];
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.sharedSetKeys = function () {
                    if (arguments.length == 1) {
                        var keys = arguments[0];
                        return fm.liveswitch.signalling.Extensible.sharedSetKeys(keys, true);
                    }
                    else if (arguments.length == 2) {
                        var keys = arguments[0];
                        var validate = arguments[1];
                        if ((!fm.liveswitch.Global.equals(keys, null))) {
                            for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                                var str = keys_1[_i];
                                var error = null;
                                var _var0 = new fm.liveswitch.Holder(error);
                                var _var1 = fm.liveswitch.signalling.Extensible.validateKey(str, _var0);
                                error = _var0.getValue();
                                if (!(!validate || _var1)) {
                                    throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Invalid key. {0}", error));
                                }
                            }
                        }
                        return keys;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.sharedSetRecord = function () {
                    if (arguments.length == 1) {
                        var record = arguments[0];
                        return fm.liveswitch.signalling.Extensible.sharedSetRecord(record, true);
                    }
                    else if (arguments.length == 2) {
                        var record = arguments[0];
                        var validate = arguments[1];
                        var error = null;
                        var _var0 = new fm.liveswitch.Holder(error);
                        var _var1 = fm.liveswitch.signalling.Extensible.validateRecord(record, _var0);
                        error = _var0.getValue();
                        if (!(!validate || _var1)) {
                            throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Invalid record. {0}", error));
                        }
                        return [record];
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.sharedSetRecords = function () {
                    if (arguments.length == 1) {
                        var records = arguments[0];
                        return fm.liveswitch.signalling.Extensible.sharedSetRecords(records, true);
                    }
                    else if (arguments.length == 2) {
                        var records = arguments[0];
                        var validate = arguments[1];
                        if ((!fm.liveswitch.Global.equals(records, null))) {
                            for (var _i = 0, records_1 = records; _i < records_1.length; _i++) {
                                var record = records_1[_i];
                                var error = null;
                                var _var0 = new fm.liveswitch.Holder(error);
                                var _var1 = fm.liveswitch.signalling.Extensible.validateRecord(record, _var0);
                                error = _var0.getValue();
                                if (!(!validate || _var1)) {
                                    throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Invalid record. {0}", error));
                                }
                            }
                        }
                        return records;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.validateChannel = function (channel, error) {
                    if (arguments.length == 2) {
                        if ((fm.liveswitch.Global.equals(channel, null))) {
                            error.setValue("Channel is null.");
                            return false;
                        }
                        if (!fm.liveswitch.StringExtensions.startsWith(channel, "/", fm.liveswitch.StringComparison.Ordinal)) {
                            error.setValue("Channel must start with a forward-slash (/).");
                            return false;
                        }
                        if ((fm.liveswitch.StringExtensions.indexOf(channel, "*", fm.liveswitch.StringComparison.Ordinal) >= 0)) {
                            error.setValue("Channel may not contain asterisks (*).");
                            return false;
                        }
                        if (fm.liveswitch.signalling.MetaChannels.isReservedChannel(channel)) {
                            error.setValue("Channel is reserved.");
                            return false;
                        }
                        error.setValue(null);
                        return true;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.validateKey = function (key, error) {
                    if (arguments.length == 2) {
                        if ((fm.liveswitch.Global.equals(key, null))) {
                            error.setValue("Key is null.");
                            return false;
                        }
                        error.setValue(null);
                        return true;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.validateRecord = function (record, error) {
                    if (arguments.length == 2) {
                        if ((fm.liveswitch.Global.equals(record, null))) {
                            error.setValue("Record is null.");
                            return false;
                        }
                        if (fm.liveswitch.StringExtensions.isNullOrEmpty(record.getKey())) {
                            error.setValue("Key is null or empty.");
                            return false;
                        }
                        error.setValue(null);
                        return true;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.prototype.copyExtensions = function (extensible) {
                    if (arguments.length == 1) {
                        for (var _i = 0, _a = extensible.getExtensionNames(); _i < _a.length; _i++) {
                            var str = _a[_i];
                            this.setExtensionValueJson(str, extensible.getExtensionValueJson(str), false);
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.prototype.getExtensionCount = function () {
                    if (arguments.length == 0) {
                        return this.getExtensions().getCount();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.prototype.getExtensionNames = function () {
                    if (arguments.length == 0) {
                        return this.getExtensions().getNames();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.prototype.getExtensions = function () {
                    if (arguments.length == 0) {
                        if ((fm.liveswitch.Global.equals(this.__extensions, null))) {
                            this.__extensions = new fm.liveswitch.signalling.Extensions();
                        }
                        return this.__extensions;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.prototype.getExtensionValueJson = function (name) {
                    if (arguments.length == 1) {
                        return this.getExtensions().getValueJson(name);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.prototype.getMetaJson = function () {
                    if (arguments.length == 0) {
                        return this.getExtensionValueJson(fm.liveswitch.signalling.Extensible.getMetaExtensionName());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.prototype.setExtensions = function (value) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(this.__extensions, null))) {
                            this.__extensions = new fm.liveswitch.signalling.Extensions();
                        }
                        if ((!fm.liveswitch.Global.equals(value, null))) {
                            for (var _i = 0, _a = value.getNames(); _i < _a.length; _i++) {
                                var str = _a[_i];
                                this.__extensions.setValueJson(str, value.getValueJson(str));
                            }
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.prototype.setExtensionValueJson = function () {
                    if (arguments.length == 2) {
                        var name_38 = arguments[0];
                        var valueJson = arguments[1];
                        this.getExtensions().setValueJson(name_38, valueJson);
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else if (arguments.length == 3) {
                        var name_39 = arguments[0];
                        var valueJson = arguments[1];
                        var validate = arguments[2];
                        this.getExtensions().setValueJson(name_39, valueJson, validate);
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.prototype.setMetaJson = function (value) {
                    if (arguments.length == 1) {
                        this.setExtensionValueJson(fm.liveswitch.signalling.Extensible.getMetaExtensionName(), value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.prototype.getExtensionValue = function (name) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.Json.deserialize(this.getExtensionValueJson.apply(this, arguments));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.prototype.getMeta = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.Json.deserialize(this.getMetaJson.apply(this, arguments));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.prototype.setExtensionValue = function () {
                    if (arguments.length == 2) {
                        var name_40 = arguments[0];
                        var extensionValue = arguments[1];
                        arguments[arguments.length - 1] = fm.liveswitch.Json.serialize(arguments[arguments.length - 1]);
                        this.setExtensionValueJson.apply(this, arguments);
                    }
                    else if (arguments.length == 3) {
                        var name_41 = arguments[0];
                        var valueJson = arguments[1];
                        var extensionValue = arguments[2];
                        arguments[arguments.length - 1] = fm.liveswitch.Json.serialize(arguments[arguments.length - 1]);
                        this.setExtensionValueJson.apply(this, arguments);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensible.prototype.setMeta = function (meta) {
                    if (arguments.length == 1) {
                        arguments[arguments.length - 1] = fm.liveswitch.Json.serialize(arguments[arguments.length - 1]);
                        this.setMetaJson.apply(this, arguments);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Extensible;
            }(fm.liveswitch.Dynamic));
            signalling.Extensible = Extensible;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/Extensible.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var InputArgs = /** @class */ (function (_super) {
                __extends(InputArgs, _super);
                function InputArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingInputArgsInit();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                InputArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.InputArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                InputArgs.prototype.fmliveswitchsignallingInputArgsInit = function () {
                    this._requestMaxRetries = 0;
                    this._requestTimeout = 0;
                    this._synchronous = false;
                };
                InputArgs.prototype.getRequestMaxRetries = function () {
                    if (arguments.length == 0) {
                        return this._requestMaxRetries;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                InputArgs.prototype.getRequestTimeout = function () {
                    if (arguments.length == 0) {
                        return this._requestTimeout;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                InputArgs.prototype.getRequestUrl = function () {
                    if (arguments.length == 0) {
                        return this._requestUrl;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                InputArgs.prototype.getSynchronous = function () {
                    if (arguments.length == 0) {
                        return this._synchronous;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                InputArgs.prototype.setRequestMaxRetries = function (value) {
                    if (arguments.length == 1) {
                        this._requestMaxRetries = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                InputArgs.prototype.setRequestTimeout = function (value) {
                    if (arguments.length == 1) {
                        this._requestTimeout = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                InputArgs.prototype.setRequestUrl = function (value) {
                    if (arguments.length == 1) {
                        this._requestUrl = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                InputArgs.prototype.setSynchronous = function (value) {
                    if (arguments.length == 1) {
                        this._synchronous = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return InputArgs;
            }(fm.liveswitch.signalling.Extensible));
            signalling.InputArgs = InputArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/InputArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var BindArgs = /** @class */ (function (_super) {
                __extends(BindArgs, _super);
                function BindArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingBindArgsInit();
                    }
                    else if (__arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.signalling.Record]'))) {
                        var record = __arguments[0];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingBindArgsInit();
                        _this.setRecord(record);
                    }
                    else if (__arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isObjectType(arguments[0][0], '[fm.liveswitch.signalling.Record]')))))) {
                        var records = __arguments[0];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingBindArgsInit();
                        _this.setRecords(records);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                BindArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.BindArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                BindArgs.prototype.fmliveswitchsignallingBindArgsInit = function () {
                    this._isPrivate = false;
                };
                BindArgs.prototype.getIsPrivate = function () {
                    if (arguments.length == 0) {
                        return this._isPrivate;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BindArgs.prototype.getOnFailure = function () {
                    if (arguments.length == 0) {
                        return this._onFailure;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BindArgs.prototype.getOnSuccess = function () {
                    if (arguments.length == 0) {
                        return this._onSuccess;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BindArgs.prototype.getRecord = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetRecord(this.__records);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BindArgs.prototype.getRecords = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetRecords(this.__records);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BindArgs.prototype.setIsPrivate = function (value) {
                    if (arguments.length == 1) {
                        this._isPrivate = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BindArgs.prototype.setOnFailure = function (value) {
                    if (arguments.length == 1) {
                        this._onFailure = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BindArgs.prototype.setOnSuccess = function (value) {
                    if (arguments.length == 1) {
                        this._onSuccess = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BindArgs.prototype.setRecord = function (value) {
                    if (arguments.length == 1) {
                        this.__records = fm.liveswitch.signalling.Extensible.sharedSetRecord(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BindArgs.prototype.setRecords = function (value) {
                    if (arguments.length == 1) {
                        this.__records = fm.liveswitch.signalling.Extensible.sharedSetRecords(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return BindArgs;
            }(fm.liveswitch.signalling.InputArgs));
            signalling.BindArgs = BindArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/Extensible.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var OutputArgs = /** @class */ (function (_super) {
                __extends(OutputArgs, _super);
                function OutputArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                OutputArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.OutputArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                OutputArgs.prototype.getClient = function () {
                    if (arguments.length == 0) {
                        return this._client;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                OutputArgs.prototype.getTimestamp = function () {
                    if (arguments.length == 0) {
                        return this.__timestamp;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                OutputArgs.prototype.setClient = function (value) {
                    if (arguments.length == 1) {
                        this._client = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                OutputArgs.prototype.setTimestamp = function (value) {
                    if (arguments.length == 1) {
                        if ((value != null)) {
                            this.__timestamp = value;
                        }
                        else {
                            this.__timestamp = null;
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return OutputArgs;
            }(fm.liveswitch.signalling.Extensible));
            signalling.OutputArgs = OutputArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/OutputArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var FailureArgs = /** @class */ (function (_super) {
                __extends(FailureArgs, _super);
                function FailureArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                FailureArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.FailureArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /** @hidden */
                FailureArgs.getErrorCode = function (exception) {
                    if (arguments.length == 1) {
                        var intResult = -1;
                        try {
                            if (((fm.liveswitch.Global.equals(exception, null)) || fm.liveswitch.StringExtensions.isNullOrEmpty(exception.message))) {
                                return intResult;
                            }
                            if ((fm.liveswitch.StringExtensions.indexOf(exception.message, "::", fm.liveswitch.StringComparison.InvariantCulture) <= -1)) {
                                return intResult;
                            }
                            var s = fm.liveswitch.Splitter.split(exception.message, "::")[0];
                            var _var0 = new fm.liveswitch.Holder(intResult);
                            var _var1 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(s, _var0);
                            intResult = _var0.getValue();
                            if (!_var1) {
                                intResult = -1;
                            }
                        }
                        catch (obj1) {
                        }
                        finally {
                        }
                        return intResult;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                FailureArgs.getErrorMessage = function (exception) {
                    if (arguments.length == 1) {
                        var message = null;
                        try {
                            if (((fm.liveswitch.Global.equals(exception, null)) || fm.liveswitch.StringExtensions.isNullOrEmpty(exception.message))) {
                                return message;
                            }
                            if ((fm.liveswitch.StringExtensions.indexOf(exception.message, "::", fm.liveswitch.StringComparison.InvariantCulture) > -1)) {
                                return fm.liveswitch.Splitter.split(exception.message, "::")[1];
                            }
                            message = exception.message;
                        }
                        catch (obj1) {
                        }
                        finally {
                        }
                        return message;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                FailureArgs.prototype.getErrorCode = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.FailureArgs.getErrorCode(this.getException());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                FailureArgs.prototype.getErrorMessage = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.FailureArgs.getErrorMessage(this.getException());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                FailureArgs.prototype.getException = function () {
                    if (arguments.length == 0) {
                        return this._exception;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                FailureArgs.prototype.setException = function (value) {
                    if (arguments.length == 1) {
                        this._exception = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return FailureArgs;
            }(fm.liveswitch.signalling.OutputArgs));
            signalling.FailureArgs = FailureArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/FailureArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var BindFailureArgs = /** @class */ (function (_super) {
                __extends(BindFailureArgs, _super);
                function BindFailureArgs(records, isPrivate) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 2) {
                        var records_2 = __arguments[0];
                        var isPrivate_1 = __arguments[1];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingBindFailureArgsInit();
                        _this.__records = records_2;
                        _this.__isPrivate = isPrivate_1;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                BindFailureArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.BindFailureArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                BindFailureArgs.prototype.fmliveswitchsignallingBindFailureArgsInit = function () {
                    this.__isPrivate = false;
                };
                BindFailureArgs.prototype.getIsPrivate = function () {
                    if (arguments.length == 0) {
                        return this.__isPrivate;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BindFailureArgs.prototype.getRecord = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetRecord(this.__records);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BindFailureArgs.prototype.getRecords = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetRecords(this.__records);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return BindFailureArgs;
            }(fm.liveswitch.signalling.FailureArgs));
            signalling.BindFailureArgs = BindFailureArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var Binding = /** @class */ (function (_super) {
                __extends(Binding, _super);
                function Binding() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var record = __arguments[0];
                        // chained constructor: Binding.call(this, record, false);
                        __arguments = new Array(2);
                        __arguments[0] = record;
                        __arguments[1] = false;
                        {
                            var record_2 = __arguments[0];
                            var isPrivate = __arguments[1];
                            _this = _super.call(this) || this;
                            _this.fmliveswitchsignallingBindingInit();
                            _this.setRecord(record_2);
                            _this.setIsPrivate(isPrivate);
                        }
                    }
                    else if (__arguments.length == 2) {
                        var record = __arguments[0];
                        var isPrivate = __arguments[1];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingBindingInit();
                        _this.setRecord(record);
                        _this.setIsPrivate(isPrivate);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                Binding.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.Binding]' + ',' + _super.prototype.getTypeString.call(this);
                };
                Binding.prototype.fmliveswitchsignallingBindingInit = function () {
                    this.__isPrivate = false;
                };
                Binding.fromJson = function (bindingJson) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.deserializeObjectFast(bindingJson, function () {
                            return new fm.liveswitch.signalling.Binding(new fm.liveswitch.signalling.Record("key"));
                        }, function (obj, name, valueJson) {
                            var str = name;
                            if ((!fm.liveswitch.Global.equals(str, null))) {
                                if (!(fm.liveswitch.Global.equals(str, "record"))) {
                                    if ((fm.liveswitch.Global.equals(str, "isPrivate"))) {
                                        var nullable = fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson);
                                        if ((nullable != null)) {
                                            obj.setIsPrivate(nullable);
                                        }
                                    }
                                }
                                else {
                                    obj.setRecord(fm.liveswitch.signalling.Record.fromJson(valueJson));
                                }
                            }
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Binding.fromJsonArray = function (bindingsJson) {
                    if (arguments.length == 1) {
                        var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(bindingsJson, fm.liveswitch.signalling.Binding.fromJson.bind(fm.liveswitch.signalling.Binding));
                        if ((fm.liveswitch.Global.equals(list, null))) {
                            return null;
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Binding.toJson = function (binding) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.serializeObjectFast(binding, function (obj, jsonObject) {
                            jsonObject["record"] = fm.liveswitch.signalling.Record.toJson(obj.getRecord());
                            jsonObject["isPrivate"] = fm.liveswitch.JsonSerializer.serializeBoolean(obj.getIsPrivate());
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Binding.toJsonArray = function (bindings) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.serializeObjectArray(bindings, fm.liveswitch.signalling.Binding.toJson.bind(fm.liveswitch.signalling.Binding));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Binding.prototype.duplicate = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.signalling.Binding(this.getRecord(), this.getIsPrivate());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Binding.prototype.getIsPrivate = function () {
                    if (arguments.length == 0) {
                        return this.__isPrivate;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Binding.prototype.getRecord = function () {
                    if (arguments.length == 0) {
                        return this.__record;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Binding.prototype.setIsPrivate = function (value) {
                    if (arguments.length == 1) {
                        this.__isPrivate = value;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Binding.prototype.setRecord = function (value) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(value, null))) {
                            throw new fm.liveswitch.Exception("record cannot be null.");
                        }
                        this.__record = value;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Binding.prototype.toJson = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Binding.toJson(this);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Binding;
            }(fm.liveswitch.Dynamic));
            signalling.Binding = Binding;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/OutputArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var SuccessArgs = /** @class */ (function (_super) {
                __extends(SuccessArgs, _super);
                function SuccessArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                SuccessArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.SuccessArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return SuccessArgs;
            }(fm.liveswitch.signalling.OutputArgs));
            signalling.SuccessArgs = SuccessArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/SuccessArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var BindSuccessArgs = /** @class */ (function (_super) {
                __extends(BindSuccessArgs, _super);
                function BindSuccessArgs(records, isPrivate) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 2) {
                        var records_3 = __arguments[0];
                        var isPrivate_2 = __arguments[1];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingBindSuccessArgsInit();
                        _this.__records = records_3;
                        _this.__isPrivate = isPrivate_2;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                BindSuccessArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.BindSuccessArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                BindSuccessArgs.prototype.fmliveswitchsignallingBindSuccessArgsInit = function () {
                    this.__isPrivate = false;
                };
                BindSuccessArgs.prototype.getIsPrivate = function () {
                    if (arguments.length == 0) {
                        return this.__isPrivate;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BindSuccessArgs.prototype.getRecord = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetRecord(this.__records);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                BindSuccessArgs.prototype.getRecords = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetRecords(this.__records);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return BindSuccessArgs;
            }(fm.liveswitch.signalling.SuccessArgs));
            signalling.BindSuccessArgs = BindSuccessArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../HttpWebRequestSender.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientBase = /** @class */ (function (_super) {
                __extends(ClientBase, _super);
                function ClientBase() {
                    var _this = this;
                    fm.liveswitch.signalling.ClientBase.fmliveswitchsignallingClientBaseInitialize();
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingClientBaseInit();
                        _this.setRequestTimeout(15000);
                        _this.setDomainKey(fm.liveswitch.signalling.Defaults.getDomainKey());
                        _this.setDomainName(fm.liveswitch.signalling.Defaults.getDomainName());
                        _this.setConcurrencyMode(fm.liveswitch.signalling.ConcurrencyMode.Low);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientBase.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientBase]' + ',' + _super.prototype.getTypeString.call(this);
                };
                ClientBase.prototype.fmliveswitchsignallingClientBaseInit = function () {
                    var _this = this;
                    this.__onHttpRequestCreated = [];
                    this.__onHttpResponseReceived = [];
                    this.__onRequestCreated = [];
                    this.__onResponseReceived = [];
                    this.__onUnhandledException = [];
                    this._autoDisconnect = false;
                    this._disableBinary = false;
                    this._onHttpRequestCreated = function (p0) { for (var _i = 0, _a = _this.__onHttpRequestCreated; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onHttpResponseReceived = function (p0) { for (var _i = 0, _a = _this.__onHttpResponseReceived; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onRequestCreated = function (p0) { for (var _i = 0, _a = _this.__onRequestCreated; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onResponseReceived = function (p0) { for (var _i = 0, _a = _this.__onResponseReceived; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onUnhandledException = function (p0) { for (var _i = 0, _a = _this.__onUnhandledException; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._requestMaxRetries = 0;
                    this._requestTimeout = 0;
                };
                /** @hidden */
                ClientBase.sanitizeDomainName = function (domainName) {
                    fm.liveswitch.signalling.ClientBase.fmliveswitchsignallingClientBaseInitialize();
                    if (arguments.length == 1) {
                        if (fm.liveswitch.StringExtensions.startsWith(domainName, "http://", fm.liveswitch.StringComparison.Ordinal)) {
                            domainName = domainName.substring(fm.liveswitch.StringExtensions.getLength("http://"));
                        }
                        else {
                            if (fm.liveswitch.StringExtensions.startsWith(domainName, "https://", fm.liveswitch.StringComparison.Ordinal)) {
                                domainName = domainName.substring(fm.liveswitch.StringExtensions.getLength("https://"));
                            }
                        }
                        var index = fm.liveswitch.StringExtensions.indexOf(domainName, "/", fm.liveswitch.StringComparison.InvariantCulture);
                        if ((!fm.liveswitch.Global.equals(index, -1))) {
                            domainName = fm.liveswitch.StringExtensions.substring(domainName, 0, index);
                        }
                        return domainName;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.addOnHttpRequestCreated = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onHttpRequestCreated, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.addOnHttpResponseReceived = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onHttpResponseReceived, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.addOnRequestCreated = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onRequestCreated, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.addOnResponseReceived = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onResponseReceived, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.addOnUnhandledException = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onUnhandledException, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.createHeaders = function () {
                    if (arguments.length == 0) {
                        if ((fm.liveswitch.Global.equals(this.getConcurrencyMode(), fm.liveswitch.signalling.ConcurrencyMode.High))) {
                            if ((fm.liveswitch.Global.equals(fm.liveswitch.signalling.ClientBase.fm_liveswitch_signalling_ClientBase__headers, null))) {
                                fm.liveswitch.signalling.ClientBase.fm_liveswitch_signalling_ClientBase__headers = this.createHeadersNoCache();
                            }
                            return fm.liveswitch.signalling.ClientBase.fm_liveswitch_signalling_ClientBase__headers;
                        }
                        return this.createHeadersNoCache();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                ClientBase.prototype.createHeadersNoCache = function () {
                    if (arguments.length == 0) {
                        var values = new fm.liveswitch.NameValueCollection();
                        if ((!fm.liveswitch.Global.equals(this.getDomainName(), fm.liveswitch.signalling.Defaults.getDomainName()))) {
                            values.set("X-FM-DomainName", this.getDomainName());
                        }
                        if ((!fm.liveswitch.Global.equals(this.getDomainKey(), fm.liveswitch.signalling.Defaults.getDomainKey()))) {
                            values.set("X-FM-DomainKey", this.getDomainKey());
                        }
                        return values;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.getAutoDisconnect = function () {
                    if (arguments.length == 0) {
                        return this._autoDisconnect;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.getAutoDisconnectArgs = function () {
                    if (arguments.length == 0) {
                        return this._autoDisconnectArgs;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.getConcurrencyMode = function () {
                    if (arguments.length == 0) {
                        return this._concurrencyMode;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.getDisableBinary = function () {
                    if (arguments.length == 0) {
                        return this._disableBinary;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.getDomainKey = function () {
                    if (arguments.length == 0) {
                        return this._domainKey;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.getDomainName = function () {
                    if (arguments.length == 0) {
                        return this.__domainName;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.getEmptyResponseMessage = function (responseArgs) {
                    if (arguments.length == 1) {
                        var str = fm.liveswitch.StringExtensions.format("Empty response received from the server with status code {0}.", fm.liveswitch.NumberExtensions.toString(responseArgs.getStatusCode()));
                        if ((!fm.liveswitch.Global.equals(responseArgs.getTextContent(), null))) {
                            return fm.liveswitch.StringExtensions.format("{0} Response body (text): {1}", str, responseArgs.getTextContent());
                        }
                        if ((!fm.liveswitch.Global.equals(responseArgs.getBinaryContent(), null))) {
                            str = fm.liveswitch.StringExtensions.format("{0} Response body (binary): {1}", str, fm.liveswitch.BitAssistant.getHexString(responseArgs.getBinaryContent()));
                        }
                        return str;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.getInvalidResponseMessage = function (responseArgs) {
                    if (arguments.length == 1) {
                        var str = fm.liveswitch.StringExtensions.format("Invalid response received from the server with status code {0}.", fm.liveswitch.NumberExtensions.toString(responseArgs.getStatusCode()));
                        if ((!fm.liveswitch.Global.equals(responseArgs.getTextContent(), null))) {
                            return fm.liveswitch.StringExtensions.format("{0} Response body (text): {1}", str, responseArgs.getTextContent());
                        }
                        if ((!fm.liveswitch.Global.equals(responseArgs.getBinaryContent(), null))) {
                            str = fm.liveswitch.StringExtensions.format("{0} Response body (binary): {1}", str, fm.liveswitch.BitAssistant.getHexString(responseArgs.getBinaryContent()));
                        }
                        return str;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.getRequestMaxRetries = function () {
                    if (arguments.length == 0) {
                        return this._requestMaxRetries;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.getRequestTimeout = function () {
                    if (arguments.length == 0) {
                        return this._requestTimeout;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.getRequestUrl = function () {
                    if (arguments.length == 0) {
                        return this.__requestUrl;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                ClientBase.prototype.internalOnHttpRequestCreated = function (e) {
                    if (arguments.length == 1) {
                        this.raiseBaseEvent(this._onHttpRequestCreated, e, "OnHttpRequestCreated");
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                ClientBase.prototype.internalOnHttpResponseReceived = function (e) {
                    if (arguments.length == 1) {
                        this.raiseBaseEvent(this._onHttpResponseReceived, e, "OnHttpResponseReceived");
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                ClientBase.prototype.internalOnRequestCreated = function (e) {
                    if (arguments.length == 1) {
                        this.raiseBaseEvent(this._onRequestCreated, e, "OnRequestCreated");
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                ClientBase.prototype.internalOnResponseReceived = function (e) {
                    if (arguments.length == 1) {
                        this.raiseBaseEvent(this._onResponseReceived, e, "OnResponseReceived");
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                ClientBase.prototype.raiseBaseEvent = function (eventMethod, args, eventName) {
                    if (arguments.length == 3) {
                        if ((!fm.liveswitch.Global.equals(eventMethod, null))) {
                            try {
                                eventMethod(args);
                            }
                            catch (exception) {
                                if (!this.raiseUnhandledException(exception)) {
                                    fm.liveswitch.Unhandled.logException(exception, fm.liveswitch.StringExtensions.format("BaseClient -> {0}", eventName));
                                }
                            }
                            finally {
                            }
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.raiseUnhandledException = function (exception) {
                    if (arguments.length == 1) {
                        var onUnhandledException = this._onUnhandledException;
                        if ((!fm.liveswitch.Global.equals(onUnhandledException, null))) {
                            var p = new fm.liveswitch.UnhandledExceptionArgs(exception);
                            try {
                                onUnhandledException(p);
                            }
                            catch (exception2) {
                                fm.liveswitch.Unhandled.logException(exception2, "BaseClient -> OnUnhandledException");
                            }
                            finally {
                            }
                            return p.getHandled();
                        }
                        return false;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.removeOnHttpRequestCreated = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onHttpRequestCreated, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.removeOnHttpResponseReceived = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onHttpResponseReceived, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.removeOnRequestCreated = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onRequestCreated, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.removeOnResponseReceived = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onResponseReceived, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.removeOnUnhandledException = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onUnhandledException, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.setAutoDisconnect = function (value) {
                    if (arguments.length == 1) {
                        this._autoDisconnect = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.setAutoDisconnectArgs = function (value) {
                    if (arguments.length == 1) {
                        this._autoDisconnectArgs = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.setConcurrencyMode = function (value) {
                    if (arguments.length == 1) {
                        this._concurrencyMode = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.setDisableBinary = function (value) {
                    if (arguments.length == 1) {
                        this._disableBinary = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.setDomainKey = function (value) {
                    if (arguments.length == 1) {
                        this._domainKey = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.setDomainName = function (value) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(value, null))) {
                            value = fm.liveswitch.signalling.Defaults.getDomainName();
                        }
                        this.__domainName = fm.liveswitch.signalling.ClientBase.sanitizeDomainName(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.setRequestMaxRetries = function (value) {
                    if (arguments.length == 1) {
                        this._requestMaxRetries = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.setRequestTimeout = function (value) {
                    if (arguments.length == 1) {
                        this._requestTimeout = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientBase.prototype.setRequestUrl = function (value) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(value, null))) {
                            throw new fm.liveswitch.Exception("Request URL cannot be null.");
                        }
                        this.__requestUrl = fm.liveswitch.HttpTransfer.replaceWildcards(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                ClientBase.fmliveswitchsignallingClientBaseInitialize = function () {
                    if (!fm.liveswitch.signalling.ClientBase.__fmliveswitchsignallingClientBaseInitialized && !fm.liveswitch.signalling.ClientBase.__fmliveswitchsignallingClientBaseInitializing) {
                        fm.liveswitch.signalling.ClientBase.__fmliveswitchsignallingClientBaseInitializing = true;
                        fm.liveswitch.signalling.ClientBase.fm_liveswitch_signalling_ClientBase__headers = null;
                        fm.liveswitch.signalling.ClientBase.__fmliveswitchsignallingClientBaseInitialized = true;
                        fm.liveswitch.signalling.ClientBase.__fmliveswitchsignallingClientBaseInitializing = false;
                    }
                };
                /** @hidden */
                ClientBase.__fmliveswitchsignallingClientBaseInitialized = false;
                /** @hidden */
                ClientBase.__fmliveswitchsignallingClientBaseInitializing = false;
                return ClientBase;
            }(fm.liveswitch.HttpWebRequestSender));
            signalling.ClientBase = ClientBase;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientBase.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var Client = /** @class */ (function (_super) {
                __extends(Client, _super);
                function Client() {
                    var _this = this;
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                        var requestUrl = __arguments[0];
                        // chained constructor: Client.call(this, requestUrl, null);
                        __arguments = new Array(2);
                        __arguments[0] = requestUrl;
                        __arguments[1] = null;
                        {
                            var requestUrl_1 = __arguments[0];
                            var sharedLock = __arguments[1];
                            // chained constructor: Client.call(this, requestUrl, requestUrl, sharedLock);
                            __arguments = new Array(3);
                            __arguments[0] = requestUrl_1;
                            __arguments[1] = requestUrl_1;
                            __arguments[2] = sharedLock;
                            {
                                var requestUrl_2 = __arguments[0];
                                var streamRequestUrl = __arguments[1];
                                var sharedLock_8 = __arguments[2];
                                // chained constructor: Client.call(this, sharedLock);
                                __arguments = new Array(1);
                                __arguments[0] = sharedLock_8;
                                {
                                    var sharedLock_9 = __arguments[0];
                                    _this = _super.call(this) || this;
                                    _this.fmliveswitchsignallingClientInit();
                                    _this.__state = fm.liveswitch.signalling.ClientState.New;
                                    _this._counter = 0;
                                    _this._lastInterval = 0;
                                    _this._lastReconnect = fm.liveswitch.signalling.Reconnect.NotSet;
                                    _this._boundRecordsLock = new Object();
                                    _this._boundRecords = new fm.liveswitch.signalling.Records();
                                    _this._subscribedChannelsLock = new Object();
                                    _this._subscribedChannels = {};
                                    _this._subscribedOnReceivesLock = new Object();
                                    _this._subscribedOnReceives = {};
                                    _this._subscribedOnPresences = {};
                                    _this._subscribedOnReceivesDynamicProperties = {};
                                    _this._subscribedOnPresencesDynamicProperties = {};
                                    _this._pendingReceives = {};
                                    _this._customOnReceivesLock = new Object();
                                    _this._customOnReceives = {};
                                    _this._presenceCacheLock = new Object();
                                    _this._presenceUserCache = {};
                                    _this._presenceDeviceCache = {};
                                    _this._queueActivated = false;
                                    _this._requestQueue = {};
                                    _this._supportedConnectionTypes = new Array(0);
                                    _this._connectionType = fm.liveswitch.signalling.ConnectionType.LongPolling;
                                    _this._batchCounter = 0;
                                    _this._batchCounterLock = new Object();
                                    _this._deferrer = null;
                                    _this._receivedMessages = false;
                                    _this._webSocketOpened = false;
                                    _this._counterLock = new Object();
                                    _this.__stateLock = sharedLock_9 || new Object();
                                    _this.setSynchronous(false);
                                    _this.setToken(fm.liveswitch.signalling.Client.generateToken());
                                    _this.setUserId(fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", ""));
                                    _this.setDeviceId(fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", ""));
                                    if ((!fm.liveswitch.Global.equals(fm.liveswitch.Platform.getInstance().getSourceLanguage(), fm.liveswitch.SourceLanguage.TypeScript))) {
                                        _this.setDisableWebSockets(true);
                                    }
                                }
                                _super.prototype.setRequestUrl.call(_this, requestUrl_2);
                                _this.setStreamRequestUrl(streamRequestUrl);
                            }
                        }
                    }
                    else if (__arguments.length == 2) {
                        var requestUrl = __arguments[0];
                        var sharedLock = __arguments[1];
                        // chained constructor: Client.call(this, requestUrl, requestUrl, sharedLock);
                        __arguments = new Array(3);
                        __arguments[0] = requestUrl;
                        __arguments[1] = requestUrl;
                        __arguments[2] = sharedLock;
                        {
                            var requestUrl_3 = __arguments[0];
                            var streamRequestUrl = __arguments[1];
                            var sharedLock_10 = __arguments[2];
                            // chained constructor: Client.call(this, sharedLock);
                            __arguments = new Array(1);
                            __arguments[0] = sharedLock_10;
                            {
                                var sharedLock_11 = __arguments[0];
                                _this = _super.call(this) || this;
                                _this.fmliveswitchsignallingClientInit();
                                _this.__state = fm.liveswitch.signalling.ClientState.New;
                                _this._counter = 0;
                                _this._lastInterval = 0;
                                _this._lastReconnect = fm.liveswitch.signalling.Reconnect.NotSet;
                                _this._boundRecordsLock = new Object();
                                _this._boundRecords = new fm.liveswitch.signalling.Records();
                                _this._subscribedChannelsLock = new Object();
                                _this._subscribedChannels = {};
                                _this._subscribedOnReceivesLock = new Object();
                                _this._subscribedOnReceives = {};
                                _this._subscribedOnPresences = {};
                                _this._subscribedOnReceivesDynamicProperties = {};
                                _this._subscribedOnPresencesDynamicProperties = {};
                                _this._pendingReceives = {};
                                _this._customOnReceivesLock = new Object();
                                _this._customOnReceives = {};
                                _this._presenceCacheLock = new Object();
                                _this._presenceUserCache = {};
                                _this._presenceDeviceCache = {};
                                _this._queueActivated = false;
                                _this._requestQueue = {};
                                _this._supportedConnectionTypes = new Array(0);
                                _this._connectionType = fm.liveswitch.signalling.ConnectionType.LongPolling;
                                _this._batchCounter = 0;
                                _this._batchCounterLock = new Object();
                                _this._deferrer = null;
                                _this._receivedMessages = false;
                                _this._webSocketOpened = false;
                                _this._counterLock = new Object();
                                _this.__stateLock = sharedLock_11 || new Object();
                                _this.setSynchronous(false);
                                _this.setToken(fm.liveswitch.signalling.Client.generateToken());
                                _this.setUserId(fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", ""));
                                _this.setDeviceId(fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", ""));
                                if ((!fm.liveswitch.Global.equals(fm.liveswitch.Platform.getInstance().getSourceLanguage(), fm.liveswitch.SourceLanguage.TypeScript))) {
                                    _this.setDisableWebSockets(true);
                                }
                            }
                            _super.prototype.setRequestUrl.call(_this, requestUrl_3);
                            _this.setStreamRequestUrl(streamRequestUrl);
                        }
                    }
                    else if (__arguments.length == 3) {
                        var requestUrl = __arguments[0];
                        var streamRequestUrl = __arguments[1];
                        var sharedLock = __arguments[2];
                        // chained constructor: Client.call(this, sharedLock);
                        __arguments = new Array(1);
                        __arguments[0] = sharedLock;
                        {
                            var sharedLock_12 = __arguments[0];
                            _this = _super.call(this) || this;
                            _this.fmliveswitchsignallingClientInit();
                            _this.__state = fm.liveswitch.signalling.ClientState.New;
                            _this._counter = 0;
                            _this._lastInterval = 0;
                            _this._lastReconnect = fm.liveswitch.signalling.Reconnect.NotSet;
                            _this._boundRecordsLock = new Object();
                            _this._boundRecords = new fm.liveswitch.signalling.Records();
                            _this._subscribedChannelsLock = new Object();
                            _this._subscribedChannels = {};
                            _this._subscribedOnReceivesLock = new Object();
                            _this._subscribedOnReceives = {};
                            _this._subscribedOnPresences = {};
                            _this._subscribedOnReceivesDynamicProperties = {};
                            _this._subscribedOnPresencesDynamicProperties = {};
                            _this._pendingReceives = {};
                            _this._customOnReceivesLock = new Object();
                            _this._customOnReceives = {};
                            _this._presenceCacheLock = new Object();
                            _this._presenceUserCache = {};
                            _this._presenceDeviceCache = {};
                            _this._queueActivated = false;
                            _this._requestQueue = {};
                            _this._supportedConnectionTypes = new Array(0);
                            _this._connectionType = fm.liveswitch.signalling.ConnectionType.LongPolling;
                            _this._batchCounter = 0;
                            _this._batchCounterLock = new Object();
                            _this._deferrer = null;
                            _this._receivedMessages = false;
                            _this._webSocketOpened = false;
                            _this._counterLock = new Object();
                            _this.__stateLock = sharedLock_12 || new Object();
                            _this.setSynchronous(false);
                            _this.setToken(fm.liveswitch.signalling.Client.generateToken());
                            _this.setUserId(fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", ""));
                            _this.setDeviceId(fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", ""));
                            if ((!fm.liveswitch.Global.equals(fm.liveswitch.Platform.getInstance().getSourceLanguage(), fm.liveswitch.SourceLanguage.TypeScript))) {
                                _this.setDisableWebSockets(true);
                            }
                        }
                        _super.prototype.setRequestUrl.call(_this, requestUrl);
                        _this.setStreamRequestUrl(streamRequestUrl);
                    }
                    else if (__arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObject(arguments[0]))) {
                        var sharedLock = __arguments[0];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingClientInit();
                        _this.__state = fm.liveswitch.signalling.ClientState.New;
                        _this._counter = 0;
                        _this._lastInterval = 0;
                        _this._lastReconnect = fm.liveswitch.signalling.Reconnect.NotSet;
                        _this._boundRecordsLock = new Object();
                        _this._boundRecords = new fm.liveswitch.signalling.Records();
                        _this._subscribedChannelsLock = new Object();
                        _this._subscribedChannels = {};
                        _this._subscribedOnReceivesLock = new Object();
                        _this._subscribedOnReceives = {};
                        _this._subscribedOnPresences = {};
                        _this._subscribedOnReceivesDynamicProperties = {};
                        _this._subscribedOnPresencesDynamicProperties = {};
                        _this._pendingReceives = {};
                        _this._customOnReceivesLock = new Object();
                        _this._customOnReceives = {};
                        _this._presenceCacheLock = new Object();
                        _this._presenceUserCache = {};
                        _this._presenceDeviceCache = {};
                        _this._queueActivated = false;
                        _this._requestQueue = {};
                        _this._supportedConnectionTypes = new Array(0);
                        _this._connectionType = fm.liveswitch.signalling.ConnectionType.LongPolling;
                        _this._batchCounter = 0;
                        _this._batchCounterLock = new Object();
                        _this._deferrer = null;
                        _this._receivedMessages = false;
                        _this._webSocketOpened = false;
                        _this._counterLock = new Object();
                        _this.__stateLock = sharedLock || new Object();
                        _this.setSynchronous(false);
                        _this.setToken(fm.liveswitch.signalling.Client.generateToken());
                        _this.setUserId(fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", ""));
                        _this.setDeviceId(fm.liveswitch.StringExtensions.replace(fm.liveswitch.Guid.newGuid().toString(), "-", ""));
                        if ((!fm.liveswitch.Global.equals(fm.liveswitch.Platform.getInstance().getSourceLanguage(), fm.liveswitch.SourceLanguage.TypeScript))) {
                            _this.setDisableWebSockets(true);
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                Client.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.Client]' + ',' + _super.prototype.getTypeString.call(this);
                };
                Client.prototype.fmliveswitchsignallingClientInit = function () {
                    var _this = this;
                    this.__onBindFailure = [];
                    this.__onBindSuccess = [];
                    this.__onClientChannelReceive = [];
                    this.__onConnectFailure = [];
                    this.__onConnectSuccess = [];
                    this.__onDeviceChannelReceive = [];
                    this.__onDisconnectComplete = [];
                    this.__onPublishFailure = [];
                    this.__onPublishSuccess = [];
                    this.__onServerBind = [];
                    this.__onServerSubscribe = [];
                    this.__onServerUnbind = [];
                    this.__onServerUnsubscribe = [];
                    this.__onServiceFailure = [];
                    this.__onServiceSuccess = [];
                    this.__onStateChange = [];
                    this.__onSubscribeFailure = [];
                    this.__onSubscribeSuccess = [];
                    this.__onUnbindFailure = [];
                    this.__onUnbindSuccess = [];
                    this.__onUnsubscribeFailure = [];
                    this.__onUnsubscribeSuccess = [];
                    this.__onUserChannelReceive = [];
                    this._batchCounter = 0;
                    this._counter = 0;
                    this._disableWebSockets = false;
                    this._lastInterval = 0;
                    this._onBindFailure = function (p0) { for (var _i = 0, _a = _this.__onBindFailure; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onBindSuccess = function (p0) { for (var _i = 0, _a = _this.__onBindSuccess; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onClientChannelReceive = function (p0) { for (var _i = 0, _a = _this.__onClientChannelReceive; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onConnectFailure = function (p0) { for (var _i = 0, _a = _this.__onConnectFailure; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onConnectSuccess = function (p0) { for (var _i = 0, _a = _this.__onConnectSuccess; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onDeviceChannelReceive = function (p0) { for (var _i = 0, _a = _this.__onDeviceChannelReceive; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onDisconnectComplete = function (p0) { for (var _i = 0, _a = _this.__onDisconnectComplete; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onPublishFailure = function (p0) { for (var _i = 0, _a = _this.__onPublishFailure; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onPublishSuccess = function (p0) { for (var _i = 0, _a = _this.__onPublishSuccess; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onServerBind = function (p0) { for (var _i = 0, _a = _this.__onServerBind; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onServerSubscribe = function (p0) { for (var _i = 0, _a = _this.__onServerSubscribe; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onServerUnbind = function (p0) { for (var _i = 0, _a = _this.__onServerUnbind; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onServerUnsubscribe = function (p0) { for (var _i = 0, _a = _this.__onServerUnsubscribe; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onServiceFailure = function (p0) { for (var _i = 0, _a = _this.__onServiceFailure; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onServiceSuccess = function (p0) { for (var _i = 0, _a = _this.__onServiceSuccess; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onStateChange = function (p0) { for (var _i = 0, _a = _this.__onStateChange; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onSubscribeFailure = function (p0) { for (var _i = 0, _a = _this.__onSubscribeFailure; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onSubscribeSuccess = function (p0) { for (var _i = 0, _a = _this.__onSubscribeSuccess; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onUnbindFailure = function (p0) { for (var _i = 0, _a = _this.__onUnbindFailure; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onUnbindSuccess = function (p0) { for (var _i = 0, _a = _this.__onUnbindSuccess; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onUnsubscribeFailure = function (p0) { for (var _i = 0, _a = _this.__onUnsubscribeFailure; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onUnsubscribeSuccess = function (p0) { for (var _i = 0, _a = _this.__onUnsubscribeSuccess; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._onUserChannelReceive = function (p0) { for (var _i = 0, _a = _this.__onUserChannelReceive; _i < _a.length; _i++) {
                        var action = _a[_i];
                        action(p0);
                    } };
                    this._queueActivated = false;
                    this._receivedMessages = false;
                    this._serverTimeout = 0;
                    this._synchronous = false;
                    this._webSocketOpened = false;
                };
                Client.addOnBindEnd = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onBindEnd, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnBindRequest = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onBindRequest, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnBindResponse = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onBindResponse, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnConnectEnd = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onConnectEnd, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnConnectRequest = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onConnectRequest, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnConnectResponse = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onConnectResponse, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnDisconnectEnd = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onDisconnectEnd, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnDisconnectRequest = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onDisconnectRequest, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnDisconnectResponse = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onDisconnectResponse, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnPublishEnd = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onPublishEnd, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnPublishRequest = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onPublishRequest, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnPublishResponse = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onPublishResponse, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnServiceEnd = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onServiceEnd, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnServiceRequest = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onServiceRequest, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnServiceResponse = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onServiceResponse, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnSubscribeEnd = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onSubscribeEnd, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnSubscribeRequest = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onSubscribeRequest, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnSubscribeResponse = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onSubscribeResponse, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnUnbindEnd = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onUnbindEnd, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnUnbindRequest = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onUnbindRequest, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnUnbindResponse = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onUnbindResponse, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnUnsubscribeEnd = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onUnsubscribeEnd, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnUnsubscribeRequest = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onUnsubscribeRequest, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.addOnUnsubscribeResponse = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onUnsubscribeResponse, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.generateToken = function () {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 0) {
                        var str = fm.liveswitch.NumberExtensions.toString(fm.liveswitch.DateTime.getUtcNow().getTicks());
                        return fm.liveswitch.StringExtensions.substring(str, (fm.liveswitch.StringExtensions.getLength(str) - 12), 8);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.getBindIsPrivateForSubscribe = function (response, subscribeArgs) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 2) {
                        if ((fm.liveswitch.Global.equals(response, null))) {
                            return subscribeArgs.getBindIsPrivate();
                        }
                        if (!(response.getIsPrivate() != null)) {
                            return subscribeArgs.getBindIsPrivate();
                        }
                        return response.getIsPrivate();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.getBindRecordsForSubscribe = function (response, subscribeArgs) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 2) {
                        if ((fm.liveswitch.Global.equals(response, null))) {
                            return subscribeArgs.__bindRecords;
                        }
                        if ((fm.liveswitch.Global.equals(response.getRecords(), null))) {
                            return subscribeArgs.__bindRecords;
                        }
                        return response.getRecords();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.getChannelForPublish = function (response, publishArgs) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 2) {
                        if ((fm.liveswitch.Global.equals(response, null))) {
                            return publishArgs.__channel;
                        }
                        if ((fm.liveswitch.Global.equals(response.getChannel(), null))) {
                            return publishArgs.__channel;
                        }
                        return response.getChannel();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.getChannelForService = function (response, serviceArgs) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 2) {
                        if ((fm.liveswitch.Global.equals(response, null))) {
                            return serviceArgs.__channel;
                        }
                        if ((fm.liveswitch.Global.equals(response.getChannel(), null))) {
                            return serviceArgs.__channel;
                        }
                        return response.getChannel();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.getChannelsForSubscribe = function (response, subscribeArgs) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 2) {
                        if ((fm.liveswitch.Global.equals(response, null))) {
                            return subscribeArgs.__channels;
                        }
                        if ((fm.liveswitch.Global.equals(response.getChannels(), null))) {
                            return subscribeArgs.__channels;
                        }
                        return response.getChannels();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.getChannelsForUnsubscribe = function (response, unsubscribeArgs) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 2) {
                        if ((fm.liveswitch.Global.equals(response, null))) {
                            return unsubscribeArgs.__channels;
                        }
                        if ((fm.liveswitch.Global.equals(response.getChannels(), null))) {
                            return unsubscribeArgs.__channels;
                        }
                        return response.getChannels();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.getDataBytesForPublish = function (response, publishArgs) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 2) {
                        if (((fm.liveswitch.Global.equals(response, null)) || (fm.liveswitch.Global.equals(response.getDataBytes(), null)))) {
                            return null;
                        }
                        return response.getDataBytes();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.getDataBytesForService = function (response, serviceArgs) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 2) {
                        if (((fm.liveswitch.Global.equals(response, null)) || (fm.liveswitch.Global.equals(response.getDataBytes(), null)))) {
                            return null;
                        }
                        return response.getDataBytes();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.getDataJsonForPublish = function (response, publishArgs) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 2) {
                        if (((fm.liveswitch.Global.equals(response, null)) || (fm.liveswitch.Global.equals(response.getDataJson(), null)))) {
                            return null;
                        }
                        return response.getDataJson();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.getDataJsonForService = function (response, serviceArgs) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 2) {
                        if (((fm.liveswitch.Global.equals(response, null)) || (fm.liveswitch.Global.equals(response.getDataJson(), null)))) {
                            return null;
                        }
                        return response.getDataJson();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.getExtensions = function (response, methodArgs) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 2) {
                        if ((!fm.liveswitch.Global.equals(response, null))) {
                            return response.getExtensions();
                        }
                        return methodArgs.getExtensions();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.getIsPrivateForBind = function (response, bindArgs) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 2) {
                        if ((fm.liveswitch.Global.equals(response, null))) {
                            return bindArgs.getIsPrivate();
                        }
                        if (!(response.getIsPrivate() != null)) {
                            return bindArgs.getIsPrivate();
                        }
                        return response.getIsPrivate();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.getKeysForUnbind = function (response, unbindArgs) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 2) {
                        if ((fm.liveswitch.Global.equals(response, null))) {
                            return unbindArgs.__keys;
                        }
                        if ((fm.liveswitch.Global.equals(response.getKeys(), null))) {
                            return unbindArgs.__keys;
                        }
                        return response.getKeys();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.getRecordsForBind = function (response, bindArgs) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 2) {
                        if ((fm.liveswitch.Global.equals(response, null))) {
                            return bindArgs.__records;
                        }
                        if ((fm.liveswitch.Global.equals(response.getRecords(), null))) {
                            return bindArgs.__records;
                        }
                        return response.getRecords();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.getSubscribedClientsForSubscribe = function (response, subscribeArgs) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 2) {
                        if ((fm.liveswitch.Global.equals(response, null))) {
                            return null;
                        }
                        if ((fm.liveswitch.Global.equals(response.getSubscribedClients(), null))) {
                            return null;
                        }
                        return response.getSubscribedClients();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.getSubscriptionKey = function (channel, tag) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 2) {
                        if ((fm.liveswitch.Global.equals(tag, null))) {
                            return fm.liveswitch.StringExtensions.format("-1|{0}", channel);
                        }
                        return fm.liveswitch.StringExtensions.format("{0}|{1}{2}", fm.liveswitch.NumberExtensions.toString(fm.liveswitch.StringExtensions.getLength(tag)), tag, channel);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.getTimestamp = function (response) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        if ((!fm.liveswitch.Global.equals(response, null))) {
                            return response.getTimestamp();
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.getUnbindKeysForUnsubscribe = function (response, unsubscribeArgs) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 2) {
                        if ((fm.liveswitch.Global.equals(response, null))) {
                            return unsubscribeArgs.__unbindKeys;
                        }
                        if ((fm.liveswitch.Global.equals(response.getKeys(), null))) {
                            return unsubscribeArgs.__unbindKeys;
                        }
                        return response.getKeys();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnBindEnd = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onBindEnd, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnBindRequest = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onBindRequest, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnBindResponse = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onBindResponse, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnConnectEnd = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onConnectEnd, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnConnectRequest = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onConnectRequest, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnConnectResponse = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onConnectResponse, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnDisconnectEnd = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onDisconnectEnd, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnDisconnectRequest = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onDisconnectRequest, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnDisconnectResponse = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onDisconnectResponse, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnPublishEnd = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onPublishEnd, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnPublishRequest = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onPublishRequest, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnPublishResponse = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onPublishResponse, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnServiceEnd = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onServiceEnd, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnServiceRequest = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onServiceRequest, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnServiceResponse = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onServiceResponse, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnSubscribeEnd = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onSubscribeEnd, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnSubscribeRequest = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onSubscribeRequest, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnSubscribeResponse = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onSubscribeResponse, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnUnbindEnd = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onUnbindEnd, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnUnbindRequest = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onUnbindRequest, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnUnbindResponse = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onUnbindResponse, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnUnsubscribeEnd = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onUnsubscribeEnd, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnUnsubscribeRequest = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onUnsubscribeRequest, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.removeOnUnsubscribeResponse = function (value) {
                    fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onUnsubscribeResponse, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.activateStream = function () {
                    if (arguments.length == 0) {
                        this.processQueue(true);
                        this._receivedMessages = false;
                        this.stream();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.addBoundRecords = function (boundRecords) {
                    if (arguments.length == 1) {
                        for (var _i = 0, boundRecords_1 = boundRecords; _i < boundRecords_1.length; _i++) {
                            var record = boundRecords_1[_i];
                            this._boundRecords.add(record);
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnBindFailure = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onBindFailure, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnBindSuccess = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onBindSuccess, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnClientChannelReceive = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onClientChannelReceive, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnConnectFailure = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onConnectFailure, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnConnectSuccess = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onConnectSuccess, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnDeviceChannelReceive = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onDeviceChannelReceive, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnDisconnectComplete = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onDisconnectComplete, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnPublishFailure = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onPublishFailure, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnPublishSuccess = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onPublishSuccess, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnServerBind = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onServerBind, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnServerSubscribe = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onServerSubscribe, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnServerUnbind = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onServerUnbind, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnServerUnsubscribe = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onServerUnsubscribe, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnServiceFailure = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onServiceFailure, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnServiceSuccess = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onServiceSuccess, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnStateChange = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onStateChange, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnSubscribeFailure = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onSubscribeFailure, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnSubscribeSuccess = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onSubscribeSuccess, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnUnbindFailure = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onUnbindFailure, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnUnbindSuccess = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onUnbindSuccess, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnUnsubscribeFailure = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onUnsubscribeFailure, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnUnsubscribeSuccess = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onUnsubscribeSuccess, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.addOnUserChannelReceive = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.add(this.__onUserChannelReceive, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.addSubscribedChannels = function (tag, channels) {
                    if (arguments.length == 2) {
                        var dictionary = null;
                        var _var0 = new fm.liveswitch.Holder(dictionary);
                        var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this._subscribedChannels, tag, _var0);
                        dictionary = _var0.getValue();
                        if (!_var1) {
                            dictionary = {};
                            this._subscribedChannels[tag] = dictionary;
                        }
                        for (var _i = 0, channels_5 = channels; _i < channels_5.length; _i++) {
                            var str = channels_5[_i];
                            if (!fm.liveswitch.HashExtensions.containsKey(dictionary, str)) {
                                dictionary[str] = new Object();
                            }
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.addSubscribedOnPresence = function (tag, channels, onPresence, dynamicProperties, reconnectAfter) {
                    if (arguments.length == 5) {
                        if ((!fm.liveswitch.Global.equals(onPresence, null))) {
                            var dictionary = null;
                            var _var0 = new fm.liveswitch.Holder(dictionary);
                            var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this._subscribedOnPresences, tag, _var0);
                            dictionary = _var0.getValue();
                            if (!_var1) {
                                dictionary = {};
                                this._subscribedOnPresences[tag] = dictionary;
                            }
                            for (var _i = 0, channels_6 = channels; _i < channels_6.length; _i++) {
                                var str = channels_6[_i];
                                dictionary[str] = onPresence;
                                this._subscribedOnPresencesDynamicProperties[fm.liveswitch.signalling.Client.getSubscriptionKey(str, tag)] = dynamicProperties;
                            }
                            reconnectAfter = this.processPendingReceives(channels, reconnectAfter);
                        }
                        return reconnectAfter;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.addSubscribedOnReceive = function (tag, channels, onReceive, dynamicProperties, reconnectAfter) {
                    if (arguments.length == 5) {
                        var dictionary = null;
                        var _var0 = new fm.liveswitch.Holder(dictionary);
                        var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this._subscribedOnReceives, tag, _var0);
                        dictionary = _var0.getValue();
                        if (!_var1) {
                            dictionary = {};
                            this._subscribedOnReceives[tag] = dictionary;
                        }
                        for (var _i = 0, channels_7 = channels; _i < channels_7.length; _i++) {
                            var str = channels_7[_i];
                            dictionary[str] = onReceive;
                            this._subscribedOnReceivesDynamicProperties[fm.liveswitch.signalling.Client.getSubscriptionKey(str, tag)] = dynamicProperties;
                        }
                        reconnectAfter = this.processPendingReceives(channels, reconnectAfter);
                        return reconnectAfter;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.addToQueue = function (request, url, synchronous, timeout, maxRetries) {
                    if (arguments.length == 5) {
                        url = fm.liveswitch.StringExtensions.nullCoalesce(url, _super.prototype.getRequestUrl.call(this));
                        var key = fm.liveswitch.StringExtensions.format("{0}+{1}|{2}{3}", [fm.liveswitch.NumberExtensions.toString(timeout), fm.liveswitch.NumberExtensions.toString(maxRetries), (synchronous ? "1" : "0"), url]);
                        if (!fm.liveswitch.HashExtensions.containsKey(this._requestQueue, key)) {
                            this._requestQueue[key] = new Array();
                        }
                        fm.liveswitch.ArrayExtensions.add(this._requestQueue[key], request);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.bind = function (bindArgs) {
                    var _this = this;
                    if (arguments.length == 1) {
                        var action = null;
                        if (((fm.liveswitch.Global.equals(bindArgs.getRecords(), null)) || (fm.liveswitch.Global.equals(bindArgs.getRecords().length, 0)))) {
                            this.raiseBindFailure(bindArgs, this.createFailureResponse(bindArgs, "Records cannot be null."));
                            return this;
                        }
                        for (var _i = 0, _a = bindArgs.getRecords(); _i < _a.length; _i++) {
                            var record = _a[_i];
                            if ((fm.liveswitch.Global.equals(record.getKey(), null))) {
                                this.raiseBindFailure(bindArgs, this.createFailureResponse(bindArgs, "Records cannot have null keys."));
                                return this;
                            }
                            if ((fm.liveswitch.Global.equals(record.getValueJson(), null))) {
                                this.raiseBindFailure(bindArgs, this.createFailureResponse(bindArgs, "Records cannot have null values."));
                                return this;
                            }
                        }
                        if (!this.raiseRequestEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onBindRequest, new fm.liveswitch.signalling.ClientBindRequestArgs(bindArgs), "OnBindRequest")) {
                            var response = this.createFailureResponse(bindArgs, "Application cancelled request.");
                            this.raiseResponseEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onBindResponse, new fm.liveswitch.signalling.ClientBindResponseArgs(bindArgs), "OnBindResponse", response);
                            this.raiseBindFailure(bindArgs, response);
                            this.raiseEndEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onBindEnd, new fm.liveswitch.signalling.ClientBindEndArgs(bindArgs), "OnBindEnd", response);
                            return this;
                        }
                        var request = new fm.liveswitch.signalling.ClientRequest();
                        var message = new fm.liveswitch.signalling.Message(fm.liveswitch.signalling.MetaChannels.getBind());
                        message.setValidate(false);
                        message.setRecords(bindArgs.getRecords());
                        message.setIsPrivate(bindArgs.getIsPrivate());
                        message.setExtensions(bindArgs.getExtensions());
                        request.setMessage(message);
                        if ((fm.liveswitch.Global.equals(action, null))) {
                            action = function (responseArgs) {
                                _this.raiseResponseEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onBindResponse, new fm.liveswitch.signalling.ClientBindResponseArgs(bindArgs), "OnBindResponse", responseArgs);
                                if ((!fm.liveswitch.Global.equals(responseArgs.getException(), null))) {
                                    _this.raiseBindFailure(bindArgs, responseArgs);
                                }
                                else {
                                    _this.addBoundRecords(responseArgs.getMessage().getRecords());
                                    _this.raiseBindSuccess(bindArgs, responseArgs);
                                }
                                _this.raiseEndEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onBindEnd, new fm.liveswitch.signalling.ClientBindEndArgs(bindArgs), "OnBindEnd", responseArgs);
                            };
                        }
                        request.setCallback(action);
                        this.addToQueue(request, bindArgs.getRequestUrl(), this.checkSynchronous(bindArgs.getSynchronous()), ((bindArgs.getRequestTimeout() != null) ? bindArgs.getRequestTimeout() : 0), ((bindArgs.getRequestMaxRetries() != null) ? bindArgs.getRequestMaxRetries() : 0));
                        this.processQueue(false);
                        return this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.bindAsync = function () {
                    if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.signalling.BindArgs]'))) {
                        var bindArgs = arguments[0];
                        return this.doBindAsync(bindArgs, bindArgs.getOnSuccess(), bindArgs.getOnFailure(), new fm.liveswitch.Promise());
                    }
                    else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.signalling.Record]'))) {
                        var record = arguments[0];
                        return this.bindAsync(new fm.liveswitch.signalling.BindArgs(record));
                    }
                    else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isObjectType(arguments[0][0], '[fm.liveswitch.signalling.Record]')))))) {
                        var records = arguments[0];
                        return this.bindAsync(new fm.liveswitch.signalling.BindArgs(records));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.checkSynchronous = function (synchronous) {
                    if (arguments.length == 1) {
                        if ((synchronous != null)) {
                            return synchronous;
                        }
                        if ((this.getSynchronous() != null)) {
                            return this.getSynchronous();
                        }
                        return false;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.clearBoundRecords = function () {
                    if (arguments.length == 0) {
                        this._boundRecords.clear();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.clearSubscribedChannels = function () {
                    if (arguments.length == 0) {
                        var obj2 = void 0;
                        fm.liveswitch.HashExtensions.clear(this._subscribedChannels);
                        fm.liveswitch.HashExtensions.clear(this._customOnReceives);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.connect = function () {
                    var _this = this;
                    if (arguments.length == 0) {
                        return this.connect(new fm.liveswitch.signalling.ConnectArgs());
                    }
                    else if (arguments.length == 1) {
                        var connectArgs_1 = arguments[0];
                        var action = null;
                        var response = void 0;
                        if (!this.raiseRequestEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onConnectRequest, new fm.liveswitch.signalling.ClientConnectRequestArgs(connectArgs_1), "OnConnectRequest")) {
                            response = this.createFailureResponse(connectArgs_1, "Application cancelled request.");
                            this.raiseResponseEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onConnectResponse, new fm.liveswitch.signalling.ClientConnectResponseArgs(connectArgs_1), "OnConnectResponse", response);
                            this.raiseConnectFailure(connectArgs_1, response);
                            this.raiseEndEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onConnectEnd, new fm.liveswitch.signalling.ClientConnectEndArgs(connectArgs_1), "OnConnectEnd", response);
                            return this;
                        }
                        if (((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.signalling.ClientState.Connected)) || (fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.signalling.ClientState.Connecting)))) {
                            var error = ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.signalling.ClientState.Connecting)) ? "Client is already connecting." : "Client is already connected.");
                            response = this.createFailureResponse(connectArgs_1, error);
                            this.raiseResponseEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onConnectResponse, new fm.liveswitch.signalling.ClientConnectResponseArgs(connectArgs_1), "OnConnectResponse", response);
                            this.raiseConnectFailure(connectArgs_1, response);
                            this.raiseEndEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onConnectEnd, new fm.liveswitch.signalling.ClientConnectEndArgs(connectArgs_1), "OnConnectEnd", response);
                            return this;
                        }
                        this.setState(fm.liveswitch.signalling.ClientState.Connecting);
                        var list = new Array();
                        if (!this.getDisableWebSockets()) {
                            fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.signalling.ConnectionType.WebSocket);
                        }
                        fm.liveswitch.ArrayExtensions.add(list, fm.liveswitch.signalling.ConnectionType.LongPolling);
                        this._supportedConnectionTypes = fm.liveswitch.ArrayExtensions.toArray(list);
                        this.setDisconnectException(null);
                        var request = new fm.liveswitch.signalling.ClientRequest();
                        var message = new fm.liveswitch.signalling.Message(fm.liveswitch.signalling.MetaChannels.getHandshake());
                        message.setClientId(this.getClientId());
                        message.setStreamId(this.getStreamId());
                        message.setAuthToken(this.getAuthToken());
                        message.setUserId(this.getUserId());
                        message.setDeviceId(this.getDeviceId());
                        message.setVersion(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__bayeuxVersion);
                        message.setMinimumVersion(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__bayeuxMinimumVersion);
                        message.setSupportedConnectionTypes(this._supportedConnectionTypes);
                        message.setExtensions(connectArgs_1.getExtensions());
                        request.setMessage(message);
                        if ((fm.liveswitch.Global.equals(action, null))) {
                            action = function (responseArgs) {
                                _this.raiseResponseEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onConnectResponse, new fm.liveswitch.signalling.ClientConnectResponseArgs(connectArgs_1), "OnConnectResponse", responseArgs);
                                if ((fm.liveswitch.Global.equals(responseArgs.getException(), null))) {
                                    _this.setClientId(responseArgs.getMessage().getClientId());
                                    _this.setStreamId(responseArgs.getMessage().getStreamId());
                                    _this.setAuthToken(responseArgs.getMessage().getAuthToken());
                                    var serverTimeout = responseArgs.getMessage().getServerTimeout();
                                    if ((serverTimeout != null)) {
                                        _this.setServerTimeout(serverTimeout);
                                    }
                                    else {
                                        _this.setServerTimeout(25000);
                                    }
                                    var index = 2147483647;
                                    for (var _i = 0, _a = responseArgs.getMessage().getSupportedConnectionTypes(); _i < _a.length; _i++) {
                                        var type = _a[_i];
                                        for (var j = 0; (j < _this._supportedConnectionTypes.length); j++) {
                                            if ((fm.liveswitch.Global.equals(_this._supportedConnectionTypes[j], type))) {
                                                if ((j < index)) {
                                                    index = j;
                                                }
                                                break;
                                            }
                                        }
                                    }
                                    if (((index < 0) || (index > _this._supportedConnectionTypes.length))) {
                                        responseArgs.setFailureSource(fm.liveswitch.FailureSource.Message);
                                        responseArgs.setException(new fm.liveswitch.Exception("Could not negotiate a connection type with the server."));
                                    }
                                    else {
                                        _this._connectionType = _this._supportedConnectionTypes[index];
                                    }
                                }
                                if ((!fm.liveswitch.Global.equals(responseArgs.getException(), null))) {
                                    _this.setDisconnectException(responseArgs.getException());
                                    _this.setState(fm.liveswitch.signalling.ClientState.Disconnected);
                                    _this.raiseConnectFailure(connectArgs_1, responseArgs);
                                    _this.raiseEndEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onConnectEnd, new fm.liveswitch.signalling.ClientConnectEndArgs(connectArgs_1), "OnConnectEnd", responseArgs);
                                }
                                else {
                                    if (((fm.liveswitch.Global.equals(_this._connectionType, fm.liveswitch.signalling.ConnectionType.WebSocket)) && !_this.getDisableWebSockets())) {
                                        if (!_this.tryWebSocket()) {
                                            _this.doLongPolling();
                                        }
                                    }
                                    else {
                                        _this.doLongPolling();
                                    }
                                    _this.setState(fm.liveswitch.signalling.ClientState.Connected);
                                    _this.raiseConnectSuccess(connectArgs_1, responseArgs);
                                    _this.raiseEndEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onConnectEnd, new fm.liveswitch.signalling.ClientConnectEndArgs(connectArgs_1), "OnConnectEnd", responseArgs);
                                }
                            };
                        }
                        request.setCallback(action);
                        this.send(request, connectArgs_1.getRequestUrl(), this.checkSynchronous(connectArgs_1.getSynchronous()), ((connectArgs_1.getRequestTimeout() != null) ? connectArgs_1.getRequestTimeout() : 0), ((connectArgs_1.getRequestMaxRetries() != null) ? connectArgs_1.getRequestMaxRetries() : 0));
                        return this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.connectAsync = function () {
                    if (arguments.length == 0) {
                        return this.connectAsync(new fm.liveswitch.signalling.ConnectArgs());
                    }
                    else if (arguments.length == 1) {
                        var connectArgs = arguments[0];
                        return this.doConnectAsync(connectArgs, connectArgs.getOnSuccess(), connectArgs.getOnFailure(), new fm.liveswitch.Promise());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.createFailureResponse = function (requestArgs, error) {
                    if (arguments.length == 2) {
                        var response = new fm.liveswitch.signalling.ClientResponse();
                        response.setDynamicProperties(requestArgs.getDynamicProperties());
                        var message = new fm.liveswitch.signalling.Message(fm.liveswitch.signalling.MetaChannels.getHandshake());
                        message.setExtensions(requestArgs.getExtensions());
                        message.setTimestamp(fm.liveswitch.DateTime.getUtcNow());
                        message.setSuccessful(false);
                        message.setError(error);
                        response.setMessage(message);
                        response.setFailureSource(fm.liveswitch.FailureSource.Message);
                        response.setException(new fm.liveswitch.Exception(error));
                        return response;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.disconnect = function () {
                    var _this = this;
                    if (arguments.length == 0) {
                        return this.disconnect(new fm.liveswitch.signalling.DisconnectArgs());
                    }
                    else if (arguments.length == 1) {
                        var disconnectArgs_1 = arguments[0];
                        var action = null;
                        if (!this.raiseRequestEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onDisconnectRequest, new fm.liveswitch.signalling.ClientDisconnectRequestArgs(disconnectArgs_1), "OnDisconnectRequest")) {
                            var response = this.createFailureResponse(disconnectArgs_1, "Application cancelled request.");
                            this.raiseResponseEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onDisconnectResponse, new fm.liveswitch.signalling.ClientDisconnectResponseArgs(disconnectArgs_1), "OnDisconnectResponse", response);
                            this.raiseDisconnectComplete(disconnectArgs_1, response);
                            this.raiseEndEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onDisconnectEnd, new fm.liveswitch.signalling.ClientDisconnectEndArgs(disconnectArgs_1), "OnDisconnectEnd", response);
                            return this;
                        }
                        if (((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.signalling.ClientState.Disconnecting)) || (fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.signalling.ClientState.Disconnected)))) {
                            var str = ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.signalling.ClientState.Disconnecting)) ? "Client is already disconnecting." : "Client is already disconnected.");
                            var response3 = new fm.liveswitch.signalling.ClientResponse();
                            response3.setDynamicProperties(disconnectArgs_1.getDynamicProperties());
                            var message = new fm.liveswitch.signalling.Message(fm.liveswitch.signalling.MetaChannels.getHandshake());
                            message.setExtensions(disconnectArgs_1.getExtensions());
                            message.setTimestamp(fm.liveswitch.DateTime.getUtcNow());
                            message.setSuccessful(false);
                            message.setError(str);
                            response3.setMessage(message);
                            response3.setFailureSource(fm.liveswitch.FailureSource.Message);
                            response3.setException(new fm.liveswitch.Exception(str));
                            var response2 = response3;
                            this.raiseResponseEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onDisconnectResponse, new fm.liveswitch.signalling.ClientDisconnectResponseArgs(disconnectArgs_1), "OnDisconnectResponse", response2);
                            this.raiseDisconnectComplete(disconnectArgs_1, response2);
                            this.raiseEndEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onDisconnectEnd, new fm.liveswitch.signalling.ClientDisconnectEndArgs(disconnectArgs_1), "OnDisconnectEnd", response2);
                            return this;
                        }
                        this.setState(fm.liveswitch.signalling.ClientState.Disconnecting);
                        var request = new fm.liveswitch.signalling.ClientRequest();
                        var message2 = new fm.liveswitch.signalling.Message(fm.liveswitch.signalling.MetaChannels.getDisconnect());
                        message2.setExtensions(disconnectArgs_1.getExtensions());
                        request.setMessage(message2);
                        if ((fm.liveswitch.Global.equals(action, null))) {
                            action = function (responseArgs) {
                                _this.raiseResponseEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onDisconnectResponse, new fm.liveswitch.signalling.ClientDisconnectResponseArgs(disconnectArgs_1), "OnDisconnectResponse", responseArgs);
                                _this._webSocketOpened = false;
                                _this.setDisconnectException(null);
                                _this.setState(fm.liveswitch.signalling.ClientState.Disconnected);
                                _this.raiseDisconnectComplete(disconnectArgs_1, responseArgs);
                                _this.raiseEndEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onDisconnectEnd, new fm.liveswitch.signalling.ClientDisconnectEndArgs(disconnectArgs_1), "OnDisconnectEnd", responseArgs);
                            };
                        }
                        request.setCallback(action);
                        this.addToQueue(request, disconnectArgs_1.getRequestUrl(), this.checkSynchronous(disconnectArgs_1.getSynchronous()), ((disconnectArgs_1.getRequestTimeout() != null) ? disconnectArgs_1.getRequestTimeout() : 0), ((disconnectArgs_1.getRequestMaxRetries() != null) ? disconnectArgs_1.getRequestMaxRetries() : 0));
                        this.processQueue(false);
                        return this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.disconnectAsync = function () {
                    if (arguments.length == 0) {
                        return this.disconnectAsync(new fm.liveswitch.signalling.DisconnectArgs());
                    }
                    else if (arguments.length == 1) {
                        var disconnectArgs = arguments[0];
                        return this.doDisconnectAsync(disconnectArgs, disconnectArgs.getOnComplete(), new fm.liveswitch.Promise());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.doBindAsync = function (bindArgs, onSuccess, onFailure, promise) {
                    if (arguments.length == 4) {
                        bindArgs.setOnSuccess(function (e) {
                            if ((!fm.liveswitch.Global.equals(onSuccess, null))) {
                                onSuccess(e);
                            }
                            promise.resolve(e);
                        });
                        bindArgs.setOnFailure(function (e) {
                            if ((!fm.liveswitch.Global.equals(onFailure, null))) {
                                onFailure(e);
                            }
                            promise.reject(e.getException());
                        });
                        this.bind(bindArgs);
                        return promise;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.doConnectAsync = function (connectArgs, onSuccess, onFailure, promise) {
                    if (arguments.length == 4) {
                        connectArgs.setOnSuccess(function (e) {
                            if ((!fm.liveswitch.Global.equals(onSuccess, null))) {
                                onSuccess(e);
                            }
                            promise.resolve(e);
                        });
                        connectArgs.setOnFailure(function (e) {
                            if ((!fm.liveswitch.Global.equals(onFailure, null))) {
                                onFailure(e);
                            }
                            promise.reject(e.getException());
                        });
                        this.connect(connectArgs);
                        return promise;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.doDisconnectAsync = function (disconnectArgs, onComplete, promise) {
                    if (arguments.length == 3) {
                        disconnectArgs.setOnComplete(function (e) {
                            if ((!fm.liveswitch.Global.equals(onComplete, null))) {
                                onComplete(e);
                            }
                            if ((fm.liveswitch.Global.equals(e.getException(), null))) {
                                promise.resolve(e);
                            }
                            else {
                                promise.reject(e.getException());
                            }
                        });
                        this.disconnect(disconnectArgs);
                        return promise;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.doLongPolling = function () {
                    if (arguments.length == 0) {
                        this._connectionType = fm.liveswitch.signalling.ConnectionType.LongPolling;
                        this._streamRequestTransfer = fm.liveswitch.signalling.MessageTransferFactory.getHttpMessageTransfer();
                        this.activateStream();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.doPublishAsync = function (publishArgs, onSuccess, onFailure, promise) {
                    if (arguments.length == 4) {
                        publishArgs.setOnSuccess(function (e) {
                            if ((!fm.liveswitch.Global.equals(onSuccess, null))) {
                                onSuccess(e);
                            }
                            promise.resolve(e);
                        });
                        publishArgs.setOnFailure(function (e) {
                            if ((!fm.liveswitch.Global.equals(onFailure, null))) {
                                onFailure(e);
                            }
                            promise.reject(e.getException());
                        });
                        this.publish(publishArgs);
                        return promise;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.doSendMany = function (synchronous, requestTransfer, requestArgs, state) {
                    var _this = this;
                    if (arguments.length == 4) {
                        var callback = null;
                        var num = void 0;
                        if (synchronous) {
                            if (fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___log.getIsVerboseEnabled()) {
                                num = requestArgs.getMessages().length;
                                fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___log.verbose(fm.liveswitch.StringExtensions.format("Starting synchronous send for {0} messages...", fm.liveswitch.NumberExtensions.toString(num)));
                            }
                            var responseArgs = requestTransfer.send(requestArgs);
                            if (fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___log.getIsVerboseEnabled()) {
                                num = requestArgs.getMessages().length;
                                fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___log.verbose(fm.liveswitch.StringExtensions.format("Finished synchronous send for {0} messages.", fm.liveswitch.NumberExtensions.toString(num)));
                            }
                            this.sendCallback(state, responseArgs);
                        }
                        else {
                            if (fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___log.getIsVerboseEnabled()) {
                                num = requestArgs.getMessages().length;
                                fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___log.verbose(fm.liveswitch.StringExtensions.format("Starting asynchronous send on {0} for {1} messages...", ((this._requestTransfer instanceof fm.liveswitch.signalling.WebSocketMessageTransfer) ? "websocket" : "http"), fm.liveswitch.NumberExtensions.toString(num)));
                            }
                            if ((fm.liveswitch.Global.equals(callback, null))) {
                                callback = function (responseArgs) {
                                    if (fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___log.getIsVerboseEnabled()) {
                                        var length_50 = requestArgs.getMessages().length;
                                        fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___log.verbose(fm.liveswitch.StringExtensions.format("Finished asynchronous send on {0} for {1} messages. Received {2} messages.", ((_this._requestTransfer instanceof fm.liveswitch.signalling.WebSocketMessageTransfer) ? "websocket" : "http"), fm.liveswitch.NumberExtensions.toString(length_50), ((!fm.liveswitch.Global.equals(responseArgs.getMessages(), null)) ? fm.liveswitch.NumberExtensions.toString(length_50 = responseArgs.getMessages().length) : "0")));
                                    }
                                    _this.sendCallback(state, responseArgs);
                                };
                            }
                            requestTransfer.sendAsync(requestArgs, callback);
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.doServiceAsync = function (serviceArgs, onSuccess, onFailure, promise) {
                    if (arguments.length == 4) {
                        serviceArgs.setOnSuccess(function (e) {
                            if ((!fm.liveswitch.Global.equals(onSuccess, null))) {
                                onSuccess(e);
                            }
                            promise.resolve(e);
                        });
                        serviceArgs.setOnFailure(function (e) {
                            if ((!fm.liveswitch.Global.equals(onFailure, null))) {
                                onFailure(e);
                            }
                            promise.reject(e.getException());
                        });
                        this.service(serviceArgs);
                        return promise;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.doSubscribeAsync = function (subscribeArgs, onSuccess, onFailure, promise) {
                    if (arguments.length == 4) {
                        subscribeArgs.setOnSuccess(function (e) {
                            if ((!fm.liveswitch.Global.equals(onSuccess, null))) {
                                onSuccess(e);
                            }
                            promise.resolve(e);
                        });
                        subscribeArgs.setOnFailure(function (e) {
                            if ((!fm.liveswitch.Global.equals(onFailure, null))) {
                                onFailure(e);
                            }
                            promise.reject(e.getException());
                        });
                        this.subscribe(subscribeArgs);
                        return promise;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.doUnbindAsync = function (unbindArgs, onSuccess, onFailure, promise) {
                    if (arguments.length == 4) {
                        unbindArgs.setOnSuccess(function (e) {
                            if ((!fm.liveswitch.Global.equals(onSuccess, null))) {
                                onSuccess(e);
                            }
                            promise.resolve(e);
                        });
                        unbindArgs.setOnFailure(function (e) {
                            if ((!fm.liveswitch.Global.equals(onFailure, null))) {
                                onFailure(e);
                            }
                            promise.reject(e.getException());
                        });
                        this.unbind(unbindArgs);
                        return promise;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.doUnsubscribeAsync = function (unsubscribeArgs, onSuccess, onFailure, promise) {
                    if (arguments.length == 4) {
                        unsubscribeArgs.setOnSuccess(function (e) {
                            if ((!fm.liveswitch.Global.equals(onSuccess, null))) {
                                onSuccess(e);
                            }
                            promise.resolve(e);
                        });
                        unsubscribeArgs.setOnFailure(function (e) {
                            if ((!fm.liveswitch.Global.equals(onFailure, null))) {
                                onFailure(e);
                            }
                            promise.reject(e.getException());
                        });
                        this.unsubscribe(unsubscribeArgs);
                        return promise;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.endBatch = function () {
                    if (arguments.length == 0) {
                        var flag = false;
                        this._batchCounter--;
                        if ((this._batchCounter <= 0)) {
                            this._batchCounter = 0;
                            flag = true;
                        }
                        if (flag) {
                            this.processQueue(false);
                        }
                        return this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.getAuthToken = function () {
                    if (arguments.length == 0) {
                        return this._authToken;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.getBoundRecords = function () {
                    if (arguments.length == 0) {
                        var records = new fm.liveswitch.signalling.Records();
                        for (var _i = 0, _a = this._boundRecords.getRecords(); _i < _a.length; _i++) {
                            var record = _a[_i];
                            records.add(record.duplicate());
                        }
                        return records;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.getClientId = function () {
                    if (arguments.length == 0) {
                        return this._clientId;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.getCustomOnReceive = function (channel) {
                    if (arguments.length == 1) {
                        return this.getCustomOnReceiveWithTag(channel, fm.liveswitch.StringExtensions.empty);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.getCustomOnReceiveWithTag = function (channel, tag) {
                    if (arguments.length == 2) {
                        if ((fm.liveswitch.Global.equals(channel, null))) {
                            throw new fm.liveswitch.Exception("channel cannot be null.");
                        }
                        if ((fm.liveswitch.Global.equals(tag, null))) {
                            tag = fm.liveswitch.StringExtensions.empty;
                        }
                        var action = null;
                        var dictionary = null;
                        var _var0 = new fm.liveswitch.Holder(dictionary);
                        var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this._customOnReceives, tag, _var0);
                        dictionary = _var0.getValue();
                        if (!_var1) {
                            return action;
                        }
                        var _var2 = new fm.liveswitch.Holder(action);
                        var _var3 = fm.liveswitch.HashExtensions.tryGetValue(dictionary, channel, _var2);
                        action = _var2.getValue();
                        if (!_var3) {
                            action = null;
                        }
                        return action;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.getDeviceId = function () {
                    if (arguments.length == 0) {
                        return this._deviceId;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.getDisableWebSockets = function () {
                    if (arguments.length == 0) {
                        return this._disableWebSockets;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.getDisconnectException = function () {
                    if (arguments.length == 0) {
                        return this._disconnectException;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.getServerTimeout = function () {
                    if (arguments.length == 0) {
                        return this._serverTimeout;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.getState = function () {
                    if (arguments.length == 0) {
                        return this.__state;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.getStreamId = function () {
                    if (arguments.length == 0) {
                        return this._streamId;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.getStreamRequestTimeout = function () {
                    if (arguments.length == 0) {
                        return (_super.prototype.getRequestTimeout.call(this) + this.getServerTimeout());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.getStreamRequestUrl = function () {
                    if (arguments.length == 0) {
                        return this.__streamRequestUrl;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.getSubscribedChannels = function () {
                    if (arguments.length == 0) {
                        var list = new Array();
                        for (var _i = 0, _a = fm.liveswitch.HashExtensions.getKeys(this._subscribedChannels); _i < _a.length; _i++) {
                            var str = _a[_i];
                            for (var _b = 0, _c = fm.liveswitch.HashExtensions.getKeys(this._subscribedChannels[str]); _b < _c.length; _b++) {
                                var str2 = _c[_b];
                                fm.liveswitch.ArrayExtensions.add(list, str2);
                            }
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else if (arguments.length == 1) {
                        var tag = arguments[0];
                        var list = new Array();
                        var dictionary = null;
                        var _var0 = new fm.liveswitch.Holder(dictionary);
                        var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this._subscribedChannels, tag, _var0);
                        dictionary = _var0.getValue();
                        if (!_var1) {
                            dictionary = null;
                        }
                        if ((!fm.liveswitch.Global.equals(dictionary, null))) {
                            for (var _d = 0, _e = fm.liveswitch.HashExtensions.getKeys(dictionary); _d < _e.length; _d++) {
                                var str = _e[_d];
                                fm.liveswitch.ArrayExtensions.add(list, str);
                            }
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.getSynchronous = function () {
                    if (arguments.length == 0) {
                        return this._synchronous;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.getToken = function () {
                    if (arguments.length == 0) {
                        return this._token;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.getUserId = function () {
                    if (arguments.length == 0) {
                        return this._userId;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.inBatch = function () {
                    if (arguments.length == 0) {
                        return (this._batchCounter > 0);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.processAdvice = function (advice) {
                    if (arguments.length == 1) {
                        if ((advice.getInterval() != null)) {
                            this._lastInterval = advice.getInterval();
                        }
                        if ((!fm.liveswitch.Global.equals(advice.getReconnect(), fm.liveswitch.signalling.Reconnect.NotSet))) {
                            this._lastReconnect = advice.getReconnect();
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.processPendingReceives = function (channels, reconnectAfter) {
                    if (arguments.length == 2) {
                        for (var _i = 0, channels_8 = channels; _i < channels_8.length; _i++) {
                            var str = channels_8[_i];
                            var list = null;
                            var _var0 = new fm.liveswitch.Holder(list);
                            var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this._pendingReceives, str, _var0);
                            list = _var0.getValue();
                            if (_var1) {
                                fm.liveswitch.HashExtensions.remove(this._pendingReceives, str);
                            }
                            if ((!fm.liveswitch.Global.equals(list, null))) {
                                for (var _a = 0, list_13 = list; _a < list_13.length; _a++) {
                                    var message = list_13[_a];
                                    reconnectAfter = this.receiveMessage(message, reconnectAfter);
                                }
                            }
                        }
                        return reconnectAfter;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.processQueue = function (activate) {
                    if (arguments.length == 1) {
                        if (activate) {
                            this._queueActivated = true;
                        }
                        if ((this._queueActivated && !this.inBatch())) {
                            var requestQueue = this._requestQueue;
                            this._requestQueue = {};
                            for (var _i = 0, _a = fm.liveswitch.HashExtensions.getKeys(requestQueue); _i < _a.length; _i++) {
                                var str = _a[_i];
                                var index = fm.liveswitch.StringExtensions.indexOf(str, "|", fm.liveswitch.StringComparison.InvariantCulture);
                                var str2 = fm.liveswitch.StringExtensions.substring(str, 0, index);
                                var str3 = str.substring((index + 1));
                                var length_51 = fm.liveswitch.StringExtensions.indexOf(str2, "+", fm.liveswitch.StringComparison.InvariantCulture);
                                var s = fm.liveswitch.StringExtensions.substring(str2, 0, length_51);
                                var str5 = str2.substring((length_51 + 1));
                                var timeout = fm.liveswitch.ParseAssistant.parseIntegerValue(s);
                                var maxRetries = fm.liveswitch.ParseAssistant.parseIntegerValue(str5);
                                var synchronous = (fm.liveswitch.Global.equals(fm.liveswitch.StringExtensions.substring(str3, 0, 1), "1"));
                                var url = str3.substring(1);
                                var requests = fm.liveswitch.ArrayExtensions.toArray(requestQueue[str]);
                                this.sendMany(requests, url, synchronous, timeout, maxRetries);
                            }
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.processRequestUrl = function (requestUrl) {
                    if (arguments.length == 1) {
                        if (fm.liveswitch.StringExtensions.isNullOrEmpty(requestUrl)) {
                            requestUrl = _super.prototype.getRequestUrl.call(this);
                        }
                        var flag = false;
                        var str = null;
                        if ((fm.liveswitch.Global.equals(_super.prototype.getConcurrencyMode.call(this), fm.liveswitch.signalling.ConcurrencyMode.High))) {
                            var _var0 = new fm.liveswitch.Holder(str);
                            var _var1 = fm.liveswitch.HashExtensions.tryGetValue(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__requestUrlCache, requestUrl, _var0);
                            str = _var0.getValue();
                            flag = _var1;
                        }
                        if (!flag) {
                            str = requestUrl;
                            str = fm.liveswitch.HttpTransfer.addQueryToUrl(fm.liveswitch.HttpTransfer.addQueryToUrl(fm.liveswitch.HttpTransfer.addQueryToUrl(str, "token", this.getToken()), "src", fm.liveswitch.HttpWebRequestTransfer.getPlatformCode()), "AspxAutoDetectCookieSupport", "1");
                            if ((!fm.liveswitch.Global.equals(_super.prototype.getConcurrencyMode.call(this), fm.liveswitch.signalling.ConcurrencyMode.High))) {
                                return str;
                            }
                            fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__requestUrlCache[requestUrl] = str;
                        }
                        return str;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.processServerAction = function (serverAction, reconnectAfter) {
                    if (arguments.length == 2) {
                        if ((fm.liveswitch.Global.equals(serverAction.getBayeuxChannel(), fm.liveswitch.signalling.MetaChannels.getBind()))) {
                            this.addBoundRecords(serverAction.getRecords());
                            this.raiseServerBind(serverAction);
                            return reconnectAfter;
                        }
                        if ((fm.liveswitch.Global.equals(serverAction.getBayeuxChannel(), fm.liveswitch.signalling.MetaChannels.getUnbind()))) {
                            this.removeBoundRecords(serverAction.getKeys());
                            this.raiseServerUnbind(serverAction);
                            return reconnectAfter;
                        }
                        if ((fm.liveswitch.Global.equals(serverAction.getBayeuxChannel(), fm.liveswitch.signalling.MetaChannels.getSubscribe()))) {
                            this.addSubscribedChannels(serverAction.getTag(), serverAction.getChannels());
                            var onReceive = null;
                            var onPresence = null;
                            var _var0 = new fm.liveswitch.Holder(onReceive);
                            var _var1 = new fm.liveswitch.Holder(onPresence);
                            this.raiseServerSubscribe(serverAction, _var0, _var1);
                            onReceive = _var0.getValue();
                            onPresence = _var1.getValue();
                            if ((fm.liveswitch.Global.equals(onReceive, null))) {
                                throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("The server subscribed the client to [{0}], but the client did not set ServerSubscribeArgs.OnReceive to handle incoming messages or ServerSubscribeArgs.OnPresence to handle incoming presence notifications.", fm.liveswitch.StringExtensions.join(", ", serverAction.getChannels())));
                            }
                            reconnectAfter = this.addSubscribedOnReceive(serverAction.getTag(), serverAction.getChannels(), onReceive, serverAction.getDynamicProperties(), reconnectAfter);
                            reconnectAfter = this.addSubscribedOnPresence(serverAction.getTag(), serverAction.getChannels(), onPresence, serverAction.getDynamicProperties(), reconnectAfter);
                            return reconnectAfter;
                        }
                        if ((fm.liveswitch.Global.equals(serverAction.getBayeuxChannel(), fm.liveswitch.signalling.MetaChannels.getUnsubscribe()))) {
                            this.removeSubscribedChannels(serverAction.getTag(), serverAction.getChannels());
                            this.raiseServerUnsubscribe(serverAction);
                            this.removeSubscribedOnReceive(serverAction.getTag(), serverAction.getChannels());
                            this.removeSubscribedOnPresence(serverAction.getTag(), serverAction.getChannels());
                        }
                        return reconnectAfter;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.publish = function (publishArgs) {
                    var _this = this;
                    if (arguments.length == 1) {
                        var action = null;
                        if (fm.liveswitch.StringExtensions.isNullOrEmpty(publishArgs.getChannel())) {
                            this.raisePublishFailure(publishArgs, this.createFailureResponse(publishArgs, "Channel cannot be null."));
                            return this;
                        }
                        if (fm.liveswitch.StringExtensions.isNullOrEmpty(publishArgs.getDataJson())) {
                            this.raisePublishFailure(publishArgs, this.createFailureResponse(publishArgs, "Data cannot be null."));
                            return this;
                        }
                        if (!this.raiseRequestEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onPublishRequest, new fm.liveswitch.signalling.ClientPublishRequestArgs(publishArgs), "OnPublishRequest")) {
                            var response = this.createFailureResponse(publishArgs, "Application cancelled request.");
                            this.raiseResponseEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onPublishResponse, new fm.liveswitch.signalling.ClientPublishResponseArgs(publishArgs), "OnPublishResponse", response);
                            this.raisePublishFailure(publishArgs, response);
                            this.raiseEndEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onPublishEnd, new fm.liveswitch.signalling.ClientPublishEndArgs(publishArgs), "OnPublishEnd", response);
                            return this;
                        }
                        var request = new fm.liveswitch.signalling.ClientRequest();
                        var message = new fm.liveswitch.signalling.Message(publishArgs.getChannel());
                        message.setValidate(false);
                        message.setDataJson(publishArgs.getDataJson());
                        message.setExtensions(publishArgs.getExtensions());
                        request.setMessage(message);
                        if ((fm.liveswitch.Global.equals(action, null))) {
                            action = function (responseArgs) {
                                _this.raiseResponseEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onPublishResponse, new fm.liveswitch.signalling.ClientPublishResponseArgs(publishArgs), "OnPublishResponse", responseArgs);
                                if ((!fm.liveswitch.Global.equals(responseArgs.getException(), null))) {
                                    _this.raisePublishFailure(publishArgs, responseArgs);
                                }
                                else {
                                    _this.raisePublishSuccess(publishArgs, responseArgs);
                                }
                                _this.raiseEndEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onPublishEnd, new fm.liveswitch.signalling.ClientPublishEndArgs(publishArgs), "OnPublishEnd", responseArgs);
                            };
                        }
                        request.setCallback(action);
                        this.addToQueue(request, publishArgs.getRequestUrl(), this.checkSynchronous(publishArgs.getSynchronous()), ((publishArgs.getRequestTimeout() != null) ? publishArgs.getRequestTimeout() : 0), ((publishArgs.getRequestMaxRetries() != null) ? publishArgs.getRequestMaxRetries() : 0));
                        this.processQueue(false);
                        return this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.publishAsync = function () {
                    if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isUint8Array(arguments[1]))) {
                        var channel = arguments[0];
                        var dataBytes = arguments[1];
                        return this.publishAsync(new fm.liveswitch.signalling.PublishArgs(channel, dataBytes));
                    }
                    else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isUint8Array(arguments[1]))) {
                        var channel = arguments[0];
                        var dataBytes = arguments[1];
                        var tag = arguments[2];
                        return this.publishAsync(new fm.liveswitch.signalling.PublishArgs(channel, dataBytes, tag));
                    }
                    else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                        var channel = arguments[0];
                        var dataJson = arguments[1];
                        return this.publishAsync(new fm.liveswitch.signalling.PublishArgs(channel, dataJson));
                    }
                    else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                        var channel = arguments[0];
                        var dataJson = arguments[1];
                        var tag = arguments[2];
                        return this.publishAsync(new fm.liveswitch.signalling.PublishArgs(channel, dataJson, tag));
                    }
                    else if (arguments.length == 1) {
                        var publishArgs = arguments[0];
                        return this.doPublishAsync(publishArgs, publishArgs.getOnSuccess(), publishArgs.getOnFailure(), new fm.liveswitch.Promise());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.raiseAction = function (callback, args, source) {
                    if (arguments.length == 3) {
                        try {
                            callback(args);
                        }
                        catch (exception) {
                            if (!_super.prototype.raiseUnhandledException.call(this, exception)) {
                                fm.liveswitch.Unhandled.logException(exception, source);
                            }
                        }
                        finally {
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseBindFailure = function (bindArgs, response) {
                    if (arguments.length == 2) {
                        var args2 = new fm.liveswitch.signalling.BindFailureArgs(fm.liveswitch.signalling.Client.getRecordsForBind(response.getMessage(), bindArgs), fm.liveswitch.signalling.Client.getIsPrivateForBind(response.getMessage(), bindArgs));
                        args2.setException(response.getException());
                        args2.setExtensions(fm.liveswitch.signalling.Client.getExtensions(response.getMessage(), bindArgs));
                        args2.setTimestamp(fm.liveswitch.signalling.Client.getTimestamp(response.getMessage()));
                        args2.setClient(this);
                        args2.setDynamicProperties(bindArgs.getDynamicProperties());
                        var args = args2;
                        var onBindFailure = this._onBindFailure;
                        if ((!fm.liveswitch.Global.equals(onBindFailure, null))) {
                            this.raiseAction(onBindFailure, args, "Client -> OnBindFailure");
                        }
                        if ((!fm.liveswitch.Global.equals(bindArgs.getOnFailure(), null))) {
                            this.raiseAction(bindArgs.getOnFailure(), args, "Client -> Bind -> OnFailure");
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseBindSuccess = function (bindArgs, response) {
                    if (arguments.length == 2) {
                        var args2 = new fm.liveswitch.signalling.BindSuccessArgs(fm.liveswitch.signalling.Client.getRecordsForBind(response.getMessage(), bindArgs), fm.liveswitch.signalling.Client.getIsPrivateForBind(response.getMessage(), bindArgs));
                        args2.setExtensions(fm.liveswitch.signalling.Client.getExtensions(response.getMessage(), bindArgs));
                        args2.setTimestamp(fm.liveswitch.signalling.Client.getTimestamp(response.getMessage()));
                        args2.setClient(this);
                        args2.setDynamicProperties(bindArgs.getDynamicProperties());
                        var args = args2;
                        var onBindSuccess = this._onBindSuccess;
                        if ((!fm.liveswitch.Global.equals(onBindSuccess, null))) {
                            this.raiseAction(onBindSuccess, args, "Client -> OnBindSuccess");
                        }
                        if ((!fm.liveswitch.Global.equals(bindArgs.getOnSuccess(), null))) {
                            this.raiseAction(bindArgs.getOnSuccess(), args, "Client -> Bind -> OnSuccess");
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseClientChannelDelivery = function (onReceive, response, reconnectAfter) {
                    if (arguments.length == 3) {
                        var args2 = new fm.liveswitch.signalling.SubscribeReceiveArgs(response.getBayeuxChannel(), response.__dataJson, response.__dataBytes, this._connectionType, reconnectAfter);
                        args2.setExtensions(response.getExtensions());
                        args2.setTimestamp(fm.liveswitch.signalling.Client.getTimestamp(response));
                        args2.setClient(this);
                        var args = args2;
                        if ((!fm.liveswitch.Global.equals(onReceive, null))) {
                            this.raiseAction(onReceive, args, "Client -> OnClientChannelReceive");
                        }
                        return args.getReconnectAfter();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseConnectFailure = function (connectArgs, response) {
                    if (arguments.length == 2) {
                        var args2 = new fm.liveswitch.signalling.ConnectFailureArgs();
                        args2.setException(response.getException());
                        args2.setExtensions(fm.liveswitch.signalling.Client.getExtensions(response.getMessage(), connectArgs));
                        args2.setTimestamp(fm.liveswitch.signalling.Client.getTimestamp(response.getMessage()));
                        args2.setClient(this);
                        args2.setDynamicProperties(connectArgs.getDynamicProperties());
                        var args = args2;
                        var onConnectFailure = this._onConnectFailure;
                        if ((!fm.liveswitch.Global.equals(onConnectFailure, null))) {
                            this.raiseAction(onConnectFailure, args, "Client -> OnConnectFailure");
                        }
                        if ((!fm.liveswitch.Global.equals(connectArgs.getOnFailure(), null))) {
                            this.raiseAction(connectArgs.getOnFailure(), args, "Client -> Connect -> OnFailure");
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseConnectSuccess = function (connectArgs, response) {
                    if (arguments.length == 2) {
                        var args2 = new fm.liveswitch.signalling.ConnectSuccessArgs();
                        args2.setExtensions(fm.liveswitch.signalling.Client.getExtensions(response.getMessage(), connectArgs));
                        args2.setConnectionType(this._connectionType);
                        args2.setTimestamp(fm.liveswitch.signalling.Client.getTimestamp(response.getMessage()));
                        args2.setClient(this);
                        args2.setDynamicProperties(connectArgs.getDynamicProperties());
                        var args = args2;
                        var onConnectSuccess = this._onConnectSuccess;
                        if ((!fm.liveswitch.Global.equals(onConnectSuccess, null))) {
                            this.raiseAction(onConnectSuccess, args, "Client -> OnConnectSuccess");
                        }
                        if ((!fm.liveswitch.Global.equals(connectArgs.getOnSuccess(), null))) {
                            this.raiseAction(connectArgs.getOnSuccess(), args, "Client -> Connect -> OnSuccess");
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseDeviceChannelDelivery = function (onReceive, response, reconnectAfter) {
                    if (arguments.length == 3) {
                        var args2 = new fm.liveswitch.signalling.SubscribeReceiveArgs(response.getBayeuxChannel(), response.__dataJson, response.__dataBytes, this._connectionType, reconnectAfter);
                        args2.setExtensions(response.getExtensions());
                        args2.setTimestamp(fm.liveswitch.signalling.Client.getTimestamp(response));
                        args2.setClient(this);
                        var args = args2;
                        if ((!fm.liveswitch.Global.equals(onReceive, null))) {
                            this.raiseAction(onReceive, args, "Client -> OnDeviceChannelReceive");
                        }
                        return args.getReconnectAfter();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseDisconnectComplete = function (disconnectArgs, response) {
                    if (arguments.length == 2) {
                        var args2 = new fm.liveswitch.signalling.DisconnectCompleteArgs();
                        args2.setException(response.getException());
                        args2.setExtensions(fm.liveswitch.signalling.Client.getExtensions(response.getMessage(), disconnectArgs));
                        args2.setTimestamp(fm.liveswitch.signalling.Client.getTimestamp(response.getMessage()));
                        args2.setClient(this);
                        args2.setDynamicProperties(disconnectArgs.getDynamicProperties());
                        var args = args2;
                        var onDisconnectComplete = this._onDisconnectComplete;
                        if ((!fm.liveswitch.Global.equals(onDisconnectComplete, null))) {
                            this.raiseAction(onDisconnectComplete, args, "Client -> OnDisconnectComplete");
                        }
                        if ((!fm.liveswitch.Global.equals(disconnectArgs.getOnComplete(), null))) {
                            this.raiseAction(disconnectArgs.getOnComplete(), args, "Client -> Disconnect -> OnComplete");
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseEndEvent = function (eventMethod, args, eventName, response) {
                    if (arguments.length == 4) {
                        args.setException(response.getException());
                        args.setMessage(response.getMessage());
                        this.raiseEvent(eventMethod, args, eventName);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.raiseEvent = function (eventMethod, args, eventName) {
                    if (arguments.length == 3) {
                        args.setClient(this);
                        if ((!fm.liveswitch.Global.equals(eventMethod, null))) {
                            try {
                                eventMethod(this, args);
                            }
                            catch (exception) {
                                if (!_super.prototype.raiseUnhandledException.call(this, exception)) {
                                    fm.liveswitch.Unhandled.logException(exception, fm.liveswitch.StringExtensions.format("Client -> {0}", eventName));
                                }
                            }
                            finally {
                            }
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseForcedUnbinds = function () {
                    if (arguments.length == 0) {
                        var list = new Array();
                        for (var _i = 0, _a = this._boundRecords.getKeys(); _i < _a.length; _i++) {
                            var str = _a[_i];
                            fm.liveswitch.ArrayExtensions.add(list, new fm.liveswitch.signalling.UnbindArgs([str]));
                        }
                        for (var _b = 0, list_14 = list; _b < list_14.length; _b++) {
                            var args = list_14[_b];
                            var response = this.createFailureResponse(args, "Disconnect forced unbind.");
                            this.raiseUnbindSuccess(args, response, true);
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseForcedUnsubscribes = function () {
                    if (arguments.length == 0) {
                        var list = new Array();
                        for (var _i = 0, _a = fm.liveswitch.HashExtensions.getKeys(this._subscribedChannels); _i < _a.length; _i++) {
                            var str = _a[_i];
                            for (var _b = 0, _c = fm.liveswitch.HashExtensions.getKeys(this._subscribedChannels[str]); _b < _c.length; _b++) {
                                var str2 = _c[_b];
                                fm.liveswitch.ArrayExtensions.add(list, new fm.liveswitch.signalling.UnsubscribeArgs([str2], str));
                            }
                        }
                        for (var _d = 0, list_15 = list; _d < list_15.length; _d++) {
                            var args = list_15[_d];
                            var response = this.createFailureResponse(args, "Disconnect forced unsubscribe.");
                            this.raiseUnsubscribeSuccess(args, response, true);
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.raiseFunction = function (callback, args, source) {
                    if (arguments.length == 3) {
                        try {
                            return callback(args);
                        }
                        catch (exception) {
                            if (!_super.prototype.raiseUnhandledException.call(this, exception)) {
                                fm.liveswitch.Unhandled.logException(exception, source);
                            }
                            return null;
                        }
                        finally {
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raisePublishFailure = function (publishArgs, response) {
                    if (arguments.length == 2) {
                        var args2 = new fm.liveswitch.signalling.PublishFailureArgs(fm.liveswitch.signalling.Client.getChannelForPublish(response.getMessage(), publishArgs), fm.liveswitch.signalling.Client.getDataJsonForPublish(response.getMessage(), publishArgs), fm.liveswitch.signalling.Client.getDataBytesForPublish(response.getMessage(), publishArgs));
                        args2.setException(response.getException());
                        args2.setExtensions(fm.liveswitch.signalling.Client.getExtensions(response.getMessage(), publishArgs));
                        args2.setTimestamp(fm.liveswitch.signalling.Client.getTimestamp(response.getMessage()));
                        args2.setClient(this);
                        args2.setDynamicProperties(publishArgs.getDynamicProperties());
                        var args = args2;
                        var onPublishFailure = this._onPublishFailure;
                        if ((!fm.liveswitch.Global.equals(onPublishFailure, null))) {
                            this.raiseAction(onPublishFailure, args, "Client -> OnPublishFailure");
                        }
                        if ((!fm.liveswitch.Global.equals(publishArgs.getOnFailure(), null))) {
                            this.raiseAction(publishArgs.getOnFailure(), args, "Client -> Publish -> OnFailure");
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raisePublishSuccess = function (publishArgs, response) {
                    if (arguments.length == 2) {
                        var args2 = new fm.liveswitch.signalling.PublishSuccessArgs(fm.liveswitch.signalling.Client.getChannelForPublish(response.getMessage(), publishArgs), fm.liveswitch.signalling.Client.getDataJsonForPublish(response.getMessage(), publishArgs), fm.liveswitch.signalling.Client.getDataBytesForPublish(response.getMessage(), publishArgs));
                        args2.setExtensions(fm.liveswitch.signalling.Client.getExtensions(response.getMessage(), publishArgs));
                        args2.setTimestamp(fm.liveswitch.signalling.Client.getTimestamp(response.getMessage()));
                        args2.setClient(this);
                        args2.setDynamicProperties(publishArgs.getDynamicProperties());
                        var args = args2;
                        var onPublishSuccess = this._onPublishSuccess;
                        if ((!fm.liveswitch.Global.equals(onPublishSuccess, null))) {
                            this.raiseAction(onPublishSuccess, args, "Client -> OnPublishSuccess");
                        }
                        if ((!fm.liveswitch.Global.equals(publishArgs.getOnSuccess(), null))) {
                            this.raiseAction(publishArgs.getOnSuccess(), args, "Client -> Publish -> OnSuccess");
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.raiseRequestEvent = function (eventMethod, args, eventName) {
                    if (arguments.length == 3) {
                        this.raiseEvent(eventMethod, args, eventName);
                        return !args.getCancel();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseResponseEvent = function (eventMethod, args, eventName, response) {
                    if (arguments.length == 4) {
                        args.setException(response.getException());
                        args.setMessage(response.getMessage());
                        this.raiseEvent(eventMethod, args, eventName);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseSendException = function (state, exception, failureSource) {
                    if (arguments.length == 3) {
                        for (var _i = 0, _a = state.getRequests(); _i < _a.length; _i++) {
                            var request = _a[_i];
                            var p = new fm.liveswitch.signalling.ClientResponse();
                            p.setDynamicProperties(request.getDynamicProperties());
                            p.setException(exception);
                            p.setFailureSource(failureSource);
                            request.getCallback()(p);
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseServerBind = function (serverAction) {
                    if (arguments.length == 1) {
                        var onServerBind = this._onServerBind;
                        if ((!fm.liveswitch.Global.equals(onServerBind, null))) {
                            var args = new fm.liveswitch.signalling.ServerBindArgs();
                            args.__records = serverAction.getRecords();
                            args.setExtensions(serverAction.getExtensions());
                            args.setTimestamp(serverAction.getTimestamp());
                            args.setClient(this);
                            this.raiseAction(onServerBind, args, "Client -> OnServerBind");
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseServerSubscribe = function (serverAction, onReceive, onPresence) {
                    if (arguments.length == 3) {
                        var onServerSubscribe = this._onServerSubscribe;
                        if ((!fm.liveswitch.Global.equals(onServerSubscribe, null))) {
                            var args2 = new fm.liveswitch.signalling.ServerSubscribeArgs();
                            args2.__channels = serverAction.getChannels();
                            args2.setExtensions(serverAction.getExtensions());
                            args2.setTimestamp(serverAction.getTimestamp());
                            args2.setClient(this);
                            var args = args2;
                            this.raiseAction(onServerSubscribe, args, "Client -> OnServerSubscribe");
                            onReceive.setValue(args.getOnReceive());
                            onPresence.setValue(args.getOnPresence());
                        }
                        else {
                            onReceive.setValue(null);
                            onPresence.setValue(null);
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseServerUnbind = function (serverAction) {
                    if (arguments.length == 1) {
                        var onServerUnbind = this._onServerUnbind;
                        if ((!fm.liveswitch.Global.equals(onServerUnbind, null))) {
                            var args = new fm.liveswitch.signalling.ServerUnbindArgs();
                            args.__keys = serverAction.getKeys();
                            args.setExtensions(serverAction.getExtensions());
                            args.setTimestamp(serverAction.getTimestamp());
                            args.setClient(this);
                            this.raiseAction(onServerUnbind, args, "Client -> OnServerUnbind");
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseServerUnsubscribe = function (serverAction) {
                    if (arguments.length == 1) {
                        var onServerUnsubscribe = this._onServerUnsubscribe;
                        if ((!fm.liveswitch.Global.equals(onServerUnsubscribe, null))) {
                            var args = new fm.liveswitch.signalling.ServerUnsubscribeArgs();
                            args.__channels = serverAction.getChannels();
                            args.setExtensions(serverAction.getExtensions());
                            args.setTimestamp(serverAction.getTimestamp());
                            args.setClient(this);
                            this.raiseAction(onServerUnsubscribe, args, "Client -> OnServerUnsubscribe");
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseServiceFailure = function (serviceArgs, response) {
                    if (arguments.length == 2) {
                        var args2 = new fm.liveswitch.signalling.ServiceFailureArgs(fm.liveswitch.signalling.Client.getChannelForService(response.getMessage(), serviceArgs), fm.liveswitch.signalling.Client.getDataJsonForService(response.getMessage(), serviceArgs), fm.liveswitch.signalling.Client.getDataBytesForService(response.getMessage(), serviceArgs));
                        args2.setException(response.getException());
                        args2.setExtensions(fm.liveswitch.signalling.Client.getExtensions(response.getMessage(), serviceArgs));
                        args2.setTimestamp(fm.liveswitch.signalling.Client.getTimestamp(response.getMessage()));
                        args2.setClient(this);
                        args2.setDynamicProperties(serviceArgs.getDynamicProperties());
                        args2.setSource(response.getFailureSource());
                        var args = args2;
                        var onServiceFailure = this._onServiceFailure;
                        if ((!fm.liveswitch.Global.equals(onServiceFailure, null))) {
                            this.raiseAction(onServiceFailure, args, "Client -> OnServiceFailure");
                        }
                        if ((!fm.liveswitch.Global.equals(serviceArgs.getOnFailure(), null))) {
                            this.raiseAction(serviceArgs.getOnFailure(), args, "Client -> Service -> OnFailure");
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseServiceSuccess = function (serviceArgs, response) {
                    if (arguments.length == 2) {
                        var args2 = new fm.liveswitch.signalling.ServiceSuccessArgs(fm.liveswitch.signalling.Client.getChannelForService(response.getMessage(), serviceArgs), fm.liveswitch.signalling.Client.getDataJsonForService(response.getMessage(), serviceArgs), fm.liveswitch.signalling.Client.getDataBytesForService(response.getMessage(), serviceArgs));
                        args2.setExtensions(fm.liveswitch.signalling.Client.getExtensions(response.getMessage(), serviceArgs));
                        args2.setTimestamp(fm.liveswitch.signalling.Client.getTimestamp(response.getMessage()));
                        args2.setClient(this);
                        args2.setDynamicProperties(serviceArgs.getDynamicProperties());
                        var args = args2;
                        var onServiceSuccess = this._onServiceSuccess;
                        if ((!fm.liveswitch.Global.equals(onServiceSuccess, null))) {
                            this.raiseAction(onServiceSuccess, args, "Client -> OnServiceSuccess");
                        }
                        if ((!fm.liveswitch.Global.equals(serviceArgs.getOnSuccess(), null))) {
                            this.raiseAction(serviceArgs.getOnSuccess(), args, "Client -> Service -> OnSuccess");
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseSubscribeFailure = function (subscribeArgs, response) {
                    if (arguments.length == 2) {
                        var args2 = new fm.liveswitch.signalling.SubscribeFailureArgs(fm.liveswitch.signalling.Client.getChannelsForSubscribe(response.getMessage(), subscribeArgs), fm.liveswitch.signalling.Client.getBindRecordsForSubscribe(response.getMessage(), subscribeArgs), fm.liveswitch.signalling.Client.getBindIsPrivateForSubscribe(response.getMessage(), subscribeArgs));
                        args2.setException(response.getException());
                        args2.setExtensions(fm.liveswitch.signalling.Client.getExtensions(response.getMessage(), subscribeArgs));
                        args2.setTimestamp(fm.liveswitch.signalling.Client.getTimestamp(response.getMessage()));
                        args2.setClient(this);
                        args2.setDynamicProperties(subscribeArgs.getDynamicProperties());
                        var args = args2;
                        var onSubscribeFailure = this._onSubscribeFailure;
                        if ((!fm.liveswitch.Global.equals(onSubscribeFailure, null))) {
                            this.raiseAction(onSubscribeFailure, args, "Client -> OnSubscribeFailure");
                        }
                        if ((!fm.liveswitch.Global.equals(subscribeArgs.getOnFailure(), null))) {
                            this.raiseAction(subscribeArgs.getOnFailure(), args, "Client -> Subscribe -> OnFailure");
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseSubscribePresence = function (onPresence, dynamicProperties, response, reconnectAfter) {
                    if (arguments.length == 4) {
                        var bayeuxChannel = response.getBayeuxChannel();
                        var notification = fm.liveswitch.signalling.PresenceNotification.fromJson(response.getDataJson());
                        if (((!fm.liveswitch.Global.equals(notification, null)) && (!fm.liveswitch.Global.equals(notification.getRemoteClient().getClientId(), this.getClientId())))) {
                            var remoteClient = notification.getRemoteClient();
                            if ((fm.liveswitch.Global.equals(remoteClient, null))) {
                                return reconnectAfter;
                            }
                            var key = fm.liveswitch.StringExtensions.nullCoalesce(remoteClient.getUserId(), fm.liveswitch.StringExtensions.empty);
                            var str4 = fm.liveswitch.StringExtensions.nullCoalesce(remoteClient.getDeviceId(), fm.liveswitch.StringExtensions.empty);
                            var firstUserSubscribe = false;
                            var lastUserUnsubscribe = false;
                            var firstDeviceSubscribe = false;
                            var lastDeviceUnsubscribe = false;
                            var dictionary = null;
                            var dictionary2 = null;
                            var _var0 = new fm.liveswitch.Holder(dictionary);
                            var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this._presenceUserCache, bayeuxChannel, _var0);
                            dictionary = _var0.getValue();
                            if (!_var1) {
                                this._presenceUserCache[bayeuxChannel] = dictionary = {};
                            }
                            var _var2 = new fm.liveswitch.Holder(dictionary2);
                            var _var3 = fm.liveswitch.HashExtensions.tryGetValue(this._presenceDeviceCache, bayeuxChannel, _var2);
                            dictionary2 = _var2.getValue();
                            if (!_var3) {
                                this._presenceDeviceCache[bayeuxChannel] = dictionary2 = {};
                            }
                            var dictionary3 = null;
                            var dictionary4 = null;
                            var _var4 = new fm.liveswitch.Holder(dictionary3);
                            var _var5 = fm.liveswitch.HashExtensions.tryGetValue(dictionary, key, _var4);
                            dictionary3 = _var4.getValue();
                            if (!_var5) {
                                dictionary[key] = dictionary3 = {};
                            }
                            var _var6 = new fm.liveswitch.Holder(dictionary4);
                            var _var7 = fm.liveswitch.HashExtensions.tryGetValue(dictionary2, str4, _var6);
                            dictionary4 = _var6.getValue();
                            if (!_var7) {
                                dictionary2[str4] = dictionary4 = {};
                            }
                            if ((fm.liveswitch.Global.equals(notification.getType(), fm.liveswitch.signalling.PresenceType.Subscribe))) {
                                firstUserSubscribe = (fm.liveswitch.Global.equals(fm.liveswitch.HashExtensions.getCount(dictionary3), 0));
                                firstDeviceSubscribe = (fm.liveswitch.Global.equals(fm.liveswitch.HashExtensions.getCount(dictionary4), 0));
                                dictionary3[remoteClient.getClientId()] = remoteClient.getBoundRecords();
                                dictionary4[remoteClient.getClientId()] = remoteClient.getBoundRecords();
                            }
                            else {
                                if (fm.liveswitch.HashExtensions.remove(dictionary3, remoteClient.getClientId())) {
                                    lastUserUnsubscribe = (fm.liveswitch.Global.equals(fm.liveswitch.HashExtensions.getCount(dictionary3), 0));
                                }
                                if (fm.liveswitch.HashExtensions.remove(dictionary4, remoteClient.getClientId())) {
                                    lastDeviceUnsubscribe = (fm.liveswitch.Global.equals(fm.liveswitch.HashExtensions.getCount(dictionary4), 0));
                                }
                            }
                            var args2 = new fm.liveswitch.signalling.SubscribePresenceArgs(bayeuxChannel, notification.getRemoteClient(), notification.getType(), firstUserSubscribe, lastUserUnsubscribe, firstDeviceSubscribe, lastDeviceUnsubscribe, this._connectionType, reconnectAfter);
                            args2.setExtensions(response.getExtensions());
                            args2.setTimestamp(fm.liveswitch.signalling.Client.getTimestamp(response));
                            args2.setClient(this);
                            args2.setDynamicProperties(dynamicProperties);
                            var args = args2;
                            if ((!fm.liveswitch.Global.equals(onPresence, null))) {
                                this.raiseAction(onPresence, args, "Client -> Subscribe -> OnPresence");
                            }
                            reconnectAfter = args.getReconnectAfter();
                        }
                        return reconnectAfter;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseSubscribeReceive = function (onReceive, dynamicProperties, response, reconnectAfter) {
                    if (arguments.length == 4) {
                        var args2 = new fm.liveswitch.signalling.SubscribeReceiveArgs(response.getBayeuxChannel(), response.__dataJson, response.__dataBytes, this._connectionType, reconnectAfter);
                        args2.setExtensions(response.getExtensions());
                        args2.setTimestamp(fm.liveswitch.signalling.Client.getTimestamp(response));
                        args2.setClient(this);
                        args2.setDynamicProperties(dynamicProperties);
                        var args = args2;
                        if ((!fm.liveswitch.Global.equals(onReceive, null))) {
                            this.raiseAction(onReceive, args, "Client -> Subscribe -> OnReceive");
                        }
                        return args.getReconnectAfter();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseSubscribeSuccess = function (subscribeArgs, response) {
                    if (arguments.length == 2) {
                        var args2 = new fm.liveswitch.signalling.SubscribeSuccessArgs(fm.liveswitch.signalling.Client.getChannelsForSubscribe(response.getMessage(), subscribeArgs), fm.liveswitch.signalling.Client.getBindRecordsForSubscribe(response.getMessage(), subscribeArgs), fm.liveswitch.signalling.Client.getBindIsPrivateForSubscribe(response.getMessage(), subscribeArgs), fm.liveswitch.signalling.Client.getSubscribedClientsForSubscribe(response.getMessage(), subscribeArgs));
                        args2.setExtensions(fm.liveswitch.signalling.Client.getExtensions(response.getMessage(), subscribeArgs));
                        args2.setTimestamp(fm.liveswitch.signalling.Client.getTimestamp(response.getMessage()));
                        args2.setClient(this);
                        args2.setDynamicProperties(subscribeArgs.getDynamicProperties());
                        var args = args2;
                        var onSubscribeSuccess = this._onSubscribeSuccess;
                        if ((!fm.liveswitch.Global.equals(onSubscribeSuccess, null))) {
                            this.raiseAction(onSubscribeSuccess, args, "Client -> OnSubscribeSuccess");
                        }
                        if ((!fm.liveswitch.Global.equals(subscribeArgs.getOnSuccess(), null))) {
                            this.raiseAction(subscribeArgs.getOnSuccess(), args, "Client -> Subscribe -> OnSuccess");
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseUnbindFailure = function (unbindArgs, response) {
                    if (arguments.length == 2) {
                        var args2 = new fm.liveswitch.signalling.UnbindFailureArgs(fm.liveswitch.signalling.Client.getKeysForUnbind(response.getMessage(), unbindArgs));
                        args2.setException(response.getException());
                        args2.setExtensions(fm.liveswitch.signalling.Client.getExtensions(response.getMessage(), unbindArgs));
                        args2.setTimestamp(fm.liveswitch.signalling.Client.getTimestamp(response.getMessage()));
                        args2.setClient(this);
                        args2.setDynamicProperties(unbindArgs.getDynamicProperties());
                        var args = args2;
                        var onUnbindFailure = this._onUnbindFailure;
                        if ((!fm.liveswitch.Global.equals(onUnbindFailure, null))) {
                            this.raiseAction(onUnbindFailure, args, "Client -> OnUnbindFailure");
                        }
                        if ((!fm.liveswitch.Global.equals(unbindArgs.getOnFailure(), null))) {
                            this.raiseAction(unbindArgs.getOnFailure(), args, "Client -> Unbind -> OnFailure");
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseUnbindSuccess = function (unbindArgs, response, forced) {
                    if (arguments.length == 3) {
                        var args2 = new fm.liveswitch.signalling.UnbindSuccessArgs(fm.liveswitch.signalling.Client.getKeysForUnbind(response.getMessage(), unbindArgs), forced);
                        args2.setExtensions(fm.liveswitch.signalling.Client.getExtensions(response.getMessage(), unbindArgs));
                        args2.setTimestamp(fm.liveswitch.signalling.Client.getTimestamp(response.getMessage()));
                        args2.setClient(this);
                        args2.setDynamicProperties(unbindArgs.getDynamicProperties());
                        var args = args2;
                        var onUnbindSuccess = this._onUnbindSuccess;
                        if ((!fm.liveswitch.Global.equals(onUnbindSuccess, null))) {
                            this.raiseAction(onUnbindSuccess, args, "Client -> OnUnbindSuccess");
                        }
                        if ((!fm.liveswitch.Global.equals(unbindArgs.getOnSuccess(), null))) {
                            this.raiseAction(unbindArgs.getOnSuccess(), args, "Client -> Unbind -> OnSuccess");
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseUnsubscribeFailure = function (unsubscribeArgs, response) {
                    if (arguments.length == 2) {
                        var args2 = new fm.liveswitch.signalling.UnsubscribeFailureArgs(fm.liveswitch.signalling.Client.getChannelsForUnsubscribe(response.getMessage(), unsubscribeArgs), fm.liveswitch.signalling.Client.getUnbindKeysForUnsubscribe(response.getMessage(), unsubscribeArgs));
                        args2.setException(response.getException());
                        args2.setExtensions(fm.liveswitch.signalling.Client.getExtensions(response.getMessage(), unsubscribeArgs));
                        args2.setTimestamp(fm.liveswitch.signalling.Client.getTimestamp(response.getMessage()));
                        args2.setClient(this);
                        args2.setDynamicProperties(unsubscribeArgs.getDynamicProperties());
                        var args = args2;
                        var onUnsubscribeFailure = this._onUnsubscribeFailure;
                        if ((!fm.liveswitch.Global.equals(onUnsubscribeFailure, null))) {
                            this.raiseAction(onUnsubscribeFailure, args, "Client -> OnUnsubscribeFailure");
                        }
                        if ((!fm.liveswitch.Global.equals(unsubscribeArgs.getOnFailure(), null))) {
                            this.raiseAction(unsubscribeArgs.getOnFailure(), args, "Client -> Unsubscribe -> OnFailure");
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseUnsubscribeSuccess = function (unsubscribeArgs, response, forced) {
                    if (arguments.length == 3) {
                        var args2 = new fm.liveswitch.signalling.UnsubscribeSuccessArgs(fm.liveswitch.signalling.Client.getChannelsForUnsubscribe(response.getMessage(), unsubscribeArgs), fm.liveswitch.signalling.Client.getUnbindKeysForUnsubscribe(response.getMessage(), unsubscribeArgs), forced);
                        args2.setExtensions(fm.liveswitch.signalling.Client.getExtensions(response.getMessage(), unsubscribeArgs));
                        args2.setTimestamp(fm.liveswitch.signalling.Client.getTimestamp(response.getMessage()));
                        args2.setClient(this);
                        args2.setDynamicProperties(unsubscribeArgs.getDynamicProperties());
                        var args = args2;
                        var onUnsubscribeSuccess = this._onUnsubscribeSuccess;
                        if ((!fm.liveswitch.Global.equals(onUnsubscribeSuccess, null))) {
                            this.raiseAction(onUnsubscribeSuccess, args, "Client -> OnUnsubscribeSuccess");
                        }
                        if ((!fm.liveswitch.Global.equals(unsubscribeArgs.getOnSuccess(), null))) {
                            this.raiseAction(unsubscribeArgs.getOnSuccess(), args, "Client -> Unsubscribe -> OnSuccess");
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.raiseUserChannelDelivery = function (onReceive, response, reconnectAfter) {
                    if (arguments.length == 3) {
                        var args2 = new fm.liveswitch.signalling.SubscribeReceiveArgs(response.getBayeuxChannel(), response.__dataJson, response.__dataBytes, this._connectionType, reconnectAfter);
                        args2.setExtensions(response.getExtensions());
                        args2.setTimestamp(fm.liveswitch.signalling.Client.getTimestamp(response));
                        args2.setClient(this);
                        var args = args2;
                        if ((!fm.liveswitch.Global.equals(onReceive, null))) {
                            this.raiseAction(onReceive, args, "Client -> OnUserChannelReceive");
                        }
                        return args.getReconnectAfter();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.receiveMessage = function (message, reconnectAfter) {
                    if (arguments.length == 2) {
                        var onClientChannelReceive = void 0;
                        var dictionary3 = void 0;
                        var num = void 0;
                        var obj2 = void 0;
                        if ((fm.liveswitch.Global.equals(message, null))) {
                            throw new fm.liveswitch.Exception("Signalling client could not process received message. Message was null.");
                        }
                        var bayeuxChannel = message.getBayeuxChannel();
                        if ((fm.liveswitch.Global.equals(bayeuxChannel, null))) {
                            throw new fm.liveswitch.Exception("Signalling client could not process received message. BayeuxChannel was null.");
                        }
                        if (fm.liveswitch.StringExtensions.startsWith(bayeuxChannel, fm.liveswitch.signalling.Reserved.getClientChannelPrefix())) {
                            if ((fm.liveswitch.Global.equals(message.getTag(), fm.liveswitch.signalling.Extensible.getServerActionsExtensionName()))) {
                                var dataJson = message.getDataJson();
                                if ((fm.liveswitch.Global.equals(dataJson, null))) {
                                    throw new fm.liveswitch.Exception("Signalling client could not process received message. Payload was null.");
                                }
                                var serverAction = fm.liveswitch.signalling.Message.fromJson(dataJson);
                                reconnectAfter = this.processServerAction(serverAction, reconnectAfter);
                                return reconnectAfter;
                            }
                            onClientChannelReceive = this._onClientChannelReceive;
                            if ((!fm.liveswitch.Global.equals(onClientChannelReceive, null))) {
                                reconnectAfter = this.raiseClientChannelDelivery(onClientChannelReceive, message, reconnectAfter);
                            }
                            return reconnectAfter;
                        }
                        if (fm.liveswitch.StringExtensions.startsWith(bayeuxChannel, fm.liveswitch.signalling.Reserved.getDeviceChannelPrefix())) {
                            onClientChannelReceive = this._onDeviceChannelReceive;
                            if ((!fm.liveswitch.Global.equals(onClientChannelReceive, null))) {
                                reconnectAfter = this.raiseDeviceChannelDelivery(onClientChannelReceive, message, reconnectAfter);
                            }
                            return reconnectAfter;
                        }
                        if (fm.liveswitch.StringExtensions.startsWith(bayeuxChannel, fm.liveswitch.signalling.Reserved.getUserChannelPrefix())) {
                            onClientChannelReceive = this._onUserChannelReceive;
                            if ((!fm.liveswitch.Global.equals(onClientChannelReceive, null))) {
                                reconnectAfter = this.raiseUserChannelDelivery(onClientChannelReceive, message, reconnectAfter);
                            }
                            return reconnectAfter;
                        }
                        var flag = ((!(message.getPresence() != null) || !(message.getPresence() != null)) ? false : message.getPresence());
                        var list = new Array();
                        var list2 = new Array();
                        var list3 = new Array();
                        if (!flag) {
                            for (var _i = 0, _a = fm.liveswitch.HashExtensions.getKeys(this._customOnReceives); _i < _a.length; _i++) {
                                var str3 = _a[_i];
                                var dictionary = this._customOnReceives[str3];
                                for (var _b = 0, _c = fm.liveswitch.HashExtensions.getKeys(dictionary); _b < _c.length; _b++) {
                                    var str4 = _c[_b];
                                    if ((fm.liveswitch.Global.equals(str4, message.getChannel()))) {
                                        fm.liveswitch.ArrayExtensions.add(list, dictionary[str4]);
                                        fm.liveswitch.ArrayExtensions.add(list3, {});
                                    }
                                }
                            }
                        }
                        if (flag) {
                            for (var _d = 0, _e = fm.liveswitch.HashExtensions.getKeys(this._subscribedOnPresences); _d < _e.length; _d++) {
                                var str3 = _e[_d];
                                var dictionary2 = this._subscribedOnPresences[str3];
                                for (var _f = 0, _g = fm.liveswitch.HashExtensions.getKeys(dictionary2); _f < _g.length; _f++) {
                                    var str4 = _g[_f];
                                    if ((fm.liveswitch.Global.equals(str4, message.getChannel()))) {
                                        fm.liveswitch.ArrayExtensions.add(list2, dictionary2[str4]);
                                        dictionary3 = null;
                                        var _var0 = new fm.liveswitch.Holder(dictionary3);
                                        var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this._subscribedOnPresencesDynamicProperties, fm.liveswitch.signalling.Client.getSubscriptionKey(str4, str3), _var0);
                                        dictionary3 = _var0.getValue();
                                        if (!_var1) {
                                            dictionary3 = {};
                                        }
                                        fm.liveswitch.ArrayExtensions.add(list3, dictionary3);
                                    }
                                }
                            }
                        }
                        else {
                            for (var _h = 0, _j = fm.liveswitch.HashExtensions.getKeys(this._subscribedOnReceives); _h < _j.length; _h++) {
                                var str3 = _j[_h];
                                var dictionary4 = this._subscribedOnReceives[str3];
                                for (var _k = 0, _l = fm.liveswitch.HashExtensions.getKeys(dictionary4); _k < _l.length; _k++) {
                                    var str4 = _l[_k];
                                    if ((fm.liveswitch.Global.equals(str4, message.getChannel()))) {
                                        fm.liveswitch.ArrayExtensions.add(list, dictionary4[str4]);
                                        dictionary3 = null;
                                        var _var2 = new fm.liveswitch.Holder(dictionary3);
                                        var _var3 = fm.liveswitch.HashExtensions.tryGetValue(this._subscribedOnReceivesDynamicProperties, fm.liveswitch.signalling.Client.getSubscriptionKey(str4, str3), _var2);
                                        dictionary3 = _var2.getValue();
                                        if (!_var3) {
                                            dictionary3 = {};
                                        }
                                        fm.liveswitch.ArrayExtensions.add(list3, dictionary3);
                                    }
                                }
                            }
                        }
                        if (((fm.liveswitch.Global.equals(fm.liveswitch.ArrayExtensions.getCount(list), 0)) && (fm.liveswitch.Global.equals(fm.liveswitch.ArrayExtensions.getCount(list2), 0)))) {
                            var list4 = null;
                            var _var4 = new fm.liveswitch.Holder(list4);
                            var _var5 = fm.liveswitch.HashExtensions.tryGetValue(this._pendingReceives, message.getChannel(), _var4);
                            list4 = _var4.getValue();
                            if (!_var5) {
                                list4 = new Array();
                                this._pendingReceives[message.getChannel()] = list4;
                            }
                            fm.liveswitch.ArrayExtensions.add(list4, message);
                            return reconnectAfter;
                        }
                        if (flag) {
                            for (num = 0; (num < fm.liveswitch.ArrayExtensions.getCount(list2)); num++) {
                                var onPresence = list2[num];
                                dictionary3 = null;
                                if ((num < fm.liveswitch.ArrayExtensions.getCount(list3))) {
                                    dictionary3 = list3[num];
                                }
                                reconnectAfter = this.raiseSubscribePresence(onPresence, dictionary3, message, reconnectAfter);
                            }
                            return reconnectAfter;
                        }
                        for (num = 0; (num < fm.liveswitch.ArrayExtensions.getCount(list)); num++) {
                            var onReceive = list[num];
                            dictionary3 = null;
                            if ((num < fm.liveswitch.ArrayExtensions.getCount(list3))) {
                                dictionary3 = list3[num];
                            }
                            reconnectAfter = this.raiseSubscribeReceive(onReceive, dictionary3, message, reconnectAfter);
                        }
                        return reconnectAfter;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.receiveSink = function (e) {
                    if (arguments.length == 1) {
                        fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___log.warn("Received message on channel with no receive handler.");
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.removeBoundRecords = function (boundKeys) {
                    if (arguments.length == 1) {
                        for (var _i = 0, boundKeys_1 = boundKeys; _i < boundKeys_1.length; _i++) {
                            var str = boundKeys_1[_i];
                            this._boundRecords.remove(str);
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnBindFailure = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onBindFailure, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnBindSuccess = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onBindSuccess, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnClientChannelReceive = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onClientChannelReceive, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnConnectFailure = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onConnectFailure, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnConnectSuccess = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onConnectSuccess, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnDeviceChannelReceive = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onDeviceChannelReceive, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnDisconnectComplete = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onDisconnectComplete, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnPublishFailure = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onPublishFailure, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnPublishSuccess = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onPublishSuccess, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnServerBind = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onServerBind, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnServerSubscribe = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onServerSubscribe, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnServerUnbind = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onServerUnbind, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnServerUnsubscribe = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onServerUnsubscribe, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnServiceFailure = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onServiceFailure, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnServiceSuccess = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onServiceSuccess, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnStateChange = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onStateChange, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnSubscribeFailure = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onSubscribeFailure, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnSubscribeSuccess = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onSubscribeSuccess, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnUnbindFailure = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onUnbindFailure, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnUnbindSuccess = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onUnbindSuccess, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnUnsubscribeFailure = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onUnsubscribeFailure, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnUnsubscribeSuccess = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onUnsubscribeSuccess, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.removeOnUserChannelReceive = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.ArrayExtensions.remove(this.__onUserChannelReceive, value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.removeSubscribedChannels = function (tag, channels) {
                    if (arguments.length == 2) {
                        var dictionary = null;
                        var _var0 = new fm.liveswitch.Holder(dictionary);
                        var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this._subscribedChannels, tag, _var0);
                        dictionary = _var0.getValue();
                        if (_var1) {
                            for (var _i = 0, channels_9 = channels; _i < channels_9.length; _i++) {
                                var str = channels_9[_i];
                                fm.liveswitch.HashExtensions.remove(dictionary, str);
                            }
                            if ((fm.liveswitch.Global.equals(fm.liveswitch.HashExtensions.getCount(dictionary), 0))) {
                                fm.liveswitch.HashExtensions.remove(this._subscribedChannels, tag);
                            }
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.removeSubscribedOnPresence = function (tag, channels) {
                    if (arguments.length == 2) {
                        var dictionary = null;
                        var _var0 = new fm.liveswitch.Holder(dictionary);
                        var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this._subscribedOnPresences, tag, _var0);
                        dictionary = _var0.getValue();
                        if (_var1) {
                            for (var _i = 0, channels_10 = channels; _i < channels_10.length; _i++) {
                                var str = channels_10[_i];
                                fm.liveswitch.HashExtensions.remove(dictionary, str);
                                fm.liveswitch.HashExtensions.remove(this._subscribedOnPresencesDynamicProperties, fm.liveswitch.signalling.Client.getSubscriptionKey(str, tag));
                            }
                            if ((fm.liveswitch.Global.equals(fm.liveswitch.HashExtensions.getCount(dictionary), 0))) {
                                fm.liveswitch.HashExtensions.remove(this._subscribedOnPresences, tag);
                            }
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.removeSubscribedOnReceive = function (tag, channels) {
                    if (arguments.length == 2) {
                        var dictionary = null;
                        var _var0 = new fm.liveswitch.Holder(dictionary);
                        var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this._subscribedOnReceives, tag, _var0);
                        dictionary = _var0.getValue();
                        if (_var1) {
                            for (var _i = 0, channels_11 = channels; _i < channels_11.length; _i++) {
                                var str = channels_11[_i];
                                fm.liveswitch.HashExtensions.remove(dictionary, str);
                                fm.liveswitch.HashExtensions.remove(this._subscribedOnReceivesDynamicProperties, fm.liveswitch.signalling.Client.getSubscriptionKey(str, tag));
                            }
                            if ((fm.liveswitch.Global.equals(fm.liveswitch.HashExtensions.getCount(dictionary), 0))) {
                                fm.liveswitch.HashExtensions.remove(this._subscribedOnReceives, tag);
                            }
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.restream = function (receivedMessages, reconnectAfter) {
                    var _this = this;
                    if (arguments.length == 2) {
                        var callback = null;
                        if ((reconnectAfter < this._lastInterval)) {
                            reconnectAfter = this._lastInterval;
                        }
                        this._receivedMessages = receivedMessages;
                        if (((fm.liveswitch.Global.equals(_super.prototype.getConcurrencyMode.call(this), fm.liveswitch.signalling.ConcurrencyMode.Low)) && (reconnectAfter > 0))) {
                            if ((fm.liveswitch.Global.equals(callback, null))) {
                                callback = function (state) {
                                    _this.stream();
                                };
                            }
                            this._deferrer = new fm.liveswitch.TimeoutTimer(callback, null);
                            this._deferrer.start(reconnectAfter);
                        }
                        else {
                            this.stream();
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.send = function (request, url, synchronous, timeout, maxRetries) {
                    if (arguments.length == 5) {
                        this.sendMany([request], url, synchronous, timeout, maxRetries);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.sendCallback = function (state, responseArgs) {
                    if (arguments.length == 2) {
                        if ((!fm.liveswitch.Global.equals(responseArgs.getException(), null))) {
                            this.raiseSendException(state, responseArgs.getException(), fm.liveswitch.FailureSource.Network);
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(responseArgs.getMessages(), null))) {
                                this.raiseSendException(state, new fm.liveswitch.Exception(_super.prototype.getInvalidResponseMessage.call(this, responseArgs)), fm.liveswitch.FailureSource.Message);
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(responseArgs.getMessages().length, 0))) {
                                    this.raiseSendException(state, new fm.liveswitch.Exception(_super.prototype.getEmptyResponseMessage.call(this, responseArgs)), fm.liveswitch.FailureSource.Message);
                                }
                                else {
                                    var list = new Array();
                                    for (var _i = 0, _a = responseArgs.getMessages(); _i < _a.length; _i++) {
                                        var message = _a[_i];
                                        var advice = message.getAdvice();
                                        if ((!fm.liveswitch.Global.equals(advice, null))) {
                                            this.processAdvice(advice);
                                            var _var0 = this._connectionType;
                                            if (_var0 == fm.liveswitch.signalling.ConnectionType.WebSocket) {
                                                do {
                                                    if ((!fm.liveswitch.Global.equals(advice.getWebSocket(), null))) {
                                                        this.processAdvice(advice.getWebSocket());
                                                    }
                                                    break;
                                                } while (false);
                                            }
                                            else if (_var0 == fm.liveswitch.signalling.ConnectionType.LongPolling) {
                                                do {
                                                    if ((!fm.liveswitch.Global.equals(advice.getLongPolling(), null))) {
                                                        this.processAdvice(advice.getLongPolling());
                                                    }
                                                    break;
                                                } while (false);
                                            }
                                            else if (_var0 == fm.liveswitch.signalling.ConnectionType.CallbackPolling) {
                                                do {
                                                    if ((!fm.liveswitch.Global.equals(advice.getCallbackPolling(), null))) {
                                                        this.processAdvice(advice.getCallbackPolling());
                                                    }
                                                    break;
                                                } while (false);
                                            }
                                        }
                                        if ((!state.getIsStream() || (fm.liveswitch.Global.equals(message.getBayeuxChannel(), fm.liveswitch.signalling.MetaChannels.getConnect())))) {
                                            if (fm.liveswitch.StringExtensions.isNullOrEmpty(message.getId())) {
                                                this.raiseSendException(state, new fm.liveswitch.Exception(message.getError()), fm.liveswitch.FailureSource.Message);
                                                return;
                                            }
                                            var request = null;
                                            var _var1 = new fm.liveswitch.Holder(request);
                                            var _var2 = fm.liveswitch.HashExtensions.tryGetValue(state.getRequestMapping(), message.getId(), _var1);
                                            request = _var1.getValue();
                                            if (!_var2) {
                                                fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___log.error("Unknown response message id.");
                                                this.raiseSendException(state, new fm.liveswitch.Exception(message.getError()), fm.liveswitch.FailureSource.Message);
                                                return;
                                            }
                                            var p = new fm.liveswitch.signalling.ClientResponse();
                                            p.setDynamicProperties(request.getDynamicProperties());
                                            p.setMessage(message);
                                            p.setException((message.getSuccessful() ? null : new fm.liveswitch.Exception(message.getError())));
                                            p.setFailureSource((message.getSuccessful() ? fm.liveswitch.FailureSource.None : fm.liveswitch.FailureSource.Message));
                                            request.getCallback()(p);
                                        }
                                        else {
                                            fm.liveswitch.ArrayExtensions.add(list, message);
                                        }
                                    }
                                    if ((fm.liveswitch.ArrayExtensions.getCount(list) > 0)) {
                                        var response2 = new fm.liveswitch.signalling.ClientResponse();
                                        response2.setDynamicProperties(state.getRequests()[0].getDynamicProperties());
                                        response2.setMessages(fm.liveswitch.ArrayExtensions.toArray(list));
                                        state.getRequests()[0].getCallback()(response2);
                                    }
                                    for (var _b = 0, _c = responseArgs.getMessages(); _b < _c.length; _b++) {
                                        var message = _c[_b];
                                        var serverActions = message.getServerActions();
                                        if ((!fm.liveswitch.Global.equals(serverActions, null))) {
                                            for (var _d = 0, serverActions_1 = serverActions; _d < serverActions_1.length; _d++) {
                                                var message2 = serverActions_1[_d];
                                                this.processServerAction(message2, this._lastInterval);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.sendMany = function (requests, url, synchronous, timeout, maxRetries) {
                    if (arguments.length == 5) {
                        var flag = false;
                        if ((fm.liveswitch.Global.equals(requests.length, 1))) {
                            flag = (fm.liveswitch.Global.equals(requests[0].getMessage().getBayeuxChannel(), fm.liveswitch.signalling.MetaChannels.getConnect()));
                        }
                        var dictionary = {};
                        var list = new Array();
                        for (var _i = 0, requests_1 = requests; _i < requests_1.length; _i++) {
                            var request = requests_1[_i];
                            if (!request.getMessage().isConnect()) {
                                request.getMessage().setClientId(this.getClientId());
                                request.getMessage().setStreamId(this.getStreamId());
                                request.getMessage().setAuthToken(this.getAuthToken());
                            }
                            if (_super.prototype.getDisableBinary.call(this)) {
                                request.getMessage().setDisableBinary(_super.prototype.getDisableBinary.call(this));
                            }
                            this._counter++;
                            request.getMessage().setId(fm.liveswitch.NumberExtensions.toString(this._counter));
                            fm.liveswitch.ArrayExtensions.add(list, request.getMessage());
                            dictionary[request.getMessage().getId()] = request;
                        }
                        var str = this.processRequestUrl(url);
                        url = this.processRequestUrl(url);
                        if (flag) {
                            timeout = this.getStreamRequestTimeout();
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(timeout, 0))) {
                                timeout = _super.prototype.getRequestTimeout.call(this);
                            }
                        }
                        if (flag) {
                            maxRetries = 0;
                        }
                        else {
                            if ((fm.liveswitch.Global.equals(maxRetries, 0))) {
                                maxRetries = _super.prototype.getRequestMaxRetries.call(this);
                            }
                        }
                        var requestTransfer = (flag ? this._streamRequestTransfer : this._requestTransfer);
                        var args2 = new fm.liveswitch.signalling.MessageRequestArgs(_super.prototype.createHeaders.call(this));
                        args2.setMessages(fm.liveswitch.ArrayExtensions.toArray(list));
                        args2.setOnRequestCreated(this.internalOnRequestCreated.bind(this));
                        args2.setOnResponseReceived(this.internalOnResponseReceived.bind(this));
                        args2.setOnHttpRequestCreated(this.internalOnHttpRequestCreated.bind(this));
                        args2.setOnHttpResponseReceived(this.internalOnHttpResponseReceived.bind(this));
                        args2.setSender(this);
                        args2.setTimeout(timeout);
                        args2.setMaxRetries(maxRetries);
                        args2.setUrl(url);
                        var requestArgs = args2;
                        requestArgs.setDynamicValue("frameUrl", str);
                        var state2 = new fm.liveswitch.signalling.ClientSendState();
                        state2.setRequests(requests);
                        state2.setRequestMapping(dictionary);
                        state2.setIsStream(flag);
                        var state = state2;
                        this.doSendMany(synchronous, requestTransfer, requestArgs, state);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.service = function (serviceArgs) {
                    var _this = this;
                    if (arguments.length == 1) {
                        var action = null;
                        if (fm.liveswitch.StringExtensions.isNullOrEmpty(serviceArgs.getChannel())) {
                            this.raiseServiceFailure(serviceArgs, this.createFailureResponse(serviceArgs, "Channel cannot be null."));
                            return this;
                        }
                        if (!this.raiseRequestEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onServiceRequest, new fm.liveswitch.signalling.ClientServiceRequestArgs(serviceArgs), "OnServiceRequest")) {
                            var response = this.createFailureResponse(serviceArgs, "Application cancelled request.");
                            this.raiseResponseEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onServiceResponse, new fm.liveswitch.signalling.ClientServiceResponseArgs(serviceArgs), "OnServiceResponse", response);
                            this.raiseServiceFailure(serviceArgs, response);
                            this.raiseEndEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onServiceEnd, new fm.liveswitch.signalling.ClientServiceEndArgs(serviceArgs), "OnServiceEnd", response);
                            return this;
                        }
                        var request = new fm.liveswitch.signalling.ClientRequest();
                        var message = new fm.liveswitch.signalling.Message(fm.liveswitch.signalling.MetaChannels.convertChannelToServiced(serviceArgs.getChannel()));
                        message.setValidate(false);
                        message.setDataJson(serviceArgs.getDataJson());
                        message.setExtensions(serviceArgs.getExtensions());
                        request.setMessage(message);
                        if ((fm.liveswitch.Global.equals(action, null))) {
                            action = function (responseArgs) {
                                _this.raiseResponseEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onServiceResponse, new fm.liveswitch.signalling.ClientServiceResponseArgs(serviceArgs), "OnServiceResponse", responseArgs);
                                if ((!fm.liveswitch.Global.equals(responseArgs.getException(), null))) {
                                    _this.raiseServiceFailure(serviceArgs, responseArgs);
                                }
                                else {
                                    _this.raiseServiceSuccess(serviceArgs, responseArgs);
                                }
                                _this.raiseEndEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onServiceEnd, new fm.liveswitch.signalling.ClientServiceEndArgs(serviceArgs), "OnServiceEnd", responseArgs);
                            };
                        }
                        request.setCallback(action);
                        this.addToQueue(request, serviceArgs.getRequestUrl(), this.checkSynchronous(serviceArgs.getSynchronous()), ((serviceArgs.getRequestTimeout() != null) ? serviceArgs.getRequestTimeout() : 0), ((serviceArgs.getRequestMaxRetries() != null) ? serviceArgs.getRequestMaxRetries() : 0));
                        this.processQueue(false);
                        return this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.serviceAsync = function () {
                    if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isUint8Array(arguments[1]))) {
                        var channel = arguments[0];
                        var dataBytes = arguments[1];
                        return this.serviceAsync(new fm.liveswitch.signalling.ServiceArgs(channel, dataBytes));
                    }
                    else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isUint8Array(arguments[1]))) {
                        var channel = arguments[0];
                        var dataBytes = arguments[1];
                        var tag = arguments[2];
                        return this.serviceAsync(new fm.liveswitch.signalling.ServiceArgs(channel, dataBytes, tag));
                    }
                    else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                        var channel = arguments[0];
                        var dataJson = arguments[1];
                        return this.serviceAsync(new fm.liveswitch.signalling.ServiceArgs(channel, dataJson));
                    }
                    else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                        var channel = arguments[0];
                        var dataJson = arguments[1];
                        var tag = arguments[2];
                        return this.serviceAsync(new fm.liveswitch.signalling.ServiceArgs(channel, dataJson, tag));
                    }
                    else if (arguments.length == 1) {
                        var serviceArgs = arguments[0];
                        return this.doServiceAsync(serviceArgs, serviceArgs.getOnSuccess(), serviceArgs.getOnFailure(), new fm.liveswitch.Promise());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.setAuthToken = function (value) {
                    if (arguments.length == 1) {
                        this._authToken = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.setClientId = function (value) {
                    if (arguments.length == 1) {
                        this._clientId = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.setCustomOnReceive = function (channel, onReceive) {
                    if (arguments.length == 2) {
                        this.setCustomOnReceiveWithTag(channel, fm.liveswitch.StringExtensions.empty, onReceive);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.setCustomOnReceiveWithTag = function (channel, tag, onReceive) {
                    if (arguments.length == 3) {
                        if ((fm.liveswitch.Global.equals(channel, null))) {
                            throw new fm.liveswitch.Exception("channel cannot be null.");
                        }
                        if ((fm.liveswitch.Global.equals(onReceive, null))) {
                            throw new fm.liveswitch.Exception("onReceive cannot be null.");
                        }
                        if ((fm.liveswitch.Global.equals(tag, null))) {
                            tag = fm.liveswitch.StringExtensions.empty;
                        }
                        var dictionary = null;
                        var _var0 = new fm.liveswitch.Holder(dictionary);
                        var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this._customOnReceives, tag, _var0);
                        dictionary = _var0.getValue();
                        if (!_var1) {
                            dictionary = {};
                            this._customOnReceives[tag] = dictionary;
                        }
                        dictionary[channel] = onReceive;
                        this.processPendingReceives([channel], this._lastInterval);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.setDeviceId = function (value) {
                    if (arguments.length == 1) {
                        this._deviceId = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.setDisableWebSockets = function (value) {
                    if (arguments.length == 1) {
                        this._disableWebSockets = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.setDisconnectException = function (value) {
                    if (arguments.length == 1) {
                        this._disconnectException = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.setServerTimeout = function (value) {
                    if (arguments.length == 1) {
                        this._serverTimeout = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.setState = function (value) {
                    if (arguments.length == 1) {
                        if ((!fm.liveswitch.Global.equals(value, this.__state))) {
                            if ((fm.liveswitch.Global.equals(value, fm.liveswitch.signalling.ClientState.Connecting))) {
                                this._requestTransfer = fm.liveswitch.signalling.MessageTransferFactory.getHttpMessageTransfer();
                            }
                            else {
                                if ((fm.liveswitch.Global.equals(value, fm.liveswitch.signalling.ClientState.Disconnected))) {
                                    this.raiseForcedUnsubscribes();
                                    this.raiseForcedUnbinds();
                                    this.clearBoundRecords();
                                    this.clearSubscribedChannels();
                                    try {
                                        if ((!fm.liveswitch.Global.equals(this._requestTransfer, null))) {
                                            this._requestTransfer.shutdown();
                                            this._requestTransfer = null;
                                        }
                                        if ((!fm.liveswitch.Global.equals(this._streamRequestTransfer, null))) {
                                            this._streamRequestTransfer.shutdown();
                                            this._streamRequestTransfer = null;
                                        }
                                    }
                                    catch (exception1) {
                                    }
                                    finally {
                                    }
                                    this._queueActivated = false;
                                }
                            }
                            this.__state = value;
                            var onStateChange = this._onStateChange;
                            if ((!fm.liveswitch.Global.equals(onStateChange, null))) {
                                onStateChange(this);
                            }
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.setStreamId = function (value) {
                    if (arguments.length == 1) {
                        this._streamId = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.setStreamRequestUrl = function (value) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(value, null))) {
                            throw new fm.liveswitch.Exception("Stream request URL cannot be null.");
                        }
                        this.__streamRequestUrl = fm.liveswitch.HttpTransfer.replaceWildcards(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.setSynchronous = function (value) {
                    if (arguments.length == 1) {
                        this._synchronous = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.setToken = function (value) {
                    if (arguments.length == 1) {
                        this._token = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.setUserId = function (value) {
                    if (arguments.length == 1) {
                        this._userId = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.startBatch = function () {
                    if (arguments.length == 0) {
                        this._batchCounter++;
                        return this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.stream = function () {
                    if (arguments.length == 0) {
                        var request2 = new fm.liveswitch.signalling.ClientRequest();
                        var message = new fm.liveswitch.signalling.Message(fm.liveswitch.signalling.MetaChannels.getConnect());
                        message.setConnectionType(this._connectionType);
                        message.setAcknowledgement(this._receivedMessages);
                        request2.setMessage(message);
                        request2.setCallback(this.streamCallback.bind(this));
                        var request = request2;
                        this.send(request, this.getStreamRequestUrl(), false, 0, 0);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.streamCallback = function (response) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(this.getState(), fm.liveswitch.signalling.ClientState.Connected))) {
                            if ((!fm.liveswitch.Global.equals(response.getException(), null))) {
                                if ((!fm.liveswitch.Global.equals(response.getMessages(), null))) {
                                    if ((fm.liveswitch.Global.equals(this._lastReconnect, fm.liveswitch.signalling.Reconnect.Retry))) {
                                        this.restream(false, this._lastInterval);
                                    }
                                    else {
                                        this.setDisconnectException(response.getException());
                                        this.setState(fm.liveswitch.signalling.ClientState.Disconnected);
                                    }
                                }
                                else {
                                    this.setDisconnectException(response.getException());
                                    this.setState(fm.liveswitch.signalling.ClientState.Disconnected);
                                }
                            }
                            else {
                                if (((fm.liveswitch.Global.equals(response.getMessages().length, 1)) && (fm.liveswitch.Global.equals(response.getMessages()[0].getBayeuxChannel(), fm.liveswitch.signalling.MetaChannels.getConnect())))) {
                                    this.restream(false, this._lastInterval);
                                }
                                else {
                                    var lastInterval = this._lastInterval;
                                    for (var _i = 0, _a = response.getMessages(); _i < _a.length; _i++) {
                                        var message = _a[_i];
                                        lastInterval = this.receiveMessage(message, lastInterval);
                                    }
                                    this.restream(true, lastInterval);
                                }
                            }
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.subscribe = function (subscribeArgs) {
                    var _this = this;
                    if (arguments.length == 1) {
                        var action = null;
                        if (((fm.liveswitch.Global.equals(subscribeArgs.getChannels(), null)) || (fm.liveswitch.Global.equals(subscribeArgs.getChannels().length, 0)))) {
                            this.raiseSubscribeFailure(subscribeArgs, this.createFailureResponse(subscribeArgs, "Channels cannot be null."));
                            return this;
                        }
                        if ((fm.liveswitch.Global.equals(subscribeArgs.getOnReceive(), null))) {
                            subscribeArgs.setOnReceive(this.receiveSink.bind(this));
                        }
                        if ((fm.liveswitch.Global.equals(subscribeArgs.getTag(), null))) {
                            subscribeArgs.setTag(fm.liveswitch.StringExtensions.empty);
                        }
                        if (!this.raiseRequestEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onSubscribeRequest, new fm.liveswitch.signalling.ClientSubscribeRequestArgs(subscribeArgs), "OnSubscribeRequest")) {
                            var response = this.createFailureResponse(subscribeArgs, "Application cancelled request.");
                            this.raiseResponseEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onSubscribeResponse, new fm.liveswitch.signalling.ClientSubscribeResponseArgs(subscribeArgs), "OnSubscribeResponse", response);
                            this.raiseSubscribeFailure(subscribeArgs, response);
                            this.raiseEndEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onSubscribeEnd, new fm.liveswitch.signalling.ClientSubscribeEndArgs(subscribeArgs), "OnSubscribeEnd", response);
                            return this;
                        }
                        var request = new fm.liveswitch.signalling.ClientRequest();
                        var message = new fm.liveswitch.signalling.Message(fm.liveswitch.signalling.MetaChannels.getSubscribe());
                        message.setValidate(false);
                        message.setChannels(subscribeArgs.getChannels());
                        message.setRecords(subscribeArgs.getBindRecords());
                        message.setIsPrivate(subscribeArgs.getBindIsPrivate());
                        message.setExtensions(subscribeArgs.getExtensions());
                        request.setMessage(message);
                        if ((fm.liveswitch.Global.equals(action, null))) {
                            action = function (responseArgs) {
                                _this.raiseResponseEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onSubscribeResponse, new fm.liveswitch.signalling.ClientSubscribeResponseArgs(subscribeArgs), "OnSubscribeResponse", responseArgs);
                                if ((!fm.liveswitch.Global.equals(responseArgs.getException(), null))) {
                                    _this.raiseSubscribeFailure(subscribeArgs, responseArgs);
                                }
                                else {
                                    for (var _i = 0, _a = responseArgs.getMessage().getChannels(); _i < _a.length; _i++) {
                                        var str = _a[_i];
                                        var subscriptionKey = fm.liveswitch.signalling.Client.getSubscriptionKey(str, subscribeArgs.getTag());
                                        _this._subscribedOnReceivesDynamicProperties[subscriptionKey] = subscribeArgs.getDynamicProperties();
                                        _this._subscribedOnPresencesDynamicProperties[subscriptionKey] = subscribeArgs.getDynamicProperties();
                                    }
                                    _this.addSubscribedChannels(responseArgs.getMessage().getTag(), responseArgs.getMessage().getChannels());
                                    _this.raiseSubscribeSuccess(subscribeArgs, responseArgs);
                                    _this.addSubscribedOnReceive(responseArgs.getMessage().getTag(), responseArgs.getMessage().getChannels(), subscribeArgs.getOnReceive(), subscribeArgs.getDynamicProperties(), _this._lastInterval);
                                    _this.addSubscribedOnPresence(responseArgs.getMessage().getTag(), responseArgs.getMessage().getChannels(), subscribeArgs.getOnPresence(), subscribeArgs.getDynamicProperties(), _this._lastInterval);
                                }
                                _this.raiseEndEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onSubscribeEnd, new fm.liveswitch.signalling.ClientSubscribeEndArgs(subscribeArgs), "OnSubscribeEnd", responseArgs);
                            };
                        }
                        request.setCallback(action);
                        this.addToQueue(request, subscribeArgs.getRequestUrl(), this.checkSynchronous(subscribeArgs.getSynchronous()), ((subscribeArgs.getRequestTimeout() != null) ? subscribeArgs.getRequestTimeout() : 0), ((subscribeArgs.getRequestMaxRetries() != null) ? subscribeArgs.getRequestMaxRetries() : 0));
                        this.processQueue(false);
                        return this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.subscribeAsync = function () {
                    if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                        var channel = arguments[0];
                        return this.subscribeAsync(new fm.liveswitch.signalling.SubscribeArgs(channel));
                    }
                    else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isFunction(arguments[1]))) {
                        var channel = arguments[0];
                        var onReceive = arguments[1];
                        return this.subscribeAsync(new fm.liveswitch.signalling.SubscribeArgs(channel, onReceive));
                    }
                    else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isFunction(arguments[1]))) {
                        var channel = arguments[0];
                        var onReceive = arguments[1];
                        var onPresence = arguments[2];
                        return this.subscribeAsync(new fm.liveswitch.signalling.SubscribeArgs(channel, onReceive, onPresence));
                    }
                    else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                        var channel = arguments[0];
                        var tag = arguments[1];
                        return this.subscribeAsync(new fm.liveswitch.signalling.SubscribeArgs(channel, tag));
                    }
                    else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                        var channel = arguments[0];
                        var tag = arguments[1];
                        var onReceive = arguments[2];
                        return this.subscribeAsync(new fm.liveswitch.signalling.SubscribeArgs(channel, tag, onReceive));
                    }
                    else if (arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                        var channel = arguments[0];
                        var tag = arguments[1];
                        var onReceive = arguments[2];
                        var onPresence = arguments[3];
                        return this.subscribeAsync(new fm.liveswitch.signalling.SubscribeArgs(channel, tag, onReceive, onPresence));
                    }
                    else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isString(arguments[0][0])))))) {
                        var channels = arguments[0];
                        return this.subscribeAsync(new fm.liveswitch.signalling.SubscribeArgs(channels));
                    }
                    else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isString(arguments[0][0]))))) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isFunction(arguments[1]))) {
                        var channels = arguments[0];
                        var onReceive = arguments[1];
                        return this.subscribeAsync(new fm.liveswitch.signalling.SubscribeArgs(channels, onReceive));
                    }
                    else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isString(arguments[0][0]))))) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isFunction(arguments[1]))) {
                        var channels = arguments[0];
                        var onReceive = arguments[1];
                        var onPresence = arguments[2];
                        return this.subscribeAsync(new fm.liveswitch.signalling.SubscribeArgs(channels, onReceive, onPresence));
                    }
                    else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isString(arguments[0][0]))))) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                        var channels = arguments[0];
                        var tag = arguments[1];
                        return this.subscribeAsync(new fm.liveswitch.signalling.SubscribeArgs(channels, tag));
                    }
                    else if (arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isString(arguments[0][0]))))) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                        var channels = arguments[0];
                        var tag = arguments[1];
                        var onReceive = arguments[2];
                        return this.subscribeAsync(new fm.liveswitch.signalling.SubscribeArgs(channels, tag, onReceive));
                    }
                    else if (arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isString(arguments[0][0])))))) {
                        var channels = arguments[0];
                        var tag = arguments[1];
                        var onReceive = arguments[2];
                        var onPresence = arguments[3];
                        return this.subscribeAsync(new fm.liveswitch.signalling.SubscribeArgs(channels, tag, onReceive, onPresence));
                    }
                    else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.signalling.SubscribeArgs]'))) {
                        var subscribeArgs = arguments[0];
                        return this.doSubscribeAsync(subscribeArgs, subscribeArgs.getOnSuccess(), subscribeArgs.getOnFailure(), new fm.liveswitch.Promise());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.tryWebSocket = function () {
                    if (arguments.length == 0) {
                        try {
                            var webSocketMessageTransfer = fm.liveswitch.signalling.MessageTransferFactory.getWebSocketMessageTransfer(this.processRequestUrl(this.getStreamRequestUrl()));
                            webSocketMessageTransfer.setHandshakeTimeout(_super.prototype.getRequestTimeout.call(this));
                            webSocketMessageTransfer.setStreamTimeout(this.getStreamRequestTimeout());
                            webSocketMessageTransfer.setOnRequestCreated(this.internalOnHttpRequestCreated.bind(this));
                            webSocketMessageTransfer.setOnResponseReceived(this.internalOnHttpResponseReceived.bind(this));
                            webSocketMessageTransfer.setOnOpenSuccess(this.webSocketOpenSuccess.bind(this));
                            webSocketMessageTransfer.setOnOpenFailure(this.webSocketOpenFailure.bind(this));
                            webSocketMessageTransfer.setOnStreamFailure(this.webSocketStreamFailure.bind(this));
                            webSocketMessageTransfer.setSender(this);
                            this._connectionType = fm.liveswitch.signalling.ConnectionType.WebSocket;
                            this._streamRequestTransfer = webSocketMessageTransfer;
                            webSocketMessageTransfer.open(_super.prototype.createHeaders.call(this));
                            return true;
                        }
                        catch (exception1) {
                            return false;
                        }
                        finally {
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.unbind = function (unbindArgs) {
                    var _this = this;
                    if (arguments.length == 1) {
                        var action = null;
                        if (((fm.liveswitch.Global.equals(unbindArgs.getKeys(), null)) || (fm.liveswitch.Global.equals(unbindArgs.getKeys().length, 0)))) {
                            this.raiseUnbindFailure(unbindArgs, this.createFailureResponse(unbindArgs, "Keys cannot be null."));
                            return this;
                        }
                        if (!this.raiseRequestEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onUnbindRequest, new fm.liveswitch.signalling.ClientUnbindRequestArgs(unbindArgs), "OnUnbindRequest")) {
                            var response = this.createFailureResponse(unbindArgs, "Application cancelled request.");
                            this.raiseResponseEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onUnbindResponse, new fm.liveswitch.signalling.ClientUnbindResponseArgs(unbindArgs), "OnUnbindResponse", response);
                            this.raiseUnbindFailure(unbindArgs, response);
                            this.raiseEndEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onUnbindEnd, new fm.liveswitch.signalling.ClientUnbindEndArgs(unbindArgs), "OnUnbindEnd", response);
                            return this;
                        }
                        var request = new fm.liveswitch.signalling.ClientRequest();
                        var message = new fm.liveswitch.signalling.Message(fm.liveswitch.signalling.MetaChannels.getUnbind());
                        message.setValidate(false);
                        message.setKeys(unbindArgs.getKeys());
                        message.setExtensions(unbindArgs.getExtensions());
                        request.setMessage(message);
                        if ((fm.liveswitch.Global.equals(action, null))) {
                            action = function (responseArgs) {
                                _this.raiseResponseEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onUnbindResponse, new fm.liveswitch.signalling.ClientUnbindResponseArgs(unbindArgs), "OnUnbindResponse", responseArgs);
                                if ((!fm.liveswitch.Global.equals(responseArgs.getException(), null))) {
                                    _this.raiseUnbindFailure(unbindArgs, responseArgs);
                                }
                                else {
                                    _this.removeBoundRecords(responseArgs.getMessage().getKeys());
                                    _this.raiseUnbindSuccess(unbindArgs, responseArgs, false);
                                }
                                _this.raiseEndEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onUnbindEnd, new fm.liveswitch.signalling.ClientUnbindEndArgs(unbindArgs), "OnUnbindEnd", responseArgs);
                            };
                        }
                        request.setCallback(action);
                        this.addToQueue(request, unbindArgs.getRequestUrl(), this.checkSynchronous(unbindArgs.getSynchronous()), ((unbindArgs.getRequestTimeout() != null) ? unbindArgs.getRequestTimeout() : 0), ((unbindArgs.getRequestMaxRetries() != null) ? unbindArgs.getRequestMaxRetries() : 0));
                        this.processQueue(false);
                        return this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.unbindAsync = function () {
                    if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                        var key = arguments[0];
                        return this.unbindAsync(new fm.liveswitch.signalling.UnbindArgs(key));
                    }
                    else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isString(arguments[0][0])))))) {
                        var keys = arguments[0];
                        return this.unbindAsync(new fm.liveswitch.signalling.UnbindArgs(keys));
                    }
                    else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.signalling.UnbindArgs]'))) {
                        var unbindArgs = arguments[0];
                        return this.doUnbindAsync(unbindArgs, unbindArgs.getOnSuccess(), unbindArgs.getOnFailure(), new fm.liveswitch.Promise());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.unsetCustomOnReceive = function (channel) {
                    if (arguments.length == 1) {
                        return this.unsetCustomOnReceiveWithTag(channel, fm.liveswitch.StringExtensions.empty);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.unsetCustomOnReceiveWithTag = function (channel, tag) {
                    if (arguments.length == 2) {
                        if ((fm.liveswitch.Global.equals(channel, null))) {
                            throw new fm.liveswitch.Exception("channel cannot be null.");
                        }
                        if ((fm.liveswitch.Global.equals(tag, null))) {
                            tag = fm.liveswitch.StringExtensions.empty;
                        }
                        var dictionary = null;
                        var _var0 = new fm.liveswitch.Holder(dictionary);
                        var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this._customOnReceives, tag, _var0);
                        dictionary = _var0.getValue();
                        if (_var1) {
                            if (fm.liveswitch.HashExtensions.remove(dictionary, channel)) {
                                if ((fm.liveswitch.Global.equals(fm.liveswitch.HashExtensions.getCount(dictionary), 0))) {
                                    fm.liveswitch.HashExtensions.remove(this._customOnReceives, tag);
                                }
                                return true;
                            }
                            return false;
                        }
                        return false;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.unsubscribe = function (unsubscribeArgs) {
                    var _this = this;
                    if (arguments.length == 1) {
                        var action = null;
                        if (((fm.liveswitch.Global.equals(unsubscribeArgs.getChannels(), null)) || (fm.liveswitch.Global.equals(unsubscribeArgs.getChannels().length, 0)))) {
                            this.raiseUnsubscribeFailure(unsubscribeArgs, this.createFailureResponse(unsubscribeArgs, "Channels cannot be null."));
                            return this;
                        }
                        if ((fm.liveswitch.Global.equals(unsubscribeArgs.getTag(), null))) {
                            unsubscribeArgs.setTag(fm.liveswitch.StringExtensions.empty);
                        }
                        if (!this.raiseRequestEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onUnsubscribeRequest, new fm.liveswitch.signalling.ClientUnsubscribeRequestArgs(unsubscribeArgs), "OnUnsubscribeRequest")) {
                            var response = this.createFailureResponse(unsubscribeArgs, "Application cancelled request.");
                            this.raiseResponseEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onUnsubscribeResponse, new fm.liveswitch.signalling.ClientUnsubscribeResponseArgs(unsubscribeArgs), "OnUnsubscribeResponse", response);
                            this.raiseUnsubscribeFailure(unsubscribeArgs, response);
                            this.raiseEndEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onUnsubscribeEnd, new fm.liveswitch.signalling.ClientUnsubscribeEndArgs(unsubscribeArgs), "OnUnsubscribeEnd", response);
                            return this;
                        }
                        var request = new fm.liveswitch.signalling.ClientRequest();
                        var message = new fm.liveswitch.signalling.Message(fm.liveswitch.signalling.MetaChannels.getUnsubscribe());
                        message.setValidate(false);
                        message.setChannels(unsubscribeArgs.getChannels());
                        message.setKeys(unsubscribeArgs.getUnbindKeys());
                        message.setExtensions(unsubscribeArgs.getExtensions());
                        request.setMessage(message);
                        if ((fm.liveswitch.Global.equals(action, null))) {
                            action = function (responseArgs) {
                                _this.raiseResponseEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onUnsubscribeResponse, new fm.liveswitch.signalling.ClientUnsubscribeResponseArgs(unsubscribeArgs), "OnUnsubscribeResponse", responseArgs);
                                if ((!fm.liveswitch.Global.equals(responseArgs.getException(), null))) {
                                    _this.raiseUnsubscribeFailure(unsubscribeArgs, responseArgs);
                                }
                                else {
                                    _this.removeSubscribedChannels(responseArgs.getMessage().getTag(), responseArgs.getMessage().getChannels());
                                    _this.removeSubscribedOnReceive(responseArgs.getMessage().getTag(), responseArgs.getMessage().getChannels());
                                    _this.removeSubscribedOnPresence(responseArgs.getMessage().getTag(), responseArgs.getMessage().getChannels());
                                    _this.raiseUnsubscribeSuccess(unsubscribeArgs, responseArgs, false);
                                }
                                _this.raiseEndEvent(fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__onUnsubscribeEnd, new fm.liveswitch.signalling.ClientUnsubscribeEndArgs(unsubscribeArgs), "OnUnsubscribeEnd", responseArgs);
                            };
                        }
                        request.setCallback(action);
                        this.addToQueue(request, unsubscribeArgs.getRequestUrl(), this.checkSynchronous(unsubscribeArgs.getSynchronous()), ((unsubscribeArgs.getRequestTimeout() != null) ? unsubscribeArgs.getRequestTimeout() : 0), ((unsubscribeArgs.getRequestMaxRetries() != null) ? unsubscribeArgs.getRequestMaxRetries() : 0));
                        this.processQueue(false);
                        return this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Client.prototype.unsubscribeAsync = function () {
                    if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                        var channel = arguments[0];
                        return this.unsubscribeAsync(new fm.liveswitch.signalling.UnsubscribeArgs(channel));
                    }
                    else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                        var channel = arguments[0];
                        var tag = arguments[1];
                        return this.unsubscribeAsync(new fm.liveswitch.signalling.UnsubscribeArgs(channel, tag));
                    }
                    else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isString(arguments[0][0])))))) {
                        var channels = arguments[0];
                        return this.unsubscribeAsync(new fm.liveswitch.signalling.UnsubscribeArgs(channels));
                    }
                    else if (arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isString(arguments[0][0])))))) {
                        var channels = arguments[0];
                        var tag = arguments[1];
                        return this.unsubscribeAsync(new fm.liveswitch.signalling.UnsubscribeArgs(channels, tag));
                    }
                    else if (arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isObjectType(arguments[0], '[fm.liveswitch.signalling.UnsubscribeArgs]'))) {
                        var unsubscribeArgs = arguments[0];
                        return this.doUnsubscribeAsync(unsubscribeArgs, unsubscribeArgs.getOnSuccess(), unsubscribeArgs.getOnFailure(), new fm.liveswitch.Promise());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.webSocketOpenFailure = function (e) {
                    if (arguments.length == 1) {
                        if (this._webSocketOpened) {
                            if (!this.tryWebSocket()) {
                                this.doLongPolling();
                            }
                        }
                        else {
                            fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___log.warn("Unable to connect via Web Socket, falling back to Long Polling.");
                            this.doLongPolling();
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.webSocketOpenSuccess = function (e) {
                    if (arguments.length == 1) {
                        this._webSocketOpened = true;
                        this.activateStream();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.prototype.webSocketStreamFailure = function (e) {
                    if (arguments.length == 1) {
                        var response = new fm.liveswitch.signalling.ClientResponse();
                        response.setException(new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("WebSocket stream error. {0}", e.getException().message)));
                        this.streamCallback(response);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Client.fmliveswitchsignallingClientInitialize = function () {
                    if (!fm.liveswitch.signalling.Client.__fmliveswitchsignallingClientInitialized && !fm.liveswitch.signalling.Client.__fmliveswitchsignallingClientInitializing) {
                        fm.liveswitch.signalling.Client.__fmliveswitchsignallingClientInitializing = true;
                        Client.fm_liveswitch_signalling_Client___onBindEnd = [];
                        Client.fm_liveswitch_signalling_Client___onBindRequest = [];
                        Client.fm_liveswitch_signalling_Client___onBindResponse = [];
                        Client.fm_liveswitch_signalling_Client___onConnectEnd = [];
                        Client.fm_liveswitch_signalling_Client___onConnectRequest = [];
                        Client.fm_liveswitch_signalling_Client___onConnectResponse = [];
                        Client.fm_liveswitch_signalling_Client___onDisconnectEnd = [];
                        Client.fm_liveswitch_signalling_Client___onDisconnectRequest = [];
                        Client.fm_liveswitch_signalling_Client___onDisconnectResponse = [];
                        Client.fm_liveswitch_signalling_Client___onPublishEnd = [];
                        Client.fm_liveswitch_signalling_Client___onPublishRequest = [];
                        Client.fm_liveswitch_signalling_Client___onPublishResponse = [];
                        Client.fm_liveswitch_signalling_Client___onServiceEnd = [];
                        Client.fm_liveswitch_signalling_Client___onServiceRequest = [];
                        Client.fm_liveswitch_signalling_Client___onServiceResponse = [];
                        Client.fm_liveswitch_signalling_Client___onSubscribeEnd = [];
                        Client.fm_liveswitch_signalling_Client___onSubscribeRequest = [];
                        Client.fm_liveswitch_signalling_Client___onSubscribeResponse = [];
                        Client.fm_liveswitch_signalling_Client___onUnbindEnd = [];
                        Client.fm_liveswitch_signalling_Client___onUnbindRequest = [];
                        Client.fm_liveswitch_signalling_Client___onUnbindResponse = [];
                        Client.fm_liveswitch_signalling_Client___onUnsubscribeEnd = [];
                        Client.fm_liveswitch_signalling_Client___onUnsubscribeRequest = [];
                        Client.fm_liveswitch_signalling_Client___onUnsubscribeResponse = [];
                        Client.fm_liveswitch_signalling_Client__onBindEnd = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onBindEnd; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onBindRequest = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onBindRequest; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onBindResponse = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onBindResponse; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onConnectEnd = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onConnectEnd; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onConnectRequest = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onConnectRequest; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onConnectResponse = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onConnectResponse; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onDisconnectEnd = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onDisconnectEnd; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onDisconnectRequest = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onDisconnectRequest; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onDisconnectResponse = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onDisconnectResponse; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onPublishEnd = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onPublishEnd; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onPublishRequest = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onPublishRequest; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onPublishResponse = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onPublishResponse; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onServiceEnd = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onServiceEnd; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onServiceRequest = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onServiceRequest; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onServiceResponse = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onServiceResponse; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onSubscribeEnd = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onSubscribeEnd; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onSubscribeRequest = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onSubscribeRequest; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onSubscribeResponse = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onSubscribeResponse; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onUnbindEnd = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onUnbindEnd; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onUnbindRequest = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onUnbindRequest; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onUnbindResponse = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onUnbindResponse; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onUnsubscribeEnd = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onUnsubscribeEnd; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onUnsubscribeRequest = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onUnsubscribeRequest; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        Client.fm_liveswitch_signalling_Client__onUnsubscribeResponse = function (p0, p1) { for (var _i = 0, _a = fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___onUnsubscribeResponse; _i < _a.length; _i++) {
                            var action = _a[_i];
                            action(p0, p1);
                        } };
                        fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client___log = fm.liveswitch.Log.getLogger(new fm.liveswitch.Type('[fm.liveswitch.signalling.Client]'));
                        fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__bayeuxVersion = "1.0";
                        fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__bayeuxMinimumVersion = "1.0";
                        fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__requestUrlCache = {};
                        fm.liveswitch.signalling.Client.fm_liveswitch_signalling_Client__requestUrlCacheLock = new Object();
                        fm.liveswitch.signalling.Client.__fmliveswitchsignallingClientInitialized = true;
                        fm.liveswitch.signalling.Client.__fmliveswitchsignallingClientInitializing = false;
                    }
                };
                /** @hidden */
                Client.__fmliveswitchsignallingClientInitialized = false;
                /** @hidden */
                Client.__fmliveswitchsignallingClientInitializing = false;
                return Client;
            }(fm.liveswitch.signalling.ClientBase));
            signalling.Client = Client;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientArgs = /** @class */ (function () {
                function ClientArgs() {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        //super();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                ClientArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientArgs]';
                };
                ClientArgs.prototype.getClient = function () {
                    if (arguments.length == 0) {
                        return this._client;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientArgs.prototype.setClient = function (value) {
                    if (arguments.length == 1) {
                        this._client = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ClientArgs;
            }());
            signalling.ClientArgs = ClientArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientEndArgs = /** @class */ (function (_super) {
                __extends(ClientEndArgs, _super);
                function ClientEndArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientEndArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientEndArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                ClientEndArgs.prototype.getException = function () {
                    if (arguments.length == 0) {
                        return this._exception;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientEndArgs.prototype.getMessage = function () {
                    if (arguments.length == 0) {
                        return this._message;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientEndArgs.prototype.setException = function (value) {
                    if (arguments.length == 1) {
                        this._exception = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientEndArgs.prototype.setMessage = function (value) {
                    if (arguments.length == 1) {
                        this._message = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ClientEndArgs;
            }(fm.liveswitch.signalling.ClientArgs));
            signalling.ClientEndArgs = ClientEndArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientEndArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientEndArgsGeneric = /** @class */ (function (_super) {
                __extends(ClientEndArgsGeneric, _super);
                function ClientEndArgsGeneric(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_1 = __arguments[0];
                        _this = _super.call(this) || this;
                        _this.setMethodArgs(methodArgs_1);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientEndArgsGeneric.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientEndArgsGeneric]' + ',' + _super.prototype.getTypeString.call(this);
                };
                ClientEndArgsGeneric.prototype.getMethodArgs = function () {
                    if (arguments.length == 0) {
                        return this._methodArgs;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientEndArgsGeneric.prototype.setMethodArgs = function (value) {
                    if (arguments.length == 1) {
                        this._methodArgs = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ClientEndArgsGeneric;
            }(fm.liveswitch.signalling.ClientEndArgs));
            signalling.ClientEndArgsGeneric = ClientEndArgsGeneric;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientEndArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientBindEndArgs = /** @class */ (function (_super) {
                __extends(ClientBindEndArgs, _super);
                function ClientBindEndArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_2 = __arguments[0];
                        _this = _super.call(this, methodArgs_2) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientBindEndArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientBindEndArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientBindEndArgs;
            }(fm.liveswitch.signalling.ClientEndArgsGeneric));
            signalling.ClientBindEndArgs = ClientBindEndArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientRequestArgs = /** @class */ (function (_super) {
                __extends(ClientRequestArgs, _super);
                function ClientRequestArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingClientRequestArgsInit();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientRequestArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientRequestArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                ClientRequestArgs.prototype.fmliveswitchsignallingClientRequestArgsInit = function () {
                    this._cancel = false;
                };
                ClientRequestArgs.prototype.getCancel = function () {
                    if (arguments.length == 0) {
                        return this._cancel;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientRequestArgs.prototype.setCancel = function (value) {
                    if (arguments.length == 1) {
                        this._cancel = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ClientRequestArgs;
            }(fm.liveswitch.signalling.ClientArgs));
            signalling.ClientRequestArgs = ClientRequestArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientRequestArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientRequestArgsGeneric = /** @class */ (function (_super) {
                __extends(ClientRequestArgsGeneric, _super);
                function ClientRequestArgsGeneric(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_3 = __arguments[0];
                        _this = _super.call(this) || this;
                        _this.setMethodArgs(methodArgs_3);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientRequestArgsGeneric.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientRequestArgsGeneric]' + ',' + _super.prototype.getTypeString.call(this);
                };
                ClientRequestArgsGeneric.prototype.getMethodArgs = function () {
                    if (arguments.length == 0) {
                        return this._methodArgs;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientRequestArgsGeneric.prototype.setMethodArgs = function (value) {
                    if (arguments.length == 1) {
                        this._methodArgs = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ClientRequestArgsGeneric;
            }(fm.liveswitch.signalling.ClientRequestArgs));
            signalling.ClientRequestArgsGeneric = ClientRequestArgsGeneric;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientRequestArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientBindRequestArgs = /** @class */ (function (_super) {
                __extends(ClientBindRequestArgs, _super);
                function ClientBindRequestArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_4 = __arguments[0];
                        _this = _super.call(this, methodArgs_4) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientBindRequestArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientBindRequestArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientBindRequestArgs;
            }(fm.liveswitch.signalling.ClientRequestArgsGeneric));
            signalling.ClientBindRequestArgs = ClientBindRequestArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientResponseArgs = /** @class */ (function (_super) {
                __extends(ClientResponseArgs, _super);
                function ClientResponseArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientResponseArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientResponseArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                ClientResponseArgs.prototype.getException = function () {
                    if (arguments.length == 0) {
                        return this._exception;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientResponseArgs.prototype.getMessage = function () {
                    if (arguments.length == 0) {
                        return this._message;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientResponseArgs.prototype.setException = function (value) {
                    if (arguments.length == 1) {
                        this._exception = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientResponseArgs.prototype.setMessage = function (value) {
                    if (arguments.length == 1) {
                        this._message = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ClientResponseArgs;
            }(fm.liveswitch.signalling.ClientArgs));
            signalling.ClientResponseArgs = ClientResponseArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientResponseArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientResponseArgsGeneric = /** @class */ (function (_super) {
                __extends(ClientResponseArgsGeneric, _super);
                function ClientResponseArgsGeneric() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else if (__arguments.length == 1) {
                        var methodArgs = __arguments[0];
                        // chained constructor: ClientResponseArgsGeneric.call(this);
                        __arguments = new Array(0);
                        {
                            _this = _super.call(this) || this;
                        }
                        _this.setMethodArgs(methodArgs);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientResponseArgsGeneric.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientResponseArgsGeneric]' + ',' + _super.prototype.getTypeString.call(this);
                };
                ClientResponseArgsGeneric.prototype.getMethodArgs = function () {
                    if (arguments.length == 0) {
                        return this._methodArgs;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientResponseArgsGeneric.prototype.setMethodArgs = function (value) {
                    if (arguments.length == 1) {
                        this._methodArgs = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ClientResponseArgsGeneric;
            }(fm.liveswitch.signalling.ClientResponseArgs));
            signalling.ClientResponseArgsGeneric = ClientResponseArgsGeneric;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientResponseArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientBindResponseArgs = /** @class */ (function (_super) {
                __extends(ClientBindResponseArgs, _super);
                function ClientBindResponseArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_5 = __arguments[0];
                        _this = _super.call(this, methodArgs_5) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientBindResponseArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientBindResponseArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientBindResponseArgs;
            }(fm.liveswitch.signalling.ClientResponseArgsGeneric));
            signalling.ClientBindResponseArgs = ClientBindResponseArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientEndArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientConnectEndArgs = /** @class */ (function (_super) {
                __extends(ClientConnectEndArgs, _super);
                function ClientConnectEndArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_6 = __arguments[0];
                        _this = _super.call(this, methodArgs_6) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientConnectEndArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientConnectEndArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientConnectEndArgs;
            }(fm.liveswitch.signalling.ClientEndArgsGeneric));
            signalling.ClientConnectEndArgs = ClientConnectEndArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientRequestArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientConnectRequestArgs = /** @class */ (function (_super) {
                __extends(ClientConnectRequestArgs, _super);
                function ClientConnectRequestArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_7 = __arguments[0];
                        _this = _super.call(this, methodArgs_7) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientConnectRequestArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientConnectRequestArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientConnectRequestArgs;
            }(fm.liveswitch.signalling.ClientRequestArgsGeneric));
            signalling.ClientConnectRequestArgs = ClientConnectRequestArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientResponseArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientConnectResponseArgs = /** @class */ (function (_super) {
                __extends(ClientConnectResponseArgs, _super);
                function ClientConnectResponseArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_8 = __arguments[0];
                        _this = _super.call(this, methodArgs_8) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientConnectResponseArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientConnectResponseArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientConnectResponseArgs;
            }(fm.liveswitch.signalling.ClientResponseArgsGeneric));
            signalling.ClientConnectResponseArgs = ClientConnectResponseArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientEndArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientDisconnectEndArgs = /** @class */ (function (_super) {
                __extends(ClientDisconnectEndArgs, _super);
                function ClientDisconnectEndArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_9 = __arguments[0];
                        _this = _super.call(this, methodArgs_9) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientDisconnectEndArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientDisconnectEndArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientDisconnectEndArgs;
            }(fm.liveswitch.signalling.ClientEndArgsGeneric));
            signalling.ClientDisconnectEndArgs = ClientDisconnectEndArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientRequestArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientDisconnectRequestArgs = /** @class */ (function (_super) {
                __extends(ClientDisconnectRequestArgs, _super);
                function ClientDisconnectRequestArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_10 = __arguments[0];
                        _this = _super.call(this, methodArgs_10) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientDisconnectRequestArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientDisconnectRequestArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientDisconnectRequestArgs;
            }(fm.liveswitch.signalling.ClientRequestArgsGeneric));
            signalling.ClientDisconnectRequestArgs = ClientDisconnectRequestArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientResponseArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientDisconnectResponseArgs = /** @class */ (function (_super) {
                __extends(ClientDisconnectResponseArgs, _super);
                function ClientDisconnectResponseArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_11 = __arguments[0];
                        _this = _super.call(this, methodArgs_11) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientDisconnectResponseArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientDisconnectResponseArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientDisconnectResponseArgs;
            }(fm.liveswitch.signalling.ClientResponseArgsGeneric));
            signalling.ClientDisconnectResponseArgs = ClientDisconnectResponseArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientEndArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientPublishEndArgs = /** @class */ (function (_super) {
                __extends(ClientPublishEndArgs, _super);
                function ClientPublishEndArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_12 = __arguments[0];
                        _this = _super.call(this, methodArgs_12) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientPublishEndArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientPublishEndArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientPublishEndArgs;
            }(fm.liveswitch.signalling.ClientEndArgsGeneric));
            signalling.ClientPublishEndArgs = ClientPublishEndArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientRequestArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientPublishRequestArgs = /** @class */ (function (_super) {
                __extends(ClientPublishRequestArgs, _super);
                function ClientPublishRequestArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_13 = __arguments[0];
                        _this = _super.call(this, methodArgs_13) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientPublishRequestArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientPublishRequestArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientPublishRequestArgs;
            }(fm.liveswitch.signalling.ClientRequestArgsGeneric));
            signalling.ClientPublishRequestArgs = ClientPublishRequestArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientResponseArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientPublishResponseArgs = /** @class */ (function (_super) {
                __extends(ClientPublishResponseArgs, _super);
                function ClientPublishResponseArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_14 = __arguments[0];
                        _this = _super.call(this, methodArgs_14) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientPublishResponseArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientPublishResponseArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientPublishResponseArgs;
            }(fm.liveswitch.signalling.ClientResponseArgsGeneric));
            signalling.ClientPublishResponseArgs = ClientPublishResponseArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientRequest = /** @class */ (function (_super) {
                __extends(ClientRequest, _super);
                function ClientRequest() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientRequest.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientRequest]' + ',' + _super.prototype.getTypeString.call(this);
                };
                ClientRequest.prototype.getCallback = function () {
                    if (arguments.length == 0) {
                        return this._callback;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientRequest.prototype.getMessage = function () {
                    if (arguments.length == 0) {
                        return this._message;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientRequest.prototype.setCallback = function (value) {
                    if (arguments.length == 1) {
                        this._callback = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientRequest.prototype.setMessage = function (value) {
                    if (arguments.length == 1) {
                        this._message = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ClientRequest;
            }(fm.liveswitch.Dynamic));
            signalling.ClientRequest = ClientRequest;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientResponse = /** @class */ (function (_super) {
                __extends(ClientResponse, _super);
                function ClientResponse() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _this.setFailureSource(fm.liveswitch.FailureSource.None);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientResponse.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientResponse]' + ',' + _super.prototype.getTypeString.call(this);
                };
                ClientResponse.prototype.getErrorCode = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.FailureArgs.getErrorCode(this.getException());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientResponse.prototype.getErrorMessage = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.FailureArgs.getErrorMessage(this.getException());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientResponse.prototype.getException = function () {
                    if (arguments.length == 0) {
                        return this._exception;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientResponse.prototype.getFailureSource = function () {
                    if (arguments.length == 0) {
                        return this._failureSource;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientResponse.prototype.getMessage = function () {
                    if (arguments.length == 0) {
                        if (((fm.liveswitch.Global.equals(this.getMessages(), null)) || (fm.liveswitch.Global.equals(this.getMessages().length, 0)))) {
                            return null;
                        }
                        return this.getMessages()[0];
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientResponse.prototype.getMessages = function () {
                    if (arguments.length == 0) {
                        return this._messages;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientResponse.prototype.setException = function (value) {
                    if (arguments.length == 1) {
                        this._exception = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientResponse.prototype.setFailureSource = function (value) {
                    if (arguments.length == 1) {
                        this._failureSource = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientResponse.prototype.setMessage = function (value) {
                    if (arguments.length == 1) {
                        this.setMessages([value]);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientResponse.prototype.setMessages = function (value) {
                    if (arguments.length == 1) {
                        this._messages = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ClientResponse;
            }(fm.liveswitch.Dynamic));
            signalling.ClientResponse = ClientResponse;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientSendState = /** @class */ (function () {
                function ClientSendState() {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        //super();
                        this.fmliveswitchsignallingClientSendStateInit();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                ClientSendState.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientSendState]';
                };
                ClientSendState.prototype.fmliveswitchsignallingClientSendStateInit = function () {
                    this._isStream = false;
                };
                ClientSendState.prototype.getIsStream = function () {
                    if (arguments.length == 0) {
                        return this._isStream;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientSendState.prototype.getRequestMapping = function () {
                    if (arguments.length == 0) {
                        return this._requestMapping;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientSendState.prototype.getRequests = function () {
                    if (arguments.length == 0) {
                        return this._requests;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientSendState.prototype.setIsStream = function (value) {
                    if (arguments.length == 1) {
                        this._isStream = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientSendState.prototype.setRequestMapping = function (value) {
                    if (arguments.length == 1) {
                        this._requestMapping = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ClientSendState.prototype.setRequests = function (value) {
                    if (arguments.length == 1) {
                        this._requests = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ClientSendState;
            }());
            signalling.ClientSendState = ClientSendState;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientEndArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientServiceEndArgs = /** @class */ (function (_super) {
                __extends(ClientServiceEndArgs, _super);
                function ClientServiceEndArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_15 = __arguments[0];
                        _this = _super.call(this, methodArgs_15) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientServiceEndArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientServiceEndArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientServiceEndArgs;
            }(fm.liveswitch.signalling.ClientEndArgsGeneric));
            signalling.ClientServiceEndArgs = ClientServiceEndArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientRequestArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientServiceRequestArgs = /** @class */ (function (_super) {
                __extends(ClientServiceRequestArgs, _super);
                function ClientServiceRequestArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_16 = __arguments[0];
                        _this = _super.call(this, methodArgs_16) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientServiceRequestArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientServiceRequestArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientServiceRequestArgs;
            }(fm.liveswitch.signalling.ClientRequestArgsGeneric));
            signalling.ClientServiceRequestArgs = ClientServiceRequestArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientResponseArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientServiceResponseArgs = /** @class */ (function (_super) {
                __extends(ClientServiceResponseArgs, _super);
                function ClientServiceResponseArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_17 = __arguments[0];
                        _this = _super.call(this, methodArgs_17) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientServiceResponseArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientServiceResponseArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientServiceResponseArgs;
            }(fm.liveswitch.signalling.ClientResponseArgsGeneric));
            signalling.ClientServiceResponseArgs = ClientServiceResponseArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientStateWrapper = /** @class */ (function () {
                function ClientStateWrapper(value) {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var value_67 = __arguments[0];
                        //super();
                        this._value = value_67;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                ClientStateWrapper.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientStateWrapper]';
                };
                ClientStateWrapper.prototype.toString = function () {
                    if (arguments.length == 0) {
                        if (this._value == fm.liveswitch.signalling.ClientState.New)
                            return 'New';
                        if (this._value == fm.liveswitch.signalling.ClientState.Connecting)
                            return 'Connecting';
                        if (this._value == fm.liveswitch.signalling.ClientState.Connected)
                            return 'Connected';
                        if (this._value == fm.liveswitch.signalling.ClientState.Disconnecting)
                            return 'Disconnecting';
                        if (this._value == fm.liveswitch.signalling.ClientState.Disconnected)
                            return 'Disconnected';
                        return '';
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ClientStateWrapper;
            }());
            signalling.ClientStateWrapper = ClientStateWrapper;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientEndArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientSubscribeEndArgs = /** @class */ (function (_super) {
                __extends(ClientSubscribeEndArgs, _super);
                function ClientSubscribeEndArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_18 = __arguments[0];
                        _this = _super.call(this, methodArgs_18) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientSubscribeEndArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientSubscribeEndArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientSubscribeEndArgs;
            }(fm.liveswitch.signalling.ClientEndArgsGeneric));
            signalling.ClientSubscribeEndArgs = ClientSubscribeEndArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientRequestArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientSubscribeRequestArgs = /** @class */ (function (_super) {
                __extends(ClientSubscribeRequestArgs, _super);
                function ClientSubscribeRequestArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_19 = __arguments[0];
                        _this = _super.call(this, methodArgs_19) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientSubscribeRequestArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientSubscribeRequestArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientSubscribeRequestArgs;
            }(fm.liveswitch.signalling.ClientRequestArgsGeneric));
            signalling.ClientSubscribeRequestArgs = ClientSubscribeRequestArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientResponseArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientSubscribeResponseArgs = /** @class */ (function (_super) {
                __extends(ClientSubscribeResponseArgs, _super);
                function ClientSubscribeResponseArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_20 = __arguments[0];
                        _this = _super.call(this, methodArgs_20) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientSubscribeResponseArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientSubscribeResponseArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientSubscribeResponseArgs;
            }(fm.liveswitch.signalling.ClientResponseArgsGeneric));
            signalling.ClientSubscribeResponseArgs = ClientSubscribeResponseArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientEndArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientUnbindEndArgs = /** @class */ (function (_super) {
                __extends(ClientUnbindEndArgs, _super);
                function ClientUnbindEndArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_21 = __arguments[0];
                        _this = _super.call(this, methodArgs_21) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientUnbindEndArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientUnbindEndArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientUnbindEndArgs;
            }(fm.liveswitch.signalling.ClientEndArgsGeneric));
            signalling.ClientUnbindEndArgs = ClientUnbindEndArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientRequestArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientUnbindRequestArgs = /** @class */ (function (_super) {
                __extends(ClientUnbindRequestArgs, _super);
                function ClientUnbindRequestArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_22 = __arguments[0];
                        _this = _super.call(this, methodArgs_22) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientUnbindRequestArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientUnbindRequestArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientUnbindRequestArgs;
            }(fm.liveswitch.signalling.ClientRequestArgsGeneric));
            signalling.ClientUnbindRequestArgs = ClientUnbindRequestArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientResponseArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientUnbindResponseArgs = /** @class */ (function (_super) {
                __extends(ClientUnbindResponseArgs, _super);
                function ClientUnbindResponseArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_23 = __arguments[0];
                        _this = _super.call(this, methodArgs_23) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientUnbindResponseArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientUnbindResponseArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientUnbindResponseArgs;
            }(fm.liveswitch.signalling.ClientResponseArgsGeneric));
            signalling.ClientUnbindResponseArgs = ClientUnbindResponseArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientEndArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientUnsubscribeEndArgs = /** @class */ (function (_super) {
                __extends(ClientUnsubscribeEndArgs, _super);
                function ClientUnsubscribeEndArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_24 = __arguments[0];
                        _this = _super.call(this, methodArgs_24) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientUnsubscribeEndArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientUnsubscribeEndArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientUnsubscribeEndArgs;
            }(fm.liveswitch.signalling.ClientEndArgsGeneric));
            signalling.ClientUnsubscribeEndArgs = ClientUnsubscribeEndArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientRequestArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientUnsubscribeRequestArgs = /** @class */ (function (_super) {
                __extends(ClientUnsubscribeRequestArgs, _super);
                function ClientUnsubscribeRequestArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_25 = __arguments[0];
                        _this = _super.call(this, methodArgs_25) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientUnsubscribeRequestArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientUnsubscribeRequestArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientUnsubscribeRequestArgs;
            }(fm.liveswitch.signalling.ClientRequestArgsGeneric));
            signalling.ClientUnsubscribeRequestArgs = ClientUnsubscribeRequestArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ClientResponseArgsGeneric.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ClientUnsubscribeResponseArgs = /** @class */ (function (_super) {
                __extends(ClientUnsubscribeResponseArgs, _super);
                function ClientUnsubscribeResponseArgs(methodArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var methodArgs_26 = __arguments[0];
                        _this = _super.call(this, methodArgs_26) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ClientUnsubscribeResponseArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ClientUnsubscribeResponseArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ClientUnsubscribeResponseArgs;
            }(fm.liveswitch.signalling.ClientResponseArgsGeneric));
            signalling.ClientUnsubscribeResponseArgs = ClientUnsubscribeResponseArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/OutputArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var CompleteArgs = /** @class */ (function (_super) {
                __extends(CompleteArgs, _super);
                function CompleteArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                CompleteArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.CompleteArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return CompleteArgs;
            }(fm.liveswitch.signalling.OutputArgs));
            signalling.CompleteArgs = CompleteArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ConcurrencyModeWrapper = /** @class */ (function () {
                function ConcurrencyModeWrapper(value) {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var value_68 = __arguments[0];
                        //super();
                        this._value = value_68;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                ConcurrencyModeWrapper.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ConcurrencyModeWrapper]';
                };
                ConcurrencyModeWrapper.prototype.toString = function () {
                    if (arguments.length == 0) {
                        if (this._value == fm.liveswitch.signalling.ConcurrencyMode.Low)
                            return 'Low';
                        if (this._value == fm.liveswitch.signalling.ConcurrencyMode.High)
                            return 'High';
                        if (this._value == fm.liveswitch.signalling.ConcurrencyMode.Default)
                            return 'Default';
                        return '';
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ConcurrencyModeWrapper;
            }());
            signalling.ConcurrencyModeWrapper = ConcurrencyModeWrapper;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/InputArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ConnectArgs = /** @class */ (function (_super) {
                __extends(ConnectArgs, _super);
                function ConnectArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ConnectArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ConnectArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                ConnectArgs.prototype.getOnFailure = function () {
                    if (arguments.length == 0) {
                        return this._onFailure;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ConnectArgs.prototype.getOnSuccess = function () {
                    if (arguments.length == 0) {
                        return this._onSuccess;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ConnectArgs.prototype.setOnFailure = function (value) {
                    if (arguments.length == 1) {
                        this._onFailure = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ConnectArgs.prototype.setOnSuccess = function (value) {
                    if (arguments.length == 1) {
                        this._onSuccess = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ConnectArgs;
            }(fm.liveswitch.signalling.InputArgs));
            signalling.ConnectArgs = ConnectArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/FailureArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ConnectFailureArgs = /** @class */ (function (_super) {
                __extends(ConnectFailureArgs, _super);
                function ConnectFailureArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ConnectFailureArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ConnectFailureArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ConnectFailureArgs;
            }(fm.liveswitch.signalling.FailureArgs));
            signalling.ConnectFailureArgs = ConnectFailureArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ConnectionTypeWrapper = /** @class */ (function () {
                function ConnectionTypeWrapper(value) {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var value_69 = __arguments[0];
                        //super();
                        this._value = value_69;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                ConnectionTypeWrapper.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ConnectionTypeWrapper]';
                };
                ConnectionTypeWrapper.prototype.toString = function () {
                    if (arguments.length == 0) {
                        if (this._value == fm.liveswitch.signalling.ConnectionType.WebSocket)
                            return 'WebSocket';
                        if (this._value == fm.liveswitch.signalling.ConnectionType.LongPolling)
                            return 'LongPolling';
                        if (this._value == fm.liveswitch.signalling.ConnectionType.CallbackPolling)
                            return 'CallbackPolling';
                        if (this._value == fm.liveswitch.signalling.ConnectionType.IFrame)
                            return 'IFrame';
                        if (this._value == fm.liveswitch.signalling.ConnectionType.Flash)
                            return 'Flash';
                        if (this._value == fm.liveswitch.signalling.ConnectionType.NotSet)
                            return 'NotSet';
                        return '';
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ConnectionTypeWrapper;
            }());
            signalling.ConnectionTypeWrapper = ConnectionTypeWrapper;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/SuccessArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ConnectSuccessArgs = /** @class */ (function (_super) {
                __extends(ConnectSuccessArgs, _super);
                function ConnectSuccessArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ConnectSuccessArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ConnectSuccessArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                ConnectSuccessArgs.prototype.getConnectionType = function () {
                    if (arguments.length == 0) {
                        return this._connectionType;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                ConnectSuccessArgs.prototype.setConnectionType = function (value) {
                    if (arguments.length == 1) {
                        this._connectionType = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ConnectSuccessArgs;
            }(fm.liveswitch.signalling.SuccessArgs));
            signalling.ConnectSuccessArgs = ConnectSuccessArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var Defaults = /** @class */ (function () {
                function Defaults() {
                    fm.liveswitch.signalling.Defaults.fmliveswitchsignallingDefaultsInitialize();
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        //super();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                Defaults.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.Defaults]';
                };
                Defaults.getDomainKey = function () {
                    fm.liveswitch.signalling.Defaults.fmliveswitchsignallingDefaultsInitialize();
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Defaults.fm_liveswitch_signalling_Defaults___domainKey;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Defaults.getDomainName = function () {
                    fm.liveswitch.signalling.Defaults.fmliveswitchsignallingDefaultsInitialize();
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Defaults.fm_liveswitch_signalling_Defaults___domainName;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Defaults.fmliveswitchsignallingDefaultsInitialize = function () {
                    if (!fm.liveswitch.signalling.Defaults.__fmliveswitchsignallingDefaultsInitialized && !fm.liveswitch.signalling.Defaults.__fmliveswitchsignallingDefaultsInitializing) {
                        fm.liveswitch.signalling.Defaults.__fmliveswitchsignallingDefaultsInitializing = true;
                        fm.liveswitch.signalling.Defaults.fm_liveswitch_signalling_Defaults___domainKey = "11111111-1111-1111-1111-111111111111";
                        fm.liveswitch.signalling.Defaults.fm_liveswitch_signalling_Defaults___domainName = "localhost";
                        fm.liveswitch.signalling.Defaults.__fmliveswitchsignallingDefaultsInitialized = true;
                        fm.liveswitch.signalling.Defaults.__fmliveswitchsignallingDefaultsInitializing = false;
                    }
                };
                /** @hidden */
                Defaults.__fmliveswitchsignallingDefaultsInitialized = false;
                /** @hidden */
                Defaults.__fmliveswitchsignallingDefaultsInitializing = false;
                return Defaults;
            }());
            signalling.Defaults = Defaults;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var DeferredStreamState = /** @class */ (function () {
                function DeferredStreamState() {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        //super();
                        this.fmliveswitchsignallingDeferredStreamStateInit();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                DeferredStreamState.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.DeferredStreamState]';
                };
                DeferredStreamState.prototype.fmliveswitchsignallingDeferredStreamStateInit = function () {
                    this._receivedMessages = false;
                };
                DeferredStreamState.prototype.getReceivedMessages = function () {
                    if (arguments.length == 0) {
                        return this._receivedMessages;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                DeferredStreamState.prototype.setReceivedMessages = function (value) {
                    if (arguments.length == 1) {
                        this._receivedMessages = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return DeferredStreamState;
            }());
            signalling.DeferredStreamState = DeferredStreamState;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/InputArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var DisconnectArgs = /** @class */ (function (_super) {
                __extends(DisconnectArgs, _super);
                function DisconnectArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                DisconnectArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.DisconnectArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                DisconnectArgs.prototype.getOnComplete = function () {
                    if (arguments.length == 0) {
                        return this._onComplete;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                DisconnectArgs.prototype.setOnComplete = function (value) {
                    if (arguments.length == 1) {
                        this._onComplete = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return DisconnectArgs;
            }(fm.liveswitch.signalling.InputArgs));
            signalling.DisconnectArgs = DisconnectArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/CompleteArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var DisconnectCompleteArgs = /** @class */ (function (_super) {
                __extends(DisconnectCompleteArgs, _super);
                function DisconnectCompleteArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                DisconnectCompleteArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.DisconnectCompleteArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                DisconnectCompleteArgs.prototype.getException = function () {
                    if (arguments.length == 0) {
                        return this._exception;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                DisconnectCompleteArgs.prototype.setException = function (value) {
                    if (arguments.length == 1) {
                        this._exception = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return DisconnectCompleteArgs;
            }(fm.liveswitch.signalling.CompleteArgs));
            signalling.DisconnectCompleteArgs = DisconnectCompleteArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var Extensions = /** @class */ (function (_super) {
                __extends(Extensions, _super);
                function Extensions() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _this.setExtensionJsons({});
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                Extensions.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.Extensions]' + ',' + _super.prototype.getTypeString.call(this);
                };
                Extensions.fromJson = function (extensionsJson) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.deserializeObjectFast(extensionsJson, function () {
                            return new fm.liveswitch.signalling.Extensions();
                        }, function (obj, name, valueJson) {
                            obj.setValueJson(name, fm.liveswitch.JsonSerializer.deserializeRaw(valueJson), false);
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensions.toJson = function (extensions) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.serializeObjectFast(extensions, function (obj, jsonObject) {
                            for (var _i = 0, _a = obj.getNames(); _i < _a.length; _i++) {
                                var str = _a[_i];
                                jsonObject[str] = fm.liveswitch.JsonSerializer.serializeRaw(obj.getValueJson(str));
                            }
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensions.prototype.getCount = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.HashExtensions.getCount(this.getExtensionJsons());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Extensions.prototype.getExtensionJsons = function () {
                    if (arguments.length == 0) {
                        return this._extensionJsons;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensions.prototype.getNames = function () {
                    if (arguments.length == 0) {
                        var list = new Array();
                        fm.liveswitch.ArrayExtensions.addRange(list, fm.liveswitch.HashExtensions.getKeys(this.getExtensionJsons()));
                        return list;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensions.prototype.getValueJson = function (name) {
                    if (arguments.length == 1) {
                        if (fm.liveswitch.HashExtensions.containsKey(this.getExtensionJsons(), name)) {
                            return this.getExtensionJsons()[name];
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Extensions.prototype.setExtensionJsons = function (value) {
                    if (arguments.length == 1) {
                        this._extensionJsons = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensions.prototype.setValueJson = function () {
                    if (arguments.length == 2) {
                        var name_42 = arguments[0];
                        var valueJson = arguments[1];
                        this.setValueJson(name_42, valueJson, true);
                    }
                    else if (arguments.length == 3) {
                        var name_43 = arguments[0];
                        var valueJson = arguments[1];
                        var validate = arguments[2];
                        if ((fm.liveswitch.Global.equals(valueJson, null))) {
                            if (fm.liveswitch.HashExtensions.containsKey(this.getExtensionJsons(), name_43)) {
                                fm.liveswitch.HashExtensions.remove(this.getExtensionJsons(), name_43);
                            }
                        }
                        else {
                            if (!(!validate || fm.liveswitch.JsonSerializer.isValidJson(valueJson))) {
                                throw new fm.liveswitch.Exception("The value is not valid JSON.");
                            }
                            this.getExtensionJsons()[name_43] = valueJson;
                        }
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensions.prototype.toJson = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensions.toJson(this);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensions.prototype.getValue = function (name) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.Json.deserialize(this.getValueJson.apply(this, arguments));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Extensions.prototype.setValue = function () {
                    if (arguments.length == 2) {
                        var name_44 = arguments[0];
                        var value = arguments[1];
                        arguments[arguments.length - 1] = fm.liveswitch.Json.serialize(arguments[arguments.length - 1]);
                        this.setValueJson.apply(this, arguments);
                    }
                    else if (arguments.length == 3) {
                        var name_45 = arguments[0];
                        var valueJson = arguments[1];
                        var value = arguments[2];
                        arguments[arguments.length - 1] = fm.liveswitch.Json.serialize(arguments[arguments.length - 1]);
                        this.setValueJson.apply(this, arguments);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Extensions;
            }(fm.liveswitch.Dynamic));
            signalling.Extensions = Extensions;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var MessageTransfer = /** @class */ (function () {
                function MessageTransfer() {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        //super();
                        this._requestArgsKey = "fm.liveswitch.signalling.messageTransfer.requestArgs";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                MessageTransfer.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.MessageTransfer]';
                };
                /** @hidden */
                MessageTransfer.raiseRequestCreated = function (requestArgs) {
                    if (arguments.length == 1) {
                        if ((!fm.liveswitch.Global.equals(requestArgs.getOnRequestCreated(), null))) {
                            var p = new fm.liveswitch.signalling.MessageRequestCreatedArgs();
                            p.setRequests(requestArgs.getMessages());
                            p.setSender(requestArgs.getSender());
                            requestArgs.getOnRequestCreated()(p);
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MessageTransfer.raiseResponseReceived = function (responseArgs) {
                    if (arguments.length == 1) {
                        if (((fm.liveswitch.Global.equals(responseArgs.getException(), null)) && (!fm.liveswitch.Global.equals(responseArgs.getRequestArgs().getOnResponseReceived(), null)))) {
                            var p = new fm.liveswitch.signalling.MessageResponseReceivedArgs();
                            p.setResponses(responseArgs.getMessages());
                            p.setSender(responseArgs.getRequestArgs().getSender());
                            responseArgs.getRequestArgs().getOnResponseReceived()(p);
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageTransfer.prototype.httpResponseArgsToMessageResponseArgs = function (httpResponseArgs) {
                    if (arguments.length == 1) {
                        var dynamicValue = httpResponseArgs.getRequestArgs().getDynamicValue(this._requestArgsKey);
                        var args3 = new fm.liveswitch.signalling.MessageResponseArgs(dynamicValue);
                        args3.setStatusCode(httpResponseArgs.getStatusCode());
                        args3.setTextContent(httpResponseArgs.getTextContent());
                        args3.setBinaryContent(httpResponseArgs.getBinaryContent());
                        args3.setException(httpResponseArgs.getException());
                        args3.setRetries(httpResponseArgs.getRetries());
                        args3.setHeaders(httpResponseArgs.getHeaders());
                        var args2 = args3;
                        if (!fm.liveswitch.StringExtensions.isNullOrEmpty(httpResponseArgs.getTextContent())) {
                            args2.setMessages(fm.liveswitch.signalling.Message.fromJsonArray(httpResponseArgs.getTextContent()));
                            return args2;
                        }
                        if ((!fm.liveswitch.Global.equals(httpResponseArgs.getBinaryContent(), null))) {
                            args2.setMessages(fm.liveswitch.signalling.Message.fromBinaryMultiple(httpResponseArgs.getBinaryContent()));
                        }
                        return args2;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageTransfer.prototype.messageRequestArgsToHttpRequestArgs = function (requestArgs) {
                    if (arguments.length == 1) {
                        var args2 = new fm.liveswitch.HttpRequestArgs();
                        args2.setMethod(fm.liveswitch.HttpMethod.Post);
                        args2.setOnRequestCreated(requestArgs.getOnHttpRequestCreated());
                        args2.setOnResponseReceived(requestArgs.getOnHttpResponseReceived());
                        args2.setSender(requestArgs.getSender());
                        args2.setTimeout(requestArgs.getTimeout());
                        args2.setMaxRetries(requestArgs.getMaxRetries());
                        args2.setUrl(requestArgs.getUrl());
                        args2.setDynamicProperties(requestArgs.getDynamicProperties());
                        var args = args2;
                        args.setDynamicValue(this._requestArgsKey, requestArgs);
                        for (var _i = 0, _a = requestArgs.getHeaders().getAllKeys(); _i < _a.length; _i++) {
                            var str = _a[_i];
                            args.getHeaders().set(str, requestArgs.getHeaders().get(str));
                        }
                        args.setTextContent(fm.liveswitch.signalling.Message.toJsonArray(requestArgs.getMessages()));
                        args.getHeaders().set("Content-Type", "application/json");
                        if (requestArgs.getIsBinary()) {
                            args.setBinaryContent(fm.liveswitch.signalling.Message.toBinaryMultiple(requestArgs.getMessages()));
                            args.getHeaders().set("Content-Type", "application/octet-stream");
                        }
                        return args;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageTransfer.prototype.send = function (requestArgs) {
                    if (arguments.length == 1) {
                        var args = void 0;
                        fm.liveswitch.signalling.MessageTransfer.raiseRequestCreated(requestArgs);
                        try {
                            args = this.sendMessages(requestArgs);
                            fm.liveswitch.signalling.MessageTransfer.raiseResponseReceived(args);
                        }
                        catch (exception) {
                            var args2 = new fm.liveswitch.signalling.MessageResponseArgs(requestArgs);
                            args2.setException(exception);
                            args = args2;
                        }
                        finally {
                        }
                        return args;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageTransfer.prototype.sendAsync = function (requestArgs, callback) {
                    if (arguments.length == 2) {
                        var action = null;
                        fm.liveswitch.signalling.MessageTransfer.raiseRequestCreated(requestArgs);
                        try {
                            if ((fm.liveswitch.Global.equals(action, null))) {
                                action = function (responseArgs) {
                                    fm.liveswitch.signalling.MessageTransfer.raiseResponseReceived(responseArgs);
                                    callback(responseArgs);
                                };
                            }
                            this.sendMessagesAsync(requestArgs, action);
                        }
                        catch (exception) {
                            var p = new fm.liveswitch.signalling.MessageResponseArgs(requestArgs);
                            p.setException(exception);
                            callback(p);
                        }
                        finally {
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return MessageTransfer;
            }());
            signalling.MessageTransfer = MessageTransfer;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/MessageTransfer.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var HttpMessageTransfer = /** @class */ (function (_super) {
                __extends(HttpMessageTransfer, _super);
                function HttpMessageTransfer() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _this._httpTransfer = fm.liveswitch.HttpTransferFactory.getHttpTransfer();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                HttpMessageTransfer.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.HttpMessageTransfer]' + ',' + _super.prototype.getTypeString.call(this);
                };
                HttpMessageTransfer.prototype.sendMessages = function (requestArgs) {
                    if (arguments.length == 1) {
                        var args = _super.prototype.messageRequestArgsToHttpRequestArgs.call(this, requestArgs);
                        var httpResponseArgs = this._httpTransfer.send(args);
                        return _super.prototype.httpResponseArgsToMessageResponseArgs.call(this, httpResponseArgs);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                HttpMessageTransfer.prototype.sendMessagesAsync = function (requestArgs, callback) {
                    var _this = this;
                    if (arguments.length == 2) {
                        var args = _super.prototype.messageRequestArgsToHttpRequestArgs.call(this, requestArgs);
                        this._httpTransfer.sendAsync(args, function (httpResponseArgs) {
                            var p = _this.httpResponseArgsToMessageResponseArgs(httpResponseArgs);
                            callback(p);
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                HttpMessageTransfer.prototype.shutdown = function () {
                    if (arguments.length == 0) {
                        try {
                            this._httpTransfer.shutdown();
                        }
                        catch (exception1) {
                        }
                        finally {
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return HttpMessageTransfer;
            }(fm.liveswitch.signalling.MessageTransfer));
            signalling.HttpMessageTransfer = HttpMessageTransfer;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/Extensible.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var MessageBase = /** @class */ (function (_super) {
                __extends(MessageBase, _super);
                function MessageBase() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingMessageBaseInit();
                        _this.setValidate(true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                MessageBase.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.MessageBase]' + ',' + _super.prototype.getTypeString.call(this);
                };
                MessageBase.prototype.fmliveswitchsignallingMessageBaseInit = function () {
                    this.__successful = false;
                    this._validate = false;
                };
                MessageBase.deserializeTimestamp = function (timestampJson) {
                    if (arguments.length == 1) {
                        var str = fm.liveswitch.JsonSerializer.deserializeString(timestampJson);
                        var utcNow = fm.liveswitch.DateTime.getUtcNow();
                        if (!fm.liveswitch.StringExtensions.isNullOrEmpty(str)) {
                            var strArray = fm.liveswitch.StringExtensions.split(str, [84]);
                            if ((!fm.liveswitch.Global.equals(strArray.length, 2))) {
                                return utcNow;
                            }
                            var str2 = strArray[0];
                            var str3 = strArray[1];
                            strArray = fm.liveswitch.StringExtensions.split(str2, [45]);
                            if ((!fm.liveswitch.Global.equals(strArray.length, 3))) {
                                return utcNow;
                            }
                            var s = strArray[0];
                            var str5 = strArray[1];
                            var str6 = strArray[2];
                            strArray = fm.liveswitch.StringExtensions.split(str3, [58]);
                            if ((!fm.liveswitch.Global.equals(strArray.length, 3))) {
                                return utcNow;
                            }
                            var str7 = strArray[0];
                            var str8 = strArray[1];
                            strArray = fm.liveswitch.StringExtensions.split(strArray[2], [46]);
                            if ((!fm.liveswitch.Global.equals(strArray.length, 2))) {
                                return utcNow;
                            }
                            var str10 = strArray[0];
                            var intResult = 0;
                            var num2 = 0;
                            var num3 = 0;
                            var num4 = 0;
                            var num5 = 0;
                            var num6 = 0;
                            var _var0 = new fm.liveswitch.Holder(intResult);
                            var _var1 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(s, _var0);
                            intResult = _var0.getValue();
                            var _var2 = new fm.liveswitch.Holder(num2);
                            var _var3 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(str5, _var2);
                            num2 = _var2.getValue();
                            var _var4 = new fm.liveswitch.Holder(num3);
                            var _var5 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(str6, _var4);
                            num3 = _var4.getValue();
                            var _var6 = new fm.liveswitch.Holder(num4);
                            var _var7 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(str7, _var6);
                            num4 = _var6.getValue();
                            var _var8 = new fm.liveswitch.Holder(num5);
                            var _var9 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(str8, _var8);
                            num5 = _var8.getValue();
                            var _var10 = new fm.liveswitch.Holder(num6);
                            var _var11 = fm.liveswitch.ParseAssistant.tryParseIntegerValue(str10, _var10);
                            num6 = _var10.getValue();
                            if (((((_var1 && _var3) && (_var5 && _var7)) && _var9) && _var11)) {
                                utcNow = new fm.liveswitch.DateTime(intResult, num2, num3, num4, num5, num6);
                            }
                        }
                        return utcNow;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageBase.serializeTimestamp = function (timestamp) {
                    if (arguments.length == 1) {
                        var str = null;
                        if ((timestamp != null)) {
                            var str2 = fm.liveswitch.NumberExtensions.toString(timestamp.getYear());
                            var str3 = fm.liveswitch.NumberExtensions.toString(timestamp.getMonth());
                            var str4 = fm.liveswitch.NumberExtensions.toString(timestamp.getDay());
                            var str5 = fm.liveswitch.NumberExtensions.toString(timestamp.getHour());
                            var str6 = fm.liveswitch.NumberExtensions.toString(timestamp.getMinute());
                            var str7 = fm.liveswitch.NumberExtensions.toString(timestamp.getSecond());
                            while ((fm.liveswitch.StringExtensions.getLength(str2) < 4)) {
                                str2 = fm.liveswitch.StringExtensions.concat("0", str2);
                            }
                            while ((fm.liveswitch.StringExtensions.getLength(str3) < 2)) {
                                str3 = fm.liveswitch.StringExtensions.concat("0", str3);
                            }
                            while ((fm.liveswitch.StringExtensions.getLength(str4) < 2)) {
                                str4 = fm.liveswitch.StringExtensions.concat("0", str4);
                            }
                            while ((fm.liveswitch.StringExtensions.getLength(str5) < 2)) {
                                str5 = fm.liveswitch.StringExtensions.concat("0", str5);
                            }
                            while ((fm.liveswitch.StringExtensions.getLength(str6) < 2)) {
                                str6 = fm.liveswitch.StringExtensions.concat("0", str6);
                            }
                            while ((fm.liveswitch.StringExtensions.getLength(str7) < 2)) {
                                str7 = fm.liveswitch.StringExtensions.concat("0", str7);
                            }
                            str = fm.liveswitch.StringExtensions.format("{0}-{1}-{2}T{3}:{4}:{5}.00", [str2, str3, str4, str5, str6, str7]);
                        }
                        return fm.liveswitch.JsonSerializer.serializeString(str);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageBase.prototype.getDataBytes = function () {
                    if (arguments.length == 0) {
                        var decoded = this.__dataBytes;
                        var valueJson = this.__dataJson;
                        if ((!fm.liveswitch.Global.equals(decoded, null))) {
                            return decoded;
                        }
                        if ((!fm.liveswitch.Global.equals(valueJson, null))) {
                            var _var0 = new fm.liveswitch.Holder(decoded);
                            var _var1 = fm.liveswitch.Base64.tryDecode(fm.liveswitch.JsonSerializer.deserializeString(valueJson), _var0);
                            decoded = _var0.getValue();
                            if (!_var1) {
                                decoded = null;
                            }
                            this.__dataBytes = decoded;
                            return decoded;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageBase.prototype.getDataJson = function () {
                    if (arguments.length == 0) {
                        var str = this.__dataJson;
                        var b = this.__dataBytes;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            return str;
                        }
                        if ((!fm.liveswitch.Global.equals(b, null))) {
                            str = fm.liveswitch.JsonSerializer.serializeString(fm.liveswitch.Base64.encode(b));
                            this.__dataJson = str;
                            return str;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageBase.prototype.getError = function () {
                    if (arguments.length == 0) {
                        return this.__error;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageBase.prototype.getIsBinary = function () {
                    if (arguments.length == 0) {
                        return (!fm.liveswitch.Global.equals(this.getDataBytes(), null));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageBase.prototype.getSuccessful = function () {
                    if (arguments.length == 0) {
                        return this.__successful;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageBase.prototype.getTimestamp = function () {
                    if (arguments.length == 0) {
                        return this.__timestamp;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageBase.prototype.getValidate = function () {
                    if (arguments.length == 0) {
                        return this._validate;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageBase.prototype.setDataBytes = function (value) {
                    if (arguments.length == 1) {
                        this.__dataJson = null;
                        this.__dataBytes = value;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageBase.prototype.setDataJson = function (value) {
                    if (arguments.length == 1) {
                        if (!((!this.getValidate() || (fm.liveswitch.Global.equals(value, null))) || fm.liveswitch.JsonSerializer.isValidJson(value))) {
                            throw new fm.liveswitch.Exception("The value is not valid JSON.");
                        }
                        this.__dataJson = value;
                        this.__dataBytes = null;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageBase.prototype.setError = function (value) {
                    if (arguments.length == 1) {
                        this.__error = value;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageBase.prototype.setSuccessful = function (value) {
                    if (arguments.length == 1) {
                        this.__successful = value;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageBase.prototype.setTimestamp = function (value) {
                    if (arguments.length == 1) {
                        this.__timestamp = value;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageBase.prototype.setValidate = function (value) {
                    if (arguments.length == 1) {
                        this._validate = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageBase.prototype.getData = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.Json.deserialize(this.getDataJson.apply(this, arguments));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageBase.prototype.setData = function (data) {
                    if (arguments.length == 1) {
                        arguments[arguments.length - 1] = fm.liveswitch.Json.serialize(arguments[arguments.length - 1]);
                        this.setDataJson.apply(this, arguments);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return MessageBase;
            }(fm.liveswitch.signalling.Extensible));
            signalling.MessageBase = MessageBase;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/MessageBase.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var Message = /** @class */ (function (_super) {
                __extends(Message, _super);
                function Message() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _this._toJsonNoDataLock = new Object();
                        _this.__connectionType = fm.liveswitch.signalling.ConnectionType.NotSet;
                    }
                    else if (__arguments.length == 1) {
                        var bayeuxChannel = __arguments[0];
                        // chained constructor: Message.call(this);
                        __arguments = new Array(0);
                        {
                            _this = _super.call(this) || this;
                            _this._toJsonNoDataLock = new Object();
                            _this.__connectionType = fm.liveswitch.signalling.ConnectionType.NotSet;
                        }
                        _super.prototype.setValidate.call(_this, false);
                        _this.setBayeuxChannel(bayeuxChannel);
                        _super.prototype.setValidate.call(_this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                Message.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.Message]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /** @hidden */
                Message.bytesToInt = function (bytes, index) {
                    if (arguments.length == 2) {
                        if ((bytes.length < (index + 4))) {
                            return -1;
                        }
                        return fm.liveswitch.Binary.fromBytes32(bytes, index, false);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Message.deserializeConnectionType = function (connectionTypeJson) {
                    if (arguments.length == 1) {
                        var _var0 = fm.liveswitch.JsonSerializer.deserializeString(connectionTypeJson);
                        if (_var0 == "long-polling") {
                            do {
                                return fm.liveswitch.signalling.ConnectionType.LongPolling;
                            } while (false);
                        }
                        else if (_var0 == "callback-polling") {
                            do {
                                return fm.liveswitch.signalling.ConnectionType.CallbackPolling;
                            } while (false);
                        }
                        else if (_var0 == "websocket") {
                            do {
                                return fm.liveswitch.signalling.ConnectionType.WebSocket;
                            } while (false);
                        }
                        else if (_var0 == "iframe") {
                            do {
                                return fm.liveswitch.signalling.ConnectionType.IFrame;
                            } while (false);
                        }
                        else if (_var0 == "flash") {
                            do {
                                return fm.liveswitch.signalling.ConnectionType.Flash;
                            } while (false);
                        }
                        return fm.liveswitch.signalling.ConnectionType.NotSet;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Message.deserializeConnectionTypeArray = function (connectionTypesJson) {
                    if (arguments.length == 1) {
                        if ((((fm.liveswitch.StringExtensions.isNullOrEmpty(connectionTypesJson) || (fm.liveswitch.Global.equals(connectionTypesJson, "null"))) || ((fm.liveswitch.StringExtensions.getLength(connectionTypesJson) < 2) || (!fm.liveswitch.Global.equals(connectionTypesJson.charCodeAt(0), 91)))) || (!fm.liveswitch.Global.equals(connectionTypesJson.charCodeAt((fm.liveswitch.StringExtensions.getLength(connectionTypesJson) - 1)), 93)))) {
                            return null;
                        }
                        connectionTypesJson = fm.liveswitch.StringExtensions.substring(connectionTypesJson, 1, (fm.liveswitch.StringExtensions.getLength(connectionTypesJson) - 2));
                        var strArray = fm.liveswitch.StringExtensions.split(connectionTypesJson, [44]);
                        var typeArray = new Array(strArray.length);
                        for (var i = 0; (i < strArray.length); i++) {
                            typeArray[i] = fm.liveswitch.signalling.Message.deserializeConnectionType(strArray[i]);
                        }
                        return typeArray;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Message.deserializeRemoteClientTable = function (remoteClientsJson) {
                    if (arguments.length == 1) {
                        var dictionary = fm.liveswitch.JsonSerializer.deserializeObject(remoteClientsJson, function () {
                            return {};
                        }, function (remoteClient, name, valueJson) {
                            remoteClient[name] = fm.liveswitch.signalling.RemoteClient.fromJsonArray(valueJson);
                        });
                        if ((fm.liveswitch.Global.equals(dictionary, null))) {
                            return null;
                        }
                        return dictionary;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.fromBinary = function () {
                    if (arguments.length == 1) {
                        var bytes = arguments[0];
                        return fm.liveswitch.signalling.Message.fromBinary(bytes, 0);
                    }
                    else if (arguments.length == 2) {
                        var bytes = arguments[0];
                        var offset = arguments[1];
                        var count = fm.liveswitch.signalling.Message.bytesToInt(bytes, offset);
                        if ((count < 0)) {
                            return null;
                        }
                        offset = (offset + 4);
                        var num2 = fm.liveswitch.signalling.Message.bytesToInt(bytes, offset);
                        if ((num2 < 0)) {
                            return null;
                        }
                        offset = (offset + 4);
                        var input = fm.liveswitch.BitAssistant.subArray(bytes, offset, count);
                        offset = (offset + count);
                        var buffer2 = fm.liveswitch.BitAssistant.subArray(bytes, offset, num2);
                        offset = (offset + num2);
                        var message = fm.liveswitch.signalling.Message.fromJson(fm.liveswitch.Utf8.decode(input, 0, input.length));
                        message.setDataBytes(buffer2);
                        return message;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.fromBinaryMultiple = function (bytes) {
                    if (arguments.length == 1) {
                        var index = 0;
                        var num2 = fm.liveswitch.signalling.Message.bytesToInt(bytes, index);
                        if ((num2 < 0)) {
                            return new Array(0);
                        }
                        index = (index + 4);
                        var messageArray = new Array(num2);
                        for (var i = 0; (i < num2); i++) {
                            var num4 = fm.liveswitch.signalling.Message.bytesToInt(bytes, index);
                            if ((num4 < 0)) {
                                return new Array(0);
                            }
                            index = (index + 4);
                            var message = fm.liveswitch.signalling.Message.fromBinary(bytes, index);
                            if ((fm.liveswitch.Global.equals(message, null))) {
                                return new Array(0);
                            }
                            index = (index + num4);
                            messageArray[i] = message;
                        }
                        return messageArray;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.fromJson = function (messageJson) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.deserializeObjectFast(messageJson, function () {
                            return new fm.liveswitch.signalling.Message();
                        }, function (obj, name, valueJson) {
                            obj.setValidate(false);
                            var _var0 = name;
                            if (_var0 == "advice") {
                                do {
                                    obj.setAdvice(fm.liveswitch.signalling.Advice.fromJson(valueJson));
                                    break;
                                } while (false);
                            }
                            else if (_var0 == "records") {
                                do {
                                    obj.setRecords(fm.liveswitch.signalling.Record.fromJsonArray(valueJson));
                                    break;
                                } while (false);
                            }
                            else if (_var0 == "keys") {
                                do {
                                    obj.setKeys(fm.liveswitch.JsonSerializer.deserializeStringArray(valueJson));
                                    break;
                                } while (false);
                            }
                            else if (_var0 == "channel") {
                                do {
                                    obj.setBayeuxChannel(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                    break;
                                } while (false);
                            }
                            else if (_var0 == "clientId") {
                                do {
                                    obj.setClientId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                    break;
                                } while (false);
                            }
                            else if (_var0 == "connectionType") {
                                do {
                                    obj.setConnectionType(fm.liveswitch.signalling.Message.deserializeConnectionType(valueJson));
                                    break;
                                } while (false);
                            }
                            else if (_var0 == "data") {
                                do {
                                    obj.setDataJson(fm.liveswitch.JsonSerializer.deserializeRaw(valueJson));
                                    break;
                                } while (false);
                            }
                            else if (_var0 == "error") {
                                do {
                                    obj.setError(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                    break;
                                } while (false);
                            }
                            else if (_var0 == "ext") {
                                do {
                                    obj.setExtensions(fm.liveswitch.signalling.Extensions.fromJson(valueJson));
                                    break;
                                } while (false);
                            }
                            else if (_var0 == "id") {
                                do {
                                    obj.setId(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                    break;
                                } while (false);
                            }
                            else if (_var0 == "minimumVersion") {
                                do {
                                    obj.setMinimumVersion(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                    break;
                                } while (false);
                            }
                            else if (_var0 == "subscription") {
                                do {
                                    if (!fm.liveswitch.StringExtensions.startsWith(valueJson, "[")) {
                                        var str = fm.liveswitch.JsonSerializer.deserializeString(valueJson);
                                        if (!fm.liveswitch.StringExtensions.isNullOrEmpty(str)) {
                                            obj.setChannels([str]);
                                        }
                                        break;
                                    }
                                    obj.setChannels(fm.liveswitch.JsonSerializer.deserializeStringArray(valueJson));
                                    break;
                                } while (false);
                            }
                            else if (_var0 == "successful") {
                                do {
                                    var nullable = fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson);
                                    obj.setSuccessful((fm.liveswitch.Global.equals(nullable, true)));
                                    break;
                                } while (false);
                            }
                            else if (_var0 == "supportedConnectionTypes") {
                                do {
                                    obj.setSupportedConnectionTypes(fm.liveswitch.signalling.Message.deserializeConnectionTypeArray(valueJson));
                                    break;
                                } while (false);
                            }
                            else if (_var0 == "timestamp") {
                                do {
                                    obj.setTimestamp(fm.liveswitch.signalling.MessageBase.deserializeTimestamp(valueJson));
                                    break;
                                } while (false);
                            }
                            else if (_var0 == "version") {
                                do {
                                    obj.setVersion(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                    break;
                                } while (false);
                            }
                            obj.setValidate(true);
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.fromJsonArray = function (messagesJson) {
                    if (arguments.length == 1) {
                        var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(messagesJson, fm.liveswitch.signalling.Message.fromJson.bind(fm.liveswitch.signalling.Message));
                        if ((fm.liveswitch.Global.equals(list, null))) {
                            return null;
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Message.intToBytes = function (i) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.Binary.toBytes32(i, false);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Message.serializeConnectionType = function (connectionType) {
                    if (arguments.length == 1) {
                        var str = null;
                        var _var0 = connectionType;
                        if (_var0 == fm.liveswitch.signalling.ConnectionType.WebSocket) {
                            do {
                                str = "websocket";
                                break;
                            } while (false);
                        }
                        else if (_var0 == fm.liveswitch.signalling.ConnectionType.LongPolling) {
                            do {
                                str = "long-polling";
                                break;
                            } while (false);
                        }
                        else if (_var0 == fm.liveswitch.signalling.ConnectionType.CallbackPolling) {
                            do {
                                str = "callback-polling";
                                break;
                            } while (false);
                        }
                        else if (_var0 == fm.liveswitch.signalling.ConnectionType.IFrame) {
                            do {
                                str = "iframe";
                                break;
                            } while (false);
                        }
                        else if (_var0 == fm.liveswitch.signalling.ConnectionType.Flash) {
                            do {
                                str = "flash";
                                break;
                            } while (false);
                        }
                        return fm.liveswitch.JsonSerializer.serializeString(str);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Message.serializeConnectionTypeArray = function (connectionTypes) {
                    if (arguments.length == 1) {
                        var strArray = new Array(connectionTypes.length);
                        for (var i = 0; (i < connectionTypes.length); i++) {
                            strArray[i] = fm.liveswitch.signalling.Message.serializeConnectionType(connectionTypes[i]);
                        }
                        return fm.liveswitch.StringExtensions.concat("[", fm.liveswitch.StringExtensions.join(",", strArray), "]");
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Message.serializeRemoteClientTable = function (remoteClients) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.serializeObject(remoteClients, function (rc, jsonObject) {
                            for (var _i = 0, _a = fm.liveswitch.HashExtensions.getKeys(remoteClients); _i < _a.length; _i++) {
                                var str = _a[_i];
                                jsonObject[str] = fm.liveswitch.signalling.RemoteClient.toJsonArray(remoteClients[str]);
                            }
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.toBinary = function (message) {
                    if (arguments.length == 1) {
                        var dataBytes = null;
                        var dataJson = null;
                        var _var0 = new fm.liveswitch.Holder(dataBytes);
                        var _var1 = new fm.liveswitch.Holder(dataJson);
                        var _var2 = message.toJsonNoData(_var0, _var1);
                        dataBytes = _var0.getValue();
                        dataJson = _var1.getValue();
                        var input = _var2;
                        if ((fm.liveswitch.Global.equals(dataBytes, null))) {
                            if ((fm.liveswitch.Global.equals(dataJson, null))) {
                                throw new fm.liveswitch.Exception("Message data bytes cannot be null.");
                            }
                            throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Message data bytes cannot be null (JSON: {0}).", dataJson));
                        }
                        if ((fm.liveswitch.Global.equals(input, null))) {
                            throw new fm.liveswitch.Exception("Message JSON cannot be null.");
                        }
                        var source = fm.liveswitch.Utf8.encode(input);
                        var destination = new Uint8Array(((8 + source.length) + dataBytes.length));
                        var destinationIndex = 0;
                        fm.liveswitch.BitAssistant.copy(fm.liveswitch.signalling.Message.intToBytes(source.length), 0, destination, destinationIndex, 4);
                        destinationIndex = (destinationIndex + 4);
                        fm.liveswitch.BitAssistant.copy(fm.liveswitch.signalling.Message.intToBytes(dataBytes.length), 0, destination, destinationIndex, 4);
                        destinationIndex = (destinationIndex + 4);
                        fm.liveswitch.BitAssistant.copy(source, 0, destination, destinationIndex, source.length);
                        destinationIndex = (destinationIndex + source.length);
                        fm.liveswitch.BitAssistant.copy(dataBytes, 0, destination, destinationIndex, dataBytes.length);
                        destinationIndex = (destinationIndex + dataBytes.length);
                        return destination;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.toBinaryMultiple = function (messages) {
                    if (arguments.length == 1) {
                        var num = 4;
                        var list = new Array();
                        for (var _i = 0, messages_1 = messages; _i < messages_1.length; _i++) {
                            var message = messages_1[_i];
                            var item = fm.liveswitch.signalling.Message.toBinary(message);
                            fm.liveswitch.ArrayExtensions.add(list, item);
                            num = (num + (4 + item.length));
                        }
                        var destination = new Uint8Array(num);
                        var destinationIndex = 0;
                        fm.liveswitch.BitAssistant.copy(fm.liveswitch.signalling.Message.intToBytes(fm.liveswitch.ArrayExtensions.getCount(list)), 0, destination, destinationIndex, 4);
                        destinationIndex = (destinationIndex + 4);
                        for (var _a = 0, list_16 = list; _a < list_16.length; _a++) {
                            var buffer = list_16[_a];
                            fm.liveswitch.BitAssistant.copy(fm.liveswitch.signalling.Message.intToBytes(buffer.length), 0, destination, destinationIndex, 4);
                            destinationIndex = (destinationIndex + 4);
                            fm.liveswitch.BitAssistant.copy(buffer, 0, destination, destinationIndex, buffer.length);
                            destinationIndex = (destinationIndex + buffer.length);
                        }
                        return destination;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.toJson = function (message) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.serializeObjectFast(message, function (obj, jsonObject) {
                            if ((!fm.liveswitch.Global.equals(obj.getClientId(), null))) {
                                jsonObject["clientId"] = fm.liveswitch.JsonSerializer.serializeString(obj.getClientId());
                            }
                            if ((obj.getTimestamp() != null)) {
                                jsonObject["timestamp"] = fm.liveswitch.signalling.MessageBase.serializeTimestamp(obj.getTimestamp());
                            }
                            if ((!fm.liveswitch.Global.equals(obj.getAdvice(), null))) {
                                jsonObject["advice"] = fm.liveswitch.signalling.Advice.toJson(obj.getAdvice());
                            }
                            if ((!fm.liveswitch.Global.equals(obj.getRecords(), null))) {
                                jsonObject["records"] = fm.liveswitch.signalling.Record.toJsonArray(obj.getRecords());
                            }
                            if ((!fm.liveswitch.Global.equals(obj.getKeys(), null))) {
                                jsonObject["keys"] = fm.liveswitch.JsonSerializer.serializeStringArray(obj.getKeys());
                            }
                            if ((!fm.liveswitch.Global.equals(obj.getBayeuxChannel(), null))) {
                                jsonObject["channel"] = fm.liveswitch.JsonSerializer.serializeString(obj.getBayeuxChannel());
                            }
                            if ((!fm.liveswitch.Global.equals(obj.getConnectionType(), fm.liveswitch.signalling.ConnectionType.NotSet))) {
                                jsonObject["connectionType"] = fm.liveswitch.signalling.Message.serializeConnectionType(obj.getConnectionType());
                            }
                            if ((!fm.liveswitch.Global.equals(obj.getDataJson(), null))) {
                                jsonObject["data"] = fm.liveswitch.JsonSerializer.serializeRaw(obj.getDataJson());
                            }
                            if ((!fm.liveswitch.Global.equals(obj.getError(), null))) {
                                jsonObject["error"] = fm.liveswitch.JsonSerializer.serializeString(obj.getError());
                            }
                            if ((obj.getExtensions().getCount() > 0)) {
                                jsonObject["ext"] = fm.liveswitch.signalling.Extensions.toJson(obj.getExtensions());
                            }
                            if ((!fm.liveswitch.Global.equals(obj.getId(), null))) {
                                jsonObject["id"] = fm.liveswitch.JsonSerializer.serializeString(obj.getId());
                            }
                            if ((!fm.liveswitch.Global.equals(obj.getMinimumVersion(), null))) {
                                jsonObject["minimumVersion"] = fm.liveswitch.JsonSerializer.serializeString(obj.getMinimumVersion());
                            }
                            if (((!fm.liveswitch.Global.equals(obj.getChannels(), null)) && ((fm.liveswitch.Global.equals(obj.getType(), fm.liveswitch.signalling.MessageType.Subscribe)) || (fm.liveswitch.Global.equals(obj.getType(), fm.liveswitch.signalling.MessageType.Unsubscribe))))) {
                                jsonObject["subscription"] = fm.liveswitch.JsonSerializer.serializeStringArray(obj.getChannels());
                            }
                            if (obj.getSuccessful()) {
                                jsonObject["successful"] = fm.liveswitch.JsonSerializer.serializeBoolean(obj.getSuccessful());
                            }
                            if ((!fm.liveswitch.Global.equals(obj.getSupportedConnectionTypes(), null))) {
                                jsonObject["supportedConnectionTypes"] = fm.liveswitch.signalling.Message.serializeConnectionTypeArray(obj.getSupportedConnectionTypes());
                            }
                            if ((!fm.liveswitch.Global.equals(obj.getVersion(), null))) {
                                jsonObject["version"] = fm.liveswitch.JsonSerializer.serializeString(obj.getVersion());
                            }
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.toJsonArray = function (messages) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.serializeObjectArray(messages, fm.liveswitch.signalling.Message.toJson.bind(fm.liveswitch.signalling.Message));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getAcknowledgement = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.JsonSerializer.deserializeBoolean(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getAcknowledgementExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getAdvice = function () {
                    if (arguments.length == 0) {
                        return this.__advice;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getAuthToken = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.JsonSerializer.deserializeString(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getAuthTokenExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getBayeuxChannel = function () {
                    if (arguments.length == 0) {
                        return this.__bayeuxChannel;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getChannel = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetChannel(this.__channels);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getChannels = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetChannels(this.__channels);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getClientId = function () {
                    if (arguments.length == 0) {
                        return this.__clientId;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getConnectionType = function () {
                    if (arguments.length == 0) {
                        return this.__connectionType;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getDeviceId = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.JsonSerializer.deserializeString(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getDeviceIdExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getDisableBinary = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.JsonSerializer.deserializeBoolean(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getDisableBinaryExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getId = function () {
                    if (arguments.length == 0) {
                        return this.__id;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getIsPrivate = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.JsonSerializer.deserializeBoolean(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getIsPrivateExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getKey = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetKey(this.__keys);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getKeys = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetKeys(this.__keys);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getMinimumVersion = function () {
                    if (arguments.length == 0) {
                        return this.__minimumVersion;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getPresence = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.JsonSerializer.deserializeBoolean(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getPresenceExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getRecord = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetRecord(this.__records);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getRecords = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetRecords(this.__records);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getRemoteClient = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.RemoteClient.fromJson(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getRemoteClientExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getReturnData = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.JsonSerializer.deserializeBoolean(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getReturnDataExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getServerActions = function () {
                    if (arguments.length == 0) {
                        var extensionValueJson = _super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getServerActionsExtensionName());
                        if (!fm.liveswitch.StringExtensions.isNullOrEmpty(extensionValueJson)) {
                            var messageArray = fm.liveswitch.signalling.Message.fromJsonArray(extensionValueJson);
                            if ((!fm.liveswitch.Global.equals(messageArray, null))) {
                                return messageArray;
                            }
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getServerTimeout = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.JsonSerializer.deserializeInteger(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getServerTimeoutExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getStreamId = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.JsonSerializer.deserializeString(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getStreamIdExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getSubscribedClients = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Message.deserializeRemoteClientTable(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getSubscribedClientsExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getSupportedConnectionTypes = function () {
                    if (arguments.length == 0) {
                        return this.__supportedConnectionTypes;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getTag = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.StringExtensions.nullCoalesce(fm.liveswitch.JsonSerializer.deserializeString(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName())), fm.liveswitch.StringExtensions.empty);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getType = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.MetaChannels.getMessageType(this.getBayeuxChannel());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getUserId = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.JsonSerializer.deserializeString(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getUserIdExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.getVersion = function () {
                    if (arguments.length == 0) {
                        return this.__version;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.isBind = function () {
                    if (arguments.length == 0) {
                        return (fm.liveswitch.Global.equals(this.getType(), fm.liveswitch.signalling.MessageType.Bind));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.isBindingTo = function (key) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(this.getType(), fm.liveswitch.signalling.MessageType.Bind))) {
                            if ((fm.liveswitch.Global.equals(this.getRecords(), null))) {
                                return false;
                            }
                            for (var _i = 0, _a = this.getRecords(); _i < _a.length; _i++) {
                                var record = _a[_i];
                                if ((fm.liveswitch.Global.equals(record.getKey(), key))) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.isConnect = function () {
                    if (arguments.length == 0) {
                        return (fm.liveswitch.Global.equals(this.getType(), fm.liveswitch.signalling.MessageType.Connect));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.isDisconnect = function () {
                    if (arguments.length == 0) {
                        return (fm.liveswitch.Global.equals(this.getType(), fm.liveswitch.signalling.MessageType.Disconnect));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.isPublish = function () {
                    if (arguments.length == 0) {
                        return (fm.liveswitch.Global.equals(this.getType(), fm.liveswitch.signalling.MessageType.Publish));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.isService = function () {
                    if (arguments.length == 0) {
                        return (fm.liveswitch.Global.equals(this.getType(), fm.liveswitch.signalling.MessageType.Service));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.isStream = function () {
                    if (arguments.length == 0) {
                        return (fm.liveswitch.Global.equals(this.getType(), fm.liveswitch.signalling.MessageType.Stream));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.isSubscribe = function () {
                    if (arguments.length == 0) {
                        return (fm.liveswitch.Global.equals(this.getType(), fm.liveswitch.signalling.MessageType.Subscribe));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.isSubscribingTo = function (channel) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(this.getType(), fm.liveswitch.signalling.MessageType.Subscribe))) {
                            if ((fm.liveswitch.Global.equals(this.getChannels(), null))) {
                                return false;
                            }
                            for (var _i = 0, _a = this.getChannels(); _i < _a.length; _i++) {
                                var str = _a[_i];
                                if ((fm.liveswitch.Global.equals(str, channel))) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.isUnbind = function () {
                    if (arguments.length == 0) {
                        return (fm.liveswitch.Global.equals(this.getType(), fm.liveswitch.signalling.MessageType.Unbind));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.isUnbindingFrom = function (key) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(this.getType(), fm.liveswitch.signalling.MessageType.Unbind))) {
                            if ((fm.liveswitch.Global.equals(this.getKeys(), null))) {
                                return false;
                            }
                            for (var _i = 0, _a = this.getKeys(); _i < _a.length; _i++) {
                                var str = _a[_i];
                                if ((fm.liveswitch.Global.equals(str, key))) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.isUnsubscribe = function () {
                    if (arguments.length == 0) {
                        return (fm.liveswitch.Global.equals(this.getType(), fm.liveswitch.signalling.MessageType.Unsubscribe));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.isUnsubscribingFrom = function (channel) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(this.getType(), fm.liveswitch.signalling.MessageType.Unsubscribe))) {
                            if ((fm.liveswitch.Global.equals(this.getChannels(), null))) {
                                return false;
                            }
                            for (var _i = 0, _a = this.getChannels(); _i < _a.length; _i++) {
                                var str = _a[_i];
                                if ((fm.liveswitch.Global.equals(str, channel))) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setAcknowledgement = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getAcknowledgementExtensionName(), fm.liveswitch.JsonSerializer.serializeBoolean(value), false);
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setAdvice = function (value) {
                    if (arguments.length == 1) {
                        this.__advice = value;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setAuthToken = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getAuthTokenExtensionName(), fm.liveswitch.JsonSerializer.serializeString(value), false);
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setBayeuxChannel = function (value) {
                    if (arguments.length == 1) {
                        this.__bayeuxChannel = value;
                        if (fm.liveswitch.signalling.MetaChannels.isServiceChannel(value)) {
                            this.setChannel(fm.liveswitch.signalling.MetaChannels.convertChannelFromServiced(value));
                        }
                        else {
                            if (!fm.liveswitch.signalling.MetaChannels.isMetaChannel(value)) {
                                this.setChannel(value);
                            }
                        }
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setChannel = function (value) {
                    if (arguments.length == 1) {
                        this.__channels = fm.liveswitch.signalling.Extensible.sharedSetChannel(value, _super.prototype.getValidate.call(this));
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setChannels = function (value) {
                    if (arguments.length == 1) {
                        this.__channels = fm.liveswitch.signalling.Extensible.sharedSetChannels(value, _super.prototype.getValidate.call(this));
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setClientId = function (value) {
                    if (arguments.length == 1) {
                        this.__clientId = value;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setConnectionType = function (value) {
                    if (arguments.length == 1) {
                        this.__connectionType = value;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setDeviceId = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getDeviceIdExtensionName(), fm.liveswitch.JsonSerializer.serializeString(value), false);
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setDisableBinary = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getDisableBinaryExtensionName(), fm.liveswitch.JsonSerializer.serializeBoolean(value), false);
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setId = function (value) {
                    if (arguments.length == 1) {
                        this.__id = value;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setIsPrivate = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getIsPrivateExtensionName(), fm.liveswitch.JsonSerializer.serializeBoolean(value), false);
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setKey = function (value) {
                    if (arguments.length == 1) {
                        this.__keys = fm.liveswitch.signalling.Extensible.sharedSetKey(value, _super.prototype.getValidate.call(this));
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setKeys = function (value) {
                    if (arguments.length == 1) {
                        this.__keys = fm.liveswitch.signalling.Extensible.sharedSetKeys(value, _super.prototype.getValidate.call(this));
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setMinimumVersion = function (value) {
                    if (arguments.length == 1) {
                        this.__minimumVersion = value;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setPresence = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getPresenceExtensionName(), fm.liveswitch.JsonSerializer.serializeBoolean(value), false);
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setRecord = function (value) {
                    if (arguments.length == 1) {
                        this.__records = fm.liveswitch.signalling.Extensible.sharedSetRecord(value, _super.prototype.getValidate.call(this));
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setRecords = function (value) {
                    if (arguments.length == 1) {
                        this.__records = fm.liveswitch.signalling.Extensible.sharedSetRecords(value, _super.prototype.getValidate.call(this));
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setRemoteClient = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getRemoteClientExtensionName(), fm.liveswitch.signalling.RemoteClient.toJson(value), false);
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setReturnData = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getReturnDataExtensionName(), fm.liveswitch.JsonSerializer.serializeBoolean(value), false);
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setServerActions = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getServerActionsExtensionName(), fm.liveswitch.signalling.Message.toJsonArray(value), false);
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setServerTimeout = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getServerTimeoutExtensionName(), fm.liveswitch.JsonSerializer.serializeInteger(value), false);
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setStreamId = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getStreamIdExtensionName(), fm.liveswitch.JsonSerializer.serializeString(value), false);
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setSubscribedClients = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getSubscribedClientsExtensionName(), fm.liveswitch.signalling.Message.serializeRemoteClientTable(value), false);
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setSupportedConnectionTypes = function (value) {
                    if (arguments.length == 1) {
                        this.__supportedConnectionTypes = value;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setTag = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName(), fm.liveswitch.JsonSerializer.serializeString(fm.liveswitch.StringExtensions.nullCoalesce(value, fm.liveswitch.StringExtensions.empty)), false);
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setUserId = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getUserIdExtensionName(), fm.liveswitch.JsonSerializer.serializeString(value), false);
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.setVersion = function (value) {
                    if (arguments.length == 1) {
                        this.__version = value;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.toBinary = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Message.toBinary(this);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Message.prototype.toJson = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Message.toJson(this);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Message.prototype.toJsonNoData = function (dataBytes, dataJson) {
                    if (arguments.length == 2) {
                        var str = void 0;
                        if (_super.prototype.getIsBinary.call(this)) {
                            dataBytes.setValue(_super.prototype.getDataBytes.call(this));
                            dataJson.setValue(null);
                            _super.prototype.setDataBytes.call(this, null);
                            str = this.toJson();
                            _super.prototype.setDataBytes.call(this, dataBytes.getValue());
                            return str;
                        }
                        dataBytes.setValue(null);
                        dataJson.setValue(_super.prototype.getDataJson.call(this));
                        _super.prototype.setDataJson.call(this, null);
                        str = this.toJson();
                        _super.prototype.setDataJson.call(this, dataJson.getValue());
                        return str;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Message;
            }(fm.liveswitch.signalling.MessageBase));
            signalling.Message = Message;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var MessageRequestArgs = /** @class */ (function (_super) {
                __extends(MessageRequestArgs, _super);
                function MessageRequestArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingMessageRequestArgsInit();
                        _this.setTimeout(15000);
                    }
                    else if (__arguments.length == 1) {
                        var headers = __arguments[0];
                        // chained constructor: MessageRequestArgs.call(this);
                        __arguments = new Array(0);
                        {
                            _this = _super.call(this) || this;
                            _this.fmliveswitchsignallingMessageRequestArgsInit();
                            _this.setTimeout(15000);
                        }
                        _this.setHeaders(headers);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                MessageRequestArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.MessageRequestArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                MessageRequestArgs.prototype.fmliveswitchsignallingMessageRequestArgsInit = function () {
                    this._maxRetries = 0;
                    this._timeout = 0;
                };
                MessageRequestArgs.prototype.getHeaders = function () {
                    if (arguments.length == 0) {
                        return this._headers;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageRequestArgs.prototype.getIsBinary = function () {
                    if (arguments.length == 0) {
                        for (var _i = 0, _a = this.getMessages(); _i < _a.length; _i++) {
                            var message = _a[_i];
                            if (!((!fm.liveswitch.Global.equals(message.getDisableBinary(), true)) && message.getIsBinary())) {
                                return false;
                            }
                        }
                        return true;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageRequestArgs.prototype.getMaxRetries = function () {
                    if (arguments.length == 0) {
                        return this._maxRetries;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageRequestArgs.prototype.getMessages = function () {
                    if (arguments.length == 0) {
                        return this._messages;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageRequestArgs.prototype.getOnHttpRequestCreated = function () {
                    if (arguments.length == 0) {
                        return this._onHttpRequestCreated;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageRequestArgs.prototype.getOnHttpResponseReceived = function () {
                    if (arguments.length == 0) {
                        return this._onHttpResponseReceived;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageRequestArgs.prototype.getOnRequestCreated = function () {
                    if (arguments.length == 0) {
                        return this._onRequestCreated;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageRequestArgs.prototype.getOnResponseReceived = function () {
                    if (arguments.length == 0) {
                        return this._onResponseReceived;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageRequestArgs.prototype.getSender = function () {
                    if (arguments.length == 0) {
                        return this._sender;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageRequestArgs.prototype.getTimeout = function () {
                    if (arguments.length == 0) {
                        return this._timeout;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageRequestArgs.prototype.getUrl = function () {
                    if (arguments.length == 0) {
                        return this._url;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageRequestArgs.prototype.setHeaders = function (value) {
                    if (arguments.length == 1) {
                        this._headers = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageRequestArgs.prototype.setMaxRetries = function (value) {
                    if (arguments.length == 1) {
                        this._maxRetries = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageRequestArgs.prototype.setMessages = function (value) {
                    if (arguments.length == 1) {
                        this._messages = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageRequestArgs.prototype.setOnHttpRequestCreated = function (value) {
                    if (arguments.length == 1) {
                        this._onHttpRequestCreated = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageRequestArgs.prototype.setOnHttpResponseReceived = function (value) {
                    if (arguments.length == 1) {
                        this._onHttpResponseReceived = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageRequestArgs.prototype.setOnRequestCreated = function (value) {
                    if (arguments.length == 1) {
                        this._onRequestCreated = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageRequestArgs.prototype.setOnResponseReceived = function (value) {
                    if (arguments.length == 1) {
                        this._onResponseReceived = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageRequestArgs.prototype.setSender = function (value) {
                    if (arguments.length == 1) {
                        this._sender = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageRequestArgs.prototype.setTimeout = function (value) {
                    if (arguments.length == 1) {
                        this._timeout = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageRequestArgs.prototype.setUrl = function (value) {
                    if (arguments.length == 1) {
                        this._url = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return MessageRequestArgs;
            }(fm.liveswitch.Dynamic));
            signalling.MessageRequestArgs = MessageRequestArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var MessageRequestCreatedArgs = /** @class */ (function () {
                function MessageRequestCreatedArgs() {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        //super();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                MessageRequestCreatedArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.MessageRequestCreatedArgs]';
                };
                MessageRequestCreatedArgs.prototype.getRequests = function () {
                    if (arguments.length == 0) {
                        return this._requests;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageRequestCreatedArgs.prototype.getSender = function () {
                    if (arguments.length == 0) {
                        return this._sender;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MessageRequestCreatedArgs.prototype.setRequests = function (value) {
                    if (arguments.length == 1) {
                        this._requests = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MessageRequestCreatedArgs.prototype.setSender = function (value) {
                    if (arguments.length == 1) {
                        this._sender = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return MessageRequestCreatedArgs;
            }());
            signalling.MessageRequestCreatedArgs = MessageRequestCreatedArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var MessageResponseArgs = /** @class */ (function (_super) {
                __extends(MessageResponseArgs, _super);
                function MessageResponseArgs(requestArgs) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var requestArgs_1 = __arguments[0];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingMessageResponseArgsInit();
                        _this.setRequestArgs(requestArgs_1);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                MessageResponseArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.MessageResponseArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                MessageResponseArgs.prototype.fmliveswitchsignallingMessageResponseArgsInit = function () {
                    this._retries = 0;
                    this._statusCode = 0;
                };
                MessageResponseArgs.prototype.getBinaryContent = function () {
                    if (arguments.length == 0) {
                        return this._binaryContent;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageResponseArgs.prototype.getException = function () {
                    if (arguments.length == 0) {
                        return this._exception;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageResponseArgs.prototype.getHeaders = function () {
                    if (arguments.length == 0) {
                        return this._headers;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageResponseArgs.prototype.getMessages = function () {
                    if (arguments.length == 0) {
                        return this._messages;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageResponseArgs.prototype.getRequestArgs = function () {
                    if (arguments.length == 0) {
                        return this._requestArgs;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageResponseArgs.prototype.getRetries = function () {
                    if (arguments.length == 0) {
                        return this._retries;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageResponseArgs.prototype.getStatusCode = function () {
                    if (arguments.length == 0) {
                        return this._statusCode;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageResponseArgs.prototype.getTextContent = function () {
                    if (arguments.length == 0) {
                        return this._textContent;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageResponseArgs.prototype.setBinaryContent = function (value) {
                    if (arguments.length == 1) {
                        this._binaryContent = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageResponseArgs.prototype.setException = function (value) {
                    if (arguments.length == 1) {
                        this._exception = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageResponseArgs.prototype.setHeaders = function (value) {
                    if (arguments.length == 1) {
                        this._headers = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageResponseArgs.prototype.setMessages = function (value) {
                    if (arguments.length == 1) {
                        this._messages = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageResponseArgs.prototype.setRequestArgs = function (value) {
                    if (arguments.length == 1) {
                        this._requestArgs = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageResponseArgs.prototype.setRetries = function (value) {
                    if (arguments.length == 1) {
                        this._retries = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageResponseArgs.prototype.setStatusCode = function (value) {
                    if (arguments.length == 1) {
                        this._statusCode = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageResponseArgs.prototype.setTextContent = function (value) {
                    if (arguments.length == 1) {
                        this._textContent = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return MessageResponseArgs;
            }(fm.liveswitch.Dynamic));
            signalling.MessageResponseArgs = MessageResponseArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var MessageResponseReceivedArgs = /** @class */ (function () {
                function MessageResponseReceivedArgs() {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        //super();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                MessageResponseReceivedArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.MessageResponseReceivedArgs]';
                };
                MessageResponseReceivedArgs.prototype.getResponses = function () {
                    if (arguments.length == 0) {
                        return this._responses;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageResponseReceivedArgs.prototype.getSender = function () {
                    if (arguments.length == 0) {
                        return this._sender;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MessageResponseReceivedArgs.prototype.setResponses = function (value) {
                    if (arguments.length == 1) {
                        this._responses = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MessageResponseReceivedArgs.prototype.setSender = function (value) {
                    if (arguments.length == 1) {
                        this._sender = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return MessageResponseReceivedArgs;
            }());
            signalling.MessageResponseReceivedArgs = MessageResponseReceivedArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var MessageTransferFactory = /** @class */ (function () {
                function MessageTransferFactory() {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        //super();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                MessageTransferFactory.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.MessageTransferFactory]';
                };
                /** @hidden */
                MessageTransferFactory.defaultCreateHttpMessageTransfer = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.signalling.HttpMessageTransfer();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MessageTransferFactory.defaultCreateWebSocketMessageTransfer = function (requestUrl) {
                    if (arguments.length == 1) {
                        return new fm.liveswitch.signalling.WebSocketMessageTransfer(requestUrl);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageTransferFactory.getCreateHttpMessageTransfer = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.MessageTransferFactory.fm_liveswitch_signalling_MessageTransferFactory__createHttpMessageTransfer;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageTransferFactory.getCreateWebSocketMessageTransfer = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.MessageTransferFactory.fm_liveswitch_signalling_MessageTransferFactory__createWebSocketMessageTransfer;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageTransferFactory.getHttpMessageTransfer = function () {
                    if (arguments.length == 0) {
                        if ((fm.liveswitch.Global.equals(fm.liveswitch.signalling.MessageTransferFactory.getCreateHttpMessageTransfer(), null))) {
                            fm.liveswitch.signalling.MessageTransferFactory.setCreateHttpMessageTransfer(fm.liveswitch.signalling.MessageTransferFactory.defaultCreateHttpMessageTransfer.bind(fm.liveswitch.signalling.MessageTransferFactory));
                        }
                        var transfer = fm.liveswitch.signalling.MessageTransferFactory.getCreateHttpMessageTransfer()();
                        if ((fm.liveswitch.Global.equals(transfer, null))) {
                            transfer = fm.liveswitch.signalling.MessageTransferFactory.defaultCreateHttpMessageTransfer();
                        }
                        return transfer;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageTransferFactory.getWebSocketMessageTransfer = function (requestUrl) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(fm.liveswitch.signalling.MessageTransferFactory.getCreateWebSocketMessageTransfer(), null))) {
                            fm.liveswitch.signalling.MessageTransferFactory.setCreateWebSocketMessageTransfer(fm.liveswitch.signalling.MessageTransferFactory.defaultCreateWebSocketMessageTransfer.bind(fm.liveswitch.signalling.MessageTransferFactory));
                        }
                        var transfer = fm.liveswitch.signalling.MessageTransferFactory.getCreateWebSocketMessageTransfer()(requestUrl);
                        if ((fm.liveswitch.Global.equals(transfer, null))) {
                            transfer = fm.liveswitch.signalling.MessageTransferFactory.defaultCreateWebSocketMessageTransfer(requestUrl);
                        }
                        return transfer;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageTransferFactory.setCreateHttpMessageTransfer = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.signalling.MessageTransferFactory.fm_liveswitch_signalling_MessageTransferFactory__createHttpMessageTransfer = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MessageTransferFactory.setCreateWebSocketMessageTransfer = function (value) {
                    if (arguments.length == 1) {
                        fm.liveswitch.signalling.MessageTransferFactory.fm_liveswitch_signalling_MessageTransferFactory__createWebSocketMessageTransfer = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return MessageTransferFactory;
            }());
            signalling.MessageTransferFactory = MessageTransferFactory;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var MessageTypeWrapper = /** @class */ (function () {
                function MessageTypeWrapper(value) {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var value_70 = __arguments[0];
                        //super();
                        this._value = value_70;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                MessageTypeWrapper.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.MessageTypeWrapper]';
                };
                MessageTypeWrapper.prototype.toString = function () {
                    if (arguments.length == 0) {
                        if (this._value == fm.liveswitch.signalling.MessageType.Connect)
                            return 'Connect';
                        if (this._value == fm.liveswitch.signalling.MessageType.Disconnect)
                            return 'Disconnect';
                        if (this._value == fm.liveswitch.signalling.MessageType.Bind)
                            return 'Bind';
                        if (this._value == fm.liveswitch.signalling.MessageType.Unbind)
                            return 'Unbind';
                        if (this._value == fm.liveswitch.signalling.MessageType.Subscribe)
                            return 'Subscribe';
                        if (this._value == fm.liveswitch.signalling.MessageType.Unsubscribe)
                            return 'Unsubscribe';
                        if (this._value == fm.liveswitch.signalling.MessageType.Publish)
                            return 'Publish';
                        if (this._value == fm.liveswitch.signalling.MessageType.Service)
                            return 'Service';
                        if (this._value == fm.liveswitch.signalling.MessageType.Stream)
                            return 'Stream';
                        if (this._value == fm.liveswitch.signalling.MessageType.Unknown)
                            return 'Unknown';
                        return '';
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return MessageTypeWrapper;
            }());
            signalling.MessageTypeWrapper = MessageTypeWrapper;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var MetaChannels = /** @class */ (function () {
                function MetaChannels() {
                }
                MetaChannels.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.MetaChannels]';
                };
                MetaChannels.convertChannelFromServiced = function (channel) {
                    if (arguments.length == 1) {
                        if (!fm.liveswitch.signalling.MetaChannels.isServiceChannel(channel)) {
                            return channel;
                        }
                        return channel.substring((fm.liveswitch.StringExtensions.getLength(fm.liveswitch.signalling.MetaChannels.getServicePrefix()) - 1));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MetaChannels.convertChannelToServiced = function (channel) {
                    if (arguments.length == 1) {
                        if (((fm.liveswitch.Global.equals(channel, null)) || (fm.liveswitch.StringExtensions.getLength(channel) < 1))) {
                            return fm.liveswitch.signalling.MetaChannels.getServicePrefix();
                        }
                        return fm.liveswitch.StringExtensions.concat(fm.liveswitch.signalling.MetaChannels.getServicePrefix(), channel.substring(1));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MetaChannels.getBind = function () {
                    if (arguments.length == 0) {
                        return "/meta/bind";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MetaChannels.getConnect = function () {
                    if (arguments.length == 0) {
                        return "/meta/connect";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MetaChannels.getDisconnect = function () {
                    if (arguments.length == 0) {
                        return "/meta/disconnect";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MetaChannels.getHandshake = function () {
                    if (arguments.length == 0) {
                        return "/meta/handshake";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                MetaChannels.getMessageType = function (bayeuxChannel) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(bayeuxChannel, fm.liveswitch.signalling.MetaChannels.getHandshake()))) {
                            return fm.liveswitch.signalling.MessageType.Connect;
                        }
                        if ((fm.liveswitch.Global.equals(bayeuxChannel, fm.liveswitch.signalling.MetaChannels.getConnect()))) {
                            return fm.liveswitch.signalling.MessageType.Stream;
                        }
                        if ((fm.liveswitch.Global.equals(bayeuxChannel, fm.liveswitch.signalling.MetaChannels.getDisconnect()))) {
                            return fm.liveswitch.signalling.MessageType.Disconnect;
                        }
                        if ((fm.liveswitch.Global.equals(bayeuxChannel, fm.liveswitch.signalling.MetaChannels.getBind()))) {
                            return fm.liveswitch.signalling.MessageType.Bind;
                        }
                        if ((fm.liveswitch.Global.equals(bayeuxChannel, fm.liveswitch.signalling.MetaChannels.getUnbind()))) {
                            return fm.liveswitch.signalling.MessageType.Unbind;
                        }
                        if ((fm.liveswitch.Global.equals(bayeuxChannel, fm.liveswitch.signalling.MetaChannels.getSubscribe()))) {
                            return fm.liveswitch.signalling.MessageType.Subscribe;
                        }
                        if ((fm.liveswitch.Global.equals(bayeuxChannel, fm.liveswitch.signalling.MetaChannels.getUnsubscribe()))) {
                            return fm.liveswitch.signalling.MessageType.Unsubscribe;
                        }
                        if (fm.liveswitch.signalling.MetaChannels.isServiceChannel(bayeuxChannel)) {
                            return fm.liveswitch.signalling.MessageType.Service;
                        }
                        if (!fm.liveswitch.signalling.MetaChannels.isMetaChannel(bayeuxChannel)) {
                            return fm.liveswitch.signalling.MessageType.Publish;
                        }
                        return fm.liveswitch.signalling.MessageType.Unknown;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MetaChannels.getMetaPrefix = function () {
                    if (arguments.length == 0) {
                        return "/meta/";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MetaChannels.getServicePrefix = function () {
                    if (arguments.length == 0) {
                        return "/service/";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MetaChannels.getSubscribe = function () {
                    if (arguments.length == 0) {
                        return "/meta/subscribe";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MetaChannels.getUnbind = function () {
                    if (arguments.length == 0) {
                        return "/meta/unbind";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MetaChannels.getUnsubscribe = function () {
                    if (arguments.length == 0) {
                        return "/meta/unsubscribe";
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MetaChannels.isMetaChannel = function (channel) {
                    if (arguments.length == 1) {
                        return ((!fm.liveswitch.Global.equals(channel, null)) && fm.liveswitch.StringExtensions.startsWith(channel, fm.liveswitch.signalling.MetaChannels.getMetaPrefix(), fm.liveswitch.StringComparison.Ordinal));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MetaChannels.isReservedChannel = function (channel) {
                    if (arguments.length == 1) {
                        return (fm.liveswitch.signalling.MetaChannels.isMetaChannel(channel) || fm.liveswitch.signalling.MetaChannels.isServiceChannel(channel));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                MetaChannels.isServiceChannel = function (channel) {
                    if (arguments.length == 1) {
                        return ((!fm.liveswitch.Global.equals(channel, null)) && fm.liveswitch.StringExtensions.startsWith(channel, fm.liveswitch.signalling.MetaChannels.getServicePrefix(), fm.liveswitch.StringComparison.Ordinal));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return MetaChannels;
            }());
            signalling.MetaChannels = MetaChannels;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../Serializable.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var PresenceNotification = /** @class */ (function (_super) {
                __extends(PresenceNotification, _super);
                function PresenceNotification() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                PresenceNotification.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.PresenceNotification]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /** @hidden */
                PresenceNotification.deserializePresenceType = function (presenceTypeJson) {
                    if (arguments.length == 1) {
                        var _var0 = fm.liveswitch.JsonSerializer.deserializeString(presenceTypeJson);
                        if (_var0 == "subscribe") {
                            do {
                                return fm.liveswitch.signalling.PresenceType.Subscribe;
                            } while (false);
                        }
                        else if (_var0 == "unsubscribe") {
                            do {
                                return fm.liveswitch.signalling.PresenceType.Unsubscribe;
                            } while (false);
                        }
                        throw new fm.liveswitch.Exception("Unknown presence type.");
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PresenceNotification.fromJson = function (presenceNotificationJson) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.deserializeObjectFast(presenceNotificationJson, function () {
                            return new fm.liveswitch.signalling.PresenceNotification();
                        }, function (obj, name, valueJson) {
                            var str = name;
                            if ((!fm.liveswitch.Global.equals(str, null))) {
                                if (!(fm.liveswitch.Global.equals(str, "channel"))) {
                                    if ((fm.liveswitch.Global.equals(str, "remoteClient"))) {
                                        obj.setRemoteClient(fm.liveswitch.signalling.RemoteClient.fromJson(valueJson));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "type"))) {
                                            obj.setType(fm.liveswitch.signalling.PresenceNotification.deserializePresenceType(valueJson));
                                        }
                                    }
                                }
                                else {
                                    obj.setChannel(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                }
                            }
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                PresenceNotification.serializePresenceType = function (presenceType) {
                    if (arguments.length == 1) {
                        var str = void 0;
                        var _var0 = presenceType;
                        if (_var0 == fm.liveswitch.signalling.PresenceType.Subscribe) {
                            do {
                                str = "subscribe";
                                break;
                            } while (false);
                        }
                        else if (_var0 == fm.liveswitch.signalling.PresenceType.Unsubscribe) {
                            do {
                                str = "unsubscribe";
                                break;
                            } while (false);
                        }
                        else {
                            do {
                                throw new fm.liveswitch.Exception("Unknown presence type.");
                            } while (false);
                        }
                        return fm.liveswitch.JsonSerializer.serializeString(str);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PresenceNotification.toJson = function (presenceNotification) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.serializeObjectFast(presenceNotification, function (obj, jsonObject) {
                            if ((!fm.liveswitch.Global.equals(obj.getChannel(), null))) {
                                jsonObject["channel"] = fm.liveswitch.JsonSerializer.serializeString(obj.getChannel());
                            }
                            if ((!fm.liveswitch.Global.equals(obj.getRemoteClient(), null))) {
                                jsonObject["remoteClient"] = fm.liveswitch.signalling.RemoteClient.toJson(obj.getRemoteClient());
                            }
                            jsonObject["type"] = fm.liveswitch.signalling.PresenceNotification.serializePresenceType(obj.getType());
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PresenceNotification.prototype.getChannel = function () {
                    if (arguments.length == 0) {
                        return this.__channel;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PresenceNotification.prototype.getRemoteClient = function () {
                    if (arguments.length == 0) {
                        return this.__remoteClient;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PresenceNotification.prototype.getType = function () {
                    if (arguments.length == 0) {
                        return this.__type;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PresenceNotification.prototype.setChannel = function (value) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(value, null))) {
                            throw new fm.liveswitch.Exception("Channel cannot be null.");
                        }
                        this.__channel = value;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PresenceNotification.prototype.setRemoteClient = function (value) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(value, null))) {
                            throw new fm.liveswitch.Exception("Remote client cannot be null.");
                        }
                        this.__remoteClient = value;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PresenceNotification.prototype.setType = function (value) {
                    if (arguments.length == 1) {
                        this.__type = value;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PresenceNotification.prototype.toJson = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.PresenceNotification.toJson(this);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return PresenceNotification;
            }(fm.liveswitch.Serializable));
            signalling.PresenceNotification = PresenceNotification;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var PresenceTypeWrapper = /** @class */ (function () {
                function PresenceTypeWrapper(value) {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var value_71 = __arguments[0];
                        //super();
                        this._value = value_71;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                PresenceTypeWrapper.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.PresenceTypeWrapper]';
                };
                PresenceTypeWrapper.prototype.toString = function () {
                    if (arguments.length == 0) {
                        if (this._value == fm.liveswitch.signalling.PresenceType.Subscribe)
                            return 'Subscribe';
                        if (this._value == fm.liveswitch.signalling.PresenceType.Unsubscribe)
                            return 'Unsubscribe';
                        return '';
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return PresenceTypeWrapper;
            }());
            signalling.PresenceTypeWrapper = PresenceTypeWrapper;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/MessageBase.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var Publication = /** @class */ (function (_super) {
                __extends(Publication, _super);
                function Publication() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else if (__arguments.length == 1) {
                        var channel = __arguments[0];
                        _this = _super.call(this) || this;
                        _this.setChannel(channel);
                    }
                    else if (__arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isUint8Array(arguments[1]))) {
                        var channel = __arguments[0];
                        var dataBytes = __arguments[1];
                        // chained constructor: Publication.call(this, channel, dataBytes, null);
                        __arguments = new Array(3);
                        __arguments[0] = channel;
                        __arguments[1] = dataBytes;
                        __arguments[2] = null;
                        {
                            var channel_3 = __arguments[0];
                            var dataBytes_1 = __arguments[1];
                            var tag = __arguments[2];
                            _this = _super.call(this) || this;
                            _this.setChannel(channel_3);
                            _super.prototype.setDataBytes.call(_this, dataBytes_1);
                            _this.setTag(tag);
                        }
                    }
                    else if (__arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isUint8Array(arguments[1]))) {
                        var channel = __arguments[0];
                        var dataBytes = __arguments[1];
                        var tag = __arguments[2];
                        _this = _super.call(this) || this;
                        _this.setChannel(channel);
                        _super.prototype.setDataBytes.call(_this, dataBytes);
                        _this.setTag(tag);
                    }
                    else if (__arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                        var channel = __arguments[0];
                        var dataJson = __arguments[1];
                        // chained constructor: Publication.call(this, channel, dataJson, null);
                        __arguments = new Array(3);
                        __arguments[0] = channel;
                        __arguments[1] = dataJson;
                        __arguments[2] = null;
                        {
                            var channel_4 = __arguments[0];
                            var dataJson_1 = __arguments[1];
                            var tag = __arguments[2];
                            _this = _super.call(this) || this;
                            _this.setChannel(channel_4);
                            _super.prototype.setDataJson.call(_this, dataJson_1);
                            _this.setTag(tag);
                        }
                    }
                    else if (__arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                        var channel = __arguments[0];
                        var dataJson = __arguments[1];
                        var tag = __arguments[2];
                        _this = _super.call(this) || this;
                        _this.setChannel(channel);
                        _super.prototype.setDataJson.call(_this, dataJson);
                        _this.setTag(tag);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                Publication.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.Publication]' + ',' + _super.prototype.getTypeString.call(this);
                };
                Publication.fromJson = function (publicationJson) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.deserializeObjectFast(publicationJson, function () {
                            return new fm.liveswitch.signalling.Publication();
                        }, function (obj, name, valueJson) {
                            obj.setValidate(false);
                            var str = name;
                            if ((!fm.liveswitch.Global.equals(str, null))) {
                                if (!(fm.liveswitch.Global.equals(str, "channel"))) {
                                    if ((fm.liveswitch.Global.equals(str, "data"))) {
                                        obj.setDataJson(fm.liveswitch.JsonSerializer.deserializeRaw(valueJson));
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "ext"))) {
                                            obj.setExtensions(fm.liveswitch.signalling.Extensions.fromJson(valueJson));
                                        }
                                        else {
                                            if ((fm.liveswitch.Global.equals(str, "successful"))) {
                                                var nullable = fm.liveswitch.JsonSerializer.deserializeBoolean(valueJson);
                                                obj.setSuccessful((fm.liveswitch.Global.equals(nullable, true)));
                                            }
                                            else {
                                                if ((fm.liveswitch.Global.equals(str, "error"))) {
                                                    obj.setError(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                                }
                                                else {
                                                    if ((fm.liveswitch.Global.equals(str, "timestamp"))) {
                                                        obj.setTimestamp(fm.liveswitch.signalling.MessageBase.deserializeTimestamp(valueJson));
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    obj.setChannel(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                }
                            }
                            obj.setValidate(true);
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Publication.fromJsonArray = function (publicationsJson) {
                    if (arguments.length == 1) {
                        var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(publicationsJson, fm.liveswitch.signalling.Publication.fromJson.bind(fm.liveswitch.signalling.Publication));
                        if ((fm.liveswitch.Global.equals(list, null))) {
                            return null;
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Publication.fromMessage = function (message) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(message, null))) {
                            return null;
                        }
                        var publication = new fm.liveswitch.signalling.Publication();
                        publication.setChannel(message.getBayeuxChannel());
                        publication.setSuccessful(message.getSuccessful());
                        publication.setError(message.getError());
                        publication.setTimestamp(message.getTimestamp());
                        publication.setDataJson(message.getDataJson());
                        publication.setExtensions(message.getExtensions());
                        return publication;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Publication.fromMessages = function (messages) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(messages, null))) {
                            return null;
                        }
                        var publicationArray = new Array(messages.length);
                        for (var i = 0; (i < messages.length); i++) {
                            publicationArray[i] = fm.liveswitch.signalling.Publication.fromMessage(messages[i]);
                        }
                        return publicationArray;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Publication.toJson = function (publication) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.serializeObjectFast(publication, function (obj, jsonObject) {
                            if ((!fm.liveswitch.Global.equals(obj.getChannel(), null))) {
                                jsonObject["channel"] = fm.liveswitch.JsonSerializer.serializeString(obj.getChannel());
                            }
                            if ((!fm.liveswitch.Global.equals(obj.getError(), null))) {
                                jsonObject["error"] = fm.liveswitch.JsonSerializer.serializeString(obj.getError());
                            }
                            if (obj.getSuccessful()) {
                                jsonObject["successful"] = fm.liveswitch.JsonSerializer.serializeBoolean(obj.getSuccessful());
                            }
                            if ((obj.getTimestamp() != null)) {
                                jsonObject["timestamp"] = fm.liveswitch.signalling.MessageBase.serializeTimestamp(obj.getTimestamp());
                            }
                            if ((obj.getExtensions().getCount() > 0)) {
                                jsonObject["ext"] = fm.liveswitch.signalling.Extensions.toJson(obj.getExtensions());
                            }
                            if ((!fm.liveswitch.Global.equals(obj.getDataJson(), null))) {
                                jsonObject["data"] = fm.liveswitch.JsonSerializer.serializeRaw(obj.getDataJson());
                            }
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Publication.toJsonArray = function (publications) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.serializeObjectArray(publications, fm.liveswitch.signalling.Publication.toJson.bind(fm.liveswitch.signalling.Publication));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Publication.toMessage = function (publication) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(publication, null))) {
                            return null;
                        }
                        var message = new fm.liveswitch.signalling.Message();
                        message.setBayeuxChannel(publication.getChannel());
                        message.setSuccessful(publication.getSuccessful());
                        message.setError(publication.getError());
                        message.setTimestamp(publication.getTimestamp());
                        message.setDataJson(publication.getDataJson());
                        message.setExtensions(publication.getExtensions());
                        return message;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Publication.toMessages = function (publications) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(publications, null))) {
                            return null;
                        }
                        var messageArray = new Array(publications.length);
                        for (var i = 0; (i < publications.length); i++) {
                            messageArray[i] = fm.liveswitch.signalling.Publication.toMessage(publications[i]);
                        }
                        return messageArray;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Publication.prototype.getChannel = function () {
                    if (arguments.length == 0) {
                        return this.__channel;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Publication.prototype.getPresence = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.JsonSerializer.deserializeBoolean(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getPresenceExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Publication.prototype.getReturnData = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.JsonSerializer.deserializeBoolean(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getReturnDataExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Publication.prototype.getTag = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.JsonSerializer.deserializeString(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Publication.prototype.setChannel = function (value) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(value, null))) {
                            this.__channel = value;
                            _super.prototype.setIsDirty.call(this, true);
                        }
                        else {
                            var error = null;
                            var _var0 = new fm.liveswitch.Holder(error);
                            var _var1 = fm.liveswitch.signalling.Extensible.validateChannel(value, _var0);
                            error = _var0.getValue();
                            if (!(!_super.prototype.getValidate.call(this) || _var1)) {
                                throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Invalid channel. {0}", error));
                            }
                            this.__channel = value;
                            _super.prototype.setIsDirty.call(this, true);
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Publication.prototype.setPresence = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getPresenceExtensionName(), fm.liveswitch.JsonSerializer.serializeBoolean(value), false);
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Publication.prototype.setReturnData = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName(), fm.liveswitch.JsonSerializer.serializeBoolean(value), false);
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Publication.prototype.setTag = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName(), fm.liveswitch.JsonSerializer.serializeString(value), false);
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Publication.prototype.toJson = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Publication.toJson(this);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Publication;
            }(fm.liveswitch.signalling.MessageBase));
            signalling.Publication = Publication;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/InputArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var PublishArgs = /** @class */ (function (_super) {
                __extends(PublishArgs, _super);
                function PublishArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else if (__arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isUint8Array(arguments[1]))) {
                        var channel = __arguments[0];
                        var dataBytes = __arguments[1];
                        // chained constructor: PublishArgs.call(this, channel, dataBytes, null);
                        __arguments = new Array(3);
                        __arguments[0] = channel;
                        __arguments[1] = dataBytes;
                        __arguments[2] = null;
                        {
                            var channel_5 = __arguments[0];
                            var dataBytes_2 = __arguments[1];
                            var tag = __arguments[2];
                            _this = _super.call(this) || this;
                            _this.setChannel(channel_5);
                            _this.setDataBytes(dataBytes_2);
                            _this.setTag(tag);
                        }
                    }
                    else if (__arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isUint8Array(arguments[1]))) {
                        var channel = __arguments[0];
                        var dataBytes = __arguments[1];
                        var tag = __arguments[2];
                        _this = _super.call(this) || this;
                        _this.setChannel(channel);
                        _this.setDataBytes(dataBytes);
                        _this.setTag(tag);
                    }
                    else if (__arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                        var channel = __arguments[0];
                        var dataJson = __arguments[1];
                        // chained constructor: PublishArgs.call(this, channel, dataJson, null);
                        __arguments = new Array(3);
                        __arguments[0] = channel;
                        __arguments[1] = dataJson;
                        __arguments[2] = null;
                        {
                            var channel_6 = __arguments[0];
                            var dataJson_2 = __arguments[1];
                            var tag = __arguments[2];
                            _this = _super.call(this) || this;
                            _this.setChannel(channel_6);
                            _this.setDataJson(dataJson_2);
                            _this.setTag(tag);
                        }
                    }
                    else if (__arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                        var channel = __arguments[0];
                        var dataJson = __arguments[1];
                        var tag = __arguments[2];
                        _this = _super.call(this) || this;
                        _this.setChannel(channel);
                        _this.setDataJson(dataJson);
                        _this.setTag(tag);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                PublishArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.PublishArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                PublishArgs.prototype.getChannel = function () {
                    if (arguments.length == 0) {
                        return this.__channel;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishArgs.prototype.getDataBytes = function () {
                    if (arguments.length == 0) {
                        var decoded = this.__dataBytes;
                        var valueJson = this.__dataJson;
                        if ((!fm.liveswitch.Global.equals(decoded, null))) {
                            return decoded;
                        }
                        if ((!fm.liveswitch.Global.equals(valueJson, null))) {
                            var _var0 = new fm.liveswitch.Holder(decoded);
                            var _var1 = fm.liveswitch.Base64.tryDecode(fm.liveswitch.JsonSerializer.deserializeString(valueJson), _var0);
                            decoded = _var0.getValue();
                            if (!_var1) {
                                decoded = null;
                            }
                            this.__dataBytes = decoded;
                            return decoded;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishArgs.prototype.getDataJson = function () {
                    if (arguments.length == 0) {
                        var str = this.__dataJson;
                        var b = this.__dataBytes;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            return str;
                        }
                        if ((!fm.liveswitch.Global.equals(b, null))) {
                            str = fm.liveswitch.JsonSerializer.serializeString(fm.liveswitch.Base64.encode(b));
                            this.__dataJson = str;
                            return str;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishArgs.prototype.getIsBinary = function () {
                    if (arguments.length == 0) {
                        return (!fm.liveswitch.Global.equals(this.getDataBytes(), null));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishArgs.prototype.getOnFailure = function () {
                    if (arguments.length == 0) {
                        return this._onFailure;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishArgs.prototype.getOnSuccess = function () {
                    if (arguments.length == 0) {
                        return this._onSuccess;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishArgs.prototype.getReturnData = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.JsonSerializer.deserializeBoolean(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getReturnDataExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishArgs.prototype.getTag = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.JsonSerializer.deserializeString(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishArgs.prototype.setChannel = function (value) {
                    if (arguments.length == 1) {
                        var error = null;
                        var _var0 = new fm.liveswitch.Holder(error);
                        var _var1 = fm.liveswitch.signalling.Extensible.validateChannel(value, _var0);
                        error = _var0.getValue();
                        if (!_var1) {
                            throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Invalid channel. {0}", error));
                        }
                        this.__channel = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishArgs.prototype.setDataBytes = function (value) {
                    if (arguments.length == 1) {
                        this.__dataJson = null;
                        this.__dataBytes = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishArgs.prototype.setDataJson = function (value) {
                    if (arguments.length == 1) {
                        if (!((fm.liveswitch.Global.equals(value, null)) || fm.liveswitch.JsonSerializer.isValidJson(value))) {
                            throw new fm.liveswitch.Exception("The value is not valid JSON.");
                        }
                        this.__dataJson = value;
                        this.__dataBytes = null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishArgs.prototype.setOnFailure = function (value) {
                    if (arguments.length == 1) {
                        this._onFailure = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishArgs.prototype.setOnSuccess = function (value) {
                    if (arguments.length == 1) {
                        this._onSuccess = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishArgs.prototype.setReturnData = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getReturnDataExtensionName(), fm.liveswitch.JsonSerializer.serializeBoolean(value), false);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishArgs.prototype.setTag = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName(), fm.liveswitch.JsonSerializer.serializeString(value), false);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishArgs.prototype.getData = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.Json.deserialize(this.getDataJson.apply(this, arguments));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishArgs.prototype.setData = function (data) {
                    if (arguments.length == 1) {
                        arguments[arguments.length - 1] = fm.liveswitch.Json.serialize(arguments[arguments.length - 1]);
                        this.setDataJson.apply(this, arguments);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return PublishArgs;
            }(fm.liveswitch.signalling.InputArgs));
            signalling.PublishArgs = PublishArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/FailureArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var PublishFailureArgs = /** @class */ (function (_super) {
                __extends(PublishFailureArgs, _super);
                function PublishFailureArgs(channel, dataJson, dataBytes) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 3) {
                        var channel_7 = __arguments[0];
                        var dataJson_3 = __arguments[1];
                        var dataBytes_3 = __arguments[2];
                        _this = _super.call(this) || this;
                        _this.__channel = channel_7;
                        _this.__dataJson = dataJson_3;
                        _this.__dataBytes = dataBytes_3;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                PublishFailureArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.PublishFailureArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                PublishFailureArgs.prototype.getChannel = function () {
                    if (arguments.length == 0) {
                        return this.__channel;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishFailureArgs.prototype.getDataBytes = function () {
                    if (arguments.length == 0) {
                        var decoded = this.__dataBytes;
                        var valueJson = this.__dataJson;
                        if ((!fm.liveswitch.Global.equals(decoded, null))) {
                            return decoded;
                        }
                        if ((!fm.liveswitch.Global.equals(valueJson, null))) {
                            var _var0 = new fm.liveswitch.Holder(decoded);
                            var _var1 = fm.liveswitch.Base64.tryDecode(fm.liveswitch.JsonSerializer.deserializeString(valueJson), _var0);
                            decoded = _var0.getValue();
                            if (!_var1) {
                                decoded = null;
                            }
                            this.__dataBytes = decoded;
                            return decoded;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishFailureArgs.prototype.getDataJson = function () {
                    if (arguments.length == 0) {
                        var str = this.__dataJson;
                        var b = this.__dataBytes;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            return str;
                        }
                        if ((!fm.liveswitch.Global.equals(b, null))) {
                            str = fm.liveswitch.JsonSerializer.serializeString(fm.liveswitch.Base64.encode(b));
                            this.__dataJson = str;
                            return str;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishFailureArgs.prototype.getIsBinary = function () {
                    if (arguments.length == 0) {
                        return (!fm.liveswitch.Global.equals(this.getDataBytes(), null));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishFailureArgs.prototype.getTag = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.JsonSerializer.deserializeString(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishFailureArgs.prototype.getData = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.Json.deserialize(this.getDataJson.apply(this, arguments));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return PublishFailureArgs;
            }(fm.liveswitch.signalling.FailureArgs));
            signalling.PublishFailureArgs = PublishFailureArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/SuccessArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var PublishSuccessArgs = /** @class */ (function (_super) {
                __extends(PublishSuccessArgs, _super);
                function PublishSuccessArgs(channel, dataJson, dataBytes) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 3) {
                        var channel_8 = __arguments[0];
                        var dataJson_4 = __arguments[1];
                        var dataBytes_4 = __arguments[2];
                        _this = _super.call(this) || this;
                        _this.__channel = channel_8;
                        _this.__dataJson = dataJson_4;
                        _this.__dataBytes = dataBytes_4;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                PublishSuccessArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.PublishSuccessArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                PublishSuccessArgs.prototype.getChannel = function () {
                    if (arguments.length == 0) {
                        return this.__channel;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishSuccessArgs.prototype.getDataBytes = function () {
                    if (arguments.length == 0) {
                        var decoded = this.__dataBytes;
                        var valueJson = this.__dataJson;
                        if ((!fm.liveswitch.Global.equals(decoded, null))) {
                            return decoded;
                        }
                        if ((!fm.liveswitch.Global.equals(valueJson, null))) {
                            var _var0 = new fm.liveswitch.Holder(decoded);
                            var _var1 = fm.liveswitch.Base64.tryDecode(fm.liveswitch.JsonSerializer.deserializeString(valueJson), _var0);
                            decoded = _var0.getValue();
                            if (!_var1) {
                                decoded = null;
                            }
                            this.__dataBytes = decoded;
                            return decoded;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishSuccessArgs.prototype.getDataJson = function () {
                    if (arguments.length == 0) {
                        var str = this.__dataJson;
                        var b = this.__dataBytes;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            return str;
                        }
                        if ((!fm.liveswitch.Global.equals(b, null))) {
                            str = fm.liveswitch.JsonSerializer.serializeString(fm.liveswitch.Base64.encode(b));
                            this.__dataJson = str;
                            return str;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishSuccessArgs.prototype.getIsBinary = function () {
                    if (arguments.length == 0) {
                        return (!fm.liveswitch.Global.equals(this.getDataBytes(), null));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishSuccessArgs.prototype.getTag = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.JsonSerializer.deserializeString(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                PublishSuccessArgs.prototype.getData = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.Json.deserialize(this.getDataJson.apply(this, arguments));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return PublishSuccessArgs;
            }(fm.liveswitch.signalling.SuccessArgs));
            signalling.PublishSuccessArgs = PublishSuccessArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/SuccessArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ReceiveArgs = /** @class */ (function (_super) {
                __extends(ReceiveArgs, _super);
                function ReceiveArgs(dataJson, dataBytes, connectionType, reconnectAfter) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 4) {
                        var dataJson_5 = __arguments[0];
                        var dataBytes_5 = __arguments[1];
                        var connectionType_2 = __arguments[2];
                        var reconnectAfter_1 = __arguments[3];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingReceiveArgsInit();
                        _this.__dataJson = dataJson_5;
                        _this.__dataBytes = dataBytes_5;
                        _this.__connectionType = connectionType_2;
                        _this.setReconnectAfter(reconnectAfter_1);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ReceiveArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ReceiveArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                ReceiveArgs.prototype.fmliveswitchsignallingReceiveArgsInit = function () {
                    this._reconnectAfter = 0;
                };
                ReceiveArgs.prototype.getConnectionType = function () {
                    if (arguments.length == 0) {
                        return this.__connectionType;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ReceiveArgs.prototype.getDataBytes = function () {
                    if (arguments.length == 0) {
                        var decoded = this.__dataBytes;
                        var valueJson = this.__dataJson;
                        if ((!fm.liveswitch.Global.equals(decoded, null))) {
                            return decoded;
                        }
                        if ((!fm.liveswitch.Global.equals(valueJson, null))) {
                            var _var0 = new fm.liveswitch.Holder(decoded);
                            var _var1 = fm.liveswitch.Base64.tryDecode(fm.liveswitch.JsonSerializer.deserializeString(valueJson), _var0);
                            decoded = _var0.getValue();
                            if (!_var1) {
                                decoded = null;
                            }
                            this.__dataBytes = decoded;
                            return decoded;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ReceiveArgs.prototype.getDataJson = function () {
                    if (arguments.length == 0) {
                        var str = this.__dataJson;
                        var b = this.__dataBytes;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            return str;
                        }
                        if ((!fm.liveswitch.Global.equals(b, null))) {
                            str = fm.liveswitch.JsonSerializer.serializeString(fm.liveswitch.Base64.encode(b));
                            this.__dataJson = str;
                            return str;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ReceiveArgs.prototype.getIsBinary = function () {
                    if (arguments.length == 0) {
                        return (!fm.liveswitch.Global.equals(this.getDataBytes(), null));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ReceiveArgs.prototype.getReconnectAfter = function () {
                    if (arguments.length == 0) {
                        return this._reconnectAfter;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ReceiveArgs.prototype.getTag = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.JsonSerializer.deserializeString(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ReceiveArgs.prototype.setReconnectAfter = function (value) {
                    if (arguments.length == 1) {
                        this._reconnectAfter = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ReceiveArgs.prototype.getData = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.Json.deserialize(this.getDataJson.apply(this, arguments));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ReceiveArgs;
            }(fm.liveswitch.signalling.SuccessArgs));
            signalling.ReceiveArgs = ReceiveArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ReconnectWrapper = /** @class */ (function () {
                function ReconnectWrapper(value) {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var value_72 = __arguments[0];
                        //super();
                        this._value = value_72;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                ReconnectWrapper.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ReconnectWrapper]';
                };
                ReconnectWrapper.prototype.toString = function () {
                    if (arguments.length == 0) {
                        if (this._value == fm.liveswitch.signalling.Reconnect.Retry)
                            return 'Retry';
                        if (this._value == fm.liveswitch.signalling.Reconnect.Handshake)
                            return 'Handshake';
                        if (this._value == fm.liveswitch.signalling.Reconnect.None)
                            return 'None';
                        if (this._value == fm.liveswitch.signalling.Reconnect.NotSet)
                            return 'NotSet';
                        return '';
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ReconnectWrapper;
            }());
            signalling.ReconnectWrapper = ReconnectWrapper;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var Record = /** @class */ (function (_super) {
                __extends(Record, _super);
                function Record() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingRecordInit();
                        _this.setValidate(true);
                    }
                    else if (__arguments.length == 1) {
                        var key = __arguments[0];
                        // chained constructor: Record.call(this, key, null);
                        __arguments = new Array(2);
                        __arguments[0] = key;
                        __arguments[1] = null;
                        {
                            var key_2 = __arguments[0];
                            var valueJson = __arguments[1];
                            // chained constructor: Record.call(this);
                            __arguments = new Array(0);
                            {
                                _this = _super.call(this) || this;
                                _this.fmliveswitchsignallingRecordInit();
                                _this.setValidate(true);
                            }
                            _this.setKey(key_2);
                            _this.setValueJson(valueJson);
                        }
                    }
                    else if (__arguments.length == 2) {
                        var key = __arguments[0];
                        var valueJson = __arguments[1];
                        // chained constructor: Record.call(this);
                        __arguments = new Array(0);
                        {
                            _this = _super.call(this) || this;
                            _this.fmliveswitchsignallingRecordInit();
                            _this.setValidate(true);
                        }
                        _this.setKey(key);
                        _this.setValueJson(valueJson);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                Record.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.Record]' + ',' + _super.prototype.getTypeString.call(this);
                };
                Record.prototype.fmliveswitchsignallingRecordInit = function () {
                    this._validate = false;
                };
                Record.fromJson = function (recordJson) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.deserializeObjectFast(recordJson, function () {
                            return new fm.liveswitch.signalling.Record("key");
                        }, function (obj, name, valueJson) {
                            obj.setValidate(false);
                            var str = name;
                            if ((!fm.liveswitch.Global.equals(str, null))) {
                                if (!(fm.liveswitch.Global.equals(str, "key"))) {
                                    if ((fm.liveswitch.Global.equals(str, "value"))) {
                                        obj.setValueJson(fm.liveswitch.JsonSerializer.deserializeRaw(valueJson));
                                    }
                                }
                                else {
                                    obj.setKey(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                }
                            }
                            obj.setValidate(true);
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Record.fromJsonArray = function (recordsJson) {
                    if (arguments.length == 1) {
                        var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(recordsJson, fm.liveswitch.signalling.Record.fromJson.bind(fm.liveswitch.signalling.Record));
                        if ((fm.liveswitch.Global.equals(list, null))) {
                            return null;
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Record.toJson = function (record) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.serializeObjectFast(record, function (obj, jsonObject) {
                            if ((!fm.liveswitch.Global.equals(obj.getKey(), null))) {
                                jsonObject["key"] = fm.liveswitch.JsonSerializer.serializeString(obj.getKey());
                            }
                            if ((!fm.liveswitch.Global.equals(obj.getValueJson(), null))) {
                                jsonObject["value"] = fm.liveswitch.JsonSerializer.serializeRaw(obj.getValueJson());
                            }
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Record.toJsonArray = function (records) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.serializeObjectArray(records, fm.liveswitch.signalling.Record.toJson.bind(fm.liveswitch.signalling.Record));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Record.prototype.duplicate = function () {
                    if (arguments.length == 0) {
                        var record = new fm.liveswitch.signalling.Record(this.getKey());
                        record.setValidate(false);
                        record.setValueJson(this.getValueJson());
                        record.setValidate(true);
                        return record;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Record.prototype.getKey = function () {
                    if (arguments.length == 0) {
                        return this.__key;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Record.prototype.getValidate = function () {
                    if (arguments.length == 0) {
                        return this._validate;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Record.prototype.getValueJson = function () {
                    if (arguments.length == 0) {
                        return this.__valueJson;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Record.prototype.setKey = function (value) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(value, null))) {
                            throw new fm.liveswitch.Exception("key cannot be null.");
                        }
                        this.__key = value;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Record.prototype.setValidate = function (value) {
                    if (arguments.length == 1) {
                        this._validate = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Record.prototype.setValueJson = function (value) {
                    if (arguments.length == 1) {
                        if (!((!this.getValidate() || (fm.liveswitch.Global.equals(value, null))) || fm.liveswitch.JsonSerializer.isValidJson(value))) {
                            throw new fm.liveswitch.Exception("value is not valid JSON.");
                        }
                        this.__valueJson = value;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Record.prototype.toJson = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Record.toJson(this);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Record.prototype.toString = function () {
                    if (arguments.length == 0) {
                        return this.toJson();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Record.prototype.getValue = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.Json.deserialize(this.getValueJson.apply(this, arguments));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Record.prototype.setValue = function (value) {
                    if (arguments.length == 1) {
                        arguments[arguments.length - 1] = fm.liveswitch.Json.serialize(arguments[arguments.length - 1]);
                        this.setValueJson.apply(this, arguments);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Record;
            }(fm.liveswitch.Dynamic));
            signalling.Record = Record;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var Records = /** @class */ (function () {
                function Records() {
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        //super();
                        this._hash = {};
                    }
                    else if (__arguments.length == 1) {
                        var records = __arguments[0];
                        //super();
                        this._hash = {};
                        for (var _i = 0, records_4 = records; _i < records_4.length; _i++) {
                            var record = records_4[_i];
                            this._hash[record.getKey()] = record;
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                Records.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.Records]';
                };
                Records.fromJson = function (recordsJson) {
                    if (arguments.length == 1) {
                        return new fm.liveswitch.signalling.Records(fm.liveswitch.signalling.Record.fromJsonArray(recordsJson));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Records.toJson = function (records) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.signalling.Record.toJsonArray(records.getRecords());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Records.prototype.add = function (record) {
                    if (arguments.length == 1) {
                        this._hash[record.getKey()] = record;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Records.prototype.clear = function () {
                    if (arguments.length == 0) {
                        fm.liveswitch.HashExtensions.clear(this._hash);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Records.prototype.clone = function () {
                    if (arguments.length == 0) {
                        var records = new fm.liveswitch.signalling.Records();
                        for (var _i = 0, _a = fm.liveswitch.HashExtensions.getValues(this._hash); _i < _a.length; _i++) {
                            var record = _a[_i];
                            records.add(record.duplicate());
                        }
                        return records;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Records.prototype.containsKey = function (key) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.HashExtensions.containsKey(this._hash, key);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Records.prototype.getCount = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.HashExtensions.getCount(this._hash);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Records.prototype.getKeys = function () {
                    if (arguments.length == 0) {
                        var list = new Array();
                        for (var _i = 0, _a = fm.liveswitch.HashExtensions.getKeys(this._hash); _i < _a.length; _i++) {
                            var str = _a[_i];
                            fm.liveswitch.ArrayExtensions.add(list, str);
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Records.prototype.getRecord = function (key) {
                    if (arguments.length == 1) {
                        var record = null;
                        var _var0 = new fm.liveswitch.Holder(record);
                        var _var1 = fm.liveswitch.HashExtensions.tryGetValue(this._hash, key, _var0);
                        record = _var0.getValue();
                        if (!_var1) {
                            record = null;
                        }
                        return record;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Records.prototype.getRecords = function () {
                    if (arguments.length == 0) {
                        var list = new Array();
                        for (var _i = 0, _a = fm.liveswitch.HashExtensions.getValues(this._hash); _i < _a.length; _i++) {
                            var record = _a[_i];
                            fm.liveswitch.ArrayExtensions.add(list, record);
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Records.prototype.getValueJson = function (key) {
                    if (arguments.length == 1) {
                        var record = this.getRecord(key);
                        if ((fm.liveswitch.Global.equals(record, null))) {
                            return null;
                        }
                        return record.getValueJson();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Records.prototype.remove = function (key) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.HashExtensions.remove(this._hash, key);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Records.prototype.toJson = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Records.toJson(this);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Records.prototype.getValue = function (key) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.Json.deserialize(this.getValueJson.apply(this, arguments));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Records;
            }());
            signalling.Records = Records;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../Serializable.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var RemoteClient = /** @class */ (function (_super) {
                __extends(RemoteClient, _super);
                function RemoteClient() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        // chained constructor: RemoteClient.call(this, null, null, null, null, new fm.liveswitch.signalling.Records());
                        __arguments = new Array(5);
                        __arguments[0] = null;
                        __arguments[1] = null;
                        __arguments[2] = null;
                        __arguments[3] = null;
                        __arguments[4] = new fm.liveswitch.signalling.Records();
                        {
                            var clientId = __arguments[0];
                            var streamId = __arguments[1];
                            var userId = __arguments[2];
                            var deviceId = __arguments[3];
                            var boundRecords = __arguments[4];
                            _this = _super.call(this) || this;
                            _this.__clientId = clientId;
                            _this.__streamId = streamId;
                            _this.__userId = userId;
                            _this.__deviceId = deviceId;
                            _this.__boundRecords = boundRecords;
                        }
                    }
                    else if (__arguments.length == 5) {
                        var clientId = __arguments[0];
                        var streamId = __arguments[1];
                        var userId = __arguments[2];
                        var deviceId = __arguments[3];
                        var boundRecords = __arguments[4];
                        _this = _super.call(this) || this;
                        _this.__clientId = clientId;
                        _this.__streamId = streamId;
                        _this.__userId = userId;
                        _this.__deviceId = deviceId;
                        _this.__boundRecords = boundRecords;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                RemoteClient.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.RemoteClient]' + ',' + _super.prototype.getTypeString.call(this);
                };
                /** @hidden */
                RemoteClient.createRemoteClient = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.signalling.RemoteClient();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                RemoteClient.deserializeRemoteClient = function (remoteClientJson) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.deserializeObjectFast(remoteClientJson, fm.liveswitch.signalling.RemoteClient.createRemoteClient.bind(fm.liveswitch.signalling.RemoteClient), fm.liveswitch.signalling.RemoteClient.deserializeRemoteClientCallback.bind(fm.liveswitch.signalling.RemoteClient));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                RemoteClient.deserializeRemoteClientArray = function (remoteClientsJson) {
                    if (arguments.length == 1) {
                        var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(remoteClientsJson, fm.liveswitch.signalling.RemoteClient.fromJson.bind(fm.liveswitch.signalling.RemoteClient));
                        if ((fm.liveswitch.Global.equals(list, null))) {
                            return null;
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                RemoteClient.deserializeRemoteClientCallback = function (remoteClient, name, valueJson) {
                    if (arguments.length == 3) {
                        var str = name;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            if (!(fm.liveswitch.Global.equals(str, "clientId"))) {
                                if ((fm.liveswitch.Global.equals(str, "streamId"))) {
                                    remoteClient.__streamId = fm.liveswitch.JsonSerializer.deserializeString(valueJson);
                                }
                                else {
                                    if ((fm.liveswitch.Global.equals(str, "userId"))) {
                                        remoteClient.__userId = fm.liveswitch.JsonSerializer.deserializeString(valueJson);
                                    }
                                    else {
                                        if ((fm.liveswitch.Global.equals(str, "deviceId"))) {
                                            remoteClient.__deviceId = fm.liveswitch.JsonSerializer.deserializeString(valueJson);
                                        }
                                        else {
                                            if ((fm.liveswitch.Global.equals(str, "boundRecords"))) {
                                                remoteClient.__boundRecords = fm.liveswitch.signalling.Records.fromJson(valueJson);
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                remoteClient.__clientId = fm.liveswitch.JsonSerializer.deserializeString(valueJson);
                            }
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                RemoteClient.fromJson = function (remoteClientJson) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.signalling.RemoteClient.deserializeRemoteClient(remoteClientJson);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                RemoteClient.fromJsonArray = function (remoteClientsJson) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.signalling.RemoteClient.deserializeRemoteClientArray(remoteClientsJson);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                RemoteClient.serializeRemoteClient = function (remoteClient) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.serializeObjectFast(remoteClient, fm.liveswitch.signalling.RemoteClient.serializeRemoteClientCallback.bind(fm.liveswitch.signalling.RemoteClient));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                RemoteClient.serializeRemoteClientArray = function (remoteClients) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.serializeObjectArray(remoteClients, fm.liveswitch.signalling.RemoteClient.toJson.bind(fm.liveswitch.signalling.RemoteClient));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                RemoteClient.serializeRemoteClientCallback = function (remoteClient, jsonObject) {
                    if (arguments.length == 2) {
                        if ((!fm.liveswitch.Global.equals(remoteClient.getClientId(), null))) {
                            jsonObject["clientId"] = fm.liveswitch.JsonSerializer.serializeString(remoteClient.getClientId());
                        }
                        if ((!fm.liveswitch.Global.equals(remoteClient.getStreamId(), null))) {
                            jsonObject["streamId"] = fm.liveswitch.JsonSerializer.serializeString(remoteClient.getStreamId());
                        }
                        if ((!fm.liveswitch.Global.equals(remoteClient.getUserId(), null))) {
                            jsonObject["userId"] = fm.liveswitch.JsonSerializer.serializeString(remoteClient.getUserId());
                        }
                        if ((!fm.liveswitch.Global.equals(remoteClient.getDeviceId(), null))) {
                            jsonObject["deviceId"] = fm.liveswitch.JsonSerializer.serializeString(remoteClient.getDeviceId());
                        }
                        if ((!fm.liveswitch.Global.equals(remoteClient.getBoundRecords(), null))) {
                            jsonObject["boundRecords"] = fm.liveswitch.signalling.Records.toJson(remoteClient.getBoundRecords());
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                RemoteClient.toJson = function (remoteClient) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.signalling.RemoteClient.serializeRemoteClient(remoteClient);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                RemoteClient.toJsonArray = function (remoteClients) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.signalling.RemoteClient.serializeRemoteClientArray(remoteClients);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                RemoteClient.prototype.getBoundRecords = function () {
                    if (arguments.length == 0) {
                        return this.__boundRecords;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                RemoteClient.prototype.getBoundValueJson = function (key) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(this.getBoundRecords(), null))) {
                            return null;
                        }
                        return this.getBoundRecords().getValueJson(key);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                RemoteClient.prototype.getClientId = function () {
                    if (arguments.length == 0) {
                        return this.__clientId;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                RemoteClient.prototype.getDeviceId = function () {
                    if (arguments.length == 0) {
                        return this.__deviceId;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                RemoteClient.prototype.getStreamId = function () {
                    if (arguments.length == 0) {
                        return this.__streamId;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                RemoteClient.prototype.getUserId = function () {
                    if (arguments.length == 0) {
                        return this.__userId;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                RemoteClient.prototype.toJson = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.RemoteClient.toJson(this);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                RemoteClient.prototype.getBoundValue = function (key) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.Json.deserialize(this.getBoundValueJson.apply(this, arguments));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return RemoteClient;
            }(fm.liveswitch.Serializable));
            signalling.RemoteClient = RemoteClient;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var Reserved = /** @class */ (function () {
                function Reserved() {
                    fm.liveswitch.signalling.Reserved.fmliveswitchsignallingReservedInitialize();
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        //super();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                }
                Reserved.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.Reserved]';
                };
                Reserved.getClientChannel = function (clientId) {
                    fm.liveswitch.signalling.Reserved.fmliveswitchsignallingReservedInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.StringExtensions.format("{0}/{1}", fm.liveswitch.signalling.Reserved.getClientChannelPrefix(), clientId);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Reserved.getClientChannelPrefix = function () {
                    fm.liveswitch.signalling.Reserved.fmliveswitchsignallingReservedInitialize();
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Reserved.fm_liveswitch_signalling_Reserved___clientChannelPrefix;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Reserved.getDeviceChannel = function (deviceId) {
                    fm.liveswitch.signalling.Reserved.fmliveswitchsignallingReservedInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.StringExtensions.format("{0}/{1}", fm.liveswitch.signalling.Reserved.getDeviceChannelPrefix(), deviceId);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Reserved.getDeviceChannelPrefix = function () {
                    fm.liveswitch.signalling.Reserved.fmliveswitchsignallingReservedInitialize();
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Reserved.fm_liveswitch_signalling_Reserved___deviceChannelPrefix;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Reserved.getUserChannel = function (userId) {
                    fm.liveswitch.signalling.Reserved.fmliveswitchsignallingReservedInitialize();
                    if (arguments.length == 1) {
                        return fm.liveswitch.StringExtensions.format("{0}/{1}", fm.liveswitch.signalling.Reserved.getUserChannelPrefix(), userId);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Reserved.getUserChannelPrefix = function () {
                    fm.liveswitch.signalling.Reserved.fmliveswitchsignallingReservedInitialize();
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Reserved.fm_liveswitch_signalling_Reserved___userChannelPrefix;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                /** @hidden */
                Reserved.fmliveswitchsignallingReservedInitialize = function () {
                    if (!fm.liveswitch.signalling.Reserved.__fmliveswitchsignallingReservedInitialized && !fm.liveswitch.signalling.Reserved.__fmliveswitchsignallingReservedInitializing) {
                        fm.liveswitch.signalling.Reserved.__fmliveswitchsignallingReservedInitializing = true;
                        fm.liveswitch.signalling.Reserved.fm_liveswitch_signalling_Reserved___clientChannelPrefix = "/fm/client";
                        fm.liveswitch.signalling.Reserved.fm_liveswitch_signalling_Reserved___deviceChannelPrefix = "/fm/device";
                        fm.liveswitch.signalling.Reserved.fm_liveswitch_signalling_Reserved___userChannelPrefix = "/fm/user";
                        fm.liveswitch.signalling.Reserved.__fmliveswitchsignallingReservedInitialized = true;
                        fm.liveswitch.signalling.Reserved.__fmliveswitchsignallingReservedInitializing = false;
                    }
                };
                /** @hidden */
                Reserved.__fmliveswitchsignallingReservedInitialized = false;
                /** @hidden */
                Reserved.__fmliveswitchsignallingReservedInitializing = false;
                return Reserved;
            }());
            signalling.Reserved = Reserved;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/OutputArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ServerArgs = /** @class */ (function (_super) {
                __extends(ServerArgs, _super);
                function ServerArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ServerArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ServerArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                return ServerArgs;
            }(fm.liveswitch.signalling.OutputArgs));
            signalling.ServerArgs = ServerArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ServerArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ServerBindArgs = /** @class */ (function (_super) {
                __extends(ServerBindArgs, _super);
                function ServerBindArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ServerBindArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ServerBindArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                ServerBindArgs.prototype.getRecord = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetRecord(this.__records);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServerBindArgs.prototype.getRecords = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetRecords(this.__records);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ServerBindArgs;
            }(fm.liveswitch.signalling.ServerArgs));
            signalling.ServerBindArgs = ServerBindArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/SuccessArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ServerSubscribeArgs = /** @class */ (function (_super) {
                __extends(ServerSubscribeArgs, _super);
                function ServerSubscribeArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ServerSubscribeArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ServerSubscribeArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                ServerSubscribeArgs.prototype.getChannel = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetChannel(this.__channels);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServerSubscribeArgs.prototype.getChannels = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetChannels(this.__channels);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServerSubscribeArgs.prototype.getOnPresence = function () {
                    if (arguments.length == 0) {
                        return this._onPresence;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServerSubscribeArgs.prototype.getOnReceive = function () {
                    if (arguments.length == 0) {
                        return this._onReceive;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServerSubscribeArgs.prototype.getTag = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.StringExtensions.nullCoalesce(fm.liveswitch.JsonSerializer.deserializeString(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName())), fm.liveswitch.StringExtensions.empty);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServerSubscribeArgs.prototype.setOnPresence = function (value) {
                    if (arguments.length == 1) {
                        this._onPresence = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServerSubscribeArgs.prototype.setOnReceive = function (value) {
                    if (arguments.length == 1) {
                        this._onReceive = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ServerSubscribeArgs;
            }(fm.liveswitch.signalling.SuccessArgs));
            signalling.ServerSubscribeArgs = ServerSubscribeArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/SuccessArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ServerUnbindArgs = /** @class */ (function (_super) {
                __extends(ServerUnbindArgs, _super);
                function ServerUnbindArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ServerUnbindArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ServerUnbindArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                ServerUnbindArgs.prototype.getKey = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetKey(this.__keys);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServerUnbindArgs.prototype.getKeys = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetKeys(this.__keys);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ServerUnbindArgs;
            }(fm.liveswitch.signalling.SuccessArgs));
            signalling.ServerUnbindArgs = ServerUnbindArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/SuccessArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ServerUnsubscribeArgs = /** @class */ (function (_super) {
                __extends(ServerUnsubscribeArgs, _super);
                function ServerUnsubscribeArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ServerUnsubscribeArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ServerUnsubscribeArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                ServerUnsubscribeArgs.prototype.getChannel = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetChannel(this.__channels);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServerUnsubscribeArgs.prototype.getChannels = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetChannels(this.__channels);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServerUnsubscribeArgs.prototype.getTag = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.StringExtensions.nullCoalesce(fm.liveswitch.JsonSerializer.deserializeString(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName())), fm.liveswitch.StringExtensions.empty);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ServerUnsubscribeArgs;
            }(fm.liveswitch.signalling.SuccessArgs));
            signalling.ServerUnsubscribeArgs = ServerUnsubscribeArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/InputArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ServiceArgs = /** @class */ (function (_super) {
                __extends(ServiceArgs, _super);
                function ServiceArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else if (__arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isUint8Array(arguments[1]))) {
                        var channel = __arguments[0];
                        var dataBytes = __arguments[1];
                        // chained constructor: ServiceArgs.call(this, channel, dataBytes, null);
                        __arguments = new Array(3);
                        __arguments[0] = channel;
                        __arguments[1] = dataBytes;
                        __arguments[2] = null;
                        {
                            var channel_9 = __arguments[0];
                            var dataBytes_6 = __arguments[1];
                            var tag = __arguments[2];
                            _this = _super.call(this) || this;
                            _this.setChannel(channel_9);
                            _this.setDataBytes(dataBytes_6);
                            _this.setTag(tag);
                        }
                    }
                    else if (__arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isUint8Array(arguments[1]))) {
                        var channel = __arguments[0];
                        var dataBytes = __arguments[1];
                        var tag = __arguments[2];
                        _this = _super.call(this) || this;
                        _this.setChannel(channel);
                        _this.setDataBytes(dataBytes);
                        _this.setTag(tag);
                    }
                    else if (__arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                        var channel = __arguments[0];
                        var dataJson = __arguments[1];
                        // chained constructor: ServiceArgs.call(this, channel, dataJson, null);
                        __arguments = new Array(3);
                        __arguments[0] = channel;
                        __arguments[1] = dataJson;
                        __arguments[2] = null;
                        {
                            var channel_10 = __arguments[0];
                            var dataJson_6 = __arguments[1];
                            var tag = __arguments[2];
                            _this = _super.call(this) || this;
                            _this.setChannel(channel_10);
                            _this.setDataJson(dataJson_6);
                            _this.setTag(tag);
                        }
                    }
                    else if (__arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                        var channel = __arguments[0];
                        var dataJson = __arguments[1];
                        var tag = __arguments[2];
                        _this = _super.call(this) || this;
                        _this.setChannel(channel);
                        _this.setDataJson(dataJson);
                        _this.setTag(tag);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ServiceArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ServiceArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                ServiceArgs.prototype.getChannel = function () {
                    if (arguments.length == 0) {
                        return this.__channel;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceArgs.prototype.getDataBytes = function () {
                    if (arguments.length == 0) {
                        var decoded = this.__dataBytes;
                        var valueJson = this.__dataJson;
                        if ((!fm.liveswitch.Global.equals(decoded, null))) {
                            return decoded;
                        }
                        if ((!fm.liveswitch.Global.equals(valueJson, null))) {
                            var _var0 = new fm.liveswitch.Holder(decoded);
                            var _var1 = fm.liveswitch.Base64.tryDecode(fm.liveswitch.JsonSerializer.deserializeString(valueJson), _var0);
                            decoded = _var0.getValue();
                            if (!_var1) {
                                decoded = null;
                            }
                            this.__dataBytes = decoded;
                            return decoded;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceArgs.prototype.getDataJson = function () {
                    if (arguments.length == 0) {
                        var str = this.__dataJson;
                        var b = this.__dataBytes;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            return str;
                        }
                        if ((!fm.liveswitch.Global.equals(b, null))) {
                            str = fm.liveswitch.JsonSerializer.serializeString(fm.liveswitch.Base64.encode(b));
                            this.__dataJson = str;
                            return str;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceArgs.prototype.getIsBinary = function () {
                    if (arguments.length == 0) {
                        return (!fm.liveswitch.Global.equals(this.getDataBytes(), null));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceArgs.prototype.getOnFailure = function () {
                    if (arguments.length == 0) {
                        return this._onFailure;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceArgs.prototype.getOnSuccess = function () {
                    if (arguments.length == 0) {
                        return this._onSuccess;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceArgs.prototype.getReturnData = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.JsonSerializer.deserializeBoolean(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getReturnDataExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceArgs.prototype.getTag = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.JsonSerializer.deserializeString(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceArgs.prototype.setChannel = function (value) {
                    if (arguments.length == 1) {
                        var error = null;
                        var _var0 = new fm.liveswitch.Holder(error);
                        var _var1 = fm.liveswitch.signalling.Extensible.validateChannel(value, _var0);
                        error = _var0.getValue();
                        if (!_var1) {
                            throw new fm.liveswitch.Exception(fm.liveswitch.StringExtensions.format("Invalid channel. {0}", error));
                        }
                        this.__channel = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceArgs.prototype.setDataBytes = function (value) {
                    if (arguments.length == 1) {
                        this.__dataJson = null;
                        this.__dataBytes = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceArgs.prototype.setDataJson = function (value) {
                    if (arguments.length == 1) {
                        if (!((fm.liveswitch.Global.equals(value, null)) || fm.liveswitch.JsonSerializer.isValidJson(value))) {
                            throw new fm.liveswitch.Exception("The value is not valid JSON.");
                        }
                        this.__dataJson = value;
                        this.__dataBytes = null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceArgs.prototype.setOnFailure = function (value) {
                    if (arguments.length == 1) {
                        this._onFailure = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceArgs.prototype.setOnSuccess = function (value) {
                    if (arguments.length == 1) {
                        this._onSuccess = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceArgs.prototype.setReturnData = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getReturnDataExtensionName(), fm.liveswitch.JsonSerializer.serializeBoolean(value), false);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceArgs.prototype.setTag = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName(), fm.liveswitch.JsonSerializer.serializeString(value), false);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceArgs.prototype.getData = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.Json.deserialize(this.getDataJson.apply(this, arguments));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceArgs.prototype.setData = function (data) {
                    if (arguments.length == 1) {
                        arguments[arguments.length - 1] = fm.liveswitch.Json.serialize(arguments[arguments.length - 1]);
                        this.setDataJson.apply(this, arguments);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ServiceArgs;
            }(fm.liveswitch.signalling.InputArgs));
            signalling.ServiceArgs = ServiceArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/FailureArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ServiceFailureArgs = /** @class */ (function (_super) {
                __extends(ServiceFailureArgs, _super);
                function ServiceFailureArgs(channel, dataJson, dataBytes) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 3) {
                        var channel_11 = __arguments[0];
                        var dataJson_7 = __arguments[1];
                        var dataBytes_7 = __arguments[2];
                        _this = _super.call(this) || this;
                        _this.__channel = channel_11;
                        _this.__dataJson = dataJson_7;
                        _this.__dataBytes = dataBytes_7;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ServiceFailureArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ServiceFailureArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                ServiceFailureArgs.prototype.getChannel = function () {
                    if (arguments.length == 0) {
                        return this.__channel;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceFailureArgs.prototype.getDataBytes = function () {
                    if (arguments.length == 0) {
                        var decoded = this.__dataBytes;
                        var valueJson = this.__dataJson;
                        if ((!fm.liveswitch.Global.equals(decoded, null))) {
                            return decoded;
                        }
                        if ((!fm.liveswitch.Global.equals(valueJson, null))) {
                            var _var0 = new fm.liveswitch.Holder(decoded);
                            var _var1 = fm.liveswitch.Base64.tryDecode(fm.liveswitch.JsonSerializer.deserializeString(valueJson), _var0);
                            decoded = _var0.getValue();
                            if (!_var1) {
                                decoded = null;
                            }
                            this.__dataBytes = decoded;
                            return decoded;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceFailureArgs.prototype.getDataJson = function () {
                    if (arguments.length == 0) {
                        var str = this.__dataJson;
                        var b = this.__dataBytes;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            return str;
                        }
                        if ((!fm.liveswitch.Global.equals(b, null))) {
                            str = fm.liveswitch.JsonSerializer.serializeString(fm.liveswitch.Base64.encode(b));
                            this.__dataJson = str;
                            return str;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceFailureArgs.prototype.getIsBinary = function () {
                    if (arguments.length == 0) {
                        return (!fm.liveswitch.Global.equals(this.getDataBytes(), null));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceFailureArgs.prototype.getSource = function () {
                    if (arguments.length == 0) {
                        return this._source;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceFailureArgs.prototype.getTag = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.JsonSerializer.deserializeString(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceFailureArgs.prototype.setSource = function (value) {
                    if (arguments.length == 1) {
                        this._source = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceFailureArgs.prototype.getData = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.Json.deserialize(this.getDataJson.apply(this, arguments));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ServiceFailureArgs;
            }(fm.liveswitch.signalling.FailureArgs));
            signalling.ServiceFailureArgs = ServiceFailureArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/SuccessArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var ServiceSuccessArgs = /** @class */ (function (_super) {
                __extends(ServiceSuccessArgs, _super);
                function ServiceSuccessArgs(channel, dataJson, dataBytes) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 3) {
                        var channel_12 = __arguments[0];
                        var dataJson_8 = __arguments[1];
                        var dataBytes_8 = __arguments[2];
                        _this = _super.call(this) || this;
                        _this.__channel = channel_12;
                        _this.__dataJson = dataJson_8;
                        _this.__dataBytes = dataBytes_8;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                ServiceSuccessArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.ServiceSuccessArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                ServiceSuccessArgs.prototype.getChannel = function () {
                    if (arguments.length == 0) {
                        return this.__channel;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceSuccessArgs.prototype.getDataBytes = function () {
                    if (arguments.length == 0) {
                        var decoded = this.__dataBytes;
                        var valueJson = this.__dataJson;
                        if ((!fm.liveswitch.Global.equals(decoded, null))) {
                            return decoded;
                        }
                        if ((!fm.liveswitch.Global.equals(valueJson, null))) {
                            var _var0 = new fm.liveswitch.Holder(decoded);
                            var _var1 = fm.liveswitch.Base64.tryDecode(fm.liveswitch.JsonSerializer.deserializeString(valueJson), _var0);
                            decoded = _var0.getValue();
                            if (!_var1) {
                                decoded = null;
                            }
                            this.__dataBytes = decoded;
                            return decoded;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceSuccessArgs.prototype.getDataJson = function () {
                    if (arguments.length == 0) {
                        var str = this.__dataJson;
                        var b = this.__dataBytes;
                        if ((!fm.liveswitch.Global.equals(str, null))) {
                            return str;
                        }
                        if ((!fm.liveswitch.Global.equals(b, null))) {
                            str = fm.liveswitch.JsonSerializer.serializeString(fm.liveswitch.Base64.encode(b));
                            this.__dataJson = str;
                            return str;
                        }
                        return null;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceSuccessArgs.prototype.getIsBinary = function () {
                    if (arguments.length == 0) {
                        return (!fm.liveswitch.Global.equals(this.getDataBytes(), null));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceSuccessArgs.prototype.getTag = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.JsonSerializer.deserializeString(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                ServiceSuccessArgs.prototype.getData = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.Json.deserialize(this.getDataJson.apply(this, arguments));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return ServiceSuccessArgs;
            }(fm.liveswitch.signalling.SuccessArgs));
            signalling.ServiceSuccessArgs = ServiceSuccessArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/InputArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var SubscribeArgs = /** @class */ (function (_super) {
                __extends(SubscribeArgs, _super);
                function SubscribeArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingSubscribeArgsInit();
                    }
                    else if (__arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                        var channel = __arguments[0];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingSubscribeArgsInit();
                        _this.setChannel(channel);
                    }
                    else if (__arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isFunction(arguments[1]))) {
                        var channel = __arguments[0];
                        var onReceive = __arguments[1];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingSubscribeArgsInit();
                        _this.setChannel(channel);
                        _this.setOnReceive(onReceive);
                    }
                    else if (__arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isFunction(arguments[1]))) {
                        var channel = __arguments[0];
                        var onReceive = __arguments[1];
                        var onPresence = __arguments[2];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingSubscribeArgsInit();
                        _this.setChannel(channel);
                        _this.setOnReceive(onReceive);
                        _this.setOnPresence(onPresence);
                    }
                    else if (__arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                        var channel = __arguments[0];
                        var tag = __arguments[1];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingSubscribeArgsInit();
                        _this.setChannel(channel);
                        _this.setTag(tag);
                    }
                    else if (__arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0])) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                        var channel = __arguments[0];
                        var tag = __arguments[1];
                        var onReceive = __arguments[2];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingSubscribeArgsInit();
                        _this.setChannel(channel);
                        _this.setTag(tag);
                        _this.setOnReceive(onReceive);
                    }
                    else if (__arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                        var channel = __arguments[0];
                        var tag = __arguments[1];
                        var onReceive = __arguments[2];
                        var onPresence = __arguments[3];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingSubscribeArgsInit();
                        _this.setChannel(channel);
                        _this.setTag(tag);
                        _this.setOnReceive(onReceive);
                        _this.setOnPresence(onPresence);
                    }
                    else if (__arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isString(arguments[0][0])))))) {
                        var channels = __arguments[0];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingSubscribeArgsInit();
                        _this.setChannels(channels);
                    }
                    else if (__arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isString(arguments[0][0]))))) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isFunction(arguments[1]))) {
                        var channels = __arguments[0];
                        var onReceive = __arguments[1];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingSubscribeArgsInit();
                        _this.setChannels(channels);
                        _this.setOnReceive(onReceive);
                    }
                    else if (__arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isString(arguments[0][0]))))) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isFunction(arguments[1]))) {
                        var channels = __arguments[0];
                        var onReceive = __arguments[1];
                        var onPresence = __arguments[2];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingSubscribeArgsInit();
                        _this.setChannels(channels);
                        _this.setOnReceive(onReceive);
                        _this.setOnPresence(onPresence);
                    }
                    else if (__arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isString(arguments[0][0]))))) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                        var channels = __arguments[0];
                        var tag = __arguments[1];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingSubscribeArgsInit();
                        _this.setChannels(channels);
                        _this.setTag(tag);
                    }
                    else if (__arguments.length == 3 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isString(arguments[0][0]))))) && (fm.liveswitch.Util.isNullOrUndefined(arguments[1]) || fm.liveswitch.Util.isString(arguments[1]))) {
                        var channels = __arguments[0];
                        var tag = __arguments[1];
                        var onReceive = __arguments[2];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingSubscribeArgsInit();
                        _this.setChannels(channels);
                        _this.setTag(tag);
                        _this.setOnReceive(onReceive);
                    }
                    else if (__arguments.length == 4 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isString(arguments[0][0])))))) {
                        var channels = __arguments[0];
                        var tag = __arguments[1];
                        var onReceive = __arguments[2];
                        var onPresence = __arguments[3];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingSubscribeArgsInit();
                        _this.setChannels(channels);
                        _this.setTag(tag);
                        _this.setOnReceive(onReceive);
                        _this.setOnPresence(onPresence);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                SubscribeArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.SubscribeArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                SubscribeArgs.prototype.fmliveswitchsignallingSubscribeArgsInit = function () {
                    this._bindIsPrivate = false;
                };
                SubscribeArgs.prototype.getBindIsPrivate = function () {
                    if (arguments.length == 0) {
                        return this._bindIsPrivate;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeArgs.prototype.getBindRecord = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetRecord(this.__bindRecords);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeArgs.prototype.getBindRecords = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetRecords(this.__bindRecords);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeArgs.prototype.getChannel = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetChannel(this.__channels);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeArgs.prototype.getChannels = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetChannels(this.__channels);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeArgs.prototype.getOnFailure = function () {
                    if (arguments.length == 0) {
                        return this._onFailure;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeArgs.prototype.getOnPresence = function () {
                    if (arguments.length == 0) {
                        return this.__onPresence;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeArgs.prototype.getOnReceive = function () {
                    if (arguments.length == 0) {
                        return this._onReceive;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeArgs.prototype.getOnSuccess = function () {
                    if (arguments.length == 0) {
                        return this._onSuccess;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeArgs.prototype.getTag = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.StringExtensions.nullCoalesce(fm.liveswitch.JsonSerializer.deserializeString(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName())), fm.liveswitch.StringExtensions.empty);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeArgs.prototype.setBindIsPrivate = function (value) {
                    if (arguments.length == 1) {
                        this._bindIsPrivate = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeArgs.prototype.setBindRecord = function (value) {
                    if (arguments.length == 1) {
                        this.__bindRecords = fm.liveswitch.signalling.Extensible.sharedSetRecord(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeArgs.prototype.setBindRecords = function (value) {
                    if (arguments.length == 1) {
                        this.__bindRecords = fm.liveswitch.signalling.Extensible.sharedSetRecords(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeArgs.prototype.setChannel = function (value) {
                    if (arguments.length == 1) {
                        this.__channels = fm.liveswitch.signalling.Extensible.sharedSetChannel(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeArgs.prototype.setChannels = function (value) {
                    if (arguments.length == 1) {
                        this.__channels = fm.liveswitch.signalling.Extensible.sharedSetChannels(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeArgs.prototype.setOnFailure = function (value) {
                    if (arguments.length == 1) {
                        this._onFailure = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeArgs.prototype.setOnPresence = function (value) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(value, null))) {
                            _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getPresenceExtensionName(), null);
                        }
                        else {
                            _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getPresenceExtensionName(), fm.liveswitch.JsonSerializer.serializeBoolean(true));
                        }
                        this.__onPresence = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeArgs.prototype.setOnReceive = function (value) {
                    if (arguments.length == 1) {
                        this._onReceive = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeArgs.prototype.setOnSuccess = function (value) {
                    if (arguments.length == 1) {
                        this._onSuccess = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeArgs.prototype.setTag = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName(), fm.liveswitch.JsonSerializer.serializeString(fm.liveswitch.StringExtensions.nullCoalesce(value, fm.liveswitch.StringExtensions.empty)), false);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return SubscribeArgs;
            }(fm.liveswitch.signalling.InputArgs));
            signalling.SubscribeArgs = SubscribeArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/FailureArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var SubscribeFailureArgs = /** @class */ (function (_super) {
                __extends(SubscribeFailureArgs, _super);
                function SubscribeFailureArgs(channels, bindRecords, bindIsPrivate) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 3) {
                        var channels_12 = __arguments[0];
                        var bindRecords_1 = __arguments[1];
                        var bindIsPrivate_1 = __arguments[2];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingSubscribeFailureArgsInit();
                        _this.__channels = channels_12;
                        _this.__bindRecords = bindRecords_1;
                        _this.__bindIsPrivate = bindIsPrivate_1;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                SubscribeFailureArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.SubscribeFailureArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                SubscribeFailureArgs.prototype.fmliveswitchsignallingSubscribeFailureArgsInit = function () {
                    this.__bindIsPrivate = false;
                };
                SubscribeFailureArgs.prototype.getBindIsPrivate = function () {
                    if (arguments.length == 0) {
                        return this.__bindIsPrivate;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeFailureArgs.prototype.getBindRecord = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetRecord(this.__bindRecords);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeFailureArgs.prototype.getBindRecords = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetRecords(this.__bindRecords);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeFailureArgs.prototype.getChannel = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetChannel(this.__channels);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeFailureArgs.prototype.getChannels = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetChannels(this.__channels);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeFailureArgs.prototype.getTag = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.StringExtensions.nullCoalesce(fm.liveswitch.JsonSerializer.deserializeString(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName())), fm.liveswitch.StringExtensions.empty);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return SubscribeFailureArgs;
            }(fm.liveswitch.signalling.FailureArgs));
            signalling.SubscribeFailureArgs = SubscribeFailureArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ReceiveArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var SubscribePresenceArgs = /** @class */ (function (_super) {
                __extends(SubscribePresenceArgs, _super);
                function SubscribePresenceArgs(channel, remoteClient, presenceType, firstUserSubscribe, lastUserUnsubscribe, firstDeviceSubscribe, lastDeviceUnsubscribe, connectionType, reconnectAfter) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 9) {
                        var channel_13 = __arguments[0];
                        var remoteClient_1 = __arguments[1];
                        var presenceType_1 = __arguments[2];
                        var firstUserSubscribe_1 = __arguments[3];
                        var lastUserUnsubscribe_1 = __arguments[4];
                        var firstDeviceSubscribe_1 = __arguments[5];
                        var lastDeviceUnsubscribe_1 = __arguments[6];
                        var connectionType_3 = __arguments[7];
                        var reconnectAfter_2 = __arguments[8];
                        _this = _super.call(this, null, null, connectionType_3, reconnectAfter_2) || this;
                        _this.fmliveswitchsignallingSubscribePresenceArgsInit();
                        _this.__channel = channel_13;
                        _this.__remoteClient = remoteClient_1;
                        _this.__presenceType = presenceType_1;
                        _this.__firstUserSubscribe = firstUserSubscribe_1;
                        _this.__lastUserUnsubscribe = lastUserUnsubscribe_1;
                        _this.__firstDeviceSubscribe = firstDeviceSubscribe_1;
                        _this.__lastDeviceUnsubscribe = lastDeviceUnsubscribe_1;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                SubscribePresenceArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.SubscribePresenceArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                SubscribePresenceArgs.prototype.fmliveswitchsignallingSubscribePresenceArgsInit = function () {
                    this.__firstDeviceSubscribe = false;
                    this.__firstUserSubscribe = false;
                    this.__lastDeviceUnsubscribe = false;
                    this.__lastUserUnsubscribe = false;
                };
                SubscribePresenceArgs.prototype.getChannel = function () {
                    if (arguments.length == 0) {
                        return this.__channel;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribePresenceArgs.prototype.getFirstDeviceSubscribe = function () {
                    if (arguments.length == 0) {
                        return this.__firstDeviceSubscribe;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribePresenceArgs.prototype.getFirstUserSubscribe = function () {
                    if (arguments.length == 0) {
                        return this.__firstUserSubscribe;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribePresenceArgs.prototype.getLastDeviceUnsubscribe = function () {
                    if (arguments.length == 0) {
                        return this.__lastDeviceUnsubscribe;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribePresenceArgs.prototype.getLastUserUnsubscribe = function () {
                    if (arguments.length == 0) {
                        return this.__lastUserUnsubscribe;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribePresenceArgs.prototype.getPresenceType = function () {
                    if (arguments.length == 0) {
                        return this.__presenceType;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribePresenceArgs.prototype.getRemoteClient = function () {
                    if (arguments.length == 0) {
                        return this.__remoteClient;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return SubscribePresenceArgs;
            }(fm.liveswitch.signalling.ReceiveArgs));
            signalling.SubscribePresenceArgs = SubscribePresenceArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/ReceiveArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var SubscribeReceiveArgs = /** @class */ (function (_super) {
                __extends(SubscribeReceiveArgs, _super);
                function SubscribeReceiveArgs(channel, dataJson, dataBytes, connectionType, reconnectAfter) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 5) {
                        var channel_14 = __arguments[0];
                        var dataJson_9 = __arguments[1];
                        var dataBytes_9 = __arguments[2];
                        var connectionType_4 = __arguments[3];
                        var reconnectAfter_3 = __arguments[4];
                        _this = _super.call(this, dataJson_9, dataBytes_9, connectionType_4, reconnectAfter_3) || this;
                        _this.__channel = channel_14;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                SubscribeReceiveArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.SubscribeReceiveArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                SubscribeReceiveArgs.prototype.getChannel = function () {
                    if (arguments.length == 0) {
                        return this.__channel;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeReceiveArgs.prototype.getRemoteClient = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.RemoteClient.fromJson(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getRemoteClientExtensionName()));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeReceiveArgs.prototype.getWasSentByMe = function () {
                    if (arguments.length == 0) {
                        return (((!fm.liveswitch.Global.equals(this.getRemoteClient(), null)) && (!fm.liveswitch.Global.equals(_super.prototype.getClient.call(this), null))) && (fm.liveswitch.Global.equals(this.getRemoteClient().getClientId(), _super.prototype.getClient.call(this).getClientId())));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return SubscribeReceiveArgs;
            }(fm.liveswitch.signalling.ReceiveArgs));
            signalling.SubscribeReceiveArgs = SubscribeReceiveArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/SuccessArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var SubscribeSuccessArgs = /** @class */ (function (_super) {
                __extends(SubscribeSuccessArgs, _super);
                function SubscribeSuccessArgs(channels, bindRecords, bindIsPrivate, subscribedClients) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 4) {
                        var channels_13 = __arguments[0];
                        var bindRecords_2 = __arguments[1];
                        var bindIsPrivate_2 = __arguments[2];
                        var subscribedClients_1 = __arguments[3];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingSubscribeSuccessArgsInit();
                        _this.__channels = channels_13;
                        _this.__bindRecords = bindRecords_2;
                        _this.__bindIsPrivate = bindIsPrivate_2;
                        _this.__subscribedClients = subscribedClients_1;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                SubscribeSuccessArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.SubscribeSuccessArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                SubscribeSuccessArgs.prototype.fmliveswitchsignallingSubscribeSuccessArgsInit = function () {
                    this.__bindIsPrivate = false;
                };
                SubscribeSuccessArgs.prototype.getBindIsPrivate = function () {
                    if (arguments.length == 0) {
                        return this.__bindIsPrivate;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeSuccessArgs.prototype.getBindRecord = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetRecord(this.__bindRecords);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeSuccessArgs.prototype.getBindRecords = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetRecords(this.__bindRecords);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeSuccessArgs.prototype.getChannel = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetChannel(this.__channels);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeSuccessArgs.prototype.getChannels = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetChannels(this.__channels);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeSuccessArgs.prototype.getSubscribedClients = function () {
                    if (arguments.length == 0) {
                        var subscribedClientsByChannel = this.getSubscribedClientsByChannel();
                        if ((fm.liveswitch.Global.equals(subscribedClientsByChannel, null))) {
                            return null;
                        }
                        var channel = this.getChannel();
                        if ((fm.liveswitch.Global.equals(channel, null))) {
                            return null;
                        }
                        return subscribedClientsByChannel[channel];
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeSuccessArgs.prototype.getSubscribedClientsByChannel = function () {
                    if (arguments.length == 0) {
                        return this.__subscribedClients;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                SubscribeSuccessArgs.prototype.getTag = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.StringExtensions.nullCoalesce(fm.liveswitch.JsonSerializer.deserializeString(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName())), fm.liveswitch.StringExtensions.empty);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return SubscribeSuccessArgs;
            }(fm.liveswitch.signalling.SuccessArgs));
            signalling.SubscribeSuccessArgs = SubscribeSuccessArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../Dynamic.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var Subscription = /** @class */ (function (_super) {
                __extends(Subscription, _super);
                function Subscription() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var channel = __arguments[0];
                        _this = _super.call(this) || this;
                        _this.setChannel(channel);
                    }
                    else if (__arguments.length == 2) {
                        var channel = __arguments[0];
                        var tag = __arguments[1];
                        _this = _super.call(this) || this;
                        _this.setChannel(channel);
                        _this.setTag(tag);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                Subscription.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.Subscription]' + ',' + _super.prototype.getTypeString.call(this);
                };
                Subscription.fromJson = function (subscriptionJson) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.deserializeObjectFast(subscriptionJson, function () {
                            return new fm.liveswitch.signalling.Subscription("/");
                        }, function (obj, name, valueJson) {
                            var str = name;
                            if ((!fm.liveswitch.Global.equals(str, null))) {
                                if (!(fm.liveswitch.Global.equals(str, "channel"))) {
                                    if ((fm.liveswitch.Global.equals(str, "tag"))) {
                                        obj.setTag(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                    }
                                }
                                else {
                                    obj.setChannel(fm.liveswitch.JsonSerializer.deserializeString(valueJson));
                                }
                            }
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Subscription.fromJsonArray = function (subscriptionsJson) {
                    if (arguments.length == 1) {
                        var list = fm.liveswitch.JsonSerializer.deserializeObjectArray(subscriptionsJson, fm.liveswitch.signalling.Subscription.fromJson.bind(fm.liveswitch.signalling.Subscription));
                        if ((fm.liveswitch.Global.equals(list, null))) {
                            return null;
                        }
                        return fm.liveswitch.ArrayExtensions.toArray(list);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Subscription.toJson = function (subscription) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.serializeObjectFast(subscription, function (obj, jsonObject) {
                            jsonObject["channel"] = fm.liveswitch.JsonSerializer.serializeString(obj.getChannel());
                            if ((!fm.liveswitch.Global.equals(subscription.getTag(), null))) {
                                jsonObject["tag"] = fm.liveswitch.JsonSerializer.serializeString(obj.getTag());
                            }
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Subscription.toJsonArray = function (subscriptions) {
                    if (arguments.length == 1) {
                        return fm.liveswitch.JsonSerializer.serializeObjectArray(subscriptions, fm.liveswitch.signalling.Subscription.toJson.bind(fm.liveswitch.signalling.Subscription));
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Subscription.prototype.duplicate = function () {
                    if (arguments.length == 0) {
                        return new fm.liveswitch.signalling.Subscription(this.getChannel(), this.getTag());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Subscription.prototype.getChannel = function () {
                    if (arguments.length == 0) {
                        return this.__channel;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Subscription.prototype.getTag = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.StringExtensions.nullCoalesce(this.__tag, fm.liveswitch.StringExtensions.empty);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Subscription.prototype.setChannel = function (value) {
                    if (arguments.length == 1) {
                        if ((fm.liveswitch.Global.equals(value, null))) {
                            throw new fm.liveswitch.Exception("channel cannot be null.");
                        }
                        this.__channel = value;
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Subscription.prototype.setTag = function (value) {
                    if (arguments.length == 1) {
                        this.__tag = fm.liveswitch.StringExtensions.nullCoalesce(value, fm.liveswitch.StringExtensions.empty);
                        _super.prototype.setIsDirty.call(this, true);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                Subscription.prototype.toJson = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Subscription.toJson(this);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return Subscription;
            }(fm.liveswitch.Dynamic));
            signalling.Subscription = Subscription;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/InputArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var UnbindArgs = /** @class */ (function (_super) {
                __extends(UnbindArgs, _super);
                function UnbindArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else if (__arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                        var key = __arguments[0];
                        _this = _super.call(this) || this;
                        _this.setKey(key);
                    }
                    else if (__arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isString(arguments[0][0])))))) {
                        var keys = __arguments[0];
                        _this = _super.call(this) || this;
                        _this.setKeys(keys);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                UnbindArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.UnbindArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                UnbindArgs.prototype.getKey = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetKey(this.__keys);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnbindArgs.prototype.getKeys = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetKeys(this.__keys);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnbindArgs.prototype.getOnFailure = function () {
                    if (arguments.length == 0) {
                        return this._onFailure;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnbindArgs.prototype.getOnSuccess = function () {
                    if (arguments.length == 0) {
                        return this._onSuccess;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnbindArgs.prototype.setKey = function (value) {
                    if (arguments.length == 1) {
                        this.__keys = fm.liveswitch.signalling.Extensible.sharedSetKey(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnbindArgs.prototype.setKeys = function (value) {
                    if (arguments.length == 1) {
                        this.__keys = fm.liveswitch.signalling.Extensible.sharedSetKeys(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnbindArgs.prototype.setOnFailure = function (value) {
                    if (arguments.length == 1) {
                        this._onFailure = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnbindArgs.prototype.setOnSuccess = function (value) {
                    if (arguments.length == 1) {
                        this._onSuccess = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return UnbindArgs;
            }(fm.liveswitch.signalling.InputArgs));
            signalling.UnbindArgs = UnbindArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/FailureArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var UnbindFailureArgs = /** @class */ (function (_super) {
                __extends(UnbindFailureArgs, _super);
                function UnbindFailureArgs(keys) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 1) {
                        var keys_2 = __arguments[0];
                        _this = _super.call(this) || this;
                        _this.__keys = keys_2;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                UnbindFailureArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.UnbindFailureArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                UnbindFailureArgs.prototype.getKey = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetKey(this.__keys);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnbindFailureArgs.prototype.getKeys = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetKeys(this.__keys);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return UnbindFailureArgs;
            }(fm.liveswitch.signalling.FailureArgs));
            signalling.UnbindFailureArgs = UnbindFailureArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/SuccessArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var UnbindSuccessArgs = /** @class */ (function (_super) {
                __extends(UnbindSuccessArgs, _super);
                function UnbindSuccessArgs(keys, forced) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 2) {
                        var keys_3 = __arguments[0];
                        var forced_1 = __arguments[1];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingUnbindSuccessArgsInit();
                        _this.__keys = keys_3;
                        _this.__forced = forced_1;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                UnbindSuccessArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.UnbindSuccessArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                UnbindSuccessArgs.prototype.fmliveswitchsignallingUnbindSuccessArgsInit = function () {
                    this.__forced = false;
                };
                UnbindSuccessArgs.prototype.getForced = function () {
                    if (arguments.length == 0) {
                        return this.__forced;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnbindSuccessArgs.prototype.getKey = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetKey(this.__keys);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnbindSuccessArgs.prototype.getKeys = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetKeys(this.__keys);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return UnbindSuccessArgs;
            }(fm.liveswitch.signalling.SuccessArgs));
            signalling.UnbindSuccessArgs = UnbindSuccessArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/InputArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var UnsubscribeArgs = /** @class */ (function (_super) {
                __extends(UnsubscribeArgs, _super);
                function UnsubscribeArgs() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else if (__arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                        var channel = __arguments[0];
                        _this = _super.call(this) || this;
                        _this.setChannel(channel);
                    }
                    else if (__arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || fm.liveswitch.Util.isString(arguments[0]))) {
                        var channel = __arguments[0];
                        var tag = __arguments[1];
                        _this = _super.call(this) || this;
                        _this.setChannel(channel);
                        _this.setTag(tag);
                    }
                    else if (__arguments.length == 1 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isString(arguments[0][0])))))) {
                        var channels = __arguments[0];
                        _this = _super.call(this) || this;
                        _this.setChannels(channels);
                    }
                    else if (__arguments.length == 2 && (fm.liveswitch.Util.isNullOrUndefined(arguments[0]) || (fm.liveswitch.Util.isArray(arguments[0]) && (arguments[0].length == 0 || (fm.liveswitch.Util.isNullOrUndefined(arguments[0][0]) || fm.liveswitch.Util.isString(arguments[0][0])))))) {
                        var channels = __arguments[0];
                        var tag = __arguments[1];
                        _this = _super.call(this) || this;
                        _this.setChannels(channels);
                        _this.setTag(tag);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                UnsubscribeArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.UnsubscribeArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                UnsubscribeArgs.prototype.getChannel = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetChannel(this.__channels);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnsubscribeArgs.prototype.getChannels = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetChannels(this.__channels);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnsubscribeArgs.prototype.getOnFailure = function () {
                    if (arguments.length == 0) {
                        return this._onFailure;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnsubscribeArgs.prototype.getOnSuccess = function () {
                    if (arguments.length == 0) {
                        return this._onSuccess;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnsubscribeArgs.prototype.getTag = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.StringExtensions.nullCoalesce(fm.liveswitch.JsonSerializer.deserializeString(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName())), fm.liveswitch.StringExtensions.empty);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnsubscribeArgs.prototype.getUnbindKey = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetKey(this.__unbindKeys);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnsubscribeArgs.prototype.getUnbindKeys = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetKeys(this.__unbindKeys);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnsubscribeArgs.prototype.setChannel = function (value) {
                    if (arguments.length == 1) {
                        this.__channels = fm.liveswitch.signalling.Extensible.sharedSetChannel(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnsubscribeArgs.prototype.setChannels = function (value) {
                    if (arguments.length == 1) {
                        this.__channels = fm.liveswitch.signalling.Extensible.sharedSetChannels(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnsubscribeArgs.prototype.setOnFailure = function (value) {
                    if (arguments.length == 1) {
                        this._onFailure = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnsubscribeArgs.prototype.setOnSuccess = function (value) {
                    if (arguments.length == 1) {
                        this._onSuccess = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnsubscribeArgs.prototype.setTag = function (value) {
                    if (arguments.length == 1) {
                        _super.prototype.setExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName(), fm.liveswitch.JsonSerializer.serializeString(fm.liveswitch.StringExtensions.nullCoalesce(value, fm.liveswitch.StringExtensions.empty)), false);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnsubscribeArgs.prototype.setUnbindKey = function (value) {
                    if (arguments.length == 1) {
                        this.__unbindKeys = fm.liveswitch.signalling.Extensible.sharedSetKey(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnsubscribeArgs.prototype.setUnbindKeys = function (value) {
                    if (arguments.length == 1) {
                        this.__unbindKeys = fm.liveswitch.signalling.Extensible.sharedSetKeys(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return UnsubscribeArgs;
            }(fm.liveswitch.signalling.InputArgs));
            signalling.UnsubscribeArgs = UnsubscribeArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/FailureArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var UnsubscribeFailureArgs = /** @class */ (function (_super) {
                __extends(UnsubscribeFailureArgs, _super);
                function UnsubscribeFailureArgs(channels, unbindKeys) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 2) {
                        var channels_14 = __arguments[0];
                        var unbindKeys_1 = __arguments[1];
                        _this = _super.call(this) || this;
                        _this.__channels = channels_14;
                        _this.__unbindKeys = unbindKeys_1;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                UnsubscribeFailureArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.UnsubscribeFailureArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                UnsubscribeFailureArgs.prototype.getChannel = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetChannel(this.__channels);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnsubscribeFailureArgs.prototype.getChannels = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetChannels(this.__channels);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnsubscribeFailureArgs.prototype.getTag = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.StringExtensions.nullCoalesce(fm.liveswitch.JsonSerializer.deserializeString(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName())), fm.liveswitch.StringExtensions.empty);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnsubscribeFailureArgs.prototype.getUnbindKey = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetKey(this.__unbindKeys);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnsubscribeFailureArgs.prototype.getUnbindKeys = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetKeys(this.__unbindKeys);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return UnsubscribeFailureArgs;
            }(fm.liveswitch.signalling.FailureArgs));
            signalling.UnsubscribeFailureArgs = UnsubscribeFailureArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/SuccessArgs.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var UnsubscribeSuccessArgs = /** @class */ (function (_super) {
                __extends(UnsubscribeSuccessArgs, _super);
                function UnsubscribeSuccessArgs(channels, unbindKeys, forced) {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 3) {
                        var channels_15 = __arguments[0];
                        var unbindKeys_2 = __arguments[1];
                        var forced_2 = __arguments[2];
                        _this = _super.call(this) || this;
                        _this.fmliveswitchsignallingUnsubscribeSuccessArgsInit();
                        _this.__channels = channels_15;
                        _this.__unbindKeys = unbindKeys_2;
                        _this.__forced = forced_2;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                UnsubscribeSuccessArgs.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.UnsubscribeSuccessArgs]' + ',' + _super.prototype.getTypeString.call(this);
                };
                UnsubscribeSuccessArgs.prototype.fmliveswitchsignallingUnsubscribeSuccessArgsInit = function () {
                    this.__forced = false;
                };
                UnsubscribeSuccessArgs.prototype.getChannel = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetChannel(this.__channels);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnsubscribeSuccessArgs.prototype.getChannels = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetChannels(this.__channels);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnsubscribeSuccessArgs.prototype.getForced = function () {
                    if (arguments.length == 0) {
                        return this.__forced;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnsubscribeSuccessArgs.prototype.getTag = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.StringExtensions.nullCoalesce(fm.liveswitch.JsonSerializer.deserializeString(_super.prototype.getExtensionValueJson.call(this, fm.liveswitch.signalling.Extensible.getTagExtensionName())), fm.liveswitch.StringExtensions.empty);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnsubscribeSuccessArgs.prototype.getUnbindKey = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetKey(this.__unbindKeys);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                UnsubscribeSuccessArgs.prototype.getUnbindKeys = function () {
                    if (arguments.length == 0) {
                        return fm.liveswitch.signalling.Extensible.sharedGetKeys(this.__unbindKeys);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return UnsubscribeSuccessArgs;
            }(fm.liveswitch.signalling.SuccessArgs));
            signalling.UnsubscribeSuccessArgs = UnsubscribeSuccessArgs;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="../signalling/MessageTransfer.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            /** @hidden */
            var WebSocketMessageTransfer = /** @class */ (function (_super) {
                __extends(WebSocketMessageTransfer, _super);
                function WebSocketMessageTransfer() {
                    var _this = this;
                    var __arguments = new Array(arguments.length);
                    for (var __argumentIndex = 0; __argumentIndex < __arguments.length; ++__argumentIndex) {
                        __arguments[__argumentIndex] = arguments[__argumentIndex];
                    }
                    if (__arguments.length == 0) {
                        _this = _super.call(this) || this;
                    }
                    else if (__arguments.length == 1) {
                        var url = __arguments[0];
                        // chained constructor: WebSocketMessageTransfer.call(this);
                        __arguments = new Array(0);
                        {
                            _this = _super.call(this) || this;
                        }
                        _this.setUrl(url);
                        _this._webSocketTransfer = fm.liveswitch.WebSocketTransferFactory.getWebSocketTransfer(_this.getUrl());
                    }
                    else {
                        throw new fm.liveswitch.Exception('Constructor overload does not exist with specified parameter count/type combination.');
                    }
                    return _this;
                }
                WebSocketMessageTransfer.prototype.getTypeString = function () {
                    return '[fm.liveswitch.signalling.WebSocketMessageTransfer]' + ',' + _super.prototype.getTypeString.call(this);
                };
                WebSocketMessageTransfer.prototype.getHandshakeTimeout = function () {
                    if (arguments.length == 0) {
                        return this._webSocketTransfer.getHandshakeTimeout();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                WebSocketMessageTransfer.prototype.getOnOpenFailure = function () {
                    if (arguments.length == 0) {
                        return this._webSocketTransfer.getOnOpenFailure();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                WebSocketMessageTransfer.prototype.getOnOpenSuccess = function () {
                    if (arguments.length == 0) {
                        return this._webSocketTransfer.getOnOpenSuccess();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                WebSocketMessageTransfer.prototype.getOnRequestCreated = function () {
                    if (arguments.length == 0) {
                        return this._webSocketTransfer.getOnRequestCreated();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                WebSocketMessageTransfer.prototype.getOnResponseReceived = function () {
                    if (arguments.length == 0) {
                        return this._webSocketTransfer.getOnResponseReceived();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                WebSocketMessageTransfer.prototype.getOnStreamFailure = function () {
                    if (arguments.length == 0) {
                        return this._webSocketTransfer.getOnStreamFailure();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                WebSocketMessageTransfer.prototype.getSender = function () {
                    if (arguments.length == 0) {
                        return this._webSocketTransfer.getSender();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                WebSocketMessageTransfer.prototype.getStreamTimeout = function () {
                    if (arguments.length == 0) {
                        return this._webSocketTransfer.getHandshakeTimeout();
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                WebSocketMessageTransfer.prototype.getUrl = function () {
                    if (arguments.length == 0) {
                        return this._url;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                WebSocketMessageTransfer.prototype.open = function (headers) {
                    if (arguments.length == 1) {
                        this._webSocketTransfer.open(headers);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                WebSocketMessageTransfer.prototype.sendMessages = function (requestArgs) {
                    if (arguments.length == 1) {
                        var args = _super.prototype.messageRequestArgsToHttpRequestArgs.call(this, requestArgs);
                        var httpResponseArgs = this._webSocketTransfer.send(args);
                        return _super.prototype.httpResponseArgsToMessageResponseArgs.call(this, httpResponseArgs);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                WebSocketMessageTransfer.prototype.sendMessagesAsync = function (requestArgs, callback) {
                    var _this = this;
                    if (arguments.length == 2) {
                        var args = _super.prototype.messageRequestArgsToHttpRequestArgs.call(this, requestArgs);
                        this._webSocketTransfer.sendAsync(args, function (httpResponseArgs) {
                            var p = _this.httpResponseArgsToMessageResponseArgs(httpResponseArgs);
                            callback(p);
                        });
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                WebSocketMessageTransfer.prototype.setHandshakeTimeout = function (value) {
                    if (arguments.length == 1) {
                        this._webSocketTransfer.setHandshakeTimeout(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                WebSocketMessageTransfer.prototype.setOnOpenFailure = function (value) {
                    if (arguments.length == 1) {
                        this._webSocketTransfer.setOnOpenFailure(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                WebSocketMessageTransfer.prototype.setOnOpenSuccess = function (value) {
                    if (arguments.length == 1) {
                        this._webSocketTransfer.setOnOpenSuccess(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                WebSocketMessageTransfer.prototype.setOnRequestCreated = function (value) {
                    if (arguments.length == 1) {
                        this._webSocketTransfer.setOnRequestCreated(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                WebSocketMessageTransfer.prototype.setOnResponseReceived = function (value) {
                    if (arguments.length == 1) {
                        this._webSocketTransfer.setOnResponseReceived(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                WebSocketMessageTransfer.prototype.setOnStreamFailure = function (value) {
                    if (arguments.length == 1) {
                        this._webSocketTransfer.setOnStreamFailure(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                WebSocketMessageTransfer.prototype.setSender = function (value) {
                    if (arguments.length == 1) {
                        this._webSocketTransfer.setSender(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                WebSocketMessageTransfer.prototype.setStreamTimeout = function (value) {
                    if (arguments.length == 1) {
                        this._webSocketTransfer.setHandshakeTimeout(value);
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                WebSocketMessageTransfer.prototype.setUrl = function (value) {
                    if (arguments.length == 1) {
                        this._url = value;
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                WebSocketMessageTransfer.prototype.shutdown = function () {
                    if (arguments.length == 0) {
                        try {
                            this._webSocketTransfer.shutdown();
                        }
                        catch (exception1) {
                        }
                        finally {
                        }
                    }
                    else {
                        throw new fm.liveswitch.Exception('Method overload does not exist with specified parameter count/type combination.');
                    }
                };
                return WebSocketMessageTransfer;
            }(fm.liveswitch.signalling.MessageTransfer));
            signalling.WebSocketMessageTransfer = WebSocketMessageTransfer;
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var ConnectionUtility = /** @class */ (function () {
            function ConnectionUtility() {
            }
            ConnectionUtility.prototype.getTypeString = function () {
                return '[fm.liveswitch.ConnectionUtility]';
            };
            ConnectionUtility.createConnection = function (sharedLock, type, audioStream, videoStream, dataStream) {
                var streams = [];
                if (audioStream != null) {
                    if (type == fm.liveswitch.ConnectionType.getSfu() || type == fm.liveswitch.ConnectionType.getMcu()) {
                        audioStream.setDiscardDtmfTones(true);
                    }
                    streams.push(audioStream);
                }
                if (videoStream != null) {
                    streams.push(videoStream);
                }
                if (dataStream != null) {
                    streams.push(dataStream);
                }
                return new fm.liveswitch.Connection(streams);
            };
            return ConnectionUtility;
        }());
        liveswitch.ConnectionUtility = ConnectionUtility;
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Binary.ts" />

(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        fm.liveswitch.Binary.fmliveswitchBinaryInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Constants.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        fm.liveswitch.Constants.fmliveswitchConstantsInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="DataBuffer.ts" />
/// <reference path="DataBufferPool.ts" />
/// <reference path="DataBufferPoolTracer.ts" />
/// <reference path="IDataBufferPool.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        fm.liveswitch.DataBuffer.fmliveswitchDataBufferInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="UnixTimestamp.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        fm.liveswitch.UnixTimestamp.fmliveswitchUnixTimestampInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="HttpTransfer.ts" />
/// <reference path="Log.ts" />
/// <reference path="ILog.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        fm.liveswitch.HttpTransfer.fmliveswitchHttpTransferInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="JsonChecker.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        fm.liveswitch.JsonChecker.fmliveswitchJsonCheckerInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="LockedRandomizer.ts" />
/// <reference path="Randomizer.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        fm.liveswitch.LockedRandomizer.fmliveswitchLockedRandomizerInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Log.ts" />
/// <reference path="AsyncLogger.ts" />
/// <reference path="ILog.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        fm.liveswitch.Log.fmliveswitchLogInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="LogConfiguration.ts" />
/// <reference path="LogProvider.ts" />
/// <reference path="LogLevel.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        fm.liveswitch.LogConfiguration.fmliveswitchLogConfigurationInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="DataBufferPool.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        fm.liveswitch.DataBufferPool.fmliveswitchDataBufferPoolInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="WebSocketBase.ts" />
/// <reference path="Log.ts" />
/// <reference path="ILog.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        fm.liveswitch.WebSocketBase.fmliveswitchWebSocketBaseInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="EncodingInfo.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        fm.liveswitch.EncodingInfo.fmliveswitchEncodingInfoInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="sdp/Attribute.ts" />
/// <reference path="sdp/AttributeRegistration.ts" />
/// <reference path="sdp/UnknownAttribute.ts" />
/// <reference path="sdp/AttributeCreationArgs.ts" />
/// <reference path="IFunction1.ts" />
/// <reference path="sdp/GroupAttribute.ts" />
/// <reference path="sdp/CategoryAttribute.ts" />
/// <reference path="sdp/CharacterSetAttribute.ts" />
/// <reference path="sdp/ConferenceTypeAttribute.ts" />
/// <reference path="sdp/CryptoAttribute.ts" />
/// <reference path="sdp/FormatParametersAttribute.ts" />
/// <reference path="sdp/FrameRateAttribute.ts" />
/// <reference path="sdp/InactiveAttribute.ts" />
/// <reference path="sdp/KeywordsAttribute.ts" />
/// <reference path="sdp/LanguageAttribute.ts" />
/// <reference path="sdp/MaxPacketTimeAttribute.ts" />
/// <reference path="sdp/OrientationAttribute.ts" />
/// <reference path="sdp/PacketTimeAttribute.ts" />
/// <reference path="sdp/QualityAttribute.ts" />
/// <reference path="sdp/ReceiveOnlyAttribute.ts" />
/// <reference path="sdp/SdpLanguageAttribute.ts" />
/// <reference path="sdp/SendOnlyAttribute.ts" />
/// <reference path="sdp/SendReceiveAttribute.ts" />
/// <reference path="sdp/SetupAttribute.ts" />
/// <reference path="sdp/ToolAttribute.ts" />
/// <reference path="sdp/MediaStreamIdSemanticAttribute.ts" />
/// <reference path="sdp/MediaStreamIdAttribute.ts" />
/// <reference path="sdp/BundleOnlyAttribute.ts" />
/// <reference path="sdp/ice/CandidateAttribute.ts" />
/// <reference path="sdp/ice/FingerprintAttribute.ts" />
/// <reference path="sdp/ice/LiteAttribute.ts" />
/// <reference path="sdp/ice/MismatchAttribute.ts" />
/// <reference path="sdp/ice/OptionsAttribute.ts" />
/// <reference path="sdp/ice/PasswordAttribute.ts" />
/// <reference path="sdp/ice/UfragAttribute.ts" />
/// <reference path="sdp/ice/RemoteCandidatesAttribute.ts" />
/// <reference path="sdp/rtp/MapAttribute.ts" />
/// <reference path="sdp/rtp/SsrcAttribute.ts" />
/// <reference path="sdp/rtp/SsrcGroupAttribute.ts" />
/// <reference path="sdp/rtp/ExtMapAttribute.ts" />
/// <reference path="sdp/rtp/RidAttribute.ts" />
/// <reference path="sdp/rtp/SimulcastAttribute.ts" />
/// <reference path="sdp/rtcp/Attribute.ts" />
/// <reference path="sdp/rtcp/FeedbackAttribute.ts" />
/// <reference path="sdp/rtcp/MuxAttribute.ts" />
/// <reference path="sdp/sctp/PortAttribute.ts" />
/// <reference path="sdp/sctp/MapAttribute.ts" />
/// <reference path="sdp/sctp/MaxMessageSizeAttribute.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            fm.liveswitch.sdp.Attribute.fmliveswitchsdpAttributeInitialize();
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="sdp/Media.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            fm.liveswitch.sdp.Media.fmliveswitchsdpMediaInitialize();
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="sdp/rtp/MapAttribute.ts" />
/// <reference path="ManagedConcurrentDictionary.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var sdp;
        (function (sdp) {
            var rtp;
            (function (rtp) {
                fm.liveswitch.sdp.rtp.MapAttribute.fmliveswitchsdprtpMapAttributeInitialize();
            })(rtp = sdp.rtp || (sdp.rtp = {}));
        })(sdp = liveswitch.sdp || (liveswitch.sdp = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="DataMessage.ts" />
/// <reference path="DataBufferPool.ts" />
/// <reference path="DataBufferPoolTracer.ts" />
/// <reference path="IDataBufferPool.ts" />
/// <reference path="Log.ts" />
/// <reference path="ILog.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        fm.liveswitch.DataMessage.fmliveswitchDataMessageInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="datamessageheader/DeliveryAttemptsElement.ts" />
/// <reference path="DataBufferPool.ts" />
/// <reference path="DataBufferPoolTracer.ts" />
/// <reference path="IDataBufferPool.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var datamessageheader;
        (function (datamessageheader) {
            fm.liveswitch.datamessageheader.DeliveryAttemptsElement.fmliveswitchdatamessageheaderDeliveryAttemptsElementInitialize();
        })(datamessageheader = liveswitch.datamessageheader || (liveswitch.datamessageheader = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="datamessageheader/ConnectionIdElement.ts" />
/// <reference path="DataBufferPool.ts" />
/// <reference path="DataBufferPoolTracer.ts" />
/// <reference path="IDataBufferPool.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var datamessageheader;
        (function (datamessageheader) {
            fm.liveswitch.datamessageheader.ConnectionIdElement.fmliveswitchdatamessageheaderConnectionIdElementInitialize();
        })(datamessageheader = liveswitch.datamessageheader || (liveswitch.datamessageheader = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="datamessageheader/TimeToLiveElement.ts" />
/// <reference path="DataBufferPool.ts" />
/// <reference path="DataBufferPoolTracer.ts" />
/// <reference path="IDataBufferPool.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var datamessageheader;
        (function (datamessageheader) {
            fm.liveswitch.datamessageheader.TimeToLiveElement.fmliveswitchdatamessageheaderTimeToLiveElementInitialize();
        })(datamessageheader = liveswitch.datamessageheader || (liveswitch.datamessageheader = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="datamessageheader/UnknownElement.ts" />
/// <reference path="DataBufferPool.ts" />
/// <reference path="DataBufferPoolTracer.ts" />
/// <reference path="IDataBufferPool.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var datamessageheader;
        (function (datamessageheader) {
            fm.liveswitch.datamessageheader.UnknownElement.fmliveswitchdatamessageheaderUnknownElementInitialize();
        })(datamessageheader = liveswitch.datamessageheader || (liveswitch.datamessageheader = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="VideoFormat.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        fm.liveswitch.VideoFormat.fmliveswitchVideoFormatInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="VideoBuffer.ts" />
/// <reference path="DataBufferPool.ts" />
/// <reference path="DataBufferPoolTracer.ts" />
/// <reference path="IDataBufferPool.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        fm.liveswitch.VideoBuffer.fmliveswitchVideoBufferInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Channel.ts" />
/// <reference path="Log.ts" />
/// <reference path="ILog.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        fm.liveswitch.Channel.fmliveswitchChannelInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Client.ts" />
/// <reference path="Log.ts" />
/// <reference path="ILog.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        fm.liveswitch.Client.fmliveswitchClientInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="ManagedConnection.ts" />
/// <reference path="Log.ts" />
/// <reference path="ILog.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        fm.liveswitch.ManagedConnection.fmliveswitchManagedConnectionInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="ServerConnection.ts" />
/// <reference path="Log.ts" />
/// <reference path="ILog.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        fm.liveswitch.ServerConnection.fmliveswitchServerConnectionInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="PeerConnection.ts" />
/// <reference path="Log.ts" />
/// <reference path="ILog.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        fm.liveswitch.PeerConnection.fmliveswitchPeerConnectionInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="SendQueue.ts" />
/// <reference path="Log.ts" />
/// <reference path="ILog.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        fm.liveswitch.SendQueue.fmliveswitchSendQueueInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="Token.ts" />
/// <reference path="Log.ts" />
/// <reference path="ILog.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        fm.liveswitch.Token.fmliveswitchTokenInitialize();
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="signalling/ClientBase.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            fm.liveswitch.signalling.ClientBase.fmliveswitchsignallingClientBaseInitialize();
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="signalling/Client.ts" />
/// <reference path="Log.ts" />
/// <reference path="ILog.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            fm.liveswitch.signalling.Client.fmliveswitchsignallingClientInitialize();
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="signalling/Defaults.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            fm.liveswitch.signalling.Defaults.fmliveswitchsignallingDefaultsInitialize();
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
/// <reference path="signalling/Reserved.ts" />
(function (fm) {
    var liveswitch;
    (function (liveswitch) {
        var signalling;
        (function (signalling) {
            fm.liveswitch.signalling.Reserved.fmliveswitchsignallingReservedInitialize();
        })(signalling = liveswitch.signalling || (liveswitch.signalling = {}));
    })(liveswitch = fm.liveswitch || (fm.liveswitch = {}));
})(fm || (fm = {}));
return fm.liveswitch;
}));
